(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea8e2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea8e2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bg8pZ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8327b803ed318cbd$export$ffb0004e005737fa; }, function (v) { return $8327b803ed318cbd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8327b803ed318cbd$export$34b9dba7ce09269b; }, function (v) { return $8327b803ed318cbd$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8327b803ed318cbd$export$25062201e9e25d76; }, function (v) { return $8327b803ed318cbd$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8327b803ed318cbd$export$ffb0004e005737fa;
var $8327b803ed318cbd$export$34b9dba7ce09269b;
var $8327b803ed318cbd$export$25062201e9e25d76;
"use strict";

var $7PdBe = parcelRequire("7PdBe");
var $8327b803ed318cbd$var$k = Symbol.for("react.element"), $8327b803ed318cbd$var$l = Symbol.for("react.fragment"), $8327b803ed318cbd$var$m = Object.prototype.hasOwnProperty, $8327b803ed318cbd$var$n = $7PdBe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $8327b803ed318cbd$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8327b803ed318cbd$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$8327b803ed318cbd$var$m.call(a, b) && !$8327b803ed318cbd$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $8327b803ed318cbd$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $8327b803ed318cbd$var$n.current
    };
}
$8327b803ed318cbd$export$ffb0004e005737fa = $8327b803ed318cbd$var$l;
$8327b803ed318cbd$export$34b9dba7ce09269b = $8327b803ed318cbd$var$q;
$8327b803ed318cbd$export$25062201e9e25d76 = $8327b803ed318cbd$var$q;

});
parcelRegister("7PdBe", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1tFHY"));

});
parcelRegister("1tFHY", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $1138da4765f86e23$export$dca3b0875bd9a954; }, function (v) { return $1138da4765f86e23$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $1138da4765f86e23$export$16fa2f45be04daa8; }, function (v) { return $1138da4765f86e23$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1138da4765f86e23$export$ffb0004e005737fa; }, function (v) { return $1138da4765f86e23$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $1138da4765f86e23$export$e2c29f18771995cb; }, function (v) { return $1138da4765f86e23$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $1138da4765f86e23$export$221d75b3f55bb0bd; }, function (v) { return $1138da4765f86e23$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1138da4765f86e23$export$5f8d39834fd61797; }, function (v) { return $1138da4765f86e23$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1138da4765f86e23$export$74bf444e3cd11ea5; }, function (v) { return $1138da4765f86e23$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $1138da4765f86e23$export$ae55be85d98224ed; }, function (v) { return $1138da4765f86e23$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $1138da4765f86e23$export$3ba232387fd5d6dd; }, function (v) { return $1138da4765f86e23$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $1138da4765f86e23$export$e530037191fcd5d7; }, function (v) { return $1138da4765f86e23$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $1138da4765f86e23$export$fd42f52fd3ae1109; }, function (v) { return $1138da4765f86e23$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $1138da4765f86e23$export$c8a8987d4410bf2d; }, function (v) { return $1138da4765f86e23$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $1138da4765f86e23$export$d38cd72104c1f0e9; }, function (v) { return $1138da4765f86e23$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $1138da4765f86e23$export$7d1e3a5e95ceca43; }, function (v) { return $1138da4765f86e23$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $1138da4765f86e23$export$257a8862b851cb5b; }, function (v) { return $1138da4765f86e23$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $1138da4765f86e23$export$a8257692ac88316c; }, function (v) { return $1138da4765f86e23$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $1138da4765f86e23$export$488013bae63b21da; }, function (v) { return $1138da4765f86e23$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $1138da4765f86e23$export$7c73462e0d25e514; }, function (v) { return $1138da4765f86e23$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $1138da4765f86e23$export$7568632d0d33d16d; }, function (v) { return $1138da4765f86e23$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $1138da4765f86e23$export$88948ce120ea2619; }, function (v) { return $1138da4765f86e23$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $1138da4765f86e23$export$35808ee640e87ca7; }, function (v) { return $1138da4765f86e23$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $1138da4765f86e23$export$fae74005e78b1a27; }, function (v) { return $1138da4765f86e23$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $1138da4765f86e23$export$dc8fbce3eb94dc1e; }, function (v) { return $1138da4765f86e23$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $1138da4765f86e23$export$6a7bc4e911dc01cf; }, function (v) { return $1138da4765f86e23$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $1138da4765f86e23$export$6d9c69b0de29b591; }, function (v) { return $1138da4765f86e23$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $1138da4765f86e23$export$f680877a34711e37; }, function (v) { return $1138da4765f86e23$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $1138da4765f86e23$export$d5a552a76deda3c2; }, function (v) { return $1138da4765f86e23$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $1138da4765f86e23$export$aaabe4eda9ed9969; }, function (v) { return $1138da4765f86e23$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $1138da4765f86e23$export$e5c5a5f917a5871c; }, function (v) { return $1138da4765f86e23$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $1138da4765f86e23$export$1538c33de8887b59; }, function (v) { return $1138da4765f86e23$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $1138da4765f86e23$export$13e3392192263954; }, function (v) { return $1138da4765f86e23$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $1138da4765f86e23$export$b8f5890fc79d6aca; }, function (v) { return $1138da4765f86e23$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $1138da4765f86e23$export$60241385465d0a34; }, function (v) { return $1138da4765f86e23$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $1138da4765f86e23$export$306c0aa65ff9ec16; }, function (v) { return $1138da4765f86e23$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $1138da4765f86e23$export$7b286972b8d8ccbf; }, function (v) { return $1138da4765f86e23$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $1138da4765f86e23$export$83d89fbfd8236492; }, function (v) { return $1138da4765f86e23$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1138da4765f86e23$export$dca3b0875bd9a954;
var $1138da4765f86e23$export$16fa2f45be04daa8;
var $1138da4765f86e23$export$ffb0004e005737fa;
var $1138da4765f86e23$export$e2c29f18771995cb;
var $1138da4765f86e23$export$221d75b3f55bb0bd;
var $1138da4765f86e23$export$5f8d39834fd61797;
var $1138da4765f86e23$export$74bf444e3cd11ea5;
var $1138da4765f86e23$export$ae55be85d98224ed;
var $1138da4765f86e23$export$3ba232387fd5d6dd;
var $1138da4765f86e23$export$e530037191fcd5d7;
var $1138da4765f86e23$export$fd42f52fd3ae1109;
var $1138da4765f86e23$export$c8a8987d4410bf2d;
var $1138da4765f86e23$export$d38cd72104c1f0e9;
var $1138da4765f86e23$export$7d1e3a5e95ceca43;
var $1138da4765f86e23$export$257a8862b851cb5b;
var $1138da4765f86e23$export$a8257692ac88316c;
var $1138da4765f86e23$export$488013bae63b21da;
var $1138da4765f86e23$export$7c73462e0d25e514;
var $1138da4765f86e23$export$7568632d0d33d16d;
var $1138da4765f86e23$export$88948ce120ea2619;
var $1138da4765f86e23$export$35808ee640e87ca7;
var $1138da4765f86e23$export$fae74005e78b1a27;
var $1138da4765f86e23$export$dc8fbce3eb94dc1e;
var $1138da4765f86e23$export$6a7bc4e911dc01cf;
var $1138da4765f86e23$export$6d9c69b0de29b591;
var $1138da4765f86e23$export$f680877a34711e37;
var $1138da4765f86e23$export$d5a552a76deda3c2;
var $1138da4765f86e23$export$aaabe4eda9ed9969;
var $1138da4765f86e23$export$e5c5a5f917a5871c;
var $1138da4765f86e23$export$1538c33de8887b59;
var $1138da4765f86e23$export$13e3392192263954;
var $1138da4765f86e23$export$b8f5890fc79d6aca;
var $1138da4765f86e23$export$60241385465d0a34;
var $1138da4765f86e23$export$306c0aa65ff9ec16;
var $1138da4765f86e23$export$7b286972b8d8ccbf;
var $1138da4765f86e23$export$83d89fbfd8236492;
"use strict";
var $1138da4765f86e23$var$l = Symbol.for("react.element"), $1138da4765f86e23$var$n = Symbol.for("react.portal"), $1138da4765f86e23$var$p = Symbol.for("react.fragment"), $1138da4765f86e23$var$q = Symbol.for("react.strict_mode"), $1138da4765f86e23$var$r = Symbol.for("react.profiler"), $1138da4765f86e23$var$t = Symbol.for("react.provider"), $1138da4765f86e23$var$u = Symbol.for("react.context"), $1138da4765f86e23$var$v = Symbol.for("react.forward_ref"), $1138da4765f86e23$var$w = Symbol.for("react.suspense"), $1138da4765f86e23$var$x = Symbol.for("react.memo"), $1138da4765f86e23$var$y = Symbol.for("react.lazy"), $1138da4765f86e23$var$z = Symbol.iterator;
function $1138da4765f86e23$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1138da4765f86e23$var$z && a[$1138da4765f86e23$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1138da4765f86e23$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1138da4765f86e23$var$C = Object.assign, $1138da4765f86e23$var$D = {};
function $1138da4765f86e23$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1138da4765f86e23$var$D;
    this.updater = e || $1138da4765f86e23$var$B;
}
$1138da4765f86e23$var$E.prototype.isReactComponent = {};
$1138da4765f86e23$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1138da4765f86e23$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1138da4765f86e23$var$F() {}
$1138da4765f86e23$var$F.prototype = $1138da4765f86e23$var$E.prototype;
function $1138da4765f86e23$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1138da4765f86e23$var$D;
    this.updater = e || $1138da4765f86e23$var$B;
}
var $1138da4765f86e23$var$H = $1138da4765f86e23$var$G.prototype = new $1138da4765f86e23$var$F;
$1138da4765f86e23$var$H.constructor = $1138da4765f86e23$var$G;
$1138da4765f86e23$var$C($1138da4765f86e23$var$H, $1138da4765f86e23$var$E.prototype);
$1138da4765f86e23$var$H.isPureReactComponent = !0;
var $1138da4765f86e23$var$I = Array.isArray, $1138da4765f86e23$var$J = Object.prototype.hasOwnProperty, $1138da4765f86e23$var$K = {
    current: null
}, $1138da4765f86e23$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1138da4765f86e23$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1138da4765f86e23$var$J.call(b, d) && !$1138da4765f86e23$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1138da4765f86e23$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1138da4765f86e23$var$K.current
    };
}
function $1138da4765f86e23$var$N(a, b) {
    return {
        $$typeof: $1138da4765f86e23$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1138da4765f86e23$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1138da4765f86e23$var$l;
}
function $1138da4765f86e23$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1138da4765f86e23$var$P = /\/+/g;
function $1138da4765f86e23$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1138da4765f86e23$var$escape("" + a.key) : b.toString(36);
}
function $1138da4765f86e23$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1138da4765f86e23$var$l:
                case $1138da4765f86e23$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1138da4765f86e23$var$Q(h, 0) : d, $1138da4765f86e23$var$I(c) ? (e = "", null != a && (e = a.replace($1138da4765f86e23$var$P, "$&/") + "/"), $1138da4765f86e23$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1138da4765f86e23$var$O(c) && (c = $1138da4765f86e23$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1138da4765f86e23$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1138da4765f86e23$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1138da4765f86e23$var$Q(k, g);
        h += $1138da4765f86e23$var$R(k, b, e, f, c);
    }
    else if (f = $1138da4765f86e23$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1138da4765f86e23$var$Q(k, g++), h += $1138da4765f86e23$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1138da4765f86e23$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1138da4765f86e23$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1138da4765f86e23$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1138da4765f86e23$var$U = {
    current: null
}, $1138da4765f86e23$var$V = {
    transition: null
}, $1138da4765f86e23$var$W = {
    ReactCurrentDispatcher: $1138da4765f86e23$var$U,
    ReactCurrentBatchConfig: $1138da4765f86e23$var$V,
    ReactCurrentOwner: $1138da4765f86e23$var$K
};
function $1138da4765f86e23$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1138da4765f86e23$export$dca3b0875bd9a954 = {
    map: $1138da4765f86e23$var$S,
    forEach: function(a, b, e) {
        $1138da4765f86e23$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1138da4765f86e23$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1138da4765f86e23$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1138da4765f86e23$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1138da4765f86e23$export$16fa2f45be04daa8 = $1138da4765f86e23$var$E;
$1138da4765f86e23$export$ffb0004e005737fa = $1138da4765f86e23$var$p;
$1138da4765f86e23$export$e2c29f18771995cb = $1138da4765f86e23$var$r;
$1138da4765f86e23$export$221d75b3f55bb0bd = $1138da4765f86e23$var$G;
$1138da4765f86e23$export$5f8d39834fd61797 = $1138da4765f86e23$var$q;
$1138da4765f86e23$export$74bf444e3cd11ea5 = $1138da4765f86e23$var$w;
$1138da4765f86e23$export$ae55be85d98224ed = $1138da4765f86e23$var$W;
$1138da4765f86e23$export$3ba232387fd5d6dd = $1138da4765f86e23$var$X;
$1138da4765f86e23$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1138da4765f86e23$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1138da4765f86e23$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1138da4765f86e23$var$J.call(b, f) && !$1138da4765f86e23$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1138da4765f86e23$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1138da4765f86e23$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1138da4765f86e23$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1138da4765f86e23$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1138da4765f86e23$export$c8a8987d4410bf2d = $1138da4765f86e23$var$M;
$1138da4765f86e23$export$d38cd72104c1f0e9 = function(a) {
    var b = $1138da4765f86e23$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1138da4765f86e23$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1138da4765f86e23$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1138da4765f86e23$var$v,
        render: a
    };
};
$1138da4765f86e23$export$a8257692ac88316c = $1138da4765f86e23$var$O;
$1138da4765f86e23$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1138da4765f86e23$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1138da4765f86e23$var$T
    };
};
$1138da4765f86e23$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1138da4765f86e23$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1138da4765f86e23$export$7568632d0d33d16d = function(a) {
    var b = $1138da4765f86e23$var$V.transition;
    $1138da4765f86e23$var$V.transition = {};
    try {
        a();
    } finally{
        $1138da4765f86e23$var$V.transition = b;
    }
};
$1138da4765f86e23$export$88948ce120ea2619 = $1138da4765f86e23$var$X;
$1138da4765f86e23$export$35808ee640e87ca7 = function(a, b) {
    return $1138da4765f86e23$var$U.current.useCallback(a, b);
};
$1138da4765f86e23$export$fae74005e78b1a27 = function(a) {
    return $1138da4765f86e23$var$U.current.useContext(a);
};
$1138da4765f86e23$export$dc8fbce3eb94dc1e = function() {};
$1138da4765f86e23$export$6a7bc4e911dc01cf = function(a) {
    return $1138da4765f86e23$var$U.current.useDeferredValue(a);
};
$1138da4765f86e23$export$6d9c69b0de29b591 = function(a, b) {
    return $1138da4765f86e23$var$U.current.useEffect(a, b);
};
$1138da4765f86e23$export$f680877a34711e37 = function() {
    return $1138da4765f86e23$var$U.current.useId();
};
$1138da4765f86e23$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1138da4765f86e23$var$U.current.useImperativeHandle(a, b, e);
};
$1138da4765f86e23$export$aaabe4eda9ed9969 = function(a, b) {
    return $1138da4765f86e23$var$U.current.useInsertionEffect(a, b);
};
$1138da4765f86e23$export$e5c5a5f917a5871c = function(a, b) {
    return $1138da4765f86e23$var$U.current.useLayoutEffect(a, b);
};
$1138da4765f86e23$export$1538c33de8887b59 = function(a, b) {
    return $1138da4765f86e23$var$U.current.useMemo(a, b);
};
$1138da4765f86e23$export$13e3392192263954 = function(a, b, e) {
    return $1138da4765f86e23$var$U.current.useReducer(a, b, e);
};
$1138da4765f86e23$export$b8f5890fc79d6aca = function(a) {
    return $1138da4765f86e23$var$U.current.useRef(a);
};
$1138da4765f86e23$export$60241385465d0a34 = function(a) {
    return $1138da4765f86e23$var$U.current.useState(a);
};
$1138da4765f86e23$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1138da4765f86e23$var$U.current.useSyncExternalStore(a, b, e);
};
$1138da4765f86e23$export$7b286972b8d8ccbf = function() {
    return $1138da4765f86e23$var$U.current.useTransition();
};
$1138da4765f86e23$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("fmu17", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b2f031d65f074034$export$2b8d127b894957b9; }, function (v) { return $b2f031d65f074034$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b2f031d65f074034$export$cea3a54a6425200c; }, function (v) { return $b2f031d65f074034$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b2f031d65f074034$export$a7c73072b1a182ae; }, function (v) { return $b2f031d65f074034$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b2f031d65f074034$export$9f27bc3417b4524d; }, function (v) { return $b2f031d65f074034$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b2f031d65f074034$export$db77ccec0bb4ccac; }, function (v) { return $b2f031d65f074034$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b2f031d65f074034$export$8392c0c9d3dcbd35; }, function (v) { return $b2f031d65f074034$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b2f031d65f074034$export$ffb0004e005737fa; }, function (v) { return $b2f031d65f074034$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b2f031d65f074034$export$b624eff549462981; }, function (v) { return $b2f031d65f074034$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b2f031d65f074034$export$7897aa7841a5380c; }, function (v) { return $b2f031d65f074034$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b2f031d65f074034$export$602eac185826482c; }, function (v) { return $b2f031d65f074034$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b2f031d65f074034$export$e2c29f18771995cb; }, function (v) { return $b2f031d65f074034$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b2f031d65f074034$export$5f8d39834fd61797; }, function (v) { return $b2f031d65f074034$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b2f031d65f074034$export$74bf444e3cd11ea5; }, function (v) { return $b2f031d65f074034$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b2f031d65f074034$export$92387174baf9b227; }, function (v) { return $b2f031d65f074034$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b2f031d65f074034$export$ec112efeb987d9c6; }, function (v) { return $b2f031d65f074034$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b2f031d65f074034$export$b706b080d889d2c9; }, function (v) { return $b2f031d65f074034$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b2f031d65f074034$export$5be5a87408f70ddc; }, function (v) { return $b2f031d65f074034$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b2f031d65f074034$export$45a5e7f76e0caa8d; }, function (v) { return $b2f031d65f074034$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b2f031d65f074034$export$455c2e768291efa6; }, function (v) { return $b2f031d65f074034$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b2f031d65f074034$export$9522e17588c12572; }, function (v) { return $b2f031d65f074034$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b2f031d65f074034$export$2110ac352bb060b9; }, function (v) { return $b2f031d65f074034$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b2f031d65f074034$export$56885ab8b9c456ab; }, function (v) { return $b2f031d65f074034$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b2f031d65f074034$export$d927fcb6adf8f9de; }, function (v) { return $b2f031d65f074034$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b2f031d65f074034$export$b82d16f27459e05a; }, function (v) { return $b2f031d65f074034$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b2f031d65f074034$export$522c17b4f5e123e8; }, function (v) { return $b2f031d65f074034$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b2f031d65f074034$export$1aabd8a0274ecfd6; }, function (v) { return $b2f031d65f074034$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b2f031d65f074034$export$9b621391a187a31a; }, function (v) { return $b2f031d65f074034$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b2f031d65f074034$export$f5bbd400c2f4426f; }, function (v) { return $b2f031d65f074034$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b2f031d65f074034$export$2b8d127b894957b9;
var $b2f031d65f074034$export$cea3a54a6425200c;
var $b2f031d65f074034$export$a7c73072b1a182ae;
var $b2f031d65f074034$export$9f27bc3417b4524d;
var $b2f031d65f074034$export$db77ccec0bb4ccac;
var $b2f031d65f074034$export$8392c0c9d3dcbd35;
var $b2f031d65f074034$export$ffb0004e005737fa;
var $b2f031d65f074034$export$b624eff549462981;
var $b2f031d65f074034$export$7897aa7841a5380c;
var $b2f031d65f074034$export$602eac185826482c;
var $b2f031d65f074034$export$e2c29f18771995cb;
var $b2f031d65f074034$export$5f8d39834fd61797;
var $b2f031d65f074034$export$74bf444e3cd11ea5;
var $b2f031d65f074034$export$92387174baf9b227;
var $b2f031d65f074034$export$ec112efeb987d9c6;
var $b2f031d65f074034$export$b706b080d889d2c9;
var $b2f031d65f074034$export$5be5a87408f70ddc;
var $b2f031d65f074034$export$45a5e7f76e0caa8d;
var $b2f031d65f074034$export$455c2e768291efa6;
var $b2f031d65f074034$export$9522e17588c12572;
var $b2f031d65f074034$export$2110ac352bb060b9;
var $b2f031d65f074034$export$56885ab8b9c456ab;
var $b2f031d65f074034$export$d927fcb6adf8f9de;
var $b2f031d65f074034$export$b82d16f27459e05a;
var $b2f031d65f074034$export$522c17b4f5e123e8;
var $b2f031d65f074034$export$1aabd8a0274ecfd6;
var $b2f031d65f074034$export$9b621391a187a31a;
var $b2f031d65f074034$export$f5bbd400c2f4426f;
"use strict";
var $b2f031d65f074034$var$b = "function" === typeof Symbol && Symbol.for, $b2f031d65f074034$var$c = $b2f031d65f074034$var$b ? Symbol.for("react.element") : 60103, $b2f031d65f074034$var$d = $b2f031d65f074034$var$b ? Symbol.for("react.portal") : 60106, $b2f031d65f074034$var$e = $b2f031d65f074034$var$b ? Symbol.for("react.fragment") : 60107, $b2f031d65f074034$var$f = $b2f031d65f074034$var$b ? Symbol.for("react.strict_mode") : 60108, $b2f031d65f074034$var$g = $b2f031d65f074034$var$b ? Symbol.for("react.profiler") : 60114, $b2f031d65f074034$var$h = $b2f031d65f074034$var$b ? Symbol.for("react.provider") : 60109, $b2f031d65f074034$var$k = $b2f031d65f074034$var$b ? Symbol.for("react.context") : 60110, $b2f031d65f074034$var$l = $b2f031d65f074034$var$b ? Symbol.for("react.async_mode") : 60111, $b2f031d65f074034$var$m = $b2f031d65f074034$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b2f031d65f074034$var$n = $b2f031d65f074034$var$b ? Symbol.for("react.forward_ref") : 60112, $b2f031d65f074034$var$p = $b2f031d65f074034$var$b ? Symbol.for("react.suspense") : 60113, $b2f031d65f074034$var$q = $b2f031d65f074034$var$b ? Symbol.for("react.suspense_list") : 60120, $b2f031d65f074034$var$r = $b2f031d65f074034$var$b ? Symbol.for("react.memo") : 60115, $b2f031d65f074034$var$t = $b2f031d65f074034$var$b ? Symbol.for("react.lazy") : 60116, $b2f031d65f074034$var$v = $b2f031d65f074034$var$b ? Symbol.for("react.block") : 60121, $b2f031d65f074034$var$w = $b2f031d65f074034$var$b ? Symbol.for("react.fundamental") : 60117, $b2f031d65f074034$var$x = $b2f031d65f074034$var$b ? Symbol.for("react.responder") : 60118, $b2f031d65f074034$var$y = $b2f031d65f074034$var$b ? Symbol.for("react.scope") : 60119;
function $b2f031d65f074034$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b2f031d65f074034$var$c:
                switch(a = a.type, a){
                    case $b2f031d65f074034$var$l:
                    case $b2f031d65f074034$var$m:
                    case $b2f031d65f074034$var$e:
                    case $b2f031d65f074034$var$g:
                    case $b2f031d65f074034$var$f:
                    case $b2f031d65f074034$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b2f031d65f074034$var$k:
                            case $b2f031d65f074034$var$n:
                            case $b2f031d65f074034$var$t:
                            case $b2f031d65f074034$var$r:
                            case $b2f031d65f074034$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b2f031d65f074034$var$d:
                return u;
        }
    }
}
function $b2f031d65f074034$var$A(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$m;
}
$b2f031d65f074034$export$2b8d127b894957b9 = $b2f031d65f074034$var$l;
$b2f031d65f074034$export$cea3a54a6425200c = $b2f031d65f074034$var$m;
$b2f031d65f074034$export$a7c73072b1a182ae = $b2f031d65f074034$var$k;
$b2f031d65f074034$export$9f27bc3417b4524d = $b2f031d65f074034$var$h;
$b2f031d65f074034$export$db77ccec0bb4ccac = $b2f031d65f074034$var$c;
$b2f031d65f074034$export$8392c0c9d3dcbd35 = $b2f031d65f074034$var$n;
$b2f031d65f074034$export$ffb0004e005737fa = $b2f031d65f074034$var$e;
$b2f031d65f074034$export$b624eff549462981 = $b2f031d65f074034$var$t;
$b2f031d65f074034$export$7897aa7841a5380c = $b2f031d65f074034$var$r;
$b2f031d65f074034$export$602eac185826482c = $b2f031d65f074034$var$d;
$b2f031d65f074034$export$e2c29f18771995cb = $b2f031d65f074034$var$g;
$b2f031d65f074034$export$5f8d39834fd61797 = $b2f031d65f074034$var$f;
$b2f031d65f074034$export$74bf444e3cd11ea5 = $b2f031d65f074034$var$p;
$b2f031d65f074034$export$92387174baf9b227 = function(a) {
    return $b2f031d65f074034$var$A(a) || $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$l;
};
$b2f031d65f074034$export$ec112efeb987d9c6 = $b2f031d65f074034$var$A;
$b2f031d65f074034$export$b706b080d889d2c9 = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$k;
};
$b2f031d65f074034$export$5be5a87408f70ddc = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$h;
};
$b2f031d65f074034$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b2f031d65f074034$var$c;
};
$b2f031d65f074034$export$455c2e768291efa6 = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$n;
};
$b2f031d65f074034$export$9522e17588c12572 = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$e;
};
$b2f031d65f074034$export$2110ac352bb060b9 = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$t;
};
$b2f031d65f074034$export$56885ab8b9c456ab = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$r;
};
$b2f031d65f074034$export$d927fcb6adf8f9de = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$d;
};
$b2f031d65f074034$export$b82d16f27459e05a = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$g;
};
$b2f031d65f074034$export$522c17b4f5e123e8 = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$f;
};
$b2f031d65f074034$export$1aabd8a0274ecfd6 = function(a) {
    return $b2f031d65f074034$var$z(a) === $b2f031d65f074034$var$p;
};
$b2f031d65f074034$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b2f031d65f074034$var$e || a === $b2f031d65f074034$var$m || a === $b2f031d65f074034$var$g || a === $b2f031d65f074034$var$f || a === $b2f031d65f074034$var$p || a === $b2f031d65f074034$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b2f031d65f074034$var$t || a.$$typeof === $b2f031d65f074034$var$r || a.$$typeof === $b2f031d65f074034$var$h || a.$$typeof === $b2f031d65f074034$var$k || a.$$typeof === $b2f031d65f074034$var$n || a.$$typeof === $b2f031d65f074034$var$w || a.$$typeof === $b2f031d65f074034$var$x || a.$$typeof === $b2f031d65f074034$var$y || a.$$typeof === $b2f031d65f074034$var$v);
};
$b2f031d65f074034$export$f5bbd400c2f4426f = $b2f031d65f074034$var$z;

});

parcelRegister("1cUCD", function(module, exports) {
"use strict";
function $0e12d568697342e5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0e12d568697342e5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0e12d568697342e5$var$checkDCE();

module.exports = (parcelRequire("gtpGL"));

});
parcelRegister("gtpGL", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bfe34808345a21f6$export$ae55be85d98224ed; }, function (v) { return $bfe34808345a21f6$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $bfe34808345a21f6$export$d39a5bbd09211389; }, function (v) { return $bfe34808345a21f6$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $bfe34808345a21f6$export$882461b6382ed46c; }, function (v) { return $bfe34808345a21f6$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $bfe34808345a21f6$export$466bfc07425424d5; }, function (v) { return $bfe34808345a21f6$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bfe34808345a21f6$export$cd75ccfd720a3cd4; }, function (v) { return $bfe34808345a21f6$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $bfe34808345a21f6$export$fa8d919ba61d84db; }, function (v) { return $bfe34808345a21f6$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bfe34808345a21f6$export$757ceba2d55c277e; }, function (v) { return $bfe34808345a21f6$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $bfe34808345a21f6$export$b3890eb0ae9dca99; }, function (v) { return $bfe34808345a21f6$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $bfe34808345a21f6$export$502457920280e6be; }, function (v) { return $bfe34808345a21f6$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bfe34808345a21f6$export$c78a37762a8d58e1; }, function (v) { return $bfe34808345a21f6$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $bfe34808345a21f6$export$dc54d992c10e8a18; }, function (v) { return $bfe34808345a21f6$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $bfe34808345a21f6$export$83d89fbfd8236492; }, function (v) { return $bfe34808345a21f6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $bfe34808345a21f6$export$ae55be85d98224ed;
var $bfe34808345a21f6$export$d39a5bbd09211389;
var $bfe34808345a21f6$export$882461b6382ed46c;
var $bfe34808345a21f6$export$466bfc07425424d5;
var $bfe34808345a21f6$export$cd75ccfd720a3cd4;
var $bfe34808345a21f6$export$fa8d919ba61d84db;
var $bfe34808345a21f6$export$757ceba2d55c277e;
var $bfe34808345a21f6$export$b3890eb0ae9dca99;
var $bfe34808345a21f6$export$502457920280e6be;
var $bfe34808345a21f6$export$c78a37762a8d58e1;
var $bfe34808345a21f6$export$dc54d992c10e8a18;
var $bfe34808345a21f6$export$83d89fbfd8236492;
"use strict";

var $7PdBe = parcelRequire("7PdBe");

var $2N9BZ = parcelRequire("2N9BZ");
function $bfe34808345a21f6$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bfe34808345a21f6$var$da = new Set, $bfe34808345a21f6$var$ea = {};
function $bfe34808345a21f6$var$fa(a, b) {
    $bfe34808345a21f6$var$ha(a, b);
    $bfe34808345a21f6$var$ha(a + "Capture", b);
}
function $bfe34808345a21f6$var$ha(a, b) {
    $bfe34808345a21f6$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$bfe34808345a21f6$var$da.add(b[a]);
}
var $bfe34808345a21f6$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bfe34808345a21f6$var$ja = Object.prototype.hasOwnProperty, $bfe34808345a21f6$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $bfe34808345a21f6$var$la = {}, $bfe34808345a21f6$var$ma = {};
function $bfe34808345a21f6$var$oa(a) {
    if ($bfe34808345a21f6$var$ja.call($bfe34808345a21f6$var$ma, a)) return !0;
    if ($bfe34808345a21f6$var$ja.call($bfe34808345a21f6$var$la, a)) return !1;
    if ($bfe34808345a21f6$var$ka.test(a)) return $bfe34808345a21f6$var$ma[a] = !0;
    $bfe34808345a21f6$var$la[a] = !0;
    return !1;
}
function $bfe34808345a21f6$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $bfe34808345a21f6$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $bfe34808345a21f6$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $bfe34808345a21f6$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $bfe34808345a21f6$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $bfe34808345a21f6$var$z[b] = new $bfe34808345a21f6$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $bfe34808345a21f6$var$ra = /[\-:]([a-z])/g;
function $bfe34808345a21f6$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($bfe34808345a21f6$var$ra, $bfe34808345a21f6$var$sa);
    $bfe34808345a21f6$var$z[b] = new $bfe34808345a21f6$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($bfe34808345a21f6$var$ra, $bfe34808345a21f6$var$sa);
    $bfe34808345a21f6$var$z[b] = new $bfe34808345a21f6$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($bfe34808345a21f6$var$ra, $bfe34808345a21f6$var$sa);
    $bfe34808345a21f6$var$z[b] = new $bfe34808345a21f6$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$bfe34808345a21f6$var$z.xlinkHref = new $bfe34808345a21f6$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $bfe34808345a21f6$var$z[a] = new $bfe34808345a21f6$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $bfe34808345a21f6$var$ta(a, b, c, d) {
    var e = $bfe34808345a21f6$var$z.hasOwnProperty(b) ? $bfe34808345a21f6$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $bfe34808345a21f6$var$qa(b, c, e, d) && (c = null), d || null === e ? $bfe34808345a21f6$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $bfe34808345a21f6$var$ua = $7PdBe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $bfe34808345a21f6$var$va = Symbol.for("react.element"), $bfe34808345a21f6$var$wa = Symbol.for("react.portal"), $bfe34808345a21f6$var$ya = Symbol.for("react.fragment"), $bfe34808345a21f6$var$za = Symbol.for("react.strict_mode"), $bfe34808345a21f6$var$Aa = Symbol.for("react.profiler"), $bfe34808345a21f6$var$Ba = Symbol.for("react.provider"), $bfe34808345a21f6$var$Ca = Symbol.for("react.context"), $bfe34808345a21f6$var$Da = Symbol.for("react.forward_ref"), $bfe34808345a21f6$var$Ea = Symbol.for("react.suspense"), $bfe34808345a21f6$var$Fa = Symbol.for("react.suspense_list"), $bfe34808345a21f6$var$Ga = Symbol.for("react.memo"), $bfe34808345a21f6$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $bfe34808345a21f6$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $bfe34808345a21f6$var$Ja = Symbol.iterator;
function $bfe34808345a21f6$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bfe34808345a21f6$var$Ja && a[$bfe34808345a21f6$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bfe34808345a21f6$var$A = Object.assign, $bfe34808345a21f6$var$La;
function $bfe34808345a21f6$var$Ma(a) {
    if (void 0 === $bfe34808345a21f6$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $bfe34808345a21f6$var$La = b && b[1] || "";
    }
    return "\n" + $bfe34808345a21f6$var$La + a;
}
var $bfe34808345a21f6$var$Na = !1;
function $bfe34808345a21f6$var$Oa(a, b) {
    if (!a || $bfe34808345a21f6$var$Na) return "";
    $bfe34808345a21f6$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $bfe34808345a21f6$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $bfe34808345a21f6$var$Ma(a) : "";
}
function $bfe34808345a21f6$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $bfe34808345a21f6$var$Ma(a.type);
        case 16:
            return $bfe34808345a21f6$var$Ma("Lazy");
        case 13:
            return $bfe34808345a21f6$var$Ma("Suspense");
        case 19:
            return $bfe34808345a21f6$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $bfe34808345a21f6$var$Oa(a.type, !1), a;
        case 11:
            return a = $bfe34808345a21f6$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $bfe34808345a21f6$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $bfe34808345a21f6$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $bfe34808345a21f6$var$ya:
            return "Fragment";
        case $bfe34808345a21f6$var$wa:
            return "Portal";
        case $bfe34808345a21f6$var$Aa:
            return "Profiler";
        case $bfe34808345a21f6$var$za:
            return "StrictMode";
        case $bfe34808345a21f6$var$Ea:
            return "Suspense";
        case $bfe34808345a21f6$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $bfe34808345a21f6$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $bfe34808345a21f6$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $bfe34808345a21f6$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $bfe34808345a21f6$var$Ga:
            return b = a.displayName || null, null !== b ? b : $bfe34808345a21f6$var$Qa(a.type) || "Memo";
        case $bfe34808345a21f6$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $bfe34808345a21f6$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $bfe34808345a21f6$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $bfe34808345a21f6$var$Qa(b);
        case 8:
            return b === $bfe34808345a21f6$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $bfe34808345a21f6$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $bfe34808345a21f6$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $bfe34808345a21f6$var$Ua(a) {
    var b = $bfe34808345a21f6$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $bfe34808345a21f6$var$Va(a) {
    a._valueTracker || (a._valueTracker = $bfe34808345a21f6$var$Ua(a));
}
function $bfe34808345a21f6$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $bfe34808345a21f6$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $bfe34808345a21f6$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $bfe34808345a21f6$var$Ya(a, b) {
    var c = b.checked;
    return $bfe34808345a21f6$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $bfe34808345a21f6$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $bfe34808345a21f6$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $bfe34808345a21f6$var$ab(a, b) {
    b = b.checked;
    null != b && $bfe34808345a21f6$var$ta(a, "checked", b, !1);
}
function $bfe34808345a21f6$var$bb(a, b) {
    $bfe34808345a21f6$var$ab(a, b);
    var c = $bfe34808345a21f6$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $bfe34808345a21f6$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $bfe34808345a21f6$var$cb(a, b.type, $bfe34808345a21f6$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $bfe34808345a21f6$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $bfe34808345a21f6$var$cb(a, b, c) {
    if ("number" !== b || $bfe34808345a21f6$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $bfe34808345a21f6$var$eb = Array.isArray;
function $bfe34808345a21f6$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $bfe34808345a21f6$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $bfe34808345a21f6$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($bfe34808345a21f6$var$p(91));
    return $bfe34808345a21f6$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $bfe34808345a21f6$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($bfe34808345a21f6$var$p(92));
            if ($bfe34808345a21f6$var$eb(c)) {
                if (1 < c.length) throw Error($bfe34808345a21f6$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $bfe34808345a21f6$var$Sa(c)
    };
}
function $bfe34808345a21f6$var$ib(a, b) {
    var c = $bfe34808345a21f6$var$Sa(b.value), d = $bfe34808345a21f6$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $bfe34808345a21f6$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $bfe34808345a21f6$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $bfe34808345a21f6$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $bfe34808345a21f6$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $bfe34808345a21f6$var$mb, $bfe34808345a21f6$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $bfe34808345a21f6$var$mb = $bfe34808345a21f6$var$mb || document.createElement("div");
        $bfe34808345a21f6$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $bfe34808345a21f6$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $bfe34808345a21f6$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $bfe34808345a21f6$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $bfe34808345a21f6$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($bfe34808345a21f6$var$pb).forEach(function(a) {
    $bfe34808345a21f6$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $bfe34808345a21f6$var$pb[b] = $bfe34808345a21f6$var$pb[a];
    });
});
function $bfe34808345a21f6$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $bfe34808345a21f6$var$pb.hasOwnProperty(a) && $bfe34808345a21f6$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $bfe34808345a21f6$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $bfe34808345a21f6$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $bfe34808345a21f6$var$tb = $bfe34808345a21f6$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $bfe34808345a21f6$var$ub(a, b) {
    if (b) {
        if ($bfe34808345a21f6$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($bfe34808345a21f6$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($bfe34808345a21f6$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($bfe34808345a21f6$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($bfe34808345a21f6$var$p(62));
    }
}
function $bfe34808345a21f6$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bfe34808345a21f6$var$wb = null;
function $bfe34808345a21f6$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $bfe34808345a21f6$var$yb = null, $bfe34808345a21f6$var$zb = null, $bfe34808345a21f6$var$Ab = null;
function $bfe34808345a21f6$var$Bb(a) {
    if (a = $bfe34808345a21f6$var$Cb(a)) {
        if ("function" !== typeof $bfe34808345a21f6$var$yb) throw Error($bfe34808345a21f6$var$p(280));
        var b = a.stateNode;
        b && (b = $bfe34808345a21f6$var$Db(b), $bfe34808345a21f6$var$yb(a.stateNode, a.type, b));
    }
}
function $bfe34808345a21f6$var$Eb(a) {
    $bfe34808345a21f6$var$zb ? $bfe34808345a21f6$var$Ab ? $bfe34808345a21f6$var$Ab.push(a) : $bfe34808345a21f6$var$Ab = [
        a
    ] : $bfe34808345a21f6$var$zb = a;
}
function $bfe34808345a21f6$var$Fb() {
    if ($bfe34808345a21f6$var$zb) {
        var a = $bfe34808345a21f6$var$zb, b = $bfe34808345a21f6$var$Ab;
        $bfe34808345a21f6$var$Ab = $bfe34808345a21f6$var$zb = null;
        $bfe34808345a21f6$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$bfe34808345a21f6$var$Bb(b[a]);
    }
}
function $bfe34808345a21f6$var$Gb(a, b) {
    return a(b);
}
function $bfe34808345a21f6$var$Hb() {}
var $bfe34808345a21f6$var$Ib = !1;
function $bfe34808345a21f6$var$Jb(a, b, c) {
    if ($bfe34808345a21f6$var$Ib) return a(b, c);
    $bfe34808345a21f6$var$Ib = !0;
    try {
        return $bfe34808345a21f6$var$Gb(a, b, c);
    } finally{
        if ($bfe34808345a21f6$var$Ib = !1, null !== $bfe34808345a21f6$var$zb || null !== $bfe34808345a21f6$var$Ab) $bfe34808345a21f6$var$Hb(), $bfe34808345a21f6$var$Fb();
    }
}
function $bfe34808345a21f6$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $bfe34808345a21f6$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($bfe34808345a21f6$var$p(231, b, typeof c));
    return c;
}
var $bfe34808345a21f6$var$Lb = !1;
if ($bfe34808345a21f6$var$ia) try {
    var $bfe34808345a21f6$var$Mb = {};
    Object.defineProperty($bfe34808345a21f6$var$Mb, "passive", {
        get: function() {
            $bfe34808345a21f6$var$Lb = !0;
        }
    });
    window.addEventListener("test", $bfe34808345a21f6$var$Mb, $bfe34808345a21f6$var$Mb);
    window.removeEventListener("test", $bfe34808345a21f6$var$Mb, $bfe34808345a21f6$var$Mb);
} catch (a) {
    $bfe34808345a21f6$var$Lb = !1;
}
function $bfe34808345a21f6$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $bfe34808345a21f6$var$Ob = !1, $bfe34808345a21f6$var$Pb = null, $bfe34808345a21f6$var$Qb = !1, $bfe34808345a21f6$var$Rb = null, $bfe34808345a21f6$var$Sb = {
    onError: function(a) {
        $bfe34808345a21f6$var$Ob = !0;
        $bfe34808345a21f6$var$Pb = a;
    }
};
function $bfe34808345a21f6$var$Tb(a, b, c, d, e, f, g, h, k) {
    $bfe34808345a21f6$var$Ob = !1;
    $bfe34808345a21f6$var$Pb = null;
    $bfe34808345a21f6$var$Nb.apply($bfe34808345a21f6$var$Sb, arguments);
}
function $bfe34808345a21f6$var$Ub(a, b, c, d, e, f, g, h, k) {
    $bfe34808345a21f6$var$Tb.apply(this, arguments);
    if ($bfe34808345a21f6$var$Ob) {
        if ($bfe34808345a21f6$var$Ob) {
            var l = $bfe34808345a21f6$var$Pb;
            $bfe34808345a21f6$var$Ob = !1;
            $bfe34808345a21f6$var$Pb = null;
        } else throw Error($bfe34808345a21f6$var$p(198));
        $bfe34808345a21f6$var$Qb || ($bfe34808345a21f6$var$Qb = !0, $bfe34808345a21f6$var$Rb = l);
    }
}
function $bfe34808345a21f6$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $bfe34808345a21f6$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $bfe34808345a21f6$var$Xb(a) {
    if ($bfe34808345a21f6$var$Vb(a) !== a) throw Error($bfe34808345a21f6$var$p(188));
}
function $bfe34808345a21f6$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $bfe34808345a21f6$var$Vb(a);
        if (null === b) throw Error($bfe34808345a21f6$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $bfe34808345a21f6$var$Xb(e), a;
                if (f === d) return $bfe34808345a21f6$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($bfe34808345a21f6$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($bfe34808345a21f6$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($bfe34808345a21f6$var$p(190));
    }
    if (3 !== c.tag) throw Error($bfe34808345a21f6$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $bfe34808345a21f6$var$Zb(a) {
    a = $bfe34808345a21f6$var$Yb(a);
    return null !== a ? $bfe34808345a21f6$var$$b(a) : null;
}
function $bfe34808345a21f6$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $bfe34808345a21f6$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $bfe34808345a21f6$var$ac = $2N9BZ.unstable_scheduleCallback, $bfe34808345a21f6$var$bc = $2N9BZ.unstable_cancelCallback, $bfe34808345a21f6$var$cc = $2N9BZ.unstable_shouldYield, $bfe34808345a21f6$var$dc = $2N9BZ.unstable_requestPaint, $bfe34808345a21f6$var$B = $2N9BZ.unstable_now, $bfe34808345a21f6$var$ec = $2N9BZ.unstable_getCurrentPriorityLevel, $bfe34808345a21f6$var$fc = $2N9BZ.unstable_ImmediatePriority, $bfe34808345a21f6$var$gc = $2N9BZ.unstable_UserBlockingPriority, $bfe34808345a21f6$var$hc = $2N9BZ.unstable_NormalPriority, $bfe34808345a21f6$var$ic = $2N9BZ.unstable_LowPriority, $bfe34808345a21f6$var$jc = $2N9BZ.unstable_IdlePriority, $bfe34808345a21f6$var$kc = null, $bfe34808345a21f6$var$lc = null;
function $bfe34808345a21f6$var$mc(a) {
    if ($bfe34808345a21f6$var$lc && "function" === typeof $bfe34808345a21f6$var$lc.onCommitFiberRoot) try {
        $bfe34808345a21f6$var$lc.onCommitFiberRoot($bfe34808345a21f6$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $bfe34808345a21f6$var$oc = Math.clz32 ? Math.clz32 : $bfe34808345a21f6$var$nc, $bfe34808345a21f6$var$pc = Math.log, $bfe34808345a21f6$var$qc = Math.LN2;
function $bfe34808345a21f6$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($bfe34808345a21f6$var$pc(a) / $bfe34808345a21f6$var$qc | 0) | 0;
}
var $bfe34808345a21f6$var$rc = 64, $bfe34808345a21f6$var$sc = 4194304;
function $bfe34808345a21f6$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $bfe34808345a21f6$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $bfe34808345a21f6$var$tc(h) : (f &= g, 0 !== f && (d = $bfe34808345a21f6$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $bfe34808345a21f6$var$tc(g) : 0 !== f && (d = $bfe34808345a21f6$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $bfe34808345a21f6$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $bfe34808345a21f6$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bfe34808345a21f6$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $bfe34808345a21f6$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $bfe34808345a21f6$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $bfe34808345a21f6$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $bfe34808345a21f6$var$yc() {
    var a = $bfe34808345a21f6$var$rc;
    $bfe34808345a21f6$var$rc <<= 1;
    0 === ($bfe34808345a21f6$var$rc & 4194240) && ($bfe34808345a21f6$var$rc = 64);
    return a;
}
function $bfe34808345a21f6$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $bfe34808345a21f6$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $bfe34808345a21f6$var$oc(b);
    a[b] = c;
}
function $bfe34808345a21f6$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $bfe34808345a21f6$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $bfe34808345a21f6$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $bfe34808345a21f6$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $bfe34808345a21f6$var$C = 0;
function $bfe34808345a21f6$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $bfe34808345a21f6$var$Ec, $bfe34808345a21f6$var$Fc, $bfe34808345a21f6$var$Gc, $bfe34808345a21f6$var$Hc, $bfe34808345a21f6$var$Ic, $bfe34808345a21f6$var$Jc = !1, $bfe34808345a21f6$var$Kc = [], $bfe34808345a21f6$var$Lc = null, $bfe34808345a21f6$var$Mc = null, $bfe34808345a21f6$var$Nc = null, $bfe34808345a21f6$var$Oc = new Map, $bfe34808345a21f6$var$Pc = new Map, $bfe34808345a21f6$var$Qc = [], $bfe34808345a21f6$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $bfe34808345a21f6$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $bfe34808345a21f6$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $bfe34808345a21f6$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $bfe34808345a21f6$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $bfe34808345a21f6$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bfe34808345a21f6$var$Pc.delete(b.pointerId);
    }
}
function $bfe34808345a21f6$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $bfe34808345a21f6$var$Cb(b), null !== b && $bfe34808345a21f6$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $bfe34808345a21f6$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $bfe34808345a21f6$var$Lc = $bfe34808345a21f6$var$Tc($bfe34808345a21f6$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $bfe34808345a21f6$var$Mc = $bfe34808345a21f6$var$Tc($bfe34808345a21f6$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $bfe34808345a21f6$var$Nc = $bfe34808345a21f6$var$Tc($bfe34808345a21f6$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $bfe34808345a21f6$var$Oc.set(f, $bfe34808345a21f6$var$Tc($bfe34808345a21f6$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $bfe34808345a21f6$var$Pc.set(f, $bfe34808345a21f6$var$Tc($bfe34808345a21f6$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $bfe34808345a21f6$var$Vc(a) {
    var b = $bfe34808345a21f6$var$Wc(a.target);
    if (null !== b) {
        var c = $bfe34808345a21f6$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $bfe34808345a21f6$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $bfe34808345a21f6$var$Ic(a.priority, function() {
                        $bfe34808345a21f6$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $bfe34808345a21f6$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $bfe34808345a21f6$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $bfe34808345a21f6$var$wb = d;
            c.target.dispatchEvent(d);
            $bfe34808345a21f6$var$wb = null;
        } else return b = $bfe34808345a21f6$var$Cb(c), null !== b && $bfe34808345a21f6$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $bfe34808345a21f6$var$Zc(a, b, c) {
    $bfe34808345a21f6$var$Xc(a) && c.delete(b);
}
function $bfe34808345a21f6$var$$c() {
    $bfe34808345a21f6$var$Jc = !1;
    null !== $bfe34808345a21f6$var$Lc && $bfe34808345a21f6$var$Xc($bfe34808345a21f6$var$Lc) && ($bfe34808345a21f6$var$Lc = null);
    null !== $bfe34808345a21f6$var$Mc && $bfe34808345a21f6$var$Xc($bfe34808345a21f6$var$Mc) && ($bfe34808345a21f6$var$Mc = null);
    null !== $bfe34808345a21f6$var$Nc && $bfe34808345a21f6$var$Xc($bfe34808345a21f6$var$Nc) && ($bfe34808345a21f6$var$Nc = null);
    $bfe34808345a21f6$var$Oc.forEach($bfe34808345a21f6$var$Zc);
    $bfe34808345a21f6$var$Pc.forEach($bfe34808345a21f6$var$Zc);
}
function $bfe34808345a21f6$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $bfe34808345a21f6$var$Jc || ($bfe34808345a21f6$var$Jc = !0, $2N9BZ.unstable_scheduleCallback($2N9BZ.unstable_NormalPriority, $bfe34808345a21f6$var$$c)));
}
function $bfe34808345a21f6$var$bd(a) {
    function b(b) {
        return $bfe34808345a21f6$var$ad(b, a);
    }
    if (0 < $bfe34808345a21f6$var$Kc.length) {
        $bfe34808345a21f6$var$ad($bfe34808345a21f6$var$Kc[0], a);
        for(var c = 1; c < $bfe34808345a21f6$var$Kc.length; c++){
            var d = $bfe34808345a21f6$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $bfe34808345a21f6$var$Lc && $bfe34808345a21f6$var$ad($bfe34808345a21f6$var$Lc, a);
    null !== $bfe34808345a21f6$var$Mc && $bfe34808345a21f6$var$ad($bfe34808345a21f6$var$Mc, a);
    null !== $bfe34808345a21f6$var$Nc && $bfe34808345a21f6$var$ad($bfe34808345a21f6$var$Nc, a);
    $bfe34808345a21f6$var$Oc.forEach(b);
    $bfe34808345a21f6$var$Pc.forEach(b);
    for(c = 0; c < $bfe34808345a21f6$var$Qc.length; c++)d = $bfe34808345a21f6$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $bfe34808345a21f6$var$Qc.length && (c = $bfe34808345a21f6$var$Qc[0], null === c.blockedOn);)$bfe34808345a21f6$var$Vc(c), null === c.blockedOn && $bfe34808345a21f6$var$Qc.shift();
}
var $bfe34808345a21f6$var$cd = $bfe34808345a21f6$var$ua.ReactCurrentBatchConfig, $bfe34808345a21f6$var$dd = !0;
function $bfe34808345a21f6$var$ed(a, b, c, d) {
    var e = $bfe34808345a21f6$var$C, f = $bfe34808345a21f6$var$cd.transition;
    $bfe34808345a21f6$var$cd.transition = null;
    try {
        $bfe34808345a21f6$var$C = 1, $bfe34808345a21f6$var$fd(a, b, c, d);
    } finally{
        $bfe34808345a21f6$var$C = e, $bfe34808345a21f6$var$cd.transition = f;
    }
}
function $bfe34808345a21f6$var$gd(a, b, c, d) {
    var e = $bfe34808345a21f6$var$C, f = $bfe34808345a21f6$var$cd.transition;
    $bfe34808345a21f6$var$cd.transition = null;
    try {
        $bfe34808345a21f6$var$C = 4, $bfe34808345a21f6$var$fd(a, b, c, d);
    } finally{
        $bfe34808345a21f6$var$C = e, $bfe34808345a21f6$var$cd.transition = f;
    }
}
function $bfe34808345a21f6$var$fd(a, b, c, d) {
    if ($bfe34808345a21f6$var$dd) {
        var e = $bfe34808345a21f6$var$Yc(a, b, c, d);
        if (null === e) $bfe34808345a21f6$var$hd(a, b, d, $bfe34808345a21f6$var$id, c), $bfe34808345a21f6$var$Sc(a, d);
        else if ($bfe34808345a21f6$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($bfe34808345a21f6$var$Sc(a, d), b & 4 && -1 < $bfe34808345a21f6$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $bfe34808345a21f6$var$Cb(e);
                null !== f && $bfe34808345a21f6$var$Ec(f);
                f = $bfe34808345a21f6$var$Yc(a, b, c, d);
                null === f && $bfe34808345a21f6$var$hd(a, b, d, $bfe34808345a21f6$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $bfe34808345a21f6$var$hd(a, b, d, null, c);
    }
}
var $bfe34808345a21f6$var$id = null;
function $bfe34808345a21f6$var$Yc(a, b, c, d) {
    $bfe34808345a21f6$var$id = null;
    a = $bfe34808345a21f6$var$xb(d);
    a = $bfe34808345a21f6$var$Wc(a);
    if (null !== a) {
        if (b = $bfe34808345a21f6$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $bfe34808345a21f6$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $bfe34808345a21f6$var$id = a;
    return null;
}
function $bfe34808345a21f6$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($bfe34808345a21f6$var$ec()){
                case $bfe34808345a21f6$var$fc:
                    return 1;
                case $bfe34808345a21f6$var$gc:
                    return 4;
                case $bfe34808345a21f6$var$hc:
                case $bfe34808345a21f6$var$ic:
                    return 16;
                case $bfe34808345a21f6$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $bfe34808345a21f6$var$kd = null, $bfe34808345a21f6$var$ld = null, $bfe34808345a21f6$var$md = null;
function $bfe34808345a21f6$var$nd() {
    if ($bfe34808345a21f6$var$md) return $bfe34808345a21f6$var$md;
    var a, b = $bfe34808345a21f6$var$ld, c = b.length, d, e = "value" in $bfe34808345a21f6$var$kd ? $bfe34808345a21f6$var$kd.value : $bfe34808345a21f6$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $bfe34808345a21f6$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $bfe34808345a21f6$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $bfe34808345a21f6$var$pd() {
    return !0;
}
function $bfe34808345a21f6$var$qd() {
    return !1;
}
function $bfe34808345a21f6$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $bfe34808345a21f6$var$pd : $bfe34808345a21f6$var$qd;
        this.isPropagationStopped = $bfe34808345a21f6$var$qd;
        return this;
    }
    $bfe34808345a21f6$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $bfe34808345a21f6$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $bfe34808345a21f6$var$pd);
        },
        persist: function() {},
        isPersistent: $bfe34808345a21f6$var$pd
    });
    return b;
}
var $bfe34808345a21f6$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bfe34808345a21f6$var$td = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$sd), $bfe34808345a21f6$var$ud = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$sd, {
    view: 0,
    detail: 0
}), $bfe34808345a21f6$var$vd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$ud), $bfe34808345a21f6$var$wd, $bfe34808345a21f6$var$xd, $bfe34808345a21f6$var$yd, $bfe34808345a21f6$var$Ad = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bfe34808345a21f6$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $bfe34808345a21f6$var$yd && ($bfe34808345a21f6$var$yd && "mousemove" === a.type ? ($bfe34808345a21f6$var$wd = a.screenX - $bfe34808345a21f6$var$yd.screenX, $bfe34808345a21f6$var$xd = a.screenY - $bfe34808345a21f6$var$yd.screenY) : $bfe34808345a21f6$var$xd = $bfe34808345a21f6$var$wd = 0, $bfe34808345a21f6$var$yd = a);
        return $bfe34808345a21f6$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $bfe34808345a21f6$var$xd;
    }
}), $bfe34808345a21f6$var$Bd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Ad), $bfe34808345a21f6$var$Cd = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$Ad, {
    dataTransfer: 0
}), $bfe34808345a21f6$var$Dd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Cd), $bfe34808345a21f6$var$Ed = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$ud, {
    relatedTarget: 0
}), $bfe34808345a21f6$var$Fd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Ed), $bfe34808345a21f6$var$Gd = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bfe34808345a21f6$var$Hd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Gd), $bfe34808345a21f6$var$Id = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $bfe34808345a21f6$var$Jd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Id), $bfe34808345a21f6$var$Kd = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$sd, {
    data: 0
}), $bfe34808345a21f6$var$Ld = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Kd), $bfe34808345a21f6$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bfe34808345a21f6$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bfe34808345a21f6$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bfe34808345a21f6$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $bfe34808345a21f6$var$Od[a]) ? !!b[a] : !1;
}
function $bfe34808345a21f6$var$zd() {
    return $bfe34808345a21f6$var$Pd;
}
var $bfe34808345a21f6$var$Qd = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $bfe34808345a21f6$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $bfe34808345a21f6$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $bfe34808345a21f6$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bfe34808345a21f6$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $bfe34808345a21f6$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $bfe34808345a21f6$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $bfe34808345a21f6$var$Rd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Qd), $bfe34808345a21f6$var$Sd = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bfe34808345a21f6$var$Td = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Sd), $bfe34808345a21f6$var$Ud = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bfe34808345a21f6$var$zd
}), $bfe34808345a21f6$var$Vd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Ud), $bfe34808345a21f6$var$Wd = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bfe34808345a21f6$var$Xd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Wd), $bfe34808345a21f6$var$Yd = $bfe34808345a21f6$var$A({}, $bfe34808345a21f6$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bfe34808345a21f6$var$Zd = $bfe34808345a21f6$var$rd($bfe34808345a21f6$var$Yd), $bfe34808345a21f6$var$$d = [
    9,
    13,
    27,
    32
], $bfe34808345a21f6$var$ae = $bfe34808345a21f6$var$ia && "CompositionEvent" in window, $bfe34808345a21f6$var$be = null;
$bfe34808345a21f6$var$ia && "documentMode" in document && ($bfe34808345a21f6$var$be = document.documentMode);
var $bfe34808345a21f6$var$ce = $bfe34808345a21f6$var$ia && "TextEvent" in window && !$bfe34808345a21f6$var$be, $bfe34808345a21f6$var$de = $bfe34808345a21f6$var$ia && (!$bfe34808345a21f6$var$ae || $bfe34808345a21f6$var$be && 8 < $bfe34808345a21f6$var$be && 11 >= $bfe34808345a21f6$var$be), $bfe34808345a21f6$var$ee = String.fromCharCode(32), $bfe34808345a21f6$var$fe = !1;
function $bfe34808345a21f6$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $bfe34808345a21f6$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bfe34808345a21f6$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $bfe34808345a21f6$var$ie = !1;
function $bfe34808345a21f6$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $bfe34808345a21f6$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $bfe34808345a21f6$var$fe = !0;
            return $bfe34808345a21f6$var$ee;
        case "textInput":
            return a = b.data, a === $bfe34808345a21f6$var$ee && $bfe34808345a21f6$var$fe ? null : a;
        default:
            return null;
    }
}
function $bfe34808345a21f6$var$ke(a, b) {
    if ($bfe34808345a21f6$var$ie) return "compositionend" === a || !$bfe34808345a21f6$var$ae && $bfe34808345a21f6$var$ge(a, b) ? (a = $bfe34808345a21f6$var$nd(), $bfe34808345a21f6$var$md = $bfe34808345a21f6$var$ld = $bfe34808345a21f6$var$kd = null, $bfe34808345a21f6$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $bfe34808345a21f6$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $bfe34808345a21f6$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bfe34808345a21f6$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$bfe34808345a21f6$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $bfe34808345a21f6$var$ne(a, b, c, d) {
    $bfe34808345a21f6$var$Eb(d);
    b = $bfe34808345a21f6$var$oe(b, "onChange");
    0 < b.length && (c = new $bfe34808345a21f6$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $bfe34808345a21f6$var$pe = null, $bfe34808345a21f6$var$qe = null;
function $bfe34808345a21f6$var$re(a) {
    $bfe34808345a21f6$var$se(a, 0);
}
function $bfe34808345a21f6$var$te(a) {
    var b = $bfe34808345a21f6$var$ue(a);
    if ($bfe34808345a21f6$var$Wa(b)) return a;
}
function $bfe34808345a21f6$var$ve(a, b) {
    if ("change" === a) return b;
}
var $bfe34808345a21f6$var$we = !1;
if ($bfe34808345a21f6$var$ia) {
    var $bfe34808345a21f6$var$xe;
    if ($bfe34808345a21f6$var$ia) {
        var $bfe34808345a21f6$var$ye = "oninput" in document;
        if (!$bfe34808345a21f6$var$ye) {
            var $bfe34808345a21f6$var$ze = document.createElement("div");
            $bfe34808345a21f6$var$ze.setAttribute("oninput", "return;");
            $bfe34808345a21f6$var$ye = "function" === typeof $bfe34808345a21f6$var$ze.oninput;
        }
        $bfe34808345a21f6$var$xe = $bfe34808345a21f6$var$ye;
    } else $bfe34808345a21f6$var$xe = !1;
    $bfe34808345a21f6$var$we = $bfe34808345a21f6$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $bfe34808345a21f6$var$Ae() {
    $bfe34808345a21f6$var$pe && ($bfe34808345a21f6$var$pe.detachEvent("onpropertychange", $bfe34808345a21f6$var$Be), $bfe34808345a21f6$var$qe = $bfe34808345a21f6$var$pe = null);
}
function $bfe34808345a21f6$var$Be(a) {
    if ("value" === a.propertyName && $bfe34808345a21f6$var$te($bfe34808345a21f6$var$qe)) {
        var b = [];
        $bfe34808345a21f6$var$ne(b, $bfe34808345a21f6$var$qe, a, $bfe34808345a21f6$var$xb(a));
        $bfe34808345a21f6$var$Jb($bfe34808345a21f6$var$re, b);
    }
}
function $bfe34808345a21f6$var$Ce(a, b, c) {
    "focusin" === a ? ($bfe34808345a21f6$var$Ae(), $bfe34808345a21f6$var$pe = b, $bfe34808345a21f6$var$qe = c, $bfe34808345a21f6$var$pe.attachEvent("onpropertychange", $bfe34808345a21f6$var$Be)) : "focusout" === a && $bfe34808345a21f6$var$Ae();
}
function $bfe34808345a21f6$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $bfe34808345a21f6$var$te($bfe34808345a21f6$var$qe);
}
function $bfe34808345a21f6$var$Ee(a, b) {
    if ("click" === a) return $bfe34808345a21f6$var$te(b);
}
function $bfe34808345a21f6$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $bfe34808345a21f6$var$te(b);
}
function $bfe34808345a21f6$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bfe34808345a21f6$var$He = "function" === typeof Object.is ? Object.is : $bfe34808345a21f6$var$Ge;
function $bfe34808345a21f6$var$Ie(a, b) {
    if ($bfe34808345a21f6$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$bfe34808345a21f6$var$ja.call(b, e) || !$bfe34808345a21f6$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $bfe34808345a21f6$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $bfe34808345a21f6$var$Ke(a, b) {
    var c = $bfe34808345a21f6$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $bfe34808345a21f6$var$Je(c);
    }
}
function $bfe34808345a21f6$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $bfe34808345a21f6$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $bfe34808345a21f6$var$Me() {
    for(var a = window, b = $bfe34808345a21f6$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $bfe34808345a21f6$var$Xa(a.document);
    }
    return b;
}
function $bfe34808345a21f6$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $bfe34808345a21f6$var$Oe(a) {
    var b = $bfe34808345a21f6$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $bfe34808345a21f6$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $bfe34808345a21f6$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $bfe34808345a21f6$var$Ke(c, f);
                var g = $bfe34808345a21f6$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $bfe34808345a21f6$var$Pe = $bfe34808345a21f6$var$ia && "documentMode" in document && 11 >= document.documentMode, $bfe34808345a21f6$var$Qe = null, $bfe34808345a21f6$var$Re = null, $bfe34808345a21f6$var$Se = null, $bfe34808345a21f6$var$Te = !1;
function $bfe34808345a21f6$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $bfe34808345a21f6$var$Te || null == $bfe34808345a21f6$var$Qe || $bfe34808345a21f6$var$Qe !== $bfe34808345a21f6$var$Xa(d) || (d = $bfe34808345a21f6$var$Qe, "selectionStart" in d && $bfe34808345a21f6$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $bfe34808345a21f6$var$Se && $bfe34808345a21f6$var$Ie($bfe34808345a21f6$var$Se, d) || ($bfe34808345a21f6$var$Se = d, d = $bfe34808345a21f6$var$oe($bfe34808345a21f6$var$Re, "onSelect"), 0 < d.length && (b = new $bfe34808345a21f6$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $bfe34808345a21f6$var$Qe)));
}
function $bfe34808345a21f6$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $bfe34808345a21f6$var$We = {
    animationend: $bfe34808345a21f6$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $bfe34808345a21f6$var$Ve("Animation", "AnimationIteration"),
    animationstart: $bfe34808345a21f6$var$Ve("Animation", "AnimationStart"),
    transitionend: $bfe34808345a21f6$var$Ve("Transition", "TransitionEnd")
}, $bfe34808345a21f6$var$Xe = {}, $bfe34808345a21f6$var$Ye = {};
$bfe34808345a21f6$var$ia && ($bfe34808345a21f6$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $bfe34808345a21f6$var$We.animationend.animation, delete $bfe34808345a21f6$var$We.animationiteration.animation, delete $bfe34808345a21f6$var$We.animationstart.animation), "TransitionEvent" in window || delete $bfe34808345a21f6$var$We.transitionend.transition);
function $bfe34808345a21f6$var$Ze(a) {
    if ($bfe34808345a21f6$var$Xe[a]) return $bfe34808345a21f6$var$Xe[a];
    if (!$bfe34808345a21f6$var$We[a]) return a;
    var b = $bfe34808345a21f6$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $bfe34808345a21f6$var$Ye) return $bfe34808345a21f6$var$Xe[a] = b[c];
    return a;
}
var $bfe34808345a21f6$var$$e = $bfe34808345a21f6$var$Ze("animationend"), $bfe34808345a21f6$var$af = $bfe34808345a21f6$var$Ze("animationiteration"), $bfe34808345a21f6$var$bf = $bfe34808345a21f6$var$Ze("animationstart"), $bfe34808345a21f6$var$cf = $bfe34808345a21f6$var$Ze("transitionend"), $bfe34808345a21f6$var$df = new Map, $bfe34808345a21f6$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $bfe34808345a21f6$var$ff(a, b) {
    $bfe34808345a21f6$var$df.set(a, b);
    $bfe34808345a21f6$var$fa(b, [
        a
    ]);
}
for(var $bfe34808345a21f6$var$gf = 0; $bfe34808345a21f6$var$gf < $bfe34808345a21f6$var$ef.length; $bfe34808345a21f6$var$gf++){
    var $bfe34808345a21f6$var$hf = $bfe34808345a21f6$var$ef[$bfe34808345a21f6$var$gf], $bfe34808345a21f6$var$jf = $bfe34808345a21f6$var$hf.toLowerCase(), $bfe34808345a21f6$var$kf = $bfe34808345a21f6$var$hf[0].toUpperCase() + $bfe34808345a21f6$var$hf.slice(1);
    $bfe34808345a21f6$var$ff($bfe34808345a21f6$var$jf, "on" + $bfe34808345a21f6$var$kf);
}
$bfe34808345a21f6$var$ff($bfe34808345a21f6$var$$e, "onAnimationEnd");
$bfe34808345a21f6$var$ff($bfe34808345a21f6$var$af, "onAnimationIteration");
$bfe34808345a21f6$var$ff($bfe34808345a21f6$var$bf, "onAnimationStart");
$bfe34808345a21f6$var$ff("dblclick", "onDoubleClick");
$bfe34808345a21f6$var$ff("focusin", "onFocus");
$bfe34808345a21f6$var$ff("focusout", "onBlur");
$bfe34808345a21f6$var$ff($bfe34808345a21f6$var$cf, "onTransitionEnd");
$bfe34808345a21f6$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bfe34808345a21f6$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bfe34808345a21f6$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bfe34808345a21f6$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bfe34808345a21f6$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bfe34808345a21f6$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bfe34808345a21f6$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bfe34808345a21f6$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bfe34808345a21f6$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bfe34808345a21f6$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bfe34808345a21f6$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bfe34808345a21f6$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($bfe34808345a21f6$var$lf));
function $bfe34808345a21f6$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $bfe34808345a21f6$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $bfe34808345a21f6$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bfe34808345a21f6$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bfe34808345a21f6$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($bfe34808345a21f6$var$Qb) throw a = $bfe34808345a21f6$var$Rb, $bfe34808345a21f6$var$Qb = !1, $bfe34808345a21f6$var$Rb = null, a;
}
function $bfe34808345a21f6$var$D(a, b) {
    var c = b[$bfe34808345a21f6$var$of];
    void 0 === c && (c = b[$bfe34808345a21f6$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($bfe34808345a21f6$var$pf(b, a, 2, !1), c.add(d));
}
function $bfe34808345a21f6$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $bfe34808345a21f6$var$pf(c, a, d, b);
}
var $bfe34808345a21f6$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $bfe34808345a21f6$var$sf(a) {
    if (!a[$bfe34808345a21f6$var$rf]) {
        a[$bfe34808345a21f6$var$rf] = !0;
        $bfe34808345a21f6$var$da.forEach(function(b) {
            "selectionchange" !== b && ($bfe34808345a21f6$var$mf.has(b) || $bfe34808345a21f6$var$qf(b, !1, a), $bfe34808345a21f6$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$bfe34808345a21f6$var$rf] || (b[$bfe34808345a21f6$var$rf] = !0, $bfe34808345a21f6$var$qf("selectionchange", !1, b));
    }
}
function $bfe34808345a21f6$var$pf(a, b, c, d) {
    switch($bfe34808345a21f6$var$jd(b)){
        case 1:
            var e = $bfe34808345a21f6$var$ed;
            break;
        case 4:
            e = $bfe34808345a21f6$var$gd;
            break;
        default:
            e = $bfe34808345a21f6$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$bfe34808345a21f6$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $bfe34808345a21f6$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $bfe34808345a21f6$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $bfe34808345a21f6$var$Jb(function() {
        var d = f, e = $bfe34808345a21f6$var$xb(c), g = [];
        a: {
            var h = $bfe34808345a21f6$var$df.get(a);
            if (void 0 !== h) {
                var k = $bfe34808345a21f6$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $bfe34808345a21f6$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $bfe34808345a21f6$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $bfe34808345a21f6$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $bfe34808345a21f6$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $bfe34808345a21f6$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $bfe34808345a21f6$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $bfe34808345a21f6$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $bfe34808345a21f6$var$Vd;
                        break;
                    case $bfe34808345a21f6$var$$e:
                    case $bfe34808345a21f6$var$af:
                    case $bfe34808345a21f6$var$bf:
                        k = $bfe34808345a21f6$var$Hd;
                        break;
                    case $bfe34808345a21f6$var$cf:
                        k = $bfe34808345a21f6$var$Xd;
                        break;
                    case "scroll":
                        k = $bfe34808345a21f6$var$vd;
                        break;
                    case "wheel":
                        k = $bfe34808345a21f6$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $bfe34808345a21f6$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $bfe34808345a21f6$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $bfe34808345a21f6$var$Kb(w, x), null != F && t.push($bfe34808345a21f6$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $bfe34808345a21f6$var$wb && (n = c.relatedTarget || c.fromElement) && ($bfe34808345a21f6$var$Wc(n) || n[$bfe34808345a21f6$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $bfe34808345a21f6$var$Wc(n) : null, null !== n && (J = $bfe34808345a21f6$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $bfe34808345a21f6$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $bfe34808345a21f6$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $bfe34808345a21f6$var$ue(k);
                        u = null == n ? h : $bfe34808345a21f6$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $bfe34808345a21f6$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $bfe34808345a21f6$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $bfe34808345a21f6$var$vf(F))u++;
                            for(; 0 < w - u;)t = $bfe34808345a21f6$var$vf(t), w--;
                            for(; 0 < u - w;)x = $bfe34808345a21f6$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $bfe34808345a21f6$var$vf(t);
                                x = $bfe34808345a21f6$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $bfe34808345a21f6$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $bfe34808345a21f6$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $bfe34808345a21f6$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $bfe34808345a21f6$var$ve;
                else if ($bfe34808345a21f6$var$me(h)) {
                    if ($bfe34808345a21f6$var$we) na = $bfe34808345a21f6$var$Fe;
                    else {
                        na = $bfe34808345a21f6$var$De;
                        var xa = $bfe34808345a21f6$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $bfe34808345a21f6$var$Ee);
                if (na && (na = na(a, d))) {
                    $bfe34808345a21f6$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $bfe34808345a21f6$var$cb(h, "number", h.value);
            }
            xa = d ? $bfe34808345a21f6$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($bfe34808345a21f6$var$me(xa) || "true" === xa.contentEditable) $bfe34808345a21f6$var$Qe = xa, $bfe34808345a21f6$var$Re = d, $bfe34808345a21f6$var$Se = null;
                    break;
                case "focusout":
                    $bfe34808345a21f6$var$Se = $bfe34808345a21f6$var$Re = $bfe34808345a21f6$var$Qe = null;
                    break;
                case "mousedown":
                    $bfe34808345a21f6$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bfe34808345a21f6$var$Te = !1;
                    $bfe34808345a21f6$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($bfe34808345a21f6$var$Pe) break;
                case "keydown":
                case "keyup":
                    $bfe34808345a21f6$var$Ue(g, c, e);
            }
            var $a;
            if ($bfe34808345a21f6$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $bfe34808345a21f6$var$ie ? $bfe34808345a21f6$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($bfe34808345a21f6$var$de && "ko" !== c.locale && ($bfe34808345a21f6$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $bfe34808345a21f6$var$ie && ($a = $bfe34808345a21f6$var$nd()) : ($bfe34808345a21f6$var$kd = e, $bfe34808345a21f6$var$ld = "value" in $bfe34808345a21f6$var$kd ? $bfe34808345a21f6$var$kd.value : $bfe34808345a21f6$var$kd.textContent, $bfe34808345a21f6$var$ie = !0)), xa = $bfe34808345a21f6$var$oe(d, ba), 0 < xa.length && (ba = new $bfe34808345a21f6$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $bfe34808345a21f6$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $bfe34808345a21f6$var$ce ? $bfe34808345a21f6$var$je(a, c) : $bfe34808345a21f6$var$ke(a, c)) d = $bfe34808345a21f6$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $bfe34808345a21f6$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $bfe34808345a21f6$var$se(g, b);
    });
}
function $bfe34808345a21f6$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $bfe34808345a21f6$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $bfe34808345a21f6$var$Kb(a, c), null != f && d.unshift($bfe34808345a21f6$var$tf(a, f, e)), f = $bfe34808345a21f6$var$Kb(a, b), null != f && d.push($bfe34808345a21f6$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $bfe34808345a21f6$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $bfe34808345a21f6$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $bfe34808345a21f6$var$Kb(c, f), null != k && g.unshift($bfe34808345a21f6$var$tf(c, k, h))) : e || (k = $bfe34808345a21f6$var$Kb(c, f), null != k && g.push($bfe34808345a21f6$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $bfe34808345a21f6$var$xf = /\r\n?/g, $bfe34808345a21f6$var$yf = /\u0000|\uFFFD/g;
function $bfe34808345a21f6$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($bfe34808345a21f6$var$xf, "\n").replace($bfe34808345a21f6$var$yf, "");
}
function $bfe34808345a21f6$var$Af(a, b, c) {
    b = $bfe34808345a21f6$var$zf(b);
    if ($bfe34808345a21f6$var$zf(a) !== b && c) throw Error($bfe34808345a21f6$var$p(425));
}
function $bfe34808345a21f6$var$Bf() {}
var $bfe34808345a21f6$var$Cf = null, $bfe34808345a21f6$var$Df = null;
function $bfe34808345a21f6$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $bfe34808345a21f6$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $bfe34808345a21f6$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $bfe34808345a21f6$var$Hf = "function" === typeof Promise ? Promise : void 0, $bfe34808345a21f6$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bfe34808345a21f6$var$Hf ? function(a) {
    return $bfe34808345a21f6$var$Hf.resolve(null).then(a).catch($bfe34808345a21f6$var$If);
} : $bfe34808345a21f6$var$Ff;
function $bfe34808345a21f6$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $bfe34808345a21f6$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $bfe34808345a21f6$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $bfe34808345a21f6$var$bd(b);
}
function $bfe34808345a21f6$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $bfe34808345a21f6$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $bfe34808345a21f6$var$Nf = Math.random().toString(36).slice(2), $bfe34808345a21f6$var$Of = "__reactFiber$" + $bfe34808345a21f6$var$Nf, $bfe34808345a21f6$var$Pf = "__reactProps$" + $bfe34808345a21f6$var$Nf, $bfe34808345a21f6$var$uf = "__reactContainer$" + $bfe34808345a21f6$var$Nf, $bfe34808345a21f6$var$of = "__reactEvents$" + $bfe34808345a21f6$var$Nf, $bfe34808345a21f6$var$Qf = "__reactListeners$" + $bfe34808345a21f6$var$Nf, $bfe34808345a21f6$var$Rf = "__reactHandles$" + $bfe34808345a21f6$var$Nf;
function $bfe34808345a21f6$var$Wc(a) {
    var b = a[$bfe34808345a21f6$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$bfe34808345a21f6$var$uf] || c[$bfe34808345a21f6$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $bfe34808345a21f6$var$Mf(a); null !== a;){
                if (c = a[$bfe34808345a21f6$var$Of]) return c;
                a = $bfe34808345a21f6$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $bfe34808345a21f6$var$Cb(a) {
    a = a[$bfe34808345a21f6$var$Of] || a[$bfe34808345a21f6$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $bfe34808345a21f6$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($bfe34808345a21f6$var$p(33));
}
function $bfe34808345a21f6$var$Db(a) {
    return a[$bfe34808345a21f6$var$Pf] || null;
}
var $bfe34808345a21f6$var$Sf = [], $bfe34808345a21f6$var$Tf = -1;
function $bfe34808345a21f6$var$Uf(a) {
    return {
        current: a
    };
}
function $bfe34808345a21f6$var$E(a) {
    0 > $bfe34808345a21f6$var$Tf || (a.current = $bfe34808345a21f6$var$Sf[$bfe34808345a21f6$var$Tf], $bfe34808345a21f6$var$Sf[$bfe34808345a21f6$var$Tf] = null, $bfe34808345a21f6$var$Tf--);
}
function $bfe34808345a21f6$var$G(a, b) {
    $bfe34808345a21f6$var$Tf++;
    $bfe34808345a21f6$var$Sf[$bfe34808345a21f6$var$Tf] = a.current;
    a.current = b;
}
var $bfe34808345a21f6$var$Vf = {}, $bfe34808345a21f6$var$H = $bfe34808345a21f6$var$Uf($bfe34808345a21f6$var$Vf), $bfe34808345a21f6$var$Wf = $bfe34808345a21f6$var$Uf(!1), $bfe34808345a21f6$var$Xf = $bfe34808345a21f6$var$Vf;
function $bfe34808345a21f6$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $bfe34808345a21f6$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $bfe34808345a21f6$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $bfe34808345a21f6$var$$f() {
    $bfe34808345a21f6$var$E($bfe34808345a21f6$var$Wf);
    $bfe34808345a21f6$var$E($bfe34808345a21f6$var$H);
}
function $bfe34808345a21f6$var$ag(a, b, c) {
    if ($bfe34808345a21f6$var$H.current !== $bfe34808345a21f6$var$Vf) throw Error($bfe34808345a21f6$var$p(168));
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$H, b);
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$Wf, c);
}
function $bfe34808345a21f6$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($bfe34808345a21f6$var$p(108, $bfe34808345a21f6$var$Ra(a) || "Unknown", e));
    return $bfe34808345a21f6$var$A({}, c, d);
}
function $bfe34808345a21f6$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $bfe34808345a21f6$var$Vf;
    $bfe34808345a21f6$var$Xf = $bfe34808345a21f6$var$H.current;
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$H, a);
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$Wf, $bfe34808345a21f6$var$Wf.current);
    return !0;
}
function $bfe34808345a21f6$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($bfe34808345a21f6$var$p(169));
    c ? (a = $bfe34808345a21f6$var$bg(a, b, $bfe34808345a21f6$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $bfe34808345a21f6$var$E($bfe34808345a21f6$var$Wf), $bfe34808345a21f6$var$E($bfe34808345a21f6$var$H), $bfe34808345a21f6$var$G($bfe34808345a21f6$var$H, a)) : $bfe34808345a21f6$var$E($bfe34808345a21f6$var$Wf);
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$Wf, c);
}
var $bfe34808345a21f6$var$eg = null, $bfe34808345a21f6$var$fg = !1, $bfe34808345a21f6$var$gg = !1;
function $bfe34808345a21f6$var$hg(a) {
    null === $bfe34808345a21f6$var$eg ? $bfe34808345a21f6$var$eg = [
        a
    ] : $bfe34808345a21f6$var$eg.push(a);
}
function $bfe34808345a21f6$var$ig(a) {
    $bfe34808345a21f6$var$fg = !0;
    $bfe34808345a21f6$var$hg(a);
}
function $bfe34808345a21f6$var$jg() {
    if (!$bfe34808345a21f6$var$gg && null !== $bfe34808345a21f6$var$eg) {
        $bfe34808345a21f6$var$gg = !0;
        var a = 0, b = $bfe34808345a21f6$var$C;
        try {
            var c = $bfe34808345a21f6$var$eg;
            for($bfe34808345a21f6$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $bfe34808345a21f6$var$eg = null;
            $bfe34808345a21f6$var$fg = !1;
        } catch (e) {
            throw null !== $bfe34808345a21f6$var$eg && ($bfe34808345a21f6$var$eg = $bfe34808345a21f6$var$eg.slice(a + 1)), $bfe34808345a21f6$var$ac($bfe34808345a21f6$var$fc, $bfe34808345a21f6$var$jg), e;
        } finally{
            $bfe34808345a21f6$var$C = b, $bfe34808345a21f6$var$gg = !1;
        }
    }
    return null;
}
var $bfe34808345a21f6$var$kg = [], $bfe34808345a21f6$var$lg = 0, $bfe34808345a21f6$var$mg = null, $bfe34808345a21f6$var$ng = 0, $bfe34808345a21f6$var$og = [], $bfe34808345a21f6$var$pg = 0, $bfe34808345a21f6$var$qg = null, $bfe34808345a21f6$var$rg = 1, $bfe34808345a21f6$var$sg = "";
function $bfe34808345a21f6$var$tg(a, b) {
    $bfe34808345a21f6$var$kg[$bfe34808345a21f6$var$lg++] = $bfe34808345a21f6$var$ng;
    $bfe34808345a21f6$var$kg[$bfe34808345a21f6$var$lg++] = $bfe34808345a21f6$var$mg;
    $bfe34808345a21f6$var$mg = a;
    $bfe34808345a21f6$var$ng = b;
}
function $bfe34808345a21f6$var$ug(a, b, c) {
    $bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg++] = $bfe34808345a21f6$var$rg;
    $bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg++] = $bfe34808345a21f6$var$sg;
    $bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg++] = $bfe34808345a21f6$var$qg;
    $bfe34808345a21f6$var$qg = a;
    var d = $bfe34808345a21f6$var$rg;
    a = $bfe34808345a21f6$var$sg;
    var e = 32 - $bfe34808345a21f6$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $bfe34808345a21f6$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $bfe34808345a21f6$var$rg = 1 << 32 - $bfe34808345a21f6$var$oc(b) + e | c << e | d;
        $bfe34808345a21f6$var$sg = f + a;
    } else $bfe34808345a21f6$var$rg = 1 << f | c << e | d, $bfe34808345a21f6$var$sg = a;
}
function $bfe34808345a21f6$var$vg(a) {
    null !== a.return && ($bfe34808345a21f6$var$tg(a, 1), $bfe34808345a21f6$var$ug(a, 1, 0));
}
function $bfe34808345a21f6$var$wg(a) {
    for(; a === $bfe34808345a21f6$var$mg;)$bfe34808345a21f6$var$mg = $bfe34808345a21f6$var$kg[--$bfe34808345a21f6$var$lg], $bfe34808345a21f6$var$kg[$bfe34808345a21f6$var$lg] = null, $bfe34808345a21f6$var$ng = $bfe34808345a21f6$var$kg[--$bfe34808345a21f6$var$lg], $bfe34808345a21f6$var$kg[$bfe34808345a21f6$var$lg] = null;
    for(; a === $bfe34808345a21f6$var$qg;)$bfe34808345a21f6$var$qg = $bfe34808345a21f6$var$og[--$bfe34808345a21f6$var$pg], $bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg] = null, $bfe34808345a21f6$var$sg = $bfe34808345a21f6$var$og[--$bfe34808345a21f6$var$pg], $bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg] = null, $bfe34808345a21f6$var$rg = $bfe34808345a21f6$var$og[--$bfe34808345a21f6$var$pg], $bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg] = null;
}
var $bfe34808345a21f6$var$xg = null, $bfe34808345a21f6$var$yg = null, $bfe34808345a21f6$var$I = !1, $bfe34808345a21f6$var$zg = null;
function $bfe34808345a21f6$var$Ag(a, b) {
    var c = $bfe34808345a21f6$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $bfe34808345a21f6$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $bfe34808345a21f6$var$xg = a, $bfe34808345a21f6$var$yg = $bfe34808345a21f6$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $bfe34808345a21f6$var$xg = a, $bfe34808345a21f6$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $bfe34808345a21f6$var$qg ? {
                id: $bfe34808345a21f6$var$rg,
                overflow: $bfe34808345a21f6$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $bfe34808345a21f6$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $bfe34808345a21f6$var$xg = a, $bfe34808345a21f6$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $bfe34808345a21f6$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $bfe34808345a21f6$var$Eg(a) {
    if ($bfe34808345a21f6$var$I) {
        var b = $bfe34808345a21f6$var$yg;
        if (b) {
            var c = b;
            if (!$bfe34808345a21f6$var$Cg(a, b)) {
                if ($bfe34808345a21f6$var$Dg(a)) throw Error($bfe34808345a21f6$var$p(418));
                b = $bfe34808345a21f6$var$Lf(c.nextSibling);
                var d = $bfe34808345a21f6$var$xg;
                b && $bfe34808345a21f6$var$Cg(a, b) ? $bfe34808345a21f6$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $bfe34808345a21f6$var$I = !1, $bfe34808345a21f6$var$xg = a);
            }
        } else {
            if ($bfe34808345a21f6$var$Dg(a)) throw Error($bfe34808345a21f6$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $bfe34808345a21f6$var$I = !1;
            $bfe34808345a21f6$var$xg = a;
        }
    }
}
function $bfe34808345a21f6$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $bfe34808345a21f6$var$xg = a;
}
function $bfe34808345a21f6$var$Gg(a) {
    if (a !== $bfe34808345a21f6$var$xg) return !1;
    if (!$bfe34808345a21f6$var$I) return $bfe34808345a21f6$var$Fg(a), $bfe34808345a21f6$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$bfe34808345a21f6$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $bfe34808345a21f6$var$yg)) {
        if ($bfe34808345a21f6$var$Dg(a)) throw $bfe34808345a21f6$var$Hg(), Error($bfe34808345a21f6$var$p(418));
        for(; b;)$bfe34808345a21f6$var$Ag(a, b), b = $bfe34808345a21f6$var$Lf(b.nextSibling);
    }
    $bfe34808345a21f6$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($bfe34808345a21f6$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $bfe34808345a21f6$var$yg = $bfe34808345a21f6$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $bfe34808345a21f6$var$yg = null;
        }
    } else $bfe34808345a21f6$var$yg = $bfe34808345a21f6$var$xg ? $bfe34808345a21f6$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $bfe34808345a21f6$var$Hg() {
    for(var a = $bfe34808345a21f6$var$yg; a;)a = $bfe34808345a21f6$var$Lf(a.nextSibling);
}
function $bfe34808345a21f6$var$Ig() {
    $bfe34808345a21f6$var$yg = $bfe34808345a21f6$var$xg = null;
    $bfe34808345a21f6$var$I = !1;
}
function $bfe34808345a21f6$var$Jg(a) {
    null === $bfe34808345a21f6$var$zg ? $bfe34808345a21f6$var$zg = [
        a
    ] : $bfe34808345a21f6$var$zg.push(a);
}
var $bfe34808345a21f6$var$Kg = $bfe34808345a21f6$var$ua.ReactCurrentBatchConfig;
function $bfe34808345a21f6$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($bfe34808345a21f6$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($bfe34808345a21f6$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($bfe34808345a21f6$var$p(284));
        if (!c._owner) throw Error($bfe34808345a21f6$var$p(290, a));
    }
    return a;
}
function $bfe34808345a21f6$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($bfe34808345a21f6$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $bfe34808345a21f6$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $bfe34808345a21f6$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $bfe34808345a21f6$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $bfe34808345a21f6$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $bfe34808345a21f6$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $bfe34808345a21f6$var$Ha && $bfe34808345a21f6$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $bfe34808345a21f6$var$Lg(a, b, c), d.return = a, d;
        d = $bfe34808345a21f6$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $bfe34808345a21f6$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $bfe34808345a21f6$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $bfe34808345a21f6$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $bfe34808345a21f6$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $bfe34808345a21f6$var$va:
                    return c = $bfe34808345a21f6$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $bfe34808345a21f6$var$Lg(a, null, b), c.return = a, c;
                case $bfe34808345a21f6$var$wa:
                    return b = $bfe34808345a21f6$var$Sg(b, a.mode, c), b.return = a, b;
                case $bfe34808345a21f6$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($bfe34808345a21f6$var$eb(b) || $bfe34808345a21f6$var$Ka(b)) return b = $bfe34808345a21f6$var$Tg(b, a.mode, c, null), b.return = a, b;
            $bfe34808345a21f6$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $bfe34808345a21f6$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $bfe34808345a21f6$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $bfe34808345a21f6$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($bfe34808345a21f6$var$eb(c) || $bfe34808345a21f6$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $bfe34808345a21f6$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $bfe34808345a21f6$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $bfe34808345a21f6$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $bfe34808345a21f6$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($bfe34808345a21f6$var$eb(d) || $bfe34808345a21f6$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $bfe34808345a21f6$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $bfe34808345a21f6$var$I && $bfe34808345a21f6$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $bfe34808345a21f6$var$I && $bfe34808345a21f6$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $bfe34808345a21f6$var$I && $bfe34808345a21f6$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $bfe34808345a21f6$var$Ka(h);
        if ("function" !== typeof l) throw Error($bfe34808345a21f6$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($bfe34808345a21f6$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $bfe34808345a21f6$var$I && $bfe34808345a21f6$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $bfe34808345a21f6$var$I && $bfe34808345a21f6$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $bfe34808345a21f6$var$I && $bfe34808345a21f6$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $bfe34808345a21f6$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $bfe34808345a21f6$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $bfe34808345a21f6$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $bfe34808345a21f6$var$Ha && $bfe34808345a21f6$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $bfe34808345a21f6$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $bfe34808345a21f6$var$ya ? (d = $bfe34808345a21f6$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $bfe34808345a21f6$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $bfe34808345a21f6$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $bfe34808345a21f6$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $bfe34808345a21f6$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $bfe34808345a21f6$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($bfe34808345a21f6$var$eb(f)) return n(a, d, f, h);
            if ($bfe34808345a21f6$var$Ka(f)) return t(a, d, f, h);
            $bfe34808345a21f6$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $bfe34808345a21f6$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $bfe34808345a21f6$var$Ug = $bfe34808345a21f6$var$Og(!0), $bfe34808345a21f6$var$Vg = $bfe34808345a21f6$var$Og(!1), $bfe34808345a21f6$var$Wg = $bfe34808345a21f6$var$Uf(null), $bfe34808345a21f6$var$Xg = null, $bfe34808345a21f6$var$Yg = null, $bfe34808345a21f6$var$Zg = null;
function $bfe34808345a21f6$var$$g() {
    $bfe34808345a21f6$var$Zg = $bfe34808345a21f6$var$Yg = $bfe34808345a21f6$var$Xg = null;
}
function $bfe34808345a21f6$var$ah(a) {
    var b = $bfe34808345a21f6$var$Wg.current;
    $bfe34808345a21f6$var$E($bfe34808345a21f6$var$Wg);
    a._currentValue = b;
}
function $bfe34808345a21f6$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $bfe34808345a21f6$var$ch(a, b) {
    $bfe34808345a21f6$var$Xg = a;
    $bfe34808345a21f6$var$Zg = $bfe34808345a21f6$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($bfe34808345a21f6$var$dh = !0), a.firstContext = null);
}
function $bfe34808345a21f6$var$eh(a) {
    var b = a._currentValue;
    if ($bfe34808345a21f6$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $bfe34808345a21f6$var$Yg) {
            if (null === $bfe34808345a21f6$var$Xg) throw Error($bfe34808345a21f6$var$p(308));
            $bfe34808345a21f6$var$Yg = a;
            $bfe34808345a21f6$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $bfe34808345a21f6$var$Yg = $bfe34808345a21f6$var$Yg.next = a;
    }
    return b;
}
var $bfe34808345a21f6$var$fh = null;
function $bfe34808345a21f6$var$gh(a) {
    null === $bfe34808345a21f6$var$fh ? $bfe34808345a21f6$var$fh = [
        a
    ] : $bfe34808345a21f6$var$fh.push(a);
}
function $bfe34808345a21f6$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $bfe34808345a21f6$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $bfe34808345a21f6$var$ih(a, d);
}
function $bfe34808345a21f6$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $bfe34808345a21f6$var$jh = !1;
function $bfe34808345a21f6$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $bfe34808345a21f6$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $bfe34808345a21f6$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bfe34808345a21f6$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($bfe34808345a21f6$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $bfe34808345a21f6$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $bfe34808345a21f6$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $bfe34808345a21f6$var$ih(a, c);
}
function $bfe34808345a21f6$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bfe34808345a21f6$var$Cc(a, c);
    }
}
function $bfe34808345a21f6$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $bfe34808345a21f6$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $bfe34808345a21f6$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $bfe34808345a21f6$var$A({}, q, r);
                            break a;
                        case 2:
                            $bfe34808345a21f6$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $bfe34808345a21f6$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $bfe34808345a21f6$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($bfe34808345a21f6$var$p(191, e));
            e.call(d);
        }
    }
}
var $bfe34808345a21f6$var$th = {}, $bfe34808345a21f6$var$uh = $bfe34808345a21f6$var$Uf($bfe34808345a21f6$var$th), $bfe34808345a21f6$var$vh = $bfe34808345a21f6$var$Uf($bfe34808345a21f6$var$th), $bfe34808345a21f6$var$wh = $bfe34808345a21f6$var$Uf($bfe34808345a21f6$var$th);
function $bfe34808345a21f6$var$xh(a) {
    if (a === $bfe34808345a21f6$var$th) throw Error($bfe34808345a21f6$var$p(174));
    return a;
}
function $bfe34808345a21f6$var$yh(a, b) {
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$wh, b);
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$vh, a);
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$uh, $bfe34808345a21f6$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $bfe34808345a21f6$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $bfe34808345a21f6$var$lb(b, a);
    }
    $bfe34808345a21f6$var$E($bfe34808345a21f6$var$uh);
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$uh, b);
}
function $bfe34808345a21f6$var$zh() {
    $bfe34808345a21f6$var$E($bfe34808345a21f6$var$uh);
    $bfe34808345a21f6$var$E($bfe34808345a21f6$var$vh);
    $bfe34808345a21f6$var$E($bfe34808345a21f6$var$wh);
}
function $bfe34808345a21f6$var$Ah(a) {
    $bfe34808345a21f6$var$xh($bfe34808345a21f6$var$wh.current);
    var b = $bfe34808345a21f6$var$xh($bfe34808345a21f6$var$uh.current);
    var c = $bfe34808345a21f6$var$lb(b, a.type);
    b !== c && ($bfe34808345a21f6$var$G($bfe34808345a21f6$var$vh, a), $bfe34808345a21f6$var$G($bfe34808345a21f6$var$uh, c));
}
function $bfe34808345a21f6$var$Bh(a) {
    $bfe34808345a21f6$var$vh.current === a && ($bfe34808345a21f6$var$E($bfe34808345a21f6$var$uh), $bfe34808345a21f6$var$E($bfe34808345a21f6$var$vh));
}
var $bfe34808345a21f6$var$L = $bfe34808345a21f6$var$Uf(0);
function $bfe34808345a21f6$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $bfe34808345a21f6$var$Dh = [];
function $bfe34808345a21f6$var$Eh() {
    for(var a = 0; a < $bfe34808345a21f6$var$Dh.length; a++)$bfe34808345a21f6$var$Dh[a]._workInProgressVersionPrimary = null;
    $bfe34808345a21f6$var$Dh.length = 0;
}
var $bfe34808345a21f6$var$Fh = $bfe34808345a21f6$var$ua.ReactCurrentDispatcher, $bfe34808345a21f6$var$Gh = $bfe34808345a21f6$var$ua.ReactCurrentBatchConfig, $bfe34808345a21f6$var$Hh = 0, $bfe34808345a21f6$var$M = null, $bfe34808345a21f6$var$N = null, $bfe34808345a21f6$var$O = null, $bfe34808345a21f6$var$Ih = !1, $bfe34808345a21f6$var$Jh = !1, $bfe34808345a21f6$var$Kh = 0, $bfe34808345a21f6$var$Lh = 0;
function $bfe34808345a21f6$var$P() {
    throw Error($bfe34808345a21f6$var$p(321));
}
function $bfe34808345a21f6$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$bfe34808345a21f6$var$He(a[c], b[c])) return !1;
    return !0;
}
function $bfe34808345a21f6$var$Nh(a, b, c, d, e, f) {
    $bfe34808345a21f6$var$Hh = f;
    $bfe34808345a21f6$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $bfe34808345a21f6$var$Fh.current = null === a || null === a.memoizedState ? $bfe34808345a21f6$var$Oh : $bfe34808345a21f6$var$Ph;
    a = c(d, e);
    if ($bfe34808345a21f6$var$Jh) {
        f = 0;
        do {
            $bfe34808345a21f6$var$Jh = !1;
            $bfe34808345a21f6$var$Kh = 0;
            if (25 <= f) throw Error($bfe34808345a21f6$var$p(301));
            f += 1;
            $bfe34808345a21f6$var$O = $bfe34808345a21f6$var$N = null;
            b.updateQueue = null;
            $bfe34808345a21f6$var$Fh.current = $bfe34808345a21f6$var$Qh;
            a = c(d, e);
        }while ($bfe34808345a21f6$var$Jh);
    }
    $bfe34808345a21f6$var$Fh.current = $bfe34808345a21f6$var$Rh;
    b = null !== $bfe34808345a21f6$var$N && null !== $bfe34808345a21f6$var$N.next;
    $bfe34808345a21f6$var$Hh = 0;
    $bfe34808345a21f6$var$O = $bfe34808345a21f6$var$N = $bfe34808345a21f6$var$M = null;
    $bfe34808345a21f6$var$Ih = !1;
    if (b) throw Error($bfe34808345a21f6$var$p(300));
    return a;
}
function $bfe34808345a21f6$var$Sh() {
    var a = 0 !== $bfe34808345a21f6$var$Kh;
    $bfe34808345a21f6$var$Kh = 0;
    return a;
}
function $bfe34808345a21f6$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bfe34808345a21f6$var$O ? $bfe34808345a21f6$var$M.memoizedState = $bfe34808345a21f6$var$O = a : $bfe34808345a21f6$var$O = $bfe34808345a21f6$var$O.next = a;
    return $bfe34808345a21f6$var$O;
}
function $bfe34808345a21f6$var$Uh() {
    if (null === $bfe34808345a21f6$var$N) {
        var a = $bfe34808345a21f6$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $bfe34808345a21f6$var$N.next;
    var b = null === $bfe34808345a21f6$var$O ? $bfe34808345a21f6$var$M.memoizedState : $bfe34808345a21f6$var$O.next;
    if (null !== b) $bfe34808345a21f6$var$O = b, $bfe34808345a21f6$var$N = a;
    else {
        if (null === a) throw Error($bfe34808345a21f6$var$p(310));
        $bfe34808345a21f6$var$N = a;
        a = {
            memoizedState: $bfe34808345a21f6$var$N.memoizedState,
            baseState: $bfe34808345a21f6$var$N.baseState,
            baseQueue: $bfe34808345a21f6$var$N.baseQueue,
            queue: $bfe34808345a21f6$var$N.queue,
            next: null
        };
        null === $bfe34808345a21f6$var$O ? $bfe34808345a21f6$var$M.memoizedState = $bfe34808345a21f6$var$O = a : $bfe34808345a21f6$var$O = $bfe34808345a21f6$var$O.next = a;
    }
    return $bfe34808345a21f6$var$O;
}
function $bfe34808345a21f6$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $bfe34808345a21f6$var$Wh(a) {
    var b = $bfe34808345a21f6$var$Uh(), c = b.queue;
    if (null === c) throw Error($bfe34808345a21f6$var$p(311));
    c.lastRenderedReducer = a;
    var d = $bfe34808345a21f6$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($bfe34808345a21f6$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $bfe34808345a21f6$var$M.lanes |= m;
                $bfe34808345a21f6$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $bfe34808345a21f6$var$He(d, b.memoizedState) || ($bfe34808345a21f6$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $bfe34808345a21f6$var$M.lanes |= f, $bfe34808345a21f6$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $bfe34808345a21f6$var$Xh(a) {
    var b = $bfe34808345a21f6$var$Uh(), c = b.queue;
    if (null === c) throw Error($bfe34808345a21f6$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $bfe34808345a21f6$var$He(f, b.memoizedState) || ($bfe34808345a21f6$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $bfe34808345a21f6$var$Yh() {}
function $bfe34808345a21f6$var$Zh(a, b) {
    var c = $bfe34808345a21f6$var$M, d = $bfe34808345a21f6$var$Uh(), e = b(), f = !$bfe34808345a21f6$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $bfe34808345a21f6$var$dh = !0);
    d = d.queue;
    $bfe34808345a21f6$var$$h($bfe34808345a21f6$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $bfe34808345a21f6$var$O && $bfe34808345a21f6$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $bfe34808345a21f6$var$bi(9, $bfe34808345a21f6$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $bfe34808345a21f6$var$Q) throw Error($bfe34808345a21f6$var$p(349));
        0 !== ($bfe34808345a21f6$var$Hh & 30) || $bfe34808345a21f6$var$di(c, b, e);
    }
    return e;
}
function $bfe34808345a21f6$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $bfe34808345a21f6$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bfe34808345a21f6$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $bfe34808345a21f6$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $bfe34808345a21f6$var$ei(b) && $bfe34808345a21f6$var$fi(a);
}
function $bfe34808345a21f6$var$ai(a, b, c) {
    return c(function() {
        $bfe34808345a21f6$var$ei(b) && $bfe34808345a21f6$var$fi(a);
    });
}
function $bfe34808345a21f6$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$bfe34808345a21f6$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $bfe34808345a21f6$var$fi(a) {
    var b = $bfe34808345a21f6$var$ih(a, 1);
    null !== b && $bfe34808345a21f6$var$gi(b, a, 1, -1);
}
function $bfe34808345a21f6$var$hi(a) {
    var b = $bfe34808345a21f6$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bfe34808345a21f6$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $bfe34808345a21f6$var$ii.bind(null, $bfe34808345a21f6$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $bfe34808345a21f6$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $bfe34808345a21f6$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bfe34808345a21f6$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $bfe34808345a21f6$var$ji() {
    return $bfe34808345a21f6$var$Uh().memoizedState;
}
function $bfe34808345a21f6$var$ki(a, b, c, d) {
    var e = $bfe34808345a21f6$var$Th();
    $bfe34808345a21f6$var$M.flags |= a;
    e.memoizedState = $bfe34808345a21f6$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $bfe34808345a21f6$var$li(a, b, c, d) {
    var e = $bfe34808345a21f6$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $bfe34808345a21f6$var$N) {
        var g = $bfe34808345a21f6$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $bfe34808345a21f6$var$Mh(d, g.deps)) {
            e.memoizedState = $bfe34808345a21f6$var$bi(b, c, f, d);
            return;
        }
    }
    $bfe34808345a21f6$var$M.flags |= a;
    e.memoizedState = $bfe34808345a21f6$var$bi(1 | b, c, f, d);
}
function $bfe34808345a21f6$var$mi(a, b) {
    return $bfe34808345a21f6$var$ki(8390656, 8, a, b);
}
function $bfe34808345a21f6$var$$h(a, b) {
    return $bfe34808345a21f6$var$li(2048, 8, a, b);
}
function $bfe34808345a21f6$var$ni(a, b) {
    return $bfe34808345a21f6$var$li(4, 2, a, b);
}
function $bfe34808345a21f6$var$oi(a, b) {
    return $bfe34808345a21f6$var$li(4, 4, a, b);
}
function $bfe34808345a21f6$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $bfe34808345a21f6$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $bfe34808345a21f6$var$li(4, 4, $bfe34808345a21f6$var$pi.bind(null, b, a), c);
}
function $bfe34808345a21f6$var$ri() {}
function $bfe34808345a21f6$var$si(a, b) {
    var c = $bfe34808345a21f6$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bfe34808345a21f6$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bfe34808345a21f6$var$ti(a, b) {
    var c = $bfe34808345a21f6$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bfe34808345a21f6$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bfe34808345a21f6$var$ui(a, b, c) {
    if (0 === ($bfe34808345a21f6$var$Hh & 21)) return a.baseState && (a.baseState = !1, $bfe34808345a21f6$var$dh = !0), a.memoizedState = c;
    $bfe34808345a21f6$var$He(c, b) || (c = $bfe34808345a21f6$var$yc(), $bfe34808345a21f6$var$M.lanes |= c, $bfe34808345a21f6$var$rh |= c, a.baseState = !0);
    return b;
}
function $bfe34808345a21f6$var$vi(a, b) {
    var c = $bfe34808345a21f6$var$C;
    $bfe34808345a21f6$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $bfe34808345a21f6$var$Gh.transition;
    $bfe34808345a21f6$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $bfe34808345a21f6$var$C = c, $bfe34808345a21f6$var$Gh.transition = d;
    }
}
function $bfe34808345a21f6$var$wi() {
    return $bfe34808345a21f6$var$Uh().memoizedState;
}
function $bfe34808345a21f6$var$xi(a, b, c) {
    var d = $bfe34808345a21f6$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bfe34808345a21f6$var$zi(a)) $bfe34808345a21f6$var$Ai(b, c);
    else if (c = $bfe34808345a21f6$var$hh(a, b, c, d), null !== c) {
        var e = $bfe34808345a21f6$var$R();
        $bfe34808345a21f6$var$gi(c, a, d, e);
        $bfe34808345a21f6$var$Bi(c, b, d);
    }
}
function $bfe34808345a21f6$var$ii(a, b, c) {
    var d = $bfe34808345a21f6$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bfe34808345a21f6$var$zi(a)) $bfe34808345a21f6$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($bfe34808345a21f6$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $bfe34808345a21f6$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $bfe34808345a21f6$var$hh(a, b, e, d);
        null !== c && (e = $bfe34808345a21f6$var$R(), $bfe34808345a21f6$var$gi(c, a, d, e), $bfe34808345a21f6$var$Bi(c, b, d));
    }
}
function $bfe34808345a21f6$var$zi(a) {
    var b = a.alternate;
    return a === $bfe34808345a21f6$var$M || null !== b && b === $bfe34808345a21f6$var$M;
}
function $bfe34808345a21f6$var$Ai(a, b) {
    $bfe34808345a21f6$var$Jh = $bfe34808345a21f6$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $bfe34808345a21f6$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bfe34808345a21f6$var$Cc(a, c);
    }
}
var $bfe34808345a21f6$var$Rh = {
    readContext: $bfe34808345a21f6$var$eh,
    useCallback: $bfe34808345a21f6$var$P,
    useContext: $bfe34808345a21f6$var$P,
    useEffect: $bfe34808345a21f6$var$P,
    useImperativeHandle: $bfe34808345a21f6$var$P,
    useInsertionEffect: $bfe34808345a21f6$var$P,
    useLayoutEffect: $bfe34808345a21f6$var$P,
    useMemo: $bfe34808345a21f6$var$P,
    useReducer: $bfe34808345a21f6$var$P,
    useRef: $bfe34808345a21f6$var$P,
    useState: $bfe34808345a21f6$var$P,
    useDebugValue: $bfe34808345a21f6$var$P,
    useDeferredValue: $bfe34808345a21f6$var$P,
    useTransition: $bfe34808345a21f6$var$P,
    useMutableSource: $bfe34808345a21f6$var$P,
    useSyncExternalStore: $bfe34808345a21f6$var$P,
    useId: $bfe34808345a21f6$var$P,
    unstable_isNewReconciler: !1
}, $bfe34808345a21f6$var$Oh = {
    readContext: $bfe34808345a21f6$var$eh,
    useCallback: function(a, b) {
        $bfe34808345a21f6$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $bfe34808345a21f6$var$eh,
    useEffect: $bfe34808345a21f6$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bfe34808345a21f6$var$ki(4194308, 4, $bfe34808345a21f6$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $bfe34808345a21f6$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $bfe34808345a21f6$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $bfe34808345a21f6$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $bfe34808345a21f6$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $bfe34808345a21f6$var$xi.bind(null, $bfe34808345a21f6$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $bfe34808345a21f6$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $bfe34808345a21f6$var$hi,
    useDebugValue: $bfe34808345a21f6$var$ri,
    useDeferredValue: function(a) {
        return $bfe34808345a21f6$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $bfe34808345a21f6$var$hi(!1), b = a[0];
        a = $bfe34808345a21f6$var$vi.bind(null, a[1]);
        $bfe34808345a21f6$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $bfe34808345a21f6$var$M, e = $bfe34808345a21f6$var$Th();
        if ($bfe34808345a21f6$var$I) {
            if (void 0 === c) throw Error($bfe34808345a21f6$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $bfe34808345a21f6$var$Q) throw Error($bfe34808345a21f6$var$p(349));
            0 !== ($bfe34808345a21f6$var$Hh & 30) || $bfe34808345a21f6$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $bfe34808345a21f6$var$mi($bfe34808345a21f6$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $bfe34808345a21f6$var$bi(9, $bfe34808345a21f6$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $bfe34808345a21f6$var$Th(), b = $bfe34808345a21f6$var$Q.identifierPrefix;
        if ($bfe34808345a21f6$var$I) {
            var c = $bfe34808345a21f6$var$sg;
            var d = $bfe34808345a21f6$var$rg;
            c = (d & ~(1 << 32 - $bfe34808345a21f6$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $bfe34808345a21f6$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $bfe34808345a21f6$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $bfe34808345a21f6$var$Ph = {
    readContext: $bfe34808345a21f6$var$eh,
    useCallback: $bfe34808345a21f6$var$si,
    useContext: $bfe34808345a21f6$var$eh,
    useEffect: $bfe34808345a21f6$var$$h,
    useImperativeHandle: $bfe34808345a21f6$var$qi,
    useInsertionEffect: $bfe34808345a21f6$var$ni,
    useLayoutEffect: $bfe34808345a21f6$var$oi,
    useMemo: $bfe34808345a21f6$var$ti,
    useReducer: $bfe34808345a21f6$var$Wh,
    useRef: $bfe34808345a21f6$var$ji,
    useState: function() {
        return $bfe34808345a21f6$var$Wh($bfe34808345a21f6$var$Vh);
    },
    useDebugValue: $bfe34808345a21f6$var$ri,
    useDeferredValue: function(a) {
        var b = $bfe34808345a21f6$var$Uh();
        return $bfe34808345a21f6$var$ui(b, $bfe34808345a21f6$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $bfe34808345a21f6$var$Wh($bfe34808345a21f6$var$Vh)[0], b = $bfe34808345a21f6$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bfe34808345a21f6$var$Yh,
    useSyncExternalStore: $bfe34808345a21f6$var$Zh,
    useId: $bfe34808345a21f6$var$wi,
    unstable_isNewReconciler: !1
}, $bfe34808345a21f6$var$Qh = {
    readContext: $bfe34808345a21f6$var$eh,
    useCallback: $bfe34808345a21f6$var$si,
    useContext: $bfe34808345a21f6$var$eh,
    useEffect: $bfe34808345a21f6$var$$h,
    useImperativeHandle: $bfe34808345a21f6$var$qi,
    useInsertionEffect: $bfe34808345a21f6$var$ni,
    useLayoutEffect: $bfe34808345a21f6$var$oi,
    useMemo: $bfe34808345a21f6$var$ti,
    useReducer: $bfe34808345a21f6$var$Xh,
    useRef: $bfe34808345a21f6$var$ji,
    useState: function() {
        return $bfe34808345a21f6$var$Xh($bfe34808345a21f6$var$Vh);
    },
    useDebugValue: $bfe34808345a21f6$var$ri,
    useDeferredValue: function(a) {
        var b = $bfe34808345a21f6$var$Uh();
        return null === $bfe34808345a21f6$var$N ? b.memoizedState = a : $bfe34808345a21f6$var$ui(b, $bfe34808345a21f6$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $bfe34808345a21f6$var$Xh($bfe34808345a21f6$var$Vh)[0], b = $bfe34808345a21f6$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bfe34808345a21f6$var$Yh,
    useSyncExternalStore: $bfe34808345a21f6$var$Zh,
    useId: $bfe34808345a21f6$var$wi,
    unstable_isNewReconciler: !1
};
function $bfe34808345a21f6$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $bfe34808345a21f6$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $bfe34808345a21f6$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bfe34808345a21f6$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $bfe34808345a21f6$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $bfe34808345a21f6$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $bfe34808345a21f6$var$R(), e = $bfe34808345a21f6$var$yi(a), f = $bfe34808345a21f6$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bfe34808345a21f6$var$nh(a, f, e);
        null !== b && ($bfe34808345a21f6$var$gi(b, a, e, d), $bfe34808345a21f6$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $bfe34808345a21f6$var$R(), e = $bfe34808345a21f6$var$yi(a), f = $bfe34808345a21f6$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bfe34808345a21f6$var$nh(a, f, e);
        null !== b && ($bfe34808345a21f6$var$gi(b, a, e, d), $bfe34808345a21f6$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $bfe34808345a21f6$var$R(), d = $bfe34808345a21f6$var$yi(a), e = $bfe34808345a21f6$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $bfe34808345a21f6$var$nh(a, e, d);
        null !== b && ($bfe34808345a21f6$var$gi(b, a, d, c), $bfe34808345a21f6$var$oh(b, a, d));
    }
};
function $bfe34808345a21f6$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$bfe34808345a21f6$var$Ie(c, d) || !$bfe34808345a21f6$var$Ie(e, f) : !0;
}
function $bfe34808345a21f6$var$Gi(a, b, c) {
    var d = !1, e = $bfe34808345a21f6$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $bfe34808345a21f6$var$eh(f) : (e = $bfe34808345a21f6$var$Zf(b) ? $bfe34808345a21f6$var$Xf : $bfe34808345a21f6$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $bfe34808345a21f6$var$Yf(a, e) : $bfe34808345a21f6$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $bfe34808345a21f6$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $bfe34808345a21f6$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $bfe34808345a21f6$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $bfe34808345a21f6$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $bfe34808345a21f6$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $bfe34808345a21f6$var$eh(f) : (f = $bfe34808345a21f6$var$Zf(b) ? $bfe34808345a21f6$var$Xf : $bfe34808345a21f6$var$H.current, e.context = $bfe34808345a21f6$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($bfe34808345a21f6$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $bfe34808345a21f6$var$Ei.enqueueReplaceState(e, e.state, null), $bfe34808345a21f6$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $bfe34808345a21f6$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $bfe34808345a21f6$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $bfe34808345a21f6$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $bfe34808345a21f6$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $bfe34808345a21f6$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $bfe34808345a21f6$var$Ni(a, b, c) {
    c = $bfe34808345a21f6$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $bfe34808345a21f6$var$Oi || ($bfe34808345a21f6$var$Oi = !0, $bfe34808345a21f6$var$Pi = d);
        $bfe34808345a21f6$var$Li(a, b);
    };
    return c;
}
function $bfe34808345a21f6$var$Qi(a, b, c) {
    c = $bfe34808345a21f6$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $bfe34808345a21f6$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $bfe34808345a21f6$var$Li(a, b);
        "function" !== typeof d && (null === $bfe34808345a21f6$var$Ri ? $bfe34808345a21f6$var$Ri = new Set([
            this
        ]) : $bfe34808345a21f6$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $bfe34808345a21f6$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $bfe34808345a21f6$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $bfe34808345a21f6$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $bfe34808345a21f6$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $bfe34808345a21f6$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $bfe34808345a21f6$var$mh(-1, 1), b.tag = 2, $bfe34808345a21f6$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $bfe34808345a21f6$var$Wi = $bfe34808345a21f6$var$ua.ReactCurrentOwner, $bfe34808345a21f6$var$dh = !1;
function $bfe34808345a21f6$var$Xi(a, b, c, d) {
    b.child = null === a ? $bfe34808345a21f6$var$Vg(b, null, c, d) : $bfe34808345a21f6$var$Ug(b, a.child, c, d);
}
function $bfe34808345a21f6$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $bfe34808345a21f6$var$ch(b, e);
    d = $bfe34808345a21f6$var$Nh(a, b, c, d, f, e);
    c = $bfe34808345a21f6$var$Sh();
    if (null !== a && !$bfe34808345a21f6$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bfe34808345a21f6$var$Zi(a, b, e);
    $bfe34808345a21f6$var$I && c && $bfe34808345a21f6$var$vg(b);
    b.flags |= 1;
    $bfe34808345a21f6$var$Xi(a, b, d, e);
    return b.child;
}
function $bfe34808345a21f6$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$bfe34808345a21f6$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $bfe34808345a21f6$var$bj(a, b, f, d, e);
        a = $bfe34808345a21f6$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $bfe34808345a21f6$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $bfe34808345a21f6$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $bfe34808345a21f6$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $bfe34808345a21f6$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($bfe34808345a21f6$var$Ie(f, d) && a.ref === b.ref) {
            if ($bfe34808345a21f6$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($bfe34808345a21f6$var$dh = !0);
            else return b.lanes = a.lanes, $bfe34808345a21f6$var$Zi(a, b, e);
        }
    }
    return $bfe34808345a21f6$var$cj(a, b, c, d, e);
}
function $bfe34808345a21f6$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $bfe34808345a21f6$var$G($bfe34808345a21f6$var$ej, $bfe34808345a21f6$var$fj), $bfe34808345a21f6$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $bfe34808345a21f6$var$G($bfe34808345a21f6$var$ej, $bfe34808345a21f6$var$fj), $bfe34808345a21f6$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $bfe34808345a21f6$var$G($bfe34808345a21f6$var$ej, $bfe34808345a21f6$var$fj);
            $bfe34808345a21f6$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $bfe34808345a21f6$var$G($bfe34808345a21f6$var$ej, $bfe34808345a21f6$var$fj), $bfe34808345a21f6$var$fj |= d;
    $bfe34808345a21f6$var$Xi(a, b, e, c);
    return b.child;
}
function $bfe34808345a21f6$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $bfe34808345a21f6$var$cj(a, b, c, d, e) {
    var f = $bfe34808345a21f6$var$Zf(c) ? $bfe34808345a21f6$var$Xf : $bfe34808345a21f6$var$H.current;
    f = $bfe34808345a21f6$var$Yf(b, f);
    $bfe34808345a21f6$var$ch(b, e);
    c = $bfe34808345a21f6$var$Nh(a, b, c, d, f, e);
    d = $bfe34808345a21f6$var$Sh();
    if (null !== a && !$bfe34808345a21f6$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bfe34808345a21f6$var$Zi(a, b, e);
    $bfe34808345a21f6$var$I && d && $bfe34808345a21f6$var$vg(b);
    b.flags |= 1;
    $bfe34808345a21f6$var$Xi(a, b, c, e);
    return b.child;
}
function $bfe34808345a21f6$var$hj(a, b, c, d, e) {
    if ($bfe34808345a21f6$var$Zf(c)) {
        var f = !0;
        $bfe34808345a21f6$var$cg(b);
    } else f = !1;
    $bfe34808345a21f6$var$ch(b, e);
    if (null === b.stateNode) $bfe34808345a21f6$var$ij(a, b), $bfe34808345a21f6$var$Gi(b, c, d), $bfe34808345a21f6$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $bfe34808345a21f6$var$eh(l) : (l = $bfe34808345a21f6$var$Zf(c) ? $bfe34808345a21f6$var$Xf : $bfe34808345a21f6$var$H.current, l = $bfe34808345a21f6$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bfe34808345a21f6$var$Hi(b, g, d, l);
        $bfe34808345a21f6$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $bfe34808345a21f6$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $bfe34808345a21f6$var$Wf.current || $bfe34808345a21f6$var$jh ? ("function" === typeof m && ($bfe34808345a21f6$var$Di(b, c, m, d), k = b.memoizedState), (h = $bfe34808345a21f6$var$jh || $bfe34808345a21f6$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $bfe34808345a21f6$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $bfe34808345a21f6$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $bfe34808345a21f6$var$eh(k) : (k = $bfe34808345a21f6$var$Zf(c) ? $bfe34808345a21f6$var$Xf : $bfe34808345a21f6$var$H.current, k = $bfe34808345a21f6$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $bfe34808345a21f6$var$Hi(b, g, d, k);
        $bfe34808345a21f6$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $bfe34808345a21f6$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $bfe34808345a21f6$var$Wf.current || $bfe34808345a21f6$var$jh ? ("function" === typeof y && ($bfe34808345a21f6$var$Di(b, c, y, d), n = b.memoizedState), (l = $bfe34808345a21f6$var$jh || $bfe34808345a21f6$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $bfe34808345a21f6$var$jj(a, b, c, d, f, e);
}
function $bfe34808345a21f6$var$jj(a, b, c, d, e, f) {
    $bfe34808345a21f6$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $bfe34808345a21f6$var$dg(b, c, !1), $bfe34808345a21f6$var$Zi(a, b, f);
    d = b.stateNode;
    $bfe34808345a21f6$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $bfe34808345a21f6$var$Ug(b, a.child, null, f), b.child = $bfe34808345a21f6$var$Ug(b, null, h, f)) : $bfe34808345a21f6$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $bfe34808345a21f6$var$dg(b, c, !0);
    return b.child;
}
function $bfe34808345a21f6$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $bfe34808345a21f6$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $bfe34808345a21f6$var$ag(a, b.context, !1);
    $bfe34808345a21f6$var$yh(a, b.containerInfo);
}
function $bfe34808345a21f6$var$lj(a, b, c, d, e) {
    $bfe34808345a21f6$var$Ig();
    $bfe34808345a21f6$var$Jg(e);
    b.flags |= 256;
    $bfe34808345a21f6$var$Xi(a, b, c, d);
    return b.child;
}
var $bfe34808345a21f6$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bfe34808345a21f6$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $bfe34808345a21f6$var$oj(a, b, c) {
    var d = b.pendingProps, e = $bfe34808345a21f6$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$L, e & 1);
    if (null === a) {
        $bfe34808345a21f6$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $bfe34808345a21f6$var$pj(g, d, 0, null), a = $bfe34808345a21f6$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $bfe34808345a21f6$var$nj(c), b.memoizedState = $bfe34808345a21f6$var$mj, a) : $bfe34808345a21f6$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $bfe34808345a21f6$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $bfe34808345a21f6$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $bfe34808345a21f6$var$Pg(h, f) : (f = $bfe34808345a21f6$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $bfe34808345a21f6$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $bfe34808345a21f6$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $bfe34808345a21f6$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $bfe34808345a21f6$var$qj(a, b) {
    b = $bfe34808345a21f6$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $bfe34808345a21f6$var$sj(a, b, c, d) {
    null !== d && $bfe34808345a21f6$var$Jg(d);
    $bfe34808345a21f6$var$Ug(b, a.child, null, c);
    a = $bfe34808345a21f6$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $bfe34808345a21f6$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $bfe34808345a21f6$var$Ki(Error($bfe34808345a21f6$var$p(422))), $bfe34808345a21f6$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $bfe34808345a21f6$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $bfe34808345a21f6$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $bfe34808345a21f6$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $bfe34808345a21f6$var$nj(g);
        b.memoizedState = $bfe34808345a21f6$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $bfe34808345a21f6$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($bfe34808345a21f6$var$p(419));
        d = $bfe34808345a21f6$var$Ki(f, d, void 0);
        return $bfe34808345a21f6$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($bfe34808345a21f6$var$dh || h) {
        d = $bfe34808345a21f6$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $bfe34808345a21f6$var$ih(a, e), $bfe34808345a21f6$var$gi(d, a, e, -1));
        }
        $bfe34808345a21f6$var$tj();
        d = $bfe34808345a21f6$var$Ki(Error($bfe34808345a21f6$var$p(421)));
        return $bfe34808345a21f6$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $bfe34808345a21f6$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $bfe34808345a21f6$var$yg = $bfe34808345a21f6$var$Lf(e.nextSibling);
    $bfe34808345a21f6$var$xg = b;
    $bfe34808345a21f6$var$I = !0;
    $bfe34808345a21f6$var$zg = null;
    null !== a && ($bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg++] = $bfe34808345a21f6$var$rg, $bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg++] = $bfe34808345a21f6$var$sg, $bfe34808345a21f6$var$og[$bfe34808345a21f6$var$pg++] = $bfe34808345a21f6$var$qg, $bfe34808345a21f6$var$rg = a.id, $bfe34808345a21f6$var$sg = a.overflow, $bfe34808345a21f6$var$qg = b);
    b = $bfe34808345a21f6$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $bfe34808345a21f6$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $bfe34808345a21f6$var$bh(a.return, b, c);
}
function $bfe34808345a21f6$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $bfe34808345a21f6$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $bfe34808345a21f6$var$Xi(a, b, d.children, c);
    d = $bfe34808345a21f6$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $bfe34808345a21f6$var$vj(a, c, b);
            else if (19 === a.tag) $bfe34808345a21f6$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $bfe34808345a21f6$var$G($bfe34808345a21f6$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $bfe34808345a21f6$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $bfe34808345a21f6$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $bfe34808345a21f6$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $bfe34808345a21f6$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $bfe34808345a21f6$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $bfe34808345a21f6$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $bfe34808345a21f6$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $bfe34808345a21f6$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($bfe34808345a21f6$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $bfe34808345a21f6$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $bfe34808345a21f6$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $bfe34808345a21f6$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $bfe34808345a21f6$var$kj(b);
            $bfe34808345a21f6$var$Ig();
            break;
        case 5:
            $bfe34808345a21f6$var$Ah(b);
            break;
        case 1:
            $bfe34808345a21f6$var$Zf(b.type) && $bfe34808345a21f6$var$cg(b);
            break;
        case 4:
            $bfe34808345a21f6$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $bfe34808345a21f6$var$G($bfe34808345a21f6$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $bfe34808345a21f6$var$G($bfe34808345a21f6$var$L, $bfe34808345a21f6$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $bfe34808345a21f6$var$oj(a, b, c);
                $bfe34808345a21f6$var$G($bfe34808345a21f6$var$L, $bfe34808345a21f6$var$L.current & 1);
                a = $bfe34808345a21f6$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $bfe34808345a21f6$var$G($bfe34808345a21f6$var$L, $bfe34808345a21f6$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $bfe34808345a21f6$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $bfe34808345a21f6$var$G($bfe34808345a21f6$var$L, $bfe34808345a21f6$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $bfe34808345a21f6$var$dj(a, b, c);
    }
    return $bfe34808345a21f6$var$Zi(a, b, c);
}
var $bfe34808345a21f6$var$zj, $bfe34808345a21f6$var$Aj, $bfe34808345a21f6$var$Bj, $bfe34808345a21f6$var$Cj;
$bfe34808345a21f6$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$bfe34808345a21f6$var$Aj = function() {};
$bfe34808345a21f6$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $bfe34808345a21f6$var$xh($bfe34808345a21f6$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $bfe34808345a21f6$var$Ya(a, e);
                d = $bfe34808345a21f6$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $bfe34808345a21f6$var$A({}, e, {
                    value: void 0
                });
                d = $bfe34808345a21f6$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $bfe34808345a21f6$var$gb(a, e);
                d = $bfe34808345a21f6$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $bfe34808345a21f6$var$Bf);
        }
        $bfe34808345a21f6$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($bfe34808345a21f6$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($bfe34808345a21f6$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $bfe34808345a21f6$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$bfe34808345a21f6$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $bfe34808345a21f6$var$Dj(a, b) {
    if (!$bfe34808345a21f6$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $bfe34808345a21f6$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $bfe34808345a21f6$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $bfe34808345a21f6$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bfe34808345a21f6$var$S(b), null;
        case 1:
            return $bfe34808345a21f6$var$Zf(b.type) && $bfe34808345a21f6$var$$f(), $bfe34808345a21f6$var$S(b), null;
        case 3:
            d = b.stateNode;
            $bfe34808345a21f6$var$zh();
            $bfe34808345a21f6$var$E($bfe34808345a21f6$var$Wf);
            $bfe34808345a21f6$var$E($bfe34808345a21f6$var$H);
            $bfe34808345a21f6$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $bfe34808345a21f6$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $bfe34808345a21f6$var$zg && ($bfe34808345a21f6$var$Fj($bfe34808345a21f6$var$zg), $bfe34808345a21f6$var$zg = null));
            $bfe34808345a21f6$var$Aj(a, b);
            $bfe34808345a21f6$var$S(b);
            return null;
        case 5:
            $bfe34808345a21f6$var$Bh(b);
            var e = $bfe34808345a21f6$var$xh($bfe34808345a21f6$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $bfe34808345a21f6$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($bfe34808345a21f6$var$p(166));
                    $bfe34808345a21f6$var$S(b);
                    return null;
                }
                a = $bfe34808345a21f6$var$xh($bfe34808345a21f6$var$uh.current);
                if ($bfe34808345a21f6$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$bfe34808345a21f6$var$Of] = b;
                    d[$bfe34808345a21f6$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $bfe34808345a21f6$var$D("cancel", d);
                            $bfe34808345a21f6$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $bfe34808345a21f6$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $bfe34808345a21f6$var$lf.length; e++)$bfe34808345a21f6$var$D($bfe34808345a21f6$var$lf[e], d);
                            break;
                        case "source":
                            $bfe34808345a21f6$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $bfe34808345a21f6$var$D("error", d);
                            $bfe34808345a21f6$var$D("load", d);
                            break;
                        case "details":
                            $bfe34808345a21f6$var$D("toggle", d);
                            break;
                        case "input":
                            $bfe34808345a21f6$var$Za(d, f);
                            $bfe34808345a21f6$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $bfe34808345a21f6$var$D("invalid", d);
                            break;
                        case "textarea":
                            $bfe34808345a21f6$var$hb(d, f), $bfe34808345a21f6$var$D("invalid", d);
                    }
                    $bfe34808345a21f6$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $bfe34808345a21f6$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $bfe34808345a21f6$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $bfe34808345a21f6$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $bfe34808345a21f6$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $bfe34808345a21f6$var$Va(d);
                            $bfe34808345a21f6$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $bfe34808345a21f6$var$Va(d);
                            $bfe34808345a21f6$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $bfe34808345a21f6$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $bfe34808345a21f6$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$bfe34808345a21f6$var$Of] = b;
                    a[$bfe34808345a21f6$var$Pf] = d;
                    $bfe34808345a21f6$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $bfe34808345a21f6$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $bfe34808345a21f6$var$D("cancel", a);
                                $bfe34808345a21f6$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $bfe34808345a21f6$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $bfe34808345a21f6$var$lf.length; e++)$bfe34808345a21f6$var$D($bfe34808345a21f6$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $bfe34808345a21f6$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $bfe34808345a21f6$var$D("error", a);
                                $bfe34808345a21f6$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $bfe34808345a21f6$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $bfe34808345a21f6$var$Za(a, d);
                                e = $bfe34808345a21f6$var$Ya(a, d);
                                $bfe34808345a21f6$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $bfe34808345a21f6$var$A({}, d, {
                                    value: void 0
                                });
                                $bfe34808345a21f6$var$D("invalid", a);
                                break;
                            case "textarea":
                                $bfe34808345a21f6$var$hb(a, d);
                                e = $bfe34808345a21f6$var$gb(a, d);
                                $bfe34808345a21f6$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $bfe34808345a21f6$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $bfe34808345a21f6$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $bfe34808345a21f6$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $bfe34808345a21f6$var$ob(a, k) : "number" === typeof k && $bfe34808345a21f6$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($bfe34808345a21f6$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $bfe34808345a21f6$var$D("scroll", a) : null != k && $bfe34808345a21f6$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $bfe34808345a21f6$var$Va(a);
                                $bfe34808345a21f6$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $bfe34808345a21f6$var$Va(a);
                                $bfe34808345a21f6$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $bfe34808345a21f6$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $bfe34808345a21f6$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $bfe34808345a21f6$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $bfe34808345a21f6$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $bfe34808345a21f6$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $bfe34808345a21f6$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($bfe34808345a21f6$var$p(166));
                c = $bfe34808345a21f6$var$xh($bfe34808345a21f6$var$wh.current);
                $bfe34808345a21f6$var$xh($bfe34808345a21f6$var$uh.current);
                if ($bfe34808345a21f6$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$bfe34808345a21f6$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $bfe34808345a21f6$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $bfe34808345a21f6$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $bfe34808345a21f6$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$bfe34808345a21f6$var$Of] = b, b.stateNode = d;
            }
            $bfe34808345a21f6$var$S(b);
            return null;
        case 13:
            $bfe34808345a21f6$var$E($bfe34808345a21f6$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($bfe34808345a21f6$var$I && null !== $bfe34808345a21f6$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $bfe34808345a21f6$var$Hg(), $bfe34808345a21f6$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $bfe34808345a21f6$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($bfe34808345a21f6$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($bfe34808345a21f6$var$p(317));
                        f[$bfe34808345a21f6$var$Of] = b;
                    } else $bfe34808345a21f6$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $bfe34808345a21f6$var$S(b);
                    f = !1;
                } else null !== $bfe34808345a21f6$var$zg && ($bfe34808345a21f6$var$Fj($bfe34808345a21f6$var$zg), $bfe34808345a21f6$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($bfe34808345a21f6$var$L.current & 1) ? 0 === $bfe34808345a21f6$var$T && ($bfe34808345a21f6$var$T = 3) : $bfe34808345a21f6$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $bfe34808345a21f6$var$S(b);
            return null;
        case 4:
            return $bfe34808345a21f6$var$zh(), $bfe34808345a21f6$var$Aj(a, b), null === a && $bfe34808345a21f6$var$sf(b.stateNode.containerInfo), $bfe34808345a21f6$var$S(b), null;
        case 10:
            return $bfe34808345a21f6$var$ah(b.type._context), $bfe34808345a21f6$var$S(b), null;
        case 17:
            return $bfe34808345a21f6$var$Zf(b.type) && $bfe34808345a21f6$var$$f(), $bfe34808345a21f6$var$S(b), null;
        case 19:
            $bfe34808345a21f6$var$E($bfe34808345a21f6$var$L);
            f = b.memoizedState;
            if (null === f) return $bfe34808345a21f6$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $bfe34808345a21f6$var$Dj(f, !1);
                else {
                    if (0 !== $bfe34808345a21f6$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $bfe34808345a21f6$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $bfe34808345a21f6$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $bfe34808345a21f6$var$G($bfe34808345a21f6$var$L, $bfe34808345a21f6$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $bfe34808345a21f6$var$B() > $bfe34808345a21f6$var$Gj && (b.flags |= 128, d = !0, $bfe34808345a21f6$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $bfe34808345a21f6$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $bfe34808345a21f6$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$bfe34808345a21f6$var$I) return $bfe34808345a21f6$var$S(b), null;
                    } else 2 * $bfe34808345a21f6$var$B() - f.renderingStartTime > $bfe34808345a21f6$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $bfe34808345a21f6$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $bfe34808345a21f6$var$B(), b.sibling = null, c = $bfe34808345a21f6$var$L.current, $bfe34808345a21f6$var$G($bfe34808345a21f6$var$L, d ? c & 1 | 2 : c & 1), b;
            $bfe34808345a21f6$var$S(b);
            return null;
        case 22:
        case 23:
            return $bfe34808345a21f6$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($bfe34808345a21f6$var$fj & 1073741824) && ($bfe34808345a21f6$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $bfe34808345a21f6$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($bfe34808345a21f6$var$p(156, b.tag));
}
function $bfe34808345a21f6$var$Ij(a, b) {
    $bfe34808345a21f6$var$wg(b);
    switch(b.tag){
        case 1:
            return $bfe34808345a21f6$var$Zf(b.type) && $bfe34808345a21f6$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $bfe34808345a21f6$var$zh(), $bfe34808345a21f6$var$E($bfe34808345a21f6$var$Wf), $bfe34808345a21f6$var$E($bfe34808345a21f6$var$H), $bfe34808345a21f6$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $bfe34808345a21f6$var$Bh(b), null;
        case 13:
            $bfe34808345a21f6$var$E($bfe34808345a21f6$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($bfe34808345a21f6$var$p(340));
                $bfe34808345a21f6$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $bfe34808345a21f6$var$E($bfe34808345a21f6$var$L), null;
        case 4:
            return $bfe34808345a21f6$var$zh(), null;
        case 10:
            return $bfe34808345a21f6$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $bfe34808345a21f6$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $bfe34808345a21f6$var$Jj = !1, $bfe34808345a21f6$var$U = !1, $bfe34808345a21f6$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $bfe34808345a21f6$var$V = null;
function $bfe34808345a21f6$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $bfe34808345a21f6$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $bfe34808345a21f6$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $bfe34808345a21f6$var$W(a, b, d);
    }
}
var $bfe34808345a21f6$var$Nj = !1;
function $bfe34808345a21f6$var$Oj(a, b) {
    $bfe34808345a21f6$var$Cf = $bfe34808345a21f6$var$dd;
    a = $bfe34808345a21f6$var$Me();
    if ($bfe34808345a21f6$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $bfe34808345a21f6$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $bfe34808345a21f6$var$dd = !1;
    for($bfe34808345a21f6$var$V = b; null !== $bfe34808345a21f6$var$V;)if (b = $bfe34808345a21f6$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $bfe34808345a21f6$var$V = a;
    else for(; null !== $bfe34808345a21f6$var$V;){
        b = $bfe34808345a21f6$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $bfe34808345a21f6$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($bfe34808345a21f6$var$p(163));
            }
        } catch (F) {
            $bfe34808345a21f6$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $bfe34808345a21f6$var$V = a;
            break;
        }
        $bfe34808345a21f6$var$V = b.return;
    }
    n = $bfe34808345a21f6$var$Nj;
    $bfe34808345a21f6$var$Nj = !1;
    return n;
}
function $bfe34808345a21f6$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $bfe34808345a21f6$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $bfe34808345a21f6$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $bfe34808345a21f6$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $bfe34808345a21f6$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $bfe34808345a21f6$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$bfe34808345a21f6$var$Of], delete b[$bfe34808345a21f6$var$Pf], delete b[$bfe34808345a21f6$var$of], delete b[$bfe34808345a21f6$var$Qf], delete b[$bfe34808345a21f6$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $bfe34808345a21f6$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $bfe34808345a21f6$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $bfe34808345a21f6$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $bfe34808345a21f6$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $bfe34808345a21f6$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($bfe34808345a21f6$var$Vj(a, b, c), a = a.sibling; null !== a;)$bfe34808345a21f6$var$Vj(a, b, c), a = a.sibling;
}
function $bfe34808345a21f6$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($bfe34808345a21f6$var$Wj(a, b, c), a = a.sibling; null !== a;)$bfe34808345a21f6$var$Wj(a, b, c), a = a.sibling;
}
var $bfe34808345a21f6$var$X = null, $bfe34808345a21f6$var$Xj = !1;
function $bfe34808345a21f6$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$bfe34808345a21f6$var$Zj(a, b, c), c = c.sibling;
}
function $bfe34808345a21f6$var$Zj(a, b, c) {
    if ($bfe34808345a21f6$var$lc && "function" === typeof $bfe34808345a21f6$var$lc.onCommitFiberUnmount) try {
        $bfe34808345a21f6$var$lc.onCommitFiberUnmount($bfe34808345a21f6$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $bfe34808345a21f6$var$U || $bfe34808345a21f6$var$Lj(c, b);
        case 6:
            var d = $bfe34808345a21f6$var$X, e = $bfe34808345a21f6$var$Xj;
            $bfe34808345a21f6$var$X = null;
            $bfe34808345a21f6$var$Yj(a, b, c);
            $bfe34808345a21f6$var$X = d;
            $bfe34808345a21f6$var$Xj = e;
            null !== $bfe34808345a21f6$var$X && ($bfe34808345a21f6$var$Xj ? (a = $bfe34808345a21f6$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $bfe34808345a21f6$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $bfe34808345a21f6$var$X && ($bfe34808345a21f6$var$Xj ? (a = $bfe34808345a21f6$var$X, c = c.stateNode, 8 === a.nodeType ? $bfe34808345a21f6$var$Kf(a.parentNode, c) : 1 === a.nodeType && $bfe34808345a21f6$var$Kf(a, c), $bfe34808345a21f6$var$bd(a)) : $bfe34808345a21f6$var$Kf($bfe34808345a21f6$var$X, c.stateNode));
            break;
        case 4:
            d = $bfe34808345a21f6$var$X;
            e = $bfe34808345a21f6$var$Xj;
            $bfe34808345a21f6$var$X = c.stateNode.containerInfo;
            $bfe34808345a21f6$var$Xj = !0;
            $bfe34808345a21f6$var$Yj(a, b, c);
            $bfe34808345a21f6$var$X = d;
            $bfe34808345a21f6$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$bfe34808345a21f6$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $bfe34808345a21f6$var$Mj(c, b, g) : 0 !== (f & 4) && $bfe34808345a21f6$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $bfe34808345a21f6$var$Yj(a, b, c);
            break;
        case 1:
            if (!$bfe34808345a21f6$var$U && ($bfe34808345a21f6$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $bfe34808345a21f6$var$W(c, b, h);
            }
            $bfe34808345a21f6$var$Yj(a, b, c);
            break;
        case 21:
            $bfe34808345a21f6$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($bfe34808345a21f6$var$U = (d = $bfe34808345a21f6$var$U) || null !== c.memoizedState, $bfe34808345a21f6$var$Yj(a, b, c), $bfe34808345a21f6$var$U = d) : $bfe34808345a21f6$var$Yj(a, b, c);
            break;
        default:
            $bfe34808345a21f6$var$Yj(a, b, c);
    }
}
function $bfe34808345a21f6$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $bfe34808345a21f6$var$Kj);
        b.forEach(function(b) {
            var d = $bfe34808345a21f6$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $bfe34808345a21f6$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $bfe34808345a21f6$var$X = h.stateNode;
                        $bfe34808345a21f6$var$Xj = !1;
                        break a;
                    case 3:
                        $bfe34808345a21f6$var$X = h.stateNode.containerInfo;
                        $bfe34808345a21f6$var$Xj = !0;
                        break a;
                    case 4:
                        $bfe34808345a21f6$var$X = h.stateNode.containerInfo;
                        $bfe34808345a21f6$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $bfe34808345a21f6$var$X) throw Error($bfe34808345a21f6$var$p(160));
            $bfe34808345a21f6$var$Zj(f, g, e);
            $bfe34808345a21f6$var$X = null;
            $bfe34808345a21f6$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $bfe34808345a21f6$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$bfe34808345a21f6$var$dk(b, a), b = b.sibling;
}
function $bfe34808345a21f6$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            if (d & 4) {
                try {
                    $bfe34808345a21f6$var$Pj(3, a, a.return), $bfe34808345a21f6$var$Qj(3, a);
                } catch (t) {
                    $bfe34808345a21f6$var$W(a, a.return, t);
                }
                try {
                    $bfe34808345a21f6$var$Pj(5, a, a.return);
                } catch (t) {
                    $bfe34808345a21f6$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            d & 512 && null !== c && $bfe34808345a21f6$var$Lj(c, c.return);
            break;
        case 5:
            $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            d & 512 && null !== c && $bfe34808345a21f6$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $bfe34808345a21f6$var$ob(e, "");
                } catch (t) {
                    $bfe34808345a21f6$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $bfe34808345a21f6$var$ab(e, f);
                    $bfe34808345a21f6$var$vb(h, g);
                    var l = $bfe34808345a21f6$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $bfe34808345a21f6$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $bfe34808345a21f6$var$nb(e, q) : "children" === m ? $bfe34808345a21f6$var$ob(e, q) : $bfe34808345a21f6$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $bfe34808345a21f6$var$bb(e, f);
                            break;
                        case "textarea":
                            $bfe34808345a21f6$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $bfe34808345a21f6$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $bfe34808345a21f6$var$fb(e, !!f.multiple, f.defaultValue, !0) : $bfe34808345a21f6$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$bfe34808345a21f6$var$Pf] = f;
                } catch (t) {
                    $bfe34808345a21f6$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($bfe34808345a21f6$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $bfe34808345a21f6$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $bfe34808345a21f6$var$bd(b.containerInfo);
            } catch (t) {
                $bfe34808345a21f6$var$W(a, a.return, t);
            }
            break;
        case 4:
            $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            break;
        case 13:
            $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($bfe34808345a21f6$var$fk = $bfe34808345a21f6$var$B()));
            d & 4 && $bfe34808345a21f6$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($bfe34808345a21f6$var$U = (l = $bfe34808345a21f6$var$U) || m, $bfe34808345a21f6$var$ck(b, a), $bfe34808345a21f6$var$U = l) : $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($bfe34808345a21f6$var$V = a, m = a.child; null !== m;){
                    for(q = $bfe34808345a21f6$var$V = m; null !== $bfe34808345a21f6$var$V;){
                        r = $bfe34808345a21f6$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $bfe34808345a21f6$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $bfe34808345a21f6$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $bfe34808345a21f6$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $bfe34808345a21f6$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $bfe34808345a21f6$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $bfe34808345a21f6$var$V = y) : $bfe34808345a21f6$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $bfe34808345a21f6$var$rb("display", g));
                            } catch (t) {
                                $bfe34808345a21f6$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $bfe34808345a21f6$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $bfe34808345a21f6$var$ck(b, a);
            $bfe34808345a21f6$var$ek(a);
            d & 4 && $bfe34808345a21f6$var$ak(a);
            break;
        case 21:
            break;
        default:
            $bfe34808345a21f6$var$ck(b, a), $bfe34808345a21f6$var$ek(a);
    }
}
function $bfe34808345a21f6$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($bfe34808345a21f6$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($bfe34808345a21f6$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($bfe34808345a21f6$var$ob(e, ""), d.flags &= -33);
                    var f = $bfe34808345a21f6$var$Uj(a);
                    $bfe34808345a21f6$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $bfe34808345a21f6$var$Uj(a);
                    $bfe34808345a21f6$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($bfe34808345a21f6$var$p(161));
            }
        } catch (k) {
            $bfe34808345a21f6$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $bfe34808345a21f6$var$hk(a, b, c) {
    $bfe34808345a21f6$var$V = a;
    $bfe34808345a21f6$var$ik(a, b, c);
}
function $bfe34808345a21f6$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $bfe34808345a21f6$var$V;){
        var e = $bfe34808345a21f6$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $bfe34808345a21f6$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $bfe34808345a21f6$var$U;
                h = $bfe34808345a21f6$var$Jj;
                var l = $bfe34808345a21f6$var$U;
                $bfe34808345a21f6$var$Jj = g;
                if (($bfe34808345a21f6$var$U = k) && !l) for($bfe34808345a21f6$var$V = e; null !== $bfe34808345a21f6$var$V;)g = $bfe34808345a21f6$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $bfe34808345a21f6$var$jk(e) : null !== k ? (k.return = g, $bfe34808345a21f6$var$V = k) : $bfe34808345a21f6$var$jk(e);
                for(; null !== f;)$bfe34808345a21f6$var$V = f, $bfe34808345a21f6$var$ik(f, b, c), f = f.sibling;
                $bfe34808345a21f6$var$V = e;
                $bfe34808345a21f6$var$Jj = h;
                $bfe34808345a21f6$var$U = l;
            }
            $bfe34808345a21f6$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $bfe34808345a21f6$var$V = f) : $bfe34808345a21f6$var$kk(a, b, c);
    }
}
function $bfe34808345a21f6$var$kk(a) {
    for(; null !== $bfe34808345a21f6$var$V;){
        var b = $bfe34808345a21f6$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $bfe34808345a21f6$var$U || $bfe34808345a21f6$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$bfe34808345a21f6$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $bfe34808345a21f6$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $bfe34808345a21f6$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $bfe34808345a21f6$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $bfe34808345a21f6$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($bfe34808345a21f6$var$p(163));
                }
                $bfe34808345a21f6$var$U || b.flags & 512 && $bfe34808345a21f6$var$Rj(b);
            } catch (r) {
                $bfe34808345a21f6$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $bfe34808345a21f6$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bfe34808345a21f6$var$V = c;
            break;
        }
        $bfe34808345a21f6$var$V = b.return;
    }
}
function $bfe34808345a21f6$var$gk(a) {
    for(; null !== $bfe34808345a21f6$var$V;){
        var b = $bfe34808345a21f6$var$V;
        if (b === a) {
            $bfe34808345a21f6$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bfe34808345a21f6$var$V = c;
            break;
        }
        $bfe34808345a21f6$var$V = b.return;
    }
}
function $bfe34808345a21f6$var$jk(a) {
    for(; null !== $bfe34808345a21f6$var$V;){
        var b = $bfe34808345a21f6$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $bfe34808345a21f6$var$Qj(4, b);
                    } catch (k) {
                        $bfe34808345a21f6$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $bfe34808345a21f6$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $bfe34808345a21f6$var$Rj(b);
                    } catch (k) {
                        $bfe34808345a21f6$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $bfe34808345a21f6$var$Rj(b);
                    } catch (k) {
                        $bfe34808345a21f6$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $bfe34808345a21f6$var$W(b, b.return, k);
        }
        if (b === a) {
            $bfe34808345a21f6$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $bfe34808345a21f6$var$V = h;
            break;
        }
        $bfe34808345a21f6$var$V = b.return;
    }
}
var $bfe34808345a21f6$var$lk = Math.ceil, $bfe34808345a21f6$var$mk = $bfe34808345a21f6$var$ua.ReactCurrentDispatcher, $bfe34808345a21f6$var$nk = $bfe34808345a21f6$var$ua.ReactCurrentOwner, $bfe34808345a21f6$var$ok = $bfe34808345a21f6$var$ua.ReactCurrentBatchConfig, $bfe34808345a21f6$var$K = 0, $bfe34808345a21f6$var$Q = null, $bfe34808345a21f6$var$Y = null, $bfe34808345a21f6$var$Z = 0, $bfe34808345a21f6$var$fj = 0, $bfe34808345a21f6$var$ej = $bfe34808345a21f6$var$Uf(0), $bfe34808345a21f6$var$T = 0, $bfe34808345a21f6$var$pk = null, $bfe34808345a21f6$var$rh = 0, $bfe34808345a21f6$var$qk = 0, $bfe34808345a21f6$var$rk = 0, $bfe34808345a21f6$var$sk = null, $bfe34808345a21f6$var$tk = null, $bfe34808345a21f6$var$fk = 0, $bfe34808345a21f6$var$Gj = Infinity, $bfe34808345a21f6$var$uk = null, $bfe34808345a21f6$var$Oi = !1, $bfe34808345a21f6$var$Pi = null, $bfe34808345a21f6$var$Ri = null, $bfe34808345a21f6$var$vk = !1, $bfe34808345a21f6$var$wk = null, $bfe34808345a21f6$var$xk = 0, $bfe34808345a21f6$var$yk = 0, $bfe34808345a21f6$var$zk = null, $bfe34808345a21f6$var$Ak = -1, $bfe34808345a21f6$var$Bk = 0;
function $bfe34808345a21f6$var$R() {
    return 0 !== ($bfe34808345a21f6$var$K & 6) ? $bfe34808345a21f6$var$B() : -1 !== $bfe34808345a21f6$var$Ak ? $bfe34808345a21f6$var$Ak : $bfe34808345a21f6$var$Ak = $bfe34808345a21f6$var$B();
}
function $bfe34808345a21f6$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($bfe34808345a21f6$var$K & 2) && 0 !== $bfe34808345a21f6$var$Z) return $bfe34808345a21f6$var$Z & -$bfe34808345a21f6$var$Z;
    if (null !== $bfe34808345a21f6$var$Kg.transition) return 0 === $bfe34808345a21f6$var$Bk && ($bfe34808345a21f6$var$Bk = $bfe34808345a21f6$var$yc()), $bfe34808345a21f6$var$Bk;
    a = $bfe34808345a21f6$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $bfe34808345a21f6$var$jd(a.type);
    return a;
}
function $bfe34808345a21f6$var$gi(a, b, c, d) {
    if (50 < $bfe34808345a21f6$var$yk) throw $bfe34808345a21f6$var$yk = 0, $bfe34808345a21f6$var$zk = null, Error($bfe34808345a21f6$var$p(185));
    $bfe34808345a21f6$var$Ac(a, c, d);
    if (0 === ($bfe34808345a21f6$var$K & 2) || a !== $bfe34808345a21f6$var$Q) a === $bfe34808345a21f6$var$Q && (0 === ($bfe34808345a21f6$var$K & 2) && ($bfe34808345a21f6$var$qk |= c), 4 === $bfe34808345a21f6$var$T && $bfe34808345a21f6$var$Ck(a, $bfe34808345a21f6$var$Z)), $bfe34808345a21f6$var$Dk(a, d), 1 === c && 0 === $bfe34808345a21f6$var$K && 0 === (b.mode & 1) && ($bfe34808345a21f6$var$Gj = $bfe34808345a21f6$var$B() + 500, $bfe34808345a21f6$var$fg && $bfe34808345a21f6$var$jg());
}
function $bfe34808345a21f6$var$Dk(a, b) {
    var c = a.callbackNode;
    $bfe34808345a21f6$var$wc(a, b);
    var d = $bfe34808345a21f6$var$uc(a, a === $bfe34808345a21f6$var$Q ? $bfe34808345a21f6$var$Z : 0);
    if (0 === d) null !== c && $bfe34808345a21f6$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $bfe34808345a21f6$var$bc(c);
        if (1 === b) 0 === a.tag ? $bfe34808345a21f6$var$ig($bfe34808345a21f6$var$Ek.bind(null, a)) : $bfe34808345a21f6$var$hg($bfe34808345a21f6$var$Ek.bind(null, a)), $bfe34808345a21f6$var$Jf(function() {
            0 === ($bfe34808345a21f6$var$K & 6) && $bfe34808345a21f6$var$jg();
        }), c = null;
        else {
            switch($bfe34808345a21f6$var$Dc(d)){
                case 1:
                    c = $bfe34808345a21f6$var$fc;
                    break;
                case 4:
                    c = $bfe34808345a21f6$var$gc;
                    break;
                case 16:
                    c = $bfe34808345a21f6$var$hc;
                    break;
                case 536870912:
                    c = $bfe34808345a21f6$var$jc;
                    break;
                default:
                    c = $bfe34808345a21f6$var$hc;
            }
            c = $bfe34808345a21f6$var$Fk(c, $bfe34808345a21f6$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $bfe34808345a21f6$var$Gk(a, b) {
    $bfe34808345a21f6$var$Ak = -1;
    $bfe34808345a21f6$var$Bk = 0;
    if (0 !== ($bfe34808345a21f6$var$K & 6)) throw Error($bfe34808345a21f6$var$p(327));
    var c = a.callbackNode;
    if ($bfe34808345a21f6$var$Hk() && a.callbackNode !== c) return null;
    var d = $bfe34808345a21f6$var$uc(a, a === $bfe34808345a21f6$var$Q ? $bfe34808345a21f6$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $bfe34808345a21f6$var$Ik(a, d);
    else {
        b = d;
        var e = $bfe34808345a21f6$var$K;
        $bfe34808345a21f6$var$K |= 2;
        var f = $bfe34808345a21f6$var$Jk();
        if ($bfe34808345a21f6$var$Q !== a || $bfe34808345a21f6$var$Z !== b) $bfe34808345a21f6$var$uk = null, $bfe34808345a21f6$var$Gj = $bfe34808345a21f6$var$B() + 500, $bfe34808345a21f6$var$Kk(a, b);
        for(;;)try {
            $bfe34808345a21f6$var$Lk();
            break;
        } catch (h) {
            $bfe34808345a21f6$var$Mk(a, h);
        }
        $bfe34808345a21f6$var$$g();
        $bfe34808345a21f6$var$mk.current = f;
        $bfe34808345a21f6$var$K = e;
        null !== $bfe34808345a21f6$var$Y ? b = 0 : ($bfe34808345a21f6$var$Q = null, $bfe34808345a21f6$var$Z = 0, b = $bfe34808345a21f6$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $bfe34808345a21f6$var$xc(a), 0 !== e && (d = e, b = $bfe34808345a21f6$var$Nk(a, e)));
        if (1 === b) throw c = $bfe34808345a21f6$var$pk, $bfe34808345a21f6$var$Kk(a, 0), $bfe34808345a21f6$var$Ck(a, d), $bfe34808345a21f6$var$Dk(a, $bfe34808345a21f6$var$B()), c;
        if (6 === b) $bfe34808345a21f6$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$bfe34808345a21f6$var$Ok(e) && (b = $bfe34808345a21f6$var$Ik(a, d), 2 === b && (f = $bfe34808345a21f6$var$xc(a), 0 !== f && (d = f, b = $bfe34808345a21f6$var$Nk(a, f))), 1 === b)) throw c = $bfe34808345a21f6$var$pk, $bfe34808345a21f6$var$Kk(a, 0), $bfe34808345a21f6$var$Ck(a, d), $bfe34808345a21f6$var$Dk(a, $bfe34808345a21f6$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($bfe34808345a21f6$var$p(345));
                case 2:
                    $bfe34808345a21f6$var$Pk(a, $bfe34808345a21f6$var$tk, $bfe34808345a21f6$var$uk);
                    break;
                case 3:
                    $bfe34808345a21f6$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $bfe34808345a21f6$var$fk + 500 - $bfe34808345a21f6$var$B(), 10 < b)) {
                        if (0 !== $bfe34808345a21f6$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $bfe34808345a21f6$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $bfe34808345a21f6$var$Ff($bfe34808345a21f6$var$Pk.bind(null, a, $bfe34808345a21f6$var$tk, $bfe34808345a21f6$var$uk), b);
                        break;
                    }
                    $bfe34808345a21f6$var$Pk(a, $bfe34808345a21f6$var$tk, $bfe34808345a21f6$var$uk);
                    break;
                case 4:
                    $bfe34808345a21f6$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $bfe34808345a21f6$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $bfe34808345a21f6$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $bfe34808345a21f6$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $bfe34808345a21f6$var$Ff($bfe34808345a21f6$var$Pk.bind(null, a, $bfe34808345a21f6$var$tk, $bfe34808345a21f6$var$uk), d);
                        break;
                    }
                    $bfe34808345a21f6$var$Pk(a, $bfe34808345a21f6$var$tk, $bfe34808345a21f6$var$uk);
                    break;
                case 5:
                    $bfe34808345a21f6$var$Pk(a, $bfe34808345a21f6$var$tk, $bfe34808345a21f6$var$uk);
                    break;
                default:
                    throw Error($bfe34808345a21f6$var$p(329));
            }
        }
    }
    $bfe34808345a21f6$var$Dk(a, $bfe34808345a21f6$var$B());
    return a.callbackNode === c ? $bfe34808345a21f6$var$Gk.bind(null, a) : null;
}
function $bfe34808345a21f6$var$Nk(a, b) {
    var c = $bfe34808345a21f6$var$sk;
    a.current.memoizedState.isDehydrated && ($bfe34808345a21f6$var$Kk(a, b).flags |= 256);
    a = $bfe34808345a21f6$var$Ik(a, b);
    2 !== a && (b = $bfe34808345a21f6$var$tk, $bfe34808345a21f6$var$tk = c, null !== b && $bfe34808345a21f6$var$Fj(b));
    return a;
}
function $bfe34808345a21f6$var$Fj(a) {
    null === $bfe34808345a21f6$var$tk ? $bfe34808345a21f6$var$tk = a : $bfe34808345a21f6$var$tk.push.apply($bfe34808345a21f6$var$tk, a);
}
function $bfe34808345a21f6$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$bfe34808345a21f6$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $bfe34808345a21f6$var$Ck(a, b) {
    b &= ~$bfe34808345a21f6$var$rk;
    b &= ~$bfe34808345a21f6$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $bfe34808345a21f6$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $bfe34808345a21f6$var$Ek(a) {
    if (0 !== ($bfe34808345a21f6$var$K & 6)) throw Error($bfe34808345a21f6$var$p(327));
    $bfe34808345a21f6$var$Hk();
    var b = $bfe34808345a21f6$var$uc(a, 0);
    if (0 === (b & 1)) return $bfe34808345a21f6$var$Dk(a, $bfe34808345a21f6$var$B()), null;
    var c = $bfe34808345a21f6$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $bfe34808345a21f6$var$xc(a);
        0 !== d && (b = d, c = $bfe34808345a21f6$var$Nk(a, d));
    }
    if (1 === c) throw c = $bfe34808345a21f6$var$pk, $bfe34808345a21f6$var$Kk(a, 0), $bfe34808345a21f6$var$Ck(a, b), $bfe34808345a21f6$var$Dk(a, $bfe34808345a21f6$var$B()), c;
    if (6 === c) throw Error($bfe34808345a21f6$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $bfe34808345a21f6$var$Pk(a, $bfe34808345a21f6$var$tk, $bfe34808345a21f6$var$uk);
    $bfe34808345a21f6$var$Dk(a, $bfe34808345a21f6$var$B());
    return null;
}
function $bfe34808345a21f6$var$Qk(a, b) {
    var c = $bfe34808345a21f6$var$K;
    $bfe34808345a21f6$var$K |= 1;
    try {
        return a(b);
    } finally{
        $bfe34808345a21f6$var$K = c, 0 === $bfe34808345a21f6$var$K && ($bfe34808345a21f6$var$Gj = $bfe34808345a21f6$var$B() + 500, $bfe34808345a21f6$var$fg && $bfe34808345a21f6$var$jg());
    }
}
function $bfe34808345a21f6$var$Rk(a) {
    null !== $bfe34808345a21f6$var$wk && 0 === $bfe34808345a21f6$var$wk.tag && 0 === ($bfe34808345a21f6$var$K & 6) && $bfe34808345a21f6$var$Hk();
    var b = $bfe34808345a21f6$var$K;
    $bfe34808345a21f6$var$K |= 1;
    var c = $bfe34808345a21f6$var$ok.transition, d = $bfe34808345a21f6$var$C;
    try {
        if ($bfe34808345a21f6$var$ok.transition = null, $bfe34808345a21f6$var$C = 1, a) return a();
    } finally{
        $bfe34808345a21f6$var$C = d, $bfe34808345a21f6$var$ok.transition = c, $bfe34808345a21f6$var$K = b, 0 === ($bfe34808345a21f6$var$K & 6) && $bfe34808345a21f6$var$jg();
    }
}
function $bfe34808345a21f6$var$Hj() {
    $bfe34808345a21f6$var$fj = $bfe34808345a21f6$var$ej.current;
    $bfe34808345a21f6$var$E($bfe34808345a21f6$var$ej);
}
function $bfe34808345a21f6$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $bfe34808345a21f6$var$Gf(c));
    if (null !== $bfe34808345a21f6$var$Y) for(c = $bfe34808345a21f6$var$Y.return; null !== c;){
        var d = c;
        $bfe34808345a21f6$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $bfe34808345a21f6$var$$f();
                break;
            case 3:
                $bfe34808345a21f6$var$zh();
                $bfe34808345a21f6$var$E($bfe34808345a21f6$var$Wf);
                $bfe34808345a21f6$var$E($bfe34808345a21f6$var$H);
                $bfe34808345a21f6$var$Eh();
                break;
            case 5:
                $bfe34808345a21f6$var$Bh(d);
                break;
            case 4:
                $bfe34808345a21f6$var$zh();
                break;
            case 13:
                $bfe34808345a21f6$var$E($bfe34808345a21f6$var$L);
                break;
            case 19:
                $bfe34808345a21f6$var$E($bfe34808345a21f6$var$L);
                break;
            case 10:
                $bfe34808345a21f6$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $bfe34808345a21f6$var$Hj();
        }
        c = c.return;
    }
    $bfe34808345a21f6$var$Q = a;
    $bfe34808345a21f6$var$Y = a = $bfe34808345a21f6$var$Pg(a.current, null);
    $bfe34808345a21f6$var$Z = $bfe34808345a21f6$var$fj = b;
    $bfe34808345a21f6$var$T = 0;
    $bfe34808345a21f6$var$pk = null;
    $bfe34808345a21f6$var$rk = $bfe34808345a21f6$var$qk = $bfe34808345a21f6$var$rh = 0;
    $bfe34808345a21f6$var$tk = $bfe34808345a21f6$var$sk = null;
    if (null !== $bfe34808345a21f6$var$fh) {
        for(b = 0; b < $bfe34808345a21f6$var$fh.length; b++)if (c = $bfe34808345a21f6$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $bfe34808345a21f6$var$fh = null;
    }
    return a;
}
function $bfe34808345a21f6$var$Mk(a, b) {
    do {
        var c = $bfe34808345a21f6$var$Y;
        try {
            $bfe34808345a21f6$var$$g();
            $bfe34808345a21f6$var$Fh.current = $bfe34808345a21f6$var$Rh;
            if ($bfe34808345a21f6$var$Ih) {
                for(var d = $bfe34808345a21f6$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $bfe34808345a21f6$var$Ih = !1;
            }
            $bfe34808345a21f6$var$Hh = 0;
            $bfe34808345a21f6$var$O = $bfe34808345a21f6$var$N = $bfe34808345a21f6$var$M = null;
            $bfe34808345a21f6$var$Jh = !1;
            $bfe34808345a21f6$var$Kh = 0;
            $bfe34808345a21f6$var$nk.current = null;
            if (null === c || null === c.return) {
                $bfe34808345a21f6$var$T = 1;
                $bfe34808345a21f6$var$pk = b;
                $bfe34808345a21f6$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $bfe34808345a21f6$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $bfe34808345a21f6$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $bfe34808345a21f6$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $bfe34808345a21f6$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $bfe34808345a21f6$var$Si(f, l, b);
                            $bfe34808345a21f6$var$tj();
                            break a;
                        }
                        k = Error($bfe34808345a21f6$var$p(426));
                    }
                } else if ($bfe34808345a21f6$var$I && h.mode & 1) {
                    var J = $bfe34808345a21f6$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $bfe34808345a21f6$var$Vi(J, g, h, f, b);
                        $bfe34808345a21f6$var$Jg($bfe34808345a21f6$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $bfe34808345a21f6$var$Ji(k, h);
                4 !== $bfe34808345a21f6$var$T && ($bfe34808345a21f6$var$T = 2);
                null === $bfe34808345a21f6$var$sk ? $bfe34808345a21f6$var$sk = [
                    f
                ] : $bfe34808345a21f6$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $bfe34808345a21f6$var$Ni(f, k, b);
                            $bfe34808345a21f6$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $bfe34808345a21f6$var$Ri || !$bfe34808345a21f6$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $bfe34808345a21f6$var$Qi(f, h, b);
                                $bfe34808345a21f6$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $bfe34808345a21f6$var$Sk(c);
        } catch (na) {
            b = na;
            $bfe34808345a21f6$var$Y === c && null !== c && ($bfe34808345a21f6$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $bfe34808345a21f6$var$Jk() {
    var a = $bfe34808345a21f6$var$mk.current;
    $bfe34808345a21f6$var$mk.current = $bfe34808345a21f6$var$Rh;
    return null === a ? $bfe34808345a21f6$var$Rh : a;
}
function $bfe34808345a21f6$var$tj() {
    if (0 === $bfe34808345a21f6$var$T || 3 === $bfe34808345a21f6$var$T || 2 === $bfe34808345a21f6$var$T) $bfe34808345a21f6$var$T = 4;
    null === $bfe34808345a21f6$var$Q || 0 === ($bfe34808345a21f6$var$rh & 268435455) && 0 === ($bfe34808345a21f6$var$qk & 268435455) || $bfe34808345a21f6$var$Ck($bfe34808345a21f6$var$Q, $bfe34808345a21f6$var$Z);
}
function $bfe34808345a21f6$var$Ik(a, b) {
    var c = $bfe34808345a21f6$var$K;
    $bfe34808345a21f6$var$K |= 2;
    var d = $bfe34808345a21f6$var$Jk();
    if ($bfe34808345a21f6$var$Q !== a || $bfe34808345a21f6$var$Z !== b) $bfe34808345a21f6$var$uk = null, $bfe34808345a21f6$var$Kk(a, b);
    for(;;)try {
        $bfe34808345a21f6$var$Tk();
        break;
    } catch (e) {
        $bfe34808345a21f6$var$Mk(a, e);
    }
    $bfe34808345a21f6$var$$g();
    $bfe34808345a21f6$var$K = c;
    $bfe34808345a21f6$var$mk.current = d;
    if (null !== $bfe34808345a21f6$var$Y) throw Error($bfe34808345a21f6$var$p(261));
    $bfe34808345a21f6$var$Q = null;
    $bfe34808345a21f6$var$Z = 0;
    return $bfe34808345a21f6$var$T;
}
function $bfe34808345a21f6$var$Tk() {
    for(; null !== $bfe34808345a21f6$var$Y;)$bfe34808345a21f6$var$Uk($bfe34808345a21f6$var$Y);
}
function $bfe34808345a21f6$var$Lk() {
    for(; null !== $bfe34808345a21f6$var$Y && !$bfe34808345a21f6$var$cc();)$bfe34808345a21f6$var$Uk($bfe34808345a21f6$var$Y);
}
function $bfe34808345a21f6$var$Uk(a) {
    var b = $bfe34808345a21f6$var$Vk(a.alternate, a, $bfe34808345a21f6$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $bfe34808345a21f6$var$Sk(a) : $bfe34808345a21f6$var$Y = b;
    $bfe34808345a21f6$var$nk.current = null;
}
function $bfe34808345a21f6$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $bfe34808345a21f6$var$Ej(c, b, $bfe34808345a21f6$var$fj), null !== c) {
                $bfe34808345a21f6$var$Y = c;
                return;
            }
        } else {
            c = $bfe34808345a21f6$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $bfe34808345a21f6$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $bfe34808345a21f6$var$T = 6;
                $bfe34808345a21f6$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $bfe34808345a21f6$var$Y = b;
            return;
        }
        $bfe34808345a21f6$var$Y = b = a;
    }while (null !== b);
    0 === $bfe34808345a21f6$var$T && ($bfe34808345a21f6$var$T = 5);
}
function $bfe34808345a21f6$var$Pk(a, b, c) {
    var d = $bfe34808345a21f6$var$C, e = $bfe34808345a21f6$var$ok.transition;
    try {
        $bfe34808345a21f6$var$ok.transition = null, $bfe34808345a21f6$var$C = 1, $bfe34808345a21f6$var$Wk(a, b, c, d);
    } finally{
        $bfe34808345a21f6$var$ok.transition = e, $bfe34808345a21f6$var$C = d;
    }
    return null;
}
function $bfe34808345a21f6$var$Wk(a, b, c, d) {
    do $bfe34808345a21f6$var$Hk();
    while (null !== $bfe34808345a21f6$var$wk);
    if (0 !== ($bfe34808345a21f6$var$K & 6)) throw Error($bfe34808345a21f6$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($bfe34808345a21f6$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $bfe34808345a21f6$var$Bc(a, f);
    a === $bfe34808345a21f6$var$Q && ($bfe34808345a21f6$var$Y = $bfe34808345a21f6$var$Q = null, $bfe34808345a21f6$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $bfe34808345a21f6$var$vk || ($bfe34808345a21f6$var$vk = !0, $bfe34808345a21f6$var$Fk($bfe34808345a21f6$var$hc, function() {
        $bfe34808345a21f6$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $bfe34808345a21f6$var$ok.transition;
        $bfe34808345a21f6$var$ok.transition = null;
        var g = $bfe34808345a21f6$var$C;
        $bfe34808345a21f6$var$C = 1;
        var h = $bfe34808345a21f6$var$K;
        $bfe34808345a21f6$var$K |= 4;
        $bfe34808345a21f6$var$nk.current = null;
        $bfe34808345a21f6$var$Oj(a, c);
        $bfe34808345a21f6$var$dk(c, a);
        $bfe34808345a21f6$var$Oe($bfe34808345a21f6$var$Df);
        $bfe34808345a21f6$var$dd = !!$bfe34808345a21f6$var$Cf;
        $bfe34808345a21f6$var$Df = $bfe34808345a21f6$var$Cf = null;
        a.current = c;
        $bfe34808345a21f6$var$hk(c, a, e);
        $bfe34808345a21f6$var$dc();
        $bfe34808345a21f6$var$K = h;
        $bfe34808345a21f6$var$C = g;
        $bfe34808345a21f6$var$ok.transition = f;
    } else a.current = c;
    $bfe34808345a21f6$var$vk && ($bfe34808345a21f6$var$vk = !1, $bfe34808345a21f6$var$wk = a, $bfe34808345a21f6$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($bfe34808345a21f6$var$Ri = null);
    $bfe34808345a21f6$var$mc(c.stateNode, d);
    $bfe34808345a21f6$var$Dk(a, $bfe34808345a21f6$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($bfe34808345a21f6$var$Oi) throw $bfe34808345a21f6$var$Oi = !1, a = $bfe34808345a21f6$var$Pi, $bfe34808345a21f6$var$Pi = null, a;
    0 !== ($bfe34808345a21f6$var$xk & 1) && 0 !== a.tag && $bfe34808345a21f6$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $bfe34808345a21f6$var$zk ? $bfe34808345a21f6$var$yk++ : ($bfe34808345a21f6$var$yk = 0, $bfe34808345a21f6$var$zk = a) : $bfe34808345a21f6$var$yk = 0;
    $bfe34808345a21f6$var$jg();
    return null;
}
function $bfe34808345a21f6$var$Hk() {
    if (null !== $bfe34808345a21f6$var$wk) {
        var a = $bfe34808345a21f6$var$Dc($bfe34808345a21f6$var$xk), b = $bfe34808345a21f6$var$ok.transition, c = $bfe34808345a21f6$var$C;
        try {
            $bfe34808345a21f6$var$ok.transition = null;
            $bfe34808345a21f6$var$C = 16 > a ? 16 : a;
            if (null === $bfe34808345a21f6$var$wk) var d = !1;
            else {
                a = $bfe34808345a21f6$var$wk;
                $bfe34808345a21f6$var$wk = null;
                $bfe34808345a21f6$var$xk = 0;
                if (0 !== ($bfe34808345a21f6$var$K & 6)) throw Error($bfe34808345a21f6$var$p(331));
                var e = $bfe34808345a21f6$var$K;
                $bfe34808345a21f6$var$K |= 4;
                for($bfe34808345a21f6$var$V = a.current; null !== $bfe34808345a21f6$var$V;){
                    var f = $bfe34808345a21f6$var$V, g = f.child;
                    if (0 !== ($bfe34808345a21f6$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($bfe34808345a21f6$var$V = l; null !== $bfe34808345a21f6$var$V;){
                                    var m = $bfe34808345a21f6$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $bfe34808345a21f6$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $bfe34808345a21f6$var$V = q;
                                    else for(; null !== $bfe34808345a21f6$var$V;){
                                        m = $bfe34808345a21f6$var$V;
                                        var r = m.sibling, y = m.return;
                                        $bfe34808345a21f6$var$Sj(m);
                                        if (m === l) {
                                            $bfe34808345a21f6$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $bfe34808345a21f6$var$V = r;
                                            break;
                                        }
                                        $bfe34808345a21f6$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $bfe34808345a21f6$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $bfe34808345a21f6$var$V = g;
                    else b: for(; null !== $bfe34808345a21f6$var$V;){
                        f = $bfe34808345a21f6$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $bfe34808345a21f6$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $bfe34808345a21f6$var$V = x;
                            break b;
                        }
                        $bfe34808345a21f6$var$V = f.return;
                    }
                }
                var w = a.current;
                for($bfe34808345a21f6$var$V = w; null !== $bfe34808345a21f6$var$V;){
                    g = $bfe34808345a21f6$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $bfe34808345a21f6$var$V = u;
                    else b: for(g = w; null !== $bfe34808345a21f6$var$V;){
                        h = $bfe34808345a21f6$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $bfe34808345a21f6$var$Qj(9, h);
                            }
                        } catch (na) {
                            $bfe34808345a21f6$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $bfe34808345a21f6$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $bfe34808345a21f6$var$V = F;
                            break b;
                        }
                        $bfe34808345a21f6$var$V = h.return;
                    }
                }
                $bfe34808345a21f6$var$K = e;
                $bfe34808345a21f6$var$jg();
                if ($bfe34808345a21f6$var$lc && "function" === typeof $bfe34808345a21f6$var$lc.onPostCommitFiberRoot) try {
                    $bfe34808345a21f6$var$lc.onPostCommitFiberRoot($bfe34808345a21f6$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $bfe34808345a21f6$var$C = c, $bfe34808345a21f6$var$ok.transition = b;
        }
    }
    return !1;
}
function $bfe34808345a21f6$var$Xk(a, b, c) {
    b = $bfe34808345a21f6$var$Ji(c, b);
    b = $bfe34808345a21f6$var$Ni(a, b, 1);
    a = $bfe34808345a21f6$var$nh(a, b, 1);
    b = $bfe34808345a21f6$var$R();
    null !== a && ($bfe34808345a21f6$var$Ac(a, 1, b), $bfe34808345a21f6$var$Dk(a, b));
}
function $bfe34808345a21f6$var$W(a, b, c) {
    if (3 === a.tag) $bfe34808345a21f6$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $bfe34808345a21f6$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $bfe34808345a21f6$var$Ri || !$bfe34808345a21f6$var$Ri.has(d))) {
                a = $bfe34808345a21f6$var$Ji(c, a);
                a = $bfe34808345a21f6$var$Qi(b, a, 1);
                b = $bfe34808345a21f6$var$nh(b, a, 1);
                a = $bfe34808345a21f6$var$R();
                null !== b && ($bfe34808345a21f6$var$Ac(b, 1, a), $bfe34808345a21f6$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $bfe34808345a21f6$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $bfe34808345a21f6$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $bfe34808345a21f6$var$Q === a && ($bfe34808345a21f6$var$Z & c) === c && (4 === $bfe34808345a21f6$var$T || 3 === $bfe34808345a21f6$var$T && ($bfe34808345a21f6$var$Z & 130023424) === $bfe34808345a21f6$var$Z && 500 > $bfe34808345a21f6$var$B() - $bfe34808345a21f6$var$fk ? $bfe34808345a21f6$var$Kk(a, 0) : $bfe34808345a21f6$var$rk |= c);
    $bfe34808345a21f6$var$Dk(a, b);
}
function $bfe34808345a21f6$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $bfe34808345a21f6$var$sc, $bfe34808345a21f6$var$sc <<= 1, 0 === ($bfe34808345a21f6$var$sc & 130023424) && ($bfe34808345a21f6$var$sc = 4194304)));
    var c = $bfe34808345a21f6$var$R();
    a = $bfe34808345a21f6$var$ih(a, b);
    null !== a && ($bfe34808345a21f6$var$Ac(a, b, c), $bfe34808345a21f6$var$Dk(a, c));
}
function $bfe34808345a21f6$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $bfe34808345a21f6$var$Yk(a, c);
}
function $bfe34808345a21f6$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($bfe34808345a21f6$var$p(314));
    }
    null !== d && d.delete(b);
    $bfe34808345a21f6$var$Yk(a, c);
}
var $bfe34808345a21f6$var$Vk;
$bfe34808345a21f6$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $bfe34808345a21f6$var$Wf.current) $bfe34808345a21f6$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $bfe34808345a21f6$var$dh = !1, $bfe34808345a21f6$var$yj(a, b, c);
            $bfe34808345a21f6$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $bfe34808345a21f6$var$dh = !1, $bfe34808345a21f6$var$I && 0 !== (b.flags & 1048576) && $bfe34808345a21f6$var$ug(b, $bfe34808345a21f6$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $bfe34808345a21f6$var$ij(a, b);
            a = b.pendingProps;
            var e = $bfe34808345a21f6$var$Yf(b, $bfe34808345a21f6$var$H.current);
            $bfe34808345a21f6$var$ch(b, c);
            e = $bfe34808345a21f6$var$Nh(null, b, d, a, e, c);
            var f = $bfe34808345a21f6$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $bfe34808345a21f6$var$Zf(d) ? (f = !0, $bfe34808345a21f6$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $bfe34808345a21f6$var$kh(b), e.updater = $bfe34808345a21f6$var$Ei, b.stateNode = e, e._reactInternals = b, $bfe34808345a21f6$var$Ii(b, d, a, c), b = $bfe34808345a21f6$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $bfe34808345a21f6$var$I && f && $bfe34808345a21f6$var$vg(b), $bfe34808345a21f6$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $bfe34808345a21f6$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $bfe34808345a21f6$var$Zk(d);
                a = $bfe34808345a21f6$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $bfe34808345a21f6$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $bfe34808345a21f6$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $bfe34808345a21f6$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $bfe34808345a21f6$var$$i(null, b, d, $bfe34808345a21f6$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($bfe34808345a21f6$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bfe34808345a21f6$var$Ci(d, e), $bfe34808345a21f6$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bfe34808345a21f6$var$Ci(d, e), $bfe34808345a21f6$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $bfe34808345a21f6$var$kj(b);
                if (null === a) throw Error($bfe34808345a21f6$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $bfe34808345a21f6$var$lh(a, b);
                $bfe34808345a21f6$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $bfe34808345a21f6$var$Ji(Error($bfe34808345a21f6$var$p(423)), b);
                        b = $bfe34808345a21f6$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $bfe34808345a21f6$var$Ji(Error($bfe34808345a21f6$var$p(424)), b);
                        b = $bfe34808345a21f6$var$lj(a, b, d, c, e);
                        break a;
                    } else for($bfe34808345a21f6$var$yg = $bfe34808345a21f6$var$Lf(b.stateNode.containerInfo.firstChild), $bfe34808345a21f6$var$xg = b, $bfe34808345a21f6$var$I = !0, $bfe34808345a21f6$var$zg = null, c = $bfe34808345a21f6$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $bfe34808345a21f6$var$Ig();
                    if (d === e) {
                        b = $bfe34808345a21f6$var$Zi(a, b, c);
                        break a;
                    }
                    $bfe34808345a21f6$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $bfe34808345a21f6$var$Ah(b), null === a && $bfe34808345a21f6$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $bfe34808345a21f6$var$Ef(d, e) ? g = null : null !== f && $bfe34808345a21f6$var$Ef(d, f) && (b.flags |= 32), $bfe34808345a21f6$var$gj(a, b), $bfe34808345a21f6$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $bfe34808345a21f6$var$Eg(b), null;
        case 13:
            return $bfe34808345a21f6$var$oj(a, b, c);
        case 4:
            return $bfe34808345a21f6$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $bfe34808345a21f6$var$Ug(b, null, d, c) : $bfe34808345a21f6$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bfe34808345a21f6$var$Ci(d, e), $bfe34808345a21f6$var$Yi(a, b, d, e, c);
        case 7:
            return $bfe34808345a21f6$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $bfe34808345a21f6$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $bfe34808345a21f6$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $bfe34808345a21f6$var$G($bfe34808345a21f6$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($bfe34808345a21f6$var$He(f.value, g)) {
                        if (f.children === e.children && !$bfe34808345a21f6$var$Wf.current) {
                            b = $bfe34808345a21f6$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $bfe34808345a21f6$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $bfe34808345a21f6$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($bfe34808345a21f6$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $bfe34808345a21f6$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $bfe34808345a21f6$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $bfe34808345a21f6$var$ch(b, c), e = $bfe34808345a21f6$var$eh(e), d = d(e), b.flags |= 1, $bfe34808345a21f6$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $bfe34808345a21f6$var$Ci(d, b.pendingProps), e = $bfe34808345a21f6$var$Ci(d.type, e), $bfe34808345a21f6$var$$i(a, b, d, e, c);
        case 15:
            return $bfe34808345a21f6$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bfe34808345a21f6$var$Ci(d, e), $bfe34808345a21f6$var$ij(a, b), b.tag = 1, $bfe34808345a21f6$var$Zf(d) ? (a = !0, $bfe34808345a21f6$var$cg(b)) : a = !1, $bfe34808345a21f6$var$ch(b, c), $bfe34808345a21f6$var$Gi(b, d, e), $bfe34808345a21f6$var$Ii(b, d, e, c), $bfe34808345a21f6$var$jj(null, b, d, !0, a, c);
        case 19:
            return $bfe34808345a21f6$var$xj(a, b, c);
        case 22:
            return $bfe34808345a21f6$var$dj(a, b, c);
    }
    throw Error($bfe34808345a21f6$var$p(156, b.tag));
};
function $bfe34808345a21f6$var$Fk(a, b) {
    return $bfe34808345a21f6$var$ac(a, b);
}
function $bfe34808345a21f6$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bfe34808345a21f6$var$Bg(a, b, c, d) {
    return new $bfe34808345a21f6$var$$k(a, b, c, d);
}
function $bfe34808345a21f6$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $bfe34808345a21f6$var$Zk(a) {
    if ("function" === typeof a) return $bfe34808345a21f6$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $bfe34808345a21f6$var$Da) return 11;
        if (a === $bfe34808345a21f6$var$Ga) return 14;
    }
    return 2;
}
function $bfe34808345a21f6$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $bfe34808345a21f6$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $bfe34808345a21f6$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $bfe34808345a21f6$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $bfe34808345a21f6$var$ya:
            return $bfe34808345a21f6$var$Tg(c.children, e, f, b);
        case $bfe34808345a21f6$var$za:
            g = 8;
            e |= 8;
            break;
        case $bfe34808345a21f6$var$Aa:
            return a = $bfe34808345a21f6$var$Bg(12, c, b, e | 2), a.elementType = $bfe34808345a21f6$var$Aa, a.lanes = f, a;
        case $bfe34808345a21f6$var$Ea:
            return a = $bfe34808345a21f6$var$Bg(13, c, b, e), a.elementType = $bfe34808345a21f6$var$Ea, a.lanes = f, a;
        case $bfe34808345a21f6$var$Fa:
            return a = $bfe34808345a21f6$var$Bg(19, c, b, e), a.elementType = $bfe34808345a21f6$var$Fa, a.lanes = f, a;
        case $bfe34808345a21f6$var$Ia:
            return $bfe34808345a21f6$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $bfe34808345a21f6$var$Ba:
                    g = 10;
                    break a;
                case $bfe34808345a21f6$var$Ca:
                    g = 9;
                    break a;
                case $bfe34808345a21f6$var$Da:
                    g = 11;
                    break a;
                case $bfe34808345a21f6$var$Ga:
                    g = 14;
                    break a;
                case $bfe34808345a21f6$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($bfe34808345a21f6$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $bfe34808345a21f6$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $bfe34808345a21f6$var$Tg(a, b, c, d) {
    a = $bfe34808345a21f6$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $bfe34808345a21f6$var$pj(a, b, c, d) {
    a = $bfe34808345a21f6$var$Bg(22, a, d, b);
    a.elementType = $bfe34808345a21f6$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $bfe34808345a21f6$var$Qg(a, b, c) {
    a = $bfe34808345a21f6$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $bfe34808345a21f6$var$Sg(a, b, c) {
    b = $bfe34808345a21f6$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $bfe34808345a21f6$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $bfe34808345a21f6$var$zc(0);
    this.expirationTimes = $bfe34808345a21f6$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bfe34808345a21f6$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $bfe34808345a21f6$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $bfe34808345a21f6$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $bfe34808345a21f6$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $bfe34808345a21f6$var$kh(f);
    return a;
}
function $bfe34808345a21f6$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bfe34808345a21f6$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $bfe34808345a21f6$var$dl(a) {
    if (!a) return $bfe34808345a21f6$var$Vf;
    a = a._reactInternals;
    a: {
        if ($bfe34808345a21f6$var$Vb(a) !== a || 1 !== a.tag) throw Error($bfe34808345a21f6$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($bfe34808345a21f6$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($bfe34808345a21f6$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($bfe34808345a21f6$var$Zf(c)) return $bfe34808345a21f6$var$bg(a, c, b);
    }
    return b;
}
function $bfe34808345a21f6$var$el(a, b, c, d, e, f, g, h, k) {
    a = $bfe34808345a21f6$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $bfe34808345a21f6$var$dl(null);
    c = a.current;
    d = $bfe34808345a21f6$var$R();
    e = $bfe34808345a21f6$var$yi(c);
    f = $bfe34808345a21f6$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $bfe34808345a21f6$var$nh(c, f, e);
    a.current.lanes = e;
    $bfe34808345a21f6$var$Ac(a, e, d);
    $bfe34808345a21f6$var$Dk(a, d);
    return a;
}
function $bfe34808345a21f6$var$fl(a, b, c, d) {
    var e = b.current, f = $bfe34808345a21f6$var$R(), g = $bfe34808345a21f6$var$yi(e);
    c = $bfe34808345a21f6$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $bfe34808345a21f6$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $bfe34808345a21f6$var$nh(e, b, g);
    null !== a && ($bfe34808345a21f6$var$gi(a, e, g, f), $bfe34808345a21f6$var$oh(a, e, g));
    return g;
}
function $bfe34808345a21f6$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $bfe34808345a21f6$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $bfe34808345a21f6$var$il(a, b) {
    $bfe34808345a21f6$var$hl(a, b);
    (a = a.alternate) && $bfe34808345a21f6$var$hl(a, b);
}
function $bfe34808345a21f6$var$jl() {
    return null;
}
var $bfe34808345a21f6$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $bfe34808345a21f6$var$ll(a) {
    this._internalRoot = a;
}
$bfe34808345a21f6$var$ml.prototype.render = $bfe34808345a21f6$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($bfe34808345a21f6$var$p(409));
    $bfe34808345a21f6$var$fl(a, b, null, null);
};
$bfe34808345a21f6$var$ml.prototype.unmount = $bfe34808345a21f6$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $bfe34808345a21f6$var$Rk(function() {
            $bfe34808345a21f6$var$fl(null, a, null, null);
        });
        b[$bfe34808345a21f6$var$uf] = null;
    }
};
function $bfe34808345a21f6$var$ml(a) {
    this._internalRoot = a;
}
$bfe34808345a21f6$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $bfe34808345a21f6$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $bfe34808345a21f6$var$Qc.length && 0 !== b && b < $bfe34808345a21f6$var$Qc[c].priority; c++);
        $bfe34808345a21f6$var$Qc.splice(c, 0, a);
        0 === c && $bfe34808345a21f6$var$Vc(a);
    }
};
function $bfe34808345a21f6$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $bfe34808345a21f6$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $bfe34808345a21f6$var$pl() {}
function $bfe34808345a21f6$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $bfe34808345a21f6$var$gl(g);
                f.call(a);
            };
        }
        var g = $bfe34808345a21f6$var$el(b, d, a, 0, null, !1, !1, "", $bfe34808345a21f6$var$pl);
        a._reactRootContainer = g;
        a[$bfe34808345a21f6$var$uf] = g.current;
        $bfe34808345a21f6$var$sf(8 === a.nodeType ? a.parentNode : a);
        $bfe34808345a21f6$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $bfe34808345a21f6$var$gl(k);
            h.call(a);
        };
    }
    var k = $bfe34808345a21f6$var$bl(a, 0, !1, null, null, !1, !1, "", $bfe34808345a21f6$var$pl);
    a._reactRootContainer = k;
    a[$bfe34808345a21f6$var$uf] = k.current;
    $bfe34808345a21f6$var$sf(8 === a.nodeType ? a.parentNode : a);
    $bfe34808345a21f6$var$Rk(function() {
        $bfe34808345a21f6$var$fl(b, k, c, d);
    });
    return k;
}
function $bfe34808345a21f6$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $bfe34808345a21f6$var$gl(g);
                h.call(a);
            };
        }
        $bfe34808345a21f6$var$fl(b, g, a, e);
    } else g = $bfe34808345a21f6$var$ql(c, b, a, e, d);
    return $bfe34808345a21f6$var$gl(g);
}
$bfe34808345a21f6$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $bfe34808345a21f6$var$tc(b.pendingLanes);
                0 !== c && ($bfe34808345a21f6$var$Cc(b, c | 1), $bfe34808345a21f6$var$Dk(b, $bfe34808345a21f6$var$B()), 0 === ($bfe34808345a21f6$var$K & 6) && ($bfe34808345a21f6$var$Gj = $bfe34808345a21f6$var$B() + 500, $bfe34808345a21f6$var$jg()));
            }
            break;
        case 13:
            $bfe34808345a21f6$var$Rk(function() {
                var b = $bfe34808345a21f6$var$ih(a, 1);
                if (null !== b) {
                    var c = $bfe34808345a21f6$var$R();
                    $bfe34808345a21f6$var$gi(b, a, 1, c);
                }
            }), $bfe34808345a21f6$var$il(a, 1);
    }
};
$bfe34808345a21f6$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $bfe34808345a21f6$var$ih(a, 134217728);
        if (null !== b) {
            var c = $bfe34808345a21f6$var$R();
            $bfe34808345a21f6$var$gi(b, a, 134217728, c);
        }
        $bfe34808345a21f6$var$il(a, 134217728);
    }
};
$bfe34808345a21f6$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $bfe34808345a21f6$var$yi(a), c = $bfe34808345a21f6$var$ih(a, b);
        if (null !== c) {
            var d = $bfe34808345a21f6$var$R();
            $bfe34808345a21f6$var$gi(c, a, b, d);
        }
        $bfe34808345a21f6$var$il(a, b);
    }
};
$bfe34808345a21f6$var$Hc = function() {
    return $bfe34808345a21f6$var$C;
};
$bfe34808345a21f6$var$Ic = function(a, b) {
    var c = $bfe34808345a21f6$var$C;
    try {
        return $bfe34808345a21f6$var$C = a, b();
    } finally{
        $bfe34808345a21f6$var$C = c;
    }
};
$bfe34808345a21f6$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $bfe34808345a21f6$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $bfe34808345a21f6$var$Db(d);
                        if (!e) throw Error($bfe34808345a21f6$var$p(90));
                        $bfe34808345a21f6$var$Wa(d);
                        $bfe34808345a21f6$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $bfe34808345a21f6$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $bfe34808345a21f6$var$fb(a, !!c.multiple, b, !1);
    }
};
$bfe34808345a21f6$var$Gb = $bfe34808345a21f6$var$Qk;
$bfe34808345a21f6$var$Hb = $bfe34808345a21f6$var$Rk;
var $bfe34808345a21f6$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $bfe34808345a21f6$var$Cb,
        $bfe34808345a21f6$var$ue,
        $bfe34808345a21f6$var$Db,
        $bfe34808345a21f6$var$Eb,
        $bfe34808345a21f6$var$Fb,
        $bfe34808345a21f6$var$Qk
    ]
}, $bfe34808345a21f6$var$tl = {
    findFiberByHostInstance: $bfe34808345a21f6$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $bfe34808345a21f6$var$ul = {
    bundleType: $bfe34808345a21f6$var$tl.bundleType,
    version: $bfe34808345a21f6$var$tl.version,
    rendererPackageName: $bfe34808345a21f6$var$tl.rendererPackageName,
    rendererConfig: $bfe34808345a21f6$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $bfe34808345a21f6$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $bfe34808345a21f6$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $bfe34808345a21f6$var$tl.findFiberByHostInstance || $bfe34808345a21f6$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bfe34808345a21f6$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bfe34808345a21f6$var$vl.isDisabled && $bfe34808345a21f6$var$vl.supportsFiber) try {
        $bfe34808345a21f6$var$kc = $bfe34808345a21f6$var$vl.inject($bfe34808345a21f6$var$ul), $bfe34808345a21f6$var$lc = $bfe34808345a21f6$var$vl;
    } catch (a) {}
}
$bfe34808345a21f6$export$ae55be85d98224ed = $bfe34808345a21f6$var$sl;
$bfe34808345a21f6$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$bfe34808345a21f6$var$nl(b)) throw Error($bfe34808345a21f6$var$p(200));
    return $bfe34808345a21f6$var$cl(a, b, null, c);
};
$bfe34808345a21f6$export$882461b6382ed46c = function(a, b) {
    if (!$bfe34808345a21f6$var$nl(a)) throw Error($bfe34808345a21f6$var$p(299));
    var c = !1, d = "", e = $bfe34808345a21f6$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $bfe34808345a21f6$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$bfe34808345a21f6$var$uf] = b.current;
    $bfe34808345a21f6$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $bfe34808345a21f6$var$ll(b);
};
$bfe34808345a21f6$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($bfe34808345a21f6$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($bfe34808345a21f6$var$p(268, a));
    }
    a = $bfe34808345a21f6$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$bfe34808345a21f6$export$cd75ccfd720a3cd4 = function(a) {
    return $bfe34808345a21f6$var$Rk(a);
};
$bfe34808345a21f6$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$bfe34808345a21f6$var$ol(b)) throw Error($bfe34808345a21f6$var$p(200));
    return $bfe34808345a21f6$var$rl(null, a, b, !0, c);
};
$bfe34808345a21f6$export$757ceba2d55c277e = function(a, b, c) {
    if (!$bfe34808345a21f6$var$nl(a)) throw Error($bfe34808345a21f6$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $bfe34808345a21f6$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $bfe34808345a21f6$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$bfe34808345a21f6$var$uf] = b.current;
    $bfe34808345a21f6$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $bfe34808345a21f6$var$ml(b);
};
$bfe34808345a21f6$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$bfe34808345a21f6$var$ol(b)) throw Error($bfe34808345a21f6$var$p(200));
    return $bfe34808345a21f6$var$rl(null, a, b, !1, c);
};
$bfe34808345a21f6$export$502457920280e6be = function(a) {
    if (!$bfe34808345a21f6$var$ol(a)) throw Error($bfe34808345a21f6$var$p(40));
    return a._reactRootContainer ? ($bfe34808345a21f6$var$Rk(function() {
        $bfe34808345a21f6$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$bfe34808345a21f6$var$uf] = null;
        });
    }), !0) : !1;
};
$bfe34808345a21f6$export$c78a37762a8d58e1 = $bfe34808345a21f6$var$Qk;
$bfe34808345a21f6$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$bfe34808345a21f6$var$ol(c)) throw Error($bfe34808345a21f6$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($bfe34808345a21f6$var$p(38));
    return $bfe34808345a21f6$var$rl(a, b, c, !1, d);
};
$bfe34808345a21f6$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("2N9BZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3BWO3"));

});
parcelRegister("3BWO3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $2a12718006643ff9$export$c4744153514ff05d; }, function (v) { return $2a12718006643ff9$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $2a12718006643ff9$export$3e506c1ccc9cc1a7; }, function (v) { return $2a12718006643ff9$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $2a12718006643ff9$export$e26fe2ed2fa76875; }, function (v) { return $2a12718006643ff9$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $2a12718006643ff9$export$502329bbf4b505b1; }, function (v) { return $2a12718006643ff9$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $2a12718006643ff9$export$6e3807111c4874c4; }, function (v) { return $2a12718006643ff9$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $2a12718006643ff9$export$c27134553091fb3a; }, function (v) { return $2a12718006643ff9$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $2a12718006643ff9$export$33ee1acdc04fd2a2; }, function (v) { return $2a12718006643ff9$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $2a12718006643ff9$export$b00a404bbd5edef2; }, function (v) { return $2a12718006643ff9$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $2a12718006643ff9$export$8352ce38b91d0c62; }, function (v) { return $2a12718006643ff9$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $2a12718006643ff9$export$d66a1c1c77bd778b; }, function (v) { return $2a12718006643ff9$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $2a12718006643ff9$export$d3dfb8e4810cb555; }, function (v) { return $2a12718006643ff9$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $2a12718006643ff9$export$839f9183b0465a69; }, function (v) { return $2a12718006643ff9$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $2a12718006643ff9$export$72fdf0e06517287b; }, function (v) { return $2a12718006643ff9$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $2a12718006643ff9$export$4b844e58a3e414b4; }, function (v) { return $2a12718006643ff9$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $2a12718006643ff9$export$816d2913ae6b83b1; }, function (v) { return $2a12718006643ff9$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $2a12718006643ff9$export$61bcfe829111a1d0; }, function (v) { return $2a12718006643ff9$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $2a12718006643ff9$export$7ee8c9beb337bc3f; }, function (v) { return $2a12718006643ff9$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $2a12718006643ff9$export$b5836b71941fa3ed; }, function (v) { return $2a12718006643ff9$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $2a12718006643ff9$export$cf845f2c119da08a; }, function (v) { return $2a12718006643ff9$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2a12718006643ff9$export$c4744153514ff05d;
var $2a12718006643ff9$export$3e506c1ccc9cc1a7;
var $2a12718006643ff9$export$e26fe2ed2fa76875;
var $2a12718006643ff9$export$502329bbf4b505b1;
var $2a12718006643ff9$export$6e3807111c4874c4;
var $2a12718006643ff9$export$c27134553091fb3a;
var $2a12718006643ff9$export$33ee1acdc04fd2a2;
var $2a12718006643ff9$export$b00a404bbd5edef2;
var $2a12718006643ff9$export$8352ce38b91d0c62;
var $2a12718006643ff9$export$d66a1c1c77bd778b;
var $2a12718006643ff9$export$d3dfb8e4810cb555;
var $2a12718006643ff9$export$839f9183b0465a69;
var $2a12718006643ff9$export$72fdf0e06517287b;
var $2a12718006643ff9$export$4b844e58a3e414b4;
var $2a12718006643ff9$export$816d2913ae6b83b1;
var $2a12718006643ff9$export$61bcfe829111a1d0;
var $2a12718006643ff9$export$7ee8c9beb337bc3f;
var $2a12718006643ff9$export$b5836b71941fa3ed;
var $2a12718006643ff9$export$cf845f2c119da08a;
"use strict";
function $2a12718006643ff9$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $2a12718006643ff9$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $2a12718006643ff9$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $2a12718006643ff9$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $2a12718006643ff9$var$g(C, c)) n < e && 0 > $2a12718006643ff9$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $2a12718006643ff9$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $2a12718006643ff9$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $2a12718006643ff9$var$l = performance;
    $2a12718006643ff9$export$c4744153514ff05d = function() {
        return $2a12718006643ff9$var$l.now();
    };
} else {
    var $2a12718006643ff9$var$p = Date, $2a12718006643ff9$var$q = $2a12718006643ff9$var$p.now();
    $2a12718006643ff9$export$c4744153514ff05d = function() {
        return $2a12718006643ff9$var$p.now() - $2a12718006643ff9$var$q;
    };
}
var $2a12718006643ff9$var$r = [], $2a12718006643ff9$var$t = [], $2a12718006643ff9$var$u = 1, $2a12718006643ff9$var$v = null, $2a12718006643ff9$var$y = 3, $2a12718006643ff9$var$z = !1, $2a12718006643ff9$var$A = !1, $2a12718006643ff9$var$B = !1, $2a12718006643ff9$var$D = "function" === typeof setTimeout ? setTimeout : null, $2a12718006643ff9$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $2a12718006643ff9$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $2a12718006643ff9$var$G(a) {
    for(var b = $2a12718006643ff9$var$h($2a12718006643ff9$var$t); null !== b;){
        if (null === b.callback) $2a12718006643ff9$var$k($2a12718006643ff9$var$t);
        else if (b.startTime <= a) $2a12718006643ff9$var$k($2a12718006643ff9$var$t), b.sortIndex = b.expirationTime, $2a12718006643ff9$var$f($2a12718006643ff9$var$r, b);
        else break;
        b = $2a12718006643ff9$var$h($2a12718006643ff9$var$t);
    }
}
function $2a12718006643ff9$var$H(a) {
    $2a12718006643ff9$var$B = !1;
    $2a12718006643ff9$var$G(a);
    if (!$2a12718006643ff9$var$A) {
        if (null !== $2a12718006643ff9$var$h($2a12718006643ff9$var$r)) $2a12718006643ff9$var$A = !0, $2a12718006643ff9$var$I($2a12718006643ff9$var$J);
        else {
            var b = $2a12718006643ff9$var$h($2a12718006643ff9$var$t);
            null !== b && $2a12718006643ff9$var$K($2a12718006643ff9$var$H, b.startTime - a);
        }
    }
}
function $2a12718006643ff9$var$J(a, b) {
    $2a12718006643ff9$var$A = !1;
    $2a12718006643ff9$var$B && ($2a12718006643ff9$var$B = !1, $2a12718006643ff9$var$E($2a12718006643ff9$var$L), $2a12718006643ff9$var$L = -1);
    $2a12718006643ff9$var$z = !0;
    var c = $2a12718006643ff9$var$y;
    try {
        $2a12718006643ff9$var$G(b);
        for($2a12718006643ff9$var$v = $2a12718006643ff9$var$h($2a12718006643ff9$var$r); null !== $2a12718006643ff9$var$v && (!($2a12718006643ff9$var$v.expirationTime > b) || a && !$2a12718006643ff9$var$M());){
            var d = $2a12718006643ff9$var$v.callback;
            if ("function" === typeof d) {
                $2a12718006643ff9$var$v.callback = null;
                $2a12718006643ff9$var$y = $2a12718006643ff9$var$v.priorityLevel;
                var e = d($2a12718006643ff9$var$v.expirationTime <= b);
                b = $2a12718006643ff9$export$c4744153514ff05d();
                "function" === typeof e ? $2a12718006643ff9$var$v.callback = e : $2a12718006643ff9$var$v === $2a12718006643ff9$var$h($2a12718006643ff9$var$r) && $2a12718006643ff9$var$k($2a12718006643ff9$var$r);
                $2a12718006643ff9$var$G(b);
            } else $2a12718006643ff9$var$k($2a12718006643ff9$var$r);
            $2a12718006643ff9$var$v = $2a12718006643ff9$var$h($2a12718006643ff9$var$r);
        }
        if (null !== $2a12718006643ff9$var$v) var w = !0;
        else {
            var m = $2a12718006643ff9$var$h($2a12718006643ff9$var$t);
            null !== m && $2a12718006643ff9$var$K($2a12718006643ff9$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $2a12718006643ff9$var$v = null, $2a12718006643ff9$var$y = c, $2a12718006643ff9$var$z = !1;
    }
}
var $2a12718006643ff9$var$N = !1, $2a12718006643ff9$var$O = null, $2a12718006643ff9$var$L = -1, $2a12718006643ff9$var$P = 5, $2a12718006643ff9$var$Q = -1;
function $2a12718006643ff9$var$M() {
    return $2a12718006643ff9$export$c4744153514ff05d() - $2a12718006643ff9$var$Q < $2a12718006643ff9$var$P ? !1 : !0;
}
function $2a12718006643ff9$var$R() {
    if (null !== $2a12718006643ff9$var$O) {
        var a = $2a12718006643ff9$export$c4744153514ff05d();
        $2a12718006643ff9$var$Q = a;
        var b = !0;
        try {
            b = $2a12718006643ff9$var$O(!0, a);
        } finally{
            b ? $2a12718006643ff9$var$S() : ($2a12718006643ff9$var$N = !1, $2a12718006643ff9$var$O = null);
        }
    } else $2a12718006643ff9$var$N = !1;
}
var $2a12718006643ff9$var$S;
if ("function" === typeof $2a12718006643ff9$var$F) $2a12718006643ff9$var$S = function() {
    $2a12718006643ff9$var$F($2a12718006643ff9$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2a12718006643ff9$var$T = new MessageChannel, $2a12718006643ff9$var$U = $2a12718006643ff9$var$T.port2;
    $2a12718006643ff9$var$T.port1.onmessage = $2a12718006643ff9$var$R;
    $2a12718006643ff9$var$S = function() {
        $2a12718006643ff9$var$U.postMessage(null);
    };
} else $2a12718006643ff9$var$S = function() {
    $2a12718006643ff9$var$D($2a12718006643ff9$var$R, 0);
};
function $2a12718006643ff9$var$I(a) {
    $2a12718006643ff9$var$O = a;
    $2a12718006643ff9$var$N || ($2a12718006643ff9$var$N = !0, $2a12718006643ff9$var$S());
}
function $2a12718006643ff9$var$K(a, b) {
    $2a12718006643ff9$var$L = $2a12718006643ff9$var$D(function() {
        a($2a12718006643ff9$export$c4744153514ff05d());
    }, b);
}
$2a12718006643ff9$export$3e506c1ccc9cc1a7 = 5;
$2a12718006643ff9$export$e26fe2ed2fa76875 = 1;
$2a12718006643ff9$export$502329bbf4b505b1 = 4;
$2a12718006643ff9$export$6e3807111c4874c4 = 3;
$2a12718006643ff9$export$c27134553091fb3a = null;
$2a12718006643ff9$export$33ee1acdc04fd2a2 = 2;
$2a12718006643ff9$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$2a12718006643ff9$export$8352ce38b91d0c62 = function() {
    $2a12718006643ff9$var$A || $2a12718006643ff9$var$z || ($2a12718006643ff9$var$A = !0, $2a12718006643ff9$var$I($2a12718006643ff9$var$J));
};
$2a12718006643ff9$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2a12718006643ff9$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$2a12718006643ff9$export$d3dfb8e4810cb555 = function() {
    return $2a12718006643ff9$var$y;
};
$2a12718006643ff9$export$839f9183b0465a69 = function() {
    return $2a12718006643ff9$var$h($2a12718006643ff9$var$r);
};
$2a12718006643ff9$export$72fdf0e06517287b = function(a) {
    switch($2a12718006643ff9$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $2a12718006643ff9$var$y;
    }
    var c = $2a12718006643ff9$var$y;
    $2a12718006643ff9$var$y = b;
    try {
        return a();
    } finally{
        $2a12718006643ff9$var$y = c;
    }
};
$2a12718006643ff9$export$4b844e58a3e414b4 = function() {};
$2a12718006643ff9$export$816d2913ae6b83b1 = function() {};
$2a12718006643ff9$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $2a12718006643ff9$var$y;
    $2a12718006643ff9$var$y = a;
    try {
        return b();
    } finally{
        $2a12718006643ff9$var$y = c;
    }
};
$2a12718006643ff9$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $2a12718006643ff9$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $2a12718006643ff9$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $2a12718006643ff9$var$f($2a12718006643ff9$var$t, a), null === $2a12718006643ff9$var$h($2a12718006643ff9$var$r) && a === $2a12718006643ff9$var$h($2a12718006643ff9$var$t) && ($2a12718006643ff9$var$B ? ($2a12718006643ff9$var$E($2a12718006643ff9$var$L), $2a12718006643ff9$var$L = -1) : $2a12718006643ff9$var$B = !0, $2a12718006643ff9$var$K($2a12718006643ff9$var$H, c - d))) : (a.sortIndex = e, $2a12718006643ff9$var$f($2a12718006643ff9$var$r, a), $2a12718006643ff9$var$A || $2a12718006643ff9$var$z || ($2a12718006643ff9$var$A = !0, $2a12718006643ff9$var$I($2a12718006643ff9$var$J)));
    return a;
};
$2a12718006643ff9$export$b5836b71941fa3ed = $2a12718006643ff9$var$M;
$2a12718006643ff9$export$cf845f2c119da08a = function(a) {
    var b = $2a12718006643ff9$var$y;
    return function() {
        var c = $2a12718006643ff9$var$y;
        $2a12718006643ff9$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $2a12718006643ff9$var$y = c;
        }
    };
};

});




parcelRegister("d8hWe", function(module, exports) {

$parcel$export(module.exports, "$mobx", function () { return $mobx; });
$parcel$export(module.exports, "createAtom", function () { return createAtom; });
$parcel$export(module.exports, "onBecomeUnobserved", function () { return onBecomeUnobserved; });
$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isAction", function () { return isAction; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "ObservableMap", function () { return ObservableMap; });
$parcel$export(module.exports, "extendObservable", function () { return extendObservable; });
$parcel$export(module.exports, "_allowStateReadsStart", function () { return allowStateReadsStart; });
$parcel$export(module.exports, "_allowStateReadsEnd", function () { return allowStateReadsEnd; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "autorun", function () { return autorun; });
$parcel$export(module.exports, "_isComputingDerivation", function () { return isComputingDerivation; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "getAtom", function () { return getAtom; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "_getAdministration", function () { return getAdministration; });
$parcel$export(module.exports, "isComputed", function () { return isComputed; });
$parcel$export(module.exports, "isComputedProp", function () { return isComputedProp; });
$parcel$export(module.exports, "keys", function () { return keys; });
$parcel$export(module.exports, "values", function () { return values; });
$parcel$export(module.exports, "entries", function () { return entries; });
$parcel$export(module.exports, "observe", function () { return observe; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "transaction", function () { return transaction; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("dBifK", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("hiuv4", function(module, exports) {

$parcel$export(module.exports, "SuperJSON", function () { return SuperJSON; });
$parcel$export(module.exports, "default", function () { return $c97bc6cf74a52551$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "serialize", function () { return serialize; });
$parcel$export(module.exports, "deserialize", function () { return deserialize; });
$parcel$export(module.exports, "stringify", function () { return stringify; });
$parcel$export(module.exports, "parse", function () { return parse; });
$parcel$export(module.exports, "registerClass", function () { return registerClass; });
$parcel$export(module.exports, "registerCustom", function () { return registerCustom; });
$parcel$export(module.exports, "registerSymbol", function () { return registerSymbol; });
$parcel$export(module.exports, "allowErrorProps", function () { return allowErrorProps; });

var $2ThsW = parcelRequire("2ThsW");

var $1FyJp = parcelRequire("1FyJp");

var $fAfAm = parcelRequire("fAfAm");

var $ehEsg = parcelRequire("ehEsg");

var $a8IkQ = parcelRequire("a8IkQ");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var SuperJSON = /** @class */ function() {
    /**
     * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
     */ function SuperJSON(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.dedupe, dedupe = _c === void 0 ? false : _c;
        this.classRegistry = new (0, $2ThsW.ClassRegistry)();
        this.symbolRegistry = new (0, $1FyJp.Registry)(function(s) {
            var _a;
            return (_a = s.description) !== null && _a !== void 0 ? _a : "";
        });
        this.customTransformerRegistry = new (0, $fAfAm.CustomTransformerRegistry)();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    SuperJSON.prototype.serialize = function(object) {
        var identities = new Map();
        var output = (0, $ehEsg.walker)(object, identities, this, this.dedupe);
        var res = {
            json: output.transformedValue
        };
        if (output.annotations) res.meta = __assign(__assign({}, res.meta), {
            values: output.annotations
        });
        var equalityAnnotations = (0, $ehEsg.generateReferentialEqualityAnnotations)(identities, this.dedupe);
        if (equalityAnnotations) res.meta = __assign(__assign({}, res.meta), {
            referentialEqualities: equalityAnnotations
        });
        return res;
    };
    SuperJSON.prototype.deserialize = function(payload) {
        var json = payload.json, meta = payload.meta;
        var result = (0, $a8IkQ.copy)(json);
        if (meta === null || meta === void 0 ? void 0 : meta.values) result = (0, $ehEsg.applyValueAnnotations)(result, meta.values, this);
        if (meta === null || meta === void 0 ? void 0 : meta.referentialEqualities) result = (0, $ehEsg.applyReferentialEqualityAnnotations)(result, meta.referentialEqualities);
        return result;
    };
    SuperJSON.prototype.stringify = function(object) {
        return JSON.stringify(this.serialize(object));
    };
    SuperJSON.prototype.parse = function(string) {
        return this.deserialize(JSON.parse(string));
    };
    SuperJSON.prototype.registerClass = function(v, options) {
        this.classRegistry.register(v, options);
    };
    SuperJSON.prototype.registerSymbol = function(v, identifier) {
        this.symbolRegistry.register(v, identifier);
    };
    SuperJSON.prototype.registerCustom = function(transformer, name) {
        this.customTransformerRegistry.register(__assign({
            name: name
        }, transformer));
    };
    SuperJSON.prototype.allowErrorProps = function() {
        var _a;
        var props = [];
        for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
        (_a = this.allowedErrorProps).push.apply(_a, __spreadArray([], __read(props)));
    };
    SuperJSON.defaultInstance = new SuperJSON();
    SuperJSON.serialize = SuperJSON.defaultInstance.serialize.bind(SuperJSON.defaultInstance);
    SuperJSON.deserialize = SuperJSON.defaultInstance.deserialize.bind(SuperJSON.defaultInstance);
    SuperJSON.stringify = SuperJSON.defaultInstance.stringify.bind(SuperJSON.defaultInstance);
    SuperJSON.parse = SuperJSON.defaultInstance.parse.bind(SuperJSON.defaultInstance);
    SuperJSON.registerClass = SuperJSON.defaultInstance.registerClass.bind(SuperJSON.defaultInstance);
    SuperJSON.registerSymbol = SuperJSON.defaultInstance.registerSymbol.bind(SuperJSON.defaultInstance);
    SuperJSON.registerCustom = SuperJSON.defaultInstance.registerCustom.bind(SuperJSON.defaultInstance);
    SuperJSON.allowErrorProps = SuperJSON.defaultInstance.allowErrorProps.bind(SuperJSON.defaultInstance);
    return SuperJSON;
}();
var $c97bc6cf74a52551$export$2e2bcd8739ae039 = SuperJSON;
var serialize = SuperJSON.serialize;
var deserialize = SuperJSON.deserialize;
var stringify = SuperJSON.stringify;
var parse = SuperJSON.parse;
var registerClass = SuperJSON.registerClass;
var registerCustom = SuperJSON.registerCustom;
var registerSymbol = SuperJSON.registerSymbol;
var allowErrorProps = SuperJSON.allowErrorProps;

});
parcelRegister("2ThsW", function(module, exports) {

$parcel$export(module.exports, "ClassRegistry", function () { return $21ae442de648cfcb$export$52adb1dcdecb659b; });

var $1FyJp = parcelRequire("1FyJp");
var $21ae442de648cfcb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $21ae442de648cfcb$export$52adb1dcdecb659b = /** @class */ function(_super) {
    $21ae442de648cfcb$var$__extends(ClassRegistry, _super);
    function ClassRegistry() {
        var _this = _super.call(this, function(c) {
            return c.name;
        }) || this;
        _this.classToAllowedProps = new Map();
        return _this;
    }
    ClassRegistry.prototype.register = function(value, options) {
        if (typeof options === "object") {
            if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
            _super.prototype.register.call(this, value, options.identifier);
        } else _super.prototype.register.call(this, value, options);
    };
    ClassRegistry.prototype.getAllowedProps = function(value) {
        return this.classToAllowedProps.get(value);
    };
    return ClassRegistry;
}((0, $1FyJp.Registry));

});
parcelRegister("1FyJp", function(module, exports) {

$parcel$export(module.exports, "Registry", function () { return $13748fb93328621e$export$4d9facee29974f3; });

var $gl6dk = parcelRequire("gl6dk");
var $13748fb93328621e$export$4d9facee29974f3 = /** @class */ function() {
    function Registry(generateIdentifier) {
        this.generateIdentifier = generateIdentifier;
        this.kv = new (0, $gl6dk.DoubleIndexedKV)();
    }
    Registry.prototype.register = function(value, identifier) {
        if (this.kv.getByValue(value)) return;
        if (!identifier) identifier = this.generateIdentifier(value);
        this.kv.set(identifier, value);
    };
    Registry.prototype.clear = function() {
        this.kv.clear();
    };
    Registry.prototype.getIdentifier = function(value) {
        return this.kv.getByValue(value);
    };
    Registry.prototype.getValue = function(identifier) {
        return this.kv.getByKey(identifier);
    };
    return Registry;
}();

});
parcelRegister("gl6dk", function(module, exports) {

$parcel$export(module.exports, "DoubleIndexedKV", function () { return $be536d78620b7da3$export$46277d766079883; });
var $be536d78620b7da3$export$46277d766079883 = /** @class */ function() {
    function DoubleIndexedKV() {
        this.keyToValue = new Map();
        this.valueToKey = new Map();
    }
    DoubleIndexedKV.prototype.set = function(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
    };
    DoubleIndexedKV.prototype.getByKey = function(key) {
        return this.keyToValue.get(key);
    };
    DoubleIndexedKV.prototype.getByValue = function(value) {
        return this.valueToKey.get(value);
    };
    DoubleIndexedKV.prototype.clear = function() {
        this.keyToValue.clear();
        this.valueToKey.clear();
    };
    return DoubleIndexedKV;
}();

});



parcelRegister("fAfAm", function(module, exports) {

$parcel$export(module.exports, "CustomTransformerRegistry", function () { return $b5864ebf4c7ca1a5$export$375fc3c989563692; });

var $jj1bQ = parcelRequire("jj1bQ");
var $b5864ebf4c7ca1a5$export$375fc3c989563692 = /** @class */ function() {
    function CustomTransformerRegistry() {
        this.transfomers = {};
    }
    CustomTransformerRegistry.prototype.register = function(transformer) {
        this.transfomers[transformer.name] = transformer;
    };
    CustomTransformerRegistry.prototype.findApplicable = function(v) {
        return (0, $jj1bQ.find)(this.transfomers, function(transformer) {
            return transformer.isApplicable(v);
        });
    };
    CustomTransformerRegistry.prototype.findByName = function(name) {
        return this.transfomers[name];
    };
    return CustomTransformerRegistry;
}();

});
parcelRegister("jj1bQ", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $e0e0b6fe4e9fd2fe$export$71aa6c912b956294; });
$parcel$export(module.exports, "forEach", function () { return $e0e0b6fe4e9fd2fe$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "includes", function () { return $e0e0b6fe4e9fd2fe$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "findArr", function () { return $e0e0b6fe4e9fd2fe$export$169650455b10d814; });
var $e0e0b6fe4e9fd2fe$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $e0e0b6fe4e9fd2fe$var$valuesOfObj(record) {
    if ("values" in Object) // eslint-disable-next-line es5/no-es6-methods
    return Object.values(record);
    var values = [];
    // eslint-disable-next-line no-restricted-syntax
    for(var key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function $e0e0b6fe4e9fd2fe$export$71aa6c912b956294(record, predicate) {
    var values = $e0e0b6fe4e9fd2fe$var$valuesOfObj(record);
    if ("find" in values) // eslint-disable-next-line es5/no-es6-methods
    return values.find(predicate);
    var valuesNotNever = values;
    for(var i = 0; i < valuesNotNever.length; i++){
        var value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
    return undefined;
}
function $e0e0b6fe4e9fd2fe$export$4b80e395e36b5a56(record, run) {
    Object.entries(record).forEach(function(_a) {
        var _b = $e0e0b6fe4e9fd2fe$var$__read(_a, 2), key = _b[0], value = _b[1];
        return run(value, key);
    });
}
function $e0e0b6fe4e9fd2fe$export$ee2e0f811dca1807(arr, value) {
    return arr.indexOf(value) !== -1;
}
function $e0e0b6fe4e9fd2fe$export$169650455b10d814(record, predicate) {
    for(var i = 0; i < record.length; i++){
        var value = record[i];
        if (predicate(value)) return value;
    }
    return undefined;
}

});


parcelRegister("ehEsg", function(module, exports) {

$parcel$export(module.exports, "applyValueAnnotations", function () { return $a66208bc9f671bcc$export$fdbee6848e682924; });
$parcel$export(module.exports, "applyReferentialEqualityAnnotations", function () { return $a66208bc9f671bcc$export$2db60f766e3cb5e0; });
$parcel$export(module.exports, "generateReferentialEqualityAnnotations", function () { return $a66208bc9f671bcc$export$df2cc2b2672a42dd; });
$parcel$export(module.exports, "walker", function () { return $a66208bc9f671bcc$export$b8edc0373b60d044; });

var $jlKA9 = parcelRequire("jlKA9");

var $cFSXD = parcelRequire("cFSXD");

var $8CCiI = parcelRequire("8CCiI");

var $jj1bQ = parcelRequire("jj1bQ");

var $1OLgH = parcelRequire("1OLgH");
var $a66208bc9f671bcc$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a66208bc9f671bcc$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
function $a66208bc9f671bcc$var$traverse(tree, walker, origin) {
    if (origin === void 0) origin = [];
    if (!tree) return;
    if (!(0, $jlKA9.isArray)(tree)) {
        (0, $jj1bQ.forEach)(tree, function(subtree, key) {
            return $a66208bc9f671bcc$var$traverse(subtree, walker, $a66208bc9f671bcc$var$__spreadArray($a66208bc9f671bcc$var$__spreadArray([], $a66208bc9f671bcc$var$__read(origin)), $a66208bc9f671bcc$var$__read((0, $cFSXD.parsePath)(key))));
        });
        return;
    }
    var _a = $a66208bc9f671bcc$var$__read(tree, 2), nodeValue = _a[0], children = _a[1];
    if (children) (0, $jj1bQ.forEach)(children, function(child, key) {
        $a66208bc9f671bcc$var$traverse(child, walker, $a66208bc9f671bcc$var$__spreadArray($a66208bc9f671bcc$var$__spreadArray([], $a66208bc9f671bcc$var$__read(origin)), $a66208bc9f671bcc$var$__read((0, $cFSXD.parsePath)(key))));
    });
    walker(nodeValue, origin);
}
function $a66208bc9f671bcc$export$fdbee6848e682924(plain, annotations, superJson) {
    $a66208bc9f671bcc$var$traverse(annotations, function(type, path) {
        plain = (0, $1OLgH.setDeep)(plain, path, function(v) {
            return (0, $8CCiI.untransformValue)(v, type, superJson);
        });
    });
    return plain;
}
function $a66208bc9f671bcc$export$2db60f766e3cb5e0(plain, annotations) {
    function apply(identicalPaths, path) {
        var object = (0, $1OLgH.getDeep)(plain, (0, $cFSXD.parsePath)(path));
        identicalPaths.map((0, $cFSXD.parsePath)).forEach(function(identicalObjectPath) {
            plain = (0, $1OLgH.setDeep)(plain, identicalObjectPath, function() {
                return object;
            });
        });
    }
    if ((0, $jlKA9.isArray)(annotations)) {
        var _a = $a66208bc9f671bcc$var$__read(annotations, 2), root = _a[0], other = _a[1];
        root.forEach(function(identicalPath) {
            plain = (0, $1OLgH.setDeep)(plain, (0, $cFSXD.parsePath)(identicalPath), function() {
                return plain;
            });
        });
        if (other) (0, $jj1bQ.forEach)(other, apply);
    } else (0, $jj1bQ.forEach)(annotations, apply);
    return plain;
}
var $a66208bc9f671bcc$var$isDeep = function(object, superJson) {
    return (0, $jlKA9.isPlainObject)(object) || (0, $jlKA9.isArray)(object) || (0, $jlKA9.isMap)(object) || (0, $jlKA9.isSet)(object) || (0, $8CCiI.isInstanceOfRegisteredClass)(object, superJson);
};
function $a66208bc9f671bcc$var$addIdentity(object, path, identities) {
    var existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function $a66208bc9f671bcc$export$df2cc2b2672a42dd(identitites, dedupe) {
    var result = {};
    var rootEqualityPaths = undefined;
    identitites.forEach(function(paths) {
        if (paths.length <= 1) return;
        // if we're not deduping, all of these objects continue existing.
        // putting the shortest path first makes it easier to parse for humans
        // if we're deduping though, only the first entry will still exist, so we can't do this optimisation.
        if (!dedupe) paths = paths.map(function(path) {
            return path.map(String);
        }).sort(function(a, b) {
            return a.length - b.length;
        });
        var _a = $a66208bc9f671bcc$var$__read(paths), representativePath = _a[0], identicalPaths = _a.slice(1);
        if (representativePath.length === 0) rootEqualityPaths = identicalPaths.map((0, $cFSXD.stringifyPath));
        else result[(0, $cFSXD.stringifyPath)(representativePath)] = identicalPaths.map((0, $cFSXD.stringifyPath));
    });
    if (rootEqualityPaths) {
        if ((0, $jlKA9.isEmptyObject)(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return (0, $jlKA9.isEmptyObject)(result) ? undefined : result;
}
var $a66208bc9f671bcc$export$b8edc0373b60d044 = function(object, identities, superJson, dedupe, path, objectsInThisPath, seenObjects) {
    var _a;
    if (path === void 0) path = [];
    if (objectsInThisPath === void 0) objectsInThisPath = [];
    if (seenObjects === void 0) seenObjects = new Map();
    var primitive = (0, $jlKA9.isPrimitive)(object);
    if (!primitive) {
        $a66208bc9f671bcc$var$addIdentity(object, path, identities);
        var seen = seenObjects.get(object);
        if (seen) // short-circuit result if we've seen this object before
        return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!$a66208bc9f671bcc$var$isDeep(object, superJson)) {
        var transformed_1 = (0, $8CCiI.transformValue)(object, superJson);
        var result_1 = transformed_1 ? {
            transformedValue: transformed_1.value,
            annotations: [
                transformed_1.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result_1);
        return result_1;
    }
    if ((0, $jj1bQ.includes)(objectsInThisPath, object)) // prevent circular references
    return {
        transformedValue: null
    };
    var transformationResult = (0, $8CCiI.transformValue)(object, superJson);
    var transformed = (_a = transformationResult === null || transformationResult === void 0 ? void 0 : transformationResult.value) !== null && _a !== void 0 ? _a : object;
    var transformedValue = (0, $jlKA9.isArray)(transformed) ? [] : {};
    var innerAnnotations = {};
    (0, $jj1bQ.forEach)(transformed, function(value, index) {
        var recursiveResult = $a66208bc9f671bcc$export$b8edc0373b60d044(value, identities, superJson, dedupe, $a66208bc9f671bcc$var$__spreadArray($a66208bc9f671bcc$var$__spreadArray([], $a66208bc9f671bcc$var$__read(path)), [
            index
        ]), $a66208bc9f671bcc$var$__spreadArray($a66208bc9f671bcc$var$__spreadArray([], $a66208bc9f671bcc$var$__read(objectsInThisPath)), [
            object
        ]), seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ((0, $jlKA9.isArray)(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ((0, $jlKA9.isPlainObject)(recursiveResult.annotations)) (0, $jj1bQ.forEach)(recursiveResult.annotations, function(tree, key) {
            innerAnnotations[(0, $cFSXD.escapeKey)(index) + "." + key] = tree;
        });
    });
    var result = (0, $jlKA9.isEmptyObject)(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : undefined
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result);
    return result;
};

});
parcelRegister("jlKA9", function(module, exports) {

$parcel$export(module.exports, "isUndefined", function () { return $e1641cb50ea325d0$export$fce6876652108ab; });
$parcel$export(module.exports, "isPlainObject", function () { return $e1641cb50ea325d0$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEmptyObject", function () { return $e1641cb50ea325d0$export$83b788b1a3698c03; });
$parcel$export(module.exports, "isArray", function () { return $e1641cb50ea325d0$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isRegExp", function () { return $e1641cb50ea325d0$export$49841c62b9eff15; });
$parcel$export(module.exports, "isMap", function () { return $e1641cb50ea325d0$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $e1641cb50ea325d0$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isSymbol", function () { return $e1641cb50ea325d0$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isDate", function () { return $e1641cb50ea325d0$export$871608497c498473; });
$parcel$export(module.exports, "isError", function () { return $e1641cb50ea325d0$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isNaNValue", function () { return $e1641cb50ea325d0$export$87fc7a69ba8e466; });
$parcel$export(module.exports, "isPrimitive", function () { return $e1641cb50ea325d0$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isBigint", function () { return $e1641cb50ea325d0$export$d65ada007028ca1; });
$parcel$export(module.exports, "isInfinite", function () { return $e1641cb50ea325d0$export$9ec5d00ddeb5163c; });
$parcel$export(module.exports, "isTypedArray", function () { return $e1641cb50ea325d0$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "isURL", function () { return $e1641cb50ea325d0$export$bab98af026af71ac; });
var $e1641cb50ea325d0$var$getType = function(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
};
var $e1641cb50ea325d0$export$fce6876652108ab = function(payload) {
    return typeof payload === "undefined";
};
var $e1641cb50ea325d0$export$630801d484da15df = function(payload) {
    return payload === null;
};
var $e1641cb50ea325d0$export$53b83ca8eaab0383 = function(payload) {
    if (typeof payload !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
var $e1641cb50ea325d0$export$83b788b1a3698c03 = function(payload) {
    return $e1641cb50ea325d0$export$53b83ca8eaab0383(payload) && Object.keys(payload).length === 0;
};
var $e1641cb50ea325d0$export$43bee75e5e14138e = function(payload) {
    return Array.isArray(payload);
};
var $e1641cb50ea325d0$export$844ec244b1367d54 = function(payload) {
    return typeof payload === "string";
};
var $e1641cb50ea325d0$export$7e4aa119212bc614 = function(payload) {
    return typeof payload === "number" && !isNaN(payload);
};
var $e1641cb50ea325d0$export$f9ce7b637dfbe238 = function(payload) {
    return typeof payload === "boolean";
};
var $e1641cb50ea325d0$export$49841c62b9eff15 = function(payload) {
    return payload instanceof RegExp;
};
var $e1641cb50ea325d0$export$5c90113a285f2241 = function(payload) {
    return payload instanceof Map;
};
var $e1641cb50ea325d0$export$6750766a7c7ec627 = function(payload) {
    return payload instanceof Set;
};
var $e1641cb50ea325d0$export$a244864fd9645c7f = function(payload) {
    return $e1641cb50ea325d0$var$getType(payload) === "Symbol";
};
var $e1641cb50ea325d0$export$871608497c498473 = function(payload) {
    return payload instanceof Date && !isNaN(payload.valueOf());
};
var $e1641cb50ea325d0$export$e6127cc7fe7395c3 = function(payload) {
    return payload instanceof Error;
};
var $e1641cb50ea325d0$export$87fc7a69ba8e466 = function(payload) {
    return typeof payload === "number" && isNaN(payload);
};
var $e1641cb50ea325d0$export$c3825b437cbdea5c = function(payload) {
    return $e1641cb50ea325d0$export$f9ce7b637dfbe238(payload) || $e1641cb50ea325d0$export$630801d484da15df(payload) || $e1641cb50ea325d0$export$fce6876652108ab(payload) || $e1641cb50ea325d0$export$7e4aa119212bc614(payload) || $e1641cb50ea325d0$export$844ec244b1367d54(payload) || $e1641cb50ea325d0$export$a244864fd9645c7f(payload);
};
var $e1641cb50ea325d0$export$d65ada007028ca1 = function(payload) {
    return typeof payload === "bigint";
};
var $e1641cb50ea325d0$export$9ec5d00ddeb5163c = function(payload) {
    return payload === Infinity || payload === -Infinity;
};
var $e1641cb50ea325d0$export$b119cc7e1840e59c = function(payload) {
    return ArrayBuffer.isView(payload) && !(payload instanceof DataView);
};
var $e1641cb50ea325d0$export$bab98af026af71ac = function(payload) {
    return payload instanceof URL;
};

});

parcelRegister("cFSXD", function(module, exports) {

$parcel$export(module.exports, "escapeKey", function () { return $93a3f273735bc263$export$ccb63190d6bf301; });
$parcel$export(module.exports, "stringifyPath", function () { return $93a3f273735bc263$export$48725424ff4cd5a6; });
$parcel$export(module.exports, "parsePath", function () { return $93a3f273735bc263$export$8ccf933b0513f8d0; });
var $93a3f273735bc263$export$ccb63190d6bf301 = function(key) {
    return key.replace(/\./g, "\\.");
};
var $93a3f273735bc263$export$48725424ff4cd5a6 = function(path) {
    return path.map(String).map($93a3f273735bc263$export$ccb63190d6bf301).join(".");
};
var $93a3f273735bc263$export$8ccf933b0513f8d0 = function(string) {
    var result = [];
    var segment = "";
    for(var i = 0; i < string.length; i++){
        var char = string.charAt(i);
        var isEscapedDot = char === "\\" && string.charAt(i + 1) === ".";
        if (isEscapedDot) {
            segment += ".";
            i++;
            continue;
        }
        var isEndOfSegment = char === ".";
        if (isEndOfSegment) {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    var lastSegment = segment;
    result.push(lastSegment);
    return result;
};

});

parcelRegister("8CCiI", function(module, exports) {

$parcel$export(module.exports, "isInstanceOfRegisteredClass", function () { return $646f95190e6a00b2$export$3541e8ed2472fc86; });
$parcel$export(module.exports, "transformValue", function () { return $646f95190e6a00b2$export$98c150630afe5417; });
$parcel$export(module.exports, "untransformValue", function () { return $646f95190e6a00b2$export$bbc227b1fb21334; });

var $jlKA9 = parcelRequire("jlKA9");

var $jj1bQ = parcelRequire("jj1bQ");
var $646f95190e6a00b2$var$__assign = undefined && undefined.__assign || function() {
    $646f95190e6a00b2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $646f95190e6a00b2$var$__assign.apply(this, arguments);
};
var $646f95190e6a00b2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $646f95190e6a00b2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
function $646f95190e6a00b2$var$simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $646f95190e6a00b2$var$simpleRules = [
    $646f95190e6a00b2$var$simpleTransformation((0, $jlKA9.isUndefined), "undefined", function() {
        return null;
    }, function() {
        return undefined;
    }),
    $646f95190e6a00b2$var$simpleTransformation((0, $jlKA9.isBigint), "bigint", function(v) {
        return v.toString();
    }, function(v) {
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    $646f95190e6a00b2$var$simpleTransformation((0, $jlKA9.isDate), "Date", function(v) {
        return v.toISOString();
    }, function(v) {
        return new Date(v);
    }),
    $646f95190e6a00b2$var$simpleTransformation((0, $jlKA9.isError), "Error", function(v, superJson) {
        var baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach(function(prop) {
            baseError[prop] = v[prop];
        });
        return baseError;
    }, function(v, superJson) {
        var e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach(function(prop) {
            e[prop] = v[prop];
        });
        return e;
    }),
    $646f95190e6a00b2$var$simpleTransformation((0, $jlKA9.isRegExp), "regexp", function(v) {
        return "" + v;
    }, function(regex) {
        var body = regex.slice(1, regex.lastIndexOf("/"));
        var flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    $646f95190e6a00b2$var$simpleTransformation((0, $jlKA9.isSet), "set", // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(v) {
        return $646f95190e6a00b2$var$__spreadArray([], $646f95190e6a00b2$var$__read(v.values()));
    }, function(v) {
        return new Set(v);
    }),
    $646f95190e6a00b2$var$simpleTransformation((0, $jlKA9.isMap), "map", function(v) {
        return $646f95190e6a00b2$var$__spreadArray([], $646f95190e6a00b2$var$__read(v.entries()));
    }, function(v) {
        return new Map(v);
    }),
    $646f95190e6a00b2$var$simpleTransformation(function(v) {
        return (0, $jlKA9.isNaNValue)(v) || (0, $jlKA9.isInfinite)(v);
    }, "number", function(v) {
        if ((0, $jlKA9.isNaNValue)(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    $646f95190e6a00b2$var$simpleTransformation(function(v) {
        return v === 0 && 1 / v === -Infinity;
    }, "number", function() {
        return "-0";
    }, Number),
    $646f95190e6a00b2$var$simpleTransformation((0, $jlKA9.isURL), "URL", function(v) {
        return v.toString();
    }, function(v) {
        return new URL(v);
    })
];
function $646f95190e6a00b2$var$compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $646f95190e6a00b2$var$symbolRule = $646f95190e6a00b2$var$compositeTransformation(function(s, superJson) {
    if ((0, $jlKA9.isSymbol)(s)) {
        var isRegistered = !!superJson.symbolRegistry.getIdentifier(s);
        return isRegistered;
    }
    return false;
}, function(s, superJson) {
    var identifier = superJson.symbolRegistry.getIdentifier(s);
    return [
        "symbol",
        identifier
    ];
}, function(v) {
    return v.description;
}, function(_, a, superJson) {
    var value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
var $646f95190e6a00b2$var$constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce(function(obj, ctor) {
    obj[ctor.name] = ctor;
    return obj;
}, {});
var $646f95190e6a00b2$var$typedArrayRule = $646f95190e6a00b2$var$compositeTransformation((0, $jlKA9.isTypedArray), function(v) {
    return [
        "typed-array",
        v.constructor.name
    ];
}, function(v) {
    return $646f95190e6a00b2$var$__spreadArray([], $646f95190e6a00b2$var$__read(v));
}, function(v, a) {
    var ctor = $646f95190e6a00b2$var$constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function $646f95190e6a00b2$export$3541e8ed2472fc86(potentialClass, superJson) {
    if (potentialClass === null || potentialClass === void 0 ? void 0 : potentialClass.constructor) {
        var isRegistered = !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
        return isRegistered;
    }
    return false;
}
var $646f95190e6a00b2$var$classRule = $646f95190e6a00b2$var$compositeTransformation($646f95190e6a00b2$export$3541e8ed2472fc86, function(clazz, superJson) {
    var identifier = superJson.classRegistry.getIdentifier(clazz.constructor);
    return [
        "class",
        identifier
    ];
}, function(clazz, superJson) {
    var allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return $646f95190e6a00b2$var$__assign({}, clazz);
    var result = {};
    allowedProps.forEach(function(prop) {
        result[prop] = clazz[prop];
    });
    return result;
}, function(v, a, superJson) {
    var clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
    return Object.assign(Object.create(clazz.prototype), v);
});
var $646f95190e6a00b2$var$customRule = $646f95190e6a00b2$var$compositeTransformation(function(value, superJson) {
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, function(value, superJson) {
    var transformer = superJson.customTransformerRegistry.findApplicable(value);
    return [
        "custom",
        transformer.name
    ];
}, function(value, superJson) {
    var transformer = superJson.customTransformerRegistry.findApplicable(value);
    return transformer.serialize(value);
}, function(v, a, superJson) {
    var transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
var $646f95190e6a00b2$var$compositeRules = [
    $646f95190e6a00b2$var$classRule,
    $646f95190e6a00b2$var$symbolRule,
    $646f95190e6a00b2$var$customRule,
    $646f95190e6a00b2$var$typedArrayRule
];
var $646f95190e6a00b2$export$98c150630afe5417 = function(value, superJson) {
    var applicableCompositeRule = (0, $jj1bQ.findArr)($646f95190e6a00b2$var$compositeRules, function(rule) {
        return rule.isApplicable(value, superJson);
    });
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    var applicableSimpleRule = (0, $jj1bQ.findArr)($646f95190e6a00b2$var$simpleRules, function(rule) {
        return rule.isApplicable(value, superJson);
    });
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
    return undefined;
};
var $646f95190e6a00b2$var$simpleRulesByAnnotation = {};
$646f95190e6a00b2$var$simpleRules.forEach(function(rule) {
    $646f95190e6a00b2$var$simpleRulesByAnnotation[rule.annotation] = rule;
});
var $646f95190e6a00b2$export$bbc227b1fb21334 = function(json, type, superJson) {
    if ((0, $jlKA9.isArray)(type)) switch(type[0]){
        case "symbol":
            return $646f95190e6a00b2$var$symbolRule.untransform(json, type, superJson);
        case "class":
            return $646f95190e6a00b2$var$classRule.untransform(json, type, superJson);
        case "custom":
            return $646f95190e6a00b2$var$customRule.untransform(json, type, superJson);
        case "typed-array":
            return $646f95190e6a00b2$var$typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        var transformation = $646f95190e6a00b2$var$simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};

});

parcelRegister("1OLgH", function(module, exports) {

$parcel$export(module.exports, "getDeep", function () { return $152f20792d8c7cfe$export$cc083bb740ac7702; });
$parcel$export(module.exports, "setDeep", function () { return $152f20792d8c7cfe$export$c615a4d8c3fee905; });

var $jlKA9 = parcelRequire("jlKA9");

var $jj1bQ = parcelRequire("jj1bQ");
var $152f20792d8c7cfe$var$getNthKey = function(value, n) {
    var keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function $152f20792d8c7cfe$var$validatePath(path) {
    if ((0, $jj1bQ.includes)(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ((0, $jj1bQ.includes)(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ((0, $jj1bQ.includes)(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
var $152f20792d8c7cfe$export$cc083bb740ac7702 = function(object, path) {
    $152f20792d8c7cfe$var$validatePath(path);
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if ((0, $jlKA9.isSet)(object)) object = $152f20792d8c7cfe$var$getNthKey(object, +key);
        else if ((0, $jlKA9.isMap)(object)) {
            var row = +key;
            var type = +path[++i] === 0 ? "key" : "value";
            var keyOfRow = $152f20792d8c7cfe$var$getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
var $152f20792d8c7cfe$export$c615a4d8c3fee905 = function(object, path, mapper) {
    $152f20792d8c7cfe$var$validatePath(path);
    if (path.length === 0) return mapper(object);
    var parent = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if ((0, $jlKA9.isArray)(parent)) {
            var index = +key;
            parent = parent[index];
        } else if ((0, $jlKA9.isPlainObject)(parent)) parent = parent[key];
        else if ((0, $jlKA9.isSet)(parent)) {
            var row = +key;
            parent = $152f20792d8c7cfe$var$getNthKey(parent, row);
        } else if ((0, $jlKA9.isMap)(parent)) {
            var isEnd = i === path.length - 2;
            if (isEnd) break;
            var row = +key;
            var type = +path[++i] === 0 ? "key" : "value";
            var keyOfRow = $152f20792d8c7cfe$var$getNthKey(parent, row);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    var lastKey = path[path.length - 1];
    if ((0, $jlKA9.isArray)(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ((0, $jlKA9.isPlainObject)(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ((0, $jlKA9.isSet)(parent)) {
        var oldValue = $152f20792d8c7cfe$var$getNthKey(parent, +lastKey);
        var newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent["delete"](oldValue);
            parent.add(newValue);
        }
    }
    if ((0, $jlKA9.isMap)(parent)) {
        var row = +path[path.length - 2];
        var keyToRow = $152f20792d8c7cfe$var$getNthKey(parent, row);
        var type = +lastKey === 0 ? "key" : "value";
        switch(type){
            case "key":
                var newKey = mapper(keyToRow);
                parent.set(newKey, parent.get(keyToRow));
                if (newKey !== keyToRow) parent["delete"](keyToRow);
                break;
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};

});


parcelRegister("a8IkQ", function(module, exports) {

$parcel$export(module.exports, "copy", function () { return $761d0acccc6fd622$export$784d13d8ee351f07; });

var $hEkYM = parcelRequire("hEkYM");
function $761d0acccc6fd622$var$assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    const propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $761d0acccc6fd622$export$784d13d8ee351f07(target, options = {}) {
    if ((0, $hEkYM.isArray)(target)) return target.map((item)=>$761d0acccc6fd622$export$784d13d8ee351f07(item, options));
    if (!(0, $hEkYM.isPlainObject)(target)) return target;
    const props = Object.getOwnPropertyNames(target);
    const symbols = Object.getOwnPropertySymbols(target);
    return [
        ...props,
        ...symbols
    ].reduce((carry, key)=>{
        if ((0, $hEkYM.isArray)(options.props) && !options.props.includes(key)) return carry;
        const val = target[key];
        const newVal = $761d0acccc6fd622$export$784d13d8ee351f07(val, options);
        $761d0acccc6fd622$var$assignProp(carry, key, newVal, target, options.nonenumerable);
        return carry;
    }, {});
}

});
parcelRegister("hEkYM", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $cd967221dcb06346$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isPlainObject", function () { return $cd967221dcb06346$export$53b83ca8eaab0383; });
function $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function $cd967221dcb06346$export$ae004ceb3d455f9a(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Object";
}
function $cd967221dcb06346$export$43bee75e5e14138e(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Array";
}
function $cd967221dcb06346$export$5bcd6e94ed871c88(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Blob";
}
function $cd967221dcb06346$export$f9ce7b637dfbe238(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Boolean";
}
function $cd967221dcb06346$export$871608497c498473(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Date" && !isNaN(payload);
}
function $cd967221dcb06346$export$4c0262a4f954db45(payload) {
    return $cd967221dcb06346$export$43bee75e5e14138e(payload) && payload.length === 0;
}
function $cd967221dcb06346$export$53b83ca8eaab0383(payload) {
    if ($cd967221dcb06346$export$e2b5c5db9e2009fd(payload) !== "Object") return false;
    const prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function $cd967221dcb06346$export$83b788b1a3698c03(payload) {
    return $cd967221dcb06346$export$53b83ca8eaab0383(payload) && Object.keys(payload).length === 0;
}
function $cd967221dcb06346$export$78d1711480f95c3e(payload) {
    return payload === "";
}
function $cd967221dcb06346$export$e6127cc7fe7395c3(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Error" || payload instanceof Error;
}
function $cd967221dcb06346$export$be78b3111c50efdd(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "File";
}
function $cd967221dcb06346$export$8064717326baf93d(payload) {
    return $cd967221dcb06346$export$43bee75e5e14138e(payload) && payload.length > 0;
}
function $cd967221dcb06346$export$36f6b23005e191ac(payload) {
    return $cd967221dcb06346$export$53b83ca8eaab0383(payload) && Object.keys(payload).length > 0;
}
function $cd967221dcb06346$export$844ec244b1367d54(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "String";
}
function $cd967221dcb06346$export$ab65b4820ba194f1(payload) {
    return $cd967221dcb06346$export$844ec244b1367d54(payload) && payload !== "";
}
function $cd967221dcb06346$export$f6e2535fb5126e54(payload) {
    return typeof payload === "function";
}
function $cd967221dcb06346$export$26b9f946b448f23e(payload, type) {
    if (!(type instanceof Function)) throw new TypeError("Type must be a function");
    if (!Object.prototype.hasOwnProperty.call(type, "prototype")) throw new TypeError("Type is not a class");
    const name = type.name;
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === name || Boolean(payload && payload.constructor === type);
}
function $cd967221dcb06346$export$49034edbe6b62415(value, classOrClassName) {
    if (typeof classOrClassName === "function") {
        for(let p = value; p; p = Object.getPrototypeOf(p)){
            if ($cd967221dcb06346$export$26b9f946b448f23e(p, classOrClassName)) return true;
        }
        return false;
    } else {
        for(let p = value; p; p = Object.getPrototypeOf(p)){
            if ($cd967221dcb06346$export$e2b5c5db9e2009fd(p) === classOrClassName) return true;
        }
        return false;
    }
}
function $cd967221dcb06346$export$5c90113a285f2241(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Map";
}
function $cd967221dcb06346$export$87fc7a69ba8e466(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Number" && isNaN(payload);
}
function $cd967221dcb06346$export$7e4aa119212bc614(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Number" && !isNaN(payload);
}
function $cd967221dcb06346$export$6dbd64961904ec9a(payload) {
    return $cd967221dcb06346$export$7e4aa119212bc614(payload) && payload < 0;
}
function $cd967221dcb06346$export$630801d484da15df(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Null";
}
function $cd967221dcb06346$export$532a90c0e5e8e48c(a, b, c, d, e) {
    return (value)=>a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
}
function $cd967221dcb06346$export$fce6876652108ab(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Undefined";
}
const $cd967221dcb06346$export$bedb7023a7733221 = $cd967221dcb06346$export$532a90c0e5e8e48c($cd967221dcb06346$export$630801d484da15df, $cd967221dcb06346$export$fce6876652108ab);
function $cd967221dcb06346$export$a6cdc56e425d0d0a(payload) {
    return $cd967221dcb06346$export$53b83ca8eaab0383(payload);
}
function $cd967221dcb06346$export$c10d0b04eaa80a43(payload) {
    return $cd967221dcb06346$export$ae004ceb3d455f9a(payload);
}
function $cd967221dcb06346$export$5374bb854d0e41c8(payload) {
    return $cd967221dcb06346$export$7e4aa119212bc614(payload) && payload > 0;
}
function $cd967221dcb06346$export$a244864fd9645c7f(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Symbol";
}
function $cd967221dcb06346$export$c3825b437cbdea5c(payload) {
    return $cd967221dcb06346$export$f9ce7b637dfbe238(payload) || $cd967221dcb06346$export$630801d484da15df(payload) || $cd967221dcb06346$export$fce6876652108ab(payload) || $cd967221dcb06346$export$7e4aa119212bc614(payload) || $cd967221dcb06346$export$844ec244b1367d54(payload) || $cd967221dcb06346$export$a244864fd9645c7f(payload);
}
function $cd967221dcb06346$export$4369c812aac99591(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Promise";
}
function $cd967221dcb06346$export$49841c62b9eff15(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "RegExp";
}
function $cd967221dcb06346$export$6750766a7c7ec627(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "Set";
}
function $cd967221dcb06346$export$45e3ca7880506f6(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "WeakMap";
}
function $cd967221dcb06346$export$6001bf5c91b8444(payload) {
    return $cd967221dcb06346$export$e2b5c5db9e2009fd(payload) === "WeakSet";
}

});



parcelRegister("lTrDt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff042be9e25dc068$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "StaffCollectionClass", function () { return $ff042be9e25dc068$export$4569752426dfcdaf; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $8LDMR = parcelRequire("8LDMR");

var $hy8Zj = parcelRequire("hy8Zj");

var $ftbex = parcelRequire("ftbex");

var $5NCwu = parcelRequire("5NCwu");
var $ff042be9e25dc068$var$_dec, $ff042be9e25dc068$var$_dec2, $ff042be9e25dc068$var$_dec3, $ff042be9e25dc068$var$_class;
function $ff042be9e25dc068$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $ff042be9e25dc068$var$StaffCollection = ($ff042be9e25dc068$var$_dec = (0, $d8hWe.action).bound, $ff042be9e25dc068$var$_dec2 = (0, $d8hWe.action).bound, $ff042be9e25dc068$var$_dec3 = (0, $d8hWe.action).bound, $ff042be9e25dc068$var$_class = class StaffCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "staff",
            modelClass: (0, $8LDMR.default)
        });
        this.addLookup("staffByRoleId", "manyByKey", {
            key: (t)=>t.roleId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("staffByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("activeStaff", "list", {
            filter: (t)=>!t.isDeleted && !t.deletedAt && !t.isArchived
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get staffsById() {
        return this.modelsById;
    }
    get staffs() {
        return this.models;
    }
    get staffById() {
        return this.modelsById;
    }
    get staff() {
        return this.models;
    }
    get staffMembersById() {
        return this.modelsById;
    }
    get staffMembers() {
        return this.models;
    }
    addStaff(data) {
        this.add(data);
    }
    addStaffs(data) {
        this.addMany(data);
    }
    createStaff() {
        var _CostCentreCollection;
        const staff = this.add({
            costCentreId: ((_CostCentreCollection = (0, $hy8Zj.default).activeCostCentres.find((cc)=>{
                var _cc$name;
                return cc === null || cc === void 0 ? void 0 : (_cc$name = cc.name) === null || _cc$name === void 0 ? void 0 : _cc$name.toLowerCase().includes("staff");
            })) === null || _CostCentreCollection === void 0 ? void 0 : _CostCentreCollection.id) || (0, $hy8Zj.default).activeCostCentres[0].id,
            permissions: (0, $5NCwu.permissionPresets).timesheet
        }, {
            trackUpdates: true
        });
        const rate = (0, $ftbex.default).add({
            staffId: staff.id,
            date: new Date(2010, 0, 1)
        }, {
            trackUpdates: true
        });
        return staff;
    }
}, $ff042be9e25dc068$var$_applyDecoratedDescriptor($ff042be9e25dc068$var$_class.prototype, "addStaff", [
    $ff042be9e25dc068$var$_dec
], Object.getOwnPropertyDescriptor($ff042be9e25dc068$var$_class.prototype, "addStaff"), $ff042be9e25dc068$var$_class.prototype), $ff042be9e25dc068$var$_applyDecoratedDescriptor($ff042be9e25dc068$var$_class.prototype, "addStaffs", [
    $ff042be9e25dc068$var$_dec2
], Object.getOwnPropertyDescriptor($ff042be9e25dc068$var$_class.prototype, "addStaffs"), $ff042be9e25dc068$var$_class.prototype), $ff042be9e25dc068$var$_applyDecoratedDescriptor($ff042be9e25dc068$var$_class.prototype, "createStaff", [
    $ff042be9e25dc068$var$_dec3
], Object.getOwnPropertyDescriptor($ff042be9e25dc068$var$_class.prototype, "createStaff"), $ff042be9e25dc068$var$_class.prototype), $ff042be9e25dc068$var$_class);
var $ff042be9e25dc068$export$2e2bcd8739ae039 = new $ff042be9e25dc068$var$StaffCollection();
const $ff042be9e25dc068$export$4569752426dfcdaf = $ff042be9e25dc068$var$StaffCollection;

});
parcelRegister("906tN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68d923ddea32787b$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $cjCbh = parcelRequire("cjCbh");
parcelRequire("dBifK");

parcelRequire("hiuv4");


var $aJxsR = parcelRequire("aJxsR");

var $fqmGV = parcelRequire("fqmGV");
var $68d923ddea32787b$var$_dec, $68d923ddea32787b$var$_dec2, $68d923ddea32787b$var$_dec3, $68d923ddea32787b$var$_dec4, $68d923ddea32787b$var$_dec5, $68d923ddea32787b$var$_dec6, $68d923ddea32787b$var$_dec7, $68d923ddea32787b$var$_dec8, $68d923ddea32787b$var$_dec9, $68d923ddea32787b$var$_dec10, $68d923ddea32787b$var$_dec11, $68d923ddea32787b$var$_class, $68d923ddea32787b$var$_descriptor, $68d923ddea32787b$var$_descriptor2, $68d923ddea32787b$var$_descriptor3, $68d923ddea32787b$var$_class2, $68d923ddea32787b$var$_descriptor4, $68d923ddea32787b$var$_descriptor5, $68d923ddea32787b$var$_class3, $68d923ddea32787b$var$_descriptor6, $68d923ddea32787b$var$_descriptor7, $68d923ddea32787b$var$_class4, $68d923ddea32787b$var$_descriptor8, $68d923ddea32787b$var$_descriptor9, $68d923ddea32787b$var$_class5, $68d923ddea32787b$var$_descriptor10;
function $68d923ddea32787b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $68d923ddea32787b$var$_defineProperty(e, r, t) {
    return (r = $68d923ddea32787b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $68d923ddea32787b$var$_toPropertyKey(t) {
    var i = $68d923ddea32787b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $68d923ddea32787b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $68d923ddea32787b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $68d923ddea32787b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $68d923ddea32787b$var$globalModelLookup = {};
let $68d923ddea32787b$var$Collection = ($68d923ddea32787b$var$_dec = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec2 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec3 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec4 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec5 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec6 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec7 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec8 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec9 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec10 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_dec11 = (0, $d8hWe.action).bound, $68d923ddea32787b$var$_class = class Collection {
    constructor({ collection: collection, modelClass: modelClass, getModelId: getModelId, modelCreator: modelCreator, modelUpdater: modelUpdater }){
        var _globalModelLookup$co;
        $68d923ddea32787b$var$_initializerDefineProperty(this, "modelsById", $68d923ddea32787b$var$_descriptor, this);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "models", $68d923ddea32787b$var$_descriptor2, this);
        $68d923ddea32787b$var$_defineProperty(this, "collection", null);
        $68d923ddea32787b$var$_defineProperty(this, "modelClass", null);
        $68d923ddea32787b$var$_defineProperty(this, "getModelId", (modelData)=>modelData === null || modelData === void 0 ? void 0 : modelData.id);
        $68d923ddea32787b$var$_defineProperty(this, "modelCreator", (m, options)=>m instanceof (0, $fqmGV.default) ? m : new this.modelClass(m, {
                ...options,
                source: "collection"
            }));
        $68d923ddea32787b$var$_defineProperty(this, "modelUpdater", (model, newData, options = {})=>model.update(newData, {
                ...options,
                source: "collection"
            }));
        $68d923ddea32787b$var$_defineProperty(this, "lookups", new Set());
        $68d923ddea32787b$var$_defineProperty(this, "cacheTimestamp", null);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "saveState", $68d923ddea32787b$var$_descriptor3, this);
        (0, $d8hWe.makeObservable)(this);
        (_globalModelLookup$co = $68d923ddea32787b$var$globalModelLookup[collection]) !== null && _globalModelLookup$co !== void 0 ? _globalModelLookup$co : $68d923ddea32787b$var$globalModelLookup[collection] = {};
        this.collection = collection;
        this.modelClass = modelClass;
        this.getModelId = getModelId !== null && getModelId !== void 0 ? getModelId : this.getModelId;
        this.modelCreator = modelCreator !== null && modelCreator !== void 0 ? modelCreator : this.modelCreator;
        this.modelUpdater = modelUpdater !== null && modelUpdater !== void 0 ? modelUpdater : this.modelUpdater;
        this.addLookup("modelsToSave", "list", {
            filter: (m)=>{
                return m === null || m === void 0 ? void 0 : m.needsSaving;
            }
        });
        this.addLookup("newUnsavedModels", "list", {
            filter: (m)=>{
                return (m === null || m === void 0 ? void 0 : m.needsSaving) && !m.createdAt;
            }
        });
    }
    get modelType() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aJxsR)))(this.collection, 1);
    }
    get needsSaving() {
        var _this$modelsToSave;
        return ((_this$modelsToSave = this.modelsToSave) === null || _this$modelsToSave === void 0 ? void 0 : _this$modelsToSave.length) > 0;
    }
    get updatedAt() {
        return Math.max(...this.modelsToSave.map((m)=>m.updatedAt));
    }
    addMany(modelDataArray, options) {
        return modelDataArray.map((md)=>this.add(md, options));
    }
    add(modelData, options = {}) {
        const modelId = this.getModelId(modelData);
        if (!modelId || !this.modelsById[modelId]) return this.create(modelId, modelData, options);
        else return this.update(modelId, modelData, options);
    }
    create(modelId, modelData, options) {
        var _modelData$id, _modelId;
        (_modelData$id = modelData.id) !== null && _modelData$id !== void 0 ? _modelData$id : modelData.id = (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))();
        (_modelId = modelId) !== null && _modelId !== void 0 ? _modelId : modelId = modelData.id;
        let model;
        if ($68d923ddea32787b$var$globalModelLookup[this.collection][modelId]) {
            model = $68d923ddea32787b$var$globalModelLookup[this.collection][modelId];
            this.modelUpdater(model, modelData, options);
        } else {
            model = this.modelCreator(modelData, options);
            $68d923ddea32787b$var$globalModelLookup[this.collection][modelId] = model;
        }
        this.modelsById[modelId] = model;
        this.models.push(model);
        // this.modelsById = { ...this.modelsById }
        // this.models = [...this.models]
        this.onCreate(modelId);
        return this.modelsById[modelId];
    }
    // update everything here
    update(modelId, modelData, options = {}) {
        this.modelUpdater(this.modelsById[modelId], modelData, options);
        // this.modelsById = { ...this.modelsById }
        // this.models = [...this.models]
        this.onUpdate(modelId);
        return this.modelsById[modelId];
    }
    delete(modelId) {
        const model = this.modelsById[modelId];
        if (model) {
            this.onDelete(modelId);
            delete this.modelsById[modelId];
            this.models = this.models.filter((m)=>m.id !== modelId);
        // this.modelsById = { ...this.modelsById }
        // this.models = [...this.models]
        }
        return model;
    }
    deleteMany(modelIds) {
        modelIds.forEach((modelId)=>{
            this.delete(modelId);
        });
    }
    onCreate(modelId) {
        const model = this.modelsById[modelId];
        [
            ...this.lookups
        ].forEach((propName)=>{
            this[propName].add(model);
        });
    }
    onUpdate(modelId) {
        const model = this.modelsById[modelId];
        [
            ...this.lookups
        ].forEach((propName)=>{
            this[propName].update(model);
        });
    }
    onDelete(modelId) {
        const model = this.modelsById[modelId];
        [
            ...this.lookups
        ].forEach((propName)=>{
            this[propName].delete(model);
        });
    }
    addLookup(propName, type, { map: map, filter: filter, key: key, keys: keys }) {
        const lookupTypes = {
            manyByMany: $68d923ddea32787b$var$ManyModelsByManyKeys,
            manyByKey: $68d923ddea32787b$var$ManyModelsByKey,
            uniqueByKey: $68d923ddea32787b$var$UniqueModelsByKey,
            list: $68d923ddea32787b$var$ModelList
        };
        const modelsByKey = new lookupTypes[type]({
            filter: filter,
            map: map,
            key: key,
            keys: keys
        });
        Object.defineProperty(this, `_${propName}`, {
            value: modelsByKey,
            writable: false
        });
        Object.defineProperty(this, propName, {
            get () {
                return this[`_${propName}`].lookup;
            }
        });
        this.lookups.add(`_${propName}`);
    }
    clear() {
        this.modelsById = {};
        this.models = [];
        this.lookups.forEach((propName)=>{
            this[propName].clear();
        });
    }
}, $68d923ddea32787b$var$_descriptor = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "modelsById", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $68d923ddea32787b$var$_descriptor2 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "models", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $68d923ddea32787b$var$_descriptor3 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "saveState", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "modelType", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "modelType"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "needsSaving", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "needsSaving"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "updatedAt", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "updatedAt"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "addMany", [
    $68d923ddea32787b$var$_dec
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "addMany"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "add", [
    $68d923ddea32787b$var$_dec2
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "add"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "create", [
    $68d923ddea32787b$var$_dec3
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "create"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "update", [
    $68d923ddea32787b$var$_dec4
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "update"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "delete", [
    $68d923ddea32787b$var$_dec5
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "delete"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "deleteMany", [
    $68d923ddea32787b$var$_dec6
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "deleteMany"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "onCreate", [
    $68d923ddea32787b$var$_dec7
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "onCreate"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "onUpdate", [
    $68d923ddea32787b$var$_dec8
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "onUpdate"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "onDelete", [
    $68d923ddea32787b$var$_dec9
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "onDelete"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "addLookup", [
    $68d923ddea32787b$var$_dec10
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "addLookup"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class.prototype, "clear", [
    $68d923ddea32787b$var$_dec11
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class.prototype, "clear"), $68d923ddea32787b$var$_class.prototype), $68d923ddea32787b$var$_class);
let $68d923ddea32787b$var$ManyModelsByManyKeys = ($68d923ddea32787b$var$_class2 = class ManyModelsByManyKeys {
    constructor({ filter: filter, map: map, keys: keys, getId: getId }){
        $68d923ddea32787b$var$_defineProperty(this, "filter", (m)=>true);
        $68d923ddea32787b$var$_defineProperty(this, "map", (m)=>m);
        $68d923ddea32787b$var$_defineProperty(this, "keys", (m)=>[
                m === null || m === void 0 ? void 0 : m.id
            ]);
        $68d923ddea32787b$var$_defineProperty(this, "getId", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "cachedData", $68d923ddea32787b$var$_descriptor4, this);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "modelsByKey", $68d923ddea32787b$var$_descriptor5, this);
        (0, $d8hWe.makeObservable)(this);
        this.filter = filter !== null && filter !== void 0 ? filter : this.filter;
        this.map = map !== null && map !== void 0 ? map : this.map;
        this.keys = keys !== null && keys !== void 0 ? keys : this.keys;
        this.getId = getId !== null && getId !== void 0 ? getId : this.getId;
    }
    add(model) {
        const modelId = this.getId(model);
        if (this.cachedData[modelId]) this.update(model);
        else if (this.filter(model)) {
            const keys = this.keys(model);
            const mappedModel = this.map(model);
            this.cachedData[modelId] = {
                modelKeys: keys,
                modelMap: mappedModel
            };
            keys.forEach((key)=>{
                var _this$modelsByKey$get;
                this.modelsByKey.set(key, (_this$modelsByKey$get = this.modelsByKey.get(key)) !== null && _this$modelsByKey$get !== void 0 ? _this$modelsByKey$get : new Set());
                this.modelsByKey.get(key).add(mappedModel);
            });
        }
    }
    update(model) {
        this.delete(model);
        this.add(model);
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    updateMany(models) {
        models.forEach((model)=>{
            this.delete(model);
            this.add(model);
        });
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    delete(model) {
        const modelId = this.getId(model);
        const cachedData = this.cachedData[modelId];
        if (cachedData) {
            if (cachedData !== null && cachedData !== void 0 && cachedData.modelKeys) cachedData.modelKeys.forEach((key)=>{
                if (this.modelsByKey.has(key)) this.modelsByKey.get(key).delete(cachedData.modelMap);
            });
            delete this.cachedData[modelId];
        }
    }
    get lookup() {
        return Object.fromEntries([
            ...this.modelsByKey
        ].map(([k, v])=>[
                k,
                [
                    ...v
                ]
            ]));
    }
    get(key) {
        if (this.has(key)) return [
            ...this.modelsByKey.get(key)
        ];
        else return [];
    }
    has(key) {
        return this.modelsByKey.has(key);
    }
    clear() {
        this.cachedData = {};
        this.modelsByKey = new Map();
    }
}, $68d923ddea32787b$var$_descriptor4 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class2.prototype, "cachedData", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $68d923ddea32787b$var$_descriptor5 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class2.prototype, "modelsByKey", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class2.prototype, "lookup", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class2.prototype, "lookup"), $68d923ddea32787b$var$_class2.prototype), $68d923ddea32787b$var$_class2);
let $68d923ddea32787b$var$ManyModelsByKey = ($68d923ddea32787b$var$_class3 = class ManyModelsByKey {
    constructor({ filter: filter, map: map, key: key, getId: getId }){
        $68d923ddea32787b$var$_defineProperty(this, "filter", (m)=>true);
        $68d923ddea32787b$var$_defineProperty(this, "map", (m)=>m);
        $68d923ddea32787b$var$_defineProperty(this, "key", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $68d923ddea32787b$var$_defineProperty(this, "getId", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "cachedData", $68d923ddea32787b$var$_descriptor6, this);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "modelsByKey", $68d923ddea32787b$var$_descriptor7, this);
        (0, $d8hWe.makeObservable)(this);
        this.filter = filter !== null && filter !== void 0 ? filter : this.filter;
        this.map = map !== null && map !== void 0 ? map : this.map;
        this.key = key !== null && key !== void 0 ? key : this.key;
        this.getId = getId !== null && getId !== void 0 ? getId : this.getId;
    }
    add(model) {
        const modelId = this.getId(model);
        if (this.cachedData[modelId]) this.update(model);
        else if (this.filter(model)) {
            var _this$modelsByKey$get2;
            const key = this.key(model);
            const mappedModel = this.map(model);
            this.cachedData[modelId] = {
                modelKey: key,
                modelMap: mappedModel
            };
            this.modelsByKey.set(key, (_this$modelsByKey$get2 = this.modelsByKey.get(key)) !== null && _this$modelsByKey$get2 !== void 0 ? _this$modelsByKey$get2 : new Set());
            this.modelsByKey.get(key).add(mappedModel);
        }
    }
    update(model) {
        this.delete(model);
        this.add(model);
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    updateMany(models) {
        models.forEach((model)=>{
            this.delete(model);
            this.add(model);
        });
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    delete(model) {
        const modelId = this.getId(model);
        const cachedData = this.cachedData[modelId];
        if (cachedData) {
            if (this.modelsByKey.has(cachedData.modelKey)) this.modelsByKey.get(cachedData.modelKey).delete(cachedData.modelMap);
            delete this.cachedData[modelId];
        }
    }
    get lookup() {
        return Object.fromEntries([
            ...this.modelsByKey
        ].map(([k, v])=>[
                k,
                [
                    ...v
                ]
            ]));
    }
    get(key) {
        if (this.has(key)) return [
            ...this.modelsByKey.get(key)
        ];
        else return [];
    }
    has(key) {
        return this.modelsByKey.has(key);
    }
    clear() {
        this.cachedData = {};
        this.modelsByKey = new Map();
    }
}, $68d923ddea32787b$var$_descriptor6 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class3.prototype, "cachedData", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $68d923ddea32787b$var$_descriptor7 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class3.prototype, "modelsByKey", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class3.prototype, "lookup", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class3.prototype, "lookup"), $68d923ddea32787b$var$_class3.prototype), $68d923ddea32787b$var$_class3);
let $68d923ddea32787b$var$UniqueModelsByKey = ($68d923ddea32787b$var$_class4 = class UniqueModelsByKey {
    constructor({ filter: filter, map: map, key: key, getId: getId }){
        $68d923ddea32787b$var$_defineProperty(this, "filter", (m)=>true);
        $68d923ddea32787b$var$_defineProperty(this, "map", (m)=>m);
        $68d923ddea32787b$var$_defineProperty(this, "key", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $68d923ddea32787b$var$_defineProperty(this, "getId", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "cachedData", $68d923ddea32787b$var$_descriptor8, this);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "modelsByKey", $68d923ddea32787b$var$_descriptor9, this);
        (0, $d8hWe.makeObservable)(this);
        this.filter = filter !== null && filter !== void 0 ? filter : this.filter;
        this.map = map !== null && map !== void 0 ? map : this.map;
        this.key = key !== null && key !== void 0 ? key : this.key;
        this.getId = getId !== null && getId !== void 0 ? getId : this.getId;
    }
    add(model) {
        const modelId = this.getId(model);
        if (this.cachedData[modelId]) this.update(model);
        else if (this.filter(model)) {
            const key = this.key(model);
            const mappedModel = this.map(model);
            this.cachedData[modelId] = {
                modelKey: key
            };
            this.modelsByKey.set(key, mappedModel);
        }
    }
    update(model) {
        this.delete(model);
        this.add(model);
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    updateMany(models) {
        models.forEach((model)=>{
            this.delete(model);
            this.add(model);
        });
    // NOTE - this really kills performance, don't do it
    // this.cachedData = { ...this.cachedData }
    // this.modelsByKey = new Map(this.modelsByKey)
    }
    delete(model) {
        const modelId = this.getId(model);
        const cachedData = this.cachedData[modelId];
        if (cachedData) {
            if (this.modelsByKey.has(cachedData.modelKey)) this.modelsByKey.delete(cachedData.modelKey);
            delete this.cachedData[modelId];
        }
    }
    get lookup() {
        return Object.fromEntries(this.modelsByKey);
    }
    get(key) {
        if (this.has(key)) return this.modelsByKey.get(key);
        else return undefined;
    }
    has(key) {
        return this.modelsByKey.has(key);
    }
    clear() {
        this.cachedData = {};
        this.modelsByKey = new Map();
    }
}, $68d923ddea32787b$var$_descriptor8 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class4.prototype, "cachedData", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $68d923ddea32787b$var$_descriptor9 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class4.prototype, "modelsByKey", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class4.prototype, "lookup", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class4.prototype, "lookup"), $68d923ddea32787b$var$_class4.prototype), $68d923ddea32787b$var$_class4);
let $68d923ddea32787b$var$ModelList = ($68d923ddea32787b$var$_class5 = class ModelList {
    constructor({ filter: filter, map: map, key: key, getId: getId }){
        $68d923ddea32787b$var$_defineProperty(this, "filter", (m)=>true);
        $68d923ddea32787b$var$_defineProperty(this, "map", (m)=>m);
        $68d923ddea32787b$var$_defineProperty(this, "getId", (m)=>m === null || m === void 0 ? void 0 : m.id);
        $68d923ddea32787b$var$_initializerDefineProperty(this, "models", $68d923ddea32787b$var$_descriptor10, this);
        (0, $d8hWe.makeObservable)(this);
        this.filter = filter !== null && filter !== void 0 ? filter : this.filter;
        this.map = map !== null && map !== void 0 ? map : this.map;
        this.getId = getId !== null && getId !== void 0 ? getId : this.getId;
    }
    add(model) {
        const modelId = this.getId(model);
        if (this.models.get(modelId)) this.update(model);
        else if (this.filter(model)) {
            const mappedModel = this.map(model);
            this.models.set(modelId, mappedModel);
        }
    }
    update(model) {
        this.delete(model);
        this.add(model);
    // NOTE - this really kills performance, don't do it
    // this.models = new Map(this.models)
    }
    updateMany(models) {
        models.forEach((model)=>{
            this.delete(model);
            this.add(model);
        });
    // NOTE - this really kills performance, don't do it
    // this.models = new Map(this.models)
    }
    delete(model) {
        const modelId = this.getId(model);
        if (this.models.has(modelId)) this.models.delete(modelId);
    }
    get lookup() {
        return [
            ...this.models.values()
        ];
    }
    has(model) {
        const modelId = this.getId(model);
        return this.models.has(modelId);
    }
    get(model) {
        const modelId = this.getId(model);
        return this.models.get(modelId);
    }
    clear() {
        this.models = new Map();
    }
}, $68d923ddea32787b$var$_descriptor10 = $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class5.prototype, "models", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $68d923ddea32787b$var$_applyDecoratedDescriptor($68d923ddea32787b$var$_class5.prototype, "lookup", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($68d923ddea32787b$var$_class5.prototype, "lookup"), $68d923ddea32787b$var$_class5.prototype), $68d923ddea32787b$var$_class5);
var $68d923ddea32787b$export$2e2bcd8739ae039 = $68d923ddea32787b$var$Collection;

});
parcelRegister("cjCbh", function(module, exports) {
/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */ 
var $2sWKF = parcelRequire("2sWKF");

var $fxK0W = parcelRequire("fxK0W");

var $35h8d = parcelRequire("35h8d");
var $8f74e0529d74a570$var$c = 0, $8f74e0529d74a570$var$blockSize = 4, $8f74e0529d74a570$var$base = 36, $8f74e0529d74a570$var$discreteValues = Math.pow($8f74e0529d74a570$var$base, $8f74e0529d74a570$var$blockSize);
function $8f74e0529d74a570$var$randomBlock() {
    return $fxK0W(($35h8d() * $8f74e0529d74a570$var$discreteValues << 0).toString($8f74e0529d74a570$var$base), $8f74e0529d74a570$var$blockSize);
}
function $8f74e0529d74a570$var$safeCounter() {
    $8f74e0529d74a570$var$c = $8f74e0529d74a570$var$c < $8f74e0529d74a570$var$discreteValues ? $8f74e0529d74a570$var$c : 0;
    $8f74e0529d74a570$var$c++; // this is not subliminal
    return $8f74e0529d74a570$var$c - 1;
}
function $8f74e0529d74a570$var$cuid() {
    // Starting with a lowercase letter makes
    // it HTML element ID friendly.
    var letter = "c", // timestamp
    // warning: this exposes the exact date and time
    // that the uid was created.
    timestamp = new Date().getTime().toString($8f74e0529d74a570$var$base), // Prevent same-machine collisions.
    counter = $fxK0W($8f74e0529d74a570$var$safeCounter().toString($8f74e0529d74a570$var$base), $8f74e0529d74a570$var$blockSize), // A few chars to generate distinct ids for different
    // clients (so different computers are far less
    // likely to generate the same id)
    print = $2sWKF(), // Grab some more chars from Math.random()
    random = $8f74e0529d74a570$var$randomBlock() + $8f74e0529d74a570$var$randomBlock();
    return letter + timestamp + counter + print + random;
}
$8f74e0529d74a570$var$cuid.slug = function slug() {
    var date = new Date().getTime().toString(36), counter = $8f74e0529d74a570$var$safeCounter().toString(36).slice(-4), print = $2sWKF().slice(0, 1) + $2sWKF().slice(-1), random = $8f74e0529d74a570$var$randomBlock().slice(-2);
    return date.slice(-2) + counter + print + random;
};
$8f74e0529d74a570$var$cuid.isCuid = function isCuid(stringToCheck) {
    if (typeof stringToCheck !== "string") return false;
    if (stringToCheck.startsWith("c")) return true;
    return false;
};
$8f74e0529d74a570$var$cuid.isSlug = function isSlug(stringToCheck) {
    if (typeof stringToCheck !== "string") return false;
    var stringLength = stringToCheck.length;
    if (stringLength >= 7 && stringLength <= 10) return true;
    return false;
};
$8f74e0529d74a570$var$cuid.fingerprint = $2sWKF;
module.exports = $8f74e0529d74a570$var$cuid;

});
parcelRegister("2sWKF", function(module, exports) {

var $fxK0W = parcelRequire("fxK0W");
var $1cbbc5291678b539$var$env = typeof window === "object" ? window : self;
var $1cbbc5291678b539$var$globalCount = Object.keys($1cbbc5291678b539$var$env).length;
var $1cbbc5291678b539$var$mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var $1cbbc5291678b539$var$clientId = $fxK0W(($1cbbc5291678b539$var$mimeTypesLength + navigator.userAgent.length).toString(36) + $1cbbc5291678b539$var$globalCount.toString(36), 4);
module.exports = function fingerprint() {
    return $1cbbc5291678b539$var$clientId;
};

});
parcelRegister("fxK0W", function(module, exports) {
module.exports = function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
};

});


parcelRegister("35h8d", function(module, exports) {
var $23ef20ae5ecc3794$var$getRandomValue;
var $23ef20ae5ecc3794$var$crypto = typeof window !== "undefined" && (window.crypto || window.msCrypto) || typeof self !== "undefined" && self.crypto;
if ($23ef20ae5ecc3794$var$crypto) {
    var $23ef20ae5ecc3794$var$lim = Math.pow(2, 32) - 1;
    $23ef20ae5ecc3794$var$getRandomValue = function() {
        return Math.abs($23ef20ae5ecc3794$var$crypto.getRandomValues(new Uint32Array(1))[0] / $23ef20ae5ecc3794$var$lim);
    };
} else $23ef20ae5ecc3794$var$getRandomValue = Math.random;
module.exports = $23ef20ae5ecc3794$var$getRandomValue;

});


parcelRegister("aJxsR", function(module, exports) {
/* global define */ (function(root, pluralize) {
    // Node.
    module.exports = pluralize();
})(module.exports, function() {
    // Rule storage - pluralize and singularize need to be run sequentially,
    // while other rules can be optimized using an object for instant lookups.
    var pluralRules = [];
    var singularRules = [];
    var uncountables = {};
    var irregularPlurals = {};
    var irregularSingles = {};
    /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */ function sanitizeRule(rule) {
        if (typeof rule === "string") return new RegExp("^" + rule + "$", "i");
        return rule;
    }
    /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */ function restoreCase(word, token) {
        // Tokens are an exact match.
        if (word === token) return token;
        // Lower cased words. E.g. "hello".
        if (word === word.toLowerCase()) return token.toLowerCase();
        // Upper cased words. E.g. "WHISKY".
        if (word === word.toUpperCase()) return token.toUpperCase();
        // Title cased words. E.g. "Title".
        if (word[0] === word[0].toUpperCase()) return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        // Lower cased words. E.g. "test".
        return token.toLowerCase();
    }
    /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */ function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function(match, index) {
            return args[index] || "";
        });
    }
    /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */ function replace(word, rule) {
        return word.replace(rule[0], function(match, index) {
            var result = interpolate(rule[1], arguments);
            if (match === "") return restoreCase(word[index - 1], result);
            return restoreCase(match, result);
        });
    }
    /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */ function sanitizeWord(token, word, rules) {
        // Empty string or doesn't need fixing.
        if (!token.length || uncountables.hasOwnProperty(token)) return word;
        var len = rules.length;
        // Iterate over the sanitization rules and use the first one to match.
        while(len--){
            var rule = rules[len];
            if (rule[0].test(word)) return replace(word, rule);
        }
        return word;
    }
    /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */ function replaceWord(replaceMap, keepMap, rules) {
        return function(word) {
            // Get the correct token and case restoration functions.
            var token = word.toLowerCase();
            // Check against the keep object map.
            if (keepMap.hasOwnProperty(token)) return restoreCase(word, token);
            // Check against the replacement map for a direct word replacement.
            if (replaceMap.hasOwnProperty(token)) return restoreCase(word, replaceMap[token]);
            // Run all the rules against the word.
            return sanitizeWord(token, word, rules);
        };
    }
    /**
   * Check if a word is part of the map.
   */ function checkWord(replaceMap, keepMap, rules, bool) {
        return function(word) {
            var token = word.toLowerCase();
            if (keepMap.hasOwnProperty(token)) return true;
            if (replaceMap.hasOwnProperty(token)) return false;
            return sanitizeWord(token, token, rules) === token;
        };
    }
    /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */ function pluralize(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);
        return (inclusive ? count + " " : "") + pluralized;
    }
    /**
   * Pluralize a word.
   *
   * @type {Function}
   */ pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Check if a word is plural.
   *
   * @type {Function}
   */ pluralize.isPlural = checkWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Singularize a word.
   *
   * @type {Function}
   */ pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Check if a word is singular.
   *
   * @type {Function}
   */ pluralize.isSingular = checkWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addPluralRule = function(rule, replacement) {
        pluralRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addSingularRule = function(rule, replacement) {
        singularRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */ pluralize.addUncountableRule = function(word) {
        if (typeof word === "string") {
            uncountables[word.toLowerCase()] = true;
            return;
        }
        // Set singular and plural references for the word.
        pluralize.addPluralRule(word, "$0");
        pluralize.addSingularRule(word, "$0");
    };
    /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */ pluralize.addIrregularRule = function(single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
    };
    /**
   * Irregular rules.
   */ [
        // Pronouns.
        [
            "I",
            "we"
        ],
        [
            "me",
            "us"
        ],
        [
            "he",
            "they"
        ],
        [
            "she",
            "they"
        ],
        [
            "them",
            "them"
        ],
        [
            "myself",
            "ourselves"
        ],
        [
            "yourself",
            "yourselves"
        ],
        [
            "itself",
            "themselves"
        ],
        [
            "herself",
            "themselves"
        ],
        [
            "himself",
            "themselves"
        ],
        [
            "themself",
            "themselves"
        ],
        [
            "is",
            "are"
        ],
        [
            "was",
            "were"
        ],
        [
            "has",
            "have"
        ],
        [
            "this",
            "these"
        ],
        [
            "that",
            "those"
        ],
        // Words ending in with a consonant and `o`.
        [
            "echo",
            "echoes"
        ],
        [
            "dingo",
            "dingoes"
        ],
        [
            "volcano",
            "volcanoes"
        ],
        [
            "tornado",
            "tornadoes"
        ],
        [
            "torpedo",
            "torpedoes"
        ],
        // Ends with `us`.
        [
            "genus",
            "genera"
        ],
        [
            "viscus",
            "viscera"
        ],
        // Ends with `ma`.
        [
            "stigma",
            "stigmata"
        ],
        [
            "stoma",
            "stomata"
        ],
        [
            "dogma",
            "dogmata"
        ],
        [
            "lemma",
            "lemmata"
        ],
        [
            "schema",
            "schemata"
        ],
        [
            "anathema",
            "anathemata"
        ],
        // Other irregular rules.
        [
            "ox",
            "oxen"
        ],
        [
            "axe",
            "axes"
        ],
        [
            "die",
            "dice"
        ],
        [
            "yes",
            "yeses"
        ],
        [
            "foot",
            "feet"
        ],
        [
            "eave",
            "eaves"
        ],
        [
            "goose",
            "geese"
        ],
        [
            "tooth",
            "teeth"
        ],
        [
            "quiz",
            "quizzes"
        ],
        [
            "human",
            "humans"
        ],
        [
            "proof",
            "proofs"
        ],
        [
            "carve",
            "carves"
        ],
        [
            "valve",
            "valves"
        ],
        [
            "looey",
            "looies"
        ],
        [
            "thief",
            "thieves"
        ],
        [
            "groove",
            "grooves"
        ],
        [
            "pickaxe",
            "pickaxes"
        ],
        [
            "passerby",
            "passersby"
        ]
    ].forEach(function(rule) {
        return pluralize.addIrregularRule(rule[0], rule[1]);
    });
    /**
   * Pluralization rules.
   */ [
        [
            /s?$/i,
            "s"
        ],
        [
            /[^\u0000-\u007F]$/i,
            "$0"
        ],
        [
            /([^aeiou]ese)$/i,
            "$1"
        ],
        [
            /(ax|test)is$/i,
            "$1es"
        ],
        [
            /(alias|[^aou]us|t[lm]as|gas|ris)$/i,
            "$1es"
        ],
        [
            /(e[mn]u)s?$/i,
            "$1s"
        ],
        [
            /([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i,
            "$1"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1i"
        ],
        [
            /(alumn|alg|vertebr)(?:a|ae)$/i,
            "$1ae"
        ],
        [
            /(seraph|cherub)(?:im)?$/i,
            "$1im"
        ],
        [
            /(her|at|gr)o$/i,
            "$1oes"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i,
            "$1a"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i,
            "$1a"
        ],
        [
            /sis$/i,
            "ses"
        ],
        [
            /(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i,
            "$1$2ves"
        ],
        [
            /([^aeiouy]|qu)y$/i,
            "$1ies"
        ],
        [
            /([^ch][ieo][ln])ey$/i,
            "$1ies"
        ],
        [
            /(x|ch|ss|sh|zz)$/i,
            "$1es"
        ],
        [
            /(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i,
            "$1ices"
        ],
        [
            /\b((?:tit)?m|l)(?:ice|ouse)$/i,
            "$1ice"
        ],
        [
            /(pe)(?:rson|ople)$/i,
            "$1ople"
        ],
        [
            /(child)(?:ren)?$/i,
            "$1ren"
        ],
        [
            /eaux$/i,
            "$0"
        ],
        [
            /m[ae]n$/i,
            "men"
        ],
        [
            "thou",
            "you"
        ]
    ].forEach(function(rule) {
        return pluralize.addPluralRule(rule[0], rule[1]);
    });
    /**
   * Singularization rules.
   */ [
        [
            /s$/i,
            ""
        ],
        [
            /(ss)$/i,
            "$1"
        ],
        [
            /(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i,
            "$1fe"
        ],
        [
            /(ar|(?:wo|[ae])l|[eo][ao])ves$/i,
            "$1f"
        ],
        [
            /ies$/i,
            "y"
        ],
        [
            /\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i,
            "$1ie"
        ],
        [
            /\b(mon|smil)ies$/i,
            "$1ey"
        ],
        [
            /\b((?:tit)?m|l)ice$/i,
            "$1ouse"
        ],
        [
            /(seraph|cherub)im$/i,
            "$1"
        ],
        [
            /(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i,
            "$1"
        ],
        [
            /(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i,
            "$1sis"
        ],
        [
            /(movie|twelve|abuse|e[mn]u)s$/i,
            "$1"
        ],
        [
            /(test)(?:is|es)$/i,
            "$1is"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1us"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i,
            "$1um"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i,
            "$1on"
        ],
        [
            /(alumn|alg|vertebr)ae$/i,
            "$1a"
        ],
        [
            /(cod|mur|sil|vert|ind)ices$/i,
            "$1ex"
        ],
        [
            /(matr|append)ices$/i,
            "$1ix"
        ],
        [
            /(pe)(rson|ople)$/i,
            "$1rson"
        ],
        [
            /(child)ren$/i,
            "$1"
        ],
        [
            /(eau)x?$/i,
            "$1"
        ],
        [
            /men$/i,
            "man"
        ]
    ].forEach(function(rule) {
        return pluralize.addSingularRule(rule[0], rule[1]);
    });
    /**
   * Uncountable rules.
   */ [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        /deer$/i,
        /fish$/i,
        /measles$/i,
        /o[iu]s$/i,
        /pox$/i,
        /sheep$/i
    ].forEach(pluralize.addUncountableRule);
    return pluralize;
});

});

parcelRegister("fqmGV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3aae2bd6bac9e71$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $cjCbh = parcelRequire("cjCbh");
parcelRequire("dBifK");


var $hiuv4 = parcelRequire("hiuv4");

var $egx7S = parcelRequire("egx7S");

var $kyFlA = parcelRequire("kyFlA");
var $b3aae2bd6bac9e71$var$_dec, $b3aae2bd6bac9e71$var$_dec2, $b3aae2bd6bac9e71$var$_dec3, $b3aae2bd6bac9e71$var$_dec4, $b3aae2bd6bac9e71$var$_dec5, $b3aae2bd6bac9e71$var$_dec6, $b3aae2bd6bac9e71$var$_dec7, $b3aae2bd6bac9e71$var$_class, $b3aae2bd6bac9e71$var$_descriptor, $b3aae2bd6bac9e71$var$_descriptor2, $b3aae2bd6bac9e71$var$_descriptor3, $b3aae2bd6bac9e71$var$_descriptor4, $b3aae2bd6bac9e71$var$_descriptor5, $b3aae2bd6bac9e71$var$_descriptor6, $b3aae2bd6bac9e71$var$_descriptor7, $b3aae2bd6bac9e71$var$_descriptor8, $b3aae2bd6bac9e71$var$_descriptor9;
function $b3aae2bd6bac9e71$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $b3aae2bd6bac9e71$var$_defineProperty(e, r, t) {
    return (r = $b3aae2bd6bac9e71$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b3aae2bd6bac9e71$var$_toPropertyKey(t) {
    var i = $b3aae2bd6bac9e71$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b3aae2bd6bac9e71$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $b3aae2bd6bac9e71$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $b3aae2bd6bac9e71$var$Model = ($b3aae2bd6bac9e71$var$_dec = (0, $d8hWe.action).bound, $b3aae2bd6bac9e71$var$_dec2 = (0, $d8hWe.action).bound, $b3aae2bd6bac9e71$var$_dec3 = (0, $d8hWe.action).bound, $b3aae2bd6bac9e71$var$_dec4 = (0, $d8hWe.action).bound, $b3aae2bd6bac9e71$var$_dec5 = (0, $d8hWe.action).bound, $b3aae2bd6bac9e71$var$_dec6 = (0, $d8hWe.action).bound, $b3aae2bd6bac9e71$var$_dec7 = (0, $d8hWe.action).bound, $b3aae2bd6bac9e71$var$_class = class Model {
    constructor(){
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "id", $b3aae2bd6bac9e71$var$_descriptor, this);
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "savedAt", $b3aae2bd6bac9e71$var$_descriptor2, this);
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "updatedAt", $b3aae2bd6bac9e71$var$_descriptor3, this);
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "deletedAt", $b3aae2bd6bac9e71$var$_descriptor4, this);
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "updateHistory", $b3aae2bd6bac9e71$var$_descriptor5, this);
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "initialized", $b3aae2bd6bac9e71$var$_descriptor6, this);
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "history", $b3aae2bd6bac9e71$var$_descriptor7, this);
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "detached", $b3aae2bd6bac9e71$var$_descriptor8, this);
        $b3aae2bd6bac9e71$var$_initializerDefineProperty(this, "failedToSave", $b3aae2bd6bac9e71$var$_descriptor9, this);
        $b3aae2bd6bac9e71$var$_defineProperty(this, "collection", null);
        $b3aae2bd6bac9e71$var$_defineProperty(this, "createdAt", null);
        $b3aae2bd6bac9e71$var$_defineProperty(this, "deletedAt", null);
        $b3aae2bd6bac9e71$var$_defineProperty(this, "initiatedAt", new Date());
        (0, $d8hWe.makeObservable)(this);
    }
    init(data, options = {}) {
        var _data$id, _options$detached;
        data = data instanceof Model ? data.serialize() : data;
        this.id = (_data$id = data.id) !== null && _data$id !== void 0 ? _data$id : this.id;
        this.savedAt = !options.trackUpdates ? this.updatedAt : null;
        this.detached = (_options$detached = options.detached) !== null && _options$detached !== void 0 ? _options$detached : false;
        this.update(data, {
            trackUpdates: false,
            source: "self",
            ...options
        });
        this.initialized = true;
    }
    get modelType() {
        return this.collection.modelType;
    }
    update(data, { trackUpdates: trackUpdates = true, savedAt: savedAt, source: source } = {}) {
        data = data instanceof Model ? data.serialize() : data;
        if (savedAt) {
            this.savedAt = savedAt;
            this.createdAt || (this.createdAt = new Date());
            //TODO this is bad
            for (const ts of this.updateHistory.keys())if (ts < savedAt) this.updateHistory.delete(ts);
        }
        for (const [key, value] of Object.entries(data))if (trackUpdates || source !== "collection" && source !== "self" || !this.updatedProps.has(key)) this.changeProp(key, value, {
            trackUpdates: trackUpdates
        });
        if (!this.detached && source !== "collection" && source !== "self" && this.collection.onUpdate) this.collection.onUpdate(this.id);
        if (!this.createdAt && this.deletedAt) this.collection.delete(this.id);
    }
    changeProp(prop, val, { trackUpdates: trackUpdates = true } = {}) {
        if (prop === "history") {
            this.history = val.map((e)=>new (0, $kyFlA.default)(this, e));
            return;
        }
        if ((prop.toLowerCase().includes("date") || prop.endsWith("At")) && val && !(val instanceof Date)) val = isNaN(new Date(val)) ? (0, $egx7S.parse)(val, "yyyy-MM-dd", new Date()) : (0, $egx7S.startOfDay)(new Date(val));
        // Check if the property is not present in the current instance and add it as an observable
        if (!this.hasOwnProperty(prop) && !(0, $d8hWe.isComputedProp)(this, prop)) (0, $d8hWe.extendObservable)(this, {
            [prop]: val
        });
        else this[((0, $d8hWe.isComputedProp)(this, prop) ? "_" : "") + prop] = val;
        if (trackUpdates) {
            this.updatedAt = new Date();
            if (!this.updateHistory.has(this.updatedAt)) this.updateHistory.set(this.updatedAt, []);
            this.updateHistory.get(this.updatedAt).push(prop);
        }
    }
    get updatedProps() {
        return new Set([
            ...this.updateHistory.values()
        ].flat().filter((prop)=>![
                "collection",
                "detached",
                "failedToSave",
                "initiatedAt"
            ].includes(prop)));
    }
    get latestUpdatedTime() {
        return [
            ...this.updateHistory.keys()
        ].sort().reverse()[0];
    }
    serialize() {
        let serialized = (0, $hiuv4.default).serialize(Object.fromEntries((0, $d8hWe.entries)(this).filter((e)=>![
                "savedAt",
                "updateHistory",
                "initialized"
            ].includes(e[0])).map((e)=>{
            if (e[0].includes("Id") && e[1] == null) {
                var _this$e$0$replace;
                return [
                    e[0],
                    (_this$e$0$replace = this[e[0].replace("Id", "")]) === null || _this$e$0$replace === void 0 ? void 0 : _this$e$0$replace.id
                ];
            }
            return e;
        }))).json;
        if (!this.createdAt) serialized.createdAt = (0, $egx7S.format)(this.initiatedAt, "yyyy-MM-dd HH:mm:ss");
        return serialized;
    }
    serializeUpdates() {
        let serialized = (0, $hiuv4.default).serialize(Object.fromEntries([
            [
                "id",
                this.id
            ],
            ...[
                ...this.updatedProps
            ].map((up)=>[
                    up,
                    this[up] instanceof Date ? (0, $egx7S.format)(this[up], "yyyy-MM-dd") : this[up]
                ]).map((e)=>{
                if (e[0].includes("Id") && e[1] == null) {
                    var _this$e$0$replace2;
                    return [
                        e[0],
                        (_this$e$0$replace2 = this[e[0].replace("Id", "")]) === null || _this$e$0$replace2 === void 0 ? void 0 : _this$e$0$replace2.id
                    ];
                }
                return e;
            })
        ])).json;
        if (!this.createdAt) serialized.createdAt = (0, $egx7S.format)(this.initiatedAt, "yyyy-MM-dd HH:mm:ss");
        return serialized;
    }
    get needsSaving() {
        return Boolean(this.updatedProps.size && this.latestUpdatedTime > this.savedAt);
    }
    clone(newData, options = {}) {
        const newId = (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))();
        const data = {
            ...this.serialize(),
            ...newData,
            id: newId
        };
        if (!options.detached) return this.collection.add(data, options);
        else return new this.constructor(data, options);
    }
    attach() {
        if (this.detached) {
            this.collection.add(this);
            this.detached = false;
        }
    }
}, $b3aae2bd6bac9e71$var$_descriptor = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "id", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))();
    }
}), $b3aae2bd6bac9e71$var$_descriptor2 = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "savedAt", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b3aae2bd6bac9e71$var$_descriptor3 = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "updatedAt", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $b3aae2bd6bac9e71$var$_descriptor4 = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "deletedAt", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $b3aae2bd6bac9e71$var$_descriptor5 = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "updateHistory", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $b3aae2bd6bac9e71$var$_descriptor6 = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "initialized", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $b3aae2bd6bac9e71$var$_descriptor7 = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "history", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $b3aae2bd6bac9e71$var$_descriptor8 = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "detached", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $b3aae2bd6bac9e71$var$_descriptor9 = $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "failedToSave", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "init", [
    $b3aae2bd6bac9e71$var$_dec
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "init"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "modelType", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "modelType"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "update", [
    $b3aae2bd6bac9e71$var$_dec2
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "update"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "changeProp", [
    $b3aae2bd6bac9e71$var$_dec3
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "changeProp"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "updatedProps", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "updatedProps"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "latestUpdatedTime", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "latestUpdatedTime"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "serialize", [
    $b3aae2bd6bac9e71$var$_dec4
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "serialize"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "serializeUpdates", [
    $b3aae2bd6bac9e71$var$_dec5
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "serializeUpdates"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "needsSaving", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "needsSaving"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "clone", [
    $b3aae2bd6bac9e71$var$_dec6
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "clone"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_applyDecoratedDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "attach", [
    $b3aae2bd6bac9e71$var$_dec7
], Object.getOwnPropertyDescriptor($b3aae2bd6bac9e71$var$_class.prototype, "attach"), $b3aae2bd6bac9e71$var$_class.prototype), $b3aae2bd6bac9e71$var$_class);
var $b3aae2bd6bac9e71$export$2e2bcd8739ae039 = $b3aae2bd6bac9e71$var$Model;

});
parcelRegister("egx7S", function(module, exports) {
"use strict";

var $OzG2U = parcelRequire("OzG2U");
Object.keys($OzG2U).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $OzG2U[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $OzG2U[key];
        }
    });
});

var $btUMY = parcelRequire("btUMY");
Object.keys($btUMY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $btUMY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $btUMY[key];
        }
    });
});

var $7hUpB = parcelRequire("7hUpB");
Object.keys($7hUpB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7hUpB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7hUpB[key];
        }
    });
});

var $dXVrc = parcelRequire("dXVrc");
Object.keys($dXVrc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dXVrc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dXVrc[key];
        }
    });
});

var $adsKU = parcelRequire("adsKU");
Object.keys($adsKU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $adsKU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $adsKU[key];
        }
    });
});

var $jgywm = parcelRequire("jgywm");
Object.keys($jgywm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jgywm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jgywm[key];
        }
    });
});

var $6NFmg = parcelRequire("6NFmg");
Object.keys($6NFmg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6NFmg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6NFmg[key];
        }
    });
});

var $4rTHm = parcelRequire("4rTHm");
Object.keys($4rTHm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4rTHm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4rTHm[key];
        }
    });
});

var $idUxy = parcelRequire("idUxy");
Object.keys($idUxy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $idUxy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $idUxy[key];
        }
    });
});

var $3y0b1 = parcelRequire("3y0b1");
Object.keys($3y0b1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3y0b1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3y0b1[key];
        }
    });
});

var $328s2 = parcelRequire("328s2");
Object.keys($328s2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $328s2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $328s2[key];
        }
    });
});

var $5kmuZ = parcelRequire("5kmuZ");
Object.keys($5kmuZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5kmuZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5kmuZ[key];
        }
    });
});

var $dTm28 = parcelRequire("dTm28");
Object.keys($dTm28).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dTm28[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dTm28[key];
        }
    });
});

var $lfnDm = parcelRequire("lfnDm");
Object.keys($lfnDm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lfnDm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lfnDm[key];
        }
    });
});

var $cfJsd = parcelRequire("cfJsd");
Object.keys($cfJsd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cfJsd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cfJsd[key];
        }
    });
});

var $7TFQk = parcelRequire("7TFQk");
Object.keys($7TFQk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7TFQk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7TFQk[key];
        }
    });
});

var $g0C3p = parcelRequire("g0C3p");
Object.keys($g0C3p).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g0C3p[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g0C3p[key];
        }
    });
});

var $2h6rH = parcelRequire("2h6rH");
Object.keys($2h6rH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2h6rH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2h6rH[key];
        }
    });
});

var $2J98k = parcelRequire("2J98k");
Object.keys($2J98k).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2J98k[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2J98k[key];
        }
    });
});

var $4w0cM = parcelRequire("4w0cM");
Object.keys($4w0cM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4w0cM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4w0cM[key];
        }
    });
});

var $5Oxgf = parcelRequire("5Oxgf");
Object.keys($5Oxgf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Oxgf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Oxgf[key];
        }
    });
});

var $5mMbR = parcelRequire("5mMbR");
Object.keys($5mMbR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5mMbR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5mMbR[key];
        }
    });
});

var $dNCuX = parcelRequire("dNCuX");
Object.keys($dNCuX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dNCuX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dNCuX[key];
        }
    });
});

var $bfN4C = parcelRequire("bfN4C");
Object.keys($bfN4C).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bfN4C[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bfN4C[key];
        }
    });
});

var $cWnUy = parcelRequire("cWnUy");
Object.keys($cWnUy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cWnUy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cWnUy[key];
        }
    });
});

var $5p9kz = parcelRequire("5p9kz");
Object.keys($5p9kz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5p9kz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5p9kz[key];
        }
    });
});

var $cp3hy = parcelRequire("cp3hy");
Object.keys($cp3hy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cp3hy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cp3hy[key];
        }
    });
});

var $cFg1S = parcelRequire("cFg1S");
Object.keys($cFg1S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cFg1S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cFg1S[key];
        }
    });
});

var $gWC9G = parcelRequire("gWC9G");
Object.keys($gWC9G).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gWC9G[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gWC9G[key];
        }
    });
});

var $lJGm5 = parcelRequire("lJGm5");
Object.keys($lJGm5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lJGm5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lJGm5[key];
        }
    });
});

var $aEauj = parcelRequire("aEauj");
Object.keys($aEauj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aEauj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aEauj[key];
        }
    });
});

var $c2Csk = parcelRequire("c2Csk");
Object.keys($c2Csk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c2Csk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c2Csk[key];
        }
    });
});

var $bV4No = parcelRequire("bV4No");
Object.keys($bV4No).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bV4No[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bV4No[key];
        }
    });
});

var $3v3tg = parcelRequire("3v3tg");
Object.keys($3v3tg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3v3tg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3v3tg[key];
        }
    });
});

var $cd1xf = parcelRequire("cd1xf");
Object.keys($cd1xf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cd1xf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cd1xf[key];
        }
    });
});

var $iNa7s = parcelRequire("iNa7s");
Object.keys($iNa7s).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iNa7s[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iNa7s[key];
        }
    });
});

var $kDfdQ = parcelRequire("kDfdQ");
Object.keys($kDfdQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kDfdQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kDfdQ[key];
        }
    });
});

var $iA8Ge = parcelRequire("iA8Ge");
Object.keys($iA8Ge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iA8Ge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iA8Ge[key];
        }
    });
});

var $b53t3 = parcelRequire("b53t3");
Object.keys($b53t3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b53t3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b53t3[key];
        }
    });
});

var $jc25u = parcelRequire("jc25u");
Object.keys($jc25u).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jc25u[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jc25u[key];
        }
    });
});

var $eW6Kv = parcelRequire("eW6Kv");
Object.keys($eW6Kv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eW6Kv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eW6Kv[key];
        }
    });
});

var $1FS2F = parcelRequire("1FS2F");
Object.keys($1FS2F).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1FS2F[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1FS2F[key];
        }
    });
});

var $fzDNf = parcelRequire("fzDNf");
Object.keys($fzDNf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fzDNf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fzDNf[key];
        }
    });
});

var $lIzMC = parcelRequire("lIzMC");
Object.keys($lIzMC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lIzMC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lIzMC[key];
        }
    });
});

var $drPXf = parcelRequire("drPXf");
Object.keys($drPXf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $drPXf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $drPXf[key];
        }
    });
});

var $7GFCF = parcelRequire("7GFCF");
Object.keys($7GFCF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7GFCF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7GFCF[key];
        }
    });
});

var $5Qeoz = parcelRequire("5Qeoz");
Object.keys($5Qeoz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Qeoz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Qeoz[key];
        }
    });
});

var $fFQ1j = parcelRequire("fFQ1j");
Object.keys($fFQ1j).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fFQ1j[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fFQ1j[key];
        }
    });
});

var $1GAoB = parcelRequire("1GAoB");
Object.keys($1GAoB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1GAoB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1GAoB[key];
        }
    });
});

var $ikboz = parcelRequire("ikboz");
Object.keys($ikboz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ikboz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ikboz[key];
        }
    });
});

var $cucJ4 = parcelRequire("cucJ4");
Object.keys($cucJ4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cucJ4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cucJ4[key];
        }
    });
});

var $gQjr2 = parcelRequire("gQjr2");
Object.keys($gQjr2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gQjr2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gQjr2[key];
        }
    });
});

var $arloc = parcelRequire("arloc");
Object.keys($arloc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $arloc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $arloc[key];
        }
    });
});

var $g3XHD = parcelRequire("g3XHD");
Object.keys($g3XHD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g3XHD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g3XHD[key];
        }
    });
});

var $f8sbe = parcelRequire("f8sbe");
Object.keys($f8sbe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f8sbe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f8sbe[key];
        }
    });
});

var $idbU5 = parcelRequire("idbU5");
Object.keys($idbU5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $idbU5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $idbU5[key];
        }
    });
});

var $czanW = parcelRequire("czanW");
Object.keys($czanW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $czanW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $czanW[key];
        }
    });
});

var $dd1ko = parcelRequire("dd1ko");
Object.keys($dd1ko).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dd1ko[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dd1ko[key];
        }
    });
});

var $hHOzE = parcelRequire("hHOzE");
Object.keys($hHOzE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hHOzE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hHOzE[key];
        }
    });
});

var $9Lm8F = parcelRequire("9Lm8F");
Object.keys($9Lm8F).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9Lm8F[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9Lm8F[key];
        }
    });
});

var $Bbtyo = parcelRequire("Bbtyo");
Object.keys($Bbtyo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $Bbtyo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $Bbtyo[key];
        }
    });
});

var $29JwN = parcelRequire("29JwN");
Object.keys($29JwN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $29JwN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $29JwN[key];
        }
    });
});

var $3qMFg = parcelRequire("3qMFg");
Object.keys($3qMFg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3qMFg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3qMFg[key];
        }
    });
});

var $a5wsS = parcelRequire("a5wsS");
Object.keys($a5wsS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a5wsS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a5wsS[key];
        }
    });
});

var $cXAdF = parcelRequire("cXAdF");
Object.keys($cXAdF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cXAdF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cXAdF[key];
        }
    });
});

var $7aQdr = parcelRequire("7aQdr");
Object.keys($7aQdr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7aQdr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7aQdr[key];
        }
    });
});

var $f713j = parcelRequire("f713j");
Object.keys($f713j).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f713j[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f713j[key];
        }
    });
});

var $1f0PT = parcelRequire("1f0PT");
Object.keys($1f0PT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1f0PT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1f0PT[key];
        }
    });
});

var $bRrVf = parcelRequire("bRrVf");
Object.keys($bRrVf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bRrVf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bRrVf[key];
        }
    });
});

var $dueTq = parcelRequire("dueTq");
Object.keys($dueTq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dueTq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dueTq[key];
        }
    });
});

var $bzn59 = parcelRequire("bzn59");
Object.keys($bzn59).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bzn59[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bzn59[key];
        }
    });
});

var $4gXiM = parcelRequire("4gXiM");
Object.keys($4gXiM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4gXiM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4gXiM[key];
        }
    });
});

var $89sdf = parcelRequire("89sdf");
Object.keys($89sdf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $89sdf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $89sdf[key];
        }
    });
});

var $fEL4X = parcelRequire("fEL4X");
Object.keys($fEL4X).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fEL4X[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fEL4X[key];
        }
    });
});

var $iXQEe = parcelRequire("iXQEe");
Object.keys($iXQEe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iXQEe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iXQEe[key];
        }
    });
});

var $1CXb3 = parcelRequire("1CXb3");
Object.keys($1CXb3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1CXb3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1CXb3[key];
        }
    });
});

var $honqr = parcelRequire("honqr");
Object.keys($honqr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $honqr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $honqr[key];
        }
    });
});

var $25jJv = parcelRequire("25jJv");
Object.keys($25jJv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $25jJv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $25jJv[key];
        }
    });
});

var $i2DV5 = parcelRequire("i2DV5");
Object.keys($i2DV5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i2DV5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i2DV5[key];
        }
    });
});

var $2GUBT = parcelRequire("2GUBT");
Object.keys($2GUBT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2GUBT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2GUBT[key];
        }
    });
});

var $bSxKo = parcelRequire("bSxKo");
Object.keys($bSxKo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bSxKo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bSxKo[key];
        }
    });
});

var $2IJZ3 = parcelRequire("2IJZ3");
Object.keys($2IJZ3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2IJZ3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2IJZ3[key];
        }
    });
});

var $2pXmW = parcelRequire("2pXmW");
Object.keys($2pXmW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2pXmW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2pXmW[key];
        }
    });
});

var $aumJk = parcelRequire("aumJk");
Object.keys($aumJk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aumJk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aumJk[key];
        }
    });
});

var $fF239 = parcelRequire("fF239");
Object.keys($fF239).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fF239[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fF239[key];
        }
    });
});

var $WJVCU = parcelRequire("WJVCU");
Object.keys($WJVCU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $WJVCU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $WJVCU[key];
        }
    });
});

var $kf69a = parcelRequire("kf69a");
Object.keys($kf69a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kf69a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kf69a[key];
        }
    });
});

var $j6n0z = parcelRequire("j6n0z");
Object.keys($j6n0z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j6n0z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j6n0z[key];
        }
    });
});

var $g07qF = parcelRequire("g07qF");
Object.keys($g07qF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g07qF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g07qF[key];
        }
    });
});

var $3MvNo = parcelRequire("3MvNo");
Object.keys($3MvNo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3MvNo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3MvNo[key];
        }
    });
});

var $f3o96 = parcelRequire("f3o96");
Object.keys($f3o96).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f3o96[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f3o96[key];
        }
    });
});

var $8Ghpp = parcelRequire("8Ghpp");
Object.keys($8Ghpp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8Ghpp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8Ghpp[key];
        }
    });
});

var $jjiLw = parcelRequire("jjiLw");
Object.keys($jjiLw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jjiLw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jjiLw[key];
        }
    });
});

var $jQ5tf = parcelRequire("jQ5tf");
Object.keys($jQ5tf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jQ5tf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jQ5tf[key];
        }
    });
});

var $kwLky = parcelRequire("kwLky");
Object.keys($kwLky).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kwLky[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kwLky[key];
        }
    });
});

var $cGISj = parcelRequire("cGISj");
Object.keys($cGISj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cGISj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cGISj[key];
        }
    });
});

var $eOJHF = parcelRequire("eOJHF");
Object.keys($eOJHF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eOJHF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eOJHF[key];
        }
    });
});

var $atSzF = parcelRequire("atSzF");
Object.keys($atSzF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $atSzF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $atSzF[key];
        }
    });
});

var $jrEu3 = parcelRequire("jrEu3");
Object.keys($jrEu3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jrEu3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jrEu3[key];
        }
    });
});

var $WiUGI = parcelRequire("WiUGI");
Object.keys($WiUGI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $WiUGI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $WiUGI[key];
        }
    });
});

var $lbAnK = parcelRequire("lbAnK");
Object.keys($lbAnK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lbAnK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lbAnK[key];
        }
    });
});

var $arZLy = parcelRequire("arZLy");
Object.keys($arZLy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $arZLy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $arZLy[key];
        }
    });
});

var $5vR3l = parcelRequire("5vR3l");
Object.keys($5vR3l).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5vR3l[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5vR3l[key];
        }
    });
});

var $giaCC = parcelRequire("giaCC");
Object.keys($giaCC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $giaCC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $giaCC[key];
        }
    });
});

var $khUWr = parcelRequire("khUWr");
Object.keys($khUWr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $khUWr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $khUWr[key];
        }
    });
});

var $ifdHb = parcelRequire("ifdHb");
Object.keys($ifdHb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ifdHb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ifdHb[key];
        }
    });
});

var $14uNq = parcelRequire("14uNq");
Object.keys($14uNq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $14uNq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $14uNq[key];
        }
    });
});

var $6ZpXn = parcelRequire("6ZpXn");
Object.keys($6ZpXn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6ZpXn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6ZpXn[key];
        }
    });
});

var $3elBl = parcelRequire("3elBl");
Object.keys($3elBl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3elBl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3elBl[key];
        }
    });
});

var $ezU5r = parcelRequire("ezU5r");
Object.keys($ezU5r).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ezU5r[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ezU5r[key];
        }
    });
});

var $4DhEl = parcelRequire("4DhEl");
Object.keys($4DhEl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4DhEl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4DhEl[key];
        }
    });
});

var $7QKjt = parcelRequire("7QKjt");
Object.keys($7QKjt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7QKjt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7QKjt[key];
        }
    });
});

var $bbwWq = parcelRequire("bbwWq");
Object.keys($bbwWq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bbwWq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bbwWq[key];
        }
    });
});

var $9BjRD = parcelRequire("9BjRD");
Object.keys($9BjRD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9BjRD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9BjRD[key];
        }
    });
});

var $b2ASO = parcelRequire("b2ASO");
Object.keys($b2ASO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b2ASO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b2ASO[key];
        }
    });
});

var $6NLud = parcelRequire("6NLud");
Object.keys($6NLud).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6NLud[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6NLud[key];
        }
    });
});

var $gFQqQ = parcelRequire("gFQqQ");
Object.keys($gFQqQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gFQqQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gFQqQ[key];
        }
    });
});

var $RmBFW = parcelRequire("RmBFW");
Object.keys($RmBFW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $RmBFW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $RmBFW[key];
        }
    });
});

var $hJ5b4 = parcelRequire("hJ5b4");
Object.keys($hJ5b4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hJ5b4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hJ5b4[key];
        }
    });
});

var $hD7uI = parcelRequire("hD7uI");
Object.keys($hD7uI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hD7uI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hD7uI[key];
        }
    });
});

var $g0OLy = parcelRequire("g0OLy");
Object.keys($g0OLy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g0OLy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g0OLy[key];
        }
    });
});

var $io8gj = parcelRequire("io8gj");
Object.keys($io8gj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $io8gj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $io8gj[key];
        }
    });
});

var $c8V0T = parcelRequire("c8V0T");
Object.keys($c8V0T).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c8V0T[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c8V0T[key];
        }
    });
});

var $1bbhh = parcelRequire("1bbhh");
Object.keys($1bbhh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1bbhh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1bbhh[key];
        }
    });
});

var $5edZi = parcelRequire("5edZi");
Object.keys($5edZi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5edZi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5edZi[key];
        }
    });
});

var $bymJ7 = parcelRequire("bymJ7");
Object.keys($bymJ7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bymJ7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bymJ7[key];
        }
    });
});

var $NKXNy = parcelRequire("NKXNy");
Object.keys($NKXNy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $NKXNy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $NKXNy[key];
        }
    });
});

var $476Jo = parcelRequire("476Jo");
Object.keys($476Jo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $476Jo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $476Jo[key];
        }
    });
});

var $iDaHS = parcelRequire("iDaHS");
Object.keys($iDaHS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iDaHS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iDaHS[key];
        }
    });
});

var $lPsfi = parcelRequire("lPsfi");
Object.keys($lPsfi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lPsfi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lPsfi[key];
        }
    });
});

var $2dno9 = parcelRequire("2dno9");
Object.keys($2dno9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2dno9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2dno9[key];
        }
    });
});

var $bPg8t = parcelRequire("bPg8t");
Object.keys($bPg8t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bPg8t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bPg8t[key];
        }
    });
});

var $7jGvd = parcelRequire("7jGvd");
Object.keys($7jGvd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7jGvd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7jGvd[key];
        }
    });
});

var $iPTMn = parcelRequire("iPTMn");
Object.keys($iPTMn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iPTMn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iPTMn[key];
        }
    });
});

var $YyN1t = parcelRequire("YyN1t");
Object.keys($YyN1t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $YyN1t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $YyN1t[key];
        }
    });
});

var $2KVDZ = parcelRequire("2KVDZ");
Object.keys($2KVDZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2KVDZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2KVDZ[key];
        }
    });
});

var $3OW6D = parcelRequire("3OW6D");
Object.keys($3OW6D).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3OW6D[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3OW6D[key];
        }
    });
});

var $6T9rM = parcelRequire("6T9rM");
Object.keys($6T9rM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6T9rM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6T9rM[key];
        }
    });
});

var $di1ga = parcelRequire("di1ga");
Object.keys($di1ga).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $di1ga[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $di1ga[key];
        }
    });
});

var $3iEpi = parcelRequire("3iEpi");
Object.keys($3iEpi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3iEpi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3iEpi[key];
        }
    });
});

var $ktaGp = parcelRequire("ktaGp");
Object.keys($ktaGp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ktaGp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ktaGp[key];
        }
    });
});

var $fZFQo = parcelRequire("fZFQo");
Object.keys($fZFQo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fZFQo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fZFQo[key];
        }
    });
});

var $kQY2r = parcelRequire("kQY2r");
Object.keys($kQY2r).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kQY2r[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kQY2r[key];
        }
    });
});

var $lx1jR = parcelRequire("lx1jR");
Object.keys($lx1jR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lx1jR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lx1jR[key];
        }
    });
});

var $3vnA2 = parcelRequire("3vnA2");
Object.keys($3vnA2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3vnA2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3vnA2[key];
        }
    });
});

var $8SDsI = parcelRequire("8SDsI");
Object.keys($8SDsI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8SDsI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8SDsI[key];
        }
    });
});

var $ciwJI = parcelRequire("ciwJI");
Object.keys($ciwJI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ciwJI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ciwJI[key];
        }
    });
});

var $0ZGpW = parcelRequire("0ZGpW");
Object.keys($0ZGpW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $0ZGpW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0ZGpW[key];
        }
    });
});

var $bTkgf = parcelRequire("bTkgf");
Object.keys($bTkgf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bTkgf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bTkgf[key];
        }
    });
});

var $hdwg1 = parcelRequire("hdwg1");
Object.keys($hdwg1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hdwg1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hdwg1[key];
        }
    });
});

var $cm2SN = parcelRequire("cm2SN");
Object.keys($cm2SN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cm2SN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cm2SN[key];
        }
    });
});

var $lo7Ds = parcelRequire("lo7Ds");
Object.keys($lo7Ds).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lo7Ds[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lo7Ds[key];
        }
    });
});

var $fYJkS = parcelRequire("fYJkS");
Object.keys($fYJkS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fYJkS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fYJkS[key];
        }
    });
});

var $844AJ = parcelRequire("844AJ");
Object.keys($844AJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $844AJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $844AJ[key];
        }
    });
});

var $1Lgka = parcelRequire("1Lgka");
Object.keys($1Lgka).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1Lgka[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1Lgka[key];
        }
    });
});

var $aKdYW = parcelRequire("aKdYW");
Object.keys($aKdYW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aKdYW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aKdYW[key];
        }
    });
});

var $iTWqO = parcelRequire("iTWqO");
Object.keys($iTWqO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iTWqO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iTWqO[key];
        }
    });
});

var $icrY8 = parcelRequire("icrY8");
Object.keys($icrY8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $icrY8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $icrY8[key];
        }
    });
});

var $jIzNc = parcelRequire("jIzNc");
Object.keys($jIzNc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jIzNc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jIzNc[key];
        }
    });
});

var $fw6tY = parcelRequire("fw6tY");
Object.keys($fw6tY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fw6tY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fw6tY[key];
        }
    });
});

var $kb76g = parcelRequire("kb76g");
Object.keys($kb76g).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kb76g[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kb76g[key];
        }
    });
});

var $44UCa = parcelRequire("44UCa");
Object.keys($44UCa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $44UCa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $44UCa[key];
        }
    });
});

var $kkRuc = parcelRequire("kkRuc");
Object.keys($kkRuc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kkRuc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kkRuc[key];
        }
    });
});

var $hu2Ob = parcelRequire("hu2Ob");
Object.keys($hu2Ob).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hu2Ob[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hu2Ob[key];
        }
    });
});

var $lRpRz = parcelRequire("lRpRz");
Object.keys($lRpRz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lRpRz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lRpRz[key];
        }
    });
});

var $fm3oy = parcelRequire("fm3oy");
Object.keys($fm3oy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fm3oy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fm3oy[key];
        }
    });
});

var $i2ARk = parcelRequire("i2ARk");
Object.keys($i2ARk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i2ARk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i2ARk[key];
        }
    });
});

var $8ZAW1 = parcelRequire("8ZAW1");
Object.keys($8ZAW1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8ZAW1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ZAW1[key];
        }
    });
});

var $bWXQK = parcelRequire("bWXQK");
Object.keys($bWXQK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bWXQK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bWXQK[key];
        }
    });
});

var $dGzVe = parcelRequire("dGzVe");
Object.keys($dGzVe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dGzVe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dGzVe[key];
        }
    });
});

var $82Mzr = parcelRequire("82Mzr");
Object.keys($82Mzr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $82Mzr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $82Mzr[key];
        }
    });
});

var $ce9pM = parcelRequire("ce9pM");
Object.keys($ce9pM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ce9pM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ce9pM[key];
        }
    });
});

var $2vbsV = parcelRequire("2vbsV");
Object.keys($2vbsV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2vbsV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2vbsV[key];
        }
    });
});

var $ccKuz = parcelRequire("ccKuz");
Object.keys($ccKuz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ccKuz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ccKuz[key];
        }
    });
});

var $7Ijc4 = parcelRequire("7Ijc4");
Object.keys($7Ijc4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Ijc4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Ijc4[key];
        }
    });
});

var $ftY8S = parcelRequire("ftY8S");
Object.keys($ftY8S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ftY8S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ftY8S[key];
        }
    });
});

var $5aL95 = parcelRequire("5aL95");
Object.keys($5aL95).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5aL95[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5aL95[key];
        }
    });
});

var $bdOW5 = parcelRequire("bdOW5");
Object.keys($bdOW5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bdOW5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bdOW5[key];
        }
    });
});

var $8xpCJ = parcelRequire("8xpCJ");
Object.keys($8xpCJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8xpCJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8xpCJ[key];
        }
    });
});

var $1LH4f = parcelRequire("1LH4f");
Object.keys($1LH4f).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1LH4f[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1LH4f[key];
        }
    });
});

var $dqWAw = parcelRequire("dqWAw");
Object.keys($dqWAw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dqWAw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dqWAw[key];
        }
    });
});

var $dPXOU = parcelRequire("dPXOU");
Object.keys($dPXOU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dPXOU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dPXOU[key];
        }
    });
});

var $k92Um = parcelRequire("k92Um");
Object.keys($k92Um).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k92Um[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k92Um[key];
        }
    });
});

var $6rfyX = parcelRequire("6rfyX");
Object.keys($6rfyX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6rfyX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6rfyX[key];
        }
    });
});

var $14wBS = parcelRequire("14wBS");
Object.keys($14wBS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $14wBS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $14wBS[key];
        }
    });
});

var $7juLA = parcelRequire("7juLA");
Object.keys($7juLA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7juLA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7juLA[key];
        }
    });
});

var $7eTIZ = parcelRequire("7eTIZ");
Object.keys($7eTIZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7eTIZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7eTIZ[key];
        }
    });
});

var $bkqji = parcelRequire("bkqji");
Object.keys($bkqji).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bkqji[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bkqji[key];
        }
    });
});

var $c00AA = parcelRequire("c00AA");
Object.keys($c00AA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c00AA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c00AA[key];
        }
    });
});

var $hsWy8 = parcelRequire("hsWy8");
Object.keys($hsWy8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hsWy8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hsWy8[key];
        }
    });
});

var $8ivM2 = parcelRequire("8ivM2");
Object.keys($8ivM2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8ivM2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ivM2[key];
        }
    });
});

var $bu2us = parcelRequire("bu2us");
Object.keys($bu2us).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bu2us[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bu2us[key];
        }
    });
});

var $aT2Tr = parcelRequire("aT2Tr");
Object.keys($aT2Tr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aT2Tr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aT2Tr[key];
        }
    });
});

var $2kaX6 = parcelRequire("2kaX6");
Object.keys($2kaX6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2kaX6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2kaX6[key];
        }
    });
});

var $kT6zj = parcelRequire("kT6zj");
Object.keys($kT6zj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kT6zj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kT6zj[key];
        }
    });
});

var $cLEfX = parcelRequire("cLEfX");
Object.keys($cLEfX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cLEfX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cLEfX[key];
        }
    });
});

var $jr5lN = parcelRequire("jr5lN");
Object.keys($jr5lN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jr5lN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jr5lN[key];
        }
    });
});

var $lBTco = parcelRequire("lBTco");
Object.keys($lBTco).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lBTco[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lBTco[key];
        }
    });
});

var $3jfnx = parcelRequire("3jfnx");
Object.keys($3jfnx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3jfnx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3jfnx[key];
        }
    });
});

var $fiS5J = parcelRequire("fiS5J");
Object.keys($fiS5J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fiS5J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fiS5J[key];
        }
    });
});

var $8vDrN = parcelRequire("8vDrN");
Object.keys($8vDrN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8vDrN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8vDrN[key];
        }
    });
});

var $kIsnz = parcelRequire("kIsnz");
Object.keys($kIsnz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kIsnz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kIsnz[key];
        }
    });
});

var $5LLIW = parcelRequire("5LLIW");
Object.keys($5LLIW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5LLIW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5LLIW[key];
        }
    });
});

var $5yDM3 = parcelRequire("5yDM3");
Object.keys($5yDM3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5yDM3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5yDM3[key];
        }
    });
});

var $6lDsN = parcelRequire("6lDsN");
Object.keys($6lDsN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6lDsN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6lDsN[key];
        }
    });
});

var $7GN8t = parcelRequire("7GN8t");
Object.keys($7GN8t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7GN8t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7GN8t[key];
        }
    });
});

var $4iQJE = parcelRequire("4iQJE");
Object.keys($4iQJE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4iQJE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4iQJE[key];
        }
    });
});

var $gw4mP = parcelRequire("gw4mP");
Object.keys($gw4mP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gw4mP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gw4mP[key];
        }
    });
});

var $hpXNO = parcelRequire("hpXNO");
Object.keys($hpXNO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hpXNO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hpXNO[key];
        }
    });
});

var $ihiFp = parcelRequire("ihiFp");
Object.keys($ihiFp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ihiFp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ihiFp[key];
        }
    });
});

var $a6G6p = parcelRequire("a6G6p");
Object.keys($a6G6p).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a6G6p[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a6G6p[key];
        }
    });
});

var $akaMM = parcelRequire("akaMM");
Object.keys($akaMM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $akaMM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $akaMM[key];
        }
    });
});

var $5QRqy = parcelRequire("5QRqy");
Object.keys($5QRqy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5QRqy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5QRqy[key];
        }
    });
});

var $3oyM0 = parcelRequire("3oyM0");
Object.keys($3oyM0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3oyM0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3oyM0[key];
        }
    });
});

var $dq7U3 = parcelRequire("dq7U3");
Object.keys($dq7U3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dq7U3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dq7U3[key];
        }
    });
});

var $kAYVg = parcelRequire("kAYVg");
Object.keys($kAYVg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kAYVg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kAYVg[key];
        }
    });
});

var $7cc1O = parcelRequire("7cc1O");
Object.keys($7cc1O).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7cc1O[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7cc1O[key];
        }
    });
});

var $g9NYq = parcelRequire("g9NYq");
Object.keys($g9NYq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g9NYq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g9NYq[key];
        }
    });
});

var $3tjSb = parcelRequire("3tjSb");
Object.keys($3tjSb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3tjSb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3tjSb[key];
        }
    });
});

var $cJLy9 = parcelRequire("cJLy9");
Object.keys($cJLy9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cJLy9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cJLy9[key];
        }
    });
});

var $6uf6b = parcelRequire("6uf6b");
Object.keys($6uf6b).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6uf6b[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6uf6b[key];
        }
    });
});

var $1rFVw = parcelRequire("1rFVw");
Object.keys($1rFVw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1rFVw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1rFVw[key];
        }
    });
});

var $1PSZi = parcelRequire("1PSZi");
Object.keys($1PSZi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1PSZi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1PSZi[key];
        }
    });
});

var $7bgap = parcelRequire("7bgap");
Object.keys($7bgap).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7bgap[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7bgap[key];
        }
    });
});

var $gJo6O = parcelRequire("gJo6O");
Object.keys($gJo6O).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gJo6O[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gJo6O[key];
        }
    });
});

var $coXV6 = parcelRequire("coXV6");
Object.keys($coXV6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $coXV6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $coXV6[key];
        }
    });
});

var $62iJ8 = parcelRequire("62iJ8");
Object.keys($62iJ8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $62iJ8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $62iJ8[key];
        }
    });
});

var $egOgU = parcelRequire("egOgU");
Object.keys($egOgU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $egOgU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $egOgU[key];
        }
    });
});

var $hcHwZ = parcelRequire("hcHwZ");
Object.keys($hcHwZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hcHwZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hcHwZ[key];
        }
    });
});

var $3Y7uu = parcelRequire("3Y7uu");
Object.keys($3Y7uu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3Y7uu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3Y7uu[key];
        }
    });
});

var $4tv7m = parcelRequire("4tv7m");
Object.keys($4tv7m).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4tv7m[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4tv7m[key];
        }
    });
});

var $6Osen = parcelRequire("6Osen");
Object.keys($6Osen).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6Osen[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6Osen[key];
        }
    });
});

var $1fmjP = parcelRequire("1fmjP");
Object.keys($1fmjP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1fmjP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1fmjP[key];
        }
    });
});

var $lCYRp = parcelRequire("lCYRp");
Object.keys($lCYRp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lCYRp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lCYRp[key];
        }
    });
});

var $640gz = parcelRequire("640gz");
Object.keys($640gz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $640gz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $640gz[key];
        }
    });
});

var $jZzj6 = parcelRequire("jZzj6");
Object.keys($jZzj6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jZzj6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jZzj6[key];
        }
    });
});

var $8J1Oa = parcelRequire("8J1Oa");
Object.keys($8J1Oa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8J1Oa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8J1Oa[key];
        }
    });
});

var $Sb1Z0 = parcelRequire("Sb1Z0");
Object.keys($Sb1Z0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $Sb1Z0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $Sb1Z0[key];
        }
    });
});

var $5ZYL6 = parcelRequire("5ZYL6");
Object.keys($5ZYL6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5ZYL6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5ZYL6[key];
        }
    });
});

var $2ZADR = parcelRequire("2ZADR");
Object.keys($2ZADR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2ZADR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ZADR[key];
        }
    });
});

var $e1R7Q = parcelRequire("e1R7Q");
Object.keys($e1R7Q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e1R7Q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e1R7Q[key];
        }
    });
});

var $7Swnx = parcelRequire("7Swnx");
Object.keys($7Swnx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Swnx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Swnx[key];
        }
    });
});

var $iAgyz = parcelRequire("iAgyz");
Object.keys($iAgyz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iAgyz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iAgyz[key];
        }
    });
});

var $8EBpB = parcelRequire("8EBpB");
Object.keys($8EBpB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8EBpB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8EBpB[key];
        }
    });
});

var $4TtZA = parcelRequire("4TtZA");
Object.keys($4TtZA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4TtZA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4TtZA[key];
        }
    });
});

});
parcelRegister("OzG2U", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $0980585dfdf13b3a$export$e16d8520af44a096; }, function (v) { return $0980585dfdf13b3a$export$e16d8520af44a096 = v; });
var $0980585dfdf13b3a$export$e16d8520af44a096;
"use strict";
$0980585dfdf13b3a$export$e16d8520af44a096 = $0980585dfdf13b3a$var$add;

var $7hUpB = parcelRequire("7hUpB");

var $4rTHm = parcelRequire("4rTHm");

var $2J98k = parcelRequire("2J98k");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $0980585dfdf13b3a$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $2ZADR.toDate)(date);
    const dateWithMonths = months || years ? (0, $4rTHm.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $7hUpB.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $2J98k.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});
parcelRegister("7hUpB", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $54e5e12d1f23d295$export$dd412b56f1e4d8aa; }, function (v) { return $54e5e12d1f23d295$export$dd412b56f1e4d8aa = v; });
var $54e5e12d1f23d295$export$dd412b56f1e4d8aa;
"use strict";
$54e5e12d1f23d295$export$dd412b56f1e4d8aa = $54e5e12d1f23d295$var$addDays;

var $2ZADR = parcelRequire("2ZADR");

var $2J98k = parcelRequire("2J98k");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $54e5e12d1f23d295$var$addDays(date, amount) {
    const _date = (0, $2ZADR.toDate)(date);
    if (isNaN(amount)) return (0, $2J98k.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});
parcelRegister("2ZADR", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $22ddb394f70a2f77$export$e67a095c620b86fe; }, function (v) { return $22ddb394f70a2f77$export$e67a095c620b86fe = v; });
var $22ddb394f70a2f77$export$e67a095c620b86fe;
"use strict";
$22ddb394f70a2f77$export$e67a095c620b86fe = $22ddb394f70a2f77$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $22ddb394f70a2f77$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});

parcelRegister("2J98k", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $1fc6de6aa6487d19$export$ead8a1812b171991; }, function (v) { return $1fc6de6aa6487d19$export$ead8a1812b171991 = v; });
var $1fc6de6aa6487d19$export$ead8a1812b171991;
"use strict";
$1fc6de6aa6487d19$export$ead8a1812b171991 = $1fc6de6aa6487d19$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $1fc6de6aa6487d19$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});


parcelRegister("4rTHm", function(module, exports) {

$parcel$export(module.exports, "addMonths", function () { return $33d4e3958a4a5c59$export$17c93e242b2d3a22; }, function (v) { return $33d4e3958a4a5c59$export$17c93e242b2d3a22 = v; });
var $33d4e3958a4a5c59$export$17c93e242b2d3a22;
"use strict";
$33d4e3958a4a5c59$export$17c93e242b2d3a22 = $33d4e3958a4a5c59$var$addMonths;

var $2ZADR = parcelRequire("2ZADR");

var $2J98k = parcelRequire("2J98k");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $33d4e3958a4a5c59$var$addMonths(date, amount) {
    const _date = (0, $2ZADR.toDate)(date);
    if (isNaN(amount)) return (0, $2J98k.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $2J98k.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});


parcelRegister("btUMY", function(module, exports) {

$parcel$export(module.exports, "addBusinessDays", function () { return $85be74407b1c0c03$export$f087b9ada3136ae9; }, function (v) { return $85be74407b1c0c03$export$f087b9ada3136ae9 = v; });
var $85be74407b1c0c03$export$f087b9ada3136ae9;
"use strict";
$85be74407b1c0c03$export$f087b9ada3136ae9 = $85be74407b1c0c03$var$addBusinessDays;

var $2J98k = parcelRequire("2J98k");

var $bPg8t = parcelRequire("bPg8t");

var $7jGvd = parcelRequire("7jGvd");

var $0ZGpW = parcelRequire("0ZGpW");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $85be74407b1c0c03$var$addBusinessDays(date, amount) {
    const _date = (0, $2ZADR.toDate)(date);
    const startedOnWeekend = (0, $0ZGpW.isWeekend)(_date);
    if (isNaN(amount)) return (0, $2J98k.constructFrom)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $0ZGpW.isWeekend)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $0ZGpW.isWeekend)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $bPg8t.isSaturday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $7jGvd.isSunday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}

});
parcelRegister("bPg8t", function(module, exports) {

$parcel$export(module.exports, "isSaturday", function () { return $89c0f950041e67e1$export$def9f260655b3a76; }, function (v) { return $89c0f950041e67e1$export$def9f260655b3a76 = v; });
var $89c0f950041e67e1$export$def9f260655b3a76;
"use strict";
$89c0f950041e67e1$export$def9f260655b3a76 = $89c0f950041e67e1$var$isSaturday;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $89c0f950041e67e1$var$isSaturday(date) {
    return (0, $2ZADR.toDate)(date).getDay() === 6;
}

});

parcelRegister("7jGvd", function(module, exports) {

$parcel$export(module.exports, "isSunday", function () { return $553b46dc6cf12394$export$70f720dfc6028987; }, function (v) { return $553b46dc6cf12394$export$70f720dfc6028987 = v; });
var $553b46dc6cf12394$export$70f720dfc6028987;
"use strict";
$553b46dc6cf12394$export$70f720dfc6028987 = $553b46dc6cf12394$var$isSunday;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $553b46dc6cf12394$var$isSunday(date) {
    return (0, $2ZADR.toDate)(date).getDay() === 0;
}

});

parcelRegister("0ZGpW", function(module, exports) {

$parcel$export(module.exports, "isWeekend", function () { return $002fd930e630c489$export$618d60ea299da42; }, function (v) { return $002fd930e630c489$export$618d60ea299da42 = v; });
var $002fd930e630c489$export$618d60ea299da42;
"use strict";
$002fd930e630c489$export$618d60ea299da42 = $002fd930e630c489$var$isWeekend;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $002fd930e630c489$var$isWeekend(date) {
    const day = (0, $2ZADR.toDate)(date).getDay();
    return day === 0 || day === 6;
}

});


parcelRegister("dXVrc", function(module, exports) {

$parcel$export(module.exports, "addHours", function () { return $a2ad56fc5bc8089f$export$4a4306ad4fa0e5e6; }, function (v) { return $a2ad56fc5bc8089f$export$4a4306ad4fa0e5e6 = v; });
var $a2ad56fc5bc8089f$export$4a4306ad4fa0e5e6;
"use strict";
$a2ad56fc5bc8089f$export$4a4306ad4fa0e5e6 = $a2ad56fc5bc8089f$var$addHours;

var $jgywm = parcelRequire("jgywm");

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $a2ad56fc5bc8089f$var$addHours(date, amount) {
    return (0, $jgywm.addMilliseconds)(date, amount * $jpzPN.millisecondsInHour);
}

});
parcelRegister("jgywm", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", function () { return $e06a4a18820bcc80$export$baf757aaf0c95c94; }, function (v) { return $e06a4a18820bcc80$export$baf757aaf0c95c94 = v; });
var $e06a4a18820bcc80$export$baf757aaf0c95c94;
"use strict";
$e06a4a18820bcc80$export$baf757aaf0c95c94 = $e06a4a18820bcc80$var$addMilliseconds;

var $2ZADR = parcelRequire("2ZADR");

var $2J98k = parcelRequire("2J98k");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $e06a4a18820bcc80$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $2ZADR.toDate)(date);
    return (0, $2J98k.constructFrom)(date, timestamp + amount);
}

});

parcelRegister("jpzPN", function(module, exports) {

$parcel$export(module.exports, "secondsInYear", function () { return $e21c261d6634349a$export$7271e9e3478110d1; }, function (v) { return $e21c261d6634349a$export$7271e9e3478110d1 = v; });
$parcel$export(module.exports, "secondsInWeek", function () { return $e21c261d6634349a$export$34804a017b31e2fe; }, function (v) { return $e21c261d6634349a$export$34804a017b31e2fe = v; });
$parcel$export(module.exports, "secondsInQuarter", function () { return $e21c261d6634349a$export$be1dccf2de902d31; }, function (v) { return $e21c261d6634349a$export$be1dccf2de902d31 = v; });
$parcel$export(module.exports, "secondsInMonth", function () { return $e21c261d6634349a$export$8e6600bbdee7dabb; }, function (v) { return $e21c261d6634349a$export$8e6600bbdee7dabb = v; });
$parcel$export(module.exports, "secondsInMinute", function () { return $e21c261d6634349a$export$a77c1a7ebebe2a5a; }, function (v) { return $e21c261d6634349a$export$a77c1a7ebebe2a5a = v; });
$parcel$export(module.exports, "secondsInHour", function () { return $e21c261d6634349a$export$698aec755e92c695; }, function (v) { return $e21c261d6634349a$export$698aec755e92c695 = v; });
$parcel$export(module.exports, "secondsInDay", function () { return $e21c261d6634349a$export$815a9362476d2fe3; }, function (v) { return $e21c261d6634349a$export$815a9362476d2fe3 = v; });
$parcel$export(module.exports, "quartersInYear", function () { return $e21c261d6634349a$export$4db7641526e3241f; }, function (v) { return $e21c261d6634349a$export$4db7641526e3241f = v; });
$parcel$export(module.exports, "monthsInYear", function () { return $e21c261d6634349a$export$80d7e435f744f319; }, function (v) { return $e21c261d6634349a$export$80d7e435f744f319 = v; });
$parcel$export(module.exports, "monthsInQuarter", function () { return $e21c261d6634349a$export$3c58128db900d44e; }, function (v) { return $e21c261d6634349a$export$3c58128db900d44e = v; });
$parcel$export(module.exports, "minutesInYear", function () { return $e21c261d6634349a$export$3633035e63cee86a; }, function (v) { return $e21c261d6634349a$export$3633035e63cee86a = v; });
$parcel$export(module.exports, "minutesInMonth", function () { return $e21c261d6634349a$export$ab7da2ccd1075c38; }, function (v) { return $e21c261d6634349a$export$ab7da2ccd1075c38 = v; });
$parcel$export(module.exports, "minutesInHour", function () { return $e21c261d6634349a$export$f2f5ae5a8e2d8f9f; }, function (v) { return $e21c261d6634349a$export$f2f5ae5a8e2d8f9f = v; });
$parcel$export(module.exports, "minutesInDay", function () { return $e21c261d6634349a$export$2423174df8cd3cd2; }, function (v) { return $e21c261d6634349a$export$2423174df8cd3cd2 = v; });
$parcel$export(module.exports, "millisecondsInWeek", function () { return $e21c261d6634349a$export$4fad13613e88edc8; }, function (v) { return $e21c261d6634349a$export$4fad13613e88edc8 = v; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $e21c261d6634349a$export$397c2d5776aa9055; }, function (v) { return $e21c261d6634349a$export$397c2d5776aa9055 = v; });
$parcel$export(module.exports, "millisecondsInMinute", function () { return $e21c261d6634349a$export$91246f0b9bd9beff; }, function (v) { return $e21c261d6634349a$export$91246f0b9bd9beff = v; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $e21c261d6634349a$export$7f72910d6dfd237a; }, function (v) { return $e21c261d6634349a$export$7f72910d6dfd237a = v; });
$parcel$export(module.exports, "millisecondsInDay", function () { return $e21c261d6634349a$export$b76b1809a2898f9a; }, function (v) { return $e21c261d6634349a$export$b76b1809a2898f9a = v; });
$parcel$export(module.exports, "daysInYear", function () { return $e21c261d6634349a$export$3913210603d8e9ae; }, function (v) { return $e21c261d6634349a$export$3913210603d8e9ae = v; });
$parcel$export(module.exports, "daysInWeek", function () { return $e21c261d6634349a$export$dfd9b671c89acc8e; }, function (v) { return $e21c261d6634349a$export$dfd9b671c89acc8e = v; });
var $e21c261d6634349a$export$7271e9e3478110d1;
var $e21c261d6634349a$export$34804a017b31e2fe;
var $e21c261d6634349a$export$be1dccf2de902d31;
var $e21c261d6634349a$export$8e6600bbdee7dabb;
var $e21c261d6634349a$export$a77c1a7ebebe2a5a;
var $e21c261d6634349a$export$698aec755e92c695;
var $e21c261d6634349a$export$815a9362476d2fe3;
var $e21c261d6634349a$export$4db7641526e3241f;
var $e21c261d6634349a$export$80d7e435f744f319;
var $e21c261d6634349a$export$3c58128db900d44e;
var $e21c261d6634349a$export$3633035e63cee86a;
var $e21c261d6634349a$export$ab7da2ccd1075c38;
var $e21c261d6634349a$export$f2f5ae5a8e2d8f9f;
var $e21c261d6634349a$export$2423174df8cd3cd2;
var $e21c261d6634349a$export$4dec998e48f9c246;
var $e21c261d6634349a$export$4fad13613e88edc8;
var $e21c261d6634349a$export$397c2d5776aa9055;
var $e21c261d6634349a$export$91246f0b9bd9beff;
var $e21c261d6634349a$export$7f72910d6dfd237a;
var $e21c261d6634349a$export$b76b1809a2898f9a;
var $e21c261d6634349a$export$81caae6e1cc7a622;
var $e21c261d6634349a$export$3913210603d8e9ae;
var $e21c261d6634349a$export$dfd9b671c89acc8e;
"use strict";
$e21c261d6634349a$export$7271e9e3478110d1 = $e21c261d6634349a$export$34804a017b31e2fe = $e21c261d6634349a$export$be1dccf2de902d31 = $e21c261d6634349a$export$8e6600bbdee7dabb = $e21c261d6634349a$export$a77c1a7ebebe2a5a = $e21c261d6634349a$export$698aec755e92c695 = $e21c261d6634349a$export$815a9362476d2fe3 = $e21c261d6634349a$export$4db7641526e3241f = $e21c261d6634349a$export$80d7e435f744f319 = $e21c261d6634349a$export$3c58128db900d44e = $e21c261d6634349a$export$3633035e63cee86a = $e21c261d6634349a$export$ab7da2ccd1075c38 = $e21c261d6634349a$export$f2f5ae5a8e2d8f9f = $e21c261d6634349a$export$2423174df8cd3cd2 = $e21c261d6634349a$export$4dec998e48f9c246 = $e21c261d6634349a$export$4fad13613e88edc8 = $e21c261d6634349a$export$397c2d5776aa9055 = $e21c261d6634349a$export$91246f0b9bd9beff = $e21c261d6634349a$export$7f72910d6dfd237a = $e21c261d6634349a$export$b76b1809a2898f9a = $e21c261d6634349a$export$81caae6e1cc7a622 = $e21c261d6634349a$export$3913210603d8e9ae = $e21c261d6634349a$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $e21c261d6634349a$var$daysInWeek = $e21c261d6634349a$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $e21c261d6634349a$var$daysInYear = $e21c261d6634349a$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $e21c261d6634349a$var$maxTime = $e21c261d6634349a$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $e21c261d6634349a$var$minTime = $e21c261d6634349a$export$4dec998e48f9c246 = -$e21c261d6634349a$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $e21c261d6634349a$var$millisecondsInWeek = $e21c261d6634349a$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $e21c261d6634349a$var$millisecondsInDay = $e21c261d6634349a$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $e21c261d6634349a$var$millisecondsInMinute = $e21c261d6634349a$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $e21c261d6634349a$var$millisecondsInHour = $e21c261d6634349a$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $e21c261d6634349a$var$millisecondsInSecond = $e21c261d6634349a$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $e21c261d6634349a$var$minutesInYear = $e21c261d6634349a$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $e21c261d6634349a$var$minutesInMonth = $e21c261d6634349a$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $e21c261d6634349a$var$minutesInDay = $e21c261d6634349a$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $e21c261d6634349a$var$minutesInHour = $e21c261d6634349a$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $e21c261d6634349a$var$monthsInQuarter = $e21c261d6634349a$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $e21c261d6634349a$var$monthsInYear = $e21c261d6634349a$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $e21c261d6634349a$var$quartersInYear = $e21c261d6634349a$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $e21c261d6634349a$var$secondsInHour = $e21c261d6634349a$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $e21c261d6634349a$var$secondsInMinute = $e21c261d6634349a$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $e21c261d6634349a$var$secondsInDay = $e21c261d6634349a$export$815a9362476d2fe3 = $e21c261d6634349a$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $e21c261d6634349a$var$secondsInWeek = $e21c261d6634349a$export$34804a017b31e2fe = $e21c261d6634349a$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $e21c261d6634349a$var$secondsInYear = $e21c261d6634349a$export$7271e9e3478110d1 = $e21c261d6634349a$var$secondsInDay * $e21c261d6634349a$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $e21c261d6634349a$var$secondsInMonth = $e21c261d6634349a$export$8e6600bbdee7dabb = $e21c261d6634349a$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $e21c261d6634349a$var$secondsInQuarter = $e21c261d6634349a$export$be1dccf2de902d31 = $e21c261d6634349a$var$secondsInMonth * 3;

});


parcelRegister("adsKU", function(module, exports) {

$parcel$export(module.exports, "addISOWeekYears", function () { return $77016c8710f53026$export$c8240694da10d5f; }, function (v) { return $77016c8710f53026$export$c8240694da10d5f = v; });
var $77016c8710f53026$export$c8240694da10d5f;
"use strict";
$77016c8710f53026$export$c8240694da10d5f = $77016c8710f53026$var$addISOWeekYears;

var $kf69a = parcelRequire("kf69a");

var $5yDM3 = parcelRequire("5yDM3");
/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $77016c8710f53026$var$addISOWeekYears(date, amount) {
    return (0, $5yDM3.setISOWeekYear)(date, (0, $kf69a.getISOWeekYear)(date) + amount);
}

});
parcelRegister("kf69a", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", function () { return $ebc9fa03fe45b7f8$export$3dbc52535f6f8fcc; }, function (v) { return $ebc9fa03fe45b7f8$export$3dbc52535f6f8fcc = v; });
var $ebc9fa03fe45b7f8$export$3dbc52535f6f8fcc;
"use strict";
$ebc9fa03fe45b7f8$export$3dbc52535f6f8fcc = $ebc9fa03fe45b7f8$var$getISOWeekYear;

var $2J98k = parcelRequire("2J98k");

var $kAYVg = parcelRequire("kAYVg");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $ebc9fa03fe45b7f8$var$getISOWeekYear(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $2J98k.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $kAYVg.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $2J98k.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $kAYVg.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});
parcelRegister("kAYVg", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", function () { return $efe66d69fe8e10af$export$6173213f95a4431e; }, function (v) { return $efe66d69fe8e10af$export$6173213f95a4431e = v; });
var $efe66d69fe8e10af$export$6173213f95a4431e;
"use strict";
$efe66d69fe8e10af$export$6173213f95a4431e = $efe66d69fe8e10af$var$startOfISOWeek;

var $7bgap = parcelRequire("7bgap");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $efe66d69fe8e10af$var$startOfISOWeek(date) {
    return (0, $7bgap.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("7bgap", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $53a619e81e7c0e52$export$42c81a444fbfb5d4; }, function (v) { return $53a619e81e7c0e52$export$42c81a444fbfb5d4 = v; });
var $53a619e81e7c0e52$export$42c81a444fbfb5d4;
"use strict";
$53a619e81e7c0e52$export$42c81a444fbfb5d4 = $53a619e81e7c0e52$var$startOfWeek;

var $2ZADR = parcelRequire("2ZADR");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $53a619e81e7c0e52$var$startOfWeek(date, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $2ZADR.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});
parcelRegister("w0VDZ", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $0603b5b3d55f1f1e$export$430a3269e24b912e; }, function (v) { return $0603b5b3d55f1f1e$export$430a3269e24b912e = v; });
$parcel$export(module.exports, "setDefaultOptions", function () { return $0603b5b3d55f1f1e$export$95365be1b0704abc; }, function (v) { return $0603b5b3d55f1f1e$export$95365be1b0704abc = v; });
var $0603b5b3d55f1f1e$export$430a3269e24b912e;
var $0603b5b3d55f1f1e$export$95365be1b0704abc;
"use strict";
$0603b5b3d55f1f1e$export$430a3269e24b912e = $0603b5b3d55f1f1e$var$getDefaultOptions;
$0603b5b3d55f1f1e$export$95365be1b0704abc = $0603b5b3d55f1f1e$var$setDefaultOptions;
let $0603b5b3d55f1f1e$var$defaultOptions = {};
function $0603b5b3d55f1f1e$var$getDefaultOptions() {
    return $0603b5b3d55f1f1e$var$defaultOptions;
}
function $0603b5b3d55f1f1e$var$setDefaultOptions(newOptions) {
    $0603b5b3d55f1f1e$var$defaultOptions = newOptions;
}

});




parcelRegister("5yDM3", function(module, exports) {

$parcel$export(module.exports, "setISOWeekYear", function () { return $40befb0d5dc1aa63$export$814397aabf10ab77; }, function (v) { return $40befb0d5dc1aa63$export$814397aabf10ab77 = v; });
var $40befb0d5dc1aa63$export$814397aabf10ab77;
"use strict";
$40befb0d5dc1aa63$export$814397aabf10ab77 = $40befb0d5dc1aa63$var$setISOWeekYear;

var $2J98k = parcelRequire("2J98k");

var $dNCuX = parcelRequire("dNCuX");

var $7cc1O = parcelRequire("7cc1O");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $40befb0d5dc1aa63$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $2ZADR.toDate)(date);
    const diff = (0, $dNCuX.differenceInCalendarDays)(_date, (0, $7cc1O.startOfISOWeekYear)(_date));
    const fourthOfJanuary = (0, $2J98k.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $7cc1O.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});
parcelRegister("dNCuX", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", function () { return $a0bdb6f0d6d81d02$export$4a02e9c37dab4871; }, function (v) { return $a0bdb6f0d6d81d02$export$4a02e9c37dab4871 = v; });
var $a0bdb6f0d6d81d02$export$4a02e9c37dab4871;
"use strict";
$a0bdb6f0d6d81d02$export$4a02e9c37dab4871 = $a0bdb6f0d6d81d02$var$differenceInCalendarDays;

var $jpzPN = parcelRequire("jpzPN");

var $5QRqy = parcelRequire("5QRqy");

var $koDIg = parcelRequire("koDIg");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $a0bdb6f0d6d81d02$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $5QRqy.startOfDay)(dateLeft);
    const startOfDayRight = (0, $5QRqy.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $koDIg.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $koDIg.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $jpzPN.millisecondsInDay);
}

});
parcelRegister("5QRqy", function(module, exports) {

$parcel$export(module.exports, "startOfDay", function () { return $442b409e65aba227$export$63fa379ae8a9ba2; }, function (v) { return $442b409e65aba227$export$63fa379ae8a9ba2 = v; });
var $442b409e65aba227$export$63fa379ae8a9ba2;
"use strict";
$442b409e65aba227$export$63fa379ae8a9ba2 = $442b409e65aba227$var$startOfDay;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $442b409e65aba227$var$startOfDay(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("koDIg", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $03d4fb44eac8feea$export$113002b5eff6e430; }, function (v) { return $03d4fb44eac8feea$export$113002b5eff6e430 = v; });
var $03d4fb44eac8feea$export$113002b5eff6e430;
"use strict";
$03d4fb44eac8feea$export$113002b5eff6e430 = $03d4fb44eac8feea$var$getTimezoneOffsetInMilliseconds;

var $2ZADR = parcelRequire("2ZADR");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $03d4fb44eac8feea$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("7cc1O", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", function () { return $53d2fbf22e4dec39$export$236bdfa374eb69a9; }, function (v) { return $53d2fbf22e4dec39$export$236bdfa374eb69a9 = v; });
var $53d2fbf22e4dec39$export$236bdfa374eb69a9;
"use strict";
$53d2fbf22e4dec39$export$236bdfa374eb69a9 = $53d2fbf22e4dec39$var$startOfISOWeekYear;

var $kf69a = parcelRequire("kf69a");

var $kAYVg = parcelRequire("kAYVg");

var $2J98k = parcelRequire("2J98k");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $53d2fbf22e4dec39$var$startOfISOWeekYear(date) {
    const year = (0, $kf69a.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $2J98k.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $kAYVg.startOfISOWeek)(fourthOfJanuary);
}

});



parcelRegister("6NFmg", function(module, exports) {

$parcel$export(module.exports, "addMinutes", function () { return $4f37668e9c1509b8$export$2287e3d29250119e; }, function (v) { return $4f37668e9c1509b8$export$2287e3d29250119e = v; });
var $4f37668e9c1509b8$export$2287e3d29250119e;
"use strict";
$4f37668e9c1509b8$export$2287e3d29250119e = $4f37668e9c1509b8$var$addMinutes;

var $jgywm = parcelRequire("jgywm");

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $4f37668e9c1509b8$var$addMinutes(date, amount) {
    return (0, $jgywm.addMilliseconds)(date, amount * $jpzPN.millisecondsInMinute);
}

});

parcelRegister("idUxy", function(module, exports) {

$parcel$export(module.exports, "addQuarters", function () { return $d4454c9591f4a2dc$export$c252a41d0fbed2ce; }, function (v) { return $d4454c9591f4a2dc$export$c252a41d0fbed2ce = v; });
var $d4454c9591f4a2dc$export$c252a41d0fbed2ce;
"use strict";
$d4454c9591f4a2dc$export$c252a41d0fbed2ce = $d4454c9591f4a2dc$var$addQuarters;

var $4rTHm = parcelRequire("4rTHm");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $d4454c9591f4a2dc$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $4rTHm.addMonths)(date, months);
}

});

parcelRegister("3y0b1", function(module, exports) {

$parcel$export(module.exports, "addSeconds", function () { return $2954af2bfe620b66$export$3cb31b0df13be68; }, function (v) { return $2954af2bfe620b66$export$3cb31b0df13be68 = v; });
var $2954af2bfe620b66$export$3cb31b0df13be68;
"use strict";
$2954af2bfe620b66$export$3cb31b0df13be68 = $2954af2bfe620b66$var$addSeconds;

var $jgywm = parcelRequire("jgywm");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $2954af2bfe620b66$var$addSeconds(date, amount) {
    return (0, $jgywm.addMilliseconds)(date, amount * 1000);
}

});

parcelRegister("328s2", function(module, exports) {

$parcel$export(module.exports, "addWeeks", function () { return $23581d373b3fdb66$export$ef501a2bb4f3ee6b; }, function (v) { return $23581d373b3fdb66$export$ef501a2bb4f3ee6b = v; });
var $23581d373b3fdb66$export$ef501a2bb4f3ee6b;
"use strict";
$23581d373b3fdb66$export$ef501a2bb4f3ee6b = $23581d373b3fdb66$var$addWeeks;

var $7hUpB = parcelRequire("7hUpB");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $23581d373b3fdb66$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $7hUpB.addDays)(date, days);
}

});

parcelRegister("5kmuZ", function(module, exports) {

$parcel$export(module.exports, "addYears", function () { return $3e1045c9e1a3e97c$export$3d83eec43f4ea476; }, function (v) { return $3e1045c9e1a3e97c$export$3d83eec43f4ea476 = v; });
var $3e1045c9e1a3e97c$export$3d83eec43f4ea476;
"use strict";
$3e1045c9e1a3e97c$export$3d83eec43f4ea476 = $3e1045c9e1a3e97c$var$addYears;

var $4rTHm = parcelRequire("4rTHm");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $3e1045c9e1a3e97c$var$addYears(date, amount) {
    return (0, $4rTHm.addMonths)(date, amount * 12);
}

});

parcelRegister("dTm28", function(module, exports) {

$parcel$export(module.exports, "areIntervalsOverlapping", function () { return $a1d180c89da6530c$export$2bf3385645436101; }, function (v) { return $a1d180c89da6530c$export$2bf3385645436101 = v; });
var $a1d180c89da6530c$export$2bf3385645436101;
"use strict";
$a1d180c89da6530c$export$2bf3385645436101 = $a1d180c89da6530c$var$areIntervalsOverlapping;

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $a1d180c89da6530c$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $2ZADR.toDate)(intervalLeft.start),
        +(0, $2ZADR.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $2ZADR.toDate)(intervalRight.start),
        +(0, $2ZADR.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

});

parcelRegister("lfnDm", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $f77d54dc95dc0352$export$7d15b64cf5a3a4c4; }, function (v) { return $f77d54dc95dc0352$export$7d15b64cf5a3a4c4 = v; });
var $f77d54dc95dc0352$export$7d15b64cf5a3a4c4;
"use strict";
$f77d54dc95dc0352$export$7d15b64cf5a3a4c4 = $f77d54dc95dc0352$var$clamp;

var $jIzNc = parcelRequire("jIzNc");

var $hu2Ob = parcelRequire("hu2Ob");
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $f77d54dc95dc0352$var$clamp(date, interval) {
    return (0, $hu2Ob.min)([
        (0, $jIzNc.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}

});
parcelRegister("jIzNc", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $e5ade402763104c2$export$8960430cfd85939f; }, function (v) { return $e5ade402763104c2$export$8960430cfd85939f = v; });
var $e5ade402763104c2$export$8960430cfd85939f;
"use strict";
$e5ade402763104c2$export$8960430cfd85939f = $e5ade402763104c2$var$max;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $e5ade402763104c2$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $2ZADR.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("hu2Ob", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $cba76ab61764e1d5$export$96ec731ed4dcb222; }, function (v) { return $cba76ab61764e1d5$export$96ec731ed4dcb222 = v; });
var $cba76ab61764e1d5$export$96ec731ed4dcb222;
"use strict";
$cba76ab61764e1d5$export$96ec731ed4dcb222 = $cba76ab61764e1d5$var$min;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $cba76ab61764e1d5$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $2ZADR.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

});


parcelRegister("cfJsd", function(module, exports) {

$parcel$export(module.exports, "closestIndexTo", function () { return $8eba24fa3829cca5$export$42127b72a9d091c7; }, function (v) { return $8eba24fa3829cca5$export$42127b72a9d091c7 = v; });
var $8eba24fa3829cca5$export$42127b72a9d091c7;
"use strict";
$8eba24fa3829cca5$export$42127b72a9d091c7 = $8eba24fa3829cca5$var$closestIndexTo;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $8eba24fa3829cca5$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $2ZADR.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $2ZADR.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("7TFQk", function(module, exports) {

$parcel$export(module.exports, "closestTo", function () { return $5bfe2096b6b2103d$export$73858b464497125a; }, function (v) { return $5bfe2096b6b2103d$export$73858b464497125a = v; });
var $5bfe2096b6b2103d$export$73858b464497125a;
"use strict";
$5bfe2096b6b2103d$export$73858b464497125a = $5bfe2096b6b2103d$var$closestTo;

var $2J98k = parcelRequire("2J98k");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $5bfe2096b6b2103d$var$closestTo(dateToCompare, dates) {
    const date = (0, $2ZADR.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, $2J98k.constructFrom)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $2ZADR.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $2J98k.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("g0C3p", function(module, exports) {

$parcel$export(module.exports, "compareAsc", function () { return $ba7a2a275bb95018$export$fe114145ae75d197; }, function (v) { return $ba7a2a275bb95018$export$fe114145ae75d197 = v; });
var $ba7a2a275bb95018$export$fe114145ae75d197;
"use strict";
$ba7a2a275bb95018$export$fe114145ae75d197 = $ba7a2a275bb95018$var$compareAsc;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $ba7a2a275bb95018$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("2h6rH", function(module, exports) {

$parcel$export(module.exports, "compareDesc", function () { return $1a822b46f4fe5bf4$export$ed84005ac9356f7a; }, function (v) { return $1a822b46f4fe5bf4$export$ed84005ac9356f7a = v; });
var $1a822b46f4fe5bf4$export$ed84005ac9356f7a;
"use strict";
$1a822b46f4fe5bf4$export$ed84005ac9356f7a = $1a822b46f4fe5bf4$var$compareDesc;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $1a822b46f4fe5bf4$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}

});

parcelRegister("4w0cM", function(module, exports) {

$parcel$export(module.exports, "constructNow", function () { return $349a4f5606015a68$export$18c3c6510fb97afc; }, function (v) { return $349a4f5606015a68$export$18c3c6510fb97afc = v; });
var $349a4f5606015a68$export$18c3c6510fb97afc;
"use strict";
$349a4f5606015a68$export$18c3c6510fb97afc = $349a4f5606015a68$var$constructNow;

var $2J98k = parcelRequire("2J98k");
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $349a4f5606015a68$var$constructNow(date) {
    return (0, $2J98k.constructFrom)(date, Date.now());
}

});

parcelRegister("5Oxgf", function(module, exports) {

$parcel$export(module.exports, "daysToWeeks", function () { return $43bb6c32c65bb0d8$export$66d8b66cbb6006a8; }, function (v) { return $43bb6c32c65bb0d8$export$66d8b66cbb6006a8 = v; });
var $43bb6c32c65bb0d8$export$66d8b66cbb6006a8;
"use strict";
$43bb6c32c65bb0d8$export$66d8b66cbb6006a8 = $43bb6c32c65bb0d8$var$daysToWeeks;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $43bb6c32c65bb0d8$var$daysToWeeks(days) {
    const weeks = days / $jpzPN.daysInWeek;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("5mMbR", function(module, exports) {

$parcel$export(module.exports, "differenceInBusinessDays", function () { return $3e846364cafb1e88$export$f30d3269a6c53cb9; }, function (v) { return $3e846364cafb1e88$export$f30d3269a6c53cb9 = v; });
var $3e846364cafb1e88$export$f30d3269a6c53cb9;
"use strict";
$3e846364cafb1e88$export$f30d3269a6c53cb9 = $3e846364cafb1e88$var$differenceInBusinessDays;

var $7hUpB = parcelRequire("7hUpB");

var $dNCuX = parcelRequire("dNCuX");

var $io8gj = parcelRequire("io8gj");

var $8SDsI = parcelRequire("8SDsI");

var $0ZGpW = parcelRequire("0ZGpW");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $3e846364cafb1e88$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    let _dateRight = (0, $2ZADR.toDate)(dateRight);
    if (!(0, $8SDsI.isValid)(_dateLeft) || !(0, $8SDsI.isValid)(_dateRight)) return NaN;
    const calendarDifference = (0, $dNCuX.differenceInCalendarDays)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $7hUpB.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $io8gj.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $0ZGpW.isWeekend)(_dateRight) ? 0 : sign;
        _dateRight = (0, $7hUpB.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("io8gj", function(module, exports) {

$parcel$export(module.exports, "isSameDay", function () { return $d630e08ea0973319$export$ea39ec197993aef0; }, function (v) { return $d630e08ea0973319$export$ea39ec197993aef0 = v; });
var $d630e08ea0973319$export$ea39ec197993aef0;
"use strict";
$d630e08ea0973319$export$ea39ec197993aef0 = $d630e08ea0973319$var$isSameDay;

var $5QRqy = parcelRequire("5QRqy");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $d630e08ea0973319$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $5QRqy.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $5QRqy.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRegister("8SDsI", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $6771fa3b9255ee10$export$1ea939691cdc45b8; }, function (v) { return $6771fa3b9255ee10$export$1ea939691cdc45b8 = v; });
var $6771fa3b9255ee10$export$1ea939691cdc45b8;
"use strict";
$6771fa3b9255ee10$export$1ea939691cdc45b8 = $6771fa3b9255ee10$var$isValid;

var $4DhEl = parcelRequire("4DhEl");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $6771fa3b9255ee10$var$isValid(date) {
    if (!(0, $4DhEl.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $2ZADR.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRegister("4DhEl", function(module, exports) {

$parcel$export(module.exports, "isDate", function () { return $35f87ed3cb8b948a$export$871608497c498473; }, function (v) { return $35f87ed3cb8b948a$export$871608497c498473 = v; });
var $35f87ed3cb8b948a$export$871608497c498473;
"use strict";
$35f87ed3cb8b948a$export$871608497c498473 = $35f87ed3cb8b948a$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $35f87ed3cb8b948a$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});



parcelRegister("bfN4C", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeekYears", function () { return $831729633a9ee1fc$export$7f8a73dc2e50a070; }, function (v) { return $831729633a9ee1fc$export$7f8a73dc2e50a070 = v; });
var $831729633a9ee1fc$export$7f8a73dc2e50a070;
"use strict";
$831729633a9ee1fc$export$7f8a73dc2e50a070 = $831729633a9ee1fc$var$differenceInCalendarISOWeekYears;

var $kf69a = parcelRequire("kf69a");
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $831729633a9ee1fc$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $kf69a.getISOWeekYear)(dateLeft) - (0, $kf69a.getISOWeekYear)(dateRight);
}

});

parcelRegister("cWnUy", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeeks", function () { return $96bd7313122305fb$export$28df1cb58b17e450; }, function (v) { return $96bd7313122305fb$export$28df1cb58b17e450 = v; });
var $96bd7313122305fb$export$28df1cb58b17e450;
"use strict";
$96bd7313122305fb$export$28df1cb58b17e450 = $96bd7313122305fb$var$differenceInCalendarISOWeeks;

var $jpzPN = parcelRequire("jpzPN");

var $kAYVg = parcelRequire("kAYVg");

var $koDIg = parcelRequire("koDIg");
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $96bd7313122305fb$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $kAYVg.startOfISOWeek)(dateLeft);
    const startOfISOWeekRight = (0, $kAYVg.startOfISOWeek)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $koDIg.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $koDIg.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $jpzPN.millisecondsInWeek);
}

});

parcelRegister("5p9kz", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", function () { return $3ef686725c85f729$export$489984ac7c996389; }, function (v) { return $3ef686725c85f729$export$489984ac7c996389 = v; });
var $3ef686725c85f729$export$489984ac7c996389;
"use strict";
$3ef686725c85f729$export$489984ac7c996389 = $3ef686725c85f729$var$differenceInCalendarMonths;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $3ef686725c85f729$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("cp3hy", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarQuarters", function () { return $907a5d955cffe4db$export$f62ae9fb13958c7a; }, function (v) { return $907a5d955cffe4db$export$f62ae9fb13958c7a = v; });
var $907a5d955cffe4db$export$f62ae9fb13958c7a;
"use strict";
$907a5d955cffe4db$export$f62ae9fb13958c7a = $907a5d955cffe4db$var$differenceInCalendarQuarters;

var $jjiLw = parcelRequire("jjiLw");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $907a5d955cffe4db$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $jjiLw.getQuarter)(_dateLeft) - (0, $jjiLw.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

});
parcelRegister("jjiLw", function(module, exports) {

$parcel$export(module.exports, "getQuarter", function () { return $e0ee591d3adc6424$export$de90a4bb31c25221; }, function (v) { return $e0ee591d3adc6424$export$de90a4bb31c25221 = v; });
var $e0ee591d3adc6424$export$de90a4bb31c25221;
"use strict";
$e0ee591d3adc6424$export$de90a4bb31c25221 = $e0ee591d3adc6424$var$getQuarter;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $e0ee591d3adc6424$var$getQuarter(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

});


parcelRegister("cFg1S", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarWeeks", function () { return $9385bf70c3036ca1$export$6ed034ce62348e4; }, function (v) { return $9385bf70c3036ca1$export$6ed034ce62348e4 = v; });
var $9385bf70c3036ca1$export$6ed034ce62348e4;
"use strict";
$9385bf70c3036ca1$export$6ed034ce62348e4 = $9385bf70c3036ca1$var$differenceInCalendarWeeks;

var $jpzPN = parcelRequire("jpzPN");

var $7bgap = parcelRequire("7bgap");

var $koDIg = parcelRequire("koDIg");
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $9385bf70c3036ca1$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $7bgap.startOfWeek)(dateLeft, options);
    const startOfWeekRight = (0, $7bgap.startOfWeek)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $koDIg.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $koDIg.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $jpzPN.millisecondsInWeek);
}

});

parcelRegister("gWC9G", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", function () { return $c55fa8f34b90aa51$export$c06dce8b38891685; }, function (v) { return $c55fa8f34b90aa51$export$c06dce8b38891685 = v; });
var $c55fa8f34b90aa51$export$c06dce8b38891685;
"use strict";
$c55fa8f34b90aa51$export$c06dce8b38891685 = $c55fa8f34b90aa51$var$differenceInCalendarYears;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $c55fa8f34b90aa51$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

});

parcelRegister("lJGm5", function(module, exports) {

$parcel$export(module.exports, "differenceInDays", function () { return $fd2ea7d025f77686$export$86415ebf4eb36b8c; }, function (v) { return $fd2ea7d025f77686$export$86415ebf4eb36b8c = v; });
var $fd2ea7d025f77686$export$86415ebf4eb36b8c;
"use strict";
$fd2ea7d025f77686$export$86415ebf4eb36b8c = $fd2ea7d025f77686$var$differenceInDays;

var $dNCuX = parcelRequire("dNCuX");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $fd2ea7d025f77686$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    const sign = $fd2ea7d025f77686$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $dNCuX.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($fd2ea7d025f77686$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $fd2ea7d025f77686$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("aEauj", function(module, exports) {

$parcel$export(module.exports, "differenceInHours", function () { return $7c05c67e22178a74$export$5436ca250d4d6872; }, function (v) { return $7c05c67e22178a74$export$5436ca250d4d6872 = v; });
var $7c05c67e22178a74$export$5436ca250d4d6872;
"use strict";
$7c05c67e22178a74$export$5436ca250d4d6872 = $7c05c67e22178a74$var$differenceInHours;

var $dTgy4 = parcelRequire("dTgy4");

var $jpzPN = parcelRequire("jpzPN");

var $bV4No = parcelRequire("bV4No");
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $7c05c67e22178a74$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $bV4No.differenceInMilliseconds)(dateLeft, dateRight) / $jpzPN.millisecondsInHour;
    return (0, $dTgy4.getRoundingMethod)(options?.roundingMethod)(diff);
}

});
parcelRegister("dTgy4", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $a1cd3fa01324d12d$export$b6474a47258c1211; }, function (v) { return $a1cd3fa01324d12d$export$b6474a47258c1211 = v; });
var $a1cd3fa01324d12d$export$b6474a47258c1211;
"use strict";
$a1cd3fa01324d12d$export$b6474a47258c1211 = $a1cd3fa01324d12d$var$getRoundingMethod;
function $a1cd3fa01324d12d$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("bV4No", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", function () { return $8ad8bce6f9c7406b$export$7be94d13716b4bf6; }, function (v) { return $8ad8bce6f9c7406b$export$7be94d13716b4bf6 = v; });
var $8ad8bce6f9c7406b$export$7be94d13716b4bf6;
"use strict";
$8ad8bce6f9c7406b$export$7be94d13716b4bf6 = $8ad8bce6f9c7406b$var$differenceInMilliseconds;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $8ad8bce6f9c7406b$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $2ZADR.toDate)(dateLeft) - +(0, $2ZADR.toDate)(dateRight);
}

});


parcelRegister("c2Csk", function(module, exports) {

$parcel$export(module.exports, "differenceInISOWeekYears", function () { return $8c4380788c8a9616$export$bf7bde0b3bf8913a; }, function (v) { return $8c4380788c8a9616$export$bf7bde0b3bf8913a = v; });
var $8c4380788c8a9616$export$bf7bde0b3bf8913a;
"use strict";
$8c4380788c8a9616$export$bf7bde0b3bf8913a = $8c4380788c8a9616$var$differenceInISOWeekYears;

var $g0C3p = parcelRequire("g0C3p");

var $bfN4C = parcelRequire("bfN4C");

var $6Osen = parcelRequire("6Osen");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $8c4380788c8a9616$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    const sign = (0, $g0C3p.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $bfN4C.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight));
    _dateLeft = (0, $6Osen.subISOWeekYears)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $g0C3p.compareAsc)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("6Osen", function(module, exports) {

$parcel$export(module.exports, "subISOWeekYears", function () { return $4f5d4fac446b4bc0$export$4f7d47b952f4a0aa; }, function (v) { return $4f5d4fac446b4bc0$export$4f7d47b952f4a0aa = v; });
var $4f5d4fac446b4bc0$export$4f7d47b952f4a0aa;
"use strict";
$4f5d4fac446b4bc0$export$4f7d47b952f4a0aa = $4f5d4fac446b4bc0$var$subISOWeekYears;

var $adsKU = parcelRequire("adsKU");
/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $4f5d4fac446b4bc0$var$subISOWeekYears(date, amount) {
    return (0, $adsKU.addISOWeekYears)(date, -amount);
}

});


parcelRegister("3v3tg", function(module, exports) {

$parcel$export(module.exports, "differenceInMinutes", function () { return $28c6f59ee351c0e8$export$d904251335be481a; }, function (v) { return $28c6f59ee351c0e8$export$d904251335be481a = v; });
var $28c6f59ee351c0e8$export$d904251335be481a;
"use strict";
$28c6f59ee351c0e8$export$d904251335be481a = $28c6f59ee351c0e8$var$differenceInMinutes;

var $dTgy4 = parcelRequire("dTgy4");

var $jpzPN = parcelRequire("jpzPN");

var $bV4No = parcelRequire("bV4No");
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $28c6f59ee351c0e8$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $bV4No.differenceInMilliseconds)(dateLeft, dateRight) / $jpzPN.millisecondsInMinute;
    return (0, $dTgy4.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("cd1xf", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", function () { return $8e37e3cb78e079ee$export$fc1ed482c2861792; }, function (v) { return $8e37e3cb78e079ee$export$fc1ed482c2861792 = v; });
var $8e37e3cb78e079ee$export$fc1ed482c2861792;
"use strict";
$8e37e3cb78e079ee$export$fc1ed482c2861792 = $8e37e3cb78e079ee$var$differenceInMonths;

var $g0C3p = parcelRequire("g0C3p");

var $5p9kz = parcelRequire("5p9kz");

var $gFQqQ = parcelRequire("gFQqQ");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $8e37e3cb78e079ee$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    const sign = (0, $g0C3p.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $5p9kz.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $g0C3p.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $gFQqQ.isLastDayOfMonth)((0, $2ZADR.toDate)(dateLeft)) && difference === 1 && (0, $g0C3p.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("gFQqQ", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", function () { return $c2392597fc46e7ca$export$c817d0312007ea5e; }, function (v) { return $c2392597fc46e7ca$export$c817d0312007ea5e = v; });
var $c2392597fc46e7ca$export$c817d0312007ea5e;
"use strict";
$c2392597fc46e7ca$export$c817d0312007ea5e = $c2392597fc46e7ca$var$isLastDayOfMonth;

var $ikboz = parcelRequire("ikboz");

var $idbU5 = parcelRequire("idbU5");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $c2392597fc46e7ca$var$isLastDayOfMonth(date) {
    const _date = (0, $2ZADR.toDate)(date);
    return +(0, $ikboz.endOfDay)(_date) === +(0, $idbU5.endOfMonth)(_date);
}

});
parcelRegister("ikboz", function(module, exports) {

$parcel$export(module.exports, "endOfDay", function () { return $d572ef2100d7e2c7$export$eb9a03f0e9aa6cea; }, function (v) { return $d572ef2100d7e2c7$export$eb9a03f0e9aa6cea = v; });
var $d572ef2100d7e2c7$export$eb9a03f0e9aa6cea;
"use strict";
$d572ef2100d7e2c7$export$eb9a03f0e9aa6cea = $d572ef2100d7e2c7$var$endOfDay;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $d572ef2100d7e2c7$var$endOfDay(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("idbU5", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", function () { return $d422acb01c583dd1$export$a2258d9c4118825c; }, function (v) { return $d422acb01c583dd1$export$a2258d9c4118825c = v; });
var $d422acb01c583dd1$export$a2258d9c4118825c;
"use strict";
$d422acb01c583dd1$export$a2258d9c4118825c = $d422acb01c583dd1$var$endOfMonth;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $d422acb01c583dd1$var$endOfMonth(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});



parcelRegister("iNa7s", function(module, exports) {

$parcel$export(module.exports, "differenceInQuarters", function () { return $dae4a716675ef3dc$export$74b5c4055a405552; }, function (v) { return $dae4a716675ef3dc$export$74b5c4055a405552 = v; });
var $dae4a716675ef3dc$export$74b5c4055a405552;
"use strict";
$dae4a716675ef3dc$export$74b5c4055a405552 = $dae4a716675ef3dc$var$differenceInQuarters;

var $dTgy4 = parcelRequire("dTgy4");

var $cd1xf = parcelRequire("cd1xf");
/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $dae4a716675ef3dc$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $cd1xf.differenceInMonths)(dateLeft, dateRight) / 3;
    return (0, $dTgy4.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("kDfdQ", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", function () { return $f0534204cb0b8881$export$c1889aec51783710; }, function (v) { return $f0534204cb0b8881$export$c1889aec51783710 = v; });
var $f0534204cb0b8881$export$c1889aec51783710;
"use strict";
$f0534204cb0b8881$export$c1889aec51783710 = $f0534204cb0b8881$var$differenceInSeconds;

var $dTgy4 = parcelRequire("dTgy4");

var $bV4No = parcelRequire("bV4No");
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $f0534204cb0b8881$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $bV4No.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, $dTgy4.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("iA8Ge", function(module, exports) {

$parcel$export(module.exports, "differenceInWeeks", function () { return $d8725282e002c691$export$b5147a91dc40ddb7; }, function (v) { return $d8725282e002c691$export$b5147a91dc40ddb7 = v; });
var $d8725282e002c691$export$b5147a91dc40ddb7;
"use strict";
$d8725282e002c691$export$b5147a91dc40ddb7 = $d8725282e002c691$var$differenceInWeeks;

var $dTgy4 = parcelRequire("dTgy4");

var $lJGm5 = parcelRequire("lJGm5");
/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $d8725282e002c691$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $lJGm5.differenceInDays)(dateLeft, dateRight) / 7;
    return (0, $dTgy4.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("b53t3", function(module, exports) {

$parcel$export(module.exports, "differenceInYears", function () { return $8112d9ea883d155b$export$ed6bf486f68899ca; }, function (v) { return $8112d9ea883d155b$export$ed6bf486f68899ca = v; });
var $8112d9ea883d155b$export$ed6bf486f68899ca;
"use strict";
$8112d9ea883d155b$export$ed6bf486f68899ca = $8112d9ea883d155b$var$differenceInYears;

var $g0C3p = parcelRequire("g0C3p");

var $gWC9G = parcelRequire("gWC9G");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $8112d9ea883d155b$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    const sign = (0, $g0C3p.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $gWC9G.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $g0C3p.compareAsc)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("jc25u", function(module, exports) {

$parcel$export(module.exports, "eachDayOfInterval", function () { return $df90c1e0e45a0868$export$7a337e5923c7ceb5; }, function (v) { return $df90c1e0e45a0868$export$7a337e5923c7ceb5 = v; });
var $df90c1e0e45a0868$export$7a337e5923c7ceb5;
"use strict";
$df90c1e0e45a0868$export$7a337e5923c7ceb5 = $df90c1e0e45a0868$var$eachDayOfInterval;

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $df90c1e0e45a0868$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $2ZADR.toDate)(interval.start);
    const endDate = (0, $2ZADR.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $2ZADR.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("eW6Kv", function(module, exports) {

$parcel$export(module.exports, "eachHourOfInterval", function () { return $adfbb7b71f0293a0$export$bb4f48fee90ea86e; }, function (v) { return $adfbb7b71f0293a0$export$bb4f48fee90ea86e = v; });
var $adfbb7b71f0293a0$export$bb4f48fee90ea86e;
"use strict";
$adfbb7b71f0293a0$export$bb4f48fee90ea86e = $adfbb7b71f0293a0$var$eachHourOfInterval;

var $dXVrc = parcelRequire("dXVrc");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $adfbb7b71f0293a0$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $2ZADR.toDate)(interval.start);
    const endDate = (0, $2ZADR.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $2ZADR.toDate)(currentDate));
        currentDate = (0, $dXVrc.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("1FS2F", function(module, exports) {

$parcel$export(module.exports, "eachMinuteOfInterval", function () { return $13838a68f08a4c4b$export$82e17d693ce9eb6c; }, function (v) { return $13838a68f08a4c4b$export$82e17d693ce9eb6c = v; });
var $13838a68f08a4c4b$export$82e17d693ce9eb6c;
"use strict";
$13838a68f08a4c4b$export$82e17d693ce9eb6c = $13838a68f08a4c4b$var$eachMinuteOfInterval;

var $6NFmg = parcelRequire("6NFmg");

var $g9NYq = parcelRequire("g9NYq");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $13838a68f08a4c4b$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $g9NYq.startOfMinute)((0, $2ZADR.toDate)(interval.start));
    const endDate = (0, $2ZADR.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $2ZADR.toDate)(currentDate));
        currentDate = (0, $6NFmg.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("g9NYq", function(module, exports) {

$parcel$export(module.exports, "startOfMinute", function () { return $bc3440520596834c$export$c66440458c6aa793; }, function (v) { return $bc3440520596834c$export$c66440458c6aa793 = v; });
var $bc3440520596834c$export$c66440458c6aa793;
"use strict";
$bc3440520596834c$export$c66440458c6aa793 = $bc3440520596834c$var$startOfMinute;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $bc3440520596834c$var$startOfMinute(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}

});


parcelRegister("fzDNf", function(module, exports) {

$parcel$export(module.exports, "eachMonthOfInterval", function () { return $b568fe0a6a9d52ce$export$1c9322f2d2a5eed3; }, function (v) { return $b568fe0a6a9d52ce$export$1c9322f2d2a5eed3 = v; });
var $b568fe0a6a9d52ce$export$1c9322f2d2a5eed3;
"use strict";
$b568fe0a6a9d52ce$export$1c9322f2d2a5eed3 = $b568fe0a6a9d52ce$var$eachMonthOfInterval;

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $b568fe0a6a9d52ce$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $2ZADR.toDate)(interval.start);
    const endDate = (0, $2ZADR.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $2ZADR.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("lIzMC", function(module, exports) {

$parcel$export(module.exports, "eachQuarterOfInterval", function () { return $fcf976d08fd3142f$export$96790a0abfab0078; }, function (v) { return $fcf976d08fd3142f$export$96790a0abfab0078 = v; });
var $fcf976d08fd3142f$export$96790a0abfab0078;
"use strict";
$fcf976d08fd3142f$export$96790a0abfab0078 = $fcf976d08fd3142f$var$eachQuarterOfInterval;

var $idUxy = parcelRequire("idUxy");

var $cJLy9 = parcelRequire("cJLy9");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $fcf976d08fd3142f$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $2ZADR.toDate)(interval.start);
    const endDate = (0, $2ZADR.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $cJLy9.startOfQuarter)(startDate) : +(0, $cJLy9.startOfQuarter)(endDate);
    let currentDate = reversed ? (0, $cJLy9.startOfQuarter)(endDate) : (0, $cJLy9.startOfQuarter)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $2ZADR.toDate)(currentDate));
        currentDate = (0, $idUxy.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("cJLy9", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", function () { return $945e926627edc938$export$69be7267a042ecb3; }, function (v) { return $945e926627edc938$export$69be7267a042ecb3 = v; });
var $945e926627edc938$export$69be7267a042ecb3;
"use strict";
$945e926627edc938$export$69be7267a042ecb3 = $945e926627edc938$var$startOfQuarter;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $945e926627edc938$var$startOfQuarter(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("drPXf", function(module, exports) {

$parcel$export(module.exports, "eachWeekOfInterval", function () { return $9ca61914dd4d578f$export$d31a8caec75fa456; }, function (v) { return $9ca61914dd4d578f$export$d31a8caec75fa456 = v; });
var $9ca61914dd4d578f$export$d31a8caec75fa456;
"use strict";
$9ca61914dd4d578f$export$d31a8caec75fa456 = $9ca61914dd4d578f$var$eachWeekOfInterval;

var $328s2 = parcelRequire("328s2");

var $7bgap = parcelRequire("7bgap");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $9ca61914dd4d578f$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $2ZADR.toDate)(interval.start);
    const endDate = (0, $2ZADR.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $7bgap.startOfWeek)(endDate, options) : (0, $7bgap.startOfWeek)(startDate, options);
    const endDateWeek = reversed ? (0, $7bgap.startOfWeek)(startDate, options) : (0, $7bgap.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $2ZADR.toDate)(currentDate));
        currentDate = (0, $328s2.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("7GFCF", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfInterval", function () { return $598cbe0c41317f28$export$a2ae85dd849354a8; }, function (v) { return $598cbe0c41317f28$export$a2ae85dd849354a8 = v; });
var $598cbe0c41317f28$export$a2ae85dd849354a8;
"use strict";
$598cbe0c41317f28$export$a2ae85dd849354a8 = $598cbe0c41317f28$var$eachWeekendOfInterval;

var $jc25u = parcelRequire("jc25u");

var $0ZGpW = parcelRequire("0ZGpW");
/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $598cbe0c41317f28$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $jc25u.eachDayOfInterval)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $0ZGpW.isWeekend)(date)) weekends.push(date);
    }
    return weekends;
}

});

parcelRegister("5Qeoz", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfMonth", function () { return $440cf9b475adc6e5$export$f9a185d0ad232d17; }, function (v) { return $440cf9b475adc6e5$export$f9a185d0ad232d17 = v; });
var $440cf9b475adc6e5$export$f9a185d0ad232d17;
"use strict";
$440cf9b475adc6e5$export$f9a185d0ad232d17 = $440cf9b475adc6e5$var$eachWeekendOfMonth;

var $7GFCF = parcelRequire("7GFCF");

var $idbU5 = parcelRequire("idbU5");

var $3tjSb = parcelRequire("3tjSb");
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $440cf9b475adc6e5$var$eachWeekendOfMonth(date) {
    const start = (0, $3tjSb.startOfMonth)(date);
    const end = (0, $idbU5.endOfMonth)(date);
    return (0, $7GFCF.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});
parcelRegister("3tjSb", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", function () { return $28737edfe5baf507$export$a5a3b454ada2268e; }, function (v) { return $28737edfe5baf507$export$a5a3b454ada2268e = v; });
var $28737edfe5baf507$export$a5a3b454ada2268e;
"use strict";
$28737edfe5baf507$export$a5a3b454ada2268e = $28737edfe5baf507$var$startOfMonth;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $28737edfe5baf507$var$startOfMonth(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("fFQ1j", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfYear", function () { return $b693097712621174$export$d4a9e5efc1ddceb9; }, function (v) { return $b693097712621174$export$d4a9e5efc1ddceb9 = v; });
var $b693097712621174$export$d4a9e5efc1ddceb9;
"use strict";
$b693097712621174$export$d4a9e5efc1ddceb9 = $b693097712621174$var$eachWeekendOfYear;

var $7GFCF = parcelRequire("7GFCF");

var $29JwN = parcelRequire("29JwN");

var $coXV6 = parcelRequire("coXV6");
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $b693097712621174$var$eachWeekendOfYear(date) {
    const start = (0, $coXV6.startOfYear)(date);
    const end = (0, $29JwN.endOfYear)(date);
    return (0, $7GFCF.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});
parcelRegister("29JwN", function(module, exports) {

$parcel$export(module.exports, "endOfYear", function () { return $191fbcec3a527b3e$export$8b7aa55c66d5569e; }, function (v) { return $191fbcec3a527b3e$export$8b7aa55c66d5569e = v; });
var $191fbcec3a527b3e$export$8b7aa55c66d5569e;
"use strict";
$191fbcec3a527b3e$export$8b7aa55c66d5569e = $191fbcec3a527b3e$var$endOfYear;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $191fbcec3a527b3e$var$endOfYear(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("coXV6", function(module, exports) {

$parcel$export(module.exports, "startOfYear", function () { return $907634ccedb683ba$export$f91e89d3d0406102; }, function (v) { return $907634ccedb683ba$export$f91e89d3d0406102 = v; });
var $907634ccedb683ba$export$f91e89d3d0406102;
"use strict";
$907634ccedb683ba$export$f91e89d3d0406102 = $907634ccedb683ba$var$startOfYear;

var $2ZADR = parcelRequire("2ZADR");

var $2J98k = parcelRequire("2J98k");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $907634ccedb683ba$var$startOfYear(date) {
    const cleanDate = (0, $2ZADR.toDate)(date);
    const _date = (0, $2J98k.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("1GAoB", function(module, exports) {

$parcel$export(module.exports, "eachYearOfInterval", function () { return $13a5f2217b668bbc$export$9b7f165f0a71d2a5; }, function (v) { return $13a5f2217b668bbc$export$9b7f165f0a71d2a5 = v; });
var $13a5f2217b668bbc$export$9b7f165f0a71d2a5;
"use strict";
$13a5f2217b668bbc$export$9b7f165f0a71d2a5 = $13a5f2217b668bbc$var$eachYearOfInterval;

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $13a5f2217b668bbc$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $2ZADR.toDate)(interval.start);
    const endDate = (0, $2ZADR.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $2ZADR.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("cucJ4", function(module, exports) {

$parcel$export(module.exports, "endOfDecade", function () { return $9172287869c69fec$export$b922ac31d5bbe7a6; }, function (v) { return $9172287869c69fec$export$b922ac31d5bbe7a6 = v; });
var $9172287869c69fec$export$b922ac31d5bbe7a6;
"use strict";
$9172287869c69fec$export$b922ac31d5bbe7a6 = $9172287869c69fec$var$endOfDecade;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $9172287869c69fec$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("gQjr2", function(module, exports) {

$parcel$export(module.exports, "endOfHour", function () { return $c4309412e41ce22d$export$95ae95d2176c5f0; }, function (v) { return $c4309412e41ce22d$export$95ae95d2176c5f0 = v; });
var $c4309412e41ce22d$export$95ae95d2176c5f0;
"use strict";
$c4309412e41ce22d$export$95ae95d2176c5f0 = $c4309412e41ce22d$var$endOfHour;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $c4309412e41ce22d$var$endOfHour(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}

});

parcelRegister("arloc", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeek", function () { return $799d047b43363481$export$186cd934f32084be; }, function (v) { return $799d047b43363481$export$186cd934f32084be = v; });
var $799d047b43363481$export$186cd934f32084be;
"use strict";
$799d047b43363481$export$186cd934f32084be = $799d047b43363481$var$endOfISOWeek;

var $Bbtyo = parcelRequire("Bbtyo");
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $799d047b43363481$var$endOfISOWeek(date) {
    return (0, $Bbtyo.endOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("Bbtyo", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", function () { return $06fc5ba563f42e87$export$ef8b6d9133084f4e; }, function (v) { return $06fc5ba563f42e87$export$ef8b6d9133084f4e = v; });
var $06fc5ba563f42e87$export$ef8b6d9133084f4e;
"use strict";
$06fc5ba563f42e87$export$ef8b6d9133084f4e = $06fc5ba563f42e87$var$endOfWeek;

var $2ZADR = parcelRequire("2ZADR");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $06fc5ba563f42e87$var$endOfWeek(date, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $2ZADR.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});


parcelRegister("g3XHD", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeekYear", function () { return $bb1b3ce2cc85095f$export$73068f3824c9c1d; }, function (v) { return $bb1b3ce2cc85095f$export$73068f3824c9c1d = v; });
var $bb1b3ce2cc85095f$export$73068f3824c9c1d;
"use strict";
$bb1b3ce2cc85095f$export$73068f3824c9c1d = $bb1b3ce2cc85095f$var$endOfISOWeekYear;

var $kf69a = parcelRequire("kf69a");

var $kAYVg = parcelRequire("kAYVg");

var $2J98k = parcelRequire("2J98k");
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $bb1b3ce2cc85095f$var$endOfISOWeekYear(date) {
    const year = (0, $kf69a.getISOWeekYear)(date);
    const fourthOfJanuaryOfNextYear = (0, $2J98k.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $kAYVg.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}

});

parcelRegister("f8sbe", function(module, exports) {

$parcel$export(module.exports, "endOfMinute", function () { return $b04d765ec3df1eb2$export$a06a772fc63bff07; }, function (v) { return $b04d765ec3df1eb2$export$a06a772fc63bff07 = v; });
var $b04d765ec3df1eb2$export$a06a772fc63bff07;
"use strict";
$b04d765ec3df1eb2$export$a06a772fc63bff07 = $b04d765ec3df1eb2$var$endOfMinute;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $b04d765ec3df1eb2$var$endOfMinute(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}

});

parcelRegister("czanW", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", function () { return $9260cf37d932ac6e$export$5f53493861eef879; }, function (v) { return $9260cf37d932ac6e$export$5f53493861eef879 = v; });
var $9260cf37d932ac6e$export$5f53493861eef879;
"use strict";
$9260cf37d932ac6e$export$5f53493861eef879 = $9260cf37d932ac6e$var$endOfQuarter;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $9260cf37d932ac6e$var$endOfQuarter(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("dd1ko", function(module, exports) {

$parcel$export(module.exports, "endOfSecond", function () { return $99dd84eeda4d4080$export$ef560ab2fa7b52a2; }, function (v) { return $99dd84eeda4d4080$export$ef560ab2fa7b52a2 = v; });
var $99dd84eeda4d4080$export$ef560ab2fa7b52a2;
"use strict";
$99dd84eeda4d4080$export$ef560ab2fa7b52a2 = $99dd84eeda4d4080$var$endOfSecond;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $99dd84eeda4d4080$var$endOfSecond(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}

});

parcelRegister("hHOzE", function(module, exports) {

$parcel$export(module.exports, "endOfToday", function () { return $ce3daec4be5f3747$export$1b7031a80bd92a6e; }, function (v) { return $ce3daec4be5f3747$export$1b7031a80bd92a6e = v; });
var $ce3daec4be5f3747$export$1b7031a80bd92a6e;
"use strict";
$ce3daec4be5f3747$export$1b7031a80bd92a6e = $ce3daec4be5f3747$var$endOfToday;

var $ikboz = parcelRequire("ikboz");
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $ce3daec4be5f3747$var$endOfToday() {
    return (0, $ikboz.endOfDay)(Date.now());
}

});

parcelRegister("9Lm8F", function(module, exports) {

$parcel$export(module.exports, "endOfTomorrow", function () { return $71b9ad1fb5c075ff$export$d788ac27ae2a54ea; }, function (v) { return $71b9ad1fb5c075ff$export$d788ac27ae2a54ea = v; });
var $71b9ad1fb5c075ff$export$d788ac27ae2a54ea;
"use strict";
$71b9ad1fb5c075ff$export$d788ac27ae2a54ea = $71b9ad1fb5c075ff$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $71b9ad1fb5c075ff$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("3qMFg", function(module, exports) {

$parcel$export(module.exports, "endOfYesterday", function () { return $27f98c9341d7b077$export$45190faf1024f97a; }, function (v) { return $27f98c9341d7b077$export$45190faf1024f97a = v; });
var $27f98c9341d7b077$export$45190faf1024f97a;
"use strict";
$27f98c9341d7b077$export$45190faf1024f97a = $27f98c9341d7b077$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $27f98c9341d7b077$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("a5wsS", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $75838dd50a5f1e47$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $d1NaV.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $16dsw.longFormatters;
    }
});

var $4rIDU = parcelRequire("4rIDU");

var $w0VDZ = parcelRequire("w0VDZ");

var $d1NaV = parcelRequire("d1NaV");

var $16dsw = parcelRequire("16dsw");

var $frKKs = parcelRequire("frKKs");

var $8SDsI = parcelRequire("8SDsI");

var $2ZADR = parcelRequire("2ZADR");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $75838dd50a5f1e47$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $75838dd50a5f1e47$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $75838dd50a5f1e47$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $75838dd50a5f1e47$var$doubleQuoteRegExp = /''/g;
const $75838dd50a5f1e47$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $75838dd50a5f1e47$var$format(date, formatStr, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $4rIDU.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $2ZADR.toDate)(date);
    if (!(0, $8SDsI.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($75838dd50a5f1e47$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $16dsw.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($75838dd50a5f1e47$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $75838dd50a5f1e47$var$cleanEscapedString(substring)
        };
        if ($d1NaV.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($75838dd50a5f1e47$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $frKKs.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $frKKs.isProtectedDayOfYearToken)(token)) (0, $frKKs.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $d1NaV.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $75838dd50a5f1e47$var$cleanEscapedString(input) {
    const matched = input.match($75838dd50a5f1e47$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($75838dd50a5f1e47$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("4rIDU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $dHYEo.enUS;
    }
});

var $dHYEo = parcelRequire("dHYEo");

});
parcelRegister("dHYEo", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $9fae5675156c0661$export$137380d9ce54f7f; }, function (v) { return $9fae5675156c0661$export$137380d9ce54f7f = v; });
var $9fae5675156c0661$export$137380d9ce54f7f;
"use strict";
$9fae5675156c0661$export$137380d9ce54f7f = void 0;

var $gpMTW = parcelRequire("gpMTW");

var $6ZLUh = parcelRequire("6ZLUh");

var $kPVTI = parcelRequire("kPVTI");

var $5cAjV = parcelRequire("5cAjV");

var $5bbRl = parcelRequire("5bbRl");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $9fae5675156c0661$var$enUS = $9fae5675156c0661$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $gpMTW.formatDistance,
    formatLong: $6ZLUh.formatLong,
    formatRelative: $kPVTI.formatRelative,
    localize: $5cAjV.localize,
    match: $5bbRl.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("gpMTW", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $bf34e9ec24b6c675$export$2c14ff85d6318973; }, function (v) { return $bf34e9ec24b6c675$export$2c14ff85d6318973 = v; });
var $bf34e9ec24b6c675$export$2c14ff85d6318973;
"use strict";
$bf34e9ec24b6c675$export$2c14ff85d6318973 = void 0;
const $bf34e9ec24b6c675$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $bf34e9ec24b6c675$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $bf34e9ec24b6c675$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$bf34e9ec24b6c675$export$2c14ff85d6318973 = $bf34e9ec24b6c675$var$formatDistance;

});

parcelRegister("6ZLUh", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $517d99e06365b264$export$cbf60ecb96cbb82f; }, function (v) { return $517d99e06365b264$export$cbf60ecb96cbb82f = v; });
var $517d99e06365b264$export$cbf60ecb96cbb82f;
"use strict";
$517d99e06365b264$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $517d99e06365b264$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $517d99e06365b264$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $517d99e06365b264$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $517d99e06365b264$var$formatLong = $517d99e06365b264$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $517d99e06365b264$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $517d99e06365b264$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $517d99e06365b264$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("6mxHK", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $4a1ef132b22ad450$export$38e44e97ce4dbb7d; }, function (v) { return $4a1ef132b22ad450$export$38e44e97ce4dbb7d = v; });
var $4a1ef132b22ad450$export$38e44e97ce4dbb7d;
"use strict";
$4a1ef132b22ad450$export$38e44e97ce4dbb7d = $4a1ef132b22ad450$var$buildFormatLongFn;
function $4a1ef132b22ad450$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("kPVTI", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $f2b57b53bba1dbe9$export$8fbbfd65594f46a0; }, function (v) { return $f2b57b53bba1dbe9$export$8fbbfd65594f46a0 = v; });
var $f2b57b53bba1dbe9$export$8fbbfd65594f46a0;
"use strict";
$f2b57b53bba1dbe9$export$8fbbfd65594f46a0 = void 0;
const $f2b57b53bba1dbe9$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f2b57b53bba1dbe9$var$formatRelative = (token, _date, _baseDate, _options)=>$f2b57b53bba1dbe9$var$formatRelativeLocale[token];
$f2b57b53bba1dbe9$export$8fbbfd65594f46a0 = $f2b57b53bba1dbe9$var$formatRelative;

});

parcelRegister("5cAjV", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3c9a3f38580577fd$export$b3bd0bc58e36cd63; }, function (v) { return $3c9a3f38580577fd$export$b3bd0bc58e36cd63 = v; });
var $3c9a3f38580577fd$export$b3bd0bc58e36cd63;
"use strict";
$3c9a3f38580577fd$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $3c9a3f38580577fd$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $3c9a3f38580577fd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $3c9a3f38580577fd$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $3c9a3f38580577fd$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $3c9a3f38580577fd$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $3c9a3f38580577fd$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $3c9a3f38580577fd$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $3c9a3f38580577fd$var$localize = $3c9a3f38580577fd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3c9a3f38580577fd$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $3c9a3f38580577fd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $3c9a3f38580577fd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $3c9a3f38580577fd$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $3c9a3f38580577fd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $3c9a3f38580577fd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3c9a3f38580577fd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("bhSfH", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $837b5d9e4a14acfc$export$63596d6ee8878b25; }, function (v) { return $837b5d9e4a14acfc$export$63596d6ee8878b25 = v; });
var $837b5d9e4a14acfc$export$63596d6ee8878b25;
"use strict";
$837b5d9e4a14acfc$export$63596d6ee8878b25 = $837b5d9e4a14acfc$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $837b5d9e4a14acfc$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("5bbRl", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $3c572de117726e68$export$4659b591c19bdf3d; }, function (v) { return $3c572de117726e68$export$4659b591c19bdf3d = v; });
var $3c572de117726e68$export$4659b591c19bdf3d;
"use strict";
$3c572de117726e68$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $3c572de117726e68$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $3c572de117726e68$var$parseOrdinalNumberPattern = /\d+/i;
const $3c572de117726e68$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $3c572de117726e68$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $3c572de117726e68$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $3c572de117726e68$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $3c572de117726e68$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $3c572de117726e68$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $3c572de117726e68$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $3c572de117726e68$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $3c572de117726e68$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $3c572de117726e68$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $3c572de117726e68$var$match = $3c572de117726e68$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $3c572de117726e68$var$matchOrdinalNumberPattern,
        parsePattern: $3c572de117726e68$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $3c572de117726e68$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c572de117726e68$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $3c572de117726e68$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c572de117726e68$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $3c572de117726e68$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c572de117726e68$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $3c572de117726e68$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c572de117726e68$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $3c572de117726e68$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3c572de117726e68$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("gZaqQ", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $c5da6f6a28ea4d7c$export$1430a0f35710914d; }, function (v) { return $c5da6f6a28ea4d7c$export$1430a0f35710914d = v; });
var $c5da6f6a28ea4d7c$export$1430a0f35710914d;
"use strict";
$c5da6f6a28ea4d7c$export$1430a0f35710914d = $c5da6f6a28ea4d7c$var$buildMatchFn;
function $c5da6f6a28ea4d7c$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $c5da6f6a28ea4d7c$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $c5da6f6a28ea4d7c$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c5da6f6a28ea4d7c$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c5da6f6a28ea4d7c$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("essio", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $a869a1279a9cabcc$export$fdaf2fd6d7edde95; }, function (v) { return $a869a1279a9cabcc$export$fdaf2fd6d7edde95 = v; });
var $a869a1279a9cabcc$export$fdaf2fd6d7edde95;
"use strict";
$a869a1279a9cabcc$export$fdaf2fd6d7edde95 = $a869a1279a9cabcc$var$buildMatchPatternFn;
function $a869a1279a9cabcc$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("d1NaV", function(module, exports) {

$parcel$export(module.exports, "formatters", function () { return $97c1838a4e76c3dc$export$fe98a034cfb96d55; }, function (v) { return $97c1838a4e76c3dc$export$fe98a034cfb96d55 = v; });
var $97c1838a4e76c3dc$export$fe98a034cfb96d55;
"use strict";
$97c1838a4e76c3dc$export$fe98a034cfb96d55 = void 0;

var $i2DV5 = parcelRequire("i2DV5");

var $WJVCU = parcelRequire("WJVCU");

var $kf69a = parcelRequire("kf69a");

var $eOJHF = parcelRequire("eOJHF");

var $jrEu3 = parcelRequire("jrEu3");

var $2iQOO = parcelRequire("2iQOO");

var $g2z8V = parcelRequire("g2z8V");
const $97c1838a4e76c3dc$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $97c1838a4e76c3dc$var$formatters = $97c1838a4e76c3dc$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $g2z8V.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $jrEu3.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $2iQOO.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $2iQOO.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $kf69a.getISOWeekYear)(date);
        // Padding
        return (0, $2iQOO.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $2iQOO.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $2iQOO.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $2iQOO.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $g2z8V.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $2iQOO.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $eOJHF.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $2iQOO.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $WJVCU.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $2iQOO.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $g2z8V.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $i2DV5.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $2iQOO.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $2iQOO.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $2iQOO.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $2iQOO.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $97c1838a4e76c3dc$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $97c1838a4e76c3dc$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $97c1838a4e76c3dc$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $97c1838a4e76c3dc$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $97c1838a4e76c3dc$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $97c1838a4e76c3dc$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $g2z8V.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $g2z8V.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $2iQOO.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $2iQOO.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $g2z8V.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $g2z8V.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $g2z8V.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $97c1838a4e76c3dc$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $97c1838a4e76c3dc$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $97c1838a4e76c3dc$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $97c1838a4e76c3dc$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $97c1838a4e76c3dc$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $97c1838a4e76c3dc$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $97c1838a4e76c3dc$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $97c1838a4e76c3dc$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $97c1838a4e76c3dc$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $97c1838a4e76c3dc$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $2iQOO.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $2iQOO.addLeadingZeros)(timestamp, token.length);
    }
};
function $97c1838a4e76c3dc$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $2iQOO.addLeadingZeros)(minutes, 2);
}
function $97c1838a4e76c3dc$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $2iQOO.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $97c1838a4e76c3dc$var$formatTimezone(offset, delimiter);
}
function $97c1838a4e76c3dc$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $2iQOO.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $2iQOO.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("i2DV5", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", function () { return $d22761214c02d14b$export$d3b42cd8452deec; }, function (v) { return $d22761214c02d14b$export$d3b42cd8452deec = v; });
var $d22761214c02d14b$export$d3b42cd8452deec;
"use strict";
$d22761214c02d14b$export$d3b42cd8452deec = $d22761214c02d14b$var$getDayOfYear;

var $dNCuX = parcelRequire("dNCuX");

var $coXV6 = parcelRequire("coXV6");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $d22761214c02d14b$var$getDayOfYear(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const diff = (0, $dNCuX.differenceInCalendarDays)(_date, (0, $coXV6.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});

parcelRegister("WJVCU", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", function () { return $0b090b54615dd8c0$export$7cabdc5698b63e2f; }, function (v) { return $0b090b54615dd8c0$export$7cabdc5698b63e2f = v; });
var $0b090b54615dd8c0$export$7cabdc5698b63e2f;
"use strict";
$0b090b54615dd8c0$export$7cabdc5698b63e2f = $0b090b54615dd8c0$var$getISOWeek;

var $jpzPN = parcelRequire("jpzPN");

var $kAYVg = parcelRequire("kAYVg");

var $7cc1O = parcelRequire("7cc1O");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $0b090b54615dd8c0$var$getISOWeek(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const diff = +(0, $kAYVg.startOfISOWeek)(_date) - +(0, $7cc1O.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $jpzPN.millisecondsInWeek) + 1;
}

});

parcelRegister("eOJHF", function(module, exports) {

$parcel$export(module.exports, "getWeek", function () { return $ac992fe6fcc15c74$export$efe19b760242b2fc; }, function (v) { return $ac992fe6fcc15c74$export$efe19b760242b2fc = v; });
var $ac992fe6fcc15c74$export$efe19b760242b2fc;
"use strict";
$ac992fe6fcc15c74$export$efe19b760242b2fc = $ac992fe6fcc15c74$var$getWeek;

var $jpzPN = parcelRequire("jpzPN");

var $7bgap = parcelRequire("7bgap");

var $gJo6O = parcelRequire("gJo6O");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $ac992fe6fcc15c74$var$getWeek(date, options) {
    const _date = (0, $2ZADR.toDate)(date);
    const diff = +(0, $7bgap.startOfWeek)(_date, options) - +(0, $gJo6O.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $jpzPN.millisecondsInWeek) + 1;
}

});
parcelRegister("gJo6O", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", function () { return $c2e38ccf5e006db7$export$bb7b45bb8e74da0f; }, function (v) { return $c2e38ccf5e006db7$export$bb7b45bb8e74da0f = v; });
var $c2e38ccf5e006db7$export$bb7b45bb8e74da0f;
"use strict";
$c2e38ccf5e006db7$export$bb7b45bb8e74da0f = $c2e38ccf5e006db7$var$startOfWeekYear;

var $2J98k = parcelRequire("2J98k");

var $jrEu3 = parcelRequire("jrEu3");

var $7bgap = parcelRequire("7bgap");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $c2e38ccf5e006db7$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $jrEu3.getWeekYear)(date, options);
    const firstWeek = (0, $2J98k.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $7bgap.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRegister("jrEu3", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", function () { return $e27ff1294d9e3302$export$12d572480ceb6e58; }, function (v) { return $e27ff1294d9e3302$export$12d572480ceb6e58 = v; });
var $e27ff1294d9e3302$export$12d572480ceb6e58;
"use strict";
$e27ff1294d9e3302$export$12d572480ceb6e58 = $e27ff1294d9e3302$var$getWeekYear;

var $2J98k = parcelRequire("2J98k");

var $7bgap = parcelRequire("7bgap");

var $2ZADR = parcelRequire("2ZADR");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $e27ff1294d9e3302$var$getWeekYear(date, options) {
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $2J98k.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $7bgap.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $2J98k.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $7bgap.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("2iQOO", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", function () { return $1ad63bdf0757aaff$export$c8306e720e213c0f; }, function (v) { return $1ad63bdf0757aaff$export$c8306e720e213c0f = v; });
var $1ad63bdf0757aaff$export$c8306e720e213c0f;
"use strict";
$1ad63bdf0757aaff$export$c8306e720e213c0f = $1ad63bdf0757aaff$var$addLeadingZeros;
function $1ad63bdf0757aaff$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("g2z8V", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", function () { return $bad817e753d0bffb$export$b0d4b338e1516f13; }, function (v) { return $bad817e753d0bffb$export$b0d4b338e1516f13 = v; });
var $bad817e753d0bffb$export$b0d4b338e1516f13;
"use strict";
$bad817e753d0bffb$export$b0d4b338e1516f13 = void 0;

var $2iQOO = parcelRequire("2iQOO");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $bad817e753d0bffb$var$lightFormatters = $bad817e753d0bffb$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $2iQOO.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $2iQOO.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $2iQOO.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $2iQOO.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $2iQOO.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $2iQOO.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $2iQOO.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $2iQOO.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("16dsw", function(module, exports) {

$parcel$export(module.exports, "longFormatters", function () { return $0cd0caa4497a9851$export$70cc8fd02856fd58; }, function (v) { return $0cd0caa4497a9851$export$70cc8fd02856fd58 = v; });
var $0cd0caa4497a9851$export$70cc8fd02856fd58;
"use strict";
$0cd0caa4497a9851$export$70cc8fd02856fd58 = void 0;
const $0cd0caa4497a9851$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $0cd0caa4497a9851$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $0cd0caa4497a9851$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $0cd0caa4497a9851$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $0cd0caa4497a9851$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $0cd0caa4497a9851$var$timeLongFormatter(timePattern, formatLong));
};
const $0cd0caa4497a9851$var$longFormatters = $0cd0caa4497a9851$export$70cc8fd02856fd58 = {
    p: $0cd0caa4497a9851$var$timeLongFormatter,
    P: $0cd0caa4497a9851$var$dateTimeLongFormatter
};

});

parcelRegister("frKKs", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $b3eda3de89036cc3$export$c6cc36aa33304772; }, function (v) { return $b3eda3de89036cc3$export$c6cc36aa33304772 = v; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $b3eda3de89036cc3$export$c6b49d6dceb604a1; }, function (v) { return $b3eda3de89036cc3$export$c6b49d6dceb604a1 = v; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $b3eda3de89036cc3$export$f5f38f90ecaaf879; }, function (v) { return $b3eda3de89036cc3$export$f5f38f90ecaaf879 = v; });
var $b3eda3de89036cc3$export$c6cc36aa33304772;
var $b3eda3de89036cc3$export$c6b49d6dceb604a1;
var $b3eda3de89036cc3$export$f5f38f90ecaaf879;
"use strict";
$b3eda3de89036cc3$export$c6cc36aa33304772 = $b3eda3de89036cc3$var$isProtectedDayOfYearToken;
$b3eda3de89036cc3$export$c6b49d6dceb604a1 = $b3eda3de89036cc3$var$isProtectedWeekYearToken;
$b3eda3de89036cc3$export$f5f38f90ecaaf879 = $b3eda3de89036cc3$var$warnOrThrowProtectedError;
const $b3eda3de89036cc3$var$dayOfYearTokenRE = /^D+$/;
const $b3eda3de89036cc3$var$weekYearTokenRE = /^Y+$/;
const $b3eda3de89036cc3$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $b3eda3de89036cc3$var$isProtectedDayOfYearToken(token) {
    return $b3eda3de89036cc3$var$dayOfYearTokenRE.test(token);
}
function $b3eda3de89036cc3$var$isProtectedWeekYearToken(token) {
    return $b3eda3de89036cc3$var$weekYearTokenRE.test(token);
}
function $b3eda3de89036cc3$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $b3eda3de89036cc3$var$message(token, format, input);
    console.warn(_message);
    if ($b3eda3de89036cc3$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $b3eda3de89036cc3$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});


parcelRegister("cXAdF", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $96f717228ad65ca6$export$2c14ff85d6318973; }, function (v) { return $96f717228ad65ca6$export$2c14ff85d6318973 = v; });
var $96f717228ad65ca6$export$2c14ff85d6318973;
"use strict";
$96f717228ad65ca6$export$2c14ff85d6318973 = $96f717228ad65ca6$var$formatDistance;

var $g0C3p = parcelRequire("g0C3p");

var $jpzPN = parcelRequire("jpzPN");

var $cd1xf = parcelRequire("cd1xf");

var $kDfdQ = parcelRequire("kDfdQ");

var $2ZADR = parcelRequire("2ZADR");

var $4rIDU = parcelRequire("4rIDU");

var $w0VDZ = parcelRequire("w0VDZ");

var $koDIg = parcelRequire("koDIg");
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $96f717228ad65ca6$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $4rIDU.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $g0C3p.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $2ZADR.toDate)(baseDate);
        dateRight = (0, $2ZADR.toDate)(date);
    } else {
        dateLeft = (0, $2ZADR.toDate)(date);
        dateRight = (0, $2ZADR.toDate)(baseDate);
    }
    const seconds = (0, $kDfdQ.differenceInSeconds)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $koDIg.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $koDIg.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $jpzPN.minutesInDay) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $jpzPN.minutesInMonth) {
        const days = Math.round(minutes / $jpzPN.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $jpzPN.minutesInMonth * 2) {
        months = Math.round(minutes / $jpzPN.minutesInMonth);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $cd1xf.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $jpzPN.minutesInMonth);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}

});

parcelRegister("7aQdr", function(module, exports) {

$parcel$export(module.exports, "formatDistanceStrict", function () { return $5391f886bad89bb0$export$e4be225b8ee0a759; }, function (v) { return $5391f886bad89bb0$export$e4be225b8ee0a759 = v; });
var $5391f886bad89bb0$export$e4be225b8ee0a759;
"use strict";
$5391f886bad89bb0$export$e4be225b8ee0a759 = $5391f886bad89bb0$var$formatDistanceStrict;

var $4rIDU = parcelRequire("4rIDU");

var $w0VDZ = parcelRequire("w0VDZ");

var $dTgy4 = parcelRequire("dTgy4");

var $koDIg = parcelRequire("koDIg");

var $g0C3p = parcelRequire("g0C3p");

var $jpzPN = parcelRequire("jpzPN");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $5391f886bad89bb0$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $4rIDU.defaultLocale;
    const comparison = (0, $g0C3p.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $2ZADR.toDate)(baseDate);
        dateRight = (0, $2ZADR.toDate)(date);
    } else {
        dateLeft = (0, $2ZADR.toDate)(date);
        dateRight = (0, $2ZADR.toDate)(baseDate);
    }
    const roundingMethod = (0, $dTgy4.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $jpzPN.millisecondsInMinute;
    const timezoneOffset = (0, $koDIg.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $koDIg.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $jpzPN.millisecondsInMinute;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $jpzPN.minutesInDay) unit = "hour";
        else if (dstNormalizedMinutes < $jpzPN.minutesInMonth) unit = "day";
        else if (dstNormalizedMinutes < $jpzPN.minutesInYear) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $jpzPN.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $jpzPN.minutesInMonth);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $jpzPN.minutesInYear);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}

});

parcelRegister("f713j", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNow", function () { return $b00853768558d5cd$export$d130c20a256f8817; }, function (v) { return $b00853768558d5cd$export$d130c20a256f8817 = v; });
var $b00853768558d5cd$export$d130c20a256f8817;
"use strict";
$b00853768558d5cd$export$d130c20a256f8817 = $b00853768558d5cd$var$formatDistanceToNow;

var $4w0cM = parcelRequire("4w0cM");

var $cXAdF = parcelRequire("cXAdF");
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $b00853768558d5cd$var$formatDistanceToNow(date, options) {
    return (0, $cXAdF.formatDistance)(date, (0, $4w0cM.constructNow)(date), options);
}

});

parcelRegister("1f0PT", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNowStrict", function () { return $0e77d726883f8828$export$d0e02d4eb1ad1e32; }, function (v) { return $0e77d726883f8828$export$d0e02d4eb1ad1e32 = v; });
var $0e77d726883f8828$export$d0e02d4eb1ad1e32;
"use strict";
$0e77d726883f8828$export$d0e02d4eb1ad1e32 = $0e77d726883f8828$var$formatDistanceToNowStrict;

var $7aQdr = parcelRequire("7aQdr");

var $4w0cM = parcelRequire("4w0cM");
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $0e77d726883f8828$var$formatDistanceToNowStrict(date, options) {
    return (0, $7aQdr.formatDistanceStrict)(date, (0, $4w0cM.constructNow)(date), options);
}

});

parcelRegister("bRrVf", function(module, exports) {

$parcel$export(module.exports, "formatDuration", function () { return $8a2a4dc38d7f2908$export$bc733b0c5cbb3e8a; }, function (v) { return $8a2a4dc38d7f2908$export$bc733b0c5cbb3e8a = v; });
var $8a2a4dc38d7f2908$export$bc733b0c5cbb3e8a;
"use strict";
$8a2a4dc38d7f2908$export$bc733b0c5cbb3e8a = $8a2a4dc38d7f2908$var$formatDuration;

var $4rIDU = parcelRequire("4rIDU");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link formatDuration} function options.
 */ const $8a2a4dc38d7f2908$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $8a2a4dc38d7f2908$var$formatDuration(duration, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $4rIDU.defaultLocale;
    const format = options?.format ?? $8a2a4dc38d7f2908$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

});

parcelRegister("dueTq", function(module, exports) {

$parcel$export(module.exports, "formatISO", function () { return $9d19a11e836e30b0$export$3c826ac3ab9da76c; }, function (v) { return $9d19a11e836e30b0$export$3c826ac3ab9da76c = v; });
var $9d19a11e836e30b0$export$3c826ac3ab9da76c;
"use strict";
$9d19a11e836e30b0$export$3c826ac3ab9da76c = $9d19a11e836e30b0$var$formatISO;

var $2ZADR = parcelRequire("2ZADR");

var $2iQOO = parcelRequire("2iQOO");
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $9d19a11e836e30b0$var$formatISO(date, options) {
    const _date = (0, $2ZADR.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $2iQOO.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $2iQOO.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $2iQOO.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $2iQOO.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $2iQOO.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $2iQOO.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $2iQOO.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $2iQOO.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}

});

parcelRegister("bzn59", function(module, exports) {

$parcel$export(module.exports, "formatISO9075", function () { return $86c4de3128c0058c$export$a673944250043fa4; }, function (v) { return $86c4de3128c0058c$export$a673944250043fa4 = v; });
var $86c4de3128c0058c$export$a673944250043fa4;
"use strict";
$86c4de3128c0058c$export$a673944250043fa4 = $86c4de3128c0058c$var$formatISO9075;

var $8SDsI = parcelRequire("8SDsI");

var $2ZADR = parcelRequire("2ZADR");

var $2iQOO = parcelRequire("2iQOO");
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $86c4de3128c0058c$var$formatISO9075(date, options) {
    const _date = (0, $2ZADR.toDate)(date);
    if (!(0, $8SDsI.isValid)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $2iQOO.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $2iQOO.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $2iQOO.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $2iQOO.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $2iQOO.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $2iQOO.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}

});

parcelRegister("4gXiM", function(module, exports) {

$parcel$export(module.exports, "formatISODuration", function () { return $31c6a82941ba3f0b$export$437c31ab743f6b26; }, function (v) { return $31c6a82941ba3f0b$export$437c31ab743f6b26 = v; });
var $31c6a82941ba3f0b$export$437c31ab743f6b26;
"use strict";
$31c6a82941ba3f0b$export$437c31ab743f6b26 = $31c6a82941ba3f0b$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $31c6a82941ba3f0b$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

});

parcelRegister("89sdf", function(module, exports) {

$parcel$export(module.exports, "formatRFC3339", function () { return $5ef50c6aea98d01c$export$6d441bffeec6bd6c; }, function (v) { return $5ef50c6aea98d01c$export$6d441bffeec6bd6c = v; });
var $5ef50c6aea98d01c$export$6d441bffeec6bd6c;
"use strict";
$5ef50c6aea98d01c$export$6d441bffeec6bd6c = $5ef50c6aea98d01c$var$formatRFC3339;

var $8SDsI = parcelRequire("8SDsI");

var $2ZADR = parcelRequire("2ZADR");

var $2iQOO = parcelRequire("2iQOO");
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $5ef50c6aea98d01c$var$formatRFC3339(date, options) {
    const _date = (0, $2ZADR.toDate)(date);
    if (!(0, $8SDsI.isValid)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $2iQOO.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, $2iQOO.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $2iQOO.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, $2iQOO.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, $2iQOO.addLeadingZeros)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $2iQOO.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $2iQOO.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $2iQOO.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

});

parcelRegister("fEL4X", function(module, exports) {

$parcel$export(module.exports, "formatRFC7231", function () { return $b65f1c59ce901bb9$export$7add2e4539ce658a; }, function (v) { return $b65f1c59ce901bb9$export$7add2e4539ce658a = v; });
var $b65f1c59ce901bb9$export$7add2e4539ce658a;
"use strict";
$b65f1c59ce901bb9$export$7add2e4539ce658a = $b65f1c59ce901bb9$var$formatRFC7231;

var $8SDsI = parcelRequire("8SDsI");

var $2ZADR = parcelRequire("2ZADR");

var $2iQOO = parcelRequire("2iQOO");
const $b65f1c59ce901bb9$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $b65f1c59ce901bb9$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $b65f1c59ce901bb9$var$formatRFC7231(date) {
    const _date = (0, $2ZADR.toDate)(date);
    if (!(0, $8SDsI.isValid)(_date)) throw new RangeError("Invalid time value");
    const dayName = $b65f1c59ce901bb9$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $2iQOO.addLeadingZeros)(_date.getUTCDate(), 2);
    const monthName = $b65f1c59ce901bb9$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $2iQOO.addLeadingZeros)(_date.getUTCHours(), 2);
    const minute = (0, $2iQOO.addLeadingZeros)(_date.getUTCMinutes(), 2);
    const second = (0, $2iQOO.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}

});

parcelRegister("iXQEe", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $dce6937470c496cf$export$8fbbfd65594f46a0; }, function (v) { return $dce6937470c496cf$export$8fbbfd65594f46a0 = v; });
var $dce6937470c496cf$export$8fbbfd65594f46a0;
"use strict";
$dce6937470c496cf$export$8fbbfd65594f46a0 = $dce6937470c496cf$var$formatRelative;

var $dNCuX = parcelRequire("dNCuX");

var $a5wsS = parcelRequire("a5wsS");

var $2ZADR = parcelRequire("2ZADR");

var $4rIDU = parcelRequire("4rIDU");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $dce6937470c496cf$var$formatRelative(date, baseDate, options) {
    const _date = (0, $2ZADR.toDate)(date);
    const _baseDate = (0, $2ZADR.toDate)(baseDate);
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $4rIDU.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $dNCuX.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $a5wsS.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

});

parcelRegister("1CXb3", function(module, exports) {

$parcel$export(module.exports, "fromUnixTime", function () { return $12f73e6b9ae57aff$export$3664df8597731ed4; }, function (v) { return $12f73e6b9ae57aff$export$3664df8597731ed4 = v; });
var $12f73e6b9ae57aff$export$3664df8597731ed4;
"use strict";
$12f73e6b9ae57aff$export$3664df8597731ed4 = $12f73e6b9ae57aff$var$fromUnixTime;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $12f73e6b9ae57aff$var$fromUnixTime(unixTime) {
    return (0, $2ZADR.toDate)(unixTime * 1000);
}

});

parcelRegister("honqr", function(module, exports) {

$parcel$export(module.exports, "getDate", function () { return $ca96d965270530e2$export$aa350b96d91cd94; }, function (v) { return $ca96d965270530e2$export$aa350b96d91cd94 = v; });
var $ca96d965270530e2$export$aa350b96d91cd94;
"use strict";
$ca96d965270530e2$export$aa350b96d91cd94 = $ca96d965270530e2$var$getDate;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $ca96d965270530e2$var$getDate(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRegister("25jJv", function(module, exports) {

$parcel$export(module.exports, "getDay", function () { return $184b5af3fb08f2a0$export$1b64bc9c5306ed54; }, function (v) { return $184b5af3fb08f2a0$export$1b64bc9c5306ed54 = v; });
var $184b5af3fb08f2a0$export$1b64bc9c5306ed54;
"use strict";
$184b5af3fb08f2a0$export$1b64bc9c5306ed54 = $184b5af3fb08f2a0$var$getDay;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $184b5af3fb08f2a0$var$getDay(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const day = _date.getDay();
    return day;
}

});

parcelRegister("2GUBT", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", function () { return $1f5b6a9b4b1aca72$export$f645ddd439eb259d; }, function (v) { return $1f5b6a9b4b1aca72$export$f645ddd439eb259d = v; });
var $1f5b6a9b4b1aca72$export$f645ddd439eb259d;
"use strict";
$1f5b6a9b4b1aca72$export$f645ddd439eb259d = $1f5b6a9b4b1aca72$var$getDaysInMonth;

var $2ZADR = parcelRequire("2ZADR");

var $2J98k = parcelRequire("2J98k");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $1f5b6a9b4b1aca72$var$getDaysInMonth(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $2J98k.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("bSxKo", function(module, exports) {

$parcel$export(module.exports, "getDaysInYear", function () { return $8a5eea62a6730d58$export$63a4a9fc49e3550e; }, function (v) { return $8a5eea62a6730d58$export$63a4a9fc49e3550e = v; });
var $8a5eea62a6730d58$export$63a4a9fc49e3550e;
"use strict";
$8a5eea62a6730d58$export$63a4a9fc49e3550e = $8a5eea62a6730d58$var$getDaysInYear;

var $RmBFW = parcelRequire("RmBFW");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $8a5eea62a6730d58$var$getDaysInYear(date) {
    const _date = (0, $2ZADR.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $RmBFW.isLeapYear)(_date) ? 366 : 365;
}

});
parcelRegister("RmBFW", function(module, exports) {

$parcel$export(module.exports, "isLeapYear", function () { return $0a067c90c34e16e7$export$553d7fa8e3805fc0; }, function (v) { return $0a067c90c34e16e7$export$553d7fa8e3805fc0 = v; });
var $0a067c90c34e16e7$export$553d7fa8e3805fc0;
"use strict";
$0a067c90c34e16e7$export$553d7fa8e3805fc0 = $0a067c90c34e16e7$var$isLeapYear;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $0a067c90c34e16e7$var$isLeapYear(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});


parcelRegister("2IJZ3", function(module, exports) {

$parcel$export(module.exports, "getDecade", function () { return $1fb35c3f051f252a$export$5bc0f4decfc52b64; }, function (v) { return $1fb35c3f051f252a$export$5bc0f4decfc52b64 = v; });
var $1fb35c3f051f252a$export$5bc0f4decfc52b64;
"use strict";
$1fb35c3f051f252a$export$5bc0f4decfc52b64 = $1fb35c3f051f252a$var$getDecade;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $1fb35c3f051f252a$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}

});

parcelRegister("2pXmW", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $1c2bf80bea8dbb5d$export$430a3269e24b912e; }, function (v) { return $1c2bf80bea8dbb5d$export$430a3269e24b912e = v; });
var $1c2bf80bea8dbb5d$export$430a3269e24b912e;
"use strict";
$1c2bf80bea8dbb5d$export$430a3269e24b912e = $1c2bf80bea8dbb5d$var$getDefaultOptions;

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $1c2bf80bea8dbb5d$var$getDefaultOptions() {
    return Object.assign({}, (0, $w0VDZ.getDefaultOptions)());
}

});

parcelRegister("aumJk", function(module, exports) {

$parcel$export(module.exports, "getHours", function () { return $7a2e566ffdb9cdd8$export$257b40f71c07d58f; }, function (v) { return $7a2e566ffdb9cdd8$export$257b40f71c07d58f = v; });
var $7a2e566ffdb9cdd8$export$257b40f71c07d58f;
"use strict";
$7a2e566ffdb9cdd8$export$257b40f71c07d58f = $7a2e566ffdb9cdd8$var$getHours;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $7a2e566ffdb9cdd8$var$getHours(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRegister("fF239", function(module, exports) {

$parcel$export(module.exports, "getISODay", function () { return $b66c46626c161b30$export$c514f4c1a8ed5e9e; }, function (v) { return $b66c46626c161b30$export$c514f4c1a8ed5e9e = v; });
var $b66c46626c161b30$export$c514f4c1a8ed5e9e;
"use strict";
$b66c46626c161b30$export$c514f4c1a8ed5e9e = $b66c46626c161b30$var$getISODay;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $b66c46626c161b30$var$getISODay(date) {
    const _date = (0, $2ZADR.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});

parcelRegister("j6n0z", function(module, exports) {

$parcel$export(module.exports, "getISOWeeksInYear", function () { return $de806cd18730a1cc$export$822983242a16750f; }, function (v) { return $de806cd18730a1cc$export$822983242a16750f = v; });
var $de806cd18730a1cc$export$822983242a16750f;
"use strict";
$de806cd18730a1cc$export$822983242a16750f = $de806cd18730a1cc$var$getISOWeeksInYear;

var $328s2 = parcelRequire("328s2");

var $jpzPN = parcelRequire("jpzPN");

var $7cc1O = parcelRequire("7cc1O");
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $de806cd18730a1cc$var$getISOWeeksInYear(date) {
    const thisYear = (0, $7cc1O.startOfISOWeekYear)(date);
    const nextYear = (0, $7cc1O.startOfISOWeekYear)((0, $328s2.addWeeks)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $jpzPN.millisecondsInWeek);
}

});

parcelRegister("g07qF", function(module, exports) {

$parcel$export(module.exports, "getMilliseconds", function () { return $ba6268addf0b4a6d$export$b8e4380f312797af; }, function (v) { return $ba6268addf0b4a6d$export$b8e4380f312797af = v; });
var $ba6268addf0b4a6d$export$b8e4380f312797af;
"use strict";
$ba6268addf0b4a6d$export$b8e4380f312797af = $ba6268addf0b4a6d$var$getMilliseconds;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $ba6268addf0b4a6d$var$getMilliseconds(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}

});

parcelRegister("3MvNo", function(module, exports) {

$parcel$export(module.exports, "getMinutes", function () { return $2c0e84c2d01ce629$export$b7f1bc3ea3ac4145; }, function (v) { return $2c0e84c2d01ce629$export$b7f1bc3ea3ac4145 = v; });
var $2c0e84c2d01ce629$export$b7f1bc3ea3ac4145;
"use strict";
$2c0e84c2d01ce629$export$b7f1bc3ea3ac4145 = $2c0e84c2d01ce629$var$getMinutes;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $2c0e84c2d01ce629$var$getMinutes(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRegister("f3o96", function(module, exports) {

$parcel$export(module.exports, "getMonth", function () { return $af59dda96c35996f$export$6ce1b5acc29cb53b; }, function (v) { return $af59dda96c35996f$export$6ce1b5acc29cb53b = v; });
var $af59dda96c35996f$export$6ce1b5acc29cb53b;
"use strict";
$af59dda96c35996f$export$6ce1b5acc29cb53b = $af59dda96c35996f$var$getMonth;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $af59dda96c35996f$var$getMonth(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRegister("8Ghpp", function(module, exports) {

$parcel$export(module.exports, "getOverlappingDaysInIntervals", function () { return $651fc001cd0f0815$export$baae148532bd1d46; }, function (v) { return $651fc001cd0f0815$export$baae148532bd1d46 = v; });
var $651fc001cd0f0815$export$baae148532bd1d46;
"use strict";
$651fc001cd0f0815$export$baae148532bd1d46 = $651fc001cd0f0815$var$getOverlappingDaysInIntervals;

var $koDIg = parcelRequire("koDIg");

var $jpzPN = parcelRequire("jpzPN");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $651fc001cd0f0815$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $2ZADR.toDate)(intervalLeft.start),
        +(0, $2ZADR.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $2ZADR.toDate)(intervalRight.start),
        +(0, $2ZADR.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $koDIg.getTimezoneOffsetInMilliseconds)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $koDIg.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $jpzPN.millisecondsInDay);
}

});

parcelRegister("jQ5tf", function(module, exports) {

$parcel$export(module.exports, "getSeconds", function () { return $e7171e01a8d1f965$export$5e9417507ff28427; }, function (v) { return $e7171e01a8d1f965$export$5e9417507ff28427 = v; });
var $e7171e01a8d1f965$export$5e9417507ff28427;
"use strict";
$e7171e01a8d1f965$export$5e9417507ff28427 = $e7171e01a8d1f965$var$getSeconds;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $e7171e01a8d1f965$var$getSeconds(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRegister("kwLky", function(module, exports) {

$parcel$export(module.exports, "getTime", function () { return $ef1b82a53c157ab8$export$1428f42a7de81803; }, function (v) { return $ef1b82a53c157ab8$export$1428f42a7de81803 = v; });
var $ef1b82a53c157ab8$export$1428f42a7de81803;
"use strict";
$ef1b82a53c157ab8$export$1428f42a7de81803 = $ef1b82a53c157ab8$var$getTime;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $ef1b82a53c157ab8$var$getTime(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}

});

parcelRegister("cGISj", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", function () { return $93cc37831057ee0c$export$1f77c0008d16313; }, function (v) { return $93cc37831057ee0c$export$1f77c0008d16313 = v; });
var $93cc37831057ee0c$export$1f77c0008d16313;
"use strict";
$93cc37831057ee0c$export$1f77c0008d16313 = $93cc37831057ee0c$var$getUnixTime;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $93cc37831057ee0c$var$getUnixTime(date) {
    return Math.trunc(+(0, $2ZADR.toDate)(date) / 1000);
}

});

parcelRegister("atSzF", function(module, exports) {

$parcel$export(module.exports, "getWeekOfMonth", function () { return $7a16f220aae32e3a$export$59fb9b85a4d8d027; }, function (v) { return $7a16f220aae32e3a$export$59fb9b85a4d8d027 = v; });
var $7a16f220aae32e3a$export$59fb9b85a4d8d027;
"use strict";
$7a16f220aae32e3a$export$59fb9b85a4d8d027 = $7a16f220aae32e3a$var$getWeekOfMonth;

var $honqr = parcelRequire("honqr");

var $25jJv = parcelRequire("25jJv");

var $3tjSb = parcelRequire("3tjSb");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $7a16f220aae32e3a$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $honqr.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $25jJv.getDay)((0, $3tjSb.startOfMonth)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

});

parcelRegister("WiUGI", function(module, exports) {

$parcel$export(module.exports, "getWeeksInMonth", function () { return $0af416afb72851e7$export$ccc1b2479e7dd654; }, function (v) { return $0af416afb72851e7$export$ccc1b2479e7dd654 = v; });
var $0af416afb72851e7$export$ccc1b2479e7dd654;
"use strict";
$0af416afb72851e7$export$ccc1b2479e7dd654 = $0af416afb72851e7$var$getWeeksInMonth;

var $cFg1S = parcelRequire("cFg1S");

var $844AJ = parcelRequire("844AJ");

var $3tjSb = parcelRequire("3tjSb");
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $0af416afb72851e7$var$getWeeksInMonth(date, options) {
    return (0, $cFg1S.differenceInCalendarWeeks)((0, $844AJ.lastDayOfMonth)(date), (0, $3tjSb.startOfMonth)(date), options) + 1;
}

});
parcelRegister("844AJ", function(module, exports) {

$parcel$export(module.exports, "lastDayOfMonth", function () { return $5df242352d8e7fa8$export$36818250d6c87922; }, function (v) { return $5df242352d8e7fa8$export$36818250d6c87922 = v; });
var $5df242352d8e7fa8$export$36818250d6c87922;
"use strict";
$5df242352d8e7fa8$export$36818250d6c87922 = $5df242352d8e7fa8$var$lastDayOfMonth;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $5df242352d8e7fa8$var$lastDayOfMonth(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("lbAnK", function(module, exports) {

$parcel$export(module.exports, "getYear", function () { return $f6c6d8c3c8d67310$export$5846dc2d57a5c860; }, function (v) { return $f6c6d8c3c8d67310$export$5846dc2d57a5c860 = v; });
var $f6c6d8c3c8d67310$export$5846dc2d57a5c860;
"use strict";
$f6c6d8c3c8d67310$export$5846dc2d57a5c860 = $f6c6d8c3c8d67310$var$getYear;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $f6c6d8c3c8d67310$var$getYear(date) {
    return (0, $2ZADR.toDate)(date).getFullYear();
}

});

parcelRegister("arZLy", function(module, exports) {

$parcel$export(module.exports, "hoursToMilliseconds", function () { return $79bc5674ca189e60$export$5b42ab7a22898b69; }, function (v) { return $79bc5674ca189e60$export$5b42ab7a22898b69 = v; });
var $79bc5674ca189e60$export$5b42ab7a22898b69;
"use strict";
$79bc5674ca189e60$export$5b42ab7a22898b69 = $79bc5674ca189e60$var$hoursToMilliseconds;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $79bc5674ca189e60$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $jpzPN.millisecondsInHour);
}

});

parcelRegister("5vR3l", function(module, exports) {

$parcel$export(module.exports, "hoursToMinutes", function () { return $4039003bfab9b97a$export$83bfc73cdf89a4d8; }, function (v) { return $4039003bfab9b97a$export$83bfc73cdf89a4d8 = v; });
var $4039003bfab9b97a$export$83bfc73cdf89a4d8;
"use strict";
$4039003bfab9b97a$export$83bfc73cdf89a4d8 = $4039003bfab9b97a$var$hoursToMinutes;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $4039003bfab9b97a$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $jpzPN.minutesInHour);
}

});

parcelRegister("giaCC", function(module, exports) {

$parcel$export(module.exports, "hoursToSeconds", function () { return $bdc69112c8cb55c5$export$59b1396ccbd5a4e1; }, function (v) { return $bdc69112c8cb55c5$export$59b1396ccbd5a4e1 = v; });
var $bdc69112c8cb55c5$export$59b1396ccbd5a4e1;
"use strict";
$bdc69112c8cb55c5$export$59b1396ccbd5a4e1 = $bdc69112c8cb55c5$var$hoursToSeconds;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $bdc69112c8cb55c5$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $jpzPN.secondsInHour);
}

});

parcelRegister("khUWr", function(module, exports) {

$parcel$export(module.exports, "interval", function () { return $ec51909b4f8eeb6a$export$3174cdbf0a0cbc84; }, function (v) { return $ec51909b4f8eeb6a$export$3174cdbf0a0cbc84 = v; });
var $ec51909b4f8eeb6a$export$3174cdbf0a0cbc84;
"use strict";
$ec51909b4f8eeb6a$export$3174cdbf0a0cbc84 = $ec51909b4f8eeb6a$var$interval;

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $ec51909b4f8eeb6a$var$interval(start, end, options) {
    const _start = (0, $2ZADR.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $2ZADR.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}

});

parcelRegister("ifdHb", function(module, exports) {

$parcel$export(module.exports, "intervalToDuration", function () { return $d48440589755e694$export$7b6c9a626316863; }, function (v) { return $d48440589755e694$export$7b6c9a626316863 = v; });
var $d48440589755e694$export$7b6c9a626316863;
"use strict";
$d48440589755e694$export$7b6c9a626316863 = $d48440589755e694$var$intervalToDuration;

var $OzG2U = parcelRequire("OzG2U");

var $lJGm5 = parcelRequire("lJGm5");

var $aEauj = parcelRequire("aEauj");

var $3v3tg = parcelRequire("3v3tg");

var $cd1xf = parcelRequire("cd1xf");

var $kDfdQ = parcelRequire("kDfdQ");

var $b53t3 = parcelRequire("b53t3");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $d48440589755e694$var$intervalToDuration(interval) {
    const start = (0, $2ZADR.toDate)(interval.start);
    const end = (0, $2ZADR.toDate)(interval.end);
    const duration = {};
    const years = (0, $b53t3.differenceInYears)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $OzG2U.add)(start, {
        years: duration.years
    });
    const months = (0, $cd1xf.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $OzG2U.add)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $lJGm5.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $OzG2U.add)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $aEauj.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $OzG2U.add)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $3v3tg.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $OzG2U.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $kDfdQ.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}

});

parcelRegister("14uNq", function(module, exports) {

$parcel$export(module.exports, "intlFormat", function () { return $0c7e0da1d2de59ef$export$f58f1234eed71f82; }, function (v) { return $0c7e0da1d2de59ef$export$f58f1234eed71f82 = v; });
var $0c7e0da1d2de59ef$export$f58f1234eed71f82;
"use strict";
$0c7e0da1d2de59ef$export$f58f1234eed71f82 = $0c7e0da1d2de59ef$var$intlFormat;

var $2ZADR = parcelRequire("2ZADR");
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $0c7e0da1d2de59ef$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($0c7e0da1d2de59ef$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $2ZADR.toDate)(date));
}
function $0c7e0da1d2de59ef$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}

});

parcelRegister("6ZpXn", function(module, exports) {

$parcel$export(module.exports, "intlFormatDistance", function () { return $516c930b33f49dff$export$a110a4020280fd5; }, function (v) { return $516c930b33f49dff$export$a110a4020280fd5 = v; });
var $516c930b33f49dff$export$a110a4020280fd5;
"use strict";
$516c930b33f49dff$export$a110a4020280fd5 = $516c930b33f49dff$var$intlFormatDistance;

var $jpzPN = parcelRequire("jpzPN");

var $dNCuX = parcelRequire("dNCuX");

var $5p9kz = parcelRequire("5p9kz");

var $cp3hy = parcelRequire("cp3hy");

var $cFg1S = parcelRequire("cFg1S");

var $gWC9G = parcelRequire("gWC9G");

var $aEauj = parcelRequire("aEauj");

var $3v3tg = parcelRequire("3v3tg");

var $kDfdQ = parcelRequire("kDfdQ");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $516c930b33f49dff$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $2ZADR.toDate)(date);
    const dateRight = (0, $2ZADR.toDate)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $kDfdQ.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $jpzPN.secondsInMinute) {
            value = (0, $kDfdQ.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $jpzPN.secondsInHour) {
            value = (0, $3v3tg.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $jpzPN.secondsInDay && Math.abs((0, $dNCuX.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, $aEauj.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $jpzPN.secondsInWeek && (value = (0, $dNCuX.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $jpzPN.secondsInMonth) {
            value = (0, $cFg1S.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $jpzPN.secondsInQuarter) {
            value = (0, $5p9kz.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $jpzPN.secondsInYear) {
            if ((0, $cp3hy.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $cp3hy.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $gWC9G.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $gWC9G.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $kDfdQ.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $3v3tg.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $aEauj.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $dNCuX.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $cFg1S.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $5p9kz.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $cp3hy.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $gWC9G.differenceInCalendarYears)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}

});

parcelRegister("3elBl", function(module, exports) {

$parcel$export(module.exports, "isAfter", function () { return $25a36f756eeb82e5$export$e4de839670987035; }, function (v) { return $25a36f756eeb82e5$export$e4de839670987035 = v; });
var $25a36f756eeb82e5$export$e4de839670987035;
"use strict";
$25a36f756eeb82e5$export$e4de839670987035 = $25a36f756eeb82e5$var$isAfter;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $25a36f756eeb82e5$var$isAfter(date, dateToCompare) {
    const _date = (0, $2ZADR.toDate)(date);
    const _dateToCompare = (0, $2ZADR.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRegister("ezU5r", function(module, exports) {

$parcel$export(module.exports, "isBefore", function () { return $a9cfd73d1e745e8b$export$5c007e10c6929c95; }, function (v) { return $a9cfd73d1e745e8b$export$5c007e10c6929c95 = v; });
var $a9cfd73d1e745e8b$export$5c007e10c6929c95;
"use strict";
$a9cfd73d1e745e8b$export$5c007e10c6929c95 = $a9cfd73d1e745e8b$var$isBefore;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $a9cfd73d1e745e8b$var$isBefore(date, dateToCompare) {
    const _date = (0, $2ZADR.toDate)(date);
    const _dateToCompare = (0, $2ZADR.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRegister("7QKjt", function(module, exports) {

$parcel$export(module.exports, "isEqual", function () { return $5b71508cb889d359$export$248d38f6296296c5; }, function (v) { return $5b71508cb889d359$export$248d38f6296296c5 = v; });
var $5b71508cb889d359$export$248d38f6296296c5;
"use strict";
$5b71508cb889d359$export$248d38f6296296c5 = $5b71508cb889d359$var$isEqual;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $5b71508cb889d359$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $2ZADR.toDate)(leftDate);
    const _dateRight = (0, $2ZADR.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRegister("bbwWq", function(module, exports) {

$parcel$export(module.exports, "isExists", function () { return $824a46474afcc77f$export$127519e0edcdc58b; }, function (v) { return $824a46474afcc77f$export$127519e0edcdc58b = v; });
var $824a46474afcc77f$export$127519e0edcdc58b;
"use strict";
$824a46474afcc77f$export$127519e0edcdc58b = $824a46474afcc77f$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $824a46474afcc77f$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

});

parcelRegister("9BjRD", function(module, exports) {

$parcel$export(module.exports, "isFirstDayOfMonth", function () { return $6fd6fa5f23144504$export$2716a425049f51dd; }, function (v) { return $6fd6fa5f23144504$export$2716a425049f51dd = v; });
var $6fd6fa5f23144504$export$2716a425049f51dd;
"use strict";
$6fd6fa5f23144504$export$2716a425049f51dd = $6fd6fa5f23144504$var$isFirstDayOfMonth;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $6fd6fa5f23144504$var$isFirstDayOfMonth(date) {
    return (0, $2ZADR.toDate)(date).getDate() === 1;
}

});

parcelRegister("b2ASO", function(module, exports) {

$parcel$export(module.exports, "isFriday", function () { return $809c7dd5000139f3$export$3b7d89f127884993; }, function (v) { return $809c7dd5000139f3$export$3b7d89f127884993 = v; });
var $809c7dd5000139f3$export$3b7d89f127884993;
"use strict";
$809c7dd5000139f3$export$3b7d89f127884993 = $809c7dd5000139f3$var$isFriday;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $809c7dd5000139f3$var$isFriday(date) {
    return (0, $2ZADR.toDate)(date).getDay() === 5;
}

});

parcelRegister("6NLud", function(module, exports) {

$parcel$export(module.exports, "isFuture", function () { return $4f3c277481521c24$export$2baac2df6018cd7; }, function (v) { return $4f3c277481521c24$export$2baac2df6018cd7 = v; });
var $4f3c277481521c24$export$2baac2df6018cd7;
"use strict";
$4f3c277481521c24$export$2baac2df6018cd7 = $4f3c277481521c24$var$isFuture;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $4f3c277481521c24$var$isFuture(date) {
    return +(0, $2ZADR.toDate)(date) > Date.now();
}

});

parcelRegister("hJ5b4", function(module, exports) {

$parcel$export(module.exports, "isMatch", function () { return $ce7aa7c8d42e346d$export$b74c33566721f70f; }, function (v) { return $ce7aa7c8d42e346d$export$b74c33566721f70f = v; });
var $ce7aa7c8d42e346d$export$b74c33566721f70f;
"use strict";
$ce7aa7c8d42e346d$export$b74c33566721f70f = $ce7aa7c8d42e346d$var$isMatch;

var $8SDsI = parcelRequire("8SDsI");

var $bdOW5 = parcelRequire("bdOW5");
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $ce7aa7c8d42e346d$var$isMatch(dateStr, formatStr, options) {
    return (0, $8SDsI.isValid)((0, $bdOW5.parse)(dateStr, formatStr, new Date(), options));
}

});
parcelRegister("bdOW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $16dsw.longFormatters;
    }
});
module.exports.parse = $82b86b6b056d8bd1$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $gB42w.parsers;
    }
});

var $2J98k = parcelRequire("2J98k");

var $2pXmW = parcelRequire("2pXmW");

var $4rIDU = parcelRequire("4rIDU");

var $2ZADR = parcelRequire("2ZADR");

var $16dsw = parcelRequire("16dsw");

var $frKKs = parcelRequire("frKKs");

var $gB42w = parcelRequire("gB42w");

var $eDoky = parcelRequire("eDoky");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $82b86b6b056d8bd1$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $82b86b6b056d8bd1$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $82b86b6b056d8bd1$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $82b86b6b056d8bd1$var$doubleQuoteRegExp = /''/g;
const $82b86b6b056d8bd1$var$notWhitespaceRegExp = /\S/;
const $82b86b6b056d8bd1$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $82b86b6b056d8bd1$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $2pXmW.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $4rIDU.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $2ZADR.toDate)(referenceDate);
        else return (0, $2J98k.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $eDoky.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($82b86b6b056d8bd1$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $16dsw.longFormatters) {
            const longFormatter = $16dsw.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($82b86b6b056d8bd1$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $frKKs.isProtectedWeekYearToken)(token)) (0, $frKKs.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $frKKs.isProtectedDayOfYearToken)(token)) (0, $frKKs.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $gB42w.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $2J98k.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($82b86b6b056d8bd1$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $82b86b6b056d8bd1$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $2J98k.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $82b86b6b056d8bd1$var$notWhitespaceRegExp.test(dateStr)) return (0, $2J98k.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $2ZADR.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $2J98k.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $2J98k.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $2J98k.constructFrom)(referenceDate, date);
}
function $82b86b6b056d8bd1$var$cleanEscapedString(input) {
    return input.match($82b86b6b056d8bd1$var$escapedStringRegExp)[1].replace($82b86b6b056d8bd1$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("gB42w", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $c1533c36d70fb987$export$19131010e7fd8373; }, function (v) { return $c1533c36d70fb987$export$19131010e7fd8373 = v; });
var $c1533c36d70fb987$export$19131010e7fd8373;
"use strict";
$c1533c36d70fb987$export$19131010e7fd8373 = void 0;

var $7UD0p = parcelRequire("7UD0p");

var $iA0Vc = parcelRequire("iA0Vc");

var $4rXoy = parcelRequire("4rXoy");

var $anzLo = parcelRequire("anzLo");

var $lou73 = parcelRequire("lou73");

var $fhXPC = parcelRequire("fhXPC");

var $gBgBX = parcelRequire("gBgBX");

var $etR7a = parcelRequire("etR7a");

var $OgFIi = parcelRequire("OgFIi");

var $hFBiM = parcelRequire("hFBiM");

var $40w2A = parcelRequire("40w2A");

var $j9TgZ = parcelRequire("j9TgZ");

var $53raH = parcelRequire("53raH");

var $dwp94 = parcelRequire("dwp94");

var $hC05v = parcelRequire("hC05v");

var $1Yk4E = parcelRequire("1Yk4E");

var $mlhKn = parcelRequire("mlhKn");

var $ifpFW = parcelRequire("ifpFW");

var $hSXar = parcelRequire("hSXar");

var $76kVa = parcelRequire("76kVa");

var $fuI4l = parcelRequire("fuI4l");

var $3HZSi = parcelRequire("3HZSi");

var $kaBqe = parcelRequire("kaBqe");

var $cBm0i = parcelRequire("cBm0i");

var $5fU7E = parcelRequire("5fU7E");

var $7BP6i = parcelRequire("7BP6i");

var $a7zA0 = parcelRequire("a7zA0");

var $4eiCo = parcelRequire("4eiCo");

var $gvwUL = parcelRequire("gvwUL");

var $5DvKE = parcelRequire("5DvKE");

var $3pjwU = parcelRequire("3pjwU");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $c1533c36d70fb987$var$parsers = $c1533c36d70fb987$export$19131010e7fd8373 = {
    G: new $7UD0p.EraParser(),
    y: new $iA0Vc.YearParser(),
    Y: new $4rXoy.LocalWeekYearParser(),
    R: new $anzLo.ISOWeekYearParser(),
    u: new $lou73.ExtendedYearParser(),
    Q: new $fhXPC.QuarterParser(),
    q: new $gBgBX.StandAloneQuarterParser(),
    M: new $etR7a.MonthParser(),
    L: new $OgFIi.StandAloneMonthParser(),
    w: new $hFBiM.LocalWeekParser(),
    I: new $40w2A.ISOWeekParser(),
    d: new $j9TgZ.DateParser(),
    D: new $53raH.DayOfYearParser(),
    E: new $dwp94.DayParser(),
    e: new $hC05v.LocalDayParser(),
    c: new $1Yk4E.StandAloneLocalDayParser(),
    i: new $mlhKn.ISODayParser(),
    a: new $ifpFW.AMPMParser(),
    b: new $hSXar.AMPMMidnightParser(),
    B: new $76kVa.DayPeriodParser(),
    h: new $fuI4l.Hour1to12Parser(),
    H: new $3HZSi.Hour0to23Parser(),
    K: new $kaBqe.Hour0To11Parser(),
    k: new $cBm0i.Hour1To24Parser(),
    m: new $5fU7E.MinuteParser(),
    s: new $7BP6i.SecondParser(),
    S: new $a7zA0.FractionOfSecondParser(),
    X: new $4eiCo.ISOTimezoneWithZParser(),
    x: new $gvwUL.ISOTimezoneParser(),
    t: new $5DvKE.TimestampSecondsParser(),
    T: new $3pjwU.TimestampMillisecondsParser()
};

});
parcelRegister("7UD0p", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $5c2c051604135fef$export$8e5a1d3f85a9688; }, function (v) { return $5c2c051604135fef$export$8e5a1d3f85a9688 = v; });
var $5c2c051604135fef$export$8e5a1d3f85a9688;
"use strict";
$5c2c051604135fef$export$8e5a1d3f85a9688 = void 0;

var $4iw05 = parcelRequire("4iw05");
class $5c2c051604135fef$var$EraParser extends $4iw05.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$5c2c051604135fef$export$8e5a1d3f85a9688 = $5c2c051604135fef$var$EraParser;

});
parcelRegister("4iw05", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $3211aa7a96911225$export$7acfa6ed01010e37; }, function (v) { return $3211aa7a96911225$export$7acfa6ed01010e37 = v; });
var $3211aa7a96911225$export$7acfa6ed01010e37;
"use strict";
$3211aa7a96911225$export$7acfa6ed01010e37 = void 0;

var $eDoky = parcelRequire("eDoky");
class $3211aa7a96911225$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $eDoky.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$3211aa7a96911225$export$7acfa6ed01010e37 = $3211aa7a96911225$var$Parser;

});
parcelRegister("eDoky", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $aa7794c0d399b66f$export$9a09e32dd4990fd5; }, function (v) { return $aa7794c0d399b66f$export$9a09e32dd4990fd5 = v; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $aa7794c0d399b66f$export$5aaf7ff7f09ea4ee; }, function (v) { return $aa7794c0d399b66f$export$5aaf7ff7f09ea4ee = v; });
var $aa7794c0d399b66f$export$9a09e32dd4990fd5;
var $aa7794c0d399b66f$export$81d53e3678089a6;
var $aa7794c0d399b66f$export$5aaf7ff7f09ea4ee;
"use strict";
$aa7794c0d399b66f$export$9a09e32dd4990fd5 = $aa7794c0d399b66f$export$81d53e3678089a6 = $aa7794c0d399b66f$export$5aaf7ff7f09ea4ee = void 0;

var $e1R7Q = parcelRequire("e1R7Q");

var $2J98k = parcelRequire("2J98k");
const $aa7794c0d399b66f$var$TIMEZONE_UNIT_PRIORITY = 10;
class $aa7794c0d399b66f$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$aa7794c0d399b66f$export$81d53e3678089a6 = $aa7794c0d399b66f$var$Setter;
class $aa7794c0d399b66f$var$ValueSetter extends $aa7794c0d399b66f$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$aa7794c0d399b66f$export$9a09e32dd4990fd5 = $aa7794c0d399b66f$var$ValueSetter;
class $aa7794c0d399b66f$var$DateToSystemTimezoneSetter extends $aa7794c0d399b66f$var$Setter {
    priority = $aa7794c0d399b66f$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $2J98k.constructFrom)(date, (0, $e1R7Q.transpose)(date, Date));
    }
}
$aa7794c0d399b66f$export$5aaf7ff7f09ea4ee = $aa7794c0d399b66f$var$DateToSystemTimezoneSetter;

});
parcelRegister("e1R7Q", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $a36a5e4a89a49082$export$9cb09a71b7d66923; }, function (v) { return $a36a5e4a89a49082$export$9cb09a71b7d66923 = v; });
var $a36a5e4a89a49082$export$9cb09a71b7d66923;
"use strict";
$a36a5e4a89a49082$export$9cb09a71b7d66923 = $a36a5e4a89a49082$var$transpose;

var $2J98k = parcelRequire("2J98k");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $a36a5e4a89a49082$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $2J98k.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRegister("iA0Vc", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $d86c4dcad27855ed$export$48d352de7cd4a988; }, function (v) { return $d86c4dcad27855ed$export$48d352de7cd4a988 = v; });
var $d86c4dcad27855ed$export$48d352de7cd4a988;
"use strict";
$d86c4dcad27855ed$export$48d352de7cd4a988 = void 0;

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $d86c4dcad27855ed$var$YearParser extends $4iw05.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $85Zyp.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $85Zyp.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$d86c4dcad27855ed$export$48d352de7cd4a988 = $d86c4dcad27855ed$var$YearParser;

});
parcelRegister("85Zyp", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $5e4e89b461ad38ad$export$fb506d2676e7f207; }, function (v) { return $5e4e89b461ad38ad$export$fb506d2676e7f207 = v; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $5e4e89b461ad38ad$export$3d50627710b84d75; }, function (v) { return $5e4e89b461ad38ad$export$3d50627710b84d75 = v; });
$parcel$export(module.exports, "mapValue", function () { return $5e4e89b461ad38ad$export$4f84e3a82c7b538; }, function (v) { return $5e4e89b461ad38ad$export$4f84e3a82c7b538 = v; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $5e4e89b461ad38ad$export$29126f735cbf69f7; }, function (v) { return $5e4e89b461ad38ad$export$29126f735cbf69f7 = v; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $5e4e89b461ad38ad$export$d931c43c4608a164; }, function (v) { return $5e4e89b461ad38ad$export$d931c43c4608a164 = v; });
$parcel$export(module.exports, "parseNDigits", function () { return $5e4e89b461ad38ad$export$513bb01536146ab6; }, function (v) { return $5e4e89b461ad38ad$export$513bb01536146ab6 = v; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $5e4e89b461ad38ad$export$2c9307b2e29c533c; }, function (v) { return $5e4e89b461ad38ad$export$2c9307b2e29c533c = v; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $5e4e89b461ad38ad$export$cc7cc9e2a3ff9388; }, function (v) { return $5e4e89b461ad38ad$export$cc7cc9e2a3ff9388 = v; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $5e4e89b461ad38ad$export$6497f4c0ecdfba8e; }, function (v) { return $5e4e89b461ad38ad$export$6497f4c0ecdfba8e = v; });
var $5e4e89b461ad38ad$export$fb506d2676e7f207;
var $5e4e89b461ad38ad$export$3d50627710b84d75;
var $5e4e89b461ad38ad$export$4f84e3a82c7b538;
var $5e4e89b461ad38ad$export$29126f735cbf69f7;
var $5e4e89b461ad38ad$export$d931c43c4608a164;
var $5e4e89b461ad38ad$export$513bb01536146ab6;
var $5e4e89b461ad38ad$export$2c9307b2e29c533c;
var $5e4e89b461ad38ad$export$cc7cc9e2a3ff9388;
var $5e4e89b461ad38ad$export$6497f4c0ecdfba8e;
"use strict";
$5e4e89b461ad38ad$export$fb506d2676e7f207 = $5e4e89b461ad38ad$var$dayPeriodEnumToHours;
$5e4e89b461ad38ad$export$3d50627710b84d75 = $5e4e89b461ad38ad$var$isLeapYearIndex;
$5e4e89b461ad38ad$export$4f84e3a82c7b538 = $5e4e89b461ad38ad$var$mapValue;
$5e4e89b461ad38ad$export$29126f735cbf69f7 = $5e4e89b461ad38ad$var$normalizeTwoDigitYear;
$5e4e89b461ad38ad$export$d931c43c4608a164 = $5e4e89b461ad38ad$var$parseAnyDigitsSigned;
$5e4e89b461ad38ad$export$513bb01536146ab6 = $5e4e89b461ad38ad$var$parseNDigits;
$5e4e89b461ad38ad$export$2c9307b2e29c533c = $5e4e89b461ad38ad$var$parseNDigitsSigned;
$5e4e89b461ad38ad$export$cc7cc9e2a3ff9388 = $5e4e89b461ad38ad$var$parseNumericPattern;
$5e4e89b461ad38ad$export$6497f4c0ecdfba8e = $5e4e89b461ad38ad$var$parseTimezonePattern;

var $jpzPN = parcelRequire("jpzPN");

var $c1pNW = parcelRequire("c1pNW");
function $5e4e89b461ad38ad$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $5e4e89b461ad38ad$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $5e4e89b461ad38ad$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $jpzPN.millisecondsInHour + minutes * $jpzPN.millisecondsInMinute + seconds * $jpzPN.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $5e4e89b461ad38ad$var$parseAnyDigitsSigned(dateString) {
    return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.anyDigitsSigned, dateString);
}
function $5e4e89b461ad38ad$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.singleDigit, dateString);
        case 2:
            return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.twoDigits, dateString);
        case 3:
            return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.threeDigits, dateString);
        case 4:
            return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.fourDigits, dateString);
        default:
            return $5e4e89b461ad38ad$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $5e4e89b461ad38ad$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $5e4e89b461ad38ad$var$parseNumericPattern($c1pNW.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $5e4e89b461ad38ad$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $5e4e89b461ad38ad$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $5e4e89b461ad38ad$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $5e4e89b461ad38ad$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("c1pNW", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", function () { return $8c09983fbab2e587$export$a7ee192b982af9c1; }, function (v) { return $8c09983fbab2e587$export$a7ee192b982af9c1 = v; });
$parcel$export(module.exports, "numericPatterns", function () { return $8c09983fbab2e587$export$c123ee06d9da8480; }, function (v) { return $8c09983fbab2e587$export$c123ee06d9da8480 = v; });
var $8c09983fbab2e587$export$a7ee192b982af9c1;
var $8c09983fbab2e587$export$c123ee06d9da8480;
"use strict";
$8c09983fbab2e587$export$a7ee192b982af9c1 = $8c09983fbab2e587$export$c123ee06d9da8480 = void 0;
const $8c09983fbab2e587$var$numericPatterns = $8c09983fbab2e587$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $8c09983fbab2e587$var$timezonePatterns = $8c09983fbab2e587$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("4rXoy", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $33d7c1ac8bf5cc2f$export$b8ef38dfcf05d5db; }, function (v) { return $33d7c1ac8bf5cc2f$export$b8ef38dfcf05d5db = v; });
var $33d7c1ac8bf5cc2f$export$b8ef38dfcf05d5db;
"use strict";
$33d7c1ac8bf5cc2f$export$b8ef38dfcf05d5db = void 0;

var $jrEu3 = parcelRequire("jrEu3");

var $7bgap = parcelRequire("7bgap");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// Local week-numbering year
class $33d7c1ac8bf5cc2f$var$LocalWeekYearParser extends $4iw05.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $85Zyp.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $jrEu3.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $85Zyp.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $7bgap.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $7bgap.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$33d7c1ac8bf5cc2f$export$b8ef38dfcf05d5db = $33d7c1ac8bf5cc2f$var$LocalWeekYearParser;

});

parcelRegister("anzLo", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $78e7cb3e6a9ca940$export$951d1df011fde06f; }, function (v) { return $78e7cb3e6a9ca940$export$951d1df011fde06f = v; });
var $78e7cb3e6a9ca940$export$951d1df011fde06f;
"use strict";
$78e7cb3e6a9ca940$export$951d1df011fde06f = void 0;

var $kAYVg = parcelRequire("kAYVg");

var $2J98k = parcelRequire("2J98k");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// ISO week-numbering year
class $78e7cb3e6a9ca940$var$ISOWeekYearParser extends $4iw05.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $85Zyp.parseNDigitsSigned)(4, dateString);
        return (0, $85Zyp.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $2J98k.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $kAYVg.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$78e7cb3e6a9ca940$export$951d1df011fde06f = $78e7cb3e6a9ca940$var$ISOWeekYearParser;

});

parcelRegister("lou73", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $f933329d58bcd8a7$export$bad9d2ea38e8f1a; }, function (v) { return $f933329d58bcd8a7$export$bad9d2ea38e8f1a = v; });
var $f933329d58bcd8a7$export$bad9d2ea38e8f1a;
"use strict";
$f933329d58bcd8a7$export$bad9d2ea38e8f1a = void 0;

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $f933329d58bcd8a7$var$ExtendedYearParser extends $4iw05.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $85Zyp.parseNDigitsSigned)(4, dateString);
        return (0, $85Zyp.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f933329d58bcd8a7$export$bad9d2ea38e8f1a = $f933329d58bcd8a7$var$ExtendedYearParser;

});

parcelRegister("fhXPC", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $b216dadc8e72bdcb$export$5cb0f701186dde1d; }, function (v) { return $b216dadc8e72bdcb$export$5cb0f701186dde1d = v; });
var $b216dadc8e72bdcb$export$5cb0f701186dde1d;
"use strict";
$b216dadc8e72bdcb$export$5cb0f701186dde1d = void 0;

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $b216dadc8e72bdcb$var$QuarterParser extends $4iw05.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$b216dadc8e72bdcb$export$5cb0f701186dde1d = $b216dadc8e72bdcb$var$QuarterParser;

});

parcelRegister("gBgBX", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $c15cfcab68b5191e$export$300c0c2990e20e6d; }, function (v) { return $c15cfcab68b5191e$export$300c0c2990e20e6d = v; });
var $c15cfcab68b5191e$export$300c0c2990e20e6d;
"use strict";
$c15cfcab68b5191e$export$300c0c2990e20e6d = void 0;

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $c15cfcab68b5191e$var$StandAloneQuarterParser extends $4iw05.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$c15cfcab68b5191e$export$300c0c2990e20e6d = $c15cfcab68b5191e$var$StandAloneQuarterParser;

});

parcelRegister("etR7a", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $a8acf99000b04a9f$export$400dd8b40ef138a3; }, function (v) { return $a8acf99000b04a9f$export$400dd8b40ef138a3 = v; });
var $a8acf99000b04a9f$export$400dd8b40ef138a3;
"use strict";
$a8acf99000b04a9f$export$400dd8b40ef138a3 = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $a8acf99000b04a9f$var$MonthParser extends $4iw05.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $85Zyp.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$a8acf99000b04a9f$export$400dd8b40ef138a3 = $a8acf99000b04a9f$var$MonthParser;

});

parcelRegister("OgFIi", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $09719a4c627f1a43$export$1d7eaa53eaa5deba; }, function (v) { return $09719a4c627f1a43$export$1d7eaa53eaa5deba = v; });
var $09719a4c627f1a43$export$1d7eaa53eaa5deba;
"use strict";
$09719a4c627f1a43$export$1d7eaa53eaa5deba = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $09719a4c627f1a43$var$StandAloneMonthParser extends $4iw05.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $85Zyp.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$09719a4c627f1a43$export$1d7eaa53eaa5deba = $09719a4c627f1a43$var$StandAloneMonthParser;

});

parcelRegister("hFBiM", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $cdd3335d6d54aa9a$export$c4005ffc174e07c0; }, function (v) { return $cdd3335d6d54aa9a$export$c4005ffc174e07c0 = v; });
var $cdd3335d6d54aa9a$export$c4005ffc174e07c0;
"use strict";
$cdd3335d6d54aa9a$export$c4005ffc174e07c0 = void 0;

var $ihiFp = parcelRequire("ihiFp");

var $7bgap = parcelRequire("7bgap");

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// Local week of year
class $cdd3335d6d54aa9a$var$LocalWeekParser extends $4iw05.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $7bgap.startOfWeek)((0, $ihiFp.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$cdd3335d6d54aa9a$export$c4005ffc174e07c0 = $cdd3335d6d54aa9a$var$LocalWeekParser;

});
parcelRegister("ihiFp", function(module, exports) {

$parcel$export(module.exports, "setWeek", function () { return $d4e84b6611ef040c$export$4b3066ce4afafd88; }, function (v) { return $d4e84b6611ef040c$export$4b3066ce4afafd88 = v; });
var $d4e84b6611ef040c$export$4b3066ce4afafd88;
"use strict";
$d4e84b6611ef040c$export$4b3066ce4afafd88 = $d4e84b6611ef040c$var$setWeek;

var $eOJHF = parcelRequire("eOJHF");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $d4e84b6611ef040c$var$setWeek(date, week, options) {
    const _date = (0, $2ZADR.toDate)(date);
    const diff = (0, $eOJHF.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("40w2A", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $2eb0041b1d67de6c$export$6fc8dbedd560a6af; }, function (v) { return $2eb0041b1d67de6c$export$6fc8dbedd560a6af = v; });
var $2eb0041b1d67de6c$export$6fc8dbedd560a6af;
"use strict";
$2eb0041b1d67de6c$export$6fc8dbedd560a6af = void 0;

var $5LLIW = parcelRequire("5LLIW");

var $kAYVg = parcelRequire("kAYVg");

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// ISO week of year
class $2eb0041b1d67de6c$var$ISOWeekParser extends $4iw05.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $kAYVg.startOfISOWeek)((0, $5LLIW.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$2eb0041b1d67de6c$export$6fc8dbedd560a6af = $2eb0041b1d67de6c$var$ISOWeekParser;

});
parcelRegister("5LLIW", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", function () { return $43365c7c3079baeb$export$6542bebf6be94082; }, function (v) { return $43365c7c3079baeb$export$6542bebf6be94082 = v; });
var $43365c7c3079baeb$export$6542bebf6be94082;
"use strict";
$43365c7c3079baeb$export$6542bebf6be94082 = $43365c7c3079baeb$var$setISOWeek;

var $WJVCU = parcelRequire("WJVCU");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $43365c7c3079baeb$var$setISOWeek(date, week) {
    const _date = (0, $2ZADR.toDate)(date);
    const diff = (0, $WJVCU.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("j9TgZ", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $df29bbac3a06c3cf$export$e8d4b28a20981dd2; }, function (v) { return $df29bbac3a06c3cf$export$e8d4b28a20981dd2 = v; });
var $df29bbac3a06c3cf$export$e8d4b28a20981dd2;
"use strict";
$df29bbac3a06c3cf$export$e8d4b28a20981dd2 = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
const $df29bbac3a06c3cf$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $df29bbac3a06c3cf$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $df29bbac3a06c3cf$var$DateParser extends $4iw05.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $85Zyp.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $df29bbac3a06c3cf$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $df29bbac3a06c3cf$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$df29bbac3a06c3cf$export$e8d4b28a20981dd2 = $df29bbac3a06c3cf$var$DateParser;

});

parcelRegister("53raH", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $3ae24f45e8fe96fb$export$6cfe0d613455f615; }, function (v) { return $3ae24f45e8fe96fb$export$6cfe0d613455f615 = v; });
var $3ae24f45e8fe96fb$export$6cfe0d613455f615;
"use strict";
$3ae24f45e8fe96fb$export$6cfe0d613455f615 = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $3ae24f45e8fe96fb$var$DayOfYearParser extends $4iw05.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $85Zyp.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$3ae24f45e8fe96fb$export$6cfe0d613455f615 = $3ae24f45e8fe96fb$var$DayOfYearParser;

});

parcelRegister("dwp94", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $9d81c4d455a7e9f3$export$1b03c8b76262f7bd; }, function (v) { return $9d81c4d455a7e9f3$export$1b03c8b76262f7bd = v; });
var $9d81c4d455a7e9f3$export$1b03c8b76262f7bd;
"use strict";
$9d81c4d455a7e9f3$export$1b03c8b76262f7bd = void 0;

var $lBTco = parcelRequire("lBTco");

var $4iw05 = parcelRequire("4iw05");
// Day of week
class $9d81c4d455a7e9f3$var$DayParser extends $4iw05.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $lBTco.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$9d81c4d455a7e9f3$export$1b03c8b76262f7bd = $9d81c4d455a7e9f3$var$DayParser;

});
parcelRegister("lBTco", function(module, exports) {

$parcel$export(module.exports, "setDay", function () { return $fbb7df020fe41607$export$b04fdcda82decc6c; }, function (v) { return $fbb7df020fe41607$export$b04fdcda82decc6c = v; });
var $fbb7df020fe41607$export$b04fdcda82decc6c;
"use strict";
$fbb7df020fe41607$export$b04fdcda82decc6c = $fbb7df020fe41607$var$setDay;

var $7hUpB = parcelRequire("7hUpB");

var $2ZADR = parcelRequire("2ZADR");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $fbb7df020fe41607$var$setDay(date, day, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $2ZADR.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $7hUpB.addDays)(_date, diff);
}

});


parcelRegister("hC05v", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $cd260db3054e7c69$export$44d1c127ab42c480; }, function (v) { return $cd260db3054e7c69$export$44d1c127ab42c480 = v; });
var $cd260db3054e7c69$export$44d1c127ab42c480;
"use strict";
$cd260db3054e7c69$export$44d1c127ab42c480 = void 0;

var $lBTco = parcelRequire("lBTco");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// Local day of week
class $cd260db3054e7c69$var$LocalDayParser extends $4iw05.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $85Zyp.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $lBTco.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$cd260db3054e7c69$export$44d1c127ab42c480 = $cd260db3054e7c69$var$LocalDayParser;

});

parcelRegister("1Yk4E", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $16faf754878d2180$export$e447a647caaaec1d; }, function (v) { return $16faf754878d2180$export$e447a647caaaec1d = v; });
var $16faf754878d2180$export$e447a647caaaec1d;
"use strict";
$16faf754878d2180$export$e447a647caaaec1d = void 0;

var $lBTco = parcelRequire("lBTco");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// Stand-alone local day of week
class $16faf754878d2180$var$StandAloneLocalDayParser extends $4iw05.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $85Zyp.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $lBTco.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$16faf754878d2180$export$e447a647caaaec1d = $16faf754878d2180$var$StandAloneLocalDayParser;

});

parcelRegister("mlhKn", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $043290fe9dfe3ea9$export$693fb1e525095b2a; }, function (v) { return $043290fe9dfe3ea9$export$693fb1e525095b2a = v; });
var $043290fe9dfe3ea9$export$693fb1e525095b2a;
"use strict";
$043290fe9dfe3ea9$export$693fb1e525095b2a = void 0;

var $kIsnz = parcelRequire("kIsnz");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// ISO day of week
class $043290fe9dfe3ea9$var$ISODayParser extends $4iw05.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $85Zyp.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $85Zyp.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $85Zyp.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $85Zyp.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $kIsnz.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$043290fe9dfe3ea9$export$693fb1e525095b2a = $043290fe9dfe3ea9$var$ISODayParser;

});
parcelRegister("kIsnz", function(module, exports) {

$parcel$export(module.exports, "setISODay", function () { return $f14dee3aa589a6d2$export$1fd9df65adb0d1aa; }, function (v) { return $f14dee3aa589a6d2$export$1fd9df65adb0d1aa = v; });
var $f14dee3aa589a6d2$export$1fd9df65adb0d1aa;
"use strict";
$f14dee3aa589a6d2$export$1fd9df65adb0d1aa = $f14dee3aa589a6d2$var$setISODay;

var $7hUpB = parcelRequire("7hUpB");

var $fF239 = parcelRequire("fF239");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $f14dee3aa589a6d2$var$setISODay(date, day) {
    const _date = (0, $2ZADR.toDate)(date);
    const currentDay = (0, $fF239.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $7hUpB.addDays)(_date, diff);
}

});


parcelRegister("ifpFW", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $d48d8b57ae3b2d63$export$8d1e08492351df91; }, function (v) { return $d48d8b57ae3b2d63$export$8d1e08492351df91 = v; });
var $d48d8b57ae3b2d63$export$8d1e08492351df91;
"use strict";
$d48d8b57ae3b2d63$export$8d1e08492351df91 = void 0;

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $d48d8b57ae3b2d63$var$AMPMParser extends $4iw05.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $85Zyp.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$d48d8b57ae3b2d63$export$8d1e08492351df91 = $d48d8b57ae3b2d63$var$AMPMParser;

});

parcelRegister("hSXar", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $d055603ba4bbcc50$export$73ca2bd0a17d273; }, function (v) { return $d055603ba4bbcc50$export$73ca2bd0a17d273 = v; });
var $d055603ba4bbcc50$export$73ca2bd0a17d273;
"use strict";
$d055603ba4bbcc50$export$73ca2bd0a17d273 = void 0;

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $d055603ba4bbcc50$var$AMPMMidnightParser extends $4iw05.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $85Zyp.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$d055603ba4bbcc50$export$73ca2bd0a17d273 = $d055603ba4bbcc50$var$AMPMMidnightParser;

});

parcelRegister("76kVa", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $52b9526f9ec0e0ea$export$bb9212adf05373db; }, function (v) { return $52b9526f9ec0e0ea$export$bb9212adf05373db = v; });
var $52b9526f9ec0e0ea$export$bb9212adf05373db;
"use strict";
$52b9526f9ec0e0ea$export$bb9212adf05373db = void 0;

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// in the morning, in the afternoon, in the evening, at night
class $52b9526f9ec0e0ea$var$DayPeriodParser extends $4iw05.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $85Zyp.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$52b9526f9ec0e0ea$export$bb9212adf05373db = $52b9526f9ec0e0ea$var$DayPeriodParser;

});

parcelRegister("fuI4l", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $b47bd7889855b5f6$export$8a04050a727a1756; }, function (v) { return $b47bd7889855b5f6$export$8a04050a727a1756 = v; });
var $b47bd7889855b5f6$export$8a04050a727a1756;
"use strict";
$b47bd7889855b5f6$export$8a04050a727a1756 = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $b47bd7889855b5f6$var$Hour1to12Parser extends $4iw05.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$b47bd7889855b5f6$export$8a04050a727a1756 = $b47bd7889855b5f6$var$Hour1to12Parser;

});

parcelRegister("3HZSi", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $2b3562457e5e519c$export$e56f4dea2c3e56dd; }, function (v) { return $2b3562457e5e519c$export$e56f4dea2c3e56dd = v; });
var $2b3562457e5e519c$export$e56f4dea2c3e56dd;
"use strict";
$2b3562457e5e519c$export$e56f4dea2c3e56dd = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $2b3562457e5e519c$var$Hour0to23Parser extends $4iw05.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$2b3562457e5e519c$export$e56f4dea2c3e56dd = $2b3562457e5e519c$var$Hour0to23Parser;

});

parcelRegister("kaBqe", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $eaf1c5154bb52bae$export$cbbe855312f87d77; }, function (v) { return $eaf1c5154bb52bae$export$cbbe855312f87d77 = v; });
var $eaf1c5154bb52bae$export$cbbe855312f87d77;
"use strict";
$eaf1c5154bb52bae$export$cbbe855312f87d77 = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $eaf1c5154bb52bae$var$Hour0To11Parser extends $4iw05.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$eaf1c5154bb52bae$export$cbbe855312f87d77 = $eaf1c5154bb52bae$var$Hour0To11Parser;

});

parcelRegister("cBm0i", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $92ca02341b9fc038$export$6008046d2b34b6a5; }, function (v) { return $92ca02341b9fc038$export$6008046d2b34b6a5 = v; });
var $92ca02341b9fc038$export$6008046d2b34b6a5;
"use strict";
$92ca02341b9fc038$export$6008046d2b34b6a5 = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $92ca02341b9fc038$var$Hour1To24Parser extends $4iw05.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$92ca02341b9fc038$export$6008046d2b34b6a5 = $92ca02341b9fc038$var$Hour1To24Parser;

});

parcelRegister("5fU7E", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $3d39e33415d687dc$export$2b52670d9e2be53; }, function (v) { return $3d39e33415d687dc$export$2b52670d9e2be53 = v; });
var $3d39e33415d687dc$export$2b52670d9e2be53;
"use strict";
$3d39e33415d687dc$export$2b52670d9e2be53 = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $3d39e33415d687dc$var$MinuteParser extends $4iw05.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$3d39e33415d687dc$export$2b52670d9e2be53 = $3d39e33415d687dc$var$MinuteParser;

});

parcelRegister("7BP6i", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $58a3a0a1e057a4b4$export$94d46d540cf1366a; }, function (v) { return $58a3a0a1e057a4b4$export$94d46d540cf1366a = v; });
var $58a3a0a1e057a4b4$export$94d46d540cf1366a;
"use strict";
$58a3a0a1e057a4b4$export$94d46d540cf1366a = void 0;

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $58a3a0a1e057a4b4$var$SecondParser extends $4iw05.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $85Zyp.parseNumericPattern)($c1pNW.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $85Zyp.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$58a3a0a1e057a4b4$export$94d46d540cf1366a = $58a3a0a1e057a4b4$var$SecondParser;

});

parcelRegister("a7zA0", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $75e62835a682d40b$export$b8e6f8b2d70893b1; }, function (v) { return $75e62835a682d40b$export$b8e6f8b2d70893b1 = v; });
var $75e62835a682d40b$export$b8e6f8b2d70893b1;
"use strict";
$75e62835a682d40b$export$b8e6f8b2d70893b1 = void 0;

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $75e62835a682d40b$var$FractionOfSecondParser extends $4iw05.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $85Zyp.mapValue)((0, $85Zyp.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$75e62835a682d40b$export$b8e6f8b2d70893b1 = $75e62835a682d40b$var$FractionOfSecondParser;

});

parcelRegister("4eiCo", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $3146e96a3141dc77$export$104d901d49fea29b; }, function (v) { return $3146e96a3141dc77$export$104d901d49fea29b = v; });
var $3146e96a3141dc77$export$104d901d49fea29b;
"use strict";
$3146e96a3141dc77$export$104d901d49fea29b = void 0;

var $2J98k = parcelRequire("2J98k");

var $koDIg = parcelRequire("koDIg");

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $3146e96a3141dc77$var$ISOTimezoneWithZParser extends $4iw05.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $2J98k.constructFrom)(date, date.getTime() - (0, $koDIg.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$3146e96a3141dc77$export$104d901d49fea29b = $3146e96a3141dc77$var$ISOTimezoneWithZParser;

});

parcelRegister("gvwUL", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $c04912bb80e0464a$export$12910e5204b52b9; }, function (v) { return $c04912bb80e0464a$export$12910e5204b52b9 = v; });
var $c04912bb80e0464a$export$12910e5204b52b9;
"use strict";
$c04912bb80e0464a$export$12910e5204b52b9 = void 0;

var $2J98k = parcelRequire("2J98k");

var $koDIg = parcelRequire("koDIg");

var $c1pNW = parcelRequire("c1pNW");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
// Timezone (ISO-8601)
class $c04912bb80e0464a$var$ISOTimezoneParser extends $4iw05.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $85Zyp.parseTimezonePattern)($c1pNW.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $2J98k.constructFrom)(date, date.getTime() - (0, $koDIg.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$c04912bb80e0464a$export$12910e5204b52b9 = $c04912bb80e0464a$var$ISOTimezoneParser;

});

parcelRegister("5DvKE", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $41a9396bd2afc744$export$2cd8bf877a05e96; }, function (v) { return $41a9396bd2afc744$export$2cd8bf877a05e96 = v; });
var $41a9396bd2afc744$export$2cd8bf877a05e96;
"use strict";
$41a9396bd2afc744$export$2cd8bf877a05e96 = void 0;

var $2J98k = parcelRequire("2J98k");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $41a9396bd2afc744$var$TimestampSecondsParser extends $4iw05.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $85Zyp.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $2J98k.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$41a9396bd2afc744$export$2cd8bf877a05e96 = $41a9396bd2afc744$var$TimestampSecondsParser;

});

parcelRegister("3pjwU", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $27b2db1cdf9b8bac$export$6d8f69c6906d6368; }, function (v) { return $27b2db1cdf9b8bac$export$6d8f69c6906d6368 = v; });
var $27b2db1cdf9b8bac$export$6d8f69c6906d6368;
"use strict";
$27b2db1cdf9b8bac$export$6d8f69c6906d6368 = void 0;

var $2J98k = parcelRequire("2J98k");

var $4iw05 = parcelRequire("4iw05");

var $85Zyp = parcelRequire("85Zyp");
class $27b2db1cdf9b8bac$var$TimestampMillisecondsParser extends $4iw05.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $85Zyp.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $2J98k.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$27b2db1cdf9b8bac$export$6d8f69c6906d6368 = $27b2db1cdf9b8bac$var$TimestampMillisecondsParser;

});




parcelRegister("hD7uI", function(module, exports) {

$parcel$export(module.exports, "isMonday", function () { return $cd5be4669b70d7ff$export$9573fe9b7c9ac3f5; }, function (v) { return $cd5be4669b70d7ff$export$9573fe9b7c9ac3f5 = v; });
var $cd5be4669b70d7ff$export$9573fe9b7c9ac3f5;
"use strict";
$cd5be4669b70d7ff$export$9573fe9b7c9ac3f5 = $cd5be4669b70d7ff$var$isMonday;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $cd5be4669b70d7ff$var$isMonday(date) {
    return (0, $2ZADR.toDate)(date).getDay() === 1;
}

});

parcelRegister("g0OLy", function(module, exports) {

$parcel$export(module.exports, "isPast", function () { return $ba84067bee08ffaf$export$fc5014aa3db48558; }, function (v) { return $ba84067bee08ffaf$export$fc5014aa3db48558 = v; });
var $ba84067bee08ffaf$export$fc5014aa3db48558;
"use strict";
$ba84067bee08ffaf$export$fc5014aa3db48558 = $ba84067bee08ffaf$var$isPast;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $ba84067bee08ffaf$var$isPast(date) {
    return +(0, $2ZADR.toDate)(date) < Date.now();
}

});

parcelRegister("c8V0T", function(module, exports) {

$parcel$export(module.exports, "isSameHour", function () { return $8d7275162284e129$export$f9f3a94a0371013; }, function (v) { return $8d7275162284e129$export$f9f3a94a0371013 = v; });
var $8d7275162284e129$export$f9f3a94a0371013;
"use strict";
$8d7275162284e129$export$f9f3a94a0371013 = $8d7275162284e129$var$isSameHour;

var $dq7U3 = parcelRequire("dq7U3");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $8d7275162284e129$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $dq7U3.startOfHour)(dateLeft);
    const dateRightStartOfHour = (0, $dq7U3.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

});
parcelRegister("dq7U3", function(module, exports) {

$parcel$export(module.exports, "startOfHour", function () { return $9c53d57bdd7cb66f$export$24f91f68e7c9d9d5; }, function (v) { return $9c53d57bdd7cb66f$export$24f91f68e7c9d9d5 = v; });
var $9c53d57bdd7cb66f$export$24f91f68e7c9d9d5;
"use strict";
$9c53d57bdd7cb66f$export$24f91f68e7c9d9d5 = $9c53d57bdd7cb66f$var$startOfHour;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $9c53d57bdd7cb66f$var$startOfHour(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

});


parcelRegister("1bbhh", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeek", function () { return $0dbf910b3a680a4c$export$1c6e74e3c7b27764; }, function (v) { return $0dbf910b3a680a4c$export$1c6e74e3c7b27764 = v; });
var $0dbf910b3a680a4c$export$1c6e74e3c7b27764;
"use strict";
$0dbf910b3a680a4c$export$1c6e74e3c7b27764 = $0dbf910b3a680a4c$var$isSameISOWeek;

var $lPsfi = parcelRequire("lPsfi");
/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $0dbf910b3a680a4c$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $lPsfi.isSameWeek)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}

});
parcelRegister("lPsfi", function(module, exports) {

$parcel$export(module.exports, "isSameWeek", function () { return $fe444563ebbfe3b5$export$6ea683876c36b8d2; }, function (v) { return $fe444563ebbfe3b5$export$6ea683876c36b8d2 = v; });
var $fe444563ebbfe3b5$export$6ea683876c36b8d2;
"use strict";
$fe444563ebbfe3b5$export$6ea683876c36b8d2 = $fe444563ebbfe3b5$var$isSameWeek;

var $7bgap = parcelRequire("7bgap");
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $fe444563ebbfe3b5$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $7bgap.startOfWeek)(dateLeft, options);
    const dateRightStartOfWeek = (0, $7bgap.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

});


parcelRegister("5edZi", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeekYear", function () { return $3ce91c38670f6843$export$5f55dbf38a1aee81; }, function (v) { return $3ce91c38670f6843$export$5f55dbf38a1aee81 = v; });
var $3ce91c38670f6843$export$5f55dbf38a1aee81;
"use strict";
$3ce91c38670f6843$export$5f55dbf38a1aee81 = $3ce91c38670f6843$var$isSameISOWeekYear;

var $7cc1O = parcelRequire("7cc1O");
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $3ce91c38670f6843$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $7cc1O.startOfISOWeekYear)(dateLeft);
    const dateRightStartOfYear = (0, $7cc1O.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}

});

parcelRegister("bymJ7", function(module, exports) {

$parcel$export(module.exports, "isSameMinute", function () { return $86947fc0cb4db253$export$5d274bf63c8705cb; }, function (v) { return $86947fc0cb4db253$export$5d274bf63c8705cb = v; });
var $86947fc0cb4db253$export$5d274bf63c8705cb;
"use strict";
$86947fc0cb4db253$export$5d274bf63c8705cb = $86947fc0cb4db253$var$isSameMinute;

var $g9NYq = parcelRequire("g9NYq");
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $86947fc0cb4db253$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $g9NYq.startOfMinute)(dateLeft);
    const dateRightStartOfMinute = (0, $g9NYq.startOfMinute)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

});

parcelRegister("NKXNy", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", function () { return $095901b044bf5afe$export$a18c89cbd24170ff; }, function (v) { return $095901b044bf5afe$export$a18c89cbd24170ff = v; });
var $095901b044bf5afe$export$a18c89cbd24170ff;
"use strict";
$095901b044bf5afe$export$a18c89cbd24170ff = $095901b044bf5afe$var$isSameMonth;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $095901b044bf5afe$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRegister("476Jo", function(module, exports) {

$parcel$export(module.exports, "isSameQuarter", function () { return $2fed0988c7ce1d49$export$5c60e4190867161c; }, function (v) { return $2fed0988c7ce1d49$export$5c60e4190867161c = v; });
var $2fed0988c7ce1d49$export$5c60e4190867161c;
"use strict";
$2fed0988c7ce1d49$export$5c60e4190867161c = $2fed0988c7ce1d49$var$isSameQuarter;

var $cJLy9 = parcelRequire("cJLy9");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $2fed0988c7ce1d49$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $cJLy9.startOfQuarter)(dateLeft);
    const dateRightStartOfQuarter = (0, $cJLy9.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

});

parcelRegister("iDaHS", function(module, exports) {

$parcel$export(module.exports, "isSameSecond", function () { return $d9042ca37f54c38e$export$b88fbcfe038f3498; }, function (v) { return $d9042ca37f54c38e$export$b88fbcfe038f3498 = v; });
var $d9042ca37f54c38e$export$b88fbcfe038f3498;
"use strict";
$d9042ca37f54c38e$export$b88fbcfe038f3498 = $d9042ca37f54c38e$var$isSameSecond;

var $6uf6b = parcelRequire("6uf6b");
/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $d9042ca37f54c38e$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $6uf6b.startOfSecond)(dateLeft);
    const dateRightStartOfSecond = (0, $6uf6b.startOfSecond)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

});
parcelRegister("6uf6b", function(module, exports) {

$parcel$export(module.exports, "startOfSecond", function () { return $4b9141b1d9eae216$export$66c51f9715fdbff5; }, function (v) { return $4b9141b1d9eae216$export$66c51f9715fdbff5 = v; });
var $4b9141b1d9eae216$export$66c51f9715fdbff5;
"use strict";
$4b9141b1d9eae216$export$66c51f9715fdbff5 = $4b9141b1d9eae216$var$startOfSecond;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $4b9141b1d9eae216$var$startOfSecond(date) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}

});


parcelRegister("2dno9", function(module, exports) {

$parcel$export(module.exports, "isSameYear", function () { return $19cef02a9c788634$export$5841f9eb9773f25f; }, function (v) { return $19cef02a9c788634$export$5841f9eb9773f25f = v; });
var $19cef02a9c788634$export$5841f9eb9773f25f;
"use strict";
$19cef02a9c788634$export$5841f9eb9773f25f = $19cef02a9c788634$var$isSameYear;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $19cef02a9c788634$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $2ZADR.toDate)(dateLeft);
    const _dateRight = (0, $2ZADR.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRegister("iPTMn", function(module, exports) {

$parcel$export(module.exports, "isThisHour", function () { return $db68420643873b9c$export$5d41bdc7172839b9; }, function (v) { return $db68420643873b9c$export$5d41bdc7172839b9 = v; });
var $db68420643873b9c$export$5d41bdc7172839b9;
"use strict";
$db68420643873b9c$export$5d41bdc7172839b9 = $db68420643873b9c$var$isThisHour;

var $4w0cM = parcelRequire("4w0cM");

var $c8V0T = parcelRequire("c8V0T");
/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $db68420643873b9c$var$isThisHour(date) {
    return (0, $c8V0T.isSameHour)(date, (0, $4w0cM.constructNow)(date));
}

});

parcelRegister("YyN1t", function(module, exports) {

$parcel$export(module.exports, "isThisISOWeek", function () { return $0b609738303d9e9b$export$4e987896c721f753; }, function (v) { return $0b609738303d9e9b$export$4e987896c721f753 = v; });
var $0b609738303d9e9b$export$4e987896c721f753;
"use strict";
$0b609738303d9e9b$export$4e987896c721f753 = $0b609738303d9e9b$var$isThisISOWeek;

var $4w0cM = parcelRequire("4w0cM");

var $1bbhh = parcelRequire("1bbhh");
/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $0b609738303d9e9b$var$isThisISOWeek(date) {
    return (0, $1bbhh.isSameISOWeek)(date, (0, $4w0cM.constructNow)(date));
}

});

parcelRegister("2KVDZ", function(module, exports) {

$parcel$export(module.exports, "isThisMinute", function () { return $201c978bfed61101$export$fa55b7d29d8d957a; }, function (v) { return $201c978bfed61101$export$fa55b7d29d8d957a = v; });
var $201c978bfed61101$export$fa55b7d29d8d957a;
"use strict";
$201c978bfed61101$export$fa55b7d29d8d957a = $201c978bfed61101$var$isThisMinute;

var $4w0cM = parcelRequire("4w0cM");

var $bymJ7 = parcelRequire("bymJ7");
/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $201c978bfed61101$var$isThisMinute(date) {
    return (0, $bymJ7.isSameMinute)(date, (0, $4w0cM.constructNow)(date));
}

});

parcelRegister("3OW6D", function(module, exports) {

$parcel$export(module.exports, "isThisMonth", function () { return $2c831d46ea5173e7$export$173f1e1d92847276; }, function (v) { return $2c831d46ea5173e7$export$173f1e1d92847276 = v; });
var $2c831d46ea5173e7$export$173f1e1d92847276;
"use strict";
$2c831d46ea5173e7$export$173f1e1d92847276 = $2c831d46ea5173e7$var$isThisMonth;

var $4w0cM = parcelRequire("4w0cM");

var $NKXNy = parcelRequire("NKXNy");
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $2c831d46ea5173e7$var$isThisMonth(date) {
    return (0, $NKXNy.isSameMonth)(date, (0, $4w0cM.constructNow)(date));
}

});

parcelRegister("6T9rM", function(module, exports) {

$parcel$export(module.exports, "isThisQuarter", function () { return $503f351f6bddf3e1$export$3d88fd18ab599ccc; }, function (v) { return $503f351f6bddf3e1$export$3d88fd18ab599ccc = v; });
var $503f351f6bddf3e1$export$3d88fd18ab599ccc;
"use strict";
$503f351f6bddf3e1$export$3d88fd18ab599ccc = $503f351f6bddf3e1$var$isThisQuarter;

var $4w0cM = parcelRequire("4w0cM");

var $476Jo = parcelRequire("476Jo");
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $503f351f6bddf3e1$var$isThisQuarter(date) {
    return (0, $476Jo.isSameQuarter)(date, (0, $4w0cM.constructNow)(date));
}

});

parcelRegister("di1ga", function(module, exports) {

$parcel$export(module.exports, "isThisSecond", function () { return $9acdeefb8e70a534$export$8d7059b5bca087e6; }, function (v) { return $9acdeefb8e70a534$export$8d7059b5bca087e6 = v; });
var $9acdeefb8e70a534$export$8d7059b5bca087e6;
"use strict";
$9acdeefb8e70a534$export$8d7059b5bca087e6 = $9acdeefb8e70a534$var$isThisSecond;

var $4w0cM = parcelRequire("4w0cM");

var $iDaHS = parcelRequire("iDaHS");
/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $9acdeefb8e70a534$var$isThisSecond(date) {
    return (0, $iDaHS.isSameSecond)(date, (0, $4w0cM.constructNow)(date));
}

});

parcelRegister("3iEpi", function(module, exports) {

$parcel$export(module.exports, "isThisWeek", function () { return $2672658985c10b1d$export$cfe4b66a69cdd8a; }, function (v) { return $2672658985c10b1d$export$cfe4b66a69cdd8a = v; });
var $2672658985c10b1d$export$cfe4b66a69cdd8a;
"use strict";
$2672658985c10b1d$export$cfe4b66a69cdd8a = $2672658985c10b1d$var$isThisWeek;

var $4w0cM = parcelRequire("4w0cM");

var $lPsfi = parcelRequire("lPsfi");
/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $2672658985c10b1d$var$isThisWeek(date, options) {
    return (0, $lPsfi.isSameWeek)(date, (0, $4w0cM.constructNow)(date), options);
}

});

parcelRegister("ktaGp", function(module, exports) {

$parcel$export(module.exports, "isThisYear", function () { return $ee6ecd816210227b$export$a28c94941893a5ac; }, function (v) { return $ee6ecd816210227b$export$a28c94941893a5ac = v; });
var $ee6ecd816210227b$export$a28c94941893a5ac;
"use strict";
$ee6ecd816210227b$export$a28c94941893a5ac = $ee6ecd816210227b$var$isThisYear;

var $4w0cM = parcelRequire("4w0cM");

var $2dno9 = parcelRequire("2dno9");
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $ee6ecd816210227b$var$isThisYear(date) {
    return (0, $2dno9.isSameYear)(date, (0, $4w0cM.constructNow)(date));
}

});

parcelRegister("fZFQo", function(module, exports) {

$parcel$export(module.exports, "isThursday", function () { return $ba4d02de9844c855$export$c8e7c906983ea347; }, function (v) { return $ba4d02de9844c855$export$c8e7c906983ea347 = v; });
var $ba4d02de9844c855$export$c8e7c906983ea347;
"use strict";
$ba4d02de9844c855$export$c8e7c906983ea347 = $ba4d02de9844c855$var$isThursday;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $ba4d02de9844c855$var$isThursday(date) {
    return (0, $2ZADR.toDate)(date).getDay() === 4;
}

});

parcelRegister("kQY2r", function(module, exports) {

$parcel$export(module.exports, "isToday", function () { return $f2e73c5e7c73e367$export$629b0a497aa65267; }, function (v) { return $f2e73c5e7c73e367$export$629b0a497aa65267 = v; });
var $f2e73c5e7c73e367$export$629b0a497aa65267;
"use strict";
$f2e73c5e7c73e367$export$629b0a497aa65267 = $f2e73c5e7c73e367$var$isToday;

var $4w0cM = parcelRequire("4w0cM");

var $io8gj = parcelRequire("io8gj");
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $f2e73c5e7c73e367$var$isToday(date) {
    return (0, $io8gj.isSameDay)(date, (0, $4w0cM.constructNow)(date));
}

});

parcelRegister("lx1jR", function(module, exports) {

$parcel$export(module.exports, "isTomorrow", function () { return $facdb40a458063f0$export$d6365ba92f0647f1; }, function (v) { return $facdb40a458063f0$export$d6365ba92f0647f1 = v; });
var $facdb40a458063f0$export$d6365ba92f0647f1;
"use strict";
$facdb40a458063f0$export$d6365ba92f0647f1 = $facdb40a458063f0$var$isTomorrow;

var $7hUpB = parcelRequire("7hUpB");

var $4w0cM = parcelRequire("4w0cM");

var $io8gj = parcelRequire("io8gj");
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $facdb40a458063f0$var$isTomorrow(date) {
    return (0, $io8gj.isSameDay)(date, (0, $7hUpB.addDays)((0, $4w0cM.constructNow)(date), 1));
}

});

parcelRegister("3vnA2", function(module, exports) {

$parcel$export(module.exports, "isTuesday", function () { return $28d68ee786e9d782$export$90d50b8f209f5ac3; }, function (v) { return $28d68ee786e9d782$export$90d50b8f209f5ac3 = v; });
var $28d68ee786e9d782$export$90d50b8f209f5ac3;
"use strict";
$28d68ee786e9d782$export$90d50b8f209f5ac3 = $28d68ee786e9d782$var$isTuesday;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $28d68ee786e9d782$var$isTuesday(date) {
    return (0, $2ZADR.toDate)(date).getDay() === 2;
}

});

parcelRegister("ciwJI", function(module, exports) {

$parcel$export(module.exports, "isWednesday", function () { return $8f408f36f69c1544$export$ec9de642cdd62944; }, function (v) { return $8f408f36f69c1544$export$ec9de642cdd62944 = v; });
var $8f408f36f69c1544$export$ec9de642cdd62944;
"use strict";
$8f408f36f69c1544$export$ec9de642cdd62944 = $8f408f36f69c1544$var$isWednesday;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $8f408f36f69c1544$var$isWednesday(date) {
    return (0, $2ZADR.toDate)(date).getDay() === 3;
}

});

parcelRegister("bTkgf", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", function () { return $8a848c363b4e247c$export$d7deef7a3738e19d; }, function (v) { return $8a848c363b4e247c$export$d7deef7a3738e19d = v; });
var $8a848c363b4e247c$export$d7deef7a3738e19d;
"use strict";
$8a848c363b4e247c$export$d7deef7a3738e19d = $8a848c363b4e247c$var$isWithinInterval;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $8a848c363b4e247c$var$isWithinInterval(date, interval) {
    const time = +(0, $2ZADR.toDate)(date);
    const [startTime, endTime] = [
        +(0, $2ZADR.toDate)(interval.start),
        +(0, $2ZADR.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRegister("hdwg1", function(module, exports) {

$parcel$export(module.exports, "isYesterday", function () { return $c88cac3466be65fb$export$221990270ebfe867; }, function (v) { return $c88cac3466be65fb$export$221990270ebfe867 = v; });
var $c88cac3466be65fb$export$221990270ebfe867;
"use strict";
$c88cac3466be65fb$export$221990270ebfe867 = $c88cac3466be65fb$var$isYesterday;

var $4w0cM = parcelRequire("4w0cM");

var $io8gj = parcelRequire("io8gj");

var $3Y7uu = parcelRequire("3Y7uu");
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $c88cac3466be65fb$var$isYesterday(date) {
    return (0, $io8gj.isSameDay)(date, (0, $3Y7uu.subDays)((0, $4w0cM.constructNow)(date), 1));
}

});
parcelRegister("3Y7uu", function(module, exports) {

$parcel$export(module.exports, "subDays", function () { return $2e3cc935ba33bc87$export$70823084e2deb1ea; }, function (v) { return $2e3cc935ba33bc87$export$70823084e2deb1ea = v; });
var $2e3cc935ba33bc87$export$70823084e2deb1ea;
"use strict";
$2e3cc935ba33bc87$export$70823084e2deb1ea = $2e3cc935ba33bc87$var$subDays;

var $7hUpB = parcelRequire("7hUpB");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $2e3cc935ba33bc87$var$subDays(date, amount) {
    return (0, $7hUpB.addDays)(date, -amount);
}

});


parcelRegister("cm2SN", function(module, exports) {

$parcel$export(module.exports, "lastDayOfDecade", function () { return $8fe9c68d3431e272$export$2aaf6241f57dd605; }, function (v) { return $8fe9c68d3431e272$export$2aaf6241f57dd605 = v; });
var $8fe9c68d3431e272$export$2aaf6241f57dd605;
"use strict";
$8fe9c68d3431e272$export$2aaf6241f57dd605 = $8fe9c68d3431e272$var$lastDayOfDecade;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $8fe9c68d3431e272$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("lo7Ds", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeek", function () { return $f921c3199a4284f1$export$b08a8fc26ae6d94b; }, function (v) { return $f921c3199a4284f1$export$b08a8fc26ae6d94b = v; });
var $f921c3199a4284f1$export$b08a8fc26ae6d94b;
"use strict";
$f921c3199a4284f1$export$b08a8fc26ae6d94b = $f921c3199a4284f1$var$lastDayOfISOWeek;

var $aKdYW = parcelRequire("aKdYW");
/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $f921c3199a4284f1$var$lastDayOfISOWeek(date) {
    return (0, $aKdYW.lastDayOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("aKdYW", function(module, exports) {

$parcel$export(module.exports, "lastDayOfWeek", function () { return $7d290bc5c82fce98$export$b73502c35a293b0a; }, function (v) { return $7d290bc5c82fce98$export$b73502c35a293b0a = v; });
var $7d290bc5c82fce98$export$b73502c35a293b0a;
"use strict";
$7d290bc5c82fce98$export$b73502c35a293b0a = $7d290bc5c82fce98$var$lastDayOfWeek;

var $2ZADR = parcelRequire("2ZADR");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $7d290bc5c82fce98$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $2ZADR.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("fYJkS", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeekYear", function () { return $ba1fa05c99dc8e3d$export$1810bada8cd02ee1; }, function (v) { return $ba1fa05c99dc8e3d$export$1810bada8cd02ee1 = v; });
var $ba1fa05c99dc8e3d$export$1810bada8cd02ee1;
"use strict";
$ba1fa05c99dc8e3d$export$1810bada8cd02ee1 = $ba1fa05c99dc8e3d$var$lastDayOfISOWeekYear;

var $kf69a = parcelRequire("kf69a");

var $kAYVg = parcelRequire("kAYVg");

var $2J98k = parcelRequire("2J98k");
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $ba1fa05c99dc8e3d$var$lastDayOfISOWeekYear(date) {
    const year = (0, $kf69a.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $2J98k.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $kAYVg.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}

});

parcelRegister("1Lgka", function(module, exports) {

$parcel$export(module.exports, "lastDayOfQuarter", function () { return $1486d7eaae4a9972$export$8693c04228304c7; }, function (v) { return $1486d7eaae4a9972$export$8693c04228304c7 = v; });
var $1486d7eaae4a9972$export$8693c04228304c7;
"use strict";
$1486d7eaae4a9972$export$8693c04228304c7 = $1486d7eaae4a9972$var$lastDayOfQuarter;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $1486d7eaae4a9972$var$lastDayOfQuarter(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("iTWqO", function(module, exports) {

$parcel$export(module.exports, "lastDayOfYear", function () { return $dc2ab04b59ae05a6$export$323f7bc07b828bed; }, function (v) { return $dc2ab04b59ae05a6$export$323f7bc07b828bed = v; });
var $dc2ab04b59ae05a6$export$323f7bc07b828bed;
"use strict";
$dc2ab04b59ae05a6$export$323f7bc07b828bed = $dc2ab04b59ae05a6$var$lastDayOfYear;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $dc2ab04b59ae05a6$var$lastDayOfYear(date) {
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("icrY8", function(module, exports) {
"use strict";
module.exports.lightFormat = $d3ff0b0534a16494$var$lightFormat;
Object.defineProperty(module.exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $g2z8V.lightFormatters;
    }
});

var $8SDsI = parcelRequire("8SDsI");

var $2ZADR = parcelRequire("2ZADR");

var $g2z8V = parcelRequire("g2z8V");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $d3ff0b0534a16494$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $d3ff0b0534a16494$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $d3ff0b0534a16494$var$doubleQuoteRegExp = /''/g;
const $d3ff0b0534a16494$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $d3ff0b0534a16494$var$lightFormat(date, formatStr) {
    const _date = (0, $2ZADR.toDate)(date);
    if (!(0, $8SDsI.isValid)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($d3ff0b0534a16494$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $d3ff0b0534a16494$var$cleanEscapedString(substring);
        const formatter = $g2z8V.lightFormatters[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($d3ff0b0534a16494$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $d3ff0b0534a16494$var$cleanEscapedString(input) {
    const matches = input.match($d3ff0b0534a16494$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($d3ff0b0534a16494$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("fw6tY", function(module, exports) {

$parcel$export(module.exports, "milliseconds", function () { return $b4bedf6f344ad7d3$export$9a27fac83d67afd3; }, function (v) { return $b4bedf6f344ad7d3$export$9a27fac83d67afd3 = v; });
var $b4bedf6f344ad7d3$export$9a27fac83d67afd3;
"use strict";
$b4bedf6f344ad7d3$export$9a27fac83d67afd3 = $b4bedf6f344ad7d3$var$milliseconds;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $b4bedf6f344ad7d3$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $jpzPN.daysInYear;
    if (months) totalDays += months * ($jpzPN.daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}

});

parcelRegister("kb76g", function(module, exports) {

$parcel$export(module.exports, "millisecondsToHours", function () { return $eb0a57a3d9264a6e$export$689a412b29fa9ed5; }, function (v) { return $eb0a57a3d9264a6e$export$689a412b29fa9ed5 = v; });
var $eb0a57a3d9264a6e$export$689a412b29fa9ed5;
"use strict";
$eb0a57a3d9264a6e$export$689a412b29fa9ed5 = $eb0a57a3d9264a6e$var$millisecondsToHours;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $eb0a57a3d9264a6e$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $jpzPN.millisecondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("44UCa", function(module, exports) {

$parcel$export(module.exports, "millisecondsToMinutes", function () { return $2f83739c2e90febe$export$a5f974e81e48cfc0; }, function (v) { return $2f83739c2e90febe$export$a5f974e81e48cfc0 = v; });
var $2f83739c2e90febe$export$a5f974e81e48cfc0;
"use strict";
$2f83739c2e90febe$export$a5f974e81e48cfc0 = $2f83739c2e90febe$var$millisecondsToMinutes;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $2f83739c2e90febe$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $jpzPN.millisecondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("kkRuc", function(module, exports) {

$parcel$export(module.exports, "millisecondsToSeconds", function () { return $ecdf2a233bbc4da2$export$f64c3bfbc58eec0f; }, function (v) { return $ecdf2a233bbc4da2$export$f64c3bfbc58eec0f = v; });
var $ecdf2a233bbc4da2$export$f64c3bfbc58eec0f;
"use strict";
$ecdf2a233bbc4da2$export$f64c3bfbc58eec0f = $ecdf2a233bbc4da2$var$millisecondsToSeconds;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $ecdf2a233bbc4da2$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $jpzPN.millisecondsInSecond;
    return Math.trunc(seconds);
}

});

parcelRegister("lRpRz", function(module, exports) {

$parcel$export(module.exports, "minutesToHours", function () { return $fea29c11e12b466e$export$815164eb42530ae7; }, function (v) { return $fea29c11e12b466e$export$815164eb42530ae7 = v; });
var $fea29c11e12b466e$export$815164eb42530ae7;
"use strict";
$fea29c11e12b466e$export$815164eb42530ae7 = $fea29c11e12b466e$var$minutesToHours;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $fea29c11e12b466e$var$minutesToHours(minutes) {
    const hours = minutes / $jpzPN.minutesInHour;
    return Math.trunc(hours);
}

});

parcelRegister("fm3oy", function(module, exports) {

$parcel$export(module.exports, "minutesToMilliseconds", function () { return $b2db8b47660ec76e$export$f6b9795ef9056e3d; }, function (v) { return $b2db8b47660ec76e$export$f6b9795ef9056e3d = v; });
var $b2db8b47660ec76e$export$f6b9795ef9056e3d;
"use strict";
$b2db8b47660ec76e$export$f6b9795ef9056e3d = $b2db8b47660ec76e$var$minutesToMilliseconds;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $b2db8b47660ec76e$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $jpzPN.millisecondsInMinute);
}

});

parcelRegister("i2ARk", function(module, exports) {

$parcel$export(module.exports, "minutesToSeconds", function () { return $d2250160bb9bf73e$export$81ded4628c655103; }, function (v) { return $d2250160bb9bf73e$export$81ded4628c655103 = v; });
var $d2250160bb9bf73e$export$81ded4628c655103;
"use strict";
$d2250160bb9bf73e$export$81ded4628c655103 = $d2250160bb9bf73e$var$minutesToSeconds;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $d2250160bb9bf73e$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $jpzPN.secondsInMinute);
}

});

parcelRegister("8ZAW1", function(module, exports) {

$parcel$export(module.exports, "monthsToQuarters", function () { return $68c0abb376169211$export$1932fa2a2068c849; }, function (v) { return $68c0abb376169211$export$1932fa2a2068c849 = v; });
var $68c0abb376169211$export$1932fa2a2068c849;
"use strict";
$68c0abb376169211$export$1932fa2a2068c849 = $68c0abb376169211$var$monthsToQuarters;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $68c0abb376169211$var$monthsToQuarters(months) {
    const quarters = months / $jpzPN.monthsInQuarter;
    return Math.trunc(quarters);
}

});

parcelRegister("bWXQK", function(module, exports) {

$parcel$export(module.exports, "monthsToYears", function () { return $8b338969ddd07b63$export$7489026ed27fc925; }, function (v) { return $8b338969ddd07b63$export$7489026ed27fc925 = v; });
var $8b338969ddd07b63$export$7489026ed27fc925;
"use strict";
$8b338969ddd07b63$export$7489026ed27fc925 = $8b338969ddd07b63$var$monthsToYears;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $8b338969ddd07b63$var$monthsToYears(months) {
    const years = months / $jpzPN.monthsInYear;
    return Math.trunc(years);
}

});

parcelRegister("dGzVe", function(module, exports) {

$parcel$export(module.exports, "nextDay", function () { return $9f6b0ffbff6ed020$export$992728922317ffc8; }, function (v) { return $9f6b0ffbff6ed020$export$992728922317ffc8 = v; });
var $9f6b0ffbff6ed020$export$992728922317ffc8;
"use strict";
$9f6b0ffbff6ed020$export$992728922317ffc8 = $9f6b0ffbff6ed020$var$nextDay;

var $7hUpB = parcelRequire("7hUpB");

var $25jJv = parcelRequire("25jJv");
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $9f6b0ffbff6ed020$var$nextDay(date, day) {
    let delta = day - (0, $25jJv.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, $7hUpB.addDays)(date, delta);
}

});

parcelRegister("82Mzr", function(module, exports) {

$parcel$export(module.exports, "nextFriday", function () { return $5db42fbba093ea84$export$21d76934fce76327; }, function (v) { return $5db42fbba093ea84$export$21d76934fce76327 = v; });
var $5db42fbba093ea84$export$21d76934fce76327;
"use strict";
$5db42fbba093ea84$export$21d76934fce76327 = $5db42fbba093ea84$var$nextFriday;

var $dGzVe = parcelRequire("dGzVe");
/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $5db42fbba093ea84$var$nextFriday(date) {
    return (0, $dGzVe.nextDay)(date, 5);
}

});

parcelRegister("ce9pM", function(module, exports) {

$parcel$export(module.exports, "nextMonday", function () { return $8e6e18695bba8919$export$a20373bb0df6efdd; }, function (v) { return $8e6e18695bba8919$export$a20373bb0df6efdd = v; });
var $8e6e18695bba8919$export$a20373bb0df6efdd;
"use strict";
$8e6e18695bba8919$export$a20373bb0df6efdd = $8e6e18695bba8919$var$nextMonday;

var $dGzVe = parcelRequire("dGzVe");
/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $8e6e18695bba8919$var$nextMonday(date) {
    return (0, $dGzVe.nextDay)(date, 1);
}

});

parcelRegister("2vbsV", function(module, exports) {

$parcel$export(module.exports, "nextSaturday", function () { return $1d275ed7023bf365$export$c52f069246f7b032; }, function (v) { return $1d275ed7023bf365$export$c52f069246f7b032 = v; });
var $1d275ed7023bf365$export$c52f069246f7b032;
"use strict";
$1d275ed7023bf365$export$c52f069246f7b032 = $1d275ed7023bf365$var$nextSaturday;

var $dGzVe = parcelRequire("dGzVe");
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $1d275ed7023bf365$var$nextSaturday(date) {
    return (0, $dGzVe.nextDay)(date, 6);
}

});

parcelRegister("ccKuz", function(module, exports) {

$parcel$export(module.exports, "nextSunday", function () { return $8e2aab5ec1eaf6ab$export$a30adaa3ef47f854; }, function (v) { return $8e2aab5ec1eaf6ab$export$a30adaa3ef47f854 = v; });
var $8e2aab5ec1eaf6ab$export$a30adaa3ef47f854;
"use strict";
$8e2aab5ec1eaf6ab$export$a30adaa3ef47f854 = $8e2aab5ec1eaf6ab$var$nextSunday;

var $dGzVe = parcelRequire("dGzVe");
/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $8e2aab5ec1eaf6ab$var$nextSunday(date) {
    return (0, $dGzVe.nextDay)(date, 0);
}

});

parcelRegister("7Ijc4", function(module, exports) {

$parcel$export(module.exports, "nextThursday", function () { return $59db87f30611cd3b$export$36d9a8523a98d5a4; }, function (v) { return $59db87f30611cd3b$export$36d9a8523a98d5a4 = v; });
var $59db87f30611cd3b$export$36d9a8523a98d5a4;
"use strict";
$59db87f30611cd3b$export$36d9a8523a98d5a4 = $59db87f30611cd3b$var$nextThursday;

var $dGzVe = parcelRequire("dGzVe");
/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $59db87f30611cd3b$var$nextThursday(date) {
    return (0, $dGzVe.nextDay)(date, 4);
}

});

parcelRegister("ftY8S", function(module, exports) {

$parcel$export(module.exports, "nextTuesday", function () { return $b458376e92864471$export$391d63ff7dc2f668; }, function (v) { return $b458376e92864471$export$391d63ff7dc2f668 = v; });
var $b458376e92864471$export$391d63ff7dc2f668;
"use strict";
$b458376e92864471$export$391d63ff7dc2f668 = $b458376e92864471$var$nextTuesday;

var $dGzVe = parcelRequire("dGzVe");
/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $b458376e92864471$var$nextTuesday(date) {
    return (0, $dGzVe.nextDay)(date, 2);
}

});

parcelRegister("5aL95", function(module, exports) {

$parcel$export(module.exports, "nextWednesday", function () { return $3c42750d7b19e1ed$export$7a895c1ff204304e; }, function (v) { return $3c42750d7b19e1ed$export$7a895c1ff204304e = v; });
var $3c42750d7b19e1ed$export$7a895c1ff204304e;
"use strict";
$3c42750d7b19e1ed$export$7a895c1ff204304e = $3c42750d7b19e1ed$var$nextWednesday;

var $dGzVe = parcelRequire("dGzVe");
/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $3c42750d7b19e1ed$var$nextWednesday(date) {
    return (0, $dGzVe.nextDay)(date, 3);
}

});

parcelRegister("8xpCJ", function(module, exports) {

$parcel$export(module.exports, "parseISO", function () { return $63754821744dff4b$export$4393d2ccbbedb219; }, function (v) { return $63754821744dff4b$export$4393d2ccbbedb219 = v; });
var $63754821744dff4b$export$4393d2ccbbedb219;
"use strict";
$63754821744dff4b$export$4393d2ccbbedb219 = $63754821744dff4b$var$parseISO;

var $jpzPN = parcelRequire("jpzPN");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $63754821744dff4b$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $63754821744dff4b$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $63754821744dff4b$var$parseYear(dateStrings.date, additionalDigits);
        date = $63754821744dff4b$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $63754821744dff4b$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $63754821744dff4b$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $63754821744dff4b$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $63754821744dff4b$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $63754821744dff4b$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $63754821744dff4b$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $63754821744dff4b$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($63754821744dff4b$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($63754821744dff4b$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($63754821744dff4b$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $63754821744dff4b$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $63754821744dff4b$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $63754821744dff4b$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($63754821744dff4b$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $63754821744dff4b$var$parseDateUnit(captures[1]);
    const month = $63754821744dff4b$var$parseDateUnit(captures[2]) - 1;
    const day = $63754821744dff4b$var$parseDateUnit(captures[3]);
    const week = $63754821744dff4b$var$parseDateUnit(captures[4]);
    const dayOfWeek = $63754821744dff4b$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$63754821744dff4b$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $63754821744dff4b$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$63754821744dff4b$var$validateDate(year, month, day) || !$63754821744dff4b$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $63754821744dff4b$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $63754821744dff4b$var$parseTime(timeString) {
    const captures = timeString.match($63754821744dff4b$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $63754821744dff4b$var$parseTimeUnit(captures[1]);
    const minutes = $63754821744dff4b$var$parseTimeUnit(captures[2]);
    const seconds = $63754821744dff4b$var$parseTimeUnit(captures[3]);
    if (!$63754821744dff4b$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $jpzPN.millisecondsInHour + minutes * $jpzPN.millisecondsInMinute + seconds * 1000;
}
function $63754821744dff4b$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $63754821744dff4b$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($63754821744dff4b$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$63754821744dff4b$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $jpzPN.millisecondsInHour + minutes * $jpzPN.millisecondsInMinute);
}
function $63754821744dff4b$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $63754821744dff4b$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $63754821744dff4b$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $63754821744dff4b$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($63754821744dff4b$var$daysInMonths[month] || ($63754821744dff4b$var$isLeapYearIndex(year) ? 29 : 28));
}
function $63754821744dff4b$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($63754821744dff4b$var$isLeapYearIndex(year) ? 366 : 365);
}
function $63754821744dff4b$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $63754821744dff4b$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $63754821744dff4b$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("1LH4f", function(module, exports) {

$parcel$export(module.exports, "parseJSON", function () { return $149b968d9f205b32$export$27924e57e9afff7f; }, function (v) { return $149b968d9f205b32$export$27924e57e9afff7f = v; });
var $149b968d9f205b32$export$27924e57e9afff7f;
"use strict";
$149b968d9f205b32$export$27924e57e9afff7f = $149b968d9f205b32$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $149b968d9f205b32$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}

});

parcelRegister("dqWAw", function(module, exports) {

$parcel$export(module.exports, "previousDay", function () { return $9c7b26769cd65ff5$export$4caccb62df4eacc0; }, function (v) { return $9c7b26769cd65ff5$export$4caccb62df4eacc0 = v; });
var $9c7b26769cd65ff5$export$4caccb62df4eacc0;
"use strict";
$9c7b26769cd65ff5$export$4caccb62df4eacc0 = $9c7b26769cd65ff5$var$previousDay;

var $25jJv = parcelRequire("25jJv");

var $3Y7uu = parcelRequire("3Y7uu");
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $9c7b26769cd65ff5$var$previousDay(date, day) {
    let delta = (0, $25jJv.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $3Y7uu.subDays)(date, delta);
}

});

parcelRegister("dPXOU", function(module, exports) {

$parcel$export(module.exports, "previousFriday", function () { return $a12e70d18d4ff3a2$export$32d52646c338c11d; }, function (v) { return $a12e70d18d4ff3a2$export$32d52646c338c11d = v; });
var $a12e70d18d4ff3a2$export$32d52646c338c11d;
"use strict";
$a12e70d18d4ff3a2$export$32d52646c338c11d = $a12e70d18d4ff3a2$var$previousFriday;

var $dqWAw = parcelRequire("dqWAw");
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $a12e70d18d4ff3a2$var$previousFriday(date) {
    return (0, $dqWAw.previousDay)(date, 5);
}

});

parcelRegister("k92Um", function(module, exports) {

$parcel$export(module.exports, "previousMonday", function () { return $eaa6e767a08fd9f6$export$398437ab6f45c582; }, function (v) { return $eaa6e767a08fd9f6$export$398437ab6f45c582 = v; });
var $eaa6e767a08fd9f6$export$398437ab6f45c582;
"use strict";
$eaa6e767a08fd9f6$export$398437ab6f45c582 = $eaa6e767a08fd9f6$var$previousMonday;

var $dqWAw = parcelRequire("dqWAw");
/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $eaa6e767a08fd9f6$var$previousMonday(date) {
    return (0, $dqWAw.previousDay)(date, 1);
}

});

parcelRegister("6rfyX", function(module, exports) {

$parcel$export(module.exports, "previousSaturday", function () { return $4b015626c9054bc3$export$36767a7e6101ecb0; }, function (v) { return $4b015626c9054bc3$export$36767a7e6101ecb0 = v; });
var $4b015626c9054bc3$export$36767a7e6101ecb0;
"use strict";
$4b015626c9054bc3$export$36767a7e6101ecb0 = $4b015626c9054bc3$var$previousSaturday;

var $dqWAw = parcelRequire("dqWAw");
/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $4b015626c9054bc3$var$previousSaturday(date) {
    return (0, $dqWAw.previousDay)(date, 6);
}

});

parcelRegister("14wBS", function(module, exports) {

$parcel$export(module.exports, "previousSunday", function () { return $0c7f75d48a4010ac$export$7d3d7d8fc5e81fd4; }, function (v) { return $0c7f75d48a4010ac$export$7d3d7d8fc5e81fd4 = v; });
var $0c7f75d48a4010ac$export$7d3d7d8fc5e81fd4;
"use strict";
$0c7f75d48a4010ac$export$7d3d7d8fc5e81fd4 = $0c7f75d48a4010ac$var$previousSunday;

var $dqWAw = parcelRequire("dqWAw");
/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $0c7f75d48a4010ac$var$previousSunday(date) {
    return (0, $dqWAw.previousDay)(date, 0);
}

});

parcelRegister("7juLA", function(module, exports) {

$parcel$export(module.exports, "previousThursday", function () { return $55322c5d6e8034a5$export$1975b5b1f6b0e34e; }, function (v) { return $55322c5d6e8034a5$export$1975b5b1f6b0e34e = v; });
var $55322c5d6e8034a5$export$1975b5b1f6b0e34e;
"use strict";
$55322c5d6e8034a5$export$1975b5b1f6b0e34e = $55322c5d6e8034a5$var$previousThursday;

var $dqWAw = parcelRequire("dqWAw");
/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $55322c5d6e8034a5$var$previousThursday(date) {
    return (0, $dqWAw.previousDay)(date, 4);
}

});

parcelRegister("7eTIZ", function(module, exports) {

$parcel$export(module.exports, "previousTuesday", function () { return $545510fa357c10ad$export$a034a75f093bcfaf; }, function (v) { return $545510fa357c10ad$export$a034a75f093bcfaf = v; });
var $545510fa357c10ad$export$a034a75f093bcfaf;
"use strict";
$545510fa357c10ad$export$a034a75f093bcfaf = $545510fa357c10ad$var$previousTuesday;

var $dqWAw = parcelRequire("dqWAw");
/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $545510fa357c10ad$var$previousTuesday(date) {
    return (0, $dqWAw.previousDay)(date, 2);
}

});

parcelRegister("bkqji", function(module, exports) {

$parcel$export(module.exports, "previousWednesday", function () { return $83f5f8a618b0914f$export$26334f591e4ce672; }, function (v) { return $83f5f8a618b0914f$export$26334f591e4ce672 = v; });
var $83f5f8a618b0914f$export$26334f591e4ce672;
"use strict";
$83f5f8a618b0914f$export$26334f591e4ce672 = $83f5f8a618b0914f$var$previousWednesday;

var $dqWAw = parcelRequire("dqWAw");
/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $83f5f8a618b0914f$var$previousWednesday(date) {
    return (0, $dqWAw.previousDay)(date, 3);
}

});

parcelRegister("c00AA", function(module, exports) {

$parcel$export(module.exports, "quartersToMonths", function () { return $8bc5f11ceffd9701$export$a29d19ce21d74c57; }, function (v) { return $8bc5f11ceffd9701$export$a29d19ce21d74c57 = v; });
var $8bc5f11ceffd9701$export$a29d19ce21d74c57;
"use strict";
$8bc5f11ceffd9701$export$a29d19ce21d74c57 = $8bc5f11ceffd9701$var$quartersToMonths;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $8bc5f11ceffd9701$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $jpzPN.monthsInQuarter);
}

});

parcelRegister("hsWy8", function(module, exports) {

$parcel$export(module.exports, "quartersToYears", function () { return $cb7277eec7435353$export$c309fa8f184b4648; }, function (v) { return $cb7277eec7435353$export$c309fa8f184b4648 = v; });
var $cb7277eec7435353$export$c309fa8f184b4648;
"use strict";
$cb7277eec7435353$export$c309fa8f184b4648 = $cb7277eec7435353$var$quartersToYears;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $cb7277eec7435353$var$quartersToYears(quarters) {
    const years = quarters / $jpzPN.quartersInYear;
    return Math.trunc(years);
}

});

parcelRegister("8ivM2", function(module, exports) {

$parcel$export(module.exports, "roundToNearestHours", function () { return $60a8a6ce9a12fa36$export$a8b87649ebc0e3c2; }, function (v) { return $60a8a6ce9a12fa36$export$a8b87649ebc0e3c2 = v; });
var $60a8a6ce9a12fa36$export$a8b87649ebc0e3c2;
"use strict";
$60a8a6ce9a12fa36$export$a8b87649ebc0e3c2 = $60a8a6ce9a12fa36$var$roundToNearestHours;

var $dTgy4 = parcelRequire("dTgy4");

var $2J98k = parcelRequire("2J98k");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $60a8a6ce9a12fa36$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $2J98k.constructFrom)(date, NaN);
    const _date = (0, $2ZADR.toDate)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $dTgy4.getRoundingMethod)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $2J98k.constructFrom)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}

});

parcelRegister("bu2us", function(module, exports) {

$parcel$export(module.exports, "roundToNearestMinutes", function () { return $85c46d8a64c0bc71$export$d97410bb8cd0dff; }, function (v) { return $85c46d8a64c0bc71$export$d97410bb8cd0dff = v; });
var $85c46d8a64c0bc71$export$d97410bb8cd0dff;
"use strict";
$85c46d8a64c0bc71$export$d97410bb8cd0dff = $85c46d8a64c0bc71$var$roundToNearestMinutes;

var $dTgy4 = parcelRequire("dTgy4");

var $2J98k = parcelRequire("2J98k");

var $2ZADR = parcelRequire("2ZADR");
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $85c46d8a64c0bc71$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $2J98k.constructFrom)(date, NaN);
    const _date = (0, $2ZADR.toDate)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $dTgy4.getRoundingMethod)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $2J98k.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}

});

parcelRegister("aT2Tr", function(module, exports) {

$parcel$export(module.exports, "secondsToHours", function () { return $7ed148f4883b294d$export$47d555ff5354096f; }, function (v) { return $7ed148f4883b294d$export$47d555ff5354096f = v; });
var $7ed148f4883b294d$export$47d555ff5354096f;
"use strict";
$7ed148f4883b294d$export$47d555ff5354096f = $7ed148f4883b294d$var$secondsToHours;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $7ed148f4883b294d$var$secondsToHours(seconds) {
    const hours = seconds / $jpzPN.secondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("2kaX6", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $1b15f1e71fbb65cc$export$fc3e7e8557f8c8c7; }, function (v) { return $1b15f1e71fbb65cc$export$fc3e7e8557f8c8c7 = v; });
var $1b15f1e71fbb65cc$export$fc3e7e8557f8c8c7;
"use strict";
$1b15f1e71fbb65cc$export$fc3e7e8557f8c8c7 = $1b15f1e71fbb65cc$var$secondsToMilliseconds;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $1b15f1e71fbb65cc$var$secondsToMilliseconds(seconds) {
    return seconds * $jpzPN.millisecondsInSecond;
}

});

parcelRegister("kT6zj", function(module, exports) {

$parcel$export(module.exports, "secondsToMinutes", function () { return $f34e0a154c91675a$export$ed657adb62398e99; }, function (v) { return $f34e0a154c91675a$export$ed657adb62398e99 = v; });
var $f34e0a154c91675a$export$ed657adb62398e99;
"use strict";
$f34e0a154c91675a$export$ed657adb62398e99 = $f34e0a154c91675a$var$secondsToMinutes;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $f34e0a154c91675a$var$secondsToMinutes(seconds) {
    const minutes = seconds / $jpzPN.secondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("cLEfX", function(module, exports) {

$parcel$export(module.exports, "set", function () { return $94b919e7225adcaa$export$adaa4cf7ef1b65be; }, function (v) { return $94b919e7225adcaa$export$adaa4cf7ef1b65be = v; });
var $94b919e7225adcaa$export$adaa4cf7ef1b65be;
"use strict";
$94b919e7225adcaa$export$adaa4cf7ef1b65be = $94b919e7225adcaa$var$set;

var $2J98k = parcelRequire("2J98k");

var $4iQJE = parcelRequire("4iQJE");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $94b919e7225adcaa$var$set(date, values) {
    let _date = (0, $2ZADR.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $2J98k.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $4iQJE.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

});
parcelRegister("4iQJE", function(module, exports) {

$parcel$export(module.exports, "setMonth", function () { return $3221bffe7880ff43$export$63264690f8e36790; }, function (v) { return $3221bffe7880ff43$export$63264690f8e36790 = v; });
var $3221bffe7880ff43$export$63264690f8e36790;
"use strict";
$3221bffe7880ff43$export$63264690f8e36790 = $3221bffe7880ff43$var$setMonth;

var $2J98k = parcelRequire("2J98k");

var $2GUBT = parcelRequire("2GUBT");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $3221bffe7880ff43$var$setMonth(date, month) {
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $2J98k.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $2GUBT.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});


parcelRegister("jr5lN", function(module, exports) {

$parcel$export(module.exports, "setDate", function () { return $e264b07829bdb32e$export$566174fa40823587; }, function (v) { return $e264b07829bdb32e$export$566174fa40823587 = v; });
var $e264b07829bdb32e$export$566174fa40823587;
"use strict";
$e264b07829bdb32e$export$566174fa40823587 = $e264b07829bdb32e$var$setDate;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $e264b07829bdb32e$var$setDate(date, dayOfMonth) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

});

parcelRegister("3jfnx", function(module, exports) {

$parcel$export(module.exports, "setDayOfYear", function () { return $268f13500e439f24$export$2af590ffc7e7d7c5; }, function (v) { return $268f13500e439f24$export$2af590ffc7e7d7c5 = v; });
var $268f13500e439f24$export$2af590ffc7e7d7c5;
"use strict";
$268f13500e439f24$export$2af590ffc7e7d7c5 = $268f13500e439f24$var$setDayOfYear;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $268f13500e439f24$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}

});

parcelRegister("fiS5J", function(module, exports) {

$parcel$export(module.exports, "setDefaultOptions", function () { return $b2427ede19cadc8b$export$95365be1b0704abc; }, function (v) { return $b2427ede19cadc8b$export$95365be1b0704abc = v; });
var $b2427ede19cadc8b$export$95365be1b0704abc;
"use strict";
$b2427ede19cadc8b$export$95365be1b0704abc = $b2427ede19cadc8b$var$setDefaultOptions;

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $b2427ede19cadc8b$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $w0VDZ.setDefaultOptions)(result);
}

});

parcelRegister("8vDrN", function(module, exports) {

$parcel$export(module.exports, "setHours", function () { return $631fd16004016d77$export$f86b797a4659b781; }, function (v) { return $631fd16004016d77$export$f86b797a4659b781 = v; });
var $631fd16004016d77$export$f86b797a4659b781;
"use strict";
$631fd16004016d77$export$f86b797a4659b781 = $631fd16004016d77$var$setHours;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $631fd16004016d77$var$setHours(date, hours) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRegister("6lDsN", function(module, exports) {

$parcel$export(module.exports, "setMilliseconds", function () { return $49f350df4dd10c6d$export$de5664029b35e06d; }, function (v) { return $49f350df4dd10c6d$export$de5664029b35e06d = v; });
var $49f350df4dd10c6d$export$de5664029b35e06d;
"use strict";
$49f350df4dd10c6d$export$de5664029b35e06d = $49f350df4dd10c6d$var$setMilliseconds;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $49f350df4dd10c6d$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

});

parcelRegister("7GN8t", function(module, exports) {

$parcel$export(module.exports, "setMinutes", function () { return $599291f62237f9d1$export$ad569bf1c79ea89d; }, function (v) { return $599291f62237f9d1$export$ad569bf1c79ea89d = v; });
var $599291f62237f9d1$export$ad569bf1c79ea89d;
"use strict";
$599291f62237f9d1$export$ad569bf1c79ea89d = $599291f62237f9d1$var$setMinutes;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $599291f62237f9d1$var$setMinutes(date, minutes) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRegister("gw4mP", function(module, exports) {

$parcel$export(module.exports, "setQuarter", function () { return $c06305b91876997f$export$8924d1de7efe1755; }, function (v) { return $c06305b91876997f$export$8924d1de7efe1755 = v; });
var $c06305b91876997f$export$8924d1de7efe1755;
"use strict";
$c06305b91876997f$export$8924d1de7efe1755 = $c06305b91876997f$var$setQuarter;

var $4iQJE = parcelRequire("4iQJE");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $c06305b91876997f$var$setQuarter(date, quarter) {
    const _date = (0, $2ZADR.toDate)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $4iQJE.setMonth)(_date, _date.getMonth() + diff * 3);
}

});

parcelRegister("hpXNO", function(module, exports) {

$parcel$export(module.exports, "setSeconds", function () { return $0345ba779746c6b5$export$aec44746644cbf43; }, function (v) { return $0345ba779746c6b5$export$aec44746644cbf43 = v; });
var $0345ba779746c6b5$export$aec44746644cbf43;
"use strict";
$0345ba779746c6b5$export$aec44746644cbf43 = $0345ba779746c6b5$var$setSeconds;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $0345ba779746c6b5$var$setSeconds(date, seconds) {
    const _date = (0, $2ZADR.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRegister("a6G6p", function(module, exports) {

$parcel$export(module.exports, "setWeekYear", function () { return $75bb1f9546b89807$export$4340968d5939835e; }, function (v) { return $75bb1f9546b89807$export$4340968d5939835e = v; });
var $75bb1f9546b89807$export$4340968d5939835e;
"use strict";
$75bb1f9546b89807$export$4340968d5939835e = $75bb1f9546b89807$var$setWeekYear;

var $2J98k = parcelRequire("2J98k");

var $dNCuX = parcelRequire("dNCuX");

var $gJo6O = parcelRequire("gJo6O");

var $2ZADR = parcelRequire("2ZADR");

var $w0VDZ = parcelRequire("w0VDZ");
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $75bb1f9546b89807$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $w0VDZ.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $2ZADR.toDate)(date);
    const diff = (0, $dNCuX.differenceInCalendarDays)(_date, (0, $gJo6O.startOfWeekYear)(_date, options));
    const firstWeek = (0, $2J98k.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $gJo6O.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});

parcelRegister("akaMM", function(module, exports) {

$parcel$export(module.exports, "setYear", function () { return $7844237c21b2de1e$export$a8408b6c5639cab7; }, function (v) { return $7844237c21b2de1e$export$a8408b6c5639cab7 = v; });
var $7844237c21b2de1e$export$a8408b6c5639cab7;
"use strict";
$7844237c21b2de1e$export$a8408b6c5639cab7 = $7844237c21b2de1e$var$setYear;

var $2J98k = parcelRequire("2J98k");

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $7844237c21b2de1e$var$setYear(date, year) {
    const _date = (0, $2ZADR.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $2J98k.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRegister("3oyM0", function(module, exports) {

$parcel$export(module.exports, "startOfDecade", function () { return $278e96388fd62dbd$export$730492981c634308; }, function (v) { return $278e96388fd62dbd$export$730492981c634308 = v; });
var $278e96388fd62dbd$export$730492981c634308;
"use strict";
$278e96388fd62dbd$export$730492981c634308 = $278e96388fd62dbd$var$startOfDecade;

var $2ZADR = parcelRequire("2ZADR");
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $278e96388fd62dbd$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $2ZADR.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("1rFVw", function(module, exports) {

$parcel$export(module.exports, "startOfToday", function () { return $10d8d5d21ede6ebc$export$444d742fd5a45a57; }, function (v) { return $10d8d5d21ede6ebc$export$444d742fd5a45a57 = v; });
var $10d8d5d21ede6ebc$export$444d742fd5a45a57;
"use strict";
$10d8d5d21ede6ebc$export$444d742fd5a45a57 = $10d8d5d21ede6ebc$var$startOfToday;

var $5QRqy = parcelRequire("5QRqy");
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $10d8d5d21ede6ebc$var$startOfToday() {
    return (0, $5QRqy.startOfDay)(Date.now());
}

});

parcelRegister("1PSZi", function(module, exports) {

$parcel$export(module.exports, "startOfTomorrow", function () { return $15653544ff4352fd$export$7e8566c79d5bee07; }, function (v) { return $15653544ff4352fd$export$7e8566c79d5bee07 = v; });
var $15653544ff4352fd$export$7e8566c79d5bee07;
"use strict";
$15653544ff4352fd$export$7e8566c79d5bee07 = $15653544ff4352fd$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $15653544ff4352fd$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("62iJ8", function(module, exports) {

$parcel$export(module.exports, "startOfYesterday", function () { return $465174c1ebdc987c$export$23a16f3c6d143ce9; }, function (v) { return $465174c1ebdc987c$export$23a16f3c6d143ce9 = v; });
var $465174c1ebdc987c$export$23a16f3c6d143ce9;
"use strict";
$465174c1ebdc987c$export$23a16f3c6d143ce9 = $465174c1ebdc987c$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $465174c1ebdc987c$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("egOgU", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $a6398e3b289c5e0c$export$f93b5905241a7cca; }, function (v) { return $a6398e3b289c5e0c$export$f93b5905241a7cca = v; });
var $a6398e3b289c5e0c$export$f93b5905241a7cca;
"use strict";
$a6398e3b289c5e0c$export$f93b5905241a7cca = $a6398e3b289c5e0c$var$sub;

var $3Y7uu = parcelRequire("3Y7uu");

var $640gz = parcelRequire("640gz");

var $2J98k = parcelRequire("2J98k");
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $a6398e3b289c5e0c$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $640gz.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $3Y7uu.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $2J98k.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});
parcelRegister("640gz", function(module, exports) {

$parcel$export(module.exports, "subMonths", function () { return $46a352ab4f760c4e$export$73d1c15a21f9fae5; }, function (v) { return $46a352ab4f760c4e$export$73d1c15a21f9fae5 = v; });
var $46a352ab4f760c4e$export$73d1c15a21f9fae5;
"use strict";
$46a352ab4f760c4e$export$73d1c15a21f9fae5 = $46a352ab4f760c4e$var$subMonths;

var $4rTHm = parcelRequire("4rTHm");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $46a352ab4f760c4e$var$subMonths(date, amount) {
    return (0, $4rTHm.addMonths)(date, -amount);
}

});


parcelRegister("hcHwZ", function(module, exports) {

$parcel$export(module.exports, "subBusinessDays", function () { return $c8655307f1d3fe66$export$e5cc51ae28664a93; }, function (v) { return $c8655307f1d3fe66$export$e5cc51ae28664a93 = v; });
var $c8655307f1d3fe66$export$e5cc51ae28664a93;
"use strict";
$c8655307f1d3fe66$export$e5cc51ae28664a93 = $c8655307f1d3fe66$var$subBusinessDays;

var $btUMY = parcelRequire("btUMY");
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $c8655307f1d3fe66$var$subBusinessDays(date, amount) {
    return (0, $btUMY.addBusinessDays)(date, -amount);
}

});

parcelRegister("4tv7m", function(module, exports) {

$parcel$export(module.exports, "subHours", function () { return $3422022e87be9867$export$5e9fa51cd5bb1e71; }, function (v) { return $3422022e87be9867$export$5e9fa51cd5bb1e71 = v; });
var $3422022e87be9867$export$5e9fa51cd5bb1e71;
"use strict";
$3422022e87be9867$export$5e9fa51cd5bb1e71 = $3422022e87be9867$var$subHours;

var $dXVrc = parcelRequire("dXVrc");
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $3422022e87be9867$var$subHours(date, amount) {
    return (0, $dXVrc.addHours)(date, -amount);
}

});

parcelRegister("1fmjP", function(module, exports) {

$parcel$export(module.exports, "subMilliseconds", function () { return $0e88813c70a282c1$export$5abaf57ab8e91640; }, function (v) { return $0e88813c70a282c1$export$5abaf57ab8e91640 = v; });
var $0e88813c70a282c1$export$5abaf57ab8e91640;
"use strict";
$0e88813c70a282c1$export$5abaf57ab8e91640 = $0e88813c70a282c1$var$subMilliseconds;

var $jgywm = parcelRequire("jgywm");
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $0e88813c70a282c1$var$subMilliseconds(date, amount) {
    return (0, $jgywm.addMilliseconds)(date, -amount);
}

});

parcelRegister("lCYRp", function(module, exports) {

$parcel$export(module.exports, "subMinutes", function () { return $fbec5b2d1cc23f23$export$e12a970efb73fce5; }, function (v) { return $fbec5b2d1cc23f23$export$e12a970efb73fce5 = v; });
var $fbec5b2d1cc23f23$export$e12a970efb73fce5;
"use strict";
$fbec5b2d1cc23f23$export$e12a970efb73fce5 = $fbec5b2d1cc23f23$var$subMinutes;

var $6NFmg = parcelRequire("6NFmg");
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $fbec5b2d1cc23f23$var$subMinutes(date, amount) {
    return (0, $6NFmg.addMinutes)(date, -amount);
}

});

parcelRegister("jZzj6", function(module, exports) {

$parcel$export(module.exports, "subQuarters", function () { return $e8df1a1aa9265b63$export$a31bfeeeee80cce6; }, function (v) { return $e8df1a1aa9265b63$export$a31bfeeeee80cce6 = v; });
var $e8df1a1aa9265b63$export$a31bfeeeee80cce6;
"use strict";
$e8df1a1aa9265b63$export$a31bfeeeee80cce6 = $e8df1a1aa9265b63$var$subQuarters;

var $idUxy = parcelRequire("idUxy");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $e8df1a1aa9265b63$var$subQuarters(date, amount) {
    return (0, $idUxy.addQuarters)(date, -amount);
}

});

parcelRegister("8J1Oa", function(module, exports) {

$parcel$export(module.exports, "subSeconds", function () { return $65a3edbfd5358817$export$e95d8ad9981db689; }, function (v) { return $65a3edbfd5358817$export$e95d8ad9981db689 = v; });
var $65a3edbfd5358817$export$e95d8ad9981db689;
"use strict";
$65a3edbfd5358817$export$e95d8ad9981db689 = $65a3edbfd5358817$var$subSeconds;

var $3y0b1 = parcelRequire("3y0b1");
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $65a3edbfd5358817$var$subSeconds(date, amount) {
    return (0, $3y0b1.addSeconds)(date, -amount);
}

});

parcelRegister("Sb1Z0", function(module, exports) {

$parcel$export(module.exports, "subWeeks", function () { return $0a2d99c8a342051b$export$b4d8ae6376193efb; }, function (v) { return $0a2d99c8a342051b$export$b4d8ae6376193efb = v; });
var $0a2d99c8a342051b$export$b4d8ae6376193efb;
"use strict";
$0a2d99c8a342051b$export$b4d8ae6376193efb = $0a2d99c8a342051b$var$subWeeks;

var $328s2 = parcelRequire("328s2");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $0a2d99c8a342051b$var$subWeeks(date, amount) {
    return (0, $328s2.addWeeks)(date, -amount);
}

});

parcelRegister("5ZYL6", function(module, exports) {

$parcel$export(module.exports, "subYears", function () { return $45e1c7ab9f08326c$export$14867687ff6c92e2; }, function (v) { return $45e1c7ab9f08326c$export$14867687ff6c92e2 = v; });
var $45e1c7ab9f08326c$export$14867687ff6c92e2;
"use strict";
$45e1c7ab9f08326c$export$14867687ff6c92e2 = $45e1c7ab9f08326c$var$subYears;

var $5kmuZ = parcelRequire("5kmuZ");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $45e1c7ab9f08326c$var$subYears(date, amount) {
    return (0, $5kmuZ.addYears)(date, -amount);
}

});

parcelRegister("7Swnx", function(module, exports) {

$parcel$export(module.exports, "weeksToDays", function () { return $5bc6b148b8887ef4$export$b696b6eeb89501ad; }, function (v) { return $5bc6b148b8887ef4$export$b696b6eeb89501ad = v; });
var $5bc6b148b8887ef4$export$b696b6eeb89501ad;
"use strict";
$5bc6b148b8887ef4$export$b696b6eeb89501ad = $5bc6b148b8887ef4$var$weeksToDays;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $5bc6b148b8887ef4$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $jpzPN.daysInWeek);
}

});

parcelRegister("iAgyz", function(module, exports) {

$parcel$export(module.exports, "yearsToDays", function () { return $d8786e8f43b0be9c$export$862cb7b6e45c3b17; }, function (v) { return $d8786e8f43b0be9c$export$862cb7b6e45c3b17 = v; });
var $d8786e8f43b0be9c$export$862cb7b6e45c3b17;
"use strict";
$d8786e8f43b0be9c$export$862cb7b6e45c3b17 = $d8786e8f43b0be9c$var$yearsToDays;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $d8786e8f43b0be9c$var$yearsToDays(years) {
    return Math.trunc(years * $jpzPN.daysInYear);
}

});

parcelRegister("8EBpB", function(module, exports) {

$parcel$export(module.exports, "yearsToMonths", function () { return $64cf1466b2239394$export$894abb0747b9a00; }, function (v) { return $64cf1466b2239394$export$894abb0747b9a00 = v; });
var $64cf1466b2239394$export$894abb0747b9a00;
"use strict";
$64cf1466b2239394$export$894abb0747b9a00 = $64cf1466b2239394$var$yearsToMonths;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $64cf1466b2239394$var$yearsToMonths(years) {
    return Math.trunc(years * $jpzPN.monthsInYear);
}

});

parcelRegister("4TtZA", function(module, exports) {

$parcel$export(module.exports, "yearsToQuarters", function () { return $3903905205329098$export$ab26576e5e7379d7; }, function (v) { return $3903905205329098$export$ab26576e5e7379d7 = v; });
var $3903905205329098$export$ab26576e5e7379d7;
"use strict";
$3903905205329098$export$ab26576e5e7379d7 = $3903905205329098$var$yearsToQuarters;

var $jpzPN = parcelRequire("jpzPN");
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $3903905205329098$var$yearsToQuarters(years) {
    return Math.trunc(years * $jpzPN.quartersInYear);
}

});


parcelRegister("kyFlA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef770e53d889089c$export$2e2bcd8739ae039; });

var $ig2C7 = parcelRequire("ig2C7");
function $ef770e53d889089c$var$_defineProperty(e, r, t) {
    return (r = $ef770e53d889089c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ef770e53d889089c$var$_toPropertyKey(t) {
    var i = $ef770e53d889089c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ef770e53d889089c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

class $ef770e53d889089c$var$HistoryEvent {
    constructor(parentModel, event){
        $ef770e53d889089c$var$_defineProperty(this, "model", null);
        $ef770e53d889089c$var$_defineProperty(this, "timestamp", null);
        $ef770e53d889089c$var$_defineProperty(this, "userId", null);
        $ef770e53d889089c$var$_defineProperty(this, "field", null);
        $ef770e53d889089c$var$_defineProperty(this, "value", null);
        this.model = parentModel;
        this.timestamp = event.timestamp;
        this.userId = event.userId;
        this.field = event.field;
        this.value = event.value;
    }
    get modelLabel() {
        return this.model.title;
    }
    get date() {
        return new Date(this.timestamp);
    }
    get user() {
        const StaffCollection = (parcelRequire("lTrDt")).default;
        return StaffCollection.staffsById[this.userId];
    }
    get fieldLabel() {
        return (0, $ig2C7.capitalCase)(this.field);
    }
}
var $ef770e53d889089c$export$2e2bcd8739ae039 = $ef770e53d889089c$var$HistoryEvent;

});
parcelRegister("ig2C7", function(module, exports) {

$parcel$export(module.exports, "capitalCase", function () { return $d4abbfa9bd4f7160$export$7fed55d4315c6715; });

var $3ETLe = parcelRequire("3ETLe");

var $cUZWo = parcelRequire("cUZWo");

var $fLjqE = parcelRequire("fLjqE");
function $d4abbfa9bd4f7160$export$2a6bd1f4c244c979(input) {
    return (0, $fLjqE.upperCaseFirst)(input.toLowerCase());
}
function $d4abbfa9bd4f7160$export$7fed55d4315c6715(input, options) {
    if (options === void 0) options = {};
    return (0, $cUZWo.noCase)(input, (0, $3ETLe.__assign)({
        delimiter: " ",
        transform: $d4abbfa9bd4f7160$export$2a6bd1f4c244c979
    }, options));
}

});
parcelRegister("3ETLe", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $2aa05c7b7f38c862$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $2aa05c7b7f38c862$var$extendStatics = function(d, b) {
    $2aa05c7b7f38c862$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2aa05c7b7f38c862$var$extendStatics(d, b);
};
function $2aa05c7b7f38c862$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2aa05c7b7f38c862$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2aa05c7b7f38c862$export$18ce0697a983be9b = function() {
    $2aa05c7b7f38c862$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2aa05c7b7f38c862$export$18ce0697a983be9b.apply(this, arguments);
};
function $2aa05c7b7f38c862$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2aa05c7b7f38c862$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2aa05c7b7f38c862$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2aa05c7b7f38c862$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $2aa05c7b7f38c862$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $2aa05c7b7f38c862$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $2aa05c7b7f38c862$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $2aa05c7b7f38c862$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2aa05c7b7f38c862$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2aa05c7b7f38c862$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2aa05c7b7f38c862$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2aa05c7b7f38c862$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2aa05c7b7f38c862$export$45d3717a4c69092e(o, m, p);
}
function $2aa05c7b7f38c862$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2aa05c7b7f38c862$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2aa05c7b7f38c862$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2aa05c7b7f38c862$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2aa05c7b7f38c862$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2aa05c7b7f38c862$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2aa05c7b7f38c862$export$10c90e4f7922046c(v) {
    return this instanceof $2aa05c7b7f38c862$export$10c90e4f7922046c ? (this.v = v, this) : new $2aa05c7b7f38c862$export$10c90e4f7922046c(v);
}
function $2aa05c7b7f38c862$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2aa05c7b7f38c862$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2aa05c7b7f38c862$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2aa05c7b7f38c862$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $2aa05c7b7f38c862$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2aa05c7b7f38c862$export$19a8beecd37a4c45 === "function" ? $2aa05c7b7f38c862$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2aa05c7b7f38c862$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2aa05c7b7f38c862$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $2aa05c7b7f38c862$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2aa05c7b7f38c862$export$45d3717a4c69092e(result, mod, k);
    }
    $2aa05c7b7f38c862$var$__setModuleDefault(result, mod);
    return result;
}
function $2aa05c7b7f38c862$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2aa05c7b7f38c862$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2aa05c7b7f38c862$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2aa05c7b7f38c862$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $2aa05c7b7f38c862$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $2aa05c7b7f38c862$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $2aa05c7b7f38c862$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $2aa05c7b7f38c862$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $2aa05c7b7f38c862$export$2e2bcd8739ae039 = {
    __extends: $2aa05c7b7f38c862$export$a8ba968b8961cb8a,
    __assign: $2aa05c7b7f38c862$export$18ce0697a983be9b,
    __rest: $2aa05c7b7f38c862$export$3c9a16f847548506,
    __decorate: $2aa05c7b7f38c862$export$29e00dfd3077644b,
    __param: $2aa05c7b7f38c862$export$d5ad3fd78186038f,
    __metadata: $2aa05c7b7f38c862$export$f1db080c865becb9,
    __awaiter: $2aa05c7b7f38c862$export$1050f835b63b671e,
    __generator: $2aa05c7b7f38c862$export$67ebef60e6f28a6,
    __createBinding: $2aa05c7b7f38c862$export$45d3717a4c69092e,
    __exportStar: $2aa05c7b7f38c862$export$f33643c0debef087,
    __values: $2aa05c7b7f38c862$export$19a8beecd37a4c45,
    __read: $2aa05c7b7f38c862$export$8d051b38c9118094,
    __spread: $2aa05c7b7f38c862$export$afc72e2116322959,
    __spreadArrays: $2aa05c7b7f38c862$export$6388937ca91ccae8,
    __spreadArray: $2aa05c7b7f38c862$export$1216008129fb82ed,
    __await: $2aa05c7b7f38c862$export$10c90e4f7922046c,
    __asyncGenerator: $2aa05c7b7f38c862$export$e427f37a30a4de9b,
    __asyncDelegator: $2aa05c7b7f38c862$export$bbd80228419bb833,
    __asyncValues: $2aa05c7b7f38c862$export$e3b29a3d6162315f,
    __makeTemplateObject: $2aa05c7b7f38c862$export$4fb47efe1390b86f,
    __importStar: $2aa05c7b7f38c862$export$c21735bcef00d192,
    __importDefault: $2aa05c7b7f38c862$export$da59b14a69baef04,
    __classPrivateFieldGet: $2aa05c7b7f38c862$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $2aa05c7b7f38c862$export$d40a35129aaff81f,
    __classPrivateFieldIn: $2aa05c7b7f38c862$export$81fdc39f203e4e04,
    __addDisposableResource: $2aa05c7b7f38c862$export$88ac25d8e944e405,
    __disposeResources: $2aa05c7b7f38c862$export$8f076105dc360e92
};

});

parcelRegister("cUZWo", function(module, exports) {

$parcel$export(module.exports, "noCase", function () { return $967ac329bb7cc563$export$a596972587f860c8; });

var $ejqmh = parcelRequire("ejqmh");
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $967ac329bb7cc563$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $967ac329bb7cc563$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $967ac329bb7cc563$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $967ac329bb7cc563$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $967ac329bb7cc563$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $ejqmh.lowerCase) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $967ac329bb7cc563$var$replace($967ac329bb7cc563$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $967ac329bb7cc563$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}

});
parcelRegister("ejqmh", function(module, exports) {

$parcel$export(module.exports, "lowerCase", function () { return $a6b74941ba5422c4$export$61d6efbc6547e8eb; });
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $a6b74941ba5422c4$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "i\u0307\u0300",
            "\xcd": "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function $a6b74941ba5422c4$export$206cd6ecad4fcdde(str, locale) {
    var lang = $a6b74941ba5422c4$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $a6b74941ba5422c4$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $a6b74941ba5422c4$export$61d6efbc6547e8eb(str);
}
function $a6b74941ba5422c4$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}

});


parcelRegister("fLjqE", function(module, exports) {

$parcel$export(module.exports, "upperCaseFirst", function () { return $b79a50f5636f7b74$export$688230ca06b60d9d; });
/**
 * Upper case the first character of an input string.
 */ function $b79a50f5636f7b74$export$688230ca06b60d9d(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}

});





parcelRegister("8LDMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66219367253be90b$export$2e2bcd8739ae039; });

var $lM5ib = parcelRequire("lM5ib");

var $d8hWe = parcelRequire("d8hWe");

var $dBifK = parcelRequire("dBifK");

var $fritC = parcelRequire("fritC");

var $dflxv = parcelRequire("dflxv");

var $hy8Zj = parcelRequire("hy8Zj");

var $cPDHe = parcelRequire("cPDHe");

var $kdO1A = parcelRequire("kdO1A");

var $8YeUb = parcelRequire("8YeUb");

var $lTrDt = parcelRequire("lTrDt");

var $ftbex = parcelRequire("ftbex");

var $cuB2x = parcelRequire("cuB2x");

var $fqmGV = parcelRequire("fqmGV");

var $5EjDW = parcelRequire("5EjDW");
parcelRequire("9W6IT");
parcelRequire("5NCwu");

var $k7Nfo = parcelRequire("k7Nfo");

var $4iD0l = parcelRequire("4iD0l");

var $5Xh7w = parcelRequire("5Xh7w");

var $cjCbh = parcelRequire("cjCbh");

var $egx7S = parcelRequire("egx7S");
var $66219367253be90b$var$_class, $66219367253be90b$var$_descriptor, $66219367253be90b$var$_descriptor2, $66219367253be90b$var$_descriptor3, $66219367253be90b$var$_descriptor4, $66219367253be90b$var$_descriptor5, $66219367253be90b$var$_descriptor6, $66219367253be90b$var$_descriptor7, $66219367253be90b$var$_descriptor8, $66219367253be90b$var$_descriptor9, $66219367253be90b$var$_descriptor10, $66219367253be90b$var$_descriptor11, $66219367253be90b$var$_descriptor12, $66219367253be90b$var$_descriptor13, $66219367253be90b$var$_descriptor14, $66219367253be90b$var$_descriptor15, $66219367253be90b$var$_descriptor16;
function $66219367253be90b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $66219367253be90b$var$_defineProperty(e, r, t) {
    return (r = $66219367253be90b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $66219367253be90b$var$_toPropertyKey(t) {
    var i = $66219367253be90b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $66219367253be90b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $66219367253be90b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $66219367253be90b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $66219367253be90b$var$StaffModel = ($66219367253be90b$var$_class = class StaffModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $66219367253be90b$var$_initializerDefineProperty(this, "firstName", $66219367253be90b$var$_descriptor, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "lastName", $66219367253be90b$var$_descriptor2, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "email", $66219367253be90b$var$_descriptor3, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "roleId", $66219367253be90b$var$_descriptor4, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "isArchived", $66219367253be90b$var$_descriptor5, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "isDeleted", $66219367253be90b$var$_descriptor6, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "inheritPayRate", $66219367253be90b$var$_descriptor7, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "inheritOvertimeRate", $66219367253be90b$var$_descriptor8, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "inheritCostRate", $66219367253be90b$var$_descriptor9, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "inheritChargeOutRate", $66219367253be90b$var$_descriptor10, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "country", $66219367253be90b$var$_descriptor11, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "permissions", $66219367253be90b$var$_descriptor12, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "billingLevelOverride", $66219367253be90b$var$_descriptor13, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "costCentreId", $66219367253be90b$var$_descriptor14, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "staffType", $66219367253be90b$var$_descriptor15, this);
        $66219367253be90b$var$_initializerDefineProperty(this, "hasLogin", $66219367253be90b$var$_descriptor16, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $lTrDt.default);
        this.init(data, options);
    }
    update(data, options) {
        var _data$permissions;
        if (data !== null && data !== void 0 && (_data$permissions = data.permissions) !== null && _data$permissions !== void 0 && _data$permissions.projects) data.permissions.projects = data.permissions.projects.map((p)=>({
                ...p,
                id: p.id || p.uuid || (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))()
            }));
        super.update(data, options);
    }
    get role() {
        return (0, $8YeUb.default).modelsById[this.roleId];
    }
    get costCentre() {
        return (0, $hy8Zj.default).modelsById[this.costCentreId];
    }
    get allocations() {
        return (0, $k7Nfo.default).allocationsByStaffId[this.id] || [];
    }
    get dailyAllocations() {
        return (0, $cPDHe.default).dailyAllocationsByStaffId[this.id] || [];
    }
    get ownerOf() {
        return (0, $kdO1A.default).projectsByOwnerId[this.id];
    }
    get rates() {
        return (0, $ftbex.default).ratesByStaffId[this.id] || [];
    }
    get payRate() {
        return this.getRateAtDate("pay", new Date());
    }
    get overtimeRate() {
        return this.getRateAtDate("overtime", new Date());
    }
    get costRate() {
        return this.getRateAtDate("cost", new Date());
    }
    get chargeOutRate() {
        return this.getRateAtDate("chargeOut", new Date());
    }
    get availability() {
        return this.getAvailabilityAtDate(new Date());
    }
    get minRateDate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(this.rates.map((r)=>r.date));
    }
    get staffAndRoleRates() {
        var _this$role;
        return [
            ...this.rates,
            ...((_this$role = this.role) === null || _this$role === void 0 ? void 0 : _this$role.rates) || []
        ];
    }
    get timeEntries() {
        return (0, $cuB2x.default).timeEntriesByStaffId[this.id];
    }
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
    get budgets() {
        return (0, $5EjDW.default).budgetsByStaffId[this.id] || [];
    }
    inheritRateType(rateType) {
        return this["inherit" + (0, $lM5ib.pascalCase)(rateType) + "Rate"];
    }
    getRateInDateRange(rateType, dateRange) {
        if (this.role && this.inheritRateType(rateType)) return this.role.getRateInDateRange(rateType, dateRange);
        return (0, $dflxv.default)(this.rates, rateType, dateRange);
    }
    getRateAtDate(rateType, date) {
        if (this.role && this.inheritRateType(rateType)) return this.role.getRateAtDate(rateType, date);
        return (0, $fritC.default)(this.rates, rateType, date);
    }
    getAvailabilityInDateRange(dateRange) {
        return (0, $dflxv.default)(this.rates, "availability", dateRange);
    }
    getAvailabilityAtDate(date) {
        return (0, $fritC.default)(this.rates, "availability", date);
    }
    getAvailableHoursInDateRange(dateRange) {
        const dailyAvailableHours = this.getAvailabilityInDateRange(dateRange) / 60 / 5;
        const weekdaysInDateRange = (0, $egx7S.differenceInBusinessDays)(dateRange[1], dateRange[0]);
        //TODO holidays
        return dailyAvailableHours * weekdaysInDateRange;
    }
    hoursInDateRange(dateRange) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.allocations.filter((a)=>a.date >= dateRange[0] && a.date <= dateRange[1]).map((a)=>a.hours));
    }
    get billingLevel() {
        if (this.billingLevelOverride) return this.billingLevelOverride;
        if (!this.hasLogin || this.isArchived || this.deletedAt || !this.email || this.email === "") return "none";
        if ((0, $4iD0l.canSeeSalaries)(this) || (0, $4iD0l.canSeeOperationalExpenses)(this) || (0, $4iD0l.canViewBilling)(this) || (0, $4iD0l.canViewSettings)(this)) return "admin";
        return "standard";
    }
}, $66219367253be90b$var$_descriptor = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "firstName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor2 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "lastName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor3 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "email", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor4 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor5 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "isArchived", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor6 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "isDeleted", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor7 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "inheritPayRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor8 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "inheritOvertimeRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor9 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "inheritCostRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor10 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "inheritChargeOutRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor11 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "country", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor12 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "permissions", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor13 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "billingLevelOverride", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor14 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "costCentreId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor15 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "staffType", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_descriptor16 = $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "hasLogin", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "role"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "costCentre"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "allocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "allocations"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "dailyAllocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "dailyAllocations"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "ownerOf", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "ownerOf"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "rates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "rates"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "payRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "payRate"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "overtimeRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "overtimeRate"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "costRate"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "chargeOutRate"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "availability", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "availability"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "minRateDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "minRateDate"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "staffAndRoleRates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "staffAndRoleRates"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "timeEntries", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "timeEntries"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "fullName", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "fullName"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "budgets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "budgets"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "inheritRateType", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "inheritRateType"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "getRateInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "getRateInDateRange"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "getRateAtDate", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "getRateAtDate"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "getAvailabilityInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "getAvailabilityInDateRange"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "getAvailabilityAtDate", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "getAvailabilityAtDate"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "getAvailableHoursInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "getAvailableHoursInDateRange"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "hoursInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "hoursInDateRange"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_applyDecoratedDescriptor($66219367253be90b$var$_class.prototype, "billingLevel", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($66219367253be90b$var$_class.prototype, "billingLevel"), $66219367253be90b$var$_class.prototype), $66219367253be90b$var$_class);
var $66219367253be90b$export$2e2bcd8739ae039 = $66219367253be90b$var$StaffModel;

});
parcelRegister("lM5ib", function(module, exports) {

$parcel$export(module.exports, "pascalCase", function () { return $fda22f9831f04a9d$export$26c6f48841fe1a8a; });

var $3ETLe = parcelRequire("3ETLe");

var $cUZWo = parcelRequire("cUZWo");
function $fda22f9831f04a9d$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $fda22f9831f04a9d$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $fda22f9831f04a9d$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $cUZWo.noCase)(input, (0, $3ETLe.__assign)({
        delimiter: "",
        transform: $fda22f9831f04a9d$export$66a4dfea2695736
    }, options));
}

});

parcelRegister("fritC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d7b5b2ef2ffd13$export$2e2bcd8739ae039; });
parcelRequire("dgarI");
parcelRequire("iVVQG");
var $b3d7b5b2ef2ffd13$export$2e2bcd8739ae039 = (rates, rateType, date)=>{
    var _date, _rates, _rates$0$rateName;
    (_date = date) !== null && _date !== void 0 ? _date : date = new Date();
    if (!((_rates = rates) !== null && _rates !== void 0 && _rates.length) || !rateType) return 0;
    rates = rates.filter((r)=>r.date <= date).sort((a, b)=>b.date - a.date);
    const rateName = rateType === "availability" ? "weeklyAvailability" : rateType + "Rate";
    if (!rates.length) return 0;
    return (_rates$0$rateName = rates[0][rateName]) !== null && _rates$0$rateName !== void 0 ? _rates$0$rateName : 0;
};

});
parcelRegister("dgarI", function(module, exports) {

$parcel$export(module.exports, "spanSetFromPointSet", function () { return $9a74df540dbdbfe5$export$47ee317d48ba68d9; });
$parcel$export(module.exports, "combineSpanSets", function () { return $9a74df540dbdbfe5$export$d44f65ac6fd569ea; });
// [{point: single point, span: between points, value}]
function $9a74df540dbdbfe5$export$47ee317d48ba68d9(pointValues, defaultBefore) {
    //[{point: single point, value}]
    const spans = [
        {
            span: [
                -Infinity,
                pointValues[0].point
            ],
            value: defaultBefore !== undefined ? defaultBefore : null
        }
    ];
    pointValues.forEach((pv, i)=>{
        spans.push({
            span: [
                pointValues[i].point,
                i !== pointValues.length - 1 ? pointValues[i + 1].point : Infinity
            ],
            value: pointValues[i].value
        });
    });
    return spans;
}
function $9a74df540dbdbfe5$export$f1ca819cd34389e5(spanValues) {
    const points = [];
    spanValues.forEach((sv, i)=>{
        if (!i) return;
        points.push({
            point: sv.span[0],
            value: sv.value
        });
    });
}
function $9a74df540dbdbfe5$export$f64c1935cce05e02(pointSet, point, defaultValue) {
    var _pointSet$filter$sort;
    return ((_pointSet$filter$sort = pointSet.filter((p)=>p.point <= point).sort((a, b)=>b.point - a.point)) === null || _pointSet$filter$sort === void 0 ? void 0 : _pointSet$filter$sort[0].value) || defaultValue;
}
function $9a74df540dbdbfe5$export$7ca312b2137cde80(spanSet, point, defaultValue) {
    var _spanSet$filter$sort;
    return ((_spanSet$filter$sort = spanSet.filter((sv)=>sv.span[0] <= point && sv.span[1] >= point).sort((a, b)=>b.span[0] - a.span[0])) === null || _spanSet$filter$sort === void 0 ? void 0 : _spanSet$filter$sort[0].value) || defaultValue;
}
function $9a74df540dbdbfe5$export$11802662041ecda0(spanSet, multiplyFunc = (v, r)=>v * r, addFunc = (l, r)=>l + r) {
    const totalLength = $9a74df540dbdbfe5$var$lengthFromSpan($9a74df540dbdbfe5$var$spanFromSpanSet(spanSet));
    let avgValue;
    spanSet.forEach((sv, i)=>{
        const length = $9a74df540dbdbfe5$var$lengthFromSpan(sv.span);
        const lengthRatio = length / totalLength;
        const adjustedValue = multiplyFunc(sv.value, lengthRatio);
        if (!i) avgValue = adjustedValue;
        else avgValue = addFunc(avgValue, adjustedValue);
    });
    return avgValue;
}
function $9a74df540dbdbfe5$export$c84214f0ca3dd761(pointSet, clamp) {
    let clampedPointSet = [
        ...pointSet.filter((p)=>p.point >= clamp[0] && p.point <= clamp[1]).sort((a, b)=>a.point - b.point)
    ];
    if (clampedPointSet[0].point > clamp[0]) clampedPointSet.unshift({
        point: clamp[0],
        value: $9a74df540dbdbfe5$export$f64c1935cce05e02([
            ...pointSet
        ], clamp[0])
    });
    return clampedPointSet;
}
function $9a74df540dbdbfe5$export$80711da03ba4e645(spanSet, span, clamp) {
    const newSpanSet = [];
    spanSet.forEach((sv)=>{
        if (sv.span[1] >= span[0] && sv.span[0] <= span[1]) newSpanSet.push({
            span: [
                clamp && sv.span[0] < clamp[0] ? clamp[0] : sv.span[0],
                clamp && sv.span[1] > clamp[1] ? clamp[1] : sv.span[1]
            ],
            value: sv.value
        });
    });
    return newSpanSet.sort((a, b)=>a.span[0] - b.span[0]);
}
function $9a74df540dbdbfe5$var$lengthFromSpan(span) {
    return span[1] - span[0];
}
// function averageSpanSetValueBetweenSpan(
//     spanSet,
//     span,
//     defaultBefore,
//     defaultAfter
// ) {
//     let spansForCalc = spanSetBetweenSpan(spanSet, span, span).sort(
//         (a, b) => a.span[0] - b.span[0]
//     )
//     if (spansForCalc[0].span[0] >= span[0]) {
//         spansForCalc.unshift({
//             span: [span[0], spanSet[0].span[0]],
//             value: defaultBefore !== undefined ? defaultBefore : null,
//         })
//     }
//     spansForCalc = spansForCalc.sort((a, b) => b.span[1] - a.span[1])
//     if (spansForCalc[spansForCalc.length - 1].span[1] <= span[1]) {
//         spansForCalc.push({
//             span: [spanSet[0].span[1], span[1]],
//             value: defaultAfter !== undefined ? defaultAfter : null,
//         })
//     }
//     const totalLength = lengthFromSpan(span)
//     let value = 0
//     spansForCalc.forEach((sv) => {
//         const length = lengthFromSpan(sv.span)
//         const ratio = length / totalLength
//         value += ratio * sv.svalue
//     })
//     return value
// }
function $9a74df540dbdbfe5$var$pointsFromSpanSet(spanSet) {
    const points = new Set();
    spanSet.forEach((sv)=>{
        var _sv$span, _sv$span2;
        if (!((_sv$span = sv.span) !== null && _sv$span !== void 0 && _sv$span[0] && (_sv$span2 = sv.span) !== null && _sv$span2 !== void 0 && _sv$span2[1])) return;
        points.add(sv.span[0]);
        points.add(sv.span[1]);
    });
    return [
        ...points
    ];
}
function $9a74df540dbdbfe5$var$spanFromSpanSet(spanSet) {
    let span = null;
    spanSet.forEach((sv, i)=>{
        var _sv$span3, _sv$span4;
        if (!((_sv$span3 = sv.span) !== null && _sv$span3 !== void 0 && _sv$span3[0] && (_sv$span4 = sv.span) !== null && _sv$span4 !== void 0 && _sv$span4[1])) return;
        if (!i) span = [
            ...sv.span
        ];
        else {
            if (span[0] > sv.span[0]) span[0] = sv.span[0];
            if (span[1] < sv.span[1]) span[1] = sv.span[1];
        }
    });
    return span;
}
function $9a74df540dbdbfe5$var$splitSpanSetAtPoints(spanSet, points, defaultBefore, defaultAfter) {
    const newSpanSet = [];
    const allPoints = [
        ...new Set([
            ...points,
            ...$9a74df540dbdbfe5$var$pointsFromSpanSet(spanSet)
        ])
    ].sort((a, b)=>a - b);
    let spanSetSpan = $9a74df540dbdbfe5$var$spanFromSpanSet(spanSet) || [
        Infinity,
        -Infinity
    ];
    let spanIndex = 0;
    allPoints.forEach((p, i)=>{
        const p2 = points[i + 1];
        if (i !== allPoints.length - 1) {
            while(p >= spanSetSpan[0] && p2 <= spanSetSpan[1] && !(p >= spanSet[spanIndex].span[0] && p2 <= spanSet[spanIndex].span[1]) && spanIndex < spanSet.length)spanIndex++;
            newSpanSet.push({
                span: [
                    p,
                    p2
                ],
                value: p < spanSetSpan[0] ? defaultBefore : p >= spanSetSpan[1] ? defaultAfter : spanSet[spanIndex].value
            });
        }
    });
    return newSpanSet;
}
function $9a74df540dbdbfe5$export$d44f65ac6fd569ea(spanSets, combineFunc = (v)=>v, defaultBefore, defaultAfter, clamp) {
    const uniquePoints = $9a74df540dbdbfe5$var$uniquePointsFromSpanSets(spanSets, clamp);
    const splitSpanSets = spanSets.map((ss)=>$9a74df540dbdbfe5$var$splitSpanSetAtPoints(ss, uniquePoints, defaultBefore, defaultAfter));
    const combinedSet = [];
    splitSpanSets[0].forEach((sss, i)=>{
        combinedSet.push({
            span: sss.span,
            value: combineFunc(...splitSpanSets.map((ss)=>ss[i].value))
        });
    });
    return combinedSet;
}
function $9a74df540dbdbfe5$var$uniquePointsFromSpanSets(spanSets, clamp) {
    const uniquePoints = new Set();
    if (clamp) {
        uniquePoints.add(clamp[0]);
        uniquePoints.add(clamp[1]);
    }
    spanSets.flat().forEach((sv)=>{
        var _sv$span5, _sv$span6;
        if (!((_sv$span5 = sv.span) !== null && _sv$span5 !== void 0 && _sv$span5[0] && (_sv$span6 = sv.span) !== null && _sv$span6 !== void 0 && _sv$span6[1])) return;
        if (!clamp) {
            uniquePoints.add(sv.span[0]);
            uniquePoints.add(sv.span[1]);
        } else {
            if (sv.span[0] >= clamp[0] && sv.span[0] <= clamp[1]) uniquePoints.add(sv.span[0]);
            if (sv.span[1] >= clamp[0] && sv.span[1] <= clamp[1]) uniquePoints.add(sv.span[1]);
        }
    });
    return [
        ...uniquePoints
    ].sort((a, b)=>a - b);
}

});

parcelRegister("iVVQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc8a6c6dbd42ab78$export$2e2bcd8739ae039; });

var $dgarI = parcelRequire("dgarI");
var $dc8a6c6dbd42ab78$export$2e2bcd8739ae039 = (rates = [], rateType, beforeIntialValue)=>{
    const rateName = rateType === "availability" ? "weeklyAvailability" : rateType + "Rate";
    if (!rates || !rates.length) return [];
    return (0, $dgarI.spanSetFromPointSet)(rates.map((rate)=>({
            point: rate.date.getTime(),
            value: rate[rateName] || 0
        })), beforeIntialValue);
};

});


parcelRegister("dflxv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a4d6259df5e5d37$export$2e2bcd8739ae039; });

var $fritC = parcelRequire("fritC");

var $dBifK = parcelRequire("dBifK");

var $egx7S = parcelRequire("egx7S");
var $9a4d6259df5e5d37$export$2e2bcd8739ae039 = (rates, rateType, dateRange)=>{
    var _2, _dateRange$_, _3, _dateRange$_2, _dateRange$, _dateRange$2;
    const now = new Date();
    (_dateRange$_ = dateRange[_2 = 0]) !== null && _dateRange$_ !== void 0 ? _dateRange$_ : dateRange[_2] = now;
    (_dateRange$_2 = dateRange[_3 = 1]) !== null && _dateRange$_2 !== void 0 ? _dateRange$_2 : dateRange[_3] = now;
    if (((_dateRange$ = dateRange[0]) === null || _dateRange$ === void 0 ? void 0 : _dateRange$.getTime()) === ((_dateRange$2 = dateRange[1]) === null || _dateRange$2 === void 0 ? void 0 : _dateRange$2.getTime())) return (0, $fritC.default)(rates, rateType, dateRange[0]);
    const businessDays = $9a4d6259df5e5d37$var$getBusinessDaysBetweenDates(...dateRange);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(businessDays.map((d)=>{
        return (0, $fritC.default)(rates, rateType, d) || 0;
    }));
};
const $9a4d6259df5e5d37$var$getBusinessDaysBetweenDates = (startDate, endDate)=>{
    const start = new Date(startDate);
    const end = new Date(endDate);
    const businessDays = [];
    let currentDate = start;
    while(currentDate <= end){
        const day = currentDate.getDay();
        if (![
            0,
            6
        ].includes(day)) businessDays.push(currentDate);
        currentDate = (0, $egx7S.addDays)(currentDate, 1);
    }
    return businessDays;
};

});

parcelRegister("hy8Zj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc6c956f9dc4aa2a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CostCentreCollectionClass", function () { return $cc6c956f9dc4aa2a$export$a7f00764127270a0; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $bxARh = parcelRequire("bxARh");
var $cc6c956f9dc4aa2a$var$_dec, $cc6c956f9dc4aa2a$var$_dec2, $cc6c956f9dc4aa2a$var$_class;
function $cc6c956f9dc4aa2a$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $cc6c956f9dc4aa2a$var$CostCentreCollection = ($cc6c956f9dc4aa2a$var$_dec = (0, $d8hWe.action).bound, $cc6c956f9dc4aa2a$var$_dec2 = (0, $d8hWe.action).bound, $cc6c956f9dc4aa2a$var$_class = class CostCentreCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "costCentres",
            modelClass: (0, $bxARh.default)
        });
        this.addLookup("activeCostCentres", "list", {
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get costCentresById() {
        return this.modelsById;
    }
    get costCentres() {
        return this.models;
    }
    get costCentresById() {
        return this.modelsById;
    }
    addCostCentre(data) {
        this.add(data);
    }
    addCostCentres(data) {
        this.addMany(data);
    }
}, $cc6c956f9dc4aa2a$var$_applyDecoratedDescriptor($cc6c956f9dc4aa2a$var$_class.prototype, "addCostCentre", [
    $cc6c956f9dc4aa2a$var$_dec
], Object.getOwnPropertyDescriptor($cc6c956f9dc4aa2a$var$_class.prototype, "addCostCentre"), $cc6c956f9dc4aa2a$var$_class.prototype), $cc6c956f9dc4aa2a$var$_applyDecoratedDescriptor($cc6c956f9dc4aa2a$var$_class.prototype, "addCostCentres", [
    $cc6c956f9dc4aa2a$var$_dec2
], Object.getOwnPropertyDescriptor($cc6c956f9dc4aa2a$var$_class.prototype, "addCostCentres"), $cc6c956f9dc4aa2a$var$_class.prototype), $cc6c956f9dc4aa2a$var$_class);
var $cc6c956f9dc4aa2a$export$2e2bcd8739ae039 = new $cc6c956f9dc4aa2a$var$CostCentreCollection();
const $cc6c956f9dc4aa2a$export$a7f00764127270a0 = $cc6c956f9dc4aa2a$var$CostCentreCollection;

});
parcelRegister("bxARh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866f5e182b05adc3$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $hy8Zj = parcelRequire("hy8Zj");

var $bzI0s = parcelRequire("bzI0s");

var $kdO1A = parcelRequire("kdO1A");

var $lTrDt = parcelRequire("lTrDt");

var $fqmGV = parcelRequire("fqmGV");
var $866f5e182b05adc3$var$_class, $866f5e182b05adc3$var$_descriptor, $866f5e182b05adc3$var$_descriptor2;
function $866f5e182b05adc3$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $866f5e182b05adc3$var$_defineProperty(e, r, t) {
    return (r = $866f5e182b05adc3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $866f5e182b05adc3$var$_toPropertyKey(t) {
    var i = $866f5e182b05adc3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $866f5e182b05adc3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $866f5e182b05adc3$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $866f5e182b05adc3$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $866f5e182b05adc3$var$CostCentreModel = ($866f5e182b05adc3$var$_class = class CostCentreModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $866f5e182b05adc3$var$_initializerDefineProperty(this, "name", $866f5e182b05adc3$var$_descriptor, this);
        $866f5e182b05adc3$var$_initializerDefineProperty(this, "isBillable", $866f5e182b05adc3$var$_descriptor2, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $hy8Zj.default);
        this.init(data, options);
    }
    get overheadExpenses() {
        return (0, $bzI0s.default).overheadExpensesByCostCentreId[this.costCentreId];
    }
    get projects() {
        return (0, $kdO1A.default).allocationsByCostCentreId[this.id];
    }
    get staff() {
        return (0, $lTrDt.default).staffByCostCentreId[this.id];
    }
}, $866f5e182b05adc3$var$_descriptor = $866f5e182b05adc3$var$_applyDecoratedDescriptor($866f5e182b05adc3$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $866f5e182b05adc3$var$_descriptor2 = $866f5e182b05adc3$var$_applyDecoratedDescriptor($866f5e182b05adc3$var$_class.prototype, "isBillable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $866f5e182b05adc3$var$_applyDecoratedDescriptor($866f5e182b05adc3$var$_class.prototype, "overheadExpenses", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($866f5e182b05adc3$var$_class.prototype, "overheadExpenses"), $866f5e182b05adc3$var$_class.prototype), $866f5e182b05adc3$var$_applyDecoratedDescriptor($866f5e182b05adc3$var$_class.prototype, "projects", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($866f5e182b05adc3$var$_class.prototype, "projects"), $866f5e182b05adc3$var$_class.prototype), $866f5e182b05adc3$var$_applyDecoratedDescriptor($866f5e182b05adc3$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($866f5e182b05adc3$var$_class.prototype, "staff"), $866f5e182b05adc3$var$_class.prototype), $866f5e182b05adc3$var$_class);
var $866f5e182b05adc3$export$2e2bcd8739ae039 = $866f5e182b05adc3$var$CostCentreModel;

});
parcelRegister("bzI0s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86d51958fa8f26c7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "OverheadExpenseCollectionClass", function () { return $86d51958fa8f26c7$export$b7dce7aaac249110; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $lquJv = parcelRequire("lquJv");
var $86d51958fa8f26c7$var$_dec, $86d51958fa8f26c7$var$_dec2, $86d51958fa8f26c7$var$_class;
function $86d51958fa8f26c7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $86d51958fa8f26c7$var$OverheadExpenseCollection = ($86d51958fa8f26c7$var$_dec = (0, $d8hWe.action).bound, $86d51958fa8f26c7$var$_dec2 = (0, $d8hWe.action).bound, $86d51958fa8f26c7$var$_class = class OverheadExpenseCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "overheadExpenses",
            modelClass: (0, $lquJv.default)
        });
        this.addLookup("overheadExpensesByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("activeOverheads", "list", {
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get overheadExpensesById() {
        return this.modelsById;
    }
    get overheadExpenses() {
        return this.models;
    }
    addOverheadExpense(data) {
        this.add(data);
    }
    addOverheadExpenses(data) {
        this.addMany(data);
    }
}, $86d51958fa8f26c7$var$_applyDecoratedDescriptor($86d51958fa8f26c7$var$_class.prototype, "addOverheadExpense", [
    $86d51958fa8f26c7$var$_dec
], Object.getOwnPropertyDescriptor($86d51958fa8f26c7$var$_class.prototype, "addOverheadExpense"), $86d51958fa8f26c7$var$_class.prototype), $86d51958fa8f26c7$var$_applyDecoratedDescriptor($86d51958fa8f26c7$var$_class.prototype, "addOverheadExpenses", [
    $86d51958fa8f26c7$var$_dec2
], Object.getOwnPropertyDescriptor($86d51958fa8f26c7$var$_class.prototype, "addOverheadExpenses"), $86d51958fa8f26c7$var$_class.prototype), $86d51958fa8f26c7$var$_class);
var $86d51958fa8f26c7$export$2e2bcd8739ae039 = new $86d51958fa8f26c7$var$OverheadExpenseCollection();
const $86d51958fa8f26c7$export$b7dce7aaac249110 = $86d51958fa8f26c7$var$OverheadExpenseCollection;

});
parcelRegister("lquJv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f993dda191ff05c6$export$2e2bcd8739ae039; });

var $egx7S = parcelRequire("egx7S");

var $d8hWe = parcelRequire("d8hWe");

var $hy8Zj = parcelRequire("hy8Zj");

var $bzI0s = parcelRequire("bzI0s");

var $fqmGV = parcelRequire("fqmGV");
var $f993dda191ff05c6$var$_class, $f993dda191ff05c6$var$_descriptor, $f993dda191ff05c6$var$_descriptor2, $f993dda191ff05c6$var$_descriptor3, $f993dda191ff05c6$var$_descriptor4, $f993dda191ff05c6$var$_descriptor5, $f993dda191ff05c6$var$_descriptor6, $f993dda191ff05c6$var$_descriptor7, $f993dda191ff05c6$var$_descriptor8;
function $f993dda191ff05c6$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $f993dda191ff05c6$var$_defineProperty(e, r, t) {
    return (r = $f993dda191ff05c6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f993dda191ff05c6$var$_toPropertyKey(t) {
    var i = $f993dda191ff05c6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f993dda191ff05c6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f993dda191ff05c6$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $f993dda191ff05c6$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $f993dda191ff05c6$var$OverheadExpenseModel = ($f993dda191ff05c6$var$_class = class OverheadExpenseModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $f993dda191ff05c6$var$_initializerDefineProperty(this, "name", $f993dda191ff05c6$var$_descriptor, this);
        $f993dda191ff05c6$var$_initializerDefineProperty(this, "value", $f993dda191ff05c6$var$_descriptor2, this);
        $f993dda191ff05c6$var$_initializerDefineProperty(this, "startDate", $f993dda191ff05c6$var$_descriptor3, this);
        $f993dda191ff05c6$var$_initializerDefineProperty(this, "endDate", $f993dda191ff05c6$var$_descriptor4, this);
        $f993dda191ff05c6$var$_initializerDefineProperty(this, "hasRepeat", $f993dda191ff05c6$var$_descriptor5, this);
        $f993dda191ff05c6$var$_initializerDefineProperty(this, "repeatQuantity", $f993dda191ff05c6$var$_descriptor6, this);
        $f993dda191ff05c6$var$_initializerDefineProperty(this, "repeatUnit", $f993dda191ff05c6$var$_descriptor7, this);
        $f993dda191ff05c6$var$_initializerDefineProperty(this, "costCentreId", $f993dda191ff05c6$var$_descriptor8, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $bzI0s.default);
        this.init(data, options);
    }
    get costCentre() {
        return (0, $hy8Zj.default).modelsById[this.costCentreId];
    }
    valueInDateRange(startDate, endDate) {
        if (!this.startDate) return 0;
        if (this.startDate > endDate) return 0;
        if (this.endDate && this.endDate < startDate) return 0;
        const adjustedEndDate = this.endDate && this.endDate <= endDate ? this.endDate : endDate;
        if (!this.hasRepeat || !this.repeatQuantity) {
            if (this.startDate >= startDate && this.startDate <= adjustedEndDate) return this.value;
            return 0;
        }
        const differenceLookup = {
            days: (0, $egx7S.differenceInDays),
            weeks: (0, $egx7S.differenceInWeeks),
            months: (0, $egx7S.differenceInMonths),
            years: (0, $egx7S.differenceInYears)
        };
        const addLookup = {
            days: (0, $egx7S.addDays),
            weeks: (0, $egx7S.addWeeks),
            months: (0, $egx7S.addMonths),
            years: (0, $egx7S.addYears)
        };
        const currentRepeatUnitDifference = differenceLookup[this.repeatUnit];
        const currentRepeatUnitAdd = addLookup[this.repeatUnit];
        const diff = currentRepeatUnitDifference((0, $egx7S.addDays)(endDate, 1), startDate);
        const startDiff = currentRepeatUnitDifference(startDate, this.startDate);
        if (diff < 0) return 0;
        let numRepeatsInRange = 0;
        let currentRepeatDate = this.startDate;
        while(currentRepeatDate <= adjustedEndDate){
            if (currentRepeatDate >= startDate) numRepeatsInRange++;
            currentRepeatDate = currentRepeatUnitAdd(currentRepeatDate, this.repeatQuantity);
        }
        return numRepeatsInRange * this.value;
    }
}, $f993dda191ff05c6$var$_descriptor = $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f993dda191ff05c6$var$_descriptor2 = $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "value", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f993dda191ff05c6$var$_descriptor3 = $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f993dda191ff05c6$var$_descriptor4 = $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f993dda191ff05c6$var$_descriptor5 = $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "hasRepeat", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f993dda191ff05c6$var$_descriptor6 = $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "repeatQuantity", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f993dda191ff05c6$var$_descriptor7 = $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "repeatUnit", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f993dda191ff05c6$var$_descriptor8 = $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "costCentreId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f993dda191ff05c6$var$_applyDecoratedDescriptor($f993dda191ff05c6$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f993dda191ff05c6$var$_class.prototype, "costCentre"), $f993dda191ff05c6$var$_class.prototype), $f993dda191ff05c6$var$_class);
var $f993dda191ff05c6$export$2e2bcd8739ae039 = $f993dda191ff05c6$var$OverheadExpenseModel;

});


parcelRegister("kdO1A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb8bd36764e8d82b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectCollectionClass", function () { return $eb8bd36764e8d82b$export$ca2e4d934c5013d7; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $TkfOD = parcelRequire("TkfOD");

var $hy8Zj = parcelRequire("hy8Zj");

var $9Lw71 = parcelRequire("9Lw71");
var $eb8bd36764e8d82b$var$_dec, $eb8bd36764e8d82b$var$_dec2, $eb8bd36764e8d82b$var$_dec3, $eb8bd36764e8d82b$var$_class;
function $eb8bd36764e8d82b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $eb8bd36764e8d82b$var$ProjectCollection = ($eb8bd36764e8d82b$var$_dec = (0, $d8hWe.action).bound, $eb8bd36764e8d82b$var$_dec2 = (0, $d8hWe.action).bound, $eb8bd36764e8d82b$var$_dec3 = (0, $d8hWe.action).bound, $eb8bd36764e8d82b$var$_class = class ProjectCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "projects",
            modelClass: (0, $TkfOD.default)
        });
        this.addLookup("projectsByOwnerId", "manyByKey", {
            key: (t)=>t.ownerId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("projectsByContactId", "manyByKey", {
            key: (t)=>t.contactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("projectsByPrimaryContactId", "manyByKey", {
            key: (t)=>t.primaryContactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("projectsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get projectsById() {
        return this.modelsById;
    }
    get projects() {
        return this.models;
    }
    addProject(data) {
        return this.add(data);
    }
    addProjects(data) {
        return this.addMany(data);
    }
    createProject() {
        const project = this.add({
            name: "New Project",
            costCentreId: (0, $hy8Zj.default).activeCostCentres[0].id,
            milestoneType: "monthly"
        }, {
            trackUpdates: true
        });
        const phase = (0, $9Lw71.default).createPhase(project.id);
        return project;
    }
}, $eb8bd36764e8d82b$var$_applyDecoratedDescriptor($eb8bd36764e8d82b$var$_class.prototype, "addProject", [
    $eb8bd36764e8d82b$var$_dec
], Object.getOwnPropertyDescriptor($eb8bd36764e8d82b$var$_class.prototype, "addProject"), $eb8bd36764e8d82b$var$_class.prototype), $eb8bd36764e8d82b$var$_applyDecoratedDescriptor($eb8bd36764e8d82b$var$_class.prototype, "addProjects", [
    $eb8bd36764e8d82b$var$_dec2
], Object.getOwnPropertyDescriptor($eb8bd36764e8d82b$var$_class.prototype, "addProjects"), $eb8bd36764e8d82b$var$_class.prototype), $eb8bd36764e8d82b$var$_applyDecoratedDescriptor($eb8bd36764e8d82b$var$_class.prototype, "createProject", [
    $eb8bd36764e8d82b$var$_dec3
], Object.getOwnPropertyDescriptor($eb8bd36764e8d82b$var$_class.prototype, "createProject"), $eb8bd36764e8d82b$var$_class.prototype), $eb8bd36764e8d82b$var$_class);
var $eb8bd36764e8d82b$export$2e2bcd8739ae039 = new $eb8bd36764e8d82b$var$ProjectCollection();
const $eb8bd36764e8d82b$export$ca2e4d934c5013d7 = $eb8bd36764e8d82b$var$ProjectCollection;

});
parcelRegister("TkfOD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a64d935b6273374$export$2e2bcd8739ae039; });

var $bwMFl = parcelRequire("bwMFl");

var $dBifK = parcelRequire("dBifK");

var $d8hWe = parcelRequire("d8hWe");

var $5Xh7w = parcelRequire("5Xh7w");

var $4sGvn = parcelRequire("4sGvn");

var $hy8Zj = parcelRequire("hy8Zj");

var $cPDHe = parcelRequire("cPDHe");

var $PIDKX = parcelRequire("PIDKX");

var $9Lw71 = parcelRequire("9Lw71");

var $8sHH3 = parcelRequire("8sHH3");

var $6omGT = parcelRequire("6omGT");

var $lTrDt = parcelRequire("lTrDt");

var $cuB2x = parcelRequire("cuB2x");

var $fqmGV = parcelRequire("fqmGV");
parcelRequire("aJxsR");

var $kdO1A = parcelRequire("kdO1A");

var $itgIJ = parcelRequire("itgIJ");

var $hwZYE = parcelRequire("hwZYE");

var $hKySO = parcelRequire("hKySO");

var $1Nfhh = parcelRequire("1Nfhh");

var $4nGBk = parcelRequire("4nGBk");

var $aZYqt = parcelRequire("aZYqt");

var $fpkTk = parcelRequire("fpkTk");

var $5EjDW = parcelRequire("5EjDW");

var $augzx = parcelRequire("augzx");

var $h8VDI = parcelRequire("h8VDI");

var $k7Nfo = parcelRequire("k7Nfo");

var $egx7S = parcelRequire("egx7S");


var $WdVIM = parcelRequire("WdVIM");
var $0a64d935b6273374$var$_dec, $0a64d935b6273374$var$_dec2, $0a64d935b6273374$var$_dec3, $0a64d935b6273374$var$_class, $0a64d935b6273374$var$_descriptor, $0a64d935b6273374$var$_descriptor2, $0a64d935b6273374$var$_descriptor3, $0a64d935b6273374$var$_descriptor4, $0a64d935b6273374$var$_descriptor5, $0a64d935b6273374$var$_descriptor6, $0a64d935b6273374$var$_descriptor7, $0a64d935b6273374$var$_descriptor8, $0a64d935b6273374$var$_descriptor9, $0a64d935b6273374$var$_descriptor10, $0a64d935b6273374$var$_descriptor11, $0a64d935b6273374$var$_descriptor12, $0a64d935b6273374$var$_descriptor13, $0a64d935b6273374$var$_descriptor14, $0a64d935b6273374$var$_descriptor15, $0a64d935b6273374$var$_descriptor16;
function $0a64d935b6273374$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $0a64d935b6273374$var$_defineProperty(e, r, t) {
    return (r = $0a64d935b6273374$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0a64d935b6273374$var$_toPropertyKey(t) {
    var i = $0a64d935b6273374$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0a64d935b6273374$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0a64d935b6273374$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $0a64d935b6273374$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $0a64d935b6273374$var$ProjectModel = ($0a64d935b6273374$var$_dec = (0, $d8hWe.action).bound, $0a64d935b6273374$var$_dec2 = (0, $d8hWe.action).bound, $0a64d935b6273374$var$_dec3 = (0, $d8hWe.action).bound, $0a64d935b6273374$var$_class = class ProjectModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $0a64d935b6273374$var$_initializerDefineProperty(this, "jobNumber", $0a64d935b6273374$var$_descriptor, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "name", $0a64d935b6273374$var$_descriptor2, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "ownerId", $0a64d935b6273374$var$_descriptor3, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "contactId", $0a64d935b6273374$var$_descriptor4, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "primaryContactId", $0a64d935b6273374$var$_descriptor5, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "costCentreId", $0a64d935b6273374$var$_descriptor6, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "rootPhaseId", $0a64d935b6273374$var$_descriptor7, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "milestoneType", $0a64d935b6273374$var$_descriptor8, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "address", $0a64d935b6273374$var$_descriptor9, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "invoiceRef", $0a64d935b6273374$var$_descriptor10, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "invoiceOpen", $0a64d935b6273374$var$_descriptor11, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "invoiceClose", $0a64d935b6273374$var$_descriptor12, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "durationUnit", $0a64d935b6273374$var$_descriptor13, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "feeData", $0a64d935b6273374$var$_descriptor14, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "_startDate", $0a64d935b6273374$var$_descriptor15, this);
        $0a64d935b6273374$var$_initializerDefineProperty(this, "_endDate", $0a64d935b6273374$var$_descriptor16, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $kdO1A.default);
        this.init(data, options);
    }
    get title() {
        return this.jobNumber && this.name ? `${this.jobNumber}: ${this.name}` : this.name || this.jobNumber;
    }
    get owner() {
        return (0, $lTrDt.default).modelsById[this.ownerId];
    }
    get contact() {
        return (0, $4sGvn.default).modelsById[this.contactId];
    }
    get primaryContact() {
        return (0, $4sGvn.default).modelsById[this.primaryContactId];
    }
    get costCentre() {
        return (0, $hy8Zj.default).modelsById[this.costCentreId];
    }
    get allocations() {
        return (0, $k7Nfo.default).allocationsByProjectId[this.id] || [];
    }
    get dailyAllocations() {
        return (0, $cPDHe.default).dailyAllocationsByProjectId[this.id] || [];
    }
    get rootPhase() {
        return (0, $9Lw71.default).modelsById[this.rootPhaseId] || this.phases.find((ph)=>ph === null || ph === void 0 ? void 0 : ph.isRootPhase) || {
            id: this.rootPhaseId
        };
    }
    get phases() {
        return ((0, $9Lw71.default).phasesByProjectId[this.id] || []).sort((0, $WdVIM.default));
    }
    get expenses() {
        return (0, $8sHH3.default).expensesByProjectId[this.id] || [];
    }
    get expenseAllocations() {
        return (0, $h8VDI.default).expenseAllocationsByProjectId[this.id] || [];
    }
    get rates() {
        return (0, $6omGT.default).ratesByProjectId[this.id] || [];
    }
    get ratesWithOutPhases() {
        return this.rates.filter((r)=>!r.phaseId || r.phase === this.rootPhase);
    }
    get timeEntries() {
        return (0, $cuB2x.default).timeEntriesByProjectId[this.id] || [];
    }
    get invoiceLineItems() {
        return (0, $aZYqt.default).lineItemsByProjectId[this.id] || [];
    }
    get revenueTargets() {
        return (0, $fpkTk.default).revenueTargetsByProjectId[this.id] || [];
    }
    get status() {
        return this._status || (0, $hKySO.statusByPriority)[(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(this.phases.map((ph)=>(0, $hKySO.statusPriorities)[ph.status]))];
    }
    get phaseStatuses() {
        return this.phases.map((ph)=>ph.status);
    }
    get startDate() {
        return this._startDate || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.startDate));
    }
    get endDate() {
        return this._endDate || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.endDate));
    }
    get fee() {
        return this._fee || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.fee));
    }
    get expenseBudget() {
        return this._expenseBudget || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.expenseBudget));
    }
    get hoursBudget() {
        return this._hoursBudget || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.hoursBudget)) || 0;
    }
    get percentLikelihood() {
        return this._percentLikelihood || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).map((ph)=>ph.feeAdjustedByLikelihood)) / this.fee;
    }
    getAggregateInvoiceLineItems(group) {
        return (0, $4nGBk.default).getGroupCollection(group).lineItemsByProjectId[this.id] || [];
    }
    getAggregateTimeEntries(group) {
        return (0, $1Nfhh.default).getGroupCollection(group).timeEntriesByProjectId[this.id] || [];
    }
    get invoices() {
        return (0, $PIDKX.default).invoicesByProjectId[this.id] || [];
    }
    get notes() {
        return (0, $itgIJ.default).notesByProjectId[this.id] || [];
    }
    get changeLog() {
        return (0, $hwZYE.default).changeLogItemsByProjectId[this.id] || [];
    }
    get duration() {
        return (0, $bwMFl.unitsBetween)(this.startDate, this.endDate, this.durationUnit);
    }
    get feeAdjustedByLikelihood() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.phases.map((ph)=>ph.feeAdjustedByLikelihood));
    }
    get budgets() {
        return (0, $5EjDW.default).budgetsByProjectId[this.id] || [];
    }
    get hoursFromBudgets() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.budgets.map((b)=>b.hours));
    }
    get costFromBudgets() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.budgets.map((b)=>b.cost));
    }
    get costRate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.budgets.map((b)=>b.costRate));
    }
    get chargeOutRate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.budgets.map((b)=>b.chargeOutRate));
    }
    get tasks() {
        return (0, $augzx.default).tasksByProjectId[this.id] || [];
    }
    updatePhaseValues(data) {
        this.phases.forEach((ph)=>ph.update(data));
    }
    scaleValueAcrossPhases(prop, value) {
        const total = this[prop];
        const multiplier = total ? value / total : 0;
        const numPhases = this.phases.length;
        this.phases.forEach((ph)=>{
            const data = {};
            data[prop] = multiplier ? ph[prop] * multiplier : value / numPhases;
            ph.update(data);
        });
    // this.update({ [prop]: value })
    }
    scaleDatesAcrossPhases({ startDate: startDate, endDate: endDate, duration: duration }) {
        const newStartDate = startDate !== null && startDate !== void 0 ? startDate : this.startDate;
        const newEndDate = endDate || (duration ? (0, $bwMFl.addUnitToDate)(newStartDate, duration.unit, duration.value) : this.endDate);
        if (newEndDate && newStartDate && this.startDate && this.endDate && this.endDate - this.startDate) {
            const newDuration = (0, $egx7S.startOfDay)(newEndDate) - (0, $egx7S.startOfDay)(newStartDate);
            const oldDuration = (0, $egx7S.startOfDay)(this.endDate) - (0, $egx7S.startOfDay)(this.startDate);
            const multiplier = this.startDate && this.endDate ? newDuration / oldDuration : 0;
            const cachedStartDate = (0, $egx7S.startOfDay)(this.startDate);
            this.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.deletedAt) && !(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>{
                const data = {};
                if (ph.startDate && ph.endDate) {
                    const distanceToStart = (0, $egx7S.startOfDay)(ph.startDate) - cachedStartDate;
                    const newDistanceToStart = distanceToStart * multiplier;
                    const distanceToEnd = (0, $egx7S.startOfDay)(ph.endDate) - cachedStartDate;
                    const newDistanceToEnd = distanceToEnd * multiplier;
                    data.startDate = (0, $egx7S.addMilliseconds)((0, $egx7S.startOfDay)(newStartDate), newDistanceToStart);
                    data.endDate = (0, $egx7S.addMilliseconds)((0, $egx7S.startOfDay)(newStartDate), newDistanceToEnd);
                    ph.update(data);
                }
            });
        } else this.phases.forEach((ph)=>{
            const data = {};
            if (newStartDate) data.startDate = newStartDate;
            if (newEndDate) data.endDate = newEndDate;
            ph.update(data);
        });
        this.update({
            _startDate: newStartDate,
            _endDate: newEndDate
        });
    }
}, $0a64d935b6273374$var$_descriptor = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "jobNumber", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor2 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor3 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "ownerId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor4 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "contactId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor5 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "primaryContactId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor6 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "costCentreId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor7 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "rootPhaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor8 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "milestoneType", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor9 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "address", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor10 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "invoiceRef", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor11 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "invoiceOpen", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor12 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "invoiceClose", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor13 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "durationUnit", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "weeks";
    }
}), $0a64d935b6273374$var$_descriptor14 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "feeData", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor15 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "_startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_descriptor16 = $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "_endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "title", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "title"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "owner", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "owner"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "contact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "contact"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "primaryContact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "primaryContact"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "costCentre"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "allocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "allocations"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "dailyAllocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "dailyAllocations"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "rootPhase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "rootPhase"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "phases", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "phases"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "expenses", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "expenses"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "expenseAllocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "expenseAllocations"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "rates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "rates"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "ratesWithOutPhases", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "ratesWithOutPhases"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "timeEntries", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "timeEntries"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "invoiceLineItems", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "invoiceLineItems"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "revenueTargets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "revenueTargets"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "status", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "status"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "phaseStatuses", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "phaseStatuses"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "startDate"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "endDate"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "fee", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "fee"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "expenseBudget", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "expenseBudget"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "hoursBudget", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "hoursBudget"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "percentLikelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "percentLikelihood"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "getAggregateInvoiceLineItems", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "getAggregateInvoiceLineItems"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "getAggregateTimeEntries", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "getAggregateTimeEntries"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "invoices", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "invoices"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "notes", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "notes"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "changeLog", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "changeLog"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "duration", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "duration"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "feeAdjustedByLikelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "feeAdjustedByLikelihood"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "budgets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "budgets"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "hoursFromBudgets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "hoursFromBudgets"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "costFromBudgets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "costFromBudgets"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "costRate"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "chargeOutRate"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "tasks", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "tasks"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "updatePhaseValues", [
    $0a64d935b6273374$var$_dec
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "updatePhaseValues"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "scaleValueAcrossPhases", [
    $0a64d935b6273374$var$_dec2
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "scaleValueAcrossPhases"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_applyDecoratedDescriptor($0a64d935b6273374$var$_class.prototype, "scaleDatesAcrossPhases", [
    $0a64d935b6273374$var$_dec3
], Object.getOwnPropertyDescriptor($0a64d935b6273374$var$_class.prototype, "scaleDatesAcrossPhases"), $0a64d935b6273374$var$_class.prototype), $0a64d935b6273374$var$_class);
var $0a64d935b6273374$export$2e2bcd8739ae039 = $0a64d935b6273374$var$ProjectModel;

});
parcelRegister("bwMFl", function(module, exports) {

$parcel$export(module.exports, "addDurationToDate", function () { return $86486ede5850aaa6$export$b0b9186f096842bc; });
$parcel$export(module.exports, "subDurationFromDate", function () { return $86486ede5850aaa6$export$2acccb27f7c18e8b; });
$parcel$export(module.exports, "addUnitToDate", function () { return $86486ede5850aaa6$export$e67f4f35bc7fad1f; });
$parcel$export(module.exports, "durationBetween", function () { return $86486ede5850aaa6$export$dac0301a751c64f9; });
$parcel$export(module.exports, "unitsBetween", function () { return $86486ede5850aaa6$export$ff74dd385b40196b; });
$parcel$export(module.exports, "durationToUnit", function () { return $86486ede5850aaa6$export$84baba02af9b54f1; });
$parcel$export(module.exports, "simplifyDuration", function () { return $86486ede5850aaa6$export$85335542364f2c3c; });
$parcel$export(module.exports, "addDurations", function () { return $86486ede5850aaa6$export$d90cff250d80b8d5; });
$parcel$export(module.exports, "subDurations", function () { return $86486ede5850aaa6$export$ab7d8420641701da; });
$parcel$export(module.exports, "multiplyDurationBy", function () { return $86486ede5850aaa6$export$4bb9989206c0c95a; });
$parcel$export(module.exports, "divideDurationBy", function () { return $86486ede5850aaa6$export$b6d8ac47fbe34e37; });
$parcel$export(module.exports, "multiplyDurations", function () { return $86486ede5850aaa6$export$5ca73923d010dd6; });
$parcel$export(module.exports, "divideDurations", function () { return $86486ede5850aaa6$export$45e93477efb4ac86; });
$parcel$export(module.exports, "dividePowerDurationByDuration", function () { return $86486ede5850aaa6$export$51e7136ebb73df6d; });
$parcel$export(module.exports, "simplifyRate", function () { return $86486ede5850aaa6$export$95db8b86ccd412e; });
$parcel$export(module.exports, "ratePerUnit", function () { return $86486ede5850aaa6$export$12664029541be726; });
$parcel$export(module.exports, "addRates", function () { return $86486ede5850aaa6$export$98a0ed8290b61472; });
$parcel$export(module.exports, "subRates", function () { return $86486ede5850aaa6$export$e58bd1b2c8c49236; });
$parcel$export(module.exports, "divideRates", function () { return $86486ede5850aaa6$export$ff03227f9dcbe87b; });
$parcel$export(module.exports, "multiplyRateBy", function () { return $86486ede5850aaa6$export$f666dc173acbafa6; });
$parcel$export(module.exports, "divideRateBy", function () { return $86486ede5850aaa6$export$de24eaed3792859a; });
$parcel$export(module.exports, "multiplyRateByDuration", function () { return $86486ede5850aaa6$export$a85789518397f9c7; });
$parcel$export(module.exports, "divideNumberByRate", function () { return $86486ede5850aaa6$export$b270334d34e4cd72; });
const $86486ede5850aaa6$export$a2dedfdebd31dc15 = (date)=>{
    return date ? new Date(date.getTime ? date.getTime() : date) : date;
};
const $86486ede5850aaa6$export$dc59854f87f8c633 = ()=>new Date(1970, 0, 1);
const $86486ede5850aaa6$export$18bceafa8e89d4f1 = (...args)=>{
    let date;
    for (const arg of args){
        date = new Date(arg && arg.getTime ? arg.getTime() : arg);
        if (date instanceof Date && date.getTime()) break;
    }
    if (!(date instanceof Date) || !date.getTime()) date = $86486ede5850aaa6$export$dc59854f87f8c633();
    return date;
};
const $86486ede5850aaa6$var$millisecondsMs = 1;
const $86486ede5850aaa6$var$secondsMs = 1000;
const $86486ede5850aaa6$var$minutesMs = $86486ede5850aaa6$var$secondsMs * 60;
const $86486ede5850aaa6$var$hoursMs = $86486ede5850aaa6$var$minutesMs * 60;
const $86486ede5850aaa6$var$daysMs = $86486ede5850aaa6$var$hoursMs * 24;
const $86486ede5850aaa6$var$weeksMs = $86486ede5850aaa6$var$daysMs * 7;
const $86486ede5850aaa6$var$yearsMs = $86486ede5850aaa6$var$daysMs * 365.25;
const $86486ede5850aaa6$var$monthsMs = $86486ede5850aaa6$var$yearsMs / 12;
const $86486ede5850aaa6$export$777ea3b65ea6cd37 = {
    milliseconds: $86486ede5850aaa6$var$millisecondsMs,
    seconds: $86486ede5850aaa6$var$secondsMs,
    minutes: $86486ede5850aaa6$var$minutesMs,
    hours: $86486ede5850aaa6$var$hoursMs,
    days: $86486ede5850aaa6$var$daysMs,
    weeks: $86486ede5850aaa6$var$weeksMs,
    months: $86486ede5850aaa6$var$monthsMs,
    years: $86486ede5850aaa6$var$yearsMs
};
const $86486ede5850aaa6$export$7f410c9d36db5855 = [
    "milliseconds",
    "seconds",
    "minutes",
    "hours",
    "days",
    "months",
    "years"
];
const $86486ede5850aaa6$export$5af1a5e21a4153cd = [
    "milliseconds",
    "seconds",
    "minutes",
    "hours"
];
const $86486ede5850aaa6$export$c0d5be433dca6a61 = {
    milliseconds: (date)=>date.getMilliseconds(),
    seconds: (date)=>date.getSeconds(),
    minutes: (date)=>date.getMinutes(),
    hours: (date)=>date.getHours(),
    days: (date)=>date.getDate(),
    months: (date)=>date.getMonth(),
    years: (date)=>date.getFullYear()
};
const $86486ede5850aaa6$export$ddd519109d59f0c0 = {
    milliseconds: (date, val)=>$86486ede5850aaa6$export$18bceafa8e89d4f1(date.setMilliseconds(val)),
    seconds: (date, val)=>$86486ede5850aaa6$export$18bceafa8e89d4f1(date.setSeconds(val)),
    minutes: (date, val)=>$86486ede5850aaa6$export$18bceafa8e89d4f1(date.setMinutes(val)),
    hours: (date, val)=>$86486ede5850aaa6$export$18bceafa8e89d4f1(date.setHours(val)),
    days: (date, val)=>$86486ede5850aaa6$export$18bceafa8e89d4f1(date.setDate(val)),
    months: (date, val)=>$86486ede5850aaa6$export$18bceafa8e89d4f1(date.setMonth(val)),
    years: (date, val)=>$86486ede5850aaa6$export$18bceafa8e89d4f1(date.setFullYear(val))
};
const $86486ede5850aaa6$export$b8af2f8c53d557f5 = {
    milliseconds: null,
    seconds: "milliseconds",
    minutes: "seconds",
    hours: "minutes",
    days: "hours",
    months: "days",
    years: "months"
};
const $86486ede5850aaa6$export$a9b3c5dc6730b3ca = {
    milliseconds: "seconds",
    seconds: "minutes",
    minutes: "hours",
    hours: "days",
    days: "months",
    months: "years",
    years: null
};
const $86486ede5850aaa6$export$cdc30aac289e199f = {
    milliseconds: (date)=>date.getMilliseconds() === $86486ede5850aaa6$export$156b9d843f318f59.milliseconds(date) - 1,
    seconds: (date)=>date.getSeconds() === $86486ede5850aaa6$export$156b9d843f318f59.seconds(date) - 1,
    minutes: (date)=>date.getMinutes() === $86486ede5850aaa6$export$156b9d843f318f59.minutes(date) - 1,
    hours: (date)=>date.getHours() === $86486ede5850aaa6$export$156b9d843f318f59.hours(date) - 1,
    days: (date)=>date.getDate() === $86486ede5850aaa6$export$156b9d843f318f59.days(date),
    months: (date)=>date.getMonth() === $86486ede5850aaa6$export$156b9d843f318f59.months(date) - 1,
    years: (date)=>false
};
const $86486ede5850aaa6$export$156b9d843f318f59 = {
    milliseconds: (date)=>1000,
    seconds: (date)=>60,
    minutes: (date)=>60,
    hours: (date)=>$86486ede5850aaa6$export$312b4fb286fbf746(date),
    days: (date)=>$86486ede5850aaa6$export$4169ecd548fbc13a(date),
    months: (date)=>12,
    years: (date)=>Infinity
};
const $86486ede5850aaa6$export$91484f0a85192b80 = {
    milliseconds: 0,
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 1,
    months: 0,
    years: 1
};
const $86486ede5850aaa6$export$312b4fb286fbf746 = (date)=>{
    const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const dayAfter = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    return (dayAfter - startOfDay) / $86486ede5850aaa6$var$hoursMs;
};
const $86486ede5850aaa6$export$4169ecd548fbc13a = (date)=>{
    // next month -1 day
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};
const $86486ede5850aaa6$export$fad1291dbb043924 = (startDate, endDate, unit)=>{
    startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(startDate);
    endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(endDate);
    // if a date is at the end of a month and can screw up future calculations
    // as the length of an month can vary - same with day length
    const adjustDay = !unit || unit === "months";
    const adjustHour = !unit || unit === "days";
    // if date is the end of the month we can move backwards 3 days
    // as every month has at least 28 days
    // note: we need to move the date backwards not forwards
    // as 31 Jan -> 28/29 Feb (01 Jan-01 Feb) would end up being 1 month long
    // and will break when adding a duration to a date, ie. 31 Jan + 1 month = 02 March
    let addHours = (adjustDay && $86486ede5850aaa6$export$cdc30aac289e199f["days"](startDate) ? -75 : 0) + // 25 hours to account for dst
    (adjustHour && $86486ede5850aaa6$export$cdc30aac289e199f["hours"](startDate) ? -2 : 0);
    if (addHours) {
        startDate = new Date(startDate.getTime() + addHours * $86486ede5850aaa6$export$777ea3b65ea6cd37["hours"]);
        endDate = new Date(endDate.getTime() + addHours * $86486ede5850aaa6$export$777ea3b65ea6cd37["hours"]);
    }
    return {
        startDate: startDate,
        endDate: endDate
    };
};
const $86486ede5850aaa6$export$92ef078ca7486c9 = (startDate, endDate, unit)=>{
    startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(startDate);
    endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(endDate);
    let fullUnitEndDate = $86486ede5850aaa6$export$a2dedfdebd31dc15(endDate);
    // to make the end date whole units distance away from the start
    // we make all smaller values equal to the start value
    let childUnit = $86486ede5850aaa6$export$b8af2f8c53d557f5[unit];
    while(childUnit){
        // end of month/day can a problem here if not adjusted prior
        fullUnitEndDate = $86486ede5850aaa6$export$ddd519109d59f0c0[childUnit](fullUnitEndDate, $86486ede5850aaa6$export$c0d5be433dca6a61[childUnit](startDate));
        childUnit = $86486ede5850aaa6$export$b8af2f8c53d557f5[childUnit];
    }
    // if the endDate unit in the opposite direction to the date direction
    // we will have accidently moved the dates outside the original range
    // and need to adjust by +/- 1 unit to move it back withing the range
    const direction = Math.sign(endDate - startDate) || 1;
    const newDirection = Math.sign(fullUnitEndDate - endDate);
    if (newDirection && direction == newDirection) fullUnitEndDate = $86486ede5850aaa6$export$ddd519109d59f0c0[unit](fullUnitEndDate, $86486ede5850aaa6$export$c0d5be433dca6a61[unit](endDate) - direction);
    return fullUnitEndDate;
};
const $86486ede5850aaa6$export$e2712fcf05dd337f = (duration)=>{
    const days = duration.days;
    duration.weeks = Math.trunc(days / 7);
    duration.days = days - duration.weeks * 7;
    return duration;
};
const $86486ede5850aaa6$export$1c9cfa9873a168c2 = (duration)=>{
    return $86486ede5850aaa6$export$bf567c9b3ce5f8ca({
        ...$86486ede5850aaa6$export$95fc0d6fa0606c9f,
        ...duration
    });
};
const $86486ede5850aaa6$export$bf567c9b3ce5f8ca = (duration)=>{
    if (duration.dateRef || "dateRef" in duration) Object.defineProperty(duration, "dateRef", {
        enumerable: false,
        value: duration.dateRef
    });
    return duration;
};
const $86486ede5850aaa6$export$2b6d965b96c60588 = (duration)=>$86486ede5850aaa6$export$bf567c9b3ce5f8ca({
        ...duration
    });
const $86486ede5850aaa6$export$95fc0d6fa0606c9f = $86486ede5850aaa6$export$bf567c9b3ce5f8ca({
    dateRef: null,
    milliseconds: 0,
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 0,
    weeks: 0,
    months: 0,
    years: 0
});
const $86486ede5850aaa6$export$b0b9186f096842bc = (date, duration)=>{
    date = $86486ede5850aaa6$export$18bceafa8e89d4f1(date);
    duration = $86486ede5850aaa6$export$1c9cfa9873a168c2(duration);
    const months = duration.years * 12 + duration.months;
    const partialMonths = months % 1;
    const days = duration.weeks * 7 + duration.days;
    const partialDays = days % 1;
    const partialHours = duration.hours % 1;
    const partialMinutes = duration.minutes % 1;
    const partialSeconds = duration.seconds % 1;
    // set date, month, year will always round to lowest integer
    // so we need to add the milliseconds for partial months
    date.setMonth(date.getMonth() + duration.years * 12 + duration.months);
    date.setDate(date.getDate() + duration.weeks * 7 + duration.days);
    date.setHours(date.getHours() + duration.hours, date.getMinutes() + duration.minutes, date.getSeconds() + duration.seconds, date.getMilliseconds() + duration.milliseconds + partialSeconds * $86486ede5850aaa6$export$777ea3b65ea6cd37["seconds"] + partialMinutes * $86486ede5850aaa6$export$777ea3b65ea6cd37["minutes"] + partialHours * $86486ede5850aaa6$export$777ea3b65ea6cd37["hours"] + partialDays * $86486ede5850aaa6$export$777ea3b65ea6cd37["days"] + partialMonths * $86486ede5850aaa6$export$777ea3b65ea6cd37["months"]);
    return date;
};
const $86486ede5850aaa6$export$2acccb27f7c18e8b = (date, duration)=>{
    date = $86486ede5850aaa6$export$18bceafa8e89d4f1(date);
    duration = $86486ede5850aaa6$export$1c9cfa9873a168c2(duration);
    const months = duration.years * 12 + duration.months;
    const partialMonths = months % 1;
    const days = duration.weeks * 7 + duration.days;
    const partialDays = days % 1;
    const partialHours = duration.hours % 1;
    const partialMinutes = duration.minutes % 1;
    const partialSeconds = duration.seconds % 1;
    // set date, month, year will always round to lowest integer
    // so we need to add the milliseconds for partial months
    date.setMonth(date.getMonth() - duration.years * 12 - duration.months);
    date.setDate(date.getDate() - duration.weeks * 7 - duration.days);
    date.setHours(date.getHours() - duration.hours, date.getMinutes() - duration.minutes, date.getSeconds() - duration.seconds, date.getMilliseconds() - duration.milliseconds - partialSeconds * $86486ede5850aaa6$export$777ea3b65ea6cd37["seconds"] - partialMinutes * $86486ede5850aaa6$export$777ea3b65ea6cd37["minutes"] - partialHours * $86486ede5850aaa6$export$777ea3b65ea6cd37["hours"] - partialDays * $86486ede5850aaa6$export$777ea3b65ea6cd37["days"] - partialMonths * $86486ede5850aaa6$export$777ea3b65ea6cd37["months"]);
    return date;
};
const $86486ede5850aaa6$export$e67f4f35bc7fad1f = (date, unit, value)=>{
    let duration = {};
    duration[unit] = value;
    return $86486ede5850aaa6$export$b0b9186f096842bc(date, duration);
};
const $86486ede5850aaa6$export$9056ed762f6403cc = (date, unit, value)=>{
    let duration = {};
    duration[unit] = value;
    return $86486ede5850aaa6$export$2acccb27f7c18e8b(date, duration);
};
const $86486ede5850aaa6$export$1afec20c5ef2a9c5 = (_startDate, _endDate, unit, multiple = 1)=>{
    _startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(_startDate);
    _endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(_endDate);
    if (unit === "weeks") {
        unit = "days";
        multiple = 7;
    }
    const multiUnit = $86486ede5850aaa6$export$777ea3b65ea6cd37[unit] * multiple;
    // everything below is unecessary work for standard units of time
    if ($86486ede5850aaa6$export$5af1a5e21a4153cd.includes(unit)) return Math.trunc((_endDate - _startDate) / multiUnit);
    let { startDate: startDate, endDate: endDate } = $86486ede5850aaa6$export$fad1291dbb043924(_startDate, _endDate, unit);
    // move the end date to be whole units away from the start date
    const fullUnitEndDate = $86486ede5850aaa6$export$92ef078ca7486c9(startDate, endDate, unit);
    // although units like days and months can have inconsistant values
    // we know the end date is whole units away from the start
    // and variance in those values are never large enough to cause issue
    // so we can just round the average value
    const fullUnitMs = fullUnitEndDate - startDate;
    let fullUnits = Math.round(fullUnitMs / $86486ede5850aaa6$export$777ea3b65ea6cd37[unit]);
    fullUnits = Math.trunc(fullUnits * $86486ede5850aaa6$export$777ea3b65ea6cd37[unit] / multiUnit);
    return fullUnits;
};
const $86486ede5850aaa6$export$dac0301a751c64f9 = (_startDate, _endDate)=>{
    _startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(_startDate);
    _endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(_endDate);
    let { startDate: startDate, endDate: endDate } = $86486ede5850aaa6$export$fad1291dbb043924(_startDate, _endDate);
    let duration = {
        ...$86486ede5850aaa6$export$95fc0d6fa0606c9f
    };
    duration.dateRef = $86486ede5850aaa6$export$a2dedfdebd31dc15(_startDate);
    const units = [
        ...$86486ede5850aaa6$export$7f410c9d36db5855
    ].reverse();
    units.forEach((unit)=>{
        duration[unit] = $86486ede5850aaa6$export$1afec20c5ef2a9c5(startDate, endDate, unit);
        startDate = $86486ede5850aaa6$export$ddd519109d59f0c0[unit](startDate, $86486ede5850aaa6$export$c0d5be433dca6a61[unit](startDate) + duration[unit]);
    });
    duration = $86486ede5850aaa6$export$e2712fcf05dd337f(duration);
    return duration;
};
const $86486ede5850aaa6$export$9e69f402df51415c = (duration, dateRef)=>{
    let startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(dateRef, duration.dateRef);
    let endDate = $86486ede5850aaa6$export$b0b9186f096842bc(startDate, duration);
    return $86486ede5850aaa6$export$dac0301a751c64f9(startDate, endDate);
};
const $86486ede5850aaa6$export$ff74dd385b40196b = (startDate, endDate, unit, multiple = 1)=>{
    if (unit === "weeks") {
        unit = "days";
        multiple = 7;
    }
    startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(startDate);
    endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(endDate);
    const multiUnit = $86486ede5850aaa6$export$777ea3b65ea6cd37[unit] * multiple;
    const fullUnits = $86486ede5850aaa6$export$1afec20c5ef2a9c5(startDate, endDate, unit, multiple);
    const fullUnitMs = fullUnits * multiUnit;
    const partialUnitMs = endDate - startDate - fullUnitMs;
    const partialUnits = partialUnitMs / multiUnit;
    return fullUnits + partialUnits;
};
const $86486ede5850aaa6$export$84baba02af9b54f1 = (duration, unit, multiple = 1, dateRef)=>{
    let startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(dateRef, duration.dateRef);
    startDate = $86486ede5850aaa6$export$a2dedfdebd31dc15(startDate);
    let endDate = $86486ede5850aaa6$export$b0b9186f096842bc(startDate, duration);
    return $86486ede5850aaa6$export$ff74dd385b40196b(startDate, endDate, unit, multiple);
};
const $86486ede5850aaa6$export$d1b23051d75c72d = (_startDate, _endDate)=>{
    _startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(_startDate);
    _endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(_endDate);
    let duration = {};
    duration.dateRef = $86486ede5850aaa6$export$a2dedfdebd31dc15(_startDate);
    let smallestUnit = null;
    let parentUnit = $86486ede5850aaa6$export$a9b3c5dc6730b3ca["milliseconds"];
    let unitVal = 0;
    while(parentUnit){
        const units = $86486ede5850aaa6$export$ff74dd385b40196b(_startDate, _endDate, parentUnit);
        if (units && units % 1 === 0) {
            smallestUnit = parentUnit;
            unitVal = units;
            parentUnit = $86486ede5850aaa6$export$a9b3c5dc6730b3ca[parentUnit];
        } else {
            parentUnit = null;
            break;
        }
    }
    // set to milliseconds if no results
    smallestUnit = smallestUnit || "milliseconds";
    unitVal = unitVal || _endDate - _startDate;
    // check weeks
    if (smallestUnit === "days" && unitVal % 7 === 0) {
        smallestUnit = "weeks";
        unitVal = unitVal / 7;
    }
    duration[smallestUnit] = unitVal;
    return $86486ede5850aaa6$export$bf567c9b3ce5f8ca(duration);
};
const $86486ede5850aaa6$export$85335542364f2c3c = (duration, dateRef)=>{
    let startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(dateRef, duration.dateRef);
    let endDate = $86486ede5850aaa6$export$b0b9186f096842bc(startDate, duration);
    return $86486ede5850aaa6$export$d1b23051d75c72d(startDate, endDate);
};
const $86486ede5850aaa6$export$e0bda707f0133070 = (duration1, duration2)=>{
    duration1 = $86486ede5850aaa6$export$85335542364f2c3c(duration1);
    duration2 = $86486ede5850aaa6$export$85335542364f2c3c(duration2);
    const duration1Unit = Object.keys(duration1)[0];
    const duration2Unit = Object.keys(duration2)[0];
    const duration2Amount = $86486ede5850aaa6$export$84baba02af9b54f1(duration2, duration1Unit);
    let newDuration2 = {};
    newDuration2[duration1Unit] = duration2Amount;
    return [
        duration1,
        newDuration2
    ];
};
const $86486ede5850aaa6$export$d90cff250d80b8d5 = (leftDuration, rightDuration)=>{
    leftDuration = $86486ede5850aaa6$export$1c9cfa9873a168c2(leftDuration);
    rightDuration = $86486ede5850aaa6$export$1c9cfa9873a168c2(rightDuration);
    Object.keys(leftDuration).forEach((unit)=>leftDuration[unit] += rightDuration[unit]);
    leftDuration.dateRef = leftDuration.dateRef || rightDuration.dateRef && $86486ede5850aaa6$export$2acccb27f7c18e8b(rightDuration.dateRef, rightDuration);
    return $86486ede5850aaa6$export$9e69f402df51415c(leftDuration);
};
const $86486ede5850aaa6$export$ab7d8420641701da = (leftDuration, rightDuration)=>{
    leftDuration = $86486ede5850aaa6$export$1c9cfa9873a168c2(leftDuration);
    rightDuration = $86486ede5850aaa6$export$1c9cfa9873a168c2(rightDuration);
    Object.keys(leftDuration).forEach((unit)=>leftDuration[unit] -= rightDuration[unit]);
    leftDuration.dateRef = leftDuration.dateRef || rightDuration.dateRef && $86486ede5850aaa6$export$b0b9186f096842bc(rightDuration.dateRef, rightDuration);
    return $86486ede5850aaa6$export$9e69f402df51415c(leftDuration);
};
const $86486ede5850aaa6$export$4bb9989206c0c95a = (duration, multiplier)=>{
    duration = $86486ede5850aaa6$export$2b6d965b96c60588(duration);
    Object.keys(duration).forEach((unit)=>duration[unit] *= multiplier);
    return $86486ede5850aaa6$export$9e69f402df51415c(duration);
};
const $86486ede5850aaa6$export$b6d8ac47fbe34e37 = (duration, divider)=>{
    duration = $86486ede5850aaa6$export$2b6d965b96c60588(duration);
    Object.keys(duration).forEach((unit)=>duration[unit] /= divider);
    return $86486ede5850aaa6$export$9e69f402df51415c(duration);
};
const $86486ede5850aaa6$export$d87c1c5f4a8ec3d9 = (duration, transformer = (unit, val)=>val)=>{
    duration = $86486ede5850aaa6$export$2b6d965b96c60588(duration);
    Object.keys(duration).forEach((unit)=>duration[unit] = transformer(unit, duration[unit]));
    return $86486ede5850aaa6$export$9e69f402df51415c(duration);
};
const $86486ede5850aaa6$export$5ca73923d010dd6 = (leftDuration, rightDuration)=>{
    const [lDuration, rDuration] = $86486ede5850aaa6$export$e0bda707f0133070(leftDuration, rightDuration);
    const unit = Object.keys(lDuration)[0];
    const amount = lDuration[unit] *= rDuration[unit];
    let duration = {};
    duration[unit] = amount;
    // powerDuration
    return {
        duration: duration,
        power: 2
    };
};
const $86486ede5850aaa6$export$45e93477efb4ac86 = (leftDuration, rightDuration)=>{
    const [lDuration, rDuration] = $86486ede5850aaa6$export$e0bda707f0133070(leftDuration, rightDuration);
    const unit = Object.keys(lDuration)[0];
    return lDuration[unit] / rDuration[unit];
};
const $86486ede5850aaa6$export$51e7136ebb73df6d = (powerDuration, duration)=>{
    const powerDurationVal = $86486ede5850aaa6$export$2b6d965b96c60588(powerDuration.duration);
    const unit = Object.keys(powerDurationVal)[0];
    const divider = $86486ede5850aaa6$export$84baba02af9b54f1(duration, unit);
    const amount = powerDurationVal[unit] / divider;
    let newDuration = {};
    newDuration[unit] = amount;
    const power = powerDuration.power - 1;
    if (power === 1) return newDuration;
    else if (power === 0) return amount;
    else return {
        duration: newDuration,
        power: 2
    };
};
const $86486ede5850aaa6$export$3f7975928575e3ba = (rate)=>({
        amount: rate.amount,
        per: $86486ede5850aaa6$export$2b6d965b96c60588(rate.per)
    });
const $86486ede5850aaa6$export$2244e9cd1ae0b12 = $86486ede5850aaa6$export$3f7975928575e3ba({
    amount: 1,
    per: {
        hours: 1
    }
});
const $86486ede5850aaa6$export$95db8b86ccd412e = (rate)=>{
    rate = $86486ede5850aaa6$export$3f7975928575e3ba(rate);
    rate.per = $86486ede5850aaa6$export$85335542364f2c3c(rate.per);
    const durationUnit = Object.keys(rate.per)[0];
    const durationAmount = Object.values(rate.per)[0];
    rate.amount /= durationAmount;
    rate.per[durationUnit] = 1;
    return rate;
};
const $86486ede5850aaa6$export$2d12575a603cb209 = (rate1, rate2)=>{
    rate1 = $86486ede5850aaa6$export$95db8b86ccd412e(rate1);
    rate2 = $86486ede5850aaa6$export$95db8b86ccd412e(rate2);
    const rate1Unit = Object.keys(rate1.per)[0];
    const rate2Divider = $86486ede5850aaa6$export$84baba02af9b54f1(rate2.per, rate1Unit);
    rate2.amount /= rate2Divider;
    rate2.per = rate1.per;
    return [
        rate1,
        rate2
    ];
};
const $86486ede5850aaa6$export$12664029541be726 = (rate, unit)=>{
    rate = $86486ede5850aaa6$export$95db8b86ccd412e(rate);
    const divider = $86486ede5850aaa6$export$84baba02af9b54f1(rate.per, unit);
    rate.amount /= divider;
    let duration = {};
    duration[unit] = 1;
    rate.per = duration;
    return rate;
};
const $86486ede5850aaa6$export$98a0ed8290b61472 = (leftRate, rightRate)=>{
    const [lRate, rRate] = $86486ede5850aaa6$export$2d12575a603cb209(leftRate, rightRate);
    lRate.amount += rRate.amount;
    return lRate;
};
const $86486ede5850aaa6$export$e58bd1b2c8c49236 = (leftRate, rightRate)=>{
    const [lRate, rRate] = $86486ede5850aaa6$export$2d12575a603cb209(leftRate, rightRate);
    lRate.amount -= rRate.amount;
    return lRate;
};
const $86486ede5850aaa6$export$ff03227f9dcbe87b = (leftRate, rightRate)=>{
    const [lRate, rRate] = $86486ede5850aaa6$export$2d12575a603cb209(leftRate, rightRate);
    const diff = lRate.amount / rRate.amount;
    return diff;
};
const $86486ede5850aaa6$export$f666dc173acbafa6 = (rate, multiplier)=>{
    rate = $86486ede5850aaa6$export$3f7975928575e3ba(rate);
    rate.amount *= multiplier;
    return rate;
};
const $86486ede5850aaa6$export$de24eaed3792859a = (rate, divider)=>{
    rate = $86486ede5850aaa6$export$3f7975928575e3ba(rate);
    rate.amount /= divider;
    return rate;
};
const $86486ede5850aaa6$export$a85789518397f9c7 = (rate, duration)=>{
    rate = $86486ede5850aaa6$export$95db8b86ccd412e(rate);
    duration = $86486ede5850aaa6$export$85335542364f2c3c(duration);
    let amount = rate.amount / $86486ede5850aaa6$export$777ea3b65ea6cd37[Object.keys(rate.per)[0]];
    amount *= $86486ede5850aaa6$export$777ea3b65ea6cd37[Object.keys(duration)[0]];
    amount *= Object.values(duration)[0];
    return amount;
};
const $86486ede5850aaa6$export$b270334d34e4cd72 = (number, rate)=>{
    rate = $86486ede5850aaa6$export$95db8b86ccd412e(rate);
    number /= rate.amount;
    const unit = Object.keys(rate.per)[0];
    let duration = {};
    duration[unit] = number;
    return duration;
};
const $86486ede5850aaa6$export$20c62bd0d1d0a26e = (number, duration)=>{
    return $86486ede5850aaa6$export$3f7975928575e3ba({
        amount: number,
        duration: duration
    });
};
const $86486ede5850aaa6$export$e60d4db9f4b84ec2 = (date, unit, multiple = 1)=>{
    date = $86486ede5850aaa6$export$18bceafa8e89d4f1(date);
    let childUnit = $86486ede5850aaa6$export$b8af2f8c53d557f5[unit];
    date = $86486ede5850aaa6$export$ddd519109d59f0c0[unit](date, Math.round($86486ede5850aaa6$export$c0d5be433dca6a61[unit](date) / multiple) * multiple);
    while(childUnit){
        date = $86486ede5850aaa6$export$ddd519109d59f0c0[childUnit](date, $86486ede5850aaa6$export$91484f0a85192b80[childUnit]);
        childUnit = $86486ede5850aaa6$export$b8af2f8c53d557f5[childUnit];
    }
    return date;
};
const $86486ede5850aaa6$export$8da934faffadeb57 = (date, unit, multiple = 1)=>{
    date = $86486ede5850aaa6$export$18bceafa8e89d4f1(date);
    date = $86486ede5850aaa6$export$ddd519109d59f0c0[unit](date, Math.ceil($86486ede5850aaa6$export$c0d5be433dca6a61[unit](date) / multiple) * multiple);
    let childUnit = $86486ede5850aaa6$export$b8af2f8c53d557f5[unit];
    while(childUnit){
        date = $86486ede5850aaa6$export$ddd519109d59f0c0[childUnit](date, $86486ede5850aaa6$export$91484f0a85192b80[childUnit]);
        childUnit = $86486ede5850aaa6$export$b8af2f8c53d557f5[childUnit];
    }
    return date;
};
const $86486ede5850aaa6$export$d0913359021b586f = (date, unit, multiple = 1)=>{
    date = $86486ede5850aaa6$export$18bceafa8e89d4f1(date);
    date = $86486ede5850aaa6$export$ddd519109d59f0c0[unit](date, Math.floor($86486ede5850aaa6$export$c0d5be433dca6a61[unit](date) / multiple) * multiple);
    let childUnit = $86486ede5850aaa6$export$b8af2f8c53d557f5[unit];
    while(childUnit){
        date = $86486ede5850aaa6$export$ddd519109d59f0c0[childUnit](date, $86486ede5850aaa6$export$91484f0a85192b80[childUnit]);
        childUnit = $86486ede5850aaa6$export$b8af2f8c53d557f5[childUnit];
    }
    return date;
};
const $86486ede5850aaa6$export$d8301f5de55672c9 = (date)=>{
    date = $86486ede5850aaa6$export$18bceafa8e89d4f1(date);
    let time = $86486ede5850aaa6$export$bf567c9b3ce5f8ca({
        dateRef: date
    });
    time.milliseconds = date.getMilliseconds();
    time.seconds = date.getSeconds();
    time.minutes = date.getMinutes();
    time.hours = date.getHours();
    return time;
};
const $86486ede5850aaa6$export$764ba8036fcce0e3 = (duration)=>{
    if (duration.milliseconds) return "milliseconds";
    if (duration.seconds) return "seconds";
    if (duration.minutes) return "minutes";
    if (duration.hours) return "hours";
};
const $86486ede5850aaa6$export$92e65f3ca6530903 = (date = $86486ede5850aaa6$export$dc59854f87f8c633())=>{
    return $86486ede5850aaa6$export$764ba8036fcce0e3($86486ede5850aaa6$export$d8301f5de55672c9(date));
};
const $86486ede5850aaa6$export$8a67e5f02235bd2c = (startDate, endDate, unit)=>{
    startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(startDate);
    endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $86486ede5850aaa6$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) < unitGetter(endDate);
};
const $86486ede5850aaa6$export$5dc2f18373ae7329 = (startDate, endDate, unit)=>{
    startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(startDate);
    endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $86486ede5850aaa6$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) <= unitGetter(endDate);
};
const $86486ede5850aaa6$export$512696a08ac73d4d = (startDate, endDate, unit)=>{
    startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(startDate);
    endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $86486ede5850aaa6$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) === unitGetter(endDate);
};
const $86486ede5850aaa6$export$6e6463d72f3ccf14 = (startDate, endDate, unit)=>{
    startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(startDate);
    endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $86486ede5850aaa6$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) > unitGetter(endDate);
};
const $86486ede5850aaa6$export$eac74d983cdc83ae = (startDate, endDate, unit)=>{
    startDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(startDate);
    endDate = $86486ede5850aaa6$export$18bceafa8e89d4f1(endDate);
    let unitGetter = $86486ede5850aaa6$export$c0d5be433dca6a61[unit];
    return unitGetter(startDate) >= unitGetter(endDate);
};

});

parcelRegister("5Xh7w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $455fbe276de9d62b$var$constants;
(function(constants) {
    constants.typeOfFunction = "function";
    constants.boolTrue = true;
})($455fbe276de9d62b$var$constants || ($455fbe276de9d62b$var$constants = {}));
function $455fbe276de9d62b$var$bind(target, propertyKey, descriptor) {
    if (!descriptor || typeof descriptor.value !== $455fbe276de9d62b$var$constants.typeOfFunction) throw new TypeError("Only methods can be decorated with @bind. <" + propertyKey + "> is not a method!");
    return {
        configurable: $455fbe276de9d62b$var$constants.boolTrue,
        get: function() {
            var bound = descriptor.value.bind(this);
            // Credits to https://github.com/andreypopp/autobind-decorator for memoizing the result of bind against a symbol on the instance.
            Object.defineProperty(this, propertyKey, {
                value: bound,
                configurable: $455fbe276de9d62b$var$constants.boolTrue,
                writable: $455fbe276de9d62b$var$constants.boolTrue
            });
            return bound;
        }
    };
}
module.exports.bind = $455fbe276de9d62b$var$bind;
module.exports.default = $455fbe276de9d62b$var$bind;

});

parcelRegister("4sGvn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33fabf96a038343e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ContactCollectionClass", function () { return $33fabf96a038343e$export$d0c905c7685a030c; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $dFLbx = parcelRequire("dFLbx");
var $33fabf96a038343e$var$_dec, $33fabf96a038343e$var$_dec2, $33fabf96a038343e$var$_dec3, $33fabf96a038343e$var$_class;
function $33fabf96a038343e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $33fabf96a038343e$var$ContactCollection = ($33fabf96a038343e$var$_dec = (0, $d8hWe.action).bound, $33fabf96a038343e$var$_dec2 = (0, $d8hWe.action).bound, $33fabf96a038343e$var$_dec3 = (0, $d8hWe.action).bound, $33fabf96a038343e$var$_class = class ContactCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "contacts",
            modelClass: (0, $dFLbx.default)
        });
        this.addLookup("contactsByAccountingSystemId", "uniqueByKey", {
            key: (t)=>t.accountingSystemContactId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get contactsById() {
        return this.modelsById;
    }
    get contacts() {
        return this.models;
    }
    get contactsById() {
        return this.modelsById;
    }
    addContact(data) {
        this.add(data);
    }
    addContacts(data) {
        this.addMany(data);
    }
    createContact() {
        const contact = this.add({
            trackUpdates: true
        });
        return contact;
    }
}, $33fabf96a038343e$var$_applyDecoratedDescriptor($33fabf96a038343e$var$_class.prototype, "addContact", [
    $33fabf96a038343e$var$_dec
], Object.getOwnPropertyDescriptor($33fabf96a038343e$var$_class.prototype, "addContact"), $33fabf96a038343e$var$_class.prototype), $33fabf96a038343e$var$_applyDecoratedDescriptor($33fabf96a038343e$var$_class.prototype, "addContacts", [
    $33fabf96a038343e$var$_dec2
], Object.getOwnPropertyDescriptor($33fabf96a038343e$var$_class.prototype, "addContacts"), $33fabf96a038343e$var$_class.prototype), $33fabf96a038343e$var$_applyDecoratedDescriptor($33fabf96a038343e$var$_class.prototype, "createContact", [
    $33fabf96a038343e$var$_dec3
], Object.getOwnPropertyDescriptor($33fabf96a038343e$var$_class.prototype, "createContact"), $33fabf96a038343e$var$_class.prototype), $33fabf96a038343e$var$_class);
var $33fabf96a038343e$export$2e2bcd8739ae039 = new $33fabf96a038343e$var$ContactCollection();
const $33fabf96a038343e$export$d0c905c7685a030c = $33fabf96a038343e$var$ContactCollection;

});
parcelRegister("dFLbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f43b4b096afca59$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $4sGvn = parcelRequire("4sGvn");

var $PIDKX = parcelRequire("PIDKX");

var $kdO1A = parcelRequire("kdO1A");

var $fqmGV = parcelRequire("fqmGV");
var $9f43b4b096afca59$var$_class, $9f43b4b096afca59$var$_descriptor, $9f43b4b096afca59$var$_descriptor2, $9f43b4b096afca59$var$_descriptor3, $9f43b4b096afca59$var$_descriptor4, $9f43b4b096afca59$var$_descriptor5, $9f43b4b096afca59$var$_descriptor6, $9f43b4b096afca59$var$_descriptor7, $9f43b4b096afca59$var$_descriptor8;
function $9f43b4b096afca59$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $9f43b4b096afca59$var$_defineProperty(e, r, t) {
    return (r = $9f43b4b096afca59$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9f43b4b096afca59$var$_toPropertyKey(t) {
    var i = $9f43b4b096afca59$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9f43b4b096afca59$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9f43b4b096afca59$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $9f43b4b096afca59$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $9f43b4b096afca59$var$ContactModel = ($9f43b4b096afca59$var$_class = class ContactModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $9f43b4b096afca59$var$_initializerDefineProperty(this, "firstName", $9f43b4b096afca59$var$_descriptor, this);
        $9f43b4b096afca59$var$_initializerDefineProperty(this, "lastName", $9f43b4b096afca59$var$_descriptor2, this);
        $9f43b4b096afca59$var$_initializerDefineProperty(this, "organisationName", $9f43b4b096afca59$var$_descriptor3, this);
        $9f43b4b096afca59$var$_initializerDefineProperty(this, "address", $9f43b4b096afca59$var$_descriptor4, this);
        $9f43b4b096afca59$var$_initializerDefineProperty(this, "email", $9f43b4b096afca59$var$_descriptor5, this);
        $9f43b4b096afca59$var$_initializerDefineProperty(this, "phone", $9f43b4b096afca59$var$_descriptor6, this);
        $9f43b4b096afca59$var$_initializerDefineProperty(this, "accountingSystemId", $9f43b4b096afca59$var$_descriptor7, this);
        $9f43b4b096afca59$var$_initializerDefineProperty(this, "accountingSystemContactId", $9f43b4b096afca59$var$_descriptor8, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $4sGvn.default);
        this.init(data, options);
    }
    get projects() {
        return [
            ...(0, $kdO1A.default).projectsByContactId[this.id] || [],
            ...(0, $kdO1A.default).projectsByPrimaryContactId[this.id] || []
        ];
    }
    get invoices() {
        return (0, $PIDKX.default).invoicesByContactId[this.id] || [];
    }
    get fullName() {
        return [
            this.firstName,
            this.lastName
        ].join(" ");
    }
    get label() {
        return this.fullName ? this.organisationName ? `${this.fullName} (${this.organisationName})` : this.fullName : this.organisationName;
    }
}, $9f43b4b096afca59$var$_descriptor = $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "firstName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9f43b4b096afca59$var$_descriptor2 = $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "lastName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9f43b4b096afca59$var$_descriptor3 = $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "organisationName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9f43b4b096afca59$var$_descriptor4 = $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "address", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9f43b4b096afca59$var$_descriptor5 = $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "email", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9f43b4b096afca59$var$_descriptor6 = $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "phone", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9f43b4b096afca59$var$_descriptor7 = $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "accountingSystemId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9f43b4b096afca59$var$_descriptor8 = $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "accountingSystemContactId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "projects", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($9f43b4b096afca59$var$_class.prototype, "projects"), $9f43b4b096afca59$var$_class.prototype), $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "invoices", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($9f43b4b096afca59$var$_class.prototype, "invoices"), $9f43b4b096afca59$var$_class.prototype), $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "fullName", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($9f43b4b096afca59$var$_class.prototype, "fullName"), $9f43b4b096afca59$var$_class.prototype), $9f43b4b096afca59$var$_applyDecoratedDescriptor($9f43b4b096afca59$var$_class.prototype, "label", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($9f43b4b096afca59$var$_class.prototype, "label"), $9f43b4b096afca59$var$_class.prototype), $9f43b4b096afca59$var$_class);
var $9f43b4b096afca59$export$2e2bcd8739ae039 = $9f43b4b096afca59$var$ContactModel;

});
parcelRegister("PIDKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09b76427b3cdef93$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InvoiceCollectionClass", function () { return $09b76427b3cdef93$export$76f5f32d2c9b7f2f; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $d2QIA = parcelRequire("d2QIA");

var $egx7S = parcelRequire("egx7S");

var $5uSSv = parcelRequire("5uSSv");
parcelRequire("dBifK");

var $aZYqt = parcelRequire("aZYqt");
var $09b76427b3cdef93$var$_dec, $09b76427b3cdef93$var$_dec2, $09b76427b3cdef93$var$_dec3, $09b76427b3cdef93$var$_class;
function $09b76427b3cdef93$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}

let $09b76427b3cdef93$var$InvoiceCollection = ($09b76427b3cdef93$var$_dec = (0, $d8hWe.action).bound, $09b76427b3cdef93$var$_dec2 = (0, $d8hWe.action).bound, $09b76427b3cdef93$var$_dec3 = (0, $d8hWe.action).bound, $09b76427b3cdef93$var$_class = class InvoiceCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "invoices",
            modelClass: (0, $d2QIA.default)
        });
        this.addLookup("invoicesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("invoicesByContactId", "manyByKey", {
            key: (t)=>t.contactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("invoicesByOldId", "uniqueByKey", {
            key: (t)=>t.oldId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get invoicesById() {
        return this.modelsById;
    }
    get invoices() {
        return this.models.filter((i)=>!i.deletedAt);
    }
    addInvoice(data) {
        this.add(data);
    }
    addInvoices(data) {
        this.addMany(data);
    }
    createInvoice(project, startDate, endDate) {
        var _SessionStore$organis, _SessionStore$organis2, _SessionStore$organis3, _SessionStore$organis4;
        // can't put this at the top for some reason - circular deps?
        const Formula = (parcelRequire("3oSmx")).default;
        const invoiceRefFormula = new Formula({
            ref: "inv0",
            prop: "description",
            formula: ((0, $5uSSv.default).organisation.settings.invoice.invoiceCode || `format(invNum, "0000")`).replace("$project.invNum", ((0, $5uSSv.default).organisation.invNumProj || 0) + 1).replace("invNumYear", ((0, $5uSSv.default).organisation.invNumYear || 0) + 1).replace("invNum", ((0, $5uSSv.default).organisation.invNum || 0) + 1).replace(/\$project/g, `#"pr${project.id}"`)
        });
        const invoice = this.add({
            ref: invoiceRefFormula.value,
            projectId: project.id,
            contactId: project === null || project === void 0 ? void 0 : project.contactId,
            startDate: startDate,
            endDate: endDate,
            issueDate: new Date(),
            dueDate: (0, $egx7S.addDays)(new Date(), (0, $5uSSv.default).organisation.settings.invoice.numDaysBetweenIssueDateAndDueDate),
            taxRatePercent: (_SessionStore$organis = (_SessionStore$organis2 = (0, $5uSSv.default).organisation.accountingSystemSettings) === null || _SessionStore$organis2 === void 0 ? void 0 : (_SessionStore$organis3 = _SessionStore$organis2.settings) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.taxOnTaxType) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4.rate) !== null && _SessionStore$organis !== void 0 ? _SessionStore$organis : 10,
            accountingSystemId: (0, $5uSSv.default).organisation.accountingSystem,
            cachedData: {
                project: {
                    name: project.name,
                    jobNumber: project.jobNumber
                },
                phases: Object.fromEntries(project.phases.map((ph)=>[
                        ph.id,
                        {
                            name: ph.name,
                            jobNumber: ph.jobNumber,
                            fee: ph.fee,
                            previousBilled: ph.previouslyBilled
                        }
                    ])),
                expenses: Object.fromEntries(project.expenses.map((e)=>[
                        e.id,
                        {
                            name: e.name,
                            cost: e.cost,
                            previousBilled: e.previouslyBilled
                        }
                    ]))
            }
        }, {
            trackUpdates: true
        });
        project.phases.filter((ph)=>!(ph !== null && ph !== void 0 && ph.isRootPhase)).forEach((ph)=>{
            const ili = (0, $aZYqt.default).add({
                invoiceId: invoice.id,
                projectId: project.id,
                contactId: invoice.contactId,
                phaseId: ph.id,
                billingType: "agreedFee",
                lineItemType: "progress",
                unitCost: ph.fee,
                description: "[phase] ([phaseprogress] completion)",
                isTaxed: true
            }, {
                trackUpdates: true
            });
        });
        project.expenses.forEach((pe)=>{
            if (pe.billable && pe.endDate && pe.endDate <= endDate && pe.cost - pe.previouslyBilled > 0) (0, $aZYqt.default).add({
                invoiceId: invoice.id,
                projectId: project.id,
                contactId: invoice.contactId,
                phaseId: pe.phaseId || project.rootPhase.id,
                billingType: "reimbursement",
                lineItemType: "expense",
                description: pe.name,
                unitQuantity: 1,
                unitCost: pe.cost - pe.previouslyBilled,
                expenseId: pe.id,
                isTaxed: true
            }, {
                trackUpdates: true
            });
        });
        return invoice;
    }
}, $09b76427b3cdef93$var$_applyDecoratedDescriptor($09b76427b3cdef93$var$_class.prototype, "addInvoice", [
    $09b76427b3cdef93$var$_dec
], Object.getOwnPropertyDescriptor($09b76427b3cdef93$var$_class.prototype, "addInvoice"), $09b76427b3cdef93$var$_class.prototype), $09b76427b3cdef93$var$_applyDecoratedDescriptor($09b76427b3cdef93$var$_class.prototype, "addInvoices", [
    $09b76427b3cdef93$var$_dec2
], Object.getOwnPropertyDescriptor($09b76427b3cdef93$var$_class.prototype, "addInvoices"), $09b76427b3cdef93$var$_class.prototype), $09b76427b3cdef93$var$_applyDecoratedDescriptor($09b76427b3cdef93$var$_class.prototype, "createInvoice", [
    $09b76427b3cdef93$var$_dec3
], Object.getOwnPropertyDescriptor($09b76427b3cdef93$var$_class.prototype, "createInvoice"), $09b76427b3cdef93$var$_class.prototype), $09b76427b3cdef93$var$_class);
var $09b76427b3cdef93$export$2e2bcd8739ae039 = new $09b76427b3cdef93$var$InvoiceCollection();
const $09b76427b3cdef93$export$76f5f32d2c9b7f2f = $09b76427b3cdef93$var$InvoiceCollection;

});
parcelRegister("d2QIA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97f45afae055df71$export$2e2bcd8739ae039; });
parcelRequire("cjCbh");

var $d8hWe = parcelRequire("d8hWe");

var $dBifK = parcelRequire("dBifK");

var $4sGvn = parcelRequire("4sGvn");

var $PIDKX = parcelRequire("PIDKX");

var $aZYqt = parcelRequire("aZYqt");

var $kdO1A = parcelRequire("kdO1A");

var $fqmGV = parcelRequire("fqmGV");

var $9Lw71 = parcelRequire("9Lw71");

var $WdVIM = parcelRequire("WdVIM");
var $97f45afae055df71$var$_dec, $97f45afae055df71$var$_class, $97f45afae055df71$var$_descriptor, $97f45afae055df71$var$_descriptor2, $97f45afae055df71$var$_descriptor3, $97f45afae055df71$var$_descriptor4, $97f45afae055df71$var$_descriptor5, $97f45afae055df71$var$_descriptor6, $97f45afae055df71$var$_descriptor7, $97f45afae055df71$var$_descriptor8, $97f45afae055df71$var$_descriptor9, $97f45afae055df71$var$_descriptor10, $97f45afae055df71$var$_descriptor11, $97f45afae055df71$var$_descriptor12, $97f45afae055df71$var$_descriptor13, $97f45afae055df71$var$_descriptor14, $97f45afae055df71$var$_descriptor15, $97f45afae055df71$var$_descriptor16, $97f45afae055df71$var$_descriptor17, $97f45afae055df71$var$_descriptor18, $97f45afae055df71$var$_descriptor19, $97f45afae055df71$var$_descriptor20;
function $97f45afae055df71$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $97f45afae055df71$var$_defineProperty(e, r, t) {
    return (r = $97f45afae055df71$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $97f45afae055df71$var$_toPropertyKey(t) {
    var i = $97f45afae055df71$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $97f45afae055df71$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $97f45afae055df71$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $97f45afae055df71$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $97f45afae055df71$var$InvoiceModel = ($97f45afae055df71$var$_dec = (0, $d8hWe.action).bound, $97f45afae055df71$var$_class = class InvoiceModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $97f45afae055df71$var$_defineProperty(this, "oldId", null);
        $97f45afae055df71$var$_initializerDefineProperty(this, "ref", $97f45afae055df71$var$_descriptor, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "dueDate", $97f45afae055df71$var$_descriptor2, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "startDate", $97f45afae055df71$var$_descriptor3, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "endDate", $97f45afae055df71$var$_descriptor4, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "issueDate", $97f45afae055df71$var$_descriptor5, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "projectId", $97f45afae055df71$var$_descriptor6, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "contactId", $97f45afae055df71$var$_descriptor7, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "taxRatePercent", $97f45afae055df71$var$_descriptor8, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "accountingSystemId", $97f45afae055df71$var$_descriptor9, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "accountingSystemInvoiceId", $97f45afae055df71$var$_descriptor10, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "cachedData", $97f45afae055df71$var$_descriptor11, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "projectStatus", $97f45afae055df71$var$_descriptor12, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "totalAmount", $97f45afae055df71$var$_descriptor13, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "totalTax", $97f45afae055df71$var$_descriptor14, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "agreedAmount", $97f45afae055df71$var$_descriptor15, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "agreedTax", $97f45afae055df71$var$_descriptor16, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "variationAmount", $97f45afae055df71$var$_descriptor17, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "variationTax", $97f45afae055df71$var$_descriptor18, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "reimbursementAmount", $97f45afae055df71$var$_descriptor19, this);
        $97f45afae055df71$var$_initializerDefineProperty(this, "reimbursementTax", $97f45afae055df71$var$_descriptor20, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $PIDKX.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get phases() {
        const phases = this.phaseIds.map((id)=>(0, $9Lw71.default).phasesById[id] || this.cachedData.phases[id] || this.project.rootPhase).sort((0, $WdVIM.default));
        return [
            ...new Set(phases)
        ];
    }
    get phaseIds() {
        return Object.keys(this.lineItemsByPhaseId);
    }
    get expenses() {
        return this.project.expenses;
    }
    get contact() {
        return (0, $4sGvn.default).contactsById[this.contactId];
    }
    get lineItems() {
        return (0, $aZYqt.default).lineItemsByInvoiceId[this.id] || [];
    }
    get timeEntries() {
        return this.lineItems.map((li)=>li.timeEntries).flat() || [];
    }
    get lineItemsByPhaseId() {
        let lineItemsByPhaseId = {
            [this.project.rootPhase.id]: []
        };
        this.project.phases.forEach((ph)=>{
            lineItemsByPhaseId[ph.id] = [];
        });
        this.lineItems.forEach((li)=>{
            const id = Boolean((0, $9Lw71.default).phasesById[li.phaseId] || this.cachedData.phases[li.phaseId]) ? li.phaseId : this.project.rootPhase.id;
            if (!lineItemsByPhaseId[id]) lineItemsByPhaseId[id] = [];
            lineItemsByPhaseId[id].push(li);
        });
        return lineItemsByPhaseId;
    }
    get lineItemsByExpenseId() {
        let lineItemsByExpenseId = {};
        this.expenses.forEach((ex)=>{
            lineItemsByExpenseId[ex.id] = [];
        });
        this.lineItems.forEach((li)=>lineItemsByExpenseId[li.expenseId].push(li));
        return lineItemsByExpenseId;
    }
    get amount() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.lineItems.map((li)=>li.amount));
    }
    get tax() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.lineItems.map((li)=>li.tax));
    }
    get phasesWithRevenue() {
        return [
            ...new Set(this.lineItems.filter((li)=>li.amount).map((li)=>li.phase))
        ];
    }
    updateCachedData() {
        this.update({
            cachedData: {
                project: {
                    name: this.project.title,
                    jobNumber: this.project.jobNumber
                },
                phases: Object.fromEntries(this.phases.map((ph)=>[
                        ph.id,
                        {
                            name: ph.title,
                            jobNumber: ph.jobNumber,
                            fee: ph.fee,
                            //loaded on InvoicePage
                            previousBilled: ph.previousBilled || 0
                        }
                    ])),
                expenses: Object.fromEntries(this.expenses.map((e)=>[
                        e.id,
                        {
                            name: e.name,
                            cost: e.cost,
                            //loaded on InvoicePage
                            previousBilled: e.previousBilled || 0
                        }
                    ]))
            }
        });
        this.lineItems.forEach((li)=>{
            if (li.lineItemType === "progress" && li.billingType === "agreedFee") li.update({
                unitQuantity: li.phase.fee ? li.amount / (li.phase.fee || 0) : 0,
                unitCost: li.phase.fee || 0
            });
        });
    }
}, $97f45afae055df71$var$_descriptor = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "ref", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor2 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "dueDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor3 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor4 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor5 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "issueDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor6 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor7 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "contactId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor8 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "taxRatePercent", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor9 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "accountingSystemId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor10 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "accountingSystemInvoiceId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor11 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "cachedData", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor12 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "projectStatus", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $97f45afae055df71$var$_descriptor13 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "totalAmount", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $97f45afae055df71$var$_descriptor14 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "totalTax", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $97f45afae055df71$var$_descriptor15 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "agreedAmount", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $97f45afae055df71$var$_descriptor16 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "agreedTax", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $97f45afae055df71$var$_descriptor17 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "variationAmount", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $97f45afae055df71$var$_descriptor18 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "variationTax", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $97f45afae055df71$var$_descriptor19 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "reimbursementAmount", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $97f45afae055df71$var$_descriptor20 = $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "reimbursementTax", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "project"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "phases", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "phases"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "phaseIds", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "phaseIds"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "expenses", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "expenses"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "contact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "contact"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "lineItems", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "lineItems"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "timeEntries", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "timeEntries"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "lineItemsByPhaseId", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "lineItemsByPhaseId"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "lineItemsByExpenseId", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "lineItemsByExpenseId"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "amount", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "amount"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "tax", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "tax"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "phasesWithRevenue", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "phasesWithRevenue"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_applyDecoratedDescriptor($97f45afae055df71$var$_class.prototype, "updateCachedData", [
    $97f45afae055df71$var$_dec
], Object.getOwnPropertyDescriptor($97f45afae055df71$var$_class.prototype, "updateCachedData"), $97f45afae055df71$var$_class.prototype), $97f45afae055df71$var$_class);
var $97f45afae055df71$export$2e2bcd8739ae039 = $97f45afae055df71$var$InvoiceModel;

});
parcelRegister("aZYqt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $801e793e9d62024e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InvoiceLineItemCollectionClass", function () { return $801e793e9d62024e$export$9f646c9fdc054650; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $4FZiQ = parcelRequire("4FZiQ");
var $801e793e9d62024e$var$_dec, $801e793e9d62024e$var$_dec2, $801e793e9d62024e$var$_class;
function $801e793e9d62024e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $801e793e9d62024e$var$InvoiceLineItemCollection = ($801e793e9d62024e$var$_dec = (0, $d8hWe.action).bound, $801e793e9d62024e$var$_dec2 = (0, $d8hWe.action).bound, $801e793e9d62024e$var$_class = class InvoiceLineItemCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "invoiceLineItems",
            modelClass: (0, $4FZiQ.default)
        });
        this.addLookup("lineItemsByInvoiceId", "manyByKey", {
            key: (t)=>t.invoiceId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByContactId", "manyByKey", {
            key: (t)=>t.contactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByInvoicePhaseId", "manyByKey", {
            key: (t)=>"i" + t.invoiceId + "ph" + (t.phaseId ? t.phaseId : "undefined"),
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get invoiceLineItemsById() {
        return this.modelsById;
    }
    get invoiceLineItems() {
        return this.models;
    }
    addInvoiceLineItem(data) {
        this.add(data);
    }
    addInvoiceLineItems(data) {
        this.addMany(data);
    }
}, $801e793e9d62024e$var$_applyDecoratedDescriptor($801e793e9d62024e$var$_class.prototype, "addInvoiceLineItem", [
    $801e793e9d62024e$var$_dec
], Object.getOwnPropertyDescriptor($801e793e9d62024e$var$_class.prototype, "addInvoiceLineItem"), $801e793e9d62024e$var$_class.prototype), $801e793e9d62024e$var$_applyDecoratedDescriptor($801e793e9d62024e$var$_class.prototype, "addInvoiceLineItems", [
    $801e793e9d62024e$var$_dec2
], Object.getOwnPropertyDescriptor($801e793e9d62024e$var$_class.prototype, "addInvoiceLineItems"), $801e793e9d62024e$var$_class.prototype), $801e793e9d62024e$var$_class);
var $801e793e9d62024e$export$2e2bcd8739ae039 = new $801e793e9d62024e$var$InvoiceLineItemCollection();
const $801e793e9d62024e$export$9f646c9fdc054650 = $801e793e9d62024e$var$InvoiceLineItemCollection;

});
parcelRegister("4FZiQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $367a8b45c5596623$export$2e2bcd8739ae039; });
parcelRequire("dnDjk");

var $d8hWe = parcelRequire("d8hWe");

var $dBifK = parcelRequire("dBifK");
parcelRequire("kjgxB");

var $5tIfX = parcelRequire("5tIfX");

var $gDVAs = parcelRequire("gDVAs");

var $fSXDi = parcelRequire("fSXDi");

var $4sGvn = parcelRequire("4sGvn");

var $PIDKX = parcelRequire("PIDKX");

var $aZYqt = parcelRequire("aZYqt");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $8sHH3 = parcelRequire("8sHH3");

var $lTrDt = parcelRequire("lTrDt");

var $cuB2x = parcelRequire("cuB2x");

var $fqmGV = parcelRequire("fqmGV");

var $367a8b45c5596623$var$_class, $367a8b45c5596623$var$_descriptor, $367a8b45c5596623$var$_descriptor2, $367a8b45c5596623$var$_descriptor3, $367a8b45c5596623$var$_descriptor4, $367a8b45c5596623$var$_descriptor5, $367a8b45c5596623$var$_descriptor6, $367a8b45c5596623$var$_descriptor7, $367a8b45c5596623$var$_descriptor8, $367a8b45c5596623$var$_descriptor9, $367a8b45c5596623$var$_descriptor10, $367a8b45c5596623$var$_descriptor11, $367a8b45c5596623$var$_descriptor12, $367a8b45c5596623$var$_descriptor13;
function $367a8b45c5596623$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $367a8b45c5596623$var$_defineProperty(e, r, t) {
    return (r = $367a8b45c5596623$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $367a8b45c5596623$var$_toPropertyKey(t) {
    var i = $367a8b45c5596623$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $367a8b45c5596623$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $367a8b45c5596623$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $367a8b45c5596623$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $367a8b45c5596623$var$InvoiceLineItemModel = ($367a8b45c5596623$var$_class = class InvoiceLineItemModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $367a8b45c5596623$var$_initializerDefineProperty(this, "projectId", $367a8b45c5596623$var$_descriptor, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "contactId", $367a8b45c5596623$var$_descriptor2, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "invoiceId", $367a8b45c5596623$var$_descriptor3, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "phaseId", $367a8b45c5596623$var$_descriptor4, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "billingType", $367a8b45c5596623$var$_descriptor5, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "lineItemType", $367a8b45c5596623$var$_descriptor6, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "description", $367a8b45c5596623$var$_descriptor7, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "unitCost", $367a8b45c5596623$var$_descriptor8, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "unitQuantity", $367a8b45c5596623$var$_descriptor9, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "isTaxed", $367a8b45c5596623$var$_descriptor10, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "staffIds", $367a8b45c5596623$var$_descriptor11, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "timesheetIds", $367a8b45c5596623$var$_descriptor12, this);
        $367a8b45c5596623$var$_initializerDefineProperty(this, "expenseId", $367a8b45c5596623$var$_descriptor13, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $aZYqt.default);
        this.init(data, options);
    }
    get invoice() {
        return (0, $PIDKX.default).invoicesById[this.invoiceId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get contact() {
        return (0, $4sGvn.default).contactsById[this.contactId];
    }
    get expense() {
        return (0, $8sHH3.default).projectExpensesById[this.expenseId];
    }
    get timeEntries() {
        return (this.timesheetIds || []).map((tsi)=>(0, $cuB2x.default).timeEntriesById[tsi]);
    }
    get staff() {
        return (this.staffIds || []).map((si)=>(0, $lTrDt.default).staffsById[si]);
    }
    get taxRate() {
        var _this$invoice;
        return (((_this$invoice = this.invoice) === null || _this$invoice === void 0 ? void 0 : _this$invoice.taxRatePercent) || 0) / 100;
    }
    get amount() {
        return this.unitQuantity * this.unitCost || 0;
    }
    get tax() {
        return this.isTaxed ? this.amount * this.taxRate : 0;
    }
    get issueDate() {
        var _this$invoice2;
        return (_this$invoice2 = this.invoice) === null || _this$invoice2 === void 0 ? void 0 : _this$invoice2.issueDate;
    }
    get dueDate() {
        var _this$invoice3;
        return (_this$invoice3 = this.invoice) === null || _this$invoice3 === void 0 ? void 0 : _this$invoice3.dueDate;
    }
    get startDate() {
        var _this$invoice4;
        return (_this$invoice4 = this.invoice) === null || _this$invoice4 === void 0 ? void 0 : _this$invoice4.startDate;
    }
    get endDate() {
        var _this$invoice5;
        return (_this$invoice5 = this.invoice) === null || _this$invoice5 === void 0 ? void 0 : _this$invoice5.endDate;
    }
    get timeEntryStartDate() {
        return this.timeEntries.length ? (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(this.timeEntries.map((te)=>te === null || te === void 0 ? void 0 : te.date)) : -Infinity;
    }
    get formattedDescription() {
        let description = this.description || "";
        // Process round() function calls: [round(code)] or [round(code, N)]
        description = description.replace(/\[round\((\w+)(?:\s*,\s*(\d+))?\)\]/gi, (match, codeName, decimalStr)=>{
            const code = codeName.toLowerCase();
            const valueFn = $367a8b45c5596623$export$f7c2451ac6791f35[code];
            if (!valueFn) return match;
            const rawValue = valueFn(this);
            const decimals = decimalStr !== undefined ? parseInt(decimalStr, 10) : 0;
            return $367a8b45c5596623$var$formatCodeValueWithDecimals(code, rawValue, decimals, this);
        });
        // Existing code replacement
        Object.keys($367a8b45c5596623$export$b5ac1d9e94403947).forEach((code)=>{
            var _getDescriptionCodeTe;
            description = description.replaceAll(`[${code}]`, ((_getDescriptionCodeTe = $367a8b45c5596623$export$b5ac1d9e94403947[code]) === null || _getDescriptionCodeTe === void 0 ? void 0 : _getDescriptionCodeTe.call($367a8b45c5596623$export$b5ac1d9e94403947, this)) || "");
        });
        return description;
    }
}, $367a8b45c5596623$var$_descriptor = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_descriptor2 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "contactId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_descriptor3 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "invoiceId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_descriptor4 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_descriptor5 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "billingType", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_descriptor6 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "lineItemType", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_descriptor7 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "description", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $367a8b45c5596623$var$_descriptor8 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "unitCost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $367a8b45c5596623$var$_descriptor9 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "unitQuantity", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $367a8b45c5596623$var$_descriptor10 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "isTaxed", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $367a8b45c5596623$var$_descriptor11 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "staffIds", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_descriptor12 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "timesheetIds", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_descriptor13 = $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "expenseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "invoice", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "invoice"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "project"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "phase"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "contact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "contact"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "expense", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "expense"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "timeEntries", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "timeEntries"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "staff"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "taxRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "taxRate"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "amount", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "amount"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "tax", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "tax"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "issueDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "issueDate"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "dueDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "dueDate"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "startDate"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "endDate"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "timeEntryStartDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "timeEntryStartDate"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_applyDecoratedDescriptor($367a8b45c5596623$var$_class.prototype, "formattedDescription", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($367a8b45c5596623$var$_class.prototype, "formattedDescription"), $367a8b45c5596623$var$_class.prototype), $367a8b45c5596623$var$_class);
var $367a8b45c5596623$export$2e2bcd8739ae039 = $367a8b45c5596623$var$InvoiceLineItemModel;
const $367a8b45c5596623$var$codeFormatType = {
    phasefee: "currency",
    phaseprogress: "percent",
    remainingprogress: "percent",
    previousprogress: "percent",
    currentbilled: "currency",
    previousbilled: "currency",
    todatebilled: "currency",
    remainingbilled: "currency",
    hours: "number",
    expensetotal: "currency",
    expenseprevious: "currency",
    expensecurrent: "currency",
    expensetodate: "currency",
    expenseremaining: "currency",
    expenseprogress: "percent",
    expensepreviousprogress: "percent",
    expenseremainingprogress: "percent"
};
const $367a8b45c5596623$var$formatCodeValueWithDecimals = (codeName, rawValue, decimals, lineItem)=>{
    const formatType = $367a8b45c5596623$var$codeFormatType[codeName];
    if (formatType === "percent") return (0, $fSXDi.FormatPercent)(rawValue, {
        decimals: decimals
    });
    if (formatType === "currency") return (0, $5tIfX.FormatCurrency)(rawValue, {
        decimals: decimals
    });
    if (formatType === "number") return (0, $gDVAs.FormatNumber)(rawValue, {
        decimals: decimals
    });
    if (codeName === "quantity") {
        var _lineItem$lineItemTyp;
        return (_lineItem$lineItemTyp = lineItem.lineItemType) !== null && _lineItem$lineItemTyp !== void 0 && _lineItem$lineItemTyp.toLowerCase().includes("progress") ? (0, $fSXDi.FormatPercent)(rawValue, {
            decimals: decimals
        }) : (0, $gDVAs.FormatNumber)(rawValue, {
            decimals: decimals
        });
    }
    return String(rawValue !== null && rawValue !== void 0 ? rawValue : "");
};
const $367a8b45c5596623$export$b5ac1d9e94403947 = {
    project: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.project(li),
    projectcode: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.projectcode(li),
    phase: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.phase(li),
    phasecode: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.phasecode(li),
    phasefee: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.phasefee(li)),
    phaseprogress: (li)=>(0, $fSXDi.FormatPercent)($367a8b45c5596623$export$f7c2451ac6791f35.phaseprogress(li)),
    remainingprogress: (li)=>(0, $fSXDi.FormatPercent)($367a8b45c5596623$export$f7c2451ac6791f35.remainingprogress(li)),
    previousprogress: (li)=>(0, $fSXDi.FormatPercent)($367a8b45c5596623$export$f7c2451ac6791f35.previousprogress(li)),
    currentbilled: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.currentbilled(li)),
    previousbilled: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.previousbilled(li)),
    todatebilled: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.todatebilled(li)),
    remainingbilled: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.remainingbilled(li)),
    quantity: (li)=>li.lineItemType.toLowerCase().includes("progress") ? (0, $fSXDi.FormatPercent)($367a8b45c5596623$export$f7c2451ac6791f35.quantity(li)) : (0, $gDVAs.FormatNumber)($367a8b45c5596623$export$f7c2451ac6791f35.quantity(li)),
    hours: (li)=>(0, $gDVAs.FormatNumber)($367a8b45c5596623$export$f7c2451ac6791f35.hours(li)),
    staff: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.staff(li),
    // date: (li) => format(getDescriptionCodeValue.date(li), 'dd/MM/yyyy'),
    expensename: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.expensename(li),
    expensetotal: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.expensetotal(li)),
    expenseprevious: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.expenseprevious(li)),
    expensecurrent: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.expensecurrent(li)),
    expensetodate: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.expensetodate(li)),
    expenseremaining: (li)=>(0, $5tIfX.FormatCurrency)($367a8b45c5596623$export$f7c2451ac6791f35.expenseremaining(li)),
    expenseprogress: (li)=>(0, $fSXDi.FormatPercent)($367a8b45c5596623$export$f7c2451ac6791f35.expenseprogress(li)),
    expensepreviousprogress: (li)=>(0, $fSXDi.FormatPercent)($367a8b45c5596623$export$f7c2451ac6791f35.expensepreviousprogress(li)),
    expenseremainingprogress: (li)=>(0, $fSXDi.FormatPercent)($367a8b45c5596623$export$f7c2451ac6791f35.expenseremainingprogress(li))
};
const $367a8b45c5596623$export$f7c2451ac6791f35 = {
    project: (li)=>{
        var _li$invoice, _li$invoice$cachedDat, _li$invoice$cachedDat2;
        return li === null || li === void 0 ? void 0 : (_li$invoice = li.invoice) === null || _li$invoice === void 0 ? void 0 : (_li$invoice$cachedDat = _li$invoice.cachedData) === null || _li$invoice$cachedDat === void 0 ? void 0 : (_li$invoice$cachedDat2 = _li$invoice$cachedDat.project) === null || _li$invoice$cachedDat2 === void 0 ? void 0 : _li$invoice$cachedDat2.name;
    },
    projectcode: (li)=>{
        var _li$invoice2, _li$invoice2$cachedDa, _li$invoice2$cachedDa2;
        return li === null || li === void 0 ? void 0 : (_li$invoice2 = li.invoice) === null || _li$invoice2 === void 0 ? void 0 : (_li$invoice2$cachedDa = _li$invoice2.cachedData) === null || _li$invoice2$cachedDa === void 0 ? void 0 : (_li$invoice2$cachedDa2 = _li$invoice2$cachedDa.project) === null || _li$invoice2$cachedDa2 === void 0 ? void 0 : _li$invoice2$cachedDa2.jobNumber;
    },
    phase: (li)=>{
        var _li$invoice3, _li$invoice3$cachedDa, _li$invoice3$cachedDa2;
        return li === null || li === void 0 ? void 0 : (_li$invoice3 = li.invoice) === null || _li$invoice3 === void 0 ? void 0 : (_li$invoice3$cachedDa = _li$invoice3.cachedData) === null || _li$invoice3$cachedDa === void 0 ? void 0 : (_li$invoice3$cachedDa2 = _li$invoice3$cachedDa.phases[li.phaseId]) === null || _li$invoice3$cachedDa2 === void 0 ? void 0 : _li$invoice3$cachedDa2.name;
    },
    phasecode: (li)=>{
        var _li$invoice4, _li$invoice4$cachedDa, _li$invoice4$cachedDa2;
        return li === null || li === void 0 ? void 0 : (_li$invoice4 = li.invoice) === null || _li$invoice4 === void 0 ? void 0 : (_li$invoice4$cachedDa = _li$invoice4.cachedData) === null || _li$invoice4$cachedDa === void 0 ? void 0 : (_li$invoice4$cachedDa2 = _li$invoice4$cachedDa.phases[li.phaseId]) === null || _li$invoice4$cachedDa2 === void 0 ? void 0 : _li$invoice4$cachedDa2.jobNumber;
    },
    phasefee: (li)=>{
        var _li$invoice5, _li$invoice5$cachedDa, _li$invoice5$cachedDa2;
        return (li === null || li === void 0 ? void 0 : (_li$invoice5 = li.invoice) === null || _li$invoice5 === void 0 ? void 0 : (_li$invoice5$cachedDa = _li$invoice5.cachedData) === null || _li$invoice5$cachedDa === void 0 ? void 0 : (_li$invoice5$cachedDa2 = _li$invoice5$cachedDa.phases[li.phaseId]) === null || _li$invoice5$cachedDa2 === void 0 ? void 0 : _li$invoice5$cachedDa2.fee) || 0;
    },
    phaseprogress: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.todatebilled(li) / $367a8b45c5596623$export$f7c2451ac6791f35.phasefee(li) || 0,
    remainingprogress: (li)=>1 - $367a8b45c5596623$export$f7c2451ac6791f35.phaseprogress(li) || 0,
    previousprogress: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.previousbilled(li) / $367a8b45c5596623$export$f7c2451ac6791f35.phasefee(li) || 0,
    currentbilled: (li)=>{
        var _li$invoice6;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum((((_li$invoice6 = li.invoice) === null || _li$invoice6 === void 0 ? void 0 : _li$invoice6.lineItems) || []).filter((li2)=>li2.billingType === "agreedFee" && li2.phase === li.phase).map((li2)=>li2.amount)) || 0;
    },
    previousbilled: (li)=>{
        var _li$invoice7, _li$invoice7$cachedDa, _li$invoice7$cachedDa2;
        return (li === null || li === void 0 ? void 0 : (_li$invoice7 = li.invoice) === null || _li$invoice7 === void 0 ? void 0 : (_li$invoice7$cachedDa = _li$invoice7.cachedData) === null || _li$invoice7$cachedDa === void 0 ? void 0 : (_li$invoice7$cachedDa2 = _li$invoice7$cachedDa.phases[li.phaseId]) === null || _li$invoice7$cachedDa2 === void 0 ? void 0 : _li$invoice7$cachedDa2.previousBilled) || 0;
    },
    todatebilled: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.previousbilled(li) + $367a8b45c5596623$export$f7c2451ac6791f35.currentbilled(li),
    remainingbilled: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.phasefee(li) - $367a8b45c5596623$export$f7c2451ac6791f35.todatebilled(li),
    quantity: (li)=>li.unitQuantity,
    hours: (li)=>li.unitQuantity,
    staff: function(li) {
        return li.staff.map((st)=>st.fullName).join(", ");
    },
    // date: function (li) {
    //     return li.timeEntries[0].date
    // },
    expensename: (li)=>{
        var _li$invoice8, _li$invoice8$cachedDa, _li$invoice8$cachedDa2;
        return li === null || li === void 0 ? void 0 : (_li$invoice8 = li.invoice) === null || _li$invoice8 === void 0 ? void 0 : (_li$invoice8$cachedDa = _li$invoice8.cachedData) === null || _li$invoice8$cachedDa === void 0 ? void 0 : (_li$invoice8$cachedDa2 = _li$invoice8$cachedDa.expenses[li.expenseId]) === null || _li$invoice8$cachedDa2 === void 0 ? void 0 : _li$invoice8$cachedDa2.name;
    },
    expensetotal: (li)=>{
        var _li$invoice9, _li$invoice9$cachedDa, _li$invoice9$cachedDa2;
        return (li === null || li === void 0 ? void 0 : (_li$invoice9 = li.invoice) === null || _li$invoice9 === void 0 ? void 0 : (_li$invoice9$cachedDa = _li$invoice9.cachedData) === null || _li$invoice9$cachedDa === void 0 ? void 0 : (_li$invoice9$cachedDa2 = _li$invoice9$cachedDa.expenses[li.expenseId]) === null || _li$invoice9$cachedDa2 === void 0 ? void 0 : _li$invoice9$cachedDa2.cost) || 0;
    },
    expenseprevious: (li)=>{
        var _li$invoice10, _li$invoice10$cachedD, _li$invoice10$cachedD2;
        return (li === null || li === void 0 ? void 0 : (_li$invoice10 = li.invoice) === null || _li$invoice10 === void 0 ? void 0 : (_li$invoice10$cachedD = _li$invoice10.cachedData) === null || _li$invoice10$cachedD === void 0 ? void 0 : (_li$invoice10$cachedD2 = _li$invoice10$cachedD.expenses[li.expenseId]) === null || _li$invoice10$cachedD2 === void 0 ? void 0 : _li$invoice10$cachedD2.previousBilled) || 0;
    },
    expensecurrent: (li)=>(li)=>{
            var _li$invoice11;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum((((_li$invoice11 = li.invoice) === null || _li$invoice11 === void 0 ? void 0 : _li$invoice11.lineItems) || []).filter((li2)=>li2.billingType === "agreedFee" && li2.expense === li.expense).map((li2)=>li2.amount)) || 0;
        },
    expensetodate: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.expenseprevious(li) + $367a8b45c5596623$export$f7c2451ac6791f35.expensecurrent(li),
    expenseremaining: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.expensetotal(li) - $367a8b45c5596623$export$f7c2451ac6791f35.expensetodate(li),
    expenseprogress: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.expensetodate(li) / $367a8b45c5596623$export$f7c2451ac6791f35.expensetotal(li),
    expensepreviousprogress: (li)=>$367a8b45c5596623$export$f7c2451ac6791f35.expenseprevious(li) / $367a8b45c5596623$export$f7c2451ac6791f35.expensetotal(li),
    expenseremainingprogress: (li)=>1 - $367a8b45c5596623$export$f7c2451ac6791f35.expenseprogress(li)
};

});
parcelRegister("dnDjk", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("kjgxB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec9269b391f91078$export$2e2bcd8739ae039; });
var $ec9269b391f91078$export$2e2bcd8739ae039 = ({ day: day, month: month, year: year }, context)=>{
    return {
        type: "date",
        value: new Date(year, month - 1, day).getTime(),
        primitive: true
    };
};

});

parcelRegister("5tIfX", function(module, exports) {

$parcel$export(module.exports, "FormatCurrency", function () { return $3fd1fd994ccec4c6$export$86025f4579c41922; });

var $1ldsY = parcelRequire("1ldsY");


var $5UCsG = parcelRequire("5UCsG");

var $5bGlM = parcelRequire("5bGlM");

var $5uSSv = parcelRequire("5uSSv");

var $hPhGC = parcelRequire("hPhGC");
const $3fd1fd994ccec4c6$export$86025f4579c41922 = (value, { decimals: decimals = 2, currency: currency = (0, (/*@__PURE__*/$parcel$interopDefault($5UCsG))).getCurrency((0, (/*@__PURE__*/$parcel$interopDefault($5bGlM))).findCountryLocales((0, $hPhGC.constantCase)(((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) || "us"))[0]), compact: compact = false } = {})=>{
    if ([
        null,
        undefined,
        ""
    ].includes(value)) return value;
    const formatter = new (0, $1ldsY.NumberFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($5bGlM))).findCountryLocales((0, $hPhGC.constantCase)(((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) || "us"))[0], {
        style: "currency",
        currency: currency || "USD",
        maximumFractionDigits: decimals,
        notation: compact ? "compact" : "standard"
    });
    return formatter.format(value);
};

});
parcelRegister("1ldsY", function(module, exports) {

$parcel$export(module.exports, "NumberFormatter", function () { return $0fa232bc941a93c9$export$cc77c4ff7e8673c5; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
class $0fa232bc941a93c9$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!$0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $0fa232bc941a93c9$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !$0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit, unitDisplay: unitDisplay = "short", locale: locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = (_UNITS_unit = $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === "function") return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === "function") return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes("-nu-")) {
        if (!locale.includes("-u-")) locale += "-u-";
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === "unit" && !$0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit, unitDisplay: unitDisplay = "short" } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $0fa232bc941a93c9$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $0fa232bc941a93c9$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

});

parcelRegister("5UCsG", function(module, exports) {

$parcel$export(module.exports, "getCurrency", function () { return $44e0046883707547$export$f07e486b45756574; }, function (v) { return $44e0046883707547$export$f07e486b45756574 = v; });
$parcel$export(module.exports, "getLocales", function () { return $44e0046883707547$export$63967f17cb506053; }, function (v) { return $44e0046883707547$export$63967f17cb506053 = v; });
var $44e0046883707547$export$f07e486b45756574;
var $44e0046883707547$export$63967f17cb506053;

var $bp5qd = parcelRequire("bp5qd");
var $44e0046883707547$var$getCountryCode = function(localeString) {
    var components = localeString.split("_");
    if (components.length == 2) return components.pop();
    components = localeString.split("-");
    if (components.length == 2) return components.pop();
    return localeString;
};
$44e0046883707547$export$f07e486b45756574 = function(locale) {
    var countryCode1 = $44e0046883707547$var$getCountryCode(locale).toUpperCase();
    if (countryCode1 in $bp5qd) return $bp5qd[countryCode1];
    return null;
};
$44e0046883707547$export$63967f17cb506053 = function(currencyCode) {
    currencyCode = currencyCode.toUpperCase();
    var locales = [];
    for(countryCode in $bp5qd)if ($bp5qd[countryCode] === currencyCode) locales.push(countryCode);
    return locales;
};

});
parcelRegister("bp5qd", function(module, exports) {
// Generated using ShowCurrencies.java
var $84d63c3241aa2888$var$map = {
    AD: "EUR",
    AE: "AED",
    AF: "AFN",
    AG: "XCD",
    AI: "XCD",
    AL: "ALL",
    AM: "AMD",
    AN: "ANG",
    AO: "AOA",
    AR: "ARS",
    AS: "USD",
    AT: "EUR",
    AU: "AUD",
    AW: "AWG",
    AX: "EUR",
    AZ: "AZN",
    BA: "BAM",
    BB: "BBD",
    BD: "BDT",
    BE: "EUR",
    BF: "XOF",
    BG: "BGN",
    BH: "BHD",
    BI: "BIF",
    BJ: "XOF",
    BL: "EUR",
    BM: "BMD",
    BN: "BND",
    BO: "BOB",
    BQ: "USD",
    BR: "BRL",
    BS: "BSD",
    BT: "BTN",
    BV: "NOK",
    BW: "BWP",
    BY: "BYR",
    BZ: "BZD",
    CA: "CAD",
    CC: "AUD",
    CD: "CDF",
    CF: "XAF",
    CG: "XAF",
    CH: "CHF",
    CI: "XOF",
    CK: "NZD",
    CL: "CLP",
    CM: "XAF",
    CN: "CNY",
    CO: "COP",
    CR: "CRC",
    CU: "CUP",
    CV: "CVE",
    CW: "ANG",
    CX: "AUD",
    CY: "EUR",
    CZ: "CZK",
    DE: "EUR",
    DJ: "DJF",
    DK: "DKK",
    DM: "XCD",
    DO: "DOP",
    DZ: "DZD",
    EC: "USD",
    EE: "EUR",
    EG: "EGP",
    EH: "MAD",
    ER: "ERN",
    ES: "EUR",
    ET: "ETB",
    FI: "EUR",
    FJ: "FJD",
    FK: "FKP",
    FM: "USD",
    FO: "DKK",
    FR: "EUR",
    GA: "XAF",
    GB: "GBP",
    GD: "XCD",
    GE: "GEL",
    GF: "EUR",
    GG: "GBP",
    GH: "GHS",
    GI: "GIP",
    GL: "DKK",
    GM: "GMD",
    GN: "GNF",
    GP: "EUR",
    GQ: "XAF",
    GR: "EUR",
    GS: "GBP",
    GT: "GTQ",
    GU: "USD",
    GW: "XOF",
    GY: "GYD",
    HK: "HKD",
    HM: "AUD",
    HN: "HNL",
    HR: "HRK",
    HT: "HTG",
    HU: "HUF",
    ID: "IDR",
    IE: "EUR",
    IL: "ILS",
    IM: "GBP",
    IN: "INR",
    IO: "USD",
    IQ: "IQD",
    IR: "IRR",
    IS: "ISK",
    IT: "EUR",
    JE: "GBP",
    JM: "JMD",
    JO: "JOD",
    JP: "JPY",
    KE: "KES",
    KG: "KGS",
    KH: "KHR",
    KI: "AUD",
    KM: "KMF",
    KN: "XCD",
    KP: "KPW",
    KR: "KRW",
    KW: "KWD",
    KY: "KYD",
    KZ: "KZT",
    LA: "LAK",
    LB: "LBP",
    LC: "XCD",
    LI: "CHF",
    LK: "LKR",
    LR: "LRD",
    LS: "LSL",
    LT: "LTL",
    LU: "EUR",
    LV: "LVL",
    LY: "LYD",
    MA: "MAD",
    MC: "EUR",
    MD: "MDL",
    ME: "EUR",
    MF: "EUR",
    MG: "MGA",
    MH: "USD",
    MK: "MKD",
    ML: "XOF",
    MM: "MMK",
    MN: "MNT",
    MO: "MOP",
    MP: "USD",
    MQ: "EUR",
    MR: "MRO",
    MS: "XCD",
    MT: "EUR",
    MU: "MUR",
    MV: "MVR",
    MW: "MWK",
    MX: "MXN",
    MY: "MYR",
    MZ: "MZN",
    NA: "NAD",
    NC: "XPF",
    NE: "XOF",
    NF: "AUD",
    NG: "NGN",
    NI: "NIO",
    NL: "EUR",
    NO: "NOK",
    NP: "NPR",
    NR: "AUD",
    NU: "NZD",
    NZ: "NZD",
    OM: "OMR",
    PA: "PAB",
    PE: "PEN",
    PF: "XPF",
    PG: "PGK",
    PH: "PHP",
    PK: "PKR",
    PL: "PLN",
    PM: "EUR",
    PN: "NZD",
    PR: "USD",
    PS: "ILS",
    PT: "EUR",
    PW: "USD",
    PY: "PYG",
    QA: "QAR",
    RE: "EUR",
    RO: "RON",
    RS: "RSD",
    RU: "RUB",
    RW: "RWF",
    SA: "SAR",
    SB: "SBD",
    SC: "SCR",
    SD: "SDG",
    SE: "SEK",
    SG: "SGD",
    SH: "SHP",
    SI: "EUR",
    SJ: "NOK",
    SK: "EUR",
    SL: "SLL",
    SM: "EUR",
    SN: "XOF",
    SO: "SOS",
    SR: "SRD",
    ST: "STD",
    SV: "SVC",
    SX: "ANG",
    SY: "SYP",
    SZ: "SZL",
    TC: "USD",
    TD: "XAF",
    TF: "EUR",
    TG: "XOF",
    TH: "THB",
    TJ: "TJS",
    TK: "NZD",
    TL: "USD",
    TM: "TMT",
    TN: "TND",
    TO: "TOP",
    TR: "TRY",
    TT: "TTD",
    TV: "AUD",
    TW: "TWD",
    TZ: "TZS",
    UA: "UAH",
    UG: "UGX",
    UM: "USD",
    US: "USD",
    UY: "UYU",
    UZ: "UZS",
    VA: "EUR",
    VC: "XCD",
    VE: "VEF",
    VG: "USD",
    VI: "USD",
    VN: "VND",
    VU: "VUV",
    WF: "XPF",
    WS: "WST",
    YE: "YER",
    YT: "EUR",
    ZA: "ZAR",
    ZM: "ZMK",
    ZW: "ZWL"
};
module.exports = $84d63c3241aa2888$var$map;

});


parcelRegister("5bGlM", function(module, exports) {

var $dlgDI = parcelRequire("dlgDI");
var $3c6ed4ba0210b17e$require$locales = $dlgDI.locales;
var $3c6ed4ba0210b17e$require$validateLocaleCode = $dlgDI.validateLocaleCode;
var $3c6ed4ba0210b17e$require$validateLanguageCode = $dlgDI.validateLanguageCode;
var $3c6ed4ba0210b17e$require$findCountryLanguages = $dlgDI.findCountryLanguages;
var $3c6ed4ba0210b17e$require$findCountryLocales = $dlgDI.findCountryLocales;
module.exports = {
    locales: $3c6ed4ba0210b17e$require$locales,
    validateLocaleCode: $3c6ed4ba0210b17e$require$validateLocaleCode,
    validateLanguageCode: $3c6ed4ba0210b17e$require$validateLanguageCode,
    findCountryLanguages: $3c6ed4ba0210b17e$require$findCountryLanguages,
    findCountryLocales: $3c6ed4ba0210b17e$require$findCountryLocales
};

});
parcelRegister("dlgDI", function(module, exports) {

var $8dZSd = parcelRequire("8dZSd");
/**
 * Takes a locale code and checks if exists in the data dictionary
 * @param {string} localeCode - Language code (e.g. "en-GB")
 * @return {boolean}
 */ const $9b6a24c829887252$var$validateLocaleCode = (localeCode)=>{
    return $8dZSd.findIndex((l)=>l.code === localeCode) !== -1;
};
/**
 * Takes a language code and checks if exists in the data dictionary
 * @param {string} languageCode - Language code (e.g. "en")
 * @return {boolean}
 */ const $9b6a24c829887252$var$validateLanguageCode = (languageCode)=>{
    return $8dZSd.findIndex((l)=>l.langCode === languageCode) !== -1;
};
/**
 * Takes a country code and returns the list of languages valid for it
 * @param {string} countryCode - Country code (e.g. "PT")
 * @return {string[]} Languages list
 */ const $9b6a24c829887252$var$findCountryLanguages = (countryCode)=>{
    const countryEntries = $8dZSd.filter((l)=>l.countryCode === countryCode);
    const langSet = new Set();
    countryEntries.forEach((e, i)=>langSet.add(countryEntries[i].langCode));
    return Array.from(langSet);
};
/**
 * Takes a country code and returns the list of locales valid for it
 * @param {string} countryCode - Country code (e.g. "PT")
 * @return {string[]} Locales list
 */ const $9b6a24c829887252$var$findCountryLocales = (countryCode)=>{
    const countryEntries = $8dZSd.filter((l)=>l.countryCode === countryCode);
    const localeSet = new Set();
    countryEntries.forEach((e, i)=>localeSet.add(countryEntries[i].code));
    return Array.from(localeSet);
};
/**
 * Returns a list with a map of all existing locale codes and the respective country+language
 * @return {Object} Locales list in the form of a map: ['pt-PT'] => 'Portuguese (PT)'
 */ const $9b6a24c829887252$var$locales = ()=>{
    const map = {};
    for (const l of $8dZSd)map[l.code] = `${l.language} (${l.countryCode})`;
    return map;
};
module.exports = {
    locales: $9b6a24c829887252$var$locales,
    validateLocaleCode: $9b6a24c829887252$var$validateLocaleCode,
    validateLanguageCode: $9b6a24c829887252$var$validateLanguageCode,
    findCountryLanguages: $9b6a24c829887252$var$findCountryLanguages,
    findCountryLocales: $9b6a24c829887252$var$findCountryLocales
};

});
parcelRegister("8dZSd", function(module, exports) {
module.exports = JSON.parse('[{"code":"af-NA","langCode":"af","countryCode":"NA","country":"Namibia","language":"Afrikaans"},{"code":"af-ZA","langCode":"af","countryCode":"ZA","country":"South Africa","language":"Afrikaans"},{"code":"ak-GH","langCode":"ak","countryCode":"GH","country":"Ghana","language":"Akan"},{"code":"am-ET","langCode":"am","countryCode":"ET","country":"Ethiopia","language":"Amharic"},{"code":"ar-AE","langCode":"ar","countryCode":"AE","country":"United Arab Emirates","language":"Arabic"},{"code":"ar-BH","langCode":"ar","countryCode":"BH","country":"Bahrain","language":"Arabic"},{"code":"ar-DJ","langCode":"ar","countryCode":"DJ","country":"Djibouti","language":"Arabic"},{"code":"ar-DZ","langCode":"ar","countryCode":"DZ","country":"Algeria","language":"Arabic"},{"code":"ar-EG","langCode":"ar","countryCode":"EG","country":"Egypt","language":"Arabic"},{"code":"ar-EH","langCode":"ar","countryCode":"EH","country":"Western Sahara","language":"Arabic"},{"code":"ar-ER","langCode":"ar","countryCode":"ER","country":"Eritrea","language":"Arabic"},{"code":"ar-IL","langCode":"ar","countryCode":"IL","country":"Israel","language":"Arabic"},{"code":"ar-IQ","langCode":"ar","countryCode":"IQ","country":"Iraq","language":"Arabic"},{"code":"ar-JO","langCode":"ar","countryCode":"JO","country":"Jordan","language":"Arabic"},{"code":"ar-KM","langCode":"ar","countryCode":"KM","country":"Comoros","language":"Arabic"},{"code":"ar-KW","langCode":"ar","countryCode":"KW","country":"Kuwait","language":"Arabic"},{"code":"ar-LB","langCode":"ar","countryCode":"LB","country":"Lebanon","language":"Arabic"},{"code":"ar-LY","langCode":"ar","countryCode":"LY","country":"Libya","language":"Arabic"},{"code":"ar-MA","langCode":"ar","countryCode":"MA","country":"Morocco","language":"Arabic"},{"code":"ar-MR","langCode":"ar","countryCode":"MR","country":"Mauritania","language":"Arabic"},{"code":"ar-OM","langCode":"ar","countryCode":"OM","country":"Oman","language":"Arabic"},{"code":"ar-PS","langCode":"ar","countryCode":"PS","country":"Palestine, State of","language":"Arabic"},{"code":"ar-QA","langCode":"ar","countryCode":"QA","country":"Qatar","language":"Arabic"},{"code":"ar-SA","langCode":"ar","countryCode":"SA","country":"Saudi Arabia","language":"Arabic"},{"code":"ar-SD","langCode":"ar","countryCode":"SD","country":"Sudan","language":"Arabic"},{"code":"ar-SO","langCode":"ar","countryCode":"SO","country":"Somalia","language":"Arabic"},{"code":"ar-SS","langCode":"ar","countryCode":"SS","country":"South Sudan","language":"Arabic"},{"code":"ar-SY","langCode":"ar","countryCode":"SY","country":"Syrian Arab Republic","language":"Arabic"},{"code":"ar-TD","langCode":"ar","countryCode":"TD","country":"Chad","language":"Arabic"},{"code":"ar-TN","langCode":"ar","countryCode":"TN","country":"Tunisia","language":"Arabic"},{"code":"ar-YE","langCode":"ar","countryCode":"YE","country":"Yemen","language":"Arabic"},{"code":"as-IN","langCode":"as","countryCode":"IN","country":"India","language":"Assamese"},{"code":"az-Cyrl-AZ","langCode":"az","countryCode":"AZ","country":"Azerbaijan","language":"Azerbaijani"},{"code":"az-Latn-AZ","langCode":"az","countryCode":"AZ","country":"Azerbaijan","language":"Azerbaijani"},{"code":"be-BY","langCode":"be","countryCode":"BY","country":"Belarus","language":"Belarusian"},{"code":"bg-BG","langCode":"bg","countryCode":"BG","country":"Bulgaria","language":"Bulgarian"},{"code":"bm-ML","langCode":"bm","countryCode":"ML","country":"Mali","language":"Bambara"},{"code":"bn-BD","langCode":"bn","countryCode":"BD","country":"Bangladesh","language":"Bengali"},{"code":"bn-IN","langCode":"bn","countryCode":"IN","country":"India","language":"Bengali"},{"code":"bo-CN","langCode":"bo","countryCode":"CN","country":"China","language":"Tibetan"},{"code":"bo-IN","langCode":"bo","countryCode":"IN","country":"India","language":"Tibetan"},{"code":"br-FR","langCode":"br","countryCode":"FR","country":"France","language":"Breton"},{"code":"bs-Cyrl-BA","langCode":"bs","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Bosnian"},{"code":"bs-Latn-BA","langCode":"bs","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Bosnian"},{"code":"ca-AD","langCode":"ca","countryCode":"AD","country":"Andorra","language":"Catalan; Valencian"},{"code":"ca-ES","langCode":"ca","countryCode":"ES","country":"Spain","language":"Catalan; Valencian"},{"code":"ca-ES-VALENCIA","langCode":"ca","countryCode":"ES","country":"Spain","language":"Catalan; Valencian"},{"code":"ca-FR","langCode":"ca","countryCode":"FR","country":"France","language":"Catalan; Valencian"},{"code":"ca-IT","langCode":"ca","countryCode":"IT","country":"Italy","language":"Catalan; Valencian"},{"code":"ce-RU","langCode":"ce","countryCode":"RU","country":"Russian Federation","language":"Chechen"},{"code":"cs-CZ","langCode":"cs","countryCode":"CZ","country":"Czech Republic","language":"Czech"},{"code":"cu-RU","langCode":"cu","countryCode":"RU","country":"Russian Federation","language":"Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic"},{"code":"cy-GB","langCode":"cy","countryCode":"GB","country":"United Kingdom","language":"Welsh"},{"code":"da-DK","langCode":"da","countryCode":"DK","country":"Denmark","language":"Danish"},{"code":"da-GL","langCode":"da","countryCode":"GL","country":"Greenland","language":"Danish"},{"code":"de-AT","langCode":"de","countryCode":"AT","country":"Austria","language":"German"},{"code":"de-BE","langCode":"de","countryCode":"BE","country":"Belgium","language":"German"},{"code":"de-CH","langCode":"de","countryCode":"CH","country":"Switzerland","language":"German"},{"code":"de-DE","langCode":"de","countryCode":"DE","country":"Germany","language":"German"},{"code":"de-IT","langCode":"de","countryCode":"IT","country":"Italy","language":"German"},{"code":"de-LI","langCode":"de","countryCode":"LI","country":"Liechtenstein","language":"German"},{"code":"de-LU","langCode":"de","countryCode":"LU","country":"Luxembourg","language":"German"},{"code":"dz-BT","langCode":"dz","countryCode":"BT","country":"Bhutan","language":"Dzongkha"},{"code":"ee-GH","langCode":"ee","countryCode":"GH","country":"Ghana","language":"Ewe"},{"code":"ee-TG","langCode":"ee","countryCode":"TG","country":"Togo","language":"Ewe"},{"code":"el-CY","langCode":"el","countryCode":"CY","country":"Cyprus","language":"Greek, Modern (1453-)"},{"code":"el-GR","langCode":"el","countryCode":"GR","country":"Greece","language":"Greek, Modern (1453-)"},{"code":"en-AG","langCode":"en","countryCode":"AG","country":"Antigua and Barbuda","language":"English"},{"code":"en-AI","langCode":"en","countryCode":"AI","country":"Anguilla","language":"English"},{"code":"en-AS","langCode":"en","countryCode":"AS","country":"American Samoa","language":"English"},{"code":"en-AT","langCode":"en","countryCode":"AT","country":"Austria","language":"English"},{"code":"en-AU","langCode":"en","countryCode":"AU","country":"Australia","language":"English"},{"code":"en-BB","langCode":"en","countryCode":"BB","country":"Barbados","language":"English"},{"code":"en-BE","langCode":"en","countryCode":"BE","country":"Belgium","language":"English"},{"code":"en-BI","langCode":"en","countryCode":"BI","country":"Burundi","language":"English"},{"code":"en-BM","langCode":"en","countryCode":"BM","country":"Bermuda","language":"English"},{"code":"en-BS","langCode":"en","countryCode":"BS","country":"Bahamas","language":"English"},{"code":"en-BW","langCode":"en","countryCode":"BW","country":"Botswana","language":"English"},{"code":"en-BZ","langCode":"en","countryCode":"BZ","country":"Belize","language":"English"},{"code":"en-CA","langCode":"en","countryCode":"CA","country":"Canada","language":"English"},{"code":"en-CC","langCode":"en","countryCode":"CC","country":"Cocos (Keeling) Islands","language":"English"},{"code":"en-CH","langCode":"en","countryCode":"CH","country":"Switzerland","language":"English"},{"code":"en-CK","langCode":"en","countryCode":"CK","country":"Cook Islands","language":"English"},{"code":"en-CM","langCode":"en","countryCode":"CM","country":"Cameroon","language":"English"},{"code":"en-CX","langCode":"en","countryCode":"CX","country":"Christmas Island","language":"English"},{"code":"en-CY","langCode":"en","countryCode":"CY","country":"Cyprus","language":"English"},{"code":"en-DE","langCode":"en","countryCode":"DE","country":"Germany","language":"English"},{"code":"en-DK","langCode":"en","countryCode":"DK","country":"Denmark","language":"English"},{"code":"en-DM","langCode":"en","countryCode":"DM","country":"Dominica","language":"English"},{"code":"en-ER","langCode":"en","countryCode":"ER","country":"Eritrea","language":"English"},{"code":"en-FI","langCode":"en","countryCode":"FI","country":"Finland","language":"English"},{"code":"en-FJ","langCode":"en","countryCode":"FJ","country":"Fiji","language":"English"},{"code":"en-FK","langCode":"en","countryCode":"FK","country":"Falkland Islands (Malvinas)","language":"English"},{"code":"en-FM","langCode":"en","countryCode":"FM","country":"Micronesia, Federated States of","language":"English"},{"code":"en-GB","langCode":"en","countryCode":"GB","country":"United Kingdom","language":"English"},{"code":"en-GD","langCode":"en","countryCode":"GD","country":"Grenada","language":"English"},{"code":"en-GG","langCode":"en","countryCode":"GG","country":"Guernsey","language":"English"},{"code":"en-GH","langCode":"en","countryCode":"GH","country":"Ghana","language":"English"},{"code":"en-GI","langCode":"en","countryCode":"GI","country":"Gibraltar","language":"English"},{"code":"en-GM","langCode":"en","countryCode":"GM","country":"Gambia","language":"English"},{"code":"en-GU","langCode":"en","countryCode":"GU","country":"Guam","language":"English"},{"code":"en-GY","langCode":"en","countryCode":"GY","country":"Guyana","language":"English"},{"code":"en-HK","langCode":"en","countryCode":"HK","country":"Hong Kong","language":"English"},{"code":"en-IE","langCode":"en","countryCode":"IE","country":"Ireland","language":"English"},{"code":"en-IL","langCode":"en","countryCode":"IL","country":"Israel","language":"English"},{"code":"en-IM","langCode":"en","countryCode":"IM","country":"Isle of Man","language":"English"},{"code":"en-IN","langCode":"en","countryCode":"IN","country":"India","language":"English"},{"code":"en-IO","langCode":"en","countryCode":"IO","country":"British Indian Ocean Territory","language":"English"},{"code":"en-JE","langCode":"en","countryCode":"JE","country":"Jersey","language":"English"},{"code":"en-JM","langCode":"en","countryCode":"JM","country":"Jamaica","language":"English"},{"code":"en-KE","langCode":"en","countryCode":"KE","country":"Kenya","language":"English"},{"code":"en-KI","langCode":"en","countryCode":"KI","country":"Kiribati","language":"English"},{"code":"en-KN","langCode":"en","countryCode":"KN","country":"Saint Kitts and Nevis","language":"English"},{"code":"en-KY","langCode":"en","countryCode":"KY","country":"Cayman Islands","language":"English"},{"code":"en-LC","langCode":"en","countryCode":"LC","country":"Saint Lucia","language":"English"},{"code":"en-LR","langCode":"en","countryCode":"LR","country":"Liberia","language":"English"},{"code":"en-LS","langCode":"en","countryCode":"LS","country":"Lesotho","language":"English"},{"code":"en-MG","langCode":"en","countryCode":"MG","country":"Madagascar","language":"English"},{"code":"en-MH","langCode":"en","countryCode":"MH","country":"Marshall Islands","language":"English"},{"code":"en-MO","langCode":"en","countryCode":"MO","country":"Macao","language":"English"},{"code":"en-MP","langCode":"en","countryCode":"MP","country":"Northern Mariana Islands","language":"English"},{"code":"en-MS","langCode":"en","countryCode":"MS","country":"Montserrat","language":"English"},{"code":"en-MT","langCode":"en","countryCode":"MT","country":"Malta","language":"English"},{"code":"en-MU","langCode":"en","countryCode":"MU","country":"Mauritius","language":"English"},{"code":"en-MW","langCode":"en","countryCode":"MW","country":"Malawi","language":"English"},{"code":"en-MY","langCode":"en","countryCode":"MY","country":"Malaysia","language":"English"},{"code":"en-NA","langCode":"en","countryCode":"NA","country":"Namibia","language":"English"},{"code":"en-NF","langCode":"en","countryCode":"NF","country":"Norfolk Island","language":"English"},{"code":"en-NG","langCode":"en","countryCode":"NG","country":"Nigeria","language":"English"},{"code":"en-NL","langCode":"en","countryCode":"NL","country":"Netherlands","language":"English"},{"code":"en-NR","langCode":"en","countryCode":"NR","country":"Nauru","language":"English"},{"code":"en-NU","langCode":"en","countryCode":"NU","country":"Niue","language":"English"},{"code":"en-NZ","langCode":"en","countryCode":"NZ","country":"New Zealand","language":"English"},{"code":"en-PG","langCode":"en","countryCode":"PG","country":"Papua New Guinea","language":"English"},{"code":"en-PH","langCode":"en","countryCode":"PH","country":"Philippines","language":"English"},{"code":"en-PK","langCode":"en","countryCode":"PK","country":"Pakistan","language":"English"},{"code":"en-PN","langCode":"en","countryCode":"PN","country":"Pitcairn","language":"English"},{"code":"en-PR","langCode":"en","countryCode":"PR","country":"Puerto Rico","language":"English"},{"code":"en-PW","langCode":"en","countryCode":"PW","country":"Palau","language":"English"},{"code":"en-RW","langCode":"en","countryCode":"RW","country":"Rwanda","language":"English"},{"code":"en-SB","langCode":"en","countryCode":"SB","country":"Solomon Islands","language":"English"},{"code":"en-SC","langCode":"en","countryCode":"SC","country":"Seychelles","language":"English"},{"code":"en-SD","langCode":"en","countryCode":"SD","country":"Sudan","language":"English"},{"code":"en-SE","langCode":"en","countryCode":"SE","country":"Sweden","language":"English"},{"code":"en-SG","langCode":"en","countryCode":"SG","country":"Singapore","language":"English"},{"code":"en-SH","langCode":"en","countryCode":"SH","country":"Saint Helena, Ascension and Tristan da Cunha","language":"English"},{"code":"en-SI","langCode":"en","countryCode":"SI","country":"Slovenia","language":"English"},{"code":"en-SL","langCode":"en","countryCode":"SL","country":"Sierra Leone","language":"English"},{"code":"en-SS","langCode":"en","countryCode":"SS","country":"South Sudan","language":"English"},{"code":"en-SX","langCode":"en","countryCode":"SX","country":"Sint Maarten (Dutch part)","language":"English"},{"code":"en-SZ","langCode":"en","countryCode":"SZ","country":"Swaziland","language":"English"},{"code":"en-TC","langCode":"en","countryCode":"TC","country":"Turks and Caicos Islands","language":"English"},{"code":"en-TK","langCode":"en","countryCode":"TK","country":"Tokelau","language":"English"},{"code":"en-TO","langCode":"en","countryCode":"TO","country":"Tonga","language":"English"},{"code":"en-TT","langCode":"en","countryCode":"TT","country":"Trinidad and Tobago","language":"English"},{"code":"en-TV","langCode":"en","countryCode":"TV","country":"Tuvalu","language":"English"},{"code":"en-TZ","langCode":"en","countryCode":"TZ","country":"Tanzania, United Republic of","language":"English"},{"code":"en-UG","langCode":"en","countryCode":"UG","country":"Uganda","language":"English"},{"code":"en-UM","langCode":"en","countryCode":"UM","country":"United States Minor Outlying Islands","language":"English"},{"code":"en-US","langCode":"en","countryCode":"US","country":"United States","language":"English"},{"code":"en-VC","langCode":"en","countryCode":"VC","country":"Saint Vincent and the Grenadines","language":"English"},{"code":"en-VG","langCode":"en","countryCode":"VG","country":"Virgin Islands, British","language":"English"},{"code":"en-VI","langCode":"en","countryCode":"VI","country":"Virgin Islands, U.S.","language":"English"},{"code":"en-VU","langCode":"en","countryCode":"VU","country":"Vanuatu","language":"English"},{"code":"en-WS","langCode":"en","countryCode":"WS","country":"Samoa","language":"English"},{"code":"en-ZA","langCode":"en","countryCode":"ZA","country":"South Africa","language":"English"},{"code":"en-ZM","langCode":"en","countryCode":"ZM","country":"Zambia","language":"English"},{"code":"en-ZW","langCode":"en","countryCode":"ZW","country":"Zimbabwe","language":"English"},{"code":"es-AR","langCode":"es","countryCode":"AR","country":"Argentina","language":"Spanish; Castilian"},{"code":"es-BO","langCode":"es","countryCode":"BO","country":"Bolivia, Plurinational State of","language":"Spanish; Castilian"},{"code":"es-BR","langCode":"es","countryCode":"BR","country":"Brazil","language":"Spanish; Castilian"},{"code":"es-BZ","langCode":"es","countryCode":"BZ","country":"Belize","language":"Spanish; Castilian"},{"code":"es-CL","langCode":"es","countryCode":"CL","country":"Chile","language":"Spanish; Castilian"},{"code":"es-CO","langCode":"es","countryCode":"CO","country":"Colombia","language":"Spanish; Castilian"},{"code":"es-CR","langCode":"es","countryCode":"CR","country":"Costa Rica","language":"Spanish; Castilian"},{"code":"es-CU","langCode":"es","countryCode":"CU","country":"Cuba","language":"Spanish; Castilian"},{"code":"es-DO","langCode":"es","countryCode":"DO","country":"Dominican Republic","language":"Spanish; Castilian"},{"code":"es-EC","langCode":"es","countryCode":"EC","country":"Ecuador","language":"Spanish; Castilian"},{"code":"es-ES","langCode":"es","countryCode":"ES","country":"Spain","language":"Spanish; Castilian"},{"code":"es-GQ","langCode":"es","countryCode":"GQ","country":"Equatorial Guinea","language":"Spanish; Castilian"},{"code":"es-GT","langCode":"es","countryCode":"GT","country":"Guatemala","language":"Spanish; Castilian"},{"code":"es-HN","langCode":"es","countryCode":"HN","country":"Honduras","language":"Spanish; Castilian"},{"code":"es-MX","langCode":"es","countryCode":"MX","country":"Mexico","language":"Spanish; Castilian"},{"code":"es-NI","langCode":"es","countryCode":"NI","country":"Nicaragua","language":"Spanish; Castilian"},{"code":"es-PA","langCode":"es","countryCode":"PA","country":"Panama","language":"Spanish; Castilian"},{"code":"es-PE","langCode":"es","countryCode":"PE","country":"Peru","language":"Spanish; Castilian"},{"code":"es-PH","langCode":"es","countryCode":"PH","country":"Philippines","language":"Spanish; Castilian"},{"code":"es-PR","langCode":"es","countryCode":"PR","country":"Puerto Rico","language":"Spanish; Castilian"},{"code":"es-PY","langCode":"es","countryCode":"PY","country":"Paraguay","language":"Spanish; Castilian"},{"code":"es-SV","langCode":"es","countryCode":"SV","country":"El Salvador","language":"Spanish; Castilian"},{"code":"es-US","langCode":"es","countryCode":"US","country":"United States","language":"Spanish; Castilian"},{"code":"es-UY","langCode":"es","countryCode":"UY","country":"Uruguay","language":"Spanish; Castilian"},{"code":"es-VE","langCode":"es","countryCode":"VE","country":"Venezuela, Bolivarian Republic of","language":"Spanish; Castilian"},{"code":"et-EE","langCode":"et","countryCode":"EE","country":"Estonia","language":"Estonian"},{"code":"eu-ES","langCode":"eu","countryCode":"ES","country":"Spain","language":"Basque"},{"code":"fa-AF","langCode":"fa","countryCode":"AF","country":"Afghanistan","language":"Persian"},{"code":"fa-IR","langCode":"fa","countryCode":"IR","country":"Iran, Islamic Republic of","language":"Persian"},{"code":"ff-Latn-BF","langCode":"ff","countryCode":"BF","country":"Burkina Faso","language":"Fulah"},{"code":"ff-Latn-CM","langCode":"ff","countryCode":"CM","country":"Cameroon","language":"Fulah"},{"code":"ff-Latn-GH","langCode":"ff","countryCode":"GH","country":"Ghana","language":"Fulah"},{"code":"ff-Latn-GM","langCode":"ff","countryCode":"GM","country":"Gambia","language":"Fulah"},{"code":"ff-Latn-GN","langCode":"ff","countryCode":"GN","country":"Guinea","language":"Fulah"},{"code":"ff-Latn-GW","langCode":"ff","countryCode":"GW","country":"Guinea-Bissau","language":"Fulah"},{"code":"ff-Latn-LR","langCode":"ff","countryCode":"LR","country":"Liberia","language":"Fulah"},{"code":"ff-Latn-MR","langCode":"ff","countryCode":"MR","country":"Mauritania","language":"Fulah"},{"code":"ff-Latn-NE","langCode":"ff","countryCode":"NE","country":"Niger","language":"Fulah"},{"code":"ff-Latn-NG","langCode":"ff","countryCode":"NG","country":"Nigeria","language":"Fulah"},{"code":"ff-Latn-SL","langCode":"ff","countryCode":"SL","country":"Sierra Leone","language":"Fulah"},{"code":"ff-Latn-SN","langCode":"ff","countryCode":"SN","country":"Senegal","language":"Fulah"},{"code":"fi-FI","langCode":"fi","countryCode":"FI","country":"Finland","language":"Finnish"},{"code":"fo-DK","langCode":"fo","countryCode":"DK","country":"Denmark","language":"Faroese"},{"code":"fo-FO","langCode":"fo","countryCode":"FO","country":"Faroe Islands","language":"Faroese"},{"code":"fr-BE","langCode":"fr","countryCode":"BE","country":"Belgium","language":"French"},{"code":"fr-BF","langCode":"fr","countryCode":"BF","country":"Burkina Faso","language":"French"},{"code":"fr-BI","langCode":"fr","countryCode":"BI","country":"Burundi","language":"French"},{"code":"fr-BJ","langCode":"fr","countryCode":"BJ","country":"Benin","language":"French"},{"code":"fr-BL","langCode":"fr","countryCode":"BL","country":"Saint Barth\xe9lemy","language":"French"},{"code":"fr-CA","langCode":"fr","countryCode":"CA","country":"Canada","language":"French"},{"code":"fr-CD","langCode":"fr","countryCode":"CD","country":"Congo, the Democratic Republic of the","language":"French"},{"code":"fr-CF","langCode":"fr","countryCode":"CF","country":"Central African Republic","language":"French"},{"code":"fr-CG","langCode":"fr","countryCode":"CG","country":"Congo","language":"French"},{"code":"fr-CH","langCode":"fr","countryCode":"CH","country":"Switzerland","language":"French"},{"code":"fr-CI","langCode":"fr","countryCode":"CI","country":"C\xf4te d\'Ivoire","language":"French"},{"code":"fr-CM","langCode":"fr","countryCode":"CM","country":"Cameroon","language":"French"},{"code":"fr-DJ","langCode":"fr","countryCode":"DJ","country":"Djibouti","language":"French"},{"code":"fr-DZ","langCode":"fr","countryCode":"DZ","country":"Algeria","language":"French"},{"code":"fr-FR","langCode":"fr","countryCode":"FR","country":"France","language":"French"},{"code":"fr-GA","langCode":"fr","countryCode":"GA","country":"Gabon","language":"French"},{"code":"fr-GF","langCode":"fr","countryCode":"GF","country":"French Guiana","language":"French"},{"code":"fr-GN","langCode":"fr","countryCode":"GN","country":"Guinea","language":"French"},{"code":"fr-GP","langCode":"fr","countryCode":"GP","country":"Guadeloupe","language":"French"},{"code":"fr-GQ","langCode":"fr","countryCode":"GQ","country":"Equatorial Guinea","language":"French"},{"code":"fr-HT","langCode":"fr","countryCode":"HT","country":"Haiti","language":"French"},{"code":"fr-KM","langCode":"fr","countryCode":"KM","country":"Comoros","language":"French"},{"code":"fr-LU","langCode":"fr","countryCode":"LU","country":"Luxembourg","language":"French"},{"code":"fr-MA","langCode":"fr","countryCode":"MA","country":"Morocco","language":"French"},{"code":"fr-MC","langCode":"fr","countryCode":"MC","country":"Monaco","language":"French"},{"code":"fr-MF","langCode":"fr","countryCode":"MF","country":"Saint Martin (French part)","language":"French"},{"code":"fr-MG","langCode":"fr","countryCode":"MG","country":"Madagascar","language":"French"},{"code":"fr-ML","langCode":"fr","countryCode":"ML","country":"Mali","language":"French"},{"code":"fr-MQ","langCode":"fr","countryCode":"MQ","country":"Martinique","language":"French"},{"code":"fr-MR","langCode":"fr","countryCode":"MR","country":"Mauritania","language":"French"},{"code":"fr-MU","langCode":"fr","countryCode":"MU","country":"Mauritius","language":"French"},{"code":"fr-NC","langCode":"fr","countryCode":"NC","country":"New Caledonia","language":"French"},{"code":"fr-NE","langCode":"fr","countryCode":"NE","country":"Niger","language":"French"},{"code":"fr-PF","langCode":"fr","countryCode":"PF","country":"French Polynesia","language":"French"},{"code":"fr-PM","langCode":"fr","countryCode":"PM","country":"Saint Pierre and Miquelon","language":"French"},{"code":"fr-RE","langCode":"fr","countryCode":"RE","country":"R\xe9union","language":"French"},{"code":"fr-RW","langCode":"fr","countryCode":"RW","country":"Rwanda","language":"French"},{"code":"fr-SC","langCode":"fr","countryCode":"SC","country":"Seychelles","language":"French"},{"code":"fr-SN","langCode":"fr","countryCode":"SN","country":"Senegal","language":"French"},{"code":"fr-SY","langCode":"fr","countryCode":"SY","country":"Syrian Arab Republic","language":"French"},{"code":"fr-TD","langCode":"fr","countryCode":"TD","country":"Chad","language":"French"},{"code":"fr-TG","langCode":"fr","countryCode":"TG","country":"Togo","language":"French"},{"code":"fr-TN","langCode":"fr","countryCode":"TN","country":"Tunisia","language":"French"},{"code":"fr-VU","langCode":"fr","countryCode":"VU","country":"Vanuatu","language":"French"},{"code":"fr-WF","langCode":"fr","countryCode":"WF","country":"Wallis and Futuna","language":"French"},{"code":"fr-YT","langCode":"fr","countryCode":"YT","country":"Mayotte","language":"French"},{"code":"fy-NL","langCode":"fy","countryCode":"NL","country":"Netherlands","language":"Western Frisian"},{"code":"ga-IE","langCode":"ga","countryCode":"IE","country":"Ireland","language":"Irish"},{"code":"gd-GB","langCode":"gd","countryCode":"GB","country":"United Kingdom","language":"Gaelic; Scottish Gaelic"},{"code":"gl-ES","langCode":"gl","countryCode":"ES","country":"Spain","language":"Galician"},{"code":"gu-IN","langCode":"gu","countryCode":"IN","country":"India","language":"Gujarati"},{"code":"gv-IM","langCode":"gv","countryCode":"IM","country":"Isle of Man","language":"Manx"},{"code":"ha-GH","langCode":"ha","countryCode":"GH","country":"Ghana","language":"Hausa"},{"code":"ha-NE","langCode":"ha","countryCode":"NE","country":"Niger","language":"Hausa"},{"code":"ha-NG","langCode":"ha","countryCode":"NG","country":"Nigeria","language":"Hausa"},{"code":"he-IL","langCode":"he","countryCode":"IL","country":"Israel","language":"Hebrew"},{"code":"hi-IN","langCode":"hi","countryCode":"IN","country":"India","language":"Hindi"},{"code":"hr-BA","langCode":"hr","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Croatian"},{"code":"hr-HR","langCode":"hr","countryCode":"HR","country":"Croatia","language":"Croatian"},{"code":"hu-HU","langCode":"hu","countryCode":"HU","country":"Hungary","language":"Hungarian"},{"code":"hy-AM","langCode":"hy","countryCode":"AM","country":"Armenia","language":"Armenian"},{"code":"id-ID","langCode":"id","countryCode":"ID","country":"Indonesia","language":"Indonesian"},{"code":"ig-NG","langCode":"ig","countryCode":"NG","country":"Nigeria","language":"Igbo"},{"code":"ii-CN","langCode":"ii","countryCode":"CN","country":"China","language":"Sichuan Yi; Nuosu"},{"code":"is-IS","langCode":"is","countryCode":"IS","country":"Iceland","language":"Icelandic"},{"code":"it-CH","langCode":"it","countryCode":"CH","country":"Switzerland","language":"Italian"},{"code":"it-IT","langCode":"it","countryCode":"IT","country":"Italy","language":"Italian"},{"code":"it-SM","langCode":"it","countryCode":"SM","country":"San Marino","language":"Italian"},{"code":"it-VA","langCode":"it","countryCode":"VA","country":"Holy See (Vatican City State)","language":"Italian"},{"code":"ja-JP","langCode":"ja","countryCode":"JP","country":"Japan","language":"Japanese"},{"code":"jv-ID","langCode":"jv","countryCode":"ID","country":"Indonesia","language":"Javanese"},{"code":"ka-GE","langCode":"ka","countryCode":"GE","country":"Georgia","language":"Georgian"},{"code":"ki-KE","langCode":"ki","countryCode":"KE","country":"Kenya","language":"Kikuyu; Gikuyu"},{"code":"kk-KZ","langCode":"kk","countryCode":"KZ","country":"Kazakhstan","language":"Kazakh"},{"code":"kl-GL","langCode":"kl","countryCode":"GL","country":"Greenland","language":"Kalaallisut; Greenlandic"},{"code":"km-KH","langCode":"km","countryCode":"KH","country":"Cambodia","language":"Central Khmer"},{"code":"kn-IN","langCode":"kn","countryCode":"IN","country":"India","language":"Kannada"},{"code":"ko-KP","langCode":"ko","countryCode":"KP","country":"Korea, Democratic People\'s Republic of","language":"Korean"},{"code":"ko-KR","langCode":"ko","countryCode":"KR","country":"Korea, Republic of","language":"Korean"},{"code":"ks-IN","langCode":"ks","countryCode":"IN","country":"India","language":"Kashmiri"},{"code":"ku-TR","langCode":"ku","countryCode":"TR","country":"Turkey","language":"Kurdish"},{"code":"kw-GB","langCode":"kw","countryCode":"GB","country":"United Kingdom","language":"Cornish"},{"code":"ky-KG","langCode":"ky","countryCode":"KG","country":"Kyrgyzstan","language":"Kirghiz; Kyrgyz"},{"code":"lb-LU","langCode":"lb","countryCode":"LU","country":"Luxembourg","language":"Luxembourgish; Letzeburgesch"},{"code":"lg-UG","langCode":"lg","countryCode":"UG","country":"Uganda","language":"Ganda"},{"code":"ln-AO","langCode":"ln","countryCode":"AO","country":"Angola","language":"Lingala"},{"code":"ln-CD","langCode":"ln","countryCode":"CD","country":"Congo, the Democratic Republic of the","language":"Lingala"},{"code":"ln-CF","langCode":"ln","countryCode":"CF","country":"Central African Republic","language":"Lingala"},{"code":"ln-CG","langCode":"ln","countryCode":"CG","country":"Congo","language":"Lingala"},{"code":"lo-LA","langCode":"lo","countryCode":"LA","country":"Lao People\'s Democratic Republic","language":"Lao"},{"code":"lt-LT","langCode":"lt","countryCode":"LT","country":"Lithuania","language":"Lithuanian"},{"code":"lu-CD","langCode":"lu","countryCode":"CD","country":"Congo, the Democratic Republic of the","language":"Luba-Katanga"},{"code":"lv-LV","langCode":"lv","countryCode":"LV","country":"Latvia","language":"Latvian"},{"code":"mg-MG","langCode":"mg","countryCode":"MG","country":"Madagascar","language":"Malagasy"},{"code":"mi-NZ","langCode":"mi","countryCode":"NZ","country":"New Zealand","language":"Maori"},{"code":"mk-MK","langCode":"mk","countryCode":"MK","country":"Macedonia, the Former Yugoslav Republic of","language":"Macedonian"},{"code":"ml-IN","langCode":"ml","countryCode":"IN","country":"India","language":"Malayalam"},{"code":"mn-MN","langCode":"mn","countryCode":"MN","country":"Mongolia","language":"Mongolian"},{"code":"mr-IN","langCode":"mr","countryCode":"IN","country":"India","language":"Marathi"},{"code":"ms-BN","langCode":"ms","countryCode":"BN","country":"Brunei Darussalam","language":"Malay"},{"code":"ms-MY","langCode":"ms","countryCode":"MY","country":"Malaysia","language":"Malay"},{"code":"ms-SG","langCode":"ms","countryCode":"SG","country":"Singapore","language":"Malay"},{"code":"mt-MT","langCode":"mt","countryCode":"MT","country":"Malta","language":"Maltese"},{"code":"my-MM","langCode":"my","countryCode":"MM","country":"Myanmar","language":"Burmese"},{"code":"nb-NO","langCode":"nb","countryCode":"NO","country":"Norway","language":"Bokm\xe5l, Norwegian; Norwegian Bokm\xe5l"},{"code":"nb-SJ","langCode":"nb","countryCode":"SJ","country":"Svalbard and Jan Mayen","language":"Bokm\xe5l, Norwegian; Norwegian Bokm\xe5l"},{"code":"nd-ZW","langCode":"nd","countryCode":"ZW","country":"Zimbabwe","language":"Ndebele, North; North Ndebele"},{"code":"ne-IN","langCode":"ne","countryCode":"IN","country":"India","language":"Nepali"},{"code":"ne-NP","langCode":"ne","countryCode":"NP","country":"Nepal","language":"Nepali"},{"code":"nl-AW","langCode":"nl","countryCode":"AW","country":"Aruba","language":"Dutch; Flemish"},{"code":"nl-BE","langCode":"nl","countryCode":"BE","country":"Belgium","language":"Dutch; Flemish"},{"code":"nl-BQ","langCode":"nl","countryCode":"BQ","country":"Bonaire, Sint Eustatius and Saba","language":"Dutch; Flemish"},{"code":"nl-CW","langCode":"nl","countryCode":"CW","country":"Cura\xe7ao","language":"Dutch; Flemish"},{"code":"nl-NL","langCode":"nl","countryCode":"NL","country":"Netherlands","language":"Dutch; Flemish"},{"code":"nl-SR","langCode":"nl","countryCode":"SR","country":"Suriname","language":"Dutch; Flemish"},{"code":"nl-SX","langCode":"nl","countryCode":"SX","country":"Sint Maarten (Dutch part)","language":"Dutch; Flemish"},{"code":"nn-NO","langCode":"nn","countryCode":"NO","country":"Norway","language":"Norwegian Nynorsk; Nynorsk, Norwegian"},{"code":"om-ET","langCode":"om","countryCode":"ET","country":"Ethiopia","language":"Oromo"},{"code":"om-KE","langCode":"om","countryCode":"KE","country":"Kenya","language":"Oromo"},{"code":"or-IN","langCode":"or","countryCode":"IN","country":"India","language":"Oriya"},{"code":"os-GE","langCode":"os","countryCode":"GE","country":"Georgia","language":"Ossetian; Ossetic"},{"code":"os-RU","langCode":"os","countryCode":"RU","country":"Russian Federation","language":"Ossetian; Ossetic"},{"code":"pa-Arab-PK","langCode":"pa","countryCode":"PK","country":"Pakistan","language":"Panjabi; Punjabi"},{"code":"pa-Guru-IN","langCode":"pa","countryCode":"IN","country":"India","language":"Panjabi; Punjabi"},{"code":"pl-PL","langCode":"pl","countryCode":"PL","country":"Poland","language":"Polish"},{"code":"ps-AF","langCode":"ps","countryCode":"AF","country":"Afghanistan","language":"Pushto; Pashto"},{"code":"pt-AO","langCode":"pt","countryCode":"AO","country":"Angola","language":"Portuguese"},{"code":"pt-BR","langCode":"pt","countryCode":"BR","country":"Brazil","language":"Portuguese"},{"code":"pt-CH","langCode":"pt","countryCode":"CH","country":"Switzerland","language":"Portuguese"},{"code":"pt-CV","langCode":"pt","countryCode":"CV","country":"Cape Verde","language":"Portuguese"},{"code":"pt-GQ","langCode":"pt","countryCode":"GQ","country":"Equatorial Guinea","language":"Portuguese"},{"code":"pt-GW","langCode":"pt","countryCode":"GW","country":"Guinea-Bissau","language":"Portuguese"},{"code":"pt-LU","langCode":"pt","countryCode":"LU","country":"Luxembourg","language":"Portuguese"},{"code":"pt-MO","langCode":"pt","countryCode":"MO","country":"Macao","language":"Portuguese"},{"code":"pt-MZ","langCode":"pt","countryCode":"MZ","country":"Mozambique","language":"Portuguese"},{"code":"pt-PT","langCode":"pt","countryCode":"PT","country":"Portugal","language":"Portuguese"},{"code":"pt-ST","langCode":"pt","countryCode":"ST","country":"Sao Tome and Principe","language":"Portuguese"},{"code":"pt-TL","langCode":"pt","countryCode":"TL","country":"Timor-Leste","language":"Portuguese"},{"code":"qu-BO","langCode":"qu","countryCode":"BO","country":"Bolivia, Plurinational State of","language":"Quechua"},{"code":"qu-EC","langCode":"qu","countryCode":"EC","country":"Ecuador","language":"Quechua"},{"code":"qu-PE","langCode":"qu","countryCode":"PE","country":"Peru","language":"Quechua"},{"code":"rm-CH","langCode":"rm","countryCode":"CH","country":"Switzerland","language":"Romansh"},{"code":"rn-BI","langCode":"rn","countryCode":"BI","country":"Burundi","language":"Rundi"},{"code":"ro-MD","langCode":"ro","countryCode":"MD","country":"Moldova, Republic of","language":"Romanian; Moldavian; Moldovan"},{"code":"ro-RO","langCode":"ro","countryCode":"RO","country":"Romania","language":"Romanian; Moldavian; Moldovan"},{"code":"ru-BY","langCode":"ru","countryCode":"BY","country":"Belarus","language":"Russian"},{"code":"ru-KG","langCode":"ru","countryCode":"KG","country":"Kyrgyzstan","language":"Russian"},{"code":"ru-KZ","langCode":"ru","countryCode":"KZ","country":"Kazakhstan","language":"Russian"},{"code":"ru-MD","langCode":"ru","countryCode":"MD","country":"Moldova, Republic of","language":"Russian"},{"code":"ru-RU","langCode":"ru","countryCode":"RU","country":"Russian Federation","language":"Russian"},{"code":"ru-UA","langCode":"ru","countryCode":"UA","country":"Ukraine","language":"Russian"},{"code":"rw-RW","langCode":"rw","countryCode":"RW","country":"Rwanda","language":"Kinyarwanda"},{"code":"sd-PK","langCode":"sd","countryCode":"PK","country":"Pakistan","language":"Sindhi"},{"code":"se-FI","langCode":"se","countryCode":"FI","country":"Finland","language":"Northern Sami"},{"code":"se-NO","langCode":"se","countryCode":"NO","country":"Norway","language":"Northern Sami"},{"code":"se-SE","langCode":"se","countryCode":"SE","country":"Sweden","language":"Northern Sami"},{"code":"sg-CF","langCode":"sg","countryCode":"CF","country":"Central African Republic","language":"Sango"},{"code":"si-LK","langCode":"si","countryCode":"LK","country":"Sri Lanka","language":"Sinhala; Sinhalese"},{"code":"sk-SK","langCode":"sk","countryCode":"SK","country":"Slovakia","language":"Slovak"},{"code":"sl-SI","langCode":"sl","countryCode":"SI","country":"Slovenia","language":"Slovenian"},{"code":"sn-ZW","langCode":"sn","countryCode":"ZW","country":"Zimbabwe","language":"Shona"},{"code":"so-DJ","langCode":"so","countryCode":"DJ","country":"Djibouti","language":"Somali"},{"code":"so-ET","langCode":"so","countryCode":"ET","country":"Ethiopia","language":"Somali"},{"code":"so-KE","langCode":"so","countryCode":"KE","country":"Kenya","language":"Somali"},{"code":"so-SO","langCode":"so","countryCode":"SO","country":"Somalia","language":"Somali"},{"code":"sq-AL","langCode":"sq","countryCode":"AL","country":"Albania","language":"Albanian"},{"code":"sq-MK","langCode":"sq","countryCode":"MK","country":"Macedonia, the Former Yugoslav Republic of","language":"Albanian"},{"code":"sr-Cyrl-BA","langCode":"sr","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Serbian"},{"code":"sr-Cyrl-ME","langCode":"sr","countryCode":"ME","country":"Montenegro","language":"Serbian"},{"code":"sr-Cyrl-RS","langCode":"sr","countryCode":"RS","country":"Serbia","language":"Serbian"},{"code":"sr-Latn-BA","langCode":"sr","countryCode":"BA","country":"Bosnia and Herzegovina","language":"Serbian"},{"code":"sr-Latn-ME","langCode":"sr","countryCode":"ME","country":"Montenegro","language":"Serbian"},{"code":"sr-Latn-RS","langCode":"sr","countryCode":"RS","country":"Serbia","language":"Serbian"},{"code":"sv-AX","langCode":"sv","countryCode":"AX","country":"\xc5land Islands","language":"Swedish"},{"code":"sv-FI","langCode":"sv","countryCode":"FI","country":"Finland","language":"Swedish"},{"code":"sv-SE","langCode":"sv","countryCode":"SE","country":"Sweden","language":"Swedish"},{"code":"sw-CD","langCode":"sw","countryCode":"CD","country":"Congo, the Democratic Republic of the","language":"Swahili"},{"code":"sw-KE","langCode":"sw","countryCode":"KE","country":"Kenya","language":"Swahili"},{"code":"sw-TZ","langCode":"sw","countryCode":"TZ","country":"Tanzania, United Republic of","language":"Swahili"},{"code":"sw-UG","langCode":"sw","countryCode":"UG","country":"Uganda","language":"Swahili"},{"code":"ta-IN","langCode":"ta","countryCode":"IN","country":"India","language":"Tamil"},{"code":"ta-LK","langCode":"ta","countryCode":"LK","country":"Sri Lanka","language":"Tamil"},{"code":"ta-MY","langCode":"ta","countryCode":"MY","country":"Malaysia","language":"Tamil"},{"code":"ta-SG","langCode":"ta","countryCode":"SG","country":"Singapore","language":"Tamil"},{"code":"te-IN","langCode":"te","countryCode":"IN","country":"India","language":"Telugu"},{"code":"tg-TJ","langCode":"tg","countryCode":"TJ","country":"Tajikistan","language":"Tajik"},{"code":"th-TH","langCode":"th","countryCode":"TH","country":"Thailand","language":"Thai"},{"code":"ti-ER","langCode":"ti","countryCode":"ER","country":"Eritrea","language":"Tigrinya"},{"code":"ti-ET","langCode":"ti","countryCode":"ET","country":"Ethiopia","language":"Tigrinya"},{"code":"tk-TM","langCode":"tk","countryCode":"TM","country":"Turkmenistan","language":"Turkmen"},{"code":"to-TO","langCode":"to","countryCode":"TO","country":"Tonga","language":"Tonga (Tonga Islands)"},{"code":"tr-CY","langCode":"tr","countryCode":"CY","country":"Cyprus","language":"Turkish"},{"code":"tr-TR","langCode":"tr","countryCode":"TR","country":"Turkey","language":"Turkish"},{"code":"tt-RU","langCode":"tt","countryCode":"RU","country":"Russian Federation","language":"Tatar"},{"code":"ug-CN","langCode":"ug","countryCode":"CN","country":"China","language":"Uighur; Uyghur"},{"code":"uk-UA","langCode":"uk","countryCode":"UA","country":"Ukraine","language":"Ukrainian"},{"code":"ur-IN","langCode":"ur","countryCode":"IN","country":"India","language":"Urdu"},{"code":"ur-PK","langCode":"ur","countryCode":"PK","country":"Pakistan","language":"Urdu"},{"code":"uz-Arab-AF","langCode":"uz","countryCode":"AF","country":"Afghanistan","language":"Uzbek"},{"code":"uz-Cyrl-UZ","langCode":"uz","countryCode":"UZ","country":"Uzbekistan","language":"Uzbek"},{"code":"uz-Latn-UZ","langCode":"uz","countryCode":"UZ","country":"Uzbekistan","language":"Uzbek"},{"code":"vi-VN","langCode":"vi","countryCode":"VN","country":"Viet Nam","language":"Vietnamese"},{"code":"wo-SN","langCode":"wo","countryCode":"SN","country":"Senegal","language":"Wolof"},{"code":"xh-ZA","langCode":"xh","countryCode":"ZA","country":"South Africa","language":"Xhosa"},{"code":"yo-BJ","langCode":"yo","countryCode":"BJ","country":"Benin","language":"Yoruba"},{"code":"yo-NG","langCode":"yo","countryCode":"NG","country":"Nigeria","language":"Yoruba"},{"code":"zh-Hans-CN","langCode":"zh","countryCode":"CN","country":"China","language":"Chinese"},{"code":"zh-Hans-HK","langCode":"zh","countryCode":"HK","country":"Hong Kong","language":"Chinese"},{"code":"zh-Hans-MO","langCode":"zh","countryCode":"MO","country":"Macao","language":"Chinese"},{"code":"zh-Hans-SG","langCode":"zh","countryCode":"SG","country":"Singapore","language":"Chinese"},{"code":"zh-Hant-HK","langCode":"zh","countryCode":"HK","country":"Hong Kong","language":"Chinese"},{"code":"zh-Hant-MO","langCode":"zh","countryCode":"MO","country":"Macao","language":"Chinese"},{"code":"zh-Hant-TW","langCode":"zh","countryCode":"TW","country":"Taiwan, Province of China","language":"Chinese"},{"code":"zu-ZA","langCode":"zu","countryCode":"ZA","country":"South Africa","language":"Zulu"}]');

});



parcelRegister("5uSSv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400a52bc98b54394$export$2e2bcd8739ae039; });

var $egx7S = parcelRequire("egx7S");

var $1xzA7 = parcelRequire("1xzA7");
parcelRequire("dBifK");

var $d8hWe = parcelRequire("d8hWe");
parcelRequire("aJxsR");
parcelRequire("X1RuM");

var $cLLPo = parcelRequire("cLLPo");

var $lTrDt = parcelRequire("lTrDt");

var $kB03O = parcelRequire("kB03O");
parcelRequire("4iD0l");

var $flyUR = parcelRequire("flyUR");

var $f9Rb7 = parcelRequire("f9Rb7");

var $3NsHP = parcelRequire("3NsHP");

var $6vulY = parcelRequire("6vulY");
parcelRequire("kAeQh");
var $400a52bc98b54394$var$_dec, $400a52bc98b54394$var$_dec2, $400a52bc98b54394$var$_dec3, $400a52bc98b54394$var$_dec4, $400a52bc98b54394$var$_dec5, $400a52bc98b54394$var$_dec6, $400a52bc98b54394$var$_dec7, $400a52bc98b54394$var$_dec8, $400a52bc98b54394$var$_dec9, $400a52bc98b54394$var$_dec10, $400a52bc98b54394$var$_dec11, $400a52bc98b54394$var$_class, $400a52bc98b54394$var$_descriptor, $400a52bc98b54394$var$_descriptor2, $400a52bc98b54394$var$_descriptor3, $400a52bc98b54394$var$_descriptor4, $400a52bc98b54394$var$_descriptor5, $400a52bc98b54394$var$_descriptor6, $400a52bc98b54394$var$_descriptor7, $400a52bc98b54394$var$_descriptor8, $400a52bc98b54394$var$_descriptor9, $400a52bc98b54394$var$_descriptor10, $400a52bc98b54394$var$_descriptor11, $400a52bc98b54394$var$_descriptor12, $400a52bc98b54394$var$_descriptor13, $400a52bc98b54394$var$_descriptor14, $400a52bc98b54394$var$_descriptor15, $400a52bc98b54394$var$_descriptor16, $400a52bc98b54394$var$_descriptor17;
function $400a52bc98b54394$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $400a52bc98b54394$var$_defineProperty(e, r, t) {
    return (r = $400a52bc98b54394$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $400a52bc98b54394$var$_toPropertyKey(t) {
    var i = $400a52bc98b54394$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $400a52bc98b54394$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $400a52bc98b54394$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $400a52bc98b54394$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}




let $400a52bc98b54394$var$SessionStore = ($400a52bc98b54394$var$_dec = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec2 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec3 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec4 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec5 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec6 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec7 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec8 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec9 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec10 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_dec11 = (0, $d8hWe.action).bound, $400a52bc98b54394$var$_class = class SessionStore {
    setMigratedToV2(migrated) {
        this.migratedToV2 = migrated;
    }
    constructor(props){
        $400a52bc98b54394$var$_initializerDefineProperty(this, "profilePictureUrl", $400a52bc98b54394$var$_descriptor, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "emailVerified", $400a52bc98b54394$var$_descriptor2, this);
        // @observable expires = null
        $400a52bc98b54394$var$_initializerDefineProperty(this, "accountId", $400a52bc98b54394$var$_descriptor3, this);
        // Global account ID across all orgs
        $400a52bc98b54394$var$_initializerDefineProperty(this, "userId", $400a52bc98b54394$var$_descriptor4, this);
        // Org-specific staff ID
        $400a52bc98b54394$var$_initializerDefineProperty(this, "userPermissions", $400a52bc98b54394$var$_descriptor5, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "userEmail", $400a52bc98b54394$var$_descriptor6, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "userFirstName", $400a52bc98b54394$var$_descriptor7, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "userLastName", $400a52bc98b54394$var$_descriptor8, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "userCreatedAt", $400a52bc98b54394$var$_descriptor9, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "organisationId", $400a52bc98b54394$var$_descriptor10, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "organisationName", $400a52bc98b54394$var$_descriptor11, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "organisationCountry", $400a52bc98b54394$var$_descriptor12, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "state", $400a52bc98b54394$var$_descriptor13, this);
        //authenticated, checkingAuth, loggingIn
        $400a52bc98b54394$var$_initializerDefineProperty(this, "accounting", $400a52bc98b54394$var$_descriptor14, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "initialized", $400a52bc98b54394$var$_descriptor15, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "updateAvailable", $400a52bc98b54394$var$_descriptor16, this);
        $400a52bc98b54394$var$_initializerDefineProperty(this, "migratedToV2", $400a52bc98b54394$var$_descriptor17, this);
        (0, $d8hWe.makeObservable)(this);
        this.initialize();
    }
    async initialize() {
        await this.checkAuthentication();
        this.initialized = true;
    }
    get authenticated() {
        return this.state === "authenticated" && // this.expires && //TODO: handle with workos
        this.userId //&&
        ;
    }
    async login({ email: email, password: password, token: token } = {}) {
        this.state = "loggingIn";
        try {
            if (email && password) {
                // Use Better Auth signIn
                const { authClient: authClient } = await Promise.resolve((parcelRequire("2BEDj")));
                const response = await authClient.signIn.email({
                    email: email,
                    password: password
                });
                if (response.error) throw new Error(response.error.message || "Login failed");
                // Get the updated session after login
                await this.checkAuthentication();
                return response;
            } else if (token) // Handle token-based auth if needed (for compatibility)
            return await this.saveLoginResponse({
                data: token
            });
        } catch (error) {
            $flyUR.captureException(error);
            console.error(error);
            this.state = "unauthenticated";
            throw error;
        }
    }
    async saveLoginResponse(response) {
        //TODO for ryan: you can use WorkOs attributes to implement more logic later
        const { data: data } = response;
        //WorkOs attributes:
        this.emailVerified = data.emailVerified;
        this.profilePictureUrl = data.profilePictureUrl;
        // DB attributes
        this.userId = response.data.userId;
        this.userPermissions = response.data.userPermissions;
        this.userEmail = response.data.userEmail;
        this.userFirstName = response.data.userFirstName;
        this.userLastName = response.data.userLastName;
        this.userCreatedAt = response.data.userCreatedAt;
        this.organisationId = response.data.organisationId;
        this.organisationName = response.data.organisationName;
        this.organisationCountry = response.data.organisationCountry;
        // this.expires = add(new Date(), {
        //     days: 13,
        //     hours: 23,
        //     minutes: 50,
        // })
        await this.saveSession();
        this.createModels();
        return response;
    }
    async logout() {
        try {
            // Use Better Auth signOut
            const { authClient: authClient } = await Promise.resolve((parcelRequire("2BEDj")));
            await authClient.signOut();
            await this.clearCache();
        } catch (error) {
            console.error("Logout failed:", error);
            await this.clearCache();
        }
    }
    async saveSession(callback) {
        const session = {
            emailVerified: this.emailVerified,
            profilePictureUrl: this.profilePictureUrl,
            accountId: this.accountId,
            // Add accountId to saved session
            userId: this.userId,
            userPermissions: (0, $d8hWe.toJS)(this.userPermissions),
            userEmail: this.userEmail,
            userFirstName: this.userFirstName,
            userLastName: this.userLastName,
            userCreatedAt: this.userCreatedAt,
            organisationId: this.organisationId,
            organisationName: this.organisationName,
            organisationCountry: this.organisationCountry,
            // expires: this.expires && formatISO(this.expires),
            accounting: {
                expires: this.accounting.expires && (0, $egx7S.formatISO)(this.accounting.expires),
                system: this.accounting.system
            }
        };
        await (0, (/*@__PURE__*/$parcel$interopDefault($1xzA7))).setItem("session", session).then(()=>{
            this.state = "authenticated";
            callback && callback(session);
            return session;
        });
    }
    async clearCache() {
        const { collections: collections, aggregateCollections: aggregateCollections } = (parcelRequire("kR2qW"));
        await this.deleteSession();
        this.state = "unauthenticated";
        this.accountId = null;
        this.userId = null;
        this.userPermissions = null;
        this.userEmail = null;
        this.userFirstName = null;
        this.userLastName = null;
        this.userCreatedAt = null;
        this.organisationId = null;
        this.organisationName = null;
        this.organisationCountry = null;
        this.accounting = {};
        collections.forEach((collection)=>{
            collection.clear();
        });
        aggregateCollections.forEach((aggregate)=>{
            aggregate.clear();
        });
    }
    async deleteSession() {
        await (0, (/*@__PURE__*/$parcel$interopDefault($1xzA7))).removeItem("session");
    }
    async checkAuthentication(callback) {
        this.state = "checkingAuth";
        try {
            var _sessionResponse$data, _sessionResponse$data2;
            // Use Better Auth to get session
            const { authClient: authClient } = await Promise.resolve((parcelRequire("2BEDj")));
            const sessionResponse = await authClient.getSession();
            const session = sessionResponse === null || sessionResponse === void 0 ? void 0 : (_sessionResponse$data = sessionResponse.data) === null || _sessionResponse$data === void 0 ? void 0 : _sessionResponse$data.session;
            const user = sessionResponse === null || sessionResponse === void 0 ? void 0 : (_sessionResponse$data2 = sessionResponse.data) === null || _sessionResponse$data2 === void 0 ? void 0 : _sessionResponse$data2.user;
            if (!user || !session) this.state = "unauthenticated";
            else {
                var _user$name, _user$name2;
                this.state = "authenticated";
                // Map Better Auth user data to SessionStore properties
                this.emailVerified = user.emailVerified || false;
                this.profilePictureUrl = user.image;
                // Multi-org support: accountId is global, userId is org-specific staff.id
                this.accountId = user.accountId || user.id; // Global account ID
                this.userId = user.staffId || user.id; // Org-specific staff ID
                this.userEmail = user.email;
                this.userFirstName = user.firstName || ((_user$name = user.name) === null || _user$name === void 0 ? void 0 : _user$name.split(" ")[0]) || "";
                this.userLastName = user.lastName || ((_user$name2 = user.name) === null || _user$name2 === void 0 ? void 0 : _user$name2.split(" ").slice(1).join(" ")) || "";
                this.userCreatedAt = user.createdAt ? new Date(user.createdAt).getTime() : null;
                // Extended staff data from customSession plugin
                this.userPermissions = user.permissions || [];
                this.organisationId = user.organisationId || null;
                this.organisationName = user.organisationName || null;
                this.organisationCountry = user.organisationCountry || "au";
                // Keep accounting session handling
                const savedSession = await (0, (/*@__PURE__*/$parcel$interopDefault($1xzA7))).getItem("session");
                if (savedSession !== null && savedSession !== void 0 && savedSession.accounting) {
                    this.accounting.expires = savedSession.accounting.expires && (0, $egx7S.parseISO)(savedSession.accounting.expires);
                    this.accounting.system = savedSession.accounting.system;
                    this.resetAccountingTimeout();
                }
                this.createModels();
                // Save the updated session to localStorage for backup
                await this.saveSession();
            }
        } catch (error) {
            console.error("Better Auth session check failed:", error);
            this.state = "unauthenticated";
        }
        callback && callback();
    }
    createModels() {
        const user = this.createUserModel();
        const org = this.createOrganisationModel();
        // if (process.env.REACT_APP_ENV === 'production') {
        $flyUR.setUser({
            email: user.email
        });
        $flyUR.setTag("name", user.fullName);
        $flyUR.setTag("organisation", this.organisationName);
        (0, $f9Rb7.default).identify(user.email, // Replace 'distinct_id' with your user's unique identifier
        {
            email: user.email,
            name: user.fullName,
            organisation: this.organisationName
        } // optional: set additional user properties
        );
        (0, $f9Rb7.default).group("organisation", this.organisationId, {
            name: this.organisationName
        });
        // }
        window.Intercom("boot", {
            app_id: "k6prha3t",
            user_id: user.id,
            email: user.email,
            name: user.fullName,
            company: {
                name: this.organisationName,
                id: this.organisationId
            },
            created_at: this.userCreatedAt
        });
    }
    createUserModel() {
        const user = (0, $lTrDt.default).add({
            id: this.userId,
            permissions: this.userPermissions,
            email: this.userEmail,
            firstName: this.userFirstName,
            lastName: this.userLastName
        }, {
            trackUpdates: false
        });
        return user;
    }
    createOrganisationModel() {
        const organisation = (0, $cLLPo.default).add({
            id: this.organisationId,
            name: this.organisationName,
            country: this.organisationCountry
        }, {
            trackUpdates: false
        });
        return organisation;
    }
    async resetAccountingTimeout() {
        if (this.accounting.expires > new Date()) setTimeout(()=>{
            this.accounting.expires = null;
        }, this.accounting.expires - new Date());
    }
    async saveAccountingExpires(expires) {
        var _this$organisation;
        this.accounting.expires = expires;
        this.accounting.system = (_this$organisation = this.organisation) === null || _this$organisation === void 0 ? void 0 : _this$organisation.accountingSystem;
        await this.saveSession();
        this.resetAccountingTimeout();
    }
    get accountingConnected() {
        var _this$organisation2;
        return this.accounting.system === ((_this$organisation2 = this.organisation) === null || _this$organisation2 === void 0 ? void 0 : _this$organisation2.accountingSystem) && this.accounting.expires && this.accounting.expires > new Date();
    }
    get user() {
        return (0, $lTrDt.default).staffsById[this.userId];
    }
    get organisation() {
        return [
            ...(0, $cLLPo.default).organisations
        ][0];
    }
    get subscription() {
        return [
            ...(0, $kB03O.default).models
        ][0];
    }
    get settings() {
        var _this$organisation3;
        return {
            ...$400a52bc98b54394$export$6e121e085e95ad99,
            ...((_this$organisation3 = this.organisation) === null || _this$organisation3 === void 0 ? void 0 : _this$organisation3.settings) || {}
        };
    }
    async checkIfUpdateIsAvailable() {
        try {
            const versionData = await (0, $6vulY.getVersion)();
            // Safely extract and normalize deployed version
            const normalizeVersion = (version)=>{
                if (version == null || typeof version === "object") return null;
                return String(version).trim().replace(/^v/, ""); // Remove leading 'v' and whitespace
            };
            // Extract version with fallback priority: clientVersion → version → raw value
            let rawDeployedVersion;
            if (versionData && typeof versionData === "object") rawDeployedVersion = versionData.clientVersion || versionData.version || versionData;
            else rawDeployedVersion = versionData;
            const deployedClientVersion = normalizeVersion(rawDeployedVersion);
            const currentAppVersion = normalizeVersion((0, $3NsHP.version));
            if (deployedClientVersion && currentAppVersion && deployedClientVersion === currentAppVersion) this.updateAvailable = false;
            else if (deployedClientVersion && currentAppVersion) // No delay needed - database has the latest deployed version
            this.updateAvailable = true;
            else {
                // Unable to determine version, assume no update available
                this.updateAvailable = false;
                console.warn("Unable to extract valid version from server response:", versionData);
            }
        } catch (error) {
            // On error, assume no update is available and report to monitoring
            this.updateAvailable = false;
            // Report to Sentry with contextual details
            $flyUR.captureException(error, {
                tags: {
                    component: "SessionStore",
                    operation: "checkIfUpdateIsAvailable"
                },
                extra: {
                    currentAppVersion: (0, $3NsHP.version),
                    stack: error.stack
                }
            });
            // Report to PostHog for analytics
            (0, $f9Rb7.default).capture("version_check_failed", {
                error: error.message,
                currentAppVersion: (0, $3NsHP.version)
            });
            console.error("Failed to check for updates:", error);
        }
    }
}, $400a52bc98b54394$var$_descriptor = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "profilePictureUrl", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $400a52bc98b54394$var$_descriptor2 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "emailVerified", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $400a52bc98b54394$var$_descriptor3 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "accountId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor4 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "userId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor5 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "userPermissions", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor6 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "userEmail", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor7 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "userFirstName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor8 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "userLastName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor9 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "userCreatedAt", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor10 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "organisationId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor11 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "organisationName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor12 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "organisationCountry", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $400a52bc98b54394$var$_descriptor13 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "state", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "unauthenticated";
    }
}), $400a52bc98b54394$var$_descriptor14 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "accounting", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $400a52bc98b54394$var$_descriptor15 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "initialized", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $400a52bc98b54394$var$_descriptor16 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "updateAvailable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $400a52bc98b54394$var$_descriptor17 = $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "migratedToV2", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "setMigratedToV2", [
    $400a52bc98b54394$var$_dec
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "setMigratedToV2"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "initialize", [
    $400a52bc98b54394$var$_dec2
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "initialize"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "authenticated", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "authenticated"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "login", [
    $400a52bc98b54394$var$_dec3
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "login"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "saveLoginResponse", [
    $400a52bc98b54394$var$_dec4
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "saveLoginResponse"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "logout", [
    $400a52bc98b54394$var$_dec5
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "logout"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "saveSession", [
    $400a52bc98b54394$var$_dec6
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "saveSession"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "clearCache", [
    $400a52bc98b54394$var$_dec7
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "clearCache"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "deleteSession", [
    $400a52bc98b54394$var$_dec8
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "deleteSession"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "checkAuthentication", [
    $400a52bc98b54394$var$_dec9
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "checkAuthentication"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "resetAccountingTimeout", [
    $400a52bc98b54394$var$_dec10
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "resetAccountingTimeout"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "saveAccountingExpires", [
    $400a52bc98b54394$var$_dec11
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "saveAccountingExpires"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "accountingConnected", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "accountingConnected"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "user", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "user"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "organisation", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "organisation"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "subscription", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "subscription"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "settings", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "settings"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_applyDecoratedDescriptor($400a52bc98b54394$var$_class.prototype, "checkIfUpdateIsAvailable", [
    (0, $d8hWe.action)
], Object.getOwnPropertyDescriptor($400a52bc98b54394$var$_class.prototype, "checkIfUpdateIsAvailable"), $400a52bc98b54394$var$_class.prototype), $400a52bc98b54394$var$_class);
var $400a52bc98b54394$export$2e2bcd8739ae039 = new $400a52bc98b54394$var$SessionStore();
const $400a52bc98b54394$export$6e121e085e95ad99 = {
    sortPhasesBy: "startDate",
    allowNoPhase: true,
    useTasks: true,
    allowAfterPhaseEnd: true,
    timeEntryAllocations: [
        "noAllocations",
        "budgets",
        "allocations"
    ],
    timeEntryStatus: [
        "active",
        "prospective",
        "onHold",
        "archived"
    ],
    timeEntryFlags: [
        "billable",
        "variation",
        "overtime"
    ],
    autoPopulate: [],
    // ["budgets", "allocations"]
    updateHoursFromRevenue: false,
    updateRevenueFromHours: false,
    autoUpdateRevenue: {
        action: "ask",
        // "automatic", "never"
        adjustOnLoad: false,
        budget: "remaining",
        start: "now",
        end: "endDate"
    },
    autoUpdateHours: {
        action: "ask",
        // "automatic", "never"
        adjustOnLoad: false,
        budget: "remaining",
        start: "now",
        end: "endDate"
    },
    reportInvoiceDateType: "issueDate",
    savingInvoices: [
        "markTimeInvoiced"
    ] // "lockTime", "automatic"
};

});
parcelRegister("1xzA7", function(module, exports) {
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode("");
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== "undefined") {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ("document" in global1 && "onreadystatechange" in global1.document.createElement("script")) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement("script");
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    "REJECTED"
                ];
                var FULFILLED = [
                    "FULFILLED"
                ];
                var PENDING = [
                    "PENDING"
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === "function") {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === "function") {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === "error") return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === "error") onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = "success";
                    } catch (e) {
                        out.status = "error";
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    if (typeof global1.Promise !== "function") global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== "undefined") return indexedDB;
                        if (typeof webkitIndexedDB !== "undefined") return webkitIndexedDB;
                        if (typeof mozIndexedDB !== "undefined") return mozIndexedDB;
                        if (typeof OIndexedDB !== "undefined") return OIndexedDB;
                        if (typeof msIndexedDB !== "undefined") return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== "undefined";
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== "TypeError") throw e;
                        var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === "undefined") // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === "function") promise.then(callback);
                    if (typeof errorCallback === "function") promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== "string") {
                        console.warn(key + " used as a key, but it is not a string.");
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === "function") return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = "readonly";
                var READ_WRITE = "readwrite";
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ""
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === "boolean") return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === "ConstraintError") console.warn('The database "' + dbInfo.name + '"' + " has been upgraded from version " + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + " to version " + dbInfo.version + ".");
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || "");
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === "[object Blob]") return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: "asyncStorage",
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === "function";
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                var BLOB_TYPE_PREFIX = "~~local_forage_type~";
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = "__lfsc__:";
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = "arbf";
                var TYPE_BLOB = "blob";
                var TYPE_INT8ARRAY = "si08";
                var TYPE_UINT8ARRAY = "ui08";
                var TYPE_UINT8CLAMPEDARRAY = "uic8";
                var TYPE_INT16ARRAY = "si16";
                var TYPE_INT32ARRAY = "si32";
                var TYPE_UINT16ARRAY = "ur16";
                var TYPE_UINT32ARRAY = "ui32";
                var TYPE_FLOAT32ARRAY = "fl32";
                var TYPE_FLOAT64ARRAY = "fl64";
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === "=") {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === "=") bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = "";
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + "=";
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + "==";
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = "";
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === "[object Int8Array]") marker += TYPE_INT8ARRAY;
                            else if (valueType === "[object Uint8Array]") marker += TYPE_UINT8ARRAY;
                            else if (valueType === "[object Uint8ClampedArray]") marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === "[object Int16Array]") marker += TYPE_INT16ARRAY;
                            else if (valueType === "[object Uint16Array]") marker += TYPE_UINT16ARRAY;
                            else if (valueType === "[object Int32Array]") marker += TYPE_INT32ARRAY;
                            else if (valueType === "[object Uint32Array]") marker += TYPE_UINT32ARRAY;
                            else if (valueType === "[object Float32Array]") marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === "[object Float64Array]") marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error("Failed to get type for BinaryArray"));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === "[object Blob]") {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error("Unkown type: " + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " " + "(id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " " + "(key, value) VALUES (?, ?)", [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, "", "", 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: "webSQLStorage",
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + "/";
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + "/";
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = "_localforage_support_test";
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + "/");
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: "localStorageWrapper",
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === "[object Array]";
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    "dropInstance"
                ];
                var LibraryMethods = [
                    "clear",
                    "getItem",
                    "iterate",
                    "key",
                    "keys",
                    "length",
                    "removeItem",
                    "setItem"
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: "",
                    driver: DefaultDriverOrder.slice(),
                    name: "localforage",
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: "keyvaluepairs",
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === "storeName") options[i] = options[i].replace(/\W/g, "_");
                                if (i === "version" && typeof options[i] !== "number") return new Error("Database version must be a number.");
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ("driver" in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === "string") return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat("_initStorage");
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error("Method " + methodName + " is not implemented by the current driver");
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info("Redefining LocalForage driver: " + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ("_support" in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === "function") driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error("No available storage method found.");
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error("No available storage method found.");
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("X1RuM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("5irfN")).default; });
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $5irfN = parcelRequire("5irfN");

var $1mERp = parcelRequire("1mERp");
$parcel$exportWildcard(module.exports, $1mERp);

});
parcelRegister("5irfN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3db3c63757283ef9$export$2e2bcd8739ae039; });
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("1mERp");
var $io2G0 = parcelRequire("io2G0");
var $1mERp = parcelRequire("1mERp");
// Add all of the Underscore functions to the wrapper object.
var $3db3c63757283ef9$var$_ = (0, $io2G0.default)($1mERp);
// Legacy Node.js API.
$3db3c63757283ef9$var$_._ = $3db3c63757283ef9$var$_;
var // Export the Underscore API.
$3db3c63757283ef9$export$2e2bcd8739ae039 = $3db3c63757283ef9$var$_;

});
parcelRegister("1mERp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", function () { return (parcelRequire("84eop")).VERSION; });
$parcel$export(module.exports, "restArguments", function () { return (parcelRequire("iY6hn")).default; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("5QpJk")).default; });
$parcel$export(module.exports, "isNull", function () { return (parcelRequire("bUKLA")).default; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("9LZZa")).default; });
$parcel$export(module.exports, "isBoolean", function () { return (parcelRequire("4cZkp")).default; });
$parcel$export(module.exports, "isElement", function () { return (parcelRequire("igcuX")).default; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("hPjBY")).default; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("8tCOW")).default; });
$parcel$export(module.exports, "isDate", function () { return (parcelRequire("aDBR2")).default; });
$parcel$export(module.exports, "isRegExp", function () { return (parcelRequire("hhTbJ")).default; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("2Q3UX")).default; });
$parcel$export(module.exports, "isSymbol", function () { return (parcelRequire("gvNaE")).default; });
$parcel$export(module.exports, "isArrayBuffer", function () { return (parcelRequire("aFyf1")).default; });
$parcel$export(module.exports, "isDataView", function () { return (parcelRequire("aZvZf")).default; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("b2r1H")).default; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("3dDjE")).default; });
$parcel$export(module.exports, "isArguments", function () { return (parcelRequire("e8nZJ")).default; });
$parcel$export(module.exports, "isFinite", function () { return (parcelRequire("0456N")).default; });
$parcel$export(module.exports, "isNaN", function () { return (parcelRequire("6DTpz")).default; });
$parcel$export(module.exports, "isTypedArray", function () { return (parcelRequire("kdQxo")).default; });
$parcel$export(module.exports, "isEmpty", function () { return (parcelRequire("6bCiJ")).default; });
$parcel$export(module.exports, "isMatch", function () { return (parcelRequire("lnyAD")).default; });
$parcel$export(module.exports, "isEqual", function () { return (parcelRequire("aUbFk")).default; });
$parcel$export(module.exports, "isMap", function () { return (parcelRequire("OWtvP")).default; });
$parcel$export(module.exports, "isWeakMap", function () { return (parcelRequire("b5JJD")).default; });
$parcel$export(module.exports, "isSet", function () { return (parcelRequire("kmWmY")).default; });
$parcel$export(module.exports, "isWeakSet", function () { return (parcelRequire("36Lyi")).default; });
$parcel$export(module.exports, "keys", function () { return (parcelRequire("9viBt")).default; });
$parcel$export(module.exports, "allKeys", function () { return (parcelRequire("lopfo")).default; });
$parcel$export(module.exports, "values", function () { return (parcelRequire("9MytN")).default; });
$parcel$export(module.exports, "pairs", function () { return (parcelRequire("4UUMg")).default; });
$parcel$export(module.exports, "invert", function () { return (parcelRequire("g2Xjy")).default; });
$parcel$export(module.exports, "functions", function () { return (parcelRequire("ev47L")).default; });
$parcel$export(module.exports, "methods", function () { return (parcelRequire("ev47L")).default; });
$parcel$export(module.exports, "extend", function () { return (parcelRequire("LWD12")).default; });
$parcel$export(module.exports, "extendOwn", function () { return (parcelRequire("dBh4b")).default; });
$parcel$export(module.exports, "assign", function () { return (parcelRequire("dBh4b")).default; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("5AhXY")).default; });
$parcel$export(module.exports, "create", function () { return (parcelRequire("hWDvr")).default; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("ck8yF")).default; });
$parcel$export(module.exports, "tap", function () { return (parcelRequire("6j29v")).default; });
$parcel$export(module.exports, "get", function () { return (parcelRequire("8JRV0")).default; });
$parcel$export(module.exports, "has", function () { return (parcelRequire("bjVGH")).default; });
$parcel$export(module.exports, "mapObject", function () { return (parcelRequire("9xYcX")).default; });
$parcel$export(module.exports, "identity", function () { return (parcelRequire("BqYay")).default; });
$parcel$export(module.exports, "constant", function () { return (parcelRequire("cCzqU")).default; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("dR5hJ")).default; });
$parcel$export(module.exports, "toPath", function () { return (parcelRequire("3bjDJ")).default; });
$parcel$export(module.exports, "property", function () { return (parcelRequire("h68zj")).default; });
$parcel$export(module.exports, "propertyOf", function () { return (parcelRequire("iE4CW")).default; });
$parcel$export(module.exports, "matcher", function () { return (parcelRequire("g75Gx")).default; });
$parcel$export(module.exports, "matches", function () { return (parcelRequire("g75Gx")).default; });
$parcel$export(module.exports, "times", function () { return (parcelRequire("fRtHs")).default; });
$parcel$export(module.exports, "random", function () { return (parcelRequire("eVnOk")).default; });
$parcel$export(module.exports, "now", function () { return (parcelRequire("awXVh")).default; });
$parcel$export(module.exports, "escape", function () { return (parcelRequire("eCPg7")).default; });
$parcel$export(module.exports, "unescape", function () { return (parcelRequire("ld48J")).default; });
$parcel$export(module.exports, "templateSettings", function () { return (parcelRequire("1V0mX")).default; });
$parcel$export(module.exports, "template", function () { return (parcelRequire("1dazk")).default; });
$parcel$export(module.exports, "result", function () { return (parcelRequire("glUPC")).default; });
$parcel$export(module.exports, "uniqueId", function () { return (parcelRequire("1nuIB")).default; });
$parcel$export(module.exports, "chain", function () { return (parcelRequire("138vE")).default; });
$parcel$export(module.exports, "iteratee", function () { return (parcelRequire("duT4D")).default; });
$parcel$export(module.exports, "partial", function () { return (parcelRequire("ewvsj")).default; });
$parcel$export(module.exports, "bind", function () { return (parcelRequire("3Upb9")).default; });
$parcel$export(module.exports, "bindAll", function () { return (parcelRequire("3IulL")).default; });
$parcel$export(module.exports, "memoize", function () { return (parcelRequire("hLQJk")).default; });
$parcel$export(module.exports, "delay", function () { return (parcelRequire("d21hC")).default; });
$parcel$export(module.exports, "defer", function () { return (parcelRequire("ag1cD")).default; });
$parcel$export(module.exports, "throttle", function () { return (parcelRequire("4jn7S")).default; });
$parcel$export(module.exports, "debounce", function () { return (parcelRequire("gXFyo")).default; });
$parcel$export(module.exports, "wrap", function () { return (parcelRequire("hpUuY")).default; });
$parcel$export(module.exports, "negate", function () { return (parcelRequire("ea4Gf")).default; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("2aTd9")).default; });
$parcel$export(module.exports, "after", function () { return (parcelRequire("4upUg")).default; });
$parcel$export(module.exports, "before", function () { return (parcelRequire("7OAuh")).default; });
$parcel$export(module.exports, "once", function () { return (parcelRequire("iZQoD")).default; });
$parcel$export(module.exports, "findKey", function () { return (parcelRequire("6j6Ib")).default; });
$parcel$export(module.exports, "findIndex", function () { return (parcelRequire("3XTza")).default; });
$parcel$export(module.exports, "findLastIndex", function () { return (parcelRequire("boWO3")).default; });
$parcel$export(module.exports, "sortedIndex", function () { return (parcelRequire("dkAhk")).default; });
$parcel$export(module.exports, "indexOf", function () { return (parcelRequire("ga1Qz")).default; });
$parcel$export(module.exports, "lastIndexOf", function () { return (parcelRequire("939uC")).default; });
$parcel$export(module.exports, "find", function () { return (parcelRequire("2SXvI")).default; });
$parcel$export(module.exports, "detect", function () { return (parcelRequire("2SXvI")).default; });
$parcel$export(module.exports, "findWhere", function () { return (parcelRequire("gaqVy")).default; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("a6aZ4")).default; });
$parcel$export(module.exports, "forEach", function () { return (parcelRequire("a6aZ4")).default; });
$parcel$export(module.exports, "map", function () { return (parcelRequire("g8BFT")).default; });
$parcel$export(module.exports, "collect", function () { return (parcelRequire("g8BFT")).default; });
$parcel$export(module.exports, "reduce", function () { return (parcelRequire("OScQd")).default; });
$parcel$export(module.exports, "foldl", function () { return (parcelRequire("OScQd")).default; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("OScQd")).default; });
$parcel$export(module.exports, "reduceRight", function () { return (parcelRequire("3NCTw")).default; });
$parcel$export(module.exports, "foldr", function () { return (parcelRequire("3NCTw")).default; });
$parcel$export(module.exports, "filter", function () { return (parcelRequire("2Uqxs")).default; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("2Uqxs")).default; });
$parcel$export(module.exports, "reject", function () { return (parcelRequire("9rYx5")).default; });
$parcel$export(module.exports, "every", function () { return (parcelRequire("kB2QF")).default; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("kB2QF")).default; });
$parcel$export(module.exports, "some", function () { return (parcelRequire("bK3EC")).default; });
$parcel$export(module.exports, "any", function () { return (parcelRequire("bK3EC")).default; });
$parcel$export(module.exports, "contains", function () { return (parcelRequire("018EX")).default; });
$parcel$export(module.exports, "includes", function () { return (parcelRequire("018EX")).default; });
$parcel$export(module.exports, "include", function () { return (parcelRequire("018EX")).default; });
$parcel$export(module.exports, "invoke", function () { return (parcelRequire("DoBWh")).default; });
$parcel$export(module.exports, "pluck", function () { return (parcelRequire("iknOH")).default; });
$parcel$export(module.exports, "where", function () { return (parcelRequire("2Jmhc")).default; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("fFtPI")).default; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("bsurc")).default; });
$parcel$export(module.exports, "shuffle", function () { return (parcelRequire("4EDj9")).default; });
$parcel$export(module.exports, "sample", function () { return (parcelRequire("c5IHR")).default; });
$parcel$export(module.exports, "sortBy", function () { return (parcelRequire("jXEkv")).default; });
$parcel$export(module.exports, "groupBy", function () { return (parcelRequire("ibVrm")).default; });
$parcel$export(module.exports, "indexBy", function () { return (parcelRequire("NrrqR")).default; });
$parcel$export(module.exports, "countBy", function () { return (parcelRequire("04PEb")).default; });
$parcel$export(module.exports, "partition", function () { return (parcelRequire("fb64c")).default; });
$parcel$export(module.exports, "toArray", function () { return (parcelRequire("7v4vT")).default; });
$parcel$export(module.exports, "size", function () { return (parcelRequire("98OEV")).default; });
$parcel$export(module.exports, "pick", function () { return (parcelRequire("lhMKl")).default; });
$parcel$export(module.exports, "omit", function () { return (parcelRequire("fUlw4")).default; });
$parcel$export(module.exports, "first", function () { return (parcelRequire("8qOWH")).default; });
$parcel$export(module.exports, "head", function () { return (parcelRequire("8qOWH")).default; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("8qOWH")).default; });
$parcel$export(module.exports, "initial", function () { return (parcelRequire("e5a0W")).default; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("4UCuP")).default; });
$parcel$export(module.exports, "rest", function () { return (parcelRequire("3wjWy")).default; });
$parcel$export(module.exports, "tail", function () { return (parcelRequire("3wjWy")).default; });
$parcel$export(module.exports, "drop", function () { return (parcelRequire("3wjWy")).default; });
$parcel$export(module.exports, "compact", function () { return (parcelRequire("3W95A")).default; });
$parcel$export(module.exports, "flatten", function () { return (parcelRequire("h5lV0")).default; });
$parcel$export(module.exports, "without", function () { return (parcelRequire("7xd8Q")).default; });
$parcel$export(module.exports, "uniq", function () { return (parcelRequire("jThen")).default; });
$parcel$export(module.exports, "unique", function () { return (parcelRequire("jThen")).default; });
$parcel$export(module.exports, "union", function () { return (parcelRequire("j2Hi3")).default; });
$parcel$export(module.exports, "intersection", function () { return (parcelRequire("94LF3")).default; });
$parcel$export(module.exports, "difference", function () { return (parcelRequire("inPGW")).default; });
$parcel$export(module.exports, "unzip", function () { return (parcelRequire("cLFHl")).default; });
$parcel$export(module.exports, "transpose", function () { return (parcelRequire("cLFHl")).default; });
$parcel$export(module.exports, "zip", function () { return (parcelRequire("gu5Mp")).default; });
$parcel$export(module.exports, "object", function () { return (parcelRequire("gWkep")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("eakIE")).default; });
$parcel$export(module.exports, "chunk", function () { return (parcelRequire("4Rksq")).default; });
$parcel$export(module.exports, "mixin", function () { return (parcelRequire("io2G0")).default; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("k0Ikh")).default; });
// Named Exports
// =============
//     Underscore.js 1.13.7
//     https://underscorejs.org
//     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $84eop = parcelRequire("84eop");

var $iY6hn = parcelRequire("iY6hn");

var $5QpJk = parcelRequire("5QpJk");

var $bUKLA = parcelRequire("bUKLA");

var $9LZZa = parcelRequire("9LZZa");

var $4cZkp = parcelRequire("4cZkp");

var $igcuX = parcelRequire("igcuX");

var $hPjBY = parcelRequire("hPjBY");

var $8tCOW = parcelRequire("8tCOW");

var $aDBR2 = parcelRequire("aDBR2");

var $hhTbJ = parcelRequire("hhTbJ");

var $2Q3UX = parcelRequire("2Q3UX");

var $gvNaE = parcelRequire("gvNaE");

var $aFyf1 = parcelRequire("aFyf1");

var $aZvZf = parcelRequire("aZvZf");

var $b2r1H = parcelRequire("b2r1H");

var $3dDjE = parcelRequire("3dDjE");

var $e8nZJ = parcelRequire("e8nZJ");

var $0456N = parcelRequire("0456N");

var $6DTpz = parcelRequire("6DTpz");

var $kdQxo = parcelRequire("kdQxo");

var $6bCiJ = parcelRequire("6bCiJ");

var $lnyAD = parcelRequire("lnyAD");

var $aUbFk = parcelRequire("aUbFk");

var $OWtvP = parcelRequire("OWtvP");

var $b5JJD = parcelRequire("b5JJD");

var $kmWmY = parcelRequire("kmWmY");

var $36Lyi = parcelRequire("36Lyi");

var $9viBt = parcelRequire("9viBt");

var $lopfo = parcelRequire("lopfo");

var $9MytN = parcelRequire("9MytN");

var $4UUMg = parcelRequire("4UUMg");

var $g2Xjy = parcelRequire("g2Xjy");

var $ev47L = parcelRequire("ev47L");

var $LWD12 = parcelRequire("LWD12");

var $dBh4b = parcelRequire("dBh4b");

var $5AhXY = parcelRequire("5AhXY");

var $hWDvr = parcelRequire("hWDvr");

var $ck8yF = parcelRequire("ck8yF");

var $6j29v = parcelRequire("6j29v");

var $8JRV0 = parcelRequire("8JRV0");

var $bjVGH = parcelRequire("bjVGH");

var $9xYcX = parcelRequire("9xYcX");

var $BqYay = parcelRequire("BqYay");

var $cCzqU = parcelRequire("cCzqU");

var $dR5hJ = parcelRequire("dR5hJ");

var $3bjDJ = parcelRequire("3bjDJ");

var $h68zj = parcelRequire("h68zj");

var $iE4CW = parcelRequire("iE4CW");

var $g75Gx = parcelRequire("g75Gx");

var $fRtHs = parcelRequire("fRtHs");

var $eVnOk = parcelRequire("eVnOk");

var $awXVh = parcelRequire("awXVh");

var $eCPg7 = parcelRequire("eCPg7");

var $ld48J = parcelRequire("ld48J");

var $1V0mX = parcelRequire("1V0mX");

var $1dazk = parcelRequire("1dazk");

var $glUPC = parcelRequire("glUPC");

var $1nuIB = parcelRequire("1nuIB");

var $138vE = parcelRequire("138vE");

var $duT4D = parcelRequire("duT4D");

var $ewvsj = parcelRequire("ewvsj");

var $3Upb9 = parcelRequire("3Upb9");

var $3IulL = parcelRequire("3IulL");

var $hLQJk = parcelRequire("hLQJk");

var $d21hC = parcelRequire("d21hC");

var $ag1cD = parcelRequire("ag1cD");

var $4jn7S = parcelRequire("4jn7S");

var $gXFyo = parcelRequire("gXFyo");

var $hpUuY = parcelRequire("hpUuY");

var $ea4Gf = parcelRequire("ea4Gf");

var $2aTd9 = parcelRequire("2aTd9");

var $4upUg = parcelRequire("4upUg");

var $7OAuh = parcelRequire("7OAuh");

var $iZQoD = parcelRequire("iZQoD");

var $6j6Ib = parcelRequire("6j6Ib");

var $3XTza = parcelRequire("3XTza");

var $boWO3 = parcelRequire("boWO3");

var $dkAhk = parcelRequire("dkAhk");

var $ga1Qz = parcelRequire("ga1Qz");

var $939uC = parcelRequire("939uC");

var $2SXvI = parcelRequire("2SXvI");

var $gaqVy = parcelRequire("gaqVy");

var $a6aZ4 = parcelRequire("a6aZ4");

var $g8BFT = parcelRequire("g8BFT");

var $OScQd = parcelRequire("OScQd");

var $3NCTw = parcelRequire("3NCTw");

var $2Uqxs = parcelRequire("2Uqxs");

var $9rYx5 = parcelRequire("9rYx5");

var $kB2QF = parcelRequire("kB2QF");

var $bK3EC = parcelRequire("bK3EC");

var $018EX = parcelRequire("018EX");

var $DoBWh = parcelRequire("DoBWh");

var $iknOH = parcelRequire("iknOH");

var $2Jmhc = parcelRequire("2Jmhc");

var $fFtPI = parcelRequire("fFtPI");

var $bsurc = parcelRequire("bsurc");

var $4EDj9 = parcelRequire("4EDj9");

var $c5IHR = parcelRequire("c5IHR");

var $jXEkv = parcelRequire("jXEkv");

var $ibVrm = parcelRequire("ibVrm");

var $NrrqR = parcelRequire("NrrqR");

var $04PEb = parcelRequire("04PEb");

var $fb64c = parcelRequire("fb64c");

var $7v4vT = parcelRequire("7v4vT");

var $98OEV = parcelRequire("98OEV");

var $lhMKl = parcelRequire("lhMKl");

var $fUlw4 = parcelRequire("fUlw4");

var $8qOWH = parcelRequire("8qOWH");

var $e5a0W = parcelRequire("e5a0W");

var $4UCuP = parcelRequire("4UCuP");

var $3wjWy = parcelRequire("3wjWy");

var $3W95A = parcelRequire("3W95A");

var $h5lV0 = parcelRequire("h5lV0");

var $7xd8Q = parcelRequire("7xd8Q");

var $jThen = parcelRequire("jThen");

var $j2Hi3 = parcelRequire("j2Hi3");

var $94LF3 = parcelRequire("94LF3");

var $inPGW = parcelRequire("inPGW");

var $cLFHl = parcelRequire("cLFHl");

var $gu5Mp = parcelRequire("gu5Mp");

var $gWkep = parcelRequire("gWkep");

var $eakIE = parcelRequire("eakIE");

var $4Rksq = parcelRequire("4Rksq");

var $io2G0 = parcelRequire("io2G0");

var $k0Ikh = parcelRequire("k0Ikh");

});
parcelRegister("84eop", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $5df9dc86f8cd0fd4$export$a4ad2735b021c132; });
$parcel$export(module.exports, "root", function () { return $5df9dc86f8cd0fd4$export$e8e78c978b129247; });
$parcel$export(module.exports, "ArrayProto", function () { return $5df9dc86f8cd0fd4$export$aabeece9448a227a; });
$parcel$export(module.exports, "ObjProto", function () { return $5df9dc86f8cd0fd4$export$e77bb59b5e655b3d; });
$parcel$export(module.exports, "SymbolProto", function () { return $5df9dc86f8cd0fd4$export$e229dcb397ceea81; });
$parcel$export(module.exports, "push", function () { return $5df9dc86f8cd0fd4$export$4cbf152802aa238; });
$parcel$export(module.exports, "slice", function () { return $5df9dc86f8cd0fd4$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "toString", function () { return $5df9dc86f8cd0fd4$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $5df9dc86f8cd0fd4$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "supportsArrayBuffer", function () { return $5df9dc86f8cd0fd4$export$20eaf89d899ede58; });
$parcel$export(module.exports, "supportsDataView", function () { return $5df9dc86f8cd0fd4$export$a2e478ad34dac33e; });
$parcel$export(module.exports, "nativeIsArray", function () { return $5df9dc86f8cd0fd4$export$552cf9b635cef256; });
$parcel$export(module.exports, "nativeKeys", function () { return $5df9dc86f8cd0fd4$export$e676cf06d7fd2114; });
$parcel$export(module.exports, "nativeCreate", function () { return $5df9dc86f8cd0fd4$export$5b53dc95b548c58c; });
$parcel$export(module.exports, "nativeIsView", function () { return $5df9dc86f8cd0fd4$export$35fc70fc5e80d5a7; });
$parcel$export(module.exports, "_isNaN", function () { return $5df9dc86f8cd0fd4$export$a739ba33a90be0a1; });
$parcel$export(module.exports, "_isFinite", function () { return $5df9dc86f8cd0fd4$export$8b48b92f6c9d5ad; });
$parcel$export(module.exports, "hasEnumBug", function () { return $5df9dc86f8cd0fd4$export$7dcea4d27900b116; });
$parcel$export(module.exports, "nonEnumerableProps", function () { return $5df9dc86f8cd0fd4$export$f8fa596d5e31cb19; });
$parcel$export(module.exports, "MAX_ARRAY_INDEX", function () { return $5df9dc86f8cd0fd4$export$63b3abc5cd28bc48; });
// Current version.
var $5df9dc86f8cd0fd4$export$a4ad2735b021c132 = "1.13.7";
var $5df9dc86f8cd0fd4$export$e8e78c978b129247 = typeof self == "object" && self.self === self && self || typeof $parcel$global == "object" && $parcel$global.global === $parcel$global && $parcel$global || Function("return this")() || {};
var $5df9dc86f8cd0fd4$export$aabeece9448a227a = Array.prototype, $5df9dc86f8cd0fd4$export$e77bb59b5e655b3d = Object.prototype;
var $5df9dc86f8cd0fd4$export$e229dcb397ceea81 = typeof Symbol !== "undefined" ? Symbol.prototype : null;
var $5df9dc86f8cd0fd4$export$4cbf152802aa238 = $5df9dc86f8cd0fd4$export$aabeece9448a227a.push, $5df9dc86f8cd0fd4$export$58adb3bec8346d0f = $5df9dc86f8cd0fd4$export$aabeece9448a227a.slice, $5df9dc86f8cd0fd4$export$f84e8e69fd4488a5 = $5df9dc86f8cd0fd4$export$e77bb59b5e655b3d.toString, $5df9dc86f8cd0fd4$export$5a15a386532a5ea4 = $5df9dc86f8cd0fd4$export$e77bb59b5e655b3d.hasOwnProperty;
var $5df9dc86f8cd0fd4$export$20eaf89d899ede58 = typeof ArrayBuffer !== "undefined", $5df9dc86f8cd0fd4$export$a2e478ad34dac33e = typeof DataView !== "undefined";
var $5df9dc86f8cd0fd4$export$552cf9b635cef256 = Array.isArray, $5df9dc86f8cd0fd4$export$e676cf06d7fd2114 = Object.keys, $5df9dc86f8cd0fd4$export$5b53dc95b548c58c = Object.create, $5df9dc86f8cd0fd4$export$35fc70fc5e80d5a7 = $5df9dc86f8cd0fd4$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $5df9dc86f8cd0fd4$export$a739ba33a90be0a1 = isNaN, $5df9dc86f8cd0fd4$export$8b48b92f6c9d5ad = isFinite;
var $5df9dc86f8cd0fd4$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable("toString");
var $5df9dc86f8cd0fd4$export$f8fa596d5e31cb19 = [
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
var $5df9dc86f8cd0fd4$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("iY6hn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcf2b389707a1a6e$export$2e2bcd8739ae039; });
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $dcf2b389707a1a6e$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("5QpJk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4415c485ed3ab0f1$export$2e2bcd8739ae039; });
// Is a given variable an object?
function $4415c485ed3ab0f1$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === "function" || type === "object" && !!obj;
}

});

parcelRegister("bUKLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ac93382d5ec3ed9$export$2e2bcd8739ae039; });
// Is a given value equal to null?
function $8ac93382d5ec3ed9$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("9LZZa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71d895e8cd965db8$export$2e2bcd8739ae039; });
// Is a given variable undefined?
function $71d895e8cd965db8$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("4cZkp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3107dae65af7717e$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");
function $3107dae65af7717e$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $84eop.toString).call(obj) === "[object Boolean]";
}

});

parcelRegister("igcuX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4b36a80ea1f4092$export$2e2bcd8739ae039; });
// Is a given value a DOM element?
function $d4b36a80ea1f4092$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("hPjBY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfa6698b3231476a$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $cfa6698b3231476a$export$2e2bcd8739ae039 = (0, $ecfdt.default)("String");

});
parcelRegister("ecfdt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a55dfd50c51b1aa9$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");
function $a55dfd50c51b1aa9$export$2e2bcd8739ae039(name) {
    var tag = "[object " + name + "]";
    return function(obj) {
        return (0, $84eop.toString).call(obj) === tag;
    };
}

});


parcelRegister("8tCOW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62bf25263d63e312$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $62bf25263d63e312$export$2e2bcd8739ae039 = (0, $ecfdt.default)("Number");

});

parcelRegister("aDBR2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7beae904fcae1896$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $7beae904fcae1896$export$2e2bcd8739ae039 = (0, $ecfdt.default)("Date");

});

parcelRegister("hhTbJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c95ed56bfc9e27fb$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $c95ed56bfc9e27fb$export$2e2bcd8739ae039 = (0, $ecfdt.default)("RegExp");

});

parcelRegister("2Q3UX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21137a107ffa9554$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $21137a107ffa9554$export$2e2bcd8739ae039 = (0, $ecfdt.default)("Error");

});

parcelRegister("gvNaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c055aee4457a5c1c$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $c055aee4457a5c1c$export$2e2bcd8739ae039 = (0, $ecfdt.default)("Symbol");

});

parcelRegister("aFyf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02012a8162e318a7$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $02012a8162e318a7$export$2e2bcd8739ae039 = (0, $ecfdt.default)("ArrayBuffer");

});

parcelRegister("aZvZf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $800869d3b32096e3$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");

var $3dDjE = parcelRequire("3dDjE");

var $aFyf1 = parcelRequire("aFyf1");

var $kaPju = parcelRequire("kaPju");
var $800869d3b32096e3$var$isDataView = (0, $ecfdt.default)("DataView");
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $800869d3b32096e3$var$alternateIsDataView(obj) {
    return obj != null && (0, $3dDjE.default)(obj.getInt8) && (0, $aFyf1.default)(obj.buffer);
}
var $800869d3b32096e3$export$2e2bcd8739ae039 = (0, $kaPju.hasDataViewBug) ? $800869d3b32096e3$var$alternateIsDataView : $800869d3b32096e3$var$isDataView;

});
parcelRegister("3dDjE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25811559865a0627$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");

var $84eop = parcelRequire("84eop");
var $25811559865a0627$var$isFunction = (0, $ecfdt.default)("Function");
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $25811559865a0627$var$nodelist = (0, $84eop.root).document && (0, $84eop.root).document.childNodes;
if (typeof /./ != "function" && typeof Int8Array != "object" && typeof $25811559865a0627$var$nodelist != "function") $25811559865a0627$var$isFunction = function(obj) {
    return typeof obj == "function" || false;
};
var $25811559865a0627$export$2e2bcd8739ae039 = $25811559865a0627$var$isFunction;

});

parcelRegister("kaPju", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", function () { return $eafc8b927f45806a$export$29b9ed4126fa90ab; });
$parcel$export(module.exports, "isIE11", function () { return $eafc8b927f45806a$export$f7bad96d83325a34; });

var $84eop = parcelRequire("84eop");

var $2FBCQ = parcelRequire("2FBCQ");
var $eafc8b927f45806a$export$29b9ed4126fa90ab = (0, $84eop.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $2FBCQ.default)(new DataView(new ArrayBuffer(8)))), $eafc8b927f45806a$export$f7bad96d83325a34 = typeof Map !== "undefined" && (0, $2FBCQ.default)(new Map);

});
parcelRegister("2FBCQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f1c98bd611bad6b$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $1f1c98bd611bad6b$export$2e2bcd8739ae039 = (0, $ecfdt.default)("Object");

});



parcelRegister("b2r1H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8094d87a3d6ac681$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");

var $ecfdt = parcelRequire("ecfdt");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$8094d87a3d6ac681$export$2e2bcd8739ae039 = (0, $84eop.nativeIsArray) || (0, $ecfdt.default)("Array");

});

parcelRegister("e8nZJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4a46ce517061fac$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");

var $31CpI = parcelRequire("31CpI");
var $a4a46ce517061fac$var$isArguments = (0, $ecfdt.default)("Arguments");
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$a4a46ce517061fac$var$isArguments(arguments)) $a4a46ce517061fac$var$isArguments = function(obj) {
        return (0, $31CpI.default)(obj, "callee");
    };
})();
var $a4a46ce517061fac$export$2e2bcd8739ae039 = $a4a46ce517061fac$var$isArguments;

});
parcelRegister("31CpI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $233f4347bd4dab78$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");
function $233f4347bd4dab78$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $84eop.hasOwnProperty).call(obj, key);
}

});


parcelRegister("0456N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00c456483720c51d$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");

var $gvNaE = parcelRequire("gvNaE");
function $00c456483720c51d$export$2e2bcd8739ae039(obj) {
    return !(0, $gvNaE.default)(obj) && (0, $84eop._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("6DTpz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d615e2931e94275$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");

var $8tCOW = parcelRequire("8tCOW");
function $4d615e2931e94275$export$2e2bcd8739ae039(obj) {
    return (0, $8tCOW.default)(obj) && (0, $84eop._isNaN)(obj);
}

});

parcelRegister("kdQxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb8dc66484fe83a8$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");

var $aZvZf = parcelRequire("aZvZf");

var $cCzqU = parcelRequire("cCzqU");

var $l6ALd = parcelRequire("l6ALd");
// Is a given value a typed array?
var $eb8dc66484fe83a8$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $eb8dc66484fe83a8$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $84eop.nativeIsView) ? (0, $84eop.nativeIsView)(obj) && !(0, $aZvZf.default)(obj) : (0, $l6ALd.default)(obj) && $eb8dc66484fe83a8$var$typedArrayPattern.test((0, $84eop.toString).call(obj));
}
var $eb8dc66484fe83a8$export$2e2bcd8739ae039 = (0, $84eop.supportsArrayBuffer) ? $eb8dc66484fe83a8$var$isTypedArray : (0, $cCzqU.default)(false);

});
parcelRegister("cCzqU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $930484e8a9e56fad$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $930484e8a9e56fad$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("l6ALd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5d6ac5f62c79322$export$2e2bcd8739ae039; });

var $cNHx5 = parcelRequire("cNHx5");

var $jqt4Z = parcelRequire("jqt4Z");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$f5d6ac5f62c79322$export$2e2bcd8739ae039 = (0, $cNHx5.default)((0, $jqt4Z.default));

});
parcelRegister("cNHx5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $951bd456d88e22fb$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");
function $951bd456d88e22fb$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == "number" && sizeProperty >= 0 && sizeProperty <= (0, $84eop.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("jqt4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e247009e8bafd2d1$export$2e2bcd8739ae039; });

var $j4YVS = parcelRequire("j4YVS");
var // Internal helper to obtain the `byteLength` property of an object.
$e247009e8bafd2d1$export$2e2bcd8739ae039 = (0, $j4YVS.default)("byteLength");

});
parcelRegister("j4YVS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de3da7f9faa8caf6$export$2e2bcd8739ae039; });
// Internal helper to generate a function to obtain property `key` from `obj`.
function $de3da7f9faa8caf6$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("6bCiJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48117af444b54cb3$export$2e2bcd8739ae039; });

var $2XWsi = parcelRequire("2XWsi");

var $b2r1H = parcelRequire("b2r1H");

var $hPjBY = parcelRequire("hPjBY");

var $e8nZJ = parcelRequire("e8nZJ");

var $9viBt = parcelRequire("9viBt");
function $48117af444b54cb3$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $2XWsi.default)(obj);
    if (typeof length == "number" && ((0, $b2r1H.default)(obj) || (0, $hPjBY.default)(obj) || (0, $e8nZJ.default)(obj))) return length === 0;
    return (0, $2XWsi.default)((0, $9viBt.default)(obj)) === 0;
}

});
parcelRegister("2XWsi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $228e6f7d90782114$export$2e2bcd8739ae039; });

var $j4YVS = parcelRequire("j4YVS");
var // Internal helper to obtain the `length` property of an object.
$228e6f7d90782114$export$2e2bcd8739ae039 = (0, $j4YVS.default)("length");

});

parcelRegister("9viBt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eb57093eb4b92f1$export$2e2bcd8739ae039; });

var $5QpJk = parcelRequire("5QpJk");

var $84eop = parcelRequire("84eop");

var $31CpI = parcelRequire("31CpI");

var $frI5F = parcelRequire("frI5F");
function $6eb57093eb4b92f1$export$2e2bcd8739ae039(obj) {
    if (!(0, $5QpJk.default)(obj)) return [];
    if (0, $84eop.nativeKeys) return (0, $84eop.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $31CpI.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $84eop.hasEnumBug) (0, $frI5F.default)(obj, keys);
    return keys;
}

});
parcelRegister("frI5F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3eb940dc17f5e00$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");

var $3dDjE = parcelRequire("3dDjE");

var $31CpI = parcelRequire("31CpI");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $b3eb940dc17f5e00$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $b3eb940dc17f5e00$export$2e2bcd8739ae039(obj, keys) {
    keys = $b3eb940dc17f5e00$var$emulatedSet(keys);
    var nonEnumIdx = (0, $84eop.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $3dDjE.default)(constructor) && constructor.prototype || (0, $84eop.ObjProto);
    // Constructor is a special case.
    var prop = "constructor";
    if ((0, $31CpI.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $84eop.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("lnyAD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f90693c53646704d$export$2e2bcd8739ae039; });

var $9viBt = parcelRequire("9viBt");
function $f90693c53646704d$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $9viBt.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("aUbFk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f082ee275fb9efb$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");

var $84eop = parcelRequire("84eop");

var $jqt4Z = parcelRequire("jqt4Z");

var $kdQxo = parcelRequire("kdQxo");

var $3dDjE = parcelRequire("3dDjE");

var $kaPju = parcelRequire("kaPju");

var $aZvZf = parcelRequire("aZvZf");

var $9viBt = parcelRequire("9viBt");

var $31CpI = parcelRequire("31CpI");

var $7UvXN = parcelRequire("7UvXN");
// We use this string twice, so give it a name for minification.
var $7f082ee275fb9efb$var$tagDataView = "[object DataView]";
// Internal recursive comparison function for `_.isEqual`.
function $7f082ee275fb9efb$var$eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    return $7f082ee275fb9efb$var$deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `_.isEqual`.
function $7f082ee275fb9efb$var$deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof (0, $5vbGV.default)) a = a._wrapped;
    if (b instanceof (0, $5vbGV.default)) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = (0, $84eop.toString).call(a);
    if (className !== (0, $84eop.toString).call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if ((0, $kaPju.hasDataViewBug) && className == "[object Object]" && (0, $aZvZf.default)(a)) {
        if (!(0, $aZvZf.default)(b)) return false;
        className = $7f082ee275fb9efb$var$tagDataView;
    }
    switch(className){
        // These types are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (0, $84eop.SymbolProto).valueOf.call(a) === (0, $84eop.SymbolProto).valueOf.call(b);
        case "[object ArrayBuffer]":
        case $7f082ee275fb9efb$var$tagDataView:
            // Coerce to typed array so we can fall through.
            return $7f082ee275fb9efb$var$deepEq((0, $7UvXN.default)(a), (0, $7UvXN.default)(b), aStack, bStack);
    }
    var areArrays = className === "[object Array]";
    if (!areArrays && (0, $kdQxo.default)(a)) {
        var byteLength = (0, $jqt4Z.default)(a);
        if (byteLength !== (0, $jqt4Z.default)(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !((0, $3dDjE.default)(aCtor) && aCtor instanceof aCtor && (0, $3dDjE.default)(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$7f082ee275fb9efb$var$eq(a[length], b[length], aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var _keys = (0, $9viBt.default)(a), key;
        length = _keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if ((0, $9viBt.default)(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = _keys[length];
            if (!((0, $31CpI.default)(b, key) && $7f082ee275fb9efb$var$eq(a[key], b[key], aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $7f082ee275fb9efb$export$2e2bcd8739ae039(a, b) {
    return $7f082ee275fb9efb$var$eq(a, b);
}

});
parcelRegister("5vbGV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4018eaaa319249f1$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");
function $4018eaaa319249f1$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $4018eaaa319249f1$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $4018eaaa319249f1$export$2e2bcd8739ae039)) return new $4018eaaa319249f1$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$4018eaaa319249f1$export$2e2bcd8739ae039.VERSION = (0, $84eop.VERSION);
// Extracts the result from a wrapped and chained object.
$4018eaaa319249f1$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$4018eaaa319249f1$export$2e2bcd8739ae039.prototype.valueOf = $4018eaaa319249f1$export$2e2bcd8739ae039.prototype.toJSON = $4018eaaa319249f1$export$2e2bcd8739ae039.prototype.value;
$4018eaaa319249f1$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("7UvXN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c268ea572085705$export$2e2bcd8739ae039; });

var $jqt4Z = parcelRequire("jqt4Z");
function $5c268ea572085705$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $jqt4Z.default)(bufferSource));
}

});


parcelRegister("OWtvP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0992078b7a1139b0$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");

var $kaPju = parcelRequire("kaPju");

var $c36uX = parcelRequire("c36uX");
var $0992078b7a1139b0$export$2e2bcd8739ae039 = (0, $kaPju.isIE11) ? (0, $c36uX.ie11fingerprint)((0, $c36uX.mapMethods)) : (0, $ecfdt.default)("Map");

});
parcelRegister("c36uX", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", function () { return $8c5ace4b56df3ff1$export$15230eca1f400e40; });
$parcel$export(module.exports, "weakMapMethods", function () { return $8c5ace4b56df3ff1$export$2f74b890a72cf48; });
$parcel$export(module.exports, "mapMethods", function () { return $8c5ace4b56df3ff1$export$de9acb94190bb764; });
$parcel$export(module.exports, "setMethods", function () { return $8c5ace4b56df3ff1$export$60e14a5e2a057f78; });

var $2XWsi = parcelRequire("2XWsi");

var $3dDjE = parcelRequire("3dDjE");

var $lopfo = parcelRequire("lopfo");
function $8c5ace4b56df3ff1$export$15230eca1f400e40(methods) {
    var length = (0, $2XWsi.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $lopfo.default)(obj);
        if ((0, $2XWsi.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $3dDjE.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $8c5ace4b56df3ff1$export$2f74b890a72cf48 || !(0, $3dDjE.default)(obj[$8c5ace4b56df3ff1$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $8c5ace4b56df3ff1$var$forEachName = "forEach", $8c5ace4b56df3ff1$var$hasName = "has", $8c5ace4b56df3ff1$var$commonInit = [
    "clear",
    "delete"
], $8c5ace4b56df3ff1$var$mapTail = [
    "get",
    $8c5ace4b56df3ff1$var$hasName,
    "set"
];
var $8c5ace4b56df3ff1$export$de9acb94190bb764 = $8c5ace4b56df3ff1$var$commonInit.concat($8c5ace4b56df3ff1$var$forEachName, $8c5ace4b56df3ff1$var$mapTail), $8c5ace4b56df3ff1$export$2f74b890a72cf48 = $8c5ace4b56df3ff1$var$commonInit.concat($8c5ace4b56df3ff1$var$mapTail), $8c5ace4b56df3ff1$export$60e14a5e2a057f78 = [
    "add"
].concat($8c5ace4b56df3ff1$var$commonInit, $8c5ace4b56df3ff1$var$forEachName, $8c5ace4b56df3ff1$var$hasName);

});
parcelRegister("lopfo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f92f6c6ea3acf14c$export$2e2bcd8739ae039; });

var $5QpJk = parcelRequire("5QpJk");

var $84eop = parcelRequire("84eop");

var $frI5F = parcelRequire("frI5F");
function $f92f6c6ea3acf14c$export$2e2bcd8739ae039(obj) {
    if (!(0, $5QpJk.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $84eop.hasEnumBug) (0, $frI5F.default)(obj, keys);
    return keys;
}

});



parcelRegister("b5JJD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8133a35f23668dad$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");

var $kaPju = parcelRequire("kaPju");

var $c36uX = parcelRequire("c36uX");
var $8133a35f23668dad$export$2e2bcd8739ae039 = (0, $kaPju.isIE11) ? (0, $c36uX.ie11fingerprint)((0, $c36uX.weakMapMethods)) : (0, $ecfdt.default)("WeakMap");

});

parcelRegister("kmWmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed4323abea45a220$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");

var $kaPju = parcelRequire("kaPju");

var $c36uX = parcelRequire("c36uX");
var $ed4323abea45a220$export$2e2bcd8739ae039 = (0, $kaPju.isIE11) ? (0, $c36uX.ie11fingerprint)((0, $c36uX.setMethods)) : (0, $ecfdt.default)("Set");

});

parcelRegister("36Lyi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2436d17b1240e792$export$2e2bcd8739ae039; });

var $ecfdt = parcelRequire("ecfdt");
var $2436d17b1240e792$export$2e2bcd8739ae039 = (0, $ecfdt.default)("WeakSet");

});

parcelRegister("9MytN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71f357b366eb4cd9$export$2e2bcd8739ae039; });

var $9viBt = parcelRequire("9viBt");
function $71f357b366eb4cd9$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $9viBt.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("4UUMg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39486f35a50c5c10$export$2e2bcd8739ae039; });

var $9viBt = parcelRequire("9viBt");
function $39486f35a50c5c10$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $9viBt.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("g2Xjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baead7d928a2bda8$export$2e2bcd8739ae039; });

var $9viBt = parcelRequire("9viBt");
function $baead7d928a2bda8$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $9viBt.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("ev47L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e728e968f1a37e$export$2e2bcd8739ae039; });

var $3dDjE = parcelRequire("3dDjE");
function $a8e728e968f1a37e$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $3dDjE.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("LWD12", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0901de41daa03da9$export$2e2bcd8739ae039; });

var $khZwg = parcelRequire("khZwg");

var $lopfo = parcelRequire("lopfo");
var // Extend a given object with all the properties in passed-in object(s).
$0901de41daa03da9$export$2e2bcd8739ae039 = (0, $khZwg.default)((0, $lopfo.default));

});
parcelRegister("khZwg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec551da2034190d8$export$2e2bcd8739ae039; });
// An internal function for creating assigner functions.
function $ec551da2034190d8$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("dBh4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e6bf81984d7d4ed$export$2e2bcd8739ae039; });

var $khZwg = parcelRequire("khZwg");

var $9viBt = parcelRequire("9viBt");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$9e6bf81984d7d4ed$export$2e2bcd8739ae039 = (0, $khZwg.default)((0, $9viBt.default));

});

parcelRegister("5AhXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $410e4048caf91c9f$export$2e2bcd8739ae039; });

var $khZwg = parcelRequire("khZwg");

var $lopfo = parcelRequire("lopfo");
var // Fill in a given object with default properties.
$410e4048caf91c9f$export$2e2bcd8739ae039 = (0, $khZwg.default)((0, $lopfo.default), true);

});

parcelRegister("hWDvr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1067f85c1ba6074$export$2e2bcd8739ae039; });

var $j0nkQ = parcelRequire("j0nkQ");

var $dBh4b = parcelRequire("dBh4b");
function $d1067f85c1ba6074$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $j0nkQ.default)(prototype);
    if (props) (0, $dBh4b.default)(result, props);
    return result;
}

});
parcelRegister("j0nkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd601e457c2f4b8a$export$2e2bcd8739ae039; });

var $5QpJk = parcelRequire("5QpJk");

var $84eop = parcelRequire("84eop");
// Create a naked function reference for surrogate-prototype-swapping.
function $dd601e457c2f4b8a$var$ctor() {
    return function() {};
}
function $dd601e457c2f4b8a$export$2e2bcd8739ae039(prototype) {
    if (!(0, $5QpJk.default)(prototype)) return {};
    if (0, $84eop.nativeCreate) return (0, $84eop.nativeCreate)(prototype);
    var Ctor = $dd601e457c2f4b8a$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("ck8yF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f8dfdc6222bf06a$export$2e2bcd8739ae039; });

var $5QpJk = parcelRequire("5QpJk");

var $b2r1H = parcelRequire("b2r1H");

var $LWD12 = parcelRequire("LWD12");
function $8f8dfdc6222bf06a$export$2e2bcd8739ae039(obj) {
    if (!(0, $5QpJk.default)(obj)) return obj;
    return (0, $b2r1H.default)(obj) ? obj.slice() : (0, $LWD12.default)({}, obj);
}

});

parcelRegister("6j29v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49762fd459c36c14$export$2e2bcd8739ae039; });
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $49762fd459c36c14$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("8JRV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65cc59c18c305f84$export$2e2bcd8739ae039; });

var $3O0m9 = parcelRequire("3O0m9");

var $h1ag0 = parcelRequire("h1ag0");

var $9LZZa = parcelRequire("9LZZa");
function $65cc59c18c305f84$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $h1ag0.default)(object, (0, $3O0m9.default)(path));
    return (0, $9LZZa.default)(value) ? defaultValue : value;
}

});
parcelRegister("3O0m9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c56515668c7fc23$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");
parcelRequire("3bjDJ");
function $2c56515668c7fc23$export$2e2bcd8739ae039(path) {
    return (0, $5vbGV.default).toPath(path);
}

});
parcelRegister("3bjDJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2511a2424240298e$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");

var $b2r1H = parcelRequire("b2r1H");
function $2511a2424240298e$export$2e2bcd8739ae039(path) {
    return (0, $b2r1H.default)(path) ? path : [
        path
    ];
}
(0, $5vbGV.default).toPath = $2511a2424240298e$export$2e2bcd8739ae039;

});


parcelRegister("h1ag0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c63a7c803253a4fe$export$2e2bcd8739ae039; });
// Internal function to obtain a nested property in `obj` along `path`.
function $c63a7c803253a4fe$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("bjVGH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83de379d4d33e247$export$2e2bcd8739ae039; });

var $31CpI = parcelRequire("31CpI");

var $3O0m9 = parcelRequire("3O0m9");
function $83de379d4d33e247$export$2e2bcd8739ae039(obj, path) {
    path = (0, $3O0m9.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $31CpI.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("9xYcX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f35e62cc73eaa0b$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $9viBt = parcelRequire("9viBt");
function $6f35e62cc73eaa0b$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $kLK30.default)(iteratee, context);
    var _keys = (0, $9viBt.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("kLK30", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1ebea8777395647$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");

var $3Kx2y = parcelRequire("3Kx2y");

var $duT4D = parcelRequire("duT4D");
function $f1ebea8777395647$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $5vbGV.default).iteratee !== (0, $duT4D.default)) return (0, $5vbGV.default).iteratee(value, context);
    return (0, $3Kx2y.default)(value, context, argCount);
}

});
parcelRegister("3Kx2y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2baf4c129b414e60$export$2e2bcd8739ae039; });

var $BqYay = parcelRequire("BqYay");

var $3dDjE = parcelRequire("3dDjE");

var $5QpJk = parcelRequire("5QpJk");

var $b2r1H = parcelRequire("b2r1H");

var $g75Gx = parcelRequire("g75Gx");

var $h68zj = parcelRequire("h68zj");

var $eUNDo = parcelRequire("eUNDo");
function $2baf4c129b414e60$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $BqYay.default;
    if ((0, $3dDjE.default)(value)) return (0, $eUNDo.default)(value, context, argCount);
    if ((0, $5QpJk.default)(value) && !(0, $b2r1H.default)(value)) return (0, $g75Gx.default)(value);
    return (0, $h68zj.default)(value);
}

});
parcelRegister("BqYay", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $070860642202f6b2$export$2e2bcd8739ae039; });
// Keep the identity function around for default iteratees.
function $070860642202f6b2$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("g75Gx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbb1b5c132127995$export$2e2bcd8739ae039; });

var $dBh4b = parcelRequire("dBh4b");

var $lnyAD = parcelRequire("lnyAD");
function $bbb1b5c132127995$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $dBh4b.default)({}, attrs);
    return function(obj) {
        return (0, $lnyAD.default)(obj, attrs);
    };
}

});

parcelRegister("h68zj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c729a4ba0e780cde$export$2e2bcd8739ae039; });

var $h1ag0 = parcelRequire("h1ag0");

var $3O0m9 = parcelRequire("3O0m9");
function $c729a4ba0e780cde$export$2e2bcd8739ae039(path) {
    path = (0, $3O0m9.default)(path);
    return function(obj) {
        return (0, $h1ag0.default)(obj, path);
    };
}

});

parcelRegister("eUNDo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adbccc025ee890b9$export$2e2bcd8739ae039; });
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $adbccc025ee890b9$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("duT4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d38cc354fa2c866$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");

var $3Kx2y = parcelRequire("3Kx2y");
function $9d38cc354fa2c866$export$2e2bcd8739ae039(value, context) {
    return (0, $3Kx2y.default)(value, context, Infinity);
}
(0, $5vbGV.default).iteratee = $9d38cc354fa2c866$export$2e2bcd8739ae039;

});



parcelRegister("dR5hJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a164531bad7b9bed$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $a164531bad7b9bed$export$2e2bcd8739ae039() {}

});

parcelRegister("iE4CW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d92f8d4290da0c87$export$2e2bcd8739ae039; });

var $dR5hJ = parcelRequire("dR5hJ");

var $8JRV0 = parcelRequire("8JRV0");
function $d92f8d4290da0c87$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $dR5hJ.default;
    return function(path) {
        return (0, $8JRV0.default)(obj, path);
    };
}

});

parcelRegister("fRtHs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02fae273d9d3a33b$export$2e2bcd8739ae039; });

var $eUNDo = parcelRequire("eUNDo");
function $02fae273d9d3a33b$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $eUNDo.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("eVnOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $add8dbdbc04434d1$export$2e2bcd8739ae039; });
// Return a random integer between `min` and `max` (inclusive).
function $add8dbdbc04434d1$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("awXVh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aab5ff53a124948$export$2e2bcd8739ae039; });
// A (possibly faster) way to get the current timestamp as an integer.
var $7aab5ff53a124948$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("eCPg7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa5c6042216ba40d$export$2e2bcd8739ae039; });

var $fexz2 = parcelRequire("fexz2");

var $cVqKk = parcelRequire("cVqKk");
var // Function for escaping strings to HTML interpolation.
$aa5c6042216ba40d$export$2e2bcd8739ae039 = (0, $fexz2.default)((0, $cVqKk.default));

});
parcelRegister("fexz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b17232f2500253e2$export$2e2bcd8739ae039; });

var $9viBt = parcelRequire("9viBt");
function $b17232f2500253e2$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = "(?:" + (0, $9viBt.default)(map).join("|") + ")";
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, "g");
    return function(string) {
        string = string == null ? "" : "" + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("cVqKk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $968f8e2aff5588bc$export$2e2bcd8739ae039; });
// Internal list of HTML entities for escaping.
var $968f8e2aff5588bc$export$2e2bcd8739ae039 = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
};

});


parcelRegister("ld48J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f70e05f3d085017d$export$2e2bcd8739ae039; });

var $fexz2 = parcelRequire("fexz2");

var $fm1nG = parcelRequire("fm1nG");
var // Function for unescaping strings from HTML interpolation.
$f70e05f3d085017d$export$2e2bcd8739ae039 = (0, $fexz2.default)((0, $fm1nG.default));

});
parcelRegister("fm1nG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2d9fb50536240e5$export$2e2bcd8739ae039; });

var $g2Xjy = parcelRequire("g2Xjy");

var $cVqKk = parcelRequire("cVqKk");
var // Internal list of HTML entities for unescaping.
$b2d9fb50536240e5$export$2e2bcd8739ae039 = (0, $g2Xjy.default)((0, $cVqKk.default));

});


parcelRegister("1V0mX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $165b66a521659be5$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$165b66a521659be5$export$2e2bcd8739ae039 = (0, $5vbGV.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("1dazk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e1f3411240971b2$export$2e2bcd8739ae039; });

var $5AhXY = parcelRequire("5AhXY");

var $5vbGV = parcelRequire("5vbGV");
parcelRequire("1V0mX");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $0e1f3411240971b2$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $0e1f3411240971b2$var$escapes = {
    "'": "'",
    "\\": "\\",
    "\r": "r",
    "\n": "n",
    "\u2028": "u2028",
    "\u2029": "u2029"
};
var $0e1f3411240971b2$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $0e1f3411240971b2$var$escapeChar(match) {
    return "\\" + $0e1f3411240971b2$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $0e1f3411240971b2$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $0e1f3411240971b2$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $5AhXY.default)({}, settings, (0, $5vbGV.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $0e1f3411240971b2$var$noMatch).source,
        (settings.interpolate || $0e1f3411240971b2$var$noMatch).source,
        (settings.evaluate || $0e1f3411240971b2$var$noMatch).source
    ].join("|") + "|$", "g");
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($0e1f3411240971b2$var$escapeRegExp, $0e1f3411240971b2$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$0e1f3411240971b2$var$bareIdentifier.test(argument)) throw new Error("variable is not a bare identifier: " + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = "with(obj||{}){\n" + source + "}\n";
        argument = "obj";
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";
    var render;
    try {
        render = new Function(argument, "_", source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $5vbGV.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = "function(" + argument + "){\n" + source + "}";
    return template;
}

});

parcelRegister("glUPC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be7ab10beeb228b9$export$2e2bcd8739ae039; });

var $3dDjE = parcelRequire("3dDjE");

var $3O0m9 = parcelRequire("3O0m9");
function $be7ab10beeb228b9$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $3O0m9.default)(path);
    var length = path.length;
    if (!length) return (0, $3dDjE.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $3dDjE.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("1nuIB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $100fc4746d6cf93d$export$2e2bcd8739ae039; });
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $100fc4746d6cf93d$var$idCounter = 0;
function $100fc4746d6cf93d$export$2e2bcd8739ae039(prefix) {
    var id = ++$100fc4746d6cf93d$var$idCounter + "";
    return prefix ? prefix + id : id;
}

});

parcelRegister("138vE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c3cac0e583ef9e6$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");
function $0c3cac0e583ef9e6$export$2e2bcd8739ae039(obj) {
    var instance = (0, $5vbGV.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("ewvsj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a92c744b984a471e$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $dkunG = parcelRequire("dkunG");

var $5vbGV = parcelRequire("5vbGV");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $a92c744b984a471e$var$partial = (0, $iY6hn.default)(function(func, boundArgs) {
    var placeholder = $a92c744b984a471e$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $dkunG.default)(func, bound, this, this, args);
    };
    return bound;
});
$a92c744b984a471e$var$partial.placeholder = (0, $5vbGV.default);
var $a92c744b984a471e$export$2e2bcd8739ae039 = $a92c744b984a471e$var$partial;

});
parcelRegister("dkunG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b44b5a141233cde$export$2e2bcd8739ae039; });

var $j0nkQ = parcelRequire("j0nkQ");

var $5QpJk = parcelRequire("5QpJk");
function $9b44b5a141233cde$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $j0nkQ.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $5QpJk.default)(result)) return result;
    return self;
}

});


parcelRegister("3Upb9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d8a2208b785fef5$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $3dDjE = parcelRequire("3dDjE");

var $dkunG = parcelRequire("dkunG");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$2d8a2208b785fef5$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(func, context, args) {
    if (!(0, $3dDjE.default)(func)) throw new TypeError("Bind must be called on a function");
    var bound = (0, $iY6hn.default)(function(callArgs) {
        return (0, $dkunG.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("3IulL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b4d060545e328eb$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $5a7zr = parcelRequire("5a7zr");

var $3Upb9 = parcelRequire("3Upb9");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$2b4d060545e328eb$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(obj, keys) {
    keys = (0, $5a7zr.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error("bindAll must be passed function names");
    while(index--){
        var key = keys[index];
        obj[key] = (0, $3Upb9.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("5a7zr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c23c24cc63561b4$export$2e2bcd8739ae039; });

var $2XWsi = parcelRequire("2XWsi");

var $iXw4o = parcelRequire("iXw4o");

var $b2r1H = parcelRequire("b2r1H");

var $e8nZJ = parcelRequire("e8nZJ");
function $3c23c24cc63561b4$export$2e2bcd8739ae039(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) depth = Infinity;
    else if (depth <= 0) return output.concat(input);
    var idx = output.length;
    for(var i = 0, length = (0, $2XWsi.default)(input); i < length; i++){
        var value = input[i];
        if ((0, $iXw4o.default)(value) && ((0, $b2r1H.default)(value) || (0, $e8nZJ.default)(value))) {
            // Flatten current level of array or arguments object.
            if (depth > 1) {
                $3c23c24cc63561b4$export$2e2bcd8739ae039(value, depth - 1, strict, output);
                idx = output.length;
            } else {
                var j = 0, len = value.length;
                while(j < len)output[idx++] = value[j++];
            }
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("iXw4o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcd69d171f278bd4$export$2e2bcd8739ae039; });

var $cNHx5 = parcelRequire("cNHx5");

var $2XWsi = parcelRequire("2XWsi");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$dcd69d171f278bd4$export$2e2bcd8739ae039 = (0, $cNHx5.default)((0, $2XWsi.default));

});



parcelRegister("hLQJk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ceffba947507d389$export$2e2bcd8739ae039; });

var $31CpI = parcelRequire("31CpI");
function $ceffba947507d389$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = "" + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $31CpI.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("d21hC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97cc751542c72cce$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$97cc751542c72cce$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("ag1cD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $777c54d6fb4f4b44$export$2e2bcd8739ae039; });

var $ewvsj = parcelRequire("ewvsj");

var $d21hC = parcelRequire("d21hC");

var $5vbGV = parcelRequire("5vbGV");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$777c54d6fb4f4b44$export$2e2bcd8739ae039 = (0, $ewvsj.default)((0, $d21hC.default), (0, $5vbGV.default), 1);

});

parcelRegister("4jn7S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $323ae01c3b299e1b$export$2e2bcd8739ae039; });

var $awXVh = parcelRequire("awXVh");
function $323ae01c3b299e1b$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $awXVh.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $awXVh.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("gXFyo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c59263c048a75fe0$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $awXVh = parcelRequire("awXVh");
function $c59263c048a75fe0$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $awXVh.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $iY6hn.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $awXVh.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("hpUuY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cae098e923d3042b$export$2e2bcd8739ae039; });

var $ewvsj = parcelRequire("ewvsj");
function $cae098e923d3042b$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $ewvsj.default)(wrapper, func);
}

});

parcelRegister("ea4Gf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a91f812860f219$export$2e2bcd8739ae039; });
// Returns a negated version of the passed-in predicate.
function $02a91f812860f219$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("2aTd9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $195757b55ba0f07c$export$2e2bcd8739ae039; });
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $195757b55ba0f07c$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("4upUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $344e0f3f4a74d3fe$export$2e2bcd8739ae039; });
// Returns a function that will only be executed on and after the Nth call.
function $344e0f3f4a74d3fe$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("7OAuh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b09818e971f4bfc$export$2e2bcd8739ae039; });
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $5b09818e971f4bfc$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("iZQoD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd46914d4d32960c$export$2e2bcd8739ae039; });

var $ewvsj = parcelRequire("ewvsj");

var $7OAuh = parcelRequire("7OAuh");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$dd46914d4d32960c$export$2e2bcd8739ae039 = (0, $ewvsj.default)((0, $7OAuh.default), 2);

});

parcelRegister("6j6Ib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4979b93a6c716d89$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $9viBt = parcelRequire("9viBt");
function $4979b93a6c716d89$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $kLK30.default)(predicate, context);
    var _keys = (0, $9viBt.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("3XTza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e31fc169f58a912$export$2e2bcd8739ae039; });

var $cuxbw = parcelRequire("cuxbw");
var // Returns the first index on an array-like that passes a truth test.
$2e31fc169f58a912$export$2e2bcd8739ae039 = (0, $cuxbw.default)(1);

});
parcelRegister("cuxbw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $918207323fd2cb93$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $2XWsi = parcelRequire("2XWsi");
function $918207323fd2cb93$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $kLK30.default)(predicate, context);
        var length = (0, $2XWsi.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("boWO3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84cf8d4b7379450a$export$2e2bcd8739ae039; });

var $cuxbw = parcelRequire("cuxbw");
var // Returns the last index on an array-like that passes a truth test.
$84cf8d4b7379450a$export$2e2bcd8739ae039 = (0, $cuxbw.default)(-1);

});

parcelRegister("dkAhk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02812e97d885f684$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $2XWsi = parcelRequire("2XWsi");
function $02812e97d885f684$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $kLK30.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $2XWsi.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("ga1Qz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc3f0342fcd3b043$export$2e2bcd8739ae039; });

var $dkAhk = parcelRequire("dkAhk");

var $3XTza = parcelRequire("3XTza");

var $lsJPq = parcelRequire("lsJPq");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$bc3f0342fcd3b043$export$2e2bcd8739ae039 = (0, $lsJPq.default)(1, (0, $3XTza.default), (0, $dkAhk.default));

});
parcelRegister("lsJPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9ffc313b54a8d83$export$2e2bcd8739ae039; });

var $2XWsi = parcelRequire("2XWsi");

var $84eop = parcelRequire("84eop");

var $6DTpz = parcelRequire("6DTpz");
function $f9ffc313b54a8d83$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $2XWsi.default)(array);
        if (typeof idx == "number") {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $84eop.slice).call(array, i, length), (0, $6DTpz.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("939uC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $696bc1ef23b5d41f$export$2e2bcd8739ae039; });

var $boWO3 = parcelRequire("boWO3");

var $lsJPq = parcelRequire("lsJPq");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$696bc1ef23b5d41f$export$2e2bcd8739ae039 = (0, $lsJPq.default)(-1, (0, $boWO3.default));

});

parcelRegister("2SXvI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $219ec978ca246f6d$export$2e2bcd8739ae039; });

var $iXw4o = parcelRequire("iXw4o");

var $3XTza = parcelRequire("3XTza");

var $6j6Ib = parcelRequire("6j6Ib");
function $219ec978ca246f6d$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $iXw4o.default)(obj) ? (0, $3XTza.default) : (0, $6j6Ib.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("gaqVy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc5277b9827ec7ed$export$2e2bcd8739ae039; });

var $2SXvI = parcelRequire("2SXvI");

var $g75Gx = parcelRequire("g75Gx");
function $bc5277b9827ec7ed$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $2SXvI.default)(obj, (0, $g75Gx.default)(attrs));
}

});

parcelRegister("a6aZ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75a2fc1d8c680920$export$2e2bcd8739ae039; });

var $eUNDo = parcelRequire("eUNDo");

var $iXw4o = parcelRequire("iXw4o");

var $9viBt = parcelRequire("9viBt");
function $75a2fc1d8c680920$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $eUNDo.default)(iteratee, context);
    var i, length;
    if ((0, $iXw4o.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $9viBt.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("g8BFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbfa9e1629ec74c3$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $iXw4o = parcelRequire("iXw4o");

var $9viBt = parcelRequire("9viBt");
function $bbfa9e1629ec74c3$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $kLK30.default)(iteratee, context);
    var _keys = !(0, $iXw4o.default)(obj) && (0, $9viBt.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("OScQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $098eb7d4e0607e21$export$2e2bcd8739ae039; });

var $3BPCB = parcelRequire("3BPCB");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$098eb7d4e0607e21$export$2e2bcd8739ae039 = (0, $3BPCB.default)(1);

});
parcelRegister("3BPCB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a0cdecb93a33a62$export$2e2bcd8739ae039; });

var $iXw4o = parcelRequire("iXw4o");

var $9viBt = parcelRequire("9viBt");

var $eUNDo = parcelRequire("eUNDo");
function $2a0cdecb93a33a62$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $iXw4o.default)(obj) && (0, $9viBt.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $eUNDo.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("3NCTw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c441e55c42ceeba$export$2e2bcd8739ae039; });

var $3BPCB = parcelRequire("3BPCB");
var // The right-associative version of reduce, also known as `foldr`.
$2c441e55c42ceeba$export$2e2bcd8739ae039 = (0, $3BPCB.default)(-1);

});

parcelRegister("2Uqxs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21e565c4b2addef2$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $a6aZ4 = parcelRequire("a6aZ4");
function $21e565c4b2addef2$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $kLK30.default)(predicate, context);
    (0, $a6aZ4.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("9rYx5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e15973065bbf662$export$2e2bcd8739ae039; });

var $2Uqxs = parcelRequire("2Uqxs");

var $ea4Gf = parcelRequire("ea4Gf");

var $kLK30 = parcelRequire("kLK30");
function $6e15973065bbf662$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $2Uqxs.default)(obj, (0, $ea4Gf.default)((0, $kLK30.default)(predicate)), context);
}

});

parcelRegister("kB2QF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efe97901c3597c77$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $iXw4o = parcelRequire("iXw4o");

var $9viBt = parcelRequire("9viBt");
function $efe97901c3597c77$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $kLK30.default)(predicate, context);
    var _keys = !(0, $iXw4o.default)(obj) && (0, $9viBt.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("bK3EC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88c6d3376aeb199f$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $iXw4o = parcelRequire("iXw4o");

var $9viBt = parcelRequire("9viBt");
function $88c6d3376aeb199f$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $kLK30.default)(predicate, context);
    var _keys = !(0, $iXw4o.default)(obj) && (0, $9viBt.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("018EX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0036cfbeb3862148$export$2e2bcd8739ae039; });

var $iXw4o = parcelRequire("iXw4o");

var $9MytN = parcelRequire("9MytN");

var $ga1Qz = parcelRequire("ga1Qz");
function $0036cfbeb3862148$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $iXw4o.default)(obj)) obj = (0, $9MytN.default)(obj);
    if (typeof fromIndex != "number" || guard) fromIndex = 0;
    return (0, $ga1Qz.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("DoBWh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0766bbd9575a38ef$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $3dDjE = parcelRequire("3dDjE");

var $g8BFT = parcelRequire("g8BFT");

var $h1ag0 = parcelRequire("h1ag0");

var $3O0m9 = parcelRequire("3O0m9");
var // Invoke a method (with arguments) on every item in a collection.
$0766bbd9575a38ef$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $3dDjE.default)(path)) func = path;
    else {
        path = (0, $3O0m9.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $g8BFT.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $h1ag0.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("iknOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d57c91c647f48c04$export$2e2bcd8739ae039; });

var $g8BFT = parcelRequire("g8BFT");

var $h68zj = parcelRequire("h68zj");
function $d57c91c647f48c04$export$2e2bcd8739ae039(obj, key) {
    return (0, $g8BFT.default)(obj, (0, $h68zj.default)(key));
}

});

parcelRegister("2Jmhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fd110650a2f5dee$export$2e2bcd8739ae039; });

var $2Uqxs = parcelRequire("2Uqxs");

var $g75Gx = parcelRequire("g75Gx");
function $1fd110650a2f5dee$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $2Uqxs.default)(obj, (0, $g75Gx.default)(attrs));
}

});

parcelRegister("fFtPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b681d38fdb162ee5$export$2e2bcd8739ae039; });

var $iXw4o = parcelRequire("iXw4o");

var $9MytN = parcelRequire("9MytN");

var $kLK30 = parcelRequire("kLK30");

var $a6aZ4 = parcelRequire("a6aZ4");
function $b681d38fdb162ee5$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == "number" && typeof obj[0] != "object" && obj != null) {
        obj = (0, $iXw4o.default)(obj) ? obj : (0, $9MytN.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $kLK30.default)(iteratee, context);
        (0, $a6aZ4.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("bsurc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8579eb88253689e6$export$2e2bcd8739ae039; });

var $iXw4o = parcelRequire("iXw4o");

var $9MytN = parcelRequire("9MytN");

var $kLK30 = parcelRequire("kLK30");

var $a6aZ4 = parcelRequire("a6aZ4");
function $8579eb88253689e6$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == "number" && typeof obj[0] != "object" && obj != null) {
        obj = (0, $iXw4o.default)(obj) ? obj : (0, $9MytN.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $kLK30.default)(iteratee, context);
        (0, $a6aZ4.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("4EDj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3639638e8800e362$export$2e2bcd8739ae039; });

var $c5IHR = parcelRequire("c5IHR");
function $3639638e8800e362$export$2e2bcd8739ae039(obj) {
    return (0, $c5IHR.default)(obj, Infinity);
}

});
parcelRegister("c5IHR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cd8a16c073b7b2b$export$2e2bcd8739ae039; });

var $iXw4o = parcelRequire("iXw4o");

var $9MytN = parcelRequire("9MytN");

var $2XWsi = parcelRequire("2XWsi");

var $eVnOk = parcelRequire("eVnOk");

var $7v4vT = parcelRequire("7v4vT");
function $8cd8a16c073b7b2b$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $iXw4o.default)(obj)) obj = (0, $9MytN.default)(obj);
        return obj[(0, $eVnOk.default)(obj.length - 1)];
    }
    var sample = (0, $7v4vT.default)(obj);
    var length = (0, $2XWsi.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $eVnOk.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("7v4vT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $575eedf27fba4f02$export$2e2bcd8739ae039; });

var $b2r1H = parcelRequire("b2r1H");

var $84eop = parcelRequire("84eop");

var $hPjBY = parcelRequire("hPjBY");

var $iXw4o = parcelRequire("iXw4o");

var $g8BFT = parcelRequire("g8BFT");

var $BqYay = parcelRequire("BqYay");

var $9MytN = parcelRequire("9MytN");
// Safely create a real, live array from anything iterable.
var $575eedf27fba4f02$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $575eedf27fba4f02$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $b2r1H.default)(obj)) return (0, $84eop.slice).call(obj);
    if ((0, $hPjBY.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($575eedf27fba4f02$var$reStrSymbol);
    if ((0, $iXw4o.default)(obj)) return (0, $g8BFT.default)(obj, (0, $BqYay.default));
    return (0, $9MytN.default)(obj);
}

});



parcelRegister("jXEkv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e882cfad39425072$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $iknOH = parcelRequire("iknOH");

var $g8BFT = parcelRequire("g8BFT");
function $e882cfad39425072$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $kLK30.default)(iteratee, context);
    return (0, $iknOH.default)((0, $g8BFT.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), "value");
}

});

parcelRegister("ibVrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3e5cf83a45d5a28$export$2e2bcd8739ae039; });

var $6x2VN = parcelRequire("6x2VN");

var $31CpI = parcelRequire("31CpI");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$d3e5cf83a45d5a28$export$2e2bcd8739ae039 = (0, $6x2VN.default)(function(result, value, key) {
    if ((0, $31CpI.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("6x2VN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c18193939bf2422$export$2e2bcd8739ae039; });

var $kLK30 = parcelRequire("kLK30");

var $a6aZ4 = parcelRequire("a6aZ4");
function $4c18193939bf2422$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $kLK30.default)(iteratee, context);
        (0, $a6aZ4.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("NrrqR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0949dd04f980f267$export$2e2bcd8739ae039; });

var $6x2VN = parcelRequire("6x2VN");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$0949dd04f980f267$export$2e2bcd8739ae039 = (0, $6x2VN.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("04PEb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00e86fe25f28e94b$export$2e2bcd8739ae039; });

var $6x2VN = parcelRequire("6x2VN");

var $31CpI = parcelRequire("31CpI");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$00e86fe25f28e94b$export$2e2bcd8739ae039 = (0, $6x2VN.default)(function(result, value, key) {
    if ((0, $31CpI.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("fb64c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0cc96d283c8d770$export$2e2bcd8739ae039; });

var $6x2VN = parcelRequire("6x2VN");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$b0cc96d283c8d770$export$2e2bcd8739ae039 = (0, $6x2VN.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("98OEV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a7c283d90512fdb$export$2e2bcd8739ae039; });

var $iXw4o = parcelRequire("iXw4o");

var $9viBt = parcelRequire("9viBt");
function $6a7c283d90512fdb$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $iXw4o.default)(obj) ? obj.length : (0, $9viBt.default)(obj).length;
}

});

parcelRegister("lhMKl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7f0ff870162ce63$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $3dDjE = parcelRequire("3dDjE");

var $eUNDo = parcelRequire("eUNDo");

var $lopfo = parcelRequire("lopfo");

var $27X9Z = parcelRequire("27X9Z");

var $5a7zr = parcelRequire("5a7zr");
var // Return a copy of the object only containing the allowed properties.
$f7f0ff870162ce63$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $3dDjE.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $eUNDo.default)(iteratee, keys[1]);
        keys = (0, $lopfo.default)(obj);
    } else {
        iteratee = (0, $27X9Z.default);
        keys = (0, $5a7zr.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("27X9Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18ca202ce5224c2c$export$2e2bcd8739ae039; });
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $18ca202ce5224c2c$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("fUlw4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b94cc6a8ff06777f$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $3dDjE = parcelRequire("3dDjE");

var $ea4Gf = parcelRequire("ea4Gf");

var $g8BFT = parcelRequire("g8BFT");

var $5a7zr = parcelRequire("5a7zr");

var $018EX = parcelRequire("018EX");

var $lhMKl = parcelRequire("lhMKl");
var // Return a copy of the object without the disallowed properties.
$b94cc6a8ff06777f$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $3dDjE.default)(iteratee)) {
        iteratee = (0, $ea4Gf.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $g8BFT.default)((0, $5a7zr.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $018EX.default)(keys, key);
        };
    }
    return (0, $lhMKl.default)(obj, iteratee, context);
});

});

parcelRegister("8qOWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6238453aa6e00a19$export$2e2bcd8739ae039; });

var $e5a0W = parcelRequire("e5a0W");
function $6238453aa6e00a19$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $e5a0W.default)(array, array.length - n);
}

});
parcelRegister("e5a0W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4094ce97977bbec$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");
function $a4094ce97977bbec$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $84eop.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("4UCuP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $393a40eaa52f2b66$export$2e2bcd8739ae039; });

var $3wjWy = parcelRequire("3wjWy");
function $393a40eaa52f2b66$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $3wjWy.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("3wjWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2903d49bb6a986da$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");
function $2903d49bb6a986da$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $84eop.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("3W95A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dddd6cd612fb66c$export$2e2bcd8739ae039; });

var $2Uqxs = parcelRequire("2Uqxs");
function $2dddd6cd612fb66c$export$2e2bcd8739ae039(array) {
    return (0, $2Uqxs.default)(array, Boolean);
}

});

parcelRegister("h5lV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c703e7de20bd6704$export$2e2bcd8739ae039; });

var $5a7zr = parcelRequire("5a7zr");
function $c703e7de20bd6704$export$2e2bcd8739ae039(array, depth) {
    return (0, $5a7zr.default)(array, depth, false);
}

});

parcelRegister("7xd8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57c5cf226aa01728$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $inPGW = parcelRequire("inPGW");
var // Return a version of the array that does not contain the specified value(s).
$57c5cf226aa01728$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(array, otherArrays) {
    return (0, $inPGW.default)(array, otherArrays);
});

});
parcelRegister("inPGW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d62278d51fd73eb6$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $5a7zr = parcelRequire("5a7zr");

var $2Uqxs = parcelRequire("2Uqxs");

var $018EX = parcelRequire("018EX");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$d62278d51fd73eb6$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(array, rest) {
    rest = (0, $5a7zr.default)(rest, true, true);
    return (0, $2Uqxs.default)(array, function(value) {
        return !(0, $018EX.default)(rest, value);
    });
});

});


parcelRegister("jThen", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7b08517af609b38$export$2e2bcd8739ae039; });

var $4cZkp = parcelRequire("4cZkp");

var $kLK30 = parcelRequire("kLK30");

var $2XWsi = parcelRequire("2XWsi");

var $018EX = parcelRequire("018EX");
function $e7b08517af609b38$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $4cZkp.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $kLK30.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $2XWsi.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $018EX.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $018EX.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("j2Hi3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddcfc8bbc7c3a6a3$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $jThen = parcelRequire("jThen");

var $5a7zr = parcelRequire("5a7zr");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$ddcfc8bbc7c3a6a3$export$2e2bcd8739ae039 = (0, $iY6hn.default)(function(arrays) {
    return (0, $jThen.default)((0, $5a7zr.default)(arrays, true, true));
});

});

parcelRegister("94LF3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69b97548e1fcd7f3$export$2e2bcd8739ae039; });

var $2XWsi = parcelRequire("2XWsi");

var $018EX = parcelRequire("018EX");
function $69b97548e1fcd7f3$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $2XWsi.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $018EX.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $018EX.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("cLFHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94ba383490353729$export$2e2bcd8739ae039; });

var $fFtPI = parcelRequire("fFtPI");

var $2XWsi = parcelRequire("2XWsi");

var $iknOH = parcelRequire("iknOH");
function $94ba383490353729$export$2e2bcd8739ae039(array) {
    var length = array && (0, $fFtPI.default)(array, (0, $2XWsi.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $iknOH.default)(array, index);
    return result;
}

});

parcelRegister("gu5Mp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c003ee6d89e45a3e$export$2e2bcd8739ae039; });

var $iY6hn = parcelRequire("iY6hn");

var $cLFHl = parcelRequire("cLFHl");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$c003ee6d89e45a3e$export$2e2bcd8739ae039 = (0, $iY6hn.default)((0, $cLFHl.default));

});

parcelRegister("gWkep", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c551c1a231658cfb$export$2e2bcd8739ae039; });

var $2XWsi = parcelRequire("2XWsi");
function $c551c1a231658cfb$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $2XWsi.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("eakIE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a502123da02c1885$export$2e2bcd8739ae039; });
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $a502123da02c1885$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("4Rksq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $389bfb1880ad9262$export$2e2bcd8739ae039; });

var $84eop = parcelRequire("84eop");
function $389bfb1880ad9262$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $84eop.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("io2G0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d62c8b62a4814753$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");

var $a6aZ4 = parcelRequire("a6aZ4");

var $ev47L = parcelRequire("ev47L");

var $84eop = parcelRequire("84eop");

var $b2222 = parcelRequire("b2222");
function $d62c8b62a4814753$export$2e2bcd8739ae039(obj) {
    (0, $a6aZ4.default)((0, $ev47L.default)(obj), function(name) {
        var func = (0, $5vbGV.default)[name] = obj[name];
        (0, $5vbGV.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $84eop.push).apply(args, arguments);
            return (0, $b2222.default)(this, func.apply((0, $5vbGV.default), args));
        };
    });
    return 0, $5vbGV.default;
}

});
parcelRegister("b2222", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8081751467513d29$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");
function $8081751467513d29$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $5vbGV.default)(obj).chain() : obj;
}

});


parcelRegister("k0Ikh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91630f74e47fdf8$export$2e2bcd8739ae039; });

var $5vbGV = parcelRequire("5vbGV");

var $a6aZ4 = parcelRequire("a6aZ4");

var $84eop = parcelRequire("84eop");

var $b2222 = parcelRequire("b2222");
// Add all mutator `Array` functions to the wrapper.
(0, $a6aZ4.default)([
    "pop",
    "push",
    "reverse",
    "shift",
    "sort",
    "splice",
    "unshift"
], function(name) {
    var method = (0, $84eop.ArrayProto)[name];
    (0, $5vbGV.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === "shift" || name === "splice") && obj.length === 0) delete obj[0];
        }
        return (0, $b2222.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $a6aZ4.default)([
    "concat",
    "join",
    "slice"
], function(name) {
    var method = (0, $84eop.ArrayProto)[name];
    (0, $5vbGV.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $b2222.default)(this, obj);
    };
});
var $e91630f74e47fdf8$export$2e2bcd8739ae039 = (0, $5vbGV.default);

});




parcelRegister("cLLPo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94bef979a92ce670$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "OrganisationCollectionClass", function () { return $94bef979a92ce670$export$296d1b1c962329c4; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $2JNXN = parcelRequire("2JNXN");
var $94bef979a92ce670$var$_dec, $94bef979a92ce670$var$_dec2, $94bef979a92ce670$var$_class;
function $94bef979a92ce670$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $94bef979a92ce670$var$OrganisationCollection = ($94bef979a92ce670$var$_dec = (0, $d8hWe.action).bound, $94bef979a92ce670$var$_dec2 = (0, $d8hWe.action).bound, $94bef979a92ce670$var$_class = class OrganisationCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "organisations",
            modelClass: (0, $2JNXN.default)
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get organisationsById() {
        return this.modelsById;
    }
    get organisations() {
        return this.models;
    }
    addOrganisation(data) {
        this.add(data);
    }
    addOrganisations(data) {
        this.addMany(data);
    }
}, $94bef979a92ce670$var$_applyDecoratedDescriptor($94bef979a92ce670$var$_class.prototype, "addOrganisation", [
    $94bef979a92ce670$var$_dec
], Object.getOwnPropertyDescriptor($94bef979a92ce670$var$_class.prototype, "addOrganisation"), $94bef979a92ce670$var$_class.prototype), $94bef979a92ce670$var$_applyDecoratedDescriptor($94bef979a92ce670$var$_class.prototype, "addOrganisations", [
    $94bef979a92ce670$var$_dec2
], Object.getOwnPropertyDescriptor($94bef979a92ce670$var$_class.prototype, "addOrganisations"), $94bef979a92ce670$var$_class.prototype), $94bef979a92ce670$var$_class);
var $94bef979a92ce670$export$2e2bcd8739ae039 = new $94bef979a92ce670$var$OrganisationCollection();
const $94bef979a92ce670$export$296d1b1c962329c4 = $94bef979a92ce670$var$OrganisationCollection;

});
parcelRegister("2JNXN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fe68a6ea69993ff$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $b2aJ3 = parcelRequire("b2aJ3");

var $hXEZ6 = parcelRequire("hXEZ6");

var $d8iCu = parcelRequire("d8iCu");

var $dSNYz = parcelRequire("dSNYz");

var $33LHM = parcelRequire("33LHM");

var $iwvDr = parcelRequire("iwvDr");

var $dZHlf = parcelRequire("dZHlf");

var $cLLPo = parcelRequire("cLLPo");

var $2U4XU = parcelRequire("2U4XU");

var $gDUfk = parcelRequire("gDUfk");

var $iV9Vs = parcelRequire("iV9Vs");

var $2AfWp = parcelRequire("2AfWp");

var $fqmGV = parcelRequire("fqmGV");

var $8JmQX = parcelRequire("8JmQX");

var $gJY2D = parcelRequire("gJY2D");

var $aWaCW = parcelRequire("aWaCW");

var $lTrDt = parcelRequire("lTrDt");

var $cjCbh = parcelRequire("cjCbh");
var $1fe68a6ea69993ff$var$_dec, $1fe68a6ea69993ff$var$_dec2, $1fe68a6ea69993ff$var$_dec3, $1fe68a6ea69993ff$var$_class, $1fe68a6ea69993ff$var$_descriptor, $1fe68a6ea69993ff$var$_descriptor2, $1fe68a6ea69993ff$var$_descriptor3, $1fe68a6ea69993ff$var$_descriptor4, $1fe68a6ea69993ff$var$_descriptor5, $1fe68a6ea69993ff$var$_descriptor6, $1fe68a6ea69993ff$var$_descriptor7, $1fe68a6ea69993ff$var$_descriptor8, $1fe68a6ea69993ff$var$_descriptor9, $1fe68a6ea69993ff$var$_descriptor10, $1fe68a6ea69993ff$var$_descriptor11, $1fe68a6ea69993ff$var$_descriptor12, $1fe68a6ea69993ff$var$_descriptor13, $1fe68a6ea69993ff$var$_descriptor14;
function $1fe68a6ea69993ff$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $1fe68a6ea69993ff$var$_defineProperty(e, r, t) {
    return (r = $1fe68a6ea69993ff$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1fe68a6ea69993ff$var$_toPropertyKey(t) {
    var i = $1fe68a6ea69993ff$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1fe68a6ea69993ff$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1fe68a6ea69993ff$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $1fe68a6ea69993ff$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $1fe68a6ea69993ff$var$OrganisationModel = ($1fe68a6ea69993ff$var$_dec = (0, $d8hWe.action).bound, $1fe68a6ea69993ff$var$_dec2 = (0, $d8hWe.action).bound, $1fe68a6ea69993ff$var$_dec3 = (0, $d8hWe.action).bound, $1fe68a6ea69993ff$var$_class = class OrganisationModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "accountingSystem", $1fe68a6ea69993ff$var$_descriptor, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "settings", $1fe68a6ea69993ff$var$_descriptor2, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "defaultRevenueForecastReportId", $1fe68a6ea69993ff$var$_descriptor3, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "defaultResourceScheduleReportId", $1fe68a6ea69993ff$var$_descriptor4, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "defaultProjectReportId", $1fe68a6ea69993ff$var$_descriptor5, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "defaultStaffReportId", $1fe68a6ea69993ff$var$_descriptor6, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "defaultTimeReportId", $1fe68a6ea69993ff$var$_descriptor7, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "defaultInvoiceReportId", $1fe68a6ea69993ff$var$_descriptor8, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "defaultContactReportId", $1fe68a6ea69993ff$var$_descriptor9, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "defaultExpenseReportId", $1fe68a6ea69993ff$var$_descriptor10, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "creatorStaffMemberId", $1fe68a6ea69993ff$var$_descriptor11, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "migratedAt", $1fe68a6ea69993ff$var$_descriptor12, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "country", $1fe68a6ea69993ff$var$_descriptor13, this);
        $1fe68a6ea69993ff$var$_initializerDefineProperty(this, "invoiceTemplates", $1fe68a6ea69993ff$var$_descriptor14, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $cLLPo.default);
        this.init(data, options);
    }
    get defaultInvoiceTemplate() {
        var _this$settings, _this$settings$invoic, _this$invoiceTemplate, _this$invoiceTemplate2, _this$invoiceTemplate3, _this$settings2, _this$settings2$invoi, _this$settings2$invoi2, _this$invoiceTemplate4;
        const id = Object.keys(this.invoiceTemplates || {})[0] || Object.keys(((_this$settings = this.settings) === null || _this$settings === void 0 ? void 0 : (_this$settings$invoic = _this$settings.invoice) === null || _this$settings$invoic === void 0 ? void 0 : _this$settings$invoic.templates) || {})[0] || (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))();
        (_this$invoiceTemplate = this.invoiceTemplates) !== null && _this$invoiceTemplate !== void 0 ? _this$invoiceTemplate : this.invoiceTemplates = {};
        (_this$invoiceTemplate3 = (_this$invoiceTemplate2 = this.invoiceTemplates)[id]) !== null && _this$invoiceTemplate3 !== void 0 ? _this$invoiceTemplate3 : _this$invoiceTemplate2[id] = new (0, $2AfWp.default)(this, ((_this$settings2 = this.settings) === null || _this$settings2 === void 0 ? void 0 : (_this$settings2$invoi = _this$settings2.invoice) === null || _this$settings2$invoi === void 0 ? void 0 : (_this$settings2$invoi2 = _this$settings2$invoi.templates) === null || _this$settings2$invoi2 === void 0 ? void 0 : _this$settings2$invoi2[id]) || {});
        return (_this$invoiceTemplate4 = this.invoiceTemplates) === null || _this$invoiceTemplate4 === void 0 ? void 0 : _this$invoiceTemplate4[id];
    }
    get defaultProjectReport() {
        return (0, $2U4XU.default).reportsById[this.defaultProjectReportId] || new (0, $8JmQX.default)({
            ...(0, $hXEZ6.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultStaffReport() {
        return (0, $2U4XU.default).reportsById[this.defaultStaffReportId] || new (0, $8JmQX.default)({
            ...(0, $33LHM.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultInvoiceReport() {
        return (0, $2U4XU.default).reportsById[this.defaultInvoiceReportId] || new (0, $8JmQX.default)({
            ...(0, $b2aJ3.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultTimeReport() {
        return (0, $2U4XU.default).reportsById[this.defaultTimeReportId] || new (0, $8JmQX.default)({
            ...(0, $iwvDr.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultExpenseReport() {
        return (0, $2U4XU.default).reportsById[this.defaultExpenseReportId] || new (0, $8JmQX.default)({
            ...(0, $dZHlf.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultRevenueForecastReport() {
        return (0, $iV9Vs.default).revenueForecastReportsById[this.defaultRevenueForecastReportId] || new (0, $aWaCW.default)({
            ...(0, $dSNYz.default),
            filters: {
                ...(0, $dSNYz.default).filters,
                invoiceData: (this.settings.reportInvoiceDateType || "issueDate").replace("issueDate", "issuedOn")
            },
            systemReport: true
        }, {
            detached: true
        });
    }
    get defaultResourceScheduleReport() {
        return (0, $gDUfk.default).resourceSchedulesById[this.defaultResourceScheduleReportId] || new (0, $gJY2D.default)({
            ...(0, $d8iCu.default),
            systemReport: true
        }, {
            detached: true
        });
    }
    get accountingSystemSettings() {
        var _this$settings3, _this$settings3$accou, _this$settings4;
        (_this$settings3$accou = (_this$settings3 = this.settings).accountingSystemSettings) !== null && _this$settings3$accou !== void 0 ? _this$settings3$accou : _this$settings3.accountingSystemSettings = {};
        return (_this$settings4 = this.settings) === null || _this$settings4 === void 0 ? void 0 : _this$settings4.accountingSystemSettings[this.accountingSystem];
    }
    updateInvoiceTemplate(templateData) {
        var _settings$invoice, _settings$invoice2, _settings$invoice2$te;
        const settings = {
            ...this.settings
        };
        (_settings$invoice = settings.invoice) !== null && _settings$invoice !== void 0 ? _settings$invoice : settings.invoice = {};
        (_settings$invoice2$te = (_settings$invoice2 = settings.invoice).templates) !== null && _settings$invoice2$te !== void 0 ? _settings$invoice2$te : _settings$invoice2.templates = {};
        settings.invoice.templates[templateData.id] = templateData;
        this.update({
            settings: settings
        });
    }
    updateInvoiceSettings(invoiceSettings) {
        var _settings$invoice3;
        const settings = {
            ...this.settings
        };
        (_settings$invoice3 = settings.invoice) !== null && _settings$invoice3 !== void 0 ? _settings$invoice3 : settings.invoice = {};
        settings.invoice = {
            ...settings.invoice,
            ...invoiceSettings
        };
        this.update({
            settings: settings
        });
    }
    updateAccountingSystemSettings(accountingSystemSettings) {
        var _settings$accountingS, _settings$accountingS2, _this$accountingSyste, _settings$accountingS3;
        const settings = {
            ...this.settings
        };
        (_settings$accountingS = settings.accountingSystemSettings) !== null && _settings$accountingS !== void 0 ? _settings$accountingS : settings.accountingSystemSettings = {};
        (_settings$accountingS3 = (_settings$accountingS2 = settings.accountingSystemSettings)[_this$accountingSyste = this.accountingSystem]) !== null && _settings$accountingS3 !== void 0 ? _settings$accountingS3 : _settings$accountingS2[_this$accountingSyste] = {};
        settings.accountingSystemSettings[this.accountingSystem] = {
            ...settings.accountingSystemSettings[this.accountingSystem],
            ...accountingSystemSettings
        };
        this.update({
            settings: settings
        });
    }
    get creatorStaff() {
        return (0, $lTrDt.default).staffsById[this.creatorStaffMemberId];
    }
}, $1fe68a6ea69993ff$var$_descriptor = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "accountingSystem", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor2 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "settings", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $1fe68a6ea69993ff$var$_descriptor3 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultRevenueForecastReportId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor4 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultResourceScheduleReportId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor5 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultProjectReportId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor6 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultStaffReportId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor7 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultTimeReportId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor8 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultInvoiceReportId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor9 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultContactReportId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor10 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultExpenseReportId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor11 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "creatorStaffMemberId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor12 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "migratedAt", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor13 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "country", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1fe68a6ea69993ff$var$_descriptor14 = $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "invoiceTemplates", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultInvoiceTemplate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultInvoiceTemplate"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultProjectReport", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultProjectReport"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultStaffReport", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultStaffReport"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultInvoiceReport", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultInvoiceReport"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultTimeReport", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultTimeReport"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultExpenseReport", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultExpenseReport"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultRevenueForecastReport", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultRevenueForecastReport"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultResourceScheduleReport", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "defaultResourceScheduleReport"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "accountingSystemSettings", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "accountingSystemSettings"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "updateInvoiceTemplate", [
    $1fe68a6ea69993ff$var$_dec
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "updateInvoiceTemplate"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "updateInvoiceSettings", [
    $1fe68a6ea69993ff$var$_dec2
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "updateInvoiceSettings"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "updateAccountingSystemSettings", [
    $1fe68a6ea69993ff$var$_dec3
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "updateAccountingSystemSettings"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_applyDecoratedDescriptor($1fe68a6ea69993ff$var$_class.prototype, "creatorStaff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1fe68a6ea69993ff$var$_class.prototype, "creatorStaff"), $1fe68a6ea69993ff$var$_class.prototype), $1fe68a6ea69993ff$var$_class);
var $1fe68a6ea69993ff$export$2e2bcd8739ae039 = $1fe68a6ea69993ff$var$OrganisationModel;

});
parcelRegister("b2aJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $808833814fb05468$export$2e2bcd8739ae039; });
var $808833814fb05468$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "invoice",
    columns: [
        "description",
        "project",
        "issuedOn",
        "amountIncTax"
    ],
    filters: [
        {
            column: "projectStatus",
            operator: "in",
            value: [
                "active"
            ],
            group: "project"
        }
    ],
    defaultGroup: "invoice",
    groupBy: [],
    sortBy: [
        [
            "issuedOn",
            "desc"
        ]
    ],
    options: {
        dateRange: "lastYear"
    }
};

});

parcelRegister("hXEZ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d137bd0bc7a235b2$export$2e2bcd8739ae039; });
var $d137bd0bc7a235b2$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "project",
    columns: [
        "name",
        "fee",
        "revenue",
        "expenses",
        "actualVsBudgetedHours",
        "actualVsBudgetedExpenses",
        "revenueVsFee",
        "profit",
        "profitMargin",
        "latestRevenueDate",
        "recordedHours"
    ],
    filters: [
        {
            column: "status",
            operator: "in",
            value: [
                "active"
            ],
            group: "project"
        }
    ],
    // defaultGroup: 'phase',
    // groupBy: ['project'],
    sortBy: [
        [
            "name",
            "asc"
        ]
    ],
    options: {
        dateRange: "allTime"
    }
};

});

parcelRegister("d8iCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98fa7735ec3a71c8$export$2e2bcd8739ae039; });
var $98fa7735ec3a71c8$export$2e2bcd8739ae039 = {
    name: "New Report",
    filters: {
        costCentres: [],
        futureRows: false,
        groups: [
            "role",
            "staff",
            "project",
            "phase"
        ],
        hoursData: "actualsProjected",
        percentData: "utilisation",
        phaseStatus: false,
        projectOwners: [],
        projectStatus: [],
        projects: [],
        roles: [],
        staff: [],
        totalData: "budgetUse"
    }
};

});

parcelRegister("dSNYz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1b715af5f19b37a$export$2e2bcd8739ae039; });
var $a1b715af5f19b37a$export$2e2bcd8739ae039 = {
    name: "New Report",
    filters: {
        costCentres: [],
        expenses: [],
        invoiceData: "issuedOn",
        projectStatus: [],
        projects: [],
        revenueData: "actualsProjected",
        staff: [],
        projectOwners: [],
        totalData: "revenueTotalFee",
        profitDataType: "margin",
        contractorExpense: "allocatedHours",
        showExpenses: true
    }
};

});

parcelRegister("33LHM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23a6a82713dd5cf5$export$2e2bcd8739ae039; });
var $23a6a82713dd5cf5$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "staffMember",
    columns: [
        "name",
        "email",
        "isActive",
        "recordedHours",
        "revenueEarned",
        "revenueEarnedPerHour"
    ],
    filters: [
        {
            column: "isActive",
            operator: "=",
            value: true
        }
    ],
    defaultGroup: "staff",
    groupBy: [],
    sortBy: [
        [
            "name",
            "asc"
        ]
    ],
    options: {
        dateRange: "allTime"
    }
};

});

parcelRegister("iwvDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7c3c13a0839fdcb$export$2e2bcd8739ae039; });
var $d7c3c13a0839fdcb$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "timesheet",
    columns: [
        "monthIndex",
        "project",
        "projectPhase",
        "staffMember",
        "task",
        "date",
        "numMinutes",
        "labourExpense",
        "cost",
        "chargeOut",
        "notes"
    ],
    filters: [],
    groupBy: [
        "project",
        "projectPhase",
        "staffMember"
    ],
    sortBy: [
        [
            "label",
            "desc"
        ]
    ],
    options: {
        dateRange: "thisMonth"
    }
};

});

parcelRegister("dZHlf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a302979f4108a5d3$export$2e2bcd8739ae039; });
var $a302979f4108a5d3$export$2e2bcd8739ae039 = {
    name: "New Report",
    type: "expense",
    columns: [
        "project",
        "projectPhase",
        "expenseName",
        "staffMember",
        "date",
        "recordedExpense",
        "invoicedExpense",
        "plannedExpense",
        "notes"
    ],
    filters: [
        {
            column: "project",
            operator: "in",
            value: []
        }
    ],
    groupBy: [
        "project",
        "projectPhase",
        "expenseName"
    ],
    sortBy: [
        [
            "label",
            "asc"
        ]
    ],
    options: {
        dateRange: "thisMonth"
    }
};

});

parcelRegister("2U4XU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21d4a9c1e34a2b34$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ReportCollectionClass", function () { return $21d4a9c1e34a2b34$export$9080ccc27301240c; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $8JmQX = parcelRequire("8JmQX");
var $21d4a9c1e34a2b34$var$_dec, $21d4a9c1e34a2b34$var$_dec2, $21d4a9c1e34a2b34$var$_class;
function $21d4a9c1e34a2b34$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $21d4a9c1e34a2b34$var$ReportCollection = ($21d4a9c1e34a2b34$var$_dec = (0, $d8hWe.action).bound, $21d4a9c1e34a2b34$var$_dec2 = (0, $d8hWe.action).bound, $21d4a9c1e34a2b34$var$_class = class ReportCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "reports",
            modelClass: (0, $8JmQX.default)
        });
        this.addLookup("reportsByType", "manyByKey", {
            key: (t)=>t.type,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get reportsById() {
        return this.modelsById;
    }
    get reports() {
        return this.models;
    }
    addReport(data) {
        this.add(data);
    }
    addReports(data) {
        this.addMany(data);
    }
}, $21d4a9c1e34a2b34$var$_applyDecoratedDescriptor($21d4a9c1e34a2b34$var$_class.prototype, "addReport", [
    $21d4a9c1e34a2b34$var$_dec
], Object.getOwnPropertyDescriptor($21d4a9c1e34a2b34$var$_class.prototype, "addReport"), $21d4a9c1e34a2b34$var$_class.prototype), $21d4a9c1e34a2b34$var$_applyDecoratedDescriptor($21d4a9c1e34a2b34$var$_class.prototype, "addReports", [
    $21d4a9c1e34a2b34$var$_dec2
], Object.getOwnPropertyDescriptor($21d4a9c1e34a2b34$var$_class.prototype, "addReports"), $21d4a9c1e34a2b34$var$_class.prototype), $21d4a9c1e34a2b34$var$_class);
var $21d4a9c1e34a2b34$export$2e2bcd8739ae039 = new $21d4a9c1e34a2b34$var$ReportCollection();
const $21d4a9c1e34a2b34$export$9080ccc27301240c = $21d4a9c1e34a2b34$var$ReportCollection;

});
parcelRegister("8JmQX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b440ddc69ef9da$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lsKv3 = parcelRequire("lsKv3");

var $aa2dd = parcelRequire("aa2dd");

var $2U4XU = parcelRequire("2U4XU");

var $fqmGV = parcelRequire("fqmGV");

var $8ib1E = parcelRequire("8ib1E");

var $bh2Tf = parcelRequire("bh2Tf");

var $2qtxz = parcelRequire("2qtxz");

var $kaUPk = parcelRequire("kaUPk");

var $2dBXm = parcelRequire("2dBXm");
parcelRequire("9Lw71");

var $hXEZ6 = parcelRequire("hXEZ6");

var $dBifK = parcelRequire("dBifK");

var $5uSSv = parcelRequire("5uSSv");

var $lsE13 = parcelRequire("lsE13");

var $iwvDr = parcelRequire("iwvDr");

var $33LHM = parcelRequire("33LHM");

var $b2aJ3 = parcelRequire("b2aJ3");

var $cuB2x = parcelRequire("cuB2x");

var $kdO1A = parcelRequire("kdO1A");
parcelRequire("X1RuM");
var $b2r1H = parcelRequire("b2r1H");

var $5Xh7w = parcelRequire("5Xh7w");

var $dZHlf = parcelRequire("dZHlf");

var $kH8oA = parcelRequire("kH8oA");
var $65b440ddc69ef9da$var$_dec, $65b440ddc69ef9da$var$_dec2, $65b440ddc69ef9da$var$_dec3, $65b440ddc69ef9da$var$_dec4, $65b440ddc69ef9da$var$_dec5, $65b440ddc69ef9da$var$_dec6, $65b440ddc69ef9da$var$_dec7, $65b440ddc69ef9da$var$_dec8, $65b440ddc69ef9da$var$_dec9, $65b440ddc69ef9da$var$_class, $65b440ddc69ef9da$var$_descriptor, $65b440ddc69ef9da$var$_descriptor2, $65b440ddc69ef9da$var$_descriptor3, $65b440ddc69ef9da$var$_descriptor4, $65b440ddc69ef9da$var$_descriptor5, $65b440ddc69ef9da$var$_descriptor6, $65b440ddc69ef9da$var$_descriptor7, $65b440ddc69ef9da$var$_descriptor8, $65b440ddc69ef9da$var$_descriptor9, $65b440ddc69ef9da$var$_descriptor10;
function $65b440ddc69ef9da$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $65b440ddc69ef9da$var$_defineProperty(e, r, t) {
    return (r = $65b440ddc69ef9da$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $65b440ddc69ef9da$var$_toPropertyKey(t) {
    var i = $65b440ddc69ef9da$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $65b440ddc69ef9da$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $65b440ddc69ef9da$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $65b440ddc69ef9da$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $65b440ddc69ef9da$var$reportDefaults = {
    project: (0, $hXEZ6.default),
    staff: (0, $33LHM.default),
    invoice: (0, $b2aJ3.default),
    timesheet: (0, $iwvDr.default),
    expense: (0, $dZHlf.default)
};
let $65b440ddc69ef9da$var$ReportModel = ($65b440ddc69ef9da$var$_dec = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_dec2 = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_dec3 = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_dec4 = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_dec5 = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_dec6 = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_dec7 = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_dec8 = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_dec9 = (0, $d8hWe.action).bound, $65b440ddc69ef9da$var$_class = class ReportModel extends (0, $fqmGV.default) {
    constructor(data, options){
        var _data$options, _data$options2, _data$options3;
        super();
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "name", $65b440ddc69ef9da$var$_descriptor, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "type", $65b440ddc69ef9da$var$_descriptor2, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "columns", $65b440ddc69ef9da$var$_descriptor3, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "filters", $65b440ddc69ef9da$var$_descriptor4, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "groupBy", $65b440ddc69ef9da$var$_descriptor5, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "sortBy", $65b440ddc69ef9da$var$_descriptor6, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "options", $65b440ddc69ef9da$var$_descriptor7, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "searchFilter", $65b440ddc69ef9da$var$_descriptor8, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "queryKey", $65b440ddc69ef9da$var$_descriptor9, this);
        $65b440ddc69ef9da$var$_initializerDefineProperty(this, "systemReport", $65b440ddc69ef9da$var$_descriptor10, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $2U4XU.default);
        if (data.filters) {
            var _data$filters;
            data.filters = (_data$filters = data.filters) === null || _data$filters === void 0 ? void 0 : _data$filters.map((f)=>{
                if (f.column.toLowerCase().includes("date") && (0, $b2r1H.default)(f.value) && !(f.value[0] instanceof Date)) return {
                    ...f,
                    value: f.value.map((d)=>d ? new Date(d) : d)
                };
                else if (f.column.toLowerCase().includes("date") && [
                    "=",
                    "!=",
                    ">",
                    "<"
                ].includes(f.operator) && f.value && !(f.value instanceof Date)) return {
                    ...f,
                    value: new Date(f.value)
                };
                return f;
            });
        }
        if ((_data$options = data.options) !== null && _data$options !== void 0 && _data$options.dateRange && (0, $b2r1H.default)((_data$options2 = data.options) === null || _data$options2 === void 0 ? void 0 : _data$options2.dateRange) && !(((_data$options3 = data.options) === null || _data$options3 === void 0 ? void 0 : _data$options3.dateRange[0]) instanceof Date)) data.options.dateRange = data.options.dateRange.map((d)=>new Date(d));
        this.init({
            ...$65b440ddc69ef9da$var$reportDefaults[data.type],
            ...(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).omitBy(data, (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).isNull)
        }, options);
        this.tableStore = new (0, $2qtxz.default)();
        this.searchFilter = "";
        this.setQueryKey();
    }
    update(data, options, ignoreQueryKey = false) {
        var _data$options4, _data$options5, _data$options6;
        if (data.filters) {
            var _data$filters2;
            data.filters = (_data$filters2 = data.filters) === null || _data$filters2 === void 0 ? void 0 : _data$filters2.map((f)=>{
                if (f.column.toLowerCase().includes("date") && (0, $b2r1H.default)(f.value) && !(f.value[0] instanceof Date)) return {
                    ...f,
                    value: f.value.map((d)=>d ? new Date(d) : null)
                };
                else if (f.column.toLowerCase().includes("date") && [
                    "=",
                    "!=",
                    ">",
                    "<"
                ].includes(f.operator) && f.value && !(f.value instanceof Date)) return {
                    ...f,
                    value: new Date(f.value)
                };
                return f;
            });
        }
        if ((_data$options4 = data.options) !== null && _data$options4 !== void 0 && _data$options4.dateRange && (0, $b2r1H.default)((_data$options5 = data.options) === null || _data$options5 === void 0 ? void 0 : _data$options5.dateRange) && !(((_data$options6 = data.options) === null || _data$options6 === void 0 ? void 0 : _data$options6.dateRange[0]) instanceof Date)) data.options.dateRange = data.options.dateRange.map((d)=>new Date(d));
        const update = super.update(data, options);
        // this.debouncedSetQueryKey()
        if (!ignoreQueryKey) this.setQueryKey();
        return update;
    }
    get tableColumns() {
        return [
            ...this.columns.map((c)=>({
                    ...this.columnOptionsById[c],
                    visible: true
                })),
            ...(this.groupBy || []).filter((c)=>!this.columns.includes(c)).map((c)=>({
                    ...this.columnOptionsById[c],
                    visible: false
                })),
            ...(this.filters || []).filter((f)=>!this.columns.includes(f.column)).map((f)=>({
                    ...this.columnOptionsById[f.column],
                    visible: false
                }))
        ].filter((c)=>!c.permissions || c.permissions());
    }
    addFilter() {
        const defaultCol = Object.values(this.columnOptionsById)[0];
        this.filters.push({
            column: defaultCol.id,
            operator: (0, $lsKv3.operatorDefaults)[defaultCol.type],
            group: "project"
        });
        this.update({
            filters: this.filters
        }, {}, true);
    }
    updateFilter(filter, prop, value) {
        filter[prop] = value;
        if (prop === "column") {
            filter.operator = (0, $lsKv3.operatorDefaults)[this.columnOptionsById[value].type];
            filter.value = null;
        }
        this.update({
            filters: this.filters
        }, {}, true);
    }
    removeFilter(filter) {
        this.filters = this.filters.filter((f)=>f !== filter);
        this.update({
            filters: this.filters
        }, {}, true);
    }
    updateOptions(prop, value) {
        this.options[prop] = value;
        this.update({
            options: this.options
        }, {}, true);
    }
    updateColumns(columnIds) {
        this.update({
            columns: columnIds
        }, {}, true);
        this.tableStore.updateColumns(this.tableColumns);
    }
    get columnOptionsById() {
        if (this.type === "project") return (0, $aa2dd.ProjectReportColumns)(this);
        if (this.type === "staffMember") return (0, $kaUPk.StaffReportColumns)(this);
        if (this.type === "invoice") return (0, $2dBXm.InvoiceReportColumns)(this);
        if (this.type === "timesheet") return (0, $lsE13.TimeReportColumns)(this);
        if (this.type === "expense") return (0, $kH8oA.ExpenseReportColumns)(this);
    }
    get rows() {
        if (this.type === "project") return (0, $kdO1A.default).projects.filter((pr)=>{
            var _pr$title, _pr$title$toLowerCase, _pr$title$toLowerCase2, _pr$title$toLowerCase3;
            return !pr.deletedAt && ((_pr$title = pr.title) === null || _pr$title === void 0 ? void 0 : (_pr$title$toLowerCase = _pr$title.toLowerCase) === null || _pr$title$toLowerCase === void 0 ? void 0 : (_pr$title$toLowerCase2 = _pr$title$toLowerCase.call(_pr$title)) === null || _pr$title$toLowerCase2 === void 0 ? void 0 : (_pr$title$toLowerCase3 = _pr$title$toLowerCase2.includes) === null || _pr$title$toLowerCase3 === void 0 ? void 0 : _pr$title$toLowerCase3.call(_pr$title$toLowerCase2, this.searchFilter.toLowerCase()));
        });
        if (this.type === "staffMember") return [];
        if (this.type === "invoice") return [];
        if (this.type === "timesheet") return (0, $cuB2x.default).timeEntries;
        if (this.type === "expense") return [];
    }
    updateSearchFilter(val) {
        this.searchFilter = val;
    // this.tableStore.updateRows(this.rows)
    }
    downloadCSV({ columns: columns, rows: rows } = {}) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8ib1E)))((0, (/*@__PURE__*/$parcel$interopDefault($bh2Tf))).unparse(this.tableStore.getCsvData({
            columns: columns,
            rows: rows
        })), `${this.name}.csv`, "text/csv");
    }
    makeDefault() {
        if (this.type === "project") (0, $5uSSv.default).organisation.update({
            defaultProjectReportId: this.id
        });
        if (this.type === "staffMember") (0, $5uSSv.default).organisation.update({
            defaultStaffReportId: this.id
        });
        if (this.type === "invoice") (0, $5uSSv.default).organisation.update({
            defaultInvoiceReportId: this.id
        });
        if (this.type === "timesheet") (0, $5uSSv.default).organisation.update({
            defaultTimeReportId: this.id
        });
        if (this.type === "expense") (0, $5uSSv.default).organisation.update({
            defaultExpenseReportId: this.id
        });
    }
    removeDefault() {
        if (this.type === "project" && this.id === (0, $5uSSv.default).organisation.defaultProjectReportId) (0, $5uSSv.default).organisation.update({
            defaultProjectReportId: null
        });
        if (this.type === "staffMember" && this.id === (0, $5uSSv.default).organisation.defaultStaffReportId) (0, $5uSSv.default).organisation.update({
            defaultStaffReportId: null
        });
        if (this.type === "invoice" && this.id === (0, $5uSSv.default).organisation.defaultInvoiceReportId) (0, $5uSSv.default).organisation.update({
            defaultInvoiceReportId: null
        });
        if (this.type === "timesheet" && this.id === (0, $5uSSv.default).organisation.defaultTimeReportId) (0, $5uSSv.default).organisation.update({
            defaultTimeReportId: null
        });
        if (this.type === "expense" && this.id === (0, $5uSSv.default).organisation.defaultExpenseReportId) (0, $5uSSv.default).organisation.update({
            defaultExpenseReportId: null
        });
    }
    get dateRange() {
        var _dateStringLookup$thi, _this$options, _this$options2, _this$options3;
        return ((_dateStringLookup$thi = (0, $lsKv3.dateStringLookup)[(_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dateRange]) === null || _dateStringLookup$thi === void 0 ? void 0 : _dateStringLookup$thi.call((0, $lsKv3.dateStringLookup), (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.fortnightType)) || ((_this$options3 = this.options) === null || _this$options3 === void 0 ? void 0 : _this$options3.dateRange);
    }
    get needsUpdate() {
        return this.queryKey !== this.makeQueryKey();
    }
    setQueryKey() {
        this.queryKey = this.makeQueryKey();
    }
    makeQueryKey() {
        return JSON.stringify({
            columns: [
                ...this.columns
            ].sort((a, b)=>a.localeCompare(b)),
            filters: [
                ...this.filters
            ].map((f)=>{
                var _f$value;
                return {
                    ...f,
                    value: (0, $b2r1H.default)(f.value) ? f.value.map((v)=>(v === null || v === void 0 ? void 0 : v.id) || v) : ((_f$value = f.value) === null || _f$value === void 0 ? void 0 : _f$value.id) || f.value
                };
            }).sort((a, b)=>a.column.localeCompare(b.column)),
            groupBy: [
                ...this.groupBy || []
            ],
            dateRange: this.options.dateRange,
            fortnightType: this.options.fortnightType
        });
    }
}, $65b440ddc69ef9da$var$_descriptor = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $65b440ddc69ef9da$var$_descriptor2 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "type", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $65b440ddc69ef9da$var$_descriptor3 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "columns", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $65b440ddc69ef9da$var$_descriptor4 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "filters", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $65b440ddc69ef9da$var$_descriptor5 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "groupBy", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $65b440ddc69ef9da$var$_descriptor6 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "sortBy", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $65b440ddc69ef9da$var$_descriptor7 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "options", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $65b440ddc69ef9da$var$_descriptor8 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "searchFilter", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $65b440ddc69ef9da$var$_descriptor9 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "queryKey", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $65b440ddc69ef9da$var$_descriptor10 = $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "systemReport", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "tableColumns", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "tableColumns"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "addFilter", [
    $65b440ddc69ef9da$var$_dec
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "addFilter"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "updateFilter", [
    $65b440ddc69ef9da$var$_dec2
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "updateFilter"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "removeFilter", [
    $65b440ddc69ef9da$var$_dec3
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "removeFilter"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "updateOptions", [
    $65b440ddc69ef9da$var$_dec4
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "updateOptions"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "updateColumns", [
    $65b440ddc69ef9da$var$_dec5
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "updateColumns"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "columnOptionsById", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "columnOptionsById"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "rows", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "rows"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "updateSearchFilter", [
    $65b440ddc69ef9da$var$_dec6
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "updateSearchFilter"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "downloadCSV", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "downloadCSV"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "makeDefault", [
    $65b440ddc69ef9da$var$_dec7
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "makeDefault"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "removeDefault", [
    $65b440ddc69ef9da$var$_dec8
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "removeDefault"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "dateRange", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "dateRange"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "needsUpdate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "needsUpdate"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_applyDecoratedDescriptor($65b440ddc69ef9da$var$_class.prototype, "setQueryKey", [
    $65b440ddc69ef9da$var$_dec9
], Object.getOwnPropertyDescriptor($65b440ddc69ef9da$var$_class.prototype, "setQueryKey"), $65b440ddc69ef9da$var$_class.prototype), $65b440ddc69ef9da$var$_class);
var $65b440ddc69ef9da$export$2e2bcd8739ae039 = $65b440ddc69ef9da$var$ReportModel;

});
parcelRegister("lsKv3", function(module, exports) {

$parcel$export(module.exports, "dateStringLookup", function () { return $fa00486b0c37c5b9$export$e7f9d68bfe6bbb2a; });
$parcel$export(module.exports, "default", function () { return $fa00486b0c37c5b9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "dateStringLabels", function () { return $fa00486b0c37c5b9$export$8aef1cf919683bdb; });
$parcel$export(module.exports, "operatorDefaults", function () { return $fa00486b0c37c5b9$export$8b85e3c190a133a; });

var $egx7S = parcelRequire("egx7S");
parcelRequire("aJxsR");
parcelRequire("dBifK");
parcelRequire("8KwGs");
parcelRequire("bwMFl");

var $02mKT = parcelRequire("02mKT");
const $fa00486b0c37c5b9$var$transformForEquality = (type, func)=>(...params)=>{
        const newParams = [];
        params.forEach((p)=>{
            if (type === "date" && typeof p === "string") p = $fa00486b0c37c5b9$export$e7f9d68bfe6bbb2a[p]();
            if (p instanceof Array) p = p.map((pi)=>(0, $02mKT.default)[type](pi));
            else p = (0, $02mKT.default)[type](p);
            newParams.push(p);
        });
        return func(...newParams);
    };
var $fa00486b0c37c5b9$export$2e2bcd8739ae039 = {
    boolean: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("boolean", (a, b)=>a === b)
    },
    text: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("text", (a, b)=>a === b),
        contains: $fa00486b0c37c5b9$var$transformForEquality("text", (a, b)=>a.includes(b)),
        starts: $fa00486b0c37c5b9$var$transformForEquality("text", (a, b)=>a.startsWith(b)),
        ends: $fa00486b0c37c5b9$var$transformForEquality("text", (a, b)=>a.endsWith(b)),
        in: $fa00486b0c37c5b9$var$transformForEquality("text", (a, b)=>new Set(b.map((bi)=>bi)).has(a))
    },
    number: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a === b),
        ">": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a > b),
        ">=": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a >= b),
        "<": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a < b),
        "<=": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a <= b),
        between: $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a >= b[0] && a <= b[1]),
        in: $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>new Set(b).has(a))
    },
    currency: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("currency", (a, b)=>a === b),
        ">": $fa00486b0c37c5b9$var$transformForEquality("currency", (a, b)=>a > b),
        ">=": $fa00486b0c37c5b9$var$transformForEquality("currency", (a, b)=>a >= b),
        "<": $fa00486b0c37c5b9$var$transformForEquality("currency", (a, b)=>a < b),
        "<=": $fa00486b0c37c5b9$var$transformForEquality("currency", (a, b)=>a <= b),
        between: $fa00486b0c37c5b9$var$transformForEquality("currency", (a, b)=>a >= b[0] && a <= b[1]),
        in: $fa00486b0c37c5b9$var$transformForEquality("currency", (a, b)=>new Set(b).has(a))
    },
    percent: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("percent", (a, b)=>a === b),
        ">": $fa00486b0c37c5b9$var$transformForEquality("percent", (a, b)=>a > b),
        ">=": $fa00486b0c37c5b9$var$transformForEquality("percent", (a, b)=>a >= b),
        "<": $fa00486b0c37c5b9$var$transformForEquality("percent", (a, b)=>a < b),
        "<=": $fa00486b0c37c5b9$var$transformForEquality("percent", (a, b)=>a <= b),
        between: $fa00486b0c37c5b9$var$transformForEquality("percent", (a, b)=>a >= b[0] && a <= b[1]),
        in: $fa00486b0c37c5b9$var$transformForEquality("percent", (a, b)=>new Set(b).has(a))
    },
    durationMinutes: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a === b),
        ">": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a > b),
        ">=": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a >= b),
        "<": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a < b),
        "<=": $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a <= b),
        between: $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>a >= b[0] && a <= b[1]),
        in: $fa00486b0c37c5b9$var$transformForEquality("number", (a, b)=>new Set(b).has(a))
    },
    date: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[0];
            return a === b;
        }),
        ">": $fa00486b0c37c5b9$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[1];
            return a > b;
        }),
        ">=": $fa00486b0c37c5b9$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[1];
            return a >= b;
        }),
        "<": $fa00486b0c37c5b9$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[0];
            return a < b;
        }),
        "<=": $fa00486b0c37c5b9$var$transformForEquality("date", (a, b)=>{
            if (b instanceof Array) b = b[0];
            return a <= b;
        }),
        between: $fa00486b0c37c5b9$var$transformForEquality("date", (a, b)=>{
            return a >= b[0] && a <= b[1];
        }),
        in: $fa00486b0c37c5b9$var$transformForEquality("date", (a, b)=>new Set(b).has(a))
    },
    duration: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("duration", (a, b)=>a === b),
        ">": $fa00486b0c37c5b9$var$transformForEquality("duration", (a, b)=>a > b),
        ">=": $fa00486b0c37c5b9$var$transformForEquality("duration", (a, b)=>a >= b),
        "<": $fa00486b0c37c5b9$var$transformForEquality("duration", (a, b)=>a < b),
        "<=": $fa00486b0c37c5b9$var$transformForEquality("duration", (a, b)=>a <= b),
        between: $fa00486b0c37c5b9$var$transformForEquality("duration", (a, b)=>a >= b[0] && a <= b[1]),
        in: $fa00486b0c37c5b9$var$transformForEquality("duration", (a, b)=>new Set(b).has(a))
    },
    progress: {
        "=": $fa00486b0c37c5b9$var$transformForEquality("progress", (a, b)=>a === b),
        ">": $fa00486b0c37c5b9$var$transformForEquality("progress", (a, b)=>a > b),
        ">=": $fa00486b0c37c5b9$var$transformForEquality("progress", (a, b)=>a >= b),
        "<": $fa00486b0c37c5b9$var$transformForEquality("progress", (a, b)=>a < b),
        "<=": $fa00486b0c37c5b9$var$transformForEquality("progress", (a, b)=>a <= b),
        between: $fa00486b0c37c5b9$var$transformForEquality("progress", (a, b)=>a >= b[0] && a <= b[1]),
        in: $fa00486b0c37c5b9$var$transformForEquality("progress", (a, b)=>new Set(b).has(a))
    },
    project: {
        in: $fa00486b0c37c5b9$var$transformForEquality("project", (a, b)=>new Set(b).has(a))
    },
    phase: {
        in: $fa00486b0c37c5b9$var$transformForEquality("phase", (a, b)=>new Set(b).has(a))
    },
    costCentre: {
        in: $fa00486b0c37c5b9$var$transformForEquality("costCentre", (a, b)=>new Set(b).has(a))
    },
    contact: {
        in: $fa00486b0c37c5b9$var$transformForEquality("contact", (a, b)=>new Set(b).has(a))
    },
    staff: {
        in: $fa00486b0c37c5b9$var$transformForEquality("staff", (a, b)=>new Set(b).has(a))
    },
    staffMember: {
        in: $fa00486b0c37c5b9$var$transformForEquality("staffMember", (a, b)=>new Set(b).has(a))
    },
    role: {
        in: $fa00486b0c37c5b9$var$transformForEquality("role", (a, b)=>new Set(b).has(a))
    },
    status: {
        in: $fa00486b0c37c5b9$var$transformForEquality("status", (a, b)=>new Set(b).has(a))
    }
};
const $fa00486b0c37c5b9$export$e7f9d68bfe6bbb2a = {
    allTime: ()=>[
            -Infinity,
            Infinity
        ],
    today: ()=>[
            (0, $egx7S.startOfDay)(new Date()),
            (0, $egx7S.endOfDay)(new Date())
        ],
    thisWeek: ()=>[
            (0, $egx7S.startOfWeek)(new Date()),
            (0, $egx7S.endOfWeek)(new Date())
        ],
    thisFortnight: ()=>(0, $egx7S.getWeek)(new Date()) % 2 ? [
            (0, $egx7S.startOfWeek)((0, $egx7S.sub)(new Date(), {
                weeks: 1
            })),
            (0, $egx7S.endOfWeek)(new Date())
        ] : [
            (0, $egx7S.startOfWeek)(new Date()),
            (0, $egx7S.endOfWeek)((0, $egx7S.add)(new Date(), {
                weeks: 1
            }))
        ],
    thisMonth: ()=>[
            (0, $egx7S.startOfMonth)(new Date()),
            (0, $egx7S.endOfMonth)(new Date())
        ],
    thisQuarter: ()=>[
            (0, $egx7S.startOfQuarter)(new Date()),
            (0, $egx7S.endOfQuarter)(new Date())
        ],
    thisYear: ()=>[
            (0, $egx7S.startOfYear)(new Date()),
            (0, $egx7S.endOfYear)(new Date())
        ],
    yesterday: ()=>[
            (0, $egx7S.startOfDay)((0, $egx7S.sub)(new Date(), {
                days: 1
            })),
            (0, $egx7S.endOfDay)((0, $egx7S.sub)(new Date(), {
                days: 1
            }))
        ],
    lastWeek: ()=>[
            (0, $egx7S.startOfWeek)((0, $egx7S.sub)(new Date(), {
                weeks: 1
            })),
            (0, $egx7S.endOfWeek)((0, $egx7S.sub)(new Date(), {
                weeks: 1
            }))
        ],
    lastFortnight: ()=>(0, $egx7S.getWeek)((0, $egx7S.sub)(new Date(), {
            weeks: 2
        })) % 2 ? [
            (0, $egx7S.startOfWeek)((0, $egx7S.sub)(new Date(), {
                weeks: 3
            })),
            (0, $egx7S.endOfWeek)((0, $egx7S.sub)(new Date(), {
                weeks: 2
            }))
        ] : [
            (0, $egx7S.startOfWeek)((0, $egx7S.sub)(new Date(), {
                weeks: 2
            })),
            (0, $egx7S.endOfWeek)((0, $egx7S.sub)(new Date(), {
                weeks: 1
            }))
        ],
    lastMonth: ()=>[
            (0, $egx7S.startOfMonth)((0, $egx7S.sub)(new Date(), {
                months: 1
            })),
            (0, $egx7S.endOfMonth)((0, $egx7S.sub)(new Date(), {
                months: 1
            }))
        ],
    lastQuarter: ()=>[
            (0, $egx7S.startOfQuarter)((0, $egx7S.sub)(new Date(), {
                months: 3
            })),
            (0, $egx7S.endOfQuarter)((0, $egx7S.sub)(new Date(), {
                months: 3
            }))
        ],
    lastYear: ()=>[
            (0, $egx7S.startOfYear)((0, $egx7S.sub)(new Date(), {
                years: 1
            })),
            (0, $egx7S.endOfYear)((0, $egx7S.sub)(new Date(), {
                years: 1
            }))
        ],
    tomorrow: ()=>[
            (0, $egx7S.startOfDay)((0, $egx7S.add)(new Date(), {
                days: 1
            })),
            (0, $egx7S.endOfDay)((0, $egx7S.add)(new Date(), {
                days: 1
            }))
        ],
    nextWeek: ()=>[
            (0, $egx7S.startOfWeek)((0, $egx7S.add)(new Date(), {
                weeks: 1
            })),
            (0, $egx7S.endOfWeek)((0, $egx7S.add)(new Date(), {
                weeks: 1
            }))
        ],
    nextFortnight: ()=>(0, $egx7S.getWeek)((0, $egx7S.add)(new Date(), {
            weeks: 2
        })) % 2 ? [
            (0, $egx7S.startOfWeek)((0, $egx7S.add)(new Date(), {
                weeks: 1
            })),
            (0, $egx7S.endOfWeek)((0, $egx7S.add)(new Date(), {
                weeks: 2
            }))
        ] : [
            (0, $egx7S.startOfWeek)((0, $egx7S.add)(new Date(), {
                weeks: 2
            })),
            (0, $egx7S.endOfWeek)((0, $egx7S.add)(new Date(), {
                weeks: 3
            }))
        ],
    nextMonth: ()=>[
            (0, $egx7S.startOfMonth)((0, $egx7S.add)(new Date(), {
                months: 1
            })),
            (0, $egx7S.endOfMonth)((0, $egx7S.add)(new Date(), {
                months: 1
            }))
        ],
    nextQuarter: ()=>[
            (0, $egx7S.startOfQuarter)((0, $egx7S.add)(new Date(), {
                months: 3
            })),
            (0, $egx7S.endOfQuarter)((0, $egx7S.add)(new Date(), {
                months: 3
            }))
        ],
    nextYear: ()=>[
            (0, $egx7S.startOfYear)((0, $egx7S.add)(new Date(), {
                years: 1
            })),
            (0, $egx7S.endOfYear)((0, $egx7S.add)(new Date(), {
                years: 1
            }))
        ],
    inLastWeek: ()=>[
            (0, $egx7S.sub)(new Date(), {
                weeks: 1
            }),
            new Date()
        ],
    inLastMonth: ()=>[
            (0, $egx7S.sub)(new Date(), {
                months: 1
            }),
            new Date()
        ],
    inLastQuarter: ()=>[
            (0, $egx7S.sub)(new Date(), {
                months: 3
            }),
            new Date()
        ],
    inLastYear: ()=>[
            (0, $egx7S.sub)(new Date(), {
                years: 1
            }),
            new Date()
        ],
    inNextWeek: ()=>[
            new Date(),
            (0, $egx7S.add)(new Date(), {
                weeks: 1
            })
        ],
    inNextMonth: ()=>[
            new Date(),
            (0, $egx7S.add)(new Date(), {
                months: 1
            })
        ],
    inNextQuarter: ()=>[
            new Date(),
            (0, $egx7S.add)(new Date(), {
                months: 3
            })
        ],
    inNextYear: ()=>[
            new Date(),
            (0, $egx7S.add)(new Date(), {
                years: 1
            })
        ]
};
const $fa00486b0c37c5b9$export$8aef1cf919683bdb = {
    custom: "custom",
    allTime: "all time",
    today: "today",
    thisWeek: "this week",
    thisFortnight: "this fortnight",
    thisMonth: "this month",
    thisQuarter: "this quarter",
    thisYear: "this year",
    yesterday: "yesterday",
    lastWeek: "last week",
    lastFortnight: "last fortnight",
    lastMonth: "last month",
    lastQuarter: "last quarter",
    lastYear: "last year",
    tomorrow: "tomorrow",
    nextWeek: "next week",
    nextMonth: "next month",
    nextQuarter: "next quarter",
    nextYear: "next year",
    inLastWeek: "the week prior to now",
    inLastMonth: "the month prior to now",
    inLastQuarter: "the quarter prior to now",
    inLastYear: "the year prior to now",
    inNextWeek: "one week from now",
    inNextMonth: "one month from now",
    inNextQuarter: "one quarter from now",
    inNextYear: "one year from now"
};
const $fa00486b0c37c5b9$export$9e1cab28bb3963b7 = {
    boolean: {
        "=": "is equal to"
    },
    text: {
        "=": "is equal to",
        "!=": "isn't equal to",
        contains: "contains",
        "!contains": "doesn't contain",
        starts: "starts with",
        "!starts": "doesn't start with",
        ends: "ends with",
        "!ends": "doesn't end with"
    },
    number: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        // '>=': 'is greater than or equal to',
        "<": "is less than",
        // '<=': 'is less than or equal to',
        between: "is between",
        "!between": "isn't between"
    },
    currency: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between",
        "!between": "isn't between"
    },
    percent: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between"
    },
    date: {
        "=": "occurs on",
        "!=": "didn't occur on",
        ">": "occurs after",
        "<": "occurs before",
        between: "occurred during",
        "!between": "didn't occur during"
    },
    duration: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between",
        "!between": "isn't between"
    },
    progress: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between",
        "!between": "isn't between"
    },
    progressBar: {
        "=": "is equal to",
        "!=": "isn't equal to",
        ">": "is greater than",
        "<": "is less than",
        between: "is between",
        "!between": "isn't between"
    },
    project: {
        in: "is any of",
        "!in": "isn't any of"
    },
    phase: {
        in: "is any of",
        "!in": "isn't any of"
    },
    costCentre: {
        in: "is any of",
        "!in": "isn't any of"
    },
    contact: {
        in: "is any of",
        "!in": "isn't any of"
    },
    staff: {
        in: "is any of",
        "!in": "isn't any of"
    },
    staffMember: {
        in: "is any of",
        "!in": "isn't any of"
    },
    staffs: {
        in: "is any of",
        "!in": "isn't any of"
    },
    staffMembers: {
        in: "is any of",
        "!in": "isn't any of"
    },
    role: {
        in: "is any of",
        "!in": "isn't any of"
    },
    status: {
        in: "is any of",
        "!in": "isn't any of"
    }
};
const $fa00486b0c37c5b9$export$8b85e3c190a133a = {
    boolean: "=",
    text: "contains",
    number: "between",
    currency: "between",
    percent: "between",
    date: "between",
    duration: "between",
    progress: "between",
    progressBar: "between",
    project: "in",
    phase: "in",
    costCentre: "in",
    contact: "in",
    staff: "in",
    staffMember: "in",
    staffs: "in",
    staffMembers: "in",
    role: "in",
    status: "in"
};
const $fa00486b0c37c5b9$export$8b6b946ca4accbfd = {
    boolean: true,
    text: "",
    number: 0,
    currency: 0,
    percent: 0,
    date: new Date(),
    duration: 0,
    progress: 0,
    progressBar: 0,
    project: [],
    phase: [],
    costCentre: [],
    contact: [],
    staff: [],
    staffMember: [],
    staffs: [],
    staffMembers: [],
    role: [],
    status: []
};
const $fa00486b0c37c5b9$export$b6277177b9e7dbdc = {
    number: [
        0,
        0
    ],
    currency: [
        0,
        0
    ],
    percent: [
        0,
        0
    ],
    date: "thisMonth",
    duration: [
        0,
        0
    ],
    progress: [
        0,
        0
    ],
    progressBar: [
        0,
        0
    ]
};

});
parcelRegister("8KwGs", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("02mKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0071d6be4cd36284$export$2e2bcd8739ae039; });

var $bwMFl = parcelRequire("bwMFl");

var $hKySO = parcelRequire("hKySO");
var $0071d6be4cd36284$export$2e2bcd8739ae039 = {
    boolean: (value)=>value !== null && value !== void 0 ? value : false,
    text: (value)=>value ? String(value).toLowerCase() : "",
    number: (value)=>value !== null && value !== void 0 ? value : null,
    currency: (value)=>value !== null && value !== void 0 ? value : null,
    percent: (value)=>value !== null && value !== void 0 ? value : null,
    durationMinutes: (value)=>value !== null && value !== void 0 ? value : null,
    date: (value)=>value instanceof Date && !isNaN(value) ? value.getTime() : null,
    duration: (value)=>value !== null && value !== void 0 && value.value && value !== null && value !== void 0 && value.unit ? (0, $bwMFl.durationToUnit)(value, "milliseconds") : null,
    progress: (value)=>value !== null && value !== void 0 && value.denominator ? value.numerator / value.denominator : null,
    progressBar: (value)=>value !== null && value !== void 0 && value.denominator ? value.numerator / value.denominator : null,
    project: (value)=>{
        var _value$id;
        return (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : "";
    },
    phase: (value)=>{
        var _value$id2;
        return (_value$id2 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id2 !== void 0 ? _value$id2 : "";
    },
    costCentre: (value)=>{
        var _value$id3;
        return (_value$id3 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id3 !== void 0 ? _value$id3 : "";
    },
    contact: (value)=>{
        var _value$id4;
        return (_value$id4 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id4 !== void 0 ? _value$id4 : "";
    },
    staff: (value)=>{
        var _value$id5;
        return (_value$id5 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id5 !== void 0 ? _value$id5 : "";
    },
    staffMember: (value)=>{
        var _value$id6;
        return (_value$id6 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id6 !== void 0 ? _value$id6 : "";
    },
    role: (value)=>{
        var _value$id7;
        return (_value$id7 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id7 !== void 0 ? _value$id7 : "";
    },
    status: (value)=>{
        var _statusPriorities$val;
        return (_statusPriorities$val = (0, $hKySO.statusPriorities)[value]) !== null && _statusPriorities$val !== void 0 ? _statusPriorities$val : null;
    }
};

});
parcelRegister("hKySO", function(module, exports) {

$parcel$export(module.exports, "statusPriorities", function () { return $cec1ca9e6cbf6c5c$export$3b40b9f7a19a5b8a; });
$parcel$export(module.exports, "statusByPriority", function () { return $cec1ca9e6cbf6c5c$export$b3919c364c9db11f; });
const $cec1ca9e6cbf6c5c$export$3b40b9f7a19a5b8a = {
    active: 1,
    onHold: 2,
    prospective: 3,
    archived: 4
};
const $cec1ca9e6cbf6c5c$export$b3919c364c9db11f = {
    1: "active",
    2: "onHold",
    3: "prospective",
    4: "archived"
};

});



parcelRegister("aa2dd", function(module, exports) {

$parcel$export(module.exports, "ProjectReportColumns", function () { return $765c8dd55b5340b0$export$87b7940e8d176c5c; });

var $RSSjA = parcelRequire("RSSjA");

var $dBifK = parcelRequire("dBifK");
parcelRequire("7PdBe");

var $geLN1 = parcelRequire("geLN1");
parcelRequire("61cVC");
parcelRequire("aJxsR");

var $byiQX = parcelRequire("byiQX");

parcelRequire("cjCbh");

var $4iD0l = parcelRequire("4iD0l");

var $5uSSv = parcelRequire("5uSSv");
const $765c8dd55b5340b0$var$getPhaseFilters = (report)=>{
    return [
        ...report.filters.filter((f)=>f.group === "phase").map((f)=>{
            var _report$columnOptions, _report$columnOptions2;
            return (_report$columnOptions = report.columnOptionsById[f.column]) === null || _report$columnOptions === void 0 ? void 0 : (_report$columnOptions2 = _report$columnOptions.queryFilters) === null || _report$columnOptions2 === void 0 ? void 0 : _report$columnOptions2.call(_report$columnOptions, f);
        }).flat()
    ];
};
const $765c8dd55b5340b0$export$87b7940e8d176c5c = (report)=>({
        name: {
            id: "name",
            label: "Name",
            type: "text",
            width: 25,
            value: (row, stores)=>{
                return stores.row.group ? stores.row.cells[stores.row.group].formattedValue : row.title;
            },
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).text[operator]("name", value),
            component: ({ value: value, group: group, stores: stores })=>{
                const { row: row, table: table } = stores;
                if (row.group === "totals") return "Total";
                return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                    style: {
                        paddingLeft: `${1 * row.groupLevel}rem`
                    },
                    children: [
                        row.childRows.length ? /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                            className: `fa fa-${`caret-${row.expanded ? "down" : "right"}`} fa-fw`,
                            onClick: ()=>table.toggleRowExpand(row)
                        }) : null,
                        row.rowObject.modelType === "project" ? value : value
                    ]
                });
            }
        },
        project: {
            id: "project",
            label: "Project",
            type: "project",
            width: 25,
            value: (row)=>row.project || (row.modelType === "project" ? row : null),
            queryFilters: ({ operator: operator, value: value, group: group })=>(0, $byiQX.queryFilters).singleId[operator](group === "project" ? "id" : "projectId", value)
        },
        jobCode: {
            id: "jobCode",
            label: "Job code",
            type: "text",
            width: 10,
            value: (row)=>row.jobNumber,
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).text[operator]("jobNumber", value),
            aggregate: "none"
        },
        startDate: {
            id: "startDate",
            label: "Start date",
            type: "date",
            width: 10,
            value: (row)=>row.startDate,
            aggregate: "min",
            permissions: (row)=>(0, $4iD0l.canViewProjectDates)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).date[operator]("startDate", value)
        },
        endDate: {
            id: "endDate",
            label: "End date",
            type: "date",
            width: 10,
            value: (row)=>row.endDate,
            aggregate: "max",
            permissions: (row)=>(0, $4iD0l.canViewProjectDates)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).date[operator]("endDate", value)
        },
        fee: {
            id: "fee",
            label: "Fee",
            type: "currency",
            width: 10,
            value: (row)=>row.fee,
            permissions: (row)=>(0, $4iD0l.canViewProjectFees)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("fee", value);
            }
        },
        expenseBudget: {
            id: "expenseBudget",
            label: "Expense Budget",
            type: "currency",
            width: 10,
            value: (row)=>row.expenseBudget,
            permissions: (row)=>(0, $4iD0l.canViewProjectExpenseBudgets)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).number[operator]("expenseBudget", value)
        },
        costCentre: {
            id: "costCentre",
            label: "Cost centre",
            type: "costCentre",
            width: 10,
            value: (row)=>row.costCentre,
            permissions: (row)=>(0, $4iD0l.canViewCostCentres)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).singleId[operator]("costCentreId", value)
        },
        contact: {
            id: "contact",
            label: "Contact",
            type: "contact",
            width: 10,
            value: (row)=>row.contact,
            permissions: (row)=>(0, $4iD0l.canViewContacts)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).singleId[operator]("contactId", value)
        },
        invoiceContact: {
            id: "invoiceContact",
            label: "Primary Contact",
            type: "contact",
            width: 10,
            value: (row)=>row.primaryContact,
            permissions: (row)=>(0, $4iD0l.canViewContacts)((0, $5uSSv.default).user) && (0, $4iD0l.canViewPrimaryContact)(),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).singleId[operator]("primaryContactId", value)
        },
        owner: {
            id: "owner",
            label: "Project Owner",
            type: "staffMember",
            width: 15,
            value: (row)=>row.owner,
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).singleId[operator]("ownerId", value)
        },
        status: {
            id: "status",
            label: "Status",
            type: "status",
            width: 10,
            value: (row)=>{
                return row.status || "active";
            },
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).text[operator]("status", value)
        },
        remainingFee: {
            id: "remainingFee",
            label: "Remaining fee",
            type: "currency",
            width: 10,
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).number[operator]("((fee - revenue) > 0 ? (fee - revenue) : 0)", value),
            value: (row)=>Math.max(0, ($765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row) || 0) - ($765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) || 0))
        },
        remainingExpenseProjectBudget: {
            id: "remainingExpenseProjectBudget",
            label: "Remaining Expense Budget",
            type: "currency",
            width: 10,
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).number[operator]("(expenseBudget - expenses - projectExpenses)", value),
            value: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectExpenses.value(row),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectExpenses.permissions(row)
        },
        latestEvent: {
            id: "latestEvent",
            label: "Latest Event",
            type: "date",
            width: 10,
            value: (row)=>row.history.length ? (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(row.history.filter((h)=>row.modelType === "phase" ? h.phaseId === row.id : true).map((h)=>new Date(h.time))) : null
        },
        latestNote: {
            id: "latestNote",
            label: "Latest Note",
            type: "text",
            width: 35,
            value: (row)=>{
                const notes = row.notes || [];
                return notes.length ? (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy(notes, [
                    "date"
                ], [
                    "desc"
                ])[0].description : null;
            },
            permissions: (row)=>(0, $4iD0l.canViewProjectNotes)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).text[operator]("latestNoteDescription", value)
        },
        currentPhases: {
            id: "currentPhases",
            label: "Current Phases",
            type: "text",
            width: 10,
            value: (row)=>row.currentPhaseTitles,
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).text[operator]("currentPhaseTitles", value)
        },
        activePhases: {
            id: "activePhases",
            label: "Active Phases",
            type: "phase",
            width: 10,
            value: (row)=>row.activePhaseTitles,
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).text[operator]("activePhaseTitles", value)
        },
        prospectivePhases: {
            id: "prospectivePhases",
            label: "Prospective Phases",
            type: "phase",
            width: 10,
            value: (row)=>row.prospectivePhaseTitles,
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).text[operator]("prospectivePhaseTitles", value)
        },
        staffMembers: {
            id: "staffMembers",
            label: "Staff members assigned",
            type: "staffs",
            width: 10,
            value: (row)=>row.budgets.map((b)=>b.staff),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).manyIds[operator]("staffMemberIds", value)
        },
        progress: {
            id: "progress",
            label: "Progress",
            type: "percent",
            width: 10,
            value: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(fee > 0 and fee != null ? revenue / fee : 0)", value);
            }
        },
        revenue: {
            id: "revenue",
            label: "Revenue",
            type: "currency",
            width: 10,
            value: (row)=>row.revenue,
            permissions: (row)=>(0, $4iD0l.canViewProjectInvoices)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenue", value);
            }
        },
        revenueWithVariations: {
            id: "revenueWithVariations",
            label: "Revenue (Variations)",
            type: "currency",
            width: 10,
            value: (row)=>row.revenueWithVariations,
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenueWithVariations", value);
            }
        },
        revenueWithVariationsReimbursements: {
            id: "revenueWithVariationsReimbursements",
            label: "Revenue (Variations + Reimbursements)",
            type: "currency",
            width: 10,
            value: (row)=>row.revenueWithVariationsReimbursements,
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenueWithVariationsReimbursements", value);
            }
        },
        recordedHours: {
            id: "recordedHours",
            label: "Recorded Hours",
            type: "number",
            width: 10,
            value: (row)=>row.recordedHours,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("recordedHours", value);
            }
        },
        recordedHoursVariation: {
            id: "recordedHoursVariation",
            label: "Recorded Hours (Variation)",
            type: "number",
            width: 10,
            value: (row)=>row.recordedHoursVariation,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("recordedHoursVariation", value);
            }
        },
        hoursBudgeted: {
            id: "hoursBudgeted",
            label: "Hours budgeted",
            type: "number",
            width: 10,
            value: (row)=>row.hoursBudget,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("hoursBudget", value);
            }
        },
        hoursAllocated: {
            id: "hoursAllocated",
            label: "Hours allocated",
            type: "number",
            width: 10,
            value: (row)=>row.hoursAllocated,
            permissions: (row)=>(0, $4iD0l.canViewStaffAllocations)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("hoursAllocated", value);
            }
        },
        expenses: {
            id: "expenses",
            label: "Expenses (cost)",
            type: "currency",
            width: 10,
            value: (row)=>row._expenses,
            permissions: (row)=>(0, $4iD0l.canViewProjectStaffCost)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("expenses", value);
            }
        },
        projectExpenses: {
            id: "projectExpenses",
            label: "Project Expenses",
            type: "currency",
            width: 10,
            value: (row)=>row.projectExpenses,
            permissions: (row)=>(0, $4iD0l.canViewProjectExpenses)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("projectExpenses", value);
            }
        },
        expensesVariation: {
            id: "expensesVariation",
            label: "Expenses (cost) + Variation Cost",
            type: "currency",
            width: 10,
            value: (row)=>row.expensesVariation,
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("expensesVariation", value);
            }
        },
        expensesVariationProject: {
            id: "expensesVariationProject",
            label: "Expenses (cost) + Variation Cost + Project Expenses",
            type: "currency",
            width: 10,
            value: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariation.value(row) + $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectExpenses.value(row),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectExpenses.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("expensesVariation + projectExpenses", value);
            }
        },
        expensesProject: {
            id: "expensesProject",
            label: "Expenses (cost) + Project Expenses",
            type: "currency",
            width: 10,
            value: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.value(row) + $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectExpenses.value(row),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectExpenses.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("expenses + projectExpenses", value);
            }
        },
        labourExpense: {
            id: "labourExpense",
            label: "Labour expense",
            type: "currency",
            width: 10,
            value: (row)=>row.labourExpense,
            permissions: (row)=>(0, $4iD0l.canViewProjectStaffPay)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("labourExpense", value);
            }
        },
        chargeOut: {
            id: "chargeOut",
            label: "Charge-out",
            type: "currency",
            width: 10,
            value: (row)=>row.chargeOut,
            permissions: (row)=>(0, $4iD0l.canViewProjectStaffChargeOut)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("chargeOut", value);
            }
        },
        chargeOutVariation: {
            id: "chargeOutVariation",
            label: "Charge-out (Variations)",
            type: "currency",
            width: 10,
            value: (row)=>row.chargeOutVariation,
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).chargeOut.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("chargeOutVariation", value);
            }
        },
        actualVsBudgetedHours: {
            id: "actualVsBudgetedHours",
            label: "Actual / Budgeted Hours",
            type: "progressBar",
            width: 20,
            value: (row)=>{
                return {
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHours.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).hoursBudgeted.value(row)
                };
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(hoursBudget > 0 and hoursBudget != null ? recordedHours / hoursBudget : 0)", value);
            }
        },
        actualVsBudgetedHoursVariation: {
            id: "actualVsBudgetedHoursVariation",
            label: "Actual (Variation) / Budgeted Hours",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHoursVariation.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).hoursBudgeted.value(row)
                }),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(hoursBudget > 0 and hoursBudget != null ? recordedHoursVariation / hoursBudget : 0)", value);
            }
        },
        actualProjectVsBudgetedExpenses: {
            id: "actualProjectVsBudgetedExpenses",
            label: "Actual (Cost + Project) / Budgeted Expenses",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(expenseBudget > 0 and expenseBudget != null ? (expenses + projectExpenses) / expenseBudget : 0)", value);
            }
        },
        actualVariationProjectVsBudgetedExpenses: {
            id: "actualVariationProjectVsBudgetedExpenses",
            label: "Actual (Cost + Project + Variation) / Budgeted Expenses",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(expenseBudget > 0 and expenseBudget != null ? (expensesVariation + projectExpenses) / expenseBudget : 0)", value);
            }
        },
        actualVariationVsBudgetedExpenses: {
            id: "actualVariationVsBudgetedExpenses",
            label: "Actual (Cost) / Budgeted Expenses",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariation.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariation.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(expenseBudget > 0 and expenseBudget != null ? expensesVariation / expenseBudget : 0)", value);
            }
        },
        actualVsBudgetedExpenses: {
            id: "actualVsBudgetedExpenses",
            label: "Actual (Cost) / Budgeted Expenses",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenseBudget.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(expenseBudget > 0 and expenseBudget != null ? expenses / expenseBudget : 0)", value);
            }
        },
        revenueVsFee: {
            id: "revenueVsFee",
            label: "Revenue / Fee",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row)
                }),
            format: (0, $geLN1.default).currency,
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(fee > 0 and fee != null ? revenue / fee : 0)", value);
            }
        },
        percentRevenueVsFee: {
            id: "percentRevenueVsFee",
            label: "Percent Revenue / Fee",
            type: "percent",
            width: 10,
            value: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row) ? $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row) : 0,
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(fee > 0 and fee != null ? revenue / fee : 0)", value);
            }
        },
        costProjectVsFee: {
            id: "costProjectVsFee",
            label: "Expenses (Cost + Project) / Fee",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(fee > 0 and fee != null ? (expenses + projectExpenses) / fee : 0)", value);
            },
            format: (0, $geLN1.default).currency
        },
        costVsFee: {
            id: "costVsFee",
            label: "Expense (cost) / Fee",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(fee > 0 and fee != null ? expenses / fee : 0)", value);
            },
            format: (0, $geLN1.default).currency
        },
        payVsFee: {
            id: "payVsFee",
            label: "Expense (labour) / Fee",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(fee > 0 and fee != null ? labourExpense / fee : 0)", value);
            },
            format: (0, $geLN1.default).currency
        },
        chargeOutVsFee: {
            id: "chargeOutVsFee",
            label: "Charge Out / Fee",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).chargeOut.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).chargeOut.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(fee > 0 and fee != null ? chargeOut / fee : 0)", value);
            },
            format: (0, $geLN1.default).currency
        },
        chargeOutVariationVsFee: {
            id: "chargeOutVariationVsFee",
            label: "Charge Out (Variations) / Fee",
            type: "progressBar",
            width: 20,
            value: (row)=>({
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).chargeOutVariation.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row)
                }),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).chargeOutVariation.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(fee > 0 and fee != null ? chargeOutVariation / fee : 0)", value);
            },
            format: (0, $geLN1.default).currency
        },
        percentOfTotalHours: {
            id: "percentOfTotalHours",
            label: "Percentage of total hours",
            type: "percent",
            width: 10,
            value: (row, stores)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHours.value(row) / stores.table.totalsRow.cells["recordedHours"].value;
            }
        },
        percentOfTotalRevenue: {
            id: "percentOfTotalRevenue",
            label: "Percentage of total revenue",
            type: "percent",
            width: 10,
            value: (row, stores)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) / stores.table.totalsRow.cells["revenue"].value;
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row)
        },
        percentOfTotalExpenses: {
            id: "percentOfTotalExpenses",
            label: "Percentage of total expenses (cost)",
            type: "percent",
            width: 10,
            value: (row, stores)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.value(row) / stores.table.totalsRow.cells["expensesProject"].value;
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.permissions(row)
        },
        percentOfTotalExpensesLabour: {
            id: "percentOfTotalExpensesLabour",
            label: "Percentage of total expenses (labour)",
            type: "percent",
            width: 10,
            value: (row, stores)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.value(row) / stores.table.totalsRow.cells["labourExpense"].value;
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.permissions(row)
        },
        profit: {
            id: "profit",
            label: "Profit (cost + project expenses)",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenue - (expenses + projectExpenses)", value);
            }
        },
        profitCost: {
            id: "profitCost",
            label: "Profit (cost)",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenue - expenses", value);
            }
        },
        profitLabour: {
            id: "profitLabour",
            label: "Profit (labour)",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenue - labourExpense", value);
            }
        },
        profitFee: {
            id: "profitFee",
            label: "Profit (fee)",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("fee - (expenses + projectExpenses)", value);
            }
        },
        profitFeeVariation: {
            id: "profitFeeVariation",
            label: "Profit (fee, variation & project expenses)",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("fee - (expensesVariation + projectExpenses)", value);
            }
        },
        profitMargin: {
            id: "profitMargin",
            label: "Profit margin (cost + project expenses)",
            type: "percent",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).profit.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profit.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(revenue > 0 and revenue != null ? (revenue - (expenses + projectExpenses)) / revenue : 0)", value);
            }
        },
        profitMarginCost: {
            id: "profitMarginCost",
            label: "Profit margin (cost)",
            type: "percent",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitCost.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitCost.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(revenue > 0 and revenue != null ? (revenue - expenses) / revenue : 0)", value);
            }
        },
        profitMarginLabour: {
            id: "profitMarginLabour",
            label: "Profit margin (labour)",
            type: "percent",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitLabour.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitLabour.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(revenue > 0 and revenue != null ? (revenue - labourExpense) / revenue : 0)", value);
            }
        },
        markup: {
            id: "markup",
            label: "Markup (cost + project expenses)",
            type: "percent",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).profit.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profit.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesProject.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("((expenses + projectExpenses) > 0 and (expenses + projectExpenses) != null ? (revenue - (expenses + projectExpenses)) / (expenses + projectExpenses) : 0)", value);
            }
        },
        markupCost: {
            id: "markupCost",
            label: "Markup (cost)",
            type: "percent",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitCost.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitCost.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(expenses > 0 and expenses != null ? (revenue - expenses) / expenses : 0)", value);
            }
        },
        markupLabour: {
            id: "markupLabour",
            label: "Markup (labour)",
            type: "percent",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitLabour.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitLabour.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(labourExpense > 0 and labourExpense != null ? (revenue - labourExpense) / labourExpense : 0)", value);
            }
        },
        revenuePerHour: {
            id: "revenuePerHour",
            label: "Revenue per hour",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHours.value(row) ? $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHours.value(row) : 0;
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(recordedHours > 0 and recordedHours != null ? revenue / recordedHours : 0)", value);
            }
        },
        revenueVariationPerHour: {
            id: "revenueVariationPerHour",
            label: "Revenue per hour (variations)",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHoursVariation.value(row) ? $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHoursVariation.value(row) : 0;
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(recordedHoursVariation > 0 and recordedHoursVariation != null ? revenueWithVariations / recordedHoursVariation : 0)", value);
            }
        },
        revenueVariationReimbursementPerHour: {
            id: "revenueVariationReimbursementPerHour",
            label: "Revenue per hour (variations + reimbursements)",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHoursVariation.value(row) ? $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariationsReimbursements.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHoursVariation.value(row) : 0;
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariationsReimbursements.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(recordedHoursVariation > 0 and recordedHoursVariation != null ? revenueWithVariationsReimbursements / recordedHoursVariation : 0)", value);
            }
        },
        completionDate: {
            id: "completionDate",
            label: "Completion date",
            type: "date",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.value(row) >= 1 ? $765c8dd55b5340b0$export$87b7940e8d176c5c(report).latestRevenueDate.value(row) : null;
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).fee.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).date[operator]("fee > 0 and (revenue / fee) > 1 ? latestInvoiceDate : null", value)
        },
        latestInvoicedPhases: {
            id: "latestInvoicedPhases",
            label: "Latest Invoiced Phases",
            type: "text",
            width: 15,
            value: (row)=>{
                return row.latestInvoicedPhases;
            },
            permissions: (row)=>(0, $4iD0l.canViewProjectInvoices)((0, $5uSSv.default).sessionUser, row),
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).text[operator]("latestInvoicedPhaseNames", value)
        },
        latestRevenueDate: {
            id: "latestRevenueDate",
            label: "Latest Revenue Date",
            type: "date",
            width: 10,
            value: (row)=>{
                return row.latestInvoiceDate;
            },
            permissions: (row)=>(0, $4iD0l.canViewProjectInvoices)((0, $5uSSv.default).sessionUser, row)
        },
        projectedHours: {
            id: "projectedHours",
            label: "Projected Hours",
            type: "number",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).recordedHours.value(row) + $765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureHours.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureHours.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("recordedHours + futureHours", value);
            }
        },
        futureHours: {
            id: "futureHours",
            label: "Future Hours",
            type: "number",
            width: 10,
            value: (row)=>{
                return row.futureHours;
            },
            permissions: (row)=>(0, $4iD0l.canViewStaffAllocations)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("futureHours", value);
            }
        },
        futureLabour: {
            id: "futureLabour",
            label: "Future Labour Expense",
            type: "number",
            width: 10,
            value: (row)=>{
                return row.futureLabour;
            },
            permissions: (row)=>(0, $4iD0l.canViewStaffAllocations)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row) && (0, $4iD0l.canViewProjectStaffPay)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("futureLabour", value);
            }
        },
        futureCost: {
            id: "futureCost",
            label: "Future Expense",
            type: "number",
            width: 10,
            value: (row)=>{
                return row.futureCost;
            },
            permissions: (row)=>(0, $4iD0l.canViewStaffAllocations)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row) && (0, $4iD0l.canViewProjectStaffCost)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("futureCost", value);
            }
        },
        futureChargeOut: {
            id: "futureChargeOut",
            label: "Future Charge Out",
            type: "number",
            width: 10,
            value: (row)=>{
                return row.futureChargeOut;
            },
            permissions: (row)=>(0, $4iD0l.canViewStaffAllocations)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row) && (0, $4iD0l.canViewProjectStaffChargeOut)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("futureChargeOut", value);
            }
        },
        futureRevenue: {
            id: "futureRevenue",
            label: "Future Revenue",
            type: "currency",
            width: 10,
            value: (row)=>{
                return row.futureRevenue;
            },
            permissions: (row)=>(0, $4iD0l.canViewRevenueTargets)((0, $5uSSv.default).user, (row === null || row === void 0 ? void 0 : row.project) || row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("futureRevenue", value);
            }
        },
        projectedRevenue: {
            id: "projectedRevenue",
            label: "Projected Revenue",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.value(row) + $765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureRevenue.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenue.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureRevenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenue + futureRevenue", value);
            }
        },
        projectedExpense: {
            id: "projectedExpense",
            label: "Projected Expense (Cost)",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureCost.value(row) + $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureCost.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expenses.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("futureCost + expenses", value);
            }
        },
        projectedLabourExpense: {
            id: "projectedLabourExpense",
            label: "Projected Labour Expense",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureLabour.value(row) + $765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureLabour.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).labourExpense.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("futureLabour + labourExpense", value);
            }
        },
        projectedChargeOut: {
            id: "projectedChargeOut",
            label: "Projected Charge Out",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureChargeOut.value(row) + $765c8dd55b5340b0$export$87b7940e8d176c5c(report).chargeOut.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).futureChargeOut.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).chargeOut.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("futureChargeOut + chargeOut", value);
            }
        },
        projectedProfit: {
            id: "projectedProfit",
            label: "Projected Profit",
            type: "currency",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectedRevenue.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectedExpense.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectedRevenue.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectedExpense.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(revenue + futureRevenue) - (futureCost + expenses)", value);
            }
        },
        projectedProfitMargin: {
            id: "projectedProfitMargin",
            label: "Projected Profit Margin",
            type: "percent",
            width: 10,
            value: (row)=>{
                return $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectedProfit.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectedRevenue.value(row);
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectedProfit.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).projectedRevenue.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(revenue + futureRevenue) > 0 ? ((revenue + futureRevenue) - (futureCost + expenses)) / (revenue + futureRevenue) : 0", value);
            }
        },
        profitVariationProject: {
            id: "profitVariationProject",
            label: "Profit (Cost + Variation + Project)",
            type: "currency",
            width: 10,
            value: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.value(row) - $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.value(row),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenueWithVariations - (expensesVariation + projectExpenses)", value);
            }
        },
        profitMarginVariationProject: {
            id: "profitMarginVariationProject",
            label: "Profit Margin (Cost + Variation + Project)",
            type: "percent",
            width: 10,
            value: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitVariationProject.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.value(row),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitVariationProject.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenueWithVariations > 0 ? (revenueWithVariations - (expensesVariation + projectExpenses)) / revenueWithVariations : 0", value);
            }
        },
        markupVariationProject: {
            id: "markupVariationProject",
            label: "Markup (Cost + Variation + Project)",
            type: "percent",
            width: 10,
            value: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitVariationProject.value(row) / $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.value(row),
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitVariationProject.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(expensesVariation + projectExpenses) > 0 ? (revenueWithVariations - (expensesVariation + projectExpenses)) / (expensesVariation + projectExpenses) : 0", value);
            }
        },
        expensesVsRevenueVariationProject: {
            id: "expensesVsRevenueVariationProject",
            label: "Expenses / Revenue (Cost + Variation + Project)",
            type: "progressBar",
            width: 20,
            value: (row)=>{
                return {
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.value(row)
                };
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenueWithVariations > 0 ? (expensesVariation + projectExpenses) / revenueWithVariations : 0", value);
            }
        },
        revenueVsExpensesVariationProject: {
            id: "revenueVsExpensesVariationProject",
            label: "Revenue / Expenses (Cost + Variation + Project)",
            type: "progressBar",
            width: 20,
            value: (row)=>{
                return {
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.value(row)
                };
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(expensesVariation + projectExpenses) > 0 ? revenueWithVariations / (expensesVariation + projectExpenses) : 0", value);
            }
        },
        profitVsRevenueVariationProject: {
            id: "profitVsRevenueVariationProject",
            label: "Profit / Revenue (Cost + Variation + Project)",
            type: "progressBar",
            width: 20,
            value: (row)=>{
                return {
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitVariationProject.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.value(row)
                };
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitVariationProject.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).revenueWithVariations.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenueWithVariations > 0 ? (revenueWithVariations - (expensesVariation + projectExpenses)) / revenueWithVariations : 0", value);
            }
        },
        profitVsExpensesVariationProject: {
            id: "profitVsExpensesVariationProject",
            label: "Profit / Expenses (Cost + Variation + Project)",
            type: "progressBar",
            width: 20,
            value: (row)=>{
                return {
                    numerator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitVariationProject.value(row),
                    denominator: $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.value(row)
                };
            },
            permissions: (row)=>$765c8dd55b5340b0$export$87b7940e8d176c5c(report).profitVariationProject.permissions(row) && $765c8dd55b5340b0$export$87b7940e8d176c5c(report).expensesVariationProject.permissions(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("(expensesVariation + projectExpenses) > 0 ? (revenueWithVariations - (expensesVariation + projectExpenses)) / (expensesVariation + projectExpenses) : 0", value);
            }
        }
    });

});
parcelRegister("RSSjA", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0a1f84648f30cf34$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $0a1f84648f30cf34$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $0a1f84648f30cf34$export$25062201e9e25d76; });

var $hvk62 = parcelRequire("hvk62");

var $kwe0A = parcelRequire("kwe0A");
parcelRequire("7PdBe");
parcelRequire("cG9fz");
parcelRequire("kdwYq");
parcelRequire("QHNm5");

parcelRequire("1IGIR");
parcelRequire("gk5Qr");
parcelRequire("bPokU");
parcelRequire("aAoqi");
var $0a1f84648f30cf34$export$ffb0004e005737fa = $hvk62.Fragment;
function $0a1f84648f30cf34$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $kwe0A.h).call(props, "css")) return $hvk62.jsx(type, props, key);
    return $hvk62.jsx((0, $kwe0A.E), (0, $kwe0A.c)(type, props), key);
}
function $0a1f84648f30cf34$export$25062201e9e25d76(type, props, key) {
    if (!(0, $kwe0A.h).call(props, "css")) return $hvk62.jsxs(type, props, key);
    return $hvk62.jsxs((0, $kwe0A.E), (0, $kwe0A.c)(type, props), key);
}

});
parcelRegister("hvk62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bg8pZ"));

});

parcelRegister("kwe0A", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $ef01a99d5cc22a2f$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $ef01a99d5cc22a2f$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $ef01a99d5cc22a2f$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $ef01a99d5cc22a2f$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $ef01a99d5cc22a2f$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $ef01a99d5cc22a2f$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $ef01a99d5cc22a2f$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $ef01a99d5cc22a2f$export$a9c23c6ac3fc3eca; });

var $7PdBe = parcelRequire("7PdBe");

var $cG9fz = parcelRequire("cG9fz");

var $hIbXl = parcelRequire("hIbXl");

var $QHNm5 = parcelRequire("QHNm5");

var $fAfNG = parcelRequire("fAfNG");

var $gk5Qr = parcelRequire("gk5Qr");

var $bPokU = parcelRequire("bPokU");

var $aAoqi = parcelRequire("aAoqi");
var $ef01a99d5cc22a2f$export$407448d2b89b1813 = false;
var $ef01a99d5cc22a2f$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $ef01a99d5cc22a2f$var$EmotionCacheContext = /* #__PURE__ */ $7PdBe.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $cG9fz.default)({
    key: "css"
}) : null);
var $ef01a99d5cc22a2f$export$e7094788287c5e9b = $ef01a99d5cc22a2f$var$EmotionCacheContext.Provider;
var $ef01a99d5cc22a2f$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $7PdBe.useContext)($ef01a99d5cc22a2f$var$EmotionCacheContext);
};
var $ef01a99d5cc22a2f$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $7PdBe.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7PdBe.useContext)($ef01a99d5cc22a2f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$ef01a99d5cc22a2f$export$23f2a1d2818174ef) $ef01a99d5cc22a2f$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $7PdBe.useContext)($ef01a99d5cc22a2f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $cG9fz.default)({
                key: "css"
            });
            return /*#__PURE__*/ $7PdBe.createElement($ef01a99d5cc22a2f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $ef01a99d5cc22a2f$export$971d5caa766a69d7 = /* #__PURE__ */ $7PdBe.createContext({});
var $ef01a99d5cc22a2f$export$3b14a55fb2447963 = function useTheme() {
    return $7PdBe.useContext($ef01a99d5cc22a2f$export$971d5caa766a69d7);
};
var $ef01a99d5cc22a2f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $hIbXl.default)({}, outerTheme, theme);
};
var $ef01a99d5cc22a2f$var$createCacheWithTheme = /* #__PURE__ */ (0, $QHNm5.default)(function(outerTheme) {
    return (0, $QHNm5.default)(function(theme) {
        return $ef01a99d5cc22a2f$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $ef01a99d5cc22a2f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7PdBe.useContext($ef01a99d5cc22a2f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $ef01a99d5cc22a2f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7PdBe.createElement($ef01a99d5cc22a2f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $ef01a99d5cc22a2f$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $7PdBe.useContext($ef01a99d5cc22a2f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7PdBe.createElement(Component, (0, $hIbXl.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $7PdBe.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $fAfNG.default)(WithTheme, Component);
}
var $ef01a99d5cc22a2f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $ef01a99d5cc22a2f$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $ef01a99d5cc22a2f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($ef01a99d5cc22a2f$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$ef01a99d5cc22a2f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $ef01a99d5cc22a2f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $gk5Qr.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $aAoqi.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $gk5Qr.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$ef01a99d5cc22a2f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7PdBe.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $ef01a99d5cc22a2f$var$Emotion = /* #__PURE__ */ $ef01a99d5cc22a2f$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$ef01a99d5cc22a2f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $gk5Qr.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bPokU.serializeStyles)(registeredStyles, undefined, $7PdBe.useContext($ef01a99d5cc22a2f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($ef01a99d5cc22a2f$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $ef01a99d5cc22a2f$var$typePropName && !$ef01a99d5cc22a2f$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7PdBe.createElement($7PdBe.Fragment, null, /*#__PURE__*/ $7PdBe.createElement($ef01a99d5cc22a2f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $7PdBe.createElement(WrappedComponent, newProps));
});
var $ef01a99d5cc22a2f$export$a9c23c6ac3fc3eca = $ef01a99d5cc22a2f$var$Emotion;

});
parcelRegister("cG9fz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93b0952e83918ba4$export$2e2bcd8739ae039; });

var $eAHhc = parcelRequire("eAHhc");

var $hHw4u = parcelRequire("hHw4u");

var $QHNm5 = parcelRequire("QHNm5");

var $cGF5c = parcelRequire("cGF5c");
var $93b0952e83918ba4$var$isBrowser = typeof document !== "undefined";
var $93b0952e83918ba4$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $hHw4u.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $hHw4u.token)(character)) break;
        (0, $hHw4u.next)();
    }
    return (0, $hHw4u.slice)(begin, (0, $hHw4u.position));
};
var $93b0952e83918ba4$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $hHw4u.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $hHw4u.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $93b0952e83918ba4$var$identifierWithPointTracking((0, $hHw4u.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $hHw4u.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $hHw4u.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $hHw4u.from)(character);
    }
    while (character = (0, $hHw4u.next)());
    return parsed;
};
var $93b0952e83918ba4$var$getRules = function getRules(value, points) {
    return (0, $hHw4u.dealloc)($93b0952e83918ba4$var$toRules((0, $hHw4u.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $93b0952e83918ba4$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $93b0952e83918ba4$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$93b0952e83918ba4$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $93b0952e83918ba4$var$fixedElements.set(element, true);
    var points = [];
    var rules = $93b0952e83918ba4$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $93b0952e83918ba4$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $93b0952e83918ba4$var$prefix(value, length) {
    switch((0, $hHw4u.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $hHw4u.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $hHw4u.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MOZ) + value + (0, $hHw4u.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + value + value;
        // order
        case 6165:
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.replace)(value, /(\w+).+(:[^]+)/, (0, $hHw4u.WEBKIT) + "box-$1$2" + (0, $hHw4u.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + "flex-item-" + (0, $hHw4u.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + "flex-line-pack" + (0, $hHw4u.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + (0, $hHw4u.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + (0, $hHw4u.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $hHw4u.WEBKIT) + "box-" + (0, $hHw4u.replace)(value, "-grow", "") + (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + (0, $hHw4u.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $hHw4u.WEBKIT) + (0, $hHw4u.replace)(value, /([^-])(transform)/g, "$1" + (0, $hHw4u.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $hHw4u.replace)((0, $hHw4u.replace)((0, $hHw4u.replace)(value, /(zoom-|grab)/, (0, $hHw4u.WEBKIT) + "$1"), /(image-set)/, (0, $hHw4u.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $hHw4u.replace)(value, /(image-set\([^]*)/, (0, $hHw4u.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $hHw4u.replace)((0, $hHw4u.replace)(value, /(.+:)(flex-)?(.*)/, (0, $hHw4u.WEBKIT) + "box-pack:$3" + (0, $hHw4u.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $hHw4u.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $hHw4u.replace)(value, /(.+)-inline(.+)/, (0, $hHw4u.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $hHw4u.strlen)(value) - 1 - length > 6) switch((0, $hHw4u.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $hHw4u.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $hHw4u.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $hHw4u.WEBKIT) + "$2-$3" + "$1" + (0, $hHw4u.MOZ) + ((0, $hHw4u.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $hHw4u.indexof)(value, "stretch") ? $93b0952e83918ba4$var$prefix((0, $hHw4u.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $hHw4u.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $hHw4u.charat)(value, (0, $hHw4u.strlen)(value) - 3 - (~(0, $hHw4u.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $hHw4u.replace)(value, ":", ":" + (0, $hHw4u.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $hHw4u.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $hHw4u.WEBKIT) + ((0, $hHw4u.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $hHw4u.WEBKIT) + "$2$3" + "$1" + (0, $hHw4u.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $hHw4u.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + (0, $hHw4u.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + (0, $hHw4u.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + (0, $hHw4u.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $hHw4u.WEBKIT) + value + (0, $hHw4u.MS) + value + value;
    }
    return value;
}
var $93b0952e83918ba4$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $hHw4u.DECLARATION:
                element["return"] = $93b0952e83918ba4$var$prefix(element.value, element.length);
                break;
            case 0, $hHw4u.KEYFRAMES:
                return (0, $hHw4u.serialize)([
                    (0, $hHw4u.copy)(element, {
                        value: (0, $hHw4u.replace)(element.value, "@", "@" + (0, $hHw4u.WEBKIT))
                    })
                ], callback);
            case 0, $hHw4u.RULESET:
                if (element.length) return (0, $hHw4u.combine)(element.props, function(value) {
                    switch((0, $hHw4u.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $hHw4u.serialize)([
                                (0, $hHw4u.copy)(element, {
                                    props: [
                                        (0, $hHw4u.replace)(value, /:(read-\w+)/, ":" + (0, $hHw4u.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $hHw4u.serialize)([
                                (0, $hHw4u.copy)(element, {
                                    props: [
                                        (0, $hHw4u.replace)(value, /:(plac\w+)/, ":" + (0, $hHw4u.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $hHw4u.copy)(element, {
                                    props: [
                                        (0, $hHw4u.replace)(value, /:(plac\w+)/, ":" + (0, $hHw4u.MOZ) + "$1")
                                    ]
                                }),
                                (0, $hHw4u.copy)(element, {
                                    props: [
                                        (0, $hHw4u.replace)(value, /:(plac\w+)/, (0, $hHw4u.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $93b0952e83918ba4$var$getServerStylisCache = $93b0952e83918ba4$var$isBrowser ? undefined : (0, $QHNm5.default)(function() {
    return (0, $cGF5c.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $93b0952e83918ba4$var$defaultStylisPlugins = [
    $93b0952e83918ba4$var$prefixer
];
var $93b0952e83918ba4$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($93b0952e83918ba4$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $93b0952e83918ba4$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($93b0952e83918ba4$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $93b0952e83918ba4$var$compat,
        $93b0952e83918ba4$var$removeLabel
    ];
    if ($93b0952e83918ba4$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $hHw4u.stringify),
            (0, $hHw4u.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $hHw4u.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $hHw4u.serialize)((0, $hHw4u.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $hHw4u.stringify)
        ];
        var _serializer = (0, $hHw4u.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $hHw4u.serialize)((0, $hHw4u.compile)(styles), _serializer);
        };
        var serverStylisCache = $93b0952e83918ba4$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $eAHhc.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("eAHhc", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $a9f5ff413efb3552$export$9d753cd7ae895cce; });
var $a9f5ff413efb3552$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $a9f5ff413efb3552$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $a9f5ff413efb3552$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $a9f5ff413efb3552$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$a9f5ff413efb3552$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($a9f5ff413efb3552$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $a9f5ff413efb3552$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("hHw4u", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $c6d86efa8d886f9d$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $c6d86efa8d886f9d$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $c6d86efa8d886f9d$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $c6d86efa8d886f9d$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $c6d86efa8d886f9d$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $c6d86efa8d886f9d$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $c6d86efa8d886f9d$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $c6d86efa8d886f9d$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $c6d86efa8d886f9d$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $c6d86efa8d886f9d$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $c6d86efa8d886f9d$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $c6d86efa8d886f9d$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $c6d86efa8d886f9d$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $c6d86efa8d886f9d$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $c6d86efa8d886f9d$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $c6d86efa8d886f9d$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $c6d86efa8d886f9d$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $c6d86efa8d886f9d$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $c6d86efa8d886f9d$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $c6d86efa8d886f9d$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $c6d86efa8d886f9d$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $c6d86efa8d886f9d$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $c6d86efa8d886f9d$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $c6d86efa8d886f9d$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $c6d86efa8d886f9d$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $c6d86efa8d886f9d$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $c6d86efa8d886f9d$export$38bcb760f1d4871c; });
var $c6d86efa8d886f9d$export$71ad59f2e432cfe8 = "-ms-";
var $c6d86efa8d886f9d$export$2c0f367103c8d01c = "-moz-";
var $c6d86efa8d886f9d$export$39dfd62a25e0fe93 = "-webkit-";
var $c6d86efa8d886f9d$export$a29989082612d0d9 = "comm";
var $c6d86efa8d886f9d$export$aa3a2e812ca8570d = "rule";
var $c6d86efa8d886f9d$export$527d108ccf083c2b = "decl";
var $c6d86efa8d886f9d$export$d3d35020fa5b54f0 = "@page";
var $c6d86efa8d886f9d$export$500415a86c544f73 = "@media";
var $c6d86efa8d886f9d$export$a763edbf796b780a = "@import";
var $c6d86efa8d886f9d$export$2790aeb8b4e5c826 = "@charset";
var $c6d86efa8d886f9d$export$1cc683e23b84b133 = "@viewport";
var $c6d86efa8d886f9d$export$9447a5efea57e862 = "@supports";
var $c6d86efa8d886f9d$export$ef011b4e114b1fba = "@document";
var $c6d86efa8d886f9d$export$6aad947bda0f3f46 = "@namespace";
var $c6d86efa8d886f9d$export$b44a8529a35fcb60 = "@keyframes";
var $c6d86efa8d886f9d$export$2c16de31893252e6 = "@font-face";
var $c6d86efa8d886f9d$export$3d846dd52e150c6f = "@counter-style";
var $c6d86efa8d886f9d$export$22314bfbb57653fe = "@font-feature-values";
var $c6d86efa8d886f9d$export$d773506282b3cfe6 = "@layer";
var $c6d86efa8d886f9d$export$2335f513bbd82c6d = Math.abs;
var $c6d86efa8d886f9d$export$6788812c4e6611e6 = String.fromCharCode;
var $c6d86efa8d886f9d$export$e6e34fd1f2686227 = Object.assign;
function $c6d86efa8d886f9d$export$d6af199866bfb566(e, r) {
    return $c6d86efa8d886f9d$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c6d86efa8d886f9d$export$a9db5e087081082d(e, 0)) << 2 ^ $c6d86efa8d886f9d$export$a9db5e087081082d(e, 1)) << 2 ^ $c6d86efa8d886f9d$export$a9db5e087081082d(e, 2)) << 2 ^ $c6d86efa8d886f9d$export$a9db5e087081082d(e, 3) : 0;
}
function $c6d86efa8d886f9d$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c6d86efa8d886f9d$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c6d86efa8d886f9d$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $c6d86efa8d886f9d$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c6d86efa8d886f9d$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c6d86efa8d886f9d$export$36776f635604f274(e) {
    return e.length;
}
function $c6d86efa8d886f9d$export$f9084667e487ed46(e) {
    return e.length;
}
function $c6d86efa8d886f9d$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c6d86efa8d886f9d$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $c6d86efa8d886f9d$export$53f1d5ea8de3d7c = 1;
var $c6d86efa8d886f9d$export$4e0c71f277ca26b3 = 1;
var $c6d86efa8d886f9d$export$f24224f1c91d8156 = 0;
var $c6d86efa8d886f9d$export$5880b8b5730aff45 = 0;
var $c6d86efa8d886f9d$export$c0306caf338ac095 = 0;
var $c6d86efa8d886f9d$export$30a86d91af8ff6e6 = "";
function $c6d86efa8d886f9d$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c6d86efa8d886f9d$export$53f1d5ea8de3d7c,
        column: $c6d86efa8d886f9d$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $c6d86efa8d886f9d$export$784d13d8ee351f07(e, r) {
    return $c6d86efa8d886f9d$export$e6e34fd1f2686227($c6d86efa8d886f9d$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $c6d86efa8d886f9d$export$eba6f6f03b0a92e7() {
    return $c6d86efa8d886f9d$export$c0306caf338ac095;
}
function $c6d86efa8d886f9d$export$232faf9add678146() {
    $c6d86efa8d886f9d$export$c0306caf338ac095 = $c6d86efa8d886f9d$export$5880b8b5730aff45 > 0 ? $c6d86efa8d886f9d$export$a9db5e087081082d($c6d86efa8d886f9d$export$30a86d91af8ff6e6, --$c6d86efa8d886f9d$export$5880b8b5730aff45) : 0;
    if ($c6d86efa8d886f9d$export$4e0c71f277ca26b3--, $c6d86efa8d886f9d$export$c0306caf338ac095 === 10) $c6d86efa8d886f9d$export$4e0c71f277ca26b3 = 1, $c6d86efa8d886f9d$export$53f1d5ea8de3d7c--;
    return $c6d86efa8d886f9d$export$c0306caf338ac095;
}
function $c6d86efa8d886f9d$export$48cfd1e771a65c4f() {
    $c6d86efa8d886f9d$export$c0306caf338ac095 = $c6d86efa8d886f9d$export$5880b8b5730aff45 < $c6d86efa8d886f9d$export$f24224f1c91d8156 ? $c6d86efa8d886f9d$export$a9db5e087081082d($c6d86efa8d886f9d$export$30a86d91af8ff6e6, $c6d86efa8d886f9d$export$5880b8b5730aff45++) : 0;
    if ($c6d86efa8d886f9d$export$4e0c71f277ca26b3++, $c6d86efa8d886f9d$export$c0306caf338ac095 === 10) $c6d86efa8d886f9d$export$4e0c71f277ca26b3 = 1, $c6d86efa8d886f9d$export$53f1d5ea8de3d7c++;
    return $c6d86efa8d886f9d$export$c0306caf338ac095;
}
function $c6d86efa8d886f9d$export$4d3fb11e950abb9e() {
    return $c6d86efa8d886f9d$export$a9db5e087081082d($c6d86efa8d886f9d$export$30a86d91af8ff6e6, $c6d86efa8d886f9d$export$5880b8b5730aff45);
}
function $c6d86efa8d886f9d$export$e88cb2efb12ae807() {
    return $c6d86efa8d886f9d$export$5880b8b5730aff45;
}
function $c6d86efa8d886f9d$export$58adb3bec8346d0f(e, r) {
    return $c6d86efa8d886f9d$export$2f35ab04d2335697($c6d86efa8d886f9d$export$30a86d91af8ff6e6, e, r);
}
function $c6d86efa8d886f9d$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c6d86efa8d886f9d$export$2de70f21292aac9e(e) {
    return $c6d86efa8d886f9d$export$53f1d5ea8de3d7c = $c6d86efa8d886f9d$export$4e0c71f277ca26b3 = 1, $c6d86efa8d886f9d$export$f24224f1c91d8156 = $c6d86efa8d886f9d$export$36776f635604f274($c6d86efa8d886f9d$export$30a86d91af8ff6e6 = e), $c6d86efa8d886f9d$export$5880b8b5730aff45 = 0, [];
}
function $c6d86efa8d886f9d$export$45918ac1574455b1(e) {
    return $c6d86efa8d886f9d$export$30a86d91af8ff6e6 = "", e;
}
function $c6d86efa8d886f9d$export$410ac95b9ec204b8(e) {
    return $c6d86efa8d886f9d$export$87c2784dc9fc4ab($c6d86efa8d886f9d$export$58adb3bec8346d0f($c6d86efa8d886f9d$export$5880b8b5730aff45 - 1, $c6d86efa8d886f9d$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c6d86efa8d886f9d$export$660b2ee2d4fb4eff(e) {
    return $c6d86efa8d886f9d$export$45918ac1574455b1($c6d86efa8d886f9d$export$5f8c09e3ae6f64e1($c6d86efa8d886f9d$export$2de70f21292aac9e(e)));
}
function $c6d86efa8d886f9d$export$7af1228ff777d175(e) {
    while($c6d86efa8d886f9d$export$c0306caf338ac095 = $c6d86efa8d886f9d$export$4d3fb11e950abb9e())if ($c6d86efa8d886f9d$export$c0306caf338ac095 < 33) $c6d86efa8d886f9d$export$48cfd1e771a65c4f();
    else break;
    return $c6d86efa8d886f9d$export$9e1725a4cfeada27(e) > 2 || $c6d86efa8d886f9d$export$9e1725a4cfeada27($c6d86efa8d886f9d$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c6d86efa8d886f9d$export$5f8c09e3ae6f64e1(e) {
    while($c6d86efa8d886f9d$export$48cfd1e771a65c4f())switch($c6d86efa8d886f9d$export$9e1725a4cfeada27($c6d86efa8d886f9d$export$c0306caf338ac095)){
        case 0:
            $c6d86efa8d886f9d$export$10d8903dec122b9d($c6d86efa8d886f9d$export$c2ab62c7bf24634($c6d86efa8d886f9d$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c6d86efa8d886f9d$export$10d8903dec122b9d($c6d86efa8d886f9d$export$410ac95b9ec204b8($c6d86efa8d886f9d$export$c0306caf338ac095), e);
            break;
        default:
            $c6d86efa8d886f9d$export$10d8903dec122b9d($c6d86efa8d886f9d$export$6788812c4e6611e6($c6d86efa8d886f9d$export$c0306caf338ac095), e);
    }
    return e;
}
function $c6d86efa8d886f9d$export$955ba06d119e085e(e, r) {
    while(--r && $c6d86efa8d886f9d$export$48cfd1e771a65c4f())if ($c6d86efa8d886f9d$export$c0306caf338ac095 < 48 || $c6d86efa8d886f9d$export$c0306caf338ac095 > 102 || $c6d86efa8d886f9d$export$c0306caf338ac095 > 57 && $c6d86efa8d886f9d$export$c0306caf338ac095 < 65 || $c6d86efa8d886f9d$export$c0306caf338ac095 > 70 && $c6d86efa8d886f9d$export$c0306caf338ac095 < 97) break;
    return $c6d86efa8d886f9d$export$58adb3bec8346d0f(e, $c6d86efa8d886f9d$export$e88cb2efb12ae807() + (r < 6 && $c6d86efa8d886f9d$export$4d3fb11e950abb9e() == 32 && $c6d86efa8d886f9d$export$48cfd1e771a65c4f() == 32));
}
function $c6d86efa8d886f9d$export$c889f2fcc19dbf12(e) {
    while($c6d86efa8d886f9d$export$48cfd1e771a65c4f())switch($c6d86efa8d886f9d$export$c0306caf338ac095){
        case e:
            return $c6d86efa8d886f9d$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c6d86efa8d886f9d$export$c889f2fcc19dbf12($c6d86efa8d886f9d$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c6d86efa8d886f9d$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c6d86efa8d886f9d$export$48cfd1e771a65c4f();
            break;
    }
    return $c6d86efa8d886f9d$export$5880b8b5730aff45;
}
function $c6d86efa8d886f9d$export$4254d4e2b3745c4c(e, r) {
    while($c6d86efa8d886f9d$export$48cfd1e771a65c4f())if (e + $c6d86efa8d886f9d$export$c0306caf338ac095 === 57) break;
    else if (e + $c6d86efa8d886f9d$export$c0306caf338ac095 === 84 && $c6d86efa8d886f9d$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c6d86efa8d886f9d$export$58adb3bec8346d0f(r, $c6d86efa8d886f9d$export$5880b8b5730aff45 - 1) + "*" + $c6d86efa8d886f9d$export$6788812c4e6611e6(e === 47 ? e : $c6d86efa8d886f9d$export$48cfd1e771a65c4f());
}
function $c6d86efa8d886f9d$export$c2ab62c7bf24634(e) {
    while(!$c6d86efa8d886f9d$export$9e1725a4cfeada27($c6d86efa8d886f9d$export$4d3fb11e950abb9e()))$c6d86efa8d886f9d$export$48cfd1e771a65c4f();
    return $c6d86efa8d886f9d$export$58adb3bec8346d0f(e, $c6d86efa8d886f9d$export$5880b8b5730aff45);
}
function $c6d86efa8d886f9d$export$ef7acd7185315e22(e) {
    return $c6d86efa8d886f9d$export$45918ac1574455b1($c6d86efa8d886f9d$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c6d86efa8d886f9d$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c6d86efa8d886f9d$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $c6d86efa8d886f9d$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c6d86efa8d886f9d$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($c6d86efa8d886f9d$export$f8e21b1e77979a08(j += $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed($c6d86efa8d886f9d$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $c6d86efa8d886f9d$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $c6d86efa8d886f9d$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $c6d86efa8d886f9d$export$955ba06d119e085e($c6d86efa8d886f9d$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c6d86efa8d886f9d$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c6d86efa8d886f9d$export$10d8903dec122b9d($c6d86efa8d886f9d$export$4a34f930e789283c($c6d86efa8d886f9d$export$4254d4e2b3745c4c($c6d86efa8d886f9d$export$48cfd1e771a65c4f(), $c6d86efa8d886f9d$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c6d86efa8d886f9d$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $c6d86efa8d886f9d$export$36776f635604f274(j) - l) $c6d86efa8d886f9d$export$10d8903dec122b9d(p > 32 ? $c6d86efa8d886f9d$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $c6d86efa8d886f9d$export$f8483753829ec8f3($c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $c6d86efa8d886f9d$export$10d8903dec122b9d(y = $c6d86efa8d886f9d$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $c6d86efa8d886f9d$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $c6d86efa8d886f9d$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c6d86efa8d886f9d$export$98e6a39c04603d36(e, y, y, n && $c6d86efa8d886f9d$export$10d8903dec122b9d($c6d86efa8d886f9d$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $c6d86efa8d886f9d$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $c6d86efa8d886f9d$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $c6d86efa8d886f9d$export$232faf9add678146() == 125) continue;
            }
            switch(j += $c6d86efa8d886f9d$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c6d86efa8d886f9d$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c6d86efa8d886f9d$export$4d3fb11e950abb9e() === 45) j += $c6d86efa8d886f9d$export$410ac95b9ec204b8($c6d86efa8d886f9d$export$48cfd1e771a65c4f());
                    v = $c6d86efa8d886f9d$export$4d3fb11e950abb9e(), o = l = $c6d86efa8d886f9d$export$36776f635604f274(g = j += $c6d86efa8d886f9d$export$c2ab62c7bf24634($c6d86efa8d886f9d$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $c6d86efa8d886f9d$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $c6d86efa8d886f9d$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $c6d86efa8d886f9d$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $c6d86efa8d886f9d$export$2f35ab04d2335697(e, v + 1, v = $c6d86efa8d886f9d$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $c6d86efa8d886f9d$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $c6d86efa8d886f9d$export$35059013cd4a06db(e, r, a, s === 0 ? $c6d86efa8d886f9d$export$aa3a2e812ca8570d : i, f, o, l);
}
function $c6d86efa8d886f9d$export$4a34f930e789283c(e, r, a) {
    return $c6d86efa8d886f9d$export$35059013cd4a06db(e, r, a, $c6d86efa8d886f9d$export$a29989082612d0d9, $c6d86efa8d886f9d$export$6788812c4e6611e6($c6d86efa8d886f9d$export$eba6f6f03b0a92e7()), $c6d86efa8d886f9d$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $c6d86efa8d886f9d$export$f8483753829ec8f3(e, r, a, n) {
    return $c6d86efa8d886f9d$export$35059013cd4a06db(e, r, a, $c6d86efa8d886f9d$export$527d108ccf083c2b, $c6d86efa8d886f9d$export$2f35ab04d2335697(e, 0, n), $c6d86efa8d886f9d$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $c6d86efa8d886f9d$export$82e9f45cca5ba907(n, c, s) {
    switch($c6d86efa8d886f9d$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c6d86efa8d886f9d$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$2c0f367103c8d01c + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c6d86efa8d886f9d$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "box-$1$2" + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "flex-item-" + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c6d86efa8d886f9d$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "grid-row-" + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "flex-line-pack" + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "box-" + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed($c6d86efa8d886f9d$export$77ad94ebf1c2b9ed($c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed($c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "box-pack:$3" + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c6d86efa8d886f9d$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "grid-column-align" + $c6d86efa8d886f9d$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c6d86efa8d886f9d$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c6d86efa8d886f9d$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c6d86efa8d886f9d$export$f8e21b1e77979a08(s, "span") ? $c6d86efa8d886f9d$export$4659b591c19bdf3d(s, /\d+/) : +$c6d86efa8d886f9d$export$4659b591c19bdf3d(s, /\d+/) - +$c6d86efa8d886f9d$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c6d86efa8d886f9d$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed($c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c6d86efa8d886f9d$export$36776f635604f274(n) - 1 - c > 6) switch($c6d86efa8d886f9d$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c6d86efa8d886f9d$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c6d86efa8d886f9d$export$2c0f367103c8d01c + ($c6d86efa8d886f9d$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c6d86efa8d886f9d$export$f8e21b1e77979a08(n, "stretch") ? $c6d86efa8d886f9d$export$82e9f45cca5ba907($c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c6d86efa8d886f9d$export$a9db5e087081082d(n, c + 6) === 121) return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, ":", ":" + $c6d86efa8d886f9d$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c6d86efa8d886f9d$export$a9db5e087081082d(n, $c6d86efa8d886f9d$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + ($c6d86efa8d886f9d$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, ":", ":" + $c6d86efa8d886f9d$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c6d86efa8d886f9d$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $c6d86efa8d886f9d$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $c6d86efa8d886f9d$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c6d86efa8d886f9d$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c6d86efa8d886f9d$export$a763edbf796b780a:
        case $c6d86efa8d886f9d$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c6d86efa8d886f9d$export$a29989082612d0d9:
            return "";
        case $c6d86efa8d886f9d$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c6d86efa8d886f9d$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c6d86efa8d886f9d$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $c6d86efa8d886f9d$export$36776f635604f274(a = $c6d86efa8d886f9d$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c6d86efa8d886f9d$export$5a7767152ae0305f(e) {
    var r = $c6d86efa8d886f9d$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c6d86efa8d886f9d$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c6d86efa8d886f9d$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c6d86efa8d886f9d$export$527d108ccf083c2b:
                n.return = $c6d86efa8d886f9d$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c6d86efa8d886f9d$export$b44a8529a35fcb60:
                return $c6d86efa8d886f9d$export$dfdc1655ccc5b9cb([
                    $c6d86efa8d886f9d$export$784d13d8ee351f07(n, {
                        value: $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c6d86efa8d886f9d$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c6d86efa8d886f9d$export$aa3a2e812ca8570d:
                if (n.length) return $c6d86efa8d886f9d$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($c6d86efa8d886f9d$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $c6d86efa8d886f9d$export$dfdc1655ccc5b9cb([
                                $c6d86efa8d886f9d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c6d86efa8d886f9d$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $c6d86efa8d886f9d$export$dfdc1655ccc5b9cb([
                                $c6d86efa8d886f9d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c6d86efa8d886f9d$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $c6d86efa8d886f9d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c6d86efa8d886f9d$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $c6d86efa8d886f9d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c6d86efa8d886f9d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c6d86efa8d886f9d$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $c6d86efa8d886f9d$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c6d86efa8d886f9d$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c6d86efa8d886f9d$export$1be1fc439b849fdf($c6d86efa8d886f9d$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c6d86efa8d886f9d$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c6d86efa8d886f9d$export$2f35ab04d2335697(r, 1, $c6d86efa8d886f9d$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c6d86efa8d886f9d$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c6d86efa8d886f9d$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c6d86efa8d886f9d$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("QHNm5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09e6d43a7e4077ee$export$2e2bcd8739ae039; });
var $09e6d43a7e4077ee$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("cGF5c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93c9467e1ec60c9a$export$2e2bcd8739ae039; });
function $93c9467e1ec60c9a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("hIbXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce4fd1f625f76bdc$export$2e2bcd8739ae039; });
function $ce4fd1f625f76bdc$export$2e2bcd8739ae039() {
    return $ce4fd1f625f76bdc$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce4fd1f625f76bdc$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fAfNG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b586796b9d130f61$export$2e2bcd8739ae039; });

var $1IGIR = parcelRequire("1IGIR");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $b586796b9d130f61$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1IGIR)))(targetComponent, sourceComponent);
};

});
parcelRegister("1IGIR", function(module, exports) {
"use strict";

var $lXnl8 = parcelRequire("lXnl8");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $140b0a4a6af61e18$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $140b0a4a6af61e18$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $140b0a4a6af61e18$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $140b0a4a6af61e18$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $140b0a4a6af61e18$var$TYPE_STATICS = {};
$140b0a4a6af61e18$var$TYPE_STATICS[$lXnl8.ForwardRef] = $140b0a4a6af61e18$var$FORWARD_REF_STATICS;
$140b0a4a6af61e18$var$TYPE_STATICS[$lXnl8.Memo] = $140b0a4a6af61e18$var$MEMO_STATICS;
function $140b0a4a6af61e18$var$getStatics(component) {
    // React v16.11 and below
    if ($lXnl8.isMemo(component)) return $140b0a4a6af61e18$var$MEMO_STATICS;
     // React v16.12 and above
    return $140b0a4a6af61e18$var$TYPE_STATICS[component["$$typeof"]] || $140b0a4a6af61e18$var$REACT_STATICS;
}
var $140b0a4a6af61e18$var$defineProperty = Object.defineProperty;
var $140b0a4a6af61e18$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $140b0a4a6af61e18$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $140b0a4a6af61e18$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $140b0a4a6af61e18$var$getPrototypeOf = Object.getPrototypeOf;
var $140b0a4a6af61e18$var$objectPrototype = Object.prototype;
function $140b0a4a6af61e18$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($140b0a4a6af61e18$var$objectPrototype) {
            var inheritedComponent = $140b0a4a6af61e18$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $140b0a4a6af61e18$var$objectPrototype) $140b0a4a6af61e18$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $140b0a4a6af61e18$var$getOwnPropertyNames(sourceComponent);
        if ($140b0a4a6af61e18$var$getOwnPropertySymbols) keys = keys.concat($140b0a4a6af61e18$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $140b0a4a6af61e18$var$getStatics(targetComponent);
        var sourceStatics = $140b0a4a6af61e18$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$140b0a4a6af61e18$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $140b0a4a6af61e18$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $140b0a4a6af61e18$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $140b0a4a6af61e18$var$hoistNonReactStatics;

});
parcelRegister("lXnl8", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fmu17"));

});



parcelRegister("gk5Qr", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $be230c462290b66a$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $be230c462290b66a$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $be230c462290b66a$export$6f077d94b33a01aa; });
var $be230c462290b66a$var$isBrowser = typeof document !== "undefined";
function $be230c462290b66a$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $be230c462290b66a$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $be230c462290b66a$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $be230c462290b66a$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $be230c462290b66a$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$be230c462290b66a$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$be230c462290b66a$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("bPokU", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $89c755cf2d2ab954$export$6321afa313b251b5; });

var $iJYTD = parcelRequire("iJYTD");

var $5HVQT = parcelRequire("5HVQT");

var $cGF5c = parcelRequire("cGF5c");
var $89c755cf2d2ab954$var$isDevelopment = false;
var $89c755cf2d2ab954$var$hyphenateRegex = /[A-Z]|^ms/g;
var $89c755cf2d2ab954$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $89c755cf2d2ab954$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $89c755cf2d2ab954$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $89c755cf2d2ab954$var$processStyleName = /* #__PURE__ */ (0, $cGF5c.default)(function(styleName) {
    return $89c755cf2d2ab954$var$isCustomProperty(styleName) ? styleName : styleName.replace($89c755cf2d2ab954$var$hyphenateRegex, "-$&").toLowerCase();
});
var $89c755cf2d2ab954$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($89c755cf2d2ab954$var$animationRegex, function(match, p1, p2) {
                $89c755cf2d2ab954$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $89c755cf2d2ab954$var$cursor
                };
                return p1;
            });
    }
    if ((0, $5HVQT.default)[key] !== 1 && !$89c755cf2d2ab954$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $89c755cf2d2ab954$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $89c755cf2d2ab954$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $89c755cf2d2ab954$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $89c755cf2d2ab954$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $89c755cf2d2ab954$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $89c755cf2d2ab954$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $89c755cf2d2ab954$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $89c755cf2d2ab954$var$cursor;
                var result = interpolation(mergedProps);
                $89c755cf2d2ab954$var$cursor = previousCursor;
                return $89c755cf2d2ab954$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $89c755cf2d2ab954$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $89c755cf2d2ab954$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($89c755cf2d2ab954$var$isProcessableValue(asString)) string += $89c755cf2d2ab954$var$processStyleName(key) + ":" + $89c755cf2d2ab954$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $89c755cf2d2ab954$var$isDevelopment) throw new Error($89c755cf2d2ab954$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($89c755cf2d2ab954$var$isProcessableValue(value[_i])) string += $89c755cf2d2ab954$var$processStyleName(key) + ":" + $89c755cf2d2ab954$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $89c755cf2d2ab954$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $89c755cf2d2ab954$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $89c755cf2d2ab954$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $89c755cf2d2ab954$var$cursor;
function $89c755cf2d2ab954$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $89c755cf2d2ab954$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $89c755cf2d2ab954$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $89c755cf2d2ab954$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $89c755cf2d2ab954$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $89c755cf2d2ab954$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $iJYTD.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $89c755cf2d2ab954$var$cursor
    };
}

});
parcelRegister("iJYTD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4baab8a9692c10$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $da4baab8a9692c10$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("5HVQT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $427dd826a4f672cc$export$2e2bcd8739ae039; });
var $427dd826a4f672cc$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("aAoqi", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $7b50361bff1fa629$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $7b50361bff1fa629$export$811a713a7276cb9d; });

var $7PdBe = parcelRequire("7PdBe");
var $7b50361bff1fa629$var$isBrowser = typeof document !== "undefined";
var $7b50361bff1fa629$var$syncFallback = function syncFallback(create) {
    return create();
};
var $7b50361bff1fa629$var$useInsertionEffect = $7PdBe.useInsertionEffect ? $7PdBe.useInsertionEffect : false;
var $7b50361bff1fa629$export$db21c7ffa21794e7 = !$7b50361bff1fa629$var$isBrowser ? $7b50361bff1fa629$var$syncFallback : $7b50361bff1fa629$var$useInsertionEffect || $7b50361bff1fa629$var$syncFallback;
var $7b50361bff1fa629$export$811a713a7276cb9d = $7b50361bff1fa629$var$useInsertionEffect || $7PdBe.useLayoutEffect;

});


parcelRegister("kdwYq", function(module, exports) {
function $eb7e996fc8246404$var$_extends() {
    return module.exports = $eb7e996fc8246404$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $eb7e996fc8246404$var$_extends.apply(null, arguments);
}
module.exports = $eb7e996fc8246404$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("geLN1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd23062f0af63fd7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "FormatMinutes", function () { return $bd23062f0af63fd7$export$63cfb4fd6bb06acc; });

var $ig2C7 = parcelRequire("ig2C7");


var $aJxsR = parcelRequire("aJxsR");

var $5tIfX = parcelRequire("5tIfX");

var $gDVAs = parcelRequire("gDVAs");

var $fSXDi = parcelRequire("fSXDi");

var $46jCe = parcelRequire("46jCe");
var $bd23062f0af63fd7$export$2e2bcd8739ae039 = {
    boolean: (value, { fallbackValue: fallbackValue } = {})=>value != null ? (0, $ig2C7.capitalCase)(String(Boolean(value))) : fallbackValue,
    text: (value, { fallbackValue: fallbackValue } = {})=>value ? String(value) : fallbackValue,
    number: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber;
        return isFinite(value) ? (_FormatNumber = (0, $gDVAs.FormatNumber)(value, {
            decimals: decimals
        })) !== null && _FormatNumber !== void 0 ? _FormatNumber : fallbackValue : fallbackValue;
    },
    currency: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatCurrency;
        return isFinite(value) ? (_FormatCurrency = (0, $5tIfX.FormatCurrency)(value, {
            decimals: decimals
        })) !== null && _FormatCurrency !== void 0 ? _FormatCurrency : fallbackValue : fallbackValue;
    },
    percent: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatPercent;
        return isFinite(value) ? (_FormatPercent = (0, $fSXDi.FormatPercent)(value, {
            decimals: decimals
        })) !== null && _FormatPercent !== void 0 ? _FormatPercent : fallbackValue : fallbackValue;
    },
    date: (value, { fallbackValue: fallbackValue } = {})=>value instanceof Date && !isNaN(value) ? (0, $46jCe.FormatDate)(value) : fallbackValue,
    duration: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>value !== null && value !== void 0 && value.value && value !== null && value !== void 0 && value.unit ? `${(0, $gDVAs.FormatNumber)(value.value, {
            decimals: decimals
        })} ${(0, (/*@__PURE__*/$parcel$interopDefault($aJxsR)))(value.unit, (0, $gDVAs.FormatNumber)(value.value, {
            decimals: decimals
        }))}` : fallbackValue,
    progress: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber2;
        return isFinite(value) ? (_FormatNumber2 = (0, $gDVAs.FormatNumber)(value, {
            decimals: 0
        })) !== null && _FormatNumber2 !== void 0 ? _FormatNumber2 : fallbackValue : fallbackValue;
    },
    progressBar: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber3;
        return isFinite(value) ? (_FormatNumber3 = (0, $gDVAs.FormatNumber)(value, {
            decimals: 0
        })) !== null && _FormatNumber3 !== void 0 ? _FormatNumber3 : fallbackValue : fallbackValue;
    },
    project: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref, _value$title;
        return (_ref = (_value$title = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title !== void 0 ? _value$title : fallbackValue) !== null && _ref !== void 0 ? _ref : "";
    },
    phase: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref2, _value$title2;
        return (_ref2 = (_value$title2 = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title2 !== void 0 ? _value$title2 : fallbackValue) !== null && _ref2 !== void 0 ? _ref2 : "";
    },
    task: (value, { fallbackValue: fallbackValue } = {})=>{
        var _value$name;
        return (_value$name = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name !== void 0 ? _value$name : fallbackValue;
    },
    costCentre: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref3, _value$name2;
        return (_ref3 = (_value$name2 = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name2 !== void 0 ? _value$name2 : fallbackValue) !== null && _ref3 !== void 0 ? _ref3 : "";
    },
    contact: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref4, _value$label;
        return (_ref4 = (_value$label = value === null || value === void 0 ? void 0 : value.label) !== null && _value$label !== void 0 ? _value$label : fallbackValue) !== null && _ref4 !== void 0 ? _ref4 : "";
    },
    staff: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref5, _value$fullName;
        return (_ref5 = (_value$fullName = value === null || value === void 0 ? void 0 : value.fullName) !== null && _value$fullName !== void 0 ? _value$fullName : fallbackValue) !== null && _ref5 !== void 0 ? _ref5 : "";
    },
    staffMember: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref6, _value$fullName2;
        return (_ref6 = (_value$fullName2 = value === null || value === void 0 ? void 0 : value.fullName) !== null && _value$fullName2 !== void 0 ? _value$fullName2 : fallbackValue) !== null && _ref6 !== void 0 ? _ref6 : "";
    },
    role: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref7, _value$name3;
        return (_ref7 = (_value$name3 = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name3 !== void 0 ? _value$name3 : fallbackValue) !== null && _ref7 !== void 0 ? _ref7 : "";
    },
    status: (value, { fallbackValue: fallbackValue } = {})=>{
        var _ref8, _ref9;
        return (_ref8 = (_ref9 = value && (0, $ig2C7.capitalCase)(value)) !== null && _ref9 !== void 0 ? _ref9 : fallbackValue) !== null && _ref8 !== void 0 ? _ref8 : "";
    },
    custom: (value, { fallbackValue: fallbackValue } = {})=>value !== null && value !== void 0 ? value : fallbackValue,
    durationMinutes: (value, { fallbackValue: fallbackValue } = {})=>{
        var _FormatMinutes;
        return isFinite(value) ? (_FormatMinutes = $bd23062f0af63fd7$export$63cfb4fd6bb06acc(value)) !== null && _FormatMinutes !== void 0 ? _FormatMinutes : fallbackValue : fallbackValue;
    }
};
function $bd23062f0af63fd7$export$63cfb4fd6bb06acc(totalMinutes) {
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    return hours + ":" + (minutes < 10 ? "0" : "") + minutes;
}

});
parcelRegister("gDVAs", function(module, exports) {

$parcel$export(module.exports, "FormatNumber", function () { return $c1dcf56c2cd7d5fd$export$9ef92266399f225b; });

var $1ldsY = parcelRequire("1ldsY");


var $5bGlM = parcelRequire("5bGlM");

var $5uSSv = parcelRequire("5uSSv");

var $hPhGC = parcelRequire("hPhGC");
const $c1dcf56c2cd7d5fd$export$9ef92266399f225b = (value, { decimals: decimals = 2, compact: compact = false } = {})=>{
    if ([
        null,
        undefined,
        ""
    ].includes(value)) return value;
    const formatter = new (0, $1ldsY.NumberFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($5bGlM))).findCountryLocales((0, $hPhGC.constantCase)(((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) || "us"))[0], {
        style: "decimal",
        maximumFractionDigits: decimals,
        notation: compact ? "compact" : "standard"
    });
    return formatter.format(value);
};

});
parcelRegister("hPhGC", function(module, exports) {

$parcel$export(module.exports, "constantCase", function () { return $cfa4eb40eb10cd14$export$f44cdeb23aa06bbd; });

var $3ETLe = parcelRequire("3ETLe");

var $cUZWo = parcelRequire("cUZWo");

var $42FMO = parcelRequire("42FMO");
function $cfa4eb40eb10cd14$export$f44cdeb23aa06bbd(input, options) {
    if (options === void 0) options = {};
    return (0, $cUZWo.noCase)(input, (0, $3ETLe.__assign)({
        delimiter: "_",
        transform: (0, $42FMO.upperCase)
    }, options));
}

});
parcelRegister("42FMO", function(module, exports) {

$parcel$export(module.exports, "upperCase", function () { return $2f17c33accd4e6b5$export$5b4b56d38b0b3c58; });
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $2f17c33accd4e6b5$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    az: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    lt: {
        regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
        map: {
            i\u0307: "I",
            j\u0307: "J",
            \u012F\u0307: "\u012E",
            i\u0307\u0300: "\xcc",
            i\u0307\u0301: "\xcd",
            i\u0307\u0303: "\u0128"
        }
    }
};
function $2f17c33accd4e6b5$export$41a02e171a5184fc(str, locale) {
    var lang = $2f17c33accd4e6b5$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $2f17c33accd4e6b5$export$5b4b56d38b0b3c58(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $2f17c33accd4e6b5$export$5b4b56d38b0b3c58(str);
}
function $2f17c33accd4e6b5$export$5b4b56d38b0b3c58(str) {
    return str.toUpperCase();
}

});



parcelRegister("fSXDi", function(module, exports) {

$parcel$export(module.exports, "FormatPercent", function () { return $b90a28012034753b$export$a733555cebd89e96; });

var $1ldsY = parcelRequire("1ldsY");


var $5bGlM = parcelRequire("5bGlM");

var $5uSSv = parcelRequire("5uSSv");

var $hPhGC = parcelRequire("hPhGC");
const $b90a28012034753b$export$a733555cebd89e96 = (value, { decimals: decimals = 2 } = {})=>{
    const formatter = new (0, $1ldsY.NumberFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($5bGlM))).findCountryLocales((0, $hPhGC.constantCase)(((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) || "us"))[0], {
        style: "percent",
        maximumFractionDigits: decimals
    });
    return formatter.format(value);
};

});

parcelRegister("46jCe", function(module, exports) {

$parcel$export(module.exports, "FormatDate", function () { return $2fc6f035b3ef2470$export$68962dbd27cd2e36; });

var $2orio = parcelRequire("2orio");


var $5bGlM = parcelRequire("5bGlM");

var $5uSSv = parcelRequire("5uSSv");

var $hPhGC = parcelRequire("hPhGC");
const $2fc6f035b3ef2470$export$68962dbd27cd2e36 = (value, options = {
    year: "numeric",
    month: "short",
    day: "2-digit"
})=>{
    const formatter = new (0, $2orio.DateFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($5bGlM))).findCountryLocales((0, $hPhGC.constantCase)(((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) || "us"))[0], options);
    return formatter.format(value);
};

});
parcelRegister("2orio", function(module, exports) {

$parcel$export(module.exports, "DateFormatter", function () { return $1be2ff062abd82d2$export$ad991b66133851cf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$formatterCache = new Map();
class $1be2ff062abd82d2$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === "function") return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === "function") return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($1be2ff062abd82d2$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {}
};
function $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        let defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($1be2ff062abd82d2$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($1be2ff062abd82d2$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($1be2ff062abd82d2$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    let formatter = $1be2ff062abd82d2$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === "hour").value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === "hour").value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}

});



parcelRegister("61cVC", function(module, exports) {

$parcel$export(module.exports, "qf", function () { return $461cdd64a7bfc080$export$d4dbd713fa707644; });

var $egx7S = parcelRequire("egx7S");
function $461cdd64a7bfc080$export$d4dbd713fa707644(value) {
    if (typeof value === "number") return String(value);
    if (value instanceof Date) return `'${(0, $egx7S.formatISO)(value, {
        representation: "date"
    })}'`;
    if (typeof value === "boolean") return value ? "true" : "false";
    if (typeof value === "string") return `"${value}"`;
    if (Array.isArray(value)) return `[${value.map((v)=>$461cdd64a7bfc080$export$d4dbd713fa707644(v)).join(",")}]`;
    if (value === null || value === undefined) return "null";
    return null;
}
function $461cdd64a7bfc080$export$599928430721e45a(field) {
    return `(${field} != null ? ${field} : 0)`;
}
function $461cdd64a7bfc080$export$ae563cffb2e58965(value, modelName) {
    modelName = modelName ? `${modelName}.` : "";
    return `${modelName}id == ${$461cdd64a7bfc080$export$d4dbd713fa707644(Number(value))}`;
}

});

parcelRegister("byiQX", function(module, exports) {

$parcel$export(module.exports, "queryFilters", function () { return $86917e8d7b124c7e$export$a99de19ba7bfbeeb; });

var $lsKv3 = parcelRequire("lsKv3");

var $61cVC = parcelRequire("61cVC");
const $86917e8d7b124c7e$export$a99de19ba7bfbeeb = {
    boolean: {
        "=": (column, value)=>value ? [
                `${column} == (${value})`
            ] : null,
        "!=": (column, value)=>value ? [
                `${column} != (${value})`
            ] : null
    },
    text: {
        "=": (column, value)=>[
                `${column} == "${value || ""}"`
            ],
        "!=": (column, value)=>[
                `${column} != "${value || ""}"`
            ],
        contains: (column, value)=>value ? [
                `contains(${column}, "%${value}%")`
            ] : [],
        "!contains": (column, value)=>value ? [
                `not(contains(${column}, "%${value}%"))`
            ] : [],
        starts: (column, value)=>value ? [
                `contains(jobNumber, "${value}%")`
            ] : [],
        "!starts": (column, value)=>value ? [
                `not(contains(jobNumber, "${value}%"))`
            ] : [],
        ends: (column, value)=>value ? [
                `contains(jobNumber, "%${value}")`
            ] : [],
        "!ends": (column, value)=>value ? [
                `not(contains(jobNumber, "%${value}"))`
            ] : [],
        in: (column, value)=>value ? [
                `${column} in ${(0, $61cVC.qf)(value)}`
            ] : [],
        "!in": (column, value)=>value ? [
                `not(${column} in ${(0, $61cVC.qf)(value)})`
            ] : []
    },
    number: {
        "=": (column, value)=>[
                `${column} == (${value || 0})`
            ],
        "!=": (column, value)=>[
                `${column} != (${value || 0})`
            ],
        ">": (column, value)=>[
                `${column} > (${value || 0})`
            ],
        ">=": (column, value)=>[
                `${column} >= (${value || 0})`
            ],
        "<": (column, value)=>[
                `${column} < (${value || 0})`
            ],
        "<=": (column, value)=>[
                `${column} <= (${value || 0})`
            ],
        between: (column, value)=>value ? [
                `${column} > (${value[0]}) and ${column} < (${value[1]})`
            ] : [],
        "!between": (column, value)=>value ? [
                `not(${column} > (${value[0]}) and ${column} < (${value[1]}))`
            ] : [],
        in: (column, value)=>value ? [
                `${column} in ${(0, $61cVC.qf)(value)}`
            ] : [],
        "!in": (column, value)=>value ? [
                `not(${column} in ${(0, $61cVC.qf)(value)})`
            ] : []
    },
    date: {
        "=": (column, value)=>value ? [
                `${column} == ${(0, $61cVC.qf)(value)}`
            ] : [],
        "!=": (column, value)=>value ? [
                `${column} != ${(0, $61cVC.qf)(value)}`
            ] : [],
        ">": (column, value)=>value ? [
                `${column} > ${(0, $61cVC.qf)(value)}`
            ] : [],
        ">=": (column, value)=>value ? [
                `${column} >= ${(0, $61cVC.qf)(value)}`
            ] : [],
        "<": (column, value)=>value ? [
                `${column} < ${(0, $61cVC.qf)(value)}`
            ] : [],
        "<=": (column, value)=>value ? [
                `${column} <= ${(0, $61cVC.qf)(value)}`
            ] : [],
        between: (column, value)=>{
            var _dateStringLookup$val;
            value = ((_dateStringLookup$val = (0, $lsKv3.dateStringLookup)[value]) === null || _dateStringLookup$val === void 0 ? void 0 : _dateStringLookup$val.call((0, $lsKv3.dateStringLookup))) || value;
            return value ? [
                `${column} > ${(0, $61cVC.qf)(value[0])} and ${column} < ${(0, $61cVC.qf)(value[1])}`
            ] : [];
        },
        "!between": (column, value)=>{
            var _dateStringLookup$val2;
            value = ((_dateStringLookup$val2 = (0, $lsKv3.dateStringLookup)[value]) === null || _dateStringLookup$val2 === void 0 ? void 0 : _dateStringLookup$val2.call((0, $lsKv3.dateStringLookup))) || value;
            return value ? [
                `not(${column} > ${(0, $61cVC.qf)(value[0])} and ${column} < ${(0, $61cVC.qf)(value[1])})`
            ] : [];
        }
    },
    singleId: {
        "=": (column, value)=>[
                `${column} == ${(0, $61cVC.qf)(value)}`
            ],
        "!=": (column, value)=>[
                `${column} != ${(0, $61cVC.qf)(value)}`
            ],
        in: (column, value)=>value !== null && value !== void 0 && value.length ? [
                `${column} in ${(0, $61cVC.qf)(value)}`
            ] : [],
        "!in": (column, value)=>value !== null && value !== void 0 && value.length ? [
                `not(${column} in ${(0, $61cVC.qf)(value)})`
            ] : []
    },
    manyIds: {
        in: (column, value)=>value !== null && value !== void 0 && value.length ? [
                value.map((v)=>[
                        `${v} in ${column}`
                    ]).join(" or ")
            ] : [],
        "!in": (column, value)=>value !== null && value !== void 0 && value.length ? [
                value.map((v)=>[
                        `not(${v} in ${column}})`
                    ]).join(" and ")
            ] : []
    }
};

});

parcelRegister("4iD0l", function(module, exports) {

$parcel$export(module.exports, "canViewStaffAllocations", function () { return $32171960e79fb10a$export$69f4631efc1ce0fb; });
$parcel$export(module.exports, "canViewRevenueTargets", function () { return $32171960e79fb10a$export$5e89d543db4cb3c5; });
$parcel$export(module.exports, "canViewProjectInvoices", function () { return $32171960e79fb10a$export$8f145ea2aacc93bf; });
$parcel$export(module.exports, "canViewProjectExpenses", function () { return $32171960e79fb10a$export$9c6c3596a649013; });
$parcel$export(module.exports, "canViewProjectNotes", function () { return $32171960e79fb10a$export$f207a5f01ef17f14; });
$parcel$export(module.exports, "canViewProjectDates", function () { return $32171960e79fb10a$export$bd20d6788db57eed; });
$parcel$export(module.exports, "canViewStaffPayRate", function () { return $32171960e79fb10a$export$5727cd4b0ac96bb; });
$parcel$export(module.exports, "canViewStaffOvertimeRate", function () { return $32171960e79fb10a$export$36053682c9f8417f; });
$parcel$export(module.exports, "canViewStaffCostRate", function () { return $32171960e79fb10a$export$882b0cfdd762e78f; });
$parcel$export(module.exports, "canViewStaffChargeOutRate", function () { return $32171960e79fb10a$export$847c46638ce2c07a; });
$parcel$export(module.exports, "canViewProjectFees", function () { return $32171960e79fb10a$export$5fe03513be1856a7; });
$parcel$export(module.exports, "canViewProjectExpenseBudgets", function () { return $32171960e79fb10a$export$46f00131111270ab; });
$parcel$export(module.exports, "canViewProjectStaffCost", function () { return $32171960e79fb10a$export$a057c023c394fd31; });
$parcel$export(module.exports, "canViewProjectStaffPay", function () { return $32171960e79fb10a$export$de83c01b76125c5d; });
$parcel$export(module.exports, "canViewProjectStaffChargeOut", function () { return $32171960e79fb10a$export$60230a5d360a4fdb; });
$parcel$export(module.exports, "canViewCostCentres", function () { return $32171960e79fb10a$export$9ffec46adf74da80; });
$parcel$export(module.exports, "canViewContacts", function () { return $32171960e79fb10a$export$b816aa6ca12c6e7b; });
$parcel$export(module.exports, "canViewBilling", function () { return $32171960e79fb10a$export$bc10a6113304fa74; });
$parcel$export(module.exports, "canViewRoles", function () { return $32171960e79fb10a$export$2f6dbf1f3b950bea; });
$parcel$export(module.exports, "canViewSettings", function () { return $32171960e79fb10a$export$b5ae555d76db988c; });
$parcel$export(module.exports, "canEnterTimeAgainstProject", function () { return $32171960e79fb10a$export$2d7ec97db174a3c7; });
$parcel$export(module.exports, "canEnterTimeAgainstPhase", function () { return $32171960e79fb10a$export$fc41a823d5177566; });
$parcel$export(module.exports, "canSeeSalaries", function () { return $32171960e79fb10a$export$f348984146c42cee; });
$parcel$export(module.exports, "canSeeOperationalExpenses", function () { return $32171960e79fb10a$export$a6beca1da1575bb4; });
$parcel$export(module.exports, "canViewFlexiRemote", function () { return $32171960e79fb10a$export$34db19be291d02b4; });
$parcel$export(module.exports, "getDefaultTasks", function () { return $32171960e79fb10a$export$e7c4ca5af7e08d26; });
$parcel$export(module.exports, "canViewPrimaryContact", function () { return $32171960e79fb10a$export$7e8ab8886625eb0e; });


var $7bpHx = parcelRequire("7bpHx");

var $61cVC = parcelRequire("61cVC");

var $5uSSv = parcelRequire("5uSSv");

var $kdO1A = parcelRequire("kdO1A");

var $5NCwu = parcelRequire("5NCwu");

var $cjCbh = parcelRequire("cjCbh");
parcelRequire("f9Rb7");
const $32171960e79fb10a$export$b325ec6732b039cf = (staff, permissions = {}, options = {
    anyProject: false
})=>{
    const staffPermissions = (staff === null || staff === void 0 ? void 0 : staff.permissions) || {};
    for(const key in permissions){
        const value = permissions[key];
        if (key.includes("project")) {
            const projectPermissions = staffPermissions.projects || [
                {
                    filter: {
                        type: "all"
                    },
                    permissions: {}
                }
            ];
            const projectIdPermissions = projectPermissions.filter((p)=>p.filter.type === "project");
            const projectOwnerPermissions = projectPermissions.filter((p)=>p.filter.type === "owner");
            const costCentreIdPermissions = projectPermissions.filter((p)=>p.filter.type === "costCentre");
            const allProjectsPermissions = projectPermissions.filter((p)=>p.filter.type === "all");
            let projectPermissionFound = null;
            // First check if we have a matching permission for a specific project
            for (const projPermission of projectIdPermissions)if (options.anyProject || projPermission.filter.values.includes(options.projectId)) {
                if (typeof value === "boolean" ? (projPermission.permissions[key] || false) === value : (0, $7bpHx.permissionLevels).indexOf(projPermission.permissions[key] || "hidden") >= (0, $7bpHx.permissionLevels).indexOf(value)) {
                    projectPermissionFound = true;
                    break;
                } else if (!options.anyProject) {
                    projectPermissionFound = false;
                    break;
                }
            }
            // If we didn't find a matching permission for a specific project, check if we have a matching permission for a project owner
            if (projectPermissionFound === null) {
                for (const projPermission of projectOwnerPermissions)if (options.anyProject || options.ownerId === staff.id) {
                    if (typeof value === "boolean" ? (projPermission.permissions[key] || false) === value : (0, $7bpHx.permissionLevels).indexOf(projPermission.permissions[key] || "hidden") >= (0, $7bpHx.permissionLevels).indexOf(value)) {
                        projectPermissionFound = true;
                        break;
                    } else if (!options.anyProject) {
                        projectPermissionFound = false;
                        break;
                    }
                }
            }
            // If we didn't find a matching permission for a project owner, check if we have a matching permission for a cost centre
            if (projectPermissionFound === null) {
                for (const projPermission of costCentreIdPermissions)if (options.anyProject || projPermission.filter.values.includes(options.costCentreId)) {
                    if (typeof value === "boolean" ? (projPermission.permissions[key] || false) === value : (0, $7bpHx.permissionLevels).indexOf(projPermission.permissions[key] || "hidden") >= (0, $7bpHx.permissionLevels).indexOf(value)) {
                        projectPermissionFound = true;
                        break;
                    } else if (!options.anyProject) {
                        projectPermissionFound = false;
                        break;
                    }
                }
            }
            // If we didn't find a matching permission for a cost centre, check if we have a matching permission for any project
            if (projectPermissionFound === null) {
                for (const projPermission of allProjectsPermissions)if (typeof value === "boolean" ? (projPermission.permissions[key] || false) === value : (0, $7bpHx.permissionLevels).indexOf(projPermission.permissions[key] || "hidden") >= (0, $7bpHx.permissionLevels).indexOf(value)) {
                    projectPermissionFound = true;
                    break;
                }
            }
            // If we didn't find a matching permission for a project, return false
            if (!projectPermissionFound) return false;
        } else if (typeof value === "boolean") {
            if ((staffPermissions[key] || false) !== value) return false;
        } else if (typeof value === "string") {
            if ((0, $7bpHx.permissionLevels).indexOf(staffPermissions[key] || "hidden") < (0, $7bpHx.permissionLevels).indexOf(value)) return false;
        } else return false;
    }
    return true;
};
const $32171960e79fb10a$export$d35c4215f2c4d736 = (staff, project, permissions)=>{
    if (!permissions.projectPermissions && Object.keys(permissions).some((key)=>key !== "projectTimesheets")) permissions.projectPermissions = "view";
    if (project) return $32171960e79fb10a$export$b325ec6732b039cf(staff, permissions, {
        projectId: project.id,
        costCentreId: project.costCentreId,
        ownerId: project.ownerId
    });
    else return $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, permissions);
};
const $32171960e79fb10a$export$7ddc7bfb8586ceeb = (staff, permissions)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, permissions, {
        anyProject: true
    });
};
const $32171960e79fb10a$export$6f77fbdf0d049e52 = (staff)=>{
    return (staff === null || staff === void 0 ? void 0 : staff.email) === "ryan@coincraft.co";
};
const $32171960e79fb10a$export$a7cfc0d056598f1a = (staff, routeId, params = {})=>{
    let project;
    switch(routeId){
        case "revenueForecast":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                canViewRevenueForecast: true
            });
        case "resourceSchedule":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                canViewResourceSchedule: true
            });
        case "weeklyPlanning":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                canViewWeeklyPlanner: true
            }) && $32171960e79fb10a$export$9f63c899c144898f(staff);
        case "projectList":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectPermissions: "view"
            });
        case "createProject":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectPermissions: "admin"
            });
        case "project":
            project = (0, $kdO1A.default).projectsById[params.id];
            if (project) return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$cc02642ec7a15a0f(staff, project);
            else return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectPermissions: "view"
            });
        case "project-details":
            project = (0, $kdO1A.default).projectsById[params.id];
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$cc02642ec7a15a0f(staff, project);
        case "project-forecasts":
            project = (0, $kdO1A.default).projectsById[params.id];
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && ($32171960e79fb10a$export$69f4631efc1ce0fb(staff, project) || $32171960e79fb10a$export$5e89d543db4cb3c5(staff, project));
        case "project-tasks":
            project = (0, $kdO1A.default).projectsById[params.id];
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$e261a1ab88e099a0(staff, project);
        case "project-changelog":
            project = (0, $kdO1A.default).projectsById[params.id];
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && ($32171960e79fb10a$export$8f145ea2aacc93bf(staff, project) || $32171960e79fb10a$export$9c6c3596a649013(staff, project));
        case "project-rates":
            project = (0, $kdO1A.default).projectsById[params.id];
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$5717ab0d892ffe61(staff, project);
        case "project-notes":
            project = (0, $kdO1A.default).projectsById[params.id];
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$f207a5f01ef17f14(staff, project);
        case "project-history":
            project = (0, $kdO1A.default).projectsById[params.id];
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$19b300001556ce8d(staff, project);
        case "project-status":
            project = (0, $kdO1A.default).projectsById[params.id];
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$bd20d6788db57eed(staff, project);
        case "staffList":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                staffPermissions: "view"
            });
        case "staff":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                staffPermissions: "view"
            });
        case "staff-details":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$35823a773372cb18(staff);
        case "staff-rates":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && ($32171960e79fb10a$export$5727cd4b0ac96bb(staff) || $32171960e79fb10a$export$36053682c9f8417f(staff) || $32171960e79fb10a$export$882b0cfdd762e78f(staff) || $32171960e79fb10a$export$847c46638ce2c07a(staff));
        case "staff-permissions":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                staffPermissions: "admin"
            });
        case "staffRoleList":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                rolePermissions: "view"
            });
        case "staffRole":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                rolePermissions: "view"
            });
        case "createStaff":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                staffPermissions: "admin"
            });
        case "invoiceList":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "view"
            });
        case "invoicePdf":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "view"
            });
        case "invoice":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "view"
            });
        case "invoiceTemplates":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "admin"
            });
        case "invoiceSettings":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                invoiceSettings: "edit"
            });
        case "createInvoice":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "admin"
            });
        case "timesheets":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectTimesheets: true
            });
        case "timesheets-daily":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff();
        case "timesheets-weekly":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff();
        case "timesheetCalendar":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectTimesheets: true
            });
        case "timesheetReports":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectTimesheets: true
            });
        case "overheadExpenses":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                operationalExpenses: "edit"
            });
        case "costCentres":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                costCentres: "edit"
            });
        case "organisationHolidays":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                holidays: "edit"
            });
        case "contacts":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                contacts: "view"
            });
        case "contact":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                contacts: "view"
            });
        case "settings":
            return !$32171960e79fb10a$export$571b4d93ee7e01ff() && $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                organisationSettings: "edit"
            });
        case "trackExpenses":
            return $32171960e79fb10a$export$f911643f217cf522();
        case "expenseReports":
            return $32171960e79fb10a$export$f911643f217cf522();
        case "suppliers":
            return $32171960e79fb10a$export$f911643f217cf522();
        case "login":
            return true;
        case "register":
            return true;
        case "registerDetails":
            return true;
        case "invite":
            return true;
        case "activateAccount":
            return true;
        case "forgottenPassword":
            return true;
        case "resetPassword":
            return true;
        case "accountingAuth":
            return true;
        case "billing":
            return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                billing: "edit"
            });
        case "impersonate":
            return $32171960e79fb10a$export$6f77fbdf0d049e52(staff);
        case "migrate":
            return true;
        case "feedbackAuth":
            return true;
        default:
            return false;
    }
};
const $32171960e79fb10a$export$5e89d543db4cb3c5 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectForecastedRevenue: "view"
    });
};
const $32171960e79fb10a$export$c38e22253b6bdfca = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectForecastedRevenue: "edit"
    });
};
const $32171960e79fb10a$export$69f4631efc1ce0fb = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectForecastedHours: "view"
    });
};
const $32171960e79fb10a$export$9f63c899c144898f = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectForecastedHours: "edit"
    });
};
const $32171960e79fb10a$export$cc02642ec7a15a0f = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectPermissions: "view"
    });
};
const $32171960e79fb10a$export$d4bf0e1fad882bfb = (staff)=>{
    return $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
        projectPermissions: "admin"
    });
};
const $32171960e79fb10a$export$1097df0e51697619 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectPermissions: "admin"
    });
};
const $32171960e79fb10a$export$19b300001556ce8d = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectPermissions: "edit"
    });
};
const $32171960e79fb10a$export$bd20d6788db57eed = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectDates: "view"
    });
};
const $32171960e79fb10a$export$f4f8e93cd5b4a159 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectDates: "edit"
    });
};
const $32171960e79fb10a$export$5fe03513be1856a7 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectFees: "view"
    });
};
const $32171960e79fb10a$export$39d988ece7dc9a7d = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectFees: "edit"
    });
};
const $32171960e79fb10a$export$46f00131111270ab = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectExpenseBudgets: "view"
    });
};
const $32171960e79fb10a$export$6ce3923959b7bb56 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectExpenseBudgets: "edit"
    });
};
const $32171960e79fb10a$export$b658ba1314280429 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectHoursBudgets: "edit"
    });
};
const $32171960e79fb10a$export$8f145ea2aacc93bf = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectInvoices: "view"
    });
};
const $32171960e79fb10a$export$b1b0b4bc6fec8224 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectInvoices: "edit"
    });
};
const $32171960e79fb10a$export$1b40dcd5759fa411 = (staff)=>{
    return $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
        projectInvoices: "admin"
    });
};
const $32171960e79fb10a$export$43d2d38a5f43dbc = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectInvoices: "admin"
    });
};
const $32171960e79fb10a$export$7bb6d9646f4fd295 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectPhasesTasks: "admin"
    });
};
const $32171960e79fb10a$export$e261a1ab88e099a0 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectPhasesTasks: "view"
    });
};
const $32171960e79fb10a$export$a057c023c394fd31 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectExpenses: "view"
    }) && $32171960e79fb10a$export$882b0cfdd762e78f(staff);
};
const $32171960e79fb10a$export$de83c01b76125c5d = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectExpenses: "view"
    }) && $32171960e79fb10a$export$5727cd4b0ac96bb(staff);
};
const $32171960e79fb10a$export$9c6c3596a649013 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectExpenses: "view"
    });
};
const $32171960e79fb10a$export$a42562e3b1090135 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectExpenses: "edit"
    });
};
const $32171960e79fb10a$export$60230a5d360a4fdb = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectFees: "view"
    }) && $32171960e79fb10a$export$847c46638ce2c07a(staff);
};
const $32171960e79fb10a$export$73d683bc2e914dd = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        editStaffTime: true
    });
};
const $32171960e79fb10a$export$9ffec46adf74da80 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        costCentres: "view"
    });
};
const $32171960e79fb10a$export$4cecdb0b0a83c076 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        costCentres: "edit"
    });
};
const $32171960e79fb10a$export$b816aa6ca12c6e7b = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        contacts: "view"
    });
};
const $32171960e79fb10a$export$886cadb798aad341 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        contacts: "edit"
    });
};
const $32171960e79fb10a$export$f207a5f01ef17f14 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectNotes: "view"
    });
};
const $32171960e79fb10a$export$ae297a467f99d59 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectNotes: "edit"
    });
};
const $32171960e79fb10a$export$194284b4117aee2 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectStaffBudgets: "view"
    });
};
const $32171960e79fb10a$export$f51d1fe47ad4aa30 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectStaffBudgets: "edit"
    });
};
const $32171960e79fb10a$export$5727cd4b0ac96bb = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        payRate: "view"
    });
};
const $32171960e79fb10a$export$36053682c9f8417f = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        overtimeRate: "view"
    });
};
const $32171960e79fb10a$export$882b0cfdd762e78f = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        costRate: "view"
    });
};
const $32171960e79fb10a$export$847c46638ce2c07a = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        chargeOutRate: "view"
    });
};
const $32171960e79fb10a$export$ed6bb8a5e2dde9b9 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        payRate: "edit"
    });
};
const $32171960e79fb10a$export$ae91a06e096f1c10 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        overtimeRate: "edit"
    });
};
const $32171960e79fb10a$export$2b0aa2266a0f8f25 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        costRate: "edit"
    });
};
const $32171960e79fb10a$export$c691d75d00a24f08 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        chargeOutRate: "edit"
    });
};
const $32171960e79fb10a$export$5717ab0d892ffe61 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectRates: "view"
    });
};
const $32171960e79fb10a$export$e70f89ed763983b4 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectRates: "edit"
    });
};
const $32171960e79fb10a$export$bc10a6113304fa74 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        billing: "edit"
    });
};
const $32171960e79fb10a$export$35823a773372cb18 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        staffPermissions: "view"
    });
};
const $32171960e79fb10a$export$848edbb71a33d6c2 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        staffPermissions: "edit"
    });
};
const $32171960e79fb10a$export$cecf2bb38f56c7a4 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        staffPermissions: "admin"
    });
};
const $32171960e79fb10a$export$f20eb6b6dac3a588 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        staffPermissions: "admin"
    });
};
const $32171960e79fb10a$export$2f6dbf1f3b950bea = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        rolePermissions: "view"
    });
};
const $32171960e79fb10a$export$a1b94807289cedb8 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        rolePermissions: "edit"
    });
};
const $32171960e79fb10a$export$d1e0f83b12dad567 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        rolePermissions: "admin"
    });
};
const $32171960e79fb10a$export$e99a38b330e9c059 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        rolePermissions: "admin"
    });
};
const $32171960e79fb10a$export$b5ae555d76db988c = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        organisationSettings: "view"
    });
};
const $32171960e79fb10a$export$b65bc3aa18e9a466 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        invoiceSettings: "view"
    });
};
const $32171960e79fb10a$export$fc71573f563e2f1 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        invoiceSettings: "edit"
    });
};
const $32171960e79fb10a$export$2d7ec97db174a3c7 = (staff, project)=>{
    return $32171960e79fb10a$export$d35c4215f2c4d736(staff, project, {
        projectTimesheets: true
    }) && $32171960e79fb10a$export$fc41a823d5177566(staff, project);
};
const $32171960e79fb10a$export$99ebb2f31597d0f8 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        operationalExpenses: "view"
    });
};
const $32171960e79fb10a$export$7c52463c7a2b7d32 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        operationalExpenses: "edit"
    });
};
const $32171960e79fb10a$export$1642bc81c5636cc = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        holidays: "view"
    });
};
const $32171960e79fb10a$export$9b42e1ed207bfe25 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        holidays: "edit"
    });
};
const $32171960e79fb10a$export$e254e84d1c0876a0 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        canViewRevenueForecast: true
    });
};
const $32171960e79fb10a$export$219bf7e74cf65303 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        canViewStaffExpenses: true
    });
};
const $32171960e79fb10a$export$afe4fe727220541a = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        canViewOperationalExpenses: true
    });
};
const $32171960e79fb10a$export$8696db803b573170 = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        canViewResourceSchedule: true
    });
};
const $32171960e79fb10a$export$fea69f48c361f13f = (staff)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        canViewWeeklyPlanner: true
    });
};
const $32171960e79fb10a$export$fa54d6a70ae90fb7 = (collection, staff, strict = false)=>{
    switch(collection){
        case "budgetedHours":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "changeLogItems":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectInvoices: "view"
            }, "project.");
        case "contacts":
            return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                contacts: "view"
            }) ? [] : [
                `id in ${(0, $61cVC.qf)([])}`
            ];
        case "costCentres":
            return [];
        case "dailyAllocations":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, strict ? {
                projectStaffBudgets: "view",
                projectForecastedHours: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "allocations":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "invoices":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectInvoices: "view"
            }, "project.");
        case "invoiceDescriptionTemplates":
            return $32171960e79fb10a$export$7ddc7bfb8586ceeb(staff, {
                projectInvoices: "view"
            }) ? [] : [
                `id in ${(0, $61cVC.qf)([])}`
            ];
        case "invoiceLineItems":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectInvoices: "view"
            }, "project.");
        case "organisation":
            return [];
        case "organisationHolidays":
            return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                holidays: "view"
            }) ? [] : [
                `id in ${(0, $61cVC.qf)([])}`
            ];
        case "organisationSubscriptions":
            return [];
        case "overheadExpenses":
            return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                operationalExpenses: "view"
            }) ? [] : [
                `id in ${(0, $61cVC.qf)([])}`
            ];
        case "phases":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "projects":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            });
        case "projectExpenseAllocations":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectExpenses: "view"
            }, "project.");
        case "projectExpenses":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectExpenses: "view"
            }, "project.");
        case "projectNotes":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectNotes: "view"
            }, "project.");
        case "projectRates":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectRates: "view"
            }, "project.");
        case "reports":
            return [];
        case "resourceScheduleReports":
            return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                canViewResourceSchedule: true
            }) ? [] : [
                `id in ${(0, $61cVC.qf)([])}`
            ];
        case "revenueForecastReports":
            return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                canViewRevenueForecast: true
            }) ? [] : [
                `id in ${(0, $61cVC.qf)([])}`
            ];
        case "revenueTargets":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectPermissions: "view",
                projectForecastedRevenue: "view"
            }, "project.");
        case "roles":
            return [];
        case "roleRates":
            return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                payRate: "view"
            }) || $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                overtimeRate: "view"
            }) || $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                costRate: "view"
            }) || $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                chargeOutRate: "view"
            }) ? [] : [
                `id in ${(0, $61cVC.qf)([])}`
            ];
        case "staff":
            return [];
        case "staffRates":
            return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                payRate: "view"
            }) || $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                overtimeRate: "view"
            }) || $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                costRate: "view"
            }) || $32171960e79fb10a$export$b325ec6732b039cf(staff, {
                chargeOutRate: "view"
            }) ? [] : [
                `id in ${(0, $61cVC.qf)([])}`
            ];
        case "tasks":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, strict ? {
                projectPermissions: "view"
            } : {
                projectTimesheets: true
            }, "project.");
        case "timeEntries":
            return [
                ...$32171960e79fb10a$export$cea5882ee84b1ee7(staff, // strict
                //     ? { projectPermissions: 'view' }
                {
                    projectTimesheets: true
                }, "project.", {
                    projectHoursBudgets: "view"
                }),
                ...strict && !$32171960e79fb10a$export$194284b4117aee2(staff) ? [
                    `staffId == ${(0, $61cVC.qf)(staff.id)}`
                ] : []
            ];
        case "revenueRows":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectForecastedRevenue: "view",
                projectInvoices: "view"
            }, "project.");
        case "monthlyRevenueCells":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectForecastedRevenue: "view",
                projectInvoices: "view"
            }, "project.");
        case "resourceRows":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectStaffBudgets: "view",
                projectForecastedHours: "view"
            }, "project.");
        case "monthlyResourceCells":
            return $32171960e79fb10a$export$cea5882ee84b1ee7(staff, {
                projectStaffBudgets: "view",
                projectForecastedHours: "view"
            }, "project.");
        default:
            return [];
    }
};
const $32171960e79fb10a$export$cea5882ee84b1ee7 = (staff, permissions = {
    projectPermissions: "view"
}, prefix = "", staffPermissions = null)=>{
    const viewAllProjects = $32171960e79fb10a$export$b325ec6732b039cf(staff, permissions);
    const viewCostCentreIdsSelf = [];
    const viewCostCentreIdsOtherStaff = [];
    const hiddenCostCentreIds = [];
    const viewProjectIdsSelf = [];
    const viewProjectIdsOtherStaff = [];
    const hiddenProjectIds = [];
    staff.permissions.projects.forEach((p)=>{
        if (p.filter.type === "costCentre") {
            if (Object.entries(permissions).every(([key, value])=>p.permissions[key] === value || (0, $7bpHx.permissionLevels).indexOf(p.permissions[key]) >= (0, $7bpHx.permissionLevels).indexOf(value))) {
                if (!staffPermissions || Object.entries(staffPermissions).every(([key, value])=>p.permissions[key] === value || (0, $7bpHx.permissionLevels).indexOf(p.permissions[key]) >= (0, $7bpHx.permissionLevels).indexOf(value))) viewCostCentreIdsOtherStaff.push(...p.filter.values);
                else viewCostCentreIdsSelf.push(...p.filter.values);
            } else hiddenCostCentreIds.push(...p.filter.values);
        } else if (p.filter.type === "project") {
            if (Object.entries(permissions).every(([key, value])=>p.permissions[key] === value || (0, $7bpHx.permissionLevels).indexOf(p.permissions[key]) >= (0, $7bpHx.permissionLevels).indexOf(value))) {
                if (!staffPermissions || Object.entries(staffPermissions).every(([key, value])=>p.permissions[key] === value || (0, $7bpHx.permissionLevels).indexOf(p.permissions[key]) >= (0, $7bpHx.permissionLevels).indexOf(value))) viewProjectIdsOtherStaff.push(...p.filter.values);
                else viewProjectIdsSelf.push(...p.filter.values);
            } else hiddenProjectIds.push(...p.filter.values);
        }
    });
    let filters = [];
    if (viewAllProjects) {
        // Basic case: Exclude hidden projects
        if (hiddenProjectIds.length) filters.push(`not(${prefix}id in (${(0, $61cVC.qf)(hiddenProjectIds)}))`);
        // More complex case: Exclude hidden cost centres, but include any explicit project IDs
        if (hiddenCostCentreIds.length) {
            if (viewProjectIdsOtherStaff.length) filters.push(`(not(${prefix}costCentreId in (${(0, $61cVC.qf)(hiddenCostCentreIds)})) or ${prefix}id in (${(0, $61cVC.qf)(viewProjectIdsOtherStaff)}))`);
            else if (viewProjectIdsSelf.length) filters.push(`(not(${prefix}costCentreId in (${(0, $61cVC.qf)(hiddenCostCentreIds)})) or (${prefix}id in (${(0, $61cVC.qf)(viewProjectIdsOtherStaff)}) and staffId == ${(0, $61cVC.qf)(staff.id)})`);
            else filters.push(`not(${prefix}costCentreId in (${(0, $61cVC.qf)(hiddenCostCentreIds)}))`);
        } else if (viewProjectIdsOtherStaff.length && filters.length) filters.push(`${prefix}id in (${(0, $61cVC.qf)(viewProjectIdsOtherStaff)})`);
        else if (viewProjectIdsSelf.length && filters.length) filters.push(`(${prefix}id in (${(0, $61cVC.qf)(viewProjectIdsSelf)}) and staffId == ${(0, $61cVC.qf)(staff.id)})`);
    } else if (viewCostCentreIdsSelf.length || viewCostCentreIdsOtherStaff.length || viewProjectIdsSelf.length || viewProjectIdsOtherStaff.length) {
        // Only include projects/cost centres explicitly allowed
        const explicitViewFilters = [];
        if (viewCostCentreIdsOtherStaff.length) explicitViewFilters.push(`${prefix}costCentreId IN (${(0, $61cVC.qf)(viewCostCentreIdsOtherStaff)})`);
        if (viewProjectIdsOtherStaff.length) explicitViewFilters.push(`${prefix}id IN (${(0, $61cVC.qf)(viewProjectIdsOtherStaff)})`);
        if (viewCostCentreIdsSelf.length) explicitViewFilters.push(`(${prefix}costCentreId IN (${(0, $61cVC.qf)(viewCostCentreIdsSelf)}) and staffId == ${(0, $61cVC.qf)(staff.id)})`);
        if (viewProjectIdsSelf.length) explicitViewFilters.push(`(${prefix}id IN (${(0, $61cVC.qf)(viewProjectIdsSelf)}) and staffId == ${(0, $61cVC.qf)(staff.id)})`);
        filters.push(`(${explicitViewFilters.join(" OR ")})`);
    } else // If there are no explicitly allowed projects or cost centers, the user shouldn't be able to see any project.
    filters.push(`${prefix}id in ${(0, $61cVC.qf)([])}`); // This is a false condition in SQL, which will result in no rows being returned.
    return filters;
};
const $32171960e79fb10a$export$fcd0e7be0d7a4a3f = (staffPermissions)=>{
    return staffPermissions.projects.some((p)=>p.filter.type === "all");
};
const $32171960e79fb10a$export$f4113ed376ae8577 = (staffPermissions)=>{
    return staffPermissions.projects.filter((p)=>p.filter.type === "project").flatMap((p)=>p.filter.values);
};
const $32171960e79fb10a$export$e3d4037aaab465e6 = (staffPermissions)=>{
    return staffPermissions.projects.filter((p)=>p.filter.type === "costCentre").flatMap((p)=>p.filter.values);
};
const $32171960e79fb10a$export$bb52a0a65cf7bc6b = (staff)=>{
    staff.permissions.projects.push({
        filter: !$32171960e79fb10a$export$fcd0e7be0d7a4a3f(staff) ? {
            type: "all"
        } : {
            type: "project",
            values: []
        },
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))(),
        permissions: {
            ...(0, $5NCwu.permissionPresets).timesheet.projects[0].permissions
        }
    });
    staff.update({
        permissions: {
            ...staff.permissions
        }
    });
};
const $32171960e79fb10a$export$ce80826071748789 = (staff, id, permissions)=>{
    const projectPermission = staff.permissions.projects.find((p)=>p.id === id);
    if (projectPermission) projectPermission.permissions = {
        ...projectPermission.permissions,
        ...permissions
    };
    staff.update({
        permissions: {
            ...staff.permissions
        }
    });
};
const $32171960e79fb10a$export$8feda8b7284fa718 = (staff, id, filter)=>{
    const projectPermission = staff.permissions.projects.find((p)=>p.id === id);
    if (projectPermission) projectPermission.filter = filter !== null && filter !== void 0 ? filter : projectPermission.filter;
    staff.update({
        permissions: {
            ...staff.permissions
        }
    });
};
const $32171960e79fb10a$export$ef31ce88c1fee5b0 = (staff, id)=>{
    staff.permissions.projects = staff.permissions.projects.filter((p)=>p.id !== id);
    staff.update({
        permissions: {
            ...staff.permissions
        }
    });
};
const $32171960e79fb10a$export$33db88f807cae7c1 = (staff, permissions)=>{
    staff.update({
        permissions: {
            ...staff.permissions,
            ...permissions
        }
    });
};
const $32171960e79fb10a$export$eefe297550f20bb2 = (staff)=>{
    return $32171960e79fb10a$export$5fe03513be1856a7(staff) || $32171960e79fb10a$export$5e89d543db4cb3c5(staff) || $32171960e79fb10a$export$8f145ea2aacc93bf(staff) || $32171960e79fb10a$export$847c46638ce2c07a(staff);
};
const $32171960e79fb10a$export$fe8739235582650e = (staff)=>{
    return $32171960e79fb10a$export$9c6c3596a649013(staff) || $32171960e79fb10a$export$46f00131111270ab(staff) || $32171960e79fb10a$export$882b0cfdd762e78f(staff);
};
const $32171960e79fb10a$export$f348984146c42cee = (staff)=>{
    return $32171960e79fb10a$export$5727cd4b0ac96bb(staff) || $32171960e79fb10a$export$36053682c9f8417f(staff);
};
const $32171960e79fb10a$export$a6beca1da1575bb4 = (staff)=>{
    return $32171960e79fb10a$export$99ebb2f31597d0f8(staff);
};
const $32171960e79fb10a$export$298056a9e410a562 = ()=>{
    var _SessionStore$setting;
    return (_SessionStore$setting = (0, $5uSSv.default).settings) === null || _SessionStore$setting === void 0 ? void 0 : _SessionStore$setting.allowNoPhase;
};
const $32171960e79fb10a$export$ae00bd829f4f51c3 = ()=>{
    var _SessionStore$setting2;
    return (_SessionStore$setting2 = (0, $5uSSv.default).settings) === null || _SessionStore$setting2 === void 0 ? void 0 : _SessionStore$setting2.useTasks;
};
const $32171960e79fb10a$export$63578e0659ccd39a = (phase)=>{
    var _SessionStore$setting3;
    return ((_SessionStore$setting3 = (0, $5uSSv.default).settings) === null || _SessionStore$setting3 === void 0 ? void 0 : _SessionStore$setting3.allowAfterPhaseEnd) || !phase.endDate || phase.endDate >= new Date();
};
const $32171960e79fb10a$export$e180c6df64ecea80 = (phase)=>{
    var _SessionStore$setting4;
    return (_SessionStore$setting4 = (0, $5uSSv.default).settings) === null || _SessionStore$setting4 === void 0 ? void 0 : _SessionStore$setting4.timeEntryStatus.includes(phase.status);
};
const $32171960e79fb10a$export$6d898cd8a81518a6 = (flag)=>{
    var _SessionStore$setting6;
    if ([
        "flexi",
        "remote"
    ].includes(flag)) {
        var _SessionStore$setting5;
        return $32171960e79fb10a$export$34db19be291d02b4() && ((_SessionStore$setting5 = (0, $5uSSv.default).settings) === null || _SessionStore$setting5 === void 0 ? void 0 : _SessionStore$setting5.timeEntryFlags.includes(flag));
    }
    return (_SessionStore$setting6 = (0, $5uSSv.default).settings) === null || _SessionStore$setting6 === void 0 ? void 0 : _SessionStore$setting6.timeEntryFlags.includes(flag);
};
const $32171960e79fb10a$var$phaseHasStaffBudgetedHours = (staff, phase)=>{
    return (phase.budgetedStaffIds || []).includes(staff.id);
};
const $32171960e79fb10a$var$phaseHasStaffAllocatedHours = (staff, phase)=>{
    return (phase.monthlyAllocatedStaffIds || []).includes(staff.id);
};
const $32171960e79fb10a$export$6111c66e9970d03f = (staff, phase)=>{
    var _SessionStore$setting7, _SessionStore$setting8, _SessionStore$setting9;
    return ((_SessionStore$setting7 = (0, $5uSSv.default).settings) === null || _SessionStore$setting7 === void 0 ? void 0 : _SessionStore$setting7.timeEntryAllocations.includes("noAllocations")) || ((_SessionStore$setting8 = (0, $5uSSv.default).settings) === null || _SessionStore$setting8 === void 0 ? void 0 : _SessionStore$setting8.timeEntryAllocations.includes("budgets")) && $32171960e79fb10a$var$phaseHasStaffBudgetedHours(staff, phase) || ((_SessionStore$setting9 = (0, $5uSSv.default).settings) === null || _SessionStore$setting9 === void 0 ? void 0 : _SessionStore$setting9.timeEntryAllocations.includes("allocations")) && $32171960e79fb10a$var$phaseHasStaffAllocatedHours(staff, phase);
};
const $32171960e79fb10a$export$fc41a823d5177566 = (staff, phase)=>{
    return $32171960e79fb10a$export$3f1b5bfd8135b6c(staff) || !(phase !== null && phase !== void 0 && phase.isRootPhase) && $32171960e79fb10a$export$63578e0659ccd39a(phase) && $32171960e79fb10a$export$e180c6df64ecea80(phase) && $32171960e79fb10a$export$6111c66e9970d03f(staff, phase) || $32171960e79fb10a$export$298056a9e410a562() && (phase === null || phase === void 0 ? void 0 : phase.isRootPhase);
};
const $32171960e79fb10a$export$3f1b5bfd8135b6c = (staff)=>{
    return $32171960e79fb10a$export$f348984146c42cee(staff) && $32171960e79fb10a$export$a6beca1da1575bb4(staff) && $32171960e79fb10a$export$bc10a6113304fa74(staff) && $32171960e79fb10a$export$b5ae555d76db988c(staff);
};
const $32171960e79fb10a$export$754fb65b80d0b166 = (staff, phase)=>{
    var _SessionStore$setting10, _SessionStore$setting11;
    return ((_SessionStore$setting10 = (0, $5uSSv.default).settings) === null || _SessionStore$setting10 === void 0 ? void 0 : _SessionStore$setting10.autoPopulate.includes("budgets")) && $32171960e79fb10a$var$phaseHasStaffBudgetedHours(staff, phase) || ((_SessionStore$setting11 = (0, $5uSSv.default).settings) === null || _SessionStore$setting11 === void 0 ? void 0 : _SessionStore$setting11.autoPopulate.includes("allocations")) && $32171960e79fb10a$var$phaseHasStaffAllocatedHours(staff, phase);
};
const $32171960e79fb10a$export$db55a6395ac2c723 = ()=>{
    var _SessionStore$setting12, _SessionStore$setting13;
    return ((_SessionStore$setting12 = (0, $5uSSv.default).settings) === null || _SessionStore$setting12 === void 0 ? void 0 : _SessionStore$setting12.autoPopulate.includes("budgets")) || ((_SessionStore$setting13 = (0, $5uSSv.default).settings) === null || _SessionStore$setting13 === void 0 ? void 0 : _SessionStore$setting13.autoPopulate.includes("allocations"));
};
const $32171960e79fb10a$export$b6ecaf9caa6603fc = ()=>{
    var _SessionStore$setting14;
    return (_SessionStore$setting14 = (0, $5uSSv.default).settings) === null || _SessionStore$setting14 === void 0 ? void 0 : _SessionStore$setting14.updateHoursFromRevenue;
};
const $32171960e79fb10a$export$b0d064f7a5278359 = ()=>{
    var _SessionStore$setting15;
    return (_SessionStore$setting15 = (0, $5uSSv.default).settings) === null || _SessionStore$setting15 === void 0 ? void 0 : _SessionStore$setting15.updateRevenueFromHours;
};
const $32171960e79fb10a$export$b23d26f35bff73e6 = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateRevenue.action === "ask" || (0, $5uSSv.default).settings.autoUpdateHours.action === "ask";
};
const $32171960e79fb10a$export$63c9e18cc2dd731d = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateRevenue.action === "ask";
};
const $32171960e79fb10a$export$f15ada9bfde93846 = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateHours.action === "ask";
};
const $32171960e79fb10a$export$c4d9e36c28fcff4e = ()=>{
    return $32171960e79fb10a$export$53d5bdd39f278bc8() && $32171960e79fb10a$export$4b11df8037968d99();
};
const $32171960e79fb10a$export$90049e1983ff85d2 = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateRevenue.action === "automatic";
};
const $32171960e79fb10a$export$70810266846e0824 = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateHours.action === "automatic";
};
const $32171960e79fb10a$export$4b11df8037968d99 = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateRevenue.action === "never";
};
const $32171960e79fb10a$export$53d5bdd39f278bc8 = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateHours.action === "never";
};
const $32171960e79fb10a$export$34cd61822c26e285 = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateRevenue.adjustOnLoad === true;
};
const $32171960e79fb10a$export$5edceaf3fd6e4e07 = ()=>{
    return (0, $5uSSv.default).settings.autoUpdateHours.adjustOnLoad === true;
};
const $32171960e79fb10a$export$7381a62a33d52327 = ()=>{
    return !(0, $5uSSv.default).settings.savingInvoices.includes("automatic");
};
const $32171960e79fb10a$export$f911643f217cf522 = (staff = (0, $5uSSv.default).user)=>{
    return $32171960e79fb10a$export$b325ec6732b039cf(staff, {
        canTrackExpenses: true
    });
};
const $32171960e79fb10a$export$52ef023427ec0160 = ()=>{
    return true;
};
const $32171960e79fb10a$export$2b8901aeafeaed5 = ()=>{
    return true;
};
const $32171960e79fb10a$export$684d952a6bbd86e5 = ()=>{
    return true;
};
const $32171960e79fb10a$export$36048df8dd0b8e59 = ()=>{
    return true;
};
const $32171960e79fb10a$export$ab2972ba6f2d8d3b = ()=>{
    return true;
};
const $32171960e79fb10a$export$a6558916f5c85935 = ()=>{
    return true;
};
const $32171960e79fb10a$export$e7c4ca5af7e08d26 = ()=>{
    if ((0, $5uSSv.default).organisation.id === "7d729342-8401-4c32-82c8-d6b156469fdc") return [
        {
            name: "Additional services",
            isBillable: true,
            isVariation: true
        },
        {
            name: "Non-billable",
            isBillable: false,
            isVariation: false
        },
        {
            name: "STUDIO Review",
            isBillable: false,
            isVariation: false
        }
    ];
    else return [];
};
const $32171960e79fb10a$export$d23957846b5a6609 = ()=>{
    return [
        "7d729342-8401-4c32-82c8-d6b156469fdc"
    ].includes((0, $5uSSv.default).organisation.id);
};
const $32171960e79fb10a$export$7e8ab8886625eb0e = ()=>{
    return [
        "f6fb558a-31eb-42cf-82fd-bd44d39207eb",
        "97a4070d-0bc0-4a1a-b907-b4e3f612a70c",
        "9d7b8c8f-ada1-4ae7-a3ed-d79d538077b4"
    ].includes((0, $5uSSv.default).organisation.id);
};
const $32171960e79fb10a$export$34db19be291d02b4 = ()=>{
    return [
        "f6fb558a-31eb-42cf-82fd-bd44d39207eb",
        "7d9cd6d4-d57c-4210-a9a0-3a9c37263ff2"
    ].includes((0, $5uSSv.default).organisation.id);
};
const $32171960e79fb10a$export$571b4d93ee7e01ff = ()=>{
    var _SessionStore$subscri;
    return (_SessionStore$subscri = (0, $5uSSv.default).subscription) === null || _SessionStore$subscri === void 0 ? void 0 : _SessionStore$subscri.isAccountLocked;
};
const $32171960e79fb10a$export$f7763d8e62d354af = ()=>{
    return (0, $5uSSv.default).migratedToV2;
};

});
parcelRegister("7bpHx", function(module, exports) {

$parcel$export(module.exports, "permissionLevels", function () { return $53ad7f30cbfee55d$export$1905b608ab6396f9; });
const $53ad7f30cbfee55d$export$934d5cf97a7eb061 = [
    {
        label: "Forecasts",
        permissions: [
            {
                label: "Can View Revenue Forecast",
                type: "switch",
                key: "canViewRevenueForecast"
            },
            {
                label: "Can View Staff Expenses",
                type: "switch",
                key: "canViewStaffExpenses",
                display: (permissions)=>permissions.canViewRevenueForecast
            },
            {
                label: "Can View Operational Expenses",
                type: "switch",
                key: "canViewOperationalExpenses",
                display: (permissions)=>permissions.canViewRevenueForecast
            },
            {
                label: "Can View Resource Schedule",
                type: "switch",
                key: "canViewResourceSchedule"
            }
        ]
    },
    {
        label: "Projects",
        permissions: [
            {
                label: "Project Permissions",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit",
                    "admin"
                ],
                key: "projectPermissions"
            },
            {
                label: "Fees",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit"
                ],
                key: "projectFees",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Expense Budgets",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit"
                ],
                key: "projectExpenseBudgets",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Hours Budgets",
                type: "radio",
                options: [
                    "view",
                    "edit"
                ],
                key: "projectHoursBudgets",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Staff Budgets",
                type: "radio",
                options: [
                    "view",
                    "admin"
                ],
                key: "projectStaffBudgets",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Project Dates",
                type: "radio",
                options: [
                    "view",
                    "edit"
                ],
                key: "projectDates",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Phases & Tasks",
                type: "radio",
                options: [
                    "view",
                    "admin"
                ],
                key: "projectPhasesTasks",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Project Expenses",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "projectExpenses",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Forecasted Revenue",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit"
                ],
                key: "projectForecastedRevenue",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Forecasted Hours",
                type: "radio",
                options: [
                    "view",
                    "edit"
                ],
                key: "projectForecastedHours",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Invoices",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "projectInvoices",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Project Rates",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "projectRates",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Project Notes",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "projectNotes",
                display: (permissions)=>permissions.projectPermissions && permissions.projectPermissions !== "hidden"
            },
            {
                label: "Can Record Time",
                type: "switch",
                key: "projectTimesheets"
            }
        ]
    },
    {
        label: "Staff & Roles",
        permissions: [
            {
                label: "Staff",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit",
                    "admin"
                ],
                key: "staffPermissions"
            },
            {
                label: "Roles",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "edit",
                    "admin"
                ],
                key: "rolePermissions"
            },
            {
                label: "Can Edit Timesheets",
                type: "switch",
                key: "editStaffTime",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            },
            {
                label: "Pay Rate",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "payRate",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            },
            {
                label: "Overtime Rate",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "overtimeRate",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            },
            {
                label: "Cost Rate",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "costRate",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            },
            {
                label: "Charge Out Rate",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "chargeOutRate",
                display: (permissions)=>permissions.staffPermissions && permissions.staffPermissions !== "hidden" || permissions.rolePermissions && permissions.rolePermissions !== "hidden"
            }
        ]
    },
    {
        label: "Organisation",
        permissions: [
            {
                label: "Contacts",
                type: "radio",
                options: [
                    "view",
                    "admin"
                ],
                key: "contacts"
            },
            {
                label: "Cost Centres",
                type: "radio",
                options: [
                    "view",
                    "admin"
                ],
                key: "costCentres"
            },
            {
                label: "Operational Expenses",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "operationalExpenses"
            },
            {
                label: "Holidays",
                type: "radio",
                options: [
                    "hidden",
                    "view",
                    "admin"
                ],
                key: "holidays"
            },
            {
                label: "Invoice Settings",
                type: "radio",
                options: [
                    "hidden",
                    "edit"
                ],
                key: "invoiceSettings"
            },
            {
                label: "Organisation Settings",
                type: "radio",
                options: [
                    "hidden",
                    "edit"
                ],
                key: "organisationSettings"
            },
            {
                label: "Billing",
                type: "radio",
                options: [
                    "hidden",
                    "edit"
                ],
                key: "billing"
            }
        ]
    }
];
const $53ad7f30cbfee55d$export$1905b608ab6396f9 = [
    "hidden",
    "view",
    "edit",
    "admin"
];

});

parcelRegister("5NCwu", function(module, exports) {

$parcel$export(module.exports, "permissionPresets", function () { return $438f693e37c5a1e5$export$807e1b0b524050b6; });
const $438f693e37c5a1e5$export$807e1b0b524050b6 = {
    masterAdmin: {
        canViewRevenueForecast: true,
        canViewStaffExpenses: true,
        canViewOperationalExpenses: true,
        canViewResourceSchedule: true,
        canViewWeeklyPlanner: true,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "admin",
                    projectFees: "edit",
                    projectExpenseBudgets: "edit",
                    projectHoursBudgets: "edit",
                    projectStaffBudgets: "admin",
                    projectDates: "edit",
                    projectPhasesTasks: "admin",
                    projectExpenses: "admin",
                    projectForecastedRevenue: "edit",
                    projectForecastedHours: "edit",
                    projectInvoices: "admin",
                    projectRates: "admin",
                    projectNotes: "admin",
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "admin",
        rolePermissions: "admin",
        editStaffTime: true,
        payRate: "admin",
        overtimeRate: "admin",
        costRate: "admin",
        chargeOutRate: "admin",
        contacts: "admin",
        costCentres: "admin",
        operationalExpenses: "admin",
        holidays: "admin",
        invoiceSettings: "edit",
        organisationSettings: "edit",
        billing: "edit"
    },
    limitedAdmin: {
        canViewRevenueForecast: true,
        canViewStaffExpenses: true,
        canViewOperationalExpenses: true,
        canViewResourceSchedule: true,
        canViewWeeklyPlanner: true,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "admin",
                    projectFees: "edit",
                    projectExpenseBudgets: "edit",
                    projectHoursBudgets: "edit",
                    projectStaffBudgets: "admin",
                    projectDates: "edit",
                    projectPhasesTasks: "admin",
                    projectExpenses: "admin",
                    projectForecastedRevenue: "edit",
                    projectForecastedHours: "edit",
                    projectInvoices: "admin",
                    projectRates: "admin",
                    projectNotes: "admin",
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "view",
        rolePermissions: "view",
        editStaffTime: true,
        payRate: "view",
        overtimeRate: "view",
        costRate: "view",
        chargeOutRate: "view",
        contacts: "admin",
        costCentres: "hidden",
        operationalExpenses: "hidden",
        holidays: "view",
        invoiceSettings: "hidden",
        organisationSettings: "hidden",
        billing: "hidden"
    },
    projectManager: {
        canViewRevenueForecast: true,
        canViewStaffExpenses: false,
        canViewOperationalExpenses: false,
        canViewResourceSchedule: true,
        canViewWeeklyPlanner: true,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "edit",
                    projectFees: "view",
                    projectExpenseBudgets: "view",
                    projectHoursBudgets: "view",
                    projectStaffBudgets: "admin",
                    projectDates: "edit",
                    projectPhasesTasks: "view",
                    projectExpenses: "admin",
                    projectForecastedRevenue: "edit",
                    projectForecastedHours: "edit",
                    projectInvoices: "view",
                    projectRates: "view",
                    projectNotes: "admin",
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "hidden",
        rolePermissions: "hidden",
        editStaffTime: false,
        payRate: "hidden",
        overtimeRate: "hidden",
        costRate: "view",
        chargeOutRate: "view",
        contacts: "view",
        costCentres: "view",
        operationalExpenses: "hidden",
        holidays: "view",
        invoiceSettings: "hidden",
        organisationSettings: "hidden",
        billing: "hidden"
    },
    viewer: {
        canViewRevenueForecast: true,
        canViewStaffExpenses: false,
        canViewOperationalExpenses: false,
        canViewResourceSchedule: true,
        canViewWeeklyPlanner: true,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "view",
                    projectFees: "view",
                    projectExpenseBudgets: "view",
                    projectHoursBudgets: "view",
                    projectStaffBudgets: "view",
                    projectDates: "view",
                    projectPhasesTasks: "view",
                    projectExpenses: "view",
                    projectForecastedRevenue: "view",
                    projectForecastedHours: "view",
                    projectInvoices: "view",
                    projectRates: "hidden",
                    projectNotes: "view",
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "hidden",
        rolePermissions: "hidden",
        editStaffTime: false,
        payRate: "hidden",
        overtimeRate: "hidden",
        costRate: "view",
        chargeOutRate: "view",
        contacts: "view",
        costCentres: "view",
        operationalExpenses: "hidden",
        holidays: "view",
        invoiceSettings: "hidden",
        organisationSettings: "hidden",
        billing: "hidden"
    },
    timesheet: {
        canViewRevenueForecast: false,
        canViewStaffExpenses: false,
        canViewOperationalExpenses: false,
        canViewResourceSchedule: false,
        canViewWeeklyPlanner: false,
        projects: [
            {
                filter: {
                    type: "all"
                },
                permissions: {
                    projectPermissions: "hidden",
                    projectFees: "hidden",
                    projectExpenseBudgets: "hidden",
                    projectHoursBudgets: "hidden",
                    projectStaffBudgets: "hidden",
                    projectDates: "hidden",
                    projectPhasesTasks: "hidden",
                    projectExpenses: "hidden",
                    projectForecastedRevenue: "hidden",
                    projectForecastedHours: "hidden",
                    projectInvoices: "hidden",
                    projectRates: "hidden",
                    projectNotes: "hidden",
                    projectTimesheets: true
                }
            }
        ],
        staffPermissions: "hidden",
        rolePermissions: "hidden",
        editStaffTime: false,
        payRate: "hidden",
        overtimeRate: "hidden",
        costRate: "hidden",
        chargeOutRate: "hidden",
        contacts: "hidden",
        costCentres: "hidden",
        operationalExpenses: "hidden",
        holidays: "hidden",
        invoiceSettings: "hidden",
        organisationSettings: "hidden",
        billing: "hidden"
    }
};

});

parcelRegister("f9Rb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b090f26829cd7c0f$export$2e2bcd8739ae039; });
var $b090f26829cd7c0f$export$6a00d17b5aff0af, $b090f26829cd7c0f$var$i = "undefined" != typeof window ? window : void 0, $b090f26829cd7c0f$var$e = "undefined" != typeof globalThis ? globalThis : $b090f26829cd7c0f$var$i, $b090f26829cd7c0f$var$r = Array.prototype, $b090f26829cd7c0f$var$s = $b090f26829cd7c0f$var$r.forEach, $b090f26829cd7c0f$var$n = $b090f26829cd7c0f$var$r.indexOf, $b090f26829cd7c0f$var$o = null == $b090f26829cd7c0f$var$e ? void 0 : $b090f26829cd7c0f$var$e.navigator, $b090f26829cd7c0f$var$a = null == $b090f26829cd7c0f$var$e ? void 0 : $b090f26829cd7c0f$var$e.document, $b090f26829cd7c0f$var$l = null == $b090f26829cd7c0f$var$e ? void 0 : $b090f26829cd7c0f$var$e.location, $b090f26829cd7c0f$var$h = null == $b090f26829cd7c0f$var$e ? void 0 : $b090f26829cd7c0f$var$e.fetch, $b090f26829cd7c0f$var$u = null != $b090f26829cd7c0f$var$e && $b090f26829cd7c0f$var$e.XMLHttpRequest && "withCredentials" in new $b090f26829cd7c0f$var$e.XMLHttpRequest ? $b090f26829cd7c0f$var$e.XMLHttpRequest : void 0, $b090f26829cd7c0f$var$d = null == $b090f26829cd7c0f$var$e ? void 0 : $b090f26829cd7c0f$var$e.AbortController, $b090f26829cd7c0f$var$v = null == $b090f26829cd7c0f$var$o ? void 0 : $b090f26829cd7c0f$var$o.userAgent, $b090f26829cd7c0f$var$c = null != $b090f26829cd7c0f$var$i ? $b090f26829cd7c0f$var$i : {}, $b090f26829cd7c0f$var$f = {
    DEBUG: !1,
    LIB_VERSION: "1.239.0"
}, $b090f26829cd7c0f$export$7bea938663611d9 = "$copy_autocapture", $b090f26829cd7c0f$export$fbd163209a0ff4bf = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
];
!function(t) {
    t.GZipJS = "gzip-js", t.Base64 = "base64";
}($b090f26829cd7c0f$export$6a00d17b5aff0af || ($b090f26829cd7c0f$export$6a00d17b5aff0af = {}));
var $b090f26829cd7c0f$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $b090f26829cd7c0f$var$m(t, i) {
    return -1 !== t.indexOf(i);
}
var $b090f26829cd7c0f$var$b = function(t) {
    return t.trim();
}, $b090f26829cd7c0f$var$w = function(t) {
    return t.replace(/^\$/, "");
};
var $b090f26829cd7c0f$var$y = Array.isArray, $b090f26829cd7c0f$var$S = Object.prototype, $b090f26829cd7c0f$var$$ = $b090f26829cd7c0f$var$S.hasOwnProperty, $b090f26829cd7c0f$var$k = $b090f26829cd7c0f$var$S.toString, $b090f26829cd7c0f$var$x = $b090f26829cd7c0f$var$y || function(t) {
    return "[object Array]" === $b090f26829cd7c0f$var$k.call(t);
}, $b090f26829cd7c0f$var$E = (t)=>"function" == typeof t, $b090f26829cd7c0f$var$I = (t)=>t === Object(t) && !$b090f26829cd7c0f$var$x(t), $b090f26829cd7c0f$var$P = (t)=>{
    if ($b090f26829cd7c0f$var$I(t)) {
        for(var i in t)if ($b090f26829cd7c0f$var$$.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $b090f26829cd7c0f$var$R = (t)=>void 0 === t, $b090f26829cd7c0f$var$T = (t)=>"[object String]" == $b090f26829cd7c0f$var$k.call(t), $b090f26829cd7c0f$var$M = (t)=>$b090f26829cd7c0f$var$T(t) && 0 === t.trim().length, $b090f26829cd7c0f$var$C = (t)=>null === t, $b090f26829cd7c0f$var$O = (t)=>$b090f26829cd7c0f$var$R(t) || $b090f26829cd7c0f$var$C(t), $b090f26829cd7c0f$var$F = (t)=>"[object Number]" == $b090f26829cd7c0f$var$k.call(t), $b090f26829cd7c0f$var$A = (t)=>"[object Boolean]" === $b090f26829cd7c0f$var$k.call(t), $b090f26829cd7c0f$var$D = (t)=>t instanceof FormData, $b090f26829cd7c0f$var$j = (t)=>$b090f26829cd7c0f$var$m($b090f26829cd7c0f$export$fbd163209a0ff4bf, t), $b090f26829cd7c0f$var$L = (t)=>{
    var e = {
        t: function(e) {
            if ($b090f26829cd7c0f$var$i && ($b090f26829cd7c0f$var$f.DEBUG || $b090f26829cd7c0f$var$c.POSTHOG_DEBUG) && !$b090f26829cd7c0f$var$R($b090f26829cd7c0f$var$i.console) && $b090f26829cd7c0f$var$i.console) {
                for(var r = ("__rrweb_original__" in $b090f26829cd7c0f$var$i.console[e]) ? $b090f26829cd7c0f$var$i.console[e].__rrweb_original__ : $b090f26829cd7c0f$var$i.console[e], s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)n[o - 1] = arguments[o];
                r(t, ...n);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("error", ...i);
        },
        critical: function() {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            console.error(t, ...e);
        },
        uninitializedWarning: (t)=>{
            e.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (i)=>$b090f26829cd7c0f$var$L(t + " " + i)
    };
    return e;
}, $b090f26829cd7c0f$var$N = $b090f26829cd7c0f$var$L("[PostHog.js]"), $b090f26829cd7c0f$var$z = $b090f26829cd7c0f$var$N.createLogger, $b090f26829cd7c0f$var$U = $b090f26829cd7c0f$var$z("[ExternalScriptsLoader]"), $b090f26829cd7c0f$var$q = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $b090f26829cd7c0f$var$U.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == $b090f26829cd7c0f$var$a ? void 0 : $b090f26829cd7c0f$var$a.querySelectorAll("script");
    if (r) {
        for(var s = 0; s < r.length; s++)if (r[s].src === i) return e();
    }
    var n = ()=>{
        if (!$b090f26829cd7c0f$var$a) return e("document not found");
        var r = $b090f26829cd7c0f$var$a.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>e(void 0, t), r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        var s, n = $b090f26829cd7c0f$var$a.querySelectorAll("body > script");
        n.length > 0 ? null == (s = n[0].parentNode) || s.insertBefore(r, n[0]) : $b090f26829cd7c0f$var$a.body.appendChild(r);
    };
    null != $b090f26829cd7c0f$var$a && $b090f26829cd7c0f$var$a.body ? n() : null == $b090f26829cd7c0f$var$a || $b090f26829cd7c0f$var$a.addEventListener("DOMContentLoaded", n);
};
function $b090f26829cd7c0f$var$B() {
    return $b090f26829cd7c0f$var$B = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $b090f26829cd7c0f$var$B.apply(this, arguments);
}
function $b090f26829cd7c0f$var$H(t, i) {
    if (null == t) return {};
    var e, r, s = {}, n = Object.keys(t);
    for(r = 0; r < n.length; r++)e = n[r], i.indexOf(e) >= 0 || (s[e] = t[e]);
    return s;
}
$b090f26829cd7c0f$var$c.__PosthogExtensions__ = $b090f26829cd7c0f$var$c.__PosthogExtensions__ || {}, $b090f26829cd7c0f$var$c.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    $b090f26829cd7c0f$var$q(t, n, e);
}, $b090f26829cd7c0f$var$c.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    $b090f26829cd7c0f$var$q(t, r, e);
};
var $b090f26829cd7c0f$var$W = {};
function $b090f26829cd7c0f$var$G(t, i, e) {
    if ($b090f26829cd7c0f$var$x(t)) {
        if ($b090f26829cd7c0f$var$s && t.forEach === $b090f26829cd7c0f$var$s) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var r = 0, n = t.length; r < n; r++)if (r in t && i.call(e, t[r], r) === $b090f26829cd7c0f$var$W) return;
        }
    }
}
function $b090f26829cd7c0f$var$J(t, i, e) {
    if (!$b090f26829cd7c0f$var$O(t)) {
        if ($b090f26829cd7c0f$var$x(t)) return $b090f26829cd7c0f$var$G(t, i, e);
        if ($b090f26829cd7c0f$var$D(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === $b090f26829cd7c0f$var$W) return;
        } else for(var s in t)if ($b090f26829cd7c0f$var$$.call(t, s) && i.call(e, t[s], s) === $b090f26829cd7c0f$var$W) return;
    }
}
var $b090f26829cd7c0f$var$V = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $b090f26829cd7c0f$var$G(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, $b090f26829cd7c0f$var$K = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $b090f26829cd7c0f$var$G(e, function(i) {
        $b090f26829cd7c0f$var$G(i, function(i) {
            t.push(i);
        });
    }), t;
};
function $b090f26829cd7c0f$var$Y(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var $b090f26829cd7c0f$var$X = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $b090f26829cd7c0f$var$Q = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $b090f26829cd7c0f$var$N.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $b090f26829cd7c0f$var$N.critical(t);
        }
    };
}, $b090f26829cd7c0f$var$Z = function(t) {
    var i = {};
    return $b090f26829cd7c0f$var$J(t, function(t, e) {
        ($b090f26829cd7c0f$var$T(t) && t.length > 0 || $b090f26829cd7c0f$var$F(t)) && (i[e] = t);
    }), i;
};
function $b090f26829cd7c0f$var$tt(t, i) {
    var e, r, s;
    return e = t, r = (t)=>$b090f26829cd7c0f$var$T(t) && !$b090f26829cd7c0f$var$C(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), $b090f26829cd7c0f$var$x(i) ? (n = [], $b090f26829cd7c0f$var$G(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, $b090f26829cd7c0f$var$J(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var $b090f26829cd7c0f$var$it = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $b090f26829cd7c0f$var$et(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!$b090f26829cd7c0f$var$T(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of $b090f26829cd7c0f$var$it)if (e === r) return !1;
    return !0;
}
function $b090f26829cd7c0f$var$rt(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function $b090f26829cd7c0f$var$st(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
var $b090f26829cd7c0f$var$nt = "$people_distinct_id", $b090f26829cd7c0f$var$ot = "__alias", $b090f26829cd7c0f$var$at = "__timers", $b090f26829cd7c0f$var$lt = "$autocapture_disabled_server_side", $b090f26829cd7c0f$var$ht = "$heatmaps_enabled_server_side", $b090f26829cd7c0f$var$ut = "$exception_capture_enabled_server_side", $b090f26829cd7c0f$var$dt = "$web_vitals_enabled_server_side", $b090f26829cd7c0f$var$vt = "$dead_clicks_enabled_server_side", $b090f26829cd7c0f$var$ct = "$web_vitals_allowed_metrics", $b090f26829cd7c0f$var$ft = "$session_recording_enabled_server_side", $b090f26829cd7c0f$var$pt = "$console_log_recording_enabled_server_side", $b090f26829cd7c0f$var$gt = "$session_recording_network_payload_capture", $b090f26829cd7c0f$var$_t = "$session_recording_masking", $b090f26829cd7c0f$var$mt = "$session_recording_canvas_recording", $b090f26829cd7c0f$var$bt = "$replay_sample_rate", $b090f26829cd7c0f$var$wt = "$replay_minimum_duration", $b090f26829cd7c0f$var$yt = "$replay_script_config", $b090f26829cd7c0f$var$St = "$sesid", $b090f26829cd7c0f$var$$t = "$session_is_sampled", $b090f26829cd7c0f$var$kt = "$session_recording_url_trigger_activated_session", $b090f26829cd7c0f$var$xt = "$session_recording_event_trigger_activated_session", $b090f26829cd7c0f$var$Et = "$enabled_feature_flags", $b090f26829cd7c0f$var$It = "$early_access_features", $b090f26829cd7c0f$var$Pt = "$feature_flag_details", $b090f26829cd7c0f$var$Rt = "$stored_person_properties", $b090f26829cd7c0f$var$Tt = "$stored_group_properties", $b090f26829cd7c0f$var$Mt = "$surveys", $b090f26829cd7c0f$var$Ct = "$surveys_activated", $b090f26829cd7c0f$var$Ot = "$flag_call_reported", $b090f26829cd7c0f$var$Ft = "$user_state", $b090f26829cd7c0f$var$At = "$client_session_props", $b090f26829cd7c0f$var$Dt = "$capture_rate_limit", $b090f26829cd7c0f$var$jt = "$initial_campaign_params", $b090f26829cd7c0f$var$Lt = "$initial_referrer_info", $b090f26829cd7c0f$var$Nt = "$initial_person_info", $b090f26829cd7c0f$var$zt = "$epp", $b090f26829cd7c0f$var$Ut = "__POSTHOG_TOOLBAR__", $b090f26829cd7c0f$var$qt = "$posthog_cookieless", $b090f26829cd7c0f$var$Bt = [
    $b090f26829cd7c0f$var$nt,
    $b090f26829cd7c0f$var$ot,
    "__cmpns",
    $b090f26829cd7c0f$var$at,
    $b090f26829cd7c0f$var$ft,
    $b090f26829cd7c0f$var$ht,
    $b090f26829cd7c0f$var$St,
    $b090f26829cd7c0f$var$Et,
    $b090f26829cd7c0f$var$Ft,
    $b090f26829cd7c0f$var$It,
    $b090f26829cd7c0f$var$Pt,
    $b090f26829cd7c0f$var$Tt,
    $b090f26829cd7c0f$var$Rt,
    $b090f26829cd7c0f$var$Mt,
    $b090f26829cd7c0f$var$Ot,
    $b090f26829cd7c0f$var$At,
    $b090f26829cd7c0f$var$Dt,
    $b090f26829cd7c0f$var$jt,
    $b090f26829cd7c0f$var$Lt,
    $b090f26829cd7c0f$var$zt
];
function $b090f26829cd7c0f$var$Ht(t) {
    return t instanceof Element && (t.id === $b090f26829cd7c0f$var$Ut || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $b090f26829cd7c0f$var$Wt(t) {
    return !!t && 1 === t.nodeType;
}
function $b090f26829cd7c0f$var$Gt(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $b090f26829cd7c0f$var$Jt(t) {
    return !!t && 3 === t.nodeType;
}
function $b090f26829cd7c0f$var$Vt(t) {
    return !!t && 11 === t.nodeType;
}
function $b090f26829cd7c0f$var$Kt(t) {
    return t ? $b090f26829cd7c0f$var$b(t).split(/\s+/) : [];
}
function $b090f26829cd7c0f$var$Yt(t) {
    var e = null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.location.href;
    return !!(e && t && t.some((t)=>e.match(t)));
}
function $b090f26829cd7c0f$var$Xt(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $b090f26829cd7c0f$var$Kt(i);
}
function $b090f26829cd7c0f$var$Qt(t) {
    return $b090f26829cd7c0f$var$O(t) ? null : $b090f26829cd7c0f$var$b(t).split(/(\s+)/).filter((t)=>$b090f26829cd7c0f$var$vi(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $b090f26829cd7c0f$var$Zt(t) {
    var i = "";
    return $b090f26829cd7c0f$var$si(t) && !$b090f26829cd7c0f$var$ni(t) && t.childNodes && t.childNodes.length && $b090f26829cd7c0f$var$J(t.childNodes, function(t) {
        var e;
        $b090f26829cd7c0f$var$Jt(t) && t.textContent && (i += null !== (e = $b090f26829cd7c0f$var$Qt(t.textContent)) && void 0 !== e ? e : "");
    }), $b090f26829cd7c0f$var$b(i);
}
function $b090f26829cd7c0f$var$ti(t) {
    var i;
    return $b090f26829cd7c0f$var$R(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $b090f26829cd7c0f$var$ii = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $b090f26829cd7c0f$var$ei(t) {
    var i = t.parentNode;
    return !(!i || !$b090f26829cd7c0f$var$Wt(i)) && i;
}
function $b090f26829cd7c0f$var$ri(t, e, r, s, n) {
    var o, a, l;
    if (void 0 === r && (r = void 0), !$b090f26829cd7c0f$var$i || !t || $b090f26829cd7c0f$var$Gt(t, "html") || !$b090f26829cd7c0f$var$Wt(t)) return !1;
    if (null != (o = r) && o.url_allowlist && !$b090f26829cd7c0f$var$Yt(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && $b090f26829cd7c0f$var$Yt(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var h = r.dom_event_allowlist;
        if (h && !h.some((t)=>e.type === t)) return !1;
    }
    for(var u = !1, d = [
        t
    ], v = !0, c = t; c.parentNode && !$b090f26829cd7c0f$var$Gt(c, "body");)if ($b090f26829cd7c0f$var$Vt(c.parentNode)) d.push(c.parentNode.host), c = c.parentNode.host;
    else {
        if (!(v = $b090f26829cd7c0f$var$ei(c))) break;
        if (s || $b090f26829cd7c0f$var$ii.indexOf(v.tagName.toLowerCase()) > -1) u = !0;
        else {
            var f = $b090f26829cd7c0f$var$i.getComputedStyle(v);
            f && "pointer" === f.getPropertyValue("cursor") && (u = !0);
        }
        d.push(v), c = v;
    }
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if ($b090f26829cd7c0f$var$R(e)) return !0;
        var r = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var s of t){
            var n = r(s);
            if ("object" == typeof n) return n.v;
        }
        return !1;
    }(d, r)) return !1;
    if (!function(t, i) {
        var e = null == i ? void 0 : i.css_selector_allowlist;
        if ($b090f26829cd7c0f$var$R(e)) return !0;
        var r = function(t) {
            if (e.some((i)=>t.matches(i))) return {
                v: !0
            };
        };
        for (var s of t){
            var n = r(s);
            if ("object" == typeof n) return n.v;
        }
        return !1;
    }(d, r)) return !1;
    var p = $b090f26829cd7c0f$var$i.getComputedStyle(t);
    if (p && "pointer" === p.getPropertyValue("cursor") && "click" === e.type) return !0;
    var g = t.tagName.toLowerCase();
    switch(g){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return u ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && ($b090f26829cd7c0f$var$ii.indexOf(g) > -1 || "true" === t.getAttribute("contenteditable"));
    }
}
function $b090f26829cd7c0f$var$si(t) {
    for(var i = t; i.parentNode && !$b090f26829cd7c0f$var$Gt(i, "body"); i = i.parentNode){
        var e = $b090f26829cd7c0f$var$Xt(i);
        if ($b090f26829cd7c0f$var$m(e, "ph-sensitive") || $b090f26829cd7c0f$var$m(e, "ph-no-capture")) return !1;
    }
    if ($b090f26829cd7c0f$var$m($b090f26829cd7c0f$var$Xt(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($b090f26829cd7c0f$var$T(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if ($b090f26829cd7c0f$var$T(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $b090f26829cd7c0f$var$ni(t) {
    return !!($b090f26829cd7c0f$var$Gt(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $b090f26829cd7c0f$var$Gt(t, "select") || $b090f26829cd7c0f$var$Gt(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $b090f26829cd7c0f$var$oi = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $b090f26829cd7c0f$var$ai = new RegExp("^(?:" + $b090f26829cd7c0f$var$oi + ")$"), $b090f26829cd7c0f$var$li = new RegExp($b090f26829cd7c0f$var$oi), $b090f26829cd7c0f$var$hi = "\\d{3}-?\\d{2}-?\\d{4}", $b090f26829cd7c0f$var$ui = new RegExp("^(" + $b090f26829cd7c0f$var$hi + ")$"), $b090f26829cd7c0f$var$di = new RegExp("(" + $b090f26829cd7c0f$var$hi + ")");
function $b090f26829cd7c0f$var$vi(t, i) {
    if (void 0 === i && (i = !0), $b090f26829cd7c0f$var$O(t)) return !1;
    if ($b090f26829cd7c0f$var$T(t)) {
        if (t = $b090f26829cd7c0f$var$b(t), (i ? $b090f26829cd7c0f$var$ai : $b090f26829cd7c0f$var$li).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? $b090f26829cd7c0f$var$ui : $b090f26829cd7c0f$var$di).test(t)) return !1;
    }
    return !0;
}
function $b090f26829cd7c0f$var$ci(t) {
    var i = $b090f26829cd7c0f$var$Zt(t);
    return $b090f26829cd7c0f$var$vi(i = (i + " " + $b090f26829cd7c0f$var$fi(t)).trim()) ? i : "";
}
function $b090f26829cd7c0f$var$fi(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && $b090f26829cd7c0f$var$J(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = $b090f26829cd7c0f$var$Zt(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + $b090f26829cd7c0f$var$fi(t)).trim());
        } catch (t) {
            $b090f26829cd7c0f$var$N.error("[AutoCapture]", t);
        }
    }), i;
}
function $b090f26829cd7c0f$var$pi(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = $b090f26829cd7c0f$var$B({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return $b090f26829cd7c0f$var$Y(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[$b090f26829cd7c0f$var$gi(i.toString())] = $b090f26829cd7c0f$var$gi(e.toString());
            }), r += ":", r += $b090f26829cd7c0f$var$Y(n).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: $b090f26829cd7c0f$var$_i(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return $b090f26829cd7c0f$var$Y(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function $b090f26829cd7c0f$var$gi(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $b090f26829cd7c0f$var$_i(t) {
    var i = t.attr__class;
    return i ? $b090f26829cd7c0f$var$x(i) ? i : $b090f26829cd7c0f$var$Kt(i) : void 0;
}
class $b090f26829cd7c0f$var$mi {
    constructor(){
        this.clicks = [];
    }
    isRageClick(t, i, e) {
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < 30 && e - r.timestamp < 1e3) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), 3 === this.clicks.length) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var $b090f26829cd7c0f$var$bi = [
    "localhost",
    "127.0.0.1"
], $b090f26829cd7c0f$var$wi = (t)=>{
    var i = null == $b090f26829cd7c0f$var$a ? void 0 : $b090f26829cd7c0f$var$a.createElement("a");
    return $b090f26829cd7c0f$var$R(i) ? null : (i.href = t, i);
}, $b090f26829cd7c0f$var$yi = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return $b090f26829cd7c0f$var$J(t, function(t, i) {
        $b090f26829cd7c0f$var$R(t) || $b090f26829cd7c0f$var$R(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, $b090f26829cd7c0f$var$Si = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!$b090f26829cd7c0f$var$x(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $b090f26829cd7c0f$var$N.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $b090f26829cd7c0f$var$$i = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], h = (a || "").split("&"), u = [], d = 0; d < h.length; d++){
        var v = h[d].split("=");
        $b090f26829cd7c0f$var$x(v) && (i.includes(v[0]) ? u.push(v[0] + "=" + e) : u.push(h[d]));
    }
    var c = l;
    return null != a && (c += "?" + u.join("&")), null != n && (c += "#" + n), c;
}, $b090f26829cd7c0f$var$ki = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $b090f26829cd7c0f$var$xi = $b090f26829cd7c0f$var$z("[AutoCapture]");
function $b090f26829cd7c0f$var$Ei(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $b090f26829cd7c0f$var$Ii(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !$b090f26829cd7c0f$var$Wt(i));
    return i;
}
function $b090f26829cd7c0f$var$Pi(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    $b090f26829cd7c0f$var$ii.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = $b090f26829cd7c0f$var$Ei(1024, $b090f26829cd7c0f$var$ci(t)) : n.$el_text = $b090f26829cd7c0f$var$Ei(1024, $b090f26829cd7c0f$var$Zt(t)));
    var o = $b090f26829cd7c0f$var$Xt(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), $b090f26829cd7c0f$var$J(t.attributes, function(e) {
        var s;
        if ((!$b090f26829cd7c0f$var$ni(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && $b090f26829cd7c0f$var$vi(e.value) && (s = e.name, !$b090f26829cd7c0f$var$T(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = $b090f26829cd7c0f$var$Kt(o).join(" ")), n["attr__" + e.name] = $b090f26829cd7c0f$var$Ei(1024, o);
        }
    });
    for(var a = 1, l = 1, h = t; h = $b090f26829cd7c0f$var$Ii(h);)a++, h.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function $b090f26829cd7c0f$var$Ri(t, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: h } = e, u = [
        t
    ], d = t; d.parentNode && !$b090f26829cd7c0f$var$Gt(d, "body");)$b090f26829cd7c0f$var$Vt(d.parentNode) ? (u.push(d.parentNode.host), d = d.parentNode.host) : (u.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, g = !1;
    if ($b090f26829cd7c0f$var$J(u, (t)=>{
        var i = $b090f26829cd7c0f$var$si(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && $b090f26829cd7c0f$var$vi(p) && p), $b090f26829cd7c0f$var$m($b090f26829cd7c0f$var$Xt(t), "ph-no-capture") && (g = !0), c.push($b090f26829cd7c0f$var$Pi(t, o, a, l));
        var e = function(t) {
            if (!$b090f26829cd7c0f$var$si(t)) return {};
            var i = {};
            return $b090f26829cd7c0f$var$J(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && $b090f26829cd7c0f$var$vi(r) && (i[e] = r);
                }
            }), i;
        }(t);
        $b090f26829cd7c0f$var$V(f, e);
    }), g) return {
        props: {},
        explicitNoCapture: g
    };
    if (a || ("a" === t.tagName.toLowerCase() || "button" === t.tagName.toLowerCase() ? c[0].$el_text = $b090f26829cd7c0f$var$ci(t) : c[0].$el_text = $b090f26829cd7c0f$var$Zt(t)), p) {
        var _, b;
        c[0].attr__href = p;
        var w = null == (_ = $b090f26829cd7c0f$var$wi(p)) ? void 0 : _.host, y = null == $b090f26829cd7c0f$var$i || null == (b = $b090f26829cd7c0f$var$i.location) ? void 0 : b.host;
        w && y && w !== y && (v = p);
    }
    return {
        props: $b090f26829cd7c0f$var$V({
            $event_type: n.type,
            $ce_version: 1
        }, h ? {} : {
            $elements: c
        }, {
            $elements_chain: $b090f26829cd7c0f$var$pi(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
class $b090f26829cd7c0f$var$Ti {
    constructor(t){
        this.i = !1, this.o = null, this.rageclicks = new $b090f26829cd7c0f$var$mi, this.h = !1, this.instance = t, this.m = null;
    }
    get S() {
        var t, i, e = $b090f26829cd7c0f$var$I(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
    }
    $() {
        if (this.isBrowserSupported()) {
            if ($b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$a) {
                var t = (t)=>{
                    t = t || (null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.event);
                    try {
                        this.k(t);
                    } catch (t) {
                        $b090f26829cd7c0f$var$xi.error("Failed to capture event", t);
                    }
                };
                if ($b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "submit", t, {
                    capture: !0
                }), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "change", t, {
                    capture: !0
                }), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "click", t, {
                    capture: !0
                }), this.S.capture_copied_text) {
                    var e = (t)=>{
                        t = t || (null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.event), this.k(t, $b090f26829cd7c0f$export$7bea938663611d9);
                    };
                    $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "copy", e, {
                        capture: !0
                    }), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "cut", e, {
                        capture: !0
                    });
                }
            }
        } else $b090f26829cd7c0f$var$xi.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this.i && (this.$(), this.i = !0);
    }
    onRemoteConfig(t) {
        t.elementsChainAsString && (this.h = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [$b090f26829cd7c0f$var$lt]: !!t.autocapture_opt_out
        }), this.o = !!t.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.m = t;
    }
    getElementSelectors(t) {
        var i, e = [];
        return null == (i = this.m) || i.forEach((i)=>{
            var r = null == $b090f26829cd7c0f$var$a ? void 0 : $b090f26829cd7c0f$var$a.querySelectorAll(i);
            null == r || r.forEach((r)=>{
                t === r && e.push(i);
            });
        }), e;
    }
    get isEnabled() {
        var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[$b090f26829cd7c0f$var$lt], r = this.o;
        if ($b090f26829cd7c0f$var$C(r) && !$b090f26829cd7c0f$var$A(e) && !this.instance.config.advanced_disable_decide) return !1;
        var s = null !== (i = this.o) && void 0 !== i ? i : !!e;
        return !!this.instance.config.autocapture && !s;
    }
    k(t, e) {
        if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
            var r, s = $b090f26829cd7c0f$var$ti(t);
            if ($b090f26829cd7c0f$var$Jt(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === t.type && t instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.k(t, "$rageclick");
            var n = e === $b090f26829cd7c0f$export$7bea938663611d9;
            if (s && $b090f26829cd7c0f$var$ri(s, t, this.S, n, n ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = $b090f26829cd7c0f$var$Ri(s, {
                    e: t,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.S.element_attribute_ignorelist,
                    elementsChainAsString: this.h
                });
                if (a) return !1;
                var l = this.getElementSelectors(s);
                if (l && l.length > 0 && (o.$element_selectors = l), e === $b090f26829cd7c0f$export$7bea938663611d9) {
                    var h, u = $b090f26829cd7c0f$var$Qt(null == $b090f26829cd7c0f$var$i || null == (h = $b090f26829cd7c0f$var$i.getSelection()) ? void 0 : h.toString()), d = t.type || "clipboard";
                    if (!u) return !1;
                    o.$selected_content = u, o.$copy_type = d;
                }
                return this.instance.capture(e, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return $b090f26829cd7c0f$var$E(null == $b090f26829cd7c0f$var$a ? void 0 : $b090f26829cd7c0f$var$a.querySelectorAll);
    }
}
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $b090f26829cd7c0f$var$F(t) && isFinite(t) && Math.floor(t) === t;
});
var $b090f26829cd7c0f$var$Mi = "0123456789abcdef";
class $b090f26829cd7c0f$var$Ci {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $b090f26829cd7c0f$var$Ci(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + $b090f26829cd7c0f$var$Mi.charAt(this.bytes[i] >>> 4) + $b090f26829cd7c0f$var$Mi.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $b090f26829cd7c0f$var$Ci(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class $b090f26829cd7c0f$var$Oi {
    constructor(){
        this.I = 0, this.P = 0, this.R = new $b090f26829cd7c0f$var$Di;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($b090f26829cd7c0f$var$R(t)) {
            this.I = 0;
            var i = this.generateOrAbort();
            if ($b090f26829cd7c0f$var$R(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.I) this.I = t, this.T();
        else {
            if (!(t + 1e4 > this.I)) return;
            this.P++, this.P > 4398046511103 && (this.I++, this.T());
        }
        return $b090f26829cd7c0f$var$Ci.fromFieldsV7(this.I, Math.trunc(this.P / Math.pow(2, 30)), this.P & Math.pow(2, 30) - 1, this.R.nextUint32());
    }
    T() {
        this.P = 1024 * this.R.nextUint32() + (1023 & this.R.nextUint32());
    }
}
var $b090f26829cd7c0f$var$Fi, $b090f26829cd7c0f$var$Ai = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$b090f26829cd7c0f$var$i && !$b090f26829cd7c0f$var$R($b090f26829cd7c0f$var$i.crypto) && crypto.getRandomValues && ($b090f26829cd7c0f$var$Ai = (t)=>crypto.getRandomValues(t));
class $b090f26829cd7c0f$var$Di {
    constructor(){
        this.M = new Uint32Array(8), this.C = 1 / 0;
    }
    nextUint32() {
        return this.C >= this.M.length && ($b090f26829cd7c0f$var$Ai(this.M), this.C = 0), this.M[this.C++];
    }
}
var $b090f26829cd7c0f$var$ji = ()=>$b090f26829cd7c0f$var$Li().toString(), $b090f26829cd7c0f$var$Li = ()=>($b090f26829cd7c0f$var$Fi || ($b090f26829cd7c0f$var$Fi = new $b090f26829cd7c0f$var$Oi)).generate(), $b090f26829cd7c0f$var$Ni = "Thu, 01 Jan 1970 00:00:00 GMT", $b090f26829cd7c0f$var$zi = "";
var $b090f26829cd7c0f$var$Ui = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $b090f26829cd7c0f$var$qi(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = $b090f26829cd7c0f$var$a), $b090f26829cd7c0f$var$zi) return $b090f26829cd7c0f$var$zi;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + $b090f26829cd7c0f$var$ji(), n = new RegExp("(^|;)\\s*" + s + "=1"); !$b090f26829cd7c0f$var$zi && r--;){
                var o = e.slice(r).join("."), l = s + "=1;domain=." + o;
                i.cookie = l, n.test(i.cookie) && (i.cookie = l + ";expires=" + $b090f26829cd7c0f$var$Ni, $b090f26829cd7c0f$var$zi = o);
            }
            return $b090f26829cd7c0f$var$zi;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($b090f26829cd7c0f$var$Ui);
                return i ? i[0] : "";
            })(t);
            r !== e && $b090f26829cd7c0f$var$N.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var $b090f26829cd7c0f$var$Bi, $b090f26829cd7c0f$var$Hi = {
    O: ()=>!!$b090f26829cd7c0f$var$a,
    F: function(t) {
        $b090f26829cd7c0f$var$N.error("cookieStore error: " + t);
    },
    A: function(t) {
        if ($b090f26829cd7c0f$var$a) {
            try {
                for(var i = t + "=", e = $b090f26829cd7c0f$var$a.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    D: function(t) {
        var i;
        try {
            i = JSON.parse($b090f26829cd7c0f$var$Hi.A(t)) || {};
        } catch (t) {}
        return i;
    },
    j: function(t, i, e, r, s) {
        if ($b090f26829cd7c0f$var$a) try {
            var n = "", o = "", l = $b090f26829cd7c0f$var$qi($b090f26829cd7c0f$var$a.location.hostname, r);
            if (e) {
                var h = new Date;
                h.setTime(h.getTime() + 24 * e * 3600000), n = "; expires=" + h.toUTCString();
            }
            s && (o = "; secure");
            var u = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + o;
            return u.length > 3686.4 && $b090f26829cd7c0f$var$N.warn("cookieStore warning: large cookie, len=" + u.length), $b090f26829cd7c0f$var$a.cookie = u, u;
        } catch (t) {
            return;
        }
    },
    L: function(t, i) {
        try {
            $b090f26829cd7c0f$var$Hi.j(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, $b090f26829cd7c0f$var$Wi = null, $b090f26829cd7c0f$var$Gi = {
    O: function() {
        if (!$b090f26829cd7c0f$var$C($b090f26829cd7c0f$var$Wi)) return $b090f26829cd7c0f$var$Wi;
        var t = !0;
        if ($b090f26829cd7c0f$var$R($b090f26829cd7c0f$var$i)) t = !1;
        else try {
            var e = "__mplssupport__";
            $b090f26829cd7c0f$var$Gi.j(e, "xyz"), '"xyz"' !== $b090f26829cd7c0f$var$Gi.A(e) && (t = !1), $b090f26829cd7c0f$var$Gi.L(e);
        } catch (i) {
            t = !1;
        }
        return t || $b090f26829cd7c0f$var$N.error("localStorage unsupported; falling back to cookie store"), $b090f26829cd7c0f$var$Wi = t, t;
    },
    F: function(t) {
        $b090f26829cd7c0f$var$N.error("localStorage error: " + t);
    },
    A: function(t) {
        try {
            return null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.localStorage.getItem(t);
        } catch (t) {
            $b090f26829cd7c0f$var$Gi.F(t);
        }
        return null;
    },
    D: function(t) {
        try {
            return JSON.parse($b090f26829cd7c0f$var$Gi.A(t)) || {};
        } catch (t) {}
        return null;
    },
    j: function(t, e) {
        try {
            null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.localStorage.setItem(t, JSON.stringify(e));
        } catch (t) {
            $b090f26829cd7c0f$var$Gi.F(t);
        }
    },
    L: function(t) {
        try {
            null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.localStorage.removeItem(t);
        } catch (t) {
            $b090f26829cd7c0f$var$Gi.F(t);
        }
    }
}, $b090f26829cd7c0f$var$Ji = [
    "distinct_id",
    $b090f26829cd7c0f$var$St,
    $b090f26829cd7c0f$var$$t,
    $b090f26829cd7c0f$var$zt,
    $b090f26829cd7c0f$var$Nt
], $b090f26829cd7c0f$var$Vi = $b090f26829cd7c0f$var$B({}, $b090f26829cd7c0f$var$Gi, {
    D: function(t) {
        try {
            var i = {};
            try {
                i = $b090f26829cd7c0f$var$Hi.D(t) || {};
            } catch (t) {}
            var e = $b090f26829cd7c0f$var$V(i, JSON.parse($b090f26829cd7c0f$var$Gi.A(t) || "{}"));
            return $b090f26829cd7c0f$var$Gi.j(t, e), e;
        } catch (t) {}
        return null;
    },
    j: function(t, i, e, r, s, n) {
        try {
            $b090f26829cd7c0f$var$Gi.j(t, i, void 0, void 0, n);
            var o = {};
            $b090f26829cd7c0f$var$Ji.forEach((t)=>{
                i[t] && (o[t] = i[t]);
            }), Object.keys(o).length && $b090f26829cd7c0f$var$Hi.j(t, o, e, r, s, n);
        } catch (t) {
            $b090f26829cd7c0f$var$Gi.F(t);
        }
    },
    L: function(t, e) {
        try {
            null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.localStorage.removeItem(t), $b090f26829cd7c0f$var$Hi.L(t, e);
        } catch (t) {
            $b090f26829cd7c0f$var$Gi.F(t);
        }
    }
}), $b090f26829cd7c0f$var$Ki = {}, $b090f26829cd7c0f$var$Yi = {
    O: function() {
        return !0;
    },
    F: function(t) {
        $b090f26829cd7c0f$var$N.error("memoryStorage error: " + t);
    },
    A: function(t) {
        return $b090f26829cd7c0f$var$Ki[t] || null;
    },
    D: function(t) {
        return $b090f26829cd7c0f$var$Ki[t] || null;
    },
    j: function(t, i) {
        $b090f26829cd7c0f$var$Ki[t] = i;
    },
    L: function(t) {
        delete $b090f26829cd7c0f$var$Ki[t];
    }
}, $b090f26829cd7c0f$var$Xi = null, $b090f26829cd7c0f$var$Qi = {
    O: function() {
        if (!$b090f26829cd7c0f$var$C($b090f26829cd7c0f$var$Xi)) return $b090f26829cd7c0f$var$Xi;
        if ($b090f26829cd7c0f$var$Xi = !0, $b090f26829cd7c0f$var$R($b090f26829cd7c0f$var$i)) $b090f26829cd7c0f$var$Xi = !1;
        else try {
            var t = "__support__";
            $b090f26829cd7c0f$var$Qi.j(t, "xyz"), '"xyz"' !== $b090f26829cd7c0f$var$Qi.A(t) && ($b090f26829cd7c0f$var$Xi = !1), $b090f26829cd7c0f$var$Qi.L(t);
        } catch (t) {
            $b090f26829cd7c0f$var$Xi = !1;
        }
        return $b090f26829cd7c0f$var$Xi;
    },
    F: function(t) {
        $b090f26829cd7c0f$var$N.error("sessionStorage error: ", t);
    },
    A: function(t) {
        try {
            return null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.sessionStorage.getItem(t);
        } catch (t) {
            $b090f26829cd7c0f$var$Qi.F(t);
        }
        return null;
    },
    D: function(t) {
        try {
            return JSON.parse($b090f26829cd7c0f$var$Qi.A(t)) || null;
        } catch (t) {}
        return null;
    },
    j: function(t, e) {
        try {
            null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.sessionStorage.setItem(t, JSON.stringify(e));
        } catch (t) {
            $b090f26829cd7c0f$var$Qi.F(t);
        }
    },
    L: function(t) {
        try {
            null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.sessionStorage.removeItem(t);
        } catch (t) {
            $b090f26829cd7c0f$var$Qi.F(t);
        }
    }
};
!function(t) {
    t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED";
}($b090f26829cd7c0f$var$Bi || ($b090f26829cd7c0f$var$Bi = {}));
class $b090f26829cd7c0f$var$Zi {
    constructor(t){
        this.N = t;
    }
    get S() {
        return this.N.config;
    }
    get consent() {
        return this.U() ? $b090f26829cd7c0f$var$Bi.DENIED : this.q;
    }
    isOptedOut() {
        return this.consent === $b090f26829cd7c0f$var$Bi.DENIED || this.consent === $b090f26829cd7c0f$var$Bi.PENDING && this.S.opt_out_capturing_by_default;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    optInOut(t) {
        this.B.j(this.H, t ? 1 : 0, this.S.cookie_expiration, this.S.cross_subdomain_cookie, this.S.secure_cookie);
    }
    reset() {
        this.B.L(this.H, this.S.cross_subdomain_cookie);
    }
    get H() {
        var { token: t, opt_out_capturing_cookie_prefix: i } = this.N.config;
        return (i || "__ph_opt_in_out_") + t;
    }
    get q() {
        var t = this.B.A(this.H);
        return "1" === t ? $b090f26829cd7c0f$var$Bi.GRANTED : "0" === t ? $b090f26829cd7c0f$var$Bi.DENIED : $b090f26829cd7c0f$var$Bi.PENDING;
    }
    get B() {
        if (!this.W) {
            var t = this.S.opt_out_capturing_persistence_type;
            this.W = "localStorage" === t ? $b090f26829cd7c0f$var$Gi : $b090f26829cd7c0f$var$Hi;
            var i = "localStorage" === t ? $b090f26829cd7c0f$var$Hi : $b090f26829cd7c0f$var$Gi;
            i.A(this.H) && (this.W.A(this.H) || this.optInOut("1" === i.A(this.H)), i.L(this.H, this.S.cross_subdomain_cookie));
        }
        return this.W;
    }
    U() {
        return !!this.S.respect_dnt && !!$b090f26829cd7c0f$var$rt([
            null == $b090f26829cd7c0f$var$o ? void 0 : $b090f26829cd7c0f$var$o.doNotTrack,
            null == $b090f26829cd7c0f$var$o ? void 0 : $b090f26829cd7c0f$var$o.msDoNotTrack,
            $b090f26829cd7c0f$var$c.doNotTrack
        ], (t)=>$b090f26829cd7c0f$var$m([
                !0,
                1,
                "1",
                "yes"
            ], t));
    }
}
var $b090f26829cd7c0f$var$te = $b090f26829cd7c0f$var$z("[Dead Clicks]"), $b090f26829cd7c0f$var$ie = ()=>!0, $b090f26829cd7c0f$var$ee = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property($b090f26829cd7c0f$var$vt)), r = t.instance.config.capture_dead_clicks;
    return $b090f26829cd7c0f$var$A(r) ? r : e;
};
class $b090f26829cd7c0f$var$re {
    get lazyLoadedDeadClicksAutocapture() {
        return this.G;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabled();
    }
    onRemoteConfig(t) {
        this.instance.persistence && this.instance.persistence.register({
            [$b090f26829cd7c0f$var$vt]: null == t ? void 0 : t.captureDeadClicks
        }), this.startIfEnabled();
    }
    startIfEnabled() {
        this.isEnabled(this) && this.J(()=>{
            this.V();
        });
    }
    J(t) {
        var i, e;
        null != (i = $b090f26829cd7c0f$var$c.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $b090f26829cd7c0f$var$te.error("failed to load script", i) : t();
        });
    }
    V() {
        var t;
        if ($b090f26829cd7c0f$var$a) {
            if (!this.G && null != (t = $b090f26829cd7c0f$var$c.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = $b090f26829cd7c0f$var$I(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.G = $b090f26829cd7c0f$var$c.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.G.start($b090f26829cd7c0f$var$a), $b090f26829cd7c0f$var$te.info("starting...");
            }
        } else $b090f26829cd7c0f$var$te.error("`document` not found. Cannot start.");
    }
    stop() {
        this.G && (this.G.stop(), this.G = void 0, $b090f26829cd7c0f$var$te.info("stopping..."));
    }
}
var $b090f26829cd7c0f$var$se = $b090f26829cd7c0f$var$z("[ExceptionAutocapture]");
class $b090f26829cd7c0f$var$ne {
    constructor(t){
        var e;
        this.K = ()=>{
            var t;
            if ($b090f26829cd7c0f$var$i && this.isEnabled && null != (t = $b090f26829cd7c0f$var$c.__PosthogExtensions__) && t.errorWrappingFunctions) {
                var e = $b090f26829cd7c0f$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $b090f26829cd7c0f$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $b090f26829cd7c0f$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.Y && this.config.capture_unhandled_errors && (this.Y = e(this.captureException.bind(this))), !this.X && this.config.capture_unhandled_rejections && (this.X = r(this.captureException.bind(this))), !this.Z && this.config.capture_console_errors && (this.Z = s(this.captureException.bind(this)));
                } catch (t) {
                    $b090f26829cd7c0f$var$se.error("failed to start", t), this.tt();
                }
            }
        }, this.instance = t, this.remoteEnabled = !(null == (e = this.instance.persistence) || !e.props[$b090f26829cd7c0f$var$ut]), this.config = this.it(), this.startIfEnabled();
    }
    it() {
        var t = this.instance.config.capture_exceptions, i = {
            capture_unhandled_errors: !1,
            capture_unhandled_rejections: !1,
            capture_console_errors: !1
        };
        return $b090f26829cd7c0f$var$I(t) ? i = $b090f26829cd7c0f$var$B({}, i, t) : ($b090f26829cd7c0f$var$R(t) ? this.remoteEnabled : t) && (i = $b090f26829cd7c0f$var$B({}, i, {
            capture_unhandled_errors: !0,
            capture_unhandled_rejections: !0
        })), i;
    }
    get isEnabled() {
        return this.config.capture_console_errors || this.config.capture_unhandled_errors || this.config.capture_unhandled_rejections;
    }
    startIfEnabled() {
        this.isEnabled && ($b090f26829cd7c0f$var$se.info("enabled"), this.J(this.K));
    }
    J(t) {
        var i, e;
        null != (i = $b090f26829cd7c0f$var$c.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "exception-autocapture", (i)=>{
            if (i) return $b090f26829cd7c0f$var$se.error("failed to load script", i);
            t();
        });
    }
    tt() {
        var t, i, e;
        null == (t = this.Y) || t.call(this), this.Y = void 0, null == (i = this.X) || i.call(this), this.X = void 0, null == (e = this.Z) || e.call(this), this.Z = void 0;
    }
    onRemoteConfig(t) {
        var i = t.autocaptureExceptions;
        this.remoteEnabled = !!i || !1, this.config = this.it(), this.instance.persistence && this.instance.persistence.register({
            [$b090f26829cd7c0f$var$ut]: this.remoteEnabled
        }), this.startIfEnabled();
    }
    captureException(t) {
        var i = this.instance.requestRouter.endpointFor("ui");
        t.$exception_personURL = i + "/project/" + this.instance.config.token + "/person/" + this.instance.get_distinct_id(), this.instance.exceptions.sendExceptionEvent(t);
    }
}
function $b090f26829cd7c0f$var$oe(t) {
    return !$b090f26829cd7c0f$var$R(Event) && $b090f26829cd7c0f$var$ae(t, Event);
}
function $b090f26829cd7c0f$var$ae(t, i) {
    try {
        return t instanceof i;
    } catch (t) {
        return !1;
    }
}
function $b090f26829cd7c0f$var$le(t) {
    switch(Object.prototype.toString.call(t)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object DOMError]":
            return !0;
        default:
            return $b090f26829cd7c0f$var$ae(t, Error);
    }
}
function $b090f26829cd7c0f$var$he(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function $b090f26829cd7c0f$var$ue(t) {
    return $b090f26829cd7c0f$var$he(t, "DOMError");
}
var $b090f26829cd7c0f$var$de = /\(error: (.*)\)/, $b090f26829cd7c0f$var$ve = 50, $b090f26829cd7c0f$var$ce = "?";
function $b090f26829cd7c0f$var$fe(t, i, e, r) {
    var s = {
        platform: "web:javascript",
        filename: t,
        function: "<anonymous>" === i ? $b090f26829cd7c0f$var$ce : i,
        in_app: !0
    };
    return $b090f26829cd7c0f$var$R(e) || (s.lineno = e), $b090f26829cd7c0f$var$R(r) || (s.colno = r), s;
}
var $b090f26829cd7c0f$var$pe = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $b090f26829cd7c0f$var$ge = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $b090f26829cd7c0f$var$_e = /\((\S*)(?::(\d+))(?::(\d+))\)/, $b090f26829cd7c0f$var$me = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $b090f26829cd7c0f$var$be = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $b090f26829cd7c0f$var$we = function() {
    for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
    var r = i.sort((t, i)=>t[0] - i[0]).map((t)=>t[1]);
    return function(t, i) {
        void 0 === i && (i = 0);
        for(var e = [], s = t.split("\n"), n = i; n < s.length; n++){
            var o = s[n];
            if (!(o.length > 1024)) {
                var a = $b090f26829cd7c0f$var$de.test(o) ? o.replace($b090f26829cd7c0f$var$de, "$1") : o;
                if (!a.match(/\S*Error: /)) {
                    for (var l of r){
                        var h = l(a);
                        if (h) {
                            e.push(h);
                            break;
                        }
                    }
                    if (e.length >= $b090f26829cd7c0f$var$ve) break;
                }
            }
        }
        return function(t) {
            if (!t.length) return [];
            var i = Array.from(t);
            return i.reverse(), i.slice(0, $b090f26829cd7c0f$var$ve).map((t)=>$b090f26829cd7c0f$var$B({}, t, {
                    filename: t.filename || $b090f26829cd7c0f$var$ye(i).filename,
                    function: t.function || $b090f26829cd7c0f$var$ce
                }));
        }(e);
    };
}(...[
    [
        30,
        (t)=>{
            var i = $b090f26829cd7c0f$var$pe.exec(t);
            if (i) {
                var [, e, r, s] = i;
                return $b090f26829cd7c0f$var$fe(e, $b090f26829cd7c0f$var$ce, +r, +s);
            }
            var n = $b090f26829cd7c0f$var$ge.exec(t);
            if (n) {
                if (n[2] && 0 === n[2].indexOf("eval")) {
                    var o = $b090f26829cd7c0f$var$_e.exec(n[2]);
                    o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
                }
                var [a, l] = $b090f26829cd7c0f$var$xe(n[1] || $b090f26829cd7c0f$var$ce, n[2]);
                return $b090f26829cd7c0f$var$fe(l, a, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
            }
        }
    ],
    [
        50,
        (t)=>{
            var i = $b090f26829cd7c0f$var$me.exec(t);
            if (i) {
                if (i[3] && i[3].indexOf(" > eval") > -1) {
                    var e = $b090f26829cd7c0f$var$be.exec(i[3]);
                    e && (i[1] = i[1] || "eval", i[3] = e[1], i[4] = e[2], i[5] = "");
                }
                var r = i[3], s = i[1] || $b090f26829cd7c0f$var$ce;
                return [s, r] = $b090f26829cd7c0f$var$xe(s, r), $b090f26829cd7c0f$var$fe(r, s, i[4] ? +i[4] : void 0, i[5] ? +i[5] : void 0);
            }
        }
    ]
]);
function $b090f26829cd7c0f$var$ye(t) {
    return t[t.length - 1] || {};
}
var $b090f26829cd7c0f$var$Se, $b090f26829cd7c0f$var$$e, $b090f26829cd7c0f$var$ke, $b090f26829cd7c0f$var$xe = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $b090f26829cd7c0f$var$ce,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
};
var $b090f26829cd7c0f$var$Ee = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
function $b090f26829cd7c0f$var$Ie(t, i) {
    void 0 === i && (i = 0);
    var e = t.stacktrace || t.stack || "", r = function(t) {
        if (t && $b090f26829cd7c0f$var$Pe.test(t.message)) return 1;
        return 0;
    }(t);
    try {
        var s = $b090f26829cd7c0f$var$we, n = function(t, i) {
            var e = function(t) {
                var i = globalThis._posthogChunkIds;
                if (!i) return {};
                var e = Object.keys(i);
                return $b090f26829cd7c0f$var$ke && e.length === $b090f26829cd7c0f$var$$e || ($b090f26829cd7c0f$var$$e = e.length, $b090f26829cd7c0f$var$ke = e.reduce((e, r)=>{
                    $b090f26829cd7c0f$var$Se || ($b090f26829cd7c0f$var$Se = {});
                    var s = $b090f26829cd7c0f$var$Se[r];
                    if (s) e[s[0]] = s[1];
                    else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                        var a = n[o], l = null == a ? void 0 : a.filename, h = i[r];
                        if (l && h) {
                            e[l] = h, $b090f26829cd7c0f$var$Se[r] = [
                                l,
                                h
                            ];
                            break;
                        }
                    }
                    return e;
                }, {})), $b090f26829cd7c0f$var$ke;
            }(i);
            return t.forEach((t)=>{
                t.filename && (t.chunk_id = e[t.filename]);
            }), t;
        }(s(e, r), s);
        return n.slice(0, n.length - i);
    } catch (t) {}
    return [];
}
var $b090f26829cd7c0f$var$Pe = /Minified React error #\d+;/i;
function $b090f26829cd7c0f$var$Re(t, i) {
    var e, r, s = $b090f26829cd7c0f$var$Ie(t), n = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, o = null !== (r = null == i ? void 0 : i.synthetic) && void 0 !== r && r;
    return {
        type: null != i && i.overrideExceptionType ? i.overrideExceptionType : t.name,
        value: function(t) {
            var i = t.message;
            if (i.error && "string" == typeof i.error.message) return String(i.error.message);
            return String(i);
        }(t),
        stacktrace: {
            frames: s,
            type: "raw"
        },
        mechanism: {
            handled: n,
            synthetic: o
        }
    };
}
function $b090f26829cd7c0f$var$Te(t, i) {
    var e = $b090f26829cd7c0f$var$Re(t, i);
    return t.cause && $b090f26829cd7c0f$var$le(t.cause) && t.cause !== t ? [
        e,
        ...$b090f26829cd7c0f$var$Te(t.cause, {
            handled: null == i ? void 0 : i.handled,
            synthetic: null == i ? void 0 : i.synthetic
        })
    ] : [
        e
    ];
}
function $b090f26829cd7c0f$var$Me(t, i) {
    return {
        $exception_list: $b090f26829cd7c0f$var$Te(t, i),
        $exception_level: "error"
    };
}
function $b090f26829cd7c0f$var$Ce(t, i) {
    var e, r, s, n = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, o = null === (r = null == i ? void 0 : i.synthetic) || void 0 === r || r, a = {
        type: null != i && i.overrideExceptionType ? i.overrideExceptionType : null !== (s = null == i ? void 0 : i.defaultExceptionType) && void 0 !== s ? s : "Error",
        value: t || (null == i ? void 0 : i.defaultExceptionMessage),
        mechanism: {
            handled: n,
            synthetic: o
        }
    };
    if (null != i && i.syntheticException) {
        var l = $b090f26829cd7c0f$var$Ie(i.syntheticException, 1);
        l.length && (a.stacktrace = {
            frames: l,
            type: "raw"
        });
    }
    return {
        $exception_list: [
            a
        ],
        $exception_level: "error"
    };
}
function $b090f26829cd7c0f$var$Oe(t) {
    return $b090f26829cd7c0f$var$T(t) && !$b090f26829cd7c0f$var$M(t) && $b090f26829cd7c0f$export$9dd8f6ec3b5e6004.indexOf(t) >= 0;
}
function $b090f26829cd7c0f$var$Fe(t, i) {
    var e, r, s = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, n = null === (r = null == i ? void 0 : i.synthetic) || void 0 === r || r, o = null != i && i.overrideExceptionType ? i.overrideExceptionType : $b090f26829cd7c0f$var$oe(t) ? t.constructor.name : "Error", a = "Non-Error 'exception' captured with keys: " + function(t, i) {
        void 0 === i && (i = 40);
        var e = Object.keys(t);
        if (e.sort(), !e.length) return "[object has no keys]";
        for(var r = e.length; r > 0; r--){
            var s = e.slice(0, r).join(", ");
            if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
        }
        return "";
    }(t), l = {
        type: o,
        value: a,
        mechanism: {
            handled: s,
            synthetic: n
        }
    };
    if (null != i && i.syntheticException) {
        var h = $b090f26829cd7c0f$var$Ie(null == i ? void 0 : i.syntheticException, 1);
        h.length && (l.stacktrace = {
            frames: h,
            type: "raw"
        });
    }
    return {
        $exception_list: [
            l
        ],
        $exception_level: $b090f26829cd7c0f$var$Oe(t.level) ? t.level : "error"
    };
}
function $b090f26829cd7c0f$var$Ae(t, i) {
    var { error: e, event: r } = t, s = {
        $exception_list: []
    }, n = e || r;
    if ($b090f26829cd7c0f$var$ue(n) || function(t) {
        return $b090f26829cd7c0f$var$he(t, "DOMException");
    }(n)) {
        var o = n;
        if (function(t) {
            return "stack" in t;
        }(n)) s = $b090f26829cd7c0f$var$Me(n, i);
        else {
            var a = o.name || ($b090f26829cd7c0f$var$ue(o) ? "DOMError" : "DOMException"), l = o.message ? a + ": " + o.message : a;
            s = $b090f26829cd7c0f$var$Ce(l, $b090f26829cd7c0f$var$B({}, i, {
                overrideExceptionType: $b090f26829cd7c0f$var$ue(o) ? "DOMError" : "DOMException",
                defaultExceptionMessage: l
            }));
        }
        return "code" in o && (s.$exception_DOMException_code = "" + o.code), s;
    }
    if (function(t) {
        return $b090f26829cd7c0f$var$he(t, "ErrorEvent");
    }(n) && n.error) return $b090f26829cd7c0f$var$Me(n.error, i);
    if ($b090f26829cd7c0f$var$le(n)) return $b090f26829cd7c0f$var$Me(n, i);
    if (function(t) {
        return $b090f26829cd7c0f$var$he(t, "Object");
    }(n) || $b090f26829cd7c0f$var$oe(n)) return $b090f26829cd7c0f$var$Fe(n, i);
    if ($b090f26829cd7c0f$var$R(e) && $b090f26829cd7c0f$var$T(r)) {
        var h = "Error", u = r, d = r.match($b090f26829cd7c0f$var$Ee);
        return d && (h = d[1], u = d[2]), $b090f26829cd7c0f$var$Ce(u, $b090f26829cd7c0f$var$B({}, i, {
            overrideExceptionType: h,
            defaultExceptionMessage: u
        }));
    }
    return $b090f26829cd7c0f$var$Ce(n, i);
}
function $b090f26829cd7c0f$var$De(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return $b090f26829cd7c0f$var$E(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
class $b090f26829cd7c0f$var$je {
    constructor(t){
        var e;
        this.N = t, this.et = (null == $b090f26829cd7c0f$var$i || null == (e = $b090f26829cd7c0f$var$i.location) ? void 0 : e.pathname) || "";
    }
    get isEnabled() {
        return "history_change" === this.N.config.capture_pageview;
    }
    startIfEnabled() {
        this.isEnabled && ($b090f26829cd7c0f$var$N.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
    }
    stop() {
        this.rt && this.rt(), this.rt = void 0, $b090f26829cd7c0f$var$N.info("History API monitoring stopped");
    }
    monitorHistoryChanges() {
        var t, e;
        if ($b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$i.history) {
            var r = this;
            null != (t = $b090f26829cd7c0f$var$i.history.pushState) && t.__posthog_wrapped__ || $b090f26829cd7c0f$var$De($b090f26829cd7c0f$var$i.history, "pushState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r.st("pushState");
                }), null != (e = $b090f26829cd7c0f$var$i.history.replaceState) && e.__posthog_wrapped__ || $b090f26829cd7c0f$var$De($b090f26829cd7c0f$var$i.history, "replaceState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r.st("replaceState");
                }), this.nt();
        }
    }
    st(t) {
        try {
            var e, r = null == $b090f26829cd7c0f$var$i || null == (e = $b090f26829cd7c0f$var$i.location) ? void 0 : e.pathname;
            if (!r) return;
            r !== this.et && this.isEnabled && this.N.capture("$pageview", {
                navigation_type: t
            }), this.et = r;
        } catch (i) {
            $b090f26829cd7c0f$var$N.error("Error capturing " + t + " pageview", i);
        }
    }
    nt() {
        if (!this.rt) {
            var t = ()=>{
                this.st("popstate");
            };
            $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "popstate", t), this.rt = ()=>{
                $b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$i.removeEventListener("popstate", t);
            };
        }
    }
}
function $b090f26829cd7c0f$var$Le(t) {
    var i, e;
    return (null == (i = JSON.stringify(t, (e = [], function(t, i) {
        if ($b090f26829cd7c0f$var$I(i)) {
            for(; e.length > 0 && e[e.length - 1] !== this;)e.pop();
            return e.includes(i) ? "[Circular]" : (e.push(i), i);
        }
        return i;
    }))) ? void 0 : i.length) || 0;
}
function $b090f26829cd7c0f$var$Ne(t, i) {
    if (void 0 === i && (i = 6606028.8), t.size >= i && t.data.length > 1) {
        var e = Math.floor(t.data.length / 2), r = t.data.slice(0, e), s = t.data.slice(e);
        return [
            $b090f26829cd7c0f$var$Ne({
                size: $b090f26829cd7c0f$var$Le(r),
                data: r,
                sessionId: t.sessionId,
                windowId: t.windowId
            }),
            $b090f26829cd7c0f$var$Ne({
                size: $b090f26829cd7c0f$var$Le(s),
                data: s,
                sessionId: t.sessionId,
                windowId: t.windowId
            })
        ].flatMap((t)=>t);
    }
    return [
        t
    ];
}
var $b090f26829cd7c0f$var$ze = ((t)=>(t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))($b090f26829cd7c0f$var$ze || {}), $b090f26829cd7c0f$var$Ue = ((t)=>(t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))($b090f26829cd7c0f$var$Ue || {}), $b090f26829cd7c0f$var$qe = "[SessionRecording]", $b090f26829cd7c0f$var$Be = "redacted", $b090f26829cd7c0f$var$He = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: (t)=>t,
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6,
    payloadHostDenyList: [
        ".lr-ingest.io",
        ".ingest.sentry.io",
        ".clarity.ms",
        "analytics.google.com"
    ]
}, $b090f26829cd7c0f$var$We = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $b090f26829cd7c0f$var$Ge = [
    "password",
    "secret",
    "passwd",
    "api_key",
    "apikey",
    "auth",
    "credentials",
    "mysql_pwd",
    "privatekey",
    "private_key",
    "token"
], $b090f26829cd7c0f$var$Je = [
    "/s/",
    "/e/",
    "/i/"
];
function $b090f26829cd7c0f$var$Ve(t, i, e, r) {
    if ($b090f26829cd7c0f$var$O(t)) return t;
    var s = (null == i ? void 0 : i["content-length"]) || function(t) {
        return new Blob([
            t
        ]).size;
    }(t);
    return $b090f26829cd7c0f$var$T(s) && (s = parseInt(s)), s > e ? $b090f26829cd7c0f$var$qe + " " + r + " body too large to record (" + s + " bytes)" : t;
}
function $b090f26829cd7c0f$var$Ke(t, i) {
    if ($b090f26829cd7c0f$var$O(t)) return t;
    var e = t;
    return $b090f26829cd7c0f$var$vi(e, !1) || (e = $b090f26829cd7c0f$var$qe + " " + i + " body " + $b090f26829cd7c0f$var$Be), $b090f26829cd7c0f$var$J($b090f26829cd7c0f$var$Ge, (t)=>{
        var r, s;
        null != (r = e) && r.length && -1 !== (null == (s = e) ? void 0 : s.indexOf(t)) && (e = $b090f26829cd7c0f$var$qe + " " + i + " body " + $b090f26829cd7c0f$var$Be + " as might contain: " + t);
    }), e;
}
var $b090f26829cd7c0f$var$Ye = (t, i)=>{
    var e, r, s, n = {
        payloadSizeLimitBytes: $b090f26829cd7c0f$var$He.payloadSizeLimitBytes,
        performanceEntryTypeToObserve: [
            ...$b090f26829cd7c0f$var$He.performanceEntryTypeToObserve
        ],
        payloadHostDenyList: [
            ...i.payloadHostDenyList || [],
            ...$b090f26829cd7c0f$var$He.payloadHostDenyList
        ]
    }, o = !1 !== t.session_recording.recordHeaders && i.recordHeaders, a = !1 !== t.session_recording.recordBody && i.recordBody, l = !1 !== t.capture_performance && i.recordPerformance, h = (e = n, s = Math.min(1e6, null !== (r = e.payloadSizeLimitBytes) && void 0 !== r ? r : 1e6), (t)=>(null != t && t.requestBody && (t.requestBody = $b090f26829cd7c0f$var$Ve(t.requestBody, t.requestHeaders, s, "Request")), null != t && t.responseBody && (t.responseBody = $b090f26829cd7c0f$var$Ve(t.responseBody, t.responseHeaders, s, "Response")), t)), u = (i)=>{
        var e, r;
        return h(((t, i)=>{
            var e, r = $b090f26829cd7c0f$var$wi(t.name), s = 0 === i.indexOf("http") ? null == (e = $b090f26829cd7c0f$var$wi(i)) ? void 0 : e.pathname : i;
            "/" === s && (s = "");
            var n = null == r ? void 0 : r.pathname.replace(s || "", "");
            if (!(r && n && $b090f26829cd7c0f$var$Je.some((t)=>0 === n.indexOf(t)))) return t;
        })((r = (e = i).requestHeaders, $b090f26829cd7c0f$var$O(r) || $b090f26829cd7c0f$var$J(Object.keys(null != r ? r : {}), (t)=>{
            $b090f26829cd7c0f$var$We.includes(t.toLowerCase()) && (r[t] = $b090f26829cd7c0f$var$Be);
        }), e), t.api_host));
    }, d = $b090f26829cd7c0f$var$E(t.session_recording.maskNetworkRequestFn);
    return d && $b090f26829cd7c0f$var$E(t.session_recording.maskCapturedNetworkRequestFn) && $b090f26829cd7c0f$var$N.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), d && (t.session_recording.maskCapturedNetworkRequestFn = (i)=>{
        var e = t.session_recording.maskNetworkRequestFn({
            url: i.name
        });
        return $b090f26829cd7c0f$var$B({}, i, {
            name: null == e ? void 0 : e.url
        });
    }), n.maskRequestFn = $b090f26829cd7c0f$var$E(t.session_recording.maskCapturedNetworkRequestFn) ? (i)=>{
        var e, r = u(i);
        return r && null !== (e = null == t.session_recording.maskCapturedNetworkRequestFn ? void 0 : t.session_recording.maskCapturedNetworkRequestFn(r)) && void 0 !== e ? e : void 0;
    } : (t)=>(function(t) {
            if (!$b090f26829cd7c0f$var$R(t)) return t.requestBody = $b090f26829cd7c0f$var$Ke(t.requestBody, "Request"), t.responseBody = $b090f26829cd7c0f$var$Ke(t.responseBody, "Response"), t;
        })(u(t)), $b090f26829cd7c0f$var$B({}, $b090f26829cd7c0f$var$He, n, {
        recordHeaders: o,
        recordBody: a,
        recordPerformance: l,
        recordInitialRequests: l
    });
};
function $b090f26829cd7c0f$var$Xe(t, i, e, r, s) {
    return i > e && ($b090f26829cd7c0f$var$N.warn("min cannot be greater than max."), i = e), $b090f26829cd7c0f$var$F(t) ? t > e ? (r && $b090f26829cd7c0f$var$N.warn(r + " cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r && $b090f26829cd7c0f$var$N.warn(r + " cannot be less than min: " + i + ". Using min value instead."), i) : t : (r && $b090f26829cd7c0f$var$N.warn(r + " must be a number. using max or fallback. max: " + e + ", fallback: " + s), $b090f26829cd7c0f$var$Xe(s || e, i, e, r));
}
class $b090f26829cd7c0f$var$Qe {
    constructor(t, i){
        var e, r;
        void 0 === i && (i = {}), this.ot = 100, this.lt = 10, this.ht = {}, this.ut = {}, this.dt = ()=>{
            Object.keys(this.ht).forEach((t)=>{
                this.ht[t] = this.ht[t] + this.lt, this.ht[t] >= this.ot && delete this.ht[t];
            });
        }, this.vt = (t)=>{
            var i = this._rrweb.mirror.getNode(t);
            if ("svg" !== (null == i ? void 0 : i.nodeName) && i instanceof Element) {
                var e = i.closest("svg");
                if (e) return [
                    this._rrweb.mirror.getId(e),
                    e
                ];
            }
            return [
                t,
                i
            ];
        }, this.ct = (t)=>{
            var i, e, r, s, n, o, a, l;
            return (null !== (i = null == (e = t.removes) ? void 0 : e.length) && void 0 !== i ? i : 0) + (null !== (r = null == (s = t.attributes) ? void 0 : s.length) && void 0 !== r ? r : 0) + (null !== (n = null == (o = t.texts) ? void 0 : o.length) && void 0 !== n ? n : 0) + (null !== (a = null == (l = t.adds) ? void 0 : l.length) && void 0 !== a ? a : 0);
        }, this.throttleMutations = (t)=>{
            if (3 !== t.type || 0 !== t.data.source) return t;
            var i = t.data, e = this.ct(i);
            i.attributes && (i.attributes = i.attributes.filter((t)=>{
                var i, e, r, [s, n] = this.vt(t.id);
                if (0 === this.ht[s]) return !1;
                (this.ht[s] = null !== (i = this.ht[s]) && void 0 !== i ? i : this.ot, this.ht[s] = Math.max(this.ht[s] - 1, 0), 0 === this.ht[s]) && (this.ut[s] || (this.ut[s] = !0, null == (e = (r = this.ft).onBlockedNode) || e.call(r, s, n)));
                return t;
            }));
            var r = this.ct(i);
            return 0 !== r || e === r ? t : void 0;
        }, this._rrweb = t, this.ft = i, this.lt = $b090f26829cd7c0f$var$Xe(null !== (e = this.ft.refillRate) && void 0 !== e ? e : this.lt, 0, 100, "mutation throttling refill rate"), this.ot = $b090f26829cd7c0f$var$Xe(null !== (r = this.ft.bucketSize) && void 0 !== r ? r : this.ot, 0, 100, "mutation throttling bucket size"), setInterval(()=>{
            this.dt();
        }, 1e3);
    }
}
var $b090f26829cd7c0f$var$Ze = Uint8Array, $b090f26829cd7c0f$var$tr = Uint16Array, $b090f26829cd7c0f$var$ir = Uint32Array, $b090f26829cd7c0f$var$er = new $b090f26829cd7c0f$var$Ze([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $b090f26829cd7c0f$var$rr = new $b090f26829cd7c0f$var$Ze([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $b090f26829cd7c0f$var$sr = new $b090f26829cd7c0f$var$Ze([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $b090f26829cd7c0f$var$nr = function(t, i) {
    for(var e = new $b090f26829cd7c0f$var$tr(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new $b090f26829cd7c0f$var$ir(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, $b090f26829cd7c0f$var$or = $b090f26829cd7c0f$var$nr($b090f26829cd7c0f$var$er, 2), $b090f26829cd7c0f$var$ar = $b090f26829cd7c0f$var$or[0], $b090f26829cd7c0f$var$lr = $b090f26829cd7c0f$var$or[1];
$b090f26829cd7c0f$var$ar[28] = 258, $b090f26829cd7c0f$var$lr[258] = 28;
for(var $b090f26829cd7c0f$var$hr = $b090f26829cd7c0f$var$nr($b090f26829cd7c0f$var$rr, 0)[1], $b090f26829cd7c0f$var$ur = new $b090f26829cd7c0f$var$tr(32768), $b090f26829cd7c0f$var$dr = 0; $b090f26829cd7c0f$var$dr < 32768; ++$b090f26829cd7c0f$var$dr){
    var $b090f26829cd7c0f$var$vr = (43690 & $b090f26829cd7c0f$var$dr) >>> 1 | (21845 & $b090f26829cd7c0f$var$dr) << 1;
    $b090f26829cd7c0f$var$vr = (61680 & ($b090f26829cd7c0f$var$vr = (52428 & $b090f26829cd7c0f$var$vr) >>> 2 | (13107 & $b090f26829cd7c0f$var$vr) << 2)) >>> 4 | (3855 & $b090f26829cd7c0f$var$vr) << 4, $b090f26829cd7c0f$var$ur[$b090f26829cd7c0f$var$dr] = ((65280 & $b090f26829cd7c0f$var$vr) >>> 8 | (255 & $b090f26829cd7c0f$var$vr) << 8) >>> 1;
}
var $b090f26829cd7c0f$var$cr = function(t, i, e) {
    for(var r = t.length, s = 0, n = new $b090f26829cd7c0f$var$tr(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new $b090f26829cd7c0f$var$tr(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new $b090f26829cd7c0f$var$tr(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var h = s << 4 | t[s], u = i - t[s], d = a[t[s] - 1]++ << u, v = d | (1 << u) - 1; d <= v; ++d)o[$b090f26829cd7c0f$var$ur[d] >>> l] = h;
    } else for(o = new $b090f26829cd7c0f$var$tr(r), s = 0; s < r; ++s)o[s] = $b090f26829cd7c0f$var$ur[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $b090f26829cd7c0f$var$fr = new $b090f26829cd7c0f$var$Ze(288);
for($b090f26829cd7c0f$var$dr = 0; $b090f26829cd7c0f$var$dr < 144; ++$b090f26829cd7c0f$var$dr)$b090f26829cd7c0f$var$fr[$b090f26829cd7c0f$var$dr] = 8;
for($b090f26829cd7c0f$var$dr = 144; $b090f26829cd7c0f$var$dr < 256; ++$b090f26829cd7c0f$var$dr)$b090f26829cd7c0f$var$fr[$b090f26829cd7c0f$var$dr] = 9;
for($b090f26829cd7c0f$var$dr = 256; $b090f26829cd7c0f$var$dr < 280; ++$b090f26829cd7c0f$var$dr)$b090f26829cd7c0f$var$fr[$b090f26829cd7c0f$var$dr] = 7;
for($b090f26829cd7c0f$var$dr = 280; $b090f26829cd7c0f$var$dr < 288; ++$b090f26829cd7c0f$var$dr)$b090f26829cd7c0f$var$fr[$b090f26829cd7c0f$var$dr] = 8;
var $b090f26829cd7c0f$var$pr = new $b090f26829cd7c0f$var$Ze(32);
for($b090f26829cd7c0f$var$dr = 0; $b090f26829cd7c0f$var$dr < 32; ++$b090f26829cd7c0f$var$dr)$b090f26829cd7c0f$var$pr[$b090f26829cd7c0f$var$dr] = 5;
var $b090f26829cd7c0f$var$gr = $b090f26829cd7c0f$var$cr($b090f26829cd7c0f$var$fr, 9, 0), $b090f26829cd7c0f$var$_r = $b090f26829cd7c0f$var$cr($b090f26829cd7c0f$var$pr, 5, 0), $b090f26829cd7c0f$var$mr = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $b090f26829cd7c0f$var$br = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof $b090f26829cd7c0f$var$tr ? $b090f26829cd7c0f$var$tr : t instanceof $b090f26829cd7c0f$var$ir ? $b090f26829cd7c0f$var$ir : $b090f26829cd7c0f$var$Ze)(e - i);
    return r.set(t.subarray(i, e)), r;
}, $b090f26829cd7c0f$var$wr = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, $b090f26829cd7c0f$var$yr = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, $b090f26829cd7c0f$var$Sr = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new $b090f26829cd7c0f$var$Ze(0),
        0
    ];
    if (1 == s) {
        var o = new $b090f26829cd7c0f$var$Ze(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], h = 0, u = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; u != s - 1;)a = e[e[h].f < e[d].f ? h++ : d++], l = e[h != u && e[h].f < e[d].f ? h++ : d++], e[u++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new $b090f26829cd7c0f$var$tr(v + 1), f = $b090f26829cd7c0f$var$$r(e[u - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, g = f - i, _ = 1 << g;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += _ - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= g; p > 0;){
            var b = n[r].s;
            c[b] < i ? p -= 1 << i - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var w = n[r].s;
            c[w] == i && (--c[w], ++p);
        }
        f = i;
    }
    return [
        new $b090f26829cd7c0f$var$Ze(c),
        f
    ];
}, $b090f26829cd7c0f$var$$r = function(t, i, e) {
    return -1 == t.s ? Math.max($b090f26829cd7c0f$var$$r(t.l, i, e + 1), $b090f26829cd7c0f$var$$r(t.r, i, e + 1)) : i[t.s] = e;
}, $b090f26829cd7c0f$var$kr = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $b090f26829cd7c0f$var$tr(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, $b090f26829cd7c0f$var$xr = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, $b090f26829cd7c0f$var$Er = function(t, i, e) {
    var r = e.length, s = $b090f26829cd7c0f$var$mr(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, $b090f26829cd7c0f$var$Ir = function(t, i, e, r, s, n, o, a, l, h, u) {
    $b090f26829cd7c0f$var$wr(i, u++, e), ++s[256];
    for(var d = $b090f26829cd7c0f$var$Sr(s, 15), v = d[0], c = d[1], f = $b090f26829cd7c0f$var$Sr(n, 15), p = f[0], g = f[1], _ = $b090f26829cd7c0f$var$kr(v), m = _[0], b = _[1], w = $b090f26829cd7c0f$var$kr(p), y = w[0], S = w[1], $ = new $b090f26829cd7c0f$var$tr(19), k = 0; k < m.length; ++k)$[31 & m[k]]++;
    for(k = 0; k < y.length; ++k)$[31 & y[k]]++;
    for(var x = $b090f26829cd7c0f$var$Sr($, 7), E = x[0], I = x[1], P = 19; P > 4 && !E[$b090f26829cd7c0f$var$sr[P - 1]]; --P);
    var R, T, M, C, O = h + 5 << 3, F = $b090f26829cd7c0f$var$xr(s, $b090f26829cd7c0f$var$fr) + $b090f26829cd7c0f$var$xr(n, $b090f26829cd7c0f$var$pr) + o, A = $b090f26829cd7c0f$var$xr(s, v) + $b090f26829cd7c0f$var$xr(n, p) + o + 14 + 3 * P + $b090f26829cd7c0f$var$xr($, E) + (2 * $[16] + 3 * $[17] + 7 * $[18]);
    if (O <= F && O <= A) return $b090f26829cd7c0f$var$Er(i, u, t.subarray(l, l + h));
    if ($b090f26829cd7c0f$var$wr(i, u, 1 + (A < F)), u += 2, A < F) {
        R = $b090f26829cd7c0f$var$cr(v, c, 0), T = v, M = $b090f26829cd7c0f$var$cr(p, g, 0), C = p;
        var D = $b090f26829cd7c0f$var$cr(E, I, 0);
        $b090f26829cd7c0f$var$wr(i, u, b - 257), $b090f26829cd7c0f$var$wr(i, u + 5, S - 1), $b090f26829cd7c0f$var$wr(i, u + 10, P - 4), u += 14;
        for(k = 0; k < P; ++k)$b090f26829cd7c0f$var$wr(i, u + 3 * k, E[$b090f26829cd7c0f$var$sr[k]]);
        u += 3 * P;
        for(var j = [
            m,
            y
        ], L = 0; L < 2; ++L){
            var N = j[L];
            for(k = 0; k < N.length; ++k){
                var z = 31 & N[k];
                $b090f26829cd7c0f$var$wr(i, u, D[z]), u += E[z], z > 15 && ($b090f26829cd7c0f$var$wr(i, u, N[k] >>> 5 & 127), u += N[k] >>> 12);
            }
        }
    } else R = $b090f26829cd7c0f$var$gr, T = $b090f26829cd7c0f$var$fr, M = $b090f26829cd7c0f$var$_r, C = $b090f26829cd7c0f$var$pr;
    for(k = 0; k < a; ++k)if (r[k] > 255) {
        z = r[k] >>> 18 & 31;
        $b090f26829cd7c0f$var$yr(i, u, R[z + 257]), u += T[z + 257], z > 7 && ($b090f26829cd7c0f$var$wr(i, u, r[k] >>> 23 & 31), u += $b090f26829cd7c0f$var$er[z]);
        var U = 31 & r[k];
        $b090f26829cd7c0f$var$yr(i, u, M[U]), u += C[U], U > 3 && ($b090f26829cd7c0f$var$yr(i, u, r[k] >>> 5 & 8191), u += $b090f26829cd7c0f$var$rr[U]);
    } else $b090f26829cd7c0f$var$yr(i, u, R[r[k]]), u += T[r[k]];
    return $b090f26829cd7c0f$var$yr(i, u, R[256]), u + T[256];
}, $b090f26829cd7c0f$var$Pr = new $b090f26829cd7c0f$var$ir([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $b090f26829cd7c0f$var$Rr = function() {
    for(var t = new $b090f26829cd7c0f$var$ir(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $b090f26829cd7c0f$var$Tr = function() {
    var t = 4294967295;
    return {
        p: function(i) {
            for(var e = t, r = 0; r < i.length; ++r)e = $b090f26829cd7c0f$var$Rr[255 & e ^ i[r]] ^ e >>> 8;
            t = e;
        },
        d: function() {
            return 4294967295 ^ t;
        }
    };
}, $b090f26829cd7c0f$var$Mr = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new $b090f26829cd7c0f$var$Ze(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), h = 0;
        if (!i || o < 8) for(var u = 0; u <= o; u += 65535){
            var d = u + 65535;
            d < o ? h = $b090f26829cd7c0f$var$Er(l, h, t.subarray(u, d)) : (l[u] = n, h = $b090f26829cd7c0f$var$Er(l, h, t.subarray(u, o)));
        }
        else {
            for(var v = $b090f26829cd7c0f$var$Pr[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, g = new $b090f26829cd7c0f$var$tr(32768), _ = new $b090f26829cd7c0f$var$tr(p + 1), m = Math.ceil(e / 3), b = 2 * m, w = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, y = new $b090f26829cd7c0f$var$ir(25e3), S = new $b090f26829cd7c0f$var$tr(288), $ = new $b090f26829cd7c0f$var$tr(32), k = 0, x = 0, E = (u = 0, 0), I = 0, P = 0; u < o; ++u){
                var R = w(u), T = 32767 & u, M = _[R];
                if (g[T] = M, _[R] = T, I <= u) {
                    var C = o - u;
                    if ((k > 7e3 || E > 24576) && C > 423) {
                        h = $b090f26829cd7c0f$var$Ir(t, l, 0, y, S, $, x, E, P, u - P, h), E = k = x = 0, P = u;
                        for(var O = 0; O < 286; ++O)S[O] = 0;
                        for(O = 0; O < 30; ++O)$[O] = 0;
                    }
                    var F = 2, A = 0, D = f, j = T - M & 32767;
                    if (C > 2 && R == w(u - j)) for(var L = Math.min(c, C) - 1, N = Math.min(32767, u), z = Math.min(258, C); j <= N && --D && T != M;){
                        if (t[u + F] == t[u + F - j]) {
                            for(var U = 0; U < z && t[u + U] == t[u + U - j]; ++U);
                            if (U > F) {
                                if (F = U, A = j, U > L) break;
                                var q = Math.min(j, U - 2), B = 0;
                                for(O = 0; O < q; ++O){
                                    var H = u - j + O + 32768 & 32767, W = H - g[H] + 32768 & 32767;
                                    W > B && (B = W, M = H);
                                }
                            }
                        }
                        j += (T = M) - (M = g[T]) + 32768 & 32767;
                    }
                    if (A) {
                        y[E++] = 268435456 | $b090f26829cd7c0f$var$lr[F] << 18 | $b090f26829cd7c0f$var$hr[A];
                        var G = 31 & $b090f26829cd7c0f$var$lr[F], J = 31 & $b090f26829cd7c0f$var$hr[A];
                        x += $b090f26829cd7c0f$var$er[G] + $b090f26829cd7c0f$var$rr[J], ++S[257 + G], ++$[J], I = u + F, ++k;
                    } else y[E++] = t[u], ++S[t[u]];
                }
            }
            h = $b090f26829cd7c0f$var$Ir(t, l, n, y, S, $, x, E, P, u - P, h);
        }
        return $b090f26829cd7c0f$var$br(a, 0, r + $b090f26829cd7c0f$var$mr(h) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !s);
}, $b090f26829cd7c0f$var$Cr = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
}, $b090f26829cd7c0f$var$Or = function(t, i) {
    var e = i.filename;
    if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $b090f26829cd7c0f$var$Cr(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
        t[3] = 8;
        for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
    }
}, $b090f26829cd7c0f$var$Fr = function(t) {
    return 10 + (t.filename && t.filename.length + 1 || 0);
};
function $b090f26829cd7c0f$var$Ar(t, i) {
    void 0 === i && (i = {});
    var e = $b090f26829cd7c0f$var$Tr(), r = t.length;
    e.p(t);
    var s = $b090f26829cd7c0f$var$Mr(t, i, $b090f26829cd7c0f$var$Fr(i), 8), n = s.length;
    return $b090f26829cd7c0f$var$Or(s, i), $b090f26829cd7c0f$var$Cr(s, n - 8, e.d()), $b090f26829cd7c0f$var$Cr(s, n - 4, r), s;
}
function $b090f26829cd7c0f$var$Dr(t, i) {
    var e = t.length;
    if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
    for(var r = new $b090f26829cd7c0f$var$Ze(t.length + (t.length >>> 1)), s = 0, n = function(t) {
        r[s++] = t;
    }, o = 0; o < e; ++o){
        if (s + 5 > r.length) {
            var a = new $b090f26829cd7c0f$var$Ze(s + 8 + (e - o << 1));
            a.set(r), r = a;
        }
        var l = t.charCodeAt(o);
        l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
    }
    return $b090f26829cd7c0f$var$br(r, 0, s);
}
function $b090f26829cd7c0f$var$jr(t, i) {
    return function(t) {
        for(var i = 0, e = 0; e < t.length; e++)i = (i << 5) - i + t.charCodeAt(e), i |= 0;
        return Math.abs(i);
    }(t) % 100 < $b090f26829cd7c0f$var$Xe(100 * i, 0, 100);
}
var $b090f26829cd7c0f$var$Lr = "disabled", $b090f26829cd7c0f$var$Nr = "sampled", $b090f26829cd7c0f$var$zr = "active", $b090f26829cd7c0f$var$Ur = "buffering", $b090f26829cd7c0f$var$qr = "paused", $b090f26829cd7c0f$var$Br = "trigger", $b090f26829cd7c0f$var$Hr = $b090f26829cd7c0f$var$Br + "_activated", $b090f26829cd7c0f$var$Wr = $b090f26829cd7c0f$var$Br + "_pending", $b090f26829cd7c0f$var$Gr = $b090f26829cd7c0f$var$Br + "_" + $b090f26829cd7c0f$var$Lr;
function $b090f26829cd7c0f$var$Jr(t, i) {
    return i.some((i)=>"regex" === i.matching && new RegExp(i.url).test(t));
}
class $b090f26829cd7c0f$var$Vr {
    constructor(t){
        this.gt = t;
    }
    triggerStatus(t) {
        var i = this.gt.map((i)=>i.triggerStatus(t));
        return i.includes($b090f26829cd7c0f$var$Hr) ? $b090f26829cd7c0f$var$Hr : i.includes($b090f26829cd7c0f$var$Wr) ? $b090f26829cd7c0f$var$Wr : $b090f26829cd7c0f$var$Gr;
    }
    stop() {
        this.gt.forEach((t)=>t.stop());
    }
}
class $b090f26829cd7c0f$var$Kr {
    constructor(t){
        this.gt = t;
    }
    triggerStatus(t) {
        var i = new Set;
        for (var e of this.gt)i.add(e.triggerStatus(t));
        switch(i.delete($b090f26829cd7c0f$var$Gr), i.size){
            case 0:
                return $b090f26829cd7c0f$var$Gr;
            case 1:
                return Array.from(i)[0];
            default:
                return $b090f26829cd7c0f$var$Wr;
        }
    }
    stop() {
        this.gt.forEach((t)=>t.stop());
    }
}
class $b090f26829cd7c0f$var$Yr {
    triggerStatus() {
        return $b090f26829cd7c0f$var$Wr;
    }
    stop() {}
}
class $b090f26829cd7c0f$var$Xr {
    constructor(t){
        this._t = [], this.bt = [], this.urlBlocked = !1, this.N = t;
    }
    onRemoteConfig(t) {
        var i, e;
        this._t = (null == (i = t.sessionRecording) ? void 0 : i.urlTriggers) || [], this.bt = (null == (e = t.sessionRecording) ? void 0 : e.urlBlocklist) || [];
    }
    wt(t) {
        var i;
        return 0 === this._t.length ? $b090f26829cd7c0f$var$Gr : (null == (i = this.N) ? void 0 : i.get_property($b090f26829cd7c0f$var$kt)) === t ? $b090f26829cd7c0f$var$Hr : $b090f26829cd7c0f$var$Wr;
    }
    triggerStatus(t) {
        var i = this.wt(t), e = i === $b090f26829cd7c0f$var$Hr ? $b090f26829cd7c0f$var$Hr : i === $b090f26829cd7c0f$var$Wr ? $b090f26829cd7c0f$var$Wr : $b090f26829cd7c0f$var$Gr;
        return this.N.register_for_session({
            $sdk_debug_replay_url_trigger_status: e
        }), e;
    }
    checkUrlTriggerConditions(t, e, r) {
        if (void 0 !== $b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$i.location.href) {
            var s = $b090f26829cd7c0f$var$i.location.href, n = this.urlBlocked, o = $b090f26829cd7c0f$var$Jr(s, this.bt);
            n && o || (o && !n ? t() : !o && n && e(), $b090f26829cd7c0f$var$Jr(s, this._t) && r("url"));
        }
    }
    stop() {}
}
class $b090f26829cd7c0f$var$Qr {
    constructor(t){
        this.linkedFlag = null, this.linkedFlagSeen = !1, this.yt = ()=>{}, this.N = t;
    }
    triggerStatus() {
        var t = $b090f26829cd7c0f$var$Wr;
        return $b090f26829cd7c0f$var$O(this.linkedFlag) && (t = $b090f26829cd7c0f$var$Gr), this.linkedFlagSeen && (t = $b090f26829cd7c0f$var$Hr), this.N.register_for_session({
            $sdk_debug_replay_linked_flag_trigger_status: t
        }), t;
    }
    onRemoteConfig(t, i) {
        var e;
        if (this.linkedFlag = (null == (e = t.sessionRecording) ? void 0 : e.linkedFlag) || null, !$b090f26829cd7c0f$var$O(this.linkedFlag) && !this.linkedFlagSeen) {
            var r = $b090f26829cd7c0f$var$T(this.linkedFlag) ? this.linkedFlag : this.linkedFlag.flag, s = $b090f26829cd7c0f$var$T(this.linkedFlag) ? null : this.linkedFlag.variant;
            this.yt = this.N.onFeatureFlags((t, e)=>{
                var n = $b090f26829cd7c0f$var$I(e) && r in e, o = s ? e[r] === s : n;
                o && i(r, s), this.linkedFlagSeen = o;
            });
        }
    }
    stop() {
        this.yt();
    }
}
class $b090f26829cd7c0f$var$Zr {
    constructor(t){
        this.St = [], this.N = t;
    }
    onRemoteConfig(t) {
        var i;
        this.St = (null == (i = t.sessionRecording) ? void 0 : i.eventTriggers) || [];
    }
    $t(t) {
        var i;
        return 0 === this.St.length ? $b090f26829cd7c0f$var$Gr : (null == (i = this.N) ? void 0 : i.get_property($b090f26829cd7c0f$var$xt)) === t ? $b090f26829cd7c0f$var$Hr : $b090f26829cd7c0f$var$Wr;
    }
    triggerStatus(t) {
        var i = this.$t(t), e = i === $b090f26829cd7c0f$var$Hr ? $b090f26829cd7c0f$var$Hr : i === $b090f26829cd7c0f$var$Wr ? $b090f26829cd7c0f$var$Wr : $b090f26829cd7c0f$var$Gr;
        return this.N.register_for_session({
            $sdk_debug_replay_event_trigger_status: e
        }), e;
    }
    stop() {}
}
function $b090f26829cd7c0f$var$ts(t) {
    return t.isRecordingEnabled ? $b090f26829cd7c0f$var$Ur : $b090f26829cd7c0f$var$Lr;
}
function $b090f26829cd7c0f$var$is(t) {
    if (!t.receivedDecide) return $b090f26829cd7c0f$var$Ur;
    if (!t.isRecordingEnabled) return $b090f26829cd7c0f$var$Lr;
    if (t.urlTriggerMatching.urlBlocked) return $b090f26829cd7c0f$var$qr;
    var i = !0 === t.isSampled, e = new $b090f26829cd7c0f$var$Vr([
        t.eventTriggerMatching,
        t.urlTriggerMatching,
        t.linkedFlagMatching
    ]).triggerStatus(t.sessionId);
    return i ? $b090f26829cd7c0f$var$Nr : e === $b090f26829cd7c0f$var$Hr ? $b090f26829cd7c0f$var$zr : e === $b090f26829cd7c0f$var$Wr ? $b090f26829cd7c0f$var$Ur : !1 === t.isSampled ? $b090f26829cd7c0f$var$Lr : $b090f26829cd7c0f$var$zr;
}
function $b090f26829cd7c0f$var$es(t) {
    if (!t.receivedDecide) return $b090f26829cd7c0f$var$Ur;
    if (!t.isRecordingEnabled) return $b090f26829cd7c0f$var$Lr;
    if (t.urlTriggerMatching.urlBlocked) return $b090f26829cd7c0f$var$qr;
    var i = new $b090f26829cd7c0f$var$Kr([
        t.eventTriggerMatching,
        t.urlTriggerMatching,
        t.linkedFlagMatching
    ]).triggerStatus(t.sessionId), e = i !== $b090f26829cd7c0f$var$Gr, r = $b090f26829cd7c0f$var$A(t.isSampled);
    return e && i === $b090f26829cd7c0f$var$Wr ? $b090f26829cd7c0f$var$Ur : e && i === $b090f26829cd7c0f$var$Gr || r && !t.isSampled ? $b090f26829cd7c0f$var$Lr : !0 === t.isSampled ? $b090f26829cd7c0f$var$Nr : $b090f26829cd7c0f$var$zr;
}
var $b090f26829cd7c0f$var$rs = "[SessionRecording]", $b090f26829cd7c0f$var$ss = $b090f26829cd7c0f$var$z($b090f26829cd7c0f$var$rs);
function $b090f26829cd7c0f$var$ns() {
    var t, i;
    return null == $b090f26829cd7c0f$var$c || null == (t = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == (i = t.rrweb) ? void 0 : i.record;
}
var $b090f26829cd7c0f$var$os = 3e5, $b090f26829cd7c0f$var$as = [
    $b090f26829cd7c0f$var$Ue.MouseMove,
    $b090f26829cd7c0f$var$Ue.MouseInteraction,
    $b090f26829cd7c0f$var$Ue.Scroll,
    $b090f26829cd7c0f$var$Ue.ViewportResize,
    $b090f26829cd7c0f$var$Ue.Input,
    $b090f26829cd7c0f$var$Ue.TouchMove,
    $b090f26829cd7c0f$var$Ue.MediaInteraction,
    $b090f26829cd7c0f$var$Ue.Drag
], $b090f26829cd7c0f$var$ls = (t)=>({
        rrwebMethod: t,
        enqueuedAt: Date.now(),
        attempt: 1
    });
function $b090f26829cd7c0f$var$hs(t) {
    return function(t, i) {
        for(var e = "", r = 0; r < t.length;){
            var s = t[r++];
            s < 128 || i ? e += String.fromCharCode(s) : s < 224 ? e += String.fromCharCode((31 & s) << 6 | 63 & t[r++]) : s < 240 ? e += String.fromCharCode((15 & s) << 12 | (63 & t[r++]) << 6 | 63 & t[r++]) : (s = ((15 & s) << 18 | (63 & t[r++]) << 12 | (63 & t[r++]) << 6 | 63 & t[r++]) - 65536, e += String.fromCharCode(55296 | s >> 10, 56320 | 1023 & s));
        }
        return e;
    }($b090f26829cd7c0f$var$Ar($b090f26829cd7c0f$var$Dr(JSON.stringify(t))), !0);
}
function $b090f26829cd7c0f$var$us(t) {
    return t.type === $b090f26829cd7c0f$var$ze.Custom && "sessionIdle" === t.data.tag;
}
class $b090f26829cd7c0f$var$ds {
    get sessionId() {
        return this.kt;
    }
    get xt() {
        return this.N.config.session_recording.session_idle_threshold_ms || 3e5;
    }
    get started() {
        return this.Et;
    }
    get It() {
        if (!this.N.sessionManager) throw new Error($b090f26829cd7c0f$var$rs + " must be started with a valid sessionManager.");
        return this.N.sessionManager;
    }
    get Pt() {
        var t, i;
        return this.Rt.triggerStatus(this.sessionId) === $b090f26829cd7c0f$var$Wr ? 6e4 : null !== (t = null == (i = this.N.config.session_recording) ? void 0 : i.full_snapshot_interval_millis) && void 0 !== t ? t : $b090f26829cd7c0f$var$os;
    }
    get Tt() {
        var t = this.N.get_property($b090f26829cd7c0f$var$$t);
        return $b090f26829cd7c0f$var$A(t) ? t : null;
    }
    get Mt() {
        var t, i, e = null == (t = this.M) ? void 0 : t.data[(null == (i = this.M) ? void 0 : i.data.length) - 1], { sessionStartTimestamp: r } = this.It.checkAndGetSessionAndWindowId(!0);
        return e ? e.timestamp - r : null;
    }
    get Ct() {
        var t = !!this.N.get_property($b090f26829cd7c0f$var$ft), e = !this.N.config.disable_session_recording;
        return $b090f26829cd7c0f$var$i && t && e;
    }
    get Ot() {
        var t = !!this.N.get_property($b090f26829cd7c0f$var$pt), i = this.N.config.enable_recording_console_log;
        return null != i ? i : t;
    }
    get Ft() {
        var t, i, e, r, s, n, o = this.N.config.session_recording.captureCanvas, a = this.N.get_property($b090f26829cd7c0f$var$mt), l = null !== (t = null !== (i = null == o ? void 0 : o.recordCanvas) && void 0 !== i ? i : null == a ? void 0 : a.enabled) && void 0 !== t && t, h = null !== (e = null !== (r = null == o ? void 0 : o.canvasFps) && void 0 !== r ? r : null == a ? void 0 : a.fps) && void 0 !== e ? e : 4, u = null !== (s = null !== (n = null == o ? void 0 : o.canvasQuality) && void 0 !== n ? n : null == a ? void 0 : a.quality) && void 0 !== s ? s : .4;
        if ("string" == typeof u) {
            var d = parseFloat(u);
            u = isNaN(d) ? .4 : d;
        }
        return {
            enabled: l,
            fps: $b090f26829cd7c0f$var$Xe(h, 0, 12, "canvas recording fps", 4),
            quality: $b090f26829cd7c0f$var$Xe(u, 0, 1, "canvas recording quality", .4)
        };
    }
    get At() {
        var t, i, e = this.N.get_property($b090f26829cd7c0f$var$gt), r = {
            recordHeaders: null == (t = this.N.config.session_recording) ? void 0 : t.recordHeaders,
            recordBody: null == (i = this.N.config.session_recording) ? void 0 : i.recordBody
        }, s = (null == r ? void 0 : r.recordHeaders) || (null == e ? void 0 : e.recordHeaders), n = (null == r ? void 0 : r.recordBody) || (null == e ? void 0 : e.recordBody), o = $b090f26829cd7c0f$var$I(this.N.config.capture_performance) ? this.N.config.capture_performance.network_timing : this.N.config.capture_performance, a = !!($b090f26829cd7c0f$var$A(o) ? o : null == e ? void 0 : e.capturePerformance);
        return s || n || a ? {
            recordHeaders: s,
            recordBody: n,
            recordPerformance: a
        } : void 0;
    }
    get Dt() {
        var t, i, e, r, s, n, o = this.N.get_property($b090f26829cd7c0f$var$_t), a = {
            maskAllInputs: null == (t = this.N.config.session_recording) ? void 0 : t.maskAllInputs,
            maskTextSelector: null == (i = this.N.config.session_recording) ? void 0 : i.maskTextSelector,
            blockSelector: null == (e = this.N.config.session_recording) ? void 0 : e.blockSelector
        }, l = null !== (r = null == a ? void 0 : a.maskAllInputs) && void 0 !== r ? r : null == o ? void 0 : o.maskAllInputs, h = null !== (s = null == a ? void 0 : a.maskTextSelector) && void 0 !== s ? s : null == o ? void 0 : o.maskTextSelector, u = null !== (n = null == a ? void 0 : a.blockSelector) && void 0 !== n ? n : null == o ? void 0 : o.blockSelector;
        return $b090f26829cd7c0f$var$R(l) && $b090f26829cd7c0f$var$R(h) && $b090f26829cd7c0f$var$R(u) ? void 0 : {
            maskAllInputs: null == l || l,
            maskTextSelector: h,
            blockSelector: u
        };
    }
    get jt() {
        var t = this.N.get_property($b090f26829cd7c0f$var$bt);
        return $b090f26829cd7c0f$var$F(t) ? t : null;
    }
    get Lt() {
        var t = this.N.get_property($b090f26829cd7c0f$var$wt);
        return $b090f26829cd7c0f$var$F(t) ? t : null;
    }
    get status() {
        return this.Nt ? this.zt({
            receivedDecide: this.Nt,
            isRecordingEnabled: this.Ct,
            isSampled: this.Tt,
            urlTriggerMatching: this.Ut,
            eventTriggerMatching: this.qt,
            linkedFlagMatching: this.Bt,
            sessionId: this.sessionId
        }) : $b090f26829cd7c0f$var$Ur;
    }
    constructor(t){
        if (this.zt = $b090f26829cd7c0f$var$ts, this.Nt = !1, this.Ht = [], this.Wt = "unknown", this.Gt = Date.now(), this.Rt = new $b090f26829cd7c0f$var$Yr, this.Jt = void 0, this.Vt = void 0, this.Kt = void 0, this.Yt = void 0, this.Xt = void 0, this._forceAllowLocalhostNetworkCapture = !1, this.Qt = ()=>{
            this.Zt();
        }, this.ti = ()=>{
            this.ii("browser offline", {});
        }, this.ei = ()=>{
            this.ii("browser online", {});
        }, this.ri = ()=>{
            if (null != $b090f26829cd7c0f$var$a && $b090f26829cd7c0f$var$a.visibilityState) {
                var t = "window " + $b090f26829cd7c0f$var$a.visibilityState;
                this.ii(t, {});
            }
        }, this.N = t, this.Et = !1, this.si = "/s/", this.ni = void 0, this.Nt = !1, !this.N.sessionManager) throw $b090f26829cd7c0f$var$ss.error("started without valid sessionManager"), new Error($b090f26829cd7c0f$var$rs + " started without valid sessionManager. This is a bug.");
        if (this.N.config.__preview_experimental_cookieless_mode) throw new Error($b090f26829cd7c0f$var$rs + " cannot be used with __preview_experimental_cookieless_mode.");
        this.Bt = new $b090f26829cd7c0f$var$Qr(this.N), this.Ut = new $b090f26829cd7c0f$var$Xr(this.N), this.qt = new $b090f26829cd7c0f$var$Zr(this.N);
        var { sessionId: i, windowId: e } = this.It.checkAndGetSessionAndWindowId();
        this.kt = i, this.oi = e, this.M = this.ai(), this.xt >= this.It.sessionTimeoutMs && $b090f26829cd7c0f$var$ss.warn("session_idle_threshold_ms (" + this.xt + ") is greater than the session timeout (" + this.It.sessionTimeoutMs + "). Session will never be detected as idle");
    }
    startIfEnabledOrStop(t) {
        this.Ct ? (this.li(t), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "beforeunload", this.Qt), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "offline", this.ti), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "online", this.ei), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "visibilitychange", this.ri), this.hi(), this.ui(), $b090f26829cd7c0f$var$O(this.Jt) && (this.Jt = this.N.on("eventCaptured", (t)=>{
            try {
                if ("$pageview" === t.event) {
                    var i = null != t && t.properties.$current_url ? this.di(null == t ? void 0 : t.properties.$current_url) : "";
                    if (!i) return;
                    this.ii("$pageview", {
                        href: i
                    });
                }
            } catch (t) {
                $b090f26829cd7c0f$var$ss.error("Could not add $pageview to rrweb session", t);
            }
        })), this.Vt || (this.Vt = this.It.onSessionId((t, i, e)=>{
            var r, s, n, o;
            e && (this.ii("$session_id_change", {
                sessionId: t,
                windowId: i,
                changeReason: e
            }), null == (r = this.N) || null == (s = r.persistence) || s.unregister($b090f26829cd7c0f$var$xt), null == (n = this.N) || null == (o = n.persistence) || o.unregister($b090f26829cd7c0f$var$kt));
        }))) : this.stopRecording();
    }
    stopRecording() {
        var t, e, r, s;
        this.Et && this.ni && (this.ni(), this.ni = void 0, this.Et = !1, null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.removeEventListener("beforeunload", this.Qt), null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.removeEventListener("offline", this.ti), null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.removeEventListener("online", this.ei), null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.removeEventListener("visibilitychange", this.ri), this.ai(), clearInterval(this.vi), null == (t = this.Jt) || t.call(this), this.Jt = void 0, null == (e = this.Xt) || e.call(this), this.Xt = void 0, null == (r = this.Vt) || r.call(this), this.Vt = void 0, null == (s = this.Yt) || s.call(this), this.Yt = void 0, this.qt.stop(), this.Ut.stop(), this.Bt.stop(), $b090f26829cd7c0f$var$ss.info("stopped"));
    }
    ci() {
        var t;
        null == (t = this.N.persistence) || t.unregister($b090f26829cd7c0f$var$$t);
    }
    fi(t) {
        var i, e = this.kt !== t, r = this.jt;
        if ($b090f26829cd7c0f$var$F(r)) {
            var s = this.Tt, n = e || !$b090f26829cd7c0f$var$A(s), o = n ? $b090f26829cd7c0f$var$jr(t, r) : s;
            n && (o ? this.pi($b090f26829cd7c0f$var$Nr) : $b090f26829cd7c0f$var$ss.warn("Sample rate (" + r + ") has determined that this sessionId (" + t + ") will not be sent to the server."), this.ii("samplingDecisionMade", {
                sampleRate: r,
                isSampled: o
            })), null == (i = this.N.persistence) || i.register({
                [$b090f26829cd7c0f$var$$t]: o
            });
        } else this.ci();
    }
    onRemoteConfig(t) {
        var i, e, r, s;
        (this.ii("$remote_config_received", t), this.gi(t), null != (i = t.sessionRecording) && i.endpoint) && (this.si = null == (s = t.sessionRecording) ? void 0 : s.endpoint);
        this.hi(), "any" === (null == (e = t.sessionRecording) ? void 0 : e.triggerMatchType) ? (this.zt = $b090f26829cd7c0f$var$is, this.Rt = new $b090f26829cd7c0f$var$Vr([
            this.qt,
            this.Ut
        ])) : (this.zt = $b090f26829cd7c0f$var$es, this.Rt = new $b090f26829cd7c0f$var$Kr([
            this.qt,
            this.Ut
        ])), this.N.register_for_session({
            $sdk_debug_replay_remote_trigger_matching_config: null == (r = t.sessionRecording) ? void 0 : r.triggerMatchType
        }), this.Ut.onRemoteConfig(t), this.qt.onRemoteConfig(t), this.Bt.onRemoteConfig(t, (t, i)=>{
            this.pi("linked_flag_matched", {
                flag: t,
                variant: i
            });
        }), this.Nt = !0, this.startIfEnabledOrStop();
    }
    hi() {
        $b090f26829cd7c0f$var$F(this.jt) && $b090f26829cd7c0f$var$O(this.Yt) && (this.Yt = this.It.onSessionId((t)=>{
            this.fi(t);
        }));
    }
    gi(t) {
        if (this.N.persistence) {
            var i, e = this.N.persistence, r = ()=>{
                var i, r, s, n, o, a, l, h, u, d = null == (i = t.sessionRecording) ? void 0 : i.sampleRate, v = $b090f26829cd7c0f$var$O(d) ? null : parseFloat(d);
                $b090f26829cd7c0f$var$O(v) && this.ci();
                var c = null == (r = t.sessionRecording) ? void 0 : r.minimumDurationMilliseconds;
                e.register({
                    [$b090f26829cd7c0f$var$ft]: !!t.sessionRecording,
                    [$b090f26829cd7c0f$var$pt]: null == (s = t.sessionRecording) ? void 0 : s.consoleLogRecordingEnabled,
                    [$b090f26829cd7c0f$var$gt]: $b090f26829cd7c0f$var$B({
                        capturePerformance: t.capturePerformance
                    }, null == (n = t.sessionRecording) ? void 0 : n.networkPayloadCapture),
                    [$b090f26829cd7c0f$var$_t]: null == (o = t.sessionRecording) ? void 0 : o.masking,
                    [$b090f26829cd7c0f$var$mt]: {
                        enabled: null == (a = t.sessionRecording) ? void 0 : a.recordCanvas,
                        fps: null == (l = t.sessionRecording) ? void 0 : l.canvasFps,
                        quality: null == (h = t.sessionRecording) ? void 0 : h.canvasQuality
                    },
                    [$b090f26829cd7c0f$var$bt]: v,
                    [$b090f26829cd7c0f$var$wt]: $b090f26829cd7c0f$var$R(c) ? null : c,
                    [$b090f26829cd7c0f$var$yt]: null == (u = t.sessionRecording) ? void 0 : u.scriptConfig
                });
            };
            r(), null == (i = this.Kt) || i.call(this), this.Kt = this.It.onSessionId(r);
        }
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null == (e = this.N.sessionRecording) || e.onRRwebEmit({
            type: 6,
            data: {
                plugin: "rrweb/console@1",
                payload: {
                    level: i,
                    trace: [],
                    payload: [
                        JSON.stringify(t)
                    ]
                }
            },
            timestamp: Date.now()
        });
    }
    li(t) {
        if (!$b090f26829cd7c0f$var$R(Object.assign) && !$b090f26829cd7c0f$var$R(Array.from) && !(this.Et || this.N.config.disable_session_recording || this.N.consent.isOptedOut())) {
            var i;
            if (this.Et = !0, this.It.checkAndGetSessionAndWindowId(), $b090f26829cd7c0f$var$ns()) this.mi();
            else null == (i = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this.N, this.bi, (t)=>{
                if (t) return $b090f26829cd7c0f$var$ss.error("could not load recorder", t);
                this.mi();
            });
            $b090f26829cd7c0f$var$ss.info("starting"), this.status === $b090f26829cd7c0f$var$zr && this.pi(t || "recording_initialized");
        }
    }
    get bi() {
        var t, i, e;
        return (null == (t = this.N) || null == (i = t.persistence) || null == (e = i.get_property($b090f26829cd7c0f$var$yt)) ? void 0 : e.script) || "recorder";
    }
    wi(t) {
        var i;
        return 3 === t.type && -1 !== $b090f26829cd7c0f$var$as.indexOf(null == (i = t.data) ? void 0 : i.source);
    }
    yi(t) {
        var i = this.wi(t);
        i || this.Wt || t.timestamp - this.Gt > this.xt && (this.Wt = !0, clearInterval(this.vi), this.ii("sessionIdle", {
            eventTimestamp: t.timestamp,
            lastActivityTimestamp: this.Gt,
            threshold: this.xt,
            bufferLength: this.M.data.length,
            bufferSize: this.M.size
        }), this.Zt());
        var e = !1;
        if (i && (this.Gt = t.timestamp, this.Wt)) {
            var r = "unknown" === this.Wt;
            this.Wt = !1, r || (this.ii("sessionNoLongerIdle", {
                reason: "user activity",
                type: t.type
            }), e = !0);
        }
        if (!this.Wt) {
            var { windowId: s, sessionId: n } = this.It.checkAndGetSessionAndWindowId(!i, t.timestamp), o = this.kt !== n, a = this.oi !== s;
            this.oi = s, this.kt = n, o || a ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : e && this.Si();
        }
    }
    $i(t) {
        try {
            return t.rrwebMethod(), !0;
        } catch (i) {
            return this.Ht.length < 10 ? this.Ht.push({
                enqueuedAt: t.enqueuedAt || Date.now(),
                attempt: t.attempt++,
                rrwebMethod: t.rrwebMethod
            }) : $b090f26829cd7c0f$var$ss.warn("could not emit queued rrweb event.", i, t), !1;
        }
    }
    ii(t, i) {
        return this.$i($b090f26829cd7c0f$var$ls(()=>$b090f26829cd7c0f$var$ns().addCustomEvent(t, i)));
    }
    ki() {
        return this.$i($b090f26829cd7c0f$var$ls(()=>$b090f26829cd7c0f$var$ns().takeFullSnapshot()));
    }
    mi() {
        var t, i, e, r, s = {
            blockClass: "ph-no-capture",
            blockSelector: void 0,
            ignoreClass: "ph-ignore-input",
            maskTextClass: "ph-mask",
            maskTextSelector: void 0,
            maskTextFn: void 0,
            maskAllInputs: !0,
            maskInputOptions: {
                password: !0
            },
            maskInputFn: void 0,
            slimDOMOptions: {},
            collectFonts: !1,
            inlineStylesheet: !0,
            recordCrossOriginIframes: !1
        }, n = this.N.config.session_recording;
        for (var [o, a] of Object.entries(n || {}))o in s && ("maskInputOptions" === o ? s.maskInputOptions = $b090f26829cd7c0f$var$B({
            password: !0
        }, a) : s[o] = a);
        (this.Ft && this.Ft.enabled && (s.recordCanvas = !0, s.sampling = {
            canvas: this.Ft.fps
        }, s.dataURLOptions = {
            type: "image/webp",
            quality: this.Ft.quality
        }), this.Dt) && (s.maskAllInputs = null === (i = this.Dt.maskAllInputs) || void 0 === i || i, s.maskTextSelector = null !== (e = this.Dt.maskTextSelector) && void 0 !== e ? e : void 0, s.blockSelector = null !== (r = this.Dt.blockSelector) && void 0 !== r ? r : void 0);
        var l = $b090f26829cd7c0f$var$ns();
        if (l) {
            this.xi = null !== (t = this.xi) && void 0 !== t ? t : new $b090f26829cd7c0f$var$Qe(l, {
                refillRate: this.N.config.session_recording.__mutationRateLimiterRefillRate,
                bucketSize: this.N.config.session_recording.__mutationRateLimiterBucketSize,
                onBlockedNode: (t, i)=>{
                    var e = "Too many mutations on node '" + t + "'. Rate limiting. This could be due to SVG animations or something similar";
                    $b090f26829cd7c0f$var$ss.info(e, {
                        node: i
                    }), this.log($b090f26829cd7c0f$var$rs + " " + e, "warn");
                }
            });
            var h = this.Ei();
            this.ni = l($b090f26829cd7c0f$var$B({
                emit: (t)=>{
                    this.onRRwebEmit(t);
                },
                plugins: h
            }, s)), this.Gt = Date.now(), this.Wt = $b090f26829cd7c0f$var$A(this.Wt) ? this.Wt : "unknown", this.ii("$session_options", {
                sessionRecordingOptions: s,
                activePlugins: h.map((t)=>null == t ? void 0 : t.name)
            }), this.ii("$posthog_config", {
                config: this.N.config
            });
        } else $b090f26829cd7c0f$var$ss.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
    }
    Si() {
        if (this.vi && clearInterval(this.vi), !0 !== this.Wt) {
            var t = this.Pt;
            t && (this.vi = setInterval(()=>{
                this.ki();
            }, t));
        }
    }
    Ei() {
        var t, i, e, r, s = [], n = null == (t = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == (i = t.rrwebPlugins) ? void 0 : i.getRecordConsolePlugin;
        n && this.Ot && s.push(n());
        var o = null == (e = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == (r = e.rrwebPlugins) ? void 0 : r.getRecordNetworkPlugin;
        this.At && $b090f26829cd7c0f$var$E(o) && (!$b090f26829cd7c0f$var$bi.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? s.push(o($b090f26829cd7c0f$var$Ye(this.N.config, this.At))) : $b090f26829cd7c0f$var$ss.info("NetworkCapture not started because we are on localhost."));
        return s;
    }
    onRRwebEmit(t) {
        var i;
        if (this.Ii(), t && $b090f26829cd7c0f$var$I(t)) {
            if (t.type === $b090f26829cd7c0f$var$ze.Meta) {
                var e = this.di(t.data.href);
                if (this.Pi = e, !e) return;
                t.data.href = e;
            } else this.Ri();
            if (this.Ut.checkUrlTriggerConditions(()=>this.Ti(), ()=>this.Mi(), (t)=>this.Ci(t)), !this.Ut.urlBlocked || (r = t).type === $b090f26829cd7c0f$var$ze.Custom && "recording paused" === r.data.tag) {
                var r;
                t.type === $b090f26829cd7c0f$var$ze.FullSnapshot && this.Si(), t.type === $b090f26829cd7c0f$var$ze.FullSnapshot && this.Nt && this.Rt.triggerStatus(this.sessionId) === $b090f26829cd7c0f$var$Wr && this.ai();
                var s = this.xi ? this.xi.throttleMutations(t) : t;
                if (s) {
                    var n = function(t) {
                        var i = t;
                        if (i && $b090f26829cd7c0f$var$I(i) && 6 === i.type && $b090f26829cd7c0f$var$I(i.data) && "rrweb/console@1" === i.data.plugin) {
                            i.data.payload.payload.length > 10 && (i.data.payload.payload = i.data.payload.payload.slice(0, 10), i.data.payload.payload.push("...[truncated]"));
                            for(var e = [], r = 0; r < i.data.payload.payload.length; r++)i.data.payload.payload[r] && i.data.payload.payload[r].length > 2e3 ? e.push(i.data.payload.payload[r].slice(0, 2e3) + "...[truncated]") : e.push(i.data.payload.payload[r]);
                            return i.data.payload.payload = e, t;
                        }
                        return t;
                    }(s);
                    if (this.yi(n), !0 !== this.Wt || $b090f26829cd7c0f$var$us(n)) {
                        if ($b090f26829cd7c0f$var$us(n)) {
                            var o = n.data.payload;
                            if (o) {
                                var a = o.lastActivityTimestamp, l = o.threshold;
                                n.timestamp = a + l;
                            }
                        }
                        var h = null === (i = this.N.config.session_recording.compress_events) || void 0 === i || i ? function(t) {
                            if ($b090f26829cd7c0f$var$Le(t) < 1024) return t;
                            try {
                                if (t.type === $b090f26829cd7c0f$var$ze.FullSnapshot) return $b090f26829cd7c0f$var$B({}, t, {
                                    data: $b090f26829cd7c0f$var$hs(t.data),
                                    cv: "2024-10"
                                });
                                if (t.type === $b090f26829cd7c0f$var$ze.IncrementalSnapshot && t.data.source === $b090f26829cd7c0f$var$Ue.Mutation) return $b090f26829cd7c0f$var$B({}, t, {
                                    cv: "2024-10",
                                    data: $b090f26829cd7c0f$var$B({}, t.data, {
                                        texts: $b090f26829cd7c0f$var$hs(t.data.texts),
                                        attributes: $b090f26829cd7c0f$var$hs(t.data.attributes),
                                        removes: $b090f26829cd7c0f$var$hs(t.data.removes),
                                        adds: $b090f26829cd7c0f$var$hs(t.data.adds)
                                    })
                                });
                                if (t.type === $b090f26829cd7c0f$var$ze.IncrementalSnapshot && t.data.source === $b090f26829cd7c0f$var$Ue.StyleSheetRule) return $b090f26829cd7c0f$var$B({}, t, {
                                    cv: "2024-10",
                                    data: $b090f26829cd7c0f$var$B({}, t.data, {
                                        adds: t.data.adds ? $b090f26829cd7c0f$var$hs(t.data.adds) : void 0,
                                        removes: t.data.removes ? $b090f26829cd7c0f$var$hs(t.data.removes) : void 0
                                    })
                                });
                            } catch (t) {
                                $b090f26829cd7c0f$var$ss.error("could not compress event - will use uncompressed event", t);
                            }
                            return t;
                        }(n) : n, u = {
                            $snapshot_bytes: $b090f26829cd7c0f$var$Le(h),
                            $snapshot_data: h,
                            $session_id: this.kt,
                            $window_id: this.oi
                        };
                        this.status !== $b090f26829cd7c0f$var$Lr ? this.Oi(u) : this.ai();
                    }
                }
            }
        }
    }
    Ri() {
        if (!this.N.config.capture_pageview && $b090f26829cd7c0f$var$i) {
            var t = this.di($b090f26829cd7c0f$var$i.location.href);
            this.Pi !== t && (this.ii("$url_changed", {
                href: t
            }), this.Pi = t);
        }
    }
    Ii() {
        if (this.Ht.length) {
            var t = [
                ...this.Ht
            ];
            this.Ht = [], t.forEach((t)=>{
                Date.now() - t.enqueuedAt <= 2e3 && this.$i(t);
            });
        }
    }
    di(t) {
        var i = this.N.config.session_recording;
        if (i.maskNetworkRequestFn) {
            var e, r = {
                url: t
            };
            return null == (e = r = i.maskNetworkRequestFn(r)) ? void 0 : e.url;
        }
        return t;
    }
    ai() {
        return this.M = {
            size: 0,
            data: [],
            sessionId: this.kt,
            windowId: this.oi
        }, this.M;
    }
    Zt() {
        this.Fi && (clearTimeout(this.Fi), this.Fi = void 0);
        var t = this.Lt, i = this.Mt, e = $b090f26829cd7c0f$var$F(i) && i >= 0, r = $b090f26829cd7c0f$var$F(t) && e && i < t;
        if (this.status === $b090f26829cd7c0f$var$Ur || this.status === $b090f26829cd7c0f$var$qr || this.status === $b090f26829cd7c0f$var$Lr || r) return this.Fi = setTimeout(()=>{
            this.Zt();
        }, 2e3), this.M;
        this.M.data.length > 0 && $b090f26829cd7c0f$var$Ne(this.M).forEach((t)=>{
            this.Ai({
                $snapshot_bytes: t.size,
                $snapshot_data: t.data,
                $session_id: t.sessionId,
                $window_id: t.windowId,
                $lib: "web",
                $lib_version: $b090f26829cd7c0f$var$f.LIB_VERSION
            });
        });
        return this.ai();
    }
    Oi(t) {
        var i, e = 2 + ((null == (i = this.M) ? void 0 : i.data.length) || 0);
        !this.Wt && (this.M.size + t.$snapshot_bytes + e > 943718.4 || this.M.sessionId !== this.kt) && (this.M = this.Zt()), this.M.size += t.$snapshot_bytes, this.M.data.push(t.$snapshot_data), this.Fi || this.Wt || (this.Fi = setTimeout(()=>{
            this.Zt();
        }, 2e3));
    }
    Ai(t) {
        this.N.capture("$snapshot", t, {
            _url: this.N.requestRouter.endpointFor("api", this.si),
            _noTruncate: !0,
            _batchKey: "recordings",
            skip_client_rate_limiting: !0
        });
    }
    Ci(t) {
        var i, e;
        this.Rt.triggerStatus(this.sessionId) === $b090f26829cd7c0f$var$Wr && (null == (i = this.N) || null == (e = i.persistence) || e.register({
            ["url" === t ? $b090f26829cd7c0f$var$kt : $b090f26829cd7c0f$var$xt]: this.kt
        }), this.Zt(), this.pi(t + "_trigger_matched"));
    }
    Ti() {
        this.Ut.urlBlocked || (this.Ut.urlBlocked = !0, clearInterval(this.vi), $b090f26829cd7c0f$var$ss.info("recording paused due to URL blocker"), this.ii("recording paused", {
            reason: "url blocker"
        }));
    }
    Mi() {
        this.Ut.urlBlocked && (this.Ut.urlBlocked = !1, this.ki(), this.Si(), this.ii("recording resumed", {
            reason: "left blocked url"
        }), $b090f26829cd7c0f$var$ss.info("recording resumed"));
    }
    ui() {
        0 !== this.qt.St.length && $b090f26829cd7c0f$var$O(this.Xt) && (this.Xt = this.N.on("eventCaptured", (t)=>{
            try {
                this.qt.St.includes(t.event) && this.Ci("event");
            } catch (t) {
                $b090f26829cd7c0f$var$ss.error("Could not activate event trigger", t);
            }
        }));
    }
    overrideLinkedFlag() {
        this.Bt.linkedFlagSeen = !0, this.ki(), this.pi("linked_flag_overridden");
    }
    overrideSampling() {
        var t;
        null == (t = this.N.persistence) || t.register({
            [$b090f26829cd7c0f$var$$t]: !0
        }), this.ki(), this.pi("sampling_overridden");
    }
    overrideTrigger(t) {
        this.Ci(t);
    }
    pi(t, i) {
        this.N.register_for_session({
            $session_recording_start_reason: t
        }), $b090f26829cd7c0f$var$ss.info(t.replace("_", " "), i), $b090f26829cd7c0f$var$m([
            "recording_initialized",
            "session_id_changed"
        ], t) || this.ii(t, i);
    }
    get sdkDebugProperties() {
        var { sessionStartTimestamp: t } = this.It.checkAndGetSessionAndWindowId(!0);
        return {
            $recording_status: this.status,
            $sdk_debug_replay_internal_buffer_length: this.M.data.length,
            $sdk_debug_replay_internal_buffer_size: this.M.size,
            $sdk_debug_current_session_duration: this.Mt,
            $sdk_debug_session_start: t
        };
    }
}
var $b090f26829cd7c0f$var$vs = $b090f26829cd7c0f$var$z("[SegmentIntegration]");
function $b090f26829cd7c0f$var$cs(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || $b090f26829cd7c0f$var$ji();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property($b090f26829cd7c0f$var$Ft, "identified")), i();
        }, s = e.user();
        "then" in s && $b090f26829cd7c0f$var$E(s.then) ? s.then((t)=>r(t)) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || $b090f26829cd7c0f$var$vs.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                var r;
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || ($b090f26829cd7c0f$var$vs.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && ($b090f26829cd7c0f$var$vs.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var s = t.Di(e, null !== (r = i.event.properties) && void 0 !== r ? r : {}, new Date);
                return i.event.properties = Object.assign({}, s, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var $b090f26829cd7c0f$var$fs = "posthog-js";
function $b090f26829cd7c0f$var$ps(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ] } = void 0 === i ? {} : i;
    return (i)=>{
        var o, a, l, h, u;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var d = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = d, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var v = (null == (o = i.exception) ? void 0 : o.values) || [], c = v.map((t)=>$b090f26829cd7c0f$var$B({}, t, {
                stacktrace: t.stacktrace ? $b090f26829cd7c0f$var$B({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$b090f26829cd7c0f$var$B({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), f = {
            $exception_message: (null == (a = v[0]) ? void 0 : a.value) || i.message,
            $exception_type: null == (l = v[0]) ? void 0 : l.type,
            $exception_personURL: d,
            $exception_level: i.level,
            $exception_list: c,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (h = v[0]) ? void 0 : h.value) || i.message,
            $sentry_exception_type: null == (u = v[0]) ? void 0 : u.type,
            $sentry_tags: i.tags
        };
        return e && r && (f.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), t.exceptions.sendExceptionEvent(f), i;
    };
}
class $b090f26829cd7c0f$var$gs {
    constructor(t, i, e, r, s){
        this.name = $b090f26829cd7c0f$var$fs, this.setupOnce = function(n) {
            n($b090f26829cd7c0f$var$ps(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s
            }));
        };
    }
}
var $b090f26829cd7c0f$var$_s, $b090f26829cd7c0f$var$ms = null != $b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$i.location ? $b090f26829cd7c0f$var$ki($b090f26829cd7c0f$var$i.location.hash, "__posthog") || $b090f26829cd7c0f$var$ki(location.hash, "state") : null, $b090f26829cd7c0f$var$bs = "_postHogToolbarParams", $b090f26829cd7c0f$var$ws = $b090f26829cd7c0f$var$z("[Toolbar]");
!function(t) {
    t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED";
}($b090f26829cd7c0f$var$_s || ($b090f26829cd7c0f$var$_s = {}));
class $b090f26829cd7c0f$var$ys {
    constructor(t){
        this.instance = t;
    }
    ji(t) {
        $b090f26829cd7c0f$var$c.ph_toolbar_state = t;
    }
    Li() {
        var t;
        return null !== (t = $b090f26829cd7c0f$var$c.ph_toolbar_state) && void 0 !== t ? t : $b090f26829cd7c0f$var$_s.UNINITIALIZED;
    }
    maybeLoadToolbar(t, e, r) {
        var s, n;
        if (void 0 === t && (t = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), !$b090f26829cd7c0f$var$i || !$b090f26829cd7c0f$var$a) return !1;
        t = null !== (s = t) && void 0 !== s ? s : $b090f26829cd7c0f$var$i.location, r = null !== (n = r) && void 0 !== n ? n : $b090f26829cd7c0f$var$i.history;
        try {
            if (!e) {
                try {
                    $b090f26829cd7c0f$var$i.localStorage.setItem("test", "test"), $b090f26829cd7c0f$var$i.localStorage.removeItem("test");
                } catch (t) {
                    return !1;
                }
                e = null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.localStorage;
            }
            var o, l = $b090f26829cd7c0f$var$ms || $b090f26829cd7c0f$var$ki(t.hash, "__posthog") || $b090f26829cd7c0f$var$ki(t.hash, "state"), h = l ? $b090f26829cd7c0f$var$X(()=>JSON.parse(atob(decodeURIComponent(l)))) || $b090f26829cd7c0f$var$X(()=>JSON.parse(decodeURIComponent(l))) : null;
            return h && "ph_authorize" === h.action ? ((o = h).source = "url", o && Object.keys(o).length > 0 && (h.desiredHash ? t.hash = h.desiredHash : r ? r.replaceState(r.state, "", t.pathname + t.search) : t.hash = "")) : ((o = JSON.parse(e.getItem($b090f26829cd7c0f$var$bs) || "{}")).source = "localstorage", delete o.userIntent), !(!o.token || this.instance.config.token !== o.token) && (this.loadToolbar(o), !0);
        } catch (t) {
            return !1;
        }
    }
    Ni(t) {
        var i = $b090f26829cd7c0f$var$c.ph_load_toolbar || $b090f26829cd7c0f$var$c.ph_load_editor;
        !$b090f26829cd7c0f$var$O(i) && $b090f26829cd7c0f$var$E(i) ? i(t, this.instance) : $b090f26829cd7c0f$var$ws.warn("No toolbar load function found");
    }
    loadToolbar(t) {
        var e = !(null == $b090f26829cd7c0f$var$a || !$b090f26829cd7c0f$var$a.getElementById($b090f26829cd7c0f$var$Ut));
        if (!$b090f26829cd7c0f$var$i || e) return !1;
        var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $b090f26829cd7c0f$var$B({
            token: this.instance.config.token
        }, t, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, r ? {
            instrument: !1
        } : {});
        if ($b090f26829cd7c0f$var$i.localStorage.setItem($b090f26829cd7c0f$var$bs, JSON.stringify($b090f26829cd7c0f$var$B({}, s, {
            source: void 0
        }))), this.Li() === $b090f26829cd7c0f$var$_s.LOADED) this.Ni(s);
        else if (this.Li() === $b090f26829cd7c0f$var$_s.UNINITIALIZED) {
            var n;
            this.ji($b090f26829cd7c0f$var$_s.LOADING), null == (n = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                if (t) return $b090f26829cd7c0f$var$ws.error("[Toolbar] Failed to load", t), void this.ji($b090f26829cd7c0f$var$_s.UNINITIALIZED);
                this.ji($b090f26829cd7c0f$var$_s.LOADED), this.Ni(s);
            }), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "turbolinks:load", ()=>{
                this.ji($b090f26829cd7c0f$var$_s.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    zi(t) {
        return this.loadToolbar(t);
    }
    maybeLoadEditor(t, i, e) {
        return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
    }
}
var $b090f26829cd7c0f$var$Ss = $b090f26829cd7c0f$var$z("[TracingHeaders]");
class $b090f26829cd7c0f$var$$s {
    constructor(t){
        this.Ui = void 0, this.qi = void 0, this.K = ()=>{
            var t, i, e, r;
            $b090f26829cd7c0f$var$R(this.Ui) && (null == (t = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == (i = t.tracingHeadersPatchFns) || i._patchXHR(this.N.sessionManager));
            $b090f26829cd7c0f$var$R(this.qi) && (null == (e = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == (r = e.tracingHeadersPatchFns) || r._patchFetch(this.N.sessionManager));
        }, this.N = t;
    }
    J(t) {
        var i, e;
        null != (i = $b090f26829cd7c0f$var$c.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.N, "tracing-headers", (i)=>{
            if (i) return $b090f26829cd7c0f$var$Ss.error("failed to load script", i);
            t();
        });
    }
    startIfEnabledOrStop() {
        var t, i;
        this.N.config.__add_tracing_headers ? this.J(this.K) : (null == (t = this.Ui) || t.call(this), null == (i = this.qi) || i.call(this), this.Ui = void 0, this.qi = void 0);
    }
}
var $b090f26829cd7c0f$var$ks = $b090f26829cd7c0f$var$z("[Web Vitals]"), $b090f26829cd7c0f$var$xs = 9e5;
class $b090f26829cd7c0f$var$Es {
    constructor(t){
        var i;
        this.Bi = !1, this.i = !1, this.M = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }, this.Hi = ()=>{
            clearTimeout(this.Wi), 0 !== this.M.metrics.length && (this.N.capture("$web_vitals", this.M.metrics.reduce((t, i)=>$b090f26829cd7c0f$var$B({}, t, {
                    ["$web_vitals_" + i.name + "_event"]: $b090f26829cd7c0f$var$B({}, i),
                    ["$web_vitals_" + i.name + "_value"]: i.value
                }), {})), this.M = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }, this.Gi = (t)=>{
            var i, e = null == (i = this.N.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
            if ($b090f26829cd7c0f$var$R(e)) $b090f26829cd7c0f$var$ks.error("Could not read session ID. Dropping metrics!");
            else {
                this.M = this.M || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = this.Ji();
                if (!$b090f26829cd7c0f$var$R(r)) {
                    if ($b090f26829cd7c0f$var$O(null == t ? void 0 : t.name) || $b090f26829cd7c0f$var$O(null == t ? void 0 : t.value)) $b090f26829cd7c0f$var$ks.error("Invalid metric received", t);
                    else if (this.Vi && t.value >= this.Vi) $b090f26829cd7c0f$var$ks.error("Ignoring metric with value >= " + this.Vi, t);
                    else this.M.url !== r && (this.Hi(), this.Wi = setTimeout(this.Hi, this.flushToCaptureTimeoutMs)), $b090f26829cd7c0f$var$R(this.M.url) && (this.M.url = r), this.M.firstMetricTimestamp = $b090f26829cd7c0f$var$R(this.M.firstMetricTimestamp) ? Date.now() : this.M.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.M.metrics.push($b090f26829cd7c0f$var$B({}, t, {
                        $current_url: r,
                        $session_id: e.sessionId,
                        $window_id: e.windowId,
                        timestamp: Date.now()
                    })), this.M.metrics.length === this.allowedMetrics.length && this.Hi();
                }
            }
        }, this.K = ()=>{
            var t, i, e, r, s = $b090f26829cd7c0f$var$c.__PosthogExtensions__;
            $b090f26829cd7c0f$var$R(s) || $b090f26829cd7c0f$var$R(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.Gi.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.Gi.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.Gi.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.Gi.bind(this)), this.i = !0) : $b090f26829cd7c0f$var$ks.error("web vitals callbacks not loaded - not starting");
        }, this.N = t, this.Bi = !(null == (i = this.N.persistence) || !i.props[$b090f26829cd7c0f$var$dt]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var t, i, e = $b090f26829cd7c0f$var$I(this.N.config.capture_performance) ? null == (t = this.N.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
        return $b090f26829cd7c0f$var$R(e) ? (null == (i = this.N.persistence) ? void 0 : i.props[$b090f26829cd7c0f$var$ct]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : e;
    }
    get flushToCaptureTimeoutMs() {
        return ($b090f26829cd7c0f$var$I(this.N.config.capture_performance) ? this.N.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get Vi() {
        var t = $b090f26829cd7c0f$var$I(this.N.config.capture_performance) && $b090f26829cd7c0f$var$F(this.N.config.capture_performance.__web_vitals_max_value) ? this.N.config.capture_performance.__web_vitals_max_value : $b090f26829cd7c0f$var$xs;
        return 0 < t && t <= 6e4 ? $b090f26829cd7c0f$var$xs : t;
    }
    get isEnabled() {
        var t = null == $b090f26829cd7c0f$var$l ? void 0 : $b090f26829cd7c0f$var$l.protocol;
        if ("http:" !== t && "https:" !== t) return $b090f26829cd7c0f$var$ks.info("Web Vitals are disabled on non-http/https protocols"), !1;
        var i = $b090f26829cd7c0f$var$I(this.N.config.capture_performance) ? this.N.config.capture_performance.web_vitals : $b090f26829cd7c0f$var$A(this.N.config.capture_performance) ? this.N.config.capture_performance : void 0;
        return $b090f26829cd7c0f$var$A(i) ? i : this.Bi;
    }
    startIfEnabled() {
        this.isEnabled && !this.i && ($b090f26829cd7c0f$var$ks.info("enabled, starting..."), this.J(this.K));
    }
    onRemoteConfig(t) {
        var i = $b090f26829cd7c0f$var$I(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = $b090f26829cd7c0f$var$I(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
        this.N.persistence && (this.N.persistence.register({
            [$b090f26829cd7c0f$var$dt]: i
        }), this.N.persistence.register({
            [$b090f26829cd7c0f$var$ct]: e
        })), this.Bi = i, this.startIfEnabled();
    }
    J(t) {
        var i, e;
        null != (i = $b090f26829cd7c0f$var$c.__PosthogExtensions__) && i.postHogWebVitalsCallbacks && t(), null == (e = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.N, "web-vitals", (i)=>{
            i ? $b090f26829cd7c0f$var$ks.error("failed to load script", i) : t();
        });
    }
    Ji() {
        var t = $b090f26829cd7c0f$var$i ? $b090f26829cd7c0f$var$i.location.href : void 0;
        return t || $b090f26829cd7c0f$var$ks.error("Could not determine current URL"), t;
    }
}
var $b090f26829cd7c0f$var$Is = $b090f26829cd7c0f$var$z("[Heatmaps]");
function $b090f26829cd7c0f$var$Ps(t) {
    return $b090f26829cd7c0f$var$I(t) && "clientX" in t && "clientY" in t && $b090f26829cd7c0f$var$F(t.clientX) && $b090f26829cd7c0f$var$F(t.clientY);
}
class $b090f26829cd7c0f$var$Rs {
    constructor(t){
        var i;
        this.rageclicks = new $b090f26829cd7c0f$var$mi, this.Bi = !1, this.i = !1, this.Ki = null, this.instance = t, this.Bi = !(null == (i = this.instance.persistence) || !i.props[$b090f26829cd7c0f$var$ht]);
    }
    get flushIntervalMilliseconds() {
        var t = 5e3;
        return $b090f26829cd7c0f$var$I(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
    }
    get isEnabled() {
        return $b090f26829cd7c0f$var$R(this.instance.config.capture_heatmaps) ? $b090f26829cd7c0f$var$R(this.instance.config.enable_heatmaps) ? this.Bi : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this.i) return;
            $b090f26829cd7c0f$var$Is.info("starting..."), this.Yi(), this.Ki = setInterval(this.Xi.bind(this), this.flushIntervalMilliseconds);
        } else {
            var t, i;
            clearInterval(null !== (t = this.Ki) && void 0 !== t ? t : void 0), null == (i = this.Qi) || i.stop(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(t) {
        var i = !!t.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [$b090f26829cd7c0f$var$ht]: i
        }), this.Bi = i, this.startIfEnabled();
    }
    getAndClearBuffer() {
        var t = this.M;
        return this.M = void 0, t;
    }
    Zi(t) {
        this.te(t.originalEvent, "deadclick");
    }
    Yi() {
        $b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$a && ($b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "beforeunload", this.Xi.bind(this)), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "click", (t)=>this.te(t || (null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.event)), {
            capture: !0
        }), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "mousemove", (t)=>this.ie(t || (null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.event)), {
            capture: !0
        }), this.Qi = new $b090f26829cd7c0f$var$re(this.instance, $b090f26829cd7c0f$var$ie, this.Zi.bind(this)), this.Qi.startIfEnabled(), this.i = !0);
    }
    ee(t, e) {
        var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(t, e, r) {
            for(var s = t; s && $b090f26829cd7c0f$var$Wt(s) && !$b090f26829cd7c0f$var$Gt(s, "body");){
                if (s === r) return !1;
                if ($b090f26829cd7c0f$var$m(e, null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.getComputedStyle(s).position)) return !0;
                s = $b090f26829cd7c0f$var$ei(s);
            }
            return !1;
        }($b090f26829cd7c0f$var$ti(t), [
            "fixed",
            "sticky"
        ], n);
        return {
            x: t.clientX + (o ? 0 : s),
            y: t.clientY + (o ? 0 : r),
            target_fixed: o,
            type: e
        };
    }
    te(t, i) {
        var e;
        if (void 0 === i && (i = "click"), !$b090f26829cd7c0f$var$Ht(t.target) && $b090f26829cd7c0f$var$Ps(t)) {
            var r = this.ee(t, i);
            null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.re($b090f26829cd7c0f$var$B({}, r, {
                type: "rageclick"
            })), this.re(r);
        }
    }
    ie(t) {
        !$b090f26829cd7c0f$var$Ht(t.target) && $b090f26829cd7c0f$var$Ps(t) && (clearTimeout(this.se), this.se = setTimeout(()=>{
            this.re(this.ee(t, "mousemove"));
        }, 500));
    }
    re(t) {
        if ($b090f26829cd7c0f$var$i) {
            var e = $b090f26829cd7c0f$var$i.location.href;
            this.M = this.M || {}, this.M[e] || (this.M[e] = []), this.M[e].push(t);
        }
    }
    Xi() {
        this.M && !$b090f26829cd7c0f$var$P(this.M) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class $b090f26829cd7c0f$var$Ts {
    constructor(t){
        this.N = t;
    }
    doPageView(t, e) {
        var r, s = this.ne(t, e);
        return this.oe = {
            pathname: null !== (r = null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: t
        }, this.N.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.ne(t, null == (i = this.oe) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.oe) ? void 0 : t.pageViewId
        };
    }
    ne(t, i) {
        var e = this.oe;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this.N.scrollManager.getContext();
        if (s && !this.N.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: h, maxContentY: u } = s;
            if (!($b090f26829cd7c0f$var$R(n) || $b090f26829cd7c0f$var$R(o) || $b090f26829cd7c0f$var$R(a) || $b090f26829cd7c0f$var$R(l) || $b090f26829cd7c0f$var$R(h) || $b090f26829cd7c0f$var$R(u))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), h = Math.ceil(h), u = Math.ceil(u);
                var d = n <= 1 ? 1 : $b090f26829cd7c0f$var$Xe(o / n, 0, 1), v = n <= 1 ? 1 : $b090f26829cd7c0f$var$Xe(a / n, 0, 1), c = l <= 1 ? 1 : $b090f26829cd7c0f$var$Xe(h / l, 0, 1), f = l <= 1 ? 1 : $b090f26829cd7c0f$var$Xe(u / l, 0, 1);
                r = $b090f26829cd7c0f$var$V(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: h,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: u,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
class $b090f26829cd7c0f$var$Ms {
    constructor(t){
        this.N = t;
    }
    sendExceptionEvent(t) {
        this.N.capture("$exception", t, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent"
        });
    }
}
var $b090f26829cd7c0f$var$Cs = "Mobile", $b090f26829cd7c0f$var$Os = "iOS", $b090f26829cd7c0f$var$Fs = "Android", $b090f26829cd7c0f$var$As = "Tablet", $b090f26829cd7c0f$var$Ds = $b090f26829cd7c0f$var$Fs + " " + $b090f26829cd7c0f$var$As, $b090f26829cd7c0f$var$js = "iPad", $b090f26829cd7c0f$var$Ls = "Apple", $b090f26829cd7c0f$var$Ns = $b090f26829cd7c0f$var$Ls + " Watch", $b090f26829cd7c0f$var$zs = "Safari", $b090f26829cd7c0f$var$Us = "BlackBerry", $b090f26829cd7c0f$var$qs = "Samsung", $b090f26829cd7c0f$var$Bs = $b090f26829cd7c0f$var$qs + "Browser", $b090f26829cd7c0f$var$Hs = $b090f26829cd7c0f$var$qs + " Internet", $b090f26829cd7c0f$var$Ws = "Chrome", $b090f26829cd7c0f$var$Gs = $b090f26829cd7c0f$var$Ws + " OS", $b090f26829cd7c0f$var$Js = $b090f26829cd7c0f$var$Ws + " " + $b090f26829cd7c0f$var$Os, $b090f26829cd7c0f$var$Vs = "Internet Explorer", $b090f26829cd7c0f$var$Ks = $b090f26829cd7c0f$var$Vs + " " + $b090f26829cd7c0f$var$Cs, $b090f26829cd7c0f$var$Ys = "Opera", $b090f26829cd7c0f$var$Xs = $b090f26829cd7c0f$var$Ys + " Mini", $b090f26829cd7c0f$var$Qs = "Edge", $b090f26829cd7c0f$var$Zs = "Microsoft " + $b090f26829cd7c0f$var$Qs, $b090f26829cd7c0f$var$tn = "Firefox", $b090f26829cd7c0f$var$en = $b090f26829cd7c0f$var$tn + " " + $b090f26829cd7c0f$var$Os, $b090f26829cd7c0f$var$rn = "Nintendo", $b090f26829cd7c0f$var$sn = "PlayStation", $b090f26829cd7c0f$var$nn = "Xbox", $b090f26829cd7c0f$var$on = $b090f26829cd7c0f$var$Fs + " " + $b090f26829cd7c0f$var$Cs, $b090f26829cd7c0f$var$an = $b090f26829cd7c0f$var$Cs + " " + $b090f26829cd7c0f$var$zs, $b090f26829cd7c0f$var$ln = "Windows", $b090f26829cd7c0f$var$hn = $b090f26829cd7c0f$var$ln + " Phone", $b090f26829cd7c0f$var$un = "Nokia", $b090f26829cd7c0f$var$dn = "Ouya", $b090f26829cd7c0f$var$vn = "Generic", $b090f26829cd7c0f$var$cn = $b090f26829cd7c0f$var$vn + " " + $b090f26829cd7c0f$var$Cs.toLowerCase(), $b090f26829cd7c0f$var$fn = $b090f26829cd7c0f$var$vn + " " + $b090f26829cd7c0f$var$As.toLowerCase(), $b090f26829cd7c0f$var$pn = "Konqueror", $b090f26829cd7c0f$var$gn = "(\\d+(\\.\\d+)?)", $b090f26829cd7c0f$var$_n = new RegExp("Version/" + $b090f26829cd7c0f$var$gn), $b090f26829cd7c0f$var$mn = new RegExp($b090f26829cd7c0f$var$nn, "i"), $b090f26829cd7c0f$var$bn = new RegExp($b090f26829cd7c0f$var$sn + " \\w+", "i"), $b090f26829cd7c0f$var$wn = new RegExp($b090f26829cd7c0f$var$rn + " \\w+", "i"), $b090f26829cd7c0f$var$yn = new RegExp($b090f26829cd7c0f$var$Us + "|PlayBook|BB10", "i"), $b090f26829cd7c0f$var$Sn = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $b090f26829cd7c0f$var$$n = (t, i)=>i && $b090f26829cd7c0f$var$m(i, $b090f26829cd7c0f$var$Ls) || function(t) {
        return $b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$zs) && !$b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$Ws) && !$b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$Fs);
    }(t), $b090f26829cd7c0f$var$kn = function(t, i) {
    return i = i || "", $b090f26829cd7c0f$var$m(t, " OPR/") && $b090f26829cd7c0f$var$m(t, "Mini") ? $b090f26829cd7c0f$var$Xs : $b090f26829cd7c0f$var$m(t, " OPR/") ? $b090f26829cd7c0f$var$Ys : $b090f26829cd7c0f$var$yn.test(t) ? $b090f26829cd7c0f$var$Us : $b090f26829cd7c0f$var$m(t, "IE" + $b090f26829cd7c0f$var$Cs) || $b090f26829cd7c0f$var$m(t, "WPDesktop") ? $b090f26829cd7c0f$var$Ks : $b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$Bs) ? $b090f26829cd7c0f$var$Hs : $b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$Qs) || $b090f26829cd7c0f$var$m(t, "Edg/") ? $b090f26829cd7c0f$var$Zs : $b090f26829cd7c0f$var$m(t, "FBIOS") ? "Facebook " + $b090f26829cd7c0f$var$Cs : $b090f26829cd7c0f$var$m(t, "UCWEB") || $b090f26829cd7c0f$var$m(t, "UCBrowser") ? "UC Browser" : $b090f26829cd7c0f$var$m(t, "CriOS") ? $b090f26829cd7c0f$var$Js : $b090f26829cd7c0f$var$m(t, "CrMo") || $b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$Ws) ? $b090f26829cd7c0f$var$Ws : $b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$Fs) && $b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$zs) ? $b090f26829cd7c0f$var$on : $b090f26829cd7c0f$var$m(t, "FxiOS") ? $b090f26829cd7c0f$var$en : $b090f26829cd7c0f$var$m(t.toLowerCase(), $b090f26829cd7c0f$var$pn.toLowerCase()) ? $b090f26829cd7c0f$var$pn : $b090f26829cd7c0f$var$$n(t, i) ? $b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$Cs) ? $b090f26829cd7c0f$var$an : $b090f26829cd7c0f$var$zs : $b090f26829cd7c0f$var$m(t, $b090f26829cd7c0f$var$tn) ? $b090f26829cd7c0f$var$tn : $b090f26829cd7c0f$var$m(t, "MSIE") || $b090f26829cd7c0f$var$m(t, "Trident/") ? $b090f26829cd7c0f$var$Vs : $b090f26829cd7c0f$var$m(t, "Gecko") ? $b090f26829cd7c0f$var$tn : "";
}, $b090f26829cd7c0f$var$xn = {
    [$b090f26829cd7c0f$var$Ks]: [
        new RegExp("rv:" + $b090f26829cd7c0f$var$gn)
    ],
    [$b090f26829cd7c0f$var$Zs]: [
        new RegExp($b090f26829cd7c0f$var$Qs + "?\\/" + $b090f26829cd7c0f$var$gn)
    ],
    [$b090f26829cd7c0f$var$Ws]: [
        new RegExp("(" + $b090f26829cd7c0f$var$Ws + "|CrMo)\\/" + $b090f26829cd7c0f$var$gn)
    ],
    [$b090f26829cd7c0f$var$Js]: [
        new RegExp("CriOS\\/" + $b090f26829cd7c0f$var$gn)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $b090f26829cd7c0f$var$gn)
    ],
    [$b090f26829cd7c0f$var$zs]: [
        $b090f26829cd7c0f$var$_n
    ],
    [$b090f26829cd7c0f$var$an]: [
        $b090f26829cd7c0f$var$_n
    ],
    [$b090f26829cd7c0f$var$Ys]: [
        new RegExp("(Opera|OPR)\\/" + $b090f26829cd7c0f$var$gn)
    ],
    [$b090f26829cd7c0f$var$tn]: [
        new RegExp($b090f26829cd7c0f$var$tn + "\\/" + $b090f26829cd7c0f$var$gn)
    ],
    [$b090f26829cd7c0f$var$en]: [
        new RegExp("FxiOS\\/" + $b090f26829cd7c0f$var$gn)
    ],
    [$b090f26829cd7c0f$var$pn]: [
        new RegExp("Konqueror[:/]?" + $b090f26829cd7c0f$var$gn, "i")
    ],
    [$b090f26829cd7c0f$var$Us]: [
        new RegExp($b090f26829cd7c0f$var$Us + " " + $b090f26829cd7c0f$var$gn),
        $b090f26829cd7c0f$var$_n
    ],
    [$b090f26829cd7c0f$var$on]: [
        new RegExp("android\\s" + $b090f26829cd7c0f$var$gn, "i")
    ],
    [$b090f26829cd7c0f$var$Hs]: [
        new RegExp($b090f26829cd7c0f$var$Bs + "\\/" + $b090f26829cd7c0f$var$gn)
    ],
    [$b090f26829cd7c0f$var$Vs]: [
        new RegExp("(rv:|MSIE )" + $b090f26829cd7c0f$var$gn)
    ],
    Mozilla: [
        new RegExp("rv:" + $b090f26829cd7c0f$var$gn)
    ]
}, $b090f26829cd7c0f$var$En = function(t, i) {
    var e = $b090f26829cd7c0f$var$kn(t, i), r = $b090f26829cd7c0f$var$xn[e];
    if ($b090f26829cd7c0f$var$R(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, $b090f26829cd7c0f$var$In = [
    [
        new RegExp($b090f26829cd7c0f$var$nn + "; " + $b090f26829cd7c0f$var$nn + " (.*?)[);]", "i"),
        (t)=>[
                $b090f26829cd7c0f$var$nn,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($b090f26829cd7c0f$var$rn, "i"),
        [
            $b090f26829cd7c0f$var$rn,
            ""
        ]
    ],
    [
        new RegExp($b090f26829cd7c0f$var$sn, "i"),
        [
            $b090f26829cd7c0f$var$sn,
            ""
        ]
    ],
    [
        $b090f26829cd7c0f$var$yn,
        [
            $b090f26829cd7c0f$var$Us,
            ""
        ]
    ],
    [
        new RegExp($b090f26829cd7c0f$var$ln, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $b090f26829cd7c0f$var$hn,
                ""
            ];
            if (new RegExp($b090f26829cd7c0f$var$Cs).test(i) && !/IEMobile\b/.test(i)) return [
                $b090f26829cd7c0f$var$ln + " " + $b090f26829cd7c0f$var$Cs,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = $b090f26829cd7c0f$var$Sn[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    $b090f26829cd7c0f$var$ln,
                    s
                ];
            }
            return [
                $b090f26829cd7c0f$var$ln,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    $b090f26829cd7c0f$var$Os,
                    i.join(".")
                ];
            }
            return [
                $b090f26829cd7c0f$var$Os,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = $b090f26829cd7c0f$var$R(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + $b090f26829cd7c0f$var$Fs + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $b090f26829cd7c0f$var$Fs + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    $b090f26829cd7c0f$var$Fs,
                    i.join(".")
                ];
            }
            return [
                $b090f26829cd7c0f$var$Fs,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $b090f26829cd7c0f$var$Gs,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $b090f26829cd7c0f$var$Pn = function(t) {
    return $b090f26829cd7c0f$var$wn.test(t) ? $b090f26829cd7c0f$var$rn : $b090f26829cd7c0f$var$bn.test(t) ? $b090f26829cd7c0f$var$sn : $b090f26829cd7c0f$var$mn.test(t) ? $b090f26829cd7c0f$var$nn : new RegExp($b090f26829cd7c0f$var$dn, "i").test(t) ? $b090f26829cd7c0f$var$dn : new RegExp("(" + $b090f26829cd7c0f$var$hn + "|WPDesktop)", "i").test(t) ? $b090f26829cd7c0f$var$hn : /iPad/.test(t) ? $b090f26829cd7c0f$var$js : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $b090f26829cd7c0f$var$Ns : $b090f26829cd7c0f$var$yn.test(t) ? $b090f26829cd7c0f$var$Us : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($b090f26829cd7c0f$var$un, "i").test(t) ? $b090f26829cd7c0f$var$un : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? !new RegExp($b090f26829cd7c0f$var$Cs).test(t) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) ? /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $b090f26829cd7c0f$var$Fs : $b090f26829cd7c0f$var$Ds : $b090f26829cd7c0f$var$Fs : new RegExp("(pda|" + $b090f26829cd7c0f$var$Cs + ")", "i").test(t) ? $b090f26829cd7c0f$var$cn : new RegExp($b090f26829cd7c0f$var$As, "i").test(t) && !new RegExp($b090f26829cd7c0f$var$As + " pc", "i").test(t) ? $b090f26829cd7c0f$var$fn : "";
}, $b090f26829cd7c0f$var$Rn = "https?://(.*)", $b090f26829cd7c0f$var$Tn = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $b090f26829cd7c0f$var$Mn = $b090f26829cd7c0f$var$K([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], $b090f26829cd7c0f$var$Tn), $b090f26829cd7c0f$var$Cn = "<masked>";
function $b090f26829cd7c0f$var$On(t, i, e) {
    if (!$b090f26829cd7c0f$var$a) return {};
    var r = i ? $b090f26829cd7c0f$var$K([], $b090f26829cd7c0f$var$Tn, e || []) : [];
    return $b090f26829cd7c0f$var$Fn($b090f26829cd7c0f$var$$i($b090f26829cd7c0f$var$a.URL, r, $b090f26829cd7c0f$var$Cn), t);
}
function $b090f26829cd7c0f$var$Fn(t, i) {
    var e = $b090f26829cd7c0f$var$Mn.concat(i || []), r = {};
    return $b090f26829cd7c0f$var$J(e, function(i) {
        var e = $b090f26829cd7c0f$var$Si(t, i);
        r[i] = e || null;
    }), r;
}
function $b090f26829cd7c0f$var$An(t) {
    var i = function(t) {
        return t ? 0 === t.search($b090f26829cd7c0f$var$Rn + "google.([^/?]*)") ? "google" : 0 === t.search($b090f26829cd7c0f$var$Rn + "bing.com") ? "bing" : 0 === t.search($b090f26829cd7c0f$var$Rn + "yahoo.com") ? "yahoo" : 0 === t.search($b090f26829cd7c0f$var$Rn + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!$b090f26829cd7c0f$var$C(i)) {
        r.$search_engine = i;
        var s = $b090f26829cd7c0f$var$a ? $b090f26829cd7c0f$var$Si($b090f26829cd7c0f$var$a.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function $b090f26829cd7c0f$var$Dn() {
    return navigator.language || navigator.userLanguage;
}
function $b090f26829cd7c0f$var$jn() {
    return (null == $b090f26829cd7c0f$var$a ? void 0 : $b090f26829cd7c0f$var$a.referrer) || "$direct";
}
function $b090f26829cd7c0f$var$Ln(t, i) {
    var e = t ? $b090f26829cd7c0f$var$K([], $b090f26829cd7c0f$var$Tn, i || []) : [], r = null == $b090f26829cd7c0f$var$l ? void 0 : $b090f26829cd7c0f$var$l.href.substring(0, 1e3);
    return {
        r: $b090f26829cd7c0f$var$jn().substring(0, 1e3),
        u: r ? $b090f26829cd7c0f$var$$i(r, e, $b090f26829cd7c0f$var$Cn) : void 0
    };
}
function $b090f26829cd7c0f$var$Nn(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = $b090f26829cd7c0f$var$wi(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = $b090f26829cd7c0f$var$wi(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $b090f26829cd7c0f$var$Fn(r);
        $b090f26829cd7c0f$var$V(s, o);
    }
    if (e) {
        var a = $b090f26829cd7c0f$var$An(e);
        $b090f26829cd7c0f$var$V(s, a);
    }
    return s;
}
function $b090f26829cd7c0f$var$zn() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $b090f26829cd7c0f$var$Un() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function $b090f26829cd7c0f$var$qn(t, e) {
    if (!$b090f26829cd7c0f$var$v) return {};
    var r, s, n, o = t ? $b090f26829cd7c0f$var$K([], $b090f26829cd7c0f$var$Tn, e || []) : [], [a, h] = function(t) {
        for(var i = 0; i < $b090f26829cd7c0f$var$In.length; i++){
            var [e, r] = $b090f26829cd7c0f$var$In[i], s = e.exec(t), n = s && ($b090f26829cd7c0f$var$E(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }($b090f26829cd7c0f$var$v);
    return $b090f26829cd7c0f$var$V($b090f26829cd7c0f$var$Z({
        $os: a,
        $os_version: h,
        $browser: $b090f26829cd7c0f$var$kn($b090f26829cd7c0f$var$v, navigator.vendor),
        $device: $b090f26829cd7c0f$var$Pn($b090f26829cd7c0f$var$v),
        $device_type: (s = $b090f26829cd7c0f$var$v, n = $b090f26829cd7c0f$var$Pn(s), n === $b090f26829cd7c0f$var$js || n === $b090f26829cd7c0f$var$Ds || "Kobo" === n || "Kindle Fire" === n || n === $b090f26829cd7c0f$var$fn ? $b090f26829cd7c0f$var$As : n === $b090f26829cd7c0f$var$rn || n === $b090f26829cd7c0f$var$nn || n === $b090f26829cd7c0f$var$sn || n === $b090f26829cd7c0f$var$dn ? "Console" : n === $b090f26829cd7c0f$var$Ns ? "Wearable" : n ? $b090f26829cd7c0f$var$Cs : "Desktop"),
        $timezone: $b090f26829cd7c0f$var$zn(),
        $timezone_offset: $b090f26829cd7c0f$var$Un()
    }), {
        $current_url: $b090f26829cd7c0f$var$$i(null == $b090f26829cd7c0f$var$l ? void 0 : $b090f26829cd7c0f$var$l.href, o, $b090f26829cd7c0f$var$Cn),
        $host: null == $b090f26829cd7c0f$var$l ? void 0 : $b090f26829cd7c0f$var$l.host,
        $pathname: null == $b090f26829cd7c0f$var$l ? void 0 : $b090f26829cd7c0f$var$l.pathname,
        $raw_user_agent: $b090f26829cd7c0f$var$v.length > 1e3 ? $b090f26829cd7c0f$var$v.substring(0, 997) + "..." : $b090f26829cd7c0f$var$v,
        $browser_version: $b090f26829cd7c0f$var$En($b090f26829cd7c0f$var$v, navigator.vendor),
        $browser_language: $b090f26829cd7c0f$var$Dn(),
        $browser_language_prefix: (r = $b090f26829cd7c0f$var$Dn(), "string" == typeof r ? r.split("-")[0] : void 0),
        $screen_height: null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.screen.height,
        $screen_width: null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.screen.width,
        $viewport_height: null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.innerHeight,
        $viewport_width: null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.innerWidth,
        $lib: "web",
        $lib_version: $b090f26829cd7c0f$var$f.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var $b090f26829cd7c0f$var$Bn, $b090f26829cd7c0f$var$Hn = $b090f26829cd7c0f$var$z("[FeatureFlags]"), $b090f26829cd7c0f$var$Wn = "$active_feature_flags", $b090f26829cd7c0f$var$Gn = "$override_feature_flags", $b090f26829cd7c0f$var$Jn = "$feature_flag_payloads", $b090f26829cd7c0f$var$Vn = "$override_feature_flag_payloads", $b090f26829cd7c0f$var$Kn = "$feature_flag_request_id", $b090f26829cd7c0f$var$Yn = (t)=>{
    var i = {};
    for (var [e, r] of $b090f26829cd7c0f$var$Y(t || {}))r && (i[e] = r);
    return i;
}, $b090f26829cd7c0f$var$Xn = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : $b090f26829cd7c0f$var$Hn.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
};
!function(t) {
    t.FeatureFlags = "feature_flags", t.Recordings = "recordings";
}($b090f26829cd7c0f$var$Bn || ($b090f26829cd7c0f$var$Bn = {}));
class $b090f26829cd7c0f$var$Qn {
    constructor(t){
        this.ae = !1, this.le = !1, this.he = !1, this.ue = !1, this.de = !1, this.ve = !1, this.ce = !1, this.N = t, this.featureFlagEventHandlers = [];
    }
    decide() {
        if (this.N.config.__preview_remote_config) this.ve = !0;
        else {
            var t = !this.fe && (this.N.config.advanced_disable_feature_flags || this.N.config.advanced_disable_feature_flags_on_first_load);
            this.pe({
                disableFlags: t
            });
        }
    }
    get hasLoadedFlags() {
        return this.le;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagsWithDetails() {
        var t = this.N.get_property($b090f26829cd7c0f$var$Pt), i = this.N.get_property($b090f26829cd7c0f$var$Gn), e = this.N.get_property($b090f26829cd7c0f$var$Vn);
        if (!e && !i) return t || {};
        var r = $b090f26829cd7c0f$var$V({}, t || {}), s = [
            ...new Set([
                ...Object.keys(e || {}),
                ...Object.keys(i || {})
            ])
        ];
        for (var n of s){
            var o, a, l = r[n], h = null == i ? void 0 : i[n], u = $b090f26829cd7c0f$var$R(h) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!h, d = $b090f26829cd7c0f$var$R(h) ? l.variant : "string" == typeof h ? h : void 0, v = null == e ? void 0 : e[n], c = $b090f26829cd7c0f$var$B({}, l, {
                enabled: u,
                variant: u ? null != d ? d : null == l ? void 0 : l.variant : void 0
            });
            if (u !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = $b090f26829cd7c0f$var$B({}, null == l ? void 0 : l.metadata, {
                payload: v,
                original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
            });
            r[n] = c;
        }
        return this.ae || ($b090f26829cd7c0f$var$Hn.warn(" Overriding feature flag details!", {
            flagDetails: t,
            overriddenPayloads: e,
            finalDetails: r
        }), this.ae = !0), r;
    }
    getFlagVariants() {
        var t = this.N.get_property($b090f26829cd7c0f$var$Et), i = this.N.get_property($b090f26829cd7c0f$var$Gn);
        if (!i) return t || {};
        for(var e = $b090f26829cd7c0f$var$V({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ae || ($b090f26829cd7c0f$var$Hn.warn(" Overriding feature flags!", {
            enabledFlags: t,
            overriddenFlags: i,
            finalFlags: e
        }), this.ae = !0), e;
    }
    getFlagPayloads() {
        var t = this.N.get_property($b090f26829cd7c0f$var$Jn), i = this.N.get_property($b090f26829cd7c0f$var$Vn);
        if (!i) return t || {};
        for(var e = $b090f26829cd7c0f$var$V({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ae || ($b090f26829cd7c0f$var$Hn.warn(" Overriding feature flag payloads!", {
            flagPayloads: t,
            overriddenPayloads: i,
            finalPayloads: e
        }), this.ae = !0), e;
    }
    reloadFeatureFlags() {
        this.ue || this.N.config.advanced_disable_feature_flags || this.fe || (this.fe = setTimeout(()=>{
            this.pe();
        }, 5));
    }
    ge() {
        clearTimeout(this.fe), this.fe = void 0;
    }
    ensureFlagsLoaded() {
        this.le || this.he || this.fe || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(t) {
        this.$anon_distinct_id = t;
    }
    setReloadingPaused(t) {
        this.ue = t;
    }
    pe(i) {
        var e;
        if (this.ge(), !this.N.config.advanced_disable_decide) {
            if (this.he) this.de = !0;
            else {
                var r = {
                    token: this.N.config.token,
                    distinct_id: this.N.get_distinct_id(),
                    groups: this.N.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: $b090f26829cd7c0f$var$B({}, (null == (e = this.N.persistence) ? void 0 : e.get_initial_props()) || {}, this.N.get_property($b090f26829cd7c0f$var$Rt) || {}),
                    group_properties: this.N.get_property($b090f26829cd7c0f$var$Tt)
                };
                (null != i && i.disableFlags || this.N.config.advanced_disable_feature_flags) && (r.disable_flags = !0);
                var s = this.N.config.__preview_flags_v2 && this.N.config.__preview_remote_config;
                s && (r.timezone = $b090f26829cd7c0f$var$zn()), this.he = !0, this.N._e({
                    method: "POST",
                    url: this.N.requestRouter.endpointFor("api", s ? "/flags/?v=2" : "/decide/?v=4"),
                    data: r,
                    compression: this.N.config.disable_compression ? void 0 : $b090f26829cd7c0f$export$6a00d17b5aff0af.Base64,
                    timeout: this.N.config.feature_flag_request_timeout_ms,
                    callback: (t)=>{
                        var i, e, s, n = !0;
                        (200 === t.statusCode && (this.de || (this.$anon_distinct_id = void 0), n = !1), this.he = !1, this.ve) || (this.ve = !0, this.N.me(null !== (s = t.json) && void 0 !== s ? s : {}));
                        r.disable_flags && !this.de || (this.ce = !n, t.json && null != (i = t.json.quotaLimited) && i.includes($b090f26829cd7c0f$var$Bn.FeatureFlags) ? $b090f26829cd7c0f$var$Hn.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.") : (this.receivedFeatureFlags(null !== (e = t.json) && void 0 !== e ? e : {}, n), this.de && (this.de = !1, this.pe())));
                    }
                });
            }
        }
    }
    getFeatureFlag(t, i) {
        if (void 0 === i && (i = {}), this.le || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFlagVariants()[t], r = "" + e, s = this.N.get_property($b090f26829cd7c0f$var$Kn) || void 0, n = this.N.get_property($b090f26829cd7c0f$var$Ot) || {};
            if ((i.send_event || !("send_event" in i)) && (!(t in n) || !n[t].includes(r))) {
                var o, a, l, h, u, d, v, c, f, p, g;
                $b090f26829cd7c0f$var$x(n[t]) ? n[t].push(r) : n[t] = [
                    r
                ], null == (o = this.N.persistence) || o.register({
                    [$b090f26829cd7c0f$var$Ot]: n
                });
                var _ = this.getFeatureFlagDetails(t), m = {
                    $feature_flag: t,
                    $feature_flag_response: e,
                    $feature_flag_payload: this.getFeatureFlagPayload(t) || null,
                    $feature_flag_request_id: s,
                    $feature_flag_bootstrapped_response: (null == (a = this.N.config.bootstrap) || null == (l = a.featureFlags) ? void 0 : l[t]) || null,
                    $feature_flag_bootstrapped_payload: (null == (h = this.N.config.bootstrap) || null == (u = h.featureFlagPayloads) ? void 0 : u[t]) || null,
                    $used_bootstrap_value: !this.ce
                };
                $b090f26829cd7c0f$var$R(null == _ || null == (d = _.metadata) ? void 0 : d.version) || (m.$feature_flag_version = _.metadata.version);
                var b, w = null !== (v = null == _ || null == (c = _.reason) ? void 0 : c.description) && void 0 !== v ? v : null == _ || null == (f = _.reason) ? void 0 : f.code;
                if (w && (m.$feature_flag_reason = w), null != _ && null != (p = _.metadata) && p.id && (m.$feature_flag_id = _.metadata.id), $b090f26829cd7c0f$var$R(null == _ ? void 0 : _.original_variant) && $b090f26829cd7c0f$var$R(null == _ ? void 0 : _.original_enabled) || (m.$feature_flag_original_response = $b090f26829cd7c0f$var$R(_.original_variant) ? _.original_enabled : _.original_variant), null != _ && null != (g = _.metadata) && g.original_payload) m.$feature_flag_original_payload = null == _ || null == (b = _.metadata) ? void 0 : b.original_payload;
                this.N.capture("$feature_flag_called", m);
            }
            return e;
        }
        $b090f26829cd7c0f$var$Hn.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagDetails(t) {
        return this.getFlagsWithDetails()[t];
    }
    getFeatureFlagPayload(t) {
        return this.getFlagPayloads()[t];
    }
    getRemoteConfigPayload(i, e) {
        var r = this.N.config.token;
        this.N._e({
            method: "POST",
            url: this.N.requestRouter.endpointFor("api", "/decide/?v=4"),
            data: {
                distinct_id: this.N.get_distinct_id(),
                token: r
            },
            compression: this.N.config.disable_compression ? void 0 : $b090f26829cd7c0f$export$6a00d17b5aff0af.Base64,
            timeout: this.N.config.feature_flag_request_timeout_ms,
            callback: (t)=>{
                var r, s = null == (r = t.json) ? void 0 : r.featureFlagPayloads;
                e((null == s ? void 0 : s[i]) || void 0);
            }
        });
    }
    isFeatureEnabled(t, i) {
        if (void 0 === i && (i = {}), this.le || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(t, i);
        $b090f26829cd7c0f$var$Hn.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers.push(t);
    }
    removeFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
    }
    receivedFeatureFlags(t, i) {
        if (this.N.persistence) {
            this.le = !0;
            var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
            !function(t, i, e, r, s) {
                void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                var n = $b090f26829cd7c0f$var$Xn(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                if (a) {
                    var h = t.requestId;
                    if ($b090f26829cd7c0f$var$x(a)) {
                        $b090f26829cd7c0f$var$Hn.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                        var u = {};
                        if (a) for(var d = 0; d < a.length; d++)u[a[d]] = !0;
                        i && i.register({
                            [$b090f26829cd7c0f$var$Wn]: a,
                            [$b090f26829cd7c0f$var$Et]: u
                        });
                    } else {
                        var v = a, c = l, f = o;
                        t.errorsWhileComputingFlags && (v = $b090f26829cd7c0f$var$B({}, e, v), c = $b090f26829cd7c0f$var$B({}, r, c), f = $b090f26829cd7c0f$var$B({}, s, f)), i && i.register($b090f26829cd7c0f$var$B({
                            [$b090f26829cd7c0f$var$Wn]: Object.keys($b090f26829cd7c0f$var$Yn(v)),
                            [$b090f26829cd7c0f$var$Et]: v || {},
                            [$b090f26829cd7c0f$var$Jn]: c || {},
                            [$b090f26829cd7c0f$var$Pt]: f || {}
                        }, h ? {
                            [$b090f26829cd7c0f$var$Kn]: h
                        } : {}));
                    }
                }
            }(t, this.N.persistence, e, r, s), this.be(i);
        }
    }
    override(t, i) {
        void 0 === i && (i = !1), $b090f26829cd7c0f$var$Hn.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
            flags: t,
            suppressWarning: i
        });
    }
    overrideFeatureFlags(t) {
        if (!this.N.__loaded || !this.N.persistence) return $b090f26829cd7c0f$var$Hn.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
        if (!1 === t) return this.N.persistence.unregister($b090f26829cd7c0f$var$Gn), this.N.persistence.unregister($b090f26829cd7c0f$var$Vn), void this.be();
        if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
            var i, e = t;
            if (this.ae = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                if (!1 === e.flags) this.N.persistence.unregister($b090f26829cd7c0f$var$Gn);
                else if (e.flags) {
                    if ($b090f26829cd7c0f$var$x(e.flags)) {
                        for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                        this.N.persistence.register({
                            [$b090f26829cd7c0f$var$Gn]: r
                        });
                    } else this.N.persistence.register({
                        [$b090f26829cd7c0f$var$Gn]: e.flags
                    });
                }
            }
            return "payloads" in e && (!1 === e.payloads ? this.N.persistence.unregister($b090f26829cd7c0f$var$Vn) : e.payloads && this.N.persistence.register({
                [$b090f26829cd7c0f$var$Vn]: e.payloads
            })), void this.be();
        }
        this.be();
    }
    onFeatureFlags(t) {
        if (this.addFeatureFlagsHandler(t), this.le) {
            var { flags: i, flagVariants: e } = this.we();
            t(i, e);
        }
        return ()=>this.removeFeatureFlagsHandler(t);
    }
    updateEarlyAccessFeatureEnrollment(t, i) {
        var e, r = (this.N.get_property($b090f26829cd7c0f$var$It) || []).find((i)=>i.flagKey === t), s = {
            ["$feature_enrollment/" + t]: i
        }, n = {
            $feature_flag: t,
            $feature_enrollment: i,
            $set: s
        };
        r && (n.$early_access_feature_name = r.name), this.N.capture("$feature_enrollment_update", n), this.setPersonPropertiesForFlags(s, !1);
        var o = $b090f26829cd7c0f$var$B({}, this.getFlagVariants(), {
            [t]: i
        });
        null == (e = this.N.persistence) || e.register({
            [$b090f26829cd7c0f$var$Wn]: Object.keys($b090f26829cd7c0f$var$Yn(o)),
            [$b090f26829cd7c0f$var$Et]: o
        }), this.be();
    }
    getEarlyAccessFeatures(t, i, e) {
        void 0 === i && (i = !1);
        var r = this.N.get_property($b090f26829cd7c0f$var$It), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
        if (r && !i) return t(r);
        this.N._e({
            url: this.N.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this.N.config.token + s),
            method: "GET",
            callback: (i)=>{
                var e;
                if (i.json) {
                    var r = i.json.earlyAccessFeatures;
                    return null == (e = this.N.persistence) || e.register({
                        [$b090f26829cd7c0f$var$It]: r
                    }), t(r);
                }
            }
        });
    }
    we() {
        var t = this.getFlags(), i = this.getFlagVariants();
        return {
            flags: t.filter((t)=>i[t]),
            flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
        };
    }
    be(t) {
        var { flags: i, flagVariants: e } = this.we();
        this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                errorsLoading: t
            }));
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this.N.get_property($b090f26829cd7c0f$var$Rt) || {};
        this.N.register({
            [$b090f26829cd7c0f$var$Rt]: $b090f26829cd7c0f$var$B({}, e, t)
        }), i && this.N.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this.N.unregister($b090f26829cd7c0f$var$Rt);
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this.N.get_property($b090f26829cd7c0f$var$Tt) || {};
        0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
            e[i] = $b090f26829cd7c0f$var$B({}, e[i], t[i]), delete t[i];
        }), this.N.register({
            [$b090f26829cd7c0f$var$Tt]: $b090f26829cd7c0f$var$B({}, e, t)
        }), i && this.N.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(t) {
        if (t) {
            var i = this.N.get_property($b090f26829cd7c0f$var$Tt) || {};
            this.N.register({
                [$b090f26829cd7c0f$var$Tt]: $b090f26829cd7c0f$var$B({}, i, {
                    [t]: {}
                })
            });
        } else this.N.unregister($b090f26829cd7c0f$var$Tt);
    }
}
var $b090f26829cd7c0f$var$Zn = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $b090f26829cd7c0f$var$to {
    constructor(t){
        this.S = t, this.props = {}, this.ye = !1, this.Se = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.B = this.$e(t), this.load(), t.debug && $b090f26829cd7c0f$var$N.info("Persistence loaded", t.persistence, $b090f26829cd7c0f$var$B({}, this.props)), this.update_config(t, t), this.save();
    }
    $e(t) {
        -1 === $b090f26829cd7c0f$var$Zn.indexOf(t.persistence.toLowerCase()) && ($b090f26829cd7c0f$var$N.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
        var i = t.persistence.toLowerCase();
        return "localstorage" === i && $b090f26829cd7c0f$var$Gi.O() ? $b090f26829cd7c0f$var$Gi : "localstorage+cookie" === i && $b090f26829cd7c0f$var$Vi.O() ? $b090f26829cd7c0f$var$Vi : "sessionstorage" === i && $b090f26829cd7c0f$var$Qi.O() ? $b090f26829cd7c0f$var$Qi : "memory" === i ? $b090f26829cd7c0f$var$Yi : "cookie" === i ? $b090f26829cd7c0f$var$Hi : $b090f26829cd7c0f$var$Vi.O() ? $b090f26829cd7c0f$var$Vi : $b090f26829cd7c0f$var$Hi;
    }
    properties() {
        var t = {};
        return $b090f26829cd7c0f$var$J(this.props, function(i, e) {
            if (e === $b090f26829cd7c0f$var$Et && $b090f26829cd7c0f$var$I(i)) for(var r = Object.keys(i), s = 0; s < r.length; s++)t["$feature/" + r[s]] = i[r[s]];
            else a = e, l = !1, ($b090f26829cd7c0f$var$C(o = $b090f26829cd7c0f$var$Bt) ? l : $b090f26829cd7c0f$var$n && o.indexOf === $b090f26829cd7c0f$var$n ? -1 != o.indexOf(a) : ($b090f26829cd7c0f$var$J(o, function(t) {
                if (l || (l = t === a)) return $b090f26829cd7c0f$var$W;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.ke) {
            var t = this.B.D(this.Se);
            t && (this.props = $b090f26829cd7c0f$var$V({}, t));
        }
    }
    save() {
        this.ke || this.B.j(this.Se, this.props, this.xe, this.Ee, this.Ie, this.S.debug);
    }
    remove() {
        this.B.L(this.Se, !1), this.B.L(this.Se, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($b090f26829cd7c0f$var$I(t)) {
            $b090f26829cd7c0f$var$R(i) && (i = "None"), this.xe = $b090f26829cd7c0f$var$R(e) ? this.Pe : e;
            var r = !1;
            if ($b090f26829cd7c0f$var$J(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($b090f26829cd7c0f$var$I(t)) {
            this.xe = $b090f26829cd7c0f$var$R(i) ? this.Pe : i;
            var e = !1;
            if ($b090f26829cd7c0f$var$J(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.ye) {
            var t = $b090f26829cd7c0f$var$On(this.S.custom_campaign_params, this.S.mask_personal_data_properties, this.S.custom_personal_data_properties);
            $b090f26829cd7c0f$var$P($b090f26829cd7c0f$var$Z(t)) || this.register(t), this.ye = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $b090f26829cd7c0f$var$a ? void 0 : $b090f26829cd7c0f$var$a.referrer) ? $b090f26829cd7c0f$var$An(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $b090f26829cd7c0f$var$jn(),
            $referring_domain: null != $b090f26829cd7c0f$var$a && $b090f26829cd7c0f$var$a.referrer && (null == (t = $b090f26829cd7c0f$var$wi($b090f26829cd7c0f$var$a.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$b090f26829cd7c0f$var$jt] || this.props[$b090f26829cd7c0f$var$Lt] || this.register_once({
            [$b090f26829cd7c0f$var$Nt]: $b090f26829cd7c0f$var$Ln(this.S.mask_personal_data_properties, this.S.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $b090f26829cd7c0f$var$J([
            $b090f26829cd7c0f$var$Lt,
            $b090f26829cd7c0f$var$jt
        ], (i)=>{
            var e = this.props[i];
            e && $b090f26829cd7c0f$var$J(e, function(i, e) {
                t["$initial_" + $b090f26829cd7c0f$var$w(e)] = i;
            });
        });
        var i, e, r = this.props[$b090f26829cd7c0f$var$Nt];
        if (r) {
            var s = (i = $b090f26829cd7c0f$var$Nn(r), e = {}, $b090f26829cd7c0f$var$J(i, function(t, i) {
                e["$initial_" + $b090f26829cd7c0f$var$w(i)] = t;
            }), e);
            $b090f26829cd7c0f$var$V(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $b090f26829cd7c0f$var$J(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i) {
        if (this.Pe = this.xe = t.cookie_expiration, this.set_disabled(t.disable_persistence), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence) {
            var e = this.$e(t), r = this.props;
            this.clear(), this.B = e, this.props = r, this.save();
        }
    }
    set_disabled(t) {
        this.ke = t, this.ke ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ee && (this.Ee = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.Ie && (this.Ie = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[$b090f26829cd7c0f$var$at] || {};
        e[t] = i, this.props[$b090f26829cd7c0f$var$at] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[$b090f26829cd7c0f$var$at] || {})[t];
        return $b090f26829cd7c0f$var$R(i) || (delete this.props[$b090f26829cd7c0f$var$at][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
class $b090f26829cd7c0f$var$io {
    constructor(){
        this.Re = {}, this.Re = {};
    }
    on(t, i) {
        return this.Re[t] || (this.Re[t] = []), this.Re[t].push(i), ()=>{
            this.Re[t] = this.Re[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.Re[t] || [])e(i);
        for (var r of this.Re["*"] || [])r(t, i);
    }
}
var $b090f26829cd7c0f$var$eo = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
class $b090f26829cd7c0f$var$ro {
    constructor(t){
        this.Te = new $b090f26829cd7c0f$var$io, this.Me = (t, i)=>this.Ce(t, i) && this.Oe(t, i) && this.Fe(t, i), this.Ce = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this.N = t, this.Ae = new Set, this.De = new Set;
    }
    init() {
        var t;
        if (!$b090f26829cd7c0f$var$R(null == (t = this.N) ? void 0 : t.je)) {
            var i;
            null == (i = this.N) || i.je((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!$b090f26829cd7c0f$var$R(null == (i = this.N) ? void 0 : i.je) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.De) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.Ae) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this.N) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this.N) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.Ae.has(t) || this.Ae.has(null == i ? void 0 : i.event)) && this.De && (null == (e = this.De) ? void 0 : e.size) > 0 && this.De.forEach((t)=>{
            this.Le(i, t) && this.Te.emit("actionCaptured", t.name);
        });
    }
    Ne(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    Le(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.Me(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Te.on(t, i);
    }
    Oe(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$b090f26829cd7c0f$var$ro.ze(r, null == i ? void 0 : i.url, (null == i ? void 0 : i.url_matching) || "contains")) return !1;
        }
        return !0;
    }
    static ze(t, e, r) {
        switch(r){
            case "regex":
                return !!$b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$eo(t, e);
            case "exact":
                return e === t;
            case "contains":
                var s = $b090f26829cd7c0f$var$ro.Ue(e).replace(/_/g, ".").replace(/%/g, ".*");
                return $b090f26829cd7c0f$var$eo(t, s);
            default:
                return !1;
        }
    }
    static Ue(t) {
        return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    Fe(t, i) {
        if ((null != i && i.href || null != i && i.tag_name || null != i && i.text) && !this.qe(t).some((t)=>!(null != i && i.href && !$b090f26829cd7c0f$var$ro.ze(t.href || "", null == i ? void 0 : i.href, (null == i ? void 0 : i.href_matching) || "exact")) && (null == i || !i.tag_name || t.tag_name === (null == i ? void 0 : i.tag_name)) && !(null != i && i.text && !$b090f26829cd7c0f$var$ro.ze(t.text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact") && !$b090f26829cd7c0f$var$ro.ze(t.$el_text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact")))) return !1;
        if (null != i && i.selector) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
            if (!r) return !1;
            if (!r.includes(null == i ? void 0 : i.selector)) return !1;
        }
        return !0;
    }
    qe(t) {
        return null == (null == t ? void 0 : t.properties.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
}
var $b090f26829cd7c0f$var$so = $b090f26829cd7c0f$var$z("[Surveys]");
class $b090f26829cd7c0f$var$no {
    constructor(t){
        this.N = t, this.Be = new Map, this.He = new Map;
    }
    register(t) {
        var i;
        $b090f26829cd7c0f$var$R(null == (i = this.N) ? void 0 : i.je) || (this.We(t), this.Ge(t));
    }
    Ge(t) {
        var i = t.filter((t)=>{
            var i, e, r, s;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (r = e.actions) || null == (s = r.values) ? void 0 : s.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.Je) {
                this.Je = new $b090f26829cd7c0f$var$ro(this.N), this.Je.init();
                this.Je.Ne((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n, o, a, l, h, u;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (r = e.actions) && r.values && (null == (s = t.conditions) || null == (n = s.actions) || null == (o = n.values) ? void 0 : o.length) > 0 && (null == (a = this.Je) || a.register(t.conditions.actions.values), null == (l = t.conditions) || null == (h = l.actions) || null == (u = h.values) || u.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.He.get(i.name);
                        e && e.push(t.id), this.He.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    We(t) {
        var i;
        if (0 !== t.filter((t)=>{
            var i, e, r, s;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (r = e.events) || null == (s = r.values) ? void 0 : s.length) > 0;
        }).length) null == (i = this.N) || i.je((t, i)=>{
            this.onEvent(t, i);
        }), t.forEach((t)=>{
            var i, e, r;
            null == (i = t.conditions) || null == (e = i.events) || null == (r = e.values) || r.forEach((i)=>{
                if (i && i.name) {
                    var e = this.Be.get(i.name);
                    e && e.push(t.id), this.Be.set(i.name, e || [
                        t.id
                    ]);
                }
            });
        });
    }
    onEvent(t, i) {
        var e, r, s = (null == (e = this.N) || null == (r = e.persistence) ? void 0 : r.props[$b090f26829cd7c0f$var$Ct]) || [];
        if ("survey shown" === t && i && s.length > 0) {
            var n;
            $b090f26829cd7c0f$var$so.info("survey event matched, removing survey from activated surveys", {
                event: t,
                eventPayload: i,
                existingActivatedSurveys: s
            });
            var o = null == i || null == (n = i.properties) ? void 0 : n.$survey_id;
            if (o) {
                var a = s.indexOf(o);
                a >= 0 && (s.splice(a, 1), this.Ve(s));
            }
        } else this.Be.has(t) && ($b090f26829cd7c0f$var$so.info("survey event matched, updating activated surveys", {
            event: t,
            surveys: this.Be.get(t)
        }), this.Ve(s.concat(this.Be.get(t) || [])));
    }
    onAction(t) {
        var i, e, r = (null == (i = this.N) || null == (e = i.persistence) ? void 0 : e.props[$b090f26829cd7c0f$var$Ct]) || [];
        this.He.has(t) && this.Ve(r.concat(this.He.get(t) || []));
    }
    Ve(t) {
        var i, e;
        null == (i = this.N) || null == (e = i.persistence) || e.register({
            [$b090f26829cd7c0f$var$Ct]: [
                ...new Set(t)
            ]
        });
    }
    getSurveys() {
        var t, i, e = null == (t = this.N) || null == (i = t.persistence) ? void 0 : i.props[$b090f26829cd7c0f$var$Ct];
        return e || [];
    }
    getEventToSurveys() {
        return this.Be;
    }
    Ke() {
        return this.Je;
    }
}
class $b090f26829cd7c0f$var$oo {
    constructor(t){
        this.Ye = null, this.Xe = !1, this.Qe = !1, this.Ze = [], this.N = t, this.tr = null;
    }
    onRemoteConfig(t) {
        var i = t.surveys;
        if ($b090f26829cd7c0f$var$O(i)) return $b090f26829cd7c0f$var$so.warn("Decide not loaded yet. Not loading surveys.");
        var e = $b090f26829cd7c0f$var$x(i);
        this.ir = e ? i.length > 0 : i, $b090f26829cd7c0f$var$so.info("decide response received, hasSurveys: " + this.ir), this.ir && this.loadIfEnabled();
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        for(var t = [], i = 0; i < localStorage.length; i++){
            var e = localStorage.key(i);
            null != e && e.startsWith("seenSurvey_") && t.push(e);
        }
        t.forEach((t)=>localStorage.removeItem(t));
    }
    loadIfEnabled() {
        if (!this.Ye) {
            if (this.Qe) $b090f26829cd7c0f$var$so.info("Already initializing surveys, skipping...");
            else if (this.N.config.disable_surveys) $b090f26829cd7c0f$var$so.info("Disabled. Not loading surveys.");
            else if (this.ir) {
                var t = null == $b090f26829cd7c0f$var$c ? void 0 : $b090f26829cd7c0f$var$c.__PosthogExtensions__;
                if (t) {
                    this.Qe = !0;
                    try {
                        var i = t.generateSurveys;
                        if (i) return void this.er(i);
                        var e = t.loadExternalDependency;
                        if (!e) return void this.rr("PostHog loadExternalDependency extension not found.");
                        e(this.N, "surveys", (i)=>{
                            i || !t.generateSurveys ? this.rr("Could not load surveys script", i) : this.er(t.generateSurveys);
                        });
                    } catch (t) {
                        throw this.rr("Error initializing surveys", t), t;
                    } finally{
                        this.Qe = !1;
                    }
                } else $b090f26829cd7c0f$var$so.error("PostHog Extensions not found.");
            } else $b090f26829cd7c0f$var$so.info("No surveys to load.");
        }
    }
    er(t) {
        this.Ye = t(this.N), this.tr = new $b090f26829cd7c0f$var$no(this.N), $b090f26829cd7c0f$var$so.info("Surveys loaded successfully"), this.sr({
            isLoaded: !0
        });
    }
    rr(t, i) {
        $b090f26829cd7c0f$var$so.error(t, i), this.sr({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.Ze.push(t), this.Ye && this.sr({
            isLoaded: !0
        }), ()=>{
            this.Ze = this.Ze.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i) {
        if (void 0 === i && (i = !1), this.N.config.disable_surveys) return $b090f26829cd7c0f$var$so.info("Disabled. Not loading surveys."), t([]);
        var e = this.N.get_property($b090f26829cd7c0f$var$Mt);
        if (e && !i) return t(e, {
            isLoaded: !0
        });
        if (this.Xe) return t([], {
            isLoaded: !1,
            error: "Surveys are already being loaded"
        });
        try {
            this.Xe = !0, this.N._e({
                url: this.N.requestRouter.endpointFor("api", "/api/surveys/?token=" + this.N.config.token),
                method: "GET",
                timeout: this.N.config.surveys_request_timeout_ms,
                callback: (i)=>{
                    var e;
                    this.Xe = !1;
                    var r = i.statusCode;
                    if (200 !== r || !i.json) {
                        var s = "Surveys API could not be loaded, status: " + r;
                        return $b090f26829cd7c0f$var$so.error(s), t([], {
                            isLoaded: !1,
                            error: s
                        });
                    }
                    var n, o = i.json.surveys || [], a = o.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && (function(t) {
                            var i, e, r;
                            return !(null == (i = t.conditions) || null == (e = i.events) || null == (r = e.values) || !r.length);
                        }(t) || function(t) {
                            var i, e, r;
                            return !(null == (i = t.conditions) || null == (e = i.actions) || null == (r = e.values) || !r.length);
                        }(t)));
                    a.length > 0 && (null == (n = this.tr) || n.register(a));
                    return null == (e = this.N.persistence) || e.register({
                        [$b090f26829cd7c0f$var$Mt]: o
                    }), t(o, {
                        isLoaded: !0
                    });
                }
            });
        } catch (t) {
            throw this.Xe = !1, t;
        }
    }
    sr(t) {
        for (var i of this.Ze)try {
            t.isLoaded ? this.getSurveys(i) : i([], t);
        } catch (t) {
            $b090f26829cd7c0f$var$so.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i) {
        if (void 0 === i && (i = !1), !$b090f26829cd7c0f$var$O(this.Ye)) return this.Ye.getActiveMatchingSurveys(t, i);
        $b090f26829cd7c0f$var$so.warn("init was not called");
    }
    nr(t) {
        var i = null;
        return this.getSurveys((e)=>{
            var r;
            i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
        }), i;
    }
    ar(t) {
        if ($b090f26829cd7c0f$var$O(this.Ye)) return {
            eligible: !1,
            reason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = "string" == typeof t ? this.nr(t) : t;
        return i ? this.Ye.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if (!$b090f26829cd7c0f$var$O(this.Ye)) return $b090f26829cd7c0f$var$so.warn("init was not called"), {
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = this.ar(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $b090f26829cd7c0f$var$O(this.Ye) ? ($b090f26829cd7c0f$var$so.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                if (s) {
                    var n = this.ar(s);
                    e({
                        visible: n.eligible,
                        disabledReason: n.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i) {
        if ($b090f26829cd7c0f$var$O(this.Ye)) $b090f26829cd7c0f$var$so.warn("init was not called");
        else {
            var e = this.nr(t), r = null == $b090f26829cd7c0f$var$a ? void 0 : $b090f26829cd7c0f$var$a.querySelector(i);
            e ? r ? this.Ye.renderSurvey(e, r) : $b090f26829cd7c0f$var$so.warn("Survey element not found") : $b090f26829cd7c0f$var$so.warn("Survey not found");
        }
    }
}
var $b090f26829cd7c0f$var$ao = $b090f26829cd7c0f$var$z("[RateLimiter]");
class $b090f26829cd7c0f$var$lo {
    constructor(t){
        var i, e;
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $b090f26829cd7c0f$var$ao.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $b090f26829cd7c0f$var$ao.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.captureEventsPerSecond = (null == (i = t.config.rate_limiting) ? void 0 : i.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null == (e = t.config.rate_limiting) ? void 0 : e.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var s = (new Date).getTime(), n = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property($b090f26829cd7c0f$var$Dt)) && void 0 !== i ? i : {
            tokens: this.captureEventsBurstLimit,
            last: s
        };
        n.tokens += (s - n.last) / 1e3 * this.captureEventsPerSecond, n.last = s, n.tokens > this.captureEventsBurstLimit && (n.tokens = this.captureEventsBurstLimit);
        var o = n.tokens < 1;
        return o || t || (n.tokens = Math.max(0, n.tokens - 1)), !o || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + this.captureEventsPerSecond + " events per second and " + this.captureEventsBurstLimit + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = o, null == (r = this.instance.persistence) || r.set_property($b090f26829cd7c0f$var$Dt, n), {
            isRateLimited: o,
            remainingTokens: n.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var $b090f26829cd7c0f$var$ho = $b090f26829cd7c0f$var$z("[RemoteConfig]");
class $b090f26829cd7c0f$var$uo {
    constructor(t){
        this.N = t;
    }
    get remoteConfig() {
        var t, i;
        return null == (t = $b090f26829cd7c0f$var$c._POSTHOG_REMOTE_CONFIG) || null == (i = t[this.N.config.token]) ? void 0 : i.config;
    }
    lr(t) {
        var i, e;
        null != (i = $b090f26829cd7c0f$var$c.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.N, "remote-config", ()=>t(this.remoteConfig)) : ($b090f26829cd7c0f$var$ho.error("PostHog Extensions not found. Cannot load remote config."), t());
    }
    hr(t) {
        this.N._e({
            method: "GET",
            url: this.N.requestRouter.endpointFor("assets", "/array/" + this.N.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $b090f26829cd7c0f$var$ho.info("Using preloaded remote config", this.remoteConfig), void this.me(this.remoteConfig);
            if (this.N.config.advanced_disable_decide) return void $b090f26829cd7c0f$var$ho.warn("Remote config is disabled. Falling back to local config.");
            this.lr((t)=>{
                if (!t) return $b090f26829cd7c0f$var$ho.info("No config found after loading remote JS config. Falling back to JSON."), void this.hr((t)=>{
                    this.me(t);
                });
                this.me(t);
            });
        } catch (t) {
            $b090f26829cd7c0f$var$ho.error("Error loading remote config", t);
        }
    }
    me(t) {
        t ? this.N.config.__preview_remote_config ? (this.N.me(t), !1 !== t.hasFeatureFlags && this.N.featureFlags.ensureFlagsLoaded()) : $b090f26829cd7c0f$var$ho.info("__preview_remote_config is disabled. Logging config instead", t) : $b090f26829cd7c0f$var$ho.error("Failed to fetch remote config from PostHog.");
    }
}
var $b090f26829cd7c0f$var$vo = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $b090f26829cd7c0f$var$C(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, $b090f26829cd7c0f$var$co = !!$b090f26829cd7c0f$var$u || !!$b090f26829cd7c0f$var$h, $b090f26829cd7c0f$var$fo = "text/plain", $b090f26829cd7c0f$var$po = (t, i)=>{
    var [e, r] = t.split("?"), s = $b090f26829cd7c0f$var$B({}, i);
    null == r || r.split("&").forEach((t)=>{
        var [i] = t.split("=");
        delete s[i];
    });
    var n = $b090f26829cd7c0f$var$yi(s);
    return e + "?" + (n = n ? (r ? r + "&" : "") + n : r);
}, $b090f26829cd7c0f$var$go = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), $b090f26829cd7c0f$var$_o = (i)=>{
    var { data: e, compression: r } = i;
    if (e) {
        if (r === $b090f26829cd7c0f$export$6a00d17b5aff0af.GZipJS) {
            var s = $b090f26829cd7c0f$var$Ar($b090f26829cd7c0f$var$Dr($b090f26829cd7c0f$var$go(e)), {
                mtime: 0
            }), n = new Blob([
                s
            ], {
                type: $b090f26829cd7c0f$var$fo
            });
            return {
                contentType: $b090f26829cd7c0f$var$fo,
                body: n,
                estimatedSize: n.size
            };
        }
        if (r === $b090f26829cd7c0f$export$6a00d17b5aff0af.Base64) {
            var o = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, h = "", u = [];
                if (!t) return t;
                t = $b090f26829cd7c0f$var$vo(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, u[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(h = u.join(""), t.length % 3){
                    case 1:
                        h = h.slice(0, -2) + "==";
                        break;
                    case 2:
                        h = h.slice(0, -1) + "=";
                }
                return h;
            }($b090f26829cd7c0f$var$go(e)), a = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $b090f26829cd7c0f$var$go(t)))(o);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: a,
                estimatedSize: new Blob([
                    a
                ]).size
            };
        }
        var l = $b090f26829cd7c0f$var$go(e);
        return {
            contentType: "application/json",
            body: l,
            estimatedSize: new Blob([
                l
            ]).size
        };
    }
}, $b090f26829cd7c0f$var$mo = [];
$b090f26829cd7c0f$var$h && $b090f26829cd7c0f$var$mo.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = $b090f26829cd7c0f$var$_o(t)) && void 0 !== i ? i : {}, o = new Headers;
        $b090f26829cd7c0f$var$J(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, l = null;
        if ($b090f26829cd7c0f$var$d) {
            var u = new $b090f26829cd7c0f$var$d;
            l = {
                signal: u.signal,
                timeout: setTimeout(()=>u.abort(), t.timeout)
            };
        }
        $b090f26829cd7c0f$var$h(a, $b090f26829cd7c0f$var$B({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = l) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $b090f26829cd7c0f$var$N.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $b090f26829cd7c0f$var$N.error(i), null == t.callback || t.callback({
                statusCode: 0,
                text: i
            });
        }).finally(()=>l ? clearTimeout(l.timeout) : null);
    }
}), $b090f26829cd7c0f$var$u && $b090f26829cd7c0f$var$mo.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new $b090f26829cd7c0f$var$u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = $b090f26829cd7c0f$var$_o(t)) && void 0 !== i ? i : {};
        $b090f26829cd7c0f$var$J(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), e.withCredentials = !0, e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != $b090f26829cd7c0f$var$o && $b090f26829cd7c0f$var$o.sendBeacon && $b090f26829cd7c0f$var$mo.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = $b090f26829cd7c0f$var$po(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = $b090f26829cd7c0f$var$_o(t)) && void 0 !== e ? e : {}, n = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $b090f26829cd7c0f$var$o.sendBeacon(i, n);
        } catch (t) {}
    }
});
var $b090f26829cd7c0f$var$bo = 3e3;
class $b090f26829cd7c0f$var$wo {
    constructor(t, i){
        this.ur = !0, this.dr = [], this.vr = $b090f26829cd7c0f$var$Xe((null == i ? void 0 : i.flush_interval_ms) || $b090f26829cd7c0f$var$bo, 250, 5e3, "flush interval", $b090f26829cd7c0f$var$bo), this.cr = t;
    }
    enqueue(t) {
        this.dr.push(t), this.pr || this.gr();
    }
    unload() {
        this._r();
        var t = this.dr.length > 0 ? this.mr() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.cr($b090f26829cd7c0f$var$B({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.ur = !1, this.gr();
    }
    gr() {
        var t = this;
        this.ur || (this.pr = setTimeout(()=>{
            if (this._r(), this.dr.length > 0) {
                var i = this.mr(), e = function(e) {
                    var r = i[e], s = (new Date).getTime();
                    r.data && $b090f26829cd7c0f$var$x(r.data) && $b090f26829cd7c0f$var$J(r.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.cr(r);
                };
                for(var r in i)e(r);
            }
        }, this.vr));
    }
    _r() {
        clearTimeout(this.pr), this.pr = void 0;
    }
    mr() {
        var t = {};
        return $b090f26829cd7c0f$var$J(this.dr, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            $b090f26829cd7c0f$var$R(t[s]) && (t[s] = $b090f26829cd7c0f$var$B({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.dr = [], t;
    }
}
var $b090f26829cd7c0f$var$yo = [
    "retriesPerformedSoFar"
];
class $b090f26829cd7c0f$var$So {
    constructor(t){
        this.br = !1, this.wr = 3e3, this.dr = [], this.N = t, this.dr = [], this.yr = !0, !$b090f26829cd7c0f$var$R($b090f26829cd7c0f$var$i) && "onLine" in $b090f26829cd7c0f$var$i.navigator && (this.yr = $b090f26829cd7c0f$var$i.navigator.onLine, $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "online", ()=>{
            this.yr = !0, this.Xi();
        }), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "offline", ()=>{
            this.yr = !1;
        }));
    }
    get length() {
        return this.dr.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = $b090f26829cd7c0f$var$H(t, $b090f26829cd7c0f$var$yo);
        $b090f26829cd7c0f$var$F(i) && i > 0 && (e.url = $b090f26829cd7c0f$var$po(e.url, {
            retry_count: i
        })), this.N._e($b090f26829cd7c0f$var$B({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this.Sr($b090f26829cd7c0f$var$B({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    Sr(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.dr.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $b090f26829cd7c0f$var$N.warn(s), this.br || (this.br = !0, this.$r());
    }
    $r() {
        this.kr && clearTimeout(this.kr), this.kr = setTimeout(()=>{
            this.yr && this.dr.length > 0 && this.Xi(), this.$r();
        }, this.wr);
    }
    Xi() {
        var t = Date.now(), i = [], e = this.dr.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.dr = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: t } of (this.kr && (clearTimeout(this.kr), this.kr = void 0), this.dr))try {
            this.N._e($b090f26829cd7c0f$var$B({}, t, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $b090f26829cd7c0f$var$N.error(t);
        }
        this.dr = [];
    }
}
class $b090f26829cd7c0f$var$$o {
    constructor(t){
        this.Er = ()=>{
            var t, i, e, r;
            this.Ir || (this.Ir = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.Ir.lastScrollY = Math.ceil(n), this.Ir.maxScrollY = Math.max(n, null !== (t = this.Ir.maxScrollY) && void 0 !== t ? t : 0), this.Ir.maxScrollHeight = Math.max(o, null !== (i = this.Ir.maxScrollHeight) && void 0 !== i ? i : 0), this.Ir.lastContentY = a, this.Ir.maxContentY = Math.max(a, null !== (e = this.Ir.maxContentY) && void 0 !== e ? e : 0), this.Ir.maxContentHeight = Math.max(l, null !== (r = this.Ir.maxContentHeight) && void 0 !== r ? r : 0);
        }, this.N = t;
    }
    getContext() {
        return this.Ir;
    }
    resetContext() {
        var t = this.Ir;
        return setTimeout(this.Er, 0), t;
    }
    startMeasuringScrollPosition() {
        $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "scroll", this.Er, {
            capture: !0
        }), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "scrollend", this.Er, {
            capture: !0
        }), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "resize", this.Er);
    }
    scrollElement() {
        if (!this.N.config.scroll_root_selector) return null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.document.documentElement;
        var t = $b090f26829cd7c0f$var$x(this.N.config.scroll_root_selector) ? this.N.config.scroll_root_selector : [
            this.N.config.scroll_root_selector
        ];
        for (var e of t){
            var r = null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this.N.config.scroll_root_selector) {
            var t = this.scrollElement();
            return t && t.scrollTop || 0;
        }
        return $b090f26829cd7c0f$var$i && ($b090f26829cd7c0f$var$i.scrollY || $b090f26829cd7c0f$var$i.pageYOffset || $b090f26829cd7c0f$var$i.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this.N.config.scroll_root_selector) {
            var t = this.scrollElement();
            return t && t.scrollLeft || 0;
        }
        return $b090f26829cd7c0f$var$i && ($b090f26829cd7c0f$var$i.scrollX || $b090f26829cd7c0f$var$i.pageXOffset || $b090f26829cd7c0f$var$i.document.documentElement.scrollLeft) || 0;
    }
}
var $b090f26829cd7c0f$var$ko = (t)=>$b090f26829cd7c0f$var$Ln(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $b090f26829cd7c0f$var$xo {
    constructor(t, i, e, r){
        this.Pr = (t)=>{
            var i = this.Rr();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.Tr(this.N)
                };
                this.Mr.register({
                    [$b090f26829cd7c0f$var$At]: e
                });
            }
        }, this.N = t, this.Cr = i, this.Mr = e, this.Tr = r || $b090f26829cd7c0f$var$ko, this.Cr.onSessionId(this.Pr);
    }
    Rr() {
        return this.Mr.props[$b090f26829cd7c0f$var$At];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.Rr()) ? void 0 : t.props;
        return i ? "r" in i ? $b090f26829cd7c0f$var$Nn(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $b090f26829cd7c0f$var$J($b090f26829cd7c0f$var$Z(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + $b090f26829cd7c0f$var$w(e)] = i;
        }), t;
    }
}
var $b090f26829cd7c0f$var$Eo = $b090f26829cd7c0f$var$z("[SessionId]");
class $b090f26829cd7c0f$var$Io {
    constructor(t, i, e){
        var r;
        if (this.Or = [], !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if (t.config.__preview_experimental_cookieless_mode) throw new Error("SessionIdManager cannot be used with __preview_experimental_cookieless_mode");
        this.S = t.config, this.Mr = t.persistence, this.oi = void 0, this.kt = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Fr = i || $b090f26829cd7c0f$var$ji, this.Ar = e || $b090f26829cd7c0f$var$ji;
        var s = this.S.persistence_name || this.S.token, n = this.S.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $b090f26829cd7c0f$var$Xe(n, 60, 36e3, "session_idle_timeout_seconds", 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Dr(), this.jr = "ph_" + s + "_window_id", this.Lr = "ph_" + s + "_primary_window_exists", this.Nr()) {
            var o = $b090f26829cd7c0f$var$Qi.D(this.jr), a = $b090f26829cd7c0f$var$Qi.D(this.Lr);
            o && !a ? this.oi = o : $b090f26829cd7c0f$var$Qi.L(this.jr), $b090f26829cd7c0f$var$Qi.j(this.Lr, !0);
        }
        if (null != (r = this.S.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.S.bootstrap.sessionID);
            this.zr(this.S.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            $b090f26829cd7c0f$var$Eo.error("Invalid sessionID in bootstrap", t);
        }
        this.Ur();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $b090f26829cd7c0f$var$R(this.Or) && (this.Or = []), this.Or.push(t), this.kt && t(this.kt, this.oi), ()=>{
            this.Or = this.Or.filter((i)=>i !== t);
        };
    }
    Nr() {
        return "memory" !== this.S.persistence && !this.Mr.ke && $b090f26829cd7c0f$var$Qi.O();
    }
    qr(t) {
        t !== this.oi && (this.oi = t, this.Nr() && $b090f26829cd7c0f$var$Qi.j(this.jr, t));
    }
    Br() {
        return this.oi ? this.oi : this.Nr() ? $b090f26829cd7c0f$var$Qi.D(this.jr) : null;
    }
    zr(t, i, e) {
        t === this.kt && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.kt = t, this.Mr.register({
            [$b090f26829cd7c0f$var$St]: [
                i,
                t,
                e
            ]
        }));
    }
    Hr() {
        if (this.kt && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
            this._sessionActivityTimestamp,
            this.kt,
            this._sessionStartTimestamp
        ];
        var t = this.Mr.props[$b090f26829cd7c0f$var$St];
        return $b090f26829cd7c0f$var$x(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.zr(null, null, null);
    }
    Ur() {
        $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "beforeunload", ()=>{
            this.Nr() && $b090f26829cd7c0f$var$Qi.L(this.Lr);
        }, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), this.S.__preview_experimental_cookieless_mode) throw new Error("checkAndGetSessionAndWindowId should not be called in __preview_experimental_cookieless_mode");
        var e = i || (new Date).getTime(), [r, s, n] = this.Hr(), o = this.Br(), a = $b090f26829cd7c0f$var$F(n) && n > 0 && Math.abs(e - n) > 864e5, l = !1, h = !s, u = !t && Math.abs(e - r) > this.sessionTimeoutMs;
        h || u || a ? (s = this.Fr(), o = this.Ar(), $b090f26829cd7c0f$var$Eo.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: h,
                activityTimeout: u,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.Ar(), l = !0);
        var d = 0 === r || !t || a ? e : r, v = 0 === n ? (new Date).getTime() : n;
        return this.qr(o), this.zr(s, d, v), t || this.Dr(), l && this.Or.forEach((t)=>t(s, o, l ? {
                noSessionId: h,
                activityTimeout: u,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: h,
                activityTimeout: u,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    Dr() {
        clearTimeout(this.Wr), this.Wr = setTimeout(()=>{
            this.resetSessionId();
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var $b090f26829cd7c0f$var$Po = [
    "$set_once",
    "$set"
], $b090f26829cd7c0f$var$Ro = $b090f26829cd7c0f$var$z("[SiteApps]");
class $b090f26829cd7c0f$var$To {
    constructor(t){
        this.N = t, this.Gr = [], this.apps = {};
    }
    get isEnabled() {
        return !!this.N.config.opt_in_site_apps;
    }
    Jr(t, i) {
        if (i) {
            var e = this.globalsForEvent(i);
            this.Gr.push(e), this.Gr.length > 1e3 && (this.Gr = this.Gr.slice(10));
        }
    }
    get siteAppLoaders() {
        var t, i;
        return null == (t = $b090f26829cd7c0f$var$c._POSTHOG_REMOTE_CONFIG) || null == (i = t[this.N.config.token]) ? void 0 : i.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var t = this.N.je(this.Jr.bind(this));
            this.Vr = ()=>{
                t(), this.Gr = [], this.Vr = void 0;
            };
        }
    }
    globalsForEvent(t) {
        var i, e, r, s, n, o, a;
        if (!t) throw new Error("Event payload is required");
        var l = {}, h = this.N.get_property("$groups") || [], u = this.N.get_property("$stored_group_properties") || {};
        for (var [d, v] of Object.entries(u))l[d] = {
            id: h[d],
            type: d,
            properties: v
        };
        var { $set_once: c, $set: f } = t;
        return {
            event: $b090f26829cd7c0f$var$B({}, $b090f26829cd7c0f$var$H(t, $b090f26829cd7c0f$var$Po), {
                properties: $b090f26829cd7c0f$var$B({}, t.properties, f ? {
                    $set: $b090f26829cd7c0f$var$B({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                } : {}, c ? {
                    $set_once: $b090f26829cd7c0f$var$B({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                } : {}),
                elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
            }),
            person: {
                properties: this.N.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(t) {
        var i = this.apps[t.id], e = ()=>{
            var e;
            (!i.errored && this.Gr.length && ($b090f26829cd7c0f$var$Ro.info("Processing " + this.Gr.length + " events for site app with id " + t.id), this.Gr.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.Vr) || e.call(this));
        }, r = !1, s = (s)=>{
            i.errored = !s, i.loaded = !0, $b090f26829cd7c0f$var$Ro.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
        };
        try {
            var { processEvent: n } = t.init({
                posthog: this.N,
                callback: (t)=>{
                    s(t);
                }
            });
            n && (i.processEvent = n), r = !0;
        } catch (i) {
            $b090f26829cd7c0f$var$Ro.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
        }
        if (r && i.loaded) try {
            e();
        } catch (e) {
            $b090f26829cd7c0f$var$Ro.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
        }
    }
    Kr() {
        var t = this.siteAppLoaders || [];
        for (var i of t)this.apps[i.id] = {
            id: i.id,
            loaded: !1,
            errored: !1,
            processedBuffer: !1
        };
        for (var e of t)this.setupSiteApp(e);
    }
    Yr(t) {
        if (0 !== Object.keys(this.apps).length) {
            var i = this.globalsForEvent(t);
            for (var e of Object.values(this.apps))try {
                null == e.processEvent || e.processEvent(i);
            } catch (i) {
                $b090f26829cd7c0f$var$Ro.error("Error while processing event " + t.event + " for site app " + e.id, i);
            }
        }
    }
    onRemoteConfig(t) {
        var i, e, r, s = this;
        if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.Kr(), void this.N.on("eventCaptured", (t)=>this.Yr(t))) : void $b090f26829cd7c0f$var$Ro.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        if (null == (e = this.Vr) || e.call(this), null != (r = t.siteApps) && r.length) {
            if (this.isEnabled) {
                var n = function(t, i) {
                    var e;
                    $b090f26829cd7c0f$var$c["__$$ph_site_app_" + t] = s.N, null == (e = $b090f26829cd7c0f$var$c.__PosthogExtensions__) || null == e.loadSiteApp || e.loadSiteApp(s.N, i, (i)=>{
                        if (i) return $b090f26829cd7c0f$var$Ro.error("Error while initializing PostHog app with config id " + t, i);
                    });
                };
                for (var { id: o, url: a } of t.siteApps)n(o, a);
            } else $b090f26829cd7c0f$var$Ro.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var $b090f26829cd7c0f$var$Mo, $b090f26829cd7c0f$var$Co = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "bytespider"
], $b090f26829cd7c0f$var$Oo = function(t, i) {
    if (!t) return !1;
    var e = t.toLowerCase();
    return $b090f26829cd7c0f$var$Co.concat(i || []).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
}, $b090f26829cd7c0f$var$Fo = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && $b090f26829cd7c0f$var$Oo(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$b090f26829cd7c0f$var$Oo(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
};
function $b090f26829cd7c0f$var$Ao(t, i, e) {
    return $b090f26829cd7c0f$var$go({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
!function(t) {
    t.US = "us", t.EU = "eu", t.CUSTOM = "custom";
}($b090f26829cd7c0f$var$Mo || ($b090f26829cd7c0f$var$Mo = {}));
var $b090f26829cd7c0f$var$Do = "i.posthog.com";
class $b090f26829cd7c0f$var$jo {
    constructor(t){
        this.Xr = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + $b090f26829cd7c0f$var$Do, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.Xr[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Xr[this.apiHost] = $b090f26829cd7c0f$var$Mo.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Xr[this.apiHost] = $b090f26829cd7c0f$var$Mo.EU : this.Xr[this.apiHost] = $b090f26829cd7c0f$var$Mo.CUSTOM), this.Xr[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if (this.region === $b090f26829cd7c0f$var$Mo.CUSTOM) return this.apiHost + i;
        var e = $b090f26829cd7c0f$var$Do + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var $b090f26829cd7c0f$var$Lo = {
    icontains: (t, e)=>!!$b090f26829cd7c0f$var$i && e.href.toLowerCase().indexOf(t.toLowerCase()) > -1,
    not_icontains: (t, e)=>!!$b090f26829cd7c0f$var$i && -1 === e.href.toLowerCase().indexOf(t.toLowerCase()),
    regex: (t, e)=>!!$b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$eo(e.href, t),
    not_regex: (t, e)=>!!$b090f26829cd7c0f$var$i && !$b090f26829cd7c0f$var$eo(e.href, t),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class $b090f26829cd7c0f$var$No {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                $b090f26829cd7c0f$var$No.Qr("retrieved web experiments from the server"), i.Zr = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.Zr) $b090f26829cd7c0f$var$No.Qr("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.Zr) || e.set(t.feature_flag_key, t);
                        var r = i.N.getFeatureFlag(t.feature_flag_key);
                        $b090f26829cd7c0f$var$T(r) && t.variants[r] && i.ts(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $b090f26829cd7c0f$var$No.es(n) && i.ts(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this.N = t, this.N.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    onFeatureFlags(t) {
        if (this._is_bot()) $b090f26829cd7c0f$var$No.Qr("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this.N.config.disable_web_experiments) {
            if ($b090f26829cd7c0f$var$O(this.Zr)) return this.Zr = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $b090f26829cd7c0f$var$No.Qr("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.Zr && null != (i = this.Zr) && i.has(t)) {
                    var e, r = this.N.getFeatureFlag(t), s = null == (e = this.Zr) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.ts(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $b090f26829cd7c0f$var$No.getWindowLocation();
        if (null != t && t.search) {
            var i = $b090f26829cd7c0f$var$Si(null == t ? void 0 : t.search, "__experiment_id"), e = $b090f26829cd7c0f$var$Si(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && ($b090f26829cd7c0f$var$No.Qr("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.rs(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this.N.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this.N.config.disable_web_experiments && !e) return t([]);
        var r = this.N.get_property("$web_experiments");
        if (r && !i) return t(r);
        this.N._e({
            url: this.N.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this.N.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    rs(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && ($b090f26829cd7c0f$var$No.Qr("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.ts(r[0].name, i, r[0].variants[i].transforms));
    }
    static es(t) {
        return !$b090f26829cd7c0f$var$O(t.conditions) && $b090f26829cd7c0f$var$No.ss(t) && $b090f26829cd7c0f$var$No.ns(t);
    }
    static ss(t) {
        var i;
        if ($b090f26829cd7c0f$var$O(t.conditions) || $b090f26829cd7c0f$var$O(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = $b090f26829cd7c0f$var$No.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || $b090f26829cd7c0f$var$Lo[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $b090f26829cd7c0f$var$i ? void 0 : $b090f26829cd7c0f$var$i.location;
    }
    static ns(t) {
        var i;
        if ($b090f26829cd7c0f$var$O(t.conditions) || $b090f26829cd7c0f$var$O(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = $b090f26829cd7c0f$var$On();
        if (e.utm_source) {
            var r, s, n, o, a, l, h, u, d, v, c, f, p, g, _, m, b = null == (r = t.conditions) || null == (s = r.utm) || !s.utm_campaign || (null == (n = t.conditions) || null == (o = n.utm) ? void 0 : o.utm_campaign) == e.utm_campaign, w = null == (a = t.conditions) || null == (l = a.utm) || !l.utm_source || (null == (h = t.conditions) || null == (u = h.utm) ? void 0 : u.utm_source) == e.utm_source, y = null == (d = t.conditions) || null == (v = d.utm) || !v.utm_medium || (null == (c = t.conditions) || null == (f = c.utm) ? void 0 : f.utm_medium) == e.utm_medium, S = null == (p = t.conditions) || null == (g = p.utm) || !g.utm_term || (null == (_ = t.conditions) || null == (m = _.utm) ? void 0 : m.utm_term) == e.utm_term;
            return b && y && S && w;
        }
        return !1;
    }
    static Qr(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $b090f26829cd7c0f$var$N.info("[WebExperiments] " + t, e);
    }
    ts(t, i, e) {
        this._is_bot() ? $b090f26829cd7c0f$var$No.Qr("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                $b090f26829cd7c0f$var$No.Qr("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : $b090f26829cd7c0f$var$No.Qr("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $b090f26829cd7c0f$var$o && this.N ? $b090f26829cd7c0f$var$Fo($b090f26829cd7c0f$var$o, this.N.config.custom_blocked_useragents) : void 0;
    }
}
var $b090f26829cd7c0f$var$zo = {}, $b090f26829cd7c0f$var$Uo = ()=>{}, $b090f26829cd7c0f$var$qo = "posthog", $b090f26829cd7c0f$var$Bo = !$b090f26829cd7c0f$var$co && -1 === (null == $b090f26829cd7c0f$var$v ? void 0 : $b090f26829cd7c0f$var$v.indexOf("MSIE")) && -1 === (null == $b090f26829cd7c0f$var$v ? void 0 : $b090f26829cd7c0f$var$v.indexOf("Mozilla")), $b090f26829cd7c0f$var$Ho = ()=>{
    var t;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: $b090f26829cd7c0f$var$et(null == $b090f26829cd7c0f$var$a ? void 0 : $b090f26829cd7c0f$var$a.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: $b090f26829cd7c0f$var$Uo,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: "if_capture_pageview",
        debug: $b090f26829cd7c0f$var$l && $b090f26829cd7c0f$var$T(null == $b090f26829cd7c0f$var$l ? void 0 : $b090f26829cd7c0f$var$l.search) && -1 !== $b090f26829cd7c0f$var$l.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $b090f26829cd7c0f$var$i || null == (t = $b090f26829cd7c0f$var$i.location) ? void 0 : t.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $b090f26829cd7c0f$var$N.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $b090f26829cd7c0f$var$bo
        },
        _onCapture: $b090f26829cd7c0f$var$Uo
    };
}, $b090f26829cd7c0f$var$Wo = (t)=>{
    var i = {};
    $b090f26829cd7c0f$var$R(t.process_person) || (i.person_profiles = t.process_person), $b090f26829cd7c0f$var$R(t.xhr_headers) || (i.request_headers = t.xhr_headers), $b090f26829cd7c0f$var$R(t.cookie_name) || (i.persistence_name = t.cookie_name), $b090f26829cd7c0f$var$R(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), $b090f26829cd7c0f$var$R(t.store_google) || (i.save_campaign_params = t.store_google), $b090f26829cd7c0f$var$R(t.verbose) || (i.debug = t.verbose);
    var e = $b090f26829cd7c0f$var$V({}, i, t);
    return $b090f26829cd7c0f$var$x(t.property_blacklist) && ($b090f26829cd7c0f$var$R(t.property_denylist) ? e.property_denylist = t.property_blacklist : $b090f26829cd7c0f$var$x(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $b090f26829cd7c0f$var$N.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class $b090f26829cd7c0f$var$Go {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get os() {
        return this.__forceAllowLocalhost;
    }
    set os(t) {
        $b090f26829cd7c0f$var$N.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $b090f26829cd7c0f$export$a9d6b9cbf49b8241 {
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        this.webPerformance = new $b090f26829cd7c0f$var$Go, this.ls = !1, this.version = $b090f26829cd7c0f$var$f.LIB_VERSION, this.hs = new $b090f26829cd7c0f$var$io, this.config = $b090f26829cd7c0f$var$Ho(), this.SentryIntegration = $b090f26829cd7c0f$var$gs, this.sentryIntegration = (t)=>(function(t, i) {
                var e = $b090f26829cd7c0f$var$ps(t, i);
                return {
                    name: $b090f26829cd7c0f$var$fs,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.us = !1, this.ds = null, this.vs = null, this.cs = null, this.featureFlags = new $b090f26829cd7c0f$var$Qn(this), this.toolbar = new $b090f26829cd7c0f$var$ys(this), this.scrollManager = new $b090f26829cd7c0f$var$$o(this), this.pageViewManager = new $b090f26829cd7c0f$var$Ts(this), this.surveys = new $b090f26829cd7c0f$var$oo(this), this.experiments = new $b090f26829cd7c0f$var$No(this), this.exceptions = new $b090f26829cd7c0f$var$Ms(this), this.rateLimiter = new $b090f26829cd7c0f$var$lo(this), this.requestRouter = new $b090f26829cd7c0f$var$jo(this), this.consent = new $b090f26829cd7c0f$var$Zi(this), this.people = {
            set: (t, i, e)=>{
                var r = $b090f26829cd7c0f$var$T(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = $b090f26829cd7c0f$var$T(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$b090f26829cd7c0f$var$N.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== $b090f26829cd7c0f$var$qo) {
            var r, s = null !== (r = $b090f26829cd7c0f$var$zo[e]) && void 0 !== r ? r : new $b090f26829cd7c0f$export$a9d6b9cbf49b8241;
            return s._init(t, i, e), $b090f26829cd7c0f$var$zo[e] = s, $b090f26829cd7c0f$var$zo[$b090f26829cd7c0f$var$qo][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(e, r, s) {
        var n, o;
        if (void 0 === r && (r = {}), $b090f26829cd7c0f$var$R(e) || $b090f26829cd7c0f$var$M(e)) return $b090f26829cd7c0f$var$N.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return $b090f26829cd7c0f$var$N.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, this.fs = [], r.person_profiles && (this.vs = r.person_profiles), this.set_config($b090f26829cd7c0f$var$V({}, $b090f26829cd7c0f$var$Ho(), $b090f26829cd7c0f$var$Wo(r), {
            name: s,
            token: e
        })), this.config.on_xhr_error && $b090f26829cd7c0f$var$N.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = r.disable_compression ? void 0 : $b090f26829cd7c0f$export$6a00d17b5aff0af.GZipJS, this.persistence = new $b090f26829cd7c0f$var$to(this.config), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $b090f26829cd7c0f$var$to($b090f26829cd7c0f$var$B({}, this.config, {
            persistence: "sessionStorage"
        }));
        var a = $b090f26829cd7c0f$var$B({}, this.persistence.props), l = $b090f26829cd7c0f$var$B({}, this.sessionPersistence.props);
        if (this.ps = new $b090f26829cd7c0f$var$wo((t)=>this.gs(t), this.config.request_queue_config), this._s = new $b090f26829cd7c0f$var$So(this), this.__request_queue = [], this.config.__preview_experimental_cookieless_mode || (this.sessionManager = new $b090f26829cd7c0f$var$Io(this), this.sessionPropsManager = new $b090f26829cd7c0f$var$xo(this, this.sessionManager, this.persistence)), new $b090f26829cd7c0f$var$$s(this).startIfEnabledOrStop(), this.siteApps = new $b090f26829cd7c0f$var$To(this), null == (n = this.siteApps) || n.init(), this.config.__preview_experimental_cookieless_mode || (this.sessionRecording = new $b090f26829cd7c0f$var$ds(this), this.sessionRecording.startIfEnabledOrStop()), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new $b090f26829cd7c0f$var$Ti(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new $b090f26829cd7c0f$var$Rs(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new $b090f26829cd7c0f$var$Es(this), this.exceptionObserver = new $b090f26829cd7c0f$var$ne(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new $b090f26829cd7c0f$var$re(this, $b090f26829cd7c0f$var$ee), this.deadClicksAutocapture.startIfEnabled(), this.historyAutocapture = new $b090f26829cd7c0f$var$je(this), this.historyAutocapture.startIfEnabled(), $b090f26829cd7c0f$var$f.DEBUG = $b090f26829cd7c0f$var$f.DEBUG || this.config.debug, $b090f26829cd7c0f$var$f.DEBUG && $b090f26829cd7c0f$var$N.info("Starting in debug mode", {
            this: this,
            config: r,
            thisC: $b090f26829cd7c0f$var$B({}, this.config),
            p: a,
            s: l
        }), this.bs(), void 0 !== (null == (o = r.bootstrap) ? void 0 : o.distinctID)) {
            var h, u, d = this.config.get_device_id($b090f26829cd7c0f$var$ji()), v = null != (h = r.bootstrap) && h.isIdentifiedID ? d : r.bootstrap.distinctID;
            this.persistence.set_property($b090f26829cd7c0f$var$Ft, null != (u = r.bootstrap) && u.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: r.bootstrap.distinctID,
                $device_id: v
            });
        }
        if (this.ws()) {
            var c, p, g = Object.keys((null == (c = r.bootstrap) ? void 0 : c.featureFlags) || {}).filter((t)=>{
                var i, e;
                return !(null == (i = r.bootstrap) || null == (e = i.featureFlags) || !e[t]);
            }).reduce((t, i)=>{
                var e, s;
                return t[i] = (null == (e = r.bootstrap) || null == (s = e.featureFlags) ? void 0 : s[i]) || !1, t;
            }, {}), _ = Object.keys((null == (p = r.bootstrap) ? void 0 : p.featureFlagPayloads) || {}).filter((t)=>g[t]).reduce((t, i)=>{
                var e, s, n, o;
                null != (e = r.bootstrap) && null != (s = e.featureFlagPayloads) && s[i] && (t[i] = null == (n = r.bootstrap) || null == (o = n.featureFlagPayloads) ? void 0 : o[i]);
                return t;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: g,
                featureFlagPayloads: _
            });
        }
        if (this.config.__preview_experimental_cookieless_mode) this.register_once({
            distinct_id: $b090f26829cd7c0f$var$qt,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var m = this.config.get_device_id($b090f26829cd7c0f$var$ji());
            this.register_once({
                distinct_id: m,
                $device_id: m
            }, ""), this.persistence.set_property($b090f26829cd7c0f$var$Ft, "anonymous");
        }
        return $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$i, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), this.toolbar.maybeLoadToolbar(), r.segment ? $b090f26829cd7c0f$var$cs(this, ()=>this.ys()) : this.ys(), $b090f26829cd7c0f$var$E(this.config._onCapture) && this.config._onCapture !== $b090f26829cd7c0f$var$Uo && ($b090f26829cd7c0f$var$N.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this;
    }
    me(i) {
        var e, r, s, n, o, l, h, u;
        if (!$b090f26829cd7c0f$var$a || !$b090f26829cd7c0f$var$a.body) return $b090f26829cd7c0f$var$N.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.me(i);
        }, 500);
        this.compression = void 0, i.supportedCompression && !this.config.disable_compression && (this.compression = $b090f26829cd7c0f$var$m(i.supportedCompression, $b090f26829cd7c0f$export$6a00d17b5aff0af.GZipJS) ? $b090f26829cd7c0f$export$6a00d17b5aff0af.GZipJS : $b090f26829cd7c0f$var$m(i.supportedCompression, $b090f26829cd7c0f$export$6a00d17b5aff0af.Base64) ? $b090f26829cd7c0f$export$6a00d17b5aff0af.Base64 : void 0), null != (e = i.analytics) && e.endpoint && (this.analyticsDefaultEndpoint = i.analytics.endpoint), this.set_config({
            person_profiles: this.vs ? this.vs : "identified_only"
        }), null == (r = this.siteApps) || r.onRemoteConfig(i), null == (s = this.sessionRecording) || s.onRemoteConfig(i), null == (n = this.autocapture) || n.onRemoteConfig(i), null == (o = this.heatmaps) || o.onRemoteConfig(i), this.surveys.onRemoteConfig(i), null == (l = this.webVitalsAutocapture) || l.onRemoteConfig(i), null == (h = this.exceptionObserver) || h.onRemoteConfig(i), null == (u = this.deadClicksAutocapture) || u.onRemoteConfig(i);
    }
    ys() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $b090f26829cd7c0f$var$N.critical("`loaded` function failed", t);
        }
        this.Ss(), this.config.capture_pageview && setTimeout(()=>{
            this.consent.isOptedIn() && this.$s();
        }, 1), new $b090f26829cd7c0f$var$uo(this).load(), this.featureFlags.decide();
    }
    Ss() {
        var t;
        this.has_opted_out_capturing() || this.config.request_batching && (null == (t = this.ps) || t.enable());
    }
    _dom_loaded() {
        this.has_opted_out_capturing() || $b090f26829cd7c0f$var$G(this.__request_queue, (t)=>this.gs(t)), this.__request_queue = [], this.Ss();
    }
    _handle_unload() {
        var t, i;
        this.config.request_batching ? (this.ks() && this.capture("$pageleave"), null == (t = this.ps) || t.unload(), null == (i = this._s) || i.unload()) : this.ks() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    _e(t) {
        this.__loaded && ($b090f26829cd7c0f$var$Bo ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $b090f26829cd7c0f$var$po(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $b090f26829cd7c0f$var$B({}, this.config.request_headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = $b090f26829cd7c0f$var$B({}, t);
            s.timeout = s.timeout || 6e4, s.url = $b090f26829cd7c0f$var$po(s.url, {
                _: (new Date).getTime().toString(),
                ver: $b090f26829cd7c0f$var$f.LIB_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = null !== (e = null == (r = $b090f26829cd7c0f$var$rt($b090f26829cd7c0f$var$mo, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : $b090f26829cd7c0f$var$mo[0].method;
            if (!o) throw new Error("No available transport method");
            o(s);
        })($b090f26829cd7c0f$var$B({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    gs(t) {
        this._s ? this._s.retriableRequest(t) : this._e(t);
    }
    _execute_array(t) {
        var i, e = [], r = [], s = [];
        $b090f26829cd7c0f$var$G(t, (t)=>{
            t && (i = t[0], $b090f26829cd7c0f$var$x(i) ? s.push(t) : $b090f26829cd7c0f$var$E(t) ? t.call(this) : $b090f26829cd7c0f$var$x(t) && "alias" === i ? e.push(t) : $b090f26829cd7c0f$var$x(t) && -1 !== i.indexOf("capture") && $b090f26829cd7c0f$var$E(this[i]) ? s.push(t) : r.push(t));
        });
        var n = function(t, i) {
            $b090f26829cd7c0f$var$G(t, function(t) {
                if ($b090f26829cd7c0f$var$x(t[0])) {
                    var e = i;
                    $b090f26829cd7c0f$var$J(t, function(t) {
                        e = e[t[0]].apply(e, t.slice(1));
                    });
                } else this[t[0]].apply(this, t.slice(1));
            }, i);
        };
        n(e, this), n(r, this), n(s, this);
    }
    ws() {
        var t, i;
        return (null == (t = this.config.bootstrap) ? void 0 : t.featureFlags) && Object.keys(null == (i = this.config.bootstrap) ? void 0 : i.featureFlags).length > 0 || !1;
    }
    push(t) {
        this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.ps) {
            if (!this.consent.isOptedOut()) {
                if (!$b090f26829cd7c0f$var$R(t) && $b090f26829cd7c0f$var$T(t)) {
                    if (this.config.opt_out_useragent_filter || !this._is_bot()) {
                        var s = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == s || !s.isRateLimited) {
                            null != i && i.$current_url && !$b090f26829cd7c0f$var$T(null == i ? void 0 : i.$current_url) && ($b090f26829cd7c0f$var$N.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var n = new Date, o = (null == e ? void 0 : e.timestamp) || n, a = $b090f26829cd7c0f$var$ji(), l = {
                                uuid: a,
                                event: t,
                                properties: this.Di(t, i || {}, o, a)
                            };
                            s && (l.properties.$lib_rate_limit_remaining_tokens = s.remainingTokens), (null == e ? void 0 : e.$set) && (l.$set = null == e ? void 0 : e.$set);
                            var h = this.xs(null == e ? void 0 : e.$set_once);
                            h && (l.$set_once = h), (l = $b090f26829cd7c0f$var$tt(l, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = o, $b090f26829cd7c0f$var$R(null == e ? void 0 : e.timestamp) || (l.properties.$event_time_override_provided = !0, l.properties.$event_time_override_system_time = n);
                            var u = $b090f26829cd7c0f$var$B({}, l.properties.$set, l.$set);
                            if ($b090f26829cd7c0f$var$P(u) || this.setPersonPropertiesForFlags(u), !$b090f26829cd7c0f$var$O(this.config.before_send)) {
                                var d = this.Es(l);
                                if (!d) return;
                                l = d;
                            }
                            this.hs.emit("eventCaptured", l);
                            var v = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: l,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.gs(v) : this.ps.enqueue(v), l;
                        }
                        $b090f26829cd7c0f$var$N.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $b090f26829cd7c0f$var$N.error("No event name provided to posthog.capture");
            }
        } else $b090f26829cd7c0f$var$N.uninitializedWarning("posthog.capture");
    }
    je(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    Di(t, i, e, r) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var s = this.persistence.remove_event_timer(t), n = $b090f26829cd7c0f$var$B({}, i);
        if (n.token = this.config.token, this.config.__preview_experimental_cookieless_mode && (n.$cookieless_mode = !0), "$snapshot" === t) {
            var o = $b090f26829cd7c0f$var$B({}, this.persistence.properties(), this.sessionPersistence.properties());
            return n.distinct_id = o.distinct_id, (!$b090f26829cd7c0f$var$T(n.distinct_id) && !$b090f26829cd7c0f$var$F(n.distinct_id) || $b090f26829cd7c0f$var$M(n.distinct_id)) && $b090f26829cd7c0f$var$N.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), n;
        }
        var l, h = $b090f26829cd7c0f$var$qn(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: u, windowId: d } = this.sessionManager.checkAndGetSessionAndWindowId();
            n.$session_id = u, n.$window_id = d;
        }
        this.sessionPropsManager && $b090f26829cd7c0f$var$V(n, this.sessionPropsManager.getSessionProps());
        try {
            var c;
            this.sessionRecording && $b090f26829cd7c0f$var$V(n, this.sessionRecording.sdkDebugProperties), n.$sdk_debug_retry_queue_size = null == (c = this._s) ? void 0 : c.length;
        } catch (t) {
            n.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $b090f26829cd7c0f$var$Mo.CUSTOM && (n.$lib_custom_api_host = this.config.api_host), l = "$pageview" === t ? this.pageViewManager.doPageView(e, r) : "$pageleave" === t ? this.pageViewManager.doPageLeave(e) : this.pageViewManager.doEvent(), n = $b090f26829cd7c0f$var$V(n, l), "$pageview" === t && $b090f26829cd7c0f$var$a && (n.title = $b090f26829cd7c0f$var$a.title), !$b090f26829cd7c0f$var$R(s)) {
            var f = e.getTime() - s;
            n.$duration = parseFloat((f / 1e3).toFixed(3));
        }
        $b090f26829cd7c0f$var$v && this.config.opt_out_useragent_filter && (n.$browser_type = this._is_bot() ? "bot" : "browser"), (n = $b090f26829cd7c0f$var$V({}, h, this.persistence.properties(), this.sessionPersistence.properties(), n)).$is_identified = this._isIdentified(), $b090f26829cd7c0f$var$x(this.config.property_denylist) ? $b090f26829cd7c0f$var$J(this.config.property_denylist, function(t) {
            delete n[t];
        }) : $b090f26829cd7c0f$var$N.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var p = this.config.sanitize_properties;
        p && ($b090f26829cd7c0f$var$N.error("sanitize_properties is deprecated. Use before_send instead"), n = p(n, t));
        var g = this.Is();
        return n.$process_person_profile = g, g && this.Ps("_calculate_event_properties"), n;
    }
    xs(t) {
        var i;
        if (!this.persistence || !this.Is()) return t;
        if (this.ls) return t;
        var e = this.persistence.get_initial_props(), r = null == (i = this.sessionPropsManager) ? void 0 : i.getSetOnceProps(), s = $b090f26829cd7c0f$var$V({}, e, r || {}, t || {}), n = this.config.sanitize_properties;
        return n && ($b090f26829cd7c0f$var$N.error("sanitize_properties is deprecated. Use before_send instead"), s = n(s, "$set_once")), this.ls = !0, $b090f26829cd7c0f$var$P(s) ? void 0 : s;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    Rs(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        return this.featureFlags.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        var i = this.featureFlags.getFeatureFlagPayload(t);
        try {
            return JSON.parse(i);
        } catch (t) {
            return i;
        }
    }
    isFeatureEnabled(t, i) {
        return this.featureFlags.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateEarlyAccessFeatureEnrollment(t, i) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(t, i);
    }
    getEarlyAccessFeatures(t, i, e) {
        return void 0 === i && (i = !1), this.featureFlags.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.hs.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags.onFeatureFlags(t);
    }
    onSurveysLoaded(t) {
        return this.surveys.onSurveysLoaded(t);
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getSurveys(t, i);
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getActiveMatchingSurveys(t, i);
    }
    renderSurvey(t, i) {
        this.surveys.renderSurvey(t, i);
    }
    canRenderSurvey(t) {
        return this.surveys.canRenderSurvey(t);
    }
    canRenderSurveyAsync(t, i) {
        return void 0 === i && (i = !1), this.surveys.canRenderSurveyAsync(t, i);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $b090f26829cd7c0f$var$N.uninitializedWarning("posthog.identify");
        if ($b090f26829cd7c0f$var$F(t) && (t = t.toString(), $b090f26829cd7c0f$var$N.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $b090f26829cd7c0f$var$N.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (this.Ps("posthog.identify")) {
                var r = this.get_distinct_id();
                if (this.register({
                    $user_id: t
                }), !this.get_property("$device_id")) {
                    var s = r;
                    this.register_once({
                        $had_persisted_distinct_id: !0,
                        $device_id: s
                    }, "");
                }
                t !== r && t !== this.get_property($b090f26829cd7c0f$var$ot) && (this.unregister($b090f26829cd7c0f$var$ot), this.register({
                    distinct_id: t
                }));
                var n = "anonymous" === (this.persistence.get_property($b090f26829cd7c0f$var$Ft) || "anonymous");
                t !== r && n ? (this.persistence.set_property($b090f26829cd7c0f$var$Ft, "identified"), this.setPersonPropertiesForFlags($b090f26829cd7c0f$var$B({}, e || {}, i || {}), !1), this.capture("$identify", {
                    distinct_id: t,
                    $anon_distinct_id: r
                }, {
                    $set: i || {},
                    $set_once: e || {}
                }), this.cs = $b090f26829cd7c0f$var$Ao(t, i, e), this.featureFlags.setAnonymousDistinctId(r)) : (i || e) && this.setPersonProperties(i, e), t !== r && (this.reloadFeatureFlags(), this.unregister($b090f26829cd7c0f$var$Ot));
            }
        } else $b090f26829cd7c0f$var$N.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this.Ps("posthog.setPersonProperties")) {
            var e = $b090f26829cd7c0f$var$Ao(this.get_distinct_id(), t, i);
            this.cs !== e ? (this.setPersonPropertiesForFlags($b090f26829cd7c0f$var$B({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.cs = e) : $b090f26829cd7c0f$var$N.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            if (this.Ps("posthog.group")) {
                var r = this.getGroups();
                r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                    $groups: $b090f26829cd7c0f$var$B({}, r, {
                        [t]: i
                    })
                }), e && (this.capture("$groupidentify", {
                    $group_type: t,
                    $group_key: i,
                    $group_set: e
                }), this.setGroupPropertiesForFlags({
                    [t]: e
                })), r[t] === i || e || this.reloadFeatureFlags();
            }
        } else $b090f26829cd7c0f$var$N.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.featureFlags.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.Ps("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, i);
    }
    resetGroupPropertiesForFlags(t) {
        this.featureFlags.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s;
        if ($b090f26829cd7c0f$var$N.info("reset"), !this.__loaded) return $b090f26829cd7c0f$var$N.uninitializedWarning("posthog.reset");
        var n = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), this.surveys.reset(), null == (r = this.persistence) || r.set_property($b090f26829cd7c0f$var$Ft, "anonymous"), null == (s = this.sessionManager) || s.resetSessionId(), this.cs = null, this.config.__preview_experimental_cookieless_mode) this.register_once({
            distinct_id: $b090f26829cd7c0f$var$qt,
            $device_id: null
        }, "");
        else {
            var o = this.config.get_device_id($b090f26829cd7c0f$var$ji());
            this.register_once({
                distinct_id: o,
                $device_id: t ? o : n
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1);
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property($b090f26829cd7c0f$var$nt) ? ($b090f26829cd7c0f$var$N.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Ps("posthog.alias") ? ($b090f26829cd7c0f$var$R(i) && (i = this.get_distinct_id()), t !== i ? (this.Rs($b090f26829cd7c0f$var$ot, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($b090f26829cd7c0f$var$N.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i, e, r, s, n = $b090f26829cd7c0f$var$B({}, this.config);
        $b090f26829cd7c0f$var$I(t) && ($b090f26829cd7c0f$var$V(this.config, $b090f26829cd7c0f$var$Wo(t)), null == (i = this.persistence) || i.update_config(this.config, n), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $b090f26829cd7c0f$var$to($b090f26829cd7c0f$var$B({}, this.config, {
            persistence: "sessionStorage"
        })), $b090f26829cd7c0f$var$Gi.O() && "true" === $b090f26829cd7c0f$var$Gi.A("ph_debug") && (this.config.debug = !0), this.config.debug && ($b090f26829cd7c0f$var$f.DEBUG = !0, $b090f26829cd7c0f$var$N.info("set_config", JSON.stringify({
            config: t,
            oldConfig: n,
            newConfig: $b090f26829cd7c0f$var$B({}, this.config)
        }, null, 2))), null == (e = this.sessionRecording) || e.startIfEnabledOrStop(), null == (r = this.autocapture) || r.startIfEnabled(), null == (s = this.heatmaps) || s.startIfEnabled(), this.surveys.loadIfEnabled(), this.bs());
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        var e = new Error("PostHog syntheticException");
        this.exceptions.sendExceptionEvent($b090f26829cd7c0f$var$B({}, $b090f26829cd7c0f$var$Ae(((t)=>t instanceof Error)(t) ? {
            error: t,
            event: t.message
        } : {
            event: t
        }, {
            syntheticException: e
        }), i));
    }
    loadToolbar(t) {
        return this.toolbar.loadToolbar(t);
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : $b090f26829cd7c0f$var$qo;
        return i !== $b090f26829cd7c0f$var$qo && (i = $b090f26829cd7c0f$var$qo + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property($b090f26829cd7c0f$var$Ft)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property($b090f26829cd7c0f$var$Ft));
    }
    Is() {
        var t, i, e, r;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $b090f26829cd7c0f$var$P(this.getGroups()) && (null == (t = this.persistence) || null == (i = t.props) || !i[$b090f26829cd7c0f$var$ot]) && (null == (e = this.persistence) || null == (r = e.props) || !r[$b090f26829cd7c0f$var$zt]));
    }
    ks() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.Is() || this.Ps("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    Ps(t) {
        return "never" === this.config.person_profiles ? ($b090f26829cd7c0f$var$N.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.Rs($b090f26829cd7c0f$var$zt, !0), !0);
    }
    bs() {
        var t, i, e, r, s = this.consent.isOptedOut(), n = this.config.opt_out_persistence_by_default, o = this.config.disable_persistence || s && !!n;
        (null == (t = this.persistence) ? void 0 : t.ke) !== o && (null == (e = this.persistence) || e.set_disabled(o));
        (null == (i = this.sessionPersistence) ? void 0 : i.ke) !== o && (null == (r = this.sessionPersistence) || r.set_disabled(o));
    }
    opt_in_capturing(t) {
        var i;
        (this.consent.optInOut(!0), this.bs(), $b090f26829cd7c0f$var$R(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) && this.capture(null !== (i = null == t ? void 0 : t.captureEventName) && void 0 !== i ? i : "$opt_in", null == t ? void 0 : t.captureProperties, {
            send_instantly: !0
        });
        this.config.capture_pageview && this.$s();
    }
    opt_out_capturing() {
        this.consent.optInOut(!1), this.bs();
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.bs();
    }
    _is_bot() {
        return $b090f26829cd7c0f$var$o ? $b090f26829cd7c0f$var$Fo($b090f26829cd7c0f$var$o, this.config.custom_blocked_useragents) : void 0;
    }
    $s() {
        $b090f26829cd7c0f$var$a && ("visible" === $b090f26829cd7c0f$var$a.visibilityState ? this.us || (this.us = !0, this.capture("$pageview", {
            title: $b090f26829cd7c0f$var$a.title
        }, {
            send_instantly: !0
        }), this.ds && ($b090f26829cd7c0f$var$a.removeEventListener("visibilitychange", this.ds), this.ds = null)) : this.ds || (this.ds = this.$s.bind(this), $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "visibilitychange", this.ds)));
    }
    debug(t) {
        !1 === t ? (null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
            debug: !1
        })) : (null == $b090f26829cd7c0f$var$i || $b090f26829cd7c0f$var$i.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
            debug: !0
        }));
    }
    Es(t) {
        if ($b090f26829cd7c0f$var$O(this.config.before_send)) return t;
        var i = $b090f26829cd7c0f$var$x(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), $b090f26829cd7c0f$var$O(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $b090f26829cd7c0f$var$j(t.event) ? $b090f26829cd7c0f$var$N.warn(s + ". This can cause unexpected behavior.") : $b090f26829cd7c0f$var$N.info(s), null;
            }
            e.properties && !$b090f26829cd7c0f$var$P(e.properties) || $b090f26829cd7c0f$var$N.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.oe) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
}
!function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = $b090f26829cd7c0f$var$Q(t.prototype[i[e]]);
}($b090f26829cd7c0f$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $b090f26829cd7c0f$export$87f1e68f1b904cbb, $b090f26829cd7c0f$export$8c0ce98316e43193, $b090f26829cd7c0f$export$22779822dd24228f, $b090f26829cd7c0f$export$9c2ac61661d417f8, $b090f26829cd7c0f$export$bbed2da3bd3bb001, $b090f26829cd7c0f$export$407ee791fe918359;
!function(t) {
    t.Button = "button", t.Tab = "tab", t.Selector = "selector";
}($b090f26829cd7c0f$export$87f1e68f1b904cbb || ($b090f26829cd7c0f$export$87f1e68f1b904cbb = {})), function(t) {
    t.Left = "left", t.Center = "center", t.Right = "right", t.NextToTrigger = "next_to_trigger";
}($b090f26829cd7c0f$export$8c0ce98316e43193 || ($b090f26829cd7c0f$export$8c0ce98316e43193 = {})), function(t) {
    t.Popover = "popover", t.API = "api", t.Widget = "widget";
}($b090f26829cd7c0f$export$22779822dd24228f || ($b090f26829cd7c0f$export$22779822dd24228f = {})), function(t) {
    t.Open = "open", t.MultipleChoice = "multiple_choice", t.SingleChoice = "single_choice", t.Rating = "rating", t.Link = "link";
}($b090f26829cd7c0f$export$9c2ac61661d417f8 || ($b090f26829cd7c0f$export$9c2ac61661d417f8 = {})), function(t) {
    t.NextQuestion = "next_question", t.End = "end", t.ResponseBased = "response_based", t.SpecificQuestion = "specific_question";
}($b090f26829cd7c0f$export$bbed2da3bd3bb001 || ($b090f26829cd7c0f$export$bbed2da3bd3bb001 = {})), function(t) {
    t.Once = "once", t.Recurring = "recurring", t.Always = "always";
}($b090f26829cd7c0f$export$407ee791fe918359 || ($b090f26829cd7c0f$export$407ee791fe918359 = {}));
var $b090f26829cd7c0f$var$ta, $b090f26829cd7c0f$export$2e2bcd8739ae039 = ($b090f26829cd7c0f$var$ta = $b090f26829cd7c0f$var$zo[$b090f26829cd7c0f$var$qo] = new $b090f26829cd7c0f$export$a9d6b9cbf49b8241, function() {
    function t() {
        t.done || (t.done = !0, $b090f26829cd7c0f$var$Bo = !1, $b090f26829cd7c0f$var$J($b090f26829cd7c0f$var$zo, function(t) {
            t._dom_loaded();
        }));
    }
    null != $b090f26829cd7c0f$var$a && $b090f26829cd7c0f$var$a.addEventListener ? "complete" === $b090f26829cd7c0f$var$a.readyState ? t() : $b090f26829cd7c0f$var$st($b090f26829cd7c0f$var$a, "DOMContentLoaded", t, {
        capture: !1
    }) : $b090f26829cd7c0f$var$i && $b090f26829cd7c0f$var$N.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $b090f26829cd7c0f$var$ta);

});



parcelRegister("8ib1E", function(module, exports) {
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
})(module.exports, function() {
    return function download(data, strFileName, strMimeType) {
        var self = window, defaultMime = "application/octet-stream", mimeType = strMimeType || defaultMime, payload = data, url = !strFileName && !strMimeType && payload, anchor = document.createElement("a"), toString = function(a) {
            return String(a);
        }, myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString, fileName = strFileName || "download", blob, reader;
        myBlob = myBlob.call ? myBlob.bind(self) : Blob;
        if (String(this) === "true") {
            payload = [
                payload,
                mimeType
            ];
            mimeType = payload[0];
            payload = payload[1];
        }
        if (url && url.length < 2048) {
            fileName = url.split("/").pop().split("?")[0];
            anchor.href = url; // assign href prop to temp anchor
            if (anchor.href.indexOf(url) !== -1) {
                var ajax = new XMLHttpRequest();
                ajax.open("GET", url, true);
                ajax.responseType = "blob";
                ajax.onload = function(e) {
                    download(e.target.response, fileName, defaultMime);
                };
                setTimeout(function() {
                    ajax.send();
                }, 0); // allows setting custom ajax headers using the return:
                return ajax;
            } // end if valid url?
        } // end if url?
        //go ahead and download dataURLs right away
        if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
            if (payload.length > 2096103.424 && myBlob !== toString) {
                payload = dataUrlToBlob(payload);
                mimeType = payload.type || defaultMime;
            } else return navigator.msSaveBlob ? navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
        } else if (/([\x80-\xff])/.test(payload)) {
            var i = 0, tempUiArr = new Uint8Array(payload.length), mx = tempUiArr.length;
            for(i; i < mx; ++i)tempUiArr[i] = payload.charCodeAt(i);
            payload = new myBlob([
                tempUiArr
            ], {
                type: mimeType
            });
        }
        blob = payload instanceof myBlob ? payload : new myBlob([
            payload
        ], {
            type: mimeType
        });
        function dataUrlToBlob(strUrl) {
            var parts = strUrl.split(/[:;,]/), type = parts[1], decoder = parts[2] == "base64" ? atob : decodeURIComponent, binData = decoder(parts.pop()), mx = binData.length, i = 0, uiArr = new Uint8Array(mx);
            for(i; i < mx; ++i)uiArr[i] = binData.charCodeAt(i);
            return new myBlob([
                uiArr
            ], {
                type: type
            });
        }
        function saver(url, winMode) {
            if ("download" in anchor) {
                anchor.href = url;
                anchor.setAttribute("download", fileName);
                anchor.className = "download-js-link";
                anchor.innerHTML = "downloading...";
                anchor.style.display = "none";
                document.body.appendChild(anchor);
                setTimeout(function() {
                    anchor.click();
                    document.body.removeChild(anchor);
                    if (winMode === true) setTimeout(function() {
                        self.URL.revokeObjectURL(anchor.href);
                    }, 250);
                }, 66);
                return true;
            }
            // handle non-a[download] safari as best we can:
            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                if (!window.open(url)) {
                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) location.href = url;
                }
                return true;
            }
            //do iframe dataURL download (old ch+FF):
            var f = document.createElement("iframe");
            document.body.appendChild(f);
            if (!winMode && /^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
            f.src = url;
            setTimeout(function() {
                document.body.removeChild(f);
            }, 333);
        } //end saver
        if (navigator.msSaveBlob) return navigator.msSaveBlob(blob, fileName);
        if (self.URL) saver(self.URL.createObjectURL(blob), true);
        else {
            // handle non-Blob()+non-URL browsers:
            if (typeof blob === "string" || blob.constructor === toString) try {
                return saver("data:" + mimeType + ";base64," + self.btoa(blob));
            } catch (y) {
                return saver("data:" + mimeType + "," + encodeURIComponent(blob));
            }
            // Blob but not URL support:
            reader = new FileReader();
            reader.onload = function(e) {
                saver(this.result);
            };
            reader.readAsDataURL(blob);
        }
        return true;
    }; /* end download() */ 
});

});

parcelRegister("bh2Tf", function(module, exports) {
/* @license
Papa Parse
v4.6.3
https://github.com/mholt/PapaParse
License: MIT
*/ Array.isArray || (Array.isArray = function(e) {
    return "[object Array]" === Object.prototype.toString.call(e);
}), function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : module.exports = t();
}(module.exports, function() {
    "use strict";
    var s, e, f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {}, n = !f.document && !!f.postMessage, o = n && /(\?|&)papaworker(=|&|$)/.test(f.location.search), a = !1, h = {}, u = 0, k = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            z(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!z(t.transform) && t.transform, t.worker && k.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!k.WORKERS_SUPPORTED) return !1;
                    if (!a && null === k.SCRIPT_PATH) throw new Error("Script path cannot be determined automatically when Papa Parse is loaded asynchronously. You need to set Papa.SCRIPT_PATH manually.");
                    var e = k.SCRIPT_PATH || s;
                    e += (-1 !== e.indexOf("?") ? "&" : "?") + "papaworker";
                    var t = new f.Worker(e);
                    return t.onmessage = m, t.id = u++, h[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = z(t.step), t.chunk = z(t.chunk), t.complete = z(t.complete), t.error = z(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            k.NODE_STREAM_INPUT, "string" == typeof e ? n = t.download ? new c(t) : new _(t) : !0 === e.readable && z(e.read) && z(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new p(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var i = !1, g = !0, m = ",", y = "\r\n", n = '"', r = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || k.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || Array.isArray(t.quotes)) && (i = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (n = t.quoteChar);
                "boolean" == typeof t.header && (g = t.header);
            }();
            var s = new RegExp(M(n), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return o(null, e, r);
                if ("object" == typeof e[0]) return o(a(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : a(e.data[0])), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), o(e.fields || [], e.data || [], r);
            throw "exception: Unable to serialize unrecognized input";
            function a(e) {
                if ("object" != typeof e) return [];
                var t = [];
                for(var r in e)t.push(r);
                return t;
            }
            function o(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && g) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var h = n ? e.length : t[o].length, u = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (u = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < h; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        u = "" === d.join("").trim();
                    }
                    if (!u) {
                        for(var p = 0; p < h; p++){
                            0 < p && !f && (i += m);
                            var _ = n && s ? e[p] : p;
                            i += v(t[o][_], p);
                        }
                        o < t.length - 1 && (!r || 0 < h && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                e = e.toString().replace(s, n + n);
                var r = "boolean" == typeof i && i || Array.isArray(i) && i[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(e, k.BAD_DELIMITERS) || -1 < e.indexOf(m) || " " === e.charAt(0) || " " === e.charAt(e.length - 1);
                return r ? n + e + n : e;
            }
        }
    };
    if (k.RECORD_SEP = String.fromCharCode(30), k.UNIT_SEP = String.fromCharCode(31), k.BYTE_ORDER_MARK = "\uFEFF", k.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        k.BYTE_ORDER_MARK
    ], k.WORKERS_SUPPORTED = !n && !!f.Worker, k.SCRIPT_PATH = null, k.NODE_STREAM_INPUT = 1, k.LocalChunkSize = 10485760, k.RemoteChunkSize = 5242880, k.DefaultDelimiter = ",", k.Parser = v, k.ParserHandle = r, k.NetworkStreamer = c, k.FileStreamer = p, k.StringStreamer = _, k.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, h = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)h.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== h.length) {
                    var e, t, r, i, n = h[0];
                    if (z(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (z(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void u();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void u();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        z(a) && a(e, n.file, n.inputElem), u();
                    }, k.parse(n.file, n.instanceConfig);
                } else z(o.complete) && o.complete();
            }
            function u() {
                h.splice(0, 1), e();
            }
        };
    }
    function l(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = E(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && z(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: k.WORKER_ID,
                    finished: a
                });
                else if (z(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return;
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !z(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
        }, this._sendError = function(e) {
            z(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: k.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function c(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = k.RemoteChunkSize), l.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = w(this._chunkLoaded, this), i.onerror = w(this._chunkError, this)), i.open("GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r), i.setRequestHeader("If-None-Match", "webkit-no-cache");
                }
                try {
                    i.send();
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status ? this._chunkError() : this._start += this._config.chunkSize;
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._finished = !this._config.chunkSize || this._start > function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substr(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function p(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = k.LocalChunkSize), l.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = w(this._chunkLoaded, this), i.onerror = w(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function _(e) {
        var r;
        l.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e = this._config.chunkSize, t = e ? r.substr(0, e) : r;
                return r = e ? r.substr(e) : "", this._finished = !r, this.parseChunk(t);
            }
        };
    }
    function g(e) {
        l.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            l.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            l.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = w(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = w(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = w(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = w(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(g) {
        var a, o, h, i = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i, n = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/, t = this, r = 0, s = 0, u = !1, e = !1, f = [], d = {
            data: [],
            errors: [],
            meta: {}
        };
        if (z(g.step)) {
            var l = g.step;
            g.step = function(e) {
                if (d = e, p()) c();
                else {
                    if (c(), 0 === d.data.length) return;
                    r += e.data.length, g.preview && r > g.preview ? o.abort() : l(d, t);
                }
            };
        }
        function m(e) {
            return "greedy" === g.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function c() {
            if (d && h && (y("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + k.DefaultDelimiter + "'"), h = !1), g.skipEmptyLines) for(var e = 0; e < d.data.length; e++)m(d.data[e]) && d.data.splice(e--, 1);
            return p() && function() {
                if (!d) return;
                for(var e = 0; p() && e < d.data.length; e++)for(var t = 0; t < d.data[e].length; t++){
                    var r = d.data[e][t];
                    g.trimHeaders && (r = r.trim()), f.push(r);
                }
                d.data.splice(0, 1);
            }(), function() {
                if (!d || !g.header && !g.dynamicTyping && !g.transform) return d;
                for(var e = 0; e < d.data.length; e++){
                    var t, r = g.header ? {} : [];
                    for(t = 0; t < d.data[e].length; t++){
                        var i = t, n = d.data[e][t];
                        g.header && (i = t >= f.length ? "__parsed_extra" : f[t]), g.transform && (n = g.transform(n, i)), n = _(i, n), "__parsed_extra" === i ? (r[i] = r[i] || [], r[i].push(n)) : r[i] = n;
                    }
                    d.data[e] = r, g.header && (t > f.length ? y("FieldMismatch", "TooManyFields", "Too many fields: expected " + f.length + " fields but parsed " + t, s + e) : t < f.length && y("FieldMismatch", "TooFewFields", "Too few fields: expected " + f.length + " fields but parsed " + t, s + e));
                }
                g.header && d.meta && (d.meta.fields = f);
                return s += d.data.length, d;
            }();
        }
        function p() {
            return g.header && 0 === f.length;
        }
        function _(e, t) {
            var r;
            return r = e, g.dynamicTypingFunction && void 0 === g.dynamicTyping[r] && (g.dynamicTyping[r] = g.dynamicTypingFunction(r)), !0 === (g.dynamicTyping[r] || g.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (i.test(t) ? parseFloat(t) : n.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function y(e, t, r, i) {
            d.errors.push({
                type: e,
                code: t,
                message: r,
                row: i
            });
        }
        this.parse = function(e, t, r) {
            var i = g.quoteChar || '"';
            if (g.newline || (g.newline = function(e, t) {
                e = e.substr(0, 1048576);
                var r = new RegExp(M(t) + "([^]*?)" + M(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), h = !1, g.delimiter) z(g.delimiter) && (g.delimiter = g.delimiter(e), d.meta.delimiter = g.delimiter);
            else {
                var n = function(e, t, r, i) {
                    for(var n, s, a, o = [
                        ",",
                        "	",
                        "|",
                        ";",
                        k.RECORD_SEP,
                        k.UNIT_SEP
                    ], h = 0; h < o.length; h++){
                        var u = o[h], f = 0, d = 0, l = 0;
                        a = void 0;
                        for(var c = new v({
                            comments: i,
                            delimiter: u,
                            newline: t,
                            preview: 10
                        }).parse(e), p = 0; p < c.data.length; p++)if (r && m(c.data[p])) l++;
                        else {
                            var _ = c.data[p].length;
                            d += _, void 0 !== a ? 1 < _ && (f += Math.abs(_ - a), a = _) : a = 0;
                        }
                        0 < c.data.length && (d /= c.data.length - l), (void 0 === s || s < f) && 1.99 < d && (s = f, n = u);
                    }
                    return {
                        successful: !!(g.delimiter = n),
                        bestDelimiter: n
                    };
                }(e, g.newline, g.skipEmptyLines, g.comments);
                n.successful ? g.delimiter = n.bestDelimiter : (h = !0, g.delimiter = k.DefaultDelimiter), d.meta.delimiter = g.delimiter;
            }
            var s = E(g);
            return g.preview && g.header && s.preview++, a = e, o = new v(s), d = o.parse(a, t, r), c(), u ? {
                meta: {
                    paused: !0
                }
            } : d || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return u;
        }, this.pause = function() {
            u = !0, o.abort(), a = a.substr(o.getCharIndex());
        }, this.resume = function() {
            u = !1, t.streamer.parseChunk(a, !0);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), d.meta.aborted = !0, z(g.complete) && g.complete(d), a = "";
        };
    }
    function M(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function v(e) {
        var S, O = (e = e || {}).delimiter, x = e.newline, T = e.comments, I = e.step, A = e.preview, D = e.fastMode, L = S = void 0 === e.quoteChar ? '"' : e.quoteChar;
        if (void 0 !== e.escapeChar && (L = e.escapeChar), ("string" != typeof O || -1 < k.BAD_DELIMITERS.indexOf(O)) && (O = ","), T === O) throw "Comment character same as delimiter";
        !0 === T ? T = "#" : ("string" != typeof T || -1 < k.BAD_DELIMITERS.indexOf(T)) && (T = !1), "\n" !== x && "\r" !== x && "\r\n" !== x && (x = "\n");
        var P = 0, F = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw "Input must be a string";
            var n = i.length, e = O.length, s = x.length, a = T.length, o = z(I), h = [], u = [], f = [], d = P = 0;
            if (!i) return C();
            if (D || !1 !== D && -1 === i.indexOf(S)) {
                for(var l = i.split(x), c = 0; c < l.length; c++){
                    if (f = l[c], P += f.length, c !== l.length - 1) P += x.length;
                    else if (r) return C();
                    if (!T || f.substr(0, a) !== T) {
                        if (o) {
                            if (h = [], k(f.split(O)), R(), F) return C();
                        } else k(f.split(O));
                        if (A && A <= c) return h = h.slice(0, A), C(!0);
                    }
                }
                return C();
            }
            for(var p, _ = i.indexOf(O, P), g = i.indexOf(x, P), m = new RegExp(M(L) + M(S), "g");;)if (i[P] !== S) {
                if (T && 0 === f.length && i.substr(P, a) === T) {
                    if (-1 === g) return C();
                    P = g + s, g = i.indexOf(x, P), _ = i.indexOf(O, P);
                } else if (-1 !== _ && (_ < g || -1 === g)) f.push(i.substring(P, _)), P = _ + e, _ = i.indexOf(O, P);
                else {
                    if (-1 === g) break;
                    if (f.push(i.substring(P, g)), w(g + s), o && (R(), F)) return C();
                    if (A && h.length >= A) return C(!0);
                }
            } else for(p = P, P++;;){
                if (-1 === (p = i.indexOf(S, p + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: P
                }), E();
                if (p === n - 1) return E(i.substring(P, p).replace(m, S));
                if (S !== L || i[p + 1] !== L) {
                    if (S === L || 0 === p || i[p - 1] !== L) {
                        var y = b(-1 === g ? _ : Math.min(_, g));
                        if (i[p + 1 + y] === O) {
                            f.push(i.substring(P, p).replace(m, S)), P = p + 1 + y + e, _ = i.indexOf(O, P), g = i.indexOf(x, P);
                            break;
                        }
                        var v = b(g);
                        if (i.substr(p + 1 + v, s) === x) {
                            if (f.push(i.substring(P, p).replace(m, S)), w(p + 1 + v + s), _ = i.indexOf(O, P), o && (R(), F)) return C();
                            if (A && h.length >= A) return C(!0);
                            break;
                        }
                        u.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: h.length,
                            index: P
                        }), p++;
                    }
                } else p++;
            }
            return E();
            function k(e) {
                h.push(e), d = P;
            }
            function b(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(p + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substr(P)), f.push(e), P = n, k(f), o && R()), C();
            }
            function w(e) {
                P = e, k(f), f = [], g = i.indexOf(x, P);
            }
            function C(e) {
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: O,
                        linebreak: x,
                        aborted: F,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function R() {
                I(C()), h = [], u = [];
            }
        }, this.abort = function() {
            F = !0;
        }, this.getCharIndex = function() {
            return P;
        };
    }
    function m(e) {
        var t = e.data, r = h[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, y(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: b,
                resume: b
            };
            if (z(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: [
                        t.results.data[s]
                    ],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else z(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && y(t.workerId, t.results);
    }
    function y(e, t) {
        var r = h[e];
        z(r.userComplete) && r.userComplete(t), r.terminate(), delete h[e];
    }
    function b() {
        throw "Not implemented.";
    }
    function E(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = E(e[r]);
        return t;
    }
    function w(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function z(e) {
        return "function" == typeof e;
    }
    return o ? f.onmessage = function(e) {
        var t = e.data;
        void 0 === k.WORKER_ID && t && (k.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: k.WORKER_ID,
            results: k.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = k.parse(t.input, t.config);
            r && f.postMessage({
                workerId: k.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    } : k.WORKERS_SUPPORTED && (e = document.getElementsByTagName("script"), s = e.length ? e[e.length - 1].src : "", document.body ? document.addEventListener("DOMContentLoaded", function() {
        a = !0;
    }, !0) : a = !0), (c.prototype = Object.create(l.prototype)).constructor = c, (p.prototype = Object.create(l.prototype)).constructor = p, (_.prototype = Object.create(_.prototype)).constructor = _, (g.prototype = Object.create(l.prototype)).constructor = g, k;
});

});

parcelRegister("2qtxz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c44ec9af865f16f$export$2e2bcd8739ae039; });

var $RSSjA = parcelRequire("RSSjA");

var $d8hWe = parcelRequire("d8hWe");
parcelRequire("7PdBe");

var $dBifK = parcelRequire("dBifK");

var $gJnjK = parcelRequire("gJnjK");

var $bBGgZ = parcelRequire("bBGgZ");

var $iCTvZ = parcelRequire("iCTvZ");
parcelRequire("eSkAj");

var $5Xh7w = parcelRequire("5Xh7w");
var $1c44ec9af865f16f$var$_dec, $1c44ec9af865f16f$var$_dec2, $1c44ec9af865f16f$var$_dec3, $1c44ec9af865f16f$var$_dec4, $1c44ec9af865f16f$var$_dec5, $1c44ec9af865f16f$var$_dec6, $1c44ec9af865f16f$var$_dec7, $1c44ec9af865f16f$var$_dec8, $1c44ec9af865f16f$var$_dec9, $1c44ec9af865f16f$var$_class, $1c44ec9af865f16f$var$_descriptor, $1c44ec9af865f16f$var$_descriptor2, $1c44ec9af865f16f$var$_descriptor3, $1c44ec9af865f16f$var$_descriptor4, $1c44ec9af865f16f$var$_descriptor5, $1c44ec9af865f16f$var$_descriptor6, $1c44ec9af865f16f$var$_descriptor7, $1c44ec9af865f16f$var$_descriptor8, $1c44ec9af865f16f$var$_descriptor9, $1c44ec9af865f16f$var$_descriptor10, $1c44ec9af865f16f$var$_descriptor11, $1c44ec9af865f16f$var$_descriptor12, $1c44ec9af865f16f$var$_descriptor13, $1c44ec9af865f16f$var$_descriptor14;
function $1c44ec9af865f16f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $1c44ec9af865f16f$var$_defineProperty(e, r, t) {
    return (r = $1c44ec9af865f16f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1c44ec9af865f16f$var$_toPropertyKey(t) {
    var i = $1c44ec9af865f16f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1c44ec9af865f16f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1c44ec9af865f16f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $1c44ec9af865f16f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $1c44ec9af865f16f$var$TableStore = ($1c44ec9af865f16f$var$_dec = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_dec2 = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_dec3 = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_dec4 = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_dec5 = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_dec6 = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_dec7 = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_dec8 = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_dec9 = (0, $d8hWe.action).bound, $1c44ec9af865f16f$var$_class = class TableStore {
    constructor(){
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "showHeader", $1c44ec9af865f16f$var$_descriptor, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "showTotals", $1c44ec9af865f16f$var$_descriptor2, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "_rows", $1c44ec9af865f16f$var$_descriptor3, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "_rowsByObject", $1c44ec9af865f16f$var$_descriptor4, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "_columns", $1c44ec9af865f16f$var$_descriptor5, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "_columnsById", $1c44ec9af865f16f$var$_descriptor6, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "expandedRows", $1c44ec9af865f16f$var$_descriptor7, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "sortBy", $1c44ec9af865f16f$var$_descriptor8, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "groups", $1c44ec9af865f16f$var$_descriptor9, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "expandedGroups", $1c44ec9af865f16f$var$_descriptor10, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "filters", $1c44ec9af865f16f$var$_descriptor11, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "reverseSort", $1c44ec9af865f16f$var$_descriptor12, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "newRowDirection", $1c44ec9af865f16f$var$_descriptor13, this);
        $1c44ec9af865f16f$var$_initializerDefineProperty(this, "expandAll", $1c44ec9af865f16f$var$_descriptor14, this);
        $1c44ec9af865f16f$var$_defineProperty(this, "onExpand", ()=>null);
        $1c44ec9af865f16f$var$_defineProperty(this, "onCollapse", ()=>null);
        (0, $d8hWe.makeObservable)(this);
    }
    update({ columns: columns, rows: rows, getChildComponent: getChildComponent, showHeader: showHeader, showTotals: showTotals, sortBy: sortBy, groupBy: groupBy, filters: filters, newRowDirection: newRowDirection, expandedGroups: expandedGroups, onExpand: onExpand, onCollapse: onCollapse, expandAll: expandAll } = {}) {
        this.getChildComponent = getChildComponent !== null && getChildComponent !== void 0 ? getChildComponent : this.getChildComponent;
        this.setupColumns(columns !== null && columns !== void 0 ? columns : this.columns);
        this.groups = groupBy !== null && groupBy !== void 0 ? groupBy : this.groups;
        this.setupRows(rows);
        this.showHeader = showHeader !== null && showHeader !== void 0 ? showHeader : this.showHeader;
        this.showTotals = showTotals !== null && showTotals !== void 0 ? showTotals : this.showTotals;
        this.sortBy = sortBy !== null && sortBy !== void 0 ? sortBy : this.sortBy;
        this.filters = filters !== null && filters !== void 0 ? filters : this.filters;
        this.newRowDirection = newRowDirection !== null && newRowDirection !== void 0 ? newRowDirection : this.newRowDirection;
        this.expandedGroups = expandedGroups !== null && expandedGroups !== void 0 ? expandedGroups : this.expandedGroups;
        this.onExpand = onExpand !== null && onExpand !== void 0 ? onExpand : this.onExpand;
        this.onCollapse = onCollapse !== null && onCollapse !== void 0 ? onCollapse : this.onCollapse;
    }
    updateRows(rows) {
        this.setupRows(rows);
    }
    updateColumns(columns) {
        this.setupColumns(columns);
    }
    updateGroups(groups) {
        this.groups = groups;
    }
    updateColumn(column) {
        this._columnsById.set(column.id || column, new (0, $gJnjK.default)({
            ...column,
            tableStore: this
        }));
        this._rows.forEach((r)=>r.updateColumn(column));
    }
    getOrCreateColumn(columnDef) {
        if (!this._columnsById.get(columnDef.id || columnDef)) this._columnsById.set(columnDef.id || columnDef, new (0, $gJnjK.default)({
            ...columnDef,
            tableStore: this
        }));
        else this._columnsById.get(columnDef.id || columnDef).update(columnDef);
        return this._columnsById.get(columnDef.id || columnDef);
    }
    setupColumns(columns) {
        this._columns = new Set(columns.map((c)=>this.getOrCreateColumn(c)));
        this._columns.add(this.getOrCreateColumn({
            id: "position",
            tableStore: this,
            label: "",
            width: 3,
            type: "number",
            editable: (r)=>false,
            visible: false,
            value: (r)=>r.position
        }));
        if (this.getChildComponent) this._columns = new Set([
            this.getOrCreateColumn({
                id: "expand",
                tableStore: this,
                label: "",
                width: 3,
                type: "button",
                editable: (model, { row: row } = {})=>{
                    return row.id !== "totals";
                },
                value: (model, { row: row } = {})=>{
                    if (row.id === "totals") return null;
                    return /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                        className: "fa fa-chevron-" + (row.expanded ? "down" : "right"),
                        style: {
                            marginRight: 0
                        }
                    });
                },
                onClick: (rowObj, stores)=>()=>{
                        this.toggleRowExpand(stores.row);
                    }
            }),
            ...this._columns
        ]);
    }
    getOrCreateRow(rowObject, { id: id, group: group } = {}) {
        if (!this._rowsByObject.get(id || rowObject.id || rowObject)) {
            var _this$getChildCompone;
            this._rowsByObject.set(id || rowObject.id || rowObject, new (0, $bBGgZ.default)({
                id: id || rowObject.id || rowObject,
                rowObject: rowObject,
                table: this,
                childComponent: (_this$getChildCompone = this.getChildComponent) === null || _this$getChildCompone === void 0 ? void 0 : _this$getChildCompone.call(this, rowObject),
                group: group,
                childRows: new Set()
            }));
        }
        return this._rowsByObject.get(id || rowObject.id || rowObject);
    }
    setupRows(rowsData = []) {
        const noGroupRows = rowsData.map((r)=>{
            return this.getOrCreateRow(r);
        });
        this._rows = new Set([
            ...noGroupRows
        ]);
        let groupRows = {};
        noGroupRows.forEach((r)=>{
            let prevGroupRow = null;
            this.groups.forEach((gId, i)=>{
                const groupId = (0, $iCTvZ.default)(...this.groups.map((gId2, i2)=>{
                    return i2 <= i ? r.cells[gId2].equalityComparatorValue : undefined;
                }));
                const groupObject = r.cells[gId].value;
                let groupRow = groupRows[groupId];
                if (!groupRow) {
                    groupRow = groupRows[groupId] = this.getOrCreateRow(groupObject, {
                        id: groupId,
                        group: gId
                    });
                    groupRow = groupRows[groupId];
                    if (prevGroupRow) prevGroupRow._childRows.add(groupRow);
                    this._rows.add(groupRow);
                }
                if (i === this.groups.length - 1) groupRow._childRows.add(r);
                prevGroupRow = groupRow;
            });
        });
    }
    get columnsById() {
        const columnsById = {};
        this._columns.forEach((c)=>{
            columnsById[c.id] = c;
        });
        return columnsById;
    }
    get columns() {
        return [
            ...this._columns
        ].filter((c)=>c.visible);
    }
    get rowsByGroup() {
        const rowsByGroup = {};
        this._rows.forEach((r)=>{
            var _r$group, _rowsByGroup$_r$group;
            (_rowsByGroup$_r$group = rowsByGroup[_r$group = r.group]) !== null && _rowsByGroup$_r$group !== void 0 ? _rowsByGroup$_r$group : rowsByGroup[_r$group] = [];
            rowsByGroup[r.group].push(r);
        });
        return rowsByGroup;
    }
    get rows() {
        var _this$rowsByGroup$thi, _this$groups;
        const newSort = (r)=>r.rowObject.isNew;
        const newDir = this.newRowDirection;
        const createdSort = (r)=>r.rowObject.createdAt;
        const createdDir = this.newRowDirection === "asc" ? "desc" : "asc";
        const columnSort = this.sortBy.map(([prop, direction])=>(r)=>{
                let val;
                if (typeof prop === "string") val = r.cells[prop].sortComparatorValue;
                else val = prop(r.rowObject);
                return val || Infinity;
            });
        const columnDir = this.sortBy.map(([prop, direction])=>direction);
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy((_this$rowsByGroup$thi = this.rowsByGroup[(_this$groups = this.groups) === null || _this$groups === void 0 ? void 0 : _this$groups[0]]) === null || _this$rowsByGroup$thi === void 0 ? void 0 : _this$rowsByGroup$thi.filter((r)=>r.visible), [
            newSort,
            ...columnSort,
            createdSort
        ], [
            newDir,
            ...columnDir,
            createdDir
        ]);
    }
    toggleRowExpand(row) {
        if (this.expandedRows.has(row)) {
            this.expandedRows.delete(row);
            this.onCollapse(row.rowObject);
        } else {
            this.expandedRows.add(row);
            this.onExpand(row.rowObject);
        }
    }
    get headerLabels() {
        return this.columns.map((c)=>c.label);
    }
    get totals() {
        return this.columns.map((c)=>c.label);
    }
    get width() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.columns.map((c)=>c.width));
    }
    updateSort(column, direction) {
        this.sortBy = [
            [
                column,
                direction
            ]
        ];
    }
    get csvData() {
        const columns = this.columns.filter((c)=>c.visible && c.id !== "expand");
        return [
            columns.map((c)=>c.label),
            ...this.rows.map((r)=>columns.map((c)=>{
                    return r.cells[c.id].formattedValue;
                }))
        ];
    }
    getCsvData({ columns: columns = this.columns.filter((c)=>c.visible && c.id !== "expand"), rows: rows = this.rows, includeHeadings: includeHeadings = true } = {}) {
        const csv = [];
        if (includeHeadings) csv.push(columns.map((c)=>c.label));
        csv.push(...rows.map((r)=>columns.map((c)=>{
                return r.cells[c.id].formattedValue;
            })));
        return csv;
    }
    get totalsRow() {
        var _this$groups2;
        return new (0, $bBGgZ.default)({
            id: "totals",
            group: "totals",
            childRows: new Set(this.rowsByGroup[(_this$groups2 = this.groups) === null || _this$groups2 === void 0 ? void 0 : _this$groups2[0]]),
            table: this
        });
    }
}, $1c44ec9af865f16f$var$_descriptor = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "showHeader", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $1c44ec9af865f16f$var$_descriptor2 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "showTotals", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $1c44ec9af865f16f$var$_descriptor3 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "_rows", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $1c44ec9af865f16f$var$_descriptor4 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "_rowsByObject", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $1c44ec9af865f16f$var$_descriptor5 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "_columns", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $1c44ec9af865f16f$var$_descriptor6 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "_columnsById", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Map();
    }
}), $1c44ec9af865f16f$var$_descriptor7 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "expandedRows", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $1c44ec9af865f16f$var$_descriptor8 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "sortBy", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            [
                "position",
                "asc"
            ]
        ];
    }
}), $1c44ec9af865f16f$var$_descriptor9 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "groups", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $1c44ec9af865f16f$var$_descriptor10 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "expandedGroups", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $1c44ec9af865f16f$var$_descriptor11 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "filters", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $1c44ec9af865f16f$var$_descriptor12 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "reverseSort", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $1c44ec9af865f16f$var$_descriptor13 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "newRowDirection", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "desc";
    }
}), $1c44ec9af865f16f$var$_descriptor14 = $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "expandAll", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "update", [
    $1c44ec9af865f16f$var$_dec
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "update"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateRows", [
    $1c44ec9af865f16f$var$_dec2
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateRows"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateColumns", [
    $1c44ec9af865f16f$var$_dec3
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateColumns"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateGroups", [
    $1c44ec9af865f16f$var$_dec4
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateGroups"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateColumn", [
    $1c44ec9af865f16f$var$_dec5
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateColumn"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "getOrCreateColumn", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "getOrCreateColumn"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "setupColumns", [
    (0, $d8hWe.action)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "setupColumns"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "getOrCreateRow", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "getOrCreateRow"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "setupRows", [
    $1c44ec9af865f16f$var$_dec6
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "setupRows"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "columnsById", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "columnsById"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "columns", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "columns"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "rowsByGroup", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "rowsByGroup"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "rows", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "rows"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "toggleRowExpand", [
    $1c44ec9af865f16f$var$_dec7
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "toggleRowExpand"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "headerLabels", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "headerLabels"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "totals", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "totals"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "width", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "width"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateSort", [
    $1c44ec9af865f16f$var$_dec8
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "updateSort"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "csvData", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "csvData"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "getCsvData", [
    $1c44ec9af865f16f$var$_dec9
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "getCsvData"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_applyDecoratedDescriptor($1c44ec9af865f16f$var$_class.prototype, "totalsRow", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1c44ec9af865f16f$var$_class.prototype, "totalsRow"), $1c44ec9af865f16f$var$_class.prototype), $1c44ec9af865f16f$var$_class);
var $1c44ec9af865f16f$export$2e2bcd8739ae039 = $1c44ec9af865f16f$var$TableStore;

});
parcelRegister("gJnjK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2e2efb0ce04d4ed$export$2e2bcd8739ae039; });

parcelRequire("7PdBe");
parcelRequire("dBifK");

var $cjCbh = parcelRequire("cjCbh");

var $geLN1 = parcelRequire("geLN1");

var $02mKT = parcelRequire("02mKT");

var $k9JvZ = parcelRequire("k9JvZ");

var $fYF9X = parcelRequire("fYF9X");

var $9oioX = parcelRequire("9oioX");

var $84Xfx = parcelRequire("84Xfx");
function $c2e2efb0ce04d4ed$var$_defineProperty(e, r, t) {
    return (r = $c2e2efb0ce04d4ed$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c2e2efb0ce04d4ed$var$_toPropertyKey(t) {
    var i = $c2e2efb0ce04d4ed$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c2e2efb0ce04d4ed$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $c2e2efb0ce04d4ed$var$TableColumnStore {
    constructor(data){
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "id", (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))());
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "label", "");
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "tableStore", null);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "type", "text");
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "value", (row)=>String(row[this.id]));
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "editable", (row)=>false);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "style", (row)=>({}));
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "unique", false);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "visible", true);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "width", "10%");
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "onChange", (row, stores)=>()=>null);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "onClick", (row, stores)=>()=>null);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "onFocus", (row, stores)=>()=>null);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "onBlur", (row, stores)=>()=>null);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "data", ()=>[]);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "component", null);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "className", ()=>"");
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "selected", (row)=>false);
        $c2e2efb0ce04d4ed$var$_defineProperty(this, "permissions", ()=>true);
        // makeObservable(this)
        this.update(data);
    }
    update({ tableStore: tableStore, id: id, label: label, type: type, value: value, editable: editable, unique: unique, visible: visible, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, width: width, data: data, style: style, aggregate: aggregate, cellStyle: cellStyle, className: className, component: component, format: format, groupFormat: groupFormat, selected: selected, permissions: permissions }) {
        // makeObservable(this)
        this.tableStore = tableStore;
        this.id = id !== null && id !== void 0 ? id : this.id;
        this.label = label !== null && label !== void 0 ? label : this.label;
        this.type = type !== null && type !== void 0 ? type : this.type;
        this.value = value !== null && value !== void 0 ? value : this.value;
        this.editable = editable !== null && editable !== void 0 ? editable : this.editable;
        this.unique = unique !== null && unique !== void 0 ? unique : this.unique; // TODO - for disabling selectors
        this.visible = visible !== null && visible !== void 0 ? visible : this.visible;
        this.width = width !== null && width !== void 0 ? width : this.width;
        this.onClick = onClick !== null && onClick !== void 0 ? onClick : this.onClick;
        this.onChange = onChange !== null && onChange !== void 0 ? onChange : this.onChange;
        this.onFocus = onFocus !== null && onFocus !== void 0 ? onFocus : this.onFocus;
        this.onBlur = onBlur !== null && onBlur !== void 0 ? onBlur : this.onBlur;
        this.data = data !== null && data !== void 0 ? data : this.data;
        this.style = style !== null && style !== void 0 ? style : this.style;
        this.aggregate = aggregate !== null && aggregate !== void 0 ? aggregate : this.aggregate;
        this.cellStyle = cellStyle !== null && cellStyle !== void 0 ? cellStyle : this.cellStyle;
        this.className = className !== null && className !== void 0 ? className : this.className;
        this.component = component;
        this.format = format;
        this.groupFormat = groupFormat;
        this.selected = selected !== null && selected !== void 0 ? selected : this.selected;
        this.permissions = permissions !== null && permissions !== void 0 ? permissions : this.permissions;
    }
    get formatter() {
        return this.format || (0, $geLN1.default)[this.type] || (()=>"");
    }
    get groupFormatter() {
        return this.groupFormat || (0, $fYF9X.default)[this.type] || (()=>"");
    }
    get equalityComparator() {
        return (0, $02mKT.default)[this.type] || (()=>-Infinity);
    }
    get sortComparator() {
        return (0, $k9JvZ.default)[this.type] || (()=>-Infinity);
    }
    get aggregator() {
        var _Aggregator$this$type, _Aggregator$this$type2, _Aggregator$this$type3;
        if (this.aggregate === "none") return ()=>null;
        return ((_Aggregator$this$type = (0, $9oioX.default)[this.type]) === null || _Aggregator$this$type === void 0 ? void 0 : _Aggregator$this$type[this.aggregate]) || ((_Aggregator$this$type2 = (0, $9oioX.default)[this.type]) === null || _Aggregator$this$type2 === void 0 ? void 0 : _Aggregator$this$type2.sum) || ((_Aggregator$this$type3 = (0, $9oioX.default)[this.type]) === null || _Aggregator$this$type3 === void 0 ? void 0 : _Aggregator$this$type3.avg) || (()=>null);
    }
    get sortable() {
        return [
            "text",
            "number"
        ].includes(this.type);
    }
    get filterable() {
        return [
            "text",
            "number"
        ].includes(this.type);
    }
    get groupable() {
        return [
            "project",
            "phase",
            "staff",
            "role",
            "costCentre",
            "status",
            "contact"
        ].includes(this.type);
    }
    get textAlign() {
        switch(this.type){
            case "number":
            case "currency":
            case "percent":
            case "durationMinutes":
            case "date":
                return "right";
            case "checkbox":
                return "center";
            default:
                return "left";
        }
    }
    get justifyContent() {
        switch(this.type){
            case "number":
            case "currency":
            case "percent":
            case "durationMinutes":
            case "date":
                return "flex-end";
            case "checkbox":
                return "center";
            default:
                return "flex-start";
        }
    }
    get cellComponent() {
        return this.component || (0, $84Xfx.default)[this.type];
    }
}
var $c2e2efb0ce04d4ed$export$2e2bcd8739ae039 = $c2e2efb0ce04d4ed$var$TableColumnStore;

});
parcelRegister("k9JvZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eac7f43af7f3fb18$export$2e2bcd8739ae039; });

var $bwMFl = parcelRequire("bwMFl");
var $eac7f43af7f3fb18$export$2e2bcd8739ae039 = {
    boolean: (value)=>value,
    text: (value)=>value ? String(value).toLowerCase() : "",
    number: (value)=>value !== null && value !== void 0 ? value : -Infinity,
    currency: (value)=>value !== null && value !== void 0 ? value : -Infinity,
    percent: (value)=>value !== null && value !== void 0 ? value : -Infinity,
    durationMinutes: (value)=>value !== null && value !== void 0 ? value : -Infinity,
    date: (value)=>value instanceof Date && !isNaN(value) ? value === null || value === void 0 ? void 0 : value.getTime() : -Infinity,
    duration: (value)=>value !== null && value !== void 0 && value.value && value !== null && value !== void 0 && value.unit ? (0, $bwMFl.durationToUnit)(value, "milliseconds") : -Infinity,
    progress: (value)=>value !== null && value !== void 0 && value.denominator ? value.numerator / value.denominator : -Infinity,
    progressBar: (value)=>value !== null && value !== void 0 && value.denominator ? value.numerator / value.denominator : -Infinity,
    project: (value)=>{
        var _value$title;
        return (_value$title = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title !== void 0 ? _value$title : "";
    },
    phase: (value)=>{
        var _value$title2;
        return (_value$title2 = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title2 !== void 0 ? _value$title2 : "";
    },
    costCentre: (value)=>{
        var _value$name;
        return (_value$name = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name !== void 0 ? _value$name : "";
    },
    contact: (value)=>{
        var _value$label;
        return (_value$label = value === null || value === void 0 ? void 0 : value.label) !== null && _value$label !== void 0 ? _value$label : "";
    },
    staff: (value)=>{
        var _value$fullName;
        return (_value$fullName = value === null || value === void 0 ? void 0 : value.fullName) !== null && _value$fullName !== void 0 ? _value$fullName : "";
    },
    staffMember: (value)=>{
        var _value$fullName2;
        return (_value$fullName2 = value === null || value === void 0 ? void 0 : value.fullName) !== null && _value$fullName2 !== void 0 ? _value$fullName2 : "";
    },
    role: (value)=>{
        var _value$name2;
        return (_value$name2 = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name2 !== void 0 ? _value$name2 : "";
    },
    status: (value)=>value !== null && value !== void 0 ? value : ""
};

});

parcelRegister("fYF9X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba1c63086b7e9639$export$2e2bcd8739ae039; });


var $aJxsR = parcelRequire("aJxsR");

var $5tIfX = parcelRequire("5tIfX");

var $gDVAs = parcelRequire("gDVAs");

var $fSXDi = parcelRequire("fSXDi");

var $dBifK = parcelRequire("dBifK");

var $46jCe = parcelRequire("46jCe");

var $geLN1 = parcelRequire("geLN1");
var $ba1c63086b7e9639$export$2e2bcd8739ae039 = {
    boolean: (values, { fallbackValue: fallbackValue } = {})=>{
        var _ref, _values$map$join, _values$map;
        return (_ref = (_values$map$join = (_values$map = values.map) === null || _values$map === void 0 ? void 0 : _values$map.call(values, (value)=>String(value)).join(", ")) !== null && _values$map$join !== void 0 ? _values$map$join : values) !== null && _ref !== void 0 ? _ref : fallbackValue;
    },
    text: (values, { fallbackValue: fallbackValue } = {})=>{
        var _ref2, _values$map$join2, _values$map2;
        return (_ref2 = (_values$map$join2 = (_values$map2 = values.map) === null || _values$map2 === void 0 ? void 0 : _values$map2.call(values, (value)=>String(value)).join(", ")) !== null && _values$map$join2 !== void 0 ? _values$map$join2 : values) !== null && _ref2 !== void 0 ? _ref2 : fallbackValue;
    },
    number: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber;
        return isFinite(value) ? (_FormatNumber = (0, $gDVAs.FormatNumber)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(value), {
            decimals: decimals
        })) !== null && _FormatNumber !== void 0 ? _FormatNumber : fallbackValue : fallbackValue;
    },
    durationMinutes: (value, { fallbackValue: fallbackValue } = {})=>{
        var _FormatMinutes;
        return isFinite(value) ? (_FormatMinutes = (0, $geLN1.FormatMinutes)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(value), {
            fallbackValue: fallbackValue
        })) !== null && _FormatMinutes !== void 0 ? _FormatMinutes : fallbackValue : fallbackValue;
    },
    currency: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>{
        var _FormatCurrency;
        return isFinite(value) ? (_FormatCurrency = (0, $5tIfX.FormatCurrency)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(value), {
            decimals: decimals
        })) !== null && _FormatCurrency !== void 0 ? _FormatCurrency : fallbackValue : fallbackValue;
    },
    // TODO - useful?
    percent: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>{
        var _FormatPercent;
        return isFinite(value) ? (_FormatPercent = (0, $fSXDi.FormatPercent)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(value), {
            decimals: decimals
        })) !== null && _FormatPercent !== void 0 ? _FormatPercent : fallbackValue : fallbackValue;
    },
    date: (value, { fallbackValue: fallbackValue } = {})=>value instanceof Date && !isNaN(value) ? (0, $46jCe.FormatDate)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(value)) : fallbackValue,
    duration: (value, { decimals: decimals = 2, fallbackValue: fallbackValue } = {})=>value !== null && value !== void 0 && value.value && value !== null && value !== void 0 && value.unit ? `${(0, $gDVAs.FormatNumber)(value.value, {
            decimals: decimals
        })} ${(0, (/*@__PURE__*/$parcel$interopDefault($aJxsR)))(value.unit, (0, $gDVAs.FormatNumber)(value.value, {
            decimals: decimals
        }))}` : fallbackValue,
    progress: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber2;
        return isFinite(value) ? (_FormatNumber2 = (0, $gDVAs.FormatNumber)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(value), {
            decimals: decimals
        })) !== null && _FormatNumber2 !== void 0 ? _FormatNumber2 : fallbackValue : fallbackValue;
    },
    progressBar: (value, { decimals: decimals = 0, fallbackValue: fallbackValue } = {})=>{
        var _FormatNumber3;
        return isFinite(value) ? (_FormatNumber3 = (0, $gDVAs.FormatNumber)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(value), {
            decimals: decimals
        })) !== null && _FormatNumber3 !== void 0 ? _FormatNumber3 : fallbackValue : fallbackValue;
    },
    project: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join3;
        return (_values$map$join3 = values.map((value)=>value === null || value === void 0 ? void 0 : value.title).join(", ")) !== null && _values$map$join3 !== void 0 ? _values$map$join3 : fallbackValue;
    },
    phase: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join4;
        return (_values$map$join4 = values.map((value)=>value === null || value === void 0 ? void 0 : value.title).join(", ")) !== null && _values$map$join4 !== void 0 ? _values$map$join4 : fallbackValue;
    },
    costCentre: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join5;
        return (_values$map$join5 = values.map((value)=>value === null || value === void 0 ? void 0 : value.name).join(", ")) !== null && _values$map$join5 !== void 0 ? _values$map$join5 : fallbackValue;
    },
    contact: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join6;
        return (_values$map$join6 = values.map((value)=>value === null || value === void 0 ? void 0 : value.label).join(", ")) !== null && _values$map$join6 !== void 0 ? _values$map$join6 : fallbackValue;
    },
    staff: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join7;
        return (_values$map$join7 = values.map((value)=>value === null || value === void 0 ? void 0 : value.fullName).join(", ")) !== null && _values$map$join7 !== void 0 ? _values$map$join7 : fallbackValue;
    },
    staffMember: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join8;
        return (_values$map$join8 = values.map((value)=>value === null || value === void 0 ? void 0 : value.fullName).join(", ")) !== null && _values$map$join8 !== void 0 ? _values$map$join8 : fallbackValue;
    },
    role: (values, { fallbackValue: fallbackValue } = {})=>{
        var _values$map$join9;
        return (_values$map$join9 = values.map((value)=>value === null || value === void 0 ? void 0 : value.name).join(", ")) !== null && _values$map$join9 !== void 0 ? _values$map$join9 : fallbackValue;
    },
    status: (values, { fallbackValue: fallbackValue } = {})=>{
        var _ref3, _values$map$join10, _values$map3;
        return (_ref3 = (_values$map$join10 = (_values$map3 = values.map) === null || _values$map3 === void 0 ? void 0 : _values$map3.call(values, (value)=>String(value)).join(", ")) !== null && _values$map$join10 !== void 0 ? _values$map$join10 : values) !== null && _ref3 !== void 0 ? _ref3 : fallbackValue;
    }
};

});

parcelRegister("9oioX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d64a118017d5ef1$export$2e2bcd8739ae039; });

parcelRequire("aJxsR");

var $dBifK = parcelRequire("dBifK");
parcelRequire("8KwGs");

var $bwMFl = parcelRequire("bwMFl");

var $hKySO = parcelRequire("hKySO");
var $6d64a118017d5ef1$export$2e2bcd8739ae039 = {
    boolean: {
        sum: (values)=>values.every((v)=>v),
        avg: (values)=>Math.round((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(values)),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(values),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(values)
    },
    // text: { sum: (values) => [...new Set(values.filter((v) => v))] },
    number: {
        sum: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.filter((v)=>isFinite(v))),
        avg: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(values.filter((v)=>isFinite(v))),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(values.filter((v)=>isFinite(v))),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(values.filter((v)=>isFinite(v)))
    },
    currency: {
        sum: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.filter((v)=>isFinite(v))),
        avg: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(values.filter((v)=>isFinite(v))),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(values.filter((v)=>isFinite(v))),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(values.filter((v)=>isFinite(v)))
    },
    percent: {
        sum: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.filter((v)=>isFinite(v))),
        avg: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(values.filter((v)=>isFinite(v))),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(values.filter((v)=>isFinite(v))),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(values.filter((v)=>isFinite(v)))
    },
    durationHours: {
        sum: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.filter((v)=>isFinite(v))),
        avg: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(values.filter((v)=>isFinite(v))),
        max: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(values.filter((v)=>isFinite(v))),
        min: (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(values.filter((v)=>isFinite(v)))
    },
    date: {
        avg: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime()))),
        max: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime()))),
        min: (values)=>new Date((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(values.filter((v)=>v instanceof Date && !isNaN(v)).map((v)=>v.getTime())))
    },
    duration: {
        sum: (values)=>{
            var _values$, _values$2;
            return {
                value: (0, $bwMFl.durationToUnit)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.map((v)=>(0, $bwMFl.durationToUnit)(v, "milliseconds") || 0)), (_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.unit),
                unit: (_values$2 = values[0]) === null || _values$2 === void 0 ? void 0 : _values$2.unit
            };
        },
        avg: (values)=>{
            var _values$3, _values$4;
            return {
                value: (0, $bwMFl.durationToUnit)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(values.map((v)=>(0, $bwMFl.durationToUnit)(v, "milliseconds") || 0)), (_values$3 = values[0]) === null || _values$3 === void 0 ? void 0 : _values$3.unit),
                unit: (_values$4 = values[0]) === null || _values$4 === void 0 ? void 0 : _values$4.unit
            };
        },
        max: (values)=>{
            var _values$5, _values$6;
            return {
                value: (0, $bwMFl.durationToUnit)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(values.map((v)=>(0, $bwMFl.durationToUnit)(v, "milliseconds") || 0)), (_values$5 = values[0]) === null || _values$5 === void 0 ? void 0 : _values$5.unit),
                unit: (_values$6 = values[0]) === null || _values$6 === void 0 ? void 0 : _values$6.unit
            };
        },
        min: (values)=>{
            var _values$7, _values$8;
            return {
                value: (0, $bwMFl.durationToUnit)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(values.map((v)=>(0, $bwMFl.durationToUnit)(v, "milliseconds") || 0)), (_values$7 = values[0]) === null || _values$7 === void 0 ? void 0 : _values$7.unit),
                unit: (_values$8 = values[0]) === null || _values$8 === void 0 ? void 0 : _values$8.unit
            };
        }
    },
    progress: {
        sum: (values)=>{
            return {
                numerator: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.numerator : 0)),
                denominator: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.denominator : 0))
            };
        },
        avg: (values)=>({
                numerator: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).avg(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.numerator : 0)),
                denominator: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).avg(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.denominator : 0))
            })
    },
    progressBar: {
        sum: (values)=>{
            return {
                numerator: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.numerator : 0)),
                denominator: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.denominator : 0))
            };
        },
        avg: (values)=>({
                numerator: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).avg(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.numerator : 0)),
                denominator: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).avg(values.map((v)=>isFinite(v === null || v === void 0 ? void 0 : v.numerator) ? v.denominator : 0))
            })
    },
    project: {
        sum: (values)=>[
                ...new Set(values.filter((v)=>v))
            ]
    },
    phase: {
        sum: (values)=>[
                ...new Set(values.filter((v)=>v))
            ]
    },
    costCentre: {
        sum: (values)=>[
                ...new Set(values.filter((v)=>v))
            ]
    },
    contact: {
        sum: (values)=>[
                ...new Set(values.filter((v)=>v))
            ]
    },
    staff: {
        sum: (values)=>[
                ...new Set(values.filter((v)=>v))
            ]
    },
    staffMember: {
        sum: (values)=>[
                ...new Set(values.filter((v)=>v))
            ]
    },
    task: {
        sum: (values)=>[
                ...new Set(values.filter((v)=>v))
            ]
    },
    role: {
        sum: (values)=>[
                ...new Set(values.filter((v)=>v))
            ]
    },
    status: {
        max: (values)=>{
            const statusPriority = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(values.map((v)=>(0, $hKySO.statusPriorities)[v]));
            return (0, $hKySO.statusByPriority)[statusPriority];
        }
    }
};

});

parcelRegister("84Xfx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e1ca82ba36682bb$export$2e2bcd8739ae039; });

var $RSSjA = parcelRequire("RSSjA");

parcelRequire("aJxsR");

var $aB9XV = parcelRequire("aB9XV");
parcelRequire("7PdBe");

var $2Tkhn = parcelRequire("2Tkhn");
const $5e1ca82ba36682bb$var$PlainTextCellComponent = ({ formattedValue: formattedValue, onClick: onClick, onFocus: onFocus, onBlur: onBlur })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        style: {
            height: "100%",
            width: "100%"
        },
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        children: formattedValue || /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
            children: "\xa0"
        })
    });
};
var $5e1ca82ba36682bb$export$2e2bcd8739ae039 = {
    boolean: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return editable ? (0, $2Tkhn.default).checkbox({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            disabled: !editable
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        });
    },
    text: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).text({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    number: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).number({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    currency: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).currency({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    percent: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).percent({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    date: ({ value: value, formattedvalue: formattedvalue, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).date({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    duration: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).duration({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    progress: ({ value: value, formattedValue: formattedValue, formatter: formatter, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
            children: `${isFinite(value === null || value === void 0 ? void 0 : value.numerator) ? formatter(value === null || value === void 0 ? void 0 : value.numerator) : "-"} / ${isFinite(value === null || value === void 0 ? void 0 : value.denominator) ? formatter(value === null || value === void 0 ? void 0 : value.denominator) : "-"}`
        });
    },
    progressBar: ({ value: value, formattedValue: formattedValue, formatter: formatter, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $aB9XV.default), {
            width: "100%",
            height: "1.5em",
            numerator: value === null || value === void 0 ? void 0 : value.numerator,
            denominator: value === null || value === void 0 ? void 0 : value.denominator,
            formatNumber: formatter
        });
    },
    project: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).project({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    phase: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).phase({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    costCentre: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return editable ? (0, $2Tkhn.default).costCentre({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        });
    },
    contact: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).contact({
            value: value,
            formattedValue: formattedValue,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    staff: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).staff({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    staffMember: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).staff({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    role: ({ value: value, formattedvalue: formattedvalue, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).role({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    button: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return value ? (0, $2Tkhn.default).button({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            disabled: !editable
        }) : null;
    },
    checkbox: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return (0, $2Tkhn.default).checkbox({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group,
            disabled: !editable
        });
    },
    textarea: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return editable ? (0, $2Tkhn.default).textarea({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
            children: value
        });
    },
    status: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return editable ? (0, $2Tkhn.default).status({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        });
    },
    staffOrRole: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>{
        return (0, $2Tkhn.default).staffOrRole({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        });
    },
    task: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).task({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        }),
    durationMinutes: ({ value: value, formattedValue: formattedValue, editable: editable = false, onChange: onChange, onClick: onClick, onFocus: onFocus, onBlur: onBlur, validator: validator, group: group, stores: stores })=>editable ? (0, $2Tkhn.default).durationMinutes({
            value: value,
            editable: editable,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            validator: validator,
            group: group
        }) : /*#__PURE__*/ (0, $RSSjA.jsx)($5e1ca82ba36682bb$var$PlainTextCellComponent, {
            formattedValue: formattedValue,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        })
};
const $5e1ca82ba36682bb$export$5ddacafafa766b44 = (number, decimals = 2, multiplyer = 1)=>{
    return Math.round((parseFloat(number) || 0) * multiplyer * Math.pow(10, decimals)) / Math.pow(10, decimals);
};

});
parcelRegister("aB9XV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b7517072049f4dc$export$2e2bcd8739ae039; });

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");
parcelRequire("dBifK");

var $4bOnx = parcelRequire("4bOnx");
var $7b7517072049f4dc$export$2e2bcd8739ae039 = ({ numerator: numerator, denominator: denominator, nullText: nullText = "N/A", formatNumber: formatNumber = (n)=>Math.round(n), ...props })=>{
    let value, text;
    if (numerator == null) {
        value = NaN;
        text = nullText;
    } else if (denominator == null || denominator === 0) {
        value = NaN;
        text = `${formatNumber(numerator)} / -`;
    } else {
        value = numerator / denominator;
        text = `${formatNumber(numerator)} / ${formatNumber(denominator)} (${(0, $4bOnx.formatPercentage0)(numerator / denominator * 100)})`;
    }
    return /*#__PURE__*/ (0, $RSSjA.jsx)($7b7517072049f4dc$var$ProgressBar, {
        value: value,
        text: text,
        ...props
    });
};
const $7b7517072049f4dc$var$ProgressBar = ({ width: width, height: height, value: value, text: text, className: className, ...props })=>{
    var val = !isNaN(value) ? value : 0;
    var color;
    if (val < 0.8) color = "#FFC734";
    else if (val <= 1.0) color = "#ffb534";
    else color = "#f05a28";
    var innerWidth = (0, $4bOnx.middleOfThree)(0, val, 1) * 100 + "%";
    return /*#__PURE__*/ (0, $RSSjA.jsx)("svg", {
        className: className,
        style: {
            width: width,
            height: height,
            display: "inline-block"
        },
        children: /*#__PURE__*/ (0, $RSSjA.jsxs)("g", {
            shapeRendering: "crisp-edges",
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsx)("rect", {
                    x: 0,
                    y: 0,
                    width: "100%",
                    height: "100%",
                    fill: !isNaN(value) ? "#888" : "#aaa",
                    stroke: "none"
                }),
                value > 0 ? /*#__PURE__*/ (0, $RSSjA.jsx)("g", {
                    children: /*#__PURE__*/ (0, $RSSjA.jsx)("rect", {
                        x: 0,
                        y: 0,
                        width: innerWidth,
                        height: "100%",
                        fill: color,
                        stroke: "none"
                    })
                }) : null,
                text ? /*#__PURE__*/ (0, $RSSjA.jsx)("text", {
                    x: "50%",
                    y: "50%",
                    fill: "white",
                    textAnchor: "middle",
                    dy: "0.4em",
                    style: {
                        fontWeight: 600,
                        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.43)"
                    },
                    children: text
                }) : null
            ]
        })
    });
};

});
parcelRegister("4bOnx", function(module, exports) {

$parcel$export(module.exports, "formatMinutes", function () { return $30cf44a1cef75e8e$export$30c35cbf580cab77; });
$parcel$export(module.exports, "parseTime", function () { return $30cf44a1cef75e8e$export$c9698ec7f05a07e1; });
$parcel$export(module.exports, "formatPercentage0", function () { return $30cf44a1cef75e8e$export$4918778803e89c4; });
$parcel$export(module.exports, "isNumber", function () { return $30cf44a1cef75e8e$export$7e4aa119212bc614; });
$parcel$export(module.exports, "middleOfThree", function () { return $30cf44a1cef75e8e$export$2ce6e9dde12d591b; });
$parcel$export(module.exports, "mergeProps", function () { return $30cf44a1cef75e8e$export$9d1611c77c2fe928; });
/* @flow */ 
var $RSSjA = parcelRequire("RSSjA");

var $8KwGs = parcelRequire("8KwGs");
parcelRequire("X1RuM");
var $5irfN = parcelRequire("5irfN");

var $7PdBe = parcelRequire("7PdBe");

var $5JTQC = parcelRequire("5JTQC");

var $ksXgP = parcelRequire("ksXgP");

var $dycmL = parcelRequire("dycmL");

var $S29Lp = parcelRequire("S29Lp");

var $cjCbh = parcelRequire("cjCbh");
function $30cf44a1cef75e8e$export$89a7e74069fbb7af(obj) {
    var str = [];
    for(var p in obj)if (obj.hasOwnProperty(p)) {
        var val = obj[p];
        if (val == null) val = "";
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(val));
    }
    return str.join("&");
}
var $30cf44a1cef75e8e$export$d2b052e7b4be1756 = (0, (/*@__PURE__*/$parcel$interopDefault($5JTQC)))({
    /**
   * `selectedName` should be managed by the parent (via `onClick`) and be set
   * to the `name` of the selected `ToggleButton` of the group in question.
   * When a `ToggleButton` is clicked, the `onClick` handler is called with the
   * value of the  `name` property being the only argument.
   */ propTypes: {
        name: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string.isRequired,
        selectedName: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func.isRequired
    },
    getInitialState: function() {
        return {};
    },
    render: function() {
        return /*#__PURE__*/ (0, $RSSjA.jsxs)("label", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ksXgP)))({
                btn: true,
                "btn-primary": true,
                active: this.props.selectedName === this.props.name
            }),
            onClick: this.handleClick,
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsx)("input", {
                    type: "radio",
                    name: "options",
                    autoComplete: "off"
                }),
                this.props.label
            ]
        });
    },
    handleClick: function() {
        this.props.onClick(this.props.name);
    }
});
var $30cf44a1cef75e8e$export$931cbfb6bfb85fc = (0, (/*@__PURE__*/$parcel$interopDefault($5JTQC)))({
    propTypes: {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).array.isRequired,
        renderMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func.isRequired,
        renderSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).any,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).object
    },
    getDefaultProps: function() {
        return {
            style: {}
        };
    },
    render: function() {
        var self = this;
        if (this.props.style.paddingLeft == null) this.props.style.paddingLeft = 0;
        return /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
            className: "btn",
            style: this.props.style,
            children: /*#__PURE__*/ (0, $RSSjA.jsxs)("span", {
                className: "dropdown",
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsxs)("button", {
                        className: "btn btn-default dropdown-toggle",
                        type: "button",
                        "data-toggle": "dropdown",
                        "aria-expanded": "true",
                        children: [
                            self.props.renderSelectedItem(self.props.value),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "caret"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)("ul", {
                        className: "dropdown-menu",
                        role: "menu",
                        "aria-labelledby": "dropdownMenu1",
                        children: self.props.items.map(function(item, index) {
                            return /*#__PURE__*/ (0, $RSSjA.jsx)("li", {
                                role: "presentation",
                                children: /*#__PURE__*/ (0, $RSSjA.jsx)("a", {
                                    href: "js/void",
                                    onClick: function() {
                                        self.props.onChange(item);
                                    },
                                    style: {
                                        color: "black"
                                    },
                                    children: self.props.renderMenuItem(item)
                                })
                            }, index);
                        })
                    })
                ]
            })
        });
    }
});
var $30cf44a1cef75e8e$export$8afccc1c0f0dfc45 = (0, (/*@__PURE__*/$parcel$interopDefault($5JTQC)))({
    propTypes: {
        // "top" and "left" are also doable but we just haven't supported those with css yet.
        orientation: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOf([
            "bottom",
            "right",
            "block"
        ]),
        message: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).any.isRequired,
        arrowProps: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).object
    },
    getDefaultProps: function() {
        return {
            arrowProps: {}
        };
    },
    render: function() {
        let { orientation: orientation, message: message, arrowProps: arrowProps, className: className, ...props } = this.props;
        return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ksXgP)))("popover", "error-message-popover", orientation, className),
            ...props,
            children: [
                orientation != null ? /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                    className: "arrow",
                    ...arrowProps
                }) : null,
                /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                    className: "popover-content",
                    children: message
                })
            ]
        });
    }
});
function $30cf44a1cef75e8e$export$8f72f92bbe1a7cfc(d) {
    if (d == null) return null;
    else return (0, (/*@__PURE__*/$parcel$interopDefault($8KwGs)))(d, "YYYY-MM-DD");
}
function $30cf44a1cef75e8e$export$588937bcd60ade55(s) {
    if (s.indexOf("+") >= 0) return (0, (/*@__PURE__*/$parcel$interopDefault($8KwGs)))(s, "YYYY-MM-DDTHH:mm:ssZ");
    else return (0, (/*@__PURE__*/$parcel$interopDefault($8KwGs)))(s, "YYYY-MM-DDTHH:mm:ss");
}
function $30cf44a1cef75e8e$export$30c35cbf580cab77(totalMinutes) {
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    return hours + ":" + (minutes < 10 ? "0" : "") + minutes;
}
function $30cf44a1cef75e8e$export$c9698ec7f05a07e1(timeText) {
    /**
   * Returns `null` if `timeText` isn't in a recognised time format.
   */ let hours, minutes;
    if (timeText == null) return null;
    if (timeText.length > 0) {
        if (timeText.match(/^\d{1,2}$/)) {
            // If they enter just a number then that's a number of hours.
            hours = parseInt(timeText);
            minutes = 0;
        } else if (timeText.match(/^(\d{0,2})[.](\d{1,2})?$/)) {
            // Regular "hh.mm" time.
            let parts = [
                RegExp.$1,
                RegExp.$2
            ];
            hours = parts[0] !== "" ? parseInt(parts[0]) : 0;
            minutes = parts[1] !== "" ? parseInt(parts[1]) : 0;
            if (minutes < 10 && parts[1].length === 1) minutes *= 10;
            minutes = minutes / 100 * 60;
        } else if (timeText.match(/^(\d{0,2})[:](\d{1,2})?$/)) {
            // Regular "hh:mm" or "hh.mm" time.
            let parts = [
                RegExp.$1,
                RegExp.$2
            ];
            hours = parts[0] !== "" ? parseInt(parts[0]) : 0;
            // We decided that eg. "3:3" should be interpreted as "3:30".  Also "3:"
            // should be "3:00". But obviously "3:06" should not be "3:60" etc.
            //
            // So:
            // "3:" -> 3:00
            // "3:0" -> 3:00
            // "3:00" -> 3:00
            // "3:01" -> 3:01
            // "3:1" -> 3:10
            // "3:5" -> 3:50
            // "3:6" -> 3:06
            // "3:9" -> 3:09
            minutes = parts[1] !== "" ? parseInt(parts[1]) : 0;
            if (minutes < 6 && parts[1].length === 1) minutes *= 10;
        } else return null;
    } else return null;
    return hours * 60 + minutes;
}
const $30cf44a1cef75e8e$export$e4936eab6cf48196 = class {
    constructor(options){
        this.component = options.component;
        this.stateVar = options.stateVar;
    }
    handleFieldChangeValue(fieldName, value) {
        this.component.state[this.stateVar][fieldName] = value;
        var newState = {};
        newState[this.stateVar] = this.component.state[this.stateVar];
        this.component.setState(newState);
        this.component._validate();
    }
    handleFieldChange(fieldName, event) {
        this.handleFieldChangeValue(fieldName, event.target.value);
    }
    getHandleFunc(fieldName) {
        var self = this;
        return function(event) {
            self.handleFieldChange(fieldName, event);
        };
    }
};
function $30cf44a1cef75e8e$export$b9efc2a2f4df02ec(component, variable) {
    function updateState(val) {
        var s = {};
        s[variable] = val;
        component.setState(s);
    }
    return {
        onMouseOver: function() {
            updateState(true);
        },
        onMouseOut: function() {
            updateState(false);
        }
    };
}
function $30cf44a1cef75e8e$export$e73c8bd0f20705a(prefix = "") {
    // http://stackoverflow.com/a/8809472/223486
    var d = new Date().getTime();
    var uuid = String(prefix) + "-" + (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))();
    // + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    //   var r = (d + Math.random()*16)%16 | 0;
    //   d = Math.floor(d/16);
    //   return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    // });
    return uuid;
}
function $30cf44a1cef75e8e$export$4918778803e89c4(num, { ifNull: ifNull = null } = {}) {
    if (!$30cf44a1cef75e8e$export$7e4aa119212bc614(num)) return ifNull;
    else return Math.round(num) + "%";
}
function $30cf44a1cef75e8e$export$4ffa315feef661a5(num, { ifNull: ifNull = null } = {}) {
    if (!$30cf44a1cef75e8e$export$7e4aa119212bc614(num)) return ifNull;
    else return Math.round(num * 100) / 100 + "%";
}
function $30cf44a1cef75e8e$export$5d19f6df0759cd52(num, { ifNull: ifNull = null } = {}) {
    if (!$30cf44a1cef75e8e$export$7e4aa119212bc614(num)) return ifNull;
    return Math.round(num);
}
function $30cf44a1cef75e8e$export$2f5fa8a9e6c033e3(num, n, { ifNull: ifNull = null } = {}) {
    /**
   * >>> formatNumber1(2)
   * "2"
   *
   * >>> formatNumber1(2.011111)
   * "2.0"
   */ if (!$30cf44a1cef75e8e$export$7e4aa119212bc614(num)) return ifNull;
    let f = num.toFixed(n);
    let shouldChop = true;
    let ix = f.indexOf(".");
    if (ix !== -1) {
        for(let i = ix + 1; i < f.length; i++)if (f[i] !== "0") {
            shouldChop = false;
            break;
        }
    }
    if (shouldChop) f = f.substr(0, f.length - n - 1);
    return f;
}
function $30cf44a1cef75e8e$export$ccce9119a8543e33(num, { ifNull: ifNull = null } = {}) {
    /**
   * >>> formatNumber1(2)
   * "2"
   *
   * >>> formatNumber1(2.011111)
   * "2.0"
   */ return $30cf44a1cef75e8e$export$2f5fa8a9e6c033e3(num, 1, {
        ifNull: ifNull
    });
}
function $30cf44a1cef75e8e$export$36c108163051f3e0(num, { ifNull: ifNull = null } = {}) {
    /**
   * >>> formatNumber2(2)
   * "2"
   *
   * >>> formatNumber2(2.011111)
   * "2.01"
   */ return $30cf44a1cef75e8e$export$2f5fa8a9e6c033e3(num, 2, {
        ifNull: ifNull
    });
}
function $30cf44a1cef75e8e$export$d716cefd47d84056(num, n, { ifNull: ifNull = null } = {}) {
    if (!$30cf44a1cef75e8e$export$7e4aa119212bc614(num)) return ifNull;
    let p = Math.pow(10, n);
    return Math.round(num * p) / p;
}
function $30cf44a1cef75e8e$export$665cf93617f845c9(num, { ifNull: ifNull = null } = {}) {
    return $30cf44a1cef75e8e$export$5d19f6df0759cd52(num, {
        ifNull: ifNull
    }) + "h";
}
function $30cf44a1cef75e8e$export$9f31de9e2b781ab3(value, singular, plural = null) {
    return `${value} ${value === 1 ? singular : plural != null ? plural : singular + "s"}`;
}
function $30cf44a1cef75e8e$export$4365868ff9ac7d1a(event, svg) {
    /**
   * `event`: a React event (I think)
   * `svg`: an SVG DOM node.
   */ let p;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX;
        point.y = event.clientY;
        point = point.matrixTransform(svg.getScreenCTM().inverse());
        p = [
            point.x,
            point.y
        ];
    } else {
        let rect = svg.getBoundingClientRect();
        p = [
            event.clientX - rect.left - svg.clientLeft,
            event.clientY - rect.top - svg.clientTop
        ];
    }
    // TODO-merge figure out when clipping is/isn't appropriate (check scrolling
    // / panning).
    var clip = true;
    if (clip) {
        let rect = svg.getBoundingClientRect();
        p[0] = $30cf44a1cef75e8e$export$2ce6e9dde12d591b(0, p[0], rect.width);
        p[1] = $30cf44a1cef75e8e$export$2ce6e9dde12d591b(0, p[1], rect.height);
    }
    return p;
}
function $30cf44a1cef75e8e$var$getEventCoordsRelativeToElement(event, element) {
    if (element.tagName === "svg") return $30cf44a1cef75e8e$export$4365868ff9ac7d1a(event, element);
    else {
        var rect = element.getBoundingClientRect();
        return [
            event.clientX - rect.left,
            event.clientY - rect.top
        ];
    }
}
function $30cf44a1cef75e8e$export$842a2cf37af977e1(n, m) {
    /**
   * `mod` function that works sensibly for negative numbers (Javascript `%` operator doesn't).
   * http://stackoverflow.com/questions/4467539/javascript-modulo-not-behaving
   */ return (n % m + m) % m;
}
function $30cf44a1cef75e8e$export$cc5ff271ec8e6438(f) {
    return function(...args) {
        let r = f(...args);
        /* eslint-disable no-console */ console.log("called", f.name, args, r);
        /* eslint-enable no-console */ return r;
    };
}
function $30cf44a1cef75e8e$export$db107f8bf21fa6e([start1, end1], [start2, end2]) {
    /**
   * If there is no intersection, return `null`.
   * If the intersection has no beginning, the intersection start is `null`.
   * If the intersection has no end, the intersection end is `null`.
   */ if (start2 != null && end1 != null && start2 > end1 || start1 != null && end2 != null && start1 > end2) return null;
    function normalise(a) {
        if (a === Infinity || a === -Infinity) return null;
        else return a;
    }
    return [
        normalise(Math.max(start1 != null ? start1 : -Infinity, start2 != null ? start2 : -Infinity)),
        normalise(Math.min(end1 != null ? end1 : Infinity, end2 != null ? end2 : Infinity))
    ];
}
function $30cf44a1cef75e8e$export$608ff0ad3171e64a(list1, list2, keyFunc1, keyFunc2, combineFunc) {
    let i = 0, j = 0, l1 = list1.length, l2 = list2.length;
    let r = [];
    while(i < l1 && j < l2){
        let key1 = keyFunc1(list1[i]);
        let key2 = keyFunc2(list2[j]);
        if (key1 < key2) r.push(combineFunc(key1, list1[i], list2[Math.max(j - 1, 0)]));
        else if (key1 == key2) r.push(combineFunc(key2, list1[i], list2[j]));
        else r.push(combineFunc(key2, list1[Math.max(i - 1, 0)], list2[j]));
        if (key1 <= key2) i++;
        if (key1 >= key2) j++;
    }
    while(i < l1){
        r.push(combineFunc(keyFunc1(list1[i]), list1[i], list2[Math.max(j - 1, 0)]));
        i++;
    }
    while(j < l2){
        r.push(combineFunc(keyFunc2(list2[j]), list1[Math.max(i - 1, 0)], list2[j]));
        j++;
    }
    return r;
}
function $30cf44a1cef75e8e$export$9d1611c77c2fe928(...propsDicts) {
    function mergeProps1(props1, props2) {
        let { style: style1, className: className1, ...props1Rest } = props1 || {};
        let { style: style2, className: className2, ...props2Rest } = props2 || {};
        return {
            style: {
                ...style1,
                ...style2
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ksXgP)))(className1, className2),
            ...props1Rest,
            ...props2Rest
        };
    }
    let result = propsDicts.reduce(mergeProps1, {});
    if (result.className === "") delete result.className;
    if ((0, $5irfN.default).isEmpty(result.style)) delete result.style;
    return result;
}
function $30cf44a1cef75e8e$export$ef0ce4c99ed038b8(d1, d2, mergeFunc) {
    let r = {};
    (0, $5irfN.default).each(d1, function(v, k) {
        r[k] = mergeFunc(k, v, d2[k]);
    });
    (0, $5irfN.default).each(d2, function(v, k) {
        if (!d1.hasOwnProperty(k)) r[k] = mergeFunc(k, undefined, v);
    });
    return r;
}
function $30cf44a1cef75e8e$export$e853e2f473efea6f(d1, d2, mergeFunc) {
    /**
   * Analogous to `mergeDicts` but works with `Immutable.Map` objects.  Note
   * that (in addition to having different argument order both in the arguments
   * passed to `mergeMaps` and the arguments `mergeMaps` passes to
   * `mergeFunc`), this function is semantically different to
   * `Immutable.Map.mergeWith` in that `mergeFunc` is always called for every
   * value in either map, whereas `mergeWith` only calls its callback for
   * values that exist in both maps, making it impossible to catch them.
   */ return d1.withMutations(function(d1) {
        d1.forEach(function(v, k) {
            d1.set(k, mergeFunc(k, v, d2.get(k)));
        });
        d2.forEach(function(v, k) {
            if (!d1.has(k)) d1.set(k, mergeFunc(k, undefined, v));
        });
    });
}
function $30cf44a1cef75e8e$export$cd4885c072542d0a(flexProp) {
    /**
   * >>> prefixFlex("1 1 auto")
   * {flex: "1 1 auto", WebkitFlex: "1 1 auto"}
   */ return {
        flex: flexProp,
        WebkitFlex: flexProp
    };
}
function $30cf44a1cef75e8e$export$f59899712d962a6d() {
    /**
  * Mixin.
  *
  * Usage:
     let MyComponentWithHover = CreateReactClass({
      mixins: [hoverState()],
       render: function() {
        return (
          <div
              {...this.getHoverHandlers()}
              style={{backgroundColor: this.state.isHovered ? 'red' : 'blue'}}
            I am blue if hovered and red otherwise.
          </div>
        );
      }
    });
  */ return {
        getInitialState: function() {
            return {
                isHovered: false
            };
        },
        getHoverHandlers: function() {
            return {
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave
            };
        },
        handleMouseEnter: function() {
            this.setState({
                isHovered: true
            });
        },
        handleMouseLeave: function() {
            this.setState({
                isHovered: false
            });
        }
    };
}
function $30cf44a1cef75e8e$export$de363e709c412c8a(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $5irfN.default).now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var now = (0, $5irfN.default).now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
const $30cf44a1cef75e8e$export$b8504afd6311b292 = class {
    constructor({ getSvgNodeFunc: getSvgNodeFunc, callback: callback, mouseUpCallback: mouseUpCallback = null, throttleMs: throttleMs = null } = {}){
        this.getSvgNodeFunc = getSvgNodeFunc;
        this.callback = callback;
        this.mouseUpCallback = mouseUpCallback;
        this.throttleMs = throttleMs;
    }
    getMouseEventProperties(getArgs) {
        if (!(0, $5irfN.default).isFunction(getArgs)) getArgs = function() {
            return getArgs;
        };
        let self = this;
        return {
            onMouseDown: function(e) {
                self.getArgs = getArgs;
                self.handleMouseDown(e);
            }
        };
    }
    getEventCoordsRelativeToElement(e) {
        return $30cf44a1cef75e8e$var$getEventCoordsRelativeToElement(e, this.getSvgNodeFunc());
    }
    handleMouseDown(e) {
        let self = this;
        // Only care about left click.
        if (e.button !== 0) return;
        var position = this.getEventCoordsRelativeToElement(e);
        this.mouseDown = true;
        this.mousePosition = {
            x: position[0],
            y: position[1]
        };
        this.throttled = $30cf44a1cef75e8e$export$de363e709c412c8a(function(e) {
            self.handleMouseMove(e);
        }, this.throttleMs);
        var $body = window.$("body");
        // If the user moves the mouse quickly, it will easily be able to move
        // outside the slider area, but we don't want that to stop the scroll
        // events from happening.  So attach the mousemove event to the `body`
        // element, making sure to clear it on mouseup.
        $body.one("mouseup", function(e) {
            $body.off("mousemove", self.throttled);
            self.handleMouseUp(e);
        });
        $body.on("mousemove", self.throttled);
        e.preventDefault();
        e.stopPropagation();
    }
    handleMouseMove(e, args) {
        if (this.mouseDown) {
            let position = this.getEventCoordsRelativeToElement(e);
            let newPosition = {
                x: position[0],
                y: position[1]
            };
            let args = this.getArgs();
            this.callback(newPosition, this.mousePosition, args);
            this.mousePosition = newPosition;
        }
        e.preventDefault();
        e.stopPropagation();
    }
    handleMouseUp(e) {
        if (this.throttled) this.throttled.cancel();
        this.mouseDown = false;
        e.preventDefault();
        e.stopPropagation();
        if (this.mouseUpCallback != null) this.mouseUpCallback();
    }
};
const $30cf44a1cef75e8e$export$b25b355fca609f64 = class {
    constructor(secondCallback){
        this.fpsTimestamp = +new Date();
        this.frameCount = 0;
        this.fps = 0;
        this.secondCallback = secondCallback;
    }
    frame() {
        this.frameCount++;
        var newTimestamp = +new Date();
        if (newTimestamp - this.fpsTimestamp >= 1000) {
            this.fps = this.frameCount;
            this.secondCallback(this.fps);
            this.fpsTimestamp = newTimestamp;
            this.frameCount = 0;
        }
    }
};
function $30cf44a1cef75e8e$export$b730691daab32e4b(arr, n, callback) {
    for(var i = 0, l = arr.length; i < l; i += n)callback(arr[i], i);
}
function $30cf44a1cef75e8e$export$98945f78de306a65(arr, n, callback) {
    var newArr = [];
    $30cf44a1cef75e8e$export$b730691daab32e4b(arr, n, function(r, i) {
        newArr.push(callback(r, i));
    });
    return newArr;
}
function $30cf44a1cef75e8e$export$8a63f25cc62965f1(arr) {
    let s = 0;
    for (let item of arr)s += item;
    return s;
}
function $30cf44a1cef75e8e$export$2ce6e9dde12d591b(a, b, c) {
    if (b < a) return a;
    if (b > c) return c;
    return b;
}
function $30cf44a1cef75e8e$export$23f4ae204700ea29(arr) {
    var smallest = null, biggest = null;
    arr.forEach(function(i) {
        if (smallest == null || i < smallest) smallest = i;
        if (biggest == null || i > biggest) biggest = i;
    });
    return [
        smallest,
        biggest
    ];
}
function $30cf44a1cef75e8e$export$36d5e0d2b514f546(n) {
    /**
   * 1 -> 1
   * 12 -> 12
   * 123 -> 123
   * 1234 -> 1234
   * 12345 -> 12.3k
   * 123456 -> 123k
   * 1234567 -> 1.23m
   * 12345678 -> 12.3m
   * 123456789 -> 123m
   * 1234567890 -> 1.23b
   * 12345678901 -> 12.3b
   * 123456789012 -> 123b
   * 1234567890123 -> 1234b
   * 12345678901234 -> 12345b
   * ...
   */ const suffixes = [
        "k",
        "m",
        "b"
    ];
    if (n < 0) return "-" + $30cf44a1cef75e8e$export$36d5e0d2b514f546(-n);
    var s = Math.round(n).toString();
    var l = s.length;
    if (l <= 4) return s;
    else if (l > suffixes.length * 3 + 3) return s.substr(0, l - suffixes.length * 3) + suffixes[suffixes.length - 1];
    var decimalPointIndex = l % 3 || null;
    var suffix = suffixes[Math.floor((s.length - 4) / 3)];
    let s1;
    if (decimalPointIndex != null) s1 = s.substr(0, decimalPointIndex) + "." + s.substring(decimalPointIndex, 3);
    else s1 = s.substr(0, 3);
    return s1 + suffix;
}
function $30cf44a1cef75e8e$export$cc7ed463489839e3([innerStart, innerEnd], [outerStartBefore, outerEndBefore], [outerStartAfter, outerEndAfter]) {
    /**
   * Before
   *      o-------------------o   (outerStartBefore, outerEndBefore)
   *         o------o             (innerStart, innerEnd)
   *
   * User drags outer range:
   *
   *      o------------------->>>>o   (outerStartAfter, outerEndAfter)
   *         o------o                 (innerStart, innerEnd)
   *
   * How should we transform the inner shape so the overall shape
   * looks the same?:
   *
   *      o-----------------------o   (outerStartAfter, outerEndAfter)
   *         o------>>o               (innerStartAfter, innerEndAfter)
   *
   * We return [innerStartAfter, innerEndAfter]
   */ if (outerStartBefore === outerEndBefore) return [
        outerStartAfter,
        outerEndAfter
    ];
    function transformPoint(val) {
        return outerStartAfter + (val - outerStartBefore) / (outerEndBefore - outerStartBefore) * (outerEndAfter - outerStartAfter);
    }
    return [
        transformPoint(innerStart),
        transformPoint(innerEnd)
    ];
}
function $30cf44a1cef75e8e$export$c3fa14697779f87e(s) {
    /**
  >>> camelCaseToSentence("onHold")
  "On Hold"
   >>> camelCaseToSentence("potential"))
  "Potential"
  */ return s.replace(/./g, function(c, i) {
        if (i === 0) return c.toUpperCase();
        else if (c === c.toUpperCase()) return " " + c;
        else return c;
    });
}
function $30cf44a1cef75e8e$export$c59b3f64f66861bb(s) {
    return s.replace(/./g, (c)=>(c === c.toUpperCase() ? "_" : "") + c.toUpperCase());
}
function $30cf44a1cef75e8e$export$3d6d4d87d9f78e80(s) {
    return s[0].toUpperCase() + s.substr(1);
}
function $30cf44a1cef75e8e$export$536cd9e170c45ee9(dct, key, defaultValue) {
    if (dct[key] == null) dct[key] = defaultValue;
    return dct[key];
}
function $30cf44a1cef75e8e$export$b5948ee077d5937f(dct, key, modifierFunc, defaultValue) {
    dct[key] = modifierFunc($30cf44a1cef75e8e$export$536cd9e170c45ee9(dct, key, defaultValue));
}
function $30cf44a1cef75e8e$export$3f063810d7bf01bd(lst, grouperFunc, keyFunc) {
    /**
  * >>> myGroupBy(<objects>, <function>, <function>)
  *
   [
    {
      grouper: grouperFunc(<object1>),
      items: [<all the objects for which grouperFunc(o) === grouperFunc(object1)],
    },
    {
      grouper: grouperFunc(<object2>),
      items: [<all the objects for which grouperFunc(o) === grouperFunc(object2)],
    },
    ...
  ]
   `keyFunc` is just a function that takes a result of calling
  `grouperFunc` on an item in `lst` and turns it into a unique string.
   Note that this function does *not* assume that `lst` is already sorted in
  any particular way.
  */ var d = {};
    var out = [];
    for (let item of lst){
        var grouper = grouperFunc(item);
        var key = keyFunc(grouper);
        if (d[key] == null) {
            d[key] = {
                grouper: grouper,
                items: []
            };
            out.push(d[key]);
        }
        d[key].items.push(item);
    }
    return out;
}
var $30cf44a1cef75e8e$export$cbd1a71eaec89d7d = (0, (/*@__PURE__*/$parcel$interopDefault($5JTQC)))({
    propTypes: {
        align: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string.isRequired
    },
    render: function() {
        return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
            style: {
                display: "table",
                width: "100%",
                height: "100%",
                tableLayout: "fixed",
                ...this.props.style
            },
            children: /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                style: {
                    display: "table-cell",
                    width: "100%",
                    height: "100%",
                    verticalAlign: this.props.align,
                    ...this.props.innerStyle
                },
                children: this.props.children
            })
        });
    }
});
function $30cf44a1cef75e8e$export$53487a654b5bdb58(a, b) {
    var _a$name, _a$name$localeCompare;
    /**
   * `a` and `b` are either null or objects that have a `name` property.
   *
   * Use this to sort by name, putting null values at the end.
   */ if (a == null && b == null) return 0;
    if (a == null && b != null) return 1;
    if (a != null && b == null) return -1;
    return (_a$name = a.name) === null || _a$name === void 0 ? void 0 : (_a$name$localeCompare = _a$name.localeCompare) === null || _a$name$localeCompare === void 0 ? void 0 : _a$name$localeCompare.call(_a$name, b.name);
}
function $30cf44a1cef75e8e$export$480a63919daf0d9f(a, b) {
    return (a != null ? +a.toDate() : 0) - (b != null ? +b.toDate() : 0);
}
function $30cf44a1cef75e8e$export$ffec9d95a62fbc09(...args) {
    /**
  * A comparator function is a function that takes two arguments and returns a
  * negative number if the first should be ordered before the second, zero if
  * they are equal, and a positive number if the first should be ordered after
  * the second.
  *
  * `compareMultiple` takes any number of comparator functions and returns a
  * comparator that tries those functions in sequence until one of them
  * returns nonzero, and then returns that value.
  *
  * eg:
    >>> [[3, 1], [2, 2], [2, 1]].sort(compareMultiple(
         (a, b) => a[0] - b[0],
         (a, b) => a[1] - b[1]
       ))
   [[2, 1], [2, 2], [3, 1]]
    One extra thing is that the comparator functions passed in can return `null`
   to denote "I already know these two objects are equal; don't continue to the
   other comparators" rather than zero, which denotes "I don't yet know how these
   objects should be ordered with respect to one another".
  */ return function(a, b) {
        for(var i = 0; i < args.length - 1; i++){
            var val = args[i](a, b);
            if (val == null) return 0;
            else if (val !== 0) return val;
        }
        return args[args.length - 1](a, b);
    };
}
function $30cf44a1cef75e8e$export$7e4aa119212bc614(ob) {
    return (0, $5irfN.default).isNumber(ob) && !isNaN(ob) && isFinite(ob);
}
function $30cf44a1cef75e8e$export$e1fe2eb830813601(ob) {
    return (0, $5irfN.default).isString(ob) && ob !== "";
}
function $30cf44a1cef75e8e$export$2ad0182371401ea4(val) {
    return val == null || val === "" || (0, $5irfN.default).isNumber(parseFloat(val));
}
function $30cf44a1cef75e8e$export$a287f47fed4544b8(val) {
    return (0, $5irfN.default).isNumber(val) && val % 1 === 0;
}
function $30cf44a1cef75e8e$export$c7d3d1f96a700512(arr, cmp) {
    var arrWithIndexes = arr.map(function(d, i) {
        return {
            item: d,
            index: i
        };
    });
    arrWithIndexes.sort(function(a, b) {
        var r = cmp(a.item, b.item);
        if (r !== 0) return r;
        else return a.index - b.index;
    });
    return arrWithIndexes.map((d)=>d.item);
}
function $30cf44a1cef75e8e$export$ebb29a1de2bc5702(ob) {
    /**
   * >>> trueKeys({a: true, b: false})
   * ['a']
   */ var keys = [];
    (0, $5irfN.default).each(ob, function(v, k) {
        if (v === true) keys.push(k);
    });
    return keys;
}
function $30cf44a1cef75e8e$export$d224121420685233(arr, keyFunc, valueFunc) {
    let d = {};
    arr.forEach(function(item) {
        d[keyFunc(item)] = valueFunc(item);
    });
    return d;
}
function $30cf44a1cef75e8e$export$8b47e1074e3d69e0(s) {
    return s != null && s.match(/^\d+$/) != null;
}
function $30cf44a1cef75e8e$export$369fdd9044fcc096(s) {
    /**
   * Is `s` a string that is *just* a float (not just a string that starts with a float
   * and might have crap attached to the end). For this function we do not consider
   * exponential format to be valid, hence check for the 'e' character in the regexp.
   * Negative numbers are accepted though.
   *
   * Adapted from http://stackoverflow.com/a/1830547/223486
   */ return s != null && s !== "" && !/[\se]/i.test(s) && !isNaN(s);
}
function $30cf44a1cef75e8e$export$1cc6de4b443ff73d(...args) {
    for(var i = 0, l = args.length; i < l; i++){
        let val = args[i];
        if (val != null) return val;
    }
}
function $30cf44a1cef75e8e$export$45505e1f18813a(arr, func, filter) {
    if (filter == null || filter === "") return arr;
    else {
        var lower = filter.toLowerCase();
        return arr.filter((item)=>func(item).toLowerCase().match(lower));
    }
}
function $30cf44a1cef75e8e$export$5b6e4109d15a5a72(expr, msg = null) {
    /* eslint-disable no-console */ if (msg != null) console.log(msg, expr);
    else console.log(expr);
    return expr;
/* eslint-enable no-console */ }
function $30cf44a1cef75e8e$export$4d9e7a1c098df5e2(s) {
    return s != null && s !== "";
}
var $30cf44a1cef75e8e$var$emailRegexp = /\S+@\S+\.\S+/;
function $30cf44a1cef75e8e$export$7fbbfbca30081d0(email) {
    return $30cf44a1cef75e8e$var$emailRegexp.test(email);
}
function $30cf44a1cef75e8e$export$e90fb89750dba83f(s) {
    // http://stackoverflow.com/a/1830844/223486
    return !isNaN(parseFloat(s)) && isFinite(s);
}
function $30cf44a1cef75e8e$export$1a6c67a2768025be(s) {
    return s == null || s === "" || $30cf44a1cef75e8e$export$e90fb89750dba83f(s);
}
function $30cf44a1cef75e8e$export$b077fa9fbdb7164c(ob, props) {
    let o = ob;
    for (let p of props){
        if (o == null) return null;
        o = o[p];
    }
    return o;
}
function $30cf44a1cef75e8e$export$923d6aa3031a214e(d) {
    return d.clone().startOf("day").subtract(d.isoWeekday() - 1, "days");
}
function $30cf44a1cef75e8e$export$6ea683876c36b8d2(d1, d2) {
    return $30cf44a1cef75e8e$export$923d6aa3031a214e(d1).isSame($30cf44a1cef75e8e$export$923d6aa3031a214e(d2));
}
function $30cf44a1cef75e8e$export$ded41c4035377ae6({ items: items, newTotal: newTotal, get: get, set: set }) {
    /**
   * `items` is a list of arbitrary objects.
   *
   * Set the "total" of `items` to `newTotal`, where `get` is a function that
   * takes an item in the list and returns its value used to calculate the
   * total, and `set` takes an item and a value and sets the item's value to
   * the new value.
   *
   * If the sum of `items` before the call is positive, the items
   * are each multiplied by the same factor so the proportion remains the same.
   * Otherwise, all the values are set to the same number.
   */ let oldTotal = $30cf44a1cef75e8e$export$8a63f25cc62965f1(items.map(get));
    if (oldTotal > 0) {
        let factor = newTotal / oldTotal;
        items.forEach(function(i) {
            set(i, get(i) * factor);
        });
    } else items.forEach(function(i) {
        set(i, newTotal / items.length);
    });
    return items;
}
function $30cf44a1cef75e8e$export$d2d3cbaff945f607(haystack, needle) {
    return haystack.toUpperCase().indexOf(needle.toUpperCase()) >= 0;
}
function $30cf44a1cef75e8e$export$e8726b15032ee6a8(haystack, needle) {
    return haystack.toUpperCase().indexOf(needle.toUpperCase()) === 0;
}
function $30cf44a1cef75e8e$export$7f93652efe7e8f8c(ob) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).isValidElement(ob)) return ob;
    else return /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
        children: ob
    });
}
function* $30cf44a1cef75e8e$export$782383ea69cc6c28(dict) {
    for(let k in dict)if (dict.hasOwnProperty(k)) yield [
        k,
        dict[k]
    ];
}
function* $30cf44a1cef75e8e$export$45a3175d55604f4(iterable) {
    /**
   * Behaves like Python's `enumerate` function.
   */ let i = 0;
    for (const x of iterable){
        yield [
            i,
            x
        ];
        i++;
    }
}
function* $30cf44a1cef75e8e$export$675f7606d6db1b29(iterable, pred) {
    for (let [i, item] of $30cf44a1cef75e8e$export$45a3175d55604f4(iterable))if (pred(item, i)) yield item;
}
function* $30cf44a1cef75e8e$export$b2517b0ab3a58435(iterable, mapper) {
    for (let [i, item] of $30cf44a1cef75e8e$export$45a3175d55604f4(iterable))yield mapper(item, i);
}
function* $30cf44a1cef75e8e$export$e08e3b67e392101e(...iterables) {
    for (let iterable of iterables)yield* iterable;
}
function* $30cf44a1cef75e8e$export$c849644d5c08230c(...iterables) {
    let iters = iterables.map((i)=>i[Symbol.iterator]());
    while(true){
        const is = iters.map((i)=>i.next());
        if ((0, $5irfN.default).any(is, (i)=>i.done)) return;
        yield is.map((i)=>i.value);
    }
}
function* $30cf44a1cef75e8e$export$6d3e77a8a54e8f53(m1, m2) {
    let m = m1.clone();
    while(!m.isAfter(m2)){
        yield m;
        m = m.clone().add(1, "day");
    }
}
function $30cf44a1cef75e8e$export$25f88d3e73d4a72a(d1, d2) {
    /**
   * `d1` and `d2` are `Immutable.Map` instances.
   * Returns `false` if any key exists in both maps but with different values,
   * `true` otherwise.
   */ for (let [k, v] of d1){
        if (d2.has(k) && !(0, (/*@__PURE__*/$parcel$interopDefault($dycmL))).is(d2.get(k), v)) return false;
    }
    return true;
}
function* $30cf44a1cef75e8e$export$d02631cccf789723(a, b) {
    if (b == null) {
        b = a;
        a = 0;
    }
    for(let i = a; i < b; i++)yield i;
}
function $30cf44a1cef75e8e$export$afd09ce65dc4508b(iterable) {
    let d = {};
    for (let [key, val] of iterable)d[key] = val;
    return d;
}
function $30cf44a1cef75e8e$export$a49e633488bd5a28(ob1, ob2) {
    if (ob1 == null && ob2 == null) return true;
    if (ob1 == null || ob2 == null) return false;
    if (ob1.constructor !== ob2.constructor) return false;
    if (ob1.id != null && ob2.id === ob1.id) return true;
    if (ob1.uuid != null && ob2.uuid === ob1.uuid) return true;
    return false;
}
function $30cf44a1cef75e8e$export$7266649f72a0dbb6(f) {
    /**
   * Decorator for debugging performance.
   */ return function(...args) {
        const t1 = (0, (/*@__PURE__*/$parcel$interopDefault($8KwGs)))();
        const r = f(...args);
        const t2 = (0, (/*@__PURE__*/$parcel$interopDefault($8KwGs)))();
        const diff = t2.diff(t1);
        if (diff > 500) /* eslint-disable no-console */ console.log("args", args, "diff", diff);
        return r;
    };
}
function $30cf44a1cef75e8e$export$d00b56ff2d620eb9(error) {
    /**
  * Convenience function you can use in the middle of an expression.
  eg:
  let a = (this.a != null) ? this.a
   : (this.b != null) ? this.b
   : raiseError(new Error("Should have had either a or b");
  */ throw error;
}
const $30cf44a1cef75e8e$export$7ca38dca1f51ae70 = {
    /**
   * Mixin that's basically the same as react-router's (deprecated) Lifecycle
   * mixin (at least for the leave hook).
   */ contextTypes: {
        router: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).object.isRequired
    },
    componentDidMount: function() {
        this.context.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    }
};
function $30cf44a1cef75e8e$export$23fe7b6f9a263c6c() {
    try {
        throw new Error();
    } catch (e) {
        /* eslint-disable no-console */ console.log(e.stack);
    /* eslint-enable no-console */ }
}
function $30cf44a1cef75e8e$export$8bf7aba4a9e09055(errorType) {
    /**
   * Throw an exception class and get a correct stack trace.
   *
   * Use
   *
   *    throwError(MyErrorClass)
   *
   * instead of
   *
   *    throw new MyErrorClass();
   */ let error = new Error();
    let exception = new Proxy(new errorType(), {
        get: function(ob, prop) {
            return error[prop];
        }
    });
    exception.name = errorType.name;
    throw exception;
}
function $30cf44a1cef75e8e$export$575af9153aa1f5a6(...percentages) {
    let p = parseFloat(percentages[0]);
    for(let i = 1; i < percentages.length; i++)p += parseFloat(percentages[i]);
    return p + "%";
}
function $30cf44a1cef75e8e$export$882a9460c4d248f6(...percentages) {
    let p = parseFloat(percentages[0]);
    for(let i = 1; i < percentages.length; i++)p -= parseFloat(percentages[i]);
    return p + "%";
}
const $30cf44a1cef75e8e$export$985327fcac726f47 = (val)=>{
    let [, hours, minutes, ampm] = val.match(/([1-2][0-4]|0?[1-9])[\s*:\s*]?([0-5][0-9])?\s*([AaPp][Mm])?/) || [];
    hours = parseInt(hours || 0);
    minutes = parseInt(minutes || 0);
    ampm = ampm || "";
    if (ampm.toLowerCase() === "pm" && hours < 12) hours += 12;
    if (ampm.toLowerCase() === "am" && hours === 12) hours = 0;
    return hours + minutes / 60;
};
const $30cf44a1cef75e8e$export$8e9d747dacc29f35 = (val)=>{
    let [, hours, minutes, ampm] = val.match(/([1-2][0-4]|0?[1-9])[\s*:\s*]?([0-5][0-9])?\s*([AaPp][Mm])?/) || [];
    hours = parseInt(hours || 0);
    minutes = parseInt(minutes || 0);
    ampm = ampm || "";
    if (ampm.toLowerCase() === "pm" && hours < 12) hours += 12;
    if (ampm.toLowerCase() === "am" && hours === 12) hours = 0;
    return hours * 60 + minutes;
};
const $30cf44a1cef75e8e$export$f84278ec39fddb19 = (numMins)=>{
    const pm = numMins >= 720;
    if (numMins >= 780) numMins -= 720;
    const hours = Math.floor(numMins / 60);
    const mins = numMins - hours * 60;
    return `${hours}:${String(mins).padStart(2, "0")}${pm ? "pm" : "am"}`;
};

});
parcelRegister("5JTQC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $7PdBe = parcelRequire("7PdBe");

var $aWwxo = parcelRequire("aWwxo");
if (typeof $7PdBe === "undefined") throw Error("create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.");
// Hack to grab NoopUpdateQueue from isomorphic React
var $42dc79e4d7514601$var$ReactNoopUpdateQueue = new $7PdBe.Component().updater;
module.exports = $aWwxo($7PdBe.Component, $7PdBe.isValidElement, $42dc79e4d7514601$var$ReactNoopUpdateQueue);

});
parcelRegister("aWwxo", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $ffvgB = parcelRequire("ffvgB");
// -- Inlined from fbjs --
var $7f788f7944aec9da$var$emptyObject = {};
var $7f788f7944aec9da$var$validateFormat = function validateFormat(format) {};
function $7f788f7944aec9da$var$_invariant(condition, format, a, b, c, d, e, f) {
    $7f788f7944aec9da$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $7f788f7944aec9da$var$warning = function() {};
var $7f788f7944aec9da$var$printWarning;
// /-- Inlined from fbjs --
var $7f788f7944aec9da$var$MIXINS_KEY = "mixins";
// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function $7f788f7944aec9da$var$identity(fn) {
    return fn;
}
var $7f788f7944aec9da$var$ReactPropTypeLocationNames;
$7f788f7944aec9da$var$ReactPropTypeLocationNames = {};
function $7f788f7944aec9da$var$factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
    /**
   * Policies that describe methods in `ReactClassInterface`.
   */ var injectedMixins = [];
    /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */ var ReactClassInterface = {
        /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */ mixins: "DEFINE_MANY",
        /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */ statics: "DEFINE_MANY",
        /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */ propTypes: "DEFINE_MANY",
        /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */ contextTypes: "DEFINE_MANY",
        /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */ childContextTypes: "DEFINE_MANY",
        // ==== Definition methods ====
        /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */ getDefaultProps: "DEFINE_MANY_MERGED",
        /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */ getInitialState: "DEFINE_MANY_MERGED",
        /**
     * @return {object}
     * @optional
     */ getChildContext: "DEFINE_MANY_MERGED",
        /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */ render: "DEFINE_ONCE",
        // ==== Delegate methods ====
        /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */ componentWillMount: "DEFINE_MANY",
        /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidMount: "DEFINE_MANY",
        /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */ componentWillReceiveProps: "DEFINE_MANY",
        /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */ shouldComponentUpdate: "DEFINE_ONCE",
        /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */ componentWillUpdate: "DEFINE_MANY",
        /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidUpdate: "DEFINE_MANY",
        /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */ componentWillUnmount: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */ UNSAFE_componentWillMount: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */ UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
        /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */ UNSAFE_componentWillUpdate: "DEFINE_MANY",
        // ==== Advanced methods ====
        /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */ updateComponent: "OVERRIDE_BASE"
    };
    /**
   * Similar to ReactClassInterface but for static methods.
   */ var ReactClassStaticInterface = {
        /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */ getDerivedStateFromProps: "DEFINE_MANY_MERGED"
    };
    /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */ var RESERVED_SPEC_KEYS = {
        displayName: function(Constructor, displayName) {
            Constructor.displayName = displayName;
        },
        mixins: function(Constructor, mixins) {
            if (mixins) for(var i = 0; i < mixins.length; i++)mixSpecIntoComponent(Constructor, mixins[i]);
        },
        childContextTypes: function(Constructor, childContextTypes) {
            Constructor.childContextTypes = $ffvgB({}, Constructor.childContextTypes, childContextTypes);
        },
        contextTypes: function(Constructor, contextTypes) {
            Constructor.contextTypes = $ffvgB({}, Constructor.contextTypes, contextTypes);
        },
        /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */ getDefaultProps: function(Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            else Constructor.getDefaultProps = getDefaultProps;
        },
        propTypes: function(Constructor, propTypes) {
            Constructor.propTypes = $ffvgB({}, Constructor.propTypes, propTypes);
        },
        statics: function(Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function() {}
    };
    function validateTypeDef(Constructor, typeDef, location) {
        for(var propName in typeDef)typeDef.hasOwnProperty(propName);
    }
    function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
        // Disallow overriding of base class methods unless explicitly allowed.
        if (ReactClassMixin.hasOwnProperty(name)) $7f788f7944aec9da$var$_invariant(specPolicy === "OVERRIDE_BASE", "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.", name);
        // Disallow defining methods more than once unless explicitly allowed.
        if (isAlreadyDefined) $7f788f7944aec9da$var$_invariant(specPolicy === "DEFINE_MANY" || specPolicy === "DEFINE_MANY_MERGED", "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
    }
    /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */ function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
            var typeofSpec, isMixinValid;
            return;
        }
        $7f788f7944aec9da$var$_invariant(typeof spec !== "function", "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object.");
        $7f788f7944aec9da$var$_invariant(!isValidElement(spec), "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        // By handling mixins before any other properties, we ensure the same
        // chaining order is applied to methods with DEFINE_MANY policy, whether
        // mixins are listed before or after these methods in the spec.
        if (spec.hasOwnProperty($7f788f7944aec9da$var$MIXINS_KEY)) RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        for(var name in spec){
            if (!spec.hasOwnProperty(name)) continue;
            if (name === $7f788f7944aec9da$var$MIXINS_KEY) continue;
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) RESERVED_SPEC_KEYS[name](Constructor, property);
            else {
                // Setup methods on prototype:
                // The following member methods should not be automatically bound:
                // 1. Expected ReactClass methods (in the "interface").
                // 2. Overridden methods (that were mixed in).
                var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                var isFunction = typeof property === "function";
                var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
                if (shouldAutoBind) {
                    autoBindPairs.push(name, property);
                    proto[name] = property;
                } else if (isAlreadyDefined) {
                    var specPolicy = ReactClassInterface[name];
                    // These cases should already be caught by validateMethodOverride.
                    $7f788f7944aec9da$var$_invariant(isReactClassMethod && (specPolicy === "DEFINE_MANY_MERGED" || specPolicy === "DEFINE_MANY"), "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.", specPolicy, name);
                    // For methods which are defined more than once, call the existing
                    // methods before calling the new property, merging if appropriate.
                    if (specPolicy === "DEFINE_MANY_MERGED") proto[name] = createMergedResultFunction(proto[name], property);
                    else if (specPolicy === "DEFINE_MANY") proto[name] = createChainedFunction(proto[name], property);
                } else proto[name] = property;
            }
        }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) return;
        for(var name in statics){
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) continue;
            var isReserved = name in RESERVED_SPEC_KEYS;
            $7f788f7944aec9da$var$_invariant(!isReserved, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
                var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
                $7f788f7944aec9da$var$_invariant(specPolicy === "DEFINE_MANY_MERGED", "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
                Constructor[name] = createMergedResultFunction(Constructor[name], property);
                return;
            }
            Constructor[name] = property;
        }
    }
    /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */ function mergeIntoWithNoDuplicateKeys(one, two) {
        $7f788f7944aec9da$var$_invariant(one && two && typeof one === "object" && typeof two === "object", "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.");
        for(var key in two)if (two.hasOwnProperty(key)) {
            $7f788f7944aec9da$var$_invariant(one[key] === undefined, "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.", key);
            one[key] = two[key];
        }
        return one;
    }
    /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createMergedResultFunction(one, two) {
        return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) return b;
            else if (b == null) return a;
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
        };
    }
    /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createChainedFunction(one, two) {
        return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
        };
    }
    /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */ function bindAutoBindMethod(component, method) {
        var boundMethod = method.bind(component);
        var componentName, _bind;
        return boundMethod;
    }
    /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */ function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for(var i = 0; i < pairs.length; i += 2){
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
        }
    }
    var IsMountedPreMixin = {
        componentDidMount: function() {
            this.__isMounted = true;
        }
    };
    var IsMountedPostMixin = {
        componentWillUnmount: function() {
            this.__isMounted = false;
        }
    };
    /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */ var ReactClassMixin = {
        /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */ replaceState: function(newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */ isMounted: function() {
            return !!this.__isMounted;
        }
    };
    var ReactClassComponent = function() {};
    $ffvgB(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
    /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */ function createClass(spec) {
        // To keep our warnings more understandable, we'll use a little hack here to
        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
        // unnecessarily identify a class without displayName as 'Constructor'.
        var Constructor = $7f788f7944aec9da$var$identity(function(props, context, updater) {
            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) bindAutoBindMethods(this);
            this.props = props;
            this.context = context;
            this.refs = $7f788f7944aec9da$var$emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;
            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.
            var initialState = this.getInitialState ? this.getInitialState() : null;
            $7f788f7944aec9da$var$_invariant(typeof initialState === "object" && !Array.isArray(initialState), "%s.getInitialState(): must return an object or null", Constructor.displayName || "ReactCompositeComponent");
            this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        // Initialize the defaultProps property after all mixins have been merged.
        if (Constructor.getDefaultProps) Constructor.defaultProps = Constructor.getDefaultProps();
        $7f788f7944aec9da$var$_invariant(Constructor.prototype.render, "createClass(...): Class specification must implement a `render` method.");
        // Reduce time spent doing lookups by setting these on the prototype.
        for(var methodName in ReactClassInterface)if (!Constructor.prototype[methodName]) Constructor.prototype[methodName] = null;
        return Constructor;
    }
    return createClass;
}
module.exports = $7f788f7944aec9da$var$factory;

});
parcelRegister("ffvgB", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $b1a082ae2edd621b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b1a082ae2edd621b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b1a082ae2edd621b$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $b1a082ae2edd621b$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $b1a082ae2edd621b$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $b1a082ae2edd621b$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $b1a082ae2edd621b$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($b1a082ae2edd621b$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($b1a082ae2edd621b$var$getOwnPropertySymbols) {
            symbols = $b1a082ae2edd621b$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($b1a082ae2edd621b$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("ksXgP", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("dycmL", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    var SLICE$0 = Array.prototype.slice;
    function createClass(ctor, superClass) {
        if (superClass) ctor.prototype = Object.create(superClass.prototype);
        ctor.prototype.constructor = ctor;
    }
    function Iterable(value) {
        return isIterable(value) ? value : Seq(value);
    }
    createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    createClass(SetIterable, Iterable);
    function SetIterable(value) {
        return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    function isIterable(maybeIterable) {
        return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
    }
    function isKeyed(maybeKeyed) {
        return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
    }
    function isIndexed(maybeIndexed) {
        return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
    }
    function isAssociative(maybeAssociative) {
        return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
    }
    function isOrdered(maybeOrdered) {
        return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
    }
    Iterable.isIterable = isIterable;
    Iterable.isKeyed = isKeyed;
    Iterable.isIndexed = isIndexed;
    Iterable.isAssociative = isAssociative;
    Iterable.isOrdered = isOrdered;
    Iterable.Keyed = KeyedIterable;
    Iterable.Indexed = IndexedIterable;
    Iterable.Set = SetIterable;
    var IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@";
    var IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@";
    var IS_INDEXED_SENTINEL = "@@__IMMUTABLE_INDEXED__@@";
    var IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@";
    // Used for setting prototype methods that IE8 chokes on.
    var DELETE = "delete";
    // Constants describing the size of trie nodes.
    var SHIFT = 5; // Resulted in best performance after ______?
    var SIZE = 1 << SHIFT;
    var MASK = SIZE - 1;
    // A consistent shared value representing "not set" which equals nothing other
    // than itself, and nothing that could be provided externally.
    var NOT_SET = {};
    // Boolean references, Rough equivalent of `bool &`.
    var CHANGE_LENGTH = {
        value: false
    };
    var DID_ALTER = {
        value: false
    };
    function MakeRef(ref) {
        ref.value = false;
        return ref;
    }
    function SetRef(ref) {
        ref && (ref.value = true);
    }
    // A function which returns a value representing an "owner" for transient writes
    // to tries. The return value will only ever equal itself, and will not equal
    // the return of any subsequent call of this function.
    function OwnerID() {}
    // http://jsperf.com/copy-array-inline
    function arrCopy(arr, offset) {
        offset = offset || 0;
        var len = Math.max(0, arr.length - offset);
        var newArr = new Array(len);
        for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
        return newArr;
    }
    function ensureSize(iter) {
        if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
        return iter.size;
    }
    function wrapIndex(iter, index) {
        // This implements "is array index" which the ECMAString spec defines as:
        //
        //     A String property name P is an array index if and only if
        //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
        //     to 2^32−1.
        //
        // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
        if (typeof index !== "number") {
            var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
            if ("" + uint32Index !== index || uint32Index === 4294967295) return NaN;
            index = uint32Index;
        }
        return index < 0 ? ensureSize(iter) + index : index;
    }
    function returnTrue() {
        return true;
    }
    function wholeSlice(begin, end, size) {
        return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
    }
    function resolveBegin(begin, size) {
        return resolveIndex(begin, size, 0);
    }
    function resolveEnd(end, size) {
        return resolveIndex(end, size, size);
    }
    function resolveIndex(index, size, defaultIndex) {
        return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
    }
    /* global Symbol */ var ITERATE_KEYS = 0;
    var ITERATE_VALUES = 1;
    var ITERATE_ENTRIES = 2;
    var REAL_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
    function Iterator(next) {
        this.next = next;
    }
    Iterator.prototype.toString = function() {
        return "[Iterator]";
    };
    Iterator.KEYS = ITERATE_KEYS;
    Iterator.VALUES = ITERATE_VALUES;
    Iterator.ENTRIES = ITERATE_ENTRIES;
    Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
        return this.toString();
    };
    Iterator.prototype[ITERATOR_SYMBOL] = function() {
        return this;
    };
    function iteratorValue(type, k, v, iteratorResult) {
        var value = type === 0 ? k : type === 1 ? v : [
            k,
            v
        ];
        iteratorResult ? iteratorResult.value = value : iteratorResult = {
            value: value,
            done: false
        };
        return iteratorResult;
    }
    function iteratorDone() {
        return {
            value: undefined,
            done: true
        };
    }
    function hasIterator(maybeIterable) {
        return !!getIteratorFn(maybeIterable);
    }
    function isIterator(maybeIterator) {
        return maybeIterator && typeof maybeIterator.next === "function";
    }
    function getIterator(iterable) {
        var iteratorFn = getIteratorFn(iterable);
        return iteratorFn && iteratorFn.call(iterable);
    }
    function getIteratorFn(iterable) {
        var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    function isArrayLike(value) {
        return value && typeof value.length === "number";
    }
    createClass(Seq, Iterable);
    function Seq(value) {
        return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
    }
    Seq.of = function() {
        return Seq(arguments);
    };
    Seq.prototype.toSeq = function() {
        return this;
    };
    Seq.prototype.toString = function() {
        return this.__toString("Seq {", "}");
    };
    Seq.prototype.cacheResult = function() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, true);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, true);
    };
    createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
        return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
    }
    KeyedSeq.prototype.toKeyedSeq = function() {
        return this;
    };
    createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
        return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }
    IndexedSeq.of = function() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function() {
        return this;
    };
    IndexedSeq.prototype.toString = function() {
        return this.__toString("Seq [", "]");
    };
    IndexedSeq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, false);
    };
    IndexedSeq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, false);
    };
    createClass(SetSeq, Seq);
    function SetSeq(value) {
        return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
    }
    SetSeq.of = function() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function() {
        return this;
    };
    Seq.isSeq = isSeq;
    Seq.Keyed = KeyedSeq;
    Seq.Set = SetSeq;
    Seq.Indexed = IndexedSeq;
    var IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@";
    Seq.prototype[IS_SEQ_SENTINEL] = true;
    createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    ArraySeq.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function(fn, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) return ii + 1;
        }
        return ii;
    };
    ArraySeq.prototype.__iterator = function(type, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        var ii = 0;
        return new Iterator(function() {
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
        });
    };
    createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
        var keys = Object.keys(object);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    ObjectSeq.prototype.get = function(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function(key) {
        return this._object.hasOwnProperty(key);
    };
    ObjectSeq.prototype.__iterate = function(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            var key = keys[reverse ? maxIndex - ii : ii];
            if (fn(object[key], key, this) === false) return ii + 1;
        }
        return ii;
    };
    ObjectSeq.prototype.__iterator = function(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        var ii = 0;
        return new Iterator(function() {
            var key = keys[reverse ? maxIndex - ii : ii];
            return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
        });
    };
    ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
        this._iterable = iterable;
        this.size = iterable.length || iterable.size;
    }
    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
        this._iterator = iterator;
        this._iteratorCache = [];
    }
    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        while(iterations < cache.length){
            if (fn(cache[iterations], iterations++, this) === false) return iterations;
        }
        var step;
        while(!(step = iterator.next()).done){
            var val = step.value;
            cache[iterations] = val;
            if (fn(val, iterations++, this) === false) break;
        }
        return iterations;
    };
    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        return new Iterator(function() {
            if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) return step;
                cache[iterations] = step.value;
            }
            return iteratorValue(type, iterations, cache[iterations++]);
        });
    };
    // # pragma Helper functions
    function isSeq(maybeSeq) {
        return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
    }
    var EMPTY_SEQ;
    function emptySequence() {
        return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
    }
    function keyedSeqFromValue(value) {
        var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === "object" ? new ObjectSeq(value) : undefined;
        if (!seq) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + value);
        return seq;
    }
    function indexedSeqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value);
        if (!seq) throw new TypeError("Expected Array or iterable object of values: " + value);
        return seq;
    }
    function seqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value) || typeof value === "object" && new ObjectSeq(value);
        if (!seq) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + value);
        return seq;
    }
    function maybeIndexedSeqFromValue(value) {
        return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
    }
    function seqIterate(seq, fn, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            for(var ii = 0; ii <= maxIndex; ii++){
                var entry = cache[reverse ? maxIndex - ii : ii];
                if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) return ii + 1;
            }
            return ii;
        }
        return seq.__iterateUncached(fn, reverse);
    }
    function seqIterator(seq, type, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            var ii = 0;
            return new Iterator(function() {
                var entry = cache[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
            });
        }
        return seq.__iteratorUncached(type, reverse);
    }
    function fromJS(json, converter) {
        return converter ? fromJSWith(converter, json, "", {
            "": json
        }) : fromJSDefault(json);
    }
    function fromJSWith(converter, json, key, parentJSON) {
        if (Array.isArray(json)) return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        if (isPlainObj(json)) return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        return json;
    }
    function fromJSDefault(json) {
        if (Array.isArray(json)) return IndexedSeq(json).map(fromJSDefault).toList();
        if (isPlainObj(json)) return KeyedSeq(json).map(fromJSDefault).toMap();
        return json;
    }
    function isPlainObj(value) {
        return value && (value.constructor === Object || value.constructor === undefined);
    }
    /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */ function is(valueA, valueB) {
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
        if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
            valueA = valueA.valueOf();
            valueB = valueB.valueOf();
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
            if (!valueA || !valueB) return false;
        }
        if (typeof valueA.equals === "function" && typeof valueB.equals === "function" && valueA.equals(valueB)) return true;
        return false;
    }
    function deepEqual(a, b) {
        if (a === b) return true;
        if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
        if (a.size === 0 && b.size === 0) return true;
        var notAssociative = !isAssociative(a);
        if (isOrdered(a)) {
            var entries = a.entries();
            return b.every(function(v, k) {
                var entry = entries.next().value;
                return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
            }) && entries.next().done;
        }
        var flipped = false;
        if (a.size === undefined) {
            if (b.size === undefined) {
                if (typeof a.cacheResult === "function") a.cacheResult();
            } else {
                flipped = true;
                var _ = a;
                a = b;
                b = _;
            }
        }
        var allEqual = true;
        var bSize = b.__iterate(function(v, k) {
            if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
                allEqual = false;
                return false;
            }
        });
        return allEqual && a.size === bSize;
    }
    createClass(Repeat, IndexedSeq);
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    Repeat.prototype.toString = function() {
        if (this.size === 0) return "Repeat []";
        return "Repeat [ " + this._value + " " + this.size + " times ]";
    };
    Repeat.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function() {
        return this;
    };
    Repeat.prototype.indexOf = function(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function(fn, reverse) {
        for(var ii = 0; ii < this.size; ii++){
            if (fn(this._value, ii, this) === false) return ii + 1;
        }
        return ii;
    };
    Repeat.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        var ii = 0;
        return new Iterator(function() {
            return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
        });
    };
    Repeat.prototype.equals = function(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };
    var EMPTY_REPEAT;
    function invariant(condition, error) {
        if (!condition) throw new Error(error);
    }
    createClass(Range, IndexedSeq);
    function Range(start, end, step) {
        if (!(this instanceof Range)) return new Range(start, end, step);
        invariant(step !== 0, "Cannot step a Range by 0");
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    Range.prototype.toString = function() {
        if (this.size === 0) return "Range []";
        return "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
    };
    Range.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function(fn, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(value, ii, this) === false) return ii + 1;
            value += reverse ? -step : step;
        }
        return ii;
    };
    Range.prototype.__iterator = function(type, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        var ii = 0;
        return new Iterator(function() {
            var v = value;
            value += reverse ? -step : step;
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
        });
    };
    Range.prototype.equals = function(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    var EMPTY_RANGE;
    createClass(Collection, Iterable);
    function Collection() {
        throw TypeError("Abstract");
    }
    createClass(KeyedCollection, Collection);
    function KeyedCollection() {}
    createClass(IndexedCollection, Collection);
    function IndexedCollection() {}
    createClass(SetCollection, Collection);
    function SetCollection() {}
    Collection.Keyed = KeyedCollection;
    Collection.Indexed = IndexedCollection;
    Collection.Set = SetCollection;
    var imul = typeof Math.imul === "function" && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
        a = a | 0; // int
        b = b | 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
    };
    // v8 has an optimization for storing 31-bit signed numbers.
    // Values which have either 00 or 11 as the high order bits qualify.
    // This function drops the highest order bit in a signed number, maintaining
    // the sign bit.
    function smi(i32) {
        return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
    }
    function hash(o) {
        if (o === false || o === null || o === undefined) return 0;
        if (typeof o.valueOf === "function") {
            o = o.valueOf();
            if (o === false || o === null || o === undefined) return 0;
        }
        if (o === true) return 1;
        var type = typeof o;
        if (type === "number") {
            if (o !== o || o === Infinity) return 0;
            var h = o | 0;
            if (h !== o) h ^= o * 0xFFFFFFFF;
            while(o > 0xFFFFFFFF){
                o /= 0xFFFFFFFF;
                h ^= o;
            }
            return smi(h);
        }
        if (type === "string") return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
        if (typeof o.hashCode === "function") return o.hashCode();
        if (type === "object") return hashJSObj(o);
        if (typeof o.toString === "function") return hashString(o.toString());
        throw new Error("Value type " + type + " cannot be hashed.");
    }
    function cachedHashString(string) {
        var hash = stringHashCache[string];
        if (hash === undefined) {
            hash = hashString(string);
            if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
                STRING_HASH_CACHE_SIZE = 0;
                stringHashCache = {};
            }
            STRING_HASH_CACHE_SIZE++;
            stringHashCache[string] = hash;
        }
        return hash;
    }
    // http://jsperf.com/hashing-strings
    function hashString(string) {
        // This is the hash from JVM
        // The hash code for a string is computed as
        // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
        // where s[i] is the ith character of the string and n is the length of
        // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
        // (exclusive) by dropping high bits.
        var hash = 0;
        for(var ii = 0; ii < string.length; ii++)hash = 31 * hash + string.charCodeAt(ii) | 0;
        return smi(hash);
    }
    function hashJSObj(obj) {
        var hash;
        if (usingWeakMap) {
            hash = weakMap.get(obj);
            if (hash !== undefined) return hash;
        }
        hash = obj[UID_HASH_KEY];
        if (hash !== undefined) return hash;
        if (!canDefineProperty) {
            hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
            if (hash !== undefined) return hash;
            hash = getIENodeHash(obj);
            if (hash !== undefined) return hash;
        }
        hash = ++objHashUID;
        if (objHashUID & 0x40000000) objHashUID = 0;
        if (usingWeakMap) weakMap.set(obj, hash);
        else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error("Non-extensible objects are not allowed as keys.");
        else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
            "enumerable": false,
            "configurable": false,
            "writable": false,
            "value": hash
        });
        else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
            // Since we can't define a non-enumerable property on the object
            // we'll hijack one of the less-used non-enumerable properties to
            // save our hash on it. Since this is a function it will not show up in
            // `JSON.stringify` which is what we want.
            obj.propertyIsEnumerable = function() {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            };
            obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
        } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
        // and we couldn't use a non-enumerable property to exploit the
        // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
        // itself.
        obj[UID_HASH_KEY] = hash;
        else throw new Error("Unable to set a non-enumerable property on object.");
        return hash;
    }
    // Get references to ES5 object methods.
    var isExtensible = Object.isExtensible;
    // True if Object.defineProperty works as expected. IE8 fails this test.
    var canDefineProperty = function() {
        try {
            Object.defineProperty({}, "@", {});
            return true;
        } catch (e) {
            return false;
        }
    }();
    // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
    // and avoid memory leaks from the IE cloneNode bug.
    function getIENodeHash(node) {
        if (node && node.nodeType > 0) switch(node.nodeType){
            case 1:
                return node.uniqueID;
            case 9:
                return node.documentElement && node.documentElement.uniqueID;
        }
    }
    // If possible, use a WeakMap.
    var usingWeakMap = typeof WeakMap === "function";
    var weakMap;
    if (usingWeakMap) weakMap = new WeakMap();
    var objHashUID = 0;
    var UID_HASH_KEY = "__immutablehash__";
    if (typeof Symbol === "function") UID_HASH_KEY = Symbol(UID_HASH_KEY);
    var STRING_HASH_CACHE_MIN_STRLEN = 16;
    var STRING_HASH_CACHE_MAX_SIZE = 255;
    var STRING_HASH_CACHE_SIZE = 0;
    var stringHashCache = {};
    function assertNotInfinite(size) {
        invariant(size !== Infinity, "Cannot perform this action with an infinite size.");
    }
    createClass(Map, KeyedCollection);
    // @pragma Construction
    function Map(value) {
        return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    Map.of = function() {
        var keyValues = SLICE$0.call(arguments, 0);
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error("Missing value for key: " + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function() {
        return this.__toString("Map {", "}");
    };
    // @pragma Access
    Map.prototype.get = function(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.setIn = function(keyPath, v) {
        return this.updateIn(keyPath, NOT_SET, function() {
            return v;
        });
    };
    Map.prototype.remove = function(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteIn = function(keyPath) {
        return this.updateIn(keyPath, function() {
            return NOT_SET;
        });
    };
    Map.prototype.update = function(k, notSetValue, updater) {
        return arguments.length === 1 ? k(this) : this.updateIn([
            k
        ], notSetValue, updater);
    };
    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
        if (!updater) {
            updater = notSetValue;
            notSetValue = undefined;
        }
        var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
        return updatedValue === NOT_SET ? undefined : updatedValue;
    };
    Map.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.merge = function() {
        return mergeIntoMapWith(this, undefined, arguments);
    };
    Map.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, merger, iters);
    };
    Map.prototype.mergeIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.merge === "function" ? m.merge.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.mergeDeep = function() {
        return mergeIntoMapWith(this, deepMerger, arguments);
    };
    Map.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };
    Map.prototype.mergeDeepIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.mergeDeep === "function" ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.sort = function(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    // @pragma Mutability
    Map.prototype.withMutations = function(fn) {
        var mutable = this.asMutable();
        fn(mutable);
        return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };
    Map.prototype.asMutable = function() {
        return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };
    Map.prototype.asImmutable = function() {
        return this.__ensureOwner();
    };
    Map.prototype.wasAltered = function() {
        return this.__altered;
    };
    Map.prototype.__iterator = function(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$0);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    function isMap(maybeMap) {
        return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
    }
    Map.isMap = isMap;
    var IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@";
    var MapPrototype = Map.prototype;
    MapPrototype[IS_MAP_SENTINEL] = true;
    MapPrototype[DELETE] = MapPrototype.remove;
    MapPrototype.removeIn = MapPrototype.deleteIn;
    // #pragma Trie Nodes
    function ArrayMapNode(ownerID, entries) {
        this.ownerID = ownerID;
        this.entries = entries;
    }
    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && entries.length === 1) return; // undefined
        if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new ArrayMapNode(ownerID, newEntries);
    };
    function BitmapIndexedNode(ownerID, bitmap, nodes) {
        this.ownerID = ownerID;
        this.bitmap = bitmap;
        this.nodes = nodes;
    }
    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
        var bitmap = this.bitmap;
        return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
    };
    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var bit = 1 << keyHashFrag;
        var bitmap = this.bitmap;
        var exists = (bitmap & bit) !== 0;
        if (!exists && value === NOT_SET) return this;
        var idx = popCount(bitmap & bit - 1);
        var nodes = this.nodes;
        var node = exists ? nodes[idx] : undefined;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
        if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
        if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
        var isEditable = ownerID && ownerID === this.ownerID;
        var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
        var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.bitmap = newBitmap;
            this.nodes = newNodes;
            return this;
        }
        return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };
    function HashArrayMapNode(ownerID, count, nodes) {
        this.ownerID = ownerID;
        this.count = count;
        this.nodes = nodes;
    }
    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var node = this.nodes[idx];
        return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };
    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var removed = value === NOT_SET;
        var nodes = this.nodes;
        var node = nodes[idx];
        if (removed && !node) return this;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        var newCount = this.count;
        if (!node) newCount++;
        else if (!newNode) {
            newCount--;
            if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newNodes = setIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.count = newCount;
            this.nodes = newNodes;
            return this;
        }
        return new HashArrayMapNode(ownerID, newCount, newNodes);
    };
    function HashCollisionNode(ownerID, keyHash, entries) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entries = entries;
    }
    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var removed = value === NOT_SET;
        if (keyHash !== this.keyHash) {
            if (removed) return this;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, keyHash, [
                key,
                value
            ]);
        }
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };
    function ValueNode(ownerID, keyHash, entry) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entry = entry;
    }
    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };
    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var keyMatch = is(key, this.entry[0]);
        if (keyMatch ? value === this.entry[1] : removed) return this;
        SetRef(didAlter);
        if (removed) {
            SetRef(didChangeSize);
            return; // undefined
        }
        if (keyMatch) {
            if (ownerID && ownerID === this.ownerID) {
                this.entry[1] = value;
                return this;
            }
            return new ValueNode(ownerID, this.keyHash, [
                key,
                value
            ]);
        }
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, hash(key), [
            key,
            value
        ]);
    };
    // #pragma Iterators
    ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
        var entries = this.entries;
        for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
            if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
        }
    };
    BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
        var nodes = this.nodes;
        for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
            var node = nodes[reverse ? maxIndex - ii : ii];
            if (node && node.iterate(fn, reverse) === false) return false;
        }
    };
    ValueNode.prototype.iterate = function(fn, reverse) {
        return fn(this.entry);
    };
    createClass(MapIterator, Iterator);
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    MapIterator.prototype.next = function() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    function mapIteratorValue(type, entry) {
        return iteratorValue(type, entry[0], entry[1]);
    }
    function mapIteratorFrame(node, prev) {
        return {
            node: node,
            index: 0,
            __prev: prev
        };
    }
    function makeMap(size, root, ownerID, hash) {
        var map = Object.create(MapPrototype);
        map.size = size;
        map._root = root;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_MAP;
    function emptyMap() {
        return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
    }
    function updateMap(map, k, v) {
        var newRoot;
        var newSize;
        if (!map._root) {
            if (v === NOT_SET) return map;
            newSize = 1;
            newRoot = new ArrayMapNode(map.__ownerID, [
                [
                    k,
                    v
                ]
            ]);
        } else {
            var didChangeSize = MakeRef(CHANGE_LENGTH);
            var didAlter = MakeRef(DID_ALTER);
            newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
            if (!didAlter.value) return map;
            newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
        }
        if (map.__ownerID) {
            map.size = newSize;
            map._root = newRoot;
            map.__hash = undefined;
            map.__altered = true;
            return map;
        }
        return newRoot ? makeMap(newSize, newRoot) : emptyMap();
    }
    function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (!node) {
            if (value === NOT_SET) return node;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return new ValueNode(ownerID, keyHash, [
                key,
                value
            ]);
        }
        return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
    }
    function isLeafNode(node) {
        return node.constructor === ValueNode || node.constructor === HashCollisionNode;
    }
    function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
        if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
            node.entry,
            entry
        ]);
        var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
        var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var newNode;
        var nodes = idx1 === idx2 ? [
            mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
        ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
            node,
            newNode
        ] : [
            newNode,
            node
        ]);
        return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
    }
    function createNodes(ownerID, entries, key, value) {
        if (!ownerID) ownerID = new OwnerID();
        var node = new ValueNode(ownerID, hash(key), [
            key,
            value
        ]);
        for(var ii = 0; ii < entries.length; ii++){
            var entry = entries[ii];
            node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
        }
        return node;
    }
    function packNodes(ownerID, nodes, count, excluding) {
        var bitmap = 0;
        var packedII = 0;
        var packedNodes = new Array(count);
        for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
            var node = nodes[ii];
            if (node !== undefined && ii !== excluding) {
                bitmap |= bit;
                packedNodes[packedII++] = node;
            }
        }
        return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
    }
    function expandNodes(ownerID, nodes, bitmap, including, node) {
        var count = 0;
        var expandedNodes = new Array(SIZE);
        for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
        expandedNodes[including] = node;
        return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
    }
    function mergeIntoMapWith(map, merger, iterables) {
        var iters = [];
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = KeyedIterable(value);
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        return mergeIntoCollectionWith(map, merger, iters);
    }
    function deepMerger(existing, value, key) {
        return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
    }
    function deepMergerWith(merger) {
        return function(existing, value, key) {
            if (existing && existing.mergeDeepWith && isIterable(value)) return existing.mergeDeepWith(merger, value);
            var nextValue = merger(existing, value, key);
            return is(existing, nextValue) ? existing : nextValue;
        };
    }
    function mergeIntoCollectionWith(collection, merger, iters) {
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return collection;
        if (collection.size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
        return collection.withMutations(function(collection) {
            var mergeIntoMap = merger ? function(value, key) {
                collection.update(key, NOT_SET, function(existing) {
                    return existing === NOT_SET ? value : merger(existing, value, key);
                });
            } : function(value, key) {
                collection.set(key, value);
            };
            for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoMap);
        });
    }
    function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
        var isNotSet = existing === NOT_SET;
        var step = keyPathIter.next();
        if (step.done) {
            var existingValue = isNotSet ? notSetValue : existing;
            var newValue = updater(existingValue);
            return newValue === existingValue ? existing : newValue;
        }
        invariant(isNotSet || existing && existing.set, "invalid keyPath");
        var key = step.value;
        var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
        var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
        return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
    }
    function popCount(x) {
        x = x - (x >> 1 & 0x55555555);
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x = x + (x >> 8);
        x = x + (x >> 16);
        return x & 0x7f;
    }
    function setIn(array, idx, val, canEdit) {
        var newArray = canEdit ? array : arrCopy(array);
        newArray[idx] = val;
        return newArray;
    }
    function spliceIn(array, idx, val, canEdit) {
        var newLen = array.length + 1;
        if (canEdit && idx + 1 === newLen) {
            array[idx] = val;
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
            newArray[ii] = val;
            after = -1;
        } else newArray[ii] = array[ii + after];
        return newArray;
    }
    function spliceOut(array, idx, canEdit) {
        var newLen = array.length - 1;
        if (canEdit && idx === newLen) {
            array.pop();
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++){
            if (ii === idx) after = 1;
            newArray[ii] = array[ii + after];
        }
        return newArray;
    }
    var MAX_ARRAY_MAP_SIZE = SIZE / 4;
    var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
    var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
    createClass(List, IndexedCollection);
    // @pragma Construction
    function List(value) {
        var empty = emptyList();
        if (value === null || value === undefined) return empty;
        if (isList(value)) return value;
        var iter = IndexedIterable(value);
        var size = iter.size;
        if (size === 0) return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    List.of = function() {
        return this(arguments);
    };
    List.prototype.toString = function() {
        return this.__toString("List [", "]");
    };
    // @pragma Access
    List.prototype.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.merge = function() {
        return mergeIntoListWith(this, undefined, arguments);
    };
    List.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, merger, iters);
    };
    List.prototype.mergeDeep = function() {
        return mergeIntoListWith(this, deepMerger, arguments);
    };
    List.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };
    List.prototype.setSize = function(size) {
        return setListBounds(this, 0, size);
    };
    // @pragma Iteration
    List.prototype.slice = function(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function(type, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
        });
    };
    List.prototype.__iterate = function(fn, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    function isList(maybeList) {
        return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
    }
    List.isList = isList;
    var IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@";
    var ListPrototype = List.prototype;
    ListPrototype[IS_LIST_SENTINEL] = true;
    ListPrototype[DELETE] = ListPrototype.remove;
    ListPrototype.setIn = MapPrototype.setIn;
    ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
    ListPrototype.update = MapPrototype.update;
    ListPrototype.updateIn = MapPrototype.updateIn;
    ListPrototype.mergeIn = MapPrototype.mergeIn;
    ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    ListPrototype.withMutations = MapPrototype.withMutations;
    ListPrototype.asMutable = MapPrototype.asMutable;
    ListPrototype.asImmutable = MapPrototype.asImmutable;
    ListPrototype.wasAltered = MapPrototype.wasAltered;
    function VNode(array, ownerID) {
        this.array = array;
        this.ownerID = ownerID;
    }
    // TODO: seems like these methods are very similar
    VNode.prototype.removeBefore = function(ownerID, level, index) {
        if (index === level ? 1 << level : this.array.length === 0) return this;
        var originIndex = index >>> level & MASK;
        if (originIndex >= this.array.length) return new VNode([], ownerID);
        var removingFirst = originIndex === 0;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[originIndex];
            newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
            if (newChild === oldChild && removingFirst) return this;
        }
        if (removingFirst && !newChild) return this;
        var editable = editableVNode(this, ownerID);
        if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
        if (newChild) editable.array[originIndex] = newChild;
        return editable;
    };
    VNode.prototype.removeAfter = function(ownerID, level, index) {
        if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
        var sizeIndex = index - 1 >>> level & MASK;
        if (sizeIndex >= this.array.length) return this;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[sizeIndex];
            newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
            if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
        }
        var editable = editableVNode(this, ownerID);
        editable.array.splice(sizeIndex + 1);
        if (newChild) editable.array[sizeIndex] = newChild;
        return editable;
    };
    var DONE = {};
    function iterateList(list, reverse) {
        var left = list._origin;
        var right = list._capacity;
        var tailPos = getTailOffset(right);
        var tail = list._tail;
        return iterateNodeOrLeaf(list._root, list._level, 0);
        function iterateNodeOrLeaf(node, level, offset) {
            return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
        }
        function iterateLeaf(node, offset) {
            var array = offset === tailPos ? tail && tail.array : node && node.array;
            var from = offset > left ? 0 : left - offset;
            var to = right - offset;
            if (to > SIZE) to = SIZE;
            return function() {
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                return array && array[idx];
            };
        }
        function iterateNode(node, level, offset) {
            var values;
            var array = node && node.array;
            var from = offset > left ? 0 : left - offset >> level;
            var to = (right - offset >> level) + 1;
            if (to > SIZE) to = SIZE;
            return function() {
                do {
                    if (values) {
                        var value = values();
                        if (value !== DONE) return value;
                        values = null;
                    }
                    if (from === to) return DONE;
                    var idx = reverse ? --to : from++;
                    values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                }while (true);
            };
        }
    }
    function makeList(origin, capacity, level, root, tail, ownerID, hash) {
        var list = Object.create(ListPrototype);
        list.size = capacity - origin;
        list._origin = origin;
        list._capacity = capacity;
        list._level = level;
        list._root = root;
        list._tail = tail;
        list.__ownerID = ownerID;
        list.__hash = hash;
        list.__altered = false;
        return list;
    }
    var EMPTY_LIST;
    function emptyList() {
        return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
    }
    function updateList(list, index, value) {
        index = wrapIndex(list, index);
        if (index !== index) return list;
        if (index >= list.size || index < 0) return list.withMutations(function(list) {
            index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
        });
        index += list._origin;
        var newTail = list._tail;
        var newRoot = list._root;
        var didAlter = MakeRef(DID_ALTER);
        if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
        else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
        if (!didAlter.value) return list;
        if (list.__ownerID) {
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
    }
    function updateVNode(node, ownerID, level, index, value, didAlter) {
        var idx = index >>> level & MASK;
        var nodeHas = node && idx < node.array.length;
        if (!nodeHas && value === undefined) return node;
        var newNode;
        if (level > 0) {
            var lowerNode = node && node.array[idx];
            var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
            if (newLowerNode === lowerNode) return node;
            newNode = editableVNode(node, ownerID);
            newNode.array[idx] = newLowerNode;
            return newNode;
        }
        if (nodeHas && node.array[idx] === value) return node;
        SetRef(didAlter);
        newNode = editableVNode(node, ownerID);
        if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
        else newNode.array[idx] = value;
        return newNode;
    }
    function editableVNode(node, ownerID) {
        if (ownerID && node && ownerID === node.ownerID) return node;
        return new VNode(node ? node.array.slice() : [], ownerID);
    }
    function listNodeFor(list, rawIndex) {
        if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
        if (rawIndex < 1 << list._level + SHIFT) {
            var node = list._root;
            var level = list._level;
            while(node && level > 0){
                node = node.array[rawIndex >>> level & MASK];
                level -= SHIFT;
            }
            return node;
        }
    }
    function setListBounds(list, begin, end) {
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) end = end | 0;
        var owner = list.__ownerID || new OwnerID();
        var oldOrigin = list._origin;
        var oldCapacity = list._capacity;
        var newOrigin = oldOrigin + begin;
        var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
        if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
        // If it's going to end after it starts, it's empty.
        if (newOrigin >= newCapacity) return list.clear();
        var newLevel = list._level;
        var newRoot = list._root;
        // New origin might need creating a higher root.
        var offsetShift = 0;
        while(newOrigin + offsetShift < 0){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                undefined,
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
            offsetShift += 1 << newLevel;
        }
        if (offsetShift) {
            newOrigin += offsetShift;
            oldOrigin += offsetShift;
            newCapacity += offsetShift;
            oldCapacity += offsetShift;
        }
        var oldTailOffset = getTailOffset(oldCapacity);
        var newTailOffset = getTailOffset(newCapacity);
        // New size might need creating a higher root.
        while(newTailOffset >= 1 << newLevel + SHIFT){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
        }
        // Locate or create the new tail.
        var oldTail = list._tail;
        var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
        // Merge Tail into tree.
        if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
            newRoot = editableVNode(newRoot, owner);
            var node = newRoot;
            for(var level = newLevel; level > SHIFT; level -= SHIFT){
                var idx = oldTailOffset >>> level & MASK;
                node = node.array[idx] = editableVNode(node.array[idx], owner);
            }
            node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
        }
        // If the size has been reduced, there's a chance the tail needs to be trimmed.
        if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
        // If the new origin is within the tail, then we do not need a root.
        if (newOrigin >= newTailOffset) {
            newOrigin -= newTailOffset;
            newCapacity -= newTailOffset;
            newLevel = SHIFT;
            newRoot = null;
            newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
        // Otherwise, if the root has been trimmed, garbage collect.
        } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
            offsetShift = 0;
            // Identify the new top root node of the subtree of the old root.
            while(newRoot){
                var beginIndex = newOrigin >>> newLevel & MASK;
                if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
                if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
                newLevel -= SHIFT;
                newRoot = newRoot.array[beginIndex];
            }
            // Trim the new sides of the new root.
            if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
            if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
            if (offsetShift) {
                newOrigin -= offsetShift;
                newCapacity -= offsetShift;
            }
        }
        if (list.__ownerID) {
            list.size = newCapacity - newOrigin;
            list._origin = newOrigin;
            list._capacity = newCapacity;
            list._level = newLevel;
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
    }
    function mergeIntoListWith(list, merger, iterables) {
        var iters = [];
        var maxSize = 0;
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = IndexedIterable(value);
            if (iter.size > maxSize) maxSize = iter.size;
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        if (maxSize > list.size) list = list.setSize(maxSize);
        return mergeIntoCollectionWith(list, merger, iters);
    }
    function getTailOffset(size) {
        return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
    }
    createClass(OrderedMap, Map);
    // @pragma Construction
    function OrderedMap(value) {
        return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    OrderedMap.of = function() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function() {
        return this.__toString("OrderedMap {", "}");
    };
    // @pragma Access
    OrderedMap.prototype.get = function(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.wasAltered = function() {
        return this._map.wasAltered() || this._list.wasAltered();
    };
    OrderedMap.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$0);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    function isOrderedMap(maybeOrderedMap) {
        return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
    }
    OrderedMap.isOrderedMap = isOrderedMap;
    OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
    OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
    function makeOrderedMap(map, list, ownerID, hash) {
        var omap = Object.create(OrderedMap.prototype);
        omap.size = map ? map.size : 0;
        omap._map = map;
        omap._list = list;
        omap.__ownerID = ownerID;
        omap.__hash = hash;
        return omap;
    }
    var EMPTY_ORDERED_MAP;
    function emptyOrderedMap() {
        return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
    }
    function updateOrderedMap(omap, k, v) {
        var map = omap._map;
        var list = omap._list;
        var i = map.get(k);
        var has = i !== undefined;
        var newMap;
        var newList;
        if (v === NOT_SET) {
            if (!has) return omap;
            if (list.size >= SIZE && list.size >= map.size * 2) {
                newList = list.filter(function(entry, idx) {
                    return entry !== undefined && i !== idx;
                });
                newMap = newList.toKeyedSeq().map(function(entry) {
                    return entry[0];
                }).flip().toMap();
                if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
            } else {
                newMap = map.remove(k);
                newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
            }
        } else if (has) {
            if (v === list.get(i)[1]) return omap;
            newMap = map;
            newList = list.set(i, [
                k,
                v
            ]);
        } else {
            newMap = map.set(k, list.size);
            newList = list.set(list.size, [
                k,
                v
            ]);
        }
        if (omap.__ownerID) {
            omap.size = newMap.size;
            omap._map = newMap;
            omap._list = newList;
            omap.__hash = undefined;
            return omap;
        }
        return makeOrderedMap(newMap, newList);
    }
    createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    ToKeyedSequence.prototype.get = function(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function() {
        var this$0 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$0._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function(mapper, context) {
        var this$0 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$0._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var ii;
        return this._iter.__iterate(this._useKeys ? function(v, k) {
            return fn(v, k, this$0);
        } : (ii = reverse ? resolveSize(this) : 0, function(v) {
            return fn(v, reverse ? --ii : ii++, this$0);
        }), reverse);
    };
    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
        if (this._useKeys) return this._iter.__iterator(type, reverse);
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var ii = reverse ? resolveSize(this) : 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
        });
    };
    ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToIndexedSequence.prototype.includes = function(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        return this._iter.__iterate(function(v) {
            return fn(v, iterations++, this$0);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value, step);
        });
    };
    createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToSetSequence.prototype.has = function(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$0);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    FromEntriesSequence.prototype.entrySeq = function() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedIterable = isIterable(entry);
                    return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
    function flipFactory(iterable) {
        var flipSequence = makeSequence(iterable);
        flipSequence._iter = iterable;
        flipSequence.size = iterable.size;
        flipSequence.flip = function() {
            return iterable;
        };
        flipSequence.reverse = function() {
            var reversedSequence = iterable.reverse.apply(this); // super.reverse()
            reversedSequence.flip = function() {
                return iterable.reverse();
            };
            return reversedSequence;
        };
        flipSequence.has = function(key) {
            return iterable.includes(key);
        };
        flipSequence.includes = function(key) {
            return iterable.has(key);
        };
        flipSequence.cacheResult = cacheResultThrough;
        flipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(k, v, this$0) !== false;
            }, reverse);
        };
        flipSequence.__iteratorUncached = function(type, reverse) {
            if (type === ITERATE_ENTRIES) {
                var iterator = iterable.__iterator(type, reverse);
                return new Iterator(function() {
                    var step = iterator.next();
                    if (!step.done) {
                        var k = step.value[0];
                        step.value[0] = step.value[1];
                        step.value[1] = k;
                    }
                    return step;
                });
            }
            return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
        };
        return flipSequence;
    }
    function mapFactory(iterable, mapper, context) {
        var mappedSequence = makeSequence(iterable);
        mappedSequence.size = iterable.size;
        mappedSequence.has = function(key) {
            return iterable.has(key);
        };
        mappedSequence.get = function(key, notSetValue) {
            var v = iterable.get(key, NOT_SET);
            return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
        };
        mappedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k, c) {
                return fn(mapper.call(context, v, k, c), k, this$0) !== false;
            }, reverse);
        };
        mappedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
            });
        };
        return mappedSequence;
    }
    function reverseFactory(iterable, useKeys) {
        var reversedSequence = makeSequence(iterable);
        reversedSequence._iter = iterable;
        reversedSequence.size = iterable.size;
        reversedSequence.reverse = function() {
            return iterable;
        };
        if (iterable.flip) reversedSequence.flip = function() {
            var flipSequence = flipFactory(iterable);
            flipSequence.reverse = function() {
                return iterable.flip();
            };
            return flipSequence;
        };
        reversedSequence.get = function(key, notSetValue) {
            return iterable.get(useKeys ? key : -1 - key, notSetValue);
        };
        reversedSequence.has = function(key) {
            return iterable.has(useKeys ? key : -1 - key);
        };
        reversedSequence.includes = function(value) {
            return iterable.includes(value);
        };
        reversedSequence.cacheResult = cacheResultThrough;
        reversedSequence.__iterate = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(v, k, this$0);
            }, !reverse);
        };
        reversedSequence.__iterator = function(type, reverse) {
            return iterable.__iterator(type, !reverse);
        };
        return reversedSequence;
    }
    function filterFactory(iterable, predicate, context, useKeys) {
        var filterSequence = makeSequence(iterable);
        if (useKeys) {
            filterSequence.has = function(key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            };
            filterSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            };
        }
        filterSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            }, reverse);
            return iterations;
        };
        filterSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterations = 0;
            return new Iterator(function() {
                while(true){
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value;
                    var key = entry[0];
                    var value = entry[1];
                    if (predicate.call(context, value, key, iterable)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
                }
            });
        };
        return filterSequence;
    }
    function countByFactory(iterable, grouper, context) {
        var groups = Map().asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), 0, function(a) {
                return a + 1;
            });
        });
        return groups.asImmutable();
    }
    function groupByFactory(iterable, grouper, context) {
        var isKeyedIter = isKeyed(iterable);
        var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), function(a) {
                return a = a || [], a.push(isKeyedIter ? [
                    k,
                    v
                ] : v), a;
            });
        });
        var coerce = iterableClass(iterable);
        return groups.map(function(arr) {
            return reify(iterable, coerce(arr));
        });
    }
    function sliceFactory(iterable, begin, end, useKeys) {
        var originalSize = iterable.size;
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) {
            if (end === Infinity) end = originalSize;
            else end = end | 0;
        }
        if (wholeSlice(begin, end, originalSize)) return iterable;
        var resolvedBegin = resolveBegin(begin, originalSize);
        var resolvedEnd = resolveEnd(end, originalSize);
        // begin or end will be NaN if they were provided as negative numbers and
        // this iterable's size is unknown. In that case, cache first so there is
        // a known size and these do not resolve to NaN.
        if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
        // Note: resolvedEnd is undefined when the original sequence's length is
        // unknown and this slice did not supply an end and should contain all
        // elements after resolvedBegin.
        // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
        var resolvedSize = resolvedEnd - resolvedBegin;
        var sliceSize;
        if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
        var sliceSeq = makeSequence(iterable);
        // If iterable.size is undefined, the size of the realized sliceSeq is
        // unknown at this point unless the number of items to slice is 0
        sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
        if (!useKeys && isSeq(iterable) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
        };
        sliceSeq.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (sliceSize === 0) return 0;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var skipped = 0;
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
                }
            });
            return iterations;
        };
        sliceSeq.__iteratorUncached = function(type, reverse) {
            if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
            // Don't bother instantiating parent iterator if taking 0.
            var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
            var skipped = 0;
            var iterations = 0;
            return new Iterator(function() {
                while(skipped++ < resolvedBegin)iterator.next();
                if (++iterations > sliceSize) return iteratorDone();
                var step = iterator.next();
                if (useKeys || type === ITERATE_VALUES) return step;
                else if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
                else return iteratorValue(type, iterations - 1, step.value[1], step);
            });
        };
        return sliceSeq;
    }
    function takeWhileFactory(iterable, predicate, context) {
        var takeSequence = makeSequence(iterable);
        takeSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
            });
            return iterations;
        };
        takeSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterating = true;
            return new Iterator(function() {
                if (!iterating) return iteratorDone();
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var k = entry[0];
                var v = entry[1];
                if (!predicate.call(context, v, k, this$0)) {
                    iterating = false;
                    return iteratorDone();
                }
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return takeSequence;
    }
    function skipWhileFactory(iterable, predicate, context, useKeys) {
        var skipSequence = makeSequence(iterable);
        skipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            });
            return iterations;
        };
        skipSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var skipping = true;
            var iterations = 0;
            return new Iterator(function() {
                var step, k, v;
                do {
                    step = iterator.next();
                    if (step.done) {
                        if (useKeys || type === ITERATE_VALUES) return step;
                        else if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                        else return iteratorValue(type, iterations++, step.value[1], step);
                    }
                    var entry = step.value;
                    k = entry[0];
                    v = entry[1];
                    skipping && (skipping = predicate.call(context, v, k, this$0));
                }while (skipping);
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return skipSequence;
    }
    function concatFactory(iterable, values) {
        var isKeyedIterable = isKeyed(iterable);
        var iters = [
            iterable
        ].concat(values).map(function(v) {
            if (!isIterable(v)) v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
                v
            ]);
            else if (isKeyedIterable) v = KeyedIterable(v);
            return v;
        }).filter(function(v) {
            return v.size !== 0;
        });
        if (iters.length === 0) return iterable;
        if (iters.length === 1) {
            var singleton = iters[0];
            if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) return singleton;
        }
        var concatSeq = new ArraySeq(iters);
        if (isKeyedIterable) concatSeq = concatSeq.toKeyedSeq();
        else if (!isIndexed(iterable)) concatSeq = concatSeq.toSetSeq();
        concatSeq = concatSeq.flatten(true);
        concatSeq.size = iters.reduce(function(sum, seq) {
            if (sum !== undefined) {
                var size = seq.size;
                if (size !== undefined) return sum + size;
            }
        }, 0);
        return concatSeq;
    }
    function flattenFactory(iterable, depth, useKeys) {
        var flatSequence = makeSequence(iterable);
        flatSequence.__iterateUncached = function(fn, reverse) {
            var iterations = 0;
            var stopped = false;
            function flatDeep(iter, currentDepth) {
                var this$0 = this;
                iter.__iterate(function(v, k) {
                    if ((!depth || currentDepth < depth) && isIterable(v)) flatDeep(v, currentDepth + 1);
                    else if (fn(v, useKeys ? k : iterations++, this$0) === false) stopped = true;
                    return !stopped;
                }, reverse);
            }
            flatDeep(iterable, 0);
            return iterations;
        };
        flatSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(type, reverse);
            var stack = [];
            var iterations = 0;
            return new Iterator(function() {
                while(iterator){
                    var step = iterator.next();
                    if (step.done !== false) {
                        iterator = stack.pop();
                        continue;
                    }
                    var v = step.value;
                    if (type === ITERATE_ENTRIES) v = v[1];
                    if ((!depth || stack.length < depth) && isIterable(v)) {
                        stack.push(iterator);
                        iterator = v.__iterator(type, reverse);
                    } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
                }
                return iteratorDone();
            });
        };
        return flatSequence;
    }
    function flatMapFactory(iterable, mapper, context) {
        var coerce = iterableClass(iterable);
        return iterable.toSeq().map(function(v, k) {
            return coerce(mapper.call(context, v, k, iterable));
        }).flatten(true);
    }
    function interposeFactory(iterable, separator) {
        var interposedSequence = makeSequence(iterable);
        interposedSequence.size = iterable.size && iterable.size * 2 - 1;
        interposedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
            }, reverse);
            return iterations;
        };
        interposedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
            var iterations = 0;
            var step;
            return new Iterator(function() {
                if (!step || iterations % 2) {
                    step = iterator.next();
                    if (step.done) return step;
                }
                return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
            });
        };
        return interposedSequence;
    }
    function sortFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        var isKeyedIterable = isKeyed(iterable);
        var index = 0;
        var entries = iterable.toSeq().map(function(v, k) {
            return [
                k,
                v,
                index++,
                mapper ? mapper(v, k, iterable) : v
            ];
        }).toArray();
        entries.sort(function(a, b) {
            return comparator(a[3], b[3]) || a[2] - b[2];
        }).forEach(isKeyedIterable ? function(v, i) {
            entries[i].length = 2;
        } : function(v, i) {
            entries[i] = v[1];
        });
        return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
    }
    function maxFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        if (mapper) {
            var entry = iterable.toSeq().map(function(v, k) {
                return [
                    v,
                    mapper(v, k, iterable)
                ];
            }).reduce(function(a, b) {
                return maxCompare(comparator, a[1], b[1]) ? b : a;
            });
            return entry && entry[0];
        } else return iterable.reduce(function(a, b) {
            return maxCompare(comparator, a, b) ? b : a;
        });
    }
    function maxCompare(comparator, a, b) {
        var comp = comparator(b, a);
        // b is considered the new max if the comparator declares them equal, but
        // they are not equal and b is in fact a nullish value.
        return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
    }
    function zipWithFactory(keyIter, zipper, iters) {
        var zipSequence = makeSequence(keyIter);
        zipSequence.size = new ArraySeq(iters).map(function(i) {
            return i.size;
        }).min();
        // Note: this a generic base implementation of __iterate in terms of
        // __iterator which may be more generically useful in the future.
        zipSequence.__iterate = function(fn, reverse) {
            /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */ // indexed:
            var iterator = this.__iterator(ITERATE_VALUES, reverse);
            var step;
            var iterations = 0;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
            return iterations;
        };
        zipSequence.__iteratorUncached = function(type, reverse) {
            var iterators = iters.map(function(i) {
                return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
            });
            var iterations = 0;
            var isDone = false;
            return new Iterator(function() {
                var steps;
                if (!isDone) {
                    steps = iterators.map(function(i) {
                        return i.next();
                    });
                    isDone = steps.some(function(s) {
                        return s.done;
                    });
                }
                if (isDone) return iteratorDone();
                return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                    return s.value;
                })));
            });
        };
        return zipSequence;
    }
    // #pragma Helper Functions
    function reify(iter, seq) {
        return isSeq(iter) ? seq : iter.constructor(seq);
    }
    function validateEntry(entry) {
        if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
    }
    function resolveSize(iter) {
        assertNotInfinite(iter.size);
        return ensureSize(iter);
    }
    function iterableClass(iterable) {
        return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
    }
    function makeSequence(iterable) {
        return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
    }
    function cacheResultThrough() {
        if (this._iter.cacheResult) {
            this._iter.cacheResult();
            this.size = this._iter.size;
            return this;
        } else return Seq.prototype.cacheResult.call(this);
    }
    function defaultComparator(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    function forceIterator(keyPath) {
        var iter = getIterator(keyPath);
        if (!iter) {
            // Array might not be iterable in this environment, so we need a fallback
            // to our wrapped type.
            if (!isArrayLike(keyPath)) throw new TypeError("Expected iterable or array-like: " + keyPath);
            iter = getIterator(Iterable(keyPath));
        }
        return iter;
    }
    createClass(Record, KeyedCollection);
    function Record(defaultValues, name) {
        var hasInitialized;
        var RecordType = function Record(values) {
            if (values instanceof RecordType) return values;
            if (!(this instanceof RecordType)) return new RecordType(values);
            if (!hasInitialized) {
                hasInitialized = true;
                var keys = Object.keys(defaultValues);
                setProps(RecordTypePrototype, keys);
                RecordTypePrototype.size = keys.length;
                RecordTypePrototype._name = name;
                RecordTypePrototype._keys = keys;
                RecordTypePrototype._defaultValues = defaultValues;
            }
            this._map = Map(values);
        };
        var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
        RecordTypePrototype.constructor = RecordType;
        return RecordType;
    }
    Record.prototype.toString = function() {
        return this.__toString(recordName(this) + " {", "}");
    };
    // @pragma Access
    Record.prototype.has = function(k) {
        return this._defaultValues.hasOwnProperty(k);
    };
    Record.prototype.get = function(k, notSetValue) {
        if (!this.has(k)) return notSetValue;
        var defaultVal = this._defaultValues[k];
        return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };
    // @pragma Modification
    Record.prototype.clear = function() {
        if (this.__ownerID) {
            this._map && this._map.clear();
            return this;
        }
        var RecordType = this.constructor;
        return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };
    Record.prototype.set = function(k, v) {
        if (!this.has(k)) throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
        if (this._map && !this._map.has(k)) {
            var defaultVal = this._defaultValues[k];
            if (v === defaultVal) return this;
        }
        var newMap = this._map && this._map.set(k, v);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.remove = function(k) {
        if (!this.has(k)) return this;
        var newMap = this._map && this._map.remove(k);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Record.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterator(type, reverse);
    };
    Record.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterate(fn, reverse);
    };
    Record.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map && this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return makeRecord(this, newMap, ownerID);
    };
    var RecordPrototype = Record.prototype;
    RecordPrototype[DELETE] = RecordPrototype.remove;
    RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
    RecordPrototype.merge = MapPrototype.merge;
    RecordPrototype.mergeWith = MapPrototype.mergeWith;
    RecordPrototype.mergeIn = MapPrototype.mergeIn;
    RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
    RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
    RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    RecordPrototype.setIn = MapPrototype.setIn;
    RecordPrototype.update = MapPrototype.update;
    RecordPrototype.updateIn = MapPrototype.updateIn;
    RecordPrototype.withMutations = MapPrototype.withMutations;
    RecordPrototype.asMutable = MapPrototype.asMutable;
    RecordPrototype.asImmutable = MapPrototype.asImmutable;
    function makeRecord(likeRecord, map, ownerID) {
        var record = Object.create(Object.getPrototypeOf(likeRecord));
        record._map = map;
        record.__ownerID = ownerID;
        return record;
    }
    function recordName(record) {
        return record._name || record.constructor.name || "Record";
    }
    function setProps(prototype, names) {
        try {
            names.forEach(setProp.bind(undefined, prototype));
        } catch (error) {
        // Object.defineProperty failed. Probably IE8.
        }
    }
    function setProp(prototype, name) {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, "Cannot set on an immutable record.");
                this.set(name, value);
            }
        });
    }
    createClass(Set, SetCollection);
    // @pragma Construction
    function Set(value) {
        return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    Set.of = function() {
        return this(arguments);
    };
    Set.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    Set.prototype.toString = function() {
        return this.__toString("Set {", "}");
    };
    // @pragma Access
    Set.prototype.has = function(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function(value) {
        return updateSet(this, this._map.set(value, true));
    };
    Set.prototype.remove = function(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.union = function() {
        var iters = SLICE$0.call(arguments, 0);
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)SetIterable(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (!iters.every(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (iters.some(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.merge = function() {
        return this.union.apply(this, arguments);
    };
    Set.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return this.union.apply(this, iters);
    };
    Set.prototype.sort = function(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._map.__iterate(function(_, k) {
            return fn(k, k, this$0);
        }, reverse);
    };
    Set.prototype.__iterator = function(type, reverse) {
        return this._map.map(function(_, k) {
            return k;
        }).__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    function isSet(maybeSet) {
        return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
    }
    Set.isSet = isSet;
    var IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@";
    var SetPrototype = Set.prototype;
    SetPrototype[IS_SET_SENTINEL] = true;
    SetPrototype[DELETE] = SetPrototype.remove;
    SetPrototype.mergeDeep = SetPrototype.merge;
    SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
    SetPrototype.withMutations = MapPrototype.withMutations;
    SetPrototype.asMutable = MapPrototype.asMutable;
    SetPrototype.asImmutable = MapPrototype.asImmutable;
    SetPrototype.__empty = emptySet;
    SetPrototype.__make = makeSet;
    function updateSet(set, newMap) {
        if (set.__ownerID) {
            set.size = newMap.size;
            set._map = newMap;
            return set;
        }
        return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
    }
    function makeSet(map, ownerID) {
        var set = Object.create(SetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_SET;
    function emptySet() {
        return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
    }
    createClass(OrderedSet, Set);
    // @pragma Construction
    function OrderedSet(value) {
        return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    OrderedSet.of = function() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    OrderedSet.prototype.toString = function() {
        return this.__toString("OrderedSet {", "}");
    };
    function isOrderedSet(maybeOrderedSet) {
        return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
    }
    OrderedSet.isOrderedSet = isOrderedSet;
    var OrderedSetPrototype = OrderedSet.prototype;
    OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
    OrderedSetPrototype.__empty = emptyOrderedSet;
    OrderedSetPrototype.__make = makeOrderedSet;
    function makeOrderedSet(map, ownerID) {
        var set = Object.create(OrderedSetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_ORDERED_SET;
    function emptyOrderedSet() {
        return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
    }
    createClass(Stack, IndexedCollection);
    // @pragma Construction
    function Stack(value) {
        return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
    }
    Stack.of = function() {
        return this(arguments);
    };
    Stack.prototype.toString = function() {
        return this.__toString("Stack [", "]");
    };
    // @pragma Access
    Stack.prototype.get = function(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function() {
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function(iter) {
        iter = IndexedIterable(iter);
        if (iter.size === 0) return this;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.reverse().forEach(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        });
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function() {
        return this.slice(1);
    };
    Stack.prototype.unshift = function() {
        return this.push.apply(this, arguments);
    };
    Stack.prototype.unshiftAll = function(iter) {
        return this.pushAll(iter);
    };
    Stack.prototype.shift = function() {
        return this.pop.apply(this, arguments);
    };
    Stack.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function(fn, reverse) {
        if (reverse) return this.reverse().__iterate(fn);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function(type, reverse) {
        if (reverse) return this.reverse().__iterator(type);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    function isStack(maybeStack) {
        return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
    }
    Stack.isStack = isStack;
    var IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@";
    var StackPrototype = Stack.prototype;
    StackPrototype[IS_STACK_SENTINEL] = true;
    StackPrototype.withMutations = MapPrototype.withMutations;
    StackPrototype.asMutable = MapPrototype.asMutable;
    StackPrototype.asImmutable = MapPrototype.asImmutable;
    StackPrototype.wasAltered = MapPrototype.wasAltered;
    function makeStack(size, head, ownerID, hash) {
        var map = Object.create(StackPrototype);
        map.size = size;
        map._head = head;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_STACK;
    function emptyStack() {
        return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
    }
    /**
   * Contributes additional methods to a constructor
   */ function mixin(ctor, methods) {
        var keyCopier = function(key) {
            ctor.prototype[key] = methods[key];
        };
        Object.keys(methods).forEach(keyCopier);
        Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
        return ctor;
    }
    Iterable.Iterator = Iterator;
    mixin(Iterable, {
        // ### Conversion to other types
        toArray: function() {
            assertNotInfinite(this.size);
            var array = new Array(this.size || 0);
            this.valueSeq().__iterate(function(v, i) {
                array[i] = v;
            });
            return array;
        },
        toIndexedSeq: function() {
            return new ToIndexedSequence(this);
        },
        toJS: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJS === "function" ? value.toJS() : value;
            }).__toJS();
        },
        toJSON: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJSON === "function" ? value.toJSON() : value;
            }).__toJS();
        },
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, true);
        },
        toMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return Map(this.toKeyedSeq());
        },
        toObject: function() {
            assertNotInfinite(this.size);
            var object = {};
            this.__iterate(function(v, k) {
                object[k] = v;
            });
            return object;
        },
        toOrderedMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedMap(this.toKeyedSeq());
        },
        toOrderedSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
        },
        toSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return Set(isKeyed(this) ? this.valueSeq() : this);
        },
        toSetSeq: function() {
            return new ToSetSequence(this);
        },
        toSeq: function() {
            return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function() {
            // Use Late Binding here to solve the circular dependency.
            return Stack(isKeyed(this) ? this.valueSeq() : this);
        },
        toList: function() {
            // Use Late Binding here to solve the circular dependency.
            return List(isKeyed(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties
        toString: function() {
            return "[Iterable]";
        },
        __toString: function(head, tail) {
            if (this.size === 0) return head + tail;
            return head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        concat: function() {
            var values = SLICE$0.call(arguments, 0);
            return reify(this, concatFactory(this, values));
        },
        includes: function(searchValue) {
            return this.some(function(value) {
                return is(value, searchValue);
            });
        },
        entries: function() {
            return this.__iterator(ITERATE_ENTRIES);
        },
        every: function(predicate, context) {
            assertNotInfinite(this.size);
            var returnValue = true;
            this.__iterate(function(v, k, c) {
                if (!predicate.call(context, v, k, c)) {
                    returnValue = false;
                    return false;
                }
            });
            return returnValue;
        },
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, true));
        },
        find: function(predicate, context, notSetValue) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[1] : notSetValue;
        },
        forEach: function(sideEffect, context) {
            assertNotInfinite(this.size);
            return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
        },
        join: function(separator) {
            assertNotInfinite(this.size);
            separator = separator !== undefined ? "" + separator : ",";
            var joined = "";
            var isFirst = true;
            this.__iterate(function(v) {
                isFirst ? isFirst = false : joined += separator;
                joined += v !== null && v !== undefined ? v.toString() : "";
            });
            return joined;
        },
        keys: function() {
            return this.__iterator(ITERATE_KEYS);
        },
        map: function(mapper, context) {
            return reify(this, mapFactory(this, mapper, context));
        },
        reduce: function(reducer, initialReduction, context) {
            assertNotInfinite(this.size);
            var reduction;
            var useFirst;
            if (arguments.length < 2) useFirst = true;
            else reduction = initialReduction;
            this.__iterate(function(v, k, c) {
                if (useFirst) {
                    useFirst = false;
                    reduction = v;
                } else reduction = reducer.call(context, reduction, v, k, c);
            });
            return reduction;
        },
        reduceRight: function(reducer, initialReduction, context) {
            var reversed = this.toKeyedSeq().reverse();
            return reversed.reduce.apply(reversed, arguments);
        },
        reverse: function() {
            return reify(this, reverseFactory(this, true));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, true));
        },
        some: function(predicate, context) {
            return !this.every(not(predicate), context);
        },
        sort: function(comparator) {
            return reify(this, sortFactory(this, comparator));
        },
        values: function() {
            return this.__iterator(ITERATE_VALUES);
        },
        // ### More sequential methods
        butLast: function() {
            return this.slice(0, -1);
        },
        isEmpty: function() {
            return this.size !== undefined ? this.size === 0 : !this.some(function() {
                return true;
            });
        },
        count: function(predicate, context) {
            return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
        },
        countBy: function(grouper, context) {
            return countByFactory(this, grouper, context);
        },
        equals: function(other) {
            return deepEqual(this, other);
        },
        entrySeq: function() {
            var iterable = this;
            if (iterable._cache) // We cache as an entries array, so we can just return the cache!
            return new ArraySeq(iterable._cache);
            var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
            entriesSequence.fromEntrySeq = function() {
                return iterable.toSeq();
            };
            return entriesSequence;
        },
        filterNot: function(predicate, context) {
            return this.filter(not(predicate), context);
        },
        findEntry: function(predicate, context, notSetValue) {
            var found = notSetValue;
            this.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    found = [
                        k,
                        v
                    ];
                    return false;
                }
            });
            return found;
        },
        findKey: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry && entry[0];
        },
        findLast: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
        },
        findLastEntry: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
        },
        findLastKey: function(predicate, context) {
            return this.toKeyedSeq().reverse().findKey(predicate, context);
        },
        first: function() {
            return this.find(returnTrue);
        },
        flatMap: function(mapper, context) {
            return reify(this, flatMapFactory(this, mapper, context));
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, true));
        },
        fromEntrySeq: function() {
            return new FromEntriesSequence(this);
        },
        get: function(searchKey, notSetValue) {
            return this.find(function(_, key) {
                return is(key, searchKey);
            }, undefined, notSetValue);
        },
        getIn: function(searchKeyPath, notSetValue) {
            var nested = this;
            // Note: in an ES6 environment, we would prefer:
            // for (var key of searchKeyPath) {
            var iter = forceIterator(searchKeyPath);
            var step;
            while(!(step = iter.next()).done){
                var key = step.value;
                nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
                if (nested === NOT_SET) return notSetValue;
            }
            return nested;
        },
        groupBy: function(grouper, context) {
            return groupByFactory(this, grouper, context);
        },
        has: function(searchKey) {
            return this.get(searchKey, NOT_SET) !== NOT_SET;
        },
        hasIn: function(searchKeyPath) {
            return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
        },
        isSubset: function(iter) {
            iter = typeof iter.includes === "function" ? iter : Iterable(iter);
            return this.every(function(value) {
                return iter.includes(value);
            });
        },
        isSuperset: function(iter) {
            iter = typeof iter.isSubset === "function" ? iter : Iterable(iter);
            return iter.isSubset(this);
        },
        keyOf: function(searchValue) {
            return this.findKey(function(value) {
                return is(value, searchValue);
            });
        },
        keySeq: function() {
            return this.toSeq().map(keyMapper).toIndexedSeq();
        },
        last: function() {
            return this.toSeq().reverse().first();
        },
        lastKeyOf: function(searchValue) {
            return this.toKeyedSeq().reverse().keyOf(searchValue);
        },
        max: function(comparator) {
            return maxFactory(this, comparator);
        },
        maxBy: function(mapper, comparator) {
            return maxFactory(this, comparator, mapper);
        },
        min: function(comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
        },
        minBy: function(mapper, comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
        },
        rest: function() {
            return this.slice(1);
        },
        skip: function(amount) {
            return this.slice(Math.max(0, amount));
        },
        skipLast: function(amount) {
            return reify(this, this.toSeq().reverse().skip(amount).reverse());
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, true));
        },
        skipUntil: function(predicate, context) {
            return this.skipWhile(not(predicate), context);
        },
        sortBy: function(mapper, comparator) {
            return reify(this, sortFactory(this, comparator, mapper));
        },
        take: function(amount) {
            return this.slice(0, Math.max(0, amount));
        },
        takeLast: function(amount) {
            return reify(this, this.toSeq().reverse().take(amount).reverse());
        },
        takeWhile: function(predicate, context) {
            return reify(this, takeWhileFactory(this, predicate, context));
        },
        takeUntil: function(predicate, context) {
            return this.takeWhile(not(predicate), context);
        },
        valueSeq: function() {
            return this.toIndexedSeq();
        },
        // ### Hashable Object
        hashCode: function() {
            return this.__hash || (this.__hash = hashIterable(this));
        }
    });
    // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
    var IterablePrototype = Iterable.prototype;
    IterablePrototype[IS_ITERABLE_SENTINEL] = true;
    IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
    IterablePrototype.__toJS = IterablePrototype.toArray;
    IterablePrototype.__toStringMapper = quoteString;
    IterablePrototype.inspect = IterablePrototype.toSource = function() {
        return this.toString();
    };
    IterablePrototype.chain = IterablePrototype.flatMap;
    IterablePrototype.contains = IterablePrototype.includes;
    mixin(KeyedIterable, {
        // ### More sequential methods
        flip: function() {
            return reify(this, flipFactory(this));
        },
        mapEntries: function(mapper, context) {
            var this$0 = this;
            var iterations = 0;
            return reify(this, this.toSeq().map(function(v, k) {
                return mapper.call(context, [
                    k,
                    v
                ], iterations++, this$0);
            }).fromEntrySeq());
        },
        mapKeys: function(mapper, context) {
            var this$0 = this;
            return reify(this, this.toSeq().flip().map(function(k, v) {
                return mapper.call(context, k, v, this$0);
            }).flip());
        }
    });
    var KeyedIterablePrototype = KeyedIterable.prototype;
    KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
    KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
    KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
    KeyedIterablePrototype.__toStringMapper = function(v, k) {
        return JSON.stringify(k) + ": " + quoteString(v);
    };
    mixin(IndexedIterable, {
        // ### Conversion to other types
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, false);
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, false));
        },
        findIndex: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        indexOf: function(searchValue) {
            var key = this.keyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        lastIndexOf: function(searchValue) {
            var key = this.lastKeyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        reverse: function() {
            return reify(this, reverseFactory(this, false));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, false));
        },
        splice: function(index, removeNum /*, ...values*/ ) {
            var numArgs = arguments.length;
            removeNum = Math.max(removeNum | 0, 0);
            if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
            // If index is negative, it should resolve relative to the size of the
            // collection. However size may be expensive to compute if not cached, so
            // only call count() if the number is in fact negative.
            index = resolveBegin(index, index < 0 ? this.count() : this.size);
            var spliced = this.slice(0, index);
            return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
        },
        // ### More collection methods
        findLastIndex: function(predicate, context) {
            var entry = this.findLastEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        first: function() {
            return this.get(0);
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, false));
        },
        get: function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
                return key === index;
            }, undefined, notSetValue);
        },
        has: function(index) {
            index = wrapIndex(this, index);
            return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
        },
        interpose: function(separator) {
            return reify(this, interposeFactory(this, separator));
        },
        interleave: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
            var interleaved = zipped.flatten(true);
            if (zipped.size) interleaved.size = zipped.size * iterables.length;
            return reify(this, interleaved);
        },
        keySeq: function() {
            return Range(0, this.size);
        },
        last: function() {
            return this.get(-1);
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, false));
        },
        zip: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            return reify(this, zipWithFactory(this, defaultZipper, iterables));
        },
        zipWith: function(zipper /*, ...iterables */ ) {
            var iterables = arrCopy(arguments);
            iterables[0] = this;
            return reify(this, zipWithFactory(this, zipper, iterables));
        }
    });
    IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
    IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
    mixin(SetIterable, {
        // ### ES6 Collection methods (ES6 Array and Map)
        get: function(value, notSetValue) {
            return this.has(value) ? value : notSetValue;
        },
        includes: function(value) {
            return this.has(value);
        },
        // ### More sequential methods
        keySeq: function() {
            return this.valueSeq();
        }
    });
    SetIterable.prototype.has = IterablePrototype.includes;
    SetIterable.prototype.contains = SetIterable.prototype.includes;
    // Mixin subclasses
    mixin(KeyedSeq, KeyedIterable.prototype);
    mixin(IndexedSeq, IndexedIterable.prototype);
    mixin(SetSeq, SetIterable.prototype);
    mixin(KeyedCollection, KeyedIterable.prototype);
    mixin(IndexedCollection, IndexedIterable.prototype);
    mixin(SetCollection, SetIterable.prototype);
    // #pragma Helper functions
    function keyMapper(v, k) {
        return k;
    }
    function entryMapper(v, k) {
        return [
            k,
            v
        ];
    }
    function not(predicate) {
        return function() {
            return !predicate.apply(this, arguments);
        };
    }
    function neg(predicate) {
        return function() {
            return -predicate.apply(this, arguments);
        };
    }
    function quoteString(value) {
        return typeof value === "string" ? JSON.stringify(value) : String(value);
    }
    function defaultZipper() {
        return arrCopy(arguments);
    }
    function defaultNegComparator(a, b) {
        return a < b ? 1 : a > b ? -1 : 0;
    }
    function hashIterable(iterable) {
        if (iterable.size === Infinity) return 0;
        var ordered = isOrdered(iterable);
        var keyed = isKeyed(iterable);
        var h = ordered ? 1 : 0;
        var size = iterable.__iterate(keyed ? ordered ? function(v, k) {
            h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
        } : function(v, k) {
            h = h + hashMerge(hash(v), hash(k)) | 0;
        } : ordered ? function(v) {
            h = 31 * h + hash(v) | 0;
        } : function(v) {
            h = h + hash(v) | 0;
        });
        return murmurHashOfSize(size, h);
    }
    function murmurHashOfSize(size, h) {
        h = imul(h, 0xCC9E2D51);
        h = imul(h << 15 | h >>> -15, 0x1B873593);
        h = imul(h << 13 | h >>> -13, 5);
        h = (h + 0xE6546B64 | 0) ^ size;
        h = imul(h ^ h >>> 16, 0x85EBCA6B);
        h = imul(h ^ h >>> 13, 0xC2B2AE35);
        h = smi(h ^ h >>> 16);
        return h;
    }
    function hashMerge(a, b) {
        return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
    }
    var Immutable = {
        Iterable: Iterable,
        Seq: Seq,
        Collection: Collection,
        Map: Map,
        OrderedMap: OrderedMap,
        List: List,
        Stack: Stack,
        Set: Set,
        OrderedSet: OrderedSet,
        Record: Record,
        Range: Range,
        Repeat: Repeat,
        is: is,
        fromJS: fromJS
    };
    return Immutable;
});

});

parcelRegister("S29Lp", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0a26b77df7b11603$var$ReactIs, $0a26b77df7b11603$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("4VWv0"))();

});
parcelRegister("4VWv0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $lX6wt = parcelRequire("lX6wt");
function $3979dcfe1902cf77$var$emptyFunction() {}
function $3979dcfe1902cf77$var$emptyFunctionWithReset() {}
$3979dcfe1902cf77$var$emptyFunctionWithReset.resetWarningCache = $3979dcfe1902cf77$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lX6wt) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $3979dcfe1902cf77$var$emptyFunctionWithReset,
        resetWarningCache: $3979dcfe1902cf77$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lX6wt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $ffb42aee938fc27c$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $ffb42aee938fc27c$var$ReactPropTypesSecret;

});





parcelRegister("2Tkhn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21b072e02f948494$export$2e2bcd8739ae039; });

var $RSSjA = parcelRequire("RSSjA");

parcelRequire("7PdBe");

var $5tIfX = parcelRequire("5tIfX");

var $j4R7e = parcelRequire("j4R7e");

var $gDVAs = parcelRequire("gDVAs");

var $ieAuE = parcelRequire("ieAuE");

var $fSXDi = parcelRequire("fSXDi");

var $7jYVK = parcelRequire("7jYVK");

var $fycIx = parcelRequire("fycIx");

var $k1Sse = parcelRequire("k1Sse");

var $6M6SV = parcelRequire("6M6SV");

var $jT3Jc = parcelRequire("jT3Jc");

var $899M7 = parcelRequire("899M7");

var $1reg7 = parcelRequire("1reg7");

var $1xiEk = parcelRequire("1xiEk");
var $21b072e02f948494$export$2e2bcd8739ae039 = {
    text: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $1reg7.default), {
            value: value,
            isEditable: editable,
            className: "coincraft-table-cell__input coincraft-table-cell__text",
            onChange: (v)=>onChange(v),
            isvalid: validator,
            ...props
        }),
    textarea: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)("textarea", {
            rows: 2,
            value: value,
            disabled: !editable,
            className: "coincraft-table-cell__textarea",
            onChange: (e)=>onChange(e.target.value),
            style: {
                padding: "1em"
            },
            ...props
        }),
    number: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $1reg7.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $gDVAs.FormatNumber),
            parser: (0, $ieAuE.ParseNumber),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right"
            },
            ...props
        }),
    currency: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $1reg7.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $5tIfX.FormatCurrency),
            parser: (0, $j4R7e.ParseCurrency),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right"
            },
            ...props
        }),
    percent: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $1reg7.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $fSXDi.FormatPercent),
            parser: (0, $7jYVK.ParsePercent),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right"
            },
            ...props
        }),
    progress: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $1reg7.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $fSXDi.FormatPercent),
            parser: (0, $7jYVK.ParsePercent),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right"
            },
            ...props
        }),
    progressBar: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $1reg7.default), {
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            value: value,
            formatter: (0, $fSXDi.FormatPercent),
            parser: (0, $7jYVK.ParsePercent),
            isEditable: editable,
            onChange: onChange,
            isValid: validator,
            style: {
                textAlign: "right"
            },
            ...props
        }),
    date: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $899M7.default), {
            isvalid: validator,
            value: value,
            isEditable: editable,
            onChange: onChange,
            ...props
        }),
    duration: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)($21b072e02f948494$var$DurationInput, {
            value: value,
            isEditable: editable,
            className: "coincraft-table-cell__input coincraft-table-cell__duration",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    checkbox: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $jT3Jc.default), {
            value: value,
            isEditable: editable,
            className: "coincraft-table-cell__checkbox",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    button: ({ value: value, editable: editable, onChange: onChange, onClick: onClick, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)("button", {
            disabled: editable === false,
            className: "coincraft-table-cell__button",
            onClick: onClick,
            style: {
                ...props.style,
                ...editable === false ? {
                    opacity: 0.75
                } : {}
            },
            ...props,
            children: value
        }),
    boolean: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.BooleanSelector), {
            selectedOption: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__bool",
            onChange: onChange,
            isvalid: validator
        }),
    project: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.ProjectSelector), {
            selectedProject: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__phase",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    phase: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.PhaseSelector), {
            selectedPhase: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__phase",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    task: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.TaskSelector), {
            selectedTask: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__task",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    contact: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.ContactSelector), {
            selectedContact: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__contact",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    costCentre: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>{
        return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.CostCentreSelector), {
            selectedCostCentre: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__contact",
            onChange: onChange,
            isvalid: validator,
            ...props
        });
    },
    staffMember: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.StaffSelector), {
            selectedStaffOrRole: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    staff: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.StaffSelector), {
            selectedStaffOrRole: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    role: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.RoleSelector), {
            selectedStaffOrRole: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    staffOrRole: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.StaffOrRoleSelector), {
            selectedStaffOrRole: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staffOrRole",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    status: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.StatusSelector), {
            selectedStatus: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__status",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    statuses: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.StatusMultiselect), {
            selectedStatuses: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__status",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    projects: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.ProjectMultiselect), {
            selectedProjects: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__phase",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    phases: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.PhaseMultiselect), {
            selectedPhases: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__phase",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    tasks: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.TaskMultiselect), {
            selectedTasks: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__task",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    contacts: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.ContactMultiselect), {
            selectedContacts: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__contact",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    costCentres: ({ value: value, editable: editable, onChange: onChange, onClick: onClick, validator: validator, ...props })=>{
        return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.CostCentreMultiselect), {
            selectedCostCentres: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__contact",
            onChange: onChange,
            isvalid: validator,
            ...props
        });
    },
    staffs: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.StaffMultiselect), {
            selectedStaffMembers: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    staffMembers: ({ value: value, editable: editable, onChange: onChange, onClick: onClick, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.StaffMultiselect), {
            selectedStaffMembers: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    roles: ({ value: value, editable: editable, onChange: onChange, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $k1Sse.RoleMultiselect), {
            selectedRoles: value,
            isEditable: editable,
            className: "coincraft-table-cell__dropdown coincraft-table-cell__staff",
            onChange: onChange,
            isvalid: validator,
            ...props
        }),
    durationMinutes: ({ value: value, editable: editable, onChange: onChange, onClick: onClick, validator: validator, ...props })=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $1xiEk.HoursInput), {
            value: value,
            isEditable: editable,
            className: "coincraft-table-cell__input coincraft-table-cell__currency",
            onChange: onChange,
            isvalid: validator,
            ...props
        })
};
const $21b072e02f948494$var$DurationInput = ({ value: value, isEditable: isEditable, onChange: onChange, isvalid: isvalid, className: className, ...props })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        ...props,
        style: {
            width: "100%"
        },
        className: `flex ${className}`,
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                className: "coincraft-table-cell coincraft-table-cell--text",
                style: {
                    width: "40%"
                },
                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $fycIx.NumberInputContainer), {
                    className: "coincraft-table-cell__text",
                    value: (0, $gDVAs.FormatNumber)(value.value, {
                        decimals: 2
                    }),
                    isEditable: isEditable,
                    onChange: (value)=>onChange({
                            value: value
                        })
                })
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                className: "coincraft-table-cell coincraft-table-cell--dropdown",
                style: {
                    width: "60%"
                },
                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $6M6SV.Selector), {
                    selectedOption: value.unit || "days",
                    onChange: (unit)=>onChange({
                            unit: unit
                        }),
                    options: [
                        "days",
                        "weeks",
                        "months"
                    ],
                    optionLabel: (o)=>o
                })
            })
        ]
    });
};

});
parcelRegister("j4R7e", function(module, exports) {

$parcel$export(module.exports, "ParseCurrency", function () { return $de3797b4e75cf32e$export$37c7b4632bbb0536; });



var $5UCsG = parcelRequire("5UCsG");

var $5bGlM = parcelRequire("5bGlM");

var $5uSSv = parcelRequire("5uSSv");

var $hPhGC = parcelRequire("hPhGC");

var $kj5AX = parcelRequire("kj5AX");
const $de3797b4e75cf32e$export$37c7b4632bbb0536 = (valueString, { currency: currency = (0, (/*@__PURE__*/$parcel$interopDefault($5UCsG))).getCurrency((0, (/*@__PURE__*/$parcel$interopDefault($5bGlM))).findCountryLocales((0, $hPhGC.constantCase)(((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) || "us"))[0]) } = {})=>{
    if ([
        null,
        undefined,
        ""
    ].includes(valueString)) return valueString;
    try {
        const noSymbols = valueString.replace(/,/g, "").replace(/\p{Sc}/gu, "");
        return (0, $kj5AX.evaluate)(noSymbols);
    } catch (e) {
        //if math.eval fails just pass string
        return valueString;
    }
// currency = 'AUD'
// const parser = new NumberParser(
//     isoLangCodes.findCountryLocales(
//         constantCase(SessionStore?.organisationCountry || 'us')
//     )[0],
//     {
//         style: 'currency',
//         currency: currency || 'USD',
//     }
// )
// return parser.parse(String(valueString))
};

});
parcelRegister("kj5AX", function(module, exports) {

$parcel$export(module.exports, "evaluate", function () { return $ec89ec0f349160f3$export$fef61f332f2c0afc; });

var $59Cgo = parcelRequire("59Cgo");

var $gkMIT = parcelRequire("gkMIT");
var $l71lI = parcelRequire("l71lI");
var $7SwSH = parcelRequire("7SwSH");
var $eZkkP = parcelRequire("eZkkP");
var $32UmN = parcelRequire("32UmN");
var $iUOTF = parcelRequire("iUOTF");
var $jcdgW = parcelRequire("jcdgW");
var $jQHb3 = parcelRequire("jQHb3");
var $f8efk = parcelRequire("f8efk");
var $jbnea = parcelRequire("jbnea");
var $3wHud = parcelRequire("3wHud");
var $3reAA = parcelRequire("3reAA");
var $5Wo7R = parcelRequire("5Wo7R");
var $5bQtu = parcelRequire("5bQtu");
var $4QA7C = parcelRequire("4QA7C");
var $gfkt3 = parcelRequire("gfkt3");
var $4jb1x = parcelRequire("4jb1x");
var $eeLk7 = parcelRequire("eeLk7");
var $i35zk = parcelRequire("i35zk");
var $9gllx = parcelRequire("9gllx");
var $jSahI = parcelRequire("jSahI");
var $4BXEH = parcelRequire("4BXEH");
var $iGg9x = parcelRequire("iGg9x");
var $2ElSv = parcelRequire("2ElSv");
var $cJZSS = parcelRequire("cJZSS");
var $8Y3TH = parcelRequire("8Y3TH");
var $ecPwy = parcelRequire("ecPwy");
var $ecsls = parcelRequire("ecsls");
var $d4OJw = parcelRequire("d4OJw");
var $bx6n0 = parcelRequire("bx6n0");
var $gQJls = parcelRequire("gQJls");
var $cCL9g = parcelRequire("cCL9g");
var $GJUrb = parcelRequire("GJUrb");
var $lJhsM = parcelRequire("lJhsM");
var $a5N99 = parcelRequire("a5N99");
var $dOa4M = parcelRequire("dOa4M");
var $jTYlf = parcelRequire("jTYlf");
var $kFH0X = parcelRequire("kFH0X");
var $6oWVY = parcelRequire("6oWVY");
var $6lZEL = parcelRequire("6lZEL");
var $62vSW = parcelRequire("62vSW");
var $28Imc = parcelRequire("28Imc");
var $1KTTV = parcelRequire("1KTTV");
var $8IaCc = parcelRequire("8IaCc");
var $g0yJb = parcelRequire("g0yJb");

var $lb8Oa = parcelRequire("lb8Oa");

function $ec89ec0f349160f3$var$_extends() {
    $ec89ec0f349160f3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ec89ec0f349160f3$var$_extends.apply(this, arguments);
}
var $ec89ec0f349160f3$var$math = {}; // NOT pure!
var $ec89ec0f349160f3$var$mathWithTransform = {}; // NOT pure!
var $ec89ec0f349160f3$var$classes = {}; // NOT pure!
var $ec89ec0f349160f3$export$85c928794f8d04d4 = (0, $ecPwy.createNode)({
    mathWithTransform: $ec89ec0f349160f3$var$mathWithTransform
});
var $ec89ec0f349160f3$export$97d96bf9b84874d5 = (0, $7SwSH.createArrayNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4
});
var $ec89ec0f349160f3$export$ec7b1e3e36733ff3 = (0, $32UmN.createBlockNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4,
    ResultSet: (0, $lb8Oa.ResultSet)
});
var $ec89ec0f349160f3$export$3166e8715d58cf9a = (0, $3reAA.createConstantNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4
});
var $ec89ec0f349160f3$export$b70fa93b5fbdd997 = (0, $ecsls.createObjectNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4
});
var $ec89ec0f349160f3$export$dbdb6279b6a3bac9 = (0, $bx6n0.createParenthesisNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4
});
var $ec89ec0f349160f3$export$a4d9a8de1ded3461 = (0, $jTYlf.createRelationalNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4
});
var $ec89ec0f349160f3$export$f18d5acc27d70423 = (0, $jcdgW.createChainClass)({
    math: $ec89ec0f349160f3$var$math
});
var $ec89ec0f349160f3$export$63698c10df99509c = (0, $kFH0X.createReviver)({
    classes: $ec89ec0f349160f3$var$classes
});
var $ec89ec0f349160f3$export$8e402c64e6081013 = (0, $3wHud.createConditionalNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4
});
var $ec89ec0f349160f3$export$cd498840ad265e90 = (0, $d4OJw.createOperatorNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4
});
var $ec89ec0f349160f3$export$d0e9917d83c120a0 = (0, $lJhsM.createRangeNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4
});
var $ec89ec0f349160f3$export$446a68c3fb943f17 = (0, $4jb1x.createFunctionAssignmentNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4,
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$e08e3b67e392101e = (0, $iUOTF.createChain)({
    Chain: $ec89ec0f349160f3$export$f18d5acc27d70423,
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$c3248ebc7ade74c5 = (0, $gkMIT.createAccessorNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4,
    subset: (0, $lb8Oa.subset)
});
var $ec89ec0f349160f3$export$929eaad981940a63 = (0, $jSahI.createIndexNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4,
    Range: (0, $lb8Oa.Range),
    size: (0, $lb8Oa.size)
});
var $ec89ec0f349160f3$export$a144098e31f7b52f = (0, $eZkkP.createAssignmentNode)({
    matrix: (0, $lb8Oa.matrix),
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4,
    subset: (0, $lb8Oa.subset)
});
var $ec89ec0f349160f3$export$93b6424aaa42dda7 = (0, $8IaCc.createSymbolNode)({
    Unit: (0, $lb8Oa.Unit),
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4,
    math: $ec89ec0f349160f3$var$math
});
var $ec89ec0f349160f3$export$f2972be796679c12 = (0, $eeLk7.createFunctionNode)({
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4,
    SymbolNode: $ec89ec0f349160f3$export$93b6424aaa42dda7,
    math: $ec89ec0f349160f3$var$math
});
var $ec89ec0f349160f3$export$98e6a39c04603d36 = (0, $gQJls.createParse)({
    AccessorNode: $ec89ec0f349160f3$export$c3248ebc7ade74c5,
    ArrayNode: $ec89ec0f349160f3$export$97d96bf9b84874d5,
    AssignmentNode: $ec89ec0f349160f3$export$a144098e31f7b52f,
    BlockNode: $ec89ec0f349160f3$export$ec7b1e3e36733ff3,
    ConditionalNode: $ec89ec0f349160f3$export$8e402c64e6081013,
    ConstantNode: $ec89ec0f349160f3$export$3166e8715d58cf9a,
    FunctionAssignmentNode: $ec89ec0f349160f3$export$446a68c3fb943f17,
    FunctionNode: $ec89ec0f349160f3$export$f2972be796679c12,
    IndexNode: $ec89ec0f349160f3$export$929eaad981940a63,
    ObjectNode: $ec89ec0f349160f3$export$b70fa93b5fbdd997,
    OperatorNode: $ec89ec0f349160f3$export$cd498840ad265e90,
    ParenthesisNode: $ec89ec0f349160f3$export$dbdb6279b6a3bac9,
    RangeNode: $ec89ec0f349160f3$export$d0e9917d83c120a0,
    RelationalNode: $ec89ec0f349160f3$export$a4d9a8de1ded3461,
    SymbolNode: $ec89ec0f349160f3$export$93b6424aaa42dda7,
    config: (0, $59Cgo.config),
    numeric: (0, $lb8Oa.numeric),
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$fef61f332f2c0afc = (0, $5bQtu.createEvaluate)({
    parse: $ec89ec0f349160f3$export$98e6a39c04603d36,
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$7acfa6ed01010e37 = (0, $GJUrb.createParserClass)({
    parse: $ec89ec0f349160f3$export$98e6a39c04603d36
});
var $ec89ec0f349160f3$export$1be7516c0280bee8 = (0, $9gllx.createHelpClass)({
    parse: $ec89ec0f349160f3$export$98e6a39c04603d36
});
var $ec89ec0f349160f3$export$ef7acd7185315e22 = (0, $f8efk.createCompile)({
    parse: $ec89ec0f349160f3$export$98e6a39c04603d36,
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$8f49e4af10703ce3 = (0, $cCL9g.createParser)({
    Parser: $ec89ec0f349160f3$export$7acfa6ed01010e37,
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$798b53621063651 = (0, $6lZEL.createSimplify)({
    bignumber: (0, $lb8Oa.bignumber),
    fraction: (0, $lb8Oa.fraction),
    ConstantNode: $ec89ec0f349160f3$export$3166e8715d58cf9a,
    FunctionNode: $ec89ec0f349160f3$export$f2972be796679c12,
    OperatorNode: $ec89ec0f349160f3$export$cd498840ad265e90,
    ParenthesisNode: $ec89ec0f349160f3$export$dbdb6279b6a3bac9,
    SymbolNode: $ec89ec0f349160f3$export$93b6424aaa42dda7,
    add: (0, $lb8Oa.add),
    config: (0, $59Cgo.config),
    divide: (0, $lb8Oa.divide),
    equal: (0, $lb8Oa.equal),
    isZero: (0, $lb8Oa.isZero),
    mathWithTransform: $ec89ec0f349160f3$var$mathWithTransform,
    multiply: (0, $lb8Oa.multiply),
    parse: $ec89ec0f349160f3$export$98e6a39c04603d36,
    pow: (0, $lb8Oa.pow),
    subtract: (0, $lb8Oa.subtract),
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$725d762cc154d53 = (0, $dOa4M.createRationalize)({
    bignumber: (0, $lb8Oa.bignumber),
    fraction: (0, $lb8Oa.fraction),
    ConstantNode: $ec89ec0f349160f3$export$3166e8715d58cf9a,
    FunctionNode: $ec89ec0f349160f3$export$f2972be796679c12,
    OperatorNode: $ec89ec0f349160f3$export$cd498840ad265e90,
    ParenthesisNode: $ec89ec0f349160f3$export$dbdb6279b6a3bac9,
    SymbolNode: $ec89ec0f349160f3$export$93b6424aaa42dda7,
    add: (0, $lb8Oa.add),
    config: (0, $59Cgo.config),
    divide: (0, $lb8Oa.divide),
    equal: (0, $lb8Oa.equal),
    isZero: (0, $lb8Oa.isZero),
    mathWithTransform: $ec89ec0f349160f3$var$mathWithTransform,
    multiply: (0, $lb8Oa.multiply),
    parse: $ec89ec0f349160f3$export$98e6a39c04603d36,
    pow: (0, $lb8Oa.pow),
    simplify: $ec89ec0f349160f3$export$798b53621063651,
    subtract: (0, $lb8Oa.subtract),
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$34512e3b2db52a4e = (0, $i35zk.createHelp)({
    Help: $ec89ec0f349160f3$export$1be7516c0280bee8,
    mathWithTransform: $ec89ec0f349160f3$var$mathWithTransform,
    typed: (0, $lb8Oa.typed)
});
var $ec89ec0f349160f3$export$42645bbd8ddfc464 = (0, $5Wo7R.createDerivative)({
    ConstantNode: $ec89ec0f349160f3$export$3166e8715d58cf9a,
    FunctionNode: $ec89ec0f349160f3$export$f2972be796679c12,
    OperatorNode: $ec89ec0f349160f3$export$cd498840ad265e90,
    ParenthesisNode: $ec89ec0f349160f3$export$dbdb6279b6a3bac9,
    SymbolNode: $ec89ec0f349160f3$export$93b6424aaa42dda7,
    config: (0, $59Cgo.config),
    equal: (0, $lb8Oa.equal),
    isZero: (0, $lb8Oa.isZero),
    numeric: (0, $lb8Oa.numeric),
    parse: $ec89ec0f349160f3$export$98e6a39c04603d36,
    simplify: $ec89ec0f349160f3$export$798b53621063651,
    typed: (0, $lb8Oa.typed)
});
$ec89ec0f349160f3$var$_extends($ec89ec0f349160f3$var$math, {
    "typeof": (0, $lb8Oa.typeOf),
    eye: (0, $lb8Oa.eye),
    reviver: $ec89ec0f349160f3$export$63698c10df99509c,
    "false": (0, $lb8Oa._false),
    "null": (0, $lb8Oa._null),
    "true": (0, $lb8Oa._true),
    replacer: (0, $lb8Oa.replacer),
    i: (0, $lb8Oa.i),
    LN10: (0, $lb8Oa.LN10),
    LOG10E: (0, $lb8Oa.LOG10E),
    NaN: (0, $lb8Oa._NaN),
    pi: (0, $lb8Oa.pi),
    SQRT1_2: (0, $lb8Oa.SQRT1_2),
    tau: (0, $lb8Oa.tau),
    efimovFactor: (0, $lb8Oa.efimovFactor),
    fineStructure: (0, $lb8Oa.fineStructure),
    sackurTetrode: (0, $lb8Oa.sackurTetrode),
    weakMixingAngle: (0, $lb8Oa.weakMixingAngle),
    e: (0, $lb8Oa.e),
    Infinity: (0, $lb8Oa._Infinity),
    LOG2E: (0, $lb8Oa.LOG2E),
    "PI": (0, $lb8Oa.pi),
    version: (0, $lb8Oa.version),
    "E": (0, $lb8Oa.e),
    phi: (0, $lb8Oa.phi),
    typed: (0, $lb8Oa.typed),
    isInteger: (0, $lb8Oa.isInteger),
    isNumeric: (0, $lb8Oa.isNumeric),
    isPositive: (0, $lb8Oa.isPositive),
    isNaN: (0, $lb8Oa.isNaN),
    equalScalar: (0, $lb8Oa.equalScalar),
    number: (0, $lb8Oa.number),
    "boolean": (0, $lb8Oa.boolean),
    complex: (0, $lb8Oa.complex),
    splitUnit: (0, $lb8Oa.splitUnit),
    unaryPlus: (0, $lb8Oa.unaryPlus),
    apply: (0, $lb8Oa.apply),
    cube: (0, $lb8Oa.cube),
    expm1: (0, $lb8Oa.expm1),
    log10: (0, $lb8Oa.log10),
    multiplyScalar: (0, $lb8Oa.multiplyScalar),
    sign: (0, $lb8Oa.sign),
    square: (0, $lb8Oa.square),
    bitNot: (0, $lb8Oa.bitNot),
    arg: (0, $lb8Oa.arg),
    im: (0, $lb8Oa.im),
    not: (0, $lb8Oa.not),
    filter: (0, $lb8Oa.filter),
    forEach: (0, $lb8Oa.forEach),
    map: (0, $lb8Oa.map),
    erf: (0, $lb8Oa.erf),
    format: (0, $lb8Oa.format),
    isPrime: (0, $lb8Oa.isPrime),
    acos: (0, $lb8Oa.acos),
    acot: (0, $lb8Oa.acot),
    acsc: (0, $lb8Oa.acsc),
    asec: (0, $lb8Oa.asec),
    asin: (0, $lb8Oa.asin),
    atan: (0, $lb8Oa.atan),
    atanh: (0, $lb8Oa.atanh),
    cosh: (0, $lb8Oa.cosh),
    coth: (0, $lb8Oa.coth),
    csch: (0, $lb8Oa.csch),
    sech: (0, $lb8Oa.sech),
    sinh: (0, $lb8Oa.sinh),
    tanh: (0, $lb8Oa.tanh),
    chain: $ec89ec0f349160f3$export$e08e3b67e392101e,
    combinations: (0, $lb8Oa.combinations),
    pickRandom: (0, $lb8Oa.pickRandom),
    randomInt: (0, $lb8Oa.randomInt),
    LN2: (0, $lb8Oa.LN2),
    clone: (0, $lb8Oa.clone),
    hasNumericValue: (0, $lb8Oa.hasNumericValue),
    typeOf: (0, $lb8Oa.typeOf),
    string: (0, $lb8Oa.string),
    fraction: (0, $lb8Oa.fraction),
    unaryMinus: (0, $lb8Oa.unaryMinus),
    addScalar: (0, $lb8Oa.addScalar),
    exp: (0, $lb8Oa.exp),
    log2: (0, $lb8Oa.log2),
    sqrt: (0, $lb8Oa.sqrt),
    conj: (0, $lb8Oa.conj),
    getMatrixDataType: (0, $lb8Oa.getMatrixDataType),
    mode: (0, $lb8Oa.mode),
    print: (0, $lb8Oa.print),
    acosh: (0, $lb8Oa.acosh),
    acsch: (0, $lb8Oa.acsch),
    asinh: (0, $lb8Oa.asinh),
    cos: (0, $lb8Oa.cos),
    csc: (0, $lb8Oa.csc),
    sin: (0, $lb8Oa.sin),
    combinationsWithRep: (0, $lb8Oa.combinationsWithRep),
    random: (0, $lb8Oa.random),
    SQRT2: (0, $lb8Oa.SQRT2),
    isNegative: (0, $lb8Oa.isNegative),
    matrix: (0, $lb8Oa.matrix),
    cbrt: (0, $lb8Oa.cbrt),
    gcd: (0, $lb8Oa.gcd),
    mod: (0, $lb8Oa.mod),
    nthRoot: (0, $lb8Oa.nthRoot),
    xgcd: (0, $lb8Oa.xgcd),
    bitAnd: (0, $lb8Oa.bitAnd),
    bitXor: (0, $lb8Oa.bitXor),
    or: (0, $lb8Oa.or),
    concat: (0, $lb8Oa.concat),
    diag: (0, $lb8Oa.diag),
    identity: (0, $lb8Oa.identity),
    ones: (0, $lb8Oa.ones),
    reshape: (0, $lb8Oa.reshape),
    size: (0, $lb8Oa.size),
    subset: (0, $lb8Oa.subset),
    zeros: (0, $lb8Oa.zeros),
    to: (0, $lb8Oa.to),
    round: (0, $lb8Oa.round),
    leftShift: (0, $lb8Oa.leftShift),
    rightLogShift: (0, $lb8Oa.rightLogShift),
    compare: (0, $lb8Oa.compare),
    compareText: (0, $lb8Oa.compareText),
    smaller: (0, $lb8Oa.smaller),
    larger: (0, $lb8Oa.larger),
    unequal: (0, $lb8Oa.unequal),
    max: (0, $lb8Oa.max),
    sparse: (0, $lb8Oa.sparse),
    acoth: (0, $lb8Oa.acoth),
    atan2: (0, $lb8Oa.atan2),
    sec: (0, $lb8Oa.sec),
    add: (0, $lb8Oa.add),
    trace: (0, $lb8Oa.trace),
    composition: (0, $lb8Oa.composition),
    isZero: (0, $lb8Oa.isZero),
    abs: (0, $lb8Oa.abs),
    floor: (0, $lb8Oa.floor),
    multiply: (0, $lb8Oa.multiply),
    dotMultiply: (0, $lb8Oa.dotMultiply),
    re: (0, $lb8Oa.re),
    flatten: (0, $lb8Oa.flatten),
    resize: (0, $lb8Oa.resize),
    squeeze: (0, $lb8Oa.squeeze),
    prod: (0, $lb8Oa.prod),
    pow: (0, $lb8Oa.pow),
    dotPow: (0, $lb8Oa.dotPow),
    rightArithShift: (0, $lb8Oa.rightArithShift),
    compareNatural: (0, $lb8Oa.compareNatural),
    equalText: (0, $lb8Oa.equalText),
    largerEq: (0, $lb8Oa.largerEq),
    partitionSelect: (0, $lb8Oa.partitionSelect),
    min: (0, $lb8Oa.min),
    asech: (0, $lb8Oa.asech),
    tan: (0, $lb8Oa.tan),
    setSize: (0, $lb8Oa.setSize),
    norm: (0, $lb8Oa.norm),
    quantileSeq: (0, $lb8Oa.quantileSeq),
    gamma: (0, $lb8Oa.gamma),
    bignumber: (0, $lb8Oa.bignumber),
    lcm: (0, $lb8Oa.lcm),
    bitOr: (0, $lb8Oa.bitOr),
    kron: (0, $lb8Oa.kron),
    transpose: (0, $lb8Oa.transpose),
    numeric: (0, $lb8Oa.numeric),
    and: (0, $lb8Oa.and),
    smallerEq: (0, $lb8Oa.smallerEq),
    sort: (0, $lb8Oa.sort),
    cot: (0, $lb8Oa.cot),
    dot: (0, $lb8Oa.dot),
    sum: (0, $lb8Oa.sum),
    factorial: (0, $lb8Oa.factorial),
    permutations: (0, $lb8Oa.permutations),
    ceil: (0, $lb8Oa.ceil),
    subtract: (0, $lb8Oa.subtract),
    cross: (0, $lb8Oa.cross),
    ctranspose: (0, $lb8Oa.ctranspose),
    equal: (0, $lb8Oa.equal),
    setCartesian: (0, $lb8Oa.setCartesian),
    setDistinct: (0, $lb8Oa.setDistinct),
    setIsSubset: (0, $lb8Oa.setIsSubset),
    setPowerset: (0, $lb8Oa.setPowerset),
    index: (0, $lb8Oa.index),
    fix: (0, $lb8Oa.fix),
    range: (0, $lb8Oa.range),
    divideScalar: (0, $lb8Oa.divideScalar),
    nthRoots: (0, $lb8Oa.nthRoots),
    lsolve: (0, $lb8Oa.lsolve),
    deepEqual: (0, $lb8Oa.deepEqual),
    setDifference: (0, $lb8Oa.setDifference),
    setMultiplicity: (0, $lb8Oa.setMultiplicity),
    hypot: (0, $lb8Oa.hypot),
    lup: (0, $lb8Oa.lup),
    slu: (0, $lb8Oa.slu),
    det: (0, $lb8Oa.det),
    distance: (0, $lb8Oa.distance),
    stirlingS2: (0, $lb8Oa.stirlingS2),
    catalan: (0, $lb8Oa.catalan),
    xor: (0, $lb8Oa.xor),
    row: (0, $lb8Oa.row),
    dotDivide: (0, $lb8Oa.dotDivide),
    createUnit: (0, $lb8Oa.createUnit),
    setSymDifference: (0, $lb8Oa.setSymDifference),
    qr: (0, $lb8Oa.qr),
    inv: (0, $lb8Oa.inv),
    expm: (0, $lb8Oa.expm),
    divide: (0, $lb8Oa.divide),
    mean: (0, $lb8Oa.mean),
    variance: (0, $lb8Oa.variance),
    std: (0, $lb8Oa.std),
    multinomial: (0, $lb8Oa.multinomial),
    atomicMass: (0, $lb8Oa.atomicMass),
    bohrMagneton: (0, $lb8Oa.bohrMagneton),
    boltzmann: (0, $lb8Oa.boltzmann),
    conductanceQuantum: (0, $lb8Oa.conductanceQuantum),
    deuteronMass: (0, $lb8Oa.deuteronMass),
    electronMass: (0, $lb8Oa.electronMass),
    faraday: (0, $lb8Oa.faraday),
    firstRadiation: (0, $lb8Oa.firstRadiation),
    gravitationConstant: (0, $lb8Oa.gravitationConstant),
    hartreeEnergy: (0, $lb8Oa.hartreeEnergy),
    klitzing: (0, $lb8Oa.klitzing),
    magneticConstant: (0, $lb8Oa.magneticConstant),
    molarMass: (0, $lb8Oa.molarMass),
    molarPlanckConstant: (0, $lb8Oa.molarPlanckConstant),
    neutronMass: (0, $lb8Oa.neutronMass),
    planckCharge: (0, $lb8Oa.planckCharge),
    planckLength: (0, $lb8Oa.planckLength),
    planckTemperature: (0, $lb8Oa.planckTemperature),
    protonMass: (0, $lb8Oa.protonMass),
    reducedPlanckConstant: (0, $lb8Oa.reducedPlanckConstant),
    secondRadiation: (0, $lb8Oa.secondRadiation),
    stefanBoltzmann: (0, $lb8Oa.stefanBoltzmann),
    vacuumImpedance: (0, $lb8Oa.vacuumImpedance),
    column: (0, $lb8Oa.column),
    usolve: (0, $lb8Oa.usolve),
    setIntersect: (0, $lb8Oa.setIntersect),
    lusolve: (0, $lb8Oa.lusolve),
    eigs: (0, $lb8Oa.eigs),
    intersect: (0, $lb8Oa.intersect),
    "var": (0, $lb8Oa.variance),
    bellNumbers: (0, $lb8Oa.bellNumbers),
    avogadro: (0, $lb8Oa.avogadro),
    classicalElectronRadius: (0, $lb8Oa.classicalElectronRadius),
    electricConstant: (0, $lb8Oa.electricConstant),
    fermiCoupling: (0, $lb8Oa.fermiCoupling),
    gravity: (0, $lb8Oa.gravity),
    loschmidt: (0, $lb8Oa.loschmidt),
    molarMassC12: (0, $lb8Oa.molarMassC12),
    nuclearMagneton: (0, $lb8Oa.nuclearMagneton),
    planckMass: (0, $lb8Oa.planckMass),
    quantumOfCirculation: (0, $lb8Oa.quantumOfCirculation),
    speedOfLight: (0, $lb8Oa.speedOfLight),
    wienDisplacement: (0, $lb8Oa.wienDisplacement),
    log: (0, $lb8Oa.log),
    unit: (0, $lb8Oa.unit),
    parse: $ec89ec0f349160f3$export$98e6a39c04603d36,
    evaluate: $ec89ec0f349160f3$export$fef61f332f2c0afc,
    sqrtm: (0, $lb8Oa.sqrtm),
    kldivergence: (0, $lb8Oa.kldivergence),
    bohrRadius: (0, $lb8Oa.bohrRadius),
    elementaryCharge: (0, $lb8Oa.elementaryCharge),
    inverseConductanceQuantum: (0, $lb8Oa.inverseConductanceQuantum),
    molarVolume: (0, $lb8Oa.molarVolume),
    planckTime: (0, $lb8Oa.planckTime),
    thomsonCrossSection: (0, $lb8Oa.thomsonCrossSection),
    log1p: (0, $lb8Oa.log1p),
    compile: $ec89ec0f349160f3$export$ef7acd7185315e22,
    parser: $ec89ec0f349160f3$export$8f49e4af10703ce3,
    median: (0, $lb8Oa.median),
    simplify: $ec89ec0f349160f3$export$798b53621063651,
    rationalize: $ec89ec0f349160f3$export$725d762cc154d53,
    gasConstant: (0, $lb8Oa.gasConstant),
    planckConstant: (0, $lb8Oa.planckConstant),
    setUnion: (0, $lb8Oa.setUnion),
    help: $ec89ec0f349160f3$export$34512e3b2db52a4e,
    derivative: $ec89ec0f349160f3$export$42645bbd8ddfc464,
    magneticFluxQuantum: (0, $lb8Oa.magneticFluxQuantum),
    "eval": $ec89ec0f349160f3$export$fef61f332f2c0afc,
    coulomb: (0, $lb8Oa.coulomb),
    mad: (0, $lb8Oa.mad),
    rydberg: (0, $lb8Oa.rydberg),
    config: (0, $59Cgo.config)
});
$ec89ec0f349160f3$var$_extends($ec89ec0f349160f3$var$mathWithTransform, $ec89ec0f349160f3$var$math, {
    apply: (0, $l71lI.createApplyTransform)({
        isInteger: (0, $lb8Oa.isInteger),
        typed: (0, $lb8Oa.typed)
    }),
    filter: (0, $4QA7C.createFilterTransform)({
        typed: (0, $lb8Oa.typed)
    }),
    map: (0, $iGg9x.createMapTransform)({
        typed: (0, $lb8Oa.typed)
    }),
    forEach: (0, $gfkt3.createForEachTransform)({
        typed: (0, $lb8Oa.typed)
    }),
    max: (0, $2ElSv.createMaxTransform)({
        larger: (0, $lb8Oa.larger),
        typed: (0, $lb8Oa.typed)
    }),
    min: (0, $8Y3TH.createMinTransform)({
        smaller: (0, $lb8Oa.smaller),
        typed: (0, $lb8Oa.typed)
    }),
    subset: (0, $28Imc.createSubsetTransform)({
        matrix: (0, $lb8Oa.matrix),
        typed: (0, $lb8Oa.typed)
    }),
    concat: (0, $jbnea.createConcatTransform)({
        isInteger: (0, $lb8Oa.isInteger),
        matrix: (0, $lb8Oa.matrix),
        typed: (0, $lb8Oa.typed)
    }),
    range: (0, $a5N99.createRangeTransform)({
        bignumber: (0, $lb8Oa.bignumber),
        matrix: (0, $lb8Oa.matrix),
        config: (0, $59Cgo.config),
        larger: (0, $lb8Oa.larger),
        largerEq: (0, $lb8Oa.largerEq),
        smaller: (0, $lb8Oa.smaller),
        smallerEq: (0, $lb8Oa.smallerEq),
        typed: (0, $lb8Oa.typed)
    }),
    sum: (0, $1KTTV.createSumTransform)({
        bignumber: (0, $lb8Oa.bignumber),
        fraction: (0, $lb8Oa.fraction),
        add: (0, $lb8Oa.add),
        config: (0, $59Cgo.config),
        typed: (0, $lb8Oa.typed)
    }),
    index: (0, $4BXEH.createIndexTransform)({
        Index: (0, $lb8Oa.Index)
    }),
    column: (0, $jQHb3.createColumnTransform)({
        Index: (0, $lb8Oa.Index),
        matrix: (0, $lb8Oa.matrix),
        range: (0, $lb8Oa.range),
        typed: (0, $lb8Oa.typed)
    }),
    row: (0, $6oWVY.createRowTransform)({
        Index: (0, $lb8Oa.Index),
        matrix: (0, $lb8Oa.matrix),
        range: (0, $lb8Oa.range),
        typed: (0, $lb8Oa.typed)
    }),
    mean: (0, $cJZSS.createMeanTransform)({
        add: (0, $lb8Oa.add),
        divide: (0, $lb8Oa.divide),
        typed: (0, $lb8Oa.typed)
    }),
    variance: (0, $g0yJb.createVarianceTransform)({
        add: (0, $lb8Oa.add),
        apply: (0, $lb8Oa.apply),
        divide: (0, $lb8Oa.divide),
        isNaN: (0, $lb8Oa.isNaN),
        multiply: (0, $lb8Oa.multiply),
        subtract: (0, $lb8Oa.subtract),
        typed: (0, $lb8Oa.typed)
    }),
    std: (0, $62vSW.createStdTransform)({
        sqrt: (0, $lb8Oa.sqrt),
        typed: (0, $lb8Oa.typed),
        variance: (0, $lb8Oa.variance)
    })
});
$ec89ec0f349160f3$var$_extends($ec89ec0f349160f3$var$classes, {
    ResultSet: (0, $lb8Oa.ResultSet),
    Complex: (0, $lb8Oa.Complex),
    Range: (0, $lb8Oa.Range),
    Node: $ec89ec0f349160f3$export$85c928794f8d04d4,
    ArrayNode: $ec89ec0f349160f3$export$97d96bf9b84874d5,
    BlockNode: $ec89ec0f349160f3$export$ec7b1e3e36733ff3,
    ConstantNode: $ec89ec0f349160f3$export$3166e8715d58cf9a,
    ObjectNode: $ec89ec0f349160f3$export$b70fa93b5fbdd997,
    ParenthesisNode: $ec89ec0f349160f3$export$dbdb6279b6a3bac9,
    RelationalNode: $ec89ec0f349160f3$export$a4d9a8de1ded3461,
    Chain: $ec89ec0f349160f3$export$f18d5acc27d70423,
    BigNumber: (0, $lb8Oa.BigNumber),
    Matrix: (0, $lb8Oa.Matrix),
    ConditionalNode: $ec89ec0f349160f3$export$8e402c64e6081013,
    OperatorNode: $ec89ec0f349160f3$export$cd498840ad265e90,
    Fraction: (0, $lb8Oa.Fraction),
    RangeNode: $ec89ec0f349160f3$export$d0e9917d83c120a0,
    DenseMatrix: (0, $lb8Oa.DenseMatrix),
    FunctionAssignmentNode: $ec89ec0f349160f3$export$446a68c3fb943f17,
    SparseMatrix: (0, $lb8Oa.SparseMatrix),
    ImmutableDenseMatrix: (0, $lb8Oa.ImmutableDenseMatrix),
    FibonacciHeap: (0, $lb8Oa.FibonacciHeap),
    AccessorNode: $ec89ec0f349160f3$export$c3248ebc7ade74c5,
    IndexNode: $ec89ec0f349160f3$export$929eaad981940a63,
    Spa: (0, $lb8Oa.Spa),
    AssignmentNode: $ec89ec0f349160f3$export$a144098e31f7b52f,
    Index: (0, $lb8Oa.Index),
    Unit: (0, $lb8Oa.Unit),
    SymbolNode: $ec89ec0f349160f3$export$93b6424aaa42dda7,
    FunctionNode: $ec89ec0f349160f3$export$f2972be796679c12,
    Parser: $ec89ec0f349160f3$export$7acfa6ed01010e37,
    Help: $ec89ec0f349160f3$export$1be7516c0280bee8
});
$ec89ec0f349160f3$export$f18d5acc27d70423.createProxy($ec89ec0f349160f3$var$math);

});
parcelRegister("59Cgo", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $3c0b79531212cb7e$export$e506a1d27d1eaa20; });

var $5bwIz = parcelRequire("5bwIz");

var $8FAbl = parcelRequire("8FAbl");
function $3c0b79531212cb7e$var$_extends() {
    $3c0b79531212cb7e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c0b79531212cb7e$var$_extends.apply(this, arguments);
}
var $3c0b79531212cb7e$export$e506a1d27d1eaa20 = /* #__PURE__ */ function config(options) {
    if (options) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
    return Object.freeze((0, $5bwIz.DEFAULT_CONFIG));
};
$3c0b79531212cb7e$var$_extends($3c0b79531212cb7e$export$e506a1d27d1eaa20, (0, $5bwIz.DEFAULT_CONFIG), {
    MATRIX_OPTIONS: (0, $8FAbl.MATRIX_OPTIONS),
    NUMBER_OPTIONS: (0, $8FAbl.NUMBER_OPTIONS)
});

});
parcelRegister("5bwIz", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", function () { return $3c675be621312d20$export$c2f8e0cc249a8d8f; });
var $3c675be621312d20$export$c2f8e0cc249a8d8f = {
    // minimum relative difference between two compared values,
    // used by all comparison functions
    epsilon: 1e-12,
    // type of default matrix output. Choose 'matrix' (default) or 'array'
    matrix: "Matrix",
    // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
    number: "number",
    // number of significant digits in BigNumbers
    precision: 64,
    // predictable output type of functions. When true, output type depends only
    // on the input types. When false (default), output type can vary depending
    // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
    // predictable is false, and returns `NaN` when true.
    predictable: false,
    // random seed for seeded pseudo random number generation
    // null = randomly seed
    randomSeed: null
};

});

parcelRegister("8FAbl", function(module, exports) {

$parcel$export(module.exports, "MATRIX_OPTIONS", function () { return $64fe38114232c2e3$export$517ab898194ae9af; });
$parcel$export(module.exports, "NUMBER_OPTIONS", function () { return $64fe38114232c2e3$export$f4b0a2084fdf2177; });

var $glBd7 = parcelRequire("glBd7");

var $5bwIz = parcelRequire("5bwIz");
var $64fe38114232c2e3$export$517ab898194ae9af = [
    "Matrix",
    "Array"
]; // valid values for option matrix
var $64fe38114232c2e3$export$f4b0a2084fdf2177 = [
    "number",
    "BigNumber",
    "Fraction"
]; // valid values for option number
function $64fe38114232c2e3$export$3984aa6f7f77f1ae(config, emit) {
    /**
   * Set configuration options for math.js, and get current options.
   * Will emit a 'config' event, with arguments (curr, prev, changes).
   *
   * This function is only available on a mathjs instance created using `create`.
   *
   * Syntax:
   *
   *     math.config(config: Object): Object
   *
   * Examples:
   *
   *
   *     import { create, all } from 'mathjs'
   *
   *     // create a mathjs instance
   *     const math = create(all)
   *
   *     math.config().number                // outputs 'number'
   *     math.evaluate('0.4')                // outputs number 0.4
   *     math.config({number: 'Fraction'})
   *     math.evaluate('0.4')                // outputs Fraction 2/5
   *
   * @param {Object} [options] Available options:
   *                            {number} epsilon
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'Matrix' (default) or 'Array'.
   *                            {string} number
   *                              A string 'number' (default), 'BigNumber', or 'Fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {string} parenthesis
   *                              How to display parentheses in LaTeX and string
   *                              output.
   *                            {string} randomSeed
   *                              Random seed for seeded pseudo random number generator.
   *                              Set to null to randomly seed.
   * @return {Object} Returns the current configuration
   */ function _config(options) {
        if (options) {
            var prev = (0, $glBd7.mapObject)(config, (0, $glBd7.clone)); // validate some of the options
            $64fe38114232c2e3$var$validateOption(options, "matrix", $64fe38114232c2e3$export$517ab898194ae9af);
            $64fe38114232c2e3$var$validateOption(options, "number", $64fe38114232c2e3$export$f4b0a2084fdf2177); // merge options
            (0, $glBd7.deepExtend)(config, options);
            var curr = (0, $glBd7.mapObject)(config, (0, $glBd7.clone));
            var changes = (0, $glBd7.mapObject)(options, (0, $glBd7.clone)); // emit 'config' event
            emit("config", curr, prev, changes);
            return curr;
        } else return (0, $glBd7.mapObject)(config, (0, $glBd7.clone));
    } // attach the valid options to the function so they can be extended
    _config.MATRIX_OPTIONS = $64fe38114232c2e3$export$517ab898194ae9af;
    _config.NUMBER_OPTIONS = $64fe38114232c2e3$export$f4b0a2084fdf2177; // attach the config properties as readonly properties to the config function
    Object.keys((0, $5bwIz.DEFAULT_CONFIG)).forEach(function(key) {
        Object.defineProperty(_config, key, {
            get: function get() {
                return config[key];
            },
            enumerable: true,
            configurable: true
        });
    });
    return _config;
}
/**
 * Test whether an Array contains a specific item.
 * @param {Array.<string>} array
 * @param {string} item
 * @return {boolean}
 */ function $64fe38114232c2e3$var$contains(array, item) {
    return array.indexOf(item) !== -1;
}
/**
 * Find a string in an array. Case insensitive search
 * @param {Array.<string>} array
 * @param {string} item
 * @return {number} Returns the index when found. Returns -1 when not found
 */ function $64fe38114232c2e3$var$findIndex(array, item) {
    return array.map(function(i) {
        return i.toLowerCase();
    }).indexOf(item.toLowerCase());
}
/**
 * Validate an option
 * @param {Object} options         Object with options
 * @param {string} name            Name of the option to validate
 * @param {Array.<string>} values  Array with valid values for this option
 */ function $64fe38114232c2e3$var$validateOption(options, name, values) {
    if (options[name] !== undefined && !$64fe38114232c2e3$var$contains(values, options[name])) {
        var index = $64fe38114232c2e3$var$findIndex(values, options[name]);
        if (index !== -1) {
            // right value, wrong casing
            // TODO: lower case values are deprecated since v3, remove this warning some day.
            console.warn('Warning: Wrong casing for configuration option "' + name + '", should be "' + values[index] + '" instead of "' + options[name] + '".');
            options[name] = values[index]; // change the option to the right casing
        } else // unknown value
        console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". Available options: ' + values.map(JSON.stringify).join(", ") + ".");
    }
}

});
parcelRegister("glBd7", function(module, exports) {

$parcel$export(module.exports, "clone", function () { return $be6b78bbed2f52f8$export$9cd59f9826255e47; });
$parcel$export(module.exports, "mapObject", function () { return $be6b78bbed2f52f8$export$d6051a0f7a227332; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $be6b78bbed2f52f8$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "extend", function () { return $be6b78bbed2f52f8$export$8b58be045bf06082; });
$parcel$export(module.exports, "deepExtend", function () { return $be6b78bbed2f52f8$export$54e9fb29908872fa; });
$parcel$export(module.exports, "deepStrictEqual", function () { return $be6b78bbed2f52f8$export$6cc798251952180; });
$parcel$export(module.exports, "lazy", function () { return $be6b78bbed2f52f8$export$488013bae63b21da; });
$parcel$export(module.exports, "pickShallow", function () { return $be6b78bbed2f52f8$export$8cea971c64639ea7; });

var $7E0JQ = parcelRequire("7E0JQ");
function $be6b78bbed2f52f8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $be6b78bbed2f52f8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $be6b78bbed2f52f8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $be6b78bbed2f52f8$var$_typeof(obj);
}
function $be6b78bbed2f52f8$export$9cd59f9826255e47(x) {
    var type = $be6b78bbed2f52f8$var$_typeof(x); // immutable primitive types
    if (type === "number" || type === "string" || type === "boolean" || x === null || x === undefined) return x;
     // use clone function of the object when available
    if (typeof x.clone === "function") return x.clone();
     // array
    if (Array.isArray(x)) return x.map(function(value) {
        return $be6b78bbed2f52f8$export$9cd59f9826255e47(value);
    });
    if (x instanceof Date) return new Date(x.valueOf());
    if ((0, $7E0JQ.isBigNumber)(x)) return x; // bignumbers are immutable
    if (x instanceof RegExp) throw new TypeError("Cannot clone " + x); // TODO: clone a RegExp
    // object
    return $be6b78bbed2f52f8$export$d6051a0f7a227332(x, $be6b78bbed2f52f8$export$9cd59f9826255e47);
}
function $be6b78bbed2f52f8$export$d6051a0f7a227332(object, callback) {
    var clone = {};
    for(var key in object)if ($be6b78bbed2f52f8$export$5a15a386532a5ea4(object, key)) clone[key] = callback(object[key]);
    return clone;
}
function $be6b78bbed2f52f8$export$8b58be045bf06082(a, b) {
    for(var prop in b)if ($be6b78bbed2f52f8$export$5a15a386532a5ea4(b, prop)) a[prop] = b[prop];
    return a;
}
function $be6b78bbed2f52f8$export$54e9fb29908872fa(a, b) {
    // TODO: add support for Arrays to deepExtend
    if (Array.isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var prop in b)if ($be6b78bbed2f52f8$export$5a15a386532a5ea4(b, prop)) {
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop] && a[prop].constructor === Object) $be6b78bbed2f52f8$export$54e9fb29908872fa(a[prop], b[prop]);
            else a[prop] = b[prop];
        } else if (Array.isArray(b[prop])) throw new TypeError("Arrays are not supported by deepExtend");
        else a[prop] = b[prop];
    }
    return a;
}
function $be6b78bbed2f52f8$export$6cc798251952180(a, b) {
    var prop, i, len;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0, len = a.length; i < len; i++){
            if (!$be6b78bbed2f52f8$export$6cc798251952180(a[i], b[i])) return false;
        }
        return true;
    } else if (typeof a === "function") return a === b;
    else if (a instanceof Object) {
        if (Array.isArray(b) || !(b instanceof Object)) return false;
        for(prop in a){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in b) || !$be6b78bbed2f52f8$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        for(prop in b){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in a) || !$be6b78bbed2f52f8$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        return true;
    } else return a === b;
}
function $be6b78bbed2f52f8$export$519b2d75cc54d03b(nestedObject) {
    var flattenedObject = {};
    $be6b78bbed2f52f8$var$_deepFlatten(nestedObject, flattenedObject);
    return flattenedObject;
} // helper function used by deepFlatten
function $be6b78bbed2f52f8$var$_deepFlatten(nestedObject, flattenedObject) {
    for(var prop in nestedObject)if ($be6b78bbed2f52f8$export$5a15a386532a5ea4(nestedObject, prop)) {
        var value = nestedObject[prop];
        if ($be6b78bbed2f52f8$var$_typeof(value) === "object" && value !== null) $be6b78bbed2f52f8$var$_deepFlatten(value, flattenedObject);
        else flattenedObject[prop] = value;
    }
}
function $be6b78bbed2f52f8$export$a73e197d57374bd3() {
    // test needed for broken IE8 implementation
    try {
        if (Object.defineProperty) {
            Object.defineProperty({}, "x", {
                get: function get() {}
            });
            return true;
        }
    } catch (e) {}
    return false;
}
function $be6b78bbed2f52f8$export$488013bae63b21da(object, prop, valueResolver) {
    var _uninitialized = true;
    var _value;
    Object.defineProperty(object, prop, {
        get: function get() {
            if (_uninitialized) {
                _value = valueResolver();
                _uninitialized = false;
            }
            return _value;
        },
        set: function set(value) {
            _value = value;
            _uninitialized = false;
        },
        configurable: true,
        enumerable: true
    });
}
function $be6b78bbed2f52f8$export$df3f009e3d155b20(object, path) {
    if (path && typeof path === "string") return $be6b78bbed2f52f8$export$df3f009e3d155b20(object, path.split("."));
    var obj = object;
    if (path) for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
    }
    return obj;
}
function $be6b78bbed2f52f8$export$5a15a386532a5ea4(object, property) {
    return object && Object.hasOwnProperty.call(object, property);
}
function $be6b78bbed2f52f8$export$1bc2c269dfa97885(object) {
    return object && typeof object.factory === "function";
}
function $be6b78bbed2f52f8$export$3988ae62b71be9a3(object, path) {
    if (typeof path === "string") {
        if ($be6b78bbed2f52f8$var$isPath(path)) return $be6b78bbed2f52f8$export$3988ae62b71be9a3(object, path.split("."));
        else return object[path];
    }
    var child = object;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        child = child ? child[key] : undefined;
    }
    return child;
}
function $be6b78bbed2f52f8$export$adaa4cf7ef1b65be(object, path, value) {
    if (typeof path === "string") {
        if ($be6b78bbed2f52f8$var$isPath(path)) return $be6b78bbed2f52f8$export$adaa4cf7ef1b65be(object, path.split("."), value);
        else {
            object[path] = value;
            return object;
        }
    }
    var child = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if (child[key] === undefined) child[key] = {};
        child = child[key];
    }
    if (path.length > 0) {
        var lastKey = path[path.length - 1];
        child[lastKey] = value;
    }
    return object;
}
function $be6b78bbed2f52f8$export$357523c63a2253b9(object, properties, transform) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = $be6b78bbed2f52f8$export$3988ae62b71be9a3(object, key);
        if (value !== undefined) $be6b78bbed2f52f8$export$adaa4cf7ef1b65be(copy, key, transform ? transform(value, key) : value);
    }
    return copy;
}
function $be6b78bbed2f52f8$export$8cea971c64639ea7(object, properties) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = object[key];
        if (value !== undefined) copy[key] = value;
    }
    return copy;
}
function $be6b78bbed2f52f8$export$68c286be0e7e55b7(object) {
    return Object.keys(object).map(function(key) {
        return object[key];
    });
} // helper function to test whether a string contains a path like 'user.name'
function $be6b78bbed2f52f8$var$isPath(str) {
    return str.indexOf(".") !== -1;
}

});
parcelRegister("7E0JQ", function(module, exports) {

$parcel$export(module.exports, "isNumber", function () { return $590cd77d02c7b135$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isBigNumber", function () { return $590cd77d02c7b135$export$e51d0e7e5c4a03ab; });
$parcel$export(module.exports, "isComplex", function () { return $590cd77d02c7b135$export$8849a896711efe0c; });
$parcel$export(module.exports, "isFraction", function () { return $590cd77d02c7b135$export$e312cb8a8e5e7c34; });
$parcel$export(module.exports, "isUnit", function () { return $590cd77d02c7b135$export$8960dc335987b8da; });
$parcel$export(module.exports, "isString", function () { return $590cd77d02c7b135$export$844ec244b1367d54; });
$parcel$export(module.exports, "isArray", function () { return $590cd77d02c7b135$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMatrix", function () { return $590cd77d02c7b135$export$b22160e0a14f87b7; });
$parcel$export(module.exports, "isCollection", function () { return $590cd77d02c7b135$export$cea7aa84e978eba5; });
$parcel$export(module.exports, "isDenseMatrix", function () { return $590cd77d02c7b135$export$eb44495df7ba11d; });
$parcel$export(module.exports, "isSparseMatrix", function () { return $590cd77d02c7b135$export$d508368d4da3c38a; });
$parcel$export(module.exports, "isRange", function () { return $590cd77d02c7b135$export$e331ccfa6f694c99; });
$parcel$export(module.exports, "isIndex", function () { return $590cd77d02c7b135$export$ba3dc792055c2f45; });
$parcel$export(module.exports, "isBoolean", function () { return $590cd77d02c7b135$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "isResultSet", function () { return $590cd77d02c7b135$export$381a1a20e6a63376; });
$parcel$export(module.exports, "isHelp", function () { return $590cd77d02c7b135$export$e5dec9a75b602d6c; });
$parcel$export(module.exports, "isFunction", function () { return $590cd77d02c7b135$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isDate", function () { return $590cd77d02c7b135$export$871608497c498473; });
$parcel$export(module.exports, "isRegExp", function () { return $590cd77d02c7b135$export$49841c62b9eff15; });
$parcel$export(module.exports, "isObject", function () { return $590cd77d02c7b135$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isNull", function () { return $590cd77d02c7b135$export$630801d484da15df; });
$parcel$export(module.exports, "isUndefined", function () { return $590cd77d02c7b135$export$fce6876652108ab; });
$parcel$export(module.exports, "isAccessorNode", function () { return $590cd77d02c7b135$export$f88fb19d6b9ee5cb; });
$parcel$export(module.exports, "isArrayNode", function () { return $590cd77d02c7b135$export$440fa93dcf2757a3; });
$parcel$export(module.exports, "isAssignmentNode", function () { return $590cd77d02c7b135$export$64d7d515ec030d5e; });
$parcel$export(module.exports, "isBlockNode", function () { return $590cd77d02c7b135$export$1665e2275a3d717a; });
$parcel$export(module.exports, "isConditionalNode", function () { return $590cd77d02c7b135$export$e1babefe78c70737; });
$parcel$export(module.exports, "isConstantNode", function () { return $590cd77d02c7b135$export$fa9d80731fd8c54b; });
$parcel$export(module.exports, "isFunctionAssignmentNode", function () { return $590cd77d02c7b135$export$27c05cfffd263d30; });
$parcel$export(module.exports, "isFunctionNode", function () { return $590cd77d02c7b135$export$6ae03b16e064e6c4; });
$parcel$export(module.exports, "isIndexNode", function () { return $590cd77d02c7b135$export$ff90979121a6cabc; });
$parcel$export(module.exports, "isNode", function () { return $590cd77d02c7b135$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "isObjectNode", function () { return $590cd77d02c7b135$export$3f18867a334658e9; });
$parcel$export(module.exports, "isOperatorNode", function () { return $590cd77d02c7b135$export$7e624cbaab6cce94; });
$parcel$export(module.exports, "isParenthesisNode", function () { return $590cd77d02c7b135$export$c55e3736c5721220; });
$parcel$export(module.exports, "isRangeNode", function () { return $590cd77d02c7b135$export$92729c5c4ff6fc83; });
$parcel$export(module.exports, "isSymbolNode", function () { return $590cd77d02c7b135$export$87815d550facaed9; });
$parcel$export(module.exports, "isChain", function () { return $590cd77d02c7b135$export$dc36953d0b3a4f05; });
$parcel$export(module.exports, "typeOf", function () { return $590cd77d02c7b135$export$f5bbd400c2f4426f; });
function $590cd77d02c7b135$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $590cd77d02c7b135$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $590cd77d02c7b135$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $590cd77d02c7b135$var$_typeof(obj);
}
function $590cd77d02c7b135$export$7e4aa119212bc614(x) {
    return typeof x === "number";
}
function $590cd77d02c7b135$export$e51d0e7e5c4a03ab(x) {
    return x && x.constructor.prototype.isBigNumber === true || false;
}
function $590cd77d02c7b135$export$8849a896711efe0c(x) {
    return x && $590cd77d02c7b135$var$_typeof(x) === "object" && Object.getPrototypeOf(x).isComplex === true || false;
}
function $590cd77d02c7b135$export$e312cb8a8e5e7c34(x) {
    return x && $590cd77d02c7b135$var$_typeof(x) === "object" && Object.getPrototypeOf(x).isFraction === true || false;
}
function $590cd77d02c7b135$export$8960dc335987b8da(x) {
    return x && x.constructor.prototype.isUnit === true || false;
}
function $590cd77d02c7b135$export$844ec244b1367d54(x) {
    return typeof x === "string";
}
var $590cd77d02c7b135$export$43bee75e5e14138e = Array.isArray;
function $590cd77d02c7b135$export$b22160e0a14f87b7(x) {
    return x && x.constructor.prototype.isMatrix === true || false;
}
function $590cd77d02c7b135$export$cea7aa84e978eba5(x) {
    return Array.isArray(x) || $590cd77d02c7b135$export$b22160e0a14f87b7(x);
}
function $590cd77d02c7b135$export$eb44495df7ba11d(x) {
    return x && x.isDenseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $590cd77d02c7b135$export$d508368d4da3c38a(x) {
    return x && x.isSparseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $590cd77d02c7b135$export$e331ccfa6f694c99(x) {
    return x && x.constructor.prototype.isRange === true || false;
}
function $590cd77d02c7b135$export$ba3dc792055c2f45(x) {
    return x && x.constructor.prototype.isIndex === true || false;
}
function $590cd77d02c7b135$export$f9ce7b637dfbe238(x) {
    return typeof x === "boolean";
}
function $590cd77d02c7b135$export$381a1a20e6a63376(x) {
    return x && x.constructor.prototype.isResultSet === true || false;
}
function $590cd77d02c7b135$export$e5dec9a75b602d6c(x) {
    return x && x.constructor.prototype.isHelp === true || false;
}
function $590cd77d02c7b135$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}
function $590cd77d02c7b135$export$871608497c498473(x) {
    return x instanceof Date;
}
function $590cd77d02c7b135$export$49841c62b9eff15(x) {
    return x instanceof RegExp;
}
function $590cd77d02c7b135$export$a6cdc56e425d0d0a(x) {
    return !!(x && $590cd77d02c7b135$var$_typeof(x) === "object" && x.constructor === Object && !$590cd77d02c7b135$export$8849a896711efe0c(x) && !$590cd77d02c7b135$export$e312cb8a8e5e7c34(x));
}
function $590cd77d02c7b135$export$630801d484da15df(x) {
    return x === null;
}
function $590cd77d02c7b135$export$fce6876652108ab(x) {
    return x === undefined;
}
function $590cd77d02c7b135$export$f88fb19d6b9ee5cb(x) {
    return x && x.isAccessorNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$440fa93dcf2757a3(x) {
    return x && x.isArrayNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$64d7d515ec030d5e(x) {
    return x && x.isAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$1665e2275a3d717a(x) {
    return x && x.isBlockNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$e1babefe78c70737(x) {
    return x && x.isConditionalNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$fa9d80731fd8c54b(x) {
    return x && x.isConstantNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$27c05cfffd263d30(x) {
    return x && x.isFunctionAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$6ae03b16e064e6c4(x) {
    return x && x.isFunctionNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$ff90979121a6cabc(x) {
    return x && x.isIndexNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$8ee0fc9ee280b4ee(x) {
    return x && x.isNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$3f18867a334658e9(x) {
    return x && x.isObjectNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$7e624cbaab6cce94(x) {
    return x && x.isOperatorNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$c55e3736c5721220(x) {
    return x && x.isParenthesisNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$92729c5c4ff6fc83(x) {
    return x && x.isRangeNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$87815d550facaed9(x) {
    return x && x.isSymbolNode === true && x.constructor.prototype.isNode === true || false;
}
function $590cd77d02c7b135$export$dc36953d0b3a4f05(x) {
    return x && x.constructor.prototype.isChain === true || false;
}
function $590cd77d02c7b135$export$f5bbd400c2f4426f(x) {
    var t = $590cd77d02c7b135$var$_typeof(x);
    if (t === "object") {
        // JavaScript types
        if (x === null) return "null";
        if (Array.isArray(x)) return "Array";
        if (x instanceof Date) return "Date";
        if (x instanceof RegExp) return "RegExp"; // math.js types
        if ($590cd77d02c7b135$export$e51d0e7e5c4a03ab(x)) return "BigNumber";
        if ($590cd77d02c7b135$export$8849a896711efe0c(x)) return "Complex";
        if ($590cd77d02c7b135$export$e312cb8a8e5e7c34(x)) return "Fraction";
        if ($590cd77d02c7b135$export$b22160e0a14f87b7(x)) return "Matrix";
        if ($590cd77d02c7b135$export$8960dc335987b8da(x)) return "Unit";
        if ($590cd77d02c7b135$export$ba3dc792055c2f45(x)) return "Index";
        if ($590cd77d02c7b135$export$e331ccfa6f694c99(x)) return "Range";
        if ($590cd77d02c7b135$export$381a1a20e6a63376(x)) return "ResultSet";
        if ($590cd77d02c7b135$export$8ee0fc9ee280b4ee(x)) return x.type;
        if ($590cd77d02c7b135$export$dc36953d0b3a4f05(x)) return "Chain";
        if ($590cd77d02c7b135$export$e5dec9a75b602d6c(x)) return "Help";
        return "Object";
    }
    if (t === "function") return "Function";
    return t; // can be 'string', 'number', 'boolean', ...
}

});




parcelRegister("gkMIT", function(module, exports) {

$parcel$export(module.exports, "createAccessorNode", function () { return $be444ef8c2c837d1$export$a21116b1766eb74; });

var $7E0JQ = parcelRequire("7E0JQ");

var $i3n6j = parcelRequire("i3n6j");

var $jKx4O = parcelRequire("jKx4O");

var $gbwN7 = parcelRequire("gbwN7");
var $be444ef8c2c837d1$var$name = "AccessorNode";
var $be444ef8c2c837d1$var$dependencies = [
    "subset",
    "Node"
];
var $be444ef8c2c837d1$export$a21116b1766eb74 = /* #__PURE__ */ (0, $jKx4O.factory)($be444ef8c2c837d1$var$name, $be444ef8c2c837d1$var$dependencies, function(_ref) {
    var subset = _ref.subset, Node = _ref.Node;
    var access = (0, $gbwN7.accessFactory)({
        subset: subset
    });
    /**
   * @constructor AccessorNode
   * @extends {Node}
   * Access an object property or get a matrix subset
   *
   * @param {Node} object                 The object from which to retrieve
   *                                      a property or subset.
   * @param {IndexNode} index             IndexNode containing ranges
   */ function AccessorNode(object, index) {
        if (!(this instanceof AccessorNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!(0, $7E0JQ.isNode)(object)) throw new TypeError('Node expected for parameter "object"');
        if (!(0, $7E0JQ.isIndexNode)(index)) throw new TypeError('IndexNode expected for parameter "index"');
        this.object = object || null;
        this.index = index; // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                if (this.index) return this.index.isObjectProperty() ? this.index.getObjectProperty() : "";
                else return this.object.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        });
    }
    AccessorNode.prototype = new Node();
    AccessorNode.prototype.type = "AccessorNode";
    AccessorNode.prototype.isAccessorNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ AccessorNode.prototype._compile = function(math, argNames) {
        var evalObject = this.object._compile(math, argNames);
        var evalIndex = this.index._compile(math, argNames);
        if (this.index.isObjectProperty()) {
            var prop = this.index.getObjectProperty();
            return function evalAccessorNode(scope, args, context) {
                return (0, $i3n6j.getSafeProperty)(evalObject(scope, args, context), prop);
            };
        } else return function evalAccessorNode(scope, args, context) {
            var object = evalObject(scope, args, context);
            var index = evalIndex(scope, args, object); // we pass object here instead of context
            return access(object, index);
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ AccessorNode.prototype.forEach = function(callback) {
        callback(this.object, "object", this);
        callback(this.index, "index", this);
    };
    /**
   * Create a new AccessorNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {AccessorNode} Returns a transformed copy of the node
   */ AccessorNode.prototype.map = function(callback) {
        return new AccessorNode(this._ifNode(callback(this.object, "object", this)), this._ifNode(callback(this.index, "index", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {AccessorNode}
   */ AccessorNode.prototype.clone = function() {
        return new AccessorNode(this.object, this.index);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype._toString = function(options) {
        var object = this.object.toString(options);
        if (needParenthesis(this.object)) object = "(" + object + ")";
        return object + this.index.toString(options);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype.toHTML = function(options) {
        var object = this.object.toHTML(options);
        if (needParenthesis(this.object)) object = '<span class="math-parenthesis math-round-parenthesis">(</span>' + object + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return object + this.index.toHTML(options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype._toTex = function(options) {
        var object = this.object.toTex(options);
        if (needParenthesis(this.object)) object = "\\left(' + object + '\\right)";
        return object + this.index.toTex(options);
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ AccessorNode.prototype.toJSON = function() {
        return {
            mathjs: "AccessorNode",
            object: this.object,
            index: this.index
        };
    };
    /**
   * Instantiate an AccessorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "AccessorNode", object: ..., index: ...}`,
   *                       where mathjs is optional
   * @returns {AccessorNode}
   */ AccessorNode.fromJSON = function(json) {
        return new AccessorNode(json.object, json.index);
    };
    /**
   * Are parenthesis needed?
   * @private
   */ function needParenthesis(node) {
        // TODO: maybe make a method on the nodes which tells whether they need parenthesis?
        return !((0, $7E0JQ.isAccessorNode)(node) || (0, $7E0JQ.isArrayNode)(node) || (0, $7E0JQ.isConstantNode)(node) || (0, $7E0JQ.isFunctionNode)(node) || (0, $7E0JQ.isObjectNode)(node) || (0, $7E0JQ.isParenthesisNode)(node) || (0, $7E0JQ.isSymbolNode)(node));
    }
    return AccessorNode;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("i3n6j", function(module, exports) {

$parcel$export(module.exports, "getSafeProperty", function () { return $d24a6d26bfa1f5ac$export$87a87648a1961976; });
$parcel$export(module.exports, "isSafeProperty", function () { return $d24a6d26bfa1f5ac$export$3039c640f3cfc12a; });
$parcel$export(module.exports, "isSafeMethod", function () { return $d24a6d26bfa1f5ac$export$2220a91638ab1d9e; });
$parcel$export(module.exports, "setSafeProperty", function () { return $d24a6d26bfa1f5ac$export$e99fe8700ee9f9cd; });
$parcel$export(module.exports, "validateSafeMethod", function () { return $d24a6d26bfa1f5ac$export$7cfb146d96805fec; });

var $glBd7 = parcelRequire("glBd7");
function $d24a6d26bfa1f5ac$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d24a6d26bfa1f5ac$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d24a6d26bfa1f5ac$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d24a6d26bfa1f5ac$var$_typeof(obj);
}
/**
 * Get a property of a plain object
 * Throws an error in case the object is not a plain object or the
 * property is not defined on the object itself
 * @param {Object} object
 * @param {string} prop
 * @return {*} Returns the property value when safe
 */ function $d24a6d26bfa1f5ac$export$87a87648a1961976(object, prop) {
    // only allow getting safe properties of a plain object
    if ($d24a6d26bfa1f5ac$export$53b83ca8eaab0383(object) && $d24a6d26bfa1f5ac$export$3039c640f3cfc12a(object, prop)) return object[prop];
    if (typeof object[prop] === "function" && $d24a6d26bfa1f5ac$export$2220a91638ab1d9e(object, prop)) throw new Error('Cannot access method "' + prop + '" as a property');
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Set a property on a plain object.
 * Throws an error in case the object is not a plain object or the
 * property would override an inherited property like .constructor or .toString
 * @param {Object} object
 * @param {string} prop
 * @param {*} value
 * @return {*} Returns the value
 */ // TODO: merge this function into access.js?
function $d24a6d26bfa1f5ac$export$e99fe8700ee9f9cd(object, prop, value) {
    // only allow setting safe properties of a plain object
    if ($d24a6d26bfa1f5ac$export$53b83ca8eaab0383(object) && $d24a6d26bfa1f5ac$export$3039c640f3cfc12a(object, prop)) {
        object[prop] = value;
        return value;
    }
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Test whether a property is safe to use for an object.
 * For example .toString and .constructor are not safe
 * @param {string} prop
 * @return {boolean} Returns true when safe
 */ function $d24a6d26bfa1f5ac$export$3039c640f3cfc12a(object, prop) {
    if (!object || $d24a6d26bfa1f5ac$var$_typeof(object) !== "object") return false;
     // SAFE: whitelisted
    // e.g length
    if ((0, $glBd7.hasOwnProperty)($d24a6d26bfa1f5ac$var$safeNativeProperties, prop)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (prop in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (prop in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
/**
 * Validate whether a method is safe.
 * Throws an error when that's not the case.
 * @param {Object} object
 * @param {string} method
 */ // TODO: merge this function into assign.js?
function $d24a6d26bfa1f5ac$export$7cfb146d96805fec(object, method) {
    if (!$d24a6d26bfa1f5ac$export$2220a91638ab1d9e(object, method)) throw new Error('No access to method "' + method + '"');
}
/**
 * Check whether a method is safe.
 * Throws an error when that's not the case (for example for `constructor`).
 * @param {Object} object
 * @param {string} method
 * @return {boolean} Returns true when safe, false otherwise
 */ function $d24a6d26bfa1f5ac$export$2220a91638ab1d9e(object, method) {
    if (object === null || object === undefined || typeof object[method] !== "function") return false;
     // UNSAFE: ghosted
    // e.g overridden toString
    // Note that IE10 doesn't support __proto__ and we can't do this check there.
    if ((0, $glBd7.hasOwnProperty)(object, method) && Object.getPrototypeOf && method in Object.getPrototypeOf(object)) return false;
     // SAFE: whitelisted
    // e.g toString
    if ((0, $glBd7.hasOwnProperty)($d24a6d26bfa1f5ac$var$safeNativeMethods, method)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (method in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (method in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
function $d24a6d26bfa1f5ac$export$53b83ca8eaab0383(object) {
    return $d24a6d26bfa1f5ac$var$_typeof(object) === "object" && object && object.constructor === Object;
}
var $d24a6d26bfa1f5ac$var$safeNativeProperties = {
    length: true,
    name: true
};
var $d24a6d26bfa1f5ac$var$safeNativeMethods = {
    toString: true,
    valueOf: true,
    toLocaleString: true
};

});

parcelRegister("jKx4O", function(module, exports) {

$parcel$export(module.exports, "factory", function () { return $e60bf880af24f98c$export$e9008f2713103c6c; });

var $YkZ7e = parcelRequire("YkZ7e");

var $glBd7 = parcelRequire("glBd7");
function $e60bf880af24f98c$export$e9008f2713103c6c(name, dependencies, create, meta) {
    function assertAndCreate(scope) {
        // we only pass the requested dependencies to the factory function
        // to prevent functions to rely on dependencies that are not explicitly
        // requested.
        var deps = (0, $glBd7.pickShallow)(scope, dependencies.map($e60bf880af24f98c$export$2f4d32a1468e229c));
        $e60bf880af24f98c$export$19a2c26dad95d6e7(name, dependencies, scope);
        return create(deps);
    }
    assertAndCreate.isFactory = true;
    assertAndCreate.fn = name;
    assertAndCreate.dependencies = dependencies.slice().sort();
    if (meta) assertAndCreate.meta = meta;
    return assertAndCreate;
}
function $e60bf880af24f98c$export$883f1d394ed355c(factories) {
    var factoriesByName = {};
    factories.forEach(function(factory) {
        factoriesByName[factory.fn] = factory;
    });
    function containsDependency(factory, dependency) {
        // TODO: detect circular references
        if ($e60bf880af24f98c$export$34763cfbed1075c2(factory)) {
            if ((0, $YkZ7e.contains)(factory.dependencies, dependency.fn || dependency.name)) return true;
            if (factory.dependencies.some(function(d) {
                return containsDependency(factoriesByName[d], dependency);
            })) return true;
        }
        return false;
    }
    var sorted = [];
    function addFactory(factory) {
        var index = 0;
        while(index < sorted.length && !containsDependency(sorted[index], factory))index++;
        sorted.splice(index, 0, factory);
    } // sort regular factory functions
    factories.filter($e60bf880af24f98c$export$34763cfbed1075c2).forEach(addFactory); // sort legacy factory functions AFTER the regular factory functions
    factories.filter(function(factory) {
        return !$e60bf880af24f98c$export$34763cfbed1075c2(factory);
    }).forEach(addFactory);
    return sorted;
} // TODO: comment or cleanup if unused in the end
function $e60bf880af24f98c$export$185802fd694ee1f5(factories) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $e60bf880af24f98c$export$883f1d394ed355c(factories).forEach(function(factory) {
        return factory(scope);
    });
    return scope;
}
function $e60bf880af24f98c$export$34763cfbed1075c2(obj) {
    return typeof obj === "function" && typeof obj.fn === "string" && Array.isArray(obj.dependencies);
}
function $e60bf880af24f98c$export$19a2c26dad95d6e7(name, dependencies, scope) {
    var allDefined = dependencies.filter(function(dependency) {
        return !$e60bf880af24f98c$export$1399ac7f45b04b5(dependency);
    }) // filter optionals
    .every(function(dependency) {
        return scope[dependency] !== undefined;
    });
    if (!allDefined) {
        var missingDependencies = dependencies.filter(function(dependency) {
            return scope[dependency] === undefined;
        }); // TODO: create a custom error class for this, a MathjsError or something like that
        throw new Error('Cannot create function "'.concat(name, '", ') + "some dependencies are missing: ".concat(missingDependencies.map(function(d) {
            return '"'.concat(d, '"');
        }).join(", "), "."));
    }
}
function $e60bf880af24f98c$export$1399ac7f45b04b5(dependency) {
    return dependency && dependency[0] === "?";
}
function $e60bf880af24f98c$export$2f4d32a1468e229c(dependency) {
    return dependency && dependency[0] === "?" ? dependency.slice(1) : dependency;
}

});
parcelRegister("YkZ7e", function(module, exports) {

$parcel$export(module.exports, "arraySize", function () { return $0b55e1d7ad2de121$export$51ffaee4afb683a5; });
$parcel$export(module.exports, "validate", function () { return $0b55e1d7ad2de121$export$a22775fa5e2eebd9; });
$parcel$export(module.exports, "validateIndex", function () { return $0b55e1d7ad2de121$export$3cfe3fbfec03f260; });
$parcel$export(module.exports, "resize", function () { return $0b55e1d7ad2de121$export$4380c87abf28fdf; });
$parcel$export(module.exports, "reshape", function () { return $0b55e1d7ad2de121$export$9eaad88cf88cee2b; });
$parcel$export(module.exports, "flatten", function () { return $0b55e1d7ad2de121$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "squeeze", function () { return $0b55e1d7ad2de121$export$889c931173b77c2f; });
$parcel$export(module.exports, "unsqueeze", function () { return $0b55e1d7ad2de121$export$5a07c5202d40a604; });
$parcel$export(module.exports, "map", function () { return $0b55e1d7ad2de121$export$871de8747c9eaa88; });
$parcel$export(module.exports, "forEach", function () { return $0b55e1d7ad2de121$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "filter", function () { return $0b55e1d7ad2de121$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterRegExp", function () { return $0b55e1d7ad2de121$export$322859471e81229d; });
$parcel$export(module.exports, "join", function () { return $0b55e1d7ad2de121$export$f7e2c8231c57a8bd; });
$parcel$export(module.exports, "identify", function () { return $0b55e1d7ad2de121$export$65e5b62a4c490288; });
$parcel$export(module.exports, "generalize", function () { return $0b55e1d7ad2de121$export$d57ad8b840ad6a01; });
$parcel$export(module.exports, "getArrayDataType", function () { return $0b55e1d7ad2de121$export$d31e00bf4359ea8b; });
$parcel$export(module.exports, "contains", function () { return $0b55e1d7ad2de121$export$2344b14b097df817; });

var $5wlxr = parcelRequire("5wlxr");

var $7E0JQ = parcelRequire("7E0JQ");

var $7HWRb = parcelRequire("7HWRb");

var $i7dcb = parcelRequire("i7dcb");

var $hPWit = parcelRequire("hPWit");
function $0b55e1d7ad2de121$export$51ffaee4afb683a5(x) {
    var s = [];
    while(Array.isArray(x)){
        s.push(x.length);
        x = x[0];
    }
    return s;
}
/**
 * Recursively validate whether each element in a multi dimensional array
 * has a size corresponding to the provided size array.
 * @param {Array} array    Array to be validated
 * @param {number[]} size  Array with the size of each dimension
 * @param {number} dim   Current dimension
 * @throws DimensionError
 * @private
 */ function $0b55e1d7ad2de121$var$_validate(array, size, dim) {
    var i;
    var len = array.length;
    if (len !== size[dim]) throw new (0, $i7dcb.DimensionError)(len, size[dim]);
    if (dim < size.length - 1) {
        // recursively validate each child array
        var dimNext = dim + 1;
        for(i = 0; i < len; i++){
            var child = array[i];
            if (!Array.isArray(child)) throw new (0, $i7dcb.DimensionError)(size.length - 1, size.length, "<");
            $0b55e1d7ad2de121$var$_validate(array[i], size, dimNext);
        }
    } else // last dimension. none of the childs may be an array
    for(i = 0; i < len; i++){
        if (Array.isArray(array[i])) throw new (0, $i7dcb.DimensionError)(size.length + 1, size.length, ">");
    }
}
function $0b55e1d7ad2de121$export$a22775fa5e2eebd9(array, size) {
    var isScalar = size.length === 0;
    if (isScalar) {
        // scalar
        if (Array.isArray(array)) throw new (0, $i7dcb.DimensionError)(array.length, 0);
    } else // array
    $0b55e1d7ad2de121$var$_validate(array, size, 0);
}
function $0b55e1d7ad2de121$export$3cfe3fbfec03f260(index, length) {
    if (!(0, $7E0JQ.isNumber)(index) || !(0, $5wlxr.isInteger)(index)) throw new TypeError("Index must be an integer (value: " + index + ")");
    if (index < 0 || typeof length === "number" && index >= length) throw new (0, $hPWit.IndexError)(index, length);
}
function $0b55e1d7ad2de121$export$4380c87abf28fdf(array, size, defaultValue) {
    // TODO: add support for scalars, having size=[] ?
    // check the type of the arguments
    if (!Array.isArray(array) || !Array.isArray(size)) throw new TypeError("Array expected");
    if (size.length === 0) throw new Error("Resizing to scalar is not supported");
     // check whether size contains positive integers
    size.forEach(function(value) {
        if (!(0, $7E0JQ.isNumber)(value) || !(0, $5wlxr.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $7HWRb.format)(size) + ")");
    }); // recursively resize the array
    var _defaultValue = defaultValue !== undefined ? defaultValue : 0;
    $0b55e1d7ad2de121$var$_resize(array, size, 0, _defaultValue);
    return array;
}
/**
 * Recursively resize a multi dimensional array
 * @param {Array} array         Array to be resized
 * @param {number[]} size       Array with the size of each dimension
 * @param {number} dim          Current dimension
 * @param {*} [defaultValue]    Value to be filled in in new entries,
 *                              undefined by default.
 * @private
 */ function $0b55e1d7ad2de121$var$_resize(array, size, dim, defaultValue) {
    var i;
    var elem;
    var oldLen = array.length;
    var newLen = size[dim];
    var minLen = Math.min(oldLen, newLen); // apply new length
    array.length = newLen;
    if (dim < size.length - 1) {
        // non-last dimension
        var dimNext = dim + 1; // resize existing child arrays
        for(i = 0; i < minLen; i++){
            // resize child array
            elem = array[i];
            if (!Array.isArray(elem)) {
                elem = [
                    elem
                ]; // add a dimension
                array[i] = elem;
            }
            $0b55e1d7ad2de121$var$_resize(elem, size, dimNext, defaultValue);
        } // create new child arrays
        for(i = minLen; i < newLen; i++){
            // get child array
            elem = [];
            array[i] = elem; // resize new child array
            $0b55e1d7ad2de121$var$_resize(elem, size, dimNext, defaultValue);
        }
    } else {
        // last dimension
        // remove dimensions of existing values
        for(i = 0; i < minLen; i++)while(Array.isArray(array[i]))array[i] = array[i][0];
         // fill new elements with the default value
        for(i = minLen; i < newLen; i++)array[i] = defaultValue;
    }
}
function $0b55e1d7ad2de121$export$9eaad88cf88cee2b(array, sizes) {
    var flatArray = $0b55e1d7ad2de121$export$bffa455ba8c619a6(array);
    var newArray;
    function product(arr) {
        return arr.reduce(function(prev, curr) {
            return prev * curr;
        });
    }
    if (!Array.isArray(array) || !Array.isArray(sizes)) throw new TypeError("Array expected");
    if (sizes.length === 0) throw new (0, $i7dcb.DimensionError)(0, product($0b55e1d7ad2de121$export$51ffaee4afb683a5(array)), "!=");
    var totalSize = 1;
    for(var sizeIndex = 0; sizeIndex < sizes.length; sizeIndex++)totalSize *= sizes[sizeIndex];
    if (flatArray.length !== totalSize) throw new (0, $i7dcb.DimensionError)(product(sizes), product($0b55e1d7ad2de121$export$51ffaee4afb683a5(array)), "!=");
    try {
        newArray = $0b55e1d7ad2de121$var$_reshape(flatArray, sizes);
    } catch (e) {
        if (e instanceof (0, $i7dcb.DimensionError)) throw new (0, $i7dcb.DimensionError)(product(sizes), product($0b55e1d7ad2de121$export$51ffaee4afb683a5(array)), "!=");
        throw e;
    }
    return newArray;
}
/**
 * Iteratively re-shape a multi dimensional array to fit the specified dimensions
 * @param {Array} array           Array to be reshaped
 * @param {Array.<number>} sizes  List of sizes for each dimension
 * @returns {Array}               Array whose data has been formatted to fit the
 *                                specified dimensions
 */ function $0b55e1d7ad2de121$var$_reshape(array, sizes) {
    // testing if there are enough elements for the requested shape
    var tmpArray = array;
    var tmpArray2; // for each dimensions starting by the last one and ignoring the first one
    for(var sizeIndex = sizes.length - 1; sizeIndex > 0; sizeIndex--){
        var size = sizes[sizeIndex];
        tmpArray2 = []; // aggregate the elements of the current tmpArray in elements of the requested size
        var length = tmpArray.length / size;
        for(var i = 0; i < length; i++)tmpArray2.push(tmpArray.slice(i * size, (i + 1) * size));
         // set it as the new tmpArray for the next loop turn or for return
        tmpArray = tmpArray2;
    }
    return tmpArray;
}
function $0b55e1d7ad2de121$export$889c931173b77c2f(array, size) {
    var s = size || $0b55e1d7ad2de121$export$51ffaee4afb683a5(array); // squeeze outer dimensions
    while(Array.isArray(array) && array.length === 1){
        array = array[0];
        s.shift();
    } // find the first dimension to be squeezed
    var dims = s.length;
    while(s[dims - 1] === 1)dims--;
     // squeeze inner dimensions
    if (dims < s.length) {
        array = $0b55e1d7ad2de121$var$_squeeze(array, dims, 0);
        s.length = dims;
    }
    return array;
}
/**
 * Recursively squeeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $0b55e1d7ad2de121$var$_squeeze(array, dims, dim) {
    var i, ii;
    if (dim < dims) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $0b55e1d7ad2de121$var$_squeeze(array[i], dims, next);
    } else while(Array.isArray(array))array = array[0];
    return array;
}
function $0b55e1d7ad2de121$export$5a07c5202d40a604(array, dims, outer, size) {
    var s = size || $0b55e1d7ad2de121$export$51ffaee4afb683a5(array); // unsqueeze outer dimensions
    if (outer) for(var i = 0; i < outer; i++){
        array = [
            array
        ];
        s.unshift(1);
    }
     // unsqueeze inner dimensions
    array = $0b55e1d7ad2de121$var$_unsqueeze(array, dims, 0);
    while(s.length < dims)s.push(1);
    return array;
}
/**
 * Recursively unsqueeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $0b55e1d7ad2de121$var$_unsqueeze(array, dims, dim) {
    var i, ii;
    if (Array.isArray(array)) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $0b55e1d7ad2de121$var$_unsqueeze(array[i], dims, next);
    } else for(var d = dim; d < dims; d++)array = [
        array
    ];
    return array;
}
function $0b55e1d7ad2de121$export$bffa455ba8c619a6(array) {
    if (!Array.isArray(array)) // if not an array, return as is
    return array;
    var flat = [];
    array.forEach(function callback(value) {
        if (Array.isArray(value)) value.forEach(callback); // traverse through sub-arrays recursively
        else flat.push(value);
    });
    return flat;
}
function $0b55e1d7ad2de121$export$871de8747c9eaa88(array, callback) {
    return Array.prototype.map.call(array, callback);
}
function $0b55e1d7ad2de121$export$4b80e395e36b5a56(array, callback) {
    Array.prototype.forEach.call(array, callback);
}
function $0b55e1d7ad2de121$export$3dea766d36a8935f(array, callback) {
    if ($0b55e1d7ad2de121$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, callback);
}
function $0b55e1d7ad2de121$export$322859471e81229d(array, regexp) {
    if ($0b55e1d7ad2de121$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, function(entry) {
        return regexp.test(entry);
    });
}
function $0b55e1d7ad2de121$export$f7e2c8231c57a8bd(array, separator) {
    return Array.prototype.join.call(array, separator);
}
function $0b55e1d7ad2de121$export$65e5b62a4c490288(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    var count = 0;
    b[0] = {
        value: a[0],
        identifier: 0
    };
    for(var i = 1; i < a.length; i++){
        if (a[i] === a[i - 1]) count++;
        else count = 0;
        b.push({
            value: a[i],
            identifier: count
        });
    }
    return b;
}
function $0b55e1d7ad2de121$export$d57ad8b840ad6a01(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(a[i].value);
    return b;
}
function $0b55e1d7ad2de121$export$d31e00bf4359ea8b(array, typeOf) {
    var type; // to hold type info
    var length = 0; // to hold length value to ensure it has consistent sizes
    for(var i = 0; i < array.length; i++){
        var item = array[i];
        var isArray = Array.isArray(item); // Saving the target matrix row size
        if (i === 0 && isArray) length = item.length;
         // If the current item is an array but the length does not equal the targetVectorSize
        if (isArray && item.length !== length) return undefined;
        var itemType = isArray ? $0b55e1d7ad2de121$export$d31e00bf4359ea8b(item, typeOf) // recurse into a nested array
         : typeOf(item);
        if (type === undefined) type = itemType; // first item
        else if (type !== itemType) return "mixed";
    }
    return type;
}
function $0b55e1d7ad2de121$export$4c7897fafd92b108(array) {
    return array[array.length - 1];
}
function $0b55e1d7ad2de121$export$59ff82fc918bd7e3(array) {
    return array.slice(0, array.length - 1);
}
function $0b55e1d7ad2de121$export$2344b14b097df817(array, item) {
    return array.indexOf(item) !== -1;
}

});
parcelRegister("5wlxr", function(module, exports) {

$parcel$export(module.exports, "isInteger", function () { return $4050a5fe83446a05$export$a287f47fed4544b8; });
$parcel$export(module.exports, "sign", function () { return $4050a5fe83446a05$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "log2", function () { return $4050a5fe83446a05$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "log10", function () { return $4050a5fe83446a05$export$75e08744a3ff8516; });
$parcel$export(module.exports, "log1p", function () { return $4050a5fe83446a05$export$144dcf16adfb9698; });
$parcel$export(module.exports, "cbrt", function () { return $4050a5fe83446a05$export$841fc4d5a1480b85; });
$parcel$export(module.exports, "expm1", function () { return $4050a5fe83446a05$export$b6c0a80d46d3391d; });
$parcel$export(module.exports, "format", function () { return $4050a5fe83446a05$export$d9468344d3651243; });
$parcel$export(module.exports, "toFixed", function () { return $4050a5fe83446a05$export$a81f732198733497; });
$parcel$export(module.exports, "digits", function () { return $4050a5fe83446a05$export$9c0987062f8f5d89; });
$parcel$export(module.exports, "nearlyEqual", function () { return $4050a5fe83446a05$export$6f3989c6ecc04081; });
$parcel$export(module.exports, "acosh", function () { return $4050a5fe83446a05$export$b26caf0f29211d08; });
$parcel$export(module.exports, "asinh", function () { return $4050a5fe83446a05$export$839d8a01b6af4fc0; });
$parcel$export(module.exports, "atanh", function () { return $4050a5fe83446a05$export$21ea955025ceb08b; });
$parcel$export(module.exports, "cosh", function () { return $4050a5fe83446a05$export$2e2fd1ad24e4d350; });
$parcel$export(module.exports, "sinh", function () { return $4050a5fe83446a05$export$545004b505d7c555; });
$parcel$export(module.exports, "tanh", function () { return $4050a5fe83446a05$export$7128670e45beef9a; });

var $glBd7 = parcelRequire("glBd7");

var $7E0JQ = parcelRequire("7E0JQ");
function $4050a5fe83446a05$export$a287f47fed4544b8(value) {
    if (typeof value === "boolean") return true;
    return isFinite(value) ? value === Math.round(value) : false; // Note: we use ==, not ===, as we can have Booleans as well
}
var $4050a5fe83446a05$export$c5552dfdbc7cec71 = /* #__PURE__ */ Math.sign || function(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $4050a5fe83446a05$export$b9fae0bba9d9094d = /* #__PURE__ */ Math.log2 || function log2(x) {
    return Math.log(x) / Math.LN2;
};
var $4050a5fe83446a05$export$75e08744a3ff8516 = /* #__PURE__ */ Math.log10 || function log10(x) {
    return Math.log(x) / Math.LN10;
};
var $4050a5fe83446a05$export$144dcf16adfb9698 = /* #__PURE__ */ Math.log1p || function(x) {
    return Math.log(x + 1);
};
var $4050a5fe83446a05$export$841fc4d5a1480b85 = /* #__PURE__ */ Math.cbrt || function cbrt(x) {
    if (x === 0) return x;
    var negate = x < 0;
    var result;
    if (negate) x = -x;
    if (isFinite(x)) {
        result = Math.exp(Math.log(x) / 3); // from https://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = (x / (result * result) + 2 * result) / 3;
    } else result = x;
    return negate ? -result : result;
};
var $4050a5fe83446a05$export$b6c0a80d46d3391d = /* #__PURE__ */ Math.expm1 || function expm1(x) {
    return x >= 2e-4 || x <= -0.0002 ? Math.exp(x) - 1 : x + x * x / 2 + x * x * x / 6;
};
function $4050a5fe83446a05$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
     // handle special cases
    if (value === Infinity) return "Infinity";
    else if (value === -Infinity) return "-Infinity";
    else if (isNaN(value)) return "NaN";
     // default values for options
    var notation = "auto";
    var precision;
    if (options) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if ((0, $7E0JQ.isNumber)(options)) precision = options;
        else if ((0, $7E0JQ.isNumber)(options.precision)) precision = options.precision;
    } // handle the various notations
    switch(notation){
        case "fixed":
            return $4050a5fe83446a05$export$a81f732198733497(value, precision);
        case "exponential":
            return $4050a5fe83446a05$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $4050a5fe83446a05$export$9299fe684ed0ee48(value, precision);
        case "auto":
            // TODO: clean up some day. Deprecated since: 2018-01-24
            // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
            if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
                var fixedOptions = (0, $glBd7.mapObject)(options, function(x) {
                    return x;
                });
                fixedOptions.exponential = undefined;
                if (options.exponential.lower !== undefined) fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
                if (options.exponential.upper !== undefined) fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
                console.warn("Deprecation warning: Formatting options exponential.lower and exponential.upper (minimum and maximum value) are replaced with exponential.lowerExp and exponential.upperExp (minimum and maximum exponent) since version 4.0.0. Replace " + JSON.stringify(options) + " with " + JSON.stringify(fixedOptions));
                return $4050a5fe83446a05$export$3e91a10e66078270(value, precision, fixedOptions);
            } // remove trailing zeros after the decimal point
            return $4050a5fe83446a05$export$3e91a10e66078270(value, precision, options && options).replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", or "fixed".');
    }
}
function $4050a5fe83446a05$export$feb80e120a50087f(value) {
    // parse the input value
    var match = String(value).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
    if (!match) throw new SyntaxError("Invalid number " + value);
    var sign = match[1];
    var digits = match[2];
    var exponent = parseFloat(match[4] || "0");
    var dot = digits.indexOf(".");
    exponent += dot !== -1 ? dot - 1 : digits.length - 1;
    var coefficients = digits.replace(".", "") // remove the dot (must be removed before removing leading zeros)
    .replace(/^0*/, function(zeros) {
        // remove leading zeros, add their count to the exponent
        exponent -= zeros.length;
        return "";
    }).replace(/0*$/, "") // remove trailing zeros
    .split("").map(function(d) {
        return parseInt(d);
    });
    if (coefficients.length === 0) {
        coefficients.push(0);
        exponent++;
    }
    return {
        sign: sign,
        coefficients: coefficients,
        exponent: exponent
    };
}
function $4050a5fe83446a05$export$9299fe684ed0ee48(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var split = $4050a5fe83446a05$export$feb80e120a50087f(value);
    var rounded = $4050a5fe83446a05$export$e5b32ced877afc7e(split, precision);
    var e = rounded.exponent;
    var c = rounded.coefficients; // find nearest lower multiple of 3 for exponent
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    if ((0, $7E0JQ.isNumber)(precision)) // add zeroes to give correct sig figs
    while(precision > c.length || e - newExp + 1 > c.length)c.push(0);
    else {
        // concatenate coefficients with necessary zeros
        // add zeros if necessary (for example: 1e+8 -> 100e+6)
        var missingZeros = Math.abs(e - newExp) - (c.length - 1);
        for(var i = 0; i < missingZeros; i++)c.push(0);
    } // find difference in exponents
    var expDiff = Math.abs(e - newExp);
    var decimalIdx = 1; // push decimal index over by expDiff times
    while(expDiff > 0){
        decimalIdx++;
        expDiff--;
    } // if all coefficient values are zero after the decimal point and precision is unset, don't add a decimal value.
    // otherwise concat with the rest of the coefficients
    var decimals = c.slice(decimalIdx).join("");
    var decimalVal = (0, $7E0JQ.isNumber)(precision) && decimals.length || decimals.match(/[1-9]/) ? "." + decimals : "";
    var str = c.slice(0, decimalIdx).join("") + decimalVal + "e" + (e >= 0 ? "+" : "") + newExp.toString();
    return rounded.sign + str;
}
function $4050a5fe83446a05$export$a81f732198733497(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var splitValue = $4050a5fe83446a05$export$feb80e120a50087f(value);
    var rounded = typeof precision === "number" ? $4050a5fe83446a05$export$e5b32ced877afc7e(splitValue, splitValue.exponent + 1 + precision) : splitValue;
    var c = rounded.coefficients;
    var p = rounded.exponent + 1; // exponent may have changed
    // append zeros if needed
    var pp = p + (precision || 0);
    if (c.length < pp) c = c.concat($4050a5fe83446a05$var$zeros(pp - c.length));
     // prepend zeros if needed
    if (p < 0) {
        c = $4050a5fe83446a05$var$zeros(-p + 1).concat(c);
        p = 1;
    } // insert a dot if needed
    if (p < c.length) c.splice(p, 0, p === 0 ? "0." : ".");
    return rounded.sign + c.join("");
}
function $4050a5fe83446a05$export$888cb08ddc4765be(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // round if needed, else create a clone
    var split = $4050a5fe83446a05$export$feb80e120a50087f(value);
    var rounded = precision ? $4050a5fe83446a05$export$e5b32ced877afc7e(split, precision) : split;
    var c = rounded.coefficients;
    var e = rounded.exponent; // append zeros if needed
    if (c.length < precision) c = c.concat($4050a5fe83446a05$var$zeros(precision - c.length));
     // format as `C.CCCe+EEE` or `C.CCCe-EEE`
    var first = c.shift();
    return rounded.sign + first + (c.length > 0 ? "." + c.join("") : "") + "e" + (e >= 0 ? "+" : "") + e;
}
function $4050a5fe83446a05$export$3e91a10e66078270(value, precision, options) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // determine lower and upper bound for exponential notation.
    var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
    var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5;
    var split = $4050a5fe83446a05$export$feb80e120a50087f(value);
    var rounded = precision ? $4050a5fe83446a05$export$e5b32ced877afc7e(split, precision) : split;
    if (rounded.exponent < lowerExp || rounded.exponent >= upperExp) // exponential notation
    return $4050a5fe83446a05$export$888cb08ddc4765be(value, precision);
    else {
        var c = rounded.coefficients;
        var e = rounded.exponent; // append trailing zeros
        if (c.length < precision) c = c.concat($4050a5fe83446a05$var$zeros(precision - c.length));
         // append trailing zeros
        // TODO: simplify the next statement
        c = c.concat($4050a5fe83446a05$var$zeros(e - c.length + 1 + (c.length < precision ? precision - c.length : 0))); // prepend zeros
        c = $4050a5fe83446a05$var$zeros(-e).concat(c);
        var dot = e > 0 ? e : 0;
        if (dot < c.length - 1) c.splice(dot + 1, 0, ".");
        return rounded.sign + c.join("");
    }
}
function $4050a5fe83446a05$export$e5b32ced877afc7e(split, precision) {
    // create a clone
    var rounded = {
        sign: split.sign,
        coefficients: split.coefficients,
        exponent: split.exponent
    };
    var c = rounded.coefficients; // prepend zeros if needed
    while(precision <= 0){
        c.unshift(0);
        rounded.exponent++;
        precision++;
    }
    if (c.length > precision) {
        var removed = c.splice(precision, c.length - precision);
        if (removed[0] >= 5) {
            var i = precision - 1;
            c[i]++;
            while(c[i] === 10){
                c.pop();
                if (i === 0) {
                    c.unshift(0);
                    rounded.exponent++;
                    i++;
                }
                i--;
                c[i]++;
            }
        }
    }
    return rounded;
}
/**
 * Create an array filled with zeros.
 * @param {number} length
 * @return {Array}
 */ function $4050a5fe83446a05$var$zeros(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push(0);
    return arr;
}
function $4050a5fe83446a05$export$9c0987062f8f5d89(value) {
    return value.toExponential().replace(/e.*$/, "") // remove exponential notation
    .replace(/^0\.?0*|\./, "") // remove decimal point and leading zeros
    .length;
}
var $4050a5fe83446a05$export$41b54fa1db30dbb5 = Number.EPSILON || 2.2204460492503130808472633361816E-16;
function $4050a5fe83446a05$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x === y;
    if (x === y) return true;
     // NaN
    if (isNaN(x) || isNaN(y)) return false;
     // at this point x and y should be finite
    if (isFinite(x) && isFinite(y)) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = Math.abs(x - y);
        if (diff < $4050a5fe83446a05$export$41b54fa1db30dbb5) return true;
        else // use relative error
        return diff <= Math.max(Math.abs(x), Math.abs(y)) * epsilon;
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}
var $4050a5fe83446a05$export$b26caf0f29211d08 = Math.acosh || function(x) {
    return Math.log(Math.sqrt(x * x - 1) + x);
};
var $4050a5fe83446a05$export$839d8a01b6af4fc0 = Math.asinh || function(x) {
    return Math.log(Math.sqrt(x * x + 1) + x);
};
var $4050a5fe83446a05$export$21ea955025ceb08b = Math.atanh || function(x) {
    return Math.log((1 + x) / (1 - x)) / 2;
};
var $4050a5fe83446a05$export$2e2fd1ad24e4d350 = Math.cosh || function(x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
};
var $4050a5fe83446a05$export$545004b505d7c555 = Math.sinh || function(x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
};
var $4050a5fe83446a05$export$7128670e45beef9a = Math.tanh || function(x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
};

});

parcelRegister("7HWRb", function(module, exports) {

$parcel$export(module.exports, "endsWith", function () { return $59ca3444a5c15a2f$export$10fdab3683b55b22; });
$parcel$export(module.exports, "format", function () { return $59ca3444a5c15a2f$export$d9468344d3651243; });
$parcel$export(module.exports, "stringify", function () { return $59ca3444a5c15a2f$export$fac44ee5b035f737; });
$parcel$export(module.exports, "escape", function () { return $59ca3444a5c15a2f$export$4e7f196112fea3c5; });
$parcel$export(module.exports, "compareText", function () { return $59ca3444a5c15a2f$export$2da9287da10b19e2; });

var $7E0JQ = parcelRequire("7E0JQ");

var $5wlxr = parcelRequire("5wlxr");

var $aIYx9 = parcelRequire("aIYx9");
function $59ca3444a5c15a2f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $59ca3444a5c15a2f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $59ca3444a5c15a2f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $59ca3444a5c15a2f$var$_typeof(obj);
}
function $59ca3444a5c15a2f$export$10fdab3683b55b22(text, search) {
    var start = text.length - search.length;
    var end = text.length;
    return text.substring(start, end) === search;
}
function $59ca3444a5c15a2f$export$d9468344d3651243(value, options) {
    if (typeof value === "number") return (0, $5wlxr.format)(value, options);
    if ((0, $7E0JQ.isBigNumber)(value)) return (0, $aIYx9.format)(value, options);
     // note: we use unsafe duck-typing here to check for Fractions, this is
    // ok here since we're only invoking toString or concatenating its values
    if ($59ca3444a5c15a2f$var$looksLikeFraction(value)) {
        if (!options || options.fraction !== "decimal") // output as ratio, like '1/3'
        return value.s * value.n + "/" + value.d;
        else // output as decimal, like '0.(3)'
        return value.toString();
    }
    if (Array.isArray(value)) return $59ca3444a5c15a2f$var$formatArray(value, options);
    if ((0, $7E0JQ.isString)(value)) return '"' + value + '"';
    if (typeof value === "function") return value.syntax ? String(value.syntax) : "function";
    if (value && $59ca3444a5c15a2f$var$_typeof(value) === "object") {
        if (typeof value.format === "function") return value.format(options);
        else if (value && value.toString(options) !== ({}).toString()) // this object has a non-native toString method, use that one
        return value.toString(options);
        else {
            var entries = Object.keys(value).map(function(key) {
                return '"' + key + '": ' + $59ca3444a5c15a2f$export$d9468344d3651243(value[key], options);
            });
            return "{" + entries.join(", ") + "}";
        }
    }
    return String(value);
}
function $59ca3444a5c15a2f$export$fac44ee5b035f737(value) {
    var text = String(value);
    var escaped = "";
    var i = 0;
    while(i < text.length){
        var c = text.charAt(i);
        if (c === "\\") {
            escaped += c;
            i++;
            c = text.charAt(i);
            if (c === "" || '"\\/bfnrtu'.indexOf(c) === -1) escaped += "\\"; // no valid escape character -> escape it
            escaped += c;
        } else if (c === '"') escaped += '\\"';
        else escaped += c;
        i++;
    }
    return '"' + escaped + '"';
}
function $59ca3444a5c15a2f$export$4e7f196112fea3c5(value) {
    var text = String(value);
    text = text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return text;
}
/**
 * Recursively format an n-dimensional matrix
 * Example output: "[[1, 2], [3, 4]]"
 * @param {Array} array
 * @param {Object | number | Function} [options]  Formatting options. See
 *                                                lib/utils/number:format for a
 *                                                description of the available
 *                                                options.
 * @returns {string} str
 */ function $59ca3444a5c15a2f$var$formatArray(array, options) {
    if (Array.isArray(array)) {
        var str = "[";
        var len = array.length;
        for(var i = 0; i < len; i++){
            if (i !== 0) str += ", ";
            str += $59ca3444a5c15a2f$var$formatArray(array[i], options);
        }
        str += "]";
        return str;
    } else return $59ca3444a5c15a2f$export$d9468344d3651243(array, options);
}
/**
 * Check whether a value looks like a Fraction (unsafe duck-type check)
 * @param {*} value
 * @return {boolean}
 */ function $59ca3444a5c15a2f$var$looksLikeFraction(value) {
    return value && $59ca3444a5c15a2f$var$_typeof(value) === "object" && typeof value.s === "number" && typeof value.n === "number" && typeof value.d === "number" || false;
}
function $59ca3444a5c15a2f$export$2da9287da10b19e2(x, y) {
    // we don't want to convert numbers to string, only accept string input
    if (!(0, $7E0JQ.isString)(x)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $7E0JQ.typeOf)(x) + ", index: 0)");
    if (!(0, $7E0JQ.isString)(y)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $7E0JQ.typeOf)(y) + ", index: 1)");
    return x === y ? 0 : x > y ? 1 : -1;
}

});
parcelRegister("aIYx9", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $7cecf8330fb89b70$export$d9468344d3651243; });

var $glBd7 = parcelRequire("glBd7");
function $7cecf8330fb89b70$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
     // handle special cases
    if (!value.isFinite()) return value.isNaN() ? "NaN" : value.gt(0) ? "Infinity" : "-Infinity";
     // default values for options
    var notation = "auto";
    var precision;
    if (options !== undefined) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if (typeof options === "number") precision = options;
        else if (options.precision) precision = options.precision;
    } // handle the various notations
    switch(notation){
        case "fixed":
            return $7cecf8330fb89b70$export$a81f732198733497(value, precision);
        case "exponential":
            return $7cecf8330fb89b70$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $7cecf8330fb89b70$export$9299fe684ed0ee48(value, precision);
        case "auto":
            // TODO: clean up some day. Deprecated since: 2018-01-24
            // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
            if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
                var fixedOptions = (0, $glBd7.mapObject)(options, function(x) {
                    return x;
                });
                fixedOptions.exponential = undefined;
                if (options.exponential.lower !== undefined) fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
                if (options.exponential.upper !== undefined) fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
                console.warn("Deprecation warning: Formatting options exponential.lower and exponential.upper (minimum and maximum value) are replaced with exponential.lowerExp and exponential.upperExp (minimum and maximum exponent) since version 4.0.0. Replace " + JSON.stringify(options) + " with " + JSON.stringify(fixedOptions));
                return $7cecf8330fb89b70$export$d9468344d3651243(value, fixedOptions);
            } // determine lower and upper bound for exponential notation.
            // TODO: implement support for upper and lower to be BigNumbers themselves
            var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
            var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5; // handle special case zero
            if (value.isZero()) return "0"; // determine whether or not to output exponential notation
            var str;
            var rounded = value.toSignificantDigits(precision);
            var exp = rounded.e;
            if (exp >= lowerExp && exp < upperExp) // normal number notation
            str = rounded.toFixed();
            else // exponential notation
            str = $7cecf8330fb89b70$export$888cb08ddc4765be(value, precision);
             // remove trailing zeros after the decimal point
            return str.replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", or "fixed".');
    }
}
function $7cecf8330fb89b70$export$9299fe684ed0ee48(value, precision) {
    // find nearest lower multiple of 3 for exponent
    var e = value.e;
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3; // find difference in exponents, and calculate the value without exponent
    var valueWithoutExp = value.mul(Math.pow(10, -newExp));
    var valueStr = valueWithoutExp.toPrecision(precision);
    if (valueStr.indexOf("e") !== -1) valueStr = valueWithoutExp.toString();
    return valueStr + "e" + (e >= 0 ? "+" : "") + newExp.toString();
}
function $7cecf8330fb89b70$export$888cb08ddc4765be(value, precision) {
    if (precision !== undefined) return value.toExponential(precision - 1); // Note the offset of one
    else return value.toExponential();
}
function $7cecf8330fb89b70$export$a81f732198733497(value, precision) {
    return value.toFixed(precision);
}

});


parcelRegister("i7dcb", function(module, exports) {

$parcel$export(module.exports, "DimensionError", function () { return $036746ac7e7cf373$export$ad1391ca020fdd96; });
/**
 * Create a range error with the message:
 *     'Dimension mismatch (<actual size> != <expected size>)'
 * @param {number | number[]} actual        The actual size
 * @param {number | number[]} expected      The expected size
 * @param {string} [relation='!=']          Optional relation between actual
 *                                          and expected size: '!=', '<', etc.
 * @extends RangeError
 */ function $036746ac7e7cf373$export$ad1391ca020fdd96(actual, expected, relation) {
    if (!(this instanceof $036746ac7e7cf373$export$ad1391ca020fdd96)) throw new SyntaxError("Constructor must be called with the new operator");
    this.actual = actual;
    this.expected = expected;
    this.relation = relation;
    this.message = "Dimension mismatch (" + (Array.isArray(actual) ? "[" + actual.join(", ") + "]" : actual) + " " + (this.relation || "!=") + " " + (Array.isArray(expected) ? "[" + expected.join(", ") + "]" : expected) + ")";
    this.stack = new Error().stack;
}
$036746ac7e7cf373$export$ad1391ca020fdd96.prototype = new RangeError();
$036746ac7e7cf373$export$ad1391ca020fdd96.prototype.constructor = RangeError;
$036746ac7e7cf373$export$ad1391ca020fdd96.prototype.name = "DimensionError";
$036746ac7e7cf373$export$ad1391ca020fdd96.prototype.isDimensionError = true;

});

parcelRegister("hPWit", function(module, exports) {

$parcel$export(module.exports, "IndexError", function () { return $cfc46bac01c6bf26$export$efa5eacb1304c464; });
/**
 * Create a range error with the message:
 *     'Index out of range (index < min)'
 *     'Index out of range (index < max)'
 *
 * @param {number} index     The actual index
 * @param {number} [min=0]   Minimum index (included)
 * @param {number} [max]     Maximum index (excluded)
 * @extends RangeError
 */ function $cfc46bac01c6bf26$export$efa5eacb1304c464(index, min, max) {
    if (!(this instanceof $cfc46bac01c6bf26$export$efa5eacb1304c464)) throw new SyntaxError("Constructor must be called with the new operator");
    this.index = index;
    if (arguments.length < 3) {
        this.min = 0;
        this.max = min;
    } else {
        this.min = min;
        this.max = max;
    }
    if (this.min !== undefined && this.index < this.min) this.message = "Index out of range (" + this.index + " < " + this.min + ")";
    else if (this.max !== undefined && this.index >= this.max) this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")";
    else this.message = "Index out of range (" + this.index + ")";
    this.stack = new Error().stack;
}
$cfc46bac01c6bf26$export$efa5eacb1304c464.prototype = new RangeError();
$cfc46bac01c6bf26$export$efa5eacb1304c464.prototype.constructor = RangeError;
$cfc46bac01c6bf26$export$efa5eacb1304c464.prototype.name = "IndexError";
$cfc46bac01c6bf26$export$efa5eacb1304c464.prototype.isIndexError = true;

});



parcelRegister("gbwN7", function(module, exports) {

$parcel$export(module.exports, "accessFactory", function () { return $bc871c13d361139f$export$f8ba146648777f78; });

var $aVkFN = parcelRequire("aVkFN");

var $i3n6j = parcelRequire("i3n6j");
function $bc871c13d361139f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bc871c13d361139f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bc871c13d361139f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bc871c13d361139f$var$_typeof(obj);
}
function $bc871c13d361139f$export$f8ba146648777f78(_ref) {
    var subset = _ref.subset;
    /**
   * Retrieve part of an object:
   *
   * - Retrieve a property from an object
   * - Retrieve a part of a string
   * - Retrieve a matrix subset
   *
   * @param {Object | Array | Matrix | string} object
   * @param {Index} index
   * @return {Object | Array | Matrix | string} Returns the subset
   */ return function access(object, index) {
        try {
            if (Array.isArray(object)) return subset(object, index);
            else if (object && typeof object.subset === "function") // Matrix
            return object.subset(index);
            else if (typeof object === "string") // TODO: move getStringSubset into a separate util file, use that
            return subset(object, index);
            else if ($bc871c13d361139f$var$_typeof(object) === "object") {
                if (!index.isObjectProperty()) throw new TypeError("Cannot apply a numeric index as object property");
                return (0, $i3n6j.getSafeProperty)(object, index.getObjectProperty());
            } else throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (err) {
            throw (0, $aVkFN.errorTransform)(err);
        }
    };
}

});
parcelRegister("aVkFN", function(module, exports) {

$parcel$export(module.exports, "errorTransform", function () { return $7f3f437c08f64a8c$export$1b927030cd80a31b; });

var $hPWit = parcelRequire("hPWit");
function $7f3f437c08f64a8c$export$1b927030cd80a31b(err) {
    if (err && err.isIndexError) return new (0, $hPWit.IndexError)(err.index + 1, err.min + 1, err.max !== undefined ? err.max + 1 : undefined);
    return err;
}

});



parcelRegister("l71lI", function(module, exports) {

$parcel$export(module.exports, "createApplyTransform", function () { return $f5eb4c5df0b36cfc$export$1c2b553a3b99e; });

var $aVkFN = parcelRequire("aVkFN");

var $jKx4O = parcelRequire("jKx4O");

var $33mpC = parcelRequire("33mpC");

var $7E0JQ = parcelRequire("7E0JQ");
var $f5eb4c5df0b36cfc$var$name = "apply";
var $f5eb4c5df0b36cfc$var$dependencies = [
    "typed",
    "isInteger"
];
var $f5eb4c5df0b36cfc$export$1c2b553a3b99e = /* #__PURE__ */ (0, $jKx4O.factory)($f5eb4c5df0b36cfc$var$name, $f5eb4c5df0b36cfc$var$dependencies, function(_ref) {
    var typed = _ref.typed, isInteger = _ref.isInteger;
    var apply = (0, $33mpC.createApply)({
        typed: typed,
        isInteger: isInteger
    }); // @see: comment of concat itself
    return typed("apply", {
        "...any": function any(args) {
            // change dim from one-based to zero-based
            var dim = args[1];
            if ((0, $7E0JQ.isNumber)(dim)) args[1] = dim - 1;
            else if ((0, $7E0JQ.isBigNumber)(dim)) args[1] = dim.minus(1);
            try {
                return apply.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("33mpC", function(module, exports) {

$parcel$export(module.exports, "createApply", function () { return $23930984a7ddbcce$export$5ccffa1686df7f00; });

var $jKx4O = parcelRequire("jKx4O");

var $YkZ7e = parcelRequire("YkZ7e");

var $7E0JQ = parcelRequire("7E0JQ");

var $hPWit = parcelRequire("hPWit");
var $23930984a7ddbcce$var$name = "apply";
var $23930984a7ddbcce$var$dependencies = [
    "typed",
    "isInteger"
];
var $23930984a7ddbcce$export$5ccffa1686df7f00 = /* #__PURE__ */ (0, $jKx4O.factory)($23930984a7ddbcce$var$name, $23930984a7ddbcce$var$dependencies, function(_ref) {
    var typed = _ref.typed, isInteger = _ref.isInteger;
    /**
   * Apply a function that maps an array to a scalar
   * along a given axis of a matrix or array.
   * Returns a new matrix or array with one less dimension than the input.
   *
   * Syntax:
   *
   *     math.apply(A, dim, callback)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [3, 4]]
   *    const sum = math.sum
   *
   *    math.apply(A, 0, sum)             // returns [4, 6]
   *    math.apply(A, 1, sum)             // returns [3, 7]
   *
   * See also:
   *
   *    map, filter, forEach
   *
   * @param {Array | Matrix} array   The input Matrix
   * @param {number} dim             The dimension along which the callback is applied
   * @param {Function} callback      The callback function that is applied. This Function
   *                                 should take an array or 1-d matrix as an input and
   *                                 return a number.
   * @return {Array | Matrix} res    The residual matrix with the function applied over some dimension.
   */ var apply = typed($23930984a7ddbcce$var$name, {
        "Array | Matrix, number | BigNumber, function": function ArrayMatrixNumberBigNumberFunction(mat, dim, callback) {
            if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
            var size = Array.isArray(mat) ? (0, $YkZ7e.arraySize)(mat) : mat.size();
            if (dim < 0 || dim >= size.length) throw new (0, $hPWit.IndexError)(dim, size.length);
            if ((0, $7E0JQ.isMatrix)(mat)) return mat.create($23930984a7ddbcce$var$_apply(mat.valueOf(), dim, callback));
            else return $23930984a7ddbcce$var$_apply(mat, dim, callback);
        }
    });
    return apply;
});
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $23930984a7ddbcce$var$_apply(mat, dim, callback) {
    var i, ret, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) return callback(mat);
        else {
            tran = $23930984a7ddbcce$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $23930984a7ddbcce$var$_apply(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $23930984a7ddbcce$var$_apply(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $23930984a7ddbcce$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}

});


parcelRegister("7SwSH", function(module, exports) {

$parcel$export(module.exports, "createArrayNode", function () { return $5bc715196a4591a3$export$c4666c772dc9bece; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $5bc715196a4591a3$var$name = "ArrayNode";
var $5bc715196a4591a3$var$dependencies = [
    "Node"
];
var $5bc715196a4591a3$export$c4666c772dc9bece = /* #__PURE__ */ (0, $jKx4O.factory)($5bc715196a4591a3$var$name, $5bc715196a4591a3$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor ArrayNode
   * @extends {Node}
   * Holds an 1-dimensional array with items
   * @param {Node[]} [items]   1 dimensional array with items
   */ function ArrayNode(items) {
        if (!(this instanceof ArrayNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.items = items || []; // validate input
        if (!Array.isArray(this.items) || !this.items.every((0, $7E0JQ.isNode))) throw new TypeError("Array containing Nodes expected");
         // TODO: deprecated since v3, remove some day
        var deprecated = function deprecated() {
            throw new Error("Property `ArrayNode.nodes` is deprecated, use `ArrayNode.items` instead");
        };
        Object.defineProperty(this, "nodes", {
            get: deprecated,
            set: deprecated
        });
    }
    ArrayNode.prototype = new Node();
    ArrayNode.prototype.type = "ArrayNode";
    ArrayNode.prototype.isArrayNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ArrayNode.prototype._compile = function(math, argNames) {
        var evalItems = (0, $YkZ7e.map)(this.items, function(item) {
            return item._compile(math, argNames);
        });
        var asMatrix = math.config.matrix !== "Array";
        if (asMatrix) {
            var matrix = math.matrix;
            return function evalArrayNode(scope, args, context) {
                return matrix((0, $YkZ7e.map)(evalItems, function(evalItem) {
                    return evalItem(scope, args, context);
                }));
            };
        } else return function evalArrayNode(scope, args, context) {
            return (0, $YkZ7e.map)(evalItems, function(evalItem) {
                return evalItem(scope, args, context);
            });
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ArrayNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.items.length; i++){
            var node = this.items[i];
            callback(node, "items[" + i + "]", this);
        }
    };
    /**
   * Create a new ArrayNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ArrayNode} Returns a transformed copy of the node
   */ ArrayNode.prototype.map = function(callback) {
        var items = [];
        for(var i = 0; i < this.items.length; i++)items[i] = this._ifNode(callback(this.items[i], "items[" + i + "]", this));
        return new ArrayNode(items);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ArrayNode}
   */ ArrayNode.prototype.clone = function() {
        return new ArrayNode(this.items.slice(0));
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ArrayNode.prototype._toString = function(options) {
        var items = this.items.map(function(node) {
            return node.toString(options);
        });
        return "[" + items.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ArrayNode.prototype.toJSON = function() {
        return {
            mathjs: "ArrayNode",
            items: this.items
        };
    };
    /**
   * Instantiate an ArrayNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ArrayNode", items: [...]}`,
   *                       where mathjs is optional
   * @returns {ArrayNode}
   */ ArrayNode.fromJSON = function(json) {
        return new ArrayNode(json.items);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ArrayNode.prototype.toHTML = function(options) {
        var items = this.items.map(function(node) {
            return node.toHTML(options);
        });
        return '<span class="math-parenthesis math-square-parenthesis">[</span>' + items.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ArrayNode.prototype._toTex = function(options) {
        var s = "\\begin{bmatrix}";
        this.items.forEach(function(node) {
            if (node.items) s += node.items.map(function(childNode) {
                return childNode.toTex(options);
            }).join("&");
            else s += node.toTex(options);
             // new line
            s += "\\\\";
        });
        s += "\\end{bmatrix}";
        return s;
    };
    return ArrayNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("eZkkP", function(module, exports) {

$parcel$export(module.exports, "createAssignmentNode", function () { return $ae968948d39f559b$export$1461ecd49f170d54; });

var $7E0JQ = parcelRequire("7E0JQ");

var $i3n6j = parcelRequire("i3n6j");

var $jKx4O = parcelRequire("jKx4O");

var $gbwN7 = parcelRequire("gbwN7");

var $3ffz5 = parcelRequire("3ffz5");

var $7OD47 = parcelRequire("7OD47");
var $ae968948d39f559b$var$name = "AssignmentNode";
var $ae968948d39f559b$var$dependencies = [
    "subset",
    "?matrix",
    "Node"
];
var $ae968948d39f559b$export$1461ecd49f170d54 = /* #__PURE__ */ (0, $jKx4O.factory)($ae968948d39f559b$var$name, $ae968948d39f559b$var$dependencies, function(_ref) {
    var subset = _ref.subset, matrix = _ref.matrix, Node = _ref.Node;
    var access = (0, $gbwN7.accessFactory)({
        subset: subset
    });
    var assign = (0, $3ffz5.assignFactory)({
        subset: subset,
        matrix: matrix
    });
    /**
   * @constructor AssignmentNode
   * @extends {Node}
   *
   * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
   * replace a subset of a matrix like `A[2,2]=42`.
   *
   * Syntax:
   *
   *     new AssignmentNode(symbol, value)
   *     new AssignmentNode(object, index, value)
   *
   * Usage:
   *
   *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2))                       // a=2
   *    new AssignmentNode(new SymbolNode('a'), new IndexNode('b'), new ConstantNode(2))   // a.b=2
   *    new AssignmentNode(new SymbolNode('a'), new IndexNode(1, 2), new ConstantNode(3))  // a[1,2]=3
   *
   * @param {SymbolNode | AccessorNode} object  Object on which to assign a value
   * @param {IndexNode} [index=null]            Index, property name or matrix
   *                                            index. Optional. If not provided
   *                                            and `object` is a SymbolNode,
   *                                            the property is assigned to the
   *                                            global scope.
   * @param {Node} value                        The value to be assigned
   */ function AssignmentNode(object, index, value) {
        if (!(this instanceof AssignmentNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.object = object;
        this.index = value ? index : null;
        this.value = value || index; // validate input
        if (!(0, $7E0JQ.isSymbolNode)(object) && !(0, $7E0JQ.isAccessorNode)(object)) throw new TypeError('SymbolNode or AccessorNode expected as "object"');
        if ((0, $7E0JQ.isSymbolNode)(object) && object.name === "end") throw new Error('Cannot assign to symbol "end"');
        if (this.index && !(0, $7E0JQ.isIndexNode)(this.index)) // index is optional
        throw new TypeError('IndexNode expected as "index"');
        if (!(0, $7E0JQ.isNode)(this.value)) throw new TypeError('Node expected as "value"');
         // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                if (this.index) return this.index.isObjectProperty() ? this.index.getObjectProperty() : "";
                else return this.object.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        });
    }
    AssignmentNode.prototype = new Node();
    AssignmentNode.prototype.type = "AssignmentNode";
    AssignmentNode.prototype.isAssignmentNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ AssignmentNode.prototype._compile = function(math, argNames) {
        var evalObject = this.object._compile(math, argNames);
        var evalIndex = this.index ? this.index._compile(math, argNames) : null;
        var evalValue = this.value._compile(math, argNames);
        var name = this.object.name;
        if (!this.index) {
            // apply a variable to the scope, for example `a=2`
            if (!(0, $7E0JQ.isSymbolNode)(this.object)) throw new TypeError("SymbolNode expected as object");
            return function evalAssignmentNode(scope, args, context) {
                return (0, $i3n6j.setSafeProperty)(scope, name, evalValue(scope, args, context));
            };
        } else if (this.index.isObjectProperty()) {
            // apply an object property for example `a.b=2`
            var prop = this.index.getObjectProperty();
            return function evalAssignmentNode(scope, args, context) {
                var object = evalObject(scope, args, context);
                var value = evalValue(scope, args, context);
                return (0, $i3n6j.setSafeProperty)(object, prop, value);
            };
        } else if ((0, $7E0JQ.isSymbolNode)(this.object)) // update a matrix subset, for example `a[2]=3`
        return function evalAssignmentNode(scope, args, context) {
            var childObject = evalObject(scope, args, context);
            var value = evalValue(scope, args, context);
            var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
            (0, $i3n6j.setSafeProperty)(scope, name, assign(childObject, index, value));
            return value;
        };
        else {
            // isAccessorNode(node.object) === true
            // update a matrix subset, for example `a.b[2]=3`
            // we will not use the compile function of the AccessorNode, but compile it
            // ourselves here as we need the parent object of the AccessorNode:
            // wee need to apply the updated object to parent object
            var evalParentObject = this.object.object._compile(math, argNames);
            if (this.object.index.isObjectProperty()) {
                var parentProp = this.object.index.getObjectProperty();
                return function evalAssignmentNode(scope, args, context) {
                    var parent = evalParentObject(scope, args, context);
                    var childObject = (0, $i3n6j.getSafeProperty)(parent, parentProp);
                    var index = evalIndex(scope, args, childObject); // Important: we pass childObject instead of context
                    var value = evalValue(scope, args, context);
                    (0, $i3n6j.setSafeProperty)(parent, parentProp, assign(childObject, index, value));
                    return value;
                };
            } else {
                // if some parameters use the 'end' parameter, we need to calculate the size
                var evalParentIndex = this.object.index._compile(math, argNames);
                return function evalAssignmentNode(scope, args, context) {
                    var parent = evalParentObject(scope, args, context);
                    var parentIndex = evalParentIndex(scope, args, parent); // Important: we pass parent instead of context
                    var childObject = access(parent, parentIndex);
                    var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
                    var value = evalValue(scope, args, context);
                    assign(parent, parentIndex, assign(childObject, index, value));
                    return value;
                };
            }
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ AssignmentNode.prototype.forEach = function(callback) {
        callback(this.object, "object", this);
        if (this.index) callback(this.index, "index", this);
        callback(this.value, "value", this);
    };
    /**
   * Create a new AssignmentNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {AssignmentNode} Returns a transformed copy of the node
   */ AssignmentNode.prototype.map = function(callback) {
        var object = this._ifNode(callback(this.object, "object", this));
        var index = this.index ? this._ifNode(callback(this.index, "index", this)) : null;
        var value = this._ifNode(callback(this.value, "value", this));
        return new AssignmentNode(object, index, value);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {AssignmentNode}
   */ AssignmentNode.prototype.clone = function() {
        return new AssignmentNode(this.object, this.index, this.value);
    };
    /*
   * Is parenthesis needed?
   * @param {node} node
   * @param {string} [parenthesis='keep']
   * @private
   */ function needParenthesis(node, parenthesis) {
        if (!parenthesis) parenthesis = "keep";
        var precedence = (0, $7OD47.getPrecedence)(node, parenthesis);
        var exprPrecedence = (0, $7OD47.getPrecedence)(node.value, parenthesis);
        return parenthesis === "all" || exprPrecedence !== null && exprPrecedence <= precedence;
    }
    /**
   * Get string representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype._toString = function(options) {
        var object = this.object.toString(options);
        var index = this.index ? this.index.toString(options) : "";
        var value = this.value.toString(options);
        if (needParenthesis(this, options && options.parenthesis)) value = "(" + value + ")";
        return object + index + " = " + value;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ AssignmentNode.prototype.toJSON = function() {
        return {
            mathjs: "AssignmentNode",
            object: this.object,
            index: this.index,
            value: this.value
        };
    };
    /**
   * Instantiate an AssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
   *                       where mathjs is optional
   * @returns {AssignmentNode}
   */ AssignmentNode.fromJSON = function(json) {
        return new AssignmentNode(json.object, json.index, json.value);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype.toHTML = function(options) {
        var object = this.object.toHTML(options);
        var index = this.index ? this.index.toHTML(options) : "";
        var value = this.value.toHTML(options);
        if (needParenthesis(this, options && options.parenthesis)) value = '<span class="math-paranthesis math-round-parenthesis">(</span>' + value + '<span class="math-paranthesis math-round-parenthesis">)</span>';
        return object + index + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + value;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype._toTex = function(options) {
        var object = this.object.toTex(options);
        var index = this.index ? this.index.toTex(options) : "";
        var value = this.value.toTex(options);
        if (needParenthesis(this, options && options.parenthesis)) value = "\\left(".concat(value, "\\right)");
        return object + index + ":=" + value;
    };
    return AssignmentNode;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("3ffz5", function(module, exports) {

$parcel$export(module.exports, "assignFactory", function () { return $25ced8b3d27a9721$export$796df36381b10d7d; });

var $aVkFN = parcelRequire("aVkFN");

var $i3n6j = parcelRequire("i3n6j");
function $25ced8b3d27a9721$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $25ced8b3d27a9721$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $25ced8b3d27a9721$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $25ced8b3d27a9721$var$_typeof(obj);
}
function $25ced8b3d27a9721$export$796df36381b10d7d(_ref) {
    var subset = _ref.subset, matrix = _ref.matrix;
    /**
   * Replace part of an object:
   *
   * - Assign a property to an object
   * - Replace a part of a string
   * - Replace a matrix subset
   *
   * @param {Object | Array | Matrix | string} object
   * @param {Index} index
   * @param {*} value
   * @return {Object | Array | Matrix | string} Returns the original object
   *                                            except in case of a string
   */ // TODO: change assign to return the value instead of the object
    return function assign(object, index, value) {
        try {
            if (Array.isArray(object)) // we use matrix.subset here instead of the function subset because we must not clone the contents
            return matrix(object).subset(index, value).valueOf();
            else if (object && typeof object.subset === "function") // Matrix
            return object.subset(index, value);
            else if (typeof object === "string") // TODO: move setStringSubset into a separate util file, use that
            return subset(object, index, value);
            else if ($25ced8b3d27a9721$var$_typeof(object) === "object") {
                if (!index.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
                (0, $i3n6j.setSafeProperty)(object, index.getObjectProperty(), value);
                return object;
            } else throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (err) {
            throw (0, $aVkFN.errorTransform)(err);
        }
    };
}

});

parcelRegister("7OD47", function(module, exports) {

$parcel$export(module.exports, "properties", function () { return $5b0b8179b2443831$export$3cb21709c4058847; });
$parcel$export(module.exports, "getPrecedence", function () { return $5b0b8179b2443831$export$94314bea1477f3d5; });
$parcel$export(module.exports, "getAssociativity", function () { return $5b0b8179b2443831$export$8a3de49886b85474; });
$parcel$export(module.exports, "isAssociativeWith", function () { return $5b0b8179b2443831$export$b539869f53b6850a; });
// list of identifiers of nodes in order of their precedence
// also contains information about left/right associativity
// and which other operator the operator is associative with
// Example:
// addition is associative with addition and subtraction, because:
// (a+b)+c=a+(b+c)
// (a+b)-c=a+(b-c)
//
// postfix operators are left associative, prefix operators
// are right associative
//
// It's also possible to set the following properties:
// latexParens: if set to false, this node doesn't need to be enclosed
//              in parentheses when using LaTeX
// latexLeftParens: if set to false, this !OperatorNode's!
//                  left argument doesn't need to be enclosed
//                  in parentheses
// latexRightParens: the same for the right argument

var $glBd7 = parcelRequire("glBd7");
var $5b0b8179b2443831$export$3cb21709c4058847 = [
    {
        // assignment
        AssignmentNode: {},
        FunctionAssignmentNode: {}
    },
    {
        // conditional expression
        ConditionalNode: {
            latexLeftParens: false,
            latexRightParens: false,
            latexParens: false // conditionals don't need parentheses in LaTeX because
        }
    },
    {
        // logical or
        "OperatorNode:or": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // logical xor
        "OperatorNode:xor": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // logical and
        "OperatorNode:and": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise or
        "OperatorNode:bitOr": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise xor
        "OperatorNode:bitXor": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise and
        "OperatorNode:bitAnd": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // relational operators
        "OperatorNode:equal": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:unequal": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:smaller": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:larger": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:smallerEq": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:largerEq": {
            associativity: "left",
            associativeWith: []
        },
        RelationalNode: {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitshift operators
        "OperatorNode:leftShift": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:rightArithShift": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:rightLogShift": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // unit conversion
        "OperatorNode:to": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // range
        RangeNode: {}
    },
    {
        // addition, subtraction
        "OperatorNode:add": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:add",
                "OperatorNode:subtract"
            ]
        },
        "OperatorNode:subtract": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // multiply, divide, modulus
        "OperatorNode:multiply": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "Operator:dotMultiply",
                "Operator:dotDivide"
            ]
        },
        "OperatorNode:divide": {
            associativity: "left",
            associativeWith: [],
            latexLeftParens: false,
            latexRightParens: false,
            latexParens: false // fractions don't require parentheses because
        },
        "OperatorNode:dotMultiply": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "OperatorNode:dotMultiply",
                "OperatorNode:doDivide"
            ]
        },
        "OperatorNode:dotDivide": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:mod": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // unary prefix operators
        "OperatorNode:unaryPlus": {
            associativity: "right"
        },
        "OperatorNode:unaryMinus": {
            associativity: "right"
        },
        "OperatorNode:bitNot": {
            associativity: "right"
        },
        "OperatorNode:not": {
            associativity: "right"
        }
    },
    {
        // exponentiation
        "OperatorNode:pow": {
            associativity: "right",
            associativeWith: [],
            latexRightParens: false // the exponent doesn't need parentheses in
        },
        "OperatorNode:dotPow": {
            associativity: "right",
            associativeWith: []
        }
    },
    {
        // factorial
        "OperatorNode:factorial": {
            associativity: "left"
        }
    },
    {
        // matrix transpose
        "OperatorNode:transpose": {
            associativity: "left"
        }
    }
];
function $5b0b8179b2443831$export$94314bea1477f3d5(_node, parenthesis) {
    var node = _node;
    if (parenthesis !== "keep") // ParenthesisNodes are only ignored when not in 'keep' mode
    node = _node.getContent();
    var identifier = node.getIdentifier();
    for(var i = 0; i < $5b0b8179b2443831$export$3cb21709c4058847.length; i++){
        if (identifier in $5b0b8179b2443831$export$3cb21709c4058847[i]) return i;
    }
    return null;
}
function $5b0b8179b2443831$export$8a3de49886b85474(_node, parenthesis) {
    var node = _node;
    if (parenthesis !== "keep") // ParenthesisNodes are only ignored when not in 'keep' mode
    node = _node.getContent();
    var identifier = node.getIdentifier();
    var index = $5b0b8179b2443831$export$94314bea1477f3d5(node, parenthesis);
    if (index === null) // node isn't in the list
    return null;
    var property = $5b0b8179b2443831$export$3cb21709c4058847[index][identifier];
    if ((0, $glBd7.hasOwnProperty)(property, "associativity")) {
        if (property.associativity === "left") return "left";
        if (property.associativity === "right") return "right";
         // associativity is invalid
        throw Error("'" + identifier + "' has the invalid associativity '" + property.associativity + "'.");
    } // associativity is undefined
    return null;
}
function $5b0b8179b2443831$export$b539869f53b6850a(nodeA, nodeB, parenthesis) {
    // ParenthesisNodes are only ignored when not in 'keep' mode
    var a = parenthesis !== "keep" ? nodeA.getContent() : nodeA;
    var b = parenthesis !== "keep" ? nodeA.getContent() : nodeB;
    var identifierA = a.getIdentifier();
    var identifierB = b.getIdentifier();
    var index = $5b0b8179b2443831$export$94314bea1477f3d5(a, parenthesis);
    if (index === null) // node isn't in the list
    return null;
    var property = $5b0b8179b2443831$export$3cb21709c4058847[index][identifierA];
    if ((0, $glBd7.hasOwnProperty)(property, "associativeWith") && property.associativeWith instanceof Array) {
        for(var i = 0; i < property.associativeWith.length; i++){
            if (property.associativeWith[i] === identifierB) return true;
        }
        return false;
    } // associativeWith is not defined
    return null;
}

});


parcelRegister("32UmN", function(module, exports) {

$parcel$export(module.exports, "createBlockNode", function () { return $237d483e0c5bba68$export$850df8ca0896c9ef; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $237d483e0c5bba68$var$name = "BlockNode";
var $237d483e0c5bba68$var$dependencies = [
    "ResultSet",
    "Node"
];
var $237d483e0c5bba68$export$850df8ca0896c9ef = /* #__PURE__ */ (0, $jKx4O.factory)($237d483e0c5bba68$var$name, $237d483e0c5bba68$var$dependencies, function(_ref) {
    var ResultSet = _ref.ResultSet, Node = _ref.Node;
    /**
   * @constructor BlockNode
   * @extends {Node}
   * Holds a set with blocks
   * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
   *            An array with blocks, where a block is constructed as an Object
   *            with properties block, which is a Node, and visible, which is
   *            a boolean. The property visible is optional and is true by default
   */ function BlockNode(blocks) {
        if (!(this instanceof BlockNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input, copy blocks
        if (!Array.isArray(blocks)) throw new Error("Array expected");
        this.blocks = blocks.map(function(block) {
            var node = block && block.node;
            var visible = block && block.visible !== undefined ? block.visible : true;
            if (!(0, $7E0JQ.isNode)(node)) throw new TypeError('Property "node" must be a Node');
            if (typeof visible !== "boolean") throw new TypeError('Property "visible" must be a boolean');
            return {
                node: node,
                visible: visible
            };
        });
    }
    BlockNode.prototype = new Node();
    BlockNode.prototype.type = "BlockNode";
    BlockNode.prototype.isBlockNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ BlockNode.prototype._compile = function(math, argNames) {
        var evalBlocks = (0, $YkZ7e.map)(this.blocks, function(block) {
            return {
                evaluate: block.node._compile(math, argNames),
                visible: block.visible
            };
        });
        return function evalBlockNodes(scope, args, context) {
            var results = [];
            (0, $YkZ7e.forEach)(evalBlocks, function evalBlockNode(block) {
                var result = block.evaluate(scope, args, context);
                if (block.visible) results.push(result);
            });
            return new ResultSet(results);
        };
    };
    /**
   * Execute a callback for each of the child blocks of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ BlockNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.blocks.length; i++)callback(this.blocks[i].node, "blocks[" + i + "].node", this);
    };
    /**
   * Create a new BlockNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {BlockNode} Returns a transformed copy of the node
   */ BlockNode.prototype.map = function(callback) {
        var blocks = [];
        for(var i = 0; i < this.blocks.length; i++){
            var block = this.blocks[i];
            var node = this._ifNode(callback(block.node, "blocks[" + i + "].node", this));
            blocks[i] = {
                node: node,
                visible: block.visible
            };
        }
        return new BlockNode(blocks);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {BlockNode}
   */ BlockNode.prototype.clone = function() {
        var blocks = this.blocks.map(function(block) {
            return {
                node: block.node,
                visible: block.visible
            };
        });
        return new BlockNode(blocks);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ BlockNode.prototype._toString = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toString(options) + (param.visible ? "" : ";");
        }).join("\n");
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ BlockNode.prototype.toJSON = function() {
        return {
            mathjs: "BlockNode",
            blocks: this.blocks
        };
    };
    /**
   * Instantiate an BlockNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
   *                       where mathjs is optional
   * @returns {BlockNode}
   */ BlockNode.fromJSON = function(json) {
        return new BlockNode(json.blocks);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ BlockNode.prototype.toHTML = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toHTML(options) + (param.visible ? "" : '<span class="math-separator">;</span>');
        }).join('<span class="math-separator"><br /></span>');
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ BlockNode.prototype._toTex = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toTex(options) + (param.visible ? "" : ";");
        }).join("\\;\\;\n");
    };
    return BlockNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("iUOTF", function(module, exports) {

$parcel$export(module.exports, "createChain", function () { return $dc54effd37fd3972$export$3ffb1c732bc8392d; });

var $jKx4O = parcelRequire("jKx4O");
var $dc54effd37fd3972$var$name = "chain";
var $dc54effd37fd3972$var$dependencies = [
    "typed",
    "Chain"
];
var $dc54effd37fd3972$export$3ffb1c732bc8392d = /* #__PURE__ */ (0, $jKx4O.factory)($dc54effd37fd3972$var$name, $dc54effd37fd3972$var$dependencies, function(_ref) {
    var typed = _ref.typed, Chain = _ref.Chain;
    /**
   * Wrap any value in a chain, allowing to perform chained operations on
   * the value.
   *
   * All methods available in the math.js library can be called upon the chain,
   * and then will be evaluated with the value itself as first argument.
   * The chain can be closed by executing `chain.done()`, which returns
   * the final value.
   *
   * The chain has a number of special functions:
   *
   * - `done()`     Finalize the chain and return the chain's value.
   * - `valueOf()`  The same as `done()`
   * - `toString()` Executes `math.format()` onto the chain's value, returning
   *                a string representation of the value.
   *
   * Syntax:
   *
   *    math.chain(value)
   *
   * Examples:
   *
   *     math.chain(3)
   *         .add(4)
   *         .subtract(2)
   *         .done()     // 5
   *
   *     math.chain( [[1, 2], [3, 4]] )
   *         .subset(math.index(0, 0), 8)
   *         .multiply(3)
   *         .done()     // [[24, 6], [9, 12]]
   *
   * @param {*} [value]   A value of any type on which to start a chained operation.
   * @return {math.Chain} The created chain
   */ return typed($dc54effd37fd3972$var$name, {
        "": function _() {
            return new Chain();
        },
        any: function any(value) {
            return new Chain(value);
        }
    });
});

});

parcelRegister("jcdgW", function(module, exports) {

$parcel$export(module.exports, "createChainClass", function () { return $df996eeae0ae1545$export$1aeed9ab2df4999f; });

var $7E0JQ = parcelRequire("7E0JQ");

var $7HWRb = parcelRequire("7HWRb");

var $glBd7 = parcelRequire("glBd7");

var $jKx4O = parcelRequire("jKx4O");
var $df996eeae0ae1545$var$name = "Chain";
var $df996eeae0ae1545$var$dependencies = [
    "?on",
    "math"
];
var $df996eeae0ae1545$export$1aeed9ab2df4999f = /* #__PURE__ */ (0, $jKx4O.factory)($df996eeae0ae1545$var$name, $df996eeae0ae1545$var$dependencies, function(_ref) {
    var on = _ref.on, math = _ref.math;
    /**
   * @constructor Chain
   * Wrap any value in a chain, allowing to perform chained operations on
   * the value.
   *
   * All methods available in the math.js library can be called upon the chain,
   * and then will be evaluated with the value itself as first argument.
   * The chain can be closed by executing chain.done(), which will return
   * the final value.
   *
   * The Chain has a number of special functions:
   * - done()             Finalize the chained operation and return the
   *                      chain's value.
   * - valueOf()          The same as done()
   * - toString()         Returns a string representation of the chain's value.
   *
   * @param {*} [value]
   */ function Chain(value) {
        if (!(this instanceof Chain)) throw new SyntaxError("Constructor must be called with the new operator");
        if ((0, $7E0JQ.isChain)(value)) this.value = value.value;
        else this.value = value;
    }
    /**
   * Attach type information
   */ Chain.prototype.type = "Chain";
    Chain.prototype.isChain = true;
    /**
   * Close the chain. Returns the final value.
   * Does the same as method valueOf()
   * @returns {*} value
   */ Chain.prototype.done = function() {
        return this.value;
    };
    /**
   * Close the chain. Returns the final value.
   * Does the same as method done()
   * @returns {*} value
   */ Chain.prototype.valueOf = function() {
        return this.value;
    };
    /**
   * Get a string representation of the value in the chain
   * @returns {string}
   */ Chain.prototype.toString = function() {
        return (0, $7HWRb.format)(this.value);
    };
    /**
   * Get a JSON representation of the chain
   * @returns {Object}
   */ Chain.prototype.toJSON = function() {
        return {
            mathjs: "Chain",
            value: this.value
        };
    };
    /**
   * Instantiate a Chain from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "Chain", value: ...}`,
   *                       where mathjs is optional
   * @returns {Chain}
   */ Chain.fromJSON = function(json) {
        return new Chain(json.value);
    };
    /**
   * Create a proxy method for the chain
   * @param {string} name
   * @param {Function} fn      The function to be proxied
   *                           If fn is no function, it is silently ignored.
   * @private
   */ function createProxy(name, fn) {
        if (typeof fn === "function") Chain.prototype[name] = chainify(fn);
    }
    /**
   * Create a proxy method for the chain
   * @param {string} name
   * @param {function} resolver   The function resolving with the
   *                              function to be proxied
   * @private
   */ function createLazyProxy(name, resolver) {
        (0, $glBd7.lazy)(Chain.prototype, name, function outerResolver() {
            var fn = resolver();
            if (typeof fn === "function") return chainify(fn);
            return undefined; // if not a function, ignore
        });
    }
    /**
   * Make a function chainable
   * @param {function} fn
   * @return {Function} chain function
   * @private
   */ function chainify(fn) {
        return function() {
            var args = [
                this.value
            ]; // `this` will be the context of a Chain instance
            for(var i = 0; i < arguments.length; i++)args[i + 1] = arguments[i];
            return new Chain(fn.apply(fn, args));
        };
    }
    /**
   * Create a proxy for a single method, or an object with multiple methods.
   * Example usage:
   *
   *   Chain.createProxy('add', function add (x, y) {...})
   *   Chain.createProxy({
   *     add:      function add (x, y) {...},
   *     subtract: function subtract (x, y) {...}
   *   }
   *
   * @param {string | Object} arg0   A name (string), or an object with
   *                                 functions
   * @param {*} [arg1]               A function, when arg0 is a name
   */ Chain.createProxy = function(arg0, arg1) {
        if (typeof arg0 === "string") // createProxy(name, value)
        createProxy(arg0, arg1);
        else {
            var _loop = function _loop(_name) {
                if ((0, $glBd7.hasOwnProperty)(arg0, _name) && excludedNames[_name] === undefined) createLazyProxy(_name, function() {
                    return arg0[_name];
                });
            };
            // createProxy(values)
            for(var _name in arg0)_loop(_name);
        }
    };
    var excludedNames = {
        expression: true,
        docs: true,
        type: true,
        classes: true,
        json: true,
        error: true,
        isChain: true // conflicts with the property isChain of a Chain instance
    }; // create proxy for everything that is in math.js
    Chain.createProxy(math); // register on the import event, automatically add a proxy for every imported function.
    if (on) on("import", function(name, resolver, path) {
        if (!path) // an imported function (not a data type or something special)
        createLazyProxy(name, resolver);
    });
    return Chain;
}, {
    isClass: true
});

});

parcelRegister("jQHb3", function(module, exports) {

$parcel$export(module.exports, "createColumnTransform", function () { return $e7345dc1825800bd$export$cb052a3b92a960e; });

var $aVkFN = parcelRequire("aVkFN");

var $jKx4O = parcelRequire("jKx4O");

var $kZHWr = parcelRequire("kZHWr");

var $7E0JQ = parcelRequire("7E0JQ");
var $e7345dc1825800bd$var$name = "column";
var $e7345dc1825800bd$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $e7345dc1825800bd$export$cb052a3b92a960e = /* #__PURE__ */ (0, $jKx4O.factory)($e7345dc1825800bd$var$name, $e7345dc1825800bd$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index, matrix = _ref.matrix, range = _ref.range;
    var column = (0, $kZHWr.createColumn)({
        typed: typed,
        Index: Index,
        matrix: matrix,
        range: range
    }); // @see: comment of column itself
    return typed("column", {
        "...any": function any(args) {
            // change last argument from zero-based to one-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $7E0JQ.isNumber)(last)) args[lastIndex] = last - 1;
            try {
                return column.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("kZHWr", function(module, exports) {

$parcel$export(module.exports, "createColumn", function () { return $f48b9707a09e4785$export$1bfa986e9c92c0b5; });

var $jKx4O = parcelRequire("jKx4O");

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");
var $f48b9707a09e4785$var$name = "column";
var $f48b9707a09e4785$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $f48b9707a09e4785$export$1bfa986e9c92c0b5 = /* #__PURE__ */ (0, $jKx4O.factory)($f48b9707a09e4785$var$name, $f48b9707a09e4785$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index, matrix = _ref.matrix, range = _ref.range;
    /**
   * Return a column from a Matrix.
   *
   * Syntax:
   *
   *     math.column(value, index)
   *
   * Example:
   *
   *     // get a column
   *     const d = [[1, 2], [3, 4]]
   *     math.column(d, 1) // returns [[2], [4]]
   *
   * See also:
   *
   *     row
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} column           The index of the column
   * @return {Array | Matrix}         The retrieved column
   */ var column = typed($f48b9707a09e4785$var$name, {
        "Matrix, number": _column,
        "Array, number": function ArrayNumber(value, column) {
            return _column(matrix((0, $glBd7.clone)(value)), column).valueOf();
        }
    });
    return column;
    /**
   * Retrieve a column of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} column  The index of the column
   * @return {Matrix}        The retrieved column
   */ function _column(value, column) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $YkZ7e.validateIndex)(column, value.size()[1]);
        var rowRange = range(0, value.size()[0]);
        var index = new Index(rowRange, column);
        return value.subset(index);
    }
});

});


parcelRegister("f8efk", function(module, exports) {

$parcel$export(module.exports, "createCompile", function () { return $b042a759cc9224cd$export$6c15201c8dbd106f; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");
var $b042a759cc9224cd$var$name = "compile";
var $b042a759cc9224cd$var$dependencies = [
    "typed",
    "parse"
];
var $b042a759cc9224cd$export$6c15201c8dbd106f = /* #__PURE__ */ (0, $jKx4O.factory)($b042a759cc9224cd$var$name, $b042a759cc9224cd$var$dependencies, function(_ref) {
    var typed = _ref.typed, parse = _ref.parse;
    /**
   * Parse and compile an expression.
   * Returns a an object with a function `evaluate([scope])` to evaluate the
   * compiled expression.
   *
   * Syntax:
   *
   *     math.compile(expr)                       // returns one node
   *     math.compile([expr1, expr2, expr3, ...]) // returns an array with nodes
   *
   * Examples:
   *
   *     const code1 = math.compile('sqrt(3^2 + 4^2)')
   *     code1.evaluate() // 5
   *
   *     let scope = {a: 3, b: 4}
   *     const code2 = math.compile('a * b') // 12
   *     code2.evaluate(scope) // 12
   *     scope.a = 5
   *     code2.evaluate(scope) // 20
   *
   *     const nodes = math.compile(['a = 3', 'b = 4', 'a * b'])
   *     nodes[2].evaluate() // 12
   *
   * See also:
   *
   *    parse, evaluate
   *
   * @param {string | string[] | Array | Matrix} expr
   *            The expression to be compiled
   * @return {{evaluate: Function} | Array.<{evaluate: Function}>} code
   *            An object with the compiled expression
   * @throws {Error}
   */ return typed($b042a759cc9224cd$var$name, {
        string: function string(expr) {
            return parse(expr).compile();
        },
        "Array | Matrix": function ArrayMatrix(expr) {
            return (0, $fbkGg.deepMap)(expr, function(entry) {
                return parse(entry).compile();
            });
        }
    });
});

});
parcelRegister("fbkGg", function(module, exports) {

$parcel$export(module.exports, "containsCollections", function () { return $b0d7ecdd0448d635$export$4d8f6a27e2f5bcb2; });
$parcel$export(module.exports, "deepForEach", function () { return $b0d7ecdd0448d635$export$519ada94592b97fc; });
$parcel$export(module.exports, "deepMap", function () { return $b0d7ecdd0448d635$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "reduce", function () { return $b0d7ecdd0448d635$export$533b26079ad0b4b; });
$parcel$export(module.exports, "scatter", function () { return $b0d7ecdd0448d635$export$c97954fff4307550; });

var $7E0JQ = parcelRequire("7E0JQ");

var $hPWit = parcelRequire("hPWit");

var $YkZ7e = parcelRequire("YkZ7e");
function $b0d7ecdd0448d635$export$4d8f6a27e2f5bcb2(array) {
    for(var i = 0; i < array.length; i++){
        if ((0, $7E0JQ.isCollection)(array[i])) return true;
    }
    return false;
}
function $b0d7ecdd0448d635$export$519ada94592b97fc(array, callback) {
    if ((0, $7E0JQ.isMatrix)(array)) array = array.valueOf();
    for(var i = 0, ii = array.length; i < ii; i++){
        var value = array[i];
        if (Array.isArray(value)) $b0d7ecdd0448d635$export$519ada94592b97fc(value, callback);
        else callback(value);
    }
}
function $b0d7ecdd0448d635$export$ce7eaaed37329a1b(array, callback, skipZeros) {
    if (array && typeof array.map === "function") // TODO: replace array.map with a for loop to improve performance
    return array.map(function(x) {
        return $b0d7ecdd0448d635$export$ce7eaaed37329a1b(x, callback, skipZeros);
    });
    else return callback(array);
}
function $b0d7ecdd0448d635$export$533b26079ad0b4b(mat, dim, callback) {
    var size = Array.isArray(mat) ? (0, $YkZ7e.arraySize)(mat) : mat.size();
    if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
    throw new (0, $hPWit.IndexError)(dim, size.length);
    if ((0, $7E0JQ.isMatrix)(mat)) return mat.create($b0d7ecdd0448d635$var$_reduce(mat.valueOf(), dim, callback));
    else return $b0d7ecdd0448d635$var$_reduce(mat, dim, callback);
}
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $b0d7ecdd0448d635$var$_reduce(mat, dim, callback) {
    var i, ret, val, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) {
            val = mat[0];
            for(i = 1; i < mat.length; i++)val = callback(val, mat[i]);
            return val;
        } else {
            tran = $b0d7ecdd0448d635$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $b0d7ecdd0448d635$var$_reduce(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $b0d7ecdd0448d635$var$_reduce(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $b0d7ecdd0448d635$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
} // TODO: document function scatter
function $b0d7ecdd0448d635$export$c97954fff4307550(a, j, w, x, u, mark, cindex, f, inverse, update, value) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr; // vars
    var k, k0, k1, i; // check we need to process values (pattern matrix)
    if (x) // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i); // x(i) = A, check we need to call function this time
            if (update) {
                // copy value to workspace calling callback function
                x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]); // function was called on current row
                u[i] = mark;
            } else // copy value to workspace
            x[i] = avalues[k];
        } else {
            // i exists in C already
            x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]); // function was called on current row
            u[i] = mark;
        }
    }
    else // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i);
        } else // indicate function was called on current row
        u[i] = mark;
    }
}

});


parcelRegister("jbnea", function(module, exports) {

$parcel$export(module.exports, "createConcatTransform", function () { return $df710fe6f642cab5$export$3571c61ed942e965; });

var $7E0JQ = parcelRequire("7E0JQ");

var $aVkFN = parcelRequire("aVkFN");

var $jKx4O = parcelRequire("jKx4O");

var $5uT3g = parcelRequire("5uT3g");
var $df710fe6f642cab5$var$name = "concat";
var $df710fe6f642cab5$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $df710fe6f642cab5$export$3571c61ed942e965 = /* #__PURE__ */ (0, $jKx4O.factory)($df710fe6f642cab5$var$name, $df710fe6f642cab5$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, isInteger = _ref.isInteger;
    var concat = (0, $5uT3g.createConcat)({
        typed: typed,
        matrix: matrix,
        isInteger: isInteger
    });
    /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function concat
   * from one-based to zero based
   */ return typed("concat", {
        "...any": function any(args) {
            // change last argument from one-based to zero-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $7E0JQ.isNumber)(last)) args[lastIndex] = last - 1;
            else if ((0, $7E0JQ.isBigNumber)(last)) args[lastIndex] = last.minus(1);
            try {
                return concat.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("5uT3g", function(module, exports) {

$parcel$export(module.exports, "createConcat", function () { return $400a753103c93224$export$c36b5511b12560e8; });

var $7E0JQ = parcelRequire("7E0JQ");

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");

var $hPWit = parcelRequire("hPWit");

var $i7dcb = parcelRequire("i7dcb");

var $jKx4O = parcelRequire("jKx4O");
var $400a753103c93224$var$name = "concat";
var $400a753103c93224$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $400a753103c93224$export$c36b5511b12560e8 = /* #__PURE__ */ (0, $jKx4O.factory)($400a753103c93224$var$name, $400a753103c93224$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, isInteger = _ref.isInteger;
    /**
   * Concatenate two or more matrices.
   *
   * Syntax:
   *
   *     math.concat(A, B, C, ...)
   *     math.concat(A, B, C, ..., dim)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *   By default the last dimension of the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [5, 6]]
   *    const B = [[3, 4], [7, 8]]
   *
   *    math.concat(A, B)                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
   *    math.concat(A, B, 0)               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
   *    math.concat('hello', ' ', 'world') // returns 'hello world'
   *
   * See also:
   *
   *    size, squeeze, subset, transpose
   *
   * @param {... Array | Matrix} args     Two or more matrices
   * @return {Array | Matrix} Concatenated matrix
   */ return typed($400a753103c93224$var$name, {
        // TODO: change signature to '...Array | Matrix, dim?' when supported
        "...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumber(args) {
            var i;
            var len = args.length;
            var dim = -1; // zero-based dimension
            var prevDim;
            var asMatrix = false;
            var matrices = []; // contains multi dimensional arrays
            for(i = 0; i < len; i++){
                var arg = args[i]; // test whether we need to return a Matrix (if not we return an Array)
                if ((0, $7E0JQ.isMatrix)(arg)) asMatrix = true;
                if ((0, $7E0JQ.isNumber)(arg) || (0, $7E0JQ.isBigNumber)(arg)) {
                    if (i !== len - 1) throw new Error("Dimension must be specified as last argument");
                     // last argument contains the dimension on which to concatenate
                    prevDim = dim;
                    dim = arg.valueOf(); // change BigNumber to number
                    if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
                    if (dim < 0 || i > 0 && dim > prevDim) // TODO: would be more clear when throwing a DimensionError here
                    throw new (0, $hPWit.IndexError)(dim, prevDim + 1);
                } else {
                    // this is a matrix or array
                    var m = (0, $glBd7.clone)(arg).valueOf();
                    var size = (0, $YkZ7e.arraySize)(m);
                    matrices[i] = m;
                    prevDim = dim;
                    dim = size.length - 1; // verify whether each of the matrices has the same number of dimensions
                    if (i > 0 && dim !== prevDim) throw new (0, $i7dcb.DimensionError)(prevDim + 1, dim + 1);
                }
            }
            if (matrices.length === 0) throw new SyntaxError("At least one matrix expected");
            var res = matrices.shift();
            while(matrices.length)res = $400a753103c93224$var$_concat(res, matrices.shift(), dim, 0);
            return asMatrix ? matrix(res) : res;
        },
        "...string": function string(args) {
            return args.join("");
        }
    });
});
/**
 * Recursively concatenate two matrices.
 * The contents of the matrices is not cloned.
 * @param {Array} a             Multi dimensional array
 * @param {Array} b             Multi dimensional array
 * @param {number} concatDim    The dimension on which to concatenate (zero-based)
 * @param {number} dim          The current dim (zero-based)
 * @return {Array} c            The concatenated matrix
 * @private
 */ function $400a753103c93224$var$_concat(a, b, concatDim, dim) {
    if (dim < concatDim) {
        // recurse into next dimension
        if (a.length !== b.length) throw new (0, $i7dcb.DimensionError)(a.length, b.length);
        var c = [];
        for(var i = 0; i < a.length; i++)c[i] = $400a753103c93224$var$_concat(a[i], b[i], concatDim, dim + 1);
        return c;
    } else // concatenate this dimension
    return a.concat(b);
}

});


parcelRegister("3wHud", function(module, exports) {

$parcel$export(module.exports, "createConditionalNode", function () { return $291617c0f574fd9c$export$401636051e48ab09; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $7OD47 = parcelRequire("7OD47");
var $291617c0f574fd9c$var$name = "ConditionalNode";
var $291617c0f574fd9c$var$dependencies = [
    "Node"
];
var $291617c0f574fd9c$export$401636051e48ab09 = /* #__PURE__ */ (0, $jKx4O.factory)($291617c0f574fd9c$var$name, $291617c0f574fd9c$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
   *
   * @param {Node} condition   Condition, must result in a boolean
   * @param {Node} trueExpr    Expression evaluated when condition is true
   * @param {Node} falseExpr   Expression evaluated when condition is true
   *
   * @constructor ConditionalNode
   * @extends {Node}
   */ function ConditionalNode(condition, trueExpr, falseExpr) {
        if (!(this instanceof ConditionalNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!(0, $7E0JQ.isNode)(condition)) throw new TypeError("Parameter condition must be a Node");
        if (!(0, $7E0JQ.isNode)(trueExpr)) throw new TypeError("Parameter trueExpr must be a Node");
        if (!(0, $7E0JQ.isNode)(falseExpr)) throw new TypeError("Parameter falseExpr must be a Node");
        this.condition = condition;
        this.trueExpr = trueExpr;
        this.falseExpr = falseExpr;
    }
    ConditionalNode.prototype = new Node();
    ConditionalNode.prototype.type = "ConditionalNode";
    ConditionalNode.prototype.isConditionalNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ConditionalNode.prototype._compile = function(math, argNames) {
        var evalCondition = this.condition._compile(math, argNames);
        var evalTrueExpr = this.trueExpr._compile(math, argNames);
        var evalFalseExpr = this.falseExpr._compile(math, argNames);
        return function evalConditionalNode(scope, args, context) {
            return testCondition(evalCondition(scope, args, context)) ? evalTrueExpr(scope, args, context) : evalFalseExpr(scope, args, context);
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ConditionalNode.prototype.forEach = function(callback) {
        callback(this.condition, "condition", this);
        callback(this.trueExpr, "trueExpr", this);
        callback(this.falseExpr, "falseExpr", this);
    };
    /**
   * Create a new ConditionalNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ConditionalNode} Returns a transformed copy of the node
   */ ConditionalNode.prototype.map = function(callback) {
        return new ConditionalNode(this._ifNode(callback(this.condition, "condition", this)), this._ifNode(callback(this.trueExpr, "trueExpr", this)), this._ifNode(callback(this.falseExpr, "falseExpr", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ConditionalNode}
   */ ConditionalNode.prototype.clone = function() {
        return new ConditionalNode(this.condition, this.trueExpr, this.falseExpr);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $7OD47.getPrecedence)(this, parenthesis); // Enclose Arguments in parentheses if they are an OperatorNode
        // or have lower or equal precedence
        // NOTE: enclosing all OperatorNodes in parentheses is a decision
        // purely based on aesthetics and readability
        var condition = this.condition.toString(options);
        var conditionPrecedence = (0, $7OD47.getPrecedence)(this.condition, parenthesis);
        if (parenthesis === "all" || this.condition.type === "OperatorNode" || conditionPrecedence !== null && conditionPrecedence <= precedence) condition = "(" + condition + ")";
        var trueExpr = this.trueExpr.toString(options);
        var truePrecedence = (0, $7OD47.getPrecedence)(this.trueExpr, parenthesis);
        if (parenthesis === "all" || this.trueExpr.type === "OperatorNode" || truePrecedence !== null && truePrecedence <= precedence) trueExpr = "(" + trueExpr + ")";
        var falseExpr = this.falseExpr.toString(options);
        var falsePrecedence = (0, $7OD47.getPrecedence)(this.falseExpr, parenthesis);
        if (parenthesis === "all" || this.falseExpr.type === "OperatorNode" || falsePrecedence !== null && falsePrecedence <= precedence) falseExpr = "(" + falseExpr + ")";
        return condition + " ? " + trueExpr + " : " + falseExpr;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ConditionalNode.prototype.toJSON = function() {
        return {
            mathjs: "ConditionalNode",
            condition: this.condition,
            trueExpr: this.trueExpr,
            falseExpr: this.falseExpr
        };
    };
    /**
   * Instantiate an ConditionalNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ConditionalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
   *                       where mathjs is optional
   * @returns {ConditionalNode}
   */ ConditionalNode.fromJSON = function(json) {
        return new ConditionalNode(json.condition, json.trueExpr, json.falseExpr);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $7OD47.getPrecedence)(this, parenthesis); // Enclose Arguments in parentheses if they are an OperatorNode
        // or have lower or equal precedence
        // NOTE: enclosing all OperatorNodes in parentheses is a decision
        // purely based on aesthetics and readability
        var condition = this.condition.toHTML(options);
        var conditionPrecedence = (0, $7OD47.getPrecedence)(this.condition, parenthesis);
        if (parenthesis === "all" || this.condition.type === "OperatorNode" || conditionPrecedence !== null && conditionPrecedence <= precedence) condition = '<span class="math-parenthesis math-round-parenthesis">(</span>' + condition + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        var trueExpr = this.trueExpr.toHTML(options);
        var truePrecedence = (0, $7OD47.getPrecedence)(this.trueExpr, parenthesis);
        if (parenthesis === "all" || this.trueExpr.type === "OperatorNode" || truePrecedence !== null && truePrecedence <= precedence) trueExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + trueExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        var falseExpr = this.falseExpr.toHTML(options);
        var falsePrecedence = (0, $7OD47.getPrecedence)(this.falseExpr, parenthesis);
        if (parenthesis === "all" || this.falseExpr.type === "OperatorNode" || falsePrecedence !== null && falsePrecedence <= precedence) falseExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + falseExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return condition + '<span class="math-operator math-conditional-operator">?</span>' + trueExpr + '<span class="math-operator math-conditional-operator">:</span>' + falseExpr;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype._toTex = function(options) {
        return "\\begin{cases} {" + this.trueExpr.toTex(options) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(options) + "}\\\\{" + this.falseExpr.toTex(options) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    };
    /**
   * Test whether a condition is met
   * @param {*} condition
   * @returns {boolean} true if condition is true or non-zero, else false
   */ function testCondition(condition) {
        if (typeof condition === "number" || typeof condition === "boolean" || typeof condition === "string") return !!condition;
        if (condition) {
            if ((0, $7E0JQ.isBigNumber)(condition)) return !condition.isZero();
            if ((0, $7E0JQ.isComplex)(condition)) return !!(condition.re || condition.im);
            if ((0, $7E0JQ.isUnit)(condition)) return !!condition.value;
        }
        if (condition === null || condition === undefined) return false;
        throw new TypeError('Unsupported type of condition "' + (0, $7E0JQ.typeOf)(condition) + '"');
    }
    return ConditionalNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("3reAA", function(module, exports) {

$parcel$export(module.exports, "createConstantNode", function () { return $280f35c99722b638$export$70fc17189bb5117e; });

var $7HWRb = parcelRequire("7HWRb");

var $7E0JQ = parcelRequire("7E0JQ");

var $fMJxQ = parcelRequire("fMJxQ");

var $jKx4O = parcelRequire("jKx4O");
var $280f35c99722b638$var$name = "ConstantNode";
var $280f35c99722b638$var$dependencies = [
    "Node"
];
var $280f35c99722b638$export$70fc17189bb5117e = /* #__PURE__ */ (0, $jKx4O.factory)($280f35c99722b638$var$name, $280f35c99722b638$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * A ConstantNode holds a constant value like a number or string.
   *
   * Usage:
   *
   *     new ConstantNode(2.3)
   *     new ConstantNode('hello')
   *
   * @param {*} value    Value can be any type (number, BigNumber, string, ...)
   * @constructor ConstantNode
   * @extends {Node}
   */ function ConstantNode(value) {
        if (!(this instanceof ConstantNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (arguments.length === 2) // TODO: remove deprecation error some day (created 2018-01-23)
        throw new SyntaxError("new ConstantNode(valueStr, valueType) is not supported anymore since math v4.0.0. Use new ConstantNode(value) instead, where value is a non-stringified value.");
        this.value = value;
    }
    ConstantNode.prototype = new Node();
    ConstantNode.prototype.type = "ConstantNode";
    ConstantNode.prototype.isConstantNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ConstantNode.prototype._compile = function(math, argNames) {
        var value = this.value;
        return function evalConstantNode() {
            return value;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ConstantNode.prototype.forEach = function(callback) {} // nothing to do, we don't have childs
     /**
   * Create a new ConstantNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {ConstantNode} Returns a clone of the node
   */ ;
    ConstantNode.prototype.map = function(callback) {
        return this.clone();
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ConstantNode}
   */ ConstantNode.prototype.clone = function() {
        return new ConstantNode(this.value);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype._toString = function(options) {
        return (0, $7HWRb.format)(this.value, options);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype.toHTML = function(options) {
        var value = this._toString(options);
        switch((0, $7E0JQ.typeOf)(this.value)){
            case "number":
            case "BigNumber":
            case "Fraction":
                return '<span class="math-number">' + value + "</span>";
            case "string":
                return '<span class="math-string">' + value + "</span>";
            case "boolean":
                return '<span class="math-boolean">' + value + "</span>";
            case "null":
                return '<span class="math-null-symbol">' + value + "</span>";
            case "undefined":
                return '<span class="math-undefined">' + value + "</span>";
            default:
                return '<span class="math-symbol">' + value + "</span>";
        }
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ConstantNode.prototype.toJSON = function() {
        return {
            mathjs: "ConstantNode",
            value: this.value
        };
    };
    /**
   * Instantiate a ConstantNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SymbolNode", value: 2.3}`,
   *                       where mathjs is optional
   * @returns {ConstantNode}
   */ ConstantNode.fromJSON = function(json) {
        return new ConstantNode(json.value);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype._toTex = function(options) {
        var value = this._toString(options);
        switch((0, $7E0JQ.typeOf)(this.value)){
            case "string":
                return "\\mathtt{" + (0, $fMJxQ.escapeLatex)(value) + "}";
            case "number":
            case "BigNumber":
                if (!isFinite(this.value)) return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
                var index = value.toLowerCase().indexOf("e");
                if (index !== -1) return value.substring(0, index) + "\\cdot10^{" + value.substring(index + 1) + "}";
                return value;
            case "Fraction":
                return this.value.toLatex();
            default:
                return value;
        }
    };
    return ConstantNode;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("fMJxQ", function(module, exports) {

$parcel$export(module.exports, "latexOperators", function () { return $b7deaaf8ee99cf35$export$c728a46e4168cd75; });
$parcel$export(module.exports, "latexFunctions", function () { return $b7deaaf8ee99cf35$export$b0cfc37067573780; });
$parcel$export(module.exports, "defaultTemplate", function () { return $b7deaaf8ee99cf35$export$76173758cefa70e5; });
$parcel$export(module.exports, "escapeLatex", function () { return $b7deaaf8ee99cf35$export$1b86a510a6af60c2; });
$parcel$export(module.exports, "toSymbol", function () { return $b7deaaf8ee99cf35$export$358d3bb1a752ff; });
/* eslint no-template-curly-in-string: "off" */ 
var $25Ht0 = parcelRequire("25Ht0");

var $glBd7 = parcelRequire("glBd7");
var $b7deaaf8ee99cf35$export$98cd3902fcdeb93d = {
    // GREEK LETTERS
    Alpha: "A",
    alpha: "\\alpha",
    Beta: "B",
    beta: "\\beta",
    Gamma: "\\Gamma",
    gamma: "\\gamma",
    Delta: "\\Delta",
    delta: "\\delta",
    Epsilon: "E",
    epsilon: "\\epsilon",
    varepsilon: "\\varepsilon",
    Zeta: "Z",
    zeta: "\\zeta",
    Eta: "H",
    eta: "\\eta",
    Theta: "\\Theta",
    theta: "\\theta",
    vartheta: "\\vartheta",
    Iota: "I",
    iota: "\\iota",
    Kappa: "K",
    kappa: "\\kappa",
    varkappa: "\\varkappa",
    Lambda: "\\Lambda",
    lambda: "\\lambda",
    Mu: "M",
    mu: "\\mu",
    Nu: "N",
    nu: "\\nu",
    Xi: "\\Xi",
    xi: "\\xi",
    Omicron: "O",
    omicron: "o",
    Pi: "\\Pi",
    pi: "\\pi",
    varpi: "\\varpi",
    Rho: "P",
    rho: "\\rho",
    varrho: "\\varrho",
    Sigma: "\\Sigma",
    sigma: "\\sigma",
    varsigma: "\\varsigma",
    Tau: "T",
    tau: "\\tau",
    Upsilon: "\\Upsilon",
    upsilon: "\\upsilon",
    Phi: "\\Phi",
    phi: "\\phi",
    varphi: "\\varphi",
    Chi: "X",
    chi: "\\chi",
    Psi: "\\Psi",
    psi: "\\psi",
    Omega: "\\Omega",
    omega: "\\omega",
    // logic
    "true": "\\mathrm{True}",
    "false": "\\mathrm{False}",
    // other
    i: "i",
    // TODO use \i ??
    inf: "\\infty",
    Inf: "\\infty",
    infinity: "\\infty",
    Infinity: "\\infty",
    oo: "\\infty",
    lim: "\\lim",
    undefined: "\\mathbf{?}"
};
var $b7deaaf8ee99cf35$export$c728a46e4168cd75 = {
    transpose: "^\\top",
    ctranspose: "^H",
    factorial: "!",
    pow: "^",
    dotPow: ".^\\wedge",
    // TODO find ideal solution
    unaryPlus: "+",
    unaryMinus: "-",
    bitNot: "\\~",
    // TODO find ideal solution
    not: "\\neg",
    multiply: "\\cdot",
    divide: "\\frac",
    // TODO how to handle that properly?
    dotMultiply: ".\\cdot",
    // TODO find ideal solution
    dotDivide: ".:",
    // TODO find ideal solution
    mod: "\\mod",
    add: "+",
    subtract: "-",
    to: "\\rightarrow",
    leftShift: "<<",
    rightArithShift: ">>",
    rightLogShift: ">>>",
    equal: "=",
    unequal: "\\neq",
    smaller: "<",
    larger: ">",
    smallerEq: "\\leq",
    largerEq: "\\geq",
    bitAnd: "\\&",
    bitXor: "\\underline{|}",
    bitOr: "|",
    and: "\\wedge",
    xor: "\\veebar",
    or: "\\vee"
};
var $b7deaaf8ee99cf35$export$b0cfc37067573780 = {
    // arithmetic
    abs: {
        1: "\\left|${args[0]}\\right|"
    },
    add: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.add, "${args[1]}\\right)")
    },
    cbrt: {
        1: "\\sqrt[3]{${args[0]}}"
    },
    ceil: {
        1: "\\left\\lceil${args[0]}\\right\\rceil"
    },
    cube: {
        1: "\\left(${args[0]}\\right)^3"
    },
    divide: {
        2: "\\frac{${args[0]}}{${args[1]}}"
    },
    dotDivide: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.dotDivide, "${args[1]}\\right)")
    },
    dotMultiply: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.dotMultiply, "${args[1]}\\right)")
    },
    dotPow: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.dotPow, "${args[1]}\\right)")
    },
    exp: {
        1: "\\exp\\left(${args[0]}\\right)"
    },
    expm1: "\\left(e".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.pow, "{${args[0]}}-1\\right)"),
    fix: {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
    },
    floor: {
        1: "\\left\\lfloor${args[0]}\\right\\rfloor"
    },
    gcd: "\\gcd\\left(${args}\\right)",
    hypot: "\\hypot\\left(${args}\\right)",
    log: {
        1: "\\ln\\left(${args[0]}\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
    },
    log10: {
        1: "\\log_{10}\\left(${args[0]}\\right)"
    },
    log1p: {
        1: "\\ln\\left(${args[0]}+1\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
    },
    log2: "\\log_{2}\\left(${args[0]}\\right)",
    mod: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.mod, "${args[1]}\\right)")
    },
    multiply: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.multiply, "${args[1]}\\right)")
    },
    norm: {
        1: "\\left\\|${args[0]}\\right\\|",
        2: undefined // use default template
    },
    nthRoot: {
        2: "\\sqrt[${args[1]}]{${args[0]}}"
    },
    nthRoots: {
        2: "\\{y : $y^{args[1]} = {${args[0]}}\\}"
    },
    pow: {
        2: "\\left(${args[0]}\\right)".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.pow, "{${args[1]}}")
    },
    round: {
        1: "\\left\\lfloor${args[0]}\\right\\rceil",
        2: undefined // use default template
    },
    sign: {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
    },
    sqrt: {
        1: "\\sqrt{${args[0]}}"
    },
    square: {
        1: "\\left(${args[0]}\\right)^2"
    },
    subtract: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.subtract, "${args[1]}\\right)")
    },
    unaryMinus: {
        1: "".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.unaryMinus, "\\left(${args[0]}\\right)")
    },
    unaryPlus: {
        1: "".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.unaryPlus, "\\left(${args[0]}\\right)")
    },
    // bitwise
    bitAnd: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.bitAnd, "${args[1]}\\right)")
    },
    bitNot: {
        1: $b7deaaf8ee99cf35$export$c728a46e4168cd75.bitNot + "\\left(${args[0]}\\right)"
    },
    bitOr: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.bitOr, "${args[1]}\\right)")
    },
    bitXor: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.bitXor, "${args[1]}\\right)")
    },
    leftShift: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.leftShift, "${args[1]}\\right)")
    },
    rightArithShift: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.rightArithShift, "${args[1]}\\right)")
    },
    rightLogShift: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.rightLogShift, "${args[1]}\\right)")
    },
    // combinatorics
    bellNumbers: {
        1: "\\mathrm{B}_{${args[0]}}"
    },
    catalan: {
        1: "\\mathrm{C}_{${args[0]}}"
    },
    stirlingS2: {
        2: "\\mathrm{S}\\left(${args}\\right)"
    },
    // complex
    arg: {
        1: "\\arg\\left(${args[0]}\\right)"
    },
    conj: {
        1: "\\left(${args[0]}\\right)^*"
    },
    im: {
        1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
    },
    re: {
        1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
    },
    // logical
    and: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.and, "${args[1]}\\right)")
    },
    not: {
        1: $b7deaaf8ee99cf35$export$c728a46e4168cd75.not + "\\left(${args[0]}\\right)"
    },
    or: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.or, "${args[1]}\\right)")
    },
    xor: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.xor, "${args[1]}\\right)")
    },
    // matrix
    cross: {
        2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
    },
    ctranspose: {
        1: "\\left(${args[0]}\\right)".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.ctranspose)
    },
    det: {
        1: "\\det\\left(${args[0]}\\right)"
    },
    dot: {
        2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
    },
    expm: {
        1: "\\exp\\left(${args[0]}\\right)"
    },
    inv: {
        1: "\\left(${args[0]}\\right)^{-1}"
    },
    sqrtm: {
        1: "{${args[0]}}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.pow, "{\\frac{1}{2}}")
    },
    trace: {
        1: "\\mathrm{tr}\\left(${args[0]}\\right)"
    },
    transpose: {
        1: "\\left(${args[0]}\\right)".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.transpose)
    },
    // probability
    combinations: {
        2: "\\binom{${args[0]}}{${args[1]}}"
    },
    combinationsWithRep: {
        2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
    },
    factorial: {
        1: "\\left(${args[0]}\\right)".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.factorial)
    },
    gamma: {
        1: "\\Gamma\\left(${args[0]}\\right)"
    },
    // relational
    equal: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.equal, "${args[1]}\\right)")
    },
    larger: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.larger, "${args[1]}\\right)")
    },
    largerEq: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.largerEq, "${args[1]}\\right)")
    },
    smaller: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.smaller, "${args[1]}\\right)")
    },
    smallerEq: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.smallerEq, "${args[1]}\\right)")
    },
    unequal: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.unequal, "${args[1]}\\right)")
    },
    // special
    erf: {
        1: "erf\\left(${args[0]}\\right)"
    },
    // statistics
    max: "\\max\\left(${args}\\right)",
    min: "\\min\\left(${args}\\right)",
    variance: "\\mathrm{Var}\\left(${args}\\right)",
    // trigonometry
    acos: {
        1: "\\cos^{-1}\\left(${args[0]}\\right)"
    },
    acosh: {
        1: "\\cosh^{-1}\\left(${args[0]}\\right)"
    },
    acot: {
        1: "\\cot^{-1}\\left(${args[0]}\\right)"
    },
    acoth: {
        1: "\\coth^{-1}\\left(${args[0]}\\right)"
    },
    acsc: {
        1: "\\csc^{-1}\\left(${args[0]}\\right)"
    },
    acsch: {
        1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
    },
    asec: {
        1: "\\sec^{-1}\\left(${args[0]}\\right)"
    },
    asech: {
        1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
    },
    asin: {
        1: "\\sin^{-1}\\left(${args[0]}\\right)"
    },
    asinh: {
        1: "\\sinh^{-1}\\left(${args[0]}\\right)"
    },
    atan: {
        1: "\\tan^{-1}\\left(${args[0]}\\right)"
    },
    atan2: {
        2: "\\mathrm{atan2}\\left(${args}\\right)"
    },
    atanh: {
        1: "\\tanh^{-1}\\left(${args[0]}\\right)"
    },
    cos: {
        1: "\\cos\\left(${args[0]}\\right)"
    },
    cosh: {
        1: "\\cosh\\left(${args[0]}\\right)"
    },
    cot: {
        1: "\\cot\\left(${args[0]}\\right)"
    },
    coth: {
        1: "\\coth\\left(${args[0]}\\right)"
    },
    csc: {
        1: "\\csc\\left(${args[0]}\\right)"
    },
    csch: {
        1: "\\mathrm{csch}\\left(${args[0]}\\right)"
    },
    sec: {
        1: "\\sec\\left(${args[0]}\\right)"
    },
    sech: {
        1: "\\mathrm{sech}\\left(${args[0]}\\right)"
    },
    sin: {
        1: "\\sin\\left(${args[0]}\\right)"
    },
    sinh: {
        1: "\\sinh\\left(${args[0]}\\right)"
    },
    tan: {
        1: "\\tan\\left(${args[0]}\\right)"
    },
    tanh: {
        1: "\\tanh\\left(${args[0]}\\right)"
    },
    // unit
    to: {
        2: "\\left(${args[0]}".concat($b7deaaf8ee99cf35$export$c728a46e4168cd75.to, "${args[1]}\\right)")
    },
    // utils
    numeric: function numeric(node, options) {
        // Not sure if this is strictly right but should work correctly for the vast majority of use cases.
        return node.args[0].toTex();
    },
    // type
    number: {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
    },
    string: {
        0: '\\mathtt{""}',
        1: "\\mathrm{string}\\left(${args[0]}\\right)"
    },
    bignumber: {
        0: "0",
        1: "\\left(${args[0]}\\right)"
    },
    complex: {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)+".concat($b7deaaf8ee99cf35$export$98cd3902fcdeb93d.i, "\\cdot\\left(${args[1]}\\right)\\right)")
    },
    matrix: {
        0: "\\begin{bmatrix}\\end{bmatrix}",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(${args[0]}\\right)"
    },
    sparse: {
        0: "\\begin{bsparse}\\end{bsparse}",
        1: "\\left(${args[0]}\\right)"
    },
    unit: {
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
    }
};
var $b7deaaf8ee99cf35$export$76173758cefa70e5 = "\\mathrm{${name}}\\left(${args}\\right)";
var $b7deaaf8ee99cf35$var$latexUnits = {
    deg: "^\\circ"
};
function $b7deaaf8ee99cf35$export$1b86a510a6af60c2(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($25Ht0)))(string, {
        preserveFormatting: true
    });
} // @param {string} name
function $b7deaaf8ee99cf35$export$358d3bb1a752ff(name, isUnit) {
    isUnit = typeof isUnit === "undefined" ? false : isUnit;
    if (isUnit) {
        if ((0, $glBd7.hasOwnProperty)($b7deaaf8ee99cf35$var$latexUnits, name)) return $b7deaaf8ee99cf35$var$latexUnits[name];
        return "\\mathrm{" + $b7deaaf8ee99cf35$export$1b86a510a6af60c2(name) + "}";
    }
    if ((0, $glBd7.hasOwnProperty)($b7deaaf8ee99cf35$export$98cd3902fcdeb93d, name)) return $b7deaaf8ee99cf35$export$98cd3902fcdeb93d[name];
    return $b7deaaf8ee99cf35$export$1b86a510a6af60c2(name);
}

});
parcelRegister("25Ht0", function(module, exports) {
"use strict";
// Map the characters to escape to their escaped values. The list is derived
// from http://www.cespedes.org/blog/85/how-to-escape-latex-special-characters
var $185dc3feb7d88375$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $185dc3feb7d88375$var$defaultEscapes = {
    "{": "\\{",
    "}": "\\}",
    "\\": "\\textbackslash{}",
    "#": "\\#",
    $: "\\$",
    "%": "\\%",
    "&": "\\&",
    "^": "\\textasciicircum{}",
    _: "\\_",
    "~": "\\textasciitilde{}"
};
var $185dc3feb7d88375$var$formatEscapes = {
    "\u2013": "\\--",
    "\u2014": "\\---",
    " ": "~",
    "	": "\\qquad{}",
    "\r\n": "\\newline{}",
    "\n": "\\newline{}"
};
var $185dc3feb7d88375$var$defaultEscapeMapFn = function defaultEscapeMapFn(defaultEscapes, formatEscapes) {
    return $185dc3feb7d88375$var$_extends({}, defaultEscapes, formatEscapes);
};
/**
 * Escape a string to be used in LaTeX documents.
 * @param {string} str the string to be escaped.
 * @param {boolean} params.preserveFormatting whether formatting escapes should
 *  be performed (default: false).
 * @param {function} params.escapeMapFn the function to modify the escape maps.
 * @return {string} the escaped string, ready to be used in LaTeX.
 */ module.exports = function(str) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$preserveFormatti = _ref.preserveFormatting, preserveFormatting = _ref$preserveFormatti === undefined ? false : _ref$preserveFormatti, _ref$escapeMapFn = _ref.escapeMapFn, escapeMapFn = _ref$escapeMapFn === undefined ? $185dc3feb7d88375$var$defaultEscapeMapFn : _ref$escapeMapFn;
    var runningStr = String(str);
    var result = "";
    var escapes = escapeMapFn($185dc3feb7d88375$var$_extends({}, $185dc3feb7d88375$var$defaultEscapes), preserveFormatting ? $185dc3feb7d88375$var$_extends({}, $185dc3feb7d88375$var$formatEscapes) : {});
    var escapeKeys = Object.keys(escapes); // as it is reused later on
    // Algorithm: Go through the string character by character, if it matches
    // with one of the special characters then we'll replace it with the escaped
    // version.
    var _loop = function _loop() {
        var specialCharFound = false;
        escapeKeys.forEach(function(key, index) {
            if (specialCharFound) return;
            if (runningStr.length >= key.length && runningStr.slice(0, key.length) === key) {
                result += escapes[escapeKeys[index]];
                runningStr = runningStr.slice(key.length, runningStr.length);
                specialCharFound = true;
            }
        });
        if (!specialCharFound) {
            result += runningStr.slice(0, 1);
            runningStr = runningStr.slice(1, runningStr.length);
        }
    };
    while(runningStr)_loop();
    return result;
};

});



parcelRegister("5Wo7R", function(module, exports) {

$parcel$export(module.exports, "createDerivative", function () { return $45351569b1e09552$export$d1d6fcabea5d55e0; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $45351569b1e09552$var$name = "derivative";
var $45351569b1e09552$var$dependencies = [
    "typed",
    "config",
    "parse",
    "simplify",
    "equal",
    "isZero",
    "numeric",
    "ConstantNode",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $45351569b1e09552$export$d1d6fcabea5d55e0 = /* #__PURE__ */ (0, $jKx4O.factory)($45351569b1e09552$var$name, $45351569b1e09552$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, parse = _ref.parse, simplify = _ref.simplify, equal = _ref.equal, isZero = _ref.isZero, numeric = _ref.numeric, ConstantNode = _ref.ConstantNode, FunctionNode = _ref.FunctionNode, OperatorNode = _ref.OperatorNode, ParenthesisNode = _ref.ParenthesisNode, SymbolNode = _ref.SymbolNode;
    /**
   * Takes the derivative of an expression expressed in parser Nodes.
   * The derivative will be taken over the supplied variable in the
   * second parameter. If there are multiple variables in the expression,
   * it will return a partial derivative.
   *
   * This uses rules of differentiation which can be found here:
   *
   * - [Differentiation rules (Wikipedia)](https://en.wikipedia.org/wiki/Differentiation_rules)
   *
   * Syntax:
   *
   *     derivative(expr, variable)
   *     derivative(expr, variable, options)
   *
   * Examples:
   *
   *     math.derivative('x^2', 'x')                     // Node {2 * x}
   *     math.derivative('x^2', 'x', {simplify: false})  // Node {2 * 1 * x ^ (2 - 1)
   *     math.derivative('sin(2x)', 'x'))                // Node {2 * cos(2 * x)}
   *     math.derivative('2*x', 'x').evaluate()          // number 2
   *     math.derivative('x^2', 'x').evaluate({x: 4})    // number 8
   *     const f = math.parse('x^2')
   *     const x = math.parse('x')
   *     math.derivative(f, x)                           // Node {2 * x}
   *
   * See also:
   *
   *     simplify, parse, evaluate
   *
   * @param  {Node | string} expr           The expression to differentiate
   * @param  {SymbolNode | string} variable The variable over which to differentiate
   * @param  {{simplify: boolean}} [options]
   *                         There is one option available, `simplify`, which
   *                         is true by default. When false, output will not
   *                         be simplified.
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
   */ var derivative = typed("derivative", {
        "Node, SymbolNode, Object": function NodeSymbolNodeObject(expr, variable, options) {
            var constNodes = {};
            constTag(constNodes, expr, variable.name);
            var res = _derivative(expr, constNodes);
            return options.simplify ? simplify(res) : res;
        },
        "Node, SymbolNode": function NodeSymbolNode(expr, variable) {
            return derivative(expr, variable, {
                simplify: true
            });
        },
        "string, SymbolNode": function stringSymbolNode(expr, variable) {
            return derivative(parse(expr), variable);
        },
        "string, SymbolNode, Object": function stringSymbolNodeObject(expr, variable, options) {
            return derivative(parse(expr), variable, options);
        },
        "string, string": function stringString(expr, variable) {
            return derivative(parse(expr), parse(variable));
        },
        "string, string, Object": function stringStringObject(expr, variable, options) {
            return derivative(parse(expr), parse(variable), options);
        },
        "Node, string": function NodeString(expr, variable) {
            return derivative(expr, parse(variable));
        },
        "Node, string, Object": function NodeStringObject(expr, variable, options) {
            return derivative(expr, parse(variable), options);
        } // TODO: replace the 8 signatures above with 4 as soon as typed-function supports optional arguments
    });
    derivative._simplify = true;
    derivative.toTex = function(deriv) {
        return _derivTex.apply(null, deriv.args);
    }; // FIXME: move the toTex method of derivative to latex.js. Difficulty is that it relies on parse.
    // NOTE: the optional "order" parameter here is currently unused
    var _derivTex = typed("_derivTex", {
        "Node, SymbolNode": function NodeSymbolNode(expr, x) {
            if ((0, $7E0JQ.isConstantNode)(expr) && (0, $7E0JQ.typeOf)(expr.value) === "string") return _derivTex(parse(expr.value).toString(), x.toString(), 1);
            else return _derivTex(expr.toString(), x.toString(), 1);
        },
        "Node, ConstantNode": function NodeConstantNode(expr, x) {
            if ((0, $7E0JQ.typeOf)(x.value) === "string") return _derivTex(expr, parse(x.value));
            else throw new Error("The second parameter to 'derivative' is a non-string constant");
        },
        "Node, SymbolNode, ConstantNode": function NodeSymbolNodeConstantNode(expr, x, order) {
            return _derivTex(expr.toString(), x.name, order.value);
        },
        "string, string, number": function stringStringNumber(expr, x, order) {
            var d;
            if (order === 1) d = "{d\\over d" + x + "}";
            else d = "{d^{" + order + "}\\over d" + x + "^{" + order + "}}";
            return d + "\\left[".concat(expr, "\\right]");
        }
    });
    /**
   * Does a depth-first search on the expression tree to identify what Nodes
   * are constants (e.g. 2 + 2), and stores the ones that are constants in
   * constNodes. Classification is done as follows:
   *
   *   1. ConstantNodes are constants.
   *   2. If there exists a SymbolNode, of which we are differentiating over,
   *      in the subtree it is not constant.
   *
   * @param  {Object} constNodes  Holds the nodes that are constant
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {string} varName     Variable that we are differentiating
   * @return {boolean}  if node is constant
   */ // TODO: can we rewrite constTag into a pure function?
    var constTag = typed("constTag", {
        "Object, ConstantNode, string": function ObjectConstantNodeString(constNodes, node) {
            constNodes[node] = true;
            return true;
        },
        "Object, SymbolNode, string": function ObjectSymbolNodeString(constNodes, node, varName) {
            // Treat other variables like constants. For reasoning, see:
            //   https://en.wikipedia.org/wiki/Partial_derivative
            if (node.name !== varName) {
                constNodes[node] = true;
                return true;
            }
            return false;
        },
        "Object, ParenthesisNode, string": function ObjectParenthesisNodeString(constNodes, node, varName) {
            return constTag(constNodes, node.content, varName);
        },
        "Object, FunctionAssignmentNode, string": function ObjectFunctionAssignmentNodeString(constNodes, node, varName) {
            if (node.params.indexOf(varName) === -1) {
                constNodes[node] = true;
                return true;
            }
            return constTag(constNodes, node.expr, varName);
        },
        "Object, FunctionNode | OperatorNode, string": function ObjectFunctionNodeOperatorNodeString(constNodes, node, varName) {
            if (node.args.length > 0) {
                var isConst = constTag(constNodes, node.args[0], varName);
                for(var i = 1; i < node.args.length; ++i)isConst = constTag(constNodes, node.args[i], varName) && isConst;
                if (isConst) {
                    constNodes[node] = true;
                    return true;
                }
            }
            return false;
        }
    });
    /**
   * Applies differentiation rules.
   *
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {Object} constNodes  Holds the nodes that are constant
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
   */ var _derivative = typed("_derivative", {
        "ConstantNode, Object": function ConstantNodeObject(node) {
            return createConstantNode(0);
        },
        "SymbolNode, Object": function SymbolNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            return createConstantNode(1);
        },
        "ParenthesisNode, Object": function ParenthesisNodeObject(node, constNodes) {
            return new ParenthesisNode(_derivative(node.content, constNodes));
        },
        "FunctionAssignmentNode, Object": function FunctionAssignmentNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            return _derivative(node.expr, constNodes);
        },
        "FunctionNode, Object": function FunctionNodeObject(node, constNodes) {
            if (node.args.length !== 1) funcArgsCheck(node);
            if (constNodes[node] !== undefined) return createConstantNode(0);
            var arg0 = node.args[0];
            var arg1;
            var div = false; // is output a fraction?
            var negative = false; // is output negative?
            var funcDerivative;
            switch(node.name){
                case "cbrt":
                    // d/dx(cbrt(x)) = 1 / (3x^(2/3))
                    div = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        createConstantNode(3),
                        new OperatorNode("^", "pow", [
                            arg0,
                            new OperatorNode("/", "divide", [
                                createConstantNode(2),
                                createConstantNode(3)
                            ])
                        ])
                    ]);
                    break;
                case "sqrt":
                case "nthRoot":
                    // d/dx(sqrt(x)) = 1 / (2*sqrt(x))
                    if (node.args.length === 1) {
                        div = true;
                        funcDerivative = new OperatorNode("*", "multiply", [
                            createConstantNode(2),
                            new FunctionNode("sqrt", [
                                arg0
                            ])
                        ]);
                    } else if (node.args.length === 2) {
                        // Rearrange from nthRoot(x, a) -> x^(1/a)
                        arg1 = new OperatorNode("/", "divide", [
                            createConstantNode(1),
                            node.args[1]
                        ]); // Is a variable?
                        constNodes[arg1] = constNodes[node.args[1]];
                        return _derivative(new OperatorNode("^", "pow", [
                            arg0,
                            arg1
                        ]), constNodes);
                    }
                    break;
                case "log10":
                    arg1 = createConstantNode(10);
                /* fall through! */ case "log":
                    if (!arg1 && node.args.length === 1) {
                        // d/dx(log(x)) = 1 / x
                        funcDerivative = arg0.clone();
                        div = true;
                    } else if (node.args.length === 1 && arg1 || node.args.length === 2 && constNodes[node.args[1]] !== undefined) {
                        // d/dx(log(x, c)) = 1 / (x*ln(c))
                        funcDerivative = new OperatorNode("*", "multiply", [
                            arg0.clone(),
                            new FunctionNode("log", [
                                arg1 || node.args[1]
                            ])
                        ]);
                        div = true;
                    } else if (node.args.length === 2) // d/dx(log(f(x), g(x))) = d/dx(log(f(x)) / log(g(x)))
                    return _derivative(new OperatorNode("/", "divide", [
                        new FunctionNode("log", [
                            arg0
                        ]),
                        new FunctionNode("log", [
                            node.args[1]
                        ])
                    ]), constNodes);
                    break;
                case "pow":
                    constNodes[arg1] = constNodes[node.args[1]]; // Pass to pow operator node parser
                    return _derivative(new OperatorNode("^", "pow", [
                        arg0,
                        node.args[1]
                    ]), constNodes);
                case "exp":
                    // d/dx(e^x) = e^x
                    funcDerivative = new FunctionNode("exp", [
                        arg0.clone()
                    ]);
                    break;
                case "sin":
                    // d/dx(sin(x)) = cos(x)
                    funcDerivative = new FunctionNode("cos", [
                        arg0.clone()
                    ]);
                    break;
                case "cos":
                    // d/dx(cos(x)) = -sin(x)
                    funcDerivative = new OperatorNode("-", "unaryMinus", [
                        new FunctionNode("sin", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "tan":
                    // d/dx(tan(x)) = sec(x)^2
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("sec", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "sec":
                    // d/dx(sec(x)) = sec(x)tan(x)
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("tan", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "csc":
                    // d/dx(csc(x)) = -csc(x)cot(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("cot", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "cot":
                    // d/dx(cot(x)) = -csc(x)^2
                    negative = true;
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("csc", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "asin":
                    // d/dx(asin(x)) = 1 / sqrt(1 - x^2)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            createConstantNode(1),
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ])
                        ])
                    ]);
                    break;
                case "acos":
                    // d/dx(acos(x)) = -1 / sqrt(1 - x^2)
                    div = true;
                    negative = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            createConstantNode(1),
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ])
                        ])
                    ]);
                    break;
                case "atan":
                    // d/dx(atan(x)) = 1 / (x^2 + 1)
                    div = true;
                    funcDerivative = new OperatorNode("+", "add", [
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ]),
                        createConstantNode(1)
                    ]);
                    break;
                case "asec":
                    // d/dx(asec(x)) = 1 / (|x|*sqrt(x^2 - 1))
                    div = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acsc":
                    // d/dx(acsc(x)) = -1 / (|x|*sqrt(x^2 - 1))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acot":
                    // d/dx(acot(x)) = -1 / (x^2 + 1)
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("+", "add", [
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ]),
                        createConstantNode(1)
                    ]);
                    break;
                case "sinh":
                    // d/dx(sinh(x)) = cosh(x)
                    funcDerivative = new FunctionNode("cosh", [
                        arg0.clone()
                    ]);
                    break;
                case "cosh":
                    // d/dx(cosh(x)) = sinh(x)
                    funcDerivative = new FunctionNode("sinh", [
                        arg0.clone()
                    ]);
                    break;
                case "tanh":
                    // d/dx(tanh(x)) = sech(x)^2
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("sech", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "sech":
                    // d/dx(sech(x)) = -sech(x)tanh(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("tanh", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "csch":
                    // d/dx(csch(x)) = -csch(x)coth(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("coth", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "coth":
                    // d/dx(coth(x)) = -csch(x)^2
                    negative = true;
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("csch", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "asinh":
                    // d/dx(asinh(x)) = 1 / sqrt(x^2 + 1)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("+", "add", [
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ]),
                            createConstantNode(1)
                        ])
                    ]);
                    break;
                case "acosh":
                    // d/dx(acosh(x)) = 1 / sqrt(x^2 - 1); XXX potentially only for x >= 1 (the real spectrum)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ]),
                            createConstantNode(1)
                        ])
                    ]);
                    break;
                case "atanh":
                    // d/dx(atanh(x)) = 1 / (1 - x^2)
                    div = true;
                    funcDerivative = new OperatorNode("-", "subtract", [
                        createConstantNode(1),
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ])
                    ]);
                    break;
                case "asech":
                    // d/dx(asech(x)) = -1 / (x*sqrt(1 - x^2))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        arg0.clone(),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                createConstantNode(1),
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ])
                            ])
                        ])
                    ]);
                    break;
                case "acsch":
                    // d/dx(acsch(x)) = -1 / (|x|*sqrt(x^2 + 1))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("+", "add", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acoth":
                    // d/dx(acoth(x)) = -1 / (1 - x^2)
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("-", "subtract", [
                        createConstantNode(1),
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ])
                    ]);
                    break;
                case "abs":
                    // d/dx(abs(x)) = abs(x)/x
                    funcDerivative = new OperatorNode("/", "divide", [
                        new FunctionNode(new SymbolNode("abs"), [
                            arg0.clone()
                        ]),
                        arg0.clone()
                    ]);
                    break;
                case "gamma":
                default:
                    throw new Error('Function "' + node.name + '" is not supported by derivative, or a wrong number of arguments is passed');
            }
            var op, func;
            if (div) {
                op = "/";
                func = "divide";
            } else {
                op = "*";
                func = "multiply";
            }
            /* Apply chain rule to all functions:
         F(x)  = f(g(x))
         F'(x) = g'(x)*f'(g(x)) */ var chainDerivative = _derivative(arg0, constNodes);
            if (negative) chainDerivative = new OperatorNode("-", "unaryMinus", [
                chainDerivative
            ]);
            return new OperatorNode(op, func, [
                chainDerivative,
                funcDerivative
            ]);
        },
        "OperatorNode, Object": function OperatorNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            if (node.op === "+") // d/dx(sum(f(x)) = sum(f'(x))
            return new OperatorNode(node.op, node.fn, node.args.map(function(arg) {
                return _derivative(arg, constNodes);
            }));
            if (node.op === "-") {
                // d/dx(+/-f(x)) = +/-f'(x)
                if (node.isUnary()) return new OperatorNode(node.op, node.fn, [
                    _derivative(node.args[0], constNodes)
                ]);
                 // Linearity of differentiation, d/dx(f(x) +/- g(x)) = f'(x) +/- g'(x)
                if (node.isBinary()) return new OperatorNode(node.op, node.fn, [
                    _derivative(node.args[0], constNodes),
                    _derivative(node.args[1], constNodes)
                ]);
            }
            if (node.op === "*") {
                // d/dx(c*f(x)) = c*f'(x)
                var constantTerms = node.args.filter(function(arg) {
                    return constNodes[arg] !== undefined;
                });
                if (constantTerms.length > 0) {
                    var nonConstantTerms = node.args.filter(function(arg) {
                        return constNodes[arg] === undefined;
                    });
                    var nonConstantNode = nonConstantTerms.length === 1 ? nonConstantTerms[0] : new OperatorNode("*", "multiply", nonConstantTerms);
                    var newArgs = constantTerms.concat(_derivative(nonConstantNode, constNodes));
                    return new OperatorNode("*", "multiply", newArgs);
                } // Product Rule, d/dx(f(x)*g(x)) = f'(x)*g(x) + f(x)*g'(x)
                return new OperatorNode("+", "add", node.args.map(function(argOuter) {
                    return new OperatorNode("*", "multiply", node.args.map(function(argInner) {
                        return argInner === argOuter ? _derivative(argInner, constNodes) : argInner.clone();
                    }));
                }));
            }
            if (node.op === "/" && node.isBinary()) {
                var arg0 = node.args[0];
                var arg1 = node.args[1]; // d/dx(f(x) / c) = f'(x) / c
                if (constNodes[arg1] !== undefined) return new OperatorNode("/", "divide", [
                    _derivative(arg0, constNodes),
                    arg1
                ]);
                 // Reciprocal Rule, d/dx(c / f(x)) = -c(f'(x)/f(x)^2)
                if (constNodes[arg0] !== undefined) return new OperatorNode("*", "multiply", [
                    new OperatorNode("-", "unaryMinus", [
                        arg0
                    ]),
                    new OperatorNode("/", "divide", [
                        _derivative(arg1, constNodes),
                        new OperatorNode("^", "pow", [
                            arg1.clone(),
                            createConstantNode(2)
                        ])
                    ])
                ]);
                 // Quotient rule, d/dx(f(x) / g(x)) = (f'(x)g(x) - f(x)g'(x)) / g(x)^2
                return new OperatorNode("/", "divide", [
                    new OperatorNode("-", "subtract", [
                        new OperatorNode("*", "multiply", [
                            _derivative(arg0, constNodes),
                            arg1.clone()
                        ]),
                        new OperatorNode("*", "multiply", [
                            arg0.clone(),
                            _derivative(arg1, constNodes)
                        ])
                    ]),
                    new OperatorNode("^", "pow", [
                        arg1.clone(),
                        createConstantNode(2)
                    ])
                ]);
            }
            if (node.op === "^" && node.isBinary()) {
                var _arg = node.args[0];
                var _arg2 = node.args[1];
                if (constNodes[_arg] !== undefined) {
                    // If is secretly constant; 0^f(x) = 1 (in JS), 1^f(x) = 1
                    if ((0, $7E0JQ.isConstantNode)(_arg) && (isZero(_arg.value) || equal(_arg.value, 1))) return createConstantNode(0);
                     // d/dx(c^f(x)) = c^f(x)*ln(c)*f'(x)
                    return new OperatorNode("*", "multiply", [
                        node,
                        new OperatorNode("*", "multiply", [
                            new FunctionNode("log", [
                                _arg.clone()
                            ]),
                            _derivative(_arg2.clone(), constNodes)
                        ])
                    ]);
                }
                if (constNodes[_arg2] !== undefined) {
                    if ((0, $7E0JQ.isConstantNode)(_arg2)) {
                        // If is secretly constant; f(x)^0 = 1 -> d/dx(1) = 0
                        if (isZero(_arg2.value)) return createConstantNode(0);
                         // Ignore exponent; f(x)^1 = f(x)
                        if (equal(_arg2.value, 1)) return _derivative(_arg, constNodes);
                    } // Elementary Power Rule, d/dx(f(x)^c) = c*f'(x)*f(x)^(c-1)
                    var powMinusOne = new OperatorNode("^", "pow", [
                        _arg.clone(),
                        new OperatorNode("-", "subtract", [
                            _arg2,
                            createConstantNode(1)
                        ])
                    ]);
                    return new OperatorNode("*", "multiply", [
                        _arg2.clone(),
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg, constNodes),
                            powMinusOne
                        ])
                    ]);
                } // Functional Power Rule, d/dx(f^g) = f^g*[f'*(g/f) + g'ln(f)]
                return new OperatorNode("*", "multiply", [
                    new OperatorNode("^", "pow", [
                        _arg.clone(),
                        _arg2.clone()
                    ]),
                    new OperatorNode("+", "add", [
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg, constNodes),
                            new OperatorNode("/", "divide", [
                                _arg2.clone(),
                                _arg.clone()
                            ])
                        ]),
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg2, constNodes),
                            new FunctionNode("log", [
                                _arg.clone()
                            ])
                        ])
                    ])
                ]);
            }
            throw new Error('Operator "' + node.op + '" is not supported by derivative, or a wrong number of arguments is passed');
        }
    });
    /**
   * Ensures the number of arguments for a function are correct,
   * and will throw an error otherwise.
   *
   * @param {FunctionNode} node
   */ function funcArgsCheck(node) {
        // TODO add min, max etc
        if ((node.name === "log" || node.name === "nthRoot" || node.name === "pow") && node.args.length === 2) return;
         // There should be an incorrect number of arguments if we reach here
        // Change all args to constants to avoid unidentified
        // symbol error when compiling function
        for(var i = 0; i < node.args.length; ++i)node.args[i] = createConstantNode(0);
        node.compile().evaluate();
        throw new Error("Expected TypeError, but none found");
    }
    /**
   * Helper function to create a constant node with a specific type
   * (number, BigNumber, Fraction)
   * @param {number} value
   * @param {string} [valueType]
   * @return {ConstantNode}
   */ function createConstantNode(value, valueType) {
        return new ConstantNode(numeric(value, valueType || config.number));
    }
    return derivative;
});

});

parcelRegister("5bQtu", function(module, exports) {

$parcel$export(module.exports, "createEvaluate", function () { return $3c76af2eee48fa84$export$4f825d0ade64f616; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");
var $3c76af2eee48fa84$var$name = "evaluate";
var $3c76af2eee48fa84$var$dependencies = [
    "typed",
    "parse"
];
var $3c76af2eee48fa84$export$4f825d0ade64f616 = /* #__PURE__ */ (0, $jKx4O.factory)($3c76af2eee48fa84$var$name, $3c76af2eee48fa84$var$dependencies, function(_ref) {
    var typed = _ref.typed, parse = _ref.parse;
    /**
   * Evaluate an expression.
   *
   * Note the evaluating arbitrary expressions may involve security risks,
   * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
   *
   * Syntax:
   *
   *     math.evaluate(expr)
   *     math.evaluate(expr, scope)
   *     math.evaluate([expr1, expr2, expr3, ...])
   *     math.evaluate([expr1, expr2, expr3, ...], scope)
   *
   * Example:
   *
   *     math.evaluate('(2+3)/4')                // 1.25
   *     math.evaluate('sqrt(3^2 + 4^2)')        // 5
   *     math.evaluate('sqrt(-4)')               // 2i
   *     math.evaluate(['a=3', 'b=4', 'a*b'])    // [3, 4, 12]
   *
   *     let scope = {a:3, b:4}
   *     math.evaluate('a * b', scope)           // 12
   *
   * See also:
   *
   *    parse, compile
   *
   * @param {string | string[] | Matrix} expr   The expression to be evaluated
   * @param {Object} [scope]                    Scope to read/write variables
   * @return {*} The result of the expression
   * @throws {Error}
   */ return typed($3c76af2eee48fa84$var$name, {
        string: function string(expr) {
            var scope = {};
            return parse(expr).compile().evaluate(scope);
        },
        "string, Object": function stringObject(expr, scope) {
            return parse(expr).compile().evaluate(scope);
        },
        "Array | Matrix": function ArrayMatrix(expr) {
            var scope = {};
            return (0, $fbkGg.deepMap)(expr, function(entry) {
                return parse(entry).compile().evaluate(scope);
            });
        },
        "Array | Matrix, Object": function ArrayMatrixObject(expr, scope) {
            return (0, $fbkGg.deepMap)(expr, function(entry) {
                return parse(entry).compile().evaluate(scope);
            });
        }
    });
});

});

parcelRegister("4QA7C", function(module, exports) {

$parcel$export(module.exports, "createFilterTransform", function () { return $387809d111749fb8$export$a53d7aa4a2c1e7e3; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $lMDm0 = parcelRequire("lMDm0");

var $41M2q = parcelRequire("41M2q");

var $jKx4O = parcelRequire("jKx4O");
var $387809d111749fb8$var$name = "filter";
var $387809d111749fb8$var$dependencies = [
    "typed"
];
var $387809d111749fb8$export$a53d7aa4a2c1e7e3 = /* #__PURE__ */ (0, $jKx4O.factory)($387809d111749fb8$var$name, $387809d111749fb8$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Attach a transform function to math.filter
   * Adds a property transform containing the transform function.
   *
   * This transform adds support for equations as test function for math.filter,
   * so you can do something like 'filter([3, -2, 5], x > 0)'.
   */ function filterTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $7E0JQ.isSymbolNode)(args[1]) || (0, $7E0JQ.isFunctionAssignmentNode)(args[1])) // a function pointer, like filter([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like filter([3, -2, 5], x > 0)
            callback = (0, $41M2q.compileInlineExpression)(args[1], math, scope);
        }
        return filter(x, callback);
    }
    filterTransform.rawArgs = true; // one based version of function filter
    var filter = typed("filter", {
        "Array, function": $387809d111749fb8$var$_filter,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($387809d111749fb8$var$_filter(x.toArray(), test));
        },
        "Array, RegExp": (0, $YkZ7e.filterRegExp),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $YkZ7e.filterRegExp)(x.toArray(), test));
        }
    });
    return filterTransform;
}, {
    isTransformFunction: true
});
/**
 * Filter values in a callback given a callback function
 *
 * !!! Passes a one-based index !!!
 *
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $387809d111749fb8$var$_filter(x, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $lMDm0.maxArgumentCount)(callback);
    return (0, $YkZ7e.filter)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        if (args === 1) return callback(value);
        else if (args === 2) return callback(value, [
            index + 1
        ]);
        else // 3 or -1
        return callback(value, [
            index + 1
        ], array);
    });
}

});
parcelRegister("lMDm0", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $fdbc9b8d6c6ed5c1$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "maxArgumentCount", function () { return $fdbc9b8d6c6ed5c1$export$6c00fba23f8c91a7; });
function $fdbc9b8d6c6ed5c1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fdbc9b8d6c6ed5c1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fdbc9b8d6c6ed5c1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fdbc9b8d6c6ed5c1$var$_typeof(obj);
}
function $fdbc9b8d6c6ed5c1$export$fc10aeed3a532e2a(fn, hasher) {
    return function memoize() {
        if ($fdbc9b8d6c6ed5c1$var$_typeof(memoize.cache) !== "object") memoize.cache = {};
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        var hash = hasher ? hasher(args) : JSON.stringify(args);
        if (!(hash in memoize.cache)) memoize.cache[hash] = fn.apply(fn, args);
        return memoize.cache[hash];
    };
}
function $fdbc9b8d6c6ed5c1$export$22992fec26710d5a(fn, isEqual) {
    var memoize = function memoize() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        for(var c = 0; c < memoize.cache.length; c++){
            var cached = memoize.cache[c];
            if (isEqual(args, cached.args)) // TODO: move this cache entry to the top so recently used entries move up?
            return cached.res;
        }
        var res = fn.apply(fn, args);
        memoize.cache.unshift({
            args: args,
            res: res
        });
        return res;
    };
    memoize.cache = [];
    return memoize;
}
function $fdbc9b8d6c6ed5c1$export$6c00fba23f8c91a7(fn) {
    return Object.keys(fn.signatures || {}).reduce(function(args, signature) {
        var count = (signature.match(/,/g) || []).length + 1;
        return Math.max(args, count);
    }, -1);
}

});

parcelRegister("41M2q", function(module, exports) {

$parcel$export(module.exports, "compileInlineExpression", function () { return $2eec84c7f98658d7$export$cbb6101da03c2e83; });

var $7E0JQ = parcelRequire("7E0JQ");
function $2eec84c7f98658d7$export$cbb6101da03c2e83(expression, math, scope) {
    // find an undefined symbol
    var symbol = expression.filter(function(node) {
        return (0, $7E0JQ.isSymbolNode)(node) && !(node.name in math) && !(node.name in scope);
    })[0];
    if (!symbol) throw new Error('No undefined variable found in inline expression "' + expression + '"');
     // create a test function for this equation
    var name = symbol.name; // variable name
    var subScope = Object.create(scope);
    var eq = expression.compile();
    return function inlineExpression(x) {
        subScope[name] = x;
        return eq.evaluate(subScope);
    };
}

});


parcelRegister("gfkt3", function(module, exports) {

$parcel$export(module.exports, "createForEachTransform", function () { return $bd3dec83584cf23a$export$342aa09106704265; });

var $7E0JQ = parcelRequire("7E0JQ");

var $lMDm0 = parcelRequire("lMDm0");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");

var $41M2q = parcelRequire("41M2q");
var $bd3dec83584cf23a$var$name = "forEach";
var $bd3dec83584cf23a$var$dependencies = [
    "typed"
];
var $bd3dec83584cf23a$export$342aa09106704265 = /* #__PURE__ */ (0, $jKx4O.factory)($bd3dec83584cf23a$var$name, $bd3dec83584cf23a$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Attach a transform function to math.forEach
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ function forEachTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $7E0JQ.isSymbolNode)(args[1]) || (0, $7E0JQ.isFunctionAssignmentNode)(args[1])) // a function pointer, like forEach([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like forEach([3, -2, 5], x > 0 ? callback1(x) : callback2(x) )
            callback = (0, $41M2q.compileInlineExpression)(args[1], math, scope);
        }
        return _forEach(x, callback);
    }
    forEachTransform.rawArgs = true; // one-based version of forEach
    var _forEach = typed("forEach", {
        "Array | Matrix, function": function ArrayMatrixFunction(array, callback) {
            // figure out what number of arguments the callback function expects
            var args = (0, $lMDm0.maxArgumentCount)(callback);
            var recurse = function recurse(value, index) {
                if (Array.isArray(value)) (0, $YkZ7e.forEach)(value, function(child, i) {
                    // we create a copy of the index array and append the new index value
                    recurse(child, index.concat(i + 1)); // one based index, hence i+1
                });
                else {
                    // invoke the callback function with the right number of arguments
                    if (args === 1) callback(value);
                    else if (args === 2) callback(value, index);
                    else // 3 or -1
                    callback(value, index, array);
                }
            };
            recurse(array.valueOf(), []); // pass Array
        }
    });
    return forEachTransform;
}, {
    isTransformFunction: true
});

});

parcelRegister("4jb1x", function(module, exports) {

$parcel$export(module.exports, "createFunctionAssignmentNode", function () { return $32317cd9b684237d$export$fd037c04876b4924; });

var $7E0JQ = parcelRequire("7E0JQ");

var $6cmon = parcelRequire("6cmon");

var $7HWRb = parcelRequire("7HWRb");

var $YkZ7e = parcelRequire("YkZ7e");

var $fMJxQ = parcelRequire("fMJxQ");

var $7OD47 = parcelRequire("7OD47");

var $i3n6j = parcelRequire("i3n6j");

var $jKx4O = parcelRequire("jKx4O");
var $32317cd9b684237d$var$name = "FunctionAssignmentNode";
var $32317cd9b684237d$var$dependencies = [
    "typed",
    "Node"
];
var $32317cd9b684237d$export$fd037c04876b4924 = /* #__PURE__ */ (0, $jKx4O.factory)($32317cd9b684237d$var$name, $32317cd9b684237d$var$dependencies, function(_ref) {
    var typed = _ref.typed, Node = _ref.Node;
    /**
   * @constructor FunctionAssignmentNode
   * @extends {Node}
   * Function assignment
   *
   * @param {string} name           Function name
   * @param {string[] | Array.<{name: string, type: string}>} params
   *                                Array with function parameter names, or an
   *                                array with objects containing the name
   *                                and type of the parameter
   * @param {Node} expr             The function expression
   */ function FunctionAssignmentNode(name, params, expr) {
        if (!(this instanceof FunctionAssignmentNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof name !== "string") throw new TypeError('String expected for parameter "name"');
        if (!Array.isArray(params)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
        if (!(0, $7E0JQ.isNode)(expr)) throw new TypeError('Node expected for parameter "expr"');
        if (name in (0, $6cmon.keywords)) throw new Error('Illegal function name, "' + name + '" is a reserved keyword');
        this.name = name;
        this.params = params.map(function(param) {
            return param && param.name || param;
        });
        this.types = params.map(function(param) {
            return param && param.type || "any";
        });
        this.expr = expr;
    }
    FunctionAssignmentNode.prototype = new Node();
    FunctionAssignmentNode.prototype.type = "FunctionAssignmentNode";
    FunctionAssignmentNode.prototype.isFunctionAssignmentNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ FunctionAssignmentNode.prototype._compile = function(math, argNames) {
        var childArgNames = Object.create(argNames);
        (0, $YkZ7e.forEach)(this.params, function(param) {
            childArgNames[param] = true;
        }); // compile the function expression with the child args
        var evalExpr = this.expr._compile(math, childArgNames);
        var name = this.name;
        var params = this.params;
        var signature = (0, $YkZ7e.join)(this.types, ",");
        var syntax = name + "(" + (0, $YkZ7e.join)(this.params, ", ") + ")";
        return function evalFunctionAssignmentNode(scope, args, context) {
            var signatures = {};
            signatures[signature] = function() {
                var childArgs = Object.create(args);
                for(var i = 0; i < params.length; i++)childArgs[params[i]] = arguments[i];
                return evalExpr(scope, childArgs, context);
            };
            var fn = typed(name, signatures);
            fn.syntax = syntax;
            (0, $i3n6j.setSafeProperty)(scope, name, fn);
            return fn;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ FunctionAssignmentNode.prototype.forEach = function(callback) {
        callback(this.expr, "expr", this);
    };
    /**
   * Create a new FunctionAssignmentNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
   */ FunctionAssignmentNode.prototype.map = function(callback) {
        var expr = this._ifNode(callback(this.expr, "expr", this));
        return new FunctionAssignmentNode(this.name, this.params.slice(0), expr);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {FunctionAssignmentNode}
   */ FunctionAssignmentNode.prototype.clone = function() {
        return new FunctionAssignmentNode(this.name, this.params.slice(0), this.expr);
    };
    /**
   * Is parenthesis needed?
   * @param {Node} node
   * @param {Object} parenthesis
   * @private
   */ function needParenthesis(node, parenthesis) {
        var precedence = (0, $7OD47.getPrecedence)(node, parenthesis);
        var exprPrecedence = (0, $7OD47.getPrecedence)(node.expr, parenthesis);
        return parenthesis === "all" || exprPrecedence !== null && exprPrecedence <= precedence;
    }
    /**
   * get string representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var expr = this.expr.toString(options);
        if (needParenthesis(this, parenthesis)) expr = "(" + expr + ")";
        return this.name + "(" + this.params.join(", ") + ") = " + expr;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ FunctionAssignmentNode.prototype.toJSON = function() {
        var types = this.types;
        return {
            mathjs: "FunctionAssignmentNode",
            name: this.name,
            params: this.params.map(function(param, index) {
                return {
                    name: param,
                    type: types[index]
                };
            }),
            expr: this.expr
        };
    };
    /**
   * Instantiate an FunctionAssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "FunctionAssignmentNode", name: ..., params: ..., expr: ...}`,
   *                       where mathjs is optional
   * @returns {FunctionAssignmentNode}
   */ FunctionAssignmentNode.fromJSON = function(json) {
        return new FunctionAssignmentNode(json.name, json.params, json.expr);
    };
    /**
   * get HTML representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var params = [];
        for(var i = 0; i < this.params.length; i++)params.push('<span class="math-symbol math-parameter">' + (0, $7HWRb.escape)(this.params[i]) + "</span>");
        var expr = this.expr.toHTML(options);
        if (needParenthesis(this, parenthesis)) expr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + expr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return '<span class="math-function">' + (0, $7HWRb.escape)(this.name) + "</span>" + '<span class="math-parenthesis math-round-parenthesis">(</span>' + params.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + expr;
    };
    /**
   * get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var expr = this.expr.toTex(options);
        if (needParenthesis(this, parenthesis)) expr = "\\left(".concat(expr, "\\right)");
        return "\\mathrm{" + this.name + "}\\left(" + this.params.map((0, $fMJxQ.toSymbol)).join(",") + "\\right):=" + expr;
    };
    return FunctionAssignmentNode;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("6cmon", function(module, exports) {

$parcel$export(module.exports, "keywords", function () { return $48353bae417b4e40$export$eebaaf2b24d91f63; });
// Reserved keywords not allowed to use in the parser
var $48353bae417b4e40$export$eebaaf2b24d91f63 = {
    end: true
};

});


parcelRegister("eeLk7", function(module, exports) {

$parcel$export(module.exports, "createFunctionNode", function () { return $a5d714fac2eff3d0$export$d03e7338a74cdf4c; });

var $7E0JQ = parcelRequire("7E0JQ");

var $7HWRb = parcelRequire("7HWRb");

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");

var $i3n6j = parcelRequire("i3n6j");

var $jKx4O = parcelRequire("jKx4O");

var $fMJxQ = parcelRequire("fMJxQ");
function $a5d714fac2eff3d0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a5d714fac2eff3d0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a5d714fac2eff3d0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a5d714fac2eff3d0$var$_typeof(obj);
}
function $a5d714fac2eff3d0$var$_extends() {
    $a5d714fac2eff3d0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a5d714fac2eff3d0$var$_extends.apply(this, arguments);
}
var $a5d714fac2eff3d0$var$name = "FunctionNode";
var $a5d714fac2eff3d0$var$dependencies = [
    "math",
    "Node",
    "SymbolNode"
];
var $a5d714fac2eff3d0$export$d03e7338a74cdf4c = /* #__PURE__ */ (0, $jKx4O.factory)($a5d714fac2eff3d0$var$name, $a5d714fac2eff3d0$var$dependencies, function(_ref) {
    var math = _ref.math, Node = _ref.Node, SymbolNode = _ref.SymbolNode;
    /**
   * @constructor FunctionNode
   * @extends {./Node}
   * invoke a list with arguments on a node
   * @param {./Node | string} fn Node resolving with a function on which to invoke
   *                             the arguments, typically a SymboNode or AccessorNode
   * @param {./Node[]} args
   */ function FunctionNode(fn, args) {
        if (!(this instanceof FunctionNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (typeof fn === "string") fn = new SymbolNode(fn);
         // validate input
        if (!(0, $7E0JQ.isNode)(fn)) throw new TypeError('Node expected as parameter "fn"');
        if (!Array.isArray(args) || !args.every((0, $7E0JQ.isNode))) throw new TypeError('Array containing Nodes expected for parameter "args"');
        this.fn = fn;
        this.args = args || []; // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                return this.fn.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        }); // TODO: deprecated since v3, remove some day
        var deprecated = function deprecated() {
            throw new Error("Property `FunctionNode.object` is deprecated, use `FunctionNode.fn` instead");
        };
        Object.defineProperty(this, "object", {
            get: deprecated,
            set: deprecated
        });
    }
    FunctionNode.prototype = new Node();
    FunctionNode.prototype.type = "FunctionNode";
    FunctionNode.prototype.isFunctionNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ FunctionNode.prototype._compile = function(math, argNames) {
        if (!(this instanceof FunctionNode)) throw new TypeError("No valid FunctionNode");
         // compile arguments
        var evalArgs = (0, $YkZ7e.map)(this.args, function(arg) {
            return arg._compile(math, argNames);
        });
        if ((0, $7E0JQ.isSymbolNode)(this.fn)) {
            // we can statically determine whether the function has an rawArgs property
            var _name = this.fn.name;
            var fn = _name in math ? (0, $i3n6j.getSafeProperty)(math, _name) : undefined;
            var isRaw = typeof fn === "function" && fn.rawArgs === true;
            if (isRaw) {
                // pass unevaluated parameters (nodes) to the function
                // "raw" evaluation
                var rawArgs = this.args;
                return function evalFunctionNode(scope, args, context) {
                    return (_name in scope ? (0, $i3n6j.getSafeProperty)(scope, _name) : fn)(rawArgs, math, $a5d714fac2eff3d0$var$_extends({}, scope, args));
                };
            } else {
                // "regular" evaluation
                if (evalArgs.length === 1) {
                    var evalArg0 = evalArgs[0];
                    return function evalFunctionNode(scope, args, context) {
                        return (_name in scope ? (0, $i3n6j.getSafeProperty)(scope, _name) : fn)(evalArg0(scope, args, context));
                    };
                } else if (evalArgs.length === 2) {
                    var _evalArg = evalArgs[0];
                    var evalArg1 = evalArgs[1];
                    return function evalFunctionNode(scope, args, context) {
                        return (_name in scope ? (0, $i3n6j.getSafeProperty)(scope, _name) : fn)(_evalArg(scope, args, context), evalArg1(scope, args, context));
                    };
                } else return function evalFunctionNode(scope, args, context) {
                    return (_name in scope ? (0, $i3n6j.getSafeProperty)(scope, _name) : fn).apply(null, (0, $YkZ7e.map)(evalArgs, function(evalArg) {
                        return evalArg(scope, args, context);
                    }));
                };
            }
        } else if ((0, $7E0JQ.isAccessorNode)(this.fn) && (0, $7E0JQ.isIndexNode)(this.fn.index) && this.fn.index.isObjectProperty()) {
            // execute the function with the right context: the object of the AccessorNode
            var evalObject = this.fn.object._compile(math, argNames);
            var prop = this.fn.index.getObjectProperty();
            var _rawArgs = this.args;
            return function evalFunctionNode(scope, args, context) {
                var object = evalObject(scope, args, context);
                (0, $i3n6j.validateSafeMethod)(object, prop);
                var isRaw = object[prop] && object[prop].rawArgs;
                return isRaw ? object[prop](_rawArgs, math, $a5d714fac2eff3d0$var$_extends({}, scope, args)) // "raw" evaluation
                 : object[prop].apply(object, (0, $YkZ7e.map)(evalArgs, function(evalArg) {
                    // "regular" evaluation
                    return evalArg(scope, args, context);
                }));
            };
        } else {
            // node.fn.isAccessorNode && !node.fn.index.isObjectProperty()
            // we have to dynamically determine whether the function has a rawArgs property
            var evalFn = this.fn._compile(math, argNames);
            var _rawArgs2 = this.args;
            return function evalFunctionNode(scope, args, context) {
                var fn = evalFn(scope, args, context);
                var isRaw = fn && fn.rawArgs;
                return isRaw ? fn(_rawArgs2, math, $a5d714fac2eff3d0$var$_extends({}, scope, args)) // "raw" evaluation
                 : fn.apply(fn, (0, $YkZ7e.map)(evalArgs, function(evalArg) {
                    // "regular" evaluation
                    return evalArg(scope, args, context);
                }));
            };
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ FunctionNode.prototype.forEach = function(callback) {
        callback(this.fn, "fn", this);
        for(var i = 0; i < this.args.length; i++)callback(this.args[i], "args[" + i + "]", this);
    };
    /**
   * Create a new FunctionNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {FunctionNode} Returns a transformed copy of the node
   */ FunctionNode.prototype.map = function(callback) {
        var fn = this._ifNode(callback(this.fn, "fn", this));
        var args = [];
        for(var i = 0; i < this.args.length; i++)args[i] = this._ifNode(callback(this.args[i], "args[" + i + "]", this));
        return new FunctionNode(fn, args);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {FunctionNode}
   */ FunctionNode.prototype.clone = function() {
        return new FunctionNode(this.fn, this.args.slice(0));
    }; // backup Node's toString function
    // @private
    var nodeToString = FunctionNode.prototype.toString;
    /**
   * Get string representation. (wrapper function)
   * This overrides parts of Node's toString function.
   * If callback is an object containing callbacks, it
   * calls the correct callback for the current node,
   * otherwise it falls back to calling Node's toString
   * function.
   *
   * @param {Object} options
   * @return {string} str
   * @override
   */ FunctionNode.prototype.toString = function(options) {
        var customString;
        var name = this.fn.toString(options);
        if (options && $a5d714fac2eff3d0$var$_typeof(options.handler) === "object" && (0, $glBd7.hasOwnProperty)(options.handler, name)) // callback is a map of callback functions
        customString = options.handler[name](this, options);
        if (typeof customString !== "undefined") return customString;
         // fall back to Node's toString
        return nodeToString.call(this, options);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype._toString = function(options) {
        var args = this.args.map(function(arg) {
            return arg.toString(options);
        });
        var fn = (0, $7E0JQ.isFunctionAssignmentNode)(this.fn) ? "(" + this.fn.toString(options) + ")" : this.fn.toString(options); // format the arguments like "add(2, 4.2)"
        return fn + "(" + args.join(", ") + ")";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ FunctionNode.prototype.toJSON = function() {
        return {
            mathjs: "FunctionNode",
            fn: this.fn,
            args: this.args
        };
    };
    /**
   * Instantiate an AssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
   *                       where mathjs is optional
   * @returns {FunctionNode}
   */ FunctionNode.fromJSON = function(json) {
        return new FunctionNode(json.fn, json.args);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype.toHTML = function(options) {
        var args = this.args.map(function(arg) {
            return arg.toHTML(options);
        }); // format the arguments like "add(2, 4.2)"
        return '<span class="math-function">' + (0, $7HWRb.escape)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + args.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    };
    /*
   * Expand a LaTeX template
   *
   * @param {string} template
   * @param {Node} node
   * @param {Object} options
   * @private
   **/ function expandTemplate(template, node, options) {
        var latex = ""; // Match everything of the form ${identifier} or ${identifier[2]} or $$
        // while submatching identifier and 2 (in the second case)
        var regex = new RegExp("\\$(?:\\{([a-z_][a-z_0-9]*)(?:\\[([0-9]+)\\])?\\}|\\$)", "ig");
        var inputPos = 0; // position in the input string
        var match;
        while((match = regex.exec(template)) !== null){
            // go through all matches
            // add everything in front of the match to the LaTeX string
            latex += template.substring(inputPos, match.index);
            inputPos = match.index;
            if (match[0] === "$$") {
                // escaped dollar sign
                latex += "$";
                inputPos++;
            } else {
                // template parameter
                inputPos += match[0].length;
                var property = node[match[1]];
                if (!property) throw new ReferenceError("Template: Property " + match[1] + " does not exist.");
                if (match[2] === undefined) // no square brackets
                switch($a5d714fac2eff3d0$var$_typeof(property)){
                    case "string":
                        latex += property;
                        break;
                    case "object":
                        if ((0, $7E0JQ.isNode)(property)) latex += property.toTex(options);
                        else if (Array.isArray(property)) // make array of Nodes into comma separated list
                        latex += property.map(function(arg, index) {
                            if ((0, $7E0JQ.isNode)(arg)) return arg.toTex(options);
                            throw new TypeError("Template: " + match[1] + "[" + index + "] is not a Node.");
                        }).join(",");
                        else throw new TypeError("Template: " + match[1] + " has to be a Node, String or array of Nodes");
                        break;
                    default:
                        throw new TypeError("Template: " + match[1] + " has to be a Node, String or array of Nodes");
                }
                else {
                    // with square brackets
                    if ((0, $7E0JQ.isNode)(property[match[2]] && property[match[2]])) latex += property[match[2]].toTex(options);
                    else throw new TypeError("Template: " + match[1] + "[" + match[2] + "] is not a Node.");
                }
            }
        }
        latex += template.slice(inputPos); // append rest of the template
        return latex;
    } // backup Node's toTex function
    // @private
    var nodeToTex = FunctionNode.prototype.toTex;
    /**
   * Get LaTeX representation. (wrapper function)
   * This overrides parts of Node's toTex function.
   * If callback is an object containing callbacks, it
   * calls the correct callback for the current node,
   * otherwise it falls back to calling Node's toTex
   * function.
   *
   * @param {Object} options
   * @return {string}
   */ FunctionNode.prototype.toTex = function(options) {
        var customTex;
        if (options && $a5d714fac2eff3d0$var$_typeof(options.handler) === "object" && (0, $glBd7.hasOwnProperty)(options.handler, this.name)) // callback is a map of callback functions
        customTex = options.handler[this.name](this, options);
        if (typeof customTex !== "undefined") return customTex;
         // fall back to Node's toTex
        return nodeToTex.call(this, options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype._toTex = function(options) {
        var args = this.args.map(function(arg) {
            // get LaTeX of the arguments
            return arg.toTex(options);
        });
        var latexConverter;
        if ((0, $fMJxQ.latexFunctions)[this.name]) latexConverter = (0, $fMJxQ.latexFunctions)[this.name];
         // toTex property on the function itself
        if (math[this.name] && (typeof math[this.name].toTex === "function" || $a5d714fac2eff3d0$var$_typeof(math[this.name].toTex) === "object" || typeof math[this.name].toTex === "string")) // .toTex is a callback function
        latexConverter = math[this.name].toTex;
        var customToTex;
        switch($a5d714fac2eff3d0$var$_typeof(latexConverter)){
            case "function":
                // a callback function
                customToTex = latexConverter(this, options);
                break;
            case "string":
                // a template string
                customToTex = expandTemplate(latexConverter, this, options);
                break;
            case "object":
                // an object with different "converters" for different numbers of arguments
                switch($a5d714fac2eff3d0$var$_typeof(latexConverter[args.length])){
                    case "function":
                        customToTex = latexConverter[args.length](this, options);
                        break;
                    case "string":
                        customToTex = expandTemplate(latexConverter[args.length], this, options);
                        break;
                }
        }
        if (typeof customToTex !== "undefined") return customToTex;
        return expandTemplate((0, $fMJxQ.defaultTemplate), this, options);
    };
    /**
   * Get identifier.
   * @return {string}
   */ FunctionNode.prototype.getIdentifier = function() {
        return this.type + ":" + this.name;
    };
    return FunctionNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("i35zk", function(module, exports) {

$parcel$export(module.exports, "createHelp", function () { return $d23cd3ae86d669a1$export$cbe80567b8b3b8ac; });

var $jKx4O = parcelRequire("jKx4O");

var $i3n6j = parcelRequire("i3n6j");

var $itHud = parcelRequire("itHud");

var $glBd7 = parcelRequire("glBd7");
var $d23cd3ae86d669a1$var$name = "help";
var $d23cd3ae86d669a1$var$dependencies = [
    "typed",
    "mathWithTransform",
    "Help"
];
var $d23cd3ae86d669a1$export$cbe80567b8b3b8ac = /* #__PURE__ */ (0, $jKx4O.factory)($d23cd3ae86d669a1$var$name, $d23cd3ae86d669a1$var$dependencies, function(_ref) {
    var typed = _ref.typed, mathWithTransform = _ref.mathWithTransform, Help = _ref.Help;
    /**
   * Retrieve help on a function or data type.
   * Help files are retrieved from the embedded documentation in math.docs.
   *
   * Syntax:
   *
   *    math.help(search)
   *
   * Examples:
   *
   *    console.log(math.help('sin').toString())
   *    console.log(math.help(math.add).toString())
   *    console.log(math.help(math.add).toJSON())
   *
   * @param {Function | string | Object} search   A function or function name
   *                                              for which to get help
   * @return {Help} A help object
   */ return typed($d23cd3ae86d669a1$var$name, {
        any: function any(search) {
            var prop;
            var searchName = search;
            if (typeof search !== "string") {
                for(prop in mathWithTransform)// search in functions and constants
                if ((0, $glBd7.hasOwnProperty)(mathWithTransform, prop) && search === mathWithTransform[prop]) {
                    searchName = prop;
                    break;
                }
            /* TODO: implement help for data types
         if (!text) {
         // search data type
         for (prop in math.type) {
         if (hasOwnProperty(math, prop)) {
         if (search === math.type[prop]) {
         text = prop
         break
         }
         }
         }
         }
         */ }
            var doc = (0, $i3n6j.getSafeProperty)((0, $itHud.embeddedDocs), searchName);
            if (!doc) {
                var searchText = typeof searchName === "function" ? searchName.name : searchName;
                throw new Error('No documentation found on "' + searchText + '"');
            }
            return new Help(doc);
        }
    });
});

});
parcelRegister("itHud", function(module, exports) {

$parcel$export(module.exports, "embeddedDocs", function () { return $d73caaebf7306664$export$c2adf0a3344c85c9; });

var $5RfsH = parcelRequire("5RfsH");

var $hYUOa = parcelRequire("hYUOa");

var $dWKEh = parcelRequire("dWKEh");

var $eDnBY = parcelRequire("eDnBY");

var $6r62a = parcelRequire("6r62a");

var $jElrL = parcelRequire("jElrL");

var $eRDIn = parcelRequire("eRDIn");

var $brgJd = parcelRequire("brgJd");

var $bzz8j = parcelRequire("bzz8j");

var $9xjfj = parcelRequire("9xjfj");

var $3jBgh = parcelRequire("3jBgh");

var $bJceR = parcelRequire("bJceR");

var $6QKlS = parcelRequire("6QKlS");

var $iX6rI = parcelRequire("iX6rI");

var $9bN8S = parcelRequire("9bN8S");

var $1mV6T = parcelRequire("1mV6T");

var $9aQ14 = parcelRequire("9aQ14");

var $liMR8 = parcelRequire("liMR8");

var $dnSL9 = parcelRequire("dnSL9");

var $9RdNK = parcelRequire("9RdNK");

var $d8I9b = parcelRequire("d8I9b");

var $8oWSk = parcelRequire("8oWSk");

var $fIgGp = parcelRequire("fIgGp");

var $gtvdW = parcelRequire("gtvdW");

var $83x5Z = parcelRequire("83x5Z");

var $8nwQw = parcelRequire("8nwQw");

var $2UyYA = parcelRequire("2UyYA");

var $bpGn7 = parcelRequire("bpGn7");

var $9a9fY = parcelRequire("9a9fY");

var $boKuU = parcelRequire("boKuU");

var $7w1OG = parcelRequire("7w1OG");

var $aKY8R = parcelRequire("aKY8R");

var $jshkX = parcelRequire("jshkX");

var $cZLyY = parcelRequire("cZLyY");

var $44RLD = parcelRequire("44RLD");

var $CEdCr = parcelRequire("CEdCr");

var $e5jhd = parcelRequire("e5jhd");

var $9SVYL = parcelRequire("9SVYL");

var $dwn59 = parcelRequire("dwn59");

var $6se9a = parcelRequire("6se9a");

var $ahNUZ = parcelRequire("ahNUZ");

var $apCH7 = parcelRequire("apCH7");

var $jzxbF = parcelRequire("jzxbF");

var $4cmN3 = parcelRequire("4cmN3");

var $eHQ4N = parcelRequire("eHQ4N");

var $nCKQN = parcelRequire("nCKQN");

var $7w5Uf = parcelRequire("7w5Uf");

var $2WRJT = parcelRequire("2WRJT");

var $deDAG = parcelRequire("deDAG");

var $beQTr = parcelRequire("beQTr");

var $3iB2L = parcelRequire("3iB2L");

var $ezvI3 = parcelRequire("ezvI3");

var $d29HZ = parcelRequire("d29HZ");

var $hG2uC = parcelRequire("hG2uC");

var $g3f4E = parcelRequire("g3f4E");

var $b5lNC = parcelRequire("b5lNC");

var $k6QQQ = parcelRequire("k6QQQ");

var $81bdO = parcelRequire("81bdO");

var $kPPS5 = parcelRequire("kPPS5");

var $8vZ4f = parcelRequire("8vZ4f");

var $eqJQP = parcelRequire("eqJQP");

var $8nLi5 = parcelRequire("8nLi5");

var $9PO32 = parcelRequire("9PO32");

var $9vmcr = parcelRequire("9vmcr");

var $9u5nx = parcelRequire("9u5nx");

var $c1wcN = parcelRequire("c1wcN");

var $4k5mO = parcelRequire("4k5mO");

var $hn0us = parcelRequire("hn0us");

var $3uybB = parcelRequire("3uybB");

var $kNKT8 = parcelRequire("kNKT8");

var $2vNtL = parcelRequire("2vNtL");

var $1InaJ = parcelRequire("1InaJ");

var $7A09n = parcelRequire("7A09n");

var $6z82k = parcelRequire("6z82k");

var $905hZ = parcelRequire("905hZ");

var $2F912 = parcelRequire("2F912");

var $e5IIS = parcelRequire("e5IIS");

var $kjQW7 = parcelRequire("kjQW7");

var $lNLv6 = parcelRequire("lNLv6");

var $dqt7Q = parcelRequire("dqt7Q");

var $6pDwH = parcelRequire("6pDwH");

var $94JAt = parcelRequire("94JAt");

var $9x1Fw = parcelRequire("9x1Fw");

var $82DFD = parcelRequire("82DFD");

var $kqrjX = parcelRequire("kqrjX");

var $cTGQE = parcelRequire("cTGQE");

var $7qaGh = parcelRequire("7qaGh");

var $loBsB = parcelRequire("loBsB");

var $2SbPc = parcelRequire("2SbPc");

var $ejbEO = parcelRequire("ejbEO");

var $1BbRK = parcelRequire("1BbRK");

var $cC0j9 = parcelRequire("cC0j9");

var $ctklo = parcelRequire("ctklo");

var $d8pkO = parcelRequire("d8pkO");

var $1LPdy = parcelRequire("1LPdy");

var $3KHcy = parcelRequire("3KHcy");

var $35Uns = parcelRequire("35Uns");

var $1O0eu = parcelRequire("1O0eu");

var $aol2S = parcelRequire("aol2S");

var $fvqQI = parcelRequire("fvqQI");

var $6IA6r = parcelRequire("6IA6r");

var $9rqfq = parcelRequire("9rqfq");

var $cQXwR = parcelRequire("cQXwR");

var $eytQA = parcelRequire("eytQA");

var $1PddZ = parcelRequire("1PddZ");

var $hxW19 = parcelRequire("hxW19");

var $l6qly = parcelRequire("l6qly");

var $hgPwg = parcelRequire("hgPwg");

var $dQIac = parcelRequire("dQIac");

var $kDSsf = parcelRequire("kDSsf");

var $kgNMh = parcelRequire("kgNMh");

var $42Q8b = parcelRequire("42Q8b");

var $fmxE6 = parcelRequire("fmxE6");

var $bfugF = parcelRequire("bfugF");

var $5IPdC = parcelRequire("5IPdC");

var $a3gaB = parcelRequire("a3gaB");

var $4r4KQ = parcelRequire("4r4KQ");

var $curJn = parcelRequire("curJn");

var $iK993 = parcelRequire("iK993");

var $jQDQ7 = parcelRequire("jQDQ7");

var $keq0M = parcelRequire("keq0M");

var $hYeOu = parcelRequire("hYeOu");

var $WEWrN = parcelRequire("WEWrN");

var $luqPQ = parcelRequire("luqPQ");

var $bq8vD = parcelRequire("bq8vD");

var $dDfGA = parcelRequire("dDfGA");

var $86Mtj = parcelRequire("86Mtj");

var $86I9x = parcelRequire("86I9x");

var $lhSzj = parcelRequire("lhSzj");

var $1R67K = parcelRequire("1R67K");

var $jKyeD = parcelRequire("jKyeD");

var $7Cg7E = parcelRequire("7Cg7E");

var $bF4YN = parcelRequire("bF4YN");

var $8X8cU = parcelRequire("8X8cU");

var $kQyUi = parcelRequire("kQyUi");

var $5eRhZ = parcelRequire("5eRhZ");

var $dTbeI = parcelRequire("dTbeI");

var $2B6IT = parcelRequire("2B6IT");

var $gfjms = parcelRequire("gfjms");

var $aSJCM = parcelRequire("aSJCM");

var $e5lSU = parcelRequire("e5lSU");

var $dVUub = parcelRequire("dVUub");

var $xaTEm = parcelRequire("xaTEm");

var $dfEOC = parcelRequire("dfEOC");

var $dQ9Ex = parcelRequire("dQ9Ex");

var $dXLeD = parcelRequire("dXLeD");

var $7E7yr = parcelRequire("7E7yr");

var $je0FP = parcelRequire("je0FP");

var $4Qi2H = parcelRequire("4Qi2H");

var $3GRfA = parcelRequire("3GRfA");

var $cFdBQ = parcelRequire("cFdBQ");

var $f0ViO = parcelRequire("f0ViO");

var $2O9Xo = parcelRequire("2O9Xo");

var $brWSV = parcelRequire("brWSV");

var $9tXMo = parcelRequire("9tXMo");

var $dmLq9 = parcelRequire("dmLq9");

var $bO5Bt = parcelRequire("bO5Bt");

var $92Q3A = parcelRequire("92Q3A");

var $iz5ka = parcelRequire("iz5ka");

var $cfWRu = parcelRequire("cfWRu");

var $eEWfh = parcelRequire("eEWfh");

var $16sR9 = parcelRequire("16sR9");

var $5TcZU = parcelRequire("5TcZU");

var $5V9lM = parcelRequire("5V9lM");

var $7d5FW = parcelRequire("7d5FW");

var $82DRz = parcelRequire("82DRz");

var $5DS2s = parcelRequire("5DS2s");

var $i1NI6 = parcelRequire("i1NI6");

var $aabq4 = parcelRequire("aabq4");

var $4gC9E = parcelRequire("4gC9E");

var $5VEOp = parcelRequire("5VEOp");

var $9wa74 = parcelRequire("9wa74");

var $im20p = parcelRequire("im20p");

var $7Ucta = parcelRequire("7Ucta");

var $dw7qY = parcelRequire("dw7qY");

var $42i4o = parcelRequire("42i4o");

var $4tqLR = parcelRequire("4tqLR");

var $kw1jC = parcelRequire("kw1jC");

var $1t2vA = parcelRequire("1t2vA");

var $lh4m5 = parcelRequire("lh4m5");

var $3fuir = parcelRequire("3fuir");

var $1u6w6 = parcelRequire("1u6w6");

var $2XphH = parcelRequire("2XphH");

var $h7Onf = parcelRequire("h7Onf");

var $gSenp = parcelRequire("gSenp");

var $MFanN = parcelRequire("MFanN");

var $b0WPV = parcelRequire("b0WPV");

var $4QdEV = parcelRequire("4QdEV");

var $darZC = parcelRequire("darZC");

var $iF04z = parcelRequire("iF04z");

var $aWl5E = parcelRequire("aWl5E");

var $2oxyG = parcelRequire("2oxyG");

var $8ODbc = parcelRequire("8ODbc");

var $kOFAA = parcelRequire("kOFAA");

var $aikwv = parcelRequire("aikwv");

var $60sIV = parcelRequire("60sIV");

var $6MUF2 = parcelRequire("6MUF2");

var $1OTLi = parcelRequire("1OTLi");

var $lxVfp = parcelRequire("lxVfp");

var $jcnRl = parcelRequire("jcnRl");

var $9RhG3 = parcelRequire("9RhG3");

var $9PKcq = parcelRequire("9PKcq");

var $kRF3p = parcelRequire("kRF3p");

var $gROZm = parcelRequire("gROZm");

var $iMmUz = parcelRequire("iMmUz");

var $6otEZ = parcelRequire("6otEZ");

var $TvXc2 = parcelRequire("TvXc2");

var $h5L5h = parcelRequire("h5L5h");

var $ffGcF = parcelRequire("ffGcF");

var $tbdpX = parcelRequire("tbdpX");
var $d73caaebf7306664$export$c2adf0a3344c85c9 = {
    // construction functions
    bignumber: (0, $5RfsH.bignumberDocs),
    "boolean": (0, $9PKcq.booleanDocs),
    complex: (0, $9RhG3.complexDocs),
    createUnit: (0, $jcnRl.createUnitDocs),
    fraction: (0, $lxVfp.fractionDocs),
    index: (0, $1OTLi.indexDocs),
    matrix: (0, $6MUF2.matrixDocs),
    number: (0, $60sIV.numberDocs),
    sparse: (0, $aikwv.sparseDocs),
    splitUnit: (0, $kOFAA.splitUnitDocs),
    string: (0, $8ODbc.stringDocs),
    unit: (0, $2oxyG.unitDocs),
    // constants
    e: (0, $aWl5E.eDocs),
    E: (0, $aWl5E.eDocs),
    "false": (0, $iF04z.falseDocs),
    i: (0, $darZC.iDocs),
    Infinity: (0, $4QdEV.InfinityDocs),
    LN2: (0, $b0WPV.LN2Docs),
    LN10: (0, $MFanN.LN10Docs),
    LOG2E: (0, $gSenp.LOG2EDocs),
    LOG10E: (0, $h7Onf.LOG10EDocs),
    NaN: (0, $2XphH.NaNDocs),
    "null": (0, $1u6w6.nullDocs),
    pi: (0, $3fuir.piDocs),
    PI: (0, $3fuir.piDocs),
    phi: (0, $lh4m5.phiDocs),
    SQRT1_2: (0, $1t2vA.SQRT12Docs),
    SQRT2: (0, $kw1jC.SQRT2Docs),
    tau: (0, $4tqLR.tauDocs),
    "true": (0, $42i4o.trueDocs),
    version: (0, $dw7qY.versionDocs),
    // physical constants
    // TODO: more detailed docs for physical constants
    speedOfLight: {
        description: "Speed of light in vacuum",
        examples: [
            "speedOfLight"
        ]
    },
    gravitationConstant: {
        description: "Newtonian constant of gravitation",
        examples: [
            "gravitationConstant"
        ]
    },
    planckConstant: {
        description: "Planck constant",
        examples: [
            "planckConstant"
        ]
    },
    reducedPlanckConstant: {
        description: "Reduced Planck constant",
        examples: [
            "reducedPlanckConstant"
        ]
    },
    magneticConstant: {
        description: "Magnetic constant (vacuum permeability)",
        examples: [
            "magneticConstant"
        ]
    },
    electricConstant: {
        description: "Electric constant (vacuum permeability)",
        examples: [
            "electricConstant"
        ]
    },
    vacuumImpedance: {
        description: "Characteristic impedance of vacuum",
        examples: [
            "vacuumImpedance"
        ]
    },
    coulomb: {
        description: "Coulomb's constant",
        examples: [
            "coulomb"
        ]
    },
    elementaryCharge: {
        description: "Elementary charge",
        examples: [
            "elementaryCharge"
        ]
    },
    bohrMagneton: {
        description: "Borh magneton",
        examples: [
            "bohrMagneton"
        ]
    },
    conductanceQuantum: {
        description: "Conductance quantum",
        examples: [
            "conductanceQuantum"
        ]
    },
    inverseConductanceQuantum: {
        description: "Inverse conductance quantum",
        examples: [
            "inverseConductanceQuantum"
        ]
    },
    // josephson: {description: 'Josephson constant', examples: ['josephson']},
    magneticFluxQuantum: {
        description: "Magnetic flux quantum",
        examples: [
            "magneticFluxQuantum"
        ]
    },
    nuclearMagneton: {
        description: "Nuclear magneton",
        examples: [
            "nuclearMagneton"
        ]
    },
    klitzing: {
        description: "Von Klitzing constant",
        examples: [
            "klitzing"
        ]
    },
    bohrRadius: {
        description: "Borh radius",
        examples: [
            "bohrRadius"
        ]
    },
    classicalElectronRadius: {
        description: "Classical electron radius",
        examples: [
            "classicalElectronRadius"
        ]
    },
    electronMass: {
        description: "Electron mass",
        examples: [
            "electronMass"
        ]
    },
    fermiCoupling: {
        description: "Fermi coupling constant",
        examples: [
            "fermiCoupling"
        ]
    },
    fineStructure: {
        description: "Fine-structure constant",
        examples: [
            "fineStructure"
        ]
    },
    hartreeEnergy: {
        description: "Hartree energy",
        examples: [
            "hartreeEnergy"
        ]
    },
    protonMass: {
        description: "Proton mass",
        examples: [
            "protonMass"
        ]
    },
    deuteronMass: {
        description: "Deuteron Mass",
        examples: [
            "deuteronMass"
        ]
    },
    neutronMass: {
        description: "Neutron mass",
        examples: [
            "neutronMass"
        ]
    },
    quantumOfCirculation: {
        description: "Quantum of circulation",
        examples: [
            "quantumOfCirculation"
        ]
    },
    rydberg: {
        description: "Rydberg constant",
        examples: [
            "rydberg"
        ]
    },
    thomsonCrossSection: {
        description: "Thomson cross section",
        examples: [
            "thomsonCrossSection"
        ]
    },
    weakMixingAngle: {
        description: "Weak mixing angle",
        examples: [
            "weakMixingAngle"
        ]
    },
    efimovFactor: {
        description: "Efimov factor",
        examples: [
            "efimovFactor"
        ]
    },
    atomicMass: {
        description: "Atomic mass constant",
        examples: [
            "atomicMass"
        ]
    },
    avogadro: {
        description: "Avogadro's number",
        examples: [
            "avogadro"
        ]
    },
    boltzmann: {
        description: "Boltzmann constant",
        examples: [
            "boltzmann"
        ]
    },
    faraday: {
        description: "Faraday constant",
        examples: [
            "faraday"
        ]
    },
    firstRadiation: {
        description: "First radiation constant",
        examples: [
            "firstRadiation"
        ]
    },
    loschmidt: {
        description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
        examples: [
            "loschmidt"
        ]
    },
    gasConstant: {
        description: "Gas constant",
        examples: [
            "gasConstant"
        ]
    },
    molarPlanckConstant: {
        description: "Molar Planck constant",
        examples: [
            "molarPlanckConstant"
        ]
    },
    molarVolume: {
        description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
        examples: [
            "molarVolume"
        ]
    },
    sackurTetrode: {
        description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
        examples: [
            "sackurTetrode"
        ]
    },
    secondRadiation: {
        description: "Second radiation constant",
        examples: [
            "secondRadiation"
        ]
    },
    stefanBoltzmann: {
        description: "Stefan-Boltzmann constant",
        examples: [
            "stefanBoltzmann"
        ]
    },
    wienDisplacement: {
        description: "Wien displacement law constant",
        examples: [
            "wienDisplacement"
        ]
    },
    // spectralRadiance: {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']},
    molarMass: {
        description: "Molar mass constant",
        examples: [
            "molarMass"
        ]
    },
    molarMassC12: {
        description: "Molar mass constant of carbon-12",
        examples: [
            "molarMassC12"
        ]
    },
    gravity: {
        description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
        examples: [
            "gravity"
        ]
    },
    planckLength: {
        description: "Planck length",
        examples: [
            "planckLength"
        ]
    },
    planckMass: {
        description: "Planck mass",
        examples: [
            "planckMass"
        ]
    },
    planckTime: {
        description: "Planck time",
        examples: [
            "planckTime"
        ]
    },
    planckCharge: {
        description: "Planck charge",
        examples: [
            "planckCharge"
        ]
    },
    planckTemperature: {
        description: "Planck temperature",
        examples: [
            "planckTemperature"
        ]
    },
    // functions - algebra
    derivative: (0, $7Ucta.derivativeDocs),
    lsolve: (0, $im20p.lsolveDocs),
    lup: (0, $9wa74.lupDocs),
    lusolve: (0, $gROZm.lusolveDocs),
    simplify: (0, $5VEOp.simplifyDocs),
    rationalize: (0, $4gC9E.rationalizeDocs),
    slu: (0, $aabq4.sluDocs),
    usolve: (0, $i1NI6.usolveDocs),
    qr: (0, $5DS2s.qrDocs),
    // functions - arithmetic
    abs: (0, $82DRz.absDocs),
    add: (0, $7d5FW.addDocs),
    cbrt: (0, $5V9lM.cbrtDocs),
    ceil: (0, $5TcZU.ceilDocs),
    cube: (0, $16sR9.cubeDocs),
    divide: (0, $eEWfh.divideDocs),
    dotDivide: (0, $cfWRu.dotDivideDocs),
    dotMultiply: (0, $iz5ka.dotMultiplyDocs),
    dotPow: (0, $kRF3p.dotPowDocs),
    exp: (0, $92Q3A.expDocs),
    expm: (0, $dmLq9.expmDocs),
    expm1: (0, $9tXMo.expm1Docs),
    fix: (0, $brWSV.fixDocs),
    floor: (0, $2O9Xo.floorDocs),
    gcd: (0, $f0ViO.gcdDocs),
    hypot: (0, $cFdBQ.hypotDocs),
    lcm: (0, $3GRfA.lcmDocs),
    log: (0, $4Qi2H.logDocs),
    log2: (0, $je0FP.log2Docs),
    log1p: (0, $7E7yr.log1pDocs),
    log10: (0, $dXLeD.log10Docs),
    mod: (0, $dQ9Ex.modDocs),
    multiply: (0, $dfEOC.multiplyDocs),
    norm: (0, $xaTEm.normDocs),
    nthRoot: (0, $dVUub.nthRootDocs),
    nthRoots: (0, $e5lSU.nthRootsDocs),
    pow: (0, $aSJCM.powDocs),
    round: (0, $gfjms.roundDocs),
    sign: (0, $2B6IT.signDocs),
    sqrt: (0, $dTbeI.sqrtDocs),
    sqrtm: (0, $5eRhZ.sqrtmDocs),
    square: (0, $kQyUi.squareDocs),
    subtract: (0, $iMmUz.subtractDocs),
    unaryMinus: (0, $8X8cU.unaryMinusDocs),
    unaryPlus: (0, $bF4YN.unaryPlusDocs),
    xgcd: (0, $7Cg7E.xgcdDocs),
    // functions - bitwise
    bitAnd: (0, $jKyeD.bitAndDocs),
    bitNot: (0, $1R67K.bitNotDocs),
    bitOr: (0, $lhSzj.bitOrDocs),
    bitXor: (0, $86I9x.bitXorDocs),
    leftShift: (0, $86Mtj.leftShiftDocs),
    rightArithShift: (0, $dDfGA.rightArithShiftDocs),
    rightLogShift: (0, $bq8vD.rightLogShiftDocs),
    // functions - combinatorics
    bellNumbers: (0, $luqPQ.bellNumbersDocs),
    catalan: (0, $WEWrN.catalanDocs),
    composition: (0, $hYeOu.compositionDocs),
    stirlingS2: (0, $keq0M.stirlingS2Docs),
    // functions - core
    config: (0, $jQDQ7.configDocs),
    "import": (0, $iK993.importDocs),
    typed: (0, $curJn.typedDocs),
    // functions - complex
    arg: (0, $4r4KQ.argDocs),
    conj: (0, $a3gaB.conjDocs),
    re: (0, $5IPdC.reDocs),
    im: (0, $bfugF.imDocs),
    // functions - expression
    evaluate: (0, $fmxE6.evaluateDocs),
    eval: (0, $fmxE6.evaluateDocs),
    // TODO: deprecated, cleanup in v7
    help: (0, $42Q8b.helpDocs),
    // functions - geometry
    distance: (0, $kgNMh.distanceDocs),
    intersect: (0, $kDSsf.intersectDocs),
    // functions - logical
    and: (0, $dQIac.andDocs),
    not: (0, $hgPwg.notDocs),
    or: (0, $l6qly.orDocs),
    xor: (0, $hxW19.xorDocs),
    // functions - matrix
    concat: (0, $1PddZ.concatDocs),
    cross: (0, $eytQA.crossDocs),
    column: (0, $ffGcF.columnDocs),
    ctranspose: (0, $cQXwR.ctransposeDocs),
    det: (0, $9rqfq.detDocs),
    diag: (0, $6IA6r.diagDocs),
    dot: (0, $fvqQI.dotDocs),
    getMatrixDataType: (0, $aol2S.getMatrixDataTypeDocs),
    identity: (0, $1O0eu.identityDocs),
    filter: (0, $35Uns.filterDocs),
    flatten: (0, $3KHcy.flattenDocs),
    forEach: (0, $1LPdy.forEachDocs),
    inv: (0, $d8pkO.invDocs),
    eigs: (0, $bO5Bt.eigsDocs),
    kron: (0, $ctklo.kronDocs),
    map: (0, $cC0j9.mapDocs),
    ones: (0, $1BbRK.onesDocs),
    partitionSelect: (0, $ejbEO.partitionSelectDocs),
    range: (0, $2SbPc.rangeDocs),
    resize: (0, $loBsB.resizeDocs),
    reshape: (0, $7qaGh.reshapeDocs),
    row: (0, $tbdpX.rowDocs),
    size: (0, $cTGQE.sizeDocs),
    sort: (0, $kqrjX.sortDocs),
    squeeze: (0, $82DFD.squeezeDocs),
    subset: (0, $9x1Fw.subsetDocs),
    trace: (0, $94JAt.traceDocs),
    transpose: (0, $6pDwH.transposeDocs),
    zeros: (0, $dqt7Q.zerosDocs),
    // functions - probability
    combinations: (0, $kjQW7.combinationsDocs),
    combinationsWithRep: (0, $lNLv6.combinationsWithRepDocs),
    // distribution: distributionDocs,
    factorial: (0, $e5IIS.factorialDocs),
    gamma: (0, $2F912.gammaDocs),
    kldivergence: (0, $905hZ.kldivergenceDocs),
    multinomial: (0, $6z82k.multinomialDocs),
    permutations: (0, $7A09n.permutationsDocs),
    pickRandom: (0, $1InaJ.pickRandomDocs),
    random: (0, $2vNtL.randomDocs),
    randomInt: (0, $kNKT8.randomIntDocs),
    // functions - relational
    compare: (0, $3uybB.compareDocs),
    compareNatural: (0, $hn0us.compareNaturalDocs),
    compareText: (0, $4k5mO.compareTextDocs),
    deepEqual: (0, $c1wcN.deepEqualDocs),
    equal: (0, $9u5nx.equalDocs),
    equalText: (0, $9vmcr.equalTextDocs),
    larger: (0, $9PO32.largerDocs),
    largerEq: (0, $8nLi5.largerEqDocs),
    smaller: (0, $eqJQP.smallerDocs),
    smallerEq: (0, $8vZ4f.smallerEqDocs),
    unequal: (0, $kPPS5.unequalDocs),
    // functions - set
    setCartesian: (0, $81bdO.setCartesianDocs),
    setDifference: (0, $k6QQQ.setDifferenceDocs),
    setDistinct: (0, $b5lNC.setDistinctDocs),
    setIntersect: (0, $g3f4E.setIntersectDocs),
    setIsSubset: (0, $hG2uC.setIsSubsetDocs),
    setMultiplicity: (0, $d29HZ.setMultiplicityDocs),
    setPowerset: (0, $ezvI3.setPowersetDocs),
    setSize: (0, $3iB2L.setSizeDocs),
    setSymDifference: (0, $beQTr.setSymDifferenceDocs),
    setUnion: (0, $deDAG.setUnionDocs),
    // functions - special
    erf: (0, $2WRJT.erfDocs),
    // functions - statistics
    mad: (0, $7w5Uf.madDocs),
    max: (0, $nCKQN.maxDocs),
    mean: (0, $eHQ4N.meanDocs),
    median: (0, $4cmN3.medianDocs),
    min: (0, $jzxbF.minDocs),
    mode: (0, $apCH7.modeDocs),
    prod: (0, $ahNUZ.prodDocs),
    quantileSeq: (0, $6se9a.quantileSeqDocs),
    std: (0, $dwn59.stdDocs),
    sum: (0, $9SVYL.sumDocs),
    variance: (0, $6otEZ.varianceDocs),
    "var": (0, $6otEZ.varianceDocs),
    // TODO: deprecated, cleanup in v7
    // functions - trigonometry
    acos: (0, $e5jhd.acosDocs),
    acosh: (0, $CEdCr.acoshDocs),
    acot: (0, $44RLD.acotDocs),
    acoth: (0, $cZLyY.acothDocs),
    acsc: (0, $jshkX.acscDocs),
    acsch: (0, $aKY8R.acschDocs),
    asec: (0, $7w1OG.asecDocs),
    asech: (0, $boKuU.asechDocs),
    asin: (0, $9a9fY.asinDocs),
    asinh: (0, $bpGn7.asinhDocs),
    atan: (0, $2UyYA.atanDocs),
    atanh: (0, $8nwQw.atanhDocs),
    atan2: (0, $83x5Z.atan2Docs),
    cos: (0, $gtvdW.cosDocs),
    cosh: (0, $fIgGp.coshDocs),
    cot: (0, $8oWSk.cotDocs),
    coth: (0, $d8I9b.cothDocs),
    csc: (0, $9RdNK.cscDocs),
    csch: (0, $dnSL9.cschDocs),
    sec: (0, $liMR8.secDocs),
    sech: (0, $9aQ14.sechDocs),
    sin: (0, $TvXc2.sinDocs),
    sinh: (0, $1mV6T.sinhDocs),
    tan: (0, $9bN8S.tanDocs),
    tanh: (0, $iX6rI.tanhDocs),
    // functions - units
    to: (0, $6QKlS.toDocs),
    // functions - utils
    clone: (0, $bJceR.cloneDocs),
    format: (0, $3jBgh.formatDocs),
    isNaN: (0, $9xjfj.isNaNDocs),
    isInteger: (0, $bzz8j.isIntegerDocs),
    isNegative: (0, $brgJd.isNegativeDocs),
    isNumeric: (0, $jElrL.isNumericDocs),
    hasNumericValue: (0, $eRDIn.hasNumericValueDocs),
    isPositive: (0, $6r62a.isPositiveDocs),
    isPrime: (0, $eDnBY.isPrimeDocs),
    isZero: (0, $dWKEh.isZeroDocs),
    // print: printDocs // TODO: add documentation for print as soon as the parser supports objects.
    typeOf: (0, $hYUOa.typeOfDocs),
    "typeof": (0, $hYUOa.typeOfDocs),
    // TODO: deprecated, cleanup in v7
    numeric: (0, $h5L5h.numericDocs)
};

});
parcelRegister("5RfsH", function(module, exports) {

$parcel$export(module.exports, "bignumberDocs", function () { return $443de562e99890c7$export$e8c3f4e3ad52a4e6; });
var $443de562e99890c7$export$e8c3f4e3ad52a4e6 = {
    name: "bignumber",
    category: "Construction",
    syntax: [
        "bignumber(x)"
    ],
    description: "Create a big number from a number or string.",
    examples: [
        "0.1 + 0.2",
        "bignumber(0.1) + bignumber(0.2)",
        'bignumber("7.2")',
        'bignumber("7.2e500")',
        "bignumber([0.1, 0.2, 0.3])"
    ],
    seealso: [
        "boolean",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};

});

parcelRegister("hYUOa", function(module, exports) {

$parcel$export(module.exports, "typeOfDocs", function () { return $d1741b32e711fde6$export$5b193b71b9b497e6; });
var $d1741b32e711fde6$export$5b193b71b9b497e6 = {
    name: "typeOf",
    category: "Utils",
    syntax: [
        "typeOf(x)"
    ],
    description: "Get the type of a variable.",
    examples: [
        "typeOf(3.5)",
        "typeOf(2 - 4i)",
        "typeOf(45 deg)",
        'typeOf("hello world")'
    ],
    seealso: [
        "getMatrixDataType"
    ]
};

});

parcelRegister("dWKEh", function(module, exports) {

$parcel$export(module.exports, "isZeroDocs", function () { return $a274e09f73a432ac$export$52c03b663dd15fa3; });
var $a274e09f73a432ac$export$52c03b663dd15fa3 = {
    name: "isZero",
    category: "Utils",
    syntax: [
        "isZero(x)"
    ],
    description: "Test whether a value is zero.",
    examples: [
        "isZero(2)",
        "isZero(0)",
        "isZero(-4)",
        "isZero([3, 0, -2, 0])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isPositive"
    ]
};

});

parcelRegister("eDnBY", function(module, exports) {

$parcel$export(module.exports, "isPrimeDocs", function () { return $aa7705f1edeb922e$export$d6ada432c5e7d9c7; });
var $aa7705f1edeb922e$export$d6ada432c5e7d9c7 = {
    name: "isPrime",
    category: "Utils",
    syntax: [
        "isPrime(x)"
    ],
    description: "Test whether a value is prime: has no divisors other than itself and one.",
    examples: [
        "isPrime(3)",
        "isPrime(-2)",
        "isPrime([2, 17, 100])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isZero"
    ]
};

});

parcelRegister("6r62a", function(module, exports) {

$parcel$export(module.exports, "isPositiveDocs", function () { return $4af9f1eb5a8c79bb$export$338f53b321c261b9; });
var $4af9f1eb5a8c79bb$export$338f53b321c261b9 = {
    name: "isPositive",
    category: "Utils",
    syntax: [
        "isPositive(x)"
    ],
    description: "Test whether a value is positive: larger than zero.",
    examples: [
        "isPositive(2)",
        "isPositive(0)",
        "isPositive(-4)",
        "isPositive([3, 0.5, -2])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isZero"
    ]
};

});

parcelRegister("jElrL", function(module, exports) {

$parcel$export(module.exports, "isNumericDocs", function () { return $e4e263a36b4fe3d0$export$7ac3927ed17fe2b6; });
var $e4e263a36b4fe3d0$export$7ac3927ed17fe2b6 = {
    name: "isNumeric",
    category: "Utils",
    syntax: [
        "isNumeric(x)"
    ],
    description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
    examples: [
        "isNumeric(2)",
        'isNumeric("2")',
        'hasNumericValue("2")',
        "isNumeric(0)",
        "isNumeric(bignumber(500))",
        "isNumeric(fraction(0.125))",
        "isNumeric(2 + 3i)",
        'isNumeric([2.3, "foo", false])'
    ],
    seealso: [
        "isInteger",
        "isZero",
        "isNegative",
        "isPositive",
        "isNaN",
        "hasNumericValue"
    ]
};

});

parcelRegister("eRDIn", function(module, exports) {

$parcel$export(module.exports, "hasNumericValueDocs", function () { return $ad24d27525c0b763$export$9d10d68d9b7d7a67; });
var $ad24d27525c0b763$export$9d10d68d9b7d7a67 = {
    name: "hasNumericValue",
    category: "Utils",
    syntax: [
        "hasNumericValue(x)"
    ],
    description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
    examples: [
        "hasNumericValue(2)",
        'hasNumericValue("2")',
        'isNumeric("2")',
        "hasNumericValue(0)",
        "hasNumericValue(bignumber(500))",
        "hasNumericValue(fraction(0.125))",
        "hasNumericValue(2 + 3i)",
        'hasNumericValue([2.3, "foo", false])'
    ],
    seealso: [
        "isInteger",
        "isZero",
        "isNegative",
        "isPositive",
        "isNaN",
        "isNumeric"
    ]
};

});

parcelRegister("brgJd", function(module, exports) {

$parcel$export(module.exports, "isNegativeDocs", function () { return $853f3136f51c054b$export$f94a800b9b237f17; });
var $853f3136f51c054b$export$f94a800b9b237f17 = {
    name: "isNegative",
    category: "Utils",
    syntax: [
        "isNegative(x)"
    ],
    description: "Test whether a value is negative: smaller than zero.",
    examples: [
        "isNegative(2)",
        "isNegative(0)",
        "isNegative(-4)",
        "isNegative([3, 0.5, -2])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};

});

parcelRegister("bzz8j", function(module, exports) {

$parcel$export(module.exports, "isIntegerDocs", function () { return $86ce37508c2a7bea$export$1d8b51b394bbccdc; });
var $86ce37508c2a7bea$export$1d8b51b394bbccdc = {
    name: "isInteger",
    category: "Utils",
    syntax: [
        "isInteger(x)"
    ],
    description: "Test whether a value is an integer number.",
    examples: [
        "isInteger(2)",
        "isInteger(3.5)",
        "isInteger([3, 0.5, -2])"
    ],
    seealso: [
        "isNegative",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};

});

parcelRegister("9xjfj", function(module, exports) {

$parcel$export(module.exports, "isNaNDocs", function () { return $6f161ff7b77503a6$export$f4e7c51d549c187f; });
var $6f161ff7b77503a6$export$f4e7c51d549c187f = {
    name: "isNaN",
    category: "Utils",
    syntax: [
        "isNaN(x)"
    ],
    description: "Test whether a value is NaN (not a number)",
    examples: [
        "isNaN(2)",
        "isNaN(0 / 0)",
        "isNaN(NaN)",
        "isNaN(Infinity)"
    ],
    seealso: [
        "isNegative",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};

});

parcelRegister("3jBgh", function(module, exports) {

$parcel$export(module.exports, "formatDocs", function () { return $26a00ccf8aad6f21$export$278425b4fe1ff1bf; });
var $26a00ccf8aad6f21$export$278425b4fe1ff1bf = {
    name: "format",
    category: "Utils",
    syntax: [
        "format(value)",
        "format(value, precision)"
    ],
    description: "Format a value of any type as string.",
    examples: [
        "format(2.3)",
        "format(3 - 4i)",
        "format([])",
        "format(pi, 3)"
    ],
    seealso: [
        "print"
    ]
};

});

parcelRegister("bJceR", function(module, exports) {

$parcel$export(module.exports, "cloneDocs", function () { return $889d640b19dc762e$export$500c01a79e32a1ad; });
var $889d640b19dc762e$export$500c01a79e32a1ad = {
    name: "clone",
    category: "Utils",
    syntax: [
        "clone(x)"
    ],
    description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
    examples: [
        "clone(3.5)",
        "clone(2 - 4i)",
        "clone(45 deg)",
        "clone([1, 2; 3, 4])",
        'clone("hello world")'
    ],
    seealso: []
};

});

parcelRegister("6QKlS", function(module, exports) {

$parcel$export(module.exports, "toDocs", function () { return $4fcb8de4be3e38c1$export$c532fecb2dfa6274; });
var $4fcb8de4be3e38c1$export$c532fecb2dfa6274 = {
    name: "to",
    category: "Units",
    syntax: [
        "x to unit",
        "to(x, unit)"
    ],
    description: "Change the unit of a value.",
    examples: [
        "5 inch to cm",
        "3.2kg to g",
        "16 bytes in bits"
    ],
    seealso: []
};

});

parcelRegister("iX6rI", function(module, exports) {

$parcel$export(module.exports, "tanhDocs", function () { return $dcc2bcb7de0cf0e5$export$52a5c54b85f75620; });
var $dcc2bcb7de0cf0e5$export$52a5c54b85f75620 = {
    name: "tanh",
    category: "Trigonometry",
    syntax: [
        "tanh(x)"
    ],
    description: "Compute the hyperbolic tangent of x in radians.",
    examples: [
        "tanh(0.5)",
        "sinh(0.5) / cosh(0.5)"
    ],
    seealso: [
        "sinh",
        "cosh"
    ]
};

});

parcelRegister("9bN8S", function(module, exports) {

$parcel$export(module.exports, "tanDocs", function () { return $6b0b42c0d0bd9b6f$export$14fc997d4768f36a; });
var $6b0b42c0d0bd9b6f$export$14fc997d4768f36a = {
    name: "tan",
    category: "Trigonometry",
    syntax: [
        "tan(x)"
    ],
    description: "Compute the tangent of x in radians.",
    examples: [
        "tan(0.5)",
        "sin(0.5) / cos(0.5)",
        "tan(pi / 4)",
        "tan(45 deg)"
    ],
    seealso: [
        "atan",
        "sin",
        "cos"
    ]
};

});

parcelRegister("1mV6T", function(module, exports) {

$parcel$export(module.exports, "sinhDocs", function () { return $0ff425666e3e6764$export$e07b4c62bc488091; });
var $0ff425666e3e6764$export$e07b4c62bc488091 = {
    name: "sinh",
    category: "Trigonometry",
    syntax: [
        "sinh(x)"
    ],
    description: "Compute the hyperbolic sine of x in radians.",
    examples: [
        "sinh(0.5)"
    ],
    seealso: [
        "cosh",
        "tanh"
    ]
};

});

parcelRegister("9aQ14", function(module, exports) {

$parcel$export(module.exports, "sechDocs", function () { return $6add659804797b16$export$6da75bc9afc8303b; });
var $6add659804797b16$export$6da75bc9afc8303b = {
    name: "sech",
    category: "Trigonometry",
    syntax: [
        "sech(x)"
    ],
    description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
    examples: [
        "sech(2)",
        "1 / cosh(2)"
    ],
    seealso: [
        "coth",
        "csch",
        "cosh"
    ]
};

});

parcelRegister("liMR8", function(module, exports) {

$parcel$export(module.exports, "secDocs", function () { return $f8212d31acb8a4f2$export$3dae56ab28d48626; });
var $f8212d31acb8a4f2$export$3dae56ab28d48626 = {
    name: "sec",
    category: "Trigonometry",
    syntax: [
        "sec(x)"
    ],
    description: "Compute the secant of x in radians. Defined as 1/cos(x)",
    examples: [
        "sec(2)",
        "1 / cos(2)"
    ],
    seealso: [
        "cot",
        "csc",
        "cos"
    ]
};

});

parcelRegister("dnSL9", function(module, exports) {

$parcel$export(module.exports, "cschDocs", function () { return $9be7e675f62837c4$export$8baf7f6e609495d8; });
var $9be7e675f62837c4$export$8baf7f6e609495d8 = {
    name: "csch",
    category: "Trigonometry",
    syntax: [
        "csch(x)"
    ],
    description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
    examples: [
        "csch(2)",
        "1 / sinh(2)"
    ],
    seealso: [
        "sech",
        "coth",
        "sinh"
    ]
};

});

parcelRegister("9RdNK", function(module, exports) {

$parcel$export(module.exports, "cscDocs", function () { return $72d3c4f3a0372c97$export$1be2e18f41ba39dc; });
var $72d3c4f3a0372c97$export$1be2e18f41ba39dc = {
    name: "csc",
    category: "Trigonometry",
    syntax: [
        "csc(x)"
    ],
    description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
    examples: [
        "csc(2)",
        "1 / sin(2)"
    ],
    seealso: [
        "sec",
        "cot",
        "sin"
    ]
};

});

parcelRegister("d8I9b", function(module, exports) {

$parcel$export(module.exports, "cothDocs", function () { return $990e44642e655a73$export$7cd2898db0b732d0; });
var $990e44642e655a73$export$7cd2898db0b732d0 = {
    name: "coth",
    category: "Trigonometry",
    syntax: [
        "coth(x)"
    ],
    description: "Compute the hyperbolic cotangent of x in radians.",
    examples: [
        "coth(2)",
        "1 / tanh(2)"
    ],
    seealso: [
        "sech",
        "csch",
        "tanh"
    ]
};

});

parcelRegister("8oWSk", function(module, exports) {

$parcel$export(module.exports, "cotDocs", function () { return $61de3c0504226535$export$b6bae004c5b418ef; });
var $61de3c0504226535$export$b6bae004c5b418ef = {
    name: "cot",
    category: "Trigonometry",
    syntax: [
        "cot(x)"
    ],
    description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
    examples: [
        "cot(2)",
        "1 / tan(2)"
    ],
    seealso: [
        "sec",
        "csc",
        "tan"
    ]
};

});

parcelRegister("fIgGp", function(module, exports) {

$parcel$export(module.exports, "coshDocs", function () { return $b707e7fb420749b0$export$5af2bed23001ffc5; });
var $b707e7fb420749b0$export$5af2bed23001ffc5 = {
    name: "cosh",
    category: "Trigonometry",
    syntax: [
        "cosh(x)"
    ],
    description: "Compute the hyperbolic cosine of x in radians.",
    examples: [
        "cosh(0.5)"
    ],
    seealso: [
        "sinh",
        "tanh",
        "coth"
    ]
};

});

parcelRegister("gtvdW", function(module, exports) {

$parcel$export(module.exports, "cosDocs", function () { return $bfe7932ead20b842$export$1a1af52900b6c58e; });
var $bfe7932ead20b842$export$1a1af52900b6c58e = {
    name: "cos",
    category: "Trigonometry",
    syntax: [
        "cos(x)"
    ],
    description: "Compute the cosine of x in radians.",
    examples: [
        "cos(2)",
        "cos(pi / 4) ^ 2",
        "cos(180 deg)",
        "cos(60 deg)",
        "sin(0.2)^2 + cos(0.2)^2"
    ],
    seealso: [
        "acos",
        "sin",
        "tan"
    ]
};

});

parcelRegister("83x5Z", function(module, exports) {

$parcel$export(module.exports, "atan2Docs", function () { return $5dd846a12e23d956$export$e4fc5308b4910337; });
var $5dd846a12e23d956$export$e4fc5308b4910337 = {
    name: "atan2",
    category: "Trigonometry",
    syntax: [
        "atan2(y, x)"
    ],
    description: "Computes the principal value of the arc tangent of y/x in radians.",
    examples: [
        "atan2(2, 2) / pi",
        "angle = 60 deg in rad",
        "x = cos(angle)",
        "y = sin(angle)",
        "atan2(y, x)"
    ],
    seealso: [
        "sin",
        "cos",
        "tan"
    ]
};

});

parcelRegister("8nwQw", function(module, exports) {

$parcel$export(module.exports, "atanhDocs", function () { return $6199f341ea13bbd0$export$e5bbdb9caa9a8f09; });
var $6199f341ea13bbd0$export$e5bbdb9caa9a8f09 = {
    name: "atanh",
    category: "Trigonometry",
    syntax: [
        "atanh(x)"
    ],
    description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
    examples: [
        "atanh(0.5)"
    ],
    seealso: [
        "acosh",
        "asinh"
    ]
};

});

parcelRegister("2UyYA", function(module, exports) {

$parcel$export(module.exports, "atanDocs", function () { return $21ebf143e6b882b7$export$80066e40c56154f0; });
var $21ebf143e6b882b7$export$80066e40c56154f0 = {
    name: "atan",
    category: "Trigonometry",
    syntax: [
        "atan(x)"
    ],
    description: "Compute the inverse tangent of a value in radians.",
    examples: [
        "atan(0.5)",
        "atan(tan(0.5))"
    ],
    seealso: [
        "tan",
        "acos",
        "asin"
    ]
};

});

parcelRegister("bpGn7", function(module, exports) {

$parcel$export(module.exports, "asinhDocs", function () { return $84f2e5af52eefa9c$export$afe7a3b04750ebb7; });
var $84f2e5af52eefa9c$export$afe7a3b04750ebb7 = {
    name: "asinh",
    category: "Trigonometry",
    syntax: [
        "asinh(x)"
    ],
    description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
    examples: [
        "asinh(0.5)"
    ],
    seealso: [
        "acosh",
        "atanh"
    ]
};

});

parcelRegister("9a9fY", function(module, exports) {

$parcel$export(module.exports, "asinDocs", function () { return $6abc3a63d074dc11$export$b85b8db6e8a2ed3d; });
var $6abc3a63d074dc11$export$b85b8db6e8a2ed3d = {
    name: "asin",
    category: "Trigonometry",
    syntax: [
        "asin(x)"
    ],
    description: "Compute the inverse sine of a value in radians.",
    examples: [
        "asin(0.5)",
        "asin(sin(0.5))"
    ],
    seealso: [
        "sin",
        "acos",
        "atan"
    ]
};

});

parcelRegister("boKuU", function(module, exports) {

$parcel$export(module.exports, "asechDocs", function () { return $84c60110dc63bea4$export$52f8b22e9936e0e; });
var $84c60110dc63bea4$export$52f8b22e9936e0e = {
    name: "asech",
    category: "Trigonometry",
    syntax: [
        "asech(x)"
    ],
    description: "Calculate the inverse secant of a value.",
    examples: [
        "asech(0.5)"
    ],
    seealso: [
        "acsch",
        "acoth"
    ]
};

});

parcelRegister("7w1OG", function(module, exports) {

$parcel$export(module.exports, "asecDocs", function () { return $578cee402f5cda85$export$fbe1d815e0591494; });
var $578cee402f5cda85$export$fbe1d815e0591494 = {
    name: "asec",
    category: "Trigonometry",
    syntax: [
        "asec(x)"
    ],
    description: "Calculate the inverse secant of a value.",
    examples: [
        "asec(0.5)",
        "asec(sec(0.5))",
        "asec(2)"
    ],
    seealso: [
        "acos",
        "acot",
        "acsc"
    ]
};

});

parcelRegister("aKY8R", function(module, exports) {

$parcel$export(module.exports, "acschDocs", function () { return $7d4cda2dee42ba11$export$319c6d631e591850; });
var $7d4cda2dee42ba11$export$319c6d631e591850 = {
    name: "acsch",
    category: "Trigonometry",
    syntax: [
        "acsch(x)"
    ],
    description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
    examples: [
        "acsch(0.5)"
    ],
    seealso: [
        "asech",
        "acoth"
    ]
};

});

parcelRegister("jshkX", function(module, exports) {

$parcel$export(module.exports, "acscDocs", function () { return $e29e1499a2e04e5e$export$911b51cd6a7612a8; });
var $e29e1499a2e04e5e$export$911b51cd6a7612a8 = {
    name: "acsc",
    category: "Trigonometry",
    syntax: [
        "acsc(x)"
    ],
    description: "Calculate the inverse cotangent of a value.",
    examples: [
        "acsc(2)",
        "acsc(csc(0.5))",
        "acsc(0.5)"
    ],
    seealso: [
        "csc",
        "asin",
        "asec"
    ]
};

});

parcelRegister("cZLyY", function(module, exports) {

$parcel$export(module.exports, "acothDocs", function () { return $976013971dcb4887$export$b7d7f2d7d0d4ec7d; });
var $976013971dcb4887$export$b7d7f2d7d0d4ec7d = {
    name: "acoth",
    category: "Trigonometry",
    syntax: [
        "acoth(x)"
    ],
    description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
    examples: [
        "acoth(2)",
        "acoth(0.5)"
    ],
    seealso: [
        "acsch",
        "asech"
    ]
};

});

parcelRegister("44RLD", function(module, exports) {

$parcel$export(module.exports, "acotDocs", function () { return $2f813e3738eafad9$export$5df2d36103c3facc; });
var $2f813e3738eafad9$export$5df2d36103c3facc = {
    name: "acot",
    category: "Trigonometry",
    syntax: [
        "acot(x)"
    ],
    description: "Calculate the inverse cotangent of a value.",
    examples: [
        "acot(0.5)",
        "acot(cot(0.5))",
        "acot(2)"
    ],
    seealso: [
        "cot",
        "atan"
    ]
};

});

parcelRegister("CEdCr", function(module, exports) {

$parcel$export(module.exports, "acoshDocs", function () { return $0742bf5004d14bce$export$eb8f1b26819009ca; });
var $0742bf5004d14bce$export$eb8f1b26819009ca = {
    name: "acosh",
    category: "Trigonometry",
    syntax: [
        "acosh(x)"
    ],
    description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
    examples: [
        "acosh(1.5)"
    ],
    seealso: [
        "cosh",
        "asinh",
        "atanh"
    ]
};

});

parcelRegister("e5jhd", function(module, exports) {

$parcel$export(module.exports, "acosDocs", function () { return $a4107c3e8d976731$export$a96a9170bca705dc; });
var $a4107c3e8d976731$export$a96a9170bca705dc = {
    name: "acos",
    category: "Trigonometry",
    syntax: [
        "acos(x)"
    ],
    description: "Compute the inverse cosine of a value in radians.",
    examples: [
        "acos(0.5)",
        "acos(cos(2.3))"
    ],
    seealso: [
        "cos",
        "atan",
        "asin"
    ]
};

});

parcelRegister("9SVYL", function(module, exports) {

$parcel$export(module.exports, "sumDocs", function () { return $7326219fdc3c8155$export$cd6065b38df4efb0; });
var $7326219fdc3c8155$export$cd6065b38df4efb0 = {
    name: "sum",
    category: "Statistics",
    syntax: [
        "sum(a, b, c, ...)",
        "sum(A)"
    ],
    description: "Compute the sum of all values.",
    examples: [
        "sum(2, 3, 4, 1)",
        "sum([2, 3, 4, 1])",
        "sum([2, 5; 4, 3])"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("dwn59", function(module, exports) {

$parcel$export(module.exports, "stdDocs", function () { return $9d802b251762b063$export$d1c23b21300d0eb8; });
var $9d802b251762b063$export$d1c23b21300d0eb8 = {
    name: "std",
    category: "Statistics",
    syntax: [
        "std(a, b, c, ...)",
        "std(A)",
        "std(A, normalization)"
    ],
    description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    examples: [
        "std(2, 4, 6)",
        "std([2, 4, 6, 8])",
        'std([2, 4, 6, 8], "uncorrected")',
        'std([2, 4, 6, 8], "biased")',
        "std([1, 2, 3; 4, 5, 6])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "prod",
        "sum",
        "variance"
    ]
};

});

parcelRegister("6se9a", function(module, exports) {

$parcel$export(module.exports, "quantileSeqDocs", function () { return $4b3054dda46020b7$export$f80c87524ae9a59f; });
var $4b3054dda46020b7$export$f80c87524ae9a59f = {
    name: "quantileSeq",
    category: "Statistics",
    syntax: [
        "quantileSeq(A, prob[, sorted])",
        "quantileSeq(A, [prob1, prob2, ...][, sorted])",
        "quantileSeq(A, N[, sorted])"
    ],
    description: "Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.",
    examples: [
        "quantileSeq([3, -1, 5, 7], 0.5)",
        "quantileSeq([3, -1, 5, 7], [1/3, 2/3])",
        "quantileSeq([3, -1, 5, 7], 2)",
        "quantileSeq([-1, 3, 5, 7], 0.5, true)"
    ],
    seealso: [
        "mean",
        "median",
        "min",
        "max",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("ahNUZ", function(module, exports) {

$parcel$export(module.exports, "prodDocs", function () { return $77d236a1b16e3d4e$export$524cc5e521f0e533; });
var $77d236a1b16e3d4e$export$524cc5e521f0e533 = {
    name: "prod",
    category: "Statistics",
    syntax: [
        "prod(a, b, c, ...)",
        "prod(A)"
    ],
    description: "Compute the product of all values.",
    examples: [
        "prod(2, 3, 4)",
        "prod([2, 3, 4])",
        "prod([2, 5; 4, 3])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("apCH7", function(module, exports) {

$parcel$export(module.exports, "modeDocs", function () { return $794a4117e13adaee$export$30b601fd0273be74; });
var $794a4117e13adaee$export$30b601fd0273be74 = {
    name: "mode",
    category: "Statistics",
    syntax: [
        "mode(a, b, c, ...)",
        "mode(A)",
        "mode(A, a, b, B, c, ...)"
    ],
    description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
    examples: [
        "mode(2, 1, 4, 3, 1)",
        "mode([1, 2.7, 3.2, 4, 2.7])",
        "mode(1, 4, 6, 1, 6)"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("jzxbF", function(module, exports) {

$parcel$export(module.exports, "minDocs", function () { return $e3fb077bf2f0178c$export$17718e9907e3ac84; });
var $e3fb077bf2f0178c$export$17718e9907e3ac84 = {
    name: "min",
    category: "Statistics",
    syntax: [
        "min(a, b, c, ...)",
        "min(A)",
        "min(A, dim)"
    ],
    description: "Compute the minimum value of a list of values.",
    examples: [
        "min(2, 3, 4, 1)",
        "min([2, 3, 4, 1])",
        "min([2, 5; 4, 3])",
        "min([2, 5; 4, 3], 1)",
        "min([2, 5; 4, 3], 2)",
        "min(2.7, 7.1, -4.5, 2.0, 4.1)",
        "max(2.7, 7.1, -4.5, 2.0, 4.1)"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("4cmN3", function(module, exports) {

$parcel$export(module.exports, "medianDocs", function () { return $30e9f614bfab6ed0$export$dd1c97a64d85784b; });
var $30e9f614bfab6ed0$export$dd1c97a64d85784b = {
    name: "median",
    category: "Statistics",
    syntax: [
        "median(a, b, c, ...)",
        "median(A)"
    ],
    description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
    examples: [
        "median(5, 2, 7)",
        "median([3, -1, 5, 7])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "prod",
        "std",
        "sum",
        "variance",
        "quantileSeq"
    ]
};

});

parcelRegister("eHQ4N", function(module, exports) {

$parcel$export(module.exports, "meanDocs", function () { return $ab4d7a1bbef63f00$export$1f7fad79151d4cc1; });
var $ab4d7a1bbef63f00$export$1f7fad79151d4cc1 = {
    name: "mean",
    category: "Statistics",
    syntax: [
        "mean(a, b, c, ...)",
        "mean(A)",
        "mean(A, dim)"
    ],
    description: "Compute the arithmetic mean of a list of values.",
    examples: [
        "mean(2, 3, 4, 1)",
        "mean([2, 3, 4, 1])",
        "mean([2, 5; 4, 3])",
        "mean([2, 5; 4, 3], 1)",
        "mean([2, 5; 4, 3], 2)",
        "mean([1.0, 2.7, 3.2, 4.0])"
    ],
    seealso: [
        "max",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("nCKQN", function(module, exports) {

$parcel$export(module.exports, "maxDocs", function () { return $047035f6c60ab90c$export$f3fddd6eb2764aa6; });
var $047035f6c60ab90c$export$f3fddd6eb2764aa6 = {
    name: "max",
    category: "Statistics",
    syntax: [
        "max(a, b, c, ...)",
        "max(A)",
        "max(A, dim)"
    ],
    description: "Compute the maximum value of a list of values.",
    examples: [
        "max(2, 3, 4, 1)",
        "max([2, 3, 4, 1])",
        "max([2, 5; 4, 3])",
        "max([2, 5; 4, 3], 1)",
        "max([2, 5; 4, 3], 2)",
        "max(2.7, 7.1, -4.5, 2.0, 4.1)",
        "min(2.7, 7.1, -4.5, 2.0, 4.1)"
    ],
    seealso: [
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};

});

parcelRegister("7w5Uf", function(module, exports) {

$parcel$export(module.exports, "madDocs", function () { return $57901a6c61077fa5$export$113a75651a4a72c6; });
var $57901a6c61077fa5$export$113a75651a4a72c6 = {
    name: "mad",
    category: "Statistics",
    syntax: [
        "mad(a, b, c, ...)",
        "mad(A)"
    ],
    description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
    examples: [
        "mad(10, 20, 30)",
        "mad([1, 2, 3])"
    ],
    seealso: [
        "mean",
        "median",
        "std",
        "abs"
    ]
};

});

parcelRegister("2WRJT", function(module, exports) {

$parcel$export(module.exports, "erfDocs", function () { return $225aaf0ebfe8104c$export$23984555c8f4e00a; });
var $225aaf0ebfe8104c$export$23984555c8f4e00a = {
    name: "erf",
    category: "Special",
    syntax: [
        "erf(x)"
    ],
    description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
    examples: [
        "erf(0.2)",
        "erf(-0.5)",
        "erf(4)"
    ],
    seealso: []
};

});

parcelRegister("deDAG", function(module, exports) {

$parcel$export(module.exports, "setUnionDocs", function () { return $9a2b4b0fff1edc01$export$c6ab538723059178; });
var $9a2b4b0fff1edc01$export$c6ab538723059178 = {
    name: "setUnion",
    category: "Set",
    syntax: [
        "setUnion(set1, set2)"
    ],
    description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setUnion([1, 2, 3, 4], [3, 4, 5, 6])",
        "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setIntersect",
        "setDifference"
    ]
};

});

parcelRegister("beQTr", function(module, exports) {

$parcel$export(module.exports, "setSymDifferenceDocs", function () { return $82ea080810953817$export$340d6a7da02d62f3; });
var $82ea080810953817$export$340d6a7da02d62f3 = {
    name: "setSymDifference",
    category: "Set",
    syntax: [
        "setSymDifference(set1, set2)"
    ],
    description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])",
        "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};

});

parcelRegister("3iB2L", function(module, exports) {

$parcel$export(module.exports, "setSizeDocs", function () { return $266fc99cd5d5fabb$export$47ff1cdc99784c11; });
var $266fc99cd5d5fabb$export$47ff1cdc99784c11 = {
    name: "setSize",
    category: "Set",
    syntax: [
        "setSize(set)",
        "setSize(set, unique)"
    ],
    description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
    examples: [
        "setSize([1, 2, 2, 4])",
        "setSize([1, 2, 2, 4], true)"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};

});

parcelRegister("ezvI3", function(module, exports) {

$parcel$export(module.exports, "setPowersetDocs", function () { return $a9bcee6e611e512e$export$7040fb97e0f08a08; });
var $a9bcee6e611e512e$export$7040fb97e0f08a08 = {
    name: "setPowerset",
    category: "Set",
    syntax: [
        "setPowerset(set)"
    ],
    description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setPowerset([1, 2, 3])"
    ],
    seealso: [
        "setCartesian"
    ]
};

});

parcelRegister("d29HZ", function(module, exports) {

$parcel$export(module.exports, "setMultiplicityDocs", function () { return $97d2fe2a0390048c$export$33972a95e247fd58; });
var $97d2fe2a0390048c$export$33972a95e247fd58 = {
    name: "setMultiplicity",
    category: "Set",
    syntax: [
        "setMultiplicity(element, set)"
    ],
    description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setMultiplicity(1, [1, 2, 2, 4])",
        "setMultiplicity(2, [1, 2, 2, 4])"
    ],
    seealso: [
        "setDistinct",
        "setSize"
    ]
};

});

parcelRegister("hG2uC", function(module, exports) {

$parcel$export(module.exports, "setIsSubsetDocs", function () { return $cde84aeafca5a80b$export$995337132a02fcf0; });
var $cde84aeafca5a80b$export$995337132a02fcf0 = {
    name: "setIsSubset",
    category: "Set",
    syntax: [
        "setIsSubset(set1, set2)"
    ],
    description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setIsSubset([1, 2], [3, 4, 5, 6])",
        "setIsSubset([3, 4], [3, 4, 5, 6])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};

});

parcelRegister("g3f4E", function(module, exports) {

$parcel$export(module.exports, "setIntersectDocs", function () { return $baf89e86c153ed80$export$97fa484e42285777; });
var $baf89e86c153ed80$export$97fa484e42285777 = {
    name: "setIntersect",
    category: "Set",
    syntax: [
        "setIntersect(set1, set2)"
    ],
    description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setIntersect([1, 2, 3, 4], [3, 4, 5, 6])",
        "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setDifference"
    ]
};

});

parcelRegister("b5lNC", function(module, exports) {

$parcel$export(module.exports, "setDistinctDocs", function () { return $812112390e27bda4$export$4c8f2f903562c625; });
var $812112390e27bda4$export$4c8f2f903562c625 = {
    name: "setDistinct",
    category: "Set",
    syntax: [
        "setDistinct(set)"
    ],
    description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setDistinct([1, 1, 1, 2, 2, 3])"
    ],
    seealso: [
        "setMultiplicity"
    ]
};

});

parcelRegister("k6QQQ", function(module, exports) {

$parcel$export(module.exports, "setDifferenceDocs", function () { return $ea3d5d5bfb60e441$export$44337ef629295c55; });
var $ea3d5d5bfb60e441$export$44337ef629295c55 = {
    name: "setDifference",
    category: "Set",
    syntax: [
        "setDifference(set1, set2)"
    ],
    description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setDifference([1, 2, 3, 4], [3, 4, 5, 6])",
        "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setSymDifference"
    ]
};

});

parcelRegister("81bdO", function(module, exports) {

$parcel$export(module.exports, "setCartesianDocs", function () { return $5d671f20fed0bf5c$export$6f06d74ab9e6fcad; });
var $5d671f20fed0bf5c$export$6f06d74ab9e6fcad = {
    name: "setCartesian",
    category: "Set",
    syntax: [
        "setCartesian(set1, set2)"
    ],
    description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setCartesian([1, 2], [3, 4])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference",
        "setPowerset"
    ]
};

});

parcelRegister("kPPS5", function(module, exports) {

$parcel$export(module.exports, "unequalDocs", function () { return $f2b0cea4e1c2e473$export$adade6432715c34e; });
var $f2b0cea4e1c2e473$export$adade6432715c34e = {
    name: "unequal",
    category: "Relational",
    syntax: [
        "x != y",
        "unequal(x, y)"
    ],
    description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
    examples: [
        "2+2 != 3",
        "2+2 != 4",
        "a = 3.2",
        "b = 6-2.8",
        "a != b",
        "50cm != 0.5m",
        "5 cm != 2 inch"
    ],
    seealso: [
        "equal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare",
        "deepEqual"
    ]
};

});

parcelRegister("8vZ4f", function(module, exports) {

$parcel$export(module.exports, "smallerEqDocs", function () { return $633096b0dae00d74$export$2693b3d153548453; });
var $633096b0dae00d74$export$2693b3d153548453 = {
    name: "smallerEq",
    category: "Relational",
    syntax: [
        "x <= y",
        "smallerEq(x, y)"
    ],
    description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
    examples: [
        "2 <= 1+1",
        "2 < 1+1",
        "a = 3.2",
        "b = 6-2.8",
        "(a <= b)"
    ],
    seealso: [
        "equal",
        "unequal",
        "larger",
        "smaller",
        "largerEq",
        "compare"
    ]
};

});

parcelRegister("eqJQP", function(module, exports) {

$parcel$export(module.exports, "smallerDocs", function () { return $a8170f7638fef175$export$4ecf0efdd4fb906b; });
var $a8170f7638fef175$export$4ecf0efdd4fb906b = {
    name: "smaller",
    category: "Relational",
    syntax: [
        "x < y",
        "smaller(x, y)"
    ],
    description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
    examples: [
        "2 < 3",
        "5 < 2*2",
        "a = 3.3",
        "b = 6-2.8",
        "(a < b)",
        "5 cm < 2 inch"
    ],
    seealso: [
        "equal",
        "unequal",
        "larger",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};

});

parcelRegister("8nLi5", function(module, exports) {

$parcel$export(module.exports, "largerEqDocs", function () { return $61a527a94aa79984$export$6ba4892ab98a938f; });
var $61a527a94aa79984$export$6ba4892ab98a938f = {
    name: "largerEq",
    category: "Relational",
    syntax: [
        "x >= y",
        "largerEq(x, y)"
    ],
    description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
    examples: [
        "2 >= 1+1",
        "2 > 1+1",
        "a = 3.2",
        "b = 6-2.8",
        "(a >= b)"
    ],
    seealso: [
        "equal",
        "unequal",
        "smallerEq",
        "smaller",
        "compare"
    ]
};

});

parcelRegister("9PO32", function(module, exports) {

$parcel$export(module.exports, "largerDocs", function () { return $728fb2f6fcafa58c$export$c775ecf5ac7366c3; });
var $728fb2f6fcafa58c$export$c775ecf5ac7366c3 = {
    name: "larger",
    category: "Relational",
    syntax: [
        "x > y",
        "larger(x, y)"
    ],
    description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
    examples: [
        "2 > 3",
        "5 > 2*2",
        "a = 3.3",
        "b = 6-2.8",
        "(a > b)",
        "(b < a)",
        "5 cm > 2 inch"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};

});

parcelRegister("9vmcr", function(module, exports) {

$parcel$export(module.exports, "equalTextDocs", function () { return $6eb83aaf5d328322$export$9f17f53860452971; });
var $6eb83aaf5d328322$export$9f17f53860452971 = {
    name: "equalText",
    category: "Relational",
    syntax: [
        "equalText(x, y)"
    ],
    description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
    examples: [
        'equalText("Hello", "Hello")',
        'equalText("a", "A")',
        'equal("2e3", "2000")',
        'equalText("2e3", "2000")',
        'equalText("B", ["A", "B", "C"])'
    ],
    seealso: [
        "compare",
        "compareNatural",
        "compareText",
        "equal"
    ]
};

});

parcelRegister("9u5nx", function(module, exports) {

$parcel$export(module.exports, "equalDocs", function () { return $6e7b16764a3d75cc$export$5d5e6107045d826c; });
var $6e7b16764a3d75cc$export$5d5e6107045d826c = {
    name: "equal",
    category: "Relational",
    syntax: [
        "x == y",
        "equal(x, y)"
    ],
    description: "Check equality of two values. Returns true if the values are equal, and false if not.",
    examples: [
        "2+2 == 3",
        "2+2 == 4",
        "a = 3.2",
        "b = 6-2.8",
        "a == b",
        "50cm == 0.5m"
    ],
    seealso: [
        "unequal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare",
        "deepEqual",
        "equalText"
    ]
};

});

parcelRegister("c1wcN", function(module, exports) {

$parcel$export(module.exports, "deepEqualDocs", function () { return $8c0e8f55e54ad490$export$b25f67ed715e775e; });
var $8c0e8f55e54ad490$export$b25f67ed715e775e = {
    name: "deepEqual",
    category: "Relational",
    syntax: [
        "deepEqual(x, y)"
    ],
    description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
    examples: [
        "deepEqual([1,3,4], [1,3,4])",
        "deepEqual([1,3,4], [1,3])"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};

});

parcelRegister("4k5mO", function(module, exports) {

$parcel$export(module.exports, "compareTextDocs", function () { return $325d316f6a5e3006$export$f1ca5e1f3bd19e5d; });
var $325d316f6a5e3006$export$f1ca5e1f3bd19e5d = {
    name: "compareText",
    category: "Relational",
    syntax: [
        "compareText(x, y)"
    ],
    description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        'compareText("B", "A")',
        'compareText("A", "B")',
        'compareText("A", "A")',
        'compareText("2", "10")',
        'compare("2", "10")',
        "compare(2, 10)",
        'compareNatural("2", "10")',
        'compareText("B", ["A", "B", "C"])'
    ],
    seealso: [
        "compare",
        "compareNatural"
    ]
};

});

parcelRegister("hn0us", function(module, exports) {

$parcel$export(module.exports, "compareNaturalDocs", function () { return $ca54f7005d622748$export$3d0415783a6e23a4; });
var $ca54f7005d622748$export$3d0415783a6e23a4 = {
    name: "compareNatural",
    category: "Relational",
    syntax: [
        "compareNatural(x, y)"
    ],
    description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        "compareNatural(2, 3)",
        "compareNatural(3, 2)",
        "compareNatural(2, 2)",
        "compareNatural(5cm, 40mm)",
        'compareNatural("2", "10")',
        "compareNatural(2 + 3i, 2 + 4i)",
        "compareNatural([1, 2, 4], [1, 2, 3])",
        "compareNatural([1, 5], [1, 2, 3])",
        "compareNatural([1, 2], [1, 2])",
        "compareNatural({a: 2}, {a: 4})"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compare",
        "compareText"
    ]
};

});

parcelRegister("3uybB", function(module, exports) {

$parcel$export(module.exports, "compareDocs", function () { return $28aeb11718ceba0d$export$b01f6c58c90dea20; });
var $28aeb11718ceba0d$export$b01f6c58c90dea20 = {
    name: "compare",
    category: "Relational",
    syntax: [
        "compare(x, y)"
    ],
    description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        "compare(2, 3)",
        "compare(3, 2)",
        "compare(2, 2)",
        "compare(5cm, 40mm)",
        "compare(2, [1, 2, 3])"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compareNatural",
        "compareText"
    ]
};

});

parcelRegister("kNKT8", function(module, exports) {

$parcel$export(module.exports, "randomIntDocs", function () { return $f24cc14ae8b8e136$export$8e2c9b3226630e9d; });
var $f24cc14ae8b8e136$export$8e2c9b3226630e9d = {
    name: "randomInt",
    category: "Probability",
    syntax: [
        "randomInt(max)",
        "randomInt(min, max)",
        "randomInt(size)",
        "randomInt(size, max)",
        "randomInt(size, min, max)"
    ],
    description: "Return a random integer number",
    examples: [
        "randomInt(10, 20)",
        "randomInt([2, 3], 10)"
    ],
    seealso: [
        "pickRandom",
        "random"
    ]
};

});

parcelRegister("2vNtL", function(module, exports) {

$parcel$export(module.exports, "randomDocs", function () { return $1d44db8bd5176f95$export$d2b3cacd4d3219ec; });
var $1d44db8bd5176f95$export$d2b3cacd4d3219ec = {
    name: "random",
    category: "Probability",
    syntax: [
        "random()",
        "random(max)",
        "random(min, max)",
        "random(size)",
        "random(size, max)",
        "random(size, min, max)"
    ],
    description: "Return a random number.",
    examples: [
        "random()",
        "random(10, 20)",
        "random([2, 3])"
    ],
    seealso: [
        "pickRandom",
        "randomInt"
    ]
};

});

parcelRegister("1InaJ", function(module, exports) {

$parcel$export(module.exports, "pickRandomDocs", function () { return $13fbdffbae512f2c$export$4a787d8dccbe181f; });
var $13fbdffbae512f2c$export$4a787d8dccbe181f = {
    name: "pickRandom",
    category: "Probability",
    syntax: [
        "pickRandom(array)",
        "pickRandom(array, number)",
        "pickRandom(array, weights)",
        "pickRandom(array, number, weights)",
        "pickRandom(array, weights, number)"
    ],
    description: "Pick a random entry from a given array.",
    examples: [
        "pickRandom(0:10)",
        "pickRandom([1, 3, 1, 6])",
        "pickRandom([1, 3, 1, 6], 2)",
        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])",
        "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])",
        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"
    ],
    seealso: [
        "random",
        "randomInt"
    ]
};

});

parcelRegister("7A09n", function(module, exports) {

$parcel$export(module.exports, "permutationsDocs", function () { return $584c030cf554a42a$export$eebb1076c4c85884; });
var $584c030cf554a42a$export$eebb1076c4c85884 = {
    name: "permutations",
    category: "Probability",
    syntax: [
        "permutations(n)",
        "permutations(n, k)"
    ],
    description: "Compute the number of permutations of n items taken k at a time",
    examples: [
        "permutations(5)",
        "permutations(5, 3)"
    ],
    seealso: [
        "combinations",
        "combinationsWithRep",
        "factorial"
    ]
};

});

parcelRegister("6z82k", function(module, exports) {

$parcel$export(module.exports, "multinomialDocs", function () { return $4c7c3edc60957964$export$5f53cf42e3f9579d; });
var $4c7c3edc60957964$export$5f53cf42e3f9579d = {
    name: "multinomial",
    category: "Probability",
    syntax: [
        "multinomial(A)"
    ],
    description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
    examples: [
        "multinomial([1, 2, 1])"
    ],
    seealso: [
        "combinations",
        "factorial"
    ]
};

});

parcelRegister("905hZ", function(module, exports) {

$parcel$export(module.exports, "kldivergenceDocs", function () { return $68d83779a2ace32f$export$9f240af60ea686af; });
var $68d83779a2ace32f$export$9f240af60ea686af = {
    name: "kldivergence",
    category: "Probability",
    syntax: [
        "kldivergence(x, y)"
    ],
    description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
    examples: [
        "kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"
    ],
    seealso: []
};

});

parcelRegister("2F912", function(module, exports) {

$parcel$export(module.exports, "gammaDocs", function () { return $1f066777d79bbfd7$export$499ae9272b264120; });
var $1f066777d79bbfd7$export$499ae9272b264120 = {
    name: "gamma",
    category: "Probability",
    syntax: [
        "gamma(n)"
    ],
    description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
    examples: [
        "gamma(4)",
        "3!",
        "gamma(1/2)",
        "sqrt(pi)"
    ],
    seealso: [
        "factorial"
    ]
};

});

parcelRegister("e5IIS", function(module, exports) {

$parcel$export(module.exports, "factorialDocs", function () { return $a424395a1b07d473$export$3e6b0f8e2df12b9d; });
var $a424395a1b07d473$export$3e6b0f8e2df12b9d = {
    name: "factorial",
    category: "Probability",
    syntax: [
        "n!",
        "factorial(n)"
    ],
    description: "Compute the factorial of a value",
    examples: [
        "5!",
        "5 * 4 * 3 * 2 * 1",
        "3!"
    ],
    seealso: [
        "combinations",
        "combinationsWithRep",
        "permutations",
        "gamma"
    ]
};

});

parcelRegister("kjQW7", function(module, exports) {

$parcel$export(module.exports, "combinationsDocs", function () { return $ecaea5103574cc99$export$c3382240e69dd024; });
var $ecaea5103574cc99$export$c3382240e69dd024 = {
    name: "combinations",
    category: "Probability",
    syntax: [
        "combinations(n, k)"
    ],
    description: "Compute the number of combinations of n items taken k at a time",
    examples: [
        "combinations(7, 5)"
    ],
    seealso: [
        "combinationsWithRep",
        "permutations",
        "factorial"
    ]
};

});

parcelRegister("lNLv6", function(module, exports) {

$parcel$export(module.exports, "combinationsWithRepDocs", function () { return $fdf30538e7d0cbae$export$6bd2fb28e29d18e3; });
var $fdf30538e7d0cbae$export$6bd2fb28e29d18e3 = {
    name: "combinationsWithRep",
    category: "Probability",
    syntax: [
        "combinationsWithRep(n, k)"
    ],
    description: "Compute the number of combinations of n items taken k at a time with replacements.",
    examples: [
        "combinationsWithRep(7, 5)"
    ],
    seealso: [
        "combinations",
        "permutations",
        "factorial"
    ]
};

});

parcelRegister("dqt7Q", function(module, exports) {

$parcel$export(module.exports, "zerosDocs", function () { return $9c644bd058dafe1d$export$d2794fce5915ba29; });
var $9c644bd058dafe1d$export$d2794fce5915ba29 = {
    name: "zeros",
    category: "Matrix",
    syntax: [
        "zeros(m)",
        "zeros(m, n)",
        "zeros(m, n, p, ...)",
        "zeros([m])",
        "zeros([m, n])",
        "zeros([m, n, p, ...])"
    ],
    description: "Create a matrix containing zeros.",
    examples: [
        "zeros(3)",
        "zeros(3, 5)",
        "a = [1, 2, 3; 4, 5, 6]",
        "zeros(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose"
    ]
};

});

parcelRegister("6pDwH", function(module, exports) {

$parcel$export(module.exports, "transposeDocs", function () { return $4ab3bd0175a4212a$export$96fcaa3e48aec95b; });
var $4ab3bd0175a4212a$export$96fcaa3e48aec95b = {
    name: "transpose",
    category: "Matrix",
    syntax: [
        "x'",
        "transpose(x)"
    ],
    description: "Transpose a matrix",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a'",
        "transpose(a)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "zeros"
    ]
};

});

parcelRegister("94JAt", function(module, exports) {

$parcel$export(module.exports, "traceDocs", function () { return $69b7d970b74301e2$export$46db08346422dd41; });
var $69b7d970b74301e2$export$46db08346422dd41 = {
    name: "trace",
    category: "Matrix",
    syntax: [
        "trace(A)"
    ],
    description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
    examples: [
        "A = [1, 2, 3; -1, 2, 3; 2, 0, 3]",
        "trace(A)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("9x1Fw", function(module, exports) {

$parcel$export(module.exports, "subsetDocs", function () { return $6f087d7c2da3026d$export$c809a1297fda8972; });
var $6f087d7c2da3026d$export$c809a1297fda8972 = {
    name: "subset",
    category: "Matrix",
    syntax: [
        "value(index)",
        "value(index) = replacement",
        "subset(value, [index])",
        "subset(value, [index], replacement)"
    ],
    description: "Get or set a subset of a matrix or string. Indexes are one-based. Both the ranges lower-bound and upper-bound are included.",
    examples: [
        "d = [1, 2; 3, 4]",
        "e = []",
        "e[1, 1:2] = [5, 6]",
        "e[2, :] = [7, 8]",
        "f = d * e",
        "f[2, 1]",
        "f[:, 1]"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("82DFD", function(module, exports) {

$parcel$export(module.exports, "squeezeDocs", function () { return $5dad486071281dd6$export$84665209630d2bb0; });
var $5dad486071281dd6$export$84665209630d2bb0 = {
    name: "squeeze",
    category: "Matrix",
    syntax: [
        "squeeze(x)"
    ],
    description: "Remove inner and outer singleton dimensions from a matrix.",
    examples: [
        "a = zeros(3,2,1)",
        "size(squeeze(a))",
        "b = zeros(1,1,3)",
        "size(squeeze(b))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("kqrjX", function(module, exports) {

$parcel$export(module.exports, "sortDocs", function () { return $edeb6db66757b7c4$export$879539db0de7fe73; });
var $edeb6db66757b7c4$export$879539db0de7fe73 = {
    name: "sort",
    category: "Matrix",
    syntax: [
        "sort(x)",
        "sort(x, compare)"
    ],
    description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
    examples: [
        "sort([5, 10, 1])",
        'sort(["C", "B", "A", "D"])',
        "sortByLength(a, b) = size(a)[1] - size(b)[1]",
        'sort(["Langdon", "Tom", "Sara"], sortByLength)',
        'sort(["10", "1", "2"], "natural")'
    ],
    seealso: [
        "map",
        "filter",
        "forEach"
    ]
};

});

parcelRegister("cTGQE", function(module, exports) {

$parcel$export(module.exports, "sizeDocs", function () { return $963bdbdd3b5795be$export$5044182a5ddc46fd; });
var $963bdbdd3b5795be$export$5044182a5ddc46fd = {
    name: "size",
    category: "Matrix",
    syntax: [
        "size(x)"
    ],
    description: "Calculate the size of a matrix.",
    examples: [
        "size(2.3)",
        'size("hello world")',
        "a = [1, 2; 3, 4; 5, 6]",
        "size(a)",
        "size(1:6)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("7qaGh", function(module, exports) {

$parcel$export(module.exports, "reshapeDocs", function () { return $56733f1952aa66ef$export$f57c799cb449edab; });
var $56733f1952aa66ef$export$f57c799cb449edab = {
    name: "reshape",
    category: "Matrix",
    syntax: [
        "reshape(x, sizes)"
    ],
    description: "Reshape a multi dimensional array to fit the specified dimensions.",
    examples: [
        "reshape([1, 2, 3, 4, 5, 6], [2, 3])",
        "reshape([[1, 2], [3, 4]], [1, 4])",
        "reshape([[1, 2], [3, 4]], [4])"
    ],
    seealso: [
        "size",
        "squeeze",
        "resize"
    ]
};

});

parcelRegister("loBsB", function(module, exports) {

$parcel$export(module.exports, "resizeDocs", function () { return $f938e5b3a19d8e9c$export$9444f970d5d871cc; });
var $f938e5b3a19d8e9c$export$9444f970d5d871cc = {
    name: "resize",
    category: "Matrix",
    syntax: [
        "resize(x, size)",
        "resize(x, size, defaultValue)"
    ],
    description: "Resize a matrix.",
    examples: [
        "resize([1,2,3,4,5], [3])",
        "resize([1,2,3], [5])",
        "resize([1,2,3], [5], -1)",
        "resize(2, [2, 3])",
        'resize("hello", [8], "!")'
    ],
    seealso: [
        "size",
        "subset",
        "squeeze",
        "reshape"
    ]
};

});

parcelRegister("2SbPc", function(module, exports) {

$parcel$export(module.exports, "rangeDocs", function () { return $2179cc16cc6b50b0$export$f7c7d2df7253c271; });
var $2179cc16cc6b50b0$export$f7c7d2df7253c271 = {
    name: "range",
    category: "Type",
    syntax: [
        "start:end",
        "start:step:end",
        "range(start, end)",
        "range(start, end, step)",
        "range(string)"
    ],
    description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
    examples: [
        "1:5",
        "3:-1:-3",
        "range(3, 7)",
        "range(0, 12, 2)",
        'range("4:10")',
        "a = [1, 2, 3, 4; 5, 6, 7, 8]",
        "a[1:2, 1:2]"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("ejbEO", function(module, exports) {

$parcel$export(module.exports, "partitionSelectDocs", function () { return $a6abe1e6e8c7d613$export$65c28ab37b5158f2; });
var $a6abe1e6e8c7d613$export$65c28ab37b5158f2 = {
    name: "partitionSelect",
    category: "Matrix",
    syntax: [
        "partitionSelect(x, k)",
        "partitionSelect(x, k, compare)"
    ],
    description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
    examples: [
        "partitionSelect([5, 10, 1], 2)",
        'partitionSelect(["C", "B", "A", "D"], 1)'
    ],
    seealso: [
        "sort"
    ]
};

});

parcelRegister("1BbRK", function(module, exports) {

$parcel$export(module.exports, "onesDocs", function () { return $12a27375e2c06c8a$export$910fc795c37fb1b2; });
var $12a27375e2c06c8a$export$910fc795c37fb1b2 = {
    name: "ones",
    category: "Matrix",
    syntax: [
        "ones(m)",
        "ones(m, n)",
        "ones(m, n, p, ...)",
        "ones([m])",
        "ones([m, n])",
        "ones([m, n, p, ...])"
    ],
    description: "Create a matrix containing ones.",
    examples: [
        "ones(3)",
        "ones(3, 5)",
        "ones([2,3]) * 4.5",
        "a = [1, 2, 3; 4, 5, 6]",
        "ones(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("cC0j9", function(module, exports) {

$parcel$export(module.exports, "mapDocs", function () { return $92e945c2ef075c03$export$212579151a971c0d; });
var $92e945c2ef075c03$export$212579151a971c0d = {
    name: "map",
    category: "Matrix",
    syntax: [
        "map(x, callback)"
    ],
    description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
    examples: [
        "map([1, 2, 3], square)"
    ],
    seealso: [
        "filter",
        "forEach"
    ]
};

});

parcelRegister("ctklo", function(module, exports) {

$parcel$export(module.exports, "kronDocs", function () { return $9147f95ecf2e0b9c$export$483111e0489c2571; });
var $9147f95ecf2e0b9c$export$483111e0489c2571 = {
    name: "kron",
    category: "Matrix",
    syntax: [
        "kron(x, y)"
    ],
    description: "Calculates the kronecker product of 2 matrices or vectors.",
    examples: [
        "kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])",
        "kron([1,1], [2,3,4])"
    ],
    seealso: [
        "multiply",
        "dot",
        "cross"
    ]
};

});

parcelRegister("d8pkO", function(module, exports) {

$parcel$export(module.exports, "invDocs", function () { return $98ffaca64f9962c1$export$d584490ba37af473; });
var $98ffaca64f9962c1$export$d584490ba37af473 = {
    name: "inv",
    category: "Matrix",
    syntax: [
        "inv(x)"
    ],
    description: "Calculate the inverse of a matrix",
    examples: [
        "inv([1, 2; 3, 4])",
        "inv(4)",
        "1 / 4"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("1LPdy", function(module, exports) {

$parcel$export(module.exports, "forEachDocs", function () { return $14a1e8f9314442a7$export$aa1ea88ef762ab5e; });
var $14a1e8f9314442a7$export$aa1ea88ef762ab5e = {
    name: "forEach",
    category: "Matrix",
    syntax: [
        "forEach(x, callback)"
    ],
    description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
    examples: [
        "forEach([1, 2, 3], function(val) { console.log(val) })"
    ],
    seealso: [
        "map",
        "sort",
        "filter"
    ]
};

});

parcelRegister("3KHcy", function(module, exports) {

$parcel$export(module.exports, "flattenDocs", function () { return $2bb72de203b773f1$export$501e32649028a485; });
var $2bb72de203b773f1$export$501e32649028a485 = {
    name: "flatten",
    category: "Matrix",
    syntax: [
        "flatten(x)"
    ],
    description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "size(a)",
        "b = flatten(a)",
        "size(b)"
    ],
    seealso: [
        "concat",
        "resize",
        "size",
        "squeeze"
    ]
};

});

parcelRegister("35Uns", function(module, exports) {

$parcel$export(module.exports, "filterDocs", function () { return $240d921cbd2e4661$export$86d791908cc7fd0c; });
var $240d921cbd2e4661$export$86d791908cc7fd0c = {
    name: "filter",
    category: "Matrix",
    syntax: [
        "filter(x, test)"
    ],
    description: "Filter items in a matrix.",
    examples: [
        "isPositive(x) = x > 0",
        "filter([6, -2, -1, 4, 3], isPositive)",
        "filter([6, -2, 0, 1, 0], x != 0)"
    ],
    seealso: [
        "sort",
        "map",
        "forEach"
    ]
};

});

parcelRegister("1O0eu", function(module, exports) {

$parcel$export(module.exports, "identityDocs", function () { return $150aa424571cc2b9$export$7fb92bf552f6842; });
var $150aa424571cc2b9$export$7fb92bf552f6842 = {
    name: "identity",
    category: "Matrix",
    syntax: [
        "identity(n)",
        "identity(m, n)",
        "identity([m, n])"
    ],
    description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
    examples: [
        "identity(3)",
        "identity(3, 5)",
        "a = [1, 2, 3; 4, 5, 6]",
        "identity(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("aol2S", function(module, exports) {

$parcel$export(module.exports, "getMatrixDataTypeDocs", function () { return $790c7870f6ab2965$export$bd8d81afc6159d78; });
var $790c7870f6ab2965$export$bd8d81afc6159d78 = {
    name: "getMatrixDataType",
    category: "Matrix",
    syntax: [
        "getMatrixDataType(x)"
    ],
    description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
    examples: [
        "getMatrixDataType([1, 2, 3])",
        "getMatrixDataType([[5 cm], [2 inch]])",
        'getMatrixDataType([1, "text"])',
        "getMatrixDataType([1, bignumber(4)])"
    ],
    seealso: [
        "matrix",
        "sparse",
        "typeOf"
    ]
};

});

parcelRegister("fvqQI", function(module, exports) {

$parcel$export(module.exports, "dotDocs", function () { return $b49e93f89bdd3596$export$5fcedf26656436a1; });
var $b49e93f89bdd3596$export$5fcedf26656436a1 = {
    name: "dot",
    category: "Matrix",
    syntax: [
        "dot(A, B)",
        "A * B"
    ],
    description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
    examples: [
        "dot([2, 4, 1], [2, 2, 3])",
        "[2, 4, 1] * [2, 2, 3]"
    ],
    seealso: [
        "multiply",
        "cross"
    ]
};

});

parcelRegister("6IA6r", function(module, exports) {

$parcel$export(module.exports, "diagDocs", function () { return $4e42db6f85e117bc$export$1c196182ad1e1777; });
var $4e42db6f85e117bc$export$1c196182ad1e1777 = {
    name: "diag",
    category: "Matrix",
    syntax: [
        "diag(x)",
        "diag(x, k)"
    ],
    description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
    examples: [
        "diag(1:3)",
        "diag(1:3, 1)",
        "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]",
        "diag(a)"
    ],
    seealso: [
        "concat",
        "det",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("9rqfq", function(module, exports) {

$parcel$export(module.exports, "detDocs", function () { return $6dfafef4a630b9ff$export$8730784260ee72c2; });
var $6dfafef4a630b9ff$export$8730784260ee72c2 = {
    name: "det",
    category: "Matrix",
    syntax: [
        "det(x)"
    ],
    description: "Calculate the determinant of a matrix",
    examples: [
        "det([1, 2; 3, 4])",
        "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"
    ],
    seealso: [
        "concat",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("cQXwR", function(module, exports) {

$parcel$export(module.exports, "ctransposeDocs", function () { return $95b88492c8245c86$export$f9de74ff268bebd9; });
var $95b88492c8245c86$export$f9de74ff268bebd9 = {
    name: "ctranspose",
    category: "Matrix",
    syntax: [
        "x'",
        "ctranspose(x)"
    ],
    description: "Complex Conjugate and Transpose a matrix",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a'",
        "ctranspose(a)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "zeros"
    ]
};

});

parcelRegister("eytQA", function(module, exports) {

$parcel$export(module.exports, "crossDocs", function () { return $a98b64b27ec2b0fa$export$daf3380fde4ae39d; });
var $a98b64b27ec2b0fa$export$daf3380fde4ae39d = {
    name: "cross",
    category: "Matrix",
    syntax: [
        "cross(A, B)"
    ],
    description: "Calculate the cross product for two vectors in three dimensional space.",
    examples: [
        "cross([1, 1, 0],  [0, 1, 1])",
        "cross([3, -3, 1], [4, 9, 2])",
        "cross([2, 3, 4],  [5, 6, 7])"
    ],
    seealso: [
        "multiply",
        "dot"
    ]
};

});

parcelRegister("1PddZ", function(module, exports) {

$parcel$export(module.exports, "concatDocs", function () { return $1544d00610ffc468$export$2651d46c991329eb; });
var $1544d00610ffc468$export$2651d46c991329eb = {
    name: "concat",
    category: "Matrix",
    syntax: [
        "concat(A, B, C, ...)",
        "concat(A, B, C, ..., dim)"
    ],
    description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
    examples: [
        "A = [1, 2; 5, 6]",
        "B = [3, 4; 7, 8]",
        "concat(A, B)",
        "concat(A, B, 1)",
        "concat(A, B, 2)"
    ],
    seealso: [
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};

});

parcelRegister("hxW19", function(module, exports) {

$parcel$export(module.exports, "xorDocs", function () { return $cc6285d2ce24652c$export$dd9d665b8b14e2b2; });
var $cc6285d2ce24652c$export$dd9d665b8b14e2b2 = {
    name: "xor",
    category: "Logical",
    syntax: [
        "x xor y",
        "xor(x, y)"
    ],
    description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
    examples: [
        "true xor false",
        "false xor false",
        "true xor true",
        "0 xor 4"
    ],
    seealso: [
        "not",
        "and",
        "or"
    ]
};

});

parcelRegister("l6qly", function(module, exports) {

$parcel$export(module.exports, "orDocs", function () { return $f5ce98636102c9c5$export$2200bcb1a08f6f8d; });
var $f5ce98636102c9c5$export$2200bcb1a08f6f8d = {
    name: "or",
    category: "Logical",
    syntax: [
        "x or y",
        "or(x, y)"
    ],
    description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
    examples: [
        "true or false",
        "false or false",
        "0 or 4"
    ],
    seealso: [
        "not",
        "and",
        "xor"
    ]
};

});

parcelRegister("hgPwg", function(module, exports) {

$parcel$export(module.exports, "notDocs", function () { return $c92be4f8faf12289$export$dfd4aa05f81041ff; });
var $c92be4f8faf12289$export$dfd4aa05f81041ff = {
    name: "not",
    category: "Logical",
    syntax: [
        "not x",
        "not(x)"
    ],
    description: "Logical not. Flips the boolean value of given argument.",
    examples: [
        "not true",
        "not false",
        "not 2",
        "not 0"
    ],
    seealso: [
        "and",
        "or",
        "xor"
    ]
};

});

parcelRegister("dQIac", function(module, exports) {

$parcel$export(module.exports, "andDocs", function () { return $a15263a81c3cb444$export$20737fc9b0a3839c; });
var $a15263a81c3cb444$export$20737fc9b0a3839c = {
    name: "and",
    category: "Logical",
    syntax: [
        "x and y",
        "and(x, y)"
    ],
    description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
    examples: [
        "true and false",
        "true and true",
        "2 and 4"
    ],
    seealso: [
        "not",
        "or",
        "xor"
    ]
};

});

parcelRegister("kDSsf", function(module, exports) {

$parcel$export(module.exports, "intersectDocs", function () { return $f071b0b233e2248b$export$cf98256b70808117; });
var $f071b0b233e2248b$export$cf98256b70808117 = {
    name: "intersect",
    category: "Geometry",
    syntax: [
        "intersect(expr1, expr2, expr3, expr4)",
        "intersect(expr1, expr2, expr3)"
    ],
    description: "Computes the intersection point of lines and/or planes.",
    examples: [
        "intersect([0, 0], [10, 10], [10, 0], [0, 10])",
        "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"
    ],
    seealso: []
};

});

parcelRegister("kgNMh", function(module, exports) {

$parcel$export(module.exports, "distanceDocs", function () { return $ec1bea1ac800a53a$export$128b8878fdfb9e22; });
var $ec1bea1ac800a53a$export$128b8878fdfb9e22 = {
    name: "distance",
    category: "Geometry",
    syntax: [
        "distance([x1, y1], [x2, y2])",
        "distance([[x1, y1], [x2, y2]])"
    ],
    description: "Calculates the Euclidean distance between two points.",
    examples: [
        "distance([0,0], [4,4])",
        "distance([[0,0], [4,4]])"
    ],
    seealso: []
};

});

parcelRegister("42Q8b", function(module, exports) {

$parcel$export(module.exports, "helpDocs", function () { return $2f1fc97a4b643a31$export$e55ca8c24fbd3be8; });
var $2f1fc97a4b643a31$export$e55ca8c24fbd3be8 = {
    name: "help",
    category: "Expression",
    syntax: [
        "help(object)",
        "help(string)"
    ],
    description: "Display documentation on a function or data type.",
    examples: [
        "help(sqrt)",
        'help("complex")'
    ],
    seealso: []
};

});

parcelRegister("fmxE6", function(module, exports) {

$parcel$export(module.exports, "evaluateDocs", function () { return $b2f302758ccc8aea$export$f32c54c70ddd9931; });
var $b2f302758ccc8aea$export$f32c54c70ddd9931 = {
    name: "evaluate",
    category: "Expression",
    syntax: [
        "evaluate(expression)",
        "evaluate([expr1, expr2, expr3, ...])"
    ],
    description: "Evaluate an expression or an array with expressions.",
    examples: [
        'evaluate("2 + 3")',
        'evaluate("sqrt(" + 4 + ")")'
    ],
    seealso: []
};

});

parcelRegister("bfugF", function(module, exports) {

$parcel$export(module.exports, "imDocs", function () { return $83089300953e44bb$export$3476e22b3f658c7c; });
var $83089300953e44bb$export$3476e22b3f658c7c = {
    name: "im",
    category: "Complex",
    syntax: [
        "im(x)"
    ],
    description: "Get the imaginary part of a complex number.",
    examples: [
        "im(2 + 3i)",
        "re(2 + 3i)",
        "im(-5.2i)",
        "im(2.4)"
    ],
    seealso: [
        "re",
        "conj",
        "abs",
        "arg"
    ]
};

});

parcelRegister("5IPdC", function(module, exports) {

$parcel$export(module.exports, "reDocs", function () { return $42a8cac44b6dc58c$export$f13699bc77b8ea67; });
var $42a8cac44b6dc58c$export$f13699bc77b8ea67 = {
    name: "re",
    category: "Complex",
    syntax: [
        "re(x)"
    ],
    description: "Get the real part of a complex number.",
    examples: [
        "re(2 + 3i)",
        "im(2 + 3i)",
        "re(-5.2i)",
        "re(2.4)"
    ],
    seealso: [
        "im",
        "conj",
        "abs",
        "arg"
    ]
};

});

parcelRegister("a3gaB", function(module, exports) {

$parcel$export(module.exports, "conjDocs", function () { return $7516ba3b359d1773$export$e042ae5cfa3c3343; });
var $7516ba3b359d1773$export$e042ae5cfa3c3343 = {
    name: "conj",
    category: "Complex",
    syntax: [
        "conj(x)"
    ],
    description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
    examples: [
        "conj(2 + 3i)",
        "conj(2 - 3i)",
        "conj(-5.2i)"
    ],
    seealso: [
        "re",
        "im",
        "abs",
        "arg"
    ]
};

});

parcelRegister("4r4KQ", function(module, exports) {

$parcel$export(module.exports, "argDocs", function () { return $33ad5f3395b72ead$export$eace15c6c3c286dc; });
var $33ad5f3395b72ead$export$eace15c6c3c286dc = {
    name: "arg",
    category: "Complex",
    syntax: [
        "arg(x)"
    ],
    description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
    examples: [
        "arg(2 + 2i)",
        "atan2(3, 2)",
        "arg(2 + 3i)"
    ],
    seealso: [
        "re",
        "im",
        "conj",
        "abs"
    ]
};

});

parcelRegister("curJn", function(module, exports) {

$parcel$export(module.exports, "typedDocs", function () { return $917dcc2ac8a3c7d5$export$7adf399073101884; });
var $917dcc2ac8a3c7d5$export$7adf399073101884 = {
    name: "typed",
    category: "Core",
    syntax: [
        "typed(signatures)",
        "typed(name, signatures)"
    ],
    description: "Create a typed function.",
    examples: [
        'double = typed({ "number, number": f(x)=x+x })',
        "double(2)",
        'double("hello")'
    ],
    seealso: []
};

});

parcelRegister("iK993", function(module, exports) {

$parcel$export(module.exports, "importDocs", function () { return $da539ddefb93f63b$export$5989ac4b02cf8057; });
var $da539ddefb93f63b$export$5989ac4b02cf8057 = {
    name: "import",
    category: "Core",
    syntax: [
        "import(functions)",
        "import(functions, options)"
    ],
    description: "Import functions or constants from an object.",
    examples: [
        "import({myFn: f(x)=x^2, myConstant: 32 })",
        "myFn(2)",
        "myConstant"
    ],
    seealso: []
};

});

parcelRegister("jQDQ7", function(module, exports) {

$parcel$export(module.exports, "configDocs", function () { return $e731c6f25f8d88a8$export$ec99a334d8c9a14a; });
var $e731c6f25f8d88a8$export$ec99a334d8c9a14a = {
    name: "config",
    category: "Core",
    syntax: [
        "config()",
        "config(options)"
    ],
    description: "Get configuration or change configuration.",
    examples: [
        "config()",
        "1/3 + 1/4",
        'config({number: "Fraction"})',
        "1/3 + 1/4"
    ],
    seealso: []
};

});

parcelRegister("keq0M", function(module, exports) {

$parcel$export(module.exports, "stirlingS2Docs", function () { return $eba94acf1dd10e39$export$46c34bdf03072170; });
var $eba94acf1dd10e39$export$46c34bdf03072170 = {
    name: "stirlingS2",
    category: "Combinatorics",
    syntax: [
        "stirlingS2(n, k)"
    ],
    description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
    examples: [
        "stirlingS2(5, 3)"
    ],
    seealso: [
        "bellNumbers"
    ]
};

});

parcelRegister("hYeOu", function(module, exports) {

$parcel$export(module.exports, "compositionDocs", function () { return $d15387e598ba0f4c$export$7898728062a0cb7c; });
var $d15387e598ba0f4c$export$7898728062a0cb7c = {
    name: "composition",
    category: "Combinatorics",
    syntax: [
        "composition(n, k)"
    ],
    description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
    examples: [
        "composition(5, 3)"
    ],
    seealso: [
        "combinations"
    ]
};

});

parcelRegister("WEWrN", function(module, exports) {

$parcel$export(module.exports, "catalanDocs", function () { return $0b052d102b595d55$export$b34ea8a080f60e3b; });
var $0b052d102b595d55$export$b34ea8a080f60e3b = {
    name: "catalan",
    category: "Combinatorics",
    syntax: [
        "catalan(n)"
    ],
    description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
    examples: [
        "catalan(3)",
        "catalan(8)"
    ],
    seealso: [
        "bellNumbers"
    ]
};

});

parcelRegister("luqPQ", function(module, exports) {

$parcel$export(module.exports, "bellNumbersDocs", function () { return $fa51373cdcf4e255$export$f6a5bb92e66e375e; });
var $fa51373cdcf4e255$export$f6a5bb92e66e375e = {
    name: "bellNumbers",
    category: "Combinatorics",
    syntax: [
        "bellNumbers(n)"
    ],
    description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
    examples: [
        "bellNumbers(3)",
        "bellNumbers(8)"
    ],
    seealso: [
        "stirlingS2"
    ]
};

});

parcelRegister("bq8vD", function(module, exports) {

$parcel$export(module.exports, "rightLogShiftDocs", function () { return $8508b92a512e471e$export$613695fe01bcb038; });
var $8508b92a512e471e$export$613695fe01bcb038 = {
    name: "rightLogShift",
    category: "Bitwise",
    syntax: [
        "x >>> y",
        "rightLogShift(x, y)"
    ],
    description: "Bitwise right logical shift of a value x by y number of bits.",
    examples: [
        "8 >>> 1",
        "4 << 1",
        "-12 >>> 2"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift"
    ]
};

});

parcelRegister("dDfGA", function(module, exports) {

$parcel$export(module.exports, "rightArithShiftDocs", function () { return $9ecb15c54c560bde$export$180767993e37a793; });
var $9ecb15c54c560bde$export$180767993e37a793 = {
    name: "rightArithShift",
    category: "Bitwise",
    syntax: [
        "x >> y",
        "rightArithShift(x, y)"
    ],
    description: "Bitwise right arithmetic shift of a value x by y number of bits.",
    examples: [
        "8 >> 1",
        "4 << 1",
        "-12 >> 2"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightLogShift"
    ]
};

});

parcelRegister("86Mtj", function(module, exports) {

$parcel$export(module.exports, "leftShiftDocs", function () { return $5e747bbee81c20d3$export$fb75ebd54811e095; });
var $5e747bbee81c20d3$export$fb75ebd54811e095 = {
    name: "leftShift",
    category: "Bitwise",
    syntax: [
        "x << y",
        "leftShift(x, y)"
    ],
    description: "Bitwise left logical shift of a value x by y number of bits.",
    examples: [
        "4 << 1",
        "8 >> 1"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("86I9x", function(module, exports) {

$parcel$export(module.exports, "bitXorDocs", function () { return $5e71221c2d189151$export$c5717818ea6d1c80; });
var $5e71221c2d189151$export$c5717818ea6d1c80 = {
    name: "bitXor",
    category: "Bitwise",
    syntax: [
        "bitXor(x, y)"
    ],
    description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
    examples: [
        "bitOr(1, 2)",
        "bitXor([2, 3, 4], 4)"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("lhSzj", function(module, exports) {

$parcel$export(module.exports, "bitOrDocs", function () { return $f7f583abe05d1617$export$dc934370739527a8; });
var $f7f583abe05d1617$export$dc934370739527a8 = {
    name: "bitOr",
    category: "Bitwise",
    syntax: [
        "x | y",
        "bitOr(x, y)"
    ],
    description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
    examples: [
        "5 | 3",
        "bitOr([1, 2, 3], 4)"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("1R67K", function(module, exports) {

$parcel$export(module.exports, "bitNotDocs", function () { return $159f7dc71b95b621$export$3d49fbbfcb05eb36; });
var $159f7dc71b95b621$export$3d49fbbfcb05eb36 = {
    name: "bitNot",
    category: "Bitwise",
    syntax: [
        "~x",
        "bitNot(x)"
    ],
    description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
    examples: [
        "~1",
        "~2",
        "bitNot([2, -3, 4])"
    ],
    seealso: [
        "bitAnd",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("jKyeD", function(module, exports) {

$parcel$export(module.exports, "bitAndDocs", function () { return $e60cde908e01a8d6$export$9809e2502d5f7c7c; });
var $e60cde908e01a8d6$export$9809e2502d5f7c7c = {
    name: "bitAnd",
    category: "Bitwise",
    syntax: [
        "x & y",
        "bitAnd(x, y)"
    ],
    description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
    examples: [
        "5 & 3",
        "bitAnd(53, 131)",
        "[1, 12, 31] & 42"
    ],
    seealso: [
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};

});

parcelRegister("7Cg7E", function(module, exports) {

$parcel$export(module.exports, "xgcdDocs", function () { return $58b8969b191ccfd4$export$82911c1a1d0407b8; });
var $58b8969b191ccfd4$export$82911c1a1d0407b8 = {
    name: "xgcd",
    category: "Arithmetic",
    syntax: [
        "xgcd(a, b)"
    ],
    description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
    examples: [
        "xgcd(8, 12)",
        "gcd(8, 12)",
        "xgcd(36163, 21199)"
    ],
    seealso: [
        "gcd",
        "lcm"
    ]
};

});

parcelRegister("bF4YN", function(module, exports) {

$parcel$export(module.exports, "unaryPlusDocs", function () { return $87d762e3231e598b$export$e50639526da1c8e2; });
var $87d762e3231e598b$export$e50639526da1c8e2 = {
    name: "unaryPlus",
    category: "Operators",
    syntax: [
        "+x",
        "unaryPlus(x)"
    ],
    description: "Converts booleans and strings to numbers.",
    examples: [
        "+true",
        '+"2"'
    ],
    seealso: [
        "add",
        "subtract",
        "unaryMinus"
    ]
};

});

parcelRegister("8X8cU", function(module, exports) {

$parcel$export(module.exports, "unaryMinusDocs", function () { return $684a33326391c166$export$4d94f3f25dc2600b; });
var $684a33326391c166$export$4d94f3f25dc2600b = {
    name: "unaryMinus",
    category: "Operators",
    syntax: [
        "-x",
        "unaryMinus(x)"
    ],
    description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
    examples: [
        "-4.5",
        "-(-5.6)",
        '-"22"'
    ],
    seealso: [
        "add",
        "subtract",
        "unaryPlus"
    ]
};

});

parcelRegister("kQyUi", function(module, exports) {

$parcel$export(module.exports, "squareDocs", function () { return $f2d3bdc392cc3d42$export$8aa8fe580e40693e; });
var $f2d3bdc392cc3d42$export$8aa8fe580e40693e = {
    name: "square",
    category: "Arithmetic",
    syntax: [
        "square(x)"
    ],
    description: "Compute the square of a value. The square of x is x * x.",
    examples: [
        "square(3)",
        "sqrt(9)",
        "3^2",
        "3 * 3"
    ],
    seealso: [
        "multiply",
        "pow",
        "sqrt",
        "cube"
    ]
};

});

parcelRegister("5eRhZ", function(module, exports) {

$parcel$export(module.exports, "sqrtmDocs", function () { return $3d0798ab144f3658$export$f470c8ca9def7f14; });
var $3d0798ab144f3658$export$f470c8ca9def7f14 = {
    name: "sqrtm",
    category: "Arithmetic",
    syntax: [
        "sqrtm(x)"
    ],
    description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
    examples: [
        "sqrtm([[1, 2], [3, 4]])"
    ],
    seealso: [
        "sqrt",
        "abs",
        "square",
        "multiply"
    ]
};

});

parcelRegister("dTbeI", function(module, exports) {

$parcel$export(module.exports, "sqrtDocs", function () { return $a1c920bc9c323d79$export$4c6bee88dcda7f24; });
var $a1c920bc9c323d79$export$4c6bee88dcda7f24 = {
    name: "sqrt",
    category: "Arithmetic",
    syntax: [
        "sqrt(x)"
    ],
    description: "Compute the square root value. If x = y * y, then y is the square root of x.",
    examples: [
        "sqrt(25)",
        "5 * 5",
        "sqrt(-1)"
    ],
    seealso: [
        "square",
        "sqrtm",
        "multiply",
        "nthRoot",
        "nthRoots",
        "pow"
    ]
};

});

parcelRegister("2B6IT", function(module, exports) {

$parcel$export(module.exports, "signDocs", function () { return $1e44408b050199e0$export$4190acef139a44f2; });
var $1e44408b050199e0$export$4190acef139a44f2 = {
    name: "sign",
    category: "Arithmetic",
    syntax: [
        "sign(x)"
    ],
    description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
    examples: [
        "sign(3.5)",
        "sign(-4.2)",
        "sign(0)"
    ],
    seealso: [
        "abs"
    ]
};

});

parcelRegister("gfjms", function(module, exports) {

$parcel$export(module.exports, "roundDocs", function () { return $bd3d10c62c1072bc$export$aaef6018d3e651c3; });
var $bd3d10c62c1072bc$export$aaef6018d3e651c3 = {
    name: "round",
    category: "Arithmetic",
    syntax: [
        "round(x)",
        "round(x, n)"
    ],
    description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
    examples: [
        "round(3.2)",
        "round(3.8)",
        "round(-4.2)",
        "round(-4.8)",
        "round(pi, 3)",
        "round(123.45678, 2)"
    ],
    seealso: [
        "ceil",
        "floor",
        "fix"
    ]
};

});

parcelRegister("aSJCM", function(module, exports) {

$parcel$export(module.exports, "powDocs", function () { return $7ec2569a4f86548f$export$2d9619da64c2bdd4; });
var $7ec2569a4f86548f$export$2d9619da64c2bdd4 = {
    name: "pow",
    category: "Operators",
    syntax: [
        "x ^ y",
        "pow(x, y)"
    ],
    description: "Calculates the power of x to y, x^y.",
    examples: [
        "2^3",
        "2*2*2",
        "1 + e ^ (pi * i)"
    ],
    seealso: [
        "multiply",
        "nthRoot",
        "nthRoots",
        "sqrt"
    ]
};

});

parcelRegister("e5lSU", function(module, exports) {

$parcel$export(module.exports, "nthRootsDocs", function () { return $a412821fe4b77e04$export$3d5c8967f6152f8f; });
var $a412821fe4b77e04$export$3d5c8967f6152f8f = {
    name: "nthRoots",
    category: "Arithmetic",
    syntax: [
        "nthRoots(A)",
        "nthRoots(A, root)"
    ],
    description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
    examples: [
        "nthRoots(1)",
        "nthRoots(1, 3)"
    ],
    seealso: [
        "sqrt",
        "pow",
        "nthRoot"
    ]
};

});

parcelRegister("dVUub", function(module, exports) {

$parcel$export(module.exports, "nthRootDocs", function () { return $a24c6a2135cba91b$export$6eeb5046d44da601; });
var $a24c6a2135cba91b$export$6eeb5046d44da601 = {
    name: "nthRoot",
    category: "Arithmetic",
    syntax: [
        "nthRoot(a)",
        "nthRoot(a, root)"
    ],
    description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
    examples: [
        "4 ^ 3",
        "nthRoot(64, 3)",
        "nthRoot(9, 2)",
        "sqrt(9)"
    ],
    seealso: [
        "nthRoots",
        "pow",
        "sqrt"
    ]
};

});

parcelRegister("xaTEm", function(module, exports) {

$parcel$export(module.exports, "normDocs", function () { return $063b89042560214c$export$9745ccea7c23999; });
var $063b89042560214c$export$9745ccea7c23999 = {
    name: "norm",
    category: "Arithmetic",
    syntax: [
        "norm(x)",
        "norm(x, p)"
    ],
    description: "Calculate the norm of a number, vector or matrix.",
    examples: [
        "abs(-3.5)",
        "norm(-3.5)",
        "norm(3 - 4i)",
        "norm([1, 2, -3], Infinity)",
        "norm([1, 2, -3], -Infinity)",
        "norm([3, 4], 2)",
        "norm([[1, 2], [3, 4]], 1)",
        'norm([[1, 2], [3, 4]], "inf")',
        'norm([[1, 2], [3, 4]], "fro")'
    ]
};

});

parcelRegister("dfEOC", function(module, exports) {

$parcel$export(module.exports, "multiplyDocs", function () { return $9a5c562ff89e520d$export$1506e47b2a5ae6da; });
var $9a5c562ff89e520d$export$1506e47b2a5ae6da = {
    name: "multiply",
    category: "Operators",
    syntax: [
        "x * y",
        "multiply(x, y)"
    ],
    description: "multiply two values.",
    examples: [
        "a = 2.1 * 3.4",
        "a / 3.4",
        "2 * 3 + 4",
        "2 * (3 + 4)",
        "3 * 2.1 km"
    ],
    seealso: [
        "divide"
    ]
};

});

parcelRegister("dQ9Ex", function(module, exports) {

$parcel$export(module.exports, "modDocs", function () { return $a1379e8810ef6df1$export$f9c7d95d1ec52e50; });
var $a1379e8810ef6df1$export$f9c7d95d1ec52e50 = {
    name: "mod",
    category: "Operators",
    syntax: [
        "x % y",
        "x mod y",
        "mod(x, y)"
    ],
    description: "Calculates the modulus, the remainder of an integer division.",
    examples: [
        "7 % 3",
        "11 % 2",
        "10 mod 4",
        "isOdd(x) = x % 2",
        "isOdd(2)",
        "isOdd(3)"
    ],
    seealso: [
        "divide"
    ]
};

});

parcelRegister("dXLeD", function(module, exports) {

$parcel$export(module.exports, "log10Docs", function () { return $a2a56cedabcbc360$export$a4c310b6d4346035; });
var $a2a56cedabcbc360$export$a4c310b6d4346035 = {
    name: "log10",
    category: "Arithmetic",
    syntax: [
        "log10(x)"
    ],
    description: "Compute the 10-base logarithm of a value.",
    examples: [
        "log10(0.00001)",
        "log10(10000)",
        "10 ^ 4",
        "log(10000) / log(10)",
        "log(10000, 10)"
    ],
    seealso: [
        "exp",
        "log"
    ]
};

});

parcelRegister("7E7yr", function(module, exports) {

$parcel$export(module.exports, "log1pDocs", function () { return $5912210162007504$export$5739f5d11cd187ac; });
var $5912210162007504$export$5739f5d11cd187ac = {
    name: "log1p",
    category: "Arithmetic",
    syntax: [
        "log1p(x)",
        "log1p(x, base)"
    ],
    description: "Calculate the logarithm of a `value+1`",
    examples: [
        "log1p(2.5)",
        "exp(log1p(1.4))",
        "pow(10, 4)",
        "log1p(9999, 10)",
        "log1p(9999) / log(10)"
    ],
    seealso: [
        "exp",
        "log",
        "log2",
        "log10"
    ]
};

});

parcelRegister("je0FP", function(module, exports) {

$parcel$export(module.exports, "log2Docs", function () { return $dfefd8eaa00db8ac$export$fa36f06e6e8bfb36; });
var $dfefd8eaa00db8ac$export$fa36f06e6e8bfb36 = {
    name: "log2",
    category: "Arithmetic",
    syntax: [
        "log2(x)"
    ],
    description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
    examples: [
        "log2(0.03125)",
        "log2(16)",
        "log2(16) / log2(2)",
        "pow(2, 4)"
    ],
    seealso: [
        "exp",
        "log1p",
        "log",
        "log10"
    ]
};

});

parcelRegister("4Qi2H", function(module, exports) {

$parcel$export(module.exports, "logDocs", function () { return $386a03a459b71a84$export$10fa3fadd260900f; });
var $386a03a459b71a84$export$10fa3fadd260900f = {
    name: "log",
    category: "Arithmetic",
    syntax: [
        "log(x)",
        "log(x, base)"
    ],
    description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
    examples: [
        "log(3.5)",
        "a = log(2.4)",
        "exp(a)",
        "10 ^ 4",
        "log(10000, 10)",
        "log(10000) / log(10)",
        "b = log(1024, 2)",
        "2 ^ b"
    ],
    seealso: [
        "exp",
        "log1p",
        "log2",
        "log10"
    ]
};

});

parcelRegister("3GRfA", function(module, exports) {

$parcel$export(module.exports, "lcmDocs", function () { return $2afe99c5844c7f26$export$371d4953326569cb; });
var $2afe99c5844c7f26$export$371d4953326569cb = {
    name: "lcm",
    category: "Arithmetic",
    syntax: [
        "lcm(x, y)"
    ],
    description: "Compute the least common multiple.",
    examples: [
        "lcm(4, 6)",
        "lcm(6, 21)",
        "lcm(6, 21, 5)"
    ],
    seealso: [
        "gcd"
    ]
};

});

parcelRegister("cFdBQ", function(module, exports) {

$parcel$export(module.exports, "hypotDocs", function () { return $9383deec6c34880e$export$53821d38c3eeff69; });
var $9383deec6c34880e$export$53821d38c3eeff69 = {
    name: "hypot",
    category: "Arithmetic",
    syntax: [
        "hypot(a, b, c, ...)",
        "hypot([a, b, c, ...])"
    ],
    description: "Calculate the hypotenusa of a list with values. ",
    examples: [
        "hypot(3, 4)",
        "sqrt(3^2 + 4^2)",
        "hypot(-2)",
        "hypot([3, 4, 5])"
    ],
    seealso: [
        "abs",
        "norm"
    ]
};

});

parcelRegister("f0ViO", function(module, exports) {

$parcel$export(module.exports, "gcdDocs", function () { return $aee34e280620fb75$export$ccc9190f6201c21e; });
var $aee34e280620fb75$export$ccc9190f6201c21e = {
    name: "gcd",
    category: "Arithmetic",
    syntax: [
        "gcd(a, b)",
        "gcd(a, b, c, ...)"
    ],
    description: "Compute the greatest common divisor.",
    examples: [
        "gcd(8, 12)",
        "gcd(-4, 6)",
        "gcd(25, 15, -10)"
    ],
    seealso: [
        "lcm",
        "xgcd"
    ]
};

});

parcelRegister("2O9Xo", function(module, exports) {

$parcel$export(module.exports, "floorDocs", function () { return $20b7f9895252d89c$export$7eb1ac5a6cfbe8b6; });
var $20b7f9895252d89c$export$7eb1ac5a6cfbe8b6 = {
    name: "floor",
    category: "Arithmetic",
    syntax: [
        "floor(x)"
    ],
    description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
    examples: [
        "floor(3.2)",
        "floor(3.8)",
        "floor(-4.2)"
    ],
    seealso: [
        "ceil",
        "fix",
        "round"
    ]
};

});

parcelRegister("brWSV", function(module, exports) {

$parcel$export(module.exports, "fixDocs", function () { return $855fe4a9b0edc406$export$ec1a27fd93212099; });
var $855fe4a9b0edc406$export$ec1a27fd93212099 = {
    name: "fix",
    category: "Arithmetic",
    syntax: [
        "fix(x)"
    ],
    description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
    examples: [
        "fix(3.2)",
        "fix(3.8)",
        "fix(-4.2)",
        "fix(-4.8)"
    ],
    seealso: [
        "ceil",
        "floor",
        "round"
    ]
};

});

parcelRegister("9tXMo", function(module, exports) {

$parcel$export(module.exports, "expm1Docs", function () { return $6e75317c14d200e7$export$d6fb67f466ac866c; });
var $6e75317c14d200e7$export$d6fb67f466ac866c = {
    name: "expm1",
    category: "Arithmetic",
    syntax: [
        "expm1(x)"
    ],
    description: "Calculate the value of subtracting 1 from the exponential value.",
    examples: [
        "expm1(2)",
        "pow(e, 2) - 1",
        "log(expm1(2) + 1)"
    ],
    seealso: [
        "exp",
        "pow",
        "log"
    ]
};

});

parcelRegister("dmLq9", function(module, exports) {

$parcel$export(module.exports, "expmDocs", function () { return $9bb21d3153aca1ef$export$df3b4f2159ca23f5; });
var $9bb21d3153aca1ef$export$df3b4f2159ca23f5 = {
    name: "expm",
    category: "Arithmetic",
    syntax: [
        "exp(x)"
    ],
    description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
    examples: [
        "expm([[0,2],[0,0]])"
    ],
    seealso: [
        "exp"
    ]
};

});

parcelRegister("bO5Bt", function(module, exports) {

$parcel$export(module.exports, "eigsDocs", function () { return $8988b5eb5444237a$export$fb74125542bfdbb; });
var $8988b5eb5444237a$export$fb74125542bfdbb = {
    name: "eigs",
    category: "Matrix",
    syntax: [
        "eigs(x)"
    ],
    description: "Calculate the eigenvalues and eigenvectors of a real symmetric matrix",
    examples: [
        "eigs([[5, 2.3], [2.3, 1]])"
    ],
    seealso: [
        "inv"
    ]
};

});

parcelRegister("92Q3A", function(module, exports) {

$parcel$export(module.exports, "expDocs", function () { return $695cae6455c5a468$export$e855e42434736fab; });
var $695cae6455c5a468$export$e855e42434736fab = {
    name: "exp",
    category: "Arithmetic",
    syntax: [
        "exp(x)"
    ],
    description: "Calculate the exponent of a value.",
    examples: [
        "exp(1.3)",
        "e ^ 1.3",
        "log(exp(1.3))",
        "x = 2.4",
        "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"
    ],
    seealso: [
        "expm",
        "expm1",
        "pow",
        "log"
    ]
};

});

parcelRegister("iz5ka", function(module, exports) {

$parcel$export(module.exports, "dotMultiplyDocs", function () { return $d83fa02cd844399d$export$4e72f4c646ece24a; });
var $d83fa02cd844399d$export$4e72f4c646ece24a = {
    name: "dotMultiply",
    category: "Operators",
    syntax: [
        "x .* y",
        "dotMultiply(x, y)"
    ],
    description: "Multiply two values element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "b = [2, 1, 1; 3, 2, 5]",
        "a .* b"
    ],
    seealso: [
        "multiply",
        "divide",
        "dotDivide"
    ]
};

});

parcelRegister("cfWRu", function(module, exports) {

$parcel$export(module.exports, "dotDivideDocs", function () { return $8ec48b789d5512b2$export$f1a6e1f6a311adf8; });
var $8ec48b789d5512b2$export$f1a6e1f6a311adf8 = {
    name: "dotDivide",
    category: "Operators",
    syntax: [
        "x ./ y",
        "dotDivide(x, y)"
    ],
    description: "Divide two values element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "b = [2, 1, 1; 3, 2, 5]",
        "a ./ b"
    ],
    seealso: [
        "multiply",
        "dotMultiply",
        "divide"
    ]
};

});

parcelRegister("eEWfh", function(module, exports) {

$parcel$export(module.exports, "divideDocs", function () { return $aac1fb742c61acc7$export$e4cc3c6ddad47fb; });
var $aac1fb742c61acc7$export$e4cc3c6ddad47fb = {
    name: "divide",
    category: "Operators",
    syntax: [
        "x / y",
        "divide(x, y)"
    ],
    description: "Divide two values.",
    examples: [
        "a = 2 / 3",
        "a * 3",
        "4.5 / 2",
        "3 + 4 / 2",
        "(3 + 4) / 2",
        "18 km / 4.5"
    ],
    seealso: [
        "multiply"
    ]
};

});

parcelRegister("16sR9", function(module, exports) {

$parcel$export(module.exports, "cubeDocs", function () { return $0cdcbc3e5da79179$export$ceabaa40b420fd2f; });
var $0cdcbc3e5da79179$export$ceabaa40b420fd2f = {
    name: "cube",
    category: "Arithmetic",
    syntax: [
        "cube(x)"
    ],
    description: "Compute the cube of a value. The cube of x is x * x * x.",
    examples: [
        "cube(2)",
        "2^3",
        "2 * 2 * 2"
    ],
    seealso: [
        "multiply",
        "square",
        "pow"
    ]
};

});

parcelRegister("5TcZU", function(module, exports) {

$parcel$export(module.exports, "ceilDocs", function () { return $449c2bd8d01138f7$export$bf625dbce78edf39; });
var $449c2bd8d01138f7$export$bf625dbce78edf39 = {
    name: "ceil",
    category: "Arithmetic",
    syntax: [
        "ceil(x)"
    ],
    description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
    examples: [
        "ceil(3.2)",
        "ceil(3.8)",
        "ceil(-4.2)"
    ],
    seealso: [
        "floor",
        "fix",
        "round"
    ]
};

});

parcelRegister("5V9lM", function(module, exports) {

$parcel$export(module.exports, "cbrtDocs", function () { return $44f98768be6c2ef5$export$9330e90a8e7851e6; });
var $44f98768be6c2ef5$export$9330e90a8e7851e6 = {
    name: "cbrt",
    category: "Arithmetic",
    syntax: [
        "cbrt(x)",
        "cbrt(x, allRoots)"
    ],
    description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
    examples: [
        "cbrt(64)",
        "cube(4)",
        "cbrt(-8)",
        "cbrt(2 + 3i)",
        "cbrt(8i)",
        "cbrt(8i, true)",
        "cbrt(27 m^3)"
    ],
    seealso: [
        "square",
        "sqrt",
        "cube",
        "multiply"
    ]
};

});

parcelRegister("7d5FW", function(module, exports) {

$parcel$export(module.exports, "addDocs", function () { return $53fe26595ca3afa4$export$6fe0cea5d5e6ddba; });
var $53fe26595ca3afa4$export$6fe0cea5d5e6ddba = {
    name: "add",
    category: "Operators",
    syntax: [
        "x + y",
        "add(x, y)"
    ],
    description: "Add two values.",
    examples: [
        "a = 2.1 + 3.6",
        "a - 3.6",
        "3 + 2i",
        "3 cm + 2 inch",
        '"2.3" + "4"'
    ],
    seealso: [
        "subtract"
    ]
};

});

parcelRegister("82DRz", function(module, exports) {

$parcel$export(module.exports, "absDocs", function () { return $5dad6e9f011c8ecd$export$d21ec9cf3daa768b; });
var $5dad6e9f011c8ecd$export$d21ec9cf3daa768b = {
    name: "abs",
    category: "Arithmetic",
    syntax: [
        "abs(x)"
    ],
    description: "Compute the absolute value.",
    examples: [
        "abs(3.5)",
        "abs(-4.2)"
    ],
    seealso: [
        "sign"
    ]
};

});

parcelRegister("5DS2s", function(module, exports) {

$parcel$export(module.exports, "qrDocs", function () { return $41ba83375914aa43$export$717c61ebe37cce2a; });
var $41ba83375914aa43$export$717c61ebe37cce2a = {
    name: "qr",
    category: "Algebra",
    syntax: [
        "qr(A)"
    ],
    description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
    examples: [
        "qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"
    ],
    seealso: [
        "lup",
        "slu",
        "matrix"
    ]
};

});

parcelRegister("i1NI6", function(module, exports) {

$parcel$export(module.exports, "usolveDocs", function () { return $d1fee16fbe74bcd3$export$2e45391f5cc49d1d; });
var $d1fee16fbe74bcd3$export$2e45391f5cc49d1d = {
    name: "usolve",
    category: "Algebra",
    syntax: [
        "x=usolve(U, b)"
    ],
    description: "Solves the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
    examples: [
        "x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"
    ],
    seealso: [
        "lup",
        "lusolve",
        "lsolve",
        "matrix",
        "sparse"
    ]
};

});

parcelRegister("aabq4", function(module, exports) {

$parcel$export(module.exports, "sluDocs", function () { return $7663b23af0b5a3e7$export$a68dbefd846d8955; });
var $7663b23af0b5a3e7$export$a68dbefd846d8955 = {
    name: "slu",
    category: "Algebra",
    syntax: [
        "slu(A, order, threshold)"
    ],
    description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
    examples: [
        "slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"
    ],
    seealso: [
        "lusolve",
        "lsolve",
        "usolve",
        "matrix",
        "sparse",
        "lup",
        "qr"
    ]
};

});

parcelRegister("4gC9E", function(module, exports) {

$parcel$export(module.exports, "rationalizeDocs", function () { return $31b640c5fef954f7$export$1802f015e36a313; });
var $31b640c5fef954f7$export$1802f015e36a313 = {
    name: "rationalize",
    category: "Algebra",
    syntax: [
        "rationalize(expr)",
        "rationalize(expr, scope)",
        "rationalize(expr, scope, detailed)"
    ],
    description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
    examples: [
        'rationalize("2x/y - y/(x+1)")',
        'rationalize("2x/y - y/(x+1)", true)'
    ],
    seealso: [
        "simplify"
    ]
};

});

parcelRegister("5VEOp", function(module, exports) {

$parcel$export(module.exports, "simplifyDocs", function () { return $4511ef0e4b2de216$export$5a53589a8ff0d1cd; });
var $4511ef0e4b2de216$export$5a53589a8ff0d1cd = {
    name: "simplify",
    category: "Algebra",
    syntax: [
        "simplify(expr)",
        "simplify(expr, rules)"
    ],
    description: "Simplify an expression tree.",
    examples: [
        'simplify("3 + 2 / 4")',
        'simplify("2x + x")',
        'f = parse("x * (x + 2 + x)")',
        "simplified = simplify(f)",
        "simplified.evaluate({x: 2})"
    ],
    seealso: [
        "derivative",
        "parse",
        "evaluate"
    ]
};

});

parcelRegister("9wa74", function(module, exports) {

$parcel$export(module.exports, "lupDocs", function () { return $6edef278435508ab$export$aa45954995260db7; });
var $6edef278435508ab$export$aa45954995260db7 = {
    name: "lup",
    category: "Algebra",
    syntax: [
        "lup(m)"
    ],
    description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
    examples: [
        "lup([[2, 1], [1, 4]])",
        "lup(matrix([[2, 1], [1, 4]]))",
        "lup(sparse([[2, 1], [1, 4]]))"
    ],
    seealso: [
        "lusolve",
        "lsolve",
        "usolve",
        "matrix",
        "sparse",
        "slu",
        "qr"
    ]
};

});

parcelRegister("im20p", function(module, exports) {

$parcel$export(module.exports, "lsolveDocs", function () { return $d5cbd650aaeb2a54$export$4bef5c6fa8c1f081; });
var $d5cbd650aaeb2a54$export$4bef5c6fa8c1f081 = {
    name: "lsolve",
    category: "Algebra",
    syntax: [
        "x=lsolve(L, b)"
    ],
    description: "Solves the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lsolve(a, b)"
    ],
    seealso: [
        "lup",
        "lusolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};

});

parcelRegister("7Ucta", function(module, exports) {

$parcel$export(module.exports, "derivativeDocs", function () { return $5c176f8ae8b5f175$export$14d93412c4f1ed0d; });
var $5c176f8ae8b5f175$export$14d93412c4f1ed0d = {
    name: "derivative",
    category: "Algebra",
    syntax: [
        "derivative(expr, variable)",
        "derivative(expr, variable, {simplify: boolean})"
    ],
    description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
    examples: [
        'derivative("2x^3", "x")',
        'derivative("2x^3", "x", {simplify: false})',
        'derivative("2x^2 + 3x + 4", "x")',
        'derivative("sin(2x)", "x")',
        'f = parse("x^2 + x")',
        'x = parse("x")',
        "df = derivative(f, x)",
        "df.evaluate({x: 3})"
    ],
    seealso: [
        "simplify",
        "parse",
        "evaluate"
    ]
};

});

parcelRegister("dw7qY", function(module, exports) {

$parcel$export(module.exports, "versionDocs", function () { return $9d7407c8feaa6726$export$c94cc7868097f914; });
var $9d7407c8feaa6726$export$c94cc7868097f914 = {
    name: "version",
    category: "Constants",
    syntax: [
        "version"
    ],
    description: "A string with the version number of math.js",
    examples: [
        "version"
    ],
    seealso: []
};

});

parcelRegister("42i4o", function(module, exports) {

$parcel$export(module.exports, "trueDocs", function () { return $2f055d9a15fd6006$export$f6ccf6a3f013127d; });
var $2f055d9a15fd6006$export$f6ccf6a3f013127d = {
    name: "true",
    category: "Constants",
    syntax: [
        "true"
    ],
    description: "Boolean value true",
    examples: [
        "true"
    ],
    seealso: [
        "false"
    ]
};

});

parcelRegister("4tqLR", function(module, exports) {

$parcel$export(module.exports, "tauDocs", function () { return $341ea302c9c0988a$export$aee6f1e4bf7402c8; });
var $341ea302c9c0988a$export$aee6f1e4bf7402c8 = {
    name: "tau",
    category: "Constants",
    syntax: [
        "tau"
    ],
    description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
    examples: [
        "tau",
        "2 * pi"
    ],
    seealso: [
        "pi"
    ]
};

});

parcelRegister("kw1jC", function(module, exports) {

$parcel$export(module.exports, "SQRT2Docs", function () { return $eef7d10ba8e19a4d$export$ce0e8257aab3e4ae; });
var $eef7d10ba8e19a4d$export$ce0e8257aab3e4ae = {
    name: "SQRT2",
    category: "Constants",
    syntax: [
        "SQRT2"
    ],
    description: "Returns the square root of 2, approximately equal to 1.414",
    examples: [
        "SQRT2",
        "sqrt(2)"
    ],
    seealso: []
};

});

parcelRegister("1t2vA", function(module, exports) {

$parcel$export(module.exports, "SQRT12Docs", function () { return $111a72033372036f$export$6838d33506c2b5d0; });
var $111a72033372036f$export$6838d33506c2b5d0 = {
    name: "SQRT1_2",
    category: "Constants",
    syntax: [
        "SQRT1_2"
    ],
    description: "Returns the square root of 1/2, approximately equal to 0.707",
    examples: [
        "SQRT1_2",
        "sqrt(1/2)"
    ],
    seealso: []
};

});

parcelRegister("lh4m5", function(module, exports) {

$parcel$export(module.exports, "phiDocs", function () { return $f7ce9060650f2bc0$export$f4e037238b5533c1; });
var $f7ce9060650f2bc0$export$f4e037238b5533c1 = {
    name: "phi",
    category: "Constants",
    syntax: [
        "phi"
    ],
    description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
    examples: [
        "phi"
    ],
    seealso: []
};

});

parcelRegister("3fuir", function(module, exports) {

$parcel$export(module.exports, "piDocs", function () { return $25da460aa0e13777$export$acdd1b7b7d3e5e4e; });
var $25da460aa0e13777$export$acdd1b7b7d3e5e4e = {
    name: "pi",
    category: "Constants",
    syntax: [
        "pi"
    ],
    description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
    examples: [
        "pi",
        "sin(pi/2)"
    ],
    seealso: [
        "tau"
    ]
};

});

parcelRegister("1u6w6", function(module, exports) {

$parcel$export(module.exports, "nullDocs", function () { return $114da5e567ba51c8$export$a805f16f075f20cb; });
var $114da5e567ba51c8$export$a805f16f075f20cb = {
    name: "null",
    category: "Constants",
    syntax: [
        "null"
    ],
    description: "Value null",
    examples: [
        "null"
    ],
    seealso: [
        "true",
        "false"
    ]
};

});

parcelRegister("2XphH", function(module, exports) {

$parcel$export(module.exports, "NaNDocs", function () { return $2274b467975c9b41$export$eabb08eada5c068d; });
var $2274b467975c9b41$export$eabb08eada5c068d = {
    name: "NaN",
    category: "Constants",
    syntax: [
        "NaN"
    ],
    description: "Not a number",
    examples: [
        "NaN",
        "0 / 0"
    ],
    seealso: []
};

});

parcelRegister("h7Onf", function(module, exports) {

$parcel$export(module.exports, "LOG10EDocs", function () { return $c77a2a5609d34c49$export$c706f91356bdd28c; });
var $c77a2a5609d34c49$export$c706f91356bdd28c = {
    name: "LOG10E",
    category: "Constants",
    syntax: [
        "LOG10E"
    ],
    description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
    examples: [
        "LOG10E",
        "log(e, 10)"
    ],
    seealso: []
};

});

parcelRegister("gSenp", function(module, exports) {

$parcel$export(module.exports, "LOG2EDocs", function () { return $c48cd7635998644b$export$813e053668381c19; });
var $c48cd7635998644b$export$813e053668381c19 = {
    name: "LOG2E",
    category: "Constants",
    syntax: [
        "LOG2E"
    ],
    description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
    examples: [
        "LOG2E",
        "log(e, 2)"
    ],
    seealso: []
};

});

parcelRegister("MFanN", function(module, exports) {

$parcel$export(module.exports, "LN10Docs", function () { return $09246a9cb36a58f0$export$a1bd41a4b6a2fca0; });
var $09246a9cb36a58f0$export$a1bd41a4b6a2fca0 = {
    name: "LN10",
    category: "Constants",
    syntax: [
        "LN10"
    ],
    description: "Returns the natural logarithm of 10, approximately equal to 2.302",
    examples: [
        "LN10",
        "log(10)"
    ],
    seealso: []
};

});

parcelRegister("b0WPV", function(module, exports) {

$parcel$export(module.exports, "LN2Docs", function () { return $804d558545f5cba1$export$6e0577c024a56563; });
var $804d558545f5cba1$export$6e0577c024a56563 = {
    name: "LN2",
    category: "Constants",
    syntax: [
        "LN2"
    ],
    description: "Returns the natural logarithm of 2, approximately equal to 0.693",
    examples: [
        "LN2",
        "log(2)"
    ],
    seealso: []
};

});

parcelRegister("4QdEV", function(module, exports) {

$parcel$export(module.exports, "InfinityDocs", function () { return $38669d2ec1d48418$export$15a96a548a33c6f1; });
var $38669d2ec1d48418$export$15a96a548a33c6f1 = {
    name: "Infinity",
    category: "Constants",
    syntax: [
        "Infinity"
    ],
    description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
    examples: [
        "Infinity",
        "1 / 0"
    ],
    seealso: []
};

});

parcelRegister("darZC", function(module, exports) {

$parcel$export(module.exports, "iDocs", function () { return $9961ec50718c8564$export$e6ca220ee1b42382; });
var $9961ec50718c8564$export$e6ca220ee1b42382 = {
    name: "i",
    category: "Constants",
    syntax: [
        "i"
    ],
    description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
    examples: [
        "i",
        "i * i",
        "sqrt(-1)"
    ],
    seealso: []
};

});

parcelRegister("iF04z", function(module, exports) {

$parcel$export(module.exports, "falseDocs", function () { return $d95c1cc254471565$export$a73c839095ae9f5c; });
var $d95c1cc254471565$export$a73c839095ae9f5c = {
    name: "false",
    category: "Constants",
    syntax: [
        "false"
    ],
    description: "Boolean value false",
    examples: [
        "false"
    ],
    seealso: [
        "true"
    ]
};

});

parcelRegister("aWl5E", function(module, exports) {

$parcel$export(module.exports, "eDocs", function () { return $7f6fae3e7730bfc5$export$3fcb7a132c6e2ba6; });
var $7f6fae3e7730bfc5$export$3fcb7a132c6e2ba6 = {
    name: "e",
    category: "Constants",
    syntax: [
        "e"
    ],
    description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
    examples: [
        "e",
        "e ^ 2",
        "exp(2)",
        "log(e)"
    ],
    seealso: [
        "exp"
    ]
};

});

parcelRegister("2oxyG", function(module, exports) {

$parcel$export(module.exports, "unitDocs", function () { return $1be7daae6124ce00$export$478a7368ebd56459; });
var $1be7daae6124ce00$export$478a7368ebd56459 = {
    name: "unit",
    category: "Construction",
    syntax: [
        "value unit",
        "unit(value, unit)",
        "unit(string)"
    ],
    description: "Create a unit.",
    examples: [
        "5.5 mm",
        "3 inch",
        'unit(7.1, "kilogram")',
        'unit("23 deg")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "number",
        "string"
    ]
};

});

parcelRegister("8ODbc", function(module, exports) {

$parcel$export(module.exports, "stringDocs", function () { return $66b162829c133189$export$783e4a4a90f7bc1d; });
var $66b162829c133189$export$783e4a4a90f7bc1d = {
    name: "string",
    category: "Construction",
    syntax: [
        '"text"',
        "string(x)"
    ],
    description: "Create a string or convert a value to a string",
    examples: [
        '"Hello World!"',
        "string(4.2)",
        "string(3 + 2i)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "number",
        "unit"
    ]
};

});

parcelRegister("kOFAA", function(module, exports) {

$parcel$export(module.exports, "splitUnitDocs", function () { return $03e92c562e4625e5$export$f729a0241c48cb52; });
var $03e92c562e4625e5$export$f729a0241c48cb52 = {
    name: "splitUnit",
    category: "Construction",
    syntax: [
        "splitUnit(unit: Unit, parts: Unit[])"
    ],
    description: "Split a unit in an array of units whose sum is equal to the original unit.",
    examples: [
        'splitUnit(1 m, ["feet", "inch"])'
    ],
    seealso: [
        "unit",
        "createUnit"
    ]
};

});

parcelRegister("aikwv", function(module, exports) {

$parcel$export(module.exports, "sparseDocs", function () { return $77eb815648ec52b5$export$b569625c2404133; });
var $77eb815648ec52b5$export$b569625c2404133 = {
    name: "sparse",
    category: "Construction",
    syntax: [
        "sparse()",
        "sparse([a1, b1, ...; a1, b2, ...])",
        'sparse([a1, b1, ...; a1, b2, ...], "number")'
    ],
    description: "Create a sparse matrix.",
    examples: [
        "sparse()",
        "sparse([3, 4; 5, 6])",
        'sparse([3, 0; 5, 0], "number")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "number",
        "string",
        "unit",
        "matrix"
    ]
};

});

parcelRegister("60sIV", function(module, exports) {

$parcel$export(module.exports, "numberDocs", function () { return $45f9060ce142cf1a$export$3b011c0eed79d7e0; });
var $45f9060ce142cf1a$export$3b011c0eed79d7e0 = {
    name: "number",
    category: "Construction",
    syntax: [
        "x",
        "number(x)",
        "number(unit, valuelessUnit)"
    ],
    description: "Create a number or convert a string or boolean into a number.",
    examples: [
        "2",
        "2e3",
        "4.05",
        "number(2)",
        'number("7.2")',
        "number(true)",
        "number([true, false, true, true])",
        'number(unit("52cm"), "m")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};

});

parcelRegister("6MUF2", function(module, exports) {

$parcel$export(module.exports, "matrixDocs", function () { return $4f132d6d78510ce4$export$dc433018b5b5e90f; });
var $4f132d6d78510ce4$export$dc433018b5b5e90f = {
    name: "matrix",
    category: "Construction",
    syntax: [
        "[]",
        "[a1, b1, ...; a2, b2, ...]",
        "matrix()",
        'matrix("dense")',
        "matrix([...])"
    ],
    description: "Create a matrix.",
    examples: [
        "[]",
        "[1, 2, 3]",
        "[1, 2, 3; 4, 5, 6]",
        "matrix()",
        "matrix([3, 4])",
        'matrix([3, 4; 5, 6], "sparse")',
        'matrix([3, 4; 5, 6], "sparse", "number")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "number",
        "string",
        "unit",
        "sparse"
    ]
};

});

parcelRegister("1OTLi", function(module, exports) {

$parcel$export(module.exports, "indexDocs", function () { return $1535b7152e9d18ab$export$39876fcf61312bba; });
var $1535b7152e9d18ab$export$39876fcf61312bba = {
    name: "index",
    category: "Construction",
    syntax: [
        "[start]",
        "[start:end]",
        "[start:step:end]",
        "[start1, start 2, ...]",
        "[start1:end1, start2:end2, ...]",
        "[start1:step1:end1, start2:step2:end2, ...]"
    ],
    description: "Create an index to get or replace a subset of a matrix",
    examples: [
        "[]",
        "[1, 2, 3]",
        "A = [1, 2, 3; 4, 5, 6]",
        "A[1, :]",
        "A[1, 2] = 50",
        "A[0:2, 0:2] = ones(2, 2)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "matrix,",
        "number",
        "range",
        "string",
        "unit"
    ]
};

});

parcelRegister("lxVfp", function(module, exports) {

$parcel$export(module.exports, "fractionDocs", function () { return $040c468d3fa65c83$export$46678100e6b87439; });
var $040c468d3fa65c83$export$46678100e6b87439 = {
    name: "fraction",
    category: "Construction",
    syntax: [
        "fraction(num)",
        "fraction(num,den)"
    ],
    description: "Create a fraction from a number or from a numerator and denominator.",
    examples: [
        "fraction(0.125)",
        "fraction(1, 3) + fraction(2, 5)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};

});

parcelRegister("jcnRl", function(module, exports) {

$parcel$export(module.exports, "createUnitDocs", function () { return $dfa1a5437958f525$export$e56a121dfffbec82; });
var $dfa1a5437958f525$export$e56a121dfffbec82 = {
    name: "createUnit",
    category: "Construction",
    syntax: [
        "createUnit(definitions)",
        "createUnit(name, definition)"
    ],
    description: "Create a user-defined unit and register it with the Unit type.",
    examples: [
        'createUnit("foo")',
        'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})',
        'createUnit("mph", "1 mile/hour")'
    ],
    seealso: [
        "unit",
        "splitUnit"
    ]
};

});

parcelRegister("9RhG3", function(module, exports) {

$parcel$export(module.exports, "complexDocs", function () { return $72d6c6a976888b1f$export$a266a326dd0e84ff; });
var $72d6c6a976888b1f$export$a266a326dd0e84ff = {
    name: "complex",
    category: "Construction",
    syntax: [
        "complex()",
        "complex(re, im)",
        "complex(string)"
    ],
    description: "Create a complex number.",
    examples: [
        "complex()",
        "complex(2, 3)",
        'complex("7 - 2i")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "index",
        "matrix",
        "number",
        "string",
        "unit"
    ]
};

});

parcelRegister("9PKcq", function(module, exports) {

$parcel$export(module.exports, "booleanDocs", function () { return $728cb6bc01b3c923$export$dbe10b9a90fd671a; });
var $728cb6bc01b3c923$export$dbe10b9a90fd671a = {
    name: "boolean",
    category: "Construction",
    syntax: [
        "x",
        "boolean(x)"
    ],
    description: "Convert a string or number into a boolean.",
    examples: [
        "boolean(0)",
        "boolean(1)",
        "boolean(3)",
        'boolean("true")',
        'boolean("false")',
        "boolean([1, 0, 1, 1])"
    ],
    seealso: [
        "bignumber",
        "complex",
        "index",
        "matrix",
        "number",
        "string",
        "unit"
    ]
};

});

parcelRegister("kRF3p", function(module, exports) {

$parcel$export(module.exports, "dotPowDocs", function () { return $f3089a58a45fb89c$export$db82d026e80f1871; });
var $f3089a58a45fb89c$export$db82d026e80f1871 = {
    name: "dotPow",
    category: "Operators",
    syntax: [
        "x .^ y",
        "dotPow(x, y)"
    ],
    description: "Calculates the power of x to y element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a .^ 2"
    ],
    seealso: [
        "pow"
    ]
};

});

parcelRegister("gROZm", function(module, exports) {

$parcel$export(module.exports, "lusolveDocs", function () { return $c47925e227f6e652$export$b24588d98e782136; });
var $c47925e227f6e652$export$b24588d98e782136 = {
    name: "lusolve",
    category: "Algebra",
    syntax: [
        "x=lusolve(A, b)",
        "x=lusolve(lu, b)"
    ],
    description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lusolve(a, b)"
    ],
    seealso: [
        "lup",
        "slu",
        "lsolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};

});

parcelRegister("iMmUz", function(module, exports) {

$parcel$export(module.exports, "subtractDocs", function () { return $dabe7b67ce94013c$export$435374265ca1b923; });
var $dabe7b67ce94013c$export$435374265ca1b923 = {
    name: "subtract",
    category: "Operators",
    syntax: [
        "x - y",
        "subtract(x, y)"
    ],
    description: "subtract two values.",
    examples: [
        "a = 5.3 - 2",
        "a + 2",
        "2/3 - 1/6",
        "2 * 3 - 3",
        "2.1 km - 500m"
    ],
    seealso: [
        "add"
    ]
};

});

parcelRegister("6otEZ", function(module, exports) {

$parcel$export(module.exports, "varianceDocs", function () { return $4a7bfdd5a4cffa87$export$5a58a225f78b347f; });
var $4a7bfdd5a4cffa87$export$5a58a225f78b347f = {
    name: "variance",
    category: "Statistics",
    syntax: [
        "variance(a, b, c, ...)",
        "variance(A)",
        "variance(A, normalization)"
    ],
    description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    examples: [
        "variance(2, 4, 6)",
        "variance([2, 4, 6, 8])",
        'variance([2, 4, 6, 8], "uncorrected")',
        'variance([2, 4, 6, 8], "biased")',
        "variance([1, 2, 3; 4, 5, 6])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "prod",
        "std",
        "sum"
    ]
};

});

parcelRegister("TvXc2", function(module, exports) {

$parcel$export(module.exports, "sinDocs", function () { return $0a6dec838c35ff11$export$c7700d6ff32b1413; });
var $0a6dec838c35ff11$export$c7700d6ff32b1413 = {
    name: "sin",
    category: "Trigonometry",
    syntax: [
        "sin(x)"
    ],
    description: "Compute the sine of x in radians.",
    examples: [
        "sin(2)",
        "sin(pi / 4) ^ 2",
        "sin(90 deg)",
        "sin(30 deg)",
        "sin(0.2)^2 + cos(0.2)^2"
    ],
    seealso: [
        "asin",
        "cos",
        "tan"
    ]
};

});

parcelRegister("h5L5h", function(module, exports) {

$parcel$export(module.exports, "numericDocs", function () { return $c7176d3712f042e2$export$d275ce05039a5f7a; });
var $c7176d3712f042e2$export$d275ce05039a5f7a = {
    name: "numeric",
    category: "Utils",
    syntax: [
        "numeric(x)"
    ],
    description: "Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.",
    examples: [
        'numeric("4")',
        'numeric("4", "number")',
        'numeric("4", "BigNumber")',
        'numeric("4", "Fraction)',
        'numeric(4, "Fraction")',
        'numeric(fraction(2, 5), "number)'
    ],
    seealso: [
        "number",
        "fraction",
        "bignumber",
        "string",
        "format"
    ]
};

});

parcelRegister("ffGcF", function(module, exports) {

$parcel$export(module.exports, "columnDocs", function () { return $b1a8fe67ca99a7c4$export$a5760461eff76999; });
var $b1a8fe67ca99a7c4$export$a5760461eff76999 = {
    name: "column",
    category: "Matrix",
    syntax: [
        "column(x, index)"
    ],
    description: "Return a column from a matrix or array.",
    examples: [
        "A = [[1, 2], [3, 4]]",
        "column(A, 1)",
        "column(A, 2)"
    ],
    seealso: [
        "row"
    ]
};

});

parcelRegister("tbdpX", function(module, exports) {

$parcel$export(module.exports, "rowDocs", function () { return $057b68b21846a60b$export$74b9786bafaa0a25; });
var $057b68b21846a60b$export$74b9786bafaa0a25 = {
    name: "row",
    category: "Matrix",
    syntax: [
        "row(x, index)"
    ],
    description: "Return a row from a matrix or array.",
    examples: [
        "A = [[1, 2], [3, 4]]",
        "row(A, 1)",
        "row(A, 2)"
    ],
    seealso: [
        "column"
    ]
};

});



parcelRegister("9gllx", function(module, exports) {

$parcel$export(module.exports, "createHelpClass", function () { return $6be62aa614a71f41$export$704346eb22eef29; });

var $7E0JQ = parcelRequire("7E0JQ");

var $glBd7 = parcelRequire("glBd7");

var $7HWRb = parcelRequire("7HWRb");

var $jKx4O = parcelRequire("jKx4O");
var $6be62aa614a71f41$var$name = "Help";
var $6be62aa614a71f41$var$dependencies = [
    "parse"
];
var $6be62aa614a71f41$export$704346eb22eef29 = /* #__PURE__ */ (0, $jKx4O.factory)($6be62aa614a71f41$var$name, $6be62aa614a71f41$var$dependencies, function(_ref) {
    var parse = _ref.parse;
    /**
   * Documentation object
   * @param {Object} doc  Object containing properties:
   *                      {string} name
   *                      {string} category
   *                      {string} description
   *                      {string[]} syntax
   *                      {string[]} examples
   *                      {string[]} seealso
   * @constructor
   */ function Help(doc) {
        if (!(this instanceof Help)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!doc) throw new Error('Argument "doc" missing');
        this.doc = doc;
    }
    /**
   * Attach type information
   */ Help.prototype.type = "Help";
    Help.prototype.isHelp = true;
    /**
   * Generate a string representation of the Help object
   * @return {string} Returns a string
   * @private
   */ Help.prototype.toString = function() {
        var doc = this.doc || {};
        var desc = "\n";
        if (doc.name) desc += "Name: " + doc.name + "\n\n";
        if (doc.category) desc += "Category: " + doc.category + "\n\n";
        if (doc.description) desc += "Description:\n    " + doc.description + "\n\n";
        if (doc.syntax) desc += "Syntax:\n    " + doc.syntax.join("\n    ") + "\n\n";
        if (doc.examples) {
            desc += "Examples:\n";
            var scope = {};
            for(var i = 0; i < doc.examples.length; i++){
                var expr = doc.examples[i];
                desc += "    " + expr + "\n";
                var res = void 0;
                try {
                    // note: res can be undefined when `expr` is an empty string
                    res = parse(expr).compile().evaluate(scope);
                } catch (e) {
                    res = e;
                }
                if (res !== undefined && !(0, $7E0JQ.isHelp)(res)) desc += "        " + (0, $7HWRb.format)(res, {
                    precision: 14
                }) + "\n";
            }
            desc += "\n";
        }
        if (doc.seealso && doc.seealso.length) desc += "See also: " + doc.seealso.join(", ") + "\n";
        return desc;
    };
    /**
   * Export the help object to JSON
   */ Help.prototype.toJSON = function() {
        var obj = (0, $glBd7.clone)(this.doc);
        obj.mathjs = "Help";
        return obj;
    };
    /**
   * Instantiate a Help object from a JSON object
   * @param {Object} json
   * @returns {Help} Returns a new Help object
   */ Help.fromJSON = function(json) {
        var doc = {};
        for(var prop in json)if (prop !== "mathjs") // ignore mathjs field
        doc[prop] = json[prop];
        return new Help(doc);
    };
    /**
   * Returns a string representation of the Help object
   */ Help.prototype.valueOf = Help.prototype.toString;
    return Help;
}, {
    isClass: true
});

});

parcelRegister("jSahI", function(module, exports) {

$parcel$export(module.exports, "createIndexNode", function () { return $e77b09d10e5fbd74$export$883b7fdc0499e9f0; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $7HWRb = parcelRequire("7HWRb");

var $jKx4O = parcelRequire("jKx4O");

var $i3n6j = parcelRequire("i3n6j");
function $e77b09d10e5fbd74$var$_toConsumableArray(arr) {
    return $e77b09d10e5fbd74$var$_arrayWithoutHoles(arr) || $e77b09d10e5fbd74$var$_iterableToArray(arr) || $e77b09d10e5fbd74$var$_unsupportedIterableToArray(arr) || $e77b09d10e5fbd74$var$_nonIterableSpread();
}
function $e77b09d10e5fbd74$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e77b09d10e5fbd74$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e77b09d10e5fbd74$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e77b09d10e5fbd74$var$_arrayLikeToArray(o, minLen);
}
function $e77b09d10e5fbd74$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $e77b09d10e5fbd74$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e77b09d10e5fbd74$var$_arrayLikeToArray(arr);
}
function $e77b09d10e5fbd74$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $e77b09d10e5fbd74$var$name = "IndexNode";
var $e77b09d10e5fbd74$var$dependencies = [
    "Range",
    "Node",
    "size"
];
var $e77b09d10e5fbd74$export$883b7fdc0499e9f0 = /* #__PURE__ */ (0, $jKx4O.factory)($e77b09d10e5fbd74$var$name, $e77b09d10e5fbd74$var$dependencies, function(_ref) {
    var Range = _ref.Range, Node = _ref.Node, size = _ref.size;
    /**
   * @constructor IndexNode
   * @extends Node
   *
   * Describes a subset of a matrix or an object property.
   * Cannot be used on its own, needs to be used within an AccessorNode or
   * AssignmentNode.
   *
   * @param {Node[]} dimensions
   * @param {boolean} [dotNotation=false]  Optional property describing whether
   *                                       this index was written using dot
   *                                       notation like `a.b`, or using bracket
   *                                       notation like `a["b"]` (default).
   *                                       Used to stringify an IndexNode.
   */ function IndexNode(dimensions, dotNotation) {
        if (!(this instanceof IndexNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.dimensions = dimensions;
        this.dotNotation = dotNotation || false; // validate input
        if (!Array.isArray(dimensions) || !dimensions.every((0, $7E0JQ.isNode))) throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
        if (this.dotNotation && !this.isObjectProperty()) throw new Error("dotNotation only applicable for object properties");
         // TODO: deprecated since v3, remove some day
        var deprecated = function deprecated() {
            throw new Error("Property `IndexNode.object` is deprecated, use `IndexNode.fn` instead");
        };
        Object.defineProperty(this, "object", {
            get: deprecated,
            set: deprecated
        });
    }
    IndexNode.prototype = new Node();
    IndexNode.prototype.type = "IndexNode";
    IndexNode.prototype.isIndexNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ IndexNode.prototype._compile = function(math, argNames) {
        // TODO: implement support for bignumber (currently bignumbers are silently
        //       reduced to numbers when changing the value to zero-based)
        // TODO: Optimization: when the range values are ConstantNodes,
        //       we can beforehand resolve the zero-based value
        // optimization for a simple object property
        var evalDimensions = (0, $YkZ7e.map)(this.dimensions, function(range, i) {
            if ((0, $7E0JQ.isRangeNode)(range)) {
                if (range.needsEnd()) {
                    // create a range containing end (like '4:end')
                    var childArgNames = Object.create(argNames);
                    childArgNames.end = true;
                    var evalStart = range.start._compile(math, childArgNames);
                    var evalEnd = range.end._compile(math, childArgNames);
                    var evalStep = range.step ? range.step._compile(math, childArgNames) : function() {
                        return 1;
                    };
                    return function evalDimension(scope, args, context) {
                        var s = size(context).valueOf();
                        var childArgs = Object.create(args);
                        childArgs.end = s[i];
                        return createRange(evalStart(scope, childArgs, context), evalEnd(scope, childArgs, context), evalStep(scope, childArgs, context));
                    };
                } else {
                    // create range
                    var _evalStart = range.start._compile(math, argNames);
                    var _evalEnd = range.end._compile(math, argNames);
                    var _evalStep = range.step ? range.step._compile(math, argNames) : function() {
                        return 1;
                    };
                    return function evalDimension(scope, args, context) {
                        return createRange(_evalStart(scope, args, context), _evalEnd(scope, args, context), _evalStep(scope, args, context));
                    };
                }
            } else if ((0, $7E0JQ.isSymbolNode)(range) && range.name === "end") {
                // SymbolNode 'end'
                var _childArgNames = Object.create(argNames);
                _childArgNames.end = true;
                var evalRange = range._compile(math, _childArgNames);
                return function evalDimension(scope, args, context) {
                    var s = size(context).valueOf();
                    var childArgs = Object.create(args);
                    childArgs.end = s[i];
                    return evalRange(scope, childArgs, context);
                };
            } else {
                // ConstantNode
                var _evalRange = range._compile(math, argNames);
                return function evalDimension(scope, args, context) {
                    return _evalRange(scope, args, context);
                };
            }
        });
        var index = (0, $i3n6j.getSafeProperty)(math, "index");
        return function evalIndexNode(scope, args, context) {
            var dimensions = (0, $YkZ7e.map)(evalDimensions, function(evalDimension) {
                return evalDimension(scope, args, context);
            });
            return index.apply(void 0, $e77b09d10e5fbd74$var$_toConsumableArray(dimensions));
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ IndexNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.dimensions.length; i++)callback(this.dimensions[i], "dimensions[" + i + "]", this);
    };
    /**
   * Create a new IndexNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {IndexNode} Returns a transformed copy of the node
   */ IndexNode.prototype.map = function(callback) {
        var dimensions = [];
        for(var i = 0; i < this.dimensions.length; i++)dimensions[i] = this._ifNode(callback(this.dimensions[i], "dimensions[" + i + "]", this));
        return new IndexNode(dimensions, this.dotNotation);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {IndexNode}
   */ IndexNode.prototype.clone = function() {
        return new IndexNode(this.dimensions.slice(0), this.dotNotation);
    };
    /**
   * Test whether this IndexNode contains a single property name
   * @return {boolean}
   */ IndexNode.prototype.isObjectProperty = function() {
        return this.dimensions.length === 1 && (0, $7E0JQ.isConstantNode)(this.dimensions[0]) && typeof this.dimensions[0].value === "string";
    };
    /**
   * Returns the property name if IndexNode contains a property.
   * If not, returns null.
   * @return {string | null}
   */ IndexNode.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this.dimensions[0].value : null;
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype._toString = function(options) {
        // format the parameters like "[1, 0:5]"
        return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ IndexNode.prototype.toJSON = function() {
        return {
            mathjs: "IndexNode",
            dimensions: this.dimensions,
            dotNotation: this.dotNotation
        };
    };
    /**
   * Instantiate an IndexNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
   *                       where mathjs is optional
   * @returns {IndexNode}
   */ IndexNode.fromJSON = function(json) {
        return new IndexNode(json.dimensions, json.dotNotation);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype.toHTML = function(options) {
        // format the parameters like "[1, 0:5]"
        var dimensions = [];
        for(var i = 0; i < this.dimensions.length; i++)dimensions[i] = this.dimensions[i].toHTML();
        if (this.dotNotation) return '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + (0, $7HWRb.escape)(this.getObjectProperty()) + "</span>";
        else return '<span class="math-parenthesis math-square-parenthesis">[</span>' + dimensions.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype._toTex = function(options) {
        var dimensions = this.dimensions.map(function(range) {
            return range.toTex(options);
        });
        return this.dotNotation ? "." + this.getObjectProperty() + "" : "_{" + dimensions.join(",") + "}";
    }; // helper function to create a Range from start, step and end
    function createRange(start, end, step) {
        return new Range((0, $7E0JQ.isBigNumber)(start) ? start.toNumber() : start, (0, $7E0JQ.isBigNumber)(end) ? end.toNumber() : end, (0, $7E0JQ.isBigNumber)(step) ? step.toNumber() : step);
    }
    return IndexNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("4BXEH", function(module, exports) {

$parcel$export(module.exports, "createIndexTransform", function () { return $35b8e4704f14a3f5$export$f20e87a60dbfc89e; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $35b8e4704f14a3f5$var$name = "index";
var $35b8e4704f14a3f5$var$dependencies = [
    "Index"
];
var $35b8e4704f14a3f5$export$f20e87a60dbfc89e = /* #__PURE__ */ (0, $jKx4O.factory)($35b8e4704f14a3f5$var$name, $35b8e4704f14a3f5$var$dependencies, function(_ref) {
    var Index = _ref.Index;
    /**
   * Attach a transform function to math.index
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ return function indexTransform() {
        var args = [];
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i]; // change from one-based to zero based, and convert BigNumber to number
            if ((0, $7E0JQ.isRange)(arg)) {
                arg.start--;
                arg.end -= arg.step > 0 ? 0 : 2;
            } else if (arg && arg.isSet === true) arg = arg.map(function(v) {
                return v - 1;
            });
            else if ((0, $7E0JQ.isArray)(arg) || (0, $7E0JQ.isMatrix)(arg)) arg = arg.map(function(v) {
                return v - 1;
            });
            else if ((0, $7E0JQ.isNumber)(arg)) arg--;
            else if ((0, $7E0JQ.isBigNumber)(arg)) arg = arg.toNumber() - 1;
            else if (typeof arg === "string") ;
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
            args[i] = arg;
        }
        var res = new Index();
        Index.apply(res, args);
        return res;
    };
}, {
    isTransformFunction: true
});

});

parcelRegister("iGg9x", function(module, exports) {

$parcel$export(module.exports, "createMapTransform", function () { return $d998addef28c113b$export$5ae33143d676d4d4; });

var $7E0JQ = parcelRequire("7E0JQ");

var $lMDm0 = parcelRequire("lMDm0");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");

var $41M2q = parcelRequire("41M2q");
var $d998addef28c113b$var$name = "map";
var $d998addef28c113b$var$dependencies = [
    "typed"
];
var $d998addef28c113b$export$5ae33143d676d4d4 = /* #__PURE__ */ (0, $jKx4O.factory)($d998addef28c113b$var$name, $d998addef28c113b$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Attach a transform function to math.map
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ function mapTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $7E0JQ.isSymbolNode)(args[1]) || (0, $7E0JQ.isFunctionAssignmentNode)(args[1])) // a function pointer, like filter([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like filter([3, -2, 5], x > 0)
            callback = (0, $41M2q.compileInlineExpression)(args[1], math, scope);
        }
        return map(x, callback);
    }
    mapTransform.rawArgs = true; // one-based version of map function
    var map = typed("map", {
        "Array, function": function ArrayFunction(x, callback) {
            return $d998addef28c113b$var$_map(x, callback, x);
        },
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.create($d998addef28c113b$var$_map(x.valueOf(), callback, x));
        }
    });
    return mapTransform;
}, {
    isTransformFunction: true
});
/**
 * Map for a multi dimensional array. One-based indexes
 * @param {Array} array
 * @param {function} callback
 * @param {Array} orig
 * @return {Array}
 * @private
 */ function $d998addef28c113b$var$_map(array, callback, orig) {
    // figure out what number of arguments the callback function expects
    var argsCount = (0, $lMDm0.maxArgumentCount)(callback);
    function recurse(value, index) {
        if (Array.isArray(value)) return (0, $YkZ7e.map)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i + 1)); // one based index, hence i + 1
        });
        else {
            // invoke the (typed) callback function with the right number of arguments
            if (argsCount === 1) return callback(value);
            else if (argsCount === 2) return callback(value, index);
            else // 3 or -1
            return callback(value, index, orig);
        }
    }
    return recurse(array, []);
}

});

parcelRegister("2ElSv", function(module, exports) {

$parcel$export(module.exports, "createMaxTransform", function () { return $1ee049b9a63115f0$export$cb806a795cec8077; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $aVkFN = parcelRequire("aVkFN");

var $lVGks = parcelRequire("lVGks");
var $1ee049b9a63115f0$var$name = "max";
var $1ee049b9a63115f0$var$dependencies = [
    "typed",
    "larger"
];
var $1ee049b9a63115f0$export$cb806a795cec8077 = /* #__PURE__ */ (0, $jKx4O.factory)($1ee049b9a63115f0$var$name, $1ee049b9a63115f0$var$dependencies, function(_ref) {
    var typed = _ref.typed, larger = _ref.larger;
    var max = (0, $lVGks.createMax)({
        typed: typed,
        larger: larger
    });
    /**
   * Attach a transform function to math.max
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function max
   * from one-based to zero based
   */ return typed("max", {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $7E0JQ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $7E0JQ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $7E0JQ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return max.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("lVGks", function(module, exports) {

$parcel$export(module.exports, "createMax", function () { return $ff6fc18155411eb8$export$b18a1b0c26c000ee; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $dYvNV = parcelRequire("dYvNV");
var $ff6fc18155411eb8$var$name = "max";
var $ff6fc18155411eb8$var$dependencies = [
    "typed",
    "larger"
];
var $ff6fc18155411eb8$export$b18a1b0c26c000ee = /* #__PURE__ */ (0, $jKx4O.factory)($ff6fc18155411eb8$var$name, $ff6fc18155411eb8$var$dependencies, function(_ref) {
    var typed = _ref.typed, larger = _ref.larger;
    /**
   * Compute the maximum value of a matrix or a  list with values.
   * In case of a multi dimensional array, the maximum of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.max(a, b, c, ...)
   *     math.max(A)
   *     math.max(A, dim)
   *
   * Examples:
   *
   *     math.max(2, 1, 4, 3)                  // returns 4
   *     math.max([2, 1, 4, 3])                // returns 4
   *
   *     // maximum over a specified dimension (zero-based)
   *     math.max([[2, 5], [4, 3], [1, 7]], 0) // returns [4, 7]
   *     math.max([[2, 5], [4, 3]], [1, 7], 1) // returns [5, 4, 7]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, min, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The maximum value
   */ return typed($ff6fc18155411eb8$var$name, {
        // max([a, b, c, d, ...])
        "Array | Matrix": _max,
        // max([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $fbkGg.reduce)(array, dim.valueOf(), _largest);
        },
        // max(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $fbkGg.containsCollections)(args)) throw new TypeError("Scalar values expected in function max");
            return _max(args);
        }
    });
    /**
   * Return the largest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is largest, or y when y is largest
   * @private
   */ function _largest(x, y) {
        try {
            return larger(x, y) ? x : y;
        } catch (err) {
            throw (0, $dYvNV.improveErrorMessage)(err, "max", y);
        }
    }
    /**
   * Recursively calculate the maximum value in an n-dimensional array
   * @param {Array} array
   * @return {number} max
   * @private
   */ function _max(array) {
        var res;
        (0, $fbkGg.deepForEach)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") res = NaN;
                else if (res === undefined || larger(value, res)) res = value;
            } catch (err) {
                throw (0, $dYvNV.improveErrorMessage)(err, "max", value);
            }
        });
        if (res === undefined) throw new Error("Cannot calculate max of an empty array");
        return res;
    }
});

});
parcelRegister("dYvNV", function(module, exports) {

$parcel$export(module.exports, "improveErrorMessage", function () { return $a2c98ca17011422c$export$c8994973cec629ae; });

var $7E0JQ = parcelRequire("7E0JQ");
function $a2c98ca17011422c$export$c8994973cec629ae(err, fnName, value) {
    // TODO: add information with the index (also needs transform in expression parser)
    var details;
    if (String(err).indexOf("Unexpected type") !== -1) {
        details = arguments.length > 2 ? " (type: " + (0, $7E0JQ.typeOf)(value) + ", value: " + JSON.stringify(value) + ")" : " (type: " + err.data.actual + ")";
        return new TypeError("Cannot calculate " + fnName + ", unexpected type of argument" + details);
    }
    if (String(err).indexOf("complex numbers") !== -1) {
        details = arguments.length > 2 ? " (type: " + (0, $7E0JQ.typeOf)(value) + ", value: " + JSON.stringify(value) + ")" : "";
        return new TypeError("Cannot calculate " + fnName + ", no ordering relation is defined for complex numbers" + details);
    }
    return err;
}

});



parcelRegister("cJZSS", function(module, exports) {

$parcel$export(module.exports, "createMeanTransform", function () { return $9469b0e4cff44de4$export$caaba12fb8f94b67; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $aVkFN = parcelRequire("aVkFN");

var $ewnoJ = parcelRequire("ewnoJ");
var $9469b0e4cff44de4$var$name = "mean";
var $9469b0e4cff44de4$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $9469b0e4cff44de4$export$caaba12fb8f94b67 = /* #__PURE__ */ (0, $jKx4O.factory)($9469b0e4cff44de4$var$name, $9469b0e4cff44de4$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, divide = _ref.divide;
    var mean = (0, $ewnoJ.createMean)({
        typed: typed,
        add: add,
        divide: divide
    });
    /**
   * Attach a transform function to math.mean
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function mean
   * from one-based to zero based
   */ return typed("mean", {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $7E0JQ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $7E0JQ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $7E0JQ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return mean.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("ewnoJ", function(module, exports) {

$parcel$export(module.exports, "createMean", function () { return $a9263435524641f3$export$301ef7ca1de6782c; });

var $fbkGg = parcelRequire("fbkGg");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");

var $dYvNV = parcelRequire("dYvNV");
var $a9263435524641f3$var$name = "mean";
var $a9263435524641f3$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $a9263435524641f3$export$301ef7ca1de6782c = /* #__PURE__ */ (0, $jKx4O.factory)($a9263435524641f3$var$name, $a9263435524641f3$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, divide = _ref.divide;
    /**
   * Compute the mean value of matrix or a list with values.
   * In case of a multi dimensional array, the mean of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.mean(a, b, c, ...)
   *     math.mean(A)
   *     math.mean(A, dim)
   *
   * Examples:
   *
   *     math.mean(2, 1, 4, 3)                     // returns 2.5
   *     math.mean([1, 2.7, 3.2, 4])               // returns 2.725
   *
   *     math.mean([[2, 5], [6, 3], [1, 7]], 0)    // returns [3, 5]
   *     math.mean([[2, 5], [6, 3], [1, 7]], 1)    // returns [3.5, 4.5, 4]
   *
   * See also:
   *
   *     median, min, max, sum, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The mean of all values
   */ return typed($a9263435524641f3$var$name, {
        // mean([a, b, c, d, ...])
        "Array | Matrix": _mean,
        // mean([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nmeanDim,
        // mean(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $fbkGg.containsCollections)(args)) throw new TypeError("Scalar values expected in function mean");
            return _mean(args);
        }
    });
    /**
   * Calculate the mean value in an n-dimensional array, returning a
   * n-1 dimensional array
   * @param {Array} array
   * @param {number} dim
   * @return {number} mean
   * @private
   */ function _nmeanDim(array, dim) {
        try {
            var sum = (0, $fbkGg.reduce)(array, dim, add);
            var s = Array.isArray(array) ? (0, $YkZ7e.arraySize)(array) : array.size();
            return divide(sum, s[dim]);
        } catch (err) {
            throw (0, $dYvNV.improveErrorMessage)(err, "mean");
        }
    }
    /**
   * Recursively calculate the mean value in an n-dimensional array
   * @param {Array} array
   * @return {number} mean
   * @private
   */ function _mean(array) {
        var sum;
        var num = 0;
        (0, $fbkGg.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $dYvNV.improveErrorMessage)(err, "mean", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate the mean of an empty array");
        return divide(sum, num);
    }
});

});


parcelRegister("8Y3TH", function(module, exports) {

$parcel$export(module.exports, "createMinTransform", function () { return $6876f340aa0bf179$export$e6239917a808c35d; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $aVkFN = parcelRequire("aVkFN");

var $boksI = parcelRequire("boksI");
var $6876f340aa0bf179$var$name = "min";
var $6876f340aa0bf179$var$dependencies = [
    "typed",
    "smaller"
];
var $6876f340aa0bf179$export$e6239917a808c35d = /* #__PURE__ */ (0, $jKx4O.factory)($6876f340aa0bf179$var$name, $6876f340aa0bf179$var$dependencies, function(_ref) {
    var typed = _ref.typed, smaller = _ref.smaller;
    var min = (0, $boksI.createMin)({
        typed: typed,
        smaller: smaller
    });
    /**
   * Attach a transform function to math.min
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function min
   * from one-based to zero based
   */ return typed("min", {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $7E0JQ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $7E0JQ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $7E0JQ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return min.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("boksI", function(module, exports) {

$parcel$export(module.exports, "createMin", function () { return $84b1cef1c2e9729e$export$b795f47e2b99170; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $dYvNV = parcelRequire("dYvNV");
var $84b1cef1c2e9729e$var$name = "min";
var $84b1cef1c2e9729e$var$dependencies = [
    "typed",
    "smaller"
];
var $84b1cef1c2e9729e$export$b795f47e2b99170 = /* #__PURE__ */ (0, $jKx4O.factory)($84b1cef1c2e9729e$var$name, $84b1cef1c2e9729e$var$dependencies, function(_ref) {
    var typed = _ref.typed, smaller = _ref.smaller;
    /**
   * Compute the minimum value of a matrix or a  list of values.
   * In case of a multi dimensional array, the minimum of the flattened array
   * will be calculated. When `dim` is provided, the minimum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.min(a, b, c, ...)
   *     math.min(A)
   *     math.min(A, dim)
   *
   * Examples:
   *
   *     math.min(2, 1, 4, 3)                  // returns 1
   *     math.min([2, 1, 4, 3])                // returns 1
   *
   *     // minimum over a specified dimension (zero-based)
   *     math.min([[2, 5], [4, 3], [1, 7]], 0) // returns [1, 3]
   *     math.min([[2, 5], [4, 3], [1, 7]], 1) // returns [2, 3, 1]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, max, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The minimum value
   */ return typed($84b1cef1c2e9729e$var$name, {
        // min([a, b, c, d, ...])
        "Array | Matrix": _min,
        // min([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $fbkGg.reduce)(array, dim.valueOf(), _smallest);
        },
        // min(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $fbkGg.containsCollections)(args)) throw new TypeError("Scalar values expected in function min");
            return _min(args);
        }
    });
    /**
   * Return the smallest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is smallest, or y when y is smallest
   * @private
   */ function _smallest(x, y) {
        try {
            return smaller(x, y) ? x : y;
        } catch (err) {
            throw (0, $dYvNV.improveErrorMessage)(err, "min", y);
        }
    }
    /**
   * Recursively calculate the minimum value in an n-dimensional array
   * @param {Array} array
   * @return {number} min
   * @private
   */ function _min(array) {
        var min;
        (0, $fbkGg.deepForEach)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") min = NaN;
                else if (min === undefined || smaller(value, min)) min = value;
            } catch (err) {
                throw (0, $dYvNV.improveErrorMessage)(err, "min", value);
            }
        });
        if (min === undefined) throw new Error("Cannot calculate min of an empty array");
        return min;
    }
});

});


parcelRegister("ecPwy", function(module, exports) {

$parcel$export(module.exports, "createNode", function () { return $a57a274efcafc3d6$export$270e7ba5936d3c48; });

var $7E0JQ = parcelRequire("7E0JQ");

var $6cmon = parcelRequire("6cmon");

var $glBd7 = parcelRequire("glBd7");

var $jKx4O = parcelRequire("jKx4O");

var $9okwi = parcelRequire("9okwi");
function $a57a274efcafc3d6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a57a274efcafc3d6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a57a274efcafc3d6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a57a274efcafc3d6$var$_typeof(obj);
}
var $a57a274efcafc3d6$var$name = "Node";
var $a57a274efcafc3d6$var$dependencies = [
    "mathWithTransform"
];
var $a57a274efcafc3d6$export$270e7ba5936d3c48 = /* #__PURE__ */ (0, $jKx4O.factory)($a57a274efcafc3d6$var$name, $a57a274efcafc3d6$var$dependencies, function(_ref) {
    var mathWithTransform = _ref.mathWithTransform;
    /**
   * Node
   */ function Node() {
        if (!(this instanceof Node)) throw new SyntaxError("Constructor must be called with the new operator");
    }
    /**
   * Evaluate the node
   * @param {Object} [scope]  Scope to read/write variables
   * @return {*}              Returns the result
   */ Node.prototype.evaluate = function(scope) {
        return this.compile().evaluate(scope);
    };
    /**
   * Evaluate the node
   * @param {Object} [scope]  Scope to read/write variables
   * @return {*}              Returns the result
   */ // TODO: Deprecated since v6.0.0. Clean up some day
    Node.prototype.eval = function(scope) {
        (0, $9okwi.warnOnce)("Method Node.eval is renamed to Node.evaluate. Please use the new method name.");
        return this.evaluate(scope);
    };
    Node.prototype.type = "Node";
    Node.prototype.isNode = true;
    Node.prototype.comment = "";
    /**
   * Compile the node into an optimized, evauatable JavaScript function
   * @return {{evaluate: function([Object])}} object
   *                Returns an object with a function 'evaluate',
   *                which can be invoked as expr.evaluate([scope: Object]),
   *                where scope is an optional object with
   *                variables.
   */ Node.prototype.compile = function() {
        var expr = this._compile(mathWithTransform, {});
        var args = {};
        var context = null;
        function evaluate(scope) {
            var s = scope || {};
            _validateScope(s);
            return expr(s, args, context);
        }
        return {
            evaluate: evaluate,
            // TODO: Deprecated since v6.0.0. Clean up some day
            eval: function deprecatedEval(scope) {
                (0, $9okwi.warnOnce)("Method eval is renamed to evaluate. Please use the new method.");
                return evaluate(scope);
            }
        };
    };
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ Node.prototype._compile = function(math, argNames) {
        throw new Error("Method _compile should be implemented by type " + this.type);
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ Node.prototype.forEach = function(callback) {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot run forEach on a Node interface");
    };
    /**
   * Create a new Node having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {OperatorNode} Returns a transformed copy of the node
   */ Node.prototype.map = function(callback) {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot run map on a Node interface");
    };
    /**
   * Validate whether an object is a Node, for use with map
   * @param {Node} node
   * @returns {Node} Returns the input if it's a node, else throws an Error
   * @protected
   */ Node.prototype._ifNode = function(node) {
        if (!(0, $7E0JQ.isNode)(node)) throw new TypeError("Callback function must return a Node");
        return node;
    };
    /**
   * Recursively traverse all nodes in a node tree. Executes given callback for
   * this node and each of its child nodes.
   * @param {function(node: Node, path: string, parent: Node)} callback
   *          A callback called for every node in the node tree.
   */ Node.prototype.traverse = function(callback) {
        // execute callback for itself
        callback(this, null, null); // eslint-disable-line standard/no-callback-literal
        // recursively traverse over all childs of a node
        function _traverse(node, callback) {
            node.forEach(function(child, path, parent) {
                callback(child, path, parent);
                _traverse(child, callback);
            });
        }
        _traverse(this, callback);
    };
    /**
   * Recursively transform a node tree via a transform function.
   *
   * For example, to replace all nodes of type SymbolNode having name 'x' with a
   * ConstantNode with value 2:
   *
   *     const res = Node.transform(function (node, path, parent) {
   *       if (node && node.isSymbolNode) && (node.name === 'x')) {
   *         return new ConstantNode(2)
   *       }
   *       else {
   *         return node
   *       }
   *     })
   *
   * @param {function(node: Node, path: string, parent: Node) : Node} callback
   *          A mapping function accepting a node, and returning
   *          a replacement for the node or the original node.
   *          Signature: callback(node: Node, index: string, parent: Node) : Node
   * @return {Node} Returns the original node or its replacement
   */ Node.prototype.transform = function(callback) {
        function _transform(child, path, parent) {
            var replacement = callback(child, path, parent);
            if (replacement !== child) // stop iterating when the node is replaced
            return replacement;
            return child.map(_transform);
        }
        return _transform(this, null, null);
    };
    /**
   * Find any node in the node tree matching given filter function. For example, to
   * find all nodes of type SymbolNode having name 'x':
   *
   *     const results = Node.filter(function (node) {
   *       return (node && node.isSymbolNode) && (node.name === 'x')
   *     })
   *
   * @param {function(node: Node, path: string, parent: Node) : Node} callback
   *            A test function returning true when a node matches, and false
   *            otherwise. Function signature:
   *            callback(node: Node, index: string, parent: Node) : boolean
   * @return {Node[]} nodes       An array with nodes matching given filter criteria
   */ Node.prototype.filter = function(callback) {
        var nodes = [];
        this.traverse(function(node, path, parent) {
            if (callback(node, path, parent)) nodes.push(node);
        });
        return nodes;
    }; // TODO: deprecated since version 1.1.0, remove this some day
    Node.prototype.find = function() {
        throw new Error("Function Node.find is deprecated. Use Node.filter instead.");
    }; // TODO: deprecated since version 1.1.0, remove this some day
    Node.prototype.match = function() {
        throw new Error("Function Node.match is deprecated. See functions Node.filter, Node.transform, Node.traverse.");
    };
    /**
   * Create a shallow clone of this node
   * @return {Node}
   */ Node.prototype.clone = function() {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot clone a Node interface");
    };
    /**
   * Create a deep clone of this node
   * @return {Node}
   */ Node.prototype.cloneDeep = function() {
        return this.map(function(node) {
            return node.cloneDeep();
        });
    };
    /**
   * Deep compare this node with another node.
   * @param {Node} other
   * @return {boolean} Returns true when both nodes are of the same type and
   *                   contain the same values (as do their childs)
   */ Node.prototype.equals = function(other) {
        return other ? (0, $glBd7.deepStrictEqual)(this, other) : false;
    };
    /**
   * Get string representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)"or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toString = function(options) {
        var customString;
        if (options && $a57a274efcafc3d6$var$_typeof(options) === "object") switch($a57a274efcafc3d6$var$_typeof(options.handler)){
            case "object":
            case "undefined":
                break;
            case "function":
                customString = options.handler(this, options);
                break;
            default:
                throw new TypeError("Object or function expected as callback");
        }
        if (typeof customString !== "undefined") return customString;
        return this._toString(options);
    };
    /**
   * Get a JSON representation of the node
   * Both .toJSON() and the static .fromJSON(json) should be implemented by all
   * implementations of Node
   * @returns {Object}
   */ Node.prototype.toJSON = function() {
        throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
    };
    /**
   * Get HTML representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)" or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toHTML = function(options) {
        var customString;
        if (options && $a57a274efcafc3d6$var$_typeof(options) === "object") switch($a57a274efcafc3d6$var$_typeof(options.handler)){
            case "object":
            case "undefined":
                break;
            case "function":
                customString = options.handler(this, options);
                break;
            default:
                throw new TypeError("Object or function expected as callback");
        }
        if (typeof customString !== "undefined") return customString;
        return this.toHTML(options);
    };
    /**
   * Internal function to generate the string output.
   * This has to be implemented by every Node
   *
   * @throws {Error}
   */ Node.prototype._toString = function() {
        // must be implemented by each of the Node implementations
        throw new Error("_toString not implemented for " + this.type);
    };
    /**
   * Get LaTeX representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)"or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toTex = function(options) {
        var customTex;
        if (options && $a57a274efcafc3d6$var$_typeof(options) === "object") switch($a57a274efcafc3d6$var$_typeof(options.handler)){
            case "object":
            case "undefined":
                break;
            case "function":
                customTex = options.handler(this, options);
                break;
            default:
                throw new TypeError("Object or function expected as callback");
        }
        if (typeof customTex !== "undefined") return customTex;
        return this._toTex(options);
    };
    /**
   * Internal function to generate the LaTeX output.
   * This has to be implemented by every Node
   *
   * @param {Object} [options]
   * @throws {Error}
   */ Node.prototype._toTex = function(options) {
        // must be implemented by each of the Node implementations
        throw new Error("_toTex not implemented for " + this.type);
    };
    /**
   * Get identifier.
   * @return {string}
   */ Node.prototype.getIdentifier = function() {
        return this.type;
    };
    /**
   * Get the content of the current Node.
   * @return {Node} node
   **/ Node.prototype.getContent = function() {
        return this;
    };
    /**
   * Validate the symbol names of a scope.
   * Throws an error when the scope contains an illegal symbol.
   * @param {Object} scope
   */ function _validateScope(scope) {
        for(var symbol in scope)if ((0, $glBd7.hasOwnProperty)(scope, symbol)) {
            if (symbol in (0, $6cmon.keywords)) throw new Error('Scope contains an illegal symbol, "' + symbol + '" is a reserved keyword');
        }
    }
    return Node;
}, {
    isClass: true,
    isNode: true
});

});
parcelRegister("9okwi", function(module, exports) {

$parcel$export(module.exports, "warnOnce", function () { return $6d6645ca1625ed8c$export$5b28268982f175ba; });
/**
 * Log a console.warn message only once
 */ var $6d6645ca1625ed8c$export$5b28268982f175ba = function() {
    var messages = {};
    return function warnOnce() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var message = args.join(", ");
        if (!messages[message]) {
            var _console;
            messages[message] = true;
            (_console = console).warn.apply(_console, [
                "Warning:"
            ].concat(args));
        }
    };
}();

});


parcelRegister("ecsls", function(module, exports) {

$parcel$export(module.exports, "createObjectNode", function () { return $a5682c66bb28fe63$export$385a7f4e27f173c4; });

var $7E0JQ = parcelRequire("7E0JQ");

var $7HWRb = parcelRequire("7HWRb");

var $i3n6j = parcelRequire("i3n6j");

var $glBd7 = parcelRequire("glBd7");

var $jKx4O = parcelRequire("jKx4O");
function $a5682c66bb28fe63$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a5682c66bb28fe63$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a5682c66bb28fe63$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a5682c66bb28fe63$var$_typeof(obj);
}
var $a5682c66bb28fe63$var$name = "ObjectNode";
var $a5682c66bb28fe63$var$dependencies = [
    "Node"
];
var $a5682c66bb28fe63$export$385a7f4e27f173c4 = /* #__PURE__ */ (0, $jKx4O.factory)($a5682c66bb28fe63$var$name, $a5682c66bb28fe63$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor ObjectNode
   * @extends {Node}
   * Holds an object with keys/values
   * @param {Object.<string, Node>} [properties]   object with key/value pairs
   */ function ObjectNode(properties) {
        if (!(this instanceof ObjectNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.properties = properties || {}; // validate input
        if (properties) {
            if (!($a5682c66bb28fe63$var$_typeof(properties) === "object") || !Object.keys(properties).every(function(key) {
                return (0, $7E0JQ.isNode)(properties[key]);
            })) throw new TypeError("Object containing Nodes expected");
        }
    }
    ObjectNode.prototype = new Node();
    ObjectNode.prototype.type = "ObjectNode";
    ObjectNode.prototype.isObjectNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ObjectNode.prototype._compile = function(math, argNames) {
        var evalEntries = {};
        for(var key in this.properties)if ((0, $glBd7.hasOwnProperty)(this.properties, key)) {
            // we stringify/parse the key here to resolve unicode characters,
            // so you cannot create a key like {"co\\u006Estructor": null}
            var stringifiedKey = (0, $7HWRb.stringify)(key);
            var parsedKey = JSON.parse(stringifiedKey);
            if (!(0, $i3n6j.isSafeProperty)(this.properties, parsedKey)) throw new Error('No access to property "' + parsedKey + '"');
            evalEntries[parsedKey] = this.properties[key]._compile(math, argNames);
        }
        return function evalObjectNode(scope, args, context) {
            var obj = {};
            for(var _key in evalEntries)if ((0, $glBd7.hasOwnProperty)(evalEntries, _key)) obj[_key] = evalEntries[_key](scope, args, context);
            return obj;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ObjectNode.prototype.forEach = function(callback) {
        for(var key in this.properties)if ((0, $glBd7.hasOwnProperty)(this.properties, key)) callback(this.properties[key], "properties[" + (0, $7HWRb.stringify)(key) + "]", this);
    };
    /**
   * Create a new ObjectNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ObjectNode} Returns a transformed copy of the node
   */ ObjectNode.prototype.map = function(callback) {
        var properties = {};
        for(var key in this.properties)if ((0, $glBd7.hasOwnProperty)(this.properties, key)) properties[key] = this._ifNode(callback(this.properties[key], "properties[" + (0, $7HWRb.stringify)(key) + "]", this));
        return new ObjectNode(properties);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ObjectNode}
   */ ObjectNode.prototype.clone = function() {
        var properties = {};
        for(var key in this.properties)if ((0, $glBd7.hasOwnProperty)(this.properties, key)) properties[key] = this.properties[key];
        return new ObjectNode(properties);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ObjectNode.prototype._toString = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $glBd7.hasOwnProperty)(this.properties, key)) entries.push((0, $7HWRb.stringify)(key) + ": " + this.properties[key].toString(options));
        return "{" + entries.join(", ") + "}";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ObjectNode.prototype.toJSON = function() {
        return {
            mathjs: "ObjectNode",
            properties: this.properties
        };
    };
    /**
   * Instantiate an OperatorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
   *                       where mathjs is optional
   * @returns {ObjectNode}
   */ ObjectNode.fromJSON = function(json) {
        return new ObjectNode(json.properties);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ObjectNode.prototype.toHTML = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $glBd7.hasOwnProperty)(this.properties, key)) entries.push('<span class="math-symbol math-property">' + (0, $7HWRb.escape)(key) + "</span>" + '<span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[key].toHTML(options));
        return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + entries.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ObjectNode.prototype._toTex = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $glBd7.hasOwnProperty)(this.properties, key)) entries.push("\\mathbf{" + key + ":} & " + this.properties[key].toTex(options) + "\\\\");
        return "\\left\\{\\begin{array}{ll}".concat(entries.join("\n"), "\\end{array}\\right\\}");
    };
    return ObjectNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("d4OJw", function(module, exports) {

$parcel$export(module.exports, "createOperatorNode", function () { return $985300a13d451856$export$aa95756bacab93d; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $7HWRb = parcelRequire("7HWRb");

var $i3n6j = parcelRequire("i3n6j");

var $7OD47 = parcelRequire("7OD47");

var $fMJxQ = parcelRequire("fMJxQ");

var $jKx4O = parcelRequire("jKx4O");
var $985300a13d451856$var$name = "OperatorNode";
var $985300a13d451856$var$dependencies = [
    "Node"
];
var $985300a13d451856$export$aa95756bacab93d = /* #__PURE__ */ (0, $jKx4O.factory)($985300a13d451856$var$name, $985300a13d451856$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor OperatorNode
   * @extends {Node}
   * An operator with two arguments, like 2+3
   *
   * @param {string} op           Operator name, for example '+'
   * @param {string} fn           Function name, for example 'add'
   * @param {Node[]} args         Operator arguments
   * @param {boolean} [implicit]  Is this an implicit multiplication?
   */ function OperatorNode(op, fn, args, implicit) {
        if (!(this instanceof OperatorNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof op !== "string") throw new TypeError('string expected for parameter "op"');
        if (typeof fn !== "string") throw new TypeError('string expected for parameter "fn"');
        if (!Array.isArray(args) || !args.every((0, $7E0JQ.isNode))) throw new TypeError('Array containing Nodes expected for parameter "args"');
        this.implicit = implicit === true;
        this.op = op;
        this.fn = fn;
        this.args = args || [];
    }
    OperatorNode.prototype = new Node();
    OperatorNode.prototype.type = "OperatorNode";
    OperatorNode.prototype.isOperatorNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ OperatorNode.prototype._compile = function(math, argNames) {
        // validate fn
        if (typeof this.fn !== "string" || !(0, $i3n6j.isSafeMethod)(math, this.fn)) {
            if (!math[this.fn]) throw new Error("Function " + this.fn + ' missing in provided namespace "math"');
            else throw new Error('No access to function "' + this.fn + '"');
        }
        var fn = (0, $i3n6j.getSafeProperty)(math, this.fn);
        var evalArgs = (0, $YkZ7e.map)(this.args, function(arg) {
            return arg._compile(math, argNames);
        });
        if (evalArgs.length === 1) {
            var evalArg0 = evalArgs[0];
            return function evalOperatorNode(scope, args, context) {
                return fn(evalArg0(scope, args, context));
            };
        } else if (evalArgs.length === 2) {
            var _evalArg = evalArgs[0];
            var evalArg1 = evalArgs[1];
            return function evalOperatorNode(scope, args, context) {
                return fn(_evalArg(scope, args, context), evalArg1(scope, args, context));
            };
        } else return function evalOperatorNode(scope, args, context) {
            return fn.apply(null, (0, $YkZ7e.map)(evalArgs, function(evalArg) {
                return evalArg(scope, args, context);
            }));
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ OperatorNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.args.length; i++)callback(this.args[i], "args[" + i + "]", this);
    };
    /**
   * Create a new OperatorNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {OperatorNode} Returns a transformed copy of the node
   */ OperatorNode.prototype.map = function(callback) {
        var args = [];
        for(var i = 0; i < this.args.length; i++)args[i] = this._ifNode(callback(this.args[i], "args[" + i + "]", this));
        return new OperatorNode(this.op, this.fn, args, this.implicit);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {OperatorNode}
   */ OperatorNode.prototype.clone = function() {
        return new OperatorNode(this.op, this.fn, this.args.slice(0), this.implicit);
    };
    /**
   * Check whether this is an unary OperatorNode:
   * has exactly one argument, like `-a`.
   * @return {boolean} Returns true when an unary operator node, false otherwise.
   */ OperatorNode.prototype.isUnary = function() {
        return this.args.length === 1;
    };
    /**
   * Check whether this is a binary OperatorNode:
   * has exactly two arguments, like `a + b`.
   * @return {boolean} Returns true when a binary operator node, false otherwise.
   */ OperatorNode.prototype.isBinary = function() {
        return this.args.length === 2;
    };
    /**
   * Calculate which parentheses are necessary. Gets an OperatorNode
   * (which is the root of the tree) and an Array of Nodes
   * (this.args) and returns an array where 'true' means that an argument
   * has to be enclosed in parentheses whereas 'false' means the opposite.
   *
   * @param {OperatorNode} root
   * @param {string} parenthesis
   * @param {Node[]} args
   * @param {boolean} latex
   * @return {boolean[]}
   * @private
   */ function calculateNecessaryParentheses(root, parenthesis, implicit, args, latex) {
        // precedence of the root OperatorNode
        var precedence = (0, $7OD47.getPrecedence)(root, parenthesis);
        var associativity = (0, $7OD47.getAssociativity)(root, parenthesis);
        if (parenthesis === "all" || args.length > 2 && root.getIdentifier() !== "OperatorNode:add" && root.getIdentifier() !== "OperatorNode:multiply") return args.map(function(arg) {
            switch(arg.getContent().type){
                // Nodes that don't need extra parentheses
                case "ArrayNode":
                case "ConstantNode":
                case "SymbolNode":
                case "ParenthesisNode":
                    return false;
                default:
                    return true;
            }
        });
        var result;
        switch(args.length){
            case 0:
                result = [];
                break;
            case 1:
                // precedence of the operand
                var operandPrecedence = (0, $7OD47.getPrecedence)(args[0], parenthesis); // handle special cases for LaTeX, where some of the parentheses aren't needed
                if (latex && operandPrecedence !== null) {
                    var operandIdentifier;
                    var rootIdentifier;
                    if (parenthesis === "keep") {
                        operandIdentifier = args[0].getIdentifier();
                        rootIdentifier = root.getIdentifier();
                    } else {
                        // Ignore Parenthesis Nodes when not in 'keep' mode
                        operandIdentifier = args[0].getContent().getIdentifier();
                        rootIdentifier = root.getContent().getIdentifier();
                    }
                    if ((0, $7OD47.properties)[precedence][rootIdentifier].latexLeftParens === false) {
                        result = [
                            false
                        ];
                        break;
                    }
                    if ((0, $7OD47.properties)[operandPrecedence][operandIdentifier].latexParens === false) {
                        result = [
                            false
                        ];
                        break;
                    }
                }
                if (operandPrecedence === null) {
                    // if the operand has no defined precedence, no parens are needed
                    result = [
                        false
                    ];
                    break;
                }
                if (operandPrecedence <= precedence) {
                    // if the operands precedence is lower, parens are needed
                    result = [
                        true
                    ];
                    break;
                } // otherwise, no parens needed
                result = [
                    false
                ];
                break;
            case 2:
                var lhsParens; // left hand side needs parenthesis?
                // precedence of the left hand side
                var lhsPrecedence = (0, $7OD47.getPrecedence)(args[0], parenthesis); // is the root node associative with the left hand side
                var assocWithLhs = (0, $7OD47.isAssociativeWith)(root, args[0], parenthesis);
                if (lhsPrecedence === null) // if the left hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                lhsParens = false;
                else if (lhsPrecedence === precedence && associativity === "right" && !assocWithLhs) // In case of equal precedence, if the root node is left associative
                // parens are **never** necessary for the left hand side.
                // If it is right associative however, parens are necessary
                // if the root node isn't associative with the left hand side
                lhsParens = true;
                else if (lhsPrecedence < precedence) lhsParens = true;
                else lhsParens = false;
                var rhsParens; // right hand side needs parenthesis?
                // precedence of the right hand side
                var rhsPrecedence = (0, $7OD47.getPrecedence)(args[1], parenthesis); // is the root node associative with the right hand side?
                var assocWithRhs = (0, $7OD47.isAssociativeWith)(root, args[1], parenthesis);
                if (rhsPrecedence === null) // if the right hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                rhsParens = false;
                else if (rhsPrecedence === precedence && associativity === "left" && !assocWithRhs) // In case of equal precedence, if the root node is right associative
                // parens are **never** necessary for the right hand side.
                // If it is left associative however, parens are necessary
                // if the root node isn't associative with the right hand side
                rhsParens = true;
                else if (rhsPrecedence < precedence) rhsParens = true;
                else rhsParens = false;
                 // handle special cases for LaTeX, where some of the parentheses aren't needed
                if (latex) {
                    var _rootIdentifier;
                    var lhsIdentifier;
                    var rhsIdentifier;
                    if (parenthesis === "keep") {
                        _rootIdentifier = root.getIdentifier();
                        lhsIdentifier = root.args[0].getIdentifier();
                        rhsIdentifier = root.args[1].getIdentifier();
                    } else {
                        // Ignore ParenthesisNodes when not in 'keep' mode
                        _rootIdentifier = root.getContent().getIdentifier();
                        lhsIdentifier = root.args[0].getContent().getIdentifier();
                        rhsIdentifier = root.args[1].getContent().getIdentifier();
                    }
                    if (lhsPrecedence !== null) {
                        if ((0, $7OD47.properties)[precedence][_rootIdentifier].latexLeftParens === false) lhsParens = false;
                        if ((0, $7OD47.properties)[lhsPrecedence][lhsIdentifier].latexParens === false) lhsParens = false;
                    }
                    if (rhsPrecedence !== null) {
                        if ((0, $7OD47.properties)[precedence][_rootIdentifier].latexRightParens === false) rhsParens = false;
                        if ((0, $7OD47.properties)[rhsPrecedence][rhsIdentifier].latexParens === false) rhsParens = false;
                    }
                }
                result = [
                    lhsParens,
                    rhsParens
                ];
                break;
            default:
                if (root.getIdentifier() === "OperatorNode:add" || root.getIdentifier() === "OperatorNode:multiply") result = args.map(function(arg) {
                    var argPrecedence = (0, $7OD47.getPrecedence)(arg, parenthesis);
                    var assocWithArg = (0, $7OD47.isAssociativeWith)(root, arg, parenthesis);
                    var argAssociativity = (0, $7OD47.getAssociativity)(arg, parenthesis);
                    if (argPrecedence === null) // if the argument has no defined precedence, no parens are needed
                    return false;
                    else if (precedence === argPrecedence && associativity === argAssociativity && !assocWithArg) return true;
                    else if (argPrecedence < precedence) return true;
                    return false;
                });
                break;
        } // handles an edge case of 'auto' parentheses with implicit multiplication of ConstantNode
        // In that case print parentheses for ParenthesisNodes even though they normally wouldn't be
        // printed.
        if (args.length >= 2 && root.getIdentifier() === "OperatorNode:multiply" && root.implicit && parenthesis === "auto" && implicit === "hide") result = args.map(function(arg, index) {
            var isParenthesisNode = arg.getIdentifier() === "ParenthesisNode";
            if (result[index] || isParenthesisNode) // put in parenthesis?
            return true;
            return false;
        });
        return result;
    }
    /**
   * Get string representation.
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $7OD47.getAssociativity)(this, parenthesis);
            var operand = args[0].toString(options);
            if (parens[0]) operand = "(" + operand + ")";
             // for example for "not", we want a space between operand and argument
            var opIsNamed = /[a-zA-Z]+/.test(this.op);
            if (assoc === "right") // prefix operator
            return this.op + (opIsNamed ? " " : "") + operand;
            else if (assoc === "left") // postfix
            return operand + (opIsNamed ? " " : "") + this.op;
             // fall back to postfix
            return operand + this.op;
        } else if (args.length === 2) {
            var lhs = args[0].toString(options); // left hand side
            var rhs = args[1].toString(options); // right hand side
            if (parens[0]) // left hand side in parenthesis?
            lhs = "(" + lhs + ")";
            if (parens[1]) // right hand side in parenthesis?
            rhs = "(" + rhs + ")";
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return lhs + " " + rhs;
            return lhs + " " + this.op + " " + rhs;
        } else if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
            var stringifiedArgs = args.map(function(arg, index) {
                arg = arg.toString(options);
                if (parens[index]) // put in parenthesis?
                arg = "(" + arg + ")";
                return arg;
            });
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return stringifiedArgs.join(" ");
            return stringifiedArgs.join(" " + this.op + " ");
        } else // fallback to formatting as a function call
        return this.fn + "(" + this.args.join(", ") + ")";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ OperatorNode.prototype.toJSON = function() {
        return {
            mathjs: "OperatorNode",
            op: this.op,
            fn: this.fn,
            args: this.args,
            implicit: this.implicit
        };
    };
    /**
   * Instantiate an OperatorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "OperatorNode", "op": "+", "fn": "add", "args": [...], "implicit": false}`,
   *                       where mathjs is optional
   * @returns {OperatorNode}
   */ OperatorNode.fromJSON = function(json) {
        return new OperatorNode(json.op, json.fn, json.args, json.implicit);
    };
    /**
   * Get HTML representation.
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $7OD47.getAssociativity)(this, parenthesis);
            var operand = args[0].toHTML(options);
            if (parens[0]) operand = '<span class="math-parenthesis math-round-parenthesis">(</span>' + operand + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (assoc === "right") // prefix operator
            return '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + (0, $7HWRb.escape)(this.op) + "</span>" + operand;
            else // postfix when assoc === 'left' or undefined
            return operand + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + (0, $7HWRb.escape)(this.op) + "</span>";
        } else if (args.length === 2) {
            // binary operatoes
            var lhs = args[0].toHTML(options); // left hand side
            var rhs = args[1].toHTML(options); // right hand side
            if (parens[0]) // left hand side in parenthesis?
            lhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + lhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (parens[1]) // right hand side in parenthesis?
            rhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + rhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return lhs + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + rhs;
            return lhs + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $7HWRb.escape)(this.op) + "</span>" + rhs;
        } else {
            var stringifiedArgs = args.map(function(arg, index) {
                arg = arg.toHTML(options);
                if (parens[index]) // put in parenthesis?
                arg = '<span class="math-parenthesis math-round-parenthesis">(</span>' + arg + '<span class="math-parenthesis math-round-parenthesis">)</span>';
                return arg;
            });
            if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
                if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return stringifiedArgs.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>');
                return stringifiedArgs.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $7HWRb.escape)(this.op) + "</span>");
            } else // fallback to formatting as a function call
            return '<span class="math-function">' + (0, $7HWRb.escape)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + stringifiedArgs.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
        }
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, true);
        var op = (0, $fMJxQ.latexOperators)[this.fn];
        op = typeof op === "undefined" ? this.op : op; // fall back to using this.op
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $7OD47.getAssociativity)(this, parenthesis);
            var operand = args[0].toTex(options);
            if (parens[0]) operand = "\\left(".concat(operand, "\\right)");
            if (assoc === "right") // prefix operator
            return op + operand;
            else if (assoc === "left") // postfix operator
            return operand + op;
             // fall back to postfix
            return operand + op;
        } else if (args.length === 2) {
            // binary operators
            var lhs = args[0]; // left hand side
            var lhsTex = lhs.toTex(options);
            if (parens[0]) lhsTex = "\\left(".concat(lhsTex, "\\right)");
            var rhs = args[1]; // right hand side
            var rhsTex = rhs.toTex(options);
            if (parens[1]) rhsTex = "\\left(".concat(rhsTex, "\\right)");
             // handle some exceptions (due to the way LaTeX works)
            var lhsIdentifier;
            if (parenthesis === "keep") lhsIdentifier = lhs.getIdentifier();
            else // Ignore ParenthesisNodes if in 'keep' mode
            lhsIdentifier = lhs.getContent().getIdentifier();
            switch(this.getIdentifier()){
                case "OperatorNode:divide":
                    // op contains '\\frac' at this point
                    return op + "{" + lhsTex + "}" + "{" + rhsTex + "}";
                case "OperatorNode:pow":
                    lhsTex = "{" + lhsTex + "}";
                    rhsTex = "{" + rhsTex + "}";
                    switch(lhsIdentifier){
                        case "ConditionalNode":
                        case "OperatorNode:divide":
                            lhsTex = "\\left(".concat(lhsTex, "\\right)");
                    }
                    break;
                case "OperatorNode:multiply":
                    if (this.implicit && implicit === "hide") return lhsTex + "~" + rhsTex;
            }
            return lhsTex + op + rhsTex;
        } else if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
            var texifiedArgs = args.map(function(arg, index) {
                arg = arg.toTex(options);
                if (parens[index]) arg = "\\left(".concat(arg, "\\right)");
                return arg;
            });
            if (this.getIdentifier() === "OperatorNode:multiply" && this.implicit) return texifiedArgs.join("~");
            return texifiedArgs.join(op);
        } else // fall back to formatting as a function call
        // as this is a fallback, it doesn't use
        // fancy function names
        return "\\mathrm{" + this.fn + "}\\left(" + args.map(function(arg) {
            return arg.toTex(options);
        }).join(",") + "\\right)";
    };
    /**
   * Get identifier.
   * @return {string}
   */ OperatorNode.prototype.getIdentifier = function() {
        return this.type + ":" + this.fn;
    };
    return OperatorNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("bx6n0", function(module, exports) {

$parcel$export(module.exports, "createParenthesisNode", function () { return $8657b7c2a729fe36$export$9bf5d3d4ef922b0c; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $8657b7c2a729fe36$var$name = "ParenthesisNode";
var $8657b7c2a729fe36$var$dependencies = [
    "Node"
];
var $8657b7c2a729fe36$export$9bf5d3d4ef922b0c = /* #__PURE__ */ (0, $jKx4O.factory)($8657b7c2a729fe36$var$name, $8657b7c2a729fe36$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor ParenthesisNode
   * @extends {Node}
   * A parenthesis node describes manual parenthesis from the user input
   * @param {Node} content
   * @extends {Node}
   */ function ParenthesisNode(content) {
        if (!(this instanceof ParenthesisNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (!(0, $7E0JQ.isNode)(content)) throw new TypeError('Node expected for parameter "content"');
        this.content = content;
    }
    ParenthesisNode.prototype = new Node();
    ParenthesisNode.prototype.type = "ParenthesisNode";
    ParenthesisNode.prototype.isParenthesisNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ParenthesisNode.prototype._compile = function(math, argNames) {
        return this.content._compile(math, argNames);
    };
    /**
   * Get the content of the current Node.
   * @return {Node} content
   * @override
   **/ ParenthesisNode.prototype.getContent = function() {
        return this.content.getContent();
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ParenthesisNode.prototype.forEach = function(callback) {
        callback(this.content, "content", this);
    };
    /**
   * Create a new ParenthesisNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {ParenthesisNode} Returns a clone of the node
   */ ParenthesisNode.prototype.map = function(callback) {
        var content = callback(this.content, "content", this);
        return new ParenthesisNode(content);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ParenthesisNode}
   */ ParenthesisNode.prototype.clone = function() {
        return new ParenthesisNode(this.content);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype._toString = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return "(" + this.content.toString(options) + ")";
        return this.content.toString(options);
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ParenthesisNode.prototype.toJSON = function() {
        return {
            mathjs: "ParenthesisNode",
            content: this.content
        };
    };
    /**
   * Instantiate an ParenthesisNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
   *                       where mathjs is optional
   * @returns {ParenthesisNode}
   */ ParenthesisNode.fromJSON = function(json) {
        return new ParenthesisNode(json.content);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype.toHTML = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return this.content.toHTML(options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype._toTex = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return "\\left(".concat(this.content.toTex(options), "\\right)");
        return this.content.toTex(options);
    };
    return ParenthesisNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("gQJls", function(module, exports) {

$parcel$export(module.exports, "createParse", function () { return $c444ad3f4a4ebd41$export$fef7a8850e50b7; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");

var $fbkGg = parcelRequire("fbkGg");

var $glBd7 = parcelRequire("glBd7");
function $c444ad3f4a4ebd41$var$_extends() {
    $c444ad3f4a4ebd41$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c444ad3f4a4ebd41$var$_extends.apply(this, arguments);
}
var $c444ad3f4a4ebd41$var$name = "parse";
var $c444ad3f4a4ebd41$var$dependencies = [
    "typed",
    "numeric",
    "config",
    "AccessorNode",
    "ArrayNode",
    "AssignmentNode",
    "BlockNode",
    "ConditionalNode",
    "ConstantNode",
    "FunctionAssignmentNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "ParenthesisNode",
    "RangeNode",
    "RelationalNode",
    "SymbolNode"
];
var $c444ad3f4a4ebd41$export$fef7a8850e50b7 = /* #__PURE__ */ (0, $jKx4O.factory)($c444ad3f4a4ebd41$var$name, $c444ad3f4a4ebd41$var$dependencies, function(_ref) {
    var typed = _ref.typed, numeric = _ref.numeric, config = _ref.config, AccessorNode = _ref.AccessorNode, ArrayNode = _ref.ArrayNode, AssignmentNode = _ref.AssignmentNode, BlockNode = _ref.BlockNode, ConditionalNode = _ref.ConditionalNode, ConstantNode = _ref.ConstantNode, FunctionAssignmentNode = _ref.FunctionAssignmentNode, FunctionNode = _ref.FunctionNode, IndexNode = _ref.IndexNode, ObjectNode = _ref.ObjectNode, OperatorNode = _ref.OperatorNode, ParenthesisNode = _ref.ParenthesisNode, RangeNode = _ref.RangeNode, RelationalNode = _ref.RelationalNode, SymbolNode = _ref.SymbolNode;
    /**
   * Parse an expression. Returns a node tree, which can be evaluated by
   * invoking node.evaluate().
   *
   * Note the evaluating arbitrary expressions may involve security risks,
   * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
   *
   * Syntax:
   *
   *     math.parse(expr)
   *     math.parse(expr, options)
   *     math.parse([expr1, expr2, expr3, ...])
   *     math.parse([expr1, expr2, expr3, ...], options)
   *
   * Example:
   *
   *     const node1 = math.parse('sqrt(3^2 + 4^2)')
   *     node1.compile().evaluate() // 5
   *
   *     let scope = {a:3, b:4}
   *     const node2 = math.parse('a * b') // 12
   *     const code2 = node2.compile()
   *     code2.evaluate(scope) // 12
   *     scope.a = 5
   *     code2.evaluate(scope) // 20
   *
   *     const nodes = math.parse(['a = 3', 'b = 4', 'a * b'])
   *     nodes[2].compile().evaluate() // 12
   *
   * See also:
   *
   *     evaluate, compile
   *
   * @param {string | string[] | Matrix} expr          Expression to be parsed
   * @param {{nodes: Object<string, Node>}} [options]  Available options:
   *                                                   - `nodes` a set of custom nodes
   * @return {Node | Node[]} node
   * @throws {Error}
   */ var parse = typed($c444ad3f4a4ebd41$var$name, {
        string: function string(expression) {
            return parseStart(expression, {});
        },
        "Array | Matrix": function ArrayMatrix(expressions) {
            return parseMultiple(expressions, {});
        },
        "string, Object": function stringObject(expression, options) {
            var extraNodes = options.nodes !== undefined ? options.nodes : {};
            return parseStart(expression, extraNodes);
        },
        "Array | Matrix, Object": parseMultiple
    });
    function parseMultiple(expressions) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var extraNodes = options.nodes !== undefined ? options.nodes : {}; // parse an array or matrix with expressions
        return (0, $fbkGg.deepMap)(expressions, function(elem) {
            if (typeof elem !== "string") throw new TypeError("String expected");
            return parseStart(elem, extraNodes);
        });
    } // token types enumeration
    var TOKENTYPE = {
        NULL: 0,
        DELIMITER: 1,
        NUMBER: 2,
        SYMBOL: 3,
        UNKNOWN: 4
    }; // map with all delimiters
    var DELIMITERS = {
        ",": true,
        "(": true,
        ")": true,
        "[": true,
        "]": true,
        "{": true,
        "}": true,
        '"': true,
        "'": true,
        ";": true,
        "+": true,
        "-": true,
        "*": true,
        ".*": true,
        "/": true,
        "./": true,
        "%": true,
        "^": true,
        ".^": true,
        "~": true,
        "!": true,
        "&": true,
        "|": true,
        "^|": true,
        "=": true,
        ":": true,
        "?": true,
        "==": true,
        "!=": true,
        "<": true,
        ">": true,
        "<=": true,
        ">=": true,
        "<<": true,
        ">>": true,
        ">>>": true
    }; // map with all named delimiters
    var NAMED_DELIMITERS = {
        mod: true,
        to: true,
        "in": true,
        and: true,
        xor: true,
        or: true,
        not: true
    };
    var CONSTANTS = {
        "true": true,
        "false": false,
        "null": null,
        undefined: undefined
    };
    var NUMERIC_CONSTANTS = [
        "NaN",
        "Infinity"
    ];
    function initialState() {
        return {
            extraNodes: {},
            // current extra nodes, must be careful not to mutate
            expression: "",
            // current expression
            comment: "",
            // last parsed comment
            index: 0,
            // current index in expr
            token: "",
            // current token
            tokenType: TOKENTYPE.NULL,
            // type of the token
            nestingLevel: 0,
            // level of nesting inside parameters, used to ignore newline characters
            conditionalLevel: null // when a conditional is being parsed, the level of the conditional is stored here
        };
    }
    /**
   * View upto `length` characters of the expression starting at the current character.
   *
   * @param {Object} state
   * @param {number} [length=1] Number of characters to view
   * @returns {string}
   * @private
   */ function currentString(state, length) {
        return state.expression.substr(state.index, length);
    }
    /**
   * View the current character. Returns '' if end of expression is reached.
   *
   * @param {Object} state
   * @returns {string}
   * @private
   */ function currentCharacter(state) {
        return currentString(state, 1);
    }
    /**
   * Get the next character from the expression.
   * The character is stored into the char c. If the end of the expression is
   * reached, the function puts an empty string in c.
   * @private
   */ function next(state) {
        state.index++;
    }
    /**
   * Preview the previous character from the expression.
   * @return {string} cNext
   * @private
   */ function prevCharacter(state) {
        return state.expression.charAt(state.index - 1);
    }
    /**
   * Preview the next character from the expression.
   * @return {string} cNext
   * @private
   */ function nextCharacter(state) {
        return state.expression.charAt(state.index + 1);
    }
    /**
   * Get next token in the current string expr.
   * The token and token type are available as token and tokenType
   * @private
   */ function getToken(state) {
        state.tokenType = TOKENTYPE.NULL;
        state.token = "";
        state.comment = ""; // skip over whitespaces
        // space, tab, and newline when inside parameters
        while(parse.isWhitespace(currentCharacter(state), state.nestingLevel))next(state);
         // skip comment
        if (currentCharacter(state) === "#") while(currentCharacter(state) !== "\n" && currentCharacter(state) !== ""){
            state.comment += currentCharacter(state);
            next(state);
        }
         // check for end of expression
        if (currentCharacter(state) === "") {
            // token is still empty
            state.tokenType = TOKENTYPE.DELIMITER;
            return;
        } // check for new line character
        if (currentCharacter(state) === "\n" && !state.nestingLevel) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = currentCharacter(state);
            next(state);
            return;
        }
        var c1 = currentCharacter(state);
        var c2 = currentString(state, 2);
        var c3 = currentString(state, 3);
        if (c3.length === 3 && DELIMITERS[c3]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c3;
            next(state);
            next(state);
            next(state);
            return;
        } // check for delimiters consisting of 2 characters
        if (c2.length === 2 && DELIMITERS[c2]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c2;
            next(state);
            next(state);
            return;
        } // check for delimiters consisting of 1 character
        if (DELIMITERS[c1]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c1;
            next(state);
            return;
        } // check for a number
        if (parse.isDigitDot(c1)) {
            state.tokenType = TOKENTYPE.NUMBER; // get number, can have a single dot
            if (currentCharacter(state) === ".") {
                state.token += currentCharacter(state);
                next(state);
                if (!parse.isDigit(currentCharacter(state))) // this is no number, it is just a dot (can be dot notation)
                state.tokenType = TOKENTYPE.DELIMITER;
            } else {
                while(parse.isDigit(currentCharacter(state))){
                    state.token += currentCharacter(state);
                    next(state);
                }
                if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) {
                    state.token += currentCharacter(state);
                    next(state);
                }
            }
            while(parse.isDigit(currentCharacter(state))){
                state.token += currentCharacter(state);
                next(state);
            } // check for exponential notation like "2.3e-4", "1.23e50" or "2e+4"
            if (currentCharacter(state) === "E" || currentCharacter(state) === "e") {
                if (parse.isDigit(nextCharacter(state)) || nextCharacter(state) === "-" || nextCharacter(state) === "+") {
                    state.token += currentCharacter(state);
                    next(state);
                    if (currentCharacter(state) === "+" || currentCharacter(state) === "-") {
                        state.token += currentCharacter(state);
                        next(state);
                    } // Scientific notation MUST be followed by an exponent
                    if (!parse.isDigit(currentCharacter(state))) throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                    while(parse.isDigit(currentCharacter(state))){
                        state.token += currentCharacter(state);
                        next(state);
                    }
                    if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                } else if (nextCharacter(state) === ".") {
                    next(state);
                    throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                }
            }
            return;
        } // check for variables, functions, named operators
        if (parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state))) {
            while(parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state)) || parse.isDigit(currentCharacter(state))){
                state.token += currentCharacter(state);
                next(state);
            }
            if ((0, $glBd7.hasOwnProperty)(NAMED_DELIMITERS, state.token)) state.tokenType = TOKENTYPE.DELIMITER;
            else state.tokenType = TOKENTYPE.SYMBOL;
            return;
        } // something unknown is found, wrong characters -> a syntax error
        state.tokenType = TOKENTYPE.UNKNOWN;
        while(currentCharacter(state) !== ""){
            state.token += currentCharacter(state);
            next(state);
        }
        throw createSyntaxError(state, 'Syntax error in part "' + state.token + '"');
    }
    /**
   * Get next token and skip newline tokens
   */ function getTokenSkipNewline(state) {
        do getToken(state);
        while (state.token === "\n"); // eslint-disable-line no-unmodified-loop-condition
    }
    /**
   * Open parameters.
   * New line characters will be ignored until closeParams(state) is called
   */ function openParams(state) {
        state.nestingLevel++;
    }
    /**
   * Close parameters.
   * New line characters will no longer be ignored
   */ function closeParams(state) {
        state.nestingLevel--;
    }
    /**
   * Checks whether the current character `c` is a valid alpha character:
   *
   * - A latin letter (upper or lower case) Ascii: a-z, A-Z
   * - An underscore                        Ascii: _
   * - A dollar sign                        Ascii: $
   * - A latin letter with accents          Unicode: \u00C0 - \u02AF
   * - A greek letter                       Unicode: \u0370 - \u03FF
   * - A mathematical alphanumeric symbol   Unicode: \u{1D400} - \u{1D7FF} excluding invalid code points
   *
   * The previous and next characters are needed to determine whether
   * this character is part of a unicode surrogate pair.
   *
   * @param {string} c      Current character in the expression
   * @param {string} cPrev  Previous character
   * @param {string} cNext  Next character
   * @return {boolean}
   */ parse.isAlpha = function isAlpha(c, cPrev, cNext) {
        return parse.isValidLatinOrGreek(c) || parse.isValidMathSymbol(c, cNext) || parse.isValidMathSymbol(cPrev, c);
    };
    /**
   * Test whether a character is a valid latin, greek, or letter-like character
   * @param {string} c
   * @return {boolean}
   */ parse.isValidLatinOrGreek = function isValidLatinOrGreek(c) {
        return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(c);
    };
    /**
   * Test whether two given 16 bit characters form a surrogate pair of a
   * unicode math symbol.
   *
   * https://unicode-table.com/en/
   * https://www.wikiwand.com/en/Mathematical_operators_and_symbols_in_Unicode
   *
   * Note: In ES6 will be unicode aware:
   * https://stackoverflow.com/questions/280712/javascript-unicode-regexes
   * https://mathiasbynens.be/notes/es6-unicode-regex
   *
   * @param {string} high
   * @param {string} low
   * @return {boolean}
   */ parse.isValidMathSymbol = function isValidMathSymbol(high, low) {
        return /^[\uD835]$/.test(high) && /^[\uDC00-\uDFFF]$/.test(low) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(low);
    };
    /**
   * Check whether given character c is a white space character: space, tab, or enter
   * @param {string} c
   * @param {number} nestingLevel
   * @return {boolean}
   */ parse.isWhitespace = function isWhitespace(c, nestingLevel) {
        // TODO: also take '\r' carriage return as newline? Or does that give problems on mac?
        return c === " " || c === "	" || c === "\n" && nestingLevel > 0;
    };
    /**
   * Test whether the character c is a decimal mark (dot).
   * This is the case when it's not the start of a delimiter '.*', './', or '.^'
   * @param {string} c
   * @param {string} cNext
   * @return {boolean}
   */ parse.isDecimalMark = function isDecimalMark(c, cNext) {
        return c === "." && cNext !== "/" && cNext !== "*" && cNext !== "^";
    };
    /**
   * checks if the given char c is a digit or dot
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isDigitDot = function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    };
    /**
   * checks if the given char c is a digit
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isDigit = function isDigit(c) {
        return c >= "0" && c <= "9";
    };
    /**
   * Start of the parse levels below, in order of precedence
   * @return {Node} node
   * @private
   */ function parseStart(expression, extraNodes) {
        var state = initialState();
        $c444ad3f4a4ebd41$var$_extends(state, {
            expression: expression,
            extraNodes: extraNodes
        });
        getToken(state);
        var node = parseBlock(state); // check for garbage at the end of the expression
        // an expression ends with a empty character '' and tokenType DELIMITER
        if (state.token !== "") {
            if (state.tokenType === TOKENTYPE.DELIMITER) // user entered a not existing operator like "//"
            // TODO: give hints for aliases, for example with "<>" give as hint " did you mean !== ?"
            throw createError(state, "Unexpected operator " + state.token);
            else throw createSyntaxError(state, 'Unexpected part "' + state.token + '"');
        }
        return node;
    }
    /**
   * Parse a block with expressions. Expressions can be separated by a newline
   * character '\n', or by a semicolon ';'. In case of a semicolon, no output
   * of the preceding line is returned.
   * @return {Node} node
   * @private
   */ function parseBlock(state) {
        var node;
        var blocks = [];
        var visible;
        if (state.token !== "" && state.token !== "\n" && state.token !== ";") {
            node = parseAssignment(state);
            node.comment = state.comment;
        } // TODO: simplify this loop
        while(state.token === "\n" || state.token === ";"){
            // eslint-disable-line no-unmodified-loop-condition
            if (blocks.length === 0 && node) {
                visible = state.token !== ";";
                blocks.push({
                    node: node,
                    visible: visible
                });
            }
            getToken(state);
            if (state.token !== "\n" && state.token !== ";" && state.token !== "") {
                node = parseAssignment(state);
                node.comment = state.comment;
                visible = state.token !== ";";
                blocks.push({
                    node: node,
                    visible: visible
                });
            }
        }
        if (blocks.length > 0) return new BlockNode(blocks);
        else {
            if (!node) {
                node = new ConstantNode(undefined);
                node.comment = state.comment;
            }
            return node;
        }
    }
    /**
   * Assignment of a function or variable,
   * - can be a variable like 'a=2.3'
   * - or a updating an existing variable like 'matrix(2,3:5)=[6,7,8]'
   * - defining a function like 'f(x) = x^2'
   * @return {Node} node
   * @private
   */ function parseAssignment(state) {
        var name, args, value, valid;
        var node = parseConditional(state);
        if (state.token === "=") {
            if ((0, $7E0JQ.isSymbolNode)(node)) {
                // parse a variable assignment like 'a = 2/3'
                name = node.name;
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new AssignmentNode(new SymbolNode(name), value);
            } else if ((0, $7E0JQ.isAccessorNode)(node)) {
                // parse a matrix subset assignment like 'A[1,2] = 4'
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new AssignmentNode(node.object, node.index, value);
            } else if ((0, $7E0JQ.isFunctionNode)(node) && (0, $7E0JQ.isSymbolNode)(node.fn)) {
                // parse function assignment like 'f(x) = x^2'
                valid = true;
                args = [];
                name = node.name;
                node.args.forEach(function(arg, index) {
                    if ((0, $7E0JQ.isSymbolNode)(arg)) args[index] = arg.name;
                    else valid = false;
                });
                if (valid) {
                    getTokenSkipNewline(state);
                    value = parseAssignment(state);
                    return new FunctionAssignmentNode(name, args, value);
                }
            }
            throw createSyntaxError(state, "Invalid left hand side of assignment operator =");
        }
        return node;
    }
    /**
   * conditional operation
   *
   *     condition ? truePart : falsePart
   *
   * Note: conditional operator is right-associative
   *
   * @return {Node} node
   * @private
   */ function parseConditional(state) {
        var node = parseLogicalOr(state);
        while(state.token === "?"){
            // eslint-disable-line no-unmodified-loop-condition
            // set a conditional level, the range operator will be ignored as long
            // as conditionalLevel === state.nestingLevel.
            var prev = state.conditionalLevel;
            state.conditionalLevel = state.nestingLevel;
            getTokenSkipNewline(state);
            var condition = node;
            var trueExpr = parseAssignment(state);
            if (state.token !== ":") throw createSyntaxError(state, "False part of conditional expression expected");
            state.conditionalLevel = null;
            getTokenSkipNewline(state);
            var falseExpr = parseAssignment(state); // Note: check for conditional operator again, right associativity
            node = new ConditionalNode(condition, trueExpr, falseExpr); // restore the previous conditional level
            state.conditionalLevel = prev;
        }
        return node;
    }
    /**
   * logical or, 'x or y'
   * @return {Node} node
   * @private
   */ function parseLogicalOr(state) {
        var node = parseLogicalXor(state);
        while(state.token === "or"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("or", "or", [
                node,
                parseLogicalXor(state)
            ]);
        }
        return node;
    }
    /**
   * logical exclusive or, 'x xor y'
   * @return {Node} node
   * @private
   */ function parseLogicalXor(state) {
        var node = parseLogicalAnd(state);
        while(state.token === "xor"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("xor", "xor", [
                node,
                parseLogicalAnd(state)
            ]);
        }
        return node;
    }
    /**
   * logical and, 'x and y'
   * @return {Node} node
   * @private
   */ function parseLogicalAnd(state) {
        var node = parseBitwiseOr(state);
        while(state.token === "and"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("and", "and", [
                node,
                parseBitwiseOr(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise or, 'x | y'
   * @return {Node} node
   * @private
   */ function parseBitwiseOr(state) {
        var node = parseBitwiseXor(state);
        while(state.token === "|"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("|", "bitOr", [
                node,
                parseBitwiseXor(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise exclusive or (xor), 'x ^| y'
   * @return {Node} node
   * @private
   */ function parseBitwiseXor(state) {
        var node = parseBitwiseAnd(state);
        while(state.token === "^|"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("^|", "bitXor", [
                node,
                parseBitwiseAnd(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise and, 'x & y'
   * @return {Node} node
   * @private
   */ function parseBitwiseAnd(state) {
        var node = parseRelational(state);
        while(state.token === "&"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("&", "bitAnd", [
                node,
                parseRelational(state)
            ]);
        }
        return node;
    }
    /**
   * Parse a chained conditional, like 'a > b >= c'
   * @return {Node} node
   */ function parseRelational(state) {
        var params = [
            parseShift(state)
        ];
        var conditionals = [];
        var operators = {
            "==": "equal",
            "!=": "unequal",
            "<": "smaller",
            ">": "larger",
            "<=": "smallerEq",
            ">=": "largerEq"
        };
        while((0, $glBd7.hasOwnProperty)(operators, state.token)){
            // eslint-disable-line no-unmodified-loop-condition
            var cond = {
                name: state.token,
                fn: operators[state.token]
            };
            conditionals.push(cond);
            getTokenSkipNewline(state);
            params.push(parseShift(state));
        }
        if (params.length === 1) return params[0];
        else if (params.length === 2) return new OperatorNode(conditionals[0].name, conditionals[0].fn, params);
        else return new RelationalNode(conditionals.map(function(c) {
            return c.fn;
        }), params);
    }
    /**
   * Bitwise left shift, bitwise right arithmetic shift, bitwise right logical shift
   * @return {Node} node
   * @private
   */ function parseShift(state) {
        var node, name, fn, params;
        node = parseConversion(state);
        var operators = {
            "<<": "leftShift",
            ">>": "rightArithShift",
            ">>>": "rightLogShift"
        };
        while((0, $glBd7.hasOwnProperty)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            params = [
                node,
                parseConversion(state)
            ];
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * conversion operators 'to' and 'in'
   * @return {Node} node
   * @private
   */ function parseConversion(state) {
        var node, name, fn, params;
        node = parseRange(state);
        var operators = {
            to: "to",
            "in": "to" // alias of 'to'
        };
        while((0, $glBd7.hasOwnProperty)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            if (name === "in" && state.token === "") // end of expression -> this is the unit 'in' ('inch')
            node = new OperatorNode("*", "multiply", [
                node,
                new SymbolNode("in")
            ], true);
            else {
                // operator 'a to b' or 'a in b'
                params = [
                    node,
                    parseRange(state)
                ];
                node = new OperatorNode(name, fn, params);
            }
        }
        return node;
    }
    /**
   * parse range, "start:end", "start:step:end", ":", "start:", ":end", etc
   * @return {Node} node
   * @private
   */ function parseRange(state) {
        var node;
        var params = [];
        if (state.token === ":") // implicit start=1 (one-based)
        node = new ConstantNode(1);
        else // explicit start
        node = parseAddSubtract(state);
        if (state.token === ":" && state.conditionalLevel !== state.nestingLevel) {
            // we ignore the range operator when a conditional operator is being processed on the same level
            params.push(node); // parse step and end
            while(state.token === ":" && params.length < 3){
                // eslint-disable-line no-unmodified-loop-condition
                getTokenSkipNewline(state);
                if (state.token === ")" || state.token === "]" || state.token === "," || state.token === "") // implicit end
                params.push(new SymbolNode("end"));
                else // explicit end
                params.push(parseAddSubtract(state));
            }
            if (params.length === 3) // params = [start, step, end]
            node = new RangeNode(params[0], params[2], params[1]); // start, end, step
            else // length === 2
            // params = [start, end]
            node = new RangeNode(params[0], params[1]); // start, end
        }
        return node;
    }
    /**
   * add or subtract
   * @return {Node} node
   * @private
   */ function parseAddSubtract(state) {
        var node, name, fn, params;
        node = parseMultiplyDivide(state);
        var operators = {
            "+": "add",
            "-": "subtract"
        };
        while((0, $glBd7.hasOwnProperty)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            params = [
                node,
                parseMultiplyDivide(state)
            ];
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * multiply, divide, modulus
   * @return {Node} node
   * @private
   */ function parseMultiplyDivide(state) {
        var node, last, name, fn;
        node = parseImplicitMultiplication(state);
        last = node;
        var operators = {
            "*": "multiply",
            ".*": "dotMultiply",
            "/": "divide",
            "./": "dotDivide",
            "%": "mod",
            mod: "mod"
        };
        while(true){
            if ((0, $glBd7.hasOwnProperty)(operators, state.token)) {
                // explicit operators
                name = state.token;
                fn = operators[name];
                getTokenSkipNewline(state);
                last = parseImplicitMultiplication(state);
                node = new OperatorNode(name, fn, [
                    node,
                    last
                ]);
            } else break;
        }
        return node;
    }
    /**
   * implicit multiplication
   * @return {Node} node
   * @private
   */ function parseImplicitMultiplication(state) {
        var node, last;
        node = parseRule2(state);
        last = node;
        while(true){
            if (state.tokenType === TOKENTYPE.SYMBOL || state.token === "in" && (0, $7E0JQ.isConstantNode)(node) || state.tokenType === TOKENTYPE.NUMBER && !(0, $7E0JQ.isConstantNode)(last) && (!(0, $7E0JQ.isOperatorNode)(last) || last.op === "!") || state.token === "(") {
                // parse implicit multiplication
                //
                // symbol:      implicit multiplication like '2a', '(2+3)a', 'a b'
                // number:      implicit multiplication like '(2+3)2'
                // parenthesis: implicit multiplication like '2(3+4)', '(3+4)(1+2)'
                last = parseRule2(state);
                node = new OperatorNode("*", "multiply", [
                    node,
                    last
                ], true);
            } else break;
        }
        return node;
    }
    /**
   * Infamous "rule 2" as described in https://github.com/josdejong/mathjs/issues/792#issuecomment-361065370
   * Explicit division gets higher precedence than implicit multiplication
   * when the division matches this pattern: [number] / [number] [symbol]
   * @return {Node} node
   * @private
   */ function parseRule2(state) {
        var node = parseUnary(state);
        var last = node;
        var tokenStates = [];
        while(true){
            // Match the "number /" part of the pattern "number / number symbol"
            if (state.token === "/" && (0, $7E0JQ.isConstantNode)(last)) {
                // Look ahead to see if the next token is a number
                tokenStates.push($c444ad3f4a4ebd41$var$_extends({}, state));
                getTokenSkipNewline(state); // Match the "number / number" part of the pattern
                if (state.tokenType === TOKENTYPE.NUMBER) {
                    // Look ahead again
                    tokenStates.push($c444ad3f4a4ebd41$var$_extends({}, state));
                    getTokenSkipNewline(state); // Match the "symbol" part of the pattern, or a left parenthesis
                    if (state.tokenType === TOKENTYPE.SYMBOL || state.token === "(") {
                        // We've matched the pattern "number / number symbol".
                        // Rewind once and build the "number / number" node; the symbol will be consumed later
                        $c444ad3f4a4ebd41$var$_extends(state, tokenStates.pop());
                        tokenStates.pop();
                        last = parseUnary(state);
                        node = new OperatorNode("/", "divide", [
                            node,
                            last
                        ]);
                    } else {
                        // Not a match, so rewind
                        tokenStates.pop();
                        $c444ad3f4a4ebd41$var$_extends(state, tokenStates.pop());
                        break;
                    }
                } else {
                    // Not a match, so rewind
                    $c444ad3f4a4ebd41$var$_extends(state, tokenStates.pop());
                    break;
                }
            } else break;
        }
        return node;
    }
    /**
   * Unary plus and minus, and logical and bitwise not
   * @return {Node} node
   * @private
   */ function parseUnary(state) {
        var name, params, fn;
        var operators = {
            "-": "unaryMinus",
            "+": "unaryPlus",
            "~": "bitNot",
            not: "not"
        };
        if ((0, $glBd7.hasOwnProperty)(operators, state.token)) {
            fn = operators[state.token];
            name = state.token;
            getTokenSkipNewline(state);
            params = [
                parseUnary(state)
            ];
            return new OperatorNode(name, fn, params);
        }
        return parsePow(state);
    }
    /**
   * power
   * Note: power operator is right associative
   * @return {Node} node
   * @private
   */ function parsePow(state) {
        var node, name, fn, params;
        node = parseLeftHandOperators(state);
        if (state.token === "^" || state.token === ".^") {
            name = state.token;
            fn = name === "^" ? "pow" : "dotPow";
            getTokenSkipNewline(state);
            params = [
                node,
                parseUnary(state)
            ]; // Go back to unary, we can have '2^-3'
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * Left hand operators: factorial x!, ctranspose x'
   * @return {Node} node
   * @private
   */ function parseLeftHandOperators(state) {
        var node, name, fn, params;
        node = parseCustomNodes(state);
        var operators = {
            "!": "factorial",
            "'": "ctranspose"
        };
        while((0, $glBd7.hasOwnProperty)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getToken(state);
            params = [
                node
            ];
            node = new OperatorNode(name, fn, params);
            node = parseAccessors(state, node);
        }
        return node;
    }
    /**
   * Parse a custom node handler. A node handler can be used to process
   * nodes in a custom way, for example for handling a plot.
   *
   * A handler must be passed as second argument of the parse function.
   * - must extend math.expression.node.Node
   * - must contain a function _compile(defs: Object) : string
   * - must contain a function find(filter: Object) : Node[]
   * - must contain a function toString() : string
   * - the constructor is called with a single argument containing all parameters
   *
   * For example:
   *
   *     nodes = {
   *       'plot': PlotHandler
   *     }
   *
   * The constructor of the handler is called as:
   *
   *     node = new PlotHandler(params)
   *
   * The handler will be invoked when evaluating an expression like:
   *
   *     node = math.parse('plot(sin(x), x)', nodes)
   *
   * @return {Node} node
   * @private
   */ function parseCustomNodes(state) {
        var params = [];
        if (state.tokenType === TOKENTYPE.SYMBOL && (0, $glBd7.hasOwnProperty)(state.extraNodes, state.token)) {
            var CustomNode = state.extraNodes[state.token];
            getToken(state); // parse parameters
            if (state.token === "(") {
                params = [];
                openParams(state);
                getToken(state);
                if (state.token !== ")") {
                    params.push(parseAssignment(state)); // parse a list with parameters
                    while(state.token === ","){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params.push(parseAssignment(state));
                    }
                }
                if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
                closeParams(state);
                getToken(state);
            } // create a new custom node
            // noinspection JSValidateTypes
            return new CustomNode(params);
        }
        return parseSymbol(state);
    }
    /**
   * parse symbols: functions, variables, constants, units
   * @return {Node} node
   * @private
   */ function parseSymbol(state) {
        var node, name;
        if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
            name = state.token;
            getToken(state);
            if ((0, $glBd7.hasOwnProperty)(CONSTANTS, name)) // true, false, null, ...
            node = new ConstantNode(CONSTANTS[name]);
            else if (NUMERIC_CONSTANTS.indexOf(name) !== -1) // NaN, Infinity
            node = new ConstantNode(numeric(name, "number"));
            else node = new SymbolNode(name);
             // parse function parameters and matrix index
            node = parseAccessors(state, node);
            return node;
        }
        return parseDoubleQuotesString(state);
    }
    /**
   * parse accessors:
   * - function invocation in round brackets (...), for example sqrt(2)
   * - index enclosed in square brackets [...], for example A[2,3]
   * - dot notation for properties, like foo.bar
   * @param {Object} state
   * @param {Node} node    Node on which to apply the parameters. If there
   *                       are no parameters in the expression, the node
   *                       itself is returned
   * @param {string[]} [types]  Filter the types of notations
   *                            can be ['(', '[', '.']
   * @return {Node} node
   * @private
   */ function parseAccessors(state, node, types) {
        var params;
        while((state.token === "(" || state.token === "[" || state.token === ".") && (!types || types.indexOf(state.token) !== -1)){
            // eslint-disable-line no-unmodified-loop-condition
            params = [];
            if (state.token === "(") {
                if ((0, $7E0JQ.isSymbolNode)(node) || (0, $7E0JQ.isAccessorNode)(node)) {
                    // function invocation like fn(2, 3) or obj.fn(2, 3)
                    openParams(state);
                    getToken(state);
                    if (state.token !== ")") {
                        params.push(parseAssignment(state)); // parse a list with parameters
                        while(state.token === ","){
                            // eslint-disable-line no-unmodified-loop-condition
                            getToken(state);
                            params.push(parseAssignment(state));
                        }
                    }
                    if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
                    closeParams(state);
                    getToken(state);
                    node = new FunctionNode(node, params);
                } else // implicit multiplication like (2+3)(4+5) or sqrt(2)(1+2)
                // don't parse it here but let it be handled by parseImplicitMultiplication
                // with correct precedence
                return node;
            } else if (state.token === "[") {
                // index notation like variable[2, 3]
                openParams(state);
                getToken(state);
                if (state.token !== "]") {
                    params.push(parseAssignment(state)); // parse a list with parameters
                    while(state.token === ","){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params.push(parseAssignment(state));
                    }
                }
                if (state.token !== "]") throw createSyntaxError(state, "Parenthesis ] expected");
                closeParams(state);
                getToken(state);
                node = new AccessorNode(node, new IndexNode(params));
            } else {
                // dot notation like variable.prop
                getToken(state);
                if (state.tokenType !== TOKENTYPE.SYMBOL) throw createSyntaxError(state, "Property name expected after dot");
                params.push(new ConstantNode(state.token));
                getToken(state);
                var dotNotation = true;
                node = new AccessorNode(node, new IndexNode(params, dotNotation));
            }
        }
        return node;
    }
    /**
   * Parse a double quotes string.
   * @return {Node} node
   * @private
   */ function parseDoubleQuotesString(state) {
        var node, str;
        if (state.token === '"') {
            str = parseDoubleQuotesStringToken(state); // create constant
            node = new ConstantNode(str); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseSingleQuotesString(state);
    }
    /**
   * Parse a string surrounded by double quotes "..."
   * @return {string}
   */ function parseDoubleQuotesStringToken(state) {
        var str = "";
        while(currentCharacter(state) !== "" && currentCharacter(state) !== '"'){
            if (currentCharacter(state) === "\\") {
                // escape character, immediately process the next
                // character to prevent stopping at a next '\"'
                str += currentCharacter(state);
                next(state);
            }
            str += currentCharacter(state);
            next(state);
        }
        getToken(state);
        if (state.token !== '"') throw createSyntaxError(state, 'End of string " expected');
        getToken(state);
        return JSON.parse('"' + str + '"'); // unescape escaped characters
    }
    /**
   * Parse a single quotes string.
   * @return {Node} node
   * @private
   */ function parseSingleQuotesString(state) {
        var node, str;
        if (state.token === "'") {
            str = parseSingleQuotesStringToken(state); // create constant
            node = new ConstantNode(str); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseMatrix(state);
    }
    /**
   * Parse a string surrounded by single quotes '...'
   * @return {string}
   */ function parseSingleQuotesStringToken(state) {
        var str = "";
        while(currentCharacter(state) !== "" && currentCharacter(state) !== "'"){
            if (currentCharacter(state) === "\\") {
                // escape character, immediately process the next
                // character to prevent stopping at a next '\''
                str += currentCharacter(state);
                next(state);
            }
            str += currentCharacter(state);
            next(state);
        }
        getToken(state);
        if (state.token !== "'") throw createSyntaxError(state, "End of string ' expected");
        getToken(state);
        return JSON.parse('"' + str + '"'); // unescape escaped characters
    }
    /**
   * parse the matrix
   * @return {Node} node
   * @private
   */ function parseMatrix(state) {
        var array, params, rows, cols;
        if (state.token === "[") {
            // matrix [...]
            openParams(state);
            getToken(state);
            if (state.token !== "]") {
                // this is a non-empty matrix
                var row = parseRow(state);
                if (state.token === ";") {
                    // 2 dimensional array
                    rows = 1;
                    params = [
                        row
                    ]; // the rows of the matrix are separated by dot-comma's
                    while(state.token === ";"){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params[rows] = parseRow(state);
                        rows++;
                    }
                    if (state.token !== "]") throw createSyntaxError(state, "End of matrix ] expected");
                    closeParams(state);
                    getToken(state); // check if the number of columns matches in all rows
                    cols = params[0].items.length;
                    for(var r = 1; r < rows; r++){
                        if (params[r].items.length !== cols) throw createError(state, "Column dimensions mismatch (" + params[r].items.length + " !== " + cols + ")");
                    }
                    array = new ArrayNode(params);
                } else {
                    // 1 dimensional vector
                    if (state.token !== "]") throw createSyntaxError(state, "End of matrix ] expected");
                    closeParams(state);
                    getToken(state);
                    array = row;
                }
            } else {
                // this is an empty matrix "[ ]"
                closeParams(state);
                getToken(state);
                array = new ArrayNode([]);
            }
            return parseAccessors(state, array);
        }
        return parseObject(state);
    }
    /**
   * Parse a single comma-separated row from a matrix, like 'a, b, c'
   * @return {ArrayNode} node
   */ function parseRow(state) {
        var params = [
            parseAssignment(state)
        ];
        var len = 1;
        while(state.token === ","){
            // eslint-disable-line no-unmodified-loop-condition
            getToken(state); // parse expression
            params[len] = parseAssignment(state);
            len++;
        }
        return new ArrayNode(params);
    }
    /**
   * parse an object, enclosed in angle brackets{...}, for example {value: 2}
   * @return {Node} node
   * @private
   */ function parseObject(state) {
        if (state.token === "{") {
            openParams(state);
            var key;
            var properties = {};
            do {
                getToken(state);
                if (state.token !== "}") {
                    // parse key
                    if (state.token === '"') key = parseDoubleQuotesStringToken(state);
                    else if (state.token === "'") key = parseSingleQuotesStringToken(state);
                    else if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
                        key = state.token;
                        getToken(state);
                    } else throw createSyntaxError(state, "Symbol or string expected as object key");
                     // parse key/value separator
                    if (state.token !== ":") throw createSyntaxError(state, "Colon : expected after object key");
                    getToken(state); // parse key
                    properties[key] = parseAssignment(state);
                }
            }while (state.token === ","); // eslint-disable-line no-unmodified-loop-condition
            if (state.token !== "}") throw createSyntaxError(state, "Comma , or bracket } expected after object value");
            closeParams(state);
            getToken(state);
            var node = new ObjectNode(properties); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseNumber(state);
    }
    /**
   * parse a number
   * @return {Node} node
   * @private
   */ function parseNumber(state) {
        var numberStr;
        if (state.tokenType === TOKENTYPE.NUMBER) {
            // this is a number
            numberStr = state.token;
            getToken(state);
            return new ConstantNode(numeric(numberStr, config.number));
        }
        return parseParentheses(state);
    }
    /**
   * parentheses
   * @return {Node} node
   * @private
   */ function parseParentheses(state) {
        var node; // check if it is a parenthesized expression
        if (state.token === "(") {
            // parentheses (...)
            openParams(state);
            getToken(state);
            node = parseAssignment(state); // start again
            if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
            closeParams(state);
            getToken(state);
            node = new ParenthesisNode(node);
            node = parseAccessors(state, node);
            return node;
        }
        return parseEnd(state);
    }
    /**
   * Evaluated when the expression is not yet ended but expected to end
   * @return {Node} res
   * @private
   */ function parseEnd(state) {
        if (state.token === "") // syntax error or unexpected end of expression
        throw createSyntaxError(state, "Unexpected end of expression");
        else throw createSyntaxError(state, "Value expected");
    }
    /**
   * Shortcut for getting the current row value (one based)
   * Returns the line of the currently handled expression
   * @private
   */ /* TODO: implement keeping track on the row number
  function row () {
    return null
  }
  */ /**
   * Shortcut for getting the current col value (one based)
   * Returns the column (position) where the last state.token starts
   * @private
   */ function col(state) {
        return state.index - state.token.length + 1;
    }
    /**
   * Create an error
   * @param {Object} state
   * @param {string} message
   * @return {SyntaxError} instantiated error
   * @private
   */ function createSyntaxError(state, message) {
        var c = col(state);
        var error = new SyntaxError(message + " (char " + c + ")");
        error["char"] = c;
        return error;
    }
    /**
   * Create an error
   * @param {Object} state
   * @param {string} message
   * @return {Error} instantiated error
   * @private
   */ function createError(state, message) {
        var c = col(state);
        var error = new SyntaxError(message + " (char " + c + ")");
        error["char"] = c;
        return error;
    }
    return parse;
});

});

parcelRegister("cCL9g", function(module, exports) {

$parcel$export(module.exports, "createParser", function () { return $930d9b5b3ebba1a6$export$88a1156fad04455f; });

var $jKx4O = parcelRequire("jKx4O");
var $930d9b5b3ebba1a6$var$name = "parser";
var $930d9b5b3ebba1a6$var$dependencies = [
    "typed",
    "Parser"
];
var $930d9b5b3ebba1a6$export$88a1156fad04455f = /* #__PURE__ */ (0, $jKx4O.factory)($930d9b5b3ebba1a6$var$name, $930d9b5b3ebba1a6$var$dependencies, function(_ref) {
    var typed = _ref.typed, Parser = _ref.Parser;
    /**
   * Create a parser. The function creates a new `math.Parser` object.
   *
   * Syntax:
   *
   *    math.parser()
   *
   * Examples:
   *
   *     const parser = new math.parser()
   *
   *     // evaluate expressions
   *     const a = parser.evaluate('sqrt(3^2 + 4^2)') // 5
   *     const b = parser.evaluate('sqrt(-4)')        // 2i
   *     const c = parser.evaluate('2 inch in cm')    // 5.08 cm
   *     const d = parser.evaluate('cos(45 deg)')     // 0.7071067811865476
   *
   *     // define variables and functions
   *     parser.evaluate('x = 7 / 2')                 // 3.5
   *     parser.evaluate('x + 3')                     // 6.5
   *     parser.evaluate('function f(x, y) = x^y')    // f(x, y)
   *     parser.evaluate('f(2, 3)')                   // 8
   *
   *     // get and set variables and functions
   *     const x = parser.get('x')                // 7
   *     const f = parser.get('f')                // function
   *     const g = f(3, 2)                        // 9
   *     parser.set('h', 500)
   *     const i = parser.evaluate('h / 2')       // 250
   *     parser.set('hello', function (name) {
   *       return 'hello, ' + name + '!'
   *     })
   *     parser.evaluate('hello("user")')         // "hello, user!"
   *
   *     // clear defined functions and variables
   *     parser.clear()
   *
   * See also:
   *
   *    evaluate, compile, parse
   *
   * @return {Parser} Parser
   */ return typed($930d9b5b3ebba1a6$var$name, {
        "": function _() {
            return new Parser();
        }
    });
});

});

parcelRegister("GJUrb", function(module, exports) {

$parcel$export(module.exports, "createParserClass", function () { return $080788fc5d4ffe55$export$17c8a99aaef91654; });

var $jKx4O = parcelRequire("jKx4O");

var $glBd7 = parcelRequire("glBd7");

var $i3n6j = parcelRequire("i3n6j");

var $9okwi = parcelRequire("9okwi");
var $080788fc5d4ffe55$var$name = "Parser";
var $080788fc5d4ffe55$var$dependencies = [
    "parse"
];
var $080788fc5d4ffe55$export$17c8a99aaef91654 = /* #__PURE__ */ (0, $jKx4O.factory)($080788fc5d4ffe55$var$name, $080788fc5d4ffe55$var$dependencies, function(_ref) {
    var parse = _ref.parse;
    /**
   * @constructor Parser
   * Parser contains methods to evaluate or parse expressions, and has a number
   * of convenience methods to get, set, and remove variables from memory. Parser
   * keeps a scope containing variables in memory, which is used for all
   * evaluations.
   *
   * Methods:
   *    const result = parser.evaluate(expr)  // evaluate an expression
   *    const value = parser.get(name)        // retrieve a variable from the parser
   *    const values = parser.getAll()        // retrieve all defined variables
   *    parser.set(name, value)               // set a variable in the parser
   *    parser.remove(name)                   // clear a variable from the
   *                                          // parsers scope
   *    parser.clear()                        // clear the parsers scope
   *
   * Example usage:
   *    const parser = new Parser()
   *    // Note: there is a convenience method which can be used instead:
   *    // const parser = new math.parser()
   *
   *    // evaluate expressions
   *    parser.evaluate('sqrt(3^2 + 4^2)')        // 5
   *    parser.evaluate('sqrt(-4)')               // 2i
   *    parser.evaluate('2 inch in cm')           // 5.08 cm
   *    parser.evaluate('cos(45 deg)')            // 0.7071067811865476
   *
   *    // define variables and functions
   *    parser.evaluate('x = 7 / 2')              // 3.5
   *    parser.evaluate('x + 3')                  // 6.5
   *    parser.evaluate('function f(x, y) = x^y') // f(x, y)
   *    parser.evaluate('f(2, 3)')                // 8
   *
   *    // get and set variables and functions
   *    const x = parser.get('x')                 // 7
   *    const f = parser.get('f')                 // function
   *    const g = f(3, 2)                         // 9
   *    parser.set('h', 500)
   *    const i = parser.evaluate('h / 2')        // 250
   *    parser.set('hello', function (name) {
   *        return 'hello, ' + name + '!'
   *    })
   *    parser.evaluate('hello("user")')          // "hello, user!"
   *
   *    // clear defined functions and variables
   *    parser.clear()
   *
   */ function Parser() {
        if (!(this instanceof Parser)) throw new SyntaxError("Constructor must be called with the new operator");
        this.scope = {};
    }
    /**
   * Attach type information
   */ Parser.prototype.type = "Parser";
    Parser.prototype.isParser = true;
    /**
   * Parse an expression and return the parsed function node.
   * The node tree can be compiled via `code = node.compile(math)`,
   * and the compiled code can be executed as `code.evaluate([scope])`
   * @param {string} expr
   * @return {Node} node
   * @throws {Error}
   */ Parser.prototype.parse = function(expr) {
        throw new Error("Parser.parse is deprecated. Use math.parse instead.");
    };
    /**
   * Parse and compile an expression, return the compiled javascript code.
   * The node can be evaluated via code.evaluate([scope])
   * @param {string} expr
   * @return {{evaluate: function}} code
   * @throws {Error}
   */ Parser.prototype.compile = function(expr) {
        throw new Error("Parser.compile is deprecated. Use math.compile instead.");
    };
    /**
   * Parse and evaluate the given expression
   * @param {string} expr   A string containing an expression, for example "2+3"
   * @return {*} result     The result, or undefined when the expression was empty
   * @throws {Error}
   */ Parser.prototype.evaluate = function(expr) {
        // TODO: validate arguments
        return parse(expr).compile().evaluate(this.scope);
    };
    /**
   * Parse and evaluate the given expression
   * @param {string} expr   A string containing an expression, for example "2+3"
   * @return {*} result     The result, or undefined when the expression was empty
   * @throws {Error}
   */ // TODO: Deprecated since v6.0.0. Clean up some day
    Parser.prototype.eval = function(expr) {
        (0, $9okwi.warnOnce)("Method Parser.eval is renamed to Parser.evaluate. Please use the new method name.");
        return this.evaluate(expr);
    };
    /**
   * Get a variable (a function or variable) by name from the parsers scope.
   * Returns undefined when not found
   * @param {string} name
   * @return {* | undefined} value
   */ Parser.prototype.get = function(name) {
        // TODO: validate arguments
        return name in this.scope ? (0, $i3n6j.getSafeProperty)(this.scope, name) : undefined;
    };
    /**
   * Get a map with all defined variables
   * @return {Object} values
   */ Parser.prototype.getAll = function() {
        return (0, $glBd7.extend)({}, this.scope);
    };
    /**
   * Set a symbol (a function or variable) by name from the parsers scope.
   * @param {string} name
   * @param {* | undefined} value
   */ Parser.prototype.set = function(name, value) {
        // TODO: validate arguments
        return (0, $i3n6j.setSafeProperty)(this.scope, name, value);
    };
    /**
   * Remove a variable from the parsers scope
   * @param {string} name
   */ Parser.prototype.remove = function(name) {
        // TODO: validate arguments
        delete this.scope[name];
    };
    /**
   * Clear the scope with variables and functions
   */ Parser.prototype.clear = function() {
        for(var _name in this.scope)if ((0, $glBd7.hasOwnProperty)(this.scope, _name)) delete this.scope[_name];
    };
    return Parser;
}, {
    isClass: true
});

});

parcelRegister("lJhsM", function(module, exports) {

$parcel$export(module.exports, "createRangeNode", function () { return $fd1b58c08f2467d1$export$fb6d9b21e29b8d46; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $7OD47 = parcelRequire("7OD47");
var $fd1b58c08f2467d1$var$name = "RangeNode";
var $fd1b58c08f2467d1$var$dependencies = [
    "Node"
];
var $fd1b58c08f2467d1$export$fb6d9b21e29b8d46 = /* #__PURE__ */ (0, $jKx4O.factory)($fd1b58c08f2467d1$var$name, $fd1b58c08f2467d1$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * @constructor RangeNode
   * @extends {Node}
   * create a range
   * @param {Node} start  included lower-bound
   * @param {Node} end    included upper-bound
   * @param {Node} [step] optional step
   */ function RangeNode(start, end, step) {
        if (!(this instanceof RangeNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate inputs
        if (!(0, $7E0JQ.isNode)(start)) throw new TypeError("Node expected");
        if (!(0, $7E0JQ.isNode)(end)) throw new TypeError("Node expected");
        if (step && !(0, $7E0JQ.isNode)(step)) throw new TypeError("Node expected");
        if (arguments.length > 3) throw new Error("Too many arguments");
        this.start = start; // included lower-bound
        this.end = end; // included upper-bound
        this.step = step || null; // optional step
    }
    RangeNode.prototype = new Node();
    RangeNode.prototype.type = "RangeNode";
    RangeNode.prototype.isRangeNode = true;
    /**
   * Check whether the RangeNode needs the `end` symbol to be defined.
   * This end is the size of the Matrix in current dimension.
   * @return {boolean}
   */ RangeNode.prototype.needsEnd = function() {
        // find all `end` symbols in this RangeNode
        var endSymbols = this.filter(function(node) {
            return (0, $7E0JQ.isSymbolNode)(node) && node.name === "end";
        });
        return endSymbols.length > 0;
    };
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ RangeNode.prototype._compile = function(math, argNames) {
        var range = math.range;
        var evalStart = this.start._compile(math, argNames);
        var evalEnd = this.end._compile(math, argNames);
        if (this.step) {
            var evalStep = this.step._compile(math, argNames);
            return function evalRangeNode(scope, args, context) {
                return range(evalStart(scope, args, context), evalEnd(scope, args, context), evalStep(scope, args, context));
            };
        } else return function evalRangeNode(scope, args, context) {
            return range(evalStart(scope, args, context), evalEnd(scope, args, context));
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ RangeNode.prototype.forEach = function(callback) {
        callback(this.start, "start", this);
        callback(this.end, "end", this);
        if (this.step) callback(this.step, "step", this);
    };
    /**
   * Create a new RangeNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {RangeNode} Returns a transformed copy of the node
   */ RangeNode.prototype.map = function(callback) {
        return new RangeNode(this._ifNode(callback(this.start, "start", this)), this._ifNode(callback(this.end, "end", this)), this.step && this._ifNode(callback(this.step, "step", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {RangeNode}
   */ RangeNode.prototype.clone = function() {
        return new RangeNode(this.start, this.end, this.step && this.step);
    };
    /**
   * Calculate the necessary parentheses
   * @param {Node} node
   * @param {string} parenthesis
   * @return {Object} parentheses
   * @private
   */ function calculateNecessaryParentheses(node, parenthesis) {
        var precedence = (0, $7OD47.getPrecedence)(node, parenthesis);
        var parens = {};
        var startPrecedence = (0, $7OD47.getPrecedence)(node.start, parenthesis);
        parens.start = startPrecedence !== null && startPrecedence <= precedence || parenthesis === "all";
        if (node.step) {
            var stepPrecedence = (0, $7OD47.getPrecedence)(node.step, parenthesis);
            parens.step = stepPrecedence !== null && stepPrecedence <= precedence || parenthesis === "all";
        }
        var endPrecedence = (0, $7OD47.getPrecedence)(node.end, parenthesis);
        parens.end = endPrecedence !== null && endPrecedence <= precedence || parenthesis === "all";
        return parens;
    }
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ RangeNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis); // format string as start:step:stop
        var str;
        var start = this.start.toString(options);
        if (parens.start) start = "(" + start + ")";
        str = start;
        if (this.step) {
            var step = this.step.toString(options);
            if (parens.step) step = "(" + step + ")";
            str += ":" + step;
        }
        var end = this.end.toString(options);
        if (parens.end) end = "(" + end + ")";
        str += ":" + end;
        return str;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ RangeNode.prototype.toJSON = function() {
        return {
            mathjs: "RangeNode",
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate an RangeNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
   *                       where mathjs is optional
   * @returns {RangeNode}
   */ RangeNode.fromJSON = function(json) {
        return new RangeNode(json.start, json.end, json.step);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ RangeNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis); // format string as start:step:stop
        var str;
        var start = this.start.toHTML(options);
        if (parens.start) start = '<span class="math-parenthesis math-round-parenthesis">(</span>' + start + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        str = start;
        if (this.step) {
            var step = this.step.toHTML(options);
            if (parens.step) step = '<span class="math-parenthesis math-round-parenthesis">(</span>' + step + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            str += '<span class="math-operator math-range-operator">:</span>' + step;
        }
        var end = this.end.toHTML(options);
        if (parens.end) end = '<span class="math-parenthesis math-round-parenthesis">(</span>' + end + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        str += '<span class="math-operator math-range-operator">:</span>' + end;
        return str;
    };
    /**
   * Get LaTeX representation
   * @params {Object} options
   * @return {string} str
   */ RangeNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis);
        var str = this.start.toTex(options);
        if (parens.start) str = "\\left(".concat(str, "\\right)");
        if (this.step) {
            var step = this.step.toTex(options);
            if (parens.step) step = "\\left(".concat(step, "\\right)");
            str += ":" + step;
        }
        var end = this.end.toTex(options);
        if (parens.end) end = "\\left(".concat(end, "\\right)");
        str += ":" + end;
        return str;
    };
    return RangeNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("a5N99", function(module, exports) {

$parcel$export(module.exports, "createRangeTransform", function () { return $01e56d65213f6f56$export$af4628cd15bbfbf2; });

var $jKx4O = parcelRequire("jKx4O");

var $h2sA3 = parcelRequire("h2sA3");
var $01e56d65213f6f56$var$name = "range";
var $01e56d65213f6f56$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq"
];
var $01e56d65213f6f56$export$af4628cd15bbfbf2 = /* #__PURE__ */ (0, $jKx4O.factory)($01e56d65213f6f56$var$name, $01e56d65213f6f56$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, bignumber = _ref.bignumber, smaller = _ref.smaller, smallerEq = _ref.smallerEq, larger = _ref.larger, largerEq = _ref.largerEq;
    var range = (0, $h2sA3.createRange)({
        typed: typed,
        config: config,
        matrix: matrix,
        bignumber: bignumber,
        smaller: smaller,
        smallerEq: smallerEq,
        larger: larger,
        largerEq: largerEq
    });
    /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed("range", {
        "...any": function any(args) {
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if (typeof last !== "boolean") // append a parameter includeEnd=true
            args.push(true);
            return range.apply(null, args);
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("h2sA3", function(module, exports) {

$parcel$export(module.exports, "createRange", function () { return $c678cb161cafe20b$export$d372f2f3c4d1b8e5; });

var $jKx4O = parcelRequire("jKx4O");

var $94t5G = parcelRequire("94t5G");
var $c678cb161cafe20b$var$name = "range";
var $c678cb161cafe20b$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq"
];
var $c678cb161cafe20b$export$d372f2f3c4d1b8e5 = /* #__PURE__ */ (0, $jKx4O.factory)($c678cb161cafe20b$var$name, $c678cb161cafe20b$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, bignumber = _ref.bignumber, smaller = _ref.smaller, smallerEq = _ref.smallerEq, larger = _ref.larger, largerEq = _ref.largerEq;
    /**
   * Create an array from a range.
   * By default, the range end is excluded. This can be customized by providing
   * an extra parameter `includeEnd`.
   *
   * Syntax:
   *
   *     math.range(str [, includeEnd])               // Create a range from a string,
   *                                                  // where the string contains the
   *                                                  // start, optional step, and end,
   *                                                  // separated by a colon.
   *     math.range(start, end [, includeEnd])        // Create a range with start and
   *                                                  // end and a step size of 1.
   *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
   *                                                  // and end.
   *
   * Where:
   *
   * - `str: string`
   *   A string 'start:end' or 'start:step:end'
   * - `start: {number | BigNumber}`
   *   Start of the range
   * - `end: number | BigNumber`
   *   End of the range, excluded by default, included when parameter includeEnd=true
   * - `step: number | BigNumber`
   *   Step size. Default value is 1.
   * - `includeEnd: boolean`
   *   Option to specify whether to include the end or not. False by default.
   *
   * Examples:
   *
   *     math.range(2, 6)        // [2, 3, 4, 5]
   *     math.range(2, -3, -1)   // [2, 1, 0, -1, -2]
   *     math.range('2:1:6')     // [2, 3, 4, 5]
   *     math.range(2, 6, true)  // [2, 3, 4, 5, 6]
   *
   * See also:
   *
   *     ones, zeros, size, subset
   *
   * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
   * @return {Array | Matrix} range
   */ return typed($c678cb161cafe20b$var$name, {
        // TODO: simplify signatures when typed-function supports default values and optional arguments
        // TODO: a number or boolean should not be converted to string here
        string: _strRange,
        "string, boolean": _strRange,
        "number, number": function numberNumber(start, end) {
            return _out(_rangeEx(start, end, 1));
        },
        "number, number, number": function numberNumberNumber(start, end, step) {
            return _out(_rangeEx(start, end, step));
        },
        "number, number, boolean": function numberNumberBoolean(start, end, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, 1)) : _out(_rangeEx(start, end, 1));
        },
        "number, number, number, boolean": function numberNumberNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, step)) : _out(_rangeEx(start, end, step));
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(start, end) {
            var BigNumber = start.constructor;
            return _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        "BigNumber, BigNumber, BigNumber": function BigNumberBigNumberBigNumber(start, end, step) {
            return _out(_bigRangeEx(start, end, step));
        },
        "BigNumber, BigNumber, boolean": function BigNumberBigNumberBoolean(start, end, includeEnd) {
            var BigNumber = start.constructor;
            return includeEnd ? _out(_bigRangeInc(start, end, new BigNumber(1))) : _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        "BigNumber, BigNumber, BigNumber, boolean": function BigNumberBigNumberBigNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_bigRangeInc(start, end, step)) : _out(_bigRangeEx(start, end, step));
        }
    });
    function _out(arr) {
        if (config.matrix === "Matrix") return matrix ? matrix(arr) : (0, $94t5G.noMatrix)();
        return arr;
    }
    function _strRange(str, includeEnd) {
        var r = _parse(str);
        if (!r) throw new SyntaxError('String "' + str + '" is no valid range');
        var fn;
        if (config.number === "BigNumber") {
            if (bignumber === undefined) (0, $94t5G.noBignumber)();
            fn = includeEnd ? _bigRangeInc : _bigRangeEx;
            return _out(fn(bignumber(r.start), bignumber(r.end), bignumber(r.step)));
        } else {
            fn = includeEnd ? _rangeInc : _rangeEx;
            return _out(fn(r.start, r.end, r.step));
        }
    }
    /**
   * Create a range with numbers. End is excluded
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeEx(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smaller(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(larger(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with numbers. End is included
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeInc(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smallerEq(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(largerEq(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is excluded
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeEx(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smaller(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(larger(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is included
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeInc(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smallerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(largerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @param {string} str
   * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
   * @private
   */ function _parse(str) {
        var args = str.split(":"); // number
        var nums = args.map(function(arg) {
            // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
            return Number(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return {
                    start: nums[0],
                    end: nums[1],
                    step: 1
                };
            case 3:
                return {
                    start: nums[0],
                    end: nums[2],
                    step: nums[1]
                };
            default:
                return null;
        }
    }
});

});
parcelRegister("94t5G", function(module, exports) {

$parcel$export(module.exports, "noBignumber", function () { return $01b44eabaa1494d2$export$f0829713dc162a8; });
$parcel$export(module.exports, "noFraction", function () { return $01b44eabaa1494d2$export$9978fd42ef220ba0; });
$parcel$export(module.exports, "noMatrix", function () { return $01b44eabaa1494d2$export$b81416cb7ecca475; });
function $01b44eabaa1494d2$export$f0829713dc162a8() {
    throw new Error('No "bignumber" implementation available');
}
function $01b44eabaa1494d2$export$9978fd42ef220ba0() {
    throw new Error('No "fraction" implementation available');
}
function $01b44eabaa1494d2$export$b81416cb7ecca475() {
    throw new Error('No "matrix" implementation available');
}
function $01b44eabaa1494d2$export$a38f8cf2e48f2bd() {
    throw new Error('No "index" implementation available');
}
function $01b44eabaa1494d2$export$32411ef9704d5eea() {
    throw new Error('No "matrix" implementation available');
}

});



parcelRegister("dOa4M", function(module, exports) {

$parcel$export(module.exports, "createRationalize", function () { return $a0d7c2c6442ca672$export$abd0968f5b11b2a8; });

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");

var $fj1VV = parcelRequire("fj1VV");

var $crDbf = parcelRequire("crDbf");
var $a0d7c2c6442ca672$var$name = "rationalize";
var $a0d7c2c6442ca672$var$dependencies = [
    "config",
    "typed",
    "equal",
    "isZero",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "parse",
    "simplify",
    "?bignumber",
    "?fraction",
    "mathWithTransform",
    "ConstantNode",
    "OperatorNode",
    "FunctionNode",
    "SymbolNode",
    "ParenthesisNode"
];
var $a0d7c2c6442ca672$export$abd0968f5b11b2a8 = /* #__PURE__ */ (0, $jKx4O.factory)($a0d7c2c6442ca672$var$name, $a0d7c2c6442ca672$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, equal = _ref.equal, isZero = _ref.isZero, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, pow = _ref.pow, parse = _ref.parse, simplify = _ref.simplify, fraction = _ref.fraction, bignumber = _ref.bignumber, mathWithTransform = _ref.mathWithTransform, ConstantNode = _ref.ConstantNode, OperatorNode = _ref.OperatorNode, FunctionNode = _ref.FunctionNode, SymbolNode = _ref.SymbolNode, ParenthesisNode = _ref.ParenthesisNode;
    var simplifyConstant = (0, $fj1VV.createSimplifyConstant)({
        typed: typed,
        config: config,
        mathWithTransform: mathWithTransform,
        fraction: fraction,
        bignumber: bignumber,
        ConstantNode: ConstantNode,
        OperatorNode: OperatorNode,
        FunctionNode: FunctionNode,
        SymbolNode: SymbolNode
    });
    var simplifyCore = (0, $crDbf.createSimplifyCore)({
        equal: equal,
        isZero: isZero,
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide,
        pow: pow,
        ConstantNode: ConstantNode,
        OperatorNode: OperatorNode,
        FunctionNode: FunctionNode,
        ParenthesisNode: ParenthesisNode
    });
    /**
   * Transform a rationalizable expression in a rational fraction.
   * If rational fraction is one variable polynomial then converts
   * the numerator and denominator in canonical form, with decreasing
   * exponents, returning the coefficients of numerator.
   *
   * Syntax:
   *
   *     rationalize(expr)
   *     rationalize(expr, detailed)
   *     rationalize(expr, scope)
   *     rationalize(expr, scope, detailed)
   *
   * Examples:
   *
   *     math.rationalize('sin(x)+y')
   *                   //  Error: There is an unsolved function call
   *     math.rationalize('2x/y - y/(x+1)')
   *                   // (2*x^2-y^2+2*x)/(x*y+y)
   *     math.rationalize('(2x+1)^6')
   *                   // 64*x^6+192*x^5+240*x^4+160*x^3+60*x^2+12*x+1
   *     math.rationalize('2x/( (2x-1) / (3x+2) ) - 5x/ ( (3x+4) / (2x^2-5) ) + 3')
   *                   // -20*x^4+28*x^3+104*x^2+6*x-12)/(6*x^2+5*x-4)
   *     math.rationalize('x/(1-x)/(x-2)/(x-3)/(x-4) + 2x/ ( (1-2x)/(2-3x) )/ ((3-4x)/(4-5x) )') =
   *                   // (-30*x^7+344*x^6-1506*x^5+3200*x^4-3472*x^3+1846*x^2-381*x)/
   *                   //     (-8*x^6+90*x^5-383*x^4+780*x^3-797*x^2+390*x-72)
   *
   *     math.rationalize('x+x+x+y',{y:1}) // 3*x+1
   *     math.rationalize('x+x+x+y',{})    // 3*x+y
   *
   *     const ret = math.rationalize('x+x+x+y',{},true)
   *                   // ret.expression=3*x+y, ret.variables = ["x","y"]
   *     const ret = math.rationalize('-2+5x^2',{},true)
   *                   // ret.expression=5*x^2-2, ret.variables = ["x"], ret.coefficients=[-2,0,5]
   *
   * See also:
   *
   *     simplify
   *
   * @param  {Node|string} expr    The expression to check if is a polynomial expression
   * @param  {Object|boolean}      optional scope of expression or true for already evaluated rational expression at input
   * @param  {Boolean}  detailed   optional True if return an object, false if return expression node (default)
   *
   * @return {Object | Node}    The rational polynomial of `expr` or na object
   *            {Object}
   *              {Expression Node} expression: node simplified expression
   *              {Expression Node} numerator: simplified numerator of expression
   *              {Expression Node | boolean} denominator: simplified denominator or false (if there is no denominator)
   *              {Array}           variables:  variable names
   *              {Array}           coefficients: coefficients of numerator sorted by increased exponent
   *           {Expression Node}  node simplified expression
   *
   */ var rationalize = typed($a0d7c2c6442ca672$var$name, {
        string: function string(expr) {
            return rationalize(parse(expr), {}, false);
        },
        "string, boolean": function stringBoolean(expr, detailed) {
            return rationalize(parse(expr), {}, detailed);
        },
        "string, Object": function stringObject(expr, scope) {
            return rationalize(parse(expr), scope, false);
        },
        "string, Object, boolean": function stringObjectBoolean(expr, scope, detailed) {
            return rationalize(parse(expr), scope, detailed);
        },
        Node: function Node(expr) {
            return rationalize(expr, {}, false);
        },
        "Node, boolean": function NodeBoolean(expr, detailed) {
            return rationalize(expr, {}, detailed);
        },
        "Node, Object": function NodeObject(expr, scope) {
            return rationalize(expr, scope, false);
        },
        "Node, Object, boolean": function NodeObjectBoolean(expr, scope, detailed) {
            var setRules = rulesRationalize(); // Rules for change polynomial in near canonical form
            var polyRet = polynomial(expr, scope, true, setRules.firstRules); // Check if expression is a rationalizable polynomial
            var nVars = polyRet.variables.length;
            expr = polyRet.expression;
            if (nVars >= 1) {
                // If expression in not a constant
                expr = expandPower(expr); // First expand power of polynomials (cannot be made from rules!)
                var sBefore; // Previous expression
                var rules;
                var eDistrDiv = true;
                var redoInic = false;
                expr = simplify(expr, setRules.firstRules, {}, {
                    exactFractions: false
                }); // Apply the initial rules, including succ div rules
                var s;
                while(true){
                    // Apply alternately  successive division rules and distr.div.rules
                    rules = eDistrDiv ? setRules.distrDivRules : setRules.sucDivRules;
                    expr = simplify(expr, rules); // until no more changes
                    eDistrDiv = !eDistrDiv; // Swap between Distr.Div and Succ. Div. Rules
                    s = expr.toString();
                    if (s === sBefore) break; // No changes : end of the loop
                    redoInic = true;
                    sBefore = s;
                }
                if (redoInic) // Apply first rules again without succ div rules (if there are changes)
                expr = simplify(expr, setRules.firstRulesAgain, {}, {
                    exactFractions: false
                });
                expr = simplify(expr, setRules.finalRules, {}, {
                    exactFractions: false
                }); // Apply final rules
            } // NVars >= 1
            var coefficients = [];
            var retRationalize = {};
            if (expr.type === "OperatorNode" && expr.isBinary() && expr.op === "/") {
                // Separate numerator from denominator
                if (nVars === 1) {
                    expr.args[0] = polyToCanonical(expr.args[0], coefficients);
                    expr.args[1] = polyToCanonical(expr.args[1]);
                }
                if (detailed) {
                    retRationalize.numerator = expr.args[0];
                    retRationalize.denominator = expr.args[1];
                }
            } else {
                if (nVars === 1) expr = polyToCanonical(expr, coefficients);
                if (detailed) {
                    retRationalize.numerator = expr;
                    retRationalize.denominator = null;
                }
            } // nVars
            if (!detailed) return expr;
            retRationalize.coefficients = coefficients;
            retRationalize.variables = polyRet.variables;
            retRationalize.expression = expr;
            return retRationalize;
        } // ^^^^^^^ end of rationalize ^^^^^^^^
    }); // end of typed rationalize
    /**
   *  Function to simplify an expression using an optional scope and
   *  return it if the expression is a polynomial expression, i.e.
   *  an expression with one or more variables and the operators
   *  +, -, *, and ^, where the exponent can only be a positive integer.
   *
   * Syntax:
   *
   *     polynomial(expr,scope,extended, rules)
   *
   * @param  {Node | string} expr     The expression to simplify and check if is polynomial expression
   * @param  {object} scope           Optional scope for expression simplification
   * @param  {boolean} extended       Optional. Default is false. When true allows divide operator.
   * @param  {array}  rules           Optional. Default is no rule.
   *
   *
   * @return {Object}
   *            {Object} node:   node simplified expression
   *            {Array}  variables:  variable names
   */ function polynomial(expr, scope, extended, rules) {
        var variables = [];
        var node = simplify(expr, rules, scope, {
            exactFractions: false
        }); // Resolves any variables and functions with all defined parameters
        extended = !!extended;
        var oper = "+-*" + (extended ? "/" : "");
        recPoly(node);
        var retFunc = {};
        retFunc.expression = node;
        retFunc.variables = variables;
        return retFunc; // -------------------------------------------------------------------------------------------------------
        /**
     *  Function to simplify an expression using an optional scope and
     *  return it if the expression is a polynomial expression, i.e.
     *  an expression with one or more variables and the operators
     *  +, -, *, and ^, where the exponent can only be a positive integer.
     *
     * Syntax:
     *
     *     recPoly(node)
     *
     *
     * @param  {Node} node               The current sub tree expression in recursion
     *
     * @return                           nothing, throw an exception if error
     */ function recPoly(node) {
            var tp = node.type; // node type
            if (tp === "FunctionNode") // No function call in polynomial expression
            throw new Error("There is an unsolved function call");
            else if (tp === "OperatorNode") {
                if (node.op === "^") {
                    // TODO: handle negative exponents like in '1/x^(-2)'
                    if (node.args[1].type !== "ConstantNode" || !(0, $5wlxr.isInteger)(parseFloat(node.args[1].value))) throw new Error("There is a non-integer exponent");
                    else recPoly(node.args[0]);
                } else {
                    if (oper.indexOf(node.op) === -1) throw new Error("Operator " + node.op + " invalid in polynomial expression");
                    for(var i = 0; i < node.args.length; i++)recPoly(node.args[i]);
                } // type of operator
            } else if (tp === "SymbolNode") {
                var _name = node.name; // variable name
                var pos = variables.indexOf(_name);
                if (pos === -1) // new variable in expression
                variables.push(_name);
            } else if (tp === "ParenthesisNode") recPoly(node.content);
            else if (tp !== "ConstantNode") throw new Error("type " + tp + " is not allowed in polynomial expression");
        } // end of recPoly
    } // end of polynomial
    // ---------------------------------------------------------------------------------------
    /**
   * Return a rule set to rationalize an polynomial expression in rationalize
   *
   * Syntax:
   *
   *     rulesRationalize()
   *
   * @return {array}        rule set to rationalize an polynomial expression
   */ function rulesRationalize() {
        var oldRules = [
            simplifyCore,
            {
                l: "n+n",
                r: "2*n"
            },
            {
                l: "n+-n",
                r: "0"
            },
            simplifyConstant,
            {
                l: "n*(n1^-1)",
                r: "n/n1"
            },
            {
                l: "n*n1^-n2",
                r: "n/n1^n2"
            },
            {
                l: "n1^-1",
                r: "1/n1"
            },
            {
                l: "n*(n1/n2)",
                r: "(n*n1)/n2"
            },
            {
                l: "1*n",
                r: "n"
            }
        ];
        var rulesFirst = [
            {
                l: "(-n1)/(-n2)",
                r: "n1/n2"
            },
            {
                l: "(-n1)*(-n2)",
                r: "n1*n2"
            },
            {
                l: "n1--n2",
                r: "n1+n2"
            },
            {
                l: "n1-n2",
                r: "n1+(-n2)"
            },
            {
                l: "(n1+n2)*n3",
                r: "(n1*n3 + n2*n3)"
            },
            {
                l: "n1*(n2+n3)",
                r: "(n1*n2+n1*n3)"
            },
            {
                l: "c1*n + c2*n",
                r: "(c1+c2)*n"
            },
            {
                l: "c1*n + n",
                r: "(c1+1)*n"
            },
            {
                l: "c1*n - c2*n",
                r: "(c1-c2)*n"
            },
            {
                l: "c1*n - n",
                r: "(c1-1)*n"
            },
            {
                l: "v/c",
                r: "(1/c)*v"
            },
            {
                l: "v/-c",
                r: "-(1/c)*v"
            },
            {
                l: "-v*-c",
                r: "c*v"
            },
            {
                l: "-v*c",
                r: "-c*v"
            },
            {
                l: "v*-c",
                r: "-c*v"
            },
            {
                l: "v*c",
                r: "c*v"
            },
            {
                l: "-(-n1*n2)",
                r: "(n1*n2)"
            },
            {
                l: "-(n1*n2)",
                r: "(-n1*n2)"
            },
            {
                l: "-(-n1+n2)",
                r: "(n1-n2)"
            },
            {
                l: "-(n1+n2)",
                r: "(-n1-n2)"
            },
            {
                l: "(n1^n2)^n3",
                r: "(n1^(n2*n3))"
            },
            {
                l: "-(-n1/n2)",
                r: "(n1/n2)"
            },
            {
                l: "-(n1/n2)",
                r: "(-n1/n2)"
            }
        ]; // Divisao and Unary
        var rulesDistrDiv = [
            {
                l: "(n1/n2 + n3/n4)",
                r: "((n1*n4 + n3*n2)/(n2*n4))"
            },
            {
                l: "(n1/n2 + n3)",
                r: "((n1 + n3*n2)/n2)"
            },
            {
                l: "(n1 + n2/n3)",
                r: "((n1*n3 + n2)/n3)"
            }
        ]; // Sum fraction with number 1
        var rulesSucDiv = [
            {
                l: "(n1/(n2/n3))",
                r: "((n1*n3)/n2)"
            },
            {
                l: "(n1/n2/n3)",
                r: "(n1/(n2*n3))"
            }
        ];
        var setRules = {}; // rules set in 4 steps.
        // All rules => infinite loop
        // setRules.allRules =oldRules.concat(rulesFirst,rulesDistrDiv,rulesSucDiv)
        setRules.firstRules = oldRules.concat(rulesFirst, rulesSucDiv); // First rule set
        setRules.distrDivRules = rulesDistrDiv; // Just distr. div. rules
        setRules.sucDivRules = rulesSucDiv; // Jus succ. div. rules
        setRules.firstRulesAgain = oldRules.concat(rulesFirst); // Last rules set without succ. div.
        // Division simplification
        // Second rule set.
        // There is no aggregate expression with parentesis, but the only variable can be scattered.
        setRules.finalRules = [
            simplifyCore,
            {
                l: "n*-n",
                r: "-n^2"
            },
            {
                l: "n*n",
                r: "n^2"
            },
            simplifyConstant,
            {
                l: "n*-n^n1",
                r: "-n^(n1+1)"
            },
            {
                l: "n*n^n1",
                r: "n^(n1+1)"
            },
            {
                l: "n^n1*-n^n2",
                r: "-n^(n1+n2)"
            },
            {
                l: "n^n1*n^n2",
                r: "n^(n1+n2)"
            },
            {
                l: "n^n1*-n",
                r: "-n^(n1+1)"
            },
            {
                l: "n^n1*n",
                r: "n^(n1+1)"
            },
            {
                l: "n^n1/-n",
                r: "-n^(n1-1)"
            },
            {
                l: "n^n1/n",
                r: "n^(n1-1)"
            },
            {
                l: "n/-n^n1",
                r: "-n^(1-n1)"
            },
            {
                l: "n/n^n1",
                r: "n^(1-n1)"
            },
            {
                l: "n^n1/-n^n2",
                r: "n^(n1-n2)"
            },
            {
                l: "n^n1/n^n2",
                r: "n^(n1-n2)"
            },
            {
                l: "n1+(-n2*n3)",
                r: "n1-n2*n3"
            },
            {
                l: "v*(-c)",
                r: "-c*v"
            },
            {
                l: "n1+-n2",
                r: "n1-n2"
            },
            {
                l: "v*c",
                r: "c*v"
            },
            {
                l: "(n1^n2)^n3",
                r: "(n1^(n2*n3))"
            } // Power to Power
        ];
        return setRules;
    } // End rulesRationalize
    // ---------------------------------------------------------------------------------------
    /**
   *  Expand recursively a tree node for handling with expressions with exponents
   *  (it's not for constants, symbols or functions with exponents)
   *  PS: The other parameters are internal for recursion
   *
   * Syntax:
   *
   *     expandPower(node)
   *
   * @param  {Node} node         Current expression node
   * @param  {node} parent       Parent current node inside the recursion
   * @param  (int}               Parent number of chid inside the rercursion
   *
   * @return {node}        node expression with all powers expanded.
   */ function expandPower(node, parent, indParent) {
        var tp = node.type;
        var internal = arguments.length > 1; // TRUE in internal calls
        if (tp === "OperatorNode" && node.isBinary()) {
            var does = false;
            var val;
            if (node.op === "^") // First operator: Parenthesis or UnaryMinus
            {
                if ((node.args[0].type === "ParenthesisNode" || node.args[0].type === "OperatorNode") && node.args[1].type === "ConstantNode") {
                    // Second operator: Constant
                    val = parseFloat(node.args[1].value);
                    does = val >= 2 && (0, $5wlxr.isInteger)(val);
                }
            }
            if (does) {
                // Exponent >= 2
                // Before:
                //            operator A --> Subtree
                // parent pow
                //            constant
                //
                if (val > 2) {
                    // Exponent > 2,
                    // AFTER:  (exponent > 2)
                    //             operator A --> Subtree
                    // parent  *
                    //                 deep clone (operator A --> Subtree
                    //             pow
                    //                 constant - 1
                    //
                    var nEsqTopo = node.args[0];
                    var nDirTopo = new OperatorNode("^", "pow", [
                        node.args[0].cloneDeep(),
                        new ConstantNode(val - 1)
                    ]);
                    node = new OperatorNode("*", "multiply", [
                        nEsqTopo,
                        nDirTopo
                    ]);
                } else // Expo = 2 - no power
                // AFTER:  (exponent =  2)
                //             operator A --> Subtree
                // parent   oper
                //            deep clone (operator A --> Subtree)
                //
                node = new OperatorNode("*", "multiply", [
                    node.args[0],
                    node.args[0].cloneDeep()
                ]);
                if (internal) {
                    // Change parent references in internal recursive calls
                    if (indParent === "content") parent.content = node;
                    else parent.args[indParent] = node;
                }
            } // does
        } // binary OperatorNode
        if (tp === "ParenthesisNode") // Recursion
        expandPower(node.content, node, "content");
        else if (tp !== "ConstantNode" && tp !== "SymbolNode") for(var i = 0; i < node.args.length; i++)expandPower(node.args[i], node, i);
        if (!internal) // return the root node
        return node;
    } // End expandPower
    // ---------------------------------------------------------------------------------------
    /**
   * Auxilary function for rationalize
   * Convert near canonical polynomial in one variable in a canonical polynomial
   * with one term for each exponent in decreasing order
   *
   * Syntax:
   *
   *     polyToCanonical(node [, coefficients])
   *
   * @param  {Node | string} expr       The near canonical polynomial expression to convert in a a canonical polynomial expression
   *
   *        The string or tree expression needs to be at below syntax, with free spaces:
   *         (  (^(-)? | [+-]? )cte (*)? var (^expo)?  | cte )+
   *       Where 'var' is one variable with any valid name
   *             'cte' are real numeric constants with any value. It can be omitted if equal than 1
   *             'expo' are integers greater than 0. It can be omitted if equal than 1.
   *
   * @param  {array}   coefficients             Optional returns coefficients sorted by increased exponent
   *
   *
   * @return {node}        new node tree with one variable polynomial or string error.
   */ function polyToCanonical(node, coefficients) {
        if (coefficients === undefined) coefficients = [];
         // coefficients.
        coefficients[0] = 0; // index is the exponent
        var o = {};
        o.cte = 1;
        o.oper = "+"; // fire: mark with * or ^ when finds * or ^ down tree, reset to "" with + and -.
        //       It is used to deduce the exponent: 1 for *, 0 for "".
        o.fire = "";
        var maxExpo = 0; // maximum exponent
        var varname = ""; // variable name
        recurPol(node, null, o);
        maxExpo = coefficients.length - 1;
        var first = true;
        var no;
        for(var i = maxExpo; i >= 0; i--){
            if (coefficients[i] === 0) continue;
            var n1 = new ConstantNode(first ? coefficients[i] : Math.abs(coefficients[i]));
            var op = coefficients[i] < 0 ? "-" : "+";
            if (i > 0) {
                // Is not a constant without variable
                var n2 = new SymbolNode(varname);
                if (i > 1) {
                    var n3 = new ConstantNode(i);
                    n2 = new OperatorNode("^", "pow", [
                        n2,
                        n3
                    ]);
                }
                if (coefficients[i] === -1 && first) n1 = new OperatorNode("-", "unaryMinus", [
                    n2
                ]);
                else if (Math.abs(coefficients[i]) === 1) n1 = n2;
                else n1 = new OperatorNode("*", "multiply", [
                    n1,
                    n2
                ]);
            }
            if (first) no = n1;
            else if (op === "+") no = new OperatorNode("+", "add", [
                no,
                n1
            ]);
            else no = new OperatorNode("-", "subtract", [
                no,
                n1
            ]);
            first = false;
        } // for
        if (first) return new ConstantNode(0);
        else return no;
        /**
     * Recursive auxilary function inside polyToCanonical for
     * converting expression in canonical form
     *
     * Syntax:
     *
     *     recurPol(node, noPai, obj)
     *
     * @param  {Node} node        The current subpolynomial expression
     * @param  {Node | Null}  noPai   The current parent node
     * @param  {object}    obj        Object with many internal flags
     *
     * @return {}                    No return. If error, throws an exception
     */ function recurPol(node, noPai, o) {
            var tp = node.type;
            if (tp === "FunctionNode") // ***** FunctionName *****
            // No function call in polynomial expression
            throw new Error("There is an unsolved function call");
            else if (tp === "OperatorNode") {
                // ***** OperatorName *****
                if ("+-*^".indexOf(node.op) === -1) throw new Error("Operator " + node.op + " invalid");
                if (noPai !== null) {
                    // -(unary),^  : children of *,+,-
                    if ((node.fn === "unaryMinus" || node.fn === "pow") && noPai.fn !== "add" && noPai.fn !== "subtract" && noPai.fn !== "multiply") throw new Error("Invalid " + node.op + " placing");
                     // -,+,* : children of +,-
                    if ((node.fn === "subtract" || node.fn === "add" || node.fn === "multiply") && noPai.fn !== "add" && noPai.fn !== "subtract") throw new Error("Invalid " + node.op + " placing");
                     // -,+ : first child
                    if ((node.fn === "subtract" || node.fn === "add" || node.fn === "unaryMinus") && o.noFil !== 0) throw new Error("Invalid " + node.op + " placing");
                } // Has parent
                // Firers: ^,*       Old:   ^,&,-(unary): firers
                if (node.op === "^" || node.op === "*") o.fire = node.op;
                for(var _i = 0; _i < node.args.length; _i++){
                    // +,-: reset fire
                    if (node.fn === "unaryMinus") o.oper = "-";
                    if (node.op === "+" || node.fn === "subtract") {
                        o.fire = "";
                        o.cte = 1; // default if there is no constant
                        o.oper = _i === 0 ? "+" : node.op;
                    }
                    o.noFil = _i; // number of son
                    recurPol(node.args[_i], node, o);
                } // for in children
            } else if (tp === "SymbolNode") {
                // ***** SymbolName *****
                if (node.name !== varname && varname !== "") throw new Error("There is more than one variable");
                varname = node.name;
                if (noPai === null) {
                    coefficients[1] = 1;
                    return;
                } // ^: Symbol is First child
                if (noPai.op === "^" && o.noFil !== 0) throw new Error("In power the variable should be the first parameter");
                 // *: Symbol is Second child
                if (noPai.op === "*" && o.noFil !== 1) throw new Error("In multiply the variable should be the second parameter");
                 // Symbol: firers '',* => it means there is no exponent above, so it's 1 (cte * var)
                if (o.fire === "" || o.fire === "*") {
                    if (maxExpo < 1) coefficients[1] = 0;
                    coefficients[1] += o.cte * (o.oper === "+" ? 1 : -1);
                    maxExpo = Math.max(1, maxExpo);
                }
            } else if (tp === "ConstantNode") {
                var valor = parseFloat(node.value);
                if (noPai === null) {
                    coefficients[0] = valor;
                    return;
                }
                if (noPai.op === "^") {
                    // cte: second  child of power
                    if (o.noFil !== 1) throw new Error("Constant cannot be powered");
                    if (!(0, $5wlxr.isInteger)(valor) || valor <= 0) throw new Error("Non-integer exponent is not allowed");
                    for(var _i2 = maxExpo + 1; _i2 < valor; _i2++)coefficients[_i2] = 0;
                    if (valor > maxExpo) coefficients[valor] = 0;
                    coefficients[valor] += o.cte * (o.oper === "+" ? 1 : -1);
                    maxExpo = Math.max(valor, maxExpo);
                    return;
                }
                o.cte = valor; // Cte: firer '' => There is no exponent and no multiplication, so the exponent is 0.
                if (o.fire === "") coefficients[0] += o.cte * (o.oper === "+" ? 1 : -1);
            } else throw new Error("Type " + tp + " is not allowed");
        } // End of recurPol
    } // End of polyToCanonical
    return rationalize;
});

});
parcelRegister("fj1VV", function(module, exports) {

$parcel$export(module.exports, "createSimplifyConstant", function () { return $b24a21419f5e6ede$export$d72b8f0d2b277ae2; });
// TODO this could be improved by simplifying seperated constants under associative and commutative operators

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $k3vsa = parcelRequire("k3vsa");

var $94t5G = parcelRequire("94t5G");
var $b24a21419f5e6ede$var$name = "simplifyConstant";
var $b24a21419f5e6ede$var$dependencies = [
    "typed",
    "config",
    "mathWithTransform",
    "?fraction",
    "?bignumber",
    "ConstantNode",
    "OperatorNode",
    "FunctionNode",
    "SymbolNode"
];
var $b24a21419f5e6ede$export$d72b8f0d2b277ae2 = /* #__PURE__ */ (0, $jKx4O.factory)($b24a21419f5e6ede$var$name, $b24a21419f5e6ede$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, mathWithTransform = _ref.mathWithTransform, fraction = _ref.fraction, bignumber = _ref.bignumber, ConstantNode = _ref.ConstantNode, OperatorNode = _ref.OperatorNode, FunctionNode = _ref.FunctionNode, SymbolNode = _ref.SymbolNode;
    var _createUtil = (0, $k3vsa.createUtil)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    }), isCommutative = _createUtil.isCommutative, isAssociative = _createUtil.isAssociative, allChildren = _createUtil.allChildren, createMakeNodeFunction = _createUtil.createMakeNodeFunction;
    function simplifyConstant(expr, options) {
        var res = foldFraction(expr, options);
        return (0, $7E0JQ.isNode)(res) ? res : _toNode(res);
    }
    function _eval(fnname, args, options) {
        try {
            return _toNumber(mathWithTransform[fnname].apply(null, args), options);
        } catch (ignore) {
            // sometimes the implicit type conversion causes the evaluation to fail, so we'll try again after removing Fractions
            args = args.map(function(x) {
                if ((0, $7E0JQ.isFraction)(x)) return x.valueOf();
                return x;
            });
            return _toNumber(mathWithTransform[fnname].apply(null, args), options);
        }
    }
    var _toNode = typed({
        Fraction: _fractionToNode,
        number: function number(n) {
            if (n < 0) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n);
        },
        BigNumber: function BigNumber(n) {
            if (n < 0) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n); // old parameters: (n.toString(), 'number')
        },
        Complex: function Complex(s) {
            throw new Error("Cannot convert Complex number to Node");
        }
    }); // convert a number to a fraction only if it can be expressed exactly
    function _exactFraction(n, options) {
        var exactFractions = options && options.exactFractions !== false;
        if (exactFractions && isFinite(n) && fraction) {
            var f = fraction(n);
            if (f.valueOf() === n) return f;
        }
        return n;
    } // Convert numbers to a preferred number type in preference order: Fraction, number, Complex
    // BigNumbers are left alone
    var _toNumber = typed({
        "string, Object": function stringObject(s, options) {
            if (config.number === "BigNumber") {
                if (bignumber === undefined) (0, $94t5G.noBignumber)();
                return bignumber(s);
            } else if (config.number === "Fraction") {
                if (fraction === undefined) (0, $94t5G.noFraction)();
                return fraction(s);
            } else {
                var n = parseFloat(s);
                return _exactFraction(n, options);
            }
        },
        "Fraction, Object": function FractionObject(s, options) {
            return s;
        },
        // we don't need options here
        "BigNumber, Object": function BigNumberObject(s, options) {
            return s;
        },
        // we don't need options here
        "number, Object": function numberObject(s, options) {
            return _exactFraction(s, options);
        },
        "Complex, Object": function ComplexObject(s, options) {
            if (s.im !== 0) return s;
            return _exactFraction(s.re, options);
        }
    });
    function unaryMinusNode(n) {
        return new OperatorNode("-", "unaryMinus", [
            n
        ]);
    }
    function _fractionToNode(f) {
        var n;
        var vn = f.s * f.n;
        if (vn < 0) n = new OperatorNode("-", "unaryMinus", [
            new ConstantNode(-vn)
        ]);
        else n = new ConstantNode(vn);
        if (f.d === 1) return n;
        return new OperatorNode("/", "divide", [
            n,
            new ConstantNode(f.d)
        ]);
    }
    /*
   * Create a binary tree from a list of Fractions and Nodes.
   * Tries to fold Fractions by evaluating them until the first Node in the list is hit, so
   * `args` should be sorted to have the Fractions at the start (if the operator is commutative).
   * @param args - list of Fractions and Nodes
   * @param fn - evaluator for the binary operation evaluator that accepts two Fractions
   * @param makeNode - creates a binary OperatorNode/FunctionNode from a list of child Nodes
   * if args.length is 1, returns args[0]
   * @return - Either a Node representing a binary expression or Fraction
   */ function foldOp(fn, args, makeNode, options) {
        return args.reduce(function(a, b) {
            if (!(0, $7E0JQ.isNode)(a) && !(0, $7E0JQ.isNode)(b)) {
                try {
                    return _eval(fn, [
                        a,
                        b
                    ], options);
                } catch (ignoreandcontinue) {}
                a = _toNode(a);
                b = _toNode(b);
            } else if (!(0, $7E0JQ.isNode)(a)) a = _toNode(a);
            else if (!(0, $7E0JQ.isNode)(b)) b = _toNode(b);
            return makeNode([
                a,
                b
            ]);
        });
    } // destroys the original node and returns a folded one
    function foldFraction(node, options) {
        switch(node.type){
            case "SymbolNode":
                return node;
            case "ConstantNode":
                if (typeof node.value === "number" || !isNaN(node.value)) return _toNumber(node.value, options);
                return node;
            case "FunctionNode":
                if (mathWithTransform[node.name] && mathWithTransform[node.name].rawArgs) return node;
                // Process operators as OperatorNode
                var operatorFunctions = [
                    "add",
                    "multiply"
                ];
                if (operatorFunctions.indexOf(node.name) === -1) {
                    var args = node.args.map(function(arg) {
                        return foldFraction(arg, options);
                    }); // If all args are numbers
                    if (!args.some((0, $7E0JQ.isNode))) try {
                        return _eval(node.name, args, options);
                    } catch (ignoreandcontine) {}
                     // Convert all args to nodes and construct a symbolic function call
                    args = args.map(function(arg) {
                        return (0, $7E0JQ.isNode)(arg) ? arg : _toNode(arg);
                    });
                    return new FunctionNode(node.name, args);
                }
            /* falls through */ case "OperatorNode":
                var fn = node.fn.toString();
                var _args;
                var res;
                var makeNode = createMakeNodeFunction(node);
                if ((0, $7E0JQ.isOperatorNode)(node) && node.isUnary()) {
                    _args = [
                        foldFraction(node.args[0], options)
                    ];
                    if (!(0, $7E0JQ.isNode)(_args[0])) res = _eval(fn, _args, options);
                    else res = makeNode(_args);
                } else if (isAssociative(node)) {
                    _args = allChildren(node);
                    _args = _args.map(function(arg) {
                        return foldFraction(arg, options);
                    });
                    if (isCommutative(fn)) {
                        // commutative binary operator
                        var consts = [];
                        var vars = [];
                        for(var i = 0; i < _args.length; i++)if (!(0, $7E0JQ.isNode)(_args[i])) consts.push(_args[i]);
                        else vars.push(_args[i]);
                        if (consts.length > 1) {
                            res = foldOp(fn, consts, makeNode, options);
                            vars.unshift(res);
                            res = foldOp(fn, vars, makeNode, options);
                        } else // we won't change the children order since it's not neccessary
                        res = foldOp(fn, _args, makeNode, options);
                    } else // non-commutative binary operator
                    res = foldOp(fn, _args, makeNode, options);
                } else {
                    // non-associative binary operator
                    _args = node.args.map(function(arg) {
                        return foldFraction(arg, options);
                    });
                    res = foldOp(fn, _args, makeNode, options);
                }
                return res;
            case "ParenthesisNode":
                // remove the uneccessary parenthesis
                return foldFraction(node.content, options);
            case "AccessorNode":
            /* falls through */ case "ArrayNode":
            /* falls through */ case "AssignmentNode":
            /* falls through */ case "BlockNode":
            /* falls through */ case "FunctionAssignmentNode":
            /* falls through */ case "IndexNode":
            /* falls through */ case "ObjectNode":
            /* falls through */ case "RangeNode":
            /* falls through */ case "ConditionalNode":
            /* falls through */ default:
                throw new Error("Unimplemented node type in simplifyConstant: ".concat(node.type));
        }
    }
    return simplifyConstant;
});

});
parcelRegister("k3vsa", function(module, exports) {

$parcel$export(module.exports, "createUtil", function () { return $e99c7c720aea3939$export$f2206d57cebf291a; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $glBd7 = parcelRequire("glBd7");
var $e99c7c720aea3939$var$name = "simplifyUtil";
var $e99c7c720aea3939$var$dependencies = [
    "FunctionNode",
    "OperatorNode",
    "SymbolNode"
];
var $e99c7c720aea3939$export$f2206d57cebf291a = /* #__PURE__ */ (0, $jKx4O.factory)($e99c7c720aea3939$var$name, $e99c7c720aea3939$var$dependencies, function(_ref) {
    var FunctionNode = _ref.FunctionNode, OperatorNode = _ref.OperatorNode, SymbolNode = _ref.SymbolNode;
    // TODO commutative/associative properties rely on the arguments
    // e.g. multiply is not commutative for matrices
    // The properties should be calculated from an argument to simplify, or possibly something in math.config
    // the other option is for typed() to specify a return type so that we can evaluate the type of arguments
    var commutative = {
        add: true,
        multiply: true
    };
    var associative = {
        add: true,
        multiply: true
    };
    function isCommutative(node, context) {
        if (!(0, $7E0JQ.isOperatorNode)(node)) return true;
        var name = node.fn.toString();
        if (context && (0, $glBd7.hasOwnProperty)(context, name) && (0, $glBd7.hasOwnProperty)(context[name], "commutative")) return context[name].commutative;
        return commutative[name] || false;
    }
    function isAssociative(node, context) {
        if (!(0, $7E0JQ.isOperatorNode)(node)) return false;
        var name = node.fn.toString();
        if (context && (0, $glBd7.hasOwnProperty)(context, name) && (0, $glBd7.hasOwnProperty)(context[name], "associative")) return context[name].associative;
        return associative[name] || false;
    }
    /**
   * Flatten all associative operators in an expression tree.
   * Assumes parentheses have already been removed.
   */ function flatten(node) {
        if (!node.args || node.args.length === 0) return node;
        node.args = allChildren(node);
        for(var i = 0; i < node.args.length; i++)flatten(node.args[i]);
    }
    /**
   * Get the children of a node as if it has been flattened.
   * TODO implement for FunctionNodes
   */ function allChildren(node) {
        var op;
        var children = [];
        var findChildren = function findChildren(node) {
            for(var i = 0; i < node.args.length; i++){
                var child = node.args[i];
                if ((0, $7E0JQ.isOperatorNode)(child) && op === child.op) findChildren(child);
                else children.push(child);
            }
        };
        if (isAssociative(node)) {
            op = node.op;
            findChildren(node);
            return children;
        } else return node.args;
    }
    /**
   *  Unflatten all flattened operators to a right-heavy binary tree.
   */ function unflattenr(node) {
        if (!node.args || node.args.length === 0) return;
        var makeNode = createMakeNodeFunction(node);
        var l = node.args.length;
        for(var i = 0; i < l; i++)unflattenr(node.args[i]);
        if (l > 2 && isAssociative(node)) {
            var curnode = node.args.pop();
            while(node.args.length > 0)curnode = makeNode([
                node.args.pop(),
                curnode
            ]);
            node.args = curnode.args;
        }
    }
    /**
   *  Unflatten all flattened operators to a left-heavy binary tree.
   */ function unflattenl(node) {
        if (!node.args || node.args.length === 0) return;
        var makeNode = createMakeNodeFunction(node);
        var l = node.args.length;
        for(var i = 0; i < l; i++)unflattenl(node.args[i]);
        if (l > 2 && isAssociative(node)) {
            var curnode = node.args.shift();
            while(node.args.length > 0)curnode = makeNode([
                curnode,
                node.args.shift()
            ]);
            node.args = curnode.args;
        }
    }
    function createMakeNodeFunction(node) {
        if ((0, $7E0JQ.isOperatorNode)(node)) return function(args) {
            try {
                return new OperatorNode(node.op, node.fn, args, node.implicit);
            } catch (err) {
                console.error(err);
                return [];
            }
        };
        else return function(args) {
            return new FunctionNode(new SymbolNode(node.name), args);
        };
    }
    return {
        createMakeNodeFunction: createMakeNodeFunction,
        isCommutative: isCommutative,
        isAssociative: isAssociative,
        flatten: flatten,
        allChildren: allChildren,
        unflattenr: unflattenr,
        unflattenl: unflattenl
    };
});

});


parcelRegister("crDbf", function(module, exports) {

$parcel$export(module.exports, "createSimplifyCore", function () { return $90f66610a2670fcc$export$c3d7d520703291df; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $90f66610a2670fcc$var$name = "simplifyCore";
var $90f66610a2670fcc$var$dependencies = [
    "equal",
    "isZero",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "ConstantNode",
    "OperatorNode",
    "FunctionNode",
    "ParenthesisNode"
];
var $90f66610a2670fcc$export$c3d7d520703291df = /* #__PURE__ */ (0, $jKx4O.factory)($90f66610a2670fcc$var$name, $90f66610a2670fcc$var$dependencies, function(_ref) {
    var equal = _ref.equal, isZero = _ref.isZero, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, pow = _ref.pow, ConstantNode = _ref.ConstantNode, OperatorNode = _ref.OperatorNode, FunctionNode = _ref.FunctionNode, ParenthesisNode = _ref.ParenthesisNode;
    var node0 = new ConstantNode(0);
    var node1 = new ConstantNode(1);
    /**
   * simplifyCore() performs single pass simplification suitable for
   * applications requiring ultimate performance. In contrast, simplify()
   * extends simplifyCore() with additional passes to provide deeper
   * simplification.
   *
   * Syntax:
   *
   *     simplify.simplifyCore(expr)
   *
   * Examples:
   *
   *     const f = math.parse('2 * 1 * x ^ (2 - 1)')
   *     math.simplify.simpifyCore(f)                          // Node {2 * x}
   *     math.simplify('2 * 1 * x ^ (2 - 1)', [math.simplify.simpifyCore]) // Node {2 * x}
   *
   * See also:
   *
   *     derivative
   *
   * @param {Node} node
   *     The expression to be simplified
   */ function simplifyCore(node) {
        if ((0, $7E0JQ.isOperatorNode)(node) && node.isUnary()) {
            var a0 = simplifyCore(node.args[0]);
            if (node.op === "+") // unary plus
            return a0;
            if (node.op === "-") {
                // unary minus
                if ((0, $7E0JQ.isOperatorNode)(a0)) {
                    if (a0.isUnary() && a0.op === "-") return a0.args[0];
                    else if (a0.isBinary() && a0.fn === "subtract") return new OperatorNode("-", "subtract", [
                        a0.args[1],
                        a0.args[0]
                    ]);
                }
                return new OperatorNode(node.op, node.fn, [
                    a0
                ]);
            }
        } else if ((0, $7E0JQ.isOperatorNode)(node) && node.isBinary()) {
            var _a = simplifyCore(node.args[0]);
            var a1 = simplifyCore(node.args[1]);
            if (node.op === "+") {
                if ((0, $7E0JQ.isConstantNode)(_a)) {
                    if (isZero(_a.value)) return a1;
                    else if ((0, $7E0JQ.isConstantNode)(a1)) return new ConstantNode(add(_a.value, a1.value));
                }
                if ((0, $7E0JQ.isConstantNode)(a1) && isZero(a1.value)) return _a;
                if ((0, $7E0JQ.isOperatorNode)(a1) && a1.isUnary() && a1.op === "-") return new OperatorNode("-", "subtract", [
                    _a,
                    a1.args[0]
                ]);
                return new OperatorNode(node.op, node.fn, a1 ? [
                    _a,
                    a1
                ] : [
                    _a
                ]);
            } else if (node.op === "-") {
                if ((0, $7E0JQ.isConstantNode)(_a) && a1) {
                    if ((0, $7E0JQ.isConstantNode)(a1)) return new ConstantNode(subtract(_a.value, a1.value));
                    else if (isZero(_a.value)) return new OperatorNode("-", "unaryMinus", [
                        a1
                    ]);
                } // if (node.fn === "subtract" && node.args.length === 2) {
                if (node.fn === "subtract") {
                    if ((0, $7E0JQ.isConstantNode)(a1) && isZero(a1.value)) return _a;
                    if ((0, $7E0JQ.isOperatorNode)(a1) && a1.isUnary() && a1.op === "-") return simplifyCore(new OperatorNode("+", "add", [
                        _a,
                        a1.args[0]
                    ]));
                    return new OperatorNode(node.op, node.fn, [
                        _a,
                        a1
                    ]);
                }
            } else if (node.op === "*") {
                if ((0, $7E0JQ.isConstantNode)(_a)) {
                    if (isZero(_a.value)) return node0;
                    else if (equal(_a.value, 1)) return a1;
                    else if ((0, $7E0JQ.isConstantNode)(a1)) return new ConstantNode(multiply(_a.value, a1.value));
                }
                if ((0, $7E0JQ.isConstantNode)(a1)) {
                    if (isZero(a1.value)) return node0;
                    else if (equal(a1.value, 1)) return _a;
                    else if ((0, $7E0JQ.isOperatorNode)(_a) && _a.isBinary() && _a.op === node.op) {
                        var a00 = _a.args[0];
                        if ((0, $7E0JQ.isConstantNode)(a00)) {
                            var a00a1 = new ConstantNode(multiply(a00.value, a1.value));
                            return new OperatorNode(node.op, node.fn, [
                                a00a1,
                                _a.args[1]
                            ], node.implicit); // constants on left
                        }
                    }
                    return new OperatorNode(node.op, node.fn, [
                        a1,
                        _a
                    ], node.implicit); // constants on left
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ], node.implicit);
            } else if (node.op === "/") {
                if ((0, $7E0JQ.isConstantNode)(_a)) {
                    if (isZero(_a.value)) return node0;
                    else if ((0, $7E0JQ.isConstantNode)(a1) && (equal(a1.value, 1) || equal(a1.value, 2) || equal(a1.value, 4))) return new ConstantNode(divide(_a.value, a1.value));
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ]);
            } else if (node.op === "^") {
                if ((0, $7E0JQ.isConstantNode)(a1)) {
                    if (isZero(a1.value)) return node1;
                    else if (equal(a1.value, 1)) return _a;
                    else {
                        if ((0, $7E0JQ.isConstantNode)(_a)) // fold constant
                        return new ConstantNode(pow(_a.value, a1.value));
                        else if ((0, $7E0JQ.isOperatorNode)(_a) && _a.isBinary() && _a.op === "^") {
                            var a01 = _a.args[1];
                            if ((0, $7E0JQ.isConstantNode)(a01)) return new OperatorNode(node.op, node.fn, [
                                _a.args[0],
                                new ConstantNode(multiply(a01.value, a1.value))
                            ]);
                        }
                    }
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ]);
            }
        } else if ((0, $7E0JQ.isParenthesisNode)(node)) {
            var c = simplifyCore(node.content);
            if ((0, $7E0JQ.isParenthesisNode)(c) || (0, $7E0JQ.isSymbolNode)(c) || (0, $7E0JQ.isConstantNode)(c)) return c;
            return new ParenthesisNode(c);
        } else if ((0, $7E0JQ.isFunctionNode)(node)) {
            var args = node.args.map(simplifyCore).map(function(arg) {
                return (0, $7E0JQ.isParenthesisNode)(arg) ? arg.content : arg;
            });
            return new FunctionNode(simplifyCore(node.fn), args);
        }
        return node;
    }
    return simplifyCore;
});

});


parcelRegister("jTYlf", function(module, exports) {

$parcel$export(module.exports, "createRelationalNode", function () { return $e7d1f5f6ea6d6631$export$92a3c2dff1e32f25; });

var $7OD47 = parcelRequire("7OD47");

var $7HWRb = parcelRequire("7HWRb");

var $i3n6j = parcelRequire("i3n6j");

var $fMJxQ = parcelRequire("fMJxQ");

var $jKx4O = parcelRequire("jKx4O");
var $e7d1f5f6ea6d6631$var$name = "RelationalNode";
var $e7d1f5f6ea6d6631$var$dependencies = [
    "Node"
];
var $e7d1f5f6ea6d6631$export$92a3c2dff1e32f25 = /* #__PURE__ */ (0, $jKx4O.factory)($e7d1f5f6ea6d6631$var$name, $e7d1f5f6ea6d6631$var$dependencies, function(_ref) {
    var Node = _ref.Node;
    /**
   * A node representing a chained conditional expression, such as 'x > y > z'
   *
   * @param {String[]} conditionals   An array of conditional operators used to compare the parameters
   * @param {Node[]} params   The parameters that will be compared
   *
   * @constructor RelationalNode
   * @extends {Node}
   */ function RelationalNode(conditionals, params) {
        if (!(this instanceof RelationalNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!Array.isArray(conditionals)) throw new TypeError("Parameter conditionals must be an array");
        if (!Array.isArray(params)) throw new TypeError("Parameter params must be an array");
        if (conditionals.length !== params.length - 1) throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
        this.conditionals = conditionals;
        this.params = params;
    }
    RelationalNode.prototype = new Node();
    RelationalNode.prototype.type = "RelationalNode";
    RelationalNode.prototype.isRelationalNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ RelationalNode.prototype._compile = function(math, argNames) {
        var self = this;
        var compiled = this.params.map(function(p) {
            return p._compile(math, argNames);
        });
        return function evalRelationalNode(scope, args, context) {
            var evalLhs;
            var evalRhs = compiled[0](scope, args, context);
            for(var i = 0; i < self.conditionals.length; i++){
                evalLhs = evalRhs;
                evalRhs = compiled[i + 1](scope, args, context);
                var condFn = (0, $i3n6j.getSafeProperty)(math, self.conditionals[i]);
                if (!condFn(evalLhs, evalRhs)) return false;
            }
            return true;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ RelationalNode.prototype.forEach = function(callback) {
        var _this = this;
        this.params.forEach(function(n, i) {
            return callback(n, "params[" + i + "]", _this);
        }, this);
    };
    /**
   * Create a new RelationalNode having its childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {RelationalNode} Returns a transformed copy of the node
   */ RelationalNode.prototype.map = function(callback) {
        var _this2 = this;
        return new RelationalNode(this.conditionals.slice(), this.params.map(function(n, i) {
            return _this2._ifNode(callback(n, "params[" + i + "]", _this2));
        }, this));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {RelationalNode}
   */ RelationalNode.prototype.clone = function() {
        return new RelationalNode(this.conditionals, this.params);
    };
    /**
   * Get string representation.
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $7OD47.getPrecedence)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $7OD47.getPrecedence)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? "(" + p.toString(options) + ")" : p.toString(options);
        });
        var operatorMap = {
            equal: "==",
            unequal: "!=",
            smaller: "<",
            larger: ">",
            smallerEq: "<=",
            largerEq: ">="
        };
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += " " + operatorMap[this.conditionals[i]] + " " + paramStrings[i + 1];
        return ret;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ RelationalNode.prototype.toJSON = function() {
        return {
            mathjs: "RelationalNode",
            conditionals: this.conditionals,
            params: this.params
        };
    };
    /**
   * Instantiate a RelationalNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "RelationalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
   *                       where mathjs is optional
   * @returns {RelationalNode}
   */ RelationalNode.fromJSON = function(json) {
        return new RelationalNode(json.conditionals, json.params);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $7OD47.getPrecedence)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $7OD47.getPrecedence)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + p.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : p.toHTML(options);
        });
        var operatorMap = {
            equal: "==",
            unequal: "!=",
            smaller: "<",
            larger: ">",
            smallerEq: "<=",
            largerEq: ">="
        };
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $7HWRb.escape)(operatorMap[this.conditionals[i]]) + "</span>" + paramStrings[i + 1];
        return ret;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $7OD47.getPrecedence)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $7OD47.getPrecedence)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? "\\left(" + p.toTex(options) + "\right)" : p.toTex(options);
        });
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += (0, $fMJxQ.latexOperators)[this.conditionals[i]] + paramStrings[i + 1];
        return ret;
    };
    return RelationalNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("kFH0X", function(module, exports) {

$parcel$export(module.exports, "createReviver", function () { return $f0c900c0ea6b7b70$export$288f43fef560974b; });

var $jKx4O = parcelRequire("jKx4O");
var $f0c900c0ea6b7b70$var$name = "reviver";
var $f0c900c0ea6b7b70$var$dependencies = [
    "classes"
];
var $f0c900c0ea6b7b70$export$288f43fef560974b = /* #__PURE__ */ (0, $jKx4O.factory)($f0c900c0ea6b7b70$var$name, $f0c900c0ea6b7b70$var$dependencies, function(_ref) {
    var classes = _ref.classes;
    /**
   * Instantiate mathjs data types from their JSON representation
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the revived object
   */ return function reviver(key, value) {
        var constructor = classes[value && value.mathjs];
        if (constructor && typeof constructor.fromJSON === "function") return constructor.fromJSON(value);
        return value;
    };
});

});

parcelRegister("6oWVY", function(module, exports) {

$parcel$export(module.exports, "createRowTransform", function () { return $4a92b30f8b93747e$export$649101a1e7f0c38d; });

var $jKx4O = parcelRequire("jKx4O");

var $3RjRH = parcelRequire("3RjRH");

var $aVkFN = parcelRequire("aVkFN");

var $7E0JQ = parcelRequire("7E0JQ");
var $4a92b30f8b93747e$var$name = "row";
var $4a92b30f8b93747e$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $4a92b30f8b93747e$export$649101a1e7f0c38d = /* #__PURE__ */ (0, $jKx4O.factory)($4a92b30f8b93747e$var$name, $4a92b30f8b93747e$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index, matrix = _ref.matrix, range = _ref.range;
    var row = (0, $3RjRH.createRow)({
        typed: typed,
        Index: Index,
        matrix: matrix,
        range: range
    }); // @see: comment of row itself
    return typed("row", {
        "...any": function any(args) {
            // change last argument from zero-based to one-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $7E0JQ.isNumber)(last)) args[lastIndex] = last - 1;
            try {
                return row.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("3RjRH", function(module, exports) {

$parcel$export(module.exports, "createRow", function () { return $2cf5bb214b441efe$export$3442c5d213434705; });

var $jKx4O = parcelRequire("jKx4O");

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");
var $2cf5bb214b441efe$var$name = "row";
var $2cf5bb214b441efe$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $2cf5bb214b441efe$export$3442c5d213434705 = /* #__PURE__ */ (0, $jKx4O.factory)($2cf5bb214b441efe$var$name, $2cf5bb214b441efe$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index, matrix = _ref.matrix, range = _ref.range;
    /**
   * Return a row from a Matrix.
   *
   * Syntax:
   *
   *     math.row(value, index)
   *
   * Example:
   *
   *     // get a row
   *     const d = [[1, 2], [3, 4]]
   *     math.row(d, 1) // returns [[3, 4]]
   *
   * See also:
   *
   *     column
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} row              The index of the row
   * @return {Array | Matrix}         The retrieved row
   */ var row = typed($2cf5bb214b441efe$var$name, {
        "Matrix, number": _row,
        "Array, number": function ArrayNumber(value, row) {
            return _row(matrix((0, $glBd7.clone)(value)), row).valueOf();
        }
    });
    return row;
    /**
   * Retrieve a row of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} row     The index of the row
   * @return {Matrix}        The retrieved row
   */ function _row(value, row) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $YkZ7e.validateIndex)(row, value.size()[0]);
        var columnRange = range(0, value.size()[1]);
        var index = new Index(row, columnRange);
        return value.subset(index);
    }
});

});


parcelRegister("6lZEL", function(module, exports) {

$parcel$export(module.exports, "createSimplify", function () { return $4a0487ec290fece1$export$5085b3a4c8276699; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $k3vsa = parcelRequire("k3vsa");

var $crDbf = parcelRequire("crDbf");

var $fj1VV = parcelRequire("fj1VV");

var $j90kH = parcelRequire("j90kH");

var $glBd7 = parcelRequire("glBd7");
function $4a0487ec290fece1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4a0487ec290fece1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4a0487ec290fece1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4a0487ec290fece1$var$_typeof(obj);
}
var $4a0487ec290fece1$var$name = "simplify";
var $4a0487ec290fece1$var$dependencies = [
    "config",
    "typed",
    "parse",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "isZero",
    "equal",
    "?fraction",
    "?bignumber",
    "mathWithTransform",
    "ConstantNode",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $4a0487ec290fece1$export$5085b3a4c8276699 = /* #__PURE__ */ (0, $jKx4O.factory)($4a0487ec290fece1$var$name, $4a0487ec290fece1$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, parse = _ref.parse, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, pow = _ref.pow, isZero = _ref.isZero, equal = _ref.equal, fraction = _ref.fraction, bignumber = _ref.bignumber, mathWithTransform = _ref.mathWithTransform, ConstantNode = _ref.ConstantNode, FunctionNode = _ref.FunctionNode, OperatorNode = _ref.OperatorNode, ParenthesisNode = _ref.ParenthesisNode, SymbolNode = _ref.SymbolNode;
    var simplifyConstant = (0, $fj1VV.createSimplifyConstant)({
        typed: typed,
        config: config,
        mathWithTransform: mathWithTransform,
        fraction: fraction,
        bignumber: bignumber,
        ConstantNode: ConstantNode,
        OperatorNode: OperatorNode,
        FunctionNode: FunctionNode,
        SymbolNode: SymbolNode
    });
    var simplifyCore = (0, $crDbf.createSimplifyCore)({
        equal: equal,
        isZero: isZero,
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide,
        pow: pow,
        ConstantNode: ConstantNode,
        OperatorNode: OperatorNode,
        FunctionNode: FunctionNode,
        ParenthesisNode: ParenthesisNode
    });
    var resolve = (0, $j90kH.createResolve)({
        parse: parse,
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        ParenthesisNode: ParenthesisNode
    });
    var _createUtil = (0, $k3vsa.createUtil)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    }), isCommutative = _createUtil.isCommutative, isAssociative = _createUtil.isAssociative, flatten = _createUtil.flatten, unflattenr = _createUtil.unflattenr, unflattenl = _createUtil.unflattenl, createMakeNodeFunction = _createUtil.createMakeNodeFunction;
    /**
   * Simplify an expression tree.
   *
   * A list of rules are applied to an expression, repeating over the list until
   * no further changes are made.
   * It's possible to pass a custom set of rules to the function as second
   * argument. A rule can be specified as an object, string, or function:
   *
   *     const rules = [
   *       { l: 'n1*n3 + n2*n3', r: '(n1+n2)*n3' },
   *       'n1*n3 + n2*n3 -> (n1+n2)*n3',
   *       function (node) {
   *         // ... return a new node or return the node unchanged
   *         return node
   *       }
   *     ]
   *
   * String and object rules consist of a left and right pattern. The left is
   * used to match against the expression and the right determines what matches
   * are replaced with. The main difference between a pattern and a normal
   * expression is that variables starting with the following characters are
   * interpreted as wildcards:
   *
   * - 'n' - matches any Node
   * - 'c' - matches any ConstantNode
   * - 'v' - matches any Node that is not a ConstantNode
   *
   * The default list of rules is exposed on the function as `simplify.rules`
   * and can be used as a basis to built a set of custom rules.
   *
   * For more details on the theory, see:
   *
   * - [Strategies for simplifying math expressions (Stackoverflow)](https://stackoverflow.com/questions/7540227/strategies-for-simplifying-math-expressions)
   * - [Symbolic computation - Simplification (Wikipedia)](https://en.wikipedia.org/wiki/Symbolic_computation#Simplification)
   *
   *  An optional `options` argument can be passed as last argument of `simplify`.
   *  There is currently one option available: `exactFractions`, a boolean which
   *  is `true` by default.
   *
   * Syntax:
   *
   *     simplify(expr)
   *     simplify(expr, rules)
   *     simplify(expr, rules)
   *     simplify(expr, rules, scope)
   *     simplify(expr, rules, scope, options)
   *     simplify(expr, scope)
   *     simplify(expr, scope, options)
   *
   * Examples:
   *
   *     math.simplify('2 * 1 * x ^ (2 - 1)')      // Node "2 * x"
   *     math.simplify('2 * 3 * x', {x: 4})        // Node "24"
   *     const f = math.parse('2 * 1 * x ^ (2 - 1)')
   *     math.simplify(f)                          // Node "2 * x"
   *     math.simplify('0.4 * x', {}, {exactFractions: true})  // Node "x * 2 / 5"
   *     math.simplify('0.4 * x', {}, {exactFractions: false}) // Node "0.4 * x"
   *
   * See also:
   *
   *     derivative, parse, evaluate, rationalize
   *
   * @param {Node | string} expr
   *            The expression to be simplified
   * @param {Array<{l:string, r: string} | string | function>} [rules]
   *            Optional list with custom rules
   * @return {Node} Returns the simplified form of `expr`
   */ var simplify = typed("simplify", {
        string: function string(expr) {
            return simplify(parse(expr), simplify.rules, {}, {});
        },
        "string, Object": function stringObject(expr, scope) {
            return simplify(parse(expr), simplify.rules, scope, {});
        },
        "string, Object, Object": function stringObjectObject(expr, scope, options) {
            return simplify(parse(expr), simplify.rules, scope, options);
        },
        "string, Array": function stringArray(expr, rules) {
            return simplify(parse(expr), rules, {}, {});
        },
        "string, Array, Object": function stringArrayObject(expr, rules, scope) {
            return simplify(parse(expr), rules, scope, {});
        },
        "string, Array, Object, Object": function stringArrayObjectObject(expr, rules, scope, options) {
            return simplify(parse(expr), rules, scope, options);
        },
        "Node, Object": function NodeObject(expr, scope) {
            return simplify(expr, simplify.rules, scope, {});
        },
        "Node, Object, Object": function NodeObjectObject(expr, scope, options) {
            return simplify(expr, simplify.rules, scope, options);
        },
        Node: function Node(expr) {
            return simplify(expr, simplify.rules, {}, {});
        },
        "Node, Array": function NodeArray(expr, rules) {
            return simplify(expr, rules, {}, {});
        },
        "Node, Array, Object": function NodeArrayObject(expr, rules, scope) {
            return simplify(expr, rules, scope, {});
        },
        "Node, Array, Object, Object": function NodeArrayObjectObject(expr, rules, scope, options) {
            rules = _buildRules(rules);
            var res = resolve(expr, scope);
            res = removeParens(res);
            var visited = {};
            var str = res.toString({
                parenthesis: "all"
            });
            while(!visited[str]){
                visited[str] = true;
                _lastsym = 0; // counter for placeholder symbols
                for(var i = 0; i < rules.length; i++){
                    if (typeof rules[i] === "function") res = rules[i](res, options);
                    else {
                        flatten(res);
                        res = applyRule(res, rules[i]);
                    }
                    unflattenl(res); // using left-heavy binary tree here since custom rule functions may expect it
                }
                str = res.toString({
                    parenthesis: "all"
                });
            }
            return res;
        }
    });
    simplify.simplifyCore = simplifyCore;
    simplify.resolve = resolve;
    function removeParens(node) {
        return node.transform(function(node, path, parent) {
            return (0, $7E0JQ.isParenthesisNode)(node) ? removeParens(node.content) : node;
        });
    } // All constants that are allowed in rules
    var SUPPORTED_CONSTANTS = {
        "true": true,
        "false": true,
        e: true,
        i: true,
        Infinity: true,
        LN2: true,
        LN10: true,
        LOG2E: true,
        LOG10E: true,
        NaN: true,
        phi: true,
        pi: true,
        SQRT1_2: true,
        SQRT2: true,
        tau: true // null: false,
    }; // Array of strings, used to build the ruleSet.
    // Each l (left side) and r (right side) are parsed by
    // the expression parser into a node tree.
    // Left hand sides are matched to subtrees within the
    // expression to be parsed and replaced with the right
    // hand side.
    // TODO: Add support for constraints on constants (either in the form of a '=' expression or a callback [callback allows things like comparing symbols alphabetically])
    // To evaluate lhs constants for rhs constants, use: { l: 'c1+c2', r: 'c3', evaluate: 'c3 = c1 + c2' }. Multiple assignments are separated by ';' in block format.
    // It is possible to get into an infinite loop with conflicting rules
    simplify.rules = [
        simplifyCore,
        // { l: 'n^0', r: '1' },     // simplifyCore
        // { l: '0*n', r: '0' },     // simplifyCore
        // { l: 'n/n', r: '1'},      // simplifyCore
        // { l: 'n^1', r: 'n' },     // simplifyCore
        // { l: '+n1', r:'n1' },     // simplifyCore
        // { l: 'n--n1', r:'n+n1' }, // simplifyCore
        {
            l: "log(e)",
            r: "1"
        },
        {
            l: "n-n1",
            r: "n+-n1"
        },
        {
            l: "-(c*v)",
            r: "(-c) * v"
        },
        {
            l: "-v",
            r: "(-1) * v"
        },
        {
            l: "n/n1^n2",
            r: "n*n1^-n2"
        },
        {
            l: "n/n1",
            r: "n*n1^-1"
        },
        {
            l: "(n ^ n1) ^ n2",
            r: "n ^ (n1 * n2)"
        },
        {
            l: "n*n",
            r: "n^2"
        },
        {
            l: "n * n^n1",
            r: "n^(n1+1)"
        },
        {
            l: "n^n1 * n^n2",
            r: "n^(n1+n2)"
        },
        {
            l: "n+n",
            r: "2*n"
        },
        {
            l: "n+-n",
            r: "0"
        },
        {
            l: "n1*n2 + n2",
            r: "(n1+1)*n2"
        },
        {
            l: "n1*n3 + n2*n3",
            r: "(n1+n2)*n3"
        },
        {
            l: "n1 + -1 * (n2 + n3)",
            r: "n1 + -1 * n2 + -1 * n3"
        },
        simplifyConstant,
        {
            l: "(-n)*n1",
            r: "-(n*n1)"
        },
        // ordering of constants
        {
            l: "c+v",
            r: "v+c",
            context: {
                add: {
                    commutative: false
                }
            }
        },
        {
            l: "v*c",
            r: "c*v",
            context: {
                multiply: {
                    commutative: false
                }
            }
        },
        // { l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
        {
            l: "n+-n1",
            r: "n-n1"
        },
        {
            l: "n*(n1^-1)",
            r: "n/n1"
        },
        {
            l: "n*n1^-n2",
            r: "n/n1^n2"
        },
        {
            l: "n1^-1",
            r: "1/n1"
        },
        {
            l: "n*(n1/n2)",
            r: "(n*n1)/n2"
        },
        {
            l: "n-(n1+n2)",
            r: "n-n1-n2"
        },
        // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
        // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
        {
            l: "1*n",
            r: "n"
        },
        {
            l: "n1/(n2/n3)",
            r: "(n1*n3)/n2"
        }
    ];
    /**
   * Parse the string array of rules into nodes
   *
   * Example syntax for rules:
   *
   * Position constants to the left in a product:
   * { l: 'n1 * c1', r: 'c1 * n1' }
   * n1 is any Node, and c1 is a ConstantNode.
   *
   * Apply difference of squares formula:
   * { l: '(n1 - n2) * (n1 + n2)', r: 'n1^2 - n2^2' }
   * n1, n2 mean any Node.
   *
   * Short hand notation:
   * 'n1 * c1 -> c1 * n1'
   */ function _buildRules(rules) {
        // Array of rules to be used to simplify expressions
        var ruleSet = [];
        for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var newRule = void 0;
            var ruleType = $4a0487ec290fece1$var$_typeof(rule);
            switch(ruleType){
                case "string":
                    var lr = rule.split("->");
                    if (lr.length === 2) rule = {
                        l: lr[0],
                        r: lr[1]
                    };
                    else throw SyntaxError("Could not parse rule: " + rule);
                /* falls through */ case "object":
                    newRule = {
                        l: removeParens(parse(rule.l)),
                        r: removeParens(parse(rule.r))
                    };
                    if (rule.context) newRule.evaluate = rule.context;
                    if (rule.evaluate) newRule.evaluate = parse(rule.evaluate);
                    if (isAssociative(newRule.l)) {
                        var makeNode = createMakeNodeFunction(newRule.l);
                        var expandsym = _getExpandPlaceholderSymbol();
                        newRule.expanded = {};
                        newRule.expanded.l = makeNode([
                            newRule.l.clone(),
                            expandsym
                        ]); // Push the expandsym into the deepest possible branch.
                        // This helps to match the newRule against nodes returned from getSplits() later on.
                        flatten(newRule.expanded.l);
                        unflattenr(newRule.expanded.l);
                        newRule.expanded.r = makeNode([
                            newRule.r,
                            expandsym
                        ]);
                    }
                    break;
                case "function":
                    newRule = rule;
                    break;
                default:
                    throw TypeError("Unsupported type of rule: " + ruleType);
            } // console.log('Adding rule: ' + rules[i])
            // console.log(newRule)
            ruleSet.push(newRule);
        }
        return ruleSet;
    }
    var _lastsym = 0;
    function _getExpandPlaceholderSymbol() {
        return new SymbolNode("_p" + _lastsym++);
    }
    /**
   * Returns a simplfied form of node, or the original node if no simplification was possible.
   *
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} The simplified form of `expr`, or the original node if no simplification was possible.
   */ var applyRule = typed("applyRule", {
        "Node, Object": function NodeObject(node, rule) {
            // console.log('Entering applyRule(' + node.toString() + ')')
            // Do not clone node unless we find a match
            var res = node; // First replace our child nodes with their simplified versions
            // If a child could not be simplified, the assignments will have
            // no effect since the node is returned unchanged
            if (res instanceof OperatorNode || res instanceof FunctionNode) {
                if (res.args) for(var i = 0; i < res.args.length; i++)res.args[i] = applyRule(res.args[i], rule);
            } else if (res instanceof ParenthesisNode) {
                if (res.content) res.content = applyRule(res.content, rule);
            } // Try to match a rule against this node
            var repl = rule.r;
            var matches = _ruleMatch(rule.l, res)[0]; // If the rule is associative operator, we can try matching it while allowing additional terms.
            // This allows us to match rules like 'n+n' to the expression '(1+x)+x' or even 'x+1+x' if the operator is commutative.
            if (!matches && rule.expanded) {
                repl = rule.expanded.r;
                matches = _ruleMatch(rule.expanded.l, res)[0];
            }
            if (matches) {
                // const before = res.toString({parenthesis: 'all'})
                // Create a new node by cloning the rhs of the matched rule
                // we keep any implicit multiplication state if relevant
                var implicit = res.implicit;
                res = repl.clone();
                if (implicit && "implicit" in repl) res.implicit = true;
                 // Replace placeholders with their respective nodes without traversing deeper into the replaced nodes
                res = res.transform(function(node) {
                    if (node.isSymbolNode && (0, $glBd7.hasOwnProperty)(matches.placeholders, node.name)) return matches.placeholders[node.name].clone();
                    else return node;
                }); // const after = res.toString({parenthesis: 'all'})
            // console.log('Simplified ' + before + ' to ' + after)
            }
            return res;
        }
    });
    /**
   * Get (binary) combinations of a flattened binary node
   * e.g. +(node1, node2, node3) -> [
   *        +(node1,  +(node2, node3)),
   *        +(node2,  +(node1, node3)),
   *        +(node3,  +(node1, node2))]
   *
   */ function getSplits(node, context) {
        var res = [];
        var right, rightArgs;
        var makeNode = createMakeNodeFunction(node);
        if (isCommutative(node, context)) for(var i = 0; i < node.args.length; i++){
            rightArgs = node.args.slice(0);
            rightArgs.splice(i, 1);
            right = rightArgs.length === 1 ? rightArgs[0] : makeNode(rightArgs);
            res.push(makeNode([
                node.args[i],
                right
            ]));
        }
        else {
            rightArgs = node.args.slice(1);
            right = rightArgs.length === 1 ? rightArgs[0] : makeNode(rightArgs);
            res.push(makeNode([
                node.args[0],
                right
            ]));
        }
        return res;
    }
    /**
   * Returns the set union of two match-placeholders or null if there is a conflict.
   */ function mergeMatch(match1, match2) {
        var res = {
            placeholders: {}
        }; // Some matches may not have placeholders; this is OK
        if (!match1.placeholders && !match2.placeholders) return res;
        else if (!match1.placeholders) return match2;
        else if (!match2.placeholders) return match1;
         // Placeholders with the same key must match exactly
        for(var key in match1.placeholders){
            res.placeholders[key] = match1.placeholders[key];
            if ((0, $glBd7.hasOwnProperty)(match2.placeholders, key)) {
                if (!_exactMatch(match1.placeholders[key], match2.placeholders[key])) return null;
            }
        }
        for(var _key in match2.placeholders)res.placeholders[_key] = match2.placeholders[_key];
        return res;
    }
    /**
   * Combine two lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
   * Each list represents matches found in one child of a node.
   */ function combineChildMatches(list1, list2) {
        var res = [];
        if (list1.length === 0 || list2.length === 0) return res;
        var merged;
        for(var i1 = 0; i1 < list1.length; i1++)for(var i2 = 0; i2 < list2.length; i2++){
            merged = mergeMatch(list1[i1], list2[i2]);
            if (merged) res.push(merged);
        }
        return res;
    }
    /**
   * Combine multiple lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
   * Each list represents matches found in one child of a node.
   * Returns a list of unique matches.
   */ function mergeChildMatches(childMatches) {
        if (childMatches.length === 0) return childMatches;
        var sets = childMatches.reduce(combineChildMatches);
        var uniqueSets = [];
        var unique = {};
        for(var i = 0; i < sets.length; i++){
            var s = JSON.stringify(sets[i]);
            if (!unique[s]) {
                unique[s] = true;
                uniqueSets.push(sets[i]);
            }
        }
        return uniqueSets;
    }
    /**
   * Determines whether node matches rule.
   *
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} rule
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @return {Object} Information about the match, if it exists.
   */ function _ruleMatch(rule, node, isSplit) {
        //    console.log('Entering _ruleMatch(' + JSON.stringify(rule) + ', ' + JSON.stringify(node) + ')')
        //    console.log('rule = ' + rule)
        //    console.log('node = ' + node)
        //    console.log('Entering _ruleMatch(' + rule.toString() + ', ' + node.toString() + ')')
        var res = [
            {
                placeholders: {}
            }
        ];
        if (rule instanceof OperatorNode && node instanceof OperatorNode || rule instanceof FunctionNode && node instanceof FunctionNode) {
            // If the rule is an OperatorNode or a FunctionNode, then node must match exactly
            if (rule instanceof OperatorNode) {
                if (rule.op !== node.op || rule.fn !== node.fn) return [];
            } else if (rule instanceof FunctionNode) {
                if (rule.name !== node.name) return [];
            } // rule and node match. Search the children of rule and node.
            if (node.args.length === 1 && rule.args.length === 1 || !isAssociative(node) || isSplit) {
                // Expect non-associative operators to match exactly
                var childMatches = [];
                for(var i = 0; i < rule.args.length; i++){
                    var childMatch = _ruleMatch(rule.args[i], node.args[i]);
                    if (childMatch.length === 0) // Child did not match, so stop searching immediately
                    return [];
                     // The child matched, so add the information returned from the child to our result
                    childMatches.push(childMatch);
                }
                res = mergeChildMatches(childMatches);
            } else if (node.args.length >= 2 && rule.args.length === 2) {
                // node is flattened, rule is not
                // Associative operators/functions can be split in different ways so we check if the rule matches each
                // them and return their union.
                var splits = getSplits(node, rule.context);
                var splitMatches = [];
                for(var _i = 0; _i < splits.length; _i++){
                    var matchSet = _ruleMatch(rule, splits[_i], true); // recursing at the same tree depth here
                    splitMatches = splitMatches.concat(matchSet);
                }
                return splitMatches;
            } else if (rule.args.length > 2) throw Error("Unexpected non-binary associative function: " + rule.toString());
            else // Incorrect number of arguments in rule and node, so no match
            return [];
        } else if (rule instanceof SymbolNode) {
            // If the rule is a SymbolNode, then it carries a special meaning
            // according to the first character of the symbol node name.
            // c.* matches a ConstantNode
            // n.* matches any node
            if (rule.name.length === 0) throw new Error("Symbol in rule has 0 length...!?");
            if (SUPPORTED_CONSTANTS[rule.name]) {
                // built-in constant must match exactly
                if (rule.name !== node.name) return [];
            } else if (rule.name[0] === "n" || rule.name.substring(0, 2) === "_p") // rule matches _anything_, so assign this node to the rule.name placeholder
            // Assign node to the rule.name placeholder.
            // Our parent will check for matches among placeholders.
            res[0].placeholders[rule.name] = node;
            else if (rule.name[0] === "v") {
                // rule matches any variable thing (not a ConstantNode)
                if (!(0, $7E0JQ.isConstantNode)(node)) res[0].placeholders[rule.name] = node;
                else // Mis-match: rule was expecting something other than a ConstantNode
                return [];
            } else if (rule.name[0] === "c") {
                // rule matches any ConstantNode
                if (node instanceof ConstantNode) res[0].placeholders[rule.name] = node;
                else // Mis-match: rule was expecting a ConstantNode
                return [];
            } else throw new Error("Invalid symbol in rule: " + rule.name);
        } else if (rule instanceof ConstantNode) {
            // Literal constant must match exactly
            if (!equal(rule.value, node.value)) return [];
        } else // Some other node was encountered which we aren't prepared for, so no match
        return [];
         // It's a match!
        // console.log('_ruleMatch(' + rule.toString() + ', ' + node.toString() + ') found a match')
        return res;
    }
    /**
   * Determines whether p and q (and all their children nodes) are identical.
   *
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} p
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} q
   * @return {Object} Information about the match, if it exists.
   */ function _exactMatch(p, q) {
        if (p instanceof ConstantNode && q instanceof ConstantNode) {
            if (!equal(p.value, q.value)) return false;
        } else if (p instanceof SymbolNode && q instanceof SymbolNode) {
            if (p.name !== q.name) return false;
        } else if (p instanceof OperatorNode && q instanceof OperatorNode || p instanceof FunctionNode && q instanceof FunctionNode) {
            if (p instanceof OperatorNode) {
                if (p.op !== q.op || p.fn !== q.fn) return false;
            } else if (p instanceof FunctionNode) {
                if (p.name !== q.name) return false;
            }
            if (p.args.length !== q.args.length) return false;
            for(var i = 0; i < p.args.length; i++){
                if (!_exactMatch(p.args[i], q.args[i])) return false;
            }
        } else return false;
        return true;
    }
    return simplify;
});

});
parcelRegister("j90kH", function(module, exports) {

$parcel$export(module.exports, "createResolve", function () { return $deff1db53f653d8b$export$de059f4622c7c2ca; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $deff1db53f653d8b$var$name = "resolve";
var $deff1db53f653d8b$var$dependencies = [
    "parse",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode"
];
var $deff1db53f653d8b$export$de059f4622c7c2ca = /* #__PURE__ */ (0, $jKx4O.factory)($deff1db53f653d8b$var$name, $deff1db53f653d8b$var$dependencies, function(_ref) {
    var parse = _ref.parse, FunctionNode = _ref.FunctionNode, OperatorNode = _ref.OperatorNode, ParenthesisNode = _ref.ParenthesisNode;
    /**
   * resolve(expr, scope) replaces variable nodes with their scoped values
   *
   * Syntax:
   *
   *     simplify.resolve(expr, scope)
   *
   * Examples:
   *
   *     math.simplify.resolve('x + y', {x:1, y:2})           // Node {1 + 2}
   *     math.simplify.resolve(math.parse('x+y'), {x:1, y:2}) // Node {1 + 2}
   *     math.simplify('x+y', {x:2, y:'x+x'}).toString()      // "6"
   *
   * @param {Node} node
   *     The expression tree to be simplified
   * @param {Object} scope with variables to be resolved
   */ function resolve(node, scope) {
        if (!scope) return node;
        if ((0, $7E0JQ.isSymbolNode)(node)) {
            var value = scope[node.name];
            if ((0, $7E0JQ.isNode)(value)) return resolve(value, scope);
            else if (typeof value === "number") return parse(String(value));
        } else if ((0, $7E0JQ.isOperatorNode)(node)) {
            var args = node.args.map(function(arg) {
                return resolve(arg, scope);
            });
            return new OperatorNode(node.op, node.fn, args, node.implicit);
        } else if ((0, $7E0JQ.isParenthesisNode)(node)) return new ParenthesisNode(resolve(node.content, scope));
        else if ((0, $7E0JQ.isFunctionNode)(node)) {
            var _args = node.args.map(function(arg) {
                return resolve(arg, scope);
            });
            return new FunctionNode(node.name, _args);
        }
        return node;
    }
    return resolve;
});

});


parcelRegister("62vSW", function(module, exports) {

$parcel$export(module.exports, "createStdTransform", function () { return $465ba9b1cecac85e$export$ef5049c11f391200; });

var $jKx4O = parcelRequire("jKx4O");

var $d6FOT = parcelRequire("d6FOT");

var $7E0JQ = parcelRequire("7E0JQ");

var $aVkFN = parcelRequire("aVkFN");
var $465ba9b1cecac85e$var$name = "std";
var $465ba9b1cecac85e$var$dependencies = [
    "typed",
    "sqrt",
    "variance"
];
var $465ba9b1cecac85e$export$ef5049c11f391200 = /* #__PURE__ */ (0, $jKx4O.factory)($465ba9b1cecac85e$var$name, $465ba9b1cecac85e$var$dependencies, function(_ref) {
    var typed = _ref.typed, sqrt = _ref.sqrt, variance = _ref.variance;
    var std = (0, $d6FOT.createStd)({
        typed: typed,
        sqrt: sqrt,
        variance: variance
    });
    return typed("std", {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length >= 2 && (0, $7E0JQ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $7E0JQ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $7E0JQ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return std.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("d6FOT", function(module, exports) {

$parcel$export(module.exports, "createStd", function () { return $98ac46725cf8fa46$export$d3f0a8dda5df7afd; });

var $jKx4O = parcelRequire("jKx4O");
var $98ac46725cf8fa46$var$name = "std";
var $98ac46725cf8fa46$var$dependencies = [
    "typed",
    "sqrt",
    "variance"
];
var $98ac46725cf8fa46$export$d3f0a8dda5df7afd = /* #__PURE__ */ (0, $jKx4O.factory)($98ac46725cf8fa46$var$name, $98ac46725cf8fa46$var$dependencies, function(_ref) {
    var typed = _ref.typed, sqrt = _ref.sqrt, variance = _ref.variance;
    /**
   * Compute the standard deviation of a matrix or a  list with values.
   * The standard deviations is defined as the square root of the variance:
   * `std(A) = sqrt(variance(A))`.
   * In case of a (multi dimensional) array or matrix, the standard deviation
   * over all elements will be calculated by default, unless an axis is specified
   * in which case the standard deviation will be computed along that axis.
   *
   * Additionally, it is possible to compute the standard deviation along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Syntax:
   *
   *     math.std(a, b, c, ...)
   *     math.std(A)
   *     math.std(A, normalization)
   *     math.std(A, dimension)
   *     math.std(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.std(2, 4, 6)                     // returns 2
   *     math.std([2, 4, 6, 8])                // returns 2.581988897471611
   *     math.std([2, 4, 6, 8], 'uncorrected') // returns 2.23606797749979
   *     math.std([2, 4, 6, 8], 'biased')      // returns 2
   *
   *     math.std([[1, 2, 3], [4, 5, 6]])      // returns 1.8708286933869707
   *     math.std([[1, 2, 3], [4, 6, 8]], 0)    // returns [2.1213203435596424, 2.8284271247461903, 3.5355339059327378]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1)    // returns [1, 2]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.7071067811865476, 1.4142135623730951]
   *
   * See also:
   *
   *    mean, median, max, min, prod, sum, variance
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the standard deviation for a matrix
   * @return {*} The standard deviation
   */ return typed($98ac46725cf8fa46$var$name, {
        // std([a, b, c, d, ...])
        "Array | Matrix": _std,
        // std([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _std,
        // std([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": _std,
        // std([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _std,
        // std(a, b, c, d, ...)
        "...": function _(args) {
            return _std(args);
        }
    });
    function _std(array, normalization) {
        if (array.length === 0) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
        try {
            return sqrt(variance.apply(null, arguments));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf(" variance") !== -1) throw new TypeError(err.message.replace(" variance", " std"));
            else throw err;
        }
    }
});

});


parcelRegister("28Imc", function(module, exports) {

$parcel$export(module.exports, "createSubsetTransform", function () { return $18eebc871fae6c4d$export$3dd4e26b0ef52fd5; });

var $jKx4O = parcelRequire("jKx4O");

var $aVkFN = parcelRequire("aVkFN");

var $45MmH = parcelRequire("45MmH");
var $18eebc871fae6c4d$var$name = "subset";
var $18eebc871fae6c4d$var$dependencies = [
    "typed",
    "matrix"
];
var $18eebc871fae6c4d$export$3dd4e26b0ef52fd5 = /* #__PURE__ */ (0, $jKx4O.factory)($18eebc871fae6c4d$var$name, $18eebc871fae6c4d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    var subset = (0, $45MmH.createSubset)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Attach a transform function to math.subset
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed("subset", {
        "...any": function any(args) {
            try {
                return subset.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("45MmH", function(module, exports) {

$parcel$export(module.exports, "createSubset", function () { return $2fad255fa049e70b$export$d8c56e74d683bb33; });

var $7E0JQ = parcelRequire("7E0JQ");

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");

var $i3n6j = parcelRequire("i3n6j");

var $i7dcb = parcelRequire("i7dcb");

var $jKx4O = parcelRequire("jKx4O");
var $2fad255fa049e70b$var$name = "subset";
var $2fad255fa049e70b$var$dependencies = [
    "typed",
    "matrix"
];
var $2fad255fa049e70b$export$d8c56e74d683bb33 = /* #__PURE__ */ (0, $jKx4O.factory)($2fad255fa049e70b$var$name, $2fad255fa049e70b$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    /**
   * Get or set a subset of a matrix or string.
   *
   * Syntax:
   *     math.subset(value, index)                                // retrieve a subset
   *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
   *
   * Examples:
   *
   *     // get a subset
   *     const d = [[1, 2], [3, 4]]
   *     math.subset(d, math.index(1, 0))        // returns 3
   *     math.subset(d, math.index([0, 1], 1))   // returns [[2], [4]]
   *
   *     // replace a subset
   *     const e = []
   *     const f = math.subset(e, math.index(0, [0, 2]), [5, 6])  // f = [[5, 6]]
   *     const g = math.subset(f, math.index(1, 1), 7, 0)         // g = [[5, 6], [0, 7]]
   *
   * See also:
   *
   *     size, resize, squeeze, index
   *
   * @param {Array | Matrix | string} matrix  An array, matrix, or string
   * @param {Index} index                     An index containing ranges for each
   *                                          dimension
   * @param {*} [replacement]                 An array, matrix, or scalar.
   *                                          If provided, the subset is replaced with replacement.
   *                                          If not provided, the subset is returned
   * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
   *                                          the matrix is resized. If not provided,
   *                                          math.matrix elements will be left undefined.
   * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
   */ return typed($2fad255fa049e70b$var$name, {
        // get subset
        "Array, Index": function ArrayIndex(value, index) {
            var m = matrix(value);
            var subset = m.subset(index); // returns a Matrix
            return index.isScalar() ? subset : subset.valueOf(); // return an Array (like the input)
        },
        "Matrix, Index": function MatrixIndex(value, index) {
            return value.subset(index);
        },
        "Object, Index": $2fad255fa049e70b$var$_getObjectProperty,
        "string, Index": $2fad255fa049e70b$var$_getSubstring,
        // set subset
        "Array, Index, any": function ArrayIndexAny(value, index, replacement) {
            return matrix((0, $glBd7.clone)(value)).subset(index, replacement, undefined).valueOf();
        },
        "Array, Index, any, any": function ArrayIndexAnyAny(value, index, replacement, defaultValue) {
            return matrix((0, $glBd7.clone)(value)).subset(index, replacement, defaultValue).valueOf();
        },
        "Matrix, Index, any": function MatrixIndexAny(value, index, replacement) {
            return value.clone().subset(index, replacement);
        },
        "Matrix, Index, any, any": function MatrixIndexAnyAny(value, index, replacement, defaultValue) {
            return value.clone().subset(index, replacement, defaultValue);
        },
        "string, Index, string": $2fad255fa049e70b$var$_setSubstring,
        "string, Index, string, string": $2fad255fa049e70b$var$_setSubstring,
        "Object, Index, any": $2fad255fa049e70b$var$_setObjectProperty
    });
});
/**
 * Retrieve a subset of a string
 * @param {string} str            string from which to get a substring
 * @param {Index} index           An index containing ranges for each dimension
 * @returns {string} substring
 * @private
 */ function $2fad255fa049e70b$var$_getSubstring(str, index) {
    if (!(0, $7E0JQ.isIndex)(index)) // TODO: better error message
    throw new TypeError("Index expected");
    if (index.size().length !== 1) throw new (0, $i7dcb.DimensionError)(index.size().length, 1);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $YkZ7e.validateIndex)(index.min()[0], strLen);
    (0, $YkZ7e.validateIndex)(index.max()[0], strLen);
    var range = index.dimension(0);
    var substr = "";
    range.forEach(function(v) {
        substr += str.charAt(v);
    });
    return substr;
}
/**
 * Replace a substring in a string
 * @param {string} str            string to be replaced
 * @param {Index} index           An index containing ranges for each dimension
 * @param {string} replacement    Replacement string
 * @param {string} [defaultValue] Default value to be uses when resizing
 *                                the string. is ' ' by default
 * @returns {string} result
 * @private
 */ function $2fad255fa049e70b$var$_setSubstring(str, index, replacement, defaultValue) {
    if (!index || index.isIndex !== true) // TODO: better error message
    throw new TypeError("Index expected");
    if (index.size().length !== 1) throw new (0, $i7dcb.DimensionError)(index.size().length, 1);
    if (defaultValue !== undefined) {
        if (typeof defaultValue !== "string" || defaultValue.length !== 1) throw new TypeError("Single character expected as defaultValue");
    } else defaultValue = " ";
    var range = index.dimension(0);
    var len = range.size()[0];
    if (len !== replacement.length) throw new (0, $i7dcb.DimensionError)(range.size()[0], replacement.length);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $YkZ7e.validateIndex)(index.min()[0]);
    (0, $YkZ7e.validateIndex)(index.max()[0]); // copy the string into an array with characters
    var chars = [];
    for(var i = 0; i < strLen; i++)chars[i] = str.charAt(i);
    range.forEach(function(v, i) {
        chars[v] = replacement.charAt(i[0]);
    }); // initialize undefined characters with a space
    if (chars.length > strLen) {
        for(var _i = strLen - 1, _len = chars.length; _i < _len; _i++)if (!chars[_i]) chars[_i] = defaultValue;
    }
    return chars.join("");
}
/**
 * Retrieve a property from an object
 * @param {Object} object
 * @param {Index} index
 * @return {*} Returns the value of the property
 * @private
 */ function $2fad255fa049e70b$var$_getObjectProperty(object, index) {
    if (index.size().length !== 1) throw new (0, $i7dcb.DimensionError)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
    return (0, $i3n6j.getSafeProperty)(object, key);
}
/**
 * Set a property on an object
 * @param {Object} object
 * @param {Index} index
 * @param {*} replacement
 * @return {*} Returns the updated object
 * @private
 */ function $2fad255fa049e70b$var$_setObjectProperty(object, index, replacement) {
    if (index.size().length !== 1) throw new (0, $i7dcb.DimensionError)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
     // clone the object, and apply the property to the clone
    var updated = (0, $glBd7.clone)(object);
    (0, $i3n6j.setSafeProperty)(updated, key, replacement);
    return updated;
}

});


parcelRegister("1KTTV", function(module, exports) {

$parcel$export(module.exports, "createSumTransform", function () { return $14757313f5bb22c1$export$1b9b65ea533d42ec; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $aVkFN = parcelRequire("aVkFN");

var $ixHXB = parcelRequire("ixHXB");
/**
 * Attach a transform function to math.sum
 * Adds a property transform containing the transform function.
 *
 * This transform changed the last `dim` parameter of function mean
 * from one-based to zero based
 */ var $14757313f5bb22c1$var$name = "sum";
var $14757313f5bb22c1$var$dependencies = [
    "typed",
    "config",
    "add",
    "?bignumber",
    "?fraction"
];
var $14757313f5bb22c1$export$1b9b65ea533d42ec = /* #__PURE__ */ (0, $jKx4O.factory)($14757313f5bb22c1$var$name, $14757313f5bb22c1$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, add = _ref.add, bignumber = _ref.bignumber, fraction = _ref.fraction;
    var sum = (0, $ixHXB.createSum)({
        typed: typed,
        config: config,
        add: add,
        bignumber: bignumber,
        fraction: fraction
    });
    return typed($14757313f5bb22c1$var$name, {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $7E0JQ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $7E0JQ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $7E0JQ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return sum.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("ixHXB", function(module, exports) {

$parcel$export(module.exports, "createSum", function () { return $d7fd68a593743cff$export$14d444d810bc35b5; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $dYvNV = parcelRequire("dYvNV");

var $94t5G = parcelRequire("94t5G");
var $d7fd68a593743cff$var$name = "sum";
var $d7fd68a593743cff$var$dependencies = [
    "typed",
    "config",
    "add",
    "?bignumber",
    "?fraction"
];
var $d7fd68a593743cff$export$14d444d810bc35b5 = /* #__PURE__ */ (0, $jKx4O.factory)($d7fd68a593743cff$var$name, $d7fd68a593743cff$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, add = _ref.add, bignumber = _ref.bignumber, fraction = _ref.fraction;
    /**
   * Compute the sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.sum(a, b, c, ...)
   *     math.sum(A)
   *
   * Examples:
   *
   *     math.sum(2, 1, 4, 3)               // returns 10
   *     math.sum([2, 1, 4, 3])             // returns 10
   *     math.sum([[2, 5], [4, 3], [1, 7]]) // returns 22
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The sum of all values
   */ return typed($d7fd68a593743cff$var$name, {
        // sum([a, b, c, d, ...])
        "Array | Matrix": _sum,
        // sum([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nsumDim,
        // sum(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $fbkGg.containsCollections)(args)) throw new TypeError("Scalar values expected in function sum");
            return _sum(args);
        }
    });
    /**
   * Recursively calculate the sum of an n-dimensional array
   * @param {Array} array
   * @return {number} sum
   * @private
   */ function _sum(array) {
        var sum;
        (0, $fbkGg.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
            } catch (err) {
                throw (0, $dYvNV.improveErrorMessage)(err, "sum", value);
            }
        });
        if (sum === undefined) switch(config.number){
            case "number":
                return 0;
            case "BigNumber":
                return bignumber ? bignumber(0) : (0, $94t5G.noBignumber)();
            case "Fraction":
                return fraction ? fraction(0) : (0, $94t5G.noFraction)();
            default:
                return 0;
        }
        return sum;
    }
    function _nsumDim(array, dim) {
        try {
            var sum = (0, $fbkGg.reduce)(array, dim, add);
            return sum;
        } catch (err) {
            throw (0, $dYvNV.improveErrorMessage)(err, "sum");
        }
    }
});

});


parcelRegister("8IaCc", function(module, exports) {

$parcel$export(module.exports, "createSymbolNode", function () { return $657aaab81bb15c51$export$b9e0005fc35ab4ee; });

var $7HWRb = parcelRequire("7HWRb");

var $i3n6j = parcelRequire("i3n6j");

var $jKx4O = parcelRequire("jKx4O");

var $fMJxQ = parcelRequire("fMJxQ");
var $657aaab81bb15c51$var$name = "SymbolNode";
var $657aaab81bb15c51$var$dependencies = [
    "math",
    "?Unit",
    "Node"
];
var $657aaab81bb15c51$export$b9e0005fc35ab4ee = /* #__PURE__ */ (0, $jKx4O.factory)($657aaab81bb15c51$var$name, $657aaab81bb15c51$var$dependencies, function(_ref) {
    var math = _ref.math, Unit = _ref.Unit, Node = _ref.Node;
    /**
   * Check whether some name is a valueless unit like "inch".
   * @param {string} name
   * @return {boolean}
   */ function isValuelessUnit(name) {
        return Unit ? Unit.isValuelessUnit(name) : false;
    }
    /**
   * @constructor SymbolNode
   * @extends {Node}
   * A symbol node can hold and resolve a symbol
   * @param {string} name
   * @extends {Node}
   */ function SymbolNode(name) {
        if (!(this instanceof SymbolNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof name !== "string") throw new TypeError('String expected for parameter "name"');
        this.name = name;
    }
    SymbolNode.prototype = new Node();
    SymbolNode.prototype.type = "SymbolNode";
    SymbolNode.prototype.isSymbolNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ SymbolNode.prototype._compile = function(math, argNames) {
        var name = this.name;
        if (argNames[name] === true) // this is a FunctionAssignment argument
        // (like an x when inside the expression of a function assignment `f(x) = ...`)
        return function(scope, args, context) {
            return args[name];
        };
        else if (name in math) return function(scope, args, context) {
            return name in scope ? (0, $i3n6j.getSafeProperty)(scope, name) : (0, $i3n6j.getSafeProperty)(math, name);
        };
        else {
            var isUnit = isValuelessUnit(name);
            return function(scope, args, context) {
                return name in scope ? (0, $i3n6j.getSafeProperty)(scope, name) : isUnit ? new Unit(null, name) : undef(name);
            };
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ SymbolNode.prototype.forEach = function(callback) {} // nothing to do, we don't have childs
     /**
   * Create a new SymbolNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {SymbolNode} Returns a clone of the node
   */ ;
    SymbolNode.prototype.map = function(callback) {
        return this.clone();
    };
    /**
   * Throws an error 'Undefined symbol {name}'
   * @param {string} name
   */ function undef(name) {
        throw new Error("Undefined symbol " + name);
    }
    /**
   * Create a clone of this node, a shallow copy
   * @return {SymbolNode}
   */ SymbolNode.prototype.clone = function() {
        return new SymbolNode(this.name);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype._toString = function(options) {
        return this.name;
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype.toHTML = function(options) {
        var name = (0, $7HWRb.escape)(this.name);
        if (name === "true" || name === "false") return '<span class="math-symbol math-boolean">' + name + "</span>";
        else if (name === "i") return '<span class="math-symbol math-imaginary-symbol">' + name + "</span>";
        else if (name === "Infinity") return '<span class="math-symbol math-infinity-symbol">' + name + "</span>";
        else if (name === "NaN") return '<span class="math-symbol math-nan-symbol">' + name + "</span>";
        else if (name === "null") return '<span class="math-symbol math-null-symbol">' + name + "</span>";
        else if (name === "undefined") return '<span class="math-symbol math-undefined-symbol">' + name + "</span>";
        return '<span class="math-symbol">' + name + "</span>";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ SymbolNode.prototype.toJSON = function() {
        return {
            mathjs: "SymbolNode",
            name: this.name
        };
    };
    /**
   * Instantiate a SymbolNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SymbolNode", name: "x"}`,
   *                       where mathjs is optional
   * @returns {SymbolNode}
   */ SymbolNode.fromJSON = function(json) {
        return new SymbolNode(json.name);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype._toTex = function(options) {
        var isUnit = false;
        if (typeof math[this.name] === "undefined" && isValuelessUnit(this.name)) isUnit = true;
        var symbol = (0, $fMJxQ.toSymbol)(this.name, isUnit);
        if (symbol[0] === "\\") // no space needed if the symbol starts with '\'
        return symbol;
         // the space prevents symbols from breaking stuff like '\cdot' if it's written right before the symbol
        return " " + symbol;
    };
    return SymbolNode;
}, {
    isClass: true,
    isNode: true
});

});

parcelRegister("g0yJb", function(module, exports) {

$parcel$export(module.exports, "createVarianceTransform", function () { return $ba7795a7fb10c6bf$export$8ab5ca08ecd18ef3; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");

var $aVkFN = parcelRequire("aVkFN");

var $4iWoN = parcelRequire("4iWoN");
var $ba7795a7fb10c6bf$var$name = "variance";
var $ba7795a7fb10c6bf$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $ba7795a7fb10c6bf$export$8ab5ca08ecd18ef3 = /* #__PURE__ */ (0, $jKx4O.factory)($ba7795a7fb10c6bf$var$name, $ba7795a7fb10c6bf$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, apply = _ref.apply, isNaN = _ref.isNaN;
    var variance = (0, $4iWoN.createVariance)({
        typed: typed,
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide,
        apply: apply,
        isNaN: isNaN
    });
    return typed($ba7795a7fb10c6bf$var$name, {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length >= 2 && (0, $7E0JQ.isCollection)(args[0])) {
                var dim = args[1];
                if ((0, $7E0JQ.isNumber)(dim)) args[1] = dim - 1;
                else if ((0, $7E0JQ.isBigNumber)(dim)) args[1] = dim.minus(1);
            }
            try {
                return variance.apply(null, args);
            } catch (err) {
                throw (0, $aVkFN.errorTransform)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});

});
parcelRegister("4iWoN", function(module, exports) {

$parcel$export(module.exports, "createVariance", function () { return $322624b0820f8de4$export$b989221824390fb; });

var $fbkGg = parcelRequire("fbkGg");

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $dYvNV = parcelRequire("dYvNV");

var $9okwi = parcelRequire("9okwi");
var $322624b0820f8de4$var$DEFAULT_NORMALIZATION = "unbiased";
var $322624b0820f8de4$var$name = "variance";
var $322624b0820f8de4$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $322624b0820f8de4$export$b989221824390fb = /* #__PURE__ */ (0, $jKx4O.factory)($322624b0820f8de4$var$name, $322624b0820f8de4$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, subtract = _ref.subtract, multiply = _ref.multiply, divide = _ref.divide, apply = _ref.apply, isNaN = _ref.isNaN;
    /**
   * Compute the variance of a matrix or a  list with values.
   * In case of a (multi dimensional) array or matrix, the variance over all
   * elements will be calculated.
   *
   * Additionally, it is possible to compute the variance along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Note that older browser may not like the variable name `var`. In that
   * case, the function can be called as `math['var'](...)` instead of
   * `math.var(...)`.
   *
   * Syntax:
   *
   *     math.variance(a, b, c, ...)
   *     math.variance(A)
   *     math.variance(A, normalization)
   *     math.variance(A, dimension)
   *     math.variance(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.variance(2, 4, 6)                     // returns 4
   *     math.variance([2, 4, 6, 8])                // returns 6.666666666666667
   *     math.variance([2, 4, 6, 8], 'uncorrected') // returns 5
   *     math.variance([2, 4, 6, 8], 'biased')      // returns 4
   *
   *     math.variance([[1, 2, 3], [4, 5, 6]])      // returns 3.5
   *     math.variance([[1, 2, 3], [4, 6, 8]], 0)   // returns [4.5, 8, 12.5]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1)   // returns [1, 4]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.5, 2]
   *
   * See also:
   *
   *    mean, median, max, min, prod, std, sum
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the variance for a matrix
   * @return {*} The variance
   */ return typed($322624b0820f8de4$var$name, {
        // variance([a, b, c, d, ...])
        "Array | Matrix": function ArrayMatrix(array) {
            return _var(array, $322624b0820f8de4$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _var,
        // variance([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return _varDim(array, dim, $322624b0820f8de4$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _varDim,
        // variance(a, b, c, d, ...)
        "...": function _(args) {
            return _var(args, $322624b0820f8de4$var$DEFAULT_NORMALIZATION);
        }
    });
    /**
   * Recursively calculate the variance of an n-dimensional array
   * @param {Array} array
   * @param {string} normalization
   *                        Determines how to normalize the variance:
   *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
   *                        - 'uncorrected' The sum of squared errors is divided by n
   *                        - 'biased'      The sum of squared errors is divided by (n + 1)
   * @return {number | BigNumber} variance
   * @private
   */ function _var(array, normalization) {
        var sum = 0;
        var num = 0;
        if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
         // calculate the mean and number of elements
        (0, $fbkGg.deepForEach)(array, function(value) {
            try {
                sum = add(sum, value);
                num++;
            } catch (err) {
                throw (0, $dYvNV.improveErrorMessage)(err, "variance", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate variance of an empty array");
        var mean = divide(sum, num); // calculate the variance
        sum = 0;
        (0, $fbkGg.deepForEach)(array, function(value) {
            var diff = subtract(value, mean);
            sum = add(sum, multiply(diff, diff));
        });
        if (isNaN(sum)) return sum;
        switch(normalization){
            case "uncorrected":
                return divide(sum, num);
            case "biased":
                return divide(sum, num + 1);
            case "unbiased":
                var zero = (0, $7E0JQ.isBigNumber)(sum) ? sum.mul(0) : 0;
                return num === 1 ? zero : divide(sum, num - 1);
            default:
                throw new Error('Unknown normalization "' + normalization + '". ' + 'Choose "unbiased" (default), "uncorrected", or "biased".');
        }
    }
    function _varDim(array, dim, normalization) {
        try {
            if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
            return apply(array, dim, function(x) {
                return _var(x, normalization);
            });
        } catch (err) {
            throw (0, $dYvNV.improveErrorMessage)(err, "variance");
        }
    }
}); // For backward compatibility, deprecated since version 6.0.0. Date: 2018-11-09
var $322624b0820f8de4$export$aa3270b68c308b31 = /* #__PURE__ */ (0, $jKx4O.factory)("var", [
    "variance"
], function(_ref2) {
    var variance = _ref2.variance;
    return function() {
        (0, $9okwi.warnOnce)('Function "var" has been renamed to "variance" in v6.0.0, please use the new function instead.');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return variance.apply(variance, args);
    };
});

});


parcelRegister("lb8Oa", function(module, exports) {

$parcel$export(module.exports, "ResultSet", function () { return $f6b17530da552cda$export$aebd5179ff543a90; });
$parcel$export(module.exports, "Complex", function () { return $f6b17530da552cda$export$50ceb3fb9926e63e; });
$parcel$export(module.exports, "Range", function () { return $f6b17530da552cda$export$9a58ef0d7ad3278c; });
$parcel$export(module.exports, "eye", function () { return $f6b17530da552cda$export$4e18cf730a59887e; });
$parcel$export(module.exports, "_false", function () { return $f6b17530da552cda$export$f650004d56f90c2a; });
$parcel$export(module.exports, "_null", function () { return $f6b17530da552cda$export$a2cbb38cda512d16; });
$parcel$export(module.exports, "_true", function () { return $f6b17530da552cda$export$93f71dfe5e50cd3e; });
$parcel$export(module.exports, "BigNumber", function () { return $f6b17530da552cda$export$d97aa349ed20696; });
$parcel$export(module.exports, "Matrix", function () { return $f6b17530da552cda$export$5b12bf1653c0dd85; });
$parcel$export(module.exports, "replacer", function () { return $f6b17530da552cda$export$b644b65666fe0c18; });
$parcel$export(module.exports, "i", function () { return $f6b17530da552cda$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "LN10", function () { return $f6b17530da552cda$export$c44341d65988fdd6; });
$parcel$export(module.exports, "LOG10E", function () { return $f6b17530da552cda$export$5ed2c057bd191c66; });
$parcel$export(module.exports, "_NaN", function () { return $f6b17530da552cda$export$14edd9ca775dcd61; });
$parcel$export(module.exports, "pi", function () { return $f6b17530da552cda$export$18c7bea995a110f; });
$parcel$export(module.exports, "SQRT1_2", function () { return $f6b17530da552cda$export$83247d8be11c091e; });
$parcel$export(module.exports, "tau", function () { return $f6b17530da552cda$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "efimovFactor", function () { return $f6b17530da552cda$export$9ea6550edaaee998; });
$parcel$export(module.exports, "fineStructure", function () { return $f6b17530da552cda$export$5c15dd8d2782cbd0; });
$parcel$export(module.exports, "sackurTetrode", function () { return $f6b17530da552cda$export$a7100dcd4c5af6d4; });
$parcel$export(module.exports, "weakMixingAngle", function () { return $f6b17530da552cda$export$857d2e3e2bc524d0; });
$parcel$export(module.exports, "Fraction", function () { return $f6b17530da552cda$export$b336c2702c498be5; });
$parcel$export(module.exports, "e", function () { return $f6b17530da552cda$export$f1e1789686576879; });
$parcel$export(module.exports, "_Infinity", function () { return $f6b17530da552cda$export$20607595d292e7d3; });
$parcel$export(module.exports, "LOG2E", function () { return $f6b17530da552cda$export$8c2c65adacba8d14; });
$parcel$export(module.exports, "version", function () { return $f6b17530da552cda$export$83d89fbfd8236492; });
$parcel$export(module.exports, "DenseMatrix", function () { return $f6b17530da552cda$export$97f0d27b48f120e8; });
$parcel$export(module.exports, "phi", function () { return $f6b17530da552cda$export$324943737027944a; });
$parcel$export(module.exports, "typed", function () { return $f6b17530da552cda$export$519f616c41a1c711; });
$parcel$export(module.exports, "isInteger", function () { return $f6b17530da552cda$export$a287f47fed4544b8; });
$parcel$export(module.exports, "isNumeric", function () { return $f6b17530da552cda$export$e90fb89750dba83f; });
$parcel$export(module.exports, "isPositive", function () { return $f6b17530da552cda$export$7e69d4236fcc3b19; });
$parcel$export(module.exports, "isNaN", function () { return $f6b17530da552cda$export$c9f5652083b8129d; });
$parcel$export(module.exports, "equalScalar", function () { return $f6b17530da552cda$export$943761f5c9c3f156; });
$parcel$export(module.exports, "number", function () { return $f6b17530da552cda$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $f6b17530da552cda$export$4a21f16c33752377; });
$parcel$export(module.exports, "complex", function () { return $f6b17530da552cda$export$83a0e34f1302825b; });
$parcel$export(module.exports, "splitUnit", function () { return $f6b17530da552cda$export$dd67294014106b35; });
$parcel$export(module.exports, "unaryPlus", function () { return $f6b17530da552cda$export$df8c837ae5df4ce4; });
$parcel$export(module.exports, "apply", function () { return $f6b17530da552cda$export$5635d7ef4b8fee1c; });
$parcel$export(module.exports, "cube", function () { return $f6b17530da552cda$export$2b0340f6c7dec49a; });
$parcel$export(module.exports, "expm1", function () { return $f6b17530da552cda$export$b6c0a80d46d3391d; });
$parcel$export(module.exports, "log10", function () { return $f6b17530da552cda$export$75e08744a3ff8516; });
$parcel$export(module.exports, "multiplyScalar", function () { return $f6b17530da552cda$export$c697bed75648cdb7; });
$parcel$export(module.exports, "sign", function () { return $f6b17530da552cda$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "square", function () { return $f6b17530da552cda$export$dd4f28cef696bc7d; });
$parcel$export(module.exports, "bitNot", function () { return $f6b17530da552cda$export$aabc449fa5b5f4c0; });
$parcel$export(module.exports, "arg", function () { return $f6b17530da552cda$export$d8da458ed75e15b; });
$parcel$export(module.exports, "im", function () { return $f6b17530da552cda$export$5fc500b917996661; });
$parcel$export(module.exports, "not", function () { return $f6b17530da552cda$export$6003a5f097c73977; });
$parcel$export(module.exports, "filter", function () { return $f6b17530da552cda$export$3dea766d36a8935f; });
$parcel$export(module.exports, "forEach", function () { return $f6b17530da552cda$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "map", function () { return $f6b17530da552cda$export$871de8747c9eaa88; });
$parcel$export(module.exports, "erf", function () { return $f6b17530da552cda$export$d3896f355fc09423; });
$parcel$export(module.exports, "format", function () { return $f6b17530da552cda$export$d9468344d3651243; });
$parcel$export(module.exports, "isPrime", function () { return $f6b17530da552cda$export$8676dd5fabd5ee34; });
$parcel$export(module.exports, "acos", function () { return $f6b17530da552cda$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "acot", function () { return $f6b17530da552cda$export$4919a578c4aafd3; });
$parcel$export(module.exports, "acsc", function () { return $f6b17530da552cda$export$43298db932064b4a; });
$parcel$export(module.exports, "asec", function () { return $f6b17530da552cda$export$ec42f46098b24bb4; });
$parcel$export(module.exports, "asin", function () { return $f6b17530da552cda$export$41726bdb1fc63f; });
$parcel$export(module.exports, "atan", function () { return $f6b17530da552cda$export$628dc4eed22b0fbd; });
$parcel$export(module.exports, "atanh", function () { return $f6b17530da552cda$export$21ea955025ceb08b; });
$parcel$export(module.exports, "cosh", function () { return $f6b17530da552cda$export$2e2fd1ad24e4d350; });
$parcel$export(module.exports, "coth", function () { return $f6b17530da552cda$export$fe7b8a3b046ac25b; });
$parcel$export(module.exports, "csch", function () { return $f6b17530da552cda$export$ca7427e8bf42a21b; });
$parcel$export(module.exports, "sech", function () { return $f6b17530da552cda$export$becbc39f348ea65e; });
$parcel$export(module.exports, "sinh", function () { return $f6b17530da552cda$export$545004b505d7c555; });
$parcel$export(module.exports, "tanh", function () { return $f6b17530da552cda$export$7128670e45beef9a; });
$parcel$export(module.exports, "combinations", function () { return $f6b17530da552cda$export$bdfcf4c6b5766439; });
$parcel$export(module.exports, "pickRandom", function () { return $f6b17530da552cda$export$2e015b6955893291; });
$parcel$export(module.exports, "randomInt", function () { return $f6b17530da552cda$export$3c5f89dae98e900b; });
$parcel$export(module.exports, "LN2", function () { return $f6b17530da552cda$export$578b45ddcdefa518; });
$parcel$export(module.exports, "clone", function () { return $f6b17530da552cda$export$9cd59f9826255e47; });
$parcel$export(module.exports, "hasNumericValue", function () { return $f6b17530da552cda$export$f6fc628e09f3ff5d; });
$parcel$export(module.exports, "typeOf", function () { return $f6b17530da552cda$export$f5bbd400c2f4426f; });
$parcel$export(module.exports, "string", function () { return $f6b17530da552cda$export$22b082955e083ec3; });
$parcel$export(module.exports, "fraction", function () { return $f6b17530da552cda$export$7f34ce79760854f7; });
$parcel$export(module.exports, "unaryMinus", function () { return $f6b17530da552cda$export$6cd304851a69e08; });
$parcel$export(module.exports, "addScalar", function () { return $f6b17530da552cda$export$2b7b095c4f443355; });
$parcel$export(module.exports, "exp", function () { return $f6b17530da552cda$export$b310ec824aaee37f; });
$parcel$export(module.exports, "log2", function () { return $f6b17530da552cda$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "sqrt", function () { return $f6b17530da552cda$export$eba8049fb5020b81; });
$parcel$export(module.exports, "conj", function () { return $f6b17530da552cda$export$fb254c661fe9c0db; });
$parcel$export(module.exports, "getMatrixDataType", function () { return $f6b17530da552cda$export$42c7d1d712906e32; });
$parcel$export(module.exports, "mode", function () { return $f6b17530da552cda$export$549ff81930776885; });
$parcel$export(module.exports, "print", function () { return $f6b17530da552cda$export$c2d084dc44961371; });
$parcel$export(module.exports, "acosh", function () { return $f6b17530da552cda$export$b26caf0f29211d08; });
$parcel$export(module.exports, "acsch", function () { return $f6b17530da552cda$export$eafdb403a25900df; });
$parcel$export(module.exports, "asinh", function () { return $f6b17530da552cda$export$839d8a01b6af4fc0; });
$parcel$export(module.exports, "cos", function () { return $f6b17530da552cda$export$50d414a77b60d802; });
$parcel$export(module.exports, "csc", function () { return $f6b17530da552cda$export$a830b5ed334924be; });
$parcel$export(module.exports, "sin", function () { return $f6b17530da552cda$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "combinationsWithRep", function () { return $f6b17530da552cda$export$f297162cf5d656b2; });
$parcel$export(module.exports, "random", function () { return $f6b17530da552cda$export$4385e60b38654f68; });
$parcel$export(module.exports, "SQRT2", function () { return $f6b17530da552cda$export$3681641e15b6e2c3; });
$parcel$export(module.exports, "isNegative", function () { return $f6b17530da552cda$export$d0909a4f38b5c4d0; });
$parcel$export(module.exports, "SparseMatrix", function () { return $f6b17530da552cda$export$de9b2b7556879848; });
$parcel$export(module.exports, "matrix", function () { return $f6b17530da552cda$export$9bdad1ae37d738e0; });
$parcel$export(module.exports, "cbrt", function () { return $f6b17530da552cda$export$841fc4d5a1480b85; });
$parcel$export(module.exports, "gcd", function () { return $f6b17530da552cda$export$f81847884871263e; });
$parcel$export(module.exports, "mod", function () { return $f6b17530da552cda$export$842a2cf37af977e1; });
$parcel$export(module.exports, "nthRoot", function () { return $f6b17530da552cda$export$cc5da69d359d7991; });
$parcel$export(module.exports, "xgcd", function () { return $f6b17530da552cda$export$6ba103b0465fe6cc; });
$parcel$export(module.exports, "bitAnd", function () { return $f6b17530da552cda$export$a74ff8d3fdef72fc; });
$parcel$export(module.exports, "bitXor", function () { return $f6b17530da552cda$export$bfcff4501301c191; });
$parcel$export(module.exports, "or", function () { return $f6b17530da552cda$export$252bb8b3bbdf6749; });
$parcel$export(module.exports, "concat", function () { return $f6b17530da552cda$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "diag", function () { return $f6b17530da552cda$export$c042e7c2f59bc046; });
$parcel$export(module.exports, "identity", function () { return $f6b17530da552cda$export$f0954fd7d5368655; });
$parcel$export(module.exports, "ones", function () { return $f6b17530da552cda$export$21041dee6b8001b0; });
$parcel$export(module.exports, "reshape", function () { return $f6b17530da552cda$export$9eaad88cf88cee2b; });
$parcel$export(module.exports, "size", function () { return $f6b17530da552cda$export$346677f925de839c; });
$parcel$export(module.exports, "subset", function () { return $f6b17530da552cda$export$e06bd7b1ab877a71; });
$parcel$export(module.exports, "zeros", function () { return $f6b17530da552cda$export$4445a00dafa2633b; });
$parcel$export(module.exports, "to", function () { return $f6b17530da552cda$export$2c618a4308a30424; });
$parcel$export(module.exports, "round", function () { return $f6b17530da552cda$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "leftShift", function () { return $f6b17530da552cda$export$48901d58d322262f; });
$parcel$export(module.exports, "rightLogShift", function () { return $f6b17530da552cda$export$502f8a5a1147da; });
$parcel$export(module.exports, "compare", function () { return $f6b17530da552cda$export$398604a469f7de9a; });
$parcel$export(module.exports, "compareText", function () { return $f6b17530da552cda$export$2da9287da10b19e2; });
$parcel$export(module.exports, "smaller", function () { return $f6b17530da552cda$export$3f732695c1493aec; });
$parcel$export(module.exports, "larger", function () { return $f6b17530da552cda$export$a94a7414fa942aea; });
$parcel$export(module.exports, "unequal", function () { return $f6b17530da552cda$export$b20c1c5fa0c7dd75; });
$parcel$export(module.exports, "max", function () { return $f6b17530da552cda$export$8960430cfd85939f; });
$parcel$export(module.exports, "ImmutableDenseMatrix", function () { return $f6b17530da552cda$export$66fe727d7ec8c7b9; });
$parcel$export(module.exports, "FibonacciHeap", function () { return $f6b17530da552cda$export$dd5bb73729f20aa3; });
$parcel$export(module.exports, "sparse", function () { return $f6b17530da552cda$export$b6b7e189aa5d134c; });
$parcel$export(module.exports, "acoth", function () { return $f6b17530da552cda$export$6faaac9ab79fd3a4; });
$parcel$export(module.exports, "atan2", function () { return $f6b17530da552cda$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "sec", function () { return $f6b17530da552cda$export$e17a63917e2ebf0f; });
$parcel$export(module.exports, "add", function () { return $f6b17530da552cda$export$e16d8520af44a096; });
$parcel$export(module.exports, "trace", function () { return $f6b17530da552cda$export$357889f174732d38; });
$parcel$export(module.exports, "composition", function () { return $f6b17530da552cda$export$fd2cf6bce05a0b18; });
$parcel$export(module.exports, "isZero", function () { return $f6b17530da552cda$export$c46ec7d82fb1f602; });
$parcel$export(module.exports, "abs", function () { return $f6b17530da552cda$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "floor", function () { return $f6b17530da552cda$export$a3fe094919f356fd; });
$parcel$export(module.exports, "multiply", function () { return $f6b17530da552cda$export$2060d2db72cce88f; });
$parcel$export(module.exports, "dotMultiply", function () { return $f6b17530da552cda$export$c6d93afbf4ee8afc; });
$parcel$export(module.exports, "re", function () { return $f6b17530da552cda$export$b1f1627d659a651; });
$parcel$export(module.exports, "flatten", function () { return $f6b17530da552cda$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "resize", function () { return $f6b17530da552cda$export$4380c87abf28fdf; });
$parcel$export(module.exports, "squeeze", function () { return $f6b17530da552cda$export$889c931173b77c2f; });
$parcel$export(module.exports, "prod", function () { return $f6b17530da552cda$export$5e143010dea16c85; });
$parcel$export(module.exports, "pow", function () { return $f6b17530da552cda$export$9c297f60e22e3389; });
$parcel$export(module.exports, "dotPow", function () { return $f6b17530da552cda$export$ef3b15136279c2ab; });
$parcel$export(module.exports, "rightArithShift", function () { return $f6b17530da552cda$export$a1da16976d3a5f68; });
$parcel$export(module.exports, "compareNatural", function () { return $f6b17530da552cda$export$762e84baec56595d; });
$parcel$export(module.exports, "equalText", function () { return $f6b17530da552cda$export$5bc21f656fb5d284; });
$parcel$export(module.exports, "largerEq", function () { return $f6b17530da552cda$export$72693dfc692346df; });
$parcel$export(module.exports, "partitionSelect", function () { return $f6b17530da552cda$export$54d1e322cf7aa273; });
$parcel$export(module.exports, "min", function () { return $f6b17530da552cda$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "Spa", function () { return $f6b17530da552cda$export$6d4069f4b64f7492; });
$parcel$export(module.exports, "asech", function () { return $f6b17530da552cda$export$3aaf4e522be48075; });
$parcel$export(module.exports, "tan", function () { return $f6b17530da552cda$export$fcdd3b0b3246a325; });
$parcel$export(module.exports, "setSize", function () { return $f6b17530da552cda$export$1c70a6cc12bc0366; });
$parcel$export(module.exports, "norm", function () { return $f6b17530da552cda$export$1991ecd29cc92c6b; });
$parcel$export(module.exports, "quantileSeq", function () { return $f6b17530da552cda$export$ff63ee916cadcfe; });
$parcel$export(module.exports, "gamma", function () { return $f6b17530da552cda$export$a7ebe8cc6aaf8d37; });
$parcel$export(module.exports, "bignumber", function () { return $f6b17530da552cda$export$8576f72eb7f14a7e; });
$parcel$export(module.exports, "lcm", function () { return $f6b17530da552cda$export$f686d97e407ec4ef; });
$parcel$export(module.exports, "bitOr", function () { return $f6b17530da552cda$export$361eb278cc70bacf; });
$parcel$export(module.exports, "kron", function () { return $f6b17530da552cda$export$44f32dfde3d58545; });
$parcel$export(module.exports, "transpose", function () { return $f6b17530da552cda$export$9cb09a71b7d66923; });
$parcel$export(module.exports, "numeric", function () { return $f6b17530da552cda$export$b7a508fa8dae59fc; });
$parcel$export(module.exports, "and", function () { return $f6b17530da552cda$export$21c0ac7fe1cef1b8; });
$parcel$export(module.exports, "smallerEq", function () { return $f6b17530da552cda$export$8d38c87f33a93d98; });
$parcel$export(module.exports, "sort", function () { return $f6b17530da552cda$export$97db5808d8f88186; });
$parcel$export(module.exports, "cot", function () { return $f6b17530da552cda$export$ef569ec50496610c; });
$parcel$export(module.exports, "dot", function () { return $f6b17530da552cda$export$94132a0e348806d4; });
$parcel$export(module.exports, "sum", function () { return $f6b17530da552cda$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "factorial", function () { return $f6b17530da552cda$export$329ce89a99f0e343; });
$parcel$export(module.exports, "permutations", function () { return $f6b17530da552cda$export$4567adbe5dd91621; });
$parcel$export(module.exports, "ceil", function () { return $f6b17530da552cda$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "subtract", function () { return $f6b17530da552cda$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "cross", function () { return $f6b17530da552cda$export$bb646b20bb93d339; });
$parcel$export(module.exports, "ctranspose", function () { return $f6b17530da552cda$export$eb6ad7870b1d0b0b; });
$parcel$export(module.exports, "equal", function () { return $f6b17530da552cda$export$411ce8e5a71e3069; });
$parcel$export(module.exports, "Index", function () { return $f6b17530da552cda$export$cf17b003b6192af3; });
$parcel$export(module.exports, "setCartesian", function () { return $f6b17530da552cda$export$dcac7a71ff10ad82; });
$parcel$export(module.exports, "setDistinct", function () { return $f6b17530da552cda$export$ec60221e756bab15; });
$parcel$export(module.exports, "setIsSubset", function () { return $f6b17530da552cda$export$ca5251f59a067f9a; });
$parcel$export(module.exports, "setPowerset", function () { return $f6b17530da552cda$export$f6ce4c11993e56f2; });
$parcel$export(module.exports, "index", function () { return $f6b17530da552cda$export$b610b8812bbcded9; });
$parcel$export(module.exports, "fix", function () { return $f6b17530da552cda$export$d838837eb5b184e3; });
$parcel$export(module.exports, "range", function () { return $f6b17530da552cda$export$d02631cccf789723; });
$parcel$export(module.exports, "divideScalar", function () { return $f6b17530da552cda$export$67275f837d70084d; });
$parcel$export(module.exports, "nthRoots", function () { return $f6b17530da552cda$export$adb173527af10aca; });
$parcel$export(module.exports, "lsolve", function () { return $f6b17530da552cda$export$be3b83cc1aa539e4; });
$parcel$export(module.exports, "deepEqual", function () { return $f6b17530da552cda$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "setDifference", function () { return $f6b17530da552cda$export$8bd517cc5b3722f7; });
$parcel$export(module.exports, "setMultiplicity", function () { return $f6b17530da552cda$export$8bb4a52260216736; });
$parcel$export(module.exports, "hypot", function () { return $f6b17530da552cda$export$f95c7888b62f8e9a; });
$parcel$export(module.exports, "lup", function () { return $f6b17530da552cda$export$91d2d01a33a1e6f8; });
$parcel$export(module.exports, "slu", function () { return $f6b17530da552cda$export$95c7459688ef4e3a; });
$parcel$export(module.exports, "det", function () { return $f6b17530da552cda$export$d063d65fed97e7fa; });
$parcel$export(module.exports, "distance", function () { return $f6b17530da552cda$export$9f17032d917177de; });
$parcel$export(module.exports, "stirlingS2", function () { return $f6b17530da552cda$export$a5abae3de3985f2f; });
$parcel$export(module.exports, "catalan", function () { return $f6b17530da552cda$export$d8807a6c0487483a; });
$parcel$export(module.exports, "xor", function () { return $f6b17530da552cda$export$6444ef5cd411280c; });
$parcel$export(module.exports, "row", function () { return $f6b17530da552cda$export$120ff0929b202a6d; });
$parcel$export(module.exports, "dotDivide", function () { return $f6b17530da552cda$export$c74f132961c51406; });
$parcel$export(module.exports, "Unit", function () { return $f6b17530da552cda$export$1d8b9ae22d404866; });
$parcel$export(module.exports, "createUnit", function () { return $f6b17530da552cda$export$aab44654646f3ccc; });
$parcel$export(module.exports, "setSymDifference", function () { return $f6b17530da552cda$export$a7eac91d5496c35b; });
$parcel$export(module.exports, "qr", function () { return $f6b17530da552cda$export$7c27fb47516129d9; });
$parcel$export(module.exports, "inv", function () { return $f6b17530da552cda$export$c02accee9f2b6a8f; });
$parcel$export(module.exports, "expm", function () { return $f6b17530da552cda$export$d9bacaa51f70e8e; });
$parcel$export(module.exports, "divide", function () { return $f6b17530da552cda$export$cd007d971a5a2143; });
$parcel$export(module.exports, "mean", function () { return $f6b17530da552cda$export$1ce691f85baaa52; });
$parcel$export(module.exports, "variance", function () { return $f6b17530da552cda$export$9b77da0927470c3d; });
$parcel$export(module.exports, "std", function () { return $f6b17530da552cda$export$b14c5e819cb6c927; });
$parcel$export(module.exports, "multinomial", function () { return $f6b17530da552cda$export$f4d580f3101a1c7e; });
$parcel$export(module.exports, "atomicMass", function () { return $f6b17530da552cda$export$11b531e5540c3ca4; });
$parcel$export(module.exports, "bohrMagneton", function () { return $f6b17530da552cda$export$c779781d69f736e8; });
$parcel$export(module.exports, "boltzmann", function () { return $f6b17530da552cda$export$f727e86dcab4e2c6; });
$parcel$export(module.exports, "conductanceQuantum", function () { return $f6b17530da552cda$export$6eafe330bdda8c71; });
$parcel$export(module.exports, "deuteronMass", function () { return $f6b17530da552cda$export$80bf07f129ad1319; });
$parcel$export(module.exports, "electronMass", function () { return $f6b17530da552cda$export$c00fb43e712bef2c; });
$parcel$export(module.exports, "faraday", function () { return $f6b17530da552cda$export$7130fbae042d5c0f; });
$parcel$export(module.exports, "firstRadiation", function () { return $f6b17530da552cda$export$f83f3c3b84952e0b; });
$parcel$export(module.exports, "gravitationConstant", function () { return $f6b17530da552cda$export$d9cccfa50756330b; });
$parcel$export(module.exports, "hartreeEnergy", function () { return $f6b17530da552cda$export$37b0dd3693d47685; });
$parcel$export(module.exports, "klitzing", function () { return $f6b17530da552cda$export$10054c6b64de12f5; });
$parcel$export(module.exports, "magneticConstant", function () { return $f6b17530da552cda$export$ba3f3691dd1c5a7; });
$parcel$export(module.exports, "molarMass", function () { return $f6b17530da552cda$export$6d4ff429f3f89356; });
$parcel$export(module.exports, "molarPlanckConstant", function () { return $f6b17530da552cda$export$dacf4a2cf8881dff; });
$parcel$export(module.exports, "neutronMass", function () { return $f6b17530da552cda$export$ba7a41eda790cc15; });
$parcel$export(module.exports, "planckCharge", function () { return $f6b17530da552cda$export$9b1b4e5bc980cec6; });
$parcel$export(module.exports, "planckLength", function () { return $f6b17530da552cda$export$c20ab336465d7d5e; });
$parcel$export(module.exports, "planckTemperature", function () { return $f6b17530da552cda$export$5a85cd1a26c2cced; });
$parcel$export(module.exports, "protonMass", function () { return $f6b17530da552cda$export$1c88a737209eb089; });
$parcel$export(module.exports, "reducedPlanckConstant", function () { return $f6b17530da552cda$export$963167ae5579ea00; });
$parcel$export(module.exports, "secondRadiation", function () { return $f6b17530da552cda$export$1f7c42a78c01e4f9; });
$parcel$export(module.exports, "stefanBoltzmann", function () { return $f6b17530da552cda$export$f63e81544c3d56ef; });
$parcel$export(module.exports, "vacuumImpedance", function () { return $f6b17530da552cda$export$4b15dbe639ad9539; });
$parcel$export(module.exports, "column", function () { return $f6b17530da552cda$export$4e0c71f277ca26b3; });
$parcel$export(module.exports, "usolve", function () { return $f6b17530da552cda$export$41828460570e21eb; });
$parcel$export(module.exports, "setIntersect", function () { return $f6b17530da552cda$export$9404cfefeb010e68; });
$parcel$export(module.exports, "lusolve", function () { return $f6b17530da552cda$export$fccc724a69f253a; });
$parcel$export(module.exports, "eigs", function () { return $f6b17530da552cda$export$e822b38c59ee8a2a; });
$parcel$export(module.exports, "intersect", function () { return $f6b17530da552cda$export$1f4807a235930d45; });
$parcel$export(module.exports, "bellNumbers", function () { return $f6b17530da552cda$export$bb522a71cda46a13; });
$parcel$export(module.exports, "avogadro", function () { return $f6b17530da552cda$export$1236f2451dbdfd63; });
$parcel$export(module.exports, "classicalElectronRadius", function () { return $f6b17530da552cda$export$f48a0c6b8cc21601; });
$parcel$export(module.exports, "electricConstant", function () { return $f6b17530da552cda$export$11ff82822f958f25; });
$parcel$export(module.exports, "fermiCoupling", function () { return $f6b17530da552cda$export$84a9a66802fec40; });
$parcel$export(module.exports, "gravity", function () { return $f6b17530da552cda$export$bfb00cec0048377d; });
$parcel$export(module.exports, "loschmidt", function () { return $f6b17530da552cda$export$9eedba962d6a1c01; });
$parcel$export(module.exports, "molarMassC12", function () { return $f6b17530da552cda$export$9589ebe123df8f2e; });
$parcel$export(module.exports, "nuclearMagneton", function () { return $f6b17530da552cda$export$7274fb1d27d1cd19; });
$parcel$export(module.exports, "planckMass", function () { return $f6b17530da552cda$export$5ce790af25e5ac75; });
$parcel$export(module.exports, "quantumOfCirculation", function () { return $f6b17530da552cda$export$5d88bfa2004001d3; });
$parcel$export(module.exports, "speedOfLight", function () { return $f6b17530da552cda$export$5d66ae3b3e8fce48; });
$parcel$export(module.exports, "wienDisplacement", function () { return $f6b17530da552cda$export$2bcc1e96766dec50; });
$parcel$export(module.exports, "log", function () { return $f6b17530da552cda$export$bef1f36f5486a6a3; });
$parcel$export(module.exports, "unit", function () { return $f6b17530da552cda$export$523c0b569236b342; });
$parcel$export(module.exports, "sqrtm", function () { return $f6b17530da552cda$export$17c7cd2216e18593; });
$parcel$export(module.exports, "kldivergence", function () { return $f6b17530da552cda$export$a9fffb6ae6e33dcc; });
$parcel$export(module.exports, "bohrRadius", function () { return $f6b17530da552cda$export$5a57f82afcc3edeb; });
$parcel$export(module.exports, "elementaryCharge", function () { return $f6b17530da552cda$export$199cdfec7f52c877; });
$parcel$export(module.exports, "inverseConductanceQuantum", function () { return $f6b17530da552cda$export$f060c4f0aa5bef89; });
$parcel$export(module.exports, "molarVolume", function () { return $f6b17530da552cda$export$863459416408c428; });
$parcel$export(module.exports, "planckTime", function () { return $f6b17530da552cda$export$85aaf319784a5b0; });
$parcel$export(module.exports, "thomsonCrossSection", function () { return $f6b17530da552cda$export$93039724ea765a8e; });
$parcel$export(module.exports, "log1p", function () { return $f6b17530da552cda$export$144dcf16adfb9698; });
$parcel$export(module.exports, "median", function () { return $f6b17530da552cda$export$9c490b34b2f16a34; });
$parcel$export(module.exports, "gasConstant", function () { return $f6b17530da552cda$export$a614e1ad972260a9; });
$parcel$export(module.exports, "planckConstant", function () { return $f6b17530da552cda$export$cbd33810258dab2e; });
$parcel$export(module.exports, "setUnion", function () { return $f6b17530da552cda$export$667066422fa0af46; });
$parcel$export(module.exports, "magneticFluxQuantum", function () { return $f6b17530da552cda$export$699e2a89b148c5ee; });
$parcel$export(module.exports, "coulomb", function () { return $f6b17530da552cda$export$2f2e110dac549211; });
$parcel$export(module.exports, "mad", function () { return $f6b17530da552cda$export$b14ea41a64d6efa6; });
$parcel$export(module.exports, "rydberg", function () { return $f6b17530da552cda$export$683732ab8f5759dc; });
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */ 
var $59Cgo = parcelRequire("59Cgo");

var $bEypZ = parcelRequire("bEypZ");
var $2jNXf = parcelRequire("2jNXf");
var $cj1Yx = parcelRequire("cj1Yx");
var $7iSbY = parcelRequire("7iSbY");
var $7FKXi = parcelRequire("7FKXi");
var $emgMJ = parcelRequire("emgMJ");
var $akViO = parcelRequire("akViO");
var $jm66J = parcelRequire("jm66J");
var $b5YZR = parcelRequire("b5YZR");
var $cJ0gP = parcelRequire("cJ0gP");
var $33mpC = parcelRequire("33mpC");
var $i49k9 = parcelRequire("i49k9");
var $5OWmv = parcelRequire("5OWmv");
var $75kpy = parcelRequire("75kpy");
var $dheaH = parcelRequire("dheaH");
var $eIEnj = parcelRequire("eIEnj");
var $8PPlP = parcelRequire("8PPlP");
var $crkXv = parcelRequire("crkXv");
var $ju1VR = parcelRequire("ju1VR");
var $aUPN9 = parcelRequire("aUPN9");
var $89yPD = parcelRequire("89yPD");
var $dtuCC = parcelRequire("dtuCC");
var $kB26N = parcelRequire("kB26N");
var $59FZ8 = parcelRequire("59FZ8");
var $8DMga = parcelRequire("8DMga");
var $deN86 = parcelRequire("deN86");
var $3JaaR = parcelRequire("3JaaR");
var $faIDE = parcelRequire("faIDE");
var $7IWw6 = parcelRequire("7IWw6");
var $7YbQp = parcelRequire("7YbQp");
var $588AD = parcelRequire("588AD");
var $jy0bV = parcelRequire("jy0bV");
var $kZHWr = parcelRequire("kZHWr");
var $CQOYX = parcelRequire("CQOYX");
var $kHNQo = parcelRequire("kHNQo");
var $eKGzs = parcelRequire("eKGzs");
var $6cjKe = parcelRequire("6cjKe");
var $g8Ozy = parcelRequire("g8Ozy");
var $6CTYU = parcelRequire("6CTYU");
var $8RH82 = parcelRequire("8RH82");
var $keVNG = parcelRequire("keVNG");
var $5uT3g = parcelRequire("5uT3g");
var $7s1xS = parcelRequire("7s1xS");
var $2tBcA = parcelRequire("2tBcA");
var $1iyEB = parcelRequire("1iyEB");
var $8Wa10 = parcelRequire("8Wa10");
var $fepA5 = parcelRequire("fepA5");
var $iLwpS = parcelRequire("iLwpS");
var $29Y0b = parcelRequire("29Y0b");
var $jxqC0 = parcelRequire("jxqC0");
var $gu3Af = parcelRequire("gu3Af");
var $bADSR = parcelRequire("bADSR");
var $2RiNJ = parcelRequire("2RiNJ");
var $8KcmA = parcelRequire("8KcmA");
var $aEDHH = parcelRequire("aEDHH");
var $AdhNZ = parcelRequire("AdhNZ");
var $8rkEF = parcelRequire("8rkEF");
var $5N4kO = parcelRequire("5N4kO");
var $13oP7 = parcelRequire("13oP7");
var $9KbY0 = parcelRequire("9KbY0");
var $5Hav5 = parcelRequire("5Hav5");
var $7GYYs = parcelRequire("7GYYs");
var $drORN = parcelRequire("drORN");
var $9LYIW = parcelRequire("9LYIW");
var $gt2fN = parcelRequire("gt2fN");
var $7dlnz = parcelRequire("7dlnz");
var $30M0v = parcelRequire("30M0v");
var $l3dYq = parcelRequire("l3dYq");
var $h6Muc = parcelRequire("h6Muc");
var $dKj2r = parcelRequire("dKj2r");
var $guHuk = parcelRequire("guHuk");
var $1mOc9 = parcelRequire("1mOc9");
var $81WsT = parcelRequire("81WsT");
var $eLlye = parcelRequire("eLlye");
var $3bhDy = parcelRequire("3bhDy");
var $keRt9 = parcelRequire("keRt9");
var $lJ23l = parcelRequire("lJ23l");
var $9cYHW = parcelRequire("9cYHW");
var $7viTB = parcelRequire("7viTB");
var $bXg5b = parcelRequire("bXg5b");
var $8jGAN = parcelRequire("8jGAN");
var $8RcKt = parcelRequire("8RcKt");
var $l6sW2 = parcelRequire("l6sW2");
var $6LZeM = parcelRequire("6LZeM");
var $hpXJy = parcelRequire("hpXJy");
var $jDeCi = parcelRequire("jDeCi");
var $lzogn = parcelRequire("lzogn");
var $2P7IC = parcelRequire("2P7IC");
var $4CU0l = parcelRequire("4CU0l");
var $38H4O = parcelRequire("38H4O");
var $3X3sP = parcelRequire("3X3sP");
var $fpJBP = parcelRequire("fpJBP");
var $k1fS4 = parcelRequire("k1fS4");
var $g467d = parcelRequire("g467d");
var $iXV0j = parcelRequire("iXV0j");
var $jYYjK = parcelRequire("jYYjK");
var $gwWlc = parcelRequire("gwWlc");
var $5IViB = parcelRequire("5IViB");
var $gBYSQ = parcelRequire("gBYSQ");
var $295b6 = parcelRequire("295b6");
var $djjMV = parcelRequire("djjMV");
var $fKiDS = parcelRequire("fKiDS");
var $5QMzt = parcelRequire("5QMzt");
var $bZZIu = parcelRequire("bZZIu");
var $cYEUZ = parcelRequire("cYEUZ");
var $1230C = parcelRequire("1230C");
var $5J1h2 = parcelRequire("5J1h2");
var $esrJX = parcelRequire("esrJX");
var $dmxxg = parcelRequire("dmxxg");
var $aD9ah = parcelRequire("aD9ah");
var $1iTPd = parcelRequire("1iTPd");
var $72wmq = parcelRequire("72wmq");
var $gdMfy = parcelRequire("gdMfy");
var $4zHhr = parcelRequire("4zHhr");
var $13F9O = parcelRequire("13F9O");
var $j66eo = parcelRequire("j66eo");
var $61mVG = parcelRequire("61mVG");
var $h7kGL = parcelRequire("h7kGL");
var $107IL = parcelRequire("107IL");
var $luwu6 = parcelRequire("luwu6");
var $lVGks = parcelRequire("lVGks");
var $ewnoJ = parcelRequire("ewnoJ");
var $4zJhG = parcelRequire("4zJhG");
var $boksI = parcelRequire("boksI");
var $2Eoq5 = parcelRequire("2Eoq5");
var $lEqFf = parcelRequire("lEqFf");
var $lTAeZ = parcelRequire("lTAeZ");
var $a8T6u = parcelRequire("a8T6u");
var $gOPHp = parcelRequire("gOPHp");
var $3tQmP = parcelRequire("3tQmP");
var $2Qers = parcelRequire("2Qers");
var $XGqZk = parcelRequire("XGqZk");
var $cFSYl = parcelRequire("cFSYl");
var $5Tgnr = parcelRequire("5Tgnr");
var $lb7yi = parcelRequire("lb7yi");
var $7m6vf = parcelRequire("7m6vf");
var $lfgmk = parcelRequire("lfgmk");
var $iMOZu = parcelRequire("iMOZu");
var $dsMjF = parcelRequire("dsMjF");
var $2woIB = parcelRequire("2woIB");
var $enfUQ = parcelRequire("enfUQ");
var $2wZoU = parcelRequire("2wZoU");
var $kxlFj = parcelRequire("kxlFj");
var $yvIP7 = parcelRequire("yvIP7");
var $cHJNG = parcelRequire("cHJNG");
var $49EV9 = parcelRequire("49EV9");
var $codjn = parcelRequire("codjn");
var $h2sA3 = parcelRequire("h2sA3");
var $caP1a = parcelRequire("caP1a");
var $4jeGd = parcelRequire("4jeGd");
var $5q6XA = parcelRequire("5q6XA");
var $hhsn0 = parcelRequire("hhsn0");
var $1mhnN = parcelRequire("1mhnN");
var $1X6MZ = parcelRequire("1X6MZ");
var $fPIiR = parcelRequire("fPIiR");
var $4GTTb = parcelRequire("4GTTb");
var $eTOzW = parcelRequire("eTOzW");
var $3RjRH = parcelRequire("3RjRH");
var $5XB3B = parcelRequire("5XB3B");
var $kDPAE = parcelRequire("kDPAE");
var $fmA9p = parcelRequire("fmA9p");
var $fClPk = parcelRequire("fClPk");
var $hoWVl = parcelRequire("hoWVl");
var $5gxQH = parcelRequire("5gxQH");
var $lVfxX = parcelRequire("lVfxX");
var $b9ENh = parcelRequire("b9ENh");
var $eu8lH = parcelRequire("eu8lH");
var $4ec09 = parcelRequire("4ec09");
var $b9MmZ = parcelRequire("b9MmZ");
var $6uNr8 = parcelRequire("6uNr8");
var $lEDwz = parcelRequire("lEDwz");
var $85Wow = parcelRequire("85Wow");
var $8a63u = parcelRequire("8a63u");
var $lmeg6 = parcelRequire("lmeg6");
var $5uhdj = parcelRequire("5uhdj");
var $k6EQp = parcelRequire("k6EQp");
var $aXhcX = parcelRequire("aXhcX");
var $iQ3s3 = parcelRequire("iQ3s3");
var $7iHRB = parcelRequire("7iHRB");
var $8QVss = parcelRequire("8QVss");
var $l964k = parcelRequire("l964k");
var $1oXlo = parcelRequire("1oXlo");
var $6HeS0 = parcelRequire("6HeS0");
var $jVWoI = parcelRequire("jVWoI");
var $gULx9 = parcelRequire("gULx9");
var $jsrry = parcelRequire("jsrry");
var $d6FOT = parcelRequire("d6FOT");
var $lzAiB = parcelRequire("lzAiB");
var $79Eji = parcelRequire("79Eji");
var $45MmH = parcelRequire("45MmH");
var $5If9u = parcelRequire("5If9u");
var $ixHXB = parcelRequire("ixHXB");
var $gDJiz = parcelRequire("gDJiz");
var $6wGNM = parcelRequire("6wGNM");
var $ejRUS = parcelRequire("ejRUS");
var $fdjZz = parcelRequire("fdjZz");
var $9eZMW = parcelRequire("9eZMW");
var $6ETLy = parcelRequire("6ETLy");
var $5tIPz = parcelRequire("5tIPz");
var $9jIEe = parcelRequire("9jIEe");
var $j8Bc0 = parcelRequire("j8Bc0");
var $kO7HK = parcelRequire("kO7HK");
var $dqgpl = parcelRequire("dqgpl");
var $f6Yj3 = parcelRequire("f6Yj3");
var $e6EEb = parcelRequire("e6EEb");
var $4iWoN = parcelRequire("4iWoN");
var $fW0nl = parcelRequire("fW0nl");
var $anw0u = parcelRequire("anw0u");
var $lBjiA = parcelRequire("lBjiA");
var $f6b17530da552cda$export$aebd5179ff543a90 = /* #__PURE__ */ (0, $1X6MZ.createResultSet)({});
var $f6b17530da552cda$export$50ceb3fb9926e63e = /* #__PURE__ */ (0, $8RH82.createComplexClass)({});
var $f6b17530da552cda$export$9a58ef0d7ad3278c = /* #__PURE__ */ (0, $caP1a.createRangeClass)({});
var $f6b17530da552cda$export$4e18cf730a59887e = /* #__PURE__ */ (0, $eLlye.createEye)({});
var $f6b17530da552cda$export$f650004d56f90c2a = /* #__PURE__ */ (0, $gt2fN.createFalse)({});
var $f6b17530da552cda$export$a2cbb38cda512d16 = /* #__PURE__ */ (0, $gt2fN.createNull)({});
var $f6b17530da552cda$export$93f71dfe5e50cd3e = /* #__PURE__ */ (0, $gt2fN.createTrue)({});
var $f6b17530da552cda$export$d97aa349ed20696 = /* #__PURE__ */ (0, $kB26N.createBigNumberClass)({
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$5b12bf1653c0dd85 = /* #__PURE__ */ (0, $luwu6.createMatrixClass)({});
var $f6b17530da552cda$export$b644b65666fe0c18 = /* #__PURE__ */ (0, $5q6XA.createReplacer)({});
var $f6b17530da552cda$export$23f2a1d2818174ef = /* #__PURE__ */ (0, $gt2fN.createI)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e
});
var $f6b17530da552cda$export$c44341d65988fdd6 = /* #__PURE__ */ (0, $gt2fN.createLN10)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$5ed2c057bd191c66 = /* #__PURE__ */ (0, $gt2fN.createLOG10E)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$14edd9ca775dcd61 = /* #__PURE__ */ (0, $gt2fN.createNaN)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$18c7bea995a110f = /* #__PURE__ */ (0, $gt2fN.createPi)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$83247d8be11c091e = /* #__PURE__ */ (0, $gt2fN.createSQRT1_2)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$a4b4b4d4d776fe92 = /* #__PURE__ */ (0, $gt2fN.createTau)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$9ea6550edaaee998 = /* #__PURE__ */ (0, $aUPN9.createEfimovFactor)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$5c15dd8d2782cbd0 = /* #__PURE__ */ (0, $aUPN9.createFineStructure)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$a7100dcd4c5af6d4 = /* #__PURE__ */ (0, $aUPN9.createSackurTetrode)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$857d2e3e2bc524d0 = /* #__PURE__ */ (0, $aUPN9.createWeakMixingAngle)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$b336c2702c498be5 = /* #__PURE__ */ (0, $6LZeM.createFractionClass)({});
var $f6b17530da552cda$export$f1e1789686576879 = /* #__PURE__ */ (0, $gt2fN.createE)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$20607595d292e7d3 = /* #__PURE__ */ (0, $gt2fN.createInfinity)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$8c2c65adacba8d14 = /* #__PURE__ */ (0, $gt2fN.createLOG2E)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$83d89fbfd8236492 = /* #__PURE__ */ (0, $gt2fN.createVersion)({});
var $f6b17530da552cda$export$97f0d27b48f120e8 = /* #__PURE__ */ (0, $aEDHH.createDenseMatrixClass)({
    Matrix: $f6b17530da552cda$export$5b12bf1653c0dd85
});
var $f6b17530da552cda$export$324943737027944a = /* #__PURE__ */ (0, $gt2fN.createPhi)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$519f616c41a1c711 = /* #__PURE__ */ (0, $6ETLy.createTyped)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    Fraction: $f6b17530da552cda$export$b336c2702c498be5
});
var $f6b17530da552cda$export$a287f47fed4544b8 = /* #__PURE__ */ (0, $gwWlc.createIsInteger)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$e90fb89750dba83f = /* #__PURE__ */ (0, $295b6.createIsNumeric)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$7e69d4236fcc3b19 = /* #__PURE__ */ (0, $djjMV.createIsPositive)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$c9f5652083b8129d = /* #__PURE__ */ (0, $5IViB.createIsNaN)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$943761f5c9c3f156 = /* #__PURE__ */ (0, $l3dYq.createEqualScalar)({
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$98e628dec113755e = /* #__PURE__ */ (0, $5Tgnr.createNumber)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$4a21f16c33752377 = /* #__PURE__ */ (0, $faIDE.createBoolean)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$83a0e34f1302825b = /* #__PURE__ */ (0, $6CTYU.createComplex)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$dd67294014106b35 = /* #__PURE__ */ (0, $1oXlo.createSplitUnit)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$df8c837ae5df4ce4 = /* #__PURE__ */ (0, $j8Bc0.createUnaryPlus)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$5635d7ef4b8fee1c = /* #__PURE__ */ (0, $33mpC.createApply)({
    isInteger: $f6b17530da552cda$export$a287f47fed4544b8,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2b0340f6c7dec49a = /* #__PURE__ */ (0, $2RiNJ.createCube)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b6c0a80d46d3391d = /* #__PURE__ */ (0, $81WsT.createExpm1)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$75e08744a3ff8516 = /* #__PURE__ */ (0, $1iTPd.createLog10)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$c697bed75648cdb7 = /* #__PURE__ */ (0, $gOPHp.createMultiplyScalar)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$c5552dfdbc7cec71 = /* #__PURE__ */ (0, $lEDwz.createSign)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Fraction: $f6b17530da552cda$export$b336c2702c498be5,
    complex: $f6b17530da552cda$export$83a0e34f1302825b,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$dd4f28cef696bc7d = /* #__PURE__ */ (0, $gULx9.createSquare)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$aabc449fa5b5f4c0 = /* #__PURE__ */ (0, $8DMga.createBitNot)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$d8da458ed75e15b = /* #__PURE__ */ (0, $i49k9.createArg)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$5fc500b917996661 = /* #__PURE__ */ (0, $3X3sP.createIm)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$6003a5f097c73977 = /* #__PURE__ */ (0, $2Qers.createNot)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$3dea766d36a8935f = /* #__PURE__ */ (0, $lJ23l.createFilter)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$4b80e395e36b5a56 = /* #__PURE__ */ (0, $8jGAN.createForEach)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$871de8747c9eaa88 = /* #__PURE__ */ (0, $h7kGL.createMap)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$d3896f355fc09423 = /* #__PURE__ */ (0, $dKj2r.createErf)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$d9468344d3651243 = /* #__PURE__ */ (0, $8RcKt.createFormat)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$8676dd5fabd5ee34 = /* #__PURE__ */ (0, $fKiDS.createIsPrime)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$fd6306be3fde5b04 = /* #__PURE__ */ (0, $2jNXf.createAcos)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$4919a578c4aafd3 = /* #__PURE__ */ (0, $7iSbY.createAcot)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$43298db932064b4a = /* #__PURE__ */ (0, $emgMJ.createAcsc)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$ec42f46098b24bb4 = /* #__PURE__ */ (0, $5OWmv.createAsec)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$41726bdb1fc63f = /* #__PURE__ */ (0, $dheaH.createAsin)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$628dc4eed22b0fbd = /* #__PURE__ */ (0, $8PPlP.createAtan)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$21ea955025ceb08b = /* #__PURE__ */ (0, $ju1VR.createAtanh)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2e2fd1ad24e4d350 = /* #__PURE__ */ (0, $1iyEB.createCosh)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$fe7b8a3b046ac25b = /* #__PURE__ */ (0, $fepA5.createCoth)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$ca7427e8bf42a21b = /* #__PURE__ */ (0, $gu3Af.createCsch)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$becbc39f348ea65e = /* #__PURE__ */ (0, $kDPAE.createSech)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$545004b505d7c555 = /* #__PURE__ */ (0, $8a63u.createSinh)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$7128670e45beef9a = /* #__PURE__ */ (0, $6wGNM.createTanh)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$bdfcf4c6b5766439 = /* #__PURE__ */ (0, $CQOYX.createCombinations)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2e015b6955893291 = /* #__PURE__ */ (0, $2woIB.createPickRandom)({
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$3c5f89dae98e900b = /* #__PURE__ */ (0, $codjn.createRandomInt)({
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$578b45ddcdefa518 = /* #__PURE__ */ (0, $gt2fN.createLN2)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$9cd59f9826255e47 = /* #__PURE__ */ (0, $jy0bV.createClone)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$f6fc628e09f3ff5d = /* #__PURE__ */ (0, $2P7IC.createHasNumericValue)({
    isNumeric: $f6b17530da552cda$export$e90fb89750dba83f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$f5bbd400c2f4426f = /* #__PURE__ */ (0, $5tIPz.createTypeOf)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$22b082955e083ec3 = /* #__PURE__ */ (0, $79Eji.createString)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$7f34ce79760854f7 = /* #__PURE__ */ (0, $l6sW2.createFraction)({
    Fraction: $f6b17530da552cda$export$b336c2702c498be5,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$6cd304851a69e08 = /* #__PURE__ */ (0, $9jIEe.createUnaryMinus)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2b7b095c4f443355 = /* #__PURE__ */ (0, $b5YZR.createAddScalar)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b310ec824aaee37f = /* #__PURE__ */ (0, $guHuk.createExp)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b9fae0bba9d9094d = /* #__PURE__ */ (0, $gdMfy.createLog2)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$eba8049fb5020b81 = /* #__PURE__ */ (0, $6HeS0.createSqrt)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$fb254c661fe9c0db = /* #__PURE__ */ (0, $7s1xS.createConj)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$42c7d1d712906e32 = /* #__PURE__ */ (0, $lzogn.createGetMatrixDataType)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$549ff81930776885 = /* #__PURE__ */ (0, $lEqFf.createMode)({
    isNaN: $f6b17530da552cda$export$c9f5652083b8129d,
    isNumeric: $f6b17530da552cda$export$e90fb89750dba83f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$c2d084dc44961371 = /* #__PURE__ */ (0, $2wZoU.createPrint)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b26caf0f29211d08 = /* #__PURE__ */ (0, $cj1Yx.createAcosh)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$eafdb403a25900df = /* #__PURE__ */ (0, $akViO.createAcsch)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$839d8a01b6af4fc0 = /* #__PURE__ */ (0, $eIEnj.createAsinh)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$50d414a77b60d802 = /* #__PURE__ */ (0, $2tBcA.createCos)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a830b5ed334924be = /* #__PURE__ */ (0, $jxqC0.createCsc)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$5de3937cb4b592ed = /* #__PURE__ */ (0, $85Wow.createSin)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$f297162cf5d656b2 = /* #__PURE__ */ (0, $kHNQo.createCombinationsWithRep)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$4385e60b38654f68 = /* #__PURE__ */ (0, $49EV9.createRandom)({
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$3681641e15b6e2c3 = /* #__PURE__ */ (0, $gt2fN.createSQRT2)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$d0909a4f38b5c4d0 = /* #__PURE__ */ (0, $gBYSQ.createIsNegative)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$de9b2b7556879848 = /* #__PURE__ */ (0, $l964k.createSparseMatrixClass)({
    Matrix: $f6b17530da552cda$export$5b12bf1653c0dd85,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$9bdad1ae37d738e0 = /* #__PURE__ */ (0, $107IL.createMatrix)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    Matrix: $f6b17530da552cda$export$5b12bf1653c0dd85,
    SparseMatrix: $f6b17530da552cda$export$de9b2b7556879848,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$841fc4d5a1480b85 = /* #__PURE__ */ (0, $7YbQp.createCbrt)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    Fraction: $f6b17530da552cda$export$b336c2702c498be5,
    config: (0, $59Cgo.config),
    isNegative: $f6b17530da552cda$export$d0909a4f38b5c4d0,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    unaryMinus: $f6b17530da552cda$export$6cd304851a69e08
});
var $f6b17530da552cda$export$f81847884871263e = /* #__PURE__ */ (0, $jDeCi.createGcd)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$842a2cf37af977e1 = /* #__PURE__ */ (0, $2Eoq5.createMod)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$cc5da69d359d7991 = /* #__PURE__ */ (0, $XGqZk.createNthRoot)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$6ba103b0465fe6cc = /* #__PURE__ */ (0, $fW0nl.createXgcd)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a74ff8d3fdef72fc = /* #__PURE__ */ (0, $59FZ8.createBitAnd)({
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$bfcff4501301c191 = /* #__PURE__ */ (0, $3JaaR.createBitXor)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$252bb8b3bbdf6749 = /* #__PURE__ */ (0, $lfgmk.createOr)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$ee1b3e54f0441b22 = /* #__PURE__ */ (0, $5uT3g.createConcat)({
    isInteger: $f6b17530da552cda$export$a287f47fed4544b8,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$c042e7c2f59bc046 = /* #__PURE__ */ (0, $8rkEF.createDiag)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    SparseMatrix: $f6b17530da552cda$export$de9b2b7556879848,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$f0954fd7d5368655 = /* #__PURE__ */ (0, $38H4O.createIdentity)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    SparseMatrix: $f6b17530da552cda$export$de9b2b7556879848,
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$21041dee6b8001b0 = /* #__PURE__ */ (0, $7m6vf.createOnes)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$9eaad88cf88cee2b = /* #__PURE__ */ (0, $hhsn0.createReshape)({
    isInteger: $f6b17530da552cda$export$a287f47fed4544b8,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$346677f925de839c = /* #__PURE__ */ (0, $lmeg6.createSize)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$e06bd7b1ab877a71 = /* #__PURE__ */ (0, $45MmH.createSubset)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$4445a00dafa2633b = /* #__PURE__ */ (0, $lBjiA.createZeros)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2c618a4308a30424 = /* #__PURE__ */ (0, $ejRUS.createTo)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2077e0241d6afd3c = /* #__PURE__ */ (0, $eTOzW.createRound)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    zeros: $f6b17530da552cda$export$4445a00dafa2633b
});
var $f6b17530da552cda$export$48901d58d322262f = /* #__PURE__ */ (0, $dmxxg.createLeftShift)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    zeros: $f6b17530da552cda$export$4445a00dafa2633b
});
var $f6b17530da552cda$export$502f8a5a1147da = /* #__PURE__ */ (0, $4GTTb.createRightLogShift)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    zeros: $f6b17530da552cda$export$4445a00dafa2633b
});
var $f6b17530da552cda$export$398604a469f7de9a = /* #__PURE__ */ (0, $eKGzs.createCompare)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    Fraction: $f6b17530da552cda$export$b336c2702c498be5,
    config: (0, $59Cgo.config),
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2da9287da10b19e2 = /* #__PURE__ */ (0, $g8Ozy.createCompareText)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$3f732695c1493aec = /* #__PURE__ */ (0, $k6EQp.createSmaller)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a94a7414fa942aea = /* #__PURE__ */ (0, $1230C.createLarger)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b20c1c5fa0c7dd75 = /* #__PURE__ */ (0, $kO7HK.createUnequal)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    config: (0, $59Cgo.config),
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$8960430cfd85939f = /* #__PURE__ */ (0, $lVGks.createMax)({
    larger: $f6b17530da552cda$export$a94a7414fa942aea,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$66fe727d7ec8c7b9 = /* #__PURE__ */ (0, $fpJBP.createImmutableDenseMatrixClass)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    smaller: $f6b17530da552cda$export$3f732695c1493aec
});
var $f6b17530da552cda$export$dd5bb73729f20aa3 = /* #__PURE__ */ (0, $keRt9.createFibonacciHeapClass)({
    larger: $f6b17530da552cda$export$a94a7414fa942aea,
    smaller: $f6b17530da552cda$export$3f732695c1493aec
});
var $f6b17530da552cda$export$b6b7e189aa5d134c = /* #__PURE__ */ (0, $8QVss.createSparse)({
    SparseMatrix: $f6b17530da552cda$export$de9b2b7556879848,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$6faaac9ab79fd3a4 = /* #__PURE__ */ (0, $7FKXi.createAcoth)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b8b770ee6a0d9760 = /* #__PURE__ */ (0, $crkXv.createAtan2)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$e17a63917e2ebf0f = /* #__PURE__ */ (0, $5XB3B.createSec)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$e16d8520af44a096 = /* #__PURE__ */ (0, $jm66J.createAdd)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    SparseMatrix: $f6b17530da552cda$export$de9b2b7556879848,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$357889f174732d38 = /* #__PURE__ */ (0, $fdjZz.createTrace)({
    add: $f6b17530da552cda$export$e16d8520af44a096,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$fd2cf6bce05a0b18 = /* #__PURE__ */ (0, $keVNG.createComposition)({
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    combinations: $f6b17530da552cda$export$bdfcf4c6b5766439,
    isInteger: $f6b17530da552cda$export$a287f47fed4544b8,
    isNegative: $f6b17530da552cda$export$d0909a4f38b5c4d0,
    isPositive: $f6b17530da552cda$export$7e69d4236fcc3b19,
    larger: $f6b17530da552cda$export$a94a7414fa942aea,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$c46ec7d82fb1f602 = /* #__PURE__ */ (0, $5QMzt.createIsZero)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2335f513bbd82c6d = /* #__PURE__ */ (0, $bEypZ.createAbs)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a3fe094919f356fd = /* #__PURE__ */ (0, $bXg5b.createFloor)({
    config: (0, $59Cgo.config),
    round: $f6b17530da552cda$export$2077e0241d6afd3c,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$2060d2db72cce88f = /* #__PURE__ */ (0, $a8T6u.createMultiply)({
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$c6d93afbf4ee8afc = /* #__PURE__ */ (0, $drORN.createDotMultiply)({
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b1f1627d659a651 = /* #__PURE__ */ (0, $4jeGd.createRe)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$bffa455ba8c619a6 = /* #__PURE__ */ (0, $7viTB.createFlatten)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$4380c87abf28fdf = /* #__PURE__ */ (0, $1mhnN.createResize)({
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0
});
var $f6b17530da552cda$export$889c931173b77c2f = /* #__PURE__ */ (0, $jsrry.createSqueeze)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$5e143010dea16c85 = /* #__PURE__ */ (0, $kxlFj.createProd)({
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$9c297f60e22e3389 = /* #__PURE__ */ (0, $enfUQ.createPow)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    fraction: $f6b17530da552cda$export$7f34ce79760854f7,
    identity: $f6b17530da552cda$export$f0954fd7d5368655,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    number: $f6b17530da552cda$export$98e628dec113755e,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$ef3b15136279c2ab = /* #__PURE__ */ (0, $9LYIW.createDotPow)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    pow: $f6b17530da552cda$export$9c297f60e22e3389,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a1da16976d3a5f68 = /* #__PURE__ */ (0, $fPIiR.createRightArithShift)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    zeros: $f6b17530da552cda$export$4445a00dafa2633b
});
var $f6b17530da552cda$export$762e84baec56595d = /* #__PURE__ */ (0, $6cjKe.createCompareNatural)({
    compare: $f6b17530da552cda$export$398604a469f7de9a,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$5bc21f656fb5d284 = /* #__PURE__ */ (0, $h6Muc.createEqualText)({
    compareText: $f6b17530da552cda$export$2da9287da10b19e2,
    isZero: $f6b17530da552cda$export$c46ec7d82fb1f602,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$72693dfc692346df = /* #__PURE__ */ (0, $5J1h2.createLargerEq)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$54d1e322cf7aa273 = /* #__PURE__ */ (0, $iMOZu.createPartitionSelect)({
    compare: $f6b17530da552cda$export$398604a469f7de9a,
    isNaN: $f6b17530da552cda$export$c9f5652083b8129d,
    isNumeric: $f6b17530da552cda$export$e90fb89750dba83f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$96ec731ed4dcb222 = /* #__PURE__ */ (0, $boksI.createMin)({
    smaller: $f6b17530da552cda$export$3f732695c1493aec,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$6d4069f4b64f7492 = /* #__PURE__ */ (0, $7iHRB.createSpaClass)({
    FibonacciHeap: $f6b17530da552cda$export$dd5bb73729f20aa3,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156
});
var $f6b17530da552cda$export$3aaf4e522be48075 = /* #__PURE__ */ (0, $75kpy.createAsech)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$fcdd3b0b3246a325 = /* #__PURE__ */ (0, $gDJiz.createTan)({
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$1c70a6cc12bc0366 = /* #__PURE__ */ (0, $4ec09.createSetSize)({
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$1991ecd29cc92c6b = /* #__PURE__ */ (0, $3tQmP.createNorm)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    add: $f6b17530da552cda$export$e16d8520af44a096,
    conj: $f6b17530da552cda$export$fb254c661fe9c0db,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    larger: $f6b17530da552cda$export$a94a7414fa942aea,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    pow: $f6b17530da552cda$export$9c297f60e22e3389,
    smaller: $f6b17530da552cda$export$3f732695c1493aec,
    sqrt: $f6b17530da552cda$export$eba8049fb5020b81,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$ff63ee916cadcfe = /* #__PURE__ */ (0, $cHJNG.createQuantileSeq)({
    add: $f6b17530da552cda$export$e16d8520af44a096,
    compare: $f6b17530da552cda$export$398604a469f7de9a,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    partitionSelect: $f6b17530da552cda$export$54d1e322cf7aa273,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a7ebe8cc6aaf8d37 = /* #__PURE__ */ (0, $hpXJy.createGamma)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    pow: $f6b17530da552cda$export$9c297f60e22e3389,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$8576f72eb7f14a7e = /* #__PURE__ */ (0, $dtuCC.createBignumber)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$f686d97e407ec4ef = /* #__PURE__ */ (0, $esrJX.createLcm)({
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$361eb278cc70bacf = /* #__PURE__ */ (0, $deN86.createBitOr)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$44f32dfde3d58545 = /* #__PURE__ */ (0, $cYEUZ.createKron)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$9cb09a71b7d66923 = /* #__PURE__ */ (0, $9eZMW.createTranspose)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b7a508fa8dae59fc = /* #__PURE__ */ (0, $lb7yi.createNumeric)({
    bignumber: $f6b17530da552cda$export$8576f72eb7f14a7e,
    fraction: $f6b17530da552cda$export$7f34ce79760854f7,
    number: $f6b17530da552cda$export$98e628dec113755e
});
var $f6b17530da552cda$export$21c0ac7fe1cef1b8 = /* #__PURE__ */ (0, $cJ0gP.createAnd)({
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    not: $f6b17530da552cda$export$6003a5f097c73977,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    zeros: $f6b17530da552cda$export$4445a00dafa2633b
});
var $f6b17530da552cda$export$8d38c87f33a93d98 = /* #__PURE__ */ (0, $aXhcX.createSmallerEq)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    config: (0, $59Cgo.config),
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$97db5808d8f88186 = /* #__PURE__ */ (0, $iQ3s3.createSort)({
    compare: $f6b17530da552cda$export$398604a469f7de9a,
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$ef569ec50496610c = /* #__PURE__ */ (0, $8Wa10.createCot)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$94132a0e348806d4 = /* #__PURE__ */ (0, $5Hav5.createDot)({
    add: $f6b17530da552cda$export$e16d8520af44a096,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$8a63f25cc62965f1 = /* #__PURE__ */ (0, $ixHXB.createSum)({
    bignumber: $f6b17530da552cda$export$8576f72eb7f14a7e,
    fraction: $f6b17530da552cda$export$7f34ce79760854f7,
    add: $f6b17530da552cda$export$e16d8520af44a096,
    config: (0, $59Cgo.config),
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$329ce89a99f0e343 = /* #__PURE__ */ (0, $3bhDy.createFactorial)({
    gamma: $f6b17530da552cda$export$a7ebe8cc6aaf8d37,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$4567adbe5dd91621 = /* #__PURE__ */ (0, $dsMjF.createPermutations)({
    factorial: $f6b17530da552cda$export$329ce89a99f0e343,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$803ce6b71a0a94b2 = /* #__PURE__ */ (0, $588AD.createCeil)({
    config: (0, $59Cgo.config),
    round: $f6b17530da552cda$export$2077e0241d6afd3c,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$4e2d2ead65e5f7e3 = /* #__PURE__ */ (0, $5If9u.createSubtract)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    unaryMinus: $f6b17530da552cda$export$6cd304851a69e08
});
var $f6b17530da552cda$export$bb646b20bb93d339 = /* #__PURE__ */ (0, $29Y0b.createCross)({
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$eb6ad7870b1d0b0b = /* #__PURE__ */ (0, $bADSR.createCtranspose)({
    conj: $f6b17530da552cda$export$fb254c661fe9c0db,
    transpose: $f6b17530da552cda$export$9cb09a71b7d66923,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$411ce8e5a71e3069 = /* #__PURE__ */ (0, $30M0v.createEqual)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$cf17b003b6192af3 = /* #__PURE__ */ (0, $g467d.createIndexClass)({
    ImmutableDenseMatrix: $f6b17530da552cda$export$66fe727d7ec8c7b9
});
var $f6b17530da552cda$export$dcac7a71ff10ad82 = /* #__PURE__ */ (0, $fmA9p.createSetCartesian)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$ec60221e756bab15 = /* #__PURE__ */ (0, $hoWVl.createSetDistinct)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$ca5251f59a067f9a = /* #__PURE__ */ (0, $lVfxX.createSetIsSubset)({
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$f6ce4c11993e56f2 = /* #__PURE__ */ (0, $eu8lH.createSetPowerset)({
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b610b8812bbcded9 = /* #__PURE__ */ (0, $k1fS4.createIndex)({
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$d838837eb5b184e3 = /* #__PURE__ */ (0, $9cYHW.createFix)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    ceil: $f6b17530da552cda$export$803ce6b71a0a94b2,
    floor: $f6b17530da552cda$export$a3fe094919f356fd,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$d02631cccf789723 = /* #__PURE__ */ (0, $h2sA3.createRange)({
    bignumber: $f6b17530da552cda$export$8576f72eb7f14a7e,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    config: (0, $59Cgo.config),
    larger: $f6b17530da552cda$export$a94a7414fa942aea,
    largerEq: $f6b17530da552cda$export$72693dfc692346df,
    smaller: $f6b17530da552cda$export$3f732695c1493aec,
    smallerEq: $f6b17530da552cda$export$8d38c87f33a93d98,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$67275f837d70084d = /* #__PURE__ */ (0, $9KbY0.createDivideScalar)({
    numeric: $f6b17530da552cda$export$b7a508fa8dae59fc,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$adb173527af10aca = /* #__PURE__ */ (0, $cFSYl.createNthRoots)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$be3b83cc1aa539e4 = /* #__PURE__ */ (0, $4zHhr.createLsolve)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$9cb4719e2e525b7a = /* #__PURE__ */ (0, $8KcmA.createDeepEqual)({
    equal: $f6b17530da552cda$export$411ce8e5a71e3069,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$8bd517cc5b3722f7 = /* #__PURE__ */ (0, $fClPk.createSetDifference)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$8bb4a52260216736 = /* #__PURE__ */ (0, $b9ENh.createSetMultiplicity)({
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$f95c7888b62f8e9a = /* #__PURE__ */ (0, $4CU0l.createHypot)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    isPositive: $f6b17530da552cda$export$7e69d4236fcc3b19,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    smaller: $f6b17530da552cda$export$3f732695c1493aec,
    sqrt: $f6b17530da552cda$export$eba8049fb5020b81,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$91d2d01a33a1e6f8 = /* #__PURE__ */ (0, $13F9O.createLup)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    Spa: $f6b17530da552cda$export$6d4069f4b64f7492,
    SparseMatrix: $f6b17530da552cda$export$de9b2b7556879848,
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    larger: $f6b17530da552cda$export$a94a7414fa942aea,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    unaryMinus: $f6b17530da552cda$export$6cd304851a69e08
});
var $f6b17530da552cda$export$95c7459688ef4e3a = /* #__PURE__ */ (0, $5uhdj.createSlu)({
    SparseMatrix: $f6b17530da552cda$export$de9b2b7556879848,
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    add: $f6b17530da552cda$export$e16d8520af44a096,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    larger: $f6b17530da552cda$export$a94a7414fa942aea,
    largerEq: $f6b17530da552cda$export$72693dfc692346df,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    transpose: $f6b17530da552cda$export$9cb09a71b7d66923,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$d063d65fed97e7fa = /* #__PURE__ */ (0, $AdhNZ.createDet)({
    lup: $f6b17530da552cda$export$91d2d01a33a1e6f8,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    unaryMinus: $f6b17530da552cda$export$6cd304851a69e08
});
var $f6b17530da552cda$export$9f17032d917177de = /* #__PURE__ */ (0, $5N4kO.createDistance)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    sqrt: $f6b17530da552cda$export$eba8049fb5020b81,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    unaryMinus: $f6b17530da552cda$export$6cd304851a69e08
});
var $f6b17530da552cda$export$a5abae3de3985f2f = /* #__PURE__ */ (0, $lzAiB.createStirlingS2)({
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    combinations: $f6b17530da552cda$export$bdfcf4c6b5766439,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    factorial: $f6b17530da552cda$export$329ce89a99f0e343,
    isInteger: $f6b17530da552cda$export$a287f47fed4544b8,
    isNegative: $f6b17530da552cda$export$d0909a4f38b5c4d0,
    larger: $f6b17530da552cda$export$a94a7414fa942aea,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    pow: $f6b17530da552cda$export$9c297f60e22e3389,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$d8807a6c0487483a = /* #__PURE__ */ (0, $7IWw6.createCatalan)({
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    combinations: $f6b17530da552cda$export$bdfcf4c6b5766439,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    isInteger: $f6b17530da552cda$export$a287f47fed4544b8,
    isNegative: $f6b17530da552cda$export$d0909a4f38b5c4d0,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$6444ef5cd411280c = /* #__PURE__ */ (0, $anw0u.createXor)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$120ff0929b202a6d = /* #__PURE__ */ (0, $3RjRH.createRow)({
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    range: $f6b17530da552cda$export$d02631cccf789723,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$c74f132961c51406 = /* #__PURE__ */ (0, $7GYYs.createDotDivide)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$1d8b9ae22d404866 = /* #__PURE__ */ (0, $dqgpl.createUnitClass)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    Fraction: $f6b17530da552cda$export$b336c2702c498be5,
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    config: (0, $59Cgo.config),
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    equal: $f6b17530da552cda$export$411ce8e5a71e3069,
    fix: $f6b17530da552cda$export$d838837eb5b184e3,
    format: $f6b17530da552cda$export$d9468344d3651243,
    isNumeric: $f6b17530da552cda$export$e90fb89750dba83f,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    number: $f6b17530da552cda$export$98e628dec113755e,
    pow: $f6b17530da552cda$export$9c297f60e22e3389,
    round: $f6b17530da552cda$export$2077e0241d6afd3c,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3
});
var $f6b17530da552cda$export$aab44654646f3ccc = /* #__PURE__ */ (0, $iLwpS.createCreateUnit)({
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a7eac91d5496c35b = /* #__PURE__ */ (0, $b9MmZ.createSetSymDifference)({
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    concat: $f6b17530da552cda$export$ee1b3e54f0441b22,
    setDifference: $f6b17530da552cda$export$8bd517cc5b3722f7,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$7c27fb47516129d9 = /* #__PURE__ */ (0, $yvIP7.createQr)({
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    complex: $f6b17530da552cda$export$83a0e34f1302825b,
    conj: $f6b17530da552cda$export$fb254c661fe9c0db,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    equal: $f6b17530da552cda$export$411ce8e5a71e3069,
    identity: $f6b17530da552cda$export$f0954fd7d5368655,
    isZero: $f6b17530da552cda$export$c46ec7d82fb1f602,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    sign: $f6b17530da552cda$export$c5552dfdbc7cec71,
    sqrt: $f6b17530da552cda$export$eba8049fb5020b81,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    unaryMinus: $f6b17530da552cda$export$6cd304851a69e08,
    zeros: $f6b17530da552cda$export$4445a00dafa2633b
});
var $f6b17530da552cda$export$c02accee9f2b6a8f = /* #__PURE__ */ (0, $jYYjK.createInv)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    det: $f6b17530da552cda$export$d063d65fed97e7fa,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    identity: $f6b17530da552cda$export$f0954fd7d5368655,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    unaryMinus: $f6b17530da552cda$export$6cd304851a69e08
});
var $f6b17530da552cda$export$d9bacaa51f70e8e = /* #__PURE__ */ (0, $1mOc9.createExpm)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    add: $f6b17530da552cda$export$e16d8520af44a096,
    identity: $f6b17530da552cda$export$f0954fd7d5368655,
    inv: $f6b17530da552cda$export$c02accee9f2b6a8f,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$cd007d971a5a2143 = /* #__PURE__ */ (0, $13oP7.createDivide)({
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    inv: $f6b17530da552cda$export$c02accee9f2b6a8f,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$1ce691f85baaa52 = /* #__PURE__ */ (0, $ewnoJ.createMean)({
    add: $f6b17530da552cda$export$e16d8520af44a096,
    divide: $f6b17530da552cda$export$cd007d971a5a2143,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$9b77da0927470c3d = /* #__PURE__ */ (0, $4iWoN.createVariance)({
    add: $f6b17530da552cda$export$e16d8520af44a096,
    apply: $f6b17530da552cda$export$5635d7ef4b8fee1c,
    divide: $f6b17530da552cda$export$cd007d971a5a2143,
    isNaN: $f6b17530da552cda$export$c9f5652083b8129d,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$b14c5e819cb6c927 = /* #__PURE__ */ (0, $d6FOT.createStd)({
    sqrt: $f6b17530da552cda$export$eba8049fb5020b81,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    variance: $f6b17530da552cda$export$9b77da0927470c3d
});
var $f6b17530da552cda$export$f4d580f3101a1c7e = /* #__PURE__ */ (0, $lTAeZ.createMultinomial)({
    add: $f6b17530da552cda$export$e16d8520af44a096,
    divide: $f6b17530da552cda$export$cd007d971a5a2143,
    factorial: $f6b17530da552cda$export$329ce89a99f0e343,
    isInteger: $f6b17530da552cda$export$a287f47fed4544b8,
    isPositive: $f6b17530da552cda$export$7e69d4236fcc3b19,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$11b531e5540c3ca4 = /* #__PURE__ */ (0, $aUPN9.createAtomicMass)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$c779781d69f736e8 = /* #__PURE__ */ (0, $aUPN9.createBohrMagneton)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$f727e86dcab4e2c6 = /* #__PURE__ */ (0, $aUPN9.createBoltzmann)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$6eafe330bdda8c71 = /* #__PURE__ */ (0, $aUPN9.createConductanceQuantum)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$80bf07f129ad1319 = /* #__PURE__ */ (0, $aUPN9.createDeuteronMass)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$c00fb43e712bef2c = /* #__PURE__ */ (0, $aUPN9.createElectronMass)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$7130fbae042d5c0f = /* #__PURE__ */ (0, $aUPN9.createFaraday)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$f83f3c3b84952e0b = /* #__PURE__ */ (0, $aUPN9.createFirstRadiation)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$d9cccfa50756330b = /* #__PURE__ */ (0, $aUPN9.createGravitationConstant)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$37b0dd3693d47685 = /* #__PURE__ */ (0, $aUPN9.createHartreeEnergy)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$10054c6b64de12f5 = /* #__PURE__ */ (0, $aUPN9.createKlitzing)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$ba3f3691dd1c5a7 = /* #__PURE__ */ (0, $aUPN9.createMagneticConstant)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$6d4ff429f3f89356 = /* #__PURE__ */ (0, $aUPN9.createMolarMass)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$dacf4a2cf8881dff = /* #__PURE__ */ (0, $aUPN9.createMolarPlanckConstant)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$ba7a41eda790cc15 = /* #__PURE__ */ (0, $aUPN9.createNeutronMass)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$9b1b4e5bc980cec6 = /* #__PURE__ */ (0, $aUPN9.createPlanckCharge)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$c20ab336465d7d5e = /* #__PURE__ */ (0, $aUPN9.createPlanckLength)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$5a85cd1a26c2cced = /* #__PURE__ */ (0, $aUPN9.createPlanckTemperature)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$1c88a737209eb089 = /* #__PURE__ */ (0, $aUPN9.createProtonMass)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$963167ae5579ea00 = /* #__PURE__ */ (0, $aUPN9.createReducedPlanckConstant)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$1f7c42a78c01e4f9 = /* #__PURE__ */ (0, $aUPN9.createSecondRadiation)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$f63e81544c3d56ef = /* #__PURE__ */ (0, $aUPN9.createStefanBoltzmann)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$4b15dbe639ad9539 = /* #__PURE__ */ (0, $aUPN9.createVacuumImpedance)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$4e0c71f277ca26b3 = /* #__PURE__ */ (0, $kZHWr.createColumn)({
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    range: $f6b17530da552cda$export$d02631cccf789723,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$41828460570e21eb = /* #__PURE__ */ (0, $e6EEb.createUsolve)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$9404cfefeb010e68 = /* #__PURE__ */ (0, $5gxQH.createSetIntersect)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    compareNatural: $f6b17530da552cda$export$762e84baec56595d,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$fccc724a69f253a = /* #__PURE__ */ (0, $j66eo.createLusolve)({
    DenseMatrix: $f6b17530da552cda$export$97f0d27b48f120e8,
    lsolve: $f6b17530da552cda$export$be3b83cc1aa539e4,
    lup: $f6b17530da552cda$export$91d2d01a33a1e6f8,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    slu: $f6b17530da552cda$export$95c7459688ef4e3a,
    typed: $f6b17530da552cda$export$519f616c41a1c711,
    usolve: $f6b17530da552cda$export$41828460570e21eb
});
var $f6b17530da552cda$export$e822b38c59ee8a2a = /* #__PURE__ */ (0, $7dlnz.createEigs)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    add: $f6b17530da552cda$export$e16d8520af44a096,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    atan: $f6b17530da552cda$export$628dc4eed22b0fbd,
    bignumber: $f6b17530da552cda$export$8576f72eb7f14a7e,
    config: (0, $59Cgo.config),
    cos: $f6b17530da552cda$export$50d414a77b60d802,
    equal: $f6b17530da552cda$export$411ce8e5a71e3069,
    inv: $f6b17530da552cda$export$c02accee9f2b6a8f,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    sin: $f6b17530da552cda$export$5de3937cb4b592ed,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$1f4807a235930d45 = /* #__PURE__ */ (0, $iXV0j.createIntersect)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    add: $f6b17530da552cda$export$e16d8520af44a096,
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    config: (0, $59Cgo.config),
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    equalScalar: $f6b17530da552cda$export$943761f5c9c3f156,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    multiplyScalar: $f6b17530da552cda$export$c697bed75648cdb7,
    smaller: $f6b17530da552cda$export$3f732695c1493aec,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$bb522a71cda46a13 = /* #__PURE__ */ (0, $89yPD.createBellNumbers)({
    addScalar: $f6b17530da552cda$export$2b7b095c4f443355,
    isInteger: $f6b17530da552cda$export$a287f47fed4544b8,
    isNegative: $f6b17530da552cda$export$d0909a4f38b5c4d0,
    stirlingS2: $f6b17530da552cda$export$a5abae3de3985f2f,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$1236f2451dbdfd63 = /* #__PURE__ */ (0, $aUPN9.createAvogadro)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$f48a0c6b8cc21601 = /* #__PURE__ */ (0, $aUPN9.createClassicalElectronRadius)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$11ff82822f958f25 = /* #__PURE__ */ (0, $aUPN9.createElectricConstant)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$84a9a66802fec40 = /* #__PURE__ */ (0, $aUPN9.createFermiCoupling)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$bfb00cec0048377d = /* #__PURE__ */ (0, $aUPN9.createGravity)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$9eedba962d6a1c01 = /* #__PURE__ */ (0, $aUPN9.createLoschmidt)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$9589ebe123df8f2e = /* #__PURE__ */ (0, $aUPN9.createMolarMassC12)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$7274fb1d27d1cd19 = /* #__PURE__ */ (0, $aUPN9.createNuclearMagneton)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$5ce790af25e5ac75 = /* #__PURE__ */ (0, $aUPN9.createPlanckMass)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$5d88bfa2004001d3 = /* #__PURE__ */ (0, $aUPN9.createQuantumOfCirculation)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$5d66ae3b3e8fce48 = /* #__PURE__ */ (0, $aUPN9.createSpeedOfLight)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$2bcc1e96766dec50 = /* #__PURE__ */ (0, $aUPN9.createWienDisplacement)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$bef1f36f5486a6a3 = /* #__PURE__ */ (0, $aD9ah.createLog)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$523c0b569236b342 = /* #__PURE__ */ (0, $f6Yj3.createUnitFunction)({
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$17c7cd2216e18593 = /* #__PURE__ */ (0, $jVWoI.createSqrtm)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    add: $f6b17530da552cda$export$e16d8520af44a096,
    identity: $f6b17530da552cda$export$f0954fd7d5368655,
    inv: $f6b17530da552cda$export$c02accee9f2b6a8f,
    max: $f6b17530da552cda$export$8960430cfd85939f,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    size: $f6b17530da552cda$export$346677f925de839c,
    sqrt: $f6b17530da552cda$export$eba8049fb5020b81,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a9fffb6ae6e33dcc = /* #__PURE__ */ (0, $bZZIu.createKldivergence)({
    divide: $f6b17530da552cda$export$cd007d971a5a2143,
    dotDivide: $f6b17530da552cda$export$c74f132961c51406,
    isNumeric: $f6b17530da552cda$export$e90fb89750dba83f,
    log: $f6b17530da552cda$export$bef1f36f5486a6a3,
    matrix: $f6b17530da552cda$export$9bdad1ae37d738e0,
    multiply: $f6b17530da552cda$export$2060d2db72cce88f,
    sum: $f6b17530da552cda$export$8a63f25cc62965f1,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$5a57f82afcc3edeb = /* #__PURE__ */ (0, $aUPN9.createBohrRadius)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$199cdfec7f52c877 = /* #__PURE__ */ (0, $aUPN9.createElementaryCharge)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$f060c4f0aa5bef89 = /* #__PURE__ */ (0, $aUPN9.createInverseConductanceQuantum)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$863459416408c428 = /* #__PURE__ */ (0, $aUPN9.createMolarVolume)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$85aaf319784a5b0 = /* #__PURE__ */ (0, $aUPN9.createPlanckTime)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$93039724ea765a8e = /* #__PURE__ */ (0, $aUPN9.createThomsonCrossSection)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$144dcf16adfb9698 = /* #__PURE__ */ (0, $72wmq.createLog1p)({
    Complex: $f6b17530da552cda$export$50ceb3fb9926e63e,
    config: (0, $59Cgo.config),
    divideScalar: $f6b17530da552cda$export$67275f837d70084d,
    log: $f6b17530da552cda$export$bef1f36f5486a6a3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$9c490b34b2f16a34 = /* #__PURE__ */ (0, $4zJhG.createMedian)({
    add: $f6b17530da552cda$export$e16d8520af44a096,
    compare: $f6b17530da552cda$export$398604a469f7de9a,
    divide: $f6b17530da552cda$export$cd007d971a5a2143,
    partitionSelect: $f6b17530da552cda$export$54d1e322cf7aa273,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$a614e1ad972260a9 = /* #__PURE__ */ (0, $aUPN9.createGasConstant)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$cbd33810258dab2e = /* #__PURE__ */ (0, $aUPN9.createPlanckConstant)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$667066422fa0af46 = /* #__PURE__ */ (0, $6uNr8.createSetUnion)({
    Index: $f6b17530da552cda$export$cf17b003b6192af3,
    concat: $f6b17530da552cda$export$ee1b3e54f0441b22,
    setIntersect: $f6b17530da552cda$export$9404cfefeb010e68,
    setSymDifference: $f6b17530da552cda$export$a7eac91d5496c35b,
    size: $f6b17530da552cda$export$346677f925de839c,
    subset: $f6b17530da552cda$export$e06bd7b1ab877a71,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$699e2a89b148c5ee = /* #__PURE__ */ (0, $aUPN9.createMagneticFluxQuantum)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$2f2e110dac549211 = /* #__PURE__ */ (0, $aUPN9.createCoulomb)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});
var $f6b17530da552cda$export$b14ea41a64d6efa6 = /* #__PURE__ */ (0, $61mVG.createMad)({
    abs: $f6b17530da552cda$export$2335f513bbd82c6d,
    map: $f6b17530da552cda$export$871de8747c9eaa88,
    median: $f6b17530da552cda$export$9c490b34b2f16a34,
    subtract: $f6b17530da552cda$export$4e2d2ead65e5f7e3,
    typed: $f6b17530da552cda$export$519f616c41a1c711
});
var $f6b17530da552cda$export$683732ab8f5759dc = /* #__PURE__ */ (0, $aUPN9.createRydberg)({
    BigNumber: $f6b17530da552cda$export$d97aa349ed20696,
    Unit: $f6b17530da552cda$export$1d8b9ae22d404866,
    config: (0, $59Cgo.config)
});

});
parcelRegister("bEypZ", function(module, exports) {

$parcel$export(module.exports, "createAbs", function () { return $87be20dd36598f24$export$dd8a9b3843a4df95; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $87be20dd36598f24$var$name = "abs";
var $87be20dd36598f24$var$dependencies = [
    "typed"
];
var $87be20dd36598f24$export$dd8a9b3843a4df95 = /* #__PURE__ */ (0, $jKx4O.factory)($87be20dd36598f24$var$name, $87be20dd36598f24$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the absolute value of a number. For matrices, the function is
   * evaluated element wise.
   *
   * Syntax:
   *
   *    math.abs(x)
   *
   * Examples:
   *
   *    math.abs(3.5)                // returns number 3.5
   *    math.abs(-4.2)               // returns number 4.2
   *
   *    math.abs([3, -5, -1, 0, 2])  // returns Array [3, 5, 1, 0, 2]
   *
   * See also:
   *
   *    sign
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            A number or matrix for which to get the absolute value
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Absolute value of `x`
   */ var abs = typed($87be20dd36598f24$var$name, {
        number: (0, $cqeCl.absNumber),
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            return x.abs();
        },
        Fraction: function Fraction(x) {
            return x.abs();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since abs(0) = 0
            return (0, $fbkGg.deepMap)(x, abs, true);
        },
        Unit: function Unit(x) {
            return x.abs();
        }
    });
    return abs;
});

});
parcelRegister("cqeCl", function(module, exports) {

$parcel$export(module.exports, "absNumber", function () { return $90b3407b5ddc238e$export$59270f717756a93a; });
$parcel$export(module.exports, "addNumber", function () { return $90b3407b5ddc238e$export$d6751d2a3b6da12a; });
$parcel$export(module.exports, "multiplyNumber", function () { return $90b3407b5ddc238e$export$4ad41ac849e391ec; });
$parcel$export(module.exports, "unaryMinusNumber", function () { return $90b3407b5ddc238e$export$339666dc881be46b; });
$parcel$export(module.exports, "unaryPlusNumber", function () { return $90b3407b5ddc238e$export$da5b80d388a295fb; });
$parcel$export(module.exports, "cbrtNumber", function () { return $90b3407b5ddc238e$export$95c2aecb85f70726; });
$parcel$export(module.exports, "ceilNumber", function () { return $90b3407b5ddc238e$export$dd91a1966a303b99; });
$parcel$export(module.exports, "cubeNumber", function () { return $90b3407b5ddc238e$export$9505f0b39acd04c; });
$parcel$export(module.exports, "expNumber", function () { return $90b3407b5ddc238e$export$a33b288b35672fe5; });
$parcel$export(module.exports, "expm1Number", function () { return $90b3407b5ddc238e$export$756d0c010cecc6c3; });
$parcel$export(module.exports, "gcdNumber", function () { return $90b3407b5ddc238e$export$3a8d786b08b3a70c; });
$parcel$export(module.exports, "lcmNumber", function () { return $90b3407b5ddc238e$export$b55f99ec1f4c5649; });
$parcel$export(module.exports, "logNumber", function () { return $90b3407b5ddc238e$export$4df0e8fcdd5c0927; });
$parcel$export(module.exports, "log10Number", function () { return $90b3407b5ddc238e$export$e3f8d49574d29dff; });
$parcel$export(module.exports, "log2Number", function () { return $90b3407b5ddc238e$export$f9bc93220cfa3c59; });
$parcel$export(module.exports, "modNumber", function () { return $90b3407b5ddc238e$export$64b58c5b0372ae95; });
$parcel$export(module.exports, "nthRootNumber", function () { return $90b3407b5ddc238e$export$9f26f16bd796a7b3; });
$parcel$export(module.exports, "signNumber", function () { return $90b3407b5ddc238e$export$af3d9fe43be78285; });
$parcel$export(module.exports, "squareNumber", function () { return $90b3407b5ddc238e$export$c4094a156ed9ab35; });
$parcel$export(module.exports, "xgcdNumber", function () { return $90b3407b5ddc238e$export$8cb756a23a623229; });
$parcel$export(module.exports, "powNumber", function () { return $90b3407b5ddc238e$export$3f512e7fd4999e01; });
$parcel$export(module.exports, "roundNumber", function () { return $90b3407b5ddc238e$export$a3992db8dd0fd9e6; });

var $5wlxr = parcelRequire("5wlxr");
var $90b3407b5ddc238e$var$n1 = "number";
var $90b3407b5ddc238e$var$n2 = "number, number";
function $90b3407b5ddc238e$export$59270f717756a93a(a) {
    return Math.abs(a);
}
$90b3407b5ddc238e$export$59270f717756a93a.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$d6751d2a3b6da12a(a, b) {
    return a + b;
}
$90b3407b5ddc238e$export$d6751d2a3b6da12a.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$fd8ce9cfca47ace5(a, b) {
    return a - b;
}
$90b3407b5ddc238e$export$fd8ce9cfca47ace5.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$4ad41ac849e391ec(a, b) {
    return a * b;
}
$90b3407b5ddc238e$export$4ad41ac849e391ec.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$58c48a269ab4a155(a, b) {
    return a / b;
}
$90b3407b5ddc238e$export$58c48a269ab4a155.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$339666dc881be46b(x) {
    return -x;
}
$90b3407b5ddc238e$export$339666dc881be46b.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$da5b80d388a295fb(x) {
    return x;
}
$90b3407b5ddc238e$export$da5b80d388a295fb.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$95c2aecb85f70726(x) {
    return (0, $5wlxr.cbrt)(x);
}
$90b3407b5ddc238e$export$95c2aecb85f70726.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$dd91a1966a303b99(x) {
    return Math.ceil(x);
}
$90b3407b5ddc238e$export$dd91a1966a303b99.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$9505f0b39acd04c(x) {
    return x * x * x;
}
$90b3407b5ddc238e$export$9505f0b39acd04c.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$a33b288b35672fe5(x) {
    return Math.exp(x);
}
$90b3407b5ddc238e$export$a33b288b35672fe5.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$756d0c010cecc6c3(x) {
    return (0, $5wlxr.expm1)(x);
}
$90b3407b5ddc238e$export$756d0c010cecc6c3.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$f0d92d0037f57a41(x) {
    return x > 0 ? Math.floor(x) : Math.ceil(x);
}
$90b3407b5ddc238e$export$f0d92d0037f57a41.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$10d3df201a8983fc(x) {
    return Math.floor(x);
}
$90b3407b5ddc238e$export$10d3df201a8983fc.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$3a8d786b08b3a70c(a, b) {
    if (!(0, $5wlxr.isInteger)(a) || !(0, $5wlxr.isInteger)(b)) throw new Error("Parameters in function gcd must be integer numbers");
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    var r;
    while(b !== 0){
        r = a % b;
        a = b;
        b = r;
    }
    return a < 0 ? -a : a;
}
$90b3407b5ddc238e$export$3a8d786b08b3a70c.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$b55f99ec1f4c5649(a, b) {
    if (!(0, $5wlxr.isInteger)(a) || !(0, $5wlxr.isInteger)(b)) throw new Error("Parameters in function lcm must be integer numbers");
    if (a === 0 || b === 0) return 0;
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    // evaluate lcm here inline to reduce overhead
    var t;
    var prod = a * b;
    while(b !== 0){
        t = b;
        b = a % t;
        a = t;
    }
    return Math.abs(prod / a);
}
$90b3407b5ddc238e$export$b55f99ec1f4c5649.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$4df0e8fcdd5c0927(x) {
    return Math.log(x);
}
$90b3407b5ddc238e$export$4df0e8fcdd5c0927.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$e3f8d49574d29dff(x) {
    return (0, $5wlxr.log10)(x);
}
$90b3407b5ddc238e$export$e3f8d49574d29dff.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$f9bc93220cfa3c59(x) {
    return (0, $5wlxr.log2)(x);
}
$90b3407b5ddc238e$export$f9bc93220cfa3c59.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$ae1f56e105ebe4a1(x) {
    return (0, $5wlxr.log1p)(x);
}
$90b3407b5ddc238e$export$ae1f56e105ebe4a1.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$64b58c5b0372ae95(x, y) {
    if (y > 0) // We don't use JavaScript's % operator here as this doesn't work
    // correctly for x < 0 and x === 0
    // see https://en.wikipedia.org/wiki/Modulo_operation
    return x - y * Math.floor(x / y);
    else if (y === 0) return x;
    else // y < 0
    // TODO: implement mod for a negative divisor
    throw new Error("Cannot calculate mod for a negative divisor");
}
$90b3407b5ddc238e$export$64b58c5b0372ae95.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$9f26f16bd796a7b3(a, root) {
    var inv = root < 0;
    if (inv) root = -root;
    if (root === 0) throw new Error("Root must be non-zero");
    if (a < 0 && Math.abs(root) % 2 !== 1) throw new Error("Root must be odd when a is negative.");
     // edge cases zero and infinity
    if (a === 0) return inv ? Infinity : 0;
    if (!isFinite(a)) return inv ? 0 : a;
    var x = Math.pow(Math.abs(a), 1 / root); // If a < 0, we require that root is an odd integer,
    // so (-1) ^ (1/root) = -1
    x = a < 0 ? -x : x;
    return inv ? 1 / x : x; // Very nice algorithm, but fails with nthRoot(-2, 3).
// Newton's method has some well-known problems at times:
// https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
/*
  let x = 1 // Initial guess
  let xPrev = 1
  let i = 0
  const iMax = 10000
  do {
    const delta = (a / Math.pow(x, root - 1) - x) / root
    xPrev = x
    x = x + delta
    i++
  }
  while (xPrev !== x && i < iMax)
   if (xPrev !== x) {
    throw new Error('Function nthRoot failed to converge')
  }
   return inv ? 1 / x : x
  */ }
$90b3407b5ddc238e$export$9f26f16bd796a7b3.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$af3d9fe43be78285(x) {
    return (0, $5wlxr.sign)(x);
}
$90b3407b5ddc238e$export$af3d9fe43be78285.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$aacd0ed14e49886d(x) {
    return Math.sqrt(x);
}
$90b3407b5ddc238e$export$aacd0ed14e49886d.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$c4094a156ed9ab35(x) {
    return x * x;
}
$90b3407b5ddc238e$export$c4094a156ed9ab35.signature = $90b3407b5ddc238e$var$n1;
function $90b3407b5ddc238e$export$8cb756a23a623229(a, b) {
    // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
    var t; // used to swap two variables
    var q; // quotient
    var r; // remainder
    var x = 0;
    var lastx = 1;
    var y = 1;
    var lasty = 0;
    if (!(0, $5wlxr.isInteger)(a) || !(0, $5wlxr.isInteger)(b)) throw new Error("Parameters in function xgcd must be integer numbers");
    while(b){
        q = Math.floor(a / b);
        r = a - q * b;
        t = x;
        x = lastx - q * x;
        lastx = t;
        t = y;
        y = lasty - q * y;
        lasty = t;
        a = b;
        b = r;
    }
    var res;
    if (a < 0) res = [
        -a,
        -lastx,
        -lasty
    ];
    else res = [
        a,
        a ? lastx : 0,
        lasty
    ];
    return res;
}
$90b3407b5ddc238e$export$8cb756a23a623229.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$3f512e7fd4999e01(x, y) {
    // x^Infinity === 0 if -1 < x < 1
    // A real number 0 is returned instead of complex(0)
    if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
    return Math.pow(x, y);
}
$90b3407b5ddc238e$export$3f512e7fd4999e01.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$a3992db8dd0fd9e6(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return parseFloat((0, $5wlxr.toFixed)(value, decimals));
}
$90b3407b5ddc238e$export$a3992db8dd0fd9e6.signature = $90b3407b5ddc238e$var$n2;
function $90b3407b5ddc238e$export$d78ecacee56245ec(x) {
    return Math.abs(x);
}
$90b3407b5ddc238e$export$d78ecacee56245ec.signature = $90b3407b5ddc238e$var$n1;

});


parcelRegister("2jNXf", function(module, exports) {

$parcel$export(module.exports, "createAcos", function () { return $1b041b0e959eb7e1$export$33da46c5ece67581; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $1b041b0e959eb7e1$var$name = "acos";
var $1b041b0e959eb7e1$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $1b041b0e959eb7e1$export$33da46c5ece67581 = /* #__PURE__ */ (0, $jKx4O.factory)($1b041b0e959eb7e1$var$name, $1b041b0e959eb7e1$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the inverse cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acos(x)
   *
   * Examples:
   *
   *    math.acos(0.5)           // returns number 1.0471975511965979
   *    math.acos(math.cos(1.5)) // returns number 1.5
   *
   *    math.acos(2)             // returns Complex 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    cos, atan, asin
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc cosine of x
   */ var acos = typed($1b041b0e959eb7e1$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.acos(x);
            else return new Complex(x, 0).acos();
        },
        Complex: function Complex(x) {
            return x.acos();
        },
        BigNumber: function BigNumber(x) {
            return x.acos();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, acos);
        }
    });
    return acos;
});

});

parcelRegister("cj1Yx", function(module, exports) {

$parcel$export(module.exports, "createAcosh", function () { return $8f58caa483467e49$export$c634796792055579; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $8f58caa483467e49$var$name = "acosh";
var $8f58caa483467e49$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $8f58caa483467e49$export$c634796792055579 = /* #__PURE__ */ (0, $jKx4O.factory)($8f58caa483467e49$var$name, $8f58caa483467e49$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the hyperbolic arccos of a value,
   * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acosh(x)
   *
   * Examples:
   *
   *    math.acosh(1.5)       // returns 0.9624236501192069
   *
   * See also:
   *
   *    cosh, asinh, atanh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosine of x
   */ var acosh = typed($8f58caa483467e49$var$name, {
        number: function number(x) {
            if (x >= 1 || config.predictable) return (0, $7HpLG.acoshNumber)(x);
            if (x <= -1) return new Complex(Math.log(Math.sqrt(x * x - 1) - x), Math.PI);
            return new Complex(x, 0).acosh();
        },
        Complex: function Complex(x) {
            return x.acosh();
        },
        BigNumber: function BigNumber(x) {
            return x.acosh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, acosh);
        }
    });
    return acosh;
});

});
parcelRegister("7HpLG", function(module, exports) {

$parcel$export(module.exports, "acoshNumber", function () { return $59b0899274d9bfb7$export$84088556f7d2d0be; });
$parcel$export(module.exports, "acotNumber", function () { return $59b0899274d9bfb7$export$ba80ccbf024897ef; });
$parcel$export(module.exports, "acothNumber", function () { return $59b0899274d9bfb7$export$e2be1aa5d5a3f81; });
$parcel$export(module.exports, "acscNumber", function () { return $59b0899274d9bfb7$export$e3b67a6e3df3fd81; });
$parcel$export(module.exports, "acschNumber", function () { return $59b0899274d9bfb7$export$51cd224337b2c783; });
$parcel$export(module.exports, "asecNumber", function () { return $59b0899274d9bfb7$export$5ec3930177455ade; });
$parcel$export(module.exports, "asechNumber", function () { return $59b0899274d9bfb7$export$cf144300ea173362; });
$parcel$export(module.exports, "asinhNumber", function () { return $59b0899274d9bfb7$export$3a027485d3336d8d; });
$parcel$export(module.exports, "atanhNumber", function () { return $59b0899274d9bfb7$export$44a1f653c6513db8; });
$parcel$export(module.exports, "cotNumber", function () { return $59b0899274d9bfb7$export$515b39f7fd07e09f; });
$parcel$export(module.exports, "cothNumber", function () { return $59b0899274d9bfb7$export$925affe88b2512fc; });
$parcel$export(module.exports, "cscNumber", function () { return $59b0899274d9bfb7$export$5a8409ad16e318b2; });
$parcel$export(module.exports, "cschNumber", function () { return $59b0899274d9bfb7$export$143835b5c1db9790; });
$parcel$export(module.exports, "secNumber", function () { return $59b0899274d9bfb7$export$ee1efc70bd8a6d93; });
$parcel$export(module.exports, "sechNumber", function () { return $59b0899274d9bfb7$export$b83345d70fe4a871; });
$parcel$export(module.exports, "sinhNumber", function () { return $59b0899274d9bfb7$export$89648c4ce0d79e70; });

var $5wlxr = parcelRequire("5wlxr");
var $59b0899274d9bfb7$var$n1 = "number";
var $59b0899274d9bfb7$var$n2 = "number, number";
function $59b0899274d9bfb7$export$99a14685a3a2b607(x) {
    return Math.acos(x);
}
$59b0899274d9bfb7$export$99a14685a3a2b607.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$84088556f7d2d0be(x) {
    return (0, $5wlxr.acosh)(x);
}
$59b0899274d9bfb7$export$84088556f7d2d0be.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$ba80ccbf024897ef(x) {
    return Math.atan(1 / x);
}
$59b0899274d9bfb7$export$ba80ccbf024897ef.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$e2be1aa5d5a3f81(x) {
    return isFinite(x) ? (Math.log((x + 1) / x) + Math.log(x / (x - 1))) / 2 : 0;
}
$59b0899274d9bfb7$export$e2be1aa5d5a3f81.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$e3b67a6e3df3fd81(x) {
    return Math.asin(1 / x);
}
$59b0899274d9bfb7$export$e3b67a6e3df3fd81.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$51cd224337b2c783(x) {
    var xInv = 1 / x;
    return Math.log(xInv + Math.sqrt(xInv * xInv + 1));
}
$59b0899274d9bfb7$export$51cd224337b2c783.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$5ec3930177455ade(x) {
    return Math.acos(1 / x);
}
$59b0899274d9bfb7$export$5ec3930177455ade.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$cf144300ea173362(x) {
    var xInv = 1 / x;
    var ret = Math.sqrt(xInv * xInv - 1);
    return Math.log(ret + xInv);
}
$59b0899274d9bfb7$export$cf144300ea173362.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$444ef2855488a2d5(x) {
    return Math.asin(x);
}
$59b0899274d9bfb7$export$444ef2855488a2d5.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$3a027485d3336d8d(x) {
    return (0, $5wlxr.asinh)(x);
}
$59b0899274d9bfb7$export$3a027485d3336d8d.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$c38dcb11df4699c0(x) {
    return Math.atan(x);
}
$59b0899274d9bfb7$export$c38dcb11df4699c0.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$a97666a135b540f9(y, x) {
    return Math.atan2(y, x);
}
$59b0899274d9bfb7$export$a97666a135b540f9.signature = $59b0899274d9bfb7$var$n2;
function $59b0899274d9bfb7$export$44a1f653c6513db8(x) {
    return (0, $5wlxr.atanh)(x);
}
$59b0899274d9bfb7$export$44a1f653c6513db8.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$8d04496be3e647d4(x) {
    return Math.cos(x);
}
$59b0899274d9bfb7$export$8d04496be3e647d4.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$7cf8db0cff734545(x) {
    return (0, $5wlxr.cosh)(x);
}
$59b0899274d9bfb7$export$7cf8db0cff734545.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$515b39f7fd07e09f(x) {
    return 1 / Math.tan(x);
}
$59b0899274d9bfb7$export$515b39f7fd07e09f.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$925affe88b2512fc(x) {
    var e = Math.exp(2 * x);
    return (e + 1) / (e - 1);
}
$59b0899274d9bfb7$export$925affe88b2512fc.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$5a8409ad16e318b2(x) {
    return 1 / Math.sin(x);
}
$59b0899274d9bfb7$export$5a8409ad16e318b2.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$143835b5c1db9790(x) {
    // consider values close to zero (+/-)
    if (x === 0) return Number.POSITIVE_INFINITY;
    else return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * (0, $5wlxr.sign)(x);
}
$59b0899274d9bfb7$export$143835b5c1db9790.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$ee1efc70bd8a6d93(x) {
    return 1 / Math.cos(x);
}
$59b0899274d9bfb7$export$ee1efc70bd8a6d93.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$b83345d70fe4a871(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
}
$59b0899274d9bfb7$export$b83345d70fe4a871.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$b6e96f13f41c8816(x) {
    return Math.sin(x);
}
$59b0899274d9bfb7$export$b6e96f13f41c8816.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$89648c4ce0d79e70(x) {
    return (0, $5wlxr.sinh)(x);
}
$59b0899274d9bfb7$export$89648c4ce0d79e70.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$ecbd7b3271ebce16(x) {
    return Math.tan(x);
}
$59b0899274d9bfb7$export$ecbd7b3271ebce16.signature = $59b0899274d9bfb7$var$n1;
function $59b0899274d9bfb7$export$70e2e2cc9c2555e4(x) {
    return (0, $5wlxr.tanh)(x);
}
$59b0899274d9bfb7$export$70e2e2cc9c2555e4.signature = $59b0899274d9bfb7$var$n1;

});


parcelRegister("7iSbY", function(module, exports) {

$parcel$export(module.exports, "createAcot", function () { return $55144048f695dccf$export$8a6845771325148e; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $55144048f695dccf$var$name = "acot";
var $55144048f695dccf$var$dependencies = [
    "typed",
    "BigNumber"
];
var $55144048f695dccf$export$8a6845771325148e = /* #__PURE__ */ (0, $jKx4O.factory)($55144048f695dccf$var$name, $55144048f695dccf$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acot(x)
   *
   * Examples:
   *
   *    math.acot(0.5)           // returns number 0.4636476090008061
   *    math.acot(math.cot(1.5)) // returns number 1.5
   *
   *    math.acot(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    cot, atan
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cotangent of x
   */ var acot = typed($55144048f695dccf$var$name, {
        number: (0, $7HpLG.acotNumber),
        Complex: function Complex(x) {
            return x.acot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atan();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, acot);
        }
    });
    return acot;
});

});

parcelRegister("7FKXi", function(module, exports) {

$parcel$export(module.exports, "createAcoth", function () { return $5960c91b3fb5eec6$export$67e40c7fd8f5703a; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $5960c91b3fb5eec6$var$name = "acoth";
var $5960c91b3fb5eec6$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $5960c91b3fb5eec6$export$67e40c7fd8f5703a = /* #__PURE__ */ (0, $jKx4O.factory)($5960c91b3fb5eec6$var$name, $5960c91b3fb5eec6$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic arccotangent of a value,
   * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acoth(x)
   *
   * Examples:
   *
   *    math.acoth(0.5)       // returns 0.8047189562170503
   *
   * See also:
   *
   *    acsch, asech
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccotangent of x
   */ var acoth = typed($5960c91b3fb5eec6$var$name, {
        number: function number(x) {
            if (x >= 1 || x <= -1 || config.predictable) return (0, $7HpLG.acothNumber)(x);
            return new Complex(x, 0).acoth();
        },
        Complex: function Complex(x) {
            return x.acoth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atanh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, acoth);
        }
    });
    return acoth;
});

});

parcelRegister("emgMJ", function(module, exports) {

$parcel$export(module.exports, "createAcsc", function () { return $a74023e76a3633b5$export$95580581b134a5bd; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $a74023e76a3633b5$var$name = "acsc";
var $a74023e76a3633b5$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $a74023e76a3633b5$export$95580581b134a5bd = /* #__PURE__ */ (0, $jKx4O.factory)($a74023e76a3633b5$var$name, $a74023e76a3633b5$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsc(x)
   *
   * Examples:
   *
   *    math.acsc(0.5)           // returns number 0.5235987755982989
   *    math.acsc(math.csc(1.5)) // returns number ~1.5
   *
   *    math.acsc(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    csc, asin, asec
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cosecant of x
   */ var acsc = typed($a74023e76a3633b5$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $7HpLG.acscNumber)(x);
            return new Complex(x, 0).acsc();
        },
        Complex: function Complex(x) {
            return x.acsc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asin();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, acsc);
        }
    });
    return acsc;
});

});

parcelRegister("akViO", function(module, exports) {

$parcel$export(module.exports, "createAcsch", function () { return $786838b289ce0a14$export$d6534043a40dc59; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $786838b289ce0a14$var$name = "acsch";
var $786838b289ce0a14$var$dependencies = [
    "typed",
    "BigNumber"
];
var $786838b289ce0a14$export$d6534043a40dc59 = /* #__PURE__ */ (0, $jKx4O.factory)($786838b289ce0a14$var$name, $786838b289ce0a14$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic arccosecant of a value,
   * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsch(x)
   *
   * Examples:
   *
   *    math.acsch(0.5)       // returns 1.4436354751788103
   *
   * See also:
   *
   *    asech, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosecant of x
   */ var acsch = typed($786838b289ce0a14$var$name, {
        number: (0, $7HpLG.acschNumber),
        Complex: function Complex(x) {
            return x.acsch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asinh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, acsch);
        }
    });
    return acsch;
});

});

parcelRegister("jm66J", function(module, exports) {

$parcel$export(module.exports, "createAdd", function () { return $e174cf37b8e59358$export$c6b51545da64d82f; });

var $jKx4O = parcelRequire("jKx4O");

var $glBd7 = parcelRequire("glBd7");

var $9vlUQ = parcelRequire("9vlUQ");

var $5JY23 = parcelRequire("5JY23");

var $fs8LR = parcelRequire("fs8LR");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");
var $e174cf37b8e59358$var$name = "add";
var $e174cf37b8e59358$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "equalScalar",
    "DenseMatrix",
    "SparseMatrix"
];
var $e174cf37b8e59358$export$c6b51545da64d82f = /* #__PURE__ */ (0, $jKx4O.factory)($e174cf37b8e59358$var$name, $e174cf37b8e59358$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, addScalar = _ref.addScalar, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix;
    var algorithm01 = (0, $9vlUQ.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $5JY23.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $fs8LR.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Add two or more values, `x + y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.add(x, y)
   *    math.add(x, y, z, ...)
   *
   * Examples:
   *
   *    math.add(2, 3)               // returns number 5
   *    math.add(2, 3, 4)            // returns number 9
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(-4, 1)
   *    math.add(a, b)               // returns Complex -2 + 4i
   *
   *    math.add([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   *    const c = math.unit('5 cm')
   *    const d = math.unit('2.1 mm')
   *    math.add(c, d)               // returns Unit 52.1 mm
   *
   *    math.add("2.3", "4")         // returns number 6.3
   *
   * See also:
   *
   *    subtract, sum
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
   */ var add = typed($e174cf37b8e59358$var$name, (0, $glBd7.extend)({
        // we extend the signatures of addScalar with signatures dealing with matrices
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, addScalar);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, addScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, addScalar, true);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, addScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return add(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return add(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return add(x, matrix(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, addScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, y, addScalar, false);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, addScalar, true);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, addScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, addScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, addScalar, true).valueOf();
        },
        "any, any": addScalar,
        "any, any, ...any": function anyAnyAny(x, y, rest) {
            var result = add(x, y);
            for(var i = 0; i < rest.length; i++)result = add(result, rest[i]);
            return result;
        }
    }, addScalar.signatures));
    return add;
});

});
parcelRegister("9vlUQ", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm01", function () { return $6eb8025480f48681$export$5e6d55d37a917802; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $6eb8025480f48681$var$name = "algorithm01";
var $6eb8025480f48681$var$dependencies = [
    "typed"
];
var $6eb8025480f48681$export$5e6d55d37a917802 = /* #__PURE__ */ (0, $jKx4O.factory)($6eb8025480f48681$var$name, $6eb8025480f48681$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  Dij          ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm1(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // process data types
        var dt = typeof adt === "string" && adt === bdt ? adt : undefined; // callback function
        var cf = dt ? typed.find(callback, [
            dt,
            dt
        ]) : callback; // vars
        var i, j; // result (DenseMatrix)
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // mark i as updated
                w[i] = mark;
            } // loop rows
            for(i = 0; i < rows; i++)// check row is in workspace
            if (w[i] === mark) // c[i][j] was already calculated
            cdata[i][j] = x[i];
            else // item does not exist in S
            cdata[i][j] = adata[i][j];
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("5JY23", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm04", function () { return $42dfb8dc49686467$export$898ea3bef50d41b7; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $42dfb8dc49686467$var$name = "algorithm04";
var $42dfb8dc49686467$var$dependencies = [
    "typed",
    "equalScalar"
];
var $42dfb8dc49686467$export$898ea3bef50d41b7 = /* #__PURE__ */ (0, $jKx4O.factory)($42dfb8dc49686467$var$name, $42dfb8dc49686467$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  B(i,j)       ; B(i,j) !== 0
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm04(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspace
        var xa = avalues && bvalues ? [] : undefined;
        var xb = avalues && bvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // update c
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check row exists in A
                if (wa[i] === mark) // update record in xa @ i
                {
                    if (xa) {
                        // invoke callback
                        var v = cf(xa[i], bvalues[k]); // check for zero
                        if (!eq(v, zero)) // update workspace
                        xa[i] = v;
                        else // remove mark (index will be removed later)
                        wa[i] = null;
                    }
                } else {
                    // update c
                    cindex.push(i); // update workspace
                    wb[i] = mark; // check we need to process values
                    if (xb) xb[i] = bvalues[k];
                }
            } // check we need to process values (non pattern matrix)
            if (xa && xb) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // check workspace has value @ i
                    if (wa[i] === mark) {
                        // push value (Aij != 0 || (Aij != 0 && Bij != 0))
                        cvalues[k] = xa[i]; // increment pointer
                        k++;
                    } else if (wb[i] === mark) {
                        // push value (bij != 0)
                        cvalues[k] = xb[i]; // increment pointer
                        k++;
                    } else // remove index @ k
                    cindex.splice(k, 1);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("fs8LR", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm10", function () { return $b40046472f8426f2$export$72a88f2eee9ec1ed; });

var $jKx4O = parcelRequire("jKx4O");
var $b40046472f8426f2$var$name = "algorithm10";
var $b40046472f8426f2$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $b40046472f8426f2$export$72a88f2eee9ec1ed = /* #__PURE__ */ (0, $jKx4O.factory)($b40046472f8426f2$var$name, $b40046472f8426f2$var$dependencies, function(_ref) {
    var typed = _ref.typed, DenseMatrix = _ref.DenseMatrix;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  b          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm10(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = b;
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("kJFHo", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm13", function () { return $f1885b1f1a2ec110$export$fa05124e71a8ffb3; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $f1885b1f1a2ec110$var$name = "algorithm13";
var $f1885b1f1a2ec110$var$dependencies = [
    "typed"
];
var $f1885b1f1a2ec110$export$fa05124e71a8ffb3 = /* #__PURE__ */ (0, $jKx4O.factory)($f1885b1f1a2ec110$var$name, $f1885b1f1a2ec110$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, Bij..z)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Matrix}   b                 The DenseMatrix instance (B)
   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
   */ return function algorithm13(a, b, callback) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b arrays
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // c arrays
        var csize = []; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // validate each one of the dimension sizes
        for(var s = 0; s < asize.length; s++){
            // must match
            if (asize[s] !== bsize[s]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
             // update dimension in c
            csize[s] = asize[s];
        } // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: csize,
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = f(av[i], bv[i]);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
        return cv;
    }
});

});

parcelRegister("5ntii", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm14", function () { return $3ea5d2f0579812dd$export$e5afe3bc814ef550; });

var $jKx4O = parcelRequire("jKx4O");

var $glBd7 = parcelRequire("glBd7");
var $3ea5d2f0579812dd$var$name = "algorithm14";
var $3ea5d2f0579812dd$var$dependencies = [
    "typed"
];
var $3ea5d2f0579812dd$export$e5afe3bc814ef550 = /* #__PURE__ */ (0, $jKx4O.factory)($3ea5d2f0579812dd$var$name, $3ea5d2f0579812dd$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, b)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij..z,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
   */ return function algorithm14(a, b, callback, inverse) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: (0, $glBd7.clone)(asize),
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv, inverse) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
        return cv;
    }
});

});


parcelRegister("b5YZR", function(module, exports) {

$parcel$export(module.exports, "createAddScalar", function () { return $813f7a01bb14fae7$export$bbebd809b9ccc50b; });

var $jKx4O = parcelRequire("jKx4O");

var $cqeCl = parcelRequire("cqeCl");
var $813f7a01bb14fae7$var$name = "addScalar";
var $813f7a01bb14fae7$var$dependencies = [
    "typed"
];
var $813f7a01bb14fae7$export$bbebd809b9ccc50b = /* #__PURE__ */ (0, $jKx4O.factory)($813f7a01bb14fae7$var$name, $813f7a01bb14fae7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Add two scalar values, `x + y`.
   * This function is meant for internal use: it is used by the public function
   * `add`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit}     Sum of `x` and `y`
   * @private
   */ var addScalar = typed($813f7a01bb14fae7$var$name, {
        "number, number": (0, $cqeCl.addNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.add(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.plus(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.add(y);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (x.value === null || x.value === undefined) throw new Error("Parameter x contains a unit with undefined value");
            if (y.value === null || y.value === undefined) throw new Error("Parameter y contains a unit with undefined value");
            if (!x.equalBase(y)) throw new Error("Units do not match");
            var res = x.clone();
            res.value = addScalar(res.value, y.value);
            res.fixPrefix = false;
            return res;
        }
    });
    return addScalar;
});

});

parcelRegister("cJ0gP", function(module, exports) {

$parcel$export(module.exports, "createAnd", function () { return $9439e5bb10686f3d$export$15a698d88cae0eff; });

var $16D4T = parcelRequire("16D4T");

var $1Gmbc = parcelRequire("1Gmbc");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $c7RNU = parcelRequire("c7RNU");

var $jKx4O = parcelRequire("jKx4O");

var $e6Xsb = parcelRequire("e6Xsb");
var $9439e5bb10686f3d$var$name = "and";
var $9439e5bb10686f3d$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "not"
];
var $9439e5bb10686f3d$export$15a698d88cae0eff = /* #__PURE__ */ (0, $jKx4O.factory)($9439e5bb10686f3d$var$name, $9439e5bb10686f3d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, not = _ref.not;
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $c7RNU.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.and(x, y)
   *
   * Examples:
   *
   *    math.and(2, 4)   // returns true
   *
   *    a = [2, 0, 0]
   *    b = [3, 7, 0]
   *    c = 0
   *
   *    math.and(a, b)   // returns [true, false, false]
   *    math.and(a, c)   // returns [false, false, false]
   *
   * See also:
   *
   *    not, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when both inputs are defined with a nonzero/nonempty value.
   */ var and = typed($9439e5bb10686f3d$var$name, {
        "number, number": (0, $e6Xsb.andNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return and(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, and, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, and, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, and, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, and);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return and(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return and(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return and(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(x, y, and, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(x, y, and, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(y, x, and, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(y, x, and, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return and(matrix(x), y).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return and(x, matrix(y)).valueOf();
        }
    });
    return and;
});

});
parcelRegister("16D4T", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm02", function () { return $0ce4aa0ecaca6b9d$export$92edb534a8f19a37; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $0ce4aa0ecaca6b9d$var$name = "algorithm02";
var $0ce4aa0ecaca6b9d$var$dependencies = [
    "typed",
    "equalScalar"
];
var $0ce4aa0ecaca6b9d$export$92edb534a8f19a37 = /* #__PURE__ */ (0, $jKx4O.factory)($0ce4aa0ecaca6b9d$var$name, $0ce4aa0ecaca6b9d$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm02(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (SparseMatrix)
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update C(i,j)
                var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // check for nonzero
                if (!eq(cij, zero)) {
                    // push i & v
                    cindex.push(i);
                    cvalues.push(cij);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return sparseMatrix.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("1Gmbc", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm11", function () { return $139aeb15b38cb947$export$a38279a12199d831; });

var $jKx4O = parcelRequire("jKx4O");
var $139aeb15b38cb947$var$name = "algorithm11";
var $139aeb15b38cb947$var$dependencies = [
    "typed",
    "equalScalar"
];
var $139aeb15b38cb947$export$a38279a12199d831 = /* #__PURE__ */ (0, $jKx4O.factory)($139aeb15b38cb947$var$name, $139aeb15b38cb947$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm11(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize ptr
            cptr[j] = cindex.length; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = aindex[k]; // invoke callback
                var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b); // check value is zero
                if (!eq(v, zero)) {
                    // push index & value
                    cindex.push(i);
                    cvalues.push(v);
                }
            }
        } // update ptr
        cptr[columns] = cindex.length; // return sparse matrix
        return s.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("c7RNU", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm06", function () { return $8d3fdfd30bc3ea0a$export$d6f401e6f2a7e54b; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");

var $fbkGg = parcelRequire("fbkGg");
var $8d3fdfd30bc3ea0a$var$name = "algorithm06";
var $8d3fdfd30bc3ea0a$var$dependencies = [
    "typed",
    "equalScalar"
];
var $8d3fdfd30bc3ea0a$export$d6f401e6f2a7e54b = /* #__PURE__ */ (0, $jKx4O.factory)($8d3fdfd30bc3ea0a$var$name, $8d3fdfd30bc3ea0a$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm06(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // marks indicating value in a given row has been updated
        var u = []; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            (0, $fbkGg.scatter)(a, j, w, x, u, mark, cindex, cf); // scatter the values of B(:,j) into workspace
            (0, $fbkGg.scatter)(b, j, w, x, u, mark, cindex, cf); // check we need to process values (non pattern matrix)
            if (x) {
                // initialize first index in j
                var k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    var i = cindex[k]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[i] === mark) {
                        // value @ i
                        var v = x[i]; // check for zero value
                        if (!eq(v, zero)) {
                            // push value
                            cvalues.push(v); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    } else // remove value @ i, do not increment pointer
                    cindex.splice(k, 1);
                }
            } else {
                // initialize first index in j
                var p = cptr[j]; // loop index in j
                while(p < cindex.length){
                    // row
                    var r = cindex[p]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[r] !== mark) // remove value @ i, do not increment pointer
                    cindex.splice(p, 1);
                    else // increment pointer
                    p++;
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("e6Xsb", function(module, exports) {

$parcel$export(module.exports, "notNumber", function () { return $a45fbe7d5c30de9e$export$5c3e9fce4e8f3d3a; });
$parcel$export(module.exports, "orNumber", function () { return $a45fbe7d5c30de9e$export$cb9e31d07eec8012; });
$parcel$export(module.exports, "xorNumber", function () { return $a45fbe7d5c30de9e$export$17cc7dc3a74df3af; });
$parcel$export(module.exports, "andNumber", function () { return $a45fbe7d5c30de9e$export$11dffb061e00e795; });
var $a45fbe7d5c30de9e$var$n1 = "number";
var $a45fbe7d5c30de9e$var$n2 = "number, number";
function $a45fbe7d5c30de9e$export$5c3e9fce4e8f3d3a(x) {
    return !x;
}
$a45fbe7d5c30de9e$export$5c3e9fce4e8f3d3a.signature = $a45fbe7d5c30de9e$var$n1;
function $a45fbe7d5c30de9e$export$cb9e31d07eec8012(x, y) {
    return !!(x || y);
}
$a45fbe7d5c30de9e$export$cb9e31d07eec8012.signature = $a45fbe7d5c30de9e$var$n2;
function $a45fbe7d5c30de9e$export$17cc7dc3a74df3af(x, y) {
    return !!x !== !!y;
}
$a45fbe7d5c30de9e$export$17cc7dc3a74df3af.signature = $a45fbe7d5c30de9e$var$n2;
function $a45fbe7d5c30de9e$export$11dffb061e00e795(x, y) {
    return !!(x && y);
}
$a45fbe7d5c30de9e$export$11dffb061e00e795.signature = $a45fbe7d5c30de9e$var$n2;

});


parcelRegister("i49k9", function(module, exports) {

$parcel$export(module.exports, "createArg", function () { return $d26fd5490e0a61fb$export$bde3dabbd4699a93; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $d26fd5490e0a61fb$var$name = "arg";
var $d26fd5490e0a61fb$var$dependencies = [
    "typed"
];
var $d26fd5490e0a61fb$export$bde3dabbd4699a93 = /* #__PURE__ */ (0, $jKx4O.factory)($d26fd5490e0a61fb$var$name, $d26fd5490e0a61fb$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the argument of a complex value.
   * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.arg(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 2)
   *    math.arg(a) / math.pi          // returns number 0.25
   *
   *    const b = math.complex('2 + 3i')
   *    math.arg(b)                    // returns number 0.982793723247329
   *    math.atan2(3, 2)               // returns number 0.982793723247329
   *
   * See also:
   *
   *    re, im, conj, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The argument of x
   */ var arg = typed($d26fd5490e0a61fb$var$name, {
        number: function number(x) {
            return Math.atan2(0, x);
        },
        BigNumber: function BigNumber(x) {
            return x.constructor.atan2(0, x);
        },
        Complex: function Complex(x) {
            return x.arg();
        },
        // TODO: implement BigNumber support for function arg
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, arg);
        }
    });
    return arg;
});

});

parcelRegister("5OWmv", function(module, exports) {

$parcel$export(module.exports, "createAsec", function () { return $43cee4c3d79cb430$export$e1f28fc7c94f90b0; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $43cee4c3d79cb430$var$name = "asec";
var $43cee4c3d79cb430$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $43cee4c3d79cb430$export$e1f28fc7c94f90b0 = /* #__PURE__ */ (0, $jKx4O.factory)($43cee4c3d79cb430$var$name, $43cee4c3d79cb430$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asec(x)
   *
   * Examples:
   *
   *    math.asec(0.5)           // returns 1.0471975511965979
   *    math.asec(math.sec(1.5)) // returns 1.5
   *
   *    math.asec(2)             // returns 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    acos, acot, acsc
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} The arc secant of x
   */ var asec = typed($43cee4c3d79cb430$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $7HpLG.asecNumber)(x);
            return new Complex(x, 0).asec();
        },
        Complex: function Complex(x) {
            return x.asec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acos();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, asec);
        }
    });
    return asec;
});

});

parcelRegister("75kpy", function(module, exports) {

$parcel$export(module.exports, "createAsech", function () { return $5288d5454c1faca3$export$8eeff5f09afe95bc; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $5288d5454c1faca3$var$name = "asech";
var $5288d5454c1faca3$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $5288d5454c1faca3$export$8eeff5f09afe95bc = /* #__PURE__ */ (0, $jKx4O.factory)($5288d5454c1faca3$var$name, $5288d5454c1faca3$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic arcsecant of a value,
   * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asech(x)
   *
   * Examples:
   *
   *    math.asech(0.5)       // returns 1.3169578969248166
   *
   * See also:
   *
   *    acsch, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsecant of x
   */ var asech = typed($5288d5454c1faca3$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) {
                var xInv = 1 / x;
                if (xInv > 0 || config.predictable) return (0, $7HpLG.asechNumber)(x);
                var ret = Math.sqrt(xInv * xInv - 1);
                return new Complex(Math.log(ret - xInv), Math.PI);
            }
            return new Complex(x, 0).asech();
        },
        Complex: function Complex(x) {
            return x.asech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acosh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, asech);
        }
    });
    return asech;
});

});

parcelRegister("dheaH", function(module, exports) {

$parcel$export(module.exports, "createAsin", function () { return $9aa7db11438fae70$export$5f05d91ddc56bc14; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $9aa7db11438fae70$var$name = "asin";
var $9aa7db11438fae70$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $9aa7db11438fae70$export$5f05d91ddc56bc14 = /* #__PURE__ */ (0, $jKx4O.factory)($9aa7db11438fae70$var$name, $9aa7db11438fae70$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the inverse sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asin(x)
   *
   * Examples:
   *
   *    math.asin(0.5)           // returns number 0.5235987755982989
   *    math.asin(math.sin(1.5)) // returns number ~1.5
   *
   *    math.asin(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    sin, atan, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc sine of x
   */ var asin = typed($9aa7db11438fae70$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.asin(x);
            else return new Complex(x, 0).asin();
        },
        Complex: function Complex(x) {
            return x.asin();
        },
        BigNumber: function BigNumber(x) {
            return x.asin();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since asin(0) = 0
            return (0, $fbkGg.deepMap)(x, asin, true);
        }
    });
    return asin;
});

});

parcelRegister("eIEnj", function(module, exports) {

$parcel$export(module.exports, "createAsinh", function () { return $ab747e5c096817ee$export$7278bb4e3c84d46a; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $ab747e5c096817ee$var$name = "asinh";
var $ab747e5c096817ee$var$dependencies = [
    "typed"
];
var $ab747e5c096817ee$export$7278bb4e3c84d46a = /* #__PURE__ */ (0, $jKx4O.factory)($ab747e5c096817ee$var$name, $ab747e5c096817ee$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the hyperbolic arcsine of a value,
   * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asinh(x)
   *
   * Examples:
   *
   *    math.asinh(0.5)       // returns 0.48121182505960347
   *
   * See also:
   *
   *    acosh, atanh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsine of x
   */ var asinh = typed("asinh", {
        number: (0, $7HpLG.asinhNumber),
        Complex: function Complex(x) {
            return x.asinh();
        },
        BigNumber: function BigNumber(x) {
            return x.asinh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since asinh(0) = 0
            return (0, $fbkGg.deepMap)(x, asinh, true);
        }
    });
    return asinh;
});

});

parcelRegister("8PPlP", function(module, exports) {

$parcel$export(module.exports, "createAtan", function () { return $66eaeb6905a58910$export$b87f3a3301a24256; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $66eaeb6905a58910$var$name = "atan";
var $66eaeb6905a58910$var$dependencies = [
    "typed"
];
var $66eaeb6905a58910$export$b87f3a3301a24256 = /* #__PURE__ */ (0, $jKx4O.factory)($66eaeb6905a58910$var$name, $66eaeb6905a58910$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the inverse tangent of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan(x)
   *
   * Examples:
   *
   *    math.atan(0.5)           // returns number 0.4636476090008061
   *    math.atan(math.tan(1.5)) // returns number 1.5
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, asin, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc tangent of x
   */ var atan = typed("atan", {
        number: function number(x) {
            return Math.atan(x);
        },
        Complex: function Complex(x) {
            return x.atan();
        },
        BigNumber: function BigNumber(x) {
            return x.atan();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since atan(0) = 0
            return (0, $fbkGg.deepMap)(x, atan, true);
        }
    });
    return atan;
});

});

parcelRegister("crkXv", function(module, exports) {

$parcel$export(module.exports, "createAtan2", function () { return $90e843a1e502ea89$export$c56716e11a38354e; });

var $jKx4O = parcelRequire("jKx4O");

var $16D4T = parcelRequire("16D4T");

var $e6fFw = parcelRequire("e6fFw");

var $bLY1y = parcelRequire("bLY1y");

var $1Gmbc = parcelRequire("1Gmbc");

var $272zs = parcelRequire("272zs");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");
var $90e843a1e502ea89$var$name = "atan2";
var $90e843a1e502ea89$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix"
];
var $90e843a1e502ea89$export$c56716e11a38354e = /* #__PURE__ */ (0, $jKx4O.factory)($90e843a1e502ea89$var$name, $90e843a1e502ea89$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, BigNumber = _ref.BigNumber, DenseMatrix = _ref.DenseMatrix;
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm09 = (0, $bLY1y.createAlgorithm09)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the inverse tangent function with two arguments, y/x.
   * By providing two arguments, the right quadrant of the computed angle can be
   * determined.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan2(y, x)
   *
   * Examples:
   *
   *    math.atan2(2, 2) / math.pi       // returns number 0.25
   *
   *    const angle = math.unit(60, 'deg') // returns Unit 60 deg
   *    const x = math.cos(angle)
   *    const y = math.sin(angle)
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, atan, sin, cos
   *
   * @param {number | Array | Matrix} y  Second dimension
   * @param {number | Array | Matrix} x  First dimension
   * @return {number | Array | Matrix} Four-quadrant inverse tangent
   */ var atan2 = typed($90e843a1e502ea89$var$name, {
        "number, number": Math.atan2,
        // Complex numbers doesn't seem to have a reasonable implementation of
        // atan2(). Even Matlab removed the support, after they only calculated
        // the atan only on base of the real part of the numbers and ignored the imaginary.
        "BigNumber, BigNumber": function BigNumberBigNumber(y, x) {
            return BigNumber.atan2(y, x);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, atan2, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            // mind the order of y and x!
            return algorithm02(y, x, atan2, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, atan2, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, atan2);
        },
        "Array, Array": function ArrayArray(x, y) {
            return atan2(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return atan2(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return atan2(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, atan2, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, atan2, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // mind the order of y and x
            return algorithm12(y, x, atan2, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // mind the order of y and x
            return algorithm14(y, x, atan2, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            return algorithm14(matrix(x), y, atan2, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            return algorithm14(matrix(y), x, atan2, true).valueOf();
        }
    });
    return atan2;
});

});
parcelRegister("e6fFw", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm03", function () { return $a43dc7b113f64528$export$486bb900f1a3c833; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $a43dc7b113f64528$var$name = "algorithm03";
var $a43dc7b113f64528$var$dependencies = [
    "typed"
];
var $a43dc7b113f64528$export$486bb900f1a3c833 = /* #__PURE__ */ (0, $jKx4O.factory)($a43dc7b113f64528$var$name, $a43dc7b113f64528$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
   * Callback function invoked M*N times.
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(Dij, 0)    ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm03(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (DenseMatrix)
        var cdata = []; // initialize dense matrix
        for(var z = 0; z < rows; z++)// initialize row
        cdata[z] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                w[i] = mark;
            } // process workspace
            for(var y = 0; y < rows; y++)// check we have a calculated value for current row
            if (w[y] === mark) // use calculated value
            cdata[y][j] = x[y];
            else // calculate value
            cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("bLY1y", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm09", function () { return $02363c77ce089755$export$c769437575b0fcdd; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $02363c77ce089755$var$name = "algorithm09";
var $02363c77ce089755$var$dependencies = [
    "typed",
    "equalScalar"
];
var $02363c77ce089755$export$c769437575b0fcdd = /* #__PURE__ */ (0, $jKx4O.factory)($02363c77ce089755$var$name, $02363c77ce089755$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij).
   * Callback function invoked NZA times, number of nonzero elements in A.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm09(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // column mark
            var mark = j + 1; // check we need to process values
            if (x) // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                w[i] = mark;
                x[i] = bvalues[k];
            }
             // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // check we need to process values
                if (x) {
                    // b value @ i,j
                    var vb = w[i] === mark ? x[i] : zero; // invoke f
                    var vc = cf(avalues[k], vb); // check zero value
                    if (!eq(vc, zero)) {
                        // push index
                        cindex.push(i); // push value
                        cvalues.push(vc);
                    }
                } else // push index
                cindex.push(i);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("272zs", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm12", function () { return $189e3ab9e9a907c5$export$806772cd23b603dc; });

var $jKx4O = parcelRequire("jKx4O");
var $189e3ab9e9a907c5$var$name = "algorithm12";
var $189e3ab9e9a907c5$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $189e3ab9e9a907c5$export$806772cd23b603dc = /* #__PURE__ */ (0, $jKx4O.factory)($189e3ab9e9a907c5$var$name, $189e3ab9e9a907c5$var$dependencies, function(_ref) {
    var typed = _ref.typed, DenseMatrix = _ref.DenseMatrix;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked MxN times.
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(0, b)    ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm12(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("ju1VR", function(module, exports) {

$parcel$export(module.exports, "createAtanh", function () { return $e2f2515813ac652d$export$c2dbbeab1e5e6195; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $e2f2515813ac652d$var$name = "atanh";
var $e2f2515813ac652d$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $e2f2515813ac652d$export$c2dbbeab1e5e6195 = /* #__PURE__ */ (0, $jKx4O.factory)($e2f2515813ac652d$var$name, $e2f2515813ac652d$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the hyperbolic arctangent of a value,
   * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atanh(x)
   *
   * Examples:
   *
   *    math.atanh(0.5)       // returns 0.5493061443340549
   *
   * See also:
   *
   *    acosh, asinh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arctangent of x
   */ var atanh = typed($e2f2515813ac652d$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) return (0, $7HpLG.atanhNumber)(x);
            return new Complex(x, 0).atanh();
        },
        Complex: function Complex(x) {
            return x.atanh();
        },
        BigNumber: function BigNumber(x) {
            return x.atanh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since atanh(0) = 0
            return (0, $fbkGg.deepMap)(x, atanh, true);
        }
    });
    return atanh;
});

});

parcelRegister("aUPN9", function(module, exports) {

$parcel$export(module.exports, "createSpeedOfLight", function () { return $7f274f1b4b71929e$export$ace78258608300fc; });
$parcel$export(module.exports, "createGravitationConstant", function () { return $7f274f1b4b71929e$export$157e78cb05354391; });
$parcel$export(module.exports, "createPlanckConstant", function () { return $7f274f1b4b71929e$export$e58ff8150d83ea6a; });
$parcel$export(module.exports, "createReducedPlanckConstant", function () { return $7f274f1b4b71929e$export$50bee65ab76b402; });
$parcel$export(module.exports, "createMagneticConstant", function () { return $7f274f1b4b71929e$export$e7fcb8898ecb0703; });
$parcel$export(module.exports, "createElectricConstant", function () { return $7f274f1b4b71929e$export$d69030cf93f04407; });
$parcel$export(module.exports, "createVacuumImpedance", function () { return $7f274f1b4b71929e$export$c9ff08d282f03cf0; });
$parcel$export(module.exports, "createCoulomb", function () { return $7f274f1b4b71929e$export$815f2029cd62d0d6; });
$parcel$export(module.exports, "createElementaryCharge", function () { return $7f274f1b4b71929e$export$542715ad7e3a9798; });
$parcel$export(module.exports, "createBohrMagneton", function () { return $7f274f1b4b71929e$export$f5851397fd1173db; });
$parcel$export(module.exports, "createConductanceQuantum", function () { return $7f274f1b4b71929e$export$e26bbd27fc291ddf; });
$parcel$export(module.exports, "createInverseConductanceQuantum", function () { return $7f274f1b4b71929e$export$f2f136373157165b; });
$parcel$export(module.exports, "createMagneticFluxQuantum", function () { return $7f274f1b4b71929e$export$fd46b6c8680e4d01; });
$parcel$export(module.exports, "createNuclearMagneton", function () { return $7f274f1b4b71929e$export$9670d94122b9a81b; });
$parcel$export(module.exports, "createKlitzing", function () { return $7f274f1b4b71929e$export$e3f21ac13bee6a0f; });
$parcel$export(module.exports, "createBohrRadius", function () { return $7f274f1b4b71929e$export$19b72356ad84e4ee; });
$parcel$export(module.exports, "createClassicalElectronRadius", function () { return $7f274f1b4b71929e$export$68a9771dccce9a23; });
$parcel$export(module.exports, "createElectronMass", function () { return $7f274f1b4b71929e$export$85362d2a7862e209; });
$parcel$export(module.exports, "createFermiCoupling", function () { return $7f274f1b4b71929e$export$b6687a2f3911256b; });
$parcel$export(module.exports, "createFineStructure", function () { return $7f274f1b4b71929e$export$aaddb59a993d3ac4; });
$parcel$export(module.exports, "createHartreeEnergy", function () { return $7f274f1b4b71929e$export$8bb818baeaa40bd6; });
$parcel$export(module.exports, "createProtonMass", function () { return $7f274f1b4b71929e$export$f357c1a8d4fccef6; });
$parcel$export(module.exports, "createDeuteronMass", function () { return $7f274f1b4b71929e$export$a403f6c5bed71f22; });
$parcel$export(module.exports, "createNeutronMass", function () { return $7f274f1b4b71929e$export$676d5ebe8fbeb250; });
$parcel$export(module.exports, "createQuantumOfCirculation", function () { return $7f274f1b4b71929e$export$6840f334b8a5b6b1; });
$parcel$export(module.exports, "createRydberg", function () { return $7f274f1b4b71929e$export$fd1b48ecb0d5c0ef; });
$parcel$export(module.exports, "createThomsonCrossSection", function () { return $7f274f1b4b71929e$export$229739a879741f68; });
$parcel$export(module.exports, "createWeakMixingAngle", function () { return $7f274f1b4b71929e$export$fa2d42c5c25c1883; });
$parcel$export(module.exports, "createEfimovFactor", function () { return $7f274f1b4b71929e$export$55fc8769b037d266; });
$parcel$export(module.exports, "createAtomicMass", function () { return $7f274f1b4b71929e$export$2f8d2da219209d0a; });
$parcel$export(module.exports, "createAvogadro", function () { return $7f274f1b4b71929e$export$4924e3d8de6ad850; });
$parcel$export(module.exports, "createBoltzmann", function () { return $7f274f1b4b71929e$export$221b7a8c9510b6cc; });
$parcel$export(module.exports, "createFaraday", function () { return $7f274f1b4b71929e$export$17ef8d738c9b0091; });
$parcel$export(module.exports, "createFirstRadiation", function () { return $7f274f1b4b71929e$export$266a9bae8a62fb6e; });
$parcel$export(module.exports, "createLoschmidt", function () { return $7f274f1b4b71929e$export$c38bce537e0ffddb; });
$parcel$export(module.exports, "createGasConstant", function () { return $7f274f1b4b71929e$export$85a77a0842c24f74; });
$parcel$export(module.exports, "createMolarPlanckConstant", function () { return $7f274f1b4b71929e$export$12e2358797b853c9; });
$parcel$export(module.exports, "createMolarVolume", function () { return $7f274f1b4b71929e$export$f5e8f56ebfacbaca; });
$parcel$export(module.exports, "createSackurTetrode", function () { return $7f274f1b4b71929e$export$467c65d9dfc3d3a2; });
$parcel$export(module.exports, "createSecondRadiation", function () { return $7f274f1b4b71929e$export$ea93a35a6f35e1b6; });
$parcel$export(module.exports, "createStefanBoltzmann", function () { return $7f274f1b4b71929e$export$a943525a62f69cd2; });
$parcel$export(module.exports, "createWienDisplacement", function () { return $7f274f1b4b71929e$export$3c74568e9574d168; });
$parcel$export(module.exports, "createMolarMass", function () { return $7f274f1b4b71929e$export$85414d775c93e6de; });
$parcel$export(module.exports, "createMolarMassC12", function () { return $7f274f1b4b71929e$export$d5045cf71611a462; });
$parcel$export(module.exports, "createGravity", function () { return $7f274f1b4b71929e$export$42b5845f95e0feee; });
$parcel$export(module.exports, "createPlanckLength", function () { return $7f274f1b4b71929e$export$675ebbcd6bdcebd7; });
$parcel$export(module.exports, "createPlanckMass", function () { return $7f274f1b4b71929e$export$d44b96c94520b20e; });
$parcel$export(module.exports, "createPlanckTime", function () { return $7f274f1b4b71929e$export$3bf63d7b96fd8541; });
$parcel$export(module.exports, "createPlanckCharge", function () { return $7f274f1b4b71929e$export$43e139a6eec1ab59; });
$parcel$export(module.exports, "createPlanckTemperature", function () { return $7f274f1b4b71929e$export$d21f20fc89fac8c0; });

var $jKx4O = parcelRequire("jKx4O");
var $7f274f1b4b71929e$export$ace78258608300fc = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("speedOfLight", "299792458", "m s^-1");
var $7f274f1b4b71929e$export$157e78cb05354391 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2");
var $7f274f1b4b71929e$export$e58ff8150d83ea6a = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("planckConstant", "6.62607015e-34", "J s");
var $7f274f1b4b71929e$export$50bee65ab76b402 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("reducedPlanckConstant", "1.0545718176461565e-34", "J s"); // Electromagnetic constants
var $7f274f1b4b71929e$export$e7fcb8898ecb0703 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("magneticConstant", "1.25663706212e-6", "N A^-2");
var $7f274f1b4b71929e$export$d69030cf93f04407 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("electricConstant", "8.8541878128e-12", "F m^-1");
var $7f274f1b4b71929e$export$c9ff08d282f03cf0 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("vacuumImpedance", "376.730313667", "ohm");
var $7f274f1b4b71929e$export$815f2029cd62d0d6 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("coulomb", "8.987551792261171e9", "N m^2 C^-2");
var $7f274f1b4b71929e$export$542715ad7e3a9798 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("elementaryCharge", "1.602176634e-19", "C");
var $7f274f1b4b71929e$export$f5851397fd1173db = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("bohrMagneton", "9.2740100783e-24", "J T^-1");
var $7f274f1b4b71929e$export$e26bbd27fc291ddf = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("conductanceQuantum", "7.748091729863649e-5", "S");
var $7f274f1b4b71929e$export$f2f136373157165b = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("inverseConductanceQuantum", "12906.403729652257", "ohm");
var $7f274f1b4b71929e$export$fd46b6c8680e4d01 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("magneticFluxQuantum", "2.0678338484619295e-15", "Wb");
var $7f274f1b4b71929e$export$9670d94122b9a81b = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("nuclearMagneton", "5.0507837461e-27", "J T^-1");
var $7f274f1b4b71929e$export$e3f21ac13bee6a0f = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("klitzing", "25812.807459304513", "ohm");
var $7f274f1b4b71929e$export$c090909964c68de4 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("josephson", "4.835978484169836e14 Hz V", "Hz V^-1"); // TODO: support for Hz needed
var $7f274f1b4b71929e$export$19b72356ad84e4ee = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("bohrRadius", "5.29177210903e-11", "m");
var $7f274f1b4b71929e$export$68a9771dccce9a23 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("classicalElectronRadius", "2.8179403262e-15", "m");
var $7f274f1b4b71929e$export$85362d2a7862e209 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("electronMass", "9.1093837015e-31", "kg");
var $7f274f1b4b71929e$export$b6687a2f3911256b = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("fermiCoupling", "1.1663787e-5", "GeV^-2");
var $7f274f1b4b71929e$export$aaddb59a993d3ac4 = $7f274f1b4b71929e$var$numberFactory("fineStructure", 7.2973525693e-3);
var $7f274f1b4b71929e$export$8bb818baeaa40bd6 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("hartreeEnergy", "4.3597447222071e-18", "J");
var $7f274f1b4b71929e$export$f357c1a8d4fccef6 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("protonMass", "1.67262192369e-27", "kg");
var $7f274f1b4b71929e$export$a403f6c5bed71f22 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("deuteronMass", "3.3435830926e-27", "kg");
var $7f274f1b4b71929e$export$676d5ebe8fbeb250 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("neutronMass", "1.6749271613e-27", "kg");
var $7f274f1b4b71929e$export$6840f334b8a5b6b1 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1");
var $7f274f1b4b71929e$export$fd1b48ecb0d5c0ef = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("rydberg", "10973731.568160", "m^-1");
var $7f274f1b4b71929e$export$229739a879741f68 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("thomsonCrossSection", "6.6524587321e-29", "m^2");
var $7f274f1b4b71929e$export$fa2d42c5c25c1883 = $7f274f1b4b71929e$var$numberFactory("weakMixingAngle", 0.22290);
var $7f274f1b4b71929e$export$55fc8769b037d266 = $7f274f1b4b71929e$var$numberFactory("efimovFactor", 22.7); // Physico-chemical constants
var $7f274f1b4b71929e$export$2f8d2da219209d0a = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("atomicMass", "1.66053906660e-27", "kg");
var $7f274f1b4b71929e$export$4924e3d8de6ad850 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("avogadro", "6.02214076e23", "mol^-1");
var $7f274f1b4b71929e$export$221b7a8c9510b6cc = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("boltzmann", "1.380649e-23", "J K^-1");
var $7f274f1b4b71929e$export$17ef8d738c9b0091 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("faraday", "96485.33212331001", "C mol^-1");
var $7f274f1b4b71929e$export$266a9bae8a62fb6e = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("firstRadiation", "3.7417718521927573e-16", "W m^2"); // export const createSpectralRadiance = /* #__PURE__ */ unitFactory('spectralRadiance', '1.1910429723971881e-16', 'W m^2 sr^-1') // TODO spectralRadiance
var $7f274f1b4b71929e$export$c38bce537e0ffddb = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("loschmidt", "2.686780111798444e25", "m^-3");
var $7f274f1b4b71929e$export$85a77a0842c24f74 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("gasConstant", "8.31446261815324", "J K^-1 mol^-1");
var $7f274f1b4b71929e$export$12e2358797b853c9 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1");
var $7f274f1b4b71929e$export$f5e8f56ebfacbaca = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("molarVolume", "0.022413969545014137", "m^3 mol^-1");
var $7f274f1b4b71929e$export$467c65d9dfc3d3a2 = $7f274f1b4b71929e$var$numberFactory("sackurTetrode", -1.16487052358);
var $7f274f1b4b71929e$export$ea93a35a6f35e1b6 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("secondRadiation", "0.014387768775039337", "m K");
var $7f274f1b4b71929e$export$a943525a62f69cd2 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4");
var $7f274f1b4b71929e$export$3c74568e9574d168 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("wienDisplacement", "2.897771955e-3", "m K"); // Adopted values
var $7f274f1b4b71929e$export$85414d775c93e6de = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("molarMass", "0.99999999965e-3", "kg mol^-1");
var $7f274f1b4b71929e$export$d5045cf71611a462 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("molarMassC12", "11.9999999958e-3", "kg mol^-1");
var $7f274f1b4b71929e$export$42b5845f95e0feee = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("gravity", "9.80665", "m s^-2"); // atm is defined in Unit.js
var $7f274f1b4b71929e$export$675ebbcd6bdcebd7 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("planckLength", "1.616255e-35", "m");
var $7f274f1b4b71929e$export$d44b96c94520b20e = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("planckMass", "2.176435e-8", "kg");
var $7f274f1b4b71929e$export$3bf63d7b96fd8541 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("planckTime", "5.391245e-44", "s");
var $7f274f1b4b71929e$export$43e139a6eec1ab59 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("planckCharge", "1.87554603778e-18", "C");
var $7f274f1b4b71929e$export$d21f20fc89fac8c0 = /* #__PURE__ */ $7f274f1b4b71929e$var$unitFactory("planckTemperature", "1.416785e+32", "K"); // helper function to create a factory function which creates a physical constant,
// a Unit with either a number value or a BigNumber value depending on the configuration
function $7f274f1b4b71929e$var$unitFactory(name, valueStr, unitStr) {
    var dependencies = [
        "config",
        "Unit",
        "BigNumber"
    ];
    return (0, $jKx4O.factory)(name, dependencies, function(_ref) {
        var config = _ref.config, Unit = _ref.Unit, BigNumber = _ref.BigNumber;
        // Note that we can parse into number or BigNumber.
        // We do not parse into Fractions as that doesn't make sense: we would lose precision of the values
        // Therefore we dont use Unit.parse()
        var value = config.number === "BigNumber" ? new BigNumber(valueStr) : parseFloat(valueStr);
        var unit = new Unit(value, unitStr);
        unit.fixPrefix = true;
        return unit;
    });
} // helper function to create a factory function which creates a numeric constant,
// either a number or BigNumber depending on the configuration
function $7f274f1b4b71929e$var$numberFactory(name, value) {
    var dependencies = [
        "config",
        "BigNumber"
    ];
    return (0, $jKx4O.factory)(name, dependencies, function(_ref2) {
        var config = _ref2.config, BigNumber = _ref2.BigNumber;
        return config.number === "BigNumber" ? new BigNumber(value) : value;
    });
}

});

parcelRegister("89yPD", function(module, exports) {

$parcel$export(module.exports, "createBellNumbers", function () { return $5efa2ee3120b1ef1$export$7b7dc3bd00d38afb; });

var $jKx4O = parcelRequire("jKx4O");
var $5efa2ee3120b1ef1$var$name = "bellNumbers";
var $5efa2ee3120b1ef1$var$dependencies = [
    "typed",
    "addScalar",
    "isNegative",
    "isInteger",
    "stirlingS2"
];
var $5efa2ee3120b1ef1$export$7b7dc3bd00d38afb = /* #__PURE__ */ (0, $jKx4O.factory)($5efa2ee3120b1ef1$var$name, $5efa2ee3120b1ef1$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, isNegative = _ref.isNegative, isInteger = _ref.isInteger, stirlingS2 = _ref.stirlingS2;
    /**
   * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
   * bellNumbers only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.bellNumbers(n)
   *
   * Examples:
   *
   *    math.bellNumbers(3) // returns 5
   *    math.bellNumbers(8) // returns 4140
   *
   * See also:
   *
   *    stirlingS2
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @return {Number | BigNumber}     B(n)
   */ return typed($5efa2ee3120b1ef1$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function bellNumbers");
             // Sum (k=0, n) S(n,k).
            var result = 0;
            for(var i = 0; i <= n; i++)result = addScalar(result, stirlingS2(n, i));
            return result;
        }
    });
});

});

parcelRegister("dtuCC", function(module, exports) {

$parcel$export(module.exports, "createBignumber", function () { return $9cf5bca6240595e5$export$1c955ee1b8a97877; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $9cf5bca6240595e5$var$name = "bignumber";
var $9cf5bca6240595e5$var$dependencies = [
    "typed",
    "BigNumber"
];
var $9cf5bca6240595e5$export$1c955ee1b8a97877 = /* #__PURE__ */ (0, $jKx4O.factory)($9cf5bca6240595e5$var$name, $9cf5bca6240595e5$var$dependencies, function(_ref) {
    var typed = _ref.typed, BigNumber = _ref.BigNumber;
    /**
   * Create a BigNumber, which can store numbers with arbitrary precision.
   * When a matrix is provided, all elements will be converted to BigNumber.
   *
   * Syntax:
   *
   *    math.bignumber(x)
   *
   * Examples:
   *
   *    0.1 + 0.2                                  // returns number 0.30000000000000004
   *    math.bignumber(0.1) + math.bignumber(0.2)  // returns BigNumber 0.3
   *
   *
   *    7.2e500                                    // returns number Infinity
   *    math.bignumber('7.2e500')                  // returns BigNumber 7.2e500
   *
   * See also:
   *
   *    boolean, complex, index, matrix, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix | boolean | null} [value]  Value for the big number,
   *                                                    0 by default.
   * @returns {BigNumber} The created bignumber
   */ var bignumber = typed("bignumber", {
        "": function _() {
            return new BigNumber(0);
        },
        number: function number(x) {
            // convert to string to prevent errors in case of >15 digits
            return new BigNumber(x + "");
        },
        string: function string(x) {
            return new BigNumber(x);
        },
        BigNumber: function BigNumber(x) {
            // we assume a BigNumber is immutable
            return x;
        },
        Fraction: function Fraction(x) {
            return new BigNumber(x.n).div(x.d).times(x.s);
        },
        "null": function _null(x) {
            return new BigNumber(0);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, bignumber);
        }
    });
    return bignumber;
});

});

parcelRegister("kB26N", function(module, exports) {

$parcel$export(module.exports, "createBigNumberClass", function () { return $efe8e60f33016d7b$export$234de8d4231bfea3; });

var $hsEv0 = parcelRequire("hsEv0");

var $jKx4O = parcelRequire("jKx4O");
var $efe8e60f33016d7b$var$name = "BigNumber";
var $efe8e60f33016d7b$var$dependencies = [
    "?on",
    "config"
];
var $efe8e60f33016d7b$export$234de8d4231bfea3 = /* #__PURE__ */ (0, $jKx4O.factory)($efe8e60f33016d7b$var$name, $efe8e60f33016d7b$var$dependencies, function(_ref) {
    var on = _ref.on, config = _ref.config;
    var BigNumber = (0, (/*@__PURE__*/$parcel$interopDefault($hsEv0))).clone({
        precision: config.precision
    });
    /**
   * Attach type information
   */ BigNumber.prototype.type = "BigNumber";
    BigNumber.prototype.isBigNumber = true;
    /**
   * Get a JSON representation of a BigNumber containing
   * type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "BigNumber", "value": "0.2"}`
   */ BigNumber.prototype.toJSON = function() {
        return {
            mathjs: "BigNumber",
            value: this.toString()
        };
    };
    /**
   * Instantiate a BigNumber from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "BigNumber", "value": "0.2"}`
   * @return {BigNumber}
   */ BigNumber.fromJSON = function(json) {
        return new BigNumber(json.value);
    };
    if (on) // listen for changed in the configuration, automatically apply changed precision
    on("config", function(curr, prev) {
        if (curr.precision !== prev.precision) BigNumber.config({
            precision: curr.precision
        });
    });
    return BigNumber;
}, {
    isClass: true
});

});
parcelRegister("hsEv0", function(module, exports) {
(function(globalScope) {
    "use strict";
    /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = "0123456789abcdef", // The natural logarithm of 10 (1025 digits).
    LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", // Pi (1025 digits).
    PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = "2.3283064365386962890625e-10";
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.asin();
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return halfPi.minus(x);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + "").length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? "-" + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = "2.3283064365386962890625e-10";
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (x.e < 0 ? "e" : "e+") + x.e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */ function maxOrMin(Ctor, args, ltgt) {
        var y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            if (!y.s) {
                x = y;
                break;
            } else if (x[ltgt](y)) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf("_") > -1) {
            str = str.replace(/(\d)_(?=\d)/g, "$1");
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === "Infinity" || str === "NaN") {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf(".");
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace(".", "");
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf(".");
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace(".", "");
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? "0p+0" : "0";
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += "0";
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = "1."; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + "." + str.slice(1);
                    }
                    str = str + (e < 0 ? "p" : "p+") + e;
                } else if (e < 0) {
                    for(; ++e;)str = "0" + str;
                    str = "0." + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += "0";
                    else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                }
            }
            str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -EXP_LIMIT,
            0,
            "toExpPos",
            0,
            EXP_LIMIT,
            "maxE",
            0,
            EXP_LIMIT,
            "minE",
            -EXP_LIMIT,
            0,
            "modulo",
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ": " + v);
            }
        }
        if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === "number") {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                // Infinity, NaN.
                } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            } else if (t !== "string") throw Error(invalidArgument + v);
            // Minus sign?
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                // Plus sign?
                if (i === 43) v = v.slice(1);
                x.s = 1;
            }
            return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    "precision",
                    "rounding",
                    "toExpNeg",
                    "toExpPos",
                    "maxE",
                    "minE",
                    "modulo",
                    "crypto"
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, "lt");
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, "gt");
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) {
        if (typeof Symbol == "function" && typeof Symbol.iterator == "symbol") {
            P[Symbol["for"]("nodejs.util.inspect.custom")] = P.toString;
            P[Symbol.toStringTag] = "Decimal";
        }
        module.exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})(module.exports);

});


parcelRegister("59FZ8", function(module, exports) {

$parcel$export(module.exports, "createBitAnd", function () { return $3c0e5c62ad88e13e$export$bea4e06c5befec3b; });

var $hGVn5 = parcelRequire("hGVn5");

var $16D4T = parcelRequire("16D4T");

var $1Gmbc = parcelRequire("1Gmbc");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $c7RNU = parcelRequire("c7RNU");

var $jKx4O = parcelRequire("jKx4O");

var $exwQn = parcelRequire("exwQn");
var $3c0e5c62ad88e13e$var$name = "bitAnd";
var $3c0e5c62ad88e13e$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar"
];
var $3c0e5c62ad88e13e$export$bea4e06c5befec3b = /* #__PURE__ */ (0, $jKx4O.factory)($3c0e5c62ad88e13e$var$name, $3c0e5c62ad88e13e$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar;
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $c7RNU.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise AND two values, `x & y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitAnd(x, y)
   *
   * Examples:
   *
   *    math.bitAnd(53, 131)               // returns number 1
   *
   *    math.bitAnd([1, 12, 31], 42)       // returns Array [0, 8, 10]
   *
   * See also:
   *
   *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to and
   * @param  {number | BigNumber | Array | Matrix} y Second value to and
   * @return {number | BigNumber | Array | Matrix} AND of `x` and `y`
   */ var bitAnd = typed($3c0e5c62ad88e13e$var$name, {
        "number, number": (0, $exwQn.bitAndNumber),
        "BigNumber, BigNumber": (0, $hGVn5.bitAndBigNumber),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, bitAnd, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, bitAnd, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, bitAnd, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, bitAnd);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return bitAnd(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return bitAnd(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return bitAnd(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, bitAnd, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, bitAnd, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, bitAnd, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, bitAnd, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, bitAnd, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, bitAnd, true).valueOf();
        }
    });
    return bitAnd;
});

});
parcelRegister("hGVn5", function(module, exports) {

$parcel$export(module.exports, "bitAndBigNumber", function () { return $ce12dcaee604d9df$export$94757ce5cf54fec9; });
$parcel$export(module.exports, "bitNotBigNumber", function () { return $ce12dcaee604d9df$export$2ada53b3c51e9645; });
$parcel$export(module.exports, "bitOrBigNumber", function () { return $ce12dcaee604d9df$export$e43ec6c4cff46d2c; });
$parcel$export(module.exports, "bitXor", function () { return $ce12dcaee604d9df$export$bfcff4501301c191; });
$parcel$export(module.exports, "leftShiftBigNumber", function () { return $ce12dcaee604d9df$export$626dff8098a67b4c; });
$parcel$export(module.exports, "rightArithShiftBigNumber", function () { return $ce12dcaee604d9df$export$d489c03691bd4cd; });
/**
 * Bitwise and for Bignumbers
 *
 * Special Cases:
 *   N &  n =  N
 *   n &  0 =  0
 *   n & -1 =  n
 *   n &  n =  n
 *   I &  I =  I
 *  -I & -I = -I
 *   I & -I =  0
 *   I &  n =  n
 *   I & -n =  I
 *  -I &  n =  0
 *  -I & -n = -I
 *
 * @param {BigNumber} x
 * @param {BigNumber} y
 * @return {BigNumber} Result of `x` & `y`, is fully precise
 * @private
 */ function $ce12dcaee604d9df$export$94757ce5cf54fec9(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitAnd");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero() || y.eq(-1) || x.eq(y)) return x;
    if (y.isZero() || x.eq(-1)) return y;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) {
            if (x.isNegative() === y.isNegative()) return x;
            return new BigNumber(0);
        }
        if (!x.isFinite()) {
            if (y.isNegative()) return x;
            if (x.isNegative()) return new BigNumber(0);
            return y;
        }
        if (!y.isFinite()) {
            if (x.isNegative()) return y;
            if (y.isNegative()) return new BigNumber(0);
            return x;
        }
    }
    return $ce12dcaee604d9df$export$884842863a0853c4(x, y, function(a, b) {
        return a & b;
    });
}
function $ce12dcaee604d9df$export$2ada53b3c51e9645(x) {
    if (x.isFinite() && !x.isInteger()) throw new Error("Integer expected in function bitNot");
    var BigNumber = x.constructor;
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    var result = x.plus(new BigNumber(1));
    result.s = -result.s || null;
    BigNumber.config({
        precision: prevPrec
    });
    return result;
}
function $ce12dcaee604d9df$export$e43ec6c4cff46d2c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitOr");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    var negOne = new BigNumber(-1);
    if (x.isZero() || y.eq(negOne) || x.eq(y)) return y;
    if (y.isZero() || x.eq(negOne)) return x;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !x.isNegative() && y.isNegative() || x.isNegative() && !y.isNegative() && !y.isFinite()) return negOne;
        if (x.isNegative() && y.isNegative()) return x.isFinite() ? x : y;
        return x.isFinite() ? y : x;
    }
    return $ce12dcaee604d9df$export$884842863a0853c4(x, y, function(a, b) {
        return a | b;
    });
}
function $ce12dcaee604d9df$export$884842863a0853c4(x, y, func) {
    var BigNumber = x.constructor;
    var xBits, yBits;
    var xSign = +(x.s < 0);
    var ySign = +(y.s < 0);
    if (xSign) {
        xBits = $ce12dcaee604d9df$var$decCoefficientToBinaryString($ce12dcaee604d9df$export$2ada53b3c51e9645(x));
        for(var i = 0; i < xBits.length; ++i)xBits[i] ^= 1;
    } else xBits = $ce12dcaee604d9df$var$decCoefficientToBinaryString(x);
    if (ySign) {
        yBits = $ce12dcaee604d9df$var$decCoefficientToBinaryString($ce12dcaee604d9df$export$2ada53b3c51e9645(y));
        for(var _i = 0; _i < yBits.length; ++_i)yBits[_i] ^= 1;
    } else yBits = $ce12dcaee604d9df$var$decCoefficientToBinaryString(y);
    var minBits, maxBits, minSign;
    if (xBits.length <= yBits.length) {
        minBits = xBits;
        maxBits = yBits;
        minSign = xSign;
    } else {
        minBits = yBits;
        maxBits = xBits;
        minSign = ySign;
    }
    var shortLen = minBits.length;
    var longLen = maxBits.length;
    var expFuncVal = func(xSign, ySign) ^ 1;
    var outVal = new BigNumber(expFuncVal ^ 1);
    var twoPower = new BigNumber(1);
    var two = new BigNumber(2);
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    while(shortLen > 0){
        if (func(minBits[--shortLen], maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    while(longLen > 0){
        if (func(minSign, maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    BigNumber.config({
        precision: prevPrec
    });
    if (expFuncVal === 0) outVal.s = -outVal.s;
    return outVal;
}
/* Extracted from decimal.js, and edited to specialize. */ function $ce12dcaee604d9df$var$decCoefficientToBinaryString(x) {
    // Convert to string
    var a = x.d; // array with digits
    var r = a[0] + "";
    for(var i = 1; i < a.length; ++i){
        var s = a[i] + "";
        for(var z = 7 - s.length; z--;)s = "0" + s;
        r += s;
    }
    var j = r.length;
    while(r.charAt(j) === "0")j--;
    var xe = x.e;
    var str = r.slice(0, j + 1 || 1);
    var strL = str.length;
    if (xe > 0) {
        if (++xe > strL) {
            // Append zeros.
            xe -= strL;
            while(xe--)str += "0";
        } else if (xe < strL) str = str.slice(0, xe) + "." + str.slice(xe);
    } // Convert from base 10 (decimal) to base 2
    var arr = [
        0
    ];
    for(var _i2 = 0; _i2 < str.length;){
        var arrL = arr.length;
        while(arrL--)arr[arrL] *= 10;
        arr[0] += parseInt(str.charAt(_i2++)); // convert to int
        for(var _j = 0; _j < arr.length; ++_j)if (arr[_j] > 1) {
            if (arr[_j + 1] === null || arr[_j + 1] === undefined) arr[_j + 1] = 0;
            arr[_j + 1] += arr[_j] >> 1;
            arr[_j] &= 1;
        }
    }
    return arr.reverse();
}
function $ce12dcaee604d9df$export$bfcff4501301c191(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitXor");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero()) return y;
    if (y.isZero()) return x;
    if (x.eq(y)) return new BigNumber(0);
    var negOne = new BigNumber(-1);
    if (x.eq(negOne)) return $ce12dcaee604d9df$export$2ada53b3c51e9645(y);
    if (y.eq(negOne)) return $ce12dcaee604d9df$export$2ada53b3c51e9645(x);
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) return negOne;
        return new BigNumber(x.isNegative() === y.isNegative() ? Infinity : -Infinity);
    }
    return $ce12dcaee604d9df$export$884842863a0853c4(x, y, function(a, b) {
        return a ^ b;
    });
}
function $ce12dcaee604d9df$export$626dff8098a67b4c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function leftShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!x.isFinite() && !y.isFinite()) return new BigNumber(NaN);
     // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.times(Math.pow(2, y.toNumber()) + "");
    return x.times(new BigNumber(2).pow(y));
}
function $ce12dcaee604d9df$export$d489c03691bd4cd(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function rightArithShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!y.isFinite()) {
        if (x.isNegative()) return new BigNumber(-1);
        if (!x.isFinite()) return new BigNumber(NaN);
        return new BigNumber(0);
    } // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.div(Math.pow(2, y.toNumber()) + "").floor();
    return x.div(new BigNumber(2).pow(y)).floor();
}

});

parcelRegister("exwQn", function(module, exports) {

$parcel$export(module.exports, "bitAndNumber", function () { return $a95d9fd5586f5fce$export$e7607930867bd49a; });
$parcel$export(module.exports, "bitNotNumber", function () { return $a95d9fd5586f5fce$export$22a2b2a0351218e7; });
$parcel$export(module.exports, "bitOrNumber", function () { return $a95d9fd5586f5fce$export$9aecb772cb5ad1c7; });
$parcel$export(module.exports, "bitXorNumber", function () { return $a95d9fd5586f5fce$export$2260a44ec1c987dc; });
$parcel$export(module.exports, "leftShiftNumber", function () { return $a95d9fd5586f5fce$export$65c07a47901525ba; });
$parcel$export(module.exports, "rightArithShiftNumber", function () { return $a95d9fd5586f5fce$export$b6d96f775be90000; });
$parcel$export(module.exports, "rightLogShiftNumber", function () { return $a95d9fd5586f5fce$export$2a8d1e3dcede6e47; });

var $5wlxr = parcelRequire("5wlxr");
var $a95d9fd5586f5fce$var$n1 = "number";
var $a95d9fd5586f5fce$var$n2 = "number, number";
function $a95d9fd5586f5fce$export$e7607930867bd49a(x, y) {
    if (!(0, $5wlxr.isInteger)(x) || !(0, $5wlxr.isInteger)(y)) throw new Error("Integers expected in function bitAnd");
    return x & y;
}
$a95d9fd5586f5fce$export$e7607930867bd49a.signature = $a95d9fd5586f5fce$var$n2;
function $a95d9fd5586f5fce$export$22a2b2a0351218e7(x) {
    if (!(0, $5wlxr.isInteger)(x)) throw new Error("Integer expected in function bitNot");
    return ~x;
}
$a95d9fd5586f5fce$export$22a2b2a0351218e7.signature = $a95d9fd5586f5fce$var$n1;
function $a95d9fd5586f5fce$export$9aecb772cb5ad1c7(x, y) {
    if (!(0, $5wlxr.isInteger)(x) || !(0, $5wlxr.isInteger)(y)) throw new Error("Integers expected in function bitOr");
    return x | y;
}
$a95d9fd5586f5fce$export$9aecb772cb5ad1c7.signature = $a95d9fd5586f5fce$var$n2;
function $a95d9fd5586f5fce$export$2260a44ec1c987dc(x, y) {
    if (!(0, $5wlxr.isInteger)(x) || !(0, $5wlxr.isInteger)(y)) throw new Error("Integers expected in function bitXor");
    return x ^ y;
}
$a95d9fd5586f5fce$export$2260a44ec1c987dc.signature = $a95d9fd5586f5fce$var$n2;
function $a95d9fd5586f5fce$export$65c07a47901525ba(x, y) {
    if (!(0, $5wlxr.isInteger)(x) || !(0, $5wlxr.isInteger)(y)) throw new Error("Integers expected in function leftShift");
    return x << y;
}
$a95d9fd5586f5fce$export$65c07a47901525ba.signature = $a95d9fd5586f5fce$var$n2;
function $a95d9fd5586f5fce$export$b6d96f775be90000(x, y) {
    if (!(0, $5wlxr.isInteger)(x) || !(0, $5wlxr.isInteger)(y)) throw new Error("Integers expected in function rightArithShift");
    return x >> y;
}
$a95d9fd5586f5fce$export$b6d96f775be90000.signature = $a95d9fd5586f5fce$var$n2;
function $a95d9fd5586f5fce$export$2a8d1e3dcede6e47(x, y) {
    if (!(0, $5wlxr.isInteger)(x) || !(0, $5wlxr.isInteger)(y)) throw new Error("Integers expected in function rightLogShift");
    return x >>> y;
}
$a95d9fd5586f5fce$export$2a8d1e3dcede6e47.signature = $a95d9fd5586f5fce$var$n2;

});


parcelRegister("8DMga", function(module, exports) {

$parcel$export(module.exports, "createBitNot", function () { return $64a766a42aaf654b$export$9e7f3c72ca8b5aa; });

var $hGVn5 = parcelRequire("hGVn5");

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $exwQn = parcelRequire("exwQn");
var $64a766a42aaf654b$var$name = "bitNot";
var $64a766a42aaf654b$var$dependencies = [
    "typed"
];
var $64a766a42aaf654b$export$9e7f3c72ca8b5aa = /* #__PURE__ */ (0, $jKx4O.factory)($64a766a42aaf654b$var$name, $64a766a42aaf654b$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Bitwise NOT value, `~x`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.bitNot(x)
   *
   * Examples:
   *
   *    math.bitNot(1)               // returns number -2
   *
   *    math.bitNot([2, -3, 4])      // returns Array [-3, 2, 5]
   *
   * See also:
   *
   *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to not
   * @return {number | BigNumber | Array | Matrix} NOT of `x`
   */ var bitNot = typed($64a766a42aaf654b$var$name, {
        number: (0, $exwQn.bitNotNumber),
        BigNumber: (0, $hGVn5.bitNotBigNumber),
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, bitNot);
        }
    });
    return bitNot;
});

});

parcelRegister("deN86", function(module, exports) {

$parcel$export(module.exports, "createBitOr", function () { return $9a32b14f7d11a78d$export$f45a7846535e9b07; });

var $hGVn5 = parcelRequire("hGVn5");

var $jKx4O = parcelRequire("jKx4O");

var $5ntii = parcelRequire("5ntii");

var $kJFHo = parcelRequire("kJFHo");

var $fs8LR = parcelRequire("fs8LR");

var $5JY23 = parcelRequire("5JY23");

var $9vlUQ = parcelRequire("9vlUQ");

var $exwQn = parcelRequire("exwQn");
var $9a32b14f7d11a78d$var$name = "bitOr";
var $9a32b14f7d11a78d$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $9a32b14f7d11a78d$export$f45a7846535e9b07 = /* #__PURE__ */ (0, $jKx4O.factory)($9a32b14f7d11a78d$var$name, $9a32b14f7d11a78d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $9vlUQ.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $5JY23.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $fs8LR.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise OR two values, `x | y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the lowest print base.
   *
   * Syntax:
   *
   *    math.bitOr(x, y)
   *
   * Examples:
   *
   *    math.bitOr(1, 2)               // returns number 3
   *
   *    math.bitOr([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to or
   * @param  {number | BigNumber | Array | Matrix} y Second value to or
   * @return {number | BigNumber | Array | Matrix} OR of `x` and `y`
   */ var bitOr = typed($9a32b14f7d11a78d$var$name, {
        "number, number": (0, $exwQn.bitOrNumber),
        "BigNumber, BigNumber": (0, $hGVn5.bitOrBigNumber),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, bitOr);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, bitOr, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, bitOr, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, bitOr);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return bitOr(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return bitOr(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return bitOr(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, y, bitOr, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, bitOr, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, bitOr, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, bitOr, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, bitOr, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, bitOr, true).valueOf();
        }
    });
    return bitOr;
});

});

parcelRegister("3JaaR", function(module, exports) {

$parcel$export(module.exports, "createBitXor", function () { return $2b6d7771994e75ec$export$1cae728fa8e01928; });

var $hGVn5 = parcelRequire("hGVn5");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $272zs = parcelRequire("272zs");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $jKx4O = parcelRequire("jKx4O");

var $exwQn = parcelRequire("exwQn");
var $2b6d7771994e75ec$var$name = "bitXor";
var $2b6d7771994e75ec$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix"
];
var $2b6d7771994e75ec$export$1cae728fa8e01928 = /* #__PURE__ */ (0, $jKx4O.factory)($2b6d7771994e75ec$var$name, $2b6d7771994e75ec$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise XOR two values, `x ^ y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitXor(x, y)
   *
   * Examples:
   *
   *    math.bitXor(1, 2)               // returns number 3
   *
   *    math.bitXor([2, 3, 4], 4)       // returns Array [6, 7, 0]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to xor
   * @param  {number | BigNumber | Array | Matrix} y Second value to xor
   * @return {number | BigNumber | Array | Matrix} XOR of `x` and `y`
   */ var bitXor = typed($2b6d7771994e75ec$var$name, {
        "number, number": (0, $exwQn.bitXorNumber),
        "BigNumber, BigNumber": (0, $hGVn5.bitXor),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, bitXor);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, bitXor, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, bitXor, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, bitXor);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return bitXor(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return bitXor(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return bitXor(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, bitXor, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, bitXor, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, bitXor, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, bitXor, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, bitXor, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, bitXor, true).valueOf();
        }
    });
    return bitXor;
});

});
parcelRegister("axjwH", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm07", function () { return $7abc21fbabc7d9cb$export$b908fb77c4366999; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $7abc21fbabc7d9cb$var$name = "algorithm07";
var $7abc21fbabc7d9cb$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $7abc21fbabc7d9cb$export$b908fb77c4366999 = /* #__PURE__ */ (0, $jKx4O.factory)($7abc21fbabc7d9cb$var$name, $7abc21fbabc7d9cb$var$dependencies, function(_ref) {
    var typed = _ref.typed, DenseMatrix = _ref.DenseMatrix;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
   * Callback function invoked MxN times.
   *
   * C(i,j) = f(Aij, Bij)
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm07(a, b, callback) {
        // sparse matrix arrays
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // vars
        var i, j; // result arrays
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspaces
        var xa = [];
        var xb = []; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // loop columns
        for(j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            _scatter(a, j, wa, xa, mark); // scatter the values of B(:,j) into workspace
            _scatter(b, j, wb, xb, mark); // loop rows
            for(i = 0; i < rows; i++){
                // matrix values @ i,j
                var va = wa[i] === mark ? xa[i] : zero;
                var vb = wb[i] === mark ? xb[i] : zero; // invoke callback
                cdata[i][j] = cf(va, vb);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
    function _scatter(m, j, w, x, mark) {
        // a arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop values in column j
        for(var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++){
            // row
            var i = index[k]; // update workspace
            w[i] = mark;
            x[i] = values[k];
        }
    }
});

});


parcelRegister("faIDE", function(module, exports) {

$parcel$export(module.exports, "createBoolean", function () { return $b0ba6a73381c8803$export$3c82aec2d86a5525; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $b0ba6a73381c8803$var$name = "boolean";
var $b0ba6a73381c8803$var$dependencies = [
    "typed"
];
var $b0ba6a73381c8803$export$3c82aec2d86a5525 = /* #__PURE__ */ (0, $jKx4O.factory)($b0ba6a73381c8803$var$name, $b0ba6a73381c8803$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Create a boolean or convert a string or number to a boolean.
   * In case of a number, `true` is returned for non-zero numbers, and `false` in
   * case of zero.
   * Strings can be `'true'` or `'false'`, or can contain a number.
   * When value is a matrix, all elements will be converted to boolean.
   *
   * Syntax:
   *
   *    math.boolean(x)
   *
   * Examples:
   *
   *    math.boolean(0)     // returns false
   *    math.boolean(1)     // returns true
   *    math.boolean(-3)     // returns true
   *    math.boolean('true')     // returns true
   *    math.boolean('false')     // returns false
   *    math.boolean([1, 0, 1, 1])     // returns [true, false, true, true]
   *
   * See also:
   *
   *    bignumber, complex, index, matrix, string, unit
   *
   * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
   * @return {boolean | Array | Matrix} The boolean value
   */ var bool = typed($b0ba6a73381c8803$var$name, {
        "": function _() {
            return false;
        },
        "boolean": function boolean(x) {
            return x;
        },
        number: function number(x) {
            return !!x;
        },
        "null": function _null(x) {
            return false;
        },
        BigNumber: function BigNumber(x) {
            return !x.isZero();
        },
        string: function string(x) {
            // try case insensitive
            var lcase = x.toLowerCase();
            if (lcase === "true") return true;
            else if (lcase === "false") return false;
             // test whether value is a valid number
            var num = Number(x);
            if (x !== "" && !isNaN(num)) return !!num;
            throw new Error('Cannot convert "' + x + '" to a boolean');
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, bool);
        }
    });
    return bool;
});

});

parcelRegister("7IWw6", function(module, exports) {

$parcel$export(module.exports, "createCatalan", function () { return $59fa08b3fd04c787$export$5a3f7692f3d4dd50; });

var $jKx4O = parcelRequire("jKx4O");
var $59fa08b3fd04c787$var$name = "catalan";
var $59fa08b3fd04c787$var$dependencies = [
    "typed",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "combinations",
    "isNegative",
    "isInteger"
];
var $59fa08b3fd04c787$export$5a3f7692f3d4dd50 = /* #__PURE__ */ (0, $jKx4O.factory)($59fa08b3fd04c787$var$name, $59fa08b3fd04c787$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, combinations = _ref.combinations, isNegative = _ref.isNegative, isInteger = _ref.isInteger;
    /**
   * The Catalan Numbers enumerate combinatorial structures of many different types.
   * catalan only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.catalan(n)
   *
   * Examples:
   *
   *    math.catalan(3) // returns 5
   *    math.catalan(8) // returns 1430
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    nth Catalan number
   * @return {Number | BigNumber}     Cn(n)
   */ return typed($59fa08b3fd04c787$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function catalan");
            return divideScalar(combinations(multiplyScalar(n, 2), n), addScalar(n, 1));
        }
    });
});

});

parcelRegister("7YbQp", function(module, exports) {

$parcel$export(module.exports, "createCbrt", function () { return $5cd7530c969ff4e0$export$2103fed9c34b0004; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $5cd7530c969ff4e0$var$name = "cbrt";
var $5cd7530c969ff4e0$var$dependencies = [
    "config",
    "typed",
    "isNegative",
    "unaryMinus",
    "matrix",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $5cd7530c969ff4e0$export$2103fed9c34b0004 = /* #__PURE__ */ (0, $jKx4O.factory)($5cd7530c969ff4e0$var$name, $5cd7530c969ff4e0$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, isNegative = _ref.isNegative, unaryMinus = _ref.unaryMinus, matrix = _ref.matrix, Complex = _ref.Complex, BigNumber = _ref.BigNumber, Fraction = _ref.Fraction;
    /**
   * Calculate the cubic root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cbrt(x)
   *    math.cbrt(x, allRoots)
   *
   * Examples:
   *
   *    math.cbrt(27)                  // returns 3
   *    math.cube(3)                   // returns 27
   *    math.cbrt(-64)                 // returns -4
   *    math.cbrt(math.unit('27 m^3')) // returns Unit 3 m
   *    math.cbrt([27, 64, 125])       // returns [3, 4, 5]
   *
   *    const x = math.complex('8i')
   *    math.cbrt(x)                   // returns Complex 1.7320508075689 + i
   *    math.cbrt(x, true)             // returns Matrix [
   *                                    //    1.7320508075689 + i
   *                                    //   -1.7320508075689 + i
   *                                    //   -2i
   *                                    // ]
   *
   * See also:
   *
   *    square, sqrt, cube
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x
   *            Value for which to calculate the cubic root.
   * @param {boolean} [allRoots]  Optional, false by default. Only applicable
   *            when `x` is a number or complex number. If true, all complex
   *            roots are returned, if false (default) the principal root is
   *            returned.
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}
   *            Returns the cubic root of `x`
   */ var cbrt = typed($5cd7530c969ff4e0$var$name, {
        number: (0, $cqeCl.cbrtNumber),
        // note: signature 'number, boolean' is also supported,
        //       created by typed as it knows how to convert number to Complex
        Complex: _cbrtComplex,
        "Complex, boolean": _cbrtComplex,
        BigNumber: function BigNumber(x) {
            return x.cbrt();
        },
        Unit: _cbrtUnit,
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since cbrt(0) = 0
            return (0, $fbkGg.deepMap)(x, cbrt, true);
        }
    });
    /**
   * Calculate the cubic root for a complex number
   * @param {Complex} x
   * @param {boolean} [allRoots]   If true, the function will return an array
   *                               with all three roots. If false or undefined,
   *                               the principal root is returned.
   * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
   * @private
   */ function _cbrtComplex(x, allRoots) {
        // https://www.wikiwand.com/en/Cube_root#/Complex_numbers
        var arg3 = x.arg() / 3;
        var abs = x.abs(); // principal root:
        var principal = new Complex((0, $cqeCl.cbrtNumber)(abs), 0).mul(new Complex(0, arg3).exp());
        if (allRoots) {
            var all = [
                principal,
                new Complex((0, $cqeCl.cbrtNumber)(abs), 0).mul(new Complex(0, arg3 + Math.PI * 2 / 3).exp()),
                new Complex((0, $cqeCl.cbrtNumber)(abs), 0).mul(new Complex(0, arg3 - Math.PI * 2 / 3).exp())
            ];
            return config.matrix === "Array" ? all : matrix(all);
        } else return principal;
    }
    /**
   * Calculate the cubic root for a Unit
   * @param {Unit} x
   * @return {Unit} Returns the cubic root of x
   * @private
   */ function _cbrtUnit(x) {
        if (x.value && (0, $7E0JQ.isComplex)(x.value)) {
            var result = x.clone();
            result.value = 1.0;
            result = result.pow(1.0 / 3); // Compute the units
            result.value = _cbrtComplex(x.value); // Compute the value
            return result;
        } else {
            var negate = isNegative(x.value);
            if (negate) x.value = unaryMinus(x.value);
             // TODO: create a helper function for this
            var third;
            if ((0, $7E0JQ.isBigNumber)(x.value)) third = new BigNumber(1).div(3);
            else if ((0, $7E0JQ.isFraction)(x.value)) third = new Fraction(1, 3);
            else third = 1 / 3;
            var _result = x.pow(third);
            if (negate) _result.value = unaryMinus(_result.value);
            return _result;
        }
    }
    return cbrt;
});

});

parcelRegister("588AD", function(module, exports) {

$parcel$export(module.exports, "createCeil", function () { return $3bc45ce10db0433c$export$bab247d909829ddf; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");

var $9zoJy = parcelRequire("9zoJy");

var $cqeCl = parcelRequire("cqeCl");
var $3bc45ce10db0433c$var$name = "ceil";
var $3bc45ce10db0433c$var$dependencies = [
    "typed",
    "config",
    "round"
];
var $3bc45ce10db0433c$export$bab247d909829ddf = /* #__PURE__ */ (0, $jKx4O.factory)($3bc45ce10db0433c$var$name, $3bc45ce10db0433c$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, round = _ref.round;
    /**
   * Round a value towards plus infinity
   * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.ceil(x)
   *
   * Examples:
   *
   *    math.ceil(3.2)               // returns number 4
   *    math.ceil(3.8)               // returns number 4
   *    math.ceil(-4.2)              // returns number -4
   *    math.ceil(-4.7)              // returns number -4
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.ceil(c)                 // returns Complex 4 - 2i
   *
   *    math.ceil([3.2, 3.8, -4.7])  // returns Array [4, 4, -4]
   *
   * See also:
   *
   *    floor, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ var ceil = typed("ceil", {
        number: function number(x) {
            if ((0, $5wlxr.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return (0, $cqeCl.ceilNumber)(x);
        },
        Complex: function Complex(x) {
            return x.ceil();
        },
        BigNumber: function BigNumber(x) {
            if ((0, $9zoJy.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return x.ceil();
        },
        Fraction: function Fraction(x) {
            return x.ceil();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $fbkGg.deepMap)(x, ceil, true);
        }
    });
    return ceil;
});

});
parcelRegister("9zoJy", function(module, exports) {

$parcel$export(module.exports, "nearlyEqual", function () { return $6f7a918d34216687$export$6f3989c6ecc04081; });
/**
 * Compares two BigNumbers.
 * @param {BigNumber} x       First value to compare
 * @param {BigNumber} y       Second value to compare
 * @param {number} [epsilon]  The maximum relative difference between x and y
 *                            If epsilon is undefined or null, the function will
 *                            test whether x and y are exactly equal.
 * @return {boolean} whether the two numbers are nearly equal
 */ function $6f7a918d34216687$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x.eq(y);
     // use "==" operator, handles infinities
    if (x.eq(y)) return true;
     // NaN
    if (x.isNaN() || y.isNaN()) return false;
     // at this point x and y should be finite
    if (x.isFinite() && y.isFinite()) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = x.minus(y).abs();
        if (diff.isZero()) return true;
        else {
            // use relative error
            var max = x.constructor.max(x.abs(), y.abs());
            return diff.lte(max.times(epsilon));
        }
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}

});


parcelRegister("jy0bV", function(module, exports) {

$parcel$export(module.exports, "createClone", function () { return $e3b1574840d5986b$export$39ad70de4044028a; });

var $glBd7 = parcelRequire("glBd7");

var $jKx4O = parcelRequire("jKx4O");
var $e3b1574840d5986b$var$name = "clone";
var $e3b1574840d5986b$var$dependencies = [
    "typed"
];
var $e3b1574840d5986b$export$39ad70de4044028a = /* #__PURE__ */ (0, $jKx4O.factory)($e3b1574840d5986b$var$name, $e3b1574840d5986b$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Clone an object.
   *
   * Syntax:
   *
   *     math.clone(x)
   *
   * Examples:
   *
   *    math.clone(3.5)                   // returns number 3.5
   *    math.clone(math.complex('2-4i') // returns Complex 2 - 4i
   *    math.clone(math.unit(45, 'deg'))  // returns Unit 45 deg
   *    math.clone([[1, 2], [3, 4]])      // returns Array [[1, 2], [3, 4]]
   *    math.clone("hello world")         // returns string "hello world"
   *
   * @param {*} x   Object to be cloned
   * @return {*} A clone of object x
   */ return typed($e3b1574840d5986b$var$name, {
        any: (0, $glBd7.clone)
    });
});

});

parcelRegister("CQOYX", function(module, exports) {

$parcel$export(module.exports, "createCombinations", function () { return $074c85eef4ea10ea$export$63e3129a196da23d; });

var $jKx4O = parcelRequire("jKx4O");

var $doD8c = parcelRequire("doD8c");
var $074c85eef4ea10ea$var$name = "combinations";
var $074c85eef4ea10ea$var$dependencies = [
    "typed"
];
var $074c85eef4ea10ea$export$63e3129a196da23d = /* #__PURE__ */ (0, $jKx4O.factory)($074c85eef4ea10ea$var$name, $074c85eef4ea10ea$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities.
   *
   * Combinations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.combinations(n, k)
   *
   * Examples:
   *
   *    math.combinations(7, 5) // returns 21
   *
   * See also:
   *
   *    combinationsWithRep, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations.
   */ return typed($074c85eef4ea10ea$var$name, {
        "number, number": (0, $doD8c.combinationsNumber),
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var nMinusk = n.minus(k);
            var one = new BigNumber(1);
            if (!$074c85eef4ea10ea$var$isPositiveInteger(n) || !$074c85eef4ea10ea$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinations");
            if (k.gt(n)) throw new TypeError("k must be less than n in function combinations");
            result = one;
            if (k.lt(nMinusk)) for(i = one; i.lte(nMinusk); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusk.plus(i)).dividedBy(i);
            return result;
        } // TODO: implement support for collection in combinations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $074c85eef4ea10ea$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});
parcelRegister("doD8c", function(module, exports) {

$parcel$export(module.exports, "combinationsNumber", function () { return $9c0bdee362512e9f$export$2a122d28e37477a2; });

var $5wlxr = parcelRequire("5wlxr");

var $5qRPl = parcelRequire("5qRPl");
function $9c0bdee362512e9f$export$2a122d28e37477a2(n, k) {
    if (!(0, $5wlxr.isInteger)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (!(0, $5wlxr.isInteger)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (k > n) throw new TypeError("k must be less than or equal to n");
    var nMinusk = n - k;
    var prodrange;
    if (k < nMinusk) {
        prodrange = (0, $5qRPl.product)(nMinusk + 1, n);
        return prodrange / (0, $5qRPl.product)(1, k);
    }
    prodrange = (0, $5qRPl.product)(k + 1, n);
    return prodrange / (0, $5qRPl.product)(1, nMinusk);
}
$9c0bdee362512e9f$export$2a122d28e37477a2.signature = "number, number";

});
parcelRegister("5qRPl", function(module, exports) {

$parcel$export(module.exports, "product", function () { return $3f49226bcbae13fd$export$dbd0f18357df1ddd; });
/** @param {number} i
 *  @param {number} n
 *  @returns {number} product of i to n
 */ function $3f49226bcbae13fd$export$dbd0f18357df1ddd(i, n) {
    if (n < i) return 1;
    if (n === i) return n;
    var half = n + i >> 1; // divide (n + i) by 2 and truncate to integer
    return $3f49226bcbae13fd$export$dbd0f18357df1ddd(i, half) * $3f49226bcbae13fd$export$dbd0f18357df1ddd(half + 1, n);
}

});



parcelRegister("kHNQo", function(module, exports) {

$parcel$export(module.exports, "createCombinationsWithRep", function () { return $f12e7cc974459ebb$export$4bdc90311ec7c1dd; });

var $jKx4O = parcelRequire("jKx4O");

var $5wlxr = parcelRequire("5wlxr");

var $5qRPl = parcelRequire("5qRPl");
var $f12e7cc974459ebb$var$name = "combinationsWithRep";
var $f12e7cc974459ebb$var$dependencies = [
    "typed"
];
var $f12e7cc974459ebb$export$4bdc90311ec7c1dd = /* #__PURE__ */ (0, $jKx4O.factory)($f12e7cc974459ebb$var$name, $f12e7cc974459ebb$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities, allowing individual outcomes to be repeated more than once.
   *
   * CombinationsWithRep only takes integer arguments.
   * The following condition must be enforced: k <= n + k -1.
   *
   * Syntax:
   *
   *     math.combinationsWithRep(n, k)
   *
   * Examples:
   *
   *    math.combinationsWithRep(7, 5) // returns 462
   *
   * See also:
   *
   *    combinations, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations with replacement.
   */ return typed($f12e7cc974459ebb$var$name, {
        "number, number": function numberNumber(n, k) {
            if (!(0, $5wlxr.isInteger)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (!(0, $5wlxr.isInteger)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n < 1) throw new TypeError("k must be less than or equal to n + k - 1");
            if (k < n - 1) {
                var _prodrange = (0, $5qRPl.product)(n, n + k - 1);
                return _prodrange / (0, $5qRPl.product)(1, k);
            }
            var prodrange = (0, $5qRPl.product)(k + 1, n + k - 1);
            return prodrange / (0, $5qRPl.product)(1, n - 1);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var one = new BigNumber(1);
            var nMinusOne = n.minus(one);
            if (!$f12e7cc974459ebb$var$isPositiveInteger(n) || !$f12e7cc974459ebb$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n.lt(one)) throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
            result = one;
            if (k.lt(nMinusOne)) for(i = one; i.lte(nMinusOne); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusOne.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $f12e7cc974459ebb$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});

parcelRegister("eKGzs", function(module, exports) {

$parcel$export(module.exports, "createCompare", function () { return $abd662458402df9a$export$a6e723c0e3b918d4; });

var $9zoJy = parcelRequire("9zoJy");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");

var $e6fFw = parcelRequire("e6fFw");

var $272zs = parcelRequire("272zs");

var $5ntii = parcelRequire("5ntii");

var $kJFHo = parcelRequire("kJFHo");

var $5Sg22 = parcelRequire("5Sg22");
var $abd662458402df9a$var$name = "compare";
var $abd662458402df9a$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "equalScalar",
    "BigNumber",
    "Fraction",
    "DenseMatrix"
];
var $abd662458402df9a$export$a6e723c0e3b918d4 = /* #__PURE__ */ (0, $jKx4O.factory)($abd662458402df9a$var$name, $abd662458402df9a$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, equalScalar = _ref.equalScalar, matrix = _ref.matrix, BigNumber = _ref.BigNumber, Fraction = _ref.Fraction, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $5Sg22.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * x and y are considered equal when the relative difference between x and y
   * is smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.compare(x, y)
   *
   * Examples:
   *
   *    math.compare(6, 1)           // returns 1
   *    math.compare(2, 3)           // returns -1
   *    math.compare(7, 7)           // returns 0
   *    math.compare('10', '2')      // returns 1
   *    math.compare('1000', '1e3')  // returns 0
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compare(a, b)           // returns 1
   *
   *    math.compare(2, [1, 2, 3])   // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
   *
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} y Second value to compare
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the result of the comparison:
   *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
   */ var compare = typed($abd662458402df9a$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y ? 0 : x > y ? 1 : -1;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $5wlxr.nearlyEqual)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (0, $9zoJy.nearlyEqual)(x, y, config.epsilon) ? new BigNumber(0) : new BigNumber(x.cmp(y));
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return new Fraction(x.compare(y));
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return compare(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, compare);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, compare, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, compare, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, compare);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return compare(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return compare(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return compare(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, compare, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, compare, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, compare, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, compare, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, compare, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, compare, true).valueOf();
        }
    });
    return compare;
});
var $abd662458402df9a$export$e744cf3e2e3d6926 = /* #__PURE__ */ (0, $jKx4O.factory)($abd662458402df9a$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($abd662458402df9a$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $5wlxr.nearlyEqual)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        }
    });
});

});
parcelRegister("5Sg22", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm05", function () { return $446e6e7f87000d02$export$f80c3080566d43b4; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $446e6e7f87000d02$var$name = "algorithm05";
var $446e6e7f87000d02$var$dependencies = [
    "typed",
    "equalScalar"
];
var $446e6e7f87000d02$export$f80c3080566d43b4 = /* #__PURE__ */ (0, $jKx4O.factory)($446e6e7f87000d02$var$name, $446e6e7f87000d02$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm05(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var xa = cvalues ? [] : undefined;
        var xb = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values A(:,j)
            for(k = aptr[j], k1 = aptr[j + 1]; k < k1; k++){
                // row
                i = aindex[k]; // push index
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop values B(:,j)
            for(k = bptr[j], k1 = bptr[j + 1]; k < k1; k++){
                // row
                i = bindex[k]; // check row existed in A
                if (wa[i] !== mark) // push index
                cindex.push(i);
                 // update workspace
                wb[i] = mark; // check we need to process values
                if (xb) xb[i] = bvalues[k];
            } // check we need to process values (non pattern matrix)
            if (cvalues) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // marks
                    var wai = wa[i];
                    var wbi = wb[i]; // check Aij or Bij are nonzero
                    if (wai === mark || wbi === mark) {
                        // matrix values @ i,j
                        var va = wai === mark ? xa[i] : zero;
                        var vb = wbi === mark ? xb[i] : zero; // Cij
                        var vc = cf(va, vb); // check for zero
                        if (!eq(vc, zero)) {
                            // push value
                            cvalues.push(vc); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    }
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("6cjKe", function(module, exports) {

$parcel$export(module.exports, "createCompareNatural", function () { return $48332df25be6fae1$export$ac9dd39e43534605; });

var $69Qws = parcelRequire("69Qws");

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $48332df25be6fae1$var$name = "compareNatural";
var $48332df25be6fae1$var$dependencies = [
    "typed",
    "compare"
];
var $48332df25be6fae1$export$ac9dd39e43534605 = /* #__PURE__ */ (0, $jKx4O.factory)($48332df25be6fae1$var$name, $48332df25be6fae1$var$dependencies, function(_ref) {
    var typed = _ref.typed, compare = _ref.compare;
    var compareBooleans = compare.signatures["boolean,boolean"];
    /**
   * Compare two values of any type in a deterministic, natural way.
   *
   * For numeric values, the function works the same as `math.compare`.
   * For types of values that can't be compared mathematically,
   * the function compares in a natural way.
   *
   * For numeric values, x and y are considered equal when the relative
   * difference between x and y is smaller than the configured epsilon.
   * The function cannot be used to compare values smaller than
   * approximately 2.22e-16.
   *
   * For Complex numbers, first the real parts are compared. If equal,
   * the imaginary parts are compared.
   *
   * Strings are compared with a natural sorting algorithm, which
   * orders strings in a "logic" way following some heuristics.
   * This differs from the function `compare`, which converts the string
   * into a numeric value and compares that. The function `compareText`
   * on the other hand compares text lexically.
   *
   * Arrays and Matrices are compared value by value until there is an
   * unequal pair of values encountered. Objects are compared by sorted
   * keys until the keys or their values are unequal.
   *
   * Syntax:
   *
   *    math.compareNatural(x, y)
   *
   * Examples:
   *
   *    math.compareNatural(6, 1)              // returns 1
   *    math.compareNatural(2, 3)              // returns -1
   *    math.compareNatural(7, 7)              // returns 0
   *
   *    math.compareNatural('10', '2')         // returns 1
   *    math.compareText('10', '2')            // returns -1
   *    math.compare('10', '2')                // returns 1
   *
   *    math.compareNatural('Answer: 10', 'Answer: 2') // returns 1
   *    math.compareText('Answer: 10', 'Answer: 2')    // returns -1
   *    math.compare('Answer: 10', 'Answer: 2')
   *        // Error: Cannot convert "Answer: 10" to a number
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compareNatural(a, b)              // returns 1
   *
   *    const c = math.complex('2 + 3i')
   *    const d = math.complex('2 + 4i')
   *    math.compareNatural(c, d)              // returns -1
   *
   *    math.compareNatural([1, 2, 4], [1, 2, 3]) // returns 1
   *    math.compareNatural([1, 2, 3], [1, 2])    // returns 1
   *    math.compareNatural([1, 5], [1, 2, 3])    // returns 1
   *    math.compareNatural([1, 2], [1, 2])       // returns 0
   *
   *    math.compareNatural({a: 2}, {a: 4})       // returns -1
   *
   * See also:
   *
   *    compare, compareText
   *
   * @param  {*} x First value to compare
   * @param  {*} y Second value to compare
   * @return {number} Returns the result of the comparison:
   *                  1 when x > y, -1 when x < y, and 0 when x == y.
   */ var compareNatural = typed($48332df25be6fae1$var$name, {
        "any, any": function anyAny(x, y) {
            var typeX = (0, $7E0JQ.typeOf)(x);
            var typeY = (0, $7E0JQ.typeOf)(y);
            var c; // numeric types
            if ((typeX === "number" || typeX === "BigNumber" || typeX === "Fraction") && (typeY === "number" || typeY === "BigNumber" || typeY === "Fraction")) {
                c = compare(x, y);
                if (c.toString() !== "0") // c can be number, BigNumber, or Fraction
                return c > 0 ? 1 : -1; // return a number
                else return (0, (/*@__PURE__*/$parcel$interopDefault($69Qws)))(typeX, typeY);
            } // matrix types
            if (typeX === "Array" || typeX === "Matrix" || typeY === "Array" || typeY === "Matrix") {
                c = compareMatricesAndArrays(x, y);
                if (c !== 0) return c;
                else return (0, (/*@__PURE__*/$parcel$interopDefault($69Qws)))(typeX, typeY);
            } // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
            if (typeX !== typeY) return (0, (/*@__PURE__*/$parcel$interopDefault($69Qws)))(typeX, typeY);
            if (typeX === "Complex") return $48332df25be6fae1$var$compareComplexNumbers(x, y);
            if (typeX === "Unit") {
                if (x.equalBase(y)) return compareNatural(x.value, y.value);
                 // compare by units
                return compareArrays(x.formatUnits(), y.formatUnits());
            }
            if (typeX === "boolean") return compareBooleans(x, y);
            if (typeX === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($69Qws)))(x, y);
            if (typeX === "Object") return compareObjects(x, y);
            if (typeX === "null") return 0;
            if (typeX === "undefined") return 0;
             // this should not occur...
            throw new TypeError('Unsupported type of value "' + typeX + '"');
        }
    });
    /**
   * Compare mixed matrix/array types, by converting to same-shaped array.
   * This comparator is non-deterministic regarding input types.
   * @param {Array | SparseMatrix | DenseMatrix | *} x
   * @param {Array | SparseMatrix | DenseMatrix | *} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareMatricesAndArrays(x, y) {
        if ((0, $7E0JQ.isSparseMatrix)(x) && (0, $7E0JQ.isSparseMatrix)(y)) return compareArrays(x.toJSON().values, y.toJSON().values);
        if ((0, $7E0JQ.isSparseMatrix)(x)) // note: convert to array is expensive
        return compareMatricesAndArrays(x.toArray(), y);
        if ((0, $7E0JQ.isSparseMatrix)(y)) // note: convert to array is expensive
        return compareMatricesAndArrays(x, y.toArray());
         // convert DenseArray into Array
        if ((0, $7E0JQ.isDenseMatrix)(x)) return compareMatricesAndArrays(x.toJSON().data, y);
        if ((0, $7E0JQ.isDenseMatrix)(y)) return compareMatricesAndArrays(x, y.toJSON().data);
         // convert scalars to array
        if (!Array.isArray(x)) return compareMatricesAndArrays([
            x
        ], y);
        if (!Array.isArray(y)) return compareMatricesAndArrays(x, [
            y
        ]);
        return compareArrays(x, y);
    }
    /**
   * Compare two Arrays
   *
   * - First, compares value by value
   * - Next, if all corresponding values are equal,
   *   look at the length: longest array will be considered largest
   *
   * @param {Array} x
   * @param {Array} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareArrays(x, y) {
        // compare each value
        for(var i = 0, ii = Math.min(x.length, y.length); i < ii; i++){
            var v = compareNatural(x[i], y[i]);
            if (v !== 0) return v;
        } // compare the size of the arrays
        if (x.length > y.length) return 1;
        if (x.length < y.length) return -1;
         // both Arrays have equal size and content
        return 0;
    }
    /**
   * Compare two objects
   *
   * - First, compare sorted property names
   * - Next, compare the property values
   *
   * @param {Object} x
   * @param {Object} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareObjects(x, y) {
        var keysX = Object.keys(x);
        var keysY = Object.keys(y); // compare keys
        keysX.sort((0, (/*@__PURE__*/$parcel$interopDefault($69Qws))));
        keysY.sort((0, (/*@__PURE__*/$parcel$interopDefault($69Qws))));
        var c = compareArrays(keysX, keysY);
        if (c !== 0) return c;
         // compare values
        for(var i = 0; i < keysX.length; i++){
            var v = compareNatural(x[keysX[i]], y[keysY[i]]);
            if (v !== 0) return v;
        }
        return 0;
    }
    return compareNatural;
});
/**
 * Compare two complex numbers, `x` and `y`:
 *
 * - First, compare the real values of `x` and `y`
 * - If equal, compare the imaginary values of `x` and `y`
 *
 * @params {Complex} x
 * @params {Complex} y
 * @returns {number} Returns the comparison result: -1, 0, or 1
 */ function $48332df25be6fae1$var$compareComplexNumbers(x, y) {
    if (x.re > y.re) return 1;
    if (x.re < y.re) return -1;
    if (x.im > y.im) return 1;
    if (x.im < y.im) return -1;
    return 0;
}

});
parcelRegister("69Qws", function(module, exports) {
/*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 */ /*jshint unused:false */ module.exports = function naturalSort(a, b) {
    "use strict";
    var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, i = function(s) {
        return naturalSort.insensitive && ("" + s).toLowerCase() || "" + s;
    }, // convert all to strings strip whitespace
    x = i(a).replace(sre, "") || "", y = i(b).replace(sre, "") || "", // chunk/tokenize
    xN = x.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), yN = y.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), // numeric, hex or date detection
    xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x), yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null, oFxNcL, oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD) {
        if (xD < yD) return -1;
        else if (xD > yD) return 1;
    }
    // natural sorting through split numeric strings and default strings
    for(var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++){
        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
        oFxNcL = !(xN[cLoc] || "").match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
        oFyNcL = !(yN[cLoc] || "").match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
        // handle numeric vs string comparison - number < string - (Kyle Adams)
        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return isNaN(oFxNcL) ? 1 : -1;
        else if (typeof oFxNcL !== typeof oFyNcL) {
            oFxNcL += "";
            oFyNcL += "";
        }
        if (oFxNcL < oFyNcL) return -1;
        if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
};

});


parcelRegister("g8Ozy", function(module, exports) {

$parcel$export(module.exports, "createCompareText", function () { return $bc049f57887f5eb5$export$3e578d0534ab5935; });

var $7HWRb = parcelRequire("7HWRb");

var $jKx4O = parcelRequire("jKx4O");

var $5ntii = parcelRequire("5ntii");

var $kJFHo = parcelRequire("kJFHo");
var $bc049f57887f5eb5$var$name = "compareText";
var $bc049f57887f5eb5$var$dependencies = [
    "typed",
    "matrix"
];
var $bc049f57887f5eb5$export$3e578d0534ab5935 = /* #__PURE__ */ (0, $jKx4O.factory)($bc049f57887f5eb5$var$name, $bc049f57887f5eb5$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Compare two strings lexically. Comparison is case sensitive.
   * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.compareText(x, y)
   *
   * Examples:
   *
   *    math.compareText('B', 'A')     // returns 1
   *    math.compareText('2', '10')    // returns 1
   *    math.compare('2', '10')        // returns -1
   *    math.compareNatural('2', '10') // returns -1
   *
   *    math.compareText('B', ['A', 'B', 'C']) // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, equalText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns the result of the comparison:
   *                                        1 when x > y, -1 when x < y, and 0 when x == y.
   */ var compareText = typed($bc049f57887f5eb5$var$name, {
        "any, any": (0, $7HWRb.compareText),
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, (0, $7HWRb.compareText));
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return compareText(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return compareText(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return compareText(x, matrix(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, (0, $7HWRb.compareText), false);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, (0, $7HWRb.compareText), true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, (0, $7HWRb.compareText), false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, (0, $7HWRb.compareText), true).valueOf();
        }
    });
    return compareText;
});
var $bc049f57887f5eb5$export$1d0ea0d151dafd85 = /* #__PURE__ */ (0, $jKx4O.factory)($bc049f57887f5eb5$var$name, [
    "typed"
], function(_ref2) {
    var typed = _ref2.typed;
    return typed($bc049f57887f5eb5$var$name, {
        "any, any": (0, $7HWRb.compareText)
    });
});

});

parcelRegister("6CTYU", function(module, exports) {

$parcel$export(module.exports, "createComplex", function () { return $4d31b770f50e9431$export$82a905fb6826da0d; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $4d31b770f50e9431$var$name = "complex";
var $4d31b770f50e9431$var$dependencies = [
    "typed",
    "Complex"
];
var $4d31b770f50e9431$export$82a905fb6826da0d = /* #__PURE__ */ (0, $jKx4O.factory)($4d31b770f50e9431$var$name, $4d31b770f50e9431$var$dependencies, function(_ref) {
    var typed = _ref.typed, Complex = _ref.Complex;
    /**
   * Create a complex value or convert a value to a complex value.
   *
   * Syntax:
   *
   *     math.complex()                           // creates a complex value with zero
   *                                              // as real and imaginary part.
   *     math.complex(re : number, im : string)   // creates a complex value with provided
   *                                              // values for real and imaginary part.
   *     math.complex(re : number)                // creates a complex value with provided
   *                                              // real value and zero imaginary part.
   *     math.complex(complex : Complex)          // clones the provided complex value.
   *     math.complex(arg : string)               // parses a string into a complex value.
   *     math.complex(array : Array)              // converts the elements of the array
   *                                              // or matrix element wise into a
   *                                              // complex value.
   *     math.complex({re: number, im: number})   // creates a complex value with provided
   *                                              // values for real an imaginary part.
   *     math.complex({r: number, phi: number})   // creates a complex value with provided
   *                                              // polar coordinates
   *
   * Examples:
   *
   *    const a = math.complex(3, -4)     // a = Complex 3 - 4i
   *    a.re = 5                          // a = Complex 5 - 4i
   *    const i = a.im                    // Number -4
   *    const b = math.complex('2 + 6i')  // Complex 2 + 6i
   *    const c = math.complex()          // Complex 0 + 0i
   *    const d = math.add(a, b)          // Complex 5 + 2i
   *
   * See also:
   *
   *    bignumber, boolean, index, matrix, number, string, unit
   *
   * @param {* | Array | Matrix} [args]
   *            Arguments specifying the real and imaginary part of the complex number
   * @return {Complex | Array | Matrix} Returns a complex value
   */ var complex = typed("complex", {
        "": function _() {
            return Complex.ZERO;
        },
        number: function number(x) {
            return new Complex(x, 0);
        },
        "number, number": function numberNumber(re, im) {
            return new Complex(re, im);
        },
        // TODO: this signature should be redundant
        "BigNumber, BigNumber": function BigNumberBigNumber(re, im) {
            return new Complex(re.toNumber(), im.toNumber());
        },
        Fraction: function Fraction(x) {
            return new Complex(x.valueOf(), 0);
        },
        Complex: function Complex(x) {
            return x.clone();
        },
        string: function string(x) {
            return Complex(x); // for example '2 + 3i'
        },
        "null": function _null(x) {
            return Complex(0);
        },
        Object: function Object(x) {
            if ("re" in x && "im" in x) return new Complex(x.re, x.im);
            if ("r" in x && "phi" in x || "abs" in x && "arg" in x) return new Complex(x);
            throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, complex);
        }
    });
    return complex;
});

});

parcelRegister("8RH82", function(module, exports) {

$parcel$export(module.exports, "createComplexClass", function () { return $6744ba6bb3d0a50c$export$24a4be44fc8b6392; });

var $85rOd = parcelRequire("85rOd");

var $5wlxr = parcelRequire("5wlxr");

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
function $6744ba6bb3d0a50c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6744ba6bb3d0a50c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6744ba6bb3d0a50c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6744ba6bb3d0a50c$var$_typeof(obj);
}
var $6744ba6bb3d0a50c$var$name = "Complex";
var $6744ba6bb3d0a50c$var$dependencies = [];
var $6744ba6bb3d0a50c$export$24a4be44fc8b6392 = /* #__PURE__ */ (0, $jKx4O.factory)($6744ba6bb3d0a50c$var$name, $6744ba6bb3d0a50c$var$dependencies, function() {
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).prototype.type = "Complex";
    (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).prototype.isComplex = true;
    /**
   * Get a JSON representation of the complex number
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).prototype.toJSON = function() {
        return {
            mathjs: "Complex",
            re: this.re,
            im: this.im
        };
    };
    /*
   * Return the value of the complex number in polar notation
   * The angle phi will be set in the interval of [-pi, pi].
   * @return {{r: number, phi: number}} Returns and object with properties r and phi.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).prototype.toPolar = function() {
        return {
            r: this.abs(),
            phi: this.arg()
        };
    };
    /**
   * Get a string representation of the complex number,
   * with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string} str
   */ (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).prototype.format = function(options) {
        var str = "";
        var im = this.im;
        var re = this.re;
        var strRe = (0, $5wlxr.format)(this.re, options);
        var strIm = (0, $5wlxr.format)(this.im, options); // round either re or im when smaller than the configured precision
        var precision = (0, $7E0JQ.isNumber)(options) ? options : options ? options.precision : null;
        if (precision !== null) {
            var epsilon = Math.pow(10, -precision);
            if (Math.abs(re / im) < epsilon) re = 0;
            if (Math.abs(im / re) < epsilon) im = 0;
        }
        if (im === 0) // real value
        str = strRe;
        else if (re === 0) {
            // purely complex value
            if (im === 1) str = "i";
            else if (im === -1) str = "-i";
            else str = strIm + "i";
        } else {
            // complex value
            if (im < 0) {
                if (im === -1) str = strRe + " - i";
                else str = strRe + " - " + strIm.substring(1) + "i";
            } else if (im === 1) str = strRe + " + i";
            else str = strRe + " + " + strIm + "i";
        }
        return str;
    };
    /**
   * Create a complex number from polar coordinates
   *
   * Usage:
   *
   *     Complex.fromPolar(r: number, phi: number) : Complex
   *     Complex.fromPolar({r: number, phi: number}) : Complex
   *
   * @param {*} args...
   * @return {Complex}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).fromPolar = function(args) {
        switch(arguments.length){
            case 1:
                var arg = arguments[0];
                if ($6744ba6bb3d0a50c$var$_typeof(arg) === "object") return (0, (/*@__PURE__*/$parcel$interopDefault($85rOd)))(arg);
                else throw new TypeError("Input has to be an object with r and phi keys.");
            case 2:
                var r = arguments[0];
                var phi = arguments[1];
                if ((0, $7E0JQ.isNumber)(r)) {
                    if ((0, $7E0JQ.isUnit)(phi) && phi.hasBase("ANGLE")) // convert unit to a number in radians
                    phi = phi.toNumber("rad");
                    if ((0, $7E0JQ.isNumber)(phi)) return new (0, (/*@__PURE__*/$parcel$interopDefault($85rOd)))({
                        r: r,
                        phi: phi
                    });
                    throw new TypeError("Phi is not a number nor an angle unit.");
                } else throw new TypeError("Radius r is not a number.");
            default:
                throw new SyntaxError("Wrong number of arguments in function fromPolar");
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).prototype.valueOf = (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).prototype.toString;
    /**
   * Create a Complex number from a JSON object
   * @param {Object} json  A JSON Object structured as
   *                       {"mathjs": "Complex", "re": 2, "im": 3}
   *                       All properties are optional, default values
   *                       for `re` and `im` are 0.
   * @return {Complex} Returns a new Complex number
   */ (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($85rOd)))(json);
    };
    /**
   * Compare two complex numbers, `a` and `b`:
   *
   * - Returns 1 when the real part of `a` is larger than the real part of `b`
   * - Returns -1 when the real part of `a` is smaller than the real part of `b`
   * - Returns 1 when the real parts are equal
   *   and the imaginary part of `a` is larger than the imaginary part of `b`
   * - Returns -1 when the real parts are equal
   *   and the imaginary part of `a` is smaller than the imaginary part of `b`
   * - Returns 0 when both real and imaginary parts are equal.
   *
   * @params {Complex} a
   * @params {Complex} b
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ (0, (/*@__PURE__*/$parcel$interopDefault($85rOd))).compare = function(a, b) {
        if (a.re > b.re) return 1;
        if (a.re < b.re) return -1;
        if (a.im > b.im) return 1;
        if (a.im < b.im) return -1;
        return 0;
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($85rOd));
}, {
    isClass: true
});

});
parcelRegister("85rOd", function(module, exports) {
/**
 * @license Complex.js v2.1.1 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class allows the manipulation of complex numbers.
 * You can pass a complex number in different formats. Either as object, double, string or two integer parameters.
 *
 * Object form
 * { re: <real>, im: <imaginary> }
 * { arg: <angle>, abs: <radius> }
 * { phi: <angle>, r: <radius> }
 *
 * Array / Vector form
 * [ real, imaginary ]
 *
 * Double form
 * 99.3 - Single double value
 *
 * String form
 * '23.1337' - Simple real number
 * '15+3i' - a simple complex number
 * '3-i' - a simple complex number
 *
 * Example:
 *
 * var c = new Complex('99.3+8i');
 * c.mul({r: 3, i: 9}).div(4.9).sub(3, 2);
 *
 */ (function(root) {
    "use strict";
    var cosh = Math.cosh || function(x) {
        return Math.abs(x) < 1e-9 ? 1 - x : (Math.exp(x) + Math.exp(-x)) * 0.5;
    };
    var sinh = Math.sinh || function(x) {
        return Math.abs(x) < 1e-9 ? x : (Math.exp(x) - Math.exp(-x)) * 0.5;
    };
    /**
   * Calculates cos(x) - 1 using Taylor series if x is small (-¼π ≤ x ≤ ¼π).
   *
   * @param {number} x
   * @returns {number} cos(x) - 1
   */ var cosm1 = function(x) {
        var b = Math.PI / 4;
        if (-b > x || x > b) return Math.cos(x) - 1.0;
        /* Calculate horner form of polynomial of taylor series in Q
    var fac = 1, alt = 1, pol = {};
    for (var i = 0; i <= 16; i++) {
      fac*= i || 1;
      if (i % 2 == 0) {
        pol[i] = new Fraction(1, alt * fac);
        alt = -alt;
      }
    }
    console.log(new Polynomial(pol).toHorner()); // (((((((1/20922789888000x^2-1/87178291200)x^2+1/479001600)x^2-1/3628800)x^2+1/40320)x^2-1/720)x^2+1/24)x^2-1/2)x^2+1
    */ var xx = x * x;
        return xx * (xx * (xx * (xx * (xx * (xx * (xx * (xx / 20922789888000 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 0.5);
    };
    var hypot = function(x, y) {
        var a = Math.abs(x);
        var b = Math.abs(y);
        if (a < 3000 && b < 3000) return Math.sqrt(a * a + b * b);
        if (a < b) {
            a = b;
            b = x / y;
        } else b = y / x;
        return a * Math.sqrt(1 + b * b);
    };
    var parser_exit = function() {
        throw SyntaxError("Invalid Param");
    };
    /**
   * Calculates log(sqrt(a^2+b^2)) in a way to avoid overflows
   *
   * @param {number} a
   * @param {number} b
   * @returns {number}
   */ function logHypot(a, b) {
        var _a = Math.abs(a);
        var _b = Math.abs(b);
        if (a === 0) return Math.log(_b);
        if (b === 0) return Math.log(_a);
        if (_a < 3000 && _b < 3000) return Math.log(a * a + b * b) * 0.5;
        /* I got 4 ideas to compute this property without overflow:
     *
     * Testing 1000000 times with random samples for a,b ∈ [1, 1000000000] against a big decimal library to get an error estimate
     *
     * 1. Only eliminate the square root: (OVERALL ERROR: 3.9122483030951116e-11)

     Math.log(a * a + b * b) / 2

     *
     *
     * 2. Try to use the non-overflowing pythagoras: (OVERALL ERROR: 8.889760039210159e-10)

     var fn = function(a, b) {
     a = Math.abs(a);
     b = Math.abs(b);
     var t = Math.min(a, b);
     a = Math.max(a, b);
     t = t / a;

     return Math.log(a) + Math.log(1 + t * t) / 2;
     };

     * 3. Abuse the identity cos(atan(y/x) = x / sqrt(x^2+y^2): (OVERALL ERROR: 3.4780178737037204e-10)

     Math.log(a / Math.cos(Math.atan2(b, a)))

     * 4. Use 3. and apply log rules: (OVERALL ERROR: 1.2014087502620896e-9)

     Math.log(a) - Math.log(Math.cos(Math.atan2(b, a)))

     */ a = a / 2;
        b = b / 2;
        return 0.5 * Math.log(a * a + b * b) + Math.LN2;
    }
    var parse = function(a, b) {
        var z = {
            "re": 0,
            "im": 0
        };
        if (a === undefined || a === null) z["re"] = z["im"] = 0;
        else if (b !== undefined) {
            z["re"] = a;
            z["im"] = b;
        } else switch(typeof a){
            case "object":
                if ("im" in a && "re" in a) {
                    z["re"] = a["re"];
                    z["im"] = a["im"];
                } else if ("abs" in a && "arg" in a) {
                    if (!Number.isFinite(a["abs"]) && Number.isFinite(a["arg"])) return Complex["INFINITY"];
                    z["re"] = a["abs"] * Math.cos(a["arg"]);
                    z["im"] = a["abs"] * Math.sin(a["arg"]);
                } else if ("r" in a && "phi" in a) {
                    if (!Number.isFinite(a["r"]) && Number.isFinite(a["phi"])) return Complex["INFINITY"];
                    z["re"] = a["r"] * Math.cos(a["phi"]);
                    z["im"] = a["r"] * Math.sin(a["phi"]);
                } else if (a.length === 2) {
                    z["re"] = a[0];
                    z["im"] = a[1];
                } else parser_exit();
                break;
            case "string":
                z["im"] = /* void */ z["re"] = 0;
                var tokens = a.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
                var plus = 1;
                var minus = 0;
                if (tokens === null) parser_exit();
                for(var i = 0; i < tokens.length; i++){
                    var c = tokens[i];
                    if (c === " " || c === "	" || c === "\n") ;
                    else if (c === "+") plus++;
                    else if (c === "-") minus++;
                    else if (c === "i" || c === "I") {
                        if (plus + minus === 0) parser_exit();
                        if (tokens[i + 1] !== " " && !isNaN(tokens[i + 1])) {
                            z["im"] += parseFloat((minus % 2 ? "-" : "") + tokens[i + 1]);
                            i++;
                        } else z["im"] += parseFloat((minus % 2 ? "-" : "") + "1");
                        plus = minus = 0;
                    } else {
                        if (plus + minus === 0 || isNaN(c)) parser_exit();
                        if (tokens[i + 1] === "i" || tokens[i + 1] === "I") {
                            z["im"] += parseFloat((minus % 2 ? "-" : "") + c);
                            i++;
                        } else z["re"] += parseFloat((minus % 2 ? "-" : "") + c);
                        plus = minus = 0;
                    }
                }
                // Still something on the stack
                if (plus + minus > 0) parser_exit();
                break;
            case "number":
                z["im"] = 0;
                z["re"] = a;
                break;
            default:
                parser_exit();
        }
        isNaN(z["re"]) || isNaN(z["im"]);
        return z;
    };
    /**
   * @constructor
   * @returns {Complex}
   */ function Complex(a, b) {
        if (!(this instanceof Complex)) return new Complex(a, b);
        var z = parse(a, b);
        this["re"] = z["re"];
        this["im"] = z["im"];
    }
    Complex.prototype = {
        "re": 0,
        "im": 0,
        /**
     * Calculates the sign of a complex number, which is a normalized complex
     *
     * @returns {Complex}
     */ "sign": function() {
            var abs = this["abs"]();
            return new Complex(this["re"] / abs, this["im"] / abs);
        },
        /**
     * Adds two complex numbers
     *
     * @returns {Complex}
     */ "add": function(a, b) {
            var z = new Complex(a, b);
            // Infinity + Infinity = NaN
            if (this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity + z = Infinity { where z != Infinity }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            return new Complex(this["re"] + z["re"], this["im"] + z["im"]);
        },
        /**
     * Subtracts two complex numbers
     *
     * @returns {Complex}
     */ "sub": function(a, b) {
            var z = new Complex(a, b);
            // Infinity - Infinity = NaN
            if (this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity - z = Infinity { where z != Infinity }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            return new Complex(this["re"] - z["re"], this["im"] - z["im"]);
        },
        /**
     * Multiplies two complex numbers
     *
     * @returns {Complex}
     */ "mul": function(a, b) {
            var z = new Complex(a, b);
            // Infinity * 0 = NaN
            if (this["isInfinite"]() && z["isZero"]() || this["isZero"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity * z = Infinity { where z != 0 }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            // Short circuit for real values
            if (z["im"] === 0 && this["im"] === 0) return new Complex(this["re"] * z["re"], 0);
            return new Complex(this["re"] * z["re"] - this["im"] * z["im"], this["re"] * z["im"] + this["im"] * z["re"]);
        },
        /**
     * Divides two complex numbers
     *
     * @returns {Complex}
     */ "div": function(a, b) {
            var z = new Complex(a, b);
            // 0 / 0 = NaN and Infinity / Infinity = NaN
            if (this["isZero"]() && z["isZero"]() || this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity / 0 = Infinity
            if (this["isInfinite"]() || z["isZero"]()) return Complex["INFINITY"];
            // 0 / Infinity = 0
            if (this["isZero"]() || z["isInfinite"]()) return Complex["ZERO"];
            a = this["re"];
            b = this["im"];
            var c = z["re"];
            var d = z["im"];
            var t, x;
            if (0 === d) // Divisor is real
            return new Complex(a / c, b / c);
            if (Math.abs(c) < Math.abs(d)) {
                x = c / d;
                t = c * x + d;
                return new Complex((a * x + b) / t, (b * x - a) / t);
            } else {
                x = d / c;
                t = d * x + c;
                return new Complex((a + b * x) / t, (b - a * x) / t);
            }
        },
        /**
     * Calculate the power of two complex numbers
     *
     * @returns {Complex}
     */ "pow": function(a, b) {
            var z = new Complex(a, b);
            a = this["re"];
            b = this["im"];
            if (z["isZero"]()) return Complex["ONE"];
            // If the exponent is real
            if (z["im"] === 0) {
                if (b === 0 && a > 0) return new Complex(Math.pow(a, z["re"]), 0);
                else if (a === 0) switch((z["re"] % 4 + 4) % 4){
                    case 0:
                        return new Complex(Math.pow(b, z["re"]), 0);
                    case 1:
                        return new Complex(0, Math.pow(b, z["re"]));
                    case 2:
                        return new Complex(-Math.pow(b, z["re"]), 0);
                    case 3:
                        return new Complex(0, -Math.pow(b, z["re"]));
                }
            }
            /* I couldn't find a good formula, so here is a derivation and optimization
       *
       * z_1^z_2 = (a + bi)^(c + di)
       *         = exp((c + di) * log(a + bi)
       *         = pow(a^2 + b^2, (c + di) / 2) * exp(i(c + di)atan2(b, a))
       * =>...
       * Re = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * cos(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
       * Im = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * sin(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
       *
       * =>...
       * Re = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * cos(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
       * Im = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * sin(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
       *
       * =>
       * Re = exp(c * logsq2 - d * arg(z_1)) * cos(d * logsq2 + c * arg(z_1))
       * Im = exp(c * logsq2 - d * arg(z_1)) * sin(d * logsq2 + c * arg(z_1))
       *
       */ if (a === 0 && b === 0 && z["re"] > 0 && z["im"] >= 0) return Complex["ZERO"];
            var arg = Math.atan2(b, a);
            var loh = logHypot(a, b);
            a = Math.exp(z["re"] * loh - z["im"] * arg);
            b = z["im"] * loh + z["re"] * arg;
            return new Complex(a * Math.cos(b), a * Math.sin(b));
        },
        /**
     * Calculate the complex square root
     *
     * @returns {Complex}
     */ "sqrt": function() {
            var a = this["re"];
            var b = this["im"];
            var r = this["abs"]();
            var re, im;
            if (a >= 0) {
                if (b === 0) return new Complex(Math.sqrt(a), 0);
                re = 0.5 * Math.sqrt(2.0 * (r + a));
            } else re = Math.abs(b) / Math.sqrt(2 * (r - a));
            if (a <= 0) im = 0.5 * Math.sqrt(2.0 * (r - a));
            else im = Math.abs(b) / Math.sqrt(2 * (r + a));
            return new Complex(re, b < 0 ? -im : im);
        },
        /**
     * Calculate the complex exponent
     *
     * @returns {Complex}
     */ "exp": function() {
            var tmp = Math.exp(this["re"]);
            this["im"];
            return new Complex(tmp * Math.cos(this["im"]), tmp * Math.sin(this["im"]));
        },
        /**
     * Calculate the complex exponent and subtracts one.
     *
     * This may be more accurate than `Complex(x).exp().sub(1)` if
     * `x` is small.
     *
     * @returns {Complex}
     */ "expm1": function() {
            /**
       * exp(a + i*b) - 1
       = exp(a) * (cos(b) + j*sin(b)) - 1
       = expm1(a)*cos(b) + cosm1(b) + j*exp(a)*sin(b)
       */ var a = this["re"];
            var b = this["im"];
            return new Complex(Math.expm1(a) * Math.cos(b) + cosm1(b), Math.exp(a) * Math.sin(b));
        },
        /**
     * Calculate the natural log
     *
     * @returns {Complex}
     */ "log": function() {
            var a = this["re"];
            var b = this["im"];
            b === 0 && a;
            return new Complex(logHypot(a, b), Math.atan2(b, a));
        },
        /**
     * Calculate the magnitude of the complex number
     *
     * @returns {number}
     */ "abs": function() {
            return hypot(this["re"], this["im"]);
        },
        /**
     * Calculate the angle of the complex number
     *
     * @returns {number}
     */ "arg": function() {
            return Math.atan2(this["im"], this["re"]);
        },
        /**
     * Calculate the sine of the complex number
     *
     * @returns {Complex}
     */ "sin": function() {
            // sin(z) = ( e^iz - e^-iz ) / 2i 
            //        = sin(a)cosh(b) + i cos(a)sinh(b)
            var a = this["re"];
            var b = this["im"];
            return new Complex(Math.sin(a) * cosh(b), Math.cos(a) * sinh(b));
        },
        /**
     * Calculate the cosine
     *
     * @returns {Complex}
     */ "cos": function() {
            // cos(z) = ( e^iz + e^-iz ) / 2 
            //        = cos(a)cosh(b) - i sin(a)sinh(b)
            var a = this["re"];
            var b = this["im"];
            return new Complex(Math.cos(a) * cosh(b), -Math.sin(a) * sinh(b));
        },
        /**
     * Calculate the tangent
     *
     * @returns {Complex}
     */ "tan": function() {
            // tan(z) = sin(z) / cos(z) 
            //        = ( e^iz - e^-iz ) / ( i( e^iz + e^-iz ) )
            //        = ( e^2iz - 1 ) / i( e^2iz + 1 )
            //        = ( sin(2a) + i sinh(2b) ) / ( cos(2a) + cosh(2b) )
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = Math.cos(a) + cosh(b);
            return new Complex(Math.sin(a) / d, sinh(b) / d);
        },
        /**
     * Calculate the cotangent
     *
     * @returns {Complex}
     */ "cot": function() {
            // cot(c) = i(e^(ci) + e^(-ci)) / (e^(ci) - e^(-ci))
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = Math.cos(a) - cosh(b);
            return new Complex(-Math.sin(a) / d, sinh(b) / d);
        },
        /**
     * Calculate the secant
     *
     * @returns {Complex}
     */ "sec": function() {
            // sec(c) = 2 / (e^(ci) + e^(-ci))
            var a = this["re"];
            var b = this["im"];
            var d = 0.5 * cosh(2 * b) + 0.5 * Math.cos(2 * a);
            return new Complex(Math.cos(a) * cosh(b) / d, Math.sin(a) * sinh(b) / d);
        },
        /**
     * Calculate the cosecans
     *
     * @returns {Complex}
     */ "csc": function() {
            // csc(c) = 2i / (e^(ci) - e^(-ci))
            var a = this["re"];
            var b = this["im"];
            var d = 0.5 * cosh(2 * b) - 0.5 * Math.cos(2 * a);
            return new Complex(Math.sin(a) * cosh(b) / d, -Math.cos(a) * sinh(b) / d);
        },
        /**
     * Calculate the complex arcus sinus
     *
     * @returns {Complex}
     */ "asin": function() {
            // asin(c) = -i * log(ci + sqrt(1 - c^2))
            var a = this["re"];
            var b = this["im"];
            var t1 = new Complex(b * b - a * a + 1, -2 * a * b)["sqrt"]();
            var t2 = new Complex(t1["re"] - b, t1["im"] + a)["log"]();
            return new Complex(t2["im"], -t2["re"]);
        },
        /**
     * Calculate the complex arcus cosinus
     *
     * @returns {Complex}
     */ "acos": function() {
            // acos(c) = i * log(c - i * sqrt(1 - c^2))
            var a = this["re"];
            var b = this["im"];
            var t1 = new Complex(b * b - a * a + 1, -2 * a * b)["sqrt"]();
            var t2 = new Complex(t1["re"] - b, t1["im"] + a)["log"]();
            return new Complex(Math.PI / 2 - t2["im"], t2["re"]);
        },
        /**
     * Calculate the complex arcus tangent
     *
     * @returns {Complex}
     */ "atan": function() {
            // atan(c) = i / 2 log((i + x) / (i - x))
            var a = this["re"];
            var b = this["im"];
            if (a === 0) {
                if (b === 1) return new Complex(0, Infinity);
                if (b === -1) return new Complex(0, -Infinity);
            }
            var d = a * a + (1.0 - b) * (1.0 - b);
            var t1 = new Complex((1 - b * b - a * a) / d, -2 * a / d).log();
            return new Complex(-0.5 * t1["im"], 0.5 * t1["re"]);
        },
        /**
     * Calculate the complex arcus cotangent
     *
     * @returns {Complex}
     */ "acot": function() {
            // acot(c) = i / 2 log((c - i) / (c + i))
            var a = this["re"];
            var b = this["im"];
            if (b === 0) return new Complex(Math.atan2(1, a), 0);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).atan() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atan();
        },
        /**
     * Calculate the complex arcus secant
     *
     * @returns {Complex}
     */ "asec": function() {
            // asec(c) = -i * log(1 / c + sqrt(1 - i / c^2))
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(0, Infinity);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).acos() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acos();
        },
        /**
     * Calculate the complex arcus cosecans
     *
     * @returns {Complex}
     */ "acsc": function() {
            // acsc(c) = -i * log(i / c + sqrt(1 - 1 / c^2))
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(Math.PI / 2, Infinity);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).asin() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asin();
        },
        /**
     * Calculate the complex sinh
     *
     * @returns {Complex}
     */ "sinh": function() {
            // sinh(c) = (e^c - e^-c) / 2
            var a = this["re"];
            var b = this["im"];
            return new Complex(sinh(a) * Math.cos(b), cosh(a) * Math.sin(b));
        },
        /**
     * Calculate the complex cosh
     *
     * @returns {Complex}
     */ "cosh": function() {
            // cosh(c) = (e^c + e^-c) / 2
            var a = this["re"];
            var b = this["im"];
            return new Complex(cosh(a) * Math.cos(b), sinh(a) * Math.sin(b));
        },
        /**
     * Calculate the complex tanh
     *
     * @returns {Complex}
     */ "tanh": function() {
            // tanh(c) = (e^c - e^-c) / (e^c + e^-c)
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = cosh(a) + Math.cos(b);
            return new Complex(sinh(a) / d, Math.sin(b) / d);
        },
        /**
     * Calculate the complex coth
     *
     * @returns {Complex}
     */ "coth": function() {
            // coth(c) = (e^c + e^-c) / (e^c - e^-c)
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = cosh(a) - Math.cos(b);
            return new Complex(sinh(a) / d, -Math.sin(b) / d);
        },
        /**
     * Calculate the complex coth
     *
     * @returns {Complex}
     */ "csch": function() {
            // csch(c) = 2 / (e^c - e^-c)
            var a = this["re"];
            var b = this["im"];
            var d = Math.cos(2 * b) - cosh(2 * a);
            return new Complex(-2 * sinh(a) * Math.cos(b) / d, 2 * cosh(a) * Math.sin(b) / d);
        },
        /**
     * Calculate the complex sech
     *
     * @returns {Complex}
     */ "sech": function() {
            // sech(c) = 2 / (e^c + e^-c)
            var a = this["re"];
            var b = this["im"];
            var d = Math.cos(2 * b) + cosh(2 * a);
            return new Complex(2 * cosh(a) * Math.cos(b) / d, -2 * sinh(a) * Math.sin(b) / d);
        },
        /**
     * Calculate the complex asinh
     *
     * @returns {Complex}
     */ "asinh": function() {
            // asinh(c) = log(c + sqrt(c^2 + 1))
            var tmp = this["im"];
            this["im"] = -this["re"];
            this["re"] = tmp;
            var res = this["asin"]();
            this["re"] = -this["im"];
            this["im"] = tmp;
            tmp = res["re"];
            res["re"] = -res["im"];
            res["im"] = tmp;
            return res;
        },
        /**
     * Calculate the complex acosh
     *
     * @returns {Complex}
     */ "acosh": function() {
            // acosh(c) = log(c + sqrt(c^2 - 1))
            var res = this["acos"]();
            if (res["im"] <= 0) {
                var tmp = res["re"];
                res["re"] = -res["im"];
                res["im"] = tmp;
            } else {
                var tmp = res["im"];
                res["im"] = -res["re"];
                res["re"] = tmp;
            }
            return res;
        },
        /**
     * Calculate the complex atanh
     *
     * @returns {Complex}
     */ "atanh": function() {
            // atanh(c) = log((1+c) / (1-c)) / 2
            var a = this["re"];
            var b = this["im"];
            var noIM = a > 1 && b === 0;
            var oneMinus = 1 - a;
            var onePlus = 1 + a;
            var d = oneMinus * oneMinus + b * b;
            var x = d !== 0 ? new Complex((onePlus * oneMinus - b * b) / d, (b * oneMinus + onePlus * b) / d) : new Complex(a !== -1 ? a / 0 : 0, b !== 0 ? b / 0 : 0);
            var temp = x["re"];
            x["re"] = logHypot(x["re"], x["im"]) / 2;
            x["im"] = Math.atan2(x["im"], temp) / 2;
            if (noIM) x["im"] = -x["im"];
            return x;
        },
        /**
     * Calculate the complex acoth
     *
     * @returns {Complex}
     */ "acoth": function() {
            // acoth(c) = log((c+1) / (c-1)) / 2
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(0, Math.PI / 2);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).atanh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atanh();
        },
        /**
     * Calculate the complex acsch
     *
     * @returns {Complex}
     */ "acsch": function() {
            // acsch(c) = log((1+sqrt(1+c^2))/c)
            var a = this["re"];
            var b = this["im"];
            if (b === 0) return new Complex(a !== 0 ? Math.log(a + Math.sqrt(a * a + 1)) : Infinity, 0);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).asinh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asinh();
        },
        /**
     * Calculate the complex asech
     *
     * @returns {Complex}
     */ "asech": function() {
            // asech(c) = log((1+sqrt(1-c^2))/c)
            var a = this["re"];
            var b = this["im"];
            if (this["isZero"]()) return Complex["INFINITY"];
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).acosh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acosh();
        },
        /**
     * Calculate the complex inverse 1/z
     *
     * @returns {Complex}
     */ "inverse": function() {
            // 1 / 0 = Infinity and 1 / Infinity = 0
            if (this["isZero"]()) return Complex["INFINITY"];
            if (this["isInfinite"]()) return Complex["ZERO"];
            var a = this["re"];
            var b = this["im"];
            var d = a * a + b * b;
            return new Complex(a / d, -b / d);
        },
        /**
     * Returns the complex conjugate
     *
     * @returns {Complex}
     */ "conjugate": function() {
            return new Complex(this["re"], -this["im"]);
        },
        /**
     * Gets the negated complex number
     *
     * @returns {Complex}
     */ "neg": function() {
            return new Complex(-this["re"], -this["im"]);
        },
        /**
     * Ceils the actual complex number
     *
     * @returns {Complex}
     */ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.ceil(this["re"] * places) / places, Math.ceil(this["im"] * places) / places);
        },
        /**
     * Floors the actual complex number
     *
     * @returns {Complex}
     */ "floor": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.floor(this["re"] * places) / places, Math.floor(this["im"] * places) / places);
        },
        /**
     * Ceils the actual complex number
     *
     * @returns {Complex}
     */ "round": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.round(this["re"] * places) / places, Math.round(this["im"] * places) / places);
        },
        /**
     * Compares two complex numbers
     *
     * **Note:** new Complex(Infinity).equals(Infinity) === false
     *
     * @returns {boolean}
     */ "equals": function(a, b) {
            var z = new Complex(a, b);
            return Math.abs(z["re"] - this["re"]) <= Complex["EPSILON"] && Math.abs(z["im"] - this["im"]) <= Complex["EPSILON"];
        },
        /**
     * Clones the actual object
     *
     * @returns {Complex}
     */ "clone": function() {
            return new Complex(this["re"], this["im"]);
        },
        /**
     * Gets a string of the actual complex number
     *
     * @returns {string}
     */ "toString": function() {
            var a = this["re"];
            var b = this["im"];
            var ret = "";
            if (this["isNaN"]()) return "NaN";
            if (this["isInfinite"]()) return "Infinity";
            if (Math.abs(a) < Complex["EPSILON"]) a = 0;
            if (Math.abs(b) < Complex["EPSILON"]) b = 0;
            // If is real number
            if (b === 0) return ret + a;
            if (a !== 0) {
                ret += a;
                ret += " ";
                if (b < 0) {
                    b = -b;
                    ret += "-";
                } else ret += "+";
                ret += " ";
            } else if (b < 0) {
                b = -b;
                ret += "-";
            }
            if (1 !== b) ret += b;
            return ret + "i";
        },
        /**
     * Returns the actual number as a vector
     *
     * @returns {Array}
     */ "toVector": function() {
            return [
                this["re"],
                this["im"]
            ];
        },
        /**
     * Returns the actual real value of the current object
     *
     * @returns {number|null}
     */ "valueOf": function() {
            if (this["im"] === 0) return this["re"];
            return null;
        },
        /**
     * Determines whether a complex number is not on the Riemann sphere.
     *
     * @returns {boolean}
     */ "isNaN": function() {
            return isNaN(this["re"]) || isNaN(this["im"]);
        },
        /**
     * Determines whether or not a complex number is at the zero pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isZero": function() {
            return this["im"] === 0 && this["re"] === 0;
        },
        /**
     * Determines whether a complex number is not at the infinity pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isFinite": function() {
            return isFinite(this["re"]) && isFinite(this["im"]);
        },
        /**
     * Determines whether or not a complex number is at the infinity pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isInfinite": function() {
            return !(this["isNaN"]() || this["isFinite"]());
        }
    };
    Complex["ZERO"] = new Complex(0, 0);
    Complex["ONE"] = new Complex(1, 0);
    Complex["I"] = new Complex(0, 1);
    Complex["PI"] = new Complex(Math.PI, 0);
    Complex["E"] = new Complex(Math.E, 0);
    Complex["INFINITY"] = new Complex(Infinity, Infinity);
    Complex["NAN"] = new Complex(NaN, NaN);
    Complex["EPSILON"] = 1e-15;
    if (typeof define === "function" && define["amd"]) define([], function() {
        return Complex;
    });
    else {
        Object.defineProperty(Complex, "__esModule", {
            "value": true
        });
        Complex["default"] = Complex;
        Complex["Complex"] = Complex;
        module.exports = Complex;
    }
})(module.exports);

});


parcelRegister("keVNG", function(module, exports) {

$parcel$export(module.exports, "createComposition", function () { return $ebc1f35f4bba494d$export$1ddf9cbadd17315f; });

var $jKx4O = parcelRequire("jKx4O");
var $ebc1f35f4bba494d$var$name = "composition";
var $ebc1f35f4bba494d$var$dependencies = [
    "typed",
    "addScalar",
    "combinations",
    "isNegative",
    "isPositive",
    "isInteger",
    "larger"
];
var $ebc1f35f4bba494d$export$1ddf9cbadd17315f = /* #__PURE__ */ (0, $jKx4O.factory)($ebc1f35f4bba494d$var$name, $ebc1f35f4bba494d$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, combinations = _ref.combinations, isPositive = _ref.isPositive, isNegative = _ref.isNegative, isInteger = _ref.isInteger, larger = _ref.larger;
    /**
   * The composition counts of n into k parts.
   *
   * composition only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *   math.composition(n, k)
   *
   * Examples:
   *
   *    math.composition(5, 3) // returns 6
   *
   * See also:
   *
   *    combinations
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
   */ return typed($ebc1f35f4bba494d$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) throw new TypeError("Positive integer value expected in function composition");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function composition");
            return combinations(addScalar(n, -1), addScalar(k, -1));
        }
    });
});

});

parcelRegister("7s1xS", function(module, exports) {

$parcel$export(module.exports, "createConj", function () { return $56cc58cc782e60f6$export$af5efe8ad97f01a2; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $56cc58cc782e60f6$var$name = "conj";
var $56cc58cc782e60f6$var$dependencies = [
    "typed"
];
var $56cc58cc782e60f6$export$af5efe8ad97f01a2 = /* #__PURE__ */ (0, $jKx4O.factory)($56cc58cc782e60f6$var$name, $56cc58cc782e60f6$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the complex conjugate of a complex value.
   * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.conj(x)
   *
   * Examples:
   *
   *    math.conj(math.complex('2 + 3i'))  // returns Complex 2 - 3i
   *    math.conj(math.complex('2 - 3i'))  // returns Complex 2 + 3i
   *    math.conj(math.complex('-5.2i'))  // returns Complex 5.2i
   *
   * See also:
   *
   *    re, im, arg, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            The complex conjugate of x
   */ var conj = typed($56cc58cc782e60f6$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.conjugate();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, conj);
        }
    });
    return conj;
});

});

parcelRegister("2tBcA", function(module, exports) {

$parcel$export(module.exports, "createCos", function () { return $1cdb25c3e967f9a0$export$923b60dfa791c630; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $1cdb25c3e967f9a0$var$name = "cos";
var $1cdb25c3e967f9a0$var$dependencies = [
    "typed"
];
var $1cdb25c3e967f9a0$export$923b60dfa791c630 = /* #__PURE__ */ (0, $jKx4O.factory)($1cdb25c3e967f9a0$var$name, $1cdb25c3e967f9a0$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cos(x)
   *
   * Examples:
   *
   *    math.cos(2)                      // returns number -0.4161468365471422
   *    math.cos(math.pi / 4)            // returns number  0.7071067811865475
   *    math.cos(math.unit(180, 'deg'))  // returns number -1
   *    math.cos(math.unit(60, 'deg'))   // returns number  0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Cosine of x
   */ var cos = typed($1cdb25c3e967f9a0$var$name, {
        number: Math.cos,
        Complex: function Complex(x) {
            return x.cos();
        },
        BigNumber: function BigNumber(x) {
            return x.cos();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cos is no angle");
            return cos(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, cos);
        }
    });
    return cos;
});

});

parcelRegister("1iyEB", function(module, exports) {

$parcel$export(module.exports, "createCosh", function () { return $0f225a6bd83467a7$export$63d35097da636c02; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");
var $0f225a6bd83467a7$var$name = "cosh";
var $0f225a6bd83467a7$var$dependencies = [
    "typed"
];
var $0f225a6bd83467a7$export$63d35097da636c02 = /* #__PURE__ */ (0, $jKx4O.factory)($0f225a6bd83467a7$var$name, $0f225a6bd83467a7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the hyperbolic cosine of a value,
   * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cosh(x)
   *
   * Examples:
   *
   *    math.cosh(0.5)       // returns number 1.1276259652063807
   *
   * See also:
   *
   *    sinh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic cosine of x
   */ var cosh = typed($0f225a6bd83467a7$var$name, {
        number: (0, $5wlxr.cosh),
        Complex: function Complex(x) {
            return x.cosh();
        },
        BigNumber: function BigNumber(x) {
            return x.cosh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cosh is no angle");
            return cosh(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, cosh);
        }
    });
    return cosh;
});

});

parcelRegister("8Wa10", function(module, exports) {

$parcel$export(module.exports, "createCot", function () { return $681b824d9282cafc$export$c5598f542ea1565c; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $681b824d9282cafc$var$name = "cot";
var $681b824d9282cafc$var$dependencies = [
    "typed",
    "BigNumber"
];
var $681b824d9282cafc$export$c5598f542ea1565c = /* #__PURE__ */ (0, $jKx4O.factory)($681b824d9282cafc$var$name, $681b824d9282cafc$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cot(x)
   *
   * Examples:
   *
   *    math.cot(2)      // returns number -0.45765755436028577
   *    1 / math.tan(2)  // returns number -0.45765755436028577
   *
   * See also:
   *
   *    tan, sec, csc
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cotangent of x
   */ var cot = typed($681b824d9282cafc$var$name, {
        number: (0, $7HpLG.cotNumber),
        Complex: function Complex(x) {
            return x.cot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tan());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
            return cot(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, cot);
        }
    });
    return cot;
});

});

parcelRegister("fepA5", function(module, exports) {

$parcel$export(module.exports, "createCoth", function () { return $b16c01a8fe597630$export$3f7f9b5400315e6a; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $b16c01a8fe597630$var$name = "coth";
var $b16c01a8fe597630$var$dependencies = [
    "typed",
    "BigNumber"
];
var $b16c01a8fe597630$export$3f7f9b5400315e6a = /* #__PURE__ */ (0, $jKx4O.factory)($b16c01a8fe597630$var$name, $b16c01a8fe597630$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic cotangent of a value,
   * defined as `coth(x) = 1 / tanh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.coth(x)
   *
   * Examples:
   *
   *    // coth(x) = 1 / tanh(x)
   *    math.coth(2)         // returns 1.0373147207275482
   *    1 / math.tanh(2)     // returns 1.0373147207275482
   *
   * See also:
   *
   *    sinh, tanh, cosh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cotangent of x
   */ var coth = typed($b16c01a8fe597630$var$name, {
        number: (0, $7HpLG.cothNumber),
        Complex: function Complex(x) {
            return x.coth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tanh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function coth is no angle");
            return coth(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, coth);
        }
    });
    return coth;
});

});

parcelRegister("iLwpS", function(module, exports) {

$parcel$export(module.exports, "createCreateUnit", function () { return $da95c30500ca0557$export$27641941eb5cadbb; });

var $jKx4O = parcelRequire("jKx4O");
var $da95c30500ca0557$var$name = "createUnit";
var $da95c30500ca0557$var$dependencies = [
    "typed",
    "Unit"
];
var $da95c30500ca0557$export$27641941eb5cadbb = /* #__PURE__ */ (0, $jKx4O.factory)($da95c30500ca0557$var$name, $da95c30500ca0557$var$dependencies, function(_ref) {
    var typed = _ref.typed, Unit = _ref.Unit;
    /**
   * Create a user-defined unit and register it with the Unit type.
   *
   * Syntax:
   *
   *     math.createUnit({
   *       baseUnit1: {
   *         aliases: [string, ...]
   *         prefixes: object
   *       },
   *       unit2: {
   *         definition: string,
   *         aliases: [string, ...]
   *         prefixes: object,
   *         offset: number
   *       },
   *       unit3: string    // Shortcut
   *     })
   *
   *     // Another shortcut:
   *     math.createUnit(string, unit : string, [object])
   *
   * Examples:
   *
   *     math.createUnit('foo')
   *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']})
   *     math.createUnit('mph', '1 mile/hour')
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
   * @param {Object} options   (optional) An object containing any of the following properties:
   *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
   *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
   *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
   *
   * See also:
   *
   *     unit
   *
   * @return {Unit} The new unit
   */ return typed($da95c30500ca0557$var$name, {
        // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
        "Object, Object": function ObjectObject(obj, options) {
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        Object: function Object(obj) {
            return Unit.createUnit(obj, {});
        },
        // Shortcut method for creating one unit.
        "string, Unit | string | Object, Object": function stringUnitStringObjectObject(name, def, options) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        "string, Unit | string | Object": function stringUnitStringObject(name, def) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, {});
        },
        // Without a definition, creates a base unit.
        string: function string(name) {
            var obj = {};
            obj[name] = {};
            return Unit.createUnit(obj, {});
        }
    });
});

});

parcelRegister("29Y0b", function(module, exports) {

$parcel$export(module.exports, "createCross", function () { return $192af7270dc2b1f9$export$bc2585c0ed744c0e; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $192af7270dc2b1f9$var$name = "cross";
var $192af7270dc2b1f9$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply"
];
var $192af7270dc2b1f9$export$bc2585c0ed744c0e = /* #__PURE__ */ (0, $jKx4O.factory)($192af7270dc2b1f9$var$name, $192af7270dc2b1f9$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, subtract = _ref.subtract, multiply = _ref.multiply;
    /**
   * Calculate the cross product for two vectors in three dimensional space.
   * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
   * as:
   *
   *    cross(A, B) = [
   *      a2 * b3 - a3 * b2,
   *      a3 * b1 - a1 * b3,
   *      a1 * b2 - a2 * b1
   *    ]
   *
   * If one of the input vectors has a dimension greater than 1, the output
   * vector will be a 1x3 (2-dimensional) matrix.
   *
   * Syntax:
   *
   *    math.cross(x, y)
   *
   * Examples:
   *
   *    math.cross([1, 1, 0],   [0, 1, 1])       // Returns [1, -1, 1]
   *    math.cross([3, -3, 1],  [4, 9, 2])       // Returns [-15, -2, 39]
   *    math.cross([2, 3, 4],   [5, 6, 7])       // Returns [-3, 6, -3]
   *    math.cross([[1, 2, 3]], [[4], [5], [6]]) // Returns [[-3, 6, -3]]
   *
   * See also:
   *
   *    dot, multiply
   *
   * @param  {Array | Matrix} x   First vector
   * @param  {Array | Matrix} y   Second vector
   * @return {Array | Matrix}     Returns the cross product of `x` and `y`
   */ return typed($192af7270dc2b1f9$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_cross(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_cross(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_cross(x, y.toArray()));
        },
        "Array, Array": _cross
    });
    /**
   * Calculate the cross product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {Array} Returns the cross product of x and y
   * @private
   */ function _cross(x, y) {
        var highestDimension = Math.max((0, $YkZ7e.arraySize)(x).length, (0, $YkZ7e.arraySize)(y).length);
        x = (0, $YkZ7e.squeeze)(x);
        y = (0, $YkZ7e.squeeze)(y);
        var xSize = (0, $YkZ7e.arraySize)(x);
        var ySize = (0, $YkZ7e.arraySize)(y);
        if (xSize.length !== 1 || ySize.length !== 1 || xSize[0] !== 3 || ySize[0] !== 3) throw new RangeError("Vectors with length 3 expected (Size A = [" + xSize.join(", ") + "], B = [" + ySize.join(", ") + "])");
        var product = [
            subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
            subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
            subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
        ];
        if (highestDimension > 1) return [
            product
        ];
        else return product;
    }
});

});

parcelRegister("jxqC0", function(module, exports) {

$parcel$export(module.exports, "createCsc", function () { return $e395bdfaa4d1b1e0$export$a0beb298aa7a2962; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $e395bdfaa4d1b1e0$var$name = "csc";
var $e395bdfaa4d1b1e0$var$dependencies = [
    "typed",
    "BigNumber"
];
var $e395bdfaa4d1b1e0$export$a0beb298aa7a2962 = /* #__PURE__ */ (0, $jKx4O.factory)($e395bdfaa4d1b1e0$var$name, $e395bdfaa4d1b1e0$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csc(x)
   *
   * Examples:
   *
   *    math.csc(2)      // returns number 1.099750170294617
   *    1 / math.sin(2)  // returns number 1.099750170294617
   *
   * See also:
   *
   *    sin, sec, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cosecant of x
   */ var csc = typed($e395bdfaa4d1b1e0$var$name, {
        number: (0, $7HpLG.cscNumber),
        Complex: function Complex(x) {
            return x.csc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sin());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csc is no angle");
            return csc(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, csc);
        }
    });
    return csc;
});

});

parcelRegister("gu3Af", function(module, exports) {

$parcel$export(module.exports, "createCsch", function () { return $c0023a53e5deadc4$export$9160aa3a39425fc9; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $c0023a53e5deadc4$var$name = "csch";
var $c0023a53e5deadc4$var$dependencies = [
    "typed",
    "BigNumber"
];
var $c0023a53e5deadc4$export$9160aa3a39425fc9 = /* #__PURE__ */ (0, $jKx4O.factory)($c0023a53e5deadc4$var$name, $c0023a53e5deadc4$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic cosecant of a value,
   * defined as `csch(x) = 1 / sinh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csch(x)
   *
   * Examples:
   *
   *    // csch(x) = 1/ sinh(x)
   *    math.csch(0.5)       // returns 1.9190347513349437
   *    1 / math.sinh(0.5)   // returns 1.9190347513349437
   *
   * See also:
   *
   *    sinh, sech, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cosecant of x
   */ var csch = typed($c0023a53e5deadc4$var$name, {
        number: (0, $7HpLG.cschNumber),
        Complex: function Complex(x) {
            return x.csch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sinh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csch is no angle");
            return csch(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, csch);
        }
    });
    return csch;
});

});

parcelRegister("bADSR", function(module, exports) {

$parcel$export(module.exports, "createCtranspose", function () { return $8701fe9866a9f72f$export$5d07146b3894f212; });

var $jKx4O = parcelRequire("jKx4O");
var $8701fe9866a9f72f$var$name = "ctranspose";
var $8701fe9866a9f72f$var$dependencies = [
    "typed",
    "transpose",
    "conj"
];
var $8701fe9866a9f72f$export$5d07146b3894f212 = /* #__PURE__ */ (0, $jKx4O.factory)($8701fe9866a9f72f$var$name, $8701fe9866a9f72f$var$dependencies, function(_ref) {
    var typed = _ref.typed, transpose = _ref.transpose, conj = _ref.conj;
    /**
   * Transpose and complex conjugate a matrix. All values of the matrix are
   * reflected over its main diagonal and then the complex conjugate is
   * taken. This is equivalent to complex conjugation for scalars and
   * vectors.
   *
   * Syntax:
   *
   *     math.ctranspose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, math.complex(6,7)]]
   *     math.ctranspose(A)               // returns [[1, 4], [2, 5], [3, {re:6,im:7}]]
   *
   * See also:
   *
   *     transpose, diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be ctransposed
   * @return {Array | Matrix}   The ctransposed matrix
   */ return typed($8701fe9866a9f72f$var$name, {
        any: function any(x) {
            return conj(transpose(x));
        }
    });
});

});

parcelRegister("2RiNJ", function(module, exports) {

$parcel$export(module.exports, "createCube", function () { return $214f1d8506a580f7$export$ce223d612b94804b; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $214f1d8506a580f7$var$name = "cube";
var $214f1d8506a580f7$var$dependencies = [
    "typed"
];
var $214f1d8506a580f7$export$ce223d612b94804b = /* #__PURE__ */ (0, $jKx4O.factory)($214f1d8506a580f7$var$name, $214f1d8506a580f7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the cube of a value, `x * x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cube(x)
   *
   * Examples:
   *
   *    math.cube(2)            // returns number 8
   *    math.pow(2, 3)          // returns number 8
   *    math.cube(4)            // returns number 64
   *    4 * 4 * 4               // returns number 64
   *
   *    math.cube([1, 2, 3, 4]) // returns Array [1, 8, 27, 64]
   *
   * See also:
   *
   *    multiply, square, pow, cbrt
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x  Number for which to calculate the cube
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} Cube of x
   */ var cube = typed($214f1d8506a580f7$var$name, {
        number: (0, $cqeCl.cubeNumber),
        Complex: function Complex(x) {
            return x.mul(x).mul(x); // Is faster than pow(x, 3)
        },
        BigNumber: function BigNumber(x) {
            return x.times(x).times(x);
        },
        Fraction: function Fraction(x) {
            return x.pow(3); // Is faster than mul()mul()mul()
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since cube(0) = 0
            return (0, $fbkGg.deepMap)(x, cube, true);
        },
        Unit: function Unit(x) {
            return x.pow(3);
        }
    });
    return cube;
});

});

parcelRegister("8KcmA", function(module, exports) {

$parcel$export(module.exports, "createDeepEqual", function () { return $65dc35aeb4dfb038$export$b1b11fc839367b58; });

var $jKx4O = parcelRequire("jKx4O");
var $65dc35aeb4dfb038$var$name = "deepEqual";
var $65dc35aeb4dfb038$var$dependencies = [
    "typed",
    "equal"
];
var $65dc35aeb4dfb038$export$b1b11fc839367b58 = /* #__PURE__ */ (0, $jKx4O.factory)($65dc35aeb4dfb038$var$name, $65dc35aeb4dfb038$var$dependencies, function(_ref) {
    var typed = _ref.typed, equal = _ref.equal;
    /**
   * Test element wise whether two matrices are equal.
   * The function accepts both matrices and scalar values.
   *
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.deepEqual(x, y)
   *
   * Examples:
   *
   *    math.deepEqual(2, 4)   // returns false
   *
   *    a = [2, 5, 1]
   *    b = [2, 7, 1]
   *
   *    math.deepEqual(a, b)   // returns false
   *    math.equal(a, b)       // returns [true, false, true]
   *
   * See also:
   *
   *    equal, unequal
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns true when the input matrices have the same size and each of their elements is equal.
   */ return typed($65dc35aeb4dfb038$var$name, {
        "any, any": function anyAny(x, y) {
            return _deepEqual(x.valueOf(), y.valueOf());
        }
    });
    /**
   * Test whether two arrays have the same size and all elements are equal
   * @param {Array | *} x
   * @param {Array | *} y
   * @return {boolean} Returns true if both arrays are deep equal
   */ function _deepEqual(x, y) {
        if (Array.isArray(x)) {
            if (Array.isArray(y)) {
                var len = x.length;
                if (len !== y.length) return false;
                for(var i = 0; i < len; i++){
                    if (!_deepEqual(x[i], y[i])) return false;
                }
                return true;
            } else return false;
        } else {
            if (Array.isArray(y)) return false;
            else return equal(x, y);
        }
    }
});

});

parcelRegister("aEDHH", function(module, exports) {

$parcel$export(module.exports, "createDenseMatrixClass", function () { return $7c1c702339a48fd1$export$1a088ca8dd364cd1; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $7HWRb = parcelRequire("7HWRb");

var $5wlxr = parcelRequire("5wlxr");

var $glBd7 = parcelRequire("glBd7");

var $i7dcb = parcelRequire("i7dcb");

var $jKx4O = parcelRequire("jKx4O");
var $7c1c702339a48fd1$var$name = "DenseMatrix";
var $7c1c702339a48fd1$var$dependencies = [
    "Matrix"
];
var $7c1c702339a48fd1$export$1a088ca8dd364cd1 = /* #__PURE__ */ (0, $jKx4O.factory)($7c1c702339a48fd1$var$name, $7c1c702339a48fd1$var$dependencies, function(_ref) {
    var Matrix = _ref.Matrix;
    /**
   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
   * @class DenseMatrix
   */ function DenseMatrix(data, datatype) {
        if (!(this instanceof DenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $7E0JQ.isString)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $7E0JQ.isMatrix)(data)) {
            // check data is a DenseMatrix
            if (data.type === "DenseMatrix") {
                // clone data & size
                this._data = (0, $glBd7.clone)(data._data);
                this._size = (0, $glBd7.clone)(data._size);
                this._datatype = datatype || data._datatype;
            } else {
                // build data from existing matrix
                this._data = data.toArray();
                this._size = data.size();
                this._datatype = datatype || data._datatype;
            }
        } else if (data && (0, $7E0JQ.isArray)(data.data) && (0, $7E0JQ.isArray)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size; // verify the dimensions of the array
            (0, $YkZ7e.validate)(this._data, this._size);
            this._datatype = datatype || data.datatype;
        } else if ((0, $7E0JQ.isArray)(data)) {
            // replace nested Matrices with Arrays
            this._data = preprocess(data); // get the dimensions of the array
            this._size = (0, $YkZ7e.arraySize)(this._data); // verify the dimensions of the array, TODO: compute size while processing array
            (0, $YkZ7e.validate)(this._data, this._size); // data type unknown
            this._datatype = datatype;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $7E0JQ.typeOf)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
        }
    }
    DenseMatrix.prototype = new Matrix();
    /**
   * Create a new DenseMatrix
   */ DenseMatrix.prototype.createDenseMatrix = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ DenseMatrix.prototype.type = "DenseMatrix";
    DenseMatrix.prototype.isDenseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf DenseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ DenseMatrix.prototype.getDataType = function() {
        return (0, $YkZ7e.getArrayDataType)(this._data, (0, $7E0JQ.typeOf));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()  // retrieve storage format
   *
   * @memberof DenseMatrix
   * @return {string}           The storage format.
   */ DenseMatrix.prototype.storage = function() {
        return "dense";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()   // retrieve matrix datatype
   *
   * @memberof DenseMatrix
   * @return {string}           The datatype.
   */ DenseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new DenseMatrix
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ DenseMatrix.prototype.create = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof DenseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ DenseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        switch(arguments.length){
            case 1:
                return _get(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _set(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Get a single element from the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ DenseMatrix.prototype.get = function(index) {
        if (!(0, $7E0JQ.isArray)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $i7dcb.DimensionError)(index.length, this._size.length);
         // check index
        for(var x = 0; x < index.length; x++)(0, $YkZ7e.validateIndex)(index[x], this._size[x]);
        var data = this._data;
        for(var i = 0, ii = index.length; i < ii; i++){
            var indexI = index[i];
            (0, $YkZ7e.validateIndex)(indexI, data.length);
            data = data[indexI];
        }
        return data;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {DenseMatrix} self
   */ DenseMatrix.prototype.set = function(index, value, defaultValue) {
        if (!(0, $7E0JQ.isArray)(index)) throw new TypeError("Array expected");
        if (index.length < this._size.length) throw new (0, $i7dcb.DimensionError)(index.length, this._size.length, "<");
        var i, ii, indexI; // enlarge matrix when needed
        var size = index.map(function(i) {
            return i + 1;
        });
        _fit(this, size, defaultValue); // traverse over the dimensions
        var data = this._data;
        for(i = 0, ii = index.length - 1; i < ii; i++){
            indexI = index[i];
            (0, $YkZ7e.validateIndex)(indexI, data.length);
            data = data[indexI];
        } // set new value
        indexI = index[index.length - 1];
        (0, $YkZ7e.validateIndex)(indexI, data.length);
        data[indexI] = value;
        return this;
    };
    /**
   * Get a submatrix of this matrix
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index   Zero-based index
   * @private
   */ function _get(matrix, index) {
        if (!(0, $7E0JQ.isIndex)(index)) throw new TypeError("Invalid index");
        var isScalar = index.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(index.min());
        else {
            // validate dimensions
            var size = index.size();
            if (size.length !== matrix._size.length) throw new (0, $i7dcb.DimensionError)(size.length, matrix._size.length);
             // validate if any of the ranges in the index is out of range
            var min = index.min();
            var max = index.max();
            for(var i = 0, ii = matrix._size.length; i < ii; i++){
                (0, $YkZ7e.validateIndex)(min[i], matrix._size[i]);
                (0, $YkZ7e.validateIndex)(max[i], matrix._size[i]);
            } // retrieve submatrix
            // TODO: more efficient when creating an empty matrix and setting _data and _size manually
            return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
        }
    }
    /**
   * Recursively get a submatrix of a multi dimensional matrix.
   * Index is not checked for correct number or length of dimensions.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {number} dims   Total number of dimensions
   * @param {number} dim    Current dimension
   * @return {Array} submatrix
   * @private
   */ function _getSubmatrix(data, index, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) return range.map(function(i) {
            (0, $YkZ7e.validateIndex)(i, data.length);
            return data[i];
        }).valueOf();
        else return range.map(function(i) {
            (0, $YkZ7e.validateIndex)(i, data.length);
            var child = data[i];
            return _getSubmatrix(child, index, dims, dim + 1);
        }).valueOf();
    }
    /**
   * Replace a submatrix in this matrix
   * Indexes are zero-based.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index
   * @param {DenseMatrix | Array | *} submatrix
   * @param {*} defaultValue          Default value, filled in on new entries when
   *                                  the matrix is resized.
   * @return {DenseMatrix} matrix
   * @private
   */ function _set(matrix, index, submatrix, defaultValue) {
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $7E0JQ.isMatrix)(submatrix)) {
            sSize = submatrix.size();
            submatrix = submatrix.valueOf();
        } else sSize = (0, $YkZ7e.arraySize)(submatrix);
        if (isScalar) {
            // set a scalar
            // check whether submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // set a submatrix
            // validate dimensions
            if (iSize.length < matrix._size.length) throw new (0, $i7dcb.DimensionError)(iSize.length, matrix._size.length, "<");
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $YkZ7e.unsqueeze)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $glBd7.deepStrictEqual)(iSize, sSize)) throw new (0, $i7dcb.DimensionError)(iSize, sSize, ">");
             // enlarge matrix when needed
            var size = index.max().map(function(i) {
                return i + 1;
            });
            _fit(matrix, size, defaultValue); // insert the sub matrix
            var dims = iSize.length;
            var dim = 0;
            _setSubmatrix(matrix._data, index, submatrix, dims, dim);
        }
        return matrix;
    }
    /**
   * Replace a submatrix of a multi dimensional matrix.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {Array} submatrix
   * @param {number} dims   Total number of dimensions
   * @param {number} dim
   * @private
   */ function _setSubmatrix(data, index, submatrix, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) range.forEach(function(dataIndex, subIndex) {
            (0, $YkZ7e.validateIndex)(dataIndex);
            data[dataIndex] = submatrix[subIndex[0]];
        });
        else range.forEach(function(dataIndex, subIndex) {
            (0, $YkZ7e.validateIndex)(dataIndex);
            _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
        });
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ DenseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $7E0JQ.isArray)(size)) throw new TypeError("Array expected");
         // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, size, defaultValue);
    };
    function _resize(matrix, size, defaultValue) {
        // check size
        if (size.length === 0) {
            // first value in matrix
            var v = matrix._data; // go deep
            while((0, $7E0JQ.isArray)(v))v = v[0];
            return v;
        } // resize matrix
        matrix._size = size.slice(0); // copy the array
        matrix._data = (0, $YkZ7e.resize)(matrix._data, matrix._size, defaultValue); // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ DenseMatrix.prototype.reshape = function(size, copy) {
        var m = copy ? this.clone() : this;
        m._data = (0, $YkZ7e.reshape)(m._data, size);
        m._size = size.slice(0);
        return m;
    };
    /**
   * Enlarge the matrix when it is smaller than given size.
   * If the matrix is larger or equal sized, nothing is done.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix           The matrix to be resized
   * @param {number[]} size
   * @param {*} defaultValue          Default value, filled in on new entries.
   * @private
   */ function _fit(matrix, size, defaultValue) {
        var newSize = matrix._size.slice(0);
        var changed = false; // add dimensions when needed
        while(newSize.length < size.length){
            newSize.push(0);
            changed = true;
        } // enlarge size when needed
        for(var i = 0, ii = size.length; i < ii; i++)if (size[i] > newSize[i]) {
            newSize[i] = size[i];
            changed = true;
        }
        if (changed) // resize only when size is changed
        _resize(matrix, newSize, defaultValue);
    }
    /**
   * Create a clone of the matrix
   * @memberof DenseMatrix
   * @return {DenseMatrix} clone
   */ DenseMatrix.prototype.clone = function() {
        var m = new DenseMatrix({
            data: (0, $glBd7.clone)(this._data),
            size: (0, $glBd7.clone)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof DenseMatrix
   * @returns {number[]} size
   */ DenseMatrix.prototype.size = function() {
        return this._size.slice(0); // return a clone of _size
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   *
   * @return {DenseMatrix} matrix
   */ DenseMatrix.prototype.map = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $7E0JQ.isArray)(value)) return value.map(function(child, i) {
                return recurse(child, index.concat(i));
            });
            else return callback(value, index, me);
        }; // determine the new datatype when the original matrix has datatype defined
        // TODO: should be done in matrix constructor instead
        var data = recurse(this._data, []);
        var datatype = this._datatype !== undefined ? (0, $YkZ7e.getArrayDataType)(data, (0, $7E0JQ.typeOf)) : undefined;
        return new DenseMatrix(data, datatype);
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ DenseMatrix.prototype.forEach = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $7E0JQ.isArray)(value)) value.forEach(function(child, i) {
                recurse(child, index.concat(i));
            });
            else callback(value, index, me);
        };
        recurse(this._data, []);
    };
    /**
   * Create an Array with a copy of the data of the DenseMatrix
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.toArray = function() {
        return (0, $glBd7.clone)(this._data);
    };
    /**
   * Get the primitive value of the DenseMatrix: a multidimensional array
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.valueOf = function() {
        return this._data;
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof DenseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ DenseMatrix.prototype.format = function(options) {
        return (0, $7HWRb.format)(this._data, options);
    };
    /**
   * Get a string representation of the matrix
   * @memberof DenseMatrix
   * @returns {string} str
   */ DenseMatrix.prototype.toString = function() {
        return (0, $7HWRb.format)(this._data);
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof DenseMatrix
   * @returns {Object}
   */ DenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "DenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof DenseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix with the diagonal values.
   */ DenseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $7E0JQ.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $7E0JQ.isNumber)(k) || !(0, $5wlxr.isInteger)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // x is a matrix get diagonal from matrix
        var data = []; // loop rows
        for(var i = 0; i < n; i++)data[i] = this._data[i + kSub][i + kSuper];
         // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                n
            ],
            datatype: this._datatype
        });
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof DenseMatrix
   * @param {Array} size                     The matrix size.
   * @param {number | Matrix | Array } value The values for the diagonal.
   * @param {number | BigNumber} [k=0]       The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]          The default value for non-diagonal
   * @param {string} [datatype]              The datatype for the diagonal
   *
   * @returns {DenseMatrix}
   */ DenseMatrix.diagonal = function(size, value, k, defaultValue) {
        if (!(0, $7E0JQ.isArray)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $7E0JQ.isBigNumber)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $7E0JQ.isNumber)(s) || !(0, $5wlxr.isInteger)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $7E0JQ.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $7E0JQ.isNumber)(k) || !(0, $5wlxr.isInteger)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $7E0JQ.isArray)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $7E0JQ.isMatrix)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // discover default value if needed
        if (!defaultValue) // check first value in array
        defaultValue = (0, $7E0JQ.isBigNumber)(_value(0)) ? _value(0).mul(0) // trick to create a BigNumber with value zero
         : 0;
         // empty array
        var data = []; // check we need to resize array
        if (size.length > 0) {
            // resize array
            data = (0, $YkZ7e.resize)(data, size, defaultValue); // fill diagonal
            for(var d = 0; d < n; d++)data[d + kSub][d + kSuper] = _value(d);
        } // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof DenseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {DenseMatrix}
   */ DenseMatrix.fromJSON = function(json) {
        return new DenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof DenseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ DenseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $7E0JQ.isNumber)(i) || !(0, $5wlxr.isInteger)(i) || !(0, $7E0JQ.isNumber)(j) || !(0, $5wlxr.isInteger)(j)) throw new Error("Row index must be positive integers");
         // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
         // validate index
        (0, $YkZ7e.validateIndex)(i, this._size[0]);
        (0, $YkZ7e.validateIndex)(j, this._size[0]); // swap rows
        DenseMatrix._swapRows(i, j, this._data); // return current instance
        return this;
    };
    /**
   * Swap rows i and j in Dense Matrix data structure.
   *
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   * @param {Array} data     Matrix data
   */ DenseMatrix._swapRows = function(i, j, data) {
        // swap values i <-> j
        var vi = data[i];
        data[i] = data[j];
        data[j] = vi;
    };
    /**
   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
   * Matrices. Replaces all nested Matrices with Arrays
   * @memberof DenseMatrix
   * @param {Array} data
   * @return {Array} data
   */ function preprocess(data) {
        for(var i = 0, ii = data.length; i < ii; i++){
            var elem = data[i];
            if ((0, $7E0JQ.isArray)(elem)) data[i] = preprocess(elem);
            else if (elem && elem.isMatrix === true) data[i] = preprocess(elem.valueOf());
        }
        return data;
    }
    return DenseMatrix;
}, {
    isClass: true
});

});

parcelRegister("AdhNZ", function(module, exports) {

$parcel$export(module.exports, "createDet", function () { return $06cdab442cbea295$export$93f810683c54b005; });

var $7E0JQ = parcelRequire("7E0JQ");

var $glBd7 = parcelRequire("glBd7");

var $7HWRb = parcelRequire("7HWRb");

var $jKx4O = parcelRequire("jKx4O");
var $06cdab442cbea295$var$name = "det";
var $06cdab442cbea295$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply",
    "unaryMinus",
    "lup"
];
var $06cdab442cbea295$export$93f810683c54b005 = /* #__PURE__ */ (0, $jKx4O.factory)($06cdab442cbea295$var$name, $06cdab442cbea295$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, subtract = _ref.subtract, multiply = _ref.multiply, unaryMinus = _ref.unaryMinus, lup = _ref.lup;
    /**
   * Calculate the determinant of a matrix.
   *
   * Syntax:
   *
   *    math.det(x)
   *
   * Examples:
   *
   *    math.det([[1, 2], [3, 4]]) // returns -2
   *
   *    const A = [
   *      [-2, 2, 3],
   *      [-1, 1, 3],
   *      [2, 0, -1]
   *    ]
   *    math.det(A) // returns 6
   *
   * See also:
   *
   *    inv
   *
   * @param {Array | Matrix} x  A matrix
   * @return {number} The determinant of `x`
   */ return typed($06cdab442cbea295$var$name, {
        any: function any(x) {
            return (0, $glBd7.clone)(x);
        },
        "Array | Matrix": function det(x) {
            var size;
            if ((0, $7E0JQ.isMatrix)(x)) size = x.size();
            else if (Array.isArray(x)) {
                x = matrix(x);
                size = x.size();
            } else // a scalar
            size = [];
            switch(size.length){
                case 0:
                    // scalar
                    return (0, $glBd7.clone)(x);
                case 1:
                    // vector
                    if (size[0] === 1) return (0, $glBd7.clone)(x.valueOf()[0]);
                    else throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
                case 2:
                    // two dimensional array
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _det(x.clone().valueOf(), rows, cols);
                    else throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $7HWRb.format)(size) + ")");
            }
        }
    });
    /**
   * Calculate the determinant of a matrix
   * @param {Array[]} matrix  A square, two dimensional matrix
   * @param {number} rows     Number of rows of the matrix (zero-based)
   * @param {number} cols     Number of columns of the matrix (zero-based)
   * @returns {number} det
   * @private
   */ function _det(matrix, rows, cols) {
        if (rows === 1) // this is a 1 x 1 matrix
        return (0, $glBd7.clone)(matrix[0][0]);
        else if (rows === 2) // this is a 2 x 2 matrix
        // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
        return subtract(multiply(matrix[0][0], matrix[1][1]), multiply(matrix[1][0], matrix[0][1]));
        else {
            // Compute the LU decomposition
            var decomp = lup(matrix); // The determinant is the product of the diagonal entries of U (and those of L, but they are all 1)
            var det = decomp.U[0][0];
            for(var _i = 1; _i < rows; _i++)det = multiply(det, decomp.U[_i][_i]);
             // The determinant will be multiplied by 1 or -1 depending on the parity of the permutation matrix.
            // This can be determined by counting the cycles. This is roughly a linear time algorithm.
            var evenCycles = 0;
            var i = 0;
            var visited = [];
            while(true){
                while(visited[i])i++;
                if (i >= rows) break;
                var j = i;
                var cycleLen = 0;
                while(!visited[decomp.p[j]]){
                    visited[decomp.p[j]] = true;
                    j = decomp.p[j];
                    cycleLen++;
                }
                if (cycleLen % 2 === 0) evenCycles++;
            }
            return evenCycles % 2 === 0 ? det : unaryMinus(det);
        }
    }
});

});

parcelRegister("8rkEF", function(module, exports) {

$parcel$export(module.exports, "createDiag", function () { return $6250ddfb538800d2$export$743a950f2cd4bacc; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");
var $6250ddfb538800d2$var$name = "diag";
var $6250ddfb538800d2$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $6250ddfb538800d2$export$743a950f2cd4bacc = /* #__PURE__ */ (0, $jKx4O.factory)($6250ddfb538800d2$var$name, $6250ddfb538800d2$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix;
    /**
   * Create a diagonal matrix or retrieve the diagonal of a matrix
   *
   * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
   * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
   * When k is positive, the values are placed on the super diagonal.
   * When k is negative, the values are placed on the sub diagonal.
   *
   * Syntax:
   *
   *     math.diag(X)
   *     math.diag(X, format)
   *     math.diag(X, k)
   *     math.diag(X, k, format)
   *
   * Examples:
   *
   *     // create a diagonal matrix
   *     math.diag([1, 2, 3])      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *     math.diag([1, 2, 3], 1)   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
   *     math.diag([1, 2, 3], -1)  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *
   *    // retrieve the diagonal from a matrix
   *    const a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
   *    math.diag(a)   // returns [1, 5, 9]
   *
   * See also:
   *
   *     ones, zeros, identity
   *
   * @param {Matrix | Array} x          A two dimensional matrix or a vector
   * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
   *                                    in or retrieved.
   * @param {string} [format='dense']   The matrix storage format.
   *
   * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
   */ return typed($6250ddfb538800d2$var$name, {
        // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
        Array: function Array(x) {
            return _diag(x, 0, (0, $YkZ7e.arraySize)(x), null);
        },
        "Array, number": function ArrayNumber(x, k) {
            return _diag(x, k, (0, $YkZ7e.arraySize)(x), null);
        },
        "Array, BigNumber": function ArrayBigNumber(x, k) {
            return _diag(x, k.toNumber(), (0, $YkZ7e.arraySize)(x), null);
        },
        "Array, string": function ArrayString(x, format) {
            return _diag(x, 0, (0, $YkZ7e.arraySize)(x), format);
        },
        "Array, number, string": function ArrayNumberString(x, k, format) {
            return _diag(x, k, (0, $YkZ7e.arraySize)(x), format);
        },
        "Array, BigNumber, string": function ArrayBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), (0, $YkZ7e.arraySize)(x), format);
        },
        Matrix: function Matrix(x) {
            return _diag(x, 0, x.size(), x.storage());
        },
        "Matrix, number": function MatrixNumber(x, k) {
            return _diag(x, k, x.size(), x.storage());
        },
        "Matrix, BigNumber": function MatrixBigNumber(x, k) {
            return _diag(x, k.toNumber(), x.size(), x.storage());
        },
        "Matrix, string": function MatrixString(x, format) {
            return _diag(x, 0, x.size(), format);
        },
        "Matrix, number, string": function MatrixNumberString(x, k, format) {
            return _diag(x, k, x.size(), format);
        },
        "Matrix, BigNumber, string": function MatrixBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), x.size(), format);
        }
    });
    /**
   * Creeate diagonal matrix from a vector or vice versa
   * @param {Array | Matrix} x
   * @param {number} k
   * @param {string} format Storage format for matrix. If null,
   *                          an Array is returned
   * @returns {Array | Matrix}
   * @private
   */ function _diag(x, k, size, format) {
        if (!(0, $5wlxr.isInteger)(k)) throw new TypeError("Second parameter in function diag must be an integer");
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // check dimensions
        switch(size.length){
            case 1:
                return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
            case 2:
                return _getDiagonal(x, k, format, size, kSub, kSuper);
        }
        throw new RangeError("Matrix for function diag must be 2 dimensional");
    }
    function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
        // matrix size
        var ms = [
            l + kSub,
            l + kSuper
        ];
        if (format && format !== "sparse" && format !== "dense") throw new TypeError("Unknown matrix type ".concat(format, '"'));
         // create diagonal matrix
        var m = format === "sparse" ? SparseMatrix.diagonal(ms, x, k) : DenseMatrix.diagonal(ms, x, k); // check we need to return a matrix
        return format !== null ? m : m.valueOf();
    }
    function _getDiagonal(x, k, format, s, kSub, kSuper) {
        // check x is a Matrix
        if ((0, $7E0JQ.isMatrix)(x)) {
            // get diagonal matrix
            var dm = x.diagonal(k); // check we need to return a matrix
            if (format !== null) {
                // check we need to change matrix format
                if (format !== dm.storage()) return matrix(dm, format);
                return dm;
            }
            return dm.valueOf();
        } // vector size
        var n = Math.min(s[0] - kSub, s[1] - kSuper); // diagonal values
        var vector = []; // loop diagonal
        for(var i = 0; i < n; i++)vector[i] = x[i + kSub][i + kSuper];
         // check we need to return a matrix
        return format !== null ? matrix(vector) : vector;
    }
});

});

parcelRegister("5N4kO", function(module, exports) {

$parcel$export(module.exports, "createDistance", function () { return $4374e41caee01d1e$export$23f482ad1a94fa7e; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $4374e41caee01d1e$var$name = "distance";
var $4374e41caee01d1e$var$dependencies = [
    "typed",
    "addScalar",
    "subtract",
    "divideScalar",
    "multiplyScalar",
    "unaryMinus",
    "sqrt",
    "abs"
];
var $4374e41caee01d1e$export$23f482ad1a94fa7e = /* #__PURE__ */ (0, $jKx4O.factory)($4374e41caee01d1e$var$name, $4374e41caee01d1e$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, subtract = _ref.subtract, multiplyScalar = _ref.multiplyScalar, divideScalar = _ref.divideScalar, unaryMinus = _ref.unaryMinus, sqrt = _ref.sqrt, abs = _ref.abs;
    /**
    * Calculates:
    *    The eucledian distance between two points in N-dimensional spaces.
    *    Distance between point and a line in 2 and 3 dimensional spaces.
    *    Pairwise distance between a set of 2D or 3D points
    * NOTE:
    *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
    *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
    *
    * Syntax:
    *    math.distance([x1, y1], [x2, y2])
    *-   math.distance({pointOneX: 4, pointOneY: 5}, {pointTwoX: 2, pointTwoY: 7})
    *    math.distance([x1, y1, z1], [x2, y2, z2])
    *    math.distance({pointOneX: 4, pointOneY: 5, pointOneZ: 8}, {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})
    *    math.distance([x1, y1, ... , N1], [x2, y2, ... , N2])
    *    math.distance([[A], [B], [C]...])
    *    math.distance([x1, y1], [LinePtX1, LinePtY1], [LinePtX2, LinePtY2])
    *    math.distance({pointX: 1, pointY: 4}, {lineOnePtX: 6, lineOnePtY: 3}, {lineTwoPtX: 2, lineTwoPtY: 8})
    *    math.distance([x1, y1, z1], [LinePtX1, LinePtY1, LinePtZ1], [LinePtX2, LinePtY2, LinePtZ2])
    *    math.distance({pointX: 1, pointY: 4, pointZ: 7}, {lineOnePtX: 6, lineOnePtY: 3, lineOnePtZ: 4}, {lineTwoPtX: 2, lineTwoPtY: 8, lineTwoPtZ: 5})
    *    math.distance([x1, y1], [xCoeffLine, yCoeffLine, constant])
    *    math.distance({pointX: 10, pointY: 10}, {xCoeffLine: 8, yCoeffLine: 1, constant: 3})
    *    math.distance([x1, y1, z1], [x0, y0, z0, a-tCoeff, b-tCoeff, c-tCoeff]) point and parametric equation of 3D line
    *    math.distance([x, y, z], [x0, y0, z0, a, b, c])
    *    math.distance({pointX: 2, pointY: 5, pointZ: 9}, {x0: 4, y0: 6, z0: 3, a: 4, b: 2, c: 0})
    *
    * Examples:
    *    math.distance([0,0], [4,4])                     // Returns 5.6569
    *    math.distance(
    *     {pointOneX: 0, pointOneY: 0},
    *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
    *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.74166
    *    math.distance(
    *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
    *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
    *    math.distance([1, 0, 1, 0], [0, -1, 0, -1])     // Returns 2
    *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
    *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
    *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
    *    math.distance([10, 10], [2, 3], [-8, 0])        // Returns 8.759953130362847
    *    math.distance(
    *     {pointX: 1, pointY: 4},
    *     {lineOnePtX: 6, lineOnePtY: 3},
    *     {lineTwoPtX: 2, lineTwoPtY: 8})                // Returns 2.720549372624744
    *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
    *    math.distance(
    *     {pointX: 2, pointY: 3, pointZ: 1},
    *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1}        // Returns 2.3204774044612857
    *
    * @param {Array | Matrix | Object} x    Co-ordinates of first point
    * @param {Array | Matrix | Object} y    Co-ordinates of second point
    * @return {Number | BigNumber} Returns the distance from two/three points
  */ return typed($4374e41caee01d1e$var$name, {
        "Array, Array, Array": function ArrayArrayArray(x, y, z) {
            // Point to Line 2D (x=Point, y=LinePoint1, z=LinePoint2)
            if (x.length === 2 && y.length === 2 && z.length === 2) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                var m = divideScalar(subtract(z[1], z[0]), subtract(y[1], y[0]));
                var xCoeff = multiplyScalar(multiplyScalar(m, m), y[0]);
                var yCoeff = unaryMinus(multiplyScalar(m, y[0]));
                var constant = x[1];
                return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object, Object": function ObjectObjectObject(x, y, z) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 2 && Object.keys(z).length === 2) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
                if (!_2d(z)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "lineOnePtX" in y && "lineOnePtY" in y && "lineTwoPtX" in z && "lineTwoPtY" in z) {
                    var m = divideScalar(subtract(z.lineTwoPtY, z.lineTwoPtX), subtract(y.lineOnePtY, y.lineOnePtX));
                    var xCoeff = multiplyScalar(multiplyScalar(m, m), y.lineOnePtX);
                    var yCoeff = unaryMinus(multiplyScalar(m, y.lineOnePtX));
                    var constant = x.pointX;
                    return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
                } else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Array, Array": function ArrayArray(x, y) {
            // Point to Line 2D (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
            if (x.length === 2 && y.length === 3) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
            } else if (x.length === 3 && y.length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                if (!_parametricLine(y)) throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
                return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
            } else if (x.length === y.length && x.length > 0) {
                // Point to Point N-dimensions
                if (!_containsOnlyNumbers(x)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                if (!_containsOnlyNumbers(y)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                return _euclideanDistance(x, y);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object": function ObjectObject(x, y) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 3) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "xCoeffLine" in y && "yCoeffLine" in y && "constant" in y) return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
                if (!_parametricLine(y)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "x0" in y && "y0" in y && "z0" in y && "a" in y && "b" in y && "c" in y) return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 2 && Object.keys(y).length === 2) {
                // Point to Point 2D
                if (!_2d(x)) throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointTwoX" in y && "pointTwoY" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY
                ], [
                    y.pointTwoX,
                    y.pointTwoY
                ]);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 3) {
                // Point to Point 3D
                if (!_3d(x)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointOneZ" in x && "pointTwoX" in y && "pointTwoY" in y && "pointTwoZ" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY,
                    x.pointOneZ
                ], [
                    y.pointTwoX,
                    y.pointTwoY,
                    y.pointTwoZ
                ]);
                else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        Array: function Array1(arr) {
            if (!_pairwise(arr)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
            return _distancePairwise(arr);
        }
    });
    function _isNumber(a) {
        // distance supports numbers and bignumbers
        return typeof a === "number" || (0, $7E0JQ.isBigNumber)(a);
    }
    function _2d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]);
    }
    function _3d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]);
    }
    function _containsOnlyNumbers(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (!Array.isArray(a)) a = _objectToArray(a);
        return a.every(_isNumber);
    }
    function _parametricLine(a) {
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) && _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
    }
    function _objectToArray(o) {
        var keys = Object.keys(o);
        var a = [];
        for(var i = 0; i < keys.length; i++)a.push(o[keys[i]]);
        return a;
    }
    function _pairwise(a) {
        // checks for valid arguments passed to _distancePairwise(Array)
        if (a[0].length === 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])) {
            if (a.some(function(aI) {
                return aI.length !== 2 || !_isNumber(aI[0]) || !_isNumber(aI[1]);
            })) return false;
        } else if (a[0].length === 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])) {
            if (a.some(function(aI) {
                return aI.length !== 3 || !_isNumber(aI[0]) || !_isNumber(aI[1]) || !_isNumber(aI[2]);
            })) return false;
        } else return false;
        return true;
    }
    function _distancePointLine2D(x, y, a, b, c) {
        var num = abs(addScalar(addScalar(multiplyScalar(a, x), multiplyScalar(b, y)), c));
        var den = sqrt(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)));
        return divideScalar(num, den);
    }
    function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c) {
        var num = [
            subtract(multiplyScalar(subtract(y0, y), c), multiplyScalar(subtract(z0, z), b)),
            subtract(multiplyScalar(subtract(z0, z), a), multiplyScalar(subtract(x0, x), c)),
            subtract(multiplyScalar(subtract(x0, x), b), multiplyScalar(subtract(y0, y), a))
        ];
        num = sqrt(addScalar(addScalar(multiplyScalar(num[0], num[0]), multiplyScalar(num[1], num[1])), multiplyScalar(num[2], num[2])));
        var den = sqrt(addScalar(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)), multiplyScalar(c, c)));
        return divideScalar(num, den);
    }
    function _euclideanDistance(x, y) {
        var vectorSize = x.length;
        var result = 0;
        var diff = 0;
        for(var i = 0; i < vectorSize; i++){
            diff = subtract(x[i], y[i]);
            result = addScalar(multiplyScalar(diff, diff), result);
        }
        return sqrt(result);
    }
    function _distancePairwise(a) {
        var result = [];
        var pointA = [];
        var pointB = [];
        for(var i = 0; i < a.length - 1; i++)for(var j = i + 1; j < a.length; j++){
            if (a[0].length === 2) {
                pointA = [
                    a[i][0],
                    a[i][1]
                ];
                pointB = [
                    a[j][0],
                    a[j][1]
                ];
            } else if (a[0].length === 3) {
                pointA = [
                    a[i][0],
                    a[i][1],
                    a[i][2]
                ];
                pointB = [
                    a[j][0],
                    a[j][1],
                    a[j][2]
                ];
            }
            result.push(_euclideanDistance(pointA, pointB));
        }
        return result;
    }
});

});

parcelRegister("13oP7", function(module, exports) {

$parcel$export(module.exports, "createDivide", function () { return $0c4953b12b9ac537$export$4df5e56bb6d14758; });

var $jKx4O = parcelRequire("jKx4O");

var $glBd7 = parcelRequire("glBd7");

var $1Gmbc = parcelRequire("1Gmbc");

var $5ntii = parcelRequire("5ntii");
var $0c4953b12b9ac537$var$name = "divide";
var $0c4953b12b9ac537$var$dependencies = [
    "typed",
    "matrix",
    "multiply",
    "equalScalar",
    "divideScalar",
    "inv"
];
var $0c4953b12b9ac537$export$4df5e56bb6d14758 = /* #__PURE__ */ (0, $jKx4O.factory)($0c4953b12b9ac537$var$name, $0c4953b12b9ac537$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, multiply = _ref.multiply, equalScalar = _ref.equalScalar, divideScalar = _ref.divideScalar, inv = _ref.inv;
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Divide two values, `x / y`.
   * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
   *
   * Syntax:
   *
   *    math.divide(x, y)
   *
   * Examples:
   *
   *    math.divide(2, 3)            // returns number 0.6666666666666666
   *
   *    const a = math.complex(5, 14)
   *    const b = math.complex(4, 1)
   *    math.divide(a, b)            // returns Complex 2 + 3i
   *
   *    const c = [[7, -6], [13, -4]]
   *    const d = [[1, 2], [4, 3]]
   *    math.divide(c, d)            // returns Array [[-9, 4], [-11, 6]]
   *
   *    const e = math.unit('18 km')
   *    math.divide(e, 4.5)          // returns Unit 4 km
   *
   * See also:
   *
   *    multiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
   */ return typed("divide", (0, $glBd7.extend)({
        // we extend the signatures of divideScalar with signatures dealing with matrices
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(x, y) {
            // TODO: implement matrix right division using pseudo inverse
            // https://www.mathworks.nl/help/matlab/ref/mrdivide.html
            // https://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
            // https://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
            return multiply(x, inv(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array | Matrix": function anyArrayMatrix(x, y) {
            return multiply(x, inv(y));
        }
    }, divideScalar.signatures));
});

});

parcelRegister("9KbY0", function(module, exports) {

$parcel$export(module.exports, "createDivideScalar", function () { return $7181b15237cb40c7$export$399593177816ff82; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");
var $7181b15237cb40c7$var$name = "divideScalar";
var $7181b15237cb40c7$var$dependencies = [
    "typed",
    "numeric"
];
var $7181b15237cb40c7$export$399593177816ff82 = /* #__PURE__ */ (0, $jKx4O.factory)($7181b15237cb40c7$var$name, $7181b15237cb40c7$var$dependencies, function(_ref) {
    var typed = _ref.typed, numeric = _ref.numeric;
    /**
   * Divide two scalar values, `x / y`.
   * This function is meant for internal use: it is used by the public functions
   * `divide` and `inv`.
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit}     Quotient, `x / y`
   * @private
   */ var divideScalar = typed($7181b15237cb40c7$var$name, {
        "number, number": function numberNumber(x, y) {
            return x / y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.div(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.div(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.div(y);
        },
        "Unit, number | Fraction | BigNumber": function UnitNumberFractionBigNumber(x, y) {
            var res = x.clone(); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $7E0JQ.typeOf)(y));
            res.value = divideScalar(res.value === null ? res._normalize(one) : res.value, y);
            return res;
        },
        "number | Fraction | BigNumber, Unit": function numberFractionBigNumberUnit(x, y) {
            var res = y.clone();
            res = res.pow(-1); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $7E0JQ.typeOf)(x));
            res.value = divideScalar(x, y.value === null ? y._normalize(one) : y.value);
            return res;
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return x.divide(y);
        }
    });
    return divideScalar;
});

});

parcelRegister("5Hav5", function(module, exports) {

$parcel$export(module.exports, "createDot", function () { return $42591d152ff5e568$export$3dc59ff00984d687; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $42591d152ff5e568$var$name = "dot";
var $42591d152ff5e568$var$dependencies = [
    "typed",
    "add",
    "multiply"
];
var $42591d152ff5e568$export$3dc59ff00984d687 = /* #__PURE__ */ (0, $jKx4O.factory)($42591d152ff5e568$var$name, $42591d152ff5e568$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, multiply = _ref.multiply;
    /**
   * Calculate the dot product of two vectors. The dot product of
   * `A = [a1, a2, a3, ..., an]` and `B = [b1, b2, b3, ..., bn]` is defined as:
   *
   *    dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn
   *
   * Syntax:
   *
   *    math.dot(x, y)
   *
   * Examples:
   *
   *    math.dot([2, 4, 1], [2, 2, 3])       // returns number 15
   *    math.multiply([2, 4, 1], [2, 2, 3])  // returns number 15
   *
   * See also:
   *
   *    multiply, cross
   *
   * @param  {Array | Matrix} x     First vector
   * @param  {Array | Matrix} y     Second vector
   * @return {number}               Returns the dot product of `x` and `y`
   */ return typed($42591d152ff5e568$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return _dot(x.toArray(), y.toArray());
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return _dot(x.toArray(), y);
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return _dot(x, y.toArray());
        },
        "Array, Array": _dot
    });
    /**
   * Calculate the dot product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {number} Returns the dot product of x and y
   * @private
   */ // TODO: double code with math.multiply
    function _dot(x, y) {
        var xSize = (0, $YkZ7e.arraySize)(x);
        var ySize = (0, $YkZ7e.arraySize)(y);
        var len = xSize[0];
        if (xSize.length !== 1 || ySize.length !== 1) throw new RangeError("Vector expected"); // TODO: better error message
        if (xSize[0] !== ySize[0]) throw new RangeError("Vectors must have equal length (" + xSize[0] + " != " + ySize[0] + ")");
        if (len === 0) throw new RangeError("Cannot calculate the dot product of empty vectors");
        var prod = 0;
        for(var i = 0; i < len; i++)prod = add(prod, multiply(x[i], y[i]));
        return prod;
    }
});

});

parcelRegister("7GYYs", function(module, exports) {

$parcel$export(module.exports, "createDotDivide", function () { return $599bc0db8036f6cc$export$e4930a420a373a24; });

var $jKx4O = parcelRequire("jKx4O");

var $16D4T = parcelRequire("16D4T");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $1Gmbc = parcelRequire("1Gmbc");

var $272zs = parcelRequire("272zs");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");
var $599bc0db8036f6cc$var$name = "dotDivide";
var $599bc0db8036f6cc$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "divideScalar",
    "DenseMatrix"
];
var $599bc0db8036f6cc$export$e4930a420a373a24 = /* #__PURE__ */ (0, $jKx4O.factory)($599bc0db8036f6cc$var$name, $599bc0db8036f6cc$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, divideScalar = _ref.divideScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Divide two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotDivide(x, y)
   *
   * Examples:
   *
   *    math.dotDivide(2, 4)   // returns 0.5
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotDivide(a, b)   // returns [[3, 2.5], [1.2, 0.5]]
   *    math.divide(a, b)      // returns [[1.75, 0.75], [-1.75, 2.25]]
   *
   * See also:
   *
   *    divide, multiply, dotMultiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
   */ var dotDivide = typed($599bc0db8036f6cc$var$name, {
        "any, any": divideScalar,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, divideScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, divideScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, divideScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, divideScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return dotDivide(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return dotDivide(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return dotDivide(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, divideScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, divideScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, divideScalar, true).valueOf();
        }
    });
    return dotDivide;
});

});

parcelRegister("drORN", function(module, exports) {

$parcel$export(module.exports, "createDotMultiply", function () { return $9ca54109b5ed2429$export$a4620e84460f321e; });

var $jKx4O = parcelRequire("jKx4O");

var $16D4T = parcelRequire("16D4T");

var $bLY1y = parcelRequire("bLY1y");

var $1Gmbc = parcelRequire("1Gmbc");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");
var $9ca54109b5ed2429$var$name = "dotMultiply";
var $9ca54109b5ed2429$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "multiplyScalar"
];
var $9ca54109b5ed2429$export$a4620e84460f321e = /* #__PURE__ */ (0, $jKx4O.factory)($9ca54109b5ed2429$var$name, $9ca54109b5ed2429$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, multiplyScalar = _ref.multiplyScalar;
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm09 = (0, $bLY1y.createAlgorithm09)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Multiply two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotMultiply(x, y)
   *
   * Examples:
   *
   *    math.dotMultiply(2, 4) // returns 8
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotMultiply(a, b) // returns [[27, 10], [30, 2]]
   *    math.multiply(a, b)    // returns [[52, 28], [23, 14]]
   *
   * See also:
   *
   *    multiply, divide, dotDivide
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
   */ var dotMultiply = typed($9ca54109b5ed2429$var$name, {
        "any, any": multiplyScalar,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, multiplyScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, multiplyScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, multiplyScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, multiplyScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return dotMultiply(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return dotMultiply(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return dotMultiply(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        }
    });
    return dotMultiply;
});

});

parcelRegister("9LYIW", function(module, exports) {

$parcel$export(module.exports, "createDotPow", function () { return $71d79b55987adbe1$export$734b49568d8effd6; });

var $jKx4O = parcelRequire("jKx4O");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $1Gmbc = parcelRequire("1Gmbc");

var $272zs = parcelRequire("272zs");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");
var $71d79b55987adbe1$var$name = "dotPow";
var $71d79b55987adbe1$var$dependencies = [
    "typed",
    "equalScalar",
    "matrix",
    "pow",
    "DenseMatrix"
];
var $71d79b55987adbe1$export$734b49568d8effd6 = /* #__PURE__ */ (0, $jKx4O.factory)($71d79b55987adbe1$var$name, $71d79b55987adbe1$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar, matrix = _ref.matrix, pow = _ref.pow, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculates the power of x to y element wise.
   *
   * Syntax:
   *
   *    math.dotPow(x, y)
   *
   * Examples:
   *
   *    math.dotPow(2, 3)            // returns number 8
   *
   *    const a = [[1, 2], [4, 3]]
   *    math.dotPow(a, 2)            // returns Array [[1, 4], [16, 9]]
   *    math.pow(a, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    pow, sqrt, multiply
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
   */ var dotPow = typed($71d79b55987adbe1$var$name, {
        "any, any": pow,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, pow, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, pow, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, pow, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, pow);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return dotPow(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return dotPow(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return dotPow(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, dotPow, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, dotPow, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, dotPow, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, dotPow, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, dotPow, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, dotPow, true).valueOf();
        }
    });
    return dotPow;
});

});

parcelRegister("gt2fN", function(module, exports) {

$parcel$export(module.exports, "createTrue", function () { return $bfd11a5a392d835a$export$e13d32722e2756df; });
$parcel$export(module.exports, "createFalse", function () { return $bfd11a5a392d835a$export$cb94e3a54c9e99b; });
$parcel$export(module.exports, "createNull", function () { return $bfd11a5a392d835a$export$d07c6114481fc17b; });
$parcel$export(module.exports, "createInfinity", function () { return $bfd11a5a392d835a$export$df1313fb6eb44f05; });
$parcel$export(module.exports, "createNaN", function () { return $bfd11a5a392d835a$export$fbdaee11df58c3cc; });
$parcel$export(module.exports, "createPi", function () { return $bfd11a5a392d835a$export$2dbe69c48ac7f49c; });
$parcel$export(module.exports, "createTau", function () { return $bfd11a5a392d835a$export$d5973a6d5d95d479; });
$parcel$export(module.exports, "createE", function () { return $bfd11a5a392d835a$export$6dca51ff4d4b257f; });
$parcel$export(module.exports, "createPhi", function () { return $bfd11a5a392d835a$export$f131830080647892; });
$parcel$export(module.exports, "createLN2", function () { return $bfd11a5a392d835a$export$ab67ddb9e8290a2c; });
$parcel$export(module.exports, "createLN10", function () { return $bfd11a5a392d835a$export$5365e90aad1235b4; });
$parcel$export(module.exports, "createLOG2E", function () { return $bfd11a5a392d835a$export$b57f4b4cfc057c2d; });
$parcel$export(module.exports, "createLOG10E", function () { return $bfd11a5a392d835a$export$57f654bce66ec8ce; });
$parcel$export(module.exports, "createSQRT1_2", function () { return $bfd11a5a392d835a$export$e6df2cb14f3e8316; });
$parcel$export(module.exports, "createSQRT2", function () { return $bfd11a5a392d835a$export$f7a593fe98eba575; });
$parcel$export(module.exports, "createI", function () { return $bfd11a5a392d835a$export$7122d2461a6f9b76; });
$parcel$export(module.exports, "createVersion", function () { return $bfd11a5a392d835a$export$72a91d9326d5a672; });

var $jKx4O = parcelRequire("jKx4O");

var $5czP5 = parcelRequire("5czP5");

var $fKKQe = parcelRequire("fKKQe");

var $58lOt = parcelRequire("58lOt");
var $bfd11a5a392d835a$export$e13d32722e2756df = /* #__PURE__ */ (0, $jKx4O.factory)("true", [], function() {
    return true;
});
var $bfd11a5a392d835a$export$cb94e3a54c9e99b = /* #__PURE__ */ (0, $jKx4O.factory)("false", [], function() {
    return false;
});
var $bfd11a5a392d835a$export$d07c6114481fc17b = /* #__PURE__ */ (0, $jKx4O.factory)("null", [], function() {
    return null;
});
var $bfd11a5a392d835a$export$df1313fb6eb44f05 = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("Infinity", [
    "config",
    "?BigNumber"
], function(_ref) {
    var config = _ref.config, BigNumber = _ref.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(Infinity) : Infinity;
});
var $bfd11a5a392d835a$export$fbdaee11df58c3cc = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("NaN", [
    "config",
    "?BigNumber"
], function(_ref2) {
    var config = _ref2.config, BigNumber = _ref2.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(NaN) : NaN;
});
var $bfd11a5a392d835a$export$2dbe69c48ac7f49c = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("pi", [
    "config",
    "?BigNumber"
], function(_ref3) {
    var config = _ref3.config, BigNumber = _ref3.BigNumber;
    return config.number === "BigNumber" ? (0, $fKKQe.createBigNumberPi)(BigNumber) : (0, $58lOt.pi);
});
var $bfd11a5a392d835a$export$d5973a6d5d95d479 = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("tau", [
    "config",
    "?BigNumber"
], function(_ref4) {
    var config = _ref4.config, BigNumber = _ref4.BigNumber;
    return config.number === "BigNumber" ? (0, $fKKQe.createBigNumberTau)(BigNumber) : (0, $58lOt.tau);
});
var $bfd11a5a392d835a$export$6dca51ff4d4b257f = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("e", [
    "config",
    "?BigNumber"
], function(_ref5) {
    var config = _ref5.config, BigNumber = _ref5.BigNumber;
    return config.number === "BigNumber" ? (0, $fKKQe.createBigNumberE)(BigNumber) : (0, $58lOt.e);
}); // golden ratio, (1+sqrt(5))/2
var $bfd11a5a392d835a$export$f131830080647892 = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("phi", [
    "config",
    "?BigNumber"
], function(_ref6) {
    var config = _ref6.config, BigNumber = _ref6.BigNumber;
    return config.number === "BigNumber" ? (0, $fKKQe.createBigNumberPhi)(BigNumber) : (0, $58lOt.phi);
});
var $bfd11a5a392d835a$export$ab67ddb9e8290a2c = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("LN2", [
    "config",
    "?BigNumber"
], function(_ref7) {
    var config = _ref7.config, BigNumber = _ref7.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(2).ln() : Math.LN2;
});
var $bfd11a5a392d835a$export$5365e90aad1235b4 = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("LN10", [
    "config",
    "?BigNumber"
], function(_ref8) {
    var config = _ref8.config, BigNumber = _ref8.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(10).ln() : Math.LN10;
});
var $bfd11a5a392d835a$export$b57f4b4cfc057c2d = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("LOG2E", [
    "config",
    "?BigNumber"
], function(_ref9) {
    var config = _ref9.config, BigNumber = _ref9.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(2).ln()) : Math.LOG2E;
});
var $bfd11a5a392d835a$export$57f654bce66ec8ce = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("LOG10E", [
    "config",
    "?BigNumber"
], function(_ref10) {
    var config = _ref10.config, BigNumber = _ref10.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(10).ln()) : Math.LOG10E;
});
var $bfd11a5a392d835a$export$e6df2cb14f3e8316 = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("SQRT1_2", [
    "config",
    "?BigNumber"
], function(_ref11) {
    var config = _ref11.config, BigNumber = _ref11.BigNumber;
    return config.number === "BigNumber" ? new BigNumber("0.5").sqrt() : Math.SQRT1_2;
});
var $bfd11a5a392d835a$export$f7a593fe98eba575 = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("SQRT2", [
    "config",
    "?BigNumber"
], function(_ref12) {
    var config = _ref12.config, BigNumber = _ref12.BigNumber;
    return config.number === "BigNumber" ? new BigNumber(2).sqrt() : Math.SQRT2;
});
var $bfd11a5a392d835a$export$7122d2461a6f9b76 = /* #__PURE__ */ $bfd11a5a392d835a$var$recreateFactory("i", [
    "Complex"
], function(_ref13) {
    var Complex = _ref13.Complex;
    return Complex.I;
}); // for backward compatibility with v5
var $bfd11a5a392d835a$export$5aab935c59859292 = /* #__PURE__ */ (0, $jKx4O.factory)("PI", [
    "pi"
], function(_ref14) {
    var pi = _ref14.pi;
    return pi;
});
var $bfd11a5a392d835a$export$56c791a240a1c942 = /* #__PURE__ */ (0, $jKx4O.factory)("E", [
    "e"
], function(_ref15) {
    var e = _ref15.e;
    return e;
});
var $bfd11a5a392d835a$export$72a91d9326d5a672 = /* #__PURE__ */ (0, $jKx4O.factory)("version", [], function() {
    return 0, $5czP5.version;
}); // helper function to create a factory with a flag recreateOnConfigChange
// idea: allow passing optional properties to be attached to the factory function as 4th argument?
function $bfd11a5a392d835a$var$recreateFactory(name, dependencies, create) {
    return (0, $jKx4O.factory)(name, dependencies, create, {
        recreateOnConfigChange: true
    });
}

});
parcelRegister("5czP5", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3c99dc749a22bb28$export$83d89fbfd8236492; });
var $3c99dc749a22bb28$export$83d89fbfd8236492 = "6.6.5"; // Note: This file is automatically generated when building math.js.
 // Changes made in this file will be overwritten.

});

parcelRegister("fKKQe", function(module, exports) {

$parcel$export(module.exports, "createBigNumberE", function () { return $b77f7ca715ab96e7$export$737cba75de6dfb68; });
$parcel$export(module.exports, "createBigNumberPhi", function () { return $b77f7ca715ab96e7$export$c7e121b24930c156; });
$parcel$export(module.exports, "createBigNumberPi", function () { return $b77f7ca715ab96e7$export$d0a8190d955e3c5b; });
$parcel$export(module.exports, "createBigNumberTau", function () { return $b77f7ca715ab96e7$export$83b6ee92a84f32c6; });

var $lMDm0 = parcelRequire("lMDm0");
var $b77f7ca715ab96e7$export$737cba75de6dfb68 = (0, $lMDm0.memoize)(function(BigNumber) {
    return new BigNumber(1).exp();
}, $b77f7ca715ab96e7$var$hasher);
var $b77f7ca715ab96e7$export$c7e121b24930c156 = (0, $lMDm0.memoize)(function(BigNumber) {
    return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
}, $b77f7ca715ab96e7$var$hasher);
var $b77f7ca715ab96e7$export$d0a8190d955e3c5b = (0, $lMDm0.memoize)(function(BigNumber) {
    return BigNumber.acos(-1);
}, $b77f7ca715ab96e7$var$hasher);
var $b77f7ca715ab96e7$export$83b6ee92a84f32c6 = (0, $lMDm0.memoize)(function(BigNumber) {
    return $b77f7ca715ab96e7$export$d0a8190d955e3c5b(BigNumber).times(2);
}, $b77f7ca715ab96e7$var$hasher);
/**
 * Create a hash for a BigNumber constructor function. The created has is
 * the configured precision
 * @param {Array} args         Supposed to contain a single entry with
 *                             a BigNumber constructor
 * @return {number} precision
 * @private
 */ function $b77f7ca715ab96e7$var$hasher(args) {
    return args[0].precision;
}

});

parcelRegister("58lOt", function(module, exports) {

$parcel$export(module.exports, "pi", function () { return $3bce9eb546373b83$export$18c7bea995a110f; });
$parcel$export(module.exports, "tau", function () { return $3bce9eb546373b83$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "e", function () { return $3bce9eb546373b83$export$f1e1789686576879; });
$parcel$export(module.exports, "phi", function () { return $3bce9eb546373b83$export$324943737027944a; });
var $3bce9eb546373b83$export$18c7bea995a110f = Math.PI;
var $3bce9eb546373b83$export$a4b4b4d4d776fe92 = 2 * Math.PI;
var $3bce9eb546373b83$export$f1e1789686576879 = Math.E;
var $3bce9eb546373b83$export$324943737027944a = 1.61803398874989484820458683436563811772030917980576286213545;

});


parcelRegister("7dlnz", function(module, exports) {

$parcel$export(module.exports, "createEigs", function () { return $540a54bf4a636120$export$ba9e077a2df092d7; });

var $glBd7 = parcelRequire("glBd7");

var $jKx4O = parcelRequire("jKx4O");

var $7HWRb = parcelRequire("7HWRb");
var $540a54bf4a636120$var$name = "eigs";
var $540a54bf4a636120$var$dependencies = [
    "config",
    "typed",
    "matrix",
    "addScalar",
    "equal",
    "subtract",
    "abs",
    "atan",
    "cos",
    "sin",
    "multiplyScalar",
    "inv",
    "bignumber",
    "multiply",
    "add"
];
var $540a54bf4a636120$export$ba9e077a2df092d7 = /* #__PURE__ */ (0, $jKx4O.factory)($540a54bf4a636120$var$name, $540a54bf4a636120$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, matrix = _ref.matrix, addScalar = _ref.addScalar, subtract = _ref.subtract, equal = _ref.equal, abs = _ref.abs, atan = _ref.atan, cos = _ref.cos, sin = _ref.sin, multiplyScalar = _ref.multiplyScalar, inv = _ref.inv, bignumber = _ref.bignumber, multiply = _ref.multiply, add = _ref.add;
    /**
   * Compute eigenvalue and eigenvector of a real symmetric matrix.
   * Only applicable to two dimensional symmetric matrices. Uses Jacobi
   * Algorithm. Matrix containing mixed type ('number', 'bignumber', 'fraction')
   * of elements are not supported. Input matrix or 2D array should contain all elements
   * of either 'number', 'bignumber' or 'fraction' type. For 'number' and 'fraction', the
   * eigenvalues are of 'number' type. For 'bignumber' the eigenvalues are of ''bignumber' type.
   * Eigenvectors are always of 'number' type.
   *
   * Syntax:
   *
   *     math.eigs(x)
   *
   * Examples:
   *
   *     const H = [[5, 2.3], [2.3, 1]]
   *     const ans = math.eigs(H) // returns {values: [E1,E2...sorted], vectors: [v1,v2.... corresponding vectors]}
   *     const E = ans.values
   *     const U = ans.vectors
   *     const UTxHxU = math.multiply(math.transpose(U), H, U) // rotates H to the eigen-representation
   *     E[0] == UTxHxU[0][0]  // returns true
   * See also:
   *
   *     inv
   *
   * @param {Array | Matrix} x  Matrix to be diagonalized
   * @return {{values: Array, vectors: Array} | {values: Matrix, vectors: Matrix}} Object containing eigenvalues (Array or Matrix) and eigenvectors (2D Array/Matrix).
   */ var eigs = typed("eigs", {
        Array: function Array1(x) {
            // check array size
            var mat = matrix(x);
            var size = mat.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
             // use dense 2D matrix implementation
            var ans = checkAndSubmit(mat, size[0]);
            return {
                values: ans[0],
                vectors: ans[1]
            };
        },
        Matrix: function Matrix(x) {
            // use dense 2D array implementation
            // dense matrix
            var size = x.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
            var ans = checkAndSubmit(x, size[0]);
            return {
                values: matrix(ans[0]),
                vectors: matrix(ans[1])
            };
        }
    }); // Is the matrix
    // symmetric ?
    function isSymmetric(x, n) {
        for(var i = 0; i < n; i++)for(var j = i; j < n; j++){
            // not symmtric
            if (!equal(x[i][j], x[j][i])) throw new TypeError("Input matrix is not symmetric");
        }
    } // check input for possible problems
    // and perform diagonalization efficiently for
    // specific type of number
    function checkAndSubmit(x, n) {
        var type = x.datatype(); // type check
        if (type === undefined) type = x.getDataType();
        if (type !== "number" && type !== "BigNumber" && type !== "Fraction") {
            if (type === "mixed") throw new TypeError("Mixed matrix element type is not supported");
            else throw new TypeError("Matrix element type not supported (" + type + ")");
        } else isSymmetric(x.toArray(), n);
         // perform efficient calculation for 'numbers'
        if (type === "number") return diag(x.toArray());
        else if (type === "Fraction") {
            var xArr = x.toArray(); // convert fraction to numbers
            for(var i = 0; i < n; i++)for(var j = i; j < n; j++){
                xArr[i][j] = xArr[i][j].valueOf();
                xArr[j][i] = xArr[i][j];
            }
            return diag(x.toArray());
        } else if (type === "BigNumber") return diagBig(x.toArray());
    } // diagonalization implementation for number (efficient)
    function diag(x) {
        var N = x.length;
        var e0 = Math.abs(config.epsilon / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAij(x);
        while(Math.abs(Vab[1]) >= Math.abs(e0)){
            var _i = Vab[0][0];
            var j = Vab[0][1];
            psi = getTheta(x[_i][_i], x[j][j], x[_i][j]);
            x = x1(x, psi, _i, j);
            Sij = Sij1(Sij, psi, _i, j);
            Vab = getAij(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i2 = 0; _i2 < N; _i2++)Ei[_i2] = x[_i2][_i2];
        return sorting((0, $glBd7.clone)(Ei), (0, $glBd7.clone)(Sij));
    } // diagonalization implementation for bigNumber
    function diagBig(x) {
        var N = x.length;
        var e0 = abs(config.epsilon / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAijBig(x);
        while(abs(Vab[1]) >= abs(e0)){
            var _i3 = Vab[0][0];
            var j = Vab[0][1];
            psi = getThetaBig(x[_i3][_i3], x[j][j], x[_i3][j]);
            x = x1Big(x, psi, _i3, j);
            Sij = Sij1Big(Sij, psi, _i3, j);
            Vab = getAijBig(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i4 = 0; _i4 < N; _i4++)Ei[_i4] = x[_i4][_i4];
         // return [clone(Ei), clone(Sij)]
        return sorting((0, $glBd7.clone)(Ei), (0, $glBd7.clone)(Sij));
    } // get angle
    function getTheta(aii, ajj, aij) {
        var denom = ajj - aii;
        if (Math.abs(denom) <= config.epsilon) return Math.PI / 4;
        else return 0.5 * Math.atan(2 * aij / (ajj - aii));
    } // get angle
    function getThetaBig(aii, ajj, aij) {
        var denom = subtract(ajj, aii);
        if (abs(denom) <= config.epsilon) return bignumber(-1).acos().div(4);
        else return multiplyScalar(0.5, atan(multiply(2, aij, inv(denom))));
    } // update eigvec
    function Sij1(Sij, theta, i, j) {
        var N = Sij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var Ski = createArray(N, 0);
        var Skj = createArray(N, 0);
        for(var k = 0; k < N; k++){
            Ski[k] = c * Sij[k][i] - s * Sij[k][j];
            Skj[k] = s * Sij[k][i] + c * Sij[k][j];
        }
        for(var _k = 0; _k < N; _k++){
            Sij[_k][i] = Ski[_k];
            Sij[_k][j] = Skj[_k];
        }
        return Sij;
    } // update eigvec for overlap
    function Sij1Big(Sij, theta, i, j) {
        var N = Sij.length;
        var c = cos(theta);
        var s = sin(theta);
        var Ski = createArray(N, bignumber(0));
        var Skj = createArray(N, bignumber(0));
        for(var k = 0; k < N; k++){
            Ski[k] = subtract(multiplyScalar(c, Sij[k][i]), multiplyScalar(s, Sij[k][j]));
            Skj[k] = addScalar(multiplyScalar(s, Sij[k][i]), multiplyScalar(c, Sij[k][j]));
        }
        for(var _k2 = 0; _k2 < N; _k2++){
            Sij[_k2][i] = Ski[_k2];
            Sij[_k2][j] = Skj[_k2];
        }
        return Sij;
    } // update matrix
    function x1Big(Hij, theta, i, j) {
        var N = Hij.length;
        var c = bignumber(cos(theta));
        var s = bignumber(sin(theta));
        var c2 = multiplyScalar(c, c);
        var s2 = multiplyScalar(s, s);
        var Aki = createArray(N, bignumber(0));
        var Akj = createArray(N, bignumber(0)); // 2cs Hij
        var csHij = multiply(bignumber(2), c, s, Hij[i][j]); //  Aii
        var Aii = addScalar(subtract(multiplyScalar(c2, Hij[i][i]), csHij), multiplyScalar(s2, Hij[j][j]));
        var Ajj = add(multiplyScalar(s2, Hij[i][i]), csHij, multiplyScalar(c2, Hij[j][j])); // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = subtract(multiplyScalar(c, Hij[i][k]), multiplyScalar(s, Hij[j][k]));
            Akj[k] = addScalar(multiplyScalar(s, Hij[i][k]), multiplyScalar(c, Hij[j][k]));
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = bignumber(0);
        Hij[j][i] = bignumber(0); // 0  to i
        for(var _k3 = 0; _k3 < N; _k3++)if (_k3 !== i && _k3 !== j) {
            Hij[i][_k3] = Aki[_k3];
            Hij[_k3][i] = Aki[_k3];
            Hij[j][_k3] = Akj[_k3];
            Hij[_k3][j] = Akj[_k3];
        }
        return Hij;
    } // update matrix
    function x1(Hij, theta, i, j) {
        var N = Hij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var c2 = c * c;
        var s2 = s * s;
        var Aki = createArray(N, 0);
        var Akj = createArray(N, 0); //  Aii
        var Aii = c2 * Hij[i][i] - 2 * c * s * Hij[i][j] + s2 * Hij[j][j];
        var Ajj = s2 * Hij[i][i] + 2 * c * s * Hij[i][j] + c2 * Hij[j][j]; // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = c * Hij[i][k] - s * Hij[j][k];
            Akj[k] = s * Hij[i][k] + c * Hij[j][k];
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = 0;
        Hij[j][i] = 0; // 0  to i
        for(var _k4 = 0; _k4 < N; _k4++)if (_k4 !== i && _k4 !== j) {
            Hij[i][_k4] = Aki[_k4];
            Hij[_k4][i] = Aki[_k4];
            Hij[j][_k4] = Akj[_k4];
            Hij[_k4][j] = Akj[_k4];
        }
        return Hij;
    } // get max off-diagonal value from Upper Diagonal
    function getAij(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (Math.abs(maxMij) < Math.abs(Mij[i][j])) {
                maxMij = Math.abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // get max off-diagonal value from Upper Diagonal
    function getAijBig(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (abs(maxMij) < abs(Mij[i][j])) {
                maxMij = abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // sort results
    function sorting(E, S) {
        var N = E.length;
        var Ef = Array(N);
        var Sf = Array(N);
        for(var k = 0; k < N; k++)Sf[k] = Array(N);
        for(var i = 0; i < N; i++){
            var minID = 0;
            var minE = E[0];
            for(var j = 0; j < E.length; j++)if (E[j] < minE) {
                minID = j;
                minE = E[minID];
            }
            Ef[i] = E.splice(minID, 1)[0];
            for(var _k5 = 0; _k5 < N; _k5++){
                Sf[_k5][i] = S[_k5][minID];
                S[_k5].splice(minID, 1);
            }
        }
        return [
            (0, $glBd7.clone)(Ef),
            (0, $glBd7.clone)(Sf)
        ];
    }
    /**
   * Create an array of a certain size and fill all items with an initial value
   * @param {number} size
   * @param {number} value
   * @return {number[]}
   */ function createArray(size, value) {
        // TODO: as soon as all browsers support Array.fill, use that instead (IE doesn't support it)
        var array = new Array(size);
        for(var i = 0; i < size; i++)array[i] = value;
        return array;
    }
    return eigs;
});

});

parcelRegister("30M0v", function(module, exports) {

$parcel$export(module.exports, "createEqual", function () { return $23169c62de9c0cad$export$988f37bc1f709b0d; });

var $jKx4O = parcelRequire("jKx4O");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $272zs = parcelRequire("272zs");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");
var $23169c62de9c0cad$var$name = "equal";
var $23169c62de9c0cad$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $23169c62de9c0cad$export$988f37bc1f709b0d = /* #__PURE__ */ (0, $jKx4O.factory)($23169c62de9c0cad$var$name, $23169c62de9c0cad$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether two values are equal.
   *
   * The function tests whether the relative difference between x and y is
   * smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is only
   * equal to `null` and nothing else, and `undefined` is only equal to
   * `undefined` and nothing else. Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.equal(x, y)
   *
   * Examples:
   *
   *    math.equal(2 + 2, 3)         // returns false
   *    math.equal(2 + 2, 4)         // returns true
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.equal(a, b)             // returns true
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.equal(c, d)             // returns [true, false, true]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.equal("1000", "1e3")    // returns true
   *    math.equal(0, null)          // returns false
   *
   * See also:
   *
   *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
   *
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
   */ var equal = typed($23169c62de9c0cad$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, equalScalar);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, equalScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, equalScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, equalScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return equal(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return equal(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return equal(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, equalScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, equalScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, equalScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, equalScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, equalScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, equalScalar, true).valueOf();
        }
    });
    return equal;
});
var $23169c62de9c0cad$export$87c1b92540f5e2ae = (0, $jKx4O.factory)($23169c62de9c0cad$var$name, [
    "typed",
    "equalScalar"
], function(_ref2) {
    var typed = _ref2.typed, equalScalar = _ref2.equalScalar;
    return typed($23169c62de9c0cad$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        }
    });
});

});

parcelRegister("l3dYq", function(module, exports) {

$parcel$export(module.exports, "createEqualScalar", function () { return $f534b7acb18455cf$export$c370bab664a0c9a2; });

var $9zoJy = parcelRequire("9zoJy");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");

var $jZlJC = parcelRequire("jZlJC");
var $f534b7acb18455cf$var$name = "equalScalar";
var $f534b7acb18455cf$var$dependencies = [
    "typed",
    "config"
];
var $f534b7acb18455cf$export$c370bab664a0c9a2 = /* #__PURE__ */ (0, $jKx4O.factory)($f534b7acb18455cf$var$name, $f534b7acb18455cf$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config;
    /**
   * Test whether two scalar values are nearly equal.
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
   * @private
   */ var equalScalar = typed($f534b7acb18455cf$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.eq(y) || (0, $9zoJy.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.equals(y);
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return (0, $jZlJC.complexEquals)(x, y, config.epsilon);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return equalScalar(x.value, y.value);
        }
    });
    return equalScalar;
});
var $f534b7acb18455cf$export$55f78fcc2979d648 = (0, $jKx4O.factory)($f534b7acb18455cf$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($f534b7acb18455cf$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});
parcelRegister("jZlJC", function(module, exports) {

$parcel$export(module.exports, "complexEquals", function () { return $e8d492e361669683$export$852c8261c9f393e0; });

var $5wlxr = parcelRequire("5wlxr");
function $e8d492e361669683$export$852c8261c9f393e0(x, y, epsilon) {
    return (0, $5wlxr.nearlyEqual)(x.re, y.re, epsilon) && (0, $5wlxr.nearlyEqual)(x.im, y.im, epsilon);
}

});


parcelRegister("h6Muc", function(module, exports) {

$parcel$export(module.exports, "createEqualText", function () { return $c7489b829646b045$export$1589aaa29568b87; });

var $jKx4O = parcelRequire("jKx4O");
var $c7489b829646b045$var$name = "equalText";
var $c7489b829646b045$var$dependencies = [
    "typed",
    "compareText",
    "isZero"
];
var $c7489b829646b045$export$1589aaa29568b87 = /* #__PURE__ */ (0, $jKx4O.factory)($c7489b829646b045$var$name, $c7489b829646b045$var$dependencies, function(_ref) {
    var typed = _ref.typed, compareText = _ref.compareText, isZero = _ref.isZero;
    /**
   * Check equality of two strings. Comparison is case sensitive.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.equalText(x, y)
   *
   * Examples:
   *
   *    math.equalText('Hello', 'Hello')     // returns true
   *    math.equalText('a', 'A')             // returns false
   *    math.equal('2e3', '2000')            // returns true
   *    math.equalText('2e3', '2000')        // returns false
   *
   *    math.equalText('B', ['A', 'B', 'C']) // returns [false, true, false]
   *
   * See also:
   *
   *    equal, compareText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
   */ return typed($c7489b829646b045$var$name, {
        "any, any": function anyAny(x, y) {
            return isZero(compareText(x, y));
        }
    });
});

});

parcelRegister("dKj2r", function(module, exports) {

$parcel$export(module.exports, "createErf", function () { return $a01e56e0dfc44e02$export$470dfa326d6cbdf5; });

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");
var $a01e56e0dfc44e02$var$name = "erf";
var $a01e56e0dfc44e02$var$dependencies = [
    "typed"
];
var $a01e56e0dfc44e02$export$470dfa326d6cbdf5 = /* #__PURE__ */ (0, $jKx4O.factory)($a01e56e0dfc44e02$var$name, $a01e56e0dfc44e02$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the erf function of a value using a rational Chebyshev
   * approximations for different intervals of x.
   *
   * This is a translation of W. J. Cody's Fortran implementation from 1987
   * ( https://www.netlib.org/specfun/erf ). See the AMS publication
   * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
   * for an explanation of this process.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.erf(x)
   *
   * Examples:
   *
   *    math.erf(0.2)    // returns 0.22270258921047847
   *    math.erf(-0.5)   // returns -0.5204998778130465
   *    math.erf(4)      // returns 0.9999999845827421
   *
   * @param {number | Array | Matrix} x   A real number
   * @return {number | Array | Matrix}    The erf of `x`
   */ var erf = typed("name", {
        number: function number(x) {
            var y = Math.abs(x);
            if (y >= $a01e56e0dfc44e02$var$MAX_NUM) return (0, $5wlxr.sign)(x);
            if (y <= $a01e56e0dfc44e02$var$THRESH) return (0, $5wlxr.sign)(x) * erf1(y);
            if (y <= 4.0) return (0, $5wlxr.sign)(x) * (1 - erfc2(y));
            return (0, $5wlxr.sign)(x) * (1 - erfc3(y));
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $fbkGg.deepMap)(n, erf);
        } // TODO: For complex numbers, use the approximation for the Faddeeva function
    });
    /**
   * Approximates the error function erf() for x <= 0.46875 using this function:
   *               n
   * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
   *              j=0
   */ function erf1(y) {
        var ysq = y * y;
        var xnum = $a01e56e0dfc44e02$var$P[0][4] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 3; i += 1){
            xnum = (xnum + $a01e56e0dfc44e02$var$P[0][i]) * ysq;
            xden = (xden + $a01e56e0dfc44e02$var$Q[0][i]) * ysq;
        }
        return y * (xnum + $a01e56e0dfc44e02$var$P[0][3]) / (xden + $a01e56e0dfc44e02$var$Q[0][3]);
    }
    /**
   * Approximates the complement of the error function erfc() for
   * 0.46875 <= x <= 4.0 using this function:
   *                       n
   * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
   *                      j=0
   */ function erfc2(y) {
        var xnum = $a01e56e0dfc44e02$var$P[1][8] * y;
        var xden = y;
        var i;
        for(i = 0; i < 7; i += 1){
            xnum = (xnum + $a01e56e0dfc44e02$var$P[1][i]) * y;
            xden = (xden + $a01e56e0dfc44e02$var$Q[1][i]) * y;
        }
        var result = (xnum + $a01e56e0dfc44e02$var$P[1][7]) / (xden + $a01e56e0dfc44e02$var$Q[1][7]);
        var ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    /**
   * Approximates the complement of the error function erfc() for x > 4.0 using
   * this function:
   *
   * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
   *               n
   *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
   *              j=0
   */ function erfc3(y) {
        var ysq = 1 / (y * y);
        var xnum = $a01e56e0dfc44e02$var$P[2][5] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 4; i += 1){
            xnum = (xnum + $a01e56e0dfc44e02$var$P[2][i]) * ysq;
            xden = (xden + $a01e56e0dfc44e02$var$Q[2][i]) * ysq;
        }
        var result = ysq * (xnum + $a01e56e0dfc44e02$var$P[2][4]) / (xden + $a01e56e0dfc44e02$var$Q[2][4]);
        result = ($a01e56e0dfc44e02$var$SQRPI - result) / y;
        ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    return erf;
});
/**
 * Upper bound for the first approximation interval, 0 <= x <= THRESH
 * @constant
 */ var $a01e56e0dfc44e02$var$THRESH = 0.46875;
/**
 * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
 * @constant
 */ var $a01e56e0dfc44e02$var$SQRPI = 5.6418958354775628695e-1;
/**
 * Coefficients for each term of the numerator sum (p_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $a01e56e0dfc44e02$var$P = [
    [
        3.16112374387056560e00,
        1.13864154151050156e02,
        3.77485237685302021e02,
        3.20937758913846947e03,
        1.85777706184603153e-1
    ],
    [
        5.64188496988670089e-1,
        8.88314979438837594e00,
        6.61191906371416295e01,
        2.98635138197400131e02,
        8.81952221241769090e02,
        1.71204761263407058e03,
        2.05107837782607147e03,
        1.23033935479799725e03,
        2.15311535474403846e-8
    ],
    [
        3.05326634961232344e-1,
        3.60344899949804439e-1,
        1.25781726111229246e-1,
        1.60837851487422766e-2,
        6.58749161529837803e-4,
        1.63153871373020978e-2
    ]
];
/**
 * Coefficients for each term of the denominator sum (q_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $a01e56e0dfc44e02$var$Q = [
    [
        2.36012909523441209e01,
        2.44024637934444173e02,
        1.28261652607737228e03,
        2.84423683343917062e03
    ],
    [
        1.57449261107098347e01,
        1.17693950891312499e02,
        5.37181101862009858e02,
        1.62138957456669019e03,
        3.29079923573345963e03,
        4.36261909014324716e03,
        3.43936767414372164e03,
        1.23033935480374942e03
    ],
    [
        2.56852019228982242e00,
        1.87295284992346047e00,
        5.27905102951428412e-1,
        6.05183413124413191e-2,
        2.33520497626869185e-3
    ]
];
/**
 * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
 * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
 * return 1
 */ var $a01e56e0dfc44e02$var$MAX_NUM = Math.pow(2, 53);

});

parcelRegister("guHuk", function(module, exports) {

$parcel$export(module.exports, "createExp", function () { return $c0212e855a7e1474$export$95a576617fd015b1; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $c0212e855a7e1474$var$name = "exp";
var $c0212e855a7e1474$var$dependencies = [
    "typed"
];
var $c0212e855a7e1474$export$95a576617fd015b1 = /* #__PURE__ */ (0, $jKx4O.factory)($c0212e855a7e1474$var$name, $c0212e855a7e1474$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the exponent of a value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.exp(x)
   *
   * Examples:
   *
   *    math.exp(2)                  // returns number 7.3890560989306495
   *    math.pow(math.e, 2)          // returns number 7.3890560989306495
   *    math.log(math.exp(2))        // returns number 2
   *
   *    math.exp([1, 2, 3])
   *    // returns Array [
   *    //   2.718281828459045,
   *    //   7.3890560989306495,
   *    //   20.085536923187668
   *    // ]
   *
   * See also:
   *
   *    expm1, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to exponentiate
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ var exp = typed($c0212e855a7e1474$var$name, {
        number: (0, $cqeCl.expNumber),
        Complex: function Complex(x) {
            return x.exp();
        },
        BigNumber: function BigNumber(x) {
            return x.exp();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // TODO: exp(sparse) should return a dense matrix since exp(0)==1
            return (0, $fbkGg.deepMap)(x, exp);
        }
    });
    return exp;
});

});

parcelRegister("1mOc9", function(module, exports) {

$parcel$export(module.exports, "createExpm", function () { return $0feec834a7429e8b$export$f2c0a6357ff6cb4c; });

var $7E0JQ = parcelRequire("7E0JQ");

var $7HWRb = parcelRequire("7HWRb");

var $jKx4O = parcelRequire("jKx4O");
var $0feec834a7429e8b$var$name = "expm";
var $0feec834a7429e8b$var$dependencies = [
    "typed",
    "abs",
    "add",
    "identity",
    "inv",
    "multiply"
];
var $0feec834a7429e8b$export$f2c0a6357ff6cb4c = /* #__PURE__ */ (0, $jKx4O.factory)($0feec834a7429e8b$var$name, $0feec834a7429e8b$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, add = _ref.add, identity = _ref.identity, inv = _ref.inv, multiply = _ref.multiply;
    /**
   * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
   * Not to be confused with exp(a), which performs element-wise
   * exponentiation.
   *
   * The exponential is calculated using the Padé approximant with scaling and
   * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
   * Matrix," by Moler and Van Loan.
   *
   * Syntax:
   *
   *     math.expm(x)
   *
   * Examples:
   *
   *     const A = [[0,2],[0,0]]
   *     math.expm(A)        // returns [[1,2],[0,1]]
   *
   * See also:
   *
   *     exp
   *
   * @param {Matrix} x  A square Matrix
   * @return {Matrix}   The exponential of x
   */ return typed($0feec834a7429e8b$var$name, {
        Matrix: function Matrix(A) {
            // Check matrix size
            var size = A.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
            var n = size[0]; // Desired accuracy of the approximant (The actual accuracy
            // will be affected by round-off error)
            var eps = 1e-15; // The Padé approximant is not so accurate when the values of A
            // are "large", so scale A by powers of two. Then compute the
            // exponential, and square the result repeatedly according to
            // the identity e^A = (e^(A/m))^m
            // Compute infinity-norm of A, ||A||, to see how "big" it is
            var infNorm = infinityNorm(A); // Find the optimal scaling factor and number of terms in the
            // Padé approximant to reach the desired accuracy
            var params = findParams(infNorm, eps);
            var q = params.q;
            var j = params.j; // The Pade approximation to e^A is:
            // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
            // where
            // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
            // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
            // Scale A by 1 / 2^j
            var Apos = multiply(A, Math.pow(2, -j)); // The i=0 term is just the identity matrix
            var N = identity(n);
            var D = identity(n); // Initialization (i=0)
            var factor = 1; // Initialization (i=1)
            var AposToI = Apos; // Cloning not necessary
            var alternate = -1;
            for(var i = 1; i <= q; i++){
                if (i > 1) {
                    AposToI = multiply(AposToI, Apos);
                    alternate = -alternate;
                }
                factor = factor * (q - i + 1) / ((2 * q - i + 1) * i);
                N = add(N, multiply(factor, AposToI));
                D = add(D, multiply(factor * alternate, AposToI));
            }
            var R = multiply(inv(D), N); // Square j times
            for(var _i = 0; _i < j; _i++)R = multiply(R, R);
            return (0, $7E0JQ.isSparseMatrix)(A) ? A.createSparseMatrix(R) : R;
        }
    });
    function infinityNorm(A) {
        var n = A.size()[0];
        var infNorm = 0;
        for(var i = 0; i < n; i++){
            var rowSum = 0;
            for(var j = 0; j < n; j++)rowSum += abs(A.get([
                i,
                j
            ]));
            infNorm = Math.max(rowSum, infNorm);
        }
        return infNorm;
    }
    /**
   * Find the best parameters for the Pade approximant given
   * the matrix norm and desired accuracy. Returns the first acceptable
   * combination in order of increasing computational load.
   */ function findParams(infNorm, eps) {
        var maxSearchSize = 30;
        for(var k = 0; k < maxSearchSize; k++)for(var q = 0; q <= k; q++){
            var j = k - q;
            if (errorEstimate(infNorm, q, j) < eps) return {
                q: q,
                j: j
            };
        }
        throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
    }
    /**
   * Returns the estimated error of the Pade approximant for the given
   * parameters.
   */ function errorEstimate(infNorm, q, j) {
        var qfac = 1;
        for(var i = 2; i <= q; i++)qfac *= i;
        var twoqfac = qfac;
        for(var _i2 = q + 1; _i2 <= 2 * q; _i2++)twoqfac *= _i2;
        var twoqp1fac = twoqfac * (2 * q + 1);
        return 8.0 * Math.pow(infNorm / Math.pow(2, j), 2 * q) * qfac * qfac / (twoqfac * twoqp1fac);
    }
});

});

parcelRegister("81WsT", function(module, exports) {

$parcel$export(module.exports, "createExpm1", function () { return $5d8bc4ad68f8e8d8$export$2b203b63f664bab3; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $5d8bc4ad68f8e8d8$var$name = "expm1";
var $5d8bc4ad68f8e8d8$var$dependencies = [
    "typed",
    "Complex"
];
var $5d8bc4ad68f8e8d8$export$2b203b63f664bab3 = /* #__PURE__ */ (0, $jKx4O.factory)($5d8bc4ad68f8e8d8$var$name, $5d8bc4ad68f8e8d8$var$dependencies, function(_ref) {
    var typed = _ref.typed, _Complex = _ref.Complex;
    /**
   * Calculate the value of subtracting 1 from the exponential value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.expm1(x)
   *
   * Examples:
   *
   *    math.expm1(2)                      // returns number 6.38905609893065
   *    math.pow(math.e, 2) - 1            // returns number 6.3890560989306495
   *    math.log(math.expm1(2) + 1)        // returns number 2
   *
   *    math.expm1([1, 2, 3])
   *    // returns Array [
   *    //   1.718281828459045,
   *    //   6.3890560989306495,
   *    //   19.085536923187668
   *    // ]
   *
   * See also:
   *
   *    exp, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to apply expm1
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ var expm1 = typed($5d8bc4ad68f8e8d8$var$name, {
        number: (0, $cqeCl.expm1Number),
        Complex: function Complex(x) {
            var r = Math.exp(x.re);
            return new _Complex(r * Math.cos(x.im) - 1, r * Math.sin(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.exp().minus(1);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, expm1);
        }
    });
    return expm1;
});

});

parcelRegister("eLlye", function(module, exports) {

$parcel$export(module.exports, "createEye", function () { return $abf62c17845e0ddc$export$a261decc5e53c821; });
// TODO: function eye is removed since v5.0.0 (June 2018). Remove it some day.

var $jKx4O = parcelRequire("jKx4O");
var $abf62c17845e0ddc$export$a261decc5e53c821 = /* #__PURE__ */ (0, $jKx4O.factory)("eye", [], function() {
    return function eye() {
        throw new Error('Function "eye" is renamed to "identity" since mathjs version 5.0.0. To keep eye working, create an alias for it using "math.import({eye: math.identity}, {override: true})"');
    };
});

});

parcelRegister("3bhDy", function(module, exports) {

$parcel$export(module.exports, "createFactorial", function () { return $25101484c2ab4dd2$export$92c37ad44e3d0481; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");
var $25101484c2ab4dd2$var$name = "factorial";
var $25101484c2ab4dd2$var$dependencies = [
    "typed",
    "gamma"
];
var $25101484c2ab4dd2$export$92c37ad44e3d0481 = /* #__PURE__ */ (0, $jKx4O.factory)($25101484c2ab4dd2$var$name, $25101484c2ab4dd2$var$dependencies, function(_ref) {
    var typed = _ref.typed, gamma = _ref.gamma;
    /**
   * Compute the factorial of a value
   *
   * Factorial only supports an integer value as argument.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.factorial(n)
   *
   * Examples:
   *
   *    math.factorial(5)    // returns 120
   *    math.factorial(3)    // returns 6
   *
   * See also:
   *
   *    combinations, combinationsWithRep, gamma, permutations
   *
   * @param {number | BigNumber | Array | Matrix} n   An integer number
   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
   */ var factorial = typed($25101484c2ab4dd2$var$name, {
        number: function number(n) {
            if (n < 0) throw new Error("Value must be non-negative");
            return gamma(n + 1);
        },
        BigNumber: function BigNumber(n) {
            if (n.isNegative()) throw new Error("Value must be non-negative");
            return gamma(n.plus(1));
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $fbkGg.deepMap)(n, factorial);
        }
    });
    return factorial;
});

});

parcelRegister("keRt9", function(module, exports) {

$parcel$export(module.exports, "createFibonacciHeapClass", function () { return $ebbe9755d336d30a$export$3143a09e27a84c41; });

var $jKx4O = parcelRequire("jKx4O");
var $ebbe9755d336d30a$var$name = "FibonacciHeap";
var $ebbe9755d336d30a$var$dependencies = [
    "smaller",
    "larger"
];
var $ebbe9755d336d30a$export$3143a09e27a84c41 = /* #__PURE__ */ (0, $jKx4O.factory)($ebbe9755d336d30a$var$name, $ebbe9755d336d30a$var$dependencies, function(_ref) {
    var smaller = _ref.smaller, larger = _ref.larger;
    var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
    /**
   * Fibonacci Heap implementation, used interally for Matrix math.
   * @class FibonacciHeap
   * @constructor FibonacciHeap
   */ function FibonacciHeap() {
        if (!(this instanceof FibonacciHeap)) throw new SyntaxError("Constructor must be called with the new operator");
         // initialize fields
        this._minimum = null;
        this._size = 0;
    }
    /**
   * Attach type information
   */ FibonacciHeap.prototype.type = "FibonacciHeap";
    FibonacciHeap.prototype.isFibonacciHeap = true;
    /**
   * Inserts a new data element into the heap. No heap consolidation is
   * performed at this time, the new node is simply inserted into the root
   * list of this heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.insert = function(key, value) {
        // create node
        var node = {
            key: key,
            value: value,
            degree: 0
        }; // check we have a node in the minimum
        if (this._minimum) {
            // minimum node
            var minimum = this._minimum; // update left & right of node
            node.left = minimum;
            node.right = minimum.right;
            minimum.right = node;
            node.right.left = node; // update minimum node in heap if needed
            if (smaller(key, minimum.key)) // node has a smaller key, use it as minimum
            this._minimum = node;
        } else {
            // set left & right
            node.left = node;
            node.right = node; // this is the first node
            this._minimum = node;
        } // increment number of nodes in heap
        this._size++; // return node
        return node;
    };
    /**
   * Returns the number of nodes in heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.size = function() {
        return this._size;
    };
    /**
   * Removes all elements from this heap.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.clear = function() {
        this._minimum = null;
        this._size = 0;
    };
    /**
   * Returns true if the heap is empty, otherwise false.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.isEmpty = function() {
        return this._size === 0;
    };
    /**
   * Extracts the node with minimum key from heap. Amortized running
   * time: O(log n).
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.extractMinimum = function() {
        // node to remove
        var node = this._minimum; // check we have a minimum
        if (node === null) return node;
         // current minimum
        var minimum = this._minimum; // get number of children
        var numberOfChildren = node.degree; // pointer to the first child
        var x = node.child; // for each child of node do...
        while(numberOfChildren > 0){
            // store node in right side
            var tempRight = x.right; // remove x from child list
            x.left.right = x.right;
            x.right.left = x.left; // add x to root list of heap
            x.left = minimum;
            x.right = minimum.right;
            minimum.right = x;
            x.right.left = x; // set Parent[x] to null
            x.parent = null;
            x = tempRight;
            numberOfChildren--;
        } // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // update minimum
        if (node === node.right) // empty
        minimum = null;
        else {
            // update minimum
            minimum = node.right; // we need to update the pointer to the root with minimum key
            minimum = _findMinimumNode(minimum, this._size);
        } // decrement size of heap
        this._size--; // update minimum
        this._minimum = minimum; // return node
        return node;
    };
    /**
   * Removes a node from the heap given the reference to the node. The trees
   * in the heap will be consolidated, if necessary. This operation may fail
   * to remove the correct element if there are nodes with key value -Infinity.
   * Running time: O(log n) amortized.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.remove = function(node) {
        // decrease key value
        this._minimum = _decreaseKey(this._minimum, node, -1); // remove the smallest
        this.extractMinimum();
    };
    /**
   * Decreases the key value for a heap node, given the new value to take on.
   * The structure of the heap may be changed and will not be consolidated.
   * Running time: O(1) amortized.
   * @memberof FibonacciHeap
   */ function _decreaseKey(minimum, node, key) {
        // set node key
        node.key = key; // get parent node
        var parent = node.parent;
        if (parent && smaller(node.key, parent.key)) {
            // remove node from parent
            _cut(minimum, node, parent); // remove all nodes from parent to the root parent
            _cascadingCut(minimum, parent);
        } // update minimum node if needed
        if (smaller(node.key, minimum.key)) minimum = node;
         // return minimum
        return minimum;
    }
    /**
   * The reverse of the link operation: removes node from the child list of parent.
   * This method assumes that min is non-null. Running time: O(1).
   * @memberof FibonacciHeap
   */ function _cut(minimum, node, parent) {
        // remove node from parent children and decrement Degree[parent]
        node.left.right = node.right;
        node.right.left = node.left;
        parent.degree--; // reset y.child if necessary
        if (parent.child === node) parent.child = node.right;
         // remove child if degree is 0
        if (parent.degree === 0) parent.child = null;
         // add node to root list of heap
        node.left = minimum;
        node.right = minimum.right;
        minimum.right = node;
        node.right.left = node; // set parent[node] to null
        node.parent = null; // set mark[node] to false
        node.mark = false;
    }
    /**
   * Performs a cascading cut operation. This cuts node from its parent and then
   * does the same for its parent, and so on up the tree.
   * Running time: O(log n); O(1) excluding the recursion.
   * @memberof FibonacciHeap
   */ function _cascadingCut(minimum, node) {
        // store parent node
        var parent = node.parent; // if there's a parent...
        if (!parent) return;
         // if node is unmarked, set it marked
        if (!node.mark) node.mark = true;
        else {
            // it's marked, cut it from parent
            _cut(minimum, node, parent); // cut its parent as well
            _cascadingCut(parent);
        }
    }
    /**
   * Make the first node a child of the second one. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ var _linkNodes = function _linkNodes(node, parent) {
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // make node a Child of parent
        node.parent = parent;
        if (!parent.child) {
            parent.child = node;
            node.right = node;
            node.left = node;
        } else {
            node.left = parent.child;
            node.right = parent.child.right;
            parent.child.right = node;
            node.right.left = node;
        } // increase degree[parent]
        parent.degree++; // set mark[node] false
        node.mark = false;
    };
    function _findMinimumNode(minimum, size) {
        // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
        var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1; // create list with initial capacity
        var array = new Array(arraySize); // find the number of root nodes.
        var numRoots = 0;
        var x = minimum;
        if (x) {
            numRoots++;
            x = x.right;
            while(x !== minimum){
                numRoots++;
                x = x.right;
            }
        } // vars
        var y; // For each node in root list do...
        while(numRoots > 0){
            // access this node's degree..
            var d = x.degree; // get next node
            var next = x.right; // check if there is a node already in array with the same degree
            while(true){
                // get node with the same degree is any
                y = array[d];
                if (!y) break;
                 // make one node with the same degree a child of the other, do this based on the key value.
                if (larger(x.key, y.key)) {
                    var temp = y;
                    y = x;
                    x = temp;
                } // make y a child of x
                _linkNodes(y, x); // we have handled this degree, go to next one.
                array[d] = null;
                d++;
            } // save this node for later when we might encounter another of the same degree.
            array[d] = x; // move forward through list.
            x = next;
            numRoots--;
        } // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
        minimum = null; // loop nodes in array
        for(var i = 0; i < arraySize; i++){
            // get current node
            y = array[i];
            if (!y) continue;
             // check if we have a linked list
            if (minimum) {
                // First remove node from root list.
                y.left.right = y.right;
                y.right.left = y.left; // now add to root list, again.
                y.left = minimum;
                y.right = minimum.right;
                minimum.right = y;
                y.right.left = y; // check if this is a new min.
                if (smaller(y.key, minimum.key)) minimum = y;
            } else minimum = y;
        }
        return minimum;
    }
    return FibonacciHeap;
}, {
    isClass: true
});

});

parcelRegister("lJ23l", function(module, exports) {

$parcel$export(module.exports, "createFilter", function () { return $fd0f64a2263a500e$export$5d81789ff4aeccdf; });

var $YkZ7e = parcelRequire("YkZ7e");

var $lMDm0 = parcelRequire("lMDm0");

var $jKx4O = parcelRequire("jKx4O");
var $fd0f64a2263a500e$var$name = "filter";
var $fd0f64a2263a500e$var$dependencies = [
    "typed"
];
var $fd0f64a2263a500e$export$5d81789ff4aeccdf = /* #__PURE__ */ (0, $jKx4O.factory)($fd0f64a2263a500e$var$name, $fd0f64a2263a500e$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Filter the items in an array or one dimensional matrix.
   *
   * Syntax:
   *
   *    math.filter(x, test)
   *
   * Examples:
   *
   *    function isPositive (x) {
   *      return x > 0
   *    }
   *    math.filter([6, -2, -1, 4, 3], isPositive) // returns [6, 4, 3]
   *
   *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/) // returns ["23", "100", "55"]
   *
   * See also:
   *
   *    forEach, map, sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to filter
   * @param {Function | RegExp} test
   *        A function or regular expression to test items.
   *        All entries for which `test` returns true are returned.
   *        When `test` is a function, it is invoked with three parameters:
   *        the value of the element, the index of the element, and the
   *        matrix/array being traversed. The function must return a boolean.
   * @return {Matrix | Array} Returns the filtered matrix.
   */ return typed("filter", {
        "Array, function": $fd0f64a2263a500e$var$_filterCallback,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($fd0f64a2263a500e$var$_filterCallback(x.toArray(), test));
        },
        "Array, RegExp": (0, $YkZ7e.filterRegExp),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $YkZ7e.filterRegExp)(x.toArray(), test));
        }
    });
});
/**
 * Filter values in a callback given a callback function
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $fd0f64a2263a500e$var$_filterCallback(x, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $lMDm0.maxArgumentCount)(callback);
    return (0, $YkZ7e.filter)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        if (args === 1) return callback(value);
        else if (args === 2) return callback(value, [
            index
        ]);
        else // 3 or -1
        return callback(value, [
            index
        ], array);
    });
}

});

parcelRegister("9cYHW", function(module, exports) {

$parcel$export(module.exports, "createFix", function () { return $6b445355d79394d2$export$3ed06081b8a4ee6; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $6b445355d79394d2$var$name = "fix";
var $6b445355d79394d2$var$dependencies = [
    "typed",
    "Complex",
    "ceil",
    "floor"
];
var $6b445355d79394d2$export$3ed06081b8a4ee6 = /* #__PURE__ */ (0, $jKx4O.factory)($6b445355d79394d2$var$name, $6b445355d79394d2$var$dependencies, function(_ref) {
    var typed = _ref.typed, _Complex = _ref.Complex, ceil = _ref.ceil, floor = _ref.floor;
    /**
   * Round a value towards zero.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.fix(x)
   *
   * Examples:
   *
   *    math.fix(3.2)                // returns number 3
   *    math.fix(3.8)                // returns number 3
   *    math.fix(-4.2)               // returns number -4
   *    math.fix(-4.7)               // returns number -4
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.fix(c)                  // returns Complex 3 - 2i
   *
   *    math.fix([3.2, 3.8, -4.7])   // returns Array [3, 3, -4]
   *
   * See also:
   *
   *    ceil, floor, round
   *
   * @param {number | BigNumber | Fraction | Complex | Array | Matrix} x Number to be rounded
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}            Rounded value
   */ var fix = typed("fix", {
        number: function number(x) {
            return x > 0 ? floor(x) : ceil(x);
        },
        Complex: function Complex(x) {
            return new _Complex(x.re > 0 ? Math.floor(x.re) : Math.ceil(x.re), x.im > 0 ? Math.floor(x.im) : Math.ceil(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.isNegative() ? ceil(x) : floor(x);
        },
        Fraction: function Fraction(x) {
            return x.s < 0 ? x.ceil() : x.floor();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since fix(0) = 0
            return (0, $fbkGg.deepMap)(x, fix, true);
        }
    });
    return fix;
});

});

parcelRegister("7viTB", function(module, exports) {

$parcel$export(module.exports, "createFlatten", function () { return $576a15f838a03afc$export$107988e3ee9f3d12; });

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $576a15f838a03afc$var$name = "flatten";
var $576a15f838a03afc$var$dependencies = [
    "typed",
    "matrix"
];
var $576a15f838a03afc$export$107988e3ee9f3d12 = /* #__PURE__ */ (0, $jKx4O.factory)($576a15f838a03afc$var$name, $576a15f838a03afc$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    /**
   * Flatten a multi dimensional matrix into a single dimensional matrix.
   *
   * Syntax:
   *
   *    math.flatten(x)
   *
   * Examples:
   *
   *    math.flatten([[1,2], [3,4]])   // returns [1, 2, 3, 4]
   *
   * See also:
   *
   *    concat, resize, size, squeeze
   *
   * @param {Matrix | Array} x   Matrix to be flattened
   * @return {Matrix | Array} Returns the flattened matrix
   */ return typed($576a15f838a03afc$var$name, {
        Array: function Array(x) {
            return (0, $YkZ7e.flatten)((0, $glBd7.clone)(x));
        },
        Matrix: function Matrix(x) {
            var flat = (0, $YkZ7e.flatten)((0, $glBd7.clone)(x.toArray())); // TODO: return the same matrix type as x
            return matrix(flat);
        }
    });
});

});

parcelRegister("bXg5b", function(module, exports) {

$parcel$export(module.exports, "createFloor", function () { return $8b41ae0ab7252791$export$e04e4803a9128c9b; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");

var $9zoJy = parcelRequire("9zoJy");
var $8b41ae0ab7252791$var$name = "floor";
var $8b41ae0ab7252791$var$dependencies = [
    "typed",
    "config",
    "round"
];
var $8b41ae0ab7252791$export$e04e4803a9128c9b = /* #__PURE__ */ (0, $jKx4O.factory)($8b41ae0ab7252791$var$name, $8b41ae0ab7252791$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, round = _ref.round;
    /**
   * Round a value towards minus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.floor(x)
   *
   * Examples:
   *
   *    math.floor(3.2)              // returns number 3
   *    math.floor(3.8)              // returns number 3
   *    math.floor(-4.2)             // returns number -5
   *    math.floor(-4.7)             // returns number -5
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.floor(c)                // returns Complex 3 - 3i
   *
   *    math.floor([3.2, 3.8, -4.7]) // returns Array [3, 3, -5]
   *
   * See also:
   *
   *    ceil, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ var floor = typed("floor", {
        number: function number(x) {
            if ((0, $5wlxr.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return Math.floor(x);
        },
        Complex: function Complex(x) {
            return x.floor();
        },
        BigNumber: function BigNumber(x) {
            if ((0, $9zoJy.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return x.floor();
        },
        Fraction: function Fraction(x) {
            return x.floor();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since floor(0) = 0
            return (0, $fbkGg.deepMap)(x, floor, true);
        }
    });
    return floor;
});

});

parcelRegister("8jGAN", function(module, exports) {

$parcel$export(module.exports, "createForEach", function () { return $60e123098b101dc5$export$a5218987e0811e05; });

var $lMDm0 = parcelRequire("lMDm0");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $60e123098b101dc5$var$name = "forEach";
var $60e123098b101dc5$var$dependencies = [
    "typed"
];
var $60e123098b101dc5$export$a5218987e0811e05 = /* #__PURE__ */ (0, $jKx4O.factory)($60e123098b101dc5$var$name, $60e123098b101dc5$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Iterate over all elements of a matrix/array, and executes the given callback function.
   *
   * Syntax:
   *
   *    math.forEach(x, callback)
   *
   * Examples:
   *
   *    math.forEach([1, 2, 3], function(value) {
   *      console.log(value)
   *    })
   *    // outputs 1, 2, 3
   *
   * See also:
   *
   *    filter, map, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix/array being traversed.
   */ return typed($60e123098b101dc5$var$name, {
        "Array, function": $60e123098b101dc5$var$_forEach,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.forEach(callback);
        }
    });
});
/**
 * forEach for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @private
 */ function $60e123098b101dc5$var$_forEach(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $lMDm0.maxArgumentCount)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) (0, $YkZ7e.forEach)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            recurse(child, index.concat(i));
        });
        else {
            // invoke the callback function with the right number of arguments
            if (args === 1) callback(value);
            else if (args === 2) callback(value, index);
            else // 3 or -1
            callback(value, index, array);
        }
    };
    recurse(array, []);
}

});

parcelRegister("8RcKt", function(module, exports) {

$parcel$export(module.exports, "createFormat", function () { return $672d29925c739237$export$abf0d9399b60f9bb; });

var $7HWRb = parcelRequire("7HWRb");

var $jKx4O = parcelRequire("jKx4O");
var $672d29925c739237$var$name = "format";
var $672d29925c739237$var$dependencies = [
    "typed"
];
var $672d29925c739237$export$abf0d9399b60f9bb = /* #__PURE__ */ (0, $jKx4O.factory)($672d29925c739237$var$name, $672d29925c739237$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Format a value of any type into a string.
   *
   * Syntax:
   *
   *    math.format(value)
   *    math.format(value, options)
   *    math.format(value, precision)
   *    math.format(value, callback)
   *
   * Where:
   *
   *  - `value: *`
   *    The value to be formatted
   *  - `options: Object`
   *    An object with formatting options. Available options:
   *    - `notation: string`
   *      Number notation. Choose from:
   *      - 'fixed'
   *        Always use regular number notation.
   *        For example '123.40' and '14000000'
   *      - 'exponential'
   *        Always use exponential notation.
   *        For example '1.234e+2' and '1.4e+7'
   *      - 'engineering'
   *        Always use engineering notation: always have exponential notation,
   *        and select the exponent to be a multiple of 3.
   *        For example '123.4e+0' and '14.0e+6'
   *      - 'auto' (default)
   *        Regular number notation for numbers having an absolute value between
   *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
   *        Lower bound is included, upper bound is excluded.
   *        For example '123.4' and '1.4e7'.
   *    - `precision: number`
   *      A number between 0 and 16 to round the digits of the number. In case
   *      of notations 'exponential', 'engineering', and 'auto', `precision`
   *      defines the total number of significant digits returned.
   *      In case of notation 'fixed', `precision` defines the number of
   *      significant digits after the decimal point.
   *      `precision` is undefined by default.
   *    - `lowerExp: number`
   *      Exponent determining the lower boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `-3`.
   *    - `upperExp: number`
   *      Exponent determining the upper boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `5`.
   *    - `fraction: string`. Available values: 'ratio' (default) or 'decimal'.
   *      For example `format(fraction(1, 3))` will output '1/3' when 'ratio' is
   *      configured, and will output `0.(3)` when 'decimal' is configured.
   * - `callback: function`
   *   A custom formatting function, invoked for all numeric elements in `value`,
   *   for example all elements of a matrix, or the real and imaginary
   *   parts of a complex number. This callback can be used to override the
   *   built-in numeric notation with any type of formatting. Function `callback`
   *   is called with `value` as parameter and must return a string.
   *
   * When `value` is an Object:
   *
   * - When the object contains a property `format` being a function, this function
   *   is invoked as `value.format(options)` and the result is returned.
   * - When the object has its own `toString` method, this method is invoked
   *   and the result is returned.
   * - In other cases the function will loop over all object properties and
   *   return JSON object notation like '{"a": 2, "b": 3}'.
   *
   * When value is a function:
   *
   * - When the function has a property `syntax`, it returns this
   *   syntax description.
   * - In other cases, a string `'function'` is returned.
   *
   * Examples:
   *
   *    math.format(6.4)                                        // returns '6.4'
   *    math.format(1240000)                                    // returns '1.24e6'
   *    math.format(1/3)                                        // returns '0.3333333333333333'
   *    math.format(1/3, 3)                                     // returns '0.333'
   *    math.format(21385, 2)                                   // returns '21000'
   *    math.format(12e8, {notation: 'fixed'})                  // returns '1200000000'
   *    math.format(2.3,  {notation: 'fixed', precision: 4})    // returns '2.3000'
   *    math.format(52.8, {notation: 'exponential'})            // returns '5.28e+1'
   *    math.format(12400,{notation: 'engineering'})            // returns '12.400e+3'
   *    math.format(2000, {lowerExp: -2, upperExp: 2})          // returns '2e+3'
   *
   *    function formatCurrency(value) {
   *      // return currency notation with two digits:
   *      return '$' + value.toFixed(2)
   *
   *      // you could also use math.format inside the callback:
   *      // return '$' + math.format(value, {notation: 'fixed', precision: 2})
   *    }
   *    math.format([2.1, 3, 0.016], formatCurrency}            // returns '[$2.10, $3.00, $0.02]'
   *
   * See also:
   *
   *    print
   *
   * @param {*} value                               Value to be stringified
   * @param {Object | Function | number} [options]  Formatting options
   * @return {string} The formatted value
   */ return typed($672d29925c739237$var$name, {
        any: (0, $7HWRb.format),
        "any, Object | function | number": (0, $7HWRb.format)
    });
});

});

parcelRegister("l6sW2", function(module, exports) {

$parcel$export(module.exports, "createFraction", function () { return $f5d09a70c203d4eb$export$de147ca8498e0312; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $f5d09a70c203d4eb$var$name = "fraction";
var $f5d09a70c203d4eb$var$dependencies = [
    "typed",
    "Fraction"
];
var $f5d09a70c203d4eb$export$de147ca8498e0312 = /* #__PURE__ */ (0, $jKx4O.factory)($f5d09a70c203d4eb$var$name, $f5d09a70c203d4eb$var$dependencies, function(_ref) {
    var typed = _ref.typed, Fraction = _ref.Fraction;
    /**
   * Create a fraction convert a value to a fraction.
   *
   * Syntax:
   *     math.fraction(numerator, denominator)
   *     math.fraction({n: numerator, d: denominator})
   *     math.fraction(matrix: Array | Matrix)         Turn all matrix entries
   *                                                   into fractions
   *
   * Examples:
   *
   *     math.fraction(1, 3)
   *     math.fraction('2/3')
   *     math.fraction({n: 2, d: 3})
   *     math.fraction([0.2, 0.25, 1.25])
   *
   * See also:
   *
   *    bignumber, number, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
   *            Arguments specifying the numerator and denominator of
   *            the fraction
   * @return {Fraction | Array | Matrix} Returns a fraction
   */ var fraction = typed("fraction", {
        number: function number(x) {
            if (!isFinite(x) || isNaN(x)) throw new Error(x + " cannot be represented as a fraction");
            return new Fraction(x);
        },
        string: function string(x) {
            return new Fraction(x);
        },
        "number, number": function numberNumber(numerator, denominator) {
            return new Fraction(numerator, denominator);
        },
        "null": function _null(x) {
            return new Fraction(0);
        },
        BigNumber: function BigNumber(x) {
            return new Fraction(x.toString());
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Object: function Object(x) {
            return new Fraction(x);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, fraction);
        }
    });
    return fraction;
});

});

parcelRegister("6LZeM", function(module, exports) {

$parcel$export(module.exports, "createFractionClass", function () { return $4ee6a25769e5a22c$export$c317f082100fca89; });

var $i1yAV = parcelRequire("i1yAV");

var $jKx4O = parcelRequire("jKx4O");
var $4ee6a25769e5a22c$var$name = "Fraction";
var $4ee6a25769e5a22c$var$dependencies = [];
var $4ee6a25769e5a22c$export$c317f082100fca89 = /* #__PURE__ */ (0, $jKx4O.factory)($4ee6a25769e5a22c$var$name, $4ee6a25769e5a22c$var$dependencies, function() {
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($i1yAV))).prototype.type = "Fraction";
    (0, (/*@__PURE__*/$parcel$interopDefault($i1yAV))).prototype.isFraction = true;
    /**
   * Get a JSON representation of a Fraction containing type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Fraction", "n": 3, "d": 8}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($i1yAV))).prototype.toJSON = function() {
        return {
            mathjs: "Fraction",
            n: this.s * this.n,
            d: this.d
        };
    };
    /**
   * Instantiate a Fraction from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "Fraction", "n": 3, "d": 8}`
   * @return {BigNumber}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($i1yAV))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($i1yAV)))(json);
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($i1yAV));
}, {
    isClass: true
});

});
parcelRegister("i1yAV", function(module, exports) {
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <numerator>, 1 => <denominator> ]
 * [ n => <numerator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */ (function(root) {
    "use strict";
    // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
    // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
    // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
    var MAX_CYCLE_LEN = 2000;
    // Parsed data to avoid calling "new" all the time
    var P = {
        "s": 1,
        "n": 0,
        "d": 1
    };
    function assign(n, s) {
        if (isNaN(n = parseInt(n, 10))) throw InvalidParameter();
        return n * s;
    }
    // Creates a new Fraction internally without the need of the bulky constructor
    function newFraction(n, d) {
        if (d === 0) throw DivisionByZero();
        var f = Object.create(Fraction.prototype);
        f["s"] = n < 0 ? -1 : 1;
        n = n < 0 ? -n : n;
        var a = gcd(n, d);
        f["n"] = n / a;
        f["d"] = d / a;
        return f;
    }
    function factorize(num) {
        var factors = {};
        var n = num;
        var i = 2;
        var s = 4;
        while(s <= n){
            while(n % i === 0){
                n /= i;
                factors[i] = (factors[i] || 0) + 1;
            }
            s += 1 + 2 * i++;
        }
        if (n !== num) {
            if (n > 1) factors[n] = (factors[n] || 0) + 1;
        } else factors[num] = (factors[num] || 0) + 1;
        return factors;
    }
    var parse = function(p1, p2) {
        var n = 0, d = 1, s = 1;
        var v = 0, w = 0, x = 0, y = 1, z = 1;
        var A = 0, B = 1;
        var C = 1, D = 1;
        var N = 10000000;
        var M;
        if (p1 === undefined || p1 === null) ;
        else if (p2 !== undefined) {
            n = p1;
            d = p2;
            s = n * d;
            if (n % 1 !== 0 || d % 1 !== 0) throw NonIntegerParameter();
        } else switch(typeof p1){
            case "object":
                if ("d" in p1 && "n" in p1) {
                    n = p1["n"];
                    d = p1["d"];
                    if ("s" in p1) n *= p1["s"];
                } else if (0 in p1) {
                    n = p1[0];
                    if (1 in p1) d = p1[1];
                } else throw InvalidParameter();
                s = n * d;
                break;
            case "number":
                if (p1 < 0) {
                    s = p1;
                    p1 = -p1;
                }
                if (p1 % 1 === 0) n = p1;
                else if (p1 > 0) {
                    if (p1 >= 1) {
                        z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
                        p1 /= z;
                    }
                    // Using Farey Sequences
                    // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/
                    while(B <= N && D <= N){
                        M = (A + C) / (B + D);
                        if (p1 === M) {
                            if (B + D <= N) {
                                n = A + C;
                                d = B + D;
                            } else if (D > B) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                            break;
                        } else {
                            if (p1 > M) {
                                A += C;
                                B += D;
                            } else {
                                C += A;
                                D += B;
                            }
                            if (B > N) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                        }
                    }
                    n *= z;
                } else if (isNaN(p1) || isNaN(p2)) d = n = NaN;
                break;
            case "string":
                B = p1.match(/\d+|./g);
                if (B === null) throw InvalidParameter();
                if (B[A] === "-") {
                    s = -1;
                    A++;
                } else if (B[A] === "+") A++;
                if (B.length === A + 1) w = assign(B[A++], s);
                else if (B[A + 1] === "." || B[A] === ".") {
                    if (B[A] !== ".") v = assign(B[A++], s);
                    A++;
                    // Check for decimal places
                    if (A + 1 === B.length || B[A + 1] === "(" && B[A + 3] === ")" || B[A + 1] === "'" && B[A + 3] === "'") {
                        w = assign(B[A], s);
                        y = Math.pow(10, B[A].length);
                        A++;
                    }
                    // Check for repeating places
                    if (B[A] === "(" && B[A + 2] === ")" || B[A] === "'" && B[A + 2] === "'") {
                        x = assign(B[A + 1], s);
                        z = Math.pow(10, B[A + 1].length) - 1;
                        A += 3;
                    }
                } else if (B[A + 1] === "/" || B[A + 1] === ":") {
                    w = assign(B[A], s);
                    y = assign(B[A + 2], 1);
                    A += 3;
                } else if (B[A + 3] === "/" && B[A + 1] === " ") {
                    v = assign(B[A], s);
                    w = assign(B[A + 2], s);
                    y = assign(B[A + 4], 1);
                    A += 5;
                }
                if (B.length <= A) {
                    d = y * z;
                    s = /* void */ n = x + d * v + z * w;
                    break;
                }
            default:
                throw InvalidParameter();
        }
        if (d === 0) throw DivisionByZero();
        P["s"] = s < 0 ? -1 : 1;
        P["n"] = Math.abs(n);
        P["d"] = Math.abs(d);
    };
    function modpow(b, e, m) {
        var r = 1;
        for(; e > 0; b = b * b % m, e >>= 1)if (e & 1) r = r * b % m;
        return r;
    }
    function cycleLen(n, d) {
        for(; d % 2 === 0; d /= 2);
        for(; d % 5 === 0; d /= 5);
        if (d === 1) return 0;
        // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
        // 10^(d-1) % d == 1
        // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
        // as we want to translate the numbers to strings.
        var rem = 10 % d;
        var t = 1;
        for(; rem !== 1; t++){
            rem = rem * 10 % d;
            if (t > MAX_CYCLE_LEN) return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
        }
        return t;
    }
    function cycleStart(n, d, len) {
        var rem1 = 1;
        var rem2 = modpow(10, len, d);
        for(var t = 0; t < 300; t++){
            // Solve 10^s == 10^(s+t) (mod d)
            if (rem1 === rem2) return t;
            rem1 = rem1 * 10 % d;
            rem2 = rem2 * 10 % d;
        }
        return 0;
    }
    function gcd(a, b) {
        if (!a) return b;
        if (!b) return a;
        while(true){
            a %= b;
            if (!a) return b;
            b %= a;
            if (!b) return a;
        }
    }
    /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */ function Fraction(a, b) {
        parse(a, b);
        if (this instanceof Fraction) {
            a = gcd(P["d"], P["n"]); // Abuse variable a
            this["s"] = P["s"];
            this["n"] = P["n"] / a;
            this["d"] = P["d"] / a;
        } else return newFraction(P["s"] * P["n"], P["d"]);
    }
    var DivisionByZero = function() {
        return new Error("Division by Zero");
    };
    var InvalidParameter = function() {
        return new Error("Invalid argument");
    };
    var NonIntegerParameter = function() {
        return new Error("Parameters must be integer");
    };
    Fraction.prototype = {
        "s": 1,
        "n": 0,
        "d": 1,
        /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/ "abs": function() {
            return newFraction(this["n"], this["d"]);
        },
        /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/ "neg": function() {
            return newFraction(-this["s"] * this["n"], this["d"]);
        },
        /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/ "add": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/ "sub": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/ "mul": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/ "div": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["d"], this["d"] * P["n"]);
        },
        /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/ "clone": function() {
            return newFraction(this["s"] * this["n"], this["d"]);
        },
        /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/ "mod": function(a, b) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            if (a === undefined) return newFraction(this["s"] * this["n"] % this["d"], 1);
            parse(a, b);
            if (0 === P["n"] && 0 === this["d"]) throw DivisionByZero();
            /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/ /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */ return newFraction(this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */ "gcd": function(a, b) {
            parse(a, b);
            // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)
            return newFraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */ "lcm": function(a, b) {
            parse(a, b);
            // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)
            if (P["n"] === 0 && this["n"] === 0) return newFraction(0, 1);
            return newFraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
        },
        /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/ "floor": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/ "round": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational number to a multiple of another rational number
     *
     * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
     **/ "roundTo": function(a, b) {
            /*
      k * x/y ≤ a/b < (k+1) * x/y
      ⇔ k ≤ a/b / (x/y) < (k+1)
      ⇔ k = floor(a/b * y/x)
      */ parse(a, b);
            return newFraction(this["s"] * Math.round(this["n"] * P["d"] / (this["d"] * P["n"])) * P["n"], P["d"]);
        },
        /**
     * Gets the inverse of the fraction, means numerator and denominator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/ "inverse": function() {
            return newFraction(this["s"] * this["d"], this["n"]);
        },
        /**
     * Calculates the fraction to some rational exponent, if possible
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */ "pow": function(a, b) {
            parse(a, b);
            // Trivial case when exp is an integer
            if (P["d"] === 1) {
                if (P["s"] < 0) return newFraction(Math.pow(this["s"] * this["d"], P["n"]), Math.pow(this["n"], P["n"]));
                else return newFraction(Math.pow(this["s"] * this["n"], P["n"]), Math.pow(this["d"], P["n"]));
            }
            // Negative roots become complex
            //     (-a/b)^(c/d) = x
            // <=> (-1)^(c/d) * (a/b)^(c/d) = x
            // <=> (cos(pi) + i*sin(pi))^(c/d) * (a/b)^(c/d) = x         # rotate 1 by 180°
            // <=> (cos(c*pi/d) + i*sin(c*pi/d)) * (a/b)^(c/d) = x       # DeMoivre's formula in Q ( https://proofwiki.org/wiki/De_Moivre%27s_Formula/Rational_Index )
            // From which follows that only for c=0 the root is non-complex. c/d is a reduced fraction, so that sin(c/dpi)=0 occurs for d=1, which is handled by our trivial case.
            if (this["s"] < 0) return null;
            // Now prime factor n and d
            var N = factorize(this["n"]);
            var D = factorize(this["d"]);
            // Exponentiate and take root for n and d individually
            var n = 1;
            var d = 1;
            for(var k in N){
                if (k === "1") continue;
                if (k === "0") {
                    n = 0;
                    break;
                }
                N[k] *= P["n"];
                if (N[k] % P["d"] === 0) N[k] /= P["d"];
                else return null;
                n *= Math.pow(k, N[k]);
            }
            for(var k in D){
                if (k === "1") continue;
                D[k] *= P["n"];
                if (D[k] % P["d"] === 0) D[k] /= P["d"];
                else return null;
                d *= Math.pow(k, D[k]);
            }
            if (P["s"] < 0) return newFraction(d, n);
            return newFraction(n, d);
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "equals": function(a, b) {
            parse(a, b);
            return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "compare": function(a, b) {
            parse(a, b);
            var t = this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"];
            return (0 < t) - (t < 0);
        },
        "simplify": function(eps) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return this;
            eps = eps || 0.001;
            var thisABS = this["abs"]();
            var cont = thisABS["toContinued"]();
            for(var i = 1; i < cont.length; i++){
                var s = newFraction(cont[i - 1], 1);
                for(var k = i - 2; k >= 0; k--)s = s["inverse"]()["add"](cont[k]);
                if (Math.abs(s["sub"](thisABS).valueOf()) < eps) return s["mul"](this["s"]);
            }
            return this;
        },
        /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */ "divisible": function(a, b) {
            parse(a, b);
            return !(!(P["n"] * this["d"]) || this["n"] * P["d"] % (P["n"] * this["d"]));
        },
        /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/ "valueOf": function() {
            return this["s"] * this["n"] / this["d"];
        },
        /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
     **/ "toFraction": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    str += " ";
                    n %= d;
                }
                str += n;
                str += "/";
                str += d;
            }
            return str;
        },
        /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/ "toLatex": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    n %= d;
                }
                str += "\\frac{";
                str += n;
                str += "}{";
                str += d;
                str += "}";
            }
            return str;
        },
        /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */ "toContinued": function() {
            var t;
            var a = this["n"];
            var b = this["d"];
            var res = [];
            if (isNaN(a) || isNaN(b)) return res;
            do {
                res.push(Math.floor(a / b));
                t = a % b;
                a = b;
                b = t;
            }while (a !== 1);
            return res;
        },
        /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/ "toString": function(dec) {
            var N = this["n"];
            var D = this["d"];
            if (isNaN(N) || isNaN(D)) return "NaN";
            dec = dec || 15; // 15 = decimal places when no repetation
            var cycLen = cycleLen(N, D); // Cycle length
            var cycOff = cycleStart(N, D, cycLen); // Cycle start
            var str = this["s"] < 0 ? "-" : "";
            str += N / D | 0;
            N %= D;
            N *= 10;
            if (N) str += ".";
            if (cycLen) {
                for(var i = cycOff; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += "(";
                for(var i = cycLen; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += ")";
            } else for(var i = dec; N && i--;){
                str += N / D | 0;
                N %= D;
                N *= 10;
            }
            return str;
        }
    };
    Object.defineProperty(module.exports, "__esModule", {
        "value": true
    });
    module.exports["default"] = Fraction;
    module.exports = Fraction;
})(module.exports);

});


parcelRegister("hpXJy", function(module, exports) {

$parcel$export(module.exports, "createGamma", function () { return $cae31b5ef9e40794$export$115da31fc3cf3d15; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $02i9h = parcelRequire("02i9h");
var $cae31b5ef9e40794$var$name = "gamma";
var $cae31b5ef9e40794$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "pow",
    "BigNumber",
    "Complex"
];
var $cae31b5ef9e40794$export$115da31fc3cf3d15 = /* #__PURE__ */ (0, $jKx4O.factory)($cae31b5ef9e40794$var$name, $cae31b5ef9e40794$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, multiplyScalar = _ref.multiplyScalar, pow = _ref.pow, _BigNumber = _ref.BigNumber, _Complex = _ref.Complex;
    /**
   * Compute the gamma function of a value using Lanczos approximation for
   * small values, and an extended Stirling approximation for large values.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gamma(n)
   *
   * Examples:
   *
   *    math.gamma(5)       // returns 24
   *    math.gamma(-0.5)    // returns -3.5449077018110335
   *    math.gamma(math.i)  // returns -0.15494982830180973 - 0.49801566811835596i
   *
   * See also:
   *
   *    combinations, factorial, permutations
   *
   * @param {number | Array | Matrix} n   A real or complex number
   * @return {number | Array | Matrix}    The gamma of `n`
   */ var gamma = typed($cae31b5ef9e40794$var$name, {
        number: (0, $02i9h.gammaNumber),
        Complex: function Complex(n) {
            if (n.im === 0) return gamma(n.re);
            n = new _Complex(n.re - 1, n.im);
            var x = new _Complex((0, $02i9h.gammaP)[0], 0);
            for(var i = 1; i < (0, $02i9h.gammaP).length; ++i){
                var real = n.re + i; // x += p[i]/(n+i)
                var den = real * real + n.im * n.im;
                if (den !== 0) {
                    x.re += (0, $02i9h.gammaP)[i] * real / den;
                    x.im += -((0, $02i9h.gammaP)[i] * n.im) / den;
                } else x.re = (0, $02i9h.gammaP)[i] < 0 ? -Infinity : Infinity;
            }
            var t = new _Complex(n.re + (0, $02i9h.gammaG) + 0.5, n.im);
            var twoPiSqrt = Math.sqrt(2 * Math.PI);
            n.re += 0.5;
            var result = pow(t, n);
            if (result.im === 0) // sqrt(2*PI)*result
            result.re *= twoPiSqrt;
            else if (result.re === 0) result.im *= twoPiSqrt;
            else {
                result.re *= twoPiSqrt;
                result.im *= twoPiSqrt;
            }
            var r = Math.exp(-t.re); // exp(-t)
            t.re = r * Math.cos(-t.im);
            t.im = r * Math.sin(-t.im);
            return multiplyScalar(multiplyScalar(result, t), x);
        },
        BigNumber: function BigNumber(n) {
            if (n.isInteger()) return n.isNegative() || n.isZero() ? new _BigNumber(Infinity) : bigFactorial(n.minus(1));
            if (!n.isFinite()) return new _BigNumber(n.isNegative() ? NaN : Infinity);
            throw new Error("Integer BigNumber expected");
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $fbkGg.deepMap)(n, gamma);
        }
    });
    /**
   * Calculate factorial for a BigNumber
   * @param {BigNumber} n
   * @returns {BigNumber} Returns the factorial of n
   */ function bigFactorial(n) {
        if (n < 8) return new _BigNumber([
            1,
            1,
            2,
            6,
            24,
            120,
            720,
            5040
        ][n]);
        var precision = config.precision + (Math.log(n.toNumber()) | 0);
        var Big = _BigNumber.clone({
            precision: precision
        });
        if (n % 2 === 1) return n.times(bigFactorial(new _BigNumber(n - 1)));
        var p = n;
        var prod = new Big(n);
        var sum = n.toNumber();
        while(p > 2){
            p -= 2;
            sum += p;
            prod = prod.times(sum);
        }
        return new _BigNumber(prod.toPrecision(_BigNumber.precision));
    }
    return gamma;
});

});
parcelRegister("02i9h", function(module, exports) {

$parcel$export(module.exports, "gammaNumber", function () { return $006e43f2abfff46f$export$da03a9f23c941fae; });
$parcel$export(module.exports, "gammaP", function () { return $006e43f2abfff46f$export$4ef5d09c80bf8d89; });
$parcel$export(module.exports, "gammaG", function () { return $006e43f2abfff46f$export$c1392abb9fefd3b6; });

var $5wlxr = parcelRequire("5wlxr");

var $5qRPl = parcelRequire("5qRPl");
function $006e43f2abfff46f$export$da03a9f23c941fae(n) {
    var x;
    if ((0, $5wlxr.isInteger)(n)) {
        if (n <= 0) return isFinite(n) ? Infinity : NaN;
        if (n > 171) return Infinity; // Will overflow
        return (0, $5qRPl.product)(1, n - 1);
    }
    if (n < 0.5) return Math.PI / (Math.sin(Math.PI * n) * $006e43f2abfff46f$export$da03a9f23c941fae(1 - n));
    if (n >= 171.35) return Infinity; // will overflow
    if (n > 85.0) {
        // Extended Stirling Approx
        var twoN = n * n;
        var threeN = twoN * n;
        var fourN = threeN * n;
        var fiveN = fourN * n;
        return Math.sqrt(2 * Math.PI / n) * Math.pow(n / Math.E, n) * (1 + 1 / (12 * n) + 1 / (288 * twoN) - 139 / (51840 * threeN) - 571 / (2488320 * fourN) + 163879 / (209018880 * fiveN) + 5246819 / (75246796800 * fiveN * n));
    }
    --n;
    x = $006e43f2abfff46f$export$4ef5d09c80bf8d89[0];
    for(var i = 1; i < $006e43f2abfff46f$export$4ef5d09c80bf8d89.length; ++i)x += $006e43f2abfff46f$export$4ef5d09c80bf8d89[i] / (n + i);
    var t = n + $006e43f2abfff46f$export$c1392abb9fefd3b6 + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
}
$006e43f2abfff46f$export$da03a9f23c941fae.signature = "number"; // TODO: comment on the variables g and p
var $006e43f2abfff46f$export$c1392abb9fefd3b6 = 4.7421875;
var $006e43f2abfff46f$export$4ef5d09c80bf8d89 = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
];

});


parcelRegister("jDeCi", function(module, exports) {

$parcel$export(module.exports, "createGcd", function () { return $e4acff6b8b5f6c5a$export$2eb8acc96c598512; });

var $jKx4O = parcelRequire("jKx4O");

var $9vlUQ = parcelRequire("9vlUQ");

var $5JY23 = parcelRequire("5JY23");

var $fs8LR = parcelRequire("fs8LR");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $cqeCl = parcelRequire("cqeCl");
var $e4acff6b8b5f6c5a$var$name = "gcd";
var $e4acff6b8b5f6c5a$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix"
];
var $e4acff6b8b5f6c5a$export$2eb8acc96c598512 = /* #__PURE__ */ (0, $jKx4O.factory)($e4acff6b8b5f6c5a$var$name, $e4acff6b8b5f6c5a$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, BigNumber = _ref.BigNumber, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $9vlUQ.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $5JY23.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $fs8LR.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the greatest common divisor for two or more values or arrays.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gcd(a, b)
   *    math.gcd(a, b, c, ...)
   *
   * Examples:
   *
   *    math.gcd(8, 12)              // returns 4
   *    math.gcd(-4, 6)              // returns 2
   *    math.gcd(25, 15, -10)        // returns 5
   *
   *    math.gcd([8, -4], [12, 6])   // returns [4, 2]
   *
   * See also:
   *
   *    lcm, xgcd
   *
   * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
   */ var gcd = typed($e4acff6b8b5f6c5a$var$name, {
        "number, number": (0, $cqeCl.gcdNumber),
        "BigNumber, BigNumber": _gcdBigNumber,
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.gcd(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, gcd);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, gcd, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, gcd, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, gcd);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return gcd(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return gcd(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return gcd(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm10(x, y, gcd, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, gcd, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            return algorithm10(y, x, gcd, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, gcd, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, gcd, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, gcd, true).valueOf();
        },
        // TODO: need a smarter notation here
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = gcd(a, b);
            for(var i = 0; i < args.length; i++)res = gcd(res, args[i]);
            return res;
        }
    });
    return gcd;
    /**
   * Calculate gcd for BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns greatest common denominator of a and b
   * @private
   */ function _gcdBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function gcd must be integer numbers");
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var zero = new BigNumber(0);
        while(!b.isZero()){
            var r = a.mod(b);
            a = b;
            b = r;
        }
        return a.lt(zero) ? a.neg() : a;
    }
});

});

parcelRegister("lzogn", function(module, exports) {

$parcel$export(module.exports, "createGetMatrixDataType", function () { return $fb3fb00832c4cdfd$export$b83055c9a38abe3c; });

var $jKx4O = parcelRequire("jKx4O");

var $YkZ7e = parcelRequire("YkZ7e");

var $7E0JQ = parcelRequire("7E0JQ");
var $fb3fb00832c4cdfd$var$name = "getMatrixDataType";
var $fb3fb00832c4cdfd$var$dependencies = [
    "typed"
];
var $fb3fb00832c4cdfd$export$b83055c9a38abe3c = /* #__PURE__ */ (0, $jKx4O.factory)($fb3fb00832c4cdfd$var$name, $fb3fb00832c4cdfd$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Find the data type of all elements in a matrix or array,
   * for example 'number' if all items are a number and 'Complex' if all values
   * are complex numbers.
   * If a matrix contains more than one data type, it will return 'mixed'.
   *
   * Syntax:
   *
   *    math.getMatrixDataType(x)
   *
   * Examples:
   *
   *    const x = [ [1, 2, 3], [4, 5, 6] ]
   *    const mixedX = [ [1, true], [2, 3] ]
   *    const fractionX = [ [math.fraction(1, 3)], [math.fraction(1, 3] ]
   *    const unitX = [ [math.unit('5cm')], [math.unit('5cm')] ]
   *    const bigNumberX = [ [math.bignumber(1)], [math.bignumber(0)] ]
   *    const sparse = math.sparse(x)
   *    const dense = math.matrix(x)
   *    math.getMatrixDataType(x)   // returns 'number'
   *    math.getMatrixDataType(sparse)   // returns 'number'
   *    math.getMatrixDataType(dense)   // returns 'number'
   *    math.getMatrixDataType(mixedX) // returns 'mixed'
   *    math.getMatrixDataType(fractionX) // returns 'Fraction'
   *    math.getMatrixDataType(unitX) // returns 'Unit'
   *    math.getMatrixDataType(bigNumberX) // return 'BigNumber'
   *
   * See also:
   *  SparseMatrix, DenseMatrix
   *
   * @param {...Matrix | Array} x   The Matrix with values.
   *
   * @return {string} A string representation of the matrix type
   */ return typed($fb3fb00832c4cdfd$var$name, {
        Array: function Array(x) {
            return (0, $YkZ7e.getArrayDataType)(x, (0, $7E0JQ.typeOf));
        },
        Matrix: function Matrix(x) {
            return x.getDataType();
        }
    });
});

});

parcelRegister("2P7IC", function(module, exports) {

$parcel$export(module.exports, "createHasNumericValue", function () { return $20e654f3593a1dfb$export$acff9f91b891ace6; });

var $jKx4O = parcelRequire("jKx4O");
var $20e654f3593a1dfb$var$name = "hasNumericValue";
var $20e654f3593a1dfb$var$dependencies = [
    "typed",
    "isNumeric"
];
var $20e654f3593a1dfb$export$acff9f91b891ace6 = /* #__PURE__ */ (0, $jKx4O.factory)($20e654f3593a1dfb$var$name, $20e654f3593a1dfb$var$dependencies, function(_ref) {
    var typed = _ref.typed, isNumeric = _ref.isNumeric;
    /**
   * Test whether a value is an numeric value.
   *
   * In case of a string, true is returned if the string contains a numeric value.
   *
   * Syntax:
   *
   *     math.hasNumericValue(x)
   *
   * Examples:
   *
   *    math.hasNumericValue(2)                     // returns true
   *    math.hasNumericValue('2')                   // returns true
   *    math.isNumeric('2')                         // returns false
   *    math.hasNumericValue(0)                     // returns true
   *    math.hasNumericValue(math.bignumber(500))   // returns true
   *    math.hasNumericValue(math.fraction(4))      // returns true
   *    math.hasNumericValue(math.complex('2-4i')   // returns false
   *    math.hasNumericValue([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, isNumeric
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, `Boolean`, or a `String` containing number. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($20e654f3593a1dfb$var$name, {
        string: function string(x) {
            return x.trim().length > 0 && !isNaN(Number(x));
        },
        any: function any(x) {
            return isNumeric(x);
        }
    });
});

});

parcelRegister("4CU0l", function(module, exports) {

$parcel$export(module.exports, "createHypot", function () { return $35e6275ab0a7f680$export$87e3687740a09cb; });

var $jKx4O = parcelRequire("jKx4O");

var $YkZ7e = parcelRequire("YkZ7e");
var $35e6275ab0a7f680$var$name = "hypot";
var $35e6275ab0a7f680$var$dependencies = [
    "typed",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "sqrt",
    "smaller",
    "isPositive"
];
var $35e6275ab0a7f680$export$87e3687740a09cb = /* #__PURE__ */ (0, $jKx4O.factory)($35e6275ab0a7f680$var$name, $35e6275ab0a7f680$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, addScalar = _ref.addScalar, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, sqrt = _ref.sqrt, smaller = _ref.smaller, isPositive = _ref.isPositive;
    /**
   * Calculate the hypotenusa of a list with values. The hypotenusa is defined as:
   *
   *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
   *
   * For matrix input, the hypotenusa is calculated for all values in the matrix.
   *
   * Syntax:
   *
   *     math.hypot(a, b, ...)
   *     math.hypot([a, b, c, ...])
   *
   * Examples:
   *
   *     math.hypot(3, 4)      // 5
   *     math.hypot(3, 4, 5)   // 7.0710678118654755
   *     math.hypot([3, 4, 5]) // 7.0710678118654755
   *     math.hypot(-2)        // 2
   *
   * See also:
   *
   *     abs, norm
   *
   * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
   *                                                          Matrix and Array input is flattened and returns a
   *                                                          single number for the whole matrix.
   * @return {number | BigNumber} Returns the hypothenusa of the input values.
   */ var hypot = typed($35e6275ab0a7f680$var$name, {
        "... number | BigNumber": _hypot,
        Array: function Array(x) {
            return hypot.apply(hypot, (0, $YkZ7e.flatten)(x));
        },
        Matrix: function Matrix(x) {
            return hypot.apply(hypot, (0, $YkZ7e.flatten)(x.toArray()));
        }
    });
    /**
   * Calculate the hypotenusa for an Array with values
   * @param {Array.<number | BigNumber>} args
   * @return {number | BigNumber} Returns the result
   * @private
   */ function _hypot(args) {
        // code based on `hypot` from es6-shim:
        // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
        var result = 0;
        var largest = 0;
        for(var i = 0; i < args.length; i++){
            var value = abs(args[i]);
            if (smaller(largest, value)) {
                result = multiplyScalar(result, multiplyScalar(divideScalar(largest, value), divideScalar(largest, value)));
                result = addScalar(result, 1);
                largest = value;
            } else result = addScalar(result, isPositive(value) ? multiplyScalar(divideScalar(value, largest), divideScalar(value, largest)) : value);
        }
        return multiplyScalar(largest, sqrt(result));
    }
    return hypot;
});

});

parcelRegister("38H4O", function(module, exports) {

$parcel$export(module.exports, "createIdentity", function () { return $249388944d4fcffd$export$2eca89e9ac669625; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");
var $249388944d4fcffd$var$name = "identity";
var $249388944d4fcffd$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber",
    "DenseMatrix",
    "SparseMatrix"
];
var $249388944d4fcffd$export$2eca89e9ac669625 = /* #__PURE__ */ (0, $jKx4O.factory)($249388944d4fcffd$var$name, $249388944d4fcffd$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, BigNumber = _ref.BigNumber, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix;
    /**
   * Create a 2-dimensional identity matrix with size m x n or n x n.
   * The matrix has ones on the diagonal and zeros elsewhere.
   *
   * Syntax:
   *
   *    math.identity(n)
   *    math.identity(n, format)
   *    math.identity(m, n)
   *    math.identity(m, n, format)
   *    math.identity([m, n])
   *    math.identity([m, n], format)
   *
   * Examples:
   *
   *    math.identity(3)                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
   *    math.identity(3, 2)                 // returns [[1, 0], [0, 1], [0, 0]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.identity(math.size(A))         // returns [[1, 0, 0], [0, 1, 0]]
   *
   * See also:
   *
   *    diag, ones, zeros, size, range
   *
   * @param {...number | Matrix | Array} size   The size for the matrix
   * @param {string} [format]                   The Matrix storage format
   *
   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
   */ return typed($249388944d4fcffd$var$name, {
        "": function _() {
            return config.matrix === "Matrix" ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        "number | BigNumber": function numberBigNumber(rows) {
            return _identity(rows, rows, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, string": function numberBigNumberString(rows, format) {
            return _identity(rows, rows, format);
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(rows, cols) {
            return _identity(rows, cols, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, number | BigNumber, string": function numberBigNumberNumberBigNumberString(rows, cols, format) {
            return _identity(rows, cols, format);
        },
        Array: function Array(size) {
            return _identityVector(size);
        },
        "Array, string": function ArrayString(size, format) {
            return _identityVector(size, format);
        },
        Matrix: function Matrix(size) {
            return _identityVector(size.valueOf(), size.storage());
        },
        "Matrix, string": function MatrixString(size, format) {
            return _identityVector(size.valueOf(), format);
        }
    });
    function _identityVector(size, format) {
        switch(size.length){
            case 0:
                return format ? matrix(format) : [];
            case 1:
                return _identity(size[0], size[0], format);
            case 2:
                return _identity(size[0], size[1], format);
            default:
                throw new Error("Vector containing two values expected");
        }
    }
    /**
   * Create an identity matrix
   * @param {number | BigNumber} rows
   * @param {number | BigNumber} cols
   * @param {string} [format]
   * @returns {Matrix}
   * @private
   */ function _identity(rows, cols, format) {
        // BigNumber constructor with the right precision
        var Big = (0, $7E0JQ.isBigNumber)(rows) || (0, $7E0JQ.isBigNumber)(cols) ? BigNumber : null;
        if ((0, $7E0JQ.isBigNumber)(rows)) rows = rows.toNumber();
        if ((0, $7E0JQ.isBigNumber)(cols)) cols = cols.toNumber();
        if (!(0, $5wlxr.isInteger)(rows) || rows < 1) throw new Error("Parameters in function identity must be positive integers");
        if (!(0, $5wlxr.isInteger)(cols) || cols < 1) throw new Error("Parameters in function identity must be positive integers");
        var one = Big ? new BigNumber(1) : 1;
        var defaultValue = Big ? new Big(0) : 0;
        var size = [
            rows,
            cols
        ]; // check we need to return a matrix
        if (format) {
            // create diagonal matrix (use optimized implementation for storage format)
            if (format === "sparse") return SparseMatrix.diagonal(size, one, 0, defaultValue);
            if (format === "dense") return DenseMatrix.diagonal(size, one, 0, defaultValue);
            throw new TypeError('Unknown matrix type "'.concat(format, '"'));
        } // create and resize array
        var res = (0, $YkZ7e.resize)([], size, defaultValue); // fill in ones on the diagonal
        var minimum = rows < cols ? rows : cols; // fill diagonal
        for(var d = 0; d < minimum; d++)res[d][d] = one;
        return res;
    }
});

});

parcelRegister("3X3sP", function(module, exports) {

$parcel$export(module.exports, "createIm", function () { return $2e0991a71f970a82$export$47dfdf308b91581; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $2e0991a71f970a82$var$name = "im";
var $2e0991a71f970a82$var$dependencies = [
    "typed"
];
var $2e0991a71f970a82$export$47dfdf308b91581 = /* #__PURE__ */ (0, $jKx4O.factory)($2e0991a71f970a82$var$name, $2e0991a71f970a82$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Get the imaginary part of a complex number.
   * For a complex number `a + bi`, the function returns `b`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.im(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number -5.2
   *    math.re(math.complex(2.4))     // returns number 0
   *
   * See also:
   *
   *    re, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The imaginary part of x
   */ var im = typed($2e0991a71f970a82$var$name, {
        number: function number(x) {
            return 0;
        },
        BigNumber: function BigNumber(x) {
            return x.mul(0);
        },
        Complex: function Complex(x) {
            return x.im;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, im);
        }
    });
    return im;
});

});

parcelRegister("fpJBP", function(module, exports) {

$parcel$export(module.exports, "createImmutableDenseMatrixClass", function () { return $b38c91daa002cb1d$export$49a565643b9ab608; });

var $7E0JQ = parcelRequire("7E0JQ");

var $glBd7 = parcelRequire("glBd7");

var $jKx4O = parcelRequire("jKx4O");
var $b38c91daa002cb1d$var$name = "ImmutableDenseMatrix";
var $b38c91daa002cb1d$var$dependencies = [
    "smaller",
    "DenseMatrix"
];
var $b38c91daa002cb1d$export$49a565643b9ab608 = /* #__PURE__ */ (0, $jKx4O.factory)($b38c91daa002cb1d$var$name, $b38c91daa002cb1d$var$dependencies, function(_ref) {
    var smaller = _ref.smaller, DenseMatrix = _ref.DenseMatrix;
    function ImmutableDenseMatrix(data, datatype) {
        if (!(this instanceof ImmutableDenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $7E0JQ.isString)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $7E0JQ.isMatrix)(data) || (0, $7E0JQ.isArray)(data)) {
            // use DenseMatrix implementation
            var matrix = new DenseMatrix(data, datatype); // internal structures
            this._data = matrix._data;
            this._size = matrix._size;
            this._datatype = matrix._datatype;
            this._min = null;
            this._max = null;
        } else if (data && (0, $7E0JQ.isArray)(data.data) && (0, $7E0JQ.isArray)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = data.datatype;
            this._min = typeof data.min !== "undefined" ? data.min : null;
            this._max = typeof data.max !== "undefined" ? data.max : null;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $7E0JQ.typeOf)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
            this._min = null;
            this._max = null;
        }
    }
    ImmutableDenseMatrix.prototype = new DenseMatrix();
    /**
   * Attach type information
   */ ImmutableDenseMatrix.prototype.type = "ImmutableDenseMatrix";
    ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | ImmutableDenseMatrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ ImmutableDenseMatrix.prototype.subset = function(index) {
        switch(arguments.length){
            case 1:
                // use base implementation
                var m = DenseMatrix.prototype.subset.call(this, index); // check result is a matrix
                if ((0, $7E0JQ.isMatrix)(m)) // return immutable matrix
                return new ImmutableDenseMatrix({
                    data: m._data,
                    size: m._size,
                    datatype: m._datatype
                });
                return m;
            // intentional fall through
            case 2:
            case 3:
                throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Replace a single element in the matrix.
   * @param {Number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {ImmutableDenseMatrix} self
   */ ImmutableDenseMatrix.prototype.set = function() {
        throw new Error("Cannot invoke set on an Immutable Matrix instance");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {Number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ ImmutableDenseMatrix.prototype.resize = function() {
        throw new Error("Cannot invoke resize on an Immutable Matrix instance");
    };
    /**
   * Disallows reshaping in favor of immutability.
   *
   * @throws {Error} Operation not allowed
   */ ImmutableDenseMatrix.prototype.reshape = function() {
        throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
    };
    /**
   * Create a clone of the matrix
   * @return {ImmutableDenseMatrix} clone
   */ ImmutableDenseMatrix.prototype.clone = function() {
        return new ImmutableDenseMatrix({
            data: (0, $glBd7.clone)(this._data),
            size: (0, $glBd7.clone)(this._size),
            datatype: this._datatype
        });
    };
    /**
   * Get a JSON representation of the matrix
   * @returns {Object}
   */ ImmutableDenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "ImmutableDenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Generate a matrix from a JSON object
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {ImmutableDenseMatrix}
   */ ImmutableDenseMatrix.fromJSON = function(json) {
        return new ImmutableDenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @param {Number} i       Matrix row index 1
   * @param {Number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ ImmutableDenseMatrix.prototype.swapRows = function() {
        throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
    };
    /**
   * Calculate the minimum value in the set
   * @return {Number | undefined} min
   */ ImmutableDenseMatrix.prototype.min = function() {
        // check min has been calculated before
        if (this._min === null) {
            // minimum
            var m = null; // compute min
            this.forEach(function(v) {
                if (m === null || smaller(v, m)) m = v;
            });
            this._min = m !== null ? m : undefined;
        }
        return this._min;
    };
    /**
   * Calculate the maximum value in the set
   * @return {Number | undefined} max
   */ ImmutableDenseMatrix.prototype.max = function() {
        // check max has been calculated before
        if (this._max === null) {
            // maximum
            var m = null; // compute max
            this.forEach(function(v) {
                if (m === null || smaller(m, v)) m = v;
            });
            this._max = m !== null ? m : undefined;
        }
        return this._max;
    };
    return ImmutableDenseMatrix;
}, {
    isClass: true
});

});

parcelRegister("k1fS4", function(module, exports) {

$parcel$export(module.exports, "createIndex", function () { return $e9303650f3ca2077$export$c6d108d7c8095f19; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");
var $e9303650f3ca2077$var$name = "index";
var $e9303650f3ca2077$var$dependencies = [
    "typed",
    "Index"
];
var $e9303650f3ca2077$export$c6d108d7c8095f19 = /* #__PURE__ */ (0, $jKx4O.factory)($e9303650f3ca2077$var$name, $e9303650f3ca2077$var$dependencies, function(_ref) {
    var typed = _ref.typed, Index = _ref.Index;
    /**
   * Create an index. An Index can store ranges having start, step, and end
   * for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Syntax:
   *
   *     math.index(range1, range2, ...)
   *
   * Where each range can be any of:
   *
   * - A number
   * - A string for getting/setting an object property
   * - An instance of `Range`
   * - A one-dimensional Array or a Matrix with numbers
   *
   * Indexes must be zero-based, integer numbers.
   *
   * Examples:
   *
   *    const b = [1, 2, 3, 4, 5]
   *    math.subset(b, math.index([1, 2, 3]))     // returns [2, 3, 4]
   *
   *    const a = math.matrix([[1, 2], [3, 4]])
   *    a.subset(math.index(0, 1))             // returns 2
   *
   * See also:
   *
   *    bignumber, boolean, complex, matrix, number, string, unit
   *
   * @param {...*} ranges   Zero or more ranges or numbers.
   * @return {Index}        Returns the created index
   */ return typed($e9303650f3ca2077$var$name, {
        "...number | string | BigNumber | Range | Array | Matrix": function numberStringBigNumberRangeArrayMatrix(args) {
            var ranges = args.map(function(arg) {
                if ((0, $7E0JQ.isBigNumber)(arg)) return arg.toNumber(); // convert BigNumber to Number
                else if (Array.isArray(arg) || (0, $7E0JQ.isMatrix)(arg)) return arg.map(function(elem) {
                    // convert BigNumber to Number
                    return (0, $7E0JQ.isBigNumber)(elem) ? elem.toNumber() : elem;
                });
                else return arg;
            });
            var res = new Index();
            Index.apply(res, ranges);
            return res;
        }
    });
});

});

parcelRegister("g467d", function(module, exports) {

$parcel$export(module.exports, "createIndexClass", function () { return $bb21c36f15cf09cd$export$300720b4fe34e62e; });

var $7E0JQ = parcelRequire("7E0JQ");

var $glBd7 = parcelRequire("glBd7");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");
var $bb21c36f15cf09cd$var$name = "Index";
var $bb21c36f15cf09cd$var$dependencies = [
    "ImmutableDenseMatrix"
];
var $bb21c36f15cf09cd$export$300720b4fe34e62e = /* #__PURE__ */ (0, $jKx4O.factory)($bb21c36f15cf09cd$var$name, $bb21c36f15cf09cd$var$dependencies, function(_ref) {
    var ImmutableDenseMatrix = _ref.ImmutableDenseMatrix;
    /**
   * Create an index. An Index can store ranges and sets for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Usage:
   *     const index = new Index(range1, range2, matrix1, array1, ...)
   *
   * Where each parameter can be any of:
   *     A number
   *     A string (containing a name of an object property)
   *     An instance of Range
   *     An Array with the Set values
   *     A Matrix with the Set values
   *
   * The parameters start, end, and step must be integer numbers.
   *
   * @class Index
   * @Constructor Index
   * @param {...*} ranges
   */ function Index(ranges) {
        if (!(this instanceof Index)) throw new SyntaxError("Constructor must be called with the new operator");
        this._dimensions = [];
        this._isScalar = true;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i];
            if ((0, $7E0JQ.isRange)(arg)) {
                this._dimensions.push(arg);
                this._isScalar = false;
            } else if (Array.isArray(arg) || (0, $7E0JQ.isMatrix)(arg)) {
                // create matrix
                var m = _createImmutableMatrix(arg.valueOf());
                this._dimensions.push(m); // size
                var size = m.size(); // scalar
                if (size.length !== 1 || size[0] !== 1) this._isScalar = false;
            } else if (typeof arg === "number") this._dimensions.push(_createImmutableMatrix([
                arg
            ]));
            else if (typeof arg === "string") // object property (arguments.count should be 1)
            this._dimensions.push(arg);
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
             // TODO: implement support for wildcard '*'
        }
    }
    /**
   * Attach type information
   */ Index.prototype.type = "Index";
    Index.prototype.isIndex = true;
    function _createImmutableMatrix(arg) {
        // loop array elements
        for(var i = 0, l = arg.length; i < l; i++){
            if (typeof arg[i] !== "number" || !(0, $5wlxr.isInteger)(arg[i])) throw new TypeError("Index parameters must be positive integer numbers");
        } // create matrix
        return new ImmutableDenseMatrix(arg);
    }
    /**
   * Create a clone of the index
   * @memberof Index
   * @return {Index} clone
   */ Index.prototype.clone = function() {
        var index = new Index();
        index._dimensions = (0, $glBd7.clone)(this._dimensions);
        index._isScalar = this._isScalar;
        return index;
    };
    /**
   * Create an index from an array with ranges/numbers
   * @memberof Index
   * @param {Array.<Array | number>} ranges
   * @return {Index} index
   * @private
   */ Index.create = function(ranges) {
        var index = new Index();
        Index.apply(index, ranges);
        return index;
    };
    /**
   * Retrieve the size of the index, the number of elements for each dimension.
   * @memberof Index
   * @returns {number[]} size
   */ Index.prototype.size = function() {
        var size = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var d = this._dimensions[i];
            size[i] = typeof d === "string" ? 1 : d.size()[0];
        }
        return size;
    };
    /**
   * Get the maximum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} max
   */ Index.prototype.max = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.max();
        }
        return values;
    };
    /**
   * Get the minimum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} min
   */ Index.prototype.min = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.min();
        }
        return values;
    };
    /**
   * Loop over each of the ranges of the index
   * @memberof Index
   * @param {Function} callback   Called for each range with a Range as first
   *                              argument, the dimension as second, and the
   *                              index object as third.
   */ Index.prototype.forEach = function(callback) {
        for(var i = 0, ii = this._dimensions.length; i < ii; i++)callback(this._dimensions[i], i, this);
    };
    /**
   * Retrieve the dimension for the given index
   * @memberof Index
   * @param {Number} dim                  Number of the dimension
   * @returns {Range | null} range
   */ Index.prototype.dimension = function(dim) {
        return this._dimensions[dim] || null;
    };
    /**
   * Test whether this index contains an object property
   * @returns {boolean} Returns true if the index is an object property
   */ Index.prototype.isObjectProperty = function() {
        return this._dimensions.length === 1 && typeof this._dimensions[0] === "string";
    };
    /**
   * Returns the object property name when the Index holds a single object property,
   * else returns null
   * @returns {string | null}
   */ Index.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this._dimensions[0] : null;
    };
    /**
   * Test whether this index contains only a single value.
   *
   * This is the case when the index is created with only scalar values as ranges,
   * not for ranges resolving into a single value.
   * @memberof Index
   * @return {boolean} isScalar
   */ Index.prototype.isScalar = function() {
        return this._isScalar;
    };
    /**
   * Expand the Index into an array.
   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.toArray = function() {
        var array = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            array.push(typeof dimension === "string" ? dimension : dimension.toArray());
        }
        return array;
    };
    /**
   * Get the primitive value of the Index, a two dimensional array.
   * Equivalent to Index.toArray().
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.valueOf = Index.prototype.toArray;
    /**
   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
   * @memberof Index
   * @returns {String} str
   */ Index.prototype.toString = function() {
        var strings = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            if (typeof dimension === "string") strings.push(JSON.stringify(dimension));
            else strings.push(dimension.toString());
        }
        return "[" + strings.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the Index
   * @memberof Index
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   */ Index.prototype.toJSON = function() {
        return {
            mathjs: "Index",
            dimensions: this._dimensions
        };
    };
    /**
   * Instantiate an Index from a JSON object
   * @memberof Index
   * @param {Object} json A JSON object structured as:
   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   * @return {Index}
   */ Index.fromJSON = function(json) {
        return Index.create(json.dimensions);
    };
    return Index;
}, {
    isClass: true
});

});

parcelRegister("iXV0j", function(module, exports) {

$parcel$export(module.exports, "createIntersect", function () { return $dce9f4849d6a3cc8$export$e2d92d8f89fdd92d; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $dce9f4849d6a3cc8$var$name = "intersect";
var $dce9f4849d6a3cc8$var$dependencies = [
    "typed",
    "config",
    "abs",
    "add",
    "addScalar",
    "matrix",
    "multiply",
    "multiplyScalar",
    "divideScalar",
    "subtract",
    "smaller",
    "equalScalar"
];
var $dce9f4849d6a3cc8$export$e2d92d8f89fdd92d = /* #__PURE__ */ (0, $jKx4O.factory)($dce9f4849d6a3cc8$var$name, $dce9f4849d6a3cc8$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, abs = _ref.abs, add = _ref.add, addScalar = _ref.addScalar, matrix = _ref.matrix, multiply = _ref.multiply, multiplyScalar = _ref.multiplyScalar, divideScalar = _ref.divideScalar, subtract = _ref.subtract, smaller = _ref.smaller, equalScalar = _ref.equalScalar;
    /**
   * Calculates the point of intersection of two lines in two or three dimensions
   * and of a line and a plane in three dimensions. The inputs are in the form of
   * arrays or 1 dimensional matrices. The line intersection functions return null
   * if the lines do not meet.
   *
   * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
   *
   * Syntax:
   *
   *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
   *    math.intersect(endPoint1, endPoint2, planeCoefficients)
   *
   * Examples:
   *
   *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10])              // Returns [5, 5]
   *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0])  // Returns [5, 5, 0]
   *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])            // Returns [7, -4, 3]
   *
   * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
   * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
   * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
   *                              OR Co-efficients of the plane's equation
   * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
   *                              OR null if the calculation is for line and plane
   * @return {Array}              Returns the point of intersection of lines/lines-planes
   */ var intersect = typed("intersect", {
        "Array, Array, Array": function ArrayArrayArray(x, y, plane) {
            if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
            if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
            if (!_4d(plane)) throw new TypeError("Array with 4 numbers expected as third argument");
            return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
        },
        "Array, Array, Array, Array": function ArrayArrayArrayArray(w, x, y, z) {
            if (w.length === 2) {
                if (!_2d(w)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
                return _intersect2d(w, x, y, z);
            } else if (w.length === 3) {
                if (!_3d(w)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
                if (!_3d(z)) throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
                return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
            } else throw new TypeError("Arrays with two or thee dimensional points expected");
        },
        "Matrix, Matrix, Matrix": function MatrixMatrixMatrix(x, y, plane) {
            return matrix(intersect(x.valueOf(), y.valueOf(), plane.valueOf()));
        },
        "Matrix, Matrix, Matrix, Matrix": function MatrixMatrixMatrixMatrix(w, x, y, z) {
            // TODO: output matrix type should match input matrix type
            return matrix(intersect(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf()));
        }
    });
    function _isNumeric(a) {
        // intersect supports numbers and bignumbers
        return typeof a === "number" || (0, $7E0JQ.isBigNumber)(a);
    }
    function _2d(x) {
        return x.length === 2 && _isNumeric(x[0]) && _isNumeric(x[1]);
    }
    function _3d(x) {
        return x.length === 3 && _isNumeric(x[0]) && _isNumeric(x[1]) && _isNumeric(x[2]);
    }
    function _4d(x) {
        return x.length === 4 && _isNumeric(x[0]) && _isNumeric(x[1]) && _isNumeric(x[2]) && _isNumeric(x[3]);
    }
    function _intersect2d(p1a, p1b, p2a, p2b) {
        var o1 = p1a;
        var o2 = p2a;
        var d1 = subtract(o1, p1b);
        var d2 = subtract(o2, p2b);
        var det = subtract(multiplyScalar(d1[0], d2[1]), multiplyScalar(d2[0], d1[1]));
        if (smaller(abs(det), config.epsilon)) return null;
        var d20o11 = multiplyScalar(d2[0], o1[1]);
        var d21o10 = multiplyScalar(d2[1], o1[0]);
        var d20o21 = multiplyScalar(d2[0], o2[1]);
        var d21o20 = multiplyScalar(d2[1], o2[0]);
        var t = divideScalar(addScalar(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
        return add(multiply(d1, t), o1);
    }
    function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l) {
        // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
        var add1 = multiplyScalar(subtract(a, b), subtract(c, d));
        var add2 = multiplyScalar(subtract(e, f), subtract(g, h));
        var add3 = multiplyScalar(subtract(i, j), subtract(k, l));
        return addScalar(addScalar(add1, add2), add3);
    }
    function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4) {
        var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
        var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
        var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
        var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
        var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
        var ta = divideScalar(subtract(multiplyScalar(d1343, d4321), multiplyScalar(d1321, d4343)), subtract(multiplyScalar(d2121, d4343), multiplyScalar(d4321, d4321)));
        var tb = divideScalar(addScalar(d1343, multiplyScalar(ta, d4321)), d4343);
        var pax = addScalar(x1, multiplyScalar(ta, subtract(x2, x1)));
        var pay = addScalar(y1, multiplyScalar(ta, subtract(y2, y1)));
        var paz = addScalar(z1, multiplyScalar(ta, subtract(z2, z1)));
        var pbx = addScalar(x3, multiplyScalar(tb, subtract(x4, x3)));
        var pby = addScalar(y3, multiplyScalar(tb, subtract(y4, y3)));
        var pbz = addScalar(z3, multiplyScalar(tb, subtract(z4, z3)));
        if (equalScalar(pax, pbx) && equalScalar(pay, pby) && equalScalar(paz, pbz)) return [
            pax,
            pay,
            paz
        ];
        else return null;
    }
    function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c) {
        var x1x = multiplyScalar(x1, x);
        var x2x = multiplyScalar(x2, x);
        var y1y = multiplyScalar(y1, y);
        var y2y = multiplyScalar(y2, y);
        var z1z = multiplyScalar(z1, z);
        var z2z = multiplyScalar(z2, z);
        var t = divideScalar(subtract(subtract(subtract(c, x1x), y1y), z1z), subtract(subtract(subtract(addScalar(addScalar(x2x, y2y), z2z), x1x), y1y), z1z));
        var px = addScalar(x1, multiplyScalar(t, subtract(x2, x1)));
        var py = addScalar(y1, multiplyScalar(t, subtract(y2, y1)));
        var pz = addScalar(z1, multiplyScalar(t, subtract(z2, z1)));
        return [
            px,
            py,
            pz
        ]; // TODO: Add cases when line is parallel to the plane:
    //       (a) no intersection,
    //       (b) line contained in plane
    }
    return intersect;
});

});

parcelRegister("jYYjK", function(module, exports) {

$parcel$export(module.exports, "createInv", function () { return $e8c268b6a3f41c70$export$ad9771ef9eafe06a; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");

var $7HWRb = parcelRequire("7HWRb");
var $e8c268b6a3f41c70$var$name = "inv";
var $e8c268b6a3f41c70$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "addScalar",
    "multiply",
    "unaryMinus",
    "det",
    "identity",
    "abs"
];
var $e8c268b6a3f41c70$export$ad9771ef9eafe06a = /* #__PURE__ */ (0, $jKx4O.factory)($e8c268b6a3f41c70$var$name, $e8c268b6a3f41c70$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, divideScalar = _ref.divideScalar, addScalar = _ref.addScalar, multiply = _ref.multiply, unaryMinus = _ref.unaryMinus, det = _ref.det, identity = _ref.identity, abs = _ref.abs;
    /**
   * Calculate the inverse of a square matrix.
   *
   * Syntax:
   *
   *     math.inv(x)
   *
   * Examples:
   *
   *     math.inv([[1, 2], [3, 4]])  // returns [[-2, 1], [1.5, -0.5]]
   *     math.inv(4)                 // returns 0.25
   *     1 / 4                       // returns 0.25
   *
   * See also:
   *
   *     det, transpose
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($e8c268b6a3f41c70$var$name, {
        "Array | Matrix": function ArrayMatrix(x) {
            var size = (0, $7E0JQ.isMatrix)(x) ? x.size() : (0, $YkZ7e.arraySize)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (size[0] === 1) {
                        if ((0, $7E0JQ.isMatrix)(x)) return matrix([
                            divideScalar(1, x.valueOf()[0])
                        ]);
                        else return [
                            divideScalar(1, x[0])
                        ];
                    } else throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
                case 2:
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) {
                        if ((0, $7E0JQ.isMatrix)(x)) return matrix(_inv(x.valueOf(), rows, cols), x.storage());
                        else // return an Array
                        return _inv(x, rows, cols);
                    } else throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $7HWRb.format)(size) + ")");
            }
        },
        any: function any(x) {
            // scalar
            return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
        }
    });
    /**
   * Calculate the inverse of a square matrix
   * @param {Array[]} mat     A square matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns, must equal rows
   * @return {Array[]} inv    Inverse matrix
   * @private
   */ function _inv(mat, rows, cols) {
        var r, s, f, value, temp;
        if (rows === 1) {
            // this is a 1 x 1 matrix
            value = mat[0][0];
            if (value === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(1, value)
                ]
            ];
        } else if (rows === 2) {
            // this is a 2 x 2 matrix
            var d = det(mat);
            if (d === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(mat[1][1], d),
                    divideScalar(unaryMinus(mat[0][1]), d)
                ],
                [
                    divideScalar(unaryMinus(mat[1][0]), d),
                    divideScalar(mat[0][0], d)
                ]
            ];
        } else {
            // this is a matrix of 3 x 3 or larger
            // calculate inverse using gauss-jordan elimination
            //      https://en.wikipedia.org/wiki/Gaussian_elimination
            //      http://mathworld.wolfram.com/MatrixInverse.html
            //      http://math.uww.edu/~mcfarlat/inverse.htm
            // make a copy of the matrix (only the arrays, not of the elements)
            var A = mat.concat();
            for(r = 0; r < rows; r++)A[r] = A[r].concat();
             // create an identity matrix which in the end will contain the
            // matrix inverse
            var B = identity(rows).valueOf(); // loop over all columns, and perform row reductions
            for(var c = 0; c < cols; c++){
                // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
                var ABig = abs(A[c][c]);
                var rBig = c;
                r = c + 1;
                while(r < rows){
                    if (abs(A[r][c]) > ABig) {
                        ABig = abs(A[r][c]);
                        rBig = r;
                    }
                    r++;
                }
                if (ABig === 0) throw Error("Cannot calculate inverse, determinant is zero");
                r = rBig;
                if (r !== c) {
                    temp = A[c];
                    A[c] = A[r];
                    A[r] = temp;
                    temp = B[c];
                    B[c] = B[r];
                    B[r] = temp;
                } // eliminate non-zero values on the other rows at column c
                var Ac = A[c];
                var Bc = B[c];
                for(r = 0; r < rows; r++){
                    var Ar = A[r];
                    var Br = B[r];
                    if (r !== c) // eliminate value at column c and row r
                    {
                        if (Ar[c] !== 0) {
                            f = divideScalar(unaryMinus(Ar[c]), Ac[c]); // add (f * row c) to row r to eliminate the value
                            // at column c
                            for(s = c; s < cols; s++)Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
                            for(s = 0; s < cols; s++)Br[s] = addScalar(Br[s], multiply(f, Bc[s]));
                        }
                    } else {
                        // normalize value at Acc to 1,
                        // divide each value on row r with the value at Acc
                        f = Ac[c];
                        for(s = c; s < cols; s++)Ar[s] = divideScalar(Ar[s], f);
                        for(s = 0; s < cols; s++)Br[s] = divideScalar(Br[s], f);
                    }
                }
            }
            return B;
        }
    }
});

});

parcelRegister("gwWlc", function(module, exports) {

$parcel$export(module.exports, "createIsInteger", function () { return $c08ce3c821578d54$export$766996d075d5608a; });

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");
var $c08ce3c821578d54$var$name = "isInteger";
var $c08ce3c821578d54$var$dependencies = [
    "typed"
];
var $c08ce3c821578d54$export$766996d075d5608a = /* #__PURE__ */ (0, $jKx4O.factory)($c08ce3c821578d54$var$name, $c08ce3c821578d54$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is an integer number.
   * The function supports `number`, `BigNumber`, and `Fraction`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isInteger(x)
   *
   * Examples:
   *
   *    math.isInteger(2)                     // returns true
   *    math.isInteger(0)                     // returns true
   *    math.isInteger(0.5)                   // returns false
   *    math.isInteger(math.bignumber(500))   // returns true
   *    math.isInteger(math.fraction(4))      // returns true
   *    math.isInteger('3')                   // returns true
   *    math.isInteger([3, 0.5, -2])          // returns [true, false, true]
   *    math.isInteger(math.complex('2-4i')   // throws an error
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isZero
   *
   * @param {number | BigNumber | Fraction | Array | Matrix} x   Value to be tested
   * @return {boolean}  Returns true when `x` contains a numeric, integer value.
   *                    Throws an error in case of an unknown data type.
   */ var isInteger = typed($c08ce3c821578d54$var$name, {
        number: (0, $5wlxr.isInteger),
        // TODO: what to do with isInteger(add(0.1, 0.2))  ?
        BigNumber: function BigNumber(x) {
            return x.isInt();
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && isFinite(x.n);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, isInteger);
        }
    });
    return isInteger;
});

});

parcelRegister("5IViB", function(module, exports) {

$parcel$export(module.exports, "createIsNaN", function () { return $42ad82329d3d7208$export$f85085363cf09711; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $9T5bt = parcelRequire("9T5bt");
var $42ad82329d3d7208$var$name = "isNaN";
var $42ad82329d3d7208$var$dependencies = [
    "typed"
];
var $42ad82329d3d7208$export$f85085363cf09711 = /* #__PURE__ */ (0, $jKx4O.factory)($42ad82329d3d7208$var$name, $42ad82329d3d7208$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is NaN (not a number).
   * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNaN(x)
   *
   * Examples:
   *
   *    math.isNaN(3)                     // returns false
   *    math.isNaN(NaN)                   // returns true
   *    math.isNaN(0)                     // returns false
   *    math.isNaN(math.bignumber(NaN))   // returns true
   *    math.isNaN(math.bignumber(0))     // returns false
   *    math.isNaN(math.fraction(-2, 5))  // returns false
   *    math.isNaN('-2')                  // returns false
   *    math.isNaN([2, 0, -3, NaN]')      // returns [false, false, false, true]
   *
   * See also:
   *
   *    isNumeric, isNegative, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is NaN.
   *                    Throws an error in case of an unknown data type.
   */ return typed($42ad82329d3d7208$var$name, {
        number: (0, $9T5bt.isNaNNumber),
        BigNumber: function BigNumber(x) {
            return x.isNaN();
        },
        Fraction: function Fraction(x) {
            return false;
        },
        Complex: function Complex(x) {
            return x.isNaN();
        },
        Unit: function Unit(x) {
            return Number.isNaN(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, Number.isNaN);
        }
    });
});

});
parcelRegister("9T5bt", function(module, exports) {

$parcel$export(module.exports, "isNegativeNumber", function () { return $732d4589dba23740$export$6dbd64961904ec9a; });
$parcel$export(module.exports, "isPositiveNumber", function () { return $732d4589dba23740$export$5374bb854d0e41c8; });
$parcel$export(module.exports, "isZeroNumber", function () { return $732d4589dba23740$export$83fb4ed1cc9804a; });
$parcel$export(module.exports, "isNaNNumber", function () { return $732d4589dba23740$export$9fd08d8371c55110; });

var $5wlxr = parcelRequire("5wlxr");
var $732d4589dba23740$var$n1 = "number";
function $732d4589dba23740$export$312381923ba56895(x) {
    return (0, $5wlxr.isInteger)(x);
}
$732d4589dba23740$export$312381923ba56895.signature = $732d4589dba23740$var$n1;
function $732d4589dba23740$export$6dbd64961904ec9a(x) {
    return x < 0;
}
$732d4589dba23740$export$6dbd64961904ec9a.signature = $732d4589dba23740$var$n1;
function $732d4589dba23740$export$5374bb854d0e41c8(x) {
    return x > 0;
}
$732d4589dba23740$export$5374bb854d0e41c8.signature = $732d4589dba23740$var$n1;
function $732d4589dba23740$export$83fb4ed1cc9804a(x) {
    return x === 0;
}
$732d4589dba23740$export$83fb4ed1cc9804a.signature = $732d4589dba23740$var$n1;
function $732d4589dba23740$export$9fd08d8371c55110(x) {
    return Number.isNaN(x);
}
$732d4589dba23740$export$9fd08d8371c55110.signature = $732d4589dba23740$var$n1;

});


parcelRegister("gBYSQ", function(module, exports) {

$parcel$export(module.exports, "createIsNegative", function () { return $c17f544370f79e8e$export$159ccd8c63e17c58; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $9T5bt = parcelRequire("9T5bt");
var $c17f544370f79e8e$var$name = "isNegative";
var $c17f544370f79e8e$var$dependencies = [
    "typed"
];
var $c17f544370f79e8e$export$159ccd8c63e17c58 = /* #__PURE__ */ (0, $jKx4O.factory)($c17f544370f79e8e$var$name, $c17f544370f79e8e$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is negative: smaller than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNegative(x)
   *
   * Examples:
   *
   *    math.isNegative(3)                     // returns false
   *    math.isNegative(-2)                    // returns true
   *    math.isNegative(0)                     // returns false
   *    math.isNegative(-0)                    // returns false
   *    math.isNegative(math.bignumber(2))     // returns false
   *    math.isNegative(math.fraction(-2, 5))  // returns true
   *    math.isNegative('-2')                  // returns true
   *    math.isNegative([2, 0, -3]')           // returns [false, false, true]
   *
   * See also:
   *
   *    isNumeric, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ var isNegative = typed($c17f544370f79e8e$var$name, {
        number: (0, $9T5bt.isNegativeNumber),
        BigNumber: function BigNumber(x) {
            return x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s < 0; // It's enough to decide on the sign
        },
        Unit: function Unit(x) {
            return isNegative(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, isNegative);
        }
    });
    return isNegative;
});

});

parcelRegister("295b6", function(module, exports) {

$parcel$export(module.exports, "createIsNumeric", function () { return $1900704cecf0c7d1$export$85b0631fa122b7f1; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");
var $1900704cecf0c7d1$var$name = "isNumeric";
var $1900704cecf0c7d1$var$dependencies = [
    "typed"
];
var $1900704cecf0c7d1$export$85b0631fa122b7f1 = /* #__PURE__ */ (0, $jKx4O.factory)($1900704cecf0c7d1$var$name, $1900704cecf0c7d1$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is an numeric value.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNumeric(x)
   *
   * Examples:
   *
   *    math.isNumeric(2)                     // returns true
   *    math.isNumeric('2')                   // returns false
   *    math.hasNumericValue('2')             // returns true
   *    math.isNumeric(0)                     // returns true
   *    math.isNumeric(math.bignumber(500))   // returns true
   *    math.isNumeric(math.fraction(4))      // returns true
   *    math.isNumeric(math.complex('2-4i')   // returns false
   *    math.isNumeric([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, hasNumericValue
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, or `boolean`. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ var isNumeric = typed($1900704cecf0c7d1$var$name, {
        "number | BigNumber | Fraction | boolean": function numberBigNumberFractionBoolean() {
            return true;
        },
        "Complex | Unit | string | null | undefined | Node": function ComplexUnitStringNullUndefinedNode() {
            return false;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, isNumeric);
        }
    });
    return isNumeric;
});

});

parcelRegister("djjMV", function(module, exports) {

$parcel$export(module.exports, "createIsPositive", function () { return $9b0c6638fe7d6822$export$2d862c12fb537dd9; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $9T5bt = parcelRequire("9T5bt");
var $9b0c6638fe7d6822$var$name = "isPositive";
var $9b0c6638fe7d6822$var$dependencies = [
    "typed"
];
var $9b0c6638fe7d6822$export$2d862c12fb537dd9 = /* #__PURE__ */ (0, $jKx4O.factory)($9b0c6638fe7d6822$var$name, $9b0c6638fe7d6822$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is positive: larger than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPositive(x)
   *
   * Examples:
   *
   *    math.isPositive(3)                     // returns true
   *    math.isPositive(-2)                    // returns false
   *    math.isPositive(0)                     // returns false
   *    math.isPositive(-0)                    // returns false
   *    math.isPositive(0.5)                   // returns true
   *    math.isPositive(math.bignumber(2))     // returns true
   *    math.isPositive(math.fraction(-2, 5))  // returns false
   *    math.isPositive(math.fraction(1,3))    // returns false
   *    math.isPositive('2')                   // returns true
   *    math.isPositive([2, 0, -3])            // returns [true, false, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ var isPositive = typed($9b0c6638fe7d6822$var$name, {
        number: (0, $9T5bt.isPositiveNumber),
        BigNumber: function BigNumber(x) {
            return !x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s > 0 && x.n > 0;
        },
        Unit: function Unit(x) {
            return isPositive(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, isPositive);
        }
    });
    return isPositive;
});

});

parcelRegister("fKiDS", function(module, exports) {

$parcel$export(module.exports, "createIsPrime", function () { return $b7699cddc05d4bc7$export$4e02350f5fb7a050; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");
var $b7699cddc05d4bc7$var$name = "isPrime";
var $b7699cddc05d4bc7$var$dependencies = [
    "typed"
];
var $b7699cddc05d4bc7$export$4e02350f5fb7a050 = /* #__PURE__ */ (0, $jKx4O.factory)($b7699cddc05d4bc7$var$name, $b7699cddc05d4bc7$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is prime: has no divisors other than itself and one.
   * The function supports type `number`, `bignumber`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPrime(x)
   *
   * Examples:
   *
   *    math.isPrime(3)                     // returns true
   *    math.isPrime(-2)                    // returns false
   *    math.isPrime(0)                     // returns false
   *    math.isPrime(-0)                    // returns false
   *    math.isPrime(0.5)                   // returns false
   *    math.isPrime('2')                   // returns true
   *    math.isPrime([2, 17, 100])           // returns [true, true, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ var isPrime = typed($b7699cddc05d4bc7$var$name, {
        number: function number(x) {
            if (x * 0 !== 0) return false;
            if (x <= 3) return x > 1;
            if (x % 2 === 0 || x % 3 === 0) return false;
            for(var i = 5; i * i <= x; i += 6){
                if (x % i === 0 || x % (i + 2) === 0) return false;
            }
            return true;
        },
        BigNumber: function BigNumber(n) {
            if (n.toNumber() * 0 !== 0) return false;
            if (n.lte(3)) return n.gt(1);
            if (n.mod(2).eq(0) || n.mod(3).eq(0)) return false;
            for(var i = 5; n.gte(i * i); i += 6){
                if (n.mod(i).eq(0) || n.mod(i + 2).eq(0)) return false;
            }
            return true;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, isPrime);
        }
    });
    return isPrime;
});

});

parcelRegister("5QMzt", function(module, exports) {

$parcel$export(module.exports, "createIsZero", function () { return $44277c49c6b232ec$export$ea90652d00dab06e; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $9T5bt = parcelRequire("9T5bt");
var $44277c49c6b232ec$var$name = "isZero";
var $44277c49c6b232ec$var$dependencies = [
    "typed"
];
var $44277c49c6b232ec$export$ea90652d00dab06e = /* #__PURE__ */ (0, $jKx4O.factory)($44277c49c6b232ec$var$name, $44277c49c6b232ec$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Test whether a value is zero.
   * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
   * `Complex`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isZero(x)
   *
   * Examples:
   *
   *    math.isZero(0)                     // returns true
   *    math.isZero(2)                     // returns false
   *    math.isZero(0.5)                   // returns false
   *    math.isZero(math.bignumber(0))     // returns true
   *    math.isZero(math.fraction(0))      // returns true
   *    math.isZero(math.fraction(1,3))    // returns false
   *    math.isZero(math.complex('2 - 4i') // returns false
   *    math.isZero(math.complex('0i')     // returns true
   *    math.isZero('0')                   // returns true
   *    math.isZero('2')                   // returns false
   *    math.isZero([2, 0, -3]')           // returns [false, true, false]
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isInteger
   *
   * @param {number | BigNumber | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
   * @return {boolean}  Returns true when `x` is zero.
   *                    Throws an error in case of an unknown data type.
   */ var isZero = typed($44277c49c6b232ec$var$name, {
        number: (0, $9T5bt.isZeroNumber),
        BigNumber: function BigNumber(x) {
            return x.isZero();
        },
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && x.n === 0;
        },
        Unit: function Unit(x) {
            return isZero(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, isZero);
        }
    });
    return isZero;
});

});

parcelRegister("bZZIu", function(module, exports) {

$parcel$export(module.exports, "createKldivergence", function () { return $8bc543da3755a097$export$eaa5cb8fd86b8d43; });

var $jKx4O = parcelRequire("jKx4O");
var $8bc543da3755a097$var$name = "kldivergence";
var $8bc543da3755a097$var$dependencies = [
    "typed",
    "matrix",
    "divide",
    "sum",
    "multiply",
    "dotDivide",
    "log",
    "isNumeric"
];
var $8bc543da3755a097$export$eaa5cb8fd86b8d43 = /* #__PURE__ */ (0, $jKx4O.factory)($8bc543da3755a097$var$name, $8bc543da3755a097$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, divide = _ref.divide, sum = _ref.sum, multiply = _ref.multiply, dotDivide = _ref.dotDivide, log = _ref.log, isNumeric = _ref.isNumeric;
    /**
     * Calculate the Kullback-Leibler (KL) divergence  between two distributions
     *
     * Syntax:
     *
     *     math.kldivergence(x, y)
     *
     * Examples:
     *
     *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])   //returns 0.24376698773121153
     *
     *
     * @param  {Array | Matrix} q    First vector
     * @param  {Array | Matrix} p    Second vector
     * @return {number}              Returns distance between q and p
     */ return typed($8bc543da3755a097$var$name, {
        "Array, Array": function ArrayArray(q, p) {
            return _kldiv(matrix(q), matrix(p));
        },
        "Matrix, Array": function MatrixArray(q, p) {
            return _kldiv(q, matrix(p));
        },
        "Array, Matrix": function ArrayMatrix(q, p) {
            return _kldiv(matrix(q), p);
        },
        "Matrix, Matrix": function MatrixMatrix(q, p) {
            return _kldiv(q, p);
        }
    });
    function _kldiv(q, p) {
        var plength = p.size().length;
        var qlength = q.size().length;
        if (plength > 1) throw new Error("first object must be one dimensional");
        if (qlength > 1) throw new Error("second object must be one dimensional");
        if (plength !== qlength) throw new Error("Length of two vectors must be equal");
         // Before calculation, apply normalization
        var sumq = sum(q);
        if (sumq === 0) throw new Error("Sum of elements in first object must be non zero");
        var sump = sum(p);
        if (sump === 0) throw new Error("Sum of elements in second object must be non zero");
        var qnorm = divide(q, sum(q));
        var pnorm = divide(p, sum(p));
        var result = sum(multiply(qnorm, log(dotDivide(qnorm, pnorm))));
        if (isNumeric(result)) return result;
        else return Number.NaN;
    }
});

});

parcelRegister("cYEUZ", function(module, exports) {

$parcel$export(module.exports, "createKron", function () { return $972ad41cd1dfe847$export$cee275bf38ddc295; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $972ad41cd1dfe847$var$name = "kron";
var $972ad41cd1dfe847$var$dependencies = [
    "typed",
    "matrix",
    "multiplyScalar"
];
var $972ad41cd1dfe847$export$cee275bf38ddc295 = /* #__PURE__ */ (0, $jKx4O.factory)($972ad41cd1dfe847$var$name, $972ad41cd1dfe847$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, multiplyScalar = _ref.multiplyScalar;
    /**
     * Calculates the kronecker product of 2 matrices or vectors.
     *
     * NOTE: If a one dimensional vector / matrix is given, it will be
     * wrapped so its two dimensions.
     * See the examples.
     *
     * Syntax:
     *
     *    math.kron(x, y)
     *
     * Examples:
     *
     *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])
     *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
     *
     *    math.kron([1,1], [2,3,4])
     *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
     *
     * See also:
     *
     *    multiply, dot, cross
     *
     * @param  {Array | Matrix} x     First vector
     * @param  {Array | Matrix} y     Second vector
     * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
     */ return typed($972ad41cd1dfe847$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_kron(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_kron(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_kron(x, y.toArray()));
        },
        "Array, Array": _kron
    });
    /**
     * Calculate the kronecker product of two matrices / vectors
     * @param {Array} a  First vector
     * @param {Array} b  Second vector
     * @returns {Array} Returns the kronecker product of x and y
     * @private
     */ function _kron(a, b) {
        // Deal with the dimensions of the matricies.
        if ((0, $YkZ7e.arraySize)(a).length === 1) // Wrap it in a 2D Matrix
        a = [
            a
        ];
        if ((0, $YkZ7e.arraySize)(b).length === 1) // Wrap it in a 2D Matrix
        b = [
            b
        ];
        if ((0, $YkZ7e.arraySize)(a).length > 2 || (0, $YkZ7e.arraySize)(b).length > 2) throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(a.length) + ", y = " + JSON.stringify(b.length) + ")");
        var t = [];
        var r = [];
        return a.map(function(a) {
            return b.map(function(b) {
                r = [];
                t.push(r);
                return a.map(function(y) {
                    return b.map(function(x) {
                        return r.push(multiplyScalar(y, x));
                    });
                });
            });
        }) && t;
    }
});

});

parcelRegister("1230C", function(module, exports) {

$parcel$export(module.exports, "createLarger", function () { return $0c084fde30993f97$export$af9bc16ae70e9aa8; });

var $9zoJy = parcelRequire("9zoJy");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $272zs = parcelRequire("272zs");

var $5ntii = parcelRequire("5ntii");

var $kJFHo = parcelRequire("kJFHo");
var $0c084fde30993f97$var$name = "larger";
var $0c084fde30993f97$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $0c084fde30993f97$export$af9bc16ae70e9aa8 = /* #__PURE__ */ (0, $jKx4O.factory)($0c084fde30993f97$var$name, $0c084fde30993f97$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is larger than y.
   *
   * The function returns true when x is larger than y and the relative
   * difference between x and y is larger than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.larger(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 3)             // returns false
   *    math.larger(5, 2 + 2)         // returns true
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.larger(a, b)             // returns false
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
   */ var larger = typed($0c084fde30993f97$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x > y;
        },
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gt(y) && !(0, $9zoJy.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) === 1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return larger(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, larger);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, larger, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, larger, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, larger);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return larger(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return larger(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return larger(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, larger, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, larger, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, larger, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, larger, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, larger, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, larger, true).valueOf();
        }
    });
    return larger;
});
var $0c084fde30993f97$export$36e0507f86788708 = /* #__PURE__ */ (0, $jKx4O.factory)($0c084fde30993f97$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($0c084fde30993f97$var$name, {
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("5J1h2", function(module, exports) {

$parcel$export(module.exports, "createLargerEq", function () { return $42b224b1eab46a19$export$26aa7f5b5fee1150; });

var $9zoJy = parcelRequire("9zoJy");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $272zs = parcelRequire("272zs");

var $5ntii = parcelRequire("5ntii");

var $kJFHo = parcelRequire("kJFHo");
var $42b224b1eab46a19$var$name = "largerEq";
var $42b224b1eab46a19$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $42b224b1eab46a19$export$26aa7f5b5fee1150 = /* #__PURE__ */ (0, $jKx4O.factory)($42b224b1eab46a19$var$name, $42b224b1eab46a19$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is larger or equal to y.
   *
   * The function returns true when x is larger than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.largerEq(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 1 + 1)         // returns false
   *    math.largerEq(2, 1 + 1)       // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
   */ var largerEq = typed($42b224b1eab46a19$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x >= y;
        },
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gte(y) || (0, $9zoJy.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) !== -1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return largerEq(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, largerEq);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, largerEq, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, largerEq, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, largerEq);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return largerEq(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return largerEq(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return largerEq(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, largerEq, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, largerEq, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, largerEq, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, largerEq, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, largerEq, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, largerEq, true).valueOf();
        }
    });
    return largerEq;
});
var $42b224b1eab46a19$export$494ed93834104475 = /* #__PURE__ */ (0, $jKx4O.factory)($42b224b1eab46a19$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($42b224b1eab46a19$var$name, {
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("esrJX", function(module, exports) {

$parcel$export(module.exports, "createLcm", function () { return $a86932d637049cda$export$5d3af1956d9bb33b; });

var $jKx4O = parcelRequire("jKx4O");

var $16D4T = parcelRequire("16D4T");

var $c7RNU = parcelRequire("c7RNU");

var $1Gmbc = parcelRequire("1Gmbc");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $cqeCl = parcelRequire("cqeCl");
var $a86932d637049cda$var$name = "lcm";
var $a86932d637049cda$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar"
];
var $a86932d637049cda$export$5d3af1956d9bb33b = /* #__PURE__ */ (0, $jKx4O.factory)($a86932d637049cda$var$name, $a86932d637049cda$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar;
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $c7RNU.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the least common multiple for two or more values or arrays.
   *
   * lcm is defined as:
   *
   *     lcm(a, b) = abs(a * b) / gcd(a, b)
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.lcm(a, b)
   *    math.lcm(a, b, c, ...)
   *
   * Examples:
   *
   *    math.lcm(4, 6)               // returns 12
   *    math.lcm(6, 21)              // returns 42
   *    math.lcm(6, 21, 5)           // returns 210
   *
   *    math.lcm([4, 6], [6, 21])    // returns [12, 42]
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Array | Matrix}                           The least common multiple
   */ var lcm = typed($a86932d637049cda$var$name, {
        "number, number": (0, $cqeCl.lcmNumber),
        "BigNumber, BigNumber": _lcmBigNumber,
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.lcm(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, lcm);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, lcm, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, lcm, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, lcm);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return lcm(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return lcm(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return lcm(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, lcm, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, lcm, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            return algorithm11(y, x, lcm, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, lcm, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, lcm, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, lcm, true).valueOf();
        },
        // TODO: need a smarter notation here
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = lcm(a, b);
            for(var i = 0; i < args.length; i++)res = lcm(res, args[i]);
            return res;
        }
    });
    return lcm;
    /**
   * Calculate lcm for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns the least common multiple of a and b
   * @private
   */ function _lcmBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
        if (a.isZero()) return a;
        if (b.isZero()) return b;
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        // evaluate lcm here inline to reduce overhead
        var prod = a.times(b);
        while(!b.isZero()){
            var t = b;
            b = a.mod(t);
            a = t;
        }
        return prod.div(a).abs();
    }
});

});

parcelRegister("dmxxg", function(module, exports) {

$parcel$export(module.exports, "createLeftShift", function () { return $9ba757e24e30c7dd$export$ce15600b23f5e78; });

var $16D4T = parcelRequire("16D4T");

var $1Gmbc = parcelRequire("1Gmbc");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $9vlUQ = parcelRequire("9vlUQ");

var $fs8LR = parcelRequire("fs8LR");

var $gyXqK = parcelRequire("gyXqK");

var $jKx4O = parcelRequire("jKx4O");

var $exwQn = parcelRequire("exwQn");

var $hGVn5 = parcelRequire("hGVn5");
var $9ba757e24e30c7dd$var$name = "leftShift";
var $9ba757e24e30c7dd$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $9ba757e24e30c7dd$export$ce15600b23f5e78 = /* #__PURE__ */ (0, $jKx4O.factory)($9ba757e24e30c7dd$var$name, $9ba757e24e30c7dd$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $9vlUQ.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $gyXqK.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $fs8LR.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise left logical shift of a value x by y number of bits, `x << y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.leftShift(x, y)
   *
   * Examples:
   *
   *    math.leftShift(1, 2)               // returns number 4
   *
   *    math.leftShift([1, 2, 3], 4)       // returns Array [16, 32, 64]
   *
   * See also:
   *
   *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` shifted left `y` times
   */ var leftShift = typed($9ba757e24e30c7dd$var$name, {
        "number, number": (0, $exwQn.leftShiftNumber),
        "BigNumber, BigNumber": (0, $hGVn5.leftShiftBigNumber),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, leftShift, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, leftShift, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, leftShift, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, leftShift);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return leftShift(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return leftShift(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return leftShift(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, leftShift, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, leftShift, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, leftShift, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, leftShift, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return leftShift(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return leftShift(x, matrix(y)).valueOf();
        }
    });
    return leftShift;
});

});
parcelRegister("gyXqK", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm08", function () { return $c0edebfa428dab2e$export$59a068f853cfbf8; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $c0edebfa428dab2e$var$name = "algorithm08";
var $c0edebfa428dab2e$var$dependencies = [
    "typed",
    "equalScalar"
];
var $c0edebfa428dab2e$export$59a068f853cfbf8 = /* #__PURE__ */ (0, $jKx4O.factory)($c0edebfa428dab2e$var$name, $c0edebfa428dab2e$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm08(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $i7dcb.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!avalues || !bvalues) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var k, k0, k1, i; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values in a
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // mark workspace
                w[i] = mark; // set value
                x[i] = avalues[k]; // add index
                cindex.push(i);
            } // loop values in b
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check value exists in workspace
                if (w[i] === mark) // evaluate callback
                x[i] = cf(x[i], bvalues[k]);
            } // initialize first index in j
            k = cptr[j]; // loop index in j
            while(k < cindex.length){
                // row
                i = cindex[k]; // value @ i
                var v = x[i]; // check for zero value
                if (!eq(v, zero)) {
                    // push value
                    cvalues.push(v); // increment pointer
                    k++;
                } else // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("aD9ah", function(module, exports) {

$parcel$export(module.exports, "createLog", function () { return $7bd4a7d2aaf2f052$export$aea8a16d5c9d1b93; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $7bd4a7d2aaf2f052$var$name = "log";
var $7bd4a7d2aaf2f052$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $7bd4a7d2aaf2f052$export$aea8a16d5c9d1b93 = /* #__PURE__ */ (0, $jKx4O.factory)($7bd4a7d2aaf2f052$var$name, $7bd4a7d2aaf2f052$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, divideScalar = _ref.divideScalar, Complex = _ref.Complex;
    /**
   * Calculate the logarithm of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log(x)
   *    math.log(x, base)
   *
   * Examples:
   *
   *    math.log(3.5)                  // returns 1.252762968495368
   *    math.exp(math.log(2.4))        // returns 2.4
   *
   *    math.pow(10, 4)                // returns 10000
   *    math.log(10000, 10)            // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *
   *    math.log(1024, 2)              // returns 10
   *    math.pow(2, 10)                // returns 1024
   *
   * See also:
   *
   *    exp, log2, log10, log1p
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x`
   */ var log = typed($7bd4a7d2aaf2f052$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $cqeCl.logNumber)(x);
            else // negative value -> complex value computation
            return new Complex(x, 0).log();
        },
        Complex: function Complex(x) {
            return x.log();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.ln();
            else // downgrade to number, return Complex valued result
            return new Complex(x.toNumber(), 0).log();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, log);
        },
        "any, any": function anyAny(x, base) {
            // calculate logarithm for a specified base, log(x, base)
            return divideScalar(log(x), log(base));
        }
    });
    return log;
});

});

parcelRegister("1iTPd", function(module, exports) {

$parcel$export(module.exports, "createLog10", function () { return $0f32c698fe0b7051$export$dea4efeb24d4590d; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $0f32c698fe0b7051$var$name = "log10";
var $0f32c698fe0b7051$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $0f32c698fe0b7051$export$dea4efeb24d4590d = /* #__PURE__ */ (0, $jKx4O.factory)($0f32c698fe0b7051$var$name, $0f32c698fe0b7051$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, _Complex = _ref.Complex;
    /**
   * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log10(x)
   *
   * Examples:
   *
   *    math.log10(0.00001)            // returns -5
   *    math.log10(10000)              // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *    math.pow(10, 4)                // returns 10000
   *
   * See also:
   *
   *    exp, log, log1p, log2
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 10-base logarithm of `x`
   */ var log10 = typed($0f32c698fe0b7051$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $cqeCl.log10Number)(x);
            else // negative value -> complex value computation
            return new _Complex(x, 0).log().div(Math.LN10);
        },
        Complex: function Complex(x) {
            return new _Complex(x).log().div(Math.LN10);
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log();
            else // downgrade to number, return Complex valued result
            return new _Complex(x.toNumber(), 0).log().div(Math.LN10);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, log10);
        }
    });
    return log10;
});

});

parcelRegister("72wmq", function(module, exports) {

$parcel$export(module.exports, "createLog1p", function () { return $5201d277119b63d6$export$93da279859a704f0; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");
var $5201d277119b63d6$var$name = "log1p";
var $5201d277119b63d6$var$dependencies = [
    "typed",
    "config",
    "divideScalar",
    "log",
    "Complex"
];
var $5201d277119b63d6$export$93da279859a704f0 = /* #__PURE__ */ (0, $jKx4O.factory)($5201d277119b63d6$var$name, $5201d277119b63d6$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, divideScalar = _ref.divideScalar, log = _ref.log, Complex = _ref.Complex;
    /**
   * Calculate the logarithm of a `value+1`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log1p(x)
   *    math.log1p(x, base)
   *
   * Examples:
   *
   *    math.log1p(2.5)                 // returns 1.252762968495368
   *    math.exp(math.log1p(1.4))       // returns 2.4
   *
   *    math.pow(10, 4)                 // returns 10000
   *    math.log1p(9999, 10)            // returns 4
   *    math.log1p(9999) / math.log(10) // returns 4
   *
   * See also:
   *
   *    exp, log, log2, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm of `x+1`.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x+1` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x+1`
   */ var log1p = typed($5201d277119b63d6$var$name, {
        number: function number(x) {
            if (x >= -1 || config.predictable) return (0, $5wlxr.log1p)(x);
            else // negative value -> complex value computation
            return _log1pComplex(new Complex(x, 0));
        },
        Complex: _log1pComplex,
        BigNumber: function BigNumber(x) {
            var y = x.plus(1);
            if (!y.isNegative() || config.predictable) return y.ln();
            else // downgrade to number, return Complex valued result
            return _log1pComplex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, log1p);
        },
        "any, any": function anyAny(x, base) {
            // calculate logarithm for a specified base, log1p(x, base)
            return divideScalar(log1p(x), log(base));
        }
    });
    /**
   * Calculate the natural logarithm of a complex number + 1
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log1pComplex(x) {
        var xRe1p = x.re + 1;
        return new Complex(Math.log(Math.sqrt(xRe1p * xRe1p + x.im * x.im)), Math.atan2(x.im, xRe1p));
    }
    return log1p;
});

});

parcelRegister("gdMfy", function(module, exports) {

$parcel$export(module.exports, "createLog2", function () { return $bcf349aba24c75c2$export$a993dae3988e0f19; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $bcf349aba24c75c2$var$name = "log2";
var $bcf349aba24c75c2$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $bcf349aba24c75c2$export$a993dae3988e0f19 = /* #__PURE__ */ (0, $jKx4O.factory)($bcf349aba24c75c2$var$name, $bcf349aba24c75c2$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, Complex = _ref.Complex;
    /**
   * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log2(x)
   *
   * Examples:
   *
   *    math.log2(0.03125)           // returns -5
   *    math.log2(16)                // returns 4
   *    math.log2(16) / math.log2(2) // returns 4
   *    math.pow(2, 4)               // returns 16
   *
   * See also:
   *
   *    exp, log, log1p, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 2-base logarithm of `x`
   */ var log2 = typed($bcf349aba24c75c2$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $cqeCl.log2Number)(x);
            else // negative value -> complex value computation
            return _log2Complex(new Complex(x, 0));
        },
        Complex: _log2Complex,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log(2);
            else // downgrade to number, return Complex valued result
            return _log2Complex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, log2);
        }
    });
    /**
   * Calculate log2 for a complex value
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log2Complex(x) {
        var newX = Math.sqrt(x.re * x.re + x.im * x.im);
        return new Complex(Math.log2 ? Math.log2(newX) : Math.log(newX) / Math.LN2, Math.atan2(x.im, x.re) / Math.LN2);
    }
    return log2;
});

});

parcelRegister("4zHhr", function(module, exports) {

$parcel$export(module.exports, "createLsolve", function () { return $354c00e0279f7713$export$1b88d04961967a10; });

var $jKx4O = parcelRequire("jKx4O");

var $MMZIZ = parcelRequire("MMZIZ");
var $354c00e0279f7713$var$name = "lsolve";
var $354c00e0279f7713$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $354c00e0279f7713$export$1b88d04961967a10 = /* #__PURE__ */ (0, $jKx4O.factory)($354c00e0279f7713$var$name, $354c00e0279f7713$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, subtract = _ref.subtract, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var solveValidation = (0, $MMZIZ.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolve(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolve(a, b)  // [[-5.5], [20]]
   *
   * See also:
   *
   *    lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($354c00e0279f7713$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            // process matrix
            return _sparseForwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            // process matrix
            return _denseForwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            // create dense matrix from array
            var m = matrix(a); // use matrix implementation
            var r = _denseForwardSubstitution(m, b); // result
            return r.valueOf();
        }
    });
    function _denseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true); // column vector data
        var bdata = b._data; // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = []; // data
        var data = m._data; // forward solve m * x = b, loop columns
        for(var j = 0; j < columns; j++){
            // b[j]
            var bj = bdata[j][0] || 0; // x[j]
            var xj = void 0; // forward substitution (outer product) avoids inner looping when bj === 0
            if (!equalScalar(bj, 0)) {
                // value @ [j, j]
                var vjj = data[j][j]; // check vjj
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error("Linear system cannot be solved since matrix is singular");
                 // calculate xj
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j + 1; i < rows; i++)// update copy of b
                bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, data[i][j]))
                ];
            } else // zero @ j
            xj = 0;
             // update x
            x[j] = [
                xj
            ];
        } // return vector
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true); // column vector data
        var bdata = b._data; // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // vars
        var i, k; // result
        var x = []; // forward solve m * x = b, loop columns
        for(var j = 0; j < columns; j++){
            // b[j]
            var bj = bdata[j][0] || 0; // forward substitution (outer product) avoids inner looping when bj === 0
            if (!equalScalar(bj, 0)) {
                // value @ [j, j]
                var vjj = 0; // lower triangular matrix values & index (column j)
                var jvalues = [];
                var jindex = []; // last index in column
                var l = ptr[j + 1]; // values in column, find value @ [j, j]
                for(k = ptr[j]; k < l; k++){
                    // row
                    i = index[k]; // check row (rows are not sorted!)
                    if (i === j) // update vjj
                    vjj = values[k];
                    else if (i > j) {
                        // store lower triangular
                        jvalues.push(values[k]);
                        jindex.push(i);
                    }
                } // at this point we must have a value @ [j, j]
                if (equalScalar(vjj, 0)) // system cannot be solved, there is no value @ [j, j]
                throw new Error("Linear system cannot be solved since matrix is singular");
                 // calculate xj
                var xj = divideScalar(bj, vjj); // loop lower triangular
                for(k = 0, l = jindex.length; k < l; k++){
                    // row
                    i = jindex[k]; // update copy of b
                    bdata[i] = [
                        subtract(bdata[i][0] || 0, multiplyScalar(xj, jvalues[k]))
                    ];
                } // update x
                x[j] = [
                    xj
                ];
            } else // update x
            x[j] = [
                0
            ];
        } // return vector
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});

});
parcelRegister("MMZIZ", function(module, exports) {

$parcel$export(module.exports, "createSolveValidation", function () { return $092a7d1bb808d89a$export$6accbcba5dda801d; });

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $7HWRb = parcelRequire("7HWRb");
function $092a7d1bb808d89a$export$6accbcba5dda801d(_ref) {
    var DenseMatrix = _ref.DenseMatrix;
    /**
   * Validates matrix and column vector b for backward/forward substitution algorithms.
   *
   * @param {Matrix} m            An N x N matrix
   * @param {Array | Matrix} b    A column vector
   * @param {Boolean} copy        Return a copy of vector b
   *
   * @return {DenseMatrix}        Dense column vector b
   */ return function solveValidation(m, b, copy) {
        // matrix size
        var size = m.size(); // validate matrix dimensions
        if (size.length !== 2) throw new RangeError("Matrix must be two dimensional (size: " + (0, $7HWRb.format)(size) + ")");
         // rows & columns
        var rows = size[0];
        var columns = size[1]; // validate rows & columns
        if (rows !== columns) throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
         // vars
        var data, i, bdata; // check b is matrix
        if ((0, $7E0JQ.isMatrix)(b)) {
            // matrix size
            var msize = b.size(); // vector
            if (msize.length === 1) {
                // check vector length
                if (msize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                 // create data array
                data = []; // matrix data (DenseMatrix)
                bdata = b._data; // loop b data
                for(i = 0; i < rows; i++)// row array
                data[i] = [
                    bdata[i]
                ];
                 // return Dense Matrix
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            } // two dimensions
            if (msize.length === 2) {
                // array must be a column vector
                if (msize[0] !== rows || msize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                 // check matrix type
                if ((0, $7E0JQ.isDenseMatrix)(b)) {
                    // check a copy is needed
                    if (copy) {
                        // create data array
                        data = []; // matrix data (DenseMatrix)
                        bdata = b._data; // loop b data
                        for(i = 0; i < rows; i++)// row array
                        data[i] = [
                            bdata[i][0]
                        ];
                         // return Dense Matrix
                        return new DenseMatrix({
                            data: data,
                            size: [
                                rows,
                                1
                            ],
                            datatype: b._datatype
                        });
                    } // b is already a column vector
                    return b;
                } // create data array
                data = [];
                for(i = 0; i < rows; i++)data[i] = [
                    0
                ];
                 // sparse matrix arrays
                var values = b._values;
                var index = b._index;
                var ptr = b._ptr; // loop values in column 0
                for(var k1 = ptr[1], k = ptr[0]; k < k1; k++){
                    // row
                    i = index[k]; // add to data
                    data[i][0] = values[k];
                } // return Dense Matrix
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            } // throw error
            throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        } // check b is array
        if ((0, $7E0JQ.isArray)(b)) {
            // size
            var asize = (0, $YkZ7e.arraySize)(b); // check matrix dimensions, vector
            if (asize.length === 1) {
                // check vector length
                if (asize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                 // create data array
                data = []; // loop b
                for(i = 0; i < rows; i++)// row array
                data[i] = [
                    b[i]
                ];
                 // return Dense Matrix
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            if (asize.length === 2) {
                // array must be a column vector
                if (asize[0] !== rows || asize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                 // create data array
                data = []; // loop b data
                for(i = 0; i < rows; i++)// row array
                data[i] = [
                    b[i][0]
                ];
                 // return Dense Matrix
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            } // throw error
            throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        }
    };
}

});


parcelRegister("13F9O", function(module, exports) {

$parcel$export(module.exports, "createLup", function () { return $0c55ff39211a0291$export$86ddf344397699d5; });

var $glBd7 = parcelRequire("glBd7");

var $jKx4O = parcelRequire("jKx4O");
var $0c55ff39211a0291$var$name = "lup";
var $0c55ff39211a0291$var$dependencies = [
    "typed",
    "matrix",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "larger",
    "equalScalar",
    "unaryMinus",
    "DenseMatrix",
    "SparseMatrix",
    "Spa"
];
var $0c55ff39211a0291$export$86ddf344397699d5 = /* #__PURE__ */ (0, $jKx4O.factory)($0c55ff39211a0291$var$name, $0c55ff39211a0291$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, abs = _ref.abs, addScalar = _ref.addScalar, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, subtract = _ref.subtract, larger = _ref.larger, equalScalar = _ref.equalScalar, unaryMinus = _ref.unaryMinus, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix, Spa = _ref.Spa;
    /**
   * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
   * row permutation vector `p` where `A[p,:] = L * U`
   *
   * Syntax:
   *
   *    math.lup(A)
   *
   * Example:
   *
   *    const m = [[2, 1], [1, 4]]
   *    const r = math.lup(m)
   *    // r = {
   *    //   L: [[1, 0], [0.5, 1]],
   *    //   U: [[2, 1], [0, 3.5]],
   *    //   P: [0, 1]
   *    // }
   *
   * See also:
   *
   *    slu, lsolve, lusolve, usolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
   *
   * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
   */ return typed($0c55ff39211a0291$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseLUP(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseLUP(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseLUP(m); // result
            return {
                L: r.L.valueOf(),
                U: r.U.valueOf(),
                p: r.p
            };
        }
    });
    function _denseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix array, clone original data
        var data = (0, $glBd7.clone)(m._data); // l matrix arrays
        var ldata = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var udata = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vector
        var p = [];
        for(i = 0; i < rows; i++)p[i] = i;
         // loop columns
        for(j = 0; j < columns; j++){
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows
            for(i = 0; i < rows; i++){
                // min i,j
                var min = Math.min(i, j); // v[i, j]
                var s = 0; // loop up to min
                for(k = 0; k < min; k++)// s = l[i, k] - data[k, j]
                s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
                data[i][j] = subtract(data[i][j], s);
            }
             // row with larger value in cvector, row >= j
            var pi = j;
            var pabsv = 0;
            var vjj = 0; // loop rows
            for(i = j; i < rows; i++){
                // data @ i, j
                var v = data[i][j]; // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = i; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            } // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in p
                p[j] = [
                    p[pi],
                    p[pi] = p[j]
                ][0]; // swap j <-> pi in data
                DenseMatrix._swapRows(j, pi, data);
            } // check column is in lower triangular matrix
            if (j < rows) // loop rows (lower triangular matrix)
            for(i = j + 1; i < rows; i++){
                // value @ i, j
                var vij = data[i][j];
                if (!equalScalar(vij, 0)) // update data
                data[i][j] = divideScalar(data[i][j], vjj);
            }
        } // loop columns
        for(j = 0; j < columns; j++)// loop rows
        for(i = 0; i < rows; i++){
            // initialize row in arrays
            if (j === 0) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i] = [];
                 // L
                ldata[i] = [];
            } // check we are in the upper triangular matrix
            if (i < j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 0;
                continue;
            } // diagonal value
            if (i === j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 1;
                continue;
            } // check row exists in upper triangular matrix
            if (i < columns) // U
            udata[i][j] = 0;
             // check column exists in lower triangular matrix
            if (j < rows) // L
            ldata[i][j] = data[i][j];
        }
         // l matrix
        var l = new DenseMatrix({
            data: ldata,
            size: lsize
        }); // u matrix
        var u = new DenseMatrix({
            data: udata,
            size: usize
        }); // p vector
        var pv = [];
        for(i = 0, n = p.length; i < n; i++)pv[p[i]] = i;
         // return matrices
        return {
            L: l,
            U: u,
            p: pv,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
    function _sparseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix arrays (will not be modified, thanks to permutation vector)
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // l matrix arrays
        var lvalues = [];
        var lindex = [];
        var lptr = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var uvalues = [];
        var uindex = [];
        var uptr = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vectors, (current index -> original index) and (original index -> current index)
        var pvCo = [];
        var pvOc = [];
        for(i = 0; i < rows; i++){
            pvCo[i] = i;
            pvOc[i] = i;
        } // swap indices in permutation vectors (condition x < y)!
        var swapIndeces = function swapIndeces(x, y) {
            // find pv indeces getting data from x and y
            var kx = pvOc[x];
            var ky = pvOc[y]; // update permutation vector current -> original
            pvCo[kx] = y;
            pvCo[ky] = x; // update permutation vector original -> current
            pvOc[x] = ky;
            pvOc[y] = kx;
        }; // loop columns
        var _loop = function _loop() {
            // sparse accumulator
            var spa = new Spa(); // check lower triangular matrix has a value @ column j
            if (j < rows) {
                // update ptr
                lptr.push(lvalues.length); // first value in j column for lower triangular matrix
                lvalues.push(1);
                lindex.push(j);
            } // update ptr
            uptr.push(uvalues.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // copy column j into sparse accumulator
            for(k = k0; k < k1; k++){
                // row
                i = index[k]; // copy column values into sparse accumulator (use permutation vector)
                spa.set(pvCo[i], values[k]);
            } // skip first column in upper triangular matrix
            if (j > 0) // loop rows in column j (above diagonal)
            spa.forEach(0, j - 1, function(k, vkj) {
                // loop rows in column k (L)
                SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function(i, vik) {
                    // check row is below k
                    if (i > k) // update spa value
                    spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
                });
            });
             // row with larger value in spa, row >= j
            var pi = j;
            var vjj = spa.get(j);
            var pabsv = abs(vjj); // loop values in spa (order by row, below diagonal)
            spa.forEach(j + 1, rows - 1, function(x, v) {
                // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = x; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            }); // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in L
                SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr); // swap values j <-> pi in U
                SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr); // swap values in spa
                spa.swap(j, pi); // update permutation vector (swap values @ j, pi)
                swapIndeces(j, pi);
            } // loop values in spa (order by row)
            spa.forEach(0, rows - 1, function(x, v) {
                // check we are above diagonal
                if (x <= j) {
                    // update upper triangular matrix
                    uvalues.push(v);
                    uindex.push(x);
                } else {
                    // update value
                    v = divideScalar(v, vjj); // check value is non zero
                    if (!equalScalar(v, 0)) {
                        // update lower triangular matrix
                        lvalues.push(v);
                        lindex.push(x);
                    }
                }
            });
        };
        for(j = 0; j < columns; j++)_loop();
         // update ptrs
        uptr.push(uvalues.length);
        lptr.push(lvalues.length); // return matrices
        return {
            L: new SparseMatrix({
                values: lvalues,
                index: lindex,
                ptr: lptr,
                size: lsize
            }),
            U: new SparseMatrix({
                values: uvalues,
                index: uindex,
                ptr: uptr,
                size: usize
            }),
            p: pvCo,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
});

});

parcelRegister("j66eo", function(module, exports) {

$parcel$export(module.exports, "createLusolve", function () { return $de7369399b08a6dd$export$a3f0777edf21dcd5; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $MMZIZ = parcelRequire("MMZIZ");

var $aJUmf = parcelRequire("aJUmf");
var $de7369399b08a6dd$var$name = "lusolve";
var $de7369399b08a6dd$var$dependencies = [
    "typed",
    "matrix",
    "lup",
    "slu",
    "usolve",
    "lsolve",
    "DenseMatrix"
];
var $de7369399b08a6dd$export$a3f0777edf21dcd5 = /* #__PURE__ */ (0, $jKx4O.factory)($de7369399b08a6dd$var$name, $de7369399b08a6dd$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, lup = _ref.lup, slu = _ref.slu, usolve = _ref.usolve, lsolve = _ref.lsolve, DenseMatrix = _ref.DenseMatrix;
    var solveValidation = (0, $MMZIZ.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
   *
   * Syntax:
   *
   *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
   *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
   *
   * Examples:
   *
   *    const m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]]
   *
   *    const x = math.lusolve(m, [-1, -1, -1, -1])        // x = [[-1], [-0.5], [-1/3], [-0.25]]
   *
   *    const f = math.lup(m)
   *    const x1 = math.lusolve(f, [-1, -1, -1, -1])       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
   *    const x2 = math.lusolve(f, [1, 2, 1, -1])          // x2 = [[1], [1], [1/3], [-0.25]]
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = math.lusolve(a, b)  // [[2], [5]]
   *
   * See also:
   *
   *    lup, slu, lsolve, usolve
   *
   * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
   * @param {Matrix | Array} b               Column Vector
   * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
   * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
   *
   * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
   */ return typed($de7369399b08a6dd$var$name, {
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            // convert a to matrix
            a = matrix(a); // matrix lup decomposition
            var d = lup(a); // solve
            var x = _lusolve(d.L, d.U, d.p, null, b); // convert result to array
            return x.valueOf();
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(a, b) {
            // matrix lup decomposition
            var d = lup(a); // solve
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(a, b) {
            // matrix lup decomposition
            var d = lup(a); // solve
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix, number, number": function SparseMatrixArrayMatrixNumberNumber(a, b, order, threshold) {
            // matrix lu decomposition
            var d = slu(a, order, threshold); // solve
            return _lusolve(d.L, d.U, d.p, d.q, b);
        },
        "Object, Array | Matrix": function ObjectArrayMatrix(d, b) {
            // solve
            return _lusolve(d.L, d.U, d.p, d.q, b);
        }
    });
    function _toMatrix(a) {
        // check it is a matrix
        if ((0, $7E0JQ.isMatrix)(a)) return a;
         // check array
        if ((0, $7E0JQ.isArray)(a)) return matrix(a);
         // throw
        throw new TypeError("Invalid Matrix LU decomposition");
    }
    function _lusolve(l, u, p, q, b) {
        // verify L, U, P
        l = _toMatrix(l);
        u = _toMatrix(u); // validate matrix and vector
        b = solveValidation(l, b, false); // apply row permutations if needed (b is a DenseMatrix)
        if (p) b._data = (0, $aJUmf.csIpvec)(p, b._data);
         // use forward substitution to resolve L * y = b
        var y = lsolve(l, b); // use backward substitution to resolve U * x = y
        var x = usolve(u, y); // apply column permutations if needed (x is a DenseMatrix)
        if (q) x._data = (0, $aJUmf.csIpvec)(q, x._data);
         // return solution
        return x;
    }
});

});
parcelRegister("aJUmf", function(module, exports) {

$parcel$export(module.exports, "csIpvec", function () { return $7d19d2d5c5e72780$export$29cc81cfd083fd62; });
/**
 * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
 *
 * @param {Array} p           The permutation vector of length n. null value denotes identity
 * @param {Array} b           The input vector
 *
 * @return {Array}            The output vector x = P'b
 */ function $7d19d2d5c5e72780$export$29cc81cfd083fd62(p, b) {
    // vars
    var k;
    var n = b.length;
    var x = []; // check permutation vector was provided, p = null denotes identity
    if (p) // loop vector
    for(k = 0; k < n; k++)// apply permutation
    x[p[k]] = b[k];
    else // loop vector
    for(k = 0; k < n; k++)// x[i] = b[i]
    x[k] = b[k];
    return x;
}

});


parcelRegister("61mVG", function(module, exports) {

$parcel$export(module.exports, "createMad", function () { return $46249f5859a3d39b$export$7b17fbe41c88575a; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");

var $dYvNV = parcelRequire("dYvNV");
var $46249f5859a3d39b$var$name = "mad";
var $46249f5859a3d39b$var$dependencies = [
    "typed",
    "abs",
    "map",
    "median",
    "subtract"
];
var $46249f5859a3d39b$export$7b17fbe41c88575a = /* #__PURE__ */ (0, $jKx4O.factory)($46249f5859a3d39b$var$name, $46249f5859a3d39b$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, map = _ref.map, median = _ref.median, subtract = _ref.subtract;
    /**
   * Compute the median absolute deviation of a matrix or a list with values.
   * The median absolute deviation is defined as the median of the absolute
   * deviations from the median.
   *
   * Syntax:
   *
   *     math.mad(a, b, c, ...)
   *     math.mad(A)
   *
   * Examples:
   *
   *     math.mad(10, 20, 30)             // returns 10
   *     math.mad([1, 2, 3])              // returns 1
   *     math.mad([[1, 2, 3], [4, 5, 6]]) // returns 1.5
   *
   * See also:
   *
   *     median, mean, std, abs
   *
   * @param {Array | Matrix} array
   *                        A single matrix or multiple scalar values.
   * @return {*} The median absolute deviation.
   */ return typed($46249f5859a3d39b$var$name, {
        // mad([a, b, c, d, ...])
        "Array | Matrix": _mad,
        // mad(a, b, c, d, ...)
        "...": function _(args) {
            return _mad(args);
        }
    });
    function _mad(array) {
        array = (0, $YkZ7e.flatten)(array.valueOf());
        if (array.length === 0) throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
        try {
            var med = median(array);
            return median(map(array, function(value) {
                return abs(subtract(value, med));
            }));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf("median") !== -1) throw new TypeError(err.message.replace("median", "mad"));
            else throw (0, $dYvNV.improveErrorMessage)(err, "mad");
        }
    }
});

});

parcelRegister("h7kGL", function(module, exports) {

$parcel$export(module.exports, "createMap", function () { return $c763237560ad4fbb$export$d49c9aa30b771d59; });

var $lMDm0 = parcelRequire("lMDm0");

var $jKx4O = parcelRequire("jKx4O");
var $c763237560ad4fbb$var$name = "map";
var $c763237560ad4fbb$var$dependencies = [
    "typed"
];
var $c763237560ad4fbb$export$d49c9aa30b771d59 = /* #__PURE__ */ (0, $jKx4O.factory)($c763237560ad4fbb$var$name, $c763237560ad4fbb$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Create a new matrix or array with the results of the callback function executed on
   * each entry of the matrix/array.
   *
   * Syntax:
   *
   *    math.map(x, callback)
   *
   * Examples:
   *
   *    math.map([1, 2, 3], function(value) {
   *      return value * value
   *    })  // returns [1, 4, 9]
   *
   * See also:
   *
   *    filter, forEach, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the matrix being traversed.
   * @return {Matrix | array}     Transformed map of x
   */ return typed($c763237560ad4fbb$var$name, {
        "Array, function": $c763237560ad4fbb$var$_map,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.map(callback);
        }
    });
});
/**
 * Map for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @return {Array}
 * @private
 */ function $c763237560ad4fbb$var$_map(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $lMDm0.maxArgumentCount)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) return value.map(function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i));
        });
        else {
            // invoke the callback function with the right number of arguments
            if (args === 1) return callback(value);
            else if (args === 2) return callback(value, index);
            else // 3 or -1
            return callback(value, index, array);
        }
    };
    return recurse(array, []);
}

});

parcelRegister("107IL", function(module, exports) {

$parcel$export(module.exports, "createMatrix", function () { return $0babc7befc2a2e58$export$f3cf8b510f9cb8ab; });

var $jKx4O = parcelRequire("jKx4O");
var $0babc7befc2a2e58$var$name = "matrix";
var $0babc7befc2a2e58$var$dependencies = [
    "typed",
    "Matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $0babc7befc2a2e58$export$f3cf8b510f9cb8ab = /* #__PURE__ */ (0, $jKx4O.factory)($0babc7befc2a2e58$var$name, $0babc7befc2a2e58$var$dependencies, function(_ref) {
    var typed = _ref.typed, Matrix = _ref.Matrix, DenseMatrix = _ref.DenseMatrix, SparseMatrix = _ref.SparseMatrix;
    /**
   * Create a Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Supported storage formats are 'dense' and 'sparse'.
   *
   * Syntax:
   *
   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
   *
   * Examples:
   *
   *    let m = math.matrix([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, sparse
   *
   * @param {Array | Matrix} [data]    A multi dimensional array
   * @param {string} [format]          The Matrix storage format
   *
   * @return {Matrix} The created matrix
   */ return typed($0babc7befc2a2e58$var$name, {
        "": function _() {
            return _create([]);
        },
        string: function string(format) {
            return _create([], format);
        },
        "string, string": function stringString(format, datatype) {
            return _create([], format, datatype);
        },
        Array: function Array(data) {
            return _create(data);
        },
        Matrix: function Matrix(data) {
            return _create(data, data.storage());
        },
        "Array | Matrix, string": _create,
        "Array | Matrix, string, string": _create
    });
    /**
   * Create a new Matrix with given storage format
   * @param {Array} data
   * @param {string} [format]
   * @param {string} [datatype]
   * @returns {Matrix} Returns a new Matrix
   * @private
   */ function _create(data, format, datatype) {
        // get storage format constructor
        if (format === "dense" || format === "default" || format === undefined) return new DenseMatrix(data, datatype);
        if (format === "sparse") return new SparseMatrix(data, datatype);
        throw new TypeError("Unknown matrix type " + JSON.stringify(format) + ".");
    }
});

});

parcelRegister("luwu6", function(module, exports) {

$parcel$export(module.exports, "createMatrixClass", function () { return $fa55990abe66b721$export$72d485cc3ed6a97a; });

var $jKx4O = parcelRequire("jKx4O");
var $fa55990abe66b721$var$name = "Matrix";
var $fa55990abe66b721$var$dependencies = [];
var $fa55990abe66b721$export$72d485cc3ed6a97a = /* #__PURE__ */ (0, $jKx4O.factory)($fa55990abe66b721$var$name, $fa55990abe66b721$var$dependencies, function() {
    /**
   * @constructor Matrix
   *
   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
   * array. A matrix can be constructed as:
   *
   *     let matrix = math.matrix(data)
   *
   * Matrix contains the functions to resize, get and set values, get the size,
   * clone the matrix and to convert the matrix to a vector, array, or scalar.
   * Furthermore, one can iterate over the matrix using map and forEach.
   * The internal Array of the Matrix can be accessed using the function valueOf.
   *
   * Example usage:
   *
   *     let matrix = math.matrix([[1, 2], [3, 4]])
   *     matix.size()              // [2, 2]
   *     matrix.resize([3, 2], 5)
   *     matrix.valueOf()          // [[1, 2], [3, 4], [5, 5]]
   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
   *
   */ function Matrix() {
        if (!(this instanceof Matrix)) throw new SyntaxError("Constructor must be called with the new operator");
    }
    /**
   * Attach type information
   */ Matrix.prototype.type = "Matrix";
    Matrix.prototype.isMatrix = true;
    /**
   * Get the Matrix storage constructor for the given format.
   *
   * @param {string} format       The Matrix storage format.
   *
   * @return {Function}           The Matrix storage constructor.
   */ Matrix.storage = function(format) {
        // TODO: deprecated since v6.0.0. Clean up some day
        throw new Error("Matrix.storage is deprecated since v6.0.0. Use the factory function math.matrix instead.");
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @return {string}           The storage format.
   */ Matrix.prototype.storage = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke storage on a Matrix interface");
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @return {string}           The datatype.
   */ Matrix.prototype.datatype = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke datatype on a Matrix interface");
    };
    /**
   * Create a new Matrix With the type of the current matrix instance
   * @param {Array | Object} data
   * @param {string} [datatype]
   */ Matrix.prototype.create = function(data, datatype) {
        throw new Error("Cannot invoke create on a Matrix interface");
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ Matrix.prototype.subset = function(index, replacement, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke subset on a Matrix interface");
    };
    /**
   * Get a single element from the matrix.
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ Matrix.prototype.get = function(index) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke get on a Matrix interface");
    };
    /**
   * Replace a single element in the matrix.
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {Matrix} self
   */ Matrix.prototype.set = function(index, value, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke set on a Matrix interface");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ Matrix.prototype.resize = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke resize on a Matrix interface");
    };
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ Matrix.prototype.reshape = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke reshape on a Matrix interface");
    };
    /**
   * Create a clone of the matrix
   * @return {Matrix} clone
   */ Matrix.prototype.clone = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke clone on a Matrix interface");
    };
    /**
   * Retrieve the size of the matrix.
   * @returns {number[]} size
   */ Matrix.prototype.size = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke size on a Matrix interface");
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {Matrix} matrix
   */ Matrix.prototype.map = function(callback, skipZeros) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke map on a Matrix interface");
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ Matrix.prototype.forEach = function(callback) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke forEach on a Matrix interface");
    };
    /**
   * Create an Array with a copy of the data of the Matrix
   * @returns {Array} array
   */ Matrix.prototype.toArray = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toArray on a Matrix interface");
    };
    /**
   * Get the primitive value of the Matrix: a multidimensional array
   * @returns {Array} array
   */ Matrix.prototype.valueOf = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke valueOf on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Matrix.prototype.format = function(options) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke format on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix
   * @returns {string} str
   */ Matrix.prototype.toString = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toString on a Matrix interface");
    };
    return Matrix;
}, {
    isClass: true
});

});

parcelRegister("4zJhG", function(module, exports) {

$parcel$export(module.exports, "createMedian", function () { return $354d8ed1325ca98d$export$cdebf3fc89add777; });

var $fbkGg = parcelRequire("fbkGg");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");

var $dYvNV = parcelRequire("dYvNV");
var $354d8ed1325ca98d$var$name = "median";
var $354d8ed1325ca98d$var$dependencies = [
    "typed",
    "add",
    "divide",
    "compare",
    "partitionSelect"
];
var $354d8ed1325ca98d$export$cdebf3fc89add777 = /* #__PURE__ */ (0, $jKx4O.factory)($354d8ed1325ca98d$var$name, $354d8ed1325ca98d$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, divide = _ref.divide, compare = _ref.compare, partitionSelect = _ref.partitionSelect;
    /**
   * Compute the median of a matrix or a list with values. The values are
   * sorted and the middle value is returned. In case of an even number of
   * values, the average of the two middle values is returned.
   * Supported types of values are: Number, BigNumber, Unit
   *
   * In case of a (multi dimensional) array or matrix, the median of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.median(a, b, c, ...)
   *     math.median(A)
   *
   * Examples:
   *
   *     math.median(5, 2, 7)        // returns 5
   *     math.median([3, -1, 5, 7])  // returns 4
   *
   * See also:
   *
   *     mean, min, max, sum, prod, std, variance, quantileSeq
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The median
   */ var median = typed($354d8ed1325ca98d$var$name, {
        // median([a, b, c, d, ...])
        "Array | Matrix": _median,
        // median([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement median(A, dim)
            throw new Error("median(A, dim) is not yet supported"); // return reduce(arguments[0], arguments[1], ...)
        },
        // median(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $fbkGg.containsCollections)(args)) throw new TypeError("Scalar values expected in function median");
            return _median(args);
        }
    });
    /**
   * Recursively calculate the median of an n-dimensional array
   * @param {Array} array
   * @return {Number} median
   * @private
   */ function _median(array) {
        try {
            array = (0, $YkZ7e.flatten)(array.valueOf());
            var num = array.length;
            if (num === 0) throw new Error("Cannot calculate median of an empty array");
            if (num % 2 === 0) {
                // even: return the average of the two middle values
                var mid = num / 2 - 1;
                var right = partitionSelect(array, mid + 1); // array now partitioned at mid + 1, take max of left part
                var left = array[mid];
                for(var i = 0; i < mid; ++i)if (compare(array[i], left) > 0) left = array[i];
                return middle2(left, right);
            } else {
                // odd: return the middle value
                var m = partitionSelect(array, (num - 1) / 2);
                return middle(m);
            }
        } catch (err) {
            throw (0, $dYvNV.improveErrorMessage)(err, "median");
        }
    } // helper function to type check the middle value of the array
    var middle = typed({
        "number | BigNumber | Complex | Unit": function numberBigNumberComplexUnit(value) {
            return value;
        }
    }); // helper function to type check the two middle value of the array
    var middle2 = typed({
        "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function numberBigNumberComplexUnitNumberBigNumberComplexUnit(left, right) {
            return divide(add(left, right), 2);
        }
    });
    return median;
});

});

parcelRegister("2Eoq5", function(module, exports) {

$parcel$export(module.exports, "createMod", function () { return $1ee2426decd3eed1$export$735bb6c30160c058; });

var $jKx4O = parcelRequire("jKx4O");

var $16D4T = parcelRequire("16D4T");

var $e6fFw = parcelRequire("e6fFw");

var $5Sg22 = parcelRequire("5Sg22");

var $1Gmbc = parcelRequire("1Gmbc");

var $272zs = parcelRequire("272zs");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $cqeCl = parcelRequire("cqeCl");
var $1ee2426decd3eed1$var$name = "mod";
var $1ee2426decd3eed1$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $1ee2426decd3eed1$export$735bb6c30160c058 = /* #__PURE__ */ (0, $jKx4O.factory)($1ee2426decd3eed1$var$name, $1ee2426decd3eed1$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $5Sg22.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculates the modulus, the remainder of an integer division.
   *
   * For matrices, the function is evaluated element wise.
   *
   * The modulus is defined as:
   *
   *     x - y * floor(x / y)
   *
   * See https://en.wikipedia.org/wiki/Modulo_operation.
   *
   * Syntax:
   *
   *    math.mod(x, y)
   *
   * Examples:
   *
   *    math.mod(8, 3)                // returns 2
   *    math.mod(11, 2)               // returns 1
   *
   *    function isOdd(x) {
   *      return math.mod(x, 2) != 0
   *    }
   *
   *    isOdd(2)                      // returns false
   *    isOdd(3)                      // returns true
   *
   * See also:
   *
   *    divide
   *
   * @param  {number | BigNumber | Fraction | Array | Matrix} x Dividend
   * @param  {number | BigNumber | Fraction | Array | Matrix} y Divisor
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
   */ var mod = typed($1ee2426decd3eed1$var$name, {
        "number, number": (0, $cqeCl.modNumber),
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return y.isZero() ? x : x.mod(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.mod(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, mod, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, mod, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, mod, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, mod);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return mod(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return mod(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return mod(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, mod, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, mod, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, mod, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, mod, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, mod, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, mod, true).valueOf();
        }
    });
    return mod;
});

});

parcelRegister("lEqFf", function(module, exports) {

$parcel$export(module.exports, "createMode", function () { return $fc32046284c15ee3$export$822530980ba269d9; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $fc32046284c15ee3$var$name = "mode";
var $fc32046284c15ee3$var$dependencies = [
    "typed",
    "isNaN",
    "isNumeric"
];
var $fc32046284c15ee3$export$822530980ba269d9 = /* #__PURE__ */ (0, $jKx4O.factory)($fc32046284c15ee3$var$name, $fc32046284c15ee3$var$dependencies, function(_ref) {
    var typed = _ref.typed, isNaN = _ref.isNaN, isNumeric = _ref.isNumeric;
    /**
  * Computes the mode of a set of numbers or a list with values(numbers or characters).
  * If there are more than one modes, it returns a list of those values.
  *
  * Syntax:
  *
  *     math.mode(a, b, c, ...)
  *     math.mode(A)
  *
  * Examples:
  *
  *     math.mode(2, 1, 4, 3, 1)                            // returns [1]
  *     math.mode([1, 2.7, 3.2, 4, 2.7])                    // returns [2.7]
  *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
  *     math.mode('a','a','b','c')                           // returns ["a"]
  *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
  *
  * See also:
  *
  *     median,
  *     mean
  *
  * @param {... *} args  A single matrix
  * @return {*} The mode of all values
  */ return typed($fc32046284c15ee3$var$name, {
        "Array | Matrix": _mode,
        "...": function _(args) {
            return _mode(args);
        }
    });
    /**
   * Calculates the mode in an 1-dimensional array
   * @param {Array} values
   * @return {Array} mode
   * @private
   */ function _mode(values) {
        values = (0, $YkZ7e.flatten)(values.valueOf());
        var num = values.length;
        if (num === 0) throw new Error("Cannot calculate mode of an empty array");
        var count = {};
        var mode = [];
        var max = 0;
        for(var i = 0; i < values.length; i++){
            var value = values[i];
            if (isNumeric(value) && isNaN(value)) throw new Error("Cannot calculate mode of an array containing NaN values");
            if (!(value in count)) count[value] = 0;
            count[value]++;
            if (count[value] === max) mode.push(value);
            else if (count[value] > max) {
                max = count[value];
                mode = [
                    value
                ];
            }
        }
        return mode;
    }
});

});

parcelRegister("lTAeZ", function(module, exports) {

$parcel$export(module.exports, "createMultinomial", function () { return $ff0ad8b05f19fef5$export$b15aee1001d110; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");
var $ff0ad8b05f19fef5$var$name = "multinomial";
var $ff0ad8b05f19fef5$var$dependencies = [
    "typed",
    "add",
    "divide",
    "multiply",
    "factorial",
    "isInteger",
    "isPositive"
];
var $ff0ad8b05f19fef5$export$b15aee1001d110 = /* #__PURE__ */ (0, $jKx4O.factory)($ff0ad8b05f19fef5$var$name, $ff0ad8b05f19fef5$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, divide = _ref.divide, multiply = _ref.multiply, factorial = _ref.factorial, isInteger = _ref.isInteger, isPositive = _ref.isPositive;
    /**
   * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
   *
   * multinomial takes one array of integers as an argument.
   * The following condition must be enforced: every ai <= 0
   *
   * Syntax:
   *
   *     math.multinomial(a) // a is an array type
   *
   * Examples:
   *
   *    math.multinomial([1,2,1]) // returns 12
   *
   * See also:
   *
   *    combinations, factorial
   *
   * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
   * @return {Number | BigNumber}         Multinomial coefficient.
   */ return typed($ff0ad8b05f19fef5$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var sum = 0;
            var denom = 1;
            (0, $fbkGg.deepForEach)(a, function(ai) {
                if (!isInteger(ai) || !isPositive(ai)) throw new TypeError("Positive integer value expected in function multinomial");
                sum = add(sum, ai);
                denom = multiply(denom, factorial(ai));
            });
            return divide(factorial(sum), denom);
        }
    });
});

});

parcelRegister("a8T6u", function(module, exports) {

$parcel$export(module.exports, "createMultiply", function () { return $76256531e927af3d$export$86d08fd318fa07c8; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");

var $1Gmbc = parcelRequire("1Gmbc");

var $5ntii = parcelRequire("5ntii");
var $76256531e927af3d$var$name = "multiply";
var $76256531e927af3d$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "multiplyScalar",
    "equalScalar"
];
var $76256531e927af3d$export$86d08fd318fa07c8 = /* #__PURE__ */ (0, $jKx4O.factory)($76256531e927af3d$var$name, $76256531e927af3d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, addScalar = _ref.addScalar, multiplyScalar = _ref.multiplyScalar, equalScalar = _ref.equalScalar;
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Multiply two or more values, `x * y`.
   * For matrices, the matrix product is calculated.
   *
   * Syntax:
   *
   *    math.multiply(x, y)
   *    math.multiply(x, y, z, ...)
   *
   * Examples:
   *
   *    math.multiply(4, 5.2)        // returns number 20.8
   *    math.multiply(2, 3, 4)       // returns number 24
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.multiply(a, b)          // returns Complex 5 + 14i
   *
   *    const c = [[1, 2], [4, 3]]
   *    const d = [[1, 2, 3], [3, -4, 7]]
   *    math.multiply(c, d)          // returns Array [[7, -6, 17], [13, -4, 33]]
   *
   *    const e = math.unit('2.1 km')
   *    math.multiply(3, e)          // returns Unit 6.3 km
   *
   * See also:
   *
   *    divide, prod, cross, dot
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
   */ var multiply = typed($76256531e927af3d$var$name, (0, $glBd7.extend)({
        // we extend the signatures of multiplyScalar with signatures dealing with matrices
        "Array, Array": function ArrayArray(x, y) {
            // check dimensions
            _validateMatrixDimensions((0, $YkZ7e.arraySize)(x), (0, $YkZ7e.arraySize)(y)); // use dense matrix implementation
            var m = multiply(matrix(x), matrix(y)); // return array or scalar
            return (0, $7E0JQ.isMatrix)(m) ? m.valueOf() : m;
        },
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // dimensions
            var xsize = x.size();
            var ysize = y.size(); // check dimensions
            _validateMatrixDimensions(xsize, ysize); // process dimensions
            if (xsize.length === 1) {
                // process y dimensions
                if (ysize.length === 1) // Vector * Vector
                return _multiplyVectorVector(x, y, xsize[0]);
                 // Vector * Matrix
                return _multiplyVectorMatrix(x, y);
            } // process y dimensions
            if (ysize.length === 1) // Matrix * Vector
            return _multiplyMatrixVector(x, y);
             // Matrix * Matrix
            return _multiplyMatrixMatrix(x, y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use Matrix * Matrix implementation
            return multiply(x, matrix(y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use Matrix * Matrix implementation
            return multiply(matrix(x, y.storage()), y);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        },
        "any, any": multiplyScalar,
        "any, any, ...any": function anyAnyAny(x, y, rest) {
            var result = multiply(x, y);
            for(var i = 0; i < rest.length; i++)result = multiply(result, rest[i]);
            return result;
        }
    }, multiplyScalar.signatures));
    function _validateMatrixDimensions(size1, size2) {
        // check left operand dimensions
        switch(size1.length){
            case 1:
                // check size2
                switch(size2.length){
                    case 1:
                        // Vector x Vector
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                        break;
                    case 2:
                        // Vector x Matrix
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vector length (" + size1[0] + ") must match Matrix rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            case 2:
                // check size2
                switch(size2.length){
                    case 1:
                        // Matrix x Vector
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + size1[1] + ") must match Vector length (" + size2[0] + ")");
                        break;
                    case 2:
                        // Matrix x Matrix
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + size1[1] + ") must match Matrix B rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            default:
                throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + size1.length + " dimensions)");
        }
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (N)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {number}             Scalar value
   */ function _multiplyVectorVector(a, b, n) {
        // check empty vector
        if (n === 0) throw new Error("Cannot multiply two empty vectors");
         // a dense
        var adata = a._data;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bdt = b._datatype; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result (do not initialize it with zero)
        var c = mf(adata[0], bdata[0]); // loop data
        for(var i = 1; i < n; i++)// multiply and accumulate
        c = af(c, mf(adata[i], bdata[i]));
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Matrix         (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorMatrix(a, b) {
        // process storage
        if (b.storage() !== "dense") throw new Error("Support for SparseMatrix not implemented");
        return _multiplyVectorDenseMatrix(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Dense Matrix   (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var alength = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix columns
        for(var j = 0; j < bcolumns; j++){
            // sum (do not initialize it with zero)
            var sum = mf(adata[0], bdata[0][j]); // loop vector
            for(var i = 1; i < alength; i++)// multiply & accumulate
            sum = af(sum, mf(adata[i], bdata[i][j]));
            c[j] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {Matrix}             Dense Vector   (M)
   */ var _multiplyMatrixVector = typed("_multiplyMatrixVector", {
        "DenseMatrix, any": _multiplyDenseMatrixVector,
        "SparseMatrix, any": _multiplySparseMatrixVector
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Matrix         (NxC)
   *
   * @return {Matrix}             Matrix         (MxC)
   */ var _multiplyMatrixMatrix = typed("_multiplyMatrixMatrix", {
        "DenseMatrix, DenseMatrix": _multiplyDenseMatrixDenseMatrix,
        "DenseMatrix, SparseMatrix": _multiplyDenseMatrixSparseMatrix,
        "SparseMatrix, DenseMatrix": _multiplySparseMatrixDenseMatrix,
        "SparseMatrix, SparseMatrix": _multiplySparseMatrixSparseMatrix
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix  (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             Dense Vector (M)
   */ function _multiplyDenseMatrixVector(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // sum (do not initialize it with zero)
            var sum = mf(row[0], bdata[0]); // loop matrix a columns
            for(var j = 1; j < acolumns; j++)// multiply & accumulate
            sum = af(sum, mf(row[j], bdata[j]));
            c[i] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            DenseMatrix    (NxC)
   *
   * @return {Matrix}             DenseMatrix    (MxC)
   */ function _multiplyDenseMatrixDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // initialize row array
            c[i] = []; // loop matrix b columns
            for(var j = 0; j < bcolumns; j++){
                // sum (avoid initializing sum to zero)
                var sum = mf(row[0], bdata[0][j]); // loop matrix a columns
                for(var x = 1; x < acolumns; x++)// multiply & accumulate
                sum = af(sum, mf(row[x], bdata[x][j]));
                c[i][j] = sum;
            }
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            SparseMatrix   (NxC)
   *
   * @return {Matrix}             SparseMatrix   (MxC)
   */ function _multiplyDenseMatrixSparseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate b matrix
        if (!bvalues) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
         // rows & columns
        var arows = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = b.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // indeces in column jb
            var kb0 = bptr[jb];
            var kb1 = bptr[jb + 1]; // do not process column jb if no data exists
            if (kb1 > kb0) {
                // last row mark processed
                var last = 0; // loop a rows
                for(var i = 0; i < arows; i++){
                    // column mark
                    var mark = i + 1; // C[i, jb]
                    var cij = void 0; // values in b column j
                    for(var kb = kb0; kb < kb1; kb++){
                        // row
                        var ib = bindex[kb]; // check value has been initialized
                        if (last !== mark) {
                            // first value in column jb
                            cij = mf(adata[i][ib], bvalues[kb]); // update mark
                            last = mark;
                        } else // accumulate value
                        cij = af(cij, mf(adata[i][ib], bvalues[kb]));
                    } // check column has been processed and value != 0
                    if (last === mark && !eq(cij, zero)) {
                        // push row & value
                        cindex.push(i);
                        cvalues.push(cij);
                    }
                }
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix    (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             SparseMatrix    (M, 1)
   */ function _multiplySparseMatrixVector(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0]; // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // update ptr
        cptr[0] = 0; // rows in b
        for(var ib = 0; ib < brows; ib++){
            // b[ib]
            var vbi = bdata[ib]; // check b[ib] != 0, avoid loops
            if (!eq(vbi, zero)) // A values & index in ib column
            for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                // a row
                var ia = aindex[ka]; // check value exists in current j
                if (!w[ia]) {
                    // ia is new entry in j
                    w[ia] = true; // add i to pattern of C
                    cindex.push(ia); // x(ia) = A
                    x[ia] = mf(vbi, avalues[ka]);
                } else // i exists in C already
                x[ia] = af(x[ia], mf(vbi, avalues[ka]));
            }
        } // copy values from x to column jb of c
        for(var p1 = cindex.length, p = 0; p < p1; p++){
            // row
            var ic = cindex[p]; // copy value
            cvalues[p] = x[ic];
        } // update ptr
        cptr[1] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                1
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            DenseMatrix       (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixDenseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        var bcolumns = b._size[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // rows in jb
            for(var ib = 0; ib < brows; ib++){
                // b[ib, jb]
                var vbij = bdata[ib][jb]; // check b[ib, jb] != 0, avoid loops
                if (!eq(vbij, zero)) // A values & index in ib column
                for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // a row
                    var ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(vbij, avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(vbij, avalues[ka]));
                }
            } // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            SparseMatrix      (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixSparseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var bcolumns = b._size[1]; // flag indicating both matrices (a & b) contain data
        var values = avalues && bvalues; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = values ? [] : undefined; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // variables
        var ka, ka0, ka1, kb, kb0, kb1, ia, ib; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // B values & index in j
            for(kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++){
                // b row
                ib = bindex[kb]; // check we need to process values
                if (values) // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(bvalues[kb], avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
                }
                else // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia);
                    }
                }
            } // check we need to process matrix values (pattern matrix)
            if (values) // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    return multiply;
});

});

parcelRegister("gOPHp", function(module, exports) {

$parcel$export(module.exports, "createMultiplyScalar", function () { return $c3e96b3cc0d587f3$export$37dc64d7e8361b32; });

var $jKx4O = parcelRequire("jKx4O");

var $cqeCl = parcelRequire("cqeCl");
var $c3e96b3cc0d587f3$var$name = "multiplyScalar";
var $c3e96b3cc0d587f3$var$dependencies = [
    "typed"
];
var $c3e96b3cc0d587f3$export$37dc64d7e8361b32 = /* #__PURE__ */ (0, $jKx4O.factory)($c3e96b3cc0d587f3$var$name, $c3e96b3cc0d587f3$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Multiply two scalar values, `x * y`.
   * This function is meant for internal use: it is used by the public function
   * `multiply`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit}     Multiplication of `x` and `y`
   * @private
   */ var multiplyScalar = typed("multiplyScalar", {
        "number, number": (0, $cqeCl.multiplyNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.mul(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.times(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.mul(y);
        },
        "number | Fraction | BigNumber | Complex, Unit": function numberFractionBigNumberComplexUnit(x, y) {
            var res = y.clone();
            res.value = res.value === null ? res._normalize(x) : multiplyScalar(res.value, x);
            return res;
        },
        "Unit, number | Fraction | BigNumber | Complex": function UnitNumberFractionBigNumberComplex(x, y) {
            var res = x.clone();
            res.value = res.value === null ? res._normalize(y) : multiplyScalar(res.value, y);
            return res;
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return x.multiply(y);
        }
    });
    return multiplyScalar;
});

});

parcelRegister("3tQmP", function(module, exports) {

$parcel$export(module.exports, "createNorm", function () { return $288cb394586aa334$export$ce85a9d2952c2966; });

var $jKx4O = parcelRequire("jKx4O");
var $288cb394586aa334$var$name = "norm";
var $288cb394586aa334$var$dependencies = [
    "typed",
    "abs",
    "add",
    "pow",
    "conj",
    "sqrt",
    "multiply",
    "equalScalar",
    "larger",
    "smaller",
    "matrix"
];
var $288cb394586aa334$export$ce85a9d2952c2966 = /* #__PURE__ */ (0, $jKx4O.factory)($288cb394586aa334$var$name, $288cb394586aa334$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, add = _ref.add, pow = _ref.pow, conj = _ref.conj, sqrt = _ref.sqrt, multiply = _ref.multiply, equalScalar = _ref.equalScalar, larger = _ref.larger, smaller = _ref.smaller, matrix = _ref.matrix;
    /**
   * Calculate the norm of a number, vector or matrix.
   *
   * The second parameter p is optional. If not provided, it defaults to 2.
   *
   * Syntax:
   *
   *    math.norm(x)
   *    math.norm(x, p)
   *
   * Examples:
   *
   *    math.abs(-3.5)                         // returns 3.5
   *    math.norm(-3.5)                        // returns 3.5
   *
   *    math.norm(math.complex(3, -4))         // returns 5
   *
   *    math.norm([1, 2, -3], Infinity)        // returns 3
   *    math.norm([1, 2, -3], -Infinity)       // returns 1
   *
   *    math.norm([3, 4], 2)                   // returns 5
   *
   *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
   *    math.norm([[1, 2], [3, 4]], 'inf')     // returns 7
   *    math.norm([[1, 2], [3, 4]], 'fro')     // returns 5.477225575051661
   *
   * See also:
   *
   *    abs, hypot
   *
   * @param  {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the norm
   * @param  {number | BigNumber | string} [p=2]
   *            Vector space.
   *            Supported numbers include Infinity and -Infinity.
   *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
   * @return {number | BigNumber} the p-norm
   */ var norm = typed($288cb394586aa334$var$name, {
        number: Math.abs,
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            // norm(x) = abs(x)
            return x.abs();
        },
        "boolean": function boolean(x) {
            // norm(x) = abs(x)
            return Math.abs(x);
        },
        Array: function Array(x) {
            return _norm(matrix(x), 2);
        },
        Matrix: function Matrix(x) {
            return _norm(x, 2);
        },
        "number | Complex | BigNumber | boolean, number | BigNumber | string": function numberComplexBigNumberBooleanNumberBigNumberString(x) {
            // ignore second parameter, TODO: remove the option of second parameter for these types
            return norm(x);
        },
        "Array, number | BigNumber | string": function ArrayNumberBigNumberString(x, p) {
            return _norm(matrix(x), p);
        },
        "Matrix, number | BigNumber | string": function MatrixNumberBigNumberString(x, p) {
            return _norm(x, p);
        }
    });
    /**
   * Calculate the norm for an array
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _norm(x, p) {
        // size
        var sizeX = x.size(); // check if it is a vector
        if (sizeX.length === 1) {
            // check p
            if (p === Number.POSITIVE_INFINITY || p === "inf") {
                // norm(x, Infinity) = max(abs(x))
                var pinf = 0; // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    var v = abs(value);
                    if (larger(v, pinf)) pinf = v;
                }, true);
                return pinf;
            }
            if (p === Number.NEGATIVE_INFINITY || p === "-inf") {
                // norm(x, -Infinity) = min(abs(x))
                var ninf; // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    var v = abs(value);
                    if (!ninf || smaller(v, ninf)) ninf = v;
                }, true);
                return ninf || 0;
            }
            if (p === "fro") return _norm(x, 2);
            if (typeof p === "number" && !isNaN(p)) {
                // check p != 0
                if (!equalScalar(p, 0)) {
                    // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
                    var n = 0; // skip zeros since abs(0) === 0
                    x.forEach(function(value) {
                        n = add(pow(abs(value), p), n);
                    }, true);
                    return pow(n, 1 / p);
                }
                return Number.POSITIVE_INFINITY;
            } // invalid parameter value
            throw new Error("Unsupported parameter value");
        } // MxN matrix
        if (sizeX.length === 2) {
            // check p
            if (p === 1) {
                // norm(x) = the largest column sum
                var c = []; // result
                var maxc = 0; // skip zeros since abs(0) == 0
                x.forEach(function(value, index) {
                    var j = index[1];
                    var cj = add(c[j] || 0, abs(value));
                    if (larger(cj, maxc)) maxc = cj;
                    c[j] = cj;
                }, true);
                return maxc;
            }
            if (p === Number.POSITIVE_INFINITY || p === "inf") {
                // norm(x) = the largest row sum
                var r = []; // result
                var maxr = 0; // skip zeros since abs(0) == 0
                x.forEach(function(value, index) {
                    var i = index[0];
                    var ri = add(r[i] || 0, abs(value));
                    if (larger(ri, maxr)) maxr = ri;
                    r[i] = ri;
                }, true);
                return maxr;
            }
            if (p === "fro") {
                // norm(x) = sqrt(sum(diag(x'x)))
                var fro = 0;
                x.forEach(function(value, index) {
                    fro = add(fro, multiply(value, conj(value)));
                });
                return abs(sqrt(fro));
            }
            if (p === 2) // not implemented
            throw new Error("Unsupported parameter value, missing implementation of matrix singular value decomposition");
             // invalid parameter value
            throw new Error("Unsupported parameter value");
        }
    }
    return norm;
});

});

parcelRegister("2Qers", function(module, exports) {

$parcel$export(module.exports, "createNot", function () { return $211ba3f247653fd2$export$8dbfb388cd6a8853; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $e6Xsb = parcelRequire("e6Xsb");
var $211ba3f247653fd2$var$name = "not";
var $211ba3f247653fd2$var$dependencies = [
    "typed"
];
var $211ba3f247653fd2$export$8dbfb388cd6a8853 = /* #__PURE__ */ (0, $jKx4O.factory)($211ba3f247653fd2$var$name, $211ba3f247653fd2$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Logical `not`. Flips boolean value of a given parameter.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.not(x)
   *
   * Examples:
   *
   *    math.not(2)      // returns false
   *    math.not(0)      // returns true
   *    math.not(true)   // returns false
   *
   *    a = [2, -7, 0]
   *    math.not(a)      // returns [false, false, true]
   *
   * See also:
   *
   *    and, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when input is a zero or empty value.
   */ var not = typed($211ba3f247653fd2$var$name, {
        number: (0, $e6Xsb.notNumber),
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        BigNumber: function BigNumber(x) {
            return x.isZero() || x.isNaN();
        },
        Unit: function Unit(x) {
            return x.value !== null ? not(x.value) : true;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, not);
        }
    });
    return not;
});

});

parcelRegister("XGqZk", function(module, exports) {

$parcel$export(module.exports, "createNthRoot", function () { return $0b366d5ea2fabc46$export$964e38ef60b1ac68; });

var $jKx4O = parcelRequire("jKx4O");

var $9vlUQ = parcelRequire("9vlUQ");

var $16D4T = parcelRequire("16D4T");

var $c7RNU = parcelRequire("c7RNU");

var $1Gmbc = parcelRequire("1Gmbc");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $cqeCl = parcelRequire("cqeCl");
var $0b366d5ea2fabc46$var$name = "nthRoot";
var $0b366d5ea2fabc46$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber"
];
var $0b366d5ea2fabc46$export$964e38ef60b1ac68 = /* #__PURE__ */ (0, $jKx4O.factory)($0b366d5ea2fabc46$var$name, $0b366d5ea2fabc46$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, _BigNumber = _ref.BigNumber;
    var algorithm01 = (0, $9vlUQ.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $c7RNU.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the nth root of a value.
   * The principal nth root of a positive real number A, is the positive real
   * solution of the equation
   *
   *     x^root = A
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *     math.nthRoot(a)
   *     math.nthRoot(a, root)
   *
   * Examples:
   *
   *     math.nthRoot(9, 2)    // returns 3, as 3^2 == 9
   *     math.sqrt(9)          // returns 3, as 3^2 == 9
   *     math.nthRoot(64, 3)   // returns 4, as 4^3 == 64
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param {number | BigNumber | Array | Matrix | Complex} a
   *              Value for which to calculate the nth root
   * @param {number | BigNumber} [root=2]    The root.
   * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
   */ var complexErr = "Complex number not supported in function nthRoot. Use nthRoots instead.";
    var nthRoot = typed($0b366d5ea2fabc46$var$name, {
        number: function number(x) {
            return (0, $cqeCl.nthRootNumber)(x, 2);
        },
        "number, number": (0, $cqeCl.nthRootNumber),
        BigNumber: function BigNumber(x) {
            return _bigNthRoot(x, new _BigNumber(2));
        },
        Complex: function Complex(x) {
            throw new Error(complexErr);
        },
        "Complex, number": function ComplexNumber(x, y) {
            throw new Error(complexErr);
        },
        "BigNumber, BigNumber": _bigNthRoot,
        "Array | Matrix": function ArrayMatrix(x) {
            return nthRoot(x, 2);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse + sparse
            return algorithm06(x, y, nthRoot);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, nthRoot, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // dense + sparse
            return algorithm01(x, y, nthRoot, false);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, nthRoot);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return nthRoot(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return nthRoot(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return nthRoot(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, nthRoot, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, nthRoot, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse - scalar
            return algorithm11(y, x, nthRoot, true);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, nthRoot, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return nthRoot(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return nthRoot(x, matrix(y)).valueOf();
        }
    });
    return nthRoot;
    /**
   * Calculate the nth root of a for BigNumbers, solve x^root == a
   * https://rosettacode.org/wiki/Nth_root#JavaScript
   * @param {BigNumber} a
   * @param {BigNumber} root
   * @private
   */ function _bigNthRoot(a, root) {
        var precision = _BigNumber.precision;
        var Big = _BigNumber.clone({
            precision: precision + 2
        });
        var zero = new _BigNumber(0);
        var one = new Big(1);
        var inv = root.isNegative();
        if (inv) root = root.neg();
        if (root.isZero()) throw new Error("Root must be non-zero");
        if (a.isNegative() && !root.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
         // edge cases zero and infinity
        if (a.isZero()) return inv ? new Big(Infinity) : 0;
        if (!a.isFinite()) return inv ? zero : a;
        var x = a.abs().pow(one.div(root)); // If a < 0, we require that root is an odd integer,
        // so (-1) ^ (1/root) = -1
        x = a.isNeg() ? x.neg() : x;
        return new _BigNumber((inv ? one.div(x) : x).toPrecision(precision));
    }
});
var $0b366d5ea2fabc46$export$f098cf3c4ef0f7ef = /* #__PURE__ */ (0, $jKx4O.factory)($0b366d5ea2fabc46$var$name, [
    "typed"
], function(_ref2) {
    var typed = _ref2.typed;
    return typed($0b366d5ea2fabc46$var$name, {
        number: (0, $cqeCl.nthRootNumber),
        "number, number": (0, $cqeCl.nthRootNumber)
    });
});

});

parcelRegister("cFSYl", function(module, exports) {

$parcel$export(module.exports, "createNthRoots", function () { return $93a3f4b856cbea7e$export$36e27b45d2aa738c; });

var $jKx4O = parcelRequire("jKx4O");
var $93a3f4b856cbea7e$var$name = "nthRoots";
var $93a3f4b856cbea7e$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $93a3f4b856cbea7e$export$36e27b45d2aa738c = /* #__PURE__ */ (0, $jKx4O.factory)($93a3f4b856cbea7e$var$name, $93a3f4b856cbea7e$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, divideScalar = _ref.divideScalar, Complex = _ref.Complex;
    /**
   * Calculate the nth roots of a value.
   * An nth root of a positive real number A,
   * is a positive real solution of the equation "x^root = A".
   * This function returns an array of complex values.
   *
   * Syntax:
   *
   *    math.nthRoots(x)
   *    math.nthRoots(x, root)
   *
   * Examples:
   *
   *    math.nthRoots(1)
   *    // returns [
   *    //   {re: 1, im: 0},
   *    //   {re: -1, im: 0}
   *    // ]
   *    nthRoots(1, 3)
   *    // returns [
   *    //   { re: 1, im: 0 },
   *    //   { re: -0.4999999999999998, im: 0.8660254037844387 },
   *    //   { re: -0.5000000000000004, im: -0.8660254037844385 }
   *    ]
   *
   * See also:
   *
   *    nthRoot, pow, sqrt
   *
   * @param {number | BigNumber | Fraction | Complex | Array | Matrix} x Number to be rounded
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}            Rounded value
   */ var nthRoots = typed($93a3f4b856cbea7e$var$name, {
        Complex: function Complex(x) {
            return _nthComplexRoots(x, 2);
        },
        "Complex, number": _nthComplexRoots
    });
    /**
   * Each function here returns a real multiple of i as a Complex value.
   * @param  {number} val
   * @return {Complex} val, i*val, -val or -i*val for index 0, 1, 2, 3
   */ // This is used to fix float artifacts for zero-valued components.
    var _calculateExactResult = [
        function realPos(val) {
            return new Complex(val, 0);
        },
        function imagPos(val) {
            return new Complex(0, val);
        },
        function realNeg(val) {
            return new Complex(-val, 0);
        },
        function imagNeg(val) {
            return new Complex(0, -val);
        }
    ];
    /**
   * Calculate the nth root of a Complex Number a using De Movire's Theorem.
   * @param  {Complex} a
   * @param  {number} root
   * @return {Array} array of n Complex Roots
   */ function _nthComplexRoots(a, root) {
        if (root < 0) throw new Error("Root must be greater than zero");
        if (root === 0) throw new Error("Root must be non-zero");
        if (root % 1 !== 0) throw new Error("Root must be an integer");
        if (a === 0 || a.abs() === 0) return [
            new Complex(0, 0)
        ];
        var aIsNumeric = typeof a === "number";
        var offset; // determine the offset (argument of a)/(pi/2)
        if (aIsNumeric || a.re === 0 || a.im === 0) {
            if (aIsNumeric) offset = 2 * +(a < 0); // numeric value on the real axis
            else if (a.im === 0) offset = 2 * +(a.re < 0); // complex value on the real axis
            else offset = 2 * +(a.im < 0) + 1; // complex value on the imaginary axis
        }
        var arg = a.arg();
        var abs = a.abs();
        var roots = [];
        var r = Math.pow(abs, 1 / root);
        for(var k = 0; k < root; k++){
            var halfPiFactor = (offset + 4 * k) / root;
            /**
       * If (offset + 4*k)/root is an integral multiple of pi/2
       * then we can produce a more exact result.
       */ if (halfPiFactor === Math.round(halfPiFactor)) {
                roots.push(_calculateExactResult[halfPiFactor % 4](r));
                continue;
            }
            roots.push(new Complex({
                r: r,
                phi: (arg + 2 * Math.PI * k) / root
            }));
        }
        return roots;
    }
    return nthRoots;
});

});

parcelRegister("5Tgnr", function(module, exports) {

$parcel$export(module.exports, "createNumber", function () { return $449ecaee35fe396a$export$763ee9f6477981ab; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $449ecaee35fe396a$var$name = "number";
var $449ecaee35fe396a$var$dependencies = [
    "typed"
];
var $449ecaee35fe396a$export$763ee9f6477981ab = /* #__PURE__ */ (0, $jKx4O.factory)($449ecaee35fe396a$var$name, $449ecaee35fe396a$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Create a number or convert a string, boolean, or unit to a number.
   * When value is a matrix, all elements will be converted to number.
   *
   * Syntax:
   *
   *    math.number(value)
   *    math.number(unit, valuelessUnit)
   *
   * Examples:
   *
   *    math.number(2)                         // returns number 2
   *    math.number('7.2')                     // returns number 7.2
   *    math.number(true)                      // returns number 1
   *    math.number([true, false, true, true]) // returns [1, 0, 1, 1]
   *    math.number(math.unit('52cm'), 'm')    // returns 0.52
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
   * @return {number | Array | Matrix} The created number
   */ var number = typed("number", {
        "": function _() {
            return 0;
        },
        number: function number(x) {
            return x;
        },
        string: function string(x) {
            if (x === "NaN") return NaN;
            var num = Number(x);
            if (isNaN(num)) throw new SyntaxError('String "' + x + '" is no valid number');
            return num;
        },
        BigNumber: function BigNumber(x) {
            return x.toNumber();
        },
        Fraction: function Fraction(x) {
            return x.valueOf();
        },
        Unit: function Unit(x) {
            throw new Error("Second argument with valueless unit expected");
        },
        "null": function _null(x) {
            return 0;
        },
        "Unit, string | Unit": function UnitStringUnit(unit, valuelessUnit) {
            return unit.toNumber(valuelessUnit);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, number);
        }
    }); // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"number","value":"2.3"}
    //
    // into a number 2.3
    number.fromJSON = function(json) {
        return parseFloat(json.value);
    };
    return number;
});

});

parcelRegister("lb7yi", function(module, exports) {

$parcel$export(module.exports, "createNumeric", function () { return $f6b07bc1eb6ef0e3$export$e3cf2d123164e554; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $94t5G = parcelRequire("94t5G");
var $f6b07bc1eb6ef0e3$var$name = "numeric";
var $f6b07bc1eb6ef0e3$var$dependencies = [
    "number",
    "?bignumber",
    "?fraction"
];
var $f6b07bc1eb6ef0e3$export$e3cf2d123164e554 = /* #__PURE__ */ (0, $jKx4O.factory)($f6b07bc1eb6ef0e3$var$name, $f6b07bc1eb6ef0e3$var$dependencies, function(_ref) {
    var _number = _ref.number, bignumber = _ref.bignumber, fraction = _ref.fraction;
    var validInputTypes = {
        string: true,
        number: true,
        BigNumber: true,
        Fraction: true
    }; // Load the conversion functions for each output type
    var validOutputTypes = {
        number: function number(x) {
            return _number(x);
        },
        BigNumber: bignumber ? function(x) {
            return bignumber(x);
        } : (0, $94t5G.noBignumber),
        Fraction: fraction ? function(x) {
            return fraction(x);
        } : (0, $94t5G.noFraction)
    };
    /**
   * Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.
   *
   * Syntax:
   *
   *    math.numeric(x)
   *
   * Examples:
   *
   *    math.numeric('4')                           // returns number 4
   *    math.numeric('4', 'number')                 // returns number 4
   *    math.numeric('4', 'BigNumber')              // returns BigNumber 4
   *    math.numeric('4', 'Fraction')               // returns Fraction 4
   *    math.numeric(4, 'Fraction')                 // returns Fraction 4
   *    math.numeric(math.fraction(2, 5), 'number') // returns number 0.4
   *
   * See also:
   *
   *    number, fraction, bignumber, string, format
   *
   * @param {string | number | BigNumber | Fraction } value
   *              A numeric value or a string containing a numeric value
   * @param {string} outputType
   *              Desired numeric output type.
   *              Available values: 'number', 'BigNumber', or 'Fraction'
   * @return {number | BigNumber | Fraction}
   *              Returns an instance of the numeric in the requested type
   */ return function numeric(value, outputType) {
        var inputType = (0, $7E0JQ.typeOf)(value);
        if (!(inputType in validInputTypes)) throw new TypeError("Cannot convert " + value + ' of type "' + inputType + '"; valid input types are ' + Object.keys(validInputTypes).join(", "));
        if (!(outputType in validOutputTypes)) throw new TypeError("Cannot convert " + value + ' to type "' + outputType + '"; valid output types are ' + Object.keys(validOutputTypes).join(", "));
        if (outputType === inputType) return value;
        else return validOutputTypes[outputType](value);
    };
});

});

parcelRegister("7m6vf", function(module, exports) {

$parcel$export(module.exports, "createOnes", function () { return $55afa1d162b2e581$export$f524a435b9c16a90; });

var $7E0JQ = parcelRequire("7E0JQ");

var $5wlxr = parcelRequire("5wlxr");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $55afa1d162b2e581$var$name = "ones";
var $55afa1d162b2e581$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $55afa1d162b2e581$export$f524a435b9c16a90 = /* #__PURE__ */ (0, $jKx4O.factory)($55afa1d162b2e581$var$name, $55afa1d162b2e581$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, BigNumber = _ref.BigNumber;
    /**
   * Create a matrix filled with ones. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.ones(m)
   *    math.ones(m, format)
   *    math.ones(m, n)
   *    math.ones(m, n, format)
   *    math.ones([m, n])
   *    math.ones([m, n], format)
   *    math.ones([m, n, p, ...])
   *    math.ones([m, n, p, ...], format)
   *
   * Examples:
   *
   *    math.ones(3)                   // returns [1, 1, 1]
   *    math.ones(3, 2)                // returns [[1, 1], [1, 1], [1, 1]]
   *    math.ones(3, 2, 'dense')       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.ones(math.size(A))       // returns [[1, 1, 1], [1, 1, 1]]
   *
   * See also:
   *
   *    zeros, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix | number}  A matrix filled with ones
   */ return typed("ones", {
        "": function _() {
            return config.matrix === "Array" ? _ones([]) : _ones([], "default");
        },
        // math.ones(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _ones(size, format);
            } else if (config.matrix === "Array") return _ones(size);
            else return _ones(size, "default");
        },
        Array: _ones,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _ones(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _ones(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with ones
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _ones(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(1) : 1;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $YkZ7e.resize)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $7E0JQ.isBigNumber)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $5wlxr.isInteger)(value) || value < 0) throw new Error("Parameters in function ones must be positive integers");
        });
    }
});

});

parcelRegister("lfgmk", function(module, exports) {

$parcel$export(module.exports, "createOr", function () { return $f777b04285aa8213$export$3d19b09907d6fd4a; });

var $e6fFw = parcelRequire("e6fFw");

var $272zs = parcelRequire("272zs");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $5Sg22 = parcelRequire("5Sg22");

var $jKx4O = parcelRequire("jKx4O");

var $e6Xsb = parcelRequire("e6Xsb");
var $f777b04285aa8213$var$name = "or";
var $f777b04285aa8213$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $f777b04285aa8213$export$3d19b09907d6fd4a = /* #__PURE__ */ (0, $jKx4O.factory)($f777b04285aa8213$var$name, $f777b04285aa8213$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $5Sg22.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.or(x, y)
   *
   * Examples:
   *
   *    math.or(2, 4)   // returns true
   *
   *    a = [2, 5, 0]
   *    b = [0, 22, 0]
   *    c = 0
   *
   *    math.or(a, b)   // returns [true, true, false]
   *    math.or(b, c)   // returns [false, true, false]
   *
   * See also:
   *
   *    and, not, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
   */ var or = typed($f777b04285aa8213$var$name, {
        "number, number": (0, $e6Xsb.orNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.re !== 0 || x.im !== 0 || y.re !== 0 || y.im !== 0;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !x.isNaN() || !y.isZero() && !y.isNaN();
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return or(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, or);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, or, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, or, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, or);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return or(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return or(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return or(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, or, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, or, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, or, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, or, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, or, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, or, true).valueOf();
        }
    });
    return or;
});

});

parcelRegister("iMOZu", function(module, exports) {

$parcel$export(module.exports, "createPartitionSelect", function () { return $dad4436361e722de$export$47c1a746705f5c42; });

var $7E0JQ = parcelRequire("7E0JQ");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");
var $dad4436361e722de$var$name = "partitionSelect";
var $dad4436361e722de$var$dependencies = [
    "typed",
    "isNumeric",
    "isNaN",
    "compare"
];
var $dad4436361e722de$export$47c1a746705f5c42 = /* #__PURE__ */ (0, $jKx4O.factory)($dad4436361e722de$var$name, $dad4436361e722de$var$dependencies, function(_ref) {
    var typed = _ref.typed, isNumeric = _ref.isNumeric, isNaN = _ref.isNaN, compare = _ref.compare;
    var asc = compare;
    var desc = function desc(a, b) {
        return -compare(a, b);
    };
    /**
   * Partition-based selection of an array or 1D matrix.
   * Will find the kth smallest value, and mutates the input array.
   * Uses Quickselect.
   *
   * Syntax:
   *
   *    math.partitionSelect(x, k)
   *    math.partitionSelect(x, k, compare)
   *
   * Examples:
   *
   *    math.partitionSelect([5, 10, 1], 2)           // returns 10
   *    math.partitionSelect(['C', 'B', 'A', 'D'], 1) // returns 'B'
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength) // returns 'Langdon'
   *
   * See also:
   *
   *    sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Number} k            The kth smallest value to be retrieved zero-based index
   * @param {Function | 'asc' | 'desc'} [compare='asc']
   *        An optional comparator function. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {*} Returns the kth lowest value.
   */ return typed($dad4436361e722de$var$name, {
        "Array | Matrix, number": function ArrayMatrixNumber(x, k) {
            return _partitionSelect(x, k, asc);
        },
        "Array | Matrix, number, string": function ArrayMatrixNumberString(x, k, compare) {
            if (compare === "asc") return _partitionSelect(x, k, asc);
            else if (compare === "desc") return _partitionSelect(x, k, desc);
            else throw new Error('Compare string must be "asc" or "desc"');
        },
        "Array | Matrix, number, function": _partitionSelect
    });
    function _partitionSelect(x, k, compare) {
        if (!(0, $5wlxr.isInteger)(k) || k < 0) throw new Error("k must be a non-negative integer");
        if ((0, $7E0JQ.isMatrix)(x)) {
            var size = x.size();
            if (size.length > 1) throw new Error("Only one dimensional matrices supported");
            return quickSelect(x.valueOf(), k, compare);
        }
        if (Array.isArray(x)) return quickSelect(x, k, compare);
    }
    /**
   * Quickselect algorithm.
   * Code adapted from:
   * https://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
   *
   * @param {Array} arr
   * @param {Number} k
   * @param {Function} compare
   * @private
   */ function quickSelect(arr, k, compare) {
        if (k >= arr.length) throw new Error("k out of bounds");
         // check for NaN values since these can cause an infinite while loop
        for(var i = 0; i < arr.length; i++){
            if (isNumeric(arr[i]) && isNaN(arr[i])) return arr[i]; // return NaN
        }
        var from = 0;
        var to = arr.length - 1; // if from == to we reached the kth element
        while(from < to){
            var r = from;
            var w = to;
            var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from]; // stop if the reader and writer meets
            while(r < w)// arr[r] >= pivot
            if (compare(arr[r], pivot) >= 0) {
                // put the large values at the end
                var tmp = arr[w];
                arr[w] = arr[r];
                arr[r] = tmp;
                --w;
            } else // the value is smaller than the pivot, skip
            ++r;
             // if we stepped up (r++) we need to step one down (arr[r] > pivot)
            if (compare(arr[r], pivot) > 0) --r;
             // the r pointer is on the end of the first k elements
            if (k <= r) to = r;
            else from = r + 1;
        }
        return arr[k];
    }
});

});

parcelRegister("dsMjF", function(module, exports) {

$parcel$export(module.exports, "createPermutations", function () { return $9cd35e805063515a$export$1d58d7915914cc9c; });

var $5wlxr = parcelRequire("5wlxr");

var $5qRPl = parcelRequire("5qRPl");

var $jKx4O = parcelRequire("jKx4O");
var $9cd35e805063515a$var$name = "permutations";
var $9cd35e805063515a$var$dependencies = [
    "typed",
    "factorial"
];
var $9cd35e805063515a$export$1d58d7915914cc9c = /* #__PURE__ */ (0, $jKx4O.factory)($9cd35e805063515a$var$name, $9cd35e805063515a$var$dependencies, function(_ref) {
    var typed = _ref.typed, factorial = _ref.factorial;
    /**
   * Compute the number of ways of obtaining an ordered subset of `k` elements
   * from a set of `n` elements.
   *
   * Permutations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.permutations(n)
   *     math.permutations(n, k)
   *
   * Examples:
   *
   *    math.permutations(5)     // 120
   *    math.permutations(5, 3)  // 60
   *
   * See also:
   *
   *    combinations, combinationsWithRep, factorial
   *
   * @param {number | BigNumber} n   The number of objects in total
   * @param {number | BigNumber} [k] The number of objects in the subset
   * @return {number | BigNumber}    The number of permutations
   */ return typed($9cd35e805063515a$var$name, {
        "number | BigNumber": factorial,
        "number, number": function numberNumber(n, k) {
            if (!(0, $5wlxr.isInteger)(n) || n < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (!(0, $5wlxr.isInteger)(k) || k < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (k > n) throw new TypeError("second argument k must be less than or equal to first argument n");
             // Permute n objects, k at a time
            return (0, $5qRPl.product)(n - k + 1, n);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var result, i;
            if (!$9cd35e805063515a$var$isPositiveInteger(n) || !$9cd35e805063515a$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function permutations");
            if (k.gt(n)) throw new TypeError("second argument k must be less than or equal to first argument n");
            var one = n.mul(0).add(1);
            result = one;
            for(i = n.minus(k).plus(1); i.lte(n); i = i.plus(1))result = result.times(i);
            return result;
        } // TODO: implement support for collection in permutations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $9cd35e805063515a$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});

parcelRegister("2woIB", function(module, exports) {

$parcel$export(module.exports, "createPickRandom", function () { return $1d61be828e12006b$export$fbe25b9f25feec34; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");

var $YkZ7e = parcelRequire("YkZ7e");

var $hgNzF = parcelRequire("hgNzF");
var $1d61be828e12006b$var$name = "pickRandom";
var $1d61be828e12006b$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $1d61be828e12006b$export$fbe25b9f25feec34 = /* #__PURE__ */ (0, $jKx4O.factory)($1d61be828e12006b$var$name, $1d61be828e12006b$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, on = _ref.on;
    // seeded pseudo random number generator
    var rng = (0, $hgNzF.createRng)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $hgNzF.createRng)(curr.randomSeed);
    });
    /**
   * Random pick one or more values from a one dimensional array.
   * Array elements are picked using a random function with uniform or weighted distribution.
   *
   * Syntax:
   *
   *     math.pickRandom(array)
   *     math.pickRandom(array, number)
   *     math.pickRandom(array, weights)
   *     math.pickRandom(array, number, weights)
   *     math.pickRandom(array, weights, number)
   *
   * Examples:
   *
   *     math.pickRandom([3, 6, 12, 2])                  // returns one of the values in the array
   *     math.pickRandom([3, 6, 12, 2], 2)               // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1])    // returns one of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]) // returns an array of two of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2) // returns an array of two of the values in the array with weighted distribution
   *
   * See also:
   *
   *     random, randomInt
   *
   * @param {Array | Matrix} array     A one dimensional array
   * @param {Int} number               An int or float
   * @param {Array | Matrix} weights   An array of ints or floats
   * @return {number | Array}          Returns a single random value from array when number is 1 or undefined.
   *                                   Returns an array with the configured number of elements when number is > 1.
   */ return typed({
        "Array | Matrix": function ArrayMatrix(possibles) {
            return _pickRandom(possibles);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(possibles, number) {
            return _pickRandom(possibles, number, undefined);
        },
        "Array | Matrix, Array": function ArrayMatrixArray(possibles, weights) {
            return _pickRandom(possibles, undefined, weights);
        },
        "Array | Matrix, Array | Matrix, number": function ArrayMatrixArrayMatrixNumber(possibles, weights, number) {
            return _pickRandom(possibles, number, weights);
        },
        "Array | Matrix, number, Array | Matrix": function ArrayMatrixNumberArrayMatrix(possibles, number, weights) {
            return _pickRandom(possibles, number, weights);
        }
    });
    function _pickRandom(possibles, number, weights) {
        var single = typeof number === "undefined";
        if (single) number = 1;
        possibles = possibles.valueOf(); // get Array
        if (weights) weights = weights.valueOf(); // get Array
        if ((0, $YkZ7e.arraySize)(possibles).length > 1) throw new Error("Only one dimensional vectors supported");
        var totalWeights = 0;
        if (typeof weights !== "undefined") {
            if (weights.length !== possibles.length) throw new Error("Weights must have the same length as possibles");
            for(var i = 0, len = weights.length; i < len; i++){
                if (!(0, $7E0JQ.isNumber)(weights[i]) || weights[i] < 0) throw new Error("Weights must be an array of positive numbers");
                totalWeights += weights[i];
            }
        }
        var length = possibles.length;
        if (length === 0) return [];
        else if (number >= length) return number > 1 ? possibles : possibles[0];
        var result = [];
        var pick;
        while(result.length < number){
            if (typeof weights === "undefined") pick = possibles[Math.floor(rng() * length)];
            else {
                var randKey = rng() * totalWeights;
                for(var _i = 0, _len = possibles.length; _i < _len; _i++){
                    randKey -= weights[_i];
                    if (randKey < 0) {
                        pick = possibles[_i];
                        break;
                    }
                }
            }
            if (result.indexOf(pick) === -1) result.push(pick);
        }
        return single ? result[0] : result; // TODO: return matrix when input was a matrix
    // TODO: add support for multi dimensional matrices
    }
});

});
parcelRegister("hgNzF", function(module, exports) {

$parcel$export(module.exports, "createRng", function () { return $c92a62b492d3ba31$export$eaf9227667332084; });
// create a random seed here to prevent an infinite loop from seed-random
// inside the factory. Reason is that math.random is defined as a getter/setter
// and seed-random generates a seed from the local entropy by reading every
// defined object including `math` itself. That means that whilst getting
// math.random, it tries to get math.random, etc... an infinite loop.
// See https://github.com/ForbesLindesay/seed-random/issues/6

var $5ZNDw = parcelRequire("5ZNDw");
var $c92a62b492d3ba31$var$singletonRandom = /* #__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5ZNDw)))();
function $c92a62b492d3ba31$export$eaf9227667332084(randomSeed) {
    var random; // create a new random generator with given seed
    function setSeed(seed) {
        random = seed === null ? $c92a62b492d3ba31$var$singletonRandom : (0, (/*@__PURE__*/$parcel$interopDefault($5ZNDw)))(String(seed));
    } // initialize a seeded pseudo random number generator with config's random seed
    setSeed(randomSeed); // wrapper function so the rng can be updated via generator
    function rng() {
        return random();
    }
    return rng;
}

});
parcelRegister("5ZNDw", function(module, exports) {
"use strict";
var $45d9270531bd6c9a$var$width = 256; // each RC4 output is 0 <= x < 256
var $45d9270531bd6c9a$var$chunks = 6; // at least six RC4 outputs for each double
var $45d9270531bd6c9a$var$digits = 52; // there are 52 significant digits in a double
var $45d9270531bd6c9a$var$pool = []; // pool: entropy pool starts empty
var $45d9270531bd6c9a$var$GLOBAL = typeof $parcel$global === "undefined" ? window : $parcel$global;
//
// The following constants are related to IEEE 754 limits.
//
var $45d9270531bd6c9a$var$startdenom = Math.pow($45d9270531bd6c9a$var$width, $45d9270531bd6c9a$var$chunks), $45d9270531bd6c9a$var$significance = Math.pow(2, $45d9270531bd6c9a$var$digits), $45d9270531bd6c9a$var$overflow = $45d9270531bd6c9a$var$significance * 2, $45d9270531bd6c9a$var$mask = $45d9270531bd6c9a$var$width - 1;
var $45d9270531bd6c9a$var$oldRandom = Math.random;
//
// seedrandom()
// This is the seedrandom function described above.
//
module.exports = function(seed, options) {
    if (options && options.global === true) {
        options.global = false;
        Math.random = module.exports(seed, options);
        options.global = true;
        return Math.random;
    }
    var use_entropy = options && options.entropy || false;
    var key = [];
    // Flatten the seed string or build one from local entropy if needed.
    var shortseed = $45d9270531bd6c9a$var$mixkey($45d9270531bd6c9a$var$flatten(use_entropy ? [
        seed,
        $45d9270531bd6c9a$var$tostring($45d9270531bd6c9a$var$pool)
    ] : 0 in arguments ? seed : $45d9270531bd6c9a$var$autoseed(), 3), key);
    // Use the seed to initialize an ARC4 generator.
    var arc4 = new $45d9270531bd6c9a$var$ARC4(key);
    // Mix the randomness into accumulated entropy.
    $45d9270531bd6c9a$var$mixkey($45d9270531bd6c9a$var$tostring(arc4.S), $45d9270531bd6c9a$var$pool);
    // Override Math.random
    // This function returns a random double in [0, 1) that contains
    // randomness in every bit of the mantissa of the IEEE 754 value.
    return function() {
        var n = arc4.g($45d9270531bd6c9a$var$chunks), d = $45d9270531bd6c9a$var$startdenom, x = 0; //   and no 'extra last byte'.
        while(n < $45d9270531bd6c9a$var$significance){
            n = (n + x) * $45d9270531bd6c9a$var$width; //   shifting numerator and
            d *= $45d9270531bd6c9a$var$width; //   denominator and generating a
            x = arc4.g(1); //   new least-significant-byte.
        }
        while(n >= $45d9270531bd6c9a$var$overflow){
            n /= 2; //   last byte, shift everything
            d /= 2; //   right using integer Math until
            x >>>= 1; //   we have exactly the desired bits.
        }
        return (n + x) / d; // Form the number within [0, 1).
    };
};
module.exports.resetGlobal = function() {
    Math.random = $45d9270531bd6c9a$var$oldRandom;
};
//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
/** @constructor */ function $45d9270531bd6c9a$var$ARC4(key) {
    var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
    // The empty key [] is treated as [0].
    if (!keylen) key = [
        keylen++
    ];
    // Set up S using the standard key scheduling algorithm.
    while(i < $45d9270531bd6c9a$var$width)s[i] = i++;
    for(i = 0; i < $45d9270531bd6c9a$var$width; i++){
        s[i] = s[j = $45d9270531bd6c9a$var$mask & j + key[i % keylen] + (t = s[i])];
        s[j] = t;
    }
    // The "g" method returns the next (count) outputs as one number.
    (me.g = function(count) {
        // Using instance members instead of closure state nearly doubles speed.
        var t, r = 0, i = me.i, j = me.j, s = me.S;
        while(count--){
            t = s[i = $45d9270531bd6c9a$var$mask & i + 1];
            r = r * $45d9270531bd6c9a$var$width + s[$45d9270531bd6c9a$var$mask & (s[i] = s[j = $45d9270531bd6c9a$var$mask & j + t]) + (s[j] = t)];
        }
        me.i = i;
        me.j = j;
        return r;
    // For robust unpredictability discard an initial batch of values.
    // See http://www.rsa.com/rsalabs/node.asp?id=2009
    })($45d9270531bd6c9a$var$width);
}
//
// flatten()
// Converts an object tree to nested arrays of strings.
//
function $45d9270531bd6c9a$var$flatten(obj, depth) {
    var result = [], typ = (typeof obj)[0], prop;
    if (depth && typ == "o") {
        for(prop in obj)try {
            result.push($45d9270531bd6c9a$var$flatten(obj[prop], depth - 1));
        } catch (e) {}
    }
    return result.length ? result : typ == "s" ? obj : obj + "\0";
}
//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
function $45d9270531bd6c9a$var$mixkey(seed, key) {
    var stringseed = seed + "", smear, j = 0;
    while(j < stringseed.length)key[$45d9270531bd6c9a$var$mask & j] = $45d9270531bd6c9a$var$mask & (smear ^= key[$45d9270531bd6c9a$var$mask & j] * 19) + stringseed.charCodeAt(j++);
    return $45d9270531bd6c9a$var$tostring(key);
}
//
// autoseed()
// Returns an object for autoseeding, using window.crypto if available.
//
/** @param {Uint8Array=} seed */ function $45d9270531bd6c9a$var$autoseed(seed) {
    try {
        $45d9270531bd6c9a$var$GLOBAL.crypto.getRandomValues(seed = new Uint8Array($45d9270531bd6c9a$var$width));
        return $45d9270531bd6c9a$var$tostring(seed);
    } catch (e) {
        return [
            +new Date,
            $45d9270531bd6c9a$var$GLOBAL,
            $45d9270531bd6c9a$var$GLOBAL.navigator && $45d9270531bd6c9a$var$GLOBAL.navigator.plugins,
            $45d9270531bd6c9a$var$GLOBAL.screen,
            $45d9270531bd6c9a$var$tostring($45d9270531bd6c9a$var$pool)
        ];
    }
}
//
// tostring()
// Converts an array of charcodes to a string
//
function $45d9270531bd6c9a$var$tostring(a) {
    return String.fromCharCode.apply(0, a);
}
//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to intefere with determinstic PRNG state later,
// seedrandom will not call Math.random on its own again after
// initialization.
//
$45d9270531bd6c9a$var$mixkey(Math.random(), $45d9270531bd6c9a$var$pool);

});



parcelRegister("enfUQ", function(module, exports) {

$parcel$export(module.exports, "createPow", function () { return $a76f8f360ce032ed$export$9c94d2d08a8d8146; });

var $jKx4O = parcelRequire("jKx4O");

var $5wlxr = parcelRequire("5wlxr");

var $YkZ7e = parcelRequire("YkZ7e");

var $cqeCl = parcelRequire("cqeCl");
var $a76f8f360ce032ed$var$name = "pow";
var $a76f8f360ce032ed$var$dependencies = [
    "typed",
    "config",
    "identity",
    "multiply",
    "matrix",
    "fraction",
    "number",
    "Complex"
];
var $a76f8f360ce032ed$export$9c94d2d08a8d8146 = /* #__PURE__ */ (0, $jKx4O.factory)($a76f8f360ce032ed$var$name, $a76f8f360ce032ed$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, identity = _ref.identity, multiply = _ref.multiply, matrix = _ref.matrix, number = _ref.number, fraction = _ref.fraction, Complex = _ref.Complex;
    /**
   * Calculates the power of x to y, `x ^ y`.
   * Matrix exponentiation is supported for square matrices `x`, and positive
   * integer exponents `y`.
   *
   * For cubic roots of negative numbers, the function returns the principal
   * root by default. In order to let the function return the real root,
   * math.js can be configured with `math.config({predictable: true})`.
   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
   *
   * Syntax:
   *
   *    math.pow(x, y)
   *
   * Examples:
   *
   *    math.pow(2, 3)               // returns number 8
   *
   *    const a = math.complex(2, 3)
   *    math.pow(a, 2)                // returns Complex -5 + 12i
   *
   *    const b = [[1, 2], [4, 3]]
   *    math.pow(b, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    multiply, sqrt, cbrt, nthRoot
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex} y                          The exponent
   * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
   */ return typed($a76f8f360ce032ed$var$name, {
        "number, number": _pow,
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.pow(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            if (y.isInteger() || x >= 0 || config.predictable) return x.pow(y);
            else return new Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            if (y.d !== 1) {
                if (config.predictable) throw new Error("Function pow does not support non-integer exponents for fractions.");
                else return _pow(x.valueOf(), y.valueOf());
            } else return x.pow(y);
        },
        "Array, number": _powArray,
        "Array, BigNumber": function ArrayBigNumber(x, y) {
            return _powArray(x, y.toNumber());
        },
        "Matrix, number": _powMatrix,
        "Matrix, BigNumber": function MatrixBigNumber(x, y) {
            return _powMatrix(x, y.toNumber());
        },
        "Unit, number | BigNumber": function UnitNumberBigNumber(x, y) {
            return x.pow(y);
        }
    });
    /**
   * Calculates the power of x to y, x^y, for two numbers.
   * @param {number} x
   * @param {number} y
   * @return {number | Complex} res
   * @private
   */ function _pow(x, y) {
        // Alternatively could define a 'realmode' config option or something, but
        // 'predictable' will work for now
        if (config.predictable && !(0, $5wlxr.isInteger)(y) && x < 0) // Check to see if y can be represented as a fraction
        try {
            var yFrac = fraction(y);
            var yNum = number(yFrac);
            if (y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
                if (yFrac.d % 2 === 1) return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
            }
        } catch (ex) {} // fraction() throws an error if y is Infinity, etc.
         // **for predictable mode** x^Infinity === NaN if x < -1
        // N.B. this behavour is different from `Math.pow` which gives
        // (-2)^Infinity === Infinity
        if (config.predictable && (x < -1 && y === Infinity || x > -1 && x < 0 && y === -Infinity)) return NaN;
        if ((0, $5wlxr.isInteger)(y) || x >= 0 || config.predictable) return (0, $cqeCl.powNumber)(x, y);
        else {
            // TODO: the following infinity checks are duplicated from powNumber. Deduplicate this somehow
            // x^Infinity === 0 if -1 < x < 1
            // A real number 0 is returned instead of complex(0)
            if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
            return new Complex(x, 0).pow(y, 0);
        }
    }
    /**
   * Calculate the power of a 2d array
   * @param {Array} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Array}
   * @private
   */ function _powArray(x, y) {
        if (!(0, $5wlxr.isInteger)(y) || y < 0) throw new TypeError("For A^b, b must be a positive integer (value is " + y + ")");
         // verify that A is a 2 dimensional square matrix
        var s = (0, $YkZ7e.arraySize)(x);
        if (s.length !== 2) throw new Error("For A^b, A must be 2 dimensional (A has " + s.length + " dimensions)");
        if (s[0] !== s[1]) throw new Error("For A^b, A must be square (size is " + s[0] + "x" + s[1] + ")");
        var res = identity(s[0]).valueOf();
        var px = x;
        while(y >= 1){
            if ((y & 1) === 1) res = multiply(px, res);
            y >>= 1;
            px = multiply(px, px);
        }
        return res;
    }
    /**
   * Calculate the power of a 2d matrix
   * @param {Matrix} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Matrix}
   * @private
   */ function _powMatrix(x, y) {
        return matrix(_powArray(x.valueOf(), y));
    }
});

});

parcelRegister("2wZoU", function(module, exports) {

$parcel$export(module.exports, "createPrint", function () { return $1d7e32d652ba9c96$export$ea4b9d9569ff81cc; });

var $7HWRb = parcelRequire("7HWRb");

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");
var $1d7e32d652ba9c96$var$name = "print";
var $1d7e32d652ba9c96$var$dependencies = [
    "typed"
];
var $1d7e32d652ba9c96$export$ea4b9d9569ff81cc = /* #__PURE__ */ (0, $jKx4O.factory)($1d7e32d652ba9c96$var$name, $1d7e32d652ba9c96$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Interpolate values into a string template.
   *
   * Syntax:
   *
   *     math.print(template, values)
   *     math.print(template, values, precision)
   *     math.print(template, values, options)
   *
   * Example usage:
   *
   *     // the following outputs: 'Lucy is 5 years old'
   *     math.print('Lucy is $age years old', {age: 5})
   *
   *     // the following outputs: 'The value of pi is 3.141592654'
   *     math.print('The value of pi is $pi', {pi: math.pi}, 10)
   *
   *     // the following outputs: 'hello Mary! The date is 2013-03-23'
   *     math.print('Hello $user.name! The date is $date', {
   *       user: {
   *         name: 'Mary',
   *       },
   *       date: new Date(2013, 2, 23).toISOString().substring(0, 10)
   *     })
   *
   *     // the following outputs: 'My favorite fruits are apples and bananas !'
   *     math.print('My favorite fruits are $0 and $1 !', [
   *       'apples',
   *       'bananas'
   *     ])
   *
   * See also:
   *
   *     format
   *
   * @param {string} template           A string containing variable placeholders.
   * @param {Object | Array | Matrix}   values An object or array containing variables
   *                                    which will be filled in in the template.
   * @param {number | Object} [options] Formatting options,
   *                                    or the number of digits to format numbers.
   *                                    See function math.format for a description
   *                                    of all options.
   * @return {string} Interpolated string
   */ return typed($1d7e32d652ba9c96$var$name, {
        // note: Matrix will be converted automatically to an Array
        "string, Object | Array": $1d7e32d652ba9c96$var$_print,
        "string, Object | Array, number | Object": $1d7e32d652ba9c96$var$_print
    });
});
/**
 * Interpolate values into a string template.
 * @param {string} template
 * @param {Object} values
 * @param {number | Object} [options]
 * @returns {string} Interpolated string
 * @private
 */ function $1d7e32d652ba9c96$var$_print(template, values, options) {
    return template.replace(/\$([\w.]+)/g, function(original, key) {
        var keys = key.split(".");
        var value = values[keys.shift()];
        while(keys.length && value !== undefined){
            var k = keys.shift();
            value = k ? value[k] : value + ".";
        }
        if (value !== undefined) {
            if (!(0, $7E0JQ.isString)(value)) return (0, $7HWRb.format)(value, options);
            else return value;
        }
        return original;
    });
}

});

parcelRegister("kxlFj", function(module, exports) {

$parcel$export(module.exports, "createProd", function () { return $ef37b1f9e51479bb$export$60310f756e9cfd41; });

var $fbkGg = parcelRequire("fbkGg");

var $jKx4O = parcelRequire("jKx4O");

var $dYvNV = parcelRequire("dYvNV");
var $ef37b1f9e51479bb$var$name = "prod";
var $ef37b1f9e51479bb$var$dependencies = [
    "typed",
    "multiply"
];
var $ef37b1f9e51479bb$export$60310f756e9cfd41 = /* #__PURE__ */ (0, $jKx4O.factory)($ef37b1f9e51479bb$var$name, $ef37b1f9e51479bb$var$dependencies, function(_ref) {
    var typed = _ref.typed, multiply = _ref.multiply;
    /**
   * Compute the product of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.prod(a, b, c, ...)
   *     math.prod(A)
   *
   * Examples:
   *
   *     math.multiply(2, 3)           // returns 6
   *     math.prod(2, 3)               // returns 6
   *     math.prod(2, 3, 4)            // returns 24
   *     math.prod([2, 3, 4])          // returns 24
   *     math.prod([[2, 5], [4, 3]])   // returns 120
   *
   * See also:
   *
   *    mean, median, min, max, sum, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The product of all values
   */ return typed($ef37b1f9e51479bb$var$name, {
        // prod([a, b, c, d, ...])
        "Array | Matrix": _prod,
        // prod([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement prod(A, dim)
            throw new Error("prod(A, dim) is not yet supported"); // return reduce(arguments[0], arguments[1], math.prod)
        },
        // prod(a, b, c, d, ...)
        "...": function _(args) {
            return _prod(args);
        }
    });
    /**
   * Recursively calculate the product of an n-dimensional array
   * @param {Array} array
   * @return {number} prod
   * @private
   */ function _prod(array) {
        var prod;
        (0, $fbkGg.deepForEach)(array, function(value) {
            try {
                prod = prod === undefined ? value : multiply(prod, value);
            } catch (err) {
                throw (0, $dYvNV.improveErrorMessage)(err, "prod", value);
            }
        });
        if (prod === undefined) throw new Error("Cannot calculate prod of an empty array");
        return prod;
    }
});

});

parcelRegister("yvIP7", function(module, exports) {

$parcel$export(module.exports, "createQr", function () { return $067bc8692f64172d$export$39b52312ba2c4d03; });

var $jKx4O = parcelRequire("jKx4O");
function $067bc8692f64172d$var$_extends() {
    $067bc8692f64172d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $067bc8692f64172d$var$_extends.apply(this, arguments);
}
var $067bc8692f64172d$var$name = "qr";
var $067bc8692f64172d$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "identity",
    "isZero",
    "equal",
    "sign",
    "sqrt",
    "conj",
    "unaryMinus",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "complex"
];
var $067bc8692f64172d$export$39b52312ba2c4d03 = /* #__PURE__ */ (0, $jKx4O.factory)($067bc8692f64172d$var$name, $067bc8692f64172d$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, zeros = _ref.zeros, identity = _ref.identity, isZero = _ref.isZero, equal = _ref.equal, sign = _ref.sign, sqrt = _ref.sqrt, conj = _ref.conj, unaryMinus = _ref.unaryMinus, addScalar = _ref.addScalar, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, subtract = _ref.subtract, complex = _ref.complex;
    /**
   * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in
   * two matrices (`Q`, `R`) where `Q` is an
   * orthogonal matrix and `R` is an upper triangular matrix.
   *
   * Syntax:
   *
   *    math.qr(A)
   *
   * Example:
   *
   *    const m = [
   *      [1, -1,  4],
   *      [1,  4, -2],
   *      [1,  4,  2],
   *      [1,  -1, 0]
   *    ]
   *    const result = math.qr(m)
   *    // r = {
   *    //   Q: [
   *    //     [0.5, -0.5,   0.5],
   *    //     [0.5,  0.5,  -0.5],
   *    //     [0.5,  0.5,   0.5],
   *    //     [0.5, -0.5,  -0.5],
   *    //   ],
   *    //   R: [
   *    //     [2, 3,  2],
   *    //     [0, 5, -2],
   *    //     [0, 0,  4],
   *    //     [0, 0,  0]
   *    //   ]
   *    // }
   *
   * See also:
   *
   *    lup, lusolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array
   * for which to get the QR decomposition.
   *
   * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
   * matrix and R: the upper triangular matrix
   */ return $067bc8692f64172d$var$_extends(typed($067bc8692f64172d$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseQR(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseQR(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseQR(m); // result
            return {
                Q: r.Q.valueOf(),
                R: r.R.valueOf()
            };
        }
    }), {
        _denseQRimpl: _denseQRimpl
    });
    function _denseQRimpl(m) {
        // rows & columns (m x n)
        var rows = m._size[0]; // m
        var cols = m._size[1]; // n
        var Q = identity([
            rows
        ], "dense");
        var Qdata = Q._data;
        var R = m.clone();
        var Rdata = R._data; // vars
        var i, j, k;
        var w = zeros([
            rows
        ], "");
        for(k = 0; k < Math.min(cols, rows); ++k){
            /*
       * **k-th Household matrix**
       *
       * The matrix I - 2*v*transpose(v)
       * x     = first column of A
       * x1    = first element of x
       * alpha = x1 / |x1| * |x|
       * e1    = tranpose([1, 0, 0, ...])
       * u     = x - alpha * e1
       * v     = u / |u|
       *
       * Household matrix = I - 2 * v * tranpose(v)
       *
       *  * Initially Q = I and R = A.
       *  * Household matrix is a reflection in a plane normal to v which
       *    will zero out all but the top right element in R.
       *  * Appplying reflection to both Q and R will not change product.
       *  * Repeat this process on the (1,1) minor to get R as an upper
       *    triangular matrix.
       *  * Reflections leave the magnitude of the columns of Q unchanged
       *    so Q remains othoganal.
       *
       */ var pivot = Rdata[k][k];
            var sgn = unaryMinus(equal(pivot, 0) ? 1 : sign(pivot));
            var conjSgn = conj(sgn);
            var alphaSquared = 0;
            for(i = k; i < rows; i++)alphaSquared = addScalar(alphaSquared, multiplyScalar(Rdata[i][k], conj(Rdata[i][k])));
            var alpha = multiplyScalar(sgn, sqrt(alphaSquared));
            if (!isZero(alpha)) {
                // first element in vector u
                var u1 = subtract(pivot, alpha); // w = v * u1 / |u|    (only elements k to (rows-1) are used)
                w[k] = 1;
                for(i = k + 1; i < rows; i++)w[i] = divideScalar(Rdata[i][k], u1);
                 // tau = - conj(u1 / alpha)
                var tau = unaryMinus(conj(divideScalar(u1, alpha)));
                var s = void 0;
                /*
         * tau and w have been choosen so that
         *
         * 2 * v * tranpose(v) = tau * w * tranpose(w)
         */ /*
         * -- calculate R = R - tau * w * tranpose(w) * R --
         * Only do calculation with rows k to (rows-1)
         * Additionally columns 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(j = k; j < cols; j++){
                    s = 0.0; // calculate jth element of [tranpose(w) * R]
                    for(i = k; i < rows; i++)s = addScalar(s, multiplyScalar(conj(w[i]), Rdata[i][j]));
                     // calculate the jth element of [tau * transpose(w) * R]
                    s = multiplyScalar(s, tau);
                    for(i = k; i < rows; i++)Rdata[i][j] = multiplyScalar(subtract(Rdata[i][j], multiplyScalar(w[i], s)), conjSgn);
                }
                /*
         * -- calculate Q = Q - tau * Q * w * transpose(w) --
         * Q is a square matrix (rows x rows)
         * Only do calculation with columns k to (rows-1)
         * Additionally rows 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(i = 0; i < rows; i++){
                    s = 0.0; // calculate ith element of [Q * w]
                    for(j = k; j < rows; j++)s = addScalar(s, multiplyScalar(Qdata[i][j], w[j]));
                     // calculate the ith element of [tau * Q * w]
                    s = multiplyScalar(s, tau);
                    for(j = k; j < rows; ++j)Qdata[i][j] = divideScalar(subtract(Qdata[i][j], multiplyScalar(s, conj(w[j]))), conjSgn);
                }
            }
        } // return matrices
        return {
            Q: Q,
            R: R,
            toString: function toString() {
                return "Q: " + this.Q.toString() + "\nR: " + this.R.toString();
            }
        };
    }
    function _denseQR(m) {
        var ret = _denseQRimpl(m);
        var Rdata = ret.R._data;
        if (m._data.length > 0) {
            var zero = Rdata[0][0].type === "Complex" ? complex(0) : 0;
            for(var i = 0; i < Rdata.length; ++i)for(var j = 0; j < i && j < (Rdata[0] || []).length; ++j)Rdata[i][j] = zero;
        }
        return ret;
    }
    function _sparseQR(m) {
        throw new Error("qr not implemented for sparse matrices yet");
    }
});

});

parcelRegister("cHJNG", function(module, exports) {

$parcel$export(module.exports, "createQuantileSeq", function () { return $93fd07305937915a$export$524607d17ea053e9; });

var $7E0JQ = parcelRequire("7E0JQ");

var $5wlxr = parcelRequire("5wlxr");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $93fd07305937915a$var$name = "quantileSeq";
var $93fd07305937915a$var$dependencies = [
    "typed",
    "add",
    "multiply",
    "partitionSelect",
    "compare"
];
var $93fd07305937915a$export$524607d17ea053e9 = /* #__PURE__ */ (0, $jKx4O.factory)($93fd07305937915a$var$name, $93fd07305937915a$var$dependencies, function(_ref) {
    var typed = _ref.typed, add = _ref.add, multiply = _ref.multiply, partitionSelect = _ref.partitionSelect, compare = _ref.compare;
    /**
   * Compute the prob order quantile of a matrix or a list with values.
   * The sequence is sorted and the middle value is returned.
   * Supported types of sequence values are: Number, BigNumber, Unit
   * Supported types of probability are: Number, BigNumber
   *
   * In case of a (multi dimensional) array or matrix, the prob order quantile
   * of all elements will be calculated.
   *
   * Syntax:
   *
   *     math.quantileSeq(A, prob[, sorted])
   *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
   *     math.quantileSeq(A, N[, sorted])
   *
   * Examples:
   *
   *     math.quantileSeq([3, -1, 5, 7], 0.5)         // returns 4
   *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3])  // returns [3, 5]
   *     math.quantileSeq([3, -1, 5, 7], 2)           // returns [3, 5]
   *     math.quantileSeq([-1, 3, 5, 7], 0.5, true)   // returns 4
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array, Matrix} data                A single matrix or Array
   * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
   *                                            the amount of evenly distributed steps of
   *                                            probabilities; only one of these options can
   *                                            be provided
   * @param {Boolean} sorted=false              is data sorted in ascending order
   * @return {Number, BigNumber, Unit, Array}   Quantile(s)
   */ function quantileSeq(data, probOrN, sorted) {
        var probArr, dataArr, one;
        if (arguments.length < 2 || arguments.length > 3) throw new SyntaxError("Function quantileSeq requires two or three parameters");
        if ((0, $7E0JQ.isCollection)(data)) {
            sorted = sorted || false;
            if (typeof sorted === "boolean") {
                dataArr = data.valueOf();
                if ((0, $7E0JQ.isNumber)(probOrN)) {
                    if (probOrN < 0) throw new Error("N/prob must be non-negative");
                    if (probOrN <= 1) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return _quantileSeq(dataArr, probOrN, sorted);
                    if (probOrN > 1) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!(0, $5wlxr.isInteger)(probOrN)) throw new Error("N must be a positive integer");
                        var nPlusOne = probOrN + 1;
                        probArr = new Array(probOrN);
                        for(var i = 0; i < probOrN;)probArr[i] = _quantileSeq(dataArr, ++i / nPlusOne, sorted);
                        return probArr;
                    }
                }
                if ((0, $7E0JQ.isBigNumber)(probOrN)) {
                    var BigNumber = probOrN.constructor;
                    if (probOrN.isNegative()) throw new Error("N/prob must be non-negative");
                    one = new BigNumber(1);
                    if (probOrN.lte(one)) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return new BigNumber(_quantileSeq(dataArr, probOrN, sorted));
                    if (probOrN.gt(one)) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!probOrN.isInteger()) throw new Error("N must be a positive integer");
                         // largest possible Array length is 2^32-1
                        // 2^32 < 10^15, thus safe conversion guaranteed
                        var intN = probOrN.toNumber();
                        if (intN > 4294967295) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
                        var _nPlusOne = new BigNumber(intN + 1);
                        probArr = new Array(intN);
                        for(var _i = 0; _i < intN;)probArr[_i] = new BigNumber(_quantileSeq(dataArr, new BigNumber(++_i).div(_nPlusOne), sorted));
                        return probArr;
                    }
                }
                if (Array.isArray(probOrN)) {
                    // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
                    probArr = new Array(probOrN.length);
                    for(var _i2 = 0; _i2 < probArr.length; ++_i2){
                        var currProb = probOrN[_i2];
                        if ((0, $7E0JQ.isNumber)(currProb)) {
                            if (currProb < 0 || currProb > 1) throw new Error("Probability must be between 0 and 1, inclusive");
                        } else if ((0, $7E0JQ.isBigNumber)(currProb)) {
                            one = new currProb.constructor(1);
                            if (currProb.isNegative() || currProb.gt(one)) throw new Error("Probability must be between 0 and 1, inclusive");
                        } else throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
                        probArr[_i2] = _quantileSeq(dataArr, currProb, sorted);
                    }
                    return probArr;
                }
                throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
            }
            throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
        }
        throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array} array
   * @param {Number, BigNumber} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeq(array, prob, sorted) {
        var flat = (0, $YkZ7e.flatten)(array);
        var len = flat.length;
        if (len === 0) throw new Error("Cannot calculate quantile of an empty sequence");
        if ((0, $7E0JQ.isNumber)(prob)) {
            var _index = prob * (len - 1);
            var _fracPart = _index % 1;
            if (_fracPart === 0) {
                var value = sorted ? flat[_index] : partitionSelect(flat, _index);
                validate(value);
                return value;
            }
            var _integerPart = Math.floor(_index);
            var _left;
            var _right;
            if (sorted) {
                _left = flat[_integerPart];
                _right = flat[_integerPart + 1];
            } else {
                _right = partitionSelect(flat, _integerPart + 1); // max of partition is kth largest
                _left = flat[_integerPart];
                for(var i = 0; i < _integerPart; ++i)if (compare(flat[i], _left) > 0) _left = flat[i];
            }
            validate(_left);
            validate(_right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
            return add(multiply(_left, 1 - _fracPart), multiply(_right, _fracPart));
        } // If prob is a BigNumber
        var index = prob.times(len - 1);
        if (index.isInteger()) {
            index = index.toNumber();
            var _value = sorted ? flat[index] : partitionSelect(flat, index);
            validate(_value);
            return _value;
        }
        var integerPart = index.floor();
        var fracPart = index.minus(integerPart);
        var integerPartNumber = integerPart.toNumber();
        var left;
        var right;
        if (sorted) {
            left = flat[integerPartNumber];
            right = flat[integerPartNumber + 1];
        } else {
            right = partitionSelect(flat, integerPartNumber + 1); // max of partition is kth largest
            left = flat[integerPartNumber];
            for(var _i3 = 0; _i3 < integerPartNumber; ++_i3)if (compare(flat[_i3], left) > 0) left = flat[_i3];
        }
        validate(left);
        validate(right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
        var one = new fracPart.constructor(1);
        return add(multiply(left, one.minus(fracPart)), multiply(right, fracPart));
    }
    /**
   * Check if array value types are valid, throw error otherwise.
   * @param {number | BigNumber | Unit} x
   * @param {number | BigNumber | Unit} x
   * @private
   */ var validate = typed({
        "number | BigNumber | Unit": function numberBigNumberUnit(x) {
            return x;
        }
    });
    return quantileSeq;
});

});

parcelRegister("49EV9", function(module, exports) {

$parcel$export(module.exports, "createRandom", function () { return $3067beb95a70145f$export$5c03d20f483e909a; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");

var $hgNzF = parcelRequire("hgNzF");

var $kUjIf = parcelRequire("kUjIf");
var $3067beb95a70145f$var$name = "random";
var $3067beb95a70145f$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $3067beb95a70145f$export$5c03d20f483e909a = /* #__PURE__ */ (0, $jKx4O.factory)($3067beb95a70145f$var$name, $3067beb95a70145f$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, on = _ref.on;
    // seeded pseudo random number generator
    var rng = (0, $hgNzF.createRng)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $hgNzF.createRng)(curr.randomSeed);
    });
    /**
   * Return a random number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.random()                // generate a random number between 0 and 1
   *     math.random(max)             // generate a random number between 0 and max
   *     math.random(min, max)        // generate a random number between min and max
   *     math.random(size)            // generate a matrix with random numbers between 0 and 1
   *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
   *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
   *
   * Examples:
   *
   *     math.random()       // returns a random number between 0 and 1
   *     math.random(100)    // returns a random number between 0 and 100
   *     math.random(30, 40) // returns a random number between 30 and 40
   *     math.random([2, 3]) // returns a 2x3 matrix with random numbers between 0 and 1
   *
   * See also:
   *
   *     randomInt, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random number
   */ return typed($3067beb95a70145f$var$name, {
        "": function _() {
            return _random(0, 1);
        },
        number: function number(max) {
            return _random(0, max);
        },
        "number, number": function numberNumber(min, max) {
            return _random(min, max);
        },
        "Array | Matrix": function ArrayMatrix(size) {
            return _randomMatrix(size, 0, 1);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(size, max) {
            return _randomMatrix(size, 0, max);
        },
        "Array | Matrix, number, number": function ArrayMatrixNumberNumber(size, min, max) {
            return _randomMatrix(size, min, max);
        }
    });
    function _randomMatrix(size, min, max) {
        var res = (0, $kUjIf.randomMatrix)(size.valueOf(), function() {
            return _random(min, max);
        });
        return (0, $7E0JQ.isMatrix)(size) ? size.create(res) : res;
    }
    function _random(min, max) {
        return min + rng() * (max - min);
    }
}); // number only implementation of random, no matrix support
var $3067beb95a70145f$export$267a132af241f602 = /* #__PURE__ */ (0, $jKx4O.factory)($3067beb95a70145f$var$name, [
    "typed",
    "config",
    "?on"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config, on = _ref2.on, matrix = _ref2.matrix;
    // seeded pseudo random number generator1
    var rng = (0, $hgNzF.createRng)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $hgNzF.createRng)(curr.randomSeed);
    });
    return typed($3067beb95a70145f$var$name, {
        "": function _() {
            return _random(0, 1);
        },
        number: function number(max) {
            return _random(0, max);
        },
        "number, number": function numberNumber(min, max) {
            return _random(min, max);
        }
    });
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});

});
parcelRegister("kUjIf", function(module, exports) {

$parcel$export(module.exports, "randomMatrix", function () { return $f38854252bec9ec2$export$6549281d357a44ec; });
/**
 * This is a util function for generating a random matrix recursively.
 * @param {number[]} size
 * @param {function} random
 * @returns {Array}
 */ function $f38854252bec9ec2$export$6549281d357a44ec(size, random) {
    var data = [];
    size = size.slice(0);
    if (size.length > 1) for(var i = 0, length = size.shift(); i < length; i++)data.push($f38854252bec9ec2$export$6549281d357a44ec(size, random));
    else for(var _i = 0, _length = size.shift(); _i < _length; _i++)data.push(random());
    return data;
}

});


parcelRegister("codjn", function(module, exports) {

$parcel$export(module.exports, "createRandomInt", function () { return $90520d52f116186a$export$e158da47ae479dd4; });

var $jKx4O = parcelRequire("jKx4O");

var $kUjIf = parcelRequire("kUjIf");

var $hgNzF = parcelRequire("hgNzF");

var $7E0JQ = parcelRequire("7E0JQ");
var $90520d52f116186a$var$name = "randomInt";
var $90520d52f116186a$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $90520d52f116186a$export$e158da47ae479dd4 = /* #__PURE__ */ (0, $jKx4O.factory)($90520d52f116186a$var$name, $90520d52f116186a$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, on = _ref.on;
    // seeded pseudo random number generator
    var rng = (0, $hgNzF.createRng)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $hgNzF.createRng)(curr.randomSeed);
    });
    /**
   * Return a random integer number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.randomInt()                // generate a random integer between 0 and 1
   *     math.randomInt(max)             // generate a random integer between 0 and max
   *     math.randomInt(min, max)        // generate a random integer between min and max
   *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
   *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
   *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
   *
   * Examples:
   *
   *     math.randomInt(100)    // returns a random integer between 0 and 100
   *     math.randomInt(30, 40) // returns a random integer between 30 and 40
   *     math.randomInt([2, 3]) // returns a 2x3 matrix with random integers between 0 and 1
   *
   * See also:
   *
   *     random, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random integer value
   */ return typed($90520d52f116186a$var$name, {
        "": function _() {
            return _randomInt(0, 1);
        },
        number: function number(max) {
            return _randomInt(0, max);
        },
        "number, number": function numberNumber(min, max) {
            return _randomInt(min, max);
        },
        "Array | Matrix": function ArrayMatrix(size) {
            return _randomIntMatrix(size, 0, 1);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(size, max) {
            return _randomIntMatrix(size, 0, max);
        },
        "Array | Matrix, number, number": function ArrayMatrixNumberNumber(size, min, max) {
            return _randomIntMatrix(size, min, max);
        }
    });
    function _randomIntMatrix(size, min, max) {
        var res = (0, $kUjIf.randomMatrix)(size.valueOf(), function() {
            return _randomInt(min, max);
        });
        return (0, $7E0JQ.isMatrix)(size) ? size.create(res) : res;
    }
    function _randomInt(min, max) {
        return Math.floor(min + rng() * (max - min));
    }
});

});

parcelRegister("caP1a", function(module, exports) {

$parcel$export(module.exports, "createRangeClass", function () { return $8dcdfe4758bf7d30$export$e87cc8d3f29c5e1b; });

var $7E0JQ = parcelRequire("7E0JQ");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");
var $8dcdfe4758bf7d30$var$name = "Range";
var $8dcdfe4758bf7d30$var$dependencies = [];
var $8dcdfe4758bf7d30$export$e87cc8d3f29c5e1b = /* #__PURE__ */ (0, $jKx4O.factory)($8dcdfe4758bf7d30$var$name, $8dcdfe4758bf7d30$var$dependencies, function() {
    /**
   * Create a range. A range has a start, step, and end, and contains functions
   * to iterate over the range.
   *
   * A range can be constructed as:
   *
   *     const range = new Range(start, end)
   *     const range = new Range(start, end, step)
   *
   * To get the result of the range:
   *     range.forEach(function (x) {
   *         console.log(x)
   *     })
   *     range.map(function (x) {
   *         return math.sin(x)
   *     })
   *     range.toArray()
   *
   * Example usage:
   *
   *     const c = new Range(2, 6)       // 2:1:5
   *     c.toArray()                     // [2, 3, 4, 5]
   *     const d = new Range(2, -3, -1)  // 2:-1:-2
   *     d.toArray()                     // [2, 1, 0, -1, -2]
   *
   * @class Range
   * @constructor Range
   * @param {number} start  included lower bound
   * @param {number} end    excluded upper bound
   * @param {number} [step] step size, default value is 1
   */ function Range(start, end, step) {
        if (!(this instanceof Range)) throw new SyntaxError("Constructor must be called with the new operator");
        var hasStart = start !== null && start !== undefined;
        var hasEnd = end !== null && end !== undefined;
        var hasStep = step !== null && step !== undefined;
        if (hasStart) {
            if ((0, $7E0JQ.isBigNumber)(start)) start = start.toNumber();
            else if (typeof start !== "number") throw new TypeError("Parameter start must be a number");
        }
        if (hasEnd) {
            if ((0, $7E0JQ.isBigNumber)(end)) end = end.toNumber();
            else if (typeof end !== "number") throw new TypeError("Parameter end must be a number");
        }
        if (hasStep) {
            if ((0, $7E0JQ.isBigNumber)(step)) step = step.toNumber();
            else if (typeof step !== "number") throw new TypeError("Parameter step must be a number");
        }
        this.start = hasStart ? parseFloat(start) : 0;
        this.end = hasEnd ? parseFloat(end) : 0;
        this.step = hasStep ? parseFloat(step) : 1;
    }
    /**
   * Attach type information
   */ Range.prototype.type = "Range";
    Range.prototype.isRange = true;
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @memberof Range
   * @param {string} str
   * @return {Range | null} range
   */ Range.parse = function(str) {
        if (typeof str !== "string") return null;
        var args = str.split(":");
        var nums = args.map(function(arg) {
            return parseFloat(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return new Range(nums[0], nums[1]);
            case 3:
                return new Range(nums[0], nums[2], nums[1]);
            default:
                return null;
        }
    };
    /**
   * Create a clone of the range
   * @return {Range} clone
   */ Range.prototype.clone = function() {
        return new Range(this.start, this.end, this.step);
    };
    /**
   * Retrieve the size of the range.
   * Returns an array containing one number, the number of elements in the range.
   * @memberof Range
   * @returns {number[]} size
   */ Range.prototype.size = function() {
        var len = 0;
        var start = this.start;
        var step = this.step;
        var end = this.end;
        var diff = end - start;
        if ((0, $5wlxr.sign)(step) === (0, $5wlxr.sign)(diff)) len = Math.ceil(diff / step);
        else if (diff === 0) len = 0;
        if (isNaN(len)) len = 0;
        return [
            len
        ];
    };
    /**
   * Calculate the minimum value in the range
   * @memberof Range
   * @return {number | undefined} min
   */ Range.prototype.min = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start;
            else // negative step
            return this.start + (size - 1) * this.step;
        } else return undefined;
    };
    /**
   * Calculate the maximum value in the range
   * @memberof Range
   * @return {number | undefined} max
   */ Range.prototype.max = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start + (size - 1) * this.step;
            else // negative step
            return this.start;
        } else return undefined;
    };
    /**
   * Execute a callback function for each value in the range.
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Range being traversed.
   */ Range.prototype.forEach = function(callback) {
        var x = this.start;
        var step = this.step;
        var end = this.end;
        var i = 0;
        if (step > 0) while(x < end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
        else if (step < 0) while(x > end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
    };
    /**
   * Execute a callback function for each value in the Range, and return the
   * results as an array
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @returns {Array} array
   */ Range.prototype.map = function(callback) {
        var array = [];
        this.forEach(function(value, index, obj) {
            array[index[0]] = callback(value, index, obj);
        });
        return array;
    };
    /**
   * Create an Array with a copy of the Ranges data
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.toArray = function() {
        var array = [];
        this.forEach(function(value, index) {
            array[index[0]] = value;
        });
        return array;
    };
    /**
   * Get the primitive value of the Range, a one dimensional array
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.valueOf = function() {
        // TODO: implement a caching mechanism for range.valueOf()
        return this.toArray();
    };
    /**
   * Get a string representation of the range, with optional formatting options.
   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
   * @memberof Range
   * @param {Object | number | function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Range.prototype.format = function(options) {
        var str = (0, $5wlxr.format)(this.start, options);
        if (this.step !== 1) str += ":" + (0, $5wlxr.format)(this.step, options);
        str += ":" + (0, $5wlxr.format)(this.end, options);
        return str;
    };
    /**
   * Get a string representation of the range.
   * @memberof Range
   * @returns {string}
   */ Range.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the range
   * @memberof Range
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   */ Range.prototype.toJSON = function() {
        return {
            mathjs: "Range",
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate a Range from a JSON object
   * @memberof Range
   * @param {Object} json A JSON object structured as:
   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   * @return {Range}
   */ Range.fromJSON = function(json) {
        return new Range(json.start, json.end, json.step);
    };
    return Range;
}, {
    isClass: true
});

});

parcelRegister("4jeGd", function(module, exports) {

$parcel$export(module.exports, "createRe", function () { return $323452e0b40ad5ae$export$803e46d0de790dbf; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $323452e0b40ad5ae$var$name = "re";
var $323452e0b40ad5ae$var$dependencies = [
    "typed"
];
var $323452e0b40ad5ae$export$803e46d0de790dbf = /* #__PURE__ */ (0, $jKx4O.factory)($323452e0b40ad5ae$var$name, $323452e0b40ad5ae$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Get the real part of a complex number.
   * For a complex number `a + bi`, the function returns `a`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.re(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number 0
   *    math.re(math.complex(2.4))     // returns number 2.4
   *
   * See also:
   *
   *    im, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The real part of x
   */ var re = typed($323452e0b40ad5ae$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.re;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, re);
        }
    });
    return re;
});

});

parcelRegister("5q6XA", function(module, exports) {

$parcel$export(module.exports, "createReplacer", function () { return $3f24c798f0f736ff$export$481a522c866104eb; });

var $jKx4O = parcelRequire("jKx4O");
var $3f24c798f0f736ff$var$name = "replacer";
var $3f24c798f0f736ff$var$dependencies = [];
var $3f24c798f0f736ff$export$481a522c866104eb = /* #__PURE__ */ (0, $jKx4O.factory)($3f24c798f0f736ff$var$name, $3f24c798f0f736ff$var$dependencies, function() {
    /**
   * Stringify data types into their JSON representation.
   * Most data types can be serialized using their `.toJSON` method,
   * but not all, for example the number `Infinity`. For these cases you have
   * to use the replacer. Example usage:
   *
   *     JSON.stringify([2, Infinity], math.replacer)
   *
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the replaced object
   */ return function replacer(key, value) {
        // the numeric values Infinitiy, -Infinity, and NaN cannot be serialized to JSON
        if (typeof value === "number" && (!isFinite(value) || isNaN(value))) return {
            mathjs: "number",
            value: String(value)
        };
        return value;
    };
});

});

parcelRegister("hhsn0", function(module, exports) {

$parcel$export(module.exports, "createReshape", function () { return $c94a07eaf97949d4$export$76c9752f34fb3440; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $c94a07eaf97949d4$var$name = "reshape";
var $c94a07eaf97949d4$var$dependencies = [
    "typed",
    "isInteger",
    "matrix"
];
var $c94a07eaf97949d4$export$76c9752f34fb3440 = /* #__PURE__ */ (0, $jKx4O.factory)($c94a07eaf97949d4$var$name, $c94a07eaf97949d4$var$dependencies, function(_ref) {
    var typed = _ref.typed, isInteger = _ref.isInteger, matrix = _ref.matrix;
    /**
   * Reshape a multi dimensional array to fit the specified dimensions
   *
   * Syntax:
   *
   *     math.reshape(x, sizes)
   *
   * Examples:
   *
   *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3])
   *     // returns Array  [[1, 2, 3], [4, 5, 6]]
   *
   *     math.reshape([[1, 2], [3, 4]], [1, 4])
   *     // returns Array  [[1, 2, 3, 4]]
   *
   *     math.reshape([[1, 2], [3, 4]], [4])
   *     // returns Array [1, 2, 3, 4]
   *
   *     const x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8])
   *     math.reshape(x, [2, 2, 2])
   *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
   *
   * See also:
   *
   *     size, squeeze, resize
   *
   * @param {Array | Matrix | *} x  Matrix to be reshaped
   * @param {number[]} sizes        One dimensional array with integral sizes for
   *                                each dimension
   *
   * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
   *
   * @throws {TypeError}            If `sizes` does not contain solely integers
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */ return typed($c94a07eaf97949d4$var$name, {
        "Matrix, Array": function MatrixArray(x, sizes) {
            if (x.reshape) return x.reshape(sizes);
            else return matrix((0, $YkZ7e.reshape)(x.valueOf(), sizes));
        },
        "Array, Array": function ArrayArray(x, sizes) {
            sizes.forEach(function(size) {
                if (!isInteger(size)) throw new TypeError("Invalid size for dimension: " + size);
            });
            return (0, $YkZ7e.reshape)(x, sizes);
        }
    });
});

});

parcelRegister("1mhnN", function(module, exports) {

$parcel$export(module.exports, "createResize", function () { return $0fd55461c4fd1f37$export$58909557046ca413; });

var $7E0JQ = parcelRequire("7E0JQ");

var $i7dcb = parcelRequire("i7dcb");

var $laGzH = parcelRequire("laGzH");

var $5wlxr = parcelRequire("5wlxr");

var $7HWRb = parcelRequire("7HWRb");

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $0fd55461c4fd1f37$var$name = "resize";
var $0fd55461c4fd1f37$var$dependencies = [
    "config",
    "matrix"
];
var $0fd55461c4fd1f37$export$58909557046ca413 = /* #__PURE__ */ (0, $jKx4O.factory)($0fd55461c4fd1f37$var$name, $0fd55461c4fd1f37$var$dependencies, function(_ref) {
    var config = _ref.config, matrix = _ref.matrix;
    /**
   * Resize a matrix
   *
   * Syntax:
   *
   *     math.resize(x, size)
   *     math.resize(x, size, defaultValue)
   *
   * Examples:
   *
   *     math.resize([1, 2, 3, 4, 5], [3]) // returns Array  [1, 2, 3]
   *     math.resize([1, 2, 3], [5], 0)    // returns Array  [1, 2, 3, 0, 0]
   *     math.resize(2, [2, 3], 0)         // returns Matrix [[2, 0, 0], [0, 0, 0]]
   *     math.resize("hello", [8], "!")    // returns string 'hello!!!'
   *
   * See also:
   *
   *     size, squeeze, subset, reshape
   *
   * @param {Array | Matrix | *} x             Matrix to be resized
   * @param {Array | Matrix} size              One dimensional array with numbers
   * @param {number | string} [defaultValue=0] Zero by default, except in
   *                                           case of a string, in that case
   *                                           defaultValue = ' '
   * @return {* | Array | Matrix} A resized clone of matrix `x`
   */ // TODO: rework resize to a typed-function
    return function resize(x, size, defaultValue) {
        if (arguments.length !== 2 && arguments.length !== 3) throw new (0, $laGzH.ArgumentsError)("resize", arguments.length, 2, 3);
        if ((0, $7E0JQ.isMatrix)(size)) size = size.valueOf(); // get Array
        if ((0, $7E0JQ.isBigNumber)(size[0])) // convert bignumbers to numbers
        size = size.map(function(value) {
            return !(0, $7E0JQ.isBigNumber)(value) ? value : value.toNumber();
        });
         // check x is a Matrix
        if ((0, $7E0JQ.isMatrix)(x)) // use optimized matrix implementation, return copy
        return x.resize(size, defaultValue, true);
        if (typeof x === "string") // resize string
        return _resizeString(x, size, defaultValue);
         // check result should be a matrix
        var asMatrix = Array.isArray(x) ? false : config.matrix !== "Array";
        if (size.length === 0) {
            // output a scalar
            while(Array.isArray(x))x = x[0];
            return (0, $glBd7.clone)(x);
        } else {
            // output an array/matrix
            if (!Array.isArray(x)) x = [
                x
            ];
            x = (0, $glBd7.clone)(x);
            var res = (0, $YkZ7e.resize)(x, size, defaultValue);
            return asMatrix ? matrix(res) : res;
        }
    };
    /**
   * Resize a string
   * @param {string} str
   * @param {number[]} size
   * @param {string} [defaultChar=' ']
   * @private
   */ function _resizeString(str, size, defaultChar) {
        if (defaultChar !== undefined) {
            if (typeof defaultChar !== "string" || defaultChar.length !== 1) throw new TypeError("Single character expected as defaultValue");
        } else defaultChar = " ";
        if (size.length !== 1) throw new (0, $i7dcb.DimensionError)(size.length, 1);
        var len = size[0];
        if (typeof len !== "number" || !(0, $5wlxr.isInteger)(len)) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $7HWRb.format)(size) + ")");
        if (str.length > len) return str.substring(0, len);
        else if (str.length < len) {
            var res = str;
            for(var i = 0, ii = len - str.length; i < ii; i++)res += defaultChar;
            return res;
        } else return str;
    }
});

});
parcelRegister("laGzH", function(module, exports) {

$parcel$export(module.exports, "ArgumentsError", function () { return $f69b8ea16b028071$export$f27c2c74ddc37d80; });
/**
 * Create a syntax error with the message:
 *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
 * @param {string} fn     Function name
 * @param {number} count  Actual argument count
 * @param {number} min    Minimum required argument count
 * @param {number} [max]  Maximum required argument count
 * @extends Error
 */ function $f69b8ea16b028071$export$f27c2c74ddc37d80(fn, count, min, max) {
    if (!(this instanceof $f69b8ea16b028071$export$f27c2c74ddc37d80)) throw new SyntaxError("Constructor must be called with the new operator");
    this.fn = fn;
    this.count = count;
    this.min = min;
    this.max = max;
    this.message = "Wrong number of arguments in function " + fn + " (" + count + " provided, " + min + (max !== undefined && max !== null ? "-" + max : "") + " expected)";
    this.stack = new Error().stack;
}
$f69b8ea16b028071$export$f27c2c74ddc37d80.prototype = new Error();
$f69b8ea16b028071$export$f27c2c74ddc37d80.prototype.constructor = Error;
$f69b8ea16b028071$export$f27c2c74ddc37d80.prototype.name = "ArgumentsError";
$f69b8ea16b028071$export$f27c2c74ddc37d80.prototype.isArgumentsError = true;

});


parcelRegister("1X6MZ", function(module, exports) {

$parcel$export(module.exports, "createResultSet", function () { return $16c0914fddfbf2b8$export$dfb3187f1c4e3bbe; });

var $jKx4O = parcelRequire("jKx4O");
var $16c0914fddfbf2b8$var$name = "ResultSet";
var $16c0914fddfbf2b8$var$dependencies = [];
var $16c0914fddfbf2b8$export$dfb3187f1c4e3bbe = /* #__PURE__ */ (0, $jKx4O.factory)($16c0914fddfbf2b8$var$name, $16c0914fddfbf2b8$var$dependencies, function() {
    /**
   * A ResultSet contains a list or results
   * @class ResultSet
   * @param {Array} entries
   * @constructor ResultSet
   */ function ResultSet(entries) {
        if (!(this instanceof ResultSet)) throw new SyntaxError("Constructor must be called with the new operator");
        this.entries = entries || [];
    }
    /**
   * Attach type information
   */ ResultSet.prototype.type = "ResultSet";
    ResultSet.prototype.isResultSet = true;
    /**
   * Returns the array with results hold by this ResultSet
   * @memberof ResultSet
   * @returns {Array} entries
   */ ResultSet.prototype.valueOf = function() {
        return this.entries;
    };
    /**
   * Returns the stringified results of the ResultSet
   * @memberof ResultSet
   * @returns {string} string
   */ ResultSet.prototype.toString = function() {
        return "[" + this.entries.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the ResultSet
   * @memberof ResultSet
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "ResultSet", "entries": [...]}`
   */ ResultSet.prototype.toJSON = function() {
        return {
            mathjs: "ResultSet",
            entries: this.entries
        };
    };
    /**
   * Instantiate a ResultSet from a JSON object
   * @memberof ResultSet
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "ResultSet", "entries": [...]}`
   * @return {ResultSet}
   */ ResultSet.fromJSON = function(json) {
        return new ResultSet(json.entries);
    };
    return ResultSet;
}, {
    isClass: true
});

});

parcelRegister("fPIiR", function(module, exports) {

$parcel$export(module.exports, "createRightArithShift", function () { return $b86dfc1af973dbc4$export$ef742376390cbf7; });

var $hGVn5 = parcelRequire("hGVn5");

var $16D4T = parcelRequire("16D4T");

var $1Gmbc = parcelRequire("1Gmbc");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $9vlUQ = parcelRequire("9vlUQ");

var $fs8LR = parcelRequire("fs8LR");

var $gyXqK = parcelRequire("gyXqK");

var $jKx4O = parcelRequire("jKx4O");

var $exwQn = parcelRequire("exwQn");
var $b86dfc1af973dbc4$var$name = "rightArithShift";
var $b86dfc1af973dbc4$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $b86dfc1af973dbc4$export$ef742376390cbf7 = /* #__PURE__ */ (0, $jKx4O.factory)($b86dfc1af973dbc4$var$name, $b86dfc1af973dbc4$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $9vlUQ.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $gyXqK.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $fs8LR.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightArithShift(x, y)
   *
   * Examples:
   *
   *    math.rightArithShift(4, 2)               // returns number 1
   *
   *    math.rightArithShift([16, -32, 64], 4)   // returns Array [1, -2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` sign-filled shifted right `y` times
   */ var rightArithShift = typed($b86dfc1af973dbc4$var$name, {
        "number, number": (0, $exwQn.rightArithShiftNumber),
        "BigNumber, BigNumber": (0, $hGVn5.rightArithShiftBigNumber),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, rightArithShift, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, rightArithShift, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, rightArithShift, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, rightArithShift);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return rightArithShift(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return rightArithShift(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return rightArithShift(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, rightArithShift, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, rightArithShift, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, rightArithShift, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, rightArithShift, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return rightArithShift(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return rightArithShift(x, matrix(y)).valueOf();
        }
    });
    return rightArithShift;
});

});

parcelRegister("4GTTb", function(module, exports) {

$parcel$export(module.exports, "createRightLogShift", function () { return $36a67016fa0968b2$export$2dd001e9fd66adcd; });

var $16D4T = parcelRequire("16D4T");

var $1Gmbc = parcelRequire("1Gmbc");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $9vlUQ = parcelRequire("9vlUQ");

var $fs8LR = parcelRequire("fs8LR");

var $gyXqK = parcelRequire("gyXqK");

var $jKx4O = parcelRequire("jKx4O");

var $exwQn = parcelRequire("exwQn");
var $36a67016fa0968b2$var$name = "rightLogShift";
var $36a67016fa0968b2$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $36a67016fa0968b2$export$2dd001e9fd66adcd = /* #__PURE__ */ (0, $jKx4O.factory)($36a67016fa0968b2$var$name, $36a67016fa0968b2$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, DenseMatrix = _ref.DenseMatrix;
    var algorithm01 = (0, $9vlUQ.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $16D4T.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $gyXqK.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $fs8LR.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightLogShift(x, y)
   *
   * Examples:
   *
   *    math.rightLogShift(4, 2)               // returns number 1
   *
   *    math.rightLogShift([16, -32, 64], 4)   // returns Array [1, 2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
   *
   * @param  {number | Array | Matrix} x Value to be shifted
   * @param  {number} y Amount of shifts
   * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
   */ var rightLogShift = typed($36a67016fa0968b2$var$name, {
        "number, number": (0, $exwQn.rightLogShiftNumber),
        // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, rightLogShift, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, rightLogShift, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, rightLogShift, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, rightLogShift);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return rightLogShift(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return rightLogShift(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return rightLogShift(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, rightLogShift, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, rightLogShift, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, rightLogShift, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, rightLogShift, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return rightLogShift(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return rightLogShift(x, matrix(y)).valueOf();
        }
    });
    return rightLogShift;
});

});

parcelRegister("eTOzW", function(module, exports) {

$parcel$export(module.exports, "createRound", function () { return $ad8d6f9f0aa6bb41$export$c41ddfead54b1fbc; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");

var $1Gmbc = parcelRequire("1Gmbc");

var $272zs = parcelRequire("272zs");

var $5ntii = parcelRequire("5ntii");

var $cqeCl = parcelRequire("cqeCl");
function $ad8d6f9f0aa6bb41$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ad8d6f9f0aa6bb41$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ad8d6f9f0aa6bb41$var$ownKeys(Object(source), true).forEach(function(key) {
            $ad8d6f9f0aa6bb41$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ad8d6f9f0aa6bb41$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ad8d6f9f0aa6bb41$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ad8d6f9f0aa6bb41$var$NO_INT = "Number of decimals in function round must be an integer";
var $ad8d6f9f0aa6bb41$var$name = "round";
var $ad8d6f9f0aa6bb41$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "BigNumber",
    "DenseMatrix"
];
var $ad8d6f9f0aa6bb41$export$c41ddfead54b1fbc = /* #__PURE__ */ (0, $jKx4O.factory)($ad8d6f9f0aa6bb41$var$name, $ad8d6f9f0aa6bb41$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, zeros = _ref.zeros, BigNumber = _ref.BigNumber, DenseMatrix = _ref.DenseMatrix;
    var algorithm11 = (0, $1Gmbc.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Round a value towards the nearest integer.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.round(x)
   *    math.round(x, n)
   *
   * Examples:
   *
   *    math.round(3.2)              // returns number 3
   *    math.round(3.8)              // returns number 4
   *    math.round(-4.2)             // returns number -4
   *    math.round(-4.7)             // returns number -5
   *    math.round(math.pi, 3)       // returns number 3.142
   *    math.round(123.45678, 2)     // returns number 123.46
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.round(c)                // returns Complex 3 - 3i
   *
   *    math.round([3.2, 3.8, -4.7]) // returns Array [3, 4, -5]
   *
   * See also:
   *
   *    ceil, fix, floor
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ var round = typed($ad8d6f9f0aa6bb41$var$name, $ad8d6f9f0aa6bb41$var$_objectSpread($ad8d6f9f0aa6bb41$var$_objectSpread({}, $ad8d6f9f0aa6bb41$var$roundNumberSignatures), {}, {
        Complex: function Complex(x) {
            return x.round();
        },
        "Complex, number": function ComplexNumber(x, n) {
            if (n % 1) throw new TypeError($ad8d6f9f0aa6bb41$var$NO_INT);
            return x.round(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($ad8d6f9f0aa6bb41$var$NO_INT);
            var _n = n.toNumber();
            return x.round(_n);
        },
        "number, BigNumber": function numberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($ad8d6f9f0aa6bb41$var$NO_INT);
            return new BigNumber(x).toDecimalPlaces(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            return x.toDecimalPlaces(0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($ad8d6f9f0aa6bb41$var$NO_INT);
            return x.toDecimalPlaces(n.toNumber());
        },
        Fraction: function Fraction(x) {
            return x.round();
        },
        "Fraction, number": function FractionNumber(x, n) {
            if (n % 1) throw new TypeError($ad8d6f9f0aa6bb41$var$NO_INT);
            return x.round(n);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since round(0) = 0
            return (0, $fbkGg.deepMap)(x, round, true);
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, round, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, round, false);
        },
        "number | Complex | BigNumber, SparseMatrix": function numberComplexBigNumberSparseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm12(y, x, round, true);
        },
        "number | Complex | BigNumber, DenseMatrix": function numberComplexBigNumberDenseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm14(y, x, round, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, round, false).valueOf();
        },
        "number | Complex | BigNumber, Array": function numberComplexBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, round, true).valueOf();
        }
    }));
    return round;
});
var $ad8d6f9f0aa6bb41$var$roundNumberSignatures = {
    number: (0, $cqeCl.roundNumber),
    "number, number": function numberNumber(x, n) {
        if (!(0, $5wlxr.isInteger)(n)) throw new TypeError($ad8d6f9f0aa6bb41$var$NO_INT);
        if (n < 0 || n > 15) throw new Error("Number of decimals in function round must be in te range of 0-15");
        return (0, $cqeCl.roundNumber)(x, n);
    }
};
var $ad8d6f9f0aa6bb41$export$ee2894e1239ff693 = /* #__PURE__ */ (0, $jKx4O.factory)($ad8d6f9f0aa6bb41$var$name, [
    "typed"
], function(_ref2) {
    var typed = _ref2.typed;
    return typed($ad8d6f9f0aa6bb41$var$name, $ad8d6f9f0aa6bb41$var$roundNumberSignatures);
});

});

parcelRegister("5XB3B", function(module, exports) {

$parcel$export(module.exports, "createSec", function () { return $456f35390f6ed05b$export$5c169ecd5c25a09e; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $456f35390f6ed05b$var$name = "sec";
var $456f35390f6ed05b$var$dependencies = [
    "typed",
    "BigNumber"
];
var $456f35390f6ed05b$export$5c169ecd5c25a09e = /* #__PURE__ */ (0, $jKx4O.factory)($456f35390f6ed05b$var$name, $456f35390f6ed05b$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sec(x)
   *
   * Examples:
   *
   *    math.sec(2)      // returns number -2.4029979617223822
   *    1 / math.cos(2)  // returns number -2.4029979617223822
   *
   * See also:
   *
   *    cos, csc, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Secant of x
   */ var sec = typed($456f35390f6ed05b$var$name, {
        number: (0, $7HpLG.secNumber),
        Complex: function Complex(x) {
            return x.sec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cos());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sec is no angle");
            return sec(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, sec);
        }
    });
    return sec;
});

});

parcelRegister("kDPAE", function(module, exports) {

$parcel$export(module.exports, "createSech", function () { return $f06f77e80d8a2776$export$97a0cf2b7d31f38b; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $f06f77e80d8a2776$var$name = "sech";
var $f06f77e80d8a2776$var$dependencies = [
    "typed",
    "BigNumber"
];
var $f06f77e80d8a2776$export$97a0cf2b7d31f38b = /* #__PURE__ */ (0, $jKx4O.factory)($f06f77e80d8a2776$var$name, $f06f77e80d8a2776$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber;
    /**
   * Calculate the hyperbolic secant of a value,
   * defined as `sech(x) = 1 / cosh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sech(x)
   *
   * Examples:
   *
   *    // sech(x) = 1/ cosh(x)
   *    math.sech(0.5)       // returns 0.886818883970074
   *    1 / math.cosh(0.5)   // returns 0.886818883970074
   *
   * See also:
   *
   *    cosh, csch, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic secant of x
   */ var sech = typed($f06f77e80d8a2776$var$name, {
        number: (0, $7HpLG.sechNumber),
        Complex: function Complex(x) {
            return x.sech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cosh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sech is no angle");
            return sech(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, sech);
        }
    });
    return sech;
});

});

parcelRegister("fmA9p", function(module, exports) {

$parcel$export(module.exports, "createSetCartesian", function () { return $b2f4f3e2f4b0f4b9$export$9fa12a9d198718c8; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $b2f4f3e2f4b0f4b9$var$name = "setCartesian";
var $b2f4f3e2f4b0f4b9$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $b2f4f3e2f4b0f4b9$export$9fa12a9d198718c8 = /* #__PURE__ */ (0, $jKx4O.factory)($b2f4f3e2f4b0f4b9$var$name, $b2f4f3e2f4b0f4b9$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index, DenseMatrix = _ref.DenseMatrix;
    /**
   * Create the cartesian product of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setCartesian(set1, set2)
   *
   * Examples:
   *
   *    math.setCartesian([1, 2], [3, 4])        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference, setPowerset
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The cartesian product of two (multi)sets
   */ return typed($b2f4f3e2f4b0f4b9$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result = [];
            if (subset(size(a1), new Index(0)) !== 0 && subset(size(a2), new Index(0)) !== 0) {
                // if any of them is empty, return empty
                var b1 = (0, $YkZ7e.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
                var b2 = (0, $YkZ7e.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
                result = [];
                for(var i = 0; i < b1.length; i++)for(var j = 0; j < b2.length; j++)result.push([
                    b1[i],
                    b2[j]
                ]);
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});

});

parcelRegister("fClPk", function(module, exports) {

$parcel$export(module.exports, "createSetDifference", function () { return $b5eb5602ffb1427f$export$d81c0f9dab86d854; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $b5eb5602ffb1427f$var$name = "setDifference";
var $b5eb5602ffb1427f$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $b5eb5602ffb1427f$export$d81c0f9dab86d854 = /* #__PURE__ */ (0, $jKx4O.factory)($b5eb5602ffb1427f$var$name, $b5eb5602ffb1427f$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index, DenseMatrix = _ref.DenseMatrix;
    /**
   * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2]
   *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2]
   *
   * See also:
   *
   *    setUnion, setIntersect, setSymDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The difference of two (multi)sets
   */ return typed($b5eb5602ffb1427f$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0) // empty-anything=empty
            result = [];
            else if (subset(size(a2), new Index(0)) === 0) // anything-empty=anything
            return (0, $YkZ7e.flatten)(a1.toArray());
            else {
                var b1 = (0, $YkZ7e.identify)((0, $YkZ7e.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $YkZ7e.identify)((0, $YkZ7e.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                var inb2;
                for(var i = 0; i < b1.length; i++){
                    inb2 = false;
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        inb2 = true;
                        break;
                    }
                    if (!inb2) result.push(b1[i]);
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $YkZ7e.generalize)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $YkZ7e.generalize)(result));
        }
    });
});

});

parcelRegister("hoWVl", function(module, exports) {

$parcel$export(module.exports, "createSetDistinct", function () { return $cab2629874f382cf$export$c149680b9d8f2963; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $cab2629874f382cf$var$name = "setDistinct";
var $cab2629874f382cf$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $cab2629874f382cf$export$c149680b9d8f2963 = /* #__PURE__ */ (0, $jKx4O.factory)($cab2629874f382cf$var$name, $cab2629874f382cf$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index, DenseMatrix = _ref.DenseMatrix;
    /**
   * Collect the distinct elements of a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setDistinct(set)
   *
   * Examples:
   *
   *    math.setDistinct([1, 1, 1, 2, 2, 3])        // returns [1, 2, 3]
   *
   * See also:
   *
   *    setMultiplicity
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {Array | Matrix}    A set containing the distinc elements of the multiset
   */ return typed($cab2629874f382cf$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var result;
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            result = [];
            else {
                var b = (0, $YkZ7e.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                result = [];
                result.push(b[0]);
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) result.push(b[i]);
            } // return an array, if the input was an array
            if (Array.isArray(a)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});

});

parcelRegister("5gxQH", function(module, exports) {

$parcel$export(module.exports, "createSetIntersect", function () { return $3d58b411a60fd3b3$export$b20ee2bdfbf6defd; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $3d58b411a60fd3b3$var$name = "setIntersect";
var $3d58b411a60fd3b3$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $3d58b411a60fd3b3$export$b20ee2bdfbf6defd = /* #__PURE__ */ (0, $jKx4O.factory)($3d58b411a60fd3b3$var$name, $3d58b411a60fd3b3$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index, DenseMatrix = _ref.DenseMatrix;
    /**
   * Create the intersection of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIntersect(set1, set2)
   *
   * Examples:
   *
   *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6])            // returns [3, 4]
   *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [3, 4]
   *
   * See also:
   *
   *    setUnion, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The intersection of two (multi)sets
   */ return typed($3d58b411a60fd3b3$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0 || subset(size(a2), new Index(0)) === 0) // of any of them is empty, return empty
            result = [];
            else {
                var b1 = (0, $YkZ7e.identify)((0, $YkZ7e.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $YkZ7e.identify)((0, $YkZ7e.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                for(var i = 0; i < b1.length; i++){
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        result.push(b1[i]);
                        break;
                    }
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $YkZ7e.generalize)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $YkZ7e.generalize)(result));
        }
    });
});

});

parcelRegister("lVfxX", function(module, exports) {

$parcel$export(module.exports, "createSetIsSubset", function () { return $ff5afb16eecb6101$export$40ad73493b9f8712; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $ff5afb16eecb6101$var$name = "setIsSubset";
var $ff5afb16eecb6101$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $ff5afb16eecb6101$export$40ad73493b9f8712 = /* #__PURE__ */ (0, $jKx4O.factory)($ff5afb16eecb6101$var$name, $ff5afb16eecb6101$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index;
    /**
   * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIsSubset(set1, set2)
   *
   * Examples:
   *
   *    math.setIsSubset([1, 2], [3, 4, 5, 6])        // returns false
   *    math.setIsSubset([3, 4], [3, 4, 5, 6])        // returns true
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {boolean}            true | false
   */ return typed($ff5afb16eecb6101$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // empty is a subset of anything
            return true;
            else if (subset(size(a2), new Index(0)) === 0) // anything is not a subset of empty
            return false;
            var b1 = (0, $YkZ7e.identify)((0, $YkZ7e.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
            var b2 = (0, $YkZ7e.identify)((0, $YkZ7e.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
            var inb2;
            for(var i = 0; i < b1.length; i++){
                inb2 = false;
                for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                    // the identifier is always a decimal int
                    inb2 = true;
                    break;
                }
                if (inb2 === false) return false;
            }
            return true;
        }
    });
});

});

parcelRegister("b9ENh", function(module, exports) {

$parcel$export(module.exports, "createSetMultiplicity", function () { return $81f02dcaf036c178$export$d1f961d649e525df; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $81f02dcaf036c178$var$name = "setMultiplicity";
var $81f02dcaf036c178$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $81f02dcaf036c178$export$d1f961d649e525df = /* #__PURE__ */ (0, $jKx4O.factory)($81f02dcaf036c178$var$name, $81f02dcaf036c178$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index;
    /**
   * Count the multiplicity of an element in a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setMultiplicity(element, set)
   *
   * Examples:
   *
   *    math.setMultiplicity(1, [1, 2, 2, 4])    // returns 1
   *    math.setMultiplicity(2, [1, 2, 2, 4])    // returns 2
   *
   * See also:
   *
   *    setDistinct, setSize
   *
   * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
   * @param {Array | Matrix}     a  A multiset
   * @return {number}            The number of how many times the multiset contains the element
   */ return typed($81f02dcaf036c178$var$name, {
        "number | BigNumber | Fraction | Complex, Array | Matrix": function numberBigNumberFractionComplexArrayMatrix(e, a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return 0
            return 0;
            var b = (0, $YkZ7e.flatten)(Array.isArray(a) ? a : a.toArray());
            var count = 0;
            for(var i = 0; i < b.length; i++)if (compareNatural(b[i], e) === 0) count++;
            return count;
        }
    });
});

});

parcelRegister("eu8lH", function(module, exports) {

$parcel$export(module.exports, "createSetPowerset", function () { return $a8ba57f5911fddb1$export$55c6b5cb0b0637db; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $a8ba57f5911fddb1$var$name = "setPowerset";
var $a8ba57f5911fddb1$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $a8ba57f5911fddb1$export$55c6b5cb0b0637db = /* #__PURE__ */ (0, $jKx4O.factory)($a8ba57f5911fddb1$var$name, $a8ba57f5911fddb1$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, subset = _ref.subset, compareNatural = _ref.compareNatural, Index = _ref.Index;
    /**
   * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setPowerset(set)
   *
   * Examples:
   *
   *    math.setPowerset([1, 2, 3])        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
   *
   * See also:
   *
   *    setCartesian
   *
   * @param {Array | Matrix}    a  A (multi)set
   * @return {Array}    The powerset of the (multi)set
   */ return typed($a8ba57f5911fddb1$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            return [];
            var b = (0, $YkZ7e.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
            var result = [];
            var number = 0;
            while(number.toString(2).length <= b.length){
                result.push(_subset(b, number.toString(2).split("").reverse()));
                number++;
            } // can not return a matrix, because of the different size of the subarrays
            return _sort(result);
        }
    }); // create subset
    function _subset(array, bitarray) {
        var result = [];
        for(var i = 0; i < bitarray.length; i++)if (bitarray[i] === "1") result.push(array[i]);
        return result;
    } // sort subsests by length
    function _sort(array) {
        var temp = [];
        for(var i = array.length - 1; i > 0; i--){
            for(var j = 0; j < i; j++)if (array[j].length > array[j + 1].length) {
                temp = array[j];
                array[j] = array[j + 1];
                array[j + 1] = temp;
            }
        }
        return array;
    }
});

});

parcelRegister("4ec09", function(module, exports) {

$parcel$export(module.exports, "createSetSize", function () { return $3141c775b6cf1821$export$55134310fc79366a; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $3141c775b6cf1821$var$name = "setSize";
var $3141c775b6cf1821$var$dependencies = [
    "typed",
    "compareNatural"
];
var $3141c775b6cf1821$export$55134310fc79366a = /* #__PURE__ */ (0, $jKx4O.factory)($3141c775b6cf1821$var$name, $3141c775b6cf1821$var$dependencies, function(_ref) {
    var typed = _ref.typed, compareNatural = _ref.compareNatural;
    /**
   * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setSize(set)
   *    math.setSize(set, unique)
   *
   * Examples:
   *
   *    math.setSize([1, 2, 2, 4])          // returns 4
   *    math.setSize([1, 2, 2, 4], true)    // returns 3
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {number}            The number of elements of the (multi)set
   */ return typed($3141c775b6cf1821$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            return Array.isArray(a) ? (0, $YkZ7e.flatten)(a).length : (0, $YkZ7e.flatten)(a.toArray()).length;
        },
        "Array | Matrix, boolean": function ArrayMatrixBoolean(a, unique) {
            if (unique === false || a.length === 0) return Array.isArray(a) ? (0, $YkZ7e.flatten)(a).length : (0, $YkZ7e.flatten)(a.toArray()).length;
            else {
                var b = (0, $YkZ7e.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                var count = 1;
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) count++;
                return count;
            }
        }
    });
});

});

parcelRegister("b9MmZ", function(module, exports) {

$parcel$export(module.exports, "createSetSymDifference", function () { return $81f60e2eb79d7d6b$export$4a9a0ead2012bfc4; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $81f60e2eb79d7d6b$var$name = "setSymDifference";
var $81f60e2eb79d7d6b$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setDifference",
    "Index"
];
var $81f60e2eb79d7d6b$export$4a9a0ead2012bfc4 = /* #__PURE__ */ (0, $jKx4O.factory)($81f60e2eb79d7d6b$var$name, $81f60e2eb79d7d6b$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, concat = _ref.concat, subset = _ref.subset, setDifference = _ref.setDifference, Index = _ref.Index;
    /**
   * Create the symmetric difference of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setSymDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 5, 6]
   *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 5, 6]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The symmetric difference of two (multi)sets
   */ return typed($81f60e2eb79d7d6b$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $YkZ7e.flatten)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $YkZ7e.flatten)(a1);
            var b1 = (0, $YkZ7e.flatten)(a1);
            var b2 = (0, $YkZ7e.flatten)(a2);
            return concat(setDifference(b1, b2), setDifference(b2, b1));
        }
    });
});

});

parcelRegister("6uNr8", function(module, exports) {

$parcel$export(module.exports, "createSetUnion", function () { return $4babe47d3953cd51$export$fbdfd2054d37f888; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $4babe47d3953cd51$var$name = "setUnion";
var $4babe47d3953cd51$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setIntersect",
    "setSymDifference",
    "Index"
];
var $4babe47d3953cd51$export$fbdfd2054d37f888 = /* #__PURE__ */ (0, $jKx4O.factory)($4babe47d3953cd51$var$name, $4babe47d3953cd51$var$dependencies, function(_ref) {
    var typed = _ref.typed, size = _ref.size, concat = _ref.concat, subset = _ref.subset, setIntersect = _ref.setIntersect, setSymDifference = _ref.setSymDifference, Index = _ref.Index;
    /**
   * Create the union of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setUnion(set1, set2)
   *
   * Examples:
   *
   *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 3, 4, 5, 6]
   *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 3, 4, 5, 6]
   *
   * See also:
   *
   *    setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The union of two (multi)sets
   */ return typed($4babe47d3953cd51$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $YkZ7e.flatten)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $YkZ7e.flatten)(a1);
            var b1 = (0, $YkZ7e.flatten)(a1);
            var b2 = (0, $YkZ7e.flatten)(a2);
            return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
        }
    });
});

});

parcelRegister("lEDwz", function(module, exports) {

$parcel$export(module.exports, "createSign", function () { return $fc3bfe2166f055ec$export$45df7cae684751af; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $fc3bfe2166f055ec$var$name = "sign";
var $fc3bfe2166f055ec$var$dependencies = [
    "typed",
    "BigNumber",
    "Fraction",
    "complex"
];
var $fc3bfe2166f055ec$export$45df7cae684751af = /* #__PURE__ */ (0, $jKx4O.factory)($fc3bfe2166f055ec$var$name, $fc3bfe2166f055ec$var$dependencies, function(_ref) {
    var typed = _ref.typed, _BigNumber = _ref.BigNumber, complex = _ref.complex, _Fraction = _ref.Fraction;
    /**
   * Compute the sign of a value. The sign of a value x is:
   *
   * -  1 when x > 0
   * - -1 when x < 0
   * -  0 when x == 0
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sign(x)
   *
   * Examples:
   *
   *    math.sign(3.5)               // returns 1
   *    math.sign(-4.2)              // returns -1
   *    math.sign(0)                 // returns 0
   *
   *    math.sign([3, 5, -2, 0, 2])  // returns [1, 1, -1, 0, 1]
   *
   * See also:
   *
   *    abs
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            The number for which to determine the sign
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}e
   *            The sign of `x`
   */ var sign = typed($fc3bfe2166f055ec$var$name, {
        number: (0, $cqeCl.signNumber),
        Complex: function Complex(x) {
            return x.im === 0 ? complex((0, $cqeCl.signNumber)(x.re)) : x.sign();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x.cmp(0));
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x.s, 1);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sign(0) = 0
            return (0, $fbkGg.deepMap)(x, sign, true);
        },
        Unit: function Unit(x) {
            return sign(x.value);
        }
    });
    return sign;
});

});

parcelRegister("85Wow", function(module, exports) {

$parcel$export(module.exports, "createSin", function () { return $5e4c164e9790eb0e$export$4b4fac44ef379cae; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $5e4c164e9790eb0e$var$name = "sin";
var $5e4c164e9790eb0e$var$dependencies = [
    "typed"
];
var $5e4c164e9790eb0e$export$4b4fac44ef379cae = /* #__PURE__ */ (0, $jKx4O.factory)($5e4c164e9790eb0e$var$name, $5e4c164e9790eb0e$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sin(x)
   *
   * Examples:
   *
   *    math.sin(2)                      // returns number 0.9092974268256813
   *    math.sin(math.pi / 4)            // returns number 0.7071067811865475
   *    math.sin(math.unit(90, 'deg'))   // returns number 1
   *    math.sin(math.unit(30, 'deg'))   // returns number 0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Sine of x
   */ var sin = typed($5e4c164e9790eb0e$var$name, {
        number: Math.sin,
        Complex: function Complex(x) {
            return x.sin();
        },
        BigNumber: function BigNumber(x) {
            return x.sin();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sin is no angle");
            return sin(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sin(0) = 0
            return (0, $fbkGg.deepMap)(x, sin, true);
        }
    });
    return sin;
});

});

parcelRegister("8a63u", function(module, exports) {

$parcel$export(module.exports, "createSinh", function () { return $5f13f4552450d045$export$c3a62182c56878d5; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $7HpLG = parcelRequire("7HpLG");
var $5f13f4552450d045$var$name = "sinh";
var $5f13f4552450d045$var$dependencies = [
    "typed"
];
var $5f13f4552450d045$export$c3a62182c56878d5 = /* #__PURE__ */ (0, $jKx4O.factory)($5f13f4552450d045$var$name, $5f13f4552450d045$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the hyperbolic sine of a value,
   * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sinh(x)
   *
   * Examples:
   *
   *    math.sinh(0.5)       // returns number 0.5210953054937474
   *
   * See also:
   *
   *    cosh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic sine of x
   */ var sinh = typed($5f13f4552450d045$var$name, {
        number: (0, $7HpLG.sinhNumber),
        Complex: function Complex(x) {
            return x.sinh();
        },
        BigNumber: function BigNumber(x) {
            return x.sinh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sinh is no angle");
            return sinh(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sinh(0) = 0
            return (0, $fbkGg.deepMap)(x, sinh, true);
        }
    });
    return sinh;
});

});

parcelRegister("lmeg6", function(module, exports) {

$parcel$export(module.exports, "createSize", function () { return $f8c6b68b291ae7ae$export$9151c23a59ce3fb6; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");

var $94t5G = parcelRequire("94t5G");
var $f8c6b68b291ae7ae$var$name = "size";
var $f8c6b68b291ae7ae$var$dependencies = [
    "typed",
    "config",
    "?matrix"
];
var $f8c6b68b291ae7ae$export$9151c23a59ce3fb6 = /* #__PURE__ */ (0, $jKx4O.factory)($f8c6b68b291ae7ae$var$name, $f8c6b68b291ae7ae$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix;
    /**
   * Calculate the size of a matrix or scalar.
   *
   * Syntax:
   *
   *     math.size(x)
   *
   * Examples:
   *
   *     math.size(2.3)                  // returns []
   *     math.size('hello world')        // returns [11]
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.size(A)                    // returns [2, 3]
   *     math.size(math.range(1,6))      // returns [5]
   *
   * See also:
   *
   *     resize, squeeze, subset
   *
   * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
   * @return {Array | Matrix} A vector with size of `x`.
   */ return typed($f8c6b68b291ae7ae$var$name, {
        Matrix: function Matrix(x) {
            return x.create(x.size());
        },
        Array: (0, $YkZ7e.arraySize),
        string: function string(x) {
            return config.matrix === "Array" ? [
                x.length
            ] : matrix([
                x.length
            ]);
        },
        "number | Complex | BigNumber | Unit | boolean | null": function numberComplexBigNumberUnitBooleanNull(x) {
            // scalar
            return config.matrix === "Array" ? [] : matrix ? matrix([]) : (0, $94t5G.noMatrix)();
        }
    });
});

});

parcelRegister("5uhdj", function(module, exports) {

$parcel$export(module.exports, "createSlu", function () { return $3fed1b5b5d4973a8$export$e44ac9822ce417ae; });

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");

var $4U4N1 = parcelRequire("4U4N1");

var $aNxIe = parcelRequire("aNxIe");
var $3fed1b5b5d4973a8$var$name = "slu";
var $3fed1b5b5d4973a8$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "transpose",
    "divideScalar",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $3fed1b5b5d4973a8$export$e44ac9822ce417ae = /* #__PURE__ */ (0, $jKx4O.factory)($3fed1b5b5d4973a8$var$name, $3fed1b5b5d4973a8$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, add = _ref.add, multiply = _ref.multiply, transpose = _ref.transpose, divideScalar = _ref.divideScalar, subtract = _ref.subtract, larger = _ref.larger, largerEq = _ref.largerEq, SparseMatrix = _ref.SparseMatrix;
    var csSqr = (0, $4U4N1.createCsSqr)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csLu = (0, $aNxIe.createCsLu)({
        abs: abs,
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract,
        larger: larger,
        largerEq: largerEq,
        SparseMatrix: SparseMatrix
    });
    /**
   * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
   *
   * `P * A * Q = L * U`
   *
   * Syntax:
   *
   *    math.slu(A, order, threshold)
   *
   * Examples:
   *
   *    const A = math.sparse([[4,3], [6, 3]])
   *    math.slu(A, 1, 0.001)
   *    // returns:
   *    // {
   *    //   L: [[1, 0], [1.5, 1]]
   *    //   U: [[4, 3], [0, -1.5]]
   *    //   p: [0, 1]
   *    //   q: [0, 1]
   *    // }
   *
   * See also:
   *
   *    lup, lsolve, usolve, lusolve
   *
   * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
   * @param {Number}       order          The Symbolic Ordering and Analysis order:
   *                                       0 - Natural ordering, no permutation vector q is returned
   *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
   *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'.
   *                                           This is appropriatefor LU factorization of unsymmetric matrices.
   *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
   *                                           A dense row is a row with more than 10*sqr(columns) entries.
   * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
   */ return typed($3fed1b5b5d4973a8$var$name, {
        "SparseMatrix, number, number": function SparseMatrixNumberNumber(a, order, threshold) {
            // verify order
            if (!(0, $5wlxr.isInteger)(order) || order < 0 || order > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
             // verify threshold
            if (threshold < 0 || threshold > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
             // perform symbolic ordering and analysis
            var s = csSqr(order, a, false); // perform lu decomposition
            var f = csLu(a, s, threshold); // return decomposition
            return {
                L: f.L,
                U: f.U,
                p: f.pinv,
                q: s.q,
                toString: function toString() {
                    return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
                }
            };
        }
    });
});

});
parcelRegister("4U4N1", function(module, exports) {

$parcel$export(module.exports, "createCsSqr", function () { return $39201b8488033fd7$export$4d3f338d9cfe48c1; });

var $eipYT = parcelRequire("eipYT");

var $hacGy = parcelRequire("hacGy");

var $dDrG9 = parcelRequire("dDrG9");

var $lMHOI = parcelRequire("lMHOI");

var $kotjB = parcelRequire("kotjB");

var $jKx4O = parcelRequire("jKx4O");
var $39201b8488033fd7$var$name = "csSqr";
var $39201b8488033fd7$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $39201b8488033fd7$export$4d3f338d9cfe48c1 = /* #__PURE__ */ (0, $jKx4O.factory)($39201b8488033fd7$var$name, $39201b8488033fd7$var$dependencies, function(_ref) {
    var add = _ref.add, multiply = _ref.multiply, transpose = _ref.transpose;
    var csAmd = (0, $lMHOI.createCsAmd)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csCounts = (0, $kotjB.createCsCounts)({
        transpose: transpose
    });
    /**
   * Symbolic ordering and analysis for QR and LU decompositions.
   *
   * @param {Number}  order           The ordering strategy (see csAmd for more details)
   * @param {Matrix}  a               The A matrix
   * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
   *                                  symbolic ordering and analysis for LU decomposition (false)
   *
   * @return {Object}                 The Symbolic ordering and analysis for matrix A
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSqr(order, a, qr) {
        // a arrays
        var aptr = a._ptr;
        var asize = a._size; // columns
        var n = asize[1]; // vars
        var k; // symbolic analysis result
        var s = {}; // fill-reducing ordering
        s.q = csAmd(order, a); // validate results
        if (order && !s.q) return null;
         // QR symbolic analysis
        if (qr) {
            // apply permutations if needed
            var c = order ? (0, $eipYT.csPermute)(a, null, s.q, 0) : a; // etree of C'*C, where C=A(:,q)
            s.parent = (0, $dDrG9.csEtree)(c, 1); // post order elimination tree
            var post = (0, $hacGy.csPost)(s.parent, n); // col counts chol(C'*C)
            s.cp = csCounts(c, s.parent, post, 1); // check we have everything needed to calculate number of nonzero elements
            if (c && s.parent && s.cp && _vcount(c, s)) // calculate number of nonzero elements
            for(s.unz = 0, k = 0; k < n; k++)s.unz += s.cp[k];
        } else {
            // for LU factorization only, guess nnz(L) and nnz(U)
            s.unz = 4 * aptr[n] + n;
            s.lnz = s.unz;
        } // return result S
        return s;
    };
    /**
   * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
   */ function _vcount(a, s) {
        // a arrays
        var aptr = a._ptr;
        var aindex = a._index;
        var asize = a._size; // rows & columns
        var m = asize[0];
        var n = asize[1]; // initialize s arrays
        s.pinv = []; // (m + n)
        s.leftmost = []; // (m)
        // vars
        var parent = s.parent;
        var pinv = s.pinv;
        var leftmost = s.leftmost; // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
        var w = []; // (m + 3 * n)
        var next = 0;
        var head = m;
        var tail = m + n;
        var nque = m + 2 * n; // vars
        var i, k, p, p0, p1; // initialize w
        for(k = 0; k < n; k++){
            // queue k is empty
            w[head + k] = -1;
            w[tail + k] = -1;
            w[nque + k] = 0;
        } // initialize row arrays
        for(i = 0; i < m; i++)leftmost[i] = -1;
         // loop columns backwards
        for(k = n - 1; k >= 0; k--)// values & index for column k
        for(p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++)// leftmost[i] = min(find(A(i,:)))
        leftmost[aindex[p]] = k;
         // scan rows in reverse order
        for(i = m - 1; i >= 0; i--){
            // row i is not yet ordered
            pinv[i] = -1;
            k = leftmost[i]; // check row i is empty
            if (k === -1) continue;
             // first row in queue k
            if (w[nque + k]++ === 0) w[tail + k] = i;
             // put i at head of queue k
            w[next + i] = w[head + k];
            w[head + k] = i;
        }
        s.lnz = 0;
        s.m2 = m; // find row permutation and nnz(V)
        for(k = 0; k < n; k++){
            // remove row i from queue k
            i = w[head + k]; // count V(k,k) as nonzero
            s.lnz++; // add a fictitious row
            if (i < 0) i = s.m2++;
             // associate row i with V(:,k)
            pinv[i] = k; // skip if V(k+1:m,k) is empty
            if (--nque[k] <= 0) continue;
             // nque[k] is nnz (V(k+1:m,k))
            s.lnz += w[nque + k]; // move all rows to parent of k
            var pa = parent[k];
            if (pa !== -1) {
                if (w[nque + pa] === 0) w[tail + pa] = w[tail + k];
                w[next + w[tail + k]] = w[head + pa];
                w[head + pa] = w[next + i];
                w[nque + pa] += w[nque + k];
            }
        }
        for(i = 0; i < m; i++)if (pinv[i] < 0) pinv[i] = k++;
        return true;
    }
});

});
parcelRegister("eipYT", function(module, exports) {

$parcel$export(module.exports, "csPermute", function () { return $02af985caec49020$export$76070a0ecffd0bb2; });
/**
 * Permutes a sparse matrix C = P * A * Q
 *
 * @param {SparseMatrix}  a         The Matrix A
 * @param {Array}   pinv            The row permutation vector
 * @param {Array}   q               The column permutation vector
 * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
 *
 * @return {Matrix}                 C = P * A * Q, null on error
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $02af985caec49020$export$76070a0ecffd0bb2(a, pinv, q, values) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    var adt = a._datatype; // rows & columns
    var m = asize[0];
    var n = asize[1]; // c arrays
    var cvalues = values && a._values ? [] : null;
    var cindex = []; // (aptr[n])
    var cptr = []; // (n + 1)
    // initialize vars
    var nz = 0; // loop columns
    for(var k = 0; k < n; k++){
        // column k of C is column q[k] of A
        cptr[k] = nz; // apply column permutation
        var j = q ? q[k] : k; // loop values in column j of A
        for(var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++){
            // row i of A is row pinv[i] of C
            var r = pinv ? pinv[aindex[t]] : aindex[t]; // index
            cindex[nz] = r; // check we need to populate values
            if (cvalues) cvalues[nz] = avalues[t];
             // increment number of nonzero elements
            nz++;
        }
    } // finalize the last column of C
    cptr[n] = nz; // return C matrix
    return a.createSparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [
            m,
            n
        ],
        datatype: adt
    });
}

});

parcelRegister("hacGy", function(module, exports) {

$parcel$export(module.exports, "csPost", function () { return $c7ed35e2bb643cb5$export$90626b0a5705891a; });

var $6TF9y = parcelRequire("6TF9y");
function $c7ed35e2bb643cb5$export$90626b0a5705891a(parent, n) {
    // check inputs
    if (!parent) return null;
     // vars
    var k = 0;
    var j; // allocate result
    var post = []; // (n)
    // workspace, head: first n entries, next: next n entries, stack: last n entries
    var w = []; // (3 * n)
    var head = 0;
    var next = n;
    var stack = 2 * n; // initialize workspace
    for(j = 0; j < n; j++)// empty linked lists
    w[head + j] = -1;
     // traverse nodes in reverse order
    for(j = n - 1; j >= 0; j--){
        // check j is a root
        if (parent[j] === -1) continue;
         // add j to list of its parent
        w[next + j] = w[head + parent[j]];
        w[head + parent[j]] = j;
    } // loop nodes
    for(j = 0; j < n; j++){
        // skip j if it is not a root
        if (parent[j] !== -1) continue;
         // depth-first search
        k = (0, $6TF9y.csTdfs)(j, k, w, head, next, post, stack);
    }
    return post;
}

});
parcelRegister("6TF9y", function(module, exports) {

$parcel$export(module.exports, "csTdfs", function () { return $5057cd450a425cd9$export$18e42241aee7902a; });
/**
 * Depth-first search and postorder of a tree rooted at node j
 *
 * @param {Number}  j               The tree node
 * @param {Number}  k
 * @param {Array}   w               The workspace array
 * @param {Number}  head            The index offset within the workspace for the head array
 * @param {Number}  next            The index offset within the workspace for the next array
 * @param {Array}   post            The post ordering array
 * @param {Number}  stack           The index offset within the workspace for the stack array
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $5057cd450a425cd9$export$18e42241aee7902a(j, k, w, head, next, post, stack) {
    // variables
    var top = 0; // place j on the stack
    w[stack] = j; // while (stack is not empty)
    while(top >= 0){
        // p = top of stack
        var p = w[stack + top]; // i = youngest child of p
        var i = w[head + p];
        if (i === -1) {
            // p has no unordered children left
            top--; // node p is the kth postordered node
            post[k++] = p;
        } else {
            // remove i from children of p
            w[head + p] = w[next + i]; // increment top
            ++top; // start dfs on child node i
            w[stack + top] = i;
        }
    }
    return k;
}

});


parcelRegister("dDrG9", function(module, exports) {

$parcel$export(module.exports, "csEtree", function () { return $9ed46350d7f28433$export$720e2a9a0fdebf8c; });
/**
 * Computes the elimination tree of Matrix A (using triu(A)) or the
 * elimination tree of A'A without forming A'A.
 *
 * @param {Matrix}  a               The A Matrix
 * @param {boolean} ata             A value of true the function computes the etree of A'A
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $9ed46350d7f28433$export$720e2a9a0fdebf8c(a, ata) {
    // check inputs
    if (!a) return null;
     // a arrays
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // rows & columns
    var m = asize[0];
    var n = asize[1]; // allocate result
    var parent = []; // (n)
    // allocate workspace
    var w = []; // (n + (ata ? m : 0))
    var ancestor = 0; // first n entries in w
    var prev = n; // last m entries (ata = true)
    var i, inext; // check we are calculating A'A
    if (ata) // initialize workspace
    for(i = 0; i < m; i++)w[prev + i] = -1;
     // loop columns
    for(var k = 0; k < n; k++){
        // node k has no parent yet
        parent[k] = -1; // nor does k have an ancestor
        w[ancestor + k] = -1; // values in column k
        for(var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++){
            // row
            var r = aindex[p]; // node
            i = ata ? w[prev + r] : r; // traverse from i to k
            for(; i !== -1 && i < k; i = inext){
                // inext = ancestor of i
                inext = w[ancestor + i]; // path compression
                w[ancestor + i] = k; // check no anc., parent is k
                if (inext === -1) parent[i] = k;
            }
            if (ata) w[prev + r] = k;
        }
    }
    return parent;
}

});

parcelRegister("lMHOI", function(module, exports) {

$parcel$export(module.exports, "createCsAmd", function () { return $fdc011d09de907fa$export$485230eb48878637; });

var $jKx4O = parcelRequire("jKx4O");

var $6Y5l2 = parcelRequire("6Y5l2");

var $fiGQc = parcelRequire("fiGQc");

var $6TF9y = parcelRequire("6TF9y");
var $fdc011d09de907fa$var$name = "csAmd";
var $fdc011d09de907fa$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $fdc011d09de907fa$export$485230eb48878637 = /* #__PURE__ */ (0, $jKx4O.factory)($fdc011d09de907fa$var$name, $fdc011d09de907fa$var$dependencies, function(_ref) {
    var add = _ref.add, multiply = _ref.multiply, transpose = _ref.transpose;
    /**
   * Approximate minimum degree ordering. The minimum degree algorithm is a widely used
   * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
   * than A. It is a gready method that selects the sparsest pivot row and column during the course
   * of a right looking sparse Cholesky factorization.
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   *
   * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
   * @param {Matrix} m        Sparse Matrix
   */ return function csAmd(order, a) {
        // check input parameters
        if (!a || order <= 0 || order > 3) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // initialize vars
        var lemax = 0; // dense threshold
        var dense = Math.max(16, 10 * Math.sqrt(n));
        dense = Math.min(n - 2, dense); // create target matrix C
        var cm = _createTargetMatrix(order, a, m, n, dense); // drop diagonal entries
        (0, $6Y5l2.csFkeep)(cm, _diag, null); // C matrix arrays
        var cindex = cm._index;
        var cptr = cm._ptr; // number of nonzero elements in C
        var cnz = cptr[n]; // allocate result (n+1)
        var P = []; // create workspace (8 * (n + 1))
        var W = [];
        var len = 0; // first n + 1 entries
        var nv = n + 1; // next n + 1 entries
        var next = 2 * (n + 1); // next n + 1 entries
        var head = 3 * (n + 1); // next n + 1 entries
        var elen = 4 * (n + 1); // next n + 1 entries
        var degree = 5 * (n + 1); // next n + 1 entries
        var w = 6 * (n + 1); // next n + 1 entries
        var hhead = 7 * (n + 1); // last n + 1 entries
        // use P as workspace for last
        var last = P; // initialize quotient graph
        var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree); // initialize degree lists
        var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next); // minimum degree node
        var mindeg = 0; // vars
        var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d; // while (selecting pivots) do
        while(nel < n){
            // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
            // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
            // many nodes have been eliminated.
            for(k = -1; mindeg < n && (k = W[head + mindeg]) === -1; mindeg++);
            if (W[next + k] !== -1) last[W[next + k]] = -1;
             // remove k from degree list
            W[head + mindeg] = W[next + k]; // elenk = |Ek|
            var elenk = W[elen + k]; // # of nodes k represents
            var nvk = W[nv + k]; // W[nv + k] nodes of A eliminated
            nel += nvk; // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is
            // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
            // degree lists. All elements e in Ek are absorved into element k.
            var dk = 0; // flag k as in Lk
            W[nv + k] = -nvk;
            var p = cptr[k]; // do in place if W[elen + k] === 0
            var pk1 = elenk === 0 ? p : cnz;
            var pk2 = pk1;
            for(k1 = 1; k1 <= elenk + 1; k1++){
                if (k1 > elenk) {
                    // search the nodes in k
                    e = k; // list of nodes starts at cindex[pj]
                    pj = p; // length of list of nodes in k
                    ln = W[len + k] - elenk;
                } else {
                    // search the nodes in e
                    e = cindex[p++];
                    pj = cptr[e]; // length of list of nodes in e
                    ln = W[len + e];
                }
                for(k2 = 1; k2 <= ln; k2++){
                    i = cindex[pj++]; // check  node i dead, or seen
                    if ((nvi = W[nv + i]) <= 0) continue;
                     // W[degree + Lk] += size of node i
                    dk += nvi; // negate W[nv + i] to denote i in Lk
                    W[nv + i] = -nvi; // place i in Lk
                    cindex[pk2++] = i;
                    if (W[next + i] !== -1) last[W[next + i]] = last[i];
                     // check we need to remove i from degree list
                    if (last[i] !== -1) W[next + last[i]] = W[next + i];
                    else W[head + W[degree + i]] = W[next + i];
                }
                if (e !== k) {
                    // absorb e into k
                    cptr[e] = (0, $fiGQc.csFlip)(k); // e is now a dead element
                    W[w + e] = 0;
                }
            } // cindex[cnz...nzmax] is free
            if (elenk !== 0) cnz = pk2;
             // external degree of k - |Lk\i|
            W[degree + k] = dk; // element k is in cindex[pk1..pk2-1]
            cptr[k] = pk1;
            W[len + k] = pk2 - pk1; // k is now an element
            W[elen + k] = -2; // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
            // scan, no entry in the w array is greater than or equal to mark.
            // clear w if necessary
            mark = _wclear(mark, lemax, W, w, n); // scan 1: find |Le\Lk|
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check if W[elen + i] empty, skip it
                if ((eln = W[elen + i]) <= 0) continue;
                 // W[nv + i] was negated
                nvi = -W[nv + i];
                var wnvi = mark - nvi; // scan Ei
                for(p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++){
                    e = cindex[p];
                    if (W[w + e] >= mark) // decrement |Le\Lk|
                    W[w + e] -= nvi;
                    else if (W[w + e] !== 0) // ensure e is a live element, 1st time e seen in scan 1
                    W[w + e] = W[degree + e] + wnvi;
                }
            } // degree update
            // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
            // function h(i) for all nodes in Lk.
            // scan2: degree update
            for(pk = pk1; pk < pk2; pk++){
                // consider node i in Lk
                i = cindex[pk];
                p1 = cptr[i];
                p2 = p1 + W[elen + i] - 1;
                pn = p1; // scan Ei
                for(h = 0, d = 0, p = p1; p <= p2; p++){
                    e = cindex[p]; // check e is an unabsorbed element
                    if (W[w + e] !== 0) {
                        // dext = |Le\Lk|
                        var dext = W[w + e] - mark;
                        if (dext > 0) {
                            // sum up the set differences
                            d += dext; // keep e in Ei
                            cindex[pn++] = e; // compute the hash of node i
                            h += e;
                        } else {
                            // aggressive absorb. e->k
                            cptr[e] = (0, $fiGQc.csFlip)(k); // e is a dead element
                            W[w + e] = 0;
                        }
                    }
                } // W[elen + i] = |Ei|
                W[elen + i] = pn - p1 + 1;
                var p3 = pn;
                var p4 = p1 + W[len + i]; // prune edges in Ai
                for(p = p2 + 1; p < p4; p++){
                    j = cindex[p]; // check node j dead or in Lk
                    var nvj = W[nv + j];
                    if (nvj <= 0) continue;
                     // degree(i) += |j|
                    d += nvj; // place j in node list of i
                    cindex[pn++] = j; // compute hash for node i
                    h += j;
                } // check for mass elimination
                if (d === 0) {
                    // absorb i into k
                    cptr[i] = (0, $fiGQc.csFlip)(k);
                    nvi = -W[nv + i]; // |Lk| -= |i|
                    dk -= nvi; // |k| += W[nv + i]
                    nvk += nvi;
                    nel += nvi;
                    W[nv + i] = 0; // node i is dead
                    W[elen + i] = -1;
                } else {
                    // update degree(i)
                    W[degree + i] = Math.min(W[degree + i], d); // move first node to end
                    cindex[pn] = cindex[p3]; // move 1st el. to end of Ei
                    cindex[p3] = cindex[p1]; // add k as 1st element in of Ei
                    cindex[p1] = k; // new len of adj. list of node i
                    W[len + i] = pn - p1 + 1; // finalize hash of i
                    h = (h < 0 ? -h : h) % n; // place i in hash bucket
                    W[next + i] = W[hhead + h];
                    W[hhead + h] = i; // save hash of i in last[i]
                    last[i] = h;
                }
            } // finalize |Lk|
            W[degree + k] = dk;
            lemax = Math.max(lemax, dk); // clear w
            mark = _wclear(mark + lemax, lemax, W, w, n); // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
            // If two nodes have identical adjacency lists, their hash functions wil be identical.
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check i is dead, skip it
                if (W[nv + i] >= 0) continue;
                 // scan hash bucket of node i
                h = last[i];
                i = W[hhead + h]; // hash bucket will be empty
                W[hhead + h] = -1;
                for(; i !== -1 && W[next + i] !== -1; i = W[next + i], mark++){
                    ln = W[len + i];
                    eln = W[elen + i];
                    for(p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++)W[w + cindex[p]] = mark;
                    var jlast = i; // compare i with all j
                    for(j = W[next + i]; j !== -1;){
                        var ok = W[len + j] === ln && W[elen + j] === eln;
                        for(p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++)// compare i and j
                        if (W[w + cindex[p]] !== mark) ok = 0;
                         // check i and j are identical
                        if (ok) {
                            // absorb j into i
                            cptr[j] = (0, $fiGQc.csFlip)(i);
                            W[nv + i] += W[nv + j];
                            W[nv + j] = 0; // node j is dead
                            W[elen + j] = -1; // delete j from hash bucket
                            j = W[next + j];
                            W[next + jlast] = j;
                        } else {
                            // j and i are different
                            jlast = j;
                            j = W[next + j];
                        }
                    }
                }
            } // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
            // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
            for(p = pk1, pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check  i is dead, skip it
                if ((nvi = -W[nv + i]) <= 0) continue;
                 // restore W[nv + i]
                W[nv + i] = nvi; // compute external degree(i)
                d = W[degree + i] + dk - nvi;
                d = Math.min(d, n - nel - nvi);
                if (W[head + d] !== -1) last[W[head + d]] = i;
                 // put i back in degree list
                W[next + i] = W[head + d];
                last[i] = -1;
                W[head + d] = i; // find new minimum degree
                mindeg = Math.min(mindeg, d);
                W[degree + i] = d; // place i in Lk
                cindex[p++] = i;
            } // # nodes absorbed into k
            W[nv + k] = nvk; // length of adj list of element k
            if ((W[len + k] = p - pk1) === 0) {
                // k is a root of the tree
                cptr[k] = -1; // k is now a dead element
                W[w + k] = 0;
            }
            if (elenk !== 0) // free unused space in Lk
            cnz = p;
        } // Postordering. The elimination is complete, but no permutation has been computed. All that is left
        // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
        // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
        // is computed. The tree is restored by unflipping all of ptr.
        // fix assembly tree
        for(i = 0; i < n; i++)cptr[i] = (0, $fiGQc.csFlip)(cptr[i]);
        for(j = 0; j <= n; j++)W[head + j] = -1;
         // place unordered nodes in lists
        for(j = n; j >= 0; j--){
            // skip if j is an element
            if (W[nv + j] > 0) continue;
             // place j in list of its parent
            W[next + j] = W[head + cptr[j]];
            W[head + cptr[j]] = j;
        } // place elements in lists
        for(e = n; e >= 0; e--){
            // skip unless e is an element
            if (W[nv + e] <= 0) continue;
            if (cptr[e] !== -1) {
                // place e in list of its parent
                W[next + e] = W[head + cptr[e]];
                W[head + cptr[e]] = e;
            }
        } // postorder the assembly tree
        for(k = 0, i = 0; i <= n; i++)if (cptr[i] === -1) k = (0, $6TF9y.csTdfs)(i, k, W, head, next, P, w);
         // remove last item in array
        P.splice(P.length - 1, 1); // return P
        return P;
    };
    /**
   * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
   * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
   *
   * Order: 0
   *   A natural ordering P=null matrix is returned.
   *
   * Order: 1
   *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
   *   P = M + M'
   *
   * Order: 2
   *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
   *   P = M' * M
   *
   * Order: 3
   *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
   *   P = M' * M
   */ function _createTargetMatrix(order, a, m, n, dense) {
        // compute A'
        var at = transpose(a); // check order = 1, matrix must be square
        if (order === 1 && n === m) // C = A + A'
        return add(a, at);
         // check order = 2, drop dense columns from M'
        if (order === 2) {
            // transpose arrays
            var tindex = at._index;
            var tptr = at._ptr; // new column index
            var p2 = 0; // loop A' columns (rows)
            for(var j = 0; j < m; j++){
                // column j of AT starts here
                var p = tptr[j]; // new column j starts here
                tptr[j] = p2; // skip dense col j
                if (tptr[j + 1] - p > dense) continue;
                 // map rows in column j of A
                for(var p1 = tptr[j + 1]; p < p1; p++)tindex[p2++] = tindex[p];
            } // finalize AT
            tptr[m] = p2; // recreate A from new transpose matrix
            a = transpose(at); // use A' * A
            return multiply(at, a);
        } // use A' * A, square or rectangular matrix
        return multiply(at, a);
    }
    /**
   * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
   *
   *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
   *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
   *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
   *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
   */ function _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
        // Initialize quotient graph
        for(var k = 0; k < n; k++)W[len + k] = cptr[k + 1] - cptr[k];
        W[len + n] = 0; // initialize workspace
        for(var i = 0; i <= n; i++){
            // degree list i is empty
            W[head + i] = -1;
            last[i] = -1;
            W[next + i] = -1; // hash list i is empty
            W[hhead + i] = -1; // node i is just one node
            W[nv + i] = 1; // node i is alive
            W[w + i] = 1; // Ek of node i is empty
            W[elen + i] = 0; // degree of node i
            W[degree + i] = W[len + i];
        } // clear w
        var mark = _wclear(0, 0, W, w, n); // n is a dead element
        W[elen + n] = -2; // n is a root of assembly tree
        cptr[n] = -1; // n is a dead element
        W[w + n] = 0; // return mark
        return mark;
    }
    /**
   * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with
   * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
   * output permutation p.
   */ function _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
        // result
        var nel = 0; // loop columns
        for(var i = 0; i < n; i++){
            // degree @ i
            var d = W[degree + i]; // check node i is empty
            if (d === 0) {
                // element i is dead
                W[elen + i] = -2;
                nel++; // i is a root of assembly tree
                cptr[i] = -1;
                W[w + i] = 0;
            } else if (d > dense) {
                // absorb i into element n
                W[nv + i] = 0; // node i is dead
                W[elen + i] = -1;
                nel++;
                cptr[i] = (0, $fiGQc.csFlip)(n);
                W[nv + n]++;
            } else {
                var h = W[head + d];
                if (h !== -1) last[h] = i;
                 // put node i in degree list d
                W[next + i] = W[head + d];
                W[head + d] = i;
            }
        }
        return nel;
    }
    function _wclear(mark, lemax, W, w, n) {
        if (mark < 2 || mark + lemax < 0) {
            for(var k = 0; k < n; k++)if (W[w + k] !== 0) W[w + k] = 1;
            mark = 2;
        } // at this point, W [0..n-1] < mark holds
        return mark;
    }
    function _diag(i, j) {
        return i !== j;
    }
});

});
parcelRegister("6Y5l2", function(module, exports) {

$parcel$export(module.exports, "csFkeep", function () { return $512c7cbf4ea59206$export$9453433d9395b8cb; });
/**
 * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
 *
 * @param {Matrix}   a              The sparse matrix
 * @param {function} callback       The callback function, function will be invoked with the following args:
 *                                    - The entry row
 *                                    - The entry column
 *                                    - The entry value
 *                                    - The state parameter
 * @param {any}      other          The state
 *
 * @return                          The number of nonzero elements in the matrix
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $512c7cbf4ea59206$export$9453433d9395b8cb(a, callback, other) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // columns
    var n = asize[1]; // nonzero items
    var nz = 0; // loop columns
    for(var j = 0; j < n; j++){
        // get current location of col j
        var p = aptr[j]; // record new location of col j
        aptr[j] = nz;
        for(; p < aptr[j + 1]; p++)// check we need to keep this item
        if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
            // keep A(i,j)
            aindex[nz] = aindex[p]; // check we need to process values (pattern only)
            if (avalues) avalues[nz] = avalues[p];
             // increment nonzero items
            nz++;
        }
    } // finalize A
    aptr[n] = nz; // trim arrays
    aindex.splice(nz, aindex.length - nz); // check we need to process values (pattern only)
    if (avalues) avalues.splice(nz, avalues.length - nz);
     // return number of nonzero items
    return nz;
}

});

parcelRegister("fiGQc", function(module, exports) {

$parcel$export(module.exports, "csFlip", function () { return $b239c4c8701bad09$export$d405b3d9168b83fa; });
/**
 * This function "flips" its input about the integer -1.
 *
 * @param {Number}  i               The value to flip
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $b239c4c8701bad09$export$d405b3d9168b83fa(i) {
    // flip the value
    return -i - 2;
}

});


parcelRegister("kotjB", function(module, exports) {

$parcel$export(module.exports, "createCsCounts", function () { return $ed8cc9eb0333de49$export$1feb4fbda2abf3b3; });

var $jKx4O = parcelRequire("jKx4O");

var $hd9SV = parcelRequire("hd9SV");
var $ed8cc9eb0333de49$var$name = "csCounts";
var $ed8cc9eb0333de49$var$dependencies = [
    "transpose"
];
var $ed8cc9eb0333de49$export$1feb4fbda2abf3b3 = /* #__PURE__ */ (0, $jKx4O.factory)($ed8cc9eb0333de49$var$name, $ed8cc9eb0333de49$var$dependencies, function(_ref) {
    var transpose = _ref.transpose;
    /**
   * Computes the column counts using the upper triangular part of A.
   * It transposes A internally, none of the input parameters are modified.
   *
   * @param {Matrix} a           The sparse matrix A
   *
   * @param {Matrix} ata         Count the columns of A'A instead
   *
   * @return                     An array of size n of the column counts or null on error
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function(a, parent, post, ata) {
        // check inputs
        if (!a || !parent || !post) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // variables
        var i, j, k, J, p, p0, p1; // workspace size
        var s = 4 * n + (ata ? n + m + 1 : 0); // allocate workspace
        var w = []; // (s)
        var ancestor = 0; // first n entries
        var maxfirst = n; // next n entries
        var prevleaf = 2 * n; // next n entries
        var first = 3 * n; // next n entries
        var head = 4 * n; // next n + 1 entries (used when ata is true)
        var next = 5 * n + 1; // last entries in workspace
        // clear workspace w[0..s-1]
        for(k = 0; k < s; k++)w[k] = -1;
         // allocate result
        var colcount = []; // (n)
        // AT = A'
        var at = transpose(a); // at arrays
        var tindex = at._index;
        var tptr = at._ptr; // find w[first + j]
        for(k = 0; k < n; k++){
            j = post[k]; // colcount[j]=1 if j is a leaf
            colcount[j] = w[first + j] === -1 ? 1 : 0;
            for(; j !== -1 && w[first + j] === -1; j = parent[j])w[first + j] = k;
        } // initialize ata if needed
        if (ata) {
            // invert post
            for(k = 0; k < n; k++)w[post[k]] = k;
             // loop rows (columns in AT)
            for(i = 0; i < m; i++){
                // values in column i of AT
                for(k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++)k = Math.min(k, w[tindex[p]]);
                 // place row i in linked list k
                w[next + i] = w[head + k];
                w[head + k] = i;
            }
        } // each node in its own set
        for(i = 0; i < n; i++)w[ancestor + i] = i;
        for(k = 0; k < n; k++){
            // j is the kth node in postordered etree
            j = post[k]; // check j is not a root
            if (parent[j] !== -1) colcount[parent[j]]--;
             // J=j for LL'=A case
            for(J = ata ? w[head + k] : j; J !== -1; J = ata ? w[next + J] : -1)for(p = tptr[J]; p < tptr[J + 1]; p++){
                i = tindex[p];
                var r = (0, $hd9SV.csLeaf)(i, j, w, first, maxfirst, prevleaf, ancestor); // check A(i,j) is in skeleton
                if (r.jleaf >= 1) colcount[j]++;
                 // check account for overlap in q
                if (r.jleaf === 2) colcount[r.q]--;
            }
            if (parent[j] !== -1) w[ancestor + j] = parent[j];
        } // sum up colcount's of each child
        for(j = 0; j < n; j++)if (parent[j] !== -1) colcount[parent[j]] += colcount[j];
        return colcount;
    };
});

});
parcelRegister("hd9SV", function(module, exports) {

$parcel$export(module.exports, "csLeaf", function () { return $c87b51799cb4b2b3$export$e5adc9884f74ac27; });
/**
 * This function determines if j is a leaf of the ith row subtree.
 * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
 *
 * @param {Number}  i               The ith row subtree
 * @param {Number}  j               The node to test
 * @param {Array}   w               The workspace array
 * @param {Number}  first           The index offset within the workspace for the first array
 * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
 * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
 * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
 *
 * @return {Object}
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $c87b51799cb4b2b3$export$e5adc9884f74ac27(i, j, w, first, maxfirst, prevleaf, ancestor) {
    var s, sparent; // our result
    var jleaf = 0;
    var q; // check j is a leaf
    if (i <= j || w[first + j] <= w[maxfirst + i]) return -1;
     // update max first[j] seen so far
    w[maxfirst + i] = w[first + j]; // jprev = previous leaf of ith subtree
    var jprev = w[prevleaf + i];
    w[prevleaf + i] = j; // check j is first or subsequent leaf
    if (jprev === -1) {
        // 1st leaf, q = root of ith subtree
        jleaf = 1;
        q = i;
    } else {
        // update jleaf
        jleaf = 2; // q = least common ancester (jprev,j)
        for(q = jprev; q !== w[ancestor + q]; q = w[ancestor + q]);
        for(s = jprev; s !== q; s = sparent){
            // path compression
            sparent = w[ancestor + s];
            w[ancestor + s] = q;
        }
    }
    return {
        jleaf: jleaf,
        q: q
    };
}

});



parcelRegister("aNxIe", function(module, exports) {

$parcel$export(module.exports, "createCsLu", function () { return $7dc8a192905f675a$export$5487b5fadeacd2f6; });

var $jKx4O = parcelRequire("jKx4O");

var $6Guq1 = parcelRequire("6Guq1");
var $7dc8a192905f675a$var$name = "csLu";
var $7dc8a192905f675a$var$dependencies = [
    "abs",
    "divideScalar",
    "multiply",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $7dc8a192905f675a$export$5487b5fadeacd2f6 = /* #__PURE__ */ (0, $jKx4O.factory)($7dc8a192905f675a$var$name, $7dc8a192905f675a$var$dependencies, function(_ref) {
    var abs = _ref.abs, divideScalar = _ref.divideScalar, multiply = _ref.multiply, subtract = _ref.subtract, larger = _ref.larger, largerEq = _ref.largerEq, SparseMatrix = _ref.SparseMatrix;
    var csSpsolve = (0, $6Guq1.createCsSpsolve)({
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract
    });
    /**
   * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
   * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L
   * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
   * L * U = A(p, q), where p is the inverse of pinv.
   *
   * @param {Matrix}  m               The A Matrix to factorize
   * @param {Object}  s               The symbolic analysis from csSqr(). Provides the fill-reducing
   *                                  column ordering q
   * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Number}                 The numeric LU factorization of A or null
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csLu(m, s, tol) {
        // validate input
        if (!m) return null;
         // m arrays
        var size = m._size; // columns
        var n = size[1]; // symbolic analysis result
        var q;
        var lnz = 100;
        var unz = 100; // update symbolic analysis parameters
        if (s) {
            q = s.q;
            lnz = s.lnz || lnz;
            unz = s.unz || unz;
        } // L arrays
        var lvalues = []; // (lnz)
        var lindex = []; // (lnz)
        var lptr = []; // (n + 1)
        // L
        var L = new SparseMatrix({
            values: lvalues,
            index: lindex,
            ptr: lptr,
            size: [
                n,
                n
            ]
        }); // U arrays
        var uvalues = []; // (unz)
        var uindex = []; // (unz)
        var uptr = []; // (n + 1)
        // U
        var U = new SparseMatrix({
            values: uvalues,
            index: uindex,
            ptr: uptr,
            size: [
                n,
                n
            ]
        }); // inverse of permutation vector
        var pinv = []; // (n)
        // vars
        var i, p; // allocate arrays
        var x = []; // (n)
        var xi = []; // (2 * n)
        // initialize variables
        for(i = 0; i < n; i++){
            // clear workspace
            x[i] = 0; // no rows pivotal yet
            pinv[i] = -1; // no cols of L yet
            lptr[i + 1] = 0;
        } // reset number of nonzero elements in L and U
        lnz = 0;
        unz = 0; // compute L(:,k) and U(:,k)
        for(var k = 0; k < n; k++){
            // update ptr
            lptr[k] = lnz;
            uptr[k] = unz; // apply column permutations if needed
            var col = q ? q[k] : k; // solve triangular system, x = L\A(:,col)
            var top = csSpsolve(L, m, col, xi, x, pinv, 1); // find pivot
            var ipiv = -1;
            var a = -1; // loop xi[] from top -> n
            for(p = top; p < n; p++){
                // x[i] is nonzero
                i = xi[p]; // check row i is not yet pivotal
                if (pinv[i] < 0) {
                    // absolute value of x[i]
                    var xabs = abs(x[i]); // check absoulte value is greater than pivot value
                    if (larger(xabs, a)) {
                        // largest pivot candidate so far
                        a = xabs;
                        ipiv = i;
                    }
                } else {
                    // x(i) is the entry U(pinv[i],k)
                    uindex[unz] = pinv[i];
                    uvalues[unz++] = x[i];
                }
            } // validate we found a valid pivot
            if (ipiv === -1 || a <= 0) return null;
             // update actual pivot column, give preference to diagonal value
            if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol))) ipiv = col;
             // the chosen pivot
            var pivot = x[ipiv]; // last entry in U(:,k) is U(k,k)
            uindex[unz] = k;
            uvalues[unz++] = pivot; // ipiv is the kth pivot row
            pinv[ipiv] = k; // first entry in L(:,k) is L(k,k) = 1
            lindex[lnz] = ipiv;
            lvalues[lnz++] = 1; // L(k+1:n,k) = x / pivot
            for(p = top; p < n; p++){
                // row
                i = xi[p]; // check x(i) is an entry in L(:,k)
                if (pinv[i] < 0) {
                    // save unpermuted row in L
                    lindex[lnz] = i; // scale pivot column
                    lvalues[lnz++] = divideScalar(x[i], pivot);
                } // x[0..n-1] = 0 for next k
                x[i] = 0;
            }
        } // update ptr
        lptr[n] = lnz;
        uptr[n] = unz; // fix row indices of L for final pinv
        for(p = 0; p < lnz; p++)lindex[p] = pinv[lindex[p]];
         // trim arrays
        lvalues.splice(lnz, lvalues.length - lnz);
        lindex.splice(lnz, lindex.length - lnz);
        uvalues.splice(unz, uvalues.length - unz);
        uindex.splice(unz, uindex.length - unz); // return LU factor
        return {
            L: L,
            U: U,
            pinv: pinv
        };
    };
});

});
parcelRegister("6Guq1", function(module, exports) {

$parcel$export(module.exports, "createCsSpsolve", function () { return $4dde42d588553e82$export$517933164557054f; });

var $klLZb = parcelRequire("klLZb");

var $jKx4O = parcelRequire("jKx4O");
var $4dde42d588553e82$var$name = "csSpsolve";
var $4dde42d588553e82$var$dependencies = [
    "divideScalar",
    "multiply",
    "subtract"
];
var $4dde42d588553e82$export$517933164557054f = /* #__PURE__ */ (0, $jKx4O.factory)($4dde42d588553e82$var$name, $4dde42d588553e82$var$dependencies, function(_ref) {
    var divideScalar = _ref.divideScalar, multiply = _ref.multiply, subtract = _ref.subtract;
    /**
   * The function csSpsolve() computes the solution to G * x = bk, where bk is the
   * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
   * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U
   * is upper triangular with the diagonal entry as the last entry in each column.
   *
   * @param {Matrix}  g               The G matrix
   * @param {Matrix}  b               The B matrix
   * @param {Number}  k               The kth column in B
   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
   * @param {Array}   x               The soluton to the linear system G * x = b
   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
   * @param {boolean} lo              The lower (true) upper triangular (false) flag
   *
   * @return {Number}                 The index for the nonzero pattern
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSpsolve(g, b, k, xi, x, pinv, lo) {
        // g arrays
        var gvalues = g._values;
        var gindex = g._index;
        var gptr = g._ptr;
        var gsize = g._size; // columns
        var n = gsize[1]; // b arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr; // vars
        var p, p0, p1, q; // xi[top..n-1] = csReach(B(:,k))
        var top = (0, $klLZb.csReach)(g, b, k, xi, pinv); // clear x
        for(p = top; p < n; p++)x[xi[p]] = 0;
         // scatter b
        for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++)x[bindex[p]] = bvalues[p];
         // loop columns
        for(var px = top; px < n; px++){
            // x array index for px
            var j = xi[px]; // apply permutation vector (U x = b), j maps to column J of G
            var J = pinv ? pinv[j] : j; // check column J is empty
            if (J < 0) continue;
             // column value indeces in G, p0 <= p < p1
            p0 = gptr[J];
            p1 = gptr[J + 1]; // x(j) /= G(j,j)
            x[j] = divideScalar(x[j], gvalues[lo ? p0 : p1 - 1]); // first entry L(j,j)
            p = lo ? p0 + 1 : p0;
            q = lo ? p1 : p1 - 1; // loop
            for(; p < q; p++){
                // row
                var i = gindex[p]; // x(i) -= G(i,j) * x(j)
                x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
            }
        } // return top of stack
        return top;
    };
});

});
parcelRegister("klLZb", function(module, exports) {

$parcel$export(module.exports, "csReach", function () { return $03d2c2075ea834c2$export$125cefbcd149ec98; });

var $hBYPp = parcelRequire("hBYPp");

var $8LvzJ = parcelRequire("8LvzJ");

var $lV5dj = parcelRequire("lV5dj");
function $03d2c2075ea834c2$export$125cefbcd149ec98(g, b, k, xi, pinv) {
    // g arrays
    var gptr = g._ptr;
    var gsize = g._size; // b arrays
    var bindex = b._index;
    var bptr = b._ptr; // columns
    var n = gsize[1]; // vars
    var p, p0, p1; // initialize top
    var top = n; // loop column indeces in B
    for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++){
        // node i
        var i = bindex[p]; // check node i is marked
        if (!(0, $hBYPp.csMarked)(gptr, i)) // start a dfs at unmarked node i
        top = (0, $lV5dj.csDfs)(i, g, top, xi, pinv);
    } // loop columns from top -> n - 1
    for(p = top; p < n; p++)// restore G
    (0, $8LvzJ.csMark)(gptr, xi[p]);
    return top;
}

});
parcelRegister("hBYPp", function(module, exports) {

$parcel$export(module.exports, "csMarked", function () { return $cd251393853f90c0$export$f0d640c1b5bfa3e; });
/**
 * Checks if the node at w[j] is marked
 *
 * @param {Array}   w               The array
 * @param {Number}  j               The array index
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $cd251393853f90c0$export$f0d640c1b5bfa3e(w, j) {
    // check node is marked
    return w[j] < 0;
}

});

parcelRegister("8LvzJ", function(module, exports) {

$parcel$export(module.exports, "csMark", function () { return $661b34b38e636351$export$53b20e7656f0b914; });

var $fiGQc = parcelRequire("fiGQc");
function $661b34b38e636351$export$53b20e7656f0b914(w, j) {
    // mark w[j]
    w[j] = (0, $fiGQc.csFlip)(w[j]);
}

});

parcelRegister("lV5dj", function(module, exports) {

$parcel$export(module.exports, "csDfs", function () { return $ff52f7298d448b30$export$c913fe476af3832b; });

var $hBYPp = parcelRequire("hBYPp");

var $8LvzJ = parcelRequire("8LvzJ");

var $kjsXw = parcelRequire("kjsXw");
function $ff52f7298d448b30$export$c913fe476af3832b(j, g, top, xi, pinv) {
    // g arrays
    var index = g._index;
    var ptr = g._ptr;
    var size = g._size; // columns
    var n = size[1]; // vars
    var i, p, p2; // initialize head
    var head = 0; // initialize the recursion stack
    xi[0] = j; // loop
    while(head >= 0){
        // get j from the top of the recursion stack
        j = xi[head]; // apply permutation vector
        var jnew = pinv ? pinv[j] : j; // check node j is marked
        if (!(0, $hBYPp.csMarked)(ptr, j)) {
            // mark node j as visited
            (0, $8LvzJ.csMark)(ptr, j); // update stack (last n entries in xi)
            xi[n + head] = jnew < 0 ? 0 : (0, $kjsXw.csUnflip)(ptr[jnew]);
        } // node j done if no unvisited neighbors
        var done = 1; // examine all neighbors of j, stack (last n entries in xi)
        for(p = xi[n + head], p2 = jnew < 0 ? 0 : (0, $kjsXw.csUnflip)(ptr[jnew + 1]); p < p2; p++){
            // consider neighbor node i
            i = index[p]; // check we have visited node i, skip it
            if ((0, $hBYPp.csMarked)(ptr, i)) continue;
             // pause depth-first search of node j, update stack (last n entries in xi)
            xi[n + head] = p; // start dfs at node i
            xi[++head] = i; // node j is not done
            done = 0; // break, to start dfs(i)
            break;
        } // check depth-first search at node j is done
        if (done) {
            // remove j from the recursion stack
            head--; // and place in the output stack
            xi[--top] = j;
        }
    }
    return top;
}

});
parcelRegister("kjsXw", function(module, exports) {

$parcel$export(module.exports, "csUnflip", function () { return $ec9c0ba70eb35a25$export$8b1bf205e2e76d92; });

var $fiGQc = parcelRequire("fiGQc");
function $ec9c0ba70eb35a25$export$8b1bf205e2e76d92(i) {
    // flip the value if it is negative
    return i < 0 ? (0, $fiGQc.csFlip)(i) : i;
}

});






parcelRegister("k6EQp", function(module, exports) {

$parcel$export(module.exports, "createSmaller", function () { return $ea340d03f60aa3a7$export$6b477d90b957f03e; });

var $9zoJy = parcelRequire("9zoJy");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $272zs = parcelRequire("272zs");

var $5ntii = parcelRequire("5ntii");

var $kJFHo = parcelRequire("kJFHo");
var $ea340d03f60aa3a7$var$name = "smaller";
var $ea340d03f60aa3a7$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $ea340d03f60aa3a7$export$6b477d90b957f03e = /* #__PURE__ */ (0, $jKx4O.factory)($ea340d03f60aa3a7$var$name, $ea340d03f60aa3a7$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is smaller than y.
   *
   * The function returns true when x is smaller than y and the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smaller(x, y)
   *
   * Examples:
   *
   *    math.smaller(2, 3)            // returns true
   *    math.smaller(5, 2 * 2)        // returns false
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.smaller(a, b)            // returns true
   *
   * See also:
   *
   *    equal, unequal, smallerEq, smaller, smallerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ var smaller = typed($ea340d03f60aa3a7$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x < y;
        },
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lt(y) && !(0, $9zoJy.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) === -1;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return smaller(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, smaller);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, smaller, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, smaller, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, smaller);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return smaller(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return smaller(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return smaller(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, smaller, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, smaller, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, smaller, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, smaller, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, smaller, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, smaller, true).valueOf();
        }
    });
    return smaller;
});
var $ea340d03f60aa3a7$export$4f82e7db4d803209 = /* #__PURE__ */ (0, $jKx4O.factory)($ea340d03f60aa3a7$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($ea340d03f60aa3a7$var$name, {
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("aXhcX", function(module, exports) {

$parcel$export(module.exports, "createSmallerEq", function () { return $7f9cc3350efdd9f2$export$e1b2fff975be9083; });

var $9zoJy = parcelRequire("9zoJy");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $272zs = parcelRequire("272zs");

var $5ntii = parcelRequire("5ntii");

var $kJFHo = parcelRequire("kJFHo");
var $7f9cc3350efdd9f2$var$name = "smallerEq";
var $7f9cc3350efdd9f2$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $7f9cc3350efdd9f2$export$e1b2fff975be9083 = /* #__PURE__ */ (0, $jKx4O.factory)($7f9cc3350efdd9f2$var$name, $7f9cc3350efdd9f2$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is smaller or equal to y.
   *
   * The function returns true when x is smaller than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smallerEq(x, y)
   *
   * Examples:
   *
   *    math.smaller(1 + 2, 3)        // returns false
   *    math.smallerEq(1 + 2, 3)      // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ var smallerEq = typed($7f9cc3350efdd9f2$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x <= y;
        },
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lte(y) || (0, $9zoJy.nearlyEqual)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) !== 1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return smallerEq(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, smallerEq);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, smallerEq, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, smallerEq, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, smallerEq);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return smallerEq(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return smallerEq(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return smallerEq(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, smallerEq, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, smallerEq, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, smallerEq, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, smallerEq, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, smallerEq, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, smallerEq, true).valueOf();
        }
    });
    return smallerEq;
});
var $7f9cc3350efdd9f2$export$78c24428429985da = /* #__PURE__ */ (0, $jKx4O.factory)($7f9cc3350efdd9f2$var$name, [
    "typed",
    "config"
], function(_ref2) {
    var typed = _ref2.typed, config = _ref2.config;
    return typed($7f9cc3350efdd9f2$var$name, {
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $5wlxr.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("iQ3s3", function(module, exports) {

$parcel$export(module.exports, "createSort", function () { return $db6fc2b7464443d7$export$10463693a2093403; });

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $db6fc2b7464443d7$var$name = "sort";
var $db6fc2b7464443d7$var$dependencies = [
    "typed",
    "matrix",
    "compare",
    "compareNatural"
];
var $db6fc2b7464443d7$export$10463693a2093403 = /* #__PURE__ */ (0, $jKx4O.factory)($db6fc2b7464443d7$var$name, $db6fc2b7464443d7$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, compare = _ref.compare, compareNatural = _ref.compareNatural;
    var compareAsc = compare;
    var compareDesc = function compareDesc(a, b) {
        return -compare(a, b);
    };
    /**
   * Sort the items in a matrix.
   *
   * Syntax:
   *
   *    math.sort(x)
   *    math.sort(x, compare)
   *
   * Examples:
   *
   *    math.sort([5, 10, 1]) // returns [1, 5, 10]
   *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural)
   *    // returns ['A', 'B', 'C', 'D']
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength)
   *    // returns ['Tom', 'Sara', 'Langdon']
   *
   * See also:
   *
   *    filter, forEach, map, compare, compareNatural
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
   *        An optional _comparator function or name. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {Matrix | Array} Returns the sorted matrix.
   */ return typed($db6fc2b7464443d7$var$name, {
        Array: function Array(x) {
            _arrayIsVector(x);
            return x.sort(compareAsc);
        },
        Matrix: function Matrix(x) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(compareAsc), x.storage());
        },
        "Array, function": function ArrayFunction(x, _comparator) {
            _arrayIsVector(x);
            return x.sort(_comparator);
        },
        "Matrix, function": function MatrixFunction(x, _comparator) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator), x.storage());
        },
        "Array, string": function ArrayString(x, order) {
            _arrayIsVector(x);
            return x.sort(_comparator(order));
        },
        "Matrix, string": function MatrixString(x, order) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator(order)), x.storage());
        }
    });
    /**
   * Get the comparator for given order ('asc', 'desc', 'natural')
   * @param {'asc' | 'desc' | 'natural'} order
   * @return {Function} Returns a _comparator function
   */ function _comparator(order) {
        if (order === "asc") return compareAsc;
        else if (order === "desc") return compareDesc;
        else if (order === "natural") return compareNatural;
        else throw new Error('String "asc", "desc", or "natural" expected');
    }
    /**
   * Validate whether an array is one dimensional
   * Throws an error when this is not the case
   * @param {Array} array
   * @private
   */ function _arrayIsVector(array) {
        if ((0, $YkZ7e.arraySize)(array).length !== 1) throw new Error("One dimensional array expected");
    }
    /**
   * Validate whether a matrix is one dimensional
   * Throws an error when this is not the case
   * @param {Matrix} matrix
   * @private
   */ function _matrixIsVector(matrix) {
        if (matrix.size().length !== 1) throw new Error("One dimensional matrix expected");
    }
});

});

parcelRegister("7iHRB", function(module, exports) {

$parcel$export(module.exports, "createSpaClass", function () { return $550c3d37da969f19$export$5e37e847685a0540; });

var $jKx4O = parcelRequire("jKx4O");
var $550c3d37da969f19$var$name = "Spa";
var $550c3d37da969f19$var$dependencies = [
    "addScalar",
    "equalScalar",
    "FibonacciHeap"
];
var $550c3d37da969f19$export$5e37e847685a0540 = /* #__PURE__ */ (0, $jKx4O.factory)($550c3d37da969f19$var$name, $550c3d37da969f19$var$dependencies, function(_ref) {
    var addScalar = _ref.addScalar, equalScalar = _ref.equalScalar, FibonacciHeap = _ref.FibonacciHeap;
    /**
   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
   * of the vector elements and an ordered list of non-zero elements.
   */ function Spa() {
        if (!(this instanceof Spa)) throw new SyntaxError("Constructor must be called with the new operator");
         // allocate vector, TODO use typed arrays
        this._values = [];
        this._heap = new FibonacciHeap();
    }
    /**
   * Attach type information
   */ Spa.prototype.type = "Spa";
    Spa.prototype.isSpa = true;
    /**
   * Set the value for index i.
   *
   * @param {number} i                       The index
   * @param {number | BigNumber | Complex}   The value at index i
   */ Spa.prototype.set = function(i, v) {
        // check we have a value @ i
        if (!this._values[i]) {
            // insert in heap
            var node = this._heap.insert(i, v); // set the value @ i
            this._values[i] = node;
        } else // update the value @ i
        this._values[i].value = v;
    };
    Spa.prototype.get = function(i) {
        var node = this._values[i];
        if (node) return node.value;
        return 0;
    };
    Spa.prototype.accumulate = function(i, v) {
        // node @ i
        var node = this._values[i];
        if (!node) {
            // insert in heap
            node = this._heap.insert(i, v); // initialize value
            this._values[i] = node;
        } else // accumulate value
        node.value = addScalar(node.value, v);
    };
    Spa.prototype.forEach = function(from, to, callback) {
        // references
        var heap = this._heap;
        var values = this._values; // nodes
        var nodes = []; // node with minimum key, save it
        var node = heap.extractMinimum();
        if (node) nodes.push(node);
         // extract nodes from heap (ordered)
        while(node && node.key <= to){
            // check it is in range
            if (node.key >= from) // check value is not zero
            {
                if (!equalScalar(node.value, 0)) // invoke callback
                callback(node.key, node.value, this);
            } // extract next node, save it
            node = heap.extractMinimum();
            if (node) nodes.push(node);
        } // reinsert all nodes in heap
        for(var i = 0; i < nodes.length; i++){
            // current node
            var n = nodes[i]; // insert node in heap
            node = heap.insert(n.key, n.value); // update values
            values[node.key] = node;
        }
    };
    Spa.prototype.swap = function(i, j) {
        // node @ i and j
        var nodei = this._values[i];
        var nodej = this._values[j]; // check we need to insert indeces
        if (!nodei && nodej) {
            // insert in heap
            nodei = this._heap.insert(i, nodej.value); // remove from heap
            this._heap.remove(nodej); // set values
            this._values[i] = nodei;
            this._values[j] = undefined;
        } else if (nodei && !nodej) {
            // insert in heap
            nodej = this._heap.insert(j, nodei.value); // remove from heap
            this._heap.remove(nodei); // set values
            this._values[j] = nodej;
            this._values[i] = undefined;
        } else if (nodei && nodej) {
            // swap values
            var v = nodei.value;
            nodei.value = nodej.value;
            nodej.value = v;
        }
    };
    return Spa;
}, {
    isClass: true
});

});

parcelRegister("8QVss", function(module, exports) {

$parcel$export(module.exports, "createSparse", function () { return $671fc003859bf4b3$export$89ff03fdb3964a99; });

var $jKx4O = parcelRequire("jKx4O");
var $671fc003859bf4b3$var$name = "sparse";
var $671fc003859bf4b3$var$dependencies = [
    "typed",
    "SparseMatrix"
];
var $671fc003859bf4b3$export$89ff03fdb3964a99 = /* #__PURE__ */ (0, $jKx4O.factory)($671fc003859bf4b3$var$name, $671fc003859bf4b3$var$dependencies, function(_ref) {
    var typed = _ref.typed, SparseMatrix = _ref.SparseMatrix;
    /**
   * Create a Sparse Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   *
   * Syntax:
   *
   *    math.sparse()               // creates an empty sparse matrix.
   *    math.sparse(data)           // creates a sparse matrix with initial data.
   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
   *
   * Examples:
   *
   *    let m = math.sparse([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, matrix
   *
   * @param {Array | Matrix} [data]    A two dimensional array
   *
   * @return {Matrix} The created matrix
   */ return typed($671fc003859bf4b3$var$name, {
        "": function _() {
            return new SparseMatrix([]);
        },
        string: function string(datatype) {
            return new SparseMatrix([], datatype);
        },
        "Array | Matrix": function ArrayMatrix(data) {
            return new SparseMatrix(data);
        },
        "Array | Matrix, string": function ArrayMatrixString(data, datatype) {
            return new SparseMatrix(data, datatype);
        }
    });
});

});

parcelRegister("l964k", function(module, exports) {

$parcel$export(module.exports, "createSparseMatrixClass", function () { return $f64f255f8cf6e964$export$a783ce8f6a98b2e5; });

var $7E0JQ = parcelRequire("7E0JQ");

var $5wlxr = parcelRequire("5wlxr");

var $7HWRb = parcelRequire("7HWRb");

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");
var $f64f255f8cf6e964$var$name = "SparseMatrix";
var $f64f255f8cf6e964$var$dependencies = [
    "typed",
    "equalScalar",
    "Matrix"
];
var $f64f255f8cf6e964$export$a783ce8f6a98b2e5 = /* #__PURE__ */ (0, $jKx4O.factory)($f64f255f8cf6e964$var$name, $f64f255f8cf6e964$var$dependencies, function(_ref) {
    var typed = _ref.typed, equalScalar = _ref.equalScalar, Matrix = _ref.Matrix;
    /**
   * Sparse Matrix implementation. This type implements a Compressed Column Storage format
   * for sparse matrices.
   * @class SparseMatrix
   */ function SparseMatrix(data, datatype) {
        if (!(this instanceof SparseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $7E0JQ.isString)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $7E0JQ.isMatrix)(data)) // create from matrix
        _createFromMatrix(this, data, datatype);
        else if (data && (0, $7E0JQ.isArray)(data.index) && (0, $7E0JQ.isArray)(data.ptr) && (0, $7E0JQ.isArray)(data.size)) {
            // initialize fields
            this._values = data.values;
            this._index = data.index;
            this._ptr = data.ptr;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
        } else if ((0, $7E0JQ.isArray)(data)) // create from array
        _createFromArray(this, data, datatype);
        else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $7E0JQ.typeOf)(data) + ")");
        else {
            // nothing provided
            this._values = [];
            this._index = [];
            this._ptr = [
                0
            ];
            this._size = [
                0,
                0
            ];
            this._datatype = datatype;
        }
    }
    function _createFromMatrix(matrix, source, datatype) {
        // check matrix type
        if (source.type === "SparseMatrix") {
            // clone arrays
            matrix._values = source._values ? (0, $glBd7.clone)(source._values) : undefined;
            matrix._index = (0, $glBd7.clone)(source._index);
            matrix._ptr = (0, $glBd7.clone)(source._ptr);
            matrix._size = (0, $glBd7.clone)(source._size);
            matrix._datatype = datatype || source._datatype;
        } else // build from matrix data
        _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
    }
    function _createFromArray(matrix, data, datatype) {
        // initialize fields
        matrix._values = [];
        matrix._index = [];
        matrix._ptr = [];
        matrix._datatype = datatype; // discover rows & columns, do not use math.size() to avoid looping array twice
        var rows = data.length;
        var columns = 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $7E0JQ.isString)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        } // check we have rows (empty array)
        if (rows > 0) {
            // column index
            var j = 0;
            do {
                // store pointer to values index
                matrix._ptr.push(matrix._index.length); // loop rows
                for(var i = 0; i < rows; i++){
                    // current row
                    var row = data[i]; // check row is an array
                    if ((0, $7E0JQ.isArray)(row)) {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < row.length) columns = row.length;
                         // check row has column
                        if (j < row.length) {
                            // value
                            var v = row[j]; // check value != 0
                            if (!eq(v, zero)) {
                                // store value
                                matrix._values.push(v); // index
                                matrix._index.push(i);
                            }
                        }
                    } else {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < 1) columns = 1;
                         // check value != 0 (row is a scalar)
                        if (!eq(row, zero)) {
                            // store value
                            matrix._values.push(row); // index
                            matrix._index.push(i);
                        }
                    }
                } // increment index
                j++;
            }while (j < columns);
        } // store number of values in ptr
        matrix._ptr.push(matrix._index.length); // size
        matrix._size = [
            rows,
            columns
        ];
    }
    SparseMatrix.prototype = new Matrix();
    /**
   * Create a new SparseMatrix
   */ SparseMatrix.prototype.createSparseMatrix = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ SparseMatrix.prototype.type = "SparseMatrix";
    SparseMatrix.prototype.isSparseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf SparseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ SparseMatrix.prototype.getDataType = function() {
        return (0, $YkZ7e.getArrayDataType)(this._values, (0, $7E0JQ.typeOf));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @memberof SparseMatrix
   * @return {string}           The storage format.
   */ SparseMatrix.prototype.storage = function() {
        return "sparse";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @memberof SparseMatrix
   * @return {string}           The datatype.
   */ SparseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new SparseMatrix
   * @memberof SparseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ SparseMatrix.prototype.create = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Get the matrix density.
   *
   * Usage:
   *     const density = matrix.density()                   // retrieve matrix density
   *
   * @memberof SparseMatrix
   * @return {number}           The matrix density.
   */ SparseMatrix.prototype.density = function() {
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // calculate density
        return rows !== 0 && columns !== 0 ? this._index.length / (rows * columns) : 0;
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof SparseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ SparseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
         // check arguments
        switch(arguments.length){
            case 1:
                return _getsubset(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _setsubset(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    function _getsubset(matrix, idx) {
        // check idx
        if (!(0, $7E0JQ.isIndex)(idx)) throw new TypeError("Invalid index");
        var isScalar = idx.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(idx.min());
         // validate dimensions
        var size = idx.size();
        if (size.length !== matrix._size.length) throw new (0, $i7dcb.DimensionError)(size.length, matrix._size.length);
         // vars
        var i, ii, k, kk; // validate if any of the ranges in the index is out of range
        var min = idx.min();
        var max = idx.max();
        for(i = 0, ii = matrix._size.length; i < ii; i++){
            (0, $YkZ7e.validateIndex)(min[i], matrix._size[i]);
            (0, $YkZ7e.validateIndex)(max[i], matrix._size[i]);
        } // matrix arrays
        var mvalues = matrix._values;
        var mindex = matrix._index;
        var mptr = matrix._ptr; // rows & columns dimensions for result matrix
        var rows = idx.dimension(0);
        var columns = idx.dimension(1); // workspace & permutation vector
        var w = [];
        var pv = []; // loop rows in resulting matrix
        rows.forEach(function(i, r) {
            // update permutation vector
            pv[i] = r[0]; // mark i in workspace
            w[i] = true;
        }); // result matrix arrays
        var values = mvalues ? [] : undefined;
        var index = [];
        var ptr = []; // loop columns in result matrix
        columns.forEach(function(j) {
            // update ptr
            ptr.push(index.length); // loop values in column j
            for(k = mptr[j], kk = mptr[j + 1]; k < kk; k++){
                // row
                i = mindex[k]; // check row is in result matrix
                if (w[i] === true) {
                    // push index
                    index.push(pv[i]); // check we need to process values
                    if (values) values.push(mvalues[k]);
                }
            }
        }); // update ptr
        ptr.push(index.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: size,
            datatype: matrix._datatype
        });
    }
    function _setsubset(matrix, index, submatrix, defaultValue) {
        // check index
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $7E0JQ.isMatrix)(submatrix)) {
            // submatrix size
            sSize = submatrix.size(); // use array representation
            submatrix = submatrix.toArray();
        } else // get submatrix size (array, scalar)
        sSize = (0, $YkZ7e.arraySize)(submatrix);
         // check index is a scalar
        if (isScalar) {
            // verify submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
             // set value
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // validate dimensions, index size must be one or two dimensions
            if (iSize.length !== 1 && iSize.length !== 2) throw new (0, $i7dcb.DimensionError)(iSize.length, matrix._size.length, "<");
             // check submatrix and index have the same dimensions
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $YkZ7e.unsqueeze)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $glBd7.deepStrictEqual)(iSize, sSize)) throw new (0, $i7dcb.DimensionError)(iSize, sSize, ">");
             // offsets
            var x0 = index.min()[0];
            var y0 = index.min()[1]; // submatrix rows and columns
            var m = sSize[0];
            var n = sSize[1]; // loop submatrix
            for(var x = 0; x < m; x++)// loop columns
            for(var y = 0; y < n; y++){
                // value at i, j
                var v = submatrix[x][y]; // invoke set (zero value will remove entry from matrix)
                matrix.set([
                    x + x0,
                    y + y0
                ], v, defaultValue);
            }
        }
        return matrix;
    }
    /**
   * Get a single element from the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ SparseMatrix.prototype.get = function(index) {
        if (!(0, $7E0JQ.isArray)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $i7dcb.DimensionError)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
         // row and column
        var i = index[0];
        var j = index[1]; // check i, j are valid
        (0, $YkZ7e.validateIndex)(i, this._size[0]);
        (0, $YkZ7e.validateIndex)(j, this._size[1]); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) return this._values[k];
        return 0;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} v
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be set to zero.
   * @return {SparseMatrix} self
   */ SparseMatrix.prototype.set = function(index, v, defaultValue) {
        if (!(0, $7E0JQ.isArray)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $i7dcb.DimensionError)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
         // row and column
        var i = index[0];
        var j = index[1]; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $7E0JQ.isString)(this._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                this._datatype,
                this._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, this._datatype);
        } // check we need to resize matrix
        if (i > rows - 1 || j > columns - 1) {
            // resize matrix
            _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue); // update rows & columns
            rows = this._size[0];
            columns = this._size[1];
        } // check i, j are valid
        (0, $YkZ7e.validateIndex)(i, rows);
        (0, $YkZ7e.validateIndex)(j, columns); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) {
            // check value != 0
            if (!eq(v, zero)) // update value
            this._values[k] = v;
            else // remove value from matrix
            _remove(k, j, this._values, this._index, this._ptr);
        } else // insert value @ (i, j)
        _insert(k, i, j, v, this._values, this._index, this._ptr);
        return this;
    };
    function _getValueIndex(i, top, bottom, index) {
        // check row is on the bottom side
        if (bottom - top === 0) return bottom;
         // loop rows [top, bottom[
        for(var r = top; r < bottom; r++){
            // check we found value index
            if (index[r] === i) return r;
        } // we did not find row
        return top;
    }
    function _remove(k, j, values, index, ptr) {
        // remove value @ k
        values.splice(k, 1);
        index.splice(k, 1); // update pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]--;
    }
    function _insert(k, i, j, v, values, index, ptr) {
        // insert value
        values.splice(k, 0, v); // update row for k
        index.splice(k, 0, i); // update column pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]++;
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof SparseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ SparseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $7E0JQ.isArray)(size)) throw new TypeError("Array expected");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // check sizes
        size.forEach(function(value) {
            if (!(0, $7E0JQ.isNumber)(value) || !(0, $5wlxr.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $7HWRb.format)(size) + ")");
        }); // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, size[0], size[1], defaultValue);
    };
    function _resize(matrix, rows, columns, defaultValue) {
        // value to insert at the time of growing matrix
        var value = defaultValue || 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $7E0JQ.isString)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype); // convert value to the same datatype
            value = typed.convert(value, matrix._datatype);
        } // should we insert the value?
        var ins = !eq(value, zero); // old columns and rows
        var r = matrix._size[0];
        var c = matrix._size[1];
        var i, j, k; // check we need to increase columns
        if (columns > c) {
            // loop new columns
            for(j = c; j < columns; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._values.length; // check we need to insert matrix._values
                if (ins) // loop rows
                for(i = 0; i < r; i++){
                    // add new matrix._values
                    matrix._values.push(value); // update matrix._index
                    matrix._index.push(i);
                }
            } // store number of matrix._values in matrix._ptr
            matrix._ptr[columns] = matrix._values.length;
        } else if (columns < c) {
            // truncate matrix._ptr
            matrix._ptr.splice(columns + 1, c - columns); // truncate matrix._values and matrix._index
            matrix._values.splice(matrix._ptr[columns], matrix._values.length);
            matrix._index.splice(matrix._ptr[columns], matrix._index.length);
        } // update columns
        c = columns; // check we need to increase rows
        if (rows > r) // check we have to insert values
        {
            if (ins) {
                // inserts
                var n = 0; // loop columns
                for(j = 0; j < c; j++){
                    // update matrix._ptr for current column
                    matrix._ptr[j] = matrix._ptr[j] + n; // where to insert matrix._values
                    k = matrix._ptr[j + 1] + n; // pointer
                    var p = 0; // loop new rows, initialize pointer
                    for(i = r; i < rows; i++, p++){
                        // add value
                        matrix._values.splice(k + p, 0, value); // update matrix._index
                        matrix._index.splice(k + p, 0, i); // increment inserts
                        n++;
                    }
                } // store number of matrix._values in matrix._ptr
                matrix._ptr[c] = matrix._values.length;
            }
        } else if (rows < r) {
            // deletes
            var d = 0; // loop columns
            for(j = 0; j < c; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._ptr[j] - d; // where matrix._values start for next column
                var k0 = matrix._ptr[j];
                var k1 = matrix._ptr[j + 1] - d; // loop matrix._index
                for(k = k0; k < k1; k++){
                    // row
                    i = matrix._index[k]; // check we need to delete value and matrix._index
                    if (i > rows - 1) {
                        // remove value
                        matrix._values.splice(k, 1); // remove item from matrix._index
                        matrix._index.splice(k, 1); // increase deletes
                        d++;
                    }
                }
            } // update matrix._ptr for current column
            matrix._ptr[j] = matrix._values.length;
        } // update matrix._size
        matrix._size[0] = rows;
        matrix._size[1] = columns; // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof SparseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ SparseMatrix.prototype.reshape = function(size, copy) {
        // validate arguments
        if (!(0, $7E0JQ.isArray)(size)) throw new TypeError("Array expected");
        if (size.length !== 2) throw new Error("Sparse matrices can only be reshaped in two dimensions");
         // check sizes
        size.forEach(function(value) {
            if (!(0, $7E0JQ.isNumber)(value) || !(0, $5wlxr.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $7HWRb.format)(size) + ")");
        }); // m * n must not change
        if (this._size[0] * this._size[1] !== size[0] * size[1]) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
         // matrix to reshape
        var m = copy ? this.clone() : this; // return unchanged if the same shape
        if (this._size[0] === size[0] && this._size[1] === size[1]) return m;
         // Convert to COO format (generate a column index)
        var colIndex = [];
        for(var i = 0; i < m._ptr.length; i++)for(var j = 0; j < m._ptr[i + 1] - m._ptr[i]; j++)colIndex.push(i);
         // Clone the values array
        var values = m._values.slice(); // Clone the row index array
        var rowIndex = m._index.slice(); // Transform the (row, column) indices
        for(var _i = 0; _i < m._index.length; _i++){
            var r1 = rowIndex[_i];
            var c1 = colIndex[_i];
            var flat = r1 * m._size[1] + c1;
            colIndex[_i] = flat % size[1];
            rowIndex[_i] = Math.floor(flat / size[1]);
        } // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
        // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
        // sorting several arrays based on some other array.
        // OR, we could easily just:
        // 1. Remove all values from the matrix
        m._values.length = 0;
        m._index.length = 0;
        m._ptr.length = size[1] + 1;
        m._size = size.slice();
        for(var _i2 = 0; _i2 < m._ptr.length; _i2++)m._ptr[_i2] = 0;
         // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
        // This step is probably the most time-consuming
        for(var h = 0; h < values.length; h++){
            var _i3 = rowIndex[h];
            var _j = colIndex[h];
            var v = values[h];
            var k = _getValueIndex(_i3, m._ptr[_j], m._ptr[_j + 1], m._index);
            _insert(k, _i3, _j, v, m._values, m._index, m._ptr);
        } // The value indices are inserted out of order, but apparently that's... still OK?
        return m;
    };
    /**
   * Create a clone of the matrix
   * @memberof SparseMatrix
   * @return {SparseMatrix} clone
   */ SparseMatrix.prototype.clone = function() {
        var m = new SparseMatrix({
            values: this._values ? (0, $glBd7.clone)(this._values) : undefined,
            index: (0, $glBd7.clone)(this._index),
            ptr: (0, $glBd7.clone)(this._ptr),
            size: (0, $glBd7.clone)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof SparseMatrix
   * @returns {number[]} size
   */ SparseMatrix.prototype.size = function() {
        return this._size.slice(0); // copy the Array
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {SparseMatrix} matrix
   */ SparseMatrix.prototype.map = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // invoke callback
        var invoke = function invoke(v, i, j) {
            // invoke callback
            return callback(v, [
                i,
                j
            ], me);
        }; // invoke _map
        return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
    };
    /**
   * Create a new matrix with the results of the callback function executed on the interval
   * [minRow..maxRow, minColumn..maxColumn].
   */ function _map(matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
        // result arrays
        var values = [];
        var index = [];
        var ptr = []; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $7E0JQ.isString)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
        } // invoke callback
        var invoke = function invoke(v, x, y) {
            // invoke callback
            v = callback(v, x, y); // check value != 0
            if (!eq(v, zero)) {
                // store value
                values.push(v); // index
                index.push(x);
            }
        }; // loop columns
        for(var j = minColumn; j <= maxColumn; j++){
            // store pointer to values index
            ptr.push(values.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = matrix._ptr[j];
            var k1 = matrix._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = matrix._index[k]; // check i is in range
                if (i >= minRow && i <= maxRow) // value @ k
                invoke(matrix._values[k], i - minRow, j - minColumn);
            }
            else {
                // create a cache holding all defined values
                var _values = {};
                for(var _k = k0; _k < k1; _k++){
                    var _i4 = matrix._index[_k];
                    _values[_i4] = matrix._values[_k];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i5 = minRow; _i5 <= maxRow; _i5++){
                    var value = _i5 in _values ? _values[_i5] : 0;
                    invoke(value, _i5 - minRow, j - minColumn);
                }
            }
        } // store number of values in ptr
        ptr.push(values.length); // return sparse matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                maxRow - minRow + 1,
                maxColumn - minColumn + 1
            ]
        });
    }
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   */ SparseMatrix.prototype.forEach = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // value @ k
                callback(this._values[k], [
                    i,
                    j
                ], me);
            }
            else {
                // create a cache holding all defined values
                var values = {};
                for(var _k2 = k0; _k2 < k1; _k2++){
                    var _i6 = this._index[_k2];
                    values[_i6] = this._values[_k2];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i7 = 0; _i7 < rows; _i7++){
                    var value = _i7 in values ? values[_i7] : 0;
                    callback(value, [
                        _i7,
                        j
                    ], me);
                }
            }
        }
    };
    /**
   * Create an Array with a copy of the data of the SparseMatrix
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.toArray = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, true);
    };
    /**
   * Get the primitive value of the SparseMatrix: a two dimensions array
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.valueOf = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, false);
    };
    function _toArray(values, index, ptr, size, copy) {
        // rows and columns
        var rows = size[0];
        var columns = size[1]; // result
        var a = []; // vars
        var i, j; // initialize array
        for(i = 0; i < rows; i++){
            a[i] = [];
            for(j = 0; j < columns; j++)a[i][j] = 0;
        } // loop columns
        for(j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                i = index[k]; // set value (use one for pattern matrix)
                a[i][j] = values ? copy ? (0, $glBd7.clone)(values[k]) : values[k] : 1;
            }
        }
        return a;
    }
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof SparseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ SparseMatrix.prototype.format = function(options) {
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // density
        var density = this.density(); // rows & columns
        var str = "Sparse Matrix [" + (0, $7HWRb.format)(rows, options) + " x " + (0, $7HWRb.format)(columns, options) + "] density: " + (0, $7HWRb.format)(density, options) + "\n"; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // append value
                str += "\n    (" + (0, $7HWRb.format)(i, options) + ", " + (0, $7HWRb.format)(j, options) + ") ==> " + (this._values ? (0, $7HWRb.format)(this._values[k], options) : "X");
            }
        }
        return str;
    };
    /**
   * Get a string representation of the matrix
   * @memberof SparseMatrix
   * @returns {string} str
   */ SparseMatrix.prototype.toString = function() {
        return (0, $7HWRb.format)(this.toArray());
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof SparseMatrix
   * @returns {Object}
   */ SparseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "SparseMatrix",
            values: this._values,
            index: this._index,
            ptr: this._ptr,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof SparseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix vector with the diagonal values.
   */ SparseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $7E0JQ.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $7E0JQ.isNumber)(k) || !(0, $5wlxr.isInteger)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // diagonal arrays
        var values = [];
        var index = [];
        var ptr = []; // initial ptr value
        ptr[0] = 0; // loop columns
        for(var j = kSuper; j < columns && values.length < n; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop x within [k0, k1[
            for(var x = k0; x < k1; x++){
                // row index
                var i = this._index[x]; // check row
                if (i === j - kSuper + kSub) {
                    // value on this column
                    values.push(this._values[x]); // store row
                    index[values.length - 1] = i - kSub; // exit loop
                    break;
                }
            }
        } // close ptr
        ptr.push(values.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                n,
                1
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof SparseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
   *                       where mathjs is optional
   * @returns {SparseMatrix}
   */ SparseMatrix.fromJSON = function(json) {
        return new SparseMatrix(json);
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof SparseMatrix
   * @param {Array} size                       The matrix size.
   * @param {number | Array | Matrix } value   The values for the diagonal.
   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]            The default value for non-diagonal
   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
   *
   * @returns {SparseMatrix}
   */ SparseMatrix.diagonal = function(size, value, k, defaultValue, datatype) {
        if (!(0, $7E0JQ.isArray)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $7E0JQ.isBigNumber)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $7E0JQ.isNumber)(s) || !(0, $5wlxr.isInteger)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $7E0JQ.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $7E0JQ.isNumber)(k) || !(0, $5wlxr.isInteger)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
         // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $7E0JQ.isString)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $7E0JQ.isArray)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $7E0JQ.isMatrix)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // create arrays
        var values = [];
        var index = [];
        var ptr = []; // loop items
        for(var j = 0; j < columns; j++){
            // number of rows with value
            ptr.push(values.length); // diagonal index
            var i = j - kSuper; // check we need to set diagonal value
            if (i >= 0 && i < n) {
                // get value @ i
                var v = _value(i); // check for zero
                if (!eq(v, zero)) {
                    // column
                    index.push(i + kSub); // add value
                    values.push(v);
                }
            }
        } // last value should be number of values
        ptr.push(values.length); // create SparseMatrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof SparseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ SparseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $7E0JQ.isNumber)(i) || !(0, $5wlxr.isInteger)(i) || !(0, $7E0JQ.isNumber)(j) || !(0, $5wlxr.isInteger)(j)) throw new Error("Row index must be positive integers");
         // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
         // validate index
        (0, $YkZ7e.validateIndex)(i, this._size[0]);
        (0, $YkZ7e.validateIndex)(j, this._size[0]); // swap rows
        SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr); // return current instance
        return this;
    };
    /**
   * Loop rows with data in column j.
   *
   * @param {number} j            Column
   * @param {Array} values        Matrix values
   * @param {Array} index         Matrix row indeces
   * @param {Array} ptr           Matrix column pointers
   * @param {Function} callback   Callback function invoked for every row in column j
   */ SparseMatrix._forEachRow = function(j, values, index, ptr, callback) {
        // indeces for column j
        var k0 = ptr[j];
        var k1 = ptr[j + 1]; // loop
        for(var k = k0; k < k1; k++)// invoke callback
        callback(index[k], values[k]);
    };
    /**
   * Swap rows x and y in Sparse Matrix data structures.
   *
   * @param {number} x         Matrix row index 1
   * @param {number} y         Matrix row index 2
   * @param {number} columns   Number of columns in matrix
   * @param {Array} values     Matrix values
   * @param {Array} index      Matrix row indeces
   * @param {Array} ptr        Matrix column pointers
   */ SparseMatrix._swapRows = function(x, y, columns, values, index, ptr) {
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // find value index @ x
            var kx = _getValueIndex(x, k0, k1, index); // find value index @ x
            var ky = _getValueIndex(y, k0, k1, index); // check both rows exist in matrix
            if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
                // swap values (check for pattern matrix)
                if (values) {
                    var v = values[kx];
                    values[kx] = values[ky];
                    values[ky] = v;
                } // next column
                continue;
            } // check x row exist & no y row
            if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
                // value @ x (check for pattern matrix)
                var vx = values ? values[kx] : undefined; // insert value @ y
                index.splice(ky, 0, y);
                if (values) values.splice(ky, 0, vx);
                 // remove value @ x (adjust array index if needed)
                index.splice(ky <= kx ? kx + 1 : kx, 1);
                if (values) values.splice(ky <= kx ? kx + 1 : kx, 1);
                 // next column
                continue;
            } // check y row exist & no x row
            if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
                // value @ y (check for pattern matrix)
                var vy = values ? values[ky] : undefined; // insert value @ x
                index.splice(kx, 0, x);
                if (values) values.splice(kx, 0, vy);
                 // remove value @ y (adjust array index if needed)
                index.splice(kx <= ky ? ky + 1 : ky, 1);
                if (values) values.splice(kx <= ky ? ky + 1 : ky, 1);
            }
        }
    };
    return SparseMatrix;
}, {
    isClass: true
});

});

parcelRegister("1oXlo", function(module, exports) {

$parcel$export(module.exports, "createSplitUnit", function () { return $105610d40e2d69ff$export$a9f61753ee14ea96; });

var $jKx4O = parcelRequire("jKx4O");
var $105610d40e2d69ff$var$name = "splitUnit";
var $105610d40e2d69ff$var$dependencies = [
    "typed"
];
var $105610d40e2d69ff$export$a9f61753ee14ea96 = /* #__PURE__ */ (0, $jKx4O.factory)($105610d40e2d69ff$var$name, $105610d40e2d69ff$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Split a unit in an array of units whose sum is equal to the original unit.
   *
   * Syntax:
   *
   *     splitUnit(unit: Unit, parts: Array.<Unit>)
   *
   * Example:
   *
   *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch'])
   *     // [ 3 feet, 3.3700787401575 inch ]
   *
   * See also:
   *
   *     unit
   *
   * @param {Array} [parts] An array of strings or valueless units.
   * @return {Array} An array of units.
   */ return typed($105610d40e2d69ff$var$name, {
        "Unit, Array": function UnitArray(unit, parts) {
            return unit.splitUnit(parts);
        }
    });
});

});

parcelRegister("6HeS0", function(module, exports) {

$parcel$export(module.exports, "createSqrt", function () { return $4e024b23207ee5eb$export$eb18ce1988c5f19c; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $4e024b23207ee5eb$var$name = "sqrt";
var $4e024b23207ee5eb$var$dependencies = [
    "config",
    "typed",
    "Complex"
];
var $4e024b23207ee5eb$export$eb18ce1988c5f19c = /* #__PURE__ */ (0, $jKx4O.factory)($4e024b23207ee5eb$var$name, $4e024b23207ee5eb$var$dependencies, function(_ref) {
    var config = _ref.config, typed = _ref.typed, Complex = _ref.Complex;
    /**
   * Calculate the square root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sqrt(x)
   *
   * Examples:
   *
   *    math.sqrt(25)                // returns 5
   *    math.square(5)               // returns 25
   *    math.sqrt(-4)                // returns Complex 2i
   *
   * See also:
   *
   *    square, multiply, cube, cbrt, sqrtm
   *
   * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
   *            Value for which to calculate the square root.
   * @return {number | BigNumber | Complex | Array | Matrix | Unit}
   *            Returns the square root of `x`
   */ var sqrt = typed("sqrt", {
        number: _sqrtNumber,
        Complex: function Complex(x) {
            return x.sqrt();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.sqrt();
            else // negative value -> downgrade to number to do complex value computation
            return _sqrtNumber(x.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sqrt(0) = 0
            return (0, $fbkGg.deepMap)(x, sqrt, true);
        },
        Unit: function Unit(x) {
            // Someday will work for complex units when they are implemented
            return x.pow(0.5);
        }
    });
    /**
   * Calculate sqrt for a number
   * @param {number} x
   * @returns {number | Complex} Returns the square root of x
   * @private
   */ function _sqrtNumber(x) {
        if (isNaN(x)) return NaN;
        else if (x >= 0 || config.predictable) return Math.sqrt(x);
        else return new Complex(x, 0).sqrt();
    }
    return sqrt;
});

});

parcelRegister("jVWoI", function(module, exports) {

$parcel$export(module.exports, "createSqrtm", function () { return $e830a3c14c581d2a$export$71d0f952576e7511; });

var $7E0JQ = parcelRequire("7E0JQ");

var $7HWRb = parcelRequire("7HWRb");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $e830a3c14c581d2a$var$name = "sqrtm";
var $e830a3c14c581d2a$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "sqrt",
    "subtract",
    "inv",
    "size",
    "max",
    "identity"
];
var $e830a3c14c581d2a$export$71d0f952576e7511 = /* #__PURE__ */ (0, $jKx4O.factory)($e830a3c14c581d2a$var$name, $e830a3c14c581d2a$var$dependencies, function(_ref) {
    var typed = _ref.typed, abs = _ref.abs, add = _ref.add, multiply = _ref.multiply, sqrt = _ref.sqrt, subtract = _ref.subtract, inv = _ref.inv, size = _ref.size, max = _ref.max, identity = _ref.identity;
    /**
   * Calculate the principal square root of a square matrix.
   * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
   *
   * Syntax:
   *
   *     X = math.sqrtm(A)
   *
   * Examples:
   *
   *     math.sqrtm([[1, 2], [3, 4]]) // returns [[-2, 1], [1.5, -0.5]]
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   */ var sqrtm = typed($e830a3c14c581d2a$var$name, {
        "Array | Matrix": function ArrayMatrix(A) {
            var size = (0, $7E0JQ.isMatrix)(A) ? A.size() : (0, $YkZ7e.arraySize)(A);
            switch(size.length){
                case 1:
                    // Single element Array | Matrix
                    if (size[0] === 1) return sqrt(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
                case 2:
                    // Two-dimensional Array | Matrix
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _denmanBeavers(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
            }
        }
    });
    var _maxIterations = 1e3;
    var _tolerance = 1e-6;
    /**
   * Calculate the principal square root matrix using the Denman–Beavers iterative method
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   * @private
   */ function _denmanBeavers(A) {
        var error;
        var iterations = 0;
        var Y = A;
        var Z = identity(size(A));
        do {
            var Yk = Y;
            Y = multiply(0.5, add(Yk, inv(Z)));
            Z = multiply(0.5, add(Z, inv(Yk)));
            error = max(abs(subtract(Y, Yk)));
            if (error > _tolerance && ++iterations > _maxIterations) throw new Error("computing square root of matrix: iterative method could not converge");
        }while (error > _tolerance);
        return Y;
    }
    return sqrtm;
});

});

parcelRegister("gULx9", function(module, exports) {

$parcel$export(module.exports, "createSquare", function () { return $c506bf7c3105c8cb$export$4ba960a63f731b0b; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $c506bf7c3105c8cb$var$name = "square";
var $c506bf7c3105c8cb$var$dependencies = [
    "typed"
];
var $c506bf7c3105c8cb$export$4ba960a63f731b0b = /* #__PURE__ */ (0, $jKx4O.factory)($c506bf7c3105c8cb$var$name, $c506bf7c3105c8cb$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Compute the square of a value, `x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.square(x)
   *
   * Examples:
   *
   *    math.square(2)           // returns number 4
   *    math.square(3)           // returns number 9
   *    math.pow(3, 2)           // returns number 9
   *    math.multiply(3, 3)      // returns number 9
   *
   *    math.square([1, 2, 3, 4])  // returns Array [1, 4, 9, 16]
   *
   * See also:
   *
   *    multiply, cube, sqrt, pow
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            Number for which to calculate the square
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Squared value
   */ var square = typed($c506bf7c3105c8cb$var$name, {
        number: (0, $cqeCl.squareNumber),
        Complex: function Complex(x) {
            return x.mul(x);
        },
        BigNumber: function BigNumber(x) {
            return x.times(x);
        },
        Fraction: function Fraction(x) {
            return x.mul(x);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since square(0) = 0
            return (0, $fbkGg.deepMap)(x, square, true);
        },
        Unit: function Unit(x) {
            return x.pow(2);
        }
    });
    return square;
});

});

parcelRegister("jsrry", function(module, exports) {

$parcel$export(module.exports, "createSqueeze", function () { return $e2a5eb8c6cd8d3b3$export$1a885844ffd505a4; });

var $glBd7 = parcelRequire("glBd7");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $e2a5eb8c6cd8d3b3$var$name = "squeeze";
var $e2a5eb8c6cd8d3b3$var$dependencies = [
    "typed",
    "matrix"
];
var $e2a5eb8c6cd8d3b3$export$1a885844ffd505a4 = /* #__PURE__ */ (0, $jKx4O.factory)($e2a5eb8c6cd8d3b3$var$name, $e2a5eb8c6cd8d3b3$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    /**
   * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
   *
   * Syntax:
   *
   *     math.squeeze(x)
   *
   * Examples:
   *
   *     math.squeeze([3])           // returns 3
   *     math.squeeze([[3]])         // returns 3
   *
   *     const A = math.zeros(3, 1)    // returns [[0], [0], [0]] (size 3x1)
   *     math.squeeze(A)             // returns [0, 0, 0] (size 3)
   *
   *     const B = math.zeros(1, 3)    // returns [[0, 0, 0]] (size 1x3)
   *     math.squeeze(B)             // returns [0, 0, 0] (size 3)
   *
   *     // only inner and outer dimensions are removed
   *     const C = math.zeros(2, 1, 3) // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *     math.squeeze(C)             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *
   * See also:
   *
   *     subset
   *
   * @param {Matrix | Array} x      Matrix to be squeezed
   * @return {Matrix | Array} Squeezed matrix
   */ return typed($e2a5eb8c6cd8d3b3$var$name, {
        Array: function Array1(x) {
            return (0, $YkZ7e.squeeze)((0, $glBd7.clone)(x));
        },
        Matrix: function Matrix(x) {
            var res = (0, $YkZ7e.squeeze)(x.toArray()); // FIXME: return the same type of matrix as the input
            return Array.isArray(res) ? matrix(res) : res;
        },
        any: function any(x) {
            // scalar
            return (0, $glBd7.clone)(x);
        }
    });
});

});

parcelRegister("lzAiB", function(module, exports) {

$parcel$export(module.exports, "createStirlingS2", function () { return $fb4906144f95b599$export$18813d136a9b83d0; });

var $jKx4O = parcelRequire("jKx4O");
var $fb4906144f95b599$var$name = "stirlingS2";
var $fb4906144f95b599$var$dependencies = [
    "typed",
    "addScalar",
    "subtract",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "factorial",
    "combinations",
    "isNegative",
    "isInteger",
    "larger"
];
var $fb4906144f95b599$export$18813d136a9b83d0 = /* #__PURE__ */ (0, $jKx4O.factory)($fb4906144f95b599$var$name, $fb4906144f95b599$var$dependencies, function(_ref) {
    var typed = _ref.typed, addScalar = _ref.addScalar, subtract = _ref.subtract, multiplyScalar = _ref.multiplyScalar, divideScalar = _ref.divideScalar, pow = _ref.pow, factorial = _ref.factorial, combinations = _ref.combinations, isNegative = _ref.isNegative, isInteger = _ref.isInteger, larger = _ref.larger;
    /**
   * The Stirling numbers of the second kind, counts the number of ways to partition
   * a set of n labelled objects into k nonempty unlabelled subsets.
   * stirlingS2 only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   *  If n = k or k = 1, then s(n,k) = 1
   *
   * Syntax:
   *
   *   math.stirlingS2(n, k)
   *
   * Examples:
   *
   *    math.stirlingS2(5, 3) //returns 25
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     S(n,k)
   */ return typed($fb4906144f95b599$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function stirlingS2");
             // 1/k! Sum(i=0 -> k) [(-1)^(k-i)*C(k,j)* i^n]
            var kFactorial = factorial(k);
            var result = 0;
            for(var i = 0; i <= k; i++){
                var negativeOne = pow(-1, subtract(k, i));
                var kChooseI = combinations(k, i);
                var iPower = pow(i, n);
                result = addScalar(result, multiplyScalar(multiplyScalar(kChooseI, iPower), negativeOne));
            }
            return divideScalar(result, kFactorial);
        }
    });
});

});

parcelRegister("79Eji", function(module, exports) {

$parcel$export(module.exports, "createString", function () { return $5358a47370652bcc$export$b2cf5914f5f18823; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");
var $5358a47370652bcc$var$name = "string";
var $5358a47370652bcc$var$dependencies = [
    "typed"
];
var $5358a47370652bcc$export$b2cf5914f5f18823 = /* #__PURE__ */ (0, $jKx4O.factory)($5358a47370652bcc$var$name, $5358a47370652bcc$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Create a string or convert any object into a string.
   * Elements of Arrays and Matrices are processed element wise.
   *
   * Syntax:
   *
   *    math.string(value)
   *
   * Examples:
   *
   *    math.string(4.2)               // returns string '4.2'
   *    math.string(math.complex(3, 2) // returns string '3 + 2i'
   *
   *    const u = math.unit(5, 'km')
   *    math.string(u.to('m'))         // returns string '5000 m'
   *
   *    math.string([true, false])     // returns ['true', 'false']
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, unit
   *
   * @param {* | Array | Matrix | null} [value]  A value to convert to a string
   * @return {string | Array | Matrix} The created string
   */ var string = typed($5358a47370652bcc$var$name, {
        "": function _() {
            return "";
        },
        number: (0, $5wlxr.format),
        "null": function _null(x) {
            return "null";
        },
        "boolean": function boolean(x) {
            return x + "";
        },
        string: function string(x) {
            return x;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, string);
        },
        any: function any(x) {
            return String(x);
        }
    });
    return string;
});

});

parcelRegister("5If9u", function(module, exports) {

$parcel$export(module.exports, "createSubtract", function () { return $428cd0b825415143$export$cd7a6c131b18ab16; });

var $jKx4O = parcelRequire("jKx4O");

var $i7dcb = parcelRequire("i7dcb");

var $9vlUQ = parcelRequire("9vlUQ");

var $e6fFw = parcelRequire("e6fFw");

var $5Sg22 = parcelRequire("5Sg22");

var $fs8LR = parcelRequire("fs8LR");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");
var $428cd0b825415143$var$name = "subtract";
var $428cd0b825415143$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "addScalar",
    "unaryMinus",
    "DenseMatrix"
];
var $428cd0b825415143$export$cd7a6c131b18ab16 = /* #__PURE__ */ (0, $jKx4O.factory)($428cd0b825415143$var$name, $428cd0b825415143$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, equalScalar = _ref.equalScalar, addScalar = _ref.addScalar, unaryMinus = _ref.unaryMinus, DenseMatrix = _ref.DenseMatrix;
    // TODO: split function subtract in two: subtract and subtractScalar
    var algorithm01 = (0, $9vlUQ.createAlgorithm01)({
        typed: typed
    });
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $5Sg22.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $fs8LR.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Subtract two values, `x - y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.subtract(x, y)
   *
   * Examples:
   *
   *    math.subtract(5.3, 2)        // returns number 3.3
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.subtract(a, b)          // returns Complex -2 + 2i
   *
   *    math.subtract([5, 7, 4], 4)  // returns Array [1, 3, 0]
   *
   *    const c = math.unit('2.1 km')
   *    const d = math.unit('500m')
   *    math.subtract(c, d)          // returns Unit 1.6 km
   *
   * See also:
   *
   *    add
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x
   *            Initial value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y
   *            Value to subtract from `x`
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Subtraction of `x` and `y`
   */ var subtract = typed($428cd0b825415143$var$name, {
        "number, number": function numberNumber(x, y) {
            return x - y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.sub(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.minus(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.sub(y);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (x.value === null) throw new Error("Parameter x contains a unit with undefined value");
            if (y.value === null) throw new Error("Parameter y contains a unit with undefined value");
            if (!x.equalBase(y)) throw new Error("Units do not match");
            var res = x.clone();
            res.value = subtract(res.value, y.value);
            res.fixPrefix = false;
            return res;
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            $428cd0b825415143$var$checkEqualDimensions(x, y);
            return algorithm05(x, y, subtract);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            $428cd0b825415143$var$checkEqualDimensions(x, y);
            return algorithm03(y, x, subtract, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            $428cd0b825415143$var$checkEqualDimensions(x, y);
            return algorithm01(x, y, subtract, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            $428cd0b825415143$var$checkEqualDimensions(x, y);
            return algorithm13(x, y, subtract);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return subtract(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return subtract(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return subtract(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, unaryMinus(y), addScalar);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, subtract);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, subtract, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, subtract, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, subtract, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, subtract, true).valueOf();
        }
    });
    return subtract;
});
/**
 * Check whether matrix x and y have the same number of dimensions.
 * Throws a DimensionError when dimensions are not equal
 * @param {Matrix} x
 * @param {Matrix} y
 */ function $428cd0b825415143$var$checkEqualDimensions(x, y) {
    var xsize = x.size();
    var ysize = y.size();
    if (xsize.length !== ysize.length) throw new (0, $i7dcb.DimensionError)(xsize.length, ysize.length);
}

});

parcelRegister("gDJiz", function(module, exports) {

$parcel$export(module.exports, "createTan", function () { return $c1d36d374af33c86$export$b61ad4f38fd9301d; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $c1d36d374af33c86$var$name = "tan";
var $c1d36d374af33c86$var$dependencies = [
    "typed"
];
var $c1d36d374af33c86$export$b61ad4f38fd9301d = /* #__PURE__ */ (0, $jKx4O.factory)($c1d36d374af33c86$var$name, $c1d36d374af33c86$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tan(x)
   *
   * Examples:
   *
   *    math.tan(0.5)                    // returns number 0.5463024898437905
   *    math.sin(0.5) / math.cos(0.5)    // returns number 0.5463024898437905
   *    math.tan(math.pi / 4)            // returns number 1
   *    math.tan(math.unit(45, 'deg'))   // returns number 1
   *
   * See also:
   *
   *    atan, sin, cos
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Tangent of x
   */ var tan = typed($c1d36d374af33c86$var$name, {
        number: Math.tan,
        Complex: function Complex(x) {
            return x.tan();
        },
        BigNumber: function BigNumber(x) {
            return x.tan();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tan is no angle");
            return tan(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since tan(0) = 0
            return (0, $fbkGg.deepMap)(x, tan, true);
        }
    });
    return tan;
});

});

parcelRegister("6wGNM", function(module, exports) {

$parcel$export(module.exports, "createTanh", function () { return $4c06eed1d745ce03$export$e1f66a5bda779194; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $5wlxr = parcelRequire("5wlxr");
var $4c06eed1d745ce03$var$name = "tanh";
var $4c06eed1d745ce03$var$dependencies = [
    "typed"
];
var $4c06eed1d745ce03$export$e1f66a5bda779194 = /* #__PURE__ */ (0, $jKx4O.factory)($4c06eed1d745ce03$var$name, $4c06eed1d745ce03$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Calculate the hyperbolic tangent of a value,
   * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tanh(x)
   *
   * Examples:
   *
   *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
   *    math.tanh(0.5)                   // returns 0.46211715726000974
   *    math.sinh(0.5) / math.cosh(0.5)  // returns 0.46211715726000974
   *    1 / math.coth(0.5)               // returns 0.46211715726000974
   *
   * See also:
   *
   *    sinh, cosh, coth
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic tangent of x
   */ var tanh = typed("tanh", {
        number: (0, $5wlxr.tanh),
        Complex: function Complex(x) {
            return x.tanh();
        },
        BigNumber: function BigNumber(x) {
            return x.tanh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tanh is no angle");
            return tanh(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since tanh(0) = 0
            return (0, $fbkGg.deepMap)(x, tanh, true);
        }
    });
    return tanh;
});

});

parcelRegister("ejRUS", function(module, exports) {

$parcel$export(module.exports, "createTo", function () { return $a6cca9af758c0173$export$6e6c19ceb4cd6856; });

var $jKx4O = parcelRequire("jKx4O");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");
var $a6cca9af758c0173$var$name = "to";
var $a6cca9af758c0173$var$dependencies = [
    "typed",
    "matrix"
];
var $a6cca9af758c0173$export$6e6c19ceb4cd6856 = /* #__PURE__ */ (0, $jKx4O.factory)($a6cca9af758c0173$var$name, $a6cca9af758c0173$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Change the unit of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.to(x, unit)
   *
   * Examples:
   *
   *    math.to(math.unit('2 inch'), 'cm')                   // returns Unit 5.08 cm
   *    math.to(math.unit('2 inch'), math.unit(null, 'cm'))  // returns Unit 5.08 cm
   *    math.to(math.unit(16, 'bytes'), 'bits')              // returns Unit 128 bits
   *
   * See also:
   *
   *    unit
   *
   * @param {Unit | Array | Matrix} x     The unit to be converted.
   * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
   *                                      or a unit without value.
   * @return {Unit | Array | Matrix} value with changed, fixed unit.
   */ var to = typed($a6cca9af758c0173$var$name, {
        "Unit, Unit | string": function UnitUnitString(x, unit) {
            return x.to(unit);
        },
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm13(x, y, to);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return to(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return to(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return to(x, matrix(y));
        },
        "Matrix, any": function MatrixAny(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(x, y, to, false);
        },
        "any, Matrix": function anyMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(y, x, to, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, to, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, to, true).valueOf();
        }
    });
    return to;
});

});

parcelRegister("fdjZz", function(module, exports) {

$parcel$export(module.exports, "createTrace", function () { return $b13793ee1a7b5de2$export$acff8254414be03b; });

var $glBd7 = parcelRequire("glBd7");

var $7HWRb = parcelRequire("7HWRb");

var $jKx4O = parcelRequire("jKx4O");
var $b13793ee1a7b5de2$var$name = "trace";
var $b13793ee1a7b5de2$var$dependencies = [
    "typed",
    "matrix",
    "add"
];
var $b13793ee1a7b5de2$export$acff8254414be03b = /* #__PURE__ */ (0, $jKx4O.factory)($b13793ee1a7b5de2$var$name, $b13793ee1a7b5de2$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, add = _ref.add;
    /**
   * Calculate the trace of a matrix: the sum of the elements on the main
   * diagonal of a square matrix.
   *
   * Syntax:
   *
   *    math.trace(x)
   *
   * Examples:
   *
   *    math.trace([[1, 2], [3, 4]]) // returns 5
   *
   *    const A = [
   *      [1, 2, 3],
   *      [-1, 2, 3],
   *      [2, 0, 3]
   *    ]
   *    math.trace(A) // returns 6
   *
   * See also:
   *
   *    diag
   *
   * @param {Array | Matrix} x  A matrix
   *
   * @return {number} The trace of `x`
   */ return typed("trace", {
        Array: function _arrayTrace(x) {
            // use dense matrix implementation
            return _denseTrace(matrix(x));
        },
        SparseMatrix: _sparseTrace,
        DenseMatrix: _denseTrace,
        any: (0, $glBd7.clone)
    });
    function _denseTrace(m) {
        // matrix size & data
        var size = m._size;
        var data = m._data; // process dimensions
        switch(size.length){
            case 1:
                // vector
                if (size[0] === 1) // return data[0]
                return (0, $glBd7.clone)(data[0]);
                throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
            case 2:
                // two dimensional
                var rows = size[0];
                var cols = size[1];
                if (rows === cols) {
                    // calulate sum
                    var sum = 0; // loop diagonal
                    for(var i = 0; i < rows; i++)sum = add(sum, data[i][i]);
                     // return trace
                    return sum;
                } else throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
            default:
                // multi dimensional
                throw new RangeError("Matrix must be two dimensional (size: " + (0, $7HWRb.format)(size) + ")");
        }
    }
    function _sparseTrace(m) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        var size = m._size; // check dimensions
        var rows = size[0];
        var columns = size[1]; // matrix must be square
        if (rows === columns) {
            // calulate sum
            var sum = 0; // check we have data (avoid looping columns)
            if (values.length > 0) // loop columns
            for(var j = 0; j < columns; j++){
                // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
                var k0 = ptr[j];
                var k1 = ptr[j + 1]; // loop k within [k0, k1[
                for(var k = k0; k < k1; k++){
                    // row index
                    var i = index[k]; // check row
                    if (i === j) {
                        // accumulate value
                        sum = add(sum, values[k]); // exit loop
                        break;
                    }
                    if (i > j) break;
                }
            }
             // return trace
            return sum;
        }
        throw new RangeError("Matrix must be square (size: " + (0, $7HWRb.format)(size) + ")");
    }
});

});

parcelRegister("9eZMW", function(module, exports) {

$parcel$export(module.exports, "createTranspose", function () { return $6ba559ba0cf31cfa$export$9a8c88485f8f638b; });

var $glBd7 = parcelRequire("glBd7");

var $7HWRb = parcelRequire("7HWRb");

var $jKx4O = parcelRequire("jKx4O");
var $6ba559ba0cf31cfa$var$name = "transpose";
var $6ba559ba0cf31cfa$var$dependencies = [
    "typed",
    "matrix"
];
var $6ba559ba0cf31cfa$export$9a8c88485f8f638b = /* #__PURE__ */ (0, $jKx4O.factory)($6ba559ba0cf31cfa$var$name, $6ba559ba0cf31cfa$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix;
    /**
   * Transpose a matrix. All values of the matrix are reflected over its
   * main diagonal. Only applicable to two dimensional matrices containing
   * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
   * vectors and scalars return the input unchanged.
   *
   * Syntax:
   *
   *     math.transpose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.transpose(A)               // returns [[1, 4], [2, 5], [3, 6]]
   *
   * See also:
   *
   *     diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be transposed
   * @return {Array | Matrix}   The transposed matrix
   */ var transpose = typed("transpose", {
        Array: function Array(x) {
            // use dense matrix implementation
            return transpose(matrix(x)).valueOf();
        },
        Matrix: function Matrix(x) {
            // matrix size
            var size = x.size(); // result
            var c; // process dimensions
            switch(size.length){
                case 1:
                    // vector
                    c = x.clone();
                    break;
                case 2:
                    // rows and columns
                    var rows = size[0];
                    var columns = size[1]; // check columns
                    if (columns === 0) // throw exception
                    throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + (0, $7HWRb.format)(size) + ")");
                     // process storage format
                    switch(x.storage()){
                        case "dense":
                            c = _denseTranspose(x, rows, columns);
                            break;
                        case "sparse":
                            c = _sparseTranspose(x, rows, columns);
                            break;
                    }
                    break;
                default:
                    // multi dimensional
                    throw new RangeError("Matrix must be a vector or two dimensional (size: " + (0, $7HWRb.format)(this._size) + ")");
            }
            return c;
        },
        // scalars
        any: function any(x) {
            return (0, $glBd7.clone)(x);
        }
    });
    function _denseTranspose(m, rows, columns) {
        // matrix array
        var data = m._data; // transposed matrix data
        var transposed = [];
        var transposedRow; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize row
            transposedRow = transposed[j] = []; // loop rows
            for(var i = 0; i < rows; i++)// set data
            transposedRow[i] = (0, $glBd7.clone)(data[i][j]);
        } // return matrix
        return m.createDenseMatrix({
            data: transposed,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    function _sparseTranspose(m, rows, columns) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result matrices
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // row counts
        var w = [];
        for(var x = 0; x < rows; x++)w[x] = 0;
         // vars
        var p, l, j; // loop values in matrix
        for(p = 0, l = index.length; p < l; p++)// number of values in row
        w[index[p]]++;
         // cumulative sum
        var sum = 0; // initialize cptr with the cummulative sum of row counts
        for(var i = 0; i < rows; i++){
            // update cptr
            cptr.push(sum); // update sum
            sum += w[i]; // update w
            w[i] = cptr[i];
        } // update cptr
        cptr.push(sum); // loop columns
        for(j = 0; j < columns; j++)// values & index in column
        for(var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++){
            // C values & index
            var q = w[index[k]]++; // C[j, i] = A[i, j]
            cindex[q] = j; // check we need to process values (pattern matrix)
            if (values) cvalues[q] = (0, $glBd7.clone)(values[k]);
        }
         // return matrix
        return m.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    return transpose;
});

});

parcelRegister("6ETLy", function(module, exports) {

$parcel$export(module.exports, "createTyped", function () { return $4d91bc7566c1f651$export$8597b5d47504f989; });
/**
 * Create a typed-function which checks the types of the arguments and
 * can match them against multiple provided signatures. The typed-function
 * automatically converts inputs in order to find a matching signature.
 * Typed functions throw informative errors in case of wrong input arguments.
 *
 * See the library [typed-function](https://github.com/josdejong/typed-function)
 * for detailed documentation.
 *
 * Syntax:
 *
 *     math.typed(name, signatures) : function
 *     math.typed(signatures) : function
 *
 * Examples:
 *
 *     // create a typed function with multiple types per argument (type union)
 *     const fn2 = typed({
 *       'number | boolean': function (b) {
 *         return 'b is a number or boolean'
 *       },
 *       'string, number | boolean': function (a, b) {
 *         return 'a is a string, b is a number or boolean'
 *       }
 *     })
 *
 *     // create a typed function with an any type argument
 *     const log = typed({
 *       'string, any': function (event, data) {
 *         console.log('event: ' + event + ', data: ' + JSON.stringify(data))
 *       }
 *     })
 *
 * @param {string} [name]                          Optional name for the typed-function
 * @param {Object<string, function>} signatures   Object with one or multiple function signatures
 * @returns {function} The created typed-function.
 */ 
var $7E0JQ = parcelRequire("7E0JQ");

var $5fKrM = parcelRequire("5fKrM");

var $5wlxr = parcelRequire("5wlxr");

var $jKx4O = parcelRequire("jKx4O");
var $4d91bc7566c1f651$var$_createTyped2 = function _createTyped() {
    // initially, return the original instance of typed-function
    // consecutively, return a new instance from typed.create.
    $4d91bc7566c1f651$var$_createTyped2 = (0, (/*@__PURE__*/$parcel$interopDefault($5fKrM))).create;
    return 0, (/*@__PURE__*/$parcel$interopDefault($5fKrM));
};
var $4d91bc7566c1f651$var$dependencies = [
    "?BigNumber",
    "?Complex",
    "?DenseMatrix",
    "?Fraction"
];
var $4d91bc7566c1f651$export$8597b5d47504f989 = /* #__PURE__ */ (0, $jKx4O.factory)("typed", $4d91bc7566c1f651$var$dependencies, function createTyped(_ref) {
    var BigNumber = _ref.BigNumber, Complex = _ref.Complex, DenseMatrix = _ref.DenseMatrix, Fraction = _ref.Fraction;
    // TODO: typed-function must be able to silently ignore signatures with unknown data types
    // get a new instance of typed-function
    var typed = $4d91bc7566c1f651$var$_createTyped2(); // define all types. The order of the types determines in which order function
    // arguments are type-checked (so for performance it's important to put the
    // most used types first).
    typed.types = [
        {
            name: "number",
            test: (0, $7E0JQ.isNumber)
        },
        {
            name: "Complex",
            test: (0, $7E0JQ.isComplex)
        },
        {
            name: "BigNumber",
            test: (0, $7E0JQ.isBigNumber)
        },
        {
            name: "Fraction",
            test: (0, $7E0JQ.isFraction)
        },
        {
            name: "Unit",
            test: (0, $7E0JQ.isUnit)
        },
        {
            name: "string",
            test: (0, $7E0JQ.isString)
        },
        {
            name: "Chain",
            test: (0, $7E0JQ.isChain)
        },
        {
            name: "Array",
            test: (0, $7E0JQ.isArray)
        },
        {
            name: "Matrix",
            test: (0, $7E0JQ.isMatrix)
        },
        {
            name: "DenseMatrix",
            test: (0, $7E0JQ.isDenseMatrix)
        },
        {
            name: "SparseMatrix",
            test: (0, $7E0JQ.isSparseMatrix)
        },
        {
            name: "Range",
            test: (0, $7E0JQ.isRange)
        },
        {
            name: "Index",
            test: (0, $7E0JQ.isIndex)
        },
        {
            name: "boolean",
            test: (0, $7E0JQ.isBoolean)
        },
        {
            name: "ResultSet",
            test: (0, $7E0JQ.isResultSet)
        },
        {
            name: "Help",
            test: (0, $7E0JQ.isHelp)
        },
        {
            name: "function",
            test: (0, $7E0JQ.isFunction)
        },
        {
            name: "Date",
            test: (0, $7E0JQ.isDate)
        },
        {
            name: "RegExp",
            test: (0, $7E0JQ.isRegExp)
        },
        {
            name: "null",
            test: (0, $7E0JQ.isNull)
        },
        {
            name: "undefined",
            test: (0, $7E0JQ.isUndefined)
        },
        {
            name: "AccessorNode",
            test: (0, $7E0JQ.isAccessorNode)
        },
        {
            name: "ArrayNode",
            test: (0, $7E0JQ.isArrayNode)
        },
        {
            name: "AssignmentNode",
            test: (0, $7E0JQ.isAssignmentNode)
        },
        {
            name: "BlockNode",
            test: (0, $7E0JQ.isBlockNode)
        },
        {
            name: "ConditionalNode",
            test: (0, $7E0JQ.isConditionalNode)
        },
        {
            name: "ConstantNode",
            test: (0, $7E0JQ.isConstantNode)
        },
        {
            name: "FunctionNode",
            test: (0, $7E0JQ.isFunctionNode)
        },
        {
            name: "FunctionAssignmentNode",
            test: (0, $7E0JQ.isFunctionAssignmentNode)
        },
        {
            name: "IndexNode",
            test: (0, $7E0JQ.isIndexNode)
        },
        {
            name: "Node",
            test: (0, $7E0JQ.isNode)
        },
        {
            name: "ObjectNode",
            test: (0, $7E0JQ.isObjectNode)
        },
        {
            name: "OperatorNode",
            test: (0, $7E0JQ.isOperatorNode)
        },
        {
            name: "ParenthesisNode",
            test: (0, $7E0JQ.isParenthesisNode)
        },
        {
            name: "RangeNode",
            test: (0, $7E0JQ.isRangeNode)
        },
        {
            name: "SymbolNode",
            test: (0, $7E0JQ.isSymbolNode)
        },
        {
            name: "Object",
            test: (0, $7E0JQ.isObject)
        } // order 'Object' last, it matches on other classes too
    ];
    typed.conversions = [
        {
            from: "number",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $4d91bc7566c1f651$var$throwNoBignumber(x);
                 // note: conversion from number to BigNumber can fail if x has >15 digits
                if ((0, $5wlxr.digits)(x) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + x + "). " + "Use function bignumber(x) to convert to BigNumber.");
                return new BigNumber(x);
            }
        },
        {
            from: "number",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $4d91bc7566c1f651$var$throwNoComplex(x);
                return new Complex(x, 0);
            }
        },
        {
            from: "number",
            to: "string",
            convert: function convert(x) {
                return x + "";
            }
        },
        {
            from: "BigNumber",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $4d91bc7566c1f651$var$throwNoComplex(x);
                return new Complex(x.toNumber(), 0);
            }
        },
        {
            from: "Fraction",
            to: "BigNumber",
            convert: function convert(x) {
                throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
            }
        },
        {
            from: "Fraction",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $4d91bc7566c1f651$var$throwNoComplex(x);
                return new Complex(x.valueOf(), 0);
            }
        },
        {
            from: "number",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $4d91bc7566c1f651$var$throwNoFraction(x);
                var f = new Fraction(x);
                if (f.valueOf() !== x) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + x + "). " + "Use function fraction(x) to convert to Fraction.");
                return f;
            }
        },
        {
            // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
            //  from: 'Fraction',
            //  to: 'number',
            //  convert: function (x) {
            //    return x.valueOf()
            //  }
            // }, {
            from: "string",
            to: "number",
            convert: function convert(x) {
                var n = Number(x);
                if (isNaN(n)) throw new Error('Cannot convert "' + x + '" to a number');
                return n;
            }
        },
        {
            from: "string",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $4d91bc7566c1f651$var$throwNoBignumber(x);
                try {
                    return new BigNumber(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigNumber');
                }
            }
        },
        {
            from: "string",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $4d91bc7566c1f651$var$throwNoFraction(x);
                try {
                    return new Fraction(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Fraction');
                }
            }
        },
        {
            from: "string",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $4d91bc7566c1f651$var$throwNoComplex(x);
                try {
                    return new Complex(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Complex');
                }
            }
        },
        {
            from: "boolean",
            to: "number",
            convert: function convert(x) {
                return +x;
            }
        },
        {
            from: "boolean",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $4d91bc7566c1f651$var$throwNoBignumber(x);
                return new BigNumber(+x);
            }
        },
        {
            from: "boolean",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $4d91bc7566c1f651$var$throwNoFraction(x);
                return new Fraction(+x);
            }
        },
        {
            from: "boolean",
            to: "string",
            convert: function convert(x) {
                return String(x);
            }
        },
        {
            from: "Array",
            to: "Matrix",
            convert: function convert(array) {
                if (!DenseMatrix) $4d91bc7566c1f651$var$throwNoMatrix();
                return new DenseMatrix(array);
            }
        },
        {
            from: "Matrix",
            to: "Array",
            convert: function convert(matrix) {
                return matrix.valueOf();
            }
        }
    ];
    return typed;
});
function $4d91bc7566c1f651$var$throwNoBignumber(x) {
    throw new Error("Cannot convert value ".concat(x, " into a BigNumber: no class 'BigNumber' provided"));
}
function $4d91bc7566c1f651$var$throwNoComplex(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Complex number: no class 'Complex' provided"));
}
function $4d91bc7566c1f651$var$throwNoMatrix() {
    throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function $4d91bc7566c1f651$var$throwNoFraction(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Fraction, no class 'Fraction' provided."));
}

});
parcelRegister("5fKrM", function(module, exports) {
/**
 * typed-function
 *
 * Type checking for JavaScript functions
 *
 * https://github.com/josdejong/typed-function
 */ "use strict";
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // OldNode. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like OldNode.
    module.exports = factory();
})(module.exports, function() {
    function ok() {
        return true;
    }
    function notOk() {
        return false;
    }
    function undef() {
        return undefined;
    }
    /**
   * @typedef {{
   *   params: Param[],
   *   fn: function
   * }} Signature
   *
   * @typedef {{
   *   types: Type[],
   *   restParam: boolean
   * }} Param
   *
   * @typedef {{
   *   name: string,
   *   typeIndex: number,
   *   test: function,
   *   conversion?: ConversionDef,
   *   conversionIndex: number,
   * }} Type
   *
   * @typedef {{
   *   from: string,
   *   to: string,
   *   convert: function (*) : *
   * }} ConversionDef
   *
   * @typedef {{
   *   name: string,
   *   test: function(*) : boolean
   * }} TypeDef
   */ // create a new instance of typed-function
    function create() {
        // data type tests
        var _types = [
            {
                name: "number",
                test: function(x) {
                    return typeof x === "number";
                }
            },
            {
                name: "string",
                test: function(x) {
                    return typeof x === "string";
                }
            },
            {
                name: "boolean",
                test: function(x) {
                    return typeof x === "boolean";
                }
            },
            {
                name: "Function",
                test: function(x) {
                    return typeof x === "function";
                }
            },
            {
                name: "Array",
                test: Array.isArray
            },
            {
                name: "Date",
                test: function(x) {
                    return x instanceof Date;
                }
            },
            {
                name: "RegExp",
                test: function(x) {
                    return x instanceof RegExp;
                }
            },
            {
                name: "Object",
                test: function(x) {
                    return typeof x === "object" && x !== null && x.constructor === Object;
                }
            },
            {
                name: "null",
                test: function(x) {
                    return x === null;
                }
            },
            {
                name: "undefined",
                test: function(x) {
                    return x === undefined;
                }
            }
        ];
        var anyType = {
            name: "any",
            test: ok
        };
        // types which need to be ignored
        var _ignore = [];
        // type conversions
        var _conversions = [];
        // This is a temporary object, will be replaced with a typed function at the end
        var typed = {
            types: _types,
            conversions: _conversions,
            ignore: _ignore
        };
        /**
     * Find the test function for a type
     * @param {String} typeName
     * @return {TypeDef} Returns the type definition when found,
     *                    Throws a TypeError otherwise
     */ function findTypeByName(typeName) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.name === typeName;
            });
            if (entry) return entry;
            if (typeName === "any") return anyType;
            var hint = findInArray(typed.types, function(entry) {
                return entry.name.toLowerCase() === typeName.toLowerCase();
            });
            throw new TypeError('Unknown type "' + typeName + '"' + (hint ? '. Did you mean "' + hint.name + '"?' : ""));
        }
        /**
     * Find the index of a type definition. Handles special case 'any'
     * @param {TypeDef} type
     * @return {number}
     */ function findTypeIndex(type) {
            if (type === anyType) return 999;
            return typed.types.indexOf(type);
        }
        /**
     * Find a type that matches a value.
     * @param {*} value
     * @return {string} Returns the name of the first type for which
     *                  the type test matches the value.
     */ function findTypeName(value) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.test(value);
            });
            if (entry) return entry.name;
            throw new TypeError("Value has unknown type. Value: " + value);
        }
        /**
     * Find a specific signature from a (composed) typed function, for example:
     *
     *   typed.find(fn, ['number', 'string'])
     *   typed.find(fn, 'number, string')
     *
     * Function find only only works for exact matches.
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature   Signature to be found, can be
     *                                        an array or a comma separated string.
     * @return {Function}                     Returns the matching signature, or
     *                                        throws an error when no signature
     *                                        is found.
     */ function find(fn, signature) {
            if (!fn.signatures) throw new TypeError("Function is no typed-function");
            // normalize input
            var arr;
            if (typeof signature === "string") {
                arr = signature.split(",");
                for(var i = 0; i < arr.length; i++)arr[i] = arr[i].trim();
            } else if (Array.isArray(signature)) arr = signature;
            else throw new TypeError("String array or a comma separated string expected");
            var str = arr.join(",");
            // find an exact match
            var match = fn.signatures[str];
            if (match) return match;
            // TODO: extend find to match non-exact signatures
            throw new TypeError("Signature not found (signature: " + (fn.name || "unnamed") + "(" + arr.join(", ") + "))");
        }
        /**
     * Convert a given value to another data type.
     * @param {*} value
     * @param {string} type
     */ function convert(value, type) {
            var from = findTypeName(value);
            // check conversion is needed
            if (type === from) return value;
            for(var i = 0; i < typed.conversions.length; i++){
                var conversion = typed.conversions[i];
                if (conversion.from === from && conversion.to === type) return conversion.convert(value);
            }
            throw new Error("Cannot convert from " + from + " to " + type);
        }
        /**
     * Stringify parameters in a normalized way
     * @param {Param[]} params
     * @return {string}
     */ function stringifyParams(params) {
            return params.map(function(param) {
                var typeNames = param.types.map(getTypeName);
                return (param.restParam ? "..." : "") + typeNames.join("|");
            }).join(",");
        }
        /**
     * Parse a parameter, like "...number | boolean"
     * @param {string} param
     * @param {ConversionDef[]} conversions
     * @return {Param} param
     */ function parseParam(param, conversions) {
            var restParam = param.indexOf("...") === 0;
            var types = !restParam ? param : param.length > 3 ? param.slice(3) : "any";
            var typeNames = types.split("|").map(trim).filter(notEmpty).filter(notIgnore);
            var matchingConversions = filterConversions(conversions, typeNames);
            var exactTypes = typeNames.map(function(typeName) {
                var type = findTypeByName(typeName);
                return {
                    name: typeName,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: null,
                    conversionIndex: -1
                };
            });
            var convertibleTypes = matchingConversions.map(function(conversion) {
                var type = findTypeByName(conversion.from);
                return {
                    name: conversion.from,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: conversion,
                    conversionIndex: conversions.indexOf(conversion)
                };
            });
            return {
                types: exactTypes.concat(convertibleTypes),
                restParam: restParam
            };
        }
        /**
     * Parse a signature with comma separated parameters,
     * like "number | boolean, ...string"
     * @param {string} signature
     * @param {function} fn
     * @param {ConversionDef[]} conversions
     * @return {Signature | null} signature
     */ function parseSignature(signature, fn, conversions) {
            var params = [];
            if (signature.trim() !== "") params = signature.split(",").map(trim).map(function(param, index, array) {
                var parsedParam = parseParam(param, conversions);
                if (parsedParam.restParam && index !== array.length - 1) throw new SyntaxError('Unexpected rest parameter "' + param + '": ' + "only allowed for the last parameter");
                return parsedParam;
            });
            if (params.some(isInvalidParam)) // invalid signature: at least one parameter has no types
            // (they may have been filtered)
            return null;
            return {
                params: params,
                fn: fn
            };
        }
        /**
     * Test whether a set of params contains a restParam
     * @param {Param[]} params
     * @return {boolean} Returns true when the last parameter is a restParam
     */ function hasRestParam(params) {
            var param = last(params);
            return param ? param.restParam : false;
        }
        /**
     * Test whether a parameter contains conversions
     * @param {Param} param
     * @return {boolean} Returns true when at least one of the parameters
     *                   contains a conversion.
     */ function hasConversions(param) {
            return param.types.some(function(type) {
                return type.conversion != null;
            });
        }
        /**
     * Create a type test for a single parameter, which can have one or multiple
     * types.
     * @param {Param} param
     * @return {function(x: *) : boolean} Returns a test function
     */ function compileTest(param) {
            if (!param || param.types.length === 0) // nothing to do
            return ok;
            else if (param.types.length === 1) return findTypeByName(param.types[0].name).test;
            else if (param.types.length === 2) {
                var test0 = findTypeByName(param.types[0].name).test;
                var test1 = findTypeByName(param.types[1].name).test;
                return function or(x) {
                    return test0(x) || test1(x);
                };
            } else {
                var tests = param.types.map(function(type) {
                    return findTypeByName(type.name).test;
                });
                return function or(x) {
                    for(var i = 0; i < tests.length; i++){
                        if (tests[i](x)) return true;
                    }
                    return false;
                };
            }
        }
        /**
     * Create a test for all parameters of a signature
     * @param {Param[]} params
     * @return {function(args: Array<*>) : boolean}
     */ function compileTests(params) {
            var tests, test0, test1;
            if (hasRestParam(params)) {
                // variable arguments like '...number'
                tests = initial(params).map(compileTest);
                var varIndex = tests.length;
                var lastTest = compileTest(last(params));
                var testRestParam = function(args) {
                    for(var i = varIndex; i < args.length; i++){
                        if (!lastTest(args[i])) return false;
                    }
                    return true;
                };
                return function testArgs(args) {
                    for(var i = 0; i < tests.length; i++){
                        if (!tests[i](args[i])) return false;
                    }
                    return testRestParam(args) && args.length >= varIndex + 1;
                };
            } else {
                // no variable arguments
                if (params.length === 0) return function testArgs(args) {
                    return args.length === 0;
                };
                else if (params.length === 1) {
                    test0 = compileTest(params[0]);
                    return function testArgs(args) {
                        return test0(args[0]) && args.length === 1;
                    };
                } else if (params.length === 2) {
                    test0 = compileTest(params[0]);
                    test1 = compileTest(params[1]);
                    return function testArgs(args) {
                        return test0(args[0]) && test1(args[1]) && args.length === 2;
                    };
                } else {
                    tests = params.map(compileTest);
                    return function testArgs(args) {
                        for(var i = 0; i < tests.length; i++){
                            if (!tests[i](args[i])) return false;
                        }
                        return args.length === tests.length;
                    };
                }
            }
        }
        /**
     * Find the parameter at a specific index of a signature.
     * Handles rest parameters.
     * @param {Signature} signature
     * @param {number} index
     * @return {Param | null} Returns the matching parameter when found,
     *                        null otherwise.
     */ function getParamAtIndex(signature, index) {
            return index < signature.params.length ? signature.params[index] : hasRestParam(signature.params) ? last(signature.params) : null;
        }
        /**
     * Get all type names of a parameter
     * @param {Signature} signature
     * @param {number} index
     * @param {boolean} excludeConversions
     * @return {string[]} Returns an array with type names
     */ function getExpectedTypeNames(signature, index, excludeConversions) {
            var param = getParamAtIndex(signature, index);
            var types = param ? excludeConversions ? param.types.filter(isExactType) : param.types : [];
            return types.map(getTypeName);
        }
        /**
     * Returns the name of a type
     * @param {Type} type
     * @return {string} Returns the type name
     */ function getTypeName(type) {
            return type.name;
        }
        /**
     * Test whether a type is an exact type or conversion
     * @param {Type} type
     * @return {boolean} Returns true when
     */ function isExactType(type) {
            return type.conversion === null || type.conversion === undefined;
        }
        /**
     * Helper function for creating error messages: create an array with
     * all available types on a specific argument index.
     * @param {Signature[]} signatures
     * @param {number} index
     * @return {string[]} Returns an array with available types
     */ function mergeExpectedParams(signatures, index) {
            var typeNames = uniq(flatMap(signatures, function(signature) {
                return getExpectedTypeNames(signature, index, false);
            }));
            return typeNames.indexOf("any") !== -1 ? [
                "any"
            ] : typeNames;
        }
        /**
     * Create
     * @param {string} name             The name of the function
     * @param {array.<*>} args          The actual arguments passed to the function
     * @param {Signature[]} signatures  A list with available signatures
     * @return {TypeError} Returns a type error with additional data
     *                     attached to it in the property `data`
     */ function createError(name, args, signatures) {
            var err, expected;
            var _name = name || "unnamed";
            // test for wrong type at some index
            var matchingSignatures = signatures;
            var index;
            for(index = 0; index < args.length; index++){
                var nextMatchingDefs = matchingSignatures.filter(function(signature) {
                    var test = compileTest(getParamAtIndex(signature, index));
                    return (index < signature.params.length || hasRestParam(signature.params)) && test(args[index]);
                });
                if (nextMatchingDefs.length === 0) {
                    // no matching signatures anymore, throw error "wrong type"
                    expected = mergeExpectedParams(matchingSignatures, index);
                    if (expected.length > 0) {
                        var actualType = findTypeName(args[index]);
                        err = new TypeError("Unexpected type of argument in function " + _name + " (expected: " + expected.join(" or ") + ", actual: " + actualType + ", index: " + index + ")");
                        err.data = {
                            category: "wrongType",
                            fn: _name,
                            index: index,
                            actual: actualType,
                            expected: expected
                        };
                        return err;
                    }
                } else matchingSignatures = nextMatchingDefs;
            }
            // test for too few arguments
            var lengths = matchingSignatures.map(function(signature) {
                return hasRestParam(signature.params) ? Infinity : signature.params.length;
            });
            if (args.length < Math.min.apply(null, lengths)) {
                expected = mergeExpectedParams(matchingSignatures, index);
                err = new TypeError("Too few arguments in function " + _name + " (expected: " + expected.join(" or ") + ", index: " + args.length + ")");
                err.data = {
                    category: "tooFewArgs",
                    fn: _name,
                    index: args.length,
                    expected: expected
                };
                return err;
            }
            // test for too many arguments
            var maxLength = Math.max.apply(null, lengths);
            if (args.length > maxLength) {
                err = new TypeError("Too many arguments in function " + _name + " (expected: " + maxLength + ", actual: " + args.length + ")");
                err.data = {
                    category: "tooManyArgs",
                    fn: _name,
                    index: args.length,
                    expectedLength: maxLength
                };
                return err;
            }
            err = new TypeError('Arguments of type "' + args.join(", ") + '" do not match any of the defined signatures of function ' + _name + ".");
            err.data = {
                category: "mismatch",
                actual: args.map(findTypeName)
            };
            return err;
        }
        /**
     * Find the lowest index of all exact types of a parameter (no conversions)
     * @param {Param} param
     * @return {number} Returns the index of the lowest type in typed.types
     */ function getLowestTypeIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (isExactType(param.types[i])) min = Math.min(min, param.types[i].typeIndex);
            return min;
        }
        /**
     * Find the lowest index of the conversion of all types of the parameter
     * having a conversion
     * @param {Param} param
     * @return {number} Returns the lowest index of the conversions of this type
     */ function getLowestConversionIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (!isExactType(param.types[i])) min = Math.min(min, param.types[i].conversionIndex);
            return min;
        }
        /**
     * Compare two params
     * @param {Param} param1
     * @param {Param} param2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareParams(param1, param2) {
            var c;
            // compare having a rest parameter or not
            c = param1.restParam - param2.restParam;
            if (c !== 0) return c;
            // compare having conversions or not
            c = hasConversions(param1) - hasConversions(param2);
            if (c !== 0) return c;
            // compare the index of the types
            c = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
            if (c !== 0) return c;
            // compare the index of any conversion
            return getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
        }
        /**
     * Compare two signatures
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareSignatures(signature1, signature2) {
            var len = Math.min(signature1.params.length, signature2.params.length);
            var i;
            var c;
            // compare whether the params have conversions at all or not
            c = signature1.params.some(hasConversions) - signature2.params.some(hasConversions);
            if (c !== 0) return c;
            // next compare whether the params have conversions one by one
            for(i = 0; i < len; i++){
                c = hasConversions(signature1.params[i]) - hasConversions(signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the types of the params one by one
            for(i = 0; i < len; i++){
                c = compareParams(signature1.params[i], signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the number of params
            return signature1.params.length - signature2.params.length;
        }
        /**
     * Get params containing all types that can be converted to the defined types.
     *
     * @param {ConversionDef[]} conversions
     * @param {string[]} typeNames
     * @return {ConversionDef[]} Returns the conversions that are available
     *                        for every type (if any)
     */ function filterConversions(conversions, typeNames) {
            var matches = {};
            conversions.forEach(function(conversion) {
                if (typeNames.indexOf(conversion.from) === -1 && typeNames.indexOf(conversion.to) !== -1 && !matches[conversion.from]) matches[conversion.from] = conversion;
            });
            return Object.keys(matches).map(function(from) {
                return matches[from];
            });
        }
        /**
     * Preprocess arguments before calling the original function:
     * - if needed convert the parameters
     * - in case of rest parameters, move the rest parameters into an Array
     * @param {Param[]} params
     * @param {function} fn
     * @return {function} Returns a wrapped function
     */ function compileArgsPreprocessing(params, fn) {
            var fnConvert = fn;
            // TODO: can we make this wrapper function smarter/simpler?
            if (params.some(hasConversions)) {
                var restParam = hasRestParam(params);
                var compiledConversions = params.map(compileArgConversion);
                fnConvert = function convertArgs() {
                    var args = [];
                    var last = restParam ? arguments.length - 1 : arguments.length;
                    for(var i = 0; i < last; i++)args[i] = compiledConversions[i](arguments[i]);
                    if (restParam) args[last] = arguments[last].map(compiledConversions[last]);
                    return fn.apply(null, args);
                };
            }
            var fnPreprocess = fnConvert;
            if (hasRestParam(params)) {
                var offset = params.length - 1;
                fnPreprocess = function preprocessRestParams() {
                    return fnConvert.apply(null, slice(arguments, 0, offset).concat([
                        slice(arguments, offset)
                    ]));
                };
            }
            return fnPreprocess;
        }
        /**
     * Compile conversion for a parameter to the right type
     * @param {Param} param
     * @return {function} Returns the wrapped function that will convert arguments
     *
     */ function compileArgConversion(param) {
            var test0, test1, conversion0, conversion1;
            var tests = [];
            var conversions = [];
            param.types.forEach(function(type) {
                if (type.conversion) {
                    tests.push(findTypeByName(type.conversion.from).test);
                    conversions.push(type.conversion.convert);
                }
            });
            // create optimized conversion functions depending on the number of conversions
            switch(conversions.length){
                case 0:
                    return function convertArg(arg) {
                        return arg;
                    };
                case 1:
                    test0 = tests[0];
                    conversion0 = conversions[0];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        return arg;
                    };
                case 2:
                    test0 = tests[0];
                    test1 = tests[1];
                    conversion0 = conversions[0];
                    conversion1 = conversions[1];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        if (test1(arg)) return conversion1(arg);
                        return arg;
                    };
                default:
                    return function convertArg(arg) {
                        for(var i = 0; i < conversions.length; i++){
                            if (tests[i](arg)) return conversions[i](arg);
                        }
                        return arg;
                    };
            }
        }
        /**
     * Convert an array with signatures into a map with signatures,
     * where signatures with union types are split into separate signatures
     *
     * Throws an error when there are conflicting types
     *
     * @param {Signature[]} signatures
     * @return {Object.<string, function>}  Returns a map with signatures
     *                                      as key and the original function
     *                                      of this signature as value.
     */ function createSignaturesMap(signatures) {
            var signaturesMap = {};
            signatures.forEach(function(signature) {
                if (!signature.params.some(hasConversions)) splitParams(signature.params, true).forEach(function(params) {
                    signaturesMap[stringifyParams(params)] = signature.fn;
                });
            });
            return signaturesMap;
        }
        /**
     * Split params with union types in to separate params.
     *
     * For example:
     *
     *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
     *     // returns:
     *     // [
     *     //   ['Array', 'string'],
     *     //   ['Array', 'RegExp'],
     *     //   ['Object', 'string'],
     *     //   ['Object', 'RegExp']
     *     // ]
     *
     * @param {Param[]} params
     * @param {boolean} ignoreConversionTypes
     * @return {Param[]}
     */ function splitParams(params, ignoreConversionTypes) {
            function _splitParams(params, index, types) {
                if (index < params.length) {
                    var param = params[index];
                    var filteredTypes = ignoreConversionTypes ? param.types.filter(isExactType) : param.types;
                    var typeGroups;
                    if (param.restParam) {
                        // split the types of a rest parameter in two:
                        // one with only exact types, and one with exact types and conversions
                        var exactTypes = filteredTypes.filter(isExactType);
                        typeGroups = exactTypes.length < filteredTypes.length ? [
                            exactTypes,
                            filteredTypes
                        ] : [
                            filteredTypes
                        ];
                    } else // split all the types of a regular parameter into one type per group
                    typeGroups = filteredTypes.map(function(type) {
                        return [
                            type
                        ];
                    });
                    // recurse over the groups with types
                    return flatMap(typeGroups, function(typeGroup) {
                        return _splitParams(params, index + 1, types.concat([
                            typeGroup
                        ]));
                    });
                } else {
                    // we've reached the end of the parameters. Now build a new Param
                    var splittedParams = types.map(function(type, typeIndex) {
                        return {
                            types: type,
                            restParam: typeIndex === params.length - 1 && hasRestParam(params)
                        };
                    });
                    return [
                        splittedParams
                    ];
                }
            }
            return _splitParams(params, 0, []);
        }
        /**
     * Test whether two signatures have a conflicting signature
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {boolean} Returns true when the signatures conflict, false otherwise.
     */ function hasConflictingParams(signature1, signature2) {
            var ii = Math.max(signature1.params.length, signature2.params.length);
            for(var i = 0; i < ii; i++){
                var typesNames1 = getExpectedTypeNames(signature1, i, true);
                var typesNames2 = getExpectedTypeNames(signature2, i, true);
                if (!hasOverlap(typesNames1, typesNames2)) return false;
            }
            var len1 = signature1.params.length;
            var len2 = signature2.params.length;
            var restParam1 = hasRestParam(signature1.params);
            var restParam2 = hasRestParam(signature2.params);
            return restParam1 ? restParam2 ? len1 === len2 : len2 >= len1 : restParam2 ? len1 >= len2 : len1 === len2;
        }
        /**
     * Create a typed function
     * @param {String} name               The name for the typed function
     * @param {Object.<string, function>} signaturesMap
     *                                    An object with one or
     *                                    multiple signatures as key, and the
     *                                    function corresponding to the
     *                                    signature as value.
     * @return {function}  Returns the created typed function.
     */ function createTypedFunction(name, signaturesMap) {
            if (Object.keys(signaturesMap).length === 0) throw new SyntaxError("No signatures provided");
            // parse the signatures, and check for conflicts
            var parsedSignatures = [];
            Object.keys(signaturesMap).map(function(signature) {
                return parseSignature(signature, signaturesMap[signature], typed.conversions);
            }).filter(notNull).forEach(function(parsedSignature) {
                // check whether this parameter conflicts with already parsed signatures
                var conflictingSignature = findInArray(parsedSignatures, function(s) {
                    return hasConflictingParams(s, parsedSignature);
                });
                if (conflictingSignature) throw new TypeError('Conflicting signatures "' + stringifyParams(conflictingSignature.params) + '" and "' + stringifyParams(parsedSignature.params) + '".');
                parsedSignatures.push(parsedSignature);
            });
            // split and filter the types of the signatures, and then order them
            var signatures = flatMap(parsedSignatures, function(parsedSignature) {
                var params = parsedSignature ? splitParams(parsedSignature.params, false) : [];
                return params.map(function(params) {
                    return {
                        params: params,
                        fn: parsedSignature.fn
                    };
                });
            }).filter(notNull);
            signatures.sort(compareSignatures);
            // we create a highly optimized checks for the first couple of signatures with max 2 arguments
            var ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
            var ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
            var ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
            var ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
            var ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
            var ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
            var allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;
            // compile the tests
            var tests = signatures.map(function(signature) {
                return compileTests(signature.params);
            });
            var test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
            var test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
            var test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
            var test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
            var test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
            var test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
            var test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
            var test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
            var test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
            var test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
            var test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
            var test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;
            // compile the functions
            var fns = signatures.map(function(signature) {
                return compileArgsPreprocessing(signature.params, signature.fn);
            });
            var fn0 = ok0 ? fns[0] : undef;
            var fn1 = ok1 ? fns[1] : undef;
            var fn2 = ok2 ? fns[2] : undef;
            var fn3 = ok3 ? fns[3] : undef;
            var fn4 = ok4 ? fns[4] : undef;
            var fn5 = ok5 ? fns[5] : undef;
            var len0 = ok0 ? signatures[0].params.length : -1;
            var len1 = ok1 ? signatures[1].params.length : -1;
            var len2 = ok2 ? signatures[2].params.length : -1;
            var len3 = ok3 ? signatures[3].params.length : -1;
            var len4 = ok4 ? signatures[4].params.length : -1;
            var len5 = ok5 ? signatures[5].params.length : -1;
            // simple and generic, but also slow
            var iStart = allOk ? 6 : 0;
            var iEnd = signatures.length;
            var generic = function generic() {
                "use strict";
                for(var i = iStart; i < iEnd; i++){
                    if (tests[i](arguments)) return fns[i].apply(null, arguments);
                }
                throw createError(name, arguments, signatures);
            };
            // create the typed function
            // fast, specialized version. Falls back to the slower, generic one if needed
            var fn = function fn(arg0, arg1) {
                "use strict";
                if (arguments.length === len0 && test00(arg0) && test01(arg1)) return fn0.apply(null, arguments);
                if (arguments.length === len1 && test10(arg0) && test11(arg1)) return fn1.apply(null, arguments);
                if (arguments.length === len2 && test20(arg0) && test21(arg1)) return fn2.apply(null, arguments);
                if (arguments.length === len3 && test30(arg0) && test31(arg1)) return fn3.apply(null, arguments);
                if (arguments.length === len4 && test40(arg0) && test41(arg1)) return fn4.apply(null, arguments);
                if (arguments.length === len5 && test50(arg0) && test51(arg1)) return fn5.apply(null, arguments);
                return generic.apply(null, arguments);
            };
            // attach name the typed function
            try {
                Object.defineProperty(fn, "name", {
                    value: name
                });
            } catch (err) {
            // old browsers do not support Object.defineProperty and some don't support setting the name property
            // the function name is not essential for the functioning, it's mostly useful for debugging,
            // so it's fine to have unnamed functions.
            }
            // attach signatures to the function
            fn.signatures = createSignaturesMap(signatures);
            return fn;
        }
        /**
     * Test whether a type should be NOT be ignored
     * @param {string} typeName
     * @return {boolean}
     */ function notIgnore(typeName) {
            return typed.ignore.indexOf(typeName) === -1;
        }
        /**
     * trim a string
     * @param {string} str
     * @return {string}
     */ function trim(str) {
            return str.trim();
        }
        /**
     * Test whether a string is not empty
     * @param {string} str
     * @return {boolean}
     */ function notEmpty(str) {
            return !!str;
        }
        /**
     * test whether a value is not strict equal to null
     * @param {*} value
     * @return {boolean}
     */ function notNull(value) {
            return value !== null;
        }
        /**
     * Test whether a parameter has no types defined
     * @param {Param} param
     * @return {boolean}
     */ function isInvalidParam(param) {
            return param.types.length === 0;
        }
        /**
     * Return all but the last items of an array
     * @param {Array} arr
     * @return {Array}
     */ function initial(arr) {
            return arr.slice(0, arr.length - 1);
        }
        /**
     * return the last item of an array
     * @param {Array} arr
     * @return {*}
     */ function last(arr) {
            return arr[arr.length - 1];
        }
        /**
     * Slice an array or function Arguments
     * @param {Array | Arguments | IArguments} arr
     * @param {number} start
     * @param {number} [end]
     * @return {Array}
     */ function slice(arr, start, end) {
            return Array.prototype.slice.call(arr, start, end);
        }
        /**
     * Test whether an array contains some item
     * @param {Array} array
     * @param {*} item
     * @return {boolean} Returns true if array contains item, false if not.
     */ function contains(array, item) {
            return array.indexOf(item) !== -1;
        }
        /**
     * Test whether two arrays have overlapping items
     * @param {Array} array1
     * @param {Array} array2
     * @return {boolean} Returns true when at least one item exists in both arrays
     */ function hasOverlap(array1, array2) {
            for(var i = 0; i < array1.length; i++){
                if (contains(array2, array1[i])) return true;
            }
            return false;
        }
        /**
     * Return the first item from an array for which test(arr[i]) returns true
     * @param {Array} arr
     * @param {function} test
     * @return {* | undefined} Returns the first matching item
     *                         or undefined when there is no match
     */ function findInArray(arr, test) {
            for(var i = 0; i < arr.length; i++){
                if (test(arr[i])) return arr[i];
            }
            return undefined;
        }
        /**
     * Filter unique items of an array with strings
     * @param {string[]} arr
     * @return {string[]}
     */ function uniq(arr) {
            var entries = {};
            for(var i = 0; i < arr.length; i++)entries[arr[i]] = true;
            return Object.keys(entries);
        }
        /**
     * Flat map the result invoking a callback for every item in an array.
     * https://gist.github.com/samgiles/762ee337dff48623e729
     * @param {Array} arr
     * @param {function} callback
     * @return {Array}
     */ function flatMap(arr, callback) {
            return Array.prototype.concat.apply([], arr.map(callback));
        }
        /**
     * Retrieve the function name from a set of typed functions,
     * and check whether the name of all functions match (if given)
     * @param {function[]} fns
     */ function getName(fns) {
            var name = "";
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // check whether the names are the same when defined
                if ((typeof fn.signatures === "object" || typeof fn.signature === "string") && fn.name !== "") {
                    if (name === "") name = fn.name;
                    else if (name !== fn.name) {
                        var err = new Error("Function names do not match (expected: " + name + ", actual: " + fn.name + ")");
                        err.data = {
                            actual: fn.name,
                            expected: name
                        };
                        throw err;
                    }
                }
            }
            return name;
        }
        // extract and merge all signatures of a list with typed functions
        function extractSignatures(fns) {
            var err;
            var signaturesMap = {};
            function validateUnique(_signature, _fn) {
                if (signaturesMap.hasOwnProperty(_signature) && _fn !== signaturesMap[_signature]) {
                    err = new Error('Signature "' + _signature + '" is defined twice');
                    err.data = {
                        signature: _signature
                    };
                    throw err;
                // else: both signatures point to the same function, that's fine
                }
            }
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // test whether this is a typed-function
                if (typeof fn.signatures === "object") {
                    // merge the signatures
                    for(var signature in fn.signatures)if (fn.signatures.hasOwnProperty(signature)) {
                        validateUnique(signature, fn.signatures[signature]);
                        signaturesMap[signature] = fn.signatures[signature];
                    }
                } else if (typeof fn.signature === "string") {
                    validateUnique(fn.signature, fn);
                    signaturesMap[fn.signature] = fn;
                } else {
                    err = new TypeError("Function is no typed-function (index: " + i + ")");
                    err.data = {
                        index: i
                    };
                    throw err;
                }
            }
            return signaturesMap;
        }
        typed = createTypedFunction("typed", {
            "string, Object": createTypedFunction,
            "Object": function(signaturesMap) {
                // find existing name
                var fns = [];
                for(var signature in signaturesMap)if (signaturesMap.hasOwnProperty(signature)) fns.push(signaturesMap[signature]);
                var name = getName(fns);
                return createTypedFunction(name, signaturesMap);
            },
            "...Function": function(fns) {
                return createTypedFunction(getName(fns), extractSignatures(fns));
            },
            "string, ...Function": function(name, fns) {
                return createTypedFunction(name, extractSignatures(fns));
            }
        });
        typed.create = create;
        typed.types = _types;
        typed.conversions = _conversions;
        typed.ignore = _ignore;
        typed.convert = convert;
        typed.find = find;
        /**
     * add a type
     * @param {{name: string, test: function}} type
     * @param {boolean} [beforeObjectTest=true]
     *                          If true, the new test will be inserted before
     *                          the test with name 'Object' (if any), since
     *                          tests for Object match Array and classes too.
     */ typed.addType = function(type, beforeObjectTest) {
            if (!type || typeof type.name !== "string" || typeof type.test !== "function") throw new TypeError("Object with properties {name: string, test: function} expected");
            if (beforeObjectTest !== false) {
                for(var i = 0; i < typed.types.length; i++)if (typed.types[i].name === "Object") {
                    typed.types.splice(i, 0, type);
                    return;
                }
            }
            typed.types.push(type);
        };
        // add a conversion
        typed.addConversion = function(conversion) {
            if (!conversion || typeof conversion.from !== "string" || typeof conversion.to !== "string" || typeof conversion.convert !== "function") throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
            typed.conversions.push(conversion);
        };
        return typed;
    }
    return create();
});

});


parcelRegister("5tIPz", function(module, exports) {

$parcel$export(module.exports, "createTypeOf", function () { return $3fd26fa1e6d15aa2$export$d7acf116afef7b4d; });

var $jKx4O = parcelRequire("jKx4O");

var $7E0JQ = parcelRequire("7E0JQ");

var $9okwi = parcelRequire("9okwi");
var $3fd26fa1e6d15aa2$var$name = "typeOf";
var $3fd26fa1e6d15aa2$var$dependencies = [
    "typed"
];
var $3fd26fa1e6d15aa2$export$d7acf116afef7b4d = /* #__PURE__ */ (0, $jKx4O.factory)($3fd26fa1e6d15aa2$var$name, $3fd26fa1e6d15aa2$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Determine the type of a variable.
   *
   * Function `typeOf` recognizes the following types of objects:
   *
   * Object                 | Returns       | Example
   * ---------------------- | ------------- | ------------------------------------------
   * null                   | `'null'`      | `math.typeOf(null)`
   * number                 | `'number'`    | `math.typeOf(3.5)`
   * boolean                | `'boolean'`   | `math.typeOf(true)`
   * string                 | `'string'`    | `math.typeOf('hello world')`
   * Array                  | `'Array'`     | `math.typeOf([1, 2, 3])`
   * Date                   | `'Date'`      | `math.typeOf(new Date())`
   * Function               | `'Function'`  | `math.typeOf(function () {})`
   * Object                 | `'Object'`    | `math.typeOf({a: 2, b: 3})`
   * RegExp                 | `'RegExp'`    | `math.typeOf(/a regexp/)`
   * undefined              | `'undefined'` | `math.typeOf(undefined)`
   * math.BigNumber         | `'BigNumber'` | `math.typeOf(math.bignumber('2.3e500'))`
   * math.Chain             | `'Chain'`     | `math.typeOf(math.chain(2))`
   * math.Complex           | `'Complex'`   | `math.typeOf(math.complex(2, 3))`
   * math.Fraction          | `'Fraction'`  | `math.typeOf(math.fraction(1, 3))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Index             | `'Index'`     | `math.typeOf(math.index(1, 3))`
   * math.Matrix            | `'Matrix'`    | `math.typeOf(math.matrix([[1,2], [3, 4]]))`
   * math.Range             | `'Range'`     | `math.typeOf(math.range(0, 10))`
   * math.ResultSet         | `'ResultSet'` | `math.typeOf(math.evaluate('a=2\nb=3'))`
   * math.Unit              | `'Unit'`      | `math.typeOf(math.unit('45 deg'))`
   * math.AccessorNode            | `'AccessorNode'`            | `math.typeOf(math.parse('A[2]'))`
   * math.ArrayNode               | `'ArrayNode'`               | `math.typeOf(math.parse('[1,2,3]'))`
   * math.AssignmentNode          | `'AssignmentNode'`          | `math.typeOf(math.parse('x=2'))`
   * math.BlockNode               | `'BlockNode'`               | `math.typeOf(math.parse('a=2; b=3'))`
   * math.ConditionalNode         | `'ConditionalNode'`         | `math.typeOf(math.parse('x<0 ? -x : x'))`
   * math.ConstantNode            | `'ConstantNode'`            | `math.typeOf(math.parse('2.3'))`
   * math.FunctionAssignmentNode  | `'FunctionAssignmentNode'`  | `math.typeOf(math.parse('f(x)=x^2'))`
   * math.FunctionNode            | `'FunctionNode'`            | `math.typeOf(math.parse('sqrt(4)'))`
   * math.IndexNode               | `'IndexNode'`               | `math.typeOf(math.parse('A[2]').index)`
   * math.ObjectNode              | `'ObjectNode'`              | `math.typeOf(math.parse('{a:2}'))`
   * math.ParenthesisNode         | `'ParenthesisNode'`         | `math.typeOf(math.parse('(2+3)'))`
   * math.RangeNode               | `'RangeNode'`               | `math.typeOf(math.parse('1:10'))`
   * math.SymbolNode              | `'SymbolNode'`              | `math.typeOf(math.parse('x'))`
   *
   * Syntax:
   *
   *    math.typeOf(x)
   *
   * Examples:
   *
   *    math.typeOf(3.5)                     // returns 'number'
   *    math.typeOf(math.complex('2-4i'))    // returns 'Complex'
   *    math.typeOf(math.unit('45 deg'))     // returns 'Unit'
   *    math.typeOf('hello world')           // returns 'string'
   *
   * @param {*} x     The variable for which to test the type.
   * @return {string} Returns the name of the type. Primitive types are lower case,
   *                  non-primitive types are upper-camel-case.
   *                  For example 'number', 'string', 'Array', 'Date'.
   */ return typed($3fd26fa1e6d15aa2$var$name, {
        any: (0, $7E0JQ.typeOf)
    });
}); // For backward compatibility, deprecated since version 6.0.0. Date: 2018-11-06
var $3fd26fa1e6d15aa2$export$4f3eb3292c67e51a = /* #__PURE__ */ (0, $jKx4O.factory)("typeof", [], function() {
    return function() {
        (0, $9okwi.warnOnce)('Function "typeof" has been renamed to "typeOf" in v6.0.0, please use the new function instead.');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (0, $7E0JQ.typeOf).apply((0, $7E0JQ.typeOf), args);
    };
});

});

parcelRegister("9jIEe", function(module, exports) {

$parcel$export(module.exports, "createUnaryMinus", function () { return $6c88858c73813e73$export$939e1be6e134f392; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $6c88858c73813e73$var$name = "unaryMinus";
var $6c88858c73813e73$var$dependencies = [
    "typed"
];
var $6c88858c73813e73$export$939e1be6e134f392 = /* #__PURE__ */ (0, $jKx4O.factory)($6c88858c73813e73$var$name, $6c88858c73813e73$var$dependencies, function(_ref) {
    var typed = _ref.typed;
    /**
   * Inverse the sign of a value, apply a unary minus operation.
   *
   * For matrices, the function is evaluated element wise. Boolean values and
   * strings will be converted to a number. For complex numbers, both real and
   * complex value are inverted.
   *
   * Syntax:
   *
   *    math.unaryMinus(x)
   *
   * Examples:
   *
   *    math.unaryMinus(3.5)      // returns -3.5
   *    math.unaryMinus(-4.2)     // returns 4.2
   *
   * See also:
   *
   *    add, subtract, unaryPlus
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
   */ var unaryMinus = typed($6c88858c73813e73$var$name, {
        number: (0, $cqeCl.unaryMinusNumber),
        Complex: function Complex(x) {
            return x.neg();
        },
        BigNumber: function BigNumber(x) {
            return x.neg();
        },
        Fraction: function Fraction(x) {
            return x.neg();
        },
        Unit: function Unit(x) {
            var res = x.clone();
            res.value = unaryMinus(x.value);
            return res;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryMinus(0) = 0
            return (0, $fbkGg.deepMap)(x, unaryMinus, true);
        } // TODO: add support for string
    });
    return unaryMinus;
});

});

parcelRegister("j8Bc0", function(module, exports) {

$parcel$export(module.exports, "createUnaryPlus", function () { return $deeb9d56f503dbdd$export$cb425222dc08ff4e; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");

var $cqeCl = parcelRequire("cqeCl");
var $deeb9d56f503dbdd$var$name = "unaryPlus";
var $deeb9d56f503dbdd$var$dependencies = [
    "typed",
    "config",
    "BigNumber"
];
var $deeb9d56f503dbdd$export$cb425222dc08ff4e = /* #__PURE__ */ (0, $jKx4O.factory)($deeb9d56f503dbdd$var$name, $deeb9d56f503dbdd$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, BigNumber = _ref.BigNumber;
    /**
   * Unary plus operation.
   * Boolean values and strings will be converted to a number, numeric values will be returned as is.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.unaryPlus(x)
   *
   * Examples:
   *
   *    math.unaryPlus(3.5)      // returns 3.5
   *    math.unaryPlus(1)     // returns 1
   *
   * See also:
   *
   *    unaryMinus, add, subtract
   *
   * @param  {number | BigNumber | Fraction | string | Complex | Unit | Array | Matrix} x
   *            Input value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns the input value when numeric, converts to a number when input is non-numeric.
   */ var unaryPlus = typed($deeb9d56f503dbdd$var$name, {
        number: (0, $cqeCl.unaryPlusNumber),
        Complex: function Complex(x) {
            return x; // complex numbers are immutable
        },
        BigNumber: function BigNumber(x) {
            return x; // bignumbers are immutable
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: function Unit(x) {
            return x.clone();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryPlus(0) = 0
            return (0, $fbkGg.deepMap)(x, unaryPlus, true);
        },
        "boolean | string": function booleanString(x) {
            // convert to a number or bignumber
            return config.number === "BigNumber" ? new BigNumber(+x) : +x;
        }
    });
    return unaryPlus;
});

});

parcelRegister("kO7HK", function(module, exports) {

$parcel$export(module.exports, "createUnequal", function () { return $f25e741ff88450e4$export$833e6c382e279d04; });

var $jKx4O = parcelRequire("jKx4O");

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $272zs = parcelRequire("272zs");

var $5ntii = parcelRequire("5ntii");

var $kJFHo = parcelRequire("kJFHo");
var $f25e741ff88450e4$var$name = "unequal";
var $f25e741ff88450e4$var$dependencies = [
    "typed",
    "config",
    "equalScalar",
    "matrix",
    "DenseMatrix"
];
var $f25e741ff88450e4$export$833e6c382e279d04 = /* #__PURE__ */ (0, $jKx4O.factory)($f25e741ff88450e4$var$name, $f25e741ff88450e4$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, equalScalar = _ref.equalScalar, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether two values are unequal.
   *
   * The function tests whether the relative difference between x and y is
   * larger than the configured epsilon. The function cannot be used to compare
   * values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
   * Strings are compared by their numerical value.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is unequal
   * with everything except `null`, and `undefined` is unequal with everything
   * except `undefined`.
   *
   * Syntax:
   *
   *    math.unequal(x, y)
   *
   * Examples:
   *
   *    math.unequal(2 + 2, 3)       // returns true
   *    math.unequal(2 + 2, 4)       // returns false
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.unequal(a, b)           // returns false
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.unequal(c, d)           // returns [false, true, false]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.unequal(0, null)        // returns true
   * See also:
   *
   *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
   */ var unequal = typed("unequal", {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return _unequal(x, y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, _unequal);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, _unequal, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, _unequal, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, _unequal);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return unequal(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return unequal(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return unequal(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, _unequal, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, _unequal, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, _unequal, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, _unequal, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, _unequal, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, _unequal, true).valueOf();
        }
    });
    function _unequal(x, y) {
        return !equalScalar(x, y);
    }
    return unequal;
});
var $f25e741ff88450e4$export$b0b3dad01e54080b = (0, $jKx4O.factory)($f25e741ff88450e4$var$name, [
    "typed",
    "equalScalar"
], function(_ref2) {
    var typed = _ref2.typed, equalScalar = _ref2.equalScalar;
    return typed($f25e741ff88450e4$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return !equalScalar(x, y);
        }
    });
});

});

parcelRegister("dqgpl", function(module, exports) {

$parcel$export(module.exports, "createUnitClass", function () { return $9c5a6e4bc073984d$export$3ad06557a3ac7a63; });

var $7E0JQ = parcelRequire("7E0JQ");

var $jKx4O = parcelRequire("jKx4O");

var $7HWRb = parcelRequire("7HWRb");

var $glBd7 = parcelRequire("glBd7");

var $fKKQe = parcelRequire("fKKQe");
function $9c5a6e4bc073984d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9c5a6e4bc073984d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9c5a6e4bc073984d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9c5a6e4bc073984d$var$_typeof(obj);
}
function $9c5a6e4bc073984d$var$_extends() {
    $9c5a6e4bc073984d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c5a6e4bc073984d$var$_extends.apply(this, arguments);
}
var $9c5a6e4bc073984d$var$name = "Unit";
var $9c5a6e4bc073984d$var$dependencies = [
    "?on",
    "config",
    "addScalar",
    "subtract",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "abs",
    "fix",
    "round",
    "equal",
    "isNumeric",
    "format",
    "number",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $9c5a6e4bc073984d$export$3ad06557a3ac7a63 = /* #__PURE__ */ (0, $jKx4O.factory)($9c5a6e4bc073984d$var$name, $9c5a6e4bc073984d$var$dependencies, function(_ref) {
    var on = _ref.on, config = _ref.config, addScalar = _ref.addScalar, subtract = _ref.subtract, multiplyScalar = _ref.multiplyScalar, divideScalar = _ref.divideScalar, pow = _ref.pow, abs = _ref.abs, fix = _ref.fix, round = _ref.round, equal = _ref.equal, isNumeric = _ref.isNumeric, format = _ref.format, number = _ref.number, Complex = _ref.Complex, _BigNumber = _ref.BigNumber, _Fraction = _ref.Fraction;
    var toNumber = number;
    /**
   * A unit can be constructed in the following ways:
   *
   *     const a = new Unit(value, name)
   *     const b = new Unit(null, name)
   *     const c = Unit.parse(str)
   *
   * Example usage:
   *
   *     const a = new Unit(5, 'cm')               // 50 mm
   *     const b = Unit.parse('23 kg')             // 23 kg
   *     const c = math.in(a, new Unit(null, 'm')  // 0.05 m
   *     const d = new Unit(9.81, "m/s^2")         // 9.81 m/s^2
   *
   * @class Unit
   * @constructor Unit
   * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
   * @param {string} [name]   A unit name like "cm" or "inch", or a derived unit of the form: "u1[^ex1] [u2[^ex2] ...] [/ u3[^ex3] [u4[^ex4]]]", such as "kg m^2/s^2", where each unit appearing after the forward slash is taken to be in the denominator. "kg m^2 s^-2" is a synonym and is also acceptable. Any of the units can include a prefix.
   */ function Unit(value, name) {
        if (!(this instanceof Unit)) throw new Error("Constructor must be called with the new operator");
        if (!(value === null || value === undefined || isNumeric(value) || (0, $7E0JQ.isComplex)(value))) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
        if (name !== undefined && (typeof name !== "string" || name === "")) throw new TypeError("Second parameter in Unit constructor must be a string");
        if (name !== undefined) {
            var u = Unit.parse(name);
            this.units = u.units;
            this.dimensions = u.dimensions;
        } else {
            this.units = [
                {
                    unit: UNIT_NONE,
                    prefix: PREFIXES.NONE,
                    // link to a list with supported prefixes
                    power: 0
                }
            ];
            this.dimensions = [];
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)this.dimensions[i] = 0;
        }
        this.value = value !== undefined && value !== null ? this._normalize(value) : null;
        this.fixPrefix = false; // if true, function format will not search for the
        // best prefix but leave it as initially provided.
        // fixPrefix is set true by the method Unit.to
        // The justification behind this is that if the constructor is explicitly called,
        // the caller wishes the units to be returned exactly as he supplied.
        this.skipAutomaticSimplification = true;
    }
    /**
   * Attach type information
   */ Unit.prototype.type = "Unit";
    Unit.prototype.isUnit = true; // private variables and functions for the Unit parser
    var text, index, c;
    function skipWhitespace() {
        while(c === " " || c === "	")next();
    }
    function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    }
    function isDigit(c) {
        return c >= "0" && c <= "9";
    }
    function next() {
        index++;
        c = text.charAt(index);
    }
    function revert(oldIndex) {
        index = oldIndex;
        c = text.charAt(index);
    }
    function parseNumber() {
        var number = "";
        var oldIndex = index;
        if (c === "+") next();
        else if (c === "-") {
            number += c;
            next();
        }
        if (!isDigitDot(c)) {
            // a + or - must be followed by a digit
            revert(oldIndex);
            return null;
        } // get number, can have a single dot
        if (c === ".") {
            number += c;
            next();
            if (!isDigit(c)) {
                // this is no legal number, it is just a dot
                revert(oldIndex);
                return null;
            }
        } else {
            while(isDigit(c)){
                number += c;
                next();
            }
            if (c === ".") {
                number += c;
                next();
            }
        }
        while(isDigit(c)){
            number += c;
            next();
        } // check for exponential notation like "2.3e-4" or "1.23e50"
        if (c === "E" || c === "e") {
            // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"
            var tentativeNumber = "";
            var tentativeIndex = index;
            tentativeNumber += c;
            next();
            if (c === "+" || c === "-") {
                tentativeNumber += c;
                next();
            } // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
            if (!isDigit(c)) {
                // The e or E must belong to something else, so return the number without the e or E.
                revert(tentativeIndex);
                return number;
            } // We can now safely say that this is scientific notation.
            number = number + tentativeNumber;
            while(isDigit(c)){
                number += c;
                next();
            }
        }
        return number;
    }
    function parseUnit() {
        var unitName = ""; // Alphanumeric characters only; matches [a-zA-Z0-9]
        var code = text.charCodeAt(index);
        while(code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122){
            unitName += c;
            next();
            code = text.charCodeAt(index);
        } // Must begin with [a-zA-Z]
        code = unitName.charCodeAt(0);
        if (code >= 65 && code <= 90 || code >= 97 && code <= 122) return unitName || null;
        else return null;
    }
    function parseCharacter(toFind) {
        if (c === toFind) {
            next();
            return toFind;
        } else return null;
    }
    /**
   * Parse a string into a unit. The value of the unit is parsed as number,
   * BigNumber, or Fraction depending on the math.js config setting `number`.
   *
   * Throws an exception if the provided string does not contain a valid unit or
   * cannot be parsed.
   * @memberof Unit
   * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
   * @return {Unit} unit
   */ Unit.parse = function(str, options) {
        options = options || {};
        text = str;
        index = -1;
        c = "";
        if (typeof text !== "string") throw new TypeError("Invalid argument in Unit.parse, string expected");
        var unit = new Unit();
        unit.units = [];
        var powerMultiplierCurrent = 1;
        var expectingUnit = false; // A unit should follow this pattern:
        // [number] ...[ [*/] unit[^number] ]
        // unit[^number] ... [ [*/] unit[^number] ]
        // Rules:
        // number is any floating point number.
        // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
        // The string may optionally begin with a number.
        // Each unit may optionally be followed by ^number.
        // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
        //   2m^2kg/s^2
        // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
        //   4erg
        next();
        skipWhitespace(); // Optional number at the start of the string
        var valueStr = parseNumber();
        var value = null;
        if (valueStr) {
            if (config.number === "BigNumber") value = new _BigNumber(valueStr);
            else if (config.number === "Fraction") try {
                // not all numbers can be turned in Fractions, for example very small numbers not
                value = new _Fraction(valueStr);
            } catch (err) {
                value = parseFloat(valueStr);
            }
            else // number
            value = parseFloat(valueStr);
            skipWhitespace(); // Whitespace is not required here
            // handle multiplication or division right after the value, like '1/s'
            if (parseCharacter("*")) {
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            }
        } // Stack to keep track of powerMultipliers applied to each parentheses group
        var powerMultiplierStack = []; // Running product of all elements in powerMultiplierStack
        var powerMultiplierStackProduct = 1;
        while(true){
            skipWhitespace(); // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
            // A '(' will always appear directly before a unit.
            while(c === "("){
                powerMultiplierStack.push(powerMultiplierCurrent);
                powerMultiplierStackProduct *= powerMultiplierCurrent;
                powerMultiplierCurrent = 1;
                next();
                skipWhitespace();
            } // Is there something here?
            var uStr = void 0;
            if (c) {
                var oldC = c;
                uStr = parseUnit();
                if (uStr === null) throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
            } else break;
             // Verify the unit exists and get the prefix (if any)
            var res = _findUnit(uStr);
            if (res === null) // Unit not found.
            throw new SyntaxError('Unit "' + uStr + '" not found.');
            var power = powerMultiplierCurrent * powerMultiplierStackProduct; // Is there a "^ number"?
            skipWhitespace();
            if (parseCharacter("^")) {
                skipWhitespace();
                var p = parseNumber();
                if (p === null) // No valid number found for the power!
                throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
                power *= p;
            } // Add the unit to the list
            unit.units.push({
                unit: res.unit,
                prefix: res.prefix,
                power: power
            });
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
             // Check for and consume closing parentheses, popping from the stack.
            // A ')' will always follow a unit.
            skipWhitespace();
            while(c === ")"){
                if (powerMultiplierStack.length === 0) throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
                powerMultiplierStackProduct /= powerMultiplierStack.pop();
                next();
                skipWhitespace();
            } // "*" and "/" should mean we are expecting something to come next.
            // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
            expectingUnit = false;
            if (parseCharacter("*")) {
                // explicit multiplication
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                // division
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            } else // implicit multiplication
            powerMultiplierCurrent = 1;
             // Replace the unit into the auto unit system
            if (res.unit.base) {
                var baseDim = res.unit.base.key;
                UNIT_SYSTEMS.auto[baseDim] = {
                    unit: res.unit,
                    prefix: res.prefix
                };
            }
        } // Has the string been entirely consumed?
        skipWhitespace();
        if (c) throw new SyntaxError('Could not parse: "' + str + '"');
         // Is there a trailing slash?
        if (expectingUnit) throw new SyntaxError('Trailing characters: "' + str + '"');
         // Is the parentheses stack empty?
        if (powerMultiplierStack.length !== 0) throw new SyntaxError('Unmatched "(" in "' + text + '"');
         // Are there any units at all?
        if (unit.units.length === 0 && !options.allowNoUnits) throw new SyntaxError('"' + str + '" contains no units');
        unit.value = value !== undefined ? unit._normalize(value) : null;
        return unit;
    };
    /**
   * create a copy of this unit
   * @memberof Unit
   * @return {Unit} Returns a cloned version of the unit
   */ Unit.prototype.clone = function() {
        var unit = new Unit();
        unit.fixPrefix = this.fixPrefix;
        unit.skipAutomaticSimplification = this.skipAutomaticSimplification;
        unit.value = (0, $glBd7.clone)(this.value);
        unit.dimensions = this.dimensions.slice(0);
        unit.units = [];
        for(var i = 0; i < this.units.length; i++){
            unit.units[i] = {};
            for(var p in this.units[i])if ((0, $glBd7.hasOwnProperty)(this.units[i], p)) unit.units[i][p] = this.units[i][p];
        }
        return unit;
    };
    /**
   * Return whether the unit is derived (such as m/s, or cm^2, but not N)
   * @memberof Unit
   * @return {boolean} True if the unit is derived
   */ Unit.prototype._isDerived = function() {
        if (this.units.length === 0) return false;
        return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
    };
    /**
   * Normalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number | BigNumber | Fraction | boolean} value
   * @return {number | BigNumber | Fraction | boolean} normalized value
   * @private
   */ Unit.prototype._normalize = function(value) {
        var unitValue, unitOffset, unitPower, unitPrefixValue;
        var convert;
        if (value === null || value === undefined || this.units.length === 0) return value;
        else if (this._isDerived()) {
            // This is a derived unit, so do not apply offsets.
            // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
            var res = value;
            convert = Unit._getNumberConverter((0, $7E0JQ.typeOf)(value)); // convert to Fraction or BigNumber if needed
            for(var i = 0; i < this.units.length; i++){
                unitValue = convert(this.units[i].unit.value);
                unitPrefixValue = convert(this.units[i].prefix.value);
                unitPower = convert(this.units[i].power);
                res = multiplyScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
            }
            return res;
        } else {
            // This is a single unit of power 1, like kg or degC
            convert = Unit._getNumberConverter((0, $7E0JQ.typeOf)(value)); // convert to Fraction or BigNumber if needed
            unitValue = convert(this.units[0].unit.value);
            unitOffset = convert(this.units[0].unit.offset);
            unitPrefixValue = convert(this.units[0].prefix.value);
            return multiplyScalar(addScalar(value, unitOffset), multiplyScalar(unitValue, unitPrefixValue));
        }
    };
    /**
   * Denormalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number} value
   * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
   * @return {number} denormalized value
   * @private
   */ Unit.prototype._denormalize = function(value, prefixValue) {
        var unitValue, unitOffset, unitPower, unitPrefixValue;
        var convert;
        if (value === null || value === undefined || this.units.length === 0) return value;
        else if (this._isDerived()) {
            // This is a derived unit, so do not apply offsets.
            // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
            // Also, prefixValue is ignored--but we will still use the prefix value stored in each unit, since kg is usually preferable to g unless the user decides otherwise.
            var res = value;
            convert = Unit._getNumberConverter((0, $7E0JQ.typeOf)(value)); // convert to Fraction or BigNumber if needed
            for(var i = 0; i < this.units.length; i++){
                unitValue = convert(this.units[i].unit.value);
                unitPrefixValue = convert(this.units[i].prefix.value);
                unitPower = convert(this.units[i].power);
                res = divideScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
            }
            return res;
        } else {
            // This is a single unit of power 1, like kg or degC
            convert = Unit._getNumberConverter((0, $7E0JQ.typeOf)(value)); // convert to Fraction or BigNumber if needed
            unitValue = convert(this.units[0].unit.value);
            unitPrefixValue = convert(this.units[0].prefix.value);
            unitOffset = convert(this.units[0].unit.offset);
            if (prefixValue === undefined || prefixValue === null) return subtract(divideScalar(divideScalar(value, unitValue), unitPrefixValue), unitOffset);
            else return subtract(divideScalar(divideScalar(value, unitValue), prefixValue), unitOffset);
        }
    };
    /**
   * Find a unit from a string
   * @memberof Unit
   * @param {string} str              A string like 'cm' or 'inch'
   * @returns {Object | null} result  When found, an object with fields unit and
   *                                  prefix is returned. Else, null is returned.
   * @private
   */ function _findUnit(str) {
        // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
        if ((0, $glBd7.hasOwnProperty)(UNITS, str)) {
            var unit = UNITS[str];
            var prefix = unit.prefixes[""];
            return {
                unit: unit,
                prefix: prefix
            };
        }
        for(var _name in UNITS){
            if ((0, $glBd7.hasOwnProperty)(UNITS, _name)) {
                if ((0, $7HWRb.endsWith)(str, _name)) {
                    var _unit = UNITS[_name];
                    var prefixLen = str.length - _name.length;
                    var prefixName = str.substring(0, prefixLen);
                    var _prefix = (0, $glBd7.hasOwnProperty)(_unit.prefixes, prefixName) ? _unit.prefixes[prefixName] : undefined;
                    if (_prefix !== undefined) // store unit, prefix, and value
                    return {
                        unit: _unit,
                        prefix: _prefix
                    };
                }
            }
        }
        return null;
    }
    /**
   * Test if the given expression is a unit.
   * The unit can have a prefix but cannot have a value.
   * @memberof Unit
   * @param {string} name   A string to be tested whether it is a value less unit.
   *                        The unit can have prefix, like "cm"
   * @return {boolean}      true if the given string is a unit
   */ Unit.isValuelessUnit = function(name) {
        return _findUnit(name) !== null;
    };
    /**
   * check if this unit has given base unit
   * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
   * @memberof Unit
   * @param {BASE_UNITS | string | undefined} base
   */ Unit.prototype.hasBase = function(base) {
        if (typeof base === "string") base = BASE_UNITS[base];
        if (!base) return false;
         // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit has a base or bases equal to another base or bases
   * For derived units, the exponent on each base also must match
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if equal base
   */ Unit.prototype.equalBase = function(other) {
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit equals another unit
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if both units are equal
   */ Unit.prototype.equals = function(other) {
        return this.equalBase(other) && equal(this.value, other.value);
    };
    /**
   * Multiply this unit with another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} product of this unit and the other unit
   */ Unit.prototype.multiply = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
         // Append other's units list onto res
        for(var _i = 0; _i < other.units.length; _i++){
            // Make a deep copy
            var inverted = {};
            for(var key in other.units[_i])inverted[key] = other.units[_i][key];
            res.units.push(inverted);
        } // If at least one operand has a value, then the result should also have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = multiplyScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Divide this unit by another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} result of dividing this unit by the other unit
   */ Unit.prototype.divide = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
         // Invert and append other's units list onto res
        for(var _i2 = 0; _i2 < other.units.length; _i2++){
            // Make a deep copy
            var inverted = {};
            for(var key in other.units[_i2])inverted[key] = other.units[_i2][key];
            inverted.power = -inverted.power;
            res.units.push(inverted);
        } // If at least one operand has a value, the result should have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = divideScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Calculate the power of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} p
   * @returns {Unit}      The result: this^p
   */ Unit.prototype.pow = function(p) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) * p;
         // Adjust the power of each unit in the list
        for(var _i3 = 0; _i3 < res.units.length; _i3++)res.units[_i3].power *= p;
        if (res.value !== null) res.value = pow(res.value, p); // only allow numeric output, we don't want to return a Complex number
        else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
   * @param {Unit} unit
   * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
   */ function getNumericIfUnitless(unit) {
        if (unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) return unit.value;
        else return unit;
    }
    /**
   * Calculate the absolute value of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} x
   * @returns {Unit}      The result: |x|, absolute value of x
   */ Unit.prototype.abs = function() {
        // This gives correct, but unexpected, results for units with an offset.
        // For example, abs(-283.15 degC) = -263.15 degC !!!
        var ret = this.clone();
        ret.value = ret.value !== null ? abs(ret.value) : null;
        for(var i in ret.units)if (ret.units[i].unit.name === "VA" || ret.units[i].unit.name === "VAR") ret.units[i].unit = UNITS.W;
        return ret;
    };
    /**
   * Convert the unit to a specific unit name.
   * @memberof Unit
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
   */ Unit.prototype.to = function(valuelessUnit) {
        var other;
        var value = this.value === null ? this._normalize(1) : this.value;
        if (typeof valuelessUnit === "string") {
            // other = new Unit(null, valuelessUnit)
            other = Unit.parse(valuelessUnit);
            if (!this.equalBase(other)) throw new Error("Units do not match ('".concat(other.toString(), "' != '").concat(this.toString(), "')"));
            if (other.value !== null) throw new Error("Cannot convert to a unit with a value");
            other.value = (0, $glBd7.clone)(value);
            other.fixPrefix = true;
            other.skipAutomaticSimplification = true;
            return other;
        } else if ((0, $7E0JQ.isUnit)(valuelessUnit)) {
            if (!this.equalBase(valuelessUnit)) throw new Error("Units do not match ('".concat(valuelessUnit.toString(), "' != '").concat(this.toString(), "')"));
            if (valuelessUnit.value !== null) throw new Error("Cannot convert to a unit with a value");
            other = valuelessUnit.clone();
            other.value = (0, $glBd7.clone)(value);
            other.fixPrefix = true;
            other.skipAutomaticSimplification = true;
            return other;
        } else throw new Error("String or Unit expected as parameter");
    };
    /**
   * Return the value of the unit when represented with given valueless unit
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number} Returns the unit value as number.
   */ // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
    Unit.prototype.toNumber = function(valuelessUnit) {
        return toNumber(this.toNumeric(valuelessUnit));
    };
    /**
   * Return the value of the unit in the original numeric type
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number | BigNumber | Fraction} Returns the unit value
   */ Unit.prototype.toNumeric = function(valuelessUnit) {
        var other;
        if (valuelessUnit) // Allow getting the numeric value without converting to a different unit
        other = this.to(valuelessUnit);
        else other = this.clone();
        if (other._isDerived() || other.units.length === 0) return other._denormalize(other.value);
        else return other._denormalize(other.value, other.units[0].prefix.value);
    };
    /**
   * Get a string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the unit
   * @memberof Unit
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   */ Unit.prototype.toJSON = function() {
        return {
            mathjs: "Unit",
            value: this._denormalize(this.value),
            unit: this.formatUnits(),
            fixPrefix: this.fixPrefix
        };
    };
    /**
   * Instantiate a Unit from a JSON object
   * @memberof Unit
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   * @return {Unit}
   */ Unit.fromJSON = function(json) {
        var unit = new Unit(json.value, json.unit);
        unit.fixPrefix = json.fixPrefix || false;
        return unit;
    };
    /**
   * Returns the string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.valueOf = Unit.prototype.toString;
    /**
   * Simplify this Unit's unit list and return a new Unit with the simplified list.
   * The returned Unit will contain a list of the "best" units for formatting.
   */ Unit.prototype.simplify = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Search for a matching base
        var matchingBase;
        for(var key in currentUnitSystem)if (ret.hasBase(BASE_UNITS[key])) {
            matchingBase = key;
            break;
        }
        if (matchingBase === "NONE") ret.units = [];
        else {
            var matchingUnit;
            if (matchingBase) // Does the unit system have a matching unit?
            {
                if ((0, $glBd7.hasOwnProperty)(currentUnitSystem, matchingBase)) matchingUnit = currentUnitSystem[matchingBase];
            }
            if (matchingUnit) ret.units = [
                {
                    unit: matchingUnit.unit,
                    prefix: matchingUnit.prefix,
                    power: 1.0
                }
            ];
            else {
                // Multiple units or units with powers are formatted like this:
                // 5 (kg m^2) / (s^3 mol)
                // Build an representation from the base units of the current unit system
                var missingBaseDim = false;
                for(var i = 0; i < BASE_DIMENSIONS.length; i++){
                    var baseDim = BASE_DIMENSIONS[i];
                    if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                        if ((0, $glBd7.hasOwnProperty)(currentUnitSystem, baseDim)) proposedUnitList.push({
                            unit: currentUnitSystem[baseDim].unit,
                            prefix: currentUnitSystem[baseDim].prefix,
                            power: ret.dimensions[i] || 0
                        });
                        else missingBaseDim = true;
                    }
                } // Is the proposed unit list "simpler" than the existing one?
                if (proposedUnitList.length < ret.units.length && !missingBaseDim) // Replace this unit list with the proposed list
                ret.units = proposedUnitList;
            }
        }
        return ret;
    };
    /**
   * Returns a new Unit in the SI system with the same value as this one
   */ Unit.prototype.toSI = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Multiple units or units with powers are formatted like this:
        // 5 (kg m^2) / (s^3 mol)
        // Build an representation from the base units of the SI unit system
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            var baseDim = BASE_DIMENSIONS[i];
            if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                if ((0, $glBd7.hasOwnProperty)(UNIT_SYSTEMS.si, baseDim)) proposedUnitList.push({
                    unit: UNIT_SYSTEMS.si[baseDim].unit,
                    prefix: UNIT_SYSTEMS.si[baseDim].prefix,
                    power: ret.dimensions[i] || 0
                });
                else throw new Error("Cannot express custom unit " + baseDim + " in SI units");
            }
        } // Replace this unit list with the proposed list
        ret.units = proposedUnitList;
        ret.fixPrefix = true;
        ret.skipAutomaticSimplification = true;
        return ret;
    };
    /**
   * Get a string representation of the units of this Unit, without the value. The unit list is formatted as-is without first being simplified.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.formatUnits = function() {
        var strNum = "";
        var strDen = "";
        var nNum = 0;
        var nDen = 0;
        for(var i = 0; i < this.units.length; i++){
            if (this.units[i].power > 0) {
                nNum++;
                strNum += " " + this.units[i].prefix.name + this.units[i].unit.name;
                if (Math.abs(this.units[i].power - 1.0) > 1e-15) strNum += "^" + this.units[i].power;
            } else if (this.units[i].power < 0) nDen++;
        }
        if (nDen > 0) {
            for(var _i4 = 0; _i4 < this.units.length; _i4++)if (this.units[_i4].power < 0) {
                if (nNum > 0) {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    if (Math.abs(this.units[_i4].power + 1.0) > 1e-15) strDen += "^" + -this.units[_i4].power;
                } else {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    strDen += "^" + this.units[_i4].power;
                }
            }
        } // Remove leading " "
        strNum = strNum.substr(1);
        strDen = strDen.substr(1); // Add parans for better copy/paste back into evaluate, for example, or for better pretty print formatting
        if (nNum > 1 && nDen > 0) strNum = "(" + strNum + ")";
        if (nDen > 1 && nNum > 0) strDen = "(" + strDen + ")";
        var str = strNum;
        if (nNum > 0 && nDen > 0) str += " / ";
        str += strDen;
        return str;
    };
    /**
   * Get a string representation of the Unit, with optional formatting options.
   * @memberof Unit
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string}
   */ Unit.prototype.format = function(options) {
        // Simplfy the unit list, unless it is valueless or was created directly in the
        // constructor or as the result of to or toSI
        var simp = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(); // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
        var isImaginary = false;
        if (typeof simp.value !== "undefined" && simp.value !== null && (0, $7E0JQ.isComplex)(simp.value)) // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
        isImaginary = Math.abs(simp.value.re) < 1e-14;
        for(var i in simp.units)if (simp.units[i].unit) {
            if (simp.units[i].unit.name === "VA" && isImaginary) simp.units[i].unit = UNITS.VAR;
            else if (simp.units[i].unit.name === "VAR" && !isImaginary) simp.units[i].unit = UNITS.VA;
        }
         // Now apply the best prefix
        // Units must have only one unit and not have the fixPrefix flag set
        if (simp.units.length === 1 && !simp.fixPrefix) // Units must have integer powers, otherwise the prefix will change the
        // outputted value by not-an-integer-power-of-ten
        {
            if (Math.abs(simp.units[0].power - Math.round(simp.units[0].power)) < 1e-14) // Apply the best prefix
            simp.units[0].prefix = simp._bestPrefix();
        }
        var value = simp._denormalize(simp.value);
        var str = simp.value !== null ? format(value, options || {}) : "";
        var unitStr = simp.formatUnits();
        if (simp.value && (0, $7E0JQ.isComplex)(simp.value)) str = "(" + str + ")"; // Surround complex values with ( ) to enable better parsing
        if (unitStr.length > 0 && str.length > 0) str += " ";
        str += unitStr;
        return str;
    };
    /**
   * Calculate the best prefix using current value.
   * @memberof Unit
   * @returns {Object} prefix
   * @private
   */ Unit.prototype._bestPrefix = function() {
        if (this.units.length !== 1) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
         // find the best prefix value (resulting in the value of which
        // the absolute value of the log10 is closest to zero,
        // though with a little offset of 1.2 for nicer values: you get a
        // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...
        // Note: the units value can be any numeric type, but to find the best
        // prefix it's enough to work with limited precision of a regular number
        // Update: using mathjs abs since we also allow complex numbers
        var absValue = this.value !== null ? abs(this.value) : 0;
        var absUnitValue = abs(this.units[0].unit.value);
        var bestPrefix = this.units[0].prefix;
        if (absValue === 0) return bestPrefix;
        var power = this.units[0].power;
        var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - 1.2;
        if (bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix; // Allow the original prefix
        bestDiff = Math.abs(bestDiff);
        var prefixes = this.units[0].unit.prefixes;
        for(var p in prefixes)if ((0, $glBd7.hasOwnProperty)(prefixes, p)) {
            var prefix = prefixes[p];
            if (prefix.scientific) {
                var diff = Math.abs(Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - 1.2);
                if (diff < bestDiff || diff === bestDiff && prefix.name.length < bestPrefix.name.length) {
                    // choose the prefix with the smallest diff, or if equal, choose the one
                    // with the shortest name (can happen with SHORTLONG for example)
                    bestPrefix = prefix;
                    bestDiff = diff;
                }
            }
        }
        return bestPrefix;
    };
    /**
   * Returns an array of units whose sum is equal to this unit
   * @memberof Unit
   * @param {Array} [parts] An array of strings or valueless units.
   *
   *   Example:
   *
   *   const u = new Unit(1, 'm')
   *   u.splitUnit(['feet', 'inch'])
   *     [ 3 feet, 3.3700787401575 inch ]
   *
   * @return {Array} An array of units.
   */ Unit.prototype.splitUnit = function(parts) {
        var x = this.clone();
        var ret = [];
        for(var i = 0; i < parts.length; i++){
            // Convert x to the requested unit
            x = x.to(parts[i]);
            if (i === parts.length - 1) break; // Get the numeric value of this unit
            var xNumeric = x.toNumeric(); // Check to see if xNumeric is nearly equal to an integer,
            // since fix can incorrectly round down if there is round-off error
            var xRounded = round(xNumeric);
            var xFixed = void 0;
            var isNearlyEqual = equal(xRounded, xNumeric);
            if (isNearlyEqual) xFixed = xRounded;
            else xFixed = fix(x.toNumeric());
            var y = new Unit(xFixed, parts[i].toString());
            ret.push(y);
            x = subtract(x, y);
        } // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
        // But instead of comparing x, the remainder, with zero--we will compare the sum of
        // all the parts so far with the original value. If they are nearly equal,
        // we set the remainder to 0.
        var testSum = 0;
        for(var _i5 = 0; _i5 < ret.length; _i5++)testSum = addScalar(testSum, ret[_i5].value);
        if (equal(testSum, this.value)) x.value = 0;
        ret.push(x);
        return ret;
    };
    var PREFIXES = {
        NONE: {
            "": {
                name: "",
                value: 1,
                scientific: true
            }
        },
        SHORT: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e1,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e2,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-1,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-2,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-3,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-6,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-9,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-12,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-15,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-18,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-21,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-24,
                scientific: true
            }
        },
        LONG: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            deca: {
                name: "deca",
                value: 1e1,
                scientific: false
            },
            hecto: {
                name: "hecto",
                value: 1e2,
                scientific: false
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            },
            deci: {
                name: "deci",
                value: 1e-1,
                scientific: false
            },
            centi: {
                name: "centi",
                value: 1e-2,
                scientific: false
            },
            milli: {
                name: "milli",
                value: 1e-3,
                scientific: true
            },
            micro: {
                name: "micro",
                value: 1e-6,
                scientific: true
            },
            nano: {
                name: "nano",
                value: 1e-9,
                scientific: true
            },
            pico: {
                name: "pico",
                value: 1e-12,
                scientific: true
            },
            femto: {
                name: "femto",
                value: 1e-15,
                scientific: true
            },
            atto: {
                name: "atto",
                value: 1e-18,
                scientific: true
            },
            zepto: {
                name: "zepto",
                value: 1e-21,
                scientific: true
            },
            yocto: {
                name: "yocto",
                value: 1e-24,
                scientific: true
            }
        },
        SQUARED: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e2,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e4,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e6,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e12,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e18,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e24,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e30,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e36,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e42,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e48,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-2,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-4,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-6,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-12,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-18,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-24,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-30,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-36,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-42,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-48,
                scientific: true
            }
        },
        CUBIC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e3,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e6,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e9,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e18,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e27,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e36,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e45,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e54,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e63,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e72,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-3,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-6,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-9,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-18,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-27,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-36,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-45,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-54,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-63,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-72,
                scientific: true
            }
        },
        BINARY_SHORT_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_SHORT_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            Ki: {
                name: "Ki",
                value: 1024,
                scientific: true
            },
            Mi: {
                name: "Mi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            Gi: {
                name: "Gi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            Ti: {
                name: "Ti",
                value: Math.pow(1024, 4),
                scientific: true
            },
            Pi: {
                name: "Pi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            Ei: {
                name: "Ei",
                value: Math.pow(1024, 6),
                scientific: true
            },
            Zi: {
                name: "Zi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            Yi: {
                name: "Yi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BINARY_LONG_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_LONG_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kibi: {
                name: "kibi",
                value: 1024,
                scientific: true
            },
            mebi: {
                name: "mebi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            gibi: {
                name: "gibi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            tebi: {
                name: "tebi",
                value: Math.pow(1024, 4),
                scientific: true
            },
            pebi: {
                name: "pebi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            exi: {
                name: "exi",
                value: Math.pow(1024, 6),
                scientific: true
            },
            zebi: {
                name: "zebi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            yobi: {
                name: "yobi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BTU: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            MM: {
                name: "MM",
                value: 1e6,
                scientific: true
            }
        }
    };
    PREFIXES.SHORTLONG = $9c5a6e4bc073984d$var$_extends({}, PREFIXES.SHORT, PREFIXES.LONG);
    PREFIXES.BINARY_SHORT = $9c5a6e4bc073984d$var$_extends({}, PREFIXES.BINARY_SHORT_SI, PREFIXES.BINARY_SHORT_IEC);
    PREFIXES.BINARY_LONG = $9c5a6e4bc073984d$var$_extends({}, PREFIXES.BINARY_LONG_SI, PREFIXES.BINARY_LONG_IEC);
    /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
   * Index  Dimension
   * -----  ---------
   *   0    Length
   *   1    Mass
   *   2    Time
   *   3    Current
   *   4    Temperature
   *   5    Luminous intensity
   *   6    Amount of substance
   *   7    Angle
   *   8    Bit (digital)
   * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
   *
   */ var BASE_DIMENSIONS = [
        "MASS",
        "LENGTH",
        "TIME",
        "CURRENT",
        "TEMPERATURE",
        "LUMINOUS_INTENSITY",
        "AMOUNT_OF_SUBSTANCE",
        "ANGLE",
        "BIT"
    ];
    var BASE_UNITS = {
        NONE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MASS: {
            dimensions: [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        LENGTH: {
            dimensions: [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TIME: {
            dimensions: [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        CURRENT: {
            dimensions: [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TEMPERATURE: {
            dimensions: [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0
            ]
        },
        LUMINOUS_INTENSITY: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0
            ]
        },
        AMOUNT_OF_SUBSTANCE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0
            ]
        },
        FORCE: {
            dimensions: [
                1,
                1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        SURFACE: {
            dimensions: [
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        VOLUME: {
            dimensions: [
                0,
                3,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ENERGY: {
            dimensions: [
                1,
                2,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        POWER: {
            dimensions: [
                1,
                2,
                -3,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        PRESSURE: {
            dimensions: [
                1,
                -1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CHARGE: {
            dimensions: [
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CAPACITANCE: {
            dimensions: [
                -1,
                -2,
                4,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_POTENTIAL: {
            dimensions: [
                1,
                2,
                -3,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_RESISTANCE: {
            dimensions: [
                1,
                2,
                -3,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_INDUCTANCE: {
            dimensions: [
                1,
                2,
                -2,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CONDUCTANCE: {
            dimensions: [
                -1,
                -2,
                3,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX: {
            dimensions: [
                1,
                2,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX_DENSITY: {
            dimensions: [
                1,
                0,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        FREQUENCY: {
            dimensions: [
                0,
                0,
                -1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ANGLE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        },
        BIT: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]
        }
    };
    for(var key in BASE_UNITS)BASE_UNITS[key].key = key;
    var BASE_UNIT_NONE = {};
    var UNIT_NONE = {
        name: "",
        base: BASE_UNIT_NONE,
        value: 1,
        offset: 0,
        dimensions: BASE_DIMENSIONS.map(function(x) {
            return 0;
        })
    };
    var UNITS = {
        // length
        meter: {
            name: "meter",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        inch: {
            name: "inch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        foot: {
            name: "foot",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yard: {
            name: "yard",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mile: {
            name: "mile",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        link: {
            name: "link",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rod: {
            name: "rod",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.0292,
            offset: 0
        },
        chain: {
            name: "chain",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        angstrom: {
            name: "angstrom",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1e-10,
            offset: 0
        },
        m: {
            name: "m",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        "in": {
            name: "in",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        ft: {
            name: "ft",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yd: {
            name: "yd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mi: {
            name: "mi",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        li: {
            name: "li",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rd: {
            name: "rd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.029210,
            offset: 0
        },
        ch: {
            name: "ch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        mil: {
            name: "mil",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0000254,
            offset: 0
        },
        // 1/1000 inch
        // Surface
        m2: {
            name: "m2",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.SQUARED,
            value: 1,
            offset: 0
        },
        sqin: {
            name: "sqin",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.00064516,
            offset: 0
        },
        // 645.16 mm2
        sqft: {
            name: "sqft",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.09290304,
            offset: 0
        },
        // 0.09290304 m2
        sqyd: {
            name: "sqyd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.83612736,
            offset: 0
        },
        // 0.83612736 m2
        sqmi: {
            name: "sqmi",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 2589988.110336,
            offset: 0
        },
        // 2.589988110336 km2
        sqrd: {
            name: "sqrd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 25.29295,
            offset: 0
        },
        // 25.29295 m2
        sqch: {
            name: "sqch",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 404.6873,
            offset: 0
        },
        // 404.6873 m2
        sqmil: {
            name: "sqmil",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 6.4516e-10,
            offset: 0
        },
        // 6.4516 * 10^-10 m2
        acre: {
            name: "acre",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 4046.86,
            offset: 0
        },
        // 4046.86 m2
        hectare: {
            name: "hectare",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 10000,
            offset: 0
        },
        // 10000 m2
        // Volume
        m3: {
            name: "m3",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.CUBIC,
            value: 1,
            offset: 0
        },
        L: {
            name: "L",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        l: {
            name: "l",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        litre: {
            name: "litre",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        cuin: {
            name: "cuin",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1.6387064e-5,
            offset: 0
        },
        // 1.6387064e-5 m3
        cuft: {
            name: "cuft",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.028316846592,
            offset: 0
        },
        // 28.316 846 592 L
        cuyd: {
            name: "cuyd",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.764554857984,
            offset: 0
        },
        // 764.554 857 984 L
        teaspoon: {
            name: "teaspoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000005,
            offset: 0
        },
        // 5 mL
        tablespoon: {
            name: "tablespoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000015,
            offset: 0
        },
        // 15 mL
        // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
        drop: {
            name: "drop",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        gtt: {
            name: "gtt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        // Liquid volume
        minim: {
            name: "minim",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00000006161152,
            offset: 0
        },
        // 0.06161152 mL
        fluiddram: {
            name: "fluiddram",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        fluidounce: {
            name: "fluidounce",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gill: {
            name: "gill",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cc: {
            name: "cc",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1e-6,
            offset: 0
        },
        // 1e-6 L
        cup: {
            name: "cup",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pint: {
            name: "pint",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        quart: {
            name: "quart",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gallon: {
            name: "gallon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        beerbarrel: {
            name: "beerbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        oilbarrel: {
            name: "oilbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        hogshead: {
            name: "hogshead",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.2384810,
            offset: 0
        },
        // 238.4810 L
        // {name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
        fldr: {
            name: "fldr",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        floz: {
            name: "floz",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gi: {
            name: "gi",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cp: {
            name: "cp",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pt: {
            name: "pt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        qt: {
            name: "qt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gal: {
            name: "gal",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        bbl: {
            name: "bbl",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        obl: {
            name: "obl",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        // {name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
        // Mass
        g: {
            name: "g",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        gram: {
            name: "gram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        ton: {
            name: "ton",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 907.18474,
            offset: 0
        },
        t: {
            name: "t",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 1000,
            offset: 0
        },
        tonne: {
            name: "tonne",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 1000,
            offset: 0
        },
        grain: {
            name: "grain",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dram: {
            name: "dram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        ounce: {
            name: "ounce",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        poundmass: {
            name: "poundmass",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        hundredweight: {
            name: "hundredweight",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        stick: {
            name: "stick",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 115e-3,
            offset: 0
        },
        stone: {
            name: "stone",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 6.35029318,
            offset: 0
        },
        gr: {
            name: "gr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dr: {
            name: "dr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        oz: {
            name: "oz",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        lbm: {
            name: "lbm",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        cwt: {
            name: "cwt",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        // Time
        s: {
            name: "s",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        min: {
            name: "min",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        h: {
            name: "h",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        second: {
            name: "second",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        sec: {
            name: "sec",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        minute: {
            name: "minute",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        hour: {
            name: "hour",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        day: {
            name: "day",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 86400,
            offset: 0
        },
        week: {
            name: "week",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 604800,
            offset: 0
        },
        month: {
            name: "month",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 2629800,
            // 1/12th of Julian year
            offset: 0
        },
        year: {
            name: "year",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600,
            // Julian year
            offset: 0
        },
        decade: {
            name: "decade",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 315576000,
            // Julian decade
            offset: 0
        },
        century: {
            name: "century",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3155760000,
            // Julian century
            offset: 0
        },
        millennium: {
            name: "millennium",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600000,
            // Julian millennium
            offset: 0
        },
        // Frequency
        hertz: {
            name: "Hertz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        Hz: {
            name: "Hz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        // Angle
        rad: {
            name: "rad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        radian: {
            name: "radian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
        deg: {
            name: "deg",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        degree: {
            name: "degree",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
        grad: {
            name: "grad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        gradian: {
            name: "gradian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
        cycle: {
            name: "cycle",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
        arcsec: {
            name: "arcsec",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
        arcmin: {
            name: "arcmin",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // Electric current
        A: {
            name: "A",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        ampere: {
            name: "ampere",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // Temperature
        // K(C) = °C + 273.15
        // K(F) = (°F + 459.67) / 1.8
        // K(R) = °R / 1.8
        K: {
            name: "K",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        degC: {
            name: "degC",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        degF: {
            name: "degF",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        degR: {
            name: "degR",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        kelvin: {
            name: "kelvin",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        celsius: {
            name: "celsius",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        fahrenheit: {
            name: "fahrenheit",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        rankine: {
            name: "rankine",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        // amount of substance
        mol: {
            name: "mol",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        mole: {
            name: "mole",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // luminous intensity
        cd: {
            name: "cd",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        candela: {
            name: "candela",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // TODO: units STERADIAN
        // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // Force
        N: {
            name: "N",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        newton: {
            name: "newton",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        dyn: {
            name: "dyn",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 0.00001,
            offset: 0
        },
        dyne: {
            name: "dyne",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 0.00001,
            offset: 0
        },
        lbf: {
            name: "lbf",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        poundforce: {
            name: "poundforce",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        kip: {
            name: "kip",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 4448.2216,
            offset: 0
        },
        // Energy
        J: {
            name: "J",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        joule: {
            name: "joule",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        erg: {
            name: "erg",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.NONE,
            value: 1e-7,
            offset: 0
        },
        Wh: {
            name: "Wh",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 3600,
            offset: 0
        },
        BTU: {
            name: "BTU",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.BTU,
            value: 1055.05585262,
            offset: 0
        },
        eV: {
            name: "eV",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1.602176565e-19,
            offset: 0
        },
        electronvolt: {
            name: "electronvolt",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1.602176565e-19,
            offset: 0
        },
        // Power
        W: {
            name: "W",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        watt: {
            name: "watt",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        hp: {
            name: "hp",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.NONE,
            value: 745.6998715386,
            offset: 0
        },
        // Electrical power units
        VAR: {
            name: "VAR",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: Complex.I,
            offset: 0
        },
        VA: {
            name: "VA",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Pressure
        Pa: {
            name: "Pa",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        psi: {
            name: "psi",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 6894.75729276459,
            offset: 0
        },
        atm: {
            name: "atm",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 101325,
            offset: 0
        },
        bar: {
            name: "bar",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORTLONG,
            value: 100000,
            offset: 0
        },
        torr: {
            name: "torr",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmHg: {
            name: "mmHg",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmH2O: {
            name: "mmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        cmH2O: {
            name: "cmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 98.0665,
            offset: 0
        },
        // Electric charge
        coulomb: {
            name: "coulomb",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        C: {
            name: "C",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric capacitance
        farad: {
            name: "farad",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        F: {
            name: "F",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric potential
        volt: {
            name: "volt",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        V: {
            name: "V",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric resistance
        ohm: {
            name: "ohm",
            base: BASE_UNITS.ELECTRIC_RESISTANCE,
            prefixes: PREFIXES.SHORTLONG,
            // Both Mohm and megaohm are acceptable
            value: 1,
            offset: 0
        },
        /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */ // Electric inductance
        henry: {
            name: "henry",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        H: {
            name: "H",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric conductance
        siemens: {
            name: "siemens",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        S: {
            name: "S",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux
        weber: {
            name: "weber",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        Wb: {
            name: "Wb",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux density
        tesla: {
            name: "tesla",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        T: {
            name: "T",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Binary
        b: {
            name: "b",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 1,
            offset: 0
        },
        bits: {
            name: "bits",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 1,
            offset: 0
        },
        B: {
            name: "B",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 8,
            offset: 0
        },
        bytes: {
            name: "bytes",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 8,
            offset: 0
        }
    }; // aliases (formerly plurals)
    var ALIASES = {
        meters: "meter",
        inches: "inch",
        feet: "foot",
        yards: "yard",
        miles: "mile",
        links: "link",
        rods: "rod",
        chains: "chain",
        angstroms: "angstrom",
        lt: "l",
        litres: "litre",
        liter: "litre",
        liters: "litre",
        teaspoons: "teaspoon",
        tablespoons: "tablespoon",
        minims: "minim",
        fluiddrams: "fluiddram",
        fluidounces: "fluidounce",
        gills: "gill",
        cups: "cup",
        pints: "pint",
        quarts: "quart",
        gallons: "gallon",
        beerbarrels: "beerbarrel",
        oilbarrels: "oilbarrel",
        hogsheads: "hogshead",
        gtts: "gtt",
        grams: "gram",
        tons: "ton",
        tonnes: "tonne",
        grains: "grain",
        drams: "dram",
        ounces: "ounce",
        poundmasses: "poundmass",
        hundredweights: "hundredweight",
        sticks: "stick",
        lb: "lbm",
        lbs: "lbm",
        kips: "kip",
        acres: "acre",
        hectares: "hectare",
        sqfeet: "sqft",
        sqyard: "sqyd",
        sqmile: "sqmi",
        sqmiles: "sqmi",
        mmhg: "mmHg",
        mmh2o: "mmH2O",
        cmh2o: "cmH2O",
        seconds: "second",
        secs: "second",
        minutes: "minute",
        mins: "minute",
        hours: "hour",
        hr: "hour",
        hrs: "hour",
        days: "day",
        weeks: "week",
        months: "month",
        years: "year",
        decades: "decade",
        centuries: "century",
        millennia: "millennium",
        hertz: "hertz",
        radians: "radian",
        degrees: "degree",
        gradians: "gradian",
        cycles: "cycle",
        arcsecond: "arcsec",
        arcseconds: "arcsec",
        arcminute: "arcmin",
        arcminutes: "arcmin",
        BTUs: "BTU",
        watts: "watt",
        joules: "joule",
        amperes: "ampere",
        coulombs: "coulomb",
        volts: "volt",
        ohms: "ohm",
        farads: "farad",
        webers: "weber",
        teslas: "tesla",
        electronvolts: "electronvolt",
        moles: "mole",
        bit: "bits",
        "byte": "bytes"
    };
    /**
   * Calculate the values for the angle units.
   * Value is calculated as number or BigNumber depending on the configuration
   * @param {{number: 'number' | 'BigNumber'}} config
   */ function calculateAngleValues(config) {
        if (config.number === "BigNumber") {
            var pi = (0, $fKKQe.createBigNumberPi)(_BigNumber);
            UNITS.rad.value = new _BigNumber(1);
            UNITS.deg.value = pi.div(180); // 2 * pi / 360
            UNITS.grad.value = pi.div(200); // 2 * pi / 400
            UNITS.cycle.value = pi.times(2); // 2 * pi
            UNITS.arcsec.value = pi.div(648000); // 2 * pi / 360 / 3600
            UNITS.arcmin.value = pi.div(10800); // 2 * pi / 360 / 60
        } else {
            // number
            UNITS.rad.value = 1;
            UNITS.deg.value = Math.PI / 180; // 2 * pi / 360
            UNITS.grad.value = Math.PI / 200; // 2 * pi / 400
            UNITS.cycle.value = Math.PI * 2; // 2 * pi
            UNITS.arcsec.value = Math.PI / 648000; // 2 * pi / 360 / 3600
            UNITS.arcmin.value = Math.PI / 10800; // 2 * pi / 360 / 60
        } // copy to the full names of the angles
        UNITS.radian.value = UNITS.rad.value;
        UNITS.degree.value = UNITS.deg.value;
        UNITS.gradian.value = UNITS.grad.value;
    } // apply the angle values now
    calculateAngleValues(config);
    if (on) // recalculate the values on change of configuration
    on("config", function(curr, prev) {
        if (curr.number !== prev.number) calculateAngleValues(curr);
    });
    /**
   * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
   * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
   * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
   */ var UNIT_SYSTEMS = {
        si: {
            // Base units
            NONE: {
                unit: UNIT_NONE,
                prefix: PREFIXES.NONE[""]
            },
            LENGTH: {
                unit: UNITS.m,
                prefix: PREFIXES.SHORT[""]
            },
            MASS: {
                unit: UNITS.g,
                prefix: PREFIXES.SHORT.k
            },
            TIME: {
                unit: UNITS.s,
                prefix: PREFIXES.SHORT[""]
            },
            CURRENT: {
                unit: UNITS.A,
                prefix: PREFIXES.SHORT[""]
            },
            TEMPERATURE: {
                unit: UNITS.K,
                prefix: PREFIXES.SHORT[""]
            },
            LUMINOUS_INTENSITY: {
                unit: UNITS.cd,
                prefix: PREFIXES.SHORT[""]
            },
            AMOUNT_OF_SUBSTANCE: {
                unit: UNITS.mol,
                prefix: PREFIXES.SHORT[""]
            },
            ANGLE: {
                unit: UNITS.rad,
                prefix: PREFIXES.SHORT[""]
            },
            BIT: {
                unit: UNITS.bits,
                prefix: PREFIXES.SHORT[""]
            },
            // Derived units
            FORCE: {
                unit: UNITS.N,
                prefix: PREFIXES.SHORT[""]
            },
            ENERGY: {
                unit: UNITS.J,
                prefix: PREFIXES.SHORT[""]
            },
            POWER: {
                unit: UNITS.W,
                prefix: PREFIXES.SHORT[""]
            },
            PRESSURE: {
                unit: UNITS.Pa,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CHARGE: {
                unit: UNITS.C,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CAPACITANCE: {
                unit: UNITS.F,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_POTENTIAL: {
                unit: UNITS.V,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_RESISTANCE: {
                unit: UNITS.ohm,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_INDUCTANCE: {
                unit: UNITS.H,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CONDUCTANCE: {
                unit: UNITS.S,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX: {
                unit: UNITS.Wb,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX_DENSITY: {
                unit: UNITS.T,
                prefix: PREFIXES.SHORT[""]
            },
            FREQUENCY: {
                unit: UNITS.Hz,
                prefix: PREFIXES.SHORT[""]
            }
        }
    }; // Clone to create the other unit systems
    UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.cgs.LENGTH = {
        unit: UNITS.m,
        prefix: PREFIXES.SHORT.c
    };
    UNIT_SYSTEMS.cgs.MASS = {
        unit: UNITS.g,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.FORCE = {
        unit: UNITS.dyn,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.ENERGY = {
        unit: UNITS.erg,
        prefix: PREFIXES.NONE[""]
    }; // there are wholly 4 unique cgs systems for electricity and magnetism,
    // so let's not worry about it unless somebody complains
    UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.us.LENGTH = {
        unit: UNITS.ft,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.MASS = {
        unit: UNITS.lbm,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.TEMPERATURE = {
        unit: UNITS.degF,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.FORCE = {
        unit: UNITS.lbf,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.ENERGY = {
        unit: UNITS.BTU,
        prefix: PREFIXES.BTU[""]
    };
    UNIT_SYSTEMS.us.POWER = {
        unit: UNITS.hp,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.PRESSURE = {
        unit: UNITS.psi,
        prefix: PREFIXES.NONE[""]
    }; // Add additional unit systems here.
    // Choose a unit system to seed the auto unit system.
    UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si)); // Set the current unit system
    var currentUnitSystem = UNIT_SYSTEMS.auto;
    /**
   * Set a unit system for formatting derived units.
   * @param {string} [name] The name of the unit system.
   */ Unit.setUnitSystem = function(name) {
        if ((0, $glBd7.hasOwnProperty)(UNIT_SYSTEMS, name)) currentUnitSystem = UNIT_SYSTEMS[name];
        else throw new Error("Unit system " + name + " does not exist. Choices are: " + Object.keys(UNIT_SYSTEMS).join(", "));
    };
    /**
   * Return the current unit system.
   * @return {string} The current unit system.
   */ Unit.getUnitSystem = function() {
        for(var _key in UNIT_SYSTEMS){
            if (UNIT_SYSTEMS[_key] === currentUnitSystem) return _key;
        }
    };
    /**
   * Converters to convert from number to an other numeric type like BigNumber
   * or Fraction
   */ Unit.typeConverters = {
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x + ""); // stringify to prevent constructor error
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x);
        },
        Complex: function Complex(x) {
            return x;
        },
        number: function number(x) {
            return x;
        }
    };
    /**
   * Retrieve the right convertor function corresponding with the type
   * of provided exampleValue.
   *
   * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
   *                        In case of an unknown type,
   * @return {Function}
   */ Unit._getNumberConverter = function(type) {
        if (!Unit.typeConverters[type]) throw new TypeError('Unsupported type "' + type + '"');
        return Unit.typeConverters[type];
    }; // Add dimensions to each built-in unit
    for(var _key2 in UNITS){
        var unit = UNITS[_key2];
        unit.dimensions = unit.base.dimensions;
    } // Create aliases
    for(var _name2 in ALIASES)if ((0, $glBd7.hasOwnProperty)(ALIASES, _name2)) {
        var _unit2 = UNITS[ALIASES[_name2]];
        var alias = {};
        for(var _key3 in _unit2)if ((0, $glBd7.hasOwnProperty)(_unit2, _key3)) alias[_key3] = _unit2[_key3];
        alias.name = _name2;
        UNITS[_name2] = alias;
    }
    function assertUnitNameIsValid(name) {
        for(var i = 0; i < name.length; i++){
            var _c = name.charAt(i);
            var isValidAlpha = function isValidAlpha(p) {
                return /^[a-zA-Z]$/.test(p);
            };
            var _isDigit = function _isDigit(c) {
                return c >= "0" && c <= "9";
            };
            if (i === 0 && !isValidAlpha(_c)) throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');
            if (i > 0 && !(isValidAlpha(_c) || _isDigit(_c))) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');
        }
    }
    /**
   * Wrapper around createUnitSingle.
   * Example:
   *  createUnit({
   *    foo: { },
   *    bar: {
   *      definition: 'kg/foo',
   *      aliases: ['ba', 'barr', 'bars'],
   *      offset: 200
   *    },
   *    baz: '4 bar'
   *  },
   *  {
   *    override: true
   *  })
   * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
   * @param {object} options
   */ Unit.createUnit = function(obj, options) {
        if ($9c5a6e4bc073984d$var$_typeof(obj) !== "object") throw new TypeError("createUnit expects first parameter to be of type 'Object'");
         // Remove all units and aliases we are overriding
        if (options && options.override) for(var _key4 in obj){
            if ((0, $glBd7.hasOwnProperty)(obj, _key4)) Unit.deleteUnit(_key4);
            if (obj[_key4].aliases) for(var i = 0; i < obj[_key4].aliases.length; i++)Unit.deleteUnit(obj[_key4].aliases[i]);
        }
         // TODO: traverse multiple times until all units have been added
        var lastUnit;
        for(var _key5 in obj)if ((0, $glBd7.hasOwnProperty)(obj, _key5)) lastUnit = Unit.createUnitSingle(_key5, obj[_key5]);
        return lastUnit;
    };
    /**
   * Create a user-defined unit and register it with the Unit type.
   * Example:
   *  createUnitSingle('knot', '0.514444444 m/s')
   *  createUnitSingle('acre', new Unit(43560, 'ft^2'))
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit, Object} definition      Definition of the unit in terms
   * of existing units. For example, '0.514444444 m / s'. Can be a Unit, a string,
   * or an Object. If an Object, may have the following properties:
   *   - definition {string|Unit} The definition of this unit.
   *   - prefixes {string} "none", "short", "long", "binary_short", or "binary_long".
   *     The default is "none".
   *   - aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
   *   - offset {Numeric} An offset to apply when converting from the unit. For
   *     example, the offset for celsius is 273.15 and the offset for farhenheit
   *     is 459.67. Default is 0.
   *   - baseName {string} If the unit's dimension does not match that of any other
   *     base unit, the name of the newly create base unit. Otherwise, this property
   *     has no effect.
   *
   * @param {Object} options   (optional) An object containing any of the following
   * properties:
   *   - override {boolean} Whether this unit should be allowed to override existing
   *     units.
   *
   * @return {Unit}
   */ Unit.createUnitSingle = function(name, obj, options) {
        if (typeof obj === "undefined" || obj === null) obj = {};
        if (typeof name !== "string") throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
         // Check collisions with existing units
        if ((0, $glBd7.hasOwnProperty)(UNITS, name)) throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
         // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.
        assertUnitNameIsValid(name);
        var defUnit = null; // The Unit from which the new unit will be created.
        var aliases = [];
        var offset = 0;
        var definition;
        var prefixes;
        var baseName;
        if (obj && obj.type === "Unit") defUnit = obj.clone();
        else if (typeof obj === "string") {
            if (obj !== "") definition = obj;
        } else if ($9c5a6e4bc073984d$var$_typeof(obj) === "object") {
            definition = obj.definition;
            prefixes = obj.prefixes;
            offset = obj.offset;
            baseName = obj.baseName;
            if (obj.aliases) aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
        } else throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
        if (aliases) for(var i = 0; i < aliases.length; i++){
            if ((0, $glBd7.hasOwnProperty)(UNITS, aliases[i])) throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
        }
        if (definition && typeof definition === "string" && !defUnit) try {
            defUnit = Unit.parse(definition, {
                allowNoUnits: true
            });
        } catch (ex) {
            ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
            throw ex;
        }
        else if (definition && definition.type === "Unit") defUnit = definition.clone();
        aliases = aliases || [];
        offset = offset || 0;
        if (prefixes && prefixes.toUpperCase) prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
        else prefixes = PREFIXES.NONE;
         // If defUnit is null, it is because the user did not
        // specify a defintion. So create a new base dimension.
        var newUnit = {};
        if (!defUnit) {
            // Add a new base dimension
            baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
            if (BASE_DIMENSIONS.indexOf(baseName) >= 0) throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
            BASE_DIMENSIONS.push(baseName); // Push 0 onto existing base units
            for(var b in BASE_UNITS)if ((0, $glBd7.hasOwnProperty)(BASE_UNITS, b)) BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length - 1] = 0;
             // Add the new base unit
            var newBaseUnit = {
                dimensions: []
            };
            for(var _i6 = 0; _i6 < BASE_DIMENSIONS.length; _i6++)newBaseUnit.dimensions[_i6] = 0;
            newBaseUnit.dimensions[BASE_DIMENSIONS.length - 1] = 1;
            newBaseUnit.key = baseName;
            BASE_UNITS[baseName] = newBaseUnit;
            newUnit = {
                name: name,
                value: 1,
                dimensions: BASE_UNITS[baseName].dimensions.slice(0),
                prefixes: prefixes,
                offset: offset,
                base: BASE_UNITS[baseName]
            };
            currentUnitSystem[baseName] = {
                unit: newUnit,
                prefix: PREFIXES.NONE[""]
            };
        } else {
            newUnit = {
                name: name,
                value: defUnit.value,
                dimensions: defUnit.dimensions.slice(0),
                prefixes: prefixes,
                offset: offset
            }; // Create a new base if no matching base exists
            var anyMatch = false;
            for(var _i7 in BASE_UNITS)if ((0, $glBd7.hasOwnProperty)(BASE_UNITS, _i7)) {
                var match = true;
                for(var j = 0; j < BASE_DIMENSIONS.length; j++)if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[_i7].dimensions[j] || 0)) > 1e-12) {
                    match = false;
                    break;
                }
                if (match) {
                    anyMatch = true;
                    newUnit.base = BASE_UNITS[_i7];
                    break;
                }
            }
            if (!anyMatch) {
                baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
                // Add the new base unit
                var _newBaseUnit = {
                    dimensions: defUnit.dimensions.slice(0)
                };
                _newBaseUnit.key = baseName;
                BASE_UNITS[baseName] = _newBaseUnit;
                currentUnitSystem[baseName] = {
                    unit: newUnit,
                    prefix: PREFIXES.NONE[""]
                };
                newUnit.base = BASE_UNITS[baseName];
            }
        }
        Unit.UNITS[name] = newUnit;
        for(var _i8 = 0; _i8 < aliases.length; _i8++){
            var aliasName = aliases[_i8];
            var _alias = {};
            for(var _key6 in newUnit)if ((0, $glBd7.hasOwnProperty)(newUnit, _key6)) _alias[_key6] = newUnit[_key6];
            _alias.name = aliasName;
            Unit.UNITS[aliasName] = _alias;
        }
        return new Unit(null, name);
    };
    Unit.deleteUnit = function(name) {
        delete Unit.UNITS[name];
    }; // expose arrays with prefixes, dimensions, units, systems
    Unit.PREFIXES = PREFIXES;
    Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
    Unit.BASE_UNITS = BASE_UNITS;
    Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
    Unit.UNITS = UNITS;
    return Unit;
}, {
    isClass: true
});

});

parcelRegister("f6Yj3", function(module, exports) {

$parcel$export(module.exports, "createUnitFunction", function () { return $b006322274622bc0$export$17074f98b69d2545; });

var $jKx4O = parcelRequire("jKx4O");

var $fbkGg = parcelRequire("fbkGg");
var $b006322274622bc0$var$name = "unit";
var $b006322274622bc0$var$dependencies = [
    "typed",
    "Unit"
]; // This function is named createUnitFunction to prevent a naming conflict with createUnit
var $b006322274622bc0$export$17074f98b69d2545 = /* #__PURE__ */ (0, $jKx4O.factory)($b006322274622bc0$var$name, $b006322274622bc0$var$dependencies, function(_ref) {
    var typed = _ref.typed, Unit = _ref.Unit;
    /**
   * Create a unit. Depending on the passed arguments, the function
   * will create and return a new math.Unit object.
   * When a matrix is provided, all elements will be converted to units.
   *
   * Syntax:
   *
   *     math.unit(unit : string)
   *     math.unit(value : number, unit : string)
   *
   * Examples:
   *
   *    const a = math.unit(5, 'cm')    // returns Unit 50 mm
   *    const b = math.unit('23 kg')    // returns Unit 23 kg
   *    a.to('m')                       // returns Unit 0.05 m
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, string, createUnit
   *
   * @param {* | Array | Matrix} args   A number and unit.
   * @return {Unit | Array | Matrix}    The created unit
   */ var unit = typed($b006322274622bc0$var$name, {
        Unit: function Unit(x) {
            return x.clone();
        },
        string: function string(x) {
            if (Unit.isValuelessUnit(x)) return new Unit(null, x); // a pure unit
            return Unit.parse(x, {
                allowNoUnits: true
            }); // a unit with value, like '5cm'
        },
        "number | BigNumber | Fraction | Complex, string": function numberBigNumberFractionComplexString(value, unit) {
            return new Unit(value, unit);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $fbkGg.deepMap)(x, unit);
        }
    });
    return unit;
});

});

parcelRegister("e6EEb", function(module, exports) {

$parcel$export(module.exports, "createUsolve", function () { return $a45127ec5c64456f$export$f652f5e8e3e838da; });

var $jKx4O = parcelRequire("jKx4O");

var $MMZIZ = parcelRequire("MMZIZ");
var $a45127ec5c64456f$var$name = "usolve";
var $a45127ec5c64456f$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $a45127ec5c64456f$export$f652f5e8e3e838da = /* #__PURE__ */ (0, $jKx4O.factory)($a45127ec5c64456f$var$name, $a45127ec5c64456f$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, divideScalar = _ref.divideScalar, multiplyScalar = _ref.multiplyScalar, subtract = _ref.subtract, equalScalar = _ref.equalScalar, DenseMatrix = _ref.DenseMatrix;
    var solveValidation = (0, $MMZIZ.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear equation system by backward substitution. Matrix must be an upper triangular matrix.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolve(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolve(a, b)  // [[8], [9]]
   *
   * See also:
   *
   *    lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($a45127ec5c64456f$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            // process matrix
            return _sparseBackwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            // process matrix
            return _denseBackwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            // create dense matrix from array
            var m = matrix(a); // use matrix implementation
            var r = _denseBackwardSubstitution(m, b); // result
            return r.valueOf();
        }
    });
    function _denseBackwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true); // column vector data
        var bdata = b._data; // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = []; // arrays
        var data = m._data; // backward solve m * x = b, loop columns (backwards)
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0; // x[j]
            var xj = void 0; // backward substitution (outer product) avoids inner looping when bj === 0
            if (!equalScalar(bj, 0)) {
                // value @ [j, j]
                var vjj = data[j][j]; // check vjj
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error("Linear system cannot be solved since matrix is singular");
                 // calculate xj
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j - 1; i >= 0; i--)// update copy of b
                bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, data[i][j]))
                ];
            } else // zero value @ j
            xj = 0;
             // update x
            x[j] = [
                xj
            ];
        } // return column vector
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseBackwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true); // column vector data
        var bdata = b._data; // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // vars
        var i, k; // result
        var x = []; // backward solve m * x = b, loop columns (backwards)
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0; // backward substitution (outer product) avoids inner looping when bj === 0
            if (!equalScalar(bj, 0)) {
                // value @ [j, j]
                var vjj = 0; // upper triangular matrix values & index (column j)
                var jvalues = [];
                var jindex = []; // first & last indeces in column
                var f = ptr[j];
                var l = ptr[j + 1]; // values in column, find value @ [j, j], loop backwards
                for(k = l - 1; k >= f; k--){
                    // row
                    i = index[k]; // check row
                    if (i === j) // update vjj
                    vjj = values[k];
                    else if (i < j) {
                        // store upper triangular
                        jvalues.push(values[k]);
                        jindex.push(i);
                    }
                } // at this point we must have a value @ [j, j]
                if (equalScalar(vjj, 0)) // system cannot be solved, there is no value @ [j, j]
                throw new Error("Linear system cannot be solved since matrix is singular");
                 // calculate xj
                var xj = divideScalar(bj, vjj); // loop upper triangular
                for(k = 0, l = jindex.length; k < l; k++){
                    // row
                    i = jindex[k]; // update copy of b
                    bdata[i] = [
                        subtract(bdata[i][0], multiplyScalar(xj, jvalues[k]))
                    ];
                } // update x
                x[j] = [
                    xj
                ];
            } else // update x
            x[j] = [
                0
            ];
        } // return vector
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});

});

parcelRegister("fW0nl", function(module, exports) {

$parcel$export(module.exports, "createXgcd", function () { return $b99c905940cc89ab$export$de8cbd18c98bf9d5; });

var $jKx4O = parcelRequire("jKx4O");

var $cqeCl = parcelRequire("cqeCl");
var $b99c905940cc89ab$var$name = "xgcd";
var $b99c905940cc89ab$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $b99c905940cc89ab$export$de8cbd18c98bf9d5 = /* #__PURE__ */ (0, $jKx4O.factory)($b99c905940cc89ab$var$name, $b99c905940cc89ab$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, BigNumber = _ref.BigNumber;
    /**
   * Calculate the extended greatest common divisor for two values.
   * See https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
   *
   * Syntax:
   *
   *    math.xgcd(a, b)
   *
   * Examples:
   *
   *    math.xgcd(8, 12)             // returns [4, -1, 1]
   *    math.gcd(8, 12)              // returns 4
   *    math.xgcd(36163, 21199)      // returns [1247, -7, 12]
   *
   * See also:
   *
   *    gcd, lcm
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
   *                              where `div = gcd(a, b)` and `a*m + b*n = div`
   */ return typed($b99c905940cc89ab$var$name, {
        "number, number": function numberNumber(a, b) {
            var res = (0, $cqeCl.xgcdNumber)(a, b);
            return config.matrix === "Array" ? res : matrix(res);
        },
        "BigNumber, BigNumber": _xgcdBigNumber // TODO: implement support for Fraction
    });
    /**
   * Calculate xgcd for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @return {BigNumber[]} result
   * @private
   */ function _xgcdBigNumber(a, b) {
        // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
        var t;
        var q;
        var r;
        var zero = new BigNumber(0);
        var one = new BigNumber(1);
        var x = zero;
        var lastx = one;
        var y = one;
        var lasty = zero;
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");
        while(!b.isZero()){
            q = a.div(b).floor();
            r = a.mod(b);
            t = x;
            x = lastx.minus(q.times(x));
            lastx = t;
            t = y;
            y = lasty.minus(q.times(y));
            lasty = t;
            a = b;
            b = r;
        }
        var res;
        if (a.lt(zero)) res = [
            a.neg(),
            lastx.neg(),
            lasty.neg()
        ];
        else res = [
            a,
            !a.isZero() ? lastx : 0,
            lasty
        ];
        return config.matrix === "Array" ? res : matrix(res);
    }
});

});

parcelRegister("anw0u", function(module, exports) {

$parcel$export(module.exports, "createXor", function () { return $78e4e1472721322f$export$a2b8cab2c7385f0e; });

var $e6fFw = parcelRequire("e6fFw");

var $axjwH = parcelRequire("axjwH");

var $272zs = parcelRequire("272zs");

var $kJFHo = parcelRequire("kJFHo");

var $5ntii = parcelRequire("5ntii");

var $jKx4O = parcelRequire("jKx4O");

var $e6Xsb = parcelRequire("e6Xsb");
var $78e4e1472721322f$var$name = "xor";
var $78e4e1472721322f$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix"
];
var $78e4e1472721322f$export$a2b8cab2c7385f0e = /* #__PURE__ */ (0, $jKx4O.factory)($78e4e1472721322f$var$name, $78e4e1472721322f$var$dependencies, function(_ref) {
    var typed = _ref.typed, matrix = _ref.matrix, DenseMatrix = _ref.DenseMatrix;
    var algorithm03 = (0, $e6fFw.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $axjwH.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $272zs.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $kJFHo.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $5ntii.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.xor(x, y)
   *
   * Examples:
   *
   *    math.xor(2, 4)   // returns false
   *
   *    a = [2, 0, 0]
   *    b = [2, 7, 0]
   *    c = 0
   *
   *    math.xor(a, b)   // returns [false, true, false]
   *    math.xor(a, c)   // returns [true, false, false]
   *
   * See also:
   *
   *    and, not, or
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one and only one input is defined with a nonzero/nonempty value.
   */ var xor = typed($78e4e1472721322f$var$name, {
        "number, number": (0, $e6Xsb.xorNumber),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN());
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return xor(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, xor);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, xor, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, xor, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, xor);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return xor(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return xor(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return xor(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, xor, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, xor, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, xor, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, xor, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, xor, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, xor, true).valueOf();
        }
    });
    return xor;
});

});

parcelRegister("lBjiA", function(module, exports) {

$parcel$export(module.exports, "createZeros", function () { return $fb9c05fc5cc3c1d9$export$13096c1635fe6e3d; });

var $7E0JQ = parcelRequire("7E0JQ");

var $5wlxr = parcelRequire("5wlxr");

var $YkZ7e = parcelRequire("YkZ7e");

var $jKx4O = parcelRequire("jKx4O");
var $fb9c05fc5cc3c1d9$var$name = "zeros";
var $fb9c05fc5cc3c1d9$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $fb9c05fc5cc3c1d9$export$13096c1635fe6e3d = /* #__PURE__ */ (0, $jKx4O.factory)($fb9c05fc5cc3c1d9$var$name, $fb9c05fc5cc3c1d9$var$dependencies, function(_ref) {
    var typed = _ref.typed, config = _ref.config, matrix = _ref.matrix, BigNumber = _ref.BigNumber;
    /**
   * Create a matrix filled with zeros. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.zeros(m)
   *    math.zeros(m, format)
   *    math.zeros(m, n)
   *    math.zeros(m, n, format)
   *    math.zeros([m, n])
   *    math.zeros([m, n], format)
   *
   * Examples:
   *
   *    math.zeros(3)                  // returns [0, 0, 0]
   *    math.zeros(3, 2)               // returns [[0, 0], [0, 0], [0, 0]]
   *    math.zeros(3, 'dense')         // returns [0, 0, 0]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.zeros(math.size(A))       // returns [[0, 0, 0], [0, 0, 0]]
   *
   * See also:
   *
   *    ones, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix}           A matrix filled with zeros
   */ return typed($fb9c05fc5cc3c1d9$var$name, {
        "": function _() {
            return config.matrix === "Array" ? _zeros([]) : _zeros([], "default");
        },
        // math.zeros(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _zeros(size, format);
            } else if (config.matrix === "Array") return _zeros(size);
            else return _zeros(size, "default");
        },
        Array: _zeros,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _zeros(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _zeros(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with zeros
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _zeros(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(0) : 0;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $YkZ7e.resize)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $7E0JQ.isBigNumber)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $5wlxr.isInteger)(value) || value < 0) throw new Error("Parameters in function zeros must be positive integers");
        });
    }
}); // TODO: zeros contains almost the same code as ones. Reuse this?

});




parcelRegister("ieAuE", function(module, exports) {

$parcel$export(module.exports, "ParseNumber", function () { return $d465d7a59f3083eb$export$24ec6072c2ea194f; });


parcelRequire("5bGlM");
parcelRequire("5uSSv");


var $kj5AX = parcelRequire("kj5AX");
const $d465d7a59f3083eb$export$24ec6072c2ea194f = (valueString)=>{
    if ([
        null,
        undefined,
        ""
    ].includes(valueString)) return valueString;
    try {
        const noCommas = valueString.replace(/,/g, "");
        return (0, $kj5AX.evaluate)(noCommas);
    } catch (e) {
        //if math.eval fails just pass string
        return valueString;
    }
// const parser = new NumberParser(
//     isoLangCodes.findCountryLocales(
//         constantCase(SessionStore?.organisationCountry || 'us')
//     )[0],
//     {
//         style: 'decimal',
//     }
// )
// return parser.parse(String(valueString))
};

});

parcelRegister("7jYVK", function(module, exports) {

$parcel$export(module.exports, "ParsePercent", function () { return $5549923fe5617680$export$604adb49655d900d; });

var $jX5nl = parcelRequire("jX5nl");


var $5bGlM = parcelRequire("5bGlM");

var $5uSSv = parcelRequire("5uSSv");

var $hPhGC = parcelRequire("hPhGC");
const $5549923fe5617680$export$604adb49655d900d = (valueString, decimals = 2)=>{
    const parser = new (0, $jX5nl.NumberParser)((0, (/*@__PURE__*/$parcel$interopDefault($5bGlM))).findCountryLocales((0, $hPhGC.constantCase)(((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) || "us"))[0], {
        style: "percent",
        maximumFractionDigits: decimals
    });
    return parser.parse(String(valueString));
};

});
parcelRegister("jX5nl", function(module, exports) {

$parcel$export(module.exports, "NumberParser", function () { return $e867b27633789e49$export$cd11ab140839f11d; });

var $1ldsY = parcelRequire("1ldsY");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e867b27633789e49$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
const $e867b27633789e49$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec"
];
class $e867b27633789e49$export$cd11ab140839f11d {
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return $e867b27633789e49$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return $e867b27633789e49$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return $e867b27633789e49$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
}
const $e867b27633789e49$var$$6c7bd7858deea686$var$numberParserCache = new Map();
function $e867b27633789e49$var$$6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = $e867b27633789e49$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of $e867b27633789e49$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = $e867b27633789e49$var$$6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function $e867b27633789e49$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    let parser = $e867b27633789e49$var$$6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $e867b27633789e49$var$$6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $e867b27633789e49$var$$6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class $e867b27633789e49$var$$6c7bd7858deea686$var$NumberParserImpl {
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        if (this.symbols.group) fullySanitizedValue = $e867b27633789e49$var$$6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, "");
        if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, ".");
        if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, "-");
        fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
        if (this.options.style === "percent") {
            // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
            let isNegative = fullySanitizedValue.indexOf("-");
            fullySanitizedValue = fullySanitizedValue.replace("-", "");
            let index = fullySanitizedValue.indexOf(".");
            if (index === -1) index = fullySanitizedValue.length;
            fullySanitizedValue = fullySanitizedValue.replace(".", "");
            if (index - 2 === 0) fullySanitizedValue = `0.${fullySanitizedValue}`;
            else if (index - 2 === -1) fullySanitizedValue = `0.0${fullySanitizedValue}`;
            else if (index - 2 === -2) fullySanitizedValue = "0.00";
            else fullySanitizedValue = `${fullySanitizedValue.slice(0, index - 2)}.${fullySanitizedValue.slice(index - 2)}`;
            if (isNegative > -1) fullySanitizedValue = `-${fullySanitizedValue}`;
        }
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        if (this.options.style === "percent") {
            var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
            // extra step for rounding percents to what our formatter would output
            let options = {
                ...this.options,
                style: "decimal",
                minimumFractionDigits: Math.min(((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) + 2, 20),
                maximumFractionDigits: Math.min(((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) + 2, 20)
            };
            return new $e867b27633789e49$export$cd11ab140839f11d(this.locale, options).parse(new (0, $1ldsY.NumberFormatter)(this.locale, options).format(newValue));
        }
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === "accounting" && $e867b27633789e49$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, "");
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        if (this.symbols.minusSign) value = value.replace("-", this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === "arab") {
            if (this.symbols.decimal) {
                value = value.replace(",", this.symbols.decimal);
                value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            }
            if (this.symbols.group) value = $e867b27633789e49$var$$6c7bd7858deea686$var$replaceAll(value, ".", this.symbols.group);
        }
        // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
        // so allow 'period' as a group char and replace it with a space
        if (this.options.locale === "fr-FR") value = $e867b27633789e49$var$$6c7bd7858deea686$var$replaceAll(value, ".", String.fromCharCode(8239));
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
        // Numbers that can't have any decimal values fail if a decimal character is typed
        if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
        // Remove numerals, groups, and decimals
        if (this.symbols.group) value = $e867b27633789e49$var$$6c7bd7858deea686$var$replaceAll(value, this.symbols.group, "");
        value = value.replace(this.symbols.numeral, "");
        if (this.symbols.decimal) value = value.replace(this.symbols.decimal, "");
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $e867b27633789e49$var$$6c7bd7858deea686$var$getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === "percent" && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
    }
}
const $e867b27633789e49$var$$6c7bd7858deea686$var$nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
const $e867b27633789e49$var$$6c7bd7858deea686$var$pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function $e867b27633789e49$var$$6c7bd7858deea686$var$getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    let symbolFormatter = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21
    });
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = symbolFormatter.formatToParts(-10000.111);
    let posAllParts = symbolFormatter.formatToParts(10000.111);
    let pluralParts = $e867b27633789e49$var$$6c7bd7858deea686$var$pluralNumbers.map((n)=>symbolFormatter.formatToParts(n));
    var _allParts_find_value;
    let minusSign = (_allParts_find_value = (_allParts_find = allParts.find((p)=>p.type === "minusSign")) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : "-";
    let plusSign = (_posAllParts_find = posAllParts.find((p)=>p.type === "plusSign")) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    // @ts-ignore
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    let decimalParts = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).formatToParts(0.001);
    let decimal = (_decimalParts_find = decimalParts.find((p)=>p.type === "decimal")) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    let group = (_allParts_find1 = allParts.find((p)=>p.type === "group")) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let allPartsLiterals = allParts.filter((p)=>!$e867b27633789e49$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$e867b27633789e49$var$$6c7bd7858deea686$var$escapeRegex(p.value));
    let pluralPartsLiterals = pluralParts.flatMap((p)=>p.filter((p)=>!$e867b27633789e49$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$e867b27633789e49$var$$6c7bd7858deea686$var$escapeRegex(p.value)));
    let sortedLiterals = [
        ...new Set([
            ...allPartsLiterals,
            ...pluralPartsLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${sortedLiterals.join("|")}|[\\p{White_Space}]`, "gu");
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join("")}]`, "g");
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $e867b27633789e49$var$$6c7bd7858deea686$var$replaceAll(str, find, replace) {
    // @ts-ignore
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $e867b27633789e49$var$$6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

});


parcelRegister("fycIx", function(module, exports) {

});

parcelRegister("k1Sse", function(module, exports) {

$parcel$export(module.exports, "ContactMultiselect", function () { return $e94e2429f066d45a$export$f9f8f6b0e5f1c453; });
$parcel$export(module.exports, "CostCentreMultiselect", function () { return $e94e2429f066d45a$export$ef8707dd53afea2f; });
$parcel$export(module.exports, "StaffMultiselect", function () { return $e94e2429f066d45a$export$f96d64fc1a4b19e2; });
$parcel$export(module.exports, "RoleMultiselect", function () { return $e94e2429f066d45a$export$801e8b331eb2dab1; });
$parcel$export(module.exports, "ProjectMultiselect", function () { return $e94e2429f066d45a$export$7a235d80d83c6a8e; });
$parcel$export(module.exports, "PhaseMultiselect", function () { return $e94e2429f066d45a$export$a4a08043e3ebad40; });
$parcel$export(module.exports, "StatusMultiselect", function () { return $e94e2429f066d45a$export$2976fe8217f8bc8b; });
$parcel$export(module.exports, "TaskMultiselect", function () { return $e94e2429f066d45a$export$b4641764ee571138; });

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");

var $4sGvn = parcelRequire("4sGvn");

var $hy8Zj = parcelRequire("hy8Zj");

var $lTrDt = parcelRequire("lTrDt");

var $dBifK = parcelRequire("dBifK");

var $9Lw71 = parcelRequire("9Lw71");

var $8YeUb = parcelRequire("8YeUb");

var $ig2C7 = parcelRequire("ig2C7");

var $kdO1A = parcelRequire("kdO1A");

var $8sHH3 = parcelRequire("8sHH3");

var $eYJ53 = parcelRequire("eYJ53");

var $augzx = parcelRequire("augzx");
const $e94e2429f066d45a$export$1e7dfd31545b5809 = ({ selectedOptions: selectedOptions = [], options: options = [], onChange: onChange = ()=>null, searchMatcher: searchMatcher, optionLabel: optionLabel, optionValue: optionValue, groupBy: groupBy, ...props })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $eYJ53.default), {
        selectedOptions: [
            ...selectedOptions
        ],
        options: [
            ...options
        ],
        getOptionLabel: optionLabel,
        getOptionValue: optionValue,
        onChange: onChange,
        filter: searchMatcher,
        groupBy: groupBy,
        ...props
    });
};
const $e94e2429f066d45a$export$f9f8f6b0e5f1c453 = ({ selectedContacts: selectedContacts, contactOptions: contactOptions, onChange: onChange, ...props })=>{
    let options = contactOptions || (0, $4sGvn.default).contacts;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedContacts,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy(options, [
            "label"
        ], [
            "asc"
        ]),
        optionLabel: (c)=>c === null || c === void 0 ? void 0 : c.label,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (c, text)=>{
            var _c$label, _c$label$toLowerCase, _c$label$toLowerCase$, _c$label$toLowerCase$2;
            return c === null || c === void 0 ? void 0 : (_c$label = c.label) === null || _c$label === void 0 ? void 0 : (_c$label$toLowerCase = _c$label.toLowerCase) === null || _c$label$toLowerCase === void 0 ? void 0 : (_c$label$toLowerCase$ = _c$label$toLowerCase.call(_c$label)) === null || _c$label$toLowerCase$ === void 0 ? void 0 : (_c$label$toLowerCase$2 = _c$label$toLowerCase$.match) === null || _c$label$toLowerCase$2 === void 0 ? void 0 : _c$label$toLowerCase$2.call(_c$label$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $e94e2429f066d45a$export$ef8707dd53afea2f = ({ selectedCostCentres: selectedCostCentres, costCentreOptions: costCentreOptions, onChange: onChange, ...props })=>{
    let options = costCentreOptions || (0, $hy8Zj.default).costCentres;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedCostCentres,
        onChange: onChange,
        options: [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy(options, [
                "name"
            ], [
                "asc"
            ])
        ],
        optionLabel: (cc)=>cc === null || cc === void 0 ? void 0 : cc.name,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (cc, text)=>{
            var _cc$name, _cc$name$toLowerCase, _cc$name$toLowerCase$, _cc$name$toLowerCase$2;
            return cc === null || cc === void 0 ? void 0 : (_cc$name = cc.name) === null || _cc$name === void 0 ? void 0 : (_cc$name$toLowerCase = _cc$name.toLowerCase) === null || _cc$name$toLowerCase === void 0 ? void 0 : (_cc$name$toLowerCase$ = _cc$name$toLowerCase.call(_cc$name)) === null || _cc$name$toLowerCase$ === void 0 ? void 0 : (_cc$name$toLowerCase$2 = _cc$name$toLowerCase$.match) === null || _cc$name$toLowerCase$2 === void 0 ? void 0 : _cc$name$toLowerCase$2.call(_cc$name$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $e94e2429f066d45a$export$f96d64fc1a4b19e2 = ({ selectedStaffMembers: selectedStaffMembers, staffOptions: staffOptions, onChange: onChange, ...props })=>{
    let options = staffOptions || (0, $lTrDt.default).staffs;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedStaffMembers,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy(options, [
            "fullName"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.fullName,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (sm, text)=>{
            var _sm$fullName, _sm$fullName$toLowerC, _sm$fullName$toLowerC2, _sm$fullName$toLowerC3;
            return sm === null || sm === void 0 ? void 0 : (_sm$fullName = sm.fullName) === null || _sm$fullName === void 0 ? void 0 : (_sm$fullName$toLowerC = _sm$fullName.toLowerCase) === null || _sm$fullName$toLowerC === void 0 ? void 0 : (_sm$fullName$toLowerC2 = _sm$fullName$toLowerC.call(_sm$fullName)) === null || _sm$fullName$toLowerC2 === void 0 ? void 0 : (_sm$fullName$toLowerC3 = _sm$fullName$toLowerC2.match) === null || _sm$fullName$toLowerC3 === void 0 ? void 0 : _sm$fullName$toLowerC3.call(_sm$fullName$toLowerC2, text.toLowerCase());
        },
        ...props
    });
};
const $e94e2429f066d45a$export$801e8b331eb2dab1 = ({ selectedRoles: selectedRoles, roleOptions: roleOptions, onChange: onChange, ...props })=>{
    let options = roleOptions || (0, $8YeUb.default).roles;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedRoles,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy(options, [
            "name"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.name,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (sm, text)=>{
            var _sm$name, _sm$name$toLowerCase, _sm$name$toLowerCase$, _sm$name$toLowerCase$2;
            return sm === null || sm === void 0 ? void 0 : (_sm$name = sm.name) === null || _sm$name === void 0 ? void 0 : (_sm$name$toLowerCase = _sm$name.toLowerCase) === null || _sm$name$toLowerCase === void 0 ? void 0 : (_sm$name$toLowerCase$ = _sm$name$toLowerCase.call(_sm$name)) === null || _sm$name$toLowerCase$ === void 0 ? void 0 : (_sm$name$toLowerCase$2 = _sm$name$toLowerCase$.match) === null || _sm$name$toLowerCase$2 === void 0 ? void 0 : _sm$name$toLowerCase$2.call(_sm$name$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $e94e2429f066d45a$export$7a235d80d83c6a8e = ({ selectedProjects: selectedProjects, projectOptions: projectOptions, onChange: onChange, ...props })=>{
    let options = projectOptions || (0, $kdO1A.default).projects;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedProjects,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy(options, [
            "title"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.title,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (sm, text)=>{
            var _sm$title, _sm$title$toLowerCase, _sm$title$toLowerCase2, _sm$title$toLowerCase3;
            return sm === null || sm === void 0 ? void 0 : (_sm$title = sm.title) === null || _sm$title === void 0 ? void 0 : (_sm$title$toLowerCase = _sm$title.toLowerCase) === null || _sm$title$toLowerCase === void 0 ? void 0 : (_sm$title$toLowerCase2 = _sm$title$toLowerCase.call(_sm$title)) === null || _sm$title$toLowerCase2 === void 0 ? void 0 : (_sm$title$toLowerCase3 = _sm$title$toLowerCase2.match) === null || _sm$title$toLowerCase3 === void 0 ? void 0 : _sm$title$toLowerCase3.call(_sm$title$toLowerCase2, text.toLowerCase());
        },
        ...props
    });
};
const $e94e2429f066d45a$export$a4a08043e3ebad40 = ({ selectedPhases: selectedPhases, phaseOptions: phaseOptions, onChange: onChange, ...props })=>{
    let options = phaseOptions || (0, $9Lw71.default).phases;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedPhases,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy(options, [
            "title"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.title,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (sm, text)=>sm.title.toLowerCase().match(text.toLowerCase()),
        ...props
    });
};
const $e94e2429f066d45a$export$2976fe8217f8bc8b = ({ selectedStatuses: selectedStatuses, onChange: onChange, placeholderLabel: placeholderLabel, ...props })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedStatuses.map((s)=>({
                value: s
            })),
        onChange: (options)=>onChange(options.map((o)=>o.value)),
        options: [
            {
                value: "active"
            },
            {
                value: "onHold"
            },
            {
                value: "prospective"
            },
            {
                value: "archived"
            }
        ],
        // sort={(c) => c.label}
        optionLabel: (o)=>(0, $ig2C7.capitalCase)(o.value),
        optionValue: (o)=>o.value,
        ...props
    });
};
const $e94e2429f066d45a$export$5ebd5a69c40fb058 = ({ selectedExpenses: selectedExpenses, onChange: onChange, placeholderLabel: placeholderLabel, ...props })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedExpenses.map((e)=>({
                value: e
            })),
        onChange: (options)=>onChange(options.map((o)=>o.value)),
        options: [
            ...new Set((0, $8sHH3.default).projectExpenses.map((e)=>e.name))
        ].map((e)=>({
                value: e
            })),
        // sort={(c) => c.label}
        optionLabel: (s)=>(0, $ig2C7.capitalCase)(s.value),
        optionValue: (o)=>o.value,
        ...props
    });
};
const $e94e2429f066d45a$export$b4641764ee571138 = ({ selectedTasks: selectedTasks, taskOptions: taskOptions, onChange: onChange, ...props })=>{
    let options = taskOptions || (0, $augzx.default).tasks;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($e94e2429f066d45a$export$1e7dfd31545b5809, {
        selectedOptions: selectedTasks,
        onChange: onChange,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy(options, [
            "title"
        ], [
            "asc"
        ]),
        optionLabel: (sm)=>sm === null || sm === void 0 ? void 0 : sm.title,
        optionValue: (sm)=>sm === null || sm === void 0 ? void 0 : sm.id,
        searchMatcher: (sm, text)=>{
            var _sm$name2;
            return sm === null || sm === void 0 ? void 0 : (_sm$name2 = sm.name) === null || _sm$name2 === void 0 ? void 0 : _sm$name2.toLowerCase().match(text.toLowerCase());
        },
        ...props
    });
};
var $e94e2429f066d45a$export$2e2bcd8739ae039 = {
    status: $e94e2429f066d45a$export$2976fe8217f8bc8b
};

});
parcelRegister("9Lw71", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71c169a692a07c73$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "PhaseCollectionClass", function () { return $71c169a692a07c73$export$12f8bb3600aabab2; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $k5Qs0 = parcelRequire("k5Qs0");

var $augzx = parcelRequire("augzx");

var $4iD0l = parcelRequire("4iD0l");
var $71c169a692a07c73$var$_dec, $71c169a692a07c73$var$_dec2, $71c169a692a07c73$var$_dec3, $71c169a692a07c73$var$_dec4, $71c169a692a07c73$var$_class;
function $71c169a692a07c73$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $71c169a692a07c73$var$PhaseCollection = ($71c169a692a07c73$var$_dec = (0, $d8hWe.action).bound, $71c169a692a07c73$var$_dec2 = (0, $d8hWe.action).bound, $71c169a692a07c73$var$_dec3 = (0, $d8hWe.action).bound, $71c169a692a07c73$var$_dec4 = (0, $d8hWe.action).bound, $71c169a692a07c73$var$_class = class PhaseCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "phases",
            modelClass: (0, $k5Qs0.default)
        });
        this.addLookup("phasesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get phasesById() {
        return this.modelsById;
    }
    get phases() {
        return this.models;
    }
    addPhase(data) {
        this.add(data);
    }
    addPhases(data) {
        this.addMany(data);
    }
    createPhase(projectId) {
        var _phase$project$costCe, _phase$project, _phase$project$costCe2;
        const phase = this.add({
            name: "New Phase",
            projectId: projectId,
            status: "active"
        }, {
            trackUpdates: true
        });
        const task = (0, $augzx.default).add({
            name: "(No task)",
            projectId: projectId,
            phaseId: phase.id,
            isDefault: true,
            isBillable: (_phase$project$costCe = (_phase$project = phase.project) === null || _phase$project === void 0 ? void 0 : (_phase$project$costCe2 = _phase$project.costCentre) === null || _phase$project$costCe2 === void 0 ? void 0 : _phase$project$costCe2.isBillable) !== null && _phase$project$costCe !== void 0 ? _phase$project$costCe : true,
            isVariation: false
        }, {
            trackUpdates: true
        });
        (0, $4iD0l.getDefaultTasks)().forEach((task)=>{
            (0, $augzx.default).add({
                projectId: projectId,
                phaseId: phase.id,
                isDefault: false,
                ...task
            }, {
                trackUpdates: true
            });
        });
        return phase;
    }
    createRootPhase(projectId) {
        const phase = this.add({
            name: "(No Phase)",
            projectId: projectId,
            status: "active",
            isRootPhase: true
        }, {
            trackUpdates: true
        });
        return phase;
    }
}, $71c169a692a07c73$var$_applyDecoratedDescriptor($71c169a692a07c73$var$_class.prototype, "addPhase", [
    $71c169a692a07c73$var$_dec
], Object.getOwnPropertyDescriptor($71c169a692a07c73$var$_class.prototype, "addPhase"), $71c169a692a07c73$var$_class.prototype), $71c169a692a07c73$var$_applyDecoratedDescriptor($71c169a692a07c73$var$_class.prototype, "addPhases", [
    $71c169a692a07c73$var$_dec2
], Object.getOwnPropertyDescriptor($71c169a692a07c73$var$_class.prototype, "addPhases"), $71c169a692a07c73$var$_class.prototype), $71c169a692a07c73$var$_applyDecoratedDescriptor($71c169a692a07c73$var$_class.prototype, "createPhase", [
    $71c169a692a07c73$var$_dec3
], Object.getOwnPropertyDescriptor($71c169a692a07c73$var$_class.prototype, "createPhase"), $71c169a692a07c73$var$_class.prototype), $71c169a692a07c73$var$_applyDecoratedDescriptor($71c169a692a07c73$var$_class.prototype, "createRootPhase", [
    $71c169a692a07c73$var$_dec4
], Object.getOwnPropertyDescriptor($71c169a692a07c73$var$_class.prototype, "createRootPhase"), $71c169a692a07c73$var$_class.prototype), $71c169a692a07c73$var$_class);
var $71c169a692a07c73$export$2e2bcd8739ae039 = new $71c169a692a07c73$var$PhaseCollection();
const $71c169a692a07c73$export$12f8bb3600aabab2 = $71c169a692a07c73$var$PhaseCollection;

});
parcelRegister("k5Qs0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea0cf5e91f820b03$export$2e2bcd8739ae039; });
parcelRequire("cjCbh");


var $d8hWe = parcelRequire("d8hWe");

var $cPDHe = parcelRequire("cPDHe");

var $kdO1A = parcelRequire("kdO1A");

var $8sHH3 = parcelRequire("8sHH3");

var $6omGT = parcelRequire("6omGT");

var $augzx = parcelRequire("augzx");

var $cuB2x = parcelRequire("cuB2x");

var $fqmGV = parcelRequire("fqmGV");

var $bwMFl = parcelRequire("bwMFl");

var $9Lw71 = parcelRequire("9Lw71");

var $dBifK = parcelRequire("dBifK");

var $5EjDW = parcelRequire("5EjDW");

var $4nGBk = parcelRequire("4nGBk");

var $aZYqt = parcelRequire("aZYqt");

var $1Nfhh = parcelRequire("1Nfhh");

var $itgIJ = parcelRequire("itgIJ");

var $fpkTk = parcelRequire("fpkTk");

var $h8VDI = parcelRequire("h8VDI");

var $hwZYE = parcelRequire("hwZYE");

var $5Xh7w = parcelRequire("5Xh7w");
parcelRequire("dflxv");

var $fritC = parcelRequire("fritC");
parcelRequire("X1RuM");

var $2F6ay = parcelRequire("2F6ay");

var $cfz4k = parcelRequire("cfz4k");
var $ea0cf5e91f820b03$var$_dec, $ea0cf5e91f820b03$var$_dec2, $ea0cf5e91f820b03$var$_dec3, $ea0cf5e91f820b03$var$_class, $ea0cf5e91f820b03$var$_descriptor, $ea0cf5e91f820b03$var$_descriptor2, $ea0cf5e91f820b03$var$_descriptor3, $ea0cf5e91f820b03$var$_descriptor4, $ea0cf5e91f820b03$var$_descriptor5, $ea0cf5e91f820b03$var$_descriptor6, $ea0cf5e91f820b03$var$_descriptor7, $ea0cf5e91f820b03$var$_descriptor8, $ea0cf5e91f820b03$var$_descriptor9, $ea0cf5e91f820b03$var$_descriptor10, $ea0cf5e91f820b03$var$_descriptor11, $ea0cf5e91f820b03$var$_descriptor12, $ea0cf5e91f820b03$var$_descriptor13, $ea0cf5e91f820b03$var$_descriptor14, $ea0cf5e91f820b03$var$_descriptor15, $ea0cf5e91f820b03$var$_descriptor16, $ea0cf5e91f820b03$var$_descriptor17;
function $ea0cf5e91f820b03$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $ea0cf5e91f820b03$var$_defineProperty(e, r, t) {
    return (r = $ea0cf5e91f820b03$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ea0cf5e91f820b03$var$_toPropertyKey(t) {
    var i = $ea0cf5e91f820b03$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ea0cf5e91f820b03$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ea0cf5e91f820b03$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $ea0cf5e91f820b03$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $ea0cf5e91f820b03$var$PhaseModel = ($ea0cf5e91f820b03$var$_dec = (0, $d8hWe.action).bound, $ea0cf5e91f820b03$var$_dec2 = (0, $d8hWe.action).bound, $ea0cf5e91f820b03$var$_dec3 = (0, $d8hWe.action).bound, $ea0cf5e91f820b03$var$_class = class PhaseModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "jobNumber", $ea0cf5e91f820b03$var$_descriptor, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "name", $ea0cf5e91f820b03$var$_descriptor2, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "projectId", $ea0cf5e91f820b03$var$_descriptor3, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "startDate", $ea0cf5e91f820b03$var$_descriptor4, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "endDate", $ea0cf5e91f820b03$var$_descriptor5, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "fee", $ea0cf5e91f820b03$var$_descriptor6, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "expenseBudget", $ea0cf5e91f820b03$var$_descriptor7, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "hoursBudget", $ea0cf5e91f820b03$var$_descriptor8, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "status", $ea0cf5e91f820b03$var$_descriptor9, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "percentLikelihood", $ea0cf5e91f820b03$var$_descriptor10, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "feeLinked", $ea0cf5e91f820b03$var$_descriptor11, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "expenseBudgetLinked", $ea0cf5e91f820b03$var$_descriptor12, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "hoursBudgetLinked", $ea0cf5e91f820b03$var$_descriptor13, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "durationUnit", $ea0cf5e91f820b03$var$_descriptor14, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "phaseData", $ea0cf5e91f820b03$var$_descriptor15, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "previousBilled", $ea0cf5e91f820b03$var$_descriptor16, this);
        $ea0cf5e91f820b03$var$_initializerDefineProperty(this, "isRootPhase", $ea0cf5e91f820b03$var$_descriptor17, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $9Lw71.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get allocations() {
        return this.monthlyAllocations;
    }
    get monthlyAllocations() {
        return (0, $2F6ay.default).allocationsByPhaseId[this.id] || [];
    }
    get weeklyAllocations() {
        return (0, $cfz4k.default).allocationsByPhaseId[this.id] || [];
    }
    get allocatedStaff() {
        return this.allocations.map((a)=>a.staff);
    }
    get dailyAllocations() {
        return (0, $cPDHe.default).dailyAllocationsByPhaseId[this.id] || [];
    }
    get title() {
        return this.jobNumber && this.name ? `${this.jobNumber}: ${this.name}` : this.name || this.jobNumber;
    }
    get expenses() {
        return (0, $8sHH3.default).expensesByPhaseId[this.id] || [];
    }
    get expenseAllocations() {
        return (0, $h8VDI.default).expenseAllocationsByPhaseId[this.id] || [];
    }
    get rates() {
        return (0, $6omGT.default).ratesByPhaseId[this.id] || [];
    }
    get tasks() {
        return ((0, $augzx.default).tasksByPhaseId[this.id] || []).sort((a, b)=>{
            // First, sort by createdAt.
            const createdAtComparison = new Date(a.initiatedAt) - new Date(b.initiatedAt);
            if (createdAtComparison !== 0) return createdAtComparison;
            // If createdAt is the same, sort by name.
            // Tasks without names go last.
            if (a.name && b.name) return a.name.localeCompare(b.name);
            if (a.name) return -1; // a has a name and comes before b
            if (b.name) return 1; // b has a name and comes before a
            // If both don't have a name, keep their order unchanged.
            return 0;
        });
    }
    get budgets() {
        return (0, $5EjDW.default).budgetsByPhaseId[this.id] || [];
    }
    get hoursFromBudgets() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.budgets.map((b)=>b.hours));
    }
    get costFromBudgets() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.budgets.map((b)=>b.cost));
    }
    get budgetedStaff() {
        return this.budgets.map((b)=>b.staff);
    }
    get budgetedRoles() {
        return [
            ...new Set([
                ...this.budgets.map((b)=>{
                    var _b$staff;
                    return (_b$staff = b.staff) === null || _b$staff === void 0 ? void 0 : _b$staff.role;
                }),
                ...this.budgets.map((b)=>b.role)
            ].filter((r)=>r))
        ];
    }
    get duration() {
        return (0, $bwMFl.unitsBetween)(this.startDate, this.endDate, this.durationUnit);
    }
    get invoiceLineItems() {
        return (0, $aZYqt.default).lineItemsByPhaseId[this.id] || [];
    }
    get timeEntries() {
        return (0, $cuB2x.default).timeEntriesByPhaseId[this.id] || [];
    }
    getAggregateInvoiceLineItems(group) {
        return (0, $4nGBk.default).getGroupCollection(group).lineItemsByPhaseId[this.id] || [];
    }
    getAggregateTimeEntries(group) {
        return (0, $1Nfhh.default).getGroupCollection(group).timeEntriesByPhaseId[this.id] || [];
    }
    get revenueTargets() {
        return (0, $fpkTk.default).revenueTargetsByPhaseId[this.id] || [];
    }
    get costCentre() {
        var _this$project;
        return (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.costCentre;
    }
    get contact() {
        var _this$project2;
        return (_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.contact;
    }
    get primaryContact() {
        var _this$project3;
        return (_this$project3 = this.project) === null || _this$project3 === void 0 ? void 0 : _this$project3.primaryContact;
    }
    get owner() {
        var _this$project4;
        return (_this$project4 = this.project) === null || _this$project4 === void 0 ? void 0 : _this$project4.owner;
    }
    get notes() {
        return (0, $itgIJ.default).notesByPhaseId[this.id];
    }
    get changeLog() {
        return (0, $hwZYE.default).changeLogItemsByPhaseId[this.id] || [];
    }
    updateDuration(duration, options) {
        const newEndDate = (0, $bwMFl.addUnitToDate)(this.startDate, duration.unit, duration.value);
        this.update({
            endDate: newEndDate
        }, options);
    }
    get hasDates() {
        return this.startDate && this.endDate;
    }
    get isCurrent() {
        return !this.startDate && this.endDate >= new Date() || !this.endDate && this.startDate <= new Date() || this.endDate >= new Date() && this.startDate <= new Date();
    }
    get hasEnded() {
        return this.hasDates && !this.isCurrent;
    }
    updateBudgets(field) {
        const budgets = this.budgets.filter((b)=>b.resource);
        const expenses = this.expenses.filter((e)=>!e.billable);
        if (field === "fee" && this.feeLinked && budgets.length) {
            const existingBudgetFee = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.chargeOut));
            if (!existingBudgetFee) budgets.forEach((b)=>{
                b.update({
                    hours: 1
                });
            });
            const ratio = this.fee / (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.chargeOut));
            budgets.forEach((b)=>{
                b.update({
                    hours: b.hours * ratio
                });
            });
        } else if (field === "expenseBudget" && this.expenseBudgetLinked && (budgets.length || expenses.length)) {
            const existingBudget = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.cost));
            if (!existingBudget) budgets.forEach((b)=>{
                b.update({
                    hours: 1
                });
            });
            const ratio = (this.expenseBudget - (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(expenses.map((e)=>e.cost))) / (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.cost));
            budgets.forEach((b)=>{
                b.update({
                    hours: b.hours * ratio
                });
            });
        } else if (field === "hoursBudget" && this.hoursBudgetLinked && budgets.length) {
            const existingBudget = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.hours));
            if (!existingBudget) budgets.forEach((b)=>{
                b.update({
                    hours: 1
                });
            });
            const ratio = this.hoursBudget / (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.hours));
            budgets.forEach((b)=>{
                b.update({
                    hours: b.hours * ratio
                });
            });
        }
        this.updateFromBudgets();
    }
    updateFromBudgets() {
        const budgets = this.budgets.filter((b)=>b.resource);
        const expenses = this.expenses.filter((e)=>!e.billable);
        if (this.feeLinked && budgets.length) this.update({
            fee: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.chargeOut))
        });
        if (this.expenseBudgetLinked && (budgets.length || expenses.length)) this.update({
            expenseBudget: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.cost)) + (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(expenses.map((e)=>e.cost))
        });
        if (this.hoursBudgetLinked && budgets.length) this.update({
            hoursBudget: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(budgets.map((b)=>b.hours))
        });
    }
    get feeAdjustedByLikelihood() {
        if ([
            "prospective",
            "onHold"
        ].includes(this.status) && this.percentLikelihood) return this.fee * (this.percentLikelihood / 100);
        else return this.fee;
    }
    get defaultTask() {
        var _this$tasks;
        return this.tasks.find((t)=>t.isDefault) || ((_this$tasks = this.tasks) === null || _this$tasks === void 0 ? void 0 : _this$tasks[0]);
    }
    get costRate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.budgets.map((b)=>b.costRate));
    }
    get chargeOutRate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.budgets.map((b)=>b.chargeOutRate));
    }
    getRateAtDate(rateType, date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.budgets.map((b)=>{
            var _b$staff2, _b$role;
            return (0, $fritC.default)(this.rates.filter((r)=>r.staff === b.staff || !r.staff && r.role === b.role), rateType, date) || ((_b$staff2 = b.staff) === null || _b$staff2 === void 0 ? void 0 : _b$staff2.getRateAtDate(rateType, date)) || ((_b$role = b.role) === null || _b$role === void 0 ? void 0 : _b$role.getRateAtDate(rateType, date)) || 0;
        }));
    }
}, $ea0cf5e91f820b03$var$_descriptor = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "jobNumber", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor2 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor3 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor4 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor5 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor6 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "fee", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $ea0cf5e91f820b03$var$_descriptor7 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "expenseBudget", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $ea0cf5e91f820b03$var$_descriptor8 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "hoursBudget", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $ea0cf5e91f820b03$var$_descriptor9 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "status", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor10 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "percentLikelihood", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor11 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "feeLinked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor12 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "expenseBudgetLinked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor13 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "hoursBudgetLinked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor14 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "durationUnit", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "weeks";
    }
}), $ea0cf5e91f820b03$var$_descriptor15 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "phaseData", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor16 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "previousBilled", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_descriptor17 = $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "isRootPhase", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "project"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "allocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "allocations"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "monthlyAllocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "monthlyAllocations"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "weeklyAllocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "weeklyAllocations"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "allocatedStaff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "allocatedStaff"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "dailyAllocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "dailyAllocations"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "title", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "title"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "expenses", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "expenses"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "expenseAllocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "expenseAllocations"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "rates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "rates"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "tasks", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "tasks"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "budgets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "budgets"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "hoursFromBudgets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "hoursFromBudgets"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "costFromBudgets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "costFromBudgets"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "budgetedStaff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "budgetedStaff"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "budgetedRoles", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "budgetedRoles"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "duration", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "duration"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "invoiceLineItems", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "invoiceLineItems"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "timeEntries", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "timeEntries"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "getAggregateInvoiceLineItems", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "getAggregateInvoiceLineItems"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "getAggregateTimeEntries", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "getAggregateTimeEntries"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "revenueTargets", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "revenueTargets"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "costCentre"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "contact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "contact"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "primaryContact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "primaryContact"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "owner", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "owner"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "notes", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "notes"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "changeLog", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "changeLog"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "updateDuration", [
    $ea0cf5e91f820b03$var$_dec
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "updateDuration"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "hasDates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "hasDates"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "isCurrent", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "isCurrent"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "hasEnded", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "hasEnded"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "updateBudgets", [
    $ea0cf5e91f820b03$var$_dec2
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "updateBudgets"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "updateFromBudgets", [
    $ea0cf5e91f820b03$var$_dec3
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "updateFromBudgets"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "feeAdjustedByLikelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "feeAdjustedByLikelihood"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "defaultTask", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "defaultTask"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "costRate"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_applyDecoratedDescriptor($ea0cf5e91f820b03$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ea0cf5e91f820b03$var$_class.prototype, "chargeOutRate"), $ea0cf5e91f820b03$var$_class.prototype), $ea0cf5e91f820b03$var$_class);
var $ea0cf5e91f820b03$export$2e2bcd8739ae039 = $ea0cf5e91f820b03$var$PhaseModel;

});
parcelRegister("cPDHe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95790a4e31b4d459$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DailyAllocationCollectionClass", function () { return $95790a4e31b4d459$export$790db561260f3e4; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $evSON = parcelRequire("evSON");

var $iCTvZ = parcelRequire("iCTvZ");
var $95790a4e31b4d459$var$_dec, $95790a4e31b4d459$var$_dec2, $95790a4e31b4d459$var$_class;
function $95790a4e31b4d459$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $95790a4e31b4d459$var$DailyAllocationCollection = ($95790a4e31b4d459$var$_dec = (0, $d8hWe.action).bound, $95790a4e31b4d459$var$_dec2 = (0, $d8hWe.action).bound, $95790a4e31b4d459$var$_class = class DailyAllocationCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "dailyAllocations",
            modelClass: (0, $evSON.default)
        });
        this.addLookup("dailyAllocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $iCTvZ.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $iCTvZ.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get dailyAllocationsById() {
        return this.modelsById;
    }
    get dailyAllocations() {
        return this.models;
    }
    get dailyAllocationsById() {
        return this.modelsById;
    }
    addDailyAllocation(data, options) {
        this.add(data, options);
    }
    addDailyAllocations(data, options) {
        this.addMany(data, options);
    }
}, $95790a4e31b4d459$var$_applyDecoratedDescriptor($95790a4e31b4d459$var$_class.prototype, "addDailyAllocation", [
    $95790a4e31b4d459$var$_dec
], Object.getOwnPropertyDescriptor($95790a4e31b4d459$var$_class.prototype, "addDailyAllocation"), $95790a4e31b4d459$var$_class.prototype), $95790a4e31b4d459$var$_applyDecoratedDescriptor($95790a4e31b4d459$var$_class.prototype, "addDailyAllocations", [
    $95790a4e31b4d459$var$_dec2
], Object.getOwnPropertyDescriptor($95790a4e31b4d459$var$_class.prototype, "addDailyAllocations"), $95790a4e31b4d459$var$_class.prototype), $95790a4e31b4d459$var$_class);
var $95790a4e31b4d459$export$2e2bcd8739ae039 = new $95790a4e31b4d459$var$DailyAllocationCollection();
const $95790a4e31b4d459$export$790db561260f3e4 = $95790a4e31b4d459$var$DailyAllocationCollection;

});
parcelRegister("evSON", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a90e7bb8875699f5$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");

var $augzx = parcelRequire("augzx");

var $fqmGV = parcelRequire("fqmGV");

var $cPDHe = parcelRequire("cPDHe");

var $hy8Zj = parcelRequire("hy8Zj");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $a90e7bb8875699f5$var$_class, $a90e7bb8875699f5$var$_descriptor, $a90e7bb8875699f5$var$_descriptor2, $a90e7bb8875699f5$var$_descriptor3, $a90e7bb8875699f5$var$_descriptor4, $a90e7bb8875699f5$var$_descriptor5, $a90e7bb8875699f5$var$_descriptor6, $a90e7bb8875699f5$var$_descriptor7, $a90e7bb8875699f5$var$_descriptor8, $a90e7bb8875699f5$var$_descriptor9, $a90e7bb8875699f5$var$_descriptor10, $a90e7bb8875699f5$var$_descriptor11, $a90e7bb8875699f5$var$_descriptor12, $a90e7bb8875699f5$var$_descriptor13, $a90e7bb8875699f5$var$_descriptor14, $a90e7bb8875699f5$var$_descriptor15, $a90e7bb8875699f5$var$_descriptor16, $a90e7bb8875699f5$var$_descriptor17, $a90e7bb8875699f5$var$_descriptor18, $a90e7bb8875699f5$var$_descriptor19, $a90e7bb8875699f5$var$_descriptor20, $a90e7bb8875699f5$var$_descriptor21;
function $a90e7bb8875699f5$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $a90e7bb8875699f5$var$_defineProperty(e, r, t) {
    return (r = $a90e7bb8875699f5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a90e7bb8875699f5$var$_toPropertyKey(t) {
    var i = $a90e7bb8875699f5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a90e7bb8875699f5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a90e7bb8875699f5$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $a90e7bb8875699f5$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $a90e7bb8875699f5$var$DailyAllocationModel = ($a90e7bb8875699f5$var$_class = class DailyAllocationModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "staffId", $a90e7bb8875699f5$var$_descriptor, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "roleId", $a90e7bb8875699f5$var$_descriptor2, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "costCentreId", $a90e7bb8875699f5$var$_descriptor3, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "projectId", $a90e7bb8875699f5$var$_descriptor4, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "phaseId", $a90e7bb8875699f5$var$_descriptor5, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "taskId", $a90e7bb8875699f5$var$_descriptor6, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "date", $a90e7bb8875699f5$var$_descriptor7, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "numMinutes", $a90e7bb8875699f5$var$_descriptor8, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "startMinutes", $a90e7bb8875699f5$var$_descriptor9, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "pay", $a90e7bb8875699f5$var$_descriptor10, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "cost", $a90e7bb8875699f5$var$_descriptor11, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "charge_out", $a90e7bb8875699f5$var$_descriptor12, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "isBillable", $a90e7bb8875699f5$var$_descriptor13, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "isVariation", $a90e7bb8875699f5$var$_descriptor14, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "isOvertime", $a90e7bb8875699f5$var$_descriptor15, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "beenInvoiced", $a90e7bb8875699f5$var$_descriptor16, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "flexi", $a90e7bb8875699f5$var$_descriptor17, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "remote", $a90e7bb8875699f5$var$_descriptor18, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "isLocked", $a90e7bb8875699f5$var$_descriptor19, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "notes", $a90e7bb8875699f5$var$_descriptor20, this);
        $a90e7bb8875699f5$var$_initializerDefineProperty(this, "deleted", $a90e7bb8875699f5$var$_descriptor21, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $cPDHe.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).staffsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $8YeUb.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return (0, $hy8Zj.default).modelsById[this.costCentreId] || this.project.costCentre;
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get task() {
        return (0, $augzx.default).modelsById[this.taskId];
    }
    get endMinutes() {
        return this.startMinutes + this.numMinutes;
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    // @computed
    // get pay() {
    //     return this.payRate * this.hours
    // }
    // @computed
    // get cost() {
    //     return this.costRate * this.hours
    // }
    // @computed
    // get chargeOut() {
    //     return this.chargeOutRate * this.hours
    // }
    get week() {
        return (0, $egx7S.getWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get month() {
        return (0, $egx7S.getMonth)(this.date);
    }
    get likelihood() {
        var _this$phase;
        return ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.likelihood) || 100;
    }
}, $a90e7bb8875699f5$var$_descriptor = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor2 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor3 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "costCentreId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor4 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor5 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor6 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "taskId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor7 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $a90e7bb8875699f5$var$_descriptor8 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a90e7bb8875699f5$var$_descriptor9 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "startMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a90e7bb8875699f5$var$_descriptor10 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a90e7bb8875699f5$var$_descriptor11 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a90e7bb8875699f5$var$_descriptor12 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "charge_out", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a90e7bb8875699f5$var$_descriptor13 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "isBillable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor14 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "isVariation", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor15 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "isOvertime", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor16 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "beenInvoiced", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor17 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "flexi", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor18 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "remote", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor19 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "isLocked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a90e7bb8875699f5$var$_descriptor20 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "notes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $a90e7bb8875699f5$var$_descriptor21 = $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "deleted", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "staff"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "role"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "costCentre"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "project"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "phase"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "task", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "task"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "endMinutes", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "endMinutes"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "hours"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "payRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "payRate"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "costRate"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "chargeOutRate"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "week", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "week"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "month", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "month"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_applyDecoratedDescriptor($a90e7bb8875699f5$var$_class.prototype, "likelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a90e7bb8875699f5$var$_class.prototype, "likelihood"), $a90e7bb8875699f5$var$_class.prototype), $a90e7bb8875699f5$var$_class);
var $a90e7bb8875699f5$export$2e2bcd8739ae039 = $a90e7bb8875699f5$var$DailyAllocationModel;

});
parcelRegister("augzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a298f9deb65eca9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TaskCollectionClass", function () { return $7a298f9deb65eca9$export$ae76438fa4f4f36a; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $7Hktb = parcelRequire("7Hktb");
var $7a298f9deb65eca9$var$_dec, $7a298f9deb65eca9$var$_dec2, $7a298f9deb65eca9$var$_class;
function $7a298f9deb65eca9$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $7a298f9deb65eca9$var$TaskCollection = ($7a298f9deb65eca9$var$_dec = (0, $d8hWe.action).bound, $7a298f9deb65eca9$var$_dec2 = (0, $d8hWe.action).bound, $7a298f9deb65eca9$var$_class = class TaskCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "tasks",
            modelClass: (0, $7Hktb.default)
        });
        this.addLookup("tasksByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("tasksByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get tasksById() {
        return this.modelsById;
    }
    get tasks() {
        return this.models;
    }
    addTask(data) {
        this.add(data);
    }
    addTasks(data) {
        this.addMany(data);
    }
}, $7a298f9deb65eca9$var$_applyDecoratedDescriptor($7a298f9deb65eca9$var$_class.prototype, "addTask", [
    $7a298f9deb65eca9$var$_dec
], Object.getOwnPropertyDescriptor($7a298f9deb65eca9$var$_class.prototype, "addTask"), $7a298f9deb65eca9$var$_class.prototype), $7a298f9deb65eca9$var$_applyDecoratedDescriptor($7a298f9deb65eca9$var$_class.prototype, "addTasks", [
    $7a298f9deb65eca9$var$_dec2
], Object.getOwnPropertyDescriptor($7a298f9deb65eca9$var$_class.prototype, "addTasks"), $7a298f9deb65eca9$var$_class.prototype), $7a298f9deb65eca9$var$_class);
var $7a298f9deb65eca9$export$2e2bcd8739ae039 = new $7a298f9deb65eca9$var$TaskCollection();
const $7a298f9deb65eca9$export$ae76438fa4f4f36a = $7a298f9deb65eca9$var$TaskCollection;

});
parcelRegister("7Hktb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59ac6d66542f524c$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $cPDHe = parcelRequire("cPDHe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $augzx = parcelRequire("augzx");

var $cuB2x = parcelRequire("cuB2x");

var $fqmGV = parcelRequire("fqmGV");
var $59ac6d66542f524c$var$_class, $59ac6d66542f524c$var$_descriptor, $59ac6d66542f524c$var$_descriptor2, $59ac6d66542f524c$var$_descriptor3, $59ac6d66542f524c$var$_descriptor4, $59ac6d66542f524c$var$_descriptor5, $59ac6d66542f524c$var$_descriptor6;
function $59ac6d66542f524c$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $59ac6d66542f524c$var$_defineProperty(e, r, t) {
    return (r = $59ac6d66542f524c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $59ac6d66542f524c$var$_toPropertyKey(t) {
    var i = $59ac6d66542f524c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $59ac6d66542f524c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $59ac6d66542f524c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $59ac6d66542f524c$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $59ac6d66542f524c$var$TaskModel = ($59ac6d66542f524c$var$_class = class TaskModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $59ac6d66542f524c$var$_initializerDefineProperty(this, "name", $59ac6d66542f524c$var$_descriptor, this);
        $59ac6d66542f524c$var$_initializerDefineProperty(this, "isDefault", $59ac6d66542f524c$var$_descriptor2, this);
        $59ac6d66542f524c$var$_initializerDefineProperty(this, "isBillable", $59ac6d66542f524c$var$_descriptor3, this);
        $59ac6d66542f524c$var$_initializerDefineProperty(this, "isVariation", $59ac6d66542f524c$var$_descriptor4, this);
        $59ac6d66542f524c$var$_initializerDefineProperty(this, "projectId", $59ac6d66542f524c$var$_descriptor5, this);
        $59ac6d66542f524c$var$_initializerDefineProperty(this, "phaseId", $59ac6d66542f524c$var$_descriptor6, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $augzx.default);
        this.init(data, options);
    }
    get dailyAllocations() {
        return (0, $cPDHe.default).dailyAllocationsByTaskId[this.id];
    }
    get timeEntries() {
        return (0, $cuB2x.default).timeEntriesByTaskId[this.id];
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
}, $59ac6d66542f524c$var$_descriptor = $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $59ac6d66542f524c$var$_descriptor2 = $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "isDefault", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $59ac6d66542f524c$var$_descriptor3 = $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "isBillable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $59ac6d66542f524c$var$_descriptor4 = $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "isVariation", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $59ac6d66542f524c$var$_descriptor5 = $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $59ac6d66542f524c$var$_descriptor6 = $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "dailyAllocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($59ac6d66542f524c$var$_class.prototype, "dailyAllocations"), $59ac6d66542f524c$var$_class.prototype), $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "timeEntries", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($59ac6d66542f524c$var$_class.prototype, "timeEntries"), $59ac6d66542f524c$var$_class.prototype), $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($59ac6d66542f524c$var$_class.prototype, "phase"), $59ac6d66542f524c$var$_class.prototype), $59ac6d66542f524c$var$_applyDecoratedDescriptor($59ac6d66542f524c$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($59ac6d66542f524c$var$_class.prototype, "project"), $59ac6d66542f524c$var$_class.prototype), $59ac6d66542f524c$var$_class);
var $59ac6d66542f524c$export$2e2bcd8739ae039 = $59ac6d66542f524c$var$TaskModel;

});
parcelRegister("cuB2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $918504bb7b9820a8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TimeEntryCollectionClass", function () { return $918504bb7b9820a8$export$b87d50baeffb91d5; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $cP6OA = parcelRequire("cP6OA");

var $iCTvZ = parcelRequire("iCTvZ");
var $918504bb7b9820a8$var$_dec, $918504bb7b9820a8$var$_dec2, $918504bb7b9820a8$var$_class;
function $918504bb7b9820a8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $918504bb7b9820a8$var$TimeEntryCollection = ($918504bb7b9820a8$var$_dec = (0, $d8hWe.action).bound, $918504bb7b9820a8$var$_dec2 = (0, $d8hWe.action).bound, $918504bb7b9820a8$var$_class = class TimeEntryCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "timeEntries",
            modelClass: (0, $cP6OA.default)
        });
        this.addLookup("timeEntriesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $iCTvZ.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByDate", "manyByKey", {
            key: (t)=>t.date.getTime(),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $iCTvZ.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get timeEntriesById() {
        return this.modelsById;
    }
    get timeEntries() {
        return this.models;
    }
    get timeEntriesById() {
        return this.modelsById;
    }
    addTimeEntry(data) {
        this.add(data);
    }
    addTimeEntries(data) {
        this.addMany(data);
    }
}, $918504bb7b9820a8$var$_applyDecoratedDescriptor($918504bb7b9820a8$var$_class.prototype, "addTimeEntry", [
    $918504bb7b9820a8$var$_dec
], Object.getOwnPropertyDescriptor($918504bb7b9820a8$var$_class.prototype, "addTimeEntry"), $918504bb7b9820a8$var$_class.prototype), $918504bb7b9820a8$var$_applyDecoratedDescriptor($918504bb7b9820a8$var$_class.prototype, "addTimeEntries", [
    $918504bb7b9820a8$var$_dec2
], Object.getOwnPropertyDescriptor($918504bb7b9820a8$var$_class.prototype, "addTimeEntries"), $918504bb7b9820a8$var$_class.prototype), $918504bb7b9820a8$var$_class);
var $918504bb7b9820a8$export$2e2bcd8739ae039 = new $918504bb7b9820a8$var$TimeEntryCollection();
const $918504bb7b9820a8$export$b87d50baeffb91d5 = $918504bb7b9820a8$var$TimeEntryCollection;

});
parcelRegister("cP6OA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $955f88c41a63d69d$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");

var $augzx = parcelRequire("augzx");

var $fqmGV = parcelRequire("fqmGV");

var $cuB2x = parcelRequire("cuB2x");

var $hy8Zj = parcelRequire("hy8Zj");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $955f88c41a63d69d$var$_class, $955f88c41a63d69d$var$_descriptor, $955f88c41a63d69d$var$_descriptor2, $955f88c41a63d69d$var$_descriptor3, $955f88c41a63d69d$var$_descriptor4, $955f88c41a63d69d$var$_descriptor5, $955f88c41a63d69d$var$_descriptor6, $955f88c41a63d69d$var$_descriptor7, $955f88c41a63d69d$var$_descriptor8, $955f88c41a63d69d$var$_descriptor9, $955f88c41a63d69d$var$_descriptor10, $955f88c41a63d69d$var$_descriptor11, $955f88c41a63d69d$var$_descriptor12, $955f88c41a63d69d$var$_descriptor13, $955f88c41a63d69d$var$_descriptor14, $955f88c41a63d69d$var$_descriptor15, $955f88c41a63d69d$var$_descriptor16, $955f88c41a63d69d$var$_descriptor17, $955f88c41a63d69d$var$_descriptor18, $955f88c41a63d69d$var$_descriptor19, $955f88c41a63d69d$var$_descriptor20, $955f88c41a63d69d$var$_descriptor21;
function $955f88c41a63d69d$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $955f88c41a63d69d$var$_defineProperty(e, r, t) {
    return (r = $955f88c41a63d69d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $955f88c41a63d69d$var$_toPropertyKey(t) {
    var i = $955f88c41a63d69d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $955f88c41a63d69d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $955f88c41a63d69d$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $955f88c41a63d69d$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $955f88c41a63d69d$var$TimeEntryModel = ($955f88c41a63d69d$var$_class = class TimeEntryModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "staffId", $955f88c41a63d69d$var$_descriptor, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "roleId", $955f88c41a63d69d$var$_descriptor2, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "costCentreId", $955f88c41a63d69d$var$_descriptor3, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "projectId", $955f88c41a63d69d$var$_descriptor4, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "phaseId", $955f88c41a63d69d$var$_descriptor5, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "taskId", $955f88c41a63d69d$var$_descriptor6, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "date", $955f88c41a63d69d$var$_descriptor7, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "numMinutes", $955f88c41a63d69d$var$_descriptor8, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "startMinutes", $955f88c41a63d69d$var$_descriptor9, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "pay", $955f88c41a63d69d$var$_descriptor10, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "cost", $955f88c41a63d69d$var$_descriptor11, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "charge_out", $955f88c41a63d69d$var$_descriptor12, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "isBillable", $955f88c41a63d69d$var$_descriptor13, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "isVariation", $955f88c41a63d69d$var$_descriptor14, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "isOvertime", $955f88c41a63d69d$var$_descriptor15, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "beenInvoiced", $955f88c41a63d69d$var$_descriptor16, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "flexi", $955f88c41a63d69d$var$_descriptor17, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "remote", $955f88c41a63d69d$var$_descriptor18, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "isLocked", $955f88c41a63d69d$var$_descriptor19, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "notes", $955f88c41a63d69d$var$_descriptor20, this);
        $955f88c41a63d69d$var$_initializerDefineProperty(this, "deleted", $955f88c41a63d69d$var$_descriptor21, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $cuB2x.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $8YeUb.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return (0, $hy8Zj.default).modelsById[this.costCentreId];
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get task() {
        return (0, $augzx.default).modelsById[this.taskId];
    }
    get endMinutes() {
        return this.startMinutes + this.numMinutes;
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    // @computed
    // get pay() {
    //     return this.payRate * this.hours
    // }
    // @computed
    // get cost() {
    //     return this.costRate * this.hours
    // }
    // @computed
    // get chargeOut() {
    //     return this.chargeOutRate * this.hours
    // }
    get week() {
        return (0, $egx7S.getWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get month() {
        return (0, $egx7S.format)(this.date, "yyyy-MM");
    }
}, $955f88c41a63d69d$var$_descriptor = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor2 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor3 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "costCentreId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor4 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor5 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor6 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "taskId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor7 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor8 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $955f88c41a63d69d$var$_descriptor9 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "startMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $955f88c41a63d69d$var$_descriptor10 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $955f88c41a63d69d$var$_descriptor11 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $955f88c41a63d69d$var$_descriptor12 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "charge_out", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $955f88c41a63d69d$var$_descriptor13 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "isBillable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor14 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "isVariation", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor15 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "isOvertime", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor16 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "beenInvoiced", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor17 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "flexi", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor18 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "remote", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor19 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "isLocked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $955f88c41a63d69d$var$_descriptor20 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "notes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $955f88c41a63d69d$var$_descriptor21 = $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "deleted", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "staff"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "role"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "costCentre"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "project"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "phase"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "task", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "task"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "endMinutes", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "endMinutes"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "hours"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "payRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "payRate"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "costRate"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "chargeOutRate"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "week", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "week"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_applyDecoratedDescriptor($955f88c41a63d69d$var$_class.prototype, "month", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($955f88c41a63d69d$var$_class.prototype, "month"), $955f88c41a63d69d$var$_class.prototype), $955f88c41a63d69d$var$_class);
var $955f88c41a63d69d$export$2e2bcd8739ae039 = $955f88c41a63d69d$var$TimeEntryModel;

});
parcelRegister("8YeUb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $687f7d299c797b33$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RoleCollectionClass", function () { return $687f7d299c797b33$export$864f7350f070dc1; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $3DTev = parcelRequire("3DTev");

var $9W6IT = parcelRequire("9W6IT");
var $687f7d299c797b33$var$_dec, $687f7d299c797b33$var$_dec2, $687f7d299c797b33$var$_dec3, $687f7d299c797b33$var$_class;
function $687f7d299c797b33$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $687f7d299c797b33$var$RoleCollection = ($687f7d299c797b33$var$_dec = (0, $d8hWe.action).bound, $687f7d299c797b33$var$_dec2 = (0, $d8hWe.action).bound, $687f7d299c797b33$var$_dec3 = (0, $d8hWe.action).bound, $687f7d299c797b33$var$_class = class RoleCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "roles",
            modelClass: (0, $3DTev.default)
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get rolesById() {
        return this.modelsById;
    }
    get roles() {
        return this.models;
    }
    addRole(data) {
        this.add(data);
    }
    addRoles(data) {
        this.addMany(data);
    }
    createRole() {
        const role = this.add({
            name: "New Role"
        }, {
            trackUpdates: true
        });
        const rate = (0, $9W6IT.default).add({
            roleId: role.id,
            date: "2000-01-01",
            payRate: 0,
            costRate: 0,
            chargeOutRate: 0,
            overtimeRate: 0
        }, {
            trackUpdates: true
        });
        return role;
    }
}, $687f7d299c797b33$var$_applyDecoratedDescriptor($687f7d299c797b33$var$_class.prototype, "addRole", [
    $687f7d299c797b33$var$_dec
], Object.getOwnPropertyDescriptor($687f7d299c797b33$var$_class.prototype, "addRole"), $687f7d299c797b33$var$_class.prototype), $687f7d299c797b33$var$_applyDecoratedDescriptor($687f7d299c797b33$var$_class.prototype, "addRoles", [
    $687f7d299c797b33$var$_dec2
], Object.getOwnPropertyDescriptor($687f7d299c797b33$var$_class.prototype, "addRoles"), $687f7d299c797b33$var$_class.prototype), $687f7d299c797b33$var$_applyDecoratedDescriptor($687f7d299c797b33$var$_class.prototype, "createRole", [
    $687f7d299c797b33$var$_dec3
], Object.getOwnPropertyDescriptor($687f7d299c797b33$var$_class.prototype, "createRole"), $687f7d299c797b33$var$_class.prototype), $687f7d299c797b33$var$_class);
var $687f7d299c797b33$export$2e2bcd8739ae039 = new $687f7d299c797b33$var$RoleCollection();
const $687f7d299c797b33$export$864f7350f070dc1 = $687f7d299c797b33$var$RoleCollection;

});
parcelRegister("3DTev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a6fdbb687a10a1c$export$2e2bcd8739ae039; });

var $lM5ib = parcelRequire("lM5ib");

var $d8hWe = parcelRequire("d8hWe");

var $8YeUb = parcelRequire("8YeUb");

var $9W6IT = parcelRequire("9W6IT");

var $lTrDt = parcelRequire("lTrDt");

var $fqmGV = parcelRequire("fqmGV");

var $dBifK = parcelRequire("dBifK");

var $fritC = parcelRequire("fritC");

var $dflxv = parcelRequire("dflxv");
var $2a6fdbb687a10a1c$var$_class, $2a6fdbb687a10a1c$var$_descriptor, $2a6fdbb687a10a1c$var$_descriptor2, $2a6fdbb687a10a1c$var$_descriptor3, $2a6fdbb687a10a1c$var$_descriptor4, $2a6fdbb687a10a1c$var$_descriptor5;
function $2a6fdbb687a10a1c$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $2a6fdbb687a10a1c$var$_defineProperty(e, r, t) {
    return (r = $2a6fdbb687a10a1c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2a6fdbb687a10a1c$var$_toPropertyKey(t) {
    var i = $2a6fdbb687a10a1c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2a6fdbb687a10a1c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $2a6fdbb687a10a1c$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $2a6fdbb687a10a1c$var$RoleModel = ($2a6fdbb687a10a1c$var$_class = class RoleModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $2a6fdbb687a10a1c$var$_initializerDefineProperty(this, "isArchived", $2a6fdbb687a10a1c$var$_descriptor, this);
        $2a6fdbb687a10a1c$var$_initializerDefineProperty(this, "avgPayRate", $2a6fdbb687a10a1c$var$_descriptor2, this);
        $2a6fdbb687a10a1c$var$_initializerDefineProperty(this, "avgOvertimeRate", $2a6fdbb687a10a1c$var$_descriptor3, this);
        $2a6fdbb687a10a1c$var$_initializerDefineProperty(this, "avgCostRate", $2a6fdbb687a10a1c$var$_descriptor4, this);
        $2a6fdbb687a10a1c$var$_initializerDefineProperty(this, "avgChargeOutRate", $2a6fdbb687a10a1c$var$_descriptor5, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $8YeUb.default);
        this.init(data, options);
    }
    get rates() {
        return (0, $9W6IT.default).ratesByRoleId[this.id] || [];
    }
    get payRate() {
        return this.getRateAtDate("pay", new Date());
    }
    get overtimeRate() {
        return this.getRateAtDate("overtime", new Date());
    }
    get costRate() {
        return this.getRateAtDate("cost", new Date());
    }
    get chargeOutRate() {
        return this.getRateAtDate("chargeOut", new Date());
    }
    get staffAndRoleRates() {
        const ratesByDate = {};
        this.staff.filter((s)=>!s.deletedAt && !s.isArchived).flatMap((s)=>s.rates).forEach((r)=>{
            ratesByDate[r.date] = r;
        });
        this.rates.forEach((r)=>{
            ratesByDate[r.date] = r;
        });
        return Object.values(ratesByDate).sort((a, b)=>a.date - b.date);
    }
    get staff() {
        return (0, $lTrDt.default).staffByRoleId[this.id] || [];
    }
    avgRateType(rateType) {
        return this["avg" + (0, $lM5ib.pascalCase)(rateType) + "Rate"];
    }
    getRateInDateRange(rateType, dateRange) {
        if (this.staff.filter((s)=>!s.inheritRateType(rateType)).length && this.avgRateType(rateType)) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.staff.filter((s)=>!s.inheritRateType(rateType) && !s.deletedAt && !s.isArchived).map((s)=>s.getRateInDateRange(rateType, dateRange)));
        return (0, $dflxv.default)(this.rates, rateType, dateRange);
    }
    getRateAtDate(rateType, date) {
        if (this.staff.filter((s)=>!s.inheritRateType(rateType) && !s.deletedAt && !s.isArchived).length && this.avgRateType(rateType)) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.staff.filter((s)=>!s.inheritRateType(rateType) && !s.deletedAt && !s.isArchived).map((s)=>s.getRateAtDate(rateType, date)).filter((v)=>v));
        return (0, $fritC.default)(this.rates, rateType, date);
    }
    getAvailabilityInDateRange(dateRange) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.staff.map((s)=>s.getAvailabilityInDateRange(dateRange)));
    }
    getAvailabilityAtDate(date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.staff.map((s)=>s.getAvailabilityAtDate(date)));
    }
}, $2a6fdbb687a10a1c$var$_descriptor = $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "isArchived", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2a6fdbb687a10a1c$var$_descriptor2 = $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "avgPayRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2a6fdbb687a10a1c$var$_descriptor3 = $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "avgOvertimeRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2a6fdbb687a10a1c$var$_descriptor4 = $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "avgCostRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2a6fdbb687a10a1c$var$_descriptor5 = $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "avgChargeOutRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "rates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "rates"), $2a6fdbb687a10a1c$var$_class.prototype), $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "payRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "payRate"), $2a6fdbb687a10a1c$var$_class.prototype), $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "overtimeRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "overtimeRate"), $2a6fdbb687a10a1c$var$_class.prototype), $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "costRate"), $2a6fdbb687a10a1c$var$_class.prototype), $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "chargeOutRate"), $2a6fdbb687a10a1c$var$_class.prototype), $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "staffAndRoleRates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "staffAndRoleRates"), $2a6fdbb687a10a1c$var$_class.prototype), $2a6fdbb687a10a1c$var$_applyDecoratedDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2a6fdbb687a10a1c$var$_class.prototype, "staff"), $2a6fdbb687a10a1c$var$_class.prototype), $2a6fdbb687a10a1c$var$_class);
var $2a6fdbb687a10a1c$export$2e2bcd8739ae039 = $2a6fdbb687a10a1c$var$RoleModel;

});
parcelRegister("9W6IT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73bebeecd70149ee$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RoleRateCollectionClass", function () { return $73bebeecd70149ee$export$620868d49ddd222e; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $94Lso = parcelRequire("94Lso");
var $73bebeecd70149ee$var$_dec, $73bebeecd70149ee$var$_dec2, $73bebeecd70149ee$var$_class;
function $73bebeecd70149ee$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $73bebeecd70149ee$var$RoleRateCollection = ($73bebeecd70149ee$var$_dec = (0, $d8hWe.action).bound, $73bebeecd70149ee$var$_dec2 = (0, $d8hWe.action).bound, $73bebeecd70149ee$var$_class = class RoleRateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "roleRates",
            modelClass: (0, $94Lso.default)
        });
        this.addLookup("ratesByRoleId", "manyByKey", {
            key: (t)=>t.roleId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get roleRatesById() {
        return this.modelsById;
    }
    get roleRates() {
        return this.models;
    }
    addRoleRate(data) {
        this.add(data);
    }
    addRoleRates(data) {
        this.addMany(data);
    }
}, $73bebeecd70149ee$var$_applyDecoratedDescriptor($73bebeecd70149ee$var$_class.prototype, "addRoleRate", [
    $73bebeecd70149ee$var$_dec
], Object.getOwnPropertyDescriptor($73bebeecd70149ee$var$_class.prototype, "addRoleRate"), $73bebeecd70149ee$var$_class.prototype), $73bebeecd70149ee$var$_applyDecoratedDescriptor($73bebeecd70149ee$var$_class.prototype, "addRoleRates", [
    $73bebeecd70149ee$var$_dec2
], Object.getOwnPropertyDescriptor($73bebeecd70149ee$var$_class.prototype, "addRoleRates"), $73bebeecd70149ee$var$_class.prototype), $73bebeecd70149ee$var$_class);
var $73bebeecd70149ee$export$2e2bcd8739ae039 = new $73bebeecd70149ee$var$RoleRateCollection();
const $73bebeecd70149ee$export$620868d49ddd222e = $73bebeecd70149ee$var$RoleRateCollection;

});
parcelRegister("94Lso", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69b94cbcdfcbff8e$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $8YeUb = parcelRequire("8YeUb");

var $9W6IT = parcelRequire("9W6IT");

var $fqmGV = parcelRequire("fqmGV");
var $69b94cbcdfcbff8e$var$_class, $69b94cbcdfcbff8e$var$_descriptor, $69b94cbcdfcbff8e$var$_descriptor2, $69b94cbcdfcbff8e$var$_descriptor3, $69b94cbcdfcbff8e$var$_descriptor4, $69b94cbcdfcbff8e$var$_descriptor5, $69b94cbcdfcbff8e$var$_descriptor6;
function $69b94cbcdfcbff8e$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $69b94cbcdfcbff8e$var$_defineProperty(e, r, t) {
    return (r = $69b94cbcdfcbff8e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $69b94cbcdfcbff8e$var$_toPropertyKey(t) {
    var i = $69b94cbcdfcbff8e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $69b94cbcdfcbff8e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $69b94cbcdfcbff8e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $69b94cbcdfcbff8e$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $69b94cbcdfcbff8e$var$RoleRateModel = ($69b94cbcdfcbff8e$var$_class = class RoleRateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $69b94cbcdfcbff8e$var$_initializerDefineProperty(this, "roleId", $69b94cbcdfcbff8e$var$_descriptor, this);
        $69b94cbcdfcbff8e$var$_initializerDefineProperty(this, "date", $69b94cbcdfcbff8e$var$_descriptor2, this);
        $69b94cbcdfcbff8e$var$_initializerDefineProperty(this, "payRate", $69b94cbcdfcbff8e$var$_descriptor3, this);
        $69b94cbcdfcbff8e$var$_initializerDefineProperty(this, "costRate", $69b94cbcdfcbff8e$var$_descriptor4, this);
        $69b94cbcdfcbff8e$var$_initializerDefineProperty(this, "chargeOutRate", $69b94cbcdfcbff8e$var$_descriptor5, this);
        $69b94cbcdfcbff8e$var$_initializerDefineProperty(this, "overtimeRate", $69b94cbcdfcbff8e$var$_descriptor6, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $9W6IT.default);
        this.init(data, options);
    }
    get role() {
        return (0, $8YeUb.default).modelsById[this.roleId];
    }
}, $69b94cbcdfcbff8e$var$_descriptor = $69b94cbcdfcbff8e$var$_applyDecoratedDescriptor($69b94cbcdfcbff8e$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $69b94cbcdfcbff8e$var$_descriptor2 = $69b94cbcdfcbff8e$var$_applyDecoratedDescriptor($69b94cbcdfcbff8e$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $69b94cbcdfcbff8e$var$_descriptor3 = $69b94cbcdfcbff8e$var$_applyDecoratedDescriptor($69b94cbcdfcbff8e$var$_class.prototype, "payRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $69b94cbcdfcbff8e$var$_descriptor4 = $69b94cbcdfcbff8e$var$_applyDecoratedDescriptor($69b94cbcdfcbff8e$var$_class.prototype, "costRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $69b94cbcdfcbff8e$var$_descriptor5 = $69b94cbcdfcbff8e$var$_applyDecoratedDescriptor($69b94cbcdfcbff8e$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $69b94cbcdfcbff8e$var$_descriptor6 = $69b94cbcdfcbff8e$var$_applyDecoratedDescriptor($69b94cbcdfcbff8e$var$_class.prototype, "overtimeRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $69b94cbcdfcbff8e$var$_applyDecoratedDescriptor($69b94cbcdfcbff8e$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($69b94cbcdfcbff8e$var$_class.prototype, "role"), $69b94cbcdfcbff8e$var$_class.prototype), $69b94cbcdfcbff8e$var$_class);
var $69b94cbcdfcbff8e$export$2e2bcd8739ae039 = $69b94cbcdfcbff8e$var$RoleRateModel;

});





parcelRegister("iCTvZ", function(module, exports) {

$parcel$export(module.exports, "tuple", function () { return $d0aadf1ddb695819$export$65e3907585753458; });
$parcel$export(module.exports, "default", function () { return $d0aadf1ddb695819$export$2e2bcd8739ae039; });
// Although `Symbol` is widely supported these days, we can safely fall
// back to using a non-enumerable string property without violating any
// assumptions elsewhere in the implementation.
var $d0aadf1ddb695819$var$useSymbol = typeof Symbol === "function" && typeof Symbol.for === "function";
// Used to mark `tuple.prototype` so that all objects that inherit from
// any `tuple.prototype` object (there could be more than one) will test
// positive according to `tuple.isTuple`.
var $d0aadf1ddb695819$var$brand = $d0aadf1ddb695819$var$useSymbol ? Symbol.for("immutable-tuple") : "@@__IMMUTABLE_TUPLE__@@";
// Used to save a reference to the globally shared `UniversalWeakMap` that
// stores all known `tuple` objects.
var $d0aadf1ddb695819$var$globalKey = $d0aadf1ddb695819$var$useSymbol ? Symbol.for("immutable-tuple-root") : "@@__IMMUTABLE_TUPLE_ROOT__@@";
// Convenient helper for defining hidden immutable properties.
function $d0aadf1ddb695819$var$def(obj, name, value, enumerable) {
    Object.defineProperty(obj, name, {
        value: value,
        enumerable: !!enumerable,
        writable: false,
        configurable: false
    });
    return value;
}
var $d0aadf1ddb695819$var$freeze = Object.freeze || function(obj) {
    return obj;
};
function $d0aadf1ddb695819$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) return false;
        case "function":
            return true;
        default:
            return false;
    }
}
// The `mustConvertThisToArray` value is true when the corresponding
// `Array` method does not attempt to modify `this`, which means we can
// pass a `tuple` object as `this` without first converting it to an
// `Array`.
function $d0aadf1ddb695819$var$forEachArrayMethod(fn) {
    function call(name, mustConvertThisToArray) {
        var desc = Object.getOwnPropertyDescriptor(Array.prototype, name);
        fn(name, desc, !!mustConvertThisToArray);
    }
    call("every");
    call("filter");
    call("find");
    call("findIndex");
    call("forEach");
    call("includes");
    call("indexOf");
    call("join");
    call("lastIndexOf");
    call("map");
    call("reduce");
    call("reduceRight");
    call("slice");
    call("some");
    call("toLocaleString");
    call("toString");
    // The `reverse` and `sort` methods are usually destructive, but for
    // `tuple` objects they return a new `tuple` object that has been
    // appropriately reversed/sorted.
    call("reverse", true);
    call("sort", true);
    // Make `[...someTuple]` work.
    call($d0aadf1ddb695819$var$useSymbol && Symbol.iterator || "@@iterator");
}
// A map data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $d0aadf1ddb695819$var$UniversalWeakMap = function UniversalWeakMap() {
    // Since a `WeakMap` cannot hold primitive values as keys, we need a
    // backup `Map` instance to hold primitive keys. Both `this._weakMap`
    // and `this._strongMap` are lazily initialized.
    this._weakMap = null;
    this._strongMap = null;
    this.data = null;
};
// Since `get` and `set` are the only methods used, that's all I've
// implemented here.
$d0aadf1ddb695819$var$UniversalWeakMap.prototype.get = function get(key) {
    var map = this._getMap(key, false);
    if (map) return map.get(key);
};
$d0aadf1ddb695819$var$UniversalWeakMap.prototype.set = function set(key, value) {
    this._getMap(key, true).set(key, value);
    // An actual `Map` or `WeakMap` would return `this` here, but
    // returning the `value` is more convenient for the `tuple`
    // implementation.
    return value;
};
$d0aadf1ddb695819$var$UniversalWeakMap.prototype._getMap = function _getMap(key, canCreate) {
    if (!canCreate) return $d0aadf1ddb695819$var$isObjRef(key) ? this._weakMap : this._strongMap;
    if ($d0aadf1ddb695819$var$isObjRef(key)) return this._weakMap || (this._weakMap = new WeakMap);
    return this._strongMap || (this._strongMap = new Map);
};
// See [`universal-weak-map.js`](universal-weak-map.html).
// See [`util.js`](util.html).
// If this package is installed multiple times, there could be mutiple
// implementations of the `tuple` function with distinct `tuple.prototype`
// objects, but the shared pool of `tuple` objects must be the same across
// all implementations. While it would be ideal to use the `global`
// object, there's no reliable way to get the global object across all JS
// environments without using the `Function` constructor, so instead we
// use the global `Array` constructor as a shared namespace.
var $d0aadf1ddb695819$var$root = Array[$d0aadf1ddb695819$var$globalKey] || $d0aadf1ddb695819$var$def(Array, $d0aadf1ddb695819$var$globalKey, new $d0aadf1ddb695819$var$UniversalWeakMap, false);
function $d0aadf1ddb695819$export$dfc7155ac0343b8() {
    return $d0aadf1ddb695819$export$90d439304ff38d15(arguments);
}
function $d0aadf1ddb695819$export$90d439304ff38d15(array) {
    var node = $d0aadf1ddb695819$var$root;
    // Because we are building a tree of *weak* maps, the tree will not
    // prevent objects in tuples from being garbage collected, since the
    // tree itself will be pruned over time when the corresponding `tuple`
    // objects become unreachable. In addition to internalization, this
    // property is a key advantage of the `immutable-tuple` package.
    var len = array.length;
    for(var i = 0; i < len; ++i){
        var item = array[i];
        node = node.get(item) || node.set(item, new $d0aadf1ddb695819$var$UniversalWeakMap);
    }
    // Return node.data rather than node itself to prevent tampering with
    // the UniversalWeakMap tree.
    return node.data || (node.data = Object.create(null));
}
// See [`lookup.js`](lookup.html).
// See [`util.js`](util.html).
// When called with any number of arguments, this function returns an
// object that inherits from `tuple.prototype` and is guaranteed to be
// `===` any other `tuple` object that has exactly the same items. In
// computer science jargon, `tuple` instances are "internalized" or just
// "interned," which allows for constant-time equality checking, and makes
// it possible for tuple objects to be used as `Map` or `WeakMap` keys, or
// stored in a `Set`.
function $d0aadf1ddb695819$export$65e3907585753458() {
    var arguments$1 = arguments;
    var node = $d0aadf1ddb695819$export$dfc7155ac0343b8.apply(null, arguments);
    if (node.tuple) return node.tuple;
    var t = Object.create($d0aadf1ddb695819$export$65e3907585753458.prototype);
    // Define immutable items with numeric indexes, and permanently fix the
    // `.length` property.
    var argc = arguments.length;
    for(var i = 0; i < argc; ++i)t[i] = arguments$1[i];
    $d0aadf1ddb695819$var$def(t, "length", argc, false);
    // Remember this new `tuple` object so that we can return the same object
    // earlier next time.
    return $d0aadf1ddb695819$var$freeze(node.tuple = t);
}
// Since the `immutable-tuple` package could be installed multiple times
// in an application, there is no guarantee that the `tuple` constructor
// or `tuple.prototype` will be unique, so `value instanceof tuple` is
// unreliable. Instead, to test if a value is a tuple, you should use
// `tuple.isTuple(value)`.
$d0aadf1ddb695819$var$def($d0aadf1ddb695819$export$65e3907585753458.prototype, $d0aadf1ddb695819$var$brand, true, false);
function $d0aadf1ddb695819$var$isTuple(that) {
    return !!(that && that[$d0aadf1ddb695819$var$brand] === true);
}
$d0aadf1ddb695819$export$65e3907585753458.isTuple = $d0aadf1ddb695819$var$isTuple;
function $d0aadf1ddb695819$var$toArray(tuple) {
    var array = [];
    var i = tuple.length;
    while(i--)array[i] = tuple[i];
    return array;
}
// Copy all generic non-destructive Array methods to `tuple.prototype`.
// This works because (for example) `Array.prototype.slice` can be invoked
// against any `Array`-like object.
$d0aadf1ddb695819$var$forEachArrayMethod(function(name, desc, mustConvertThisToArray) {
    var method = desc && desc.value;
    if (typeof method === "function") {
        desc.value = function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            var result = method.apply(mustConvertThisToArray ? $d0aadf1ddb695819$var$toArray(this) : this, args);
            // Of course, `tuple.prototype.slice` should return a `tuple` object,
            // not a new `Array`.
            return Array.isArray(result) ? $d0aadf1ddb695819$export$65e3907585753458.apply(void 0, result) : result;
        };
        Object.defineProperty($d0aadf1ddb695819$export$65e3907585753458.prototype, name, desc);
    }
});
// Like `Array.prototype.concat`, except for the extra effort required to
// convert any tuple arguments to arrays, so that
// ```
// tuple(1).concat(tuple(2), 3) === tuple(1, 2, 3)
// ```
var $d0aadf1ddb695819$var$ref = Array.prototype;
var $d0aadf1ddb695819$var$concat = $d0aadf1ddb695819$var$ref.concat;
$d0aadf1ddb695819$export$65e3907585753458.prototype.concat = function() {
    var args = [], len = arguments.length;
    while(len--)args[len] = arguments[len];
    return $d0aadf1ddb695819$export$65e3907585753458.apply(void 0, $d0aadf1ddb695819$var$concat.apply($d0aadf1ddb695819$var$toArray(this), args.map(function(item) {
        return $d0aadf1ddb695819$var$isTuple(item) ? $d0aadf1ddb695819$var$toArray(item) : item;
    })));
};
var $d0aadf1ddb695819$export$2e2bcd8739ae039 = $d0aadf1ddb695819$export$65e3907585753458;

});






parcelRegister("8sHH3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6292d4db3f4c4177$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectExpenseCollectionClass", function () { return $6292d4db3f4c4177$export$c3a184893613313d; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $iTrNV = parcelRequire("iTrNV");
var $6292d4db3f4c4177$var$_dec, $6292d4db3f4c4177$var$_dec2, $6292d4db3f4c4177$var$_class;
function $6292d4db3f4c4177$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $6292d4db3f4c4177$var$ProjectExpenseCollection = ($6292d4db3f4c4177$var$_dec = (0, $d8hWe.action).bound, $6292d4db3f4c4177$var$_dec2 = (0, $d8hWe.action).bound, $6292d4db3f4c4177$var$_class = class ProjectExpenseCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "projectExpenses",
            modelClass: (0, $iTrNV.default)
        });
        this.addLookup("expensesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expensesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expensesByName", "manyByKey", {
            key: (t)=>t.name,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get projectExpensesById() {
        return this.modelsById;
    }
    get projectExpenses() {
        return this.models;
    }
    addProjectExpense(data) {
        this.add(data);
    }
    addProjectExpenses(data) {
        this.addMany(data);
    }
}, $6292d4db3f4c4177$var$_applyDecoratedDescriptor($6292d4db3f4c4177$var$_class.prototype, "addProjectExpense", [
    $6292d4db3f4c4177$var$_dec
], Object.getOwnPropertyDescriptor($6292d4db3f4c4177$var$_class.prototype, "addProjectExpense"), $6292d4db3f4c4177$var$_class.prototype), $6292d4db3f4c4177$var$_applyDecoratedDescriptor($6292d4db3f4c4177$var$_class.prototype, "addProjectExpenses", [
    $6292d4db3f4c4177$var$_dec2
], Object.getOwnPropertyDescriptor($6292d4db3f4c4177$var$_class.prototype, "addProjectExpenses"), $6292d4db3f4c4177$var$_class.prototype), $6292d4db3f4c4177$var$_class);
var $6292d4db3f4c4177$export$2e2bcd8739ae039 = new $6292d4db3f4c4177$var$ProjectExpenseCollection();
const $6292d4db3f4c4177$export$c3a184893613313d = $6292d4db3f4c4177$var$ProjectExpenseCollection;

});
parcelRegister("iTrNV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc12ee69b6dd8a99$export$2e2bcd8739ae039; });

var $egx7S = parcelRequire("egx7S");

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $h8VDI = parcelRequire("h8VDI");

var $8sHH3 = parcelRequire("8sHH3");

var $fqmGV = parcelRequire("fqmGV");

var $dBifK = parcelRequire("dBifK");

var $aZYqt = parcelRequire("aZYqt");

var $foua5 = parcelRequire("foua5");
var $dc12ee69b6dd8a99$var$_class, $dc12ee69b6dd8a99$var$_descriptor, $dc12ee69b6dd8a99$var$_descriptor2, $dc12ee69b6dd8a99$var$_descriptor3, $dc12ee69b6dd8a99$var$_descriptor4, $dc12ee69b6dd8a99$var$_descriptor5, $dc12ee69b6dd8a99$var$_descriptor6, $dc12ee69b6dd8a99$var$_descriptor7, $dc12ee69b6dd8a99$var$_descriptor8, $dc12ee69b6dd8a99$var$_descriptor9, $dc12ee69b6dd8a99$var$_descriptor10, $dc12ee69b6dd8a99$var$_descriptor11, $dc12ee69b6dd8a99$var$_descriptor12;
function $dc12ee69b6dd8a99$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $dc12ee69b6dd8a99$var$_defineProperty(e, r, t) {
    return (r = $dc12ee69b6dd8a99$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $dc12ee69b6dd8a99$var$_toPropertyKey(t) {
    var i = $dc12ee69b6dd8a99$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $dc12ee69b6dd8a99$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $dc12ee69b6dd8a99$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $dc12ee69b6dd8a99$var$ProjectExpenseModel = ($dc12ee69b6dd8a99$var$_class = class ProjectExpenseModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "projectId", $dc12ee69b6dd8a99$var$_descriptor, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "phaseId", $dc12ee69b6dd8a99$var$_descriptor2, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "supplierId", $dc12ee69b6dd8a99$var$_descriptor3, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "name", $dc12ee69b6dd8a99$var$_descriptor4, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "quantity", $dc12ee69b6dd8a99$var$_descriptor5, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "unitCost", $dc12ee69b6dd8a99$var$_descriptor6, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "billable", $dc12ee69b6dd8a99$var$_descriptor7, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "cost", $dc12ee69b6dd8a99$var$_descriptor8, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "startDate", $dc12ee69b6dd8a99$var$_descriptor9, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "endDate", $dc12ee69b6dd8a99$var$_descriptor10, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "beenInvoiced", $dc12ee69b6dd8a99$var$_descriptor11, this);
        $dc12ee69b6dd8a99$var$_initializerDefineProperty(this, "previousBilled", $dc12ee69b6dd8a99$var$_descriptor12, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $8sHH3.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get supplier() {
        return (0, $foua5.default).modelsById[this.supplierId];
    }
    get allocations() {
        return (0, $h8VDI.default).expenseAllocationsByExpenseId[this.id] || [];
    }
    get invoiceLineItems() {
        return (0, $aZYqt.default).lineItemsByExpenseId[this.id] || [];
    }
    get businessDays() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max([
            (0, $egx7S.differenceInBusinessDays)((0, $egx7S.addDays)(this.endDate, 1), this.startDate),
            1
        ]);
    }
    costInDateRange(dateRange) {
        if (dateRange[0] > this.endDate) return 0;
        if (dateRange[1] < this.startDate) return 0;
        const businessDays = (0, $egx7S.differenceInBusinessDays)((0, $egx7S.addDays)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min([
            dateRange[1],
            this.endDate
        ]), 1), (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max([
            dateRange[0],
            this.startDate
        ]));
        const businessDayRatio = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min([
            businessDays / this.businessDays,
            1
        ]);
        return businessDayRatio * this.cost;
    }
    allocatedCostInDateRange(dateRange) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.allocations.filter((a)=>a.date >= dateRange[0] && a.date <= dateRange[1]).map((a)=>a.amount));
    }
    allocatedCostInDateRangeAdjustedByLikelihood(dateRange) {
        var _this$phase, _this$phase2;
        const value = this.allocatedCostInDateRange(dateRange);
        if ([
            "prospective",
            "onHold"
        ].includes((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.status) && ((_this$phase2 = this.phase) === null || _this$phase2 === void 0 ? void 0 : _this$phase2.percentLikelihood) != undefined) {
            var _this$phase$percentLi, _this$phase3;
            return value * Math.min(((_this$phase$percentLi = (_this$phase3 = this.phase) === null || _this$phase3 === void 0 ? void 0 : _this$phase3.percentLikelihood) !== null && _this$phase$percentLi !== void 0 ? _this$phase$percentLi : 100) / 100, 1);
        } else return value;
    }
    amountBilledInDateRange(dateRange) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.invoiceLineItems.filter((a)=>a.date >= dateRange[0] && a.date <= dateRange[1]).map((a)=>a.amount));
    }
}, $dc12ee69b6dd8a99$var$_descriptor = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor2 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor3 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "supplierId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor4 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor5 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "quantity", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor6 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "unitCost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor7 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "billable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor8 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor9 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor10 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor11 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "beenInvoiced", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_descriptor12 = $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "previousBilled", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "project"), $dc12ee69b6dd8a99$var$_class.prototype), $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "phase"), $dc12ee69b6dd8a99$var$_class.prototype), $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "supplier", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "supplier"), $dc12ee69b6dd8a99$var$_class.prototype), $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "allocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "allocations"), $dc12ee69b6dd8a99$var$_class.prototype), $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "invoiceLineItems", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "invoiceLineItems"), $dc12ee69b6dd8a99$var$_class.prototype), $dc12ee69b6dd8a99$var$_applyDecoratedDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "businessDays", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc12ee69b6dd8a99$var$_class.prototype, "businessDays"), $dc12ee69b6dd8a99$var$_class.prototype), $dc12ee69b6dd8a99$var$_class);
var $dc12ee69b6dd8a99$export$2e2bcd8739ae039 = $dc12ee69b6dd8a99$var$ProjectExpenseModel;

});
parcelRegister("h8VDI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7afe5046292bb3e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectExpenseAllocationCollectionClass", function () { return $c7afe5046292bb3e$export$62a818585501d2ca; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $iVVsJ = parcelRequire("iVVsJ");
var $c7afe5046292bb3e$var$_dec, $c7afe5046292bb3e$var$_dec2, $c7afe5046292bb3e$var$_class;
function $c7afe5046292bb3e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $c7afe5046292bb3e$var$ProjectExpenseAllocationCollection = ($c7afe5046292bb3e$var$_dec = (0, $d8hWe.action).bound, $c7afe5046292bb3e$var$_dec2 = (0, $d8hWe.action).bound, $c7afe5046292bb3e$var$_class = class ProjectExpenseAllocationCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "projectExpenseAllocations",
            modelClass: (0, $iVVsJ.default)
        });
        this.addLookup("expenseAllocationsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseAllocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseAllocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get projectExpenseAllocationsById() {
        return this.modelsById;
    }
    get projectExpenseAllocations() {
        return this.models;
    }
    addProjectExpenseAllocation(data) {
        this.add(data);
    }
    addProjectExpenseAllocations(data) {
        this.addMany(data);
    }
}, $c7afe5046292bb3e$var$_applyDecoratedDescriptor($c7afe5046292bb3e$var$_class.prototype, "addProjectExpenseAllocation", [
    $c7afe5046292bb3e$var$_dec
], Object.getOwnPropertyDescriptor($c7afe5046292bb3e$var$_class.prototype, "addProjectExpenseAllocation"), $c7afe5046292bb3e$var$_class.prototype), $c7afe5046292bb3e$var$_applyDecoratedDescriptor($c7afe5046292bb3e$var$_class.prototype, "addProjectExpenseAllocations", [
    $c7afe5046292bb3e$var$_dec2
], Object.getOwnPropertyDescriptor($c7afe5046292bb3e$var$_class.prototype, "addProjectExpenseAllocations"), $c7afe5046292bb3e$var$_class.prototype), $c7afe5046292bb3e$var$_class);
var $c7afe5046292bb3e$export$2e2bcd8739ae039 = new $c7afe5046292bb3e$var$ProjectExpenseAllocationCollection();
const $c7afe5046292bb3e$export$62a818585501d2ca = $c7afe5046292bb3e$var$ProjectExpenseAllocationCollection;

});
parcelRegister("iVVsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc8a1fb549019a3e$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $h8VDI = parcelRequire("h8VDI");

var $8sHH3 = parcelRequire("8sHH3");

var $fqmGV = parcelRequire("fqmGV");
var $dc8a1fb549019a3e$var$_class, $dc8a1fb549019a3e$var$_descriptor, $dc8a1fb549019a3e$var$_descriptor2, $dc8a1fb549019a3e$var$_descriptor3, $dc8a1fb549019a3e$var$_descriptor4, $dc8a1fb549019a3e$var$_descriptor5;
function $dc8a1fb549019a3e$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $dc8a1fb549019a3e$var$_defineProperty(e, r, t) {
    return (r = $dc8a1fb549019a3e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $dc8a1fb549019a3e$var$_toPropertyKey(t) {
    var i = $dc8a1fb549019a3e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $dc8a1fb549019a3e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dc8a1fb549019a3e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $dc8a1fb549019a3e$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $dc8a1fb549019a3e$var$ProjectExpenseAllocationModel = ($dc8a1fb549019a3e$var$_class = class ProjectExpenseAllocationModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $dc8a1fb549019a3e$var$_initializerDefineProperty(this, "projectId", $dc8a1fb549019a3e$var$_descriptor, this);
        $dc8a1fb549019a3e$var$_initializerDefineProperty(this, "phaseId", $dc8a1fb549019a3e$var$_descriptor2, this);
        $dc8a1fb549019a3e$var$_initializerDefineProperty(this, "expenseId", $dc8a1fb549019a3e$var$_descriptor3, this);
        $dc8a1fb549019a3e$var$_initializerDefineProperty(this, "date", $dc8a1fb549019a3e$var$_descriptor4, this);
        $dc8a1fb549019a3e$var$_initializerDefineProperty(this, "amount", $dc8a1fb549019a3e$var$_descriptor5, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $h8VDI.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get expense() {
        return (0, $8sHH3.default).modelsById[this.expenseId];
    }
}, $dc8a1fb549019a3e$var$_descriptor = $dc8a1fb549019a3e$var$_applyDecoratedDescriptor($dc8a1fb549019a3e$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc8a1fb549019a3e$var$_descriptor2 = $dc8a1fb549019a3e$var$_applyDecoratedDescriptor($dc8a1fb549019a3e$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc8a1fb549019a3e$var$_descriptor3 = $dc8a1fb549019a3e$var$_applyDecoratedDescriptor($dc8a1fb549019a3e$var$_class.prototype, "expenseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc8a1fb549019a3e$var$_descriptor4 = $dc8a1fb549019a3e$var$_applyDecoratedDescriptor($dc8a1fb549019a3e$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc8a1fb549019a3e$var$_descriptor5 = $dc8a1fb549019a3e$var$_applyDecoratedDescriptor($dc8a1fb549019a3e$var$_class.prototype, "amount", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc8a1fb549019a3e$var$_applyDecoratedDescriptor($dc8a1fb549019a3e$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc8a1fb549019a3e$var$_class.prototype, "project"), $dc8a1fb549019a3e$var$_class.prototype), $dc8a1fb549019a3e$var$_applyDecoratedDescriptor($dc8a1fb549019a3e$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc8a1fb549019a3e$var$_class.prototype, "phase"), $dc8a1fb549019a3e$var$_class.prototype), $dc8a1fb549019a3e$var$_applyDecoratedDescriptor($dc8a1fb549019a3e$var$_class.prototype, "expense", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($dc8a1fb549019a3e$var$_class.prototype, "expense"), $dc8a1fb549019a3e$var$_class.prototype), $dc8a1fb549019a3e$var$_class);
var $dc8a1fb549019a3e$export$2e2bcd8739ae039 = $dc8a1fb549019a3e$var$ProjectExpenseAllocationModel;

});


parcelRegister("foua5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3507e6173c64f5c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SupplierCollectionClass", function () { return $b3507e6173c64f5c$export$5a8dcfc08959bb7; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $iW52j = parcelRequire("iW52j");
var $b3507e6173c64f5c$var$_dec, $b3507e6173c64f5c$var$_dec2, $b3507e6173c64f5c$var$_class;
function $b3507e6173c64f5c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $b3507e6173c64f5c$var$SupplierCollection = ($b3507e6173c64f5c$var$_dec = (0, $d8hWe.action).bound, $b3507e6173c64f5c$var$_dec2 = (0, $d8hWe.action).bound, $b3507e6173c64f5c$var$_class = class SupplierCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "suppliers",
            modelClass: (0, $iW52j.default)
        });
        this.addLookup("activeSuppliers", "list", {
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get suppliersById() {
        return this.modelsById;
    }
    get suppliers() {
        return this.models;
    }
    addSupplier(data) {
        this.add(data);
    }
    addSuppliers(data) {
        this.addMany(data);
    }
}, $b3507e6173c64f5c$var$_applyDecoratedDescriptor($b3507e6173c64f5c$var$_class.prototype, "addSupplier", [
    $b3507e6173c64f5c$var$_dec
], Object.getOwnPropertyDescriptor($b3507e6173c64f5c$var$_class.prototype, "addSupplier"), $b3507e6173c64f5c$var$_class.prototype), $b3507e6173c64f5c$var$_applyDecoratedDescriptor($b3507e6173c64f5c$var$_class.prototype, "addSuppliers", [
    $b3507e6173c64f5c$var$_dec2
], Object.getOwnPropertyDescriptor($b3507e6173c64f5c$var$_class.prototype, "addSuppliers"), $b3507e6173c64f5c$var$_class.prototype), $b3507e6173c64f5c$var$_class);
var $b3507e6173c64f5c$export$2e2bcd8739ae039 = new $b3507e6173c64f5c$var$SupplierCollection();
const $b3507e6173c64f5c$export$5a8dcfc08959bb7 = $b3507e6173c64f5c$var$SupplierCollection;

});
parcelRegister("iW52j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc918ce4b70920ca$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $foua5 = parcelRequire("foua5");

var $fqmGV = parcelRequire("fqmGV");
var $dc918ce4b70920ca$var$_class, $dc918ce4b70920ca$var$_descriptor;
function $dc918ce4b70920ca$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $dc918ce4b70920ca$var$_defineProperty(e, r, t) {
    return (r = $dc918ce4b70920ca$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $dc918ce4b70920ca$var$_toPropertyKey(t) {
    var i = $dc918ce4b70920ca$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $dc918ce4b70920ca$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dc918ce4b70920ca$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $dc918ce4b70920ca$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $dc918ce4b70920ca$var$SupplierModel = ($dc918ce4b70920ca$var$_class = class SupplierModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $dc918ce4b70920ca$var$_initializerDefineProperty(this, "name", $dc918ce4b70920ca$var$_descriptor, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $foua5.default);
        this.init(data, options);
    }
}, $dc918ce4b70920ca$var$_descriptor = $dc918ce4b70920ca$var$_applyDecoratedDescriptor($dc918ce4b70920ca$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $dc918ce4b70920ca$var$_class);
var $dc918ce4b70920ca$export$2e2bcd8739ae039 = $dc918ce4b70920ca$var$SupplierModel;

});




parcelRegister("6omGT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a7695e4b9373a25$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectRateCollectionClass", function () { return $4a7695e4b9373a25$export$353aa4820a667e4e; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $giUcg = parcelRequire("giUcg");
var $4a7695e4b9373a25$var$_dec, $4a7695e4b9373a25$var$_dec2, $4a7695e4b9373a25$var$_class;
function $4a7695e4b9373a25$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $4a7695e4b9373a25$var$ProjectRateCollection = ($4a7695e4b9373a25$var$_dec = (0, $d8hWe.action).bound, $4a7695e4b9373a25$var$_dec2 = (0, $d8hWe.action).bound, $4a7695e4b9373a25$var$_class = class ProjectRateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "projectRates",
            modelClass: (0, $giUcg.default)
        });
        this.addLookup("ratesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("ratesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get projectRatesById() {
        return this.modelsById;
    }
    get projectRates() {
        return this.models;
    }
    addProjectRate(data) {
        this.add(data);
    }
    addProjectRates(data) {
        this.addMany(data);
    }
}, $4a7695e4b9373a25$var$_applyDecoratedDescriptor($4a7695e4b9373a25$var$_class.prototype, "addProjectRate", [
    $4a7695e4b9373a25$var$_dec
], Object.getOwnPropertyDescriptor($4a7695e4b9373a25$var$_class.prototype, "addProjectRate"), $4a7695e4b9373a25$var$_class.prototype), $4a7695e4b9373a25$var$_applyDecoratedDescriptor($4a7695e4b9373a25$var$_class.prototype, "addProjectRates", [
    $4a7695e4b9373a25$var$_dec2
], Object.getOwnPropertyDescriptor($4a7695e4b9373a25$var$_class.prototype, "addProjectRates"), $4a7695e4b9373a25$var$_class.prototype), $4a7695e4b9373a25$var$_class);
var $4a7695e4b9373a25$export$2e2bcd8739ae039 = new $4a7695e4b9373a25$var$ProjectRateCollection();
const $4a7695e4b9373a25$export$353aa4820a667e4e = $4a7695e4b9373a25$var$ProjectRateCollection;

});
parcelRegister("giUcg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bde9eb4f90451c19$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $6omGT = parcelRequire("6omGT");

var $8YeUb = parcelRequire("8YeUb");

var $lTrDt = parcelRequire("lTrDt");

var $fqmGV = parcelRequire("fqmGV");
var $bde9eb4f90451c19$var$_class, $bde9eb4f90451c19$var$_descriptor, $bde9eb4f90451c19$var$_descriptor2, $bde9eb4f90451c19$var$_descriptor3, $bde9eb4f90451c19$var$_descriptor4, $bde9eb4f90451c19$var$_descriptor5, $bde9eb4f90451c19$var$_descriptor6, $bde9eb4f90451c19$var$_descriptor7;
function $bde9eb4f90451c19$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $bde9eb4f90451c19$var$_defineProperty(e, r, t) {
    return (r = $bde9eb4f90451c19$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $bde9eb4f90451c19$var$_toPropertyKey(t) {
    var i = $bde9eb4f90451c19$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $bde9eb4f90451c19$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $bde9eb4f90451c19$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $bde9eb4f90451c19$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $bde9eb4f90451c19$var$ProjectRateModel = ($bde9eb4f90451c19$var$_class = class ProjectRateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $bde9eb4f90451c19$var$_initializerDefineProperty(this, "projectId", $bde9eb4f90451c19$var$_descriptor, this);
        $bde9eb4f90451c19$var$_initializerDefineProperty(this, "itemType", $bde9eb4f90451c19$var$_descriptor2, this);
        $bde9eb4f90451c19$var$_initializerDefineProperty(this, "date", $bde9eb4f90451c19$var$_descriptor3, this);
        $bde9eb4f90451c19$var$_initializerDefineProperty(this, "costRate", $bde9eb4f90451c19$var$_descriptor4, this);
        $bde9eb4f90451c19$var$_initializerDefineProperty(this, "chargeOutRate", $bde9eb4f90451c19$var$_descriptor5, this);
        $bde9eb4f90451c19$var$_initializerDefineProperty(this, "itemId", $bde9eb4f90451c19$var$_descriptor6, this);
        $bde9eb4f90451c19$var$_initializerDefineProperty(this, "phaseId", $bde9eb4f90451c19$var$_descriptor7, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $6omGT.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get staff() {
        return (0, $lTrDt.default).modelsById[this.itemId];
    }
    get role() {
        return (0, $8YeUb.default).modelsById[this.itemId];
    }
    get resource() {
        return this.staff || this.role;
    }
}, $bde9eb4f90451c19$var$_descriptor = $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $bde9eb4f90451c19$var$_descriptor2 = $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "itemType", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $bde9eb4f90451c19$var$_descriptor3 = $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $bde9eb4f90451c19$var$_descriptor4 = $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "costRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $bde9eb4f90451c19$var$_descriptor5 = $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $bde9eb4f90451c19$var$_descriptor6 = $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "itemId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $bde9eb4f90451c19$var$_descriptor7 = $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($bde9eb4f90451c19$var$_class.prototype, "project"), $bde9eb4f90451c19$var$_class.prototype), $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($bde9eb4f90451c19$var$_class.prototype, "phase"), $bde9eb4f90451c19$var$_class.prototype), $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($bde9eb4f90451c19$var$_class.prototype, "staff"), $bde9eb4f90451c19$var$_class.prototype), $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($bde9eb4f90451c19$var$_class.prototype, "role"), $bde9eb4f90451c19$var$_class.prototype), $bde9eb4f90451c19$var$_applyDecoratedDescriptor($bde9eb4f90451c19$var$_class.prototype, "resource", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($bde9eb4f90451c19$var$_class.prototype, "resource"), $bde9eb4f90451c19$var$_class.prototype), $bde9eb4f90451c19$var$_class);
var $bde9eb4f90451c19$export$2e2bcd8739ae039 = $bde9eb4f90451c19$var$ProjectRateModel;

});


parcelRegister("5EjDW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41cfece71eb81a01$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BudgetCollectionClass", function () { return $41cfece71eb81a01$export$7a8bad899befefd5; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $dXu4K = parcelRequire("dXu4K");
var $41cfece71eb81a01$var$_dec, $41cfece71eb81a01$var$_dec2, $41cfece71eb81a01$var$_class;
function $41cfece71eb81a01$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $41cfece71eb81a01$var$BudgetCollection = ($41cfece71eb81a01$var$_dec = (0, $d8hWe.action).bound, $41cfece71eb81a01$var$_dec2 = (0, $d8hWe.action).bound, $41cfece71eb81a01$var$_class = class BudgetCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "budgetedHours",
            modelClass: (0, $dXu4K.default)
        });
        this.addLookup("budgetsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByRoleId", "manyByKey", {
            key: (t)=>t.roleId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get budgetsById() {
        return this.modelsById;
    }
    get budgets() {
        return this.models;
    }
    get budgetsById() {
        return this.modelsById;
    }
    addBudget(data) {
        this.add(data);
    }
    addBudgets(data) {
        this.addMany(data);
    }
}, $41cfece71eb81a01$var$_applyDecoratedDescriptor($41cfece71eb81a01$var$_class.prototype, "addBudget", [
    $41cfece71eb81a01$var$_dec
], Object.getOwnPropertyDescriptor($41cfece71eb81a01$var$_class.prototype, "addBudget"), $41cfece71eb81a01$var$_class.prototype), $41cfece71eb81a01$var$_applyDecoratedDescriptor($41cfece71eb81a01$var$_class.prototype, "addBudgets", [
    $41cfece71eb81a01$var$_dec2
], Object.getOwnPropertyDescriptor($41cfece71eb81a01$var$_class.prototype, "addBudgets"), $41cfece71eb81a01$var$_class.prototype), $41cfece71eb81a01$var$_class);
var $41cfece71eb81a01$export$2e2bcd8739ae039 = new $41cfece71eb81a01$var$BudgetCollection();
const $41cfece71eb81a01$export$7a8bad899befefd5 = $41cfece71eb81a01$var$BudgetCollection;

});
parcelRegister("dXu4K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2981d69c53e4142$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $lTrDt = parcelRequire("lTrDt");

var $fqmGV = parcelRequire("fqmGV");

var $kdO1A = parcelRequire("kdO1A");

var $8YeUb = parcelRequire("8YeUb");

var $5EjDW = parcelRequire("5EjDW");
parcelRequire("dgarI");
parcelRequire("g2xwr");

var $5tqXB = parcelRequire("5tqXB");
var $a2981d69c53e4142$var$_dec, $a2981d69c53e4142$var$_class, $a2981d69c53e4142$var$_descriptor, $a2981d69c53e4142$var$_descriptor2, $a2981d69c53e4142$var$_descriptor3, $a2981d69c53e4142$var$_descriptor4, $a2981d69c53e4142$var$_descriptor5;
function $a2981d69c53e4142$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $a2981d69c53e4142$var$_defineProperty(e, r, t) {
    return (r = $a2981d69c53e4142$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a2981d69c53e4142$var$_toPropertyKey(t) {
    var i = $a2981d69c53e4142$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a2981d69c53e4142$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a2981d69c53e4142$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $a2981d69c53e4142$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $a2981d69c53e4142$var$BudgetModel = ($a2981d69c53e4142$var$_dec = (0, $d8hWe.action).bound, $a2981d69c53e4142$var$_class = class BudgetModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $a2981d69c53e4142$var$_initializerDefineProperty(this, "staffId", $a2981d69c53e4142$var$_descriptor, this);
        $a2981d69c53e4142$var$_initializerDefineProperty(this, "roleId", $a2981d69c53e4142$var$_descriptor2, this);
        $a2981d69c53e4142$var$_initializerDefineProperty(this, "projectId", $a2981d69c53e4142$var$_descriptor3, this);
        $a2981d69c53e4142$var$_initializerDefineProperty(this, "phaseId", $a2981d69c53e4142$var$_descriptor4, this);
        $a2981d69c53e4142$var$_initializerDefineProperty(this, "hours", $a2981d69c53e4142$var$_descriptor5, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $5EjDW.default);
        this.init(data, options);
    }
    get resource() {
        return this.staff || this.role;
    }
    get staff() {
        return (0, $lTrDt.default).staffsById[this.staffId];
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get role() {
        return (0, $8YeUb.default).rolesById[this.roleId];
    }
    get costRate() {
        if (!this.resource) return 0;
        return (0, $5tqXB.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "cost", [
            this.startDate,
            this.endDate
        ]);
    }
    get chargeOutRate() {
        if (!this.resource) return 0;
        return (0, $5tqXB.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "chargeOut", [
            this.startDate,
            this.endDate
        ]);
    }
    get cost() {
        return this.hours * this.costRate;
    }
    get chargeOut() {
        return this.hours * this.chargeOutRate;
    }
    rateValueToHours(value, rateType) {
        const rateName = rateType === "availability" ? "weeklyAvailability" : rateType + "Rate";
        this.update({
            hours: value / this[rateName]
        });
    }
    get rates() {
        var _this$resource;
        return (_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.rates.sort((a, b)=>a.date - b.date);
    }
    get startDate() {
        var _this$phase;
        return (_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.startDate;
    }
    get endDate() {
        var _this$phase2;
        return (_this$phase2 = this.phase) === null || _this$phase2 === void 0 ? void 0 : _this$phase2.endDate;
    }
}, $a2981d69c53e4142$var$_descriptor = $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a2981d69c53e4142$var$_descriptor2 = $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a2981d69c53e4142$var$_descriptor3 = $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a2981d69c53e4142$var$_descriptor4 = $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a2981d69c53e4142$var$_descriptor5 = $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "hours", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "resource", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "resource"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "staff"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "phase"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "project"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "role"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "costRate"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "chargeOutRate"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "cost", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "cost"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "chargeOut", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "chargeOut"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "rateValueToHours", [
    $a2981d69c53e4142$var$_dec
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "rateValueToHours"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "rates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "rates"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "startDate"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_applyDecoratedDescriptor($a2981d69c53e4142$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a2981d69c53e4142$var$_class.prototype, "endDate"), $a2981d69c53e4142$var$_class.prototype), $a2981d69c53e4142$var$_class);
var $a2981d69c53e4142$export$2e2bcd8739ae039 = $a2981d69c53e4142$var$BudgetModel;

});
parcelRegister("g2xwr", function(module, exports) {

var $dBifK = parcelRequire("dBifK");

var $dgarI = parcelRequire("dgarI");

var $iVVQG = parcelRequire("iVVQG");
var $bad6d6136c622f97$export$2e2bcd8739ae039 = ({ project: project, phase: phase, staff: staff, role: role }, rateType)=>{
    var _phase$project;
    let resourceRates;
    if (staff && !staff.inheritRateType(rateType)) resourceRates = (0, $iVVQG.default)(staff.rates.sort((a, b)=>a.date - b.date), rateType);
    else if (!staff || staff.inheritRateType(rateType)) {
        role = (staff === null || staff === void 0 ? void 0 : staff.role) || role;
        if (!role) resourceRates = [];
        else if (role.avgRateType(rateType)) resourceRates = (0, $dgarI.combineSpanSets)(role.staff.filter((s)=>!s.inheritRateType(rateType)).map((s)=>(0, $iVVQG.default)(s.rates.sort((a, b)=>a.date - b.date), rateType)), (...values)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(values.filter((v)=>v));
        });
        else resourceRates = (0, $iVVQG.default)(role.rates.sort((a, b)=>a.date - b.date), rateType);
    }
    const projectRates = (0, $iVVQG.default)(((phase === null || phase === void 0 ? void 0 : (_phase$project = phase.project) === null || _phase$project === void 0 ? void 0 : _phase$project.rates) || (project === null || project === void 0 ? void 0 : project.rates) || []).filter((r)=>{
        var _r$phase;
        return (!phase || !r.phase || r.phase === r.project.rootPhase || ((_r$phase = r.phase) === null || _r$phase === void 0 ? void 0 : _r$phase.isRootPhase) || phase.id === r.phase) && (!r.resource || staff && r.staff === staff || !staff && role && r.role === role);
    }).sort((a, b)=>a.date - b.date), rateType);
    const phaseRates = (0, $iVVQG.default)(phase === null || phase === void 0 ? void 0 : phase.rates.filter((r)=>!r.resource || staff && r.staff === staff || !staff && role && r.role === role).sort((a, b)=>a.date - b.date), rateType);
    const combinedSpans = (0, $dgarI.combineSpanSets)([
        phaseRates,
        projectRates,
        resourceRates
    ], (phaseRate, projectRate, resourceRate)=>{
        var _resourceRates$, _resourceRates$2;
        return phaseRate || projectRate || resourceRate || ((_resourceRates$ = resourceRates[1]) === null || _resourceRates$ === void 0 ? void 0 : _resourceRates$.value) || ((_resourceRates$2 = resourceRates[0]) === null || _resourceRates$2 === void 0 ? void 0 : _resourceRates$2.value // to handle potential NaN before first rate
        );
    });
    return combinedSpans;
};

});

parcelRegister("5tqXB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fc492f3a15e0296$export$2e2bcd8739ae039; });

var $egx7S = parcelRequire("egx7S");

var $l150U = parcelRequire("l150U");

var $dBifK = parcelRequire("dBifK");
var $3fc492f3a15e0296$export$2e2bcd8739ae039 = (models, rateType, dateRange)=>{
    var _2, _dateRange$_, _3, _dateRange$_2, _dateRange$, _dateRange$2;
    const now = new Date();
    (_dateRange$_ = dateRange[_2 = 0]) !== null && _dateRange$_ !== void 0 ? _dateRange$_ : dateRange[_2] = now;
    (_dateRange$_2 = dateRange[_3 = 1]) !== null && _dateRange$_2 !== void 0 ? _dateRange$_2 : dateRange[_3] = now;
    if (((_dateRange$ = dateRange[0]) === null || _dateRange$ === void 0 ? void 0 : _dateRange$.getTime()) === ((_dateRange$2 = dateRange[1]) === null || _dateRange$2 === void 0 ? void 0 : _dateRange$2.getTime())) return (0, $l150U.default)(models, rateType, dateRange[0]);
    const businessDays = $3fc492f3a15e0296$var$getBusinessDaysBetweenDates(...dateRange);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(businessDays.map((d)=>{
        return (0, $l150U.default)(models, rateType, d) || 0;
    }));
};
const $3fc492f3a15e0296$var$getBusinessDaysBetweenDates = (startDate, endDate)=>{
    const start = new Date(startDate);
    const end = new Date(endDate);
    const businessDays = [];
    let currentDate = start;
    while(currentDate <= end){
        const day = currentDate.getDay();
        if (![
            0,
            6
        ].includes(day)) businessDays.push(currentDate);
        currentDate = (0, $egx7S.addDays)(currentDate, 1);
    }
    return businessDays;
};

});
parcelRegister("l150U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4cd9493d61ba655$export$2e2bcd8739ae039; });

var $dBifK = parcelRequire("dBifK");
const $f4cd9493d61ba655$var$getCombinedRateAtDate = (models, rateType, date)=>{
    var _date, _role, _staff$role, _role2;
    (_date = date) !== null && _date !== void 0 ? _date : date = new Date();
    let { project: project, phase: phase, staff: staff, role: role } = models;
    const projectId = project === null || project === void 0 ? void 0 : project.id;
    const phaseId = phase === null || phase === void 0 ? void 0 : phase.id;
    const staffId = staff === null || staff === void 0 ? void 0 : staff.id;
    const roleId = ((_role = role) === null || _role === void 0 ? void 0 : _role.id) || (staff === null || staff === void 0 ? void 0 : (_staff$role = staff.role) === null || _staff$role === void 0 ? void 0 : _staff$role.id);
    (_role2 = role) !== null && _role2 !== void 0 ? _role2 : role = staff === null || staff === void 0 ? void 0 : staff.role;
    const matchingProjectRates = ((project === null || project === void 0 ? void 0 : project.rates) || []).filter((x)=>{
        var _x$phase;
        return x.date <= date && (!x.phaseId || ((_x$phase = x.phase) === null || _x$phase === void 0 ? void 0 : _x$phase.isRootPhase) || x.phaseId === phaseId) && (!x.itemId || staffId === x.itemId || roleId === x.itemId);
    }).sort((a, b)=>b.date - a.date);
    const perfectPhaseMatches = matchingProjectRates.filter((x)=>x.phaseId === phaseId);
    const perfectPhaseStaffMatches = perfectPhaseMatches.filter((x)=>x.itemId === staffId);
    const perfectPhaseRoleMatches = perfectPhaseMatches.filter((x)=>x.itemId === roleId);
    const perfectStaffMatches = matchingProjectRates.filter((x)=>x.itemId === staffId);
    const perfectRoleMatches = matchingProjectRates.filter((x)=>x.itemId === roleId);
    const perfectPhaseMatch = perfectPhaseMatches[0] || null;
    const perfectPhaseStaffMatch = perfectPhaseStaffMatches[0] || null;
    const perfectPhaseRoleMatch = perfectPhaseRoleMatches[0] || null;
    const perfectStaffMatch = perfectStaffMatches[0] || null;
    const perfectRoleMatch = perfectRoleMatches[0] || null;
    const projectMatch = matchingProjectRates[0] || null;
    const latestProjectRate = perfectPhaseStaffMatch || perfectPhaseRoleMatch || perfectPhaseMatch || perfectStaffMatch || perfectRoleMatch || projectMatch;
    if (latestProjectRate && [
        "cost",
        "chargeOut"
    ].includes(rateType) && (latestProjectRate === null || latestProjectRate === void 0 ? void 0 : latestProjectRate[rateType + "Rate"]) > 0) return (latestProjectRate === null || latestProjectRate === void 0 ? void 0 : latestProjectRate[rateType + "Rate"]) || 0;
    if (staffId && staff.inheritRateType(rateType) || !staffId && roleId) {
        if (!staffId && role.avgRateType(rateType)) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(role.staff.map((s)=>{
            return $f4cd9493d61ba655$var$getCombinedRateAtDate({
                project: project,
                phase: phase,
                staff: s,
                role: role
            }, rateType, date) || 0;
        }));
        else {
            var _role3;
            const matchingRoleRates = (((_role3 = role) === null || _role3 === void 0 ? void 0 : _role3.rates) || []).filter((x)=>x.date <= date);
            const latestRoleRate = matchingRoleRates.sort((a, b)=>b.date - a.date)[0];
            return (latestRoleRate === null || latestRoleRate === void 0 ? void 0 : latestRoleRate[rateType + "Rate"]) || 0;
        }
    } else {
        const matchingStaffRates = ((staff === null || staff === void 0 ? void 0 : staff.rates) || []).filter((x)=>x.date <= date);
        const latestStaffRate = matchingStaffRates.sort((a, b)=>b.date - a.date)[0];
        return (latestStaffRate === null || latestStaffRate === void 0 ? void 0 : latestStaffRate[rateType + "Rate"]) || 0;
    }
};
var $f4cd9493d61ba655$export$2e2bcd8739ae039 = $f4cd9493d61ba655$var$getCombinedRateAtDate;

});




parcelRegister("4nGBk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $330a5b122b13fa74$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InvoiceLineItemAggregateCollectionClass", function () { return $330a5b122b13fa74$export$649da615b4200d2c; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $5z1wx = parcelRequire("5z1wx");

var $16Zx6 = parcelRequire("16Zx6");
var $330a5b122b13fa74$var$_dec, $330a5b122b13fa74$var$_dec2, $330a5b122b13fa74$var$_class;
function $330a5b122b13fa74$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $330a5b122b13fa74$var$InvoiceLineItemAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $330a5b122b13fa74$var$InvoiceLineItemAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $330a5b122b13fa74$var$InvoiceLineItemAggregateCollection = ($330a5b122b13fa74$var$_dec = (0, $d8hWe.action).bound, $330a5b122b13fa74$var$_dec2 = (0, $d8hWe.action).bound, $330a5b122b13fa74$var$_class = class InvoiceLineItemAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "invoiceLineItems",
            modelClass: (0, $16Zx6.default)
        });
        this.addLookup("lineItemsByInvoiceId", "manyByKey", {
            key: (t)=>t.invoiceId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByContactId", "manyByKey", {
            key: (t)=>t.contactId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByInvoicePhaseId", "manyByKey", {
            key: (t)=>"i" + t.invoiceId + "ph" + (t.phaseId ? t.phaseId : "undefined"),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("lineItemsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get invoiceLineItemsById() {
        return this.modelsById;
    }
    get invoiceLineItems() {
        return this.models;
    }
    get invoiceLineItemsById() {
        return this.modelsById;
    }
    addInvoiceLineItem(data) {
        this.add(data);
    }
    addInvoiceLineItems(data) {
        this.addMany(data);
    }
}, $330a5b122b13fa74$var$_applyDecoratedDescriptor($330a5b122b13fa74$var$_class.prototype, "addInvoiceLineItem", [
    $330a5b122b13fa74$var$_dec
], Object.getOwnPropertyDescriptor($330a5b122b13fa74$var$_class.prototype, "addInvoiceLineItem"), $330a5b122b13fa74$var$_class.prototype), $330a5b122b13fa74$var$_applyDecoratedDescriptor($330a5b122b13fa74$var$_class.prototype, "addInvoiceLineItems", [
    $330a5b122b13fa74$var$_dec2
], Object.getOwnPropertyDescriptor($330a5b122b13fa74$var$_class.prototype, "addInvoiceLineItems"), $330a5b122b13fa74$var$_class.prototype), $330a5b122b13fa74$var$_class);
var $330a5b122b13fa74$export$2e2bcd8739ae039 = new $330a5b122b13fa74$var$InvoiceLineItemAggregate();
const $330a5b122b13fa74$export$649da615b4200d2c = $330a5b122b13fa74$var$InvoiceLineItemAggregateCollection;

});
parcelRegister("5z1wx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40d16734ffe914d0$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $5Xh7w = parcelRequire("5Xh7w");
var $40d16734ffe914d0$var$_dec, $40d16734ffe914d0$var$_dec2, $40d16734ffe914d0$var$_dec3, $40d16734ffe914d0$var$_dec4, $40d16734ffe914d0$var$_class, $40d16734ffe914d0$var$_descriptor;
function $40d16734ffe914d0$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $40d16734ffe914d0$var$_defineProperty(e, r, t) {
    return (r = $40d16734ffe914d0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $40d16734ffe914d0$var$_toPropertyKey(t) {
    var i = $40d16734ffe914d0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $40d16734ffe914d0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $40d16734ffe914d0$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $40d16734ffe914d0$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $40d16734ffe914d0$var$Aggregate = ($40d16734ffe914d0$var$_dec = (0, $d8hWe.action).bound, $40d16734ffe914d0$var$_dec2 = (0, $d8hWe.action).bound, $40d16734ffe914d0$var$_dec3 = (0, $d8hWe.action).bound, $40d16734ffe914d0$var$_dec4 = (0, $d8hWe.action).bound, $40d16734ffe914d0$var$_class = class Aggregate {
    constructor({ collectionClass: collectionClass }){
        $40d16734ffe914d0$var$_initializerDefineProperty(this, "collectionsByGroup", $40d16734ffe914d0$var$_descriptor, this);
        $40d16734ffe914d0$var$_defineProperty(this, "collectionClass", null);
        this.collectionClass = collectionClass;
        (0, $d8hWe.makeObservable)(this);
    }
    get collection() {
        return new this.collectionClass().collection;
    }
    get modelType() {
        return new this.collectionClass().modelType;
    }
    groupByModelId(groupBy, modelData) {
        return this.modelType + String(groupBy.sort().map((prop)=>modelData[prop]));
    }
    groupById(groupBy) {
        return this.modelType + String(groupBy.sort());
    }
    getGroupCollection(groupBy) {
        var _this$collectionsByGr, _this$collectionsByGr2;
        const groupId = this.groupById(groupBy);
        (_this$collectionsByGr2 = (_this$collectionsByGr = this.collectionsByGroup)[groupId]) !== null && _this$collectionsByGr2 !== void 0 ? _this$collectionsByGr2 : _this$collectionsByGr[groupId] = new this.collectionClass();
        return this.collectionsByGroup[groupId];
    }
    add(groupBy, modelData, options) {
        const collection = this.getGroupCollection(groupBy);
        const modelId = this.groupByModelId(groupBy, modelData);
        modelData.id = modelId;
        modelData.id = modelId;
        return collection.add(modelData, options);
    }
    addMany(groupBy, modelDataArray, options) {
        return modelDataArray.map((md)=>this.add(groupBy, md, options));
    }
    clearGroupCollection(groupBy) {
        const groupId = this.groupById(groupBy);
        delete this.collectionsByGroup[groupId];
    }
    clear() {
        const collections = Object.values(this.collectionsByGroup);
        collections.forEach((collection)=>collection.clear());
        this.collectionsByGroup = {};
    }
}, $40d16734ffe914d0$var$_descriptor = $40d16734ffe914d0$var$_applyDecoratedDescriptor($40d16734ffe914d0$var$_class.prototype, "collectionsByGroup", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $40d16734ffe914d0$var$_applyDecoratedDescriptor($40d16734ffe914d0$var$_class.prototype, "groupByModelId", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($40d16734ffe914d0$var$_class.prototype, "groupByModelId"), $40d16734ffe914d0$var$_class.prototype), $40d16734ffe914d0$var$_applyDecoratedDescriptor($40d16734ffe914d0$var$_class.prototype, "groupById", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($40d16734ffe914d0$var$_class.prototype, "groupById"), $40d16734ffe914d0$var$_class.prototype), $40d16734ffe914d0$var$_applyDecoratedDescriptor($40d16734ffe914d0$var$_class.prototype, "getGroupCollection", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($40d16734ffe914d0$var$_class.prototype, "getGroupCollection"), $40d16734ffe914d0$var$_class.prototype), $40d16734ffe914d0$var$_applyDecoratedDescriptor($40d16734ffe914d0$var$_class.prototype, "add", [
    $40d16734ffe914d0$var$_dec
], Object.getOwnPropertyDescriptor($40d16734ffe914d0$var$_class.prototype, "add"), $40d16734ffe914d0$var$_class.prototype), $40d16734ffe914d0$var$_applyDecoratedDescriptor($40d16734ffe914d0$var$_class.prototype, "addMany", [
    $40d16734ffe914d0$var$_dec2
], Object.getOwnPropertyDescriptor($40d16734ffe914d0$var$_class.prototype, "addMany"), $40d16734ffe914d0$var$_class.prototype), $40d16734ffe914d0$var$_applyDecoratedDescriptor($40d16734ffe914d0$var$_class.prototype, "clearGroupCollection", [
    $40d16734ffe914d0$var$_dec3
], Object.getOwnPropertyDescriptor($40d16734ffe914d0$var$_class.prototype, "clearGroupCollection"), $40d16734ffe914d0$var$_class.prototype), $40d16734ffe914d0$var$_applyDecoratedDescriptor($40d16734ffe914d0$var$_class.prototype, "clear", [
    $40d16734ffe914d0$var$_dec4
], Object.getOwnPropertyDescriptor($40d16734ffe914d0$var$_class.prototype, "clear"), $40d16734ffe914d0$var$_class.prototype), $40d16734ffe914d0$var$_class);
var $40d16734ffe914d0$export$2e2bcd8739ae039 = $40d16734ffe914d0$var$Aggregate;

});

parcelRegister("16Zx6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf615213603af67$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $4sGvn = parcelRequire("4sGvn");

var $PIDKX = parcelRequire("PIDKX");

var $4nGBk = parcelRequire("4nGBk");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $fqmGV = parcelRequire("fqmGV");
var $0cf615213603af67$var$_class, $0cf615213603af67$var$_descriptor, $0cf615213603af67$var$_descriptor2, $0cf615213603af67$var$_descriptor3, $0cf615213603af67$var$_descriptor4, $0cf615213603af67$var$_descriptor5;
function $0cf615213603af67$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $0cf615213603af67$var$_defineProperty(e, r, t) {
    return (r = $0cf615213603af67$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0cf615213603af67$var$_toPropertyKey(t) {
    var i = $0cf615213603af67$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0cf615213603af67$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0cf615213603af67$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $0cf615213603af67$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $0cf615213603af67$var$InvoiceLineItemAggregateModel = ($0cf615213603af67$var$_class = class InvoiceLineItemAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $0cf615213603af67$var$_initializerDefineProperty(this, "projectId", $0cf615213603af67$var$_descriptor, this);
        $0cf615213603af67$var$_initializerDefineProperty(this, "contactId", $0cf615213603af67$var$_descriptor2, this);
        $0cf615213603af67$var$_initializerDefineProperty(this, "phaseId", $0cf615213603af67$var$_descriptor3, this);
        $0cf615213603af67$var$_initializerDefineProperty(this, "billingType", $0cf615213603af67$var$_descriptor4, this);
        $0cf615213603af67$var$_initializerDefineProperty(this, "amount", $0cf615213603af67$var$_descriptor5, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $4nGBk.default);
        this.init(data, options);
    }
    get invoice() {
        return (0, $PIDKX.default).invoicesById[this.invoiceId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get contact() {
        return (0, $4sGvn.default).contactsById[this.contactId];
    }
}, $0cf615213603af67$var$_descriptor = $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0cf615213603af67$var$_descriptor2 = $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "contactId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0cf615213603af67$var$_descriptor3 = $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0cf615213603af67$var$_descriptor4 = $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "billingType", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0cf615213603af67$var$_descriptor5 = $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "amount", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "invoice", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0cf615213603af67$var$_class.prototype, "invoice"), $0cf615213603af67$var$_class.prototype), $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0cf615213603af67$var$_class.prototype, "project"), $0cf615213603af67$var$_class.prototype), $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0cf615213603af67$var$_class.prototype, "phase"), $0cf615213603af67$var$_class.prototype), $0cf615213603af67$var$_applyDecoratedDescriptor($0cf615213603af67$var$_class.prototype, "contact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0cf615213603af67$var$_class.prototype, "contact"), $0cf615213603af67$var$_class.prototype), $0cf615213603af67$var$_class);
var $0cf615213603af67$export$2e2bcd8739ae039 = $0cf615213603af67$var$InvoiceLineItemAggregateModel;

});


parcelRegister("1Nfhh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e637debbe2aad2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TimeEntryAggregateCollectionClass", function () { return $14e637debbe2aad2$export$debcd62ea0d4cde0; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $4Ndf7 = parcelRequire("4Ndf7");

var $5z1wx = parcelRequire("5z1wx");
parcelRequire("5Xh7w");

var $iCTvZ = parcelRequire("iCTvZ");
var $14e637debbe2aad2$var$_dec, $14e637debbe2aad2$var$_dec2, $14e637debbe2aad2$var$_class;
function $14e637debbe2aad2$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $14e637debbe2aad2$var$TimeEntryAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $14e637debbe2aad2$var$TimeEntryAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $14e637debbe2aad2$var$TimeEntryAggregateCollection = ($14e637debbe2aad2$var$_dec = (0, $d8hWe.action).bound, $14e637debbe2aad2$var$_dec2 = (0, $d8hWe.action).bound, $14e637debbe2aad2$var$_class = class TimeEntryAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "timeEntries",
            modelClass: (0, $4Ndf7.default)
        });
        this.addLookup("timeEntriesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("timeEntriesByModelTuple", "manyByMany", {
            keys: (t)=>{
                var _t$project, _t$phase, _t$role, _t$staff2, _t$project2, _t$phase2, _t$project3, _t$role2, _t$project4, _t$staff3, _t$phase3, _t$role3, _t$phase4, _t$staff4, _t$role4, _t$staff5, _t$project5, _t$phase5, _t$role5, _t$project6, _t$phase6, _t$staff6, _t$project7, _t$role6, _t$staff7, _t$phase7, _t$role7, _t$staff8, _t$project8, _t$phase8, _t$role8, _t$staff9;
                return [
                    (0, $iCTvZ.default)((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.id, undefined, undefined, undefined),
                    (0, $iCTvZ.default)(undefined, (_t$phase = t.phase) === null || _t$phase === void 0 ? void 0 : _t$phase.id, undefined, undefined),
                    (0, $iCTvZ.default)(undefined, undefined, (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.id, undefined),
                    (0, $iCTvZ.default)(undefined, undefined, undefined, (_t$staff2 = t.staff) === null || _t$staff2 === void 0 ? void 0 : _t$staff2.id),
                    (0, $iCTvZ.default)((_t$project2 = t.project) === null || _t$project2 === void 0 ? void 0 : _t$project2.id, (_t$phase2 = t.phase) === null || _t$phase2 === void 0 ? void 0 : _t$phase2.id, undefined, undefined),
                    (0, $iCTvZ.default)((_t$project3 = t.project) === null || _t$project3 === void 0 ? void 0 : _t$project3.id, undefined, (_t$role2 = t.role) === null || _t$role2 === void 0 ? void 0 : _t$role2.id, undefined),
                    (0, $iCTvZ.default)((_t$project4 = t.project) === null || _t$project4 === void 0 ? void 0 : _t$project4.id, undefined, undefined, (_t$staff3 = t.staff) === null || _t$staff3 === void 0 ? void 0 : _t$staff3.id),
                    (0, $iCTvZ.default)(undefined, (_t$phase3 = t.phase) === null || _t$phase3 === void 0 ? void 0 : _t$phase3.id, (_t$role3 = t.role) === null || _t$role3 === void 0 ? void 0 : _t$role3.id, undefined),
                    (0, $iCTvZ.default)(undefined, (_t$phase4 = t.phase) === null || _t$phase4 === void 0 ? void 0 : _t$phase4.id, undefined, (_t$staff4 = t.staff) === null || _t$staff4 === void 0 ? void 0 : _t$staff4.id),
                    (0, $iCTvZ.default)(undefined, undefined, (_t$role4 = t.role) === null || _t$role4 === void 0 ? void 0 : _t$role4.id, (_t$staff5 = t.staff) === null || _t$staff5 === void 0 ? void 0 : _t$staff5.id),
                    (0, $iCTvZ.default)((_t$project5 = t.project) === null || _t$project5 === void 0 ? void 0 : _t$project5.id, (_t$phase5 = t.phase) === null || _t$phase5 === void 0 ? void 0 : _t$phase5.id, (_t$role5 = t.role) === null || _t$role5 === void 0 ? void 0 : _t$role5.id, undefined),
                    (0, $iCTvZ.default)((_t$project6 = t.project) === null || _t$project6 === void 0 ? void 0 : _t$project6.id, (_t$phase6 = t.phase) === null || _t$phase6 === void 0 ? void 0 : _t$phase6.id, undefined, (_t$staff6 = t.staff) === null || _t$staff6 === void 0 ? void 0 : _t$staff6.id),
                    (0, $iCTvZ.default)((_t$project7 = t.project) === null || _t$project7 === void 0 ? void 0 : _t$project7.id, undefined, (_t$role6 = t.role) === null || _t$role6 === void 0 ? void 0 : _t$role6.id, (_t$staff7 = t.staff) === null || _t$staff7 === void 0 ? void 0 : _t$staff7.id),
                    (0, $iCTvZ.default)(undefined, (_t$phase7 = t.phase) === null || _t$phase7 === void 0 ? void 0 : _t$phase7.id, (_t$role7 = t.role) === null || _t$role7 === void 0 ? void 0 : _t$role7.id, (_t$staff8 = t.staff) === null || _t$staff8 === void 0 ? void 0 : _t$staff8.id),
                    (0, $iCTvZ.default)((_t$project8 = t.project) === null || _t$project8 === void 0 ? void 0 : _t$project8.id, (_t$phase8 = t.phase) === null || _t$phase8 === void 0 ? void 0 : _t$phase8.id, (_t$role8 = t.role) === null || _t$role8 === void 0 ? void 0 : _t$role8.id, (_t$staff9 = t.staff) === null || _t$staff9 === void 0 ? void 0 : _t$staff9.id)
                ];
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get timeEntriesById() {
        return this.modelsById;
    }
    get timeEntries() {
        return this.models;
    }
    get timeEntriesById() {
        return this.modelsById;
    }
    addTimeEntry(data) {
        this.add(data);
    }
    addTimeEntries(data) {
        this.addMany(data);
    }
}, $14e637debbe2aad2$var$_applyDecoratedDescriptor($14e637debbe2aad2$var$_class.prototype, "addTimeEntry", [
    $14e637debbe2aad2$var$_dec
], Object.getOwnPropertyDescriptor($14e637debbe2aad2$var$_class.prototype, "addTimeEntry"), $14e637debbe2aad2$var$_class.prototype), $14e637debbe2aad2$var$_applyDecoratedDescriptor($14e637debbe2aad2$var$_class.prototype, "addTimeEntries", [
    $14e637debbe2aad2$var$_dec2
], Object.getOwnPropertyDescriptor($14e637debbe2aad2$var$_class.prototype, "addTimeEntries"), $14e637debbe2aad2$var$_class.prototype), $14e637debbe2aad2$var$_class);
var $14e637debbe2aad2$export$2e2bcd8739ae039 = new $14e637debbe2aad2$var$TimeEntryAggregate();
const $14e637debbe2aad2$export$debcd62ea0d4cde0 = $14e637debbe2aad2$var$TimeEntryAggregateCollection;

});
parcelRegister("4Ndf7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37d602c646243412$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");

var $fqmGV = parcelRequire("fqmGV");

var $1Nfhh = parcelRequire("1Nfhh");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $37d602c646243412$var$_class, $37d602c646243412$var$_descriptor, $37d602c646243412$var$_descriptor2, $37d602c646243412$var$_descriptor3, $37d602c646243412$var$_descriptor4, $37d602c646243412$var$_descriptor5, $37d602c646243412$var$_descriptor6, $37d602c646243412$var$_descriptor7, $37d602c646243412$var$_descriptor8, $37d602c646243412$var$_descriptor9, $37d602c646243412$var$_descriptor10, $37d602c646243412$var$_descriptor11;
function $37d602c646243412$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $37d602c646243412$var$_defineProperty(e, r, t) {
    return (r = $37d602c646243412$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $37d602c646243412$var$_toPropertyKey(t) {
    var i = $37d602c646243412$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $37d602c646243412$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $37d602c646243412$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $37d602c646243412$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $37d602c646243412$var$TimeEntryAggregateModel = ($37d602c646243412$var$_class = class TimeEntryAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $37d602c646243412$var$_initializerDefineProperty(this, "staffId", $37d602c646243412$var$_descriptor, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "projectId", $37d602c646243412$var$_descriptor2, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "phaseId", $37d602c646243412$var$_descriptor3, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "month", $37d602c646243412$var$_descriptor4, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "numMinutes", $37d602c646243412$var$_descriptor5, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "pay", $37d602c646243412$var$_descriptor6, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "cost", $37d602c646243412$var$_descriptor7, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "chargeOut", $37d602c646243412$var$_descriptor8, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "isBillable", $37d602c646243412$var$_descriptor9, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "isVariation", $37d602c646243412$var$_descriptor10, this);
        $37d602c646243412$var$_initializerDefineProperty(this, "beenInvoiced", $37d602c646243412$var$_descriptor11, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $1Nfhh.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role) || (0, $8YeUb.default).modelsById[this.roleId];
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get date() {
        return this._date || (0, $egx7S.parse)(this.month, "yyyy-MM", new Date());
    }
    get startDate() {
        return (0, $egx7S.startOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get endDate() {
        return (0, $egx7S.endOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get hours() {
        return this.numMinutes / 60;
    }
}, $37d602c646243412$var$_descriptor = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $37d602c646243412$var$_descriptor2 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $37d602c646243412$var$_descriptor3 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $37d602c646243412$var$_descriptor4 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "month", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $37d602c646243412$var$_descriptor5 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $37d602c646243412$var$_descriptor6 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $37d602c646243412$var$_descriptor7 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $37d602c646243412$var$_descriptor8 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "chargeOut", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $37d602c646243412$var$_descriptor9 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "isBillable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $37d602c646243412$var$_descriptor10 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "isVariation", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $37d602c646243412$var$_descriptor11 = $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "beenInvoiced", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($37d602c646243412$var$_class.prototype, "staff"), $37d602c646243412$var$_class.prototype), $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($37d602c646243412$var$_class.prototype, "role"), $37d602c646243412$var$_class.prototype), $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($37d602c646243412$var$_class.prototype, "project"), $37d602c646243412$var$_class.prototype), $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($37d602c646243412$var$_class.prototype, "phase"), $37d602c646243412$var$_class.prototype), $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($37d602c646243412$var$_class.prototype, "date"), $37d602c646243412$var$_class.prototype), $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($37d602c646243412$var$_class.prototype, "startDate"), $37d602c646243412$var$_class.prototype), $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($37d602c646243412$var$_class.prototype, "endDate"), $37d602c646243412$var$_class.prototype), $37d602c646243412$var$_applyDecoratedDescriptor($37d602c646243412$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($37d602c646243412$var$_class.prototype, "hours"), $37d602c646243412$var$_class.prototype), $37d602c646243412$var$_class);
var $37d602c646243412$export$2e2bcd8739ae039 = $37d602c646243412$var$TimeEntryAggregateModel;

});


parcelRegister("itgIJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d727e7c877c4cbaa$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectNoteCollectionClass", function () { return $d727e7c877c4cbaa$export$6e7f6fc112bd9aaa; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $iQR2i = parcelRequire("iQR2i");
var $d727e7c877c4cbaa$var$_dec, $d727e7c877c4cbaa$var$_dec2, $d727e7c877c4cbaa$var$_class;
function $d727e7c877c4cbaa$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $d727e7c877c4cbaa$var$ProjectNoteCollection = ($d727e7c877c4cbaa$var$_dec = (0, $d8hWe.action).bound, $d727e7c877c4cbaa$var$_dec2 = (0, $d8hWe.action).bound, $d727e7c877c4cbaa$var$_class = class ProjectNoteCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "projectNotes",
            modelClass: (0, $iQR2i.default)
        });
        this.addLookup("notesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("notesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get notesById() {
        return this.modelsById;
    }
    get notes() {
        return this.models;
    }
    addNote(data) {
        this.add(data);
    }
    addNotes(data) {
        this.addMany(data);
    }
}, $d727e7c877c4cbaa$var$_applyDecoratedDescriptor($d727e7c877c4cbaa$var$_class.prototype, "addNote", [
    $d727e7c877c4cbaa$var$_dec
], Object.getOwnPropertyDescriptor($d727e7c877c4cbaa$var$_class.prototype, "addNote"), $d727e7c877c4cbaa$var$_class.prototype), $d727e7c877c4cbaa$var$_applyDecoratedDescriptor($d727e7c877c4cbaa$var$_class.prototype, "addNotes", [
    $d727e7c877c4cbaa$var$_dec2
], Object.getOwnPropertyDescriptor($d727e7c877c4cbaa$var$_class.prototype, "addNotes"), $d727e7c877c4cbaa$var$_class.prototype), $d727e7c877c4cbaa$var$_class);
var $d727e7c877c4cbaa$export$2e2bcd8739ae039 = new $d727e7c877c4cbaa$var$ProjectNoteCollection();
const $d727e7c877c4cbaa$export$6e7f6fc112bd9aaa = $d727e7c877c4cbaa$var$ProjectNoteCollection;

});
parcelRegister("iQR2i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db96392de4932685$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $itgIJ = parcelRequire("itgIJ");

var $fqmGV = parcelRequire("fqmGV");
var $db96392de4932685$var$_class, $db96392de4932685$var$_descriptor, $db96392de4932685$var$_descriptor2, $db96392de4932685$var$_descriptor3, $db96392de4932685$var$_descriptor4;
function $db96392de4932685$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $db96392de4932685$var$_defineProperty(e, r, t) {
    return (r = $db96392de4932685$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $db96392de4932685$var$_toPropertyKey(t) {
    var i = $db96392de4932685$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $db96392de4932685$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $db96392de4932685$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $db96392de4932685$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $db96392de4932685$var$ProjectNoteModel = ($db96392de4932685$var$_class = class ProjectNoteModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $db96392de4932685$var$_initializerDefineProperty(this, "date", $db96392de4932685$var$_descriptor, this);
        $db96392de4932685$var$_initializerDefineProperty(this, "description", $db96392de4932685$var$_descriptor2, this);
        $db96392de4932685$var$_initializerDefineProperty(this, "projectId", $db96392de4932685$var$_descriptor3, this);
        $db96392de4932685$var$_initializerDefineProperty(this, "phaseId", $db96392de4932685$var$_descriptor4, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $itgIJ.default);
        this.init(data, options);
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
}, $db96392de4932685$var$_descriptor = $db96392de4932685$var$_applyDecoratedDescriptor($db96392de4932685$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $db96392de4932685$var$_descriptor2 = $db96392de4932685$var$_applyDecoratedDescriptor($db96392de4932685$var$_class.prototype, "description", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $db96392de4932685$var$_descriptor3 = $db96392de4932685$var$_applyDecoratedDescriptor($db96392de4932685$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $db96392de4932685$var$_descriptor4 = $db96392de4932685$var$_applyDecoratedDescriptor($db96392de4932685$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $db96392de4932685$var$_applyDecoratedDescriptor($db96392de4932685$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($db96392de4932685$var$_class.prototype, "phase"), $db96392de4932685$var$_class.prototype), $db96392de4932685$var$_applyDecoratedDescriptor($db96392de4932685$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($db96392de4932685$var$_class.prototype, "project"), $db96392de4932685$var$_class.prototype), $db96392de4932685$var$_class);
var $db96392de4932685$export$2e2bcd8739ae039 = $db96392de4932685$var$ProjectNoteModel;

});


parcelRegister("fpkTk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3796567247715ea$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RevenueTargetCollectionClass", function () { return $b3796567247715ea$export$53bbc56d3b16a709; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $ecvfS = parcelRequire("ecvfS");
var $b3796567247715ea$var$_dec, $b3796567247715ea$var$_dec2, $b3796567247715ea$var$_class;
function $b3796567247715ea$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $b3796567247715ea$var$RevenueTargetCollection = ($b3796567247715ea$var$_dec = (0, $d8hWe.action).bound, $b3796567247715ea$var$_dec2 = (0, $d8hWe.action).bound, $b3796567247715ea$var$_class = class RevenueTargetCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "revenueTargets",
            modelClass: (0, $ecvfS.default)
        });
        this.addLookup("revenueTargetsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("revenueTargetsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get revenueTargetsById() {
        return this.modelsById;
    }
    get revenueTargets() {
        return this.models;
    }
    addRevenueTarget(data, options) {
        return this.add(data, options);
    }
    addRevenueTargets(data, options) {
        return this.addMany(data, options);
    }
}, $b3796567247715ea$var$_applyDecoratedDescriptor($b3796567247715ea$var$_class.prototype, "addRevenueTarget", [
    $b3796567247715ea$var$_dec
], Object.getOwnPropertyDescriptor($b3796567247715ea$var$_class.prototype, "addRevenueTarget"), $b3796567247715ea$var$_class.prototype), $b3796567247715ea$var$_applyDecoratedDescriptor($b3796567247715ea$var$_class.prototype, "addRevenueTargets", [
    $b3796567247715ea$var$_dec2
], Object.getOwnPropertyDescriptor($b3796567247715ea$var$_class.prototype, "addRevenueTargets"), $b3796567247715ea$var$_class.prototype), $b3796567247715ea$var$_class);
var $b3796567247715ea$export$2e2bcd8739ae039 = new $b3796567247715ea$var$RevenueTargetCollection();
const $b3796567247715ea$export$53bbc56d3b16a709 = $b3796567247715ea$var$RevenueTargetCollection;

});
parcelRegister("ecvfS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a56a6e45875399ba$export$2e2bcd8739ae039; });
parcelRequire("cjCbh");

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $fpkTk = parcelRequire("fpkTk");

var $fqmGV = parcelRequire("fqmGV");
var $a56a6e45875399ba$var$_class, $a56a6e45875399ba$var$_descriptor, $a56a6e45875399ba$var$_descriptor2, $a56a6e45875399ba$var$_descriptor3, $a56a6e45875399ba$var$_descriptor4;
function $a56a6e45875399ba$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $a56a6e45875399ba$var$_defineProperty(e, r, t) {
    return (r = $a56a6e45875399ba$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a56a6e45875399ba$var$_toPropertyKey(t) {
    var i = $a56a6e45875399ba$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a56a6e45875399ba$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a56a6e45875399ba$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $a56a6e45875399ba$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $a56a6e45875399ba$var$RevenueTargetModel = ($a56a6e45875399ba$var$_class = class RevenueTargetModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $a56a6e45875399ba$var$_initializerDefineProperty(this, "projectId", $a56a6e45875399ba$var$_descriptor, this);
        $a56a6e45875399ba$var$_initializerDefineProperty(this, "phaseId", $a56a6e45875399ba$var$_descriptor2, this);
        $a56a6e45875399ba$var$_initializerDefineProperty(this, "date", $a56a6e45875399ba$var$_descriptor3, this);
        $a56a6e45875399ba$var$_initializerDefineProperty(this, "amount", $a56a6e45875399ba$var$_descriptor4, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $fpkTk.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get amountAdjustedByLikelihood() {
        var _this$phase, _this$phase2;
        if ([
            "prospective",
            "onHold"
        ].includes((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.status) && (_this$phase2 = this.phase) !== null && _this$phase2 !== void 0 && _this$phase2.percentLikelihood) {
            var _this$phase3;
            return this.amount * (((_this$phase3 = this.phase) === null || _this$phase3 === void 0 ? void 0 : _this$phase3.percentLikelihood) / 100);
        } else return this.amount;
    }
}, $a56a6e45875399ba$var$_descriptor = $a56a6e45875399ba$var$_applyDecoratedDescriptor($a56a6e45875399ba$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a56a6e45875399ba$var$_descriptor2 = $a56a6e45875399ba$var$_applyDecoratedDescriptor($a56a6e45875399ba$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a56a6e45875399ba$var$_descriptor3 = $a56a6e45875399ba$var$_applyDecoratedDescriptor($a56a6e45875399ba$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $a56a6e45875399ba$var$_descriptor4 = $a56a6e45875399ba$var$_applyDecoratedDescriptor($a56a6e45875399ba$var$_class.prototype, "amount", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a56a6e45875399ba$var$_applyDecoratedDescriptor($a56a6e45875399ba$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a56a6e45875399ba$var$_class.prototype, "project"), $a56a6e45875399ba$var$_class.prototype), $a56a6e45875399ba$var$_applyDecoratedDescriptor($a56a6e45875399ba$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a56a6e45875399ba$var$_class.prototype, "phase"), $a56a6e45875399ba$var$_class.prototype), $a56a6e45875399ba$var$_applyDecoratedDescriptor($a56a6e45875399ba$var$_class.prototype, "amountAdjustedByLikelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a56a6e45875399ba$var$_class.prototype, "amountAdjustedByLikelihood"), $a56a6e45875399ba$var$_class.prototype), $a56a6e45875399ba$var$_class);
var $a56a6e45875399ba$export$2e2bcd8739ae039 = $a56a6e45875399ba$var$RevenueTargetModel;

});


parcelRegister("hwZYE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc35803acec27c2f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ChangeLogCollectionClass", function () { return $cc35803acec27c2f$export$5f370d5d1485773b; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");
parcelRequire("iQR2i");

var $hhboy = parcelRequire("hhboy");
var $cc35803acec27c2f$var$_dec, $cc35803acec27c2f$var$_dec2, $cc35803acec27c2f$var$_class;
function $cc35803acec27c2f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $cc35803acec27c2f$var$ChangeLogCollection = ($cc35803acec27c2f$var$_dec = (0, $d8hWe.action).bound, $cc35803acec27c2f$var$_dec2 = (0, $d8hWe.action).bound, $cc35803acec27c2f$var$_class = class ChangeLogCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "changeLogItems",
            modelClass: (0, $hhboy.default)
        });
        this.addLookup("changeLogItemsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("changeLogItemsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get changeLogItemsById() {
        return this.modelsById;
    }
    get changeLogItems() {
        return this.models;
    }
    get changeLogItemsById() {
        return this.modelsById;
    }
    addChangeLogItem(data) {
        this.add(data);
    }
    addChangeLogItems(data) {
        this.addMany(data);
    }
}, $cc35803acec27c2f$var$_applyDecoratedDescriptor($cc35803acec27c2f$var$_class.prototype, "addChangeLogItem", [
    $cc35803acec27c2f$var$_dec
], Object.getOwnPropertyDescriptor($cc35803acec27c2f$var$_class.prototype, "addChangeLogItem"), $cc35803acec27c2f$var$_class.prototype), $cc35803acec27c2f$var$_applyDecoratedDescriptor($cc35803acec27c2f$var$_class.prototype, "addChangeLogItems", [
    $cc35803acec27c2f$var$_dec2
], Object.getOwnPropertyDescriptor($cc35803acec27c2f$var$_class.prototype, "addChangeLogItems"), $cc35803acec27c2f$var$_class.prototype), $cc35803acec27c2f$var$_class);
var $cc35803acec27c2f$export$2e2bcd8739ae039 = new $cc35803acec27c2f$var$ChangeLogCollection();
const $cc35803acec27c2f$export$5f370d5d1485773b = $cc35803acec27c2f$var$ChangeLogCollection;

});
parcelRegister("hhboy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c93cdcff6e504a0e$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $hwZYE = parcelRequire("hwZYE");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $fqmGV = parcelRequire("fqmGV");
var $c93cdcff6e504a0e$var$_class, $c93cdcff6e504a0e$var$_descriptor, $c93cdcff6e504a0e$var$_descriptor2, $c93cdcff6e504a0e$var$_descriptor3, $c93cdcff6e504a0e$var$_descriptor4, $c93cdcff6e504a0e$var$_descriptor5, $c93cdcff6e504a0e$var$_descriptor6, $c93cdcff6e504a0e$var$_descriptor7, $c93cdcff6e504a0e$var$_descriptor8;
function $c93cdcff6e504a0e$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c93cdcff6e504a0e$var$_defineProperty(e, r, t) {
    return (r = $c93cdcff6e504a0e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c93cdcff6e504a0e$var$_toPropertyKey(t) {
    var i = $c93cdcff6e504a0e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c93cdcff6e504a0e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c93cdcff6e504a0e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c93cdcff6e504a0e$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c93cdcff6e504a0e$var$ChangeLogModel = ($c93cdcff6e504a0e$var$_class = class ChangeLogModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $c93cdcff6e504a0e$var$_initializerDefineProperty(this, "date", $c93cdcff6e504a0e$var$_descriptor, this);
        $c93cdcff6e504a0e$var$_initializerDefineProperty(this, "title", $c93cdcff6e504a0e$var$_descriptor2, this);
        $c93cdcff6e504a0e$var$_initializerDefineProperty(this, "revenueType", $c93cdcff6e504a0e$var$_descriptor3, this);
        $c93cdcff6e504a0e$var$_initializerDefineProperty(this, "revenue", $c93cdcff6e504a0e$var$_descriptor4, this);
        $c93cdcff6e504a0e$var$_initializerDefineProperty(this, "expenses", $c93cdcff6e504a0e$var$_descriptor5, this);
        $c93cdcff6e504a0e$var$_initializerDefineProperty(this, "percentProgress", $c93cdcff6e504a0e$var$_descriptor6, this);
        $c93cdcff6e504a0e$var$_initializerDefineProperty(this, "projectId", $c93cdcff6e504a0e$var$_descriptor7, this);
        $c93cdcff6e504a0e$var$_initializerDefineProperty(this, "phaseId", $c93cdcff6e504a0e$var$_descriptor8, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $hwZYE.default);
        this.init(data, options);
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
}, $c93cdcff6e504a0e$var$_descriptor = $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c93cdcff6e504a0e$var$_descriptor2 = $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "title", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c93cdcff6e504a0e$var$_descriptor3 = $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "revenueType", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c93cdcff6e504a0e$var$_descriptor4 = $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "revenue", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c93cdcff6e504a0e$var$_descriptor5 = $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "expenses", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c93cdcff6e504a0e$var$_descriptor6 = $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "percentProgress", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c93cdcff6e504a0e$var$_descriptor7 = $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c93cdcff6e504a0e$var$_descriptor8 = $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($c93cdcff6e504a0e$var$_class.prototype, "phase"), $c93cdcff6e504a0e$var$_class.prototype), $c93cdcff6e504a0e$var$_applyDecoratedDescriptor($c93cdcff6e504a0e$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($c93cdcff6e504a0e$var$_class.prototype, "project"), $c93cdcff6e504a0e$var$_class.prototype), $c93cdcff6e504a0e$var$_class);
var $c93cdcff6e504a0e$export$2e2bcd8739ae039 = $c93cdcff6e504a0e$var$ChangeLogModel;

});


parcelRegister("2F6ay", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f0432306a74f982$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MonthlyAllocationCollectionClass", function () { return $1f0432306a74f982$export$8c2a7cbfa9d4b9db; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $2vNGQ = parcelRequire("2vNGQ");

var $iCTvZ = parcelRequire("iCTvZ");

var $egx7S = parcelRequire("egx7S");
var $1f0432306a74f982$var$_dec, $1f0432306a74f982$var$_dec2, $1f0432306a74f982$var$_dec3, $1f0432306a74f982$var$_class;
function $1f0432306a74f982$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $1f0432306a74f982$var$MonthlyAllocationCollection = ($1f0432306a74f982$var$_dec = (0, $d8hWe.action).bound, $1f0432306a74f982$var$_dec2 = (0, $d8hWe.action).bound, $1f0432306a74f982$var$_dec3 = (0, $d8hWe.action).bound, $1f0432306a74f982$var$_class = class MonthlyAllocationCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "monthlyAllocations",
            modelClass: (0, $2vNGQ.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $iCTvZ.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $iCTvZ.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data, options) {
        this.add(data, options);
    }
    addAllocations(data, options) {
        this.addMany(data, options);
    }
    addAllocationsAcrossDateRange(dateRange, data, options) {
        const workingDays = [];
        let date = dateRange[0];
        while(date <= dateRange[1]){
            if (!(0, $egx7S.isWeekend)(date)) workingDays.push(date);
            date = (0, $egx7S.addDays)(date, 1);
        }
        const numMinutes = data.numMinutes / workingDays.length;
        this.addMany(workingDays.map((date)=>({
                ...data,
                date: date,
                numMinutes: numMinutes
            })), options);
    }
}, $1f0432306a74f982$var$_applyDecoratedDescriptor($1f0432306a74f982$var$_class.prototype, "addAllocation", [
    $1f0432306a74f982$var$_dec
], Object.getOwnPropertyDescriptor($1f0432306a74f982$var$_class.prototype, "addAllocation"), $1f0432306a74f982$var$_class.prototype), $1f0432306a74f982$var$_applyDecoratedDescriptor($1f0432306a74f982$var$_class.prototype, "addAllocations", [
    $1f0432306a74f982$var$_dec2
], Object.getOwnPropertyDescriptor($1f0432306a74f982$var$_class.prototype, "addAllocations"), $1f0432306a74f982$var$_class.prototype), $1f0432306a74f982$var$_applyDecoratedDescriptor($1f0432306a74f982$var$_class.prototype, "addAllocationsAcrossDateRange", [
    $1f0432306a74f982$var$_dec3
], Object.getOwnPropertyDescriptor($1f0432306a74f982$var$_class.prototype, "addAllocationsAcrossDateRange"), $1f0432306a74f982$var$_class.prototype), $1f0432306a74f982$var$_class);
var $1f0432306a74f982$export$2e2bcd8739ae039 = new $1f0432306a74f982$var$MonthlyAllocationCollection();
const $1f0432306a74f982$export$8c2a7cbfa9d4b9db = $1f0432306a74f982$var$MonthlyAllocationCollection;

});
parcelRegister("2vNGQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d45056eab64919b$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");
parcelRequire("augzx");

var $fqmGV = parcelRequire("fqmGV");

var $2F6ay = parcelRequire("2F6ay");
parcelRequire("hy8Zj");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $1d45056eab64919b$var$_class, $1d45056eab64919b$var$_descriptor, $1d45056eab64919b$var$_descriptor2, $1d45056eab64919b$var$_descriptor3, $1d45056eab64919b$var$_descriptor4, $1d45056eab64919b$var$_descriptor5, $1d45056eab64919b$var$_descriptor6, $1d45056eab64919b$var$_descriptor7, $1d45056eab64919b$var$_descriptor8, $1d45056eab64919b$var$_descriptor9, $1d45056eab64919b$var$_descriptor10;
function $1d45056eab64919b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $1d45056eab64919b$var$_defineProperty(e, r, t) {
    return (r = $1d45056eab64919b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1d45056eab64919b$var$_toPropertyKey(t) {
    var i = $1d45056eab64919b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1d45056eab64919b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1d45056eab64919b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $1d45056eab64919b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $1d45056eab64919b$var$MonthlyAllocationModel = ($1d45056eab64919b$var$_class = class MonthlyAllocationModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $1d45056eab64919b$var$_initializerDefineProperty(this, "staffId", $1d45056eab64919b$var$_descriptor, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "roleId", $1d45056eab64919b$var$_descriptor2, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "projectId", $1d45056eab64919b$var$_descriptor3, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "phaseId", $1d45056eab64919b$var$_descriptor4, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "month", $1d45056eab64919b$var$_descriptor5, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "numMinutes", $1d45056eab64919b$var$_descriptor6, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "startMinutes", $1d45056eab64919b$var$_descriptor7, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "pay", $1d45056eab64919b$var$_descriptor8, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "cost", $1d45056eab64919b$var$_descriptor9, this);
        $1d45056eab64919b$var$_initializerDefineProperty(this, "charge_out", $1d45056eab64919b$var$_descriptor10, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $2F6ay.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).staffsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $8YeUb.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return this.project.costCentre;
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    get week() {
        return (0, $egx7S.getWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get date() {
        return (0, $egx7S.startOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get likelihood() {
        var _this$phase;
        return ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.likelihood) || 100;
    }
}, $1d45056eab64919b$var$_descriptor = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1d45056eab64919b$var$_descriptor2 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1d45056eab64919b$var$_descriptor3 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1d45056eab64919b$var$_descriptor4 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1d45056eab64919b$var$_descriptor5 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "month", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $egx7S.format)(new Date(), "yyyy-MM");
    }
}), $1d45056eab64919b$var$_descriptor6 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1d45056eab64919b$var$_descriptor7 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "startMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1d45056eab64919b$var$_descriptor8 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1d45056eab64919b$var$_descriptor9 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1d45056eab64919b$var$_descriptor10 = $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "charge_out", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "staff"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "role"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "costCentre"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "project"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "phase"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "hours"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "payRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "payRate"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "costRate"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "chargeOutRate"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "week", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "week"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "date"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_applyDecoratedDescriptor($1d45056eab64919b$var$_class.prototype, "likelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1d45056eab64919b$var$_class.prototype, "likelihood"), $1d45056eab64919b$var$_class.prototype), $1d45056eab64919b$var$_class);
var $1d45056eab64919b$export$2e2bcd8739ae039 = $1d45056eab64919b$var$MonthlyAllocationModel;

});


parcelRegister("cfz4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eb216b097769ef6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "WeeklyAllocationCollectionClass", function () { return $8eb216b097769ef6$export$8832f0b03729b15f; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $3hOII = parcelRequire("3hOII");

var $iCTvZ = parcelRequire("iCTvZ");

var $egx7S = parcelRequire("egx7S");
var $8eb216b097769ef6$var$_dec, $8eb216b097769ef6$var$_dec2, $8eb216b097769ef6$var$_dec3, $8eb216b097769ef6$var$_class;
function $8eb216b097769ef6$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $8eb216b097769ef6$var$WeeklyAllocationCollection = ($8eb216b097769ef6$var$_dec = (0, $d8hWe.action).bound, $8eb216b097769ef6$var$_dec2 = (0, $d8hWe.action).bound, $8eb216b097769ef6$var$_dec3 = (0, $d8hWe.action).bound, $8eb216b097769ef6$var$_class = class WeeklyAllocationCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "weeklyAllocations",
            modelClass: (0, $3hOII.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $iCTvZ.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $iCTvZ.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data, options) {
        this.add(data, options);
    }
    addAllocations(data, options) {
        this.addMany(data, options);
    }
    addAllocationsAcrossDateRange(dateRange, data, options) {
        const workingDays = [];
        let date = dateRange[0];
        while(date <= dateRange[1]){
            if (!(0, $egx7S.isWeekend)(date)) workingDays.push(date);
            date = (0, $egx7S.addDays)(date, 1);
        }
        const numMinutes = data.numMinutes / workingDays.length;
        this.addMany(workingDays.map((date)=>({
                ...data,
                date: date,
                numMinutes: numMinutes
            })), options);
    }
}, $8eb216b097769ef6$var$_applyDecoratedDescriptor($8eb216b097769ef6$var$_class.prototype, "addAllocation", [
    $8eb216b097769ef6$var$_dec
], Object.getOwnPropertyDescriptor($8eb216b097769ef6$var$_class.prototype, "addAllocation"), $8eb216b097769ef6$var$_class.prototype), $8eb216b097769ef6$var$_applyDecoratedDescriptor($8eb216b097769ef6$var$_class.prototype, "addAllocations", [
    $8eb216b097769ef6$var$_dec2
], Object.getOwnPropertyDescriptor($8eb216b097769ef6$var$_class.prototype, "addAllocations"), $8eb216b097769ef6$var$_class.prototype), $8eb216b097769ef6$var$_applyDecoratedDescriptor($8eb216b097769ef6$var$_class.prototype, "addAllocationsAcrossDateRange", [
    $8eb216b097769ef6$var$_dec3
], Object.getOwnPropertyDescriptor($8eb216b097769ef6$var$_class.prototype, "addAllocationsAcrossDateRange"), $8eb216b097769ef6$var$_class.prototype), $8eb216b097769ef6$var$_class);
var $8eb216b097769ef6$export$2e2bcd8739ae039 = new $8eb216b097769ef6$var$WeeklyAllocationCollection();
const $8eb216b097769ef6$export$8832f0b03729b15f = $8eb216b097769ef6$var$WeeklyAllocationCollection;

});
parcelRegister("3hOII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $264a4d9677c5f3b0$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");
parcelRequire("augzx");

var $fqmGV = parcelRequire("fqmGV");

var $cfz4k = parcelRequire("cfz4k");
parcelRequire("hy8Zj");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $264a4d9677c5f3b0$var$_class, $264a4d9677c5f3b0$var$_descriptor, $264a4d9677c5f3b0$var$_descriptor2, $264a4d9677c5f3b0$var$_descriptor3, $264a4d9677c5f3b0$var$_descriptor4, $264a4d9677c5f3b0$var$_descriptor5, $264a4d9677c5f3b0$var$_descriptor6, $264a4d9677c5f3b0$var$_descriptor7, $264a4d9677c5f3b0$var$_descriptor8, $264a4d9677c5f3b0$var$_descriptor9, $264a4d9677c5f3b0$var$_descriptor10;
function $264a4d9677c5f3b0$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $264a4d9677c5f3b0$var$_defineProperty(e, r, t) {
    return (r = $264a4d9677c5f3b0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $264a4d9677c5f3b0$var$_toPropertyKey(t) {
    var i = $264a4d9677c5f3b0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $264a4d9677c5f3b0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $264a4d9677c5f3b0$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $264a4d9677c5f3b0$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $264a4d9677c5f3b0$var$WeeklyAllocationModel = ($264a4d9677c5f3b0$var$_class = class WeeklyAllocationModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "staffId", $264a4d9677c5f3b0$var$_descriptor, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "roleId", $264a4d9677c5f3b0$var$_descriptor2, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "projectId", $264a4d9677c5f3b0$var$_descriptor3, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "phaseId", $264a4d9677c5f3b0$var$_descriptor4, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "week", $264a4d9677c5f3b0$var$_descriptor5, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "numMinutes", $264a4d9677c5f3b0$var$_descriptor6, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "startMinutes", $264a4d9677c5f3b0$var$_descriptor7, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "pay", $264a4d9677c5f3b0$var$_descriptor8, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "cost", $264a4d9677c5f3b0$var$_descriptor9, this);
        $264a4d9677c5f3b0$var$_initializerDefineProperty(this, "charge_out", $264a4d9677c5f3b0$var$_descriptor10, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $cfz4k.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).staffsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $8YeUb.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return this.project.costCentre;
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    get month() {
        return (0, $egx7S.format)(this.date, "yyyy-MM");
    }
    get date() {
        return (0, $egx7S.startOfISOWeek)((0, $egx7S.parse)(this.week, "RRRR-II", new Date(), {
            weekStartsOn: 1
        }));
    }
    get likelihood() {
        var _this$phase;
        return ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.likelihood) || 100;
    }
}, $264a4d9677c5f3b0$var$_descriptor = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $264a4d9677c5f3b0$var$_descriptor2 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $264a4d9677c5f3b0$var$_descriptor3 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $264a4d9677c5f3b0$var$_descriptor4 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $264a4d9677c5f3b0$var$_descriptor5 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "week", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $egx7S.format)(new Date(), "RRRR-II");
    }
}), $264a4d9677c5f3b0$var$_descriptor6 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $264a4d9677c5f3b0$var$_descriptor7 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "startMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $264a4d9677c5f3b0$var$_descriptor8 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $264a4d9677c5f3b0$var$_descriptor9 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $264a4d9677c5f3b0$var$_descriptor10 = $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "charge_out", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "staff"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "role"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "costCentre"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "project"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "phase"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "hours"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "payRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "payRate"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "costRate"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "chargeOutRate"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "month", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "month"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "date"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_applyDecoratedDescriptor($264a4d9677c5f3b0$var$_class.prototype, "likelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($264a4d9677c5f3b0$var$_class.prototype, "likelihood"), $264a4d9677c5f3b0$var$_class.prototype), $264a4d9677c5f3b0$var$_class);
var $264a4d9677c5f3b0$export$2e2bcd8739ae039 = $264a4d9677c5f3b0$var$WeeklyAllocationModel;

});




parcelRegister("eYJ53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae79a35afb139ec8$export$2e2bcd8739ae039; });

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");

var $9gX1H = parcelRequire("9gX1H");
var $aQYlP = parcelRequire("aQYlP");

var $iT6E4 = parcelRequire("iT6E4");
function $ae79a35afb139ec8$var$arrayMove(array, from, to) {
    const slicedArray = array.slice();
    slicedArray.splice(to < 0 ? array.length + to : to, 0, slicedArray.splice(from, 1)[0]);
    return slicedArray;
}
const $ae79a35afb139ec8$var$SortableMultiValue = (0, $iT6E4.SortableElement)((props)=>{
    // this prevents the menu from being opened/closed when the user clicks
    // on a value to begin dragging it. ideally, detecting a click (instead of
    // a drag) would still focus the control and toggle the menu, but that
    // requires some magic with refs that are out of scope for this example
    const onMouseDown = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const innerProps = {
        ...props.innerProps,
        onMouseDown: onMouseDown
    };
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $9gX1H.c).MultiValue, {
        ...props,
        innerProps: innerProps
    });
});
const $ae79a35afb139ec8$var$SortableMultiValueLabel = (0, $iT6E4.SortableHandle)((props)=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $9gX1H.c).MultiValueLabel, {
        ...props
    }));
const $ae79a35afb139ec8$var$SortableSelect = (0, $iT6E4.SortableContainer)((0, $aQYlP.default));
function $ae79a35afb139ec8$export$2e2bcd8739ae039({ selectedOptions: selectedOptions, options: options, onChange: onChange, ...props }) {
    const onSortEnd = ({ oldIndex: oldIndex, newIndex: newIndex })=>{
        const newValue = $ae79a35afb139ec8$var$arrayMove(selectedOptions, oldIndex, newIndex);
        onChange(newValue);
    };
    return /*#__PURE__*/ (0, $RSSjA.jsx)($ae79a35afb139ec8$var$SortableSelect, {
        useDragHandle: true,
        // react-sortable-hoc props:
        axis: "xy",
        onSortEnd: onSortEnd,
        distance: 4,
        // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
        getHelperDimensions: ({ node: node })=>node.getBoundingClientRect(),
        // react-select props:
        isMulti: true,
        options: options,
        value: selectedOptions,
        onChange: onChange,
        components: {
            // @ts-ignore We're failing to provide a required index prop to SortableElement
            MultiValue: $ae79a35afb139ec8$var$SortableMultiValue,
            MultiValueLabel: $ae79a35afb139ec8$var$SortableMultiValueLabel
        },
        closeMenuOnSelect: false,
        isClearable: false,
        styles: props.style,
        ...props
    });
}

});
parcelRegister("9gX1H", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $6c03651204a2790c$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $6c03651204a2790c$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $6c03651204a2790c$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $6c03651204a2790c$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $6c03651204a2790c$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $6c03651204a2790c$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $6c03651204a2790c$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $6c03651204a2790c$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $6c03651204a2790c$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $6c03651204a2790c$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $6c03651204a2790c$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $6c03651204a2790c$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $6c03651204a2790c$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $6c03651204a2790c$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $6c03651204a2790c$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $6c03651204a2790c$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $6c03651204a2790c$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $6c03651204a2790c$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $6c03651204a2790c$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $6c03651204a2790c$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $6c03651204a2790c$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $6c03651204a2790c$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $6c03651204a2790c$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $6c03651204a2790c$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $6c03651204a2790c$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $6c03651204a2790c$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $6c03651204a2790c$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $6c03651204a2790c$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $6c03651204a2790c$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $6c03651204a2790c$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $6c03651204a2790c$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $6c03651204a2790c$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $6c03651204a2790c$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $6c03651204a2790c$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $6c03651204a2790c$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $6c03651204a2790c$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $6c03651204a2790c$export$db3b6bfb95261072; });
$parcel$export(module.exports, "F", function () { return $6c03651204a2790c$export$d66501df72047452; });

var $b17Jx = parcelRequire("b17Jx");

var $hIbXl = parcelRequire("hIbXl");

var $5OJLl = parcelRequire("5OJLl");

var $5OuPz = parcelRequire("5OuPz");

var $j6qgd = parcelRequire("j6qgd");

var $enYWB = parcelRequire("enYWB");

var $eEs0l = parcelRequire("eEs0l");

var $dHPh8 = parcelRequire("dHPh8");

var $7PdBe = parcelRequire("7PdBe");

var $1cUCD = parcelRequire("1cUCD");

var $2smHE = parcelRequire("2smHE");

var $cyvBx = parcelRequire("cyvBx");
var $6c03651204a2790c$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $6c03651204a2790c$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $6c03651204a2790c$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $6c03651204a2790c$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($6c03651204a2790c$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $6c03651204a2790c$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($6c03651204a2790c$var$isArray(value)) return value.filter(Boolean);
    if ((0, $enYWB.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $6c03651204a2790c$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $j6qgd.default)(props, $6c03651204a2790c$var$_excluded$4);
    return (0, $b17Jx.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $6c03651204a2790c$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $6c03651204a2790c$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $6c03651204a2790c$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $6c03651204a2790c$var$normalizedHeight(el) {
    if ($6c03651204a2790c$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $6c03651204a2790c$var$getScrollTop(el) {
    if ($6c03651204a2790c$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $6c03651204a2790c$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($6c03651204a2790c$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $6c03651204a2790c$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $6c03651204a2790c$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $6c03651204a2790c$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $6c03651204a2790c$export$b4171a6734a65d42;
    var start = $6c03651204a2790c$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $6c03651204a2790c$var$easeOutCubic(currentTime, start, change, duration);
        $6c03651204a2790c$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $6c03651204a2790c$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $6c03651204a2790c$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $6c03651204a2790c$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $6c03651204a2790c$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $6c03651204a2790c$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $6c03651204a2790c$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $6c03651204a2790c$var$passiveOptionAccessed = false;
var $6c03651204a2790c$var$options = {
    get passive () {
        return $6c03651204a2790c$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $6c03651204a2790c$var$w = typeof window !== "undefined" ? window : {};
if ($6c03651204a2790c$var$w.addEventListener && $6c03651204a2790c$var$w.removeEventListener) {
    $6c03651204a2790c$var$w.addEventListener("p", $6c03651204a2790c$export$b4171a6734a65d42, $6c03651204a2790c$var$options);
    $6c03651204a2790c$var$w.removeEventListener("p", $6c03651204a2790c$export$b4171a6734a65d42, false);
}
var $6c03651204a2790c$export$2408f22a0fab9ae5 = $6c03651204a2790c$var$passiveOptionAccessed;
function $6c03651204a2790c$export$3466f893ebf79586(item) {
    return item != null;
}
function $6c03651204a2790c$var$isArray(arg) {
    return Array.isArray(arg);
}
function $6c03651204a2790c$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $6c03651204a2790c$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $6c03651204a2790c$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $6c03651204a2790c$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $5OuPz.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $5OuPz.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $6c03651204a2790c$var$_excluded$3 = [
    "children",
    "innerProps"
], $6c03651204a2790c$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $6c03651204a2790c$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $6c03651204a2790c$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $6c03651204a2790c$var$normalizedHeight(scrollParent);
    var scrollTop = $6c03651204a2790c$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $6c03651204a2790c$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $6c03651204a2790c$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $6c03651204a2790c$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $6c03651204a2790c$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $6c03651204a2790c$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $6c03651204a2790c$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $6c03651204a2790c$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $6c03651204a2790c$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $b17Jx.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $dHPh8.default)(_objectSpread2, $6c03651204a2790c$var$alignToControl(placement), "100%"), (0, $dHPh8.default)(_objectSpread2, "position", "absolute"), (0, $dHPh8.default)(_objectSpread2, "width", "100%"), (0, $dHPh8.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $6c03651204a2790c$var$PortalPlacementContext = /*#__PURE__*/ (0, $7PdBe.createContext)(null);
// NOTE: internal only
var $6c03651204a2790c$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $7PdBe.useContext)($6c03651204a2790c$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $7PdBe.useRef)(null);
    var _useState = (0, $7PdBe.useState)(maxMenuHeight), _useState2 = (0, $5OuPz.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $7PdBe.useState)(null), _useState4 = (0, $5OuPz.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $cyvBx.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $6c03651204a2790c$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $b17Jx.default)((0, $b17Jx.default)({}, props), {}, {
            placement: placement || $6c03651204a2790c$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $6c03651204a2790c$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $6c03651204a2790c$var$Menu$1 = $6c03651204a2790c$var$Menu;
// ==============================
// Menu List
// ==============================
var $6c03651204a2790c$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $b17Jx.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $6c03651204a2790c$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $6c03651204a2790c$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $b17Jx.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $6c03651204a2790c$export$3b14a55fb2447963 = $6c03651204a2790c$var$noticeCSS;
var $6c03651204a2790c$export$342063e11d6c3cad = $6c03651204a2790c$var$noticeCSS;
var $6c03651204a2790c$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $j6qgd.default)(_ref6, $6c03651204a2790c$var$_excluded$3);
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps((0, $b17Jx.default)((0, $b17Jx.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $6c03651204a2790c$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $j6qgd.default)(_ref7, $6c03651204a2790c$var$_excluded2$1);
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps((0, $b17Jx.default)((0, $b17Jx.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $6c03651204a2790c$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $6c03651204a2790c$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $7PdBe.useRef)(null);
    var cleanupRef = (0, $7PdBe.useRef)(null);
    var _useState5 = (0, $7PdBe.useState)($6c03651204a2790c$var$coercePlacement(menuPlacement)), _useState6 = (0, $5OuPz.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $7PdBe.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $7PdBe.useState)(null), _useState8 = (0, $5OuPz.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $7PdBe.useCallback)(function() {
        if (!controlElement) return;
        var rect = $6c03651204a2790c$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $cyvBx.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $7PdBe.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $2smHE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $cyvBx.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $7PdBe.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({
        ref: setMenuPortalElement
    }, $6c03651204a2790c$var$getStyleProps((0, $b17Jx.default)((0, $b17Jx.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $5OJLl.jsx)($6c03651204a2790c$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1cUCD.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $6c03651204a2790c$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $6c03651204a2790c$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $6c03651204a2790c$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $b17Jx.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $6c03651204a2790c$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $6c03651204a2790c$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $6c03651204a2790c$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $6c03651204a2790c$var$_templateObject;
var $6c03651204a2790c$var$_excluded$2 = [
    "size"
], $6c03651204a2790c$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $6c03651204a2790c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $6c03651204a2790c$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $6c03651204a2790c$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $j6qgd.default)(_ref, $6c03651204a2790c$var$_excluded$2);
    return (0, $5OJLl.jsx)("svg", (0, $hIbXl.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $6c03651204a2790c$var$_ref2
    }, props));
};
var $6c03651204a2790c$var$CrossIcon = function CrossIcon(props) {
    return (0, $5OJLl.jsx)($6c03651204a2790c$var$Svg, (0, $hIbXl.default)({
        size: 20
    }, props), (0, $5OJLl.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $6c03651204a2790c$var$DownChevron = function DownChevron(props) {
    return (0, $5OJLl.jsx)($6c03651204a2790c$var$Svg, (0, $hIbXl.default)({
        size: 20
    }, props), (0, $5OJLl.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $6c03651204a2790c$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $b17Jx.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $6c03651204a2790c$export$f1e1789686576879 = $6c03651204a2790c$var$baseCSS;
var $6c03651204a2790c$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $5OJLl.jsx)($6c03651204a2790c$var$DownChevron, null));
};
var $6c03651204a2790c$export$407448d2b89b1813 = $6c03651204a2790c$var$baseCSS;
var $6c03651204a2790c$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $5OJLl.jsx)($6c03651204a2790c$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $6c03651204a2790c$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $b17Jx.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $6c03651204a2790c$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $5OJLl.jsx)("span", (0, $hIbXl.default)({}, innerProps, $6c03651204a2790c$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $6c03651204a2790c$var$loadingDotAnimations = (0, $5OJLl.keyframes)($6c03651204a2790c$var$_templateObject || ($6c03651204a2790c$var$_templateObject = (0, $eEs0l.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $6c03651204a2790c$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $b17Jx.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $6c03651204a2790c$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $5OJLl.jsx)("span", {
        css: /*#__PURE__*/ (0, $5OJLl.css)({
            animation: "".concat($6c03651204a2790c$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $6c03651204a2790c$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $j6qgd.default)(_ref7, $6c03651204a2790c$var$_excluded2);
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps((0, $b17Jx.default)((0, $b17Jx.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $5OJLl.jsx)($6c03651204a2790c$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $5OJLl.jsx)($6c03651204a2790c$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $5OJLl.jsx)($6c03651204a2790c$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $6c03651204a2790c$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $b17Jx.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $6c03651204a2790c$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({
        ref: innerRef
    }, $6c03651204a2790c$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $6c03651204a2790c$var$Control$1 = $6c03651204a2790c$var$Control;
var $6c03651204a2790c$var$_excluded$1 = [
    "data"
];
var $6c03651204a2790c$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $6c03651204a2790c$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $5OJLl.jsx)(Heading, (0, $hIbXl.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $5OJLl.jsx)("div", null, children));
};
var $6c03651204a2790c$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $b17Jx.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $6c03651204a2790c$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $6c03651204a2790c$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $j6qgd.default)(_cleanCommonProps, $6c03651204a2790c$var$_excluded$1);
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $6c03651204a2790c$var$Group$1 = $6c03651204a2790c$var$Group;
var $6c03651204a2790c$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $6c03651204a2790c$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $b17Jx.default)((0, $b17Jx.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $6c03651204a2790c$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $6c03651204a2790c$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $6c03651204a2790c$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $b17Jx.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $6c03651204a2790c$var$spacingStyle)
};
var $6c03651204a2790c$var$inputStyle = function inputStyle(isHidden) {
    return (0, $b17Jx.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $6c03651204a2790c$var$spacingStyle);
};
var $6c03651204a2790c$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $6c03651204a2790c$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $j6qgd.default)(_cleanCommonProps, $6c03651204a2790c$var$_excluded);
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $5OJLl.jsx)("input", (0, $hIbXl.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $6c03651204a2790c$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $6c03651204a2790c$var$Input$1 = $6c03651204a2790c$var$Input;
var $6c03651204a2790c$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $b17Jx.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $6c03651204a2790c$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $b17Jx.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $6c03651204a2790c$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $b17Jx.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $6c03651204a2790c$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $5OJLl.jsx)("div", innerProps, children);
};
var $6c03651204a2790c$var$MultiValueContainer = $6c03651204a2790c$var$MultiValueGeneric;
var $6c03651204a2790c$var$MultiValueLabel = $6c03651204a2790c$var$MultiValueGeneric;
function $6c03651204a2790c$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({
        role: "button"
    }, innerProps), children || (0, $5OJLl.jsx)($6c03651204a2790c$var$CrossIcon, {
        size: 14
    }));
}
var $6c03651204a2790c$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $5OJLl.jsx)(Container, {
        data: data,
        innerProps: (0, $b17Jx.default)((0, $b17Jx.default)({}, $6c03651204a2790c$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $5OJLl.jsx)(Label, {
        data: data,
        innerProps: (0, $b17Jx.default)({}, $6c03651204a2790c$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $5OJLl.jsx)(Remove, {
        data: data,
        innerProps: (0, $b17Jx.default)((0, $b17Jx.default)({}, $6c03651204a2790c$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $6c03651204a2790c$var$MultiValue$1 = $6c03651204a2790c$var$MultiValue;
var $6c03651204a2790c$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $b17Jx.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $6c03651204a2790c$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $6c03651204a2790c$var$Option$1 = $6c03651204a2790c$var$Option;
var $6c03651204a2790c$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $b17Jx.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $6c03651204a2790c$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $6c03651204a2790c$var$Placeholder$1 = $6c03651204a2790c$var$Placeholder;
var $6c03651204a2790c$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $b17Jx.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $6c03651204a2790c$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $5OJLl.jsx)("div", (0, $hIbXl.default)({}, $6c03651204a2790c$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $6c03651204a2790c$var$SingleValue$1 = $6c03651204a2790c$var$SingleValue;
var $6c03651204a2790c$export$db3b6bfb95261072 = {
    ClearIndicator: $6c03651204a2790c$var$ClearIndicator,
    Control: $6c03651204a2790c$var$Control$1,
    DropdownIndicator: $6c03651204a2790c$var$DropdownIndicator,
    DownChevron: $6c03651204a2790c$var$DownChevron,
    CrossIcon: $6c03651204a2790c$var$CrossIcon,
    Group: $6c03651204a2790c$var$Group$1,
    GroupHeading: $6c03651204a2790c$var$GroupHeading,
    IndicatorsContainer: $6c03651204a2790c$var$IndicatorsContainer,
    IndicatorSeparator: $6c03651204a2790c$var$IndicatorSeparator,
    Input: $6c03651204a2790c$var$Input$1,
    LoadingIndicator: $6c03651204a2790c$var$LoadingIndicator,
    Menu: $6c03651204a2790c$var$Menu$1,
    MenuList: $6c03651204a2790c$var$MenuList,
    MenuPortal: $6c03651204a2790c$var$MenuPortal,
    LoadingMessage: $6c03651204a2790c$var$LoadingMessage,
    NoOptionsMessage: $6c03651204a2790c$var$NoOptionsMessage,
    MultiValue: $6c03651204a2790c$var$MultiValue$1,
    MultiValueContainer: $6c03651204a2790c$var$MultiValueContainer,
    MultiValueLabel: $6c03651204a2790c$var$MultiValueLabel,
    MultiValueRemove: $6c03651204a2790c$var$MultiValueRemove,
    Option: $6c03651204a2790c$var$Option$1,
    Placeholder: $6c03651204a2790c$var$Placeholder$1,
    SelectContainer: $6c03651204a2790c$var$SelectContainer,
    SingleValue: $6c03651204a2790c$var$SingleValue$1,
    ValueContainer: $6c03651204a2790c$var$ValueContainer
};
var $6c03651204a2790c$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $b17Jx.default)((0, $b17Jx.default)({}, $6c03651204a2790c$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("b17Jx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8055c96ebabed328$export$2e2bcd8739ae039; });

var $dHPh8 = parcelRequire("dHPh8");
function $8055c96ebabed328$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8055c96ebabed328$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8055c96ebabed328$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dHPh8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8055c96ebabed328$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("dHPh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa710bd0bec0ded$export$2e2bcd8739ae039; });

var $id3YY = parcelRequire("id3YY");
function $9fa710bd0bec0ded$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $id3YY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("id3YY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d41c87b4ff734097$export$2e2bcd8739ae039; });

var $enYWB = parcelRequire("enYWB");

var $u6BEy = parcelRequire("u6BEy");
function $d41c87b4ff734097$export$2e2bcd8739ae039(t) {
    var i = (0, $u6BEy.default)(t, "string");
    return "symbol" == (0, $enYWB.default)(i) ? i : i + "";
}

});
parcelRegister("enYWB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7927cf1c3b58f12$export$2e2bcd8739ae039; });
function $a7927cf1c3b58f12$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a7927cf1c3b58f12$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a7927cf1c3b58f12$export$2e2bcd8739ae039(o);
}

});

parcelRegister("u6BEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a7ed54f7df5bdb$export$2e2bcd8739ae039; });

var $enYWB = parcelRequire("enYWB");
function $05a7ed54f7df5bdb$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $enYWB.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $enYWB.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("5OJLl", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $43c51ec7ed581e26$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $43c51ec7ed581e26$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $43c51ec7ed581e26$export$c8a8987d4410bf2d; });

var $kwe0A = parcelRequire("kwe0A");

var $7PdBe = parcelRequire("7PdBe");

var $gk5Qr = parcelRequire("gk5Qr");

var $aAoqi = parcelRequire("aAoqi");

var $bPokU = parcelRequire("bPokU");
parcelRequire("cG9fz");
parcelRequire("kdwYq");
parcelRequire("QHNm5");

parcelRequire("1IGIR");
var $43c51ec7ed581e26$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $kwe0A.h).call(props, "css")) return $7PdBe.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $kwe0A.E);
    createElementArgArray[1] = (0, $kwe0A.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7PdBe.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $43c51ec7ed581e26$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $kwe0A.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $bPokU.serializeStyles)([
        styles
    ], undefined, $7PdBe.useContext((0, $kwe0A.T)));
    if (!(0, $kwe0A.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7PdBe.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7PdBe.useRef();
    (0, $aAoqi.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $aAoqi.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $gk5Qr.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $43c51ec7ed581e26$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $bPokU.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $43c51ec7ed581e26$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $43c51ec7ed581e26$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $43c51ec7ed581e26$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $43c51ec7ed581e26$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $gk5Qr.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $43c51ec7ed581e26$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $aAoqi.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $gk5Qr.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $kwe0A.i) && res !== undefined) rules += res;
        }
        if (!(0, $kwe0A.i)) return rules;
    });
    if (!(0, $kwe0A.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $7PdBe.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $43c51ec7ed581e26$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $kwe0A.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $kwe0A.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $bPokU.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $gk5Qr.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $kwe0A.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $43c51ec7ed581e26$var$merge(cache.registered, css, $43c51ec7ed581e26$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7PdBe.useContext((0, $kwe0A.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7PdBe.createElement($7PdBe.Fragment, null, /*#__PURE__*/ $7PdBe.createElement($43c51ec7ed581e26$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});

parcelRegister("5OuPz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b989a21471f920$export$2e2bcd8739ae039; });

var $dHSGp = parcelRequire("dHSGp");

var $hk3tl = parcelRequire("hk3tl");

var $bCHYX = parcelRequire("bCHYX");

var $bxFc7 = parcelRequire("bxFc7");
function $43b989a21471f920$export$2e2bcd8739ae039(r, e) {
    return (0, $dHSGp.default)(r) || (0, $hk3tl.default)(r, e) || (0, $bCHYX.default)(r, e) || (0, $bxFc7.default)();
}

});
parcelRegister("dHSGp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa9b572a0fe4bbb$export$2e2bcd8739ae039; });
function $9fa9b572a0fe4bbb$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("hk3tl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c6ff6fc35721c4$export$2e2bcd8739ae039; });
function $c9c6ff6fc35721c4$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("bCHYX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87655c4521341a4c$export$2e2bcd8739ae039; });

var $37Vfb = parcelRequire("37Vfb");
function $87655c4521341a4c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $37Vfb.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $37Vfb.default)(r, a) : void 0;
    }
}

});
parcelRegister("37Vfb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $246e6dfed6cc5f27$export$2e2bcd8739ae039; });
function $246e6dfed6cc5f27$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("bxFc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8672bb1d56bb5cbb$export$2e2bcd8739ae039; });
function $8672bb1d56bb5cbb$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("j6qgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de82f2a80d79661a$export$2e2bcd8739ae039; });

var $ih1SQ = parcelRequire("ih1SQ");
function $de82f2a80d79661a$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $ih1SQ.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("ih1SQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4db4695ac62efe4$export$2e2bcd8739ae039; });
function $d4db4695ac62efe4$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("eEs0l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaaa863a7a317bb0$export$2e2bcd8739ae039; });
function $aaaa863a7a317bb0$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("2smHE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $1c9fcea4113f96b6$export$deee3a793edee05f; });

var $kla0n = parcelRequire("kla0n");
var $7Bw5s = parcelRequire("7Bw5s");

var $3M140 = parcelRequire("3M140");

var $bYyLo = parcelRequire("bYyLo");
function $1c9fcea4113f96b6$var$getCssDimensions(element) {
    const css = (0, $bYyLo.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $bYyLo.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $3M140.round)(width) !== offsetWidth || (0, $3M140.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $1c9fcea4113f96b6$var$unwrapElement(element) {
    return !(0, $bYyLo.isElement)(element) ? element.contextElement : element;
}
function $1c9fcea4113f96b6$var$getScale(element) {
    const domElement = $1c9fcea4113f96b6$var$unwrapElement(element);
    if (!(0, $bYyLo.isHTMLElement)(domElement)) return (0, $3M140.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $1c9fcea4113f96b6$var$getCssDimensions(domElement);
    let x = ($ ? (0, $3M140.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $3M140.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $1c9fcea4113f96b6$var$noOffsets = /*#__PURE__*/ (0, $3M140.createCoords)(0);
function $1c9fcea4113f96b6$var$getVisualOffsets(element) {
    const win = (0, $bYyLo.getWindow)(element);
    if (!(0, $bYyLo.isWebKit)() || !win.visualViewport) return $1c9fcea4113f96b6$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $1c9fcea4113f96b6$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $bYyLo.getWindow)(element)) return false;
    return isFixed;
}
function $1c9fcea4113f96b6$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $1c9fcea4113f96b6$var$unwrapElement(element);
    let scale = (0, $3M140.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $bYyLo.isElement)(offsetParent)) scale = $1c9fcea4113f96b6$var$getScale(offsetParent);
        } else scale = $1c9fcea4113f96b6$var$getScale(element);
    }
    const visualOffsets = $1c9fcea4113f96b6$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $1c9fcea4113f96b6$var$getVisualOffsets(domElement) : (0, $3M140.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $bYyLo.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $bYyLo.isElement)(offsetParent) ? (0, $bYyLo.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $bYyLo.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $1c9fcea4113f96b6$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $bYyLo.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $bYyLo.getWindow)(currentIFrame);
            currentIFrame = (0, $bYyLo.getFrameElement)(currentWin);
        }
    }
    return (0, $7Bw5s.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $1c9fcea4113f96b6$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $bYyLo.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $bYyLo.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $3M140.createCoords)(1);
    const offsets = (0, $3M140.createCoords)(0);
    const isOffsetParentAnElement = (0, $bYyLo.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bYyLo.getNodeName)(offsetParent) !== "body" || (0, $bYyLo.isOverflowElement)(documentElement)) scroll = (0, $bYyLo.getNodeScroll)(offsetParent);
        if ((0, $bYyLo.isHTMLElement)(offsetParent)) {
            const offsetRect = $1c9fcea4113f96b6$var$getBoundingClientRect(offsetParent);
            scale = $1c9fcea4113f96b6$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $1c9fcea4113f96b6$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $1c9fcea4113f96b6$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $1c9fcea4113f96b6$var$getBoundingClientRect((0, $bYyLo.getDocumentElement)(element)).left + (0, $bYyLo.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $1c9fcea4113f96b6$var$getDocumentRect(element) {
    const html = (0, $bYyLo.getDocumentElement)(element);
    const scroll = (0, $bYyLo.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $3M140.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $3M140.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $1c9fcea4113f96b6$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $bYyLo.getComputedStyle)(body).direction === "rtl") x += (0, $3M140.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $1c9fcea4113f96b6$var$getViewportRect(element, strategy) {
    const win = (0, $bYyLo.getWindow)(element);
    const html = (0, $bYyLo.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $bYyLo.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $1c9fcea4113f96b6$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $1c9fcea4113f96b6$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $bYyLo.isHTMLElement)(element) ? $1c9fcea4113f96b6$var$getScale(element) : (0, $3M140.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $1c9fcea4113f96b6$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $1c9fcea4113f96b6$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $1c9fcea4113f96b6$var$getDocumentRect((0, $bYyLo.getDocumentElement)(element));
    else if ((0, $bYyLo.isElement)(clippingAncestor)) rect = $1c9fcea4113f96b6$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $1c9fcea4113f96b6$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $7Bw5s.rectToClientRect)(rect);
}
function $1c9fcea4113f96b6$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $bYyLo.getParentNode)(element);
    if (parentNode === stopNode || !(0, $bYyLo.isElement)(parentNode) || (0, $bYyLo.isLastTraversableNode)(parentNode)) return false;
    return (0, $bYyLo.getComputedStyle)(parentNode).position === "fixed" || $1c9fcea4113f96b6$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $1c9fcea4113f96b6$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $bYyLo.getOverflowAncestors)(element, [], false).filter((el)=>(0, $bYyLo.isElement)(el) && (0, $bYyLo.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $bYyLo.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $bYyLo.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $bYyLo.isElement)(currentNode) && !(0, $bYyLo.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $bYyLo.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $bYyLo.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $bYyLo.isOverflowElement)(currentNode) && !currentNodeIsContaining && $1c9fcea4113f96b6$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $bYyLo.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $1c9fcea4113f96b6$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $bYyLo.isTopLayer)(element) ? [] : $1c9fcea4113f96b6$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $1c9fcea4113f96b6$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $3M140.max)(rect.top, accRect.top);
        accRect.right = (0, $3M140.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3M140.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3M140.max)(rect.left, accRect.left);
        return accRect;
    }, $1c9fcea4113f96b6$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $1c9fcea4113f96b6$var$getDimensions(element) {
    const { width: width, height: height } = $1c9fcea4113f96b6$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $1c9fcea4113f96b6$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $bYyLo.isHTMLElement)(offsetParent);
    const documentElement = (0, $bYyLo.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $1c9fcea4113f96b6$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $3M140.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bYyLo.getNodeName)(offsetParent) !== "body" || (0, $bYyLo.isOverflowElement)(documentElement)) scroll = (0, $bYyLo.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $1c9fcea4113f96b6$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $1c9fcea4113f96b6$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $1c9fcea4113f96b6$var$isStaticPositioned(element) {
    return (0, $bYyLo.getComputedStyle)(element).position === "static";
}
function $1c9fcea4113f96b6$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $bYyLo.isHTMLElement)(element) || (0, $bYyLo.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $1c9fcea4113f96b6$var$getOffsetParent(element, polyfill) {
    const win = (0, $bYyLo.getWindow)(element);
    if ((0, $bYyLo.isTopLayer)(element)) return win;
    if (!(0, $bYyLo.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $bYyLo.getParentNode)(element);
        while(svgOffsetParent && !(0, $bYyLo.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $bYyLo.isElement)(svgOffsetParent) && !$1c9fcea4113f96b6$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $bYyLo.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $1c9fcea4113f96b6$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $bYyLo.isTableElement)(offsetParent) && $1c9fcea4113f96b6$var$isStaticPositioned(offsetParent))offsetParent = $1c9fcea4113f96b6$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $bYyLo.isLastTraversableNode)(offsetParent) && $1c9fcea4113f96b6$var$isStaticPositioned(offsetParent) && !(0, $bYyLo.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $bYyLo.getContainingBlock)(element) || win;
}
const $1c9fcea4113f96b6$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $1c9fcea4113f96b6$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $1c9fcea4113f96b6$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $1c9fcea4113f96b6$var$isRTL(element) {
    return (0, $bYyLo.getComputedStyle)(element).direction === "rtl";
}
const $1c9fcea4113f96b6$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $1c9fcea4113f96b6$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $bYyLo.getDocumentElement,
    getClippingRect: $1c9fcea4113f96b6$var$getClippingRect,
    getOffsetParent: $1c9fcea4113f96b6$var$getOffsetParent,
    getElementRects: $1c9fcea4113f96b6$var$getElementRects,
    getClientRects: $1c9fcea4113f96b6$var$getClientRects,
    getDimensions: $1c9fcea4113f96b6$var$getDimensions,
    getScale: $1c9fcea4113f96b6$var$getScale,
    isElement: $bYyLo.isElement,
    isRTL: $1c9fcea4113f96b6$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $1c9fcea4113f96b6$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $bYyLo.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $3M140.floor)(top);
        const insetRight = (0, $3M140.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $3M140.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $3M140.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $3M140.max)(0, (0, $3M140.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $1c9fcea4113f96b6$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $1c9fcea4113f96b6$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $bYyLo.getOverflowAncestors)(referenceEl) : [],
        ...(0, $bYyLo.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $1c9fcea4113f96b6$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $1c9fcea4113f96b6$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $1c9fcea4113f96b6$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $1c9fcea4113f96b6$export$37b6bde19b108ecc = (0, $kla0n.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $1c9fcea4113f96b6$export$cc800923e997bb8 = (0, $kla0n.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $1c9fcea4113f96b6$export$91fb6ecbd551914 = (0, $kla0n.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $1c9fcea4113f96b6$export$fba63a578e423eb = (0, $kla0n.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $1c9fcea4113f96b6$export$8a83211c878a3f1f = (0, $kla0n.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $1c9fcea4113f96b6$export$346677f925de839c = (0, $kla0n.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $1c9fcea4113f96b6$export$fe8985bb6374093c = (0, $kla0n.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $1c9fcea4113f96b6$export$f2120bbfa5450bd2 = (0, $kla0n.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $1c9fcea4113f96b6$export$18c8ad048e32c7d5 = (0, $kla0n.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $1c9fcea4113f96b6$export$7bf07e38f3dc4b69 = (0, $kla0n.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $1c9fcea4113f96b6$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $1c9fcea4113f96b6$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $kla0n.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("kla0n", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $eced8798831281d6$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $eced8798831281d6$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $eced8798831281d6$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $eced8798831281d6$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $eced8798831281d6$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $eced8798831281d6$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $eced8798831281d6$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $eced8798831281d6$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $eced8798831281d6$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $eced8798831281d6$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $eced8798831281d6$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("7Bw5s")).rectToClientRect; });

var $7Bw5s = parcelRequire("7Bw5s");
function $eced8798831281d6$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $7Bw5s.getSideAxis)(placement);
    const alignmentAxis = (0, $7Bw5s.getAlignmentAxis)(placement);
    const alignLength = (0, $7Bw5s.getAxisLength)(alignmentAxis);
    const side = (0, $7Bw5s.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $7Bw5s.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $eced8798831281d6$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $eced8798831281d6$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $eced8798831281d6$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $eced8798831281d6$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $7Bw5s.evaluate)(options, state);
    const paddingObject = (0, $7Bw5s.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $7Bw5s.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $7Bw5s.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $eced8798831281d6$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $7Bw5s.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $7Bw5s.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $7Bw5s.getAlignmentAxis)(placement);
            const length = (0, $7Bw5s.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $7Bw5s.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $7Bw5s.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $7Bw5s.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $7Bw5s.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $eced8798831281d6$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $7Bw5s.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $7Bw5s.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $7Bw5s.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $7Bw5s.getAlignment)(placement) === alignment || (autoAlignment ? (0, $7Bw5s.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $eced8798831281d6$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $7Bw5s.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $7Bw5s.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $7Bw5s.placements) ? $eced8798831281d6$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $eced8798831281d6$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $7Bw5s.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $7Bw5s.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $7Bw5s.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $7Bw5s.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $eced8798831281d6$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $7Bw5s.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $7Bw5s.getSide)(placement);
            const initialSideAxis = (0, $7Bw5s.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $7Bw5s.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $7Bw5s.getOppositePlacement)(initialPlacement)
            ] : (0, $7Bw5s.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $7Bw5s.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $eced8798831281d6$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $7Bw5s.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $7Bw5s.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $eced8798831281d6$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $eced8798831281d6$var$isAnySideFullyClipped(overflow) {
    return (0, $7Bw5s.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $eced8798831281d6$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $7Bw5s.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $eced8798831281d6$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $eced8798831281d6$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $eced8798831281d6$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $eced8798831281d6$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $eced8798831281d6$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $eced8798831281d6$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $eced8798831281d6$var$getBoundingRect(rects) {
    const minX = (0, $7Bw5s.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $7Bw5s.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $7Bw5s.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $7Bw5s.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $eced8798831281d6$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $7Bw5s.rectToClientRect)($eced8798831281d6$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $eced8798831281d6$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $7Bw5s.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $eced8798831281d6$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $7Bw5s.rectToClientRect)($eced8798831281d6$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $7Bw5s.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $7Bw5s.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $7Bw5s.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $7Bw5s.getSide)(placement) === "left";
                    const maxRight = (0, $7Bw5s.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $7Bw5s.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $eced8798831281d6$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $7Bw5s.getSide)(placement);
    const alignment = (0, $7Bw5s.getAlignment)(placement);
    const isVertical = (0, $7Bw5s.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $7Bw5s.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $eced8798831281d6$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $eced8798831281d6$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $eced8798831281d6$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $7Bw5s.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $eced8798831281d6$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $7Bw5s.getSideAxis)((0, $7Bw5s.getSide)(placement));
            const mainAxis = (0, $7Bw5s.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $7Bw5s.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $7Bw5s.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $eced8798831281d6$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $7Bw5s.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $7Bw5s.getSideAxis)(placement);
            const mainAxis = (0, $7Bw5s.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $7Bw5s.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $7Bw5s.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $eced8798831281d6$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $7Bw5s.evaluate)(options, state);
            const overflow = await $eced8798831281d6$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $7Bw5s.getSide)(placement);
            const alignment = (0, $7Bw5s.getAlignment)(placement);
            const isYAxis = (0, $7Bw5s.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $7Bw5s.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $7Bw5s.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $7Bw5s.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $7Bw5s.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $7Bw5s.max)(overflow.left, 0);
                const xMax = (0, $7Bw5s.max)(overflow.right, 0);
                const yMin = (0, $7Bw5s.max)(overflow.top, 0);
                const yMax = (0, $7Bw5s.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $7Bw5s.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $7Bw5s.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("7Bw5s", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $5894e0f08081e479$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $5894e0f08081e479$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $5894e0f08081e479$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $5894e0f08081e479$export$8960430cfd85939f; });
$parcel$export(module.exports, "clamp", function () { return $5894e0f08081e479$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $5894e0f08081e479$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $5894e0f08081e479$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $5894e0f08081e479$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $5894e0f08081e479$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $5894e0f08081e479$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $5894e0f08081e479$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $5894e0f08081e479$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $5894e0f08081e479$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $5894e0f08081e479$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $5894e0f08081e479$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $5894e0f08081e479$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $5894e0f08081e479$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $5894e0f08081e479$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $5894e0f08081e479$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $5894e0f08081e479$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $5894e0f08081e479$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $5894e0f08081e479$export$803cd8101b6c182b = /*#__PURE__*/ $5894e0f08081e479$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $5894e0f08081e479$export$27b07d8a310ed8b5[0], side + "-" + $5894e0f08081e479$export$27b07d8a310ed8b5[1]), []);
const $5894e0f08081e479$export$96ec731ed4dcb222 = Math.min;
const $5894e0f08081e479$export$8960430cfd85939f = Math.max;
const $5894e0f08081e479$export$2077e0241d6afd3c = Math.round;
const $5894e0f08081e479$export$a3fe094919f356fd = Math.floor;
const $5894e0f08081e479$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $5894e0f08081e479$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $5894e0f08081e479$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $5894e0f08081e479$export$7d15b64cf5a3a4c4(start, value, end) {
    return $5894e0f08081e479$export$8960430cfd85939f(start, $5894e0f08081e479$export$96ec731ed4dcb222(value, end));
}
function $5894e0f08081e479$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $5894e0f08081e479$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $5894e0f08081e479$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $5894e0f08081e479$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $5894e0f08081e479$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $5894e0f08081e479$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($5894e0f08081e479$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $5894e0f08081e479$export$2b57e0052a6d6d4c(placement) {
    return $5894e0f08081e479$export$8a000a963141ac32($5894e0f08081e479$export$f28e8f882010718a(placement));
}
function $5894e0f08081e479$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $5894e0f08081e479$export$f0989780f32bfcda(placement);
    const alignmentAxis = $5894e0f08081e479$export$2b57e0052a6d6d4c(placement);
    const length = $5894e0f08081e479$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $5894e0f08081e479$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $5894e0f08081e479$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $5894e0f08081e479$export$496432a3699e50b1(placement) {
    const oppositePlacement = $5894e0f08081e479$export$9c5e28bad23365fa(placement);
    return [
        $5894e0f08081e479$export$2b182c584985588b(placement),
        oppositePlacement,
        $5894e0f08081e479$export$2b182c584985588b(oppositePlacement)
    ];
}
function $5894e0f08081e479$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$5894e0f08081e479$var$oppositeAlignmentMap[alignment]);
}
function $5894e0f08081e479$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $5894e0f08081e479$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $5894e0f08081e479$export$f0989780f32bfcda(placement);
    let list = $5894e0f08081e479$var$getSideList($5894e0f08081e479$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($5894e0f08081e479$export$2b182c584985588b));
    }
    return list;
}
function $5894e0f08081e479$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$5894e0f08081e479$var$oppositeSideMap[side]);
}
function $5894e0f08081e479$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $5894e0f08081e479$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $5894e0f08081e479$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $5894e0f08081e479$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("3M140", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $2bf6adfd97852c13$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $2bf6adfd97852c13$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $2bf6adfd97852c13$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $2bf6adfd97852c13$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $2bf6adfd97852c13$export$a397704b5e280835; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $2bf6adfd97852c13$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $2bf6adfd97852c13$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $2bf6adfd97852c13$export$803cd8101b6c182b = /*#__PURE__*/ $2bf6adfd97852c13$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $2bf6adfd97852c13$export$27b07d8a310ed8b5[0], side + "-" + $2bf6adfd97852c13$export$27b07d8a310ed8b5[1]), []);
const $2bf6adfd97852c13$export$96ec731ed4dcb222 = Math.min;
const $2bf6adfd97852c13$export$8960430cfd85939f = Math.max;
const $2bf6adfd97852c13$export$2077e0241d6afd3c = Math.round;
const $2bf6adfd97852c13$export$a3fe094919f356fd = Math.floor;
const $2bf6adfd97852c13$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $2bf6adfd97852c13$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $2bf6adfd97852c13$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $2bf6adfd97852c13$export$7d15b64cf5a3a4c4(start, value, end) {
    return $2bf6adfd97852c13$export$8960430cfd85939f(start, $2bf6adfd97852c13$export$96ec731ed4dcb222(value, end));
}
function $2bf6adfd97852c13$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $2bf6adfd97852c13$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $2bf6adfd97852c13$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $2bf6adfd97852c13$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $2bf6adfd97852c13$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $2bf6adfd97852c13$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($2bf6adfd97852c13$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $2bf6adfd97852c13$export$2b57e0052a6d6d4c(placement) {
    return $2bf6adfd97852c13$export$8a000a963141ac32($2bf6adfd97852c13$export$f28e8f882010718a(placement));
}
function $2bf6adfd97852c13$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $2bf6adfd97852c13$export$f0989780f32bfcda(placement);
    const alignmentAxis = $2bf6adfd97852c13$export$2b57e0052a6d6d4c(placement);
    const length = $2bf6adfd97852c13$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $2bf6adfd97852c13$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $2bf6adfd97852c13$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $2bf6adfd97852c13$export$496432a3699e50b1(placement) {
    const oppositePlacement = $2bf6adfd97852c13$export$9c5e28bad23365fa(placement);
    return [
        $2bf6adfd97852c13$export$2b182c584985588b(placement),
        oppositePlacement,
        $2bf6adfd97852c13$export$2b182c584985588b(oppositePlacement)
    ];
}
function $2bf6adfd97852c13$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$2bf6adfd97852c13$var$oppositeAlignmentMap[alignment]);
}
function $2bf6adfd97852c13$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $2bf6adfd97852c13$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $2bf6adfd97852c13$export$f0989780f32bfcda(placement);
    let list = $2bf6adfd97852c13$var$getSideList($2bf6adfd97852c13$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($2bf6adfd97852c13$export$2b182c584985588b));
    }
    return list;
}
function $2bf6adfd97852c13$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$2bf6adfd97852c13$var$oppositeSideMap[side]);
}
function $2bf6adfd97852c13$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $2bf6adfd97852c13$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $2bf6adfd97852c13$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $2bf6adfd97852c13$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});

parcelRegister("bYyLo", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $0240011733df5fc9$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $0240011733df5fc9$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $0240011733df5fc9$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $0240011733df5fc9$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0240011733df5fc9$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $0240011733df5fc9$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $0240011733df5fc9$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $0240011733df5fc9$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $0240011733df5fc9$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $0240011733df5fc9$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $0240011733df5fc9$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $0240011733df5fc9$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $0240011733df5fc9$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $0240011733df5fc9$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $0240011733df5fc9$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $0240011733df5fc9$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $0240011733df5fc9$export$7bf1f8740e3e34af; });
function $0240011733df5fc9$export$651544f548703224(node) {
    if ($0240011733df5fc9$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $0240011733df5fc9$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $0240011733df5fc9$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($0240011733df5fc9$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $0240011733df5fc9$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $0240011733df5fc9$export$38b2d434cce3ea22(value).Node;
}
function $0240011733df5fc9$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $0240011733df5fc9$export$38b2d434cce3ea22(value).Element;
}
function $0240011733df5fc9$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $0240011733df5fc9$export$38b2d434cce3ea22(value).HTMLElement;
}
function $0240011733df5fc9$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $0240011733df5fc9$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $0240011733df5fc9$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $0240011733df5fc9$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $0240011733df5fc9$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($0240011733df5fc9$export$651544f548703224(element));
}
function $0240011733df5fc9$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $0240011733df5fc9$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $0240011733df5fc9$export$78551043582a6a98();
    const css = $0240011733df5fc9$export$45a5e7f76e0caa8d(elementOrCss) ? $0240011733df5fc9$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $0240011733df5fc9$export$940d8225183e1404(element) {
    let currentNode = $0240011733df5fc9$export$4e12058fc4d51d56(element);
    while($0240011733df5fc9$export$1b3bfaa9684536aa(currentNode) && !$0240011733df5fc9$export$d1162fb0b6d4cd51(currentNode)){
        if ($0240011733df5fc9$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($0240011733df5fc9$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $0240011733df5fc9$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $0240011733df5fc9$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $0240011733df5fc9$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($0240011733df5fc9$export$651544f548703224(node));
}
function $0240011733df5fc9$export$3735103072e4a80(element) {
    return $0240011733df5fc9$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $0240011733df5fc9$export$dc8fc79fa2800137(element) {
    if ($0240011733df5fc9$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $0240011733df5fc9$export$4e12058fc4d51d56(node) {
    if ($0240011733df5fc9$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $0240011733df5fc9$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $0240011733df5fc9$export$e495491855dc5418(node);
    return $0240011733df5fc9$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $0240011733df5fc9$export$7cd01a57c8ca906c(node) {
    const parentNode = $0240011733df5fc9$export$4e12058fc4d51d56(node);
    if ($0240011733df5fc9$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($0240011733df5fc9$export$1b3bfaa9684536aa(parentNode) && $0240011733df5fc9$export$989e911fa9af580a(parentNode)) return parentNode;
    return $0240011733df5fc9$export$7cd01a57c8ca906c(parentNode);
}
function $0240011733df5fc9$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $0240011733df5fc9$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $0240011733df5fc9$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $0240011733df5fc9$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $0240011733df5fc9$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $0240011733df5fc9$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $0240011733df5fc9$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $0240011733df5fc9$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("cyvBx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92412d010b23cee0$export$2e2bcd8739ae039; });

var $7PdBe = parcelRequire("7PdBe");
var $92412d010b23cee0$var$index = (0, $7PdBe.useLayoutEffect);
var $92412d010b23cee0$export$2e2bcd8739ae039 = $92412d010b23cee0$var$index;

});


parcelRegister("aQYlP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e6d9327f784f819$export$2e2bcd8739ae039; });

var $1eVYh = parcelRequire("1eVYh");

var $hIbXl = parcelRequire("hIbXl");

var $7PdBe = parcelRequire("7PdBe");

var $cDCJY = parcelRequire("cDCJY");

var $kwe0A = parcelRequire("kwe0A");

var $cG9fz = parcelRequire("cG9fz");

var $9gX1H = parcelRequire("9gX1H");
parcelRequire("fIAZC");
parcelRequire("j3FKP");
parcelRequire("8OqzN");
parcelRequire("63amM");
parcelRequire("42PgU");
parcelRequire("iYEZH");
parcelRequire("lbAen");
parcelRequire("gI2DD");

parcelRequire("jToPP");
parcelRequire("em1Ga");
parcelRequire("hgUYm");
parcelRequire("1cUCD");

parcelRequire("cyvBx");
var $7e6d9327f784f819$var$StateManagedSelect = /*#__PURE__*/ (0, $7PdBe.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $1eVYh.u)(props);
    return /*#__PURE__*/ $7PdBe.createElement((0, $cDCJY.S), (0, $hIbXl.default)({
        ref: ref
    }, baseSelectProps));
});
var $7e6d9327f784f819$export$2e2bcd8739ae039 = $7e6d9327f784f819$var$StateManagedSelect;
var $7e6d9327f784f819$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $7PdBe.useMemo)(function() {
        return (0, $cG9fz.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $7PdBe.createElement((0, $kwe0A.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("1eVYh", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $0e74111c5d562b80$export$3b14a55fb2447963; });

var $b17Jx = parcelRequire("b17Jx");

var $5OuPz = parcelRequire("5OuPz");

var $j6qgd = parcelRequire("j6qgd");

var $7PdBe = parcelRequire("7PdBe");
var $0e74111c5d562b80$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $0e74111c5d562b80$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $j6qgd.default)(_ref, $0e74111c5d562b80$var$_excluded);
    var _useState = (0, $7PdBe.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $5OuPz.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $7PdBe.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $5OuPz.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $7PdBe.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $5OuPz.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $7PdBe.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $7PdBe.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $7PdBe.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $7PdBe.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $b17Jx.default)((0, $b17Jx.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("cDCJY", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $93372d9c106fd460$export$25ce5a424b770e84; });

var $hIbXl = parcelRequire("hIbXl");

var $b17Jx = parcelRequire("b17Jx");

var $hGO86 = parcelRequire("hGO86");

var $9pbVp = parcelRequire("9pbVp");

var $diRJC = parcelRequire("diRJC");

var $01eLm = parcelRequire("01eLm");

var $2fMxM = parcelRequire("2fMxM");

var $7PdBe = parcelRequire("7PdBe");

var $9gX1H = parcelRequire("9gX1H");

var $5OJLl = parcelRequire("5OJLl");

var $5qb3I = parcelRequire("5qb3I");

var $j6qgd = parcelRequire("j6qgd");
function $93372d9c106fd460$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $93372d9c106fd460$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $93372d9c106fd460$var$A11yText = function A11yText(props) {
    return (0, $5OJLl.jsx)("span", (0, $hIbXl.default)({
        css: $93372d9c106fd460$var$_ref
    }, props));
};
var $93372d9c106fd460$var$A11yText$1 = $93372d9c106fd460$var$A11yText;
var $93372d9c106fd460$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $93372d9c106fd460$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $7PdBe.useMemo)(function() {
        return (0, $b17Jx.default)((0, $b17Jx.default)({}, $93372d9c106fd460$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $7PdBe.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $b17Jx.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $7PdBe.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $7PdBe.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $7PdBe.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $5OJLl.jsx)((0, $7PdBe.Fragment), null, (0, $5OJLl.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $5OJLl.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $5OJLl.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $5OJLl.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $5OJLl.jsx)((0, $7PdBe.Fragment), null, (0, $5OJLl.jsx)($93372d9c106fd460$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $5OJLl.jsx)($93372d9c106fd460$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $93372d9c106fd460$var$LiveRegion$1 = $93372d9c106fd460$var$LiveRegion;
var $93372d9c106fd460$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $93372d9c106fd460$var$anyDiacritic = new RegExp("[" + $93372d9c106fd460$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $93372d9c106fd460$var$diacriticToBase = {};
for(var $93372d9c106fd460$var$i = 0; $93372d9c106fd460$var$i < $93372d9c106fd460$var$diacritics.length; $93372d9c106fd460$var$i++){
    var $93372d9c106fd460$var$diacritic = $93372d9c106fd460$var$diacritics[$93372d9c106fd460$var$i];
    for(var $93372d9c106fd460$var$j = 0; $93372d9c106fd460$var$j < $93372d9c106fd460$var$diacritic.letters.length; $93372d9c106fd460$var$j++)$93372d9c106fd460$var$diacriticToBase[$93372d9c106fd460$var$diacritic.letters[$93372d9c106fd460$var$j]] = $93372d9c106fd460$var$diacritic.base;
}
var $93372d9c106fd460$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($93372d9c106fd460$var$anyDiacritic, function(match) {
        return $93372d9c106fd460$var$diacriticToBase[match];
    });
};
var $93372d9c106fd460$var$memoizedStripDiacriticsForInput = (0, $5qb3I.default)($93372d9c106fd460$var$stripDiacritics);
var $93372d9c106fd460$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $93372d9c106fd460$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $93372d9c106fd460$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $b17Jx.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $93372d9c106fd460$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $93372d9c106fd460$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $93372d9c106fd460$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $93372d9c106fd460$var$memoizedStripDiacriticsForInput(input);
            candidate = $93372d9c106fd460$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $93372d9c106fd460$var$_excluded = [
    "innerRef"
];
function $93372d9c106fd460$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $j6qgd.default)(_ref, $93372d9c106fd460$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $9gX1H.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $5OJLl.jsx)("input", (0, $hIbXl.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $5OJLl.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $93372d9c106fd460$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $93372d9c106fd460$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $7PdBe.useRef)(false);
    var isTop = (0, $7PdBe.useRef)(false);
    var touchStart = (0, $7PdBe.useRef)(0);
    var scrollTarget = (0, $7PdBe.useRef)(null);
    var handleEventDelta = (0, $7PdBe.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $93372d9c106fd460$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $7PdBe.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $7PdBe.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $7PdBe.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $7PdBe.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $9gX1H.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $7PdBe.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $7PdBe.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $93372d9c106fd460$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $93372d9c106fd460$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $93372d9c106fd460$var$preventTouchMove(e) {
    e.preventDefault();
}
function $93372d9c106fd460$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $93372d9c106fd460$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $93372d9c106fd460$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $93372d9c106fd460$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $93372d9c106fd460$var$activeScrollLocks = 0;
var $93372d9c106fd460$var$listenerOptions = {
    capture: false,
    passive: false
};
function $93372d9c106fd460$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $7PdBe.useRef)({});
    var scrollTarget = (0, $7PdBe.useRef)(null);
    var addScrollLock = (0, $7PdBe.useCallback)(function(touchScrollTarget) {
        if (!$93372d9c106fd460$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $93372d9c106fd460$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $93372d9c106fd460$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($93372d9c106fd460$var$LOCK_STYLES).forEach(function(key) {
                var val = $93372d9c106fd460$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $93372d9c106fd460$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $93372d9c106fd460$var$preventTouchMove, $93372d9c106fd460$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $93372d9c106fd460$var$preventInertiaScroll, $93372d9c106fd460$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $93372d9c106fd460$var$allowTouchMove, $93372d9c106fd460$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $93372d9c106fd460$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $7PdBe.useCallback)(function(touchScrollTarget) {
        if (!$93372d9c106fd460$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $93372d9c106fd460$var$activeScrollLocks = Math.max($93372d9c106fd460$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $93372d9c106fd460$var$activeScrollLocks < 1) $93372d9c106fd460$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $93372d9c106fd460$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $93372d9c106fd460$var$preventTouchMove, $93372d9c106fd460$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $93372d9c106fd460$var$preventInertiaScroll, $93372d9c106fd460$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $93372d9c106fd460$var$allowTouchMove, $93372d9c106fd460$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $7PdBe.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $93372d9c106fd460$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $93372d9c106fd460$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $93372d9c106fd460$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $93372d9c106fd460$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $93372d9c106fd460$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $93372d9c106fd460$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $5OJLl.jsx)((0, $7PdBe.Fragment), null, lockEnabled && (0, $5OJLl.jsx)("div", {
        onClick: $93372d9c106fd460$var$blurSelectInput,
        css: $93372d9c106fd460$var$_ref2$1
    }), children(targetRef));
}
function $93372d9c106fd460$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $93372d9c106fd460$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $93372d9c106fd460$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $5OJLl.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $93372d9c106fd460$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $93372d9c106fd460$var$RequiredInput$1 = $93372d9c106fd460$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $93372d9c106fd460$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $93372d9c106fd460$var$isIPhone() {
    return $93372d9c106fd460$var$testPlatform(/^iPhone/i);
}
function $93372d9c106fd460$var$isMac() {
    return $93372d9c106fd460$var$testPlatform(/^Mac/i);
}
function $93372d9c106fd460$var$isIPad() {
    return $93372d9c106fd460$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $93372d9c106fd460$var$isMac() && navigator.maxTouchPoints > 1;
}
function $93372d9c106fd460$var$isIOS() {
    return $93372d9c106fd460$var$isIPhone() || $93372d9c106fd460$var$isIPad();
}
function $93372d9c106fd460$var$isAppleDevice() {
    return $93372d9c106fd460$var$isMac() || $93372d9c106fd460$var$isIOS();
}
var $93372d9c106fd460$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $93372d9c106fd460$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $93372d9c106fd460$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $93372d9c106fd460$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $93372d9c106fd460$var$defaultStyles = {
    clearIndicator: (0, $9gX1H.a),
    container: (0, $9gX1H.b),
    control: (0, $9gX1H.d),
    dropdownIndicator: (0, $9gX1H.e),
    group: (0, $9gX1H.g),
    groupHeading: (0, $9gX1H.f),
    indicatorsContainer: (0, $9gX1H.i),
    indicatorSeparator: (0, $9gX1H.h),
    input: (0, $9gX1H.j),
    loadingIndicator: (0, $9gX1H.l),
    loadingMessage: (0, $9gX1H.k),
    menu: (0, $9gX1H.m),
    menuList: (0, $9gX1H.n),
    menuPortal: (0, $9gX1H.o),
    multiValue: (0, $9gX1H.p),
    multiValueLabel: (0, $9gX1H.q),
    multiValueRemove: (0, $9gX1H.t),
    noOptionsMessage: (0, $9gX1H.u),
    option: (0, $9gX1H.v),
    placeholder: (0, $9gX1H.w),
    singleValue: (0, $9gX1H.x),
    valueContainer: (0, $9gX1H.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $93372d9c106fd460$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $b17Jx.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $93372d9c106fd460$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $93372d9c106fd460$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $93372d9c106fd460$var$baseUnit = 4;
// The minimum height of the control
var $93372d9c106fd460$var$controlHeight = 38;
// The amount of space between the control and menu */
var $93372d9c106fd460$var$menuGutter = $93372d9c106fd460$var$baseUnit * 2;
var $93372d9c106fd460$var$spacing = {
    baseUnit: $93372d9c106fd460$var$baseUnit,
    controlHeight: $93372d9c106fd460$var$controlHeight,
    menuGutter: $93372d9c106fd460$var$menuGutter
};
var $93372d9c106fd460$export$4368d992c4eafac0 = {
    borderRadius: $93372d9c106fd460$var$borderRadius,
    colors: $93372d9c106fd460$var$colors,
    spacing: $93372d9c106fd460$var$spacing
};
var $93372d9c106fd460$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $9gX1H.z)(),
    captureMenuScroll: !(0, $9gX1H.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $93372d9c106fd460$export$db3b6bfb95261072(),
    formatGroupLabel: $93372d9c106fd460$var$formatGroupLabel,
    getOptionLabel: $93372d9c106fd460$export$8b22cf2602fb60ce,
    getOptionValue: $93372d9c106fd460$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $93372d9c106fd460$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $9gX1H.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $93372d9c106fd460$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $93372d9c106fd460$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $93372d9c106fd460$var$_isOptionSelected(props, option, selectValue);
    var label = $93372d9c106fd460$var$getOptionLabel(props, option);
    var value = $93372d9c106fd460$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $93372d9c106fd460$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $93372d9c106fd460$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $93372d9c106fd460$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $93372d9c106fd460$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $93372d9c106fd460$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $9gX1H.K));
}
function $93372d9c106fd460$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $2fMxM.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $93372d9c106fd460$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $2fMxM.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $93372d9c106fd460$var$buildFocusableOptions(props, selectValue) {
    return $93372d9c106fd460$var$buildFocusableOptionsFromCategorizedOptions($93372d9c106fd460$var$buildCategorizedOptions(props, selectValue));
}
function $93372d9c106fd460$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$93372d9c106fd460$var$shouldHideSelectedOptions(props) || !isSelected) && $93372d9c106fd460$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $93372d9c106fd460$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $93372d9c106fd460$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $93372d9c106fd460$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $93372d9c106fd460$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $93372d9c106fd460$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $93372d9c106fd460$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $93372d9c106fd460$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $93372d9c106fd460$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $93372d9c106fd460$var$getOptionValue(props, i) === candidate;
    });
}
function $93372d9c106fd460$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $93372d9c106fd460$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $93372d9c106fd460$var$instanceId = 1;
var $93372d9c106fd460$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $diRJC.default)(Select, _Component);
    var _super = (0, $01eLm.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $hGO86.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $93372d9c106fd460$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $9gX1H.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $9gX1H.B)([].concat((0, $2fMxM.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $9gX1H.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $9gX1H.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $9gX1H.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $9gX1H.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $9gX1H.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $93372d9c106fd460$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $93372d9c106fd460$var$buildFocusableOptionsWithIds($93372d9c106fd460$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $9gX1H.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $93372d9c106fd460$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $93372d9c106fd460$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $93372d9c106fd460$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $9gX1H.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $93372d9c106fd460$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $93372d9c106fd460$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $b17Jx.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $9gX1H.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $93372d9c106fd460$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$93372d9c106fd460$var$instanceId);
        _this.state.selectValue = (0, $9gX1H.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $93372d9c106fd460$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $9pbVp.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $9gX1H.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $9gX1H.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $93372d9c106fd460$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($93372d9c106fd460$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $b17Jx.default)((0, $b17Jx.default)({}, $93372d9c106fd460$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $93372d9c106fd460$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $93372d9c106fd460$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $93372d9c106fd460$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $b17Jx.default)((0, $b17Jx.default)((0, $b17Jx.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $7PdBe.createElement($93372d9c106fd460$var$DummyInput, (0, $hIbXl.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $9gX1H.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $7PdBe.createElement(Input, (0, $hIbXl.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $7PdBe.createElement(Placeholder, (0, $hIbXl.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $7PdBe.createElement(MultiValue, (0, $hIbXl.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $7PdBe.createElement(SingleValue, (0, $hIbXl.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $7PdBe.createElement(ClearIndicator, (0, $hIbXl.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $7PdBe.createElement(LoadingIndicator, (0, $hIbXl.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $7PdBe.createElement(IndicatorSeparator, (0, $hIbXl.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $7PdBe.createElement(DropdownIndicator, (0, $hIbXl.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $7PdBe.createElement(Option, (0, $hIbXl.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $7PdBe.createElement(Group, (0, $hIbXl.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $7PdBe.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $7PdBe.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $7PdBe.createElement((0, $9gX1H.M), (0, $hIbXl.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $7PdBe.createElement(Menu, (0, $hIbXl.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $7PdBe.createElement($93372d9c106fd460$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $7PdBe.createElement(MenuList, (0, $hIbXl.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $7PdBe.createElement(MenuPortal, (0, $hIbXl.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $7PdBe.createElement($93372d9c106fd460$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $7PdBe.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $7PdBe.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $7PdBe.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $7PdBe.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $7PdBe.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $7PdBe.createElement($93372d9c106fd460$var$LiveRegion$1, (0, $hIbXl.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $7PdBe.createElement(SelectContainer, (0, $hIbXl.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $7PdBe.createElement(Control, (0, $hIbXl.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $7PdBe.createElement(ValueContainer, (0, $hIbXl.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $7PdBe.createElement(IndicatorsContainer, (0, $hIbXl.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $9gX1H.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $93372d9c106fd460$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $93372d9c106fd460$var$buildFocusableOptionsWithIds($93372d9c106fd460$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $93372d9c106fd460$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $93372d9c106fd460$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $93372d9c106fd460$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $9gX1H.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $b17Jx.default)((0, $b17Jx.default)((0, $b17Jx.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $7PdBe.Component));
$93372d9c106fd460$export$25ce5a424b770e84.defaultProps = $93372d9c106fd460$export$407448d2b89b1813;

});
parcelRegister("hGO86", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce0d3e9ecf192bec$export$2e2bcd8739ae039; });
function $ce0d3e9ecf192bec$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9pbVp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d8fb2ec31702227$export$2e2bcd8739ae039; });

var $id3YY = parcelRequire("id3YY");
function $6d8fb2ec31702227$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $id3YY.default)(o.key), o);
    }
}
function $6d8fb2ec31702227$export$2e2bcd8739ae039(e, r, t) {
    return r && $6d8fb2ec31702227$var$_defineProperties(e.prototype, r), t && $6d8fb2ec31702227$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("diRJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9af6a36a64d5414f$export$2e2bcd8739ae039; });

var $izWVf = parcelRequire("izWVf");
function $9af6a36a64d5414f$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $izWVf.default)(t, e);
}

});
parcelRegister("izWVf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d86933a4d014b959$export$2e2bcd8739ae039; });
function $d86933a4d014b959$export$2e2bcd8739ae039(t, e) {
    return $d86933a4d014b959$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d86933a4d014b959$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("01eLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $003b8bbb6c0851de$export$2e2bcd8739ae039; });

var $bvSjj = parcelRequire("bvSjj");

var $aHPz1 = parcelRequire("aHPz1");

var $iGxTj = parcelRequire("iGxTj");
function $003b8bbb6c0851de$export$2e2bcd8739ae039(t) {
    var r = (0, $aHPz1.default)();
    return function() {
        var e, o = (0, $bvSjj.default)(t);
        if (r) {
            var s = (0, $bvSjj.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $iGxTj.default)(this, e);
    };
}

});
parcelRegister("bvSjj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $861cb7e3a85519ef$export$2e2bcd8739ae039; });
function $861cb7e3a85519ef$export$2e2bcd8739ae039(t) {
    return $861cb7e3a85519ef$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $861cb7e3a85519ef$export$2e2bcd8739ae039(t);
}

});

parcelRegister("aHPz1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cb5eb07c59fdd02$export$2e2bcd8739ae039; });
function $7cb5eb07c59fdd02$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7cb5eb07c59fdd02$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("iGxTj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9a67051db922437$export$2e2bcd8739ae039; });

var $enYWB = parcelRequire("enYWB");

var $goT1f = parcelRequire("goT1f");
function $d9a67051db922437$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $enYWB.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $goT1f.default)(t);
}

});
parcelRegister("goT1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf0990ddf23658d5$export$2e2bcd8739ae039; });
function $bf0990ddf23658d5$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("2fMxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a42a34e2d075ff1$export$2e2bcd8739ae039; });

var $8eqbk = parcelRequire("8eqbk");

var $7dhUW = parcelRequire("7dhUW");

var $bCHYX = parcelRequire("bCHYX");

var $5OYwT = parcelRequire("5OYwT");
function $1a42a34e2d075ff1$export$2e2bcd8739ae039(r) {
    return (0, $8eqbk.default)(r) || (0, $7dhUW.default)(r) || (0, $bCHYX.default)(r) || (0, $5OYwT.default)();
}

});
parcelRegister("8eqbk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fe3f0a896b68d5f$export$2e2bcd8739ae039; });

var $37Vfb = parcelRequire("37Vfb");
function $5fe3f0a896b68d5f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $37Vfb.default)(r);
}

});

parcelRegister("7dhUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5407a5567a1c27d3$export$2e2bcd8739ae039; });
function $5407a5567a1c27d3$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("5OYwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43d09327770265e7$export$2e2bcd8739ae039; });
function $43d09327770265e7$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("5qb3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f27f58c60ed1a5b$export$2e2bcd8739ae039; });
var $3f27f58c60ed1a5b$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $3f27f58c60ed1a5b$var$isEqual(first, second) {
    if (first === second) return true;
    if ($3f27f58c60ed1a5b$var$safeIsNaN(first) && $3f27f58c60ed1a5b$var$safeIsNaN(second)) return true;
    return false;
}
function $3f27f58c60ed1a5b$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$3f27f58c60ed1a5b$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $3f27f58c60ed1a5b$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $3f27f58c60ed1a5b$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("fIAZC", function(module, exports) {

var $hgUYm = parcelRequire("hgUYm");
function $b717a9105e9f72e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b717a9105e9f72e2$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b717a9105e9f72e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $hgUYm(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b717a9105e9f72e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $b717a9105e9f72e2$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hgUYm", function(module, exports) {

var $f9Wla = parcelRequire("f9Wla");
function $c9301fd5b0d641db$var$_defineProperty(e, r, t) {
    return (r = $f9Wla(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $c9301fd5b0d641db$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f9Wla", function(module, exports) {

var $jToPP = parcelRequire("jToPP");
var $b094f37685a5c0b0$var$_typeof = $jToPP.default;

var $4L5nT = parcelRequire("4L5nT");
function $b094f37685a5c0b0$var$toPropertyKey(t) {
    var i = $4L5nT(t, "string");
    return "symbol" == $b094f37685a5c0b0$var$_typeof(i) ? i : i + "";
}
module.exports = $b094f37685a5c0b0$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jToPP", function(module, exports) {
function $e7b66b134752c650$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $e7b66b134752c650$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e7b66b134752c650$var$_typeof(o);
}
module.exports = $e7b66b134752c650$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4L5nT", function(module, exports) {

var $jToPP = parcelRequire("jToPP");
var $376fba745d567b9e$var$_typeof = $jToPP.default;
function $376fba745d567b9e$var$toPrimitive(t, r) {
    if ("object" != $376fba745d567b9e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $376fba745d567b9e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $376fba745d567b9e$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("j3FKP", function(module, exports) {

var $5pL2L = parcelRequire("5pL2L");

var $llKy1 = parcelRequire("llKy1");

var $4tRa5 = parcelRequire("4tRa5");

var $64R3M = parcelRequire("64R3M");
function $ddfeafa5c8269955$var$_slicedToArray(r, e) {
    return $5pL2L(r) || $llKy1(r, e) || $4tRa5(r, e) || $64R3M();
}
module.exports = $ddfeafa5c8269955$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5pL2L", function(module, exports) {
function $3f13c76fbe866620$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $3f13c76fbe866620$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("llKy1", function(module, exports) {
function $f8afaa8af4cf7824$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $f8afaa8af4cf7824$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4tRa5", function(module, exports) {

var $e7FUr = parcelRequire("e7FUr");
function $34331ba9c1abd609$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e7FUr(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e7FUr(r, a) : void 0;
    }
}
module.exports = $34331ba9c1abd609$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("e7FUr", function(module, exports) {
function $a4823a76b21c4c76$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $a4823a76b21c4c76$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("64R3M", function(module, exports) {
function $46cc4663fbdcbc3b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $46cc4663fbdcbc3b$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8OqzN", function(module, exports) {

var $kxu1t = parcelRequire("kxu1t");
function $66a79bc093013c10$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $kxu1t(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $66a79bc093013c10$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kxu1t", function(module, exports) {
function $ef3e2d973379b35f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $ef3e2d973379b35f$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("63amM", function(module, exports) {
function $467b106e80098fe9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $467b106e80098fe9$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("42PgU", function(module, exports) {

var $f9Wla = parcelRequire("f9Wla");
function $2f1f1ed6330ab43a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $f9Wla(o.key), o);
    }
}
function $2f1f1ed6330ab43a$var$_createClass(e, r, t) {
    return r && $2f1f1ed6330ab43a$var$_defineProperties(e.prototype, r), t && $2f1f1ed6330ab43a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $2f1f1ed6330ab43a$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iYEZH", function(module, exports) {

var $gmHSu = parcelRequire("gmHSu");
function $dd0da12aa6b4092a$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $gmHSu(t, e);
}
module.exports = $dd0da12aa6b4092a$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gmHSu", function(module, exports) {
function $bea0bca986fdbd2e$var$_setPrototypeOf(t, e) {
    return module.exports = $bea0bca986fdbd2e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $bea0bca986fdbd2e$var$_setPrototypeOf(t, e);
}
module.exports = $bea0bca986fdbd2e$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lbAen", function(module, exports) {

var $iy1gs = parcelRequire("iy1gs");

var $3Wzbs = parcelRequire("3Wzbs");

var $fDU9F = parcelRequire("fDU9F");
function $f6c6babbee910790$var$_createSuper(t) {
    var r = $3Wzbs();
    return function() {
        var e, o = $iy1gs(t);
        if (r) {
            var s = $iy1gs(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $fDU9F(this, e);
    };
}
module.exports = $f6c6babbee910790$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iy1gs", function(module, exports) {
function $d80c6212e0fc8421$var$_getPrototypeOf(t) {
    return module.exports = $d80c6212e0fc8421$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d80c6212e0fc8421$var$_getPrototypeOf(t);
}
module.exports = $d80c6212e0fc8421$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3Wzbs", function(module, exports) {
function $2df214a3d8014322$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $2df214a3d8014322$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $2df214a3d8014322$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fDU9F", function(module, exports) {

var $jToPP = parcelRequire("jToPP");
var $b6360eb96f893716$var$_typeof = $jToPP.default;

var $9bfCq = parcelRequire("9bfCq");
function $b6360eb96f893716$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $b6360eb96f893716$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $9bfCq(t);
}
module.exports = $b6360eb96f893716$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9bfCq", function(module, exports) {
function $6af141b6198388c7$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $6af141b6198388c7$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("gI2DD", function(module, exports) {

var $kIag3 = parcelRequire("kIag3");

var $5QrTA = parcelRequire("5QrTA");

var $4tRa5 = parcelRequire("4tRa5");

var $5jdIm = parcelRequire("5jdIm");
function $c2a2cd52614acb84$var$_toConsumableArray(r) {
    return $kIag3(r) || $5QrTA(r) || $4tRa5(r) || $5jdIm();
}
module.exports = $c2a2cd52614acb84$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kIag3", function(module, exports) {

var $e7FUr = parcelRequire("e7FUr");
function $f13fdfb2d429882f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e7FUr(r);
}
module.exports = $f13fdfb2d429882f$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5QrTA", function(module, exports) {
function $44177290e79f4a31$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $44177290e79f4a31$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5jdIm", function(module, exports) {
function $3dd95d81f805323b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $3dd95d81f805323b$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("em1Ga", function(module, exports) {
function $a7346c3615d44db7$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $a7346c3615d44db7$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iT6E4", function(module, exports) {

$parcel$export(module.exports, "SortableHandle", function () { return $dc0284adcdd860f0$export$680929e2aec3ce89; });
$parcel$export(module.exports, "SortableContainer", function () { return $dc0284adcdd860f0$export$a4b10e5599330dd0; });
$parcel$export(module.exports, "SortableElement", function () { return $dc0284adcdd860f0$export$58d1e4fb0d207bf7; });

var $hIbXl = parcelRequire("hIbXl");

var $5OuPz = parcelRequire("5OuPz");

var $76QQU = parcelRequire("76QQU");

var $hGO86 = parcelRequire("hGO86");

var $9pbVp = parcelRequire("9pbVp");

var $iGxTj = parcelRequire("iGxTj");

var $bvSjj = parcelRequire("bvSjj");

var $diRJC = parcelRequire("diRJC");

var $goT1f = parcelRequire("goT1f");

var $dHPh8 = parcelRequire("dHPh8");

var $7PdBe = parcelRequire("7PdBe");

var $1cUCD = parcelRequire("1cUCD");

var $ibnnr = parcelRequire("ibnnr");

var $2fMxM = parcelRequire("2fMxM");

var $S29Lp = parcelRequire("S29Lp");
var $dc0284adcdd860f0$var$Manager = function() {
    function Manager() {
        (0, $hGO86.default)(this, Manager);
        (0, $dHPh8.default)(this, "refs", {});
    }
    (0, $9pbVp.default)(Manager, [
        {
            key: "add",
            value: function add(collection, ref) {
                if (!this.refs[collection]) this.refs[collection] = [];
                this.refs[collection].push(ref);
            }
        },
        {
            key: "remove",
            value: function remove(collection, ref) {
                var index = this.getIndex(collection, ref);
                if (index !== -1) this.refs[collection].splice(index, 1);
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return this.active;
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                var _this = this;
                return this.refs[this.active.collection].find(function(_ref) {
                    var node = _ref.node;
                    return node.sortableInfo.index == _this.active.index;
                });
            }
        },
        {
            key: "getIndex",
            value: function getIndex(collection, ref) {
                return this.refs[collection].indexOf(ref);
            }
        },
        {
            key: "getOrderedRefs",
            value: function getOrderedRefs() {
                var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
                return this.refs[collection].sort($dc0284adcdd860f0$var$sortByIndex);
            }
        }
    ]);
    return Manager;
}();
function $dc0284adcdd860f0$var$sortByIndex(_ref2, _ref3) {
    var index1 = _ref2.node.sortableInfo.index;
    var index2 = _ref3.node.sortableInfo.index;
    return index1 - index2;
}
function $dc0284adcdd860f0$export$5d49d615ad5ea2b0(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
}
function $dc0284adcdd860f0$var$omit(obj, keysToOmit) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
        return acc;
    }, {});
}
var $dc0284adcdd860f0$var$events = {
    end: [
        "touchend",
        "touchcancel",
        "mouseup"
    ],
    move: [
        "touchmove",
        "mousemove"
    ],
    start: [
        "touchstart",
        "mousedown"
    ]
};
var $dc0284adcdd860f0$var$vendorPrefix = function() {
    if (typeof window === "undefined" || typeof document === "undefined") return "";
    var styles = window.getComputedStyle(document.documentElement, "") || [
        "-moz-hidden-iframe"
    ];
    var pre = (Array.prototype.slice.call(styles).join("").match(/-(moz|webkit|ms)-/) || styles.OLink === "" && [
        "",
        "o"
    ])[1];
    switch(pre){
        case "ms":
            return "ms";
        default:
            return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : "";
    }
}();
function $dc0284adcdd860f0$var$setInlineStyles(node, styles) {
    Object.keys(styles).forEach(function(key) {
        node.style[key] = styles[key];
    });
}
function $dc0284adcdd860f0$var$setTranslate3d(node, translate) {
    node.style["".concat($dc0284adcdd860f0$var$vendorPrefix, "Transform")] = translate == null ? "" : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function $dc0284adcdd860f0$var$setTransitionDuration(node, duration) {
    node.style["".concat($dc0284adcdd860f0$var$vendorPrefix, "TransitionDuration")] = duration == null ? "" : "".concat(duration, "ms");
}
function $dc0284adcdd860f0$var$closest(el, fn) {
    while(el){
        if (fn(el)) return el;
        el = el.parentNode;
    }
    return null;
}
function $dc0284adcdd860f0$var$limit(min, max, value1) {
    return Math.max(min, Math.min(value1, max));
}
function $dc0284adcdd860f0$var$getPixelValue(stringValue) {
    if (stringValue.substr(-2) === "px") return parseFloat(stringValue);
    return 0;
}
function $dc0284adcdd860f0$var$getElementMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        bottom: $dc0284adcdd860f0$var$getPixelValue(style.marginBottom),
        left: $dc0284adcdd860f0$var$getPixelValue(style.marginLeft),
        right: $dc0284adcdd860f0$var$getPixelValue(style.marginRight),
        top: $dc0284adcdd860f0$var$getPixelValue(style.marginTop)
    };
}
function $dc0284adcdd860f0$var$provideDisplayName(prefix, Component$$1) {
    var componentName = Component$$1.displayName || Component$$1.name;
    return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}
function $dc0284adcdd860f0$var$getScrollAdjustedBoundingClientRect(node, scrollDelta) {
    var boundingClientRect = node.getBoundingClientRect();
    return {
        top: boundingClientRect.top + scrollDelta.top,
        left: boundingClientRect.left + scrollDelta.left
    };
}
function $dc0284adcdd860f0$var$getPosition(event) {
    if (event.touches && event.touches.length) return {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
    };
    else if (event.changedTouches && event.changedTouches.length) return {
        x: event.changedTouches[0].pageX,
        y: event.changedTouches[0].pageY
    };
    else return {
        x: event.pageX,
        y: event.pageY
    };
}
function $dc0284adcdd860f0$var$isTouchEvent(event) {
    return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function $dc0284adcdd860f0$var$getEdgeOffset(node, parent) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        left: 0,
        top: 0
    };
    if (!node) return undefined;
    var nodeOffset = {
        left: offset.left + node.offsetLeft,
        top: offset.top + node.offsetTop
    };
    if (node.parentNode === parent) return nodeOffset;
    return $dc0284adcdd860f0$var$getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function $dc0284adcdd860f0$var$getTargetIndex(newIndex, prevIndex, oldIndex) {
    if (newIndex < oldIndex && newIndex > prevIndex) return newIndex - 1;
    else if (newIndex > oldIndex && newIndex < prevIndex) return newIndex + 1;
    else return newIndex;
}
function $dc0284adcdd860f0$var$getLockPixelOffset(_ref) {
    var lockOffset = _ref.lockOffset, width = _ref.width, height = _ref.height;
    var offsetX = lockOffset;
    var offsetY = lockOffset;
    var unit = "px";
    if (typeof lockOffset === "string") {
        var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
        (0, (/*@__PURE__*/$parcel$interopDefault($ibnnr)))(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
        offsetX = parseFloat(lockOffset);
        offsetY = parseFloat(lockOffset);
        unit = match[1];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ibnnr)))(isFinite(offsetX) && isFinite(offsetY), "lockOffset value should be a finite. Given %s", lockOffset);
    if (unit === "%") {
        offsetX = offsetX * width / 100;
        offsetY = offsetY * height / 100;
    }
    return {
        x: offsetX,
        y: offsetY
    };
}
function $dc0284adcdd860f0$var$getLockPixelOffsets(_ref2) {
    var height = _ref2.height, width = _ref2.width, lockOffset = _ref2.lockOffset;
    var offsets = Array.isArray(lockOffset) ? lockOffset : [
        lockOffset,
        lockOffset
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($ibnnr)))(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
    var _offsets = (0, $5OuPz.default)(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
    return [
        $dc0284adcdd860f0$var$getLockPixelOffset({
            height: height,
            lockOffset: minLockOffset,
            width: width
        }),
        $dc0284adcdd860f0$var$getLockPixelOffset({
            height: height,
            lockOffset: maxLockOffset,
            width: width
        })
    ];
}
function $dc0284adcdd860f0$var$isScrollable(el) {
    var computedStyle = window.getComputedStyle(el);
    var overflowRegex = /(auto|scroll)/;
    var properties = [
        "overflow",
        "overflowX",
        "overflowY"
    ];
    return properties.find(function(property) {
        return overflowRegex.test(computedStyle[property]);
    });
}
function $dc0284adcdd860f0$var$getScrollingParent(el) {
    if (!(el instanceof HTMLElement)) return null;
    else if ($dc0284adcdd860f0$var$isScrollable(el)) return el;
    else return $dc0284adcdd860f0$var$getScrollingParent(el.parentNode);
}
function $dc0284adcdd860f0$var$getContainerGridGap(element) {
    var style = window.getComputedStyle(element);
    if (style.display === "grid") return {
        x: $dc0284adcdd860f0$var$getPixelValue(style.gridColumnGap),
        y: $dc0284adcdd860f0$var$getPixelValue(style.gridRowGap)
    };
    return {
        x: 0,
        y: 0
    };
}
var $dc0284adcdd860f0$var$KEYCODE = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};
var $dc0284adcdd860f0$var$NodeType = {
    Anchor: "A",
    Button: "BUTTON",
    Canvas: "CANVAS",
    Input: "INPUT",
    Option: "OPTION",
    Textarea: "TEXTAREA",
    Select: "SELECT"
};
function $dc0284adcdd860f0$var$cloneNode(node) {
    var selector = "input, textarea, select, canvas, [contenteditable]";
    var fields = node.querySelectorAll(selector);
    var clonedNode = node.cloneNode(true);
    var clonedFields = (0, $2fMxM.default)(clonedNode.querySelectorAll(selector));
    clonedFields.forEach(function(field, i) {
        if (field.type !== "file") field.value = fields[i].value;
        if (field.type === "radio" && field.name) field.name = "__sortableClone__".concat(field.name);
        if (field.tagName === $dc0284adcdd860f0$var$NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
            var destCtx = field.getContext("2d");
            destCtx.drawImage(fields[i], 0, 0);
        }
    });
    return clonedNode;
}
function $dc0284adcdd860f0$export$680929e2aec3ce89(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $diRJC.default)(WithSortableHandle, _React$Component);
        function WithSortableHandle() {
            var _getPrototypeOf2;
            var _this;
            (0, $hGO86.default)(this, WithSortableHandle);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $iGxTj.default)(this, (_getPrototypeOf2 = (0, $bvSjj.default)(WithSortableHandle)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "wrappedInstance", (0, $7PdBe.createRef)());
            return _this;
        }
        (0, $9pbVp.default)(WithSortableHandle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var node = (0, $1cUCD.findDOMNode)(this);
                    node.sortableHandle = true;
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($ibnnr)))(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call");
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $7PdBe.createElement)(WrappedComponent, (0, $hIbXl.default)({
                        ref: ref
                    }, this.props));
                }
            }
        ]);
        return WithSortableHandle;
    }((0, $7PdBe.Component)), (0, $dHPh8.default)(_class, "displayName", $dc0284adcdd860f0$var$provideDisplayName("sortableHandle", WrappedComponent)), _temp;
}
function $dc0284adcdd860f0$var$isSortableHandle(node) {
    return node.sortableHandle != null;
}
var $dc0284adcdd860f0$var$AutoScroller = function() {
    function AutoScroller(container, onScrollCallback) {
        (0, $hGO86.default)(this, AutoScroller);
        this.container = container;
        this.onScrollCallback = onScrollCallback;
    }
    (0, $9pbVp.default)(AutoScroller, [
        {
            key: "clear",
            value: function clear() {
                if (this.interval == null) return;
                clearInterval(this.interval);
                this.interval = null;
            }
        },
        {
            key: "update",
            value: function update(_ref) {
                var _this = this;
                var translate = _ref.translate, minTranslate = _ref.minTranslate, maxTranslate = _ref.maxTranslate, width = _ref.width, height = _ref.height;
                var direction = {
                    x: 0,
                    y: 0
                };
                var speed = {
                    x: 1,
                    y: 1
                };
                var acceleration = {
                    x: 10,
                    y: 10
                };
                var _this$container = this.container, scrollTop = _this$container.scrollTop, scrollLeft = _this$container.scrollLeft, scrollHeight = _this$container.scrollHeight, scrollWidth = _this$container.scrollWidth, clientHeight = _this$container.clientHeight, clientWidth = _this$container.clientWidth;
                var isTop = scrollTop === 0;
                var isBottom = scrollHeight - scrollTop - clientHeight === 0;
                var isLeft = scrollLeft === 0;
                var isRight = scrollWidth - scrollLeft - clientWidth === 0;
                if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
                    direction.y = 1;
                    speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
                } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
                    direction.x = 1;
                    speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
                } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
                    direction.y = -1;
                    speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
                } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
                    direction.x = -1;
                    speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
                }
                if (this.interval) {
                    this.clear();
                    this.isAutoScrolling = false;
                }
                if (direction.x !== 0 || direction.y !== 0) this.interval = setInterval(function() {
                    _this.isAutoScrolling = true;
                    var offset = {
                        left: speed.x * direction.x,
                        top: speed.y * direction.y
                    };
                    _this.container.scrollTop += offset.top;
                    _this.container.scrollLeft += offset.left;
                    _this.onScrollCallback(offset);
                }, 5);
            }
        }
    ]);
    return AutoScroller;
}();
function $dc0284adcdd860f0$var$defaultGetHelperDimensions(_ref) {
    var node = _ref.node;
    return {
        height: node.offsetHeight,
        width: node.offsetWidth
    };
}
function $dc0284adcdd860f0$var$defaultShouldCancelStart(event) {
    var interactiveElements = [
        $dc0284adcdd860f0$var$NodeType.Input,
        $dc0284adcdd860f0$var$NodeType.Textarea,
        $dc0284adcdd860f0$var$NodeType.Select,
        $dc0284adcdd860f0$var$NodeType.Option,
        $dc0284adcdd860f0$var$NodeType.Button
    ];
    if (interactiveElements.indexOf(event.target.tagName) !== -1) return true;
    if ($dc0284adcdd860f0$var$closest(event.target, function(el) {
        return el.contentEditable === "true";
    })) return true;
    return false;
}
var $dc0284adcdd860f0$var$propTypes = {
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOf([
        "x",
        "y",
        "xy"
    ]),
    contentWindow: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).any,
    disableAutoscroll: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).bool,
    distance: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
    getContainer: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    getHelperDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    helperClass: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string,
    helperContainer: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
        typeof HTMLElement === "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).any : (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).instanceOf(HTMLElement)
    ]),
    hideSortableGhost: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).bool,
    keyboardSortingTransitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
    lockAxis: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string,
    lockOffset: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string
        ]))
    ]),
    lockToContainerEdges: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).bool,
    onSortEnd: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    onSortMove: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    onSortOver: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    onSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    pressDelay: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
    pressThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
    keyCodes: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).shape({
        lift: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number),
        drop: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number),
        cancel: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number),
        up: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number),
        down: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number)
    }),
    shouldCancelStart: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
    updateBeforeSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    useDragHandle: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).bool,
    useWindowAsScrollContainer: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).bool
};
var $dc0284adcdd860f0$var$defaultKeyCodes = {
    lift: [
        $dc0284adcdd860f0$var$KEYCODE.SPACE
    ],
    drop: [
        $dc0284adcdd860f0$var$KEYCODE.SPACE
    ],
    cancel: [
        $dc0284adcdd860f0$var$KEYCODE.ESC
    ],
    up: [
        $dc0284adcdd860f0$var$KEYCODE.UP,
        $dc0284adcdd860f0$var$KEYCODE.LEFT
    ],
    down: [
        $dc0284adcdd860f0$var$KEYCODE.DOWN,
        $dc0284adcdd860f0$var$KEYCODE.RIGHT
    ]
};
var $dc0284adcdd860f0$var$defaultProps = {
    axis: "y",
    disableAutoscroll: false,
    distance: 0,
    getHelperDimensions: $dc0284adcdd860f0$var$defaultGetHelperDimensions,
    hideSortableGhost: true,
    lockOffset: "50%",
    lockToContainerEdges: false,
    pressDelay: 0,
    pressThreshold: 5,
    keyCodes: $dc0284adcdd860f0$var$defaultKeyCodes,
    shouldCancelStart: $dc0284adcdd860f0$var$defaultShouldCancelStart,
    transitionDuration: 300,
    useWindowAsScrollContainer: false
};
var $dc0284adcdd860f0$var$omittedProps = Object.keys($dc0284adcdd860f0$var$propTypes);
function $dc0284adcdd860f0$var$validateProps(props) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ibnnr)))(!(props.distance && props.pressDelay), "Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.");
}
function $dc0284adcdd860f0$var$_finallyRethrows(body, finalizer) {
    try {
        var result = body();
    } catch (e) {
        return finalizer(true, e);
    }
    if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
    return finalizer(false, value);
}
var $dc0284adcdd860f0$var$SortableContext = (0, $7PdBe.createContext)({
    manager: {}
});
function $dc0284adcdd860f0$export$a4b10e5599330dd0(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $diRJC.default)(WithSortableContainer, _React$Component);
        function WithSortableContainer(props) {
            var _this;
            (0, $hGO86.default)(this, WithSortableContainer);
            _this = (0, $iGxTj.default)(this, (0, $bvSjj.default)(WithSortableContainer).call(this, props));
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "state", {});
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "handleStart", function(event) {
                var _this$props = _this.props, distance = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
                if (event.button === 2 || shouldCancelStart(event)) return;
                _this.touched = true;
                _this.position = $dc0284adcdd860f0$var$getPosition(event);
                var node = $dc0284adcdd860f0$var$closest(event.target, function(el) {
                    return el.sortableInfo != null;
                });
                if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
                    var useDragHandle = _this.props.useDragHandle;
                    var _node$sortableInfo = node.sortableInfo, index = _node$sortableInfo.index, collection = _node$sortableInfo.collection, disabled = _node$sortableInfo.disabled;
                    if (disabled) return;
                    if (useDragHandle && !$dc0284adcdd860f0$var$closest(event.target, $dc0284adcdd860f0$var$isSortableHandle)) return;
                    _this.manager.active = {
                        collection: collection,
                        index: index
                    };
                    if (!$dc0284adcdd860f0$var$isTouchEvent(event) && event.target.tagName === $dc0284adcdd860f0$var$NodeType.Anchor) event.preventDefault();
                    if (!distance) {
                        if (_this.props.pressDelay === 0) _this.handlePress(event);
                        else _this.pressTimer = setTimeout(function() {
                            return _this.handlePress(event);
                        }, _this.props.pressDelay);
                    }
                }
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "nodeIsChild", function(node) {
                return node.sortableInfo.manager === _this.manager;
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "handleMove", function(event) {
                var _this$props2 = _this.props, distance = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
                if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
                    var position = $dc0284adcdd860f0$var$getPosition(event);
                    var delta = {
                        x: _this.position.x - position.x,
                        y: _this.position.y - position.y
                    };
                    var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
                    _this.delta = delta;
                    if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
                        clearTimeout(_this.cancelTimer);
                        _this.cancelTimer = setTimeout(_this.cancel, 0);
                    } else if (distance && combinedDelta >= distance && _this.manager.isActive()) _this.handlePress(event);
                }
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "handleEnd", function() {
                _this.touched = false;
                _this.cancel();
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "cancel", function() {
                var distance = _this.props.distance;
                var sorting = _this.state.sorting;
                if (!sorting) {
                    if (!distance) clearTimeout(_this.pressTimer);
                    _this.manager.active = null;
                }
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "handlePress", function(event) {
                try {
                    var active = _this.manager.getActive();
                    var _temp6 = function() {
                        if (active) {
                            var _temp7 = function _temp7() {
                                var index = _node.sortableInfo.index;
                                var margin = $dc0284adcdd860f0$var$getElementMargin(_node);
                                var gridGap = $dc0284adcdd860f0$var$getContainerGridGap(_this.container);
                                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();
                                var dimensions = _getHelperDimensions({
                                    index: index,
                                    node: _node,
                                    collection: _collection
                                });
                                _this.node = _node;
                                _this.margin = margin;
                                _this.gridGap = gridGap;
                                _this.width = dimensions.width;
                                _this.height = dimensions.height;
                                _this.marginOffset = {
                                    x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                                    y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                                };
                                _this.boundingClientRect = _node.getBoundingClientRect();
                                _this.containerBoundingRect = containerBoundingRect;
                                _this.index = index;
                                _this.newIndex = index;
                                _this.axis = {
                                    x: _axis.indexOf("x") >= 0,
                                    y: _axis.indexOf("y") >= 0
                                };
                                _this.offsetEdge = $dc0284adcdd860f0$var$getEdgeOffset(_node, _this.container);
                                if (_isKeySorting) _this.initialOffset = $dc0284adcdd860f0$var$getPosition((0, $76QQU.default)({}, event, {
                                    pageX: _this.boundingClientRect.left,
                                    pageY: _this.boundingClientRect.top
                                }));
                                else _this.initialOffset = $dc0284adcdd860f0$var$getPosition(event);
                                _this.initialScroll = {
                                    left: _this.scrollContainer.scrollLeft,
                                    top: _this.scrollContainer.scrollTop
                                };
                                _this.initialWindowScroll = {
                                    left: window.pageXOffset,
                                    top: window.pageYOffset
                                };
                                _this.helper = _this.helperContainer.appendChild($dc0284adcdd860f0$var$cloneNode(_node));
                                $dc0284adcdd860f0$var$setInlineStyles(_this.helper, {
                                    boxSizing: "border-box",
                                    height: "".concat(_this.height, "px"),
                                    left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                                    pointerEvents: "none",
                                    position: "fixed",
                                    top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                                    width: "".concat(_this.width, "px")
                                });
                                if (_isKeySorting) _this.helper.focus();
                                if (_hideSortableGhost) {
                                    _this.sortableGhost = _node;
                                    $dc0284adcdd860f0$var$setInlineStyles(_node, {
                                        opacity: 0,
                                        visibility: "hidden"
                                    });
                                }
                                _this.minTranslate = {};
                                _this.maxTranslate = {};
                                if (_isKeySorting) {
                                    var _ref = _useWindowAsScrollContainer ? {
                                        top: 0,
                                        left: 0,
                                        width: _this.contentWindow.innerWidth,
                                        height: _this.contentWindow.innerHeight
                                    } : _this.containerBoundingRect, containerTop = _ref.top, containerLeft = _ref.left, containerWidth = _ref.width, containerHeight = _ref.height;
                                    var containerBottom = containerTop + containerHeight;
                                    var containerRight = containerLeft + containerWidth;
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                                        _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                                        _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                                    }
                                } else {
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                                        _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                                        _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                                    }
                                }
                                if (_helperClass) _helperClass.split(" ").forEach(function(className) {
                                    return _this.helper.classList.add(className);
                                });
                                _this.listenerNode = event.touches ? event.target : _this.contentWindow;
                                if (_isKeySorting) {
                                    _this.listenerNode.addEventListener("wheel", _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener("mousedown", _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener("keydown", _this.handleKeyDown);
                                } else {
                                    $dc0284adcdd860f0$var$events.move.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                                    });
                                    $dc0284adcdd860f0$var$events.end.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                                    });
                                }
                                _this.setState({
                                    sorting: true,
                                    sortingIndex: index
                                });
                                if (_onSortStart) _onSortStart({
                                    node: _node,
                                    index: index,
                                    collection: _collection,
                                    isKeySorting: _isKeySorting,
                                    nodes: _this.manager.getOrderedRefs(),
                                    helper: _this.helper
                                }, event);
                                if (_isKeySorting) _this.keyMove(0);
                            };
                            var _this$props3 = _this.props, _axis = _this$props3.axis, _getHelperDimensions = _this$props3.getHelperDimensions, _helperClass = _this$props3.helperClass, _hideSortableGhost = _this$props3.hideSortableGhost, updateBeforeSortStart = _this$props3.updateBeforeSortStart, _onSortStart = _this$props3.onSortStart, _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
                            var _node = active.node, _collection = active.collection;
                            var _isKeySorting = _this.manager.isKeySorting;
                            var _temp8 = function() {
                                if (typeof updateBeforeSortStart === "function") {
                                    _this._awaitingUpdateBeforeSortStart = true;
                                    var _temp9 = $dc0284adcdd860f0$var$_finallyRethrows(function() {
                                        var index = _node.sortableInfo.index;
                                        return Promise.resolve(updateBeforeSortStart({
                                            collection: _collection,
                                            index: index,
                                            node: _node,
                                            isKeySorting: _isKeySorting
                                        }, event)).then(function() {});
                                    }, function(_wasThrown, _result) {
                                        _this._awaitingUpdateBeforeSortStart = false;
                                        if (_wasThrown) throw _result;
                                        return _result;
                                    });
                                    if (_temp9 && _temp9.then) return _temp9.then(function() {});
                                }
                            }();
                            return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
                        }
                    }();
                    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function() {}) : void 0);
                } catch (e) {
                    return Promise.reject(e);
                }
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "handleSortMove", function(event) {
                var onSortMove = _this.props.onSortMove;
                if (typeof event.preventDefault === "function" && event.cancelable) event.preventDefault();
                _this.updateHelperPosition(event);
                _this.animateNodes();
                _this.autoscroll();
                if (onSortMove) onSortMove(event);
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "handleSortEnd", function(event) {
                var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
                var _this$manager = _this.manager, collection = _this$manager.active.collection, isKeySorting = _this$manager.isKeySorting;
                var nodes = _this.manager.getOrderedRefs();
                if (_this.listenerNode) {
                    if (isKeySorting) {
                        _this.listenerNode.removeEventListener("wheel", _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener("mousedown", _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener("keydown", _this.handleKeyDown);
                    } else {
                        $dc0284adcdd860f0$var$events.move.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
                        });
                        $dc0284adcdd860f0$var$events.end.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
                        });
                    }
                }
                _this.helper.parentNode.removeChild(_this.helper);
                if (hideSortableGhost && _this.sortableGhost) $dc0284adcdd860f0$var$setInlineStyles(_this.sortableGhost, {
                    opacity: "",
                    visibility: ""
                });
                for(var i = 0, len = nodes.length; i < len; i++){
                    var _node2 = nodes[i];
                    var el = _node2.node;
                    _node2.edgeOffset = null;
                    _node2.boundingClientRect = null;
                    $dc0284adcdd860f0$var$setTranslate3d(el, null);
                    $dc0284adcdd860f0$var$setTransitionDuration(el, null);
                    _node2.translate = null;
                }
                _this.autoScroller.clear();
                _this.manager.active = null;
                _this.manager.isKeySorting = false;
                _this.setState({
                    sorting: false,
                    sortingIndex: null
                });
                if (typeof onSortEnd === "function") onSortEnd({
                    collection: collection,
                    newIndex: _this.newIndex,
                    oldIndex: _this.index,
                    isKeySorting: isKeySorting,
                    nodes: nodes
                }, event);
                _this.touched = false;
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "autoscroll", function() {
                var disableAutoscroll = _this.props.disableAutoscroll;
                var isKeySorting = _this.manager.isKeySorting;
                if (disableAutoscroll) {
                    _this.autoScroller.clear();
                    return;
                }
                if (isKeySorting) {
                    var translate = (0, $76QQU.default)({}, _this.translate);
                    var scrollX = 0;
                    var scrollY = 0;
                    if (_this.axis.x) {
                        translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
                        scrollX = _this.translate.x - translate.x;
                    }
                    if (_this.axis.y) {
                        translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
                        scrollY = _this.translate.y - translate.y;
                    }
                    _this.translate = translate;
                    $dc0284adcdd860f0$var$setTranslate3d(_this.helper, _this.translate);
                    _this.scrollContainer.scrollLeft += scrollX;
                    _this.scrollContainer.scrollTop += scrollY;
                    return;
                }
                _this.autoScroller.update({
                    height: _this.height,
                    maxTranslate: _this.maxTranslate,
                    minTranslate: _this.minTranslate,
                    translate: _this.translate,
                    width: _this.width
                });
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "onAutoScroll", function(offset) {
                _this.translate.x += offset.left;
                _this.translate.y += offset.top;
                _this.animateNodes();
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "handleKeyDown", function(event) {
                var keyCode = event.keyCode;
                var _this$props5 = _this.props, shouldCancelStart = _this$props5.shouldCancelStart, _this$props5$keyCodes = _this$props5.keyCodes, customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;
                var keyCodes = (0, $76QQU.default)({}, $dc0284adcdd860f0$var$defaultKeyCodes, customKeyCodes);
                if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) return;
                event.stopPropagation();
                event.preventDefault();
                if (keyCodes.lift.includes(keyCode) && !_this.manager.active) _this.keyLift(event);
                else if (keyCodes.drop.includes(keyCode) && _this.manager.active) _this.keyDrop(event);
                else if (keyCodes.cancel.includes(keyCode)) {
                    _this.newIndex = _this.manager.active.index;
                    _this.keyDrop(event);
                } else if (keyCodes.up.includes(keyCode)) _this.keyMove(-1);
                else if (keyCodes.down.includes(keyCode)) _this.keyMove(1);
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "keyLift", function(event) {
                var target = event.target;
                var node = $dc0284adcdd860f0$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                var _node$sortableInfo2 = node.sortableInfo, index = _node$sortableInfo2.index, collection = _node$sortableInfo2.collection;
                _this.initialFocusedNode = target;
                _this.manager.isKeySorting = true;
                _this.manager.active = {
                    index: index,
                    collection: collection
                };
                _this.handlePress(event);
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "keyMove", function(shift) {
                var nodes = _this.manager.getOrderedRefs();
                var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
                var newIndex = _this.newIndex + shift;
                var prevIndex = _this.newIndex;
                if (newIndex < 0 || newIndex > lastIndex) return;
                _this.prevIndex = prevIndex;
                _this.newIndex = newIndex;
                var targetIndex = $dc0284adcdd860f0$var$getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
                var target = nodes.find(function(_ref2) {
                    var node = _ref2.node;
                    return node.sortableInfo.index === targetIndex;
                });
                var targetNode = target.node;
                var scrollDelta = _this.containerScrollDelta;
                var targetBoundingClientRect = target.boundingClientRect || $dc0284adcdd860f0$var$getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
                var targetTranslate = target.translate || {
                    x: 0,
                    y: 0
                };
                var targetPosition = {
                    top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
                    left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
                };
                var shouldAdjustForSize = prevIndex < newIndex;
                var sizeAdjustment = {
                    x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
                    y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
                };
                _this.handleSortMove({
                    pageX: targetPosition.left + sizeAdjustment.x,
                    pageY: targetPosition.top + sizeAdjustment.y,
                    ignoreTransition: shift === 0
                });
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "keyDrop", function(event) {
                _this.handleSortEnd(event);
                if (_this.initialFocusedNode) _this.initialFocusedNode.focus();
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "handleKeyEnd", function(event) {
                if (_this.manager.active) _this.keyDrop(event);
            });
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "isValidSortingTarget", function(event) {
                var useDragHandle = _this.props.useDragHandle;
                var target = event.target;
                var node = $dc0284adcdd860f0$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? $dc0284adcdd860f0$var$isSortableHandle(target) : target.sortableInfo);
            });
            var manager = new $dc0284adcdd860f0$var$Manager();
            $dc0284adcdd860f0$var$validateProps(props);
            _this.manager = manager;
            _this.wrappedInstance = (0, $7PdBe.createRef)();
            _this.sortableContextValue = {
                manager: manager
            };
            _this.events = {
                end: _this.handleEnd,
                move: _this.handleMove,
                start: _this.handleStart
            };
            return _this;
        }
        (0, $9pbVp.default)(WithSortableContainer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    var container = this.getContainer();
                    Promise.resolve(container).then(function(containerNode) {
                        _this2.container = containerNode;
                        _this2.document = _this2.container.ownerDocument || document;
                        var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
                        _this2.contentWindow = typeof contentWindow === "function" ? contentWindow() : contentWindow;
                        _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : $dc0284adcdd860f0$var$getScrollingParent(_this2.container) || _this2.container;
                        _this2.autoScroller = new $dc0284adcdd860f0$var$AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
                        Object.keys(_this2.events).forEach(function(key) {
                            return $dc0284adcdd860f0$var$events[key].forEach(function(eventName) {
                                return _this2.container.addEventListener(eventName, _this2.events[key], false);
                            });
                        });
                        _this2.container.addEventListener("keydown", _this2.handleKeyDown);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this3 = this;
                    if (this.helper && this.helper.parentNode) this.helper.parentNode.removeChild(this.helper);
                    if (!this.container) return;
                    Object.keys(this.events).forEach(function(key) {
                        return $dc0284adcdd860f0$var$events[key].forEach(function(eventName) {
                            return _this3.container.removeEventListener(eventName, _this3.events[key]);
                        });
                    });
                    this.container.removeEventListener("keydown", this.handleKeyDown);
                }
            },
            {
                key: "updateHelperPosition",
                value: function updateHelperPosition(event) {
                    var _this$props6 = this.props, lockAxis = _this$props6.lockAxis, lockOffset = _this$props6.lockOffset, lockToContainerEdges = _this$props6.lockToContainerEdges, transitionDuration = _this$props6.transitionDuration, _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration, keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
                    var isKeySorting = this.manager.isKeySorting;
                    var ignoreTransition = event.ignoreTransition;
                    var offset = $dc0284adcdd860f0$var$getPosition(event);
                    var translate = {
                        x: offset.x - this.initialOffset.x,
                        y: offset.y - this.initialOffset.y
                    };
                    translate.y -= window.pageYOffset - this.initialWindowScroll.top;
                    translate.x -= window.pageXOffset - this.initialWindowScroll.left;
                    this.translate = translate;
                    if (lockToContainerEdges) {
                        var _getLockPixelOffsets = $dc0284adcdd860f0$var$getLockPixelOffsets({
                            height: this.height,
                            lockOffset: lockOffset,
                            width: this.width
                        }), _getLockPixelOffsets2 = (0, $5OuPz.default)(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
                        var minOffset = {
                            x: this.width / 2 - minLockOffset.x,
                            y: this.height / 2 - minLockOffset.y
                        };
                        var maxOffset = {
                            x: this.width / 2 - maxLockOffset.x,
                            y: this.height / 2 - maxLockOffset.y
                        };
                        translate.x = $dc0284adcdd860f0$var$limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
                        translate.y = $dc0284adcdd860f0$var$limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
                    }
                    if (lockAxis === "x") translate.y = 0;
                    else if (lockAxis === "y") translate.x = 0;
                    if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) $dc0284adcdd860f0$var$setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
                    $dc0284adcdd860f0$var$setTranslate3d(this.helper, translate);
                }
            },
            {
                key: "animateNodes",
                value: function animateNodes() {
                    var _this$props7 = this.props, transitionDuration = _this$props7.transitionDuration, hideSortableGhost = _this$props7.hideSortableGhost, onSortOver = _this$props7.onSortOver;
                    var containerScrollDelta = this.containerScrollDelta, windowScrollDelta = this.windowScrollDelta;
                    var nodes = this.manager.getOrderedRefs();
                    var sortingOffset = {
                        left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
                        top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
                    };
                    var isKeySorting = this.manager.isKeySorting;
                    var prevIndex = this.newIndex;
                    this.newIndex = null;
                    for(var i = 0, len = nodes.length; i < len; i++){
                        var _node3 = nodes[i].node;
                        var index = _node3.sortableInfo.index;
                        var width = _node3.offsetWidth;
                        var height = _node3.offsetHeight;
                        var offset = {
                            height: this.height > height ? height / 2 : this.height / 2,
                            width: this.width > width ? width / 2 : this.width / 2
                        };
                        var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
                        var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
                        var translate = {
                            x: 0,
                            y: 0
                        };
                        var edgeOffset = nodes[i].edgeOffset;
                        if (!edgeOffset) {
                            edgeOffset = $dc0284adcdd860f0$var$getEdgeOffset(_node3, this.container);
                            nodes[i].edgeOffset = edgeOffset;
                            if (isKeySorting) nodes[i].boundingClientRect = $dc0284adcdd860f0$var$getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
                        }
                        var nextNode = i < nodes.length - 1 && nodes[i + 1];
                        var prevNode = i > 0 && nodes[i - 1];
                        if (nextNode && !nextNode.edgeOffset) {
                            nextNode.edgeOffset = $dc0284adcdd860f0$var$getEdgeOffset(nextNode.node, this.container);
                            if (isKeySorting) nextNode.boundingClientRect = $dc0284adcdd860f0$var$getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
                        }
                        if (index === this.index) {
                            if (hideSortableGhost) {
                                this.sortableGhost = _node3;
                                $dc0284adcdd860f0$var$setInlineStyles(_node3, {
                                    opacity: 0,
                                    visibility: "hidden"
                                });
                            }
                            continue;
                        }
                        if (transitionDuration) $dc0284adcdd860f0$var$setTransitionDuration(_node3, transitionDuration);
                        if (this.axis.x) {
                            if (this.axis.y) {
                                if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                                        if (nextNode) {
                                            translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    if (this.newIndex === null) this.newIndex = index;
                                } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                                        if (prevNode) {
                                            translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    this.newIndex = index;
                                }
                            } else {
                                if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    this.newIndex = index;
                                } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (this.newIndex == null) this.newIndex = index;
                                }
                            }
                        } else if (this.axis.y) {
                            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
                                translate.y = -(this.height + this.marginOffset.y);
                                this.newIndex = index;
                            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
                                translate.y = this.height + this.marginOffset.y;
                                if (this.newIndex == null) this.newIndex = index;
                            }
                        }
                        $dc0284adcdd860f0$var$setTranslate3d(_node3, translate);
                        nodes[i].translate = translate;
                    }
                    if (this.newIndex == null) this.newIndex = this.index;
                    if (isKeySorting) this.newIndex = prevIndex;
                    var oldIndex = isKeySorting ? this.prevIndex : prevIndex;
                    if (onSortOver && this.newIndex !== oldIndex) onSortOver({
                        collection: this.manager.active.collection,
                        index: this.index,
                        newIndex: this.newIndex,
                        oldIndex: oldIndex,
                        isKeySorting: isKeySorting,
                        nodes: nodes,
                        helper: this.helper
                    });
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($ibnnr)))(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call");
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "getContainer",
                value: function getContainer() {
                    var getContainer = this.props.getContainer;
                    if (typeof getContainer !== "function") return (0, $1cUCD.findDOMNode)(this);
                    return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $7PdBe.createElement)($dc0284adcdd860f0$var$SortableContext.Provider, {
                        value: this.sortableContextValue
                    }, (0, $7PdBe.createElement)(WrappedComponent, (0, $hIbXl.default)({
                        ref: ref
                    }, $dc0284adcdd860f0$var$omit(this.props, $dc0284adcdd860f0$var$omittedProps))));
                }
            },
            {
                key: "helperContainer",
                get: function get() {
                    var helperContainer = this.props.helperContainer;
                    if (typeof helperContainer === "function") return helperContainer();
                    return this.props.helperContainer || this.document.body;
                }
            },
            {
                key: "containerScrollDelta",
                get: function get() {
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    if (useWindowAsScrollContainer) return {
                        left: 0,
                        top: 0
                    };
                    return {
                        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
                        top: this.scrollContainer.scrollTop - this.initialScroll.top
                    };
                }
            },
            {
                key: "windowScrollDelta",
                get: function get() {
                    return {
                        left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
                        top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
                    };
                }
            }
        ]);
        return WithSortableContainer;
    }((0, $7PdBe.Component)), (0, $dHPh8.default)(_class, "displayName", $dc0284adcdd860f0$var$provideDisplayName("sortableList", WrappedComponent)), (0, $dHPh8.default)(_class, "defaultProps", $dc0284adcdd860f0$var$defaultProps), (0, $dHPh8.default)(_class, "propTypes", $dc0284adcdd860f0$var$propTypes), _temp;
}
var $dc0284adcdd860f0$var$propTypes$1 = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number.isRequired,
    collection: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).bool
};
var $dc0284adcdd860f0$var$omittedProps$1 = Object.keys($dc0284adcdd860f0$var$propTypes$1);
function $dc0284adcdd860f0$export$58d1e4fb0d207bf7(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $diRJC.default)(WithSortableElement, _React$Component);
        function WithSortableElement() {
            var _getPrototypeOf2;
            var _this;
            (0, $hGO86.default)(this, WithSortableElement);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $iGxTj.default)(this, (_getPrototypeOf2 = (0, $bvSjj.default)(WithSortableElement)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $dHPh8.default)((0, $goT1f.default)((0, $goT1f.default)(_this)), "wrappedInstance", (0, $7PdBe.createRef)());
            return _this;
        }
        (0, $9pbVp.default)(WithSortableElement, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.register();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.node) {
                        if (prevProps.index !== this.props.index) this.node.sortableInfo.index = this.props.index;
                        if (prevProps.disabled !== this.props.disabled) this.node.sortableInfo.disabled = this.props.disabled;
                    }
                    if (prevProps.collection !== this.props.collection) {
                        this.unregister(prevProps.collection);
                        this.register();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.unregister();
                }
            },
            {
                key: "register",
                value: function register() {
                    var _this$props = this.props, collection = _this$props.collection, disabled = _this$props.disabled, index = _this$props.index;
                    var node = (0, $1cUCD.findDOMNode)(this);
                    node.sortableInfo = {
                        collection: collection,
                        disabled: disabled,
                        index: index,
                        manager: this.context.manager
                    };
                    this.node = node;
                    this.ref = {
                        node: node
                    };
                    this.context.manager.add(collection, this.ref);
                }
            },
            {
                key: "unregister",
                value: function unregister() {
                    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
                    this.context.manager.remove(collection, this.ref);
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($ibnnr)))(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call");
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $7PdBe.createElement)(WrappedComponent, (0, $hIbXl.default)({
                        ref: ref
                    }, $dc0284adcdd860f0$var$omit(this.props, $dc0284adcdd860f0$var$omittedProps$1)));
                }
            }
        ]);
        return WithSortableElement;
    }((0, $7PdBe.Component)), (0, $dHPh8.default)(_class, "displayName", $dc0284adcdd860f0$var$provideDisplayName("sortableElement", WrappedComponent)), (0, $dHPh8.default)(_class, "contextType", $dc0284adcdd860f0$var$SortableContext), (0, $dHPh8.default)(_class, "propTypes", $dc0284adcdd860f0$var$propTypes$1), (0, $dHPh8.default)(_class, "defaultProps", {
        collection: 0
    }), _temp;
}

});
parcelRegister("76QQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52d2174f818f5b55$export$2e2bcd8739ae039; });

var $dHPh8 = parcelRequire("dHPh8");
function $52d2174f818f5b55$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            (0, $dHPh8.default)(e, r, t[r]);
        });
    }
    return e;
}

});

parcelRegister("ibnnr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $d3cb6349ceb241e1$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $d3cb6349ceb241e1$var$invariant;

});




parcelRegister("6M6SV", function(module, exports) {

$parcel$export(module.exports, "Selector", function () { return $4eec90f52ab05947$export$d15f4cd5286f9b1e; });
$parcel$export(module.exports, "BooleanSelector", function () { return $4eec90f52ab05947$export$9e6a0c752efd96fc; });
$parcel$export(module.exports, "ContactSelector", function () { return $4eec90f52ab05947$export$9ec8b34c1e7a643e; });
$parcel$export(module.exports, "CostCentreSelector", function () { return $4eec90f52ab05947$export$2d2573c5466d1f18; });
$parcel$export(module.exports, "StaffSelector", function () { return $4eec90f52ab05947$export$74aac9a301f18d2e; });
$parcel$export(module.exports, "RoleSelector", function () { return $4eec90f52ab05947$export$7b32174eb7b60a13; });
$parcel$export(module.exports, "ProjectSelector", function () { return $4eec90f52ab05947$export$a764642e4b725728; });
$parcel$export(module.exports, "PhaseSelector", function () { return $4eec90f52ab05947$export$c6fe3fcc5c7d197b; });
$parcel$export(module.exports, "TaskSelector", function () { return $4eec90f52ab05947$export$b1a90c704904b8d3; });
$parcel$export(module.exports, "StaffOrRoleSelector", function () { return $4eec90f52ab05947$export$96db3e3d08047f0e; });
$parcel$export(module.exports, "StatusSelector", function () { return $4eec90f52ab05947$export$73bf5bb44ab352ee; });

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");

var $4sGvn = parcelRequire("4sGvn");

var $hy8Zj = parcelRequire("hy8Zj");

var $lTrDt = parcelRequire("lTrDt");

var $dBifK = parcelRequire("dBifK");

var $9Lw71 = parcelRequire("9Lw71");

var $8YeUb = parcelRequire("8YeUb");

var $ig2C7 = parcelRequire("ig2C7");

var $kdO1A = parcelRequire("kdO1A");

var $lsKv3 = parcelRequire("lsKv3");

var $augzx = parcelRequire("augzx");

var $2Tkhn = parcelRequire("2Tkhn");
const $4eec90f52ab05947$export$d15f4cd5286f9b1e = ({ selectedOption: selectedOption, options: options, onChange: onChange, disableOption: disableOption, searchMatcher: searchMatcher, optionLabel: optionLabel, groupBy: groupBy, sort: sort, ...props })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        ...props,
        value: selectedOption,
        options: sort ? (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sortBy(options, sort) : options,
        onChange: onChange,
        disableOption: disableOption,
        searchMatcher: searchMatcher,
        optionLabel: optionLabel,
        groupBy: groupBy
    });
};
const $4eec90f52ab05947$export$9e6a0c752efd96fc = ({ selectedOption: selectedOption, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = [
        true,
        false
    ];
    if (nullable) options = [
        null,
        ...options
    ];
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedOption,
        onChange: onChange,
        options: options,
        sort: (c)=>c,
        optionLabel: (c)=>c === null ? "Doesn't matter" : c ? "Yes" : "No",
        searchMatcher: (c, text)=>{
            var _match, _ref;
            return (_match = (_ref = c === null ? "doesn't matter" : c ? "yes" : "no").match) === null || _match === void 0 ? void 0 : _match.call(_ref, text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$9ec8b34c1e7a643e = ({ selectedContact: selectedContact, contactOptions: contactOptions, disabledContacts: disabledContacts, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = contactOptions || (0, $4sGvn.default).contacts;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (contact)=>disabledContacts ? disabledContacts.includes(contact) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedContact,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (c)=>(c === null || c === void 0 ? void 0 : c.label) || -Infinity,
        optionLabel: (c)=>(c === null || c === void 0 ? void 0 : c.label) || placeholderLabel || "Select Contact...",
        searchMatcher: (c, text)=>{
            var _c$label, _c$label$toLowerCase, _c$label$toLowerCase$, _c$label$toLowerCase$2;
            return c === null || c === void 0 ? void 0 : (_c$label = c.label) === null || _c$label === void 0 ? void 0 : (_c$label$toLowerCase = _c$label.toLowerCase) === null || _c$label$toLowerCase === void 0 ? void 0 : (_c$label$toLowerCase$ = _c$label$toLowerCase.call(_c$label)) === null || _c$label$toLowerCase$ === void 0 ? void 0 : (_c$label$toLowerCase$2 = _c$label$toLowerCase$.match) === null || _c$label$toLowerCase$2 === void 0 ? void 0 : _c$label$toLowerCase$2.call(_c$label$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$2d2573c5466d1f18 = ({ selectedCostCentre: selectedCostCentre, costCentreOptions: costCentreOptions, disabledCostCentres: disabledCostCentres, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = costCentreOptions || (0, $hy8Zj.default).costCentres;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (costCentre)=>disabledCostCentres ? disabledCostCentres.includes(costCentre) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedCostCentre,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (cc)=>(cc === null || cc === void 0 ? void 0 : cc.name) || -Infinity,
        optionLabel: (cc)=>(cc === null || cc === void 0 ? void 0 : cc.name) || placeholderLabel || "Select Cost Centre...",
        searchMatcher: (cc, text)=>{
            var _cc$name, _cc$name$toLowerCase, _cc$name$toLowerCase$, _cc$name$toLowerCase$2;
            return cc === null || cc === void 0 ? void 0 : (_cc$name = cc.name) === null || _cc$name === void 0 ? void 0 : (_cc$name$toLowerCase = _cc$name.toLowerCase) === null || _cc$name$toLowerCase === void 0 ? void 0 : (_cc$name$toLowerCase$ = _cc$name$toLowerCase.call(_cc$name)) === null || _cc$name$toLowerCase$ === void 0 ? void 0 : (_cc$name$toLowerCase$2 = _cc$name$toLowerCase$.match) === null || _cc$name$toLowerCase$2 === void 0 ? void 0 : _cc$name$toLowerCase$2.call(_cc$name$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$74aac9a301f18d2e = ({ selectedStaffMember: selectedStaffMember, staffOptions: staffOptions, disabledStaff: disabledStaff, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = staffOptions || (0, $lTrDt.default).staffs;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (staff)=>disabledStaff ? disabledStaff.includes(staff) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedStaffMember,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.fullName) || -Infinity,
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.fullName) || placeholderLabel || "Select Staff...",
        searchMatcher: (sm, text)=>{
            var _sm$fullName, _sm$fullName$toLowerC, _sm$fullName$toLowerC2, _sm$fullName$toLowerC3;
            return sm === null || sm === void 0 ? void 0 : (_sm$fullName = sm.fullName) === null || _sm$fullName === void 0 ? void 0 : (_sm$fullName$toLowerC = _sm$fullName.toLowerCase) === null || _sm$fullName$toLowerC === void 0 ? void 0 : (_sm$fullName$toLowerC2 = _sm$fullName$toLowerC.call(_sm$fullName)) === null || _sm$fullName$toLowerC2 === void 0 ? void 0 : (_sm$fullName$toLowerC3 = _sm$fullName$toLowerC2.match) === null || _sm$fullName$toLowerC3 === void 0 ? void 0 : _sm$fullName$toLowerC3.call(_sm$fullName$toLowerC2, text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$7b32174eb7b60a13 = ({ selectedRole: selectedRole, roleOptions: roleOptions, disabledRoles: disabledRoles, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = roleOptions || (0, $8YeUb.default).roles;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (role)=>disabledRoles ? disabledRoles.includes(role) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedRole,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.name) || -Infinity,
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.name) || placeholderLabel || "Select Role...",
        searchMatcher: (sm, text)=>{
            var _sm$name, _sm$name$toLowerCase, _sm$name$toLowerCase$, _sm$name$toLowerCase$2;
            return sm === null || sm === void 0 ? void 0 : (_sm$name = sm.name) === null || _sm$name === void 0 ? void 0 : (_sm$name$toLowerCase = _sm$name.toLowerCase) === null || _sm$name$toLowerCase === void 0 ? void 0 : (_sm$name$toLowerCase$ = _sm$name$toLowerCase.call(_sm$name)) === null || _sm$name$toLowerCase$ === void 0 ? void 0 : (_sm$name$toLowerCase$2 = _sm$name$toLowerCase$.match) === null || _sm$name$toLowerCase$2 === void 0 ? void 0 : _sm$name$toLowerCase$2.call(_sm$name$toLowerCase$, text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$a764642e4b725728 = ({ selectedProject: selectedProject, projectOptions: projectOptions, disabledProjects: disabledProjects, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = projectOptions || (0, $kdO1A.default).projects;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (project)=>disabledProjects ? disabledProjects.includes(project) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedProject,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (ph)=>(ph === null || ph === void 0 ? void 0 : ph.title) || -Infinity,
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.title) || placeholderLabel || "Select Project...",
        searchMatcher: (sm, text)=>{
            var _sm$title, _sm$title$toLowerCase, _sm$title$toLowerCase2, _sm$title$toLowerCase3;
            return sm === null || sm === void 0 ? void 0 : (_sm$title = sm.title) === null || _sm$title === void 0 ? void 0 : (_sm$title$toLowerCase = _sm$title.toLowerCase) === null || _sm$title$toLowerCase === void 0 ? void 0 : (_sm$title$toLowerCase2 = _sm$title$toLowerCase.call(_sm$title)) === null || _sm$title$toLowerCase2 === void 0 ? void 0 : (_sm$title$toLowerCase3 = _sm$title$toLowerCase2.match) === null || _sm$title$toLowerCase3 === void 0 ? void 0 : _sm$title$toLowerCase3.call(_sm$title$toLowerCase2, text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$c6fe3fcc5c7d197b = ({ selectedPhase: selectedPhase, phaseOptions: phaseOptions, disabledPhases: disabledPhases, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = phaseOptions || (0, $9Lw71.default).phases;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (phase)=>disabledPhases ? disabledPhases.includes(phase) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedPhase,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (ph)=>(ph === null || ph === void 0 ? void 0 : ph.title) || -Infinity,
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.title) || placeholderLabel || "Select Phase...",
        searchMatcher: (sm, text)=>sm.title.toLowerCase().match(text.toLowerCase()),
        ...props
    });
};
const $4eec90f52ab05947$export$b1a90c704904b8d3 = ({ selectedTask: selectedTask, taskOptions: taskOptions, disabledTasks: disabledTasks, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = taskOptions || (0, $augzx.default).tasks;
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (task)=>disabledTasks ? disabledTasks.includes(task) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedTask,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (ph)=>(ph === null || ph === void 0 ? void 0 : ph.name) || -Infinity,
        optionLabel: (sm)=>(sm === null || sm === void 0 ? void 0 : sm.name) || placeholderLabel || "Select Task...",
        searchMatcher: (sm, text)=>{
            var _sm$name2;
            return sm === null || sm === void 0 ? void 0 : (_sm$name2 = sm.name) === null || _sm$name2 === void 0 ? void 0 : _sm$name2.toLowerCase().match(text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$96db3e3d08047f0e = ({ selectedStaffOrRole: selectedStaffOrRole, staffOrRoleOptions: staffOrRoleOptions, disabledStaffOrRoles: disabledStaffOrRoles, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = staffOrRoleOptions || [
        ...(0, $8YeUb.default).roles,
        ...(0, $lTrDt.default).staffs
    ];
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (sor)=>disabledStaffOrRoles ? disabledStaffOrRoles.includes(sor) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedStaffOrRole,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (sor)=>(sor === null || sor === void 0 ? void 0 : sor.fullName) || (sor === null || sor === void 0 ? void 0 : sor.name) || -Infinity,
        optionLabel: (sor)=>(sor === null || sor === void 0 ? void 0 : sor.fullName) || (sor === null || sor === void 0 ? void 0 : sor.name) || placeholderLabel || "Select Staff or Role...",
        searchMatcher: (sor, text)=>{
            var _ref2, _ref2$toLowerCase, _ref2$toLowerCase$cal, _ref2$toLowerCase$cal2;
            return (_ref2 = (sor === null || sor === void 0 ? void 0 : sor.fullName) || (sor === null || sor === void 0 ? void 0 : sor.name)) === null || _ref2 === void 0 ? void 0 : (_ref2$toLowerCase = _ref2.toLowerCase) === null || _ref2$toLowerCase === void 0 ? void 0 : (_ref2$toLowerCase$cal = _ref2$toLowerCase.call(_ref2)) === null || _ref2$toLowerCase$cal === void 0 ? void 0 : (_ref2$toLowerCase$cal2 = _ref2$toLowerCase$cal.match) === null || _ref2$toLowerCase$cal2 === void 0 ? void 0 : _ref2$toLowerCase$cal2.call(_ref2$toLowerCase$cal, text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$798b7b5bfe472f0c = ({ selectedCostCentreOrProject: selectedCostCentreOrProject, costCentreOrProjectOptions: costCentreOrProjectOptions, disabledCostCentresOrProjects: disabledCostCentresOrProjects, onChange: onChange, placeholderLabel: placeholderLabel, nullable: nullable, ...props })=>{
    let options = costCentreOrProjectOptions || [
        ...(0, $hy8Zj.default).costCentres,
        ...(0, $kdO1A.default).projects
    ];
    if (nullable) options = [
        null,
        ...options
    ];
    const isOptionDisabled = (ccop)=>disabledCostCentresOrProjects ? disabledCostCentresOrProjects.includes(ccop) : false;
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedCostCentreOrProject,
        onChange: onChange,
        options: options,
        isOptionDisabled: isOptionDisabled,
        sort: (ccop)=>(ccop === null || ccop === void 0 ? void 0 : ccop.name) || (ccop === null || ccop === void 0 ? void 0 : ccop.title) || -Infinity,
        optionLabel: (ccop)=>(ccop === null || ccop === void 0 ? void 0 : ccop.name) || (ccop === null || ccop === void 0 ? void 0 : ccop.title) || placeholderLabel || "Select Cost Centre or Project...",
        searchMatcher: (ccop, text)=>{
            var _ref3, _ref3$toLowerCase, _ref3$toLowerCase$cal, _ref3$toLowerCase$cal2;
            return (_ref3 = ccop.name || ccop.title) === null || _ref3 === void 0 ? void 0 : (_ref3$toLowerCase = _ref3.toLowerCase) === null || _ref3$toLowerCase === void 0 ? void 0 : (_ref3$toLowerCase$cal = _ref3$toLowerCase.call(_ref3)) === null || _ref3$toLowerCase$cal === void 0 ? void 0 : (_ref3$toLowerCase$cal2 = _ref3$toLowerCase$cal.match) === null || _ref3$toLowerCase$cal2 === void 0 ? void 0 : _ref3$toLowerCase$cal2.call(_ref3$toLowerCase$cal, text.toLowerCase());
        },
        ...props
    });
};
const $4eec90f52ab05947$export$73bf5bb44ab352ee = ({ selectedStatus: selectedStatus, onChange: onChange, placeholderLabel: placeholderLabel, ...props })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
        selectedOption: selectedStatus,
        onChange: onChange,
        options: [
            "active",
            "onHold",
            "prospective",
            "archived"
        ],
        // sort={(c) => c.label}
        optionLabel: (s)=>(0, $ig2C7.capitalCase)(s),
        ...props
    });
};
const $4eec90f52ab05947$export$7d0eb98e148310d4 = ({ selectedDateRange: selectedDateRange, onChange: onChange, ...props })=>{
    const optionsKeys = Object.keys((0, $lsKv3.dateStringLabels));
    const selectedOption = optionsKeys.includes(selectedDateRange) ? selectedDateRange : "custom";
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)($4eec90f52ab05947$export$d15f4cd5286f9b1e, {
                selectedOption: selectedOption,
                onChange: (opt)=>onChange(opt === "custom" ? [
                        new Date(),
                        new Date()
                    ] : opt),
                options: optionsKeys,
                // sort={(c) => c.label}
                optionLabel: (s)=>(0, $lsKv3.dateStringLabels)[s],
                ...props
            }),
            selectedOption === "custom" ? /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $RSSjA.Fragment), {
                children: [
                    (0, $2Tkhn.default).date({
                        style: {
                            width: "10em"
                        },
                        value: selectedDateRange[0],
                        editable: true,
                        onChange: (val)=>onChange([
                                val,
                                selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange[1]
                            ])
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                        style: {
                            margin: "0 0.5em"
                        },
                        children: "to"
                    }),
                    (0, $2Tkhn.default).date({
                        style: {
                            width: "10em"
                        },
                        value: selectedDateRange[1],
                        editable: true,
                        onChange: (val)=>onChange([
                                selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange[0],
                                val
                            ])
                    })
                ]
            }) : null
        ]
    });
};

});

parcelRegister("jT3Jc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7a60bab8ed9738b$export$2e2bcd8739ae039; });

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");
parcelRequire("dBifK");

var $cjCbh = parcelRequire("cjCbh");
var $e7a60bab8ed9738b$export$2e2bcd8739ae039 = ({ id: id, label: label, disabled: disabled = false, labelPosition: labelPosition = "right", valueLink: valueLink, value: value, indeterminate: indeterminate = false, onChange: onChange, onClick: onClick, className: className = "", style: style, ...props })=>{
    id = id != null ? id : "coincraft-checkbox-" + (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))();
    value = valueLink != null ? valueLink.value : value;
    indeterminate = value === "indeterminate";
    value = value === "indeterminate" ? false : value;
    let checkbox = /*#__PURE__*/ (0, $RSSjA.jsx)("input", {
        className: "coincraft-checkbox__input",
        id: id,
        type: "checkbox",
        checked: value,
        disabled: disabled,
        onChange: (event)=>{
            if (!disabled) {
                if (valueLink != null) valueLink.requestChange(event.target.checked);
                else onChange(event.target.checked, event);
            }
        },
        onClick: onClick,
        style: {
            cursor: "pointer"
        },
        tabIndex: "0",
        ref: (input)=>{
            if (input) input.indeterminate = indeterminate;
        }
    });
    label = label != null ? /*#__PURE__*/ (0, $RSSjA.jsx)("label", {
        htmlFor: id,
        style: labelPosition === "right" ? {
            marginLeft: "1em"
        } : {
            marginRight: "1em"
        },
        children: label
    }) : null;
    return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        className: `coincraft-checkbox ${className}`,
        style: {
            display: "inline-block",
            ...style
        },
        children: labelPosition === "right" ? /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
            className: "inline-flex flex-align-items-center",
            children: [
                checkbox,
                label
            ]
        }) : /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
            className: "inline-flex flex-align-items-center",
            children: [
                label,
                checkbox
            ]
        })
    });
};

});

parcelRegister("899M7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ee6bf25cc6be153$export$2e2bcd8739ae039; });

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");
parcelRequire("dBifK");

var $4bOnx = parcelRequire("4bOnx");

var $dPQOH = parcelRequire("dPQOH");

parcelRequire("5uSSv");

var $46jCe = parcelRequire("46jCe");

var $hDgMg = parcelRequire("hDgMg");

var $3ipPr = parcelRequire("3ipPr");

var $lnG1F = parcelRequire("lnG1F");
(0, (/*@__PURE__*/$parcel$interopDefault($lnG1F)))((0, (/*@__PURE__*/$parcel$interopDefault($3ipPr))));
var $5ee6bf25cc6be153$export$2e2bcd8739ae039 = ({ isEditable: isEditable = true, value: value, onChange: onChange, dropLeft: dropLeft = false, min: min, max: max, actionArgs: actionArgs, isValid: isValid = true, ...props })=>{
    if (isEditable) {
        if (dropLeft) props = (0, $4bOnx.mergeProps)({
            className: "rw-dropleft"
        }, props);
        return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $dPQOH.DateTimePicker), {
            className: !isValid ? "invalid-date-picker" : "",
            time: false,
            format: (d)=>(0, $46jCe.FormatDate)(d, {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }),
            value: value,
            onChange: (newDate)=>{
                var val = newDate != null ? newDate : null;
                onChange(val);
            },
            parse: (0, $hDgMg.ParseDate),
            // react-widgets DateTimePicker doesn't work properly if you pass `null`
            // here (esp. `max`).
            min: min || new Date(1970, 0, 1),
            max: max || new Date(2069, 11, 30),
            ...props
        });
    } else // Yes, moment.js format strings are different to the format strings
    // accepted by `DateTimePicker`.
    return /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
        children: value != null ? (0, $46jCe.FormatDate)(value, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }) : "(None)"
    });
};

});
parcelRegister("dPQOH", function(module, exports) {
"use strict";
var $a1290212669332d4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8cebN = parcelRequire("8cebN");









module.exports = $a1290212669332d4$var$_extends({}, $8cebN, {
    DropdownList: (parcelRequire("gFbIU")),
    Combobox: (parcelRequire("gvCH7")),
    Calendar: (parcelRequire("3TyqS")),
    DateTimePicker: (parcelRequire("llMlN")),
    NumberPicker: (parcelRequire("7r6hs")),
    Multiselect: (parcelRequire("lEfWo")),
    SelectList: (parcelRequire("1rnPs")),
    utils: {
        ReplaceTransitionGroup: (parcelRequire("5MgSZ")),
        SlideTransition: (parcelRequire("7eZIS"))
    }
});

});
parcelRegister("8cebN", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $kLuvQ = parcelRequire("kLuvQ");
var $5f7a736417e27474$var$_configuration2 = $5f7a736417e27474$var$_interopRequireDefault($kLuvQ);

var $d6vOx = parcelRequire("d6vOx");
var $5f7a736417e27474$var$localizers = $5f7a736417e27474$var$_interopRequireWildcard($d6vOx);
function $5f7a736417e27474$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $5f7a736417e27474$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    setAnimate: function setAnimate(animatefn) {
        $5f7a736417e27474$var$_configuration2.default.animate = animatefn;
    },
    setLocalizers: function setLocalizers(_ref) {
        var date = _ref.date, number = _ref.number;
        date && this.setDateLocalizer(date);
        number && this.setNumberLocalizer(number);
    },
    setDateLocalizer: $5f7a736417e27474$var$localizers.setDate,
    setNumberLocalizer: $5f7a736417e27474$var$localizers.setNumber
};
module.exports = module.exports["default"];

});
parcelRegister("kLuvQ", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $fn4Eq = parcelRequire("fn4Eq");
var $f1dfdd9b38273323$var$_animate2 = $f1dfdd9b38273323$var$_interopRequireDefault($fn4Eq);
function $f1dfdd9b38273323$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    animate: $f1dfdd9b38273323$var$_animate2.default
};
module.exports = module.exports["default"];

});
parcelRegister("fn4Eq", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $b30c9c955e474642$var$animate;

var $1ZfdB = parcelRequire("1ZfdB");
var $b30c9c955e474642$var$_hyphenate2 = $b30c9c955e474642$var$_interopRequireDefault($1ZfdB);

var $gKGWM = parcelRequire("gKGWM");
var $b30c9c955e474642$var$_style2 = $b30c9c955e474642$var$_interopRequireDefault($gKGWM);

var $cAxOK = parcelRequire("cAxOK");
var $b30c9c955e474642$var$_on2 = $b30c9c955e474642$var$_interopRequireDefault($cAxOK);

var $MdAos = parcelRequire("MdAos");
var $b30c9c955e474642$var$_off2 = $b30c9c955e474642$var$_interopRequireDefault($MdAos);

var $f3D8L = parcelRequire("f3D8L");
var $b30c9c955e474642$var$_properties2 = $b30c9c955e474642$var$_interopRequireDefault($f3D8L);
function $b30c9c955e474642$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b30c9c955e474642$var$has = Object.prototype.hasOwnProperty, $b30c9c955e474642$var$reset = {}, $b30c9c955e474642$var$TRANSLATION_MAP = {
    left: "translateX",
    right: "translateX",
    top: "translateY",
    bottom: "translateY"
};
$b30c9c955e474642$var$reset[$b30c9c955e474642$var$_properties2.default.property] = $b30c9c955e474642$var$reset[$b30c9c955e474642$var$_properties2.default.duration] = $b30c9c955e474642$var$reset[$b30c9c955e474642$var$_properties2.default.delay] = $b30c9c955e474642$var$reset[$b30c9c955e474642$var$_properties2.default.timing] = "";
$b30c9c955e474642$var$animate.endEvent = $b30c9c955e474642$var$_properties2.default.end;
$b30c9c955e474642$var$animate.transform = $b30c9c955e474642$var$_properties2.default.transform;
$b30c9c955e474642$var$animate.TRANSLATION_MAP = $b30c9c955e474642$var$TRANSLATION_MAP;
// super lean animate function for transitions
// doesn't support all translations to keep it matching the jquery API
/**
 * code in part from: Zepto 1.1.4 | zeptojs.com/license
 */ function $b30c9c955e474642$var$animate(node, properties, duration, easing, callback) {
    var cssProperties = [], fakeEvent = {
        target: node,
        currentTarget: node
    }, cssValues = {}, transforms = "", fired;
    if (typeof easing === "function") callback = easing, easing = null;
    if (!$b30c9c955e474642$var$_properties2.default.end) duration = 0;
    if (duration === undefined) duration = 200;
    for(var key in properties)if ($b30c9c955e474642$var$has.call(properties, key)) {
        if (/(top|bottom)/.test(key)) transforms += $b30c9c955e474642$var$TRANSLATION_MAP[key] + "(" + properties[key] + ") ";
        else {
            cssValues[key] = properties[key];
            cssProperties.push((0, $b30c9c955e474642$var$_hyphenate2.default)(key));
        }
    }
    if (transforms) {
        cssValues[$b30c9c955e474642$var$_properties2.default.transform] = transforms;
        cssProperties.push($b30c9c955e474642$var$_properties2.default.transform);
    }
    if (duration > 0) {
        cssValues[$b30c9c955e474642$var$_properties2.default.property] = cssProperties.join(", ");
        cssValues[$b30c9c955e474642$var$_properties2.default.duration] = duration / 1000 + "s";
        cssValues[$b30c9c955e474642$var$_properties2.default.delay] = "0s";
        cssValues[$b30c9c955e474642$var$_properties2.default.timing] = easing || "linear";
        (0, $b30c9c955e474642$var$_on2.default)(node, $b30c9c955e474642$var$_properties2.default.end, done);
        setTimeout(function() {
            if (!fired) done(fakeEvent);
        }, duration + 500);
    }
    node.clientLeft; // trigger page reflow
    (0, $b30c9c955e474642$var$_style2.default)(node, cssValues);
    if (duration <= 0) setTimeout(done.bind(null, fakeEvent), 0);
    return {
        cancel: function cancel() {
            if (fired) return;
            fired = true;
            (0, $b30c9c955e474642$var$_off2.default)(node, $b30c9c955e474642$var$_properties2.default.end, done);
            (0, $b30c9c955e474642$var$_style2.default)(node, $b30c9c955e474642$var$reset);
        }
    };
    function done(event) {
        if (event.target !== event.currentTarget) return;
        fired = true;
        (0, $b30c9c955e474642$var$_off2.default)(event.target, $b30c9c955e474642$var$_properties2.default.end, done);
        (0, $b30c9c955e474642$var$_style2.default)(node, $b30c9c955e474642$var$reset);
        callback && callback.call(this);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("1ZfdB", function(module, exports) {
"use strict";
var $17274afbcc11c430$var$rUpper = /([A-Z])/g;
module.exports = function hyphenate(string) {
    return string.replace($17274afbcc11c430$var$rUpper, "-$1").toLowerCase();
};

});

parcelRegister("gKGWM", function(module, exports) {
"use strict";

var $dB9ZP = parcelRequire("dB9ZP");

var $gVP5c = parcelRequire("gVP5c");

var $bIv6j = parcelRequire("bIv6j");

var $kxdZn = parcelRequire("kxdZn");
var $c322419f8e37e60c$var$has = Object.prototype.hasOwnProperty;
module.exports = function style(node, property, value) {
    var css = "", props = property;
    if (typeof property === "string") {
        if (value === undefined) return node.style[$dB9ZP(property)] || $bIv6j(node).getPropertyValue($gVP5c(property));
        else (props = {})[property] = value;
    }
    for(var key in props)if ($c322419f8e37e60c$var$has.call(props, key)) !props[key] && props[key] !== 0 ? $kxdZn(node, $gVP5c(key)) : css += $gVP5c(key) + ":" + props[key] + ";";
    node.style.cssText += ";" + css;
};

});
parcelRegister("dB9ZP", function(module, exports) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */ "use strict";

var $h9pIE = parcelRequire("h9pIE");
var $9e667c17331c89e3$var$msPattern = /^-ms-/;
module.exports = function camelizeStyleName(string) {
    return $h9pIE(string.replace($9e667c17331c89e3$var$msPattern, "ms-"));
};

});
parcelRegister("h9pIE", function(module, exports) {
"use strict";
var $c7c73a3b69e31e15$var$rHyphen = /-(.)/g;
module.exports = function camelize(string) {
    return string.replace($c7c73a3b69e31e15$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
};

});


parcelRegister("gVP5c", function(module, exports) {
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ "use strict";

var $1ZfdB = parcelRequire("1ZfdB");
var $c5399830f942d601$var$msPattern = /^ms-/;
module.exports = function hyphenateStyleName(string) {
    return $1ZfdB(string).replace($c5399830f942d601$var$msPattern, "-ms-");
};

});

parcelRegister("bIv6j", function(module, exports) {
"use strict";

var $61fgT = parcelRequire("61fgT");

var $dB9ZP = parcelRequire("dB9ZP");
var $887bedbac2dbddf9$var$_utilCamelizeStyle2 = $61fgT.interopRequireDefault($dB9ZP);
var $887bedbac2dbddf9$var$rposition = /^(top|right|bottom|left)$/;
var $887bedbac2dbddf9$var$rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
module.exports = function _getComputedStyle(node) {
    if (!node) throw new TypeError("No Element passed to `getComputedStyle()`");
    var doc = node.ownerDocument;
    return "defaultView" in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
        getPropertyValue: function getPropertyValue(prop) {
            var style = node.style;
            prop = (0, $887bedbac2dbddf9$var$_utilCamelizeStyle2["default"])(prop);
            if (prop == "float") prop = "styleFloat";
            var current = node.currentStyle[prop] || null;
            if (current == null && style && style[prop]) current = style[prop];
            if ($887bedbac2dbddf9$var$rnumnonpx.test(current) && !$887bedbac2dbddf9$var$rposition.test(prop)) {
                // Remember the original values
                var left = style.left;
                var runStyle = node.runtimeStyle;
                var rsLeft = runStyle && runStyle.left;
                // Put in the new values to get a computed value out
                if (rsLeft) runStyle.left = node.currentStyle.left;
                style.left = prop === "fontSize" ? "1em" : current;
                current = style.pixelLeft + "px";
                // Revert the changed values
                style.left = left;
                if (rsLeft) runStyle.left = rsLeft;
            }
            return current;
        }
    };
};

});
parcelRegister("61fgT", function(module, exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else factory(module.exports);
})(module.exports, function(global) {
    var babelHelpers = global;
    babelHelpers.interopRequireDefault = function(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    };
    babelHelpers._extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
});

});


parcelRegister("kxdZn", function(module, exports) {
"use strict";
module.exports = function removeStyle(node, key) {
    return "removeProperty" in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
};

});


parcelRegister("cAxOK", function(module, exports) {
"use strict";

var $cAyTR = parcelRequire("cAyTR");
var $92a3144db1e65a5d$var$on = function on() {};
if ($cAyTR) $92a3144db1e65a5d$var$on = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.addEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.attachEvent("on" + eventName, handler);
    };
}();
module.exports = $92a3144db1e65a5d$var$on;

});
parcelRegister("cAyTR", function(module, exports) {
"use strict";
module.exports = !!(typeof window !== "undefined" && window.document && window.document.createElement);

});


parcelRegister("MdAos", function(module, exports) {
"use strict";

var $cAyTR = parcelRequire("cAyTR");
var $090f05b466f5c623$var$off = function off() {};
if ($cAyTR) $090f05b466f5c623$var$off = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.removeEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.detachEvent("on" + eventName, handler);
    };
}();
module.exports = $090f05b466f5c623$var$off;

});

parcelRegister("f3D8L", function(module, exports) {
"use strict";

var $cAyTR = parcelRequire("cAyTR");
var $af657f4c2ab956cb$var$has = Object.prototype.hasOwnProperty, $af657f4c2ab956cb$var$transform = "transform", $af657f4c2ab956cb$var$transition = {}, $af657f4c2ab956cb$var$transitionTiming, $af657f4c2ab956cb$var$transitionDuration, $af657f4c2ab956cb$var$transitionProperty, $af657f4c2ab956cb$var$transitionDelay;
if ($cAyTR) {
    $af657f4c2ab956cb$var$transition = $af657f4c2ab956cb$var$getTransitionProperties();
    $af657f4c2ab956cb$var$transform = $af657f4c2ab956cb$var$transition.prefix + $af657f4c2ab956cb$var$transform;
    $af657f4c2ab956cb$var$transitionProperty = $af657f4c2ab956cb$var$transition.prefix + "transition-property";
    $af657f4c2ab956cb$var$transitionDuration = $af657f4c2ab956cb$var$transition.prefix + "transition-duration";
    $af657f4c2ab956cb$var$transitionDelay = $af657f4c2ab956cb$var$transition.prefix + "transition-delay";
    $af657f4c2ab956cb$var$transitionTiming = $af657f4c2ab956cb$var$transition.prefix + "transition-timing-function";
}
module.exports = {
    transform: $af657f4c2ab956cb$var$transform,
    end: $af657f4c2ab956cb$var$transition.end,
    property: $af657f4c2ab956cb$var$transitionProperty,
    timing: $af657f4c2ab956cb$var$transitionTiming,
    delay: $af657f4c2ab956cb$var$transitionDelay,
    duration: $af657f4c2ab956cb$var$transitionDuration
};
function $af657f4c2ab956cb$var$getTransitionProperties() {
    var endEvent, prefix = "", transitions = {
        O: "otransitionend",
        Moz: "transitionend",
        Webkit: "webkitTransitionEnd",
        ms: "MSTransitionEnd"
    };
    var element = document.createElement("div");
    for(var vendor in transitions)if ($af657f4c2ab956cb$var$has.call(transitions, vendor)) {
        if (element.style[vendor + "TransitionProperty"] !== undefined) {
            prefix = "-" + vendor.toLowerCase() + "-";
            endEvent = transitions[vendor];
            break;
        }
    }
    if (!endEvent && element.style.transitionProperty !== undefined) endEvent = "transitionend";
    return {
        end: endEvent,
        prefix: prefix
    };
}

});



parcelRegister("d6vOx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $98a4838a735a0bdb$export$1e511d4a378977f5; }, function (v) { return $98a4838a735a0bdb$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "date", function () { return $98a4838a735a0bdb$export$324d90190a8b822a; }, function (v) { return $98a4838a735a0bdb$export$324d90190a8b822a = v; });
$parcel$export(module.exports, "number", function () { return $98a4838a735a0bdb$export$98e628dec113755e; }, function (v) { return $98a4838a735a0bdb$export$98e628dec113755e = v; });
$parcel$export(module.exports, "setNumber", function () { return $98a4838a735a0bdb$export$96a94ca0e6838874; }, function (v) { return $98a4838a735a0bdb$export$96a94ca0e6838874 = v; });
$parcel$export(module.exports, "setDate", function () { return $98a4838a735a0bdb$export$566174fa40823587; }, function (v) { return $98a4838a735a0bdb$export$566174fa40823587 = v; });
$parcel$export(module.exports, "default", function () { return $98a4838a735a0bdb$export$2e2bcd8739ae039; }, function (v) { return $98a4838a735a0bdb$export$2e2bcd8739ae039 = v; });
var $98a4838a735a0bdb$export$1e511d4a378977f5;
var $98a4838a735a0bdb$export$324d90190a8b822a;
var $98a4838a735a0bdb$export$98e628dec113755e;
var $98a4838a735a0bdb$export$96a94ca0e6838874;
var $98a4838a735a0bdb$export$566174fa40823587;
var $98a4838a735a0bdb$export$2e2bcd8739ae039;
"use strict";
$98a4838a735a0bdb$export$1e511d4a378977f5 = true;
$98a4838a735a0bdb$export$324d90190a8b822a = $98a4838a735a0bdb$export$98e628dec113755e = $98a4838a735a0bdb$export$96a94ca0e6838874 = undefined;
$98a4838a735a0bdb$export$566174fa40823587 = $98a4838a735a0bdb$var$setDate;

var $ibnnr = parcelRequire("ibnnr");
var $98a4838a735a0bdb$var$_invariant2 = $98a4838a735a0bdb$var$_interopRequireDefault($ibnnr);
parcelRequire("4cOpg");

var $S29Lp = parcelRequire("S29Lp");
var $98a4838a735a0bdb$var$_propTypes2 = $98a4838a735a0bdb$var$_interopRequireDefault($S29Lp);
function $98a4838a735a0bdb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $98a4838a735a0bdb$var$localePropType = $98a4838a735a0bdb$var$_propTypes2.default.oneOfType([
    $98a4838a735a0bdb$var$_propTypes2.default.string,
    $98a4838a735a0bdb$var$_propTypes2.default.func
]);
var $98a4838a735a0bdb$var$REQUIRED_NUMBER_FORMATS = [
    "default"
];
var $98a4838a735a0bdb$var$REQUIRED_DATE_FORMATS = [
    "default",
    "date",
    "time",
    "header",
    "footer",
    "dayOfMonth",
    "month",
    "year",
    "decade",
    "century"
];
function $98a4838a735a0bdb$var$_format(localizer, formatter, value, format, culture) {
    var result = typeof format === "function" ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
    (0, $98a4838a735a0bdb$var$_invariant2.default)(result == null || typeof result === "string", "`localizer format(..)` must return a string, null, or undefined");
    return result;
}
function $98a4838a735a0bdb$var$checkFormats(requiredFormats, formats) {}
var $98a4838a735a0bdb$var$_numberLocalizer = $98a4838a735a0bdb$var$createWrapper("NumberPicker");
function $98a4838a735a0bdb$var$setNumber(_ref) {
    var _format2 = _ref.format, _parse = _ref.parse, _ref$decimalChar = _ref.decimalChar, decimalChar = _ref$decimalChar === undefined ? function() {
        return ".";
    } : _ref$decimalChar, _ref$precision = _ref.precision, precision = _ref$precision === undefined ? function() {
        return null;
    } : _ref$precision, formats = _ref.formats, propType = _ref.propType;
    (0, $98a4838a735a0bdb$var$_invariant2.default)(typeof _format2 === "function", "number localizer `format(..)` must be a function");
    (0, $98a4838a735a0bdb$var$_invariant2.default)(typeof _parse === "function", "number localizer `parse(..)` must be a function");
    $98a4838a735a0bdb$var$checkFormats($98a4838a735a0bdb$var$REQUIRED_NUMBER_FORMATS, formats);
    formats.editFormat = formats.editFormat || function(str) {
        return parseFloat(str);
    };
    $98a4838a735a0bdb$var$_numberLocalizer = {
        formats: formats,
        precision: precision,
        decimalChar: decimalChar,
        propType: propType || $98a4838a735a0bdb$var$localePropType,
        format: function format(value, str, culture) {
            return $98a4838a735a0bdb$var$_format(this, _format2, value, str, culture);
        },
        parse: function parse(value, culture, format) {
            var result = _parse.call(this, value, culture, format);
            (0, $98a4838a735a0bdb$var$_invariant2.default)(result == null || typeof result === "number", "number localizer `parse(..)` must return a number, null, or undefined");
            return result;
        }
    };
}
$98a4838a735a0bdb$export$96a94ca0e6838874 = $98a4838a735a0bdb$var$setNumber;
var $98a4838a735a0bdb$var$_dateLocalizer = $98a4838a735a0bdb$var$createWrapper("DateTimePicker");
function $98a4838a735a0bdb$var$setDate(spec) {
    (0, $98a4838a735a0bdb$var$_invariant2.default)(typeof spec.format === "function", "date localizer `format(..)` must be a function");
    (0, $98a4838a735a0bdb$var$_invariant2.default)(typeof spec.parse === "function", "date localizer `parse(..)` must be a function");
    (0, $98a4838a735a0bdb$var$_invariant2.default)(typeof spec.firstOfWeek === "function", "date localizer `firstOfWeek(..)` must be a function");
    $98a4838a735a0bdb$var$checkFormats($98a4838a735a0bdb$var$REQUIRED_DATE_FORMATS, spec.formats);
    $98a4838a735a0bdb$var$_dateLocalizer = {
        formats: spec.formats,
        propType: spec.propType || $98a4838a735a0bdb$var$localePropType,
        startOfWeek: spec.firstOfWeek,
        format: function format(value, str, culture) {
            return $98a4838a735a0bdb$var$_format(this, spec.format, value, str, culture);
        },
        parse: function parse(value, culture) {
            var result = spec.parse.call(this, value, culture);
            (0, $98a4838a735a0bdb$var$_invariant2.default)(result == null || result instanceof Date && !isNaN(result.getTime()), "date localizer `parse(..)` must return a valid Date, null, or undefined");
            return result;
        }
    };
}
var $98a4838a735a0bdb$var$number = $98a4838a735a0bdb$export$98e628dec113755e = {
    propType: function propType() {
        var _numberLocalizer2;
        return (_numberLocalizer2 = $98a4838a735a0bdb$var$_numberLocalizer).propType.apply(_numberLocalizer2, arguments);
    },
    getFormat: function getFormat(key, format) {
        return format || $98a4838a735a0bdb$var$_numberLocalizer.formats[key];
    },
    parse: function parse() {
        var _numberLocalizer3;
        return (_numberLocalizer3 = $98a4838a735a0bdb$var$_numberLocalizer).parse.apply(_numberLocalizer3, arguments);
    },
    format: function format() {
        var _numberLocalizer4;
        return (_numberLocalizer4 = $98a4838a735a0bdb$var$_numberLocalizer).format.apply(_numberLocalizer4, arguments);
    },
    decimalChar: function decimalChar() {
        var _numberLocalizer5;
        return (_numberLocalizer5 = $98a4838a735a0bdb$var$_numberLocalizer).decimalChar.apply(_numberLocalizer5, arguments);
    },
    precision: function precision() {
        var _numberLocalizer6;
        return (_numberLocalizer6 = $98a4838a735a0bdb$var$_numberLocalizer).precision.apply(_numberLocalizer6, arguments);
    }
};
var $98a4838a735a0bdb$var$date = $98a4838a735a0bdb$export$324d90190a8b822a = {
    propType: function propType() {
        var _dateLocalizer2;
        return (_dateLocalizer2 = $98a4838a735a0bdb$var$_dateLocalizer).propType.apply(_dateLocalizer2, arguments);
    },
    getFormat: function getFormat(key, format) {
        return format || $98a4838a735a0bdb$var$_dateLocalizer.formats[key];
    },
    parse: function parse() {
        var _dateLocalizer3;
        return (_dateLocalizer3 = $98a4838a735a0bdb$var$_dateLocalizer).parse.apply(_dateLocalizer3, arguments);
    },
    format: function format() {
        var _dateLocalizer4;
        return (_dateLocalizer4 = $98a4838a735a0bdb$var$_dateLocalizer).format.apply(_dateLocalizer4, arguments);
    },
    startOfWeek: function startOfWeek() {
        var _dateLocalizer5;
        return (_dateLocalizer5 = $98a4838a735a0bdb$var$_dateLocalizer).startOfWeek.apply(_dateLocalizer5, arguments);
    }
};
$98a4838a735a0bdb$export$2e2bcd8739ae039 = {
    number: $98a4838a735a0bdb$var$number,
    date: $98a4838a735a0bdb$var$date
};
function $98a4838a735a0bdb$var$createWrapper() {
    var dummy = {};
    return dummy;
}

});
parcelRegister("4cOpg", function(module, exports) {
"use strict";
var $30ff621354eceb68$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $30ff621354eceb68$var$idCount = 0;
var $30ff621354eceb68$var$_ = module.exports = {
    has: $30ff621354eceb68$var$has,
    result: function result(value) {
        for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return typeof value === "function" ? value.apply(undefined, args) : value;
    },
    isShallowEqual: function isShallowEqual(a, b) {
        if (a === b) return true;
        if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
        if ((typeof a === "undefined" ? "undefined" : $30ff621354eceb68$var$_typeof(a)) !== "object" && (typeof b === "undefined" ? "undefined" : $30ff621354eceb68$var$_typeof(b)) !== "object") return a === b;
        if ((typeof a === "undefined" ? "undefined" : $30ff621354eceb68$var$_typeof(a)) !== (typeof b === "undefined" ? "undefined" : $30ff621354eceb68$var$_typeof(b))) return false;
        return $30ff621354eceb68$var$shallowEqual(a, b);
    },
    transform: function transform(obj, cb, seed) {
        $30ff621354eceb68$var$_.each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
        return seed;
    },
    each: function each(obj, cb, thisArg) {
        if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
        for(var key in obj)if ($30ff621354eceb68$var$has(obj, key)) cb.call(thisArg, obj[key], key, obj);
    },
    pick: function pick(obj, keys) {
        keys = [].concat(keys);
        return $30ff621354eceb68$var$_.transform(obj, function(mapped, val, key) {
            if (keys.indexOf(key) !== -1) mapped[key] = val;
        }, {});
    },
    pickProps: function pickProps(props, componentClass) {
        return $30ff621354eceb68$var$_.pick(props, Object.keys(componentClass.propTypes));
    },
    omit: function omit(obj, keys) {
        keys = [].concat(keys);
        return $30ff621354eceb68$var$_.transform(obj, function(mapped, val, key) {
            if (keys.indexOf(key) === -1) mapped[key] = val;
        }, {});
    },
    omitOwnProps: function omitOwnProps(component) {
        for(var _len2 = arguments.length, others = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)others[_key2 - 1] = arguments[_key2];
        var keys = others.reduce(function(arr, compClass) {
            return arr.concat(Object.keys(compClass.propTypes));
        }, Object.keys(component.constructor.propTypes));
        return $30ff621354eceb68$var$_.omit(component.props, keys);
    },
    find: function find(arr, cb, thisArg) {
        var result;
        if (Array.isArray(arr)) {
            arr.every(function(val, idx) {
                if (cb.call(thisArg, val, idx, arr)) return result = val, false;
                return true;
            });
            return result;
        } else for(var key in arr)if ($30ff621354eceb68$var$has(arr, key)) {
            if (cb.call(thisArg, arr[key], key, arr)) return arr[key];
        }
    },
    chunk: function chunk(array, chunkSize) {
        var index = 0, length = array ? array.length : 0, result = [];
        chunkSize = Math.max(+chunkSize || 1, 1);
        while(index < length)result.push(array.slice(index, index += chunkSize));
        return result;
    },
    splat: function splat(obj) {
        return obj == null ? [] : [].concat(obj);
    },
    noop: function noop() {},
    uniqueId: function uniqueId(prefix) {
        return "" + ((prefix == null ? "" : prefix) + ++$30ff621354eceb68$var$idCount);
    }
};
function $30ff621354eceb68$var$has(o, k) {
    return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}
function $30ff621354eceb68$var$eql(a, b) {
    return a === b;
}
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 */ function $30ff621354eceb68$var$shallowEqual(objA, objB) {
    if (objA == null || objB == null) return false;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$30ff621354eceb68$var$has(objB, keysA[i]) || !$30ff621354eceb68$var$eql(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});



parcelRegister("gFbIU", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $c21991b4014f9736$var$_desc, $c21991b4014f9736$var$_value, $c21991b4014f9736$var$_obj;
var $c21991b4014f9736$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $c21991b4014f9736$var$_react2 = $c21991b4014f9736$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $c21991b4014f9736$var$_propTypes2 = $c21991b4014f9736$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $c21991b4014f9736$var$_createReactClass2 = $c21991b4014f9736$var$_interopRequireDefault($5JTQC);

var $8UrAr = parcelRequire("8UrAr");
var $c21991b4014f9736$var$_activeElement2 = $c21991b4014f9736$var$_interopRequireDefault($8UrAr);

var $4odDf = parcelRequire("4odDf");
var $c21991b4014f9736$var$_contains2 = $c21991b4014f9736$var$_interopRequireDefault($4odDf);

var $ksXgP = parcelRequire("ksXgP");
var $c21991b4014f9736$var$_classnames2 = $c21991b4014f9736$var$_interopRequireDefault($ksXgP);

var $4cOpg = parcelRequire("4cOpg");
var $c21991b4014f9736$var$_3 = $c21991b4014f9736$var$_interopRequireDefault($4cOpg);

var $atEP4 = parcelRequire("atEP4");
var $c21991b4014f9736$var$_Widget2 = $c21991b4014f9736$var$_interopRequireDefault($atEP4);

var $dHGtJ = parcelRequire("dHGtJ");
var $c21991b4014f9736$var$_Input2 = $c21991b4014f9736$var$_interopRequireDefault($dHGtJ);

var $j8c9s = parcelRequire("j8c9s");
var $c21991b4014f9736$var$_Select2 = $c21991b4014f9736$var$_interopRequireDefault($j8c9s);

var $bMTYU = parcelRequire("bMTYU");
var $c21991b4014f9736$var$_DropdownListInput2 = $c21991b4014f9736$var$_interopRequireDefault($bMTYU);

var $6faAq = parcelRequire("6faAq");
var $c21991b4014f9736$var$_Popup2 = $c21991b4014f9736$var$_interopRequireDefault($6faAq);

var $96zKa = parcelRequire("96zKa");
var $c21991b4014f9736$var$_compat2 = $c21991b4014f9736$var$_interopRequireDefault($96zKa);

var $8v4NT = parcelRequire("8v4NT");
var $c21991b4014f9736$var$_propTypes4 = $c21991b4014f9736$var$_interopRequireDefault($8v4NT);

var $emiXD = parcelRequire("emiXD");
var $c21991b4014f9736$var$_List2 = $c21991b4014f9736$var$_interopRequireDefault($emiXD);

var $bp2Lh = parcelRequire("bp2Lh");
var $c21991b4014f9736$var$_ListGroupable2 = $c21991b4014f9736$var$_interopRequireDefault($bp2Lh);

var $jQzQU = parcelRequire("jQzQU");
var $c21991b4014f9736$var$_validateListInterface2 = $c21991b4014f9736$var$_interopRequireDefault($jQzQU);

var $7iIDV = parcelRequire("7iIDV");
var $c21991b4014f9736$var$_uncontrollable2 = $c21991b4014f9736$var$_interopRequireDefault($7iIDV);

var $3Y3Be = parcelRequire("3Y3Be");

var $7RxtH = parcelRequire("7RxtH");

var $b6t9X = parcelRequire("b6t9X");
function $c21991b4014f9736$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c21991b4014f9736$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $c21991b4014f9736$var$result = $c21991b4014f9736$var$_3.default.result;
var $c21991b4014f9736$var$propTypes = $c21991b4014f9736$var$_extends({}, $c21991b4014f9736$var$_Popup2.default.propTypes, {
    //-- controlled props -----------
    value: $c21991b4014f9736$var$_propTypes2.default.any,
    onChange: $c21991b4014f9736$var$_propTypes2.default.func,
    open: $c21991b4014f9736$var$_propTypes2.default.bool,
    onToggle: $c21991b4014f9736$var$_propTypes2.default.func,
    //------------------------------------
    data: $c21991b4014f9736$var$_propTypes2.default.array,
    valueField: $c21991b4014f9736$var$_propTypes2.default.string,
    textField: $c21991b4014f9736$var$_propTypes4.default.accessor,
    valueComponent: $c21991b4014f9736$var$_propTypes4.default.elementType,
    itemComponent: $c21991b4014f9736$var$_propTypes4.default.elementType,
    listComponent: $c21991b4014f9736$var$_propTypes4.default.elementType,
    groupComponent: $c21991b4014f9736$var$_propTypes4.default.elementType,
    groupBy: $c21991b4014f9736$var$_propTypes4.default.accessor,
    onSelect: $c21991b4014f9736$var$_propTypes2.default.func,
    searchTerm: $c21991b4014f9736$var$_propTypes2.default.string,
    onSearch: $c21991b4014f9736$var$_propTypes2.default.func,
    busy: $c21991b4014f9736$var$_propTypes2.default.bool,
    delay: $c21991b4014f9736$var$_propTypes2.default.number,
    dropUp: $c21991b4014f9736$var$_propTypes2.default.bool,
    duration: $c21991b4014f9736$var$_propTypes2.default.number,
    disabled: $c21991b4014f9736$var$_propTypes4.default.disabled.acceptsArray,
    readOnly: $c21991b4014f9736$var$_propTypes4.default.readOnly.acceptsArray,
    messages: $c21991b4014f9736$var$_propTypes2.default.shape({
        open: $c21991b4014f9736$var$_propTypes4.default.message,
        emptyList: $c21991b4014f9736$var$_propTypes4.default.message,
        emptyFilter: $c21991b4014f9736$var$_propTypes4.default.message,
        filterPlaceholder: $c21991b4014f9736$var$_propTypes4.default.message
    })
});








var $c21991b4014f9736$var$DropdownList = (0, $c21991b4014f9736$var$_createReactClass2.default)(($c21991b4014f9736$var$_obj = {
    displayName: "DropdownList",
    mixins: [
        (parcelRequire("5jwiU")),
        (parcelRequire("4cxcq")),
        (parcelRequire("3agVy")),
        (parcelRequire("2Ah31")),
        (parcelRequire("7dl0U")),
        (parcelRequire("5NCz1")),
        (parcelRequire("9AXXZ"))(),
        (parcelRequire("k1uk1"))({
            didHandle: function didHandle(focused) {
                if (!focused) this.close();
            }
        })
    ],
    propTypes: $c21991b4014f9736$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            delay: 500,
            value: "",
            open: false,
            data: [],
            searchTerm: "",
            messages: $c21991b4014f9736$var$msgs(),
            ariaActiveDescendantKey: "dropdownlist"
        };
    },
    getInitialState: function getInitialState() {
        var _props = this.props, open = _props.open, filter = _props.filter, value = _props.value, data = _props.data, searchTerm = _props.searchTerm, valueField = _props.valueField;
        var processed = filter ? this.filter(data, searchTerm) : data, initialIdx = (0, $3Y3Be.dataIndexOf)(data, value, valueField);
        return {
            filteredData: open && filter ? processed : null,
            selectedItem: processed[initialIdx],
            focusedItem: processed[initialIdx] || data[0]
        };
    },
    componentDidUpdate: function componentDidUpdate() {
        this.refs.list && (0, $c21991b4014f9736$var$_validateListInterface2.default)(this.refs.list);
    },
    componentWillReceiveProps: function componentWillReceiveProps(props) {
        var open = props.open, filter = props.filter, value = props.value, data = props.data, searchTerm = props.searchTerm, valueField = props.valueField;
        var processed = filter ? this.filter(data, searchTerm) : data, idx = (0, $3Y3Be.dataIndexOf)(data, value, valueField);
        this.setState({
            filteredData: open && filter ? processed : null,
            selectedItem: processed[idx],
            focusedItem: processed[!~idx ? 0 : idx]
        });
    },
    renderFilter: function renderFilter(messages) {
        var _this = this;
        return $c21991b4014f9736$var$_react2.default.createElement("div", {
            ref: "filterWrapper",
            className: "rw-filter-input"
        }, $c21991b4014f9736$var$_react2.default.createElement($c21991b4014f9736$var$_Select2.default, {
            component: "span",
            icon: "search"
        }), $c21991b4014f9736$var$_react2.default.createElement($c21991b4014f9736$var$_Input2.default, {
            ref: "filter",
            value: this.props.searchTerm,
            placeholder: $c21991b4014f9736$var$_3.default.result(messages.filterPlaceholder, this.props),
            onChange: function onChange(e) {
                return (0, $b6t9X.notify)(_this.props.onSearch, e.target.value);
            }
        }));
    },
    renderList: function renderList(List, id, messages) {
        var _props2 = this.props, open = _props2.open, filter = _props2.filter, data = _props2.data;
        var _state = this.state, selectedItem = _state.selectedItem, focusedItem = _state.focusedItem;
        var listProps = $c21991b4014f9736$var$_3.default.pickProps(this.props, List);
        var items = this._data();
        return $c21991b4014f9736$var$_react2.default.createElement("div", null, filter && this.renderFilter(messages), $c21991b4014f9736$var$_react2.default.createElement(List, $c21991b4014f9736$var$_extends({}, listProps, {
            ref: "list",
            id: id,
            data: items,
            "aria-live": open && "polite",
            "aria-labelledby": (0, $b6t9X.instanceId)(this),
            "aria-hidden": !this.props.open,
            selected: selectedItem,
            focused: open ? focusedItem : null,
            onSelect: this.handleSelect,
            onMove: this._scrollTo,
            messages: {
                emptyList: data.length ? messages.emptyFilter : messages.emptyList
            }
        })));
    },
    render: function render() {
        var _this2 = this;
        var _props3 = this.props, className = _props3.className, tabIndex = _props3.tabIndex, duration = _props3.duration, valueField = _props3.valueField, textField = _props3.textField, groupBy = _props3.groupBy, messages = _props3.messages, data = _props3.data, busy = _props3.busy, dropUp = _props3.dropUp, placeholder = _props3.placeholder, value = _props3.value, open = _props3.open, valueComponent = _props3.valueComponent, List = _props3.listComponent;
        List = List || groupBy && $c21991b4014f9736$var$_ListGroupable2.default || $c21991b4014f9736$var$_List2.default;
        var focused = this.state.focused;
        var disabled = (0, $7RxtH.isDisabled)(this.props), readOnly = (0, $7RxtH.isReadOnly)(this.props), valueItem = (0, $3Y3Be.dataItem)(data, value, valueField) // take value from the raw data
        , listID = (0, $b6t9X.instanceId)(this, "__listbox");
        var elementProps = $c21991b4014f9736$var$_extends($c21991b4014f9736$var$_3.default.omitOwnProps(this, List), {
            role: "combobox",
            tabIndex: tabIndex || 0,
            "aria-owns": listID,
            "aria-expanded": !!open,
            "aria-haspopup": true,
            "aria-busy": !!busy,
            "aria-live": !open && "polite",
            "aria-autocomplete": "list",
            "aria-disabled": disabled,
            "aria-readonly": readOnly
        });
        var shouldRenderPopup = open || (0, $b6t9X.isFirstFocusedRender)(this);
        messages = $c21991b4014f9736$var$msgs(messages);
        return $c21991b4014f9736$var$_react2.default.createElement($c21991b4014f9736$var$_Widget2.default, $c21991b4014f9736$var$_extends({}, elementProps, {
            ref: "input",
            className: (0, $c21991b4014f9736$var$_classnames2.default)(className, "rw-dropdownlist"),
            open: open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress
        }), $c21991b4014f9736$var$_react2.default.createElement($c21991b4014f9736$var$_Select2.default, {
            busy: busy,
            icon: "caret-down",
            component: "span",
            className: "rw-dropdownlist-picker",
            label: $c21991b4014f9736$var$result(messages.open, this.props)
        }), $c21991b4014f9736$var$_react2.default.createElement($c21991b4014f9736$var$_DropdownListInput2.default, {
            value: valueItem,
            textField: textField,
            placeholder: placeholder,
            valueComponent: valueComponent
        }), shouldRenderPopup && $c21991b4014f9736$var$_react2.default.createElement($c21991b4014f9736$var$_Popup2.default, {
            open: open,
            dropUp: dropUp,
            duration: duration,
            onOpen: function onOpen() {
                return _this2.focus();
            },
            onOpening: function onOpening() {
                return _this2.refs.list.forceUpdate();
            }
        }, this.renderList(List, listID, messages)));
    },
    handleSelect: function handleSelect(data) {
        this.close();
        (0, $b6t9X.notify)(this.props.onSelect, data);
        this.change(data);
        this.focus(this);
    },
    handleClick: function handleClick(e) {
        var wrapper = this.refs.filterWrapper;
        if (!this.props.filter || !this.props.open) this.toggle();
        else if (!(0, $c21991b4014f9736$var$_contains2.default)($c21991b4014f9736$var$_compat2.default.findDOMNode(wrapper), e.target)) this.close();
        (0, $b6t9X.notify)(this.props.onClick, e);
    },
    handleKeyDown: function handleKeyDown(e) {
        var _this3 = this;
        var key = e.key, alt = e.altKey, list = this.refs.list, filtering = this.props.filter, focusedItem = this.state.focusedItem, selectedItem = this.state.selectedItem, isOpen = this.props.open, closeWithFocus = function closeWithFocus() {
            _this3.close(), $c21991b4014f9736$var$_compat2.default.findDOMNode(_this3).focus();
        };
        (0, $b6t9X.notify)(this.props.onKeyDown, [
            e
        ]);
        var change = function change(item, fromList) {
            if (item == null) return;
            fromList ? _this3.handleSelect(item) : _this3.change(item);
        };
        if (e.defaultPrevented) return;
        if (key === "End") {
            e.preventDefault();
            if (isOpen) this.setState({
                focusedItem: list.last()
            });
            else change(list.last());
        } else if (key === "Home") {
            e.preventDefault();
            if (isOpen) this.setState({
                focusedItem: list.first()
            });
            else change(list.first());
        } else if (key === "Escape" && isOpen) {
            e.preventDefault();
            closeWithFocus();
        } else if ((key === "Enter" || key === " " && !filtering) && isOpen) {
            e.preventDefault();
            change(this.state.focusedItem, true);
        } else if (key === " " && !filtering && !isOpen) {
            e.preventDefault();
            this.open();
        } else if (key === "ArrowDown") {
            if (alt) this.open();
            else if (isOpen) this.setState({
                focusedItem: list.next(focusedItem)
            });
            else change(list.next(selectedItem));
            e.preventDefault();
        } else if (key === "ArrowUp") {
            if (alt) closeWithFocus();
            else if (isOpen) this.setState({
                focusedItem: list.prev(focusedItem)
            });
            else change(list.prev(selectedItem));
            e.preventDefault();
        }
    },
    handleKeyPress: function handleKeyPress(e) {
        var _this4 = this;
        (0, $b6t9X.notify)(this.props.onKeyPress, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (!(this.props.filter && this.props.open)) this.search(String.fromCharCode(e.which), function(item) {
            _this4._mounted && _this4.props.open ? _this4.setState({
                focusedItem: item
            }) : item && _this4.change(item);
        });
    },
    change: function change(data) {
        if (!(0, $3Y3Be.valueMatcher)(data, this.props.value, this.props.valueField)) {
            (0, $b6t9X.notify)(this.props.onChange, data);
            (0, $b6t9X.notify)(this.props.onSearch, "");
            this.close();
        }
    },
    focus: function focus(target) {
        var _props4 = this.props, filter = _props4.filter, open = _props4.open;
        var inst = target || (filter && open ? this.refs.filter : this.refs.input);
        inst = $c21991b4014f9736$var$_compat2.default.findDOMNode(inst);
        if ((0, $c21991b4014f9736$var$_activeElement2.default)() !== inst) inst.focus();
    },
    _data: function _data() {
        return this.state.filteredData || this.props.data.concat();
    },
    search: function search(character, cb) {
        var _this5 = this;
        var word = ((this._searchTerm || "") + character).toLowerCase();
        if (!character) return;
        this._searchTerm = word;
        this.setTimeout("search", function() {
            var list = _this5.refs.list, key = _this5.props.open ? "focusedItem" : "selectedItem", item = list.next(_this5.state[key], word);
            _this5._searchTerm = "";
            if (item) cb(item);
        }, this.props.delay);
    },
    open: function open() {
        (0, $b6t9X.notify)(this.props.onToggle, true);
    },
    close: function close() {
        (0, $b6t9X.notify)(this.props.onToggle, false);
    },
    toggle: function toggle() {
        this.props.open ? this.close() : this.open();
    }
}, $c21991b4014f9736$var$_applyDecoratedDescriptor($c21991b4014f9736$var$_obj, "handleSelect", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($c21991b4014f9736$var$_obj, "handleSelect"), $c21991b4014f9736$var$_obj), $c21991b4014f9736$var$_applyDecoratedDescriptor($c21991b4014f9736$var$_obj, "handleClick", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($c21991b4014f9736$var$_obj, "handleClick"), $c21991b4014f9736$var$_obj), $c21991b4014f9736$var$_applyDecoratedDescriptor($c21991b4014f9736$var$_obj, "handleKeyDown", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($c21991b4014f9736$var$_obj, "handleKeyDown"), $c21991b4014f9736$var$_obj), $c21991b4014f9736$var$_applyDecoratedDescriptor($c21991b4014f9736$var$_obj, "handleKeyPress", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($c21991b4014f9736$var$_obj, "handleKeyPress"), $c21991b4014f9736$var$_obj), $c21991b4014f9736$var$_obj));
function $c21991b4014f9736$var$msgs(msgs) {
    return $c21991b4014f9736$var$_extends({
        open: "open dropdown",
        filterPlaceholder: "",
        emptyList: "There are no items in this list",
        emptyFilter: "The filter returned no results"
    }, msgs);
}
module.exports.default = (0, $c21991b4014f9736$var$_uncontrollable2.default)($c21991b4014f9736$var$DropdownList, {
    open: "onToggle",
    value: "onChange",
    searchTerm: "onSearch"
}, [
    "focus"
]);
module.exports = module.exports["default"];

});
parcelRegister("8UrAr", function(module, exports) {
"use strict";

var $61fgT = parcelRequire("61fgT");
module.exports.__esModule = true;
/**
 * document.activeElement
 */ module.exports["default"] = $67c8f3db6cc8d48c$var$activeElement;

var $6CU1q = parcelRequire("6CU1q");
var $67c8f3db6cc8d48c$var$_ownerDocument2 = $61fgT.interopRequireDefault($6CU1q);
function $67c8f3db6cc8d48c$var$activeElement() {
    var doc = arguments[0] === undefined ? document : arguments[0];
    try {
        return doc.activeElement;
    } catch (e) {}
}
module.exports = module.exports["default"];

});
parcelRegister("6CU1q", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $4d31bf8186026143$var$ownerDocument;
function $4d31bf8186026143$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
module.exports = module.exports["default"];

});


parcelRegister("4odDf", function(module, exports) {
"use strict";

var $cAyTR = parcelRequire("cAyTR");
var $3323fa594a9a7ecc$var$contains = function() {
    var root = $cAyTR && document.documentElement;
    return root && root.contains ? function(context, node) {
        return context.contains(node);
    } : root && root.compareDocumentPosition ? function(context, node) {
        return context === node || !!(context.compareDocumentPosition(node) & 16);
    } : function(context, node) {
        if (node) do {
            if (node === context) return true;
        }while (node = node.parentNode);
        return false;
    };
}();
module.exports = $3323fa594a9a7ecc$var$contains;

});

parcelRegister("atEP4", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $7a0c475efc1f62a4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7a0c475efc1f62a4$var$_class, $7a0c475efc1f62a4$var$_temp;

var $7PdBe = parcelRequire("7PdBe");
var $7a0c475efc1f62a4$var$_react2 = $7a0c475efc1f62a4$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $7a0c475efc1f62a4$var$_propTypes2 = $7a0c475efc1f62a4$var$_interopRequireDefault($S29Lp);

var $ksXgP = parcelRequire("ksXgP");
var $7a0c475efc1f62a4$var$_classnames2 = $7a0c475efc1f62a4$var$_interopRequireDefault($ksXgP);
function $7a0c475efc1f62a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a0c475efc1f62a4$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $7a0c475efc1f62a4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7a0c475efc1f62a4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7a0c475efc1f62a4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7a0c475efc1f62a4$var$Widget = ($7a0c475efc1f62a4$var$_temp = $7a0c475efc1f62a4$var$_class = function(_React$Component) {
    $7a0c475efc1f62a4$var$_inherits(Widget, _React$Component);
    function Widget() {
        $7a0c475efc1f62a4$var$_classCallCheck(this, Widget);
        return $7a0c475efc1f62a4$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Widget.prototype.render = function render() {
        var _props = this.props, className = _props.className, tabIndex = _props.tabIndex, open = _props.open, dropUp = _props.dropUp, disabled = _props.disabled, readOnly = _props.readOnly, focused = _props.focused, props = $7a0c475efc1f62a4$var$_objectWithoutProperties(_props, [
            "className",
            "tabIndex",
            "open",
            "dropUp",
            "disabled",
            "readOnly",
            "focused"
        ]);
        var isRtl = !!this.context.isRtl;
        var openClass = "rw-open" + (dropUp ? "-up" : "");
        tabIndex = tabIndex != null ? tabIndex : "-1";
        return $7a0c475efc1f62a4$var$_react2.default.createElement("div", $7a0c475efc1f62a4$var$_extends({}, props, {
            tabIndex: tabIndex,
            className: (0, $7a0c475efc1f62a4$var$_classnames2.default)(className, "rw-widget", isRtl && "rw-rtl", open && openClass, focused && "rw-state-focus", disabled && "rw-state-disabled", readOnly && "rw-state-readonly")
        }));
    };
    return Widget;
}($7a0c475efc1f62a4$var$_react2.default.Component), $7a0c475efc1f62a4$var$_class.propTypes = {
    tabIndex: $7a0c475efc1f62a4$var$_propTypes2.default.node,
    focused: $7a0c475efc1f62a4$var$_propTypes2.default.bool,
    disabled: $7a0c475efc1f62a4$var$_propTypes2.default.bool,
    readOnly: $7a0c475efc1f62a4$var$_propTypes2.default.bool,
    open: $7a0c475efc1f62a4$var$_propTypes2.default.bool,
    dropUp: $7a0c475efc1f62a4$var$_propTypes2.default.bool
}, $7a0c475efc1f62a4$var$_class.contextTypes = {
    isRtl: $7a0c475efc1f62a4$var$_propTypes2.default.bool
}, $7a0c475efc1f62a4$var$_temp);
module.exports.default = $7a0c475efc1f62a4$var$Widget;
module.exports = module.exports["default"];

});

parcelRegister("dHGtJ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $9fa03de3967e9bcc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $9fa03de3967e9bcc$var$_react2 = $9fa03de3967e9bcc$var$_interopRequireDefault($7PdBe);

var $ksXgP = parcelRequire("ksXgP");
var $9fa03de3967e9bcc$var$_classnames2 = $9fa03de3967e9bcc$var$_interopRequireDefault($ksXgP);
function $9fa03de3967e9bcc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9fa03de3967e9bcc$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $9fa03de3967e9bcc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9fa03de3967e9bcc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9fa03de3967e9bcc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9fa03de3967e9bcc$var$Input = function(_React$Component) {
    $9fa03de3967e9bcc$var$_inherits(Input, _React$Component);
    function Input() {
        $9fa03de3967e9bcc$var$_classCallCheck(this, Input);
        return $9fa03de3967e9bcc$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Input.prototype.render = function render() {
        var _props = this.props, className = _props.className, disabled = _props.disabled, readOnly = _props.readOnly, value = _props.value, tabIndex = _props.tabIndex, _props$component = _props.component, Component = _props$component === undefined ? "input" : _props$component, props = $9fa03de3967e9bcc$var$_objectWithoutProperties(_props, [
            "className",
            "disabled",
            "readOnly",
            "value",
            "tabIndex",
            "component"
        ]);
        return $9fa03de3967e9bcc$var$_react2.default.createElement(Component, $9fa03de3967e9bcc$var$_extends({}, props, {
            type: "text",
            tabIndex: tabIndex || 0,
            autoComplete: "off",
            disabled: disabled,
            readOnly: readOnly,
            "aria-disabled": disabled,
            "aria-readonly": readOnly,
            value: value == null ? "" : value,
            className: (0, $9fa03de3967e9bcc$var$_classnames2.default)(className, "rw-input")
        }));
    };
    return Input;
}($9fa03de3967e9bcc$var$_react2.default.Component);
module.exports.default = $9fa03de3967e9bcc$var$Input;
module.exports = module.exports["default"];

});

parcelRegister("j8c9s", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $ded830be43704b82$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $ded830be43704b82$var$_react2 = $ded830be43704b82$var$_interopRequireDefault($7PdBe);

var $ksXgP = parcelRequire("ksXgP");
var $ded830be43704b82$var$_classnames2 = $ded830be43704b82$var$_interopRequireDefault($ksXgP);

var $6MCLm = parcelRequire("6MCLm");
var $ded830be43704b82$var$_Button2 = $ded830be43704b82$var$_interopRequireDefault($6MCLm);
function $ded830be43704b82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ded830be43704b82$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $ded830be43704b82$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ded830be43704b82$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ded830be43704b82$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ded830be43704b82$var$Select = function(_React$Component) {
    $ded830be43704b82$var$_inherits(Select, _React$Component);
    function Select() {
        $ded830be43704b82$var$_classCallCheck(this, Select);
        return $ded830be43704b82$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Select.prototype.render = function render() {
        var _props = this.props, className = _props.className, props = $ded830be43704b82$var$_objectWithoutProperties(_props, [
            "className"
        ]);
        return $ded830be43704b82$var$_react2.default.createElement($ded830be43704b82$var$_Button2.default, $ded830be43704b82$var$_extends({}, props, {
            className: (0, $ded830be43704b82$var$_classnames2.default)(className, "rw-select")
        }));
    };
    return Select;
}($ded830be43704b82$var$_react2.default.Component);
module.exports.default = $ded830be43704b82$var$Select;
module.exports = module.exports["default"];

});
parcelRegister("6MCLm", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $4f054b4c2d748dea$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $4f054b4c2d748dea$var$_react2 = $4f054b4c2d748dea$var$_interopRequireDefault($7PdBe);

var $ksXgP = parcelRequire("ksXgP");
var $4f054b4c2d748dea$var$_classnames2 = $4f054b4c2d748dea$var$_interopRequireDefault($ksXgP);
function $4f054b4c2d748dea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4f054b4c2d748dea$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $4f054b4c2d748dea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4f054b4c2d748dea$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4f054b4c2d748dea$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $4f054b4c2d748dea$var$Button = function(_React$Component) {
    $4f054b4c2d748dea$var$_inherits(Button, _React$Component);
    function Button() {
        $4f054b4c2d748dea$var$_classCallCheck(this, Button);
        return $4f054b4c2d748dea$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Button.prototype.render = function render() {
        var _props = this.props, className = _props.className, disabled = _props.disabled, label = _props.label, icon = _props.icon, busy = _props.busy, active = _props.active, children = _props.children, _props$component = _props.component, Tag = _props$component === undefined ? "button" : _props$component, props = $4f054b4c2d748dea$var$_objectWithoutProperties(_props, [
            "className",
            "disabled",
            "label",
            "icon",
            "busy",
            "active",
            "children",
            "component"
        ]);
        var type = props.type;
        if (Tag === "button") type = type || "button";
        return $4f054b4c2d748dea$var$_react2.default.createElement(Tag, $4f054b4c2d748dea$var$_extends({}, props, {
            tabIndex: "-1",
            title: label,
            type: type,
            disabled: disabled,
            "aria-disabled": disabled,
            "aria-label": label,
            className: (0, $4f054b4c2d748dea$var$_classnames2.default)(className, "rw-btn", active && !disabled && "rw-state-active")
        }), icon && $4f054b4c2d748dea$var$_react2.default.createElement("span", {
            "aria-hidden": true,
            className: (0, $4f054b4c2d748dea$var$_classnames2.default)("rw-i", "rw-i-" + icon, busy && "rw-loading")
        }), children);
    };
    return Button;
}($4f054b4c2d748dea$var$_react2.default.Component);
module.exports.default = $4f054b4c2d748dea$var$Button;
module.exports = module.exports["default"];

});


parcelRegister("bMTYU", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $894f9a28402b1926$var$_class, $894f9a28402b1926$var$_temp;

var $7PdBe = parcelRequire("7PdBe");
var $894f9a28402b1926$var$_react2 = $894f9a28402b1926$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $894f9a28402b1926$var$_propTypes2 = $894f9a28402b1926$var$_interopRequireDefault($S29Lp);

var $8v4NT = parcelRequire("8v4NT");
var $894f9a28402b1926$var$_propTypes4 = $894f9a28402b1926$var$_interopRequireDefault($8v4NT);

var $3Y3Be = parcelRequire("3Y3Be");
function $894f9a28402b1926$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $894f9a28402b1926$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $894f9a28402b1926$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $894f9a28402b1926$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $894f9a28402b1926$var$DropdownListInput = ($894f9a28402b1926$var$_temp = $894f9a28402b1926$var$_class = function(_React$Component) {
    $894f9a28402b1926$var$_inherits(DropdownListInput, _React$Component);
    function DropdownListInput() {
        $894f9a28402b1926$var$_classCallCheck(this, DropdownListInput);
        return $894f9a28402b1926$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    DropdownListInput.prototype.render = function render() {
        var _props = this.props, placeholder = _props.placeholder, value = _props.value, textField = _props.textField, Component = _props.valueComponent;
        return $894f9a28402b1926$var$_react2.default.createElement("div", {
            className: "rw-input"
        }, !value && placeholder ? $894f9a28402b1926$var$_react2.default.createElement("span", {
            className: "rw-placeholder"
        }, placeholder) : Component ? $894f9a28402b1926$var$_react2.default.createElement(Component, {
            item: value
        }) : (0, $3Y3Be.dataText)(value, textField));
    };
    return DropdownListInput;
}($894f9a28402b1926$var$_react2.default.Component), $894f9a28402b1926$var$_class.propTypes = {
    value: $894f9a28402b1926$var$_propTypes2.default.any,
    placeholder: $894f9a28402b1926$var$_propTypes2.default.string,
    textField: $894f9a28402b1926$var$_propTypes4.default.accessor,
    valueComponent: $894f9a28402b1926$var$_propTypes4.default.elementType
}, $894f9a28402b1926$var$_temp);
module.exports.default = $894f9a28402b1926$var$DropdownListInput;
module.exports = module.exports["default"];

});
parcelRegister("8v4NT", function(module, exports) {
"use strict";

var $7PdBe = parcelRequire("7PdBe");
var $6304f1e1907c23e3$var$_react2 = $6304f1e1907c23e3$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $6304f1e1907c23e3$var$_propTypes2 = $6304f1e1907c23e3$var$_interopRequireDefault($S29Lp);

var $d6vOx = parcelRequire("d6vOx");
var $6304f1e1907c23e3$var$_localizers2 = $6304f1e1907c23e3$var$_interopRequireDefault($d6vOx);

var $lUHFm = parcelRequire("lUHFm");
var $6304f1e1907c23e3$var$_filter2 = $6304f1e1907c23e3$var$_interopRequireDefault($lUHFm);
function $6304f1e1907c23e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6304f1e1907c23e3$var$filterTypes = Object.keys($6304f1e1907c23e3$var$_filter2.default).filter(function(i) {
    return i !== "filter";
});
function $6304f1e1907c23e3$var$getInteractionPropType(key) {
    var types = [
        $6304f1e1907c23e3$var$_propTypes2.default.bool,
        $6304f1e1907c23e3$var$_propTypes2.default.oneOf([
            key
        ])
    ], propType = $6304f1e1907c23e3$var$_propTypes2.default.oneOfType(types);
    propType.acceptsArray = $6304f1e1907c23e3$var$_propTypes2.default.oneOfType(types.concat($6304f1e1907c23e3$var$_propTypes2.default.array));
    return propType;
}
module.exports = {
    elementType: $6304f1e1907c23e3$var$createChainableTypeChecker(function(props, propName, componentName) {
        if (typeof props[propName] !== "function") {
            if ($6304f1e1907c23e3$var$_react2.default.isValidElement(props[propName])) return new Error("Invalid prop `" + propName + "` specified in  `" + componentName + "`." + " Expected an Element `type`, not an actual Element");
            if (typeof props[propName] !== "string") return new Error("Invalid prop `" + propName + "` specified in  `" + componentName + "`." + " Expected an Element `type` such as a tag name or return value of createReactClass(...)");
        }
        return null;
    }),
    numberFormat: $6304f1e1907c23e3$var$createChainableTypeChecker(function() {
        var _localizers$number;
        return (_localizers$number = $6304f1e1907c23e3$var$_localizers2.default.number).propType.apply(_localizers$number, arguments);
    }),
    dateFormat: $6304f1e1907c23e3$var$createChainableTypeChecker(function() {
        var _localizers$date;
        return (_localizers$date = $6304f1e1907c23e3$var$_localizers2.default.date).propType.apply(_localizers$date, arguments);
    }),
    disabled: $6304f1e1907c23e3$var$getInteractionPropType("disabled"),
    readOnly: $6304f1e1907c23e3$var$getInteractionPropType("readOnly"),
    accessor: $6304f1e1907c23e3$var$_propTypes2.default.oneOfType([
        $6304f1e1907c23e3$var$_propTypes2.default.string,
        $6304f1e1907c23e3$var$_propTypes2.default.func
    ]),
    message: $6304f1e1907c23e3$var$_propTypes2.default.oneOfType([
        $6304f1e1907c23e3$var$_propTypes2.default.node,
        $6304f1e1907c23e3$var$_propTypes2.default.string
    ]),
    filter: $6304f1e1907c23e3$var$_propTypes2.default.oneOfType([
        $6304f1e1907c23e3$var$_propTypes2.default.func,
        $6304f1e1907c23e3$var$_propTypes2.default.bool,
        $6304f1e1907c23e3$var$_propTypes2.default.oneOf($6304f1e1907c23e3$var$filterTypes)
    ])
};
function $6304f1e1907c23e3$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName) {
        componentName = componentName || "<<anonymous>>";
        for(var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++)args[_key - 4] = arguments[_key];
        if (props[propName] == null) {
            if (isRequired) return new Error("Required prop `" + propName + "` was not specified in  `" + componentName + "`.");
        } else return validate.apply(undefined, [
            props,
            propName,
            componentName
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

});
parcelRegister("lUHFm", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $ff40b31eb05ea61a$var$common = {
    eq: function eq(a, b) {
        return a === b;
    },
    neq: function neq(a, b) {
        return a !== b;
    },
    gt: function gt(a, b) {
        return a > b;
    },
    gte: function gte(a, b) {
        return a >= b;
    },
    lt: function lt(a, b) {
        return a < b;
    },
    lte: function lte(a, b) {
        return a <= b;
    },
    contains: function contains(a, b) {
        return a.indexOf(b) !== -1;
    },
    startsWith: function startsWith(a, b) {
        return a.lastIndexOf(b, 0) === 0;
    },
    endsWith: function endsWith(a, b) {
        var pos = a.length - b.length, lastIndex = a.indexOf(b, pos);
        return lastIndex !== -1 && lastIndex === pos;
    }
};
module.exports.default = $ff40b31eb05ea61a$var$common;
module.exports = module.exports["default"];

});


parcelRegister("3Y3Be", function(module, exports) {

$parcel$export(module.exports, "dataValue", function () { return $2e39c4788442b868$export$5b778755b18e3df6; }, function (v) { return $2e39c4788442b868$export$5b778755b18e3df6 = v; });
$parcel$export(module.exports, "dataText", function () { return $2e39c4788442b868$export$681c486861d21a35; }, function (v) { return $2e39c4788442b868$export$681c486861d21a35 = v; });
$parcel$export(module.exports, "dataIndexOf", function () { return $2e39c4788442b868$export$cbe71908c8876c47; }, function (v) { return $2e39c4788442b868$export$cbe71908c8876c47 = v; });
$parcel$export(module.exports, "valueMatcher", function () { return $2e39c4788442b868$export$7ea29c9eab6647da; }, function (v) { return $2e39c4788442b868$export$7ea29c9eab6647da = v; });
$parcel$export(module.exports, "dataItem", function () { return $2e39c4788442b868$export$d45376104c4ecf1a; }, function (v) { return $2e39c4788442b868$export$d45376104c4ecf1a = v; });
var $2e39c4788442b868$export$1e511d4a378977f5;
var $2e39c4788442b868$export$5b778755b18e3df6;
var $2e39c4788442b868$export$681c486861d21a35;
var $2e39c4788442b868$export$cbe71908c8876c47;
var $2e39c4788442b868$export$7ea29c9eab6647da;
var $2e39c4788442b868$export$d45376104c4ecf1a;
"use strict";
$2e39c4788442b868$export$1e511d4a378977f5 = true;
var $2e39c4788442b868$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
$2e39c4788442b868$export$5b778755b18e3df6 = $2e39c4788442b868$var$dataValue;
$2e39c4788442b868$export$681c486861d21a35 = $2e39c4788442b868$var$dataText;
$2e39c4788442b868$export$cbe71908c8876c47 = $2e39c4788442b868$var$dataIndexOf;
$2e39c4788442b868$export$7ea29c9eab6647da = $2e39c4788442b868$var$valueMatcher;
$2e39c4788442b868$export$d45376104c4ecf1a = $2e39c4788442b868$var$dataItem;

var $4cOpg = parcelRequire("4cOpg");
function $2e39c4788442b868$var$accessor(data, field) {
    var value = data;
    if (typeof field === "function") value = field(data);
    else if (data == null) value = data;
    else if (typeof field === "string" && (typeof data === "undefined" ? "undefined" : $2e39c4788442b868$var$_typeof(data)) === "object" && field in data) value = data[field];
    return value;
}
function $2e39c4788442b868$var$dataValue(item, valueField) {
    return valueField && item && (0, $4cOpg.has)(item, valueField) ? item[valueField] : item;
}
function $2e39c4788442b868$var$dataText(item, textField) {
    var value = $2e39c4788442b868$var$accessor(item, textField);
    return value == null ? "" : value + "";
}
function $2e39c4788442b868$var$dataIndexOf(data, item, valueField) {
    var idx = -1, len = data.length, isValueEqual = function isValueEqual(datum) {
        return $2e39c4788442b868$var$valueMatcher(item, datum, valueField);
    };
    while(++idx < len){
        var datum = data[idx];
        if (datum === item || isValueEqual(datum)) return idx;
    }
    return -1;
}
/**
 * I don't know that the shallow equal makes sense here but am too afraid to
 * remove it.
 */ function $2e39c4788442b868$var$valueMatcher(a, b, valueField) {
    return (0, $4cOpg.isShallowEqual)($2e39c4788442b868$var$dataValue(a, valueField), $2e39c4788442b868$var$dataValue(b, valueField));
}
function $2e39c4788442b868$var$dataItem(data, item, valueField) {
    var idx = $2e39c4788442b868$var$dataIndexOf(data, $2e39c4788442b868$var$dataValue(item, valueField), valueField);
    if (idx !== -1) return data[idx];
    return item;
}

});


parcelRegister("6faAq", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $48bc5b075d0fc1ff$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $48bc5b075d0fc1ff$var$_OVERFLOW;

var $7PdBe = parcelRequire("7PdBe");
var $48bc5b075d0fc1ff$var$_react2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $48bc5b075d0fc1ff$var$_propTypes2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $48bc5b075d0fc1ff$var$_createReactClass2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($5JTQC);

var $4cOpg = parcelRequire("4cOpg");
var $48bc5b075d0fc1ff$var$_3 = $48bc5b075d0fc1ff$var$_interopRequireDefault($4cOpg);

var $gKGWM = parcelRequire("gKGWM");
var $48bc5b075d0fc1ff$var$_style2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($gKGWM);

var $7gbNL = parcelRequire("7gbNL");
var $48bc5b075d0fc1ff$var$_height2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($7gbNL);

var $dB9ZP = parcelRequire("dB9ZP");
var $48bc5b075d0fc1ff$var$_camelizeStyle2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($dB9ZP);

var $kLuvQ = parcelRequire("kLuvQ");
var $48bc5b075d0fc1ff$var$_configuration2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($kLuvQ);

var $ksXgP = parcelRequire("ksXgP");
var $48bc5b075d0fc1ff$var$_classnames2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($ksXgP);

var $96zKa = parcelRequire("96zKa");
var $48bc5b075d0fc1ff$var$_compat2 = $48bc5b075d0fc1ff$var$_interopRequireDefault($96zKa);
function $48bc5b075d0fc1ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $48bc5b075d0fc1ff$var$transform = (0, $48bc5b075d0fc1ff$var$_camelizeStyle2.default)($48bc5b075d0fc1ff$var$_configuration2.default.animate.transform);
var $48bc5b075d0fc1ff$var$CLOSING = 0, $48bc5b075d0fc1ff$var$CLOSED = 1, $48bc5b075d0fc1ff$var$OPENING = 2, $48bc5b075d0fc1ff$var$OPEN = 3;
function $48bc5b075d0fc1ff$var$properties(prop, value) {
    var _ref, _ref2;
    var TRANSLATION_MAP = $48bc5b075d0fc1ff$var$_configuration2.default.animate.TRANSLATION_MAP;
    if (TRANSLATION_MAP && TRANSLATION_MAP[prop]) return _ref = {}, _ref[$48bc5b075d0fc1ff$var$transform] = TRANSLATION_MAP[prop] + "(" + value + ")", _ref;
    return _ref2 = {}, _ref2[prop] = value, _ref2;
}
var $48bc5b075d0fc1ff$var$OVERFLOW = ($48bc5b075d0fc1ff$var$_OVERFLOW = {}, $48bc5b075d0fc1ff$var$_OVERFLOW[$48bc5b075d0fc1ff$var$CLOSED] = "hidden", $48bc5b075d0fc1ff$var$_OVERFLOW[$48bc5b075d0fc1ff$var$CLOSING] = "hidden", $48bc5b075d0fc1ff$var$_OVERFLOW[$48bc5b075d0fc1ff$var$OPENING] = "hidden", $48bc5b075d0fc1ff$var$_OVERFLOW);
var $48bc5b075d0fc1ff$var$propTypes = {
    open: $48bc5b075d0fc1ff$var$_propTypes2.default.bool,
    dropUp: $48bc5b075d0fc1ff$var$_propTypes2.default.bool,
    duration: $48bc5b075d0fc1ff$var$_propTypes2.default.number,
    onClosing: $48bc5b075d0fc1ff$var$_propTypes2.default.func,
    onOpening: $48bc5b075d0fc1ff$var$_propTypes2.default.func,
    onClose: $48bc5b075d0fc1ff$var$_propTypes2.default.func,
    onOpen: $48bc5b075d0fc1ff$var$_propTypes2.default.func
};
module.exports.default = (0, $48bc5b075d0fc1ff$var$_createReactClass2.default)({
    displayName: "Popup",
    propTypes: $48bc5b075d0fc1ff$var$propTypes,
    getInitialState: function getInitialState() {
        return {
            initialRender: true,
            status: this.props.open ? $48bc5b075d0fc1ff$var$OPENING : $48bc5b075d0fc1ff$var$CLOSED
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            duration: 200,
            open: false,
            onClosing: function onClosing() {},
            onOpening: function onOpening() {},
            onClose: function onClose() {},
            onOpen: function onOpen() {}
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState({
            contentChanged: $48bc5b075d0fc1ff$var$childKey(nextProps.children) !== $48bc5b075d0fc1ff$var$childKey(this.props.children)
        });
    },
    componentDidMount: function componentDidMount() {
        var _this = this;
        var isOpen = this.state.status === $48bc5b075d0fc1ff$var$OPENING;
        $48bc5b075d0fc1ff$var$_compat2.default.batchedUpdates(function() {
            _this.setState({
                initialRender: false
            });
            if (isOpen) _this.open();
        });
    },
    componentDidUpdate: function componentDidUpdate(pvProps) {
        var closing = pvProps.open && !this.props.open, opening = !pvProps.open && this.props.open, open = this.props.open, status = this.state.status;
        if (!!pvProps.dropUp !== !!this.props.dropUp) {
            this.cancelNextCallback();
            if (status === $48bc5b075d0fc1ff$var$OPENING) this.open();
            if (status === $48bc5b075d0fc1ff$var$CLOSING) this.close();
            return;
        }
        if (opening) this.open();
        else if (closing) this.close();
        else if (open) {
            // this.height() returns a floating point number with the desired height
            // for this popup. Because of potential rounding errors in floating point
            // aritmetic we must allow an error margin when comparing to the current
            // state, otherwise we can end up in an infinite loop where the height
            // is never exactly equal to our target value.
            var height = this.height(), diff = Math.abs(height - this.state.height);
            if (isNaN(diff) || diff > 0.1) this.setState({
                height: height
            });
        }
    },
    render: function render() {
        var _props = this.props, className = _props.className, dropUp = _props.dropUp, style = _props.style, _state = this.state, status = _state.status, height = _state.height;
        var overflow = $48bc5b075d0fc1ff$var$OVERFLOW[status] || "visible", display = status === $48bc5b075d0fc1ff$var$CLOSED ? "none" : "block";
        return $48bc5b075d0fc1ff$var$_react2.default.createElement("div", {
            style: $48bc5b075d0fc1ff$var$_extends({
                display: display,
                overflow: overflow,
                height: height
            }, style),
            className: (0, $48bc5b075d0fc1ff$var$_classnames2.default)(className, "rw-popup-container", dropUp && "rw-dropup", this.isTransitioning() && "rw-popup-animating")
        }, this.renderChildren());
    },
    renderChildren: function renderChildren() {
        if (!this.props.children) return $48bc5b075d0fc1ff$var$_react2.default.createElement("span", {
            className: "rw-popup rw-widget"
        });
        var offset = this.getOffsetForStatus(this.state.status), child = $48bc5b075d0fc1ff$var$_react2.default.Children.only(this.props.children);
        return (0, $7PdBe.cloneElement)(child, {
            style: $48bc5b075d0fc1ff$var$_extends({}, child.props.style, offset, {
                position: this.isTransitioning() ? "absolute" : undefined
            }),
            className: (0, $48bc5b075d0fc1ff$var$_classnames2.default)(child.props.className, "rw-popup rw-widget")
        });
    },
    open: function open() {
        var _this2 = this;
        this.cancelNextCallback();
        var el = $48bc5b075d0fc1ff$var$_compat2.default.findDOMNode(this).firstChild, height = this.height();
        this.props.onOpening();
        this.safeSetState({
            status: $48bc5b075d0fc1ff$var$OPENING,
            height: height
        }, function() {
            var offset = _this2.getOffsetForStatus($48bc5b075d0fc1ff$var$OPEN), duration = _this2.props.duration;
            _this2.animate(el, offset, duration, "ease", function() {
                _this2.safeSetState({
                    status: $48bc5b075d0fc1ff$var$OPEN
                }, function() {
                    _this2.props.onOpen();
                });
            });
        });
    },
    close: function close() {
        var _this3 = this;
        this.cancelNextCallback();
        var el = $48bc5b075d0fc1ff$var$_compat2.default.findDOMNode(this).firstChild, height = this.height();
        this.props.onClosing();
        this.safeSetState({
            status: $48bc5b075d0fc1ff$var$CLOSING,
            height: height
        }, function() {
            var offset = _this3.getOffsetForStatus($48bc5b075d0fc1ff$var$CLOSED), duration = _this3.props.duration;
            _this3.animate(el, offset, duration, "ease", function() {
                return _this3.safeSetState({
                    status: $48bc5b075d0fc1ff$var$CLOSED
                }, function() {
                    _this3.props.onClose();
                });
            });
        });
    },
    getOffsetForStatus: function getOffsetForStatus(status) {
        var _CLOSED$CLOSING$OPENI;
        if (this.state.initialRender) return {};
        var _in = $48bc5b075d0fc1ff$var$properties("top", this.props.dropUp ? "100%" : "-100%"), out = $48bc5b075d0fc1ff$var$properties("top", 0);
        return (_CLOSED$CLOSING$OPENI = {}, _CLOSED$CLOSING$OPENI[$48bc5b075d0fc1ff$var$CLOSED] = _in, _CLOSED$CLOSING$OPENI[$48bc5b075d0fc1ff$var$CLOSING] = out, _CLOSED$CLOSING$OPENI[$48bc5b075d0fc1ff$var$OPENING] = _in, _CLOSED$CLOSING$OPENI[$48bc5b075d0fc1ff$var$OPEN] = out, _CLOSED$CLOSING$OPENI)[status] || {};
    },
    height: function height() {
        var container = $48bc5b075d0fc1ff$var$_compat2.default.findDOMNode(this), content = container.firstChild, margin = parseInt((0, $48bc5b075d0fc1ff$var$_style2.default)(content, "margin-top"), 10) + parseInt((0, $48bc5b075d0fc1ff$var$_style2.default)(content, "margin-bottom"), 10);
        var old = container.style.display, height = void 0;
        container.style.display = "block";
        height = ((0, $48bc5b075d0fc1ff$var$_height2.default)(content) || 0) + (isNaN(margin) ? 0 : margin);
        container.style.display = old;
        return height;
    },
    isTransitioning: function isTransitioning() {
        return this.state.status === $48bc5b075d0fc1ff$var$OPENING || this.state.status === $48bc5b075d0fc1ff$var$CLOSED;
    },
    animate: function animate(el, props, dur, easing, cb) {
        this._transition = $48bc5b075d0fc1ff$var$_configuration2.default.animate(el, props, dur, easing, this.setNextCallback(cb));
    },
    cancelNextCallback: function cancelNextCallback() {
        if (this._transition && this._transition.cancel) {
            this._transition.cancel();
            this._transition = null;
        }
        if (this.nextCallback) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    },
    safeSetState: function safeSetState(nextState, callback) {
        this.setState(nextState, this.setNextCallback(callback));
    },
    setNextCallback: function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            return active = false;
        };
        return this.nextCallback;
    }
});
function $48bc5b075d0fc1ff$var$childKey(children) {
    var nextChildMapping = $48bc5b075d0fc1ff$var$_react2.default.Children.map(children, function(c) {
        return c;
    });
    for(var key in nextChildMapping)return key;
}
module.exports = module.exports["default"];

});
parcelRegister("7gbNL", function(module, exports) {
"use strict";

var $4YZHC = parcelRequire("4YZHC");

var $8uPzo = parcelRequire("8uPzo");
module.exports = function height(node, client) {
    var win = $8uPzo(node);
    return win ? win.innerHeight : client ? node.clientHeight : $4YZHC(node).height;
};

});
parcelRegister("4YZHC", function(module, exports) {
"use strict";

var $4odDf = parcelRequire("4odDf");

var $8uPzo = parcelRequire("8uPzo");

var $6CU1q = parcelRequire("6CU1q");
module.exports = function offset(node) {
    var doc = $6CU1q(node), win = $8uPzo(doc), docElem = doc && doc.documentElement, box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    if (!doc) return;
    // Make sure it's not a disconnected DOM node
    if (!$4odDf(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    if (box.width || box.height) box = {
        top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
        left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
        width: (box.width == null ? node.offsetWidth : box.width) || 0,
        height: (box.height == null ? node.offsetHeight : box.height) || 0
    };
    return box;
};

});
parcelRegister("8uPzo", function(module, exports) {
"use strict";
module.exports = function getWindow(node) {
    return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
};

});



parcelRegister("96zKa", function(module, exports) {
"use strict";

var $7PdBe = parcelRequire("7PdBe");
var $6a10668f05c135ab$var$_react2 = $6a10668f05c135ab$var$_interopRequireDefault($7PdBe);

var $1cUCD = parcelRequire("1cUCD");
var $6a10668f05c135ab$var$_reactDom2 = $6a10668f05c135ab$var$_interopRequireDefault($1cUCD);
function $6a10668f05c135ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6a10668f05c135ab$var$_version = $6a10668f05c135ab$var$_react2.default.version.split(".").map(parseFloat);
module.exports = {
    version: function version() {
        return $6a10668f05c135ab$var$_version;
    },
    findDOMNode: function findDOMNode(component) {
        return $6a10668f05c135ab$var$_reactDom2.default.findDOMNode(component);
    },
    batchedUpdates: function batchedUpdates(cb) {
        $6a10668f05c135ab$var$_reactDom2.default.unstable_batchedUpdates(cb);
    }
};

});


parcelRegister("emiXD", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $a741d4037f2d7225$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $a741d4037f2d7225$var$_react2 = $a741d4037f2d7225$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $a741d4037f2d7225$var$_propTypes2 = $a741d4037f2d7225$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $a741d4037f2d7225$var$_createReactClass2 = $a741d4037f2d7225$var$_interopRequireDefault($5JTQC);

var $e29jL = parcelRequire("e29jL");
var $a741d4037f2d7225$var$_ListOption2 = $a741d4037f2d7225$var$_interopRequireDefault($e29jL);

var $8v4NT = parcelRequire("8v4NT");
var $a741d4037f2d7225$var$_propTypes4 = $a741d4037f2d7225$var$_interopRequireDefault($8v4NT);

var $96zKa = parcelRequire("96zKa");
var $a741d4037f2d7225$var$_compat2 = $a741d4037f2d7225$var$_interopRequireDefault($96zKa);

var $ksXgP = parcelRequire("ksXgP");
var $a741d4037f2d7225$var$_classnames2 = $a741d4037f2d7225$var$_interopRequireDefault($ksXgP);

var $4cOpg = parcelRequire("4cOpg");
var $a741d4037f2d7225$var$_3 = $a741d4037f2d7225$var$_interopRequireDefault($4cOpg);

var $3Y3Be = parcelRequire("3Y3Be");

var $b6t9X = parcelRequire("b6t9X");

var $7RxtH = parcelRequire("7RxtH");
function $a741d4037f2d7225$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a741d4037f2d7225$var$optionId = function optionId(id, idx) {
    return id + "__option__" + idx;
};


module.exports.default = (0, $a741d4037f2d7225$var$_createReactClass2.default)({
    displayName: "List",
    mixins: [
        (parcelRequire("6SWik")),
        (parcelRequire("9AXXZ"))()
    ],
    propTypes: {
        data: $a741d4037f2d7225$var$_propTypes2.default.array,
        onSelect: $a741d4037f2d7225$var$_propTypes2.default.func,
        onMove: $a741d4037f2d7225$var$_propTypes2.default.func,
        optionComponent: $a741d4037f2d7225$var$_propTypes4.default.elementType,
        itemComponent: $a741d4037f2d7225$var$_propTypes4.default.elementType,
        selected: $a741d4037f2d7225$var$_propTypes2.default.any,
        focused: $a741d4037f2d7225$var$_propTypes2.default.any,
        valueField: $a741d4037f2d7225$var$_propTypes4.default.accessor,
        textField: $a741d4037f2d7225$var$_propTypes4.default.accessor,
        disabled: $a741d4037f2d7225$var$_propTypes4.default.disabled.acceptsArray,
        readOnly: $a741d4037f2d7225$var$_propTypes4.default.readOnly.acceptsArray,
        messages: $a741d4037f2d7225$var$_propTypes2.default.shape({
            emptyList: $a741d4037f2d7225$var$_propTypes4.default.message
        })
    },
    getDefaultProps: function getDefaultProps() {
        return {
            onSelect: function onSelect() {},
            optionComponent: $a741d4037f2d7225$var$_ListOption2.default,
            ariaActiveDescendantKey: "list",
            data: [],
            messages: {
                emptyList: "There are no items in this list"
            }
        };
    },
    componentDidMount: function componentDidMount() {
        this.move();
    },
    componentDidUpdate: function componentDidUpdate() {
        var _props = this.props, data = _props.data, focused = _props.focused, idx = data.indexOf(focused), activeId = $a741d4037f2d7225$var$optionId((0, $b6t9X.instanceId)(this), idx);
        this.ariaActiveDescendant(idx !== -1 ? activeId : null);
        this.move();
    },
    render: function render() {
        var _this = this;
        var _props2 = this.props, className = _props2.className, role = _props2.role, data = _props2.data, textField = _props2.textField, valueField = _props2.valueField, focused = _props2.focused, selected = _props2.selected, messages = _props2.messages, onSelect = _props2.onSelect, ItemComponent = _props2.itemComponent, Option = _props2.optionComponent;
        var id = (0, $b6t9X.instanceId)(this), items = void 0;
        var elementProps = $a741d4037f2d7225$var$_3.default.omitOwnProps(this);
        items = !data.length ? $a741d4037f2d7225$var$_react2.default.createElement("li", {
            className: "rw-list-empty"
        }, $a741d4037f2d7225$var$_3.default.result(messages.emptyList, this.props)) : data.map(function(item, idx) {
            var currentId = $a741d4037f2d7225$var$optionId(id, idx), isDisabled = (0, $7RxtH.isDisabledItem)(item, _this.props), isReadOnly = (0, $7RxtH.isReadOnlyItem)(item, _this.props);
            return $a741d4037f2d7225$var$_react2.default.createElement(Option, {
                key: "item_" + idx,
                id: currentId,
                dataItem: item,
                disabled: isDisabled,
                readOnly: isReadOnly,
                focused: focused === item,
                selected: selected === item,
                onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
            }, ItemComponent ? $a741d4037f2d7225$var$_react2.default.createElement(ItemComponent, {
                item: item,
                value: (0, $3Y3Be.dataValue)(item, valueField),
                text: (0, $3Y3Be.dataText)(item, textField),
                disabled: isDisabled,
                readOnly: isReadOnly
            }) : (0, $3Y3Be.dataText)(item, textField));
        });
        return $a741d4037f2d7225$var$_react2.default.createElement("ul", $a741d4037f2d7225$var$_extends({
            id: id,
            tabIndex: "-1",
            className: (0, $a741d4037f2d7225$var$_classnames2.default)(className, "rw-list"),
            role: role === undefined ? "listbox" : role
        }, elementProps), items);
    },
    _data: function _data() {
        return this.props.data;
    },
    move: function move() {
        var list = $a741d4037f2d7225$var$_compat2.default.findDOMNode(this), idx = this._data().indexOf(this.props.focused), selected = list.children[idx];
        if (!selected) return;
        (0, $b6t9X.notify)(this.props.onMove, [
            selected,
            list,
            this.props.focused
        ]);
    }
});
module.exports = module.exports["default"];

});
parcelRegister("e29jL", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $a3787ae6aa8e965f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $a3787ae6aa8e965f$var$_react2 = $a3787ae6aa8e965f$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $a3787ae6aa8e965f$var$_propTypes2 = $a3787ae6aa8e965f$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $a3787ae6aa8e965f$var$_createReactClass2 = $a3787ae6aa8e965f$var$_interopRequireDefault($5JTQC);

var $ksXgP = parcelRequire("ksXgP");
var $a3787ae6aa8e965f$var$_classnames2 = $a3787ae6aa8e965f$var$_interopRequireDefault($ksXgP);

var $4cOpg = parcelRequire("4cOpg");
var $a3787ae6aa8e965f$var$_3 = $a3787ae6aa8e965f$var$_interopRequireDefault($4cOpg);
function $a3787ae6aa8e965f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a3787ae6aa8e965f$var$ListOption = (0, $a3787ae6aa8e965f$var$_createReactClass2.default)({
    displayName: "ListOption",
    propTypes: {
        dataItem: $a3787ae6aa8e965f$var$_propTypes2.default.any,
        focused: $a3787ae6aa8e965f$var$_propTypes2.default.bool,
        selected: $a3787ae6aa8e965f$var$_propTypes2.default.bool,
        disabled: $a3787ae6aa8e965f$var$_propTypes2.default.bool,
        readOnly: $a3787ae6aa8e965f$var$_propTypes2.default.bool
    },
    render: function render() {
        var _props = this.props, className = _props.className, children = _props.children, focused = _props.focused, selected = _props.selected, disabled = _props.disabled, readOnly = _props.readOnly;
        var props = $a3787ae6aa8e965f$var$_3.default.omitOwnProps(this);
        var classes = {
            "rw-state-focus": focused,
            "rw-state-selected": selected,
            "rw-state-disabled": disabled,
            "rw-state-readonly": readOnly
        };
        return $a3787ae6aa8e965f$var$_react2.default.createElement("li", $a3787ae6aa8e965f$var$_extends({
            role: "option",
            tabIndex: !(disabled || readOnly) ? "-1" : undefined,
            "aria-selected": !!selected,
            className: (0, $a3787ae6aa8e965f$var$_classnames2.default)("rw-list-option", className, classes)
        }, props), children);
    }
});
module.exports.default = $a3787ae6aa8e965f$var$ListOption;
module.exports = module.exports["default"];

});

parcelRegister("b6t9X", function(module, exports) {

$parcel$export(module.exports, "notify", function () { return $8156dfb9b3121617$export$5e14cdade93d6f7b; }, function (v) { return $8156dfb9b3121617$export$5e14cdade93d6f7b = v; });
$parcel$export(module.exports, "instanceId", function () { return $8156dfb9b3121617$export$ccd86612c5e58cc1; }, function (v) { return $8156dfb9b3121617$export$ccd86612c5e58cc1 = v; });
$parcel$export(module.exports, "isFirstFocusedRender", function () { return $8156dfb9b3121617$export$bd6a1ea09c5c68cd; }, function (v) { return $8156dfb9b3121617$export$bd6a1ea09c5c68cd = v; });
var $8156dfb9b3121617$export$1e511d4a378977f5;
var $8156dfb9b3121617$export$5e14cdade93d6f7b;
var $8156dfb9b3121617$export$ccd86612c5e58cc1;
var $8156dfb9b3121617$export$bd6a1ea09c5c68cd;
"use strict";
$8156dfb9b3121617$export$1e511d4a378977f5 = true;
$8156dfb9b3121617$export$5e14cdade93d6f7b = $8156dfb9b3121617$var$notify;
$8156dfb9b3121617$export$ccd86612c5e58cc1 = $8156dfb9b3121617$var$instanceId;
$8156dfb9b3121617$export$bd6a1ea09c5c68cd = $8156dfb9b3121617$var$isFirstFocusedRender;

var $4cOpg = parcelRequire("4cOpg");
function $8156dfb9b3121617$var$notify(handler, args) {
    handler && handler.apply(null, [].concat(args));
}
function $8156dfb9b3121617$var$instanceId(component) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    component.__id || (component.__id = (0, $4cOpg.uniqueId)("rw_"));
    return (component.props.id || component.__id) + suffix;
}
function $8156dfb9b3121617$var$isFirstFocusedRender(component) {
    return component._firstFocus || component.state.focused && (component._firstFocus = true);
}

});

parcelRegister("7RxtH", function(module, exports) {

$parcel$export(module.exports, "widgetEditable", function () { return $5b9773b144eda2ef$export$7c01345218365f30; }, function (v) { return $5b9773b144eda2ef$export$7c01345218365f30 = v; });
$parcel$export(module.exports, "widgetEnabled", function () { return $5b9773b144eda2ef$export$18bcbbf0c0ffc49a; }, function (v) { return $5b9773b144eda2ef$export$18bcbbf0c0ffc49a = v; });
$parcel$export(module.exports, "isDisabled", function () { return $5b9773b144eda2ef$export$30e0dc115df457ed; }, function (v) { return $5b9773b144eda2ef$export$30e0dc115df457ed = v; });
$parcel$export(module.exports, "isReadOnly", function () { return $5b9773b144eda2ef$export$2498094d90b6ac72; }, function (v) { return $5b9773b144eda2ef$export$2498094d90b6ac72 = v; });
$parcel$export(module.exports, "isDisabledItem", function () { return $5b9773b144eda2ef$export$f4ef2e7dd004d142; }, function (v) { return $5b9773b144eda2ef$export$f4ef2e7dd004d142 = v; });
$parcel$export(module.exports, "isReadOnlyItem", function () { return $5b9773b144eda2ef$export$afabd9ff1a0663e5; }, function (v) { return $5b9773b144eda2ef$export$afabd9ff1a0663e5 = v; });
$parcel$export(module.exports, "contains", function () { return $5b9773b144eda2ef$export$2344b14b097df817; }, function (v) { return $5b9773b144eda2ef$export$2344b14b097df817 = v; });
var $5b9773b144eda2ef$export$1e511d4a378977f5;
var $5b9773b144eda2ef$export$7c01345218365f30;
var $5b9773b144eda2ef$export$18bcbbf0c0ffc49a;
var $5b9773b144eda2ef$export$30e0dc115df457ed;
var $5b9773b144eda2ef$export$2498094d90b6ac72;
var $5b9773b144eda2ef$export$f4ef2e7dd004d142;
var $5b9773b144eda2ef$export$afabd9ff1a0663e5;
var $5b9773b144eda2ef$export$2344b14b097df817;
var $5b9773b144eda2ef$export$d947e5f4f4c48d48;
"use strict";
$5b9773b144eda2ef$export$1e511d4a378977f5 = true;
$5b9773b144eda2ef$export$7c01345218365f30 = $5b9773b144eda2ef$export$18bcbbf0c0ffc49a = undefined;
$5b9773b144eda2ef$export$30e0dc115df457ed = $5b9773b144eda2ef$var$isDisabled;
$5b9773b144eda2ef$export$2498094d90b6ac72 = $5b9773b144eda2ef$var$isReadOnly;
$5b9773b144eda2ef$export$f4ef2e7dd004d142 = $5b9773b144eda2ef$var$isDisabledItem;
$5b9773b144eda2ef$export$afabd9ff1a0663e5 = $5b9773b144eda2ef$var$isReadOnlyItem;
$5b9773b144eda2ef$export$2344b14b097df817 = $5b9773b144eda2ef$var$contains;
$5b9773b144eda2ef$export$d947e5f4f4c48d48 = $5b9773b144eda2ef$var$move;

var $3Y3Be = parcelRequire("3Y3Be");
function $5b9773b144eda2ef$var$isDisabled(props) {
    return props.disabled === true || props.disabled === "disabled";
}
function $5b9773b144eda2ef$var$isReadOnly(props) {
    return props.readOnly === true || props.readOnly === "readOnly";
}
function $5b9773b144eda2ef$var$isDisabledItem(item, props) {
    return $5b9773b144eda2ef$var$isDisabled(props) || $5b9773b144eda2ef$var$contains(item, props.disabled, props.valueField);
}
function $5b9773b144eda2ef$var$isReadOnlyItem(item, props) {
    return $5b9773b144eda2ef$var$isReadOnly(props) || $5b9773b144eda2ef$var$contains(item, props.readOnly, props.valueField);
}
function $5b9773b144eda2ef$var$contains(item, values, valueField) {
    return Array.isArray(values) ? values.some(function(value) {
        return (0, $3Y3Be.valueMatcher)(item, value, valueField);
    }) : (0, $3Y3Be.valueMatcher)(item, values, valueField);
}
function $5b9773b144eda2ef$var$move(dir, item, props, list) {
    var isDisabledOrReadonly = function isDisabledOrReadonly(item) {
        return $5b9773b144eda2ef$var$isDisabledItem(item, props) || $5b9773b144eda2ef$var$isReadOnlyItem(item, props);
    }, stop = dir === "next" ? list.last() : list.first(), next = list[dir](item);
    while(next !== stop && isDisabledOrReadonly(next))next = list[dir](next);
    return isDisabledOrReadonly(next) ? item : next;
}
var $5b9773b144eda2ef$var$widgetEnabled = $5b9773b144eda2ef$export$18bcbbf0c0ffc49a = $5b9773b144eda2ef$var$interactionDecorator(true);
var $5b9773b144eda2ef$var$widgetEditable = $5b9773b144eda2ef$export$7c01345218365f30 = $5b9773b144eda2ef$var$interactionDecorator(false);
function $5b9773b144eda2ef$var$interactionDecorator(disabledOnly) {
    function wrap(method) {
        return function decoratedMethod() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!($5b9773b144eda2ef$var$isDisabled(this.props) || !disabledOnly && $5b9773b144eda2ef$var$isReadOnly(this.props))) return method.apply(this, args);
        };
    }
    return function decorate(target, key, desc) {
        if (desc.initializer) {
            var init = desc.initializer;
            desc.initializer = function() {
                return wrap(init());
            };
        } else desc.value = wrap(desc.value);
        return desc;
    };
}

});

parcelRegister("6SWik", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $lUHFm = parcelRequire("lUHFm");
var $50350156992c78c7$var$_filter2 = $50350156992c78c7$var$_interopRequireDefault($lUHFm);

var $3Y3Be = parcelRequire("3Y3Be");

var $8v4NT = parcelRequire("8v4NT");
var $50350156992c78c7$var$_propTypes2 = $50350156992c78c7$var$_interopRequireDefault($8v4NT);

var $7RxtH = parcelRequire("7RxtH");
function $50350156992c78c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $50350156992c78c7$var$EMPTY_VALUE = {};
var $50350156992c78c7$var$isDisabledOrReadonly = function isDisabledOrReadonly(item, props) {
    return (0, $7RxtH.isDisabledItem)(item, props) || (0, $7RxtH.isReadOnlyItem)(item, props);
};
module.exports.default = {
    propTypes: {
        textField: $50350156992c78c7$var$_propTypes2.default.accessor,
        valueField: $50350156992c78c7$var$_propTypes2.default.accessor,
        disabled: $50350156992c78c7$var$_propTypes2.default.disabled.acceptsArray,
        readOnly: $50350156992c78c7$var$_propTypes2.default.readOnly.acceptsArray
    },
    first: function first() {
        return this.next($50350156992c78c7$var$EMPTY_VALUE);
    },
    last: function last() {
        var data = this._data(), item = data[data.length - 1];
        return $50350156992c78c7$var$isDisabledOrReadonly(item, this.props) ? this.prev(item) : item;
    },
    prev: function prev(item, word) {
        var data = this._data(), nextIdx = data.indexOf(item), matches = $50350156992c78c7$var$matcher(word, item, this.props.textField);
        if (nextIdx < 0 || nextIdx == null) nextIdx = 0;
        nextIdx--;
        while(nextIdx > -1 && ($50350156992c78c7$var$isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx])))nextIdx--;
        return nextIdx >= 0 ? data[nextIdx] : item;
    },
    next: function next(item, word) {
        var data = this._data(), nextIdx = data.indexOf(item) + 1, len = data.length, matches = $50350156992c78c7$var$matcher(word, item, this.props.textField);
        while(nextIdx < len && ($50350156992c78c7$var$isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx])))nextIdx++;
        return nextIdx < len ? data[nextIdx] : item;
    }
};
function $50350156992c78c7$var$matcher(word, item, textField) {
    if (!word) return function() {
        return true;
    };
    word = word.toLowerCase();
    return function(item) {
        return $50350156992c78c7$var$_filter2.default.startsWith((0, $3Y3Be.dataText)(item, textField).toLowerCase(), word);
    };
}
module.exports = module.exports["default"];

});

parcelRegister("9AXXZ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = function(nodeOrComponent) {
    var reconcileChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $6fc5fdf1c1a0823b$var$defaultReconcile;
    return {
        propTypes: {
            ariaActiveDescendantKey: $6fc5fdf1c1a0823b$var$_propTypes2.default.string.isRequired
        },
        contextTypes: {
            activeDescendants: $6fc5fdf1c1a0823b$var$shape
        },
        childContextTypes: {
            activeDescendants: $6fc5fdf1c1a0823b$var$shape
        },
        ariaActiveDescendant: function ariaActiveDescendant(id) {
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.ariaActiveDescendantKey;
            var activeDescendants = this.context.activeDescendants;
            var current = this.__ariaActiveDescendantId;
            if (id === undefined) return current;
            id = reconcileChildren.call(this, key, id);
            if (id === undefined) id = current;
            else {
                this.__ariaActiveDescendantId = id;
                $6fc5fdf1c1a0823b$var$flushAriaToNode(id, nodeOrComponent, this);
            }
            activeDescendants && activeDescendants.reconcile(key, id);
        },
        getChildContext: function getChildContext() {
            var _this = this;
            return this._context || (this._context = {
                activeDescendants: {
                    reconcile: function reconcile(key, id) {
                        return _this.ariaActiveDescendant(id, key);
                    }
                }
            });
        }
    };
};

var $S29Lp = parcelRequire("S29Lp");
var $6fc5fdf1c1a0823b$var$_propTypes2 = $6fc5fdf1c1a0823b$var$_interopRequireDefault($S29Lp);

var $96zKa = parcelRequire("96zKa");
var $6fc5fdf1c1a0823b$var$_compat2 = $6fc5fdf1c1a0823b$var$_interopRequireDefault($96zKa);
function $6fc5fdf1c1a0823b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6fc5fdf1c1a0823b$var$shape = $6fc5fdf1c1a0823b$var$_propTypes2.default.shape({
    //setActive: PropTypes.func,
    reconcile: $6fc5fdf1c1a0823b$var$_propTypes2.default.func
});
function $6fc5fdf1c1a0823b$var$defaultReconcile(key, id) {
    return id;
}
function $6fc5fdf1c1a0823b$var$flushAriaToNode(id, nodeOrComponent, ctx) {
    var node = typeof nodeOrComponent === "function" ? nodeOrComponent(ctx) : typeof nodeOrComponent === "string" ? ctx.refs[nodeOrComponent] : ctx;
    if (node) {
        if (id) $6fc5fdf1c1a0823b$var$_compat2.default.findDOMNode(node).setAttribute("aria-activedescendant", id);
        else $6fc5fdf1c1a0823b$var$_compat2.default.findDOMNode(node).removeAttribute("aria-activedescendant");
    }
}
module.exports = module.exports["default"];

});


parcelRegister("bp2Lh", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $84d42be8ebd6a4d3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $84d42be8ebd6a4d3$var$_react2 = $84d42be8ebd6a4d3$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $84d42be8ebd6a4d3$var$_propTypes2 = $84d42be8ebd6a4d3$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $84d42be8ebd6a4d3$var$_createReactClass2 = $84d42be8ebd6a4d3$var$_interopRequireDefault($5JTQC);

var $e29jL = parcelRequire("e29jL");
var $84d42be8ebd6a4d3$var$_ListOption2 = $84d42be8ebd6a4d3$var$_interopRequireDefault($e29jL);

var $8v4NT = parcelRequire("8v4NT");
var $84d42be8ebd6a4d3$var$_propTypes4 = $84d42be8ebd6a4d3$var$_interopRequireDefault($8v4NT);

var $96zKa = parcelRequire("96zKa");
var $84d42be8ebd6a4d3$var$_compat2 = $84d42be8ebd6a4d3$var$_interopRequireDefault($96zKa);

var $ksXgP = parcelRequire("ksXgP");
var $84d42be8ebd6a4d3$var$_classnames2 = $84d42be8ebd6a4d3$var$_interopRequireDefault($ksXgP);

var $4cOpg = parcelRequire("4cOpg");
var $84d42be8ebd6a4d3$var$_3 = $84d42be8ebd6a4d3$var$_interopRequireDefault($4cOpg);

var $8cKrz = parcelRequire("8cKrz");
var $84d42be8ebd6a4d3$var$_warning2 = $84d42be8ebd6a4d3$var$_interopRequireDefault($8cKrz);

var $3Y3Be = parcelRequire("3Y3Be");

var $b6t9X = parcelRequire("b6t9X");

var $7RxtH = parcelRequire("7RxtH");
function $84d42be8ebd6a4d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $84d42be8ebd6a4d3$var$optionId = function optionId(id, idx) {
    return id + "__option__" + idx;
};


module.exports.default = (0, $84d42be8ebd6a4d3$var$_createReactClass2.default)({
    displayName: "List",
    mixins: [
        (parcelRequire("6SWik")),
        (parcelRequire("9AXXZ"))()
    ],
    propTypes: {
        data: $84d42be8ebd6a4d3$var$_propTypes2.default.array,
        onSelect: $84d42be8ebd6a4d3$var$_propTypes2.default.func,
        onMove: $84d42be8ebd6a4d3$var$_propTypes2.default.func,
        optionComponent: $84d42be8ebd6a4d3$var$_propTypes4.default.elementType,
        itemComponent: $84d42be8ebd6a4d3$var$_propTypes4.default.elementType,
        groupComponent: $84d42be8ebd6a4d3$var$_propTypes4.default.elementType,
        selected: $84d42be8ebd6a4d3$var$_propTypes2.default.any,
        focused: $84d42be8ebd6a4d3$var$_propTypes2.default.any,
        valueField: $84d42be8ebd6a4d3$var$_propTypes4.default.accessor,
        textField: $84d42be8ebd6a4d3$var$_propTypes4.default.accessor,
        disabled: $84d42be8ebd6a4d3$var$_propTypes4.default.disabled.acceptsArray,
        readOnly: $84d42be8ebd6a4d3$var$_propTypes4.default.readOnly.acceptsArray,
        groupBy: $84d42be8ebd6a4d3$var$_propTypes4.default.accessor,
        messages: $84d42be8ebd6a4d3$var$_propTypes2.default.shape({
            emptyList: $84d42be8ebd6a4d3$var$_propTypes4.default.message
        })
    },
    getDefaultProps: function getDefaultProps() {
        return {
            onSelect: function onSelect() {},
            data: [],
            optionComponent: $84d42be8ebd6a4d3$var$_ListOption2.default,
            ariaActiveDescendantKey: "groupedList",
            messages: {
                emptyList: "There are no items in this list"
            }
        };
    },
    getInitialState: function getInitialState() {
        var keys = [];
        return {
            groups: this._group(this.props.groupBy, this.props.data, keys),
            sortedKeys: keys
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var keys = [];
        if (nextProps.data !== this.props.data || nextProps.groupBy !== this.props.groupBy) this.setState({
            groups: this._group(nextProps.groupBy, nextProps.data, keys),
            sortedKeys: keys
        });
    },
    componentDidMount: function componentDidMount() {
        this.move();
    },
    componentDidUpdate: function componentDidUpdate() {
        this.ariaActiveDescendant(this._currentActiveID);
        this.move();
    },
    render: function render() {
        var _this = this;
        var _props = this.props, className = _props.className, role = _props.role, data = _props.data, messages = _props.messages;
        var _state = this.state, sortedKeys = _state.sortedKeys, groups = _state.groups;
        var elementProps = $84d42be8ebd6a4d3$var$_3.default.omitOwnProps(this);
        var items = [], idx = -1, group = void 0;
        var id = (0, $b6t9X.instanceId)(this);
        this._currentActiveID = null;
        if (data.length) items = sortedKeys.reduce(function(items, key) {
            group = groups[key];
            items.push(_this._renderGroupHeader(key));
            for(var itemIdx = 0; itemIdx < group.length; itemIdx++)items.push(_this._renderItem(key, group[itemIdx], ++idx));
            return items;
        }, []);
        else items = $84d42be8ebd6a4d3$var$_react2.default.createElement("li", {
            className: "rw-list-empty"
        }, $84d42be8ebd6a4d3$var$_3.default.result(messages.emptyList, this.props));
        return $84d42be8ebd6a4d3$var$_react2.default.createElement("ul", $84d42be8ebd6a4d3$var$_extends({
            ref: "scrollable",
            id: id,
            tabIndex: "-1",
            className: (0, $84d42be8ebd6a4d3$var$_classnames2.default)(className, "rw-list", "rw-list-grouped"),
            role: role === undefined ? "listbox" : role
        }, elementProps), items);
    },
    _renderGroupHeader: function _renderGroupHeader(group) {
        var GroupComponent = this.props.groupComponent, id = (0, $b6t9X.instanceId)(this);
        return $84d42be8ebd6a4d3$var$_react2.default.createElement("li", {
            key: "item_" + group,
            tabIndex: "-1",
            role: "separator",
            id: id + "_group_" + group,
            className: "rw-list-optgroup"
        }, GroupComponent ? $84d42be8ebd6a4d3$var$_react2.default.createElement(GroupComponent, {
            item: group
        }) : group);
    },
    _renderItem: function _renderItem(group, item, idx) {
        var _props2 = this.props, focused = _props2.focused, selected = _props2.selected, onSelect = _props2.onSelect, textField = _props2.textField, valueField = _props2.valueField, ItemComponent = _props2.itemComponent, Option = _props2.optionComponent;
        var currentID = $84d42be8ebd6a4d3$var$optionId((0, $b6t9X.instanceId)(this), idx), isDisabled = (0, $7RxtH.isDisabledItem)(item, this.props), isReadOnly = (0, $7RxtH.isReadOnlyItem)(item, this.props);
        if (focused === item) this._currentActiveID = currentID;
        return $84d42be8ebd6a4d3$var$_react2.default.createElement(Option, {
            key: "item_" + group + "_" + idx,
            id: currentID,
            dataItem: item,
            focused: focused === item,
            selected: selected === item,
            disabled: isDisabled,
            readOnly: isReadOnly,
            onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
        }, ItemComponent ? $84d42be8ebd6a4d3$var$_react2.default.createElement(ItemComponent, {
            item: item,
            value: (0, $3Y3Be.dataValue)(item, valueField),
            text: (0, $3Y3Be.dataText)(item, textField),
            disabled: isDisabled,
            readOnly: isReadOnly
        }) : (0, $3Y3Be.dataText)(item, textField));
    },
    _isIndexOf: function _isIndexOf(idx, item) {
        return this.props.data[idx] === item;
    },
    _group: function _group(groupBy, data, keys) {
        var iter = typeof groupBy === "function" ? groupBy : function(item) {
            return item[groupBy];
        };
        // the keys array ensures that groups are rendered in the order they came in
        // which means that if you sort the data array it will render sorted,
        // so long as you also sorted by group
        keys = keys || [];
        (0, $84d42be8ebd6a4d3$var$_warning2.default)(typeof groupBy !== "string" || !data.length || $84d42be8ebd6a4d3$var$_3.default.has(data[0], groupBy), "[React Widgets] You seem to be trying to group this list by a " + ("property `" + groupBy + "` that doesn't exist in the dataset items, this may be a typo"));
        return data.reduce(function(grps, item) {
            var group = iter(item);
            $84d42be8ebd6a4d3$var$_3.default.has(grps, group) ? grps[group].push(item) : (keys.push(group), grps[group] = [
                item
            ]);
            return grps;
        }, {});
    },
    _data: function _data() {
        var groups = this.state.groups;
        return this.state.sortedKeys.reduce(function(flat, grp) {
            return flat.concat(groups[grp]);
        }, []);
    },
    move: function move() {
        var selected = this.getItemDOMNode(this.props.focused);
        if (!selected) return;
        (0, $b6t9X.notify)(this.props.onMove, [
            selected,
            $84d42be8ebd6a4d3$var$_compat2.default.findDOMNode(this),
            this.props.focused
        ]);
    },
    getItemDOMNode: function getItemDOMNode(item) {
        var list = $84d42be8ebd6a4d3$var$_compat2.default.findDOMNode(this), groups = this.state.groups, idx = -1, itemIdx, child;
        this.state.sortedKeys.some(function(group) {
            itemIdx = groups[group].indexOf(item);
            idx++;
            if (itemIdx !== -1) return !!(child = list.children[idx + itemIdx + 1]);
            idx += groups[group].length;
        });
        return child;
    }
});
module.exports = module.exports["default"];

});
parcelRegister("8cKrz", function(module, exports) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $5f937877cd123034$var$warning = function() {};
module.exports = $5f937877cd123034$var$warning;

});


parcelRegister("jQzQU", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $e72eaf30ea6650fb$var$validateListComponent;

var $ibnnr = parcelRequire("ibnnr");
var $e72eaf30ea6650fb$var$_invariant2 = $e72eaf30ea6650fb$var$_interopRequireDefault($ibnnr);
function $e72eaf30ea6650fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e72eaf30ea6650fb$var$METHODS = [
    "next",
    "prev",
    "first",
    "last"
];
function $e72eaf30ea6650fb$var$validateListComponent(list) {}
module.exports = module.exports["default"];

});

parcelRegister("7iIDV", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $8GVbg = parcelRequire("8GVbg");
var $550cd80444899e82$var$_createUncontrollable2 = $550cd80444899e82$var$_interopRequireDefault($8GVbg);
function $550cd80444899e82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $550cd80444899e82$var$mixin = {
    shouldComponentUpdate: function shouldComponentUpdate() {
        //let the forceUpdate trigger the update
        return !this._notifying;
    }
};
function $550cd80444899e82$var$set(component, propName, handler, value, args) {
    if (handler) {
        component._notifying = true;
        handler.call.apply(handler, [
            component,
            value
        ].concat(args));
        component._notifying = false;
    }
    component._values[propName] = value;
    if (!component.unmounted) component.forceUpdate();
}
module.exports.default = (0, $550cd80444899e82$var$_createUncontrollable2.default)($550cd80444899e82$var$mixin, $550cd80444899e82$var$set);
module.exports = module.exports["default"];

});
parcelRegister("8GVbg", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $653e99e080fcde22$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.default = $653e99e080fcde22$var$createUncontrollable;

var $7PdBe = parcelRequire("7PdBe");
var $653e99e080fcde22$var$_react2 = $653e99e080fcde22$var$_interopRequireDefault($7PdBe);

var $ibnnr = parcelRequire("ibnnr");
var $653e99e080fcde22$var$_invariant2 = $653e99e080fcde22$var$_interopRequireDefault($ibnnr);

var $3s1Lf = parcelRequire("3s1Lf");
var $653e99e080fcde22$var$utils = $653e99e080fcde22$var$_interopRequireWildcard($3s1Lf);
function $653e99e080fcde22$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $653e99e080fcde22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $653e99e080fcde22$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $653e99e080fcde22$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $653e99e080fcde22$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $653e99e080fcde22$var$createUncontrollable(mixin, set) {
    return uncontrollable;
    function uncontrollable(Component, controlledValues) {
        var _class, _temp;
        var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var displayName = Component.displayName || Component.name || "Component", basePropTypes = $653e99e080fcde22$var$utils.getType(Component).propTypes, isCompositeComponent = $653e99e080fcde22$var$utils.isReactComponent(Component), controlledProps = Object.keys(controlledValues), propTypes;
        var OMIT_PROPS = [
            "valueLink",
            "checkedLink"
        ].concat(controlledProps.map($653e99e080fcde22$var$utils.defaultKey));
        propTypes = $653e99e080fcde22$var$utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
        (0, $653e99e080fcde22$var$_invariant2.default)(isCompositeComponent || !methods.length, "[uncontrollable] stateless function components cannot pass through methods because they have no associated instances. Check component: " + displayName + ", " + "attempting to pass through methods: " + methods.join(", "));
        methods = $653e99e080fcde22$var$utils.transform(methods, function(obj, method) {
            obj[method] = function() {
                var _refs$inner;
                return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
            };
        }, {});
        var component = (_temp = _class = function(_React$Component) {
            $653e99e080fcde22$var$_inherits(component, _React$Component);
            function component() {
                $653e99e080fcde22$var$_classCallCheck(this, component);
                return $653e99e080fcde22$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
            }
            component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
                for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
            };
            component.prototype.componentWillMount = function componentWillMount() {
                var _this2 = this;
                var props = this.props;
                this._values = {};
                controlledProps.forEach(function(key) {
                    _this2._values[key] = props[$653e99e080fcde22$var$utils.defaultKey(key)];
                });
            };
            /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */ component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
                var _this3 = this;
                var props = this.props;
                if (mixin.componentWillReceiveProps) mixin.componentWillReceiveProps.call(this, nextProps);
                controlledProps.forEach(function(key) {
                    if ($653e99e080fcde22$var$utils.getValue(nextProps, key) === undefined && $653e99e080fcde22$var$utils.getValue(props, key) !== undefined) _this3._values[key] = nextProps[$653e99e080fcde22$var$utils.defaultKey(key)];
                });
            };
            component.prototype.componentWillUnmount = function componentWillUnmount() {
                this.unmounted = true;
            };
            component.prototype.getControlledInstance = function getControlledInstance() {
                return this.refs.inner;
            };
            component.prototype.render = function render() {
                var _this4 = this;
                var newProps = {}, props = omitProps(this.props);
                $653e99e080fcde22$var$utils.each(controlledValues, function(handle, propName) {
                    var linkPropName = $653e99e080fcde22$var$utils.getLinkName(propName), prop = _this4.props[propName];
                    if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) prop = _this4.props[linkPropName].value;
                    newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
                    newProps[handle] = setAndNotify.bind(_this4, propName);
                });
                newProps = $653e99e080fcde22$var$_extends({}, props, newProps, {
                    ref: isCompositeComponent ? "inner" : null
                });
                return $653e99e080fcde22$var$_react2.default.createElement(Component, newProps);
            };
            return component;
        }($653e99e080fcde22$var$_react2.default.Component), _class.displayName = "Uncontrolled(" + displayName + ")", _class.propTypes = propTypes, _temp);
        $653e99e080fcde22$var$_extends(component.prototype, methods);
        component.ControlledComponent = Component;
        /**
     * useful when wrapping a Component and you want to control
     * everything
     */ component.deferControlTo = function(newComponent) {
            var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var nextMethods = arguments[2];
            return uncontrollable(newComponent, $653e99e080fcde22$var$_extends({}, controlledValues, additions), nextMethods);
        };
        return component;
        function setAndNotify(propName, value) {
            var linkName = $653e99e080fcde22$var$utils.getLinkName(propName), handler = this.props[controlledValues[propName]];
            if (linkName && isProp(this.props, linkName) && !handler) handler = this.props[linkName].requestChange;
            for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
            set(this, propName, handler, value, args);
        }
        function isProp(props, prop) {
            return props[prop] !== undefined;
        }
        function omitProps(props) {
            var result = {};
            $653e99e080fcde22$var$utils.each(props, function(value, key) {
                if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
            });
            return result;
        }
    }
}
module.exports = module.exports["default"];

});
parcelRegister("3s1Lf", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $28355a5b5044dab5$export$1e511d4a378977f5; }, function (v) { return $28355a5b5044dab5$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "version", function () { return $28355a5b5044dab5$export$83d89fbfd8236492; }, function (v) { return $28355a5b5044dab5$export$83d89fbfd8236492 = v; });
$parcel$export(module.exports, "uncontrolledPropTypes", function () { return $28355a5b5044dab5$export$8abd944bed26e726; }, function (v) { return $28355a5b5044dab5$export$8abd944bed26e726 = v; });
$parcel$export(module.exports, "getType", function () { return $28355a5b5044dab5$export$e2b5c5db9e2009fd; }, function (v) { return $28355a5b5044dab5$export$e2b5c5db9e2009fd = v; });
$parcel$export(module.exports, "getValue", function () { return $28355a5b5044dab5$export$bf7199a9ebcb84a9; }, function (v) { return $28355a5b5044dab5$export$bf7199a9ebcb84a9 = v; });
$parcel$export(module.exports, "getLinkName", function () { return $28355a5b5044dab5$export$7b848b49fe0c4510; }, function (v) { return $28355a5b5044dab5$export$7b848b49fe0c4510 = v; });
$parcel$export(module.exports, "defaultKey", function () { return $28355a5b5044dab5$export$26cbf8c37e721e67; }, function (v) { return $28355a5b5044dab5$export$26cbf8c37e721e67 = v; });
$parcel$export(module.exports, "chain", function () { return $28355a5b5044dab5$export$e08e3b67e392101e; }, function (v) { return $28355a5b5044dab5$export$e08e3b67e392101e = v; });
$parcel$export(module.exports, "transform", function () { return $28355a5b5044dab5$export$51186ad6e864892a; }, function (v) { return $28355a5b5044dab5$export$51186ad6e864892a = v; });
$parcel$export(module.exports, "each", function () { return $28355a5b5044dab5$export$79b2f7037acddd43; }, function (v) { return $28355a5b5044dab5$export$79b2f7037acddd43 = v; });
$parcel$export(module.exports, "has", function () { return $28355a5b5044dab5$export$a4f4bb6b1453fff5; }, function (v) { return $28355a5b5044dab5$export$a4f4bb6b1453fff5 = v; });
$parcel$export(module.exports, "isReactComponent", function () { return $28355a5b5044dab5$export$51d570c6883e4310; }, function (v) { return $28355a5b5044dab5$export$51d570c6883e4310 = v; });
var $28355a5b5044dab5$export$1e511d4a378977f5;
var $28355a5b5044dab5$export$83d89fbfd8236492;
var $28355a5b5044dab5$export$8abd944bed26e726;
var $28355a5b5044dab5$export$e2b5c5db9e2009fd;
var $28355a5b5044dab5$export$bf7199a9ebcb84a9;
var $28355a5b5044dab5$export$7b848b49fe0c4510;
var $28355a5b5044dab5$export$26cbf8c37e721e67;
var $28355a5b5044dab5$export$e08e3b67e392101e;
var $28355a5b5044dab5$export$51186ad6e864892a;
var $28355a5b5044dab5$export$79b2f7037acddd43;
var $28355a5b5044dab5$export$a4f4bb6b1453fff5;
var $28355a5b5044dab5$export$51d570c6883e4310;
"use strict";
$28355a5b5044dab5$export$1e511d4a378977f5 = true;
$28355a5b5044dab5$export$83d89fbfd8236492 = undefined;
$28355a5b5044dab5$export$8abd944bed26e726 = $28355a5b5044dab5$var$uncontrolledPropTypes;
$28355a5b5044dab5$export$e2b5c5db9e2009fd = $28355a5b5044dab5$var$getType;
$28355a5b5044dab5$export$bf7199a9ebcb84a9 = $28355a5b5044dab5$var$getValue;
$28355a5b5044dab5$export$7b848b49fe0c4510 = $28355a5b5044dab5$var$getLinkName;
$28355a5b5044dab5$export$26cbf8c37e721e67 = $28355a5b5044dab5$var$defaultKey;
$28355a5b5044dab5$export$e08e3b67e392101e = $28355a5b5044dab5$var$chain;
$28355a5b5044dab5$export$51186ad6e864892a = $28355a5b5044dab5$var$transform;
$28355a5b5044dab5$export$79b2f7037acddd43 = $28355a5b5044dab5$var$each;
$28355a5b5044dab5$export$a4f4bb6b1453fff5 = $28355a5b5044dab5$var$has;
$28355a5b5044dab5$export$51d570c6883e4310 = $28355a5b5044dab5$var$isReactComponent;

var $7PdBe = parcelRequire("7PdBe");
var $28355a5b5044dab5$var$_react2 = $28355a5b5044dab5$var$_interopRequireDefault($7PdBe);

var $ibnnr = parcelRequire("ibnnr");
var $28355a5b5044dab5$var$_invariant2 = $28355a5b5044dab5$var$_interopRequireDefault($ibnnr);
function $28355a5b5044dab5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $28355a5b5044dab5$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to " + "`" + name + "` without an `" + handler + "` handler. This will render a read-only field. " + "If the field should be mutable use `" + $28355a5b5044dab5$var$defaultKey(propName) + "`. Otherwise, set `" + handler + "`");
        }
    };
}
function $28355a5b5044dab5$var$uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
    var propTypes = {};
    return propTypes;
}
var $28355a5b5044dab5$var$version = $28355a5b5044dab5$export$83d89fbfd8236492 = $28355a5b5044dab5$var$_react2.default.version.split(".").map(parseFloat);
function $28355a5b5044dab5$var$getType(component) {
    if ($28355a5b5044dab5$var$version[0] >= 15 || $28355a5b5044dab5$var$version[0] === 0 && $28355a5b5044dab5$var$version[1] >= 13) return component;
    return component.type;
}
function $28355a5b5044dab5$var$getValue(props, name) {
    var linkPropName = $28355a5b5044dab5$var$getLinkName(name);
    if (linkPropName && !$28355a5b5044dab5$var$isProp(props, name) && $28355a5b5044dab5$var$isProp(props, linkPropName)) return props[linkPropName].value;
    return props[name];
}
function $28355a5b5044dab5$var$isProp(props, prop) {
    return props[prop] !== undefined;
}
function $28355a5b5044dab5$var$getLinkName(name) {
    return name === "value" ? "valueLink" : name === "checked" ? "checkedLink" : null;
}
function $28355a5b5044dab5$var$defaultKey(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $28355a5b5044dab5$var$chain(thisArg, a, b) {
    return function chainedFunction() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        a && a.call.apply(a, [
            thisArg
        ].concat(args));
        b && b.call.apply(b, [
            thisArg
        ].concat(args));
    };
}
function $28355a5b5044dab5$var$transform(obj, cb, seed) {
    $28355a5b5044dab5$var$each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
    return seed;
}
function $28355a5b5044dab5$var$each(obj, cb, thisArg) {
    if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
    for(var key in obj)if ($28355a5b5044dab5$var$has(obj, key)) cb.call(thisArg, obj[key], key, obj);
}
function $28355a5b5044dab5$var$has(o, k) {
    return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ function $28355a5b5044dab5$var$isReactComponent(component) {
    return !!(component && component.prototype && component.prototype.isReactComponent);
}

});



parcelRegister("5jwiU", function(module, exports) {
"use strict";

var $4cOpg = parcelRequire("4cOpg");
var $3de7c8ff47475630$var$has = $4cOpg.has;
module.exports = {
    componentWillUnmount: function componentWillUnmount() {
        var timers = this._timers || {};
        this._unmounted = true;
        for(var k in timers)if ($3de7c8ff47475630$var$has(timers, k)) this.clearTimeout(k);
    },
    clearTimeout: function clearTimeout(key) {
        var timers = this._timers || {};
        window.clearTimeout(timers[key]);
    },
    setTimeout: function setTimeout(key, cb, duration) {
        var _this = this;
        var timers = this._timers || (this._timers = Object.create(null));
        if (this._unmounted) return;
        this.clearTimeout(key);
        timers[key] = window.setTimeout(function() {
            if (!_this._unmounted) cb();
        }, duration);
    }
};

});

parcelRegister("4cxcq", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $S29Lp = parcelRequire("S29Lp");
var $30f20919e78e27f4$var$_propTypes2 = $30f20919e78e27f4$var$_interopRequireDefault($S29Lp);

var $1cUCD = parcelRequire("1cUCD");
function $30f20919e78e27f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    propTypes: {
        autoFocus: $30f20919e78e27f4$var$_propTypes2.default.bool
    },
    componentDidMount: function componentDidMount() {
        var autoFocus = this.props.autoFocus;
        if (autoFocus) this.focus ? this.focus() : (0, $1cUCD.findDOMNode)(this).focus();
    }
};
module.exports = module.exports["default"];

});

parcelRegister("3agVy", function(module, exports) {
"use strict";

var $4cOpg = parcelRequire("4cOpg");
//backport PureRenderEqual
module.exports = {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        return !$4cOpg.isShallowEqual(this.props, nextProps) || !$4cOpg.isShallowEqual(this.state, nextState);
    }
};

});

parcelRegister("2Ah31", function(module, exports) {
"use strict";

var $S29Lp = parcelRequire("S29Lp");
var $1e1c2adfcab1c6fd$var$_propTypes2 = $1e1c2adfcab1c6fd$var$_interopRequireDefault($S29Lp);

var $lUHFm = parcelRequire("lUHFm");
var $1e1c2adfcab1c6fd$var$_filter2 = $1e1c2adfcab1c6fd$var$_interopRequireDefault($lUHFm);

var $8v4NT = parcelRequire("8v4NT");
var $1e1c2adfcab1c6fd$var$_propTypes4 = $1e1c2adfcab1c6fd$var$_interopRequireDefault($8v4NT);

var $3Y3Be = parcelRequire("3Y3Be");
function $1e1c2adfcab1c6fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1e1c2adfcab1c6fd$var$dflt = function dflt(f) {
    return f === true ? "startsWith" : f ? f : "eq";
};
module.exports = {
    propTypes: {
        data: $1e1c2adfcab1c6fd$var$_propTypes2.default.array,
        value: $1e1c2adfcab1c6fd$var$_propTypes2.default.any,
        filter: $1e1c2adfcab1c6fd$var$_propTypes4.default.filter,
        caseSensitive: $1e1c2adfcab1c6fd$var$_propTypes2.default.bool,
        minLength: $1e1c2adfcab1c6fd$var$_propTypes2.default.number
    },
    getDefaultProps: function getDefaultProps() {
        return {
            caseSensitive: false,
            minLength: 1
        };
    },
    filterIndexOf: function filterIndexOf(items, searchTerm) {
        var idx = -1, matches = typeof this.props.filter === "function" ? this.props.filter : $1e1c2adfcab1c6fd$var$getFilter($1e1c2adfcab1c6fd$var$_filter2.default[$1e1c2adfcab1c6fd$var$dflt(this.props.filter)], searchTerm, this);
        if (!searchTerm || !searchTerm.trim() || this.props.filter && searchTerm.length < (this.props.minLength || 1)) return -1;
        items.every(function(item, i) {
            if (matches(item, searchTerm, i)) return idx = i, false;
            return true;
        });
        return idx;
    },
    filter: function filter(items, searchTerm) {
        var matches = typeof this.props.filter === "string" ? $1e1c2adfcab1c6fd$var$getFilter($1e1c2adfcab1c6fd$var$_filter2.default[this.props.filter], searchTerm, this) : this.props.filter;
        if (!matches || !searchTerm || !searchTerm.trim() || searchTerm.length < (this.props.minLength || 1)) return items;
        return items.filter(function(item, idx) {
            return matches(item, searchTerm, idx);
        });
    }
};
function $1e1c2adfcab1c6fd$var$getFilter(matcher, searchTerm, ctx) {
    searchTerm = !ctx.props.caseSensitive ? searchTerm.toLowerCase() : searchTerm;
    return function(item) {
        var val = (0, $3Y3Be.dataText)(item, ctx.props.textField);
        if (!ctx.props.caseSensitive) val = val.toLowerCase();
        return matcher(val, searchTerm);
    };
}

});

parcelRegister("7dl0U", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $6PAjE = parcelRequire("6PAjE");
var $540a0c2c41c89d9e$var$_scrollTo3 = $540a0c2c41c89d9e$var$_interopRequireDefault($6PAjE);
function $540a0c2c41c89d9e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    _scrollTo: function _scrollTo(selected, list, focused) {
        var state = this._scrollState || (this._scrollState = {}), handler = this.props.onMove, lastVisible = state.visible, lastItem = state.focused, shown, changed;
        state.visible = !(!list.offsetWidth || !list.offsetHeight);
        state.focused = focused;
        changed = lastItem !== focused;
        shown = state.visible && !lastVisible;
        if (shown || state.visible && changed) {
            if (handler) handler(selected, list, focused);
            else {
                state.scrollCancel && state.scrollCancel();
                state.scrollCancel = (0, $540a0c2c41c89d9e$var$_scrollTo3.default)(selected, list);
            }
        }
    }
};
module.exports = module.exports["default"];

});
parcelRegister("6PAjE", function(module, exports) {
"use strict";

var $4YZHC = parcelRequire("4YZHC");

var $7gbNL = parcelRequire("7gbNL");

var $2mdTb = parcelRequire("2mdTb");

var $koeQQ = parcelRequire("koeQQ");

var $hkz6h = parcelRequire("hkz6h");

var $8uPzo = parcelRequire("8uPzo");
module.exports = function scrollTo(selected, scrollParent) {
    var offset = $4YZHC(selected), poff = {
        top: 0,
        left: 0
    }, list, listScrollTop, selectedTop, isWin, selectedHeight, listHeight, bottom;
    if (!selected) return;
    list = scrollParent || $2mdTb(selected);
    isWin = $8uPzo(list);
    listScrollTop = $koeQQ(list);
    listHeight = $7gbNL(list, true);
    isWin = $8uPzo(list);
    if (!isWin) poff = $4YZHC(list);
    offset = {
        top: offset.top - poff.top,
        left: offset.left - poff.left,
        height: offset.height,
        width: offset.width
    };
    selectedHeight = offset.height;
    selectedTop = offset.top + (isWin ? 0 : listScrollTop);
    bottom = selectedTop + selectedHeight;
    listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
    var id = $hkz6h(function() {
        return $koeQQ(list, listScrollTop);
    });
    return function() {
        return $hkz6h.cancel(id);
    };
};

});
parcelRegister("2mdTb", function(module, exports) {
"use strict";

var $gKGWM = parcelRequire("gKGWM");

var $7gbNL = parcelRequire("7gbNL");
module.exports = function scrollPrarent(node) {
    var position = $gKGWM(node, "position"), excludeStatic = position === "absolute", ownerDoc = node.ownerDocument;
    if (position === "fixed") return ownerDoc || document;
    while((node = node.parentNode) && node.nodeType !== 9){
        var isStatic = excludeStatic && $gKGWM(node, "position") === "static", style = $gKGWM(node, "overflow") + $gKGWM(node, "overflow-y") + $gKGWM(node, "overflow-x");
        if (isStatic) continue;
        if (/(auto|scroll)/.test(style) && $7gbNL(node) < node.scrollHeight) return node;
    }
    return document;
};

});

parcelRegister("koeQQ", function(module, exports) {
"use strict";

var $8uPzo = parcelRequire("8uPzo");
module.exports = function scrollTop(node, val) {
    var win = $8uPzo(node);
    if (val === undefined) return win ? "pageYOffset" in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
    if (win) win.scrollTo("pageXOffset" in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);
    else node.scrollTop = val;
};

});

parcelRegister("hkz6h", function(module, exports) {
"use strict";

var $cAyTR = parcelRequire("cAyTR");
var $c9df8822ebc47f72$var$vendors = [
    "",
    "webkit",
    "moz",
    "o",
    "ms"
], $c9df8822ebc47f72$var$cancel = "clearTimeout", $c9df8822ebc47f72$var$raf = $c9df8822ebc47f72$var$fallback, $c9df8822ebc47f72$var$compatRaf;
var $c9df8822ebc47f72$var$getKey = function getKey(vendor, k) {
    return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + "AnimationFrame";
};
if ($cAyTR) $c9df8822ebc47f72$var$vendors.some(function(vendor) {
    var rafKey = $c9df8822ebc47f72$var$getKey(vendor, "request");
    if (rafKey in window) {
        $c9df8822ebc47f72$var$cancel = $c9df8822ebc47f72$var$getKey(vendor, "cancel");
        return $c9df8822ebc47f72$var$raf = function(cb) {
            return window[rafKey](cb);
        };
    }
});
/* https://github.com/component/raf */ var $c9df8822ebc47f72$var$prev = new Date().getTime();
function $c9df8822ebc47f72$var$fallback(fn) {
    var curr = new Date().getTime(), ms = Math.max(0, 16 - (curr - $c9df8822ebc47f72$var$prev)), req = setTimeout(fn, ms);
    $c9df8822ebc47f72$var$prev = curr;
    return req;
}
$c9df8822ebc47f72$var$compatRaf = function(cb) {
    return $c9df8822ebc47f72$var$raf(cb);
};
$c9df8822ebc47f72$var$compatRaf.cancel = function(id) {
    return window[$c9df8822ebc47f72$var$cancel](id);
};
module.exports = $c9df8822ebc47f72$var$compatRaf;

});



parcelRegister("5NCz1", function(module, exports) {
"use strict";

var $S29Lp = parcelRequire("S29Lp");
module.exports = {
    propTypes: {
        isRtl: $S29Lp.bool
    },
    contextTypes: {
        isRtl: $S29Lp.bool
    },
    childContextTypes: {
        isRtl: $S29Lp.bool
    },
    getChildContext: function getChildContext() {
        return {
            isRtl: !!(this.props.isRtl || this.context && this.context.isRtl)
        };
    },
    isRtl: function isRtl() {
        return !!(this.props.isRtl || this.context && this.context.isRtl);
    }
};

});

parcelRegister("k1uk1", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $e93b6bf6a2ee6605$var$FocusMixin;

var $b6t9X = parcelRequire("b6t9X");

var $7RxtH = parcelRequire("7RxtH");

var $96zKa = parcelRequire("96zKa");
var $e93b6bf6a2ee6605$var$_compat2 = $e93b6bf6a2ee6605$var$_interopRequireDefault($96zKa);
function $e93b6bf6a2ee6605$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e93b6bf6a2ee6605$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
function $e93b6bf6a2ee6605$var$FocusMixin(_ref) {
    var _desc, _value, _obj;
    var willHandle = _ref.willHandle, didHandle = _ref.didHandle;
    function _handleFocus(inst, focused, event) {
        var handler = inst.props[focused ? "onFocus" : "onBlur"];
        if (handler && event) event.persist();
        if (willHandle && willHandle.call(inst, focused, event) === false) return;
        inst.setTimeout("focus", function() {
            $e93b6bf6a2ee6605$var$_compat2.default.batchedUpdates(function() {
                if (didHandle) didHandle.call(inst, focused, event);
                if (focused !== inst.state.focused) {
                    (0, $b6t9X.notify)(handler, event);
                    if (inst._mounted) inst.setState({
                        focused: focused
                    });
                }
            });
        });
    }
    return _obj = {
        handleBlur: function handleBlur(event) {
            _handleFocus(this, false, event);
        },
        handleFocus: function handleFocus(event) {
            _handleFocus(this, true, event);
        },
        componentDidMount: function componentDidMount() {
            this._mounted = true;
        },
        componentWillUnmount: function componentWillUnmount() {
            this._mounted = false;
        }
    }, $e93b6bf6a2ee6605$var$_applyDecoratedDescriptor(_obj, "handleBlur", [
        $7RxtH.widgetEnabled
    ], Object.getOwnPropertyDescriptor(_obj, "handleBlur"), _obj), $e93b6bf6a2ee6605$var$_applyDecoratedDescriptor(_obj, "handleFocus", [
        $7RxtH.widgetEnabled
    ], Object.getOwnPropertyDescriptor(_obj, "handleFocus"), _obj), _obj;
}
module.exports = module.exports["default"];

});


parcelRegister("gvCH7", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $c04d8e82ec7bf7a4$var$_desc, $c04d8e82ec7bf7a4$var$_value, $c04d8e82ec7bf7a4$var$_obj;
var $c04d8e82ec7bf7a4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $c04d8e82ec7bf7a4$var$_react2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $c04d8e82ec7bf7a4$var$_propTypes2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $c04d8e82ec7bf7a4$var$_createReactClass2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($5JTQC);

var $ksXgP = parcelRequire("ksXgP");
var $c04d8e82ec7bf7a4$var$_classnames2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($ksXgP);

var $4cOpg = parcelRequire("4cOpg");
var $c04d8e82ec7bf7a4$var$_3 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($4cOpg);

var $lUHFm = parcelRequire("lUHFm");
var $c04d8e82ec7bf7a4$var$_filter2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($lUHFm);

var $atEP4 = parcelRequire("atEP4");
var $c04d8e82ec7bf7a4$var$_Widget2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($atEP4);

var $6faAq = parcelRequire("6faAq");
var $c04d8e82ec7bf7a4$var$_Popup2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($6faAq);

var $j8c9s = parcelRequire("j8c9s");
var $c04d8e82ec7bf7a4$var$_Select2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($j8c9s);

var $boj5u = parcelRequire("boj5u");
var $c04d8e82ec7bf7a4$var$_ComboboxInput2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($boj5u);

var $96zKa = parcelRequire("96zKa");
var $c04d8e82ec7bf7a4$var$_compat2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($96zKa);

var $8v4NT = parcelRequire("8v4NT");
var $c04d8e82ec7bf7a4$var$_propTypes4 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($8v4NT);

var $emiXD = parcelRequire("emiXD");
var $c04d8e82ec7bf7a4$var$_List2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($emiXD);

var $bp2Lh = parcelRequire("bp2Lh");
var $c04d8e82ec7bf7a4$var$_ListGroupable2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($bp2Lh);

var $jQzQU = parcelRequire("jQzQU");
var $c04d8e82ec7bf7a4$var$_validateListInterface2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($jQzQU);

var $7iIDV = parcelRequire("7iIDV");
var $c04d8e82ec7bf7a4$var$_uncontrollable2 = $c04d8e82ec7bf7a4$var$_interopRequireDefault($7iIDV);

var $3Y3Be = parcelRequire("3Y3Be");

var $7RxtH = parcelRequire("7RxtH");

var $b6t9X = parcelRequire("b6t9X");
function $c04d8e82ec7bf7a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c04d8e82ec7bf7a4$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $c04d8e82ec7bf7a4$var$defaultSuggest = function defaultSuggest(f) {
    return f === true ? "startsWith" : f ? f : "eq";
};
var $c04d8e82ec7bf7a4$var$propTypes = $c04d8e82ec7bf7a4$var$_extends({}, $c04d8e82ec7bf7a4$var$_Popup2.default.propTypes, {
    //-- controlled props -----------
    value: $c04d8e82ec7bf7a4$var$_propTypes2.default.any,
    onChange: $c04d8e82ec7bf7a4$var$_propTypes2.default.func,
    open: $c04d8e82ec7bf7a4$var$_propTypes2.default.bool,
    onToggle: $c04d8e82ec7bf7a4$var$_propTypes2.default.func,
    //------------------------------------
    itemComponent: $c04d8e82ec7bf7a4$var$_propTypes4.default.elementType,
    listComponent: $c04d8e82ec7bf7a4$var$_propTypes4.default.elementType,
    groupComponent: $c04d8e82ec7bf7a4$var$_propTypes4.default.elementType,
    groupBy: $c04d8e82ec7bf7a4$var$_propTypes4.default.accessor,
    data: $c04d8e82ec7bf7a4$var$_propTypes2.default.array,
    valueField: $c04d8e82ec7bf7a4$var$_propTypes2.default.string,
    textField: $c04d8e82ec7bf7a4$var$_propTypes4.default.accessor,
    name: $c04d8e82ec7bf7a4$var$_propTypes2.default.string,
    onSelect: $c04d8e82ec7bf7a4$var$_propTypes2.default.func,
    autoFocus: $c04d8e82ec7bf7a4$var$_propTypes2.default.bool,
    disabled: $c04d8e82ec7bf7a4$var$_propTypes4.default.disabled.acceptsArray,
    readOnly: $c04d8e82ec7bf7a4$var$_propTypes4.default.readOnly.acceptsArray,
    suggest: $c04d8e82ec7bf7a4$var$_propTypes4.default.filter,
    filter: $c04d8e82ec7bf7a4$var$_propTypes4.default.filter,
    busy: $c04d8e82ec7bf7a4$var$_propTypes2.default.bool,
    dropUp: $c04d8e82ec7bf7a4$var$_propTypes2.default.bool,
    duration: $c04d8e82ec7bf7a4$var$_propTypes2.default.number,
    delay: $c04d8e82ec7bf7a4$var$_propTypes2.default.number,
    placeholder: $c04d8e82ec7bf7a4$var$_propTypes2.default.string,
    "aria-labelledby": $c04d8e82ec7bf7a4$var$_propTypes2.default.string,
    "aria-describedby": $c04d8e82ec7bf7a4$var$_propTypes2.default.string,
    messages: $c04d8e82ec7bf7a4$var$_propTypes2.default.shape({
        open: $c04d8e82ec7bf7a4$var$_propTypes4.default.message,
        emptyList: $c04d8e82ec7bf7a4$var$_propTypes4.default.message,
        emptyFilter: $c04d8e82ec7bf7a4$var$_propTypes4.default.message
    })
});






var $c04d8e82ec7bf7a4$var$ComboBox = (0, $c04d8e82ec7bf7a4$var$_createReactClass2.default)(($c04d8e82ec7bf7a4$var$_obj = {
    displayName: "ComboBox",
    mixins: [
        (parcelRequire("5jwiU")),
        (parcelRequire("2Ah31")),
        (parcelRequire("7dl0U")),
        (parcelRequire("5NCz1")),
        (parcelRequire("9AXXZ"))("input"),
        (parcelRequire("k1uk1"))({
            willHandle: function willHandle(focused) {
                // not suggesting anymore
                !focused && this.refs.input.accept();
            },
            didHandle: function didHandle(focused) {
                if (!focused) this.close();
            }
        })
    ],
    propTypes: $c04d8e82ec7bf7a4$var$propTypes,
    getInitialState: function getInitialState() {
        var _props = this.props, value = _props.value, data = _props.data, valueField = _props.valueField, items = this.process(data, value), idx = (0, $3Y3Be.dataIndexOf)(items, value, valueField);
        return {
            selectedItem: items[idx],
            focusedItem: items[!~idx ? 0 : idx],
            processedData: items,
            open: false
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            data: [],
            value: "",
            open: false,
            suggest: false,
            filter: false,
            delay: 500,
            messages: $c04d8e82ec7bf7a4$var$msgs(),
            ariaActiveDescendantKey: "combobox"
        };
    },
    componentDidUpdate: function componentDidUpdate() {
        this.refs.list && (0, $c04d8e82ec7bf7a4$var$_validateListInterface2.default)(this.refs.list);
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        var isSuggesting = this.refs.input && this.refs.input.isSuggesting(), stateChanged = !$c04d8e82ec7bf7a4$var$_3.default.isShallowEqual(nextState, this.state), valueChanged = !$c04d8e82ec7bf7a4$var$_3.default.isShallowEqual(nextProps, this.props);
        return isSuggesting || stateChanged || valueChanged;
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var value = nextProps.value, data = nextProps.data, valueField = nextProps.valueField, textField = nextProps.textField;
        var rawIdx = (0, $3Y3Be.dataIndexOf)(data, value, valueField), valueItem = rawIdx === -1 ? nextProps.value : nextProps.data[rawIdx], isSuggesting = this.refs.input && this.refs.input.isSuggesting();
        var items = this.process(nextProps.data, nextProps.value, (rawIdx === -1 || isSuggesting) && (0, $3Y3Be.dataText)(valueItem, textField));
        var idx = (0, $3Y3Be.dataIndexOf)(items, value, valueField), focused = this.filterIndexOf(items, (0, $3Y3Be.dataText)(valueItem, textField));
        this._searchTerm = "";
        this.setState({
            processedData: items,
            selectedItem: items[idx],
            focusedItem: items[idx === -1 ? focused !== -1 ? focused : 0 // focus the closest match
             : idx]
        });
    },
    renderInput: function renderInput(listID) {
        var _props2 = this.props, suggest = _props2.suggest, filter = _props2.filter, textField = _props2.textField, busy = _props2.busy, name = _props2.name, data = _props2.data, value = _props2.value, valueField = _props2.valueField, autoFocus = _props2.autoFocus, tabIndex = _props2.tabIndex, disabled = _props2.disabled, readOnly = _props2.readOnly, placeholder = _props2.placeholder, open = _props2.open, ariaLabelledby = _props2["aria-labelledby"], ariaDescribedby = _props2["aria-describedby"];
        var valueItem = (0, $3Y3Be.dataItem)(data, value, valueField); // take value from the raw data
        var completeType = suggest ? filter ? "both" : "inline" : filter ? "list" : "";
        return $c04d8e82ec7bf7a4$var$_react2.default.createElement($c04d8e82ec7bf7a4$var$_ComboboxInput2.default, {
            ref: "input",
            id: (0, $b6t9X.instanceId)(this, "_input"),
            autoFocus: autoFocus,
            tabIndex: tabIndex,
            suggest: suggest,
            name: name,
            role: "combobox",
            disabled: disabled,
            readOnly: readOnly,
            "aria-owns": listID,
            "aria-busy": !!busy,
            "aria-autocomplete": completeType,
            "aria-expanded": open,
            "aria-haspopup": true,
            "aria-describedby": ariaDescribedby,
            "aria-labelledby": ariaLabelledby,
            placeholder: placeholder,
            value: (0, $3Y3Be.dataText)(valueItem, textField),
            onChange: this.handleInputChange,
            onKeyDown: this.handleInputKeyDown
        });
    },
    renderList: function renderList(List, id, messages) {
        var _props3 = this.props, open = _props3.open, data = _props3.data;
        var _state = this.state, selectedItem = _state.selectedItem, focusedItem = _state.focusedItem;
        var listProps = $c04d8e82ec7bf7a4$var$_3.default.pickProps(this.props, List);
        var items = this._data();
        return $c04d8e82ec7bf7a4$var$_react2.default.createElement(List, $c04d8e82ec7bf7a4$var$_extends({
            ref: "list"
        }, listProps, {
            id: id,
            data: items,
            selected: selectedItem,
            focused: focusedItem,
            "aria-hidden": !open,
            "aria-labelledby": (0, $b6t9X.instanceId)(this),
            "aria-live": open && "polite",
            onSelect: this.handleSelect,
            onMove: this._scrollTo,
            messages: {
                emptyList: data.length ? messages.emptyFilter : messages.emptyList
            }
        }));
    },
    render: function render() {
        var _this = this;
        var _props4 = this.props, className = _props4.className, duration = _props4.duration, groupBy = _props4.groupBy, messages = _props4.messages, busy = _props4.busy, dropUp = _props4.dropUp, open = _props4.open, List = _props4.listComponent;
        var focused = this.state.focused;
        var disabled = (0, $7RxtH.isDisabled)(this.props), readOnly = (0, $7RxtH.isReadOnly)(this.props), listID = (0, $b6t9X.instanceId)(this, "_listbox");
        List = List || groupBy && $c04d8e82ec7bf7a4$var$_ListGroupable2.default || $c04d8e82ec7bf7a4$var$_List2.default;
        var elementProps = $c04d8e82ec7bf7a4$var$_3.default.omitOwnProps(this, List);
        var shouldRenderPopup = open || (0, $b6t9X.isFirstFocusedRender)(this);
        messages = $c04d8e82ec7bf7a4$var$msgs(messages);
        return $c04d8e82ec7bf7a4$var$_react2.default.createElement($c04d8e82ec7bf7a4$var$_Widget2.default, $c04d8e82ec7bf7a4$var$_extends({}, elementProps, {
            open: open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            className: (0, $c04d8e82ec7bf7a4$var$_classnames2.default)(className, "rw-combobox")
        }), $c04d8e82ec7bf7a4$var$_react2.default.createElement($c04d8e82ec7bf7a4$var$_Select2.default, {
            onClick: this.toggle,
            disabled: !!(disabled || readOnly),
            busy: busy,
            icon: "caret-down",
            label: $c04d8e82ec7bf7a4$var$_3.default.result(messages.open, this.props)
        }), this.renderInput(listID), shouldRenderPopup && $c04d8e82ec7bf7a4$var$_react2.default.createElement($c04d8e82ec7bf7a4$var$_Popup2.default, {
            open: open,
            dropUp: dropUp,
            duration: duration,
            onOpening: function onOpening() {
                return _this.refs.list.forceUpdate();
            }
        }, $c04d8e82ec7bf7a4$var$_react2.default.createElement("div", null, this.renderList(List, listID, messages))));
    },
    handleSelect: function handleSelect(data) {
        this.close();
        (0, $b6t9X.notify)(this.props.onSelect, data);
        this.change(data);
        this.focus();
    },
    handleInputKeyDown: function handleInputKeyDown(e) {
        this._deleting = e.key === "Backspace" || e.key === "Delete";
        this._isTyping = true;
    },
    handleInputChange: function handleInputChange(e) {
        var _props5 = this.props, data = _props5.data, textField = _props5.textField;
        var shouldSuggest = !!this.props.suggest, strVal = e.target.value, suggestion;
        suggestion = this._deleting || !shouldSuggest ? strVal : this.suggest(this._data(), strVal);
        suggestion = suggestion || strVal;
        data = $c04d8e82ec7bf7a4$var$_3.default.find(data, function(item) {
            return (0, $3Y3Be.dataText)(item, textField).toLowerCase() === suggestion.toLowerCase();
        });
        this.change(!this._deleting && data ? data : strVal, true);
        this.open();
    },
    focus: function focus() {
        this.refs.input && this.refs.input.focus();
    },
    handleKeyDown: function handleKeyDown(e) {
        var self = this, key = e.key, alt = e.altKey, list = this.refs.list, focusedItem = this.state.focusedItem, selectedItem = this.state.selectedItem, isOpen = this.props.open;
        (0, $b6t9X.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (key === "End") {
            if (isOpen) this.setState({
                focusedItem: list.last()
            });
            else select(list.last(), true);
        } else if (key === "Home") {
            if (isOpen) this.setState({
                focusedItem: list.first()
            });
            else select(list.first(), true);
        } else if (key === "Escape" && isOpen) this.close();
        else if (key === "Enter" && isOpen) {
            e.preventDefault();
            select(this.state.focusedItem, true);
        } else if (key === "ArrowDown") {
            if (alt) this.open();
            else if (isOpen) this.setState({
                focusedItem: list.next(focusedItem)
            });
            else select(list.next(selectedItem), true);
        } else if (key === "ArrowUp") {
            if (alt) this.close();
            else if (isOpen) this.setState({
                focusedItem: list.prev(focusedItem)
            });
            else select(list.prev(selectedItem), true);
        }
        function select(item, fromList) {
            if (!item) return self.change($c04d8e82ec7bf7a4$var$_compat2.default.findDOMNode(self.refs.input).value, false);
            self.refs.input.accept(true); //removes caret
            if (fromList) return self.handleSelect(item);
            self.change(item, false);
        }
    },
    change: function change(data, typing) {
        this._typedChange = !!typing;
        (0, $b6t9X.notify)(this.props.onChange, data);
    },
    open: function open() {
        if (!this.props.open) (0, $b6t9X.notify)(this.props.onToggle, true);
    },
    close: function close() {
        if (this.props.open) (0, $b6t9X.notify)(this.props.onToggle, false);
    },
    toggle: function toggle() {
        this.focus();
        this.props.open ? this.close() : this.open();
    },
    suggest: function suggest(data, value) {
        var _props6 = this.props, textField = _props6.textField, suggest = _props6.suggest, minLength = _props6.minLength;
        var word = (0, $3Y3Be.dataText)(value, textField), suggestion;
        suggest = $c04d8e82ec7bf7a4$var$defaultSuggest(suggest);
        if (!(word || "").trim() || word.length < (minLength || 1)) return "";
        suggestion = typeof value === "string" ? $c04d8e82ec7bf7a4$var$_3.default.find(data, $c04d8e82ec7bf7a4$var$getFilter(suggest, word, textField)) : value;
        if (suggestion && (!this.state || !this.state.deleting)) return (0, $3Y3Be.dataText)(suggestion, textField);
        return "";
    },
    _data: function _data() {
        return this.state.processedData;
    },
    process: function process(data, values, searchTerm) {
        if (this.props.filter && searchTerm) data = this.filter(data, searchTerm);
        return data;
    }
}, $c04d8e82ec7bf7a4$var$_applyDecoratedDescriptor($c04d8e82ec7bf7a4$var$_obj, "handleSelect", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($c04d8e82ec7bf7a4$var$_obj, "handleSelect"), $c04d8e82ec7bf7a4$var$_obj), $c04d8e82ec7bf7a4$var$_applyDecoratedDescriptor($c04d8e82ec7bf7a4$var$_obj, "handleKeyDown", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($c04d8e82ec7bf7a4$var$_obj, "handleKeyDown"), $c04d8e82ec7bf7a4$var$_obj), $c04d8e82ec7bf7a4$var$_applyDecoratedDescriptor($c04d8e82ec7bf7a4$var$_obj, "toggle", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($c04d8e82ec7bf7a4$var$_obj, "toggle"), $c04d8e82ec7bf7a4$var$_obj), $c04d8e82ec7bf7a4$var$_obj));
module.exports.default = (0, $c04d8e82ec7bf7a4$var$_uncontrollable2.default)($c04d8e82ec7bf7a4$var$ComboBox, {
    open: "onToggle",
    value: "onChange"
}, [
    "focus"
]);
function $c04d8e82ec7bf7a4$var$msgs(msgs) {
    return $c04d8e82ec7bf7a4$var$_extends({
        open: "open combobox",
        emptyList: "There are no items in this list",
        emptyFilter: "The filter returned no results"
    }, msgs);
}
function $c04d8e82ec7bf7a4$var$getFilter(suggest, word, textField) {
    return typeof suggest === "string" ? function(item) {
        return $c04d8e82ec7bf7a4$var$_filter2.default[suggest]((0, $3Y3Be.dataText)(item, textField).toLowerCase(), word.toLowerCase());
    } : function(item) {
        return suggest(item, word);
    };
}
module.exports = module.exports["default"];

});
parcelRegister("boj5u", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $84b0bdfa4a95400d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $84b0bdfa4a95400d$var$_react2 = $84b0bdfa4a95400d$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $84b0bdfa4a95400d$var$_propTypes2 = $84b0bdfa4a95400d$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $84b0bdfa4a95400d$var$_createReactClass2 = $84b0bdfa4a95400d$var$_interopRequireDefault($5JTQC);

var $4cOpg = parcelRequire("4cOpg");
var $84b0bdfa4a95400d$var$_3 = $84b0bdfa4a95400d$var$_interopRequireDefault($4cOpg);

var $jkH3F = parcelRequire("jkH3F");
var $84b0bdfa4a95400d$var$_caret2 = $84b0bdfa4a95400d$var$_interopRequireDefault($jkH3F);

var $96zKa = parcelRequire("96zKa");
var $84b0bdfa4a95400d$var$_compat2 = $84b0bdfa4a95400d$var$_interopRequireDefault($96zKa);

var $dHGtJ = parcelRequire("dHGtJ");
var $84b0bdfa4a95400d$var$_Input2 = $84b0bdfa4a95400d$var$_interopRequireDefault($dHGtJ);
function $84b0bdfa4a95400d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $84b0bdfa4a95400d$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
module.exports.default = (0, $84b0bdfa4a95400d$var$_createReactClass2.default)({
    displayName: "ComboboxInput",
    propTypes: {
        value: $84b0bdfa4a95400d$var$_propTypes2.default.string,
        suggest: $84b0bdfa4a95400d$var$_propTypes2.default.bool,
        onChange: $84b0bdfa4a95400d$var$_propTypes2.default.func.isRequired
    },
    componentDidUpdate: function componentDidUpdate() {
        var input = $84b0bdfa4a95400d$var$_compat2.default.findDOMNode(this), val = this.props.value;
        if (this.isSuggesting()) {
            var start = val.toLowerCase().indexOf(this._last.toLowerCase()) + this._last.length, end = val.length - start;
            if (start >= 0) (0, $84b0bdfa4a95400d$var$_caret2.default)(input, start, start + end);
        }
    },
    getDefaultProps: function getDefaultProps() {
        return {
            value: ""
        };
    },
    render: function render() {
        var _props = this.props, onKeyDown = _props.onKeyDown, props = $84b0bdfa4a95400d$var$_objectWithoutProperties(_props, [
            "onKeyDown"
        ]);
        delete props.suggest;
        return $84b0bdfa4a95400d$var$_react2.default.createElement($84b0bdfa4a95400d$var$_Input2.default, $84b0bdfa4a95400d$var$_extends({}, props, {
            onKeyDown: onKeyDown,
            onChange: this.handleChange
        }));
    },
    isSuggesting: function isSuggesting() {
        var val = this.props.value, isSuggestion = this._last != null && val.toLowerCase().indexOf(this._last.toLowerCase()) !== -1;
        return this.props.suggest && isSuggestion;
    },
    accept: function accept(removeCaret) {
        var val = $84b0bdfa4a95400d$var$_compat2.default.findDOMNode(this).value || "", end = val.length;
        this._last = null;
        removeCaret && (0, $84b0bdfa4a95400d$var$_caret2.default)($84b0bdfa4a95400d$var$_compat2.default.findDOMNode(this), end, end);
    },
    handleChange: function handleChange(e) {
        var val = e.target.value, pl = !!this.props.placeholder;
        // IE fires input events when setting/unsetting placeholders.
        // issue #112
        if (pl && !val && val === (this.props.value || "")) return;
        this._last = val;
        this.props.onChange(e, val);
    },
    focus: function focus() {
        $84b0bdfa4a95400d$var$_compat2.default.findDOMNode(this).focus();
    }
});
module.exports = module.exports["default"];

});
parcelRegister("jkH3F", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $e1314904ddf864cb$var$caret;
/*eslint-disable no-empty */ function $e1314904ddf864cb$var$caret(el, start, end) {
    if (start === undefined) return $e1314904ddf864cb$var$get(el);
    $e1314904ddf864cb$var$set(el, start, end);
}
function $e1314904ddf864cb$var$get(el) {
    var start, end, rangeEl, clone;
    if (el.selectionStart !== undefined) {
        start = el.selectionStart;
        end = el.selectionEnd;
    } else try {
        el.focus();
        rangeEl = el.createTextRange();
        clone = rangeEl.duplicate();
        rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
        clone.setEndPoint("EndToStart", rangeEl);
        start = clone.text.length;
        end = start + rangeEl.text.length;
    } catch (e) {}
    return {
        start: start,
        end: end
    };
}
function $e1314904ddf864cb$var$set(el, start, end) {
    var rangeEl;
    try {
        if (el.selectionStart !== undefined) {
            el.focus();
            el.setSelectionRange(start, end);
        } else {
            el.focus();
            rangeEl = el.createTextRange();
            rangeEl.collapse(true);
            rangeEl.moveStart("character", start);
            rangeEl.moveEnd("character", end - start);
            rangeEl.select();
        }
    } catch (e) {}
}
module.exports = module.exports["default"];

});



parcelRegister("3TyqS", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $2d6137bbf5af1f8e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2d6137bbf5af1f8e$var$_VIEW, $2d6137bbf5af1f8e$var$_OPPOSITE_DIRECTION, $2d6137bbf5af1f8e$var$_MULTIPLIER, $2d6137bbf5af1f8e$var$_desc, $2d6137bbf5af1f8e$var$_value2, $2d6137bbf5af1f8e$var$_obj; //values, omit

var $7PdBe = parcelRequire("7PdBe");
var $2d6137bbf5af1f8e$var$_react2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $2d6137bbf5af1f8e$var$_propTypes2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $2d6137bbf5af1f8e$var$_createReactClass2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($5JTQC);

var $ksXgP = parcelRequire("ksXgP");
var $2d6137bbf5af1f8e$var$_classnames2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($ksXgP);

var $96zKa = parcelRequire("96zKa");
var $2d6137bbf5af1f8e$var$_compat2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($96zKa);

var $atEP4 = parcelRequire("atEP4");
var $2d6137bbf5af1f8e$var$_Widget2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($atEP4);

var $gzEq6 = parcelRequire("gzEq6");
var $2d6137bbf5af1f8e$var$_Header2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($gzEq6);

var $8Mjo5 = parcelRequire("8Mjo5");
var $2d6137bbf5af1f8e$var$_Footer2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($8Mjo5);

var $lFqOo = parcelRequire("lFqOo");
var $2d6137bbf5af1f8e$var$_Month2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($lFqOo);

var $5Wau1 = parcelRequire("5Wau1");
var $2d6137bbf5af1f8e$var$_Year2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($5Wau1);

var $h2wol = parcelRequire("h2wol");
var $2d6137bbf5af1f8e$var$_Decade2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($h2wol);

var $xygTe = parcelRequire("xygTe");
var $2d6137bbf5af1f8e$var$_Century2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($xygTe);

var $d6vOx = parcelRequire("d6vOx");

var $8v4NT = parcelRequire("8v4NT");
var $2d6137bbf5af1f8e$var$_propTypes4 = $2d6137bbf5af1f8e$var$_interopRequireDefault($8v4NT);

var $7iIDV = parcelRequire("7iIDV");
var $2d6137bbf5af1f8e$var$_uncontrollable2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($7iIDV);

var $7eZIS = parcelRequire("7eZIS");
var $2d6137bbf5af1f8e$var$_SlideTransition2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($7eZIS);

var $ecwgv = parcelRequire("ecwgv");
var $2d6137bbf5af1f8e$var$_dates2 = $2d6137bbf5af1f8e$var$_interopRequireDefault($ecwgv);

var $jn9XT = parcelRequire("jn9XT");
var $2d6137bbf5af1f8e$var$constants = $2d6137bbf5af1f8e$var$_interopRequireWildcard($jn9XT);

var $4cOpg = parcelRequire("4cOpg");
var $2d6137bbf5af1f8e$var$_3 = $2d6137bbf5af1f8e$var$_interopRequireDefault($4cOpg);

var $b6t9X = parcelRequire("b6t9X");

var $7RxtH = parcelRequire("7RxtH");
function $2d6137bbf5af1f8e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $2d6137bbf5af1f8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2d6137bbf5af1f8e$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $2d6137bbf5af1f8e$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $2d6137bbf5af1f8e$var$dir = $2d6137bbf5af1f8e$var$constants.directions, $2d6137bbf5af1f8e$var$values = function values(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
}, $2d6137bbf5af1f8e$var$invert = function invert(obj) {
    return $2d6137bbf5af1f8e$var$_3.default.transform(obj, function(o, val, key) {
        o[val] = key;
    }, {});
};
var $2d6137bbf5af1f8e$var$views = $2d6137bbf5af1f8e$var$constants.calendarViews, $2d6137bbf5af1f8e$var$VIEW_OPTIONS = $2d6137bbf5af1f8e$var$values($2d6137bbf5af1f8e$var$views), $2d6137bbf5af1f8e$var$ALT_VIEW = $2d6137bbf5af1f8e$var$invert($2d6137bbf5af1f8e$var$constants.calendarViewHierarchy), $2d6137bbf5af1f8e$var$NEXT_VIEW = $2d6137bbf5af1f8e$var$constants.calendarViewHierarchy, $2d6137bbf5af1f8e$var$VIEW_UNIT = $2d6137bbf5af1f8e$var$constants.calendarViewUnits, $2d6137bbf5af1f8e$var$VIEW = ($2d6137bbf5af1f8e$var$_VIEW = {}, $2d6137bbf5af1f8e$var$_VIEW[$2d6137bbf5af1f8e$var$views.MONTH] = $2d6137bbf5af1f8e$var$_Month2.default, $2d6137bbf5af1f8e$var$_VIEW[$2d6137bbf5af1f8e$var$views.YEAR] = $2d6137bbf5af1f8e$var$_Year2.default, $2d6137bbf5af1f8e$var$_VIEW[$2d6137bbf5af1f8e$var$views.DECADE] = $2d6137bbf5af1f8e$var$_Decade2.default, $2d6137bbf5af1f8e$var$_VIEW[$2d6137bbf5af1f8e$var$views.CENTURY] = $2d6137bbf5af1f8e$var$_Century2.default, $2d6137bbf5af1f8e$var$_VIEW);
var $2d6137bbf5af1f8e$var$ARROWS_TO_DIRECTION = {
    ArrowDown: $2d6137bbf5af1f8e$var$dir.DOWN,
    ArrowUp: $2d6137bbf5af1f8e$var$dir.UP,
    ArrowRight: $2d6137bbf5af1f8e$var$dir.RIGHT,
    ArrowLeft: $2d6137bbf5af1f8e$var$dir.LEFT
};
var $2d6137bbf5af1f8e$var$OPPOSITE_DIRECTION = ($2d6137bbf5af1f8e$var$_OPPOSITE_DIRECTION = {}, $2d6137bbf5af1f8e$var$_OPPOSITE_DIRECTION[$2d6137bbf5af1f8e$var$dir.LEFT] = $2d6137bbf5af1f8e$var$dir.RIGHT, $2d6137bbf5af1f8e$var$_OPPOSITE_DIRECTION[$2d6137bbf5af1f8e$var$dir.RIGHT] = $2d6137bbf5af1f8e$var$dir.LEFT, $2d6137bbf5af1f8e$var$_OPPOSITE_DIRECTION);
var $2d6137bbf5af1f8e$var$MULTIPLIER = ($2d6137bbf5af1f8e$var$_MULTIPLIER = {}, $2d6137bbf5af1f8e$var$_MULTIPLIER[$2d6137bbf5af1f8e$var$views.YEAR] = 1, $2d6137bbf5af1f8e$var$_MULTIPLIER[$2d6137bbf5af1f8e$var$views.DECADE] = 10, $2d6137bbf5af1f8e$var$_MULTIPLIER[$2d6137bbf5af1f8e$var$views.CENTURY] = 100, $2d6137bbf5af1f8e$var$_MULTIPLIER);
var $2d6137bbf5af1f8e$var$format = function format(props, f) {
    return $d6vOx.date.getFormat(f, props[f + "Format"]);
};
var $2d6137bbf5af1f8e$var$propTypes = {
    disabled: $2d6137bbf5af1f8e$var$_propTypes4.default.disabled,
    readOnly: $2d6137bbf5af1f8e$var$_propTypes4.default.readOnly,
    onChange: $2d6137bbf5af1f8e$var$_propTypes2.default.func,
    value: $2d6137bbf5af1f8e$var$_propTypes2.default.instanceOf(Date),
    min: $2d6137bbf5af1f8e$var$_propTypes2.default.instanceOf(Date),
    max: $2d6137bbf5af1f8e$var$_propTypes2.default.instanceOf(Date),
    currentDate: $2d6137bbf5af1f8e$var$_propTypes2.default.instanceOf(Date),
    onCurrentDateChange: $2d6137bbf5af1f8e$var$_propTypes2.default.func,
    view: $2d6137bbf5af1f8e$var$_propTypes2.default.oneOf($2d6137bbf5af1f8e$var$VIEW_OPTIONS),
    initialView: $2d6137bbf5af1f8e$var$_propTypes2.default.oneOf($2d6137bbf5af1f8e$var$VIEW_OPTIONS),
    finalView: function finalView(props, propName, componentName) {
        for(var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
        var err = $2d6137bbf5af1f8e$var$_propTypes2.default.oneOf($2d6137bbf5af1f8e$var$VIEW_OPTIONS).apply(undefined, [
            props,
            propName,
            componentName
        ].concat(args));
        if (err) return err;
        if ($2d6137bbf5af1f8e$var$VIEW_OPTIONS.indexOf(props[propName]) < $2d6137bbf5af1f8e$var$VIEW_OPTIONS.indexOf(props.initialView)) return new Error(("The `" + propName + "` prop: `" + props[propName] + "` cannot be 'lower' than the `initialView`\n        prop. This creates a range that cannot be rendered.").replace(/\n\t/g, ""));
    },
    onViewChange: $2d6137bbf5af1f8e$var$_propTypes2.default.func,
    onNavigate: $2d6137bbf5af1f8e$var$_propTypes2.default.func,
    culture: $2d6137bbf5af1f8e$var$_propTypes2.default.string,
    footer: $2d6137bbf5af1f8e$var$_propTypes2.default.bool,
    dayComponent: $2d6137bbf5af1f8e$var$_propTypes4.default.elementType,
    headerFormat: $2d6137bbf5af1f8e$var$_propTypes4.default.dateFormat,
    footerFormat: $2d6137bbf5af1f8e$var$_propTypes4.default.dateFormat,
    dayFormat: $2d6137bbf5af1f8e$var$_propTypes4.default.dateFormat,
    dateFormat: $2d6137bbf5af1f8e$var$_propTypes4.default.dateFormat,
    monthFormat: $2d6137bbf5af1f8e$var$_propTypes4.default.dateFormat,
    yearFormat: $2d6137bbf5af1f8e$var$_propTypes4.default.dateFormat,
    decadeFormat: $2d6137bbf5af1f8e$var$_propTypes4.default.dateFormat,
    centuryFormat: $2d6137bbf5af1f8e$var$_propTypes4.default.dateFormat,
    messages: $2d6137bbf5af1f8e$var$_propTypes2.default.shape({
        moveBack: $2d6137bbf5af1f8e$var$_propTypes2.default.string,
        moveForward: $2d6137bbf5af1f8e$var$_propTypes2.default.string
    })
};






var $2d6137bbf5af1f8e$var$Calendar = (0, $2d6137bbf5af1f8e$var$_createReactClass2.default)(($2d6137bbf5af1f8e$var$_obj = {
    displayName: "Calendar",
    mixins: [
        (parcelRequire("5jwiU")),
        (parcelRequire("4cxcq")),
        (parcelRequire("3agVy")),
        (parcelRequire("5NCz1")),
        (parcelRequire("9AXXZ"))(),
        (parcelRequire("k1uk1"))({
            willHandle: function willHandle() {
                if (+this.props.tabIndex === -1) return false;
            }
        })
    ],
    propTypes: $2d6137bbf5af1f8e$var$propTypes,
    getInitialState: function getInitialState() {
        return {
            selectedIndex: 0,
            view: this.props.initialView || "month"
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            min: new Date(1900, 0, 1),
            max: new Date(2099, 11, 31),
            currentDate: new Date(),
            initialView: "month",
            finalView: "century",
            tabIndex: "0",
            footer: false,
            ariaActiveDescendantKey: "calendar",
            messages: $2d6137bbf5af1f8e$var$msgs({})
        };
    },
    componentWillMount: function componentWillMount() {
        this.changeCurrentDate(this.props.value);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var bottom = $2d6137bbf5af1f8e$var$VIEW_OPTIONS.indexOf(nextProps.initialView), top = $2d6137bbf5af1f8e$var$VIEW_OPTIONS.indexOf(nextProps.finalView), current = $2d6137bbf5af1f8e$var$VIEW_OPTIONS.indexOf(this.state.view), view = this.state.view, val = this.inRangeValue(nextProps.value);
        if (current < bottom) this.setState({
            view: view = nextProps.initialView
        });
        else if (current > top) this.setState({
            view: view = nextProps.finalView
        });
        //if the value changes reset views to the new one
        if (!$2d6137bbf5af1f8e$var$_dates2.default.eq(val, $2d6137bbf5af1f8e$var$dateOrNull(this.props.value), $2d6137bbf5af1f8e$var$VIEW_UNIT[view])) this.changeCurrentDate(val, nextProps.currentDate);
    },
    render: function render() {
        var _this = this;
        var _props = this.props, className = _props.className, value = _props.value, footerFormat = _props.footerFormat, disabled = _props.disabled, readOnly = _props.readOnly, finalView = _props.finalView, footer = _props.footer, messages = _props.messages, min = _props.min, max = _props.max, culture = _props.culture, duration = _props.duration, tabIndex = _props.tabIndex, currentDate = _props.currentDate;
        var _state = this.state, view = _state.view, slideDirection = _state.slideDirection, focused = _state.focused;
        var View = $2d6137bbf5af1f8e$var$VIEW[view], unit = $2d6137bbf5af1f8e$var$VIEW_UNIT[view], todaysDate = new Date(), todayNotInRange = !$2d6137bbf5af1f8e$var$_dates2.default.inRange(todaysDate, min, max, view);
        unit = unit === "day" ? "date" : unit;
        var viewID = (0, $b6t9X.instanceId)(this, "_calendar"), labelID = (0, $b6t9X.instanceId)(this, "_calendar_label"), key = view + "_" + $2d6137bbf5af1f8e$var$_dates2.default[view](currentDate);
        var elementProps = $2d6137bbf5af1f8e$var$_3.default.omitOwnProps(this), viewProps = $2d6137bbf5af1f8e$var$_3.default.pickProps(this.props, View);
        var isDisabled = disabled || readOnly;
        messages = $2d6137bbf5af1f8e$var$msgs(this.props.messages);
        return $2d6137bbf5af1f8e$var$_react2.default.createElement($2d6137bbf5af1f8e$var$_Widget2.default, $2d6137bbf5af1f8e$var$_extends({}, elementProps, {
            role: "group",
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            tabIndex: tabIndex || 0,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            className: (0, $2d6137bbf5af1f8e$var$_classnames2.default)(className, "rw-calendar")
        }), $2d6137bbf5af1f8e$var$_react2.default.createElement($2d6137bbf5af1f8e$var$_Header2.default, {
            label: this._label(),
            labelId: labelID,
            messages: messages,
            upDisabled: isDisabled || view === finalView,
            prevDisabled: isDisabled || !$2d6137bbf5af1f8e$var$_dates2.default.inRange(this.nextDate($2d6137bbf5af1f8e$var$dir.LEFT), min, max, view),
            nextDisabled: isDisabled || !$2d6137bbf5af1f8e$var$_dates2.default.inRange(this.nextDate($2d6137bbf5af1f8e$var$dir.RIGHT), min, max, view),
            onViewChange: this.navigate.bind(null, $2d6137bbf5af1f8e$var$dir.UP, null),
            onMoveLeft: this.navigate.bind(null, $2d6137bbf5af1f8e$var$dir.LEFT, null),
            onMoveRight: this.navigate.bind(null, $2d6137bbf5af1f8e$var$dir.RIGHT, null)
        }), $2d6137bbf5af1f8e$var$_react2.default.createElement($2d6137bbf5af1f8e$var$_SlideTransition2.default, {
            ref: "animation",
            duration: duration,
            direction: slideDirection,
            onAnimate: function onAnimate() {
                return focused && _this.focus();
            }
        }, $2d6137bbf5af1f8e$var$_react2.default.createElement(View, $2d6137bbf5af1f8e$var$_extends({}, viewProps, {
            key: key,
            id: viewID,
            value: value,
            today: todaysDate,
            focused: currentDate,
            onChange: this.change,
            onKeyDown: this.handleKeyDown,
            "aria-labelledby": labelID,
            ariaActiveDescendantKey: "calendarView"
        }))), footer && $2d6137bbf5af1f8e$var$_react2.default.createElement($2d6137bbf5af1f8e$var$_Footer2.default, {
            value: todaysDate,
            format: footerFormat,
            culture: culture,
            disabled: disabled || todayNotInRange,
            readOnly: readOnly,
            onClick: this.select
        }));
    },
    navigate: function navigate(direction, date) {
        var view = this.state.view, slideDir = direction === $2d6137bbf5af1f8e$var$dir.LEFT || direction === $2d6137bbf5af1f8e$var$dir.UP ? "right" : "left";
        if (!date) date = [
            $2d6137bbf5af1f8e$var$dir.LEFT,
            $2d6137bbf5af1f8e$var$dir.RIGHT
        ].indexOf(direction) !== -1 ? this.nextDate(direction) : this.props.currentDate;
        if (direction === $2d6137bbf5af1f8e$var$dir.DOWN) view = $2d6137bbf5af1f8e$var$ALT_VIEW[view] || view;
        if (direction === $2d6137bbf5af1f8e$var$dir.UP) view = $2d6137bbf5af1f8e$var$NEXT_VIEW[view] || view;
        if (this.isValidView(view) && $2d6137bbf5af1f8e$var$_dates2.default.inRange(date, this.props.min, this.props.max, view)) {
            (0, $b6t9X.notify)(this.props.onNavigate, [
                date,
                slideDir,
                view
            ]);
            this.focus(true);
            this.changeCurrentDate(date);
            this.setState({
                slideDirection: slideDir,
                view: view
            });
        }
    },
    focus: function focus() {
        if (+this.props.tabIndex > -1) $2d6137bbf5af1f8e$var$_compat2.default.findDOMNode(this).focus();
    },
    change: function change(date) {
        if (this.state.view === this.props.initialView) {
            this.changeCurrentDate(date);
            (0, $b6t9X.notify)(this.props.onChange, date);
            this.focus();
            return;
        }
        this.navigate($2d6137bbf5af1f8e$var$dir.DOWN, date);
    },
    changeCurrentDate: function changeCurrentDate(date) {
        var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.currentDate;
        var inRangeDate = this.inRangeValue(date ? new Date(date) : currentDate);
        if ($2d6137bbf5af1f8e$var$_dates2.default.eq(inRangeDate, $2d6137bbf5af1f8e$var$dateOrNull(currentDate), $2d6137bbf5af1f8e$var$VIEW_UNIT[this.state.view])) return;
        (0, $b6t9X.notify)(this.props.onCurrentDateChange, inRangeDate);
    },
    select: function select(date) {
        var view = this.props.initialView, slideDir = view !== this.state.view || $2d6137bbf5af1f8e$var$_dates2.default.gt(date, this.state.currentDate) ? "left" // move down to a the view
         : "right";
        (0, $b6t9X.notify)(this.props.onChange, date);
        if (this.isValidView(view) && $2d6137bbf5af1f8e$var$_dates2.default.inRange(date, this.props.min, this.props.max, view)) {
            this.focus();
            this.changeCurrentDate(date);
            this.setState({
                slideDirection: slideDir,
                view: view
            });
        }
    },
    nextDate: function nextDate(direction) {
        var method = direction === $2d6137bbf5af1f8e$var$dir.LEFT ? "subtract" : "add", view = this.state.view, unit = view === $2d6137bbf5af1f8e$var$views.MONTH ? view : $2d6137bbf5af1f8e$var$views.YEAR, multi = $2d6137bbf5af1f8e$var$MULTIPLIER[view] || 1;
        return $2d6137bbf5af1f8e$var$_dates2.default[method](this.props.currentDate, 1 * multi, unit);
    },
    handleKeyDown: function handleKeyDown(e) {
        var ctrl = e.ctrlKey, key = e.key, direction = $2d6137bbf5af1f8e$var$ARROWS_TO_DIRECTION[key], current = this.props.currentDate, view = this.state.view, unit = $2d6137bbf5af1f8e$var$VIEW_UNIT[view], currentDate = current;
        if (key === "Enter") {
            e.preventDefault();
            return this.change(current);
        }
        if (direction) {
            if (ctrl) {
                e.preventDefault();
                this.navigate(direction);
            } else {
                if (this.isRtl() && $2d6137bbf5af1f8e$var$OPPOSITE_DIRECTION[direction]) direction = $2d6137bbf5af1f8e$var$OPPOSITE_DIRECTION[direction];
                currentDate = $2d6137bbf5af1f8e$var$_dates2.default.move(currentDate, this.props.min, this.props.max, view, direction);
                if (!$2d6137bbf5af1f8e$var$_dates2.default.eq(current, currentDate, unit)) {
                    e.preventDefault();
                    if ($2d6137bbf5af1f8e$var$_dates2.default.gt(currentDate, current, view)) this.navigate($2d6137bbf5af1f8e$var$dir.RIGHT, currentDate);
                    else if ($2d6137bbf5af1f8e$var$_dates2.default.lt(currentDate, current, view)) this.navigate($2d6137bbf5af1f8e$var$dir.LEFT, currentDate);
                    else this.changeCurrentDate(currentDate);
                }
            }
        }
        (0, $b6t9X.notify)(this.props.onKeyDown, [
            e
        ]);
    },
    _label: function _label() {
        var _props2 = this.props, culture = _props2.culture, props = $2d6137bbf5af1f8e$var$_objectWithoutProperties(_props2, [
            "culture"
        ]), view = this.state.view, dt = this.props.currentDate;
        if (view === "month") return $d6vOx.date.format(dt, $2d6137bbf5af1f8e$var$format(props, "header"), culture);
        else if (view === "year") return $d6vOx.date.format(dt, $2d6137bbf5af1f8e$var$format(props, "year"), culture);
        else if (view === "decade") return $d6vOx.date.format($2d6137bbf5af1f8e$var$_dates2.default.startOf(dt, "decade"), $2d6137bbf5af1f8e$var$format(props, "decade"), culture);
        else if (view === "century") return $d6vOx.date.format($2d6137bbf5af1f8e$var$_dates2.default.startOf(dt, "century"), $2d6137bbf5af1f8e$var$format(props, "century"), culture);
    },
    inRangeValue: function inRangeValue(_value) {
        var value = $2d6137bbf5af1f8e$var$dateOrNull(_value);
        if (value === null) return value;
        return $2d6137bbf5af1f8e$var$_dates2.default.max($2d6137bbf5af1f8e$var$_dates2.default.min(value, this.props.max), this.props.min);
    },
    isValidView: function isValidView(next) {
        var bottom = $2d6137bbf5af1f8e$var$VIEW_OPTIONS.indexOf(this.props.initialView), top = $2d6137bbf5af1f8e$var$VIEW_OPTIONS.indexOf(this.props.finalView), current = $2d6137bbf5af1f8e$var$VIEW_OPTIONS.indexOf(next);
        return current >= bottom && current <= top;
    }
}, $2d6137bbf5af1f8e$var$_applyDecoratedDescriptor($2d6137bbf5af1f8e$var$_obj, "navigate", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($2d6137bbf5af1f8e$var$_obj, "navigate"), $2d6137bbf5af1f8e$var$_obj), $2d6137bbf5af1f8e$var$_applyDecoratedDescriptor($2d6137bbf5af1f8e$var$_obj, "change", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($2d6137bbf5af1f8e$var$_obj, "change"), $2d6137bbf5af1f8e$var$_obj), $2d6137bbf5af1f8e$var$_applyDecoratedDescriptor($2d6137bbf5af1f8e$var$_obj, "select", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($2d6137bbf5af1f8e$var$_obj, "select"), $2d6137bbf5af1f8e$var$_obj), $2d6137bbf5af1f8e$var$_applyDecoratedDescriptor($2d6137bbf5af1f8e$var$_obj, "handleKeyDown", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($2d6137bbf5af1f8e$var$_obj, "handleKeyDown"), $2d6137bbf5af1f8e$var$_obj), $2d6137bbf5af1f8e$var$_obj));
function $2d6137bbf5af1f8e$var$dateOrNull(dt) {
    if (dt && !isNaN(dt.getTime())) return dt;
    return null;
}
function $2d6137bbf5af1f8e$var$msgs(msgs) {
    return $2d6137bbf5af1f8e$var$_extends({
        moveBack: "navigate back",
        moveForward: "navigate forward"
    }, msgs);
}
module.exports.default = (0, $2d6137bbf5af1f8e$var$_uncontrollable2.default)($2d6137bbf5af1f8e$var$Calendar, {
    value: "onChange",
    currentDate: "onCurrentDateChange",
    view: "onViewChange"
}, [
    "focus"
]);
module.exports = module.exports["default"];

});
parcelRegister("gzEq6", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $7PdBe = parcelRequire("7PdBe");
var $c10f44ccab878fa0$var$_react2 = $c10f44ccab878fa0$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $c10f44ccab878fa0$var$_propTypes2 = $c10f44ccab878fa0$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $c10f44ccab878fa0$var$_createReactClass2 = $c10f44ccab878fa0$var$_interopRequireDefault($5JTQC);

var $6MCLm = parcelRequire("6MCLm");
var $c10f44ccab878fa0$var$_Button2 = $c10f44ccab878fa0$var$_interopRequireDefault($6MCLm);
function $c10f44ccab878fa0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


module.exports.default = (0, $c10f44ccab878fa0$var$_createReactClass2.default)({
    displayName: "Header",
    propTypes: {
        label: $c10f44ccab878fa0$var$_propTypes2.default.string.isRequired,
        labelId: $c10f44ccab878fa0$var$_propTypes2.default.string,
        upDisabled: $c10f44ccab878fa0$var$_propTypes2.default.bool.isRequired,
        prevDisabled: $c10f44ccab878fa0$var$_propTypes2.default.bool.isRequired,
        nextDisabled: $c10f44ccab878fa0$var$_propTypes2.default.bool.isRequired,
        onViewChange: $c10f44ccab878fa0$var$_propTypes2.default.func.isRequired,
        onMoveLeft: $c10f44ccab878fa0$var$_propTypes2.default.func.isRequired,
        onMoveRight: $c10f44ccab878fa0$var$_propTypes2.default.func.isRequired,
        messages: $c10f44ccab878fa0$var$_propTypes2.default.shape({
            moveBack: $c10f44ccab878fa0$var$_propTypes2.default.string,
            moveForward: $c10f44ccab878fa0$var$_propTypes2.default.string
        })
    },
    mixins: [
        (parcelRequire("3agVy")),
        (parcelRequire("fFwwU"))
    ],
    getDefaultProps: function getDefaultProps() {
        return {
            messages: {
                moveBack: "navigate back",
                moveForward: "navigate forward"
            }
        };
    },
    render: function render() {
        var _props = this.props, messages = _props.messages, label = _props.label, labelId = _props.labelId, onMoveRight = _props.onMoveRight, onMoveLeft = _props.onMoveLeft, onViewChange = _props.onViewChange, prevDisabled = _props.prevDisabled, upDisabled = _props.upDisabled, nextDisabled = _props.nextDisabled;
        var rtl = this.isRtl();
        return $c10f44ccab878fa0$var$_react2.default.createElement("div", {
            className: "rw-header"
        }, $c10f44ccab878fa0$var$_react2.default.createElement($c10f44ccab878fa0$var$_Button2.default, {
            className: "rw-btn-left",
            onClick: onMoveLeft,
            disabled: prevDisabled,
            label: messages.moveBack,
            icon: "caret-" + (rtl ? "right" : "left")
        }), $c10f44ccab878fa0$var$_react2.default.createElement($c10f44ccab878fa0$var$_Button2.default, {
            id: labelId,
            onClick: onViewChange,
            className: "rw-btn-view",
            disabled: upDisabled,
            "aria-live": "polite",
            "aria-atomic": "true"
        }, label), $c10f44ccab878fa0$var$_react2.default.createElement($c10f44ccab878fa0$var$_Button2.default, {
            className: "rw-btn-right",
            onClick: onMoveRight,
            disabled: nextDisabled,
            label: messages.moveForward,
            icon: "caret-" + (rtl ? "left" : "right")
        }));
    }
});
module.exports = module.exports["default"];

});
parcelRegister("fFwwU", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $S29Lp = parcelRequire("S29Lp");
var $b683eb151a9299f6$var$_propTypes2 = $b683eb151a9299f6$var$_interopRequireDefault($S29Lp);
function $b683eb151a9299f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = {
    contextTypes: {
        isRtl: $b683eb151a9299f6$var$_propTypes2.default.bool
    },
    isRtl: function isRtl() {
        return !!this.context.isRtl;
    }
};
module.exports = module.exports["default"];

});


parcelRegister("8Mjo5", function(module, exports) {
"use strict";

var $7PdBe = parcelRequire("7PdBe");
var $6641d86674aeb8f9$var$_react2 = $6641d86674aeb8f9$var$_interopRequireDefault($7PdBe);

var $5JTQC = parcelRequire("5JTQC");
var $6641d86674aeb8f9$var$_createReactClass2 = $6641d86674aeb8f9$var$_interopRequireDefault($5JTQC);

var $6MCLm = parcelRequire("6MCLm");
var $6641d86674aeb8f9$var$_Button2 = $6641d86674aeb8f9$var$_interopRequireDefault($6MCLm);

var $d6vOx = parcelRequire("d6vOx");
function $6641d86674aeb8f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6641d86674aeb8f9$var$format = function format(props) {
    return $d6vOx.date.getFormat("footer", props.format);
};
module.exports = (0, $6641d86674aeb8f9$var$_createReactClass2.default)({
    displayName: "Footer",
    render: function render() {
        var _props = this.props, disabled = _props.disabled, readOnly = _props.readOnly, value = _props.value;
        return $6641d86674aeb8f9$var$_react2.default.createElement("div", {
            className: "rw-footer"
        }, $6641d86674aeb8f9$var$_react2.default.createElement($6641d86674aeb8f9$var$_Button2.default, {
            disabled: !!(disabled || readOnly),
            onClick: this.props.onClick.bind(null, value)
        }, $d6vOx.date.format(value, $6641d86674aeb8f9$var$format(this.props), this.props.culture)));
    }
});

});

parcelRegister("lFqOo", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $7PdBe = parcelRequire("7PdBe");
var $fc6239930ff0120f$var$_react2 = $fc6239930ff0120f$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $fc6239930ff0120f$var$_propTypes2 = $fc6239930ff0120f$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $fc6239930ff0120f$var$_createReactClass2 = $fc6239930ff0120f$var$_interopRequireDefault($5JTQC);

var $lCjaG = parcelRequire("lCjaG");
var $fc6239930ff0120f$var$_CalendarView2 = $fc6239930ff0120f$var$_interopRequireDefault($lCjaG);

var $ecwgv = parcelRequire("ecwgv");
var $fc6239930ff0120f$var$_dates2 = $fc6239930ff0120f$var$_interopRequireDefault($ecwgv);

var $d6vOx = parcelRequire("d6vOx");

var $8v4NT = parcelRequire("8v4NT");
var $fc6239930ff0120f$var$_propTypes4 = $fc6239930ff0120f$var$_interopRequireDefault($8v4NT);

var $4cOpg = parcelRequire("4cOpg");
var $fc6239930ff0120f$var$_3 = $fc6239930ff0120f$var$_interopRequireDefault($4cOpg);

var $b6t9X = parcelRequire("b6t9X");
function $fc6239930ff0120f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fc6239930ff0120f$var$dayFormat = function dayFormat(props) {
    return $d6vOx.date.getFormat("weekday", props.dayFormat);
}, $fc6239930ff0120f$var$dateFormat = function dateFormat(props) {
    return $d6vOx.date.getFormat("dayOfMonth", props.dateFormat);
};
var $fc6239930ff0120f$var$optionId = function optionId(id, date) {
    return id + "__month_" + $fc6239930ff0120f$var$_dates2.default.month(date) + "-" + $fc6239930ff0120f$var$_dates2.default.date(date);
};
var $fc6239930ff0120f$var$propTypes = {
    culture: $fc6239930ff0120f$var$_propTypes2.default.string,
    today: $fc6239930ff0120f$var$_propTypes2.default.instanceOf(Date),
    value: $fc6239930ff0120f$var$_propTypes2.default.instanceOf(Date),
    focused: $fc6239930ff0120f$var$_propTypes2.default.instanceOf(Date),
    min: $fc6239930ff0120f$var$_propTypes2.default.instanceOf(Date),
    max: $fc6239930ff0120f$var$_propTypes2.default.instanceOf(Date),
    onChange: $fc6239930ff0120f$var$_propTypes2.default.func.isRequired,
    dayComponent: $fc6239930ff0120f$var$_propTypes4.default.elementType,
    dayFormat: $fc6239930ff0120f$var$_propTypes4.default.dateFormat,
    dateFormat: $fc6239930ff0120f$var$_propTypes4.default.dateFormat
};
var $fc6239930ff0120f$var$isEqual = function isEqual(dateA, dateB) {
    return $fc6239930ff0120f$var$_dates2.default.eq(dateA, dateB, "day");
};


var $fc6239930ff0120f$var$MonthView = (0, $fc6239930ff0120f$var$_createReactClass2.default)({
    displayName: "MonthView",
    statics: {
        isEqual: $fc6239930ff0120f$var$isEqual
    },
    mixins: [
        (parcelRequire("fFwwU")),
        (parcelRequire("9AXXZ"))()
    ],
    propTypes: $fc6239930ff0120f$var$propTypes,
    componentDidUpdate: function componentDidUpdate() {
        var activeId = $fc6239930ff0120f$var$optionId((0, $b6t9X.instanceId)(this), this.props.focused);
        this.ariaActiveDescendant(activeId, null);
    },
    render: function render() {
        var _props = this.props, focused = _props.focused, culture = _props.culture, month = $fc6239930ff0120f$var$_dates2.default.visibleDays(focused, culture), rows = $fc6239930ff0120f$var$_3.default.chunk(month, 7);
        return $fc6239930ff0120f$var$_react2.default.createElement($fc6239930ff0120f$var$_CalendarView2.default, $fc6239930ff0120f$var$_3.default.omitOwnProps(this), $fc6239930ff0120f$var$_react2.default.createElement("thead", null, $fc6239930ff0120f$var$_react2.default.createElement("tr", null, this.renderHeaders(rows[0], $fc6239930ff0120f$var$dayFormat(this.props), culture))), $fc6239930ff0120f$var$_react2.default.createElement("tbody", null, rows.map(this.renderRow)));
    },
    renderRow: function renderRow(row, rowIdx) {
        var _this = this;
        var _props2 = this.props, focused = _props2.focused, today = _props2.today, disabled = _props2.disabled, onChange = _props2.onChange, value = _props2.value, culture = _props2.culture, min = _props2.min, max = _props2.max, Day = _props2.dayComponent, id = (0, $b6t9X.instanceId)(this), labelFormat = $d6vOx.date.getFormat("footer");
        return $fc6239930ff0120f$var$_react2.default.createElement($fc6239930ff0120f$var$_CalendarView2.default.Row, {
            key: rowIdx
        }, row.map(function(date, colIdx) {
            var formattedDate = $d6vOx.date.format(date, $fc6239930ff0120f$var$dateFormat(_this.props), culture), label = $d6vOx.date.format(date, labelFormat, culture);
            return $fc6239930ff0120f$var$_react2.default.createElement($fc6239930ff0120f$var$_CalendarView2.default.Cell, {
                key: colIdx,
                id: $fc6239930ff0120f$var$optionId(id, date),
                label: label,
                date: date,
                now: today,
                min: min,
                max: max,
                unit: "day",
                viewUnit: "month",
                onChange: onChange,
                focused: focused,
                selected: value,
                disabled: disabled
            }, Day ? $fc6239930ff0120f$var$_react2.default.createElement(Day, {
                date: date,
                label: formattedDate
            }) : formattedDate);
        }));
    },
    renderHeaders: function renderHeaders(week, format, culture) {
        return week.map(function(date) {
            return $fc6239930ff0120f$var$_react2.default.createElement("th", {
                key: "header_" + $fc6239930ff0120f$var$_dates2.default.weekday(date, undefined, $d6vOx.date.startOfWeek(culture))
            }, $d6vOx.date.format(date, format, culture));
        });
    }
});
module.exports.default = $fc6239930ff0120f$var$MonthView;
module.exports = module.exports["default"];

});
parcelRegister("lCjaG", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $fbcc049b04a3d5f8$var$_class, $fbcc049b04a3d5f8$var$_temp2;
var $fbcc049b04a3d5f8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $fbcc049b04a3d5f8$var$_react2 = $fbcc049b04a3d5f8$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $fbcc049b04a3d5f8$var$_propTypes2 = $fbcc049b04a3d5f8$var$_interopRequireDefault($S29Lp);

var $ksXgP = parcelRequire("ksXgP");
var $fbcc049b04a3d5f8$var$_classnames2 = $fbcc049b04a3d5f8$var$_interopRequireDefault($ksXgP);

var $ecwgv = parcelRequire("ecwgv");
var $fbcc049b04a3d5f8$var$_dates2 = $fbcc049b04a3d5f8$var$_interopRequireDefault($ecwgv);
function $fbcc049b04a3d5f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fbcc049b04a3d5f8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fbcc049b04a3d5f8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fbcc049b04a3d5f8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $fbcc049b04a3d5f8$var$VIEW_UNITS = [
    "month",
    "year",
    "decade",
    "century"
];
function $fbcc049b04a3d5f8$var$clamp(date, min, max) {
    return $fbcc049b04a3d5f8$var$_dates2.default.max($fbcc049b04a3d5f8$var$_dates2.default.min(date, max), min);
}
var $fbcc049b04a3d5f8$var$CalendarView = function(_React$Component) {
    $fbcc049b04a3d5f8$var$_inherits(CalendarView, _React$Component);
    function CalendarView() {
        $fbcc049b04a3d5f8$var$_classCallCheck(this, CalendarView);
        return $fbcc049b04a3d5f8$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    CalendarView.prototype.render = function render() {
        var className = this.props.className;
        return $fbcc049b04a3d5f8$var$_react2.default.createElement("table", $fbcc049b04a3d5f8$var$_extends({}, this.props, {
            role: "grid",
            tabIndex: "-1",
            className: (0, $fbcc049b04a3d5f8$var$_classnames2.default)(className, "rw-nav-view", "rw-calendar-grid")
        }));
    };
    return CalendarView;
}($fbcc049b04a3d5f8$var$_react2.default.Component);
var $fbcc049b04a3d5f8$var$CalendarViewCell = ($fbcc049b04a3d5f8$var$_temp2 = $fbcc049b04a3d5f8$var$_class = function(_React$Component2) {
    $fbcc049b04a3d5f8$var$_inherits(CalendarViewCell, _React$Component2);
    function CalendarViewCell() {
        var _temp, _this2, _ret;
        $fbcc049b04a3d5f8$var$_classCallCheck(this, CalendarViewCell);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this2 = $fbcc049b04a3d5f8$var$_possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [
            this
        ].concat(args))), _this2), _this2.handleChange = function() {
            var _this2$props = _this2.props, onChange = _this2$props.onChange, min = _this2$props.min, max = _this2$props.max, date = _this2$props.date;
            onChange($fbcc049b04a3d5f8$var$clamp(date, min, max));
        }, _temp), $fbcc049b04a3d5f8$var$_possibleConstructorReturn(_this2, _ret);
    }
    CalendarViewCell.prototype.isEqual = function isEqual(date) {
        return $fbcc049b04a3d5f8$var$_dates2.default.eq(this.props.date, date, this.props.unit);
    };
    CalendarViewCell.prototype.isEmpty = function isEmpty() {
        var _props = this.props, unit = _props.unit, min = _props.min, max = _props.max, date = _props.date;
        return !$fbcc049b04a3d5f8$var$_dates2.default.inRange(date, min, max, unit);
    };
    CalendarViewCell.prototype.isNow = function isNow() {
        return this.isEqual(this.props.now);
    };
    CalendarViewCell.prototype.isFocused = function isFocused() {
        return this.isEqual(this.props.focused);
    };
    CalendarViewCell.prototype.isSelected = function isSelected() {
        return this.isEqual(this.props.selected);
    };
    CalendarViewCell.prototype.isOffView = function isOffView() {
        var _props2 = this.props, viewUnit = _props2.viewUnit, focused = _props2.focused, date = _props2.date;
        return viewUnit && $fbcc049b04a3d5f8$var$_dates2.default[viewUnit](date) !== $fbcc049b04a3d5f8$var$_dates2.default[viewUnit](focused);
    };
    CalendarViewCell.prototype.render = function render() {
        var _props3 = this.props, children = _props3.children, id = _props3.id, label = _props3.label, disabled = _props3.disabled;
        if (this.isEmpty()) return $fbcc049b04a3d5f8$var$_react2.default.createElement("td", {
            className: "rw-empty-cell",
            role: "presentation"
        }, "\xa0");
        return $fbcc049b04a3d5f8$var$_react2.default.createElement("td", {
            role: "gridcell",
            id: id,
            title: label,
            "aria-label": label,
            "aria-readonly": disabled,
            "aria-selected": this.isSelected()
        }, $fbcc049b04a3d5f8$var$_react2.default.createElement("span", {
            "aria-labelledby": id,
            onClick: this.handleChange,
            className: (0, $fbcc049b04a3d5f8$var$_classnames2.default)("rw-btn", this.isNow() && "rw-now", this.isOffView() && "rw-off-range", this.isFocused() && "rw-state-focus", this.isSelected() && "rw-state-selected")
        }, children));
    };
    return CalendarViewCell;
}($fbcc049b04a3d5f8$var$_react2.default.Component), $fbcc049b04a3d5f8$var$_class.propTypes = {
    id: $fbcc049b04a3d5f8$var$_propTypes2.default.string,
    label: $fbcc049b04a3d5f8$var$_propTypes2.default.string,
    today: $fbcc049b04a3d5f8$var$_propTypes2.default.instanceOf(Date),
    selected: $fbcc049b04a3d5f8$var$_propTypes2.default.instanceOf(Date),
    focused: $fbcc049b04a3d5f8$var$_propTypes2.default.instanceOf(Date),
    min: $fbcc049b04a3d5f8$var$_propTypes2.default.instanceOf(Date),
    max: $fbcc049b04a3d5f8$var$_propTypes2.default.instanceOf(Date),
    unit: $fbcc049b04a3d5f8$var$_propTypes2.default.oneOf([
        "day"
    ].concat($fbcc049b04a3d5f8$var$VIEW_UNITS)),
    viewUnit: $fbcc049b04a3d5f8$var$_propTypes2.default.oneOf($fbcc049b04a3d5f8$var$VIEW_UNITS),
    onChange: $fbcc049b04a3d5f8$var$_propTypes2.default.func.isRequired
}, $fbcc049b04a3d5f8$var$_temp2);
$fbcc049b04a3d5f8$var$CalendarView.Row = function(props) {
    return $fbcc049b04a3d5f8$var$_react2.default.createElement("tr", $fbcc049b04a3d5f8$var$_extends({
        role: "row"
    }, props));
};
$fbcc049b04a3d5f8$var$CalendarView.Cell = $fbcc049b04a3d5f8$var$CalendarViewCell;
module.exports.default = $fbcc049b04a3d5f8$var$CalendarView;
module.exports = module.exports["default"];

});
parcelRegister("ecwgv", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $a56b36e39931a6df$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $dQVfm = parcelRequire("dQVfm");
var $a56b36e39931a6df$var$_dateArithmetic2 = $a56b36e39931a6df$var$_interopRequireDefault($dQVfm);

var $jn9XT = parcelRequire("jn9XT");

var $d6vOx = parcelRequire("d6vOx");
function $a56b36e39931a6df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a56b36e39931a6df$var$dates = $a56b36e39931a6df$var$_extends({}, $a56b36e39931a6df$var$_dateArithmetic2.default, {
    parse: function parse(date, format, culture) {
        return $d6vOx.date.parse(date, format, culture);
    },
    format: function format(date, _format, culture) {
        return $d6vOx.date.format(date, _format, culture);
    },
    monthsInYear: function monthsInYear(year) {
        var months = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], date = new Date(year, 0, 1);
        return months.map(function(i) {
            return $a56b36e39931a6df$var$dates.month(date, i);
        });
    },
    firstVisibleDay: function firstVisibleDay(date, culture) {
        var firstOfMonth = $a56b36e39931a6df$var$dates.startOf(date, "month");
        return $a56b36e39931a6df$var$dates.startOf(firstOfMonth, "week", $d6vOx.date.startOfWeek(culture));
    },
    lastVisibleDay: function lastVisibleDay(date, culture) {
        var endOfMonth = $a56b36e39931a6df$var$dates.endOf(date, "month");
        return $a56b36e39931a6df$var$dates.endOf(endOfMonth, "week", $d6vOx.date.startOfWeek(culture));
    },
    visibleDays: function visibleDays(date, culture) {
        var current = $a56b36e39931a6df$var$dates.firstVisibleDay(date, culture), last = $a56b36e39931a6df$var$dates.lastVisibleDay(date, culture), days = [];
        while($a56b36e39931a6df$var$dates.lte(current, last, "day")){
            days.push(current);
            current = $a56b36e39931a6df$var$dates.add(current, 1, "day");
        }
        return days;
    },
    move: function move(date, min, max, unit, direction) {
        var isMonth = unit === "month", isUpOrDown = direction === $jn9XT.directions.UP || direction === $jn9XT.directions.DOWN, rangeUnit = $jn9XT.calendarViewUnits[unit], addUnit = isMonth && isUpOrDown ? "week" : $jn9XT.calendarViewUnits[unit], amount = isMonth || !isUpOrDown ? 1 : 4, newDate;
        if (direction === $jn9XT.directions.UP || direction === $jn9XT.directions.LEFT) amount *= -1;
        newDate = $a56b36e39931a6df$var$dates.add(date, amount, addUnit);
        return $a56b36e39931a6df$var$dates.inRange(newDate, min, max, rangeUnit) ? newDate : date;
    },
    merge: function merge(date, time, defaultDate) {
        if (time == null && date == null) return null;
        if (time == null) time = defaultDate || new Date();
        if (date == null) date = defaultDate || new Date();
        date = $a56b36e39931a6df$var$dates.startOf(date, "day");
        date = $a56b36e39931a6df$var$dates.hours(date, $a56b36e39931a6df$var$dates.hours(time));
        date = $a56b36e39931a6df$var$dates.minutes(date, $a56b36e39931a6df$var$dates.minutes(time));
        date = $a56b36e39931a6df$var$dates.seconds(date, $a56b36e39931a6df$var$dates.seconds(time));
        return $a56b36e39931a6df$var$dates.milliseconds(date, $a56b36e39931a6df$var$dates.milliseconds(time));
    },
    sameMonth: function sameMonth(dateA, dateB) {
        return $a56b36e39931a6df$var$dates.eq(dateA, dateB, "month");
    },
    today: function today() {
        return this.startOf(new Date(), "day");
    },
    yesterday: function yesterday() {
        return this.add(this.startOf(new Date(), "day"), -1, "day");
    },
    tomorrow: function tomorrow() {
        return this.add(this.startOf(new Date(), "day"), 1, "day");
    }
});
module.exports.default = $a56b36e39931a6df$var$dates;
module.exports = module.exports["default"];

});
parcelRegister("dQVfm", function(module, exports) {
var $a15c89b8642fdec4$var$MILI = "milliseconds", $a15c89b8642fdec4$var$SECONDS = "seconds", $a15c89b8642fdec4$var$MINUTES = "minutes", $a15c89b8642fdec4$var$HOURS = "hours", $a15c89b8642fdec4$var$DAY = "day", $a15c89b8642fdec4$var$WEEK = "week", $a15c89b8642fdec4$var$MONTH = "month", $a15c89b8642fdec4$var$YEAR = "year", $a15c89b8642fdec4$var$DECADE = "decade", $a15c89b8642fdec4$var$CENTURY = "century";
var $a15c89b8642fdec4$var$dates = module.exports = {
    add: function(date, num, unit) {
        date = new Date(date);
        switch(unit){
            case $a15c89b8642fdec4$var$MILI:
            case $a15c89b8642fdec4$var$SECONDS:
            case $a15c89b8642fdec4$var$MINUTES:
            case $a15c89b8642fdec4$var$HOURS:
            case $a15c89b8642fdec4$var$YEAR:
                return $a15c89b8642fdec4$var$dates[unit](date, $a15c89b8642fdec4$var$dates[unit](date) + num);
            case $a15c89b8642fdec4$var$DAY:
                return $a15c89b8642fdec4$var$dates.date(date, $a15c89b8642fdec4$var$dates.date(date) + num);
            case $a15c89b8642fdec4$var$WEEK:
                return $a15c89b8642fdec4$var$dates.date(date, $a15c89b8642fdec4$var$dates.date(date) + 7 * num);
            case $a15c89b8642fdec4$var$MONTH:
                return $a15c89b8642fdec4$var$monthMath(date, num);
            case $a15c89b8642fdec4$var$DECADE:
                return $a15c89b8642fdec4$var$dates.year(date, $a15c89b8642fdec4$var$dates.year(date) + num * 10);
            case $a15c89b8642fdec4$var$CENTURY:
                return $a15c89b8642fdec4$var$dates.year(date, $a15c89b8642fdec4$var$dates.year(date) + num * 100);
        }
        throw new TypeError('Invalid units: "' + unit + '"');
    },
    subtract: function(date, num, unit) {
        return $a15c89b8642fdec4$var$dates.add(date, -num, unit);
    },
    startOf: function(date, unit, firstOfWeek) {
        date = new Date(date);
        switch(unit){
            case "century":
            case "decade":
            case "year":
                date = $a15c89b8642fdec4$var$dates.month(date, 0);
            case "month":
                date = $a15c89b8642fdec4$var$dates.date(date, 1);
            case "week":
            case "day":
                date = $a15c89b8642fdec4$var$dates.hours(date, 0);
            case "hours":
                date = $a15c89b8642fdec4$var$dates.minutes(date, 0);
            case "minutes":
                date = $a15c89b8642fdec4$var$dates.seconds(date, 0);
            case "seconds":
                date = $a15c89b8642fdec4$var$dates.milliseconds(date, 0);
        }
        if (unit === $a15c89b8642fdec4$var$DECADE) date = $a15c89b8642fdec4$var$dates.subtract(date, $a15c89b8642fdec4$var$dates.year(date) % 10, "year");
        if (unit === $a15c89b8642fdec4$var$CENTURY) date = $a15c89b8642fdec4$var$dates.subtract(date, $a15c89b8642fdec4$var$dates.year(date) % 100, "year");
        if (unit === $a15c89b8642fdec4$var$WEEK) date = $a15c89b8642fdec4$var$dates.weekday(date, 0, firstOfWeek);
        return date;
    },
    endOf: function(date, unit, firstOfWeek) {
        date = new Date(date);
        date = $a15c89b8642fdec4$var$dates.startOf(date, unit, firstOfWeek);
        date = $a15c89b8642fdec4$var$dates.add(date, 1, unit);
        date = $a15c89b8642fdec4$var$dates.subtract(date, 1, $a15c89b8642fdec4$var$MILI);
        return date;
    },
    eq: $a15c89b8642fdec4$var$createComparer(function(a, b) {
        return a === b;
    }),
    neq: $a15c89b8642fdec4$var$createComparer(function(a, b) {
        return a !== b;
    }),
    gt: $a15c89b8642fdec4$var$createComparer(function(a, b) {
        return a > b;
    }),
    gte: $a15c89b8642fdec4$var$createComparer(function(a, b) {
        return a >= b;
    }),
    lt: $a15c89b8642fdec4$var$createComparer(function(a, b) {
        return a < b;
    }),
    lte: $a15c89b8642fdec4$var$createComparer(function(a, b) {
        return a <= b;
    }),
    min: function() {
        return new Date(Math.min.apply(Math, arguments));
    },
    max: function() {
        return new Date(Math.max.apply(Math, arguments));
    },
    inRange: function(day, min, max, unit) {
        unit = unit || "day";
        return (!min || $a15c89b8642fdec4$var$dates.gte(day, min, unit)) && (!max || $a15c89b8642fdec4$var$dates.lte(day, max, unit));
    },
    milliseconds: $a15c89b8642fdec4$var$createAccessor("Milliseconds"),
    seconds: $a15c89b8642fdec4$var$createAccessor("Seconds"),
    minutes: $a15c89b8642fdec4$var$createAccessor("Minutes"),
    hours: $a15c89b8642fdec4$var$createAccessor("Hours"),
    day: $a15c89b8642fdec4$var$createAccessor("Day"),
    date: $a15c89b8642fdec4$var$createAccessor("Date"),
    month: $a15c89b8642fdec4$var$createAccessor("Month"),
    year: $a15c89b8642fdec4$var$createAccessor("FullYear"),
    decade: function(date, val) {
        return val === undefined ? $a15c89b8642fdec4$var$dates.year($a15c89b8642fdec4$var$dates.startOf(date, $a15c89b8642fdec4$var$DECADE)) : $a15c89b8642fdec4$var$dates.add(date, val + 10, $a15c89b8642fdec4$var$YEAR);
    },
    century: function(date, val) {
        return val === undefined ? $a15c89b8642fdec4$var$dates.year($a15c89b8642fdec4$var$dates.startOf(date, $a15c89b8642fdec4$var$CENTURY)) : $a15c89b8642fdec4$var$dates.add(date, val + 100, $a15c89b8642fdec4$var$YEAR);
    },
    weekday: function(date, val, firstDay) {
        var weekday = ($a15c89b8642fdec4$var$dates.day(date) + 7 - (firstDay || 0)) % 7;
        return val === undefined ? weekday : $a15c89b8642fdec4$var$dates.add(date, val - weekday, $a15c89b8642fdec4$var$DAY);
    },
    diff: function(date1, date2, unit, asFloat) {
        var dividend, divisor, result;
        switch(unit){
            case $a15c89b8642fdec4$var$MILI:
            case $a15c89b8642fdec4$var$SECONDS:
            case $a15c89b8642fdec4$var$MINUTES:
            case $a15c89b8642fdec4$var$HOURS:
            case $a15c89b8642fdec4$var$DAY:
            case $a15c89b8642fdec4$var$WEEK:
                dividend = date2.getTime() - date1.getTime();
                break;
            case $a15c89b8642fdec4$var$MONTH:
            case $a15c89b8642fdec4$var$YEAR:
            case $a15c89b8642fdec4$var$DECADE:
            case $a15c89b8642fdec4$var$CENTURY:
                dividend = ($a15c89b8642fdec4$var$dates.year(date2) - $a15c89b8642fdec4$var$dates.year(date1)) * 12 + $a15c89b8642fdec4$var$dates.month(date2) - $a15c89b8642fdec4$var$dates.month(date1);
                break;
            default:
                throw new TypeError('Invalid units: "' + unit + '"');
        }
        switch(unit){
            case $a15c89b8642fdec4$var$MILI:
                divisor = 1;
                break;
            case $a15c89b8642fdec4$var$SECONDS:
                divisor = 1000;
                break;
            case $a15c89b8642fdec4$var$MINUTES:
                divisor = 60000;
                break;
            case $a15c89b8642fdec4$var$HOURS:
                divisor = 3600000;
                break;
            case $a15c89b8642fdec4$var$DAY:
                divisor = 86400000;
                break;
            case $a15c89b8642fdec4$var$WEEK:
                divisor = 604800000;
                break;
            case $a15c89b8642fdec4$var$MONTH:
                divisor = 1;
                break;
            case $a15c89b8642fdec4$var$YEAR:
                divisor = 12;
                break;
            case $a15c89b8642fdec4$var$DECADE:
                divisor = 120;
                break;
            case $a15c89b8642fdec4$var$CENTURY:
                divisor = 1200;
                break;
            default:
                throw new TypeError('Invalid units: "' + unit + '"');
        }
        result = dividend / divisor;
        return asFloat ? result : $a15c89b8642fdec4$var$absoluteFloor(result);
    }
};
function $a15c89b8642fdec4$var$absoluteFloor(number) {
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function $a15c89b8642fdec4$var$monthMath(date, val) {
    var current = $a15c89b8642fdec4$var$dates.month(date), newMonth = current + val;
    date = $a15c89b8642fdec4$var$dates.month(date, newMonth);
    while(newMonth < 0)newMonth = 12 + newMonth;
    //month rollover
    if ($a15c89b8642fdec4$var$dates.month(date) !== newMonth % 12) date = $a15c89b8642fdec4$var$dates.date(date, 0) //move to last of month
    ;
    return date;
}
function $a15c89b8642fdec4$var$createAccessor(method) {
    return function(date, val) {
        if (val === undefined) return date["get" + method]();
        date = new Date(date);
        date["set" + method](val);
        return date;
    };
}
function $a15c89b8642fdec4$var$createComparer(operator) {
    return function(a, b, unit) {
        return operator(+$a15c89b8642fdec4$var$dates.startOf(a, unit), +$a15c89b8642fdec4$var$dates.startOf(b, unit));
    };
}

});

parcelRegister("jn9XT", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $e1a7e528096c20c7$export$1e511d4a378977f5; }, function (v) { return $e1a7e528096c20c7$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "directions", function () { return $e1a7e528096c20c7$export$8fc1e0a9d795944b; }, function (v) { return $e1a7e528096c20c7$export$8fc1e0a9d795944b = v; });
$parcel$export(module.exports, "datePopups", function () { return $e1a7e528096c20c7$export$cd7f3c697ad73093; }, function (v) { return $e1a7e528096c20c7$export$cd7f3c697ad73093 = v; });
$parcel$export(module.exports, "calendarViews", function () { return $e1a7e528096c20c7$export$94782752c77b2346; }, function (v) { return $e1a7e528096c20c7$export$94782752c77b2346 = v; });
$parcel$export(module.exports, "calendarViewHierarchy", function () { return $e1a7e528096c20c7$export$abfd20dcf220b491; }, function (v) { return $e1a7e528096c20c7$export$abfd20dcf220b491 = v; });
$parcel$export(module.exports, "calendarViewUnits", function () { return $e1a7e528096c20c7$export$46e217f41366f998; }, function (v) { return $e1a7e528096c20c7$export$46e217f41366f998 = v; });
var $e1a7e528096c20c7$export$1e511d4a378977f5;
var $e1a7e528096c20c7$export$8fc1e0a9d795944b;
var $e1a7e528096c20c7$export$cd7f3c697ad73093;
var $e1a7e528096c20c7$export$94782752c77b2346;
var $e1a7e528096c20c7$export$abfd20dcf220b491;
var $e1a7e528096c20c7$export$46e217f41366f998;
"use strict";
$e1a7e528096c20c7$export$1e511d4a378977f5 = true;
var $e1a7e528096c20c7$var$_calendarViewHierarch, $e1a7e528096c20c7$var$_calendarViewUnits;
var $e1a7e528096c20c7$var$views = {
    MONTH: "month",
    YEAR: "year",
    DECADE: "decade",
    CENTURY: "century"
};
var $e1a7e528096c20c7$var$directions = $e1a7e528096c20c7$export$8fc1e0a9d795944b = {
    LEFT: "LEFT",
    RIGHT: "RIGHT",
    UP: "UP",
    DOWN: "DOWN"
};
var $e1a7e528096c20c7$var$datePopups = $e1a7e528096c20c7$export$cd7f3c697ad73093 = {
    TIME: "time",
    CALENDAR: "calendar"
};
var $e1a7e528096c20c7$var$calendarViews = $e1a7e528096c20c7$export$94782752c77b2346 = $e1a7e528096c20c7$var$views;
var $e1a7e528096c20c7$var$calendarViewHierarchy = $e1a7e528096c20c7$export$abfd20dcf220b491 = ($e1a7e528096c20c7$var$_calendarViewHierarch = {}, $e1a7e528096c20c7$var$_calendarViewHierarch[$e1a7e528096c20c7$var$views.MONTH] = $e1a7e528096c20c7$var$views.YEAR, $e1a7e528096c20c7$var$_calendarViewHierarch[$e1a7e528096c20c7$var$views.YEAR] = $e1a7e528096c20c7$var$views.DECADE, $e1a7e528096c20c7$var$_calendarViewHierarch[$e1a7e528096c20c7$var$views.DECADE] = $e1a7e528096c20c7$var$views.CENTURY, $e1a7e528096c20c7$var$_calendarViewHierarch);
var $e1a7e528096c20c7$var$calendarViewUnits = $e1a7e528096c20c7$export$46e217f41366f998 = ($e1a7e528096c20c7$var$_calendarViewUnits = {}, $e1a7e528096c20c7$var$_calendarViewUnits[$e1a7e528096c20c7$var$views.MONTH] = "day", $e1a7e528096c20c7$var$_calendarViewUnits[$e1a7e528096c20c7$var$views.YEAR] = $e1a7e528096c20c7$var$views.MONTH, $e1a7e528096c20c7$var$_calendarViewUnits[$e1a7e528096c20c7$var$views.DECADE] = $e1a7e528096c20c7$var$views.YEAR, $e1a7e528096c20c7$var$_calendarViewUnits[$e1a7e528096c20c7$var$views.CENTURY] = $e1a7e528096c20c7$var$views.DECADE, $e1a7e528096c20c7$var$_calendarViewUnits);

});




parcelRegister("5Wau1", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $7PdBe = parcelRequire("7PdBe");
var $452a80440b7b6fc1$var$_react2 = $452a80440b7b6fc1$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $452a80440b7b6fc1$var$_propTypes2 = $452a80440b7b6fc1$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $452a80440b7b6fc1$var$_createReactClass2 = $452a80440b7b6fc1$var$_interopRequireDefault($5JTQC);

var $lCjaG = parcelRequire("lCjaG");
var $452a80440b7b6fc1$var$_CalendarView2 = $452a80440b7b6fc1$var$_interopRequireDefault($lCjaG);

var $ecwgv = parcelRequire("ecwgv");
var $452a80440b7b6fc1$var$_dates2 = $452a80440b7b6fc1$var$_interopRequireDefault($ecwgv);

var $d6vOx = parcelRequire("d6vOx");

var $4cOpg = parcelRequire("4cOpg");
var $452a80440b7b6fc1$var$_3 = $452a80440b7b6fc1$var$_interopRequireDefault($4cOpg);

var $8v4NT = parcelRequire("8v4NT");
var $452a80440b7b6fc1$var$_propTypes4 = $452a80440b7b6fc1$var$_interopRequireDefault($8v4NT);

var $b6t9X = parcelRequire("b6t9X");
function $452a80440b7b6fc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $452a80440b7b6fc1$var$format = function format(props) {
    return $d6vOx.date.getFormat("month", props.monthFormat);
};
var $452a80440b7b6fc1$var$propTypes = {
    culture: $452a80440b7b6fc1$var$_propTypes2.default.string,
    today: $452a80440b7b6fc1$var$_propTypes2.default.instanceOf(Date),
    value: $452a80440b7b6fc1$var$_propTypes2.default.instanceOf(Date),
    focused: $452a80440b7b6fc1$var$_propTypes2.default.instanceOf(Date),
    min: $452a80440b7b6fc1$var$_propTypes2.default.instanceOf(Date),
    max: $452a80440b7b6fc1$var$_propTypes2.default.instanceOf(Date),
    onChange: $452a80440b7b6fc1$var$_propTypes2.default.func.isRequired,
    monthFormat: $452a80440b7b6fc1$var$_propTypes4.default.dateFormat
};
var $452a80440b7b6fc1$var$optionId = function optionId(id, date) {
    return id + "__year_" + $452a80440b7b6fc1$var$_dates2.default.year(date) + "-" + $452a80440b7b6fc1$var$_dates2.default.month(date);
};


var $452a80440b7b6fc1$var$YearView = (0, $452a80440b7b6fc1$var$_createReactClass2.default)({
    displayName: "YearView",
    mixins: [
        (parcelRequire("fFwwU")),
        (parcelRequire("9AXXZ"))()
    ],
    propTypes: $452a80440b7b6fc1$var$propTypes,
    componentDidUpdate: function componentDidUpdate() {
        var activeId = $452a80440b7b6fc1$var$optionId((0, $b6t9X.instanceId)(this), this.props.focused);
        this.ariaActiveDescendant(activeId);
    },
    render: function render() {
        var focused = this.props.focused, months = $452a80440b7b6fc1$var$_dates2.default.monthsInYear($452a80440b7b6fc1$var$_dates2.default.year(focused));
        return $452a80440b7b6fc1$var$_react2.default.createElement($452a80440b7b6fc1$var$_CalendarView2.default, $452a80440b7b6fc1$var$_3.default.omitOwnProps(this), $452a80440b7b6fc1$var$_react2.default.createElement("tbody", null, $452a80440b7b6fc1$var$_3.default.chunk(months, 4).map(this.renderRow)));
    },
    renderRow: function renderRow(row, rowIdx) {
        var _this = this;
        var _props = this.props, focused = _props.focused, disabled = _props.disabled, onChange = _props.onChange, value = _props.value, today = _props.today, culture = _props.culture, min = _props.min, max = _props.max;
        var id = (0, $b6t9X.instanceId)(this), labelFormat = $d6vOx.date.getFormat("header");
        return $452a80440b7b6fc1$var$_react2.default.createElement($452a80440b7b6fc1$var$_CalendarView2.default.Row, {
            key: rowIdx
        }, row.map(function(date, colIdx) {
            var label = $d6vOx.date.format(date, labelFormat, culture);
            return $452a80440b7b6fc1$var$_react2.default.createElement($452a80440b7b6fc1$var$_CalendarView2.default.Cell, {
                key: colIdx,
                id: $452a80440b7b6fc1$var$optionId(id, date),
                label: label,
                date: date,
                now: today,
                min: min,
                max: max,
                unit: "month",
                onChange: onChange,
                focused: focused,
                selected: value,
                disabled: disabled
            }, $d6vOx.date.format(date, $452a80440b7b6fc1$var$format(_this.props), culture));
        }));
    }
});
module.exports.default = $452a80440b7b6fc1$var$YearView;
module.exports = module.exports["default"];

});

parcelRegister("h2wol", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $7PdBe = parcelRequire("7PdBe");
var $c67bbfde5cbc306d$var$_react2 = $c67bbfde5cbc306d$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $c67bbfde5cbc306d$var$_propTypes2 = $c67bbfde5cbc306d$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $c67bbfde5cbc306d$var$_createReactClass2 = $c67bbfde5cbc306d$var$_interopRequireDefault($5JTQC);

var $lCjaG = parcelRequire("lCjaG");
var $c67bbfde5cbc306d$var$_CalendarView2 = $c67bbfde5cbc306d$var$_interopRequireDefault($lCjaG);

var $ecwgv = parcelRequire("ecwgv");
var $c67bbfde5cbc306d$var$_dates2 = $c67bbfde5cbc306d$var$_interopRequireDefault($ecwgv);

var $d6vOx = parcelRequire("d6vOx");

var $4cOpg = parcelRequire("4cOpg");
var $c67bbfde5cbc306d$var$_3 = $c67bbfde5cbc306d$var$_interopRequireDefault($4cOpg);

var $8v4NT = parcelRequire("8v4NT");
var $c67bbfde5cbc306d$var$_propTypes4 = $c67bbfde5cbc306d$var$_interopRequireDefault($8v4NT);

var $b6t9X = parcelRequire("b6t9X");
function $c67bbfde5cbc306d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c67bbfde5cbc306d$var$propTypes = {
    culture: $c67bbfde5cbc306d$var$_propTypes2.default.string,
    today: $c67bbfde5cbc306d$var$_propTypes2.default.instanceOf(Date),
    value: $c67bbfde5cbc306d$var$_propTypes2.default.instanceOf(Date),
    focused: $c67bbfde5cbc306d$var$_propTypes2.default.instanceOf(Date),
    min: $c67bbfde5cbc306d$var$_propTypes2.default.instanceOf(Date),
    max: $c67bbfde5cbc306d$var$_propTypes2.default.instanceOf(Date),
    onChange: $c67bbfde5cbc306d$var$_propTypes2.default.func.isRequired,
    yearFormat: $c67bbfde5cbc306d$var$_propTypes4.default.dateFormat
};
var $c67bbfde5cbc306d$var$optionId = function optionId(id, date) {
    return id + "__decade_" + $c67bbfde5cbc306d$var$_dates2.default.year(date);
};



module.exports.default = (0, $c67bbfde5cbc306d$var$_createReactClass2.default)({
    displayName: "DecadeView",
    mixins: [
        (parcelRequire("3agVy")),
        (parcelRequire("fFwwU")),
        (parcelRequire("9AXXZ"))()
    ],
    propTypes: $c67bbfde5cbc306d$var$propTypes,
    componentDidUpdate: function componentDidUpdate() {
        var activeId = $c67bbfde5cbc306d$var$optionId((0, $b6t9X.instanceId)(this), this.props.focused);
        this.ariaActiveDescendant(activeId);
    },
    render: function render() {
        var focused = this.props.focused;
        return $c67bbfde5cbc306d$var$_react2.default.createElement($c67bbfde5cbc306d$var$_CalendarView2.default, $c67bbfde5cbc306d$var$_3.default.omitOwnProps(this), $c67bbfde5cbc306d$var$_react2.default.createElement("tbody", null, $c67bbfde5cbc306d$var$_3.default.chunk($c67bbfde5cbc306d$var$getDecadeYears(focused), 4).map(this.renderRow)));
    },
    renderRow: function renderRow(row, rowIdx) {
        var _props = this.props, focused = _props.focused, disabled = _props.disabled, onChange = _props.onChange, yearFormat = _props.yearFormat, value = _props.value, today = _props.today, culture = _props.culture, min = _props.min, max = _props.max;
        var id = (0, $b6t9X.instanceId)(this);
        return $c67bbfde5cbc306d$var$_react2.default.createElement($c67bbfde5cbc306d$var$_CalendarView2.default.Row, {
            key: rowIdx
        }, row.map(function(date, colIdx) {
            var label = $d6vOx.date.format(date, $d6vOx.date.getFormat("year", yearFormat), culture);
            return $c67bbfde5cbc306d$var$_react2.default.createElement($c67bbfde5cbc306d$var$_CalendarView2.default.Cell, {
                key: colIdx,
                unit: "year",
                id: $c67bbfde5cbc306d$var$optionId(id, date),
                label: label,
                date: date,
                now: today,
                min: min,
                max: max,
                onChange: onChange,
                focused: focused,
                selected: value,
                disabled: disabled
            }, label);
        }));
    }
});
function $c67bbfde5cbc306d$var$getDecadeYears(_date) {
    var days = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ], date = $c67bbfde5cbc306d$var$_dates2.default.add($c67bbfde5cbc306d$var$_dates2.default.startOf(_date, "decade"), -2, "year");
    return days.map(function() {
        return date = $c67bbfde5cbc306d$var$_dates2.default.add(date, 1, "year");
    });
}
module.exports = module.exports["default"];

});

parcelRegister("xygTe", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $7PdBe = parcelRequire("7PdBe");
var $064daac58dd08248$var$_react2 = $064daac58dd08248$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $064daac58dd08248$var$_propTypes2 = $064daac58dd08248$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $064daac58dd08248$var$_createReactClass2 = $064daac58dd08248$var$_interopRequireDefault($5JTQC);

var $lCjaG = parcelRequire("lCjaG");
var $064daac58dd08248$var$_CalendarView2 = $064daac58dd08248$var$_interopRequireDefault($lCjaG);

var $ecwgv = parcelRequire("ecwgv");
var $064daac58dd08248$var$_dates2 = $064daac58dd08248$var$_interopRequireDefault($ecwgv);

var $d6vOx = parcelRequire("d6vOx");

var $4cOpg = parcelRequire("4cOpg");
var $064daac58dd08248$var$_3 = $064daac58dd08248$var$_interopRequireDefault($4cOpg);

var $8v4NT = parcelRequire("8v4NT");
var $064daac58dd08248$var$_propTypes4 = $064daac58dd08248$var$_interopRequireDefault($8v4NT);

var $b6t9X = parcelRequire("b6t9X");
function $064daac58dd08248$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $064daac58dd08248$var$format = function format(props) {
    return $d6vOx.date.getFormat("decade", props.decadeFormat);
};
var $064daac58dd08248$var$optionId = function optionId(id, date) {
    return id + "__century_" + $064daac58dd08248$var$_dates2.default.year(date);
};
var $064daac58dd08248$var$propTypes = {
    culture: $064daac58dd08248$var$_propTypes2.default.string,
    today: $064daac58dd08248$var$_propTypes2.default.instanceOf(Date),
    value: $064daac58dd08248$var$_propTypes2.default.instanceOf(Date),
    focused: $064daac58dd08248$var$_propTypes2.default.instanceOf(Date),
    min: $064daac58dd08248$var$_propTypes2.default.instanceOf(Date),
    max: $064daac58dd08248$var$_propTypes2.default.instanceOf(Date),
    onChange: $064daac58dd08248$var$_propTypes2.default.func.isRequired,
    decadeFormat: $064daac58dd08248$var$_propTypes4.default.dateFormat
};



module.exports.default = (0, $064daac58dd08248$var$_createReactClass2.default)({
    displayName: "CenturyView",
    mixins: [
        (parcelRequire("3agVy")),
        (parcelRequire("fFwwU")),
        (parcelRequire("9AXXZ"))()
    ],
    propTypes: $064daac58dd08248$var$propTypes,
    componentDidUpdate: function componentDidUpdate() {
        var activeId = $064daac58dd08248$var$optionId((0, $b6t9X.instanceId)(this), this.props.focused);
        this.ariaActiveDescendant(activeId);
    },
    render: function render() {
        var focused = this.props.focused;
        return $064daac58dd08248$var$_react2.default.createElement($064daac58dd08248$var$_CalendarView2.default, $064daac58dd08248$var$_3.default.omitOwnProps(this), $064daac58dd08248$var$_react2.default.createElement("tbody", null, $064daac58dd08248$var$_3.default.chunk($064daac58dd08248$var$getCenturyDecades(focused), 4).map(this.renderRow)));
    },
    renderRow: function renderRow(row, rowIdx) {
        var _this = this;
        var _props = this.props, focused = _props.focused, disabled = _props.disabled, onChange = _props.onChange, value = _props.value, today = _props.today, culture = _props.culture, min = _props.min, max = _props.max;
        var id = (0, $b6t9X.instanceId)(this, "_century");
        return $064daac58dd08248$var$_react2.default.createElement($064daac58dd08248$var$_CalendarView2.default.Row, {
            key: rowIdx
        }, row.map(function(date, colIdx) {
            var label = $d6vOx.date.format($064daac58dd08248$var$_dates2.default.startOf(date, "decade"), $064daac58dd08248$var$format(_this.props), culture);
            return $064daac58dd08248$var$_react2.default.createElement($064daac58dd08248$var$_CalendarView2.default.Cell, {
                key: colIdx,
                unit: "decade",
                id: $064daac58dd08248$var$optionId(id, date),
                label: label,
                date: date,
                now: today,
                min: min,
                max: max,
                onChange: onChange,
                focused: focused,
                selected: value,
                disabled: disabled
            }, label);
        }));
    }
});
function $064daac58dd08248$var$getCenturyDecades(_date) {
    var days = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ], date = $064daac58dd08248$var$_dates2.default.add($064daac58dd08248$var$_dates2.default.startOf(_date, "century"), -20, "year");
    return days.map(function() {
        return date = $064daac58dd08248$var$_dates2.default.add(date, 10, "year");
    });
}
module.exports = module.exports["default"];

});

parcelRegister("7eZIS", function(module, exports) {
"use strict";
var $5459b810eb194a4e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $5459b810eb194a4e$var$_react2 = $5459b810eb194a4e$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $5459b810eb194a4e$var$_propTypes2 = $5459b810eb194a4e$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $5459b810eb194a4e$var$_createReactClass2 = $5459b810eb194a4e$var$_interopRequireDefault($5JTQC);

var $5MgSZ = parcelRequire("5MgSZ");
var $5459b810eb194a4e$var$_ReplaceTransitionGroup2 = $5459b810eb194a4e$var$_interopRequireDefault($5MgSZ);

var $96zKa = parcelRequire("96zKa");
var $5459b810eb194a4e$var$_compat2 = $5459b810eb194a4e$var$_interopRequireDefault($96zKa);

var $gKGWM = parcelRequire("gKGWM");
var $5459b810eb194a4e$var$_style2 = $5459b810eb194a4e$var$_interopRequireDefault($gKGWM);

var $fvaf6 = parcelRequire("fvaf6");
var $5459b810eb194a4e$var$_width2 = $5459b810eb194a4e$var$_interopRequireDefault($fvaf6);

var $kLuvQ = parcelRequire("kLuvQ");
var $5459b810eb194a4e$var$_configuration2 = $5459b810eb194a4e$var$_interopRequireDefault($kLuvQ);

var $4cOpg = parcelRequire("4cOpg");
var $5459b810eb194a4e$var$_3 = $5459b810eb194a4e$var$_interopRequireDefault($4cOpg);
function $5459b810eb194a4e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5459b810eb194a4e$var$SlideChildGroup = (0, $5459b810eb194a4e$var$_createReactClass2.default)({
    displayName: "SlideChildGroup",
    propTypes: {
        direction: $5459b810eb194a4e$var$_propTypes2.default.oneOf([
            "left",
            "right"
        ]),
        duration: $5459b810eb194a4e$var$_propTypes2.default.number
    },
    componentWillEnter: function componentWillEnter(done) {
        var _this = this;
        var node = $5459b810eb194a4e$var$_compat2.default.findDOMNode(this), width = (0, $5459b810eb194a4e$var$_width2.default)(node), direction = this.props.direction;
        width = direction === "left" ? width : -width;
        this.ORGINAL_POSITION = node.style.position;
        (0, $5459b810eb194a4e$var$_style2.default)(node, {
            position: "absolute",
            left: width + "px",
            top: 0
        });
        $5459b810eb194a4e$var$_configuration2.default.animate(node, {
            left: 0
        }, this.props.duration, function() {
            (0, $5459b810eb194a4e$var$_style2.default)(node, {
                position: _this.ORGINAL_POSITION,
                overflow: "hidden"
            });
            _this.ORGINAL_POSITION = null;
            done && done();
        });
    },
    componentWillLeave: function componentWillLeave(done) {
        var _this2 = this;
        var node = $5459b810eb194a4e$var$_compat2.default.findDOMNode(this), width = (0, $5459b810eb194a4e$var$_width2.default)(node), direction = this.props.direction;
        width = direction === "left" ? -width : width;
        this.ORGINAL_POSITION = node.style.position;
        (0, $5459b810eb194a4e$var$_style2.default)(node, {
            position: "absolute",
            top: 0,
            left: 0
        });
        $5459b810eb194a4e$var$_configuration2.default.animate(node, {
            left: width + "px"
        }, this.props.duration, function() {
            (0, $5459b810eb194a4e$var$_style2.default)(node, {
                position: _this2.ORGINAL_POSITION,
                overflow: "hidden"
            });
            _this2.ORGINAL_POSITION = null;
            done && done();
        });
    },
    render: function render() {
        return $5459b810eb194a4e$var$_react2.default.Children.only(this.props.children);
    }
});
module.exports = (0, $5459b810eb194a4e$var$_createReactClass2.default)({
    displayName: "exports",
    propTypes: {
        direction: $5459b810eb194a4e$var$_propTypes2.default.oneOf([
            "left",
            "right"
        ]),
        duration: $5459b810eb194a4e$var$_propTypes2.default.number
    },
    getDefaultProps: function getDefaultProps() {
        return {
            direction: "left",
            duration: 250
        };
    },
    _wrapChild: function _wrapChild(child, ref) {
        return $5459b810eb194a4e$var$_react2.default.createElement($5459b810eb194a4e$var$SlideChildGroup, {
            key: child.key,
            ref: ref,
            direction: this.props.direction,
            duration: this.props.duration
        }, child);
    },
    render: function render() {
        var _props = this.props, style = _props.style, children = _props.children;
        style = $5459b810eb194a4e$var$_extends({}, style, {
            position: "relative",
            overflow: "hidden"
        });
        return $5459b810eb194a4e$var$_react2.default.createElement($5459b810eb194a4e$var$_ReplaceTransitionGroup2.default, $5459b810eb194a4e$var$_extends({}, $5459b810eb194a4e$var$_3.default.omitOwnProps(this), {
            ref: "container",
            component: "div",
            childFactory: this._wrapChild,
            style: style
        }), children);
    }
});

});
parcelRegister("5MgSZ", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $7PdBe = parcelRequire("7PdBe");
var $434e889f78503531$var$_react2 = $434e889f78503531$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $434e889f78503531$var$_propTypes2 = $434e889f78503531$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $434e889f78503531$var$_createReactClass2 = $434e889f78503531$var$_interopRequireDefault($5JTQC);

var $gKGWM = parcelRequire("gKGWM");
var $434e889f78503531$var$_style2 = $434e889f78503531$var$_interopRequireDefault($gKGWM);

var $7gbNL = parcelRequire("7gbNL");
var $434e889f78503531$var$_height2 = $434e889f78503531$var$_interopRequireDefault($7gbNL);

var $fvaf6 = parcelRequire("fvaf6");
var $434e889f78503531$var$_width2 = $434e889f78503531$var$_interopRequireDefault($fvaf6);

var $96zKa = parcelRequire("96zKa");
var $434e889f78503531$var$_compat2 = $434e889f78503531$var$_interopRequireDefault($96zKa);

var $4cOpg = parcelRequire("4cOpg");
var $434e889f78503531$var$_3 = $434e889f78503531$var$_interopRequireDefault($4cOpg);
function $434e889f78503531$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * A streamlined version of TransitionGroup built for managing at most two active children
 * also provides additional hooks for animation start/end
 * https://github.com/facebook/react/blob/master/src/addons/transitions/ReactTransitionGroup.js
 * relevent code is licensed accordingly
 */ function $434e889f78503531$var$getChild(children) {
    return $434e889f78503531$var$_react2.default.Children.only(children);
}
function $434e889f78503531$var$key(child) {
    return child && child.key;
}
module.exports.default = (0, $434e889f78503531$var$_createReactClass2.default)({
    displayName: "ReplaceTransitionGroup",
    propTypes: {
        component: $434e889f78503531$var$_propTypes2.default.oneOfType([
            $434e889f78503531$var$_propTypes2.default.element,
            $434e889f78503531$var$_propTypes2.default.string
        ]),
        childFactory: $434e889f78503531$var$_propTypes2.default.func,
        onAnimating: $434e889f78503531$var$_propTypes2.default.func,
        onAnimate: $434e889f78503531$var$_propTypes2.default.func
    },
    getDefaultProps: function getDefaultProps() {
        return {
            component: "span",
            childFactory: function childFactory(a) {
                return a;
            },
            onAnimating: $434e889f78503531$var$_3.default.noop,
            onAnimate: $434e889f78503531$var$_3.default.noop
        };
    },
    getInitialState: function getInitialState() {
        return {
            children: $434e889f78503531$var$_3.default.splat(this.props.children)
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var nextChild = $434e889f78503531$var$getChild(nextProps.children), stack = this.state.children.slice(), next = stack[1], last = stack[0];
        var isLastChild = last && $434e889f78503531$var$key(last) === $434e889f78503531$var$key(nextChild), isNextChild = next && $434e889f78503531$var$key(next) === $434e889f78503531$var$key(nextChild);
        //no children
        if (!last) {
            stack.push(nextChild);
            this.entering = nextChild;
        } else if (last && !next && !isLastChild) {
            //new child
            stack.push(nextChild);
            this.leaving = last;
            this.entering = nextChild;
        } else if (last && next && !isLastChild && !isNextChild) {
            // the child is not the current one, exit the current one, add the new one
            //  - shift the stack down
            stack.shift();
            stack.push(nextChild);
            this.leaving = next;
            this.entering = nextChild;
        } else if (isLastChild) stack.splice(0, 1, nextChild);
        else if (isNextChild) stack.splice(1, 1, nextChild);
        if (this.state.children[0] !== stack[0] || this.state.children[1] !== stack[1]) this.setState({
            children: stack
        });
    },
    componentWillMount: function componentWillMount() {
        this.animatingKeys = {};
        this.leaving = null;
        this.entering = null;
    },
    componentDidMount: function componentDidMount() {
        this._mounted = true;
    },
    componentWillUnmount: function componentWillUnmount() {
        this._mounted = false;
    },
    componentDidUpdate: function componentDidUpdate() {
        var entering = this.entering, leaving = this.leaving, first = this.refs[$434e889f78503531$var$key(entering) || $434e889f78503531$var$key(leaving)], node = $434e889f78503531$var$_compat2.default.findDOMNode(this), el = first && $434e889f78503531$var$_compat2.default.findDOMNode(first);
        if (el) (0, $434e889f78503531$var$_style2.default)(node, {
            overflow: "hidden",
            height: (0, $434e889f78503531$var$_height2.default)(el) + "px",
            width: (0, $434e889f78503531$var$_width2.default)(el) + "px"
        });
        this.props.onAnimating();
        this.entering = null;
        this.leaving = null;
        if (entering) this.performEnter($434e889f78503531$var$key(entering));
        if (leaving) this.performLeave($434e889f78503531$var$key(leaving));
    },
    performEnter: function performEnter(key) {
        var component = this.refs[key];
        if (!component) return;
        this.animatingKeys[key] = true;
        if (component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));
        else this._handleDoneEntering(key);
    },
    _tryFinish: function _tryFinish() {
        if (this.isTransitioning()) return;
        if (this._mounted) (0, $434e889f78503531$var$_style2.default)($434e889f78503531$var$_compat2.default.findDOMNode(this), {
            overflow: "visible",
            height: "",
            width: ""
        });
        this.props.onAnimate();
    },
    _handleDoneEntering: function _handleDoneEntering(enterkey) {
        var component = this.refs[enterkey];
        if (component && component.componentDidEnter) component.componentDidEnter();
        delete this.animatingKeys[enterkey];
        if ($434e889f78503531$var$key(this.props.children) !== enterkey) this.performLeave(enterkey); // This was removed before it had fully entered. Remove it.
        this._tryFinish();
    },
    performLeave: function performLeave(key) {
        var component = this.refs[key];
        if (!component) return;
        this.animatingKeys[key] = true;
        if (component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
        else this._handleDoneLeaving(key);
    },
    _handleDoneLeaving: function _handleDoneLeaving(leavekey) {
        var component = this.refs[leavekey];
        if (component && component.componentDidLeave) component.componentDidLeave();
        delete this.animatingKeys[leavekey];
        if ($434e889f78503531$var$key(this.props.children) === leavekey) this.performEnter(leavekey); // This entered again before it fully left. Add it again.
        else if (this._mounted) this.setState({
            children: this.state.children.filter(function(c) {
                return $434e889f78503531$var$key(c) !== leavekey;
            })
        });
        this._tryFinish();
    },
    isTransitioning: function isTransitioning() {
        return !!Object.keys(this.animatingKeys).length;
    },
    render: function render() {
        var _this = this;
        var Component = this.props.component;
        return $434e889f78503531$var$_react2.default.createElement(Component, $434e889f78503531$var$_3.default.omitOwnProps(this), this.state.children.map(function(c) {
            return _this.props.childFactory(c, $434e889f78503531$var$key(c));
        }));
    }
});
module.exports = module.exports["default"];

});
parcelRegister("fvaf6", function(module, exports) {
"use strict";

var $4YZHC = parcelRequire("4YZHC");

var $8uPzo = parcelRequire("8uPzo");
module.exports = function width(node, client) {
    var win = $8uPzo(node);
    return win ? win.innerWidth : client ? node.clientWidth : $4YZHC(node).width;
};

});




parcelRegister("llMlN", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $f8b1108902772c53$var$_desc, $f8b1108902772c53$var$_value, $f8b1108902772c53$var$_obj;
var $f8b1108902772c53$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}; //pick, omit, has

var $7PdBe = parcelRequire("7PdBe");
var $f8b1108902772c53$var$_react2 = $f8b1108902772c53$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $f8b1108902772c53$var$_propTypes2 = $f8b1108902772c53$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $f8b1108902772c53$var$_createReactClass2 = $f8b1108902772c53$var$_interopRequireDefault($5JTQC);

var $ibnnr = parcelRequire("ibnnr");
var $f8b1108902772c53$var$_invariant2 = $f8b1108902772c53$var$_interopRequireDefault($ibnnr);

var $8UrAr = parcelRequire("8UrAr");
var $f8b1108902772c53$var$_activeElement2 = $f8b1108902772c53$var$_interopRequireDefault($8UrAr);

var $ksXgP = parcelRequire("ksXgP");
var $f8b1108902772c53$var$_classnames2 = $f8b1108902772c53$var$_interopRequireDefault($ksXgP);

var $96zKa = parcelRequire("96zKa");
var $f8b1108902772c53$var$_compat2 = $f8b1108902772c53$var$_interopRequireDefault($96zKa);

var $4cOpg = parcelRequire("4cOpg");
var $f8b1108902772c53$var$_3 = $f8b1108902772c53$var$_interopRequireDefault($4cOpg);

var $ecwgv = parcelRequire("ecwgv");
var $f8b1108902772c53$var$_dates2 = $f8b1108902772c53$var$_interopRequireDefault($ecwgv);

var $d6vOx = parcelRequire("d6vOx");

var $jn9XT = parcelRequire("jn9XT");

var $atEP4 = parcelRequire("atEP4");
var $f8b1108902772c53$var$_Widget2 = $f8b1108902772c53$var$_interopRequireDefault($atEP4);

var $6faAq = parcelRequire("6faAq");
var $f8b1108902772c53$var$_Popup2 = $f8b1108902772c53$var$_interopRequireDefault($6faAq);

var $3TyqS = parcelRequire("3TyqS");
var $f8b1108902772c53$var$_Calendar2 = $f8b1108902772c53$var$_interopRequireDefault($3TyqS);

var $awUGW = parcelRequire("awUGW");
var $f8b1108902772c53$var$_TimeList2 = $f8b1108902772c53$var$_interopRequireDefault($awUGW);

var $5VZsp = parcelRequire("5VZsp");
var $f8b1108902772c53$var$_DateTimePickerInput2 = $f8b1108902772c53$var$_interopRequireDefault($5VZsp);

var $6MCLm = parcelRequire("6MCLm");
var $f8b1108902772c53$var$_Button2 = $f8b1108902772c53$var$_interopRequireDefault($6MCLm);

var $8v4NT = parcelRequire("8v4NT");
var $f8b1108902772c53$var$_propTypes4 = $f8b1108902772c53$var$_interopRequireDefault($8v4NT);

var $7iIDV = parcelRequire("7iIDV");
var $f8b1108902772c53$var$_uncontrollable2 = $f8b1108902772c53$var$_interopRequireDefault($7iIDV);

var $7RxtH = parcelRequire("7RxtH");

var $b6t9X = parcelRequire("b6t9X");
function $f8b1108902772c53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8b1108902772c53$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $f8b1108902772c53$var$Calendar = $f8b1108902772c53$var$_Calendar2.default.ControlledComponent;
var $f8b1108902772c53$var$viewEnum = Object.keys($jn9XT.calendarViews).map(function(k) {
    return $jn9XT.calendarViews[k];
});
var $f8b1108902772c53$var$propTypes = $f8b1108902772c53$var$_extends({}, $f8b1108902772c53$var$Calendar.propTypes, {
    //-- controlled props -----------
    value: $f8b1108902772c53$var$_propTypes2.default.instanceOf(Date),
    onChange: $f8b1108902772c53$var$_propTypes2.default.func,
    open: $f8b1108902772c53$var$_propTypes2.default.oneOf([
        false,
        $jn9XT.datePopups.TIME,
        $jn9XT.datePopups.CALENDAR
    ]),
    onToggle: $f8b1108902772c53$var$_propTypes2.default.func,
    currentDate: $f8b1108902772c53$var$_propTypes2.default.instanceOf(Date),
    onCurrentDateChange: $f8b1108902772c53$var$_propTypes2.default.func,
    //------------------------------------
    onSelect: $f8b1108902772c53$var$_propTypes2.default.func,
    min: $f8b1108902772c53$var$_propTypes2.default.instanceOf(Date),
    max: $f8b1108902772c53$var$_propTypes2.default.instanceOf(Date),
    culture: $f8b1108902772c53$var$_propTypes2.default.string,
    format: $f8b1108902772c53$var$_propTypes4.default.dateFormat,
    timeFormat: $f8b1108902772c53$var$_propTypes4.default.dateFormat,
    editFormat: $f8b1108902772c53$var$_propTypes4.default.dateFormat,
    calendar: $f8b1108902772c53$var$_propTypes2.default.bool,
    time: $f8b1108902772c53$var$_propTypes2.default.bool,
    timeComponent: $f8b1108902772c53$var$_propTypes4.default.elementType,
    //popup
    dropUp: $f8b1108902772c53$var$_propTypes2.default.bool,
    duration: $f8b1108902772c53$var$_propTypes2.default.number,
    placeholder: $f8b1108902772c53$var$_propTypes2.default.string,
    name: $f8b1108902772c53$var$_propTypes2.default.string,
    initialView: $f8b1108902772c53$var$_propTypes2.default.oneOf($f8b1108902772c53$var$viewEnum),
    finalView: $f8b1108902772c53$var$_propTypes2.default.oneOf($f8b1108902772c53$var$viewEnum),
    autoFocus: $f8b1108902772c53$var$_propTypes2.default.bool,
    disabled: $f8b1108902772c53$var$_propTypes4.default.disabled,
    readOnly: $f8b1108902772c53$var$_propTypes4.default.readOnly,
    parse: $f8b1108902772c53$var$_propTypes2.default.oneOfType([
        $f8b1108902772c53$var$_propTypes2.default.arrayOf($f8b1108902772c53$var$_propTypes2.default.string),
        $f8b1108902772c53$var$_propTypes2.default.string,
        $f8b1108902772c53$var$_propTypes2.default.func
    ]),
    "aria-labelledby": $f8b1108902772c53$var$_propTypes2.default.string,
    "aria-describedby": $f8b1108902772c53$var$_propTypes2.default.string,
    messages: $f8b1108902772c53$var$_propTypes2.default.shape({
        calendarButton: $f8b1108902772c53$var$_propTypes2.default.string,
        timeButton: $f8b1108902772c53$var$_propTypes2.default.string
    })
});






var $f8b1108902772c53$var$DateTimePicker = (0, $f8b1108902772c53$var$_createReactClass2.default)(($f8b1108902772c53$var$_obj = {
    displayName: "DateTimePicker",
    mixins: [
        (parcelRequire("5jwiU")),
        (parcelRequire("3agVy")),
        (parcelRequire("7dl0U")),
        (parcelRequire("5NCz1")),
        (parcelRequire("k1uk1"))({
            didHandle: function didHandle(focused) {
                if (!focused) this.close();
            }
        }),
        (parcelRequire("9AXXZ"))("valueInput", function(key, id) {
            var open = this.props.open, current = this.ariaActiveDescendant(), calIsActive = open === $jn9XT.datePopups.CALENDAR && key === "calendar", timeIsActive = open === $jn9XT.datePopups.TIME && key === "timelist";
            if (!current || timeIsActive || calIsActive) return id;
        })
    ],
    propTypes: $f8b1108902772c53$var$propTypes,
    getInitialState: function getInitialState() {
        return {
            focused: false
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            currentDate: new Date(),
            min: new Date(1900, 0, 1),
            max: new Date(2099, 11, 31),
            calendar: true,
            time: true,
            open: false,
            //calendar override
            footer: true,
            messages: {
                calendarButton: "Select Date",
                timeButton: "Select Time"
            },
            ariaActiveDescendantKey: "dropdownlist"
        };
    },
    renderInput: function renderInput(id, owns) {
        var _props = this.props, open = _props.open, value = _props.value, editFormat = _props.editFormat, culture = _props.culture, busy = _props.busy, placeholder = _props.placeholder, disabled = _props.disabled, readOnly = _props.readOnly, name = _props.name, tabIndex = _props.tabIndex, autoFocus = _props.autoFocus, ariaLabelledby = _props["aria-labelledby"], ariaDescribedby = _props["aria-describedby"];
        var focused = this.state.focused;
        return $f8b1108902772c53$var$_react2.default.createElement($f8b1108902772c53$var$_DateTimePickerInput2.default, {
            id: id,
            ref: "valueInput",
            role: "combobox",
            name: name,
            tabIndex: tabIndex,
            autoFocus: autoFocus,
            placeholder: placeholder,
            disabled: disabled,
            readOnly: readOnly,
            value: value,
            format: $f8b1108902772c53$var$getFormat(this.props),
            editFormat: editFormat,
            editing: focused,
            culture: culture,
            parse: this._parse,
            onChange: this.handleChange,
            "aria-haspopup": true,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            "aria-expanded": !!open,
            "aria-busy": !!busy,
            "aria-owns": owns
        });
    },
    renderButtons: function renderButtons(messages) {
        var _props2 = this.props, calendar = _props2.calendar, time = _props2.time, disabled = _props2.disabled, readOnly = _props2.readOnly;
        if (!calendar && !time) return null;
        return $f8b1108902772c53$var$_react2.default.createElement("span", {
            className: "rw-select"
        }, calendar && $f8b1108902772c53$var$_react2.default.createElement($f8b1108902772c53$var$_Button2.default, {
            icon: "calendar",
            className: "rw-btn-calendar",
            label: messages.calendarButton,
            disabled: !!(disabled || readOnly),
            onClick: this._click.bind(null, $jn9XT.datePopups.CALENDAR)
        }), time && $f8b1108902772c53$var$_react2.default.createElement($f8b1108902772c53$var$_Button2.default, {
            icon: "clock-o",
            className: "rw-btn-time",
            label: messages.timeButton,
            disabled: !!(disabled || readOnly),
            onClick: this._click.bind(null, $jn9XT.datePopups.TIME)
        }));
    },
    renderCalendar: function renderCalendar(id, inputID) {
        var _this = this;
        var _props3 = this.props, open = _props3.open, value = _props3.value, duration = _props3.duration, dropUp = _props3.dropUp;
        var calendarProps = $f8b1108902772c53$var$_3.default.pickProps(this.props, $f8b1108902772c53$var$Calendar);
        return $f8b1108902772c53$var$_react2.default.createElement($f8b1108902772c53$var$_Popup2.default, {
            dropUp: dropUp,
            duration: duration,
            open: open === $jn9XT.datePopups.CALENDAR,
            className: "rw-calendar-popup"
        }, $f8b1108902772c53$var$_react2.default.createElement($f8b1108902772c53$var$Calendar, $f8b1108902772c53$var$_extends({}, calendarProps, {
            ref: "calPopup",
            id: id,
            tabIndex: "-1",
            value: value,
            autoFocus: false,
            onChange: this.handleDateSelect,
            onNavigate: function onNavigate() {
                return _this.focus();
            },
            currentDate: this.props.currentDate,
            onCurrentDateChange: this.props.onCurrentDateChange,
            "aria-hidden": !open,
            "aria-live": "polite",
            "aria-labelledby": inputID,
            ariaActiveDescendantKey: "calendar"
        })));
    },
    renderTimeList: function renderTimeList(id, inputID) {
        var _this2 = this;
        var _props4 = this.props, open = _props4.open, value = _props4.value, duration = _props4.duration, dropUp = _props4.dropUp, calendar = _props4.calendar, timeFormat = _props4.timeFormat, timeComponent = _props4.timeComponent;
        var timeListProps = $f8b1108902772c53$var$_3.default.pickProps(this.props, $f8b1108902772c53$var$_TimeList2.default);
        return $f8b1108902772c53$var$_react2.default.createElement($f8b1108902772c53$var$_Popup2.default, {
            dropUp: dropUp,
            duration: duration,
            open: open === $jn9XT.datePopups.TIME,
            onOpening: function onOpening() {
                return _this2.refs.timePopup.forceUpdate();
            }
        }, $f8b1108902772c53$var$_react2.default.createElement("div", null, $f8b1108902772c53$var$_react2.default.createElement($f8b1108902772c53$var$_TimeList2.default, $f8b1108902772c53$var$_extends({}, timeListProps, {
            ref: "timePopup",
            id: id,
            format: timeFormat,
            value: $f8b1108902772c53$var$dateOrNull(value),
            onMove: this._scrollTo,
            onSelect: this.handleTimeSelect,
            preserveDate: !!calendar,
            itemComponent: timeComponent,
            "aria-labelledby": inputID,
            "aria-live": open && "polite",
            "aria-hidden": !open,
            ariaActiveDescendantKey: "timelist"
        }))));
    },
    render: function render() {
        var _props5 = this.props, className = _props5.className, calendar = _props5.calendar, time = _props5.time, open = _props5.open, messages = _props5.messages, disabled = _props5.disabled, readOnly = _props5.readOnly, dropUp = _props5.dropUp;
        var focused = this.state.focused;
        var inputID = (0, $b6t9X.instanceId)(this, "_input"), timeListID = (0, $b6t9X.instanceId)(this, "_time_listbox"), dateListID = (0, $b6t9X.instanceId)(this, "_cal"), owns = "";
        var elementProps = $f8b1108902772c53$var$_3.default.omitOwnProps(this, $f8b1108902772c53$var$Calendar, $f8b1108902772c53$var$_TimeList2.default);
        var shouldRenderList = open || (0, $b6t9X.isFirstFocusedRender)(this);
        if (calendar) owns += dateListID;
        if (time) owns += " " + timeListID;
        return $f8b1108902772c53$var$_react2.default.createElement($f8b1108902772c53$var$_Widget2.default, $f8b1108902772c53$var$_extends({}, elementProps, {
            open: !!open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            className: (0, $f8b1108902772c53$var$_classnames2.default)(className, "rw-datetimepicker", calendar && time && "rw-has-both", !calendar && !time && "rw-has-neither")
        }), this.renderInput(inputID, owns.trim()), this.renderButtons(messages), shouldRenderList && this.renderTimeList(timeListID, inputID), shouldRenderList && this.renderCalendar(dateListID, inputID));
    },
    handleChange: function handleChange(date, str, constrain) {
        var _props6 = this.props, onChange = _props6.onChange, value = _props6.value;
        if (constrain) date = this.inRangeValue(date);
        if (onChange) {
            if (date == null || value == null) {
                if (date != value) onChange(date, str);
            } else if (!$f8b1108902772c53$var$_dates2.default.eq(date, value)) onChange(date, str);
        }
    },
    handleKeyDown: function handleKeyDown(e) {
        var _props7 = this.props, open = _props7.open, calendar = _props7.calendar, time = _props7.time;
        (0, $b6t9X.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (e.key === "Escape" && open) this.close();
        else if (e.altKey) {
            e.preventDefault();
            if (e.key === "ArrowDown") {
                if (calendar && time) this.open(open === $jn9XT.datePopups.CALENDAR ? $jn9XT.datePopups.TIME : $jn9XT.datePopups.CALENDAR);
                else if (time) this.open($jn9XT.datePopups.TIME);
                else if (calendar) this.open($jn9XT.datePopups.CALENDAR);
            } else if (e.key === "ArrowUp") this.close();
        } else if (open) {
            if (open === $jn9XT.datePopups.CALENDAR) this.refs.calPopup.handleKeyDown(e);
            if (open === $jn9XT.datePopups.TIME) this.refs.timePopup.handleKeyDown(e);
        }
    },
    handleKeyPress: function handleKeyPress(e) {
        (0, $b6t9X.notify)(this.props.onKeyPress, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (this.props.open === $jn9XT.datePopups.TIME) this.refs.timePopup.handleKeyPress(e);
    },
    focus: function focus() {
        var valueInput = this.refs.valueInput;
        if (valueInput && (0, $f8b1108902772c53$var$_activeElement2.default)() !== $f8b1108902772c53$var$_compat2.default.findDOMNode(valueInput)) valueInput.focus();
    },
    handleDateSelect: function handleDateSelect(date) {
        var format = $f8b1108902772c53$var$getFormat(this.props), dateTime = $f8b1108902772c53$var$_dates2.default.merge(date, this.props.value, this.props.currentDate), dateStr = $f8b1108902772c53$var$formatDate(date, format, this.props.culture);
        this.close();
        (0, $b6t9X.notify)(this.props.onSelect, [
            dateTime,
            dateStr
        ]);
        this.handleChange(dateTime, dateStr, true);
        this.focus();
    },
    handleTimeSelect: function handleTimeSelect(datum) {
        var format = $f8b1108902772c53$var$getFormat(this.props), dateTime = $f8b1108902772c53$var$_dates2.default.merge(this.props.value, datum.date, this.props.currentDate), dateStr = $f8b1108902772c53$var$formatDate(datum.date, format, this.props.culture);
        this.close();
        (0, $b6t9X.notify)(this.props.onSelect, [
            dateTime,
            dateStr
        ]);
        this.handleChange(dateTime, dateStr, true);
        this.focus();
    },
    _click: function _click(view, e) {
        this.focus();
        this.toggle(view, e);
    },
    _parse: function _parse(string) {
        var format = $f8b1108902772c53$var$getFormat(this.props, true), editFormat = this.props.editFormat, parse = this.props.parse, formats = [];
        if (typeof parse === "function") return parse(string, this.props.culture);
        if (typeof format === "string") formats.push(format);
        if (typeof editFormat === "string") formats.push(editFormat);
        if (parse) formats = formats.concat(this.props.parse);
        (0, $f8b1108902772c53$var$_invariant2.default)(formats.length, "React Widgets: there are no specified `parse` formats provided and the `format` prop is a function. the DateTimePicker is unable to parse `%s` into a dateTime, please provide either a parse function or Globalize.js compatible string for `format`", string);
        return $f8b1108902772c53$var$formatsParser(formats, this.props.culture, string);
    },
    toggle: function toggle(view) {
        this.props.open ? this.props.open !== view ? this.open(view) : this.close(view) : this.open(view);
    },
    open: function open(view) {
        if (this.props.open !== view && this.props[view] === true) (0, $b6t9X.notify)(this.props.onToggle, view);
    },
    close: function close() {
        if (this.props.open) (0, $b6t9X.notify)(this.props.onToggle, false);
    },
    inRangeValue: function inRangeValue(value) {
        if (value == null) return value;
        return $f8b1108902772c53$var$_dates2.default.max($f8b1108902772c53$var$_dates2.default.min(value, this.props.max), this.props.min);
    }
}, $f8b1108902772c53$var$_applyDecoratedDescriptor($f8b1108902772c53$var$_obj, "handleChange", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($f8b1108902772c53$var$_obj, "handleChange"), $f8b1108902772c53$var$_obj), $f8b1108902772c53$var$_applyDecoratedDescriptor($f8b1108902772c53$var$_obj, "handleKeyDown", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($f8b1108902772c53$var$_obj, "handleKeyDown"), $f8b1108902772c53$var$_obj), $f8b1108902772c53$var$_applyDecoratedDescriptor($f8b1108902772c53$var$_obj, "handleKeyPress", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($f8b1108902772c53$var$_obj, "handleKeyPress"), $f8b1108902772c53$var$_obj), $f8b1108902772c53$var$_applyDecoratedDescriptor($f8b1108902772c53$var$_obj, "handleDateSelect", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($f8b1108902772c53$var$_obj, "handleDateSelect"), $f8b1108902772c53$var$_obj), $f8b1108902772c53$var$_applyDecoratedDescriptor($f8b1108902772c53$var$_obj, "handleTimeSelect", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($f8b1108902772c53$var$_obj, "handleTimeSelect"), $f8b1108902772c53$var$_obj), $f8b1108902772c53$var$_applyDecoratedDescriptor($f8b1108902772c53$var$_obj, "_click", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($f8b1108902772c53$var$_obj, "_click"), $f8b1108902772c53$var$_obj), $f8b1108902772c53$var$_obj));
module.exports.default = (0, $f8b1108902772c53$var$_uncontrollable2.default)($f8b1108902772c53$var$DateTimePicker, {
    open: "onToggle",
    value: "onChange",
    currentDate: "onCurrentDateChange"
}, [
    "focus"
]);
function $f8b1108902772c53$var$getFormat(props) {
    var cal = props[$jn9XT.datePopups.CALENDAR] != null ? props.calendar : true, time = props[$jn9XT.datePopups.TIME] != null ? props.time : true;
    return props.format ? props.format : cal && time || !cal && !time ? $d6vOx.date.getFormat("default") : $d6vOx.date.getFormat(cal ? "date" : "time");
}
function $f8b1108902772c53$var$formatDate(date, format, culture) {
    var val = "";
    if (date instanceof Date && !isNaN(date.getTime())) val = $d6vOx.date.format(date, format, culture);
    return val;
}
function $f8b1108902772c53$var$formatsParser(formats, culture, str) {
    var date;
    for(var i = 0; i < formats.length; i++){
        date = $d6vOx.date.parse(str, formats[i], culture);
        if (date) return date;
    }
    return null;
}
function $f8b1108902772c53$var$dateOrNull(dt) {
    if (dt && !isNaN(dt.getTime())) return dt;
    return null;
}
module.exports = module.exports["default"];

});
parcelRegister("awUGW", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $7aa8de544ae09616$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $7aa8de544ae09616$var$_react2 = $7aa8de544ae09616$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $7aa8de544ae09616$var$_propTypes2 = $7aa8de544ae09616$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $7aa8de544ae09616$var$_createReactClass2 = $7aa8de544ae09616$var$_interopRequireDefault($5JTQC);

var $ecwgv = parcelRequire("ecwgv");
var $7aa8de544ae09616$var$_dates3 = $7aa8de544ae09616$var$_interopRequireDefault($ecwgv);

var $emiXD = parcelRequire("emiXD");
var $7aa8de544ae09616$var$_List2 = $7aa8de544ae09616$var$_interopRequireDefault($emiXD);

var $d6vOx = parcelRequire("d6vOx");

var $8v4NT = parcelRequire("8v4NT");
var $7aa8de544ae09616$var$_propTypes4 = $7aa8de544ae09616$var$_interopRequireDefault($8v4NT);

var $4cOpg = parcelRequire("4cOpg");
var $7aa8de544ae09616$var$_3 = $7aa8de544ae09616$var$_interopRequireDefault($4cOpg);
function $7aa8de544ae09616$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7aa8de544ae09616$var$format = function format(props) {
    return $d6vOx.date.getFormat("time", props.format);
};

module.exports.default = (0, $7aa8de544ae09616$var$_createReactClass2.default)({
    displayName: "TimeList",
    propTypes: {
        value: $7aa8de544ae09616$var$_propTypes2.default.instanceOf(Date),
        step: $7aa8de544ae09616$var$_propTypes2.default.number,
        min: $7aa8de544ae09616$var$_propTypes2.default.instanceOf(Date),
        max: $7aa8de544ae09616$var$_propTypes2.default.instanceOf(Date),
        currentDate: $7aa8de544ae09616$var$_propTypes2.default.instanceOf(Date),
        itemComponent: $7aa8de544ae09616$var$_propTypes4.default.elementType,
        format: $7aa8de544ae09616$var$_propTypes4.default.dateFormat,
        onSelect: $7aa8de544ae09616$var$_propTypes2.default.func,
        preserveDate: $7aa8de544ae09616$var$_propTypes2.default.bool,
        culture: $7aa8de544ae09616$var$_propTypes2.default.string,
        delay: $7aa8de544ae09616$var$_propTypes2.default.number
    },
    mixins: [
        (parcelRequire("5jwiU"))
    ],
    getDefaultProps: function getDefaultProps() {
        return {
            step: 30,
            onSelect: function onSelect() {},
            min: new Date(1900, 0, 1),
            max: new Date(2099, 11, 31),
            preserveDate: true,
            delay: 300,
            ariaActiveDescendantKey: "timelist"
        };
    },
    getInitialState: function getInitialState() {
        var data = this._dates(this.props), focusedItem = this._closestDate(data, this.props.value || this.props.currentDate);
        return {
            focusedItem: focusedItem || data[0],
            dates: data
        };
    },
    componentDidMount: function componentDidMount() {
        this._mounted = true;
    },
    componentWillUnmount: function componentWillUnmount() {
        this._mounted = false;
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var data = this._dates(nextProps), focusedItem = this._closestDate(data, nextProps.value || this.props.currentDate), valChanged = !$7aa8de544ae09616$var$_dates3.default.eq(nextProps.value, this.props.value, "minutes"), minChanged = !$7aa8de544ae09616$var$_dates3.default.eq(nextProps.min, this.props.min, "minutes"), maxChanged = !$7aa8de544ae09616$var$_dates3.default.eq(nextProps.max, this.props.max, "minutes"), localeChanged = this.props.format !== nextProps.format || this.props.culture !== nextProps.culture;
        if (valChanged || minChanged || maxChanged || localeChanged) this.setState({
            focusedItem: focusedItem || data[0],
            dates: data
        });
    },
    render: function render() {
        var _props = this.props, value = _props.value, onSelect = _props.onSelect, itemComponent = _props.itemComponent;
        var times = this.state.dates, date = this._closestDate(times, value);
        return $7aa8de544ae09616$var$_react2.default.createElement($7aa8de544ae09616$var$_List2.default, $7aa8de544ae09616$var$_extends({}, $7aa8de544ae09616$var$_3.default.omitOwnProps(this), {
            ref: "list",
            data: times,
            textField: "label",
            valueField: "date",
            selected: date,
            onSelect: onSelect,
            focused: this.state.focusedItem,
            itemComponent: itemComponent
        }));
    },
    _closestDate: function _closestDate(times, date) {
        var roundTo = 60000 * this.props.step, inst = null, label;
        if (!date) return null;
        date = new Date(Math.floor(date.getTime() / roundTo) * roundTo);
        label = $d6vOx.date.format(date, $7aa8de544ae09616$var$format(this.props), this.props.culture);
        times.some(function(time) {
            if (time.label === label) return inst = time;
        });
        return inst;
    },
    _data: function _data() {
        return this.state.dates;
    },
    _dates: function _dates(props) {
        var times = [], i = 0, values = this._dateValues(props), start = values.min, startDay = $7aa8de544ae09616$var$_dates3.default.date(start);
        while($7aa8de544ae09616$var$_dates3.default.date(start) === startDay && $7aa8de544ae09616$var$_dates3.default.lte(start, values.max)){
            i++;
            times.push({
                date: start,
                label: $d6vOx.date.format(start, $7aa8de544ae09616$var$format(props), props.culture)
            });
            start = $7aa8de544ae09616$var$_dates3.default.add(start, props.step || 30, "minutes");
        }
        return times;
    },
    _dateValues: function _dateValues(props) {
        var value = props.value || props.currentDate || $7aa8de544ae09616$var$_dates3.default.today(), useDate = props.preserveDate, min = props.min, max = props.max, start, end;
        //compare just the time regradless of whether they fall on the same day
        if (!useDate) {
            start = $7aa8de544ae09616$var$_dates3.default.startOf($7aa8de544ae09616$var$_dates3.default.merge(new Date(), min, props.currentDate), "minutes");
            end = $7aa8de544ae09616$var$_dates3.default.startOf($7aa8de544ae09616$var$_dates3.default.merge(new Date(), max, props.currentDate), "minutes");
            if ($7aa8de544ae09616$var$_dates3.default.lte(end, start) && $7aa8de544ae09616$var$_dates3.default.gt(max, min, "day")) end = $7aa8de544ae09616$var$_dates3.default.tomorrow();
            return {
                min: start,
                max: end
            };
        }
        start = $7aa8de544ae09616$var$_dates3.default.today();
        end = $7aa8de544ae09616$var$_dates3.default.tomorrow();
        //date parts are equal
        return {
            min: $7aa8de544ae09616$var$_dates3.default.eq(value, min, "day") ? $7aa8de544ae09616$var$_dates3.default.merge(start, min, props.currentDate) : start,
            max: $7aa8de544ae09616$var$_dates3.default.eq(value, max, "day") ? $7aa8de544ae09616$var$_dates3.default.merge(start, max, props.currentDate) : end
        };
    },
    handleKeyDown: function handleKeyDown(e) {
        var key = e.key, focusedItem = this.state.focusedItem, list = this.refs.list;
        if (key === "End") {
            e.preventDefault();
            this.setState({
                focusedItem: list.last()
            });
        } else if (key === "Home") {
            e.preventDefault();
            this.setState({
                focusedItem: list.first()
            });
        } else if (key === "Enter") this.props.onSelect(focusedItem);
        else if (key === "ArrowDown") {
            e.preventDefault();
            this.setState({
                focusedItem: list.next(focusedItem)
            });
        } else if (key === "ArrowUp") {
            e.preventDefault();
            this.setState({
                focusedItem: list.prev(focusedItem)
            });
        }
    },
    handleKeyPress: function handleKeyPress(e) {
        var _this = this;
        e.preventDefault();
        this.search(String.fromCharCode(e.which), function(item) {
            _this._mounted && _this.setState({
                focusedItem: item
            });
        });
    },
    scrollTo: function scrollTo() {
        this.refs.list.move && this.refs.list.move();
    },
    search: function search(character, cb) {
        var _this2 = this;
        var word = ((this._searchTerm || "") + character).toLowerCase();
        this._searchTerm = word;
        this.setTimeout("search", function() {
            var list = _this2.refs.list, item = list.next(_this2.state.focusedItem, word);
            _this2._searchTerm = "";
            if (item) cb(item);
        }, this.props.delay);
    }
});
module.exports = module.exports["default"];

});

parcelRegister("5VZsp", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $4521f2bca1c3ed50$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $4521f2bca1c3ed50$var$_react2 = $4521f2bca1c3ed50$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $4521f2bca1c3ed50$var$_propTypes2 = $4521f2bca1c3ed50$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $4521f2bca1c3ed50$var$_createReactClass2 = $4521f2bca1c3ed50$var$_interopRequireDefault($5JTQC);

var $4cOpg = parcelRequire("4cOpg");
var $4521f2bca1c3ed50$var$_3 = $4521f2bca1c3ed50$var$_interopRequireDefault($4cOpg);

var $dHGtJ = parcelRequire("dHGtJ");
var $4521f2bca1c3ed50$var$_Input2 = $4521f2bca1c3ed50$var$_interopRequireDefault($dHGtJ);

var $96zKa = parcelRequire("96zKa");
var $4521f2bca1c3ed50$var$_compat2 = $4521f2bca1c3ed50$var$_interopRequireDefault($96zKa);

var $d6vOx = parcelRequire("d6vOx");

var $8v4NT = parcelRequire("8v4NT");
var $4521f2bca1c3ed50$var$_propTypes4 = $4521f2bca1c3ed50$var$_interopRequireDefault($8v4NT);
function $4521f2bca1c3ed50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = (0, $4521f2bca1c3ed50$var$_createReactClass2.default)({
    displayName: "DateTimePickerInput",
    propTypes: {
        format: $4521f2bca1c3ed50$var$_propTypes4.default.dateFormat.isRequired,
        editing: $4521f2bca1c3ed50$var$_propTypes2.default.bool,
        editFormat: $4521f2bca1c3ed50$var$_propTypes4.default.dateFormat,
        parse: $4521f2bca1c3ed50$var$_propTypes2.default.func.isRequired,
        value: $4521f2bca1c3ed50$var$_propTypes2.default.instanceOf(Date),
        onChange: $4521f2bca1c3ed50$var$_propTypes2.default.func.isRequired,
        culture: $4521f2bca1c3ed50$var$_propTypes2.default.string
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var value = nextProps.value, editing = nextProps.editing, editFormat = nextProps.editFormat, format = nextProps.format, culture = nextProps.culture;
        this.setState({
            textValue: $4521f2bca1c3ed50$var$formatDate(value, editing && editFormat ? editFormat : format, culture)
        });
    },
    getInitialState: function getInitialState() {
        var _props = this.props, value = _props.value, editing = _props.editing, editFormat = _props.editFormat, format = _props.format, culture = _props.culture;
        return {
            textValue: $4521f2bca1c3ed50$var$formatDate(value, editing && editFormat ? editFormat : format, culture)
        };
    },
    render: function render() {
        var _props2 = this.props, disabled = _props2.disabled, readOnly = _props2.readOnly;
        var textValue = this.state.textValue;
        var props = $4521f2bca1c3ed50$var$_3.default.omitOwnProps(this);
        return $4521f2bca1c3ed50$var$_react2.default.createElement($4521f2bca1c3ed50$var$_Input2.default, $4521f2bca1c3ed50$var$_extends({}, props, {
            type: "text",
            value: textValue,
            disabled: disabled,
            readOnly: readOnly,
            onChange: this.handleChange,
            onBlur: this.handleBlur
        }));
    },
    handleChange: function handleChange(_ref) {
        var value = _ref.target.value;
        this._needsFlush = true;
        this.setState({
            textValue: value
        });
    },
    handleBlur: function handleBlur(event) {
        var _props3 = this.props, format = _props3.format, culture = _props3.culture, parse = _props3.parse, onChange = _props3.onChange, onBlur = _props3.onBlur;
        onBlur && onBlur(event);
        if (this._needsFlush) {
            var date = parse(event.target.value);
            this._needsFlush = false;
            onChange(date, $4521f2bca1c3ed50$var$formatDate(date, format, culture));
        }
    },
    focus: function focus() {
        $4521f2bca1c3ed50$var$_compat2.default.findDOMNode(this).focus();
    }
});
function $4521f2bca1c3ed50$var$isValid(d) {
    return !isNaN(d.getTime());
}
function $4521f2bca1c3ed50$var$formatDate(date, format, culture) {
    var val = "";
    if (date instanceof Date && $4521f2bca1c3ed50$var$isValid(date)) val = $d6vOx.date.format(date, format, culture);
    return val;
}
module.exports = module.exports["default"];

});


parcelRegister("7r6hs", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $569fed33e4f790f8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $569fed33e4f790f8$var$_desc, $569fed33e4f790f8$var$_value, $569fed33e4f790f8$var$_obj;

var $7PdBe = parcelRequire("7PdBe");
var $569fed33e4f790f8$var$_react2 = $569fed33e4f790f8$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $569fed33e4f790f8$var$_propTypes2 = $569fed33e4f790f8$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $569fed33e4f790f8$var$_createReactClass2 = $569fed33e4f790f8$var$_interopRequireDefault($5JTQC);

var $ksXgP = parcelRequire("ksXgP");
var $569fed33e4f790f8$var$_classnames2 = $569fed33e4f790f8$var$_interopRequireDefault($ksXgP);

var $4cOpg = parcelRequire("4cOpg");
var $569fed33e4f790f8$var$_3 = $569fed33e4f790f8$var$_interopRequireDefault($4cOpg);

var $96zKa = parcelRequire("96zKa");
var $569fed33e4f790f8$var$_compat2 = $569fed33e4f790f8$var$_interopRequireDefault($96zKa);

var $8v4NT = parcelRequire("8v4NT");
var $569fed33e4f790f8$var$_propTypes4 = $569fed33e4f790f8$var$_interopRequireDefault($8v4NT);

var $7iIDV = parcelRequire("7iIDV");
var $569fed33e4f790f8$var$_uncontrollable2 = $569fed33e4f790f8$var$_interopRequireDefault($7iIDV);

var $jn9XT = parcelRequire("jn9XT");

var $6Les3 = parcelRequire("6Les3");
var $569fed33e4f790f8$var$_repeater2 = $569fed33e4f790f8$var$_interopRequireDefault($6Les3);

var $d6vOx = parcelRequire("d6vOx");

var $cDLMG = parcelRequire("cDLMG");
var $569fed33e4f790f8$var$_NumberInput2 = $569fed33e4f790f8$var$_interopRequireDefault($cDLMG);

var $6MCLm = parcelRequire("6MCLm");
var $569fed33e4f790f8$var$_Button2 = $569fed33e4f790f8$var$_interopRequireDefault($6MCLm);

var $7RxtH = parcelRequire("7RxtH");

var $b6t9X = parcelRequire("b6t9X");
function $569fed33e4f790f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $569fed33e4f790f8$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $569fed33e4f790f8$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $569fed33e4f790f8$var$format = function format(props) {
    return $d6vOx.number.getFormat("default", props.format);
};
var $569fed33e4f790f8$var$propTypes = {
    // -- controlled props -----------
    value: $569fed33e4f790f8$var$_propTypes2.default.number,
    onChange: $569fed33e4f790f8$var$_propTypes2.default.func,
    //------------------------------------
    min: $569fed33e4f790f8$var$_propTypes2.default.number,
    max: $569fed33e4f790f8$var$_propTypes2.default.number,
    step: $569fed33e4f790f8$var$_propTypes2.default.number,
    precision: $569fed33e4f790f8$var$_propTypes2.default.number,
    culture: $569fed33e4f790f8$var$_propTypes2.default.string,
    format: $569fed33e4f790f8$var$_propTypes4.default.numberFormat,
    name: $569fed33e4f790f8$var$_propTypes2.default.string,
    parse: $569fed33e4f790f8$var$_propTypes2.default.func,
    autoFocus: $569fed33e4f790f8$var$_propTypes2.default.bool,
    disabled: $569fed33e4f790f8$var$_propTypes4.default.disabled,
    readOnly: $569fed33e4f790f8$var$_propTypes4.default.readOnly,
    messages: $569fed33e4f790f8$var$_propTypes2.default.shape({
        increment: $569fed33e4f790f8$var$_propTypes2.default.string,
        decrement: $569fed33e4f790f8$var$_propTypes2.default.string
    }),
    placeholder: $569fed33e4f790f8$var$_propTypes2.default.string
};




var $569fed33e4f790f8$var$NumberPicker = (0, $569fed33e4f790f8$var$_createReactClass2.default)(($569fed33e4f790f8$var$_obj = {
    displayName: "NumberPicker",
    mixins: [
        (parcelRequire("5jwiU")),
        (parcelRequire("3agVy")),
        (parcelRequire("5NCz1")),
        (parcelRequire("k1uk1"))({
            willHandle: function willHandle(focused) {
                if (focused) this.focus();
            }
        })
    ],
    propTypes: $569fed33e4f790f8$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            open: false,
            min: -Infinity,
            max: Infinity,
            step: 1,
            messages: {
                increment: "increment value",
                decrement: "decrement value"
            }
        };
    },
    getInitialState: function getInitialState() {
        return {
            focused: false,
            active: false
        };
    },
    render: function render() {
        var _this = this;
        var _$omitOwnProps = $569fed33e4f790f8$var$_3.default.omitOwnProps(this), className = _$omitOwnProps.className, onKeyPress = _$omitOwnProps.onKeyPress, onKeyUp = _$omitOwnProps.onKeyUp, props = $569fed33e4f790f8$var$_objectWithoutProperties(_$omitOwnProps, [
            "className",
            "onKeyPress",
            "onKeyUp"
        ]);
        var val = this.constrainValue(this.props.value);
        return $569fed33e4f790f8$var$_react2.default.createElement("div", $569fed33e4f790f8$var$_extends({}, props, {
            ref: "element",
            onKeyDown: this._keyDown,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: "-1",
            className: (0, $569fed33e4f790f8$var$_classnames2.default)(className, "rw-numberpicker", "rw-widget", {
                "rw-state-focus": this.state.focused,
                "rw-state-disabled": this.props.disabled,
                "rw-state-readonly": this.props.readOnly,
                "rw-rtl": this.isRtl()
            })
        }), $569fed33e4f790f8$var$_react2.default.createElement("span", {
            className: "rw-select"
        }, $569fed33e4f790f8$var$_react2.default.createElement($569fed33e4f790f8$var$_Button2.default, {
            icon: "caret-up",
            onClick: this.handleFocus,
            label: this.props.messages.increment,
            active: this.state.active === $jn9XT.directions.UP,
            disabled: val === this.props.max || this.props.disabled,
            onMouseUp: function onMouseUp() {
                return _this.handleMouseUp($jn9XT.directions.UP);
            },
            onMouseDown: function onMouseDown() {
                return _this.handleMouseDown($jn9XT.directions.UP);
            },
            onMouseLeave: function onMouseLeave() {
                return _this.handleMouseUp($jn9XT.directions.UP);
            }
        }), $569fed33e4f790f8$var$_react2.default.createElement($569fed33e4f790f8$var$_Button2.default, {
            icon: "caret-down",
            onClick: this.handleFocus,
            label: this.props.messages.decrement,
            active: this.state.active === $jn9XT.directions.DOWN,
            disabled: val === this.props.min || this.props.disabled,
            onMouseUp: function onMouseUp() {
                return _this.handleMouseUp($jn9XT.directions.DOWN);
            },
            onMouseDown: function onMouseDown() {
                return _this.handleMouseDown($jn9XT.directions.DOWN);
            },
            onMouseLeave: function onMouseLeave() {
                return _this.handleMouseUp($jn9XT.directions.DOWN);
            }
        })), $569fed33e4f790f8$var$_react2.default.createElement($569fed33e4f790f8$var$_NumberInput2.default, {
            ref: "input",
            tabIndex: props.tabIndex,
            placeholder: this.props.placeholder,
            value: val,
            autoFocus: this.props.autoFocus,
            editing: this.state.focused,
            format: this.props.format,
            parse: this.props.parse,
            name: this.props.name,
            role: "spinbutton",
            min: this.props.min,
            "aria-valuenow": val,
            "aria-valuemin": isFinite(this.props.min) ? this.props.min : null,
            "aria-valuemax": isFinite(this.props.max) ? this.props.max : null,
            "aria-disabled": this.props.disabled,
            "aria-readonly": this.props.readonly,
            disabled: this.props.disabled,
            readOnly: this.props.readOnly,
            onChange: this.change,
            onKeyPress: onKeyPress,
            onKeyUp: onKeyUp
        }));
    },
    handleMouseDown: function handleMouseDown(dir) {
        var method = dir === $jn9XT.directions.UP ? this.increment : this.decrement;
        this.setState({
            active: dir
        });
        var val = method.call(this);
        if (!(dir === $jn9XT.directions.UP && val === this.props.max || dir === $jn9XT.directions.DOWN && val === this.props.min)) {
            if (!this._cancelRepeater) this._cancelRepeater = (0, $569fed33e4f790f8$var$_repeater2.default)(this.handleMouseDown.bind(null, dir));
        } else this.handleMouseUp();
    },
    handleMouseUp: function handleMouseUp() {
        this.setState({
            active: false
        });
        this._cancelRepeater && this._cancelRepeater();
        this._cancelRepeater = null;
    },
    _keyDown: function _keyDown(e) {
        var key = e.key;
        (0, $b6t9X.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (key === "End" && isFinite(this.props.max)) this.change(this.props.max);
        else if (key === "Home" && isFinite(this.props.min)) this.change(this.props.min);
        else if (key === "ArrowDown") {
            e.preventDefault();
            this.decrement();
        } else if (key === "ArrowUp") {
            e.preventDefault();
            this.increment();
        }
    },
    focus: function focus() {
        $569fed33e4f790f8$var$_compat2.default.findDOMNode(this.refs.input).focus();
    },
    increment: function increment() {
        return this.step(this.props.step);
    },
    decrement: function decrement() {
        return this.step(-this.props.step);
    },
    step: function step(amount) {
        var value = (this.props.value || 0) + amount;
        var decimals = this.props.precision != null ? this.props.precision : $d6vOx.number.precision($569fed33e4f790f8$var$format(this.props));
        this.change(decimals != null ? $569fed33e4f790f8$var$round(value, decimals) : value);
        return value;
    },
    change: function change(val) {
        val = this.constrainValue(val);
        if (this.props.value !== val) (0, $b6t9X.notify)(this.props.onChange, val);
    },
    constrainValue: function constrainValue(value) {
        var max = this.props.max == null ? Infinity : this.props.max, min = this.props.min == null ? -Infinity : this.props.min;
        if (value == null || value === "") return null;
        return Math.max(Math.min(value, max), min);
    }
}, $569fed33e4f790f8$var$_applyDecoratedDescriptor($569fed33e4f790f8$var$_obj, "handleMouseDown", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($569fed33e4f790f8$var$_obj, "handleMouseDown"), $569fed33e4f790f8$var$_obj), $569fed33e4f790f8$var$_applyDecoratedDescriptor($569fed33e4f790f8$var$_obj, "handleMouseUp", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($569fed33e4f790f8$var$_obj, "handleMouseUp"), $569fed33e4f790f8$var$_obj), $569fed33e4f790f8$var$_applyDecoratedDescriptor($569fed33e4f790f8$var$_obj, "_keyDown", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($569fed33e4f790f8$var$_obj, "_keyDown"), $569fed33e4f790f8$var$_obj), $569fed33e4f790f8$var$_obj));
module.exports.default = (0, $569fed33e4f790f8$var$_uncontrollable2.default)($569fed33e4f790f8$var$NumberPicker, {
    value: "onChange"
}, [
    "focus"
]);
// thank you kendo ui core
// https://github.com/telerik/kendo-ui-core/blob/master/src/kendo.core.js#L1036
function $569fed33e4f790f8$var$round(value, precision) {
    precision = precision || 0;
    value = ("" + value).split("e");
    value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + precision : precision)));
    value = ("" + value).split("e");
    value = +(value[0] + "e" + (value[1] ? +value[1] - precision : -precision));
    return value.toFixed(precision);
}
module.exports = module.exports["default"];

});
parcelRegister("6Les3", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $4ec257a416c7d321$var$Repeater;
// my tests in ie11/chrome/FF indicate that keyDown repeats
// at about 35ms+/- 5ms after an initial 500ms delay. callback fires on the leading edge
function $4ec257a416c7d321$var$Repeater(callback) {
    var id, cancel = function cancel() {
        return clearInterval(id);
    };
    id = setInterval(function() {
        cancel();
        id = setInterval(callback, 35);
        callback(); //fire after everything in case the user cancels on the first call
    }, 500);
    return cancel;
}
module.exports = module.exports["default"];

});

parcelRegister("cDLMG", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $933e317e98ca628a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $933e317e98ca628a$var$_react2 = $933e317e98ca628a$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $933e317e98ca628a$var$_propTypes2 = $933e317e98ca628a$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $933e317e98ca628a$var$_createReactClass2 = $933e317e98ca628a$var$_interopRequireDefault($5JTQC);

var $4cOpg = parcelRequire("4cOpg");
var $933e317e98ca628a$var$_3 = $933e317e98ca628a$var$_interopRequireDefault($4cOpg);

var $8v4NT = parcelRequire("8v4NT");
var $933e317e98ca628a$var$_propTypes4 = $933e317e98ca628a$var$_interopRequireDefault($8v4NT);

var $d6vOx = parcelRequire("d6vOx");
function $933e317e98ca628a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $933e317e98ca628a$var$getFormat = function getFormat(props) {
    return $d6vOx.number.getFormat("default", props.format);
};
var $933e317e98ca628a$var$propTypes = {
    value: $933e317e98ca628a$var$_propTypes2.default.number,
    editing: $933e317e98ca628a$var$_propTypes2.default.bool,
    placeholder: $933e317e98ca628a$var$_propTypes2.default.string,
    format: $933e317e98ca628a$var$_propTypes4.default.numberFormat,
    parse: $933e317e98ca628a$var$_propTypes2.default.func,
    culture: $933e317e98ca628a$var$_propTypes2.default.string,
    min: $933e317e98ca628a$var$_propTypes2.default.number,
    onChange: $933e317e98ca628a$var$_propTypes2.default.func.isRequired,
    onKeyDown: $933e317e98ca628a$var$_propTypes2.default.func
};
module.exports.default = (0, $933e317e98ca628a$var$_createReactClass2.default)({
    displayName: "NumberPickerInput",
    propTypes: $933e317e98ca628a$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            editing: false
        };
    },
    getDefaultState: function getDefaultState() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var value = props.value, decimal = $d6vOx.number.decimalChar(null, props.culture), format = $933e317e98ca628a$var$getFormat(props);
        if (value == null || isNaN(props.value)) value = "";
        else value = props.editing ? ("" + value).replace(".", decimal) : $d6vOx.number.format(value, format, props.culture);
        return {
            stringValue: "" + value
        };
    },
    getInitialState: function getInitialState() {
        return this.getDefaultState();
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState(this.getDefaultState(nextProps));
    },
    render: function render() {
        var value = this.state.stringValue;
        var props = $933e317e98ca628a$var$_3.default.omitOwnProps(this);
        return $933e317e98ca628a$var$_react2.default.createElement("input", $933e317e98ca628a$var$_extends({}, props, {
            type: "text",
            className: "rw-input",
            onChange: this._change,
            onBlur: this._finish,
            "aria-disabled": this.props.disabled,
            "aria-readonly": this.props.readOnly,
            disabled: this.props.disabled,
            readOnly: this.props.readOnly,
            placeholder: this.props.placeholder,
            value: value
        }));
    },
    _change: function _change(e) {
        var val = e.target.value, number = this._parse(e.target.value);
        var isIntermediate = this.isIntermediateValue(number, val);
        if (val == null || val.trim() === "") {
            this.current("");
            return this.props.onChange(null);
        }
        if (!isIntermediate) {
            if (number !== this.props.value) return this.props.onChange(number);
        } else this.current(e.target.value);
    },
    _finish: function _finish() {
        var str = this.state.stringValue, number = this._parse(str);
        // if number is below the min
        // we need to flush low values and decimal stops, onBlur means i'm done inputing
        if (this.isIntermediateValue(number, str)) {
            if (isNaN(number)) number = null;
            this.props.onChange(number);
        }
    },
    _parse: function _parse(strVal) {
        var culture = this.props.culture, delimChar = $d6vOx.number.decimalChar(null, culture), userParse = this.props.parse;
        if (userParse) return userParse(strVal, culture);
        strVal = strVal.replace(delimChar, ".");
        strVal = parseFloat(strVal);
        return strVal;
    },
    isIntermediateValue: function isIntermediateValue(num, str) {
        return !!(num < this.props.min || this.isSign(str) || this.isAtDelimiter(num, str) || this.isPaddedZeros(str));
    },
    isSign: function isSign(val) {
        return (val || "").trim() === "-";
    },
    isPaddedZeros: function isPaddedZeros(str) {
        var localeChar = $d6vOx.number.decimalChar(null, this.props.culture);
        var _str$split = str.split(localeChar), _ = _str$split[0], decimals = _str$split[1];
        return !!(decimals && decimals.match(/0+$/));
    },
    isAtDelimiter: function isAtDelimiter(num, str) {
        var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
        var localeChar = $d6vOx.number.decimalChar(null, props.culture), lastIndex = str.length - 1, char;
        if (str.length < 1) return false;
        char = str[lastIndex];
        return !!(char === localeChar && str.indexOf(char) === lastIndex);
    },
    isValid: function isValid(num) {
        if (typeof num !== "number" || isNaN(num)) return false;
        return num >= this.props.min;
    },
    //this intermediate state is for when one runs into the decimal or are typing the number
    current: function current(stringValue) {
        this.setState({
            stringValue: stringValue
        });
    }
});
module.exports = module.exports["default"];

});


parcelRegister("lEfWo", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $fc29b2e9a6a4b9fa$var$_desc, $fc29b2e9a6a4b9fa$var$_value, $fc29b2e9a6a4b9fa$var$_obj;
var $fc29b2e9a6a4b9fa$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $fc29b2e9a6a4b9fa$var$_react2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $fc29b2e9a6a4b9fa$var$_propTypes2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $fc29b2e9a6a4b9fa$var$_createReactClass2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($5JTQC);

var $ksXgP = parcelRequire("ksXgP");
var $fc29b2e9a6a4b9fa$var$_classnames2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($ksXgP);

var $4cOpg = parcelRequire("4cOpg");
var $fc29b2e9a6a4b9fa$var$_3 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($4cOpg);

var $7iIDV = parcelRequire("7iIDV");
var $fc29b2e9a6a4b9fa$var$_uncontrollable2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($7iIDV);

var $atEP4 = parcelRequire("atEP4");
var $fc29b2e9a6a4b9fa$var$_Widget2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($atEP4);

var $6faAq = parcelRequire("6faAq");
var $fc29b2e9a6a4b9fa$var$_Popup2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($6faAq);

var $83Fz7 = parcelRequire("83Fz7");
var $fc29b2e9a6a4b9fa$var$_MultiselectInput2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($83Fz7);

var $jpla3 = parcelRequire("jpla3");
var $fc29b2e9a6a4b9fa$var$_MultiselectTagList2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($jpla3);

var $8v4NT = parcelRequire("8v4NT");
var $fc29b2e9a6a4b9fa$var$_propTypes4 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($8v4NT);

var $emiXD = parcelRequire("emiXD");
var $fc29b2e9a6a4b9fa$var$_List2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($emiXD);

var $bp2Lh = parcelRequire("bp2Lh");
var $fc29b2e9a6a4b9fa$var$_ListGroupable2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($bp2Lh);

var $jQzQU = parcelRequire("jQzQU");
var $fc29b2e9a6a4b9fa$var$_validateListInterface2 = $fc29b2e9a6a4b9fa$var$_interopRequireDefault($jQzQU);

var $3Y3Be = parcelRequire("3Y3Be");

var $7RxtH = parcelRequire("7RxtH");

var $b6t9X = parcelRequire("b6t9X");
function $fc29b2e9a6a4b9fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fc29b2e9a6a4b9fa$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $fc29b2e9a6a4b9fa$var$compatCreate = function compatCreate(props, msgs) {
    return typeof msgs.createNew === "function" ? msgs.createNew(props) : [
        $fc29b2e9a6a4b9fa$var$_react2.default.createElement("strong", {
            key: "dumb"
        }, '"' + props.searchTerm + '"'),
        " " + msgs.createNew
    ];
};
var $fc29b2e9a6a4b9fa$var$splat = $fc29b2e9a6a4b9fa$var$_3.default.splat;
var $fc29b2e9a6a4b9fa$var$propTypes = $fc29b2e9a6a4b9fa$var$_extends({}, $fc29b2e9a6a4b9fa$var$_Popup2.default.propTypes, {
    data: $fc29b2e9a6a4b9fa$var$_propTypes2.default.array,
    //-- controlled props --
    value: $fc29b2e9a6a4b9fa$var$_propTypes2.default.array,
    onChange: $fc29b2e9a6a4b9fa$var$_propTypes2.default.func,
    searchTerm: $fc29b2e9a6a4b9fa$var$_propTypes2.default.string,
    onSearch: $fc29b2e9a6a4b9fa$var$_propTypes2.default.func,
    open: $fc29b2e9a6a4b9fa$var$_propTypes2.default.bool,
    onToggle: $fc29b2e9a6a4b9fa$var$_propTypes2.default.func,
    //-------------------------------------------
    valueField: $fc29b2e9a6a4b9fa$var$_propTypes2.default.string,
    textField: $fc29b2e9a6a4b9fa$var$_propTypes4.default.accessor,
    tagComponent: $fc29b2e9a6a4b9fa$var$_propTypes4.default.elementType,
    itemComponent: $fc29b2e9a6a4b9fa$var$_propTypes4.default.elementType,
    listComponent: $fc29b2e9a6a4b9fa$var$_propTypes4.default.elementType,
    groupComponent: $fc29b2e9a6a4b9fa$var$_propTypes4.default.elementType,
    groupBy: $fc29b2e9a6a4b9fa$var$_propTypes4.default.accessor,
    createComponent: $fc29b2e9a6a4b9fa$var$_propTypes4.default.elementType,
    onSelect: $fc29b2e9a6a4b9fa$var$_propTypes2.default.func,
    onCreate: $fc29b2e9a6a4b9fa$var$_propTypes2.default.oneOfType([
        $fc29b2e9a6a4b9fa$var$_propTypes2.default.oneOf([
            false
        ]),
        $fc29b2e9a6a4b9fa$var$_propTypes2.default.func
    ]),
    inputSize: $fc29b2e9a6a4b9fa$var$_propTypes2.default.func,
    busy: $fc29b2e9a6a4b9fa$var$_propTypes2.default.bool,
    dropUp: $fc29b2e9a6a4b9fa$var$_propTypes2.default.bool,
    placeholder: $fc29b2e9a6a4b9fa$var$_propTypes2.default.string,
    autoFocus: $fc29b2e9a6a4b9fa$var$_propTypes2.default.bool,
    disabled: $fc29b2e9a6a4b9fa$var$_propTypes4.default.disabled.acceptsArray,
    readOnly: $fc29b2e9a6a4b9fa$var$_propTypes4.default.readOnly.acceptsArray,
    messages: $fc29b2e9a6a4b9fa$var$_propTypes2.default.shape({
        open: $fc29b2e9a6a4b9fa$var$_propTypes4.default.message,
        emptyList: $fc29b2e9a6a4b9fa$var$_propTypes4.default.message,
        emptyFilter: $fc29b2e9a6a4b9fa$var$_propTypes4.default.message,
        createNew: $fc29b2e9a6a4b9fa$var$_propTypes4.default.message
    })
});






var $fc29b2e9a6a4b9fa$var$Multiselect = (0, $fc29b2e9a6a4b9fa$var$_createReactClass2.default)(($fc29b2e9a6a4b9fa$var$_obj = {
    displayName: "Multiselect",
    mixins: [
        (parcelRequire("5jwiU")),
        (parcelRequire("2Ah31")),
        (parcelRequire("7dl0U")),
        (parcelRequire("5NCz1")),
        (parcelRequire("k1uk1"))({
            willHandle: function willHandle(focused) {
                focused && this.focus();
            },
            didHandle: function didHandle(focused) {
                if (!focused) this.close();
                if (!focused && this.refs.tagList) this.setState({
                    focusedTag: null
                });
                if (focused && !this.props.open) this.open();
            }
        }),
        (parcelRequire("9AXXZ"))("input", function(key, id) {
            var myKey = this.props.ariaActiveDescendantKey;
            var createIsActive = (!this._data().length || this.state.focusedItem === null) && key === myKey;
            var tagIsActive = this.state.focusedTag != null && key === "taglist";
            var listIsActive = this.state.focusedTag == null && key === "list";
            if (createIsActive || tagIsActive || listIsActive) return id;
        })
    ],
    propTypes: $fc29b2e9a6a4b9fa$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            data: [],
            filter: "startsWith",
            value: [],
            open: false,
            searchTerm: "",
            ariaActiveDescendantKey: "multiselect",
            messages: {
                createNew: "(create new tag)",
                emptyList: "There are no items in this list",
                emptyFilter: "The filter returned no results",
                tagsLabel: "selected items",
                selectedItems: "selected items",
                noneSelected: "no selected items",
                removeLabel: "remove selected item"
            }
        };
    },
    getInitialState: function getInitialState() {
        var _props = this.props, data = _props.data, value = _props.value, valueField = _props.valueField, searchTerm = _props.searchTerm, dataItems = $fc29b2e9a6a4b9fa$var$splat(value).map(function(item) {
            return (0, $3Y3Be.dataItem)(data, item, valueField);
        }), processedData = this.process(data, dataItems, searchTerm);
        return {
            focusedTag: null,
            focusedItem: processedData[0],
            processedData: processedData,
            dataItems: dataItems
        };
    },
    componentDidUpdate: function componentDidUpdate() {
        this.ariaActiveDescendant((0, $b6t9X.instanceId)(this, "__createlist_option"));
        this.refs.list && (0, $fc29b2e9a6a4b9fa$var$_validateListInterface2.default)(this.refs.list);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var data = nextProps.data, value = nextProps.value, valueField = nextProps.valueField, searchTerm = nextProps.searchTerm, values = $fc29b2e9a6a4b9fa$var$_3.default.splat(value), current = this.state.focusedItem, items = this.process(data, values, searchTerm);
        this.setState({
            processedData: items,
            focusedItem: items.indexOf(current) === -1 ? items[0] : current,
            dataItems: values.map(function(item) {
                return (0, $3Y3Be.dataItem)(data, item, valueField);
            })
        });
    },
    renderCreateItem: function renderCreateItem(id, messages) {
        var _this = this;
        var searchTerm = this.props.searchTerm;
        var focusedItem = this.state.focusedItem;
        var createIsFocused = !this._data().length || focusedItem === null;
        var optionID = (0, $b6t9X.instanceId)(this, "__createlist_option");
        return $fc29b2e9a6a4b9fa$var$_react2.default.createElement("ul", {
            id: id,
            role: "listbox",
            className: "rw-list rw-multiselect-create-tag"
        }, $fc29b2e9a6a4b9fa$var$_react2.default.createElement("li", {
            id: optionID,
            role: "option",
            onClick: function onClick() {
                return _this.handleCreate(searchTerm);
            },
            className: (0, $fc29b2e9a6a4b9fa$var$_classnames2.default)("rw-list-option", "rw-create-list-option", createIsFocused && "rw-state-focus")
        }, $fc29b2e9a6a4b9fa$var$compatCreate(this.props, messages)));
    },
    renderInput: function renderInput(owns) {
        var _props2 = this.props, searchTerm = _props2.searchTerm, maxLength = _props2.maxLength, tabIndex = _props2.tabIndex, busy = _props2.busy, open = _props2.open, disabled = _props2.disabled, readOnly = _props2.readOnly;
        return $fc29b2e9a6a4b9fa$var$_react2.default.createElement($fc29b2e9a6a4b9fa$var$_MultiselectInput2.default, {
            ref: "input",
            tabIndex: tabIndex || 0,
            role: "listbox",
            "aria-expanded": !!open,
            "aria-busy": !!busy,
            autoFocus: this.props.autoFocus,
            "aria-owns": owns,
            "aria-haspopup": true,
            value: searchTerm,
            maxLength: maxLength,
            disabled: disabled === true,
            readOnly: readOnly === true,
            placeholder: this.getPlaceholder(),
            inputSize: this.props.inputSize,
            onKeyDown: this.handleSearchKeyDown,
            onKeyUp: this.handleSearchKeyUp,
            onChange: this.handleInputChange,
            onClick: this.handleInputInteraction,
            onTouchEnd: this.handleInputInteraction
        });
    },
    renderList: function renderList(List, id, messages) {
        var _props3 = this.props, open = _props3.open, disabled = _props3.disabled, readOnly = _props3.readOnly;
        var focusedItem = this.state.focusedItem;
        var listProps = $fc29b2e9a6a4b9fa$var$_3.default.pickProps(this.props, List);
        var items = this._data();
        return $fc29b2e9a6a4b9fa$var$_react2.default.createElement(List, $fc29b2e9a6a4b9fa$var$_extends({
            ref: "list",
            key: 0
        }, listProps, {
            readOnly: readOnly,
            disabled: disabled,
            id: id,
            "aria-live": "polite",
            "aria-labelledby": (0, $b6t9X.instanceId)(this),
            "aria-hidden": !open,
            ariaActiveDescendantKey: "list",
            data: items,
            focused: focusedItem,
            onSelect: this.handleSelect,
            onMove: this._scrollTo,
            messages: {
                emptyList: this._lengthWithoutValues ? messages.emptyFilter : messages.emptyList
            }
        }));
    },
    renderNotificationArea: function renderNotificationArea(id, messages) {
        var textField = this.props.textField;
        var _state = this.state, focused = _state.focused, dataItems = _state.dataItems;
        return $fc29b2e9a6a4b9fa$var$_react2.default.createElement("span", {
            id: id,
            role: "status",
            className: "rw-sr",
            "aria-live": "assertive",
            "aria-atomic": "true",
            "aria-relevant": "additions removals text"
        }, focused && (dataItems.length ? messages.selectedItems + ": " + dataItems.map(function(item) {
            return (0, $3Y3Be.dataText)(item, textField);
        }).join(", ") : messages.noneSelected));
    },
    renderTags: function renderTags(id, messages) {
        var _props4 = this.props, disabled = _props4.disabled, readOnly = _props4.readOnly, valueField = _props4.valueField, textField = _props4.textField;
        var _state2 = this.state, focusedTag = _state2.focusedTag, dataItems = _state2.dataItems;
        var Component = this.props.tagComponent;
        return $fc29b2e9a6a4b9fa$var$_react2.default.createElement($fc29b2e9a6a4b9fa$var$_MultiselectTagList2.default, {
            ref: "tagList",
            id: id,
            valueField: valueField,
            textField: textField,
            "aria-label": messages.tagsLabel,
            value: dataItems,
            focused: focusedTag,
            disabled: disabled,
            readOnly: readOnly,
            onDelete: this.handleDelete,
            valueComponent: Component,
            ariaActiveDescendantKey: "taglist"
        });
    },
    render: function render() {
        var _this2 = this;
        var _props5 = this.props, className = _props5.className, groupBy = _props5.groupBy, messages = _props5.messages, busy = _props5.busy, dropUp = _props5.dropUp, open = _props5.open, duration = _props5.duration, disabled = _props5.disabled, readOnly = _props5.readOnly, List = _props5.listComponent;
        var _state3 = this.state, focused = _state3.focused, dataItems = _state3.dataItems;
        List = List || groupBy && $fc29b2e9a6a4b9fa$var$_ListGroupable2.default || $fc29b2e9a6a4b9fa$var$_List2.default;
        var elementProps = $fc29b2e9a6a4b9fa$var$_3.default.omitOwnProps(this, List);
        var shouldRenderTags = !!dataItems.length, shouldRenderPopup = (0, $b6t9X.isFirstFocusedRender)(this) || open, shouldShowCreate = this.shouldShowCreate();
        var tagsID = (0, $b6t9X.instanceId)(this, "_taglist"), listID = (0, $b6t9X.instanceId)(this, "__listbox"), createID = (0, $b6t9X.instanceId)(this, "__createlist"), notifyID = (0, $b6t9X.instanceId)(this, "__notify");
        var inputOwns = listID + " " + notifyID + " " + (shouldRenderTags ? tagsID : "") + (shouldShowCreate ? createID : "");
        messages = $fc29b2e9a6a4b9fa$var$msgs(messages);
        return $fc29b2e9a6a4b9fa$var$_react2.default.createElement($fc29b2e9a6a4b9fa$var$_Widget2.default, $fc29b2e9a6a4b9fa$var$_extends({}, elementProps, {
            id: (0, $b6t9X.instanceId)(this),
            open: open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled === true,
            readOnly: readOnly === true,
            onKeyDown: this.handleKeyDown,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onTouchEnd: this.handleFocus,
            className: (0, $fc29b2e9a6a4b9fa$var$_classnames2.default)(className, "rw-multiselect")
        }), this.renderNotificationArea(notifyID, messages), $fc29b2e9a6a4b9fa$var$_react2.default.createElement("div", {
            className: "rw-multiselect-wrapper"
        }, busy && $fc29b2e9a6a4b9fa$var$_react2.default.createElement("span", {
            className: "rw-i rw-loading"
        }), shouldRenderTags && this.renderTags(tagsID, messages), this.renderInput(inputOwns)), shouldRenderPopup && $fc29b2e9a6a4b9fa$var$_react2.default.createElement($fc29b2e9a6a4b9fa$var$_Popup2.default, {
            dropUp: dropUp,
            open: open,
            duration: duration,
            onOpening: function onOpening() {
                return _this2.refs.list.forceUpdate();
            }
        }, $fc29b2e9a6a4b9fa$var$_react2.default.createElement("div", null, this.renderList(List, listID, messages), shouldShowCreate && this.renderCreateItem(createID, messages))));
    },
    _data: function _data() {
        return this.state.processedData;
    },
    handleDelete: function handleDelete(value) {
        this.focus();
        this.change(this.state.dataItems.filter(function(d) {
            return d !== value;
        }));
    },
    handleSearchKeyDown: function handleSearchKeyDown(e) {
        if (e.key === "Backspace" && e.target.value && !this._deletingText) this._deletingText = true;
    },
    handleSearchKeyUp: function handleSearchKeyUp(e) {
        if (e.key === "Backspace" && this._deletingText) this._deletingText = false;
    },
    handleInputChange: function handleInputChange(e) {
        (0, $b6t9X.notify)(this.props.onSearch, [
            e.target.value
        ]);
        this.open();
    },
    handleInputInteraction: function handleInputInteraction() {
        this.open();
    },
    handleSelect: function handleSelect(data) {
        if (data === undefined) {
            if (this.props.onCreate) this.handleCreate(this.props.searchTerm);
            return;
        }
        (0, $b6t9X.notify)(this.props.onSelect, data);
        this.change(this.state.dataItems.concat(data));
        this.close();
        this.focus();
    },
    handleCreate: function handleCreate(tag) {
        if (tag.trim() === "") return;
        (0, $b6t9X.notify)(this.props.onCreate, tag);
        this.props.searchTerm && (0, $b6t9X.notify)(this.props.onSearch, [
            ""
        ]);
        this.close();
        this.focus();
    },
    handleKeyDown: function handleKeyDown(e) {
        var key = e.key, keyCode = e.keyCode, altKey = e.altKey, ctrlKey = e.ctrlKey, noSearch = !this.props.searchTerm && !this._deletingText, isOpen = this.props.open;
        var _state4 = this.state, focusedTag = _state4.focusedTag, focusedItem = _state4.focusedItem;
        var _refs = this.refs, list = _refs.list, tagList = _refs.tagList;
        var nullTag = {
            focusedTag: null
        };
        (0, $b6t9X.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (key === "ArrowDown") {
            var next = list.next(focusedItem), creating = this.shouldShowCreate() && focusedItem === next || focusedItem === null;
            next = creating ? null : next;
            e.preventDefault();
            if (isOpen) this.setState($fc29b2e9a6a4b9fa$var$_extends({
                focusedItem: next
            }, nullTag));
            else this.open();
        } else if (key === "ArrowUp") {
            var prev = focusedItem === null ? list.last() : list.prev(focusedItem);
            e.preventDefault();
            if (altKey) this.close();
            else if (isOpen) this.setState($fc29b2e9a6a4b9fa$var$_extends({
                focusedItem: prev
            }, nullTag));
        } else if (key === "End") {
            e.preventDefault();
            if (isOpen) this.setState($fc29b2e9a6a4b9fa$var$_extends({
                focusedItem: list.last()
            }, nullTag));
            else tagList && this.setState({
                focusedTag: tagList.last()
            });
        } else if (key === "Home") {
            e.preventDefault();
            if (isOpen) this.setState($fc29b2e9a6a4b9fa$var$_extends({
                focusedItem: list.first()
            }, nullTag));
            else tagList && this.setState({
                focusedTag: tagList.first()
            });
        } else if (isOpen && keyCode === 13) {
            // using keyCode to ignore enter for japanese IME
            e.preventDefault();
            ctrlKey && this.props.onCreate || focusedItem === null ? this.handleCreate(this.props.searchTerm) : this.handleSelect(this.state.focusedItem);
        } else if (key === "Escape") isOpen ? this.close() : tagList && this.setState(nullTag);
        else if (noSearch && key === "ArrowLeft") tagList && this.setState({
            focusedTag: tagList.prev(focusedTag)
        });
        else if (noSearch && key === "ArrowRight") tagList && this.setState({
            focusedTag: tagList.next(focusedTag)
        });
        else if (noSearch && key === "Delete") tagList && tagList.remove(focusedTag);
        else if (noSearch && key === "Backspace") tagList && tagList.removeNext();
    },
    change: function change(data) {
        (0, $b6t9X.notify)(this.props.onChange, [
            data
        ]);
        (0, $b6t9X.notify)(this.props.onSearch, [
            ""
        ]);
    },
    focus: function focus() {
        this.refs.input && this.refs.input.focus();
    },
    open: function open() {
        if (!this.props.open) (0, $b6t9X.notify)(this.props.onToggle, true);
    },
    close: function close() {
        (0, $b6t9X.notify)(this.props.onToggle, false);
    },
    toggle: function toggle() {
        this.props.open ? this.close() : this.open();
    },
    process: function process(data, values, searchTerm) {
        var valueField = this.props.valueField;
        var items = data.filter(function(i) {
            return !values.some(function(v) {
                return (0, $3Y3Be.valueMatcher)(i, v, valueField);
            });
        });
        this._lengthWithoutValues = items.length;
        if (searchTerm) items = this.filter(items, searchTerm);
        return items;
    },
    shouldShowCreate: function shouldShowCreate() {
        var _props6 = this.props, textField = _props6.textField, searchTerm = _props6.searchTerm, onCreate = _props6.onCreate, caseSensitive = _props6.caseSensitive;
        if (!onCreate || !searchTerm) return false;
        var lower = function lower(text) {
            return caseSensitive ? text : text.toLowerCase();
        };
        var eq = function eq(v) {
            return lower((0, $3Y3Be.dataText)(v, textField)) === lower(searchTerm);
        };
        // if there is an exact match on textFields: "john" => { name: "john" }, don't show
        return !this._data().some(eq) && !this.state.dataItems.some(eq);
    },
    getPlaceholder: function getPlaceholder() {
        return (this.props.value || []).length ? "" : this.props.placeholder || "";
    }
}, $fc29b2e9a6a4b9fa$var$_applyDecoratedDescriptor($fc29b2e9a6a4b9fa$var$_obj, "handleInputInteraction", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($fc29b2e9a6a4b9fa$var$_obj, "handleInputInteraction"), $fc29b2e9a6a4b9fa$var$_obj), $fc29b2e9a6a4b9fa$var$_applyDecoratedDescriptor($fc29b2e9a6a4b9fa$var$_obj, "handleSelect", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($fc29b2e9a6a4b9fa$var$_obj, "handleSelect"), $fc29b2e9a6a4b9fa$var$_obj), $fc29b2e9a6a4b9fa$var$_applyDecoratedDescriptor($fc29b2e9a6a4b9fa$var$_obj, "handleCreate", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($fc29b2e9a6a4b9fa$var$_obj, "handleCreate"), $fc29b2e9a6a4b9fa$var$_obj), $fc29b2e9a6a4b9fa$var$_applyDecoratedDescriptor($fc29b2e9a6a4b9fa$var$_obj, "handleKeyDown", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($fc29b2e9a6a4b9fa$var$_obj, "handleKeyDown"), $fc29b2e9a6a4b9fa$var$_obj), $fc29b2e9a6a4b9fa$var$_applyDecoratedDescriptor($fc29b2e9a6a4b9fa$var$_obj, "change", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($fc29b2e9a6a4b9fa$var$_obj, "change"), $fc29b2e9a6a4b9fa$var$_obj), $fc29b2e9a6a4b9fa$var$_obj));
function $fc29b2e9a6a4b9fa$var$msgs(msgs) {
    return $fc29b2e9a6a4b9fa$var$_extends({
        createNew: "(create new tag)",
        emptyList: "There are no items in this list",
        emptyFilter: "The filter returned no results",
        tagsLabel: "selected items",
        selectedItems: "selected items",
        removeLabel: "remove selected item"
    }, msgs);
}
module.exports.default = (0, $fc29b2e9a6a4b9fa$var$_uncontrollable2.default)($fc29b2e9a6a4b9fa$var$Multiselect, {
    open: "onToggle",
    value: "onChange",
    searchTerm: "onSearch"
}, [
    "focus"
]);
module.exports = module.exports["default"];

});
parcelRegister("83Fz7", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $5dded88f67ef626a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5dded88f67ef626a$var$_class, $5dded88f67ef626a$var$_temp;

var $7PdBe = parcelRequire("7PdBe");
var $5dded88f67ef626a$var$_react2 = $5dded88f67ef626a$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $5dded88f67ef626a$var$_propTypes2 = $5dded88f67ef626a$var$_interopRequireDefault($S29Lp);

var $4cOpg = parcelRequire("4cOpg");
var $5dded88f67ef626a$var$_3 = $5dded88f67ef626a$var$_interopRequireDefault($4cOpg);

var $96zKa = parcelRequire("96zKa");
var $5dded88f67ef626a$var$_compat2 = $5dded88f67ef626a$var$_interopRequireDefault($96zKa);

var $8v4NT = parcelRequire("8v4NT");
var $5dded88f67ef626a$var$_propTypes4 = $5dded88f67ef626a$var$_interopRequireDefault($8v4NT);
function $5dded88f67ef626a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5dded88f67ef626a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5dded88f67ef626a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5dded88f67ef626a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5dded88f67ef626a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5dded88f67ef626a$var$MultiselectInput = ($5dded88f67ef626a$var$_temp = $5dded88f67ef626a$var$_class = function(_React$Component) {
    $5dded88f67ef626a$var$_inherits(MultiselectInput, _React$Component);
    function MultiselectInput() {
        $5dded88f67ef626a$var$_classCallCheck(this, MultiselectInput);
        return $5dded88f67ef626a$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    MultiselectInput.prototype.render = function render() {
        var _props = this.props, disabled = _props.disabled, readOnly = _props.readOnly, placeholder = _props.placeholder, onChange = _props.onChange, value = _props.value, props = $5dded88f67ef626a$var$_objectWithoutProperties(_props, [
            "disabled",
            "readOnly",
            "placeholder",
            "onChange",
            "value"
        ]);
        var size = props.inputSize ? props.inputSize(value || placeholder) : Math.max((value || placeholder).length, 1) + 1;
        var elementProps = $5dded88f67ef626a$var$_3.default.omitOwnProps(this);
        return $5dded88f67ef626a$var$_react2.default.createElement("input", $5dded88f67ef626a$var$_extends({}, elementProps, {
            size: size,
            className: "rw-input",
            autoComplete: "off",
            "aria-disabled": disabled,
            "aria-readonly": readOnly,
            disabled: disabled,
            readOnly: readOnly,
            placeholder: placeholder,
            onChange: onChange,
            value: value
        }));
    };
    MultiselectInput.prototype.focus = function focus() {
        $5dded88f67ef626a$var$_compat2.default.findDOMNode(this).focus();
    };
    return MultiselectInput;
}($5dded88f67ef626a$var$_react2.default.Component), $5dded88f67ef626a$var$_class.propTypes = {
    value: $5dded88f67ef626a$var$_propTypes2.default.string,
    placeholder: $5dded88f67ef626a$var$_propTypes2.default.string,
    maxLength: $5dded88f67ef626a$var$_propTypes2.default.number,
    inputSize: $5dded88f67ef626a$var$_propTypes2.default.func,
    onChange: $5dded88f67ef626a$var$_propTypes2.default.func.isRequired,
    disabled: $5dded88f67ef626a$var$_propTypes4.default.disabled,
    readOnly: $5dded88f67ef626a$var$_propTypes4.default.readOnly
}, $5dded88f67ef626a$var$_temp);
module.exports.default = $5dded88f67ef626a$var$MultiselectInput;
module.exports = module.exports["default"];

});

parcelRegister("jpla3", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $e210c44f28cd07ce$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7PdBe = parcelRequire("7PdBe");
var $e210c44f28cd07ce$var$_react2 = $e210c44f28cd07ce$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $e210c44f28cd07ce$var$_propTypes2 = $e210c44f28cd07ce$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $e210c44f28cd07ce$var$_createReactClass2 = $e210c44f28cd07ce$var$_interopRequireDefault($5JTQC);

var $4cOpg = parcelRequire("4cOpg");
var $e210c44f28cd07ce$var$_3 = $e210c44f28cd07ce$var$_interopRequireDefault($4cOpg);

var $ksXgP = parcelRequire("ksXgP");
var $e210c44f28cd07ce$var$_classnames2 = $e210c44f28cd07ce$var$_interopRequireDefault($ksXgP);

var $8v4NT = parcelRequire("8v4NT");
var $e210c44f28cd07ce$var$_propTypes4 = $e210c44f28cd07ce$var$_interopRequireDefault($8v4NT);

var $b6t9X = parcelRequire("b6t9X");

var $3Y3Be = parcelRequire("3Y3Be");

var $7RxtH = parcelRequire("7RxtH");
function $e210c44f28cd07ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e210c44f28cd07ce$var$optionId = function optionId(id, idx) {
    return id + "__option__" + idx;
};


module.exports.default = (0, $e210c44f28cd07ce$var$_createReactClass2.default)({
    displayName: "MultiselectTagList",
    mixins: [
        (parcelRequire("3agVy")),
        (parcelRequire("9AXXZ"))()
    ],
    propTypes: {
        value: $e210c44f28cd07ce$var$_propTypes2.default.array,
        focused: $e210c44f28cd07ce$var$_propTypes2.default.number,
        valueField: $e210c44f28cd07ce$var$_propTypes2.default.string,
        textField: $e210c44f28cd07ce$var$_propTypes4.default.accessor,
        onDelete: $e210c44f28cd07ce$var$_propTypes2.default.func.isRequired,
        valueComponent: $e210c44f28cd07ce$var$_propTypes2.default.func,
        disabled: $e210c44f28cd07ce$var$_propTypes4.default.disabled.acceptsArray,
        readOnly: $e210c44f28cd07ce$var$_propTypes4.default.readOnly.acceptsArray
    },
    getDefaultProps: function getDefaultProps() {
        return {
            ariaActiveDescendantKey: "taglist"
        };
    },
    componentDidUpdate: function componentDidUpdate() {
        var focused = this.props.focused, activeId = $e210c44f28cd07ce$var$optionId((0, $b6t9X.instanceId)(this), focused);
        this.ariaActiveDescendant(focused == null || (0, $7RxtH.isDisabledItem)(focused, this.props) ? null : activeId);
    },
    render: function render() {
        var _this = this;
        var _props = this.props, focused = _props.focused, value = _props.value, textField = _props.textField, ValueComponent = _props.valueComponent;
        var id = (0, $b6t9X.instanceId)(this);
        var props = $e210c44f28cd07ce$var$_3.default.omitOwnProps(this);
        return $e210c44f28cd07ce$var$_react2.default.createElement("ul", $e210c44f28cd07ce$var$_extends({}, props, {
            role: "listbox",
            tabIndex: "-1",
            className: "rw-multiselect-taglist"
        }), value.map(function(item, i) {
            var isDisabled = (0, $7RxtH.isDisabledItem)(item, _this.props), isReadonly = (0, $7RxtH.isReadOnlyItem)(item, _this.props), isFocused = !isDisabled && focused === i, currentID = $e210c44f28cd07ce$var$optionId(id, i);
            return $e210c44f28cd07ce$var$_react2.default.createElement("li", {
                key: i,
                id: currentID,
                tabIndex: "-1",
                role: "option",
                className: (0, $e210c44f28cd07ce$var$_classnames2.default)({
                    "rw-state-focus": isFocused,
                    "rw-state-disabled": isDisabled,
                    "rw-state-readonly": isReadonly
                })
            }, ValueComponent ? $e210c44f28cd07ce$var$_react2.default.createElement(ValueComponent, {
                item: item
            }) : (0, $3Y3Be.dataText)(item, textField), $e210c44f28cd07ce$var$_react2.default.createElement("span", {
                tabIndex: "-1",
                onClick: !(isDisabled || isReadonly) ? _this._delete.bind(null, item) : undefined,
                "aria-disabled": isDisabled,
                "aria-label": "Unselect",
                disabled: isDisabled
            }, $e210c44f28cd07ce$var$_react2.default.createElement("span", {
                className: "rw-tag-btn",
                "aria-hidden": "true"
            }, "\xd7")));
        }));
    },
    _delete: function _delete(val) {
        this.props.onDelete(val);
    },
    remove: function remove(idx) {
        var val = this.props.value[idx];
        if (val && !((0, $7RxtH.isDisabledItem)(val, this.props) || (0, $7RxtH.isReadOnlyItem)(val, this.props))) this.props.onDelete(val);
    },
    removeNext: function removeNext() {
        var val = this.props.value[this.props.value.length - 1];
        if (val && !((0, $7RxtH.isDisabledItem)(val, this.props) || (0, $7RxtH.isReadOnlyItem)(val, this.props))) this.props.onDelete(val);
    },
    clear: function clear() {
        this.setState({
            focused: null
        });
    },
    first: function first() {
        var idx = 0, value = this.props.value, l = value.length;
        while(idx < l && (0, $7RxtH.isDisabledItem)(value[idx], this.props))idx++;
        return idx !== l ? idx : null;
    },
    last: function last() {
        var value = this.props.value, idx = value.length - 1;
        while(idx > -1 && (0, $7RxtH.isDisabledItem)(value[idx], this.props))idx--;
        return idx >= 0 ? idx : null;
    },
    next: function next(current) {
        var nextIdx = current + 1, value = this.props.value, l = value.length;
        while(nextIdx < l && (0, $7RxtH.isDisabledItem)(nextIdx, this.props))nextIdx++;
        if (current === null || nextIdx >= l) return null;
        return nextIdx;
    },
    prev: function prev(current) {
        var nextIdx = current, value = this.props.value;
        if (nextIdx === null || nextIdx === 0) nextIdx = value.length;
        nextIdx--;
        while(nextIdx > -1 && (0, $7RxtH.isDisabledItem)(value[nextIdx], this.props))nextIdx--;
        return nextIdx >= 0 ? nextIdx : null;
    }
});
module.exports = module.exports["default"];

});


parcelRegister("1rnPs", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $10cacbfa4ebd9f8c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $10cacbfa4ebd9f8c$var$_desc, $10cacbfa4ebd9f8c$var$_value, $10cacbfa4ebd9f8c$var$_obj;

var $7PdBe = parcelRequire("7PdBe");
var $10cacbfa4ebd9f8c$var$_react2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($7PdBe);

var $S29Lp = parcelRequire("S29Lp");
var $10cacbfa4ebd9f8c$var$_propTypes2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($S29Lp);

var $5JTQC = parcelRequire("5JTQC");
var $10cacbfa4ebd9f8c$var$_createReactClass2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($5JTQC);

var $4cOpg = parcelRequire("4cOpg");
var $10cacbfa4ebd9f8c$var$_3 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($4cOpg);

var $ksXgP = parcelRequire("ksXgP");
var $10cacbfa4ebd9f8c$var$_classnames2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($ksXgP);

var $7iIDV = parcelRequire("7iIDV");
var $10cacbfa4ebd9f8c$var$_uncontrollable2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($7iIDV);

var $96zKa = parcelRequire("96zKa");
var $10cacbfa4ebd9f8c$var$_compat2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($96zKa);

var $8v4NT = parcelRequire("8v4NT");
var $10cacbfa4ebd9f8c$var$_propTypes4 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($8v4NT);

var $emiXD = parcelRequire("emiXD");
var $10cacbfa4ebd9f8c$var$_List2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($emiXD);

var $bp2Lh = parcelRequire("bp2Lh");
var $10cacbfa4ebd9f8c$var$_ListGroupable2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($bp2Lh);

var $e29jL = parcelRequire("e29jL");
var $10cacbfa4ebd9f8c$var$_ListOption2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($e29jL);

var $atEP4 = parcelRequire("atEP4");
var $10cacbfa4ebd9f8c$var$_Widget2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($atEP4);

var $jQzQU = parcelRequire("jQzQU");
var $10cacbfa4ebd9f8c$var$_validateListInterface2 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($jQzQU);

var $6PAjE = parcelRequire("6PAjE");
var $10cacbfa4ebd9f8c$var$_scrollTo3 = $10cacbfa4ebd9f8c$var$_interopRequireDefault($6PAjE);

var $3Y3Be = parcelRequire("3Y3Be");

var $7RxtH = parcelRequire("7RxtH");

var $b6t9X = parcelRequire("b6t9X");
function $10cacbfa4ebd9f8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $10cacbfa4ebd9f8c$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $10cacbfa4ebd9f8c$var$find = $10cacbfa4ebd9f8c$var$_3.default.find;
var $10cacbfa4ebd9f8c$var$propTypes = {
    data: $10cacbfa4ebd9f8c$var$_propTypes2.default.array,
    value: $10cacbfa4ebd9f8c$var$_propTypes2.default.oneOfType([
        $10cacbfa4ebd9f8c$var$_propTypes2.default.any,
        $10cacbfa4ebd9f8c$var$_propTypes2.default.array
    ]),
    onChange: $10cacbfa4ebd9f8c$var$_propTypes2.default.func,
    onMove: $10cacbfa4ebd9f8c$var$_propTypes2.default.func,
    multiple: $10cacbfa4ebd9f8c$var$_propTypes2.default.bool,
    itemComponent: $10cacbfa4ebd9f8c$var$_propTypes4.default.elementType,
    listComponent: $10cacbfa4ebd9f8c$var$_propTypes4.default.elementType,
    valueField: $10cacbfa4ebd9f8c$var$_propTypes2.default.string,
    textField: $10cacbfa4ebd9f8c$var$_propTypes4.default.accessor,
    busy: $10cacbfa4ebd9f8c$var$_propTypes2.default.bool,
    filter: $10cacbfa4ebd9f8c$var$_propTypes2.default.string,
    delay: $10cacbfa4ebd9f8c$var$_propTypes2.default.number,
    disabled: $10cacbfa4ebd9f8c$var$_propTypes4.default.disabled.acceptsArray,
    readOnly: $10cacbfa4ebd9f8c$var$_propTypes4.default.readOnly.acceptsArray,
    messages: $10cacbfa4ebd9f8c$var$_propTypes2.default.shape({
        emptyList: $10cacbfa4ebd9f8c$var$_propTypes2.default.string
    })
};
function $10cacbfa4ebd9f8c$var$getFirstValue(props) {
    var data = props.data, value = props.value, valueField = props.valueField;
    value = $10cacbfa4ebd9f8c$var$_3.default.splat(value);
    if (value.length) return $10cacbfa4ebd9f8c$var$find(data, function(d) {
        return (0, $3Y3Be.dataIndexOf)(value, d, valueField) !== -1;
    }) || null;
    return null;
}





var $10cacbfa4ebd9f8c$var$SelectList = (0, $10cacbfa4ebd9f8c$var$_createReactClass2.default)(($10cacbfa4ebd9f8c$var$_obj = {
    displayName: "SelectList",
    propTypes: $10cacbfa4ebd9f8c$var$propTypes,
    mixins: [
        (parcelRequire("5jwiU")),
        (parcelRequire("4cxcq")),
        (parcelRequire("5NCz1")),
        (parcelRequire("9AXXZ"))(),
        (parcelRequire("k1uk1"))({
            didHandle: function didHandle(focused) {
                // the rigamarole here is to avoid flicker went clicking an item and
                // gaining focus at the same time.
                if (focused !== this.state.focused) {
                    if (!focused) this.setState({
                        focusedItem: null
                    });
                    else if (focused && !this._clicking) this.setState({
                        focusedItem: $10cacbfa4ebd9f8c$var$getFirstValue(this.props)
                    });
                    this._clicking = false;
                }
            }
        })
    ],
    getDefaultProps: function getDefaultProps() {
        return {
            delay: 250,
            value: [],
            data: [],
            ariaActiveDescendantKey: "selectlist",
            messages: {
                emptyList: "There are no items in this list"
            }
        };
    },
    getDefaultState: function getDefaultState(props) {
        var data = props.data, value = props.value, valueField = props.valueField, multiple = props.multiple;
        return {
            dataItems: multiple && $10cacbfa4ebd9f8c$var$_3.default.splat(value).map(function(item) {
                return (0, $3Y3Be.dataItem)(data, item, valueField);
            })
        };
    },
    getInitialState: function getInitialState() {
        var state = this.getDefaultState(this.props);
        state.ListItem = $10cacbfa4ebd9f8c$var$getListItem(this);
        return state;
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        return this.setState(this.getDefaultState(nextProps));
    },
    componentDidMount: function componentDidMount() {
        (0, $10cacbfa4ebd9f8c$var$_validateListInterface2.default)(this.refs.list);
    },
    render: function render() {
        var _props = this.props, className = _props.className, tabIndex = _props.tabIndex, busy = _props.busy, groupBy = _props.groupBy, List = _props.listComponent;
        List = List || groupBy && $10cacbfa4ebd9f8c$var$_ListGroupable2.default || $10cacbfa4ebd9f8c$var$_List2.default;
        var elementProps = $10cacbfa4ebd9f8c$var$_3.default.omitOwnProps(this, List);
        var listProps = $10cacbfa4ebd9f8c$var$_3.default.pickProps(this.props, List);
        var _state = this.state, ListItem = _state.ListItem, focusedItem = _state.focusedItem, focused = _state.focused;
        var items = this._data();
        focusedItem = focused && !(0, $7RxtH.isDisabled)(this.props) && !(0, $7RxtH.isReadOnly)(this.props) && focusedItem;
        return $10cacbfa4ebd9f8c$var$_react2.default.createElement($10cacbfa4ebd9f8c$var$_Widget2.default, $10cacbfa4ebd9f8c$var$_extends({}, elementProps, {
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            disabled: (0, $7RxtH.isDisabled)(this.props),
            readOnly: (0, $7RxtH.isReadOnly)(this.props),
            role: "radiogroup",
            "aria-busy": !!busy,
            className: (0, $10cacbfa4ebd9f8c$var$_classnames2.default)(className, "rw-selectlist", busy && "rw-loading-mask")
        }), $10cacbfa4ebd9f8c$var$_react2.default.createElement(List, $10cacbfa4ebd9f8c$var$_extends({}, listProps, {
            ref: "list",
            role: "radiogroup",
            tabIndex: tabIndex || "0",
            id: (0, $b6t9X.instanceId)(this, "_listbox"),
            data: items,
            focused: focusedItem,
            optionComponent: ListItem,
            itemComponent: this.props.itemComponent,
            onMove: this._scrollTo
        })));
    },
    _scrollTo: function _scrollTo(selected, list) {
        var handler = this.props.onMove;
        if (handler) handler(selected, list);
        else {
            this._scrollCancel && this._scrollCancel();
            // default behavior is to scroll the whole page not just the widget
            this._scrollCancel = (0, $10cacbfa4ebd9f8c$var$_scrollTo3.default)(selected);
        }
    },
    handleKeyDown: function handleKeyDown(e) {
        var _this = this;
        var key = e.key, _props2 = this.props, valueField = _props2.valueField, multiple = _props2.multiple, list = this.refs.list, focusedItem = this.state.focusedItem;
        var change = function change(item) {
            if (item) _this.handleChange(item, multiple ? !(0, $7RxtH.contains)(item, _this._values(), valueField) // toggle value
             : true);
        };
        (0, $b6t9X.notify)(this.props.onKeyDown, [
            e
        ]);
        if (e.defaultPrevented) return;
        if (key === "End") {
            e.preventDefault();
            focusedItem = list.last();
            this.setState({
                focusedItem: focusedItem
            });
            if (!multiple) change(focusedItem);
        } else if (key === "Home") {
            e.preventDefault();
            focusedItem = list.first();
            this.setState({
                focusedItem: focusedItem
            });
            if (!multiple) change(focusedItem);
        } else if (key === "Enter" || key === " ") {
            e.preventDefault();
            change(focusedItem);
        } else if (key === "ArrowDown" || key === "ArrowRight") {
            e.preventDefault();
            focusedItem = list.next(focusedItem);
            this.setState({
                focusedItem: focusedItem
            });
            if (!multiple) change(focusedItem);
        } else if (key === "ArrowUp" || key === "ArrowLeft") {
            e.preventDefault();
            focusedItem = list.prev(focusedItem);
            this.setState({
                focusedItem: focusedItem
            });
            if (!multiple) change(focusedItem);
        } else if (multiple && e.keyCode === 65 && e.ctrlKey) {
            e.preventDefault();
            this.selectAll();
        }
    },
    handleKeyPress: function handleKeyPress(e) {
        (0, $b6t9X.notify)(this.props.onKeyPress, [
            e
        ]);
        if (e.defaultPrevented) return;
        this.search(String.fromCharCode(e.which));
    },
    focus: function focus() {
        $10cacbfa4ebd9f8c$var$_compat2.default.findDOMNode(this.refs.list).focus();
    },
    selectAll: function selectAll() {
        var _this2 = this;
        var _props3 = this.props, disabled = _props3.disabled, readOnly = _props3.readOnly, valueField = _props3.valueField, values = this.state.dataItems, data = this._data(), blacklist;
        disabled = disabled || readOnly;
        disabled = Array.isArray(disabled) ? disabled : [];
        //disabled values that are not selected
        blacklist = disabled.filter(function(v) {
            return !(0, $7RxtH.contains)(v, values, valueField);
        });
        data = data.filter(function(v) {
            return !(0, $7RxtH.contains)(v, blacklist, valueField);
        });
        if (data.length === values.length) {
            data = disabled.filter(function(item) {
                return (0, $7RxtH.contains)(item, values, valueField);
            });
            data = data.map(function(item) {
                return (0, $3Y3Be.dataItem)(_this2._data(), item, valueField);
            });
        }
        (0, $b6t9X.notify)(this.props.onChange, [
            data
        ]);
    },
    handleChange: function handleChange(item, checked) {
        var multiple = this.props.multiple, values = this.state.dataItems;
        multiple = !!multiple;
        this.clearTimeout("focusedItem");
        this.setState({
            focusedItem: item
        });
        if (!multiple) return (0, $b6t9X.notify)(this.props.onChange, checked ? item : null);
        values = checked ? values.concat(item) : values.filter(function(v) {
            return v !== item;
        });
        (0, $b6t9X.notify)(this.props.onChange, [
            values || []
        ]);
    },
    search: function search(character) {
        var _this3 = this;
        var word = ((this._searchTerm || "") + character).toLowerCase(), list = this.refs.list, multiple = this.props.multiple;
        if (!character) return;
        this._searchTerm = word;
        this.setTimeout("search", function() {
            var focusedItem = list.next(_this3.state.focusedItem, word);
            _this3._searchTerm = "";
            if (focusedItem) !multiple ? _this3.handleChange(focusedItem, true) : _this3.setState({
                focusedItem: focusedItem
            });
        }, this.props.delay);
    },
    _data: function _data() {
        return this.props.data;
    },
    _values: function _values() {
        return this.props.multiple ? this.state.dataItems : this.props.value;
    }
}, $10cacbfa4ebd9f8c$var$_applyDecoratedDescriptor($10cacbfa4ebd9f8c$var$_obj, "handleKeyDown", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($10cacbfa4ebd9f8c$var$_obj, "handleKeyDown"), $10cacbfa4ebd9f8c$var$_obj), $10cacbfa4ebd9f8c$var$_applyDecoratedDescriptor($10cacbfa4ebd9f8c$var$_obj, "handleKeyPress", [
    $7RxtH.widgetEditable
], Object.getOwnPropertyDescriptor($10cacbfa4ebd9f8c$var$_obj, "handleKeyPress"), $10cacbfa4ebd9f8c$var$_obj), $10cacbfa4ebd9f8c$var$_obj));
function $10cacbfa4ebd9f8c$var$getListItem(parent) {
    return (0, $10cacbfa4ebd9f8c$var$_createReactClass2.default)({
        displayName: "SelectItem",
        handleChange: function handleChange(e) {
            var _props4 = this.props, disabled = _props4.disabled, readonly = _props4.readonly, dataItem = _props4.dataItem;
            if (!disabled && !readonly) parent.handleChange(dataItem, e.target.checked);
        },
        handleMouseDown: function handleMouseDown() {
            parent._clicking = true;
        },
        render: function render() {
            var _props5 = this.props, children = _props5.children, disabled = _props5.disabled, readonly = _props5.readonly, item = _props5.dataItem;
            var _parent$props = parent.props, multiple = _parent$props.multiple, _parent$props$name = _parent$props.name, name = _parent$props$name === undefined ? (0, $b6t9X.instanceId)(parent, "_name") : _parent$props$name;
            var checked = (0, $7RxtH.contains)(item, parent._values(), parent.props.valueField), type = multiple ? "checkbox" : "radio";
            return $10cacbfa4ebd9f8c$var$_react2.default.createElement($10cacbfa4ebd9f8c$var$_ListOption2.default, $10cacbfa4ebd9f8c$var$_extends({}, this.props, {
                role: type,
                "aria-checked": !!checked
            }), $10cacbfa4ebd9f8c$var$_react2.default.createElement("label", {
                onMouseDown: this.handleMouseDown
            }, $10cacbfa4ebd9f8c$var$_react2.default.createElement("input", {
                name: name,
                type: type,
                tabIndex: "-1",
                role: "presentation",
                checked: checked,
                disabled: disabled || readonly,
                onChange: this.handleChange
            }), children));
        }
    });
}
module.exports.default = (0, $10cacbfa4ebd9f8c$var$_uncontrollable2.default)($10cacbfa4ebd9f8c$var$SelectList, {
    value: "onChange"
}, [
    "selectAll",
    "focus"
]);
module.exports = module.exports["default"];

});


parcelRegister("hDgMg", function(module, exports) {

$parcel$export(module.exports, "ParseDate", function () { return $cd6317d58b4c0000$export$b00030cc143c3fde; });


var $5bGlM = parcelRequire("5bGlM");

var $46jCe = parcelRequire("46jCe");

var $egx7S = parcelRequire("egx7S");

var $1ghCV = parcelRequire("1ghCV");

var $5uSSv = parcelRequire("5uSSv");

var $hPhGC = parcelRequire("hPhGC");
const $cd6317d58b4c0000$var$knownDate = new Date(2015, 10, 30);
const $cd6317d58b4c0000$var$knownFormat = ()=>(0, $46jCe.FormatDate)($cd6317d58b4c0000$var$knownDate, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
const $cd6317d58b4c0000$var$knownYearFormat = ()=>(0, $46jCe.FormatDate)($cd6317d58b4c0000$var$knownDate, {
        year: "numeric"
    });
const $cd6317d58b4c0000$var$knownMonthFormat = ()=>(0, $46jCe.FormatDate)($cd6317d58b4c0000$var$knownDate, {
        month: "2-digit"
    });
const $cd6317d58b4c0000$var$knownDayFormat = ()=>(0, $46jCe.FormatDate)($cd6317d58b4c0000$var$knownDate, {
        day: "2-digit"
    });
const $cd6317d58b4c0000$var$knownFormatWithoutNumbers = ()=>$cd6317d58b4c0000$var$knownFormat().replace($cd6317d58b4c0000$var$knownYearFormat(), "#").replace($cd6317d58b4c0000$var$knownMonthFormat(), "#").replace($cd6317d58b4c0000$var$knownDayFormat(), "#");
const $cd6317d58b4c0000$var$defaultSeparator = ()=>$cd6317d58b4c0000$var$knownFormatWithoutNumbers().split("#")[1];
const $cd6317d58b4c0000$var$defaultFormat = ()=>$cd6317d58b4c0000$var$knownFormat().replace($cd6317d58b4c0000$var$knownYearFormat(), "yyyy").replace($cd6317d58b4c0000$var$knownMonthFormat(), "MM").replace($cd6317d58b4c0000$var$knownDayFormat(), "dd");
const $cd6317d58b4c0000$var$supportedSeparators = ()=>{
    const seps = [
        "/",
        ".",
        "-",
        " "
    ];
    if (!seps.includes($cd6317d58b4c0000$var$defaultSeparator())) seps.unshift($cd6317d58b4c0000$var$defaultSeparator());
    return seps;
};
const $cd6317d58b4c0000$var$supportedYears = [
    "yyyy",
    "yy"
];
const $cd6317d58b4c0000$var$supportedMonths = [
    "MM",
    "M",
    "MMM",
    "MMMM"
];
const $cd6317d58b4c0000$var$supportedDays = [
    "dd",
    "d"
];
// all combinations of defaultFormat replacing year, month, day, and separators with supported formats
const $cd6317d58b4c0000$var$supportedFormats = ()=>$cd6317d58b4c0000$var$supportedYears.flatMap((year)=>{
        return $cd6317d58b4c0000$var$supportedMonths.flatMap((month)=>{
            return $cd6317d58b4c0000$var$supportedDays.flatMap((day)=>{
                return $cd6317d58b4c0000$var$supportedSeparators().map((separator)=>{
                    return $cd6317d58b4c0000$var$defaultFormat().replace("yyyy", year).replace("MM", month).replace("dd", day).replaceAll($cd6317d58b4c0000$var$defaultSeparator(), separator);
                });
            });
        });
    });
const $cd6317d58b4c0000$export$b00030cc143c3fde = (valueString)=>{
    const localeString = (0, (/*@__PURE__*/$parcel$interopDefault($5bGlM))).findCountryLocales((0, $hPhGC.constantCase)(((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) || "us"))[0];
    const localeLang = localeString.split("-")[0];
    const localeCountry = localeString.split("-")[1];
    const locale = $1ghCV[localeLang + localeCountry] || $1ghCV[localeLang];
    for (let formatString of $cd6317d58b4c0000$var$supportedFormats()){
        const params = [
            valueString,
            formatString,
            new Date()
        ];
        if (locale) params.push({
            locale: locale
        });
        const date = (0, $egx7S.parse)(...params);
        if (!isNaN(date) && date.getFullYear() > 1900) return date;
    }
    return null;
};

});
parcelRegister("1ghCV", function(module, exports) {
"use strict";

var $3v5DY = parcelRequire("3v5DY");
Object.keys($3v5DY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3v5DY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3v5DY[key];
        }
    });
});

var $b3Pe5 = parcelRequire("b3Pe5");
Object.keys($b3Pe5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b3Pe5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b3Pe5[key];
        }
    });
});

var $egOtd = parcelRequire("egOtd");
Object.keys($egOtd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $egOtd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $egOtd[key];
        }
    });
});

var $lsb5U = parcelRequire("lsb5U");
Object.keys($lsb5U).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lsb5U[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lsb5U[key];
        }
    });
});

var $10AxR = parcelRequire("10AxR");
Object.keys($10AxR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $10AxR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $10AxR[key];
        }
    });
});

var $ei07v = parcelRequire("ei07v");
Object.keys($ei07v).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ei07v[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ei07v[key];
        }
    });
});

var $euGQ2 = parcelRequire("euGQ2");
Object.keys($euGQ2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $euGQ2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $euGQ2[key];
        }
    });
});

var $40FoF = parcelRequire("40FoF");
Object.keys($40FoF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $40FoF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $40FoF[key];
        }
    });
});

var $hQG5x = parcelRequire("hQG5x");
Object.keys($hQG5x).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hQG5x[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hQG5x[key];
        }
    });
});

var $gWrid = parcelRequire("gWrid");
Object.keys($gWrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gWrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gWrid[key];
        }
    });
});

var $4nKni = parcelRequire("4nKni");
Object.keys($4nKni).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4nKni[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4nKni[key];
        }
    });
});

var $iTiqN = parcelRequire("iTiqN");
Object.keys($iTiqN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iTiqN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iTiqN[key];
        }
    });
});

var $8aQky = parcelRequire("8aQky");
Object.keys($8aQky).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8aQky[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8aQky[key];
        }
    });
});

var $9OlUo = parcelRequire("9OlUo");
Object.keys($9OlUo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9OlUo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9OlUo[key];
        }
    });
});

var $gAhpI = parcelRequire("gAhpI");
Object.keys($gAhpI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gAhpI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gAhpI[key];
        }
    });
});

var $bKlVs = parcelRequire("bKlVs");
Object.keys($bKlVs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bKlVs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bKlVs[key];
        }
    });
});

var $i1Rhb = parcelRequire("i1Rhb");
Object.keys($i1Rhb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i1Rhb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i1Rhb[key];
        }
    });
});

var $5iJL4 = parcelRequire("5iJL4");
Object.keys($5iJL4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5iJL4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5iJL4[key];
        }
    });
});

var $hPkgR = parcelRequire("hPkgR");
Object.keys($hPkgR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hPkgR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hPkgR[key];
        }
    });
});

var $8Tqxg = parcelRequire("8Tqxg");
Object.keys($8Tqxg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8Tqxg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8Tqxg[key];
        }
    });
});

var $3nJmE = parcelRequire("3nJmE");
Object.keys($3nJmE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3nJmE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3nJmE[key];
        }
    });
});

var $1lIM8 = parcelRequire("1lIM8");
Object.keys($1lIM8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1lIM8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1lIM8[key];
        }
    });
});

var $C9iCq = parcelRequire("C9iCq");
Object.keys($C9iCq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $C9iCq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $C9iCq[key];
        }
    });
});

var $aJXp8 = parcelRequire("aJXp8");
Object.keys($aJXp8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aJXp8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aJXp8[key];
        }
    });
});

var $dTOfC = parcelRequire("dTOfC");
Object.keys($dTOfC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dTOfC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dTOfC[key];
        }
    });
});

var $2Rv61 = parcelRequire("2Rv61");
Object.keys($2Rv61).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2Rv61[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2Rv61[key];
        }
    });
});

var $b3X9W = parcelRequire("b3X9W");
Object.keys($b3X9W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b3X9W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b3X9W[key];
        }
    });
});

var $dHYEo = parcelRequire("dHYEo");
Object.keys($dHYEo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dHYEo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dHYEo[key];
        }
    });
});

var $9VmyF = parcelRequire("9VmyF");
Object.keys($9VmyF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9VmyF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9VmyF[key];
        }
    });
});

var $lT55e = parcelRequire("lT55e");
Object.keys($lT55e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lT55e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lT55e[key];
        }
    });
});

var $dMzdE = parcelRequire("dMzdE");
Object.keys($dMzdE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dMzdE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dMzdE[key];
        }
    });
});

var $imzMG = parcelRequire("imzMG");
Object.keys($imzMG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $imzMG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $imzMG[key];
        }
    });
});

var $3x3kp = parcelRequire("3x3kp");
Object.keys($3x3kp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3x3kp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3x3kp[key];
        }
    });
});

var $gOQ6e = parcelRequire("gOQ6e");
Object.keys($gOQ6e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gOQ6e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gOQ6e[key];
        }
    });
});

var $2uuW8 = parcelRequire("2uuW8");
Object.keys($2uuW8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2uuW8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2uuW8[key];
        }
    });
});

var $7DDCw = parcelRequire("7DDCw");
Object.keys($7DDCw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7DDCw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7DDCw[key];
        }
    });
});

var $6rz6V = parcelRequire("6rz6V");
Object.keys($6rz6V).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6rz6V[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6rz6V[key];
        }
    });
});

var $gQXHh = parcelRequire("gQXHh");
Object.keys($gQXHh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gQXHh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gQXHh[key];
        }
    });
});

var $ib3ON = parcelRequire("ib3ON");
Object.keys($ib3ON).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ib3ON[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ib3ON[key];
        }
    });
});

var $aJh9D = parcelRequire("aJh9D");
Object.keys($aJh9D).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aJh9D[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aJh9D[key];
        }
    });
});

var $cinY1 = parcelRequire("cinY1");
Object.keys($cinY1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cinY1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cinY1[key];
        }
    });
});

var $8DCVZ = parcelRequire("8DCVZ");
Object.keys($8DCVZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8DCVZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8DCVZ[key];
        }
    });
});

var $6jp7T = parcelRequire("6jp7T");
Object.keys($6jp7T).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6jp7T[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6jp7T[key];
        }
    });
});

var $dYmvp = parcelRequire("dYmvp");
Object.keys($dYmvp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dYmvp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dYmvp[key];
        }
    });
});

var $bvEwX = parcelRequire("bvEwX");
Object.keys($bvEwX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bvEwX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bvEwX[key];
        }
    });
});

var $fiAne = parcelRequire("fiAne");
Object.keys($fiAne).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fiAne[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fiAne[key];
        }
    });
});

var $eCK0b = parcelRequire("eCK0b");
Object.keys($eCK0b).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eCK0b[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eCK0b[key];
        }
    });
});

var $2ptiC = parcelRequire("2ptiC");
Object.keys($2ptiC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2ptiC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ptiC[key];
        }
    });
});

var $eMMV0 = parcelRequire("eMMV0");
Object.keys($eMMV0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eMMV0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eMMV0[key];
        }
    });
});

var $jg1fb = parcelRequire("jg1fb");
Object.keys($jg1fb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jg1fb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jg1fb[key];
        }
    });
});

var $8Nk9Q = parcelRequire("8Nk9Q");
Object.keys($8Nk9Q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8Nk9Q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8Nk9Q[key];
        }
    });
});

var $hONOV = parcelRequire("hONOV");
Object.keys($hONOV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hONOV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hONOV[key];
        }
    });
});

var $d4hCv = parcelRequire("d4hCv");
Object.keys($d4hCv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d4hCv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d4hCv[key];
        }
    });
});

var $7o0Js = parcelRequire("7o0Js");
Object.keys($7o0Js).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7o0Js[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7o0Js[key];
        }
    });
});

var $hNeJq = parcelRequire("hNeJq");
Object.keys($hNeJq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hNeJq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hNeJq[key];
        }
    });
});

var $4VaJp = parcelRequire("4VaJp");
Object.keys($4VaJp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4VaJp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4VaJp[key];
        }
    });
});

var $kfWTt = parcelRequire("kfWTt");
Object.keys($kfWTt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kfWTt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kfWTt[key];
        }
    });
});

var $gUbqL = parcelRequire("gUbqL");
Object.keys($gUbqL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gUbqL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gUbqL[key];
        }
    });
});

var $7AR6Q = parcelRequire("7AR6Q");
Object.keys($7AR6Q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7AR6Q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7AR6Q[key];
        }
    });
});

var $eRkRq = parcelRequire("eRkRq");
Object.keys($eRkRq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eRkRq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eRkRq[key];
        }
    });
});

var $kojIy = parcelRequire("kojIy");
Object.keys($kojIy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kojIy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kojIy[key];
        }
    });
});

var $8STiP = parcelRequire("8STiP");
Object.keys($8STiP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8STiP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8STiP[key];
        }
    });
});

var $h6qyW = parcelRequire("h6qyW");
Object.keys($h6qyW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h6qyW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h6qyW[key];
        }
    });
});

var $l2Dfu = parcelRequire("l2Dfu");
Object.keys($l2Dfu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l2Dfu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l2Dfu[key];
        }
    });
});

var $e5k24 = parcelRequire("e5k24");
Object.keys($e5k24).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e5k24[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e5k24[key];
        }
    });
});

var $aFyK4 = parcelRequire("aFyK4");
Object.keys($aFyK4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aFyK4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aFyK4[key];
        }
    });
});

var $acSzB = parcelRequire("acSzB");
Object.keys($acSzB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $acSzB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $acSzB[key];
        }
    });
});

var $5AchQ = parcelRequire("5AchQ");
Object.keys($5AchQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5AchQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5AchQ[key];
        }
    });
});

var $7pqQx = parcelRequire("7pqQx");
Object.keys($7pqQx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7pqQx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7pqQx[key];
        }
    });
});

var $UQmiN = parcelRequire("UQmiN");
Object.keys($UQmiN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $UQmiN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $UQmiN[key];
        }
    });
});

var $gn5Ir = parcelRequire("gn5Ir");
Object.keys($gn5Ir).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gn5Ir[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gn5Ir[key];
        }
    });
});

var $cHaGg = parcelRequire("cHaGg");
Object.keys($cHaGg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cHaGg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cHaGg[key];
        }
    });
});

var $5hZna = parcelRequire("5hZna");
Object.keys($5hZna).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5hZna[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5hZna[key];
        }
    });
});

var $gr2w7 = parcelRequire("gr2w7");
Object.keys($gr2w7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gr2w7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gr2w7[key];
        }
    });
});

var $jeXbz = parcelRequire("jeXbz");
Object.keys($jeXbz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jeXbz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jeXbz[key];
        }
    });
});

var $kdY07 = parcelRequire("kdY07");
Object.keys($kdY07).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kdY07[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kdY07[key];
        }
    });
});

var $k5Ibj = parcelRequire("k5Ibj");
Object.keys($k5Ibj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k5Ibj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k5Ibj[key];
        }
    });
});

var $5Afma = parcelRequire("5Afma");
Object.keys($5Afma).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Afma[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Afma[key];
        }
    });
});

var $jXMJV = parcelRequire("jXMJV");
Object.keys($jXMJV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jXMJV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jXMJV[key];
        }
    });
});

var $lu951 = parcelRequire("lu951");
Object.keys($lu951).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lu951[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lu951[key];
        }
    });
});

var $4xbyg = parcelRequire("4xbyg");
Object.keys($4xbyg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4xbyg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4xbyg[key];
        }
    });
});

var $btFP9 = parcelRequire("btFP9");
Object.keys($btFP9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $btFP9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $btFP9[key];
        }
    });
});

var $j5iEU = parcelRequire("j5iEU");
Object.keys($j5iEU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j5iEU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j5iEU[key];
        }
    });
});

var $8ZBgL = parcelRequire("8ZBgL");
Object.keys($8ZBgL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8ZBgL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ZBgL[key];
        }
    });
});

var $lWxDa = parcelRequire("lWxDa");
Object.keys($lWxDa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lWxDa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lWxDa[key];
        }
    });
});

var $3wqDe = parcelRequire("3wqDe");
Object.keys($3wqDe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3wqDe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3wqDe[key];
        }
    });
});

var $78uUV = parcelRequire("78uUV");
Object.keys($78uUV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $78uUV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $78uUV[key];
        }
    });
});

var $c70JZ = parcelRequire("c70JZ");
Object.keys($c70JZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c70JZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c70JZ[key];
        }
    });
});

var $d9K5W = parcelRequire("d9K5W");
Object.keys($d9K5W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d9K5W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d9K5W[key];
        }
    });
});

var $1pTle = parcelRequire("1pTle");
Object.keys($1pTle).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1pTle[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1pTle[key];
        }
    });
});

var $abAb5 = parcelRequire("abAb5");
Object.keys($abAb5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $abAb5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $abAb5[key];
        }
    });
});

var $fdEXL = parcelRequire("fdEXL");
Object.keys($fdEXL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fdEXL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fdEXL[key];
        }
    });
});

var $248JA = parcelRequire("248JA");
Object.keys($248JA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $248JA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $248JA[key];
        }
    });
});

var $4aezq = parcelRequire("4aezq");
Object.keys($4aezq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4aezq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4aezq[key];
        }
    });
});

var $10bE8 = parcelRequire("10bE8");
Object.keys($10bE8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $10bE8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $10bE8[key];
        }
    });
});

});
parcelRegister("3v5DY", function(module, exports) {

$parcel$export(module.exports, "af", function () { return $28c8a512ac022e18$export$c9170ad7d4cd7e57; }, function (v) { return $28c8a512ac022e18$export$c9170ad7d4cd7e57 = v; });
var $28c8a512ac022e18$export$c9170ad7d4cd7e57;
"use strict";
$28c8a512ac022e18$export$c9170ad7d4cd7e57 = void 0;

var $iZj9q = parcelRequire("iZj9q");

var $eMCTp = parcelRequire("eMCTp");

var $6we5n = parcelRequire("6we5n");

var $10DYn = parcelRequire("10DYn");

var $DlCNw = parcelRequire("DlCNw");
/**
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw](https://github.com/marnusw)
 */ const $28c8a512ac022e18$var$af = $28c8a512ac022e18$export$c9170ad7d4cd7e57 = {
    code: "af",
    formatDistance: $iZj9q.formatDistance,
    formatLong: $eMCTp.formatLong,
    formatRelative: $6we5n.formatRelative,
    localize: $10DYn.localize,
    match: $DlCNw.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("iZj9q", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $dd2cc7814f25bbb0$export$2c14ff85d6318973; }, function (v) { return $dd2cc7814f25bbb0$export$2c14ff85d6318973 = v; });
var $dd2cc7814f25bbb0$export$2c14ff85d6318973;
"use strict";
$dd2cc7814f25bbb0$export$2c14ff85d6318973 = void 0;
const $dd2cc7814f25bbb0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: "minder as {{count}} sekondes"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekondes"
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: "minder as {{count}} minute"
    },
    xMinutes: {
        one: "'n minuut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} ure"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} ure"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dae"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weke"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weke"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maande"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maande"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer as 1 jaar",
        other: "meer as {{count}} jaar"
    },
    almostXYears: {
        one: "byna 1 jaar",
        other: "byna {{count}} jaar"
    }
};
const $dd2cc7814f25bbb0$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $dd2cc7814f25bbb0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oor " + result;
        else return result + " gelede";
    }
    return result;
};
$dd2cc7814f25bbb0$export$2c14ff85d6318973 = $dd2cc7814f25bbb0$var$formatDistance;

});

parcelRegister("eMCTp", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ac33b7a5dc5b088c$export$cbf60ecb96cbb82f; }, function (v) { return $ac33b7a5dc5b088c$export$cbf60ecb96cbb82f = v; });
var $ac33b7a5dc5b088c$export$cbf60ecb96cbb82f;
"use strict";
$ac33b7a5dc5b088c$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $ac33b7a5dc5b088c$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "yyyy/MM/dd"
};
const $ac33b7a5dc5b088c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $ac33b7a5dc5b088c$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $ac33b7a5dc5b088c$var$formatLong = $ac33b7a5dc5b088c$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $ac33b7a5dc5b088c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $ac33b7a5dc5b088c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $ac33b7a5dc5b088c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6we5n", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $4bf0a85bfe8fa7f1$export$8fbbfd65594f46a0; }, function (v) { return $4bf0a85bfe8fa7f1$export$8fbbfd65594f46a0 = v; });
var $4bf0a85bfe8fa7f1$export$8fbbfd65594f46a0;
"use strict";
$4bf0a85bfe8fa7f1$export$8fbbfd65594f46a0 = void 0;
const $4bf0a85bfe8fa7f1$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $4bf0a85bfe8fa7f1$var$formatRelative = (token, _date, _baseDate, _options)=>$4bf0a85bfe8fa7f1$var$formatRelativeLocale[token];
$4bf0a85bfe8fa7f1$export$8fbbfd65594f46a0 = $4bf0a85bfe8fa7f1$var$formatRelative;

});

parcelRegister("10DYn", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0bc4cc502d01a7ba$export$b3bd0bc58e36cd63; }, function (v) { return $0bc4cc502d01a7ba$export$b3bd0bc58e36cd63 = v; });
var $0bc4cc502d01a7ba$export$b3bd0bc58e36cd63;
"use strict";
$0bc4cc502d01a7ba$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $0bc4cc502d01a7ba$var$eraValues = {
    narrow: [
        "vC",
        "nC"
    ],
    abbreviated: [
        "vC",
        "nC"
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $0bc4cc502d01a7ba$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ste kwartaal",
        "2de kwartaal",
        "3de kwartaal",
        "4de kwartaal"
    ]
};
const $0bc4cc502d01a7ba$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januarie",
        "Februarie",
        "Maart",
        "April",
        "Mei",
        "Junie",
        "Julie",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
const $0bc4cc502d01a7ba$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "W",
        "D",
        "V",
        "S"
    ],
    short: [
        "So",
        "Ma",
        "Di",
        "Wo",
        "Do",
        "Vr",
        "Sa"
    ],
    abbreviated: [
        "Son",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vry",
        "Sat"
    ],
    wide: [
        "Sondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrydag",
        "Saterdag"
    ]
};
const $0bc4cc502d01a7ba$var$dayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    }
};
const $0bc4cc502d01a7ba$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    }
};
const $0bc4cc502d01a7ba$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + "ste";
        default:
            return number + "de";
    }
    return number + "ste";
};
const $0bc4cc502d01a7ba$var$localize = $0bc4cc502d01a7ba$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0bc4cc502d01a7ba$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $0bc4cc502d01a7ba$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $0bc4cc502d01a7ba$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $0bc4cc502d01a7ba$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $0bc4cc502d01a7ba$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $0bc4cc502d01a7ba$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0bc4cc502d01a7ba$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("DlCNw", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $07646adcb4c37057$export$4659b591c19bdf3d; }, function (v) { return $07646adcb4c37057$export$4659b591c19bdf3d = v; });
var $07646adcb4c37057$export$4659b591c19bdf3d;
"use strict";
$07646adcb4c37057$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $07646adcb4c37057$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
const $07646adcb4c37057$var$parseOrdinalNumberPattern = /\d+/i;
const $07646adcb4c37057$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
const $07646adcb4c37057$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $07646adcb4c37057$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
const $07646adcb4c37057$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $07646adcb4c37057$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
const $07646adcb4c37057$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
const $07646adcb4c37057$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
const $07646adcb4c37057$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
const $07646adcb4c37057$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
const $07646adcb4c37057$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
const $07646adcb4c37057$var$match = $07646adcb4c37057$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $07646adcb4c37057$var$matchOrdinalNumberPattern,
        parsePattern: $07646adcb4c37057$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $07646adcb4c37057$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $07646adcb4c37057$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $07646adcb4c37057$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $07646adcb4c37057$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $07646adcb4c37057$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $07646adcb4c37057$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $07646adcb4c37057$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $07646adcb4c37057$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $07646adcb4c37057$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $07646adcb4c37057$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("b3Pe5", function(module, exports) {

$parcel$export(module.exports, "ar", function () { return $80d7b5f6064f261c$export$d24c54395ce0c509; }, function (v) { return $80d7b5f6064f261c$export$d24c54395ce0c509 = v; });
var $80d7b5f6064f261c$export$d24c54395ce0c509;
"use strict";
$80d7b5f6064f261c$export$d24c54395ce0c509 = void 0;

var $gKcud = parcelRequire("gKcud");

var $h78Nv = parcelRequire("h78Nv");

var $8AxN1 = parcelRequire("8AxN1");

var $lT7mE = parcelRequire("lT7mE");

var $2510j = parcelRequire("2510j");
/**
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO](https://github.com/AbdallahAHO)
 * @author Koussay Haj Kacem [@essana3](https://github.com/essana3)
 */ const $80d7b5f6064f261c$var$ar = $80d7b5f6064f261c$export$d24c54395ce0c509 = {
    code: "ar",
    formatDistance: $gKcud.formatDistance,
    formatLong: $h78Nv.formatLong,
    formatRelative: $8AxN1.formatRelative,
    localize: $lT7mE.localize,
    match: $2510j.match,
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("gKcud", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $c30aa0b9c9937f04$export$2c14ff85d6318973; }, function (v) { return $c30aa0b9c9937f04$export$2c14ff85d6318973 = v; });
var $c30aa0b9c9937f04$export$2c14ff85d6318973;
"use strict";
$c30aa0b9c9937f04$export$2c14ff85d6318973 = void 0;
const $c30aa0b9c9937f04$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
const $c30aa0b9c9937f04$var$formatDistance = (token, count, options)=>{
    const usageGroup = $c30aa0b9c9937f04$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$c30aa0b9c9937f04$export$2c14ff85d6318973 = $c30aa0b9c9937f04$var$formatDistance;

});

parcelRegister("h78Nv", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $c759ea1c858cda73$export$cbf60ecb96cbb82f; }, function (v) { return $c759ea1c858cda73$export$cbf60ecb96cbb82f = v; });
var $c759ea1c858cda73$export$cbf60ecb96cbb82f;
"use strict";
$c759ea1c858cda73$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $c759ea1c858cda73$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $c759ea1c858cda73$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $c759ea1c858cda73$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $c759ea1c858cda73$var$formatLong = $c759ea1c858cda73$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $c759ea1c858cda73$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $c759ea1c858cda73$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $c759ea1c858cda73$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("8AxN1", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $640be57672120dd0$export$8fbbfd65594f46a0; }, function (v) { return $640be57672120dd0$export$8fbbfd65594f46a0 = v; });
var $640be57672120dd0$export$8fbbfd65594f46a0;
"use strict";
$640be57672120dd0$export$8fbbfd65594f46a0 = void 0;
const $640be57672120dd0$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: "P"
};
const $640be57672120dd0$var$formatRelative = (token)=>$640be57672120dd0$var$formatRelativeLocale[token];
$640be57672120dd0$export$8fbbfd65594f46a0 = $640be57672120dd0$var$formatRelative;

});

parcelRegister("lT7mE", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $fef4726b87bc2b38$export$b3bd0bc58e36cd63; }, function (v) { return $fef4726b87bc2b38$export$b3bd0bc58e36cd63 = v; });
var $fef4726b87bc2b38$export$b3bd0bc58e36cd63;
"use strict";
$fef4726b87bc2b38$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $fef4726b87bc2b38$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $fef4726b87bc2b38$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $fef4726b87bc2b38$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $fef4726b87bc2b38$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $fef4726b87bc2b38$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $fef4726b87bc2b38$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $fef4726b87bc2b38$var$ordinalNumber = (num)=>String(num);
const $fef4726b87bc2b38$var$localize = $fef4726b87bc2b38$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $fef4726b87bc2b38$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $fef4726b87bc2b38$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $fef4726b87bc2b38$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $fef4726b87bc2b38$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $fef4726b87bc2b38$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $fef4726b87bc2b38$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $fef4726b87bc2b38$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("2510j", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $183cd3c700222482$export$4659b591c19bdf3d; }, function (v) { return $183cd3c700222482$export$4659b591c19bdf3d = v; });
var $183cd3c700222482$export$4659b591c19bdf3d;
"use strict";
$183cd3c700222482$export$4659b591c19bdf3d = void 0;

var $essio = parcelRequire("essio");

var $gZaqQ = parcelRequire("gZaqQ");
const $183cd3c700222482$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $183cd3c700222482$var$parseOrdinalNumberPattern = /\d+/i;
const $183cd3c700222482$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
const $183cd3c700222482$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
const $183cd3c700222482$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
const $183cd3c700222482$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $183cd3c700222482$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $183cd3c700222482$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
const $183cd3c700222482$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $183cd3c700222482$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $183cd3c700222482$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
const $183cd3c700222482$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
const $183cd3c700222482$var$match = $183cd3c700222482$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $183cd3c700222482$var$matchOrdinalNumberPattern,
        parsePattern: $183cd3c700222482$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $183cd3c700222482$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $183cd3c700222482$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $183cd3c700222482$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $183cd3c700222482$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $183cd3c700222482$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $183cd3c700222482$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $183cd3c700222482$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $183cd3c700222482$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $183cd3c700222482$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $183cd3c700222482$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("egOtd", function(module, exports) {

$parcel$export(module.exports, "arDZ", function () { return $a639b5aa2037adb1$export$f30a46e7176f7a; }, function (v) { return $a639b5aa2037adb1$export$f30a46e7176f7a = v; });
var $a639b5aa2037adb1$export$f30a46e7176f7a;
"use strict";
$a639b5aa2037adb1$export$f30a46e7176f7a = void 0;

var $2Bo1T = parcelRequire("2Bo1T");

var $kTxvu = parcelRequire("kTxvu");

var $fiBYd = parcelRequire("fiBYd");

var $lf8U3 = parcelRequire("lf8U3");

var $7M8IM = parcelRequire("7M8IM");
/**
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429](https://github.com/badre429)
 * @author Ahmed ElShahat [@elshahat](https://github.com/elshahat)
 */ const $a639b5aa2037adb1$var$arDZ = $a639b5aa2037adb1$export$f30a46e7176f7a = {
    code: "ar-DZ",
    formatDistance: $2Bo1T.formatDistance,
    formatLong: $kTxvu.formatLong,
    formatRelative: $fiBYd.formatRelative,
    localize: $lf8U3.localize,
    match: $7M8IM.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("2Bo1T", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $1e51ad41017db1eb$export$2c14ff85d6318973; }, function (v) { return $1e51ad41017db1eb$export$2c14ff85d6318973 = v; });
var $1e51ad41017db1eb$export$2c14ff85d6318973;
"use strict";
$1e51ad41017db1eb$export$2c14ff85d6318973 = void 0;
const $1e51ad41017db1eb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $1e51ad41017db1eb$var$formatDistance = (token, count, options)=>{
    options = options || {};
    const usageGroup = $1e51ad41017db1eb$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$1e51ad41017db1eb$export$2c14ff85d6318973 = $1e51ad41017db1eb$var$formatDistance;

});

parcelRegister("kTxvu", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $f362ef73b8c6dd48$export$cbf60ecb96cbb82f; }, function (v) { return $f362ef73b8c6dd48$export$cbf60ecb96cbb82f = v; });
var $f362ef73b8c6dd48$export$cbf60ecb96cbb82f;
"use strict";
$f362ef73b8c6dd48$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $f362ef73b8c6dd48$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $f362ef73b8c6dd48$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $f362ef73b8c6dd48$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $f362ef73b8c6dd48$var$formatLong = $f362ef73b8c6dd48$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $f362ef73b8c6dd48$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $f362ef73b8c6dd48$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $f362ef73b8c6dd48$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fiBYd", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b235fd9353534259$export$8fbbfd65594f46a0; }, function (v) { return $b235fd9353534259$export$8fbbfd65594f46a0 = v; });
var $b235fd9353534259$export$8fbbfd65594f46a0;
"use strict";
$b235fd9353534259$export$8fbbfd65594f46a0 = void 0;
const $b235fd9353534259$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $b235fd9353534259$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $b235fd9353534259$var$formatRelativeLocale[token];
};
$b235fd9353534259$export$8fbbfd65594f46a0 = $b235fd9353534259$var$formatRelative;

});

parcelRegister("lf8U3", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $f771e7a9f0ec18dd$export$b3bd0bc58e36cd63; }, function (v) { return $f771e7a9f0ec18dd$export$b3bd0bc58e36cd63 = v; });
var $f771e7a9f0ec18dd$export$b3bd0bc58e36cd63;
"use strict";
$f771e7a9f0ec18dd$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $f771e7a9f0ec18dd$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $f771e7a9f0ec18dd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $f771e7a9f0ec18dd$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $f771e7a9f0ec18dd$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $f771e7a9f0ec18dd$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $f771e7a9f0ec18dd$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $f771e7a9f0ec18dd$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $f771e7a9f0ec18dd$var$localize = $f771e7a9f0ec18dd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f771e7a9f0ec18dd$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $f771e7a9f0ec18dd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $f771e7a9f0ec18dd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $f771e7a9f0ec18dd$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $f771e7a9f0ec18dd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $f771e7a9f0ec18dd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f771e7a9f0ec18dd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7M8IM", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5a93c7efaebbeec9$export$4659b591c19bdf3d; }, function (v) { return $5a93c7efaebbeec9$export$4659b591c19bdf3d = v; });
var $5a93c7efaebbeec9$export$4659b591c19bdf3d;
"use strict";
$5a93c7efaebbeec9$export$4659b591c19bdf3d = void 0;

var $essio = parcelRequire("essio");

var $gZaqQ = parcelRequire("gZaqQ");
const $5a93c7efaebbeec9$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $5a93c7efaebbeec9$var$parseOrdinalNumberPattern = /\d+/i;
const $5a93c7efaebbeec9$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $5a93c7efaebbeec9$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $5a93c7efaebbeec9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $5a93c7efaebbeec9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $5a93c7efaebbeec9$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
const $5a93c7efaebbeec9$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
const $5a93c7efaebbeec9$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $5a93c7efaebbeec9$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $5a93c7efaebbeec9$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $5a93c7efaebbeec9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $5a93c7efaebbeec9$var$match = $5a93c7efaebbeec9$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $5a93c7efaebbeec9$var$matchOrdinalNumberPattern,
        parsePattern: $5a93c7efaebbeec9$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5a93c7efaebbeec9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a93c7efaebbeec9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5a93c7efaebbeec9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a93c7efaebbeec9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>Number(index) + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5a93c7efaebbeec9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a93c7efaebbeec9$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5a93c7efaebbeec9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a93c7efaebbeec9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5a93c7efaebbeec9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5a93c7efaebbeec9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("lsb5U", function(module, exports) {

$parcel$export(module.exports, "arEG", function () { return $f9e4d1971f1d4222$export$121716977511c975; }, function (v) { return $f9e4d1971f1d4222$export$121716977511c975 = v; });
var $f9e4d1971f1d4222$export$121716977511c975;
"use strict";
$f9e4d1971f1d4222$export$121716977511c975 = void 0;

var $1sxCn = parcelRequire("1sxCn");

var $5UONl = parcelRequire("5UONl");

var $kube4 = parcelRequire("kube4");

var $8uv2A = parcelRequire("8uv2A");

var $8BtKG = parcelRequire("8BtKG");
/**
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13](https://github.com/AbdAllahAbdElFattah13)
 */ const $f9e4d1971f1d4222$var$arEG = $f9e4d1971f1d4222$export$121716977511c975 = {
    code: "ar-EG",
    formatDistance: $1sxCn.formatDistance,
    formatLong: $5UONl.formatLong,
    formatRelative: $kube4.formatRelative,
    localize: $8uv2A.localize,
    match: $8BtKG.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("1sxCn", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $11027bcb9f1abc00$export$2c14ff85d6318973; }, function (v) { return $11027bcb9f1abc00$export$2c14ff85d6318973 = v; });
var $11027bcb9f1abc00$export$2c14ff85d6318973;
"use strict";
$11027bcb9f1abc00$export$2c14ff85d6318973 = void 0;
const $11027bcb9f1abc00$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
const $11027bcb9f1abc00$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $11027bcb9f1abc00$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return `\u{641}\u{64A} \u{62E}\u{644}\u{627}\u{644} ${result}`;
        else return `\u{645}\u{646}\u{630} ${result}`;
    }
    return result;
};
$11027bcb9f1abc00$export$2c14ff85d6318973 = $11027bcb9f1abc00$var$formatDistance;

});

parcelRegister("5UONl", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $44e995800fa7ee72$export$cbf60ecb96cbb82f; }, function (v) { return $44e995800fa7ee72$export$cbf60ecb96cbb82f = v; });
var $44e995800fa7ee72$export$cbf60ecb96cbb82f;
"use strict";
$44e995800fa7ee72$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $44e995800fa7ee72$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "dd/MMM/y",
    short: "d/MM/y"
};
const $44e995800fa7ee72$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $44e995800fa7ee72$var$dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $44e995800fa7ee72$var$formatLong = $44e995800fa7ee72$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $44e995800fa7ee72$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $44e995800fa7ee72$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $44e995800fa7ee72$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("kube4", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ee9f5133e3d573d3$export$8fbbfd65594f46a0; }, function (v) { return $ee9f5133e3d573d3$export$8fbbfd65594f46a0 = v; });
var $ee9f5133e3d573d3$export$8fbbfd65594f46a0;
"use strict";
$ee9f5133e3d573d3$export$8fbbfd65594f46a0 = void 0;
const $ee9f5133e3d573d3$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: "P"
};
const $ee9f5133e3d573d3$var$formatRelative = (token, _date, _baseDate, _options)=>$ee9f5133e3d573d3$var$formatRelativeLocale[token];
$ee9f5133e3d573d3$export$8fbbfd65594f46a0 = $ee9f5133e3d573d3$var$formatRelative;

});

parcelRegister("8uv2A", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $62e93418710818c8$export$b3bd0bc58e36cd63; }, function (v) { return $62e93418710818c8$export$b3bd0bc58e36cd63 = v; });
var $62e93418710818c8$export$b3bd0bc58e36cd63;
"use strict";
$62e93418710818c8$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $62e93418710818c8$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $62e93418710818c8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $62e93418710818c8$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $62e93418710818c8$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $62e93418710818c8$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $62e93418710818c8$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $62e93418710818c8$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $62e93418710818c8$var$localize = $62e93418710818c8$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $62e93418710818c8$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $62e93418710818c8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $62e93418710818c8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $62e93418710818c8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $62e93418710818c8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $62e93418710818c8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $62e93418710818c8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("8BtKG", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $6438db9140f35440$export$4659b591c19bdf3d; }, function (v) { return $6438db9140f35440$export$4659b591c19bdf3d = v; });
var $6438db9140f35440$export$4659b591c19bdf3d;
"use strict";
$6438db9140f35440$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $6438db9140f35440$var$matchOrdinalNumberPattern = /^(\d+)/;
const $6438db9140f35440$var$parseOrdinalNumberPattern = /\d+/i;
const $6438db9140f35440$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
const $6438db9140f35440$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
const $6438db9140f35440$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
const $6438db9140f35440$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
const $6438db9140f35440$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $6438db9140f35440$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
const $6438db9140f35440$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
const $6438db9140f35440$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
const $6438db9140f35440$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
const $6438db9140f35440$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
const $6438db9140f35440$var$match = $6438db9140f35440$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $6438db9140f35440$var$matchOrdinalNumberPattern,
        parsePattern: $6438db9140f35440$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6438db9140f35440$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6438db9140f35440$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6438db9140f35440$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6438db9140f35440$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6438db9140f35440$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6438db9140f35440$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6438db9140f35440$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6438db9140f35440$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6438db9140f35440$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6438db9140f35440$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("10AxR", function(module, exports) {

$parcel$export(module.exports, "arMA", function () { return $0bc2239eef206fa4$export$6cd16787de86607; }, function (v) { return $0bc2239eef206fa4$export$6cd16787de86607 = v; });
var $0bc2239eef206fa4$export$6cd16787de86607;
"use strict";
$0bc2239eef206fa4$export$6cd16787de86607 = void 0;

var $2gZ5h = parcelRequire("2gZ5h");

var $hqBJi = parcelRequire("hqBJi");

var $1XTWC = parcelRequire("1XTWC");

var $juuTV = parcelRequire("juuTV");

var $7nmvP = parcelRequire("7nmvP");
/**
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf](https://github.com/rramiachraf)
 */ const $0bc2239eef206fa4$var$arMA = $0bc2239eef206fa4$export$6cd16787de86607 = {
    code: "ar-MA",
    formatDistance: $2gZ5h.formatDistance,
    formatLong: $hqBJi.formatLong,
    formatRelative: $1XTWC.formatRelative,
    localize: $juuTV.localize,
    match: $7nmvP.match,
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("2gZ5h", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $1a7c7570d78706d4$export$2c14ff85d6318973; }, function (v) { return $1a7c7570d78706d4$export$2c14ff85d6318973 = v; });
var $1a7c7570d78706d4$export$2c14ff85d6318973;
"use strict";
$1a7c7570d78706d4$export$2c14ff85d6318973 = void 0;
const $1a7c7570d78706d4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $1a7c7570d78706d4$var$formatDistance = (token, count, options)=>{
    options = options || {};
    const usageGroup = $1a7c7570d78706d4$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$1a7c7570d78706d4$export$2c14ff85d6318973 = $1a7c7570d78706d4$var$formatDistance;

});

parcelRegister("hqBJi", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $cb0221b54ebb0ca8$export$cbf60ecb96cbb82f; }, function (v) { return $cb0221b54ebb0ca8$export$cbf60ecb96cbb82f = v; });
var $cb0221b54ebb0ca8$export$cbf60ecb96cbb82f;
"use strict";
$cb0221b54ebb0ca8$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $cb0221b54ebb0ca8$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $cb0221b54ebb0ca8$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $cb0221b54ebb0ca8$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $cb0221b54ebb0ca8$var$formatLong = $cb0221b54ebb0ca8$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $cb0221b54ebb0ca8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $cb0221b54ebb0ca8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $cb0221b54ebb0ca8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("1XTWC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $16e6b2869a75ecbf$export$8fbbfd65594f46a0; }, function (v) { return $16e6b2869a75ecbf$export$8fbbfd65594f46a0 = v; });
var $16e6b2869a75ecbf$export$8fbbfd65594f46a0;
"use strict";
$16e6b2869a75ecbf$export$8fbbfd65594f46a0 = void 0;
const $16e6b2869a75ecbf$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $16e6b2869a75ecbf$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $16e6b2869a75ecbf$var$formatRelativeLocale[token];
};
$16e6b2869a75ecbf$export$8fbbfd65594f46a0 = $16e6b2869a75ecbf$var$formatRelative;

});

parcelRegister("juuTV", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $e308c9f99159403f$export$b3bd0bc58e36cd63; }, function (v) { return $e308c9f99159403f$export$b3bd0bc58e36cd63 = v; });
var $e308c9f99159403f$export$b3bd0bc58e36cd63;
"use strict";
$e308c9f99159403f$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $e308c9f99159403f$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $e308c9f99159403f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $e308c9f99159403f$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
const $e308c9f99159403f$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $e308c9f99159403f$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $e308c9f99159403f$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $e308c9f99159403f$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $e308c9f99159403f$var$localize = $e308c9f99159403f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e308c9f99159403f$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $e308c9f99159403f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $e308c9f99159403f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $e308c9f99159403f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $e308c9f99159403f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $e308c9f99159403f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e308c9f99159403f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7nmvP", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $55ec24e32ced565e$export$4659b591c19bdf3d; }, function (v) { return $55ec24e32ced565e$export$4659b591c19bdf3d = v; });
var $55ec24e32ced565e$export$4659b591c19bdf3d;
"use strict";
$55ec24e32ced565e$export$4659b591c19bdf3d = void 0;

var $essio = parcelRequire("essio");

var $gZaqQ = parcelRequire("gZaqQ");
const $55ec24e32ced565e$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $55ec24e32ced565e$var$parseOrdinalNumberPattern = /\d+/i;
const $55ec24e32ced565e$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $55ec24e32ced565e$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $55ec24e32ced565e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $55ec24e32ced565e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $55ec24e32ced565e$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
const $55ec24e32ced565e$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
const $55ec24e32ced565e$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $55ec24e32ced565e$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $55ec24e32ced565e$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $55ec24e32ced565e$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $55ec24e32ced565e$var$match = $55ec24e32ced565e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $55ec24e32ced565e$var$matchOrdinalNumberPattern,
        parsePattern: $55ec24e32ced565e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55ec24e32ced565e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55ec24e32ced565e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55ec24e32ced565e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55ec24e32ced565e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>Number(index) + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55ec24e32ced565e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55ec24e32ced565e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55ec24e32ced565e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55ec24e32ced565e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55ec24e32ced565e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $55ec24e32ced565e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("ei07v", function(module, exports) {

$parcel$export(module.exports, "arSA", function () { return $a672d6f5b032a211$export$f6f6c9668e179f08; }, function (v) { return $a672d6f5b032a211$export$f6f6c9668e179f08 = v; });
var $a672d6f5b032a211$export$f6f6c9668e179f08;
"use strict";
$a672d6f5b032a211$export$f6f6c9668e179f08 = void 0;

var $4dkzM = parcelRequire("4dkzM");

var $giyiX = parcelRequire("giyiX");

var $61TSd = parcelRequire("61TSd");

var $75Z3r = parcelRequire("75Z3r");

var $huaV4 = parcelRequire("huaV4");
/**
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani](https://github.com/dalwadani)
 */ const $a672d6f5b032a211$var$arSA = $a672d6f5b032a211$export$f6f6c9668e179f08 = {
    code: "ar-SA",
    formatDistance: $4dkzM.formatDistance,
    formatLong: $giyiX.formatLong,
    formatRelative: $61TSd.formatRelative,
    localize: $75Z3r.localize,
    match: $huaV4.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("4dkzM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $311856514fdc6d32$export$2c14ff85d6318973; }, function (v) { return $311856514fdc6d32$export$2c14ff85d6318973 = v; });
var $311856514fdc6d32$export$2c14ff85d6318973;
"use strict";
$311856514fdc6d32$export$2c14ff85d6318973 = void 0;
const $311856514fdc6d32$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $311856514fdc6d32$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $311856514fdc6d32$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$311856514fdc6d32$export$2c14ff85d6318973 = $311856514fdc6d32$var$formatDistance;

});

parcelRegister("giyiX", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $bdd8f001d7fe646c$export$cbf60ecb96cbb82f; }, function (v) { return $bdd8f001d7fe646c$export$cbf60ecb96cbb82f = v; });
var $bdd8f001d7fe646c$export$cbf60ecb96cbb82f;
"use strict";
$bdd8f001d7fe646c$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $bdd8f001d7fe646c$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $bdd8f001d7fe646c$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $bdd8f001d7fe646c$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $bdd8f001d7fe646c$var$formatLong = $bdd8f001d7fe646c$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $bdd8f001d7fe646c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $bdd8f001d7fe646c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $bdd8f001d7fe646c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("61TSd", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $463e2d5f7d41f33a$export$8fbbfd65594f46a0; }, function (v) { return $463e2d5f7d41f33a$export$8fbbfd65594f46a0 = v; });
var $463e2d5f7d41f33a$export$8fbbfd65594f46a0;
"use strict";
$463e2d5f7d41f33a$export$8fbbfd65594f46a0 = void 0;
const $463e2d5f7d41f33a$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $463e2d5f7d41f33a$var$formatRelative = (token, _date, _baseDate, _options)=>$463e2d5f7d41f33a$var$formatRelativeLocale[token];
$463e2d5f7d41f33a$export$8fbbfd65594f46a0 = $463e2d5f7d41f33a$var$formatRelative;

});

parcelRegister("75Z3r", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $52a85c2c3ffb0878$export$b3bd0bc58e36cd63; }, function (v) { return $52a85c2c3ffb0878$export$b3bd0bc58e36cd63 = v; });
var $52a85c2c3ffb0878$export$b3bd0bc58e36cd63;
"use strict";
$52a85c2c3ffb0878$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $52a85c2c3ffb0878$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $52a85c2c3ffb0878$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $52a85c2c3ffb0878$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $52a85c2c3ffb0878$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $52a85c2c3ffb0878$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $52a85c2c3ffb0878$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $52a85c2c3ffb0878$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $52a85c2c3ffb0878$var$localize = $52a85c2c3ffb0878$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $52a85c2c3ffb0878$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $52a85c2c3ffb0878$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $52a85c2c3ffb0878$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $52a85c2c3ffb0878$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $52a85c2c3ffb0878$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $52a85c2c3ffb0878$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $52a85c2c3ffb0878$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("huaV4", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $cbadb5619589f537$export$4659b591c19bdf3d; }, function (v) { return $cbadb5619589f537$export$4659b591c19bdf3d = v; });
var $cbadb5619589f537$export$4659b591c19bdf3d;
"use strict";
$cbadb5619589f537$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $cbadb5619589f537$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $cbadb5619589f537$var$parseOrdinalNumberPattern = /\d+/i;
const $cbadb5619589f537$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $cbadb5619589f537$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $cbadb5619589f537$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $cbadb5619589f537$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $cbadb5619589f537$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
const $cbadb5619589f537$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
const $cbadb5619589f537$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $cbadb5619589f537$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $cbadb5619589f537$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $cbadb5619589f537$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $cbadb5619589f537$var$match = $cbadb5619589f537$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $cbadb5619589f537$var$matchOrdinalNumberPattern,
        parsePattern: $cbadb5619589f537$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cbadb5619589f537$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cbadb5619589f537$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cbadb5619589f537$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cbadb5619589f537$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cbadb5619589f537$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cbadb5619589f537$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cbadb5619589f537$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cbadb5619589f537$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cbadb5619589f537$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cbadb5619589f537$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("euGQ2", function(module, exports) {

$parcel$export(module.exports, "arTN", function () { return $a8d518d8920bdb2d$export$79b362f080eb24d6; }, function (v) { return $a8d518d8920bdb2d$export$79b362f080eb24d6 = v; });
var $a8d518d8920bdb2d$export$79b362f080eb24d6;
"use strict";
$a8d518d8920bdb2d$export$79b362f080eb24d6 = void 0;

var $9ThbM = parcelRequire("9ThbM");

var $kWRmy = parcelRequire("kWRmy");

var $6uJqD = parcelRequire("6uJqD");

var $49mrE = parcelRequire("49mrE");

var $6OE2g = parcelRequire("6OE2g");
/**
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3](https://github.com/essana3)
 */ const $a8d518d8920bdb2d$var$arTN = $a8d518d8920bdb2d$export$79b362f080eb24d6 = {
    code: "ar-TN",
    formatDistance: $9ThbM.formatDistance,
    formatLong: $kWRmy.formatLong,
    formatRelative: $6uJqD.formatRelative,
    localize: $49mrE.localize,
    match: $6OE2g.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("9ThbM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $73369579cdf0af03$export$2c14ff85d6318973; }, function (v) { return $73369579cdf0af03$export$2c14ff85d6318973 = v; });
var $73369579cdf0af03$export$2c14ff85d6318973;
"use strict";
$73369579cdf0af03$export$2c14ff85d6318973 = void 0;
const $73369579cdf0af03$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
const $73369579cdf0af03$var$formatDistance = (token, count, options)=>{
    const usageGroup = $73369579cdf0af03$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
$73369579cdf0af03$export$2c14ff85d6318973 = $73369579cdf0af03$var$formatDistance;

});

parcelRegister("kWRmy", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $f4029e295594cf93$export$cbf60ecb96cbb82f; }, function (v) { return $f4029e295594cf93$export$cbf60ecb96cbb82f = v; });
var $f4029e295594cf93$export$cbf60ecb96cbb82f;
"use strict";
$f4029e295594cf93$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $f4029e295594cf93$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $f4029e295594cf93$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $f4029e295594cf93$var$dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $f4029e295594cf93$var$formatLong = $f4029e295594cf93$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $f4029e295594cf93$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $f4029e295594cf93$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $f4029e295594cf93$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6uJqD", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $4ba8c898dcccd13a$export$8fbbfd65594f46a0; }, function (v) { return $4ba8c898dcccd13a$export$8fbbfd65594f46a0 = v; });
var $4ba8c898dcccd13a$export$8fbbfd65594f46a0;
"use strict";
$4ba8c898dcccd13a$export$8fbbfd65594f46a0 = void 0;
const $4ba8c898dcccd13a$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: "P"
};
const $4ba8c898dcccd13a$var$formatRelative = (token)=>$4ba8c898dcccd13a$var$formatRelativeLocale[token];
$4ba8c898dcccd13a$export$8fbbfd65594f46a0 = $4ba8c898dcccd13a$var$formatRelative;

});

parcelRegister("49mrE", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $305969c8e53c0062$export$b3bd0bc58e36cd63; }, function (v) { return $305969c8e53c0062$export$b3bd0bc58e36cd63 = v; });
var $305969c8e53c0062$export$b3bd0bc58e36cd63;
"use strict";
$305969c8e53c0062$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $305969c8e53c0062$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $305969c8e53c0062$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $305969c8e53c0062$var$monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $305969c8e53c0062$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $305969c8e53c0062$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $305969c8e53c0062$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $305969c8e53c0062$var$ordinalNumber = (num)=>String(num);
const $305969c8e53c0062$var$localize = $305969c8e53c0062$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $305969c8e53c0062$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $305969c8e53c0062$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $305969c8e53c0062$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $305969c8e53c0062$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $305969c8e53c0062$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $305969c8e53c0062$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $305969c8e53c0062$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("6OE2g", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $4f6677d032da5ff4$export$4659b591c19bdf3d; }, function (v) { return $4f6677d032da5ff4$export$4659b591c19bdf3d = v; });
var $4f6677d032da5ff4$export$4659b591c19bdf3d;
"use strict";
$4f6677d032da5ff4$export$4659b591c19bdf3d = void 0;

var $essio = parcelRequire("essio");

var $gZaqQ = parcelRequire("gZaqQ");
const $4f6677d032da5ff4$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $4f6677d032da5ff4$var$parseOrdinalNumberPattern = /\d+/i;
const $4f6677d032da5ff4$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
const $4f6677d032da5ff4$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
const $4f6677d032da5ff4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
const $4f6677d032da5ff4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $4f6677d032da5ff4$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $4f6677d032da5ff4$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
const $4f6677d032da5ff4$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $4f6677d032da5ff4$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $4f6677d032da5ff4$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
const $4f6677d032da5ff4$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
const $4f6677d032da5ff4$var$match = $4f6677d032da5ff4$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $4f6677d032da5ff4$var$matchOrdinalNumberPattern,
        parsePattern: $4f6677d032da5ff4$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f6677d032da5ff4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f6677d032da5ff4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f6677d032da5ff4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f6677d032da5ff4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f6677d032da5ff4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f6677d032da5ff4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f6677d032da5ff4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f6677d032da5ff4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f6677d032da5ff4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4f6677d032da5ff4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("40FoF", function(module, exports) {

$parcel$export(module.exports, "az", function () { return $2eb7461370c9a09b$export$3d12bd131bb975d1; }, function (v) { return $2eb7461370c9a09b$export$3d12bd131bb975d1 = v; });
var $2eb7461370c9a09b$export$3d12bd131bb975d1;
"use strict";
$2eb7461370c9a09b$export$3d12bd131bb975d1 = void 0;

var $03OZ1 = parcelRequire("03OZ1");

var $ad3wh = parcelRequire("ad3wh");

var $3hIGl = parcelRequire("3hIGl");

var $T7nfJ = parcelRequire("T7nfJ");

var $3EkxR = parcelRequire("3EkxR");
/**
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ const $2eb7461370c9a09b$var$az = $2eb7461370c9a09b$export$3d12bd131bb975d1 = {
    code: "az",
    formatDistance: $03OZ1.formatDistance,
    formatLong: $ad3wh.formatLong,
    formatRelative: $3hIGl.formatRelative,
    localize: $T7nfJ.localize,
    match: $3EkxR.match,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("03OZ1", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $00b7d42804764d2c$export$2c14ff85d6318973; }, function (v) { return $00b7d42804764d2c$export$2c14ff85d6318973 = v; });
var $00b7d42804764d2c$export$2c14ff85d6318973;
"use strict";
$00b7d42804764d2c$export$2c14ff85d6318973 = void 0;
const $00b7d42804764d2c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: "1 il",
        other: "{{count}} il"
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
const $00b7d42804764d2c$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $00b7d42804764d2c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
$00b7d42804764d2c$export$2c14ff85d6318973 = $00b7d42804764d2c$var$formatDistance;

});

parcelRegister("ad3wh", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $76edd93a5eef00a9$export$cbf60ecb96cbb82f; }, function (v) { return $76edd93a5eef00a9$export$cbf60ecb96cbb82f = v; });
var $76edd93a5eef00a9$export$cbf60ecb96cbb82f;
"use strict";
$76edd93a5eef00a9$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $76edd93a5eef00a9$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: "dd.MM.yyyy"
};
const $76edd93a5eef00a9$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $76edd93a5eef00a9$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $76edd93a5eef00a9$var$formatLong = $76edd93a5eef00a9$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $76edd93a5eef00a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $76edd93a5eef00a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $76edd93a5eef00a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("3hIGl", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $26459e8a31c44567$export$8fbbfd65594f46a0; }, function (v) { return $26459e8a31c44567$export$8fbbfd65594f46a0 = v; });
var $26459e8a31c44567$export$8fbbfd65594f46a0;
"use strict";
$26459e8a31c44567$export$8fbbfd65594f46a0 = void 0;
const $26459e8a31c44567$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: "P"
};
const $26459e8a31c44567$var$formatRelative = (token, _date, _baseDate, _options)=>$26459e8a31c44567$var$formatRelativeLocale[token];
$26459e8a31c44567$export$8fbbfd65594f46a0 = $26459e8a31c44567$var$formatRelative;

});

parcelRegister("T7nfJ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0a5adb802d6cadd5$export$b3bd0bc58e36cd63; }, function (v) { return $0a5adb802d6cadd5$export$b3bd0bc58e36cd63 = v; });
var $0a5adb802d6cadd5$export$b3bd0bc58e36cd63;
"use strict";
$0a5adb802d6cadd5$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $0a5adb802d6cadd5$var$eraValues = {
    narrow: [
        "e.\u0259",
        "b.e"
    ],
    abbreviated: [
        "e.\u0259",
        "b.e"
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        "bizim era"
    ]
};
const $0a5adb802d6cadd5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ci kvartal",
        "2ci kvartal",
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
const $0a5adb802d6cadd5$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "\u0130",
        "\u0130",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "\u0130yun",
        "\u0130yul",
        "Avq",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "\u0130yun",
        "\u0130yul",
        "Avqust",
        "Sentyabr",
        "Oktyabr",
        "Noyabr",
        "Dekabr"
    ]
};
const $0a5adb802d6cadd5$var$dayValues = {
    narrow: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "\u015E."
    ],
    short: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "\u015E."
    ],
    abbreviated: [
        "Baz",
        "Baz.e",
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        "Bazar",
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
const $0a5adb802d6cadd5$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
const $0a5adb802d6cadd5$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
const $0a5adb802d6cadd5$var$suffixes = {
    1: "-inci",
    5: "-inci",
    8: "-inci",
    70: "-inci",
    80: "-inci",
    2: "-nci",
    7: "-nci",
    20: "-nci",
    50: "-nci",
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: "-uncu",
    10: "-uncu",
    30: "-uncu",
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
const $0a5adb802d6cadd5$var$getSuffix = (number)=>{
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    const a = number % 10;
    const b = number % 100 - a;
    const c = number >= 100 ? 100 : null;
    if ($0a5adb802d6cadd5$var$suffixes[a]) return $0a5adb802d6cadd5$var$suffixes[a];
    else if ($0a5adb802d6cadd5$var$suffixes[b]) return $0a5adb802d6cadd5$var$suffixes[b];
    else if (c !== null) return $0a5adb802d6cadd5$var$suffixes[c];
    return "";
};
const $0a5adb802d6cadd5$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const suffix = $0a5adb802d6cadd5$var$getSuffix(number);
    return number + suffix;
};
const $0a5adb802d6cadd5$var$localize = $0a5adb802d6cadd5$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0a5adb802d6cadd5$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $0a5adb802d6cadd5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $0a5adb802d6cadd5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $0a5adb802d6cadd5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $0a5adb802d6cadd5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $0a5adb802d6cadd5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0a5adb802d6cadd5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("3EkxR", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $2a850b5ad5f97bc7$export$4659b591c19bdf3d; }, function (v) { return $2a850b5ad5f97bc7$export$4659b591c19bdf3d = v; });
var $2a850b5ad5f97bc7$export$4659b591c19bdf3d;
"use strict";
$2a850b5ad5f97bc7$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $2a850b5ad5f97bc7$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
const $2a850b5ad5f97bc7$var$parseOrdinalNumberPattern = /\d+/i;
const $2a850b5ad5f97bc7$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
const $2a850b5ad5f97bc7$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
const $2a850b5ad5f97bc7$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
const $2a850b5ad5f97bc7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2a850b5ad5f97bc7$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
const $2a850b5ad5f97bc7$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
const $2a850b5ad5f97bc7$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
const $2a850b5ad5f97bc7$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
const $2a850b5ad5f97bc7$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
const $2a850b5ad5f97bc7$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
const $2a850b5ad5f97bc7$var$match = $2a850b5ad5f97bc7$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $2a850b5ad5f97bc7$var$matchOrdinalNumberPattern,
        parsePattern: $2a850b5ad5f97bc7$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2a850b5ad5f97bc7$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2a850b5ad5f97bc7$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2a850b5ad5f97bc7$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2a850b5ad5f97bc7$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2a850b5ad5f97bc7$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2a850b5ad5f97bc7$var$parseMonthPatterns,
        defaultParseWidth: "narrow"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2a850b5ad5f97bc7$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2a850b5ad5f97bc7$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2a850b5ad5f97bc7$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2a850b5ad5f97bc7$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("hQG5x", function(module, exports) {

$parcel$export(module.exports, "be", function () { return $cfe7f0dffdff692e$export$51b138e5a065c2bb; }, function (v) { return $cfe7f0dffdff692e$export$51b138e5a065c2bb = v; });
var $cfe7f0dffdff692e$export$51b138e5a065c2bb;
"use strict";
$cfe7f0dffdff692e$export$51b138e5a065c2bb = void 0;

var $8BBvh = parcelRequire("8BBvh");

var $lTELg = parcelRequire("lTELg");

var $enfEO = parcelRequire("enfEO");

var $8s4Ql = parcelRequire("8s4Ql");

var $6CHoq = parcelRequire("6CHoq");
/**
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik](https://github.com/alyrik)
 * @author Martin Wind [@arvigeus](https://github.com/mawi12345)
 */ const $cfe7f0dffdff692e$var$be = $cfe7f0dffdff692e$export$51b138e5a065c2bb = {
    code: "be",
    formatDistance: $8BBvh.formatDistance,
    formatLong: $lTELg.formatLong,
    formatRelative: $enfEO.formatRelative,
    localize: $8s4Ql.localize,
    match: $6CHoq.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("8BBvh", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $019dead1fed0f21d$export$2c14ff85d6318973; }, function (v) { return $019dead1fed0f21d$export$2c14ff85d6318973 = v; });
var $019dead1fed0f21d$export$2c14ff85d6318973;
"use strict";
$019dead1fed0f21d$export$2c14ff85d6318973 = void 0;
function $019dead1fed0f21d$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $019dead1fed0f21d$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $019dead1fed0f21d$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $019dead1fed0f21d$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $019dead1fed0f21d$var$declension(scheme.past, count);
                else return $019dead1fed0f21d$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $019dead1fed0f21d$var$declension(scheme.regular, count);
    };
}
const $019dead1fed0f21d$var$halfAMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
const $019dead1fed0f21d$var$formatDistanceLocale = {
    lessThanXSeconds: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $019dead1fed0f21d$var$halfAMinute,
    lessThanXMinutes: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u0456",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    xWeeks: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    aboutXMonths: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $019dead1fed0f21d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
const $019dead1fed0f21d$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $019dead1fed0f21d$var$formatDistanceLocale[token](count, options);
};
$019dead1fed0f21d$export$2c14ff85d6318973 = $019dead1fed0f21d$var$formatDistance;

});

parcelRegister("lTELg", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ff0e5a5b5aaa5234$export$cbf60ecb96cbb82f; }, function (v) { return $ff0e5a5b5aaa5234$export$cbf60ecb96cbb82f = v; });
var $ff0e5a5b5aaa5234$export$cbf60ecb96cbb82f;
"use strict";
$ff0e5a5b5aaa5234$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $ff0e5a5b5aaa5234$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $ff0e5a5b5aaa5234$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $ff0e5a5b5aaa5234$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $ff0e5a5b5aaa5234$var$formatLong = $ff0e5a5b5aaa5234$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $ff0e5a5b5aaa5234$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $ff0e5a5b5aaa5234$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $ff0e5a5b5aaa5234$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("enfEO", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a76f5be651a7eeaa$export$8fbbfd65594f46a0; }, function (v) { return $a76f5be651a7eeaa$export$8fbbfd65594f46a0 = v; });
var $a76f5be651a7eeaa$export$8fbbfd65594f46a0;
"use strict";
$a76f5be651a7eeaa$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");

var $2ZADR = parcelRequire("2ZADR");
const $a76f5be651a7eeaa$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $a76f5be651a7eeaa$var$lastWeek(day) {
    const weekday = $a76f5be651a7eeaa$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $a76f5be651a7eeaa$var$thisWeek(day) {
    const weekday = $a76f5be651a7eeaa$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $a76f5be651a7eeaa$var$nextWeek(day) {
    const weekday = $a76f5be651a7eeaa$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
const $a76f5be651a7eeaa$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $2ZADR.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $a76f5be651a7eeaa$var$thisWeek(day);
    else return $a76f5be651a7eeaa$var$lastWeek(day);
};
const $a76f5be651a7eeaa$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $2ZADR.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $a76f5be651a7eeaa$var$thisWeek(day);
    else return $a76f5be651a7eeaa$var$nextWeek(day);
};
const $a76f5be651a7eeaa$var$formatRelativeLocale = {
    lastWeek: $a76f5be651a7eeaa$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $a76f5be651a7eeaa$var$nextWeekFormat,
    other: "P"
};
const $a76f5be651a7eeaa$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $a76f5be651a7eeaa$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$a76f5be651a7eeaa$export$8fbbfd65594f46a0 = $a76f5be651a7eeaa$var$formatRelative;

});

parcelRegister("8s4Ql", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6274b2029d7659ea$export$b3bd0bc58e36cd63; }, function (v) { return $6274b2029d7659ea$export$b3bd0bc58e36cd63 = v; });
var $6274b2029d7659ea$export$b3bd0bc58e36cd63;
"use strict";
$6274b2029d7659ea$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $6274b2029d7659ea$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
const $6274b2029d7659ea$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $6274b2029d7659ea$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
const $6274b2029d7659ea$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
const $6274b2029d7659ea$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $6274b2029d7659ea$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
const $6274b2029d7659ea$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
const $6274b2029d7659ea$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-\u0433\u0430";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
const $6274b2029d7659ea$var$localize = $6274b2029d7659ea$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6274b2029d7659ea$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $6274b2029d7659ea$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $6274b2029d7659ea$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $6274b2029d7659ea$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $6274b2029d7659ea$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $6274b2029d7659ea$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $6274b2029d7659ea$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $6274b2029d7659ea$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("6CHoq", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $4d27f39f80b8f040$export$4659b591c19bdf3d; }, function (v) { return $4d27f39f80b8f040$export$4659b591c19bdf3d = v; });
var $4d27f39f80b8f040$export$4659b591c19bdf3d;
"use strict";
$4d27f39f80b8f040$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $4d27f39f80b8f040$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
const $4d27f39f80b8f040$var$parseOrdinalNumberPattern = /\d+/i;
const $4d27f39f80b8f040$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
const $4d27f39f80b8f040$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $4d27f39f80b8f040$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
const $4d27f39f80b8f040$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $4d27f39f80b8f040$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
const $4d27f39f80b8f040$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
const $4d27f39f80b8f040$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
const $4d27f39f80b8f040$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $4d27f39f80b8f040$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
const $4d27f39f80b8f040$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $4d27f39f80b8f040$var$match = $4d27f39f80b8f040$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $4d27f39f80b8f040$var$matchOrdinalNumberPattern,
        parsePattern: $4d27f39f80b8f040$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4d27f39f80b8f040$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4d27f39f80b8f040$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4d27f39f80b8f040$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4d27f39f80b8f040$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4d27f39f80b8f040$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4d27f39f80b8f040$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4d27f39f80b8f040$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4d27f39f80b8f040$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4d27f39f80b8f040$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4d27f39f80b8f040$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("gWrid", function(module, exports) {

$parcel$export(module.exports, "beTarask", function () { return $c5573be942ce264d$export$af663c27a971be30; }, function (v) { return $c5573be942ce264d$export$af663c27a971be30 = v; });
var $c5573be942ce264d$export$af663c27a971be30;
"use strict";
$c5573be942ce264d$export$af663c27a971be30 = void 0;

var $7dSdW = parcelRequire("7dSdW");

var $cMlaU = parcelRequire("cMlaU");

var $bvM6p = parcelRequire("bvM6p");

var $2PQro = parcelRequire("2PQro");

var $hLzJe = parcelRequire("hLzJe");
/**
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears](https://github.com/nopears)
 */ const $c5573be942ce264d$var$beTarask = $c5573be942ce264d$export$af663c27a971be30 = {
    code: "be-tarask",
    formatDistance: $7dSdW.formatDistance,
    formatLong: $cMlaU.formatLong,
    formatRelative: $bvM6p.formatRelative,
    localize: $2PQro.localize,
    match: $hLzJe.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("7dSdW", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $5423cf0d39909268$export$2c14ff85d6318973; }, function (v) { return $5423cf0d39909268$export$2c14ff85d6318973 = v; });
var $5423cf0d39909268$export$2c14ff85d6318973;
"use strict";
$5423cf0d39909268$export$2c14ff85d6318973 = void 0;
function $5423cf0d39909268$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $5423cf0d39909268$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $5423cf0d39909268$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $5423cf0d39909268$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $5423cf0d39909268$var$declension(scheme.past, count);
                else return $5423cf0d39909268$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $5423cf0d39909268$var$declension(scheme.regular, count);
    };
}
const $5423cf0d39909268$var$halfAMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
const $5423cf0d39909268$var$formatDistanceLocale = {
    lessThanXSeconds: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $5423cf0d39909268$var$halfAMinute,
    lessThanXMinutes: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u0456",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    xWeeks: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    aboutXMonths: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $5423cf0d39909268$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
const $5423cf0d39909268$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $5423cf0d39909268$var$formatDistanceLocale[token](count, options);
};
$5423cf0d39909268$export$2c14ff85d6318973 = $5423cf0d39909268$var$formatDistance;

});

parcelRegister("cMlaU", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $94da64a278837c5c$export$cbf60ecb96cbb82f; }, function (v) { return $94da64a278837c5c$export$cbf60ecb96cbb82f = v; });
var $94da64a278837c5c$export$cbf60ecb96cbb82f;
"use strict";
$94da64a278837c5c$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $94da64a278837c5c$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $94da64a278837c5c$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $94da64a278837c5c$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $94da64a278837c5c$var$formatLong = $94da64a278837c5c$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $94da64a278837c5c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $94da64a278837c5c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $94da64a278837c5c$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("bvM6p", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $8617e7108d53f8e5$export$8fbbfd65594f46a0; }, function (v) { return $8617e7108d53f8e5$export$8fbbfd65594f46a0 = v; });
var $8617e7108d53f8e5$export$8fbbfd65594f46a0;
"use strict";
$8617e7108d53f8e5$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");

var $2ZADR = parcelRequire("2ZADR");
const $8617e7108d53f8e5$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $8617e7108d53f8e5$var$lastWeek(day) {
    const weekday = $8617e7108d53f8e5$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $8617e7108d53f8e5$var$thisWeek(day) {
    const weekday = $8617e7108d53f8e5$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $8617e7108d53f8e5$var$nextWeek(day) {
    const weekday = $8617e7108d53f8e5$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
const $8617e7108d53f8e5$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $2ZADR.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $8617e7108d53f8e5$var$thisWeek(day);
    else return $8617e7108d53f8e5$var$lastWeek(day);
};
const $8617e7108d53f8e5$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $2ZADR.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $8617e7108d53f8e5$var$thisWeek(day);
    else return $8617e7108d53f8e5$var$nextWeek(day);
};
const $8617e7108d53f8e5$var$formatRelativeLocale = {
    lastWeek: $8617e7108d53f8e5$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $8617e7108d53f8e5$var$nextWeekFormat,
    other: "P"
};
const $8617e7108d53f8e5$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $8617e7108d53f8e5$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$8617e7108d53f8e5$export$8fbbfd65594f46a0 = $8617e7108d53f8e5$var$formatRelative;

});

parcelRegister("2PQro", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $210905d699bd1668$export$b3bd0bc58e36cd63; }, function (v) { return $210905d699bd1668$export$b3bd0bc58e36cd63 = v; });
var $210905d699bd1668$export$b3bd0bc58e36cd63;
"use strict";
$210905d699bd1668$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $210905d699bd1668$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
const $210905d699bd1668$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $210905d699bd1668$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
const $210905d699bd1668$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
const $210905d699bd1668$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $210905d699bd1668$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
const $210905d699bd1668$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
const $210905d699bd1668$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-\u0433\u0430";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
const $210905d699bd1668$var$localize = $210905d699bd1668$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $210905d699bd1668$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $210905d699bd1668$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $210905d699bd1668$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $210905d699bd1668$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $210905d699bd1668$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $210905d699bd1668$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $210905d699bd1668$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $210905d699bd1668$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("hLzJe", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $cef28a60aa857709$export$4659b591c19bdf3d; }, function (v) { return $cef28a60aa857709$export$4659b591c19bdf3d = v; });
var $cef28a60aa857709$export$4659b591c19bdf3d;
"use strict";
$cef28a60aa857709$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $cef28a60aa857709$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
const $cef28a60aa857709$var$parseOrdinalNumberPattern = /\d+/i;
const $cef28a60aa857709$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
const $cef28a60aa857709$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $cef28a60aa857709$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
const $cef28a60aa857709$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $cef28a60aa857709$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
const $cef28a60aa857709$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
const $cef28a60aa857709$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
const $cef28a60aa857709$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $cef28a60aa857709$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
const $cef28a60aa857709$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $cef28a60aa857709$var$match = $cef28a60aa857709$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $cef28a60aa857709$var$matchOrdinalNumberPattern,
        parsePattern: $cef28a60aa857709$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cef28a60aa857709$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cef28a60aa857709$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cef28a60aa857709$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cef28a60aa857709$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cef28a60aa857709$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cef28a60aa857709$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cef28a60aa857709$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cef28a60aa857709$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cef28a60aa857709$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cef28a60aa857709$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("4nKni", function(module, exports) {

$parcel$export(module.exports, "bg", function () { return $330d487a8c1424a4$export$136fd86de524d3c2; }, function (v) { return $330d487a8c1424a4$export$136fd86de524d3c2 = v; });
var $330d487a8c1424a4$export$136fd86de524d3c2;
"use strict";
$330d487a8c1424a4$export$136fd86de524d3c2 = void 0;

var $g6jEm = parcelRequire("g6jEm");

var $2U76y = parcelRequire("2U76y");

var $vFAmu = parcelRequire("vFAmu");

var $cZppg = parcelRequire("cZppg");

var $eV9QO = parcelRequire("eV9QO");
/**
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus](https://github.com/arvigeus)
 * @author Tsvetan Ovedenski [@fintara](https://github.com/fintara)
 */ const $330d487a8c1424a4$var$bg = $330d487a8c1424a4$export$136fd86de524d3c2 = {
    code: "bg",
    formatDistance: $g6jEm.formatDistance,
    formatLong: $2U76y.formatLong,
    formatRelative: $vFAmu.formatRelative,
    localize: $cZppg.localize,
    match: $eV9QO.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("g6jEm", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $bb8c72f05bc638ac$export$2c14ff85d6318973; }, function (v) { return $bb8c72f05bc638ac$export$2c14ff85d6318973 = v; });
var $bb8c72f05bc638ac$export$2c14ff85d6318973;
"use strict";
$bb8c72f05bc638ac$export$2c14ff85d6318973 = void 0;
const $bb8c72f05bc638ac$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
const $bb8c72f05bc638ac$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $bb8c72f05bc638ac$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
$bb8c72f05bc638ac$export$2c14ff85d6318973 = $bb8c72f05bc638ac$var$formatDistance;

});

parcelRegister("2U76y", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $21d6528f57c2665d$export$cbf60ecb96cbb82f; }, function (v) { return $21d6528f57c2665d$export$cbf60ecb96cbb82f = v; });
var $21d6528f57c2665d$export$cbf60ecb96cbb82f;
"use strict";
$21d6528f57c2665d$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $21d6528f57c2665d$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
const $21d6528f57c2665d$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
const $21d6528f57c2665d$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $21d6528f57c2665d$var$formatLong = $21d6528f57c2665d$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $21d6528f57c2665d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $21d6528f57c2665d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $21d6528f57c2665d$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("vFAmu", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $05f3275ff6dd9544$export$8fbbfd65594f46a0; }, function (v) { return $05f3275ff6dd9544$export$8fbbfd65594f46a0 = v; });
var $05f3275ff6dd9544$export$8fbbfd65594f46a0;
"use strict";
$05f3275ff6dd9544$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");

var $2ZADR = parcelRequire("2ZADR");
// Adapted from the `ru` translation
const $05f3275ff6dd9544$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function $05f3275ff6dd9544$var$lastWeek(day) {
    const weekday = $05f3275ff6dd9544$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function $05f3275ff6dd9544$var$thisWeek(day) {
    const weekday = $05f3275ff6dd9544$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $05f3275ff6dd9544$var$nextWeek(day) {
    const weekday = $05f3275ff6dd9544$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
const $05f3275ff6dd9544$var$lastWeekFormatToken = (dirtyDate, baseDate, options)=>{
    const date = (0, $2ZADR.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $05f3275ff6dd9544$var$thisWeek(day);
    else return $05f3275ff6dd9544$var$lastWeek(day);
};
const $05f3275ff6dd9544$var$nextWeekFormatToken = (dirtyDate, baseDate, options)=>{
    const date = (0, $2ZADR.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $05f3275ff6dd9544$var$thisWeek(day);
    else return $05f3275ff6dd9544$var$nextWeek(day);
};
const $05f3275ff6dd9544$var$formatRelativeLocale = {
    lastWeek: $05f3275ff6dd9544$var$lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: $05f3275ff6dd9544$var$nextWeekFormatToken,
    other: "P"
};
const $05f3275ff6dd9544$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $05f3275ff6dd9544$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$05f3275ff6dd9544$export$8fbbfd65594f46a0 = $05f3275ff6dd9544$var$formatRelative;

});

parcelRegister("cZppg", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $974ee3be4456317b$export$b3bd0bc58e36cd63; }, function (v) { return $974ee3be4456317b$export$b3bd0bc58e36cd63 = v; });
var $974ee3be4456317b$export$b3bd0bc58e36cd63;
"use strict";
$974ee3be4456317b$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $974ee3be4456317b$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
const $974ee3be4456317b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
const $974ee3be4456317b$var$monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
const $974ee3be4456317b$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
const $974ee3be4456317b$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function $974ee3be4456317b$var$isFeminine(unit) {
    return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function $974ee3be4456317b$var$isNeuter(unit) {
    return unit === "quarter";
}
function $974ee3be4456317b$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    const suffix = $974ee3be4456317b$var$isNeuter(unit) ? neuter : $974ee3be4456317b$var$isFeminine(unit) ? feminine : masculine;
    return number + "-" + suffix;
}
const $974ee3be4456317b$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return $974ee3be4456317b$var$numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return $974ee3be4456317b$var$numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return $974ee3be4456317b$var$numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $974ee3be4456317b$var$numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return $974ee3be4456317b$var$numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return $974ee3be4456317b$var$numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return $974ee3be4456317b$var$numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
const $974ee3be4456317b$var$localize = $974ee3be4456317b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $974ee3be4456317b$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $974ee3be4456317b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $974ee3be4456317b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $974ee3be4456317b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $974ee3be4456317b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $974ee3be4456317b$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("eV9QO", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $adce07b779e4ff3c$export$4659b591c19bdf3d; }, function (v) { return $adce07b779e4ff3c$export$4659b591c19bdf3d = v; });
var $adce07b779e4ff3c$export$4659b591c19bdf3d;
"use strict";
$adce07b779e4ff3c$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $adce07b779e4ff3c$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
const $adce07b779e4ff3c$var$parseOrdinalNumberPattern = /\d+/i;
const $adce07b779e4ff3c$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
const $adce07b779e4ff3c$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
const $adce07b779e4ff3c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
const $adce07b779e4ff3c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $adce07b779e4ff3c$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
const $adce07b779e4ff3c$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
const $adce07b779e4ff3c$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
const $adce07b779e4ff3c$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
const $adce07b779e4ff3c$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
const $adce07b779e4ff3c$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
const $adce07b779e4ff3c$var$match = $adce07b779e4ff3c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $adce07b779e4ff3c$var$matchOrdinalNumberPattern,
        parsePattern: $adce07b779e4ff3c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adce07b779e4ff3c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $adce07b779e4ff3c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adce07b779e4ff3c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $adce07b779e4ff3c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adce07b779e4ff3c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $adce07b779e4ff3c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adce07b779e4ff3c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $adce07b779e4ff3c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adce07b779e4ff3c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $adce07b779e4ff3c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("iTiqN", function(module, exports) {

$parcel$export(module.exports, "bn", function () { return $dc0ba91f6740e784$export$acf3ba20e47771d; }, function (v) { return $dc0ba91f6740e784$export$acf3ba20e47771d = v; });
var $dc0ba91f6740e784$export$acf3ba20e47771d;
"use strict";
$dc0ba91f6740e784$export$acf3ba20e47771d = void 0;

var $6epkW = parcelRequire("6epkW");

var $1xGhX = parcelRequire("1xGhX");

var $k12fx = parcelRequire("k12fx");

var $aFtIB = parcelRequire("aFtIB");

var $79XUQ = parcelRequire("79XUQ");
/**
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman](https://github.com/touhidrahman)
 * @author Farhad Yasir [@nutboltu](https://github.com/nutboltu)
 */ const $dc0ba91f6740e784$var$bn = $dc0ba91f6740e784$export$acf3ba20e47771d = {
    code: "bn",
    formatDistance: $6epkW.formatDistance,
    formatLong: $1xGhX.formatLong,
    formatRelative: $k12fx.formatRelative,
    localize: $aFtIB.localize,
    match: $79XUQ.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("6epkW", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4897b4386481e25d$export$2c14ff85d6318973; }, function (v) { return $4897b4386481e25d$export$2c14ff85d6318973 = v; });
var $4897b4386481e25d$export$2c14ff85d6318973;
"use strict";
$4897b4386481e25d$export$2c14ff85d6318973 = void 0;

var $aFtIB = parcelRequire("aFtIB");
const $4897b4386481e25d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
const $4897b4386481e25d$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $4897b4386481e25d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $aFtIB.numberToLocale)(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
$4897b4386481e25d$export$2c14ff85d6318973 = $4897b4386481e25d$var$formatDistance;

});
parcelRegister("aFtIB", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $7c44c92a8ea2d9f5$export$b3bd0bc58e36cd63; }, function (v) { return $7c44c92a8ea2d9f5$export$b3bd0bc58e36cd63 = v; });
$parcel$export(module.exports, "numberToLocale", function () { return $7c44c92a8ea2d9f5$export$3e1d599946644f03; }, function (v) { return $7c44c92a8ea2d9f5$export$3e1d599946644f03 = v; });
var $7c44c92a8ea2d9f5$export$b3bd0bc58e36cd63;
var $7c44c92a8ea2d9f5$export$3e1d599946644f03;
"use strict";
$7c44c92a8ea2d9f5$export$b3bd0bc58e36cd63 = void 0;
$7c44c92a8ea2d9f5$export$3e1d599946644f03 = $7c44c92a8ea2d9f5$var$numberToLocale;

var $bhSfH = parcelRequire("bhSfH");
const $7c44c92a8ea2d9f5$var$numberValues = {
    locale: {
        1: "\u09E7",
        2: "\u09E8",
        3: "\u09E9",
        4: "\u09EA",
        5: "\u09EB",
        6: "\u09EC",
        7: "\u09ED",
        8: "\u09EE",
        9: "\u09EF",
        0: "\u09E6"
    },
    number: {
        "\u09E7": "1",
        "\u09E8": "2",
        "\u09E9": "3",
        "\u09EA": "4",
        "\u09EB": "5",
        "\u09EC": "6",
        "\u09ED": "7",
        "\u09EE": "8",
        "\u09EF": "9",
        "\u09E6": "0"
    }
};
const $7c44c92a8ea2d9f5$var$eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
const $7c44c92a8ea2d9f5$var$quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
const $7c44c92a8ea2d9f5$var$monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
const $7c44c92a8ea2d9f5$var$dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
const $7c44c92a8ea2d9f5$var$dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
const $7c44c92a8ea2d9f5$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function $7c44c92a8ea2d9f5$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
const $7c44c92a8ea2d9f5$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const localeNumber = $7c44c92a8ea2d9f5$var$numberToLocale(number);
    const unit = options?.unit;
    if (unit === "date") return $7c44c92a8ea2d9f5$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    const rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
// function localeToNumber(locale: string): number {
//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
//     return numberValues.number[match as keyof typeof numberValues.number]
//   })
//   return Number(enNumber)
// }
function $7c44c92a8ea2d9f5$var$numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $7c44c92a8ea2d9f5$var$numberValues.locale[match];
    });
}
const $7c44c92a8ea2d9f5$var$localize = $7c44c92a8ea2d9f5$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7c44c92a8ea2d9f5$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $7c44c92a8ea2d9f5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $7c44c92a8ea2d9f5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $7c44c92a8ea2d9f5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $7c44c92a8ea2d9f5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $7c44c92a8ea2d9f5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7c44c92a8ea2d9f5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});


parcelRegister("1xGhX", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $11f9ad2c356f36c2$export$cbf60ecb96cbb82f; }, function (v) { return $11f9ad2c356f36c2$export$cbf60ecb96cbb82f = v; });
var $11f9ad2c356f36c2$export$cbf60ecb96cbb82f;
"use strict";
$11f9ad2c356f36c2$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $11f9ad2c356f36c2$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $11f9ad2c356f36c2$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $11f9ad2c356f36c2$var$dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $11f9ad2c356f36c2$var$formatLong = $11f9ad2c356f36c2$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $11f9ad2c356f36c2$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $11f9ad2c356f36c2$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $11f9ad2c356f36c2$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("k12fx", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e925a5617f21de33$export$8fbbfd65594f46a0; }, function (v) { return $e925a5617f21de33$export$8fbbfd65594f46a0 = v; });
var $e925a5617f21de33$export$8fbbfd65594f46a0;
"use strict";
$e925a5617f21de33$export$8fbbfd65594f46a0 = void 0;
const $e925a5617f21de33$var$formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: "P"
};
const $e925a5617f21de33$var$formatRelative = (token, _date, _baseDate, _options)=>$e925a5617f21de33$var$formatRelativeLocale[token];
$e925a5617f21de33$export$8fbbfd65594f46a0 = $e925a5617f21de33$var$formatRelative;

});

parcelRegister("79XUQ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5367d9b0500ddb6c$export$4659b591c19bdf3d; }, function (v) { return $5367d9b0500ddb6c$export$4659b591c19bdf3d = v; });
var $5367d9b0500ddb6c$export$4659b591c19bdf3d;
"use strict";
$5367d9b0500ddb6c$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $5367d9b0500ddb6c$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
const $5367d9b0500ddb6c$var$parseOrdinalNumberPattern = /\d+/i;
const $5367d9b0500ddb6c$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
const $5367d9b0500ddb6c$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
const $5367d9b0500ddb6c$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
const $5367d9b0500ddb6c$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
const $5367d9b0500ddb6c$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
const $5367d9b0500ddb6c$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
const $5367d9b0500ddb6c$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
const $5367d9b0500ddb6c$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
const $5367d9b0500ddb6c$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
const $5367d9b0500ddb6c$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
const $5367d9b0500ddb6c$var$match = $5367d9b0500ddb6c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $5367d9b0500ddb6c$var$matchOrdinalNumberPattern,
        parsePattern: $5367d9b0500ddb6c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5367d9b0500ddb6c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5367d9b0500ddb6c$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5367d9b0500ddb6c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5367d9b0500ddb6c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5367d9b0500ddb6c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5367d9b0500ddb6c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5367d9b0500ddb6c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5367d9b0500ddb6c$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5367d9b0500ddb6c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5367d9b0500ddb6c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8aQky", function(module, exports) {

$parcel$export(module.exports, "bs", function () { return $5f37d9a9ac5a889f$export$4e222d082f82ee97; }, function (v) { return $5f37d9a9ac5a889f$export$4e222d082f82ee97 = v; });
var $5f37d9a9ac5a889f$export$4e222d082f82ee97;
"use strict";
$5f37d9a9ac5a889f$export$4e222d082f82ee97 = void 0;

var $a2RNJ = parcelRequire("a2RNJ");

var $iTKGV = parcelRequire("iTKGV");

var $7bCjP = parcelRequire("7bCjP");

var $c5lp6 = parcelRequire("c5lp6");

var $lwdFC = parcelRequire("lwdFC");
/**
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic](https://github.com/branislavlazic)
 */ const $5f37d9a9ac5a889f$var$bs = $5f37d9a9ac5a889f$export$4e222d082f82ee97 = {
    code: "bs",
    formatDistance: $a2RNJ.formatDistance,
    formatLong: $iTKGV.formatLong,
    formatRelative: $7bCjP.formatRelative,
    localize: $c5lp6.localize,
    match: $lwdFC.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("a2RNJ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $7503d30c3472cecf$export$2c14ff85d6318973; }, function (v) { return $7503d30c3472cecf$export$2c14ff85d6318973 = v; });
var $7503d30c3472cecf$export$2c14ff85d6318973;
"use strict";
$7503d30c3472cecf$export$2c14ff85d6318973 = void 0;
const $7503d30c3472cecf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 sedmicu",
            withPrepositionAgo: "oko 1 sedmicu",
            withPrepositionIn: "oko 1 sedmicu"
        },
        dual: "oko {{count}} sedmice",
        other: "oko {{count}} sedmice"
    },
    xWeeks: {
        one: {
            standalone: "1 sedmicu",
            withPrepositionAgo: "1 sedmicu",
            withPrepositionIn: "1 sedmicu"
        },
        dual: "{{count}} sedmice",
        other: "{{count}} sedmice"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $7503d30c3472cecf$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $7503d30c3472cecf$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
$7503d30c3472cecf$export$2c14ff85d6318973 = $7503d30c3472cecf$var$formatDistance;

});

parcelRegister("iTKGV", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $dc2194ffb60e946a$export$cbf60ecb96cbb82f; }, function (v) { return $dc2194ffb60e946a$export$cbf60ecb96cbb82f = v; });
var $dc2194ffb60e946a$export$cbf60ecb96cbb82f;
"use strict";
$dc2194ffb60e946a$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $dc2194ffb60e946a$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $dc2194ffb60e946a$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $dc2194ffb60e946a$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $dc2194ffb60e946a$var$formatLong = $dc2194ffb60e946a$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $dc2194ffb60e946a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $dc2194ffb60e946a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $dc2194ffb60e946a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("7bCjP", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $53b748ce8d4de444$export$8fbbfd65594f46a0; }, function (v) { return $53b748ce8d4de444$export$8fbbfd65594f46a0 = v; });
var $53b748ce8d4de444$export$8fbbfd65594f46a0;
"use strict";
$53b748ce8d4de444$export$8fbbfd65594f46a0 = void 0;
const $53b748ce8d4de444$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: "P"
};
const $53b748ce8d4de444$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $53b748ce8d4de444$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$53b748ce8d4de444$export$8fbbfd65594f46a0 = $53b748ce8d4de444$var$formatRelative;

});

parcelRegister("c5lp6", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8cc68e0748672398$export$b3bd0bc58e36cd63; }, function (v) { return $8cc68e0748672398$export$b3bd0bc58e36cd63 = v; });
var $8cc68e0748672398$export$b3bd0bc58e36cd63;
"use strict";
$8cc68e0748672398$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $8cc68e0748672398$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Prije Hrista",
        "Poslije Hrista"
    ]
};
const $8cc68e0748672398$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $8cc68e0748672398$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $8cc68e0748672398$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $8cc68e0748672398$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $8cc68e0748672398$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $8cc68e0748672398$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $8cc68e0748672398$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return String(number) + ".";
};
const $8cc68e0748672398$var$localize = $8cc68e0748672398$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8cc68e0748672398$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $8cc68e0748672398$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $8cc68e0748672398$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $8cc68e0748672398$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $8cc68e0748672398$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $8cc68e0748672398$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $8cc68e0748672398$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8cc68e0748672398$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("lwdFC", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $faa730c470c7881a$export$4659b591c19bdf3d; }, function (v) { return $faa730c470c7881a$export$4659b591c19bdf3d = v; });
var $faa730c470c7881a$export$4659b591c19bdf3d;
"use strict";
$faa730c470c7881a$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $faa730c470c7881a$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $faa730c470c7881a$var$parseOrdinalNumberPattern = /\d+/i;
const $faa730c470c7881a$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
const $faa730c470c7881a$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $faa730c470c7881a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $faa730c470c7881a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $faa730c470c7881a$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
const $faa730c470c7881a$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $faa730c470c7881a$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $faa730c470c7881a$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $faa730c470c7881a$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
const $faa730c470c7881a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
const $faa730c470c7881a$var$match = $faa730c470c7881a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $faa730c470c7881a$var$matchOrdinalNumberPattern,
        parsePattern: $faa730c470c7881a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $faa730c470c7881a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $faa730c470c7881a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $faa730c470c7881a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $faa730c470c7881a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $faa730c470c7881a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $faa730c470c7881a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $faa730c470c7881a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $faa730c470c7881a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $faa730c470c7881a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $faa730c470c7881a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("9OlUo", function(module, exports) {

$parcel$export(module.exports, "ca", function () { return $7249c7262ff487a8$export$89e9012e902952b6; }, function (v) { return $7249c7262ff487a8$export$89e9012e902952b6 = v; });
var $7249c7262ff487a8$export$89e9012e902952b6;
"use strict";
$7249c7262ff487a8$export$89e9012e902952b6 = void 0;

var $cmltj = parcelRequire("cmltj");

var $1Gq96 = parcelRequire("1Gq96");

var $53HUr = parcelRequire("53HUr");

var $fTewZ = parcelRequire("fTewZ");

var $ijfMF = parcelRequire("ijfMF");
/**
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Alex Vizcaino [@avizcaino](https://github.com/avizcaino)
 */ const $7249c7262ff487a8$var$ca = $7249c7262ff487a8$export$89e9012e902952b6 = {
    code: "ca",
    formatDistance: $cmltj.formatDistance,
    formatLong: $1Gq96.formatLong,
    formatRelative: $53HUr.formatRelative,
    localize: $fTewZ.localize,
    match: $ijfMF.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("cmltj", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $8ff831f1a355fff2$export$2c14ff85d6318973; }, function (v) { return $8ff831f1a355fff2$export$2c14ff85d6318973 = v; });
var $8ff831f1a355fff2$export$2c14ff85d6318973;
"use strict";
$8ff831f1a355fff2$export$2c14ff85d6318973 = void 0;
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ const $8ff831f1a355fff2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: "menys de {{count}} segons"
    },
    xSeconds: {
        one: "1 segon",
        other: "{{count}} segons"
    },
    halfAMinute: "mig minut",
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: "menys de {{count}} minuts"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minuts"
    },
    aboutXHours: {
        one: "aproximadament una hora",
        other: "aproximadament {{count}} hores"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} hores"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dies"
    },
    aboutXWeeks: {
        one: "aproximadament una setmana",
        other: "aproximadament {{count}} setmanes"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanes"
    },
    aboutXMonths: {
        one: "aproximadament un mes",
        other: "aproximadament {{count}} mesos"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} mesos"
    },
    aboutXYears: {
        one: "aproximadament un any",
        other: "aproximadament {{count}} anys"
    },
    xYears: {
        one: "1 any",
        other: "{{count}} anys"
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
const $8ff831f1a355fff2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $8ff831f1a355fff2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "fa " + result;
    }
    return result;
};
$8ff831f1a355fff2$export$2c14ff85d6318973 = $8ff831f1a355fff2$var$formatDistance;

});

parcelRegister("1Gq96", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $139dfeb5f5083f5b$export$cbf60ecb96cbb82f; }, function (v) { return $139dfeb5f5083f5b$export$cbf60ecb96cbb82f = v; });
var $139dfeb5f5083f5b$export$cbf60ecb96cbb82f;
"use strict";
$139dfeb5f5083f5b$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $139dfeb5f5083f5b$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $139dfeb5f5083f5b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $139dfeb5f5083f5b$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $139dfeb5f5083f5b$var$formatLong = $139dfeb5f5083f5b$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $139dfeb5f5083f5b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $139dfeb5f5083f5b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $139dfeb5f5083f5b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("53HUr", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $3aef4b0b55c67081$export$8fbbfd65594f46a0; }, function (v) { return $3aef4b0b55c67081$export$8fbbfd65594f46a0 = v; });
var $3aef4b0b55c67081$export$8fbbfd65594f46a0;
"use strict";
$3aef4b0b55c67081$export$8fbbfd65594f46a0 = void 0;
const $3aef4b0b55c67081$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
const $3aef4b0b55c67081$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: "P"
};
const $3aef4b0b55c67081$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $3aef4b0b55c67081$var$formatRelativeLocalePlural[token];
    return $3aef4b0b55c67081$var$formatRelativeLocale[token];
};
$3aef4b0b55c67081$export$8fbbfd65594f46a0 = $3aef4b0b55c67081$var$formatRelative;

});

parcelRegister("fTewZ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $b91743a0f6c1a40b$export$b3bd0bc58e36cd63; }, function (v) { return $b91743a0f6c1a40b$export$b3bd0bc58e36cd63 = v; });
var $b91743a0f6c1a40b$export$b3bd0bc58e36cd63;
"use strict";
$b91743a0f6c1a40b$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ const $b91743a0f6c1a40b$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a. de C.",
        "d. de C."
    ],
    wide: [
        "abans de Crist",
        "despr\xe9s de Crist"
    ]
};
const $b91743a0f6c1a40b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1r trimestre",
        "2n trimestre",
        "3r trimestre",
        "4t trimestre"
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ const $b91743a0f6c1a40b$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MG",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DS"
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "maig",
        "juny",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "des."
    ],
    wide: [
        "gener",
        "febrer",
        "mar\xe7",
        "abril",
        "maig",
        "juny",
        "juliol",
        "agost",
        "setembre",
        "octubre",
        "novembre",
        "desembre"
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ const $b91743a0f6c1a40b$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "diumenge",
        "dilluns",
        "dimarts",
        "dimecres",
        "dijous",
        "divendres",
        "dissabte"
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ const $b91743a0f6c1a40b$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    }
};
const $b91743a0f6c1a40b$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ const $b91743a0f6c1a40b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "r";
        case 2:
            return number + "n";
        case 3:
            return number + "r";
        case 4:
            return number + "t";
    }
    return number + "\xe8";
};
const $b91743a0f6c1a40b$var$localize = $b91743a0f6c1a40b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b91743a0f6c1a40b$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $b91743a0f6c1a40b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $b91743a0f6c1a40b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $b91743a0f6c1a40b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $b91743a0f6c1a40b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $b91743a0f6c1a40b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b91743a0f6c1a40b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("ijfMF", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $d5463eb687eb4186$export$4659b591c19bdf3d; }, function (v) { return $d5463eb687eb4186$export$4659b591c19bdf3d = v; });
var $d5463eb687eb4186$export$4659b591c19bdf3d;
"use strict";
$d5463eb687eb4186$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $d5463eb687eb4186$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
const $d5463eb687eb4186$var$parseOrdinalNumberPattern = /\d+/i;
const $d5463eb687eb4186$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
const $d5463eb687eb4186$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
const $d5463eb687eb4186$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
const $d5463eb687eb4186$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d5463eb687eb4186$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
const $d5463eb687eb4186$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
const $d5463eb687eb4186$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
const $d5463eb687eb4186$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
const $d5463eb687eb4186$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
const $d5463eb687eb4186$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
const $d5463eb687eb4186$var$match = $d5463eb687eb4186$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $d5463eb687eb4186$var$matchOrdinalNumberPattern,
        parsePattern: $d5463eb687eb4186$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d5463eb687eb4186$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5463eb687eb4186$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d5463eb687eb4186$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5463eb687eb4186$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d5463eb687eb4186$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5463eb687eb4186$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d5463eb687eb4186$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5463eb687eb4186$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d5463eb687eb4186$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5463eb687eb4186$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("gAhpI", function(module, exports) {

$parcel$export(module.exports, "ckb", function () { return $c12d842b03e950c8$export$c045140574fce5cd; }, function (v) { return $c12d842b03e950c8$export$c045140574fce5cd = v; });
var $c12d842b03e950c8$export$c045140574fce5cd;
"use strict";
$c12d842b03e950c8$export$c045140574fce5cd = void 0;

var $irNwa = parcelRequire("irNwa");

var $4LlxU = parcelRequire("4LlxU");

var $82XZX = parcelRequire("82XZX");

var $ig9av = parcelRequire("ig9av");

var $iDoXr = parcelRequire("iDoXr");
/**
 * @type {Locale}
 * @category Locales
 * @summary Central Kurdish locale.
 * @language Central Kurdish
 * @iso-639-2 kur
 * @author Revan Sarbast [@Revan99]{@link https://github.com/Revan99}
 */ const $c12d842b03e950c8$var$ckb = $c12d842b03e950c8$export$c045140574fce5cd = {
    code: "ckb",
    formatDistance: $irNwa.formatDistance,
    formatLong: $4LlxU.formatLong,
    formatRelative: $82XZX.formatRelative,
    localize: $ig9av.localize,
    match: $iDoXr.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("irNwa", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $d6e128d3d814b228$export$2c14ff85d6318973; }, function (v) { return $d6e128d3d814b228$export$2c14ff85d6318973 = v; });
var $d6e128d3d814b228$export$2c14ff85d6318973;
"use strict";
$d6e128d3d814b228$export$2c14ff85d6318973 = void 0;
const $d6e128d3d814b228$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 \u06CC\u06D5\u06A9 \u0686\u0631\u06A9\u06D5",
        other: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 {{count}} \u0686\u0631\u06A9\u06D5"
    },
    xSeconds: {
        one: "1 \u0686\u0631\u06A9\u06D5",
        other: "{{count}} \u0686\u0631\u06A9\u06D5"
    },
    halfAMinute: "\u0646\u06CC\u0648 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
    lessThanXMinutes: {
        one: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 \u06CC\u06D5\u06A9 \u062E\u0648\u0644\u06D5\u06A9",
        other: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 {{count}} \u062E\u0648\u0644\u06D5\u06A9"
    },
    xMinutes: {
        one: "1 \u062E\u0648\u0644\u06D5\u06A9",
        other: "{{count}} \u062E\u0648\u0644\u06D5\u06A9"
    },
    aboutXHours: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631"
    },
    xHours: {
        one: "1 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
        other: "{{count}} \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631"
    },
    xDays: {
        one: "1 \u0695\u06C6\u0698",
        other: "{{count}} \u0698\u06C6\u0698"
    },
    aboutXWeeks: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u0647\u06D5\u0641\u062A\u06D5",
        other: "\u062F\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0647\u06D5\u0641\u062A\u06D5"
    },
    xWeeks: {
        one: "1 \u0647\u06D5\u0641\u062A\u06D5",
        other: "{{count}} \u0647\u06D5\u0641\u062A\u06D5"
    },
    aboutXMonths: {
        one: "\u062F\u0627\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u0645\u0627\u0646\u06AF",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0645\u0627\u0646\u06AF"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0646\u06AF",
        other: "{{count}} \u0645\u0627\u0646\u06AF"
    },
    aboutXYears: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC  1 \u0633\u0627\u06B5",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0633\u0627\u06B5"
    },
    xYears: {
        one: "1 \u0633\u0627\u06B5",
        other: "{{count}} \u0633\u0627\u06B5"
    },
    overXYears: {
        one: "\u0632\u06CC\u0627\u062A\u0631 \u0644\u06D5 \u0633\u0627\u06B5\u06CE\u06A9",
        other: "\u0632\u06CC\u0627\u062A\u0631 \u0644\u06D5 {{count}} \u0633\u0627\u06B5"
    },
    almostXYears: {
        one: "\u0628\u06D5\u0646\u0632\u06CC\u06A9\u06D5\u06CC\u06CC \u0633\u0627\u06B5\u06CE\u06A9  ",
        other: "\u0628\u06D5\u0646\u0632\u06CC\u06A9\u06D5\u06CC\u06CC {{count}} \u0633\u0627\u06B5"
    }
};
const $d6e128d3d814b228$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $d6e128d3d814b228$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0644\u06D5 \u0645\u0627\u0648\u06D5\u06CC " + result + "\u062F\u0627";
        else return result + "\u067E\u06CE\u0634 \u0626\u06CE\u0633\u062A\u0627";
    }
    return result;
};
$d6e128d3d814b228$export$2c14ff85d6318973 = $d6e128d3d814b228$var$formatDistance;

});

parcelRegister("4LlxU", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $377c43ccbdfd92e5$export$cbf60ecb96cbb82f; }, function (v) { return $377c43ccbdfd92e5$export$cbf60ecb96cbb82f = v; });
var $377c43ccbdfd92e5$export$cbf60ecb96cbb82f;
"use strict";
$377c43ccbdfd92e5$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $377c43ccbdfd92e5$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $377c43ccbdfd92e5$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $377c43ccbdfd92e5$var$dateTimeFormats = {
    full: "{{date}} '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' {{time}}",
    long: "{{date}} '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $377c43ccbdfd92e5$var$formatLong = $377c43ccbdfd92e5$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $377c43ccbdfd92e5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $377c43ccbdfd92e5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $377c43ccbdfd92e5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("82XZX", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $5dbd0d06ab215164$export$8fbbfd65594f46a0; }, function (v) { return $5dbd0d06ab215164$export$8fbbfd65594f46a0 = v; });
var $5dbd0d06ab215164$export$8fbbfd65594f46a0;
"use strict";
$5dbd0d06ab215164$export$8fbbfd65594f46a0 = void 0;
const $5dbd0d06ab215164$var$formatRelativeLocale = {
    lastWeek: "'\u0647\u06D5\u0641\u062A\u06D5\u06CC \u0695\u0627\u0628\u0631\u062F\u0648\u0648' eeee '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    yesterday: "'\u062F\u0648\u06CE\u0646\u06CE \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    today: "'\u0626\u06D5\u0645\u0695\u06C6 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    tomorrow: "'\u0628\u06D5\u06CC\u0627\u0646\u06CC \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    nextWeek: "eeee '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    other: "P"
};
const $5dbd0d06ab215164$var$formatRelative = (token, _date, _baseDate, _options)=>$5dbd0d06ab215164$var$formatRelativeLocale[token];
$5dbd0d06ab215164$export$8fbbfd65594f46a0 = $5dbd0d06ab215164$var$formatRelative;

});

parcelRegister("ig9av", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $d4b0d54204187132$export$b3bd0bc58e36cd63; }, function (v) { return $d4b0d54204187132$export$b3bd0bc58e36cd63 = v; });
var $d4b0d54204187132$export$b3bd0bc58e36cd63;
"use strict";
$d4b0d54204187132$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $d4b0d54204187132$var$eraValues = {
    narrow: [
        "\u067E",
        "\u062F"
    ],
    abbreviated: [
        "\u067E-\u0632",
        "\u062F-\u0632"
    ],
    wide: [
        "\u067E\u06CE\u0634 \u0632\u0627\u06CC\u0646",
        "\u062F\u0648\u0627\u06CC \u0632\u0627\u06CC\u0646"
    ]
};
const $d4b0d54204187132$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06861\u0645",
        "\u06862\u0645",
        "\u06863\u0645",
        "\u06864\u0645"
    ],
    wide: [
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u06CC\u06D5\u06A9\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u0633\u06CE\u06CC\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u0686\u0648\u0627\u0631\u06D5\u0645"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $d4b0d54204187132$var$monthValues = {
    narrow: [
        "\u06A9-\u062F",
        "\u0634",
        "\u0626\u0627",
        "\u0646",
        "\u0645",
        "\u062D",
        "\u062A",
        "\u0626\u0627",
        "\u0626\u06D5",
        "\u062A\u0634-\u06CC",
        "\u062A\u0634-\u062F",
        "\u06A9-\u06CC"
    ],
    abbreviated: [
        "\u06A9\u0627\u0646-\u062F\u0648\u0648",
        "\u0634\u0648\u0628",
        "\u0626\u0627\u062F",
        "\u0646\u06CC\u0633",
        "\u0645\u0627\u06CC\u0633",
        "\u062D\u0648\u0632",
        "\u062A\u06D5\u0645",
        "\u0626\u0627\u0628",
        "\u0626\u06D5\u0644",
        "\u062A\u0634-\u06CC\u06D5\u06A9",
        "\u062A\u0634-\u062F\u0648\u0648",
        "\u06A9\u0627\u0646-\u06CC\u06D5\u06A9"
    ],
    wide: [
        "\u06A9\u0627\u0646\u0648\u0648\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0634\u0648\u0628\u0627\u062A",
        "\u0626\u0627\u062F\u0627\u0631",
        "\u0646\u06CC\u0633\u0627\u0646",
        "\u0645\u0627\u06CC\u0633",
        "\u062D\u0648\u0632\u06D5\u06CC\u0631\u0627\u0646",
        "\u062A\u06D5\u0645\u0645\u0648\u0632",
        "\u0626\u0627\u0628",
        "\u0626\u06D5\u06CC\u0644\u0648\u0644",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u06A9\u0627\u0646\u0648\u0648\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645"
    ]
};
const $d4b0d54204187132$var$dayValues = {
    narrow: [
        "\u06CC-\u0634",
        "\u062F-\u0634",
        "\u0633-\u0634",
        "\u0686-\u0634",
        "\u067E-\u0634",
        "\u0647\u06D5",
        "\u0634"
    ],
    short: [
        "\u06CC\u06D5-\u0634\u06D5",
        "\u062F\u0648\u0648-\u0634\u06D5",
        "\u0633\u06CE-\u0634\u06D5",
        "\u0686\u0648-\u0634\u06D5",
        "\u067E\u06CE-\u0634\u06D5",
        "\u0647\u06D5\u06CC",
        "\u0634\u06D5"
    ],
    abbreviated: [
        "\u06CC\u06D5\u06A9-\u0634\u06D5\u0645",
        "\u062F\u0648\u0648-\u0634\u06D5\u0645",
        "\u0633\u06CE-\u0634\u06D5\u0645",
        "\u0686\u0648\u0627\u0631-\u0634\u06D5\u0645",
        "\u067E\u06CE\u0646\u062C-\u0634\u06D5\u0645",
        "\u0647\u06D5\u06CC\u0646\u06CC",
        "\u0634\u06D5\u0645\u06D5"
    ],
    wide: [
        "\u06CC\u06D5\u06A9 \u0634\u06D5\u0645\u06D5",
        "\u062F\u0648\u0648 \u0634\u06D5\u0645\u06D5",
        "\u0633\u06CE \u0634\u06D5\u0645\u06D5",
        "\u0686\u0648\u0627\u0631 \u0634\u06D5\u0645\u06D5",
        "\u067E\u06CE\u0646\u062C \u0634\u06D5\u0645\u06D5",
        "\u0647\u06D5\u06CC\u0646\u06CC",
        "\u0634\u06D5\u0645\u06D5"
    ]
};
const $d4b0d54204187132$var$dayPeriodValues = {
    narrow: {
        am: "\u067E",
        pm: "\u062F",
        midnight: "\u0646-\u0634",
        noon: "\u0646",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    },
    abbreviated: {
        am: "\u067E-\u0646",
        pm: "\u062F-\u0646",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    },
    wide: {
        am: "\u067E\u06CE\u0634 \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        pm: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    }
};
const $d4b0d54204187132$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u067E",
        pm: "\u062F",
        midnight: "\u0646-\u0634",
        noon: "\u0646",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    },
    abbreviated: {
        am: "\u067E-\u0646",
        pm: "\u062F-\u0646",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    },
    wide: {
        am: "\u067E\u06CE\u0634 \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        pm: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    }
};
const $d4b0d54204187132$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $d4b0d54204187132$var$localize = $d4b0d54204187132$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $d4b0d54204187132$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $d4b0d54204187132$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $d4b0d54204187132$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $d4b0d54204187132$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $d4b0d54204187132$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $d4b0d54204187132$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $d4b0d54204187132$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("iDoXr", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $d90f3a92c984522d$export$4659b591c19bdf3d; }, function (v) { return $d90f3a92c984522d$export$4659b591c19bdf3d = v; });
var $d90f3a92c984522d$export$4659b591c19bdf3d;
"use strict";
$d90f3a92c984522d$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $d90f3a92c984522d$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d90f3a92c984522d$var$parseOrdinalNumberPattern = /\d+/i;
const $d90f3a92c984522d$var$matchEraPatterns = {
    narrow: /^(پ|د)/i,
    abbreviated: /^(پ-ز|د.ز)/i,
    wide: /^(پێش زاین| دوای زاین)/i
};
const $d90f3a92c984522d$var$parseEraPatterns = {
    any: [
        /^د/g,
        /^پ/g
    ]
};
const $d90f3a92c984522d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^م[1234]چ/i,
    wide: /^(یەکەم|دووەم|سێیەم| چوارەم) (چارەگی)? quarter/i
};
const $d90f3a92c984522d$var$parseQuarterPatterns = {
    wide: [
        /چارەگی یەکەم/,
        /چارەگی دووەم/,
        /چارەگی سيیەم/,
        /چارەگی چوارەم/
    ],
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d90f3a92c984522d$var$matchMonthPatterns = {
    narrow: /^(ک-د|ش|ئا|ن|م|ح|ت|ئە|تش-ی|تش-د|ک-ی)/i,
    abbreviated: /^(کان-دوو|شوب|ئاد|نیس|مایس|حوز|تەم|ئاب|ئەل|تش-یەک|تش-دوو|کان-یەک)/i,
    wide: /^(کانوونی دووەم|شوبات|ئادار|نیسان|مایس|حوزەیران|تەمموز|ئاب|ئەیلول|تشرینی یەکەم|تشرینی دووەم|کانوونی یەکەم)/i
};
const $d90f3a92c984522d$var$parseMonthPatterns = {
    narrow: [
        /^ک-د/i,
        /^ش/i,
        /^ئا/i,
        /^ن/i,
        /^م/i,
        /^ح/i,
        /^ت/i,
        /^ئا/i,
        /^ئە/i,
        /^تش-ی/i,
        /^تش-د/i,
        /^ک-ی/i
    ],
    any: [
        /^کان-دوو/i,
        /^شوب/i,
        /^ئاد/i,
        /^نیس/i,
        /^مایس/i,
        /^حوز/i,
        /^تەم/i,
        /^ئاب/i,
        /^ئەل/i,
        /^تش-یەک/i,
        /^تش-دوو/i,
        /^|کان-یەک/i
    ]
};
const $d90f3a92c984522d$var$matchDayPatterns = {
    narrow: /^(ش|ی|د|س|چ|پ|هە)/i,
    short: /^(یە-شە|دوو-شە|سێ-شە|چو-شە|پێ-شە|هە|شە)/i,
    abbreviated: /^(یەک-شەم|دوو-شەم|سێ-شەم|چوار-شەم|پێنخ-شەم|هەینی|شەمە)/i,
    wide: /^(یەک شەمە|دوو شەمە|سێ شەمە|چوار شەمە|پێنج شەمە|هەینی|شەمە)/i
};
const $d90f3a92c984522d$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d90f3a92c984522d$var$matchDayPeriodPatterns = {
    narrow: /^(پ|د|ن-ش|ن| (بەیانی|دوای نیوەڕۆ|ئێوارە|شەو))/i,
    abbreviated: /^(پ-ن|د-ن|نیوە شەو|نیوەڕۆ|بەیانی|دوای نیوەڕۆ|ئێوارە|شەو)/,
    wide: /^(پێش نیوەڕۆ|دوای نیوەڕۆ|نیوەڕۆ|نیوە شەو|لەبەیانیدا|لەدواینیوەڕۆدا|لە ئێوارەدا|لە شەودا)/,
    any: /^(پ|د|بەیانی|نیوەڕۆ|ئێوارە|شەو)/
};
const $d90f3a92c984522d$var$parseDayPeriodPatterns = {
    any: {
        am: /^د/i,
        pm: /^پ/i,
        midnight: /^ن-ش/i,
        noon: /^ن/i,
        morning: /بەیانی/i,
        afternoon: /دواینیوەڕۆ/i,
        evening: /ئێوارە/i,
        night: /شەو/i
    }
};
const $d90f3a92c984522d$var$match = $d90f3a92c984522d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $d90f3a92c984522d$var$matchOrdinalNumberPattern,
        parsePattern: $d90f3a92c984522d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d90f3a92c984522d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d90f3a92c984522d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d90f3a92c984522d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d90f3a92c984522d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d90f3a92c984522d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d90f3a92c984522d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d90f3a92c984522d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d90f3a92c984522d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $d90f3a92c984522d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d90f3a92c984522d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("bKlVs", function(module, exports) {

$parcel$export(module.exports, "cs", function () { return $88d4ff9ac54ebd5f$export$bde1ed0f60b38f2f; }, function (v) { return $88d4ff9ac54ebd5f$export$bde1ed0f60b38f2f = v; });
var $88d4ff9ac54ebd5f$export$bde1ed0f60b38f2f;
"use strict";
$88d4ff9ac54ebd5f$export$bde1ed0f60b38f2f = void 0;

var $2ssDV = parcelRequire("2ssDV");

var $6WcDE = parcelRequire("6WcDE");

var $2Qboz = parcelRequire("2Qboz");

var $dpilp = parcelRequire("dpilp");

var $1DMIa = parcelRequire("1DMIa");
/**
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus](https://github.com/davidrus)
 * @author Pavel Hrách [@SilenY](https://github.com/SilenY)
 * @author Jozef Bíroš [@JozefBiros](https://github.com/JozefBiros)
 */ const $88d4ff9ac54ebd5f$var$cs = $88d4ff9ac54ebd5f$export$bde1ed0f60b38f2f = {
    code: "cs",
    formatDistance: $2ssDV.formatDistance,
    formatLong: $6WcDE.formatLong,
    formatRelative: $2Qboz.formatRelative,
    localize: $dpilp.localize,
    match: $1DMIa.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("2ssDV", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $1ca46a2c439c0327$export$2c14ff85d6318973; }, function (v) { return $1ca46a2c439c0327$export$2c14ff85d6318973 = v; });
var $1ca46a2c439c0327$export$2c14ff85d6318973;
"use strict";
$1ca46a2c439c0327$export$2c14ff85d6318973 = void 0;
const $1ca46a2c439c0327$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E 1 sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E 1 sekundou",
            future: "za m\xe9n\u011B ne\u017E 1 sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: "1 sekunda",
            past: "p\u0159ed 1 sekundou",
            future: "za 1 sekundu"
        },
        few: {
            regular: "{{count}} sekundy",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekundy"
        },
        many: {
            regular: "{{count}} sekund",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekund"
        }
    },
    halfAMinute: {
        type: "other",
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E 1 minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E 1 minutou",
            future: "za m\xe9n\u011B ne\u017E 1 minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: "1 minuta",
            past: "p\u0159ed 1 minutou",
            future: "za 1 minutu"
        },
        few: {
            regular: "{{count}} minuty",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minuty"
        },
        many: {
            regular: "{{count}} minut",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minut"
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 hodinou",
            future: "p\u0159ibli\u017En\u011B za 1 hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: "1 hodina",
            past: "p\u0159ed 1 hodinou",
            future: "za 1 hodinu"
        },
        few: {
            regular: "{{count}} hodiny",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodiny"
        },
        many: {
            regular: "{{count}} hodin",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodin"
        }
    },
    xDays: {
        one: {
            regular: "1 den",
            past: "p\u0159ed 1 dnem",
            future: "za 1 den"
        },
        few: {
            regular: "{{count}} dny",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dny"
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za 1 t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "1 t\xfdden",
            past: "p\u0159ed 1 t\xfddnem",
            future: "za 1 t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za 1 m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "1 m\u011Bs\xedc",
            past: "p\u0159ed 1 m\u011Bs\xedcem",
            future: "za 1 m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 rokem",
            future: "p\u0159ibli\u017En\u011B za 1 rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: "1 rok",
            past: "p\u0159ed 1 rokem",
            future: "za 1 rok"
        },
        few: {
            regular: "{{count}} roky",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} roky"
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E 1 rok",
            past: "p\u0159ed v\xedce ne\u017E 1 rokem",
            future: "za v\xedce ne\u017E 1 rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: "skoro 1 rok",
            past: "skoro p\u0159ed 1 rokem",
            future: "skoro za 1 rok"
        },
        few: {
            regular: "skoro {{count}} roky",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} roky"
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
const $1ca46a2c439c0327$var$formatDistance = (token, count, options)=>{
    let pluralResult;
    const tokenValue = $1ca46a2c439c0327$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === "other") pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    const suffixExist = options?.addSuffix === true;
    const comparison = options?.comparison;
    let timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace("{{count}}", String(count));
};
$1ca46a2c439c0327$export$2c14ff85d6318973 = $1ca46a2c439c0327$var$formatDistance;

});

parcelRegister("6WcDE", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $50d1f69c3fe35fe9$export$cbf60ecb96cbb82f; }, function (v) { return $50d1f69c3fe35fe9$export$cbf60ecb96cbb82f = v; });
var $50d1f69c3fe35fe9$export$cbf60ecb96cbb82f;
"use strict";
$50d1f69c3fe35fe9$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $50d1f69c3fe35fe9$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy",
    long: "d. MMMM yyyy",
    medium: "d. M. yyyy",
    short: "dd.MM.yyyy"
};
const $50d1f69c3fe35fe9$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $50d1f69c3fe35fe9$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $50d1f69c3fe35fe9$var$formatLong = $50d1f69c3fe35fe9$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $50d1f69c3fe35fe9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $50d1f69c3fe35fe9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $50d1f69c3fe35fe9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("2Qboz", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $211946f3dff4f9d1$export$8fbbfd65594f46a0; }, function (v) { return $211946f3dff4f9d1$export$8fbbfd65594f46a0 = v; });
var $211946f3dff4f9d1$export$8fbbfd65594f46a0;
"use strict";
$211946f3dff4f9d1$export$8fbbfd65594f46a0 = void 0;
const $211946f3dff4f9d1$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    "sobotu"
];
const $211946f3dff4f9d1$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        return "'v " + $211946f3dff4f9d1$var$accusativeWeekdays[day] + " o' p";
    },
    other: "P"
};
const $211946f3dff4f9d1$var$formatRelative = (token, date)=>{
    const format = $211946f3dff4f9d1$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$211946f3dff4f9d1$export$8fbbfd65594f46a0 = $211946f3dff4f9d1$var$formatRelative;

});

parcelRegister("dpilp", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $9c2bd6f18c1014e2$export$b3bd0bc58e36cd63; }, function (v) { return $9c2bd6f18c1014e2$export$b3bd0bc58e36cd63 = v; });
var $9c2bd6f18c1014e2$export$b3bd0bc58e36cd63;
"use strict";
$9c2bd6f18c1014e2$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $9c2bd6f18c1014e2$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        "n. l."
    ],
    abbreviated: [
        "p\u0159. n. l.",
        "n. l."
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
const $9c2bd6f18c1014e2$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
const $9c2bd6f18c1014e2$var$monthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "leden",
        "\xfanor",
        "b\u0159ezen",
        "duben",
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        "srpen",
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        "listopad",
        "prosinec"
    ]
};
const $9c2bd6f18c1014e2$var$formattingMonthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "ledna",
        "\xfanora",
        "b\u0159ezna",
        "dubna",
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        "srpna",
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        "listopadu",
        "prosince"
    ]
};
const $9c2bd6f18c1014e2$var$dayValues = {
    narrow: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    short: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    abbreviated: [
        "ned",
        "pon",
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        "sob"
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        "sobota"
    ]
};
const $9c2bd6f18c1014e2$var$dayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $9c2bd6f18c1014e2$var$formattingDayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $9c2bd6f18c1014e2$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $9c2bd6f18c1014e2$var$localize = $9c2bd6f18c1014e2$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9c2bd6f18c1014e2$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $9c2bd6f18c1014e2$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $9c2bd6f18c1014e2$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $9c2bd6f18c1014e2$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $9c2bd6f18c1014e2$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $9c2bd6f18c1014e2$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $9c2bd6f18c1014e2$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9c2bd6f18c1014e2$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("1DMIa", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $131f38045bcf1fa3$export$4659b591c19bdf3d; }, function (v) { return $131f38045bcf1fa3$export$4659b591c19bdf3d = v; });
var $131f38045bcf1fa3$export$4659b591c19bdf3d;
"use strict";
$131f38045bcf1fa3$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $131f38045bcf1fa3$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $131f38045bcf1fa3$var$parseOrdinalNumberPattern = /\d+/i;
const $131f38045bcf1fa3$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
const $131f38045bcf1fa3$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
const $131f38045bcf1fa3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
const $131f38045bcf1fa3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $131f38045bcf1fa3$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
const $131f38045bcf1fa3$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
const $131f38045bcf1fa3$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
const $131f38045bcf1fa3$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
const $131f38045bcf1fa3$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
const $131f38045bcf1fa3$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
const $131f38045bcf1fa3$var$match = $131f38045bcf1fa3$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $131f38045bcf1fa3$var$matchOrdinalNumberPattern,
        parsePattern: $131f38045bcf1fa3$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $131f38045bcf1fa3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $131f38045bcf1fa3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $131f38045bcf1fa3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $131f38045bcf1fa3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $131f38045bcf1fa3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $131f38045bcf1fa3$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $131f38045bcf1fa3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $131f38045bcf1fa3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $131f38045bcf1fa3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $131f38045bcf1fa3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("i1Rhb", function(module, exports) {

$parcel$export(module.exports, "cy", function () { return $d201a5846a3a9355$export$aea64bc1b6f8f415; }, function (v) { return $d201a5846a3a9355$export$aea64bc1b6f8f415 = v; });
var $d201a5846a3a9355$export$aea64bc1b6f8f415;
"use strict";
$d201a5846a3a9355$export$aea64bc1b6f8f415 = void 0;

var $hBous = parcelRequire("hBous");

var $88sWC = parcelRequire("88sWC");

var $hZ3oA = parcelRequire("hZ3oA");

var $95DdT = parcelRequire("95DdT");

var $7rWTK = parcelRequire("7rWTK");
/**
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo](https://github.com/elmomalmo)
 */ const $d201a5846a3a9355$var$cy = $d201a5846a3a9355$export$aea64bc1b6f8f415 = {
    code: "cy",
    formatDistance: $hBous.formatDistance,
    formatLong: $88sWC.formatLong,
    formatRelative: $hZ3oA.formatRelative,
    localize: $95DdT.localize,
    match: $7rWTK.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("hBous", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $cd08e3a48af12efa$export$2c14ff85d6318973; }, function (v) { return $cd08e3a48af12efa$export$2c14ff85d6318973 = v; });
var $cd08e3a48af12efa$export$2c14ff85d6318973;
"use strict";
$cd08e3a48af12efa$export$2c14ff85d6318973 = void 0;
const $cd08e3a48af12efa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "llai na eiliad",
        other: "llai na {{count}} eiliad"
    },
    xSeconds: {
        one: "1 eiliad",
        other: "{{count}} eiliad"
    },
    halfAMinute: "hanner munud",
    lessThanXMinutes: {
        one: "llai na munud",
        two: "llai na 2 funud",
        other: "llai na {{count}} munud"
    },
    xMinutes: {
        one: "1 munud",
        two: "2 funud",
        other: "{{count}} munud"
    },
    aboutXHours: {
        one: "tua 1 awr",
        other: "tua {{count}} awr"
    },
    xHours: {
        one: "1 awr",
        other: "{{count}} awr"
    },
    xDays: {
        one: "1 diwrnod",
        two: "2 ddiwrnod",
        other: "{{count}} diwrnod"
    },
    aboutXWeeks: {
        one: "tua 1 wythnos",
        two: "tua pythefnos",
        other: "tua {{count}} wythnos"
    },
    xWeeks: {
        one: "1 wythnos",
        two: "pythefnos",
        other: "{{count}} wythnos"
    },
    aboutXMonths: {
        one: "tua 1 mis",
        two: "tua 2 fis",
        other: "tua {{count}} mis"
    },
    xMonths: {
        one: "1 mis",
        two: "2 fis",
        other: "{{count}} mis"
    },
    aboutXYears: {
        one: "tua 1 flwyddyn",
        two: "tua 2 flynedd",
        other: "tua {{count}} mlynedd"
    },
    xYears: {
        one: "1 flwyddyn",
        two: "2 flynedd",
        other: "{{count}} mlynedd"
    },
    overXYears: {
        one: "dros 1 flwyddyn",
        two: "dros 2 flynedd",
        other: "dros {{count}} mlynedd"
    },
    almostXYears: {
        one: "bron 1 flwyddyn",
        two: "bron 2 flynedd",
        other: "bron {{count}} mlynedd"
    }
};
const $cd08e3a48af12efa$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $cd08e3a48af12efa$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "mewn " + result;
        else return result + " yn \xf4l";
    }
    return result;
};
$cd08e3a48af12efa$export$2c14ff85d6318973 = $cd08e3a48af12efa$var$formatDistance;

});

parcelRegister("88sWC", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $5ec585d4bf16aa45$export$cbf60ecb96cbb82f; }, function (v) { return $5ec585d4bf16aa45$export$cbf60ecb96cbb82f = v; });
var $5ec585d4bf16aa45$export$cbf60ecb96cbb82f;
"use strict";
$5ec585d4bf16aa45$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $5ec585d4bf16aa45$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $5ec585d4bf16aa45$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $5ec585d4bf16aa45$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $5ec585d4bf16aa45$var$formatLong = $5ec585d4bf16aa45$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $5ec585d4bf16aa45$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $5ec585d4bf16aa45$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $5ec585d4bf16aa45$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("hZ3oA", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $d17ac47717aef7be$export$8fbbfd65594f46a0; }, function (v) { return $d17ac47717aef7be$export$8fbbfd65594f46a0 = v; });
var $d17ac47717aef7be$export$8fbbfd65594f46a0;
"use strict";
$d17ac47717aef7be$export$8fbbfd65594f46a0 = void 0;
const $d17ac47717aef7be$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: "P"
};
const $d17ac47717aef7be$var$formatRelative = (token, _date, _baseDate, _options)=>$d17ac47717aef7be$var$formatRelativeLocale[token];
$d17ac47717aef7be$export$8fbbfd65594f46a0 = $d17ac47717aef7be$var$formatRelative;

});

parcelRegister("95DdT", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $69e301978c302aa5$export$b3bd0bc58e36cd63; }, function (v) { return $69e301978c302aa5$export$b3bd0bc58e36cd63 = v; });
var $69e301978c302aa5$export$b3bd0bc58e36cd63;
"use strict";
$69e301978c302aa5$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $69e301978c302aa5$var$eraValues = {
    narrow: [
        "C",
        "O"
    ],
    abbreviated: [
        "CC",
        "OC"
    ],
    wide: [
        "Cyn Crist",
        "Ar \xf4l Crist"
    ]
};
const $69e301978c302aa5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Ch1",
        "Ch2",
        "Ch3",
        "Ch4"
    ],
    wide: [
        "Chwarter 1af",
        "2ail chwarter",
        "3ydd chwarter",
        "4ydd chwarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $69e301978c302aa5$var$monthValues = {
    narrow: [
        "I",
        "Ch",
        "Ma",
        "E",
        "Mi",
        "Me",
        "G",
        "A",
        "Md",
        "H",
        "T",
        "Rh"
    ],
    abbreviated: [
        "Ion",
        "Chwe",
        "Maw",
        "Ebr",
        "Mai",
        "Meh",
        "Gor",
        "Aws",
        "Med",
        "Hyd",
        "Tach",
        "Rhag"
    ],
    wide: [
        "Ionawr",
        "Chwefror",
        "Mawrth",
        "Ebrill",
        "Mai",
        "Mehefin",
        "Gorffennaf",
        "Awst",
        "Medi",
        "Hydref",
        "Tachwedd",
        "Rhagfyr"
    ]
};
const $69e301978c302aa5$var$dayValues = {
    narrow: [
        "S",
        "Ll",
        "M",
        "M",
        "I",
        "G",
        "S"
    ],
    short: [
        "Su",
        "Ll",
        "Ma",
        "Me",
        "Ia",
        "Gw",
        "Sa"
    ],
    abbreviated: [
        "Sul",
        "Llun",
        "Maw",
        "Mer",
        "Iau",
        "Gwe",
        "Sad"
    ],
    wide: [
        "dydd Sul",
        "dydd Llun",
        "dydd Mawrth",
        "dydd Mercher",
        "dydd Iau",
        "dydd Gwener",
        "dydd Sadwrn"
    ]
};
const $69e301978c302aa5$var$dayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    }
};
const $69e301978c302aa5$var$formattingDayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    }
};
const $69e301978c302aa5$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + "fed";
        case 1:
            return number + "af";
        case 2:
            return number + "ail";
        case 3:
        case 4:
            return number + "ydd";
        case 5:
        case 6:
            return number + "ed";
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + "fed";
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + "eg";
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + "fed";
    return number + "ain";
};
const $69e301978c302aa5$var$localize = $69e301978c302aa5$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $69e301978c302aa5$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $69e301978c302aa5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $69e301978c302aa5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $69e301978c302aa5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $69e301978c302aa5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $69e301978c302aa5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $69e301978c302aa5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7rWTK", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $56c8bdf41b816c88$export$4659b591c19bdf3d; }, function (v) { return $56c8bdf41b816c88$export$4659b591c19bdf3d = v; });
var $56c8bdf41b816c88$export$4659b591c19bdf3d;
"use strict";
$56c8bdf41b816c88$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $56c8bdf41b816c88$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
const $56c8bdf41b816c88$var$parseOrdinalNumberPattern = /\d+/i;
const $56c8bdf41b816c88$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
const $56c8bdf41b816c88$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
const $56c8bdf41b816c88$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
const $56c8bdf41b816c88$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $56c8bdf41b816c88$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
const $56c8bdf41b816c88$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
const $56c8bdf41b816c88$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
const $56c8bdf41b816c88$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
const $56c8bdf41b816c88$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
const $56c8bdf41b816c88$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
const $56c8bdf41b816c88$var$match = $56c8bdf41b816c88$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $56c8bdf41b816c88$var$matchOrdinalNumberPattern,
        parsePattern: $56c8bdf41b816c88$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $56c8bdf41b816c88$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56c8bdf41b816c88$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $56c8bdf41b816c88$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56c8bdf41b816c88$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $56c8bdf41b816c88$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56c8bdf41b816c88$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $56c8bdf41b816c88$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56c8bdf41b816c88$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $56c8bdf41b816c88$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $56c8bdf41b816c88$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("5iJL4", function(module, exports) {

$parcel$export(module.exports, "da", function () { return $3dc220d6f80220db$export$8c8450b83b664ba4; }, function (v) { return $3dc220d6f80220db$export$8c8450b83b664ba4 = v; });
var $3dc220d6f80220db$export$8c8450b83b664ba4;
"use strict";
$3dc220d6f80220db$export$8c8450b83b664ba4 = void 0;

var $cm5GM = parcelRequire("cm5GM");

var $ib4Ac = parcelRequire("ib4Ac");

var $7Punj = parcelRequire("7Punj");

var $hplQH = parcelRequire("hplQH");

var $fexr1 = parcelRequire("fexr1");
/**
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg](https://github.com/MathiasKandelborg)
 * @author Anders B. Hansen [@Andersbiha](https://github.com/Andersbiha)
 * @author [@kgram](https://github.com/kgram)
 * @author [@stefanbugge](https://github.com/stefanbugge)
 */ const $3dc220d6f80220db$var$da = $3dc220d6f80220db$export$8c8450b83b664ba4 = {
    code: "da",
    formatDistance: $cm5GM.formatDistance,
    formatLong: $ib4Ac.formatLong,
    formatRelative: $7Punj.formatRelative,
    localize: $hplQH.localize,
    match: $fexr1.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("cm5GM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $8febf3ce4cd65ecc$export$2c14ff85d6318973; }, function (v) { return $8febf3ce4cd65ecc$export$2c14ff85d6318973 = v; });
var $8febf3ce4cd65ecc$export$2c14ff85d6318973;
"use strict";
$8febf3ce4cd65ecc$export$2c14ff85d6318973 = void 0;
const $8febf3ce4cd65ecc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: "mindre end {{count}} minutter"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "cirka 1 time",
        other: "cirka {{count}} timer"
    },
    xHours: {
        one: "1 time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dage"
    },
    aboutXWeeks: {
        one: "cirka 1 uge",
        other: "cirka {{count}} uger"
    },
    xWeeks: {
        one: "1 uge",
        other: "{{count}} uger"
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
const $8febf3ce4cd65ecc$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $8febf3ce4cd65ecc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
$8febf3ce4cd65ecc$export$2c14ff85d6318973 = $8febf3ce4cd65ecc$var$formatDistance;

});

parcelRegister("ib4Ac", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d3bccf24cfdca4dc$export$cbf60ecb96cbb82f; }, function (v) { return $d3bccf24cfdca4dc$export$cbf60ecb96cbb82f = v; });
var $d3bccf24cfdca4dc$export$cbf60ecb96cbb82f;
"use strict";
$d3bccf24cfdca4dc$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $d3bccf24cfdca4dc$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
};
const $d3bccf24cfdca4dc$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $d3bccf24cfdca4dc$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $d3bccf24cfdca4dc$var$formatLong = $d3bccf24cfdca4dc$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $d3bccf24cfdca4dc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $d3bccf24cfdca4dc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $d3bccf24cfdca4dc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("7Punj", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $5b34dba79056e87e$export$8fbbfd65594f46a0; }, function (v) { return $5b34dba79056e87e$export$8fbbfd65594f46a0 = v; });
var $5b34dba79056e87e$export$8fbbfd65594f46a0;
"use strict";
$5b34dba79056e87e$export$8fbbfd65594f46a0 = void 0;
const $5b34dba79056e87e$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: "P"
};
const $5b34dba79056e87e$var$formatRelative = (token, _date, _baseDate, _options)=>$5b34dba79056e87e$var$formatRelativeLocale[token];
$5b34dba79056e87e$export$8fbbfd65594f46a0 = $5b34dba79056e87e$var$formatRelative;

});

parcelRegister("hplQH", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $cac5b83b6c4f27d4$export$b3bd0bc58e36cd63; }, function (v) { return $cac5b83b6c4f27d4$export$b3bd0bc58e36cd63 = v; });
var $cac5b83b6c4f27d4$export$b3bd0bc58e36cd63;
"use strict";
$cac5b83b6c4f27d4$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $cac5b83b6c4f27d4$var$eraValues = {
    narrow: [
        "fvt",
        "vt"
    ],
    abbreviated: [
        "f.v.t.",
        "v.t."
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        "vesterlandsk tidsregning"
    ]
};
const $cac5b83b6c4f27d4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. kvt.",
        "2. kvt.",
        "3. kvt.",
        "4. kvt."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $cac5b83b6c4f27d4$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marts",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
const $cac5b83b6c4f27d4$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        "man.",
        "tir.",
        "ons.",
        "tor.",
        "fre.",
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
const $cac5b83b6c4f27d4$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    }
};
const $cac5b83b6c4f27d4$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    }
};
const $cac5b83b6c4f27d4$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $cac5b83b6c4f27d4$var$localize = $cac5b83b6c4f27d4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $cac5b83b6c4f27d4$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $cac5b83b6c4f27d4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $cac5b83b6c4f27d4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $cac5b83b6c4f27d4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $cac5b83b6c4f27d4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $cac5b83b6c4f27d4$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $cac5b83b6c4f27d4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("fexr1", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $b172194619a9e79d$export$4659b591c19bdf3d; }, function (v) { return $b172194619a9e79d$export$4659b591c19bdf3d = v; });
var $b172194619a9e79d$export$4659b591c19bdf3d;
"use strict";
$b172194619a9e79d$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $b172194619a9e79d$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $b172194619a9e79d$var$parseOrdinalNumberPattern = /\d+/i;
const $b172194619a9e79d$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
const $b172194619a9e79d$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
const $b172194619a9e79d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
const $b172194619a9e79d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $b172194619a9e79d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
const $b172194619a9e79d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $b172194619a9e79d$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
const $b172194619a9e79d$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $b172194619a9e79d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
const $b172194619a9e79d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
const $b172194619a9e79d$var$match = $b172194619a9e79d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $b172194619a9e79d$var$matchOrdinalNumberPattern,
        parsePattern: $b172194619a9e79d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b172194619a9e79d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b172194619a9e79d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b172194619a9e79d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b172194619a9e79d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b172194619a9e79d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b172194619a9e79d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b172194619a9e79d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b172194619a9e79d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b172194619a9e79d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b172194619a9e79d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("hPkgR", function(module, exports) {

$parcel$export(module.exports, "de", function () { return $cfa6ec7ba65ddb8d$export$2fa162a495d26869; }, function (v) { return $cfa6ec7ba65ddb8d$export$2fa162a495d26869 = v; });
var $cfa6ec7ba65ddb8d$export$2fa162a495d26869;
"use strict";
$cfa6ec7ba65ddb8d$export$2fa162a495d26869 = void 0;

var $7eKU9 = parcelRequire("7eKU9");

var $i1S5Y = parcelRequire("i1S5Y");

var $lKNM7 = parcelRequire("lKNM7");

var $1geGY = parcelRequire("1geGY");

var $7SKbZ = parcelRequire("7SKbZ");
/**
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Asia [@asia-t](https://github.com/asia-t)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author RomanErnst [@pex](https://github.com/pex)
 * @author Philipp Keck [@Philipp91](https://github.com/Philipp91)
 */ const $cfa6ec7ba65ddb8d$var$de = $cfa6ec7ba65ddb8d$export$2fa162a495d26869 = {
    code: "de",
    formatDistance: $7eKU9.formatDistance,
    formatLong: $i1S5Y.formatLong,
    formatRelative: $lKNM7.formatRelative,
    localize: $1geGY.localize,
    match: $7SKbZ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("7eKU9", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $544e397f61c917f9$export$2c14ff85d6318973; }, function (v) { return $544e397f61c917f9$export$2c14ff85d6318973 = v; });
var $544e397f61c917f9$export$2c14ff85d6318973;
"use strict";
$544e397f61c917f9$export$2c14ff85d6318973 = void 0;
const $544e397f61c917f9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        }
    },
    xSeconds: {
        standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        },
        withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        }
    },
    halfAMinute: {
        standalone: "eine halbe Minute",
        withPreposition: "einer halben Minute"
    },
    lessThanXMinutes: {
        standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        }
    },
    xMinutes: {
        standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        },
        withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        },
        withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        }
    },
    xHours: {
        standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        },
        withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        }
    },
    xDays: {
        standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
        },
        withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        },
        withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
        },
        withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
        }
    },
    xMonths: {
        standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
        },
        withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
        }
    },
    aboutXYears: {
        standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
        },
        withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
        }
    },
    xYears: {
        standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
        },
        withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
        }
    },
    overXYears: {
        standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
        }
    },
    almostXYears: {
        standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
        },
        withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
        }
    }
};
const $544e397f61c917f9$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = options?.addSuffix ? $544e397f61c917f9$var$formatDistanceLocale[token].withPreposition : $544e397f61c917f9$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return "vor " + result;
    }
    return result;
};
$544e397f61c917f9$export$2c14ff85d6318973 = $544e397f61c917f9$var$formatDistance;

});

parcelRegister("i1S5Y", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d20248371ac84e90$export$cbf60ecb96cbb82f; }, function (v) { return $d20248371ac84e90$export$cbf60ecb96cbb82f = v; });
var $d20248371ac84e90$export$cbf60ecb96cbb82f;
"use strict";
$d20248371ac84e90$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const $d20248371ac84e90$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $d20248371ac84e90$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $d20248371ac84e90$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $d20248371ac84e90$var$formatLong = $d20248371ac84e90$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $d20248371ac84e90$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $d20248371ac84e90$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $d20248371ac84e90$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("lKNM7", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $fd648122b182c52d$export$8fbbfd65594f46a0; }, function (v) { return $fd648122b182c52d$export$8fbbfd65594f46a0 = v; });
var $fd648122b182c52d$export$8fbbfd65594f46a0;
"use strict";
$fd648122b182c52d$export$8fbbfd65594f46a0 = void 0;
const $fd648122b182c52d$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
const $fd648122b182c52d$var$formatRelative = (token, _date, _baseDate, _options)=>$fd648122b182c52d$var$formatRelativeLocale[token];
$fd648122b182c52d$export$8fbbfd65594f46a0 = $fd648122b182c52d$var$formatRelative;

});

parcelRegister("1geGY", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0eb2ae9f0ded22db$export$b3bd0bc58e36cd63; }, function (v) { return $0eb2ae9f0ded22db$export$b3bd0bc58e36cd63 = v; });
var $0eb2ae9f0ded22db$export$b3bd0bc58e36cd63;
"use strict";
$0eb2ae9f0ded22db$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $0eb2ae9f0ded22db$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
const $0eb2ae9f0ded22db$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $0eb2ae9f0ded22db$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const $0eb2ae9f0ded22db$var$formattingMonthValues = {
    narrow: $0eb2ae9f0ded22db$var$monthValues.narrow,
    abbreviated: [
        "Jan.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $0eb2ae9f0ded22db$var$monthValues.wide
};
const $0eb2ae9f0ded22db$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const $0eb2ae9f0ded22db$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
const $0eb2ae9f0ded22db$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
const $0eb2ae9f0ded22db$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $0eb2ae9f0ded22db$var$localize = $0eb2ae9f0ded22db$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0eb2ae9f0ded22db$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $0eb2ae9f0ded22db$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $0eb2ae9f0ded22db$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $0eb2ae9f0ded22db$var$monthValues,
        formattingValues: $0eb2ae9f0ded22db$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $0eb2ae9f0ded22db$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $0eb2ae9f0ded22db$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0eb2ae9f0ded22db$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7SKbZ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5bd16862d2342036$export$4659b591c19bdf3d; }, function (v) { return $5bd16862d2342036$export$4659b591c19bdf3d = v; });
var $5bd16862d2342036$export$4659b591c19bdf3d;
"use strict";
$5bd16862d2342036$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $5bd16862d2342036$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $5bd16862d2342036$var$parseOrdinalNumberPattern = /\d+/i;
const $5bd16862d2342036$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
const $5bd16862d2342036$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
const $5bd16862d2342036$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
const $5bd16862d2342036$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $5bd16862d2342036$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
const $5bd16862d2342036$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $5bd16862d2342036$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
const $5bd16862d2342036$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
const $5bd16862d2342036$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
const $5bd16862d2342036$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        evening: /abends/i,
        night: /nachts/i
    }
};
const $5bd16862d2342036$var$match = $5bd16862d2342036$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $5bd16862d2342036$var$matchOrdinalNumberPattern,
        parsePattern: $5bd16862d2342036$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bd16862d2342036$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bd16862d2342036$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bd16862d2342036$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bd16862d2342036$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bd16862d2342036$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bd16862d2342036$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bd16862d2342036$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bd16862d2342036$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bd16862d2342036$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bd16862d2342036$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8Tqxg", function(module, exports) {

$parcel$export(module.exports, "deAT", function () { return $67980b2aac214b0c$export$4de28f36c5657e35; }, function (v) { return $67980b2aac214b0c$export$4de28f36c5657e35 = v; });
var $67980b2aac214b0c$export$4de28f36c5657e35;
"use strict";
$67980b2aac214b0c$export$4de28f36c5657e35 = void 0;

var $7eKU9 = parcelRequire("7eKU9");

var $i1S5Y = parcelRequire("i1S5Y");

var $lKNM7 = parcelRequire("lKNM7");

var $7SKbZ = parcelRequire("7SKbZ");

var $7Tl65 = parcelRequire("7Tl65");
/**
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein](https://github.com/cstenglein)
 */ const $67980b2aac214b0c$var$deAT = $67980b2aac214b0c$export$4de28f36c5657e35 = {
    code: "de-AT",
    formatDistance: $7eKU9.formatDistance,
    formatLong: $i1S5Y.formatLong,
    formatRelative: $lKNM7.formatRelative,
    localize: $7Tl65.localize,
    match: $7SKbZ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("7Tl65", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $5bee08efee216056$export$b3bd0bc58e36cd63; }, function (v) { return $5bee08efee216056$export$b3bd0bc58e36cd63 = v; });
var $5bee08efee216056$export$b3bd0bc58e36cd63;
"use strict";
$5bee08efee216056$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $5bee08efee216056$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
const $5bee08efee216056$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $5bee08efee216056$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "J\xe4n",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "J\xe4nner",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
const $5bee08efee216056$var$formattingMonthValues = {
    narrow: $5bee08efee216056$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $5bee08efee216056$var$monthValues.wide
};
const $5bee08efee216056$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const $5bee08efee216056$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
const $5bee08efee216056$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
const $5bee08efee216056$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $5bee08efee216056$var$localize = $5bee08efee216056$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $5bee08efee216056$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $5bee08efee216056$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $5bee08efee216056$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $5bee08efee216056$var$monthValues,
        formattingValues: $5bee08efee216056$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $5bee08efee216056$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $5bee08efee216056$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5bee08efee216056$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});


parcelRegister("3nJmE", function(module, exports) {

$parcel$export(module.exports, "el", function () { return $2766b57b70f89a2b$export$c3da0dad1b44eea9; }, function (v) { return $2766b57b70f89a2b$export$c3da0dad1b44eea9 = v; });
var $2766b57b70f89a2b$export$c3da0dad1b44eea9;
"use strict";
$2766b57b70f89a2b$export$c3da0dad1b44eea9 = void 0;

var $hFbTB = parcelRequire("hFbTB");

var $aG6UT = parcelRequire("aG6UT");

var $lE4Oh = parcelRequire("lE4Oh");

var $hHOIW = parcelRequire("hHOIW");

var $6bOjY = parcelRequire("6bOjY");
/**
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk](https://github.com/fanixk)
 * @author Theodoros Orfanidis [@teoulas](https://github.com/teoulas)
 */ const $2766b57b70f89a2b$var$el = $2766b57b70f89a2b$export$c3da0dad1b44eea9 = {
    code: "el",
    formatDistance: $hFbTB.formatDistance,
    formatLong: $aG6UT.formatLong,
    formatRelative: $lE4Oh.formatRelative,
    localize: $hHOIW.localize,
    match: $6bOjY.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("hFbTB", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $cdbf7e4615abbaf3$export$2c14ff85d6318973; }, function (v) { return $cdbf7e4615abbaf3$export$2c14ff85d6318973 = v; });
var $cdbf7e4615abbaf3$export$2c14ff85d6318973;
"use strict";
$cdbf7e4615abbaf3$export$2c14ff85d6318973 = void 0;
const $cdbf7e4615abbaf3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
const $cdbf7e4615abbaf3$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $cdbf7e4615abbaf3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
$cdbf7e4615abbaf3$export$2c14ff85d6318973 = $cdbf7e4615abbaf3$var$formatDistance;

});

parcelRegister("aG6UT", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $7c633125f52ddb83$export$cbf60ecb96cbb82f; }, function (v) { return $7c633125f52ddb83$export$cbf60ecb96cbb82f = v; });
var $7c633125f52ddb83$export$cbf60ecb96cbb82f;
"use strict";
$7c633125f52ddb83$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $7c633125f52ddb83$var$dateFormats = {
    full: "EEEE, d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "d/M/yy"
};
const $7c633125f52ddb83$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $7c633125f52ddb83$var$dateTimeFormats = {
    full: "{{date}} - {{time}}",
    long: "{{date}} - {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $7c633125f52ddb83$var$formatLong = $7c633125f52ddb83$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $7c633125f52ddb83$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $7c633125f52ddb83$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $7c633125f52ddb83$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("lE4Oh", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $fc21108d5a1a8cb1$export$8fbbfd65594f46a0; }, function (v) { return $fc21108d5a1a8cb1$export$8fbbfd65594f46a0 = v; });
var $fc21108d5a1a8cb1$export$8fbbfd65594f46a0;
"use strict";
$fc21108d5a1a8cb1$export$8fbbfd65594f46a0 = void 0;
const $fc21108d5a1a8cb1$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 6:
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: "P"
};
const $fc21108d5a1a8cb1$var$formatRelative = (token, date)=>{
    const format = $fc21108d5a1a8cb1$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$fc21108d5a1a8cb1$export$8fbbfd65594f46a0 = $fc21108d5a1a8cb1$var$formatRelative;

});

parcelRegister("hHOIW", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $ce3dcc857def24b7$export$b3bd0bc58e36cd63; }, function (v) { return $ce3dcc857def24b7$export$b3bd0bc58e36cd63 = v; });
var $ce3dcc857def24b7$export$b3bd0bc58e36cd63;
"use strict";
$ce3dcc857def24b7$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $ce3dcc857def24b7$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
const $ce3dcc857def24b7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
const $ce3dcc857def24b7$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
const $ce3dcc857def24b7$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
const $ce3dcc857def24b7$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        "T",
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
const $ce3dcc857def24b7$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
const $ce3dcc857def24b7$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let suffix;
    if (unit === "year" || unit === "month") suffix = "\u03BF\u03C2";
    else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
const $ce3dcc857def24b7$var$localize = $ce3dcc857def24b7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ce3dcc857def24b7$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $ce3dcc857def24b7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $ce3dcc857def24b7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $ce3dcc857def24b7$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $ce3dcc857def24b7$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $ce3dcc857def24b7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $ce3dcc857def24b7$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("6bOjY", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $481acdea94427d72$export$4659b591c19bdf3d; }, function (v) { return $481acdea94427d72$export$4659b591c19bdf3d = v; });
var $481acdea94427d72$export$4659b591c19bdf3d;
"use strict";
$481acdea94427d72$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $481acdea94427d72$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
const $481acdea94427d72$var$parseOrdinalNumberPattern = /\d+/i;
const $481acdea94427d72$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
const $481acdea94427d72$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
const $481acdea94427d72$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
const $481acdea94427d72$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $481acdea94427d72$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
const $481acdea94427d72$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
const $481acdea94427d72$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
const $481acdea94427d72$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
const $481acdea94427d72$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
const $481acdea94427d72$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
const $481acdea94427d72$var$match = $481acdea94427d72$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $481acdea94427d72$var$matchOrdinalNumberPattern,
        parsePattern: $481acdea94427d72$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $481acdea94427d72$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $481acdea94427d72$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $481acdea94427d72$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $481acdea94427d72$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $481acdea94427d72$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $481acdea94427d72$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $481acdea94427d72$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $481acdea94427d72$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $481acdea94427d72$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $481acdea94427d72$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("1lIM8", function(module, exports) {

$parcel$export(module.exports, "enAU", function () { return $0fba7c0bf4b2b8c8$export$6f7b98a3ca24eeee; }, function (v) { return $0fba7c0bf4b2b8c8$export$6f7b98a3ca24eeee = v; });
var $0fba7c0bf4b2b8c8$export$6f7b98a3ca24eeee;
"use strict";
$0fba7c0bf4b2b8c8$export$6f7b98a3ca24eeee = void 0;

var $gpMTW = parcelRequire("gpMTW");

var $iiVpu = parcelRequire("iiVpu");

var $kPVTI = parcelRequire("kPVTI");

var $5cAjV = parcelRequire("5cAjV");

var $5bbRl = parcelRequire("5bbRl");
/**
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige](https://github.com/JulienMalige)
 */ const $0fba7c0bf4b2b8c8$var$enAU = $0fba7c0bf4b2b8c8$export$6f7b98a3ca24eeee = {
    code: "en-AU",
    formatDistance: $gpMTW.formatDistance,
    formatLong: $iiVpu.formatLong,
    formatRelative: $kPVTI.formatRelative,
    localize: $5cAjV.localize,
    match: $5bbRl.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("iiVpu", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d53670ea4464127b$export$cbf60ecb96cbb82f; }, function (v) { return $d53670ea4464127b$export$cbf60ecb96cbb82f = v; });
var $d53670ea4464127b$export$cbf60ecb96cbb82f;
"use strict";
$d53670ea4464127b$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $d53670ea4464127b$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $d53670ea4464127b$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $d53670ea4464127b$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $d53670ea4464127b$var$formatLong = $d53670ea4464127b$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $d53670ea4464127b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $d53670ea4464127b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $d53670ea4464127b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("C9iCq", function(module, exports) {

$parcel$export(module.exports, "enCA", function () { return $072ac35f5c2c42cf$export$965481d0ea2ba235; }, function (v) { return $072ac35f5c2c42cf$export$965481d0ea2ba235 = v; });
var $072ac35f5c2c42cf$export$965481d0ea2ba235;
"use strict";
$072ac35f5c2c42cf$export$965481d0ea2ba235 = void 0;

var $kPVTI = parcelRequire("kPVTI");

var $5cAjV = parcelRequire("5cAjV");

var $5bbRl = parcelRequire("5bbRl");

var $dQCc2 = parcelRequire("dQCc2");

var $3dD8p = parcelRequire("3dD8p");
/**
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak](https://github.com/markowsiak)
 * @author Marco Imperatore [@mimperatore](https://github.com/mimperatore)
 */ const $072ac35f5c2c42cf$var$enCA = $072ac35f5c2c42cf$export$965481d0ea2ba235 = {
    code: "en-CA",
    formatDistance: $dQCc2.formatDistance,
    formatLong: $3dD8p.formatLong,
    formatRelative: $kPVTI.formatRelative,
    localize: $5cAjV.localize,
    match: $5bbRl.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("dQCc2", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $a14dc210d7f84fa0$export$2c14ff85d6318973; }, function (v) { return $a14dc210d7f84fa0$export$2c14ff85d6318973 = v; });
var $a14dc210d7f84fa0$export$2c14ff85d6318973;
"use strict";
$a14dc210d7f84fa0$export$2c14ff85d6318973 = void 0;
const $a14dc210d7f84fa0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "a second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "a minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about an hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "an hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "a day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about a week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "a week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about a month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "a month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about a year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "a year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over a year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost a year",
        other: "almost {{count}} years"
    }
};
const $a14dc210d7f84fa0$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $a14dc210d7f84fa0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$a14dc210d7f84fa0$export$2c14ff85d6318973 = $a14dc210d7f84fa0$var$formatDistance;

});

parcelRegister("3dD8p", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $2580f157b5ff4b9b$export$cbf60ecb96cbb82f; }, function (v) { return $2580f157b5ff4b9b$export$cbf60ecb96cbb82f = v; });
var $2580f157b5ff4b9b$export$cbf60ecb96cbb82f;
"use strict";
$2580f157b5ff4b9b$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $2580f157b5ff4b9b$var$dateFormats = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
};
const $2580f157b5ff4b9b$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2580f157b5ff4b9b$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2580f157b5ff4b9b$var$formatLong = $2580f157b5ff4b9b$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $2580f157b5ff4b9b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $2580f157b5ff4b9b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $2580f157b5ff4b9b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("aJXp8", function(module, exports) {

$parcel$export(module.exports, "enGB", function () { return $7d1c2fd831357153$export$1d08ac19b34481d5; }, function (v) { return $7d1c2fd831357153$export$1d08ac19b34481d5 = v; });
var $7d1c2fd831357153$export$1d08ac19b34481d5;
"use strict";
$7d1c2fd831357153$export$1d08ac19b34481d5 = void 0;

var $gpMTW = parcelRequire("gpMTW");

var $kPVTI = parcelRequire("kPVTI");

var $5cAjV = parcelRequire("5cAjV");

var $5bbRl = parcelRequire("5bbRl");

var $3dHRh = parcelRequire("3dHRh");
/**
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik](https://github.com/glintik)
 */ const $7d1c2fd831357153$var$enGB = $7d1c2fd831357153$export$1d08ac19b34481d5 = {
    code: "en-GB",
    formatDistance: $gpMTW.formatDistance,
    formatLong: $3dHRh.formatLong,
    formatRelative: $kPVTI.formatRelative,
    localize: $5cAjV.localize,
    match: $5bbRl.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("3dHRh", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $25849b5422c349dd$export$cbf60ecb96cbb82f; }, function (v) { return $25849b5422c349dd$export$cbf60ecb96cbb82f = v; });
var $25849b5422c349dd$export$cbf60ecb96cbb82f;
"use strict";
$25849b5422c349dd$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $25849b5422c349dd$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $25849b5422c349dd$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $25849b5422c349dd$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $25849b5422c349dd$var$formatLong = $25849b5422c349dd$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $25849b5422c349dd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $25849b5422c349dd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $25849b5422c349dd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("dTOfC", function(module, exports) {

$parcel$export(module.exports, "enIE", function () { return $a1e76433d92d1b96$export$cc1aa062f801d69e; }, function (v) { return $a1e76433d92d1b96$export$cc1aa062f801d69e = v; });
var $a1e76433d92d1b96$export$cc1aa062f801d69e;
"use strict";
$a1e76433d92d1b96$export$cc1aa062f801d69e = void 0;

var $gpMTW = parcelRequire("gpMTW");

var $kPVTI = parcelRequire("kPVTI");

var $5cAjV = parcelRequire("5cAjV");

var $5bbRl = parcelRequire("5bbRl");

var $3dHRh = parcelRequire("3dHRh");
/**
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75](https://github.com/tan75)
 */ const $a1e76433d92d1b96$var$enIE = $a1e76433d92d1b96$export$cc1aa062f801d69e = {
    code: "en-IE",
    formatDistance: $gpMTW.formatDistance,
    formatLong: $3dHRh.formatLong,
    formatRelative: $kPVTI.formatRelative,
    localize: $5cAjV.localize,
    match: $5bbRl.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});

parcelRegister("2Rv61", function(module, exports) {

$parcel$export(module.exports, "enIN", function () { return $2158a709260fda6f$export$c9cb94638a6621e; }, function (v) { return $2158a709260fda6f$export$c9cb94638a6621e = v; });
var $2158a709260fda6f$export$c9cb94638a6621e;
"use strict";
$2158a709260fda6f$export$c9cb94638a6621e = void 0;

var $gpMTW = parcelRequire("gpMTW");

var $kPVTI = parcelRequire("kPVTI");

var $5cAjV = parcelRequire("5cAjV");

var $5bbRl = parcelRequire("5bbRl");

var $WgTiE = parcelRequire("WgTiE");
/**
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha](https://github.com/gbhasha)
 */ const $2158a709260fda6f$var$enIN = $2158a709260fda6f$export$c9cb94638a6621e = {
    code: "en-IN",
    formatDistance: $gpMTW.formatDistance,
    formatLong: $WgTiE.formatLong,
    formatRelative: $kPVTI.formatRelative,
    localize: $5cAjV.localize,
    match: $5bbRl.match,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("WgTiE", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $0af28514e8cd2792$export$cbf60ecb96cbb82f; }, function (v) { return $0af28514e8cd2792$export$cbf60ecb96cbb82f = v; });
var $0af28514e8cd2792$export$cbf60ecb96cbb82f;
"use strict";
$0af28514e8cd2792$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $0af28514e8cd2792$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
};
const $0af28514e8cd2792$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $0af28514e8cd2792$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $0af28514e8cd2792$var$formatLong = $0af28514e8cd2792$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $0af28514e8cd2792$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $0af28514e8cd2792$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $0af28514e8cd2792$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("b3X9W", function(module, exports) {

$parcel$export(module.exports, "enNZ", function () { return $80dddd4f9b905ade$export$2bdafeb919fd632b; }, function (v) { return $80dddd4f9b905ade$export$2bdafeb919fd632b = v; });
var $80dddd4f9b905ade$export$2bdafeb919fd632b;
"use strict";
$80dddd4f9b905ade$export$2bdafeb919fd632b = void 0;

var $gpMTW = parcelRequire("gpMTW");

var $kPVTI = parcelRequire("kPVTI");

var $5cAjV = parcelRequire("5cAjV");

var $5bbRl = parcelRequire("5bbRl");

var $kntDk = parcelRequire("kntDk");
/**
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact](https://github.com/muntact)
 */ const $80dddd4f9b905ade$var$enNZ = $80dddd4f9b905ade$export$2bdafeb919fd632b = {
    code: "en-NZ",
    formatDistance: $gpMTW.formatDistance,
    formatLong: $kntDk.formatLong,
    formatRelative: $kPVTI.formatRelative,
    localize: $5cAjV.localize,
    match: $5bbRl.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("kntDk", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ed5cf12aa72ef574$export$cbf60ecb96cbb82f; }, function (v) { return $ed5cf12aa72ef574$export$cbf60ecb96cbb82f = v; });
var $ed5cf12aa72ef574$export$cbf60ecb96cbb82f;
"use strict";
$ed5cf12aa72ef574$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $ed5cf12aa72ef574$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $ed5cf12aa72ef574$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $ed5cf12aa72ef574$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $ed5cf12aa72ef574$var$formatLong = $ed5cf12aa72ef574$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $ed5cf12aa72ef574$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $ed5cf12aa72ef574$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $ed5cf12aa72ef574$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("9VmyF", function(module, exports) {

$parcel$export(module.exports, "enZA", function () { return $739aef7f711a6a22$export$61b66188632c07cb; }, function (v) { return $739aef7f711a6a22$export$61b66188632c07cb = v; });
var $739aef7f711a6a22$export$61b66188632c07cb;
"use strict";
$739aef7f711a6a22$export$61b66188632c07cb = void 0;

var $gpMTW = parcelRequire("gpMTW");

var $kPVTI = parcelRequire("kPVTI");

var $5cAjV = parcelRequire("5cAjV");

var $5bbRl = parcelRequire("5bbRl");

var $3KChP = parcelRequire("3KChP");
/**
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav](https://github.com/shaykav)
 */ const $739aef7f711a6a22$var$enZA = $739aef7f711a6a22$export$61b66188632c07cb = {
    code: "en-ZA",
    formatDistance: $gpMTW.formatDistance,
    formatLong: $3KChP.formatLong,
    formatRelative: $kPVTI.formatRelative,
    localize: $5cAjV.localize,
    match: $5bbRl.match,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("3KChP", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $2bb35de687b7df7f$export$cbf60ecb96cbb82f; }, function (v) { return $2bb35de687b7df7f$export$cbf60ecb96cbb82f = v; });
var $2bb35de687b7df7f$export$cbf60ecb96cbb82f;
"use strict";
$2bb35de687b7df7f$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $2bb35de687b7df7f$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
};
const $2bb35de687b7df7f$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $2bb35de687b7df7f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2bb35de687b7df7f$var$formatLong = $2bb35de687b7df7f$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $2bb35de687b7df7f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $2bb35de687b7df7f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $2bb35de687b7df7f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("lT55e", function(module, exports) {

$parcel$export(module.exports, "eo", function () { return $fef2ad7deb867ed2$export$9e6f8948b1b2764c; }, function (v) { return $fef2ad7deb867ed2$export$9e6f8948b1b2764c = v; });
var $fef2ad7deb867ed2$export$9e6f8948b1b2764c;
"use strict";
$fef2ad7deb867ed2$export$9e6f8948b1b2764c = void 0;

var $gW7gZ = parcelRequire("gW7gZ");

var $c93dQ = parcelRequire("c93dQ");

var $1fvnN = parcelRequire("1fvnN");

var $9GI1z = parcelRequire("9GI1z");

var $cRu2M = parcelRequire("cRu2M");
/**
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ const $fef2ad7deb867ed2$var$eo = $fef2ad7deb867ed2$export$9e6f8948b1b2764c = {
    code: "eo",
    formatDistance: $gW7gZ.formatDistance,
    formatLong: $c93dQ.formatLong,
    formatRelative: $1fvnN.formatRelative,
    localize: $9GI1z.localize,
    match: $cRu2M.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("gW7gZ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $c547b46469e98f11$export$2c14ff85d6318973; }, function (v) { return $c547b46469e98f11$export$2c14ff85d6318973 = v; });
var $c547b46469e98f11$export$2c14ff85d6318973;
"use strict";
$c547b46469e98f11$export$2c14ff85d6318973 = void 0;
const $c547b46469e98f11$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "malpli ol sekundo",
        other: "malpli ol {{count}} sekundoj"
    },
    xSeconds: {
        one: "1 sekundo",
        other: "{{count}} sekundoj"
    },
    halfAMinute: "duonminuto",
    lessThanXMinutes: {
        one: "malpli ol minuto",
        other: "malpli ol {{count}} minutoj"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutoj"
    },
    aboutXHours: {
        one: "proksimume 1 horo",
        other: "proksimume {{count}} horoj"
    },
    xHours: {
        one: "1 horo",
        other: "{{count}} horoj"
    },
    xDays: {
        one: "1 tago",
        other: "{{count}} tagoj"
    },
    aboutXMonths: {
        one: "proksimume 1 monato",
        other: "proksimume {{count}} monatoj"
    },
    xWeeks: {
        one: "1 semajno",
        other: "{{count}} semajnoj"
    },
    aboutXWeeks: {
        one: "proksimume 1 semajno",
        other: "proksimume {{count}} semajnoj"
    },
    xMonths: {
        one: "1 monato",
        other: "{{count}} monatoj"
    },
    aboutXYears: {
        one: "proksimume 1 jaro",
        other: "proksimume {{count}} jaroj"
    },
    xYears: {
        one: "1 jaro",
        other: "{{count}} jaroj"
    },
    overXYears: {
        one: "pli ol 1 jaro",
        other: "pli ol {{count}} jaroj"
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
const $c547b46469e98f11$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c547b46469e98f11$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options?.comparison && options.comparison > 0) return "post " + result;
        else return "anta\u016D " + result;
    }
    return result;
};
$c547b46469e98f11$export$2c14ff85d6318973 = $c547b46469e98f11$var$formatDistance;

});

parcelRegister("c93dQ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $8d78d32943ee6935$export$cbf60ecb96cbb82f; }, function (v) { return $8d78d32943ee6935$export$cbf60ecb96cbb82f = v; });
var $8d78d32943ee6935$export$cbf60ecb96cbb82f;
"use strict";
$8d78d32943ee6935$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $8d78d32943ee6935$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: "y-MMMM-dd",
    medium: "y-MMM-dd",
    short: "yyyy-MM-dd"
};
const $8d78d32943ee6935$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $8d78d32943ee6935$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $8d78d32943ee6935$var$formatLong = $8d78d32943ee6935$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $8d78d32943ee6935$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $8d78d32943ee6935$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $8d78d32943ee6935$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("1fvnN", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $0e8f891df5c610e1$export$8fbbfd65594f46a0; }, function (v) { return $0e8f891df5c610e1$export$8fbbfd65594f46a0 = v; });
var $0e8f891df5c610e1$export$8fbbfd65594f46a0;
"use strict";
$0e8f891df5c610e1$export$8fbbfd65594f46a0 = void 0;
const $0e8f891df5c610e1$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: "P"
};
const $0e8f891df5c610e1$var$formatRelative = (token, _date, _baseDate, _options)=>$0e8f891df5c610e1$var$formatRelativeLocale[token];
$0e8f891df5c610e1$export$8fbbfd65594f46a0 = $0e8f891df5c610e1$var$formatRelative;

});

parcelRegister("9GI1z", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $70da2f97a838314a$export$b3bd0bc58e36cd63; }, function (v) { return $70da2f97a838314a$export$b3bd0bc58e36cd63 = v; });
var $70da2f97a838314a$export$b3bd0bc58e36cd63;
"use strict";
$70da2f97a838314a$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $70da2f97a838314a$var$eraValues = {
    narrow: [
        "aK",
        "pK"
    ],
    abbreviated: [
        "a.K.E.",
        "p.K.E."
    ],
    wide: [
        "anta\u016D Komuna Erao",
        "Komuna Erao"
    ]
};
const $70da2f97a838314a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1-a kvaronjaro",
        "2-a kvaronjaro",
        "3-a kvaronjaro",
        "4-a kvaronjaro"
    ]
};
const $70da2f97a838314a$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "a\u016Dg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januaro",
        "februaro",
        "marto",
        "aprilo",
        "majo",
        "junio",
        "julio",
        "a\u016Dgusto",
        "septembro",
        "oktobro",
        "novembro",
        "decembro"
    ]
};
const $70da2f97a838314a$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "\u0134",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "\u0135a",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim",
        "lun",
        "mar",
        "mer",
        "\u0135a\u016D",
        "ven",
        "sab"
    ],
    wide: [
        "diman\u0109o",
        "lundo",
        "mardo",
        "merkredo",
        "\u0135a\u016Ddo",
        "vendredo",
        "sabato"
    ]
};
const $70da2f97a838314a$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    abbreviated: {
        am: "a.t.m.",
        pm: "p.t.m.",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: "posttagmeze",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    }
};
const $70da2f97a838314a$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + "-a";
};
const $70da2f97a838314a$var$localize = $70da2f97a838314a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $70da2f97a838314a$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $70da2f97a838314a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $70da2f97a838314a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $70da2f97a838314a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $70da2f97a838314a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $70da2f97a838314a$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("cRu2M", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $95d1bd5922d56819$export$4659b591c19bdf3d; }, function (v) { return $95d1bd5922d56819$export$4659b591c19bdf3d = v; });
var $95d1bd5922d56819$export$4659b591c19bdf3d;
"use strict";
$95d1bd5922d56819$export$4659b591c19bdf3d = void 0;

var $essio = parcelRequire("essio");

var $gZaqQ = parcelRequire("gZaqQ");
const $95d1bd5922d56819$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
const $95d1bd5922d56819$var$parseOrdinalNumberPattern = /\d+/i;
const $95d1bd5922d56819$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
const $95d1bd5922d56819$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
const $95d1bd5922d56819$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
const $95d1bd5922d56819$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $95d1bd5922d56819$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
const $95d1bd5922d56819$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $95d1bd5922d56819$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
const $95d1bd5922d56819$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
const $95d1bd5922d56819$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
const $95d1bd5922d56819$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
const $95d1bd5922d56819$var$match = $95d1bd5922d56819$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $95d1bd5922d56819$var$matchOrdinalNumberPattern,
        parsePattern: $95d1bd5922d56819$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $95d1bd5922d56819$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d1bd5922d56819$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $95d1bd5922d56819$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d1bd5922d56819$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $95d1bd5922d56819$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d1bd5922d56819$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $95d1bd5922d56819$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d1bd5922d56819$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $95d1bd5922d56819$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $95d1bd5922d56819$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("dMzdE", function(module, exports) {

$parcel$export(module.exports, "es", function () { return $a08b13db577cae67$export$ca5e4045a55e76d2; }, function (v) { return $a08b13db577cae67$export$ca5e4045a55e76d2 = v; });
var $a08b13db577cae67$export$ca5e4045a55e76d2;
"use strict";
$a08b13db577cae67$export$ca5e4045a55e76d2 = void 0;

var $baD2H = parcelRequire("baD2H");

var $lw3aP = parcelRequire("lw3aP");

var $eInIO = parcelRequire("eInIO");

var $9LOVS = parcelRequire("9LOVS");

var $g5PP8 = parcelRequire("g5PP8");
/**
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto](https://github.com/juanangosto)
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Fernando Agüero [@fjaguero](https://github.com/fjaguero)
 * @author Gastón Haro [@harogaston](https://github.com/harogaston)
 * @author Yago Carballo [@YagoCarballo](https://github.com/YagoCarballo)
 */ const $a08b13db577cae67$var$es = $a08b13db577cae67$export$ca5e4045a55e76d2 = {
    code: "es",
    formatDistance: $baD2H.formatDistance,
    formatLong: $lw3aP.formatLong,
    formatRelative: $eInIO.formatRelative,
    localize: $9LOVS.localize,
    match: $g5PP8.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("baD2H", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $821ee9efa33724d4$export$2c14ff85d6318973; }, function (v) { return $821ee9efa33724d4$export$2c14ff85d6318973 = v; });
var $821ee9efa33724d4$export$2c14ff85d6318973;
"use strict";
$821ee9efa33724d4$export$2c14ff85d6318973 = void 0;
const $821ee9efa33724d4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
const $821ee9efa33724d4$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $821ee9efa33724d4$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};
$821ee9efa33724d4$export$2c14ff85d6318973 = $821ee9efa33724d4$var$formatDistance;

});

parcelRegister("lw3aP", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $fa9f0c605d311294$export$cbf60ecb96cbb82f; }, function (v) { return $fa9f0c605d311294$export$cbf60ecb96cbb82f = v; });
var $fa9f0c605d311294$export$cbf60ecb96cbb82f;
"use strict";
$fa9f0c605d311294$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $fa9f0c605d311294$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $fa9f0c605d311294$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $fa9f0c605d311294$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $fa9f0c605d311294$var$formatLong = $fa9f0c605d311294$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa9f0c605d311294$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa9f0c605d311294$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa9f0c605d311294$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("eInIO", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ab679364bafff4ef$export$8fbbfd65594f46a0; }, function (v) { return $ab679364bafff4ef$export$8fbbfd65594f46a0 = v; });
var $ab679364bafff4ef$export$8fbbfd65594f46a0;
"use strict";
$ab679364bafff4ef$export$8fbbfd65594f46a0 = void 0;
const $ab679364bafff4ef$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
const $ab679364bafff4ef$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
const $ab679364bafff4ef$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $ab679364bafff4ef$var$formatRelativeLocalePlural[token];
    else return $ab679364bafff4ef$var$formatRelativeLocale[token];
};
$ab679364bafff4ef$export$8fbbfd65594f46a0 = $ab679364bafff4ef$var$formatRelative;

});

parcelRegister("9LOVS", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $71d002ff5eb30b9c$export$b3bd0bc58e36cd63; }, function (v) { return $71d002ff5eb30b9c$export$b3bd0bc58e36cd63 = v; });
var $71d002ff5eb30b9c$export$b3bd0bc58e36cd63;
"use strict";
$71d002ff5eb30b9c$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $71d002ff5eb30b9c$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
const $71d002ff5eb30b9c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $71d002ff5eb30b9c$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
const $71d002ff5eb30b9c$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
const $71d002ff5eb30b9c$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
const $71d002ff5eb30b9c$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
const $71d002ff5eb30b9c$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $71d002ff5eb30b9c$var$localize = $71d002ff5eb30b9c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $71d002ff5eb30b9c$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $71d002ff5eb30b9c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $71d002ff5eb30b9c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $71d002ff5eb30b9c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $71d002ff5eb30b9c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $71d002ff5eb30b9c$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $71d002ff5eb30b9c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("g5PP8", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $bb75501d3efff8e5$export$4659b591c19bdf3d; }, function (v) { return $bb75501d3efff8e5$export$4659b591c19bdf3d = v; });
var $bb75501d3efff8e5$export$4659b591c19bdf3d;
"use strict";
$bb75501d3efff8e5$export$4659b591c19bdf3d = void 0;

var $essio = parcelRequire("essio");

var $gZaqQ = parcelRequire("gZaqQ");
const $bb75501d3efff8e5$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $bb75501d3efff8e5$var$parseOrdinalNumberPattern = /\d+/i;
const $bb75501d3efff8e5$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
const $bb75501d3efff8e5$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
const $bb75501d3efff8e5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $bb75501d3efff8e5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $bb75501d3efff8e5$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
const $bb75501d3efff8e5$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
const $bb75501d3efff8e5$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
const $bb75501d3efff8e5$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
const $bb75501d3efff8e5$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
const $bb75501d3efff8e5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
const $bb75501d3efff8e5$var$match = $bb75501d3efff8e5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $bb75501d3efff8e5$var$matchOrdinalNumberPattern,
        parsePattern: $bb75501d3efff8e5$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bb75501d3efff8e5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb75501d3efff8e5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bb75501d3efff8e5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb75501d3efff8e5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bb75501d3efff8e5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb75501d3efff8e5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bb75501d3efff8e5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb75501d3efff8e5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bb75501d3efff8e5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bb75501d3efff8e5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("imzMG", function(module, exports) {

$parcel$export(module.exports, "et", function () { return $d5e60a14bc8c7061$export$457177dcde8472be; }, function (v) { return $d5e60a14bc8c7061$export$457177dcde8472be = v; });
var $d5e60a14bc8c7061$export$457177dcde8472be;
"use strict";
$d5e60a14bc8c7061$export$457177dcde8472be = void 0;

var $8DQs5 = parcelRequire("8DQs5");

var $84JZZ = parcelRequire("84JZZ");

var $6FocL = parcelRequire("6FocL");

var $d95KY = parcelRequire("d95KY");

var $lyVvo = parcelRequire("lyVvo");
/**
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit](https://github.com/priithansen)
 */ const $d5e60a14bc8c7061$var$et = $d5e60a14bc8c7061$export$457177dcde8472be = {
    code: "et",
    formatDistance: $8DQs5.formatDistance,
    formatLong: $84JZZ.formatLong,
    formatRelative: $6FocL.formatRelative,
    localize: $d95KY.localize,
    match: $lyVvo.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("8DQs5", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $64aaa71beb71a5df$export$2c14ff85d6318973; }, function (v) { return $64aaa71beb71a5df$export$2c14ff85d6318973 = v; });
var $64aaa71beb71a5df$export$2c14ff85d6318973;
"use strict";
$64aaa71beb71a5df$export$2c14ff85d6318973 = void 0;
const $64aaa71beb71a5df$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: "{{count}} sekundit"
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: "{{count}} sekundi"
        }
    },
    halfAMinute: {
        standalone: "pool minutit",
        withPreposition: "poole minuti"
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: "{{count}} minutit"
        },
        withPreposition: {
            one: "\xfche minuti",
            other: "{{count}} minuti"
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: "umbes {{count}} tundi"
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: "umbes {{count}} tunni"
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: "{{count}} tundi"
        },
        withPreposition: {
            one: "\xfche tunni",
            other: "{{count}} tunni"
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: "umbes {{count}} kuud"
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: "umbes {{count}} kuu"
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: "{{count}} kuud"
        },
        withPreposition: {
            one: "\xfche kuu",
            other: "{{count}} kuu"
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: "umbes {{count}} aastat"
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: "umbes {{count}} aasta"
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: "{{count}} aastat"
        },
        withPreposition: {
            one: "\xfche aasta",
            other: "{{count}} aasta"
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: "rohkem kui {{count}} aastat"
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: "rohkem kui {{count}} aasta"
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: "peaaegu {{count}} aastat"
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: "peaaegu {{count}} aasta"
        }
    }
};
const $64aaa71beb71a5df$var$formatDistance = (token, count, options)=>{
    const usageGroup = options?.addSuffix ? $64aaa71beb71a5df$var$formatDistanceLocale[token].withPreposition : $64aaa71beb71a5df$var$formatDistanceLocale[token].standalone;
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + " eest";
    }
    return result;
};
$64aaa71beb71a5df$export$2c14ff85d6318973 = $64aaa71beb71a5df$var$formatDistance;

});

parcelRegister("84JZZ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $5e1260dc806093cc$export$cbf60ecb96cbb82f; }, function (v) { return $5e1260dc806093cc$export$cbf60ecb96cbb82f = v; });
var $5e1260dc806093cc$export$cbf60ecb96cbb82f;
"use strict";
$5e1260dc806093cc$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $5e1260dc806093cc$var$dateFormats = {
    full: "EEEE, d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $5e1260dc806093cc$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $5e1260dc806093cc$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: "{{date}}. {{time}}",
    short: "{{date}}. {{time}}"
};
const $5e1260dc806093cc$var$formatLong = $5e1260dc806093cc$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $5e1260dc806093cc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $5e1260dc806093cc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $5e1260dc806093cc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6FocL", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $4da958fe81240a53$export$8fbbfd65594f46a0; }, function (v) { return $4da958fe81240a53$export$8fbbfd65594f46a0 = v; });
var $4da958fe81240a53$export$8fbbfd65594f46a0;
"use strict";
$4da958fe81240a53$export$8fbbfd65594f46a0 = void 0;
const $4da958fe81240a53$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: "P"
};
const $4da958fe81240a53$var$formatRelative = (token, _date, _baseDate, _options)=>$4da958fe81240a53$var$formatRelativeLocale[token];
$4da958fe81240a53$export$8fbbfd65594f46a0 = $4da958fe81240a53$var$formatRelative;

});

parcelRegister("d95KY", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $992094cb0024810b$export$b3bd0bc58e36cd63; }, function (v) { return $992094cb0024810b$export$b3bd0bc58e36cd63 = v; });
var $992094cb0024810b$export$b3bd0bc58e36cd63;
"use strict";
$992094cb0024810b$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $992094cb0024810b$var$eraValues = {
    narrow: [
        "e.m.a",
        "m.a.j"
    ],
    abbreviated: [
        "e.m.a",
        "m.a.j"
    ],
    wide: [
        "enne meie ajaarvamist",
        "meie ajaarvamise j\xe4rgi"
    ]
};
const $992094cb0024810b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $992094cb0024810b$var$monthValues = {
    narrow: [
        "J",
        "V",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jaan",
        "veebr",
        "m\xe4rts",
        "apr",
        "mai",
        "juuni",
        "juuli",
        "aug",
        "sept",
        "okt",
        "nov",
        "dets"
    ],
    wide: [
        "jaanuar",
        "veebruar",
        "m\xe4rts",
        "aprill",
        "mai",
        "juuni",
        "juuli",
        "august",
        "september",
        "oktoober",
        "november",
        "detsember"
    ]
};
const $992094cb0024810b$var$dayValues = {
    narrow: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    short: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    abbreviated: [
        "p\xfchap.",
        "esmasp.",
        "teisip.",
        "kolmap.",
        "neljap.",
        "reede.",
        "laup."
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        "reede",
        "laup\xe4ev"
    ]
};
const $992094cb0024810b$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
const $992094cb0024810b$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
const $992094cb0024810b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $992094cb0024810b$var$localize = $992094cb0024810b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $992094cb0024810b$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $992094cb0024810b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $992094cb0024810b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $992094cb0024810b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $992094cb0024810b$var$monthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $992094cb0024810b$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $992094cb0024810b$var$dayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $992094cb0024810b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $992094cb0024810b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("lyVvo", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $fb296151a0d337ff$export$4659b591c19bdf3d; }, function (v) { return $fb296151a0d337ff$export$4659b591c19bdf3d = v; });
var $fb296151a0d337ff$export$4659b591c19bdf3d;
"use strict";
$fb296151a0d337ff$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $fb296151a0d337ff$var$matchOrdinalNumberPattern = /^\d+\./i;
const $fb296151a0d337ff$var$parseOrdinalNumberPattern = /\d+/i;
const $fb296151a0d337ff$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
const $fb296151a0d337ff$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
const $fb296151a0d337ff$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $fb296151a0d337ff$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $fb296151a0d337ff$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
const $fb296151a0d337ff$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $fb296151a0d337ff$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
const $fb296151a0d337ff$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
const $fb296151a0d337ff$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
const $fb296151a0d337ff$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
const $fb296151a0d337ff$var$match = $fb296151a0d337ff$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $fb296151a0d337ff$var$matchOrdinalNumberPattern,
        parsePattern: $fb296151a0d337ff$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $fb296151a0d337ff$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fb296151a0d337ff$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $fb296151a0d337ff$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fb296151a0d337ff$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $fb296151a0d337ff$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fb296151a0d337ff$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $fb296151a0d337ff$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fb296151a0d337ff$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $fb296151a0d337ff$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fb296151a0d337ff$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("3x3kp", function(module, exports) {

$parcel$export(module.exports, "eu", function () { return $2927091341515677$export$2f4e8cc3c5ca4de9; }, function (v) { return $2927091341515677$export$2f4e8cc3c5ca4de9 = v; });
var $2927091341515677$export$2f4e8cc3c5ca4de9;
"use strict";
$2927091341515677$export$2f4e8cc3c5ca4de9 = void 0;

var $7b8jr = parcelRequire("7b8jr");

var $XMgnD = parcelRequire("XMgnD");

var $79lwK = parcelRequire("79lwK");

var $j26hh = parcelRequire("j26hh");

var $faFxb = parcelRequire("faFxb");
/**
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom](https://github.com/JacobSoderblom)
 */ const $2927091341515677$var$eu = $2927091341515677$export$2f4e8cc3c5ca4de9 = {
    code: "eu",
    formatDistance: $7b8jr.formatDistance,
    formatLong: $XMgnD.formatLong,
    formatRelative: $79lwK.formatRelative,
    localize: $j26hh.localize,
    match: $faFxb.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("7b8jr", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $53a002364cdbc4b3$export$2c14ff85d6318973; }, function (v) { return $53a002364cdbc4b3$export$2c14ff85d6318973 = v; });
var $53a002364cdbc4b3$export$2c14ff85d6318973;
"use strict";
$53a002364cdbc4b3$export$2c14ff85d6318973 = void 0;
const $53a002364cdbc4b3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "segundo bat baino gutxiago",
        other: "{{count}} segundo baino gutxiago"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundo"
    },
    halfAMinute: "minutu erdi",
    lessThanXMinutes: {
        one: "minutu bat baino gutxiago",
        other: "{{count}} minutu baino gutxiago"
    },
    xMinutes: {
        one: "1 minutu",
        other: "{{count}} minutu"
    },
    aboutXHours: {
        one: "1 ordu gutxi gorabehera",
        other: "{{count}} ordu gutxi gorabehera"
    },
    xHours: {
        one: "1 ordu",
        other: "{{count}} ordu"
    },
    xDays: {
        one: "1 egun",
        other: "{{count}} egun"
    },
    aboutXWeeks: {
        one: "aste 1 inguru",
        other: "{{count}} aste inguru"
    },
    xWeeks: {
        one: "1 aste",
        other: "{{count}} astean"
    },
    aboutXMonths: {
        one: "1 hilabete gutxi gorabehera",
        other: "{{count}} hilabete gutxi gorabehera"
    },
    xMonths: {
        one: "1 hilabete",
        other: "{{count}} hilabete"
    },
    aboutXYears: {
        one: "1 urte gutxi gorabehera",
        other: "{{count}} urte gutxi gorabehera"
    },
    xYears: {
        one: "1 urte",
        other: "{{count}} urte"
    },
    overXYears: {
        one: "1 urte baino gehiago",
        other: "{{count}} urte baino gehiago"
    },
    almostXYears: {
        one: "ia 1 urte",
        other: "ia {{count}} urte"
    }
};
const $53a002364cdbc4b3$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $53a002364cdbc4b3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "duela " + result;
    }
    return result;
};
$53a002364cdbc4b3$export$2c14ff85d6318973 = $53a002364cdbc4b3$var$formatDistance;

});

parcelRegister("XMgnD", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $0b3af2de5dfeba92$export$cbf60ecb96cbb82f; }, function (v) { return $0b3af2de5dfeba92$export$cbf60ecb96cbb82f = v; });
var $0b3af2de5dfeba92$export$cbf60ecb96cbb82f;
"use strict";
$0b3af2de5dfeba92$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $0b3af2de5dfeba92$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: "y MMM d",
    short: "yy/MM/dd"
};
const $0b3af2de5dfeba92$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $0b3af2de5dfeba92$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $0b3af2de5dfeba92$var$formatLong = $0b3af2de5dfeba92$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $0b3af2de5dfeba92$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $0b3af2de5dfeba92$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $0b3af2de5dfeba92$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("79lwK", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $534a127f5aae6c93$export$8fbbfd65594f46a0; }, function (v) { return $534a127f5aae6c93$export$8fbbfd65594f46a0 = v; });
var $534a127f5aae6c93$export$8fbbfd65594f46a0;
"use strict";
$534a127f5aae6c93$export$8fbbfd65594f46a0 = void 0;
const $534a127f5aae6c93$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
const $534a127f5aae6c93$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
const $534a127f5aae6c93$var$formatRelative = (token, date)=>{
    if (date.getHours() !== 1) return $534a127f5aae6c93$var$formatRelativeLocalePlural[token];
    return $534a127f5aae6c93$var$formatRelativeLocale[token];
};
$534a127f5aae6c93$export$8fbbfd65594f46a0 = $534a127f5aae6c93$var$formatRelative;

});

parcelRegister("j26hh", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $ddb312d7c229fa1d$export$b3bd0bc58e36cd63; }, function (v) { return $ddb312d7c229fa1d$export$b3bd0bc58e36cd63 = v; });
var $ddb312d7c229fa1d$export$b3bd0bc58e36cd63;
"use strict";
$ddb312d7c229fa1d$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $ddb312d7c229fa1d$var$eraValues = {
    narrow: [
        "k.a.",
        "k.o."
    ],
    abbreviated: [
        "k.a.",
        "k.o."
    ],
    wide: [
        "kristo aurretik",
        "kristo ondoren"
    ]
};
const $ddb312d7c229fa1d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1H",
        "2H",
        "3H",
        "4H"
    ],
    wide: [
        "1. hiruhilekoa",
        "2. hiruhilekoa",
        "3. hiruhilekoa",
        "4. hiruhilekoa"
    ]
};
const $ddb312d7c229fa1d$var$monthValues = {
    narrow: [
        "u",
        "o",
        "m",
        "a",
        "m",
        "e",
        "u",
        "a",
        "i",
        "u",
        "a",
        "a"
    ],
    abbreviated: [
        "urt",
        "ots",
        "mar",
        "api",
        "mai",
        "eka",
        "uzt",
        "abu",
        "ira",
        "urr",
        "aza",
        "abe"
    ],
    wide: [
        "urtarrila",
        "otsaila",
        "martxoa",
        "apirila",
        "maiatza",
        "ekaina",
        "uztaila",
        "abuztua",
        "iraila",
        "urria",
        "azaroa",
        "abendua"
    ]
};
const $ddb312d7c229fa1d$var$dayValues = {
    narrow: [
        "i",
        "a",
        "a",
        "a",
        "o",
        "o",
        "l"
    ],
    short: [
        "ig",
        "al",
        "as",
        "az",
        "og",
        "or",
        "lr"
    ],
    abbreviated: [
        "iga",
        "ast",
        "ast",
        "ast",
        "ost",
        "ost",
        "lar"
    ],
    wide: [
        "igandea",
        "astelehena",
        "asteartea",
        "asteazkena",
        "osteguna",
        "ostirala",
        "larunbata"
    ]
};
const $ddb312d7c229fa1d$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    }
};
const $ddb312d7c229fa1d$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    }
};
const $ddb312d7c229fa1d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $ddb312d7c229fa1d$var$localize = $ddb312d7c229fa1d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ddb312d7c229fa1d$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $ddb312d7c229fa1d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $ddb312d7c229fa1d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $ddb312d7c229fa1d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $ddb312d7c229fa1d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $ddb312d7c229fa1d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ddb312d7c229fa1d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("faFxb", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $b0b8020af7efa564$export$4659b591c19bdf3d; }, function (v) { return $b0b8020af7efa564$export$4659b591c19bdf3d = v; });
var $b0b8020af7efa564$export$4659b591c19bdf3d;
"use strict";
$b0b8020af7efa564$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $b0b8020af7efa564$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
const $b0b8020af7efa564$var$parseOrdinalNumberPattern = /\d+/i;
const $b0b8020af7efa564$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
const $b0b8020af7efa564$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
const $b0b8020af7efa564$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
const $b0b8020af7efa564$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $b0b8020af7efa564$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
const $b0b8020af7efa564$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
const $b0b8020af7efa564$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
const $b0b8020af7efa564$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
const $b0b8020af7efa564$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
const $b0b8020af7efa564$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
const $b0b8020af7efa564$var$match = $b0b8020af7efa564$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $b0b8020af7efa564$var$matchOrdinalNumberPattern,
        parsePattern: $b0b8020af7efa564$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b0b8020af7efa564$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b0b8020af7efa564$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b0b8020af7efa564$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b0b8020af7efa564$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b0b8020af7efa564$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b0b8020af7efa564$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b0b8020af7efa564$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b0b8020af7efa564$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b0b8020af7efa564$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b0b8020af7efa564$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("gOQ6e", function(module, exports) {

$parcel$export(module.exports, "faIR", function () { return $c3e9babe01f8ce7e$export$355e05e1e35701f3; }, function (v) { return $c3e9babe01f8ce7e$export$355e05e1e35701f3 = v; });
var $c3e9babe01f8ce7e$export$355e05e1e35701f3;
"use strict";
$c3e9babe01f8ce7e$export$355e05e1e35701f3 = void 0;

var $kpYVd = parcelRequire("kpYVd");

var $41WON = parcelRequire("41WON");

var $gYUjW = parcelRequire("gYUjW");

var $4CS4n = parcelRequire("4CS4n");

var $70GMg = parcelRequire("70GMg");
/**
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za](https://github.com/mort3za)
 */ const $c3e9babe01f8ce7e$var$faIR = $c3e9babe01f8ce7e$export$355e05e1e35701f3 = {
    code: "fa-IR",
    formatDistance: $kpYVd.formatDistance,
    formatLong: $41WON.formatLong,
    formatRelative: $gYUjW.formatRelative,
    localize: $4CS4n.localize,
    match: $70GMg.match,
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("kpYVd", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $03d605c749fd4c62$export$2c14ff85d6318973; }, function (v) { return $03d605c749fd4c62$export$2c14ff85d6318973 = v; });
var $03d605c749fd4c62$export$2c14ff85d6318973;
"use strict";
$03d605c749fd4c62$export$2c14ff85d6318973 = void 0;
const $03d605c749fd4c62$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
const $03d605c749fd4c62$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $03d605c749fd4c62$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
$03d605c749fd4c62$export$2c14ff85d6318973 = $03d605c749fd4c62$var$formatDistance;

});

parcelRegister("41WON", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $2ef4e180fb6b360c$export$cbf60ecb96cbb82f; }, function (v) { return $2ef4e180fb6b360c$export$cbf60ecb96cbb82f = v; });
var $2ef4e180fb6b360c$export$cbf60ecb96cbb82f;
"use strict";
$2ef4e180fb6b360c$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $2ef4e180fb6b360c$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "yyyy/MM/dd"
};
const $2ef4e180fb6b360c$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2ef4e180fb6b360c$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2ef4e180fb6b360c$var$formatLong = $2ef4e180fb6b360c$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $2ef4e180fb6b360c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $2ef4e180fb6b360c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $2ef4e180fb6b360c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("gYUjW", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c5cdf00998b33248$export$8fbbfd65594f46a0; }, function (v) { return $c5cdf00998b33248$export$8fbbfd65594f46a0 = v; });
var $c5cdf00998b33248$export$8fbbfd65594f46a0;
"use strict";
$c5cdf00998b33248$export$8fbbfd65594f46a0 = void 0;
const $c5cdf00998b33248$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: "P"
};
const $c5cdf00998b33248$var$formatRelative = (token, _date, _baseDate, _options)=>$c5cdf00998b33248$var$formatRelativeLocale[token];
$c5cdf00998b33248$export$8fbbfd65594f46a0 = $c5cdf00998b33248$var$formatRelative;

});

parcelRegister("4CS4n", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $35e4a726287aecce$export$b3bd0bc58e36cd63; }, function (v) { return $35e4a726287aecce$export$b3bd0bc58e36cd63 = v; });
var $35e4a726287aecce$export$b3bd0bc58e36cd63;
"use strict";
$35e4a726287aecce$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $35e4a726287aecce$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
const $35e4a726287aecce$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $35e4a726287aecce$var$monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
const $35e4a726287aecce$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
const $35e4a726287aecce$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
const $35e4a726287aecce$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
const $35e4a726287aecce$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $35e4a726287aecce$var$localize = $35e4a726287aecce$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $35e4a726287aecce$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $35e4a726287aecce$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $35e4a726287aecce$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $35e4a726287aecce$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $35e4a726287aecce$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $35e4a726287aecce$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $35e4a726287aecce$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("70GMg", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $51a9b732eb6ad962$export$4659b591c19bdf3d; }, function (v) { return $51a9b732eb6ad962$export$4659b591c19bdf3d = v; });
var $51a9b732eb6ad962$export$4659b591c19bdf3d;
"use strict";
$51a9b732eb6ad962$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $51a9b732eb6ad962$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $51a9b732eb6ad962$var$parseOrdinalNumberPattern = /\d+/i;
const $51a9b732eb6ad962$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
const $51a9b732eb6ad962$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $51a9b732eb6ad962$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
const $51a9b732eb6ad962$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $51a9b732eb6ad962$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
const $51a9b732eb6ad962$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
const $51a9b732eb6ad962$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
const $51a9b732eb6ad962$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
const $51a9b732eb6ad962$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
const $51a9b732eb6ad962$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
const $51a9b732eb6ad962$var$match = $51a9b732eb6ad962$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $51a9b732eb6ad962$var$matchOrdinalNumberPattern,
        parsePattern: $51a9b732eb6ad962$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51a9b732eb6ad962$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51a9b732eb6ad962$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51a9b732eb6ad962$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51a9b732eb6ad962$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51a9b732eb6ad962$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51a9b732eb6ad962$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51a9b732eb6ad962$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51a9b732eb6ad962$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51a9b732eb6ad962$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51a9b732eb6ad962$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("2uuW8", function(module, exports) {

$parcel$export(module.exports, "fi", function () { return $1d0661794d5d774e$export$ed5179c818622fb; }, function (v) { return $1d0661794d5d774e$export$ed5179c818622fb = v; });
var $1d0661794d5d774e$export$ed5179c818622fb;
"use strict";
$1d0661794d5d774e$export$ed5179c818622fb = void 0;

var $8Ls3l = parcelRequire("8Ls3l");

var $8o5mh = parcelRequire("8o5mh");

var $7qkuC = parcelRequire("7qkuC");

var $32oc8 = parcelRequire("32oc8");

var $6OpwY = parcelRequire("6OpwY");
/**
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe](https://github.com/Pyppe)
 * @author Edo Rivai [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Samu Juvonen [@sjuvonen](https://github.com/sjuvonen)
 */ const $1d0661794d5d774e$var$fi = $1d0661794d5d774e$export$ed5179c818622fb = {
    code: "fi",
    formatDistance: $8Ls3l.formatDistance,
    formatLong: $8o5mh.formatLong,
    formatRelative: $7qkuC.formatRelative,
    localize: $32oc8.localize,
    match: $6OpwY.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("8Ls3l", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $661879452c7e7541$export$2c14ff85d6318973; }, function (v) { return $661879452c7e7541$export$2c14ff85d6318973 = v; });
var $661879452c7e7541$export$2c14ff85d6318973;
"use strict";
$661879452c7e7541$export$2c14ff85d6318973 = void 0;
function $661879452c7e7541$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, "sekunnin");
}
function $661879452c7e7541$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, "minuutin");
}
function $661879452c7e7541$var$futureHours(text) {
    return text.replace(/tuntia?/, "tunnin");
}
function $661879452c7e7541$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $661879452c7e7541$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, "viikon");
}
function $661879452c7e7541$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function $661879452c7e7541$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, "vuoden");
}
const $661879452c7e7541$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "alle sekunti",
        other: "alle {{count}} sekuntia",
        futureTense: $661879452c7e7541$var$futureSeconds
    },
    xSeconds: {
        one: "sekunti",
        other: "{{count}} sekuntia",
        futureTense: $661879452c7e7541$var$futureSeconds
    },
    halfAMinute: {
        one: "puoli minuuttia",
        other: "puoli minuuttia",
        futureTense: (_text)=>"puolen minuutin"
    },
    lessThanXMinutes: {
        one: "alle minuutti",
        other: "alle {{count}} minuuttia",
        futureTense: $661879452c7e7541$var$futureMinutes
    },
    xMinutes: {
        one: "minuutti",
        other: "{{count}} minuuttia",
        futureTense: $661879452c7e7541$var$futureMinutes
    },
    aboutXHours: {
        one: "noin tunti",
        other: "noin {{count}} tuntia",
        futureTense: $661879452c7e7541$var$futureHours
    },
    xHours: {
        one: "tunti",
        other: "{{count}} tuntia",
        futureTense: $661879452c7e7541$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $661879452c7e7541$var$futureDays
    },
    aboutXWeeks: {
        one: "noin viikko",
        other: "noin {{count}} viikkoa",
        futureTense: $661879452c7e7541$var$futureWeeks
    },
    xWeeks: {
        one: "viikko",
        other: "{{count}} viikkoa",
        futureTense: $661879452c7e7541$var$futureWeeks
    },
    aboutXMonths: {
        one: "noin kuukausi",
        other: "noin {{count}} kuukautta",
        futureTense: $661879452c7e7541$var$futureMonths
    },
    xMonths: {
        one: "kuukausi",
        other: "{{count}} kuukautta",
        futureTense: $661879452c7e7541$var$futureMonths
    },
    aboutXYears: {
        one: "noin vuosi",
        other: "noin {{count}} vuotta",
        futureTense: $661879452c7e7541$var$futureYears
    },
    xYears: {
        one: "vuosi",
        other: "{{count}} vuotta",
        futureTense: $661879452c7e7541$var$futureYears
    },
    overXYears: {
        one: "yli vuosi",
        other: "yli {{count}} vuotta",
        futureTense: $661879452c7e7541$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $661879452c7e7541$var$futureYears
    }
};
const $661879452c7e7541$var$formatDistance = (token, count, options)=>{
    const tokenValue = $661879452c7e7541$var$formatDistanceLocale[token];
    const result = count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + " kuluttua";
        else return result + " sitten";
    }
    return result;
};
$661879452c7e7541$export$2c14ff85d6318973 = $661879452c7e7541$var$formatDistance;

});

parcelRegister("8o5mh", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $61b4b8af6ef8912e$export$cbf60ecb96cbb82f; }, function (v) { return $61b4b8af6ef8912e$export$cbf60ecb96cbb82f = v; });
var $61b4b8af6ef8912e$export$cbf60ecb96cbb82f;
"use strict";
$61b4b8af6ef8912e$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $61b4b8af6ef8912e$var$dateFormats = {
    full: "eeee d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "d.M.y"
};
const $61b4b8af6ef8912e$var$timeFormats = {
    full: "HH.mm.ss zzzz",
    long: "HH.mm.ss z",
    medium: "HH.mm.ss",
    short: "HH.mm"
};
const $61b4b8af6ef8912e$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $61b4b8af6ef8912e$var$formatLong = $61b4b8af6ef8912e$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $61b4b8af6ef8912e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $61b4b8af6ef8912e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $61b4b8af6ef8912e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("7qkuC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $567adb9227ddc06d$export$8fbbfd65594f46a0; }, function (v) { return $567adb9227ddc06d$export$8fbbfd65594f46a0 = v; });
var $567adb9227ddc06d$export$8fbbfd65594f46a0;
"use strict";
$567adb9227ddc06d$export$8fbbfd65594f46a0 = void 0;
const $567adb9227ddc06d$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: "P"
};
const $567adb9227ddc06d$var$formatRelative = (token, _date, _baseDate, _options)=>$567adb9227ddc06d$var$formatRelativeLocale[token];
$567adb9227ddc06d$export$8fbbfd65594f46a0 = $567adb9227ddc06d$var$formatRelative;

});

parcelRegister("32oc8", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $236453985a4805c4$export$b3bd0bc58e36cd63; }, function (v) { return $236453985a4805c4$export$b3bd0bc58e36cd63 = v; });
var $236453985a4805c4$export$b3bd0bc58e36cd63;
"use strict";
$236453985a4805c4$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $236453985a4805c4$var$eraValues = {
    narrow: [
        "eaa.",
        "jaa."
    ],
    abbreviated: [
        "eaa.",
        "jaa."
    ],
    wide: [
        "ennen ajanlaskun alkua",
        "j\xe4lkeen ajanlaskun alun"
    ]
};
const $236453985a4805c4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartaali",
        "2. kvartaali",
        "3. kvartaali",
        "4. kvartaali"
    ]
};
const $236453985a4805c4$var$monthValues = {
    narrow: [
        "T",
        "H",
        "M",
        "H",
        "T",
        "K",
        "H",
        "E",
        "S",
        "L",
        "M",
        "J"
    ],
    abbreviated: [
        "tammi",
        "helmi",
        "maalis",
        "huhti",
        "touko",
        "kes\xe4",
        "hein\xe4",
        "elo",
        "syys",
        "loka",
        "marras",
        "joulu"
    ],
    wide: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kes\xe4kuu",
        "hein\xe4kuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
    ]
};
const $236453985a4805c4$var$formattingMonthValues = {
    narrow: $236453985a4805c4$var$monthValues.narrow,
    abbreviated: $236453985a4805c4$var$monthValues.abbreviated,
    wide: [
        "tammikuuta",
        "helmikuuta",
        "maaliskuuta",
        "huhtikuuta",
        "toukokuuta",
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        "elokuuta",
        "syyskuuta",
        "lokakuuta",
        "marraskuuta",
        "joulukuuta"
    ]
};
const $236453985a4805c4$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "K",
        "T",
        "P",
        "L"
    ],
    short: [
        "su",
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la"
    ],
    abbreviated: [
        "sunn.",
        "maan.",
        "tiis.",
        "kesk.",
        "torst.",
        "perj.",
        "la"
    ],
    wide: [
        "sunnuntai",
        "maanantai",
        "tiistai",
        "keskiviikko",
        "torstai",
        "perjantai",
        "lauantai"
    ]
};
const $236453985a4805c4$var$formattingDayValues = {
    narrow: $236453985a4805c4$var$dayValues.narrow,
    short: $236453985a4805c4$var$dayValues.short,
    abbreviated: $236453985a4805c4$var$dayValues.abbreviated,
    wide: [
        "sunnuntaina",
        "maanantaina",
        "tiistaina",
        "keskiviikkona",
        "torstaina",
        "perjantaina",
        "lauantaina"
    ]
};
const $236453985a4805c4$var$dayPeriodValues = {
    narrow: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    }
};
const $236453985a4805c4$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $236453985a4805c4$var$localize = $236453985a4805c4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $236453985a4805c4$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $236453985a4805c4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $236453985a4805c4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $236453985a4805c4$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $236453985a4805c4$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $236453985a4805c4$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $236453985a4805c4$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $236453985a4805c4$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("6OpwY", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $4f5b378031d3b07b$export$4659b591c19bdf3d; }, function (v) { return $4f5b378031d3b07b$export$4659b591c19bdf3d = v; });
var $4f5b378031d3b07b$export$4659b591c19bdf3d;
"use strict";
$4f5b378031d3b07b$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $4f5b378031d3b07b$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
const $4f5b378031d3b07b$var$parseOrdinalNumberPattern = /\d+/i;
const $4f5b378031d3b07b$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
const $4f5b378031d3b07b$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
const $4f5b378031d3b07b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
const $4f5b378031d3b07b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $4f5b378031d3b07b$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
const $4f5b378031d3b07b$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
const $4f5b378031d3b07b$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
const $4f5b378031d3b07b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
const $4f5b378031d3b07b$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
const $4f5b378031d3b07b$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
const $4f5b378031d3b07b$var$match = $4f5b378031d3b07b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $4f5b378031d3b07b$var$matchOrdinalNumberPattern,
        parsePattern: $4f5b378031d3b07b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f5b378031d3b07b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f5b378031d3b07b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f5b378031d3b07b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f5b378031d3b07b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f5b378031d3b07b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f5b378031d3b07b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f5b378031d3b07b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4f5b378031d3b07b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $4f5b378031d3b07b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4f5b378031d3b07b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("7DDCw", function(module, exports) {

$parcel$export(module.exports, "fr", function () { return $58fae8b4c2b5a94f$export$acb2a88f7d552ebf; }, function (v) { return $58fae8b4c2b5a94f$export$acb2a88f7d552ebf = v; });
var $58fae8b4c2b5a94f$export$acb2a88f7d552ebf;
"use strict";
$58fae8b4c2b5a94f$export$acb2a88f7d552ebf = void 0;

var $jZ4wG = parcelRequire("jZ4wG");

var $g6Gj7 = parcelRequire("g6Gj7");

var $bgjqw = parcelRequire("bgjqw");

var $3HBXk = parcelRequire("3HBXk");

var $dA6q0 = parcelRequire("dA6q0");
/**
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 */ const $58fae8b4c2b5a94f$var$fr = $58fae8b4c2b5a94f$export$acb2a88f7d552ebf = {
    code: "fr",
    formatDistance: $jZ4wG.formatDistance,
    formatLong: $g6Gj7.formatLong,
    formatRelative: $bgjqw.formatRelative,
    localize: $3HBXk.localize,
    match: $dA6q0.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("jZ4wG", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $e8c73999fa271a7e$export$2c14ff85d6318973; }, function (v) { return $e8c73999fa271a7e$export$2c14ff85d6318973 = v; });
var $e8c73999fa271a7e$export$2c14ff85d6318973;
"use strict";
$e8c73999fa271a7e$export$2c14ff85d6318973 = void 0;
const $e8c73999fa271a7e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
const $e8c73999fa271a7e$var$formatDistance = (token, count, options)=>{
    let result;
    const form = $e8c73999fa271a7e$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};
$e8c73999fa271a7e$export$2c14ff85d6318973 = $e8c73999fa271a7e$var$formatDistance;

});

parcelRegister("g6Gj7", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $bb9e0637fce60f84$export$cbf60ecb96cbb82f; }, function (v) { return $bb9e0637fce60f84$export$cbf60ecb96cbb82f = v; });
var $bb9e0637fce60f84$export$cbf60ecb96cbb82f;
"use strict";
$bb9e0637fce60f84$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $bb9e0637fce60f84$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $bb9e0637fce60f84$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $bb9e0637fce60f84$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $bb9e0637fce60f84$var$formatLong = $bb9e0637fce60f84$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $bb9e0637fce60f84$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $bb9e0637fce60f84$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $bb9e0637fce60f84$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("bgjqw", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $8330420fd74dcc73$export$8fbbfd65594f46a0; }, function (v) { return $8330420fd74dcc73$export$8fbbfd65594f46a0 = v; });
var $8330420fd74dcc73$export$8fbbfd65594f46a0;
"use strict";
$8330420fd74dcc73$export$8fbbfd65594f46a0 = void 0;
const $8330420fd74dcc73$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
const $8330420fd74dcc73$var$formatRelative = (token, _date, _baseDate, _options)=>$8330420fd74dcc73$var$formatRelativeLocale[token];
$8330420fd74dcc73$export$8fbbfd65594f46a0 = $8330420fd74dcc73$var$formatRelative;

});

parcelRegister("3HBXk", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $2b22d487536c3624$export$b3bd0bc58e36cd63; }, function (v) { return $2b22d487536c3624$export$b3bd0bc58e36cd63 = v; });
var $2b22d487536c3624$export$b3bd0bc58e36cd63;
"use strict";
$2b22d487536c3624$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $2b22d487536c3624$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
const $2b22d487536c3624$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
const $2b22d487536c3624$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
const $2b22d487536c3624$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
const $2b22d487536c3624$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
const $2b22d487536c3624$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return "0";
    const feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    let suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
const $2b22d487536c3624$var$LONG_MONTHS_TOKENS = [
    "MMM",
    "MMMM"
];
const $2b22d487536c3624$var$localize = $2b22d487536c3624$export$b3bd0bc58e36cd63 = {
    preprocessor: (date, parts)=>{
        // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
        // Use case "do MMMM" => 1er août, 29 août
        // see https://github.com/date-fns/date-fns/issues/1391
        if (date.getDate() === 1) return parts;
        const hasLongMonthToken = parts.some((part)=>part.isToken && $2b22d487536c3624$var$LONG_MONTHS_TOKENS.includes(part.value));
        if (!hasLongMonthToken) return parts;
        return parts.map((part)=>part.isToken && part.value === "do" ? {
                isToken: true,
                value: "d"
            } : part);
    },
    ordinalNumber: $2b22d487536c3624$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $2b22d487536c3624$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $2b22d487536c3624$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $2b22d487536c3624$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $2b22d487536c3624$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $2b22d487536c3624$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("dA6q0", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $9e339dbd3136c32c$export$4659b591c19bdf3d; }, function (v) { return $9e339dbd3136c32c$export$4659b591c19bdf3d = v; });
var $9e339dbd3136c32c$export$4659b591c19bdf3d;
"use strict";
$9e339dbd3136c32c$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $9e339dbd3136c32c$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const $9e339dbd3136c32c$var$parseOrdinalNumberPattern = /\d+/i;
const $9e339dbd3136c32c$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
const $9e339dbd3136c32c$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $9e339dbd3136c32c$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
const $9e339dbd3136c32c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $9e339dbd3136c32c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
const $9e339dbd3136c32c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $9e339dbd3136c32c$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
const $9e339dbd3136c32c$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
const $9e339dbd3136c32c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
const $9e339dbd3136c32c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
const $9e339dbd3136c32c$var$match = $9e339dbd3136c32c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $9e339dbd3136c32c$var$matchOrdinalNumberPattern,
        parsePattern: $9e339dbd3136c32c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9e339dbd3136c32c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9e339dbd3136c32c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9e339dbd3136c32c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9e339dbd3136c32c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9e339dbd3136c32c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9e339dbd3136c32c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9e339dbd3136c32c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9e339dbd3136c32c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9e339dbd3136c32c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9e339dbd3136c32c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("6rz6V", function(module, exports) {

$parcel$export(module.exports, "frCA", function () { return $4b107ff027e12a04$export$ba0a7939fd366aec; }, function (v) { return $4b107ff027e12a04$export$ba0a7939fd366aec = v; });
var $4b107ff027e12a04$export$ba0a7939fd366aec;
"use strict";
$4b107ff027e12a04$export$ba0a7939fd366aec = void 0;

var $jZ4wG = parcelRequire("jZ4wG");

var $bgjqw = parcelRequire("bgjqw");

var $3HBXk = parcelRequire("3HBXk");

var $dA6q0 = parcelRequire("dA6q0");

var $3454n = parcelRequire("3454n");
// Unique for fr-CA
/**
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Gabriele Petrioli [@gpetrioli](https://github.com/gpetrioli)
 */ const $4b107ff027e12a04$var$frCA = $4b107ff027e12a04$export$ba0a7939fd366aec = {
    code: "fr-CA",
    formatDistance: $jZ4wG.formatDistance,
    formatLong: $3454n.formatLong,
    formatRelative: $bgjqw.formatRelative,
    localize: $3HBXk.localize,
    match: $dA6q0.match,
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("3454n", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $23b5ad8d10118ff4$export$cbf60ecb96cbb82f; }, function (v) { return $23b5ad8d10118ff4$export$cbf60ecb96cbb82f = v; });
var $23b5ad8d10118ff4$export$cbf60ecb96cbb82f;
"use strict";
$23b5ad8d10118ff4$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $23b5ad8d10118ff4$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "yy-MM-dd"
};
const $23b5ad8d10118ff4$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $23b5ad8d10118ff4$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $23b5ad8d10118ff4$var$formatLong = $23b5ad8d10118ff4$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $23b5ad8d10118ff4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $23b5ad8d10118ff4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $23b5ad8d10118ff4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("gQXHh", function(module, exports) {

$parcel$export(module.exports, "frCH", function () { return $c44fcf49756647f6$export$5ca9c7dd526fb524; }, function (v) { return $c44fcf49756647f6$export$5ca9c7dd526fb524 = v; });
var $c44fcf49756647f6$export$5ca9c7dd526fb524;
"use strict";
$c44fcf49756647f6$export$5ca9c7dd526fb524 = void 0;

var $jZ4wG = parcelRequire("jZ4wG");

var $3HBXk = parcelRequire("3HBXk");

var $dA6q0 = parcelRequire("dA6q0");

var $d8MrW = parcelRequire("d8MrW");

var $ac1R8 = parcelRequire("ac1R8");
// Unique for fr-CH
/**
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */ const $c44fcf49756647f6$var$frCH = $c44fcf49756647f6$export$5ca9c7dd526fb524 = {
    code: "fr-CH",
    formatDistance: $jZ4wG.formatDistance,
    formatLong: $d8MrW.formatLong,
    formatRelative: $ac1R8.formatRelative,
    localize: $3HBXk.localize,
    match: $dA6q0.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("d8MrW", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $99119ad3f4b31ee9$export$cbf60ecb96cbb82f; }, function (v) { return $99119ad3f4b31ee9$export$cbf60ecb96cbb82f = v; });
var $99119ad3f4b31ee9$export$cbf60ecb96cbb82f;
"use strict";
$99119ad3f4b31ee9$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $99119ad3f4b31ee9$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $99119ad3f4b31ee9$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $99119ad3f4b31ee9$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $99119ad3f4b31ee9$var$formatLong = $99119ad3f4b31ee9$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $99119ad3f4b31ee9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $99119ad3f4b31ee9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $99119ad3f4b31ee9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("ac1R8", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $76bc76eceabf47c5$export$8fbbfd65594f46a0; }, function (v) { return $76bc76eceabf47c5$export$8fbbfd65594f46a0 = v; });
var $76bc76eceabf47c5$export$8fbbfd65594f46a0;
"use strict";
$76bc76eceabf47c5$export$8fbbfd65594f46a0 = void 0;
const $76bc76eceabf47c5$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: "P"
};
const $76bc76eceabf47c5$var$formatRelative = (token, _date, _baseDate, _options)=>$76bc76eceabf47c5$var$formatRelativeLocale[token];
$76bc76eceabf47c5$export$8fbbfd65594f46a0 = $76bc76eceabf47c5$var$formatRelative;

});


parcelRegister("ib3ON", function(module, exports) {

$parcel$export(module.exports, "fy", function () { return $d3bc3752e0099099$export$c0dcd1f2238f086d; }, function (v) { return $d3bc3752e0099099$export$c0dcd1f2238f086d = v; });
var $d3bc3752e0099099$export$c0dcd1f2238f086d;
"use strict";
$d3bc3752e0099099$export$c0dcd1f2238f086d = void 0;

var $j6wPR = parcelRequire("j6wPR");

var $4SInU = parcelRequire("4SInU");

var $dqpnA = parcelRequire("dqpnA");

var $5gKkZ = parcelRequire("5gKkZ");

var $cajbh = parcelRequire("cajbh");
/**
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02](https://github.com/damon02)
 */ const $d3bc3752e0099099$var$fy = $d3bc3752e0099099$export$c0dcd1f2238f086d = {
    code: "fy",
    formatDistance: $j6wPR.formatDistance,
    formatLong: $4SInU.formatLong,
    formatRelative: $dqpnA.formatRelative,
    localize: $5gKkZ.localize,
    match: $cajbh.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("j6wPR", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $de880c4e6828389e$export$2c14ff85d6318973; }, function (v) { return $de880c4e6828389e$export$2c14ff85d6318973 = v; });
var $de880c4e6828389e$export$2c14ff85d6318973;
"use strict";
$de880c4e6828389e$export$2c14ff85d6318973 = void 0;
const $de880c4e6828389e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 1 sekonde",
        other: "minder as {{count}} sekonden"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekonden"
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: "minder as {{count}} minuten"
    },
    xMinutes: {
        one: "1 min\xfat",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "sawat 1 oere",
        other: "sawat {{count}} oere"
    },
    xHours: {
        one: "1 oere",
        other: "{{count}} oere"
    },
    xDays: {
        one: "1 dei",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "sawat 1 wike",
        other: "sawat {{count}} wiken"
    },
    xWeeks: {
        one: "1 wike",
        other: "{{count}} wiken"
    },
    aboutXMonths: {
        one: "sawat 1 moanne",
        other: "sawat {{count}} moannen"
    },
    xMonths: {
        one: "1 moanne",
        other: "{{count}} moannen"
    },
    aboutXYears: {
        one: "sawat 1 jier",
        other: "sawat {{count}} jier"
    },
    xYears: {
        one: "1 jier",
        other: "{{count}} jier"
    },
    overXYears: {
        one: "mear as 1 jier",
        other: "mear as {{count}}s jier"
    },
    almostXYears: {
        one: "hast 1 jier",
        other: "hast {{count}} jier"
    }
};
const $de880c4e6828389e$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $de880c4e6828389e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oer " + result;
        else return result + " lyn";
    }
    return result;
};
$de880c4e6828389e$export$2c14ff85d6318973 = $de880c4e6828389e$var$formatDistance;

});

parcelRegister("4SInU", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $38dea2745f41be9b$export$cbf60ecb96cbb82f; }, function (v) { return $38dea2745f41be9b$export$cbf60ecb96cbb82f = v; });
var $38dea2745f41be9b$export$cbf60ecb96cbb82f;
"use strict";
$38dea2745f41be9b$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $38dea2745f41be9b$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
const $38dea2745f41be9b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $38dea2745f41be9b$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $38dea2745f41be9b$var$formatLong = $38dea2745f41be9b$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $38dea2745f41be9b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $38dea2745f41be9b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $38dea2745f41be9b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dqpnA", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9c6163eafedaba53$export$8fbbfd65594f46a0; }, function (v) { return $9c6163eafedaba53$export$8fbbfd65594f46a0 = v; });
var $9c6163eafedaba53$export$8fbbfd65594f46a0;
"use strict";
$9c6163eafedaba53$export$8fbbfd65594f46a0 = void 0;
const $9c6163eafedaba53$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $9c6163eafedaba53$var$formatRelative = (token, _date, _baseDate, _options)=>$9c6163eafedaba53$var$formatRelativeLocale[token];
$9c6163eafedaba53$export$8fbbfd65594f46a0 = $9c6163eafedaba53$var$formatRelative;

});

parcelRegister("5gKkZ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3d62640c5d183eb8$export$b3bd0bc58e36cd63; }, function (v) { return $3d62640c5d183eb8$export$b3bd0bc58e36cd63 = v; });
var $3d62640c5d183eb8$export$b3bd0bc58e36cd63;
"use strict";
$3d62640c5d183eb8$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $3d62640c5d183eb8$var$eraValues = {
    narrow: [
        "f.K.",
        "n.K."
    ],
    abbreviated: [
        "f.Kr.",
        "n.Kr."
    ],
    wide: [
        "foar Kristus",
        "nei Kristus"
    ]
};
const $3d62640c5d183eb8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e fearnsjier",
        "2e fearnsjier",
        "3e fearnsjier",
        "4e fearnsjier"
    ]
};
const $3d62640c5d183eb8$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mai.",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "jannewaris",
        "febrewaris",
        "maart",
        "april",
        "maaie",
        "juny",
        "july",
        "augustus",
        "septimber",
        "oktober",
        "novimber",
        "desimber"
    ]
};
const $3d62640c5d183eb8$var$dayValues = {
    narrow: [
        "s",
        "m",
        "t",
        "w",
        "t",
        "f",
        "s"
    ],
    short: [
        "si",
        "mo",
        "ti",
        "wo",
        "to",
        "fr",
        "so"
    ],
    abbreviated: [
        "snein",
        "moa",
        "tii",
        "woa",
        "ton",
        "fre",
        "sneon"
    ],
    wide: [
        "snein",
        "moandei",
        "tiisdei",
        "woansdei",
        "tongersdei",
        "freed",
        "sneon"
    ]
};
const $3d62640c5d183eb8$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    }
};
const $3d62640c5d183eb8$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $3d62640c5d183eb8$var$localize = $3d62640c5d183eb8$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3d62640c5d183eb8$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $3d62640c5d183eb8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $3d62640c5d183eb8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $3d62640c5d183eb8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $3d62640c5d183eb8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $3d62640c5d183eb8$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("cajbh", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $8db54c1e007b71d5$export$4659b591c19bdf3d; }, function (v) { return $8db54c1e007b71d5$export$4659b591c19bdf3d = v; });
var $8db54c1e007b71d5$export$4659b591c19bdf3d;
"use strict";
$8db54c1e007b71d5$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $8db54c1e007b71d5$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $8db54c1e007b71d5$var$parseOrdinalNumberPattern = /\d+/i;
const $8db54c1e007b71d5$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
const $8db54c1e007b71d5$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
const $8db54c1e007b71d5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
const $8db54c1e007b71d5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $8db54c1e007b71d5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
const $8db54c1e007b71d5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
const $8db54c1e007b71d5$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
const $8db54c1e007b71d5$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
const $8db54c1e007b71d5$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
const $8db54c1e007b71d5$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
const $8db54c1e007b71d5$var$match = $8db54c1e007b71d5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $8db54c1e007b71d5$var$matchOrdinalNumberPattern,
        parsePattern: $8db54c1e007b71d5$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $8db54c1e007b71d5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8db54c1e007b71d5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $8db54c1e007b71d5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8db54c1e007b71d5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $8db54c1e007b71d5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8db54c1e007b71d5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $8db54c1e007b71d5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8db54c1e007b71d5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $8db54c1e007b71d5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8db54c1e007b71d5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("aJh9D", function(module, exports) {

$parcel$export(module.exports, "gd", function () { return $7cfb69e104879329$export$64ad7087a50b462f; }, function (v) { return $7cfb69e104879329$export$64ad7087a50b462f = v; });
var $7cfb69e104879329$export$64ad7087a50b462f;
"use strict";
$7cfb69e104879329$export$64ad7087a50b462f = void 0;

var $bSoLG = parcelRequire("bSoLG");

var $sS3CJ = parcelRequire("sS3CJ");

var $1HIX4 = parcelRequire("1HIX4");

var $hndDN = parcelRequire("hndDN");

var $klKei = parcelRequire("klKei");
/**
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll](https://github.com/leedriscoll)
 */ const $7cfb69e104879329$var$gd = $7cfb69e104879329$export$64ad7087a50b462f = {
    code: "gd",
    formatDistance: $bSoLG.formatDistance,
    formatLong: $sS3CJ.formatLong,
    formatRelative: $1HIX4.formatRelative,
    localize: $hndDN.localize,
    match: $klKei.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("bSoLG", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $8a57f349dabf9a84$export$2c14ff85d6318973; }, function (v) { return $8a57f349dabf9a84$export$2c14ff85d6318973 = v; });
var $8a57f349dabf9a84$export$2c14ff85d6318973;
"use strict";
$8a57f349dabf9a84$export$2c14ff85d6318973 = void 0;
const $8a57f349dabf9a84$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "nas lugha na diog",
        other: "nas lugha na {{count}} diogan"
    },
    xSeconds: {
        one: "1 diog",
        two: "2 dhiog",
        twenty: "20 diog",
        other: "{{count}} diogan"
    },
    halfAMinute: "leth mhionaid",
    lessThanXMinutes: {
        one: "nas lugha na mionaid",
        other: "nas lugha na {{count}} mionaidean"
    },
    xMinutes: {
        one: "1 mionaid",
        two: "2 mhionaid",
        twenty: "20 mionaid",
        other: "{{count}} mionaidean"
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: "mu 1 seachdain",
        other: "mu {{count}} seachdainean"
    },
    xWeeks: {
        one: "1 seachdain",
        other: "{{count}} seachdainean"
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: "mu bhliadhna",
        other: "mu {{count}} bliadhnaichean"
    },
    xYears: {
        one: "1 bhliadhna",
        other: "{{count}} bliadhna"
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
const $8a57f349dabf9a84$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $8a57f349dabf9a84$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "ann an " + result;
        else return "o chionn " + result;
    }
    return result;
};
$8a57f349dabf9a84$export$2c14ff85d6318973 = $8a57f349dabf9a84$var$formatDistance;

});

parcelRegister("sS3CJ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $056c8c529eda13a6$export$cbf60ecb96cbb82f; }, function (v) { return $056c8c529eda13a6$export$cbf60ecb96cbb82f = v; });
var $056c8c529eda13a6$export$cbf60ecb96cbb82f;
"use strict";
$056c8c529eda13a6$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $056c8c529eda13a6$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $056c8c529eda13a6$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $056c8c529eda13a6$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $056c8c529eda13a6$var$formatLong = $056c8c529eda13a6$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $056c8c529eda13a6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $056c8c529eda13a6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $056c8c529eda13a6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("1HIX4", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $13dcad10333837d4$export$8fbbfd65594f46a0; }, function (v) { return $13dcad10333837d4$export$8fbbfd65594f46a0 = v; });
var $13dcad10333837d4$export$8fbbfd65594f46a0;
"use strict";
$13dcad10333837d4$export$8fbbfd65594f46a0 = void 0;
const $13dcad10333837d4$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: "P"
};
const $13dcad10333837d4$var$formatRelative = (token, _date, _baseDate, _options)=>$13dcad10333837d4$var$formatRelativeLocale[token];
$13dcad10333837d4$export$8fbbfd65594f46a0 = $13dcad10333837d4$var$formatRelative;

});

parcelRegister("hndDN", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $ca5f2a713ddcb25e$export$b3bd0bc58e36cd63; }, function (v) { return $ca5f2a713ddcb25e$export$b3bd0bc58e36cd63 = v; });
var $ca5f2a713ddcb25e$export$b3bd0bc58e36cd63;
"use strict";
$ca5f2a713ddcb25e$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $ca5f2a713ddcb25e$var$eraValues = {
    narrow: [
        "R",
        "A"
    ],
    abbreviated: [
        "RC",
        "AD"
    ],
    wide: [
        "ro Chr\xecosta",
        "anno domini"
    ]
};
const $ca5f2a713ddcb25e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "C1",
        "C2",
        "C3",
        "C4"
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        "an treas cairteal",
        "an ceathramh cairteal"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $ca5f2a713ddcb25e$var$monthValues = {
    narrow: [
        "F",
        "G",
        "M",
        "G",
        "C",
        "\xd2",
        "I",
        "L",
        "S",
        "D",
        "S",
        "D"
    ],
    abbreviated: [
        "Faoi",
        "Gear",
        "M\xe0rt",
        "Gibl",
        "C\xe8it",
        "\xd2gmh",
        "Iuch",
        "L\xf9n",
        "Sult",
        "D\xe0mh",
        "Samh",
        "D\xf9bh"
    ],
    wide: [
        "Am Faoilleach",
        "An Gearran",
        "Am M\xe0rt",
        "An Giblean",
        "An C\xe8itean",
        "An t-\xd2gmhios",
        "An t-Iuchar",
        "An L\xf9nastal",
        "An t-Sultain",
        "An D\xe0mhair",
        "An t-Samhain",
        "An D\xf9bhlachd"
    ]
};
const $ca5f2a713ddcb25e$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "C",
        "A",
        "H",
        "S"
    ],
    short: [
        "D\xf2",
        "Lu",
        "M\xe0",
        "Ci",
        "Ar",
        "Ha",
        "Sa"
    ],
    abbreviated: [
        "Did",
        "Dil",
        "Dim",
        "Dic",
        "Dia",
        "Dih",
        "Dis"
    ],
    wide: [
        "Did\xf2mhnaich",
        "Diluain",
        "Dim\xe0irt",
        "Diciadain",
        "Diardaoin",
        "Dihaoine",
        "Disathairne"
    ]
};
const $ca5f2a713ddcb25e$var$dayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    }
};
const $ca5f2a713ddcb25e$var$formattingDayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    }
};
const $ca5f2a713ddcb25e$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "d";
        case 2:
            return number + "na";
    }
    if (rem100 === 12) return number + "na";
    return number + "mh";
};
const $ca5f2a713ddcb25e$var$localize = $ca5f2a713ddcb25e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ca5f2a713ddcb25e$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $ca5f2a713ddcb25e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $ca5f2a713ddcb25e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $ca5f2a713ddcb25e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $ca5f2a713ddcb25e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $ca5f2a713ddcb25e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ca5f2a713ddcb25e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("klKei", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $ed09a10c010db7f5$export$4659b591c19bdf3d; }, function (v) { return $ed09a10c010db7f5$export$4659b591c19bdf3d = v; });
var $ed09a10c010db7f5$export$4659b591c19bdf3d;
"use strict";
$ed09a10c010db7f5$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $ed09a10c010db7f5$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
const $ed09a10c010db7f5$var$parseOrdinalNumberPattern = /\d+/i;
const $ed09a10c010db7f5$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
const $ed09a10c010db7f5$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $ed09a10c010db7f5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
const $ed09a10c010db7f5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ed09a10c010db7f5$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
const $ed09a10c010db7f5$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
const $ed09a10c010db7f5$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
const $ed09a10c010db7f5$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
const $ed09a10c010db7f5$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
const $ed09a10c010db7f5$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
const $ed09a10c010db7f5$var$match = $ed09a10c010db7f5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $ed09a10c010db7f5$var$matchOrdinalNumberPattern,
        parsePattern: $ed09a10c010db7f5$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $ed09a10c010db7f5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed09a10c010db7f5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $ed09a10c010db7f5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed09a10c010db7f5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $ed09a10c010db7f5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed09a10c010db7f5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $ed09a10c010db7f5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed09a10c010db7f5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $ed09a10c010db7f5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ed09a10c010db7f5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("cinY1", function(module, exports) {

$parcel$export(module.exports, "gl", function () { return $8f39c1d1c81aed4b$export$5822a9d0880a5d82; }, function (v) { return $8f39c1d1c81aed4b$export$5822a9d0880a5d82 = v; });
var $8f39c1d1c81aed4b$export$5822a9d0880a5d82;
"use strict";
$8f39c1d1c81aed4b$export$5822a9d0880a5d82 = void 0;

var $90YpM = parcelRequire("90YpM");

var $2AgTy = parcelRequire("2AgTy");

var $kStvp = parcelRequire("kStvp");

var $fQrRG = parcelRequire("fQrRG");

var $akKPS = parcelRequire("akKPS");
/**
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech](https://github.com/cocodinTech)
 * @author Fidel Pita [@fidelpita](https://github.com/fidelpita)
 */ const $8f39c1d1c81aed4b$var$gl = $8f39c1d1c81aed4b$export$5822a9d0880a5d82 = {
    code: "gl",
    formatDistance: $90YpM.formatDistance,
    formatLong: $2AgTy.formatLong,
    formatRelative: $kStvp.formatRelative,
    localize: $fQrRG.localize,
    match: $akKPS.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("90YpM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $6902fa48cc1229d8$export$2c14ff85d6318973; }, function (v) { return $6902fa48cc1229d8$export$2c14ff85d6318973 = v; });
var $6902fa48cc1229d8$export$2c14ff85d6318973;
"use strict";
$6902fa48cc1229d8$export$2c14ff85d6318973 = void 0;
const $6902fa48cc1229d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos dun segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos dun minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "arredor dunha hora",
        other: "arredor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "arredor dunha semana",
        other: "arredor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "arredor de 1 mes",
        other: "arredor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "arredor dun ano",
        other: "arredor de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: "case un ano",
        other: "case {{count}} anos"
    }
};
const $6902fa48cc1229d8$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $6902fa48cc1229d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hai " + result;
    }
    return result;
};
$6902fa48cc1229d8$export$2c14ff85d6318973 = $6902fa48cc1229d8$var$formatDistance;

});

parcelRegister("2AgTy", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $1e1c0c8f68c718a9$export$cbf60ecb96cbb82f; }, function (v) { return $1e1c0c8f68c718a9$export$cbf60ecb96cbb82f = v; });
var $1e1c0c8f68c718a9$export$cbf60ecb96cbb82f;
"use strict";
$1e1c0c8f68c718a9$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $1e1c0c8f68c718a9$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $1e1c0c8f68c718a9$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $1e1c0c8f68c718a9$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $1e1c0c8f68c718a9$var$formatLong = $1e1c0c8f68c718a9$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $1e1c0c8f68c718a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $1e1c0c8f68c718a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $1e1c0c8f68c718a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("kStvp", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $f32fbcfde79e975d$export$8fbbfd65594f46a0; }, function (v) { return $f32fbcfde79e975d$export$8fbbfd65594f46a0 = v; });
var $f32fbcfde79e975d$export$8fbbfd65594f46a0;
"use strict";
$f32fbcfde79e975d$export$8fbbfd65594f46a0 = void 0;
const $f32fbcfde79e975d$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: "P"
};
const $f32fbcfde79e975d$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: "P"
};
const $f32fbcfde79e975d$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $f32fbcfde79e975d$var$formatRelativeLocalePlural[token];
    return $f32fbcfde79e975d$var$formatRelativeLocale[token];
};
$f32fbcfde79e975d$export$8fbbfd65594f46a0 = $f32fbcfde79e975d$var$formatRelative;

});

parcelRegister("fQrRG", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $b89153b458fbd0a6$export$b3bd0bc58e36cd63; }, function (v) { return $b89153b458fbd0a6$export$b3bd0bc58e36cd63 = v; });
var $b89153b458fbd0a6$export$b3bd0bc58e36cd63;
"use strict";
$b89153b458fbd0a6$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $b89153b458fbd0a6$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despois de cristo"
    ]
};
const $b89153b458fbd0a6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $b89153b458fbd0a6$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "xan",
        "feb",
        "mar",
        "abr",
        "mai",
        "xun",
        "xul",
        "ago",
        "set",
        "out",
        "nov",
        "dec"
    ],
    wide: [
        "xaneiro",
        "febreiro",
        "marzo",
        "abril",
        "maio",
        "xu\xf1o",
        "xullo",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "decembro"
    ]
};
const $b89153b458fbd0a6$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "me",
        "xo",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "xov",
        "ven",
        "sab"
    ],
    wide: [
        "domingo",
        "luns",
        "martes",
        "m\xe9rcores",
        "xoves",
        "venres",
        "s\xe1bado"
    ]
};
const $b89153b458fbd0a6$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    }
};
const $b89153b458fbd0a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    }
};
const $b89153b458fbd0a6$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $b89153b458fbd0a6$var$localize = $b89153b458fbd0a6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b89153b458fbd0a6$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $b89153b458fbd0a6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $b89153b458fbd0a6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $b89153b458fbd0a6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $b89153b458fbd0a6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $b89153b458fbd0a6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b89153b458fbd0a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("akKPS", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $78601a3feea1ba34$export$4659b591c19bdf3d; }, function (v) { return $78601a3feea1ba34$export$4659b591c19bdf3d = v; });
var $78601a3feea1ba34$export$4659b591c19bdf3d;
"use strict";
$78601a3feea1ba34$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $78601a3feea1ba34$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $78601a3feea1ba34$var$parseOrdinalNumberPattern = /\d+/i;
const $78601a3feea1ba34$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
const $78601a3feea1ba34$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
const $78601a3feea1ba34$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $78601a3feea1ba34$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $78601a3feea1ba34$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
const $78601a3feea1ba34$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
const $78601a3feea1ba34$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
const $78601a3feea1ba34$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
const $78601a3feea1ba34$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
const $78601a3feea1ba34$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
const $78601a3feea1ba34$var$match = $78601a3feea1ba34$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $78601a3feea1ba34$var$matchOrdinalNumberPattern,
        parsePattern: $78601a3feea1ba34$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $78601a3feea1ba34$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $78601a3feea1ba34$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $78601a3feea1ba34$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $78601a3feea1ba34$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $78601a3feea1ba34$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $78601a3feea1ba34$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $78601a3feea1ba34$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $78601a3feea1ba34$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $78601a3feea1ba34$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $78601a3feea1ba34$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8DCVZ", function(module, exports) {

$parcel$export(module.exports, "gu", function () { return $64a02ad18c9e3635$export$85e91b8206de11f6; }, function (v) { return $64a02ad18c9e3635$export$85e91b8206de11f6 = v; });
var $64a02ad18c9e3635$export$85e91b8206de11f6;
"use strict";
$64a02ad18c9e3635$export$85e91b8206de11f6 = void 0;

var $f45A7 = parcelRequire("f45A7");

var $fCfBk = parcelRequire("fCfBk");

var $4eC8k = parcelRequire("4eC8k");

var $jS0UC = parcelRequire("jS0UC");

var $7Ro4C = parcelRequire("7Ro4C");
/**
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM](https://github.com/manadaym)
 */ const $64a02ad18c9e3635$var$gu = $64a02ad18c9e3635$export$85e91b8206de11f6 = {
    code: "gu",
    formatDistance: $f45A7.formatDistance,
    formatLong: $fCfBk.formatLong,
    formatRelative: $4eC8k.formatRelative,
    localize: $jS0UC.localize,
    match: $7Ro4C.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("f45A7", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $af7b8f24d9913ae8$export$2c14ff85d6318973; }, function (v) { return $af7b8f24d9913ae8$export$2c14ff85d6318973 = v; });
var $af7b8f24d9913ae8$export$2c14ff85d6318973;
"use strict";
$af7b8f24d9913ae8$export$2c14ff85d6318973 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $af7b8f24d9913ae8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
const $af7b8f24d9913ae8$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $af7b8f24d9913ae8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
$af7b8f24d9913ae8$export$2c14ff85d6318973 = $af7b8f24d9913ae8$var$formatDistance;

});

parcelRegister("fCfBk", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $b5e681a93beeb9b7$export$cbf60ecb96cbb82f; }, function (v) { return $b5e681a93beeb9b7$export$cbf60ecb96cbb82f = v; });
var $b5e681a93beeb9b7$export$cbf60ecb96cbb82f;
"use strict";
$b5e681a93beeb9b7$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
//Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $b5e681a93beeb9b7$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "d/M/yy"
};
const $b5e681a93beeb9b7$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    long: "hh:mm:ss a z",
    medium: "hh:mm:ss a",
    short: "hh:mm a"
};
const $b5e681a93beeb9b7$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $b5e681a93beeb9b7$var$formatLong = $b5e681a93beeb9b7$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $b5e681a93beeb9b7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $b5e681a93beeb9b7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $b5e681a93beeb9b7$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("4eC8k", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $31560cb982f79ffc$export$8fbbfd65594f46a0; }, function (v) { return $31560cb982f79ffc$export$8fbbfd65594f46a0 = v; });
var $31560cb982f79ffc$export$8fbbfd65594f46a0;
"use strict";
$31560cb982f79ffc$export$8fbbfd65594f46a0 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $31560cb982f79ffc$var$formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    today: "'\u0A86\u0A9C\u0AC7' p",
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    nextWeek: "eeee p",
    other: "P"
};
const $31560cb982f79ffc$var$formatRelative = (token, _date, _baseDate, _options)=>$31560cb982f79ffc$var$formatRelativeLocale[token];
$31560cb982f79ffc$export$8fbbfd65594f46a0 = $31560cb982f79ffc$var$formatRelative;

});

parcelRegister("jS0UC", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $e773c49c725156cf$export$b3bd0bc58e36cd63; }, function (v) { return $e773c49c725156cf$export$b3bd0bc58e36cd63 = v; });
var $e773c49c725156cf$export$b3bd0bc58e36cd63;
"use strict";
$e773c49c725156cf$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1621 - #1630
const $e773c49c725156cf$var$eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
const $e773c49c725156cf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
const $e773c49c725156cf$var$monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
const $e773c49c725156cf$var$dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
const $e773c49c725156cf$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
const $e773c49c725156cf$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
const $e773c49c725156cf$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $e773c49c725156cf$var$localize = $e773c49c725156cf$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e773c49c725156cf$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $e773c49c725156cf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $e773c49c725156cf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $e773c49c725156cf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $e773c49c725156cf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $e773c49c725156cf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e773c49c725156cf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7Ro4C", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5b902826d4b9bc68$export$4659b591c19bdf3d; }, function (v) { return $5b902826d4b9bc68$export$4659b591c19bdf3d = v; });
var $5b902826d4b9bc68$export$4659b591c19bdf3d;
"use strict";
$5b902826d4b9bc68$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $5b902826d4b9bc68$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
const $5b902826d4b9bc68$var$parseOrdinalNumberPattern = /\d+/i;
const $5b902826d4b9bc68$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
const $5b902826d4b9bc68$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
const $5b902826d4b9bc68$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
const $5b902826d4b9bc68$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $5b902826d4b9bc68$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
const $5b902826d4b9bc68$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
const $5b902826d4b9bc68$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
const $5b902826d4b9bc68$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
const $5b902826d4b9bc68$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
const $5b902826d4b9bc68$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
const $5b902826d4b9bc68$var$match = $5b902826d4b9bc68$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $5b902826d4b9bc68$var$matchOrdinalNumberPattern,
        parsePattern: $5b902826d4b9bc68$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5b902826d4b9bc68$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5b902826d4b9bc68$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5b902826d4b9bc68$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5b902826d4b9bc68$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5b902826d4b9bc68$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5b902826d4b9bc68$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5b902826d4b9bc68$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5b902826d4b9bc68$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5b902826d4b9bc68$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5b902826d4b9bc68$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("6jp7T", function(module, exports) {

$parcel$export(module.exports, "he", function () { return $49880202637ecd12$export$10cc7d172bb7969; }, function (v) { return $49880202637ecd12$export$10cc7d172bb7969 = v; });
var $49880202637ecd12$export$10cc7d172bb7969;
"use strict";
$49880202637ecd12$export$10cc7d172bb7969 = void 0;

var $4YKgQ = parcelRequire("4YKgQ");

var $6qNqO = parcelRequire("6qNqO");

var $fwtZU = parcelRequire("fwtZU");

var $1Jj8H = parcelRequire("1Jj8H");

var $ainFw = parcelRequire("ainFw");
/**
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah](https://github.com/nirlah)
 */ const $49880202637ecd12$var$he = $49880202637ecd12$export$10cc7d172bb7969 = {
    code: "he",
    formatDistance: $4YKgQ.formatDistance,
    formatLong: $6qNqO.formatLong,
    formatRelative: $fwtZU.formatRelative,
    localize: $1Jj8H.localize,
    match: $ainFw.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("4YKgQ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $3a00a86aa1c7c80c$export$2c14ff85d6318973; }, function (v) { return $3a00a86aa1c7c80c$export$2c14ff85d6318973 = v; });
var $3a00a86aa1c7c80c$export$2c14ff85d6318973;
"use strict";
$3a00a86aa1c7c80c$export$2c14ff85d6318973 = void 0;
const $3a00a86aa1c7c80c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
const $3a00a86aa1c7c80c$var$formatDistance = (token, count, options)=>{
    // Return word instead of `in one day` or `one day ago`
    if (token === "xDays" && options?.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    let result;
    const tokenValue = $3a00a86aa1c7c80c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
$3a00a86aa1c7c80c$export$2c14ff85d6318973 = $3a00a86aa1c7c80c$var$formatDistance;

});

parcelRegister("6qNqO", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $4aeb83d6c5c897bd$export$cbf60ecb96cbb82f; }, function (v) { return $4aeb83d6c5c897bd$export$cbf60ecb96cbb82f = v; });
var $4aeb83d6c5c897bd$export$cbf60ecb96cbb82f;
"use strict";
$4aeb83d6c5c897bd$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $4aeb83d6c5c897bd$var$dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: "d.M.y"
};
const $4aeb83d6c5c897bd$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $4aeb83d6c5c897bd$var$dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $4aeb83d6c5c897bd$var$formatLong = $4aeb83d6c5c897bd$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $4aeb83d6c5c897bd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $4aeb83d6c5c897bd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $4aeb83d6c5c897bd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fwtZU", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b4d11d1591e5ab54$export$8fbbfd65594f46a0; }, function (v) { return $b4d11d1591e5ab54$export$8fbbfd65594f46a0 = v; });
var $b4d11d1591e5ab54$export$8fbbfd65594f46a0;
"use strict";
$b4d11d1591e5ab54$export$8fbbfd65594f46a0 = void 0;
const $b4d11d1591e5ab54$var$formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: "P"
};
const $b4d11d1591e5ab54$var$formatRelative = (token, _date, _baseDate, _options)=>$b4d11d1591e5ab54$var$formatRelativeLocale[token];
$b4d11d1591e5ab54$export$8fbbfd65594f46a0 = $b4d11d1591e5ab54$var$formatRelative;

});

parcelRegister("1Jj8H", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $1428d7100d43e525$export$b3bd0bc58e36cd63; }, function (v) { return $1428d7100d43e525$export$b3bd0bc58e36cd63 = v; });
var $1428d7100d43e525$export$b3bd0bc58e36cd63;
"use strict";
$1428d7100d43e525$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $1428d7100d43e525$var$eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
const $1428d7100d43e525$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
const $1428d7100d43e525$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
const $1428d7100d43e525$var$dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
const $1428d7100d43e525$var$dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
const $1428d7100d43e525$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
const $1428d7100d43e525$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    const unit = String(options?.unit);
    const isFemale = [
        "year",
        "hour",
        "minute",
        "second"
    ].indexOf(unit) >= 0;
    const male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    const female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    const index = number - 1;
    return isFemale ? female[index] : male[index];
};
const $1428d7100d43e525$var$localize = $1428d7100d43e525$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1428d7100d43e525$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $1428d7100d43e525$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $1428d7100d43e525$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $1428d7100d43e525$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $1428d7100d43e525$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $1428d7100d43e525$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1428d7100d43e525$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("ainFw", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $77edf1ede4a49c2c$export$4659b591c19bdf3d; }, function (v) { return $77edf1ede4a49c2c$export$4659b591c19bdf3d = v; });
var $77edf1ede4a49c2c$export$4659b591c19bdf3d;
"use strict";
$77edf1ede4a49c2c$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $77edf1ede4a49c2c$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
const $77edf1ede4a49c2c$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
const $77edf1ede4a49c2c$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
const $77edf1ede4a49c2c$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
const $77edf1ede4a49c2c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
const $77edf1ede4a49c2c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $77edf1ede4a49c2c$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
const $77edf1ede4a49c2c$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
const $77edf1ede4a49c2c$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
const $77edf1ede4a49c2c$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
const $77edf1ede4a49c2c$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
const $77edf1ede4a49c2c$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
const $77edf1ede4a49c2c$var$ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
const $77edf1ede4a49c2c$var$match = $77edf1ede4a49c2c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $77edf1ede4a49c2c$var$matchOrdinalNumberPattern,
        parsePattern: $77edf1ede4a49c2c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>{
            const number = parseInt(value, 10);
            return isNaN(number) ? $77edf1ede4a49c2c$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $77edf1ede4a49c2c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77edf1ede4a49c2c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $77edf1ede4a49c2c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77edf1ede4a49c2c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $77edf1ede4a49c2c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77edf1ede4a49c2c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $77edf1ede4a49c2c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77edf1ede4a49c2c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $77edf1ede4a49c2c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $77edf1ede4a49c2c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("dYmvp", function(module, exports) {

$parcel$export(module.exports, "hi", function () { return $a2c2561bde0e12da$export$43bde67df112d15b; }, function (v) { return $a2c2561bde0e12da$export$43bde67df112d15b = v; });
var $a2c2561bde0e12da$export$43bde67df112d15b;
"use strict";
$a2c2561bde0e12da$export$43bde67df112d15b = void 0;

var $hmaoM = parcelRequire("hmaoM");

var $jG7ft = parcelRequire("jG7ft");

var $5S0q9 = parcelRequire("5S0q9");

var $bbNcj = parcelRequire("bbNcj");

var $8jR2o = parcelRequire("8jR2o");
/**
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal](https://github.com/mukeshmandiwal)
 */ const $a2c2561bde0e12da$var$hi = $a2c2561bde0e12da$export$43bde67df112d15b = {
    code: "hi",
    formatDistance: $hmaoM.formatDistance,
    formatLong: $jG7ft.formatLong,
    formatRelative: $5S0q9.formatRelative,
    localize: $bbNcj.localize,
    match: $8jR2o.match,
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("hmaoM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ca2c8eaf4da180b0$export$2c14ff85d6318973; }, function (v) { return $ca2c8eaf4da180b0$export$2c14ff85d6318973 = v; });
var $ca2c8eaf4da180b0$export$2c14ff85d6318973;
"use strict";
$ca2c8eaf4da180b0$export$2c14ff85d6318973 = void 0;

var $bbNcj = parcelRequire("bbNcj");
// Source: https://www.unicode.org/cldr/charts/32/summary/hi.html
const $ca2c8eaf4da180b0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        other: "{{count}} \u0918\u0902\u091F\u0947"
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
const $ca2c8eaf4da180b0$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ca2c8eaf4da180b0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $bbNcj.numberToLocale)(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
$ca2c8eaf4da180b0$export$2c14ff85d6318973 = $ca2c8eaf4da180b0$var$formatDistance;

});
parcelRegister("bbNcj", function(module, exports) {

$parcel$export(module.exports, "localeToNumber", function () { return $8256e26339291f46$export$b431cabd737c2a; }, function (v) { return $8256e26339291f46$export$b431cabd737c2a = v; });
$parcel$export(module.exports, "localize", function () { return $8256e26339291f46$export$b3bd0bc58e36cd63; }, function (v) { return $8256e26339291f46$export$b3bd0bc58e36cd63 = v; });
$parcel$export(module.exports, "numberToLocale", function () { return $8256e26339291f46$export$3e1d599946644f03; }, function (v) { return $8256e26339291f46$export$3e1d599946644f03 = v; });
var $8256e26339291f46$export$b431cabd737c2a;
var $8256e26339291f46$export$b3bd0bc58e36cd63;
var $8256e26339291f46$export$3e1d599946644f03;
"use strict";
$8256e26339291f46$export$b431cabd737c2a = $8256e26339291f46$var$localeToNumber;
$8256e26339291f46$export$b3bd0bc58e36cd63 = void 0;
$8256e26339291f46$export$3e1d599946644f03 = $8256e26339291f46$var$numberToLocale;

var $bhSfH = parcelRequire("bhSfH");
const $8256e26339291f46$var$numberValues = {
    locale: {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    },
    number: {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096A": "4",
        "\u096B": "5",
        "\u096C": "6",
        "\u096D": "7",
        "\u096E": "8",
        "\u096F": "9",
        "\u0966": "0"
    }
};
// CLDR #1585 - #1592
const $8256e26339291f46$var$eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
const $8256e26339291f46$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
const $8256e26339291f46$var$monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
const $8256e26339291f46$var$dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
const $8256e26339291f46$var$dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
const $8256e26339291f46$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
const $8256e26339291f46$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return $8256e26339291f46$var$numberToLocale(number);
};
function $8256e26339291f46$var$localeToNumber(locale) {
    const enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $8256e26339291f46$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $8256e26339291f46$var$numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $8256e26339291f46$var$numberValues.locale[match];
    });
}
const $8256e26339291f46$var$localize = $8256e26339291f46$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8256e26339291f46$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $8256e26339291f46$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $8256e26339291f46$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $8256e26339291f46$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $8256e26339291f46$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $8256e26339291f46$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8256e26339291f46$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});


parcelRegister("jG7ft", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $e5378ff6563c8641$export$cbf60ecb96cbb82f; }, function (v) { return $e5378ff6563c8641$export$cbf60ecb96cbb82f = v; });
var $e5378ff6563c8641$export$cbf60ecb96cbb82f;
"use strict";
$e5378ff6563c8641$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $e5378ff6563c8641$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $e5378ff6563c8641$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $e5378ff6563c8641$var$dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    long: "{{date}} '\u0915\u094B' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $e5378ff6563c8641$var$formatLong = $e5378ff6563c8641$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $e5378ff6563c8641$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $e5378ff6563c8641$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $e5378ff6563c8641$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("5S0q9", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $446252776f33dc98$export$8fbbfd65594f46a0; }, function (v) { return $446252776f33dc98$export$8fbbfd65594f46a0 = v; });
var $446252776f33dc98$export$8fbbfd65594f46a0;
"use strict";
$446252776f33dc98$export$8fbbfd65594f46a0 = void 0;
const $446252776f33dc98$var$formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: "P"
};
const $446252776f33dc98$var$formatRelative = (token, _date, _baseDate, _options)=>$446252776f33dc98$var$formatRelativeLocale[token];
$446252776f33dc98$export$8fbbfd65594f46a0 = $446252776f33dc98$var$formatRelative;

});

parcelRegister("8jR2o", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $60e93d3f8c686409$export$4659b591c19bdf3d; }, function (v) { return $60e93d3f8c686409$export$4659b591c19bdf3d = v; });
var $60e93d3f8c686409$export$4659b591c19bdf3d;
"use strict";
$60e93d3f8c686409$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");

var $bbNcj = parcelRequire("bbNcj");
const $60e93d3f8c686409$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
const $60e93d3f8c686409$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
const $60e93d3f8c686409$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
const $60e93d3f8c686409$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $60e93d3f8c686409$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
const $60e93d3f8c686409$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $60e93d3f8c686409$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
const $60e93d3f8c686409$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
const $60e93d3f8c686409$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
const $60e93d3f8c686409$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
const $60e93d3f8c686409$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
const $60e93d3f8c686409$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
const $60e93d3f8c686409$var$match = $60e93d3f8c686409$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $60e93d3f8c686409$var$matchOrdinalNumberPattern,
        parsePattern: $60e93d3f8c686409$var$parseOrdinalNumberPattern,
        valueCallback: $bbNcj.localeToNumber
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $60e93d3f8c686409$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $60e93d3f8c686409$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $60e93d3f8c686409$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $60e93d3f8c686409$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $60e93d3f8c686409$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $60e93d3f8c686409$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $60e93d3f8c686409$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $60e93d3f8c686409$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $60e93d3f8c686409$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $60e93d3f8c686409$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("bvEwX", function(module, exports) {

$parcel$export(module.exports, "hr", function () { return $861207818387e51c$export$b4adb3f464574dcf; }, function (v) { return $861207818387e51c$export$b4adb3f464574dcf = v; });
var $861207818387e51c$export$b4adb3f464574dcf;
"use strict";
$861207818387e51c$export$b4adb3f464574dcf = void 0;

var $hwAtw = parcelRequire("hwAtw");

var $6dwfN = parcelRequire("6dwfN");

var $1T7ZQ = parcelRequire("1T7ZQ");

var $4MwpL = parcelRequire("4MwpL");

var $hjIcJ = parcelRequire("hjIcJ");
/**
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon](https://github.com/silvenon)
 * @author Manico [@manico](https://github.com/manico)
 * @author Ivan Jeržabek [@jerzabek](https://github.com/jerzabek)
 */ const $861207818387e51c$var$hr = $861207818387e51c$export$b4adb3f464574dcf = {
    code: "hr",
    formatDistance: $hwAtw.formatDistance,
    formatLong: $6dwfN.formatLong,
    formatRelative: $1T7ZQ.formatRelative,
    localize: $4MwpL.localize,
    match: $hjIcJ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("hwAtw", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $cc21b806bbb8f2dc$export$2c14ff85d6318973; }, function (v) { return $cc21b806bbb8f2dc$export$2c14ff85d6318973 = v; });
var $cc21b806bbb8f2dc$export$2c14ff85d6318973;
"use strict";
$cc21b806bbb8f2dc$export$2c14ff85d6318973 = void 0;
const $cc21b806bbb8f2dc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 tjedan",
            withPrepositionAgo: "oko 1 tjedan",
            withPrepositionIn: "oko 1 tjedan"
        },
        dual: "oko {{count}} tjedna",
        other: "oko {{count}} tjedana"
    },
    xWeeks: {
        one: {
            standalone: "1 tjedan",
            withPrepositionAgo: "1 tjedan",
            withPrepositionIn: "1 tjedan"
        },
        dual: "{{count}} tjedna",
        other: "{{count}} tjedana"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $cc21b806bbb8f2dc$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $cc21b806bbb8f2dc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
$cc21b806bbb8f2dc$export$2c14ff85d6318973 = $cc21b806bbb8f2dc$var$formatDistance;

});

parcelRegister("6dwfN", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $486cf9e6643d859f$export$cbf60ecb96cbb82f; }, function (v) { return $486cf9e6643d859f$export$cbf60ecb96cbb82f = v; });
var $486cf9e6643d859f$export$cbf60ecb96cbb82f;
"use strict";
$486cf9e6643d859f$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $486cf9e6643d859f$var$dateFormats = {
    full: "EEEE, d. MMMM y.",
    long: "d. MMMM y.",
    medium: "d. MMM y.",
    short: "dd. MM. y."
};
const $486cf9e6643d859f$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $486cf9e6643d859f$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $486cf9e6643d859f$var$formatLong = $486cf9e6643d859f$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $486cf9e6643d859f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $486cf9e6643d859f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $486cf9e6643d859f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("1T7ZQ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $1601216b74620518$export$8fbbfd65594f46a0; }, function (v) { return $1601216b74620518$export$8fbbfd65594f46a0 = v; });
var $1601216b74620518$export$8fbbfd65594f46a0;
"use strict";
$1601216b74620518$export$8fbbfd65594f46a0 = void 0;
const $1601216b74620518$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: "P"
};
const $1601216b74620518$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $1601216b74620518$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$1601216b74620518$export$8fbbfd65594f46a0 = $1601216b74620518$var$formatRelative;

});

parcelRegister("4MwpL", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $37b4c9f9f31177bd$export$b3bd0bc58e36cd63; }, function (v) { return $37b4c9f9f31177bd$export$b3bd0bc58e36cd63 = v; });
var $37b4c9f9f31177bd$export$b3bd0bc58e36cd63;
"use strict";
$37b4c9f9f31177bd$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $37b4c9f9f31177bd$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Kr.",
        "po. Kr."
    ],
    wide: [
        "Prije Krista",
        "Poslije Krista"
    ]
};
const $37b4c9f9f31177bd$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $37b4c9f9f31177bd$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        "travanj",
        "svibanj",
        "lipanj",
        "srpanj",
        "kolovoz",
        "rujan",
        "listopad",
        "studeni",
        "prosinac"
    ]
};
const $37b4c9f9f31177bd$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        "travnja",
        "svibnja",
        "lipnja",
        "srpnja",
        "kolovoza",
        "rujna",
        "listopada",
        "studenog",
        "prosinca"
    ]
};
const $37b4c9f9f31177bd$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $37b4c9f9f31177bd$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
const $37b4c9f9f31177bd$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
const $37b4c9f9f31177bd$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $37b4c9f9f31177bd$var$localize = $37b4c9f9f31177bd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $37b4c9f9f31177bd$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $37b4c9f9f31177bd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $37b4c9f9f31177bd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $37b4c9f9f31177bd$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $37b4c9f9f31177bd$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $37b4c9f9f31177bd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $37b4c9f9f31177bd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $37b4c9f9f31177bd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("hjIcJ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $c9b680199a9a5445$export$4659b591c19bdf3d; }, function (v) { return $c9b680199a9a5445$export$4659b591c19bdf3d = v; });
var $c9b680199a9a5445$export$4659b591c19bdf3d;
"use strict";
$c9b680199a9a5445$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $c9b680199a9a5445$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $c9b680199a9a5445$var$parseOrdinalNumberPattern = /\d+/i;
const $c9b680199a9a5445$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
const $c9b680199a9a5445$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $c9b680199a9a5445$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $c9b680199a9a5445$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c9b680199a9a5445$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
const $c9b680199a9a5445$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
const $c9b680199a9a5445$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $c9b680199a9a5445$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $c9b680199a9a5445$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
const $c9b680199a9a5445$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
const $c9b680199a9a5445$var$match = $c9b680199a9a5445$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $c9b680199a9a5445$var$matchOrdinalNumberPattern,
        parsePattern: $c9b680199a9a5445$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c9b680199a9a5445$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c9b680199a9a5445$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c9b680199a9a5445$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c9b680199a9a5445$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c9b680199a9a5445$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c9b680199a9a5445$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c9b680199a9a5445$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c9b680199a9a5445$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c9b680199a9a5445$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c9b680199a9a5445$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("fiAne", function(module, exports) {

$parcel$export(module.exports, "ht", function () { return $b234c080a70e1861$export$f1db1a98c1e73c14; }, function (v) { return $b234c080a70e1861$export$f1db1a98c1e73c14 = v; });
var $b234c080a70e1861$export$f1db1a98c1e73c14;
"use strict";
$b234c080a70e1861$export$f1db1a98c1e73c14 = void 0;

var $h2MxR = parcelRequire("h2MxR");

var $jnNPQ = parcelRequire("jnNPQ");

var $hjU9f = parcelRequire("hjU9f");

var $5buSS = parcelRequire("5buSS");

var $eUXZM = parcelRequire("eUXZM");
/**
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo](https://github.com/rmariuzzo)
 * @author Watson Marcelain [@watsongm24](https://github.com/watsongm24)
 */ const $b234c080a70e1861$var$ht = $b234c080a70e1861$export$f1db1a98c1e73c14 = {
    code: "ht",
    formatDistance: $h2MxR.formatDistance,
    formatLong: $jnNPQ.formatLong,
    formatRelative: $hjU9f.formatRelative,
    localize: $5buSS.localize,
    match: $eUXZM.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("h2MxR", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $c68847a50f081525$export$2c14ff85d6318973; }, function (v) { return $c68847a50f081525$export$2c14ff85d6318973 = v; });
var $c68847a50f081525$export$2c14ff85d6318973;
"use strict";
$c68847a50f081525$export$2c14ff85d6318973 = void 0;
const $c68847a50f081525$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mwens pase yon segond",
        other: "mwens pase {{count}} segond"
    },
    xSeconds: {
        one: "1 segond",
        other: "{{count}} segond"
    },
    halfAMinute: "30 segond",
    lessThanXMinutes: {
        one: "mwens pase yon minit",
        other: "mwens pase {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: "1 jou",
        other: "{{count}} jou"
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: "anviwon 1 mwa",
        other: "anviwon {{count}} mwa"
    },
    xMonths: {
        one: "1 mwa",
        other: "{{count}} mwa"
    },
    aboutXYears: {
        one: "anviwon 1 an",
        other: "anviwon {{count}} an"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} an"
    },
    overXYears: {
        one: "plis pase 1 an",
        other: "plis pase {{count}} an"
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
const $c68847a50f081525$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c68847a50f081525$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "nan " + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
$c68847a50f081525$export$2c14ff85d6318973 = $c68847a50f081525$var$formatDistance;

});

parcelRegister("jnNPQ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $e1c6d282dfb54394$export$cbf60ecb96cbb82f; }, function (v) { return $e1c6d282dfb54394$export$cbf60ecb96cbb82f = v; });
var $e1c6d282dfb54394$export$cbf60ecb96cbb82f;
"use strict";
$e1c6d282dfb54394$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $e1c6d282dfb54394$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $e1c6d282dfb54394$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $e1c6d282dfb54394$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $e1c6d282dfb54394$var$formatLong = $e1c6d282dfb54394$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $e1c6d282dfb54394$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $e1c6d282dfb54394$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $e1c6d282dfb54394$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("hjU9f", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c9bfc3d926399b66$export$8fbbfd65594f46a0; }, function (v) { return $c9bfc3d926399b66$export$8fbbfd65594f46a0 = v; });
var $c9bfc3d926399b66$export$8fbbfd65594f46a0;
"use strict";
$c9bfc3d926399b66$export$8fbbfd65594f46a0 = void 0;
const $c9bfc3d926399b66$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: "P"
};
const $c9bfc3d926399b66$var$formatRelative = (token, _date, _baseDate, _options)=>$c9bfc3d926399b66$var$formatRelativeLocale[token];
$c9bfc3d926399b66$export$8fbbfd65594f46a0 = $c9bfc3d926399b66$var$formatRelative;

});

parcelRegister("5buSS", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3c65efc5dd1cf93e$export$b3bd0bc58e36cd63; }, function (v) { return $3c65efc5dd1cf93e$export$b3bd0bc58e36cd63 = v; });
var $3c65efc5dd1cf93e$export$b3bd0bc58e36cd63;
"use strict";
$3c65efc5dd1cf93e$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $3c65efc5dd1cf93e$var$eraValues = {
    narrow: [
        "av. J.-K",
        "ap. J.-K"
    ],
    abbreviated: [
        "av. J.-K",
        "ap. J.-K"
    ],
    wide: [
        "anvan Jezi Kris",
        "apre Jezi Kris"
    ]
};
const $3c65efc5dd1cf93e$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1ye trim.",
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
const $3c65efc5dd1cf93e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "fevr.",
        "mas",
        "avr.",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "sept.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "janvye",
        "fevrye",
        "mas",
        "avril",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "septanm",
        "okt\xf2b",
        "novanm",
        "desanm"
    ]
};
const $3c65efc5dd1cf93e$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "le",
        "ma",
        "m\xe8",
        "je",
        "va",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "len.",
        "mad.",
        "m\xe8k.",
        "jed.",
        "van.",
        "sam."
    ],
    wide: [
        "dimanch",
        "lendi",
        "madi",
        "m\xe8kredi",
        "jedi",
        "vandredi",
        "samdi"
    ]
};
const $3c65efc5dd1cf93e$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "swa",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "maten",
        afternoon: "apr\xe8midi",
        evening: "swa",
        night: "maten"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "nan maten",
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: "nan maten"
    }
};
const $3c65efc5dd1cf93e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    if (number === 0) return String(number);
    const suffix = number === 1 ? "ye" : "y\xe8m";
    return number + suffix;
};
const $3c65efc5dd1cf93e$var$localize = $3c65efc5dd1cf93e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3c65efc5dd1cf93e$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $3c65efc5dd1cf93e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $3c65efc5dd1cf93e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $3c65efc5dd1cf93e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $3c65efc5dd1cf93e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $3c65efc5dd1cf93e$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("eUXZM", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $adc4d5855450fa34$export$4659b591c19bdf3d; }, function (v) { return $adc4d5855450fa34$export$4659b591c19bdf3d = v; });
var $adc4d5855450fa34$export$4659b591c19bdf3d;
"use strict";
$adc4d5855450fa34$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $adc4d5855450fa34$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
const $adc4d5855450fa34$var$parseOrdinalNumberPattern = /\d+/i;
const $adc4d5855450fa34$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
const $adc4d5855450fa34$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $adc4d5855450fa34$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
const $adc4d5855450fa34$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $adc4d5855450fa34$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
const $adc4d5855450fa34$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
const $adc4d5855450fa34$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
const $adc4d5855450fa34$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
const $adc4d5855450fa34$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
const $adc4d5855450fa34$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
const $adc4d5855450fa34$var$match = $adc4d5855450fa34$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $adc4d5855450fa34$var$matchOrdinalNumberPattern,
        parsePattern: $adc4d5855450fa34$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adc4d5855450fa34$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $adc4d5855450fa34$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adc4d5855450fa34$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $adc4d5855450fa34$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adc4d5855450fa34$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $adc4d5855450fa34$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adc4d5855450fa34$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $adc4d5855450fa34$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $adc4d5855450fa34$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $adc4d5855450fa34$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("eCK0b", function(module, exports) {

$parcel$export(module.exports, "hu", function () { return $aa584c578de66d95$export$9901d21957972d53; }, function (v) { return $aa584c578de66d95$export$9901d21957972d53 = v; });
var $aa584c578de66d95$export$9901d21957972d53;
"use strict";
$aa584c578de66d95$export$9901d21957972d53 = void 0;

var $kSkQW = parcelRequire("kSkQW");

var $aaqmx = parcelRequire("aaqmx");

var $k39ey = parcelRequire("k39ey");

var $2leMa = parcelRequire("2leMa");

var $1GVuF = parcelRequire("1GVuF");
/**
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
 * @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
 * @author Zoltan Szepesi [@twodcube](https://github.com/twodcube)
 */ const $aa584c578de66d95$var$hu = $aa584c578de66d95$export$9901d21957972d53 = {
    code: "hu",
    formatDistance: $kSkQW.formatDistance,
    formatLong: $aaqmx.formatLong,
    formatRelative: $k39ey.formatRelative,
    localize: $2leMa.localize,
    match: $1GVuF.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("kSkQW", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f32906ba612ad6ee$export$2c14ff85d6318973; }, function (v) { return $f32906ba612ad6ee$export$2c14ff85d6318973 = v; });
var $f32906ba612ad6ee$export$2c14ff85d6318973;
"use strict";
$f32906ba612ad6ee$export$2c14ff85d6318973 = void 0;
const $f32906ba612ad6ee$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: "majdnem",
    lessthan: "kevesebb mint"
};
const $f32906ba612ad6ee$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: " perc",
    xhours: " \xf3ra",
    xdays: " nap",
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
const $f32906ba612ad6ee$var$withSuffixes = {
    xseconds: {
        "-1": " m\xe1sodperccel ezel\u0151tt",
        1: " m\xe1sodperc m\xfalva",
        0: " m\xe1sodperce"
    },
    halfaminute: {
        "-1": "f\xe9l perccel ezel\u0151tt",
        1: "f\xe9l perc m\xfalva",
        0: "f\xe9l perce"
    },
    xminutes: {
        "-1": " perccel ezel\u0151tt",
        1: " perc m\xfalva",
        0: " perce"
    },
    xhours: {
        "-1": " \xf3r\xe1val ezel\u0151tt",
        1: " \xf3ra m\xfalva",
        0: " \xf3r\xe1ja"
    },
    xdays: {
        "-1": " nappal ezel\u0151tt",
        1: " nap m\xfalva",
        0: " napja"
    },
    xweeks: {
        "-1": " h\xe9ttel ezel\u0151tt",
        1: " h\xe9t m\xfalva",
        0: " hete"
    },
    xmonths: {
        "-1": " h\xf3nappal ezel\u0151tt",
        1: " h\xf3nap m\xfalva",
        0: " h\xf3napja"
    },
    xyears: {
        "-1": " \xe9vvel ezel\u0151tt",
        1: " \xe9v m\xfalva",
        0: " \xe9ve"
    }
};
const $f32906ba612ad6ee$var$formatDistance = (token, count, options)=>{
    const adverb = token.match(/about|over|almost|lessthan/i);
    const unit = adverb ? token.replace(adverb[0], "") : token;
    const addSuffix = options?.addSuffix === true;
    const key = unit.toLowerCase();
    const comparison = options?.comparison || 0;
    const translated = addSuffix ? $f32906ba612ad6ee$var$withSuffixes[key][comparison] : $f32906ba612ad6ee$var$withoutSuffixes[key];
    let result = key === "halfaminute" ? translated : count + translated;
    if (adverb) {
        const adv = adverb[0].toLowerCase();
        result = $f32906ba612ad6ee$var$translations[adv] + " " + result;
    }
    return result;
};
$f32906ba612ad6ee$export$2c14ff85d6318973 = $f32906ba612ad6ee$var$formatDistance;

});

parcelRegister("aaqmx", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $766f49989c0ec0ec$export$cbf60ecb96cbb82f; }, function (v) { return $766f49989c0ec0ec$export$cbf60ecb96cbb82f = v; });
var $766f49989c0ec0ec$export$cbf60ecb96cbb82f;
"use strict";
$766f49989c0ec0ec$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $766f49989c0ec0ec$var$dateFormats = {
    full: "y. MMMM d., EEEE",
    long: "y. MMMM d.",
    medium: "y. MMM d.",
    short: "y. MM. dd."
};
const $766f49989c0ec0ec$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $766f49989c0ec0ec$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $766f49989c0ec0ec$var$formatLong = $766f49989c0ec0ec$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $766f49989c0ec0ec$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $766f49989c0ec0ec$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $766f49989c0ec0ec$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("k39ey", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e98b40170c912938$export$8fbbfd65594f46a0; }, function (v) { return $e98b40170c912938$export$8fbbfd65594f46a0 = v; });
var $e98b40170c912938$export$8fbbfd65594f46a0;
"use strict";
$e98b40170c912938$export$8fbbfd65594f46a0 = void 0;
const $e98b40170c912938$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    "kedden",
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    "szombaton"
];
function $e98b40170c912938$var$week(isFuture) {
    return (date)=>{
        const weekday = $e98b40170c912938$var$accusativeWeekdays[date.getDay()];
        const prefix = isFuture ? "" : "'m\xfalt' ";
        return `${prefix}'${weekday}' p'-kor'`;
    };
}
const $e98b40170c912938$var$formatRelativeLocale = {
    lastWeek: $e98b40170c912938$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $e98b40170c912938$var$week(true),
    other: "P"
};
const $e98b40170c912938$var$formatRelative = (token, date)=>{
    const format = $e98b40170c912938$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$e98b40170c912938$export$8fbbfd65594f46a0 = $e98b40170c912938$var$formatRelative;

});

parcelRegister("2leMa", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $1b4901196c0b446c$export$b3bd0bc58e36cd63; }, function (v) { return $1b4901196c0b446c$export$b3bd0bc58e36cd63 = v; });
var $1b4901196c0b446c$export$b3bd0bc58e36cd63;
"use strict";
$1b4901196c0b446c$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $1b4901196c0b446c$var$eraValues = {
    narrow: [
        "ie.",
        "isz."
    ],
    abbreviated: [
        "i. e.",
        "i. sz."
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
const $1b4901196c0b446c$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
const $1b4901196c0b446c$var$formattingQuarterValues = {
    narrow: [
        "I.",
        "II.",
        "III.",
        "IV."
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
const $1b4901196c0b446c$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "\xc1",
        "M",
        "J",
        "J",
        "A",
        "Sz",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "febr.",
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        "aug.",
        "szept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        "augusztus",
        "szeptember",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
const $1b4901196c0b446c$var$dayValues = {
    narrow: [
        "V",
        "H",
        "K",
        "Sz",
        "Cs",
        "P",
        "Sz"
    ],
    short: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    abbreviated: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        "kedd",
        "szerda",
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        "szombat"
    ]
};
const $1b4901196c0b446c$var$dayPeriodValues = {
    narrow: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    abbreviated: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    wide: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "d\xe9lut\xe1n",
        evening: "este",
        night: "\xe9jjel"
    }
};
const $1b4901196c0b446c$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $1b4901196c0b446c$var$localize = $1b4901196c0b446c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1b4901196c0b446c$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $1b4901196c0b446c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $1b4901196c0b446c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1,
        formattingValues: $1b4901196c0b446c$var$formattingQuarterValues,
        defaultFormattingWidth: "wide"
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $1b4901196c0b446c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $1b4901196c0b446c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $1b4901196c0b446c$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("1GVuF", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $13b64fb376bbdb95$export$4659b591c19bdf3d; }, function (v) { return $13b64fb376bbdb95$export$4659b591c19bdf3d = v; });
var $13b64fb376bbdb95$export$4659b591c19bdf3d;
"use strict";
$13b64fb376bbdb95$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $13b64fb376bbdb95$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $13b64fb376bbdb95$var$parseOrdinalNumberPattern = /\d+/i;
const $13b64fb376bbdb95$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
const $13b64fb376bbdb95$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
const $13b64fb376bbdb95$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
const $13b64fb376bbdb95$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
const $13b64fb376bbdb95$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
const $13b64fb376bbdb95$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $13b64fb376bbdb95$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
const $13b64fb376bbdb95$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
const $13b64fb376bbdb95$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
const $13b64fb376bbdb95$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
const $13b64fb376bbdb95$var$match = $13b64fb376bbdb95$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $13b64fb376bbdb95$var$matchOrdinalNumberPattern,
        parsePattern: $13b64fb376bbdb95$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $13b64fb376bbdb95$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $13b64fb376bbdb95$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $13b64fb376bbdb95$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $13b64fb376bbdb95$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $13b64fb376bbdb95$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $13b64fb376bbdb95$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $13b64fb376bbdb95$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $13b64fb376bbdb95$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $13b64fb376bbdb95$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $13b64fb376bbdb95$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("2ptiC", function(module, exports) {

$parcel$export(module.exports, "hy", function () { return $1c14a4d0d231647c$export$2fe4a56bcaea74cb; }, function (v) { return $1c14a4d0d231647c$export$2fe4a56bcaea74cb = v; });
var $1c14a4d0d231647c$export$2fe4a56bcaea74cb;
"use strict";
$1c14a4d0d231647c$export$2fe4a56bcaea74cb = void 0;

var $eFT23 = parcelRequire("eFT23");

var $ikMn9 = parcelRequire("ikMn9");

var $k6ivo = parcelRequire("k6ivo");

var $8yb2R = parcelRequire("8yb2R");

var $7ndyc = parcelRequire("7ndyc");
/**
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan](https://github.com/alexigityan)
 */ const $1c14a4d0d231647c$var$hy = $1c14a4d0d231647c$export$2fe4a56bcaea74cb = {
    code: "hy",
    formatDistance: $eFT23.formatDistance,
    formatLong: $ikMn9.formatLong,
    formatRelative: $k6ivo.formatRelative,
    localize: $8yb2R.localize,
    match: $7ndyc.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("eFT23", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $aaef953cda282639$export$2c14ff85d6318973; }, function (v) { return $aaef953cda282639$export$2c14ff85d6318973 = v; });
var $aaef953cda282639$export$2c14ff85d6318973;
"use strict";
$aaef953cda282639$export$2c14ff85d6318973 = void 0;
const $aaef953cda282639$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
const $aaef953cda282639$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $aaef953cda282639$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
$aaef953cda282639$export$2c14ff85d6318973 = $aaef953cda282639$var$formatDistance;

});

parcelRegister("ikMn9", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d58f9e013f0f8f82$export$cbf60ecb96cbb82f; }, function (v) { return $d58f9e013f0f8f82$export$cbf60ecb96cbb82f = v; });
var $d58f9e013f0f8f82$export$cbf60ecb96cbb82f;
"use strict";
$d58f9e013f0f8f82$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $d58f9e013f0f8f82$var$dateFormats = {
    full: "d MMMM, y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd.MM.yyyy"
};
const $d58f9e013f0f8f82$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $d58f9e013f0f8f82$var$dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $d58f9e013f0f8f82$var$formatLong = $d58f9e013f0f8f82$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $d58f9e013f0f8f82$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $d58f9e013f0f8f82$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $d58f9e013f0f8f82$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("k6ivo", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ea22b8f481fb6b71$export$8fbbfd65594f46a0; }, function (v) { return $ea22b8f481fb6b71$export$8fbbfd65594f46a0 = v; });
var $ea22b8f481fb6b71$export$8fbbfd65594f46a0;
"use strict";
$ea22b8f481fb6b71$export$8fbbfd65594f46a0 = void 0;
const $ea22b8f481fb6b71$var$formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: "P"
};
const $ea22b8f481fb6b71$var$formatRelative = (token, _date, _baseDate, _options)=>$ea22b8f481fb6b71$var$formatRelativeLocale[token];
$ea22b8f481fb6b71$export$8fbbfd65594f46a0 = $ea22b8f481fb6b71$var$formatRelative;

});

parcelRegister("8yb2R", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $639a1107b777e9e6$export$b3bd0bc58e36cd63; }, function (v) { return $639a1107b777e9e6$export$b3bd0bc58e36cd63 = v; });
var $639a1107b777e9e6$export$b3bd0bc58e36cd63;
"use strict";
$639a1107b777e9e6$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $639a1107b777e9e6$var$eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
const $639a1107b777e9e6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
const $639a1107b777e9e6$var$monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
const $639a1107b777e9e6$var$dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
const $639a1107b777e9e6$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
const $639a1107b777e9e6$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
const $639a1107b777e9e6$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
const $639a1107b777e9e6$var$localize = $639a1107b777e9e6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $639a1107b777e9e6$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $639a1107b777e9e6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $639a1107b777e9e6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $639a1107b777e9e6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $639a1107b777e9e6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $639a1107b777e9e6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $639a1107b777e9e6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7ndyc", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $55e531462a78c52a$export$4659b591c19bdf3d; }, function (v) { return $55e531462a78c52a$export$4659b591c19bdf3d = v; });
var $55e531462a78c52a$export$4659b591c19bdf3d;
"use strict";
$55e531462a78c52a$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $55e531462a78c52a$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
const $55e531462a78c52a$var$parseOrdinalNumberPattern = /\d+/i;
const $55e531462a78c52a$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
const $55e531462a78c52a$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
const $55e531462a78c52a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
const $55e531462a78c52a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $55e531462a78c52a$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
const $55e531462a78c52a$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
const $55e531462a78c52a$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
const $55e531462a78c52a$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
const $55e531462a78c52a$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
const $55e531462a78c52a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
const $55e531462a78c52a$var$match = $55e531462a78c52a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $55e531462a78c52a$var$matchOrdinalNumberPattern,
        parsePattern: $55e531462a78c52a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55e531462a78c52a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55e531462a78c52a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55e531462a78c52a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55e531462a78c52a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55e531462a78c52a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55e531462a78c52a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55e531462a78c52a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55e531462a78c52a$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $55e531462a78c52a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $55e531462a78c52a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("eMMV0", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $ac3b7e95c89d5348$export$d560c7e4a29451c2; }, function (v) { return $ac3b7e95c89d5348$export$d560c7e4a29451c2 = v; });
var $ac3b7e95c89d5348$export$d560c7e4a29451c2;
"use strict";
$ac3b7e95c89d5348$export$d560c7e4a29451c2 = void 0;

var $gTJn1 = parcelRequire("gTJn1");

var $jG0zK = parcelRequire("jG0zK");

var $6FdcG = parcelRequire("6FdcG");

var $2am8T = parcelRequire("2am8T");

var $fRS1v = parcelRequire("fRS1v");
/**
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso](https://github.com/rbudiharso)
 * @author Benget Nata [@bentinata](https://github.com/bentinata)
 * @author Budi Irawan [@deerawan](https://github.com/deerawan)
 * @author Try Ajitiono [@imballinst](https://github.com/imballinst)
 */ const $ac3b7e95c89d5348$var$id = $ac3b7e95c89d5348$export$d560c7e4a29451c2 = {
    code: "id",
    formatDistance: $gTJn1.formatDistance,
    formatLong: $jG0zK.formatLong,
    formatRelative: $6FdcG.formatRelative,
    localize: $2am8T.localize,
    match: $fRS1v.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("gTJn1", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $c4d4fa0284e95fc4$export$2c14ff85d6318973; }, function (v) { return $c4d4fa0284e95fc4$export$2c14ff85d6318973 = v; });
var $c4d4fa0284e95fc4$export$2c14ff85d6318973;
"use strict";
$c4d4fa0284e95fc4$export$2c14ff85d6318973 = void 0;
const $c4d4fa0284e95fc4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 detik",
        other: "kurang dari {{count}} detik"
    },
    xSeconds: {
        one: "1 detik",
        other: "{{count}} detik"
    },
    halfAMinute: "setengah menit",
    lessThanXMinutes: {
        one: "kurang dari 1 menit",
        other: "kurang dari {{count}} menit"
    },
    xMinutes: {
        one: "1 menit",
        other: "{{count}} menit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
const $c4d4fa0284e95fc4$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c4d4fa0284e95fc4$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam waktu " + result;
        else return result + " yang lalu";
    }
    return result;
};
$c4d4fa0284e95fc4$export$2c14ff85d6318973 = $c4d4fa0284e95fc4$var$formatDistance;

});

parcelRegister("jG0zK", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $e53262df1b7ca1d9$export$cbf60ecb96cbb82f; }, function (v) { return $e53262df1b7ca1d9$export$cbf60ecb96cbb82f = v; });
var $e53262df1b7ca1d9$export$cbf60ecb96cbb82f;
"use strict";
$e53262df1b7ca1d9$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $e53262df1b7ca1d9$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
const $e53262df1b7ca1d9$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
const $e53262df1b7ca1d9$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $e53262df1b7ca1d9$var$formatLong = $e53262df1b7ca1d9$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $e53262df1b7ca1d9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $e53262df1b7ca1d9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $e53262df1b7ca1d9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6FdcG", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $4da0d05bad939006$export$8fbbfd65594f46a0; }, function (v) { return $4da0d05bad939006$export$8fbbfd65594f46a0 = v; });
var $4da0d05bad939006$export$8fbbfd65594f46a0;
"use strict";
$4da0d05bad939006$export$8fbbfd65594f46a0 = void 0;
const $4da0d05bad939006$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: "P"
};
const $4da0d05bad939006$var$formatRelative = (token, _date, _baseDate, _options)=>$4da0d05bad939006$var$formatRelativeLocale[token];
$4da0d05bad939006$export$8fbbfd65594f46a0 = $4da0d05bad939006$var$formatRelative;

});

parcelRegister("2am8T", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $193db0f710123b47$export$b3bd0bc58e36cd63; }, function (v) { return $193db0f710123b47$export$b3bd0bc58e36cd63 = v; });
var $193db0f710123b47$export$b3bd0bc58e36cd63;
"use strict";
$193db0f710123b47$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
// All data for localization are taken from this page
// https://www.unicode.org/cldr/charts/32/summary/id.html
const $193db0f710123b47$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masehi",
        "Masehi"
    ]
};
const $193db0f710123b47$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "Kuartal ke-1",
        "Kuartal ke-2",
        "Kuartal ke-3",
        "Kuartal ke-4"
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $193db0f710123b47$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agt",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
const $193db0f710123b47$var$dayValues = {
    narrow: [
        "M",
        "S",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    wide: [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
    ]
};
const $193db0f710123b47$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
const $193db0f710123b47$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
const $193db0f710123b47$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + number;
};
const $193db0f710123b47$var$localize = $193db0f710123b47$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $193db0f710123b47$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $193db0f710123b47$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $193db0f710123b47$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $193db0f710123b47$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $193db0f710123b47$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $193db0f710123b47$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $193db0f710123b47$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("fRS1v", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $b8d5b62462f45be2$export$4659b591c19bdf3d; }, function (v) { return $b8d5b62462f45be2$export$4659b591c19bdf3d = v; });
var $b8d5b62462f45be2$export$4659b591c19bdf3d;
"use strict";
$b8d5b62462f45be2$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $b8d5b62462f45be2$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
const $b8d5b62462f45be2$var$parseOrdinalNumberPattern = /\d+/i;
const $b8d5b62462f45be2$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
const $b8d5b62462f45be2$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
const $b8d5b62462f45be2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
const $b8d5b62462f45be2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $b8d5b62462f45be2$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
const $b8d5b62462f45be2$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $b8d5b62462f45be2$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
const $b8d5b62462f45be2$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
const $b8d5b62462f45be2$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
const $b8d5b62462f45be2$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
const $b8d5b62462f45be2$var$match = $b8d5b62462f45be2$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $b8d5b62462f45be2$var$matchOrdinalNumberPattern,
        parsePattern: $b8d5b62462f45be2$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b8d5b62462f45be2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b8d5b62462f45be2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b8d5b62462f45be2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b8d5b62462f45be2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b8d5b62462f45be2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b8d5b62462f45be2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b8d5b62462f45be2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b8d5b62462f45be2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b8d5b62462f45be2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b8d5b62462f45be2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jg1fb", function(module, exports) {

$parcel$export(module.exports, "is", function () { return $e05079f6baa9ea4f$export$226b3eccf92c9ed9; }, function (v) { return $e05079f6baa9ea4f$export$226b3eccf92c9ed9 = v; });
var $e05079f6baa9ea4f$export$226b3eccf92c9ed9;
"use strict";
$e05079f6baa9ea4f$export$226b3eccf92c9ed9 = void 0;

var $dhool = parcelRequire("dhool");

var $5h7F2 = parcelRequire("5h7F2");

var $lOMJk = parcelRequire("lOMJk");

var $4MQmv = parcelRequire("4MQmv");

var $21vRr = parcelRequire("21vRr");
/**
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank](https://github.com/derekblank)
 * @author Arnór Ýmir [@lamayg](https://github.com/lamayg)
 */ const $e05079f6baa9ea4f$var$is = $e05079f6baa9ea4f$export$226b3eccf92c9ed9 = {
    code: "is",
    formatDistance: $dhool.formatDistance,
    formatLong: $5h7F2.formatLong,
    formatRelative: $lOMJk.formatRelative,
    localize: $4MQmv.localize,
    match: $21vRr.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("dhool", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $9aafc88d35ca54f8$export$2c14ff85d6318973; }, function (v) { return $9aafc88d35ca54f8$export$2c14ff85d6318973 = v; });
var $9aafc88d35ca54f8$export$2c14ff85d6318973;
"use strict";
$9aafc88d35ca54f8$export$2c14ff85d6318973 = void 0;
const $9aafc88d35ca54f8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: "1 klukkustund",
        other: "{{count}} klukkustundir"
    },
    xDays: {
        one: "1 dagur",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "um viku",
        other: "um {{count}} vikur"
    },
    xWeeks: {
        one: "1 viku",
        other: "{{count}} vikur"
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
const $9aafc88d35ca54f8$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $9aafc88d35ca54f8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
$9aafc88d35ca54f8$export$2c14ff85d6318973 = $9aafc88d35ca54f8$var$formatDistance;

});

parcelRegister("5h7F2", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $3d747b96779e49aa$export$cbf60ecb96cbb82f; }, function (v) { return $3d747b96779e49aa$export$cbf60ecb96cbb82f = v; });
var $3d747b96779e49aa$export$cbf60ecb96cbb82f;
"use strict";
$3d747b96779e49aa$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $3d747b96779e49aa$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "d.MM.y"
};
const $3d747b96779e49aa$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $3d747b96779e49aa$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $3d747b96779e49aa$var$formatLong = $3d747b96779e49aa$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $3d747b96779e49aa$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $3d747b96779e49aa$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $3d747b96779e49aa$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("lOMJk", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $fe2411401d7762b5$export$8fbbfd65594f46a0; }, function (v) { return $fe2411401d7762b5$export$8fbbfd65594f46a0 = v; });
var $fe2411401d7762b5$export$8fbbfd65594f46a0;
"use strict";
$fe2411401d7762b5$export$8fbbfd65594f46a0 = void 0;
const $fe2411401d7762b5$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: "P"
};
const $fe2411401d7762b5$var$formatRelative = (token, _date, _baseDate, _options)=>$fe2411401d7762b5$var$formatRelativeLocale[token];
$fe2411401d7762b5$export$8fbbfd65594f46a0 = $fe2411401d7762b5$var$formatRelative;

});

parcelRegister("4MQmv", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $37c443212a39b553$export$b3bd0bc58e36cd63; }, function (v) { return $37c443212a39b553$export$b3bd0bc58e36cd63 = v; });
var $37c443212a39b553$export$b3bd0bc58e36cd63;
"use strict";
$37c443212a39b553$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $37c443212a39b553$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "fyrir Krist",
        "eftir Krist"
    ]
};
const $37c443212a39b553$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1F",
        "2F",
        "3F",
        "4F"
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
const $37c443212a39b553$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "\xc1",
        "S",
        "\xd3",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "sept.",
        "okt.",
        "n\xf3v.",
        "des."
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "september",
        "okt\xf3ber",
        "n\xf3vember",
        "desember"
    ]
};
const $37c443212a39b553$var$dayValues = {
    narrow: [
        "S",
        "M",
        "\xde",
        "M",
        "F",
        "F",
        "L"
    ],
    short: [
        "Su",
        "M\xe1",
        "\xder",
        "Mi",
        "Fi",
        "F\xf6",
        "La"
    ],
    abbreviated: [
        "sun.",
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        "fim.",
        "f\xf6s.",
        "lau."
    ],
    wide: [
        "sunnudagur",
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        "fimmtudagur",
        "f\xf6studagur",
        "laugardagur"
    ]
};
const $37c443212a39b553$var$dayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
const $37c443212a39b553$var$formattingDayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
const $37c443212a39b553$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $37c443212a39b553$var$localize = $37c443212a39b553$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $37c443212a39b553$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $37c443212a39b553$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $37c443212a39b553$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $37c443212a39b553$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $37c443212a39b553$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $37c443212a39b553$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $37c443212a39b553$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("21vRr", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $179463ab6106e826$export$4659b591c19bdf3d; }, function (v) { return $179463ab6106e826$export$4659b591c19bdf3d = v; });
var $179463ab6106e826$export$4659b591c19bdf3d;
"use strict";
$179463ab6106e826$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $179463ab6106e826$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $179463ab6106e826$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
const $179463ab6106e826$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
const $179463ab6106e826$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
const $179463ab6106e826$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
const $179463ab6106e826$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
const $179463ab6106e826$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
const $179463ab6106e826$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
const $179463ab6106e826$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
const $179463ab6106e826$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
const $179463ab6106e826$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
const $179463ab6106e826$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
const $179463ab6106e826$var$match = $179463ab6106e826$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $179463ab6106e826$var$matchOrdinalNumberPattern,
        parsePattern: $179463ab6106e826$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $179463ab6106e826$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $179463ab6106e826$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $179463ab6106e826$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $179463ab6106e826$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $179463ab6106e826$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $179463ab6106e826$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $179463ab6106e826$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $179463ab6106e826$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $179463ab6106e826$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $179463ab6106e826$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8Nk9Q", function(module, exports) {

$parcel$export(module.exports, "it", function () { return $6672893e24cd563b$export$3486a10f30cf1ee4; }, function (v) { return $6672893e24cd563b$export$3486a10f30cf1ee4 = v; });
var $6672893e24cd563b$export$3486a10f30cf1ee4;
"use strict";
$6672893e24cd563b$export$3486a10f30cf1ee4 = void 0;

var $7kFrj = parcelRequire("7kFrj");

var $fcm8t = parcelRequire("fcm8t");

var $30bI9 = parcelRequire("30bI9");

var $rTLyL = parcelRequire("rTLyL");

var $hyWA6 = parcelRequire("hyWA6");
/**
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo](https://github.com/albertorestifo)
 * @author Giovanni Polimeni [@giofilo](https://github.com/giofilo)
 * @author Vincenzo Carrese [@vin-car](https://github.com/vin-car)
 */ const $6672893e24cd563b$var$it = $6672893e24cd563b$export$3486a10f30cf1ee4 = {
    code: "it",
    formatDistance: $7kFrj.formatDistance,
    formatLong: $fcm8t.formatLong,
    formatRelative: $30bI9.formatRelative,
    localize: $rTLyL.localize,
    match: $hyWA6.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("7kFrj", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $556a8baf5f3a4fb7$export$2c14ff85d6318973; }, function (v) { return $556a8baf5f3a4fb7$export$2c14ff85d6318973 = v; });
var $556a8baf5f3a4fb7$export$2c14ff85d6318973;
"use strict";
$556a8baf5f3a4fb7$export$2c14ff85d6318973 = void 0;
const $556a8baf5f3a4fb7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
    },
    xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
    },
    xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "un'ora",
        other: "{{count}} ore"
    },
    xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
    },
    aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
    },
    xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
    },
    aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
    },
    xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
    },
    aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
    },
    xYears: {
        one: "un anno",
        other: "{{count}} anni"
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
    }
};
const $556a8baf5f3a4fb7$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $556a8baf5f3a4fb7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "tra " + result;
        else return result + " fa";
    }
    return result;
};
$556a8baf5f3a4fb7$export$2c14ff85d6318973 = $556a8baf5f3a4fb7$var$formatDistance;

});

parcelRegister("fcm8t", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $b10925b0aad24067$export$cbf60ecb96cbb82f; }, function (v) { return $b10925b0aad24067$export$cbf60ecb96cbb82f = v; });
var $b10925b0aad24067$export$cbf60ecb96cbb82f;
"use strict";
$b10925b0aad24067$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $b10925b0aad24067$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $b10925b0aad24067$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $b10925b0aad24067$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $b10925b0aad24067$var$formatLong = $b10925b0aad24067$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $b10925b0aad24067$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $b10925b0aad24067$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $b10925b0aad24067$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("30bI9", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $22fa74c0970f6e58$export$8fbbfd65594f46a0; }, function (v) { return $22fa74c0970f6e58$export$8fbbfd65594f46a0 = v; });
var $22fa74c0970f6e58$export$8fbbfd65594f46a0;
"use strict";
$22fa74c0970f6e58$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");
const $22fa74c0970f6e58$var$weekdays = [
    "domenica",
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    "sabato"
];
function $22fa74c0970f6e58$var$lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $22fa74c0970f6e58$var$weekdays[day] + " scorso alle' p";
    }
}
function $22fa74c0970f6e58$var$thisWeek(day) {
    return "'" + $22fa74c0970f6e58$var$weekdays[day] + " alle' p";
}
function $22fa74c0970f6e58$var$nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $22fa74c0970f6e58$var$weekdays[day] + " prossimo alle' p";
    }
}
const $22fa74c0970f6e58$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $22fa74c0970f6e58$var$thisWeek(day);
        else return $22fa74c0970f6e58$var$lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $22fa74c0970f6e58$var$thisWeek(day);
        else return $22fa74c0970f6e58$var$nextWeek(day);
    },
    other: "P"
};
const $22fa74c0970f6e58$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $22fa74c0970f6e58$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$22fa74c0970f6e58$export$8fbbfd65594f46a0 = $22fa74c0970f6e58$var$formatRelative;

});

parcelRegister("rTLyL", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $053dc7b7163521e5$export$b3bd0bc58e36cd63; }, function (v) { return $053dc7b7163521e5$export$b3bd0bc58e36cd63 = v; });
var $053dc7b7163521e5$export$b3bd0bc58e36cd63;
"use strict";
$053dc7b7163521e5$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $053dc7b7163521e5$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "avanti Cristo",
        "dopo Cristo"
    ]
};
const $053dc7b7163521e5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $053dc7b7163521e5$var$monthValues = {
    narrow: [
        "G",
        "F",
        "M",
        "A",
        "M",
        "G",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
    ],
    wide: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
    ]
};
const $053dc7b7163521e5$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "G",
        "V",
        "S"
    ],
    short: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    wide: [
        "domenica",
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        "sabato"
    ]
};
const $053dc7b7163521e5$var$dayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    }
};
const $053dc7b7163521e5$var$formattingDayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    }
};
const $053dc7b7163521e5$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return String(number);
};
const $053dc7b7163521e5$var$localize = $053dc7b7163521e5$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $053dc7b7163521e5$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $053dc7b7163521e5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $053dc7b7163521e5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $053dc7b7163521e5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $053dc7b7163521e5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $053dc7b7163521e5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $053dc7b7163521e5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("hyWA6", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $cc930da9000fd3a5$export$4659b591c19bdf3d; }, function (v) { return $cc930da9000fd3a5$export$4659b591c19bdf3d = v; });
var $cc930da9000fd3a5$export$4659b591c19bdf3d;
"use strict";
$cc930da9000fd3a5$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $cc930da9000fd3a5$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $cc930da9000fd3a5$var$parseOrdinalNumberPattern = /\d+/i;
const $cc930da9000fd3a5$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
const $cc930da9000fd3a5$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
const $cc930da9000fd3a5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $cc930da9000fd3a5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $cc930da9000fd3a5$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
const $cc930da9000fd3a5$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $cc930da9000fd3a5$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
const $cc930da9000fd3a5$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
const $cc930da9000fd3a5$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
const $cc930da9000fd3a5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
const $cc930da9000fd3a5$var$match = $cc930da9000fd3a5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $cc930da9000fd3a5$var$matchOrdinalNumberPattern,
        parsePattern: $cc930da9000fd3a5$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc930da9000fd3a5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc930da9000fd3a5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc930da9000fd3a5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc930da9000fd3a5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc930da9000fd3a5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc930da9000fd3a5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc930da9000fd3a5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc930da9000fd3a5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc930da9000fd3a5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cc930da9000fd3a5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("hONOV", function(module, exports) {

$parcel$export(module.exports, "itCH", function () { return $cf8dc07c2928c4cd$export$a3f860f37034c31a; }, function (v) { return $cf8dc07c2928c4cd$export$a3f860f37034c31a = v; });
var $cf8dc07c2928c4cd$export$a3f860f37034c31a;
"use strict";
$cf8dc07c2928c4cd$export$a3f860f37034c31a = void 0;

var $7kFrj = parcelRequire("7kFrj");

var $30bI9 = parcelRequire("30bI9");

var $rTLyL = parcelRequire("rTLyL");

var $hyWA6 = parcelRequire("hyWA6");

var $lcGoK = parcelRequire("lcGoK");
/**
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66](https://github.com/maic66)
 */ const $cf8dc07c2928c4cd$var$itCH = $cf8dc07c2928c4cd$export$a3f860f37034c31a = {
    code: "it-CH",
    formatDistance: $7kFrj.formatDistance,
    formatLong: $lcGoK.formatLong,
    formatRelative: $30bI9.formatRelative,
    localize: $rTLyL.localize,
    match: $hyWA6.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("lcGoK", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $f6fb9b5c0aa54631$export$cbf60ecb96cbb82f; }, function (v) { return $f6fb9b5c0aa54631$export$cbf60ecb96cbb82f = v; });
var $f6fb9b5c0aa54631$export$cbf60ecb96cbb82f;
"use strict";
$f6fb9b5c0aa54631$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $f6fb9b5c0aa54631$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $f6fb9b5c0aa54631$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $f6fb9b5c0aa54631$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $f6fb9b5c0aa54631$var$formatLong = $f6fb9b5c0aa54631$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $f6fb9b5c0aa54631$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $f6fb9b5c0aa54631$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $f6fb9b5c0aa54631$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("d4hCv", function(module, exports) {

$parcel$export(module.exports, "ja", function () { return $9839510f2588e9ae$export$8c6f505e9474ce90; }, function (v) { return $9839510f2588e9ae$export$8c6f505e9474ce90 = v; });
var $9839510f2588e9ae$export$8c6f505e9474ce90;
"use strict";
$9839510f2588e9ae$export$8c6f505e9474ce90 = void 0;

var $9iMpf = parcelRequire("9iMpf");

var $4GZLY = parcelRequire("4GZLY");

var $9wakn = parcelRequire("9wakn");

var $ho7Xm = parcelRequire("ho7Xm");

var $6ElBY = parcelRequire("6ElBY");
/**
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Yamagishi Kazutoshi [@ykzts](https://github.com/ykzts)
 * @author Luca Ban [@mesqueeb](https://github.com/mesqueeb)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 * @author Taiki IKeda [@so99ynoodles](https://github.com/so99ynoodles)
 */ const $9839510f2588e9ae$var$ja = $9839510f2588e9ae$export$8c6f505e9474ce90 = {
    code: "ja",
    formatDistance: $9iMpf.formatDistance,
    formatLong: $4GZLY.formatLong,
    formatRelative: $9wakn.formatRelative,
    localize: $ho7Xm.localize,
    match: $6ElBY.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("9iMpf", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $6c5b57f5c08737b2$export$2c14ff85d6318973; }, function (v) { return $6c5b57f5c08737b2$export$2c14ff85d6318973 = v; });
var $6c5b57f5c08737b2$export$2c14ff85d6318973;
"use strict";
$6c5b57f5c08737b2$export$2c14ff85d6318973 = void 0;
const $6c5b57f5c08737b2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
const $6c5b57f5c08737b2$var$formatDistance = (token, count, options)=>{
    options = options || {};
    let result;
    const tokenValue = $6c5b57f5c08737b2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
$6c5b57f5c08737b2$export$2c14ff85d6318973 = $6c5b57f5c08737b2$var$formatDistance;

});

parcelRegister("4GZLY", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $36ab0072a4e782e3$export$cbf60ecb96cbb82f; }, function (v) { return $36ab0072a4e782e3$export$cbf60ecb96cbb82f = v; });
var $36ab0072a4e782e3$export$cbf60ecb96cbb82f;
"use strict";
$36ab0072a4e782e3$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $36ab0072a4e782e3$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
const $36ab0072a4e782e3$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $36ab0072a4e782e3$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $36ab0072a4e782e3$var$formatLong = $36ab0072a4e782e3$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $36ab0072a4e782e3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $36ab0072a4e782e3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $36ab0072a4e782e3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9wakn", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6edf1d1752616eef$export$8fbbfd65594f46a0; }, function (v) { return $6edf1d1752616eef$export$8fbbfd65594f46a0 = v; });
var $6edf1d1752616eef$export$8fbbfd65594f46a0;
"use strict";
$6edf1d1752616eef$export$8fbbfd65594f46a0 = void 0;
const $6edf1d1752616eef$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: "P"
};
const $6edf1d1752616eef$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $6edf1d1752616eef$var$formatRelativeLocale[token];
};
$6edf1d1752616eef$export$8fbbfd65594f46a0 = $6edf1d1752616eef$var$formatRelative;

});

parcelRegister("ho7Xm", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $ca8ad99032d99392$export$b3bd0bc58e36cd63; }, function (v) { return $ca8ad99032d99392$export$b3bd0bc58e36cd63 = v; });
var $ca8ad99032d99392$export$b3bd0bc58e36cd63;
"use strict";
$ca8ad99032d99392$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $ca8ad99032d99392$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
const $ca8ad99032d99392$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
const $ca8ad99032d99392$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
const $ca8ad99032d99392$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
const $ca8ad99032d99392$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
const $ca8ad99032d99392$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
const $ca8ad99032d99392$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "year":
            return `${number}\u{5E74}`;
        case "quarter":
            return `\u{7B2C}${number}\u{56DB}\u{534A}\u{671F}`;
        case "month":
            return `${number}\u{6708}`;
        case "week":
            return `\u{7B2C}${number}\u{9031}`;
        case "date":
            return `${number}\u{65E5}`;
        case "hour":
            return `${number}\u{6642}`;
        case "minute":
            return `${number}\u{5206}`;
        case "second":
            return `${number}\u{79D2}`;
        default:
            return `${number}`;
    }
};
const $ca8ad99032d99392$var$localize = $ca8ad99032d99392$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ca8ad99032d99392$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $ca8ad99032d99392$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $ca8ad99032d99392$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $ca8ad99032d99392$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $ca8ad99032d99392$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $ca8ad99032d99392$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ca8ad99032d99392$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("6ElBY", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $013fdbd71c1e8dad$export$4659b591c19bdf3d; }, function (v) { return $013fdbd71c1e8dad$export$4659b591c19bdf3d = v; });
var $013fdbd71c1e8dad$export$4659b591c19bdf3d;
"use strict";
$013fdbd71c1e8dad$export$4659b591c19bdf3d = void 0;

var $essio = parcelRequire("essio");

var $gZaqQ = parcelRequire("gZaqQ");
const $013fdbd71c1e8dad$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
const $013fdbd71c1e8dad$var$parseOrdinalNumberPattern = /\d+/i;
const $013fdbd71c1e8dad$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
const $013fdbd71c1e8dad$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
const $013fdbd71c1e8dad$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
const $013fdbd71c1e8dad$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
const $013fdbd71c1e8dad$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
const $013fdbd71c1e8dad$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $013fdbd71c1e8dad$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
const $013fdbd71c1e8dad$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
const $013fdbd71c1e8dad$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
const $013fdbd71c1e8dad$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
const $013fdbd71c1e8dad$var$match = $013fdbd71c1e8dad$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $013fdbd71c1e8dad$var$matchOrdinalNumberPattern,
        parsePattern: $013fdbd71c1e8dad$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $013fdbd71c1e8dad$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $013fdbd71c1e8dad$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $013fdbd71c1e8dad$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $013fdbd71c1e8dad$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $013fdbd71c1e8dad$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $013fdbd71c1e8dad$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $013fdbd71c1e8dad$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $013fdbd71c1e8dad$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $013fdbd71c1e8dad$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $013fdbd71c1e8dad$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("7o0Js", function(module, exports) {

$parcel$export(module.exports, "jaHira", function () { return $560b57b75ffe129d$export$f0ae70b1ccde4a97; }, function (v) { return $560b57b75ffe129d$export$f0ae70b1ccde4a97 = v; });
var $560b57b75ffe129d$export$f0ae70b1ccde4a97;
"use strict";
$560b57b75ffe129d$export$f0ae70b1ccde4a97 = void 0;

var $d4DiF = parcelRequire("d4DiF");

var $fFLpd = parcelRequire("fFLpd");

var $kCALz = parcelRequire("kCALz");

var $e26o8 = parcelRequire("e26o8");

var $iXbik = parcelRequire("iXbik");
/**
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo](https://github.com/Eritutteo)
 */ const $560b57b75ffe129d$var$jaHira = $560b57b75ffe129d$export$f0ae70b1ccde4a97 = {
    code: "ja-Hira",
    formatDistance: $d4DiF.formatDistance,
    formatLong: $fFLpd.formatLong,
    formatRelative: $kCALz.formatRelative,
    localize: $e26o8.localize,
    match: $iXbik.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("d4DiF", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $984a2245678569cd$export$2c14ff85d6318973; }, function (v) { return $984a2245678569cd$export$2c14ff85d6318973 = v; });
var $984a2245678569cd$export$2c14ff85d6318973;
"use strict";
$984a2245678569cd$export$2c14ff85d6318973 = void 0;
const $984a2245678569cd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
const $984a2245678569cd$var$formatDistance = (token, count, options)=>{
    options = options || {};
    let result;
    const tokenValue = $984a2245678569cd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
$984a2245678569cd$export$2c14ff85d6318973 = $984a2245678569cd$var$formatDistance;

});

parcelRegister("fFLpd", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $b68f752531d88947$export$cbf60ecb96cbb82f; }, function (v) { return $b68f752531d88947$export$cbf60ecb96cbb82f = v; });
var $b68f752531d88947$export$cbf60ecb96cbb82f;
"use strict";
$b68f752531d88947$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $b68f752531d88947$var$dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
const $b68f752531d88947$var$timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $b68f752531d88947$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $b68f752531d88947$var$formatLong = $b68f752531d88947$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $b68f752531d88947$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $b68f752531d88947$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $b68f752531d88947$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("kCALz", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $f033e0491abf9326$export$8fbbfd65594f46a0; }, function (v) { return $f033e0491abf9326$export$8fbbfd65594f46a0 = v; });
var $f033e0491abf9326$export$8fbbfd65594f46a0;
"use strict";
$f033e0491abf9326$export$8fbbfd65594f46a0 = void 0;
const $f033e0491abf9326$var$formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: "P"
};
const $f033e0491abf9326$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $f033e0491abf9326$var$formatRelativeLocale[token];
};
$f033e0491abf9326$export$8fbbfd65594f46a0 = $f033e0491abf9326$var$formatRelative;

});

parcelRegister("e26o8", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a3763526cfcb12a1$export$b3bd0bc58e36cd63; }, function (v) { return $a3763526cfcb12a1$export$b3bd0bc58e36cd63 = v; });
var $a3763526cfcb12a1$export$b3bd0bc58e36cd63;
"use strict";
$a3763526cfcb12a1$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $a3763526cfcb12a1$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
const $a3763526cfcb12a1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
const $a3763526cfcb12a1$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
const $a3763526cfcb12a1$var$dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
const $a3763526cfcb12a1$var$dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
const $a3763526cfcb12a1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
const $a3763526cfcb12a1$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "year":
            return `${number}\u{306D}\u{3093}`;
        case "quarter":
            return `\u{3060}\u{3044}${number}\u{3057}\u{306F}\u{3093}\u{304D}`;
        case "month":
            return `${number}\u{304C}\u{3064}`;
        case "week":
            return `\u{3060}\u{3044}${number}\u{3057}\u{3085}\u{3046}`;
        case "date":
            return `${number}\u{306B}\u{3061}`;
        case "hour":
            return `${number}\u{3058}`;
        case "minute":
            return `${number}\u{3075}\u{3093}`;
        case "second":
            return `${number}\u{3073}\u{3087}\u{3046}`;
        default:
            return `${number}`;
    }
};
const $a3763526cfcb12a1$var$localize = $a3763526cfcb12a1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a3763526cfcb12a1$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $a3763526cfcb12a1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $a3763526cfcb12a1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $a3763526cfcb12a1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $a3763526cfcb12a1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $a3763526cfcb12a1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a3763526cfcb12a1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("iXbik", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $dcc67f93636fb70e$export$4659b591c19bdf3d; }, function (v) { return $dcc67f93636fb70e$export$4659b591c19bdf3d = v; });
var $dcc67f93636fb70e$export$4659b591c19bdf3d;
"use strict";
$dcc67f93636fb70e$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $dcc67f93636fb70e$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
const $dcc67f93636fb70e$var$parseOrdinalNumberPattern = /\d+/i;
const $dcc67f93636fb70e$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
const $dcc67f93636fb70e$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
const $dcc67f93636fb70e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
const $dcc67f93636fb70e$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
const $dcc67f93636fb70e$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
const $dcc67f93636fb70e$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $dcc67f93636fb70e$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
const $dcc67f93636fb70e$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
const $dcc67f93636fb70e$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
const $dcc67f93636fb70e$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
const $dcc67f93636fb70e$var$match = $dcc67f93636fb70e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $dcc67f93636fb70e$var$matchOrdinalNumberPattern,
        parsePattern: $dcc67f93636fb70e$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $dcc67f93636fb70e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $dcc67f93636fb70e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $dcc67f93636fb70e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $dcc67f93636fb70e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $dcc67f93636fb70e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $dcc67f93636fb70e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $dcc67f93636fb70e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $dcc67f93636fb70e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $dcc67f93636fb70e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $dcc67f93636fb70e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("hNeJq", function(module, exports) {

$parcel$export(module.exports, "ka", function () { return $cf4270a709201b98$export$b20f780fa2c7402; }, function (v) { return $cf4270a709201b98$export$b20f780fa2c7402 = v; });
var $cf4270a709201b98$export$b20f780fa2c7402;
"use strict";
$cf4270a709201b98$export$b20f780fa2c7402 = void 0;

var $90J09 = parcelRequire("90J09");

var $ihBw4 = parcelRequire("ihBw4");

var $8XXzu = parcelRequire("8XXzu");

var $kw23H = parcelRequire("kw23H");

var $bqdlQ = parcelRequire("bqdlQ");
/**
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish](https://github.com/Landish)
 * @author Nick Shvelidze [@shvelo](https://github.com/shvelo)
 */ const $cf4270a709201b98$var$ka = $cf4270a709201b98$export$b20f780fa2c7402 = {
    code: "ka",
    formatDistance: $90J09.formatDistance,
    formatLong: $ihBw4.formatLong,
    formatRelative: $8XXzu.formatRelative,
    localize: $kw23H.localize,
    match: $bqdlQ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("90J09", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $68f70577f75207a3$export$2c14ff85d6318973; }, function (v) { return $68f70577f75207a3$export$2c14ff85d6318973 = v; });
var $68f70577f75207a3$export$2c14ff85d6318973;
"use strict";
$68f70577f75207a3$export$2c14ff85d6318973 = void 0;
const $68f70577f75207a3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
const $68f70577f75207a3$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $68f70577f75207a3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (options?.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace("{{count}}", String(count));
    else if (options?.addSuffix) result = tokenValue.past.replace("{{count}}", String(count));
    else result = tokenValue.present.replace("{{count}}", String(count));
    return result;
};
$68f70577f75207a3$export$2c14ff85d6318973 = $68f70577f75207a3$var$formatDistance;

});

parcelRegister("ihBw4", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d4f6ea7434d01ac6$export$cbf60ecb96cbb82f; }, function (v) { return $d4f6ea7434d01ac6$export$cbf60ecb96cbb82f = v; });
var $d4f6ea7434d01ac6$export$cbf60ecb96cbb82f;
"use strict";
$d4f6ea7434d01ac6$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $d4f6ea7434d01ac6$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do, MMMM, y",
    medium: "d, MMM, y",
    short: "dd/MM/yyyy"
};
const $d4f6ea7434d01ac6$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $d4f6ea7434d01ac6$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $d4f6ea7434d01ac6$var$formatLong = $d4f6ea7434d01ac6$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $d4f6ea7434d01ac6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $d4f6ea7434d01ac6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $d4f6ea7434d01ac6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("8XXzu", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $68720b09d3dab0cd$export$8fbbfd65594f46a0; }, function (v) { return $68720b09d3dab0cd$export$8fbbfd65594f46a0 = v; });
var $68720b09d3dab0cd$export$8fbbfd65594f46a0;
"use strict";
$68720b09d3dab0cd$export$8fbbfd65594f46a0 = void 0;
const $68720b09d3dab0cd$var$formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: "P"
};
const $68720b09d3dab0cd$var$formatRelative = (token, _date, _baseDate, _options)=>$68720b09d3dab0cd$var$formatRelativeLocale[token];
$68720b09d3dab0cd$export$8fbbfd65594f46a0 = $68720b09d3dab0cd$var$formatRelative;

});

parcelRegister("kw23H", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $eef864a111344c57$export$b3bd0bc58e36cd63; }, function (v) { return $eef864a111344c57$export$b3bd0bc58e36cd63 = v; });
var $eef864a111344c57$export$b3bd0bc58e36cd63;
"use strict";
$eef864a111344c57$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $eef864a111344c57$var$eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
const $eef864a111344c57$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eef864a111344c57$var$monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
const $eef864a111344c57$var$dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
const $eef864a111344c57$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
const $eef864a111344c57$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
const $eef864a111344c57$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
const $eef864a111344c57$var$localize = $eef864a111344c57$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eef864a111344c57$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $eef864a111344c57$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $eef864a111344c57$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $eef864a111344c57$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $eef864a111344c57$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $eef864a111344c57$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eef864a111344c57$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("bqdlQ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $850c7ab521fc8da8$export$4659b591c19bdf3d; }, function (v) { return $850c7ab521fc8da8$export$4659b591c19bdf3d = v; });
var $850c7ab521fc8da8$export$4659b591c19bdf3d;
"use strict";
$850c7ab521fc8da8$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $850c7ab521fc8da8$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
const $850c7ab521fc8da8$var$parseOrdinalNumberPattern = /\d+/i;
const $850c7ab521fc8da8$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
const $850c7ab521fc8da8$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
const $850c7ab521fc8da8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
const $850c7ab521fc8da8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $850c7ab521fc8da8$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
const $850c7ab521fc8da8$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
const $850c7ab521fc8da8$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
const $850c7ab521fc8da8$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
const $850c7ab521fc8da8$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
const $850c7ab521fc8da8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
const $850c7ab521fc8da8$var$match = $850c7ab521fc8da8$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $850c7ab521fc8da8$var$matchOrdinalNumberPattern,
        parsePattern: $850c7ab521fc8da8$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $850c7ab521fc8da8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $850c7ab521fc8da8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $850c7ab521fc8da8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $850c7ab521fc8da8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $850c7ab521fc8da8$var$matchMonthPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $850c7ab521fc8da8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $850c7ab521fc8da8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $850c7ab521fc8da8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $850c7ab521fc8da8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $850c7ab521fc8da8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("4VaJp", function(module, exports) {

$parcel$export(module.exports, "kk", function () { return $3954cf598343834c$export$4b04b6f14f77e727; }, function (v) { return $3954cf598343834c$export$4b04b6f14f77e727 = v; });
var $3954cf598343834c$export$4b04b6f14f77e727;
"use strict";
$3954cf598343834c$export$4b04b6f14f77e727 = void 0;

var $11Lnj = parcelRequire("11Lnj");

var $aCXN9 = parcelRequire("aCXN9");

var $3g4JP = parcelRequire("3g4JP");

var $ktTLM = parcelRequire("ktTLM");

var $3wrHG = parcelRequire("3wrHG");
/**
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi](https://github.com/drugoi)
 */ const $3954cf598343834c$var$kk = $3954cf598343834c$export$4b04b6f14f77e727 = {
    code: "kk",
    formatDistance: $11Lnj.formatDistance,
    formatLong: $aCXN9.formatLong,
    formatRelative: $3g4JP.formatRelative,
    localize: $ktTLM.localize,
    match: $3wrHG.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("11Lnj", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $0bfaa21f6d2e1b53$export$2c14ff85d6318973; }, function (v) { return $0bfaa21f6d2e1b53$export$2c14ff85d6318973 = v; });
var $0bfaa21f6d2e1b53$export$2c14ff85d6318973;
"use strict";
$0bfaa21f6d2e1b53$export$2c14ff85d6318973 = void 0;
const $0bfaa21f6d2e1b53$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: (options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: "weeks",
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: "weeks",
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function $0bfaa21f6d2e1b53$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
const $0bfaa21f6d2e1b53$var$formatDistance = (token, count, options)=>{
    const tokenValue = $0bfaa21f6d2e1b53$var$formatDistanceLocale[token];
    if (typeof tokenValue === "function") return tokenValue(options);
    if (tokenValue.type === "weeks") return count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $0bfaa21f6d2e1b53$var$declension(tokenValue.future, count);
            else return $0bfaa21f6d2e1b53$var$declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return $0bfaa21f6d2e1b53$var$declension(tokenValue.past, count);
            else return $0bfaa21f6d2e1b53$var$declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return $0bfaa21f6d2e1b53$var$declension(tokenValue.regular, count);
};
$0bfaa21f6d2e1b53$export$2c14ff85d6318973 = $0bfaa21f6d2e1b53$var$formatDistance;

});

parcelRegister("aCXN9", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $7bcbd569bb22da40$export$cbf60ecb96cbb82f; }, function (v) { return $7bcbd569bb22da40$export$cbf60ecb96cbb82f = v; });
var $7bcbd569bb22da40$export$cbf60ecb96cbb82f;
"use strict";
$7bcbd569bb22da40$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $7bcbd569bb22da40$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: "dd.MM.yyyy"
};
const $7bcbd569bb22da40$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $7bcbd569bb22da40$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $7bcbd569bb22da40$var$formatLong = $7bcbd569bb22da40$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $7bcbd569bb22da40$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $7bcbd569bb22da40$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $7bcbd569bb22da40$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("3g4JP", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $25f68aa1993f3344$export$8fbbfd65594f46a0; }, function (v) { return $25f68aa1993f3344$export$8fbbfd65594f46a0 = v; });
var $25f68aa1993f3344$export$8fbbfd65594f46a0;
"use strict";
$25f68aa1993f3344$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");
const $25f68aa1993f3344$var$accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function $25f68aa1993f3344$var$lastWeek(day) {
    const weekday = $25f68aa1993f3344$var$accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $25f68aa1993f3344$var$thisWeek(day) {
    const weekday = $25f68aa1993f3344$var$accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $25f68aa1993f3344$var$nextWeek(day) {
    const weekday = $25f68aa1993f3344$var$accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
const $25f68aa1993f3344$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $25f68aa1993f3344$var$thisWeek(day);
        else return $25f68aa1993f3344$var$lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $25f68aa1993f3344$var$thisWeek(day);
        else return $25f68aa1993f3344$var$nextWeek(day);
    },
    other: "P"
};
const $25f68aa1993f3344$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $25f68aa1993f3344$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$25f68aa1993f3344$export$8fbbfd65594f46a0 = $25f68aa1993f3344$var$formatRelative;

});

parcelRegister("ktTLM", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $ee91c6c7bebe2f1f$export$b3bd0bc58e36cd63; }, function (v) { return $ee91c6c7bebe2f1f$export$b3bd0bc58e36cd63 = v; });
var $ee91c6c7bebe2f1f$export$b3bd0bc58e36cd63;
"use strict";
$ee91c6c7bebe2f1f$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $ee91c6c7bebe2f1f$var$eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
const $ee91c6c7bebe2f1f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $ee91c6c7bebe2f1f$var$monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $ee91c6c7bebe2f1f$var$formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $ee91c6c7bebe2f1f$var$dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
const $ee91c6c7bebe2f1f$var$dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
const $ee91c6c7bebe2f1f$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
const $ee91c6c7bebe2f1f$var$suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
const $ee91c6c7bebe2f1f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const mod10 = number % 10;
    const b = number >= 100 ? 100 : null;
    const suffix = $ee91c6c7bebe2f1f$var$suffixes[number] || $ee91c6c7bebe2f1f$var$suffixes[mod10] || b && $ee91c6c7bebe2f1f$var$suffixes[b] || "";
    return number + suffix;
};
const $ee91c6c7bebe2f1f$var$localize = $ee91c6c7bebe2f1f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ee91c6c7bebe2f1f$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $ee91c6c7bebe2f1f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $ee91c6c7bebe2f1f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $ee91c6c7bebe2f1f$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $ee91c6c7bebe2f1f$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $ee91c6c7bebe2f1f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $ee91c6c7bebe2f1f$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $ee91c6c7bebe2f1f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("3wrHG", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $2909d99f49f49e85$export$4659b591c19bdf3d; }, function (v) { return $2909d99f49f49e85$export$4659b591c19bdf3d = v; });
var $2909d99f49f49e85$export$4659b591c19bdf3d;
"use strict";
$2909d99f49f49e85$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $2909d99f49f49e85$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
const $2909d99f49f49e85$var$parseOrdinalNumberPattern = /\d+/i;
const $2909d99f49f49e85$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
const $2909d99f49f49e85$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
const $2909d99f49f49e85$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
const $2909d99f49f49e85$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2909d99f49f49e85$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
const $2909d99f49f49e85$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
const $2909d99f49f49e85$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
const $2909d99f49f49e85$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
const $2909d99f49f49e85$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
const $2909d99f49f49e85$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
const $2909d99f49f49e85$var$match = $2909d99f49f49e85$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $2909d99f49f49e85$var$matchOrdinalNumberPattern,
        parsePattern: $2909d99f49f49e85$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2909d99f49f49e85$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2909d99f49f49e85$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2909d99f49f49e85$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2909d99f49f49e85$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2909d99f49f49e85$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2909d99f49f49e85$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2909d99f49f49e85$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2909d99f49f49e85$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $2909d99f49f49e85$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2909d99f49f49e85$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("kfWTt", function(module, exports) {

$parcel$export(module.exports, "km", function () { return $ebf2e46a579d34d0$export$476a5568f36fcaf3; }, function (v) { return $ebf2e46a579d34d0$export$476a5568f36fcaf3 = v; });
var $ebf2e46a579d34d0$export$476a5568f36fcaf3;
"use strict";
$ebf2e46a579d34d0$export$476a5568f36fcaf3 = void 0;

var $1Y4WT = parcelRequire("1Y4WT");

var $j1BHv = parcelRequire("j1BHv");

var $dCNRe = parcelRequire("dCNRe");

var $91CTm = parcelRequire("91CTm");

var $kARkz = parcelRequire("kARkz");
/**
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay](https://github.com/seanghay)
 */ const $ebf2e46a579d34d0$var$km = $ebf2e46a579d34d0$export$476a5568f36fcaf3 = {
    code: "km",
    formatDistance: $1Y4WT.formatDistance,
    formatLong: $j1BHv.formatLong,
    formatRelative: $dCNRe.formatRelative,
    localize: $91CTm.localize,
    match: $kARkz.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("1Y4WT", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $16ef3bcddbb23d11$export$2c14ff85d6318973; }, function (v) { return $16ef3bcddbb23d11$export$2c14ff85d6318973 = v; });
var $16ef3bcddbb23d11$export$2c14ff85d6318973;
"use strict";
$16ef3bcddbb23d11$export$2c14ff85d6318973 = void 0;
const $16ef3bcddbb23d11$var$formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
const $16ef3bcddbb23d11$var$formatDistance = (token, count, options)=>{
    const tokenValue = $16ef3bcddbb23d11$var$formatDistanceLocale[token];
    let result = tokenValue;
    if (typeof count === "number") result = result.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
$16ef3bcddbb23d11$export$2c14ff85d6318973 = $16ef3bcddbb23d11$var$formatDistance;

});

parcelRegister("j1BHv", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $dd9b5ae03036d6b8$export$cbf60ecb96cbb82f; }, function (v) { return $dd9b5ae03036d6b8$export$cbf60ecb96cbb82f = v; });
var $dd9b5ae03036d6b8$export$cbf60ecb96cbb82f;
"use strict";
$dd9b5ae03036d6b8$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $dd9b5ae03036d6b8$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $dd9b5ae03036d6b8$var$timeFormats = {
    full: "h:mm:ss a",
    long: "h:mm:ss a",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $dd9b5ae03036d6b8$var$dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $dd9b5ae03036d6b8$var$formatLong = $dd9b5ae03036d6b8$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $dd9b5ae03036d6b8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $dd9b5ae03036d6b8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $dd9b5ae03036d6b8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dCNRe", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9eb57fac6d92e147$export$8fbbfd65594f46a0; }, function (v) { return $9eb57fac6d92e147$export$8fbbfd65594f46a0 = v; });
var $9eb57fac6d92e147$export$8fbbfd65594f46a0;
"use strict";
$9eb57fac6d92e147$export$8fbbfd65594f46a0 = void 0;
const $9eb57fac6d92e147$var$formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: "P"
};
const $9eb57fac6d92e147$var$formatRelative = (token, _date, _baseDate, _options)=>$9eb57fac6d92e147$var$formatRelativeLocale[token];
$9eb57fac6d92e147$export$8fbbfd65594f46a0 = $9eb57fac6d92e147$var$formatRelative;

});

parcelRegister("91CTm", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $69226028329ddcf0$export$b3bd0bc58e36cd63; }, function (v) { return $69226028329ddcf0$export$b3bd0bc58e36cd63 = v; });
var $69226028329ddcf0$export$b3bd0bc58e36cd63;
"use strict";
$69226028329ddcf0$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $69226028329ddcf0$var$eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
const $69226028329ddcf0$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
const $69226028329ddcf0$var$monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
const $69226028329ddcf0$var$dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
const $69226028329ddcf0$var$dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
const $69226028329ddcf0$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
const $69226028329ddcf0$var$ordinalNumber = (dirtyNumber, _)=>{
    const number = Number(dirtyNumber);
    return number.toString();
};
const $69226028329ddcf0$var$localize = $69226028329ddcf0$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $69226028329ddcf0$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $69226028329ddcf0$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $69226028329ddcf0$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $69226028329ddcf0$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $69226028329ddcf0$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $69226028329ddcf0$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $69226028329ddcf0$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("kARkz", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $efe089cca594b9a5$export$4659b591c19bdf3d; }, function (v) { return $efe089cca594b9a5$export$4659b591c19bdf3d = v; });
var $efe089cca594b9a5$export$4659b591c19bdf3d;
"use strict";
$efe089cca594b9a5$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $efe089cca594b9a5$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $efe089cca594b9a5$var$parseOrdinalNumberPattern = /\d+/i;
const $efe089cca594b9a5$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
const $efe089cca594b9a5$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
const $efe089cca594b9a5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
const $efe089cca594b9a5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $efe089cca594b9a5$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
const $efe089cca594b9a5$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
const $efe089cca594b9a5$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
const $efe089cca594b9a5$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
const $efe089cca594b9a5$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
const $efe089cca594b9a5$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
const $efe089cca594b9a5$var$match = $efe089cca594b9a5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $efe089cca594b9a5$var$matchOrdinalNumberPattern,
        parsePattern: $efe089cca594b9a5$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efe089cca594b9a5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efe089cca594b9a5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efe089cca594b9a5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efe089cca594b9a5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efe089cca594b9a5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efe089cca594b9a5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efe089cca594b9a5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efe089cca594b9a5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efe089cca594b9a5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $efe089cca594b9a5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("gUbqL", function(module, exports) {

$parcel$export(module.exports, "kn", function () { return $c4eabe2eac2a8936$export$85d70026956e40a0; }, function (v) { return $c4eabe2eac2a8936$export$85d70026956e40a0 = v; });
var $c4eabe2eac2a8936$export$85d70026956e40a0;
"use strict";
$c4eabe2eac2a8936$export$85d70026956e40a0 = void 0;

var $7FJkB = parcelRequire("7FJkB");

var $2G1sT = parcelRequire("2G1sT");

var $iKQxb = parcelRequire("iKQxb");

var $7HLNk = parcelRequire("7HLNk");

var $hEpdL = parcelRequire("hEpdL");
/**
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli](https://github.com/developergouli)
 */ const $c4eabe2eac2a8936$var$kn = $c4eabe2eac2a8936$export$85d70026956e40a0 = {
    code: "kn",
    formatDistance: $7FJkB.formatDistance,
    formatLong: $2G1sT.formatLong,
    formatRelative: $iKQxb.formatRelative,
    localize: $7HLNk.localize,
    match: $hEpdL.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("7FJkB", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $595f8692cac9532e$export$2c14ff85d6318973; }, function (v) { return $595f8692cac9532e$export$2c14ff85d6318973 = v; });
var $595f8692cac9532e$export$2c14ff85d6318973;
"use strict";
$595f8692cac9532e$export$2c14ff85d6318973 = void 0;
// note: no implementation for weeks
const $595f8692cac9532e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function $595f8692cac9532e$var$getResultByTense(parentToken, options) {
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
const $595f8692cac9532e$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $595f8692cac9532e$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $595f8692cac9532e$var$getResultByTense(tokenValue.one, options);
    else result = $595f8692cac9532e$var$getResultByTense(tokenValue.other, options);
    return result.replace("{{count}}", String(count));
};
$595f8692cac9532e$export$2c14ff85d6318973 = $595f8692cac9532e$var$formatDistance;

});

parcelRegister("2G1sT", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $1f30a3f02affed3c$export$cbf60ecb96cbb82f; }, function (v) { return $1f30a3f02affed3c$export$cbf60ecb96cbb82f = v; });
var $1f30a3f02affed3c$export$cbf60ecb96cbb82f;
"use strict";
$1f30a3f02affed3c$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
const $1f30a3f02affed3c$var$dateFormats = {
    full: "EEEE, MMMM d, y",
    long: "MMMM d, y",
    medium: "MMM d, y",
    short: "d/M/yy"
};
const $1f30a3f02affed3c$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    long: "hh:mm:ss a z",
    medium: "hh:mm:ss a",
    short: "hh:mm a"
};
const $1f30a3f02affed3c$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $1f30a3f02affed3c$var$formatLong = $1f30a3f02affed3c$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $1f30a3f02affed3c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $1f30a3f02affed3c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $1f30a3f02affed3c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("iKQxb", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $da75461530c299e9$export$8fbbfd65594f46a0; }, function (v) { return $da75461530c299e9$export$8fbbfd65594f46a0 = v; });
var $da75461530c299e9$export$8fbbfd65594f46a0;
"use strict";
$da75461530c299e9$export$8fbbfd65594f46a0 = void 0;
const $da75461530c299e9$var$formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: "P"
};
const $da75461530c299e9$var$formatRelative = (token, _date, _baseDate, _options)=>$da75461530c299e9$var$formatRelativeLocale[token];
$da75461530c299e9$export$8fbbfd65594f46a0 = $da75461530c299e9$var$formatRelative;

});

parcelRegister("7HLNk", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $59c19f9597968dba$export$b3bd0bc58e36cd63; }, function (v) { return $59c19f9597968dba$export$b3bd0bc58e36cd63 = v; });
var $59c19f9597968dba$export$b3bd0bc58e36cd63;
"use strict";
$59c19f9597968dba$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
const $59c19f9597968dba$var$eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ]
};
const $59c19f9597968dba$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ]
};
// CLDR #1646 - #1717
const $59c19f9597968dba$var$monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
const $59c19f9597968dba$var$dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
const $59c19f9597968dba$var$dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
const $59c19f9597968dba$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
const $59c19f9597968dba$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
const $59c19f9597968dba$var$localize = $59c19f9597968dba$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $59c19f9597968dba$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $59c19f9597968dba$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $59c19f9597968dba$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $59c19f9597968dba$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $59c19f9597968dba$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $59c19f9597968dba$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $59c19f9597968dba$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("hEpdL", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $cd99bc7317045aa6$export$4659b591c19bdf3d; }, function (v) { return $cd99bc7317045aa6$export$4659b591c19bdf3d = v; });
var $cd99bc7317045aa6$export$4659b591c19bdf3d;
"use strict";
$cd99bc7317045aa6$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $cd99bc7317045aa6$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
const $cd99bc7317045aa6$var$parseOrdinalNumberPattern = /\d+/i;
const $cd99bc7317045aa6$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
const $cd99bc7317045aa6$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
const $cd99bc7317045aa6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
const $cd99bc7317045aa6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $cd99bc7317045aa6$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
const $cd99bc7317045aa6$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
const $cd99bc7317045aa6$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
const $cd99bc7317045aa6$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
const $cd99bc7317045aa6$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
const $cd99bc7317045aa6$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
const $cd99bc7317045aa6$var$match = $cd99bc7317045aa6$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $cd99bc7317045aa6$var$matchOrdinalNumberPattern,
        parsePattern: $cd99bc7317045aa6$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd99bc7317045aa6$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd99bc7317045aa6$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd99bc7317045aa6$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd99bc7317045aa6$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd99bc7317045aa6$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd99bc7317045aa6$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd99bc7317045aa6$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd99bc7317045aa6$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd99bc7317045aa6$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cd99bc7317045aa6$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("7AR6Q", function(module, exports) {

$parcel$export(module.exports, "ko", function () { return $5875179d8760b170$export$798cf677954c9533; }, function (v) { return $5875179d8760b170$export$798cf677954c9533 = v; });
var $5875179d8760b170$export$798cf677954c9533;
"use strict";
$5875179d8760b170$export$798cf677954c9533 = void 0;

var $3Dyph = parcelRequire("3Dyph");

var $hpdRI = parcelRequire("hpdRI");

var $eQygL = parcelRequire("eQygL");

var $598IU = parcelRequire("598IU");

var $g1RMm = parcelRequire("g1RMm");
/**
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev](https://github.com/angdev)
 * @author Lee Seoyoen [@iamssen](https://github.com/iamssen)
 * @author Taiki IKeda [@so99ynoodles](https://github.com/so99ynoodles)
 */ const $5875179d8760b170$var$ko = $5875179d8760b170$export$798cf677954c9533 = {
    code: "ko",
    formatDistance: $3Dyph.formatDistance,
    formatLong: $hpdRI.formatLong,
    formatRelative: $eQygL.formatRelative,
    localize: $598IU.localize,
    match: $g1RMm.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("3Dyph", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $2a5fb41a32ed3d61$export$2c14ff85d6318973; }, function (v) { return $2a5fb41a32ed3d61$export$2c14ff85d6318973 = v; });
var $2a5fb41a32ed3d61$export$2c14ff85d6318973;
"use strict";
$2a5fb41a32ed3d61$export$2c14ff85d6318973 = void 0;
const $2a5fb41a32ed3d61$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
const $2a5fb41a32ed3d61$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2a5fb41a32ed3d61$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
$2a5fb41a32ed3d61$export$2c14ff85d6318973 = $2a5fb41a32ed3d61$var$formatDistance;

});

parcelRegister("hpdRI", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $cabf86db04fd343e$export$cbf60ecb96cbb82f; }, function (v) { return $cabf86db04fd343e$export$cbf60ecb96cbb82f = v; });
var $cabf86db04fd343e$export$cbf60ecb96cbb82f;
"use strict";
$cabf86db04fd343e$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $cabf86db04fd343e$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: "y.MM.dd",
    short: "y.MM.dd"
};
const $cabf86db04fd343e$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: "a H:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $cabf86db04fd343e$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $cabf86db04fd343e$var$formatLong = $cabf86db04fd343e$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $cabf86db04fd343e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $cabf86db04fd343e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $cabf86db04fd343e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("eQygL", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $acf081335bdd1a58$export$8fbbfd65594f46a0; }, function (v) { return $acf081335bdd1a58$export$8fbbfd65594f46a0 = v; });
var $acf081335bdd1a58$export$8fbbfd65594f46a0;
"use strict";
$acf081335bdd1a58$export$8fbbfd65594f46a0 = void 0;
const $acf081335bdd1a58$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: "P"
};
const $acf081335bdd1a58$var$formatRelative = (token, _date, _baseDate, _options)=>$acf081335bdd1a58$var$formatRelativeLocale[token];
$acf081335bdd1a58$export$8fbbfd65594f46a0 = $acf081335bdd1a58$var$formatRelative;

});

parcelRegister("598IU", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $3bf48f4d49b8707d$export$b3bd0bc58e36cd63; }, function (v) { return $3bf48f4d49b8707d$export$b3bd0bc58e36cd63 = v; });
var $3bf48f4d49b8707d$export$b3bd0bc58e36cd63;
"use strict";
$3bf48f4d49b8707d$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $3bf48f4d49b8707d$var$eraValues = {
    narrow: [
        "BC",
        "AD"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
const $3bf48f4d49b8707d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
const $3bf48f4d49b8707d$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
const $3bf48f4d49b8707d$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
const $3bf48f4d49b8707d$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
const $3bf48f4d49b8707d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
const $3bf48f4d49b8707d$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "minute":
        case "second":
            return String(number);
        case "date":
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
const $3bf48f4d49b8707d$var$localize = $3bf48f4d49b8707d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3bf48f4d49b8707d$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $3bf48f4d49b8707d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $3bf48f4d49b8707d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $3bf48f4d49b8707d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $3bf48f4d49b8707d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $3bf48f4d49b8707d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3bf48f4d49b8707d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("g1RMm", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $bab674b5857d4a42$export$4659b591c19bdf3d; }, function (v) { return $bab674b5857d4a42$export$4659b591c19bdf3d = v; });
var $bab674b5857d4a42$export$4659b591c19bdf3d;
"use strict";
$bab674b5857d4a42$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $bab674b5857d4a42$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
const $bab674b5857d4a42$var$parseOrdinalNumberPattern = /\d+/i;
const $bab674b5857d4a42$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
const $bab674b5857d4a42$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
const $bab674b5857d4a42$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
const $bab674b5857d4a42$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $bab674b5857d4a42$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
const $bab674b5857d4a42$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $bab674b5857d4a42$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
const $bab674b5857d4a42$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
const $bab674b5857d4a42$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
const $bab674b5857d4a42$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
const $bab674b5857d4a42$var$match = $bab674b5857d4a42$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $bab674b5857d4a42$var$matchOrdinalNumberPattern,
        parsePattern: $bab674b5857d4a42$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bab674b5857d4a42$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab674b5857d4a42$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bab674b5857d4a42$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab674b5857d4a42$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bab674b5857d4a42$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab674b5857d4a42$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bab674b5857d4a42$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab674b5857d4a42$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bab674b5857d4a42$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bab674b5857d4a42$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("eRkRq", function(module, exports) {

$parcel$export(module.exports, "lb", function () { return $ad16326c9bf80e0e$export$736eba5cc491e759; }, function (v) { return $ad16326c9bf80e0e$export$736eba5cc491e759 = v; });
var $ad16326c9bf80e0e$export$736eba5cc491e759;
"use strict";
$ad16326c9bf80e0e$export$736eba5cc491e759 = void 0;

var $bN9w7 = parcelRequire("bN9w7");

var $fKFaA = parcelRequire("fKFaA");

var $fLctp = parcelRequire("fLctp");

var $ceRRC = parcelRequire("ceRRC");

var $hCxwL = parcelRequire("hCxwL");
/**
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler](https://github.com/dwaxweiler)
 */ const $ad16326c9bf80e0e$var$lb = $ad16326c9bf80e0e$export$736eba5cc491e759 = {
    code: "lb",
    formatDistance: $bN9w7.formatDistance,
    formatLong: $fKFaA.formatLong,
    formatRelative: $fLctp.formatRelative,
    localize: $ceRRC.localize,
    match: $hCxwL.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("bN9w7", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $895ba730b91b1881$export$2c14ff85d6318973; }, function (v) { return $895ba730b91b1881$export$2c14ff85d6318973 = v; });
var $895ba730b91b1881$export$2c14ff85d6318973;
"use strict";
$895ba730b91b1881$export$2c14ff85d6318973 = void 0;
const $895ba730b91b1881$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: "eng Sekonn",
            other: "{{count}} Sekonnen"
        },
        withPreposition: {
            one: "enger Sekonn",
            other: "{{count}} Sekonnen"
        }
    },
    halfAMinute: {
        standalone: "eng hallef Minutt",
        withPreposition: "enger hallwer Minutt"
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: "eng Minutt",
            other: "{{count}} Minutten"
        },
        withPreposition: {
            one: "enger Minutt",
            other: "{{count}} Minutten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: "eng Stonn",
            other: "{{count}} Stonnen"
        },
        withPreposition: {
            one: "enger Stonn",
            other: "{{count}} Stonnen"
        }
    },
    xDays: {
        standalone: {
            one: "een Dag",
            other: "{{count}} Deeg"
        },
        withPreposition: {
            one: "engem Dag",
            other: "{{count}} Deeg"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "eng Woch",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "enger Woch",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: "ee Mount",
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: "engem Mount",
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: "ee Joer",
            other: "{{count}} Joer"
        },
        withPreposition: {
            one: "engem Joer",
            other: "{{count}} Joer"
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: "bal ee Joer",
            other: "bal {{count}} Joer"
        },
        withPreposition: {
            one: "bal engem Joer",
            other: "bal {{count}} Joer"
        }
    }
};
const $895ba730b91b1881$var$EXCEPTION_CONSONANTS = [
    "d",
    "h",
    "n",
    "t",
    "z"
];
const $895ba730b91b1881$var$VOWELS = [
    "a,",
    "e",
    "i",
    "o",
    "u"
];
const $895ba730b91b1881$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
const $895ba730b91b1881$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $895ba730b91b1881$var$isFinalNNeeded(nextWords) {
    const firstLetter = nextWords.charAt(0).toLowerCase();
    if ($895ba730b91b1881$var$VOWELS.indexOf(firstLetter) != -1 || $895ba730b91b1881$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    const firstWord = nextWords.split(" ")[0];
    const number = parseInt(firstWord);
    if (!isNaN(number) && $895ba730b91b1881$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $895ba730b91b1881$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
const $895ba730b91b1881$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $895ba730b91b1881$var$formatDistanceLocale[token];
    const usageGroup = options?.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "a" + ($895ba730b91b1881$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
        else return "viru" + ($895ba730b91b1881$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
    }
    return result;
};
$895ba730b91b1881$export$2c14ff85d6318973 = $895ba730b91b1881$var$formatDistance;

});

parcelRegister("fKFaA", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $b77b1654165a7b9c$export$cbf60ecb96cbb82f; }, function (v) { return $b77b1654165a7b9c$export$cbf60ecb96cbb82f = v; });
var $b77b1654165a7b9c$export$cbf60ecb96cbb82f;
"use strict";
$b77b1654165a7b9c$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const $b77b1654165a7b9c$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.yy"
};
const $b77b1654165a7b9c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $b77b1654165a7b9c$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $b77b1654165a7b9c$var$formatLong = $b77b1654165a7b9c$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $b77b1654165a7b9c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $b77b1654165a7b9c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $b77b1654165a7b9c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fLctp", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b794ebbfa947348e$export$8fbbfd65594f46a0; }, function (v) { return $b794ebbfa947348e$export$8fbbfd65594f46a0 = v; });
var $b794ebbfa947348e$export$8fbbfd65594f46a0;
"use strict";
$b794ebbfa947348e$export$8fbbfd65594f46a0 = void 0;
const $b794ebbfa947348e$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        let result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += "n";
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
const $b794ebbfa947348e$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $b794ebbfa947348e$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$b794ebbfa947348e$export$8fbbfd65594f46a0 = $b794ebbfa947348e$var$formatRelative;

});

parcelRegister("ceRRC", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8e90931933f96e13$export$b3bd0bc58e36cd63; }, function (v) { return $8e90931933f96e13$export$b3bd0bc58e36cd63 = v; });
var $8e90931933f96e13$export$b3bd0bc58e36cd63;
"use strict";
$8e90931933f96e13$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $8e90931933f96e13$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "viru Christus",
        "no Christus"
    ]
};
const $8e90931933f96e13$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
const $8e90931933f96e13$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4e",
        "Abr",
        "Mee",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4erz",
        "Abr\xebll",
        "Mee",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
const $8e90931933f96e13$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "M\xe9",
        "D\xeb",
        "M\xeb",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonndeg",
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        "Donneschdeg",
        "Freideg",
        "Samschdeg"
    ]
};
const $8e90931933f96e13$var$dayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    }
};
const $8e90931933f96e13$var$formattingDayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom.",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    }
};
const $8e90931933f96e13$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $8e90931933f96e13$var$localize = $8e90931933f96e13$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8e90931933f96e13$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $8e90931933f96e13$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $8e90931933f96e13$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $8e90931933f96e13$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $8e90931933f96e13$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $8e90931933f96e13$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8e90931933f96e13$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("hCxwL", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $cd3ffe1cc408cf69$export$4659b591c19bdf3d; }, function (v) { return $cd3ffe1cc408cf69$export$4659b591c19bdf3d = v; });
var $cd3ffe1cc408cf69$export$4659b591c19bdf3d;
"use strict";
$cd3ffe1cc408cf69$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $cd3ffe1cc408cf69$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $cd3ffe1cc408cf69$var$parseOrdinalNumberPattern = /\d+/i;
const $cd3ffe1cc408cf69$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
const $cd3ffe1cc408cf69$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
const $cd3ffe1cc408cf69$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
const $cd3ffe1cc408cf69$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $cd3ffe1cc408cf69$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
const $cd3ffe1cc408cf69$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $cd3ffe1cc408cf69$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
const $cd3ffe1cc408cf69$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
const $cd3ffe1cc408cf69$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
const $cd3ffe1cc408cf69$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        evening: /owes/i,
        night: /nuets/i
    }
};
const $cd3ffe1cc408cf69$var$match = $cd3ffe1cc408cf69$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $cd3ffe1cc408cf69$var$matchOrdinalNumberPattern,
        parsePattern: $cd3ffe1cc408cf69$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd3ffe1cc408cf69$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd3ffe1cc408cf69$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd3ffe1cc408cf69$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd3ffe1cc408cf69$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd3ffe1cc408cf69$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd3ffe1cc408cf69$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd3ffe1cc408cf69$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd3ffe1cc408cf69$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cd3ffe1cc408cf69$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cd3ffe1cc408cf69$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("kojIy", function(module, exports) {

$parcel$export(module.exports, "lt", function () { return $ed85580f083c922f$export$b961576059b7aeb6; }, function (v) { return $ed85580f083c922f$export$b961576059b7aeb6 = v; });
var $ed85580f083c922f$export$b961576059b7aeb6;
"use strict";
$ed85580f083c922f$export$b961576059b7aeb6 = void 0;

var $hJbQy = parcelRequire("hJbQy");

var $hSUyW = parcelRequire("hSUyW");

var $85oLy = parcelRequire("85oLy");

var $9LSVs = parcelRequire("9LSVs");

var $f5KgG = parcelRequire("f5KgG");
/**
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
 * @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
 */ const $ed85580f083c922f$var$lt = $ed85580f083c922f$export$b961576059b7aeb6 = {
    code: "lt",
    formatDistance: $hJbQy.formatDistance,
    formatLong: $hSUyW.formatLong,
    formatRelative: $85oLy.formatRelative,
    localize: $9LSVs.localize,
    match: $f5KgG.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("hJbQy", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ce7fd41d44486123$export$2c14ff85d6318973; }, function (v) { return $ce7fd41d44486123$export$2c14ff85d6318973 = v; });
var $ce7fd41d44486123$export$2c14ff85d6318973;
"use strict";
$ce7fd41d44486123$export$2c14ff85d6318973 = void 0;
const $ce7fd41d44486123$var$translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: "apie",
    over: "daugiau nei",
    almost: "beveik",
    lessthan: "ma\u017Eiau nei"
};
const $ce7fd41d44486123$var$translateSeconds = (_number, addSuffix, _key, isFuture)=>{
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : "kelias sekundes";
};
const $ce7fd41d44486123$var$translateSingular = (_number, addSuffix, key, isFuture)=>{
    return !addSuffix ? $ce7fd41d44486123$var$forms(key)[0] : isFuture ? $ce7fd41d44486123$var$forms(key)[1] : $ce7fd41d44486123$var$forms(key)[2];
};
const $ce7fd41d44486123$var$translate = (number, addSuffix, key, isFuture)=>{
    const result = number + " ";
    if (number === 1) return result + $ce7fd41d44486123$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($ce7fd41d44486123$var$special(number) ? $ce7fd41d44486123$var$forms(key)[1] : $ce7fd41d44486123$var$forms(key)[0]);
    else {
        if (isFuture) return result + $ce7fd41d44486123$var$forms(key)[1];
        else return result + ($ce7fd41d44486123$var$special(number) ? $ce7fd41d44486123$var$forms(key)[1] : $ce7fd41d44486123$var$forms(key)[2]);
    }
};
function $ce7fd41d44486123$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $ce7fd41d44486123$var$forms(key) {
    return $ce7fd41d44486123$var$translations[key].split("_");
}
const $ce7fd41d44486123$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $ce7fd41d44486123$var$translateSeconds,
        other: $ce7fd41d44486123$var$translate
    },
    xSeconds: {
        one: $ce7fd41d44486123$var$translateSeconds,
        other: $ce7fd41d44486123$var$translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    xMinutes: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    aboutXHours: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    xHours: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    xDays: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    aboutXWeeks: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    xWeeks: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    aboutXMonths: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    xMonths: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    aboutXYears: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    xYears: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    overXYears: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    },
    almostXYears: {
        one: $ce7fd41d44486123$var$translateSingular,
        other: $ce7fd41d44486123$var$translate
    }
};
const $ce7fd41d44486123$var$formatDistance = (token, count, options)=>{
    const adverb = token.match(/about|over|almost|lessthan/i);
    const unit = adverb ? token.replace(adverb[0], "") : token;
    const isFuture = options?.comparison !== undefined && options.comparison > 0;
    let result;
    const tokenValue = $ce7fd41d44486123$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, options?.addSuffix === true, unit.toLowerCase() + "_one", isFuture);
    else result = tokenValue.other(count, options?.addSuffix === true, unit.toLowerCase() + "_other", isFuture);
    if (adverb) {
        const key = adverb[0].toLowerCase();
        result = $ce7fd41d44486123$var$translations[key] + " " + result;
    }
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "po " + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
$ce7fd41d44486123$export$2c14ff85d6318973 = $ce7fd41d44486123$var$formatDistance;

});

parcelRegister("hSUyW", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d0535af3e1899ed0$export$cbf60ecb96cbb82f; }, function (v) { return $d0535af3e1899ed0$export$cbf60ecb96cbb82f = v; });
var $d0535af3e1899ed0$export$cbf60ecb96cbb82f;
"use strict";
$d0535af3e1899ed0$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $d0535af3e1899ed0$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: "y-MM-dd",
    short: "y-MM-dd"
};
const $d0535af3e1899ed0$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $d0535af3e1899ed0$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $d0535af3e1899ed0$var$formatLong = $d0535af3e1899ed0$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $d0535af3e1899ed0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $d0535af3e1899ed0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $d0535af3e1899ed0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("85oLy", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $5e320061481212d6$export$8fbbfd65594f46a0; }, function (v) { return $5e320061481212d6$export$8fbbfd65594f46a0 = v; });
var $5e320061481212d6$export$8fbbfd65594f46a0;
"use strict";
$5e320061481212d6$export$8fbbfd65594f46a0 = void 0;
const $5e320061481212d6$var$formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: "eeee p",
    other: "P"
};
const $5e320061481212d6$var$formatRelative = (token, _date, _baseDate, _options)=>$5e320061481212d6$var$formatRelativeLocale[token];
$5e320061481212d6$export$8fbbfd65594f46a0 = $5e320061481212d6$var$formatRelative;

});

parcelRegister("9LSVs", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $71d31bec7dd79d78$export$b3bd0bc58e36cd63; }, function (v) { return $71d31bec7dd79d78$export$b3bd0bc58e36cd63 = v; });
var $71d31bec7dd79d78$export$b3bd0bc58e36cd63;
"use strict";
$71d31bec7dd79d78$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $71d31bec7dd79d78$var$eraValues = {
    narrow: [
        "pr. Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pr. Kr.",
        "po Kr."
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        "po Kristaus"
    ]
};
const $71d31bec7dd79d78$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I ketv.",
        "II ketv.",
        "III ketv.",
        "IV ketv."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
const $71d31bec7dd79d78$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I k.",
        "II k.",
        "III k.",
        "IV k."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
const $71d31bec7dd79d78$var$monthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "bir\u017E.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausis",
        "vasaris",
        "kovas",
        "balandis",
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        "liepa",
        "rugpj\u016Btis",
        "rugs\u0117jis",
        "spalis",
        "lapkritis",
        "gruodis"
    ]
};
const $71d31bec7dd79d78$var$formattingMonthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "bir\u017E.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausio",
        "vasario",
        "kovo",
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        "liepos",
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        "spalio",
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
const $71d31bec7dd79d78$var$dayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "\u0160"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "\u0160t"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "\u0161t"
    ],
    wide: [
        "sekmadienis",
        "pirmadienis",
        "antradienis",
        "tre\u010Diadienis",
        "ketvirtadienis",
        "penktadienis",
        "\u0161e\u0161tadienis"
    ]
};
const $71d31bec7dd79d78$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "\u0160"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "\u0160t"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
const $71d31bec7dd79d78$var$dayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    }
};
const $71d31bec7dd79d78$var$formattingDayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    }
};
const $71d31bec7dd79d78$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "-oji";
};
const $71d31bec7dd79d78$var$localize = $71d31bec7dd79d78$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $71d31bec7dd79d78$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $71d31bec7dd79d78$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $71d31bec7dd79d78$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $71d31bec7dd79d78$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $71d31bec7dd79d78$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $71d31bec7dd79d78$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $71d31bec7dd79d78$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $71d31bec7dd79d78$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $71d31bec7dd79d78$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $71d31bec7dd79d78$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("f5KgG", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $afcb368320e94a57$export$4659b591c19bdf3d; }, function (v) { return $afcb368320e94a57$export$4659b591c19bdf3d = v; });
var $afcb368320e94a57$export$4659b591c19bdf3d;
"use strict";
$afcb368320e94a57$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $afcb368320e94a57$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
const $afcb368320e94a57$var$parseOrdinalNumberPattern = /\d+/i;
const $afcb368320e94a57$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
const $afcb368320e94a57$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
const $afcb368320e94a57$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
const $afcb368320e94a57$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
const $afcb368320e94a57$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
const $afcb368320e94a57$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
const $afcb368320e94a57$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
const $afcb368320e94a57$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
const $afcb368320e94a57$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
const $afcb368320e94a57$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
const $afcb368320e94a57$var$match = $afcb368320e94a57$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $afcb368320e94a57$var$matchOrdinalNumberPattern,
        parsePattern: $afcb368320e94a57$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $afcb368320e94a57$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $afcb368320e94a57$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $afcb368320e94a57$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $afcb368320e94a57$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $afcb368320e94a57$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $afcb368320e94a57$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $afcb368320e94a57$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $afcb368320e94a57$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $afcb368320e94a57$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $afcb368320e94a57$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8STiP", function(module, exports) {

$parcel$export(module.exports, "lv", function () { return $677e43d01191450d$export$54ca4d1eb7926f1; }, function (v) { return $677e43d01191450d$export$54ca4d1eb7926f1 = v; });
var $677e43d01191450d$export$54ca4d1eb7926f1;
"use strict";
$677e43d01191450d$export$54ca4d1eb7926f1 = void 0;

var $1s8DE = parcelRequire("1s8DE");

var $b10cN = parcelRequire("b10cN");

var $fEvRG = parcelRequire("fEvRG");

var $avZ9Q = parcelRequire("avZ9Q");

var $70W6p = parcelRequire("70W6p");
/**
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs](https://github.com/prudolfs)
 */ const $677e43d01191450d$var$lv = $677e43d01191450d$export$54ca4d1eb7926f1 = {
    code: "lv",
    formatDistance: $1s8DE.formatDistance,
    formatLong: $b10cN.formatLong,
    formatRelative: $fEvRG.formatRelative,
    localize: $avZ9Q.localize,
    match: $70W6p.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("1s8DE", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $10ef1b69c5fbf033$export$2c14ff85d6318973; }, function (v) { return $10ef1b69c5fbf033$export$2c14ff85d6318973 = v; });
var $10ef1b69c5fbf033$export$2c14ff85d6318973;
"use strict";
$10ef1b69c5fbf033$export$2c14ff85d6318973 = void 0;
function $10ef1b69c5fbf033$var$buildLocalizeTokenFn(schema) {
    return (count, options)=>{
        if (count === 1) {
            if (options?.addSuffix) return schema.one[0].replace("{{time}}", schema.one[2]);
            else return schema.one[0].replace("{{time}}", schema.one[1]);
        } else {
            const rem = count % 10 === 1 && count % 100 !== 11;
            if (options?.addSuffix) return schema.other[0].replace("{{time}}", rem ? schema.other[3] : schema.other[4]).replace("{{count}}", String(count));
            else return schema.other[0].replace("{{time}}", rem ? schema.other[1] : schema.other[2]).replace("{{count}}", String(count));
        }
    };
}
const $10ef1b69c5fbf033$var$formatDistanceLocale = {
    lessThanXSeconds: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "sekundi",
            "sekundi"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    xSeconds: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "sekunde",
            "sekundes"
        ],
        other: [
            "{{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    halfAMinute: (_count, options)=>{
        if (options?.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            "{{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xHours: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "{{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xDays: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "diena",
            "dienas"
        ],
        other: [
            "{{count}} {{time}}",
            "diena",
            "dienas",
            "dienas",
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "{{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "{{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    xYears: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "{{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    overXYears: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            "gadu",
            "gadu"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    almostXYears: $10ef1b69c5fbf033$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    })
};
const $10ef1b69c5fbf033$var$formatDistance = (token, count, options)=>{
    const result = $10ef1b69c5fbf033$var$formatDistanceLocale[token](count, options);
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return "pirms " + result;
    }
    return result;
};
$10ef1b69c5fbf033$export$2c14ff85d6318973 = $10ef1b69c5fbf033$var$formatDistance;

});

parcelRegister("b10cN", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $804ff27c2ce1810e$export$cbf60ecb96cbb82f; }, function (v) { return $804ff27c2ce1810e$export$cbf60ecb96cbb82f = v; });
var $804ff27c2ce1810e$export$cbf60ecb96cbb82f;
"use strict";
$804ff27c2ce1810e$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $804ff27c2ce1810e$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: "dd.MM.y.",
    short: "dd.MM.y."
};
const $804ff27c2ce1810e$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $804ff27c2ce1810e$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $804ff27c2ce1810e$var$formatLong = $804ff27c2ce1810e$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $804ff27c2ce1810e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $804ff27c2ce1810e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $804ff27c2ce1810e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fEvRG", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b6534f23e91de3f0$export$8fbbfd65594f46a0; }, function (v) { return $b6534f23e91de3f0$export$8fbbfd65594f46a0 = v; });
var $b6534f23e91de3f0$export$8fbbfd65594f46a0;
"use strict";
$b6534f23e91de3f0$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");
const $b6534f23e91de3f0$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
const $b6534f23e91de3f0$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return "eeee 'plkst.' p";
        const weekday = $b6534f23e91de3f0$var$weekdays[date.getDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: (date, baseDate, options)=>{
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return "eeee 'plkst.' p";
        const weekday = $b6534f23e91de3f0$var$weekdays[date.getDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: "P"
};
const $b6534f23e91de3f0$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $b6534f23e91de3f0$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$b6534f23e91de3f0$export$8fbbfd65594f46a0 = $b6534f23e91de3f0$var$formatRelative;

});

parcelRegister("avZ9Q", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $7a7c3d467fc4e4a6$export$b3bd0bc58e36cd63; }, function (v) { return $7a7c3d467fc4e4a6$export$b3bd0bc58e36cd63 = v; });
var $7a7c3d467fc4e4a6$export$b3bd0bc58e36cd63;
"use strict";
$7a7c3d467fc4e4a6$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $7a7c3d467fc4e4a6$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
const $7a7c3d467fc4e4a6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmais ceturksnis",
        "otrais ceturksnis",
        "tre\u0161ais ceturksnis",
        "ceturtais ceturksnis"
    ]
};
const $7a7c3d467fc4e4a6$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
const $7a7c3d467fc4e4a6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "marts",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        "marts",
        "apr\u012Blis",
        "maijs",
        "j\u016Bnijs",
        "j\u016Blijs",
        "augusts",
        "septembris",
        "oktobris",
        "novembris",
        "decembris"
    ]
};
const $7a7c3d467fc4e4a6$var$formattingMonthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "mart\u0101",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
const $7a7c3d467fc4e4a6$var$dayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdiena",
        "pirmdiena",
        "otrdiena",
        "tre\u0161diena",
        "ceturtdiena",
        "piektdiena",
        "sestdiena"
    ]
};
const $7a7c3d467fc4e4a6$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
const $7a7c3d467fc4e4a6$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "diena",
        evening: "vakars",
        night: "nakts"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: "vakars",
        night: "nakts"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakts",
        noon: "pusdienlaiks",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: "vakars",
        night: "nakts"
    }
};
const $7a7c3d467fc4e4a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
const $7a7c3d467fc4e4a6$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $7a7c3d467fc4e4a6$var$localize = $7a7c3d467fc4e4a6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7a7c3d467fc4e4a6$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $7a7c3d467fc4e4a6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $7a7c3d467fc4e4a6$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $7a7c3d467fc4e4a6$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $7a7c3d467fc4e4a6$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $7a7c3d467fc4e4a6$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $7a7c3d467fc4e4a6$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $7a7c3d467fc4e4a6$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $7a7c3d467fc4e4a6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7a7c3d467fc4e4a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("70W6p", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $51b59a631fb4d532$export$4659b591c19bdf3d; }, function (v) { return $51b59a631fb4d532$export$4659b591c19bdf3d = v; });
var $51b59a631fb4d532$export$4659b591c19bdf3d;
"use strict";
$51b59a631fb4d532$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $51b59a631fb4d532$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $51b59a631fb4d532$var$parseOrdinalNumberPattern = /\d+/i;
const $51b59a631fb4d532$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
const $51b59a631fb4d532$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
const $51b59a631fb4d532$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
const $51b59a631fb4d532$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
const $51b59a631fb4d532$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
const $51b59a631fb4d532$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $51b59a631fb4d532$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
const $51b59a631fb4d532$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
const $51b59a631fb4d532$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
const $51b59a631fb4d532$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
const $51b59a631fb4d532$var$match = $51b59a631fb4d532$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $51b59a631fb4d532$var$matchOrdinalNumberPattern,
        parsePattern: $51b59a631fb4d532$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51b59a631fb4d532$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51b59a631fb4d532$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51b59a631fb4d532$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51b59a631fb4d532$var$parseQuarterPatterns,
        defaultParseWidth: "wide",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51b59a631fb4d532$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51b59a631fb4d532$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51b59a631fb4d532$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51b59a631fb4d532$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $51b59a631fb4d532$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51b59a631fb4d532$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("h6qyW", function(module, exports) {

$parcel$export(module.exports, "mk", function () { return $c73799fca2276b34$export$ad7cae49b56e2eb8; }, function (v) { return $c73799fca2276b34$export$ad7cae49b56e2eb8 = v; });
var $c73799fca2276b34$export$ad7cae49b56e2eb8;
"use strict";
$c73799fca2276b34$export$ad7cae49b56e2eb8 = void 0;

var $lUz5L = parcelRequire("lUz5L");

var $eAkD6 = parcelRequire("eAkD6");

var $9KBXe = parcelRequire("9KBXe");

var $2ug3G = parcelRequire("2ug3G");

var $9leRc = parcelRequire("9leRc");
/**
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar](https://github.com/vlahupetar)
 * @author Altrim Beqiri [@altrim](https://github.com/altrim)
 */ const $c73799fca2276b34$var$mk = $c73799fca2276b34$export$ad7cae49b56e2eb8 = {
    code: "mk",
    formatDistance: $lUz5L.formatDistance,
    formatLong: $eAkD6.formatLong,
    formatRelative: $9KBXe.formatRelative,
    localize: $2ug3G.localize,
    match: $9leRc.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("lUz5L", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ff3a0c7551a4885a$export$2c14ff85d6318973; }, function (v) { return $ff3a0c7551a4885a$export$2c14ff85d6318973 = v; });
var $ff3a0c7551a4885a$export$2c14ff85d6318973;
"use strict";
$ff3a0c7551a4885a$export$2c14ff85d6318973 = void 0;
const $ff3a0c7551a4885a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
const $ff3a0c7551a4885a$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ff3a0c7551a4885a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
$ff3a0c7551a4885a$export$2c14ff85d6318973 = $ff3a0c7551a4885a$var$formatDistance;

});

parcelRegister("eAkD6", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a9e46e1e99d5626f$export$cbf60ecb96cbb82f; }, function (v) { return $a9e46e1e99d5626f$export$cbf60ecb96cbb82f = v; });
var $a9e46e1e99d5626f$export$cbf60ecb96cbb82f;
"use strict";
$a9e46e1e99d5626f$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $a9e46e1e99d5626f$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
const $a9e46e1e99d5626f$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
const $a9e46e1e99d5626f$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $a9e46e1e99d5626f$var$formatLong = $a9e46e1e99d5626f$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $a9e46e1e99d5626f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $a9e46e1e99d5626f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $a9e46e1e99d5626f$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("9KBXe", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $7195d9e0bbe928a6$export$8fbbfd65594f46a0; }, function (v) { return $7195d9e0bbe928a6$export$8fbbfd65594f46a0 = v; });
var $7195d9e0bbe928a6$export$8fbbfd65594f46a0;
"use strict";
$7195d9e0bbe928a6$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");
const $7195d9e0bbe928a6$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function $7195d9e0bbe928a6$var$lastWeek(day) {
    const weekday = $7195d9e0bbe928a6$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function $7195d9e0bbe928a6$var$thisWeek(day) {
    const weekday = $7195d9e0bbe928a6$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function $7195d9e0bbe928a6$var$nextWeek(day) {
    const weekday = $7195d9e0bbe928a6$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
const $7195d9e0bbe928a6$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $7195d9e0bbe928a6$var$thisWeek(day);
        else return $7195d9e0bbe928a6$var$lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $7195d9e0bbe928a6$var$thisWeek(day);
        else return $7195d9e0bbe928a6$var$nextWeek(day);
    },
    other: "P"
};
const $7195d9e0bbe928a6$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $7195d9e0bbe928a6$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$7195d9e0bbe928a6$export$8fbbfd65594f46a0 = $7195d9e0bbe928a6$var$formatRelative;

});

parcelRegister("2ug3G", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $1cfad6f8c6a4bffd$export$b3bd0bc58e36cd63; }, function (v) { return $1cfad6f8c6a4bffd$export$b3bd0bc58e36cd63 = v; });
var $1cfad6f8c6a4bffd$export$b3bd0bc58e36cd63;
"use strict";
$1cfad6f8c6a4bffd$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $1cfad6f8c6a4bffd$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
const $1cfad6f8c6a4bffd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $1cfad6f8c6a4bffd$var$monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
const $1cfad6f8c6a4bffd$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
const $1cfad6f8c6a4bffd$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
const $1cfad6f8c6a4bffd$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
const $1cfad6f8c6a4bffd$var$localize = $1cfad6f8c6a4bffd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1cfad6f8c6a4bffd$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $1cfad6f8c6a4bffd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $1cfad6f8c6a4bffd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $1cfad6f8c6a4bffd$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $1cfad6f8c6a4bffd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $1cfad6f8c6a4bffd$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("9leRc", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $6cd19987295aec19$export$4659b591c19bdf3d; }, function (v) { return $6cd19987295aec19$export$4659b591c19bdf3d = v; });
var $6cd19987295aec19$export$4659b591c19bdf3d;
"use strict";
$6cd19987295aec19$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $6cd19987295aec19$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
const $6cd19987295aec19$var$parseOrdinalNumberPattern = /\d+/i;
const $6cd19987295aec19$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
const $6cd19987295aec19$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
const $6cd19987295aec19$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
const $6cd19987295aec19$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6cd19987295aec19$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
const $6cd19987295aec19$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
const $6cd19987295aec19$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
const $6cd19987295aec19$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
const $6cd19987295aec19$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
const $6cd19987295aec19$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
const $6cd19987295aec19$var$match = $6cd19987295aec19$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $6cd19987295aec19$var$matchOrdinalNumberPattern,
        parsePattern: $6cd19987295aec19$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6cd19987295aec19$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6cd19987295aec19$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6cd19987295aec19$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6cd19987295aec19$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6cd19987295aec19$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6cd19987295aec19$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6cd19987295aec19$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6cd19987295aec19$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6cd19987295aec19$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6cd19987295aec19$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("l2Dfu", function(module, exports) {

$parcel$export(module.exports, "mn", function () { return $f5183ae1302cd183$export$e78c44be168181dc; }, function (v) { return $f5183ae1302cd183$export$e78c44be168181dc = v; });
var $f5183ae1302cd183$export$e78c44be168181dc;
"use strict";
$f5183ae1302cd183$export$e78c44be168181dc = void 0;

var $kRHv4 = parcelRequire("kRHv4");

var $lrN4g = parcelRequire("lrN4g");

var $hTYMh = parcelRequire("hTYMh");

var $9Zlgr = parcelRequire("9Zlgr");

var $9sSBN = parcelRequire("9sSBN");
/**
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203](https://github.com/bilguun0203)
 */ const $f5183ae1302cd183$var$mn = $f5183ae1302cd183$export$e78c44be168181dc = {
    code: "mn",
    formatDistance: $kRHv4.formatDistance,
    formatLong: $lrN4g.formatLong,
    formatRelative: $hTYMh.formatRelative,
    localize: $9Zlgr.localize,
    match: $9sSBN.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("kRHv4", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f30a80212107df26$export$2c14ff85d6318973; }, function (v) { return $f30a80212107df26$export$2c14ff85d6318973 = v; });
var $f30a80212107df26$export$2c14ff85d6318973;
"use strict";
$f30a80212107df26$export$2c14ff85d6318973 = void 0;
const $f30a80212107df26$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
const $f30a80212107df26$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f30a80212107df26$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        /**
     * Append genitive case
     */ const words = result.split(" ");
        const lastword = words.pop();
        result = words.join(" ");
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
$f30a80212107df26$export$2c14ff85d6318973 = $f30a80212107df26$var$formatDistance;

});

parcelRegister("lrN4g", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $f9d22e704bbefbf3$export$cbf60ecb96cbb82f; }, function (v) { return $f9d22e704bbefbf3$export$cbf60ecb96cbb82f = v; });
var $f9d22e704bbefbf3$export$cbf60ecb96cbb82f;
"use strict";
$f9d22e704bbefbf3$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $f9d22e704bbefbf3$var$dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: "y.MM.dd"
};
const $f9d22e704bbefbf3$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $f9d22e704bbefbf3$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $f9d22e704bbefbf3$var$formatLong = $f9d22e704bbefbf3$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $f9d22e704bbefbf3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $f9d22e704bbefbf3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $f9d22e704bbefbf3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("hTYMh", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $d086b7e8c42dca66$export$8fbbfd65594f46a0; }, function (v) { return $d086b7e8c42dca66$export$8fbbfd65594f46a0 = v; });
var $d086b7e8c42dca66$export$8fbbfd65594f46a0;
"use strict";
$d086b7e8c42dca66$export$8fbbfd65594f46a0 = void 0;
const $d086b7e8c42dca66$var$formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: "P"
};
const $d086b7e8c42dca66$var$formatRelative = (token, _date, _baseDate, _options)=>$d086b7e8c42dca66$var$formatRelativeLocale[token];
$d086b7e8c42dca66$export$8fbbfd65594f46a0 = $d086b7e8c42dca66$var$formatRelative;

});

parcelRegister("9Zlgr", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $745a4e2d21545f32$export$b3bd0bc58e36cd63; }, function (v) { return $745a4e2d21545f32$export$b3bd0bc58e36cd63 = v; });
var $745a4e2d21545f32$export$b3bd0bc58e36cd63;
"use strict";
$745a4e2d21545f32$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $745a4e2d21545f32$var$eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
const $745a4e2d21545f32$var$quarterValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV"
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $745a4e2d21545f32$var$monthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
const $745a4e2d21545f32$var$formattingMonthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
const $745a4e2d21545f32$var$dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
const $745a4e2d21545f32$var$formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
const $745a4e2d21545f32$var$dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
const $745a4e2d21545f32$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $745a4e2d21545f32$var$localize = $745a4e2d21545f32$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $745a4e2d21545f32$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $745a4e2d21545f32$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $745a4e2d21545f32$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $745a4e2d21545f32$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $745a4e2d21545f32$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $745a4e2d21545f32$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $745a4e2d21545f32$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $745a4e2d21545f32$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("9sSBN", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $6e4116bb406529e7$export$4659b591c19bdf3d; }, function (v) { return $6e4116bb406529e7$export$4659b591c19bdf3d = v; });
var $6e4116bb406529e7$export$4659b591c19bdf3d;
"use strict";
$6e4116bb406529e7$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $6e4116bb406529e7$var$matchOrdinalNumberPattern = /\d+/i;
const $6e4116bb406529e7$var$parseOrdinalNumberPattern = /\d+/i;
const $6e4116bb406529e7$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
const $6e4116bb406529e7$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
const $6e4116bb406529e7$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
const $6e4116bb406529e7$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
const $6e4116bb406529e7$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
const $6e4116bb406529e7$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
const $6e4116bb406529e7$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
const $6e4116bb406529e7$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
const $6e4116bb406529e7$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
const $6e4116bb406529e7$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
const $6e4116bb406529e7$var$match = $6e4116bb406529e7$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $6e4116bb406529e7$var$matchOrdinalNumberPattern,
        parsePattern: $6e4116bb406529e7$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6e4116bb406529e7$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6e4116bb406529e7$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6e4116bb406529e7$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6e4116bb406529e7$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6e4116bb406529e7$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6e4116bb406529e7$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6e4116bb406529e7$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6e4116bb406529e7$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6e4116bb406529e7$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6e4116bb406529e7$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("e5k24", function(module, exports) {

$parcel$export(module.exports, "ms", function () { return $a41112569be011f9$export$5dd2165da01bec80; }, function (v) { return $a41112569be011f9$export$5dd2165da01bec80 = v; });
var $a41112569be011f9$export$5dd2165da01bec80;
"use strict";
$a41112569be011f9$export$5dd2165da01bec80 = void 0;

var $2K23C = parcelRequire("2K23C");

var $iQjUQ = parcelRequire("iQjUQ");

var $6hBHt = parcelRequire("6hBHt");

var $fzPc1 = parcelRequire("fzPc1");

var $hyh3w = parcelRequire("hyh3w");
/**
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten](https://github.com/Zyten)
 */ const $a41112569be011f9$var$ms = $a41112569be011f9$export$5dd2165da01bec80 = {
    code: "ms",
    formatDistance: $2K23C.formatDistance,
    formatLong: $iQjUQ.formatLong,
    formatRelative: $6hBHt.formatRelative,
    localize: $fzPc1.localize,
    match: $hyh3w.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("2K23C", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $1ff179346103b05e$export$2c14ff85d6318973; }, function (v) { return $1ff179346103b05e$export$2c14ff85d6318973 = v; });
var $1ff179346103b05e$export$2c14ff85d6318973;
"use strict";
$1ff179346103b05e$export$2c14ff85d6318973 = void 0;
const $1ff179346103b05e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 saat",
        other: "kurang dari {{count}} saat"
    },
    xSeconds: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    halfAMinute: "setengah minit",
    lessThanXMinutes: {
        one: "kurang dari 1 minit",
        other: "kurang dari {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
const $1ff179346103b05e$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $1ff179346103b05e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam masa " + result;
        else return result + " yang lalu";
    }
    return result;
};
$1ff179346103b05e$export$2c14ff85d6318973 = $1ff179346103b05e$var$formatDistance;

});

parcelRegister("iQjUQ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $db7c882f3e4dad3b$export$cbf60ecb96cbb82f; }, function (v) { return $db7c882f3e4dad3b$export$cbf60ecb96cbb82f = v; });
var $db7c882f3e4dad3b$export$cbf60ecb96cbb82f;
"use strict";
$db7c882f3e4dad3b$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $db7c882f3e4dad3b$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
const $db7c882f3e4dad3b$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
const $db7c882f3e4dad3b$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $db7c882f3e4dad3b$var$formatLong = $db7c882f3e4dad3b$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $db7c882f3e4dad3b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $db7c882f3e4dad3b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $db7c882f3e4dad3b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6hBHt", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $4931930e8786b06d$export$8fbbfd65594f46a0; }, function (v) { return $4931930e8786b06d$export$8fbbfd65594f46a0 = v; });
var $4931930e8786b06d$export$8fbbfd65594f46a0;
"use strict";
$4931930e8786b06d$export$8fbbfd65594f46a0 = void 0;
const $4931930e8786b06d$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: "P"
};
const $4931930e8786b06d$var$formatRelative = (token, _date, _baseDate, _options)=>$4931930e8786b06d$var$formatRelativeLocale[token];
$4931930e8786b06d$export$8fbbfd65594f46a0 = $4931930e8786b06d$var$formatRelative;

});

parcelRegister("fzPc1", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $b571d5c16d5d0c7e$export$b3bd0bc58e36cd63; }, function (v) { return $b571d5c16d5d0c7e$export$b3bd0bc58e36cd63 = v; });
var $b571d5c16d5d0c7e$export$b3bd0bc58e36cd63;
"use strict";
$b571d5c16d5d0c7e$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
// Most data for localization are taken from this page
// https://www.unicode.org/cldr/charts/32/summary/ms.html
const $b571d5c16d5d0c7e$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masihi",
        "Masihi"
    ]
};
const $b571d5c16d5d0c7e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "S1",
        "S2",
        "S3",
        "S4"
    ],
    wide: [
        "Suku pertama",
        "Suku kedua",
        "Suku ketiga",
        "Suku keempat"
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $b571d5c16d5d0c7e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mac",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ogo",
        "Sep",
        "Okt",
        "Nov",
        "Dis"
    ],
    wide: [
        "Januari",
        "Februari",
        "Mac",
        "April",
        "Mei",
        "Jun",
        "Julai",
        "Ogos",
        "September",
        "Oktober",
        "November",
        "Disember"
    ]
};
const $b571d5c16d5d0c7e$var$dayValues = {
    narrow: [
        "A",
        "I",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    wide: [
        "Ahad",
        "Isnin",
        "Selasa",
        "Rabu",
        "Khamis",
        "Jumaat",
        "Sabtu"
    ]
};
const $b571d5c16d5d0c7e$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tgh malam",
        noon: "tgh hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
const $b571d5c16d5d0c7e$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
const $b571d5c16d5d0c7e$var$ordinalNumber = (dirtyNumber, _options)=>{
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + Number(dirtyNumber);
};
const $b571d5c16d5d0c7e$var$localize = $b571d5c16d5d0c7e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b571d5c16d5d0c7e$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $b571d5c16d5d0c7e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $b571d5c16d5d0c7e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $b571d5c16d5d0c7e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $b571d5c16d5d0c7e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $b571d5c16d5d0c7e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b571d5c16d5d0c7e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("hyh3w", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $cc72d794448c2a52$export$4659b591c19bdf3d; }, function (v) { return $cc72d794448c2a52$export$4659b591c19bdf3d = v; });
var $cc72d794448c2a52$export$4659b591c19bdf3d;
"use strict";
$cc72d794448c2a52$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $cc72d794448c2a52$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
const $cc72d794448c2a52$var$parseOrdinalNumberPattern = /petama|\d+/i;
const $cc72d794448c2a52$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
const $cc72d794448c2a52$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
const $cc72d794448c2a52$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
const $cc72d794448c2a52$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
const $cc72d794448c2a52$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
const $cc72d794448c2a52$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
const $cc72d794448c2a52$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
const $cc72d794448c2a52$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
const $cc72d794448c2a52$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
const $cc72d794448c2a52$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
const $cc72d794448c2a52$var$match = $cc72d794448c2a52$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $cc72d794448c2a52$var$matchOrdinalNumberPattern,
        parsePattern: $cc72d794448c2a52$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc72d794448c2a52$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc72d794448c2a52$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc72d794448c2a52$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc72d794448c2a52$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc72d794448c2a52$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc72d794448c2a52$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc72d794448c2a52$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc72d794448c2a52$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $cc72d794448c2a52$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cc72d794448c2a52$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("aFyK4", function(module, exports) {

$parcel$export(module.exports, "mt", function () { return $02012c1c03d85080$export$f2a459ff55c00db5; }, function (v) { return $02012c1c03d85080$export$f2a459ff55c00db5 = v; });
var $02012c1c03d85080$export$f2a459ff55c00db5;
"use strict";
$02012c1c03d85080$export$f2a459ff55c00db5 = void 0;

var $iUtzI = parcelRequire("iUtzI");

var $1VRPX = parcelRequire("1VRPX");

var $83ZUC = parcelRequire("83ZUC");

var $hTQI9 = parcelRequire("hTQI9");

var $fOxWr = parcelRequire("fOxWr");
/**
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ const $02012c1c03d85080$var$mt = $02012c1c03d85080$export$f2a459ff55c00db5 = {
    code: "mt",
    formatDistance: $iUtzI.formatDistance,
    formatLong: $1VRPX.formatLong,
    formatRelative: $83ZUC.formatRelative,
    localize: $hTQI9.localize,
    match: $fOxWr.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("iUtzI", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $dc4465f22c8ac199$export$2c14ff85d6318973; }, function (v) { return $dc4465f22c8ac199$export$2c14ff85d6318973 = v; });
var $dc4465f22c8ac199$export$2c14ff85d6318973;
"use strict";
$dc4465f22c8ac199$export$2c14ff85d6318973 = void 0;
const $dc4465f22c8ac199$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "inqas minn sekonda",
        other: "inqas minn {{count}} sekondi"
    },
    xSeconds: {
        one: "sekonda",
        other: "{{count}} sekondi"
    },
    halfAMinute: "nofs minuta",
    lessThanXMinutes: {
        one: "inqas minn minuta",
        other: "inqas minn {{count}} minuti"
    },
    xMinutes: {
        one: "minuta",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: "madwar xahar",
        other: "madwar {{count}} xhur"
    },
    xMonths: {
        one: "xahar",
        other: "{{count}} xhur"
    },
    aboutXYears: {
        one: "madwar sena",
        two: "madwar sentejn",
        other: "madwar {{count}} snin"
    },
    xYears: {
        one: "sena",
        two: "sentejn",
        other: "{{count}} snin"
    },
    overXYears: {
        one: "aktar minn sena",
        two: "aktar minn sentejn",
        other: "aktar minn {{count}} snin"
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
const $dc4465f22c8ac199$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $dc4465f22c8ac199$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + " ilu";
    }
    return result;
};
$dc4465f22c8ac199$export$2c14ff85d6318973 = $dc4465f22c8ac199$var$formatDistance;

});

parcelRegister("1VRPX", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $1684e03922d4a042$export$cbf60ecb96cbb82f; }, function (v) { return $1684e03922d4a042$export$cbf60ecb96cbb82f = v; });
var $1684e03922d4a042$export$cbf60ecb96cbb82f;
"use strict";
$1684e03922d4a042$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $1684e03922d4a042$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $1684e03922d4a042$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $1684e03922d4a042$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $1684e03922d4a042$var$formatLong = $1684e03922d4a042$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $1684e03922d4a042$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $1684e03922d4a042$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $1684e03922d4a042$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("83ZUC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $5deea1006dee2974$export$8fbbfd65594f46a0; }, function (v) { return $5deea1006dee2974$export$8fbbfd65594f46a0 = v; });
var $5deea1006dee2974$export$8fbbfd65594f46a0;
"use strict";
$5deea1006dee2974$export$8fbbfd65594f46a0 = void 0;
const $5deea1006dee2974$var$formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: "P"
};
const $5deea1006dee2974$var$formatRelative = (token, _date, _baseDate, _options)=>$5deea1006dee2974$var$formatRelativeLocale[token];
$5deea1006dee2974$export$8fbbfd65594f46a0 = $5deea1006dee2974$var$formatRelative;

});

parcelRegister("hTQI9", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $d0807612f6185d90$export$b3bd0bc58e36cd63; }, function (v) { return $d0807612f6185d90$export$b3bd0bc58e36cd63 = v; });
var $d0807612f6185d90$export$b3bd0bc58e36cd63;
"use strict";
$d0807612f6185d90$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $d0807612f6185d90$var$eraValues = {
    narrow: [
        "Q",
        "W"
    ],
    abbreviated: [
        "QK",
        "WK"
    ],
    wide: [
        "qabel Kristu",
        "wara Kristu"
    ]
};
const $d0807612f6185d90$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kwart",
        "2. kwart",
        "3. kwart",
        "4. kwart"
    ]
};
const $d0807612f6185d90$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "\u0120",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Fra",
        "Mar",
        "Apr",
        "Mej",
        "\u0120un",
        "Lul",
        "Aww",
        "Set",
        "Ott",
        "Nov",
        "Di\u010B"
    ],
    wide: [
        "Jannar",
        "Frar",
        "Marzu",
        "April",
        "Mejju",
        "\u0120unju",
        "Lulju",
        "Awwissu",
        "Settembru",
        "Ottubru",
        "Novembru",
        "Di\u010Bembru"
    ]
};
const $d0807612f6185d90$var$dayValues = {
    narrow: [
        "\u0126",
        "T",
        "T",
        "E",
        "\u0126",
        "\u0120",
        "S"
    ],
    short: [
        "\u0126a",
        "Tn",
        "Tl",
        "Er",
        "\u0126a",
        "\u0120i",
        "Si"
    ],
    abbreviated: [
        "\u0126ad",
        "Tne",
        "Tli",
        "Erb",
        "\u0126am",
        "\u0120im",
        "Sib"
    ],
    wide: [
        "Il-\u0126add",
        "It-Tnejn",
        "It-Tlieta",
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        "Is-Sibt"
    ]
};
const $d0807612f6185d90$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    }
};
const $d0807612f6185d90$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    }
};
const $d0807612f6185d90$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $d0807612f6185d90$var$localize = $d0807612f6185d90$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $d0807612f6185d90$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $d0807612f6185d90$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $d0807612f6185d90$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $d0807612f6185d90$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $d0807612f6185d90$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $d0807612f6185d90$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $d0807612f6185d90$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("fOxWr", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $b835daa311243a07$export$4659b591c19bdf3d; }, function (v) { return $b835daa311243a07$export$4659b591c19bdf3d = v; });
var $b835daa311243a07$export$4659b591c19bdf3d;
"use strict";
$b835daa311243a07$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $b835daa311243a07$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $b835daa311243a07$var$parseOrdinalNumberPattern = /\d+/i;
const $b835daa311243a07$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
const $b835daa311243a07$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
const $b835daa311243a07$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
const $b835daa311243a07$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $b835daa311243a07$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
const $b835daa311243a07$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $b835daa311243a07$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
const $b835daa311243a07$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
const $b835daa311243a07$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
const $b835daa311243a07$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
const $b835daa311243a07$var$match = $b835daa311243a07$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $b835daa311243a07$var$matchOrdinalNumberPattern,
        parsePattern: $b835daa311243a07$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b835daa311243a07$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b835daa311243a07$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b835daa311243a07$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b835daa311243a07$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b835daa311243a07$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b835daa311243a07$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b835daa311243a07$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b835daa311243a07$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b835daa311243a07$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b835daa311243a07$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("acSzB", function(module, exports) {

$parcel$export(module.exports, "nb", function () { return $76e55b7bb502a9b1$export$38ef0e3f791a121e; }, function (v) { return $76e55b7bb502a9b1$export$38ef0e3f791a121e = v; });
var $76e55b7bb502a9b1$export$38ef0e3f791a121e;
"use strict";
$76e55b7bb502a9b1$export$38ef0e3f791a121e = void 0;

var $9DkG4 = parcelRequire("9DkG4");

var $4ox7O = parcelRequire("4ox7O");

var $8zJUM = parcelRequire("8zJUM");

var $da3kq = parcelRequire("da3kq");

var $1xWKt = parcelRequire("1xWKt");
/**
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse](https://github.com/Hanse)
 * @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Dag Stuan [@dagstuan](https://github.com/dagstuan)
 */ const $76e55b7bb502a9b1$var$nb = $76e55b7bb502a9b1$export$38ef0e3f791a121e = {
    code: "nb",
    formatDistance: $9DkG4.formatDistance,
    formatLong: $4ox7O.formatLong,
    formatRelative: $8zJUM.formatRelative,
    localize: $da3kq.localize,
    match: $1xWKt.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("9DkG4", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $7037cbba32fddf50$export$2c14ff85d6318973; }, function (v) { return $7037cbba32fddf50$export$2c14ff85d6318973 = v; });
var $7037cbba32fddf50$export$2c14ff85d6318973;
"use strict";
$7037cbba32fddf50$export$2c14ff85d6318973 = void 0;
const $7037cbba32fddf50$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
    },
    xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "et halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
    },
    xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
    },
    xHours: {
        one: "en time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dager"
    },
    aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
    },
    xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
const $7037cbba32fddf50$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $7037cbba32fddf50$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
$7037cbba32fddf50$export$2c14ff85d6318973 = $7037cbba32fddf50$var$formatDistance;

});

parcelRegister("4ox7O", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $33331942e8ecf0e4$export$cbf60ecb96cbb82f; }, function (v) { return $33331942e8ecf0e4$export$cbf60ecb96cbb82f = v; });
var $33331942e8ecf0e4$export$cbf60ecb96cbb82f;
"use strict";
$33331942e8ecf0e4$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $33331942e8ecf0e4$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $33331942e8ecf0e4$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $33331942e8ecf0e4$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $33331942e8ecf0e4$var$formatLong = $33331942e8ecf0e4$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $33331942e8ecf0e4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $33331942e8ecf0e4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $33331942e8ecf0e4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("8zJUM", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $63e5355383c3e439$export$8fbbfd65594f46a0; }, function (v) { return $63e5355383c3e439$export$8fbbfd65594f46a0 = v; });
var $63e5355383c3e439$export$8fbbfd65594f46a0;
"use strict";
$63e5355383c3e439$export$8fbbfd65594f46a0 = void 0;
const $63e5355383c3e439$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $63e5355383c3e439$var$formatRelative = (token, _date, _baseDate, _options)=>$63e5355383c3e439$var$formatRelativeLocale[token];
$63e5355383c3e439$export$8fbbfd65594f46a0 = $63e5355383c3e439$var$formatRelative;

});

parcelRegister("da3kq", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $994eca821451f1a4$export$b3bd0bc58e36cd63; }, function (v) { return $994eca821451f1a4$export$b3bd0bc58e36cd63 = v; });
var $994eca821451f1a4$export$b3bd0bc58e36cd63;
"use strict";
$994eca821451f1a4$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $994eca821451f1a4$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
const $994eca821451f1a4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $994eca821451f1a4$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
const $994eca821451f1a4$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
const $994eca821451f1a4$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
const $994eca821451f1a4$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $994eca821451f1a4$var$localize = $994eca821451f1a4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $994eca821451f1a4$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $994eca821451f1a4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $994eca821451f1a4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $994eca821451f1a4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $994eca821451f1a4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $994eca821451f1a4$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("1xWKt", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $120671bce9ed6bca$export$4659b591c19bdf3d; }, function (v) { return $120671bce9ed6bca$export$4659b591c19bdf3d = v; });
var $120671bce9ed6bca$export$4659b591c19bdf3d;
"use strict";
$120671bce9ed6bca$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $120671bce9ed6bca$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $120671bce9ed6bca$var$parseOrdinalNumberPattern = /\d+/i;
const $120671bce9ed6bca$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
const $120671bce9ed6bca$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
const $120671bce9ed6bca$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $120671bce9ed6bca$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $120671bce9ed6bca$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
const $120671bce9ed6bca$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $120671bce9ed6bca$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
const $120671bce9ed6bca$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $120671bce9ed6bca$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
const $120671bce9ed6bca$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
const $120671bce9ed6bca$var$match = $120671bce9ed6bca$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $120671bce9ed6bca$var$matchOrdinalNumberPattern,
        parsePattern: $120671bce9ed6bca$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $120671bce9ed6bca$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120671bce9ed6bca$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $120671bce9ed6bca$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120671bce9ed6bca$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $120671bce9ed6bca$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120671bce9ed6bca$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $120671bce9ed6bca$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120671bce9ed6bca$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $120671bce9ed6bca$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $120671bce9ed6bca$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("5AchQ", function(module, exports) {

$parcel$export(module.exports, "nl", function () { return $4109d870a5fcaae0$export$9c64ee4d84d79ce1; }, function (v) { return $4109d870a5fcaae0$export$9c64ee4d84d79ce1 = v; });
var $4109d870a5fcaae0$export$9c64ee4d84d79ce1;
"use strict";
$4109d870a5fcaae0$export$9c64ee4d84d79ce1 = void 0;

var $c0af6 = parcelRequire("c0af6");

var $6Kxox = parcelRequire("6Kxox");

var $irVVC = parcelRequire("irVVC");

var $1cfFM = parcelRequire("1cfFM");

var $a0heO = parcelRequire("a0heO");
/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Edo Rivai [@edorivai](https://github.com/edorivai)
 * @author Niels Keurentjes [@curry684](https://github.com/curry684)
 * @author Stefan Vermaas [@stefanvermaas](https://github.com/stefanvermaas)
 */ const $4109d870a5fcaae0$var$nl = $4109d870a5fcaae0$export$9c64ee4d84d79ce1 = {
    code: "nl",
    formatDistance: $c0af6.formatDistance,
    formatLong: $6Kxox.formatLong,
    formatRelative: $irVVC.formatRelative,
    localize: $1cfFM.localize,
    match: $a0heO.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("c0af6", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $8bcd6e189b1e9ebe$export$2c14ff85d6318973; }, function (v) { return $8bcd6e189b1e9ebe$export$2c14ff85d6318973 = v; });
var $8bcd6e189b1e9ebe$export$2c14ff85d6318973;
"use strict";
$8bcd6e189b1e9ebe$export$2c14ff85d6318973 = void 0;
const $8bcd6e189b1e9ebe$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
const $8bcd6e189b1e9ebe$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $8bcd6e189b1e9ebe$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
$8bcd6e189b1e9ebe$export$2c14ff85d6318973 = $8bcd6e189b1e9ebe$var$formatDistance;

});

parcelRegister("6Kxox", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $4ea0f17299728698$export$cbf60ecb96cbb82f; }, function (v) { return $4ea0f17299728698$export$cbf60ecb96cbb82f = v; });
var $4ea0f17299728698$export$cbf60ecb96cbb82f;
"use strict";
$4ea0f17299728698$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $4ea0f17299728698$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
const $4ea0f17299728698$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $4ea0f17299728698$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $4ea0f17299728698$var$formatLong = $4ea0f17299728698$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $4ea0f17299728698$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $4ea0f17299728698$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $4ea0f17299728698$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("irVVC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $d6e7aef3a7289065$export$8fbbfd65594f46a0; }, function (v) { return $d6e7aef3a7289065$export$8fbbfd65594f46a0 = v; });
var $d6e7aef3a7289065$export$8fbbfd65594f46a0;
"use strict";
$d6e7aef3a7289065$export$8fbbfd65594f46a0 = void 0;
const $d6e7aef3a7289065$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $d6e7aef3a7289065$var$formatRelative = (token, _date, _baseDate, _options)=>$d6e7aef3a7289065$var$formatRelativeLocale[token];
$d6e7aef3a7289065$export$8fbbfd65594f46a0 = $d6e7aef3a7289065$var$formatRelative;

});

parcelRegister("1cfFM", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0df311c21327800d$export$b3bd0bc58e36cd63; }, function (v) { return $0df311c21327800d$export$b3bd0bc58e36cd63 = v; });
var $0df311c21327800d$export$b3bd0bc58e36cd63;
"use strict";
$0df311c21327800d$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $0df311c21327800d$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $0df311c21327800d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
const $0df311c21327800d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $0df311c21327800d$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
const $0df311c21327800d$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
const $0df311c21327800d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $0df311c21327800d$var$localize = $0df311c21327800d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0df311c21327800d$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $0df311c21327800d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $0df311c21327800d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $0df311c21327800d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $0df311c21327800d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $0df311c21327800d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("a0heO", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $748746910b4e9f76$export$4659b591c19bdf3d; }, function (v) { return $748746910b4e9f76$export$4659b591c19bdf3d = v; });
var $748746910b4e9f76$export$4659b591c19bdf3d;
"use strict";
$748746910b4e9f76$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $748746910b4e9f76$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $748746910b4e9f76$var$parseOrdinalNumberPattern = /\d+/i;
const $748746910b4e9f76$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
const $748746910b4e9f76$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $748746910b4e9f76$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
const $748746910b4e9f76$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $748746910b4e9f76$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
const $748746910b4e9f76$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
const $748746910b4e9f76$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
const $748746910b4e9f76$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
const $748746910b4e9f76$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
const $748746910b4e9f76$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
const $748746910b4e9f76$var$match = $748746910b4e9f76$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $748746910b4e9f76$var$matchOrdinalNumberPattern,
        parsePattern: $748746910b4e9f76$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $748746910b4e9f76$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $748746910b4e9f76$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $748746910b4e9f76$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $748746910b4e9f76$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $748746910b4e9f76$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $748746910b4e9f76$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $748746910b4e9f76$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $748746910b4e9f76$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $748746910b4e9f76$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $748746910b4e9f76$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("7pqQx", function(module, exports) {

$parcel$export(module.exports, "nlBE", function () { return $016461d3ea31d7d1$export$3fc71760fcd6c40e; }, function (v) { return $016461d3ea31d7d1$export$3fc71760fcd6c40e = v; });
var $016461d3ea31d7d1$export$3fc71760fcd6c40e;
"use strict";
$016461d3ea31d7d1$export$3fc71760fcd6c40e = void 0;

var $g7Ldx = parcelRequire("g7Ldx");

var $5HYAJ = parcelRequire("5HYAJ");

var $kGiUh = parcelRequire("kGiUh");

var $bHHK1 = parcelRequire("bHHK1");

var $a0U87 = parcelRequire("a0U87");
/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */ const $016461d3ea31d7d1$var$nlBE = $016461d3ea31d7d1$export$3fc71760fcd6c40e = {
    code: "nl-BE",
    formatDistance: $g7Ldx.formatDistance,
    formatLong: $5HYAJ.formatLong,
    formatRelative: $kGiUh.formatRelative,
    localize: $bHHK1.localize,
    match: $a0U87.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("g7Ldx", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $bbd1ed2ef2c57ad2$export$2c14ff85d6318973; }, function (v) { return $bbd1ed2ef2c57ad2$export$2c14ff85d6318973 = v; });
var $bbd1ed2ef2c57ad2$export$2c14ff85d6318973;
"use strict";
$bbd1ed2ef2c57ad2$export$2c14ff85d6318973 = void 0;
const $bbd1ed2ef2c57ad2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
const $bbd1ed2ef2c57ad2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $bbd1ed2ef2c57ad2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
$bbd1ed2ef2c57ad2$export$2c14ff85d6318973 = $bbd1ed2ef2c57ad2$var$formatDistance;

});

parcelRegister("5HYAJ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $427ff818444dc6fd$export$cbf60ecb96cbb82f; }, function (v) { return $427ff818444dc6fd$export$cbf60ecb96cbb82f = v; });
var $427ff818444dc6fd$export$cbf60ecb96cbb82f;
"use strict";
$427ff818444dc6fd$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $427ff818444dc6fd$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $427ff818444dc6fd$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $427ff818444dc6fd$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $427ff818444dc6fd$var$formatLong = $427ff818444dc6fd$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $427ff818444dc6fd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $427ff818444dc6fd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $427ff818444dc6fd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("kGiUh", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $f0e6655f185560b8$export$8fbbfd65594f46a0; }, function (v) { return $f0e6655f185560b8$export$8fbbfd65594f46a0 = v; });
var $f0e6655f185560b8$export$8fbbfd65594f46a0;
"use strict";
$f0e6655f185560b8$export$8fbbfd65594f46a0 = void 0;
const $f0e6655f185560b8$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $f0e6655f185560b8$var$formatRelative = (token, _date, _baseDate, _options)=>$f0e6655f185560b8$var$formatRelativeLocale[token];
$f0e6655f185560b8$export$8fbbfd65594f46a0 = $f0e6655f185560b8$var$formatRelative;

});

parcelRegister("bHHK1", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8855a3f8dbffee68$export$b3bd0bc58e36cd63; }, function (v) { return $8855a3f8dbffee68$export$b3bd0bc58e36cd63 = v; });
var $8855a3f8dbffee68$export$b3bd0bc58e36cd63;
"use strict";
$8855a3f8dbffee68$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $8855a3f8dbffee68$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $8855a3f8dbffee68$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
const $8855a3f8dbffee68$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $8855a3f8dbffee68$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
const $8855a3f8dbffee68$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
const $8855a3f8dbffee68$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $8855a3f8dbffee68$var$localize = $8855a3f8dbffee68$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8855a3f8dbffee68$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $8855a3f8dbffee68$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $8855a3f8dbffee68$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $8855a3f8dbffee68$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $8855a3f8dbffee68$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $8855a3f8dbffee68$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("a0U87", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $74a571b7ab33a722$export$4659b591c19bdf3d; }, function (v) { return $74a571b7ab33a722$export$4659b591c19bdf3d = v; });
var $74a571b7ab33a722$export$4659b591c19bdf3d;
"use strict";
$74a571b7ab33a722$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $74a571b7ab33a722$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $74a571b7ab33a722$var$parseOrdinalNumberPattern = /\d+/i;
const $74a571b7ab33a722$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
const $74a571b7ab33a722$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $74a571b7ab33a722$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
const $74a571b7ab33a722$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $74a571b7ab33a722$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
const $74a571b7ab33a722$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
const $74a571b7ab33a722$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
const $74a571b7ab33a722$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
const $74a571b7ab33a722$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
const $74a571b7ab33a722$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
const $74a571b7ab33a722$var$match = $74a571b7ab33a722$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $74a571b7ab33a722$var$matchOrdinalNumberPattern,
        parsePattern: $74a571b7ab33a722$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $74a571b7ab33a722$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74a571b7ab33a722$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $74a571b7ab33a722$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74a571b7ab33a722$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $74a571b7ab33a722$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74a571b7ab33a722$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $74a571b7ab33a722$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74a571b7ab33a722$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $74a571b7ab33a722$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $74a571b7ab33a722$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("UQmiN", function(module, exports) {

$parcel$export(module.exports, "nn", function () { return $0aadd86d42d2d5ce$export$5581105212343b35; }, function (v) { return $0aadd86d42d2d5ce$export$5581105212343b35 = v; });
var $0aadd86d42d2d5ce$export$5581105212343b35;
"use strict";
$0aadd86d42d2d5ce$export$5581105212343b35 = void 0;

var $7Uo6M = parcelRequire("7Uo6M");

var $bhEK1 = parcelRequire("bhEK1");

var $jsxj4 = parcelRequire("jsxj4");

var $cgyU2 = parcelRequire("cgyU2");

var $92dky = parcelRequire("92dky");
/**
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner](https://github.com/draperunner)
 */ const $0aadd86d42d2d5ce$var$nn = $0aadd86d42d2d5ce$export$5581105212343b35 = {
    code: "nn",
    formatDistance: $7Uo6M.formatDistance,
    formatLong: $bhEK1.formatLong,
    formatRelative: $jsxj4.formatRelative,
    localize: $cgyU2.localize,
    match: $92dky.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("7Uo6M", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $5c2076c33c702b76$export$2c14ff85d6318973; }, function (v) { return $5c2076c33c702b76$export$2c14ff85d6318973 = v; });
var $5c2076c33c702b76$export$2c14ff85d6318973;
"use strict";
$5c2076c33c702b76$export$2c14ff85d6318973 = void 0;
const $5c2076c33c702b76$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn eitt sekund",
        other: "mindre enn {{count}} sekund"
    },
    xSeconds: {
        one: "eitt sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "eit halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn eitt minutt",
        other: "mindre enn {{count}} minutt"
    },
    xMinutes: {
        one: "eitt minutt",
        other: "{{count}} minutt"
    },
    aboutXHours: {
        one: "omtrent ein time",
        other: "omtrent {{count}} timar"
    },
    xHours: {
        one: "ein time",
        other: "{{count}} timar"
    },
    xDays: {
        one: "ein dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "omtrent ei veke",
        other: "omtrent {{count}} veker"
    },
    xWeeks: {
        one: "ei veke",
        other: "{{count}} veker"
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
const $5c2076c33c702b76$var$wordMapping = [
    "null",
    "ein",
    "to",
    "tre",
    "fire",
    "fem",
    "seks",
    "sju",
    "\xe5tte",
    "ni",
    "ti",
    "elleve",
    "tolv"
];
const $5c2076c33c702b76$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $5c2076c33c702b76$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $5c2076c33c702b76$var$wordMapping[count] : String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sidan";
    }
    return result;
};
$5c2076c33c702b76$export$2c14ff85d6318973 = $5c2076c33c702b76$var$formatDistance;

});

parcelRegister("bhEK1", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $8370e29b0434ec09$export$cbf60ecb96cbb82f; }, function (v) { return $8370e29b0434ec09$export$cbf60ecb96cbb82f = v; });
var $8370e29b0434ec09$export$cbf60ecb96cbb82f;
"use strict";
$8370e29b0434ec09$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $8370e29b0434ec09$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $8370e29b0434ec09$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $8370e29b0434ec09$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $8370e29b0434ec09$var$formatLong = $8370e29b0434ec09$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $8370e29b0434ec09$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $8370e29b0434ec09$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $8370e29b0434ec09$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("jsxj4", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $e2aa77d34c5636af$export$8fbbfd65594f46a0; }, function (v) { return $e2aa77d34c5636af$export$8fbbfd65594f46a0 = v; });
var $e2aa77d34c5636af$export$8fbbfd65594f46a0;
"use strict";
$e2aa77d34c5636af$export$8fbbfd65594f46a0 = void 0;
const $e2aa77d34c5636af$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $e2aa77d34c5636af$var$formatRelative = (token, _date, _baseDate, _options)=>$e2aa77d34c5636af$var$formatRelativeLocale[token];
$e2aa77d34c5636af$export$8fbbfd65594f46a0 = $e2aa77d34c5636af$var$formatRelative;

});

parcelRegister("cgyU2", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8ee20da6aa1cbc4d$export$b3bd0bc58e36cd63; }, function (v) { return $8ee20da6aa1cbc4d$export$b3bd0bc58e36cd63 = v; });
var $8ee20da6aa1cbc4d$export$b3bd0bc58e36cd63;
"use strict";
$8ee20da6aa1cbc4d$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $8ee20da6aa1cbc4d$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
const $8ee20da6aa1cbc4d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $8ee20da6aa1cbc4d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
const $8ee20da6aa1cbc4d$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "su",
        "m\xe5",
        "ty",
        "on",
        "to",
        "fr",
        "lau"
    ],
    abbreviated: [
        "sun",
        "m\xe5n",
        "tys",
        "ons",
        "tor",
        "fre",
        "laur"
    ],
    wide: [
        "sundag",
        "m\xe5ndag",
        "tysdag",
        "onsdag",
        "torsdag",
        "fredag",
        "laurdag"
    ]
};
const $8ee20da6aa1cbc4d$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
const $8ee20da6aa1cbc4d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $8ee20da6aa1cbc4d$var$localize = $8ee20da6aa1cbc4d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8ee20da6aa1cbc4d$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $8ee20da6aa1cbc4d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $8ee20da6aa1cbc4d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $8ee20da6aa1cbc4d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $8ee20da6aa1cbc4d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $8ee20da6aa1cbc4d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("92dky", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $693ea42511c4fb18$export$4659b591c19bdf3d; }, function (v) { return $693ea42511c4fb18$export$4659b591c19bdf3d = v; });
var $693ea42511c4fb18$export$4659b591c19bdf3d;
"use strict";
$693ea42511c4fb18$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $693ea42511c4fb18$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $693ea42511c4fb18$var$parseOrdinalNumberPattern = /\d+/i;
const $693ea42511c4fb18$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
const $693ea42511c4fb18$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
const $693ea42511c4fb18$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $693ea42511c4fb18$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $693ea42511c4fb18$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
const $693ea42511c4fb18$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $693ea42511c4fb18$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
const $693ea42511c4fb18$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $693ea42511c4fb18$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
const $693ea42511c4fb18$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
const $693ea42511c4fb18$var$match = $693ea42511c4fb18$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $693ea42511c4fb18$var$matchOrdinalNumberPattern,
        parsePattern: $693ea42511c4fb18$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $693ea42511c4fb18$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $693ea42511c4fb18$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $693ea42511c4fb18$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $693ea42511c4fb18$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $693ea42511c4fb18$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $693ea42511c4fb18$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $693ea42511c4fb18$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $693ea42511c4fb18$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $693ea42511c4fb18$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $693ea42511c4fb18$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("gn5Ir", function(module, exports) {

$parcel$export(module.exports, "oc", function () { return $beb33a62c1061cf2$export$35a3191dac31414; }, function (v) { return $beb33a62c1061cf2$export$35a3191dac31414 = v; });
var $beb33a62c1061cf2$export$35a3191dac31414;
"use strict";
$beb33a62c1061cf2$export$35a3191dac31414 = void 0;

var $5FnWL = parcelRequire("5FnWL");

var $e8O4E = parcelRequire("e8O4E");

var $dE6T4 = parcelRequire("dE6T4");

var $630zA = parcelRequire("630zA");

var $2fvoI = parcelRequire("2fvoI");
/**
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ const $beb33a62c1061cf2$var$oc = $beb33a62c1061cf2$export$35a3191dac31414 = {
    code: "oc",
    formatDistance: $5FnWL.formatDistance,
    formatLong: $e8O4E.formatLong,
    formatRelative: $dE6T4.formatRelative,
    localize: $630zA.localize,
    match: $2fvoI.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("5FnWL", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $42035b72840a62fb$export$2c14ff85d6318973; }, function (v) { return $42035b72840a62fb$export$2c14ff85d6318973 = v; });
var $42035b72840a62fb$export$2c14ff85d6318973;
"use strict";
$42035b72840a62fb$export$2c14ff85d6318973 = void 0;
const $42035b72840a62fb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: "mens de {{count}} segondas"
    },
    xSeconds: {
        one: "1 segonda",
        other: "{{count}} segondas"
    },
    halfAMinute: "30 segondas",
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: "mens de {{count}} minutas"
    },
    xMinutes: {
        one: "1 minuta",
        other: "{{count}} minutas"
    },
    aboutXHours: {
        one: "environ 1 ora",
        other: "environ {{count}} oras"
    },
    xHours: {
        one: "1 ora",
        other: "{{count}} oras"
    },
    xDays: {
        one: "1 jorn",
        other: "{{count}} jorns"
    },
    aboutXWeeks: {
        one: "environ 1 setmana",
        other: "environ {{count}} setmanas"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanas"
    },
    aboutXMonths: {
        one: "environ 1 mes",
        other: "environ {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: "mai de {{count}} ans"
    },
    almostXYears: {
        one: "gaireben un an",
        other: "gaireben {{count}} ans"
    }
};
const $42035b72840a62fb$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $42035b72840a62fb$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return "fa " + result;
    }
    return result;
};
$42035b72840a62fb$export$2c14ff85d6318973 = $42035b72840a62fb$var$formatDistance;

});

parcelRegister("e8O4E", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a4b8a7ae6e58593b$export$cbf60ecb96cbb82f; }, function (v) { return $a4b8a7ae6e58593b$export$cbf60ecb96cbb82f = v; });
var $a4b8a7ae6e58593b$export$cbf60ecb96cbb82f;
"use strict";
$a4b8a7ae6e58593b$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $a4b8a7ae6e58593b$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $a4b8a7ae6e58593b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a4b8a7ae6e58593b$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a4b8a7ae6e58593b$var$formatLong = $a4b8a7ae6e58593b$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $a4b8a7ae6e58593b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $a4b8a7ae6e58593b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $a4b8a7ae6e58593b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dE6T4", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9ef45a782c28d801$export$8fbbfd65594f46a0; }, function (v) { return $9ef45a782c28d801$export$8fbbfd65594f46a0 = v; });
var $9ef45a782c28d801$export$8fbbfd65594f46a0;
"use strict";
$9ef45a782c28d801$export$8fbbfd65594f46a0 = void 0;
const $9ef45a782c28d801$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: "P"
};
const $9ef45a782c28d801$var$formatRelative = (token, _date, _baseDate, _options)=>$9ef45a782c28d801$var$formatRelativeLocale[token];
$9ef45a782c28d801$export$8fbbfd65594f46a0 = $9ef45a782c28d801$var$formatRelative;

});

parcelRegister("630zA", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $467377b18f876035$export$b3bd0bc58e36cd63; }, function (v) { return $467377b18f876035$export$b3bd0bc58e36cd63 = v; });
var $467377b18f876035$export$b3bd0bc58e36cd63;
"use strict";
$467377b18f876035$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $467377b18f876035$var$eraValues = {
    narrow: [
        "ab. J.C.",
        "apr. J.C."
    ],
    abbreviated: [
        "ab. J.C.",
        "apr. J.C."
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
const $467377b18f876035$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1\xe8r trim.",
        "2nd trim.",
        "3en trim.",
        "4en trim."
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
const $467377b18f876035$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MA",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DC"
    ],
    abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "mai",
        "junh",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "dec."
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        "abril",
        "mai",
        "junh",
        "julhet",
        "agost",
        "setembre",
        "oct\xf2bre",
        "novembre",
        "decembre"
    ]
};
const $467377b18f876035$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "dimenge",
        "diluns",
        "dimars",
        "dim\xe8cres",
        "dij\xf2us",
        "divendres",
        "dissabte"
    ]
};
const $467377b18f876035$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
const $467377b18f876035$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    }
};
const $467377b18f876035$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = "nd";
            break;
        default:
            ordinal = "en";
    }
    // feminine for year, week, hour, minute, second
    if (unit === "year" || unit === "week" || unit === "hour" || unit === "minute" || unit === "second") ordinal += "a";
    return number + ordinal;
};
const $467377b18f876035$var$localize = $467377b18f876035$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $467377b18f876035$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $467377b18f876035$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $467377b18f876035$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $467377b18f876035$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $467377b18f876035$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $467377b18f876035$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $467377b18f876035$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("2fvoI", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $1a355667a7528a7b$export$4659b591c19bdf3d; }, function (v) { return $1a355667a7528a7b$export$4659b591c19bdf3d = v; });
var $1a355667a7528a7b$export$4659b591c19bdf3d;
"use strict";
$1a355667a7528a7b$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $1a355667a7528a7b$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
const $1a355667a7528a7b$var$parseOrdinalNumberPattern = /\d+/i;
const $1a355667a7528a7b$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
const $1a355667a7528a7b$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
const $1a355667a7528a7b$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
const $1a355667a7528a7b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $1a355667a7528a7b$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
const $1a355667a7528a7b$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $1a355667a7528a7b$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
const $1a355667a7528a7b$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
const $1a355667a7528a7b$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
const $1a355667a7528a7b$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
const $1a355667a7528a7b$var$match = $1a355667a7528a7b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $1a355667a7528a7b$var$matchOrdinalNumberPattern,
        parsePattern: $1a355667a7528a7b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1a355667a7528a7b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a355667a7528a7b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1a355667a7528a7b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a355667a7528a7b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1a355667a7528a7b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a355667a7528a7b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1a355667a7528a7b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a355667a7528a7b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1a355667a7528a7b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1a355667a7528a7b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("cHaGg", function(module, exports) {

$parcel$export(module.exports, "pl", function () { return $93e1c9207124418f$export$6ea5311eda92944f; }, function (v) { return $93e1c9207124418f$export$6ea5311eda92944f = v; });
var $93e1c9207124418f$export$6ea5311eda92944f;
"use strict";
$93e1c9207124418f$export$6ea5311eda92944f = void 0;

var $cxtEF = parcelRequire("cxtEF");

var $1l7oA = parcelRequire("1l7oA");

var $4Bsb3 = parcelRequire("4Bsb3");

var $15wJp = parcelRequire("15wJp");

var $7WQlS = parcelRequire("7WQlS");
/**
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks](https://github.com/ertrzyiks)
 * @author Just RAG [@justrag](https://github.com/justrag)
 * @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Mateusz Tokarski [@mutisz](https://github.com/mutisz)
 */ const $93e1c9207124418f$var$pl = $93e1c9207124418f$export$6ea5311eda92944f = {
    code: "pl",
    formatDistance: $cxtEF.formatDistance,
    formatLong: $1l7oA.formatLong,
    formatRelative: $4Bsb3.formatRelative,
    localize: $15wJp.localize,
    match: $7WQlS.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("cxtEF", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $920f91ef5706eaff$export$2c14ff85d6318973; }, function (v) { return $920f91ef5706eaff$export$2c14ff85d6318973 = v; });
var $920f91ef5706eaff$export$2c14ff85d6318973;
"use strict";
$920f91ef5706eaff$export$2c14ff85d6318973 = void 0;
const $920f91ef5706eaff$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: "{{count}} sekundy",
        other: "{{count}} sekund"
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: "{{count}} minuty",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: "godzina",
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: "{{count}} godziny",
        other: "{{count}} godzin"
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: "{{count}} dni",
        other: "{{count}} dni"
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: "{{count}} tygodnie",
        other: "{{count}} tygodni"
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: "rok",
        twoFour: "{{count}} lata",
        other: "{{count}} lat"
    },
    overXYears: {
        one: "ponad rok",
        twoFour: "ponad {{count}} lata",
        other: "ponad {{count}} lat"
    },
    almostXYears: {
        one: "prawie rok",
        twoFour: "prawie {{count}} lata",
        other: "prawie {{count}} lat"
    }
};
function $920f91ef5706eaff$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    const rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    const rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $920f91ef5706eaff$var$declension(scheme, count, time) {
    const group = $920f91ef5706eaff$var$declensionGroup(scheme, count);
    const finalText = typeof group === "string" ? group : group[time];
    return finalText.replace("{{count}}", String(count));
}
const $920f91ef5706eaff$var$formatDistance = (token, count, options)=>{
    const scheme = $920f91ef5706eaff$var$formatDistanceLocale[token];
    if (!options?.addSuffix) return $920f91ef5706eaff$var$declension(scheme, count, "regular");
    if (options.comparison && options.comparison > 0) return "za " + $920f91ef5706eaff$var$declension(scheme, count, "future");
    else return $920f91ef5706eaff$var$declension(scheme, count, "past") + " temu";
};
$920f91ef5706eaff$export$2c14ff85d6318973 = $920f91ef5706eaff$var$formatDistance;

});

parcelRegister("1l7oA", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $0f9d7d3c6bc1134f$export$cbf60ecb96cbb82f; }, function (v) { return $0f9d7d3c6bc1134f$export$cbf60ecb96cbb82f = v; });
var $0f9d7d3c6bc1134f$export$cbf60ecb96cbb82f;
"use strict";
$0f9d7d3c6bc1134f$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $0f9d7d3c6bc1134f$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $0f9d7d3c6bc1134f$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $0f9d7d3c6bc1134f$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $0f9d7d3c6bc1134f$var$formatLong = $0f9d7d3c6bc1134f$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $0f9d7d3c6bc1134f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $0f9d7d3c6bc1134f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $0f9d7d3c6bc1134f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("4Bsb3", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $35a07993192ac47c$export$8fbbfd65594f46a0; }, function (v) { return $35a07993192ac47c$export$8fbbfd65594f46a0 = v; });
var $35a07993192ac47c$export$8fbbfd65594f46a0;
"use strict";
$35a07993192ac47c$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");
const $35a07993192ac47c$var$adjectivesLastWeek = {
    masculine: "ostatni",
    feminine: "ostatnia"
};
const $35a07993192ac47c$var$adjectivesThisWeek = {
    masculine: "ten",
    feminine: "ta"
};
const $35a07993192ac47c$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
const $35a07993192ac47c$var$dayGrammaticalGender = {
    0: "feminine",
    1: "masculine",
    2: "masculine",
    3: "feminine",
    4: "masculine",
    5: "masculine",
    6: "feminine"
};
function $35a07993192ac47c$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    let adjectives;
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) adjectives = $35a07993192ac47c$var$adjectivesThisWeek;
    else if (token === "lastWeek") adjectives = $35a07993192ac47c$var$adjectivesLastWeek;
    else if (token === "nextWeek") adjectives = $35a07993192ac47c$var$adjectivesNextWeek;
    else throw new Error(`Cannot determine adjectives for token ${token}`);
    const day = date.getDay();
    const grammaticalGender = $35a07993192ac47c$var$dayGrammaticalGender[day];
    const adjective = adjectives[grammaticalGender];
    return `'${adjective}' eeee 'o' p`;
}
const $35a07993192ac47c$var$formatRelativeLocale = {
    lastWeek: $35a07993192ac47c$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $35a07993192ac47c$var$dayAndTimeWithAdjective,
    other: "P"
};
const $35a07993192ac47c$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $35a07993192ac47c$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(token, date, baseDate, options);
    return format;
};
$35a07993192ac47c$export$8fbbfd65594f46a0 = $35a07993192ac47c$var$formatRelative;

});

parcelRegister("15wJp", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0cafa5ded808d5f1$export$b3bd0bc58e36cd63; }, function (v) { return $0cafa5ded808d5f1$export$b3bd0bc58e36cd63 = v; });
var $0cafa5ded808d5f1$export$b3bd0bc58e36cd63;
"use strict";
$0cafa5ded808d5f1$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $0cafa5ded808d5f1$var$eraValues = {
    narrow: [
        "p.n.e.",
        "n.e."
    ],
    abbreviated: [
        "p.n.e.",
        "n.e."
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        "naszej ery"
    ]
};
const $0cafa5ded808d5f1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I kw.",
        "II kw.",
        "III kw.",
        "IV kw."
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
const $0cafa5ded808d5f1$var$monthValues = {
    narrow: [
        "S",
        "L",
        "M",
        "K",
        "M",
        "C",
        "L",
        "S",
        "W",
        "P",
        "L",
        "G"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycze\u0144",
        "luty",
        "marzec",
        "kwiecie\u0144",
        "maj",
        "czerwiec",
        "lipiec",
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        "listopad",
        "grudzie\u0144"
    ]
};
const $0cafa5ded808d5f1$var$monthFormattingValues = {
    narrow: [
        "s",
        "l",
        "m",
        "k",
        "m",
        "c",
        "l",
        "s",
        "w",
        "p",
        "l",
        "g"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        "listopada",
        "grudnia"
    ]
};
const $0cafa5ded808d5f1$var$dayValues = {
    narrow: [
        "N",
        "P",
        "W",
        "\u015A",
        "C",
        "P",
        "S"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $0cafa5ded808d5f1$var$dayFormattingValues = {
    narrow: [
        "n",
        "p",
        "w",
        "\u015B",
        "c",
        "p",
        "s"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $0cafa5ded808d5f1$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: "rano",
        afternoon: "popo\u0142.",
        evening: "wiecz.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    }
};
const $0cafa5ded808d5f1$var$dayPeriodFormattingValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: "rano",
        afternoon: "po po\u0142.",
        evening: "wiecz.",
        night: "w nocy"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    }
};
const $0cafa5ded808d5f1$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $0cafa5ded808d5f1$var$localize = $0cafa5ded808d5f1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0cafa5ded808d5f1$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $0cafa5ded808d5f1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $0cafa5ded808d5f1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $0cafa5ded808d5f1$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $0cafa5ded808d5f1$var$monthFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $0cafa5ded808d5f1$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $0cafa5ded808d5f1$var$dayFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $0cafa5ded808d5f1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0cafa5ded808d5f1$var$dayPeriodFormattingValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7WQlS", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5c968f324a7f5e5a$export$4659b591c19bdf3d; }, function (v) { return $5c968f324a7f5e5a$export$4659b591c19bdf3d = v; });
var $5c968f324a7f5e5a$export$4659b591c19bdf3d;
"use strict";
$5c968f324a7f5e5a$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $5c968f324a7f5e5a$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $5c968f324a7f5e5a$var$parseOrdinalNumberPattern = /\d+/i;
const $5c968f324a7f5e5a$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
const $5c968f324a7f5e5a$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
const $5c968f324a7f5e5a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
const $5c968f324a7f5e5a$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
const $5c968f324a7f5e5a$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
const $5c968f324a7f5e5a$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
const $5c968f324a7f5e5a$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
const $5c968f324a7f5e5a$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
const $5c968f324a7f5e5a$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
const $5c968f324a7f5e5a$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
const $5c968f324a7f5e5a$var$match = $5c968f324a7f5e5a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $5c968f324a7f5e5a$var$matchOrdinalNumberPattern,
        parsePattern: $5c968f324a7f5e5a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5c968f324a7f5e5a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5c968f324a7f5e5a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5c968f324a7f5e5a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5c968f324a7f5e5a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5c968f324a7f5e5a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5c968f324a7f5e5a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5c968f324a7f5e5a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5c968f324a7f5e5a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5c968f324a7f5e5a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5c968f324a7f5e5a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("5hZna", function(module, exports) {

$parcel$export(module.exports, "pt", function () { return $3d9e259d54ab50c1$export$84175d5f1cb4e39d; }, function (v) { return $3d9e259d54ab50c1$export$84175d5f1cb4e39d = v; });
var $3d9e259d54ab50c1$export$84175d5f1cb4e39d;
"use strict";
$3d9e259d54ab50c1$export$84175d5f1cb4e39d = void 0;

var $iUrWy = parcelRequire("iUrWy");

var $ly0UX = parcelRequire("ly0UX");

var $9c6yH = parcelRequire("9c6yH");

var $kML7R = parcelRequire("kML7R");

var $js8Dd = parcelRequire("js8Dd");
/**
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire](https://github.com/dfreire)
 * @author Adrián de la Rosa [@adrm](https://github.com/adrm)
 */ const $3d9e259d54ab50c1$var$pt = $3d9e259d54ab50c1$export$84175d5f1cb4e39d = {
    code: "pt",
    formatDistance: $iUrWy.formatDistance,
    formatLong: $ly0UX.formatLong,
    formatRelative: $9c6yH.formatRelative,
    localize: $kML7R.localize,
    match: $js8Dd.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("iUrWy", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $dc4321f07e44e23e$export$2c14ff85d6318973; }, function (v) { return $dc4321f07e44e23e$export$2c14ff85d6318973 = v; });
var $dc4321f07e44e23e$export$2c14ff85d6318973;
"use strict";
$dc4321f07e44e23e$export$2c14ff85d6318973 = void 0;
const $dc4321f07e44e23e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: "aproximadamente {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $dc4321f07e44e23e$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $dc4321f07e44e23e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "daqui a " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
$dc4321f07e44e23e$export$2c14ff85d6318973 = $dc4321f07e44e23e$var$formatDistance;

});

parcelRegister("ly0UX", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $fafd7c332091eb76$export$cbf60ecb96cbb82f; }, function (v) { return $fafd7c332091eb76$export$cbf60ecb96cbb82f = v; });
var $fafd7c332091eb76$export$cbf60ecb96cbb82f;
"use strict";
$fafd7c332091eb76$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $fafd7c332091eb76$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
};
const $fafd7c332091eb76$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $fafd7c332091eb76$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $fafd7c332091eb76$var$formatLong = $fafd7c332091eb76$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $fafd7c332091eb76$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $fafd7c332091eb76$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $fafd7c332091eb76$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9c6yH", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6b1a527602805d31$export$8fbbfd65594f46a0; }, function (v) { return $6b1a527602805d31$export$8fbbfd65594f46a0 = v; });
var $6b1a527602805d31$export$8fbbfd65594f46a0;
"use strict";
$6b1a527602805d31$export$8fbbfd65594f46a0 = void 0;
const $6b1a527602805d31$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $6b1a527602805d31$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $6b1a527602805d31$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$6b1a527602805d31$export$8fbbfd65594f46a0 = $6b1a527602805d31$var$formatRelative;

});

parcelRegister("kML7R", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $f21cd88abdef3bcf$export$b3bd0bc58e36cd63; }, function (v) { return $f21cd88abdef3bcf$export$b3bd0bc58e36cd63 = v; });
var $f21cd88abdef3bcf$export$b3bd0bc58e36cd63;
"use strict";
$f21cd88abdef3bcf$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $f21cd88abdef3bcf$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "antes de Cristo",
        "depois de Cristo"
    ]
};
const $f21cd88abdef3bcf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $f21cd88abdef3bcf$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $f21cd88abdef3bcf$var$dayValues = {
    narrow: [
        "d",
        "s",
        "t",
        "q",
        "q",
        "s",
        "s"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    abbreviated: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $f21cd88abdef3bcf$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    }
};
const $f21cd88abdef3bcf$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    }
};
const $f21cd88abdef3bcf$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $f21cd88abdef3bcf$var$localize = $f21cd88abdef3bcf$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f21cd88abdef3bcf$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $f21cd88abdef3bcf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $f21cd88abdef3bcf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $f21cd88abdef3bcf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $f21cd88abdef3bcf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $f21cd88abdef3bcf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f21cd88abdef3bcf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("js8Dd", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e29753e27e8f01a7$export$4659b591c19bdf3d; }, function (v) { return $e29753e27e8f01a7$export$4659b591c19bdf3d = v; });
var $e29753e27e8f01a7$export$4659b591c19bdf3d;
"use strict";
$e29753e27e8f01a7$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $e29753e27e8f01a7$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
const $e29753e27e8f01a7$var$parseOrdinalNumberPattern = /\d+/i;
const $e29753e27e8f01a7$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
const $e29753e27e8f01a7$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
const $e29753e27e8f01a7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
const $e29753e27e8f01a7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e29753e27e8f01a7$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $e29753e27e8f01a7$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $e29753e27e8f01a7$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
const $e29753e27e8f01a7$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
const $e29753e27e8f01a7$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
const $e29753e27e8f01a7$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
const $e29753e27e8f01a7$var$match = $e29753e27e8f01a7$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $e29753e27e8f01a7$var$matchOrdinalNumberPattern,
        parsePattern: $e29753e27e8f01a7$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e29753e27e8f01a7$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e29753e27e8f01a7$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e29753e27e8f01a7$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e29753e27e8f01a7$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e29753e27e8f01a7$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e29753e27e8f01a7$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e29753e27e8f01a7$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e29753e27e8f01a7$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e29753e27e8f01a7$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e29753e27e8f01a7$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("gr2w7", function(module, exports) {

$parcel$export(module.exports, "ptBR", function () { return $bf711ecd9481797e$export$93dd81123f5ddbcd; }, function (v) { return $bf711ecd9481797e$export$93dd81123f5ddbcd = v; });
var $bf711ecd9481797e$export$93dd81123f5ddbcd;
"use strict";
$bf711ecd9481797e$export$93dd81123f5ddbcd = void 0;

var $czlm9 = parcelRequire("czlm9");

var $kzbv3 = parcelRequire("kzbv3");

var $4bxqA = parcelRequire("4bxqA");

var $lrrbj = parcelRequire("lrrbj");

var $dETDu = parcelRequire("dETDu");
/**
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe](https://github.com/duailibe)
 * @author Yago Carballo [@yagocarballo](https://github.com/YagoCarballo)
 */ const $bf711ecd9481797e$var$ptBR = $bf711ecd9481797e$export$93dd81123f5ddbcd = {
    code: "pt-BR",
    formatDistance: $czlm9.formatDistance,
    formatLong: $kzbv3.formatLong,
    formatRelative: $4bxqA.formatRelative,
    localize: $lrrbj.localize,
    match: $dETDu.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("czlm9", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $926951ce514b7f5e$export$2c14ff85d6318973; }, function (v) { return $926951ce514b7f5e$export$2c14ff85d6318973 = v; });
var $926951ce514b7f5e$export$2c14ff85d6318973;
"use strict";
$926951ce514b7f5e$export$2c14ff85d6318973 = void 0;
const $926951ce514b7f5e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "cerca de 1 hora",
        other: "cerca de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "cerca de 1 semana",
        other: "cerca de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: "cerca de {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "cerca de 1 ano",
        other: "cerca de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $926951ce514b7f5e$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $926951ce514b7f5e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "em " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
$926951ce514b7f5e$export$2c14ff85d6318973 = $926951ce514b7f5e$var$formatDistance;

});

parcelRegister("kzbv3", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ef8fff303d22fdec$export$cbf60ecb96cbb82f; }, function (v) { return $ef8fff303d22fdec$export$cbf60ecb96cbb82f = v; });
var $ef8fff303d22fdec$export$cbf60ecb96cbb82f;
"use strict";
$ef8fff303d22fdec$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $ef8fff303d22fdec$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $ef8fff303d22fdec$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $ef8fff303d22fdec$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $ef8fff303d22fdec$var$formatLong = $ef8fff303d22fdec$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $ef8fff303d22fdec$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $ef8fff303d22fdec$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $ef8fff303d22fdec$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("4bxqA", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $30c21e8dd0b36249$export$8fbbfd65594f46a0; }, function (v) { return $30c21e8dd0b36249$export$8fbbfd65594f46a0 = v; });
var $30c21e8dd0b36249$export$8fbbfd65594f46a0;
"use strict";
$30c21e8dd0b36249$export$8fbbfd65594f46a0 = void 0;
const $30c21e8dd0b36249$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $30c21e8dd0b36249$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $30c21e8dd0b36249$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$30c21e8dd0b36249$export$8fbbfd65594f46a0 = $30c21e8dd0b36249$var$formatRelative;

});

parcelRegister("lrrbj", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $f9c1343d804e6ce2$export$b3bd0bc58e36cd63; }, function (v) { return $f9c1343d804e6ce2$export$b3bd0bc58e36cd63 = v; });
var $f9c1343d804e6ce2$export$b3bd0bc58e36cd63;
"use strict";
$f9c1343d804e6ce2$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $f9c1343d804e6ce2$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "depois de cristo"
    ]
};
const $f9c1343d804e6ce2$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $f9c1343d804e6ce2$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $f9c1343d804e6ce2$var$dayValues = {
    narrow: [
        "D",
        "S",
        "T",
        "Q",
        "Q",
        "S",
        "S"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sab"
    ],
    abbreviated: [
        "domingo",
        "segunda",
        "ter\xe7a",
        "quarta",
        "quinta",
        "sexta",
        "s\xe1bado"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $f9c1343d804e6ce2$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    }
};
const $f9c1343d804e6ce2$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    }
};
const $f9c1343d804e6ce2$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    if (options?.unit === "week") return number + "\xaa";
    return number + "\xba";
};
const $f9c1343d804e6ce2$var$localize = $f9c1343d804e6ce2$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f9c1343d804e6ce2$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $f9c1343d804e6ce2$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $f9c1343d804e6ce2$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $f9c1343d804e6ce2$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $f9c1343d804e6ce2$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $f9c1343d804e6ce2$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f9c1343d804e6ce2$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("dETDu", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $9f1a2aeb46fb2486$export$4659b591c19bdf3d; }, function (v) { return $9f1a2aeb46fb2486$export$4659b591c19bdf3d = v; });
var $9f1a2aeb46fb2486$export$4659b591c19bdf3d;
"use strict";
$9f1a2aeb46fb2486$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $9f1a2aeb46fb2486$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
const $9f1a2aeb46fb2486$var$parseOrdinalNumberPattern = /\d+/i;
const $9f1a2aeb46fb2486$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
const $9f1a2aeb46fb2486$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
const $9f1a2aeb46fb2486$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $9f1a2aeb46fb2486$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $9f1a2aeb46fb2486$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $9f1a2aeb46fb2486$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
const $9f1a2aeb46fb2486$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
const $9f1a2aeb46fb2486$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
const $9f1a2aeb46fb2486$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
const $9f1a2aeb46fb2486$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
const $9f1a2aeb46fb2486$var$match = $9f1a2aeb46fb2486$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $9f1a2aeb46fb2486$var$matchOrdinalNumberPattern,
        parsePattern: $9f1a2aeb46fb2486$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9f1a2aeb46fb2486$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9f1a2aeb46fb2486$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9f1a2aeb46fb2486$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9f1a2aeb46fb2486$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9f1a2aeb46fb2486$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9f1a2aeb46fb2486$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9f1a2aeb46fb2486$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9f1a2aeb46fb2486$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $9f1a2aeb46fb2486$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9f1a2aeb46fb2486$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jeXbz", function(module, exports) {

$parcel$export(module.exports, "ro", function () { return $e01d3c276419f07a$export$ea30ec7f37fb148d; }, function (v) { return $e01d3c276419f07a$export$ea30ec7f37fb148d = v; });
var $e01d3c276419f07a$export$ea30ec7f37fb148d;
"use strict";
$e01d3c276419f07a$export$ea30ec7f37fb148d = void 0;

var $eorL4 = parcelRequire("eorL4");

var $besHA = parcelRequire("besHA");

var $kwWz4 = parcelRequire("kwWz4");

var $8iVyj = parcelRequire("8iVyj");

var $5Ywim = parcelRequire("5Ywim");
/**
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu](https://github.com/jsergiu)
 * @author Adrian Ocneanu [@aocneanu](https://github.com/aocneanu)
 * @author Mihai Ocneanu [@gandesc](https://github.com/gandesc)
 */ const $e01d3c276419f07a$var$ro = $e01d3c276419f07a$export$ea30ec7f37fb148d = {
    code: "ro",
    formatDistance: $eorL4.formatDistance,
    formatLong: $besHA.formatLong,
    formatRelative: $kwWz4.formatRelative,
    localize: $8iVyj.localize,
    match: $5Ywim.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("eorL4", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $a7a8d6c375a0322a$export$2c14ff85d6318973; }, function (v) { return $a7a8d6c375a0322a$export$2c14ff85d6318973 = v; });
var $a7a8d6c375a0322a$export$2c14ff85d6318973;
"use strict";
$a7a8d6c375a0322a$export$2c14ff85d6318973 = void 0;
const $a7a8d6c375a0322a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: "{{count}} secunde"
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "1 or\u0103",
        other: "{{count}} ore"
    },
    xDays: {
        one: "1 zi",
        other: "{{count}} zile"
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: "circa {{count}} luni"
    },
    xMonths: {
        one: "1 lun\u0103",
        other: "{{count}} luni"
    },
    aboutXYears: {
        one: "circa 1 an",
        other: "circa {{count}} ani"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ani"
    },
    overXYears: {
        one: "peste 1 an",
        other: "peste {{count}} ani"
    },
    almostXYears: {
        one: "aproape 1 an",
        other: "aproape {{count}} ani"
    }
};
const $a7a8d6c375a0322a$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $a7a8d6c375a0322a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
$a7a8d6c375a0322a$export$2c14ff85d6318973 = $a7a8d6c375a0322a$var$formatDistance;

});

parcelRegister("besHA", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $82d744273cc785a8$export$cbf60ecb96cbb82f; }, function (v) { return $82d744273cc785a8$export$cbf60ecb96cbb82f = v; });
var $82d744273cc785a8$export$cbf60ecb96cbb82f;
"use strict";
$82d744273cc785a8$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $82d744273cc785a8$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd.MM.yyyy"
};
const $82d744273cc785a8$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $82d744273cc785a8$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $82d744273cc785a8$var$formatLong = $82d744273cc785a8$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $82d744273cc785a8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $82d744273cc785a8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $82d744273cc785a8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("kwWz4", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ef24398a05daf38a$export$8fbbfd65594f46a0; }, function (v) { return $ef24398a05daf38a$export$8fbbfd65594f46a0 = v; });
var $ef24398a05daf38a$export$8fbbfd65594f46a0;
"use strict";
$ef24398a05daf38a$export$8fbbfd65594f46a0 = void 0;
const $ef24398a05daf38a$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: "P"
};
const $ef24398a05daf38a$var$formatRelative = (token, _date, _baseDate, _options)=>$ef24398a05daf38a$var$formatRelativeLocale[token];
$ef24398a05daf38a$export$8fbbfd65594f46a0 = $ef24398a05daf38a$var$formatRelative;

});

parcelRegister("8iVyj", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $60bca5e7c0dbf6ec$export$b3bd0bc58e36cd63; }, function (v) { return $60bca5e7c0dbf6ec$export$b3bd0bc58e36cd63 = v; });
var $60bca5e7c0dbf6ec$export$b3bd0bc58e36cd63;
"use strict";
$60bca5e7c0dbf6ec$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $60bca5e7c0dbf6ec$var$eraValues = {
    narrow: [
        "\xce",
        "D"
    ],
    abbreviated: [
        "\xce.d.C.",
        "D.C."
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
const $60bca5e7c0dbf6ec$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "primul trimestru",
        "al doilea trimestru",
        "al treilea trimestru",
        "al patrulea trimestru"
    ]
};
const $60bca5e7c0dbf6ec$var$monthValues = {
    narrow: [
        "I",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "noi",
        "dec"
    ],
    wide: [
        "ianuarie",
        "februarie",
        "martie",
        "aprilie",
        "mai",
        "iunie",
        "iulie",
        "august",
        "septembrie",
        "octombrie",
        "noiembrie",
        "decembrie"
    ]
};
const $60bca5e7c0dbf6ec$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "du",
        "lu",
        "ma",
        "mi",
        "jo",
        "vi",
        "s\xe2"
    ],
    abbreviated: [
        "dum",
        "lun",
        "mar",
        "mie",
        "joi",
        "vin",
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        "luni",
        "mar\u021Bi",
        "miercuri",
        "joi",
        "vineri",
        "s\xe2mb\u0103t\u0103"
    ]
};
const $60bca5e7c0dbf6ec$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "ami",
        morning: "dim",
        afternoon: "da",
        evening: "s",
        night: "n"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
const $60bca5e7c0dbf6ec$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
const $60bca5e7c0dbf6ec$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $60bca5e7c0dbf6ec$var$localize = $60bca5e7c0dbf6ec$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $60bca5e7c0dbf6ec$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $60bca5e7c0dbf6ec$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $60bca5e7c0dbf6ec$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $60bca5e7c0dbf6ec$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $60bca5e7c0dbf6ec$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $60bca5e7c0dbf6ec$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $60bca5e7c0dbf6ec$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("5Ywim", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $459b9b803e36df70$export$4659b591c19bdf3d; }, function (v) { return $459b9b803e36df70$export$4659b591c19bdf3d = v; });
var $459b9b803e36df70$export$4659b591c19bdf3d;
"use strict";
$459b9b803e36df70$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $459b9b803e36df70$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $459b9b803e36df70$var$parseOrdinalNumberPattern = /\d+/i;
const $459b9b803e36df70$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
const $459b9b803e36df70$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
const $459b9b803e36df70$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
const $459b9b803e36df70$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $459b9b803e36df70$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
const $459b9b803e36df70$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $459b9b803e36df70$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
const $459b9b803e36df70$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
const $459b9b803e36df70$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
const $459b9b803e36df70$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
const $459b9b803e36df70$var$match = $459b9b803e36df70$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $459b9b803e36df70$var$matchOrdinalNumberPattern,
        parsePattern: $459b9b803e36df70$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $459b9b803e36df70$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $459b9b803e36df70$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $459b9b803e36df70$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $459b9b803e36df70$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $459b9b803e36df70$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $459b9b803e36df70$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $459b9b803e36df70$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $459b9b803e36df70$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $459b9b803e36df70$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $459b9b803e36df70$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("kdY07", function(module, exports) {

$parcel$export(module.exports, "ru", function () { return $eb939076ea86bb20$export$cf48009033a0126b; }, function (v) { return $eb939076ea86bb20$export$cf48009033a0126b = v; });
var $eb939076ea86bb20$export$cf48009033a0126b;
"use strict";
$eb939076ea86bb20$export$cf48009033a0126b = void 0;

var $4kIqe = parcelRequire("4kIqe");

var $lzAra = parcelRequire("lzAra");

var $dIYQL = parcelRequire("dIYQL");

var $8rpLw = parcelRequire("8rpLw");

var $g9mV9 = parcelRequire("g9mV9");
/**
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $eb939076ea86bb20$var$ru = $eb939076ea86bb20$export$cf48009033a0126b = {
    code: "ru",
    formatDistance: $4kIqe.formatDistance,
    formatLong: $lzAra.formatLong,
    formatRelative: $dIYQL.formatRelative,
    localize: $8rpLw.localize,
    match: $g9mV9.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("4kIqe", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $327b7cf6b1d96af5$export$2c14ff85d6318973; }, function (v) { return $327b7cf6b1d96af5$export$2c14ff85d6318973 = v; });
var $327b7cf6b1d96af5$export$2c14ff85d6318973;
"use strict";
$327b7cf6b1d96af5$export$2c14ff85d6318973 = void 0;
function $327b7cf6b1d96af5$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $327b7cf6b1d96af5$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $327b7cf6b1d96af5$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $327b7cf6b1d96af5$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $327b7cf6b1d96af5$var$declension(scheme.past, count);
                else return $327b7cf6b1d96af5$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $327b7cf6b1d96af5$var$declension(scheme.regular, count);
    };
}
const $327b7cf6b1d96af5$var$formatDistanceLocale = {
    lessThanXSeconds: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: (_count, options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $327b7cf6b1d96af5$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
const $327b7cf6b1d96af5$var$formatDistance = (token, count, options)=>{
    return $327b7cf6b1d96af5$var$formatDistanceLocale[token](count, options);
};
$327b7cf6b1d96af5$export$2c14ff85d6318973 = $327b7cf6b1d96af5$var$formatDistance;

});

parcelRegister("lzAra", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $fb49218ab5c220b3$export$cbf60ecb96cbb82f; }, function (v) { return $fb49218ab5c220b3$export$cbf60ecb96cbb82f = v; });
var $fb49218ab5c220b3$export$cbf60ecb96cbb82f;
"use strict";
$fb49218ab5c220b3$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $fb49218ab5c220b3$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $fb49218ab5c220b3$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $fb49218ab5c220b3$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $fb49218ab5c220b3$var$formatLong = $fb49218ab5c220b3$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $fb49218ab5c220b3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $fb49218ab5c220b3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $fb49218ab5c220b3$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("dIYQL", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9fde95fcf9c9b478$export$8fbbfd65594f46a0; }, function (v) { return $9fde95fcf9c9b478$export$8fbbfd65594f46a0 = v; });
var $9fde95fcf9c9b478$export$8fbbfd65594f46a0;
"use strict";
$9fde95fcf9c9b478$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");
const $9fde95fcf9c9b478$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $9fde95fcf9c9b478$var$lastWeek(day) {
    const weekday = $9fde95fcf9c9b478$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $9fde95fcf9c9b478$var$thisWeek(day) {
    const weekday = $9fde95fcf9c9b478$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $9fde95fcf9c9b478$var$nextWeek(day) {
    const weekday = $9fde95fcf9c9b478$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
const $9fde95fcf9c9b478$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $9fde95fcf9c9b478$var$thisWeek(day);
        else return $9fde95fcf9c9b478$var$lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $9fde95fcf9c9b478$var$thisWeek(day);
        else return $9fde95fcf9c9b478$var$nextWeek(day);
    },
    other: "P"
};
const $9fde95fcf9c9b478$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $9fde95fcf9c9b478$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$9fde95fcf9c9b478$export$8fbbfd65594f46a0 = $9fde95fcf9c9b478$var$formatRelative;

});

parcelRegister("8rpLw", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6254d4d88aa92375$export$b3bd0bc58e36cd63; }, function (v) { return $6254d4d88aa92375$export$b3bd0bc58e36cd63 = v; });
var $6254d4d88aa92375$export$b3bd0bc58e36cd63;
"use strict";
$6254d4d88aa92375$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $6254d4d88aa92375$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
const $6254d4d88aa92375$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $6254d4d88aa92375$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
const $6254d4d88aa92375$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
const $6254d4d88aa92375$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
const $6254d4d88aa92375$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
const $6254d4d88aa92375$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
const $6254d4d88aa92375$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let suffix;
    if (unit === "date") suffix = "-\u0435";
    else if (unit === "week" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
const $6254d4d88aa92375$var$localize = $6254d4d88aa92375$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6254d4d88aa92375$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $6254d4d88aa92375$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $6254d4d88aa92375$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $6254d4d88aa92375$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $6254d4d88aa92375$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $6254d4d88aa92375$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $6254d4d88aa92375$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $6254d4d88aa92375$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("g9mV9", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $bc1f443443ab5875$export$4659b591c19bdf3d; }, function (v) { return $bc1f443443ab5875$export$4659b591c19bdf3d = v; });
var $bc1f443443ab5875$export$4659b591c19bdf3d;
"use strict";
$bc1f443443ab5875$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $bc1f443443ab5875$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
const $bc1f443443ab5875$var$parseOrdinalNumberPattern = /\d+/i;
const $bc1f443443ab5875$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
const $bc1f443443ab5875$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $bc1f443443ab5875$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
const $bc1f443443ab5875$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $bc1f443443ab5875$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
const $bc1f443443ab5875$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $bc1f443443ab5875$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
const $bc1f443443ab5875$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $bc1f443443ab5875$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
const $bc1f443443ab5875$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $bc1f443443ab5875$var$match = $bc1f443443ab5875$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $bc1f443443ab5875$var$matchOrdinalNumberPattern,
        parsePattern: $bc1f443443ab5875$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bc1f443443ab5875$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bc1f443443ab5875$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bc1f443443ab5875$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bc1f443443ab5875$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bc1f443443ab5875$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bc1f443443ab5875$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bc1f443443ab5875$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bc1f443443ab5875$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bc1f443443ab5875$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bc1f443443ab5875$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("k5Ibj", function(module, exports) {

$parcel$export(module.exports, "se", function () { return $ea068bc4ef86c2cd$export$6362df887b441e93; }, function (v) { return $ea068bc4ef86c2cd$export$6362df887b441e93 = v; });
var $ea068bc4ef86c2cd$export$6362df887b441e93;
"use strict";
$ea068bc4ef86c2cd$export$6362df887b441e93 = void 0;

var $QGZz3 = parcelRequire("QGZz3");

var $cs0yP = parcelRequire("cs0yP");

var $3ygxK = parcelRequire("3ygxK");

var $cuZjT = parcelRequire("cuZjT");

var $foRa0 = parcelRequire("foRa0");
/**
 * @category Locales
 * @summary Northern Sámi locale.
 * @language Northern Sámi
 * @iso-639-2 sme
 * @author Audun Rundberg [@audunru](https://github.com/audunru)
 */ const $ea068bc4ef86c2cd$var$se = $ea068bc4ef86c2cd$export$6362df887b441e93 = {
    code: "se",
    formatDistance: $QGZz3.formatDistance,
    formatLong: $cs0yP.formatLong,
    formatRelative: $3ygxK.formatRelative,
    localize: $cuZjT.localize,
    match: $foRa0.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("QGZz3", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $09e634c104ba0002$export$2c14ff85d6318973; }, function (v) { return $09e634c104ba0002$export$2c14ff85d6318973 = v; });
var $09e634c104ba0002$export$2c14ff85d6318973;
"use strict";
$09e634c104ba0002$export$2c14ff85d6318973 = void 0;
const $09e634c104ba0002$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "unnit go ovtta sekundda",
        other: "unnit go {{count}} sekundda"
    },
    xSeconds: {
        one: "sekundda",
        other: "{{count}} sekundda"
    },
    halfAMinute: "bealle minuhta",
    lessThanXMinutes: {
        one: "unnit go bealle minuhta",
        other: "unnit go {{count}} minuhta"
    },
    xMinutes: {
        one: "minuhta",
        other: "{{count}} minuhta"
    },
    aboutXHours: {
        one: "sullii ovtta diimmu",
        other: "sullii {{count}} diimmu"
    },
    xHours: {
        one: "diimmu",
        other: "{{count}} diimmu"
    },
    xDays: {
        one: "beaivvi",
        other: "{{count}} beaivvi"
    },
    aboutXWeeks: {
        one: "sullii ovtta vahku",
        other: "sullii {{count}} vahku"
    },
    xWeeks: {
        one: "vahku",
        other: "{{count}} vahku"
    },
    aboutXMonths: {
        one: "sullii ovtta m\xe1nu",
        other: "sullii {{count}} m\xe1nu"
    },
    xMonths: {
        one: "m\xe1nu",
        other: "{{count}} m\xe1nu"
    },
    aboutXYears: {
        one: "sullii ovtta jagi",
        other: "sullii {{count}} jagi"
    },
    xYears: {
        one: "jagi",
        other: "{{count}} jagi"
    },
    overXYears: {
        one: "guhkit go jagi",
        other: "guhkit go {{count}} jagi"
    },
    almostXYears: {
        one: "measta jagi",
        other: "measta {{count}} jagi"
    }
};
const $09e634c104ba0002$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $09e634c104ba0002$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "geah\u010Den " + result;
        else return result + " \xe1igi";
    }
    return result;
};
$09e634c104ba0002$export$2c14ff85d6318973 = $09e634c104ba0002$var$formatDistance;

});

parcelRegister("cs0yP", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $910888eef3299f07$export$cbf60ecb96cbb82f; }, function (v) { return $910888eef3299f07$export$cbf60ecb96cbb82f = v; });
var $910888eef3299f07$export$cbf60ecb96cbb82f;
"use strict";
$910888eef3299f07$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $910888eef3299f07$var$dateFormats = {
    full: "EEEE MMMM d. 'b.' y",
    long: "MMMM d. 'b.' y",
    medium: "MMM d. 'b.' y",
    short: "dd.MM.y"
};
const $910888eef3299f07$var$timeFormats = {
    full: "'dii.' HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $910888eef3299f07$var$dateTimeFormats = {
    full: "{{date}} 'dii.' {{time}}",
    long: "{{date}} 'dii.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $910888eef3299f07$var$formatLong = $910888eef3299f07$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $910888eef3299f07$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $910888eef3299f07$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $910888eef3299f07$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("3ygxK", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $29616136dc1beb75$export$8fbbfd65594f46a0; }, function (v) { return $29616136dc1beb75$export$8fbbfd65594f46a0 = v; });
var $29616136dc1beb75$export$8fbbfd65594f46a0;
"use strict";
$29616136dc1beb75$export$8fbbfd65594f46a0 = void 0;
const $29616136dc1beb75$var$formatRelativeLocale = {
    lastWeek: "'ovddit' eeee 'dii.' p",
    yesterday: "'ikte dii.' p",
    today: "'odne dii.' p",
    tomorrow: "'ihtin dii.' p",
    nextWeek: "EEEE 'dii.' p",
    other: "P"
};
const $29616136dc1beb75$var$formatRelative = (token, _date, _baseDate, _options)=>$29616136dc1beb75$var$formatRelativeLocale[token];
$29616136dc1beb75$export$8fbbfd65594f46a0 = $29616136dc1beb75$var$formatRelative;

});

parcelRegister("cuZjT", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $025928ae47cf23b7$export$b3bd0bc58e36cd63; }, function (v) { return $025928ae47cf23b7$export$b3bd0bc58e36cd63 = v; });
var $025928ae47cf23b7$export$b3bd0bc58e36cd63;
"use strict";
$025928ae47cf23b7$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $025928ae47cf23b7$var$eraValues = {
    narrow: [
        "o.Kr.",
        "m.Kr."
    ],
    abbreviated: [
        "o.Kr.",
        "m.Kr."
    ],
    wide: [
        "ovdal Kristusa",
        "ma\u014B\u014Bel Kristusa"
    ]
};
const $025928ae47cf23b7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvart\xe1la",
        "2. kvart\xe1la",
        "3. kvart\xe1la",
        "4. kvart\xe1la"
    ]
};
const $025928ae47cf23b7$var$monthValues = {
    narrow: [
        "O",
        "G",
        "N",
        "C",
        "M",
        "G",
        "S",
        "B",
        "\u010C",
        "G",
        "S",
        "J"
    ],
    abbreviated: [
        "o\u0111\u0111a",
        "guov",
        "njuk",
        "cuo",
        "mies",
        "geas",
        "suoi",
        "borg",
        "\u010Dak\u010D",
        "golg",
        "sk\xe1b",
        "juov"
    ],
    wide: [
        "o\u0111\u0111ajagem\xe1nnu",
        "guovvam\xe1nnu",
        "njuk\u010Dam\xe1nnu",
        "cuo\u014Bom\xe1nnu",
        "miessem\xe1nnu",
        "geassem\xe1nnu",
        "suoidnem\xe1nnu",
        "borgem\xe1nnu",
        "\u010Dak\u010Dam\xe1nnu",
        "golggotm\xe1nnu",
        "sk\xe1bmam\xe1nnu",
        "juovlam\xe1nnu"
    ]
};
const $025928ae47cf23b7$var$dayValues = {
    narrow: [
        "S",
        "V",
        "M",
        "G",
        "D",
        "B",
        "L"
    ],
    short: [
        "sotn",
        "vuos",
        "ma\u014B",
        "gask",
        "duor",
        "bear",
        "l\xe1v"
    ],
    abbreviated: [
        "sotn",
        "vuos",
        "ma\u014B",
        "gask",
        "duor",
        "bear",
        "l\xe1v"
    ],
    wide: [
        "sotnabeaivi",
        "vuoss\xe1rga",
        "ma\u014B\u014Beb\xe1rga",
        "gaskavahkku",
        "duorastat",
        "bearjadat",
        "l\xe1vvardat"
    ]
};
const $025928ae47cf23b7$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "gaskaidja",
        noon: "gaskabeaivi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaska.",
        evening: "eahkes",
        night: "ihkku"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gaskaidja",
        noon: "gaskabeaivvi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaskabea.",
        evening: "eahkes",
        night: "ihkku"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gaskaidja",
        noon: "gaskabeavvi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaskabeaivvi",
        evening: "eahkes",
        night: "ihkku"
    }
};
const $025928ae47cf23b7$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $025928ae47cf23b7$var$localize = $025928ae47cf23b7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $025928ae47cf23b7$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $025928ae47cf23b7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $025928ae47cf23b7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $025928ae47cf23b7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $025928ae47cf23b7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $025928ae47cf23b7$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("foRa0", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $b36255758f2f2d4e$export$4659b591c19bdf3d; }, function (v) { return $b36255758f2f2d4e$export$4659b591c19bdf3d = v; });
var $b36255758f2f2d4e$export$4659b591c19bdf3d;
"use strict";
$b36255758f2f2d4e$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $b36255758f2f2d4e$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $b36255758f2f2d4e$var$parseOrdinalNumberPattern = /\d+/i;
const $b36255758f2f2d4e$var$matchEraPatterns = {
    narrow: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
    abbreviated: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
    wide: /^(ovdal Kristusa|ovdal min áiggi|maŋŋel Kristusa|min áigi)/i
};
const $b36255758f2f2d4e$var$parseEraPatterns = {
    any: [
        /^o/i,
        /^m/i
    ]
};
const $b36255758f2f2d4e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartála/i
};
const $b36255758f2f2d4e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $b36255758f2f2d4e$var$matchMonthPatterns = {
    narrow: /^[ogncmsbčj]/i,
    abbreviated: /^(ođđa|guov|njuk|cuo|mies|geas|suoi|borg|čakč|golg|skáb|juov)\.?/i,
    wide: /^(ođđajagemánnu|guovvamánnu|njukčamánnu|cuoŋománnu|miessemánnu|geassemánnu|suoidnemánnu|borgemánnu|čakčamánnu|golggotmánnu|skábmamánnu|juovlamánnu)/i
};
const $b36255758f2f2d4e$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^g/i,
        /^n/i,
        /^c/i,
        /^m/i,
        /^g/i,
        /^s/i,
        /^b/i,
        /^č/i,
        /^g/i,
        /^s/i,
        /^j/i
    ],
    any: [
        /^o/i,
        /^gu/i,
        /^n/i,
        /^c/i,
        /^m/i,
        /^ge/i,
        /^su/i,
        /^b/i,
        /^č/i,
        /^go/i,
        /^sk/i,
        /^j/i
    ]
};
const $b36255758f2f2d4e$var$matchDayPatterns = {
    narrow: /^[svmgdbl]/i,
    short: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
    abbreviated: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
    wide: /^(sotnabeaivi|vuossárga|maŋŋebárga|gaskavahkku|duorastat|bearjadat|lávvardat)/i
};
const $b36255758f2f2d4e$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^v/i,
        /^m/i,
        /^g/i,
        /^d/i,
        /^b/i,
        /^l/i
    ]
};
const $b36255758f2f2d4e$var$matchDayPeriodPatterns = {
    narrow: /^(gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku))/i
};
const $b36255758f2f2d4e$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^gaskai/i,
        noon: /^gaskab/i,
        morning: /iđđes/i,
        afternoon: /maŋŋel gaskabeaivvi/i,
        evening: /eahkes/i,
        night: /ihkku/i
    }
};
const $b36255758f2f2d4e$var$match = $b36255758f2f2d4e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $b36255758f2f2d4e$var$matchOrdinalNumberPattern,
        parsePattern: $b36255758f2f2d4e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b36255758f2f2d4e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b36255758f2f2d4e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b36255758f2f2d4e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b36255758f2f2d4e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b36255758f2f2d4e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b36255758f2f2d4e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b36255758f2f2d4e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b36255758f2f2d4e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $b36255758f2f2d4e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b36255758f2f2d4e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("5Afma", function(module, exports) {

$parcel$export(module.exports, "sk", function () { return $410c3a07deabec17$export$d608fa5b5bfd2021; }, function (v) { return $410c3a07deabec17$export$d608fa5b5bfd2021 = v; });
var $410c3a07deabec17$export$d608fa5b5bfd2021;
"use strict";
$410c3a07deabec17$export$d608fa5b5bfd2021 = void 0;

var $fS7jy = parcelRequire("fS7jy");

var $k8MRY = parcelRequire("k8MRY");

var $I5sZl = parcelRequire("I5sZl");

var $8halm = parcelRequire("8halm");

var $eEMqn = parcelRequire("eEMqn");
/**
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak](https://github.com/mareksuscak)
 */ const $410c3a07deabec17$var$sk = $410c3a07deabec17$export$d608fa5b5bfd2021 = {
    code: "sk",
    formatDistance: $fS7jy.formatDistance,
    formatLong: $k8MRY.formatLong,
    formatRelative: $I5sZl.formatRelative,
    localize: $8halm.localize,
    match: $eEMqn.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("fS7jy", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $b8e192a6fb51f7c3$export$2c14ff85d6318973; }, function (v) { return $b8e192a6fb51f7c3$export$2c14ff85d6318973 = v; });
var $b8e192a6fb51f7c3$export$2c14ff85d6318973;
"use strict";
$b8e192a6fb51f7c3$export$2c14ff85d6318973 = void 0;
function $b8e192a6fb51f7c3$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $b8e192a6fb51f7c3$var$declension(scheme, count, time) {
    const group = $b8e192a6fb51f7c3$var$declensionGroup(scheme, count);
    const finalText = group[time];
    return finalText.replace("{{count}}", String(count));
}
function $b8e192a6fb51f7c3$var$extractPreposition(token) {
    const result = [
        "lessThan",
        "about",
        "over",
        "almost"
    ].filter(function(preposition) {
        return !!token.match(new RegExp("^" + preposition));
    });
    return result[0];
}
function $b8e192a6fb51f7c3$var$prefixPreposition(preposition) {
    let translation = "";
    if (preposition === "almost") translation = "takmer";
    if (preposition === "about") translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + " " : "";
}
function $b8e192a6fb51f7c3$var$suffixPreposition(preposition) {
    let translation = "";
    if (preposition === "lessThan") translation = "menej ne\u017E";
    if (preposition === "over") translation = "viac ne\u017E";
    return translation.length > 0 ? translation + " " : "";
}
function $b8e192a6fb51f7c3$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
const $b8e192a6fb51f7c3$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: "sekunda",
            past: "sekundou",
            future: "sekundu"
        },
        twoFour: {
            present: "{{count}} sekundy",
            past: "{{count}} sekundami",
            future: "{{count}} sekundy"
        },
        other: {
            present: "{{count}} sek\xfand",
            past: "{{count}} sekundami",
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: "hodina",
            past: "hodinou",
            future: "hodinu"
        },
        twoFour: {
            present: "{{count}} hodiny",
            past: "{{count}} hodinami",
            future: "{{count}} hodiny"
        },
        other: {
            present: "{{count}} hod\xedn",
            past: "{{count}} hodinami",
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: "{{count}} dni",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dni"
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: "mesiac",
            past: "mesiacom",
            future: "mesiac"
        },
        twoFour: {
            present: "{{count}} mesiace",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiace"
        },
        other: {
            present: "{{count}} mesiacov",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiacov"
        }
    },
    xYears: {
        one: {
            present: "rok",
            past: "rokom",
            future: "rok"
        },
        twoFour: {
            present: "{{count}} roky",
            past: "{{count}} rokmi",
            future: "{{count}} roky"
        },
        other: {
            present: "{{count}} rokov",
            past: "{{count}} rokmi",
            future: "{{count}} rokov"
        }
    }
};
const $b8e192a6fb51f7c3$var$formatDistance = (token, count, options)=>{
    const preposition = $b8e192a6fb51f7c3$var$extractPreposition(token) || "";
    const key = $b8e192a6fb51f7c3$var$lowercaseFirstLetter(token.substring(preposition.length));
    const scheme = $b8e192a6fb51f7c3$var$formatDistanceLocale[key];
    if (!options?.addSuffix) return $b8e192a6fb51f7c3$var$prefixPreposition(preposition) + $b8e192a6fb51f7c3$var$suffixPreposition(preposition) + $b8e192a6fb51f7c3$var$declension(scheme, count, "present");
    if (options.comparison && options.comparison > 0) return $b8e192a6fb51f7c3$var$prefixPreposition(preposition) + "o " + $b8e192a6fb51f7c3$var$suffixPreposition(preposition) + $b8e192a6fb51f7c3$var$declension(scheme, count, "future");
    else return $b8e192a6fb51f7c3$var$prefixPreposition(preposition) + "pred " + $b8e192a6fb51f7c3$var$suffixPreposition(preposition) + $b8e192a6fb51f7c3$var$declension(scheme, count, "past");
};
$b8e192a6fb51f7c3$export$2c14ff85d6318973 = $b8e192a6fb51f7c3$var$formatDistance;

});

parcelRegister("k8MRY", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ea9a76797e1957b8$export$cbf60ecb96cbb82f; }, function (v) { return $ea9a76797e1957b8$export$cbf60ecb96cbb82f = v; });
var $ea9a76797e1957b8$export$cbf60ecb96cbb82f;
"use strict";
$ea9a76797e1957b8$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
const $ea9a76797e1957b8$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. M. y",
    short: "d. M. y"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
const $ea9a76797e1957b8$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
const $ea9a76797e1957b8$var$dateTimeFormats = {
    full: "{{date}}, {{time}}",
    long: "{{date}}, {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}} {{time}}"
};
const $ea9a76797e1957b8$var$formatLong = $ea9a76797e1957b8$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $ea9a76797e1957b8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $ea9a76797e1957b8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $ea9a76797e1957b8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("I5sZl", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $084859b817a2f85d$export$8fbbfd65594f46a0; }, function (v) { return $084859b817a2f85d$export$8fbbfd65594f46a0 = v; });
var $084859b817a2f85d$export$8fbbfd65594f46a0;
"use strict";
$084859b817a2f85d$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
const $084859b817a2f85d$var$accusativeWeekdays = [
    "nede\u013Eu",
    "pondelok",
    "utorok",
    "stredu",
    "\u0161tvrtok",
    "piatok",
    "sobotu"
];
function $084859b817a2f85d$var$lastWeek(day) {
    const weekday = $084859b817a2f85d$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $084859b817a2f85d$var$thisWeek(day) {
    const weekday = $084859b817a2f85d$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $084859b817a2f85d$var$nextWeek(day) {
    const weekday = $084859b817a2f85d$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
const $084859b817a2f85d$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $084859b817a2f85d$var$thisWeek(day);
        else return $084859b817a2f85d$var$lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $084859b817a2f85d$var$thisWeek(day);
        else return $084859b817a2f85d$var$nextWeek(day);
    },
    other: "P"
};
const $084859b817a2f85d$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $084859b817a2f85d$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$084859b817a2f85d$export$8fbbfd65594f46a0 = $084859b817a2f85d$var$formatRelative;

});

parcelRegister("8halm", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6067ef428402790e$export$b3bd0bc58e36cd63; }, function (v) { return $6067ef428402790e$export$b3bd0bc58e36cd63 = v; });
var $6067ef428402790e$export$b3bd0bc58e36cd63;
"use strict";
$6067ef428402790e$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
const $6067ef428402790e$var$eraValues = {
    narrow: [
        "pred Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pred Kr.",
        "po Kr."
    ],
    wide: [
        "pred Kristom",
        "po Kristovi"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
const $6067ef428402790e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
const $6067ef428402790e$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "marec",
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "august",
        "september",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
const $6067ef428402790e$var$formattingMonthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        "marca",
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        "augusta",
        "septembra",
        "okt\xf3bra",
        "novembra",
        "decembra"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
const $6067ef428402790e$var$dayValues = {
    narrow: [
        "n",
        "p",
        "u",
        "s",
        "\u0161",
        "p",
        "s"
    ],
    short: [
        "ne",
        "po",
        "ut",
        "st",
        "\u0161t",
        "pi",
        "so"
    ],
    abbreviated: [
        "ne",
        "po",
        "ut",
        "st",
        "\u0161t",
        "pi",
        "so"
    ],
    wide: [
        "nede\u013Ea",
        "pondelok",
        "utorok",
        "streda",
        "\u0161tvrtok",
        "piatok",
        "sobota"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
const $6067ef428402790e$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "polnoc",
        noon: "poludnie",
        morning: "r\xe1no",
        afternoon: "popoludnie",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $6067ef428402790e$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "nap.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "v n."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "napol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "v noci"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o polnoci",
        noon: "napoludnie",
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: "v noci"
    }
};
const $6067ef428402790e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $6067ef428402790e$var$localize = $6067ef428402790e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6067ef428402790e$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $6067ef428402790e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $6067ef428402790e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $6067ef428402790e$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $6067ef428402790e$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $6067ef428402790e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $6067ef428402790e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6067ef428402790e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("eEMqn", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $aaba5d2ffbf7d212$export$4659b591c19bdf3d; }, function (v) { return $aaba5d2ffbf7d212$export$4659b591c19bdf3d = v; });
var $aaba5d2ffbf7d212$export$4659b591c19bdf3d;
"use strict";
$aaba5d2ffbf7d212$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $aaba5d2ffbf7d212$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $aaba5d2ffbf7d212$var$parseOrdinalNumberPattern = /\d+/i;
const $aaba5d2ffbf7d212$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
const $aaba5d2ffbf7d212$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
const $aaba5d2ffbf7d212$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
const $aaba5d2ffbf7d212$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $aaba5d2ffbf7d212$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
const $aaba5d2ffbf7d212$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $aaba5d2ffbf7d212$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
const $aaba5d2ffbf7d212$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
const $aaba5d2ffbf7d212$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
const $aaba5d2ffbf7d212$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
const $aaba5d2ffbf7d212$var$match = $aaba5d2ffbf7d212$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $aaba5d2ffbf7d212$var$matchOrdinalNumberPattern,
        parsePattern: $aaba5d2ffbf7d212$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $aaba5d2ffbf7d212$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $aaba5d2ffbf7d212$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $aaba5d2ffbf7d212$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $aaba5d2ffbf7d212$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $aaba5d2ffbf7d212$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $aaba5d2ffbf7d212$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $aaba5d2ffbf7d212$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $aaba5d2ffbf7d212$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $aaba5d2ffbf7d212$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $aaba5d2ffbf7d212$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("jXMJV", function(module, exports) {

$parcel$export(module.exports, "sl", function () { return $e88955ae1b0ca08a$export$c48c9775cb5125a6; }, function (v) { return $e88955ae1b0ca08a$export$c48c9775cb5125a6 = v; });
var $e88955ae1b0ca08a$export$c48c9775cb5125a6;
"use strict";
$e88955ae1b0ca08a$export$c48c9775cb5125a6 = void 0;

var $9ekuH = parcelRequire("9ekuH");

var $4535v = parcelRequire("4535v");

var $9Zvdk = parcelRequire("9Zvdk");

var $8dZVD = parcelRequire("8dZVD");

var $cq55d = parcelRequire("cq55d");
/**
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph](https://github.com/Neoglyph)
 * @author Mato Žgajner [@mzgajner](https://github.com/mzgajner)
 */ const $e88955ae1b0ca08a$var$sl = $e88955ae1b0ca08a$export$c48c9775cb5125a6 = {
    code: "sl",
    formatDistance: $9ekuH.formatDistance,
    formatLong: $4535v.formatLong,
    formatRelative: $9Zvdk.formatRelative,
    localize: $8dZVD.localize,
    match: $cq55d.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("9ekuH", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $6b855196e1eba6fe$export$2c14ff85d6318973; }, function (v) { return $6b855196e1eba6fe$export$2c14ff85d6318973 = v; });
var $6b855196e1eba6fe$export$2c14ff85d6318973;
"use strict";
$6b855196e1eba6fe$export$2c14ff85d6318973 = void 0;
function $6b855196e1eba6fe$var$isPluralType(val) {
    return val.one !== undefined;
}
const $6b855196e1eba6fe$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: "manj kot {{count}} sekunda",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        },
        past: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundama",
            few: "manj kot {{count}} sekundami",
            other: "manj kot {{count}} sekundami"
        },
        future: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        }
    },
    xSeconds: {
        present: {
            one: "{{count}} sekunda",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        },
        past: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundama",
            few: "{{count}} sekundami",
            other: "{{count}} sekundami"
        },
        future: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        }
    },
    halfAMinute: "pol minute",
    lessThanXMinutes: {
        present: {
            one: "manj kot {{count}} minuta",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        },
        past: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minutama",
            few: "manj kot {{count}} minutami",
            other: "manj kot {{count}} minutami"
        },
        future: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        }
    },
    xMinutes: {
        present: {
            one: "{{count}} minuta",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        },
        past: {
            one: "{{count}} minuto",
            two: "{{count}} minutama",
            few: "{{count}} minutami",
            other: "{{count}} minutami"
        },
        future: {
            one: "{{count}} minuto",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: "{{count}} ura",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        },
        past: {
            one: "{{count}} uro",
            two: "{{count}} urama",
            few: "{{count}} urami",
            other: "{{count}} urami"
        },
        future: {
            one: "{{count}} uro",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        }
    },
    xDays: {
        present: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        },
        past: {
            one: "{{count}} dnem",
            two: "{{count}} dnevoma",
            few: "{{count}} dnevi",
            other: "{{count}} dnevi"
        },
        future: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: "{{count}} teden",
        two: "{{count}} tedna",
        few: "{{count}} tedne",
        other: "{{count}} tednov"
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} meseci",
            other: "{{count}} mesecev"
        },
        past: {
            one: "{{count}} mesecem",
            two: "{{count}} mesecema",
            few: "{{count}} meseci",
            other: "{{count}} meseci"
        },
        future: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} mesece",
            other: "{{count}} mesecev"
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        },
        past: {
            one: "{{count}} letom",
            two: "{{count}} letoma",
            few: "{{count}} leti",
            other: "{{count}} leti"
        },
        future: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        },
        past: {
            one: "skoraj {{count}} letom",
            two: "skoraj {{count}} letoma",
            few: "skoraj {{count}} leti",
            other: "skoraj {{count}} leti"
        },
        future: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        }
    }
};
function $6b855196e1eba6fe$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return "one";
        case 2:
            return "two";
        case 3:
        case 4:
            return "few";
        default:
            return "other";
    }
}
const $6b855196e1eba6fe$var$formatDistance = (token, count, options)=>{
    let result = "";
    let tense = "present";
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = "future";
            result = "\u010Dez ";
        } else {
            tense = "past";
            result = "pred ";
        }
    }
    const tokenValue = $6b855196e1eba6fe$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result += tokenValue;
    else {
        const form = $6b855196e1eba6fe$var$getFormFromCount(count);
        if ($6b855196e1eba6fe$var$isPluralType(tokenValue)) result += tokenValue[form].replace("{{count}}", String(count));
        else result += tokenValue[tense][form].replace("{{count}}", String(count));
    }
    return result;
};
$6b855196e1eba6fe$export$2c14ff85d6318973 = $6b855196e1eba6fe$var$formatDistance;

});

parcelRegister("4535v", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $2f8a06381fc76593$export$cbf60ecb96cbb82f; }, function (v) { return $2f8a06381fc76593$export$cbf60ecb96cbb82f = v; });
var $2f8a06381fc76593$export$cbf60ecb96cbb82f;
"use strict";
$2f8a06381fc76593$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $2f8a06381fc76593$var$dateFormats = {
    full: "EEEE, dd. MMMM y",
    long: "dd. MMMM y",
    medium: "d. MMM y",
    short: "d. MM. yy"
};
const $2f8a06381fc76593$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $2f8a06381fc76593$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $2f8a06381fc76593$var$formatLong = $2f8a06381fc76593$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $2f8a06381fc76593$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $2f8a06381fc76593$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $2f8a06381fc76593$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9Zvdk", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $746206020d15e18d$export$8fbbfd65594f46a0; }, function (v) { return $746206020d15e18d$export$8fbbfd65594f46a0 = v; });
var $746206020d15e18d$export$8fbbfd65594f46a0;
"use strict";
$746206020d15e18d$export$8fbbfd65594f46a0 = void 0;
const $746206020d15e18d$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: "P"
};
const $746206020d15e18d$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $746206020d15e18d$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$746206020d15e18d$export$8fbbfd65594f46a0 = $746206020d15e18d$var$formatRelative;

});

parcelRegister("8dZVD", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $5fcf9361bc760776$export$b3bd0bc58e36cd63; }, function (v) { return $5fcf9361bc760776$export$b3bd0bc58e36cd63 = v; });
var $5fcf9361bc760776$export$b3bd0bc58e36cd63;
"use strict";
$5fcf9361bc760776$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $5fcf9361bc760776$var$eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
const $5fcf9361bc760776$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
const $5fcf9361bc760776$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "avg.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marec",
        "april",
        "maj",
        "junij",
        "julij",
        "avgust",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $5fcf9361bc760776$var$dayValues = {
    narrow: [
        "n",
        "p",
        "t",
        "s",
        "\u010D",
        "p",
        "s"
    ],
    short: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "\u010Det.",
        "pet.",
        "sob."
    ],
    abbreviated: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "\u010Det.",
        "pet.",
        "sob."
    ],
    wide: [
        "nedelja",
        "ponedeljek",
        "torek",
        "sreda",
        "\u010Detrtek",
        "petek",
        "sobota"
    ]
};
const $5fcf9361bc760776$var$dayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "j",
        afternoon: "p",
        evening: "v",
        night: "n"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "poln.",
        noon: "pold.",
        morning: "jut.",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "polno\u010D",
        noon: "poldne",
        morning: "jutro",
        afternoon: "popoldne",
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
const $5fcf9361bc760776$var$formattingDayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "zj",
        afternoon: "p",
        evening: "zv",
        night: "po"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "opoln.",
        noon: "opold.",
        morning: "zjut.",
        afternoon: "pop.",
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "opolno\u010Di",
        noon: "opoldne",
        morning: "zjutraj",
        afternoon: "popoldan",
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
const $5fcf9361bc760776$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $5fcf9361bc760776$var$localize = $5fcf9361bc760776$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $5fcf9361bc760776$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $5fcf9361bc760776$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $5fcf9361bc760776$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $5fcf9361bc760776$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $5fcf9361bc760776$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $5fcf9361bc760776$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5fcf9361bc760776$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("cq55d", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $90abdb2bd4874977$export$4659b591c19bdf3d; }, function (v) { return $90abdb2bd4874977$export$4659b591c19bdf3d = v; });
var $90abdb2bd4874977$export$4659b591c19bdf3d;
"use strict";
$90abdb2bd4874977$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $90abdb2bd4874977$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $90abdb2bd4874977$var$parseOrdinalNumberPattern = /\d+/i;
const $90abdb2bd4874977$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
const $90abdb2bd4874977$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
const $90abdb2bd4874977$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
const $90abdb2bd4874977$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $90abdb2bd4874977$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
const $90abdb2bd4874977$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $90abdb2bd4874977$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
const $90abdb2bd4874977$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
const $90abdb2bd4874977$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
const $90abdb2bd4874977$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
const $90abdb2bd4874977$var$match = $90abdb2bd4874977$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $90abdb2bd4874977$var$matchOrdinalNumberPattern,
        parsePattern: $90abdb2bd4874977$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $90abdb2bd4874977$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $90abdb2bd4874977$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $90abdb2bd4874977$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $90abdb2bd4874977$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $90abdb2bd4874977$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $90abdb2bd4874977$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $90abdb2bd4874977$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $90abdb2bd4874977$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $90abdb2bd4874977$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $90abdb2bd4874977$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("lu951", function(module, exports) {

$parcel$export(module.exports, "sq", function () { return $fa4371698cec568a$export$a8157a6a5eefedbe; }, function (v) { return $fa4371698cec568a$export$a8157a6a5eefedbe = v; });
var $fa4371698cec568a$export$a8157a6a5eefedbe;
"use strict";
$fa4371698cec568a$export$a8157a6a5eefedbe = void 0;

var $kz9d3 = parcelRequire("kz9d3");

var $ae9V8 = parcelRequire("ae9V8");

var $6x0su = parcelRequire("6x0su");

var $aW5P9 = parcelRequire("aW5P9");

var $cJ4Xn = parcelRequire("cJ4Xn");
/**
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine](https://github.com/arditdine)
 */ const $fa4371698cec568a$var$sq = $fa4371698cec568a$export$a8157a6a5eefedbe = {
    code: "sq",
    formatDistance: $kz9d3.formatDistance,
    formatLong: $ae9V8.formatLong,
    formatRelative: $6x0su.formatRelative,
    localize: $aW5P9.localize,
    match: $cJ4Xn.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("kz9d3", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ef8e385b562a71bc$export$2c14ff85d6318973; }, function (v) { return $ef8e385b562a71bc$export$2c14ff85d6318973 = v; });
var $ef8e385b562a71bc$export$2c14ff85d6318973;
"use strict";
$ef8e385b562a71bc$export$2c14ff85d6318973 = void 0;
const $ef8e385b562a71bc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: "{{count}} sekonda"
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: "rreth 1 muaj",
        other: "rreth {{count}} muaj"
    },
    xMonths: {
        one: "1 muaj",
        other: "{{count}} muaj"
    },
    aboutXYears: {
        one: "rreth 1 vit",
        other: "rreth {{count}} vite"
    },
    xYears: {
        one: "1 vit",
        other: "{{count}} vite"
    },
    overXYears: {
        one: "mbi 1 vit",
        other: "mbi {{count}} vite"
    },
    almostXYears: {
        one: "pothuajse 1 vit",
        other: "pothuajse {{count}} vite"
    }
};
const $ef8e385b562a71bc$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ef8e385b562a71bc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
$ef8e385b562a71bc$export$2c14ff85d6318973 = $ef8e385b562a71bc$var$formatDistance;

});

parcelRegister("ae9V8", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $7722e8388574577f$export$cbf60ecb96cbb82f; }, function (v) { return $7722e8388574577f$export$cbf60ecb96cbb82f = v; });
var $7722e8388574577f$export$cbf60ecb96cbb82f;
"use strict";
$7722e8388574577f$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $7722e8388574577f$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $7722e8388574577f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $7722e8388574577f$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $7722e8388574577f$var$formatLong = $7722e8388574577f$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $7722e8388574577f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $7722e8388574577f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $7722e8388574577f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6x0su", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $4c162e369ccb0258$export$8fbbfd65594f46a0; }, function (v) { return $4c162e369ccb0258$export$8fbbfd65594f46a0 = v; });
var $4c162e369ccb0258$export$8fbbfd65594f46a0;
"use strict";
$4c162e369ccb0258$export$8fbbfd65594f46a0 = void 0;
const $4c162e369ccb0258$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $4c162e369ccb0258$var$formatRelative = (token, _date, _baseDate, _options)=>$4c162e369ccb0258$var$formatRelativeLocale[token];
$4c162e369ccb0258$export$8fbbfd65594f46a0 = $4c162e369ccb0258$var$formatRelative;

});

parcelRegister("aW5P9", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $7f63d6b44b68555b$export$b3bd0bc58e36cd63; }, function (v) { return $7f63d6b44b68555b$export$b3bd0bc58e36cd63 = v; });
var $7f63d6b44b68555b$export$b3bd0bc58e36cd63;
"use strict";
$7f63d6b44b68555b$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $7f63d6b44b68555b$var$eraValues = {
    narrow: [
        "P",
        "M"
    ],
    abbreviated: [
        "PK",
        "MK"
    ],
    wide: [
        "Para Krishtit",
        "Mbas Krishtit"
    ]
};
const $7f63d6b44b68555b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "4-mujori I",
        "4-mujori II",
        "4-mujori III",
        "4-mujori IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $7f63d6b44b68555b$var$monthValues = {
    narrow: [
        "J",
        "S",
        "M",
        "P",
        "M",
        "Q",
        "K",
        "G",
        "S",
        "T",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Shk",
        "Mar",
        "Pri",
        "Maj",
        "Qer",
        "Kor",
        "Gus",
        "Sht",
        "Tet",
        "N\xebn",
        "Dhj"
    ],
    wide: [
        "Janar",
        "Shkurt",
        "Mars",
        "Prill",
        "Maj",
        "Qershor",
        "Korrik",
        "Gusht",
        "Shtator",
        "Tetor",
        "N\xebntor",
        "Dhjetor"
    ]
};
const $7f63d6b44b68555b$var$dayValues = {
    narrow: [
        "D",
        "H",
        "M",
        "M",
        "E",
        "P",
        "S"
    ],
    short: [
        "Di",
        "H\xeb",
        "Ma",
        "M\xeb",
        "En",
        "Pr",
        "Sh"
    ],
    abbreviated: [
        "Die",
        "H\xebn",
        "Mar",
        "M\xebr",
        "Enj",
        "Pre",
        "Sht"
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        "Enjte",
        "Premte",
        "Shtun\xeb"
    ]
};
const $7f63d6b44b68555b$var$dayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "m\xebngjes",
        afternoon: "dite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
const $7f63d6b44b68555b$var$formattingDayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
const $7f63d6b44b68555b$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    if (options?.unit === "hour") return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + "t";
    return number + "-t\xeb";
};
const $7f63d6b44b68555b$var$localize = $7f63d6b44b68555b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7f63d6b44b68555b$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $7f63d6b44b68555b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $7f63d6b44b68555b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $7f63d6b44b68555b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $7f63d6b44b68555b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $7f63d6b44b68555b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7f63d6b44b68555b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("cJ4Xn", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $943d88516eb74ea4$export$4659b591c19bdf3d; }, function (v) { return $943d88516eb74ea4$export$4659b591c19bdf3d = v; });
var $943d88516eb74ea4$export$4659b591c19bdf3d;
"use strict";
$943d88516eb74ea4$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $943d88516eb74ea4$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
const $943d88516eb74ea4$var$parseOrdinalNumberPattern = /\d+/i;
const $943d88516eb74ea4$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
const $943d88516eb74ea4$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
const $943d88516eb74ea4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
const $943d88516eb74ea4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $943d88516eb74ea4$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
const $943d88516eb74ea4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
const $943d88516eb74ea4$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
const $943d88516eb74ea4$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
const $943d88516eb74ea4$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
const $943d88516eb74ea4$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
const $943d88516eb74ea4$var$match = $943d88516eb74ea4$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $943d88516eb74ea4$var$matchOrdinalNumberPattern,
        parsePattern: $943d88516eb74ea4$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $943d88516eb74ea4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $943d88516eb74ea4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $943d88516eb74ea4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $943d88516eb74ea4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $943d88516eb74ea4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $943d88516eb74ea4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $943d88516eb74ea4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $943d88516eb74ea4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $943d88516eb74ea4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $943d88516eb74ea4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("4xbyg", function(module, exports) {

$parcel$export(module.exports, "sr", function () { return $34d3346455fcb5a7$export$187592e8a03966af; }, function (v) { return $34d3346455fcb5a7$export$187592e8a03966af = v; });
var $34d3346455fcb5a7$export$187592e8a03966af;
"use strict";
$34d3346455fcb5a7$export$187592e8a03966af = void 0;

var $6cQ4s = parcelRequire("6cQ4s");

var $khzoL = parcelRequire("khzoL");

var $czfcI = parcelRequire("czfcI");

var $a00PD = parcelRequire("a00PD");

var $kAbYb = parcelRequire("kAbYb");
/**
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje](https://github.com/rogyvoje)
 */ const $34d3346455fcb5a7$var$sr = $34d3346455fcb5a7$export$187592e8a03966af = {
    code: "sr",
    formatDistance: $6cQ4s.formatDistance,
    formatLong: $khzoL.formatLong,
    formatRelative: $czfcI.formatRelative,
    localize: $a00PD.localize,
    match: $kAbYb.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("6cQ4s", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $484c41464c848d67$export$2c14ff85d6318973; }, function (v) { return $484c41464c848d67$export$2c14ff85d6318973 = v; });
var $484c41464c848d67$export$2c14ff85d6318973;
"use strict";
$484c41464c848d67$export$2c14ff85d6318973 = void 0;
const $484c41464c848d67$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
const $484c41464c848d67$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $484c41464c848d67$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
$484c41464c848d67$export$2c14ff85d6318973 = $484c41464c848d67$var$formatDistance;

});

parcelRegister("khzoL", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ec40da8cd04758b9$export$cbf60ecb96cbb82f; }, function (v) { return $ec40da8cd04758b9$export$cbf60ecb96cbb82f = v; });
var $ec40da8cd04758b9$export$cbf60ecb96cbb82f;
"use strict";
$ec40da8cd04758b9$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $ec40da8cd04758b9$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $ec40da8cd04758b9$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $ec40da8cd04758b9$var$dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $ec40da8cd04758b9$var$formatLong = $ec40da8cd04758b9$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $ec40da8cd04758b9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $ec40da8cd04758b9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $ec40da8cd04758b9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("czfcI", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $92648c1f2bea1357$export$8fbbfd65594f46a0; }, function (v) { return $92648c1f2bea1357$export$8fbbfd65594f46a0 = v; });
var $92648c1f2bea1357$export$8fbbfd65594f46a0;
"use strict";
$92648c1f2bea1357$export$8fbbfd65594f46a0 = void 0;
const $92648c1f2bea1357$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: "P"
};
const $92648c1f2bea1357$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $92648c1f2bea1357$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$92648c1f2bea1357$export$8fbbfd65594f46a0 = $92648c1f2bea1357$var$formatRelative;

});

parcelRegister("a00PD", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $747a8ca4d148e2bd$export$b3bd0bc58e36cd63; }, function (v) { return $747a8ca4d148e2bd$export$b3bd0bc58e36cd63 = v; });
var $747a8ca4d148e2bd$export$b3bd0bc58e36cd63;
"use strict";
$747a8ca4d148e2bd$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $747a8ca4d148e2bd$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
const $747a8ca4d148e2bd$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $747a8ca4d148e2bd$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
const $747a8ca4d148e2bd$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
const $747a8ca4d148e2bd$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $747a8ca4d148e2bd$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
const $747a8ca4d148e2bd$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
const $747a8ca4d148e2bd$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $747a8ca4d148e2bd$var$localize = $747a8ca4d148e2bd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $747a8ca4d148e2bd$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $747a8ca4d148e2bd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $747a8ca4d148e2bd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $747a8ca4d148e2bd$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $747a8ca4d148e2bd$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $747a8ca4d148e2bd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $747a8ca4d148e2bd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $747a8ca4d148e2bd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("kAbYb", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $efc0745b03cb88f0$export$4659b591c19bdf3d; }, function (v) { return $efc0745b03cb88f0$export$4659b591c19bdf3d = v; });
var $efc0745b03cb88f0$export$4659b591c19bdf3d;
"use strict";
$efc0745b03cb88f0$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $efc0745b03cb88f0$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $efc0745b03cb88f0$var$parseOrdinalNumberPattern = /\d+/i;
const $efc0745b03cb88f0$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
const $efc0745b03cb88f0$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
const $efc0745b03cb88f0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
const $efc0745b03cb88f0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $efc0745b03cb88f0$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
const $efc0745b03cb88f0$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $efc0745b03cb88f0$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
const $efc0745b03cb88f0$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
const $efc0745b03cb88f0$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
const $efc0745b03cb88f0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
const $efc0745b03cb88f0$var$match = $efc0745b03cb88f0$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $efc0745b03cb88f0$var$matchOrdinalNumberPattern,
        parsePattern: $efc0745b03cb88f0$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efc0745b03cb88f0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efc0745b03cb88f0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efc0745b03cb88f0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efc0745b03cb88f0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efc0745b03cb88f0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efc0745b03cb88f0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efc0745b03cb88f0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efc0745b03cb88f0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $efc0745b03cb88f0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $efc0745b03cb88f0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("btFP9", function(module, exports) {

$parcel$export(module.exports, "srLatn", function () { return $85b2d8882fe9f429$export$dd0ad751d91f231a; }, function (v) { return $85b2d8882fe9f429$export$dd0ad751d91f231a = v; });
var $85b2d8882fe9f429$export$dd0ad751d91f231a;
"use strict";
$85b2d8882fe9f429$export$dd0ad751d91f231a = void 0;

var $2gTiM = parcelRequire("2gTiM");

var $bfkB7 = parcelRequire("bfkB7");

var $24K2R = parcelRequire("24K2R");

var $fDz8I = parcelRequire("fDz8I");

var $grJeU = parcelRequire("grJeU");
/**
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje](https://github.com/rogyvoje)
 */ const $85b2d8882fe9f429$var$srLatn = $85b2d8882fe9f429$export$dd0ad751d91f231a = {
    code: "sr-Latn",
    formatDistance: $2gTiM.formatDistance,
    formatLong: $bfkB7.formatLong,
    formatRelative: $24K2R.formatRelative,
    localize: $fDz8I.localize,
    match: $grJeU.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("2gTiM", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $1a77f935debb6ce4$export$2c14ff85d6318973; }, function (v) { return $1a77f935debb6ce4$export$2c14ff85d6318973 = v; });
var $1a77f935debb6ce4$export$2c14ff85d6318973;
"use strict";
$1a77f935debb6ce4$export$2c14ff85d6318973 = void 0;
const $1a77f935debb6ce4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 nedelju",
            withPrepositionAgo: "oko 1 nedelju",
            withPrepositionIn: "oko 1 nedelju"
        },
        dual: "oko {{count}} nedelje",
        other: "oko {{count}} nedelje"
    },
    xWeeks: {
        one: {
            standalone: "1 nedelju",
            withPrepositionAgo: "1 nedelju",
            withPrepositionIn: "1 nedelju"
        },
        dual: "{{count}} nedelje",
        other: "{{count}} nedelje"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mesec",
            withPrepositionAgo: "oko 1 mesec",
            withPrepositionIn: "oko 1 mesec"
        },
        dual: "oko {{count}} meseca",
        other: "oko {{count}} meseci"
    },
    xMonths: {
        one: {
            standalone: "1 mesec",
            withPrepositionAgo: "1 mesec",
            withPrepositionIn: "1 mesec"
        },
        dual: "{{count}} meseca",
        other: "{{count}} meseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $1a77f935debb6ce4$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $1a77f935debb6ce4$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "pre " + result;
    }
    return result;
};
$1a77f935debb6ce4$export$2c14ff85d6318973 = $1a77f935debb6ce4$var$formatDistance;

});

parcelRegister("bfkB7", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $830112b2db71318c$export$cbf60ecb96cbb82f; }, function (v) { return $830112b2db71318c$export$cbf60ecb96cbb82f = v; });
var $830112b2db71318c$export$cbf60ecb96cbb82f;
"use strict";
$830112b2db71318c$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $830112b2db71318c$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $830112b2db71318c$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $830112b2db71318c$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $830112b2db71318c$var$formatLong = $830112b2db71318c$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $830112b2db71318c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $830112b2db71318c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $830112b2db71318c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("24K2R", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $182fac1809a47ee6$export$8fbbfd65594f46a0; }, function (v) { return $182fac1809a47ee6$export$8fbbfd65594f46a0 = v; });
var $182fac1809a47ee6$export$8fbbfd65594f46a0;
"use strict";
$182fac1809a47ee6$export$8fbbfd65594f46a0 = void 0;
const $182fac1809a47ee6$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: "P"
};
const $182fac1809a47ee6$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $182fac1809a47ee6$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$182fac1809a47ee6$export$8fbbfd65594f46a0 = $182fac1809a47ee6$var$formatRelative;

});

parcelRegister("fDz8I", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $02f017c449a5fe2c$export$b3bd0bc58e36cd63; }, function (v) { return $02f017c449a5fe2c$export$b3bd0bc58e36cd63 = v; });
var $02f017c449a5fe2c$export$b3bd0bc58e36cd63;
"use strict";
$02f017c449a5fe2c$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $02f017c449a5fe2c$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Pre Hrista",
        "Posle Hrista"
    ]
};
const $02f017c449a5fe2c$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $02f017c449a5fe2c$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $02f017c449a5fe2c$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $02f017c449a5fe2c$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedelja",
        "ponedeljak",
        "utorak",
        "sreda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $02f017c449a5fe2c$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $02f017c449a5fe2c$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $02f017c449a5fe2c$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $02f017c449a5fe2c$var$localize = $02f017c449a5fe2c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $02f017c449a5fe2c$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $02f017c449a5fe2c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $02f017c449a5fe2c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $02f017c449a5fe2c$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $02f017c449a5fe2c$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $02f017c449a5fe2c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $02f017c449a5fe2c$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $02f017c449a5fe2c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("grJeU", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $bf924296febd355f$export$4659b591c19bdf3d; }, function (v) { return $bf924296febd355f$export$4659b591c19bdf3d = v; });
var $bf924296febd355f$export$4659b591c19bdf3d;
"use strict";
$bf924296febd355f$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $bf924296febd355f$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $bf924296febd355f$var$parseOrdinalNumberPattern = /\d+/i;
const $bf924296febd355f$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
const $bf924296febd355f$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $bf924296febd355f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $bf924296febd355f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $bf924296febd355f$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
const $bf924296febd355f$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $bf924296febd355f$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $bf924296febd355f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $bf924296febd355f$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
const $bf924296febd355f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
const $bf924296febd355f$var$match = $bf924296febd355f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $bf924296febd355f$var$matchOrdinalNumberPattern,
        parsePattern: $bf924296febd355f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bf924296febd355f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf924296febd355f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bf924296febd355f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf924296febd355f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bf924296febd355f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf924296febd355f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bf924296febd355f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf924296febd355f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $bf924296febd355f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bf924296febd355f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("j5iEU", function(module, exports) {

$parcel$export(module.exports, "sv", function () { return $de4cf539903d332e$export$65540e5f7f6e7dce; }, function (v) { return $de4cf539903d332e$export$65540e5f7f6e7dce = v; });
var $de4cf539903d332e$export$65540e5f7f6e7dce;
"use strict";
$de4cf539903d332e$export$65540e5f7f6e7dce = void 0;

var $kMK81 = parcelRequire("kMK81");

var $9th4C = parcelRequire("9th4C");

var $kkgMb = parcelRequire("kkgMb");

var $dLL6K = parcelRequire("dLL6K");

var $1R3bc = parcelRequire("1R3bc");
/**
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen](https://github.com/ejulen)
 * @author Alexander Nanberg [@alexandernanberg](https://github.com/alexandernanberg)
 * @author Henrik Andersson [@limelights](https://github.com/limelights)
 */ const $de4cf539903d332e$var$sv = $de4cf539903d332e$export$65540e5f7f6e7dce = {
    code: "sv",
    formatDistance: $kMK81.formatDistance,
    formatLong: $9th4C.formatLong,
    formatRelative: $kkgMb.formatRelative,
    localize: $dLL6K.localize,
    match: $1R3bc.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("kMK81", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f21c127e53312ec6$export$2c14ff85d6318973; }, function (v) { return $f21c127e53312ec6$export$2c14ff85d6318973 = v; });
var $f21c127e53312ec6$export$2c14ff85d6318973;
"use strict";
$f21c127e53312ec6$export$2c14ff85d6318973 = void 0;
const $f21c127e53312ec6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: "en sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: "en minut",
        other: "{{count}} minuter"
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: "en timme",
        other: "{{count}} timmar"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} veckor"
    },
    xWeeks: {
        one: "en vecka",
        other: "{{count}} veckor"
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
const $f21c127e53312ec6$var$wordMapping = [
    "noll",
    "en",
    "tv\xe5",
    "tre",
    "fyra",
    "fem",
    "sex",
    "sju",
    "\xe5tta",
    "nio",
    "tio",
    "elva",
    "tolv"
];
const $f21c127e53312ec6$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f21c127e53312ec6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $f21c127e53312ec6$var$wordMapping[count] : String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sedan";
    }
    return result;
};
$f21c127e53312ec6$export$2c14ff85d6318973 = $f21c127e53312ec6$var$formatDistance;

});

parcelRegister("9th4C", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $6e5410ea7053716f$export$cbf60ecb96cbb82f; }, function (v) { return $6e5410ea7053716f$export$cbf60ecb96cbb82f = v; });
var $6e5410ea7053716f$export$cbf60ecb96cbb82f;
"use strict";
$6e5410ea7053716f$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $6e5410ea7053716f$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
};
const $6e5410ea7053716f$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6e5410ea7053716f$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $6e5410ea7053716f$var$formatLong = $6e5410ea7053716f$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $6e5410ea7053716f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $6e5410ea7053716f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $6e5410ea7053716f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("kkgMb", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $ecc2b04811ebf570$export$8fbbfd65594f46a0; }, function (v) { return $ecc2b04811ebf570$export$8fbbfd65594f46a0 = v; });
var $ecc2b04811ebf570$export$8fbbfd65594f46a0;
"use strict";
$ecc2b04811ebf570$export$8fbbfd65594f46a0 = void 0;
const $ecc2b04811ebf570$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $ecc2b04811ebf570$var$formatRelative = (token, _date, _baseDate, _options)=>$ecc2b04811ebf570$var$formatRelativeLocale[token];
$ecc2b04811ebf570$export$8fbbfd65594f46a0 = $ecc2b04811ebf570$var$formatRelative;

});

parcelRegister("dLL6K", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a06434c3bfb2f22f$export$b3bd0bc58e36cd63; }, function (v) { return $a06434c3bfb2f22f$export$b3bd0bc58e36cd63 = v; });
var $a06434c3bfb2f22f$export$b3bd0bc58e36cd63;
"use strict";
$a06434c3bfb2f22f$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $a06434c3bfb2f22f$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf6re Kristus",
        "efter Kristus"
    ]
};
const $a06434c3bfb2f22f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1:a kvartalet",
        "2:a kvartalet",
        "3:e kvartalet",
        "4:e kvartalet"
    ]
};
const $a06434c3bfb2f22f$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "maj",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $a06434c3bfb2f22f$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf6",
        "m\xe5",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        "tis",
        "ons",
        "tors",
        "fre",
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
const $a06434c3bfb2f22f$var$dayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "morg.",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    abbreviated: {
        am: "f.m.",
        pm: "e.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: "eftermiddag",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "eftermiddag",
        evening: "kv\xe4ll",
        night: "natt"
    }
};
const $a06434c3bfb2f22f$var$formattingDayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
const $a06434c3bfb2f22f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ":a";
    }
    return number + ":e";
};
const $a06434c3bfb2f22f$var$localize = $a06434c3bfb2f22f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a06434c3bfb2f22f$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $a06434c3bfb2f22f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $a06434c3bfb2f22f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $a06434c3bfb2f22f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $a06434c3bfb2f22f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $a06434c3bfb2f22f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a06434c3bfb2f22f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("1R3bc", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $159d35131ebfc7fd$export$4659b591c19bdf3d; }, function (v) { return $159d35131ebfc7fd$export$4659b591c19bdf3d = v; });
var $159d35131ebfc7fd$export$4659b591c19bdf3d;
"use strict";
$159d35131ebfc7fd$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $159d35131ebfc7fd$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
const $159d35131ebfc7fd$var$parseOrdinalNumberPattern = /\d+/i;
const $159d35131ebfc7fd$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
const $159d35131ebfc7fd$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
const $159d35131ebfc7fd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
const $159d35131ebfc7fd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $159d35131ebfc7fd$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
const $159d35131ebfc7fd$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $159d35131ebfc7fd$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
const $159d35131ebfc7fd$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $159d35131ebfc7fd$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
const $159d35131ebfc7fd$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
const $159d35131ebfc7fd$var$match = $159d35131ebfc7fd$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $159d35131ebfc7fd$var$matchOrdinalNumberPattern,
        parsePattern: $159d35131ebfc7fd$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $159d35131ebfc7fd$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $159d35131ebfc7fd$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $159d35131ebfc7fd$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $159d35131ebfc7fd$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $159d35131ebfc7fd$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $159d35131ebfc7fd$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $159d35131ebfc7fd$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $159d35131ebfc7fd$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $159d35131ebfc7fd$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $159d35131ebfc7fd$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("8ZBgL", function(module, exports) {

$parcel$export(module.exports, "ta", function () { return $68c0ee26ee5fffad$export$d4b02e284d602eb2; }, function (v) { return $68c0ee26ee5fffad$export$d4b02e284d602eb2 = v; });
var $68c0ee26ee5fffad$export$d4b02e284d602eb2;
"use strict";
$68c0ee26ee5fffad$export$d4b02e284d602eb2 = void 0;

var $4EC1Z = parcelRequire("4EC1Z");

var $fmKHo = parcelRequire("fmKHo");

var $ecZQn = parcelRequire("ecZQn");

var $39fmg = parcelRequire("39fmg");

var $jIC36 = parcelRequire("jIC36");
/**
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s](https://github.com/sibiraj-s)
 */ const $68c0ee26ee5fffad$var$ta = $68c0ee26ee5fffad$export$d4b02e284d602eb2 = {
    code: "ta",
    formatDistance: $4EC1Z.formatDistance,
    formatLong: $fmKHo.formatLong,
    formatRelative: $ecZQn.formatRelative,
    localize: $39fmg.localize,
    match: $jIC36.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("4EC1Z", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $3638660f1c51256b$export$2c14ff85d6318973; }, function (v) { return $3638660f1c51256b$export$2c14ff85d6318973 = v; });
var $3638660f1c51256b$export$2c14ff85d6318973;
"use strict";
$3638660f1c51256b$export$2c14ff85d6318973 = void 0;
function $3638660f1c51256b$var$isPluralType(val) {
    return val.one !== undefined;
}
const $3638660f1c51256b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
const $3638660f1c51256b$var$formatDistance = (token, count, options)=>{
    const tense = options?.addSuffix ? options.comparison && options.comparison > 0 ? "in" : "ago" : "default";
    const tokenValue = $3638660f1c51256b$var$formatDistanceLocale[token];
    if (!$3638660f1c51256b$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace("{{count}}", String(count));
};
$3638660f1c51256b$export$2c14ff85d6318973 = $3638660f1c51256b$var$formatDistance;

});

parcelRegister("fmKHo", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $b2fd22849ae8e660$export$cbf60ecb96cbb82f; }, function (v) { return $b2fd22849ae8e660$export$cbf60ecb96cbb82f = v; });
var $b2fd22849ae8e660$export$cbf60ecb96cbb82f;
"use strict";
$b2fd22849ae8e660$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
// CLDR #1846 - #1849
const $b2fd22849ae8e660$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "d/M/yy"
};
// CLDR #1850 - #1853
const $b2fd22849ae8e660$var$timeFormats = {
    full: "a h:mm:ss zzzz",
    long: "a h:mm:ss z",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $b2fd22849ae8e660$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $b2fd22849ae8e660$var$formatLong = $b2fd22849ae8e660$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $b2fd22849ae8e660$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $b2fd22849ae8e660$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $b2fd22849ae8e660$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("ecZQn", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a582289182e524f2$export$8fbbfd65594f46a0; }, function (v) { return $a582289182e524f2$export$8fbbfd65594f46a0 = v; });
var $a582289182e524f2$export$8fbbfd65594f46a0;
"use strict";
$a582289182e524f2$export$8fbbfd65594f46a0 = void 0;
const $a582289182e524f2$var$formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: "P"
};
const $a582289182e524f2$var$formatRelative = (token, _date, _baseDate, _options)=>$a582289182e524f2$var$formatRelativeLocale[token];
$a582289182e524f2$export$8fbbfd65594f46a0 = $a582289182e524f2$var$formatRelative;

});

parcelRegister("39fmg", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $24ae202c98b01126$export$b3bd0bc58e36cd63; }, function (v) { return $24ae202c98b01126$export$b3bd0bc58e36cd63 = v; });
var $24ae202c98b01126$export$b3bd0bc58e36cd63;
"use strict";
$24ae202c98b01126$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
const $24ae202c98b01126$var$eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ]
};
const $24ae202c98b01126$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
const $24ae202c98b01126$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD"
    ]
};
const $24ae202c98b01126$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        "\u0B9A\u0BA9\u0BBF"
    ]
};
// CLDR #1780 - #1845
const $24ae202c98b01126$var$dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
const $24ae202c98b01126$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
const $24ae202c98b01126$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $24ae202c98b01126$var$localize = $24ae202c98b01126$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $24ae202c98b01126$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $24ae202c98b01126$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $24ae202c98b01126$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $24ae202c98b01126$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $24ae202c98b01126$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $24ae202c98b01126$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $24ae202c98b01126$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("jIC36", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e5afa425e3126cb1$export$4659b591c19bdf3d; }, function (v) { return $e5afa425e3126cb1$export$4659b591c19bdf3d = v; });
var $e5afa425e3126cb1$export$4659b591c19bdf3d;
"use strict";
$e5afa425e3126cb1$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $e5afa425e3126cb1$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
const $e5afa425e3126cb1$var$parseOrdinalNumberPattern = /\d+/i;
const $e5afa425e3126cb1$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
const $e5afa425e3126cb1$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
const $e5afa425e3126cb1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
const $e5afa425e3126cb1$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
const $e5afa425e3126cb1$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
const $e5afa425e3126cb1$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
const $e5afa425e3126cb1$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
const $e5afa425e3126cb1$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
const $e5afa425e3126cb1$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
const $e5afa425e3126cb1$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
const $e5afa425e3126cb1$var$match = $e5afa425e3126cb1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $e5afa425e3126cb1$var$matchOrdinalNumberPattern,
        parsePattern: $e5afa425e3126cb1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e5afa425e3126cb1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e5afa425e3126cb1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e5afa425e3126cb1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e5afa425e3126cb1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e5afa425e3126cb1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e5afa425e3126cb1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e5afa425e3126cb1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e5afa425e3126cb1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $e5afa425e3126cb1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e5afa425e3126cb1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("lWxDa", function(module, exports) {

$parcel$export(module.exports, "te", function () { return $ff991a20241edc16$export$dfb0c08939807f45; }, function (v) { return $ff991a20241edc16$export$dfb0c08939807f45 = v; });
var $ff991a20241edc16$export$dfb0c08939807f45;
"use strict";
$ff991a20241edc16$export$dfb0c08939807f45 = void 0;

var $k5x7v = parcelRequire("k5x7v");

var $8KHbx = parcelRequire("8KHbx");

var $9u3jJ = parcelRequire("9u3jJ");

var $c8SNe = parcelRequire("c8SNe");

var $7TBgm = parcelRequire("7TBgm");
/**
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum](https://github.com/kranthilakum)
 */ const $ff991a20241edc16$var$te = $ff991a20241edc16$export$dfb0c08939807f45 = {
    code: "te",
    formatDistance: $k5x7v.formatDistance,
    formatLong: $8KHbx.formatLong,
    formatRelative: $9u3jJ.formatRelative,
    localize: $c8SNe.localize,
    match: $7TBgm.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("k5x7v", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $e9fdf73e1649b203$export$2c14ff85d6318973; }, function (v) { return $e9fdf73e1649b203$export$2c14ff85d6318973 = v; });
var $e9fdf73e1649b203$export$2c14ff85d6318973;
"use strict";
$e9fdf73e1649b203$export$2c14ff85d6318973 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
const $e9fdf73e1649b203$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
const $e9fdf73e1649b203$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = options?.addSuffix ? $e9fdf73e1649b203$var$formatDistanceLocale[token].withPreposition : $e9fdf73e1649b203$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
$e9fdf73e1649b203$export$2c14ff85d6318973 = $e9fdf73e1649b203$var$formatDistance;

});

parcelRegister("8KHbx", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $65f41e418556f6a9$export$cbf60ecb96cbb82f; }, function (v) { return $65f41e418556f6a9$export$cbf60ecb96cbb82f = v; });
var $65f41e418556f6a9$export$cbf60ecb96cbb82f;
"use strict";
$65f41e418556f6a9$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
// CLDR #1807 - #1811
const $65f41e418556f6a9$var$dateFormats = {
    full: "d, MMMM y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd-MM-yy"
};
// CLDR #1807 - #1811
const $65f41e418556f6a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
// CLDR #1815 - #1818
const $65f41e418556f6a9$var$dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $65f41e418556f6a9$var$formatLong = $65f41e418556f6a9$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $65f41e418556f6a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $65f41e418556f6a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $65f41e418556f6a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9u3jJ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6e797d2269cc74d6$export$8fbbfd65594f46a0; }, function (v) { return $6e797d2269cc74d6$export$8fbbfd65594f46a0 = v; });
var $6e797d2269cc74d6$export$8fbbfd65594f46a0;
"use strict";
$6e797d2269cc74d6$export$8fbbfd65594f46a0 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
const $6e797d2269cc74d6$var$formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    other: "P"
};
const $6e797d2269cc74d6$var$formatRelative = (token, _date, _baseDate, _options)=>$6e797d2269cc74d6$var$formatRelativeLocale[token];
$6e797d2269cc74d6$export$8fbbfd65594f46a0 = $6e797d2269cc74d6$var$formatRelative;

});

parcelRegister("c8SNe", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $8d70bc260a4e6bd4$export$b3bd0bc58e36cd63; }, function (v) { return $8d70bc260a4e6bd4$export$b3bd0bc58e36cd63 = v; });
var $8d70bc260a4e6bd4$export$b3bd0bc58e36cd63;
"use strict";
$8d70bc260a4e6bd4$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
const $8d70bc260a4e6bd4$var$eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
const $8d70bc260a4e6bd4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
const $8d70bc260a4e6bd4$var$monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
const $8d70bc260a4e6bd4$var$dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
const $8d70bc260a4e6bd4$var$dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
const $8d70bc260a4e6bd4$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
const $8d70bc260a4e6bd4$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\u0C35";
};
const $8d70bc260a4e6bd4$var$localize = $8d70bc260a4e6bd4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8d70bc260a4e6bd4$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $8d70bc260a4e6bd4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $8d70bc260a4e6bd4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $8d70bc260a4e6bd4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $8d70bc260a4e6bd4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $8d70bc260a4e6bd4$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8d70bc260a4e6bd4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7TBgm", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5bfa93164bfb222a$export$4659b591c19bdf3d; }, function (v) { return $5bfa93164bfb222a$export$4659b591c19bdf3d = v; });
var $5bfa93164bfb222a$export$4659b591c19bdf3d;
"use strict";
$5bfa93164bfb222a$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $5bfa93164bfb222a$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
const $5bfa93164bfb222a$var$parseOrdinalNumberPattern = /\d+/i;
const $5bfa93164bfb222a$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
const $5bfa93164bfb222a$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
const $5bfa93164bfb222a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
const $5bfa93164bfb222a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $5bfa93164bfb222a$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
const $5bfa93164bfb222a$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
const $5bfa93164bfb222a$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
const $5bfa93164bfb222a$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
const $5bfa93164bfb222a$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
const $5bfa93164bfb222a$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
const $5bfa93164bfb222a$var$match = $5bfa93164bfb222a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $5bfa93164bfb222a$var$matchOrdinalNumberPattern,
        parsePattern: $5bfa93164bfb222a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bfa93164bfb222a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bfa93164bfb222a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bfa93164bfb222a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bfa93164bfb222a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bfa93164bfb222a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bfa93164bfb222a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bfa93164bfb222a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5bfa93164bfb222a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5bfa93164bfb222a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5bfa93164bfb222a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("3wqDe", function(module, exports) {

$parcel$export(module.exports, "th", function () { return $290904c1a0280c3f$export$d657bc098992a431; }, function (v) { return $290904c1a0280c3f$export$d657bc098992a431 = v; });
var $290904c1a0280c3f$export$d657bc098992a431;
"use strict";
$290904c1a0280c3f$export$d657bc098992a431 = void 0;

var $8Ruai = parcelRequire("8Ruai");

var $l5OU1 = parcelRequire("l5OU1");

var $5s3PI = parcelRequire("5s3PI");

var $h9YTt = parcelRequire("h9YTt");

var $cpl8s = parcelRequire("cpl8s");
/**
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat](https://github.com/athivvat)
 * @author [@hawkup](https://github.com/hawkup)
 * @author  Jirawat I. [@nodtem66](https://github.com/nodtem66)
 */ const $290904c1a0280c3f$var$th = $290904c1a0280c3f$export$d657bc098992a431 = {
    code: "th",
    formatDistance: $8Ruai.formatDistance,
    formatLong: $l5OU1.formatLong,
    formatRelative: $5s3PI.formatRelative,
    localize: $h9YTt.localize,
    match: $cpl8s.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("8Ruai", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $673aac1de53371b1$export$2c14ff85d6318973; }, function (v) { return $673aac1de53371b1$export$2c14ff85d6318973 = v; });
var $673aac1de53371b1$export$2c14ff85d6318973;
"use strict";
$673aac1de53371b1$export$2c14ff85d6318973 = void 0;
const $673aac1de53371b1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
const $673aac1de53371b1$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $673aac1de53371b1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === "halfAMinute") return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
$673aac1de53371b1$export$2c14ff85d6318973 = $673aac1de53371b1$var$formatDistance;

});

parcelRegister("l5OU1", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $f5b18cc74eebc7d7$export$cbf60ecb96cbb82f; }, function (v) { return $f5b18cc74eebc7d7$export$cbf60ecb96cbb82f = v; });
var $f5b18cc74eebc7d7$export$cbf60ecb96cbb82f;
"use strict";
$f5b18cc74eebc7d7$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $f5b18cc74eebc7d7$var$dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $f5b18cc74eebc7d7$var$timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
const $f5b18cc74eebc7d7$var$dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $f5b18cc74eebc7d7$var$formatLong = $f5b18cc74eebc7d7$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $f5b18cc74eebc7d7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $f5b18cc74eebc7d7$var$timeFormats,
        defaultWidth: "medium"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $f5b18cc74eebc7d7$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("5s3PI", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $3f828a7a8b10a736$export$8fbbfd65594f46a0; }, function (v) { return $3f828a7a8b10a736$export$8fbbfd65594f46a0 = v; });
var $3f828a7a8b10a736$export$8fbbfd65594f46a0;
"use strict";
$3f828a7a8b10a736$export$8fbbfd65594f46a0 = void 0;
const $3f828a7a8b10a736$var$formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: "P"
};
const $3f828a7a8b10a736$var$formatRelative = (token, _date, _baseDate, _options)=>$3f828a7a8b10a736$var$formatRelativeLocale[token];
$3f828a7a8b10a736$export$8fbbfd65594f46a0 = $3f828a7a8b10a736$var$formatRelative;

});

parcelRegister("h9YTt", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $c7e2832b5bf2a30a$export$b3bd0bc58e36cd63; }, function (v) { return $c7e2832b5bf2a30a$export$b3bd0bc58e36cd63 = v; });
var $c7e2832b5bf2a30a$export$b3bd0bc58e36cd63;
"use strict";
$c7e2832b5bf2a30a$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $c7e2832b5bf2a30a$var$eraValues = {
    narrow: [
        "B",
        "\u0E04\u0E28"
    ],
    abbreviated: [
        "BC",
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
const $c7e2832b5bf2a30a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
const $c7e2832b5bf2a30a$var$dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
const $c7e2832b5bf2a30a$var$monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
const $c7e2832b5bf2a30a$var$dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
const $c7e2832b5bf2a30a$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
const $c7e2832b5bf2a30a$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $c7e2832b5bf2a30a$var$localize = $c7e2832b5bf2a30a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $c7e2832b5bf2a30a$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $c7e2832b5bf2a30a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $c7e2832b5bf2a30a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $c7e2832b5bf2a30a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $c7e2832b5bf2a30a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $c7e2832b5bf2a30a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c7e2832b5bf2a30a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("cpl8s", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $908836e5c1fee45e$export$4659b591c19bdf3d; }, function (v) { return $908836e5c1fee45e$export$4659b591c19bdf3d = v; });
var $908836e5c1fee45e$export$4659b591c19bdf3d;
"use strict";
$908836e5c1fee45e$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $908836e5c1fee45e$var$matchOrdinalNumberPattern = /^\d+/i;
const $908836e5c1fee45e$var$parseOrdinalNumberPattern = /\d+/i;
const $908836e5c1fee45e$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
const $908836e5c1fee45e$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
const $908836e5c1fee45e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
const $908836e5c1fee45e$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
const $908836e5c1fee45e$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
const $908836e5c1fee45e$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
const $908836e5c1fee45e$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
const $908836e5c1fee45e$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
const $908836e5c1fee45e$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
const $908836e5c1fee45e$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
const $908836e5c1fee45e$var$match = $908836e5c1fee45e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $908836e5c1fee45e$var$matchOrdinalNumberPattern,
        parsePattern: $908836e5c1fee45e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $908836e5c1fee45e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $908836e5c1fee45e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $908836e5c1fee45e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $908836e5c1fee45e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $908836e5c1fee45e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $908836e5c1fee45e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $908836e5c1fee45e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $908836e5c1fee45e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $908836e5c1fee45e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $908836e5c1fee45e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("78uUV", function(module, exports) {

$parcel$export(module.exports, "tr", function () { return $5321433f230a3d22$export$72451b88a72ad9c2; }, function (v) { return $5321433f230a3d22$export$72451b88a72ad9c2 = v; });
var $5321433f230a3d22$export$72451b88a72ad9c2;
"use strict";
$5321433f230a3d22$export$72451b88a72ad9c2 = void 0;

var $bP6zP = parcelRequire("bP6zP");

var $dg3a6 = parcelRequire("dg3a6");

var $9qg4a = parcelRequire("9qg4a");

var $6ya1E = parcelRequire("6ya1E");

var $h6uqi = parcelRequire("h6uqi");
/**
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin](https://github.com/alpcanaydin)
 * @author Berkay Sargın [@berkaey](https://github.com/berkaey)
 * @author Fatih Bulut [@bulutfatih](https://github.com/bulutfatih)
 * @author Ismail Demirbilek [@dbtek](https://github.com/dbtek)
 * @author İsmail Kayar [@ikayar](https://github.com/ikayar)
 *
 *
 */ const $5321433f230a3d22$var$tr = $5321433f230a3d22$export$72451b88a72ad9c2 = {
    code: "tr",
    formatDistance: $bP6zP.formatDistance,
    formatLong: $dg3a6.formatLong,
    formatRelative: $9qg4a.formatRelative,
    localize: $6ya1E.localize,
    match: $h6uqi.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("bP6zP", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $89b98f26efe72352$export$2c14ff85d6318973; }, function (v) { return $89b98f26efe72352$export$2c14ff85d6318973 = v; });
var $89b98f26efe72352$export$2c14ff85d6318973;
"use strict";
$89b98f26efe72352$export$2c14ff85d6318973 = void 0;
const $89b98f26efe72352$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniyeden az",
        other: "{{count}} saniyeden az"
    },
    xSeconds: {
        one: "1 saniye",
        other: "{{count}} saniye"
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: "bir dakikadan az",
        other: "{{count}} dakikadan az"
    },
    xMinutes: {
        one: "1 dakika",
        other: "{{count}} dakika"
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
const $89b98f26efe72352$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $89b98f26efe72352$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \xf6nce";
    }
    return result;
};
$89b98f26efe72352$export$2c14ff85d6318973 = $89b98f26efe72352$var$formatDistance;

});

parcelRegister("dg3a6", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $9a6f38e4400dfdd0$export$cbf60ecb96cbb82f; }, function (v) { return $9a6f38e4400dfdd0$export$cbf60ecb96cbb82f = v; });
var $9a6f38e4400dfdd0$export$cbf60ecb96cbb82f;
"use strict";
$9a6f38e4400dfdd0$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $9a6f38e4400dfdd0$var$dateFormats = {
    full: "d MMMM y EEEE",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.yyyy"
};
const $9a6f38e4400dfdd0$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $9a6f38e4400dfdd0$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $9a6f38e4400dfdd0$var$formatLong = $9a6f38e4400dfdd0$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $9a6f38e4400dfdd0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $9a6f38e4400dfdd0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $9a6f38e4400dfdd0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9qg4a", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $6dc3012cc355df48$export$8fbbfd65594f46a0; }, function (v) { return $6dc3012cc355df48$export$8fbbfd65594f46a0 = v; });
var $6dc3012cc355df48$export$8fbbfd65594f46a0;
"use strict";
$6dc3012cc355df48$export$8fbbfd65594f46a0 = void 0;
const $6dc3012cc355df48$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: "P"
};
const $6dc3012cc355df48$var$formatRelative = (token, _date, _baseDate, _options)=>$6dc3012cc355df48$var$formatRelativeLocale[token];
$6dc3012cc355df48$export$8fbbfd65594f46a0 = $6dc3012cc355df48$var$formatRelative;

});

parcelRegister("6ya1E", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $4c4db1f51db943ed$export$b3bd0bc58e36cd63; }, function (v) { return $4c4db1f51db943ed$export$b3bd0bc58e36cd63 = v; });
var $4c4db1f51db943ed$export$b3bd0bc58e36cd63;
"use strict";
$4c4db1f51db943ed$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $4c4db1f51db943ed$var$eraValues = {
    narrow: [
        "M\xd6",
        "MS"
    ],
    abbreviated: [
        "M\xd6",
        "MS"
    ],
    wide: [
        "Milattan \xd6nce",
        "Milattan Sonra"
    ]
};
const $4c4db1f51db943ed$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
const $4c4db1f51db943ed$var$monthValues = {
    narrow: [
        "O",
        "\u015E",
        "M",
        "N",
        "M",
        "H",
        "T",
        "A",
        "E",
        "E",
        "K",
        "A"
    ],
    abbreviated: [
        "Oca",
        "\u015Eub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "A\u011Fu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara"
    ],
    wide: [
        "Ocak",
        "\u015Eubat",
        "Mart",
        "Nisan",
        "May\u0131s",
        "Haziran",
        "Temmuz",
        "A\u011Fustos",
        "Eyl\xfcl",
        "Ekim",
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
const $4c4db1f51db943ed$var$dayValues = {
    narrow: [
        "P",
        "P",
        "S",
        "\xc7",
        "P",
        "C",
        "C"
    ],
    short: [
        "Pz",
        "Pt",
        "Sa",
        "\xc7a",
        "Pe",
        "Cu",
        "Ct"
    ],
    abbreviated: [
        "Paz",
        "Pzt",
        "Sal",
        "\xc7ar",
        "Per",
        "Cum",
        "Cts"
    ],
    wide: [
        "Pazar",
        "Pazartesi",
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        "Cuma",
        "Cumartesi"
    ]
};
const $4c4db1f51db943ed$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    }
};
const $4c4db1f51db943ed$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    }
};
const $4c4db1f51db943ed$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $4c4db1f51db943ed$var$localize = $4c4db1f51db943ed$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $4c4db1f51db943ed$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $4c4db1f51db943ed$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $4c4db1f51db943ed$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $4c4db1f51db943ed$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $4c4db1f51db943ed$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $4c4db1f51db943ed$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $4c4db1f51db943ed$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("h6uqi", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $c73a989ef9585390$export$4659b591c19bdf3d; }, function (v) { return $c73a989ef9585390$export$4659b591c19bdf3d = v; });
var $c73a989ef9585390$export$4659b591c19bdf3d;
"use strict";
$c73a989ef9585390$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $c73a989ef9585390$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $c73a989ef9585390$var$parseOrdinalNumberPattern = /\d+/i;
const $c73a989ef9585390$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
const $c73a989ef9585390$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
const $c73a989ef9585390$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
const $c73a989ef9585390$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
const $c73a989ef9585390$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
const $c73a989ef9585390$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
const $c73a989ef9585390$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
const $c73a989ef9585390$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
const $c73a989ef9585390$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
const $c73a989ef9585390$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
const $c73a989ef9585390$var$match = $c73a989ef9585390$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $c73a989ef9585390$var$matchOrdinalNumberPattern,
        parsePattern: $c73a989ef9585390$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c73a989ef9585390$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c73a989ef9585390$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c73a989ef9585390$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c73a989ef9585390$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c73a989ef9585390$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c73a989ef9585390$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c73a989ef9585390$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c73a989ef9585390$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $c73a989ef9585390$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c73a989ef9585390$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("c70JZ", function(module, exports) {

$parcel$export(module.exports, "ug", function () { return $8d16b6925dabcf78$export$9ba1309004beb64a; }, function (v) { return $8d16b6925dabcf78$export$9ba1309004beb64a = v; });
var $8d16b6925dabcf78$export$9ba1309004beb64a;
"use strict";
$8d16b6925dabcf78$export$9ba1309004beb64a = void 0;

var $7qgQw = parcelRequire("7qgQw");

var $8LjqH = parcelRequire("8LjqH");

var $4LAz8 = parcelRequire("4LAz8");

var $9AV8S = parcelRequire("9AV8S");

var $2ArqK = parcelRequire("2ArqK");
/**
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly](https://github.com/abduwaly)
 */ const $8d16b6925dabcf78$var$ug = $8d16b6925dabcf78$export$9ba1309004beb64a = {
    code: "ug",
    formatDistance: $7qgQw.formatDistance,
    formatLong: $8LjqH.formatLong,
    formatRelative: $4LAz8.formatRelative,
    localize: $9AV8S.localize,
    match: $2ArqK.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("7qgQw", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $567807652683a8cd$export$2c14ff85d6318973; }, function (v) { return $567807652683a8cd$export$2c14ff85d6318973 = v; });
var $567807652683a8cd$export$2c14ff85d6318973;
"use strict";
$567807652683a8cd$export$2c14ff85d6318973 = void 0;
const $567807652683a8cd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
const $567807652683a8cd$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $567807652683a8cd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
$567807652683a8cd$export$2c14ff85d6318973 = $567807652683a8cd$var$formatDistance;

});

parcelRegister("8LjqH", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $6611c8d1f3769a0c$export$cbf60ecb96cbb82f; }, function (v) { return $6611c8d1f3769a0c$export$cbf60ecb96cbb82f = v; });
var $6611c8d1f3769a0c$export$cbf60ecb96cbb82f;
"use strict";
$6611c8d1f3769a0c$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $6611c8d1f3769a0c$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $6611c8d1f3769a0c$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $6611c8d1f3769a0c$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6611c8d1f3769a0c$var$formatLong = $6611c8d1f3769a0c$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $6611c8d1f3769a0c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $6611c8d1f3769a0c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $6611c8d1f3769a0c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("4LAz8", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $3787ea6a97623f6b$export$8fbbfd65594f46a0; }, function (v) { return $3787ea6a97623f6b$export$8fbbfd65594f46a0 = v; });
var $3787ea6a97623f6b$export$8fbbfd65594f46a0;
"use strict";
$3787ea6a97623f6b$export$8fbbfd65594f46a0 = void 0;
const $3787ea6a97623f6b$var$formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: "P"
};
const $3787ea6a97623f6b$var$formatRelative = (token, _date, _baseDate, _options)=>$3787ea6a97623f6b$var$formatRelativeLocale[token];
$3787ea6a97623f6b$export$8fbbfd65594f46a0 = $3787ea6a97623f6b$var$formatRelative;

});

parcelRegister("9AV8S", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6fc3cd1bc697fcd7$export$b3bd0bc58e36cd63; }, function (v) { return $6fc3cd1bc697fcd7$export$b3bd0bc58e36cd63 = v; });
var $6fc3cd1bc697fcd7$export$b3bd0bc58e36cd63;
"use strict";
$6fc3cd1bc697fcd7$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $6fc3cd1bc697fcd7$var$eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
const $6fc3cd1bc697fcd7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1",
        "2",
        "3",
        "4"
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $6fc3cd1bc697fcd7$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
const $6fc3cd1bc697fcd7$var$dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
const $6fc3cd1bc697fcd7$var$dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
const $6fc3cd1bc697fcd7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
const $6fc3cd1bc697fcd7$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $6fc3cd1bc697fcd7$var$localize = $6fc3cd1bc697fcd7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6fc3cd1bc697fcd7$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $6fc3cd1bc697fcd7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $6fc3cd1bc697fcd7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $6fc3cd1bc697fcd7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $6fc3cd1bc697fcd7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $6fc3cd1bc697fcd7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6fc3cd1bc697fcd7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("2ArqK", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $1e2438a88b55a996$export$4659b591c19bdf3d; }, function (v) { return $1e2438a88b55a996$export$4659b591c19bdf3d = v; });
var $1e2438a88b55a996$export$4659b591c19bdf3d;
"use strict";
$1e2438a88b55a996$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $1e2438a88b55a996$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $1e2438a88b55a996$var$parseOrdinalNumberPattern = /\d+/i;
const $1e2438a88b55a996$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
const $1e2438a88b55a996$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
const $1e2438a88b55a996$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
const $1e2438a88b55a996$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $1e2438a88b55a996$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
const $1e2438a88b55a996$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
const $1e2438a88b55a996$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
const $1e2438a88b55a996$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
const $1e2438a88b55a996$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
const $1e2438a88b55a996$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
const $1e2438a88b55a996$var$match = $1e2438a88b55a996$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $1e2438a88b55a996$var$matchOrdinalNumberPattern,
        parsePattern: $1e2438a88b55a996$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1e2438a88b55a996$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1e2438a88b55a996$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1e2438a88b55a996$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1e2438a88b55a996$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1e2438a88b55a996$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1e2438a88b55a996$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1e2438a88b55a996$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1e2438a88b55a996$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1e2438a88b55a996$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1e2438a88b55a996$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("d9K5W", function(module, exports) {

$parcel$export(module.exports, "uk", function () { return $993fdf1895e35d5d$export$312745a8a3013c00; }, function (v) { return $993fdf1895e35d5d$export$312745a8a3013c00 = v; });
var $993fdf1895e35d5d$export$312745a8a3013c00;
"use strict";
$993fdf1895e35d5d$export$312745a8a3013c00 = void 0;

var $3lgam = parcelRequire("3lgam");

var $ltUUJ = parcelRequire("ltUUJ");

var $zyRjE = parcelRequire("zyRjE");

var $3YJSJ = parcelRequire("3YJSJ");

var $a0hYQ = parcelRequire("a0hYQ");
/**
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk](https://github.com/korzhyk)
 * @author Andriy Shcherbyak [@shcherbyakdev](https://github.com/shcherbyakdev)
 */ const $993fdf1895e35d5d$var$uk = $993fdf1895e35d5d$export$312745a8a3013c00 = {
    code: "uk",
    formatDistance: $3lgam.formatDistance,
    formatLong: $ltUUJ.formatLong,
    formatRelative: $zyRjE.formatRelative,
    localize: $3YJSJ.localize,
    match: $a0hYQ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("3lgam", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $26efdf7e0a1475b2$export$2c14ff85d6318973; }, function (v) { return $26efdf7e0a1475b2$export$2c14ff85d6318973 = v; });
var $26efdf7e0a1475b2$export$2c14ff85d6318973;
"use strict";
$26efdf7e0a1475b2$export$2c14ff85d6318973 = void 0;
function $26efdf7e0a1475b2$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $26efdf7e0a1475b2$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $26efdf7e0a1475b2$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $26efdf7e0a1475b2$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $26efdf7e0a1475b2$var$declension(scheme.past, count);
                else return $26efdf7e0a1475b2$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $26efdf7e0a1475b2$var$declension(scheme.regular, count);
    };
}
const $26efdf7e0a1475b2$var$halfAtMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
const $26efdf7e0a1475b2$var$formatDistanceLocale = {
    lessThanXSeconds: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $26efdf7e0a1475b2$var$halfAtMinute,
    lessThanXMinutes: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $26efdf7e0a1475b2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
const $26efdf7e0a1475b2$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $26efdf7e0a1475b2$var$formatDistanceLocale[token](count, options);
};
$26efdf7e0a1475b2$export$2c14ff85d6318973 = $26efdf7e0a1475b2$var$formatDistance;

});

parcelRegister("ltUUJ", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $fa38745df33a173f$export$cbf60ecb96cbb82f; }, function (v) { return $fa38745df33a173f$export$cbf60ecb96cbb82f = v; });
var $fa38745df33a173f$export$cbf60ecb96cbb82f;
"use strict";
$fa38745df33a173f$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $fa38745df33a173f$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: "dd.MM.y"
};
const $fa38745df33a173f$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $fa38745df33a173f$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $fa38745df33a173f$var$formatLong = $fa38745df33a173f$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa38745df33a173f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa38745df33a173f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa38745df33a173f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("zyRjE", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $06ae4f41dd684496$export$8fbbfd65594f46a0; }, function (v) { return $06ae4f41dd684496$export$8fbbfd65594f46a0 = v; });
var $06ae4f41dd684496$export$8fbbfd65594f46a0;
"use strict";
$06ae4f41dd684496$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");

var $2ZADR = parcelRequire("2ZADR");
const $06ae4f41dd684496$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $06ae4f41dd684496$var$lastWeek(day) {
    const weekday = $06ae4f41dd684496$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $06ae4f41dd684496$var$thisWeek(day) {
    const weekday = $06ae4f41dd684496$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $06ae4f41dd684496$var$nextWeek(day) {
    const weekday = $06ae4f41dd684496$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
const $06ae4f41dd684496$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $2ZADR.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $06ae4f41dd684496$var$thisWeek(day);
    else return $06ae4f41dd684496$var$lastWeek(day);
};
const $06ae4f41dd684496$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $2ZADR.toDate)(dirtyDate);
    const day = date.getDay();
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return $06ae4f41dd684496$var$thisWeek(day);
    else return $06ae4f41dd684496$var$nextWeek(day);
};
const $06ae4f41dd684496$var$formatRelativeLocale = {
    lastWeek: $06ae4f41dd684496$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $06ae4f41dd684496$var$nextWeekFormat,
    other: "P"
};
const $06ae4f41dd684496$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $06ae4f41dd684496$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$06ae4f41dd684496$export$8fbbfd65594f46a0 = $06ae4f41dd684496$var$formatRelative;

});

parcelRegister("3YJSJ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $2e5a90d8502016c4$export$b3bd0bc58e36cd63; }, function (v) { return $2e5a90d8502016c4$export$b3bd0bc58e36cd63 = v; });
var $2e5a90d8502016c4$export$b3bd0bc58e36cd63;
"use strict";
$2e5a90d8502016c4$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $2e5a90d8502016c4$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
const $2e5a90d8502016c4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $2e5a90d8502016c4$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
const $2e5a90d8502016c4$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
const $2e5a90d8502016c4$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $2e5a90d8502016c4$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
const $2e5a90d8502016c4$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
const $2e5a90d8502016c4$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    if (unit === "date") {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === "minute" || unit === "second" || unit === "hour") suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
const $2e5a90d8502016c4$var$localize = $2e5a90d8502016c4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2e5a90d8502016c4$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $2e5a90d8502016c4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $2e5a90d8502016c4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $2e5a90d8502016c4$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $2e5a90d8502016c4$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $2e5a90d8502016c4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $2e5a90d8502016c4$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $2e5a90d8502016c4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("a0hYQ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $7487d9fe11f0f391$export$4659b591c19bdf3d; }, function (v) { return $7487d9fe11f0f391$export$4659b591c19bdf3d = v; });
var $7487d9fe11f0f391$export$4659b591c19bdf3d;
"use strict";
$7487d9fe11f0f391$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $7487d9fe11f0f391$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
const $7487d9fe11f0f391$var$parseOrdinalNumberPattern = /\d+/i;
const $7487d9fe11f0f391$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
const $7487d9fe11f0f391$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $7487d9fe11f0f391$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
const $7487d9fe11f0f391$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7487d9fe11f0f391$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
const $7487d9fe11f0f391$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
const $7487d9fe11f0f391$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
const $7487d9fe11f0f391$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
const $7487d9fe11f0f391$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
const $7487d9fe11f0f391$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $7487d9fe11f0f391$var$match = $7487d9fe11f0f391$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $7487d9fe11f0f391$var$matchOrdinalNumberPattern,
        parsePattern: $7487d9fe11f0f391$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $7487d9fe11f0f391$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7487d9fe11f0f391$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $7487d9fe11f0f391$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7487d9fe11f0f391$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $7487d9fe11f0f391$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7487d9fe11f0f391$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $7487d9fe11f0f391$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7487d9fe11f0f391$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $7487d9fe11f0f391$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7487d9fe11f0f391$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("1pTle", function(module, exports) {

$parcel$export(module.exports, "uz", function () { return $10830dec5e43be9f$export$461e3962c82dff4f; }, function (v) { return $10830dec5e43be9f$export$461e3962c82dff4f = v; });
var $10830dec5e43be9f$export$461e3962c82dff4f;
"use strict";
$10830dec5e43be9f$export$461e3962c82dff4f = void 0;

var $h8R3G = parcelRequire("h8R3G");

var $luvGc = parcelRequire("luvGc");

var $fD86l = parcelRequire("fD86l");

var $gfRvN = parcelRequire("gfRvN");

var $e4Abm = parcelRequire("e4Abm");
/**
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali](https://github.com/Mukhammadali)
 */ const $10830dec5e43be9f$var$uz = $10830dec5e43be9f$export$461e3962c82dff4f = {
    code: "uz",
    formatDistance: $h8R3G.formatDistance,
    formatLong: $luvGc.formatLong,
    formatRelative: $fD86l.formatRelative,
    localize: $gfRvN.localize,
    match: $e4Abm.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("h8R3G", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $c7ac5752227f34e1$export$2c14ff85d6318973; }, function (v) { return $c7ac5752227f34e1$export$2c14ff85d6318973 = v; });
var $c7ac5752227f34e1$export$2c14ff85d6318973;
"use strict";
$c7ac5752227f34e1$export$2c14ff85d6318973 = void 0;
const $c7ac5752227f34e1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "sekunddan kam",
        other: "{{count}} sekunddan kam"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "yarim minut",
    lessThanXMinutes: {
        one: "bir minutdan kam",
        other: "{{count}} minutdan kam"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: "tahminan 1 soat",
        other: "tahminan {{count}} soat"
    },
    xHours: {
        one: "1 soat",
        other: "{{count}} soat"
    },
    xDays: {
        one: "1 kun",
        other: "{{count}} kun"
    },
    aboutXWeeks: {
        one: "tahminan 1 hafta",
        other: "tahminan {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "tahminan 1 oy",
        other: "tahminan {{count}} oy"
    },
    xMonths: {
        one: "1 oy",
        other: "{{count}} oy"
    },
    aboutXYears: {
        one: "tahminan 1 yil",
        other: "tahminan {{count}} yil"
    },
    xYears: {
        one: "1 yil",
        other: "{{count}} yil"
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: "deyarli 1 yil",
        other: "deyarli {{count}} yil"
    }
};
const $c7ac5752227f34e1$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c7ac5752227f34e1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " dan keyin";
        else return result + " oldin";
    }
    return result;
};
$c7ac5752227f34e1$export$2c14ff85d6318973 = $c7ac5752227f34e1$var$formatDistance;

});

parcelRegister("luvGc", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $fa54f93ff052fa0d$export$cbf60ecb96cbb82f; }, function (v) { return $fa54f93ff052fa0d$export$cbf60ecb96cbb82f = v; });
var $fa54f93ff052fa0d$export$cbf60ecb96cbb82f;
"use strict";
$fa54f93ff052fa0d$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $fa54f93ff052fa0d$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $fa54f93ff052fa0d$var$timeFormats = {
    full: "h:mm:ss zzzz",
    long: "h:mm:ss z",
    medium: "h:mm:ss",
    short: "h:mm"
};
const $fa54f93ff052fa0d$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $fa54f93ff052fa0d$var$formatLong = $fa54f93ff052fa0d$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa54f93ff052fa0d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa54f93ff052fa0d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $fa54f93ff052fa0d$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("fD86l", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b610c84690ac0875$export$8fbbfd65594f46a0; }, function (v) { return $b610c84690ac0875$export$8fbbfd65594f46a0 = v; });
var $b610c84690ac0875$export$8fbbfd65594f46a0;
"use strict";
$b610c84690ac0875$export$8fbbfd65594f46a0 = void 0;
const $b610c84690ac0875$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: "P"
};
const $b610c84690ac0875$var$formatRelative = (token, _date, _baseDate, _options)=>$b610c84690ac0875$var$formatRelativeLocale[token];
$b610c84690ac0875$export$8fbbfd65594f46a0 = $b610c84690ac0875$var$formatRelative;

});

parcelRegister("gfRvN", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $bd578e5f5bc5f434$export$b3bd0bc58e36cd63; }, function (v) { return $bd578e5f5bc5f434$export$b3bd0bc58e36cd63 = v; });
var $bd578e5f5bc5f434$export$b3bd0bc58e36cd63;
"use strict";
$bd578e5f5bc5f434$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $bd578e5f5bc5f434$var$eraValues = {
    narrow: [
        "M.A",
        "M."
    ],
    abbreviated: [
        "M.A",
        "M."
    ],
    wide: [
        "Miloddan Avvalgi",
        "Milodiy"
    ]
};
const $bd578e5f5bc5f434$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "CH.1",
        "CH.2",
        "CH.3",
        "CH.4"
    ],
    wide: [
        "1-chi chorak",
        "2-chi chorak",
        "3-chi chorak",
        "4-chi chorak"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $bd578e5f5bc5f434$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "Iyun",
        "Iyul",
        "Avg",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "Iyun",
        "Iyul",
        "Avgust",
        "Sentabr",
        "Oktabr",
        "Noyabr",
        "Dekabr"
    ]
};
const $bd578e5f5bc5f434$var$dayValues = {
    narrow: [
        "Y",
        "D",
        "S",
        "CH",
        "P",
        "J",
        "SH"
    ],
    short: [
        "Ya",
        "Du",
        "Se",
        "Cho",
        "Pa",
        "Ju",
        "Sha"
    ],
    abbreviated: [
        "Yak",
        "Dush",
        "Sesh",
        "Chor",
        "Pay",
        "Jum",
        "Shan"
    ],
    wide: [
        "Yakshanba",
        "Dushanba",
        "Seshanba",
        "Chorshanba",
        "Payshanba",
        "Juma",
        "Shanba"
    ]
};
const $bd578e5f5bc5f434$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
const $bd578e5f5bc5f434$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
const $bd578e5f5bc5f434$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $bd578e5f5bc5f434$var$localize = $bd578e5f5bc5f434$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bd578e5f5bc5f434$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $bd578e5f5bc5f434$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $bd578e5f5bc5f434$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $bd578e5f5bc5f434$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $bd578e5f5bc5f434$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $bd578e5f5bc5f434$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bd578e5f5bc5f434$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("e4Abm", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $a3ed8170461c6a17$export$4659b591c19bdf3d; }, function (v) { return $a3ed8170461c6a17$export$4659b591c19bdf3d = v; });
var $a3ed8170461c6a17$export$4659b591c19bdf3d;
"use strict";
$a3ed8170461c6a17$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $a3ed8170461c6a17$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
const $a3ed8170461c6a17$var$parseOrdinalNumberPattern = /\d+/i;
const $a3ed8170461c6a17$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
const $a3ed8170461c6a17$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $a3ed8170461c6a17$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
const $a3ed8170461c6a17$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a3ed8170461c6a17$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
const $a3ed8170461c6a17$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $a3ed8170461c6a17$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
const $a3ed8170461c6a17$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
const $a3ed8170461c6a17$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
const $a3ed8170461c6a17$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
const $a3ed8170461c6a17$var$match = $a3ed8170461c6a17$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $a3ed8170461c6a17$var$matchOrdinalNumberPattern,
        parsePattern: $a3ed8170461c6a17$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $a3ed8170461c6a17$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a3ed8170461c6a17$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $a3ed8170461c6a17$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a3ed8170461c6a17$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $a3ed8170461c6a17$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a3ed8170461c6a17$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $a3ed8170461c6a17$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a3ed8170461c6a17$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $a3ed8170461c6a17$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a3ed8170461c6a17$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("abAb5", function(module, exports) {

$parcel$export(module.exports, "uzCyrl", function () { return $76a6fe9f198b7863$export$fe32212c9efceff7; }, function (v) { return $76a6fe9f198b7863$export$fe32212c9efceff7 = v; });
var $76a6fe9f198b7863$export$fe32212c9efceff7;
"use strict";
$76a6fe9f198b7863$export$fe32212c9efceff7 = void 0;

var $fWz9h = parcelRequire("fWz9h");

var $38iFB = parcelRequire("38iFB");

var $6u690 = parcelRequire("6u690");

var $giAzJ = parcelRequire("giAzJ");

var $8fcXQ = parcelRequire("8fcXQ");
/**
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28](https://github.com/kamronbek28)
 */ const $76a6fe9f198b7863$var$uzCyrl = $76a6fe9f198b7863$export$fe32212c9efceff7 = {
    code: "uz-Cyrl",
    formatDistance: $fWz9h.formatDistance,
    formatLong: $38iFB.formatLong,
    formatRelative: $6u690.formatRelative,
    localize: $giAzJ.localize,
    match: $8fcXQ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("fWz9h", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $b9b789923bdcc69f$export$2c14ff85d6318973; }, function (v) { return $b9b789923bdcc69f$export$2c14ff85d6318973 = v; });
var $b9b789923bdcc69f$export$2c14ff85d6318973;
"use strict";
$b9b789923bdcc69f$export$2c14ff85d6318973 = void 0;
const $b9b789923bdcc69f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
const $b9b789923bdcc69f$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b9b789923bdcc69f$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
$b9b789923bdcc69f$export$2c14ff85d6318973 = $b9b789923bdcc69f$var$formatDistance;

});

parcelRegister("38iFB", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $248099ecb016f5d7$export$cbf60ecb96cbb82f; }, function (v) { return $248099ecb016f5d7$export$cbf60ecb96cbb82f = v; });
var $248099ecb016f5d7$export$cbf60ecb96cbb82f;
"use strict";
$248099ecb016f5d7$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $248099ecb016f5d7$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $248099ecb016f5d7$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $248099ecb016f5d7$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $248099ecb016f5d7$var$formatLong = $248099ecb016f5d7$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $248099ecb016f5d7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $248099ecb016f5d7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $248099ecb016f5d7$var$dateTimeFormats,
        defaultWidth: "any"
    })
};

});

parcelRegister("6u690", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $4b8a4f886e8dc6e4$export$8fbbfd65594f46a0; }, function (v) { return $4b8a4f886e8dc6e4$export$8fbbfd65594f46a0 = v; });
var $4b8a4f886e8dc6e4$export$8fbbfd65594f46a0;
"use strict";
$4b8a4f886e8dc6e4$export$8fbbfd65594f46a0 = void 0;
const $4b8a4f886e8dc6e4$var$formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: "P"
};
const $4b8a4f886e8dc6e4$var$formatRelative = (token, _date, _baseDate, _options)=>$4b8a4f886e8dc6e4$var$formatRelativeLocale[token];
$4b8a4f886e8dc6e4$export$8fbbfd65594f46a0 = $4b8a4f886e8dc6e4$var$formatRelative;

});

parcelRegister("giAzJ", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $bddab2df33a05750$export$b3bd0bc58e36cd63; }, function (v) { return $bddab2df33a05750$export$b3bd0bc58e36cd63 = v; });
var $bddab2df33a05750$export$b3bd0bc58e36cd63;
"use strict";
$bddab2df33a05750$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $bddab2df33a05750$var$eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
const $bddab2df33a05750$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
const $bddab2df33a05750$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
const $bddab2df33a05750$var$dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
const $bddab2df33a05750$var$dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
const $bddab2df33a05750$var$formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
const $bddab2df33a05750$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $bddab2df33a05750$var$localize = $bddab2df33a05750$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bddab2df33a05750$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $bddab2df33a05750$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $bddab2df33a05750$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $bddab2df33a05750$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $bddab2df33a05750$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $bddab2df33a05750$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $bddab2df33a05750$var$formattingDayPeriodValues,
        defaultFormattingWidth: "any"
    })
};

});

parcelRegister("8fcXQ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $6009c7de7e693ba9$export$4659b591c19bdf3d; }, function (v) { return $6009c7de7e693ba9$export$4659b591c19bdf3d = v; });
var $6009c7de7e693ba9$export$4659b591c19bdf3d;
"use strict";
$6009c7de7e693ba9$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $6009c7de7e693ba9$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
const $6009c7de7e693ba9$var$parseOrdinalNumberPattern = /\d+/i;
const $6009c7de7e693ba9$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
const $6009c7de7e693ba9$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
const $6009c7de7e693ba9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
const $6009c7de7e693ba9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6009c7de7e693ba9$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
const $6009c7de7e693ba9$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $6009c7de7e693ba9$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
const $6009c7de7e693ba9$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
const $6009c7de7e693ba9$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
const $6009c7de7e693ba9$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
const $6009c7de7e693ba9$var$match = $6009c7de7e693ba9$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $6009c7de7e693ba9$var$matchOrdinalNumberPattern,
        parsePattern: $6009c7de7e693ba9$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6009c7de7e693ba9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6009c7de7e693ba9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6009c7de7e693ba9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6009c7de7e693ba9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6009c7de7e693ba9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6009c7de7e693ba9$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6009c7de7e693ba9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6009c7de7e693ba9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $6009c7de7e693ba9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6009c7de7e693ba9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("fdEXL", function(module, exports) {

$parcel$export(module.exports, "vi", function () { return $b147d84c85691f6c$export$e3786bf10a8abdf2; }, function (v) { return $b147d84c85691f6c$export$e3786bf10a8abdf2 = v; });
var $b147d84c85691f6c$export$e3786bf10a8abdf2;
"use strict";
$b147d84c85691f6c$export$e3786bf10a8abdf2 = void 0;

var $kHfp7 = parcelRequire("kHfp7");

var $aw1mv = parcelRequire("aw1mv");

var $aJ9NI = parcelRequire("aJ9NI");

var $aEMpy = parcelRequire("aEMpy");

var $te4jZ = parcelRequire("te4jZ");
/**
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh](https://github.com/trongthanh)
 * @author Leroy Hopson [@lihop](https://github.com/lihop)
 */ const $b147d84c85691f6c$var$vi = $b147d84c85691f6c$export$e3786bf10a8abdf2 = {
    code: "vi",
    formatDistance: $kHfp7.formatDistance,
    formatLong: $aw1mv.formatLong,
    formatRelative: $aJ9NI.formatRelative,
    localize: $aEMpy.localize,
    match: $te4jZ.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};

});
parcelRegister("kHfp7", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f113c5bfa77709d2$export$2c14ff85d6318973; }, function (v) { return $f113c5bfa77709d2$export$2c14ff85d6318973 = v; });
var $f113c5bfa77709d2$export$2c14ff85d6318973;
"use strict";
$f113c5bfa77709d2$export$2c14ff85d6318973 = void 0;
const $f113c5bfa77709d2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
const $f113c5bfa77709d2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f113c5bfa77709d2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
$f113c5bfa77709d2$export$2c14ff85d6318973 = $f113c5bfa77709d2$var$formatDistance;

});

parcelRegister("aw1mv", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $7a7df302068eb478$export$cbf60ecb96cbb82f; }, function (v) { return $7a7df302068eb478$export$cbf60ecb96cbb82f = v; });
var $7a7df302068eb478$export$cbf60ecb96cbb82f;
"use strict";
$7a7df302068eb478$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $7a7df302068eb478$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: "dd/MM/y"
};
const $7a7df302068eb478$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $7a7df302068eb478$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: "{{date}} {{time}}",
    // ngày 25 tháng 08 năm 2017 23:25
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $7a7df302068eb478$var$formatLong = $7a7df302068eb478$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $7a7df302068eb478$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $7a7df302068eb478$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $7a7df302068eb478$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("aJ9NI", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $7cf5b5954cc2d928$export$8fbbfd65594f46a0; }, function (v) { return $7cf5b5954cc2d928$export$8fbbfd65594f46a0 = v; });
var $7cf5b5954cc2d928$export$8fbbfd65594f46a0;
"use strict";
$7cf5b5954cc2d928$export$8fbbfd65594f46a0 = void 0;
const $7cf5b5954cc2d928$var$formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: "P"
};
const $7cf5b5954cc2d928$var$formatRelative = (token, _date, _baseDate, _options)=>$7cf5b5954cc2d928$var$formatRelativeLocale[token];
$7cf5b5954cc2d928$export$8fbbfd65594f46a0 = $7cf5b5954cc2d928$var$formatRelative;

});

parcelRegister("aEMpy", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $7c233143986b3763$export$b3bd0bc58e36cd63; }, function (v) { return $7c233143986b3763$export$b3bd0bc58e36cd63 = v; });
var $7c233143986b3763$export$b3bd0bc58e36cd63;
"use strict";
$7c233143986b3763$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
// Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
const $7c233143986b3763$var$eraValues = {
    narrow: [
        "TCN",
        "SCN"
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        "sau CN"
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
const $7c233143986b3763$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
const $7c233143986b3763$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $7c233143986b3763$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "Thg 1",
        "Thg 2",
        "Thg 3",
        "Thg 4",
        "Thg 5",
        "Thg 6",
        "Thg 7",
        "Thg 8",
        "Thg 9",
        "Thg 10",
        "Thg 11",
        "Thg 12"
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
const $7c233143986b3763$var$formattingMonthValues = {
    narrow: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "thg 1",
        "thg 2",
        "thg 3",
        "thg 4",
        "thg 5",
        "thg 6",
        "thg 7",
        "thg 8",
        "thg 9",
        "thg 10",
        "thg 11",
        "thg 12"
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
const $7c233143986b3763$var$dayValues = {
    narrow: [
        "CN",
        "T2",
        "T3",
        "T4",
        "T5",
        "T6",
        "T7"
    ],
    short: [
        "CN",
        "Th 2",
        "Th 3",
        "Th 4",
        "Th 5",
        "Th 6",
        "Th 7"
    ],
    abbreviated: [
        "CN",
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
const $7c233143986b3763$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
const $7c233143986b3763$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
const $7c233143986b3763$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (unit === "quarter") // many news outlets use "quý I"...
    switch(number){
        case 1:
            return "I";
        case 2:
            return "II";
        case 3:
            return "III";
        case 4:
            return "IV";
    }
    else if (unit === "day") // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2"; // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3"; // meaning 3rd day
        case 3:
            return "th\u1EE9 4"; // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt"; // meaning Sunday, there's no 8th day :D
    }
    else if (unit === "week") {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === "dayOfYear") {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
const $7c233143986b3763$var$localize = $7c233143986b3763$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7c233143986b3763$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $7c233143986b3763$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $7c233143986b3763$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $7c233143986b3763$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $7c233143986b3763$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $7c233143986b3763$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $7c233143986b3763$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $7c233143986b3763$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7c233143986b3763$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("te4jZ", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $057d9f4c7728d848$export$4659b591c19bdf3d; }, function (v) { return $057d9f4c7728d848$export$4659b591c19bdf3d = v; });
var $057d9f4c7728d848$export$4659b591c19bdf3d;
"use strict";
$057d9f4c7728d848$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $057d9f4c7728d848$var$matchOrdinalNumberPattern = /^(\d+)/i;
const $057d9f4c7728d848$var$parseOrdinalNumberPattern = /\d+/i;
const $057d9f4c7728d848$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
const $057d9f4c7728d848$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
const $057d9f4c7728d848$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
const $057d9f4c7728d848$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
const $057d9f4c7728d848$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
const $057d9f4c7728d848$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
const $057d9f4c7728d848$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
const $057d9f4c7728d848$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
const $057d9f4c7728d848$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
const $057d9f4c7728d848$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
const $057d9f4c7728d848$var$match = $057d9f4c7728d848$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $057d9f4c7728d848$var$matchOrdinalNumberPattern,
        parsePattern: $057d9f4c7728d848$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $057d9f4c7728d848$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $057d9f4c7728d848$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $057d9f4c7728d848$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $057d9f4c7728d848$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $057d9f4c7728d848$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $057d9f4c7728d848$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $057d9f4c7728d848$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $057d9f4c7728d848$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $057d9f4c7728d848$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $057d9f4c7728d848$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("248JA", function(module, exports) {

$parcel$export(module.exports, "zhCN", function () { return $1812baf5aa76b0c7$export$836e793ad054f4a7; }, function (v) { return $1812baf5aa76b0c7$export$836e793ad054f4a7 = v; });
var $1812baf5aa76b0c7$export$836e793ad054f4a7;
"use strict";
$1812baf5aa76b0c7$export$836e793ad054f4a7 = void 0;

var $8lIla = parcelRequire("8lIla");

var $ijs26 = parcelRequire("ijs26");

var $elkKf = parcelRequire("elkKf");

var $68XP8 = parcelRequire("68XP8");

var $7tdOA = parcelRequire("7tdOA");
/**
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario](https://github.com/KingMario)
 * @author Song Shuoyun [@fnlctrl](https://github.com/fnlctrl)
 * @author sabrinaM [@sabrinamiao](https://github.com/sabrinamiao)
 * @author Carney Wu [@cubicwork](https://github.com/cubicwork)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 */ const $1812baf5aa76b0c7$var$zhCN = $1812baf5aa76b0c7$export$836e793ad054f4a7 = {
    code: "zh-CN",
    formatDistance: $8lIla.formatDistance,
    formatLong: $ijs26.formatLong,
    formatRelative: $elkKf.formatRelative,
    localize: $68XP8.localize,
    match: $7tdOA.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("8lIla", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $6142adfbdd725d69$export$2c14ff85d6318973; }, function (v) { return $6142adfbdd725d69$export$2c14ff85d6318973 = v; });
var $6142adfbdd725d69$export$2c14ff85d6318973;
"use strict";
$6142adfbdd725d69$export$2c14ff85d6318973 = void 0;
const $6142adfbdd725d69$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
const $6142adfbdd725d69$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $6142adfbdd725d69$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
$6142adfbdd725d69$export$2c14ff85d6318973 = $6142adfbdd725d69$var$formatDistance;

});

parcelRegister("ijs26", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d54fbf14c6644dd8$export$cbf60ecb96cbb82f; }, function (v) { return $d54fbf14c6644dd8$export$cbf60ecb96cbb82f = v; });
var $d54fbf14c6644dd8$export$cbf60ecb96cbb82f;
"use strict";
$d54fbf14c6644dd8$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $d54fbf14c6644dd8$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $d54fbf14c6644dd8$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $d54fbf14c6644dd8$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $d54fbf14c6644dd8$var$formatLong = $d54fbf14c6644dd8$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $d54fbf14c6644dd8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $d54fbf14c6644dd8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $d54fbf14c6644dd8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("elkKf", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a7131e5a75499492$export$8fbbfd65594f46a0; }, function (v) { return $a7131e5a75499492$export$8fbbfd65594f46a0 = v; });
var $a7131e5a75499492$export$8fbbfd65594f46a0;
"use strict";
$a7131e5a75499492$export$8fbbfd65594f46a0 = void 0;

var $lPsfi = parcelRequire("lPsfi");
function $a7131e5a75499492$var$checkWeek(date, baseDate, options) {
    const baseFormat = "eeee p";
    if ((0, $lPsfi.isSameWeek)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
const $a7131e5a75499492$var$formatRelativeLocale = {
    lastWeek: $a7131e5a75499492$var$checkWeek,
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $a7131e5a75499492$var$checkWeek,
    other: "PP p"
};
const $a7131e5a75499492$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $a7131e5a75499492$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$a7131e5a75499492$export$8fbbfd65594f46a0 = $a7131e5a75499492$var$formatRelative;

});

parcelRegister("68XP8", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $012783b24410c756$export$b3bd0bc58e36cd63; }, function (v) { return $012783b24410c756$export$b3bd0bc58e36cd63 = v; });
var $012783b24410c756$export$b3bd0bc58e36cd63;
"use strict";
$012783b24410c756$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $012783b24410c756$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $012783b24410c756$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
const $012783b24410c756$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $012783b24410c756$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $012783b24410c756$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
const $012783b24410c756$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
const $012783b24410c756$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number.toString() + "\u65E5";
        case "hour":
            return number.toString() + "\u65F6";
        case "minute":
            return number.toString() + "\u5206";
        case "second":
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
const $012783b24410c756$var$localize = $012783b24410c756$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $012783b24410c756$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $012783b24410c756$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $012783b24410c756$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $012783b24410c756$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $012783b24410c756$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $012783b24410c756$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $012783b24410c756$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("7tdOA", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5705f53570774da2$export$4659b591c19bdf3d; }, function (v) { return $5705f53570774da2$export$4659b591c19bdf3d = v; });
var $5705f53570774da2$export$4659b591c19bdf3d;
"use strict";
$5705f53570774da2$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $5705f53570774da2$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
const $5705f53570774da2$var$parseOrdinalNumberPattern = /\d+/i;
const $5705f53570774da2$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $5705f53570774da2$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $5705f53570774da2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
const $5705f53570774da2$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $5705f53570774da2$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $5705f53570774da2$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $5705f53570774da2$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $5705f53570774da2$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $5705f53570774da2$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
const $5705f53570774da2$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $5705f53570774da2$var$match = $5705f53570774da2$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $5705f53570774da2$var$matchOrdinalNumberPattern,
        parsePattern: $5705f53570774da2$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5705f53570774da2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5705f53570774da2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5705f53570774da2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5705f53570774da2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5705f53570774da2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5705f53570774da2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5705f53570774da2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5705f53570774da2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $5705f53570774da2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5705f53570774da2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("4aezq", function(module, exports) {

$parcel$export(module.exports, "zhHK", function () { return $308365fe87aceeab$export$2099e693528da242; }, function (v) { return $308365fe87aceeab$export$2099e693528da242 = v; });
var $308365fe87aceeab$export$2099e693528da242;
"use strict";
$308365fe87aceeab$export$2099e693528da242 = void 0;

var $9Eqrd = parcelRequire("9Eqrd");

var $jESIE = parcelRequire("jESIE");

var $fXIxZ = parcelRequire("fXIxZ");

var $4liuT = parcelRequire("4liuT");

var $2j8O0 = parcelRequire("2j8O0");
/**
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo](https://github.com/gaplo)
 */ const $308365fe87aceeab$var$zhHK = $308365fe87aceeab$export$2099e693528da242 = {
    code: "zh-HK",
    formatDistance: $9Eqrd.formatDistance,
    formatLong: $jESIE.formatLong,
    formatRelative: $fXIxZ.formatRelative,
    localize: $4liuT.localize,
    match: $2j8O0.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("9Eqrd", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $706c5b8639b4dbbd$export$2c14ff85d6318973; }, function (v) { return $706c5b8639b4dbbd$export$2c14ff85d6318973 = v; });
var $706c5b8639b4dbbd$export$2c14ff85d6318973;
"use strict";
$706c5b8639b4dbbd$export$2c14ff85d6318973 = void 0;
const $706c5b8639b4dbbd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
const $706c5b8639b4dbbd$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $706c5b8639b4dbbd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
$706c5b8639b4dbbd$export$2c14ff85d6318973 = $706c5b8639b4dbbd$var$formatDistance;

});

parcelRegister("jESIE", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $e4fc32d94f634f6a$export$cbf60ecb96cbb82f; }, function (v) { return $e4fc32d94f634f6a$export$cbf60ecb96cbb82f = v; });
var $e4fc32d94f634f6a$export$cbf60ecb96cbb82f;
"use strict";
$e4fc32d94f634f6a$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $e4fc32d94f634f6a$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $e4fc32d94f634f6a$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $e4fc32d94f634f6a$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $e4fc32d94f634f6a$var$formatLong = $e4fc32d94f634f6a$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $e4fc32d94f634f6a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $e4fc32d94f634f6a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $e4fc32d94f634f6a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("fXIxZ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $b9eeebda1aebcc2d$export$8fbbfd65594f46a0; }, function (v) { return $b9eeebda1aebcc2d$export$8fbbfd65594f46a0 = v; });
var $b9eeebda1aebcc2d$export$8fbbfd65594f46a0;
"use strict";
$b9eeebda1aebcc2d$export$8fbbfd65594f46a0 = void 0;
const $b9eeebda1aebcc2d$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: "P"
};
const $b9eeebda1aebcc2d$var$formatRelative = (token, _date, _baseDate, _options)=>$b9eeebda1aebcc2d$var$formatRelativeLocale[token];
$b9eeebda1aebcc2d$export$8fbbfd65594f46a0 = $b9eeebda1aebcc2d$var$formatRelative;

});

parcelRegister("4liuT", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $329778bfb09cf4b2$export$b3bd0bc58e36cd63; }, function (v) { return $329778bfb09cf4b2$export$b3bd0bc58e36cd63 = v; });
var $329778bfb09cf4b2$export$b3bd0bc58e36cd63;
"use strict";
$329778bfb09cf4b2$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $329778bfb09cf4b2$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $329778bfb09cf4b2$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
const $329778bfb09cf4b2$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $329778bfb09cf4b2$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $329778bfb09cf4b2$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
const $329778bfb09cf4b2$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
const $329778bfb09cf4b2$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number + "\u65E5";
        case "hour":
            return number + "\u6642";
        case "minute":
            return number + "\u5206";
        case "second":
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
const $329778bfb09cf4b2$var$localize = $329778bfb09cf4b2$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $329778bfb09cf4b2$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $329778bfb09cf4b2$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $329778bfb09cf4b2$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $329778bfb09cf4b2$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $329778bfb09cf4b2$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $329778bfb09cf4b2$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $329778bfb09cf4b2$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("2j8O0", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $1ae42fb15a79f232$export$4659b591c19bdf3d; }, function (v) { return $1ae42fb15a79f232$export$4659b591c19bdf3d = v; });
var $1ae42fb15a79f232$export$4659b591c19bdf3d;
"use strict";
$1ae42fb15a79f232$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $1ae42fb15a79f232$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
const $1ae42fb15a79f232$var$parseOrdinalNumberPattern = /\d+/i;
const $1ae42fb15a79f232$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $1ae42fb15a79f232$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $1ae42fb15a79f232$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
const $1ae42fb15a79f232$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $1ae42fb15a79f232$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $1ae42fb15a79f232$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $1ae42fb15a79f232$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $1ae42fb15a79f232$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $1ae42fb15a79f232$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
const $1ae42fb15a79f232$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $1ae42fb15a79f232$var$match = $1ae42fb15a79f232$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $1ae42fb15a79f232$var$matchOrdinalNumberPattern,
        parsePattern: $1ae42fb15a79f232$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1ae42fb15a79f232$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1ae42fb15a79f232$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1ae42fb15a79f232$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1ae42fb15a79f232$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1ae42fb15a79f232$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1ae42fb15a79f232$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1ae42fb15a79f232$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1ae42fb15a79f232$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $1ae42fb15a79f232$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1ae42fb15a79f232$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("10bE8", function(module, exports) {

$parcel$export(module.exports, "zhTW", function () { return $0baed34134076d15$export$3991fdf1bb6f66b9; }, function (v) { return $0baed34134076d15$export$3991fdf1bb6f66b9 = v; });
var $0baed34134076d15$export$3991fdf1bb6f66b9;
"use strict";
$0baed34134076d15$export$3991fdf1bb6f66b9 = void 0;

var $9TJuf = parcelRequire("9TJuf");

var $lY8e5 = parcelRequire("lY8e5");

var $dOebK = parcelRequire("dOebK");

var $9gojB = parcelRequire("9gojB");

var $6kiO6 = parcelRequire("6kiO6");
/**
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai](https://github.com/tpai)
 * @author Jack Hsu [@jackhsu978](https://github.com/jackhsu978)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 */ const $0baed34134076d15$var$zhTW = $0baed34134076d15$export$3991fdf1bb6f66b9 = {
    code: "zh-TW",
    formatDistance: $9TJuf.formatDistance,
    formatLong: $lY8e5.formatLong,
    formatRelative: $dOebK.formatRelative,
    localize: $9gojB.localize,
    match: $6kiO6.match,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};

});
parcelRegister("9TJuf", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $734c88de924ff4bd$export$2c14ff85d6318973; }, function (v) { return $734c88de924ff4bd$export$2c14ff85d6318973 = v; });
var $734c88de924ff4bd$export$2c14ff85d6318973;
"use strict";
$734c88de924ff4bd$export$2c14ff85d6318973 = void 0;
const $734c88de924ff4bd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
const $734c88de924ff4bd$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $734c88de924ff4bd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
$734c88de924ff4bd$export$2c14ff85d6318973 = $734c88de924ff4bd$var$formatDistance;

});

parcelRegister("lY8e5", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $ffe59522a0093814$export$cbf60ecb96cbb82f; }, function (v) { return $ffe59522a0093814$export$cbf60ecb96cbb82f = v; });
var $ffe59522a0093814$export$cbf60ecb96cbb82f;
"use strict";
$ffe59522a0093814$export$cbf60ecb96cbb82f = void 0;

var $6mxHK = parcelRequire("6mxHK");
const $ffe59522a0093814$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $ffe59522a0093814$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $ffe59522a0093814$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $ffe59522a0093814$var$formatLong = $ffe59522a0093814$export$cbf60ecb96cbb82f = {
    date: (0, $6mxHK.buildFormatLongFn)({
        formats: $ffe59522a0093814$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6mxHK.buildFormatLongFn)({
        formats: $ffe59522a0093814$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6mxHK.buildFormatLongFn)({
        formats: $ffe59522a0093814$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("dOebK", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a0daf36c08824c7b$export$8fbbfd65594f46a0; }, function (v) { return $a0daf36c08824c7b$export$8fbbfd65594f46a0 = v; });
var $a0daf36c08824c7b$export$8fbbfd65594f46a0;
"use strict";
$a0daf36c08824c7b$export$8fbbfd65594f46a0 = void 0;
const $a0daf36c08824c7b$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: "P"
};
const $a0daf36c08824c7b$var$formatRelative = (token, _date, _baseDate, _options)=>$a0daf36c08824c7b$var$formatRelativeLocale[token];
$a0daf36c08824c7b$export$8fbbfd65594f46a0 = $a0daf36c08824c7b$var$formatRelative;

});

parcelRegister("9gojB", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $6be878256f0c3951$export$b3bd0bc58e36cd63; }, function (v) { return $6be878256f0c3951$export$b3bd0bc58e36cd63 = v; });
var $6be878256f0c3951$export$b3bd0bc58e36cd63;
"use strict";
$6be878256f0c3951$export$b3bd0bc58e36cd63 = void 0;

var $bhSfH = parcelRequire("bhSfH");
const $6be878256f0c3951$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $6be878256f0c3951$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
const $6be878256f0c3951$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $6be878256f0c3951$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $6be878256f0c3951$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
const $6be878256f0c3951$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
const $6be878256f0c3951$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number + "\u65E5";
        case "hour":
            return number + "\u6642";
        case "minute":
            return number + "\u5206";
        case "second":
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
const $6be878256f0c3951$var$localize = $6be878256f0c3951$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6be878256f0c3951$var$ordinalNumber,
    era: (0, $bhSfH.buildLocalizeFn)({
        values: $6be878256f0c3951$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $bhSfH.buildLocalizeFn)({
        values: $6be878256f0c3951$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $bhSfH.buildLocalizeFn)({
        values: $6be878256f0c3951$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $bhSfH.buildLocalizeFn)({
        values: $6be878256f0c3951$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $bhSfH.buildLocalizeFn)({
        values: $6be878256f0c3951$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6be878256f0c3951$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("6kiO6", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $49b3330b8462a531$export$4659b591c19bdf3d; }, function (v) { return $49b3330b8462a531$export$4659b591c19bdf3d = v; });
var $49b3330b8462a531$export$4659b591c19bdf3d;
"use strict";
$49b3330b8462a531$export$4659b591c19bdf3d = void 0;

var $gZaqQ = parcelRequire("gZaqQ");

var $essio = parcelRequire("essio");
const $49b3330b8462a531$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
const $49b3330b8462a531$var$parseOrdinalNumberPattern = /\d+/i;
const $49b3330b8462a531$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $49b3330b8462a531$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $49b3330b8462a531$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
const $49b3330b8462a531$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $49b3330b8462a531$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $49b3330b8462a531$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $49b3330b8462a531$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $49b3330b8462a531$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $49b3330b8462a531$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
const $49b3330b8462a531$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $49b3330b8462a531$var$match = $49b3330b8462a531$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $essio.buildMatchPatternFn)({
        matchPattern: $49b3330b8462a531$var$matchOrdinalNumberPattern,
        parsePattern: $49b3330b8462a531$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $49b3330b8462a531$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49b3330b8462a531$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $49b3330b8462a531$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49b3330b8462a531$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $49b3330b8462a531$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49b3330b8462a531$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $49b3330b8462a531$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49b3330b8462a531$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gZaqQ.buildMatchFn)({
        matchPatterns: $49b3330b8462a531$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $49b3330b8462a531$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});




parcelRegister("3ipPr", function(module, exports) {
/*!
 * Globalize
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 */ (function(window, undefined) {
    var Globalize, // private variables
    regexHex, regexInfinity, regexParseFloat, regexTrim, // private JavaScript utility functions
    arrayIndexOf, endsWith, extend, isArray, isFunction, isObject, startsWith, trim, truncate, zeroPad, // private Globalization utility functions
    appendPreOrPostMatch, expandFormat, formatDate, formatNumber, getTokenRegExp, getEra, getEraYear, parseExact, parseNegativePattern;
    // Global variable (Globalize) or CommonJS module (globalize)
    Globalize = function(cultureSelector) {
        return new Globalize.prototype.init(cultureSelector);
    };
    // Assume CommonJS
    module.exports = Globalize;
    Globalize.cultures = {};
    Globalize.prototype = {
        constructor: Globalize,
        init: function(cultureSelector) {
            this.cultures = Globalize.cultures;
            this.cultureSelector = cultureSelector;
            return this;
        }
    };
    Globalize.prototype.init.prototype = Globalize.prototype;
    // 1. When defining a culture, all fields are required except the ones stated as optional.
    // 2. Each culture should have a ".calendars" object with at least one calendar named "standard"
    //    which serves as the default calendar in use by that culture.
    // 3. Each culture should have a ".calendar" object which is the current calendar being used,
    //    it may be dynamically changed at any time to one of the calendars in ".calendars".
    Globalize.cultures["default"] = {
        // A unique name for the culture in the form <language code>-<country/region code>
        name: "en",
        // the name of the culture in the english language
        englishName: "English",
        // the name of the culture in its own language
        nativeName: "English",
        // whether the culture uses right-to-left text
        isRTL: false,
        // "language" is used for so-called "specific" cultures.
        // For example, the culture "es-CL" means "Spanish, in Chili".
        // It represents the Spanish-speaking culture as it is in Chili,
        // which might have different formatting rules or even translations
        // than Spanish in Spain. A "neutral" culture is one that is not
        // specific to a region. For example, the culture "es" is the generic
        // Spanish culture, which may be a more generalized version of the language
        // that may or may not be what a specific culture expects.
        // For a specific culture like "es-CL", the "language" field refers to the
        // neutral, generic culture information for the language it is using.
        // This is not always a simple matter of the string before the dash.
        // For example, the "zh-Hans" culture is netural (Simplified Chinese).
        // And the "zh-SG" culture is Simplified Chinese in Singapore, whose lanugage
        // field is "zh-CHS", not "zh".
        // This field should be used to navigate from a specific culture to it's
        // more general, neutral culture. If a culture is already as general as it
        // can get, the language may refer to itself.
        language: "en",
        // numberFormat defines general number formatting rules, like the digits in
        // each grouping, the group separator, and how negative numbers are displayed.
        numberFormat: {
            // [negativePattern]
            // Note, numberFormat.pattern has no "positivePattern" unlike percent and currency,
            // but is still defined as an array for consistency with them.
            //   negativePattern: one of "(n)|-n|- n|n-|n -"
            pattern: [
                "-n"
            ],
            // number of decimal places normally shown
            decimals: 2,
            // string that separates number groups, as in 1,000,000
            ",": ",",
            // string that separates a number from the fractional portion, as in 1.99
            ".": ".",
            // array of numbers indicating the size of each number group.
            // TODO: more detailed description and example
            groupSizes: [
                3
            ],
            // symbol used for positive numbers
            "+": "+",
            // symbol used for negative numbers
            "-": "-",
            // symbol used for NaN (Not-A-Number)
            "NaN": "NaN",
            // symbol used for Negative Infinity
            negativeInfinity: "-Infinity",
            // symbol used for Positive Infinity
            positiveInfinity: "Infinity",
            percent: {
                // [negativePattern, positivePattern]
                //   negativePattern: one of "-n %|-n%|-%n|%-n|%n-|n-%|n%-|-% n|n %-|% n-|% -n|n- %"
                //   positivePattern: one of "n %|n%|%n|% n"
                pattern: [
                    "-n %",
                    "n %"
                ],
                // number of decimal places normally shown
                decimals: 2,
                // array of numbers indicating the size of each number group.
                // TODO: more detailed description and example
                groupSizes: [
                    3
                ],
                // string that separates number groups, as in 1,000,000
                ",": ",",
                // string that separates a number from the fractional portion, as in 1.99
                ".": ".",
                // symbol used to represent a percentage
                symbol: "%"
            },
            currency: {
                // [negativePattern, positivePattern]
                //   negativePattern: one of "($n)|-$n|$-n|$n-|(n$)|-n$|n-$|n$-|-n $|-$ n|n $-|$ n-|$ -n|n- $|($ n)|(n $)"
                //   positivePattern: one of "$n|n$|$ n|n $"
                pattern: [
                    "($n)",
                    "$n"
                ],
                // number of decimal places normally shown
                decimals: 2,
                // array of numbers indicating the size of each number group.
                // TODO: more detailed description and example
                groupSizes: [
                    3
                ],
                // string that separates number groups, as in 1,000,000
                ",": ",",
                // string that separates a number from the fractional portion, as in 1.99
                ".": ".",
                // symbol used to represent currency
                symbol: "$"
            }
        },
        // calendars defines all the possible calendars used by this culture.
        // There should be at least one defined with name "standard", and is the default
        // calendar used by the culture.
        // A calendar contains information about how dates are formatted, information about
        // the calendar's eras, a standard set of the date formats,
        // translations for day and month names, and if the calendar is not based on the Gregorian
        // calendar, conversion functions to and from the Gregorian calendar.
        calendars: {
            standard: {
                // name that identifies the type of calendar this is
                name: "Gregorian_USEnglish",
                // separator of parts of a date (e.g. "/" in 11/05/1955)
                "/": "/",
                // separator of parts of a time (e.g. ":" in 05:44 PM)
                ":": ":",
                // the first day of the week (0 = Sunday, 1 = Monday, etc)
                firstDay: 0,
                days: {
                    // full day names
                    names: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    // abbreviated day names
                    namesAbbr: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    // shortest day names
                    namesShort: [
                        "Su",
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                        "Sa"
                    ]
                },
                months: {
                    // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                    names: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                        ""
                    ],
                    // abbreviated month names
                    namesAbbr: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                        ""
                    ]
                },
                // AM and PM designators in one of these forms:
                // The usual view, and the upper and lower case versions
                //   [ standard, lowercase, uppercase ]
                // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
                //   null
                AM: [
                    "AM",
                    "am",
                    "AM"
                ],
                PM: [
                    "PM",
                    "pm",
                    "PM"
                ],
                eras: [
                    // eras in reverse chronological order.
                    // name: the name of the era in this culture (e.g. A.D., C.E.)
                    // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                    // offset: offset in years from gregorian calendar
                    {
                        "name": "A.D.",
                        "start": null,
                        "offset": 0
                    }
                ],
                // when a two digit year is given, it will never be parsed as a four digit
                // year greater than this year (in the appropriate era for the culture)
                // Set it as a full year (e.g. 2029) or use an offset format starting from
                // the current year: "+19" would correspond to 2029 if the current year 2010.
                twoDigitYearMax: 2029,
                // set of predefined date and time patterns used by the culture
                // these represent the format someone in this culture would expect
                // to see given the portions of the date that are shown.
                patterns: {
                    // short date pattern
                    d: "M/d/yyyy",
                    // long date pattern
                    D: "dddd, MMMM dd, yyyy",
                    // short time pattern
                    t: "h:mm tt",
                    // long time pattern
                    T: "h:mm:ss tt",
                    // long date, short time pattern
                    f: "dddd, MMMM dd, yyyy h:mm tt",
                    // long date, long time pattern
                    F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                    // month/day pattern
                    M: "MMMM dd",
                    // month/year pattern
                    Y: "yyyy MMMM",
                    // S is a sortable format that does not vary by culture
                    S: "yyyy'-'MM'-'dd'T'HH':'mm':'ss"
                }
            }
        },
        // For localized strings
        messages: {}
    };
    Globalize.cultures["default"].calendar = Globalize.cultures["default"].calendars.standard;
    Globalize.cultures.en = Globalize.cultures["default"];
    Globalize.cultureSelector = "en";
    //
    // private variables
    //
    regexHex = /^0x[a-f0-9]+$/i;
    regexInfinity = /^[+\-]?infinity$/i;
    regexParseFloat = /^[+\-]?\d*\.?\d*(e[+\-]?\d+)?$/;
    regexTrim = /^\s+|\s+$/g;
    //
    // private JavaScript utility functions
    //
    arrayIndexOf = function(array, item) {
        if (array.indexOf) return array.indexOf(item);
        for(var i = 0, length = array.length; i < length; i++){
            if (array[i] === item) return i;
        }
        return -1;
    };
    endsWith = function(value, pattern) {
        return value.substr(value.length - pattern.length) === pattern;
    };
    extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            target = arguments[1] || {};
            // skip the boolean and the target
            i = 2;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                src = target[name];
                copy = options[name];
                // Prevent never-ending loop
                if (target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (isObject(copy) || (copyIsArray = isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && isArray(src) ? src : [];
                    } else clone = src && isObject(src) ? src : {};
                    // Never move original objects, clone them
                    target[name] = extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    isFunction = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Function]";
    };
    isObject = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    };
    startsWith = function(value, pattern) {
        return value.indexOf(pattern) === 0;
    };
    trim = function(value) {
        return (value + "").replace(regexTrim, "");
    };
    truncate = function(value) {
        if (isNaN(value)) return NaN;
        return Math[value < 0 ? "ceil" : "floor"](value);
    };
    zeroPad = function(str, count, left) {
        var l;
        for(l = str.length; l < count; l += 1)str = left ? "0" + str : str + "0";
        return str;
    };
    //
    // private Globalization utility functions
    //
    appendPreOrPostMatch = function(preMatch, strings) {
        // appends pre- and post- token match strings while removing escaped characters.
        // Returns a single quote count which is used to determine if the token occurs
        // in a string literal.
        var quoteCount = 0, escaped = false;
        for(var i = 0, il = preMatch.length; i < il; i++){
            var c = preMatch.charAt(i);
            switch(c){
                case "'":
                    if (escaped) strings.push("'");
                    else quoteCount++;
                    escaped = false;
                    break;
                case "\\":
                    if (escaped) strings.push("\\");
                    escaped = !escaped;
                    break;
                default:
                    strings.push(c);
                    escaped = false;
                    break;
            }
        }
        return quoteCount;
    };
    expandFormat = function(cal, format) {
        // expands unspecified or single character date formats into the full pattern.
        format = format || "F";
        var pattern, patterns = cal.patterns, len = format.length;
        if (len === 1) {
            pattern = patterns[format];
            if (!pattern) throw "Invalid date format string '" + format + "'.";
            format = pattern;
        } else if (len === 2 && format.charAt(0) === "%") // %X escape format -- intended as a custom format string that is only one character, not a built-in format.
        format = format.charAt(1);
        return format;
    };
    formatDate = function(value, format, culture) {
        var cal = culture.calendar, convert = cal.convert, ret;
        if (!format || !format.length || format === "i") {
            if (culture && culture.name.length) {
                if (convert) // non-gregorian calendar, so we cannot use built-in toLocaleString()
                ret = formatDate(value, cal.patterns.F, culture);
                else {
                    var eraDate = new Date(value.getTime()), era = getEra(value, cal.eras);
                    eraDate.setFullYear(getEraYear(value, cal, era));
                    ret = eraDate.toLocaleString();
                }
            } else ret = value.toString();
            return ret;
        }
        var eras = cal.eras, sortable = format === "s";
        format = expandFormat(cal, format);
        // Start with an empty string
        ret = [];
        var hour, zeros = [
            "0",
            "00",
            "000"
        ], foundDay, checkedDay, dayPartRegExp = /([^d]|^)(d|dd)([^d]|$)/g, quoteCount = 0, tokenRegExp = getTokenRegExp(), converted;
        function padZeros(num, c) {
            var r, s = num + "";
            if (c > 1 && s.length < c) {
                r = zeros[c - 2] + s;
                return r.substr(r.length - c, c);
            } else r = s;
            return r;
        }
        function hasDay() {
            if (foundDay || checkedDay) return foundDay;
            foundDay = dayPartRegExp.test(format);
            checkedDay = true;
            return foundDay;
        }
        function getPart(date, part) {
            if (converted) return converted[part];
            switch(part){
                case 0:
                    return date.getFullYear();
                case 1:
                    return date.getMonth();
                case 2:
                    return date.getDate();
                default:
                    throw "Invalid part value " + part;
            }
        }
        if (!sortable && convert) converted = convert.fromGregorian(value);
        for(;;){
            // Save the current index
            var index = tokenRegExp.lastIndex, // Look for the next pattern
            ar = tokenRegExp.exec(format);
            // Append the text before the pattern (or the end of the string if not found)
            var preMatch = format.slice(index, ar ? ar.index : format.length);
            quoteCount += appendPreOrPostMatch(preMatch, ret);
            if (!ar) break;
            // do not replace any matches that occur inside a string literal.
            if (quoteCount % 2) {
                ret.push(ar[0]);
                continue;
            }
            var current = ar[0], clength = current.length;
            switch(current){
                case "ddd":
                //Day of the week, as a three-letter abbreviation
                case "dddd":
                    // Day of the week, using the full name
                    var names = clength === 3 ? cal.days.namesAbbr : cal.days.names;
                    ret.push(names[value.getDay()]);
                    break;
                case "d":
                // Day of month, without leading zero for single-digit days
                case "dd":
                    // Day of month, with leading zero for single-digit days
                    foundDay = true;
                    ret.push(padZeros(getPart(value, 2), clength));
                    break;
                case "MMM":
                // Month, as a three-letter abbreviation
                case "MMMM":
                    // Month, using the full name
                    var part = getPart(value, 1);
                    ret.push(cal.monthsGenitive && hasDay() ? cal.monthsGenitive[clength === 3 ? "namesAbbr" : "names"][part] : cal.months[clength === 3 ? "namesAbbr" : "names"][part]);
                    break;
                case "M":
                // Month, as digits, with no leading zero for single-digit months
                case "MM":
                    // Month, as digits, with leading zero for single-digit months
                    ret.push(padZeros(getPart(value, 1) + 1, clength));
                    break;
                case "y":
                // Year, as two digits, but with no leading zero for years less than 10
                case "yy":
                // Year, as two digits, with leading zero for years less than 10
                case "yyyy":
                    // Year represented by four full digits
                    part = converted ? converted[0] : getEraYear(value, cal, getEra(value, eras), sortable);
                    if (clength < 4) part = part % 100;
                    ret.push(padZeros(part, clength));
                    break;
                case "h":
                // Hours with no leading zero for single-digit hours, using 12-hour clock
                case "hh":
                    // Hours with leading zero for single-digit hours, using 12-hour clock
                    hour = value.getHours() % 12;
                    if (hour === 0) hour = 12;
                    ret.push(padZeros(hour, clength));
                    break;
                case "H":
                // Hours with no leading zero for single-digit hours, using 24-hour clock
                case "HH":
                    // Hours with leading zero for single-digit hours, using 24-hour clock
                    ret.push(padZeros(value.getHours(), clength));
                    break;
                case "m":
                // Minutes with no leading zero for single-digit minutes
                case "mm":
                    // Minutes with leading zero for single-digit minutes
                    ret.push(padZeros(value.getMinutes(), clength));
                    break;
                case "s":
                // Seconds with no leading zero for single-digit seconds
                case "ss":
                    // Seconds with leading zero for single-digit seconds
                    ret.push(padZeros(value.getSeconds(), clength));
                    break;
                case "t":
                // One character am/pm indicator ("a" or "p")
                case "tt":
                    // Multicharacter am/pm indicator
                    part = value.getHours() < 12 ? cal.AM ? cal.AM[0] : " " : cal.PM ? cal.PM[0] : " ";
                    ret.push(clength === 1 ? part.charAt(0) : part);
                    break;
                case "f":
                // Deciseconds
                case "ff":
                // Centiseconds
                case "fff":
                    // Milliseconds
                    ret.push(padZeros(value.getMilliseconds(), 3).substr(0, clength));
                    break;
                case "z":
                // Time zone offset, no leading zero
                case "zz":
                    // Time zone offset with leading zero
                    hour = value.getTimezoneOffset() / 60;
                    ret.push((hour <= 0 ? "+" : "-") + padZeros(Math.floor(Math.abs(hour)), clength));
                    break;
                case "zzz":
                    // Time zone offset with leading zero
                    hour = value.getTimezoneOffset() / 60;
                    ret.push((hour <= 0 ? "+" : "-") + padZeros(Math.floor(Math.abs(hour)), 2) + // Hard coded ":" separator, rather than using cal.TimeSeparator
                    // Repeated here for consistency, plus ":" was already assumed in date parsing.
                    ":" + padZeros(Math.abs(value.getTimezoneOffset() % 60), 2));
                    break;
                case "g":
                case "gg":
                    if (cal.eras) ret.push(cal.eras[getEra(value, eras)].name);
                    break;
                case "/":
                    ret.push(cal["/"]);
                    break;
                default:
                    throw "Invalid date format pattern '" + current + "'.";
            }
        }
        return ret.join("");
    };
    // formatNumber
    (function() {
        var expandNumber;
        expandNumber = function(number, precision, formatInfo) {
            var groupSizes = formatInfo.groupSizes, curSize = groupSizes[0], curGroupIndex = 1, factor = Math.pow(10, precision), rounded = Math.round(number * factor) / factor;
            if (!isFinite(rounded)) rounded = number;
            number = rounded;
            var numberString = number + "", right = "", split = numberString.split(/e/i), exponent = split.length > 1 ? parseInt(split[1], 10) : 0;
            numberString = split[0];
            split = numberString.split(".");
            numberString = split[0];
            right = split.length > 1 ? split[1] : "";
            var l;
            if (exponent > 0) {
                right = zeroPad(right, exponent, false);
                numberString += right.slice(0, exponent);
                right = right.substr(exponent);
            } else if (exponent < 0) {
                exponent = -exponent;
                numberString = zeroPad(numberString, exponent + 1, true);
                right = numberString.slice(-exponent, numberString.length) + right;
                numberString = numberString.slice(0, -exponent);
            }
            if (precision > 0) right = formatInfo["."] + (right.length > precision ? right.slice(0, precision) : zeroPad(right, precision));
            else right = "";
            var stringIndex = numberString.length - 1, sep = formatInfo[","], ret = "";
            while(stringIndex >= 0){
                if (curSize === 0 || curSize > stringIndex) return numberString.slice(0, stringIndex + 1) + (ret.length ? sep + ret + right : right);
                ret = numberString.slice(stringIndex - curSize + 1, stringIndex + 1) + (ret.length ? sep + ret : "");
                stringIndex -= curSize;
                if (curGroupIndex < groupSizes.length) {
                    curSize = groupSizes[curGroupIndex];
                    curGroupIndex++;
                }
            }
            return numberString.slice(0, stringIndex + 1) + sep + ret + right;
        };
        formatNumber = function(value, format, culture) {
            if (!isFinite(value)) {
                if (value === Infinity) return culture.numberFormat.positiveInfinity;
                if (value === -Infinity) return culture.numberFormat.negativeInfinity;
                return culture.numberFormat["NaN"];
            }
            if (!format || format === "i") return culture.name.length ? value.toLocaleString() : value.toString();
            format = format || "D";
            var nf = culture.numberFormat, number = Math.abs(value), precision = -1, pattern;
            if (format.length > 1) precision = parseInt(format.slice(1), 10);
            var current = format.charAt(0).toUpperCase(), formatInfo;
            switch(current){
                case "D":
                    pattern = "n";
                    number = truncate(number);
                    if (precision !== -1) number = zeroPad("" + number, precision, true);
                    if (value < 0) number = "-" + number;
                    break;
                case "N":
                    formatInfo = nf;
                /* falls through */ case "C":
                    formatInfo = formatInfo || nf.currency;
                /* falls through */ case "P":
                    formatInfo = formatInfo || nf.percent;
                    pattern = value < 0 ? formatInfo.pattern[0] : formatInfo.pattern[1] || "n";
                    if (precision === -1) precision = formatInfo.decimals;
                    number = expandNumber(number * (current === "P" ? 100 : 1), precision, formatInfo);
                    break;
                default:
                    throw "Bad number format specifier: " + current;
            }
            var patternParts = /n|\$|-|%/g, ret = "";
            for(;;){
                var index = patternParts.lastIndex, ar = patternParts.exec(pattern);
                ret += pattern.slice(index, ar ? ar.index : pattern.length);
                if (!ar) break;
                switch(ar[0]){
                    case "n":
                        ret += number;
                        break;
                    case "$":
                        ret += nf.currency.symbol;
                        break;
                    case "-":
                        // don't make 0 negative
                        if (/[1-9]/.test(number)) ret += nf["-"];
                        break;
                    case "%":
                        ret += nf.percent.symbol;
                        break;
                }
            }
            return ret;
        };
    })();
    getTokenRegExp = function() {
        // regular expression for matching date and time tokens in format strings.
        return /\/|dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|y|hh|h|HH|H|mm|m|ss|s|tt|t|fff|ff|f|zzz|zz|z|gg|g/g;
    };
    getEra = function(date, eras) {
        if (!eras) return 0;
        var start, ticks = date.getTime();
        for(var i = 0, l = eras.length; i < l; i++){
            start = eras[i].start;
            if (start === null || ticks >= start) return i;
        }
        return 0;
    };
    getEraYear = function(date, cal, era, sortable) {
        var year = date.getFullYear();
        if (!sortable && cal.eras) // convert normal gregorian year to era-shifted gregorian
        // year by subtracting the era offset
        year -= cal.eras[era].offset;
        return year;
    };
    // parseExact
    (function() {
        var expandYear, getDayIndex, getMonthIndex, getParseRegExp, outOfRange, toUpper, toUpperArray;
        expandYear = function(cal, year) {
            // expands 2-digit year into 4 digits.
            if (year < 100) {
                var now = new Date(), era = getEra(now), curr = getEraYear(now, cal, era), twoDigitYearMax = cal.twoDigitYearMax;
                twoDigitYearMax = typeof twoDigitYearMax === "string" ? new Date().getFullYear() % 100 + parseInt(twoDigitYearMax, 10) : twoDigitYearMax;
                year += curr - curr % 100;
                if (year > twoDigitYearMax) year -= 100;
            }
            return year;
        };
        getDayIndex = function(cal, value, abbr) {
            var ret, days = cal.days, upperDays = cal._upperDays;
            if (!upperDays) cal._upperDays = upperDays = [
                toUpperArray(days.names),
                toUpperArray(days.namesAbbr),
                toUpperArray(days.namesShort)
            ];
            value = toUpper(value);
            if (abbr) {
                ret = arrayIndexOf(upperDays[1], value);
                if (ret === -1) ret = arrayIndexOf(upperDays[2], value);
            } else ret = arrayIndexOf(upperDays[0], value);
            return ret;
        };
        getMonthIndex = function(cal, value, abbr) {
            var months = cal.months, monthsGen = cal.monthsGenitive || cal.months, upperMonths = cal._upperMonths, upperMonthsGen = cal._upperMonthsGen;
            if (!upperMonths) {
                cal._upperMonths = upperMonths = [
                    toUpperArray(months.names),
                    toUpperArray(months.namesAbbr)
                ];
                cal._upperMonthsGen = upperMonthsGen = [
                    toUpperArray(monthsGen.names),
                    toUpperArray(monthsGen.namesAbbr)
                ];
            }
            value = toUpper(value);
            var i = arrayIndexOf(abbr ? upperMonths[1] : upperMonths[0], value);
            if (i < 0) i = arrayIndexOf(abbr ? upperMonthsGen[1] : upperMonthsGen[0], value);
            return i;
        };
        getParseRegExp = function(cal, format) {
            // converts a format string into a regular expression with groups that
            // can be used to extract date fields from a date string.
            // check for a cached parse regex.
            var re = cal._parseRegExp;
            if (!re) cal._parseRegExp = re = {};
            else {
                var reFormat = re[format];
                if (reFormat) return reFormat;
            }
            // expand single digit formats, then escape regular expression characters.
            var expFormat = expandFormat(cal, format).replace(/([\^\$\.\*\+\?\|\[\]\(\)\{\}])/g, "\\\\$1"), regexp = [
                "^"
            ], groups = [], index = 0, quoteCount = 0, tokenRegExp = getTokenRegExp(), match;
            // iterate through each date token found.
            while((match = tokenRegExp.exec(expFormat)) !== null){
                var preMatch = expFormat.slice(index, match.index);
                index = tokenRegExp.lastIndex;
                // don't replace any matches that occur inside a string literal.
                quoteCount += appendPreOrPostMatch(preMatch, regexp);
                if (quoteCount % 2) {
                    regexp.push(match[0]);
                    continue;
                }
                // add a regex group for the token.
                var m = match[0], len = m.length, add;
                switch(m){
                    case "dddd":
                    case "ddd":
                    case "MMMM":
                    case "MMM":
                    case "gg":
                    case "g":
                        add = "(\\D+)";
                        break;
                    case "tt":
                    case "t":
                        add = "(\\D*)";
                        break;
                    case "yyyy":
                    case "fff":
                    case "ff":
                    case "f":
                        add = "(\\d{" + len + "})";
                        break;
                    case "dd":
                    case "d":
                    case "MM":
                    case "M":
                    case "yy":
                    case "y":
                    case "HH":
                    case "H":
                    case "hh":
                    case "h":
                    case "mm":
                    case "m":
                    case "ss":
                    case "s":
                        add = "(\\d\\d?)";
                        break;
                    case "zzz":
                        add = "([+-]?\\d\\d?:\\d{2})";
                        break;
                    case "zz":
                    case "z":
                        add = "([+-]?\\d\\d?)";
                        break;
                    case "/":
                        add = "(\\/)";
                        break;
                    default:
                        throw "Invalid date format pattern '" + m + "'.";
                }
                if (add) regexp.push(add);
                groups.push(match[0]);
            }
            appendPreOrPostMatch(expFormat.slice(index), regexp);
            regexp.push("$");
            // allow whitespace to differ when matching formats.
            var regexpStr = regexp.join("").replace(/\s+/g, "\\s+"), parseRegExp = {
                "regExp": regexpStr,
                "groups": groups
            };
            // cache the regex for this format.
            return re[format] = parseRegExp;
        };
        outOfRange = function(value, low, high) {
            return value < low || value > high;
        };
        toUpper = function(value) {
            // "he-IL" has non-breaking space in weekday names.
            return value.split("\xa0").join(" ").toUpperCase();
        };
        toUpperArray = function(arr) {
            var results = [];
            for(var i = 0, l = arr.length; i < l; i++)results[i] = toUpper(arr[i]);
            return results;
        };
        parseExact = function(value, format, culture) {
            // try to parse the date string by matching against the format string
            // while using the specified culture for date field names.
            value = trim(value);
            var cal = culture.calendar, // convert date formats into regular expressions with groupings.
            // use the regexp to determine the input format and extract the date fields.
            parseInfo = getParseRegExp(cal, format), match = new RegExp(parseInfo.regExp).exec(value);
            if (match === null) return null;
            // found a date format that matches the input.
            var groups = parseInfo.groups, era = null, year = null, month = null, date = null, weekDay = null, hour = 0, hourOffset, min = 0, sec = 0, msec = 0, tzMinOffset = null, pmHour = false;
            // iterate the format groups to extract and set the date fields.
            for(var j = 0, jl = groups.length; j < jl; j++){
                var matchGroup = match[j + 1];
                if (matchGroup) {
                    var current = groups[j], clength = current.length, matchInt = parseInt(matchGroup, 10);
                    switch(current){
                        case "dd":
                        case "d":
                            // Day of month.
                            date = matchInt;
                            // check that date is generally in valid range, also checking overflow below.
                            if (outOfRange(date, 1, 31)) return null;
                            break;
                        case "MMM":
                        case "MMMM":
                            month = getMonthIndex(cal, matchGroup, clength === 3);
                            if (outOfRange(month, 0, 11)) return null;
                            break;
                        case "M":
                        case "MM":
                            // Month.
                            month = matchInt - 1;
                            if (outOfRange(month, 0, 11)) return null;
                            break;
                        case "y":
                        case "yy":
                        case "yyyy":
                            year = clength < 4 ? expandYear(cal, matchInt) : matchInt;
                            if (outOfRange(year, 0, 9999)) return null;
                            break;
                        case "h":
                        case "hh":
                            // Hours (12-hour clock).
                            hour = matchInt;
                            if (hour === 12) hour = 0;
                            if (outOfRange(hour, 0, 11)) return null;
                            break;
                        case "H":
                        case "HH":
                            // Hours (24-hour clock).
                            hour = matchInt;
                            if (outOfRange(hour, 0, 23)) return null;
                            break;
                        case "m":
                        case "mm":
                            // Minutes.
                            min = matchInt;
                            if (outOfRange(min, 0, 59)) return null;
                            break;
                        case "s":
                        case "ss":
                            // Seconds.
                            sec = matchInt;
                            if (outOfRange(sec, 0, 59)) return null;
                            break;
                        case "tt":
                        case "t":
                            // AM/PM designator.
                            // see if it is standard, upper, or lower case PM. If not, ensure it is at least one of
                            // the AM tokens. If not, fail the parse for this format.
                            pmHour = cal.PM && (matchGroup === cal.PM[0] || matchGroup === cal.PM[1] || matchGroup === cal.PM[2]);
                            if (!pmHour && (!cal.AM || matchGroup !== cal.AM[0] && matchGroup !== cal.AM[1] && matchGroup !== cal.AM[2])) return null;
                            break;
                        case "f":
                        // Deciseconds.
                        case "ff":
                        // Centiseconds.
                        case "fff":
                            // Milliseconds.
                            msec = matchInt * Math.pow(10, 3 - clength);
                            if (outOfRange(msec, 0, 999)) return null;
                            break;
                        case "ddd":
                        // Day of week.
                        case "dddd":
                            // Day of week.
                            weekDay = getDayIndex(cal, matchGroup, clength === 3);
                            if (outOfRange(weekDay, 0, 6)) return null;
                            break;
                        case "zzz":
                            // Time zone offset in +/- hours:min.
                            var offsets = matchGroup.split(/:/);
                            if (offsets.length !== 2) return null;
                            hourOffset = parseInt(offsets[0], 10);
                            if (outOfRange(hourOffset, -12, 13)) return null;
                            var minOffset = parseInt(offsets[1], 10);
                            if (outOfRange(minOffset, 0, 59)) return null;
                            tzMinOffset = hourOffset * 60 + (startsWith(matchGroup, "-") ? -minOffset : minOffset);
                            break;
                        case "z":
                        case "zz":
                            // Time zone offset in +/- hours.
                            hourOffset = matchInt;
                            if (outOfRange(hourOffset, -12, 13)) return null;
                            tzMinOffset = hourOffset * 60;
                            break;
                        case "g":
                        case "gg":
                            var eraName = matchGroup;
                            if (!eraName || !cal.eras) return null;
                            eraName = trim(eraName.toLowerCase());
                            for(var i = 0, l = cal.eras.length; i < l; i++)if (eraName === cal.eras[i].name.toLowerCase()) {
                                era = i;
                                break;
                            }
                            // could not find an era with that name
                            if (era === null) return null;
                            break;
                    }
                }
            }
            var result = new Date(), defaultYear, convert = cal.convert;
            defaultYear = convert ? convert.fromGregorian(result)[0] : result.getFullYear();
            if (year === null) year = defaultYear;
            else if (cal.eras) // year must be shifted to normal gregorian year
            // but not if year was not specified, its already normal gregorian
            // per the main if clause above.
            year += cal.eras[era || 0].offset;
            // set default day and month to 1 and January, so if unspecified, these are the defaults
            // instead of the current day/month.
            if (month === null) month = 0;
            if (date === null) date = 1;
            // now have year, month, and date, but in the culture's calendar.
            // convert to gregorian if necessary
            if (convert) {
                result = convert.toGregorian(year, month, date);
                // conversion failed, must be an invalid match
                if (result === null) return null;
            } else {
                // have to set year, month and date together to avoid overflow based on current date.
                result.setFullYear(year, month, date);
                // check to see if date overflowed for specified month (only checked 1-31 above).
                if (result.getDate() !== date) return null;
                // invalid day of week.
                if (weekDay !== null && result.getDay() !== weekDay) return null;
            }
            // if pm designator token was found make sure the hours fit the 24-hour clock.
            if (pmHour && hour < 12) hour += 12;
            result.setHours(hour, min, sec, msec);
            if (tzMinOffset !== null) {
                // adjust timezone to utc before applying local offset.
                var adjustedMin = result.getMinutes() - (tzMinOffset + result.getTimezoneOffset());
                // Safari limits hours and minutes to the range of -127 to 127.  We need to use setHours
                // to ensure both these fields will not exceed this range.	adjustedMin will range
                // somewhere between -1440 and 1500, so we only need to split this into hours.
                result.setHours(result.getHours() + parseInt(adjustedMin / 60, 10), adjustedMin % 60);
            }
            return result;
        };
    })();
    parseNegativePattern = function(value, nf, negativePattern) {
        var neg = nf["-"], pos = nf["+"], ret;
        switch(negativePattern){
            case "n -":
                neg = " " + neg;
                pos = " " + pos;
            /* falls through */ case "n-":
                if (endsWith(value, neg)) ret = [
                    "-",
                    value.substr(0, value.length - neg.length)
                ];
                else if (endsWith(value, pos)) ret = [
                    "+",
                    value.substr(0, value.length - pos.length)
                ];
                break;
            case "- n":
                neg += " ";
                pos += " ";
            /* falls through */ case "-n":
                if (startsWith(value, neg)) ret = [
                    "-",
                    value.substr(neg.length)
                ];
                else if (startsWith(value, pos)) ret = [
                    "+",
                    value.substr(pos.length)
                ];
                break;
            case "(n)":
                if (startsWith(value, "(") && endsWith(value, ")")) ret = [
                    "-",
                    value.substr(1, value.length - 2)
                ];
                break;
        }
        return ret || [
            "",
            value
        ];
    };
    //
    // public instance functions
    //
    Globalize.prototype.findClosestCulture = function(cultureSelector) {
        return Globalize.findClosestCulture.call(this, cultureSelector);
    };
    Globalize.prototype.format = function(value, format, cultureSelector) {
        return Globalize.format.call(this, value, format, cultureSelector);
    };
    Globalize.prototype.localize = function(key, cultureSelector) {
        return Globalize.localize.call(this, key, cultureSelector);
    };
    Globalize.prototype.parseInt = function(value, radix, cultureSelector) {
        return Globalize.parseInt.call(this, value, radix, cultureSelector);
    };
    Globalize.prototype.parseFloat = function(value, radix, cultureSelector) {
        return Globalize.parseFloat.call(this, value, radix, cultureSelector);
    };
    Globalize.prototype.culture = function(cultureSelector) {
        return Globalize.culture.call(this, cultureSelector);
    };
    //
    // public singleton functions
    //
    Globalize.addCultureInfo = function(cultureName, baseCultureName, info) {
        var base = {}, isNew = false;
        if (typeof cultureName !== "string") {
            // cultureName argument is optional string. If not specified, assume info is first
            // and only argument. Specified info deep-extends current culture.
            info = cultureName;
            cultureName = this.culture().name;
            base = this.cultures[cultureName];
        } else if (typeof baseCultureName !== "string") {
            // baseCultureName argument is optional string. If not specified, assume info is second
            // argument. Specified info deep-extends specified culture.
            // If specified culture does not exist, create by deep-extending default
            info = baseCultureName;
            isNew = this.cultures[cultureName] == null;
            base = this.cultures[cultureName] || this.cultures["default"];
        } else {
            // cultureName and baseCultureName specified. Assume a new culture is being created
            // by deep-extending an specified base culture
            isNew = true;
            base = this.cultures[baseCultureName];
        }
        this.cultures[cultureName] = extend(true, {}, base, info);
        // Make the standard calendar the current culture if it's a new culture
        if (isNew) this.cultures[cultureName].calendar = this.cultures[cultureName].calendars.standard;
    };
    Globalize.findClosestCulture = function(name) {
        var match;
        if (!name) return this.findClosestCulture(this.cultureSelector) || this.cultures["default"];
        if (typeof name === "string") name = name.split(",");
        if (isArray(name)) {
            var lang, cultures = this.cultures, list = name, i, l = list.length, prioritized = [];
            for(i = 0; i < l; i++){
                name = trim(list[i]);
                var pri, parts = name.split(";");
                lang = trim(parts[0]);
                if (parts.length === 1) pri = 1;
                else {
                    name = trim(parts[1]);
                    if (name.indexOf("q=") === 0) {
                        name = name.substr(2);
                        pri = parseFloat(name);
                        pri = isNaN(pri) ? 0 : pri;
                    } else pri = 1;
                }
                prioritized.push({
                    lang: lang,
                    pri: pri
                });
            }
            prioritized.sort(function(a, b) {
                if (a.pri < b.pri) return 1;
                else if (a.pri > b.pri) return -1;
                return 0;
            });
            // exact match
            for(i = 0; i < l; i++){
                lang = prioritized[i].lang;
                match = cultures[lang];
                if (match) return match;
            }
            // neutral language match
            for(i = 0; i < l; i++){
                lang = prioritized[i].lang;
                do {
                    var index = lang.lastIndexOf("-");
                    if (index === -1) break;
                    // strip off the last part. e.g. en-US => en
                    lang = lang.substr(0, index);
                    match = cultures[lang];
                    if (match) return match;
                }while (1);
            }
            // last resort: match first culture using that language
            for(i = 0; i < l; i++){
                lang = prioritized[i].lang;
                for(var cultureKey in cultures){
                    var culture = cultures[cultureKey];
                    if (culture.language == lang) return culture;
                }
            }
        } else if (typeof name === "object") return name;
        return match || null;
    };
    Globalize.format = function(value, format, cultureSelector) {
        var culture = this.findClosestCulture(cultureSelector);
        if (value instanceof Date) value = formatDate(value, format, culture);
        else if (typeof value === "number") value = formatNumber(value, format, culture);
        return value;
    };
    Globalize.localize = function(key, cultureSelector) {
        return this.findClosestCulture(cultureSelector).messages[key] || this.cultures["default"].messages[key];
    };
    Globalize.parseDate = function(value, formats, culture) {
        culture = this.findClosestCulture(culture);
        var date, prop, patterns;
        if (formats) {
            if (typeof formats === "string") formats = [
                formats
            ];
            if (formats.length) for(var i = 0, l = formats.length; i < l; i++){
                var format = formats[i];
                if (format) {
                    date = parseExact(value, format, culture);
                    if (date) break;
                }
            }
        } else {
            patterns = culture.calendar.patterns;
            for(prop in patterns){
                date = parseExact(value, patterns[prop], culture);
                if (date) break;
            }
        }
        return date || null;
    };
    Globalize.parseInt = function(value, radix, cultureSelector) {
        return truncate(Globalize.parseFloat(value, radix, cultureSelector));
    };
    Globalize.parseFloat = function(value, radix, cultureSelector) {
        // radix argument is optional
        if (typeof radix !== "number") {
            cultureSelector = radix;
            radix = 10;
        }
        var culture = this.findClosestCulture(cultureSelector);
        var ret = NaN, nf = culture.numberFormat;
        if (value.indexOf(culture.numberFormat.currency.symbol) > -1) {
            // remove currency symbol
            value = value.replace(culture.numberFormat.currency.symbol, "");
            // replace decimal seperator
            value = value.replace(culture.numberFormat.currency["."], culture.numberFormat["."]);
        }
        //Remove percentage character from number string before parsing
        if (value.indexOf(culture.numberFormat.percent.symbol) > -1) value = value.replace(culture.numberFormat.percent.symbol, "");
        // remove spaces: leading, trailing and between - and number. Used for negative currency pt-BR
        value = value.replace(/ /g, "");
        // allow infinity or hexidecimal
        if (regexInfinity.test(value)) ret = parseFloat(value);
        else if (!radix && regexHex.test(value)) ret = parseInt(value, 16);
        else {
            // determine sign and number
            var signInfo = parseNegativePattern(value, nf, nf.pattern[0]), sign = signInfo[0], num = signInfo[1];
            // #44 - try parsing as "(n)"
            if (sign === "" && nf.pattern[0] !== "(n)") {
                signInfo = parseNegativePattern(value, nf, "(n)");
                sign = signInfo[0];
                num = signInfo[1];
            }
            // try parsing as "-n"
            if (sign === "" && nf.pattern[0] !== "-n") {
                signInfo = parseNegativePattern(value, nf, "-n");
                sign = signInfo[0];
                num = signInfo[1];
            }
            sign = sign || "+";
            // determine exponent and number
            var exponent, intAndFraction, exponentPos = num.indexOf("e");
            if (exponentPos < 0) exponentPos = num.indexOf("E");
            if (exponentPos < 0) {
                intAndFraction = num;
                exponent = null;
            } else {
                intAndFraction = num.substr(0, exponentPos);
                exponent = num.substr(exponentPos + 1);
            }
            // determine decimal position
            var integer, fraction, decSep = nf["."], decimalPos = intAndFraction.indexOf(decSep);
            if (decimalPos < 0) {
                integer = intAndFraction;
                fraction = null;
            } else {
                integer = intAndFraction.substr(0, decimalPos);
                fraction = intAndFraction.substr(decimalPos + decSep.length);
            }
            // handle groups (e.g. 1,000,000)
            var groupSep = nf[","];
            integer = integer.split(groupSep).join("");
            var altGroupSep = groupSep.replace(/\u00A0/g, " ");
            if (groupSep !== altGroupSep) integer = integer.split(altGroupSep).join("");
            // build a natively parsable number string
            var p = sign + integer;
            if (fraction !== null) p += "." + fraction;
            if (exponent !== null) {
                // exponent itself may have a number patternd
                var expSignInfo = parseNegativePattern(exponent, nf, "-n");
                p += "e" + (expSignInfo[0] || "+") + expSignInfo[1];
            }
            if (regexParseFloat.test(p)) ret = parseFloat(p);
        }
        return ret;
    };
    Globalize.culture = function(cultureSelector) {
        // setter
        if (typeof cultureSelector !== "undefined") this.cultureSelector = cultureSelector;
        // getter
        return this.findClosestCulture(cultureSelector) || this.cultures["default"];
    };
})(module.exports);

});

parcelRegister("lnG1F", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $f90c586f386acce2$var$globalizeLocalizers;

var $S29Lp = parcelRequire("S29Lp");
var $f90c586f386acce2$var$_propTypes2 = $f90c586f386acce2$var$_interopRequireDefault($S29Lp);

var $8cebN = parcelRequire("8cebN");
var $f90c586f386acce2$var$_configure2 = $f90c586f386acce2$var$_interopRequireDefault($8cebN);
function $f90c586f386acce2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f90c586f386acce2$var$endOfDecade(date) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + 10);
    date.setMilliseconds(date.getMilliseconds() - 1);
    return date;
}
function $f90c586f386acce2$var$endOfCentury(date) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + 100);
    date.setMilliseconds(date.getMilliseconds() - 1);
    return date;
}
function $f90c586f386acce2$var$globalizeLocalizers(globalize) {
    var localizers = globalize.locale && !globalize.cultures ? $f90c586f386acce2$var$newGlobalize(globalize) : $f90c586f386acce2$var$oldGlobalize(globalize);
    $f90c586f386acce2$var$_configure2.default.setLocalizers(localizers);
    return localizers;
}
function $f90c586f386acce2$var$newGlobalize(globalize) {
    var locale = function locale(culture) {
        return culture ? globalize(culture) : globalize;
    };
    var date = {
        formats: {
            date: {
                date: "short"
            },
            time: {
                time: "short"
            },
            default: {
                datetime: "medium"
            },
            header: "MMMM yyyy",
            footer: {
                date: "full"
            },
            weekday: "eeeeee",
            dayOfMonth: "dd",
            month: "MMM",
            year: "yyyy",
            decade: function decade(dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format($f90c586f386acce2$var$endOfDecade(dt), l.formats.year, culture);
            },
            century: function century(dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format($f90c586f386acce2$var$endOfCentury(dt), l.formats.year, culture);
            }
        },
        propType: $f90c586f386acce2$var$_propTypes2.default.oneOfType([
            $f90c586f386acce2$var$_propTypes2.default.string,
            $f90c586f386acce2$var$_propTypes2.default.object,
            $f90c586f386acce2$var$_propTypes2.default.func
        ]),
        firstOfWeek: function firstOfWeek(culture) {
            var date = new Date();
            //cldr-data doesn't seem to be zero based
            var localeDay = Math.max(parseInt(locale(culture).formatDate(date, {
                raw: "e"
            }), 10) - 1, 0);
            return Math.abs(date.getDay() - localeDay);
        },
        parse: function parse(value, format, culture) {
            format = typeof format === "string" ? {
                raw: format
            } : format;
            return locale(culture).parseDate(value, format);
        },
        format: function format(value, _format, culture) {
            _format = typeof _format === "string" ? {
                raw: _format
            } : _format;
            return locale(culture).formatDate(value, _format);
        }
    };
    var number = {
        formats: {
            default: {
                maximumFractionDigits: 0
            }
        },
        propType: $f90c586f386acce2$var$_propTypes2.default.oneOfType([
            $f90c586f386acce2$var$_propTypes2.default.object,
            $f90c586f386acce2$var$_propTypes2.default.func
        ]),
        // TODO major bump consistent ordering
        parse: function parse(value, culture) {
            return locale(culture).parseNumber(value);
        },
        format: function format(value, _format2, culture) {
            if (value == null) return value;
            if (_format2 && _format2.currency) return locale(culture).formatCurrency(value, _format2.currency, _format2);
            return locale(culture).formatNumber(value, _format2);
        },
        decimalChar: function decimalChar(format, culture) {
            var str = this.format(1.1, {
                raw: "0.0"
            }, culture);
            return str[str.length - 2] || ".";
        },
        precision: function precision(format) {
            return !format || format.maximumFractionDigits == null ? null : format.maximumFractionDigits;
        }
    };
    return {
        date: date,
        number: number
    };
}
function $f90c586f386acce2$var$oldGlobalize(globalize) {
    var shortNames = Object.create(null);
    function getCulture(culture) {
        return culture ? globalize.findClosestCulture(culture) : globalize.culture();
    }
    function firstOfWeek(culture) {
        culture = getCulture(culture);
        return culture && culture.calendar.firstDay || 0;
    }
    function shortDay(dayOfTheWeek) {
        var culture = getCulture(arguments[1]), name = culture.name, days = function days() {
            return culture.calendar.days.namesShort.slice();
        };
        var names = shortNames[name] || (shortNames[name] = days());
        return names[dayOfTheWeek.getDay()];
    }
    var date = {
        formats: {
            date: "d",
            time: "t",
            default: "f",
            header: "MMMM yyyy",
            footer: "D",
            weekday: shortDay,
            dayOfMonth: "dd",
            month: "MMM",
            year: "yyyy",
            decade: function decade(dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format($f90c586f386acce2$var$endOfDecade(dt), l.formats.year, culture);
            },
            century: function century(dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format($f90c586f386acce2$var$endOfCentury(dt), l.formats.year, culture);
            }
        },
        firstOfWeek: firstOfWeek,
        parse: function parse(value, format, culture) {
            return globalize.parseDate(value, format, culture);
        },
        format: function format(value, _format3, culture) {
            return globalize.format(value, _format3, culture);
        }
    };
    function formatData(format, _culture) {
        var culture = getCulture(_culture), numFormat = culture.numberFormat;
        if (typeof format === "string") {
            if (format.indexOf("p") !== -1) numFormat = numFormat.percent;
            if (format.indexOf("c") !== -1) numFormat = numFormat.curency;
        }
        return numFormat;
    }
    var number = {
        formats: {
            default: "D"
        },
        // TODO major bump consistent ordering
        parse: function parse(value, culture) {
            return globalize.parseFloat(value, 10, culture);
        },
        format: function format(value, _format4, culture) {
            return globalize.format(value, _format4, culture);
        },
        decimalChar: function decimalChar(format, culture) {
            var data = formatData(format, culture);
            return data["."] || ".";
        },
        precision: function precision(format, _culture) {
            var data = formatData(format, _culture);
            if (typeof format === "string" && format.length > 1) return parseFloat(format.substr(1));
            return data ? data.decimals : null;
        }
    };
    return {
        date: date,
        number: number
    };
}
module.exports = module.exports["default"];

});


parcelRegister("1reg7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10c35f9c513ca8d1$export$2e2bcd8739ae039; });

var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");

var $dBifK = parcelRequire("dBifK");

var $e6FFD = parcelRequire("e6FFD");
const $10c35f9c513ca8d1$var$TextInput = ({ value: value, onChange: onChange, onBlur: onBlur, isEditable: isEditable = true, isValid: isValid = true, nullReadOnlyValue: nullReadOnlyValue, style: style, formatter: formatter, parser: parser, ...props })=>{
    const errorStyles = {
        color: "#dc2d11",
        border: "2px solid #dc2d11"
    };
    const [inputValue, setInputValue] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(formatter ? formatter(value) : value);
    const handleChange = (event)=>{
        setInputValue(event.target.value);
        const parsedVal = parser ? parser(event.target.value) : event.target.value;
        onChange && onChange(parsedVal);
    };
    const handleBlur = (event)=>{
        // Format the value when the input loses focus
        const parsedVal = parser ? parser(event.target.value) : event.target.value;
        const formattedValue = formatter ? formatter(parsedVal) : parsedVal;
        setInputValue(formattedValue);
        onBlur && onBlur(parsedVal);
    };
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    (0, $7PdBe.useEffect)(()=>{
        if ((inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === document.activeElement) return;
        setInputValue(formatter ? formatter(value) : value);
    }, [
        value
    ]);
    if (isEditable) return /*#__PURE__*/ (0, $RSSjA.jsx)("input", {
        type: "text",
        value: inputValue,
        style: {
            ...!isValid ? errorStyles : {},
            ...style
        },
        onChange: handleChange,
        onBlur: handleBlur,
        ref: inputRef,
        ...props
    });
    else {
        if (value == null && nullReadOnlyValue != null) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).isString(nullReadOnlyValue)) return /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                children: nullReadOnlyValue
            });
            else return nullReadOnlyValue;
        } else return /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
            children: value
        });
    }
};
var $10c35f9c513ca8d1$export$2e2bcd8739ae039 = (0, $e6FFD.observer)($10c35f9c513ca8d1$var$TextInput);

});
parcelRegister("e6FFD", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return $a451f31cd2de4d8c$export$b6ae1bc530f4c149; });

var $d8hWe = parcelRequire("d8hWe");

var $7PdBe = parcelRequire("7PdBe");
parcelRequire("8moxf");
var $jfxKI = parcelRequire("jfxKI");
var $kZPHp = parcelRequire("kZPHp");
var $a451f31cd2de4d8c$var$symbolId = 0;
function $a451f31cd2de4d8c$var$createSymbol(name) {
    if (typeof Symbol === "function") return Symbol(name);
    var symbol = "__$mobx-react " + name + " (" + $a451f31cd2de4d8c$var$symbolId + ")";
    $a451f31cd2de4d8c$var$symbolId++;
    return symbol;
}
var $a451f31cd2de4d8c$var$createdSymbols = {};
function $a451f31cd2de4d8c$var$newSymbol(name) {
    if (!$a451f31cd2de4d8c$var$createdSymbols[name]) $a451f31cd2de4d8c$var$createdSymbols[name] = $a451f31cd2de4d8c$var$createSymbol(name);
    return $a451f31cd2de4d8c$var$createdSymbols[name];
}
function $a451f31cd2de4d8c$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($a451f31cd2de4d8c$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$a451f31cd2de4d8c$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $a451f31cd2de4d8c$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
} // based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $a451f31cd2de4d8c$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $a451f31cd2de4d8c$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$a451f31cd2de4d8c$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */ function $a451f31cd2de4d8c$var$setHiddenProp(target, prop, value) {
    if (!Object.hasOwnProperty.call(target, prop)) Object.defineProperty(target, prop, {
        enumerable: false,
        configurable: true,
        writable: true,
        value: value
    });
    else target[prop] = value;
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $a451f31cd2de4d8c$var$mobxMixins = /*#__PURE__*/ $a451f31cd2de4d8c$var$newSymbol("patchMixins");
var $a451f31cd2de4d8c$var$mobxPatchedDefinition = /*#__PURE__*/ $a451f31cd2de4d8c$var$newSymbol("patchedDefinition");
function $a451f31cd2de4d8c$var$getMixins(target, methodName) {
    var mixins = target[$a451f31cd2de4d8c$var$mobxMixins] = target[$a451f31cd2de4d8c$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $a451f31cd2de4d8c$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $a451f31cd2de4d8c$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $a451f31cd2de4d8c$var$wrapper.call.apply($a451f31cd2de4d8c$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $a451f31cd2de4d8c$var$patch(target, methodName, mixinMethod) {
    var mixins = $a451f31cd2de4d8c$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$a451f31cd2de4d8c$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $a451f31cd2de4d8c$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $a451f31cd2de4d8c$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $a451f31cd2de4d8c$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$a451f31cd2de4d8c$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $a451f31cd2de4d8c$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $a451f31cd2de4d8c$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $a451f31cd2de4d8c$var$mobxAdminProperty = (0, $d8hWe.$mobx) || "$mobx"; // BC
var $a451f31cd2de4d8c$var$mobxObserverProperty = /*#__PURE__*/ $a451f31cd2de4d8c$var$newSymbol("isMobXReactObserver");
var $a451f31cd2de4d8c$var$mobxIsUnmounted = /*#__PURE__*/ $a451f31cd2de4d8c$var$newSymbol("isUnmounted");
var $a451f31cd2de4d8c$var$skipRenderKey = /*#__PURE__*/ $a451f31cd2de4d8c$var$newSymbol("skipRender");
var $a451f31cd2de4d8c$var$isForcingUpdateKey = /*#__PURE__*/ $a451f31cd2de4d8c$var$newSymbol("isForcingUpdate");
function $a451f31cd2de4d8c$var$makeClassComponentObserver(componentClass) {
    var target = componentClass.prototype;
    if (componentClass[$a451f31cd2de4d8c$var$mobxObserverProperty]) {
        var displayName = $a451f31cd2de4d8c$var$getDisplayName(target);
        console.warn("The provided component class (" + displayName + ")\n                has already been declared as an observer component.");
    } else componentClass[$a451f31cd2de4d8c$var$mobxObserverProperty] = true;
    if (target.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $7PdBe.PureComponent)) {
        if (!target.shouldComponentUpdate) target.shouldComponentUpdate = $a451f31cd2de4d8c$var$observerSCU;
        else if (target.shouldComponentUpdate !== $a451f31cd2de4d8c$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    } // this.props and this.state are made observable, just to make sure @computed fields that
    // are defined inside the component, and which rely on state or props, re-compute if state or props change
    // (otherwise the computed wouldn't update and become stale on props change, since props are not observable)
    // However, this solution is not without it's own problems: https://github.com/mobxjs/mobx-react/issues?utf8=%E2%9C%93&q=is%3Aissue+label%3Aobservable-props-or-not+
    $a451f31cd2de4d8c$var$makeObservableProp(target, "props");
    $a451f31cd2de4d8c$var$makeObservableProp(target, "state");
    if (componentClass.contextType) $a451f31cd2de4d8c$var$makeObservableProp(target, "context");
    var originalRender = target.render;
    if (typeof originalRender !== "function") {
        var _displayName = $a451f31cd2de4d8c$var$getDisplayName(target);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    target.render = function() {
        this.render = (0, $jfxKI.isUsingStaticRendering)() ? originalRender : $a451f31cd2de4d8c$var$createReactiveRender.call(this, originalRender);
        return this.render();
    };
    $a451f31cd2de4d8c$var$patch(target, "componentDidMount", function() {
        this[$a451f31cd2de4d8c$var$mobxIsUnmounted] = false;
        if (!this.render[$a451f31cd2de4d8c$var$mobxAdminProperty]) // Reaction is re-created automatically during render, but a component can re-mount and skip render #3395.
        // To re-create the reaction and re-subscribe to relevant observables we have to force an update.
        (0, $7PdBe.Component).prototype.forceUpdate.call(this);
    });
    $a451f31cd2de4d8c$var$patch(target, "componentWillUnmount", function() {
        if ((0, $jfxKI.isUsingStaticRendering)()) return;
        var reaction = this.render[$a451f31cd2de4d8c$var$mobxAdminProperty];
        if (reaction) {
            reaction.dispose(); // Forces reaction to be re-created on next render
            this.render[$a451f31cd2de4d8c$var$mobxAdminProperty] = null;
        } else {
            // Render may have been hot-swapped and/or overridden by a subclass.
            var _displayName2 = $a451f31cd2de4d8c$var$getDisplayName(this);
            console.warn("The reactive render of an observer class component (" + _displayName2 + ")\n                was overridden after MobX attached. This may result in a memory leak if the\n                overridden reactive render was not properly disposed.");
        }
        this[$a451f31cd2de4d8c$var$mobxIsUnmounted] = true;
    });
    return componentClass;
} // Generates a friendly name for debugging
function $a451f31cd2de4d8c$var$getDisplayName(comp) {
    return comp.displayName || comp.name || comp.constructor && (comp.constructor.displayName || comp.constructor.name) || "<component>";
}
function $a451f31cd2de4d8c$var$createReactiveRender(originalRender) {
    var _this = this;
    /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */ $a451f31cd2de4d8c$var$setHiddenProp(this, $a451f31cd2de4d8c$var$skipRenderKey, false);
    /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */ $a451f31cd2de4d8c$var$setHiddenProp(this, $a451f31cd2de4d8c$var$isForcingUpdateKey, false);
    var initialName = $a451f31cd2de4d8c$var$getDisplayName(this);
    var boundOriginalRender = originalRender.bind(this);
    var isRenderingPending = false;
    var createReaction = function createReaction() {
        var reaction = new (0, $d8hWe.Reaction)(initialName + ".render()", function() {
            if (!isRenderingPending) {
                // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.test.tsx)
                // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                // See #85 / Pull #44
                isRenderingPending = true;
                if (_this[$a451f31cd2de4d8c$var$mobxIsUnmounted] !== true) {
                    var hasError = true;
                    try {
                        $a451f31cd2de4d8c$var$setHiddenProp(_this, $a451f31cd2de4d8c$var$isForcingUpdateKey, true);
                        if (!_this[$a451f31cd2de4d8c$var$skipRenderKey]) (0, $7PdBe.Component).prototype.forceUpdate.call(_this);
                        hasError = false;
                    } finally{
                        $a451f31cd2de4d8c$var$setHiddenProp(_this, $a451f31cd2de4d8c$var$isForcingUpdateKey, false);
                        if (hasError) {
                            reaction.dispose(); // Forces reaction to be re-created on next render
                            _this.render[$a451f31cd2de4d8c$var$mobxAdminProperty] = null;
                        }
                    }
                }
            }
        });
        reaction["reactComponent"] = _this;
        return reaction;
    };
    function reactiveRender() {
        var _reactiveRender$mobxA;
        isRenderingPending = false; // Create reaction lazily to support re-mounting #3395
        var reaction = (_reactiveRender$mobxA = reactiveRender[$a451f31cd2de4d8c$var$mobxAdminProperty]) != null ? _reactiveRender$mobxA : reactiveRender[$a451f31cd2de4d8c$var$mobxAdminProperty] = createReaction();
        var exception = undefined;
        var rendering = undefined;
        reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                rendering = (0, $d8hWe._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                exception = e;
            }
        });
        if (exception) throw exception;
        return rendering;
    }
    return reactiveRender;
}
function $a451f31cd2de4d8c$var$observerSCU(nextProps, nextState) {
    if ((0, $jfxKI.isUsingStaticRendering)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
     // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
     // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$a451f31cd2de4d8c$var$shallowEqual(this.props, nextProps);
}
function $a451f31cd2de4d8c$var$makeObservableProp(target, propName) {
    var valueHolderKey = $a451f31cd2de4d8c$var$newSymbol("reactProp_" + propName + "_valueHolder");
    var atomHolderKey = $a451f31cd2de4d8c$var$newSymbol("reactProp_" + propName + "_atomHolder");
    function getAtom() {
        if (!this[atomHolderKey]) $a451f31cd2de4d8c$var$setHiddenProp(this, atomHolderKey, (0, $d8hWe.createAtom)("reactive " + propName));
        return this[atomHolderKey];
    }
    Object.defineProperty(target, propName, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var prevReadState = false; // Why this check? BC?
            // @ts-expect-error
            if ((0, $d8hWe._allowStateReadsStart) && (0, $d8hWe._allowStateReadsEnd)) prevReadState = (0, $d8hWe._allowStateReadsStart)(true);
            getAtom.call(this).reportObserved(); // Why this check? BC?
            // @ts-expect-error
            if ((0, $d8hWe._allowStateReadsStart) && (0, $d8hWe._allowStateReadsEnd)) (0, $d8hWe._allowStateReadsEnd)(prevReadState);
            return this[valueHolderKey];
        },
        set: function set(v) {
            if (!this[$a451f31cd2de4d8c$var$isForcingUpdateKey] && !$a451f31cd2de4d8c$var$shallowEqual(this[valueHolderKey], v)) {
                $a451f31cd2de4d8c$var$setHiddenProp(this, valueHolderKey, v);
                $a451f31cd2de4d8c$var$setHiddenProp(this, $a451f31cd2de4d8c$var$skipRenderKey, true);
                getAtom.call(this).reportChanged();
                $a451f31cd2de4d8c$var$setHiddenProp(this, $a451f31cd2de4d8c$var$skipRenderKey, false);
            } else $a451f31cd2de4d8c$var$setHiddenProp(this, valueHolderKey, v);
        }
    });
}
/**
 * Observer function / decorator
 */ function $a451f31cd2de4d8c$export$b6ae1bc530f4c149(component) {
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $7PdBe.Component), component) || Object.prototype.isPrototypeOf.call((0, $7PdBe.PureComponent), component)) // Class component
    return $a451f31cd2de4d8c$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $kZPHp.observer)(component);
}
function $a451f31cd2de4d8c$var$_extends() {
    $a451f31cd2de4d8c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a451f31cd2de4d8c$var$_extends.apply(this, arguments);
}
function $a451f31cd2de4d8c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a451f31cd2de4d8c$var$_excluded = [
    "children"
];
var $a451f31cd2de4d8c$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createContext({});
function $a451f31cd2de4d8c$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $a451f31cd2de4d8c$var$_objectWithoutPropertiesLoose(props, $a451f31cd2de4d8c$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useContext($a451f31cd2de4d8c$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef($a451f31cd2de4d8c$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement($a451f31cd2de4d8c$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$a451f31cd2de4d8c$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $a451f31cd2de4d8c$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).forwardRef(function(props, ref) {
        var newProps = $a451f31cd2de4d8c$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useContext($a451f31cd2de4d8c$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $a451f31cd2de4d8c$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $a451f31cd2de4d8c$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $a451f31cd2de4d8c$var$getInjectName(component, injectNames);
    return Injector;
}
function $a451f31cd2de4d8c$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $a451f31cd2de4d8c$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $a451f31cd2de4d8c$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $a451f31cd2de4d8c$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $a451f31cd2de4d8c$var$createStoreInjector($a451f31cd2de4d8c$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $a451f31cd2de4d8c$var$protoStoreKey = /*#__PURE__*/ $a451f31cd2de4d8c$var$newSymbol("disposeOnUnmountProto");
var $a451f31cd2de4d8c$var$instStoreKey = /*#__PURE__*/ $a451f31cd2de4d8c$var$newSymbol("disposeOnUnmountInst");
function $a451f31cd2de4d8c$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$a451f31cd2de4d8c$var$protoStoreKey] || [], this[$a451f31cd2de4d8c$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
function $a451f31cd2de4d8c$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $a451f31cd2de4d8c$export$4e749cb731da87a9(target, fn);
    });
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor); // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
     // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string"; // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$a451f31cd2de4d8c$var$protoStoreKey] || !!target[$a451f31cd2de4d8c$var$instStoreKey];
    var store = isDecorator ? target[$a451f31cd2de4d8c$var$protoStoreKey] || (target[$a451f31cd2de4d8c$var$protoStoreKey] = []) : target[$a451f31cd2de4d8c$var$instStoreKey] || (target[$a451f31cd2de4d8c$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $a451f31cd2de4d8c$var$patch(target, "componentWillUnmount", $a451f31cd2de4d8c$var$runDisposersOnWillUnmount);
     // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
function $a451f31cd2de4d8c$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $d8hWe.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false); // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
} // Copied from React.PropTypes
function $a451f31cd2de4d8c$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
     // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
     // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
} // Copied from React.PropTypes
function $a451f31cd2de4d8c$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($a451f31cd2de4d8c$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $a451f31cd2de4d8c$var$getPreciseType(propValue) {
    var propType = $a451f31cd2de4d8c$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $a451f31cd2de4d8c$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $a451f31cd2de4d8c$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $d8hWe.untracked)(function() {
            if (allowNativeType) {
                if ($a451f31cd2de4d8c$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $d8hWe.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $d8hWe.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $d8hWe.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $a451f31cd2de4d8c$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $a451f31cd2de4d8c$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $a451f31cd2de4d8c$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $d8hWe.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $a451f31cd2de4d8c$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $a451f31cd2de4d8c$var$observableArray = /*#__PURE__*/ $a451f31cd2de4d8c$var$createObservableTypeCheckerCreator(false, "Array");
var $a451f31cd2de4d8c$var$observableArrayOf = /*#__PURE__*/ $a451f31cd2de4d8c$var$createObservableArrayOfTypeChecker.bind(null, false);
var $a451f31cd2de4d8c$var$observableMap = /*#__PURE__*/ $a451f31cd2de4d8c$var$createObservableTypeCheckerCreator(false, "Map");
var $a451f31cd2de4d8c$var$observableObject = /*#__PURE__*/ $a451f31cd2de4d8c$var$createObservableTypeCheckerCreator(false, "Object");
var $a451f31cd2de4d8c$var$arrayOrObservableArray = /*#__PURE__*/ $a451f31cd2de4d8c$var$createObservableTypeCheckerCreator(true, "Array");
var $a451f31cd2de4d8c$var$arrayOrObservableArrayOf = /*#__PURE__*/ $a451f31cd2de4d8c$var$createObservableArrayOfTypeChecker.bind(null, true);
var $a451f31cd2de4d8c$var$objectOrObservableObject = /*#__PURE__*/ $a451f31cd2de4d8c$var$createObservableTypeCheckerCreator(true, "Object");
var $a451f31cd2de4d8c$export$e0c95a451cd220b7 = {
    observableArray: $a451f31cd2de4d8c$var$observableArray,
    observableArrayOf: $a451f31cd2de4d8c$var$observableArrayOf,
    observableMap: $a451f31cd2de4d8c$var$observableMap,
    observableObject: $a451f31cd2de4d8c$var$observableObject,
    arrayOrObservableArray: $a451f31cd2de4d8c$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $a451f31cd2de4d8c$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $a451f31cd2de4d8c$var$objectOrObservableObject
};
if (!(0, $7PdBe.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $d8hWe.observable)) throw new Error("mobx-react requires mobx to be available");

});
parcelRegister("8moxf", function(module, exports) {

$parcel$export(module.exports, "isUsingStaticRendering", function () { return (parcelRequire("jfxKI")).isUsingStaticRendering; });
$parcel$export(module.exports, "observer", function () { return (parcelRequire("kZPHp")).observer; });
parcelRequire("gAQCe");
parcelRequire("cvveR");
var $1cUCD = parcelRequire("1cUCD");

var $g6BXW = parcelRequire("g6BXW");
parcelRequire("fF8eg");

var $hphoA = parcelRequire("hphoA");

var $jfxKI = parcelRequire("jfxKI");

var $8Gu7i = parcelRequire("8Gu7i");

var $kZPHp = parcelRequire("kZPHp");

var $aE6YX = parcelRequire("aE6YX");

var $aLW4E = parcelRequire("aLW4E");

var $bRCcz = parcelRequire("bRCcz");

var $eAxd5 = parcelRequire("eAxd5");
var $616368fe09ee017c$var$_a;
(0, $g6BXW.observerBatching)((0, $1cUCD.unstable_batchedUpdates));
var $616368fe09ee017c$export$469d51fb8d268227 = ($616368fe09ee017c$var$_a = (0, $8Gu7i.observerFinalizationRegistry)["finalizeAllImmediately"]) !== null && $616368fe09ee017c$var$_a !== void 0 ? $616368fe09ee017c$var$_a : function() {};
function $616368fe09ee017c$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $hphoA.useObserver)(fn, baseComponentName);
}
function $616368fe09ee017c$export$7613124ee4202834(enable) {
    (0, $jfxKI.enableStaticRendering)(enable);
}

});
parcelRegister("gAQCe", function(module, exports) {

var $d8hWe = parcelRequire("d8hWe");

var $7PdBe = parcelRequire("7PdBe");
if (!(0, $7PdBe.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $d8hWe.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

});

parcelRegister("cvveR", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("1cUCD")).unstable_batchedUpdates; });

var $1cUCD = parcelRequire("1cUCD");

});

parcelRegister("g6BXW", function(module, exports) {

$parcel$export(module.exports, "observerBatching", function () { return $bb9aa81f15f124e7$export$294943bbc3c74f4f; });

var $d8hWe = parcelRequire("d8hWe");
function $bb9aa81f15f124e7$export$fb2daceae6f5097a(callback) {
    callback();
}
function $bb9aa81f15f124e7$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $bb9aa81f15f124e7$export$fb2daceae6f5097a;
    (0, $d8hWe.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $bb9aa81f15f124e7$export$13ce1459b9a04b51 = function() {
    return true;
};

});

parcelRegister("fF8eg", function(module, exports) {
var $b6711179ce0de5cb$var$deprecatedMessages = [];
function $b6711179ce0de5cb$export$be38475be17599d(msg) {
    if (!$b6711179ce0de5cb$var$deprecatedMessages.includes(msg)) {
        $b6711179ce0de5cb$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

});

parcelRegister("hphoA", function(module, exports) {

$parcel$export(module.exports, "useObserver", function () { return $cac243dc5c8c1ef3$export$b9c7ecd090a87b14; });

var $d8hWe = parcelRequire("d8hWe");

var $7PdBe = parcelRequire("7PdBe");

var $3HFsr = parcelRequire("3HFsr");

var $8Gu7i = parcelRequire("8Gu7i");

var $jfxKI = parcelRequire("jfxKI");
var $cac243dc5c8c1ef3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $cac243dc5c8c1ef3$var$observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var $cac243dc5c8c1ef3$var$ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function $cac243dc5c8c1ef3$var$objectToBeRetainedByReactFactory() {
    return new $cac243dc5c8c1ef3$var$ObjectToBeRetainedByReact();
}
function $cac243dc5c8c1ef3$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $jfxKI.isUsingStaticRendering)()) return fn();
    var _a = $cac243dc5c8c1ef3$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState($cac243dc5c8c1ef3$var$objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = $cac243dc5c8c1ef3$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(), 2), setState = _b[1];
    var forceUpdate = function() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    if (!admRef.current) // First render
    admRef.current = {
        reaction: null,
        mounted: false,
        changedBeforeMount: false
    };
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or component was not committed and reaction was disposed by registry
        adm.reaction = new (0, $d8hWe.Reaction)($cac243dc5c8c1ef3$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (adm.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            adm.changedBeforeMount = true;
        });
        (0, $8Gu7i.observerFinalizationRegistry).register(objectRetainedByReact, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useDebugValue(adm.reaction, (0, $3HFsr.printDebugValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(function() {
        (0, $8Gu7i.observerFinalizationRegistry).unregister(adm);
        adm.mounted = true;
        if (adm.reaction) {
            if (adm.changedBeforeMount) {
                // Got a change before mount, force an update
                adm.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            adm.reaction = new (0, $d8hWe.Reaction)($cac243dc5c8c1ef3$var$observerComponentNameFor(baseComponentName), function() {
                // We've definitely already been mounted at this point
                forceUpdate();
            });
            forceUpdate();
        }
        return function() {
            adm.reaction.dispose();
            adm.reaction = null;
            adm.mounted = false;
            adm.changedBeforeMount = false;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    adm.reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}

});
parcelRegister("3HFsr", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", function () { return $2b258be878286816$export$ef795f1f307682c7; });

var $d8hWe = parcelRequire("d8hWe");
function $2b258be878286816$export$ef795f1f307682c7(v) {
    return (0, $d8hWe.getDependencyTree)(v);
}

});

parcelRegister("8Gu7i", function(module, exports) {

$parcel$export(module.exports, "observerFinalizationRegistry", function () { return $65299b8483e76ff4$export$10e8a12fbfd8583c; });

var $7ODRZ = parcelRequire("7ODRZ");
var $65299b8483e76ff4$export$10e8a12fbfd8583c = new (0, $7ODRZ.UniversalFinalizationRegistry)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});

});
parcelRegister("7ODRZ", function(module, exports) {

$parcel$export(module.exports, "UniversalFinalizationRegistry", function () { return $5b0c213f6472a1cc$export$da5d55a244964b51; });
var $5b0c213f6472a1cc$export$e901ba0ffe10ba41 = 10000;
var $5b0c213f6472a1cc$export$1ae22ce5a82f26b6 = 10000;
var $5b0c213f6472a1cc$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $5b0c213f6472a1cc$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $5b0c213f6472a1cc$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $5b0c213f6472a1cc$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $5b0c213f6472a1cc$export$b7a00d372cedeedd;

});


parcelRegister("jfxKI", function(module, exports) {

$parcel$export(module.exports, "enableStaticRendering", function () { return $e039999843ab4100$export$5d52eaa7c0f24c9e; });
$parcel$export(module.exports, "isUsingStaticRendering", function () { return $e039999843ab4100$export$55979271896d643e; });
var $e039999843ab4100$var$globalIsUsingStaticRendering = false;
function $e039999843ab4100$export$5d52eaa7c0f24c9e(enable) {
    $e039999843ab4100$var$globalIsUsingStaticRendering = enable;
}
function $e039999843ab4100$export$55979271896d643e() {
    return $e039999843ab4100$var$globalIsUsingStaticRendering;
}

});


parcelRegister("kZPHp", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return $f4919b8b078fbb4d$export$b6ae1bc530f4c149; });

var $7PdBe = parcelRequire("7PdBe");

var $jfxKI = parcelRequire("jfxKI");

var $hphoA = parcelRequire("hphoA");
var $f4919b8b078fbb4d$var$warnObserverOptionsDeprecated = true;
var $f4919b8b078fbb4d$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $f4919b8b078fbb4d$var$ReactForwardRefSymbol = $f4919b8b078fbb4d$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $7PdBe.forwardRef) === "function" && (0, $7PdBe.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $f4919b8b078fbb4d$var$ReactMemoSymbol = $f4919b8b078fbb4d$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $7PdBe.memo) === "function" && (0, $7PdBe.memo)(function(props) {
    return null;
})["$$typeof"];
function $f4919b8b078fbb4d$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($f4919b8b078fbb4d$var$ReactMemoSymbol && baseComponent["$$typeof"] === $f4919b8b078fbb4d$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $jfxKI.isUsingStaticRendering)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($f4919b8b078fbb4d$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $f4919b8b078fbb4d$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $hphoA.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") observerComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $7PdBe.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $7PdBe.memo)(observerComponent);
    $f4919b8b078fbb4d$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $f4919b8b078fbb4d$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $f4919b8b078fbb4d$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$f4919b8b078fbb4d$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});

parcelRegister("aE6YX", function(module, exports) {

var $hphoA = parcelRequire("hphoA");
function $7c030e58aa871efa$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $hphoA.useObserver)(component);
}
$7c030e58aa871efa$export$c1cbdee04e18ea8b.displayName = "Observer";
function $7c030e58aa871efa$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("aLW4E", function(module, exports) {

var $d8hWe = parcelRequire("d8hWe");

var $7PdBe = parcelRequire("7PdBe");
function $7d7b577a70bd7cdf$export$aa207039f277c5f(initializer, annotations) {
    return (0, $7PdBe.useState)(function() {
        return (0, $d8hWe.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

});

parcelRegister("bRCcz", function(module, exports) {

var $d8hWe = parcelRequire("d8hWe");

var $7PdBe = parcelRequire("7PdBe");
parcelRequire("fF8eg");

var $eAxd5 = parcelRequire("eAxd5");
function $8a3247076447a965$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $eAxd5.useAsObservableSource)(current);
    return (0, $7PdBe.useState)(function() {
        return (0, $d8hWe.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

});
parcelRegister("eAxd5", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSource", function () { return $02bda5f0cc9d4df7$export$e0ded3646391939c; });
parcelRequire("fF8eg");

var $d8hWe = parcelRequire("d8hWe");

var $7PdBe = parcelRequire("7PdBe");
var $02bda5f0cc9d4df7$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $02bda5f0cc9d4df7$export$e0ded3646391939c(current) {
    var _a = $02bda5f0cc9d4df7$var$__read((0, $7PdBe.useState)(function() {
        return (0, $d8hWe.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $d8hWe.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

});





parcelRegister("1xiEk", function(module, exports) {

$parcel$export(module.exports, "HoursInput", function () { return $11e756ed80532a64$export$1f7201f597f5f219; });

var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");

var $ksXgP = parcelRequire("ksXgP");

var $4bOnx = parcelRequire("4bOnx");

var $S29Lp = parcelRequire("S29Lp");
const $11e756ed80532a64$export$1f7201f597f5f219 = ({ value: value, className: className, onChange: onChange, isEditable: isEditable = true, style: style })=>{
    const [val, setVal] = (0, $7PdBe.useState)(formatFunc(value));
    const inputRef = (0, $7PdBe.useRef)(null);
    (0, $7PdBe.useEffect)(()=>{
        if (document.activeElement !== inputRef.current) setVal(formatFunc(value));
    }, [
        value
    ]);
    const handleChange = (event)=>{
        let text = event.target.value;
        setVal(text);
        let time = (0, $4bOnx.parseTime)(text);
        onChange(time != null ? time : text);
    };
    const handleBlur = ()=>{
        let [time, isValid] = parseFunc(val);
        if (isValid) setVal(formatFunc(time));
    };
    const handleFocus = ()=>{
        // Select the text box's contents on focus. For some reason if we don't
        // do this in a $timeout the contents are momentarily selected and then
        // deselected.
        setTimeout(()=>{
            let node = inputRef.current;
            if (node === document.activeElement) node.select();
        });
    };
    const handleKeyUp = (event)=>{
        let [currentVal, isValid] = parseFunc(val);
        if (isValid) {
            let newTime = null;
            if (event.keyCode === 38) // Up arrow: + 15 minutes
            newTime = currentVal + 15;
            else if (event.keyCode === 40) // Down arrow: - 15 minutes
            {
                if (currentVal >= 15) newTime = currentVal - 15;
            }
            if (newTime != null) {
                setVal(formatFunc(newTime));
                onChange(newTime);
            }
        }
    };
    let [_, isValid] = parseFunc(val);
    if (isEditable) return /*#__PURE__*/ (0, $RSSjA.jsx)("input", {
        ref: inputRef,
        type: "text",
        value: val,
        onKeyUp: handleKeyUp,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ksXgP)))(className, {
            classNameInvalid: !isValid
        }),
        disabled: !isEditable,
        style: {
            textAlign: "right",
            ...style
        }
    });
    else return /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
        children: val
    });
    function formatFunc(n) {
        return (0, $4bOnx.isNumber)(n) ? (0, $4bOnx.formatMinutes)(n) : n;
    }
    function parseFunc(text) {
        let time = (0, $4bOnx.parseTime)(text);
        return [
            time,
            time != null
        ];
    }
};
$11e756ed80532a64$export$1f7201f597f5f219.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
        // Valid state
        (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string // Invalid state
    ]).isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).any,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func.isRequired,
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).bool,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).object
};

});




parcelRegister("bBGgZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8733f0f7ccdd92bf$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");
parcelRequire("7PdBe");

var $dBifK = parcelRequire("dBifK");

var $cjCbh = parcelRequire("cjCbh");


var $lsKv3 = parcelRequire("lsKv3");

parcelRequire("fYF9X");

var $eSkAj = parcelRequire("eSkAj");

var $5Xh7w = parcelRequire("5Xh7w");
var $8733f0f7ccdd92bf$var$_class;
function $8733f0f7ccdd92bf$var$_defineProperty(e, r, t) {
    return (r = $8733f0f7ccdd92bf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8733f0f7ccdd92bf$var$_toPropertyKey(t) {
    var i = $8733f0f7ccdd92bf$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8733f0f7ccdd92bf$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $8733f0f7ccdd92bf$var$TableRowStore = ($8733f0f7ccdd92bf$var$_class = class TableRowStore {
    constructor({ id: id, table: table, rowObject: rowObject, childComponent: childComponent, group: group, childRows: childRows }){
        $8733f0f7ccdd92bf$var$_defineProperty(this, "id", (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))());
        $8733f0f7ccdd92bf$var$_defineProperty(this, "table", {});
        $8733f0f7ccdd92bf$var$_defineProperty(this, "rowObject", {});
        $8733f0f7ccdd92bf$var$_defineProperty(this, "rowOptions", {});
        $8733f0f7ccdd92bf$var$_defineProperty(this, "group", undefined);
        $8733f0f7ccdd92bf$var$_defineProperty(this, "_cellsByColumnId", new Map());
        (0, $d8hWe.makeObservable)(this);
        this.id = id !== null && id !== void 0 ? id : this.id;
        this.table = table !== null && table !== void 0 ? table : this.table;
        this.rowObject = rowObject !== null && rowObject !== void 0 ? rowObject : this.rowObject;
        this.childComponent = childComponent;
        this.group = group;
        this._childRows = childRows || new Set();
    }
    getOrCreateCell(column) {
        if (!this._cellsByColumnId.get(column.id || column)) this._cellsByColumnId.set(column.id || column, new (0, $eSkAj.default)({
            table: this.table,
            column: column,
            row: this
        }));
        return this._cellsByColumnId.get(column.id || column);
    }
    updateColumn(column) {
        this._cellsByColumnId.set(column.id, new (0, $eSkAj.default)({
            table: this.table,
            column: column,
            row: this
        }));
    }
    get cells() {
        const cells = {};
        this.table._columns.forEach((column)=>{
            cells[column.id] = this.getOrCreateCell(column);
        });
        return cells;
    }
    get groupLevel() {
        const groupIndex = this.table.groups.findIndex((g)=>g === this.group);
        return groupIndex >= 0 ? groupIndex : this.table.groups.length;
    }
    get parent() {
        return this.table._rows.filter((r)=>r._childRows.has(this))[0];
    }
    get expanded() {
        return this.table.expandedRows.has(this) || this.table.expandedGroups.includes(this.group);
    }
    get childRows() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).orderBy([
            ...this._childRows
        ].filter((cr)=>cr.visible), [
            (r)=>r.rowObject.isNew,
            ...this.table.sortBy.map(([prop, direction])=>(r)=>{
                    let val;
                    if (typeof prop === "string") val = r.cells[prop].value;
                    else val = prop(r);
                    return val || Infinity;
                }),
            (r)=>r.rowObject.initiatedAt
        ], [
            "desc",
            ...this.table.sortBy.map(([prop, direction])=>direction),
            "asc"
        ]);
    }
    get descendants() {
        const descendants = [];
        if (this.childRows.length) this.childRows.forEach((cr)=>{
            descendants.push(...cr.descendants);
        });
        else descendants.push(this);
        return descendants;
    }
    get ungroupedDescendants() {
        return this.descendants.filter((r)=>!r.group);
    }
    get visible() {
        return this.table.filters.every(({ column: column, operator: operator, value: value, group: group })=>{
            var _Filters$type, _Filters$type$operato;
            if (group !== this.group) return true;
            const val = this.cells[column].value;
            if (this.cells[column].equalityComparatorValue == null) return false;
            const type = this.cells[column].type;
            const not = operator.includes("!");
            const matchFilter = (_Filters$type = (0, $lsKv3.default)[type]) === null || _Filters$type === void 0 ? void 0 : (_Filters$type$operato = _Filters$type[operator.replace("!", "")]) === null || _Filters$type$operato === void 0 ? void 0 : _Filters$type$operato.call(_Filters$type, val, value);
            return not ? !matchFilter : matchFilter;
        });
    }
}, $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "getOrCreateCell", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "getOrCreateCell"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "updateColumn", [
    (0, $d8hWe.action)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "updateColumn"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "cells", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "cells"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "groupLevel", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "groupLevel"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "parent", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "parent"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "expanded", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "expanded"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "childRows", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "childRows"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "descendants", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "descendants"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "ungroupedDescendants", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "ungroupedDescendants"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_applyDecoratedDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "visible", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8733f0f7ccdd92bf$var$_class.prototype, "visible"), $8733f0f7ccdd92bf$var$_class.prototype), $8733f0f7ccdd92bf$var$_class);
var $8733f0f7ccdd92bf$export$2e2bcd8739ae039 = $8733f0f7ccdd92bf$var$TableRowStore;

});
parcelRegister("eSkAj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad461389c183139d$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");
parcelRequire("7PdBe");
parcelRequire("dBifK");

var $cjCbh = parcelRequire("cjCbh");

parcelRequire("lsKv3");

var $9WFAs = parcelRequire("9WFAs");
var $ad461389c183139d$var$_class;
function $ad461389c183139d$var$_defineProperty(e, r, t) {
    return (r = $ad461389c183139d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ad461389c183139d$var$_toPropertyKey(t) {
    var i = $ad461389c183139d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ad461389c183139d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ad461389c183139d$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $ad461389c183139d$var$TableCellStore = ($ad461389c183139d$var$_class = class TableCellStore {
    constructor({ table: table, row: row, column: column }){
        $ad461389c183139d$var$_defineProperty(this, "id", (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))());
        $ad461389c183139d$var$_defineProperty(this, "table", {});
        $ad461389c183139d$var$_defineProperty(this, "row", {});
        $ad461389c183139d$var$_defineProperty(this, "column", {});
        (0, $d8hWe.makeObservable)(this);
        this.table = table !== null && table !== void 0 ? table : this.table;
        this.row = row !== null && row !== void 0 ? row : this.row;
        this.column = column !== null && column !== void 0 ? column : this.column;
    }
    get stores() {
        return {
            cell: this,
            row: this.row,
            column: this.column,
            table: this.table
        };
    }
    get rowObject() {
        return this.row.rowObject;
    }
    get group() {
        return this.row.group;
    }
    get type() {
        return this.column.type;
    }
    get data() {
        return this.column.data;
    }
    get editable() {
        return this.rowObject && this.column.editable(this.rowObject, this.stores);
    }
    get onChange() {
        var _this$column$onChange, _this$column;
        return (_this$column$onChange = (_this$column = this.column).onChange) === null || _this$column$onChange === void 0 ? void 0 : _this$column$onChange.call(_this$column, this.rowObject, this.stores);
    }
    get onClick() {
        var _this$column$onClick, _this$column2;
        return (_this$column$onClick = (_this$column2 = this.column).onClick) === null || _this$column$onClick === void 0 ? void 0 : _this$column$onClick.call(_this$column2, this.rowObject, this.stores);
    }
    get onFocus() {
        var _this$column$onFocus, _this$column3;
        return (_this$column$onFocus = (_this$column3 = this.column).onFocus) === null || _this$column$onFocus === void 0 ? void 0 : _this$column$onFocus.call(_this$column3, this.rowObject, this.stores);
    }
    get onBlur() {
        var _this$column$onBlur, _this$column4;
        return (_this$column$onBlur = (_this$column4 = this.column).onBlur) === null || _this$column$onBlur === void 0 ? void 0 : _this$column$onBlur.call(_this$column4, this.rowObject, this.stores);
    }
    get value() {
        if (!this.hasPermission) return null;
        const getBestValue = (values)=>{
            let sortValue = null;
            let bestValue = null;
            for (let v of values)if (v) {
                sortValue = this.column.sortComparator((v === null || v === void 0 ? void 0 : v[0]) || v, this.stores);
                bestValue = v;
                break;
            }
            if (!sortValue || typeof sortValue === "number" && !isFinite(sortValue)) for (let v of values){
                let sv = this.column.sortComparator((v === null || v === void 0 ? void 0 : v[0]) || v, this.stores);
                if (sv !== null && sv !== undefined && isFinite(sv)) {
                    sortValue = sv;
                    bestValue = v;
                    break;
                }
            }
            return bestValue;
        };
        const value = getBestValue([
            $ad461389c183139d$var$tryOrNull(()=>this.column.value(this.rowObject, this.stores)),
            this.rowObject[this.column.id],
            this.row.childRows.length ? this.column.aggregator(this.row.descendants.map((d)=>d.cells[this.column.id].value), this.stores) : null
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($9WFAs))).array(value) && value.length === 1 ? value[0] : (0, (/*@__PURE__*/$parcel$interopDefault($9WFAs))).array(value) && value.length === 0 ? null : value;
    }
    get formattedValue() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($9WFAs))).array(this.value)) return this.column.groupFormatter(this.value, this.stores);
        else return this.column.formatter(this.value, this.stores);
    }
    get formattedCSVValue() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($9WFAs))).array(this.value)) return this.column.csvGroupFormatter(this.value, this.stores);
        else return this.column.csvFormatter(this.value, this.stores);
    }
    get equalityComparatorValue() {
        let value = (0, (/*@__PURE__*/$parcel$interopDefault($9WFAs))).array(this.value) ? this.value[0] : this.value;
        return this.column.equalityComparator(value, this.stores);
    }
    get sortComparatorValue() {
        let value = (0, (/*@__PURE__*/$parcel$interopDefault($9WFAs))).array(this.value) ? this.value[0] : this.value;
        return this.column.sortComparator(value, this.stores);
    }
    get component() {
        var _this$column$cellComp, _this$column5;
        return (_this$column$cellComp = (_this$column5 = this.column).cellComponent) === null || _this$column$cellComp === void 0 ? void 0 : _this$column$cellComp.call(_this$column5, {
            value: this.value,
            group: this.group,
            formattedValue: this.formattedValue,
            formatter: this.column.formatter,
            editable: this.editable,
            onChange: this.onChange,
            onClick: this.onClick,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            stores: this.stores
        });
    }
    get readOnlyComponent() {
        return this.column.cellComponent({
            value: this.value,
            group: this.group,
            formattedValue: this.formattedValue,
            formatter: this.column.formatter,
            editable: false,
            stores: this.stores
        });
    }
    get style() {
        return this.column.style(this.rowObject, this.stores);
    }
    get className() {
        return this.column.className(this.rowObject, this.stores);
    }
    get selected() {
        return this.column.selected(this.rowObject, this.stores);
    }
    get hasPermission() {
        return this.column.permissions(this.rowObject, this.stores);
    }
}, $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "stores", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "stores"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "rowObject", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "rowObject"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "group", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "group"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "type", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "type"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "data", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "data"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "editable", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "editable"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "onChange", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "onChange"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "onClick", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "onClick"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "onFocus", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "onFocus"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "onBlur", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "onBlur"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "value", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "value"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "formattedValue", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "formattedValue"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "formattedCSVValue", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "formattedCSVValue"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "equalityComparatorValue", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "equalityComparatorValue"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "sortComparatorValue", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "sortComparatorValue"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "component", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "component"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "readOnlyComponent", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "readOnlyComponent"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "style", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "style"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "className", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "className"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "selected", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "selected"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_applyDecoratedDescriptor($ad461389c183139d$var$_class.prototype, "hasPermission", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($ad461389c183139d$var$_class.prototype, "hasPermission"), $ad461389c183139d$var$_class.prototype), $ad461389c183139d$var$_class);
var $ad461389c183139d$export$2e2bcd8739ae039 = $ad461389c183139d$var$TableCellStore;
const $ad461389c183139d$var$tryOrNull = (func)=>{
    try {
        return func === null || func === void 0 ? void 0 : func();
    } catch (e) {
        // console.warn(e)
        return null;
    }
};

});
parcelRegister("9WFAs", function(module, exports) {
"use strict";
/// <reference lib="es2018"/>
/// <reference lib="dom"/>
/// <reference types="node"/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $73d9ca2d7adcc91c$var$typedArrayTypeNames = [
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Uint16Array",
    "Int32Array",
    "Uint32Array",
    "Float32Array",
    "Float64Array",
    "BigInt64Array",
    "BigUint64Array"
];
function $73d9ca2d7adcc91c$var$isTypedArrayName(name) {
    return $73d9ca2d7adcc91c$var$typedArrayTypeNames.includes(name);
}
const $73d9ca2d7adcc91c$var$objectTypeNames = [
    "Function",
    "Generator",
    "AsyncGenerator",
    "GeneratorFunction",
    "AsyncGeneratorFunction",
    "AsyncFunction",
    "Observable",
    "Array",
    "Buffer",
    "Blob",
    "Object",
    "RegExp",
    "Date",
    "Error",
    "Map",
    "Set",
    "WeakMap",
    "WeakSet",
    "ArrayBuffer",
    "SharedArrayBuffer",
    "DataView",
    "Promise",
    "URL",
    "FormData",
    "URLSearchParams",
    "HTMLElement",
    ...$73d9ca2d7adcc91c$var$typedArrayTypeNames
];
function $73d9ca2d7adcc91c$var$isObjectTypeName(name) {
    return $73d9ca2d7adcc91c$var$objectTypeNames.includes(name);
}
const $73d9ca2d7adcc91c$var$primitiveTypeNames = [
    "null",
    "undefined",
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol"
];
function $73d9ca2d7adcc91c$var$isPrimitiveTypeName(name) {
    return $73d9ca2d7adcc91c$var$primitiveTypeNames.includes(name);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $73d9ca2d7adcc91c$var$isOfType(type) {
    return (value)=>typeof value === type;
}
const { toString: $73d9ca2d7adcc91c$var$toString } = Object.prototype;
const $73d9ca2d7adcc91c$var$getObjectType = (value)=>{
    const objectTypeName = $73d9ca2d7adcc91c$var$toString.call(value).slice(8, -1);
    if (/HTML\w+Element/.test(objectTypeName) && $73d9ca2d7adcc91c$var$is.domElement(value)) return "HTMLElement";
    if ($73d9ca2d7adcc91c$var$isObjectTypeName(objectTypeName)) return objectTypeName;
    return undefined;
};
const $73d9ca2d7adcc91c$var$isObjectOfType = (type)=>(value)=>$73d9ca2d7adcc91c$var$getObjectType(value) === type;
function $73d9ca2d7adcc91c$var$is(value) {
    if (value === null) return "null";
    switch(typeof value){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return "number";
        case "boolean":
            return "boolean";
        case "function":
            return "Function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        default:
    }
    if ($73d9ca2d7adcc91c$var$is.observable(value)) return "Observable";
    if ($73d9ca2d7adcc91c$var$is.array(value)) return "Array";
    if ($73d9ca2d7adcc91c$var$is.buffer(value)) return "Buffer";
    const tagType = $73d9ca2d7adcc91c$var$getObjectType(value);
    if (tagType) return tagType;
    if (value instanceof String || value instanceof Boolean || value instanceof Number) throw new TypeError("Please don't use object wrappers for primitive types");
    return "Object";
}
$73d9ca2d7adcc91c$var$is.undefined = $73d9ca2d7adcc91c$var$isOfType("undefined");
$73d9ca2d7adcc91c$var$is.string = $73d9ca2d7adcc91c$var$isOfType("string");
const $73d9ca2d7adcc91c$var$isNumberType = $73d9ca2d7adcc91c$var$isOfType("number");
$73d9ca2d7adcc91c$var$is.number = (value)=>$73d9ca2d7adcc91c$var$isNumberType(value) && !$73d9ca2d7adcc91c$var$is.nan(value);
$73d9ca2d7adcc91c$var$is.bigint = $73d9ca2d7adcc91c$var$isOfType("bigint");
// eslint-disable-next-line @typescript-eslint/ban-types
$73d9ca2d7adcc91c$var$is.function_ = $73d9ca2d7adcc91c$var$isOfType("function");
$73d9ca2d7adcc91c$var$is.null_ = (value)=>value === null;
$73d9ca2d7adcc91c$var$is.class_ = (value)=>$73d9ca2d7adcc91c$var$is.function_(value) && value.toString().startsWith("class ");
$73d9ca2d7adcc91c$var$is.boolean = (value)=>value === true || value === false;
$73d9ca2d7adcc91c$var$is.symbol = $73d9ca2d7adcc91c$var$isOfType("symbol");
$73d9ca2d7adcc91c$var$is.numericString = (value)=>$73d9ca2d7adcc91c$var$is.string(value) && !$73d9ca2d7adcc91c$var$is.emptyStringOrWhitespace(value) && !Number.isNaN(Number(value));
$73d9ca2d7adcc91c$var$is.array = (value, assertion)=>{
    if (!Array.isArray(value)) return false;
    if (!$73d9ca2d7adcc91c$var$is.function_(assertion)) return true;
    return value.every(assertion);
};
$73d9ca2d7adcc91c$var$is.buffer = (value)=>{
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = value) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.isBuffer) === null || _c === void 0 ? void 0 : _c.call(_b, value)) !== null && _d !== void 0 ? _d : false;
};
$73d9ca2d7adcc91c$var$is.blob = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("Blob")(value);
$73d9ca2d7adcc91c$var$is.nullOrUndefined = (value)=>$73d9ca2d7adcc91c$var$is.null_(value) || $73d9ca2d7adcc91c$var$is.undefined(value);
$73d9ca2d7adcc91c$var$is.object = (value)=>!$73d9ca2d7adcc91c$var$is.null_(value) && (typeof value === "object" || $73d9ca2d7adcc91c$var$is.function_(value));
$73d9ca2d7adcc91c$var$is.iterable = (value)=>{
    var _a;
    return $73d9ca2d7adcc91c$var$is.function_((_a = value) === null || _a === void 0 ? void 0 : _a[Symbol.iterator]);
};
$73d9ca2d7adcc91c$var$is.asyncIterable = (value)=>{
    var _a;
    return $73d9ca2d7adcc91c$var$is.function_((_a = value) === null || _a === void 0 ? void 0 : _a[Symbol.asyncIterator]);
};
$73d9ca2d7adcc91c$var$is.generator = (value)=>{
    var _a, _b;
    return $73d9ca2d7adcc91c$var$is.iterable(value) && $73d9ca2d7adcc91c$var$is.function_((_a = value) === null || _a === void 0 ? void 0 : _a.next) && $73d9ca2d7adcc91c$var$is.function_((_b = value) === null || _b === void 0 ? void 0 : _b.throw);
};
$73d9ca2d7adcc91c$var$is.asyncGenerator = (value)=>$73d9ca2d7adcc91c$var$is.asyncIterable(value) && $73d9ca2d7adcc91c$var$is.function_(value.next) && $73d9ca2d7adcc91c$var$is.function_(value.throw);
$73d9ca2d7adcc91c$var$is.nativePromise = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("Promise")(value);
const $73d9ca2d7adcc91c$var$hasPromiseAPI = (value)=>{
    var _a, _b;
    return $73d9ca2d7adcc91c$var$is.function_((_a = value) === null || _a === void 0 ? void 0 : _a.then) && $73d9ca2d7adcc91c$var$is.function_((_b = value) === null || _b === void 0 ? void 0 : _b.catch);
};
$73d9ca2d7adcc91c$var$is.promise = (value)=>$73d9ca2d7adcc91c$var$is.nativePromise(value) || $73d9ca2d7adcc91c$var$hasPromiseAPI(value);
$73d9ca2d7adcc91c$var$is.generatorFunction = $73d9ca2d7adcc91c$var$isObjectOfType("GeneratorFunction");
$73d9ca2d7adcc91c$var$is.asyncGeneratorFunction = (value)=>$73d9ca2d7adcc91c$var$getObjectType(value) === "AsyncGeneratorFunction";
$73d9ca2d7adcc91c$var$is.asyncFunction = (value)=>$73d9ca2d7adcc91c$var$getObjectType(value) === "AsyncFunction";
// eslint-disable-next-line no-prototype-builtins, @typescript-eslint/ban-types
$73d9ca2d7adcc91c$var$is.boundFunction = (value)=>$73d9ca2d7adcc91c$var$is.function_(value) && !value.hasOwnProperty("prototype");
$73d9ca2d7adcc91c$var$is.regExp = $73d9ca2d7adcc91c$var$isObjectOfType("RegExp");
$73d9ca2d7adcc91c$var$is.date = $73d9ca2d7adcc91c$var$isObjectOfType("Date");
$73d9ca2d7adcc91c$var$is.error = $73d9ca2d7adcc91c$var$isObjectOfType("Error");
$73d9ca2d7adcc91c$var$is.map = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("Map")(value);
$73d9ca2d7adcc91c$var$is.set = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("Set")(value);
$73d9ca2d7adcc91c$var$is.weakMap = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("WeakMap")(value);
$73d9ca2d7adcc91c$var$is.weakSet = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("WeakSet")(value);
$73d9ca2d7adcc91c$var$is.int8Array = $73d9ca2d7adcc91c$var$isObjectOfType("Int8Array");
$73d9ca2d7adcc91c$var$is.uint8Array = $73d9ca2d7adcc91c$var$isObjectOfType("Uint8Array");
$73d9ca2d7adcc91c$var$is.uint8ClampedArray = $73d9ca2d7adcc91c$var$isObjectOfType("Uint8ClampedArray");
$73d9ca2d7adcc91c$var$is.int16Array = $73d9ca2d7adcc91c$var$isObjectOfType("Int16Array");
$73d9ca2d7adcc91c$var$is.uint16Array = $73d9ca2d7adcc91c$var$isObjectOfType("Uint16Array");
$73d9ca2d7adcc91c$var$is.int32Array = $73d9ca2d7adcc91c$var$isObjectOfType("Int32Array");
$73d9ca2d7adcc91c$var$is.uint32Array = $73d9ca2d7adcc91c$var$isObjectOfType("Uint32Array");
$73d9ca2d7adcc91c$var$is.float32Array = $73d9ca2d7adcc91c$var$isObjectOfType("Float32Array");
$73d9ca2d7adcc91c$var$is.float64Array = $73d9ca2d7adcc91c$var$isObjectOfType("Float64Array");
$73d9ca2d7adcc91c$var$is.bigInt64Array = $73d9ca2d7adcc91c$var$isObjectOfType("BigInt64Array");
$73d9ca2d7adcc91c$var$is.bigUint64Array = $73d9ca2d7adcc91c$var$isObjectOfType("BigUint64Array");
$73d9ca2d7adcc91c$var$is.arrayBuffer = $73d9ca2d7adcc91c$var$isObjectOfType("ArrayBuffer");
$73d9ca2d7adcc91c$var$is.sharedArrayBuffer = $73d9ca2d7adcc91c$var$isObjectOfType("SharedArrayBuffer");
$73d9ca2d7adcc91c$var$is.dataView = $73d9ca2d7adcc91c$var$isObjectOfType("DataView");
$73d9ca2d7adcc91c$var$is.enumCase = (value, targetEnum)=>Object.values(targetEnum).includes(value);
$73d9ca2d7adcc91c$var$is.directInstanceOf = (instance, class_)=>Object.getPrototypeOf(instance) === class_.prototype;
$73d9ca2d7adcc91c$var$is.urlInstance = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("URL")(value);
$73d9ca2d7adcc91c$var$is.urlString = (value)=>{
    if (!$73d9ca2d7adcc91c$var$is.string(value)) return false;
    try {
        new URL(value); // eslint-disable-line no-new
        return true;
    } catch (_a) {
        return false;
    }
};
// Example: `is.truthy = (value: unknown): value is (not false | not 0 | not '' | not undefined | not null) => Boolean(value);`
$73d9ca2d7adcc91c$var$is.truthy = (value)=>Boolean(value);
// Example: `is.falsy = (value: unknown): value is (not true | 0 | '' | undefined | null) => Boolean(value);`
$73d9ca2d7adcc91c$var$is.falsy = (value)=>!value;
$73d9ca2d7adcc91c$var$is.nan = (value)=>Number.isNaN(value);
$73d9ca2d7adcc91c$var$is.primitive = (value)=>$73d9ca2d7adcc91c$var$is.null_(value) || $73d9ca2d7adcc91c$var$isPrimitiveTypeName(typeof value);
$73d9ca2d7adcc91c$var$is.integer = (value)=>Number.isInteger(value);
$73d9ca2d7adcc91c$var$is.safeInteger = (value)=>Number.isSafeInteger(value);
$73d9ca2d7adcc91c$var$is.plainObject = (value)=>{
    // From: https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
    if ($73d9ca2d7adcc91c$var$toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.getPrototypeOf({});
};
$73d9ca2d7adcc91c$var$is.typedArray = (value)=>$73d9ca2d7adcc91c$var$isTypedArrayName($73d9ca2d7adcc91c$var$getObjectType(value));
const $73d9ca2d7adcc91c$var$isValidLength = (value)=>$73d9ca2d7adcc91c$var$is.safeInteger(value) && value >= 0;
$73d9ca2d7adcc91c$var$is.arrayLike = (value)=>!$73d9ca2d7adcc91c$var$is.nullOrUndefined(value) && !$73d9ca2d7adcc91c$var$is.function_(value) && $73d9ca2d7adcc91c$var$isValidLength(value.length);
$73d9ca2d7adcc91c$var$is.inRange = (value, range)=>{
    if ($73d9ca2d7adcc91c$var$is.number(range)) return value >= Math.min(0, range) && value <= Math.max(range, 0);
    if ($73d9ca2d7adcc91c$var$is.array(range) && range.length === 2) return value >= Math.min(...range) && value <= Math.max(...range);
    throw new TypeError(`Invalid range: ${JSON.stringify(range)}`);
};
const $73d9ca2d7adcc91c$var$NODE_TYPE_ELEMENT = 1;
const $73d9ca2d7adcc91c$var$DOM_PROPERTIES_TO_CHECK = [
    "innerHTML",
    "ownerDocument",
    "style",
    "attributes",
    "nodeValue"
];
$73d9ca2d7adcc91c$var$is.domElement = (value)=>{
    return $73d9ca2d7adcc91c$var$is.object(value) && value.nodeType === $73d9ca2d7adcc91c$var$NODE_TYPE_ELEMENT && $73d9ca2d7adcc91c$var$is.string(value.nodeName) && !$73d9ca2d7adcc91c$var$is.plainObject(value) && $73d9ca2d7adcc91c$var$DOM_PROPERTIES_TO_CHECK.every((property)=>property in value);
};
$73d9ca2d7adcc91c$var$is.observable = (value)=>{
    var _a, _b, _c, _d;
    if (!value) return false;
    // eslint-disable-next-line no-use-extend-native/no-use-extend-native
    if (value === ((_b = (_a = value)[Symbol.observable]) === null || _b === void 0 ? void 0 : _b.call(_a))) return true;
    if (value === ((_d = (_c = value)["@@observable"]) === null || _d === void 0 ? void 0 : _d.call(_c))) return true;
    return false;
};
$73d9ca2d7adcc91c$var$is.nodeStream = (value)=>$73d9ca2d7adcc91c$var$is.object(value) && $73d9ca2d7adcc91c$var$is.function_(value.pipe) && !$73d9ca2d7adcc91c$var$is.observable(value);
$73d9ca2d7adcc91c$var$is.infinite = (value)=>value === Infinity || value === -Infinity;
const $73d9ca2d7adcc91c$var$isAbsoluteMod2 = (remainder)=>(value)=>$73d9ca2d7adcc91c$var$is.integer(value) && Math.abs(value % 2) === remainder;
$73d9ca2d7adcc91c$var$is.evenInteger = $73d9ca2d7adcc91c$var$isAbsoluteMod2(0);
$73d9ca2d7adcc91c$var$is.oddInteger = $73d9ca2d7adcc91c$var$isAbsoluteMod2(1);
$73d9ca2d7adcc91c$var$is.emptyArray = (value)=>$73d9ca2d7adcc91c$var$is.array(value) && value.length === 0;
$73d9ca2d7adcc91c$var$is.nonEmptyArray = (value)=>$73d9ca2d7adcc91c$var$is.array(value) && value.length > 0;
$73d9ca2d7adcc91c$var$is.emptyString = (value)=>$73d9ca2d7adcc91c$var$is.string(value) && value.length === 0;
const $73d9ca2d7adcc91c$var$isWhiteSpaceString = (value)=>$73d9ca2d7adcc91c$var$is.string(value) && !/\S/.test(value);
$73d9ca2d7adcc91c$var$is.emptyStringOrWhitespace = (value)=>$73d9ca2d7adcc91c$var$is.emptyString(value) || $73d9ca2d7adcc91c$var$isWhiteSpaceString(value);
// TODO: Use `not ''` when the `not` operator is available.
$73d9ca2d7adcc91c$var$is.nonEmptyString = (value)=>$73d9ca2d7adcc91c$var$is.string(value) && value.length > 0;
// TODO: Use `not ''` when the `not` operator is available.
$73d9ca2d7adcc91c$var$is.nonEmptyStringAndNotWhitespace = (value)=>$73d9ca2d7adcc91c$var$is.string(value) && !$73d9ca2d7adcc91c$var$is.emptyStringOrWhitespace(value);
$73d9ca2d7adcc91c$var$is.emptyObject = (value)=>$73d9ca2d7adcc91c$var$is.object(value) && !$73d9ca2d7adcc91c$var$is.map(value) && !$73d9ca2d7adcc91c$var$is.set(value) && Object.keys(value).length === 0;
// TODO: Use `not` operator here to remove `Map` and `Set` from type guard:
// - https://github.com/Microsoft/TypeScript/pull/29317
$73d9ca2d7adcc91c$var$is.nonEmptyObject = (value)=>$73d9ca2d7adcc91c$var$is.object(value) && !$73d9ca2d7adcc91c$var$is.map(value) && !$73d9ca2d7adcc91c$var$is.set(value) && Object.keys(value).length > 0;
$73d9ca2d7adcc91c$var$is.emptySet = (value)=>$73d9ca2d7adcc91c$var$is.set(value) && value.size === 0;
$73d9ca2d7adcc91c$var$is.nonEmptySet = (value)=>$73d9ca2d7adcc91c$var$is.set(value) && value.size > 0;
$73d9ca2d7adcc91c$var$is.emptyMap = (value)=>$73d9ca2d7adcc91c$var$is.map(value) && value.size === 0;
$73d9ca2d7adcc91c$var$is.nonEmptyMap = (value)=>$73d9ca2d7adcc91c$var$is.map(value) && value.size > 0;
// `PropertyKey` is any value that can be used as an object key (string, number, or symbol)
$73d9ca2d7adcc91c$var$is.propertyKey = (value)=>$73d9ca2d7adcc91c$var$is.any([
        $73d9ca2d7adcc91c$var$is.string,
        $73d9ca2d7adcc91c$var$is.number,
        $73d9ca2d7adcc91c$var$is.symbol
    ], value);
$73d9ca2d7adcc91c$var$is.formData = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("FormData")(value);
$73d9ca2d7adcc91c$var$is.urlSearchParams = (value)=>$73d9ca2d7adcc91c$var$isObjectOfType("URLSearchParams")(value);
const $73d9ca2d7adcc91c$var$predicateOnArray = (method, predicate, values)=>{
    if (!$73d9ca2d7adcc91c$var$is.function_(predicate)) throw new TypeError(`Invalid predicate: ${JSON.stringify(predicate)}`);
    if (values.length === 0) throw new TypeError("Invalid number of values");
    return method.call(values, predicate);
};
$73d9ca2d7adcc91c$var$is.any = (predicate, ...values)=>{
    const predicates = $73d9ca2d7adcc91c$var$is.array(predicate) ? predicate : [
        predicate
    ];
    return predicates.some((singlePredicate)=>$73d9ca2d7adcc91c$var$predicateOnArray(Array.prototype.some, singlePredicate, values));
};
$73d9ca2d7adcc91c$var$is.all = (predicate, ...values)=>$73d9ca2d7adcc91c$var$predicateOnArray(Array.prototype.every, predicate, values);
const $73d9ca2d7adcc91c$var$assertType = (condition, description, value, options = {})=>{
    if (!condition) {
        const { multipleValues: multipleValues } = options;
        const valuesMessage = multipleValues ? `received values of types ${[
            ...new Set(value.map((singleValue)=>`\`${$73d9ca2d7adcc91c$var$is(singleValue)}\``))
        ].join(", ")}` : `received value of type \`${$73d9ca2d7adcc91c$var$is(value)}\``;
        throw new TypeError(`Expected value which is \`${description}\`, ${valuesMessage}.`);
    }
};
module.exports.assert = {
    // Unknowns.
    undefined: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.undefined(value), "undefined", value),
    string: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.string(value), "string", value),
    number: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.number(value), "number", value),
    bigint: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.bigint(value), "bigint", value),
    // eslint-disable-next-line @typescript-eslint/ban-types
    function_: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.function_(value), "Function", value),
    null_: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.null_(value), "null", value),
    class_: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.class_(value), "Class" /* class_ */ , value),
    boolean: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.boolean(value), "boolean", value),
    symbol: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.symbol(value), "symbol", value),
    numericString: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.numericString(value), "string with a number" /* numericString */ , value),
    array: (value, assertion)=>{
        const assert = $73d9ca2d7adcc91c$var$assertType;
        assert($73d9ca2d7adcc91c$var$is.array(value), "Array", value);
        if (assertion) value.forEach(assertion);
    },
    buffer: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.buffer(value), "Buffer", value),
    blob: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.blob(value), "Blob", value),
    nullOrUndefined: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nullOrUndefined(value), "null or undefined" /* nullOrUndefined */ , value),
    object: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.object(value), "Object", value),
    iterable: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.iterable(value), "Iterable" /* iterable */ , value),
    asyncIterable: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.asyncIterable(value), "AsyncIterable" /* asyncIterable */ , value),
    generator: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.generator(value), "Generator", value),
    asyncGenerator: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.asyncGenerator(value), "AsyncGenerator", value),
    nativePromise: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nativePromise(value), "native Promise" /* nativePromise */ , value),
    promise: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.promise(value), "Promise", value),
    generatorFunction: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.generatorFunction(value), "GeneratorFunction", value),
    asyncGeneratorFunction: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.asyncGeneratorFunction(value), "AsyncGeneratorFunction", value),
    // eslint-disable-next-line @typescript-eslint/ban-types
    asyncFunction: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.asyncFunction(value), "AsyncFunction", value),
    // eslint-disable-next-line @typescript-eslint/ban-types
    boundFunction: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.boundFunction(value), "Function", value),
    regExp: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.regExp(value), "RegExp", value),
    date: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.date(value), "Date", value),
    error: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.error(value), "Error", value),
    map: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.map(value), "Map", value),
    set: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.set(value), "Set", value),
    weakMap: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.weakMap(value), "WeakMap", value),
    weakSet: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.weakSet(value), "WeakSet", value),
    int8Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.int8Array(value), "Int8Array", value),
    uint8Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.uint8Array(value), "Uint8Array", value),
    uint8ClampedArray: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.uint8ClampedArray(value), "Uint8ClampedArray", value),
    int16Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.int16Array(value), "Int16Array", value),
    uint16Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.uint16Array(value), "Uint16Array", value),
    int32Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.int32Array(value), "Int32Array", value),
    uint32Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.uint32Array(value), "Uint32Array", value),
    float32Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.float32Array(value), "Float32Array", value),
    float64Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.float64Array(value), "Float64Array", value),
    bigInt64Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.bigInt64Array(value), "BigInt64Array", value),
    bigUint64Array: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.bigUint64Array(value), "BigUint64Array", value),
    arrayBuffer: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.arrayBuffer(value), "ArrayBuffer", value),
    sharedArrayBuffer: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.sharedArrayBuffer(value), "SharedArrayBuffer", value),
    dataView: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.dataView(value), "DataView", value),
    enumCase: (value, targetEnum)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.enumCase(value, targetEnum), "EnumCase", value),
    urlInstance: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.urlInstance(value), "URL", value),
    urlString: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.urlString(value), "string with a URL" /* urlString */ , value),
    truthy: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.truthy(value), "truthy" /* truthy */ , value),
    falsy: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.falsy(value), "falsy" /* falsy */ , value),
    nan: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nan(value), "NaN" /* nan */ , value),
    primitive: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.primitive(value), "primitive" /* primitive */ , value),
    integer: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.integer(value), "integer" /* integer */ , value),
    safeInteger: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.safeInteger(value), "integer" /* safeInteger */ , value),
    plainObject: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.plainObject(value), "plain object" /* plainObject */ , value),
    typedArray: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.typedArray(value), "TypedArray" /* typedArray */ , value),
    arrayLike: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.arrayLike(value), "array-like" /* arrayLike */ , value),
    domElement: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.domElement(value), "HTMLElement" /* domElement */ , value),
    observable: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.observable(value), "Observable", value),
    nodeStream: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nodeStream(value), "Node.js Stream" /* nodeStream */ , value),
    infinite: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.infinite(value), "infinite number" /* infinite */ , value),
    emptyArray: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.emptyArray(value), "empty array" /* emptyArray */ , value),
    nonEmptyArray: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nonEmptyArray(value), "non-empty array" /* nonEmptyArray */ , value),
    emptyString: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.emptyString(value), "empty string" /* emptyString */ , value),
    emptyStringOrWhitespace: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.emptyStringOrWhitespace(value), "empty string or whitespace" /* emptyStringOrWhitespace */ , value),
    nonEmptyString: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nonEmptyString(value), "non-empty string" /* nonEmptyString */ , value),
    nonEmptyStringAndNotWhitespace: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nonEmptyStringAndNotWhitespace(value), "non-empty string and not whitespace" /* nonEmptyStringAndNotWhitespace */ , value),
    emptyObject: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.emptyObject(value), "empty object" /* emptyObject */ , value),
    nonEmptyObject: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nonEmptyObject(value), "non-empty object" /* nonEmptyObject */ , value),
    emptySet: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.emptySet(value), "empty set" /* emptySet */ , value),
    nonEmptySet: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nonEmptySet(value), "non-empty set" /* nonEmptySet */ , value),
    emptyMap: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.emptyMap(value), "empty map" /* emptyMap */ , value),
    nonEmptyMap: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.nonEmptyMap(value), "non-empty map" /* nonEmptyMap */ , value),
    propertyKey: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.propertyKey(value), "PropertyKey", value),
    formData: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.formData(value), "FormData", value),
    urlSearchParams: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.urlSearchParams(value), "URLSearchParams", value),
    // Numbers.
    evenInteger: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.evenInteger(value), "even integer" /* evenInteger */ , value),
    oddInteger: (value)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.oddInteger(value), "odd integer" /* oddInteger */ , value),
    // Two arguments.
    directInstanceOf: (instance, class_)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.directInstanceOf(instance, class_), "T" /* directInstanceOf */ , instance),
    inRange: (value, range)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.inRange(value, range), "in range" /* inRange */ , value),
    // Variadic functions.
    any: (predicate, ...values)=>{
        return $73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.any(predicate, ...values), "predicate returns truthy for any value" /* any */ , values, {
            multipleValues: true
        });
    },
    all: (predicate, ...values)=>$73d9ca2d7adcc91c$var$assertType($73d9ca2d7adcc91c$var$is.all(predicate, ...values), "predicate returns truthy for all values" /* all */ , values, {
            multipleValues: true
        })
};
// Some few keywords are reserved, but we'll populate them for Node.js users
// See https://github.com/Microsoft/TypeScript/issues/2536
Object.defineProperties($73d9ca2d7adcc91c$var$is, {
    class: {
        value: $73d9ca2d7adcc91c$var$is.class_
    },
    function: {
        value: $73d9ca2d7adcc91c$var$is.function_
    },
    null: {
        value: $73d9ca2d7adcc91c$var$is.null_
    }
});
Object.defineProperties(module.exports.assert, {
    class: {
        value: module.exports.assert.class_
    },
    function: {
        value: module.exports.assert.function_
    },
    null: {
        value: module.exports.assert.null_
    }
});
module.exports.default = $73d9ca2d7adcc91c$var$is;
// For CommonJS default export support
module.exports = $73d9ca2d7adcc91c$var$is;
module.exports.default = $73d9ca2d7adcc91c$var$is;
module.exports.assert = module.exports.assert;

});




parcelRegister("kaUPk", function(module, exports) {

$parcel$export(module.exports, "StaffReportColumns", function () { return $eb00d271f840cfed$export$b55d6bbeaf19c082; });

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("dBifK");
parcelRequire("7PdBe");

var $byiQX = parcelRequire("byiQX");
parcelRequire("61cVC");

var $egx7S = parcelRequire("egx7S");

var $5uSSv = parcelRequire("5uSSv");

var $4iD0l = parcelRequire("4iD0l");
const $eb00d271f840cfed$export$b55d6bbeaf19c082 = (report)=>({
        name: {
            id: "name",
            label: "Name",
            type: "text",
            width: 25,
            value: (row)=>{
                return row.fullName;
            },
            component: ({ value: value, stores: stores })=>{
                const { row: row } = stores;
                return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                    children: /*#__PURE__*/ (0, $RSSjA.jsx)("a", {
                        href: `/staff/${row.rowObject.id}`,
                        onClick: (e)=>{
                            e.preventDefault();
                        },
                        children: value
                    })
                });
            }
        },
        lastName: {
            id: "lastName",
            label: "Last name",
            type: "text",
            width: 15,
            value: (row)=>row.lastName
        },
        firstName: {
            id: "firstName",
            label: "First name",
            type: "text",
            width: 15,
            value: (row)=>row.firstName
        },
        email: {
            id: "email",
            label: "Email",
            type: "text",
            width: 25,
            value: (row)=>row.email,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("email", value);
            }
        },
        role: {
            id: "role",
            label: "Role",
            type: "role",
            width: 15,
            value: (row)=>row.role,
            permissions: (row)=>(0, $4iD0l.canViewRoles)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("roleId", value);
            }
        },
        costCentre: {
            id: "costCentre",
            label: "Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>row.costCentre,
            permissions: (row)=>(0, $4iD0l.canViewCostCentres)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("costCentreId", value);
            }
        },
        isArchived: {
            id: "isArchived",
            label: "Is Archived",
            type: "boolean",
            width: 15,
            value: (row)=>row.isArchived,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("isArchived", value);
            }
        },
        isActive: {
            id: "isActive",
            label: "Is Active",
            type: "boolean",
            width: 15,
            value: (row)=>!row.isArchived,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("isActive", value);
            }
        },
        payRate: {
            id: "payRate",
            label: "Pay Rate",
            type: "number",
            width: 15,
            value: (row)=>row.payRate,
            permissions: (row)=>(0, $4iD0l.canViewStaffPayRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("payRate", value);
            }
        },
        overtimeRate: {
            id: "overtimeRate",
            label: "Overtime Rate",
            type: "number",
            width: 15,
            value: (row)=>row.overtimeRate,
            permissions: (row)=>(0, $4iD0l.canViewStaffOvertimeRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("overtimeRate", value);
            }
        },
        costRate: {
            id: "costRate",
            label: "Cost Rate",
            type: "number",
            width: 15,
            value: (row)=>row.costRate,
            permissions: (row)=>(0, $4iD0l.canViewStaffCostRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("costRate", value);
            }
        },
        chargeOutRate: {
            id: "chargeOutRate",
            label: "Charge Out Rate",
            type: "number",
            width: 15,
            value: (row)=>row.chargeOutRate,
            permissions: (row)=>(0, $4iD0l.canViewStaffChargeOutRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("chargeOutRate", value);
            }
        },
        weeklyAvailability: {
            id: "weeklyAvailability",
            label: "Weekly Availability",
            type: "number",
            width: 15,
            value: (row)=>row.getLatestRate("availability"),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("weeklyAvailability", value);
            }
        },
        allocatedHours: {
            id: "allocatedHours",
            label: "Allocated hours",
            type: "number",
            width: 15,
            value: (row)=>row.allocatedHours,
            permissions: (row)=>(0, $4iD0l.canViewStaffAllocations)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("allocatedHours", value);
            }
        },
        availableHours: {
            id: "availableHours",
            label: "Available hours",
            type: "number",
            width: 15,
            value: (row)=>{
                return row.weeklyAvailability / 5 * (0, $egx7S.differenceInBusinessDays)((0, $egx7S.addDays)(report.dateRange[1], 1), report.dateRange[0]);
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator](`(weeklyAvailability / 5) * ${(0, $egx7S.differenceInBusinessDays)((0, $egx7S.addDays)(report.dateRange[1], 1), report.dateRange[0])}`, value);
            }
        },
        recordedHours: {
            id: "recordedHours",
            label: "Recorded hours",
            type: "number",
            width: 15,
            value: (row)=>row.recordedHours,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("recordedHours", value);
            }
        },
        billableHours: {
            id: "billableHours",
            label: "Billable Hours",
            type: "number",
            width: 15,
            value: (row)=>row.billableHours,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("billableHours", value);
            }
        },
        nonBillableHours: {
            id: "nonBillableHours",
            label: "Non Billable Hours",
            type: "number",
            width: 15,
            value: (row)=>row.nonBillableHours,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("nonBillableHours", value);
            }
        },
        percentBillableHours: {
            id: "percentBillableHours",
            label: "Percent Billable Hours",
            type: "percent",
            width: 15,
            value: (row)=>{
                return $eb00d271f840cfed$export$b55d6bbeaf19c082(report).billableHours.value(row) / $eb00d271f840cfed$export$b55d6bbeaf19c082(report).recordedHours.value(row);
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("billableHours / recordedHours", value);
            }
        },
        overtimeHours: {
            id: "overtimeHours",
            label: "Overtime hours",
            type: "number",
            width: 15,
            value: (row)=>row.overtimeHours,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("overtimeHours", value);
            }
        },
        invoicedHours: {
            id: "invoicedHours",
            label: "Invoiced Hours",
            type: "number",
            width: 15,
            value: (row)=>{
                return row.invoicedHours;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("invoicedHours", value);
            }
        },
        pay: {
            id: "pay",
            label: "Pay",
            type: "currency",
            width: 15,
            value: (row)=>row.pay,
            permissions: (row)=>(0, $4iD0l.canViewStaffPayRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("pay", value);
            }
        },
        cost: {
            id: "cost",
            label: "Cost",
            type: "currency",
            width: 15,
            value: (row)=>row.cost,
            permissions: (row)=>(0, $4iD0l.canViewStaffCostRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("cost", value);
            }
        },
        chargeOut: {
            id: "chargeOut",
            label: "Charge Out",
            type: "currency",
            width: 15,
            value: (row)=>row.chargeOut,
            permissions: (row)=>(0, $4iD0l.canViewStaffChargeOutRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("chargeOut", value);
            }
        },
        revenueEarned: {
            id: "revenueEarned",
            label: "Revenue Earned",
            type: "currency",
            width: 15,
            value: (row)=>{
                return row.revenueEarned;
            },
            permissions: (row)=>(0, $4iD0l.canViewStaffChargeOutRate)((0, $5uSSv.default).user) && (0, $4iD0l.canViewProjectInvoices)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("revenueEarned", value);
            }
        },
        revenueEarnedPerHour: {
            id: "revenueEarnedPerHour",
            label: "Revenue Earned Per Hour",
            type: "currency",
            width: 15,
            value: (row)=>{
                return $eb00d271f840cfed$export$b55d6bbeaf19c082(report).recordedHours.value(row) ? $eb00d271f840cfed$export$b55d6bbeaf19c082(report).revenueEarned.value(row) / $eb00d271f840cfed$export$b55d6bbeaf19c082(report).recordedHours.value(row) : 0;
            },
            permissions: (row)=>(0, $4iD0l.canViewStaffChargeOutRate)((0, $5uSSv.default).user) && (0, $4iD0l.canViewProjectInvoices)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("recordedHours > 0 ? revenueEarned / recordedHours : 0", value);
            }
        },
        projects: {
            id: "projects",
            label: "Projects",
            type: "project",
            width: 15,
            value: (row)=>{
                return [
                    ...new Set(row.budgets.map((b)=>b.project))
                ];
            },
            queryFilters: ({ operator: operator, value: value })=>(0, $byiQX.queryFilters).manyIds[operator]("projectIds", value)
        }
    });

});

parcelRegister("2dBXm", function(module, exports) {

$parcel$export(module.exports, "InvoiceReportColumns", function () { return $19da3d03bff4a0bb$export$6a18a24ce908699c; });

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("dBifK");
parcelRequire("7PdBe");

var $byiQX = parcelRequire("byiQX");

var $4iD0l = parcelRequire("4iD0l");
const $19da3d03bff4a0bb$export$6a18a24ce908699c = (report)=>({
        description: {
            id: "description",
            label: "Invoice #",
            type: "text",
            width: 15,
            value: (row)=>{
                return row.ref;
            },
            component: ({ value: value, stores: stores })=>{
                const { row: row } = stores;
                return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                    children: value
                });
            }
        },
        issuedOn: {
            id: "issuedOn",
            label: "Issue Date",
            type: "date",
            width: 10,
            value: (row)=>row.issueDate,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).date[operator]("issueDate", value);
            }
        },
        dueDate: {
            id: "dueDate",
            label: "Due Date",
            type: "date",
            width: 10,
            value: (row)=>row.dueDate,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).date[operator]("dueDate", value);
            }
        },
        startDate: {
            id: "startDate",
            label: "Work Start Date",
            type: "date",
            width: 10,
            value: (row)=>row.startDate,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).date[operator]("startDate", value);
            }
        },
        endDate: {
            id: "endDate",
            label: "Work End Date",
            type: "date",
            width: 10,
            value: (row)=>row.endDate,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).date[operator]("endDate", value);
            }
        },
        createdAt: {
            id: "createdAt",
            label: "Creation Date",
            type: "date",
            width: 10,
            value: (row)=>row.createdAt,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).date[operator]("createdAt", value);
            }
        },
        project: {
            id: "project",
            label: "Project",
            type: "project",
            width: 20,
            value: (row)=>row.project,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectId", value);
            }
        },
        contact: {
            id: "contact",
            label: "Client",
            type: "contact",
            width: 20,
            value: (row)=>row.contact,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("contactId", value);
            }
        },
        projectContact: {
            id: "projectContact",
            label: "Project Client",
            type: "contact",
            width: 20,
            value: (row)=>row.project.contact,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectContactId", value);
            }
        },
        projectOwner: {
            id: "projectOwner",
            label: "ProjectOwner",
            type: "staff",
            width: 20,
            value: (row)=>row.project.owner,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectOwnerId", value);
            }
        },
        projectPrimaryContact: {
            id: "projectPrimaryContact",
            label: "Project Primary Contact",
            type: "contact",
            width: 20,
            value: (row)=>row.project.primaryContact,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectPrimaryContactId", value);
            },
            permissions: (row)=>(0, $4iD0l.canViewPrimaryContact)()
        },
        costCentre: {
            id: "costCentre",
            label: "Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>row.project.costCentre,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectCostCentreId", value);
            }
        },
        amountExTax: {
            id: "amountExTax",
            label: "Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.totalAmount,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("totalAmount", value);
            }
        },
        amountIncTax: {
            id: "amountIncTax",
            label: "Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>$19da3d03bff4a0bb$export$6a18a24ce908699c(report).amountExTax.value(row) + $19da3d03bff4a0bb$export$6a18a24ce908699c(report).amountTax.value(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("totalAmount + totalTax", value);
            }
        },
        amountTax: {
            id: "amountTax",
            label: "Tax Amount",
            type: "currency",
            width: 10,
            value: (row)=>row.totalTax,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("totalTax", value);
            }
        },
        agreedFeeExTax: {
            id: "agreedFeeExTax",
            label: "Agreed Fee Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.agreedAmount,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("agreedAmount", value);
            }
        },
        variationExTax: {
            id: "variationExTax",
            label: "Variation Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.variationAmount,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("variationAmount", value);
            }
        },
        agreedFeeVariationExTax: {
            id: "agreedFeeVariationExTax",
            label: "Agreed Fee + Variation Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>$19da3d03bff4a0bb$export$6a18a24ce908699c(report).agreedFeeExTax.value(row) + $19da3d03bff4a0bb$export$6a18a24ce908699c(report).variationExTax.value(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("agreedAmount + variationAmount", value);
            }
        },
        reimbursementExTax: {
            id: "reimbursementExTax",
            label: "Reimbursement Amount exc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.reimbursementAmount,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("reimbursementAmount", value);
            }
        },
        agreedFeeTax: {
            id: "agreedFeeTax",
            label: "Agreed Fee Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.agreedTax,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("agreedTax", value);
            }
        },
        variationTax: {
            id: "variationTax",
            label: "Variation Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.variationTax,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("variationTax", value);
            }
        },
        agreedFeeVariationTax: {
            id: "agreedFeeVariationTax",
            label: "Agreed Fee + Variation Tax",
            type: "currency",
            width: 10,
            value: (row)=>$19da3d03bff4a0bb$export$6a18a24ce908699c(report).agreedFeeTax.value(row) + $19da3d03bff4a0bb$export$6a18a24ce908699c(report).variationTax.value(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("agreedFeeTax + variationTax", value);
            }
        },
        reimbursementTax: {
            id: "reimbursementTax",
            label: "Reimbursement Tax",
            type: "currency",
            width: 10,
            value: (row)=>row.reimbursementAmount,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("reimbursementAmount", value);
            }
        },
        agreedFeeIncTax: {
            id: "agreedFeeIncTax",
            label: "Agreed Fee Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>$19da3d03bff4a0bb$export$6a18a24ce908699c(report).agreedFeeExTax.value(row) + $19da3d03bff4a0bb$export$6a18a24ce908699c(report).agreedFeeTax.value(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("agreedFeeExTax + agreedFeeTax", value);
            }
        },
        variationIncTax: {
            id: "variationIncTax",
            label: "Variation Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>$19da3d03bff4a0bb$export$6a18a24ce908699c(report).variationExTax.value(row) + $19da3d03bff4a0bb$export$6a18a24ce908699c(report).variationTax.value(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("variationExTax + variationTax", value);
            }
        },
        agreedFeeVariationIncTax: {
            id: "agreedFeeVariationIncTax",
            label: "Agreed Fee + Variation Amount inc. Tax",
            type: "currency",
            width: 10,
            value: (row)=>$19da3d03bff4a0bb$export$6a18a24ce908699c(report).agreedFeeVariationExTax.value(row) + $19da3d03bff4a0bb$export$6a18a24ce908699c(report).agreedFeeVariationTax.value(row),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("agreedFeeVariationExTax + agreedFeeVariationTax", value);
            }
        },
        reimbursementIncTax: {
            id: "reimbursementIncTax",
            label: "Reimbursement Amount inc. Tax",
            type: "currency",
            width: 10,
            agreedFeeVariationIncTax: {
                id: "agreedFeeVariationIncTax",
                label: "Agreed Fee + Variation Amount inc. Tax",
                type: "currency",
                width: 10,
                value: (row)=>$19da3d03bff4a0bb$export$6a18a24ce908699c(report).reimbursementExTax.value(row) + $19da3d03bff4a0bb$export$6a18a24ce908699c(report).reimbursementTax.value(row),
                queryFilters: ({ operator: operator, value: value })=>{
                    return (0, $byiQX.queryFilters).number[operator]("reimbursementExTax + reimbursementTax", value);
                }
            }
        },
        synced: {
            id: "synced",
            label: "Synced",
            type: "boolean",
            width: 10,
            value: (row)=>row.synced,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("synced", value);
            }
        },
        projectStatus: {
            id: "projectStatus",
            label: "Project Status",
            type: "status",
            width: 10,
            value: (row)=>row.projectStatus || "active",
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("projectStatus", value);
            }
        }
    });

});

parcelRegister("lsE13", function(module, exports) {

$parcel$export(module.exports, "TimeReportColumns", function () { return $f9fb40d3cc0410c8$export$b09dcabc134e2643; });

var $dBifK = parcelRequire("dBifK");
parcelRequire("7PdBe");

var $byiQX = parcelRequire("byiQX");

var $hy8Zj = parcelRequire("hy8Zj");

var $lTrDt = parcelRequire("lTrDt");

var $4sGvn = parcelRequire("4sGvn");

var $4iD0l = parcelRequire("4iD0l");

var $5uSSv = parcelRequire("5uSSv");
const $f9fb40d3cc0410c8$export$b09dcabc134e2643 = (report)=>({
        project: {
            id: "project",
            label: "Project",
            type: "project",
            width: 20,
            value: (row)=>row.project,
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectId", value);
            }
        },
        projectPhase: {
            id: "projectPhase",
            label: "Phase",
            type: "phase",
            width: 20,
            value: (row)=>{
                return row.phase;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("phaseName", value);
            }
        },
        staffMember: {
            id: "staffMember",
            label: "Staff",
            type: "staffMember",
            width: 20,
            value: (row)=>{
                return row.staff;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("staffId", value);
            }
        },
        task: {
            id: "task",
            label: "Task",
            type: "task",
            width: 20,
            value: (row)=>{
                return row.task;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("taskName", value);
            }
        },
        date: {
            id: "date",
            label: "Date",
            type: "date",
            width: 10,
            value: (row)=>{
                return row.date;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).date[operator]("date", value);
            }
        },
        numMinutes: {
            id: "numMinutes",
            label: "Hours",
            type: "number",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.hours;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("numMinutes", value);
            }
        },
        notes: {
            id: "notes",
            label: "Notes",
            type: "text",
            width: 30,
            value: (row)=>{
                return row.notes;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("notes", value);
            }
        },
        costCentre: {
            id: "costCentre",
            label: "Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>{
                return (0, $hy8Zj.default).costCentresById[row.projectCostCentreId];
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectCostCentreId", value);
            }
        },
        staffCostCentre: {
            id: "staffCostCentre",
            label: "Staff Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>{
                return (0, $hy8Zj.default).costCentresById[row.staffCostCentreId];
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("staffCostCentreId", value);
            }
        },
        projectOwner: {
            id: "projectOwner",
            label: "Project Owner",
            type: "staff",
            width: 20,
            value: (row)=>{
                return (0, $lTrDt.default).staffById[row.projectOwnerId];
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectOwnerId", value);
            }
        },
        projectContact: {
            id: "projectContact",
            label: "Project Client",
            type: "contact",
            width: 20,
            value: (row)=>{
                return (0, $4sGvn.default).contactsById[row.projectContactId];
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectContactId", value);
            }
        },
        projectInvoiceContact: {
            id: "projectInvoiceContact",
            label: "Project Primary Contact",
            type: "contact",
            width: 20,
            value: (row)=>{
                return (0, $4sGvn.default).contactsById[row.projectPrimaryContactId];
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("projectPrimaryContactId", value);
            },
            permissions: (row)=>(0, $4iD0l.canViewPrimaryContact)()
        },
        projectCode: {
            id: "projectCode",
            label: "Project Code",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectCode;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("projectCode", value);
            }
        },
        projectPhaseCode: {
            id: "projectPhaseCode",
            label: "Phase Code",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectPhaseCode;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("projectPhaseCode", value);
            }
        },
        staffMemberFirstName: {
            id: "staffMemberFirstName",
            label: "Staff First Name",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.staffMemberFirstName;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("staffMemberFirstName", value);
            }
        },
        staffMemberLastName: {
            id: "staffMemberLastName",
            label: "Staff Last Name",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.staffMemberLastName;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("staffMemberLastName", value);
            }
        },
        staffRole: {
            id: "staffRole",
            label: "Staff Role",
            type: "role",
            width: 20,
            value: (row)=>{
                var _row$staff;
                return (_row$staff = row.staff) === null || _row$staff === void 0 ? void 0 : _row$staff.role;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).singleId[operator]("staffRoleId", value);
            }
        },
        monthIndex: {
            id: "monthIndex",
            label: "Month",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.month;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).text[operator]("month", value);
            }
        },
        isBillable: {
            id: "isBillable",
            label: "Billable",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.isBillable;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("isBillable", value);
            }
        },
        isVariation: {
            id: "isVariation",
            label: "Variation",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.isVariation;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("isVariation", value);
            }
        },
        isOvertime: {
            id: "isOvertime",
            label: "Overtime",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.isOvertime;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("isOvertime", value);
            }
        },
        isLocked: {
            id: "isLocked",
            label: "Locked",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.isLocked;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("isLocked", value);
            }
        },
        beenInvoiced: {
            id: "beenInvoiced",
            label: "Invoiced",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.beenInvoiced;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("beenInvoiced", value);
            }
        },
        flexi: {
            id: "flexi",
            label: "Flexi",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.flexi;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("flexi", value);
            },
            permissions: (row)=>(0, $4iD0l.canViewFlexiRemote)()
        },
        remote: {
            id: "remote",
            label: "Remote",
            type: "boolean",
            width: 20,
            value: (row)=>{
                return row.remote;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("remote", value);
            },
            permissions: (row)=>(0, $4iD0l.canViewFlexiRemote)()
        },
        fee: {
            id: "fee",
            label: "Fee",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                var _row$phase, _row$project;
                return ((_row$phase = row.phase) === null || _row$phase === void 0 ? void 0 : _row$phase.fee) || ((_row$project = row.project) === null || _row$project === void 0 ? void 0 : _row$project.fee);
            },
            permissions: (r)=>(0, $4iD0l.canViewProjectFees)((0, $5uSSv.default).user, r === null || r === void 0 ? void 0 : r.project),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("projectFee", value);
            }
        },
        remainingFee: {
            id: "remainingFee",
            label: "Remaining Fee",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                var _row$phase2, _row$phase3, _row$phase4, _row$project2, _row$project3;
                return (_row$phase2 = row.phase) !== null && _row$phase2 !== void 0 && _row$phase2.fee ? ((_row$phase3 = row.phase) === null || _row$phase3 === void 0 ? void 0 : _row$phase3.fee) - ((_row$phase4 = row.phase) === null || _row$phase4 === void 0 ? void 0 : _row$phase4.revenue) : ((_row$project2 = row.project) === null || _row$project2 === void 0 ? void 0 : _row$project2.fee) - (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum((_row$project3 = row.project) === null || _row$project3 === void 0 ? void 0 : _row$project3.phases.map((phase)=>phase.revenue));
            },
            permissions: (r)=>(0, $4iD0l.canViewProjectFees)((0, $5uSSv.default).user, r === null || r === void 0 ? void 0 : r.project) && (0, $4iD0l.canViewRevenueTargets)((0, $5uSSv.default).user, r === null || r === void 0 ? void 0 : r.project),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("projectRemainingFee", value);
            }
        },
        budget: {
            id: "budget",
            label: "Expense Budget",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                var _row$phase5, _row$project4;
                return ((_row$phase5 = row.phase) === null || _row$phase5 === void 0 ? void 0 : _row$phase5.expenseBudget) || ((_row$project4 = row.project) === null || _row$project4 === void 0 ? void 0 : _row$project4.expenseBudget);
            },
            permissions: (r)=>(0, $4iD0l.canViewProjectExpenseBudgets)((0, $5uSSv.default).user, r === null || r === void 0 ? void 0 : r.project),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("projectExpenseBudget", value);
            }
        },
        hoursBudget: {
            id: "hoursBudget",
            label: "Hours Budget",
            type: "number",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                var _row$phase6, _row$project5;
                return ((_row$phase6 = row.phase) === null || _row$phase6 === void 0 ? void 0 : _row$phase6.hoursBudget) || ((_row$project5 = row.project) === null || _row$project5 === void 0 ? void 0 : _row$project5.hoursBudget);
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("projectHoursBudget", value);
            }
        },
        startMinutes: {
            id: "startMinutes",
            label: "Start Time",
            type: "time",
            width: 20,
            value: (row)=>{
                return row.startMinutes;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).time[operator]("startMinutes", value);
            }
        },
        endMinutes: {
            id: "endMinutes",
            label: "End Time",
            type: "time",
            width: 20,
            value: (row)=>{
                return row.endMinutes;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).time[operator]("endMinutes", value);
            }
        },
        labourExpense: {
            id: "labourExpense",
            label: "Labour Expense",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.pay;
            },
            permissions: (r)=>(0, $4iD0l.canViewStaffPayRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("pay", value);
            }
        },
        cost: {
            id: "cost",
            label: "Expense (cost)",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.cost;
            },
            permissions: (r)=>(0, $4iD0l.canViewStaffCostRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("cost", value);
            }
        },
        chargeOut: {
            id: "chargeOut",
            label: "Charge Out",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.chargeOut;
            },
            permissions: (r)=>(0, $4iD0l.canViewStaffChargeOutRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("chargeOut", value);
            }
        },
        chargeOutRate: {
            id: "chargeOutRate",
            label: "Charge Out Rate",
            type: "currency",
            width: 20,
            aggregate: "sum",
            value: (row)=>{
                return row.chargeOut / row.hours;
            },
            permissions: (r)=>(0, $4iD0l.canViewStaffChargeOutRate)((0, $5uSSv.default).user),
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).number[operator]("chargeOutRate", value);
            }
        },
        hasNote: {
            id: "hasNote",
            label: "Has Note",
            type: "boolean",
            width: 10,
            value: (row)=>{
                return row.note && row.note.length > 0;
            },
            queryFilters: ({ operator: operator, value: value })=>{
                return (0, $byiQX.queryFilters).boolean[operator]("hasNote", value);
            }
        }
    });

});

parcelRegister("kH8oA", function(module, exports) {

$parcel$export(module.exports, "ExpenseReportColumns", function () { return $f10e55ffdc03ec99$export$d953fc7f6b362cb7; });
parcelRequire("dBifK");

var $4iD0l = parcelRequire("4iD0l");
parcelRequire("5uSSv");

var $egx7S = parcelRequire("egx7S");
parcelRequire("geLN1");
const $f10e55ffdc03ec99$export$d953fc7f6b362cb7 = (report)=>({
        project: {
            id: "project",
            label: "Project",
            type: "project",
            width: 20,
            value: (row)=>row.project,
            format: (project)=>{
                return project;
            }
        },
        projectPhase: {
            id: "projectPhase",
            label: "Phase",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectPhase;
            }
        },
        projectStatus: {
            id: "projectStatus",
            label: "Project Status",
            type: "status",
            width: 20,
            value: (row)=>{
                return row.projectStatus;
            }
        },
        phaseStatus: {
            id: "phaseStatus",
            label: "Phase Status",
            type: "status",
            width: 20,
            value: (row)=>{
                return row.phaseStatus;
            }
        },
        staffMember: {
            id: "staffMember",
            label: "Staff",
            type: "staffMember",
            width: 20,
            value: (row)=>{
                return row.staffMember;
            },
            format: (staff)=>staff
        },
        date: {
            id: "date",
            label: "Date",
            type: "date",
            width: 10,
            aggregate: "same",
            value: (row)=>{
                return row.date ? new Date(row.date) : null;
            }
        },
        notes: {
            id: "notes",
            label: "Notes",
            type: "text",
            width: 30,
            value: (row)=>{
                return row.notes;
            }
        },
        costCentre: {
            id: "costCentre",
            label: "Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>{
                return row.costCentre;
            },
            format: (costCentre)=>costCentre
        },
        staffCostCentre: {
            id: "staffCostCentre",
            label: "Staff Cost Centre",
            type: "costCentre",
            width: 15,
            value: (row)=>{
                return row.staffCostCentre;
            },
            format: (costCentre)=>costCentre
        },
        projectOwner: {
            id: "projectOwner",
            label: "Project Owner",
            type: "staffMember",
            width: 20,
            value: (row)=>{
                return row.projectOwner;
            },
            format: (staff)=>staff
        },
        projectContact: {
            id: "projectContact",
            label: "Project Client",
            type: "contact",
            width: 20,
            value: (row)=>{
                return row.projectContact;
            },
            format: (contact)=>contact
        },
        projectInvoiceContact: {
            id: "projectInvoiceContact",
            label: "Project Primary Contact",
            type: "contact",
            width: 20,
            value: (row)=>{
                return row.projectInvoiceContact;
            },
            format: (contact)=>contact,
            permissions: (row)=>(0, $4iD0l.canViewPrimaryContact)()
        },
        projectCode: {
            id: "projectCode",
            label: "Project Code",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectCode;
            }
        },
        projectPhaseCode: {
            id: "projectPhaseCode",
            label: "Phase Code",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.projectPhaseCode;
            }
        },
        staffRole: {
            id: "staffRole",
            label: "Staff Role",
            type: "role",
            width: 20,
            value: (row)=>{
                return row.staffRole;
            },
            format: (v)=>v
        },
        monthIndex: {
            id: "monthIndex",
            label: "Month",
            type: "text",
            width: 20,
            format: (month)=>month && (0, $egx7S.format)((0, $egx7S.parse)(month, "yyyy-MM", new Date()), "MMM yyyy"),
            value: (row)=>{
                return row === null || row === void 0 ? void 0 : row.monthIndex;
            }
        },
        isLocked: {
            id: "isLocked",
            label: "Is Locked",
            type: "boolean",
            width: 10,
            value: (row)=>{
                return row.isLocked;
            }
        },
        beenInvoiced: {
            id: "beenInvoiced",
            label: "Has Been Invoiced",
            type: "boolean",
            width: 10,
            value: (row)=>{
                return row.beenInvoiced;
            }
        },
        expenseName: {
            id: "expenseName",
            label: "Expense Name",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.expenseName;
            }
        },
        recordedExpense: {
            id: "recordedExpense",
            label: "Recorded Expense",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.recordedExpense;
            }
        },
        plannedExpense: {
            id: "plannedExpense",
            label: "Planned Expense",
            type: "currency",
            width: 10,
            aggregate: "sum",
            value: (row)=>{
                return row.plannedExpense;
            }
        },
        invoicedExpense: {
            id: "invoicedExpense",
            label: "Invoiced Expense",
            type: "currency",
            width: 10,
            value: (row)=>{
                return row.beenInvoiced;
            }
        },
        // recordedVsPlannedExpense: {
        //     id: 'recordedVsPlannedExpense',
        //     label: 'Recorded vs Planned Expense',
        //     type: 'progressBar',
        //     format: (v) => Formatter.currency(v, { decimals: 0 }),
        //     width: 30,
        //     aggregate: 'sum',
        //     value: (row) => {
        //         return row.recordedVsPlannedExpense
        //     },
        // },
        // invoicedVsPlannedExpense: {
        //     id: 'invoicedVsPlannedExpense',
        //     label: 'Invoiced vs Planned Expense',
        //     type: 'progressBar',
        //     format: (v) => Formatter.currency(v, { decimals: 0 }),
        //     width: 30,
        //     aggregate: 'sum',
        //     value: (row) => {
        //         return row.invoicedVsPlannedExpense
        //     },
        // },
        // invoicedVsRecordedExpense: {
        //     id: 'invoicedVsRecordedExpense',
        //     label: 'Invoiced vs Recorded Expense',
        //     type: 'progressBar',
        //     format: (v) => Formatter.currency(v, { decimals: 0 }),
        //     width: 30,
        //     aggregate: 'sum',
        //     value: (row) => {
        //         return row.invoicedVsRecordedExpense
        //     },
        // },
        supplier: {
            id: "supplier",
            label: "Supplier",
            type: "text",
            width: 20,
            value: (row)=>{
                return row.supplier;
            },
            format: (supplier)=>supplier
        }
    });

});



parcelRegister("gDUfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1dbeb32518ab75c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ResourceScheduleReportCollectionClass", function () { return $c1dbeb32518ab75c$export$e3f3a79e92bf9bf5; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $gJY2D = parcelRequire("gJY2D");
var $c1dbeb32518ab75c$var$_dec, $c1dbeb32518ab75c$var$_dec2, $c1dbeb32518ab75c$var$_class;
function $c1dbeb32518ab75c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $c1dbeb32518ab75c$var$ResourceScheduleReportCollection = ($c1dbeb32518ab75c$var$_dec = (0, $d8hWe.action).bound, $c1dbeb32518ab75c$var$_dec2 = (0, $d8hWe.action).bound, $c1dbeb32518ab75c$var$_class = class ResourceScheduleReportCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "resourceScheduleReports",
            modelClass: (0, $gJY2D.default)
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get resourceSchedulesById() {
        return this.modelsById;
    }
    get resourceSchedules() {
        return this.models;
    }
    addResourceSchedule(data) {
        this.add(data);
    }
    addResourceSchedules(data) {
        this.addMany(data);
    }
}, $c1dbeb32518ab75c$var$_applyDecoratedDescriptor($c1dbeb32518ab75c$var$_class.prototype, "addResourceSchedule", [
    $c1dbeb32518ab75c$var$_dec
], Object.getOwnPropertyDescriptor($c1dbeb32518ab75c$var$_class.prototype, "addResourceSchedule"), $c1dbeb32518ab75c$var$_class.prototype), $c1dbeb32518ab75c$var$_applyDecoratedDescriptor($c1dbeb32518ab75c$var$_class.prototype, "addResourceSchedules", [
    $c1dbeb32518ab75c$var$_dec2
], Object.getOwnPropertyDescriptor($c1dbeb32518ab75c$var$_class.prototype, "addResourceSchedules"), $c1dbeb32518ab75c$var$_class.prototype), $c1dbeb32518ab75c$var$_class);
var $c1dbeb32518ab75c$export$2e2bcd8739ae039 = new $c1dbeb32518ab75c$var$ResourceScheduleReportCollection();
const $c1dbeb32518ab75c$export$e3f3a79e92bf9bf5 = $c1dbeb32518ab75c$var$ResourceScheduleReportCollection;

});
parcelRegister("gJY2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ff6c49db24bd2c$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $d8iCu = parcelRequire("d8iCu");

var $gDUfk = parcelRequire("gDUfk");

var $fqmGV = parcelRequire("fqmGV");
parcelRequire("X1RuM");

var $5uSSv = parcelRequire("5uSSv");
var $c2ff6c49db24bd2c$var$_dec, $c2ff6c49db24bd2c$var$_dec2, $c2ff6c49db24bd2c$var$_dec3, $c2ff6c49db24bd2c$var$_dec4, $c2ff6c49db24bd2c$var$_class, $c2ff6c49db24bd2c$var$_descriptor, $c2ff6c49db24bd2c$var$_descriptor2, $c2ff6c49db24bd2c$var$_descriptor3, $c2ff6c49db24bd2c$var$_descriptor4;
function $c2ff6c49db24bd2c$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $c2ff6c49db24bd2c$var$_defineProperty(e, r, t) {
    return (r = $c2ff6c49db24bd2c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c2ff6c49db24bd2c$var$_toPropertyKey(t) {
    var i = $c2ff6c49db24bd2c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c2ff6c49db24bd2c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $c2ff6c49db24bd2c$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $c2ff6c49db24bd2c$var$ResourceScheduleReportModel = ($c2ff6c49db24bd2c$var$_dec = (0, $d8hWe.action).bound, $c2ff6c49db24bd2c$var$_dec2 = (0, $d8hWe.action).bound, $c2ff6c49db24bd2c$var$_dec3 = (0, $d8hWe.action).bound, $c2ff6c49db24bd2c$var$_dec4 = (0, $d8hWe.action).bound, $c2ff6c49db24bd2c$var$_class = class ResourceScheduleReportModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $c2ff6c49db24bd2c$var$_initializerDefineProperty(this, "name", $c2ff6c49db24bd2c$var$_descriptor, this);
        $c2ff6c49db24bd2c$var$_initializerDefineProperty(this, "filters", $c2ff6c49db24bd2c$var$_descriptor2, this);
        $c2ff6c49db24bd2c$var$_initializerDefineProperty(this, "queryKey", $c2ff6c49db24bd2c$var$_descriptor3, this);
        $c2ff6c49db24bd2c$var$_initializerDefineProperty(this, "systemReport", $c2ff6c49db24bd2c$var$_descriptor4, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $gDUfk.default);
        data.filters = {
            ...(0, $d8iCu.default).filters,
            ...data.filters
        };
        this.init(data, options);
        this.setQueryKey();
    }
    update(data, options, ignoreQueryKey = false) {
        super.update(data, options);
        if (!ignoreQueryKey) this.setQueryKey();
    }
    updateFilters(data) {
        this.update({
            filters: {
                ...this.filters,
                ...data
            }
        }, {}, true);
    }
    get needsUpdate() {
        return this.queryKey !== this.makeQueryKey();
    }
    setQueryKey() {
        this.queryKey = this.makeQueryKey();
    }
    makeQueryKey() {
        return JSON.stringify({
            filters: this.filters
        });
    }
    makeDefault() {
        (0, $5uSSv.default).organisation.update({
            defaultResourceScheduleReportId: this.id
        });
    }
    removeDefault() {
        (0, $5uSSv.default).organisation.update({
            defaultResourceScheduleReportId: null
        });
    }
}, $c2ff6c49db24bd2c$var$_descriptor = $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c2ff6c49db24bd2c$var$_descriptor2 = $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "filters", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c2ff6c49db24bd2c$var$_descriptor3 = $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "queryKey", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $c2ff6c49db24bd2c$var$_descriptor4 = $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "systemReport", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "updateFilters", [
    $c2ff6c49db24bd2c$var$_dec
], Object.getOwnPropertyDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "updateFilters"), $c2ff6c49db24bd2c$var$_class.prototype), $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "needsUpdate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "needsUpdate"), $c2ff6c49db24bd2c$var$_class.prototype), $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "setQueryKey", [
    $c2ff6c49db24bd2c$var$_dec2
], Object.getOwnPropertyDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "setQueryKey"), $c2ff6c49db24bd2c$var$_class.prototype), $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "makeDefault", [
    $c2ff6c49db24bd2c$var$_dec3
], Object.getOwnPropertyDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "makeDefault"), $c2ff6c49db24bd2c$var$_class.prototype), $c2ff6c49db24bd2c$var$_applyDecoratedDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "removeDefault", [
    $c2ff6c49db24bd2c$var$_dec4
], Object.getOwnPropertyDescriptor($c2ff6c49db24bd2c$var$_class.prototype, "removeDefault"), $c2ff6c49db24bd2c$var$_class.prototype), $c2ff6c49db24bd2c$var$_class);
var $c2ff6c49db24bd2c$export$2e2bcd8739ae039 = $c2ff6c49db24bd2c$var$ResourceScheduleReportModel;

});


parcelRegister("iV9Vs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc653fedb3b404f3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RevenueForecastReportCollectionClass", function () { return $dc653fedb3b404f3$export$4595977366ccd31e; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $aWaCW = parcelRequire("aWaCW");
var $dc653fedb3b404f3$var$_dec, $dc653fedb3b404f3$var$_dec2, $dc653fedb3b404f3$var$_class;
function $dc653fedb3b404f3$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $dc653fedb3b404f3$var$RevenueForecastReportCollection = ($dc653fedb3b404f3$var$_dec = (0, $d8hWe.action).bound, $dc653fedb3b404f3$var$_dec2 = (0, $d8hWe.action).bound, $dc653fedb3b404f3$var$_class = class RevenueForecastReportCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "revenueForecastReports",
            modelClass: (0, $aWaCW.default)
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get revenueForecastReportsById() {
        return this.modelsById;
    }
    get revenueForecastReports() {
        return this.models;
    }
    addRevenueForecastReport(data) {
        this.add(data);
    }
    addRevenueForecastReports(data) {
        this.addMany(data);
    }
}, $dc653fedb3b404f3$var$_applyDecoratedDescriptor($dc653fedb3b404f3$var$_class.prototype, "addRevenueForecastReport", [
    $dc653fedb3b404f3$var$_dec
], Object.getOwnPropertyDescriptor($dc653fedb3b404f3$var$_class.prototype, "addRevenueForecastReport"), $dc653fedb3b404f3$var$_class.prototype), $dc653fedb3b404f3$var$_applyDecoratedDescriptor($dc653fedb3b404f3$var$_class.prototype, "addRevenueForecastReports", [
    $dc653fedb3b404f3$var$_dec2
], Object.getOwnPropertyDescriptor($dc653fedb3b404f3$var$_class.prototype, "addRevenueForecastReports"), $dc653fedb3b404f3$var$_class.prototype), $dc653fedb3b404f3$var$_class);
var $dc653fedb3b404f3$export$2e2bcd8739ae039 = new $dc653fedb3b404f3$var$RevenueForecastReportCollection();
const $dc653fedb3b404f3$export$4595977366ccd31e = $dc653fedb3b404f3$var$RevenueForecastReportCollection;

});
parcelRegister("aWaCW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f679075e51a437b$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $iV9Vs = parcelRequire("iV9Vs");

var $fqmGV = parcelRequire("fqmGV");

var $dSNYz = parcelRequire("dSNYz");
parcelRequire("X1RuM");

var $5uSSv = parcelRequire("5uSSv");
var $7f679075e51a437b$var$_dec, $7f679075e51a437b$var$_dec2, $7f679075e51a437b$var$_dec3, $7f679075e51a437b$var$_dec4, $7f679075e51a437b$var$_class, $7f679075e51a437b$var$_descriptor, $7f679075e51a437b$var$_descriptor2, $7f679075e51a437b$var$_descriptor3, $7f679075e51a437b$var$_descriptor4;
function $7f679075e51a437b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $7f679075e51a437b$var$_defineProperty(e, r, t) {
    return (r = $7f679075e51a437b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7f679075e51a437b$var$_toPropertyKey(t) {
    var i = $7f679075e51a437b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7f679075e51a437b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7f679075e51a437b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $7f679075e51a437b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $7f679075e51a437b$var$RevenueForecastReportModel = ($7f679075e51a437b$var$_dec = (0, $d8hWe.action).bound, $7f679075e51a437b$var$_dec2 = (0, $d8hWe.action).bound, $7f679075e51a437b$var$_dec3 = (0, $d8hWe.action).bound, $7f679075e51a437b$var$_dec4 = (0, $d8hWe.action).bound, $7f679075e51a437b$var$_class = class RevenueForecastReportModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $7f679075e51a437b$var$_initializerDefineProperty(this, "name", $7f679075e51a437b$var$_descriptor, this);
        $7f679075e51a437b$var$_initializerDefineProperty(this, "filters", $7f679075e51a437b$var$_descriptor2, this);
        $7f679075e51a437b$var$_initializerDefineProperty(this, "queryKey", $7f679075e51a437b$var$_descriptor3, this);
        $7f679075e51a437b$var$_initializerDefineProperty(this, "systemReport", $7f679075e51a437b$var$_descriptor4, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $iV9Vs.default);
        data.filters = {
            ...(0, $dSNYz.default).filters,
            invoiceData: (0, $5uSSv.default).settings.reportInvoiceDateType.replace("issueDate", "issuedOn"),
            ...data.filters
        };
        this.init(data, options);
        this.setQueryKey();
    }
    update(data, options, ignoreQueryKey = false) {
        super.update(data, options);
        if (!ignoreQueryKey) this.setQueryKey();
    }
    updateFilters(data) {
        this.update({
            filters: {
                ...this.filters,
                ...data
            }
        }, {}, true);
    }
    get needsUpdate() {
        return this.queryKey !== this.makeQueryKey();
    }
    setQueryKey() {
        this.queryKey = this.makeQueryKey();
    }
    makeQueryKey() {
        return JSON.stringify({
            filters: this.filters
        });
    }
    makeDefault() {
        (0, $5uSSv.default).organisation.update({
            defaultRevenueForecastReportId: this.id
        });
    }
    removeDefault() {
        (0, $5uSSv.default).organisation.update({
            defaultRevenueForecastReportId: null
        });
    }
}, $7f679075e51a437b$var$_descriptor = $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7f679075e51a437b$var$_descriptor2 = $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "filters", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7f679075e51a437b$var$_descriptor3 = $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "queryKey", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7f679075e51a437b$var$_descriptor4 = $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "systemReport", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "updateFilters", [
    $7f679075e51a437b$var$_dec
], Object.getOwnPropertyDescriptor($7f679075e51a437b$var$_class.prototype, "updateFilters"), $7f679075e51a437b$var$_class.prototype), $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "needsUpdate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($7f679075e51a437b$var$_class.prototype, "needsUpdate"), $7f679075e51a437b$var$_class.prototype), $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "setQueryKey", [
    $7f679075e51a437b$var$_dec2
], Object.getOwnPropertyDescriptor($7f679075e51a437b$var$_class.prototype, "setQueryKey"), $7f679075e51a437b$var$_class.prototype), $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "makeDefault", [
    $7f679075e51a437b$var$_dec3
], Object.getOwnPropertyDescriptor($7f679075e51a437b$var$_class.prototype, "makeDefault"), $7f679075e51a437b$var$_class.prototype), $7f679075e51a437b$var$_applyDecoratedDescriptor($7f679075e51a437b$var$_class.prototype, "removeDefault", [
    $7f679075e51a437b$var$_dec4
], Object.getOwnPropertyDescriptor($7f679075e51a437b$var$_class.prototype, "removeDefault"), $7f679075e51a437b$var$_class.prototype), $7f679075e51a437b$var$_class);
var $7f679075e51a437b$export$2e2bcd8739ae039 = $7f679075e51a437b$var$RevenueForecastReportModel;

});


parcelRegister("2AfWp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e1b4f22e34b8213$export$2e2bcd8739ae039; });
parcelRequire("cjCbh");

var $d8hWe = parcelRequire("d8hWe");
parcelRequire("dBifK");
parcelRequire("4sGvn");
parcelRequire("PIDKX");
parcelRequire("aZYqt");
parcelRequire("kdO1A");
parcelRequire("fqmGV");

var $5Xh7w = parcelRequire("5Xh7w");
var $1e1b4f22e34b8213$var$_dec, $1e1b4f22e34b8213$var$_dec2, $1e1b4f22e34b8213$var$_class, $1e1b4f22e34b8213$var$_descriptor, $1e1b4f22e34b8213$var$_descriptor2, $1e1b4f22e34b8213$var$_descriptor3, $1e1b4f22e34b8213$var$_descriptor4, $1e1b4f22e34b8213$var$_descriptor5, $1e1b4f22e34b8213$var$_descriptor6, $1e1b4f22e34b8213$var$_descriptor7, $1e1b4f22e34b8213$var$_descriptor8, $1e1b4f22e34b8213$var$_descriptor9, $1e1b4f22e34b8213$var$_descriptor10, $1e1b4f22e34b8213$var$_descriptor11, $1e1b4f22e34b8213$var$_descriptor12, $1e1b4f22e34b8213$var$_descriptor13, $1e1b4f22e34b8213$var$_descriptor14, $1e1b4f22e34b8213$var$_descriptor15, $1e1b4f22e34b8213$var$_descriptor16, $1e1b4f22e34b8213$var$_descriptor17, $1e1b4f22e34b8213$var$_descriptor18;
function $1e1b4f22e34b8213$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $1e1b4f22e34b8213$var$_defineProperty(e, r, t) {
    return (r = $1e1b4f22e34b8213$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1e1b4f22e34b8213$var$_toPropertyKey(t) {
    var i = $1e1b4f22e34b8213$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1e1b4f22e34b8213$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1e1b4f22e34b8213$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $1e1b4f22e34b8213$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}

let $1e1b4f22e34b8213$var$InvoiceTemplateModel = ($1e1b4f22e34b8213$var$_dec = (0, $d8hWe.action).bound, $1e1b4f22e34b8213$var$_dec2 = (0, $d8hWe.action).bound, $1e1b4f22e34b8213$var$_class = class InvoiceTemplateModel {
    constructor(org, data){
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "id", $1e1b4f22e34b8213$var$_descriptor, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "templateName", $1e1b4f22e34b8213$var$_descriptor2, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "contentStart", $1e1b4f22e34b8213$var$_descriptor3, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "contentEnd", $1e1b4f22e34b8213$var$_descriptor4, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "footerLeft", $1e1b4f22e34b8213$var$_descriptor5, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "footerRight", $1e1b4f22e34b8213$var$_descriptor6, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "logoUrl", $1e1b4f22e34b8213$var$_descriptor7, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "logoSize", $1e1b4f22e34b8213$var$_descriptor8, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "taxName", $1e1b4f22e34b8213$var$_descriptor9, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "columns", $1e1b4f22e34b8213$var$_descriptor10, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "projectCode", $1e1b4f22e34b8213$var$_descriptor11, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "projectName", $1e1b4f22e34b8213$var$_descriptor12, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "projectAddress", $1e1b4f22e34b8213$var$_descriptor13, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "showDueDate", $1e1b4f22e34b8213$var$_descriptor14, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "showInvoiceNumber", $1e1b4f22e34b8213$var$_descriptor15, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "openPerProject", $1e1b4f22e34b8213$var$_descriptor16, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "closePerProject", $1e1b4f22e34b8213$var$_descriptor17, this);
        $1e1b4f22e34b8213$var$_initializerDefineProperty(this, "organisation", $1e1b4f22e34b8213$var$_descriptor18, this);
        (0, $d8hWe.makeObservable)(this);
        this.organisation = org;
        for (const [key, value] of Object.entries(data))this.changeProp(key, value);
    }
    update(data = {}, options, invoice) {
        for (const [key, value] of Object.entries(data))this.changeProp(key, value);
        this.organisation.updateInvoiceTemplate(this.serialize(), options);
        if (this.openPerProject && invoice !== null && invoice !== void 0 && invoice.project) invoice.project.update({
            invoiceOpen: data.contentStart || ""
        });
        if (this.closePerProject && invoice !== null && invoice !== void 0 && invoice.project) invoice.project.update({
            invoiceClose: data.contentEnd || ""
        });
    }
    changeProp(prop, val) {
        this[prop] = val;
    }
    serialize() {
        return {
            id: this.id,
            templateName: this.templateName,
            contentStart: this.contentStart,
            contentEnd: this.contentEnd,
            footerLeft: this.footerLeft,
            footerRight: this.footerRight,
            logoUrl: this.logoUrl,
            logoSize: this.logoSize,
            taxName: this.taxName,
            columns: this.columns,
            projectCode: this.projectCode,
            projectName: this.projectName,
            projectAddress: this.projectAddress,
            showDueDate: this.showDueDate,
            showInvoiceNumber: this.showInvoiceNumber,
            openPerProject: this.openPerProject,
            closePerProject: this.closePerProject
        };
    }
    getProjectText(invoice) {
        let ctext = [];
        if (invoice.project.jobNumber && this.projectCode) ctext.push(invoice.project.jobNumber);
        if (invoice.project.name && this.projectName) ctext.push(invoice.project.name);
        if (invoice.project.address && this.projectAddress) ctext.push(invoice.project.address);
        return ctext.join("\n");
    }
    getClientText(invoice) {
        var _invoice$contact, _invoice$contact2;
        if (!invoice.contact) return "";
        let ctext = [];
        if (invoice.contact.firstName && invoice.contact.lastName) ctext.push(`${invoice.contact.firstName} ${invoice.contact.lastName}`);
        if (invoice.contact.organisationName) ctext.push(invoice.contact.organisationName);
        if ((_invoice$contact = invoice.contact) !== null && _invoice$contact !== void 0 && _invoice$contact.address) ctext.push((_invoice$contact2 = invoice.contact) === null || _invoice$contact2 === void 0 ? void 0 : _invoice$contact2.address);
        return ctext.join("\n");
    }
    getOpeningText(invoice) {
        if (this.openPerProject) return invoice.project.invoiceOpen;
        else return this.contentStart;
    }
    getClosingText(invoice) {
        if (this.closePerProject) return invoice.project.invoiceClose;
        else return this.contentEnd;
    }
}, $1e1b4f22e34b8213$var$_descriptor = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "id", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1e1b4f22e34b8213$var$_descriptor2 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "templateName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "New Template";
    }
}), $1e1b4f22e34b8213$var$_descriptor3 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "contentStart", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ``;
    }
}), $1e1b4f22e34b8213$var$_descriptor4 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "contentEnd", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return `Please deposit funds electronically within 14 days to:
                    CC Architecture
                    BSB: XXX-XXX
                    Account: XXXX XXXX
                    *Please include reference the invoice number in the payment description.`;
    }
}), $1e1b4f22e34b8213$var$_descriptor5 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "footerLeft", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return `CC Architecture Pty Ltd
                                ABN: XX XXX XXX XXX`;
    }
}), $1e1b4f22e34b8213$var$_descriptor6 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "footerRight", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return `123 Threshold Lane, Melbourne, 
                                VIC Australia 3000
                                Ph: XX XXXX XXXX
                                lecorb@ccarch.com.au
                                `;
    }
}), $1e1b4f22e34b8213$var$_descriptor7 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "logoUrl", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new URL((parcelRequire("4Iihd")));
    }
}), $1e1b4f22e34b8213$var$_descriptor8 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "logoSize", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 6;
    }
}), $1e1b4f22e34b8213$var$_descriptor9 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "taxName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "GST";
    }
}), $1e1b4f22e34b8213$var$_descriptor10 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "columns", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            "description",
            "quantity",
            "unitPrice",
            "amount"
        ];
    }
}), $1e1b4f22e34b8213$var$_descriptor11 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "projectCode", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $1e1b4f22e34b8213$var$_descriptor12 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "projectName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $1e1b4f22e34b8213$var$_descriptor13 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "projectAddress", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $1e1b4f22e34b8213$var$_descriptor14 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "showDueDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $1e1b4f22e34b8213$var$_descriptor15 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "showInvoiceNumber", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return true;
    }
}), $1e1b4f22e34b8213$var$_descriptor16 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "openPerProject", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $1e1b4f22e34b8213$var$_descriptor17 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "closePerProject", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $1e1b4f22e34b8213$var$_descriptor18 = $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "organisation", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "update", [
    $1e1b4f22e34b8213$var$_dec
], Object.getOwnPropertyDescriptor($1e1b4f22e34b8213$var$_class.prototype, "update"), $1e1b4f22e34b8213$var$_class.prototype), $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "changeProp", [
    $1e1b4f22e34b8213$var$_dec2
], Object.getOwnPropertyDescriptor($1e1b4f22e34b8213$var$_class.prototype, "changeProp"), $1e1b4f22e34b8213$var$_class.prototype), $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "serialize", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($1e1b4f22e34b8213$var$_class.prototype, "serialize"), $1e1b4f22e34b8213$var$_class.prototype), $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "getProjectText", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($1e1b4f22e34b8213$var$_class.prototype, "getProjectText"), $1e1b4f22e34b8213$var$_class.prototype), $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "getClientText", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($1e1b4f22e34b8213$var$_class.prototype, "getClientText"), $1e1b4f22e34b8213$var$_class.prototype), $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "getOpeningText", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($1e1b4f22e34b8213$var$_class.prototype, "getOpeningText"), $1e1b4f22e34b8213$var$_class.prototype), $1e1b4f22e34b8213$var$_applyDecoratedDescriptor($1e1b4f22e34b8213$var$_class.prototype, "getClosingText", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($1e1b4f22e34b8213$var$_class.prototype, "getClosingText"), $1e1b4f22e34b8213$var$_class.prototype), $1e1b4f22e34b8213$var$_class);
var $1e1b4f22e34b8213$export$2e2bcd8739ae039 = $1e1b4f22e34b8213$var$InvoiceTemplateModel;

});
parcelRegister("4Iihd", function(module, exports) {

module.exports = (parcelRequire("cPIEy")).getBundleURL("2Lllm") + "coincraft_logo_130.1b205a5d.png";

});




parcelRegister("kB03O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efe74f58a205d90e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "OrganisationSubscriptionCollectionClass", function () { return $efe74f58a205d90e$export$2e9a9d75bf939bf4; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $ePGXV = parcelRequire("ePGXV");
var $efe74f58a205d90e$var$_dec, $efe74f58a205d90e$var$_dec2, $efe74f58a205d90e$var$_class;
function $efe74f58a205d90e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $efe74f58a205d90e$var$OrganisationSubscriptionCollection = ($efe74f58a205d90e$var$_dec = (0, $d8hWe.action).bound, $efe74f58a205d90e$var$_dec2 = (0, $d8hWe.action).bound, $efe74f58a205d90e$var$_class = class OrganisationSubscriptionCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "organisationSubscriptions",
            modelClass: (0, $ePGXV.default)
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get organisationSubscriptionsById() {
        return this.modelsById;
    }
    get organisationSubscriptions() {
        return this.models;
    }
    addOrganisationSubscription(data) {
        this.add(data);
    }
    addOrganisationSubscriptions(data) {
        this.addMany(data);
    }
}, $efe74f58a205d90e$var$_applyDecoratedDescriptor($efe74f58a205d90e$var$_class.prototype, "addOrganisationSubscription", [
    $efe74f58a205d90e$var$_dec
], Object.getOwnPropertyDescriptor($efe74f58a205d90e$var$_class.prototype, "addOrganisationSubscription"), $efe74f58a205d90e$var$_class.prototype), $efe74f58a205d90e$var$_applyDecoratedDescriptor($efe74f58a205d90e$var$_class.prototype, "addOrganisationSubscriptions", [
    $efe74f58a205d90e$var$_dec2
], Object.getOwnPropertyDescriptor($efe74f58a205d90e$var$_class.prototype, "addOrganisationSubscriptions"), $efe74f58a205d90e$var$_class.prototype), $efe74f58a205d90e$var$_class);
var $efe74f58a205d90e$export$2e2bcd8739ae039 = new $efe74f58a205d90e$var$OrganisationSubscriptionCollection();
const $efe74f58a205d90e$export$2e9a9d75bf939bf4 = $efe74f58a205d90e$var$OrganisationSubscriptionCollection;

});
parcelRegister("ePGXV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acc728252d9af4f4$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $kB03O = parcelRequire("kB03O");

var $fqmGV = parcelRequire("fqmGV");

var $egx7S = parcelRequire("egx7S");

var $dBifK = parcelRequire("dBifK");

var $5uSSv = parcelRequire("5uSSv");
var $acc728252d9af4f4$var$_class, $acc728252d9af4f4$var$_descriptor, $acc728252d9af4f4$var$_descriptor2, $acc728252d9af4f4$var$_descriptor3, $acc728252d9af4f4$var$_descriptor4, $acc728252d9af4f4$var$_descriptor5, $acc728252d9af4f4$var$_descriptor6, $acc728252d9af4f4$var$_descriptor7, $acc728252d9af4f4$var$_descriptor8, $acc728252d9af4f4$var$_descriptor9, $acc728252d9af4f4$var$_descriptor10, $acc728252d9af4f4$var$_descriptor11, $acc728252d9af4f4$var$_descriptor12, $acc728252d9af4f4$var$_descriptor13, $acc728252d9af4f4$var$_descriptor14, $acc728252d9af4f4$var$_descriptor15, $acc728252d9af4f4$var$_descriptor16, $acc728252d9af4f4$var$_descriptor17, $acc728252d9af4f4$var$_descriptor18;
function $acc728252d9af4f4$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $acc728252d9af4f4$var$_defineProperty(e, r, t) {
    return (r = $acc728252d9af4f4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $acc728252d9af4f4$var$_toPropertyKey(t) {
    var i = $acc728252d9af4f4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $acc728252d9af4f4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $acc728252d9af4f4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $acc728252d9af4f4$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $acc728252d9af4f4$var$OrganisationSubscriptionModel = ($acc728252d9af4f4$var$_class = class OrganisationSubscriptionModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "subscribedAt", $acc728252d9af4f4$var$_descriptor, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "startedTrialOn", $acc728252d9af4f4$var$_descriptor2, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "cardBrand", $acc728252d9af4f4$var$_descriptor3, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "cardLast4", $acc728252d9af4f4$var$_descriptor4, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "cardExpDate", $acc728252d9af4f4$var$_descriptor5, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "endsTrialOn", $acc728252d9af4f4$var$_descriptor6, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "receiptEmail", $acc728252d9af4f4$var$_descriptor7, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "stripeId", $acc728252d9af4f4$var$_descriptor8, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "credit", $acc728252d9af4f4$var$_descriptor9, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "nextPaymentDate", $acc728252d9af4f4$var$_descriptor10, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "monthlyAdminPlanId", $acc728252d9af4f4$var$_descriptor11, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "monthlyCouponId", $acc728252d9af4f4$var$_descriptor12, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "monthlyStandardPlanId", $acc728252d9af4f4$var$_descriptor13, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "subscriptionPeriod", $acc728252d9af4f4$var$_descriptor14, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "unpaidInvoices", $acc728252d9af4f4$var$_descriptor15, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "yearlyAdminPlanId", $acc728252d9af4f4$var$_descriptor16, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "yearlyCouponId", $acc728252d9af4f4$var$_descriptor17, this);
        $acc728252d9af4f4$var$_initializerDefineProperty(this, "yearlyStandardPlanId", $acc728252d9af4f4$var$_descriptor18, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $kB03O.default);
        this.init(data, options);
    }
    update(data, options) {
        super.update(data, options);
    }
    get trialEndDate() {
        return (0, $egx7S.endOfDay)(new Date(this.endsTrialOn));
    }
    get hasSubscription() {
        return this.subscribedAt !== null;
    }
    get hasTrialExpired() {
        if (this.hasSubscription) return false;
        return this.trialEndDate < (0, $egx7S.endOfDay)(new Date());
    }
    get hasCreditCardExpired() {
        if (!this.cardExpDate) return false;
        return (0, $egx7S.endOfDay)(this.cardExpDate) < (0, $egx7S.endOfDay)(new Date());
    }
    get willCreditCardExpireInLessThanAMonth() {
        if (!this.cardExpDate) return false;
        return (0, $egx7S.differenceInMonths)(this.cardExpDate, new Date()) < 1;
    }
    get invoicesDue() {
        return this.unpaidInvoices.filter((inv)=>(inv.stripe_invoice_id !== "proration" || inv.amount >= 50) && inv.date);
    }
    get hasUnpaidInvoices() {
        return this.invoicesDue.length > 0;
    }
    get earliestUnpaidInvoiceDate() {
        if (!this.invoicesDue.length > 0) return null;
        else return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(this.invoicesDue.map((inv)=>new Date(inv.date)));
    }
    get hasOverdueInvoices() {
        return false;
    }
    get isAccountLocked() {
        //TODO - add unpaid invoices
        return this.hasTrialExpired || this.hasOverdueInvoices;
    }
    get defaultMonthlyStandardPlanId() {
        const subscribedDate = this.subscribedAt ? new Date(this.subscribedAt) : null;
        if (subscribedDate && subscribedDate < new Date("2023-03-20")) return [
            "au",
            "nz"
        ].includes((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) ? "1_Month_Aus_Standard" : "1_Month_US_Standard";
        return [
            "au",
            "nz"
        ].includes((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) ? "1_Month_Aus_35" : "1_Month_US_25";
    }
    get defaultYearlyStandardPlanId() {
        const subscribedDate = this.subscribedAt ? new Date(this.subscribedAt) : null;
        if (subscribedDate && subscribedDate < new Date("2023-03-20")) return [
            "au",
            "nz"
        ].includes((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) ? "12_Month_Aus_Standard" : "12_Month_US_Standard";
        return [
            "au",
            "nz"
        ].includes((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) ? "12_Month_Aus_35" : "12_Month_US_23";
    }
    get defaultMonthlyAdminPlanId() {
        const subscribedDate = this.subscribedAt ? new Date(this.subscribedAt) : null;
        if (subscribedDate && subscribedDate < new Date("2023-03-20")) return [
            "au",
            "nz"
        ].includes((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) ? "1_Month_Aus_Admin" : "1_Month_US_Admin";
        return [
            "au",
            "nz"
        ].includes((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) ? "1_Month_Aus_35" : "1_Month_US_25";
    }
    get defaultYearlyAdminPlanId() {
        const subscribedDate = this.subscribedAt ? new Date(this.subscribedAt) : null;
        if (subscribedDate && subscribedDate < new Date("2023-03-20")) return [
            "au",
            "nz"
        ].includes((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) ? "12_Month_Aus_Admin" : "12_Month_US_Admin";
        return [
            "au",
            "nz"
        ].includes((0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry) ? "12_Month_Aus_35" : "12_Month_US_25";
    }
    get monthlyAdminPlanPrice() {
        return $acc728252d9af4f4$var$planLookup[this.monthlyAdminPlanId || this.defaultMonthlyAdminPlanId].amount;
    }
    get monthlyStandardPlanPrice() {
        return $acc728252d9af4f4$var$planLookup[this.monthlyStandardPlanId || this.defaultMonthlyStandardPlanId].amount;
    }
    get yearlyAdminPlanPrice() {
        return $acc728252d9af4f4$var$planLookup[this.yearlyAdminPlanId || this.defaultYearlyAdminPlanId].amount;
    }
    get yearlyStandardPlanPrice() {
        return $acc728252d9af4f4$var$planLookup[this.yearlyStandardPlanId || this.defaultYearlyStandardPlanId].amount;
    }
    get yearlyDiscount() {
        var _couponLookup;
        return ((_couponLookup = $acc728252d9af4f4$var$couponLookup[this.yearlyCouponId || "15_percent_forever"]) === null || _couponLookup === void 0 ? void 0 : _couponLookup.percentDiscount) || 0;
    }
    get monthlyDiscount() {
        var _couponLookup$this$mo;
        return ((_couponLookup$this$mo = $acc728252d9af4f4$var$couponLookup[this.monthlyCouponId]) === null || _couponLookup$this$mo === void 0 ? void 0 : _couponLookup$this$mo.percentDiscount) || 0;
    }
    get taxPercent() {
        var _taxLookup$SessionSto;
        return ((_taxLookup$SessionSto = $acc728252d9af4f4$var$taxLookup[(0, $5uSSv.default) === null || (0, $5uSSv.default) === void 0 ? void 0 : (0, $5uSSv.default).organisationCountry]) === null || _taxLookup$SessionSto === void 0 ? void 0 : _taxLookup$SessionSto.taxPercent) || 0;
    }
}, $acc728252d9af4f4$var$_descriptor = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "subscribedAt", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor2 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "startedTrialOn", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor3 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "cardBrand", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor4 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "cardLast4", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor5 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "cardExpDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor6 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "endsTrialOn", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor7 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "receiptEmail", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor8 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "stripeId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor9 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "credit", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor10 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "nextPaymentDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor11 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "monthlyAdminPlanId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor12 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "monthlyCouponId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor13 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "monthlyStandardPlanId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor14 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "subscriptionPeriod", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor15 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "unpaidInvoices", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor16 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "yearlyAdminPlanId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor17 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "yearlyCouponId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_descriptor18 = $acc728252d9af4f4$var$_applyDecoratedDescriptor($acc728252d9af4f4$var$_class.prototype, "yearlyStandardPlanId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $acc728252d9af4f4$var$_class);
var $acc728252d9af4f4$export$2e2bcd8739ae039 = $acc728252d9af4f4$var$OrganisationSubscriptionModel;
const $acc728252d9af4f4$var$planLookup = {
    "1_Month_Aus_Admin": {
        id: "1_Month_Aus_Admin",
        interval: "month",
        intervalCount: 1,
        amount: 4500,
        currency: "aud"
    },
    "1_Month_Aus_Standard": {
        id: "1",
        interval: "month",
        intervalCount: 1,
        amount: 2000,
        currency: "aud"
    },
    "12_Month_Aus_Admin": {
        id: "12_Month_Aus_Admin",
        interval: "year",
        intervalCount: 1,
        amount: 54000,
        currency: "aud"
    },
    "12_Month_Aus_Standard": {
        id: "12_Month_Aus_Standard",
        interval: "year",
        intervalCount: 1,
        amount: 24000,
        currency: "aud"
    },
    "6_Month_Aus_Admin": {
        id: "6_Month_Aus_Admin",
        interval: "month",
        intervalCount: 6,
        amount: 27000,
        currency: "aud"
    },
    "6_Month_Aus_Standard": {
        id: "6_Month_Aus_Standard",
        interval: "month",
        intervalCount: 6,
        amount: 12000,
        currency: "aud"
    },
    "1_Month_Aus_Standard_$15": {
        id: "15AUD_User",
        interval: "month",
        intervalCount: 1,
        amount: 1500,
        currency: "aud"
    },
    "12_Month_Aus_Standard_$15": {
        id: "12_Month_15AUD",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "aud"
    },
    "12_Month_Aus_Standard_BS": {
        id: "12_Month_Timesheet_BS",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "aud"
    },
    "1_Month_US_Admin": {
        id: "1month_admin_usd",
        interval: "month",
        intervalCount: 1,
        amount: 3500,
        currency: "usd"
    },
    "1_Month_US_Standard": {
        id: "1month_timesheet_usd",
        interval: "month",
        intervalCount: 1,
        amount: 1500,
        currency: "usd"
    },
    "12_Month_US_Admin": {
        id: "12month_admin_usd",
        interval: "year",
        intervalCount: 1,
        amount: 42000,
        currency: "usd"
    },
    "12_Month_US_Standard": {
        id: "12month_timesheet_usd",
        interval: "year",
        intervalCount: 1,
        amount: 18000,
        currency: "usd"
    },
    "1_Month_US_Any_$23": {
        id: "1_monthly_plan",
        interval: "month",
        intervalCount: 1,
        amount: 2300,
        currency: "usd"
    },
    "12_Month_US_Admin_$30": {
        id: "12month_admin_30usd",
        interval: "year",
        intervalCount: 1,
        amount: 36000,
        currency: "usd"
    },
    "1_Month_Aus_29": {
        id: "price_1MnYUZC5Z2UupQFYupQNBHo6",
        interval: "month",
        intervalCount: 1,
        amount: 2900,
        currency: "aud"
    },
    "12_Month_Aus_29": {
        id: "price_1MnYV3C5Z2UupQFYEBt85US1",
        interval: "year",
        intervalCount: 1,
        amount: 34800,
        currency: "aud"
    },
    "1_Month_US_19": {
        id: "price_1MnYW7C5Z2UupQFYHpzWaEih",
        interval: "month",
        intervalCount: 1,
        amount: 1900,
        currency: "usd"
    },
    "12_Month_US_19": {
        id: "price_1MnYWeC5Z2UupQFYmgDbRJqy",
        interval: "year",
        intervalCount: 1,
        amount: 22800,
        currency: "usd"
    },
    "1_Month_Aus_35": {
        id: "price_1Q8B6xC5Z2UupQFYHil12VMM",
        interval: "month",
        intervalCount: 1,
        amount: 3500,
        currency: "aud"
    },
    "12_Month_Aus_35": {
        id: "price_1Q8B7tC5Z2UupQFY5PjrScn4",
        interval: "year",
        intervalCount: 1,
        amount: 42000,
        currency: "aud"
    },
    "1_Month_US_25": {
        id: "price_1Q8B8tC5Z2UupQFYLobMM9KB",
        interval: "month",
        intervalCount: 1,
        amount: 2500,
        currency: "usd"
    },
    "12_Month_US_25": {
        id: "price_1Q8B9RC5Z2UupQFYCVOeNrd7",
        interval: "year",
        intervalCount: 1,
        amount: 30000,
        currency: "usd"
    }
};
const $acc728252d9af4f4$var$couponLookup = {
    "10_percent_forever": {
        id: "10_percent_forever",
        percentDiscount: 10
    },
    "15_percent_forever": {
        id: "15_percent_forever",
        percentDiscount: 15
    },
    "20_percent_forever": {
        id: "20_percent_forever",
        percentDiscount: 20
    },
    "25_percent_forever": {
        id: "25_percent_forever",
        percentDiscount: 25
    },
    "35_percent_forever": {
        id: "35_percent_forever",
        percentDiscount: 35
    },
    "50_percent_forever": {
        id: "50_percent_forever",
        percentDiscount: 50
    },
    FREE: {
        id: "FREE",
        percentDiscount: 100
    },
    "20_percent_1_year": {
        id: "20_percent_1_year",
        percentDiscount: 20
    },
    "25_percent_1_year": {
        id: "25_percent_1_year",
        percentDiscount: 25
    },
    "50_percent_12months": {
        id: "50_percent_12months",
        percentDiscount: 50
    },
    "35_percent_off_6_months": {
        id: "35_percent_off_6_months",
        percentDiscount: 35
    },
    "5_percent_discount_once": {
        id: "5_percent_discount_once",
        percentDiscount: 5
    },
    "10_percent_discount_once": {
        id: "10_percent_discount_once",
        percentDiscount: 10
    },
    "20_percent_discount_once": {
        id: "20_percent_discount_once",
        percentDiscount: 20
    },
    "25_percent_discount_once": {
        id: "25_percent_discount_once",
        percentDiscount: 25
    },
    "35_percent_discount_once": {
        id: "35_percent_discount_once",
        percentDiscount: 35
    },
    "50_percent_discount_once": {
        id: "50_percent_discount_once",
        percentDiscount: 50
    }
};
const $acc728252d9af4f4$var$taxLookup = {
    au: {
        name: "GST",
        taxPercent: 10
    }
};

});


parcelRegister("flyUR", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $b2c3e6c7ddb4dd76$export$f5282963edea4a68; });
$parcel$export(module.exports, "setTag", function () { return $b2c3e6c7ddb4dd76$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "setUser", function () { return $b2c3e6c7ddb4dd76$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "getCurrentScope", function () { return $b2c3e6c7ddb4dd76$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $b2c3e6c7ddb4dd76$export$6bb76d6eba7e258c; });

var $kVkzB = parcelRequire("kVkzB");
var $fy3b9 = parcelRequire("fy3b9");
var $92ZnQ = parcelRequire("92ZnQ");
var $AYbSY = parcelRequire("AYbSY");
var $fEvRX = parcelRequire("fEvRX");

var $1uoyx = parcelRequire("1uoyx");

var $53lKa = parcelRequire("53lKa");

var $j8q4L = parcelRequire("j8q4L");

var $OMVlP = parcelRequire("OMVlP");

var $kPQMl = parcelRequire("kPQMl");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $b2c3e6c7ddb4dd76$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $j8q4L.getCurrentHub)().captureException(exception, (0, $kPQMl.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $b2c3e6c7ddb4dd76$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $j8q4L.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $b2c3e6c7ddb4dd76$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $j8q4L.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $b2c3e6c7ddb4dd76$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $j8q4L.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $b2c3e6c7ddb4dd76$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $j8q4L.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $b2c3e6c7ddb4dd76$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $j8q4L.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $b2c3e6c7ddb4dd76$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $j8q4L.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $b2c3e6c7ddb4dd76$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $j8q4L.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $b2c3e6c7ddb4dd76$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $j8q4L.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $b2c3e6c7ddb4dd76$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $j8q4L.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $b2c3e6c7ddb4dd76$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $j8q4L.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $b2c3e6c7ddb4dd76$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $j8q4L.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $b2c3e6c7ddb4dd76$export$9a4fed82c350c2bd(callback) {
    return (0, $j8q4L.runWithAsyncContext)(()=>{
        return callback((0, $j8q4L.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $b2c3e6c7ddb4dd76$export$e57ac09b143d92a2(span, callback) {
    return $b2c3e6c7ddb4dd76$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $b2c3e6c7ddb4dd76$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $j8q4L.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $b2c3e6c7ddb4dd76$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $b2c3e6c7ddb4dd76$export$c7be4b0125a10cba();
    const client = $b2c3e6c7ddb4dd76$export$6bb76d6eba7e258c();
    if (!client) (0, $53lKa.DEBUG_BUILD) && (0, $92ZnQ.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $53lKa.DEBUG_BUILD) && (0, $92ZnQ.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $fEvRX.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $b2c3e6c7ddb4dd76$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $b2c3e6c7ddb4dd76$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $AYbSY.timestampInSeconds)();
    function finishCheckIn(status) {
        $b2c3e6c7ddb4dd76$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $AYbSY.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $fy3b9.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $b2c3e6c7ddb4dd76$export$4909b86c8034bf73(timeout) {
    const client = $b2c3e6c7ddb4dd76$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $53lKa.DEBUG_BUILD) && (0, $92ZnQ.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $b2c3e6c7ddb4dd76$export$8360e631d277ea4d(timeout) {
    const client = $b2c3e6c7ddb4dd76$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $53lKa.DEBUG_BUILD) && (0, $92ZnQ.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $b2c3e6c7ddb4dd76$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $j8q4L.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $b2c3e6c7ddb4dd76$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $j8q4L.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $b2c3e6c7ddb4dd76$export$3f95c6f800b78024() {
    return !!$b2c3e6c7ddb4dd76$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $b2c3e6c7ddb4dd76$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $j8q4L.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $b2c3e6c7ddb4dd76$export$c0d84948cecf78d8(context) {
    const client = $b2c3e6c7ddb4dd76$export$6bb76d6eba7e258c();
    const isolationScope = (0, $j8q4L.getIsolationScope)();
    const currentScope = $b2c3e6c7ddb4dd76$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $1uoyx.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $kVkzB.GLOBAL_OBJ).navigator || {};
    const session = (0, $OMVlP.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $OMVlP.updateSession)(currentSession, {
        status: "exited"
    });
    $b2c3e6c7ddb4dd76$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $b2c3e6c7ddb4dd76$export$17a5be43989a0bc1() {
    const isolationScope = (0, $j8q4L.getIsolationScope)();
    const currentScope = $b2c3e6c7ddb4dd76$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $OMVlP.closeSession)(session);
    $b2c3e6c7ddb4dd76$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $b2c3e6c7ddb4dd76$var$_sendSessionUpdate() {
    const isolationScope = (0, $j8q4L.getIsolationScope)();
    const currentScope = $b2c3e6c7ddb4dd76$export$c7be4b0125a10cba();
    const client = $b2c3e6c7ddb4dd76$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $b2c3e6c7ddb4dd76$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $b2c3e6c7ddb4dd76$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $b2c3e6c7ddb4dd76$var$_sendSessionUpdate();
}

});
parcelRegister("kVkzB", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $f3b916ed760b8b6a$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $f3b916ed760b8b6a$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $f3b916ed760b8b6a$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $f3b916ed760b8b6a$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $f3b916ed760b8b6a$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $f3b916ed760b8b6a$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $f3b916ed760b8b6a$var$isGlobalObj(window) || typeof self == "object" && $f3b916ed760b8b6a$var$isGlobalObj(self) || typeof $parcel$global == "object" && $f3b916ed760b8b6a$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $f3b916ed760b8b6a$export$256479dc0cea61c4() {
    return $f3b916ed760b8b6a$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $f3b916ed760b8b6a$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $f3b916ed760b8b6a$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("fy3b9", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $b51c7f41b0829885$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $b51c7f41b0829885$export$49034edbe6b62415; });
$parcel$export(module.exports, "isString", function () { return $b51c7f41b0829885$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $b51c7f41b0829885$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $b51c7f41b0829885$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $b51c7f41b0829885$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $b51c7f41b0829885$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $b51c7f41b0829885$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $b51c7f41b0829885$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $b51c7f41b0829885$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $b51c7f41b0829885$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $b51c7f41b0829885$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $b51c7f41b0829885$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$e6127cc7fe7395c3(wat) {
    switch($b51c7f41b0829885$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $b51c7f41b0829885$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$var$isBuiltin(wat, className) {
    return $b51c7f41b0829885$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$9f9636d330b71954(wat) {
    return $b51c7f41b0829885$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$ef9e2056653f0c8e(wat) {
    return $b51c7f41b0829885$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$12e869b2a583f783(wat) {
    return $b51c7f41b0829885$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$844ec244b1367d54(wat) {
    return $b51c7f41b0829885$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$c3825b437cbdea5c(wat) {
    return wat === null || $b51c7f41b0829885$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$53b83ca8eaab0383(wat) {
    return $b51c7f41b0829885$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $b51c7f41b0829885$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $b51c7f41b0829885$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$49841c62b9eff15(wat) {
    return $b51c7f41b0829885$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $b51c7f41b0829885$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$bc2894c7158efbac(wat) {
    return $b51c7f41b0829885$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b51c7f41b0829885$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("92ZnQ", function(module, exports) {

$parcel$export(module.exports, "consoleSandbox", function () { return $6963ea744bc3d118$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $6963ea744bc3d118$export$af88d00dbe7f521; });

var $84ytc = parcelRequire("84ytc");

var $kVkzB = parcelRequire("kVkzB");
/** Prefix for logging strings */ const $6963ea744bc3d118$var$PREFIX = "Sentry Logger ";
const $6963ea744bc3d118$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $6963ea744bc3d118$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $6963ea744bc3d118$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $kVkzB.GLOBAL_OBJ))) return callback();
    const console = (0, $kVkzB.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($6963ea744bc3d118$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $6963ea744bc3d118$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $6963ea744bc3d118$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $84ytc.DEBUG_BUILD) $6963ea744bc3d118$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $6963ea744bc3d118$export$cda52e2a8927a2ca(()=>{
                (0, $kVkzB.GLOBAL_OBJ).console[name](`${$6963ea744bc3d118$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $6963ea744bc3d118$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $6963ea744bc3d118$export$af88d00dbe7f521 = $6963ea744bc3d118$var$makeLogger();

});
parcelRegister("84ytc", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $5e096f7b86c1b0ec$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $5e096f7b86c1b0ec$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("AYbSY", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $06f20d87177c659b$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $06f20d87177c659b$export$ee52dced521e3e18; });

var $kVkzB = parcelRequire("kVkzB");
const $06f20d87177c659b$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $06f20d87177c659b$export$7740643b9eeaf0c4() {
    return Date.now() / $06f20d87177c659b$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $06f20d87177c659b$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $kVkzB.GLOBAL_OBJ);
    if (!performance || !performance.now) return $06f20d87177c659b$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $06f20d87177c659b$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $06f20d87177c659b$export$ee52dced521e3e18 = $06f20d87177c659b$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $06f20d87177c659b$export$c5907b5a8838db13 = $06f20d87177c659b$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $06f20d87177c659b$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $06f20d87177c659b$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $kVkzB.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $06f20d87177c659b$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $06f20d87177c659b$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $06f20d87177c659b$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $06f20d87177c659b$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("fEvRX", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $b6535005c4123c4a$export$19f53698e68b2496; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $b6535005c4123c4a$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "arrayify", function () { return $b6535005c4123c4a$export$3131421a7d01b4fb; });

var $inuFq = parcelRequire("inuFq");

var $fi8I5 = parcelRequire("fi8I5");

var $kVkzB = parcelRequire("kVkzB");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $b6535005c4123c4a$export$19f53698e68b2496() {
    const gbl = (0, $kVkzB.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $b6535005c4123c4a$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $b6535005c4123c4a$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $b6535005c4123c4a$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $b6535005c4123c4a$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $b6535005c4123c4a$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $b6535005c4123c4a$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $b6535005c4123c4a$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $b6535005c4123c4a$export$d364f2020ab30578(input) {
    const match = input.match($b6535005c4123c4a$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $b6535005c4123c4a$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $fi8I5.snipLine)(line, 0));
    frame.context_line = (0, $fi8I5.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $fi8I5.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $b6535005c4123c4a$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $inuFq.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $b6535005c4123c4a$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("inuFq", function(module, exports) {

$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $d61229da6680be80$export$e73679ffaf56810e; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $d61229da6680be80$export$62ff257738bf57f5; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $d61229da6680be80$export$d25f2688db1bb433; });

var $Dgygx = parcelRequire("Dgygx");

var $84ytc = parcelRequire("84ytc");

var $fy3b9 = parcelRequire("fy3b9");

var $92ZnQ = parcelRequire("92ZnQ");

var $fi8I5 = parcelRequire("fi8I5");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $d61229da6680be80$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $d61229da6680be80$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $d61229da6680be80$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $84ytc.DEBUG_BUILD) && (0, $92ZnQ.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $d61229da6680be80$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $d61229da6680be80$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $d61229da6680be80$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $d61229da6680be80$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $d61229da6680be80$export$62ff257738bf57f5(value) {
    if ((0, $fy3b9.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$d61229da6680be80$var$getOwnProperties(value)
    };
    else if ((0, $fy3b9.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $d61229da6680be80$var$serializeEventTarget(value.target),
            currentTarget: $d61229da6680be80$var$serializeEventTarget(value.currentTarget),
            ...$d61229da6680be80$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $fy3b9.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $d61229da6680be80$var$serializeEventTarget(target) {
    try {
        return (0, $fy3b9.isElement)(target) ? (0, $Dgygx.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $d61229da6680be80$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $d61229da6680be80$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($d61229da6680be80$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $fi8I5.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $fi8I5.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $d61229da6680be80$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $d61229da6680be80$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $d61229da6680be80$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($d61229da6680be80$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $d61229da6680be80$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($d61229da6680be80$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $d61229da6680be80$var$isPojo(input) {
    if (!(0, $fy3b9.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $d61229da6680be80$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $fy3b9.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("Dgygx", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $07607b73467ae4fb$export$5647df6b7814ac86; });

var $fy3b9 = parcelRequire("fy3b9");

var $kVkzB = parcelRequire("kVkzB");
// eslint-disable-next-line deprecation/deprecation
const $07607b73467ae4fb$var$WINDOW = (0, $kVkzB.getGlobalObject)();
const $07607b73467ae4fb$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $07607b73467ae4fb$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $07607b73467ae4fb$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $07607b73467ae4fb$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $07607b73467ae4fb$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($07607b73467ae4fb$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $fy3b9.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $07607b73467ae4fb$export$1cfafeee2987818b() {
    try {
        return $07607b73467ae4fb$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $07607b73467ae4fb$export$c660c1f3ab49225c(selector) {
    if ($07607b73467ae4fb$var$WINDOW.document && $07607b73467ae4fb$var$WINDOW.document.querySelector) return $07607b73467ae4fb$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $07607b73467ae4fb$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$07607b73467ae4fb$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("fi8I5", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $b21f4b15373f726f$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $b21f4b15373f726f$export$4215662d762d6f9d; });

var $fy3b9 = parcelRequire("fy3b9");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $b21f4b15373f726f$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $b21f4b15373f726f$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b21f4b15373f726f$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $fy3b9.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $b21f4b15373f726f$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $fy3b9.isString)(value)) return false;
    if ((0, $fy3b9.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $fy3b9.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $b21f4b15373f726f$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$b21f4b15373f726f$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("1uoyx", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $115ba4183c697342$export$849dbeeeda01ae98; });
const $115ba4183c697342$export$849dbeeeda01ae98 = "production";

});

parcelRegister("53lKa", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $3ade195fa727a06c$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3ade195fa727a06c$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("j8q4L", function(module, exports) {

$parcel$export(module.exports, "getCurrentHub", function () { return $dee2fdca3e1378d1$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $dee2fdca3e1378d1$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $dee2fdca3e1378d1$export$70d775fb1f267027; });

var $92ZnQ = parcelRequire("92ZnQ");
var $AYbSY = parcelRequire("AYbSY");
var $kVkzB = parcelRequire("kVkzB");
var $fy3b9 = parcelRequire("fy3b9");
var $fEvRX = parcelRequire("fEvRX");

var $1uoyx = parcelRequire("1uoyx");

var $53lKa = parcelRequire("53lKa");

var $ipi3S = parcelRequire("ipi3S");

var $OMVlP = parcelRequire("OMVlP");

var $glGRp = parcelRequire("glGRp");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $dee2fdca3e1378d1$export$24a86ef7798177e4 = parseFloat((0, $glGRp.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $dee2fdca3e1378d1$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $dee2fdca3e1378d1$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $dee2fdca3e1378d1$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $ipi3S.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $ipi3S.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $fy3b9.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $fEvRX.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $fEvRX.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $fEvRX.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $dee2fdca3e1378d1$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $AYbSY.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $92ZnQ.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $dee2fdca3e1378d1$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $dee2fdca3e1378d1$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $53lKa.DEBUG_BUILD) && (0, $92ZnQ.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $53lKa.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $92ZnQ.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $92ZnQ.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $OMVlP.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $1uoyx.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $kVkzB.GLOBAL_OBJ).navigator || {};
        const session = (0, $OMVlP.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $OMVlP.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $dee2fdca3e1378d1$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $53lKa.DEBUG_BUILD) && (0, $92ZnQ.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $dee2fdca3e1378d1$export$19eade501500c6c1() {
    (0, $kVkzB.GLOBAL_OBJ).__SENTRY__ = (0, $kVkzB.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $kVkzB.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $dee2fdca3e1378d1$export$4188a14ad302d1bc(hub) {
    const registry = $dee2fdca3e1378d1$export$19eade501500c6c1();
    const oldHub = $dee2fdca3e1378d1$export$bfa8a924a84a76b7(registry);
    $dee2fdca3e1378d1$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $dee2fdca3e1378d1$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $dee2fdca3e1378d1$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $dee2fdca3e1378d1$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $dee2fdca3e1378d1$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $dee2fdca3e1378d1$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $dee2fdca3e1378d1$var$getGlobalHub(registry = $dee2fdca3e1378d1$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$dee2fdca3e1378d1$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $dee2fdca3e1378d1$export$bfa8a924a84a76b7(registry).isOlderThan($dee2fdca3e1378d1$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $dee2fdca3e1378d1$export$849f05434e95d2f2(registry, new $dee2fdca3e1378d1$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $dee2fdca3e1378d1$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $dee2fdca3e1378d1$export$236689a79f5aa020(carrier, parent = $dee2fdca3e1378d1$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$dee2fdca3e1378d1$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $dee2fdca3e1378d1$export$bfa8a924a84a76b7(carrier).isOlderThan($dee2fdca3e1378d1$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $dee2fdca3e1378d1$export$849f05434e95d2f2(carrier, new $dee2fdca3e1378d1$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $dee2fdca3e1378d1$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $dee2fdca3e1378d1$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $dee2fdca3e1378d1$export$70d775fb1f267027(callback, options = {}) {
    const registry = $dee2fdca3e1378d1$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $dee2fdca3e1378d1$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $dee2fdca3e1378d1$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $kVkzB.getGlobalSingleton)("hub", ()=>new $dee2fdca3e1378d1$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $dee2fdca3e1378d1$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("ipi3S", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $d668927658f66e69$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $d668927658f66e69$export$aa55d5ab8e05984f; });

var $AYbSY = parcelRequire("AYbSY");
var $fy3b9 = parcelRequire("fy3b9");
var $92ZnQ = parcelRequire("92ZnQ");
var $fEvRX = parcelRequire("fEvRX");

var $kGFZd = parcelRequire("kGFZd");

var $OMVlP = parcelRequire("OMVlP");

var $i66yn = parcelRequire("i66yn");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $d668927658f66e69$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $d668927658f66e69$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $d668927658f66e69$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $d668927658f66e69$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $d668927658f66e69$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $d668927658f66e69$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $OMVlP.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $d668927658f66e69$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $fy3b9.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $d668927658f66e69$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $d668927658f66e69$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $AYbSY.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $i66yn.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $kGFZd.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $kGFZd.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $fEvRX.uuid4)();
        if (!this._client) {
            (0, $92ZnQ.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $fEvRX.uuid4)();
        if (!this._client) {
            (0, $92ZnQ.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $fEvRX.uuid4)();
        if (!this._client) {
            (0, $92ZnQ.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $d668927658f66e69$export$aa55d5ab8e05984f() {
    if (!$d668927658f66e69$var$globalScope) $d668927658f66e69$var$globalScope = new $d668927658f66e69$export$775b6bb06e53a214();
    return $d668927658f66e69$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $d668927658f66e69$export$c83048efd17527d6(scope) {
    $d668927658f66e69$var$globalScope = scope;
}
function $d668927658f66e69$var$generatePropagationContext() {
    return {
        traceId: (0, $fEvRX.uuid4)(),
        spanId: (0, $fEvRX.uuid4)().substring(16)
    };
}

});
parcelRegister("kGFZd", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $f0f84c7f9b88616e$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $f0f84c7f9b88616e$export$bf2a096c3e883e79; });

var $kVkzB = parcelRequire("kVkzB");
var $fy3b9 = parcelRequire("fy3b9");
var $92ZnQ = parcelRequire("92ZnQ");
var $cYlOz = parcelRequire("cYlOz");

var $53lKa = parcelRequire("53lKa");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $f0f84c7f9b88616e$export$3c4238858b85e8ac() {
    return (0, $kVkzB.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $f0f84c7f9b88616e$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $f0f84c7f9b88616e$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $f0f84c7f9b88616e$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $cYlOz.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $53lKa.DEBUG_BUILD) && processor.id && result === null && (0, $92ZnQ.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $fy3b9.isThenable)(result)) result.then((final)=>$f0f84c7f9b88616e$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $f0f84c7f9b88616e$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("cYlOz", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", function () { return $971c028d40e7fdab$export$6f292d4960313241; });

var $fy3b9 = parcelRequire("fy3b9");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $971c028d40e7fdab$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($971c028d40e7fdab$var$States || ($971c028d40e7fdab$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $971c028d40e7fdab$export$1fda8aa4d135f8aa(value) {
    return new $971c028d40e7fdab$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $971c028d40e7fdab$export$78e43115b553f358(reason) {
    return new $971c028d40e7fdab$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $971c028d40e7fdab$export$6f292d4960313241 {
    constructor(executor){
        $971c028d40e7fdab$export$6f292d4960313241.prototype.__init.call(this);
        $971c028d40e7fdab$export$6f292d4960313241.prototype.__init2.call(this);
        $971c028d40e7fdab$export$6f292d4960313241.prototype.__init3.call(this);
        $971c028d40e7fdab$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $971c028d40e7fdab$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $971c028d40e7fdab$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $971c028d40e7fdab$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($971c028d40e7fdab$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($971c028d40e7fdab$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $971c028d40e7fdab$var$States.PENDING) return;
            if ((0, $fy3b9.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $971c028d40e7fdab$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $971c028d40e7fdab$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $971c028d40e7fdab$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("OMVlP", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $098a9eead107a95a$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $098a9eead107a95a$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $098a9eead107a95a$export$56521d9ba90f62ee; });

var $inuFq = parcelRequire("inuFq");
var $AYbSY = parcelRequire("AYbSY");
var $fEvRX = parcelRequire("fEvRX");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $098a9eead107a95a$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $AYbSY.timestampInSeconds)();
    const session = {
        sid: (0, $fEvRX.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$098a9eead107a95a$var$sessionToJSON(session)
    };
    if (context) $098a9eead107a95a$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $098a9eead107a95a$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $AYbSY.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $fEvRX.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $098a9eead107a95a$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $098a9eead107a95a$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $098a9eead107a95a$var$sessionToJSON(session) {
    return (0, $inuFq.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("i66yn", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $d2cddee7722fe065$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $d2cddee7722fe065$export$25ac7e259a513db4; });

var $fEvRX = parcelRequire("fEvRX");
var $inuFq = parcelRequire("inuFq");

var $aGCns = parcelRequire("aGCns");

var $1dwd0 = parcelRequire("1dwd0");

var $38ytd = parcelRequire("38ytd");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $d2cddee7722fe065$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $d2cddee7722fe065$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $d2cddee7722fe065$var$applySpanToEvent(event, span);
    $d2cddee7722fe065$var$applyFingerprintToEvent(event, fingerprint);
    $d2cddee7722fe065$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $d2cddee7722fe065$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $d2cddee7722fe065$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $d2cddee7722fe065$export$b1a120a2871faa46(data, "extra", extra);
    $d2cddee7722fe065$export$b1a120a2871faa46(data, "tags", tags);
    $d2cddee7722fe065$export$b1a120a2871faa46(data, "user", user);
    $d2cddee7722fe065$export$b1a120a2871faa46(data, "contexts", contexts);
    $d2cddee7722fe065$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $d2cddee7722fe065$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $d2cddee7722fe065$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $inuFq.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $inuFq.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $inuFq.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $inuFq.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $d2cddee7722fe065$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $d2cddee7722fe065$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $d2cddee7722fe065$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $38ytd.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $1dwd0.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $aGCns.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $38ytd.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $d2cddee7722fe065$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $fEvRX.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("aGCns", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $7c7b98900feb481b$export$a117f995597e25df; });

var $inuFq = parcelRequire("inuFq");

var $1uoyx = parcelRequire("1uoyx");

var $flyUR = parcelRequire("flyUR");

var $1dwd0 = parcelRequire("1dwd0");

var $38ytd = parcelRequire("38ytd");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $7c7b98900feb481b$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $inuFq.dropUndefinedKeys)({
        environment: options.environment || (0, $1uoyx.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $7c7b98900feb481b$export$a117f995597e25df(span) {
    const client = (0, $flyUR.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $7c7b98900feb481b$export$366bad00d6815eed((0, $38ytd.spanToJSON)(span).trace_id || "", client, (0, $flyUR.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $1dwd0.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $38ytd.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $38ytd.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRegister("1dwd0", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $0e2ffd5923c3008f$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $0e2ffd5923c3008f$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("38ytd", function(module, exports) {

$parcel$export(module.exports, "spanToTraceContext", function () { return $248cdb848172e2b0$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $248cdb848172e2b0$export$92d8c23565496537; });
$parcel$export(module.exports, "spanIsSampled", function () { return $248cdb848172e2b0$export$5caecac1caaf3a71; });

var $inuFq = parcelRequire("inuFq");
var $dXDMt = parcelRequire("dXDMt");
var $AYbSY = parcelRequire("AYbSY");
// These are aligned with OpenTelemetry trace flags
const $248cdb848172e2b0$export$208d5b368507fb8b = 0x0;
const $248cdb848172e2b0$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $248cdb848172e2b0$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $248cdb848172e2b0$export$92d8c23565496537(span);
    return (0, $inuFq.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $248cdb848172e2b0$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $248cdb848172e2b0$export$5caecac1caaf3a71(span);
    return (0, $dXDMt.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $248cdb848172e2b0$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $248cdb848172e2b0$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $248cdb848172e2b0$var$ensureTimestampInSeconds(input.getTime());
    return (0, $AYbSY.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $248cdb848172e2b0$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $248cdb848172e2b0$export$92d8c23565496537(span) {
    if ($248cdb848172e2b0$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $248cdb848172e2b0$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $248cdb848172e2b0$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $248cdb848172e2b0$export$eb571cd9b5d98de8);
}

});
parcelRegister("dXDMt", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $a29fa4b0cf8a3fe7$export$f35d907436da45cf; });

var $lNYKq = parcelRequire("lNYKq");

var $fEvRX = parcelRequire("fEvRX");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $a29fa4b0cf8a3fe7$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $a29fa4b0cf8a3fe7$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($a29fa4b0cf8a3fe7$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $a29fa4b0cf8a3fe7$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $a29fa4b0cf8a3fe7$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $lNYKq.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $fEvRX.uuid4)(),
            spanId: (0, $fEvRX.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $fEvRX.uuid4)(),
            parentSpanId: parentSpanId || (0, $fEvRX.uuid4)().substring(16),
            spanId: (0, $fEvRX.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $a29fa4b0cf8a3fe7$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $a29fa4b0cf8a3fe7$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $lNYKq.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $fEvRX.uuid4)(),
        spanId: (0, $fEvRX.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $fEvRX.uuid4)(),
        parentSpanId: parentSpanId || (0, $fEvRX.uuid4)().substring(16),
        spanId: (0, $fEvRX.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $a29fa4b0cf8a3fe7$export$f35d907436da45cf(traceId = (0, $fEvRX.uuid4)(), spanId = (0, $fEvRX.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("lNYKq", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $fdfd4bd7dde79d4d$export$5b96ee2c8421f107; });

var $84ytc = parcelRequire("84ytc");

var $fy3b9 = parcelRequire("fy3b9");

var $92ZnQ = parcelRequire("92ZnQ");
const $fdfd4bd7dde79d4d$export$9ca9946bd449ac06 = "baggage";
const $fdfd4bd7dde79d4d$export$6e69537d67fa20f = "sentry-";
const $fdfd4bd7dde79d4d$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $fdfd4bd7dde79d4d$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $fdfd4bd7dde79d4d$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $fy3b9.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $fdfd4bd7dde79d4d$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $fdfd4bd7dde79d4d$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($fdfd4bd7dde79d4d$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($fdfd4bd7dde79d4d$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $fdfd4bd7dde79d4d$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$fdfd4bd7dde79d4d$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $fdfd4bd7dde79d4d$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $fdfd4bd7dde79d4d$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $fdfd4bd7dde79d4d$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $fdfd4bd7dde79d4d$export$bdd844ddb2def819) {
            (0, $84ytc.DEBUG_BUILD) && (0, $92ZnQ.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});






parcelRegister("glGRp", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $be6fdab3076d0259$export$31499a9cd224b78c; });
const $be6fdab3076d0259$export$31499a9cd224b78c = "7.118.0";

});


parcelRegister("kPQMl", function(module, exports) {

$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $f2b182d119c33366$export$76b5f966996d1653; });

var $fEvRX = parcelRequire("fEvRX");
var $AYbSY = parcelRequire("AYbSY");
var $kVkzB = parcelRequire("kVkzB");
var $8aKKC = parcelRequire("8aKKC");
var $fi8I5 = parcelRequire("fi8I5");

var $1uoyx = parcelRequire("1uoyx");

var $kGFZd = parcelRequire("kGFZd");

var $ipi3S = parcelRequire("ipi3S");

var $i66yn = parcelRequire("i66yn");

var $38ytd = parcelRequire("38ytd");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $f2b182d119c33366$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $fEvRX.uuid4)(),
        timestamp: event.timestamp || (0, $AYbSY.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $f2b182d119c33366$var$applyClientOptions(prepared, options);
    $f2b182d119c33366$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $f2b182d119c33366$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $f2b182d119c33366$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $fEvRX.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $ipi3S.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $i66yn.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $i66yn.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $i66yn.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $kGFZd.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $kGFZd.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $f2b182d119c33366$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $f2b182d119c33366$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $f2b182d119c33366$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $1uoyx.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $fi8I5.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $fi8I5.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $fi8I5.truncate)(request.url, maxValueLength);
}
const $f2b182d119c33366$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $f2b182d119c33366$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $kVkzB.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $f2b182d119c33366$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $f2b182d119c33366$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $f2b182d119c33366$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $f2b182d119c33366$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $f2b182d119c33366$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $8aKKC.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $8aKKC.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $8aKKC.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $8aKKC.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $8aKKC.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $38ytd.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $8aKKC.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $f2b182d119c33366$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $ipi3S.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $f2b182d119c33366$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($f2b182d119c33366$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($f2b182d119c33366$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $f2b182d119c33366$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $ipi3S.Scope) || typeof hint === "function";
}
const $f2b182d119c33366$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $f2b182d119c33366$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$f2b182d119c33366$var$captureContextKeys.includes(key));
}

});
parcelRegister("8aKKC", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $5f3385a6237430ec$export$a3295358bff77e; });

var $fy3b9 = parcelRequire("fy3b9");

var $g4LiR = parcelRequire("g4LiR");

var $inuFq = parcelRequire("inuFq");

var $4rvjf = parcelRequire("4rvjf");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5f3385a6237430ec$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5f3385a6237430ec$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5f3385a6237430ec$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5f3385a6237430ec$export$a3295358bff77e(object, depth);
    if ($5f3385a6237430ec$var$jsonSize(normalized) > maxSize) return $5f3385a6237430ec$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5f3385a6237430ec$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $g4LiR.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $fy3b9.isNaN)(value)) return value;
    const stringified = $5f3385a6237430ec$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5f3385a6237430ec$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $inuFq.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5f3385a6237430ec$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5f3385a6237430ec$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $fy3b9.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $fy3b9.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $4rvjf.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5f3385a6237430ec$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5f3385a6237430ec$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $5f3385a6237430ec$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5f3385a6237430ec$var$jsonSize(value) {
    return $5f3385a6237430ec$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5f3385a6237430ec$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("g4LiR", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $bb41b67e151239c3$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $bb41b67e151239c3$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("4rvjf", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", function () { return $33c1f87495f26fbe$export$aad197c7121a6651; });

var $9mUAy = parcelRequire("9mUAy");
const $33c1f87495f26fbe$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $33c1f87495f26fbe$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $33c1f87495f26fbe$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $33c1f87495f26fbe$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $33c1f87495f26fbe$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($33c1f87495f26fbe$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $33c1f87495f26fbe$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $33c1f87495f26fbe$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $33c1f87495f26fbe$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $33c1f87495f26fbe$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $33c1f87495f26fbe$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($33c1f87495f26fbe$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($33c1f87495f26fbe$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $33c1f87495f26fbe$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $33c1f87495f26fbe$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $33c1f87495f26fbe$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $33c1f87495f26fbe$var$defaultFunctionName;
        return fn.name || $33c1f87495f26fbe$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $33c1f87495f26fbe$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $33c1f87495f26fbe$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $9mUAy.node)(getModule)
    ];
}

});
parcelRegister("9mUAy", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $6d221070e84f162c$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $6d221070e84f162c$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $6d221070e84f162c$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $6d221070e84f162c$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("3NsHP", function(module, exports) {
module.exports = JSON.parse('{"name":"cc_mobile_web_client","version":"1.9.185","private":true,"dependencies":{"@babel/preset-typescript":"^7.22.5","@clerk/clerk-react":"^5.13.1","@daveyplate/better-auth-tanstack":"^1.3.6","@daveyplate/better-auth-ui":"^3.2.6","@doodle3d/clipper-js":"^1.0.11","@emotion/react":"^11.11.1","@emotion/styled":"^11.9.3","@fortawesome/fontawesome-svg-core":"^6.1.1","@fortawesome/free-regular-svg-icons":"^6.1.1","@fortawesome/free-solid-svg-icons":"^6.1.1","@fortawesome/react-fontawesome":"^0.1.18","@hcaptcha/react-hcaptcha":"^1.14.0","@hookform/resolvers":"^3.9.0","@internationalized/date":"^3.3.0","@internationalized/number":"^3.1.1","@marsidev/react-turnstile":"^1.1.0","@mui/material":"^5.16.6","@radix-ui/react-avatar":"^1.1.0","@radix-ui/react-checkbox":"^1.1.0","@radix-ui/react-dialog":"^1.1.0","@radix-ui/react-dropdown-menu":"^2.1.0","@radix-ui/react-label":"^2.1.0","@radix-ui/react-select":"^2.2.0","@radix-ui/react-separator":"^1.1.0","@radix-ui/react-slot":"^1.1.0","@radix-ui/react-tabs":"^1.1.0","@react-hook/hover":"^4.0.0","@react-hook/media-query":"^1.1.1","@react-hook/mouse-position":"^4.1.3","@react-hook/resize-observer":"^1.2.6","@rooks/use-outside-click":"^4.11.2","@ryki/datemath":"^1.3.4","@sentry/react":"^7.73.0","@sindresorhus/is":"4.6.0","@skoging/react-app-rewire-source-map-loader":"^1.0.9","@tanstack/react-query":"^4.18.0","@tanstack/react-query-devtools":"^4.29.6","@trpc/client":"^11.1.2","@trpc/react":"^9.27.4","@trpc/server":"^11.1.2","add":"^2.0.6","antd":"^4.7.3","autoprefixer":"^10.4.21","axios":"^0.19.0","axios-request-handler":"^1.0.4","better-auth":"^1.3.25","bind-decorator":"^1.0.11","change-case":"^4.1.2","class-variance-authority":"^0.7.0","classnames":"^2.2.5","clsx":"^2.1.1","copy-to-clipboard":"^3.3.1","create-react-class":"^15.6.3","cuid":"^2.1.8","date-fns":"^3.6.0","downloadjs":"^1.4.7","element-resize-detector":"^1.2.3","flux":"^2.1.1","get-user-locale":"^1.5.1","globalize":"^0.1.1","hamjest":"^2.13.0","history":"^1.17.0","husl":"^6.0.1","immutable":"^3.8.1","immutable-tuple":"^0.4.10","input-otp":"^1.4.2","install":"^0.13.0","iso-lang-codes":"^2.1.1","jquery":"^3.4.1","js-cookie":"^3.0.1","js-file-download":"^0.4.8","jwt-decode":"^4.0.0","locale-currency":"^0.0.2","localforage":"^1.10.0","lodash.merge":"^4.3.5","logrocket":"^1.2.2","lucide-react":"^0.407.0","mathjs":"^6.2.1","mobx":"^6.0.1","mobx-react":"^7.0.0","mobx-react-lite":"^3.0.1","mobx-utils":"^6.0.5","mockdate":"^1.0.4","moment":"^2.14.1","mousetrap":"^1.6.1","nearley":"^2.20.1","npm":"^3.9.0","numeral":"^2.0.6","papaparse":"^4.3.6","pluralize":"^8.0.0","postcss":"^8.5.6","posthog-js":"^1.239.0","prop-types":"^15.7.2","react":"^18.2.0","react-addons-linked-state-mixin":"^15.0.2","react-addons-pure-render-mixin":"^15.4.2","react-addons-transition-group":"^15.3.2","react-aria":"^3.19.0","react-calendar":"^3.1.0","react-data-grid":"^6.1.0","react-dom":"^18.2.0","react-draggable-list":"^4.1.0","react-error-boundary":"^3.1.4","react-hook-form":"^7.52.1","react-input-autosize":"^1.1.0","react-promise-suspense":"^0.3.3","react-router":"^3.0.2","react-scripts":"3.1.1","react-select":"^5.4.0","react-sortable-hoc":"^2.0.0","react-tap-event-plugin":"^1.0.0","react-textarea-autosize":"^4.0.1","react-tooltip":"^5.19.0","react-use-gesture":"^7.0.16","react-widgets":"^3.4.5","reselect":"^2.5.3","rsvp":"^3.2.1","sass":"^1.48.0","sonner":"^1.7.0","superjson":"^1.9.1","tailwind-merge":"^2.6.0","tailwindcss":"^3.0.0","title-case":"^3.0.3","trackjs":"^3.9.2","typescript":"^5.1.6","underscore":"^1.8.3","velocity-animate":"^1.2.3","vinyl-source-stream":"^1.1.0","wait":"^0.4.2","wouter":"^2.8.0-alpha.2","xspans":"^1.0.1","yarn":"^1.22.19","zod":"^3.0.0"},"devDependencies":{"@babel/core":"^7.12.0","@babel/plugin-proposal-class-properties":"^7.18.6","@babel/plugin-proposal-decorators":"^7.4.4","@babel/plugin-proposal-logical-assignment-operators":"^7.2.0","@babel/plugin-proposal-nullish-coalescing-operator":"^7.4.4","@babel/plugin-proposal-optional-chaining":"^7.2.0","@babel/plugin-proposal-record-and-tuple":"^7.18.6","@babel/preset-env":"^7.22.9","@babel/preset-react":"^7.22.5","@bloomberg/record-tuple-polyfill":"^0.0.4","@parcel/packager-raw-url":"2.12.0","@parcel/transformer-sass":"2.12.0","@parcel/transformer-webmanifest":"2.12.0","babel-loader":"8.0.6","customize-cra":"^0.2.13","enzyme":"^2.7.1","json":"^9.0.4","parcel":"^2.12.0","qunitjs":"^2.0.0-rc1","react-addons-test-utils":"^15.4.2","react-app-rewired":"^2.1.3","tailwind-scrollbar":"^4.0.2","tailwindcss-animate":"^1.0.7"},"source":"./public/index.html","scripts":{"start":"parcel --port 3001","build":"parcel build --dist-dir build"},"parcel":{"extends":"@parcel/config-default","transformers":{"*.txt":["...","@parcel/transformer-raw"]},"contentHash":{"txt":false}},"eslintConfig":{"extends":"react-app"},"browserslist":{"production":[">0.2%","not dead","not op_mini all"],"development":["last 1 chrome version","last 1 firefox version","last 1 safari version"]},"engines":{"node":">=20.19.0"},"alias":{"better-auth/react":"./node_modules/better-auth/dist/client/react/index.mjs","better-auth/client":"./node_modules/better-auth/dist/client/index.mjs","better-auth/client/plugins":"./node_modules/better-auth/dist/client/plugins/index.mjs"}}');

});

parcelRegister("6vulY", function(module, exports) {

$parcel$export(module.exports, "getVersion", function () { return $4bcd2edf9255f209$export$c506eb22e615ba4a; });
parcelRequire("3NsHP");

var $b8BPd = parcelRequire("b8BPd");
async function $4bcd2edf9255f209$export$c506eb22e615ba4a() {
    const data = await (0, $b8BPd.trpc).utils.getVersion.query();
    // Return the full version data object for enhanced version checking
    return data;
}

});
parcelRegister("b8BPd", function(module, exports) {

$parcel$export(module.exports, "trpc", function () { return $48dfbeefc591b915$export$26420885829a1061; });

var $7crml = parcelRequire("7crml");
var $gARAj = parcelRequire("gARAj");

var $f9Rb7 = parcelRequire("f9Rb7");
const $48dfbeefc591b915$export$26420885829a1061 = (0, $7crml.createTRPCProxyClient)({
    links: [
        (0, $gARAj.httpLink)({
            url: `${"https://server2.coincraft.co"}/trpc`,
            fetch (url, options) {
                return fetch(url, {
                    ...options,
                    credentials: "include" // Include cookies for Better Auth sessions
                });
            },
            async headers () {
                const headers = {};
                // Add PostHog session info for server-side event tracking
                try {
                    const sessionId = (0, $f9Rb7.default).get_session_id();
                    const distinctId = (0, $f9Rb7.default).get_distinct_id();
                    if (sessionId) headers["x-posthog-session-id"] = sessionId;
                    if (distinctId) headers["x-posthog-distinct-id"] = distinctId;
                } catch (error) {
                    // PostHog might not be initialized yet, that's ok
                    console.debug("PostHog session info not available:", error);
                }
                return headers;
            }
        })
    ]
});

});
parcelRegister("7crml", function(module, exports) {

$parcel$export(module.exports, "createTRPCProxyClient", function () { return $84cfe0951de1982f$export$b2acd49cd3814618; });
$parcel$export(module.exports, "httpLink", function () { return (parcelRequire("gARAj")).httpLink; });

var $a6ELx = parcelRequire("a6ELx");

var $3GFYM = parcelRequire("3GFYM");

var $2J6qj = parcelRequire("2J6qj");

var $aBBWl = parcelRequire("aBBWl");

var $gARAj = parcelRequire("gARAj");

var $jker1 = parcelRequire("jker1");

var $fj8ND = parcelRequire("fj8ND");

var $i1TZg = parcelRequire("i1TZg");

var $2IWia = parcelRequire("2IWia");

var $lQFgY = parcelRequire("lQFgY");
var $c2p8A = parcelRequire("c2p8A");

var $8hhvi = parcelRequire("8hhvi");
var $1h7sD = parcelRequire("1h7sD");
var $d09NT = parcelRequire("d09NT");
var $6bgAm = parcelRequire("6bgAm");

var $8hhvi = parcelRequire("8hhvi");
var $1h7sD = parcelRequire("1h7sD");

var $6bgAm = parcelRequire("6bgAm");
//#region src/internals/TRPCUntypedClient.ts
var $84cfe0951de1982f$var$import_defineProperty = (0, $a6ELx.__toESM)((0, $a6ELx.require_defineProperty)(), 1);
var $84cfe0951de1982f$var$import_objectSpread2$4 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
var $84cfe0951de1982f$export$a10d649cc8f633d5 = class {
    constructor(opts){
        (0, $84cfe0951de1982f$var$import_defineProperty.default)(this, "links", void 0);
        (0, $84cfe0951de1982f$var$import_defineProperty.default)(this, "runtime", void 0);
        (0, $84cfe0951de1982f$var$import_defineProperty.default)(this, "requestId", void 0);
        this.requestId = 0;
        this.runtime = {};
        this.links = opts.links.map((link)=>link(this.runtime));
    }
    $request(opts) {
        var _opts$context;
        const chain$ = (0, $3GFYM.createChain)({
            links: this.links,
            op: (0, $84cfe0951de1982f$var$import_objectSpread2$4.default)((0, $84cfe0951de1982f$var$import_objectSpread2$4.default)({}, opts), {}, {
                context: (_opts$context = opts.context) !== null && _opts$context !== void 0 ? _opts$context : {},
                id: ++this.requestId
            })
        });
        return chain$.pipe((0, $lQFgY.share)());
    }
    async requestAsPromise(opts) {
        var _this = this;
        try {
            const req$ = _this.$request(opts);
            const envelope = await (0, $c2p8A.observableToPromise)(req$);
            const data = envelope.result.data;
            return data;
        } catch (err) {
            throw (0, $2J6qj.TRPCClientError).from(err);
        }
    }
    query(path, input, opts) {
        return this.requestAsPromise({
            type: "query",
            path: path,
            input: input,
            context: opts === null || opts === void 0 ? void 0 : opts.context,
            signal: opts === null || opts === void 0 ? void 0 : opts.signal
        });
    }
    mutation(path, input, opts) {
        return this.requestAsPromise({
            type: "mutation",
            path: path,
            input: input,
            context: opts === null || opts === void 0 ? void 0 : opts.context,
            signal: opts === null || opts === void 0 ? void 0 : opts.signal
        });
    }
    subscription(path, input, opts) {
        const observable$ = this.$request({
            type: "subscription",
            path: path,
            input: input,
            context: opts.context,
            signal: opts.signal
        });
        return observable$.subscribe({
            next (envelope) {
                switch(envelope.result.type){
                    case "state":
                        var _opts$onConnectionSta;
                        (_opts$onConnectionSta = opts.onConnectionStateChange) === null || _opts$onConnectionSta === void 0 || _opts$onConnectionSta.call(opts, envelope.result);
                        break;
                    case "started":
                        var _opts$onStarted;
                        (_opts$onStarted = opts.onStarted) === null || _opts$onStarted === void 0 || _opts$onStarted.call(opts, {
                            context: envelope.context
                        });
                        break;
                    case "stopped":
                        var _opts$onStopped;
                        (_opts$onStopped = opts.onStopped) === null || _opts$onStopped === void 0 || _opts$onStopped.call(opts);
                        break;
                    case "data":
                    case void 0:
                        var _opts$onData;
                        (_opts$onData = opts.onData) === null || _opts$onData === void 0 || _opts$onData.call(opts, envelope.result.data);
                        break;
                }
            },
            error (err) {
                var _opts$onError;
                (_opts$onError = opts.onError) === null || _opts$onError === void 0 || _opts$onError.call(opts, err);
            },
            complete () {
                var _opts$onComplete;
                (_opts$onComplete = opts.onComplete) === null || _opts$onComplete === void 0 || _opts$onComplete.call(opts);
            }
        });
    }
};
//#endregion
//#region src/createTRPCUntypedClient.ts
function $84cfe0951de1982f$export$3f94c4551b43e9f9(opts) {
    return new $84cfe0951de1982f$export$a10d649cc8f633d5(opts);
}
//#endregion
//#region src/createTRPCClient.ts
const $84cfe0951de1982f$var$untypedClientSymbol = Symbol.for("trpc_untypedClient");
const $84cfe0951de1982f$var$clientCallTypeMap = {
    query: "query",
    mutate: "mutation",
    subscribe: "subscription"
};
/** @internal */ const $84cfe0951de1982f$export$fb09c8ac507dc94d = (clientCallType)=>{
    return $84cfe0951de1982f$var$clientCallTypeMap[clientCallType];
};
/**
* @internal
*/ function $84cfe0951de1982f$export$a66136bdbd4ef050(client) {
    const proxy = (0, $1h7sD.createRecursiveProxy)(({ path: path, args: args })=>{
        const pathCopy = [
            ...path
        ];
        const procedureType = $84cfe0951de1982f$export$fb09c8ac507dc94d(pathCopy.pop());
        const fullPath = pathCopy.join(".");
        return client[procedureType](fullPath, ...args);
    });
    return (0, $1h7sD.createFlatProxy)((key)=>{
        if (key === $84cfe0951de1982f$var$untypedClientSymbol) return client;
        return proxy[key];
    });
}
function $84cfe0951de1982f$export$b2acd49cd3814618(opts) {
    const client = new $84cfe0951de1982f$export$a10d649cc8f633d5(opts);
    const proxy = $84cfe0951de1982f$export$a66136bdbd4ef050(client);
    return proxy;
}
/**
* Get an untyped client from a proxy client
* @internal
*/ function $84cfe0951de1982f$export$53bfa8a200ae4db4(client) {
    return client[$84cfe0951de1982f$var$untypedClientSymbol];
}
//#endregion
//#region src/links/httpBatchStreamLink.ts
var $84cfe0951de1982f$var$import_objectSpread2$3 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
/**
* @see https://trpc.io/docs/client/links/httpBatchStreamLink
*/ function $84cfe0951de1982f$export$33a61750bfc89a79(opts) {
    var _opts$maxURLLength, _opts$maxItems;
    const resolvedOpts = (0, $aBBWl.resolveHTTPLinkOptions)(opts);
    const maxURLLength = (_opts$maxURLLength = opts.maxURLLength) !== null && _opts$maxURLLength !== void 0 ? _opts$maxURLLength : Infinity;
    const maxItems = (_opts$maxItems = opts.maxItems) !== null && _opts$maxItems !== void 0 ? _opts$maxItems : Infinity;
    return ()=>{
        const batchLoader = (type)=>{
            return {
                validate (batchOps) {
                    if (maxURLLength === Infinity && maxItems === Infinity) return true;
                    if (batchOps.length > maxItems) return false;
                    const path = batchOps.map((op)=>op.path).join(",");
                    const inputs = batchOps.map((op)=>op.input);
                    const url = (0, $aBBWl.getUrl)((0, $84cfe0951de1982f$var$import_objectSpread2$3.default)((0, $84cfe0951de1982f$var$import_objectSpread2$3.default)({}, resolvedOpts), {}, {
                        type: type,
                        path: path,
                        inputs: inputs,
                        signal: null
                    }));
                    return url.length <= maxURLLength;
                },
                async fetch (batchOps) {
                    const path = batchOps.map((op)=>op.path).join(",");
                    const inputs = batchOps.map((op)=>op.input);
                    const batchSignals = (0, $jker1.allAbortSignals)(...batchOps.map((op)=>op.signal));
                    const abortController = new AbortController();
                    const responsePromise = (0, $aBBWl.fetchHTTPResponse)((0, $84cfe0951de1982f$var$import_objectSpread2$3.default)((0, $84cfe0951de1982f$var$import_objectSpread2$3.default)({}, resolvedOpts), {}, {
                        signal: (0, $jker1.raceAbortSignals)(batchSignals, abortController.signal),
                        type: type,
                        contentTypeHeader: "application/json",
                        trpcAcceptHeader: "application/jsonl",
                        getUrl: $aBBWl.getUrl,
                        getBody: $aBBWl.getBody,
                        inputs: inputs,
                        path: path,
                        headers () {
                            if (!opts.headers) return {};
                            if (typeof opts.headers === "function") return opts.headers({
                                opList: batchOps
                            });
                            return opts.headers;
                        }
                    }));
                    const res = await responsePromise;
                    const [head] = await (0, $d09NT.jsonlStreamConsumer)({
                        from: res.body,
                        deserialize: (data)=>resolvedOpts.transformer.output.deserialize(data),
                        formatError (opts$1) {
                            const error = opts$1.error;
                            return (0, $2J6qj.TRPCClientError).from({
                                error: error
                            });
                        },
                        abortController: abortController
                    });
                    const promises = Object.keys(batchOps).map(async (key)=>{
                        let json = await Promise.resolve(head[key]);
                        if ("result" in json) {
                            /**
							* Not very pretty, but we need to unwrap nested data as promises
							* Our stream producer will only resolve top-level async values or async values that are directly nested in another async value
							*/ const result = await Promise.resolve(json.result);
                            json = {
                                result: {
                                    data: await Promise.resolve(result.data)
                                }
                            };
                        }
                        return {
                            json: json,
                            meta: {
                                response: res
                            }
                        };
                    });
                    return promises;
                }
            };
        };
        const query = (0, $jker1.dataLoader)(batchLoader("query"));
        const mutation = (0, $jker1.dataLoader)(batchLoader("mutation"));
        const loaders = {
            query: query,
            mutation: mutation
        };
        return ({ op: op })=>{
            return (0, $c2p8A.observable)((observer)=>{
                /* istanbul ignore if -- @preserve */ if (op.type === "subscription") throw new Error("Subscriptions are unsupported by `httpBatchStreamLink` - use `httpSubscriptionLink` or `wsLink`");
                const loader = loaders[op.type];
                const promise = loader.load(op);
                let _res = void 0;
                promise.then((res)=>{
                    _res = res;
                    if ("error" in res.json) {
                        observer.error((0, $2J6qj.TRPCClientError).from(res.json, {
                            meta: res.meta
                        }));
                        return;
                    } else if ("result" in res.json) {
                        observer.next({
                            context: res.meta,
                            result: res.json.result
                        });
                        observer.complete();
                        return;
                    }
                    observer.complete();
                }).catch((err)=>{
                    observer.error((0, $2J6qj.TRPCClientError).from(err, {
                        meta: _res === null || _res === void 0 ? void 0 : _res.meta
                    }));
                });
                return ()=>{};
            });
        };
    };
}
/**
* @deprecated use {@link httpBatchStreamLink} instead
*/ const $84cfe0951de1982f$export$24eee9f0ddf4df55 = $84cfe0951de1982f$export$33a61750bfc89a79;
//#endregion
//#region src/internals/inputWithTrackedEventId.ts
var $84cfe0951de1982f$var$import_objectSpread2$2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
function $84cfe0951de1982f$var$inputWithTrackedEventId(input, lastEventId) {
    if (!lastEventId) return input;
    if (input != null && typeof input !== "object") return input;
    return (0, $84cfe0951de1982f$var$import_objectSpread2$2.default)((0, $84cfe0951de1982f$var$import_objectSpread2$2.default)({}, input !== null && input !== void 0 ? input : {}), {}, {
        lastEventId: lastEventId
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/asyncIterator.js
var $84cfe0951de1982f$var$require_asyncIterator = (0, $a6ELx.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/asyncIterator.js" (exports, module) {
        function _asyncIterator$1(r) {
            var n, t, o, e = 2;
            for("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;){
                if (t && null != (n = r[t])) return n.call(r);
                if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r));
                t = "@@asyncIterator", o = "@@iterator";
            }
            throw new TypeError("Object is not async iterable");
        }
        function AsyncFromSyncIterator(r) {
            function AsyncFromSyncIteratorContinuation(r$1) {
                if (Object(r$1) !== r$1) return Promise.reject(new TypeError(r$1 + " is not an object."));
                var n = r$1.done;
                return Promise.resolve(r$1.value).then(function(r$2) {
                    return {
                        value: r$2,
                        done: n
                    };
                });
            }
            return AsyncFromSyncIterator = function AsyncFromSyncIterator$1(r$1) {
                this.s = r$1, this.n = r$1.next;
            }, AsyncFromSyncIterator.prototype = {
                s: null,
                n: null,
                next: function next() {
                    return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
                },
                "return": function _return(r$1) {
                    var n = this.s["return"];
                    return void 0 === n ? Promise.resolve({
                        value: r$1,
                        done: !0
                    }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
                },
                "throw": function _throw(r$1) {
                    var n = this.s["return"];
                    return void 0 === n ? Promise.reject(r$1) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
                }
            }, new AsyncFromSyncIterator(r);
        }
        module.exports = _asyncIterator$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region src/links/httpSubscriptionLink.ts
var $84cfe0951de1982f$var$import_asyncIterator = (0, $a6ELx.__toESM)($84cfe0951de1982f$var$require_asyncIterator(), 1);
async function $84cfe0951de1982f$var$urlWithConnectionParams(opts) {
    let url = await (0, $2IWia.resultOf)(opts.url);
    if (opts.connectionParams) {
        const params = await (0, $2IWia.resultOf)(opts.connectionParams);
        const prefix = url.includes("?") ? "&" : "?";
        url += prefix + "connectionParams=" + encodeURIComponent(JSON.stringify(params));
    }
    return url;
}
/**
* @see https://trpc.io/docs/client/links/httpSubscriptionLink
*/ function $84cfe0951de1982f$export$f26e4c4fbbc52d14(opts) {
    const transformer = (0, $fj8ND.getTransformer)(opts.transformer);
    return ()=>{
        return ({ op: op })=>{
            return (0, $c2p8A.observable)((observer)=>{
                var _opts$EventSource;
                const { type: type, path: path, input: input } = op;
                /* istanbul ignore if -- @preserve */ if (type !== "subscription") throw new Error("httpSubscriptionLink only supports subscriptions");
                let lastEventId = void 0;
                const ac = new AbortController();
                const signal = (0, $jker1.raceAbortSignals)(op.signal, ac.signal);
                const eventSourceStream = (0, $d09NT.sseStreamConsumer)({
                    url: async ()=>(0, $aBBWl.getUrl)({
                            transformer: transformer,
                            url: await $84cfe0951de1982f$var$urlWithConnectionParams(opts),
                            input: $84cfe0951de1982f$var$inputWithTrackedEventId(input, lastEventId),
                            path: path,
                            type: type,
                            signal: null
                        }),
                    init: ()=>(0, $2IWia.resultOf)(opts.eventSourceOptions, {
                            op: op
                        }),
                    signal: signal,
                    deserialize: (data)=>transformer.output.deserialize(data),
                    EventSource: (_opts$EventSource = opts.EventSource) !== null && _opts$EventSource !== void 0 ? _opts$EventSource : globalThis.EventSource
                });
                const connectionState = (0, $lQFgY.behaviorSubject)({
                    type: "state",
                    state: "connecting",
                    error: null
                });
                const connectionSub = connectionState.subscribe({
                    next (state) {
                        observer.next({
                            result: state
                        });
                    }
                });
                (0, $6bgAm.run)(async ()=>{
                    var _iteratorAbruptCompletion = false;
                    var _didIteratorError = false;
                    var _iteratorError;
                    try {
                        for(var _iterator = (0, $84cfe0951de1982f$var$import_asyncIterator.default)(eventSourceStream), _step; _iteratorAbruptCompletion = !(_step = await _iterator.next()).done; _iteratorAbruptCompletion = false){
                            const chunk = _step.value;
                            switch(chunk.type){
                                case "ping":
                                    break;
                                case "data":
                                    const chunkData = chunk.data;
                                    let result;
                                    if (chunkData.id) {
                                        lastEventId = chunkData.id;
                                        result = {
                                            id: chunkData.id,
                                            data: chunkData
                                        };
                                    } else result = {
                                        data: chunkData.data
                                    };
                                    observer.next({
                                        result: result,
                                        context: {
                                            eventSource: chunk.eventSource
                                        }
                                    });
                                    break;
                                case "connected":
                                    observer.next({
                                        result: {
                                            type: "started"
                                        },
                                        context: {
                                            eventSource: chunk.eventSource
                                        }
                                    });
                                    connectionState.next({
                                        type: "state",
                                        state: "pending",
                                        error: null
                                    });
                                    break;
                                case "serialized-error":
                                    {
                                        const error = (0, $2J6qj.TRPCClientError).from({
                                            error: chunk.error
                                        });
                                        if ((0, $6bgAm.retryableRpcCodes).includes(chunk.error.code)) {
                                            connectionState.next({
                                                type: "state",
                                                state: "connecting",
                                                error: error
                                            });
                                            break;
                                        }
                                        throw error;
                                    }
                                case "connecting":
                                    {
                                        const lastState = connectionState.get();
                                        const error = chunk.event && (0, $2J6qj.TRPCClientError).from(chunk.event);
                                        if (!error && lastState.state === "connecting") break;
                                        connectionState.next({
                                            type: "state",
                                            state: "connecting",
                                            error: error
                                        });
                                        break;
                                    }
                                case "timeout":
                                    connectionState.next({
                                        type: "state",
                                        state: "connecting",
                                        error: new (0, $2J6qj.TRPCClientError)(`Timeout of ${chunk.ms}ms reached while waiting for a response`)
                                    });
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (_iteratorAbruptCompletion && _iterator.return != null) await _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    observer.next({
                        result: {
                            type: "stopped"
                        }
                    });
                    connectionState.next({
                        type: "state",
                        state: "idle",
                        error: null
                    });
                    observer.complete();
                }).catch((error)=>{
                    observer.error((0, $2J6qj.TRPCClientError).from(error));
                });
                return ()=>{
                    observer.complete();
                    ac.abort();
                    connectionSub.unsubscribe();
                };
            });
        };
    };
}
/**
* @deprecated use {@link httpSubscriptionLink} instead
*/ const $84cfe0951de1982f$export$8a16e1d42470e826 = $84cfe0951de1982f$export$f26e4c4fbbc52d14;
//#endregion
//#region src/links/retryLink.ts
var $84cfe0951de1982f$var$import_objectSpread2$1 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
/**
* @see https://trpc.io/docs/v11/client/links/retryLink
*/ function $84cfe0951de1982f$export$a51db439a65b48ef(opts) {
    return ()=>{
        return (callOpts)=>{
            return (0, $c2p8A.observable)((observer)=>{
                let next$;
                let callNextTimeout = void 0;
                let lastEventId = void 0;
                attempt(1);
                function opWithLastEventId() {
                    const op = callOpts.op;
                    if (!lastEventId) return op;
                    return (0, $84cfe0951de1982f$var$import_objectSpread2$1.default)((0, $84cfe0951de1982f$var$import_objectSpread2$1.default)({}, op), {}, {
                        input: $84cfe0951de1982f$var$inputWithTrackedEventId(op.input, lastEventId)
                    });
                }
                function attempt(attempts) {
                    const op = opWithLastEventId();
                    next$ = callOpts.next(op).subscribe({
                        error (error) {
                            var _opts$retryDelayMs, _opts$retryDelayMs2;
                            const shouldRetry = opts.retry({
                                op: op,
                                attempts: attempts,
                                error: error
                            });
                            if (!shouldRetry) {
                                observer.error(error);
                                return;
                            }
                            const delayMs = (_opts$retryDelayMs = (_opts$retryDelayMs2 = opts.retryDelayMs) === null || _opts$retryDelayMs2 === void 0 ? void 0 : _opts$retryDelayMs2.call(opts, attempts)) !== null && _opts$retryDelayMs !== void 0 ? _opts$retryDelayMs : 0;
                            if (delayMs <= 0) {
                                attempt(attempts + 1);
                                return;
                            }
                            callNextTimeout = setTimeout(()=>attempt(attempts + 1), delayMs);
                        },
                        next (envelope) {
                            if ((!envelope.result.type || envelope.result.type === "data") && envelope.result.id) lastEventId = envelope.result.id;
                            observer.next(envelope);
                        },
                        complete () {
                            observer.complete();
                        }
                    });
                }
                return ()=>{
                    next$.unsubscribe();
                    clearTimeout(callNextTimeout);
                };
            });
        };
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/usingCtx.js
var $84cfe0951de1982f$var$require_usingCtx = (0, $a6ELx.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/usingCtx.js" (exports, module) {
        function _usingCtx() {
            var r = "function" == typeof SuppressedError ? SuppressedError : function(r$1, e$1) {
                var n$1 = Error();
                return n$1.name = "SuppressedError", n$1.error = r$1, n$1.suppressed = e$1, n$1;
            }, e = {}, n = [];
            function using(r$1, e$1) {
                if (null != e$1) {
                    if (Object(e$1) !== e$1) throw new TypeError("using declarations can only be used with objects, functions, null, or undefined.");
                    if (r$1) var o = e$1[Symbol.asyncDispose || Symbol["for"]("Symbol.asyncDispose")];
                    if (void 0 === o && (o = e$1[Symbol.dispose || Symbol["for"]("Symbol.dispose")], r$1)) var t = o;
                    if ("function" != typeof o) throw new TypeError("Object is not disposable.");
                    t && (o = function o$1() {
                        try {
                            t.call(e$1);
                        } catch (r$2) {
                            return Promise.reject(r$2);
                        }
                    }), n.push({
                        v: e$1,
                        d: o,
                        a: r$1
                    });
                } else r$1 && n.push({
                    d: e$1,
                    a: r$1
                });
                return e$1;
            }
            return {
                e: e,
                u: using.bind(null, !1),
                a: using.bind(null, !0),
                d: function d() {
                    var o, t = this.e, s = 0;
                    function next() {
                        for(; o = n.pop();)try {
                            if (!o.a && 1 === s) return s = 0, n.push(o), Promise.resolve().then(next);
                            if (o.d) {
                                var r$1 = o.d.call(o.v);
                                if (o.a) return s |= 2, Promise.resolve(r$1).then(next, err);
                            } else s |= 1;
                        } catch (r$2) {
                            return err(r$2);
                        }
                        if (1 === s) return t !== e ? Promise.reject(t) : Promise.resolve();
                        if (t !== e) throw t;
                    }
                    function err(n$1) {
                        return t = t !== e ? new r(n$1, t) : n$1, next();
                    }
                    return next();
                }
            };
        }
        module.exports = _usingCtx, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/OverloadYield.js
var $84cfe0951de1982f$var$require_OverloadYield = (0, $a6ELx.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/OverloadYield.js" (exports, module) {
        function _OverloadYield(e, d) {
            this.v = e, this.k = d;
        }
        module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/awaitAsyncGenerator.js
var $84cfe0951de1982f$var$require_awaitAsyncGenerator = (0, $a6ELx.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/awaitAsyncGenerator.js" (exports, module) {
        var OverloadYield$1 = $84cfe0951de1982f$var$require_OverloadYield();
        function _awaitAsyncGenerator$1(e) {
            return new OverloadYield$1(e, 0);
        }
        module.exports = _awaitAsyncGenerator$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/wrapAsyncGenerator.js
var $84cfe0951de1982f$var$require_wrapAsyncGenerator = (0, $a6ELx.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/wrapAsyncGenerator.js" (exports, module) {
        var OverloadYield = $84cfe0951de1982f$var$require_OverloadYield();
        function _wrapAsyncGenerator$1(e) {
            return function() {
                return new AsyncGenerator(e.apply(this, arguments));
            };
        }
        function AsyncGenerator(e) {
            var r, t;
            function resume(r$1, t$1) {
                try {
                    var n = e[r$1](t$1), o = n.value, u = o instanceof OverloadYield;
                    Promise.resolve(u ? o.v : o).then(function(t$2) {
                        if (u) {
                            var i = "return" === r$1 ? "return" : "next";
                            if (!o.k || t$2.done) return resume(i, t$2);
                            t$2 = e[i](t$2).value;
                        }
                        settle(n.done ? "return" : "normal", t$2);
                    }, function(e$1) {
                        resume("throw", e$1);
                    });
                } catch (e$1) {
                    settle("throw", e$1);
                }
            }
            function settle(e$1, n) {
                switch(e$1){
                    case "return":
                        r.resolve({
                            value: n,
                            done: !0
                        });
                        break;
                    case "throw":
                        r.reject(n);
                        break;
                    default:
                        r.resolve({
                            value: n,
                            done: !1
                        });
                }
                (r = r.next) ? resume(r.key, r.arg) : t = null;
            }
            this._invoke = function(e$1, n) {
                return new Promise(function(o, u) {
                    var i = {
                        key: e$1,
                        arg: n,
                        resolve: o,
                        reject: u,
                        next: null
                    };
                    t ? t = t.next = i : (r = t = i, resume(e$1, n));
                });
            }, "function" != typeof e["return"] && (this["return"] = void 0);
        }
        AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
            return this;
        }, AsyncGenerator.prototype.next = function(e) {
            return this._invoke("next", e);
        }, AsyncGenerator.prototype["throw"] = function(e) {
            return this._invoke("throw", e);
        }, AsyncGenerator.prototype["return"] = function(e) {
            return this._invoke("return", e);
        };
        module.exports = _wrapAsyncGenerator$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region src/links/localLink.ts
var $84cfe0951de1982f$var$import_usingCtx = (0, $a6ELx.__toESM)($84cfe0951de1982f$var$require_usingCtx(), 1);
var $84cfe0951de1982f$var$import_awaitAsyncGenerator = (0, $a6ELx.__toESM)($84cfe0951de1982f$var$require_awaitAsyncGenerator(), 1);
var $84cfe0951de1982f$var$import_wrapAsyncGenerator = (0, $a6ELx.__toESM)($84cfe0951de1982f$var$require_wrapAsyncGenerator(), 1);
var $84cfe0951de1982f$var$import_objectSpread2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
/**
* localLink is a terminating link that allows you to make tRPC procedure calls directly in your application without going through HTTP.
*
* @see https://trpc.io/docs/links/localLink
*/ function $84cfe0951de1982f$export$e2b175feb12af1b8(opts) {
    const transformer = (0, $fj8ND.getTransformer)(opts.transformer);
    const transformChunk = (chunk)=>{
        if (opts.transformer) return chunk;
        if (chunk === void 0) return chunk;
        const serialized = JSON.stringify(transformer.input.serialize(chunk));
        const deserialized = JSON.parse(transformer.output.deserialize(serialized));
        return deserialized;
    };
    return ()=>({ op: op })=>(0, $c2p8A.observable)((observer)=>{
                let ctx = void 0;
                const ac = new AbortController();
                const signal = (0, $jker1.raceAbortSignals)(op.signal, ac.signal);
                const signalPromise = (0, $jker1.abortSignalToPromise)(signal);
                signalPromise.catch(()=>{});
                let input = op.input;
                async function runProcedure(newInput) {
                    input = newInput;
                    ctx = await opts.createContext();
                    return (0, $8hhvi.callProcedure)({
                        router: opts.router,
                        path: op.path,
                        getRawInput: async ()=>newInput,
                        ctx: ctx,
                        type: op.type,
                        signal: signal
                    });
                }
                function onErrorCallback(cause) {
                    var _opts$onError;
                    if ((0, $d09NT.isAbortError)(cause)) return;
                    (_opts$onError = opts.onError) === null || _opts$onError === void 0 || _opts$onError.call(opts, {
                        error: (0, $8hhvi.getTRPCErrorFromUnknown)(cause),
                        type: op.type,
                        path: op.path,
                        input: input,
                        ctx: ctx
                    });
                }
                function coerceToTRPCClientError(cause) {
                    if ((0, $2J6qj.isTRPCClientError)(cause)) return cause;
                    const error = (0, $8hhvi.getTRPCErrorFromUnknown)(cause);
                    const shape = (0, $1h7sD.getErrorShape)({
                        config: opts.router._def._config,
                        ctx: ctx,
                        error: error,
                        input: input,
                        path: op.path,
                        type: op.type
                    });
                    return (0, $2J6qj.TRPCClientError).from({
                        error: transformChunk(shape)
                    });
                }
                (0, $6bgAm.run)(async ()=>{
                    switch(op.type){
                        case "query":
                        case "mutation":
                            {
                                const result = await runProcedure(op.input);
                                if (!(0, $6bgAm.isAsyncIterable)(result)) {
                                    observer.next({
                                        result: {
                                            data: transformChunk(result)
                                        }
                                    });
                                    observer.complete();
                                    break;
                                }
                                observer.next({
                                    result: {
                                        data: (0, $84cfe0951de1982f$var$import_wrapAsyncGenerator.default)(function*() {
                                            try {
                                                var _usingCtx$1 = (0, $84cfe0951de1982f$var$import_usingCtx.default)();
                                                const iterator = _usingCtx$1.a((0, $d09NT.iteratorResource)(result));
                                                const _finally = _usingCtx$1.u((0, $d09NT.makeResource)({}, ()=>{
                                                    observer.complete();
                                                }));
                                                try {
                                                    while(true){
                                                        const res = yield (0, $84cfe0951de1982f$var$import_awaitAsyncGenerator.default)(Promise.race([
                                                            iterator.next(),
                                                            signalPromise
                                                        ]));
                                                        if (res.done) return transformChunk(res.value);
                                                        yield transformChunk(res.value);
                                                    }
                                                } catch (cause) {
                                                    onErrorCallback(cause);
                                                    throw coerceToTRPCClientError(cause);
                                                }
                                            } catch (_) {
                                                _usingCtx$1.e = _;
                                            } finally{
                                                yield (0, $84cfe0951de1982f$var$import_awaitAsyncGenerator.default)(_usingCtx$1.d());
                                            }
                                        })()
                                    }
                                });
                                break;
                            }
                        case "subscription":
                            try {
                                var _usingCtx3 = (0, $84cfe0951de1982f$var$import_usingCtx.default)();
                                const connectionState = (0, $lQFgY.behaviorSubject)({
                                    type: "state",
                                    state: "connecting",
                                    error: null
                                });
                                const connectionSub = connectionState.subscribe({
                                    next (state) {
                                        observer.next({
                                            result: state
                                        });
                                    }
                                });
                                let lastEventId = void 0;
                                const _finally = _usingCtx3.u((0, $d09NT.makeResource)({}, async ()=>{
                                    observer.complete();
                                    connectionState.next({
                                        type: "state",
                                        state: "idle",
                                        error: null
                                    });
                                    connectionSub.unsubscribe();
                                }));
                                while(true)try {
                                    var _usingCtx4 = (0, $84cfe0951de1982f$var$import_usingCtx.default)();
                                    const result = await runProcedure($84cfe0951de1982f$var$inputWithTrackedEventId(op.input, lastEventId));
                                    if (!(0, $6bgAm.isAsyncIterable)(result)) throw new Error("Expected an async iterable");
                                    const iterator = _usingCtx4.a((0, $d09NT.iteratorResource)(result));
                                    observer.next({
                                        result: {
                                            type: "started"
                                        }
                                    });
                                    connectionState.next({
                                        type: "state",
                                        state: "pending",
                                        error: null
                                    });
                                    while(true){
                                        let res;
                                        try {
                                            res = await Promise.race([
                                                iterator.next(),
                                                signalPromise
                                            ]);
                                        } catch (cause) {
                                            if ((0, $d09NT.isAbortError)(cause)) return;
                                            const error = (0, $8hhvi.getTRPCErrorFromUnknown)(cause);
                                            if (!(0, $6bgAm.retryableRpcCodes).includes((0, $6bgAm.TRPC_ERROR_CODES_BY_KEY)[error.code])) throw coerceToTRPCClientError(error);
                                            onErrorCallback(error);
                                            connectionState.next({
                                                type: "state",
                                                state: "connecting",
                                                error: coerceToTRPCClientError(error)
                                            });
                                            break;
                                        }
                                        if (res.done) return;
                                        let chunk;
                                        if ((0, $8hhvi.isTrackedEnvelope)(res.value)) {
                                            lastEventId = res.value[0];
                                            chunk = {
                                                id: res.value[0],
                                                data: {
                                                    id: res.value[0],
                                                    data: res.value[1]
                                                }
                                            };
                                        } else chunk = {
                                            data: res.value
                                        };
                                        observer.next({
                                            result: (0, $84cfe0951de1982f$var$import_objectSpread2.default)((0, $84cfe0951de1982f$var$import_objectSpread2.default)({}, chunk), {}, {
                                                data: transformChunk(chunk.data)
                                            })
                                        });
                                    }
                                } catch (_) {
                                    _usingCtx4.e = _;
                                } finally{
                                    await _usingCtx4.d();
                                }
                                break;
                            } catch (_) {
                                _usingCtx3.e = _;
                            } finally{
                                _usingCtx3.d();
                            }
                    }
                }).catch((cause)=>{
                    onErrorCallback(cause);
                    observer.error(coerceToTRPCClientError(cause));
                });
                return ()=>{
                    ac.abort();
                };
            });
}
/**
* @deprecated Renamed to `unstable_localLink`. This alias will be removed in a future major release.
*/ const $84cfe0951de1982f$export$7f06993a2368ea14 = $84cfe0951de1982f$export$e2b175feb12af1b8;

});
parcelRegister("a6ELx", function(module, exports) {

$parcel$export(module.exports, "__commonJS", function () { return $4d8bffb7da400bd5$export$c98acbe61b4a254a; });
$parcel$export(module.exports, "__toESM", function () { return $4d8bffb7da400bd5$export$82dec27a9dce9602; });
$parcel$export(module.exports, "require_defineProperty", function () { return $4d8bffb7da400bd5$export$ab908e1fcccc7689; });
$parcel$export(module.exports, "require_objectSpread2", function () { return $4d8bffb7da400bd5$export$32dc13945d3e01da; });
//#region rolldown:runtime
var $4d8bffb7da400bd5$var$__create = Object.create;
var $4d8bffb7da400bd5$var$__defProp = Object.defineProperty;
var $4d8bffb7da400bd5$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $4d8bffb7da400bd5$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $4d8bffb7da400bd5$var$__getProtoOf = Object.getPrototypeOf;
var $4d8bffb7da400bd5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4d8bffb7da400bd5$export$c98acbe61b4a254a = (cb, mod)=>function() {
        return mod || (0, cb[$4d8bffb7da400bd5$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $4d8bffb7da400bd5$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") for(var keys = $4d8bffb7da400bd5$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$4d8bffb7da400bd5$var$__hasOwnProp.call(to, key) && key !== except) $4d8bffb7da400bd5$var$__defProp(to, key, {
            get: ((k)=>from[k]).bind(null, key),
            enumerable: !(desc = $4d8bffb7da400bd5$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $4d8bffb7da400bd5$export$82dec27a9dce9602 = (mod, isNodeMode, target)=>(target = mod != null ? $4d8bffb7da400bd5$var$__create($4d8bffb7da400bd5$var$__getProtoOf(mod)) : {}, $4d8bffb7da400bd5$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $4d8bffb7da400bd5$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/typeof.js
var $4d8bffb7da400bd5$var$require_typeof = $4d8bffb7da400bd5$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/typeof.js" (exports, module) {
        function _typeof$2(o) {
            "@babel/helpers - typeof";
            return module.exports = _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
                return typeof o$1;
            } : function(o$1) {
                return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
            }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof$2(o);
        }
        module.exports = _typeof$2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPrimitive.js
var $4d8bffb7da400bd5$var$require_toPrimitive = $4d8bffb7da400bd5$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPrimitive.js" (exports, module) {
        var _typeof$1 = $4d8bffb7da400bd5$var$require_typeof()["default"];
        function toPrimitive$1(t, r) {
            if ("object" != _typeof$1(t) || !t) return t;
            var e = t[Symbol.toPrimitive];
            if (void 0 !== e) {
                var i = e.call(t, r || "default");
                if ("object" != _typeof$1(i)) return i;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === r ? String : Number)(t);
        }
        module.exports = toPrimitive$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPropertyKey.js
var $4d8bffb7da400bd5$var$require_toPropertyKey = $4d8bffb7da400bd5$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPropertyKey.js" (exports, module) {
        var _typeof = $4d8bffb7da400bd5$var$require_typeof()["default"];
        var toPrimitive = $4d8bffb7da400bd5$var$require_toPrimitive();
        function toPropertyKey$1(t) {
            var i = toPrimitive(t, "string");
            return "symbol" == _typeof(i) ? i : i + "";
        }
        module.exports = toPropertyKey$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/defineProperty.js
var $4d8bffb7da400bd5$export$ab908e1fcccc7689 = $4d8bffb7da400bd5$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/defineProperty.js" (exports, module) {
        var toPropertyKey = $4d8bffb7da400bd5$var$require_toPropertyKey();
        function _defineProperty(e, r, t) {
            return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
                value: t,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[r] = t, e;
        }
        module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/objectSpread2.js
var $4d8bffb7da400bd5$export$32dc13945d3e01da = $4d8bffb7da400bd5$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/objectSpread2.js" (exports, module) {
        var defineProperty = $4d8bffb7da400bd5$export$ab908e1fcccc7689();
        function ownKeys(e, r) {
            var t = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                r && (o = o.filter(function(r$1) {
                    return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
                })), t.push.apply(t, o);
            }
            return t;
        }
        function _objectSpread2(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = null != arguments[r] ? arguments[r] : {};
                r % 2 ? ownKeys(Object(t), !0).forEach(function(r$1) {
                    defineProperty(e, r$1, t[r$1]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r$1) {
                    Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
                });
            }
            return e;
        }
        module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});

});

parcelRegister("3GFYM", function(module, exports) {

$parcel$export(module.exports, "createChain", function () { return $0dd8283840ee6f12$export$3ffb1c732bc8392d; });

var $c2p8A = parcelRequire("c2p8A");
//#region src/links/internals/createChain.ts
/** @internal */ function $0dd8283840ee6f12$export$3ffb1c732bc8392d(opts) {
    return (0, $c2p8A.observable)((observer)=>{
        function execute(index = 0, op = opts.op) {
            const next = opts.links[index];
            if (!next) throw new Error("No more links to execute - did you forget to add an ending link?");
            const subscription = next({
                op: op,
                next (nextOp) {
                    const nextObserver = execute(index + 1, nextOp);
                    return nextObserver;
                }
            });
            return subscription;
        }
        const obs$ = execute();
        return obs$.subscribe(observer);
    });
}
//#endregion
//#region src/links/splitLink.ts
function $0dd8283840ee6f12$var$asArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $0dd8283840ee6f12$export$257e6b46ab9f6918(opts) {
    return (runtime)=>{
        const yes = $0dd8283840ee6f12$var$asArray(opts.true).map((link)=>link(runtime));
        const no = $0dd8283840ee6f12$var$asArray(opts.false).map((link)=>link(runtime));
        return (props)=>{
            return (0, $c2p8A.observable)((observer)=>{
                const links = opts.condition(props.op) ? yes : no;
                return $0dd8283840ee6f12$export$3ffb1c732bc8392d({
                    op: props.op,
                    links: links
                }).subscribe(observer);
            });
        };
    };
}

});
parcelRegister("c2p8A", function(module, exports) {

$parcel$export(module.exports, "isObservable", function () { return $42d33ce08f875bff$export$5cd057a6046189f9; });
$parcel$export(module.exports, "observable", function () { return $42d33ce08f875bff$export$5ab46cbf6120b33a; });
$parcel$export(module.exports, "observableToPromise", function () { return $42d33ce08f875bff$export$391d300976c8872e; });
$parcel$export(module.exports, "observableToAsyncIterable", function () { return $42d33ce08f875bff$export$e81127a1e310791c; });
//#region src/observable/observable.ts
/** @public */ function $42d33ce08f875bff$export$5cd057a6046189f9(x) {
    return typeof x === "object" && x !== null && "subscribe" in x;
}
/** @public */ function $42d33ce08f875bff$export$5ab46cbf6120b33a(subscribe) {
    const self = {
        subscribe (observer) {
            let teardownRef = null;
            let isDone = false;
            let unsubscribed = false;
            let teardownImmediately = false;
            function unsubscribe() {
                if (teardownRef === null) {
                    teardownImmediately = true;
                    return;
                }
                if (unsubscribed) return;
                unsubscribed = true;
                if (typeof teardownRef === "function") teardownRef();
                else if (teardownRef) teardownRef.unsubscribe();
            }
            teardownRef = subscribe({
                next (value) {
                    var _observer$next;
                    if (isDone) return;
                    (_observer$next = observer.next) === null || _observer$next === void 0 || _observer$next.call(observer, value);
                },
                error (err) {
                    var _observer$error;
                    if (isDone) return;
                    isDone = true;
                    (_observer$error = observer.error) === null || _observer$error === void 0 || _observer$error.call(observer, err);
                    unsubscribe();
                },
                complete () {
                    var _observer$complete;
                    if (isDone) return;
                    isDone = true;
                    (_observer$complete = observer.complete) === null || _observer$complete === void 0 || _observer$complete.call(observer);
                    unsubscribe();
                }
            });
            if (teardownImmediately) unsubscribe();
            return {
                unsubscribe: unsubscribe
            };
        },
        pipe (...operations) {
            return operations.reduce($42d33ce08f875bff$var$pipeReducer, self);
        }
    };
    return self;
}
function $42d33ce08f875bff$var$pipeReducer(prev, fn) {
    return fn(prev);
}
/** @internal */ function $42d33ce08f875bff$export$391d300976c8872e(observable$1) {
    const ac = new AbortController();
    const promise = new Promise((resolve, reject)=>{
        let isDone = false;
        function onDone() {
            if (isDone) return;
            isDone = true;
            obs$.unsubscribe();
        }
        ac.signal.addEventListener("abort", ()=>{
            reject(ac.signal.reason);
        });
        const obs$ = observable$1.subscribe({
            next (data) {
                isDone = true;
                resolve(data);
                onDone();
            },
            error (data) {
                reject(data);
            },
            complete () {
                ac.abort();
                onDone();
            }
        });
    });
    return promise;
}
/**
* @internal
*/ function $42d33ce08f875bff$var$observableToReadableStream(observable$1, signal) {
    let unsub = null;
    const onAbort = ()=>{
        unsub === null || unsub === void 0 || unsub.unsubscribe();
        unsub = null;
        signal.removeEventListener("abort", onAbort);
    };
    return new ReadableStream({
        start (controller) {
            unsub = observable$1.subscribe({
                next (data) {
                    controller.enqueue({
                        ok: true,
                        value: data
                    });
                },
                error (error) {
                    controller.enqueue({
                        ok: false,
                        error: error
                    });
                    controller.close();
                },
                complete () {
                    controller.close();
                }
            });
            if (signal.aborted) onAbort();
            else signal.addEventListener("abort", onAbort, {
                once: true
            });
        },
        cancel () {
            onAbort();
        }
    });
}
/** @internal */ function $42d33ce08f875bff$export$e81127a1e310791c(observable$1, signal) {
    const stream = $42d33ce08f875bff$var$observableToReadableStream(observable$1, signal);
    const reader = stream.getReader();
    const iterator = {
        async next () {
            const value = await reader.read();
            if (value.done) return {
                value: void 0,
                done: true
            };
            const { value: result } = value;
            if (!result.ok) throw result.error;
            return {
                value: result.value,
                done: false
            };
        },
        async return () {
            await reader.cancel();
            return {
                value: void 0,
                done: true
            };
        }
    };
    return {
        [Symbol.asyncIterator] () {
            return iterator;
        }
    };
}

});


parcelRegister("2J6qj", function(module, exports) {

$parcel$export(module.exports, "isTRPCClientError", function () { return $f0607bf65a32f9aa$export$720fa6143c7b3d1b; });
$parcel$export(module.exports, "TRPCClientError", function () { return $f0607bf65a32f9aa$export$786579e406d4246d; });

var $a6ELx = parcelRequire("a6ELx");

var $6bgAm = parcelRequire("6bgAm");
//#region src/TRPCClientError.ts
var $f0607bf65a32f9aa$var$import_defineProperty = (0, $a6ELx.__toESM)((0, $a6ELx.require_defineProperty)(), 1);
var $f0607bf65a32f9aa$var$import_objectSpread2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
function $f0607bf65a32f9aa$export$720fa6143c7b3d1b(cause) {
    return cause instanceof $f0607bf65a32f9aa$export$786579e406d4246d;
}
function $f0607bf65a32f9aa$var$isTRPCErrorResponse(obj) {
    return (0, $6bgAm.isObject)(obj) && (0, $6bgAm.isObject)(obj["error"]) && typeof obj["error"]["code"] === "number" && typeof obj["error"]["message"] === "string";
}
function $f0607bf65a32f9aa$var$getMessageFromUnknownError(err, fallback) {
    if (typeof err === "string") return err;
    if ((0, $6bgAm.isObject)(err) && typeof err["message"] === "string") return err["message"];
    return fallback;
}
var $f0607bf65a32f9aa$export$786579e406d4246d = class TRPCClientError extends Error {
    constructor(message, opts){
        var _opts$result, _opts$result2;
        const cause = opts === null || opts === void 0 ? void 0 : opts.cause;
        super(message, {
            cause: cause
        });
        (0, $f0607bf65a32f9aa$var$import_defineProperty.default)(this, "cause", void 0);
        (0, $f0607bf65a32f9aa$var$import_defineProperty.default)(this, "shape", void 0);
        (0, $f0607bf65a32f9aa$var$import_defineProperty.default)(this, "data", void 0);
        (0, $f0607bf65a32f9aa$var$import_defineProperty.default)(this, "meta", void 0);
        this.meta = opts === null || opts === void 0 ? void 0 : opts.meta;
        this.cause = cause;
        this.shape = opts === null || opts === void 0 || (_opts$result = opts.result) === null || _opts$result === void 0 ? void 0 : _opts$result.error;
        this.data = opts === null || opts === void 0 || (_opts$result2 = opts.result) === null || _opts$result2 === void 0 ? void 0 : _opts$result2.error.data;
        this.name = "TRPCClientError";
        Object.setPrototypeOf(this, TRPCClientError.prototype);
    }
    static from(_cause, opts = {}) {
        const cause = _cause;
        if ($f0607bf65a32f9aa$export$720fa6143c7b3d1b(cause)) {
            if (opts.meta) cause.meta = (0, $f0607bf65a32f9aa$var$import_objectSpread2.default)((0, $f0607bf65a32f9aa$var$import_objectSpread2.default)({}, cause.meta), opts.meta);
            return cause;
        }
        if ($f0607bf65a32f9aa$var$isTRPCErrorResponse(cause)) return new TRPCClientError(cause.error.message, (0, $f0607bf65a32f9aa$var$import_objectSpread2.default)((0, $f0607bf65a32f9aa$var$import_objectSpread2.default)({}, opts), {}, {
            result: cause
        }));
        return new TRPCClientError($f0607bf65a32f9aa$var$getMessageFromUnknownError(cause, "Unknown error"), (0, $f0607bf65a32f9aa$var$import_objectSpread2.default)((0, $f0607bf65a32f9aa$var$import_objectSpread2.default)({}, opts), {}, {
            cause: cause
        }));
    }
};

});
parcelRegister("6bgAm", function(module, exports) {

$parcel$export(module.exports, "TRPC_ERROR_CODES_BY_KEY", function () { return $3064e042b56a67ac$export$bfde8546f9e43f6a; });
$parcel$export(module.exports, "TRPC_ERROR_CODES_BY_NUMBER", function () { return $3064e042b56a67ac$export$1c81d19d5f55b92b; });
$parcel$export(module.exports, "retryableRpcCodes", function () { return $3064e042b56a67ac$export$a63141de08e65338; });
$parcel$export(module.exports, "mergeWithoutOverrides", function () { return $3064e042b56a67ac$export$cbc4135182f2ba80; });
$parcel$export(module.exports, "isObject", function () { return $3064e042b56a67ac$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isFunction", function () { return $3064e042b56a67ac$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "omitPrototype", function () { return $3064e042b56a67ac$export$c5d60f57eb02bcf7; });
$parcel$export(module.exports, "isAsyncIterable", function () { return $3064e042b56a67ac$export$edb10ab8dd75a915; });
$parcel$export(module.exports, "run", function () { return $3064e042b56a67ac$export$889ea624f2cb2c57; });
$parcel$export(module.exports, "identity", function () { return $3064e042b56a67ac$export$f0954fd7d5368655; });
$parcel$export(module.exports, "sleep", function () { return $3064e042b56a67ac$export$e772c8ff12451969; });
//#region src/unstable-core-do-not-import/rpc/codes.ts
/**
* JSON-RPC 2.0 Error codes
*
* `-32000` to `-32099` are reserved for implementation-defined server-errors.
* For tRPC we're copying the last digits of HTTP 4XX errors.
*/ const $3064e042b56a67ac$export$bfde8546f9e43f6a = {
    PARSE_ERROR: -32700,
    BAD_REQUEST: -32600,
    INTERNAL_SERVER_ERROR: -32603,
    NOT_IMPLEMENTED: -32603,
    BAD_GATEWAY: -32603,
    SERVICE_UNAVAILABLE: -32603,
    GATEWAY_TIMEOUT: -32603,
    UNAUTHORIZED: -32001,
    PAYMENT_REQUIRED: -32002,
    FORBIDDEN: -32003,
    NOT_FOUND: -32004,
    METHOD_NOT_SUPPORTED: -32005,
    TIMEOUT: -32008,
    CONFLICT: -32009,
    PRECONDITION_FAILED: -32012,
    PAYLOAD_TOO_LARGE: -32013,
    UNSUPPORTED_MEDIA_TYPE: -32015,
    UNPROCESSABLE_CONTENT: -32022,
    TOO_MANY_REQUESTS: -32029,
    CLIENT_CLOSED_REQUEST: -32099
};
const $3064e042b56a67ac$export$1c81d19d5f55b92b = {
    [-32700]: "PARSE_ERROR",
    [-32600]: "BAD_REQUEST",
    [-32603]: "INTERNAL_SERVER_ERROR",
    [-32001]: "UNAUTHORIZED",
    [-32002]: "PAYMENT_REQUIRED",
    [-32003]: "FORBIDDEN",
    [-32004]: "NOT_FOUND",
    [-32005]: "METHOD_NOT_SUPPORTED",
    [-32008]: "TIMEOUT",
    [-32009]: "CONFLICT",
    [-32012]: "PRECONDITION_FAILED",
    [-32013]: "PAYLOAD_TOO_LARGE",
    [-32015]: "UNSUPPORTED_MEDIA_TYPE",
    [-32022]: "UNPROCESSABLE_CONTENT",
    [-32029]: "TOO_MANY_REQUESTS",
    [-32099]: "CLIENT_CLOSED_REQUEST"
};
/**
* tRPC error codes that are considered retryable
* With out of the box SSE, the client will reconnect when these errors are encountered
*/ const $3064e042b56a67ac$export$a63141de08e65338 = [
    $3064e042b56a67ac$export$bfde8546f9e43f6a.BAD_GATEWAY,
    $3064e042b56a67ac$export$bfde8546f9e43f6a.SERVICE_UNAVAILABLE,
    $3064e042b56a67ac$export$bfde8546f9e43f6a.GATEWAY_TIMEOUT,
    $3064e042b56a67ac$export$bfde8546f9e43f6a.INTERNAL_SERVER_ERROR
];
//#endregion
//#region src/unstable-core-do-not-import/utils.ts
/**
* Ensures there are no duplicate keys when building a procedure.
* @internal
*/ function $3064e042b56a67ac$export$cbc4135182f2ba80(obj1, ...objs) {
    const newObj = Object.assign(Object.create(null), obj1);
    for (const overrides of objs)for(const key in overrides){
        if (key in newObj && newObj[key] !== overrides[key]) throw new Error(`Duplicate key ${key}`);
        newObj[key] = overrides[key];
    }
    return newObj;
}
/**
* Check that value is object
* @internal
*/ function $3064e042b56a67ac$export$a6cdc56e425d0d0a(value) {
    return !!value && !Array.isArray(value) && typeof value === "object";
}
function $3064e042b56a67ac$export$f6e2535fb5126e54(fn) {
    return typeof fn === "function";
}
/**
* Create an object without inheriting anything from `Object.prototype`
* @internal
*/ function $3064e042b56a67ac$export$c5d60f57eb02bcf7(obj) {
    return Object.assign(Object.create(null), obj);
}
const $3064e042b56a67ac$var$asyncIteratorsSupported = typeof Symbol === "function" && !!Symbol.asyncIterator;
function $3064e042b56a67ac$export$edb10ab8dd75a915(value) {
    return $3064e042b56a67ac$var$asyncIteratorsSupported && $3064e042b56a67ac$export$a6cdc56e425d0d0a(value) && Symbol.asyncIterator in value;
}
/**
* Run an IIFE
*/ const $3064e042b56a67ac$export$889ea624f2cb2c57 = (fn)=>fn();
function $3064e042b56a67ac$export$8793edee2d425525() {}
function $3064e042b56a67ac$export$f0954fd7d5368655(it) {
    return it;
}
/**
* Generic runtime assertion function. Throws, if the condition is not `true`.
*
* Can be used as a slightly less dangerous variant of type assertions. Code
* mistakes would be revealed at runtime then (hopefully during testing).
*/ function $3064e042b56a67ac$export$a7a9523472993e97(condition, msg = "no additional info") {
    if (!condition) throw new Error(`AssertionError: ${msg}`);
}
function $3064e042b56a67ac$export$e772c8ff12451969(ms = 0) {
    return new Promise((res)=>setTimeout(res, ms));
}
/**
* Ponyfill for
* [`AbortSignal.any`](https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/any_static).
*/ function $3064e042b56a67ac$export$758eb44b1d90bfe(signals) {
    if (typeof AbortSignal.any === "function") return AbortSignal.any(signals);
    const ac = new AbortController();
    for (const signal of signals){
        if (signal.aborted) {
            trigger();
            break;
        }
        signal.addEventListener("abort", trigger, {
            once: true
        });
    }
    return ac.signal;
    function trigger() {
        ac.abort();
        for (const signal of signals)signal.removeEventListener("abort", trigger);
    }
}

});


parcelRegister("aBBWl", function(module, exports) {

$parcel$export(module.exports, "resolveHTTPLinkOptions", function () { return $b3a827ddbe833d32$export$44e81710cea19650; });
$parcel$export(module.exports, "getUrl", function () { return $b3a827ddbe833d32$export$94df0e59ebebf4a7; });
$parcel$export(module.exports, "getBody", function () { return $b3a827ddbe833d32$export$135b49d4bc2964c6; });
$parcel$export(module.exports, "jsonHttpRequester", function () { return $b3a827ddbe833d32$export$e6ba4793279549c5; });
$parcel$export(module.exports, "httpRequest", function () { return $b3a827ddbe833d32$export$46f383001bf60e04; });
$parcel$export(module.exports, "fetchHTTPResponse", function () { return $b3a827ddbe833d32$export$b91933b10432b596; });

var $a6ELx = parcelRequire("a6ELx");

var $fj8ND = parcelRequire("fj8ND");
//#region src/getFetch.ts
const $b3a827ddbe833d32$var$isFunction = (fn)=>typeof fn === "function";
function $b3a827ddbe833d32$export$3105c6651375d4fa(customFetchImpl) {
    if (customFetchImpl) return customFetchImpl;
    if (typeof window !== "undefined" && $b3a827ddbe833d32$var$isFunction(window.fetch)) return window.fetch;
    if (typeof globalThis !== "undefined" && $b3a827ddbe833d32$var$isFunction(globalThis.fetch)) return globalThis.fetch;
    throw new Error("No fetch implementation found");
}
//#endregion
//#region src/links/internals/httpUtils.ts
var $b3a827ddbe833d32$var$import_objectSpread2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)());
function $b3a827ddbe833d32$export$44e81710cea19650(opts) {
    return {
        url: opts.url.toString(),
        fetch: opts.fetch,
        transformer: (0, $fj8ND.getTransformer)(opts.transformer),
        methodOverride: opts.methodOverride
    };
}
function $b3a827ddbe833d32$var$arrayToDict(array) {
    const dict = {};
    for(let index = 0; index < array.length; index++){
        const element = array[index];
        dict[index] = element;
    }
    return dict;
}
const $b3a827ddbe833d32$var$METHOD = {
    query: "GET",
    mutation: "POST",
    subscription: "PATCH"
};
function $b3a827ddbe833d32$var$getInput(opts) {
    return "input" in opts ? opts.transformer.input.serialize(opts.input) : $b3a827ddbe833d32$var$arrayToDict(opts.inputs.map((_input)=>opts.transformer.input.serialize(_input)));
}
const $b3a827ddbe833d32$export$94df0e59ebebf4a7 = (opts)=>{
    const parts = opts.url.split("?");
    const base = parts[0].replace(/\/$/, "");
    let url = base + "/" + opts.path;
    const queryParts = [];
    if (parts[1]) queryParts.push(parts[1]);
    if ("inputs" in opts) queryParts.push("batch=1");
    if (opts.type === "query" || opts.type === "subscription") {
        const input = $b3a827ddbe833d32$var$getInput(opts);
        if (input !== void 0 && opts.methodOverride !== "POST") queryParts.push(`input=${encodeURIComponent(JSON.stringify(input))}`);
    }
    if (queryParts.length) url += "?" + queryParts.join("&");
    return url;
};
const $b3a827ddbe833d32$export$135b49d4bc2964c6 = (opts)=>{
    if (opts.type === "query" && opts.methodOverride !== "POST") return void 0;
    const input = $b3a827ddbe833d32$var$getInput(opts);
    return input !== void 0 ? JSON.stringify(input) : void 0;
};
const $b3a827ddbe833d32$export$e6ba4793279549c5 = (opts)=>{
    return $b3a827ddbe833d32$export$46f383001bf60e04((0, $b3a827ddbe833d32$var$import_objectSpread2.default)((0, $b3a827ddbe833d32$var$import_objectSpread2.default)({}, opts), {}, {
        contentTypeHeader: "application/json",
        getUrl: $b3a827ddbe833d32$export$94df0e59ebebf4a7,
        getBody: $b3a827ddbe833d32$export$135b49d4bc2964c6
    }));
};
/**
* Polyfill for DOMException with AbortError name
*/ var $b3a827ddbe833d32$var$AbortError = class extends Error {
    constructor(){
        const name = "AbortError";
        super(name);
        this.name = name;
        this.message = name;
    }
};
/**
* Polyfill for `signal.throwIfAborted()`
*
* @see https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/throwIfAborted
*/ const $b3a827ddbe833d32$var$throwIfAborted = (signal)=>{
    var _signal$throwIfAborte;
    if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) return;
    (_signal$throwIfAborte = signal.throwIfAborted) === null || _signal$throwIfAborte === void 0 || _signal$throwIfAborte.call(signal);
    if (typeof DOMException !== "undefined") throw new DOMException("AbortError", "AbortError");
    throw new $b3a827ddbe833d32$var$AbortError();
};
async function $b3a827ddbe833d32$export$b91933b10432b596(opts) {
    var _opts$methodOverride;
    $b3a827ddbe833d32$var$throwIfAborted(opts.signal);
    const url = opts.getUrl(opts);
    const body = opts.getBody(opts);
    const method = (_opts$methodOverride = opts.methodOverride) !== null && _opts$methodOverride !== void 0 ? _opts$methodOverride : $b3a827ddbe833d32$var$METHOD[opts.type];
    const resolvedHeaders = await (async ()=>{
        const heads = await opts.headers();
        if (Symbol.iterator in heads) return Object.fromEntries(heads);
        return heads;
    })();
    const headers = (0, $b3a827ddbe833d32$var$import_objectSpread2.default)((0, $b3a827ddbe833d32$var$import_objectSpread2.default)((0, $b3a827ddbe833d32$var$import_objectSpread2.default)({}, opts.contentTypeHeader && method !== "GET" ? {
        "content-type": opts.contentTypeHeader
    } : {}), opts.trpcAcceptHeader ? {
        "trpc-accept": opts.trpcAcceptHeader
    } : void 0), resolvedHeaders);
    return $b3a827ddbe833d32$export$3105c6651375d4fa(opts.fetch)(url, {
        method: method,
        signal: opts.signal,
        body: body,
        headers: headers
    });
}
async function $b3a827ddbe833d32$export$46f383001bf60e04(opts) {
    const meta = {};
    const res = await $b3a827ddbe833d32$export$b91933b10432b596(opts);
    meta.response = res;
    const json = await res.json();
    meta.responseJSON = json;
    return {
        json: json,
        meta: meta
    };
}

});
parcelRegister("fj8ND", function(module, exports) {

$parcel$export(module.exports, "getTransformer", function () { return $4f8ccb4eb892bab1$export$58e86018bd6095cc; });
//#region src/internals/transformer.ts
/**
* @internal
*/ /**
* @internal
*/ function $4f8ccb4eb892bab1$export$58e86018bd6095cc(transformer) {
    const _transformer = transformer;
    if (!_transformer) return {
        input: {
            serialize: (data)=>data,
            deserialize: (data)=>data
        },
        output: {
            serialize: (data)=>data,
            deserialize: (data)=>data
        }
    };
    if ("input" in _transformer) return _transformer;
    return {
        input: _transformer,
        output: _transformer
    };
}

});


parcelRegister("gARAj", function(module, exports) {

$parcel$export(module.exports, "httpLink", function () { return $828fec84f806bc48$export$9b6146f3c3e2c24a; });

var $a6ELx = parcelRequire("a6ELx");

var $2J6qj = parcelRequire("2J6qj");

var $aBBWl = parcelRequire("aBBWl");

var $c2p8A = parcelRequire("c2p8A");

var $8hhvi = parcelRequire("8hhvi");
//#region src/links/internals/contentTypes.ts
function $828fec84f806bc48$export$c771fe502e5c8d00(input) {
    return input instanceof Uint8Array || input instanceof Blob;
}
function $828fec84f806bc48$export$67a42df2b7ab73bc(input) {
    return input instanceof FormData;
}
function $828fec84f806bc48$export$6c42a296ab929dce(input) {
    return $828fec84f806bc48$export$c771fe502e5c8d00(input) || $828fec84f806bc48$export$67a42df2b7ab73bc(input);
}
//#endregion
//#region src/links/httpLink.ts
var $828fec84f806bc48$var$import_objectSpread2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
const $828fec84f806bc48$var$universalRequester = (opts)=>{
    if ("input" in opts) {
        const { input: input } = opts;
        if ($828fec84f806bc48$export$67a42df2b7ab73bc(input)) {
            if (opts.type !== "mutation" && opts.methodOverride !== "POST") throw new Error("FormData is only supported for mutations");
            return (0, $aBBWl.httpRequest)((0, $828fec84f806bc48$var$import_objectSpread2.default)((0, $828fec84f806bc48$var$import_objectSpread2.default)({}, opts), {}, {
                contentTypeHeader: void 0,
                getUrl: $aBBWl.getUrl,
                getBody: ()=>input
            }));
        }
        if ($828fec84f806bc48$export$c771fe502e5c8d00(input)) {
            if (opts.type !== "mutation" && opts.methodOverride !== "POST") throw new Error("Octet type input is only supported for mutations");
            return (0, $aBBWl.httpRequest)((0, $828fec84f806bc48$var$import_objectSpread2.default)((0, $828fec84f806bc48$var$import_objectSpread2.default)({}, opts), {}, {
                contentTypeHeader: "application/octet-stream",
                getUrl: $aBBWl.getUrl,
                getBody: ()=>input
            }));
        }
    }
    return (0, $aBBWl.jsonHttpRequester)(opts);
};
/**
* @see https://trpc.io/docs/client/links/httpLink
*/ function $828fec84f806bc48$export$9b6146f3c3e2c24a(opts) {
    const resolvedOpts = (0, $aBBWl.resolveHTTPLinkOptions)(opts);
    return ()=>{
        return (operationOpts)=>{
            const { op: op } = operationOpts;
            return (0, $c2p8A.observable)((observer)=>{
                const { path: path, input: input, type: type } = op;
                /* istanbul ignore if -- @preserve */ if (type === "subscription") throw new Error("Subscriptions are unsupported by `httpLink` - use `httpSubscriptionLink` or `wsLink`");
                const request = $828fec84f806bc48$var$universalRequester((0, $828fec84f806bc48$var$import_objectSpread2.default)((0, $828fec84f806bc48$var$import_objectSpread2.default)({}, resolvedOpts), {}, {
                    type: type,
                    path: path,
                    input: input,
                    signal: op.signal,
                    headers () {
                        if (!opts.headers) return {};
                        if (typeof opts.headers === "function") return opts.headers({
                            op: op
                        });
                        return opts.headers;
                    }
                }));
                let meta = void 0;
                request.then((res)=>{
                    meta = res.meta;
                    const transformed = (0, $8hhvi.transformResult)(res.json, resolvedOpts.transformer.output);
                    if (!transformed.ok) {
                        observer.error((0, $2J6qj.TRPCClientError).from(transformed.error, {
                            meta: meta
                        }));
                        return;
                    }
                    observer.next({
                        context: res.meta,
                        result: transformed.result
                    });
                    observer.complete();
                }).catch((cause)=>{
                    observer.error((0, $2J6qj.TRPCClientError).from(cause, {
                        meta: meta
                    }));
                });
                return ()=>{};
            });
        };
    };
}

});
parcelRegister("8hhvi", function(module, exports) {

$parcel$export(module.exports, "getTRPCErrorFromUnknown", function () { return $b2b31fb82f942983$export$7d3246e17f8c8266; });
$parcel$export(module.exports, "TRPCError", function () { return $b2b31fb82f942983$export$f30f9aa22bbec82a; });
$parcel$export(module.exports, "transformTRPCResponse", function () { return $b2b31fb82f942983$export$ba650e8f1d255662; });
$parcel$export(module.exports, "transformResult", function () { return $b2b31fb82f942983$export$f13b29f9ed0c5a03; });
$parcel$export(module.exports, "getProcedureAtPath", function () { return $b2b31fb82f942983$export$d2dcfaee2ac9d170; });
$parcel$export(module.exports, "callProcedure", function () { return $b2b31fb82f942983$export$1abcc33cf50ffb3e; });
$parcel$export(module.exports, "isTrackedEnvelope", function () { return $b2b31fb82f942983$export$319fd0f56ca4887f; });

var $1h7sD = parcelRequire("1h7sD");

var $6bgAm = parcelRequire("6bgAm");
//#region src/unstable-core-do-not-import/error/formatter.ts
const $b2b31fb82f942983$export$74332e2e6daaf651 = ({ shape: shape })=>{
    return shape;
};
//#endregion
//#region src/unstable-core-do-not-import/error/TRPCError.ts
var $b2b31fb82f942983$var$import_defineProperty = (0, $1h7sD.__toESM)((0, $1h7sD.require_defineProperty)(), 1);
var $b2b31fb82f942983$var$UnknownCauseError = class extends Error {
};
function $b2b31fb82f942983$export$22aa9a5f89dcf72(cause) {
    if (cause instanceof Error) return cause;
    const type = typeof cause;
    if (type === "undefined" || type === "function" || cause === null) return void 0;
    if (type !== "object") return new Error(String(cause));
    if ((0, $6bgAm.isObject)(cause)) return Object.assign(new $b2b31fb82f942983$var$UnknownCauseError(), cause);
    return void 0;
}
function $b2b31fb82f942983$export$7d3246e17f8c8266(cause) {
    if (cause instanceof $b2b31fb82f942983$export$f30f9aa22bbec82a) return cause;
    if (cause instanceof Error && cause.name === "TRPCError") return cause;
    const trpcError = new $b2b31fb82f942983$export$f30f9aa22bbec82a({
        code: "INTERNAL_SERVER_ERROR",
        cause: cause
    });
    if (cause instanceof Error && cause.stack) trpcError.stack = cause.stack;
    return trpcError;
}
var $b2b31fb82f942983$export$f30f9aa22bbec82a = class extends Error {
    constructor(opts){
        var _ref, _opts$message, _this$cause;
        const cause = $b2b31fb82f942983$export$22aa9a5f89dcf72(opts.cause);
        const message = (_ref = (_opts$message = opts.message) !== null && _opts$message !== void 0 ? _opts$message : cause === null || cause === void 0 ? void 0 : cause.message) !== null && _ref !== void 0 ? _ref : opts.code;
        super(message, {
            cause: cause
        });
        (0, $b2b31fb82f942983$var$import_defineProperty.default)(this, "cause", void 0);
        (0, $b2b31fb82f942983$var$import_defineProperty.default)(this, "code", void 0);
        this.code = opts.code;
        this.name = "TRPCError";
        (_this$cause = this.cause) !== null && _this$cause !== void 0 || (this.cause = cause);
    }
};
//#endregion
//#region src/unstable-core-do-not-import/transformer.ts
var $b2b31fb82f942983$var$import_objectSpread2$1 = (0, $1h7sD.__toESM)((0, $1h7sD.require_objectSpread2)(), 1);
/**
* @internal
*/ function $b2b31fb82f942983$export$41053bfb47edc0c1(transformer) {
    if ("input" in transformer) return transformer;
    return {
        input: transformer,
        output: transformer
    };
}
/**
* @internal
*/ const $b2b31fb82f942983$export$dd7d22f1dfadb12f = {
    input: {
        serialize: (obj)=>obj,
        deserialize: (obj)=>obj
    },
    output: {
        serialize: (obj)=>obj,
        deserialize: (obj)=>obj
    }
};
function $b2b31fb82f942983$var$transformTRPCResponseItem(config, item) {
    if ("error" in item) return (0, $b2b31fb82f942983$var$import_objectSpread2$1.default)((0, $b2b31fb82f942983$var$import_objectSpread2$1.default)({}, item), {}, {
        error: config.transformer.output.serialize(item.error)
    });
    if ("data" in item.result) return (0, $b2b31fb82f942983$var$import_objectSpread2$1.default)((0, $b2b31fb82f942983$var$import_objectSpread2$1.default)({}, item), {}, {
        result: (0, $b2b31fb82f942983$var$import_objectSpread2$1.default)((0, $b2b31fb82f942983$var$import_objectSpread2$1.default)({}, item.result), {}, {
            data: config.transformer.output.serialize(item.result.data)
        })
    });
    return item;
}
/**
* Takes a unserialized `TRPCResponse` and serializes it with the router's transformers
**/ function $b2b31fb82f942983$export$ba650e8f1d255662(config, itemOrItems) {
    return Array.isArray(itemOrItems) ? itemOrItems.map((item)=>$b2b31fb82f942983$var$transformTRPCResponseItem(config, item)) : $b2b31fb82f942983$var$transformTRPCResponseItem(config, itemOrItems);
}
/** @internal */ function $b2b31fb82f942983$var$transformResultInner(response, transformer) {
    if ("error" in response) {
        const error = transformer.deserialize(response.error);
        return {
            ok: false,
            error: (0, $b2b31fb82f942983$var$import_objectSpread2$1.default)((0, $b2b31fb82f942983$var$import_objectSpread2$1.default)({}, response), {}, {
                error: error
            })
        };
    }
    const result = (0, $b2b31fb82f942983$var$import_objectSpread2$1.default)((0, $b2b31fb82f942983$var$import_objectSpread2$1.default)({}, response.result), (!response.result.type || response.result.type === "data") && {
        type: "data",
        data: transformer.deserialize(response.result.data)
    });
    return {
        ok: true,
        result: result
    };
}
var $b2b31fb82f942983$var$TransformResultError = class extends Error {
    constructor(){
        super("Unable to transform response from server");
    }
};
/**
* Transforms and validates that the result is a valid TRPCResponse
* @internal
*/ function $b2b31fb82f942983$export$f13b29f9ed0c5a03(response, transformer) {
    let result;
    try {
        result = $b2b31fb82f942983$var$transformResultInner(response, transformer);
    } catch (_unused) {
        throw new $b2b31fb82f942983$var$TransformResultError();
    }
    if (!result.ok && (!(0, $6bgAm.isObject)(result.error.error) || typeof result.error.error["code"] !== "number")) throw new $b2b31fb82f942983$var$TransformResultError();
    if (result.ok && !(0, $6bgAm.isObject)(result.result)) throw new $b2b31fb82f942983$var$TransformResultError();
    return result;
}
//#endregion
//#region src/unstable-core-do-not-import/router.ts
var $b2b31fb82f942983$var$import_objectSpread2 = (0, $1h7sD.__toESM)((0, $1h7sD.require_objectSpread2)(), 1);
const $b2b31fb82f942983$var$lazySymbol = Symbol("lazy");
function $b2b31fb82f942983$var$once(fn) {
    const uncalled = Symbol();
    let result = uncalled;
    return ()=>{
        if (result === uncalled) result = fn();
        return result;
    };
}
/**
* Lazy load a router
* @see https://trpc.io/docs/server/merging-routers#lazy-load
*/ function $b2b31fb82f942983$export$488013bae63b21da(importRouter) {
    async function resolve() {
        const mod = await importRouter();
        if ($b2b31fb82f942983$var$isRouter(mod)) return mod;
        const routers = Object.values(mod);
        if (routers.length !== 1 || !$b2b31fb82f942983$var$isRouter(routers[0])) throw new Error("Invalid router module - either define exactly 1 export or return the router directly.\nExample: `lazy(() => import('./slow.js').then((m) => m.slowRouter))`");
        return routers[0];
    }
    resolve[$b2b31fb82f942983$var$lazySymbol] = true;
    return resolve;
}
function $b2b31fb82f942983$var$isLazy(input) {
    return typeof input === "function" && $b2b31fb82f942983$var$lazySymbol in input;
}
function $b2b31fb82f942983$var$isRouter(value) {
    return (0, $6bgAm.isObject)(value) && (0, $6bgAm.isObject)(value["_def"]) && "router" in value["_def"];
}
const $b2b31fb82f942983$var$emptyRouter = {
    _ctx: null,
    _errorShape: null,
    _meta: null,
    queries: {},
    mutations: {},
    subscriptions: {},
    errorFormatter: $b2b31fb82f942983$export$74332e2e6daaf651,
    transformer: $b2b31fb82f942983$export$dd7d22f1dfadb12f
};
/**
* Reserved words that can't be used as router or procedure names
*/ const $b2b31fb82f942983$var$reservedWords = [
    "then",
    "call",
    "apply"
];
/**
* @internal
*/ function $b2b31fb82f942983$export$4da7fd32ab11c222(config) {
    function createRouterInner(input) {
        const reservedWordsUsed = new Set(Object.keys(input).filter((v)=>$b2b31fb82f942983$var$reservedWords.includes(v)));
        if (reservedWordsUsed.size > 0) throw new Error("Reserved words used in `router({})` call: " + Array.from(reservedWordsUsed).join(", "));
        const procedures = (0, $6bgAm.omitPrototype)({});
        const lazy$1 = (0, $6bgAm.omitPrototype)({});
        function createLazyLoader(opts) {
            return {
                ref: opts.ref,
                load: $b2b31fb82f942983$var$once(async ()=>{
                    const router$1 = await opts.ref();
                    const lazyPath = [
                        ...opts.path,
                        opts.key
                    ];
                    const lazyKey = lazyPath.join(".");
                    opts.aggregate[opts.key] = step(router$1._def.record, lazyPath);
                    delete lazy$1[lazyKey];
                    for (const [nestedKey, nestedItem] of Object.entries(router$1._def.lazy)){
                        const nestedRouterKey = [
                            ...lazyPath,
                            nestedKey
                        ].join(".");
                        lazy$1[nestedRouterKey] = createLazyLoader({
                            ref: nestedItem.ref,
                            path: lazyPath,
                            key: nestedKey,
                            aggregate: opts.aggregate[opts.key]
                        });
                    }
                })
            };
        }
        function step(from, path = []) {
            const aggregate = (0, $6bgAm.omitPrototype)({});
            for (const [key, item] of Object.entries(from !== null && from !== void 0 ? from : {})){
                if ($b2b31fb82f942983$var$isLazy(item)) {
                    lazy$1[[
                        ...path,
                        key
                    ].join(".")] = createLazyLoader({
                        path: path,
                        ref: item,
                        key: key,
                        aggregate: aggregate
                    });
                    continue;
                }
                if ($b2b31fb82f942983$var$isRouter(item)) {
                    aggregate[key] = step(item._def.record, [
                        ...path,
                        key
                    ]);
                    continue;
                }
                if (!$b2b31fb82f942983$var$isProcedure(item)) {
                    aggregate[key] = step(item, [
                        ...path,
                        key
                    ]);
                    continue;
                }
                const newPath = [
                    ...path,
                    key
                ].join(".");
                if (procedures[newPath]) throw new Error(`Duplicate key: ${newPath}`);
                procedures[newPath] = item;
                aggregate[key] = item;
            }
            return aggregate;
        }
        const record = step(input);
        const _def = (0, $b2b31fb82f942983$var$import_objectSpread2.default)((0, $b2b31fb82f942983$var$import_objectSpread2.default)({
            _config: config,
            router: true,
            procedures: procedures,
            lazy: lazy$1
        }, $b2b31fb82f942983$var$emptyRouter), {}, {
            record: record
        });
        const router = (0, $b2b31fb82f942983$var$import_objectSpread2.default)((0, $b2b31fb82f942983$var$import_objectSpread2.default)({}, record), {}, {
            _def: _def,
            createCaller: $b2b31fb82f942983$export$596cd4b0e3fc3d()({
                _def: _def
            })
        });
        return router;
    }
    return createRouterInner;
}
function $b2b31fb82f942983$var$isProcedure(procedureOrRouter) {
    return typeof procedureOrRouter === "function";
}
/**
* @internal
*/ async function $b2b31fb82f942983$export$d2dcfaee2ac9d170(router, path) {
    const { _def: _def } = router;
    let procedure = _def.procedures[path];
    while(!procedure){
        const key = Object.keys(_def.lazy).find((key$1)=>path.startsWith(key$1));
        if (!key) return null;
        const lazyRouter = _def.lazy[key];
        await lazyRouter.load();
        procedure = _def.procedures[path];
    }
    return procedure;
}
/**
* @internal
*/ async function $b2b31fb82f942983$export$1abcc33cf50ffb3e(opts) {
    const { type: type, path: path } = opts;
    const proc = await $b2b31fb82f942983$export$d2dcfaee2ac9d170(opts.router, path);
    if (!proc || !$b2b31fb82f942983$var$isProcedure(proc) || proc._def.type !== type && !opts.allowMethodOverride) throw new $b2b31fb82f942983$export$f30f9aa22bbec82a({
        code: "NOT_FOUND",
        message: `No "${type}"-procedure on path "${path}"`
    });
    /* istanbul ignore if -- @preserve */ if (proc._def.type !== type && opts.allowMethodOverride && proc._def.type === "subscription") throw new $b2b31fb82f942983$export$f30f9aa22bbec82a({
        code: "METHOD_NOT_SUPPORTED",
        message: `Method override is not supported for subscriptions`
    });
    return proc(opts);
}
function $b2b31fb82f942983$export$596cd4b0e3fc3d() {
    return function createCallerInner(router) {
        const { _def: _def } = router;
        return function createCaller(ctxOrCallback, opts) {
            return (0, $1h7sD.createRecursiveProxy)(async ({ path: path, args: args })=>{
                const fullPath = path.join(".");
                if (path.length === 1 && path[0] === "_def") return _def;
                const procedure = await $b2b31fb82f942983$export$d2dcfaee2ac9d170(router, fullPath);
                let ctx = void 0;
                try {
                    if (!procedure) throw new $b2b31fb82f942983$export$f30f9aa22bbec82a({
                        code: "NOT_FOUND",
                        message: `No procedure found on path "${path}"`
                    });
                    ctx = (0, $6bgAm.isFunction)(ctxOrCallback) ? await Promise.resolve(ctxOrCallback()) : ctxOrCallback;
                    return await procedure({
                        path: fullPath,
                        getRawInput: async ()=>args[0],
                        ctx: ctx,
                        type: procedure._def.type,
                        signal: opts === null || opts === void 0 ? void 0 : opts.signal
                    });
                } catch (cause) {
                    var _opts$onError, _procedure$_def$type;
                    opts === null || opts === void 0 || (_opts$onError = opts.onError) === null || _opts$onError === void 0 || _opts$onError.call(opts, {
                        ctx: ctx,
                        error: $b2b31fb82f942983$export$7d3246e17f8c8266(cause),
                        input: args[0],
                        path: fullPath,
                        type: (_procedure$_def$type = procedure === null || procedure === void 0 ? void 0 : procedure._def.type) !== null && _procedure$_def$type !== void 0 ? _procedure$_def$type : "unknown"
                    });
                    throw cause;
                }
            });
        };
    };
}
function $b2b31fb82f942983$export$133965fb4131a816(...routerList) {
    var _routerList$;
    const record = (0, $6bgAm.mergeWithoutOverrides)({}, ...routerList.map((r)=>r._def.record));
    const errorFormatter = routerList.reduce((currentErrorFormatter, nextRouter)=>{
        if (nextRouter._def._config.errorFormatter && nextRouter._def._config.errorFormatter !== $b2b31fb82f942983$export$74332e2e6daaf651) {
            if (currentErrorFormatter !== $b2b31fb82f942983$export$74332e2e6daaf651 && currentErrorFormatter !== nextRouter._def._config.errorFormatter) throw new Error("You seem to have several error formatters");
            return nextRouter._def._config.errorFormatter;
        }
        return currentErrorFormatter;
    }, $b2b31fb82f942983$export$74332e2e6daaf651);
    const transformer = routerList.reduce((prev, current)=>{
        if (current._def._config.transformer && current._def._config.transformer !== $b2b31fb82f942983$export$dd7d22f1dfadb12f) {
            if (prev !== $b2b31fb82f942983$export$dd7d22f1dfadb12f && prev !== current._def._config.transformer) throw new Error("You seem to have several transformers");
            return current._def._config.transformer;
        }
        return prev;
    }, $b2b31fb82f942983$export$dd7d22f1dfadb12f);
    const router = $b2b31fb82f942983$export$4da7fd32ab11c222({
        errorFormatter: errorFormatter,
        transformer: transformer,
        isDev: routerList.every((r)=>r._def._config.isDev),
        allowOutsideOfServer: routerList.every((r)=>r._def._config.allowOutsideOfServer),
        isServer: routerList.every((r)=>r._def._config.isServer),
        $types: (_routerList$ = routerList[0]) === null || _routerList$ === void 0 ? void 0 : _routerList$._def._config.$types
    })(record);
    return router;
}
//#endregion
//#region src/unstable-core-do-not-import/stream/tracked.ts
const $b2b31fb82f942983$var$trackedSymbol = Symbol();
/**
* Produce a typed server-sent event message
* @deprecated use `tracked(id, data)` instead
*/ function $b2b31fb82f942983$export$d2eb86c820565c41(event) {
    return $b2b31fb82f942983$export$96e1cf6e20023c3a(event.id, event.data);
}
function $b2b31fb82f942983$export$319fd0f56ca4887f(value) {
    return Array.isArray(value) && value[2] === $b2b31fb82f942983$var$trackedSymbol;
}
/**
* Automatically track an event so that it can be resumed from a given id if the connection is lost
*/ function $b2b31fb82f942983$export$96e1cf6e20023c3a(id, data) {
    if (id === "") throw new Error("`id` must not be an empty string as empty string is the same as not setting the id at all");
    return [
        id,
        data,
        $b2b31fb82f942983$var$trackedSymbol
    ];
}

});
parcelRegister("1h7sD", function(module, exports) {

$parcel$export(module.exports, "__commonJS", function () { return $40267c88e3b2ef00$export$c98acbe61b4a254a; });
$parcel$export(module.exports, "__toESM", function () { return $40267c88e3b2ef00$export$82dec27a9dce9602; });
$parcel$export(module.exports, "createRecursiveProxy", function () { return $40267c88e3b2ef00$export$7b7795bbf1e1dd0c; });
$parcel$export(module.exports, "createFlatProxy", function () { return $40267c88e3b2ef00$export$341f807458b1fa7f; });
$parcel$export(module.exports, "getHTTPStatusCode", function () { return $40267c88e3b2ef00$export$10ee37adc9bafa65; });
$parcel$export(module.exports, "require_defineProperty", function () { return $40267c88e3b2ef00$export$ab908e1fcccc7689; });
$parcel$export(module.exports, "require_objectSpread2", function () { return $40267c88e3b2ef00$export$32dc13945d3e01da; });
$parcel$export(module.exports, "getErrorShape", function () { return $40267c88e3b2ef00$export$84f1b56083509104; });

var $6bgAm = parcelRequire("6bgAm");
//#region rolldown:runtime
var $40267c88e3b2ef00$var$__create = Object.create;
var $40267c88e3b2ef00$var$__defProp = Object.defineProperty;
var $40267c88e3b2ef00$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $40267c88e3b2ef00$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $40267c88e3b2ef00$var$__getProtoOf = Object.getPrototypeOf;
var $40267c88e3b2ef00$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $40267c88e3b2ef00$export$c98acbe61b4a254a = (cb, mod)=>function() {
        return mod || (0, cb[$40267c88e3b2ef00$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $40267c88e3b2ef00$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") for(var keys = $40267c88e3b2ef00$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$40267c88e3b2ef00$var$__hasOwnProp.call(to, key) && key !== except) $40267c88e3b2ef00$var$__defProp(to, key, {
            get: ((k)=>from[k]).bind(null, key),
            enumerable: !(desc = $40267c88e3b2ef00$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $40267c88e3b2ef00$export$82dec27a9dce9602 = (mod, isNodeMode, target)=>(target = mod != null ? $40267c88e3b2ef00$var$__create($40267c88e3b2ef00$var$__getProtoOf(mod)) : {}, $40267c88e3b2ef00$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $40267c88e3b2ef00$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
//#endregion
//#region src/unstable-core-do-not-import/createProxy.ts
const $40267c88e3b2ef00$var$noop = ()=>{};
const $40267c88e3b2ef00$var$freezeIfAvailable = (obj)=>{
    if (Object.freeze) Object.freeze(obj);
};
function $40267c88e3b2ef00$var$createInnerProxy(callback, path, memo) {
    var _memo$cacheKey;
    const cacheKey = path.join(".");
    (_memo$cacheKey = memo[cacheKey]) !== null && _memo$cacheKey !== void 0 || (memo[cacheKey] = new Proxy($40267c88e3b2ef00$var$noop, {
        get (_obj, key) {
            if (typeof key !== "string" || key === "then") return void 0;
            return $40267c88e3b2ef00$var$createInnerProxy(callback, [
                ...path,
                key
            ], memo);
        },
        apply (_1, _2, args) {
            const lastOfPath = path[path.length - 1];
            let opts = {
                args: args,
                path: path
            };
            if (lastOfPath === "call") opts = {
                args: args.length >= 2 ? [
                    args[1]
                ] : [],
                path: path.slice(0, -1)
            };
            else if (lastOfPath === "apply") opts = {
                args: args.length >= 2 ? args[1] : [],
                path: path.slice(0, -1)
            };
            $40267c88e3b2ef00$var$freezeIfAvailable(opts.args);
            $40267c88e3b2ef00$var$freezeIfAvailable(opts.path);
            return callback(opts);
        }
    }));
    return memo[cacheKey];
}
/**
* Creates a proxy that calls the callback with the path and arguments
*
* @internal
*/ const $40267c88e3b2ef00$export$7b7795bbf1e1dd0c = (callback)=>$40267c88e3b2ef00$var$createInnerProxy(callback, [], Object.create(null));
/**
* Used in place of `new Proxy` where each handler will map 1 level deep to another value.
*
* @internal
*/ const $40267c88e3b2ef00$export$341f807458b1fa7f = (callback)=>{
    return new Proxy($40267c88e3b2ef00$var$noop, {
        get (_obj, name) {
            if (name === "then") return void 0;
            return callback(name);
        }
    });
};
//#endregion
//#region src/unstable-core-do-not-import/http/getHTTPStatusCode.ts
const $40267c88e3b2ef00$export$436d3686117b12a2 = {
    PARSE_ERROR: 400,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    METHOD_NOT_SUPPORTED: 405,
    TIMEOUT: 408,
    CONFLICT: 409,
    PRECONDITION_FAILED: 412,
    PAYLOAD_TOO_LARGE: 413,
    UNSUPPORTED_MEDIA_TYPE: 415,
    UNPROCESSABLE_CONTENT: 422,
    TOO_MANY_REQUESTS: 429,
    CLIENT_CLOSED_REQUEST: 499,
    INTERNAL_SERVER_ERROR: 500,
    NOT_IMPLEMENTED: 501,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504
};
const $40267c88e3b2ef00$export$426ac10c13690e5f = {
    400: "BAD_REQUEST",
    401: "UNAUTHORIZED",
    402: "PAYMENT_REQUIRED",
    403: "FORBIDDEN",
    404: "NOT_FOUND",
    405: "METHOD_NOT_SUPPORTED",
    408: "TIMEOUT",
    409: "CONFLICT",
    412: "PRECONDITION_FAILED",
    413: "PAYLOAD_TOO_LARGE",
    415: "UNSUPPORTED_MEDIA_TYPE",
    422: "UNPROCESSABLE_CONTENT",
    429: "TOO_MANY_REQUESTS",
    499: "CLIENT_CLOSED_REQUEST",
    500: "INTERNAL_SERVER_ERROR",
    501: "NOT_IMPLEMENTED",
    502: "BAD_GATEWAY",
    503: "SERVICE_UNAVAILABLE",
    504: "GATEWAY_TIMEOUT"
};
function $40267c88e3b2ef00$export$a7b3b8f6f5c31e77(code) {
    var _JSONRPC2_TO_HTTP_COD;
    return (_JSONRPC2_TO_HTTP_COD = $40267c88e3b2ef00$export$436d3686117b12a2[code]) !== null && _JSONRPC2_TO_HTTP_COD !== void 0 ? _JSONRPC2_TO_HTTP_COD : 500;
}
function $40267c88e3b2ef00$export$4f08fb88e9242129(code) {
    var _HTTP_CODE_TO_JSONRPC;
    return (_HTTP_CODE_TO_JSONRPC = $40267c88e3b2ef00$export$426ac10c13690e5f[code]) !== null && _HTTP_CODE_TO_JSONRPC !== void 0 ? _HTTP_CODE_TO_JSONRPC : "INTERNAL_SERVER_ERROR";
}
function $40267c88e3b2ef00$export$10ee37adc9bafa65(json) {
    const arr = Array.isArray(json) ? json : [
        json
    ];
    const httpStatuses = new Set(arr.map((res)=>{
        if ("error" in res && (0, $6bgAm.isObject)(res.error.data)) {
            var _res$error$data;
            if (typeof ((_res$error$data = res.error.data) === null || _res$error$data === void 0 ? void 0 : _res$error$data["httpStatus"]) === "number") return res.error.data["httpStatus"];
            const code = (0, $6bgAm.TRPC_ERROR_CODES_BY_NUMBER)[res.error.code];
            return $40267c88e3b2ef00$export$a7b3b8f6f5c31e77(code);
        }
        return 200;
    }));
    if (httpStatuses.size !== 1) return 207;
    const httpStatus = httpStatuses.values().next().value;
    return httpStatus;
}
function $40267c88e3b2ef00$export$b7c4c86fc34f289(error) {
    return $40267c88e3b2ef00$export$a7b3b8f6f5c31e77(error.code);
}
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/typeof.js
var $40267c88e3b2ef00$var$require_typeof = $40267c88e3b2ef00$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/typeof.js" (exports, module) {
        function _typeof$2(o) {
            "@babel/helpers - typeof";
            return module.exports = _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
                return typeof o$1;
            } : function(o$1) {
                return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
            }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof$2(o);
        }
        module.exports = _typeof$2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPrimitive.js
var $40267c88e3b2ef00$var$require_toPrimitive = $40267c88e3b2ef00$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPrimitive.js" (exports, module) {
        var _typeof$1 = $40267c88e3b2ef00$var$require_typeof()["default"];
        function toPrimitive$1(t, r) {
            if ("object" != _typeof$1(t) || !t) return t;
            var e = t[Symbol.toPrimitive];
            if (void 0 !== e) {
                var i = e.call(t, r || "default");
                if ("object" != _typeof$1(i)) return i;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === r ? String : Number)(t);
        }
        module.exports = toPrimitive$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPropertyKey.js
var $40267c88e3b2ef00$var$require_toPropertyKey = $40267c88e3b2ef00$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPropertyKey.js" (exports, module) {
        var _typeof = $40267c88e3b2ef00$var$require_typeof()["default"];
        var toPrimitive = $40267c88e3b2ef00$var$require_toPrimitive();
        function toPropertyKey$1(t) {
            var i = toPrimitive(t, "string");
            return "symbol" == _typeof(i) ? i : i + "";
        }
        module.exports = toPropertyKey$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/defineProperty.js
var $40267c88e3b2ef00$export$ab908e1fcccc7689 = $40267c88e3b2ef00$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/defineProperty.js" (exports, module) {
        var toPropertyKey = $40267c88e3b2ef00$var$require_toPropertyKey();
        function _defineProperty(e, r, t) {
            return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
                value: t,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[r] = t, e;
        }
        module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/objectSpread2.js
var $40267c88e3b2ef00$export$32dc13945d3e01da = $40267c88e3b2ef00$export$c98acbe61b4a254a({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/objectSpread2.js" (exports, module) {
        var defineProperty = $40267c88e3b2ef00$export$ab908e1fcccc7689();
        function ownKeys(e, r) {
            var t = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                r && (o = o.filter(function(r$1) {
                    return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
                })), t.push.apply(t, o);
            }
            return t;
        }
        function _objectSpread2(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = null != arguments[r] ? arguments[r] : {};
                r % 2 ? ownKeys(Object(t), !0).forEach(function(r$1) {
                    defineProperty(e, r$1, t[r$1]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r$1) {
                    Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
                });
            }
            return e;
        }
        module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region src/unstable-core-do-not-import/error/getErrorShape.ts
var $40267c88e3b2ef00$var$import_objectSpread2 = $40267c88e3b2ef00$export$82dec27a9dce9602($40267c88e3b2ef00$export$32dc13945d3e01da(), 1);
/**
* @internal
*/ function $40267c88e3b2ef00$export$84f1b56083509104(opts) {
    const { path: path, error: error, config: config } = opts;
    const { code: code } = opts.error;
    const shape = {
        message: error.message,
        code: (0, $6bgAm.TRPC_ERROR_CODES_BY_KEY)[code],
        data: {
            code: code,
            httpStatus: $40267c88e3b2ef00$export$b7c4c86fc34f289(error)
        }
    };
    if (config.isDev && typeof opts.error.stack === "string") shape.data.stack = opts.error.stack;
    if (typeof path === "string") shape.data.path = path;
    return config.errorFormatter((0, $40267c88e3b2ef00$var$import_objectSpread2.default)((0, $40267c88e3b2ef00$var$import_objectSpread2.default)({}, opts), {}, {
        shape: shape
    }));
}

});



parcelRegister("jker1", function(module, exports) {

$parcel$export(module.exports, "dataLoader", function () { return $057b3db16b0bf41c$export$644e1ee1c0bb3075; });
$parcel$export(module.exports, "allAbortSignals", function () { return $057b3db16b0bf41c$export$b64ff053dfda93ab; });
$parcel$export(module.exports, "raceAbortSignals", function () { return $057b3db16b0bf41c$export$907af54682109572; });
$parcel$export(module.exports, "abortSignalToPromise", function () { return $057b3db16b0bf41c$export$a2d1781d885b24f5; });

var $a6ELx = parcelRequire("a6ELx");

var $2J6qj = parcelRequire("2J6qj");

var $aBBWl = parcelRequire("aBBWl");

var $c2p8A = parcelRequire("c2p8A");

var $8hhvi = parcelRequire("8hhvi");
//#region src/internals/dataLoader.ts
/**
* A function that should never be called unless we messed something up.
*/ const $057b3db16b0bf41c$var$throwFatalError = ()=>{
    throw new Error("Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new");
};
/**
* Dataloader that's very inspired by https://github.com/graphql/dataloader
* Less configuration, no caching, and allows you to cancel requests
* When cancelling a single fetch the whole batch will be cancelled only when _all_ items are cancelled
*/ function $057b3db16b0bf41c$export$644e1ee1c0bb3075(batchLoader) {
    let pendingItems = null;
    let dispatchTimer = null;
    const destroyTimerAndPendingItems = ()=>{
        clearTimeout(dispatchTimer);
        dispatchTimer = null;
        pendingItems = null;
    };
    /**
	* Iterate through the items and split them into groups based on the `batchLoader`'s validate function
	*/ function groupItems(items) {
        const groupedItems = [
            []
        ];
        let index = 0;
        while(true){
            const item = items[index];
            if (!item) break;
            const lastGroup = groupedItems[groupedItems.length - 1];
            if (item.aborted) {
                var _item$reject;
                (_item$reject = item.reject) === null || _item$reject === void 0 || _item$reject.call(item, new Error("Aborted"));
                index++;
                continue;
            }
            const isValid = batchLoader.validate(lastGroup.concat(item).map((it)=>it.key));
            if (isValid) {
                lastGroup.push(item);
                index++;
                continue;
            }
            if (lastGroup.length === 0) {
                var _item$reject2;
                (_item$reject2 = item.reject) === null || _item$reject2 === void 0 || _item$reject2.call(item, new Error("Input is too big for a single dispatch"));
                index++;
                continue;
            }
            groupedItems.push([]);
        }
        return groupedItems;
    }
    function dispatch() {
        const groupedItems = groupItems(pendingItems);
        destroyTimerAndPendingItems();
        for (const items of groupedItems){
            if (!items.length) continue;
            const batch = {
                items: items
            };
            for (const item of items)item.batch = batch;
            const promise = batchLoader.fetch(batch.items.map((_item)=>_item.key));
            promise.then(async (result)=>{
                await Promise.all(result.map(async (valueOrPromise, index)=>{
                    const item = batch.items[index];
                    try {
                        var _item$resolve;
                        const value = await Promise.resolve(valueOrPromise);
                        (_item$resolve = item.resolve) === null || _item$resolve === void 0 || _item$resolve.call(item, value);
                    } catch (cause) {
                        var _item$reject3;
                        (_item$reject3 = item.reject) === null || _item$reject3 === void 0 || _item$reject3.call(item, cause);
                    }
                    item.batch = null;
                    item.reject = null;
                    item.resolve = null;
                }));
                for (const item of batch.items){
                    var _item$reject4;
                    (_item$reject4 = item.reject) === null || _item$reject4 === void 0 || _item$reject4.call(item, new Error("Missing result"));
                    item.batch = null;
                }
            }).catch((cause)=>{
                for (const item of batch.items){
                    var _item$reject5;
                    (_item$reject5 = item.reject) === null || _item$reject5 === void 0 || _item$reject5.call(item, cause);
                    item.batch = null;
                }
            });
        }
    }
    function load(key) {
        var _dispatchTimer;
        const item = {
            aborted: false,
            key: key,
            batch: null,
            resolve: $057b3db16b0bf41c$var$throwFatalError,
            reject: $057b3db16b0bf41c$var$throwFatalError
        };
        const promise = new Promise((resolve, reject)=>{
            var _pendingItems;
            item.reject = reject;
            item.resolve = resolve;
            (_pendingItems = pendingItems) !== null && _pendingItems !== void 0 || (pendingItems = []);
            pendingItems.push(item);
        });
        (_dispatchTimer = dispatchTimer) !== null && _dispatchTimer !== void 0 || (dispatchTimer = setTimeout(dispatch));
        return promise;
    }
    return {
        load: load
    };
}
//#endregion
//#region src/internals/signals.ts
/**
* Like `Promise.all()` but for abort signals
* - When all signals have been aborted, the merged signal will be aborted
* - If one signal is `null`, no signal will be aborted
*/ function $057b3db16b0bf41c$export$b64ff053dfda93ab(...signals) {
    const ac = new AbortController();
    const count = signals.length;
    let abortedCount = 0;
    const onAbort = ()=>{
        if (++abortedCount === count) ac.abort();
    };
    for (const signal of signals)if (signal === null || signal === void 0 ? void 0 : signal.aborted) onAbort();
    else signal === null || signal === void 0 || signal.addEventListener("abort", onAbort, {
        once: true
    });
    return ac.signal;
}
/**
* Like `Promise.race` but for abort signals
*
* Basically, a ponyfill for
* [`AbortSignal.any`](https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/any_static).
*/ function $057b3db16b0bf41c$export$907af54682109572(...signals) {
    const ac = new AbortController();
    for (const signal of signals)if (signal === null || signal === void 0 ? void 0 : signal.aborted) ac.abort();
    else signal === null || signal === void 0 || signal.addEventListener("abort", ()=>ac.abort(), {
        once: true
    });
    return ac.signal;
}
function $057b3db16b0bf41c$export$a2d1781d885b24f5(signal) {
    return new Promise((_, reject)=>{
        if (signal.aborted) {
            reject(signal.reason);
            return;
        }
        signal.addEventListener("abort", ()=>{
            reject(signal.reason);
        }, {
            once: true
        });
    });
}
//#endregion
//#region src/links/httpBatchLink.ts
var $057b3db16b0bf41c$var$import_objectSpread2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
/**
* @see https://trpc.io/docs/client/links/httpBatchLink
*/ function $057b3db16b0bf41c$export$5b913342393f3ee0(opts) {
    var _opts$maxURLLength, _opts$maxItems;
    const resolvedOpts = (0, $aBBWl.resolveHTTPLinkOptions)(opts);
    const maxURLLength = (_opts$maxURLLength = opts.maxURLLength) !== null && _opts$maxURLLength !== void 0 ? _opts$maxURLLength : Infinity;
    const maxItems = (_opts$maxItems = opts.maxItems) !== null && _opts$maxItems !== void 0 ? _opts$maxItems : Infinity;
    return ()=>{
        const batchLoader = (type)=>{
            return {
                validate (batchOps) {
                    if (maxURLLength === Infinity && maxItems === Infinity) return true;
                    if (batchOps.length > maxItems) return false;
                    const path = batchOps.map((op)=>op.path).join(",");
                    const inputs = batchOps.map((op)=>op.input);
                    const url = (0, $aBBWl.getUrl)((0, $057b3db16b0bf41c$var$import_objectSpread2.default)((0, $057b3db16b0bf41c$var$import_objectSpread2.default)({}, resolvedOpts), {}, {
                        type: type,
                        path: path,
                        inputs: inputs,
                        signal: null
                    }));
                    return url.length <= maxURLLength;
                },
                async fetch (batchOps) {
                    const path = batchOps.map((op)=>op.path).join(",");
                    const inputs = batchOps.map((op)=>op.input);
                    const signal = $057b3db16b0bf41c$export$b64ff053dfda93ab(...batchOps.map((op)=>op.signal));
                    const res = await (0, $aBBWl.jsonHttpRequester)((0, $057b3db16b0bf41c$var$import_objectSpread2.default)((0, $057b3db16b0bf41c$var$import_objectSpread2.default)({}, resolvedOpts), {}, {
                        path: path,
                        inputs: inputs,
                        type: type,
                        headers () {
                            if (!opts.headers) return {};
                            if (typeof opts.headers === "function") return opts.headers({
                                opList: batchOps
                            });
                            return opts.headers;
                        },
                        signal: signal
                    }));
                    const resJSON = Array.isArray(res.json) ? res.json : batchOps.map(()=>res.json);
                    const result = resJSON.map((item)=>({
                            meta: res.meta,
                            json: item
                        }));
                    return result;
                }
            };
        };
        const query = $057b3db16b0bf41c$export$644e1ee1c0bb3075(batchLoader("query"));
        const mutation = $057b3db16b0bf41c$export$644e1ee1c0bb3075(batchLoader("mutation"));
        const loaders = {
            query: query,
            mutation: mutation
        };
        return ({ op: op })=>{
            return (0, $c2p8A.observable)((observer)=>{
                /* istanbul ignore if -- @preserve */ if (op.type === "subscription") throw new Error("Subscriptions are unsupported by `httpLink` - use `httpSubscriptionLink` or `wsLink`");
                const loader = loaders[op.type];
                const promise = loader.load(op);
                let _res = void 0;
                promise.then((res)=>{
                    _res = res;
                    const transformed = (0, $8hhvi.transformResult)(res.json, resolvedOpts.transformer.output);
                    if (!transformed.ok) {
                        observer.error((0, $2J6qj.TRPCClientError).from(transformed.error, {
                            meta: res.meta
                        }));
                        return;
                    }
                    observer.next({
                        context: res.meta,
                        result: transformed.result
                    });
                    observer.complete();
                }).catch((err)=>{
                    observer.error((0, $2J6qj.TRPCClientError).from(err, {
                        meta: _res === null || _res === void 0 ? void 0 : _res.meta
                    }));
                });
                return ()=>{};
            });
        };
    };
}

});

parcelRegister("i1TZg", function(module, exports) {

var $a6ELx = parcelRequire("a6ELx");

var $c2p8A = parcelRequire("c2p8A");
var $lQFgY = parcelRequire("lQFgY");
//#region src/links/loggerLink.ts
var $5c84487bcc8edf31$var$import_objectSpread2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
function $5c84487bcc8edf31$var$isFormData(value) {
    if (typeof FormData === "undefined") return false;
    return value instanceof FormData;
}
const $5c84487bcc8edf31$var$palettes = {
    css: {
        query: [
            "72e3ff",
            "3fb0d8"
        ],
        mutation: [
            "c5a3fc",
            "904dfc"
        ],
        subscription: [
            "ff49e1",
            "d83fbe"
        ]
    },
    ansi: {
        regular: {
            query: [
                "\x1b[30;46m",
                "\x1b[97;46m"
            ],
            mutation: [
                "\x1b[30;45m",
                "\x1b[97;45m"
            ],
            subscription: [
                "\x1b[30;42m",
                "\x1b[97;42m"
            ]
        },
        bold: {
            query: [
                "\x1b[1;30;46m",
                "\x1b[1;97;46m"
            ],
            mutation: [
                "\x1b[1;30;45m",
                "\x1b[1;97;45m"
            ],
            subscription: [
                "\x1b[1;30;42m",
                "\x1b[1;97;42m"
            ]
        }
    }
};
function $5c84487bcc8edf31$var$constructPartsAndArgs(opts) {
    const { direction: direction, type: type, withContext: withContext, path: path, id: id, input: input } = opts;
    const parts = [];
    const args = [];
    if (opts.colorMode === "none") parts.push(direction === "up" ? ">>" : "<<", type, `#${id}`, path);
    else if (opts.colorMode === "ansi") {
        const [lightRegular, darkRegular] = $5c84487bcc8edf31$var$palettes.ansi.regular[type];
        const [lightBold, darkBold] = $5c84487bcc8edf31$var$palettes.ansi.bold[type];
        const reset = "\x1b[0m";
        parts.push(direction === "up" ? lightRegular : darkRegular, direction === "up" ? ">>" : "<<", type, direction === "up" ? lightBold : darkBold, `#${id}`, path, reset);
    } else {
        const [light, dark] = $5c84487bcc8edf31$var$palettes.css[type];
        const css = `
    background-color: #${direction === "up" ? light : dark};
    color: ${direction === "up" ? "black" : "white"};
    padding: 2px;
  `;
        parts.push("%c", direction === "up" ? ">>" : "<<", type, `#${id}`, `%c${path}%c`, "%O");
        args.push(css, `${css}; font-weight: bold;`, `${css}; font-weight: normal;`);
    }
    if (direction === "up") args.push(withContext ? {
        input: input,
        context: opts.context
    } : {
        input: input
    });
    else args.push((0, $5c84487bcc8edf31$var$import_objectSpread2.default)({
        input: input,
        result: opts.result,
        elapsedMs: opts.elapsedMs
    }, withContext && {
        context: opts.context
    }));
    return {
        parts: parts,
        args: args
    };
}
const $5c84487bcc8edf31$var$defaultLogger = ({ c: c = console, colorMode: colorMode = "css", withContext: withContext })=>(props)=>{
        const rawInput = props.input;
        const input = $5c84487bcc8edf31$var$isFormData(rawInput) ? Object.fromEntries(rawInput) : rawInput;
        const { parts: parts, args: args } = $5c84487bcc8edf31$var$constructPartsAndArgs((0, $5c84487bcc8edf31$var$import_objectSpread2.default)((0, $5c84487bcc8edf31$var$import_objectSpread2.default)({}, props), {}, {
            colorMode: colorMode,
            input: input,
            withContext: withContext
        }));
        const fn = props.direction === "down" && props.result && (props.result instanceof Error || "error" in props.result.result && props.result.result.error) ? "error" : "log";
        c[fn].apply(null, [
            parts.join(" ")
        ].concat(args));
    };
/**
* @see https://trpc.io/docs/v11/client/links/loggerLink
*/ function $5c84487bcc8edf31$export$6c4954c1f47de3ce(opts = {}) {
    var _opts$colorMode, _opts$withContext;
    const { enabled: enabled = ()=>true } = opts;
    const colorMode = (_opts$colorMode = opts.colorMode) !== null && _opts$colorMode !== void 0 ? _opts$colorMode : typeof window === "undefined" ? "ansi" : "css";
    const withContext = (_opts$withContext = opts.withContext) !== null && _opts$withContext !== void 0 ? _opts$withContext : colorMode === "css";
    const { logger: logger = $5c84487bcc8edf31$var$defaultLogger({
        c: opts.console,
        colorMode: colorMode,
        withContext: withContext
    }) } = opts;
    return ()=>{
        return ({ op: op, next: next })=>{
            return (0, $c2p8A.observable)((observer)=>{
                if (enabled((0, $5c84487bcc8edf31$var$import_objectSpread2.default)((0, $5c84487bcc8edf31$var$import_objectSpread2.default)({}, op), {}, {
                    direction: "up"
                }))) logger((0, $5c84487bcc8edf31$var$import_objectSpread2.default)((0, $5c84487bcc8edf31$var$import_objectSpread2.default)({}, op), {}, {
                    direction: "up"
                }));
                const requestStartTime = Date.now();
                function logResult(result) {
                    const elapsedMs = Date.now() - requestStartTime;
                    if (enabled((0, $5c84487bcc8edf31$var$import_objectSpread2.default)((0, $5c84487bcc8edf31$var$import_objectSpread2.default)({}, op), {}, {
                        direction: "down",
                        result: result
                    }))) logger((0, $5c84487bcc8edf31$var$import_objectSpread2.default)((0, $5c84487bcc8edf31$var$import_objectSpread2.default)({}, op), {}, {
                        direction: "down",
                        elapsedMs: elapsedMs,
                        result: result
                    }));
                }
                return next(op).pipe((0, $lQFgY.tap)({
                    next (result) {
                        logResult(result);
                    },
                    error (result) {
                        logResult(result);
                    }
                })).subscribe(observer);
            });
        };
    };
}

});
parcelRegister("lQFgY", function(module, exports) {

$parcel$export(module.exports, "share", function () { return $2b5f8087b0ccef79$export$ed80d9de1d9df928; });
$parcel$export(module.exports, "tap", function () { return $2b5f8087b0ccef79$export$3f23594af5f37336; });
$parcel$export(module.exports, "behaviorSubject", function () { return $2b5f8087b0ccef79$export$ed9b3ab89c5b6bf5; });

var $c2p8A = parcelRequire("c2p8A");
//#region src/observable/operators.ts
function $2b5f8087b0ccef79$export$871de8747c9eaa88(project) {
    return (source)=>{
        return (0, $c2p8A.observable)((destination)=>{
            let index = 0;
            const subscription = source.subscribe({
                next (value) {
                    destination.next(project(value, index++));
                },
                error (error) {
                    destination.error(error);
                },
                complete () {
                    destination.complete();
                }
            });
            return subscription;
        });
    };
}
function $2b5f8087b0ccef79$export$ed80d9de1d9df928(_opts) {
    return (source)=>{
        let refCount = 0;
        let subscription = null;
        const observers = [];
        function startIfNeeded() {
            if (subscription) return;
            subscription = source.subscribe({
                next (value) {
                    for (const observer of observers){
                        var _observer$next;
                        (_observer$next = observer.next) === null || _observer$next === void 0 || _observer$next.call(observer, value);
                    }
                },
                error (error) {
                    for (const observer of observers){
                        var _observer$error;
                        (_observer$error = observer.error) === null || _observer$error === void 0 || _observer$error.call(observer, error);
                    }
                },
                complete () {
                    for (const observer of observers){
                        var _observer$complete;
                        (_observer$complete = observer.complete) === null || _observer$complete === void 0 || _observer$complete.call(observer);
                    }
                }
            });
        }
        function resetIfNeeded() {
            if (refCount === 0 && subscription) {
                const _sub = subscription;
                subscription = null;
                _sub.unsubscribe();
            }
        }
        return (0, $c2p8A.observable)((subscriber)=>{
            refCount++;
            observers.push(subscriber);
            startIfNeeded();
            return {
                unsubscribe () {
                    refCount--;
                    resetIfNeeded();
                    const index = observers.findIndex((v)=>v === subscriber);
                    if (index > -1) observers.splice(index, 1);
                }
            };
        });
    };
}
function $2b5f8087b0ccef79$export$3f23594af5f37336(observer) {
    return (source)=>{
        return (0, $c2p8A.observable)((destination)=>{
            return source.subscribe({
                next (value) {
                    var _observer$next2;
                    (_observer$next2 = observer.next) === null || _observer$next2 === void 0 || _observer$next2.call(observer, value);
                    destination.next(value);
                },
                error (error) {
                    var _observer$error2;
                    (_observer$error2 = observer.error) === null || _observer$error2 === void 0 || _observer$error2.call(observer, error);
                    destination.error(error);
                },
                complete () {
                    var _observer$complete2;
                    (_observer$complete2 = observer.complete) === null || _observer$complete2 === void 0 || _observer$complete2.call(observer);
                    destination.complete();
                }
            });
        });
    };
}
const $2b5f8087b0ccef79$var$distinctUnsetMarker = Symbol();
function $2b5f8087b0ccef79$export$779c5fb865a0172e(compare = (a, b)=>a === b) {
    return (source)=>{
        return (0, $c2p8A.observable)((destination)=>{
            let lastValue = $2b5f8087b0ccef79$var$distinctUnsetMarker;
            return source.subscribe({
                next (value) {
                    if (lastValue !== $2b5f8087b0ccef79$var$distinctUnsetMarker && compare(lastValue, value)) return;
                    lastValue = value;
                    destination.next(value);
                },
                error (error) {
                    destination.error(error);
                },
                complete () {
                    destination.complete();
                }
            });
        });
    };
}
const $2b5f8087b0ccef79$var$isDeepEqual = (a, b)=>{
    if (a === b) return true;
    const bothAreObjects = a && b && typeof a === "object" && typeof b === "object";
    return !!bothAreObjects && Object.keys(a).length === Object.keys(b).length && Object.entries(a).every(([k, v])=>$2b5f8087b0ccef79$var$isDeepEqual(v, b[k]));
};
function $2b5f8087b0ccef79$export$aebdfc9c743f81fc() {
    return $2b5f8087b0ccef79$export$779c5fb865a0172e($2b5f8087b0ccef79$var$isDeepEqual);
}
//#endregion
//#region src/observable/behaviorSubject.ts
/**
* @internal
* An observable that maintains and provides a "current value" to subscribers
* @see https://www.learnrxjs.io/learn-rxjs/subjects/behaviorsubject
*/ function $2b5f8087b0ccef79$export$ed9b3ab89c5b6bf5(initialValue) {
    let value = initialValue;
    const observerList = [];
    const addObserver = (observer)=>{
        if (value !== void 0) observer.next(value);
        observerList.push(observer);
    };
    const removeObserver = (observer)=>{
        observerList.splice(observerList.indexOf(observer), 1);
    };
    const obs = (0, $c2p8A.observable)((observer)=>{
        addObserver(observer);
        return ()=>{
            removeObserver(observer);
        };
    });
    obs.next = (nextValue)=>{
        if (value === nextValue) return;
        value = nextValue;
        for (const observer of observerList)observer.next(nextValue);
    };
    obs.get = ()=>value;
    return obs;
}

});


parcelRegister("2IWia", function(module, exports) {

$parcel$export(module.exports, "resultOf", function () { return $02abedc4de0635cb$export$8b2fe420833eba76; });

var $a6ELx = parcelRequire("a6ELx");

var $2J6qj = parcelRequire("2J6qj");

var $fj8ND = parcelRequire("fj8ND");

var $lQFgY = parcelRequire("lQFgY");
var $c2p8A = parcelRequire("c2p8A");

var $6bgAm = parcelRequire("6bgAm");
var $8hhvi = parcelRequire("8hhvi");
//#region src/links/wsLink/wsClient/options.ts
const $02abedc4de0635cb$var$lazyDefaults = {
    enabled: false,
    closeMs: 0
};
const $02abedc4de0635cb$var$keepAliveDefaults = {
    enabled: false,
    pongTimeoutMs: 1e3,
    intervalMs: 5e3
};
/**
* Calculates a delay for exponential backoff based on the retry attempt index.
* The delay starts at 0 for the first attempt and doubles for each subsequent attempt,
* capped at 30 seconds.
*/ const $02abedc4de0635cb$var$exponentialBackoff = (attemptIndex)=>{
    return attemptIndex === 0 ? 0 : Math.min(1e3 * 2 ** attemptIndex, 3e4);
};
//#endregion
//#region src/links/internals/urlWithConnectionParams.ts
/**
* Get the result of a value or function that returns a value
* It also optionally accepts typesafe arguments for the function
*/ const $02abedc4de0635cb$export$8b2fe420833eba76 = (value, ...args)=>{
    return typeof value === "function" ? value(...args) : value;
};
//#endregion
//#region src/links/wsLink/wsClient/utils.ts
var $02abedc4de0635cb$var$import_defineProperty$3 = (0, $a6ELx.__toESM)((0, $a6ELx.require_defineProperty)(), 1);
var $02abedc4de0635cb$var$TRPCWebSocketClosedError = class TRPCWebSocketClosedError extends Error {
    constructor(opts){
        super(opts.message, {
            cause: opts.cause
        });
        this.name = "TRPCWebSocketClosedError";
        Object.setPrototypeOf(this, TRPCWebSocketClosedError.prototype);
    }
};
/**
* Utility class for managing a timeout that can be started, stopped, and reset.
* Useful for scenarios where the timeout duration is reset dynamically based on events.
*/ var $02abedc4de0635cb$var$ResettableTimeout = class {
    constructor(onTimeout, timeoutMs){
        this.onTimeout = onTimeout;
        this.timeoutMs = timeoutMs;
        (0, $02abedc4de0635cb$var$import_defineProperty$3.default)(this, "timeout", void 0);
    }
    /**
	* Resets the current timeout, restarting it with the same duration.
	* Does nothing if no timeout is active.
	*/ reset() {
        if (!this.timeout) return;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.onTimeout, this.timeoutMs);
    }
    start() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.onTimeout, this.timeoutMs);
    }
    stop() {
        clearTimeout(this.timeout);
        this.timeout = void 0;
    }
};
function $02abedc4de0635cb$var$withResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
/**
* Resolves a WebSocket URL and optionally appends connection parameters.
*
* If connectionParams are provided, appends 'connectionParams=1' query parameter.
*/ async function $02abedc4de0635cb$var$prepareUrl(urlOptions) {
    const url = await $02abedc4de0635cb$export$8b2fe420833eba76(urlOptions.url);
    if (!urlOptions.connectionParams) return url;
    const prefix = url.includes("?") ? "&" : "?";
    const connectionParams = `${prefix}connectionParams=1`;
    return url + connectionParams;
}
async function $02abedc4de0635cb$var$buildConnectionMessage(connectionParams) {
    const message = {
        method: "connectionParams",
        data: await $02abedc4de0635cb$export$8b2fe420833eba76(connectionParams)
    };
    return JSON.stringify(message);
}
//#endregion
//#region src/links/wsLink/wsClient/requestManager.ts
var $02abedc4de0635cb$var$import_defineProperty$2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_defineProperty)(), 1);
/**
* Manages WebSocket requests, tracking their lifecycle and providing utility methods
* for handling outgoing and pending requests.
*
* - **Outgoing requests**: Requests that are queued and waiting to be sent.
* - **Pending requests**: Requests that have been sent and are in flight awaiting a response.
*   For subscriptions, multiple responses may be received until the subscription is closed.
*/ var $02abedc4de0635cb$var$RequestManager = class {
    constructor(){
        (0, $02abedc4de0635cb$var$import_defineProperty$2.default)(this, "outgoingRequests", new Array());
        (0, $02abedc4de0635cb$var$import_defineProperty$2.default)(this, "pendingRequests", {});
    }
    /**
	* Registers a new request by adding it to the outgoing queue and setting up
	* callbacks for lifecycle events such as completion or error.
	*
	* @param message - The outgoing message to be sent.
	* @param callbacks - Callback functions to observe the request's state.
	* @returns A cleanup function to manually remove the request.
	*/ register(message, callbacks) {
        const { promise: end, resolve: resolve } = $02abedc4de0635cb$var$withResolvers();
        this.outgoingRequests.push({
            id: String(message.id),
            message: message,
            end: end,
            callbacks: {
                next: callbacks.next,
                complete: ()=>{
                    callbacks.complete();
                    resolve();
                },
                error: (e)=>{
                    callbacks.error(e);
                    resolve();
                }
            }
        });
        return ()=>{
            this.delete(message.id);
            callbacks.complete();
            resolve();
        };
    }
    /**
	* Deletes a request from both the outgoing and pending collections, if it exists.
	*/ delete(messageId) {
        if (messageId === null) return;
        this.outgoingRequests = this.outgoingRequests.filter(({ id: id })=>id !== String(messageId));
        delete this.pendingRequests[String(messageId)];
    }
    /**
	* Moves all outgoing requests to the pending state and clears the outgoing queue.
	*
	* The caller is expected to handle the actual sending of the requests
	* (e.g., sending them over the network) after this method is called.
	*
	* @returns The list of requests that were transitioned to the pending state.
	*/ flush() {
        const requests = this.outgoingRequests;
        this.outgoingRequests = [];
        for (const request of requests)this.pendingRequests[request.id] = request;
        return requests;
    }
    /**
	* Retrieves all currently pending requests, which are in flight awaiting responses
	* or handling ongoing subscriptions.
	*/ getPendingRequests() {
        return Object.values(this.pendingRequests);
    }
    /**
	* Retrieves a specific pending request by its message ID.
	*/ getPendingRequest(messageId) {
        if (messageId === null) return null;
        return this.pendingRequests[String(messageId)];
    }
    /**
	* Retrieves all outgoing requests, which are waiting to be sent.
	*/ getOutgoingRequests() {
        return this.outgoingRequests;
    }
    /**
	* Retrieves all requests, both outgoing and pending, with their respective states.
	*
	* @returns An array of all requests with their state ("outgoing" or "pending").
	*/ getRequests() {
        return [
            ...this.getOutgoingRequests().map((request)=>({
                    state: "outgoing",
                    message: request.message,
                    end: request.end,
                    callbacks: request.callbacks
                })),
            ...this.getPendingRequests().map((request)=>({
                    state: "pending",
                    message: request.message,
                    end: request.end,
                    callbacks: request.callbacks
                }))
        ];
    }
    /**
	* Checks if there are any pending requests, including ongoing subscriptions.
	*/ hasPendingRequests() {
        return this.getPendingRequests().length > 0;
    }
    /**
	* Checks if there are any pending subscriptions
	*/ hasPendingSubscriptions() {
        return this.getPendingRequests().some((request)=>request.message.method === "subscription");
    }
    /**
	* Checks if there are any outgoing requests waiting to be sent.
	*/ hasOutgoingRequests() {
        return this.outgoingRequests.length > 0;
    }
};
//#endregion
//#region src/links/wsLink/wsClient/wsConnection.ts
var $02abedc4de0635cb$var$import_defineProperty$1 = (0, $a6ELx.__toESM)((0, $a6ELx.require_defineProperty)(), 1);
/**
* Opens a WebSocket connection asynchronously and returns a promise
* that resolves when the connection is successfully established.
* The promise rejects if an error occurs during the connection attempt.
*/ function $02abedc4de0635cb$var$asyncWsOpen(ws) {
    const { promise: promise, resolve: resolve, reject: reject } = $02abedc4de0635cb$var$withResolvers();
    ws.addEventListener("open", ()=>{
        ws.removeEventListener("error", reject);
        resolve();
    });
    ws.addEventListener("error", reject);
    return promise;
}
/**
* Sets up a periodic ping-pong mechanism to keep the WebSocket connection alive.
*
* - Sends "PING" messages at regular intervals defined by `intervalMs`.
* - If a "PONG" response is not received within the `pongTimeoutMs`, the WebSocket is closed.
* - The ping timer resets upon receiving any message to maintain activity.
* - Automatically starts the ping process when the WebSocket connection is opened.
* - Cleans up timers when the WebSocket is closed.
*
* @param ws - The WebSocket instance to manage.
* @param options - Configuration options for ping-pong intervals and timeouts.
*/ function $02abedc4de0635cb$var$setupPingInterval(ws, { intervalMs: intervalMs, pongTimeoutMs: pongTimeoutMs }) {
    let pingTimeout;
    let pongTimeout;
    function start() {
        pingTimeout = setTimeout(()=>{
            ws.send("PING");
            pongTimeout = setTimeout(()=>{
                ws.close();
            }, pongTimeoutMs);
        }, intervalMs);
    }
    function reset() {
        clearTimeout(pingTimeout);
        start();
    }
    function pong() {
        clearTimeout(pongTimeout);
        reset();
    }
    ws.addEventListener("open", start);
    ws.addEventListener("message", ({ data: data })=>{
        clearTimeout(pingTimeout);
        start();
        if (data === "PONG") pong();
    });
    ws.addEventListener("close", ()=>{
        clearTimeout(pingTimeout);
        clearTimeout(pongTimeout);
    });
}
/**
* Manages a WebSocket connection with support for reconnection, keep-alive mechanisms,
* and observable state tracking.
*/ var $02abedc4de0635cb$var$WsConnection = class WsConnection {
    constructor(opts){
        var _opts$WebSocketPonyfi;
        (0, $02abedc4de0635cb$var$import_defineProperty$1.default)(this, "id", ++WsConnection.connectCount);
        (0, $02abedc4de0635cb$var$import_defineProperty$1.default)(this, "WebSocketPonyfill", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty$1.default)(this, "urlOptions", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty$1.default)(this, "keepAliveOpts", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty$1.default)(this, "wsObservable", (0, $lQFgY.behaviorSubject)(null));
        (0, $02abedc4de0635cb$var$import_defineProperty$1.default)(this, "openPromise", null);
        this.WebSocketPonyfill = (_opts$WebSocketPonyfi = opts.WebSocketPonyfill) !== null && _opts$WebSocketPonyfi !== void 0 ? _opts$WebSocketPonyfi : WebSocket;
        if (!this.WebSocketPonyfill) throw new Error("No WebSocket implementation found - you probably don't want to use this on the server, but if you do you need to pass a `WebSocket`-ponyfill");
        this.urlOptions = opts.urlOptions;
        this.keepAliveOpts = opts.keepAlive;
    }
    get ws() {
        return this.wsObservable.get();
    }
    set ws(ws) {
        this.wsObservable.next(ws);
    }
    /**
	* Checks if the WebSocket connection is open and ready to communicate.
	*/ isOpen() {
        return !!this.ws && this.ws.readyState === this.WebSocketPonyfill.OPEN && !this.openPromise;
    }
    /**
	* Checks if the WebSocket connection is closed or in the process of closing.
	*/ isClosed() {
        return !!this.ws && (this.ws.readyState === this.WebSocketPonyfill.CLOSING || this.ws.readyState === this.WebSocketPonyfill.CLOSED);
    }
    async open() {
        var _this = this;
        if (_this.openPromise) return _this.openPromise;
        _this.id = ++WsConnection.connectCount;
        const wsPromise = $02abedc4de0635cb$var$prepareUrl(_this.urlOptions).then((url)=>new _this.WebSocketPonyfill(url));
        _this.openPromise = wsPromise.then(async (ws)=>{
            _this.ws = ws;
            ws.addEventListener("message", function({ data: data }) {
                if (data === "PING") this.send("PONG");
            });
            if (_this.keepAliveOpts.enabled) $02abedc4de0635cb$var$setupPingInterval(ws, _this.keepAliveOpts);
            ws.addEventListener("close", ()=>{
                if (_this.ws === ws) _this.ws = null;
            });
            await $02abedc4de0635cb$var$asyncWsOpen(ws);
            if (_this.urlOptions.connectionParams) ws.send(await $02abedc4de0635cb$var$buildConnectionMessage(_this.urlOptions.connectionParams));
        });
        try {
            await _this.openPromise;
        } finally{
            _this.openPromise = null;
        }
    }
    /**
	* Closes the WebSocket connection gracefully.
	* Waits for any ongoing open operation to complete before closing.
	*/ async close() {
        var _this2 = this;
        try {
            await _this2.openPromise;
        } finally{
            var _this$ws;
            (_this$ws = _this2.ws) === null || _this$ws === void 0 || _this$ws.close();
        }
    }
};
(0, $02abedc4de0635cb$var$import_defineProperty$1.default)($02abedc4de0635cb$var$WsConnection, "connectCount", 0);
/**
* Provides a backward-compatible representation of the connection state.
*/ function $02abedc4de0635cb$var$backwardCompatibility(connection) {
    if (connection.isOpen()) return {
        id: connection.id,
        state: "open",
        ws: connection.ws
    };
    if (connection.isClosed()) return {
        id: connection.id,
        state: "closed",
        ws: connection.ws
    };
    if (!connection.ws) return null;
    return {
        id: connection.id,
        state: "connecting",
        ws: connection.ws
    };
}
//#endregion
//#region src/links/wsLink/wsClient/wsClient.ts
var $02abedc4de0635cb$var$import_defineProperty = (0, $a6ELx.__toESM)((0, $a6ELx.require_defineProperty)(), 1);
var $02abedc4de0635cb$var$import_objectSpread2 = (0, $a6ELx.__toESM)((0, $a6ELx.require_objectSpread2)(), 1);
/**
* A WebSocket client for managing TRPC operations, supporting lazy initialization,
* reconnection, keep-alive, and request management.
*/ var $02abedc4de0635cb$var$WsClient = class {
    constructor(opts){
        var _opts$retryDelayMs;
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "connectionState", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "allowReconnect", false);
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "requestManager", new $02abedc4de0635cb$var$RequestManager());
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "activeConnection", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "reconnectRetryDelay", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "inactivityTimeout", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "callbacks", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "lazyMode", void 0);
        (0, $02abedc4de0635cb$var$import_defineProperty.default)(this, "reconnecting", null);
        this.callbacks = {
            onOpen: opts.onOpen,
            onClose: opts.onClose,
            onError: opts.onError
        };
        const lazyOptions = (0, $02abedc4de0635cb$var$import_objectSpread2.default)((0, $02abedc4de0635cb$var$import_objectSpread2.default)({}, $02abedc4de0635cb$var$lazyDefaults), opts.lazy);
        this.inactivityTimeout = new $02abedc4de0635cb$var$ResettableTimeout(()=>{
            if (this.requestManager.hasOutgoingRequests() || this.requestManager.hasPendingRequests()) {
                this.inactivityTimeout.reset();
                return;
            }
            this.close().catch(()=>null);
        }, lazyOptions.closeMs);
        this.activeConnection = new $02abedc4de0635cb$var$WsConnection({
            WebSocketPonyfill: opts.WebSocket,
            urlOptions: opts,
            keepAlive: (0, $02abedc4de0635cb$var$import_objectSpread2.default)((0, $02abedc4de0635cb$var$import_objectSpread2.default)({}, $02abedc4de0635cb$var$keepAliveDefaults), opts.keepAlive)
        });
        this.activeConnection.wsObservable.subscribe({
            next: (ws)=>{
                if (!ws) return;
                this.setupWebSocketListeners(ws);
            }
        });
        this.reconnectRetryDelay = (_opts$retryDelayMs = opts.retryDelayMs) !== null && _opts$retryDelayMs !== void 0 ? _opts$retryDelayMs : $02abedc4de0635cb$var$exponentialBackoff;
        this.lazyMode = lazyOptions.enabled;
        this.connectionState = (0, $lQFgY.behaviorSubject)({
            type: "state",
            state: lazyOptions.enabled ? "idle" : "connecting",
            error: null
        });
        if (!this.lazyMode) this.open().catch(()=>null);
    }
    /**
	* Opens the WebSocket connection. Handles reconnection attempts and updates
	* the connection state accordingly.
	*/ async open() {
        var _this = this;
        _this.allowReconnect = true;
        if (_this.connectionState.get().state !== "connecting") _this.connectionState.next({
            type: "state",
            state: "connecting",
            error: null
        });
        try {
            await _this.activeConnection.open();
        } catch (error) {
            _this.reconnect(new $02abedc4de0635cb$var$TRPCWebSocketClosedError({
                message: "Initialization error",
                cause: error
            }));
            return _this.reconnecting;
        }
    }
    /**
	* Closes the WebSocket connection and stops managing requests.
	* Ensures all outgoing and pending requests are properly finalized.
	*/ async close() {
        var _this2 = this;
        _this2.allowReconnect = false;
        _this2.inactivityTimeout.stop();
        const requestsToAwait = [];
        for (const request of _this2.requestManager.getRequests())if (request.message.method === "subscription") request.callbacks.complete();
        else if (request.state === "outgoing") request.callbacks.error((0, $2J6qj.TRPCClientError).from(new $02abedc4de0635cb$var$TRPCWebSocketClosedError({
            message: "Closed before connection was established"
        })));
        else requestsToAwait.push(request.end);
        await Promise.all(requestsToAwait).catch(()=>null);
        await _this2.activeConnection.close().catch(()=>null);
        _this2.connectionState.next({
            type: "state",
            state: "idle",
            error: null
        });
    }
    /**
	* Method to request the server.
	* Handles data transformation, batching of requests, and subscription lifecycle.
	*
	* @param op - The operation details including id, type, path, input and signal
	* @param transformer - Data transformer for serializing requests and deserializing responses
	* @param lastEventId - Optional ID of the last received event for subscriptions
	*
	* @returns An observable that emits operation results and handles cleanup
	*/ request({ op: { id: id, type: type, path: path, input: input, signal: signal }, transformer: transformer, lastEventId: lastEventId }) {
        return (0, $c2p8A.observable)((observer)=>{
            const abort = this.batchSend({
                id: id,
                method: type,
                params: {
                    input: transformer.input.serialize(input),
                    path: path,
                    lastEventId: lastEventId
                }
            }, (0, $02abedc4de0635cb$var$import_objectSpread2.default)((0, $02abedc4de0635cb$var$import_objectSpread2.default)({}, observer), {}, {
                next (event) {
                    const transformed = (0, $8hhvi.transformResult)(event, transformer.output);
                    if (!transformed.ok) {
                        observer.error((0, $2J6qj.TRPCClientError).from(transformed.error));
                        return;
                    }
                    observer.next({
                        result: transformed.result
                    });
                }
            }));
            return ()=>{
                abort();
                if (type === "subscription" && this.activeConnection.isOpen()) this.send({
                    id: id,
                    method: "subscription.stop"
                });
                signal === null || signal === void 0 || signal.removeEventListener("abort", abort);
            };
        });
    }
    get connection() {
        return $02abedc4de0635cb$var$backwardCompatibility(this.activeConnection);
    }
    reconnect(closedError) {
        var _this3 = this;
        this.connectionState.next({
            type: "state",
            state: "connecting",
            error: (0, $2J6qj.TRPCClientError).from(closedError)
        });
        if (this.reconnecting) return;
        const tryReconnect = async (attemptIndex)=>{
            try {
                await (0, $6bgAm.sleep)(_this3.reconnectRetryDelay(attemptIndex));
                if (_this3.allowReconnect) {
                    await _this3.activeConnection.close();
                    await _this3.activeConnection.open();
                    if (_this3.requestManager.hasPendingRequests()) _this3.send(_this3.requestManager.getPendingRequests().map(({ message: message })=>message));
                }
                _this3.reconnecting = null;
            } catch (_unused) {
                await tryReconnect(attemptIndex + 1);
            }
        };
        this.reconnecting = tryReconnect(0);
    }
    setupWebSocketListeners(ws) {
        var _this4 = this;
        const handleCloseOrError = (cause)=>{
            const reqs = this.requestManager.getPendingRequests();
            for (const { message: message, callbacks: callbacks } of reqs){
                if (message.method === "subscription") continue;
                callbacks.error((0, $2J6qj.TRPCClientError).from(cause !== null && cause !== void 0 ? cause : new $02abedc4de0635cb$var$TRPCWebSocketClosedError({
                    message: "WebSocket closed",
                    cause: cause
                })));
                this.requestManager.delete(message.id);
            }
        };
        ws.addEventListener("open", ()=>{
            (0, $6bgAm.run)(async ()=>{
                var _this$callbacks$onOpe, _this$callbacks;
                if (_this4.lazyMode) _this4.inactivityTimeout.start();
                (_this$callbacks$onOpe = (_this$callbacks = _this4.callbacks).onOpen) === null || _this$callbacks$onOpe === void 0 || _this$callbacks$onOpe.call(_this$callbacks);
                _this4.connectionState.next({
                    type: "state",
                    state: "pending",
                    error: null
                });
            }).catch((error)=>{
                ws.close(3e3);
                handleCloseOrError(error);
            });
        });
        ws.addEventListener("message", ({ data: data })=>{
            this.inactivityTimeout.reset();
            if (typeof data !== "string" || [
                "PING",
                "PONG"
            ].includes(data)) return;
            const incomingMessage = JSON.parse(data);
            if ("method" in incomingMessage) {
                this.handleIncomingRequest(incomingMessage);
                return;
            }
            this.handleResponseMessage(incomingMessage);
        });
        ws.addEventListener("close", (event)=>{
            var _this$callbacks$onClo, _this$callbacks2;
            handleCloseOrError(event);
            (_this$callbacks$onClo = (_this$callbacks2 = this.callbacks).onClose) === null || _this$callbacks$onClo === void 0 || _this$callbacks$onClo.call(_this$callbacks2, event);
            if (!this.lazyMode || this.requestManager.hasPendingSubscriptions()) this.reconnect(new $02abedc4de0635cb$var$TRPCWebSocketClosedError({
                message: "WebSocket closed",
                cause: event
            }));
        });
        ws.addEventListener("error", (event)=>{
            var _this$callbacks$onErr, _this$callbacks3;
            handleCloseOrError(event);
            (_this$callbacks$onErr = (_this$callbacks3 = this.callbacks).onError) === null || _this$callbacks$onErr === void 0 || _this$callbacks$onErr.call(_this$callbacks3, event);
            this.reconnect(new $02abedc4de0635cb$var$TRPCWebSocketClosedError({
                message: "WebSocket closed",
                cause: event
            }));
        });
    }
    handleResponseMessage(message) {
        const request = this.requestManager.getPendingRequest(message.id);
        if (!request) return;
        request.callbacks.next(message);
        let completed = true;
        if ("result" in message && request.message.method === "subscription") {
            if (message.result.type === "data") request.message.params.lastEventId = message.result.id;
            if (message.result.type !== "stopped") completed = false;
        }
        if (completed) {
            request.callbacks.complete();
            this.requestManager.delete(message.id);
        }
    }
    handleIncomingRequest(message) {
        if (message.method === "reconnect") this.reconnect(new $02abedc4de0635cb$var$TRPCWebSocketClosedError({
            message: "Server requested reconnect"
        }));
    }
    /**
	* Sends a message or batch of messages directly to the server.
	*/ send(messageOrMessages) {
        if (!this.activeConnection.isOpen()) throw new Error("Active connection is not open");
        const messages = messageOrMessages instanceof Array ? messageOrMessages : [
            messageOrMessages
        ];
        this.activeConnection.ws.send(JSON.stringify(messages.length === 1 ? messages[0] : messages));
    }
    /**
	* Groups requests for batch sending.
	*
	* @returns A function to abort the batched request.
	*/ batchSend(message, callbacks) {
        var _this5 = this;
        this.inactivityTimeout.reset();
        (0, $6bgAm.run)(async ()=>{
            if (!_this5.activeConnection.isOpen()) await _this5.open();
            await (0, $6bgAm.sleep)(0);
            if (!_this5.requestManager.hasOutgoingRequests()) return;
            _this5.send(_this5.requestManager.flush().map(({ message: message$1 })=>message$1));
        }).catch((err)=>{
            this.requestManager.delete(message.id);
            callbacks.error((0, $2J6qj.TRPCClientError).from(err));
        });
        return this.requestManager.register(message, callbacks);
    }
};
//#endregion
//#region src/links/wsLink/createWsClient.ts
function $02abedc4de0635cb$export$345df463fed6e4eb(opts) {
    return new $02abedc4de0635cb$var$WsClient(opts);
}
//#endregion
//#region src/links/wsLink/wsLink.ts
function $02abedc4de0635cb$export$31d1274c8c32ef82(opts) {
    const { client: client } = opts;
    const transformer = (0, $fj8ND.getTransformer)(opts.transformer);
    return ()=>{
        return ({ op: op })=>{
            return (0, $c2p8A.observable)((observer)=>{
                const connStateSubscription = op.type === "subscription" ? client.connectionState.subscribe({
                    next (result) {
                        observer.next({
                            result: result,
                            context: op.context
                        });
                    }
                }) : null;
                const requestSubscription = client.request({
                    op: op,
                    transformer: transformer
                }).subscribe(observer);
                return ()=>{
                    requestSubscription.unsubscribe();
                    connStateSubscription === null || connStateSubscription === void 0 || connStateSubscription.unsubscribe();
                };
            });
        };
    };
}

});

parcelRegister("d09NT", function(module, exports) {

$parcel$export(module.exports, "isAbortError", function () { return $2e4200fd07666b61$export$d2c30ea522b3259e; });
$parcel$export(module.exports, "makeResource", function () { return $2e4200fd07666b61$export$d656de2b69647d7d; });
$parcel$export(module.exports, "iteratorResource", function () { return $2e4200fd07666b61$export$31af6aaecae75479; });
$parcel$export(module.exports, "jsonlStreamConsumer", function () { return $2e4200fd07666b61$export$cda9b7fa8d9fbf55; });
$parcel$export(module.exports, "sseStreamConsumer", function () { return $2e4200fd07666b61$export$892255ae5d6656c6; });

var $1h7sD = parcelRequire("1h7sD");

var $8hhvi = parcelRequire("8hhvi");

var $6bgAm = parcelRequire("6bgAm");

var $c2p8A = parcelRequire("c2p8A");
//#region src/unstable-core-do-not-import/http/parseConnectionParams.ts
function $2e4200fd07666b61$export$5c0a89bce3743bee(parsed) {
    try {
        if (parsed === null) return null;
        if (!(0, $6bgAm.isObject)(parsed)) throw new Error("Expected object");
        const nonStringValues = Object.entries(parsed).filter(([_key, value])=>typeof value !== "string");
        if (nonStringValues.length > 0) throw new Error(`Expected connectionParams to be string values. Got ${nonStringValues.map(([key, value])=>`${key}: ${typeof value}`).join(", ")}`);
        return parsed;
    } catch (cause) {
        throw new (0, $8hhvi.TRPCError)({
            code: "PARSE_ERROR",
            message: "Invalid connection params shape",
            cause: cause
        });
    }
}
function $2e4200fd07666b61$export$d511d0c821c1aba3(str) {
    let parsed;
    try {
        parsed = JSON.parse(str);
    } catch (cause) {
        throw new (0, $8hhvi.TRPCError)({
            code: "PARSE_ERROR",
            message: "Not JSON-parsable query params",
            cause: cause
        });
    }
    return $2e4200fd07666b61$export$5c0a89bce3743bee(parsed);
}
//#endregion
//#region src/unstable-core-do-not-import/http/contentType.ts
var $2e4200fd07666b61$var$import_objectSpread2$1 = (0, $1h7sD.__toESM)((0, $1h7sD.require_objectSpread2)(), 1);
/**
* Memoize a function that takes no arguments
* @internal
*/ function $2e4200fd07666b61$var$memo(fn) {
    let promise = null;
    const sym = Symbol.for("@trpc/server/http/memo");
    let value = sym;
    return {
        read: async ()=>{
            var _promise;
            if (value !== sym) return value;
            (_promise = promise) !== null && _promise !== void 0 || (promise = fn().catch((cause)=>{
                if (cause instanceof (0, $8hhvi.TRPCError)) throw cause;
                throw new (0, $8hhvi.TRPCError)({
                    code: "BAD_REQUEST",
                    message: cause instanceof Error ? cause.message : "Invalid input",
                    cause: cause
                });
            }));
            value = await promise;
            promise = null;
            return value;
        },
        result: ()=>{
            return value !== sym ? value : void 0;
        }
    };
}
const $2e4200fd07666b61$var$jsonContentTypeHandler = {
    isMatch (req) {
        var _req$headers$get;
        return !!((_req$headers$get = req.headers.get("content-type")) === null || _req$headers$get === void 0 ? void 0 : _req$headers$get.startsWith("application/json"));
    },
    async parse (opts) {
        var _types$values$next$va;
        const { req: req } = opts;
        const isBatchCall = opts.searchParams.get("batch") === "1";
        const paths = isBatchCall ? opts.path.split(",") : [
            opts.path
        ];
        const getInputs = $2e4200fd07666b61$var$memo(async ()=>{
            let inputs = void 0;
            if (req.method === "GET") {
                const queryInput = opts.searchParams.get("input");
                if (queryInput) inputs = JSON.parse(queryInput);
            } else inputs = await req.json();
            if (inputs === void 0) return {};
            if (!isBatchCall) return {
                0: opts.router._def._config.transformer.input.deserialize(inputs)
            };
            if (!(0, $6bgAm.isObject)(inputs)) throw new (0, $8hhvi.TRPCError)({
                code: "BAD_REQUEST",
                message: '"input" needs to be an object when doing a batch call'
            });
            const acc = {};
            for (const index of paths.keys()){
                const input = inputs[index];
                if (input !== void 0) acc[index] = opts.router._def._config.transformer.input.deserialize(input);
            }
            return acc;
        });
        const calls = await Promise.all(paths.map(async (path, index)=>{
            const procedure = await (0, $8hhvi.getProcedureAtPath)(opts.router, path);
            return {
                path: path,
                procedure: procedure,
                getRawInput: async ()=>{
                    const inputs = await getInputs.read();
                    let input = inputs[index];
                    if ((procedure === null || procedure === void 0 ? void 0 : procedure._def.type) === "subscription") {
                        var _ref, _opts$headers$get;
                        const lastEventId = (_ref = (_opts$headers$get = opts.headers.get("last-event-id")) !== null && _opts$headers$get !== void 0 ? _opts$headers$get : opts.searchParams.get("lastEventId")) !== null && _ref !== void 0 ? _ref : opts.searchParams.get("Last-Event-Id");
                        if (lastEventId) {
                            if ((0, $6bgAm.isObject)(input)) input = (0, $2e4200fd07666b61$var$import_objectSpread2$1.default)((0, $2e4200fd07666b61$var$import_objectSpread2$1.default)({}, input), {}, {
                                lastEventId: lastEventId
                            });
                            else {
                                var _input;
                                (_input = input) !== null && _input !== void 0 || (input = {
                                    lastEventId: lastEventId
                                });
                            }
                        }
                    }
                    return input;
                },
                result: ()=>{
                    var _getInputs$result;
                    return (_getInputs$result = getInputs.result()) === null || _getInputs$result === void 0 ? void 0 : _getInputs$result[index];
                }
            };
        }));
        const types = new Set(calls.map((call)=>{
            var _call$procedure;
            return (_call$procedure = call.procedure) === null || _call$procedure === void 0 ? void 0 : _call$procedure._def.type;
        }).filter(Boolean));
        /* istanbul ignore if -- @preserve */ if (types.size > 1) throw new (0, $8hhvi.TRPCError)({
            code: "BAD_REQUEST",
            message: `Cannot mix procedure types in call: ${Array.from(types).join(", ")}`
        });
        const type = (_types$values$next$va = types.values().next().value) !== null && _types$values$next$va !== void 0 ? _types$values$next$va : "unknown";
        const connectionParamsStr = opts.searchParams.get("connectionParams");
        const info = {
            isBatchCall: isBatchCall,
            accept: req.headers.get("trpc-accept"),
            calls: calls,
            type: type,
            connectionParams: connectionParamsStr === null ? null : $2e4200fd07666b61$export$d511d0c821c1aba3(connectionParamsStr),
            signal: req.signal,
            url: opts.url
        };
        return info;
    }
};
const $2e4200fd07666b61$var$formDataContentTypeHandler = {
    isMatch (req) {
        var _req$headers$get2;
        return !!((_req$headers$get2 = req.headers.get("content-type")) === null || _req$headers$get2 === void 0 ? void 0 : _req$headers$get2.startsWith("multipart/form-data"));
    },
    async parse (opts) {
        const { req: req } = opts;
        if (req.method !== "POST") throw new (0, $8hhvi.TRPCError)({
            code: "METHOD_NOT_SUPPORTED",
            message: "Only POST requests are supported for multipart/form-data requests"
        });
        const getInputs = $2e4200fd07666b61$var$memo(async ()=>{
            const fd = await req.formData();
            return fd;
        });
        const procedure = await (0, $8hhvi.getProcedureAtPath)(opts.router, opts.path);
        return {
            accept: null,
            calls: [
                {
                    path: opts.path,
                    getRawInput: getInputs.read,
                    result: getInputs.result,
                    procedure: procedure
                }
            ],
            isBatchCall: false,
            type: "mutation",
            connectionParams: null,
            signal: req.signal,
            url: opts.url
        };
    }
};
const $2e4200fd07666b61$var$octetStreamContentTypeHandler = {
    isMatch (req) {
        var _req$headers$get3;
        return !!((_req$headers$get3 = req.headers.get("content-type")) === null || _req$headers$get3 === void 0 ? void 0 : _req$headers$get3.startsWith("application/octet-stream"));
    },
    async parse (opts) {
        const { req: req } = opts;
        if (req.method !== "POST") throw new (0, $8hhvi.TRPCError)({
            code: "METHOD_NOT_SUPPORTED",
            message: "Only POST requests are supported for application/octet-stream requests"
        });
        const getInputs = $2e4200fd07666b61$var$memo(async ()=>{
            return req.body;
        });
        return {
            calls: [
                {
                    path: opts.path,
                    getRawInput: getInputs.read,
                    result: getInputs.result,
                    procedure: await (0, $8hhvi.getProcedureAtPath)(opts.router, opts.path)
                }
            ],
            isBatchCall: false,
            accept: null,
            type: "mutation",
            connectionParams: null,
            signal: req.signal,
            url: opts.url
        };
    }
};
const $2e4200fd07666b61$var$handlers = [
    $2e4200fd07666b61$var$jsonContentTypeHandler,
    $2e4200fd07666b61$var$formDataContentTypeHandler,
    $2e4200fd07666b61$var$octetStreamContentTypeHandler
];
function $2e4200fd07666b61$var$getContentTypeHandler(req) {
    const handler = $2e4200fd07666b61$var$handlers.find((handler$1)=>handler$1.isMatch(req));
    if (handler) return handler;
    if (!handler && req.method === "GET") return $2e4200fd07666b61$var$jsonContentTypeHandler;
    throw new (0, $8hhvi.TRPCError)({
        code: "UNSUPPORTED_MEDIA_TYPE",
        message: req.headers.has("content-type") ? `Unsupported content-type "${req.headers.get("content-type")}` : "Missing content-type header"
    });
}
async function $2e4200fd07666b61$export$a6b910f7a3808ee3(opts) {
    const handler = $2e4200fd07666b61$var$getContentTypeHandler(opts.req);
    return await handler.parse(opts);
}
//#endregion
//#region src/unstable-core-do-not-import/http/abortError.ts
function $2e4200fd07666b61$export$d2c30ea522b3259e(error) {
    return (0, $6bgAm.isObject)(error) && error["name"] === "AbortError";
}
function $2e4200fd07666b61$export$c0630ace8f564330(message = "AbortError") {
    throw new DOMException(message, "AbortError");
}
//#endregion
//#region src/vendor/unpromise/unpromise.ts
var $2e4200fd07666b61$var$import_defineProperty = (0, $1h7sD.__toESM)((0, $1h7sD.require_defineProperty)(), 1);
let $2e4200fd07666b61$var$_Symbol$toStringTag;
/** Memory safe (weakmapped) cache of the ProxyPromise for each Promise,
* which is retained for the lifetime of the original Promise.
*/ const $2e4200fd07666b61$var$subscribableCache = /* @__PURE__ */ new WeakMap();
/** A NOOP function allowing a consistent interface for settled
* SubscribedPromises (settled promises are not subscribed - they resolve
* immediately). */ const $2e4200fd07666b61$var$NOOP = ()=>{};
$2e4200fd07666b61$var$_Symbol$toStringTag = Symbol.toStringTag;
/**
* Every `Promise<T>` can be shadowed by a single `ProxyPromise<T>`. It is
* created once, cached and reused throughout the lifetime of the Promise. Get a
* Promise's ProxyPromise using `Unpromise.proxy(promise)`.
*
* The `ProxyPromise<T>` attaches handlers to the original `Promise<T>`
* `.then()` and `.catch()` just once. Promises derived from it use a
* subscription- (and unsubscription-) based mechanism that monitors these
* handlers.
*
* Every time you call `.subscribe()`, `.then()` `.catch()` or `.finally()` on a
* `ProxyPromise<T>` it returns a `SubscribedPromise<T>` having an additional
* `unsubscribe()` method. Calling `unsubscribe()` detaches reference chains
* from the original, potentially long-lived Promise, eliminating memory leaks.
*
* This approach can eliminate the memory leaks that otherwise come about from
* repeated `race()` or `any()` calls invoking `.then()` and `.catch()` multiple
* times on the same long-lived native Promise (subscriptions which can never be
* cleaned up).
*
* `Unpromise.race(promises)` is a reference implementation of `Promise.race`
* avoiding memory leaks when using long-lived unsettled Promises.
*
* `Unpromise.any(promises)` is a reference implementation of `Promise.any`
* avoiding memory leaks when using long-lived unsettled Promises.
*
* `Unpromise.resolve(promise)` returns an ephemeral `SubscribedPromise<T>` for
* any given `Promise<T>` facilitating arbitrary async/await patterns. Behind
* the scenes, `resolve` is implemented simply as
* `Unpromise.proxy(promise).subscribe()`. Don't forget to call `.unsubscribe()`
* to tidy up!
*
*/ var $2e4200fd07666b61$export$cebb049a33434478 = class Unpromise {
    constructor(arg){
        (0, $2e4200fd07666b61$var$import_defineProperty.default)(this, "promise", void 0);
        (0, $2e4200fd07666b61$var$import_defineProperty.default)(this, "subscribers", []);
        (0, $2e4200fd07666b61$var$import_defineProperty.default)(this, "settlement", null);
        (0, $2e4200fd07666b61$var$import_defineProperty.default)(this, $2e4200fd07666b61$var$_Symbol$toStringTag, "Unpromise");
        if (typeof arg === "function") this.promise = new Promise(arg);
        else this.promise = arg;
        const thenReturn = this.promise.then((value)=>{
            const { subscribers: subscribers } = this;
            this.subscribers = null;
            this.settlement = {
                status: "fulfilled",
                value: value
            };
            subscribers === null || subscribers === void 0 || subscribers.forEach(({ resolve: resolve })=>{
                resolve(value);
            });
        });
        if ("catch" in thenReturn) thenReturn.catch((reason)=>{
            const { subscribers: subscribers } = this;
            this.subscribers = null;
            this.settlement = {
                status: "rejected",
                reason: reason
            };
            subscribers === null || subscribers === void 0 || subscribers.forEach(({ reject: reject })=>{
                reject(reason);
            });
        });
    }
    /** Create a promise that mitigates uncontrolled subscription to a long-lived
	* Promise via .then() and .catch() - otherwise a source of memory leaks.
	*
	* The returned promise has an `unsubscribe()` method which can be called when
	* the Promise is no longer being tracked by application logic, and which
	* ensures that there is no reference chain from the original promise to the
	* new one, and therefore no memory leak.
	*
	* If original promise has not yet settled, this adds a new unique promise
	* that listens to then/catch events, along with an `unsubscribe()` method to
	* detach it.
	*
	* If original promise has settled, then creates a new Promise.resolve() or
	* Promise.reject() and provided unsubscribe is a noop.
	*
	* If you call `unsubscribe()` before the returned Promise has settled, it
	* will never settle.
	*/ subscribe() {
        let promise;
        let unsubscribe;
        const { settlement: settlement } = this;
        if (settlement === null) {
            if (this.subscribers === null) throw new Error("Unpromise settled but still has subscribers");
            const subscriber = $2e4200fd07666b61$var$withResolvers();
            this.subscribers = $2e4200fd07666b61$var$listWithMember(this.subscribers, subscriber);
            promise = subscriber.promise;
            unsubscribe = ()=>{
                if (this.subscribers !== null) this.subscribers = $2e4200fd07666b61$var$listWithoutMember(this.subscribers, subscriber);
            };
        } else {
            const { status: status } = settlement;
            if (status === "fulfilled") promise = Promise.resolve(settlement.value);
            else promise = Promise.reject(settlement.reason);
            unsubscribe = $2e4200fd07666b61$var$NOOP;
        }
        return Object.assign(promise, {
            unsubscribe: unsubscribe
        });
    }
    /** STANDARD PROMISE METHODS (but returning a SubscribedPromise) */ then(onfulfilled, onrejected) {
        const subscribed = this.subscribe();
        const { unsubscribe: unsubscribe } = subscribed;
        return Object.assign(subscribed.then(onfulfilled, onrejected), {
            unsubscribe: unsubscribe
        });
    }
    catch(onrejected) {
        const subscribed = this.subscribe();
        const { unsubscribe: unsubscribe } = subscribed;
        return Object.assign(subscribed.catch(onrejected), {
            unsubscribe: unsubscribe
        });
    }
    finally(onfinally) {
        const subscribed = this.subscribe();
        const { unsubscribe: unsubscribe } = subscribed;
        return Object.assign(subscribed.finally(onfinally), {
            unsubscribe: unsubscribe
        });
    }
    /** Unpromise STATIC METHODS */ /** Create or Retrieve the proxy Unpromise (a re-used Unpromise for the VM lifetime
	* of the provided Promise reference) */ static proxy(promise) {
        const cached = Unpromise.getSubscribablePromise(promise);
        return typeof cached !== "undefined" ? cached : Unpromise.createSubscribablePromise(promise);
    }
    /** Create and store an Unpromise keyed by an original Promise. */ static createSubscribablePromise(promise) {
        const created = new Unpromise(promise);
        $2e4200fd07666b61$var$subscribableCache.set(promise, created);
        $2e4200fd07666b61$var$subscribableCache.set(created, created);
        return created;
    }
    /** Retrieve a previously-created Unpromise keyed by an original Promise. */ static getSubscribablePromise(promise) {
        return $2e4200fd07666b61$var$subscribableCache.get(promise);
    }
    /** Promise STATIC METHODS */ /** Lookup the Unpromise for this promise, and derive a SubscribedPromise from
	* it (that can be later unsubscribed to eliminate Memory leaks) */ static resolve(value) {
        const promise = typeof value === "object" && value !== null && "then" in value && typeof value.then === "function" ? value : Promise.resolve(value);
        return Unpromise.proxy(promise).subscribe();
    }
    static async any(values) {
        const valuesArray = Array.isArray(values) ? values : [
            ...values
        ];
        const subscribedPromises = valuesArray.map(Unpromise.resolve);
        try {
            return await Promise.any(subscribedPromises);
        } finally{
            subscribedPromises.forEach(({ unsubscribe: unsubscribe })=>{
                unsubscribe();
            });
        }
    }
    static async race(values) {
        const valuesArray = Array.isArray(values) ? values : [
            ...values
        ];
        const subscribedPromises = valuesArray.map(Unpromise.resolve);
        try {
            return await Promise.race(subscribedPromises);
        } finally{
            subscribedPromises.forEach(({ unsubscribe: unsubscribe })=>{
                unsubscribe();
            });
        }
    }
    /** Create a race of SubscribedPromises that will fulfil to a single winning
	* Promise (in a 1-Tuple). Eliminates memory leaks from long-lived promises
	* accumulating .then() and .catch() subscribers. Allows simple logic to
	* consume the result, like...
	* ```ts
	* const [ winner ] = await Unpromise.race([ promiseA, promiseB ]);
	* if(winner === promiseB){
	*   const result = await promiseB;
	*   // do the thing
	* }
	* ```
	* */ static async raceReferences(promises) {
        const selfPromises = promises.map($2e4200fd07666b61$var$resolveSelfTuple);
        try {
            return await Promise.race(selfPromises);
        } finally{
            for (const promise of selfPromises)promise.unsubscribe();
        }
    }
};
/** Promises a 1-tuple containing the original promise when it resolves. Allows
* awaiting the eventual Promise ***reference*** (easy to destructure and
* exactly compare with ===). Avoids resolving to the Promise ***value*** (which
* may be ambiguous and therefore hard to identify as the winner of a race).
* You can call unsubscribe on the Promise to mitigate memory leaks.
* */ function $2e4200fd07666b61$var$resolveSelfTuple(promise) {
    return $2e4200fd07666b61$export$cebb049a33434478.proxy(promise).then(()=>[
            promise
        ]);
}
/** VENDORED (Future) PROMISE UTILITIES */ /** Reference implementation of https://github.com/tc39/proposal-promise-with-resolvers */ function $2e4200fd07666b61$var$withResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
/** IMMUTABLE LIST OPERATIONS */ function $2e4200fd07666b61$var$listWithMember(arr, member) {
    return [
        ...arr,
        member
    ];
}
function $2e4200fd07666b61$var$listWithoutIndex(arr, index) {
    return [
        ...arr.slice(0, index),
        ...arr.slice(index + 1)
    ];
}
function $2e4200fd07666b61$var$listWithoutMember(arr, member) {
    const index = arr.indexOf(member);
    if (index !== -1) return $2e4200fd07666b61$var$listWithoutIndex(arr, index);
    return arr;
}
//#endregion
//#region src/unstable-core-do-not-import/stream/utils/disposable.ts
var $2e4200fd07666b61$var$_Symbol, $2e4200fd07666b61$var$_Symbol$dispose, $2e4200fd07666b61$var$_Symbol2, $2e4200fd07666b61$var$_Symbol2$asyncDispose;
($2e4200fd07666b61$var$_Symbol$dispose = ($2e4200fd07666b61$var$_Symbol = Symbol).dispose) !== null && $2e4200fd07666b61$var$_Symbol$dispose !== void 0 || ($2e4200fd07666b61$var$_Symbol.dispose = Symbol());
($2e4200fd07666b61$var$_Symbol2$asyncDispose = ($2e4200fd07666b61$var$_Symbol2 = Symbol).asyncDispose) !== null && $2e4200fd07666b61$var$_Symbol2$asyncDispose !== void 0 || ($2e4200fd07666b61$var$_Symbol2.asyncDispose = Symbol());
/**
* Takes a value and a dispose function and returns a new object that implements the Disposable interface.
* The returned object is the original value augmented with a Symbol.dispose method.
* @param thing The value to make disposable
* @param dispose Function to call when disposing the resource
* @returns The original value with Symbol.dispose method added
*/ function $2e4200fd07666b61$export$d656de2b69647d7d(thing, dispose) {
    const it = thing;
    const existing = it[Symbol.dispose];
    it[Symbol.dispose] = ()=>{
        dispose();
        existing === null || existing === void 0 || existing();
    };
    return it;
}
/**
* Takes a value and an async dispose function and returns a new object that implements the AsyncDisposable interface.
* The returned object is the original value augmented with a Symbol.asyncDispose method.
* @param thing The value to make async disposable
* @param dispose Async function to call when disposing the resource
* @returns The original value with Symbol.asyncDispose method added
*/ function $2e4200fd07666b61$export$8eea18d870642d59(thing, dispose) {
    const it = thing;
    const existing = it[Symbol.asyncDispose];
    it[Symbol.asyncDispose] = async ()=>{
        await dispose();
        await (existing === null || existing === void 0 ? void 0 : existing());
    };
    return it;
}
//#endregion
//#region src/unstable-core-do-not-import/stream/utils/timerResource.ts
const $2e4200fd07666b61$var$disposablePromiseTimerResult = Symbol();
function $2e4200fd07666b61$var$timerResource(ms) {
    let timer = null;
    return $2e4200fd07666b61$export$d656de2b69647d7d({
        start () {
            if (timer) throw new Error("Timer already started");
            const promise = new Promise((resolve)=>{
                timer = setTimeout(()=>resolve($2e4200fd07666b61$var$disposablePromiseTimerResult), ms);
            });
            return promise;
        }
    }, ()=>{
        if (timer) clearTimeout(timer);
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/usingCtx.js
var $2e4200fd07666b61$export$c8fafa628198d7df = (0, $1h7sD.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/usingCtx.js" (exports, module) {
        function _usingCtx() {
            var r = "function" == typeof SuppressedError ? SuppressedError : function(r$1, e$1) {
                var n$1 = Error();
                return n$1.name = "SuppressedError", n$1.error = r$1, n$1.suppressed = e$1, n$1;
            }, e = {}, n = [];
            function using(r$1, e$1) {
                if (null != e$1) {
                    if (Object(e$1) !== e$1) throw new TypeError("using declarations can only be used with objects, functions, null, or undefined.");
                    if (r$1) var o = e$1[Symbol.asyncDispose || Symbol["for"]("Symbol.asyncDispose")];
                    if (void 0 === o && (o = e$1[Symbol.dispose || Symbol["for"]("Symbol.dispose")], r$1)) var t = o;
                    if ("function" != typeof o) throw new TypeError("Object is not disposable.");
                    t && (o = function o$1() {
                        try {
                            t.call(e$1);
                        } catch (r$2) {
                            return Promise.reject(r$2);
                        }
                    }), n.push({
                        v: e$1,
                        d: o,
                        a: r$1
                    });
                } else r$1 && n.push({
                    d: e$1,
                    a: r$1
                });
                return e$1;
            }
            return {
                e: e,
                u: using.bind(null, !1),
                a: using.bind(null, !0),
                d: function d() {
                    var o, t = this.e, s = 0;
                    function next() {
                        for(; o = n.pop();)try {
                            if (!o.a && 1 === s) return s = 0, n.push(o), Promise.resolve().then(next);
                            if (o.d) {
                                var r$1 = o.d.call(o.v);
                                if (o.a) return s |= 2, Promise.resolve(r$1).then(next, err);
                            } else s |= 1;
                        } catch (r$2) {
                            return err(r$2);
                        }
                        if (1 === s) return t !== e ? Promise.reject(t) : Promise.resolve();
                        if (t !== e) throw t;
                    }
                    function err(n$1) {
                        return t = t !== e ? new r(n$1, t) : n$1, next();
                    }
                    return next();
                }
            };
        }
        module.exports = _usingCtx, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/OverloadYield.js
var $2e4200fd07666b61$var$require_OverloadYield = (0, $1h7sD.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/OverloadYield.js" (exports, module) {
        function _OverloadYield(e, d) {
            this.v = e, this.k = d;
        }
        module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/awaitAsyncGenerator.js
var $2e4200fd07666b61$var$require_awaitAsyncGenerator = (0, $1h7sD.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/awaitAsyncGenerator.js" (exports, module) {
        var OverloadYield$2 = $2e4200fd07666b61$var$require_OverloadYield();
        function _awaitAsyncGenerator$5(e) {
            return new OverloadYield$2(e, 0);
        }
        module.exports = _awaitAsyncGenerator$5, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/wrapAsyncGenerator.js
var $2e4200fd07666b61$var$require_wrapAsyncGenerator = (0, $1h7sD.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/wrapAsyncGenerator.js" (exports, module) {
        var OverloadYield$1 = $2e4200fd07666b61$var$require_OverloadYield();
        function _wrapAsyncGenerator$6(e) {
            return function() {
                return new AsyncGenerator(e.apply(this, arguments));
            };
        }
        function AsyncGenerator(e) {
            var r, t;
            function resume(r$1, t$1) {
                try {
                    var n = e[r$1](t$1), o = n.value, u = o instanceof OverloadYield$1;
                    Promise.resolve(u ? o.v : o).then(function(t$2) {
                        if (u) {
                            var i = "return" === r$1 ? "return" : "next";
                            if (!o.k || t$2.done) return resume(i, t$2);
                            t$2 = e[i](t$2).value;
                        }
                        settle(n.done ? "return" : "normal", t$2);
                    }, function(e$1) {
                        resume("throw", e$1);
                    });
                } catch (e$1) {
                    settle("throw", e$1);
                }
            }
            function settle(e$1, n) {
                switch(e$1){
                    case "return":
                        r.resolve({
                            value: n,
                            done: !0
                        });
                        break;
                    case "throw":
                        r.reject(n);
                        break;
                    default:
                        r.resolve({
                            value: n,
                            done: !1
                        });
                }
                (r = r.next) ? resume(r.key, r.arg) : t = null;
            }
            this._invoke = function(e$1, n) {
                return new Promise(function(o, u) {
                    var i = {
                        key: e$1,
                        arg: n,
                        resolve: o,
                        reject: u,
                        next: null
                    };
                    t ? t = t.next = i : (r = t = i, resume(e$1, n));
                });
            }, "function" != typeof e["return"] && (this["return"] = void 0);
        }
        AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
            return this;
        }, AsyncGenerator.prototype.next = function(e) {
            return this._invoke("next", e);
        }, AsyncGenerator.prototype["throw"] = function(e) {
            return this._invoke("throw", e);
        }, AsyncGenerator.prototype["return"] = function(e) {
            return this._invoke("return", e);
        };
        module.exports = _wrapAsyncGenerator$6, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region src/unstable-core-do-not-import/stream/utils/asyncIterable.ts
var $2e4200fd07666b61$var$import_usingCtx$4 = (0, $1h7sD.__toESM)($2e4200fd07666b61$export$c8fafa628198d7df(), 1);
var $2e4200fd07666b61$var$import_awaitAsyncGenerator$4 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_awaitAsyncGenerator(), 1);
var $2e4200fd07666b61$var$import_wrapAsyncGenerator$5 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_wrapAsyncGenerator(), 1);
function $2e4200fd07666b61$export$31af6aaecae75479(iterable) {
    const iterator = iterable[Symbol.asyncIterator]();
    if (iterator[Symbol.asyncDispose]) return iterator;
    return $2e4200fd07666b61$export$8eea18d870642d59(iterator, async ()=>{
        var _iterator$return;
        await ((_iterator$return = iterator.return) === null || _iterator$return === void 0 ? void 0 : _iterator$return.call(iterator));
    });
}
/**
* Derives a new {@link AsyncGenerator} based on {@link iterable}, that automatically aborts after the specified duration.
*/ function $2e4200fd07666b61$export$142d74197e6b4718(_x, _x2) {
    return $2e4200fd07666b61$var$_withMaxDuration.apply(this, arguments);
}
function $2e4200fd07666b61$var$_withMaxDuration() {
    $2e4200fd07666b61$var$_withMaxDuration = (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$5.default)(function*(iterable, opts) {
        try {
            var _usingCtx$1 = (0, $2e4200fd07666b61$var$import_usingCtx$4.default)();
            const iterator = _usingCtx$1.a($2e4200fd07666b61$export$31af6aaecae75479(iterable));
            const timer = _usingCtx$1.u($2e4200fd07666b61$var$timerResource(opts.maxDurationMs));
            const timerPromise = timer.start();
            let result;
            while(true){
                result = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$4.default)($2e4200fd07666b61$export$cebb049a33434478.race([
                    iterator.next(),
                    timerPromise
                ]));
                if (result === $2e4200fd07666b61$var$disposablePromiseTimerResult) $2e4200fd07666b61$export$c0630ace8f564330();
                if (result.done) return result;
                yield result.value;
                result = null;
            }
        } catch (_) {
            _usingCtx$1.e = _;
        } finally{
            yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$4.default)(_usingCtx$1.d());
        }
    });
    return $2e4200fd07666b61$var$_withMaxDuration.apply(this, arguments);
}
/**
* Derives a new {@link AsyncGenerator} based of {@link iterable}, that yields its first
* {@link count} values. Then, a grace period of {@link gracePeriodMs} is started in which further
* values may still come through. After this period, the generator aborts.
*/ function $2e4200fd07666b61$export$d12b460caff1e2b6(_x3, _x4) {
    return $2e4200fd07666b61$var$_takeWithGrace.apply(this, arguments);
}
function $2e4200fd07666b61$var$_takeWithGrace() {
    $2e4200fd07666b61$var$_takeWithGrace = (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$5.default)(function*(iterable, opts) {
        try {
            var _usingCtx3 = (0, $2e4200fd07666b61$var$import_usingCtx$4.default)();
            const iterator = _usingCtx3.a($2e4200fd07666b61$export$31af6aaecae75479(iterable));
            let result;
            const timer = _usingCtx3.u($2e4200fd07666b61$var$timerResource(opts.gracePeriodMs));
            let count = opts.count;
            let timerPromise = new Promise(()=>{});
            while(true){
                result = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$4.default)($2e4200fd07666b61$export$cebb049a33434478.race([
                    iterator.next(),
                    timerPromise
                ]));
                if (result === $2e4200fd07666b61$var$disposablePromiseTimerResult) $2e4200fd07666b61$export$c0630ace8f564330();
                if (result.done) return result.value;
                yield result.value;
                if (--count === 0) timerPromise = timer.start();
                result = null;
            }
        } catch (_) {
            _usingCtx3.e = _;
        } finally{
            yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$4.default)(_usingCtx3.d());
        }
    });
    return $2e4200fd07666b61$var$_takeWithGrace.apply(this, arguments);
}
//#endregion
//#region src/unstable-core-do-not-import/stream/utils/createDeferred.ts
function $2e4200fd07666b61$export$e673efccd97e4223() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
//#endregion
//#region src/unstable-core-do-not-import/stream/utils/mergeAsyncIterables.ts
var $2e4200fd07666b61$var$import_usingCtx$3 = (0, $1h7sD.__toESM)($2e4200fd07666b61$export$c8fafa628198d7df(), 1);
var $2e4200fd07666b61$var$import_awaitAsyncGenerator$3 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_awaitAsyncGenerator(), 1);
var $2e4200fd07666b61$var$import_wrapAsyncGenerator$4 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_wrapAsyncGenerator(), 1);
function $2e4200fd07666b61$var$createManagedIterator(iterable, onResult) {
    const iterator = iterable[Symbol.asyncIterator]();
    let state = "idle";
    function cleanup() {
        state = "done";
        onResult = ()=>{};
    }
    function pull() {
        if (state !== "idle") return;
        state = "pending";
        const next = iterator.next();
        next.then((result)=>{
            if (result.done) {
                state = "done";
                onResult({
                    status: "return",
                    value: result.value
                });
                cleanup();
                return;
            }
            state = "idle";
            onResult({
                status: "yield",
                value: result.value
            });
        }).catch((cause)=>{
            onResult({
                status: "error",
                error: cause
            });
            cleanup();
        });
    }
    return {
        pull: pull,
        destroy: async ()=>{
            var _iterator$return;
            cleanup();
            await ((_iterator$return = iterator.return) === null || _iterator$return === void 0 ? void 0 : _iterator$return.call(iterator));
        }
    };
}
/**
* Creates a new async iterable that merges multiple async iterables into a single stream.
* Values from the input iterables are yielded in the order they resolve, similar to Promise.race().
*
* New iterables can be added dynamically using the returned {@link MergedAsyncIterables.add} method, even after iteration has started.
*
* If any of the input iterables throws an error, that error will be propagated through the merged stream.
* Other iterables will not continue to be processed.
*
* @template TYield The type of values yielded by the input iterables
*/ function $2e4200fd07666b61$var$mergeAsyncIterables() {
    let state = "idle";
    let flushSignal = $2e4200fd07666b61$export$e673efccd97e4223();
    /**
	* used while {@link state} is `idle`
	*/ const iterables = [];
    /**
	* used while {@link state} is `pending`
	*/ const iterators = /* @__PURE__ */ new Set();
    const buffer = [];
    function initIterable(iterable) {
        if (state !== "pending") return;
        const iterator = $2e4200fd07666b61$var$createManagedIterator(iterable, (result)=>{
            if (state !== "pending") return;
            switch(result.status){
                case "yield":
                    buffer.push([
                        iterator,
                        result
                    ]);
                    break;
                case "return":
                    iterators.delete(iterator);
                    break;
                case "error":
                    buffer.push([
                        iterator,
                        result
                    ]);
                    iterators.delete(iterator);
                    break;
            }
            flushSignal.resolve();
        });
        iterators.add(iterator);
        iterator.pull();
    }
    return {
        add (iterable) {
            switch(state){
                case "idle":
                    iterables.push(iterable);
                    break;
                case "pending":
                    initIterable(iterable);
                    break;
                case "done":
                    break;
            }
        },
        [Symbol.asyncIterator] () {
            return (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$4.default)(function*() {
                try {
                    var _usingCtx$1 = (0, $2e4200fd07666b61$var$import_usingCtx$3.default)();
                    if (state !== "idle") throw new Error("Cannot iterate twice");
                    state = "pending";
                    const _finally = _usingCtx$1.a($2e4200fd07666b61$export$8eea18d870642d59({}, async ()=>{
                        state = "done";
                        const errors = [];
                        await Promise.all(Array.from(iterators.values()).map(async (it)=>{
                            try {
                                await it.destroy();
                            } catch (cause) {
                                errors.push(cause);
                            }
                        }));
                        buffer.length = 0;
                        iterators.clear();
                        flushSignal.resolve();
                        if (errors.length > 0) throw new AggregateError(errors);
                    }));
                    while(iterables.length > 0)initIterable(iterables.shift());
                    while(iterators.size > 0){
                        yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$3.default)(flushSignal.promise);
                        while(buffer.length > 0){
                            const [iterator, result] = buffer.shift();
                            switch(result.status){
                                case "yield":
                                    yield result.value;
                                    iterator.pull();
                                    break;
                                case "error":
                                    throw result.error;
                            }
                        }
                        flushSignal = $2e4200fd07666b61$export$e673efccd97e4223();
                    }
                } catch (_) {
                    _usingCtx$1.e = _;
                } finally{
                    yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$3.default)(_usingCtx$1.d());
                }
            })();
        }
    };
}
//#endregion
//#region src/unstable-core-do-not-import/stream/utils/readableStreamFrom.ts
/**
* Creates a ReadableStream from an AsyncIterable.
*
* @param iterable - The source AsyncIterable to stream from
* @returns A ReadableStream that yields values from the AsyncIterable
*/ function $2e4200fd07666b61$var$readableStreamFrom(iterable) {
    const iterator = iterable[Symbol.asyncIterator]();
    return new ReadableStream({
        async cancel () {
            var _iterator$return;
            await ((_iterator$return = iterator.return) === null || _iterator$return === void 0 ? void 0 : _iterator$return.call(iterator));
        },
        async pull (controller) {
            const result = await iterator.next();
            if (result.done) {
                controller.close();
                return;
            }
            controller.enqueue(result.value);
        }
    });
}
//#endregion
//#region src/unstable-core-do-not-import/stream/utils/withPing.ts
var $2e4200fd07666b61$var$import_usingCtx$2 = (0, $1h7sD.__toESM)($2e4200fd07666b61$export$c8fafa628198d7df(), 1);
var $2e4200fd07666b61$var$import_awaitAsyncGenerator$2 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_awaitAsyncGenerator(), 1);
var $2e4200fd07666b61$var$import_wrapAsyncGenerator$3 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_wrapAsyncGenerator(), 1);
const $2e4200fd07666b61$var$PING_SYM = Symbol("ping");
/**
* Derives a new {@link AsyncGenerator} based of {@link iterable}, that yields {@link PING_SYM}
* whenever no value has been yielded for {@link pingIntervalMs}.
*/ function $2e4200fd07666b61$var$withPing(_x, _x2) {
    return $2e4200fd07666b61$var$_withPing.apply(this, arguments);
}
function $2e4200fd07666b61$var$_withPing() {
    $2e4200fd07666b61$var$_withPing = (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$3.default)(function*(iterable, pingIntervalMs) {
        try {
            var _usingCtx$1 = (0, $2e4200fd07666b61$var$import_usingCtx$2.default)();
            const iterator = _usingCtx$1.a($2e4200fd07666b61$export$31af6aaecae75479(iterable));
            let result;
            let nextPromise = iterator.next();
            while(true)try {
                var _usingCtx3 = (0, $2e4200fd07666b61$var$import_usingCtx$2.default)();
                const pingPromise = _usingCtx3.u($2e4200fd07666b61$var$timerResource(pingIntervalMs));
                result = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$2.default)($2e4200fd07666b61$export$cebb049a33434478.race([
                    nextPromise,
                    pingPromise.start()
                ]));
                if (result === $2e4200fd07666b61$var$disposablePromiseTimerResult) {
                    yield $2e4200fd07666b61$var$PING_SYM;
                    continue;
                }
                if (result.done) return result.value;
                nextPromise = iterator.next();
                yield result.value;
                result = null;
            } catch (_) {
                _usingCtx3.e = _;
            } finally{
                _usingCtx3.d();
            }
        } catch (_) {
            _usingCtx$1.e = _;
        } finally{
            yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$2.default)(_usingCtx$1.d());
        }
    });
    return $2e4200fd07666b61$var$_withPing.apply(this, arguments);
}
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/asyncIterator.js
var $2e4200fd07666b61$var$require_asyncIterator = (0, $1h7sD.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/asyncIterator.js" (exports, module) {
        function _asyncIterator$2(r) {
            var n, t, o, e = 2;
            for("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;){
                if (t && null != (n = r[t])) return n.call(r);
                if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r));
                t = "@@asyncIterator", o = "@@iterator";
            }
            throw new TypeError("Object is not async iterable");
        }
        function AsyncFromSyncIterator(r) {
            function AsyncFromSyncIteratorContinuation(r$1) {
                if (Object(r$1) !== r$1) return Promise.reject(new TypeError(r$1 + " is not an object."));
                var n = r$1.done;
                return Promise.resolve(r$1.value).then(function(r$2) {
                    return {
                        value: r$2,
                        done: n
                    };
                });
            }
            return AsyncFromSyncIterator = function AsyncFromSyncIterator$1(r$1) {
                this.s = r$1, this.n = r$1.next;
            }, AsyncFromSyncIterator.prototype = {
                s: null,
                n: null,
                next: function next() {
                    return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
                },
                "return": function _return(r$1) {
                    var n = this.s["return"];
                    return void 0 === n ? Promise.resolve({
                        value: r$1,
                        done: !0
                    }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
                },
                "throw": function _throw(r$1) {
                    var n = this.s["return"];
                    return void 0 === n ? Promise.reject(r$1) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
                }
            }, new AsyncFromSyncIterator(r);
        }
        module.exports = _asyncIterator$2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region src/unstable-core-do-not-import/stream/jsonl.ts
var $2e4200fd07666b61$var$import_awaitAsyncGenerator$1 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_awaitAsyncGenerator(), 1);
var $2e4200fd07666b61$var$import_wrapAsyncGenerator$2 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_wrapAsyncGenerator(), 1);
var $2e4200fd07666b61$var$import_usingCtx$1 = (0, $1h7sD.__toESM)($2e4200fd07666b61$export$c8fafa628198d7df(), 1);
var $2e4200fd07666b61$var$import_asyncIterator$1 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_asyncIterator(), 1);
function $2e4200fd07666b61$var$isPlainObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
const $2e4200fd07666b61$var$CHUNK_VALUE_TYPE_PROMISE = 0;
const $2e4200fd07666b61$var$CHUNK_VALUE_TYPE_ASYNC_ITERABLE = 1;
const $2e4200fd07666b61$var$PROMISE_STATUS_FULFILLED = 0;
const $2e4200fd07666b61$var$PROMISE_STATUS_REJECTED = 1;
const $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_RETURN = 0;
const $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_YIELD = 1;
const $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_ERROR = 2;
function $2e4200fd07666b61$export$4369c812aac99591(value) {
    return ((0, $6bgAm.isObject)(value) || (0, $6bgAm.isFunction)(value)) && typeof (value === null || value === void 0 ? void 0 : value["then"]) === "function" && typeof (value === null || value === void 0 ? void 0 : value["catch"]) === "function";
}
var $2e4200fd07666b61$var$MaxDepthError = class extends Error {
    constructor(path){
        super("Max depth reached at path: " + path.join("."));
        this.path = path;
    }
};
function $2e4200fd07666b61$var$createBatchStreamProducer(_x3) {
    return $2e4200fd07666b61$var$_createBatchStreamProducer.apply(this, arguments);
}
function $2e4200fd07666b61$var$_createBatchStreamProducer() {
    $2e4200fd07666b61$var$_createBatchStreamProducer = (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$2.default)(function*(opts) {
        const { data: data } = opts;
        let counter = 0;
        const placeholder = 0;
        const mergedIterables = $2e4200fd07666b61$var$mergeAsyncIterables();
        function registerAsync(callback) {
            const idx = counter++;
            const iterable$1 = callback(idx);
            mergedIterables.add(iterable$1);
            return idx;
        }
        function encodePromise(promise, path) {
            return registerAsync(/* @__PURE__ */ function() {
                var _ref = (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$2.default)(function*(idx) {
                    const error = checkMaxDepth(path);
                    if (error) {
                        promise.catch((cause)=>{
                            var _opts$onError;
                            (_opts$onError = opts.onError) === null || _opts$onError === void 0 || _opts$onError.call(opts, {
                                error: cause,
                                path: path
                            });
                        });
                        promise = Promise.reject(error);
                    }
                    try {
                        const next = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$1.default)(promise);
                        yield [
                            idx,
                            $2e4200fd07666b61$var$PROMISE_STATUS_FULFILLED,
                            encode(next, path)
                        ];
                    } catch (cause) {
                        var _opts$onError2, _opts$formatError;
                        (_opts$onError2 = opts.onError) === null || _opts$onError2 === void 0 || _opts$onError2.call(opts, {
                            error: cause,
                            path: path
                        });
                        yield [
                            idx,
                            $2e4200fd07666b61$var$PROMISE_STATUS_REJECTED,
                            (_opts$formatError = opts.formatError) === null || _opts$formatError === void 0 ? void 0 : _opts$formatError.call(opts, {
                                error: cause,
                                path: path
                            })
                        ];
                    }
                });
                return function(_x) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
        function encodeAsyncIterable(iterable$1, path) {
            return registerAsync(/* @__PURE__ */ function() {
                var _ref2 = (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$2.default)(function*(idx) {
                    try {
                        var _usingCtx$1 = (0, $2e4200fd07666b61$var$import_usingCtx$1.default)();
                        const error = checkMaxDepth(path);
                        if (error) throw error;
                        const iterator = _usingCtx$1.a($2e4200fd07666b61$export$31af6aaecae75479(iterable$1));
                        try {
                            while(true){
                                const next = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$1.default)(iterator.next());
                                if (next.done) {
                                    yield [
                                        idx,
                                        $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_RETURN,
                                        encode(next.value, path)
                                    ];
                                    break;
                                }
                                yield [
                                    idx,
                                    $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_YIELD,
                                    encode(next.value, path)
                                ];
                            }
                        } catch (cause) {
                            var _opts$onError3, _opts$formatError2;
                            (_opts$onError3 = opts.onError) === null || _opts$onError3 === void 0 || _opts$onError3.call(opts, {
                                error: cause,
                                path: path
                            });
                            yield [
                                idx,
                                $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_ERROR,
                                (_opts$formatError2 = opts.formatError) === null || _opts$formatError2 === void 0 ? void 0 : _opts$formatError2.call(opts, {
                                    error: cause,
                                    path: path
                                })
                            ];
                        }
                    } catch (_) {
                        _usingCtx$1.e = _;
                    } finally{
                        yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$1.default)(_usingCtx$1.d());
                    }
                });
                return function(_x2) {
                    return _ref2.apply(this, arguments);
                };
            }());
        }
        function checkMaxDepth(path) {
            if (opts.maxDepth && path.length > opts.maxDepth) return new $2e4200fd07666b61$var$MaxDepthError(path);
            return null;
        }
        function encodeAsync(value, path) {
            if ($2e4200fd07666b61$export$4369c812aac99591(value)) return [
                $2e4200fd07666b61$var$CHUNK_VALUE_TYPE_PROMISE,
                encodePromise(value, path)
            ];
            if ((0, $6bgAm.isAsyncIterable)(value)) {
                if (opts.maxDepth && path.length >= opts.maxDepth) throw new Error("Max depth reached");
                return [
                    $2e4200fd07666b61$var$CHUNK_VALUE_TYPE_ASYNC_ITERABLE,
                    encodeAsyncIterable(value, path)
                ];
            }
            return null;
        }
        function encode(value, path) {
            if (value === void 0) return [
                []
            ];
            const reg = encodeAsync(value, path);
            if (reg) return [
                [
                    placeholder
                ],
                [
                    null,
                    ...reg
                ]
            ];
            if (!$2e4200fd07666b61$var$isPlainObject(value)) return [
                [
                    value
                ]
            ];
            const newObj = {};
            const asyncValues = [];
            for (const [key, item] of Object.entries(value)){
                const transformed = encodeAsync(item, [
                    ...path,
                    key
                ]);
                if (!transformed) {
                    newObj[key] = item;
                    continue;
                }
                newObj[key] = placeholder;
                asyncValues.push([
                    key,
                    ...transformed
                ]);
            }
            return [
                [
                    newObj
                ],
                ...asyncValues
            ];
        }
        const newHead = {};
        for (const [key, item] of Object.entries(data))newHead[key] = encode(item, [
            key
        ]);
        yield newHead;
        let iterable = mergedIterables;
        if (opts.pingMs) iterable = $2e4200fd07666b61$var$withPing(mergedIterables, opts.pingMs);
        var _iteratorAbruptCompletion = false;
        var _didIteratorError = false;
        var _iteratorError;
        try {
            for(var _iterator = (0, $2e4200fd07666b61$var$import_asyncIterator$1.default)(iterable), _step; _iteratorAbruptCompletion = !(_step = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$1.default)(_iterator.next())).done; _iteratorAbruptCompletion = false){
                const value = _step.value;
                yield value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (_iteratorAbruptCompletion && _iterator.return != null) yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$1.default)(_iterator.return());
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    });
    return $2e4200fd07666b61$var$_createBatchStreamProducer.apply(this, arguments);
}
/**
* JSON Lines stream producer
* @see https://jsonlines.org/
*/ function $2e4200fd07666b61$export$c99e56e677b5b958(opts) {
    let stream = $2e4200fd07666b61$var$readableStreamFrom($2e4200fd07666b61$var$createBatchStreamProducer(opts));
    const { serialize: serialize } = opts;
    if (serialize) stream = stream.pipeThrough(new TransformStream({
        transform (chunk, controller) {
            if (chunk === $2e4200fd07666b61$var$PING_SYM) controller.enqueue($2e4200fd07666b61$var$PING_SYM);
            else controller.enqueue(serialize(chunk));
        }
    }));
    return stream.pipeThrough(new TransformStream({
        transform (chunk, controller) {
            if (chunk === $2e4200fd07666b61$var$PING_SYM) controller.enqueue(" ");
            else controller.enqueue(JSON.stringify(chunk) + "\n");
        }
    })).pipeThrough(new TextEncoderStream());
}
var $2e4200fd07666b61$var$AsyncError = class extends Error {
    constructor(data){
        super("Received error from server");
        this.data = data;
    }
};
const $2e4200fd07666b61$var$nodeJsStreamToReaderEsque = (source)=>{
    return {
        getReader () {
            const stream = new ReadableStream({
                start (controller) {
                    source.on("data", (chunk)=>{
                        controller.enqueue(chunk);
                    });
                    source.on("end", ()=>{
                        controller.close();
                    });
                    source.on("error", (error)=>{
                        controller.error(error);
                    });
                }
            });
            return stream.getReader();
        }
    };
};
function $2e4200fd07666b61$var$createLineAccumulator(from) {
    const reader = "getReader" in from ? from.getReader() : $2e4200fd07666b61$var$nodeJsStreamToReaderEsque(from).getReader();
    let lineAggregate = "";
    return new ReadableStream({
        async pull (controller) {
            const { done: done, value: value } = await reader.read();
            if (done) controller.close();
            else controller.enqueue(value);
        },
        cancel () {
            return reader.cancel();
        }
    }).pipeThrough(new TextDecoderStream()).pipeThrough(new TransformStream({
        transform (chunk, controller) {
            var _parts$pop;
            lineAggregate += chunk;
            const parts = lineAggregate.split("\n");
            lineAggregate = (_parts$pop = parts.pop()) !== null && _parts$pop !== void 0 ? _parts$pop : "";
            for (const part of parts)controller.enqueue(part);
        }
    }));
}
function $2e4200fd07666b61$var$createConsumerStream(from) {
    const stream = $2e4200fd07666b61$var$createLineAccumulator(from);
    let sentHead = false;
    return stream.pipeThrough(new TransformStream({
        transform (line, controller) {
            if (!sentHead) {
                const head = JSON.parse(line);
                controller.enqueue(head);
                sentHead = true;
            } else {
                const chunk = JSON.parse(line);
                controller.enqueue(chunk);
            }
        }
    }));
}
/**
* Creates a handler for managing stream controllers and their lifecycle
*/ function $2e4200fd07666b61$var$createStreamsManager(abortController) {
    const controllerMap = /* @__PURE__ */ new Map();
    /**
	* Checks if there are no pending controllers or deferred promises
	*/ function isEmpty() {
        return Array.from(controllerMap.values()).every((c)=>c.closed);
    }
    /**
	* Creates a stream controller
	*/ function createStreamController() {
        let originalController;
        const stream = new ReadableStream({
            start (controller) {
                originalController = controller;
            }
        });
        const streamController = {
            enqueue: (v)=>originalController.enqueue(v),
            close: ()=>{
                originalController.close();
                clear();
                if (isEmpty()) abortController.abort();
            },
            closed: false,
            getReaderResource: ()=>{
                const reader = stream.getReader();
                return $2e4200fd07666b61$export$d656de2b69647d7d(reader, ()=>{
                    reader.releaseLock();
                    streamController.close();
                });
            },
            error: (reason)=>{
                originalController.error(reason);
                clear();
            }
        };
        function clear() {
            Object.assign(streamController, {
                closed: true,
                close: ()=>{},
                enqueue: ()=>{},
                getReaderResource: null,
                error: ()=>{}
            });
        }
        return streamController;
    }
    /**
	* Gets or creates a stream controller
	*/ function getOrCreate(chunkId) {
        let c = controllerMap.get(chunkId);
        if (!c) {
            c = createStreamController();
            controllerMap.set(chunkId, c);
        }
        return c;
    }
    /**
	* Cancels all pending controllers and rejects deferred promises
	*/ function cancelAll(reason) {
        for (const controller of controllerMap.values())controller.error(reason);
    }
    return {
        getOrCreate: getOrCreate,
        isEmpty: isEmpty,
        cancelAll: cancelAll
    };
}
/**
* JSON Lines stream consumer
* @see https://jsonlines.org/
*/ async function $2e4200fd07666b61$export$cda9b7fa8d9fbf55(opts) {
    const { deserialize: deserialize = (v)=>v } = opts;
    let source = $2e4200fd07666b61$var$createConsumerStream(opts.from);
    if (deserialize) source = source.pipeThrough(new TransformStream({
        transform (chunk, controller) {
            controller.enqueue(deserialize(chunk));
        }
    }));
    let headDeferred = $2e4200fd07666b61$export$e673efccd97e4223();
    const streamManager = $2e4200fd07666b61$var$createStreamsManager(opts.abortController);
    function decodeChunkDefinition(value) {
        const [_path, type, chunkId] = value;
        const controller = streamManager.getOrCreate(chunkId);
        switch(type){
            case $2e4200fd07666b61$var$CHUNK_VALUE_TYPE_PROMISE:
                return (0, $6bgAm.run)(async ()=>{
                    try {
                        var _usingCtx3 = (0, $2e4200fd07666b61$var$import_usingCtx$1.default)();
                        const reader = _usingCtx3.u(controller.getReaderResource());
                        const { value: value$1 } = await reader.read();
                        const [_chunkId, status, data] = value$1;
                        switch(status){
                            case $2e4200fd07666b61$var$PROMISE_STATUS_FULFILLED:
                                return decode(data);
                            case $2e4200fd07666b61$var$PROMISE_STATUS_REJECTED:
                                var _opts$formatError3, _opts$formatError4;
                                throw (_opts$formatError3 = (_opts$formatError4 = opts.formatError) === null || _opts$formatError4 === void 0 ? void 0 : _opts$formatError4.call(opts, {
                                    error: data
                                })) !== null && _opts$formatError3 !== void 0 ? _opts$formatError3 : new $2e4200fd07666b61$var$AsyncError(data);
                        }
                    } catch (_) {
                        _usingCtx3.e = _;
                    } finally{
                        _usingCtx3.d();
                    }
                });
            case $2e4200fd07666b61$var$CHUNK_VALUE_TYPE_ASYNC_ITERABLE:
                return (0, $6bgAm.run)((0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$2.default)(function*() {
                    try {
                        var _usingCtx4 = (0, $2e4200fd07666b61$var$import_usingCtx$1.default)();
                        const reader = _usingCtx4.u(controller.getReaderResource());
                        while(true){
                            const { value: value$1 } = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator$1.default)(reader.read());
                            const [_chunkId, status, data] = value$1;
                            switch(status){
                                case $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_YIELD:
                                    yield decode(data);
                                    break;
                                case $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_RETURN:
                                    return decode(data);
                                case $2e4200fd07666b61$var$ASYNC_ITERABLE_STATUS_ERROR:
                                    var _opts$formatError5, _opts$formatError6;
                                    throw (_opts$formatError5 = (_opts$formatError6 = opts.formatError) === null || _opts$formatError6 === void 0 ? void 0 : _opts$formatError6.call(opts, {
                                        error: data
                                    })) !== null && _opts$formatError5 !== void 0 ? _opts$formatError5 : new $2e4200fd07666b61$var$AsyncError(data);
                            }
                        }
                    } catch (_) {
                        _usingCtx4.e = _;
                    } finally{
                        _usingCtx4.d();
                    }
                }));
        }
    }
    function decode(value) {
        const [[data], ...asyncProps] = value;
        for (const value$1 of asyncProps){
            const [key] = value$1;
            const decoded = decodeChunkDefinition(value$1);
            if (key === null) return decoded;
            data[key] = decoded;
        }
        return data;
    }
    const closeOrAbort = (reason)=>{
        headDeferred === null || headDeferred === void 0 || headDeferred.reject(reason);
        streamManager.cancelAll(reason);
    };
    source.pipeTo(new WritableStream({
        write (chunkOrHead) {
            if (headDeferred) {
                const head = chunkOrHead;
                for (const [key, value] of Object.entries(chunkOrHead)){
                    const parsed = decode(value);
                    head[key] = parsed;
                }
                headDeferred.resolve(head);
                headDeferred = null;
                return;
            }
            const chunk = chunkOrHead;
            const [idx] = chunk;
            const controller = streamManager.getOrCreate(idx);
            controller.enqueue(chunk);
        },
        close: ()=>closeOrAbort(new Error("Stream closed")),
        abort: closeOrAbort
    }), {
        signal: opts.abortController.signal
    }).catch((error)=>{
        var _opts$onError4;
        (_opts$onError4 = opts.onError) === null || _opts$onError4 === void 0 || _opts$onError4.call(opts, {
            error: error
        });
        closeOrAbort(error);
    });
    return [
        await headDeferred.promise,
        streamManager
    ];
}
//#endregion
//#region ../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/asyncGeneratorDelegate.js
var $2e4200fd07666b61$var$require_asyncGeneratorDelegate = (0, $1h7sD.__commonJS)({
    "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/asyncGeneratorDelegate.js" (exports, module) {
        var OverloadYield = $2e4200fd07666b61$var$require_OverloadYield();
        function _asyncGeneratorDelegate$1(t) {
            var e = {}, n = !1;
            function pump(e$1, r) {
                return n = !0, r = new Promise(function(n$1) {
                    n$1(t[e$1](r));
                }), {
                    done: !1,
                    value: new OverloadYield(r, 1)
                };
            }
            return e["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function() {
                return this;
            }, e.next = function(t$1) {
                return n ? (n = !1, t$1) : pump("next", t$1);
            }, "function" == typeof t["throw"] && (e["throw"] = function(t$1) {
                if (n) throw n = !1, t$1;
                return pump("throw", t$1);
            }), "function" == typeof t["return"] && (e["return"] = function(t$1) {
                return n ? (n = !1, t$1) : pump("return", t$1);
            }), e;
        }
        module.exports = _asyncGeneratorDelegate$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
});
//#endregion
//#region src/unstable-core-do-not-import/stream/sse.ts
var $2e4200fd07666b61$var$import_asyncIterator = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_asyncIterator(), 1);
var $2e4200fd07666b61$var$import_awaitAsyncGenerator = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_awaitAsyncGenerator(), 1);
var $2e4200fd07666b61$var$import_wrapAsyncGenerator$1 = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_wrapAsyncGenerator(), 1);
var $2e4200fd07666b61$var$import_asyncGeneratorDelegate = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_asyncGeneratorDelegate(), 1);
var $2e4200fd07666b61$var$import_usingCtx = (0, $1h7sD.__toESM)($2e4200fd07666b61$export$c8fafa628198d7df(), 1);
const $2e4200fd07666b61$var$PING_EVENT = "ping";
const $2e4200fd07666b61$var$SERIALIZED_ERROR_EVENT = "serialized-error";
const $2e4200fd07666b61$var$CONNECTED_EVENT = "connected";
const $2e4200fd07666b61$var$RETURN_EVENT = "return";
/**
*
* @see https://html.spec.whatwg.org/multipage/server-sent-events.html
*/ function $2e4200fd07666b61$export$c6cc0cb1e257d583(opts) {
    var _opts$ping$enabled, _opts$ping, _opts$ping$intervalMs, _opts$ping2, _opts$client;
    const { serialize: serialize = (0, $6bgAm.identity) } = opts;
    const ping = {
        enabled: (_opts$ping$enabled = (_opts$ping = opts.ping) === null || _opts$ping === void 0 ? void 0 : _opts$ping.enabled) !== null && _opts$ping$enabled !== void 0 ? _opts$ping$enabled : false,
        intervalMs: (_opts$ping$intervalMs = (_opts$ping2 = opts.ping) === null || _opts$ping2 === void 0 ? void 0 : _opts$ping2.intervalMs) !== null && _opts$ping$intervalMs !== void 0 ? _opts$ping$intervalMs : 1e3
    };
    const client = (_opts$client = opts.client) !== null && _opts$client !== void 0 ? _opts$client : {};
    if (ping.enabled && client.reconnectAfterInactivityMs && ping.intervalMs > client.reconnectAfterInactivityMs) throw new Error(`Ping interval must be less than client reconnect interval to prevent unnecessary reconnection - ping.intervalMs: ${ping.intervalMs} client.reconnectAfterInactivityMs: ${client.reconnectAfterInactivityMs}`);
    function generator() {
        return _generator.apply(this, arguments);
    }
    function _generator() {
        _generator = (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$1.default)(function*() {
            yield {
                event: $2e4200fd07666b61$var$CONNECTED_EVENT,
                data: JSON.stringify(client)
            };
            let iterable = opts.data;
            if (opts.emitAndEndImmediately) iterable = $2e4200fd07666b61$export$d12b460caff1e2b6(iterable, {
                count: 1,
                gracePeriodMs: 1
            });
            if (opts.maxDurationMs && opts.maxDurationMs > 0 && opts.maxDurationMs !== Infinity) iterable = $2e4200fd07666b61$export$142d74197e6b4718(iterable, {
                maxDurationMs: opts.maxDurationMs
            });
            if (ping.enabled && ping.intervalMs !== Infinity && ping.intervalMs > 0) iterable = $2e4200fd07666b61$var$withPing(iterable, ping.intervalMs);
            let value;
            let chunk;
            var _iteratorAbruptCompletion = false;
            var _didIteratorError = false;
            var _iteratorError;
            try {
                for(var _iterator = (0, $2e4200fd07666b61$var$import_asyncIterator.default)(iterable), _step; _iteratorAbruptCompletion = !(_step = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator.default)(_iterator.next())).done; _iteratorAbruptCompletion = false){
                    value = _step.value;
                    if (value === $2e4200fd07666b61$var$PING_SYM) {
                        yield {
                            event: $2e4200fd07666b61$var$PING_EVENT,
                            data: ""
                        };
                        continue;
                    }
                    chunk = (0, $8hhvi.isTrackedEnvelope)(value) ? {
                        id: value[0],
                        data: value[1]
                    } : {
                        data: value
                    };
                    chunk.data = JSON.stringify(serialize(chunk.data));
                    yield chunk;
                    value = null;
                    chunk = null;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (_iteratorAbruptCompletion && _iterator.return != null) yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator.default)(_iterator.return());
                } finally{
                    if (_didIteratorError) throw _iteratorError;
                }
            }
        });
        return _generator.apply(this, arguments);
    }
    function generatorWithErrorHandling() {
        return _generatorWithErrorHandling.apply(this, arguments);
    }
    function _generatorWithErrorHandling() {
        _generatorWithErrorHandling = (0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$1.default)(function*() {
            try {
                yield* (0, $2e4200fd07666b61$var$import_asyncGeneratorDelegate.default)((0, $2e4200fd07666b61$var$import_asyncIterator.default)(generator()));
                yield {
                    event: $2e4200fd07666b61$var$RETURN_EVENT,
                    data: ""
                };
            } catch (cause) {
                var _opts$formatError, _opts$formatError2;
                if ($2e4200fd07666b61$export$d2c30ea522b3259e(cause)) return;
                const error = (0, $8hhvi.getTRPCErrorFromUnknown)(cause);
                const data = (_opts$formatError = (_opts$formatError2 = opts.formatError) === null || _opts$formatError2 === void 0 ? void 0 : _opts$formatError2.call(opts, {
                    error: error
                })) !== null && _opts$formatError !== void 0 ? _opts$formatError : null;
                yield {
                    event: $2e4200fd07666b61$var$SERIALIZED_ERROR_EVENT,
                    data: JSON.stringify(serialize(data))
                };
            }
        });
        return _generatorWithErrorHandling.apply(this, arguments);
    }
    const stream = $2e4200fd07666b61$var$readableStreamFrom(generatorWithErrorHandling());
    return stream.pipeThrough(new TransformStream({
        transform (chunk, controller) {
            if ("event" in chunk) controller.enqueue(`event: ${chunk.event}\n`);
            if ("data" in chunk) controller.enqueue(`data: ${chunk.data}\n`);
            if ("id" in chunk) controller.enqueue(`id: ${chunk.id}\n`);
            if ("comment" in chunk) controller.enqueue(`: ${chunk.comment}\n`);
            controller.enqueue("\n\n");
        }
    })).pipeThrough(new TextEncoderStream());
}
async function $2e4200fd07666b61$var$withTimeout(opts) {
    try {
        var _usingCtx$1 = (0, $2e4200fd07666b61$var$import_usingCtx.default)();
        const timeoutPromise = _usingCtx$1.u($2e4200fd07666b61$var$timerResource(opts.timeoutMs));
        const res = await $2e4200fd07666b61$export$cebb049a33434478.race([
            opts.promise,
            timeoutPromise.start()
        ]);
        if (res === $2e4200fd07666b61$var$disposablePromiseTimerResult) return await opts.onTimeout();
        return res;
    } catch (_) {
        _usingCtx$1.e = _;
    } finally{
        _usingCtx$1.d();
    }
}
/**
* @see https://html.spec.whatwg.org/multipage/server-sent-events.html
*/ function $2e4200fd07666b61$export$892255ae5d6656c6(opts) {
    const { deserialize: deserialize = (v)=>v } = opts;
    let clientOptions = {};
    const signal = opts.signal;
    let _es = null;
    const createStream = ()=>new ReadableStream({
            async start (controller) {
                const [url, init] = await Promise.all([
                    opts.url(),
                    opts.init()
                ]);
                const eventSource = _es = new opts.EventSource(url, init);
                controller.enqueue({
                    type: "connecting",
                    eventSource: _es,
                    event: null
                });
                eventSource.addEventListener($2e4200fd07666b61$var$CONNECTED_EVENT, (_msg)=>{
                    const msg = _msg;
                    const options = JSON.parse(msg.data);
                    clientOptions = options;
                    controller.enqueue({
                        type: "connected",
                        options: options,
                        eventSource: eventSource
                    });
                });
                eventSource.addEventListener($2e4200fd07666b61$var$SERIALIZED_ERROR_EVENT, (_msg)=>{
                    const msg = _msg;
                    controller.enqueue({
                        type: "serialized-error",
                        error: deserialize(JSON.parse(msg.data)),
                        eventSource: eventSource
                    });
                });
                eventSource.addEventListener($2e4200fd07666b61$var$PING_EVENT, ()=>{
                    controller.enqueue({
                        type: "ping",
                        eventSource: eventSource
                    });
                });
                eventSource.addEventListener($2e4200fd07666b61$var$RETURN_EVENT, ()=>{
                    eventSource.close();
                    controller.close();
                    _es = null;
                });
                eventSource.addEventListener("error", (event)=>{
                    if (eventSource.readyState === eventSource.CLOSED) controller.error(event);
                    else controller.enqueue({
                        type: "connecting",
                        eventSource: eventSource,
                        event: event
                    });
                });
                eventSource.addEventListener("message", (_msg)=>{
                    const msg = _msg;
                    const chunk = deserialize(JSON.parse(msg.data));
                    const def = {
                        data: chunk
                    };
                    if (msg.lastEventId) def.id = msg.lastEventId;
                    controller.enqueue({
                        type: "data",
                        data: def,
                        eventSource: eventSource
                    });
                });
                const onAbort = ()=>{
                    try {
                        eventSource.close();
                        controller.close();
                    } catch (_unused) {}
                };
                if (signal.aborted) onAbort();
                else signal.addEventListener("abort", onAbort);
            },
            cancel () {
                _es === null || _es === void 0 || _es.close();
            }
        });
    const getStreamResource = ()=>{
        let stream = createStream();
        let reader = stream.getReader();
        async function dispose() {
            await reader.cancel();
            _es = null;
        }
        return $2e4200fd07666b61$export$8eea18d870642d59({
            read () {
                return reader.read();
            },
            async recreate () {
                await dispose();
                stream = createStream();
                reader = stream.getReader();
            }
        }, dispose);
    };
    return (0, $6bgAm.run)((0, $2e4200fd07666b61$var$import_wrapAsyncGenerator$1.default)(function*() {
        try {
            var _usingCtx3 = (0, $2e4200fd07666b61$var$import_usingCtx.default)();
            const stream = _usingCtx3.a(getStreamResource());
            while(true){
                let promise = stream.read();
                const timeoutMs = clientOptions.reconnectAfterInactivityMs;
                if (timeoutMs) promise = $2e4200fd07666b61$var$withTimeout({
                    promise: promise,
                    timeoutMs: timeoutMs,
                    onTimeout: async ()=>{
                        const res = {
                            value: {
                                type: "timeout",
                                ms: timeoutMs,
                                eventSource: _es
                            },
                            done: false
                        };
                        await stream.recreate();
                        return res;
                    }
                });
                const result = yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator.default)(promise);
                if (result.done) return result.value;
                yield result.value;
            }
        } catch (_) {
            _usingCtx3.e = _;
        } finally{
            yield (0, $2e4200fd07666b61$var$import_awaitAsyncGenerator.default)(_usingCtx3.d());
        }
    }));
}
const $2e4200fd07666b61$export$d0408899c42992a = {
    "Content-Type": "text/event-stream",
    "Cache-Control": "no-cache, no-transform",
    "X-Accel-Buffering": "no",
    Connection: "keep-alive"
};
//#endregion
//#region src/unstable-core-do-not-import/http/resolveResponse.ts
var $2e4200fd07666b61$var$import_wrapAsyncGenerator = (0, $1h7sD.__toESM)($2e4200fd07666b61$var$require_wrapAsyncGenerator(), 1);
var $2e4200fd07666b61$var$import_objectSpread2 = (0, $1h7sD.__toESM)((0, $1h7sD.require_objectSpread2)(), 1);
function $2e4200fd07666b61$var$errorToAsyncIterable(err) {
    return (0, $6bgAm.run)((0, $2e4200fd07666b61$var$import_wrapAsyncGenerator.default)(function*() {
        throw err;
    }));
}
const $2e4200fd07666b61$var$TYPE_ACCEPTED_METHOD_MAP = {
    mutation: [
        "POST"
    ],
    query: [
        "GET"
    ],
    subscription: [
        "GET"
    ]
};
const $2e4200fd07666b61$var$TYPE_ACCEPTED_METHOD_MAP_WITH_METHOD_OVERRIDE = {
    mutation: [
        "POST"
    ],
    query: [
        "GET",
        "POST"
    ],
    subscription: [
        "GET",
        "POST"
    ]
};
function $2e4200fd07666b61$var$initResponse(initOpts) {
    var _responseMeta, _info$calls$find$proc, _info$calls$find;
    const { ctx: ctx, info: info, responseMeta: responseMeta, untransformedJSON: untransformedJSON, errors: errors = [], headers: headers } = initOpts;
    let status = untransformedJSON ? (0, $1h7sD.getHTTPStatusCode)(untransformedJSON) : 200;
    const eagerGeneration = !untransformedJSON;
    const data = eagerGeneration ? [] : Array.isArray(untransformedJSON) ? untransformedJSON : [
        untransformedJSON
    ];
    const meta = (_responseMeta = responseMeta === null || responseMeta === void 0 ? void 0 : responseMeta({
        ctx: ctx,
        info: info,
        paths: info === null || info === void 0 ? void 0 : info.calls.map((call)=>call.path),
        data: data,
        errors: errors,
        eagerGeneration: eagerGeneration,
        type: (_info$calls$find$proc = info === null || info === void 0 || (_info$calls$find = info.calls.find((call)=>{
            var _call$procedure;
            return (_call$procedure = call.procedure) === null || _call$procedure === void 0 ? void 0 : _call$procedure._def.type;
        })) === null || _info$calls$find === void 0 || (_info$calls$find = _info$calls$find.procedure) === null || _info$calls$find === void 0 ? void 0 : _info$calls$find._def.type) !== null && _info$calls$find$proc !== void 0 ? _info$calls$find$proc : "unknown"
    })) !== null && _responseMeta !== void 0 ? _responseMeta : {};
    if (meta.headers) {
        if (meta.headers instanceof Headers) for (const [key, value] of meta.headers.entries())headers.append(key, value);
        else /**
		* @deprecated, delete in v12
		*/ for (const [key, value] of Object.entries(meta.headers))if (Array.isArray(value)) for (const v of value)headers.append(key, v);
        else if (typeof value === "string") headers.set(key, value);
    }
    if (meta.status) status = meta.status;
    return {
        status: status
    };
}
function $2e4200fd07666b61$var$caughtErrorToData(cause, errorOpts) {
    const { router: router, req: req, onError: onError } = errorOpts.opts;
    const error = (0, $8hhvi.getTRPCErrorFromUnknown)(cause);
    onError === null || onError === void 0 || onError({
        error: error,
        path: errorOpts.path,
        input: errorOpts.input,
        ctx: errorOpts.ctx,
        type: errorOpts.type,
        req: req
    });
    const untransformedJSON = {
        error: (0, $1h7sD.getErrorShape)({
            config: router._def._config,
            error: error,
            type: errorOpts.type,
            path: errorOpts.path,
            input: errorOpts.input,
            ctx: errorOpts.ctx
        })
    };
    const transformedJSON = (0, $8hhvi.transformTRPCResponse)(router._def._config, untransformedJSON);
    const body = JSON.stringify(transformedJSON);
    return {
        error: error,
        untransformedJSON: untransformedJSON,
        body: body
    };
}
/**
* Check if a value is a stream-like object
* - if it's an async iterable
* - if it's an object with async iterables or promises
*/ function $2e4200fd07666b61$var$isDataStream(v) {
    if (!(0, $6bgAm.isObject)(v)) return false;
    if ((0, $6bgAm.isAsyncIterable)(v)) return true;
    return Object.values(v).some($2e4200fd07666b61$export$4369c812aac99591) || Object.values(v).some((0, $6bgAm.isAsyncIterable));
}
async function $2e4200fd07666b61$export$ace1d6afc438cf26(opts) {
    var _ref, _opts$allowBatching, _opts$batching, _opts$allowMethodOver, _config$sse$enabled, _config$sse;
    const { router: router, req: req } = opts;
    const headers = new Headers([
        [
            "vary",
            "trpc-accept"
        ]
    ]);
    const config = router._def._config;
    const url = new URL(req.url);
    if (req.method === "HEAD") return new Response(null, {
        status: 204
    });
    const allowBatching = (_ref = (_opts$allowBatching = opts.allowBatching) !== null && _opts$allowBatching !== void 0 ? _opts$allowBatching : (_opts$batching = opts.batching) === null || _opts$batching === void 0 ? void 0 : _opts$batching.enabled) !== null && _ref !== void 0 ? _ref : true;
    const allowMethodOverride = ((_opts$allowMethodOver = opts.allowMethodOverride) !== null && _opts$allowMethodOver !== void 0 ? _opts$allowMethodOver : false) && req.method === "POST";
    const infoTuple = await (0, $6bgAm.run)(async ()=>{
        try {
            return [
                void 0,
                await $2e4200fd07666b61$export$a6b910f7a3808ee3({
                    req: req,
                    path: decodeURIComponent(opts.path),
                    router: router,
                    searchParams: url.searchParams,
                    headers: opts.req.headers,
                    url: url
                })
            ];
        } catch (cause) {
            return [
                (0, $8hhvi.getTRPCErrorFromUnknown)(cause),
                void 0
            ];
        }
    });
    const ctxManager = (0, $6bgAm.run)(()=>{
        let result = void 0;
        return {
            valueOrUndefined: ()=>{
                if (!result) return void 0;
                return result[1];
            },
            value: ()=>{
                const [err, ctx] = result;
                if (err) throw err;
                return ctx;
            },
            create: async (info)=>{
                if (result) throw new Error("This should only be called once - report a bug in tRPC");
                try {
                    const ctx = await opts.createContext({
                        info: info
                    });
                    result = [
                        void 0,
                        ctx
                    ];
                } catch (cause) {
                    result = [
                        (0, $8hhvi.getTRPCErrorFromUnknown)(cause),
                        void 0
                    ];
                }
            }
        };
    });
    const methodMapper = allowMethodOverride ? $2e4200fd07666b61$var$TYPE_ACCEPTED_METHOD_MAP_WITH_METHOD_OVERRIDE : $2e4200fd07666b61$var$TYPE_ACCEPTED_METHOD_MAP;
    /**
	* @deprecated
	*/ const isStreamCall = req.headers.get("trpc-accept") === "application/jsonl";
    const experimentalSSE = (_config$sse$enabled = (_config$sse = config.sse) === null || _config$sse === void 0 ? void 0 : _config$sse.enabled) !== null && _config$sse$enabled !== void 0 ? _config$sse$enabled : true;
    try {
        const [infoError, info] = infoTuple;
        if (infoError) throw infoError;
        if (info.isBatchCall && !allowBatching) throw new (0, $8hhvi.TRPCError)({
            code: "BAD_REQUEST",
            message: `Batching is not enabled on the server`
        });
        /* istanbul ignore if -- @preserve */ if (isStreamCall && !info.isBatchCall) throw new (0, $8hhvi.TRPCError)({
            message: `Streaming requests must be batched (you can do a batch of 1)`,
            code: "BAD_REQUEST"
        });
        await ctxManager.create(info);
        const rpcCalls = info.calls.map(async (call)=>{
            const proc = call.procedure;
            try {
                if (opts.error) throw opts.error;
                if (!proc) throw new (0, $8hhvi.TRPCError)({
                    code: "NOT_FOUND",
                    message: `No procedure found on path "${call.path}"`
                });
                if (!methodMapper[proc._def.type].includes(req.method)) throw new (0, $8hhvi.TRPCError)({
                    code: "METHOD_NOT_SUPPORTED",
                    message: `Unsupported ${req.method}-request to ${proc._def.type} procedure at path "${call.path}"`
                });
                if (proc._def.type === "subscription") {
                    /* istanbul ignore if -- @preserve */ if (info.isBatchCall) throw new (0, $8hhvi.TRPCError)({
                        code: "BAD_REQUEST",
                        message: `Cannot batch subscription calls`
                    });
                }
                const data = await proc({
                    path: call.path,
                    getRawInput: call.getRawInput,
                    ctx: ctxManager.value(),
                    type: proc._def.type,
                    signal: opts.req.signal
                });
                return [
                    void 0,
                    {
                        data: data
                    }
                ];
            } catch (cause) {
                var _opts$onError, _call$procedure$_def$, _call$procedure2;
                const error = (0, $8hhvi.getTRPCErrorFromUnknown)(cause);
                const input = call.result();
                (_opts$onError = opts.onError) === null || _opts$onError === void 0 || _opts$onError.call(opts, {
                    error: error,
                    path: call.path,
                    input: input,
                    ctx: ctxManager.valueOrUndefined(),
                    type: (_call$procedure$_def$ = (_call$procedure2 = call.procedure) === null || _call$procedure2 === void 0 ? void 0 : _call$procedure2._def.type) !== null && _call$procedure$_def$ !== void 0 ? _call$procedure$_def$ : "unknown",
                    req: opts.req
                });
                return [
                    error,
                    void 0
                ];
            }
        });
        if (!info.isBatchCall) {
            const [call] = info.calls;
            const [error, result] = await rpcCalls[0];
            switch(info.type){
                case "unknown":
                case "mutation":
                case "query":
                    {
                        headers.set("content-type", "application/json");
                        if ($2e4200fd07666b61$var$isDataStream(result === null || result === void 0 ? void 0 : result.data)) throw new (0, $8hhvi.TRPCError)({
                            code: "UNSUPPORTED_MEDIA_TYPE",
                            message: "Cannot use stream-like response in non-streaming request - use httpBatchStreamLink"
                        });
                        const res = error ? {
                            error: (0, $1h7sD.getErrorShape)({
                                config: config,
                                ctx: ctxManager.valueOrUndefined(),
                                error: error,
                                input: call.result(),
                                path: call.path,
                                type: info.type
                            })
                        } : {
                            result: {
                                data: result.data
                            }
                        };
                        const headResponse$1 = $2e4200fd07666b61$var$initResponse({
                            ctx: ctxManager.valueOrUndefined(),
                            info: info,
                            responseMeta: opts.responseMeta,
                            errors: error ? [
                                error
                            ] : [],
                            headers: headers,
                            untransformedJSON: [
                                res
                            ]
                        });
                        return new Response(JSON.stringify((0, $8hhvi.transformTRPCResponse)(config, res)), {
                            status: headResponse$1.status,
                            headers: headers
                        });
                    }
                case "subscription":
                    {
                        const iterable = (0, $6bgAm.run)(()=>{
                            if (error) return $2e4200fd07666b61$var$errorToAsyncIterable(error);
                            if (!experimentalSSE) return $2e4200fd07666b61$var$errorToAsyncIterable(new (0, $8hhvi.TRPCError)({
                                code: "METHOD_NOT_SUPPORTED",
                                message: 'Missing experimental flag "sseSubscriptions"'
                            }));
                            if (!(0, $c2p8A.isObservable)(result.data) && !(0, $6bgAm.isAsyncIterable)(result.data)) return $2e4200fd07666b61$var$errorToAsyncIterable(new (0, $8hhvi.TRPCError)({
                                message: `Subscription ${call.path} did not return an observable or a AsyncGenerator`,
                                code: "INTERNAL_SERVER_ERROR"
                            }));
                            const dataAsIterable = (0, $c2p8A.isObservable)(result.data) ? (0, $c2p8A.observableToAsyncIterable)(result.data, opts.req.signal) : result.data;
                            return dataAsIterable;
                        });
                        const stream = $2e4200fd07666b61$export$c6cc0cb1e257d583((0, $2e4200fd07666b61$var$import_objectSpread2.default)((0, $2e4200fd07666b61$var$import_objectSpread2.default)({}, config.sse), {}, {
                            data: iterable,
                            serialize: (v)=>config.transformer.output.serialize(v),
                            formatError (errorOpts) {
                                var _call$procedure$_def$2, _call$procedure3, _opts$onError2;
                                const error$1 = (0, $8hhvi.getTRPCErrorFromUnknown)(errorOpts.error);
                                const input = call === null || call === void 0 ? void 0 : call.result();
                                const path = call === null || call === void 0 ? void 0 : call.path;
                                const type = (_call$procedure$_def$2 = call === null || call === void 0 || (_call$procedure3 = call.procedure) === null || _call$procedure3 === void 0 ? void 0 : _call$procedure3._def.type) !== null && _call$procedure$_def$2 !== void 0 ? _call$procedure$_def$2 : "unknown";
                                (_opts$onError2 = opts.onError) === null || _opts$onError2 === void 0 || _opts$onError2.call(opts, {
                                    error: error$1,
                                    path: path,
                                    input: input,
                                    ctx: ctxManager.valueOrUndefined(),
                                    req: opts.req,
                                    type: type
                                });
                                const shape = (0, $1h7sD.getErrorShape)({
                                    config: config,
                                    ctx: ctxManager.valueOrUndefined(),
                                    error: error$1,
                                    input: input,
                                    path: path,
                                    type: type
                                });
                                return shape;
                            }
                        }));
                        for (const [key, value] of Object.entries($2e4200fd07666b61$export$d0408899c42992a))headers.set(key, value);
                        const headResponse$1 = $2e4200fd07666b61$var$initResponse({
                            ctx: ctxManager.valueOrUndefined(),
                            info: info,
                            responseMeta: opts.responseMeta,
                            errors: [],
                            headers: headers,
                            untransformedJSON: null
                        });
                        return new Response(stream, {
                            headers: headers,
                            status: headResponse$1.status
                        });
                    }
            }
        }
        if (info.accept === "application/jsonl") {
            headers.set("content-type", "application/json");
            headers.set("transfer-encoding", "chunked");
            const headResponse$1 = $2e4200fd07666b61$var$initResponse({
                ctx: ctxManager.valueOrUndefined(),
                info: info,
                responseMeta: opts.responseMeta,
                errors: [],
                headers: headers,
                untransformedJSON: null
            });
            const stream = $2e4200fd07666b61$export$c99e56e677b5b958((0, $2e4200fd07666b61$var$import_objectSpread2.default)((0, $2e4200fd07666b61$var$import_objectSpread2.default)({}, config.jsonl), {}, {
                maxDepth: Infinity,
                data: rpcCalls.map(async (res)=>{
                    const [error, result] = await res;
                    const call = info.calls[0];
                    if (error) {
                        var _procedure$_def$type, _procedure;
                        return {
                            error: (0, $1h7sD.getErrorShape)({
                                config: config,
                                ctx: ctxManager.valueOrUndefined(),
                                error: error,
                                input: call.result(),
                                path: call.path,
                                type: (_procedure$_def$type = (_procedure = call.procedure) === null || _procedure === void 0 ? void 0 : _procedure._def.type) !== null && _procedure$_def$type !== void 0 ? _procedure$_def$type : "unknown"
                            })
                        };
                    }
                    /**
					* Not very pretty, but we need to wrap nested data in promises
					* Our stream producer will only resolve top-level async values or async values that are directly nested in another async value
					*/ const iterable = (0, $c2p8A.isObservable)(result.data) ? (0, $c2p8A.observableToAsyncIterable)(result.data, opts.req.signal) : Promise.resolve(result.data);
                    return {
                        result: Promise.resolve({
                            data: iterable
                        })
                    };
                }),
                serialize: config.transformer.output.serialize,
                onError: (cause)=>{
                    var _opts$onError3, _info$type;
                    (_opts$onError3 = opts.onError) === null || _opts$onError3 === void 0 || _opts$onError3.call(opts, {
                        error: (0, $8hhvi.getTRPCErrorFromUnknown)(cause),
                        path: void 0,
                        input: void 0,
                        ctx: ctxManager.valueOrUndefined(),
                        req: opts.req,
                        type: (_info$type = info === null || info === void 0 ? void 0 : info.type) !== null && _info$type !== void 0 ? _info$type : "unknown"
                    });
                },
                formatError (errorOpts) {
                    var _call$procedure$_def$3, _call$procedure4;
                    const call = info === null || info === void 0 ? void 0 : info.calls[errorOpts.path[0]];
                    const error = (0, $8hhvi.getTRPCErrorFromUnknown)(errorOpts.error);
                    const input = call === null || call === void 0 ? void 0 : call.result();
                    const path = call === null || call === void 0 ? void 0 : call.path;
                    const type = (_call$procedure$_def$3 = call === null || call === void 0 || (_call$procedure4 = call.procedure) === null || _call$procedure4 === void 0 ? void 0 : _call$procedure4._def.type) !== null && _call$procedure$_def$3 !== void 0 ? _call$procedure$_def$3 : "unknown";
                    const shape = (0, $1h7sD.getErrorShape)({
                        config: config,
                        ctx: ctxManager.valueOrUndefined(),
                        error: error,
                        input: input,
                        path: path,
                        type: type
                    });
                    return shape;
                }
            }));
            return new Response(stream, {
                headers: headers,
                status: headResponse$1.status
            });
        }
        /**
		* Non-streaming response:
		* - await all responses in parallel, blocking on the slowest one
		* - create headers with known response body
		* - return a complete HTTPResponse
		*/ headers.set("content-type", "application/json");
        const results = (await Promise.all(rpcCalls)).map((res)=>{
            const [error, result] = res;
            if (error) return res;
            if ($2e4200fd07666b61$var$isDataStream(result.data)) return [
                new (0, $8hhvi.TRPCError)({
                    code: "UNSUPPORTED_MEDIA_TYPE",
                    message: "Cannot use stream-like response in non-streaming request - use httpBatchStreamLink"
                }),
                void 0
            ];
            return res;
        });
        const resultAsRPCResponse = results.map(([error, result], index)=>{
            const call = info.calls[index];
            if (error) {
                var _call$procedure$_def$4, _call$procedure5;
                return {
                    error: (0, $1h7sD.getErrorShape)({
                        config: config,
                        ctx: ctxManager.valueOrUndefined(),
                        error: error,
                        input: call.result(),
                        path: call.path,
                        type: (_call$procedure$_def$4 = (_call$procedure5 = call.procedure) === null || _call$procedure5 === void 0 ? void 0 : _call$procedure5._def.type) !== null && _call$procedure$_def$4 !== void 0 ? _call$procedure$_def$4 : "unknown"
                    })
                };
            }
            return {
                result: {
                    data: result.data
                }
            };
        });
        const errors = results.map(([error])=>error).filter(Boolean);
        const headResponse = $2e4200fd07666b61$var$initResponse({
            ctx: ctxManager.valueOrUndefined(),
            info: info,
            responseMeta: opts.responseMeta,
            untransformedJSON: resultAsRPCResponse,
            errors: errors,
            headers: headers
        });
        return new Response(JSON.stringify((0, $8hhvi.transformTRPCResponse)(config, resultAsRPCResponse)), {
            status: headResponse.status,
            headers: headers
        });
    } catch (cause) {
        var _info$type2;
        const [_infoError, info] = infoTuple;
        const ctx = ctxManager.valueOrUndefined();
        const { error: error, untransformedJSON: untransformedJSON, body: body } = $2e4200fd07666b61$var$caughtErrorToData(cause, {
            opts: opts,
            ctx: ctxManager.valueOrUndefined(),
            type: (_info$type2 = info === null || info === void 0 ? void 0 : info.type) !== null && _info$type2 !== void 0 ? _info$type2 : "unknown"
        });
        const headResponse = $2e4200fd07666b61$var$initResponse({
            ctx: ctx,
            info: info,
            responseMeta: opts.responseMeta,
            untransformedJSON: untransformedJSON,
            errors: [
                error
            ],
            headers: headers
        });
        return new Response(body, {
            status: headResponse.status,
            headers: headers
        });
    }
}

});




parcelRegister("kAeQh", function(module, exports) {

$parcel$export(module.exports, "makeRequest", function () { return $efc2aecc9f4cf4a1$export$699251e5611cc6db; });
parcelRequire("7PdBe");

var $jKGh7 = parcelRequire("jKGh7");
parcelRequire("5uSSv");

var $flyUR = parcelRequire("flyUR");
async function $efc2aecc9f4cf4a1$export$699251e5611cc6db({ path: path, method: method, data: data, baseURL: baseURL = "https://server2.coincraft.co", maxRetries: maxRetries = 3 }) {
    //const maxRetries = 3
    const retryDelay = 500; // Delay in milliseconds
    let attempts = 0;
    while(attempts < maxRetries)try {
        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        };
        const response = await (0, (/*@__PURE__*/$parcel$interopDefault($jKGh7))).request({
            baseURL: baseURL,
            url: path,
            method: method,
            data: data,
            timeout: 30000,
            withCredentials: true,
            headers: headers
        });
        return response;
    } catch (error) {
        var _error$response;
        // Check if the error is a timeout
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jKGh7))).isCancel(error) || error.code === "ECONNABORTED" || error.message.includes("timeout")) {
            attempts = maxRetries;
            throw error; // Do not retry on timeouts
        }
        if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) // await SessionStore.checkAuthentication()
        attempts = maxRetries;
        attempts++;
        // check login
        if (attempts >= maxRetries) {
            $flyUR.captureException(error);
            // Handle error or throw it after max retries
            if (error.response) console.error(error.response);
            else if (error.request) console.error(error.request);
            else console.error("Error", error.message);
            throw error;
        }
        // Wait for a specified time before retrying
        await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    }
}

});
parcelRegister("jKGh7", function(module, exports) {

module.exports = (parcelRequire("bcxzY"));

});
parcelRegister("bcxzY", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");

var $jakNT = parcelRequire("jakNT");

var $gBD1p = parcelRequire("gBD1p");

var $dAm1N = parcelRequire("dAm1N");

var $k84Zj = parcelRequire("k84Zj");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $827adcd50f31132f$var$createInstance(defaultConfig) {
    var context = new $gBD1p(defaultConfig);
    var instance = $jakNT($gBD1p.prototype.request, context);
    // Copy axios.prototype to instance
    $bizsW.extend(instance, $gBD1p.prototype, context);
    // Copy context to instance
    $bizsW.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $827adcd50f31132f$var$axios = $827adcd50f31132f$var$createInstance($k84Zj);
// Expose Axios class to allow class inheritance
$827adcd50f31132f$var$axios.Axios = $gBD1p;
// Factory for creating new instances
$827adcd50f31132f$var$axios.create = function create(instanceConfig) {
    return $827adcd50f31132f$var$createInstance($dAm1N($827adcd50f31132f$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$827adcd50f31132f$var$axios.Cancel = (parcelRequire("53ZPL"));

$827adcd50f31132f$var$axios.CancelToken = (parcelRequire("5kwOY"));

$827adcd50f31132f$var$axios.isCancel = (parcelRequire("aPeVm"));
// Expose all/spread
$827adcd50f31132f$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$827adcd50f31132f$var$axios.spread = (parcelRequire("gcHh0"));
module.exports = $827adcd50f31132f$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $827adcd50f31132f$var$axios;

});
parcelRegister("bizsW", function(module, exports) {
"use strict";

var $jakNT = parcelRequire("jakNT");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $839ce2e9b7eccb9d$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $839ce2e9b7eccb9d$var$isArray(val) {
    return $839ce2e9b7eccb9d$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $839ce2e9b7eccb9d$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $839ce2e9b7eccb9d$var$isBuffer(val) {
    return val !== null && !$839ce2e9b7eccb9d$var$isUndefined(val) && val.constructor !== null && !$839ce2e9b7eccb9d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $839ce2e9b7eccb9d$var$isArrayBuffer(val) {
    return $839ce2e9b7eccb9d$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $839ce2e9b7eccb9d$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $839ce2e9b7eccb9d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $839ce2e9b7eccb9d$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $839ce2e9b7eccb9d$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $839ce2e9b7eccb9d$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $839ce2e9b7eccb9d$var$isDate(val) {
    return $839ce2e9b7eccb9d$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $839ce2e9b7eccb9d$var$isFile(val) {
    return $839ce2e9b7eccb9d$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $839ce2e9b7eccb9d$var$isBlob(val) {
    return $839ce2e9b7eccb9d$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $839ce2e9b7eccb9d$var$isFunction(val) {
    return $839ce2e9b7eccb9d$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $839ce2e9b7eccb9d$var$isStream(val) {
    return $839ce2e9b7eccb9d$var$isObject(val) && $839ce2e9b7eccb9d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $839ce2e9b7eccb9d$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $839ce2e9b7eccb9d$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $839ce2e9b7eccb9d$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $839ce2e9b7eccb9d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($839ce2e9b7eccb9d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $839ce2e9b7eccb9d$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $839ce2e9b7eccb9d$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$839ce2e9b7eccb9d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $839ce2e9b7eccb9d$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $839ce2e9b7eccb9d$var$deepMerge(result[key], val);
        else if (typeof val === "object") result[key] = $839ce2e9b7eccb9d$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$839ce2e9b7eccb9d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $839ce2e9b7eccb9d$var$extend(a, b, thisArg) {
    $839ce2e9b7eccb9d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jakNT(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $839ce2e9b7eccb9d$var$isArray,
    isArrayBuffer: $839ce2e9b7eccb9d$var$isArrayBuffer,
    isBuffer: $839ce2e9b7eccb9d$var$isBuffer,
    isFormData: $839ce2e9b7eccb9d$var$isFormData,
    isArrayBufferView: $839ce2e9b7eccb9d$var$isArrayBufferView,
    isString: $839ce2e9b7eccb9d$var$isString,
    isNumber: $839ce2e9b7eccb9d$var$isNumber,
    isObject: $839ce2e9b7eccb9d$var$isObject,
    isUndefined: $839ce2e9b7eccb9d$var$isUndefined,
    isDate: $839ce2e9b7eccb9d$var$isDate,
    isFile: $839ce2e9b7eccb9d$var$isFile,
    isBlob: $839ce2e9b7eccb9d$var$isBlob,
    isFunction: $839ce2e9b7eccb9d$var$isFunction,
    isStream: $839ce2e9b7eccb9d$var$isStream,
    isURLSearchParams: $839ce2e9b7eccb9d$var$isURLSearchParams,
    isStandardBrowserEnv: $839ce2e9b7eccb9d$var$isStandardBrowserEnv,
    forEach: $839ce2e9b7eccb9d$var$forEach,
    merge: $839ce2e9b7eccb9d$var$merge,
    deepMerge: $839ce2e9b7eccb9d$var$deepMerge,
    extend: $839ce2e9b7eccb9d$var$extend,
    trim: $839ce2e9b7eccb9d$var$trim
};

});
parcelRegister("jakNT", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("gBD1p", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");

var $fu7bf = parcelRequire("fu7bf");

var $3SU6e = parcelRequire("3SU6e");

var $1wKaK = parcelRequire("1wKaK");

var $dAm1N = parcelRequire("dAm1N");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $c16e5eed45703aee$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $3SU6e(),
        response: new $3SU6e()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $c16e5eed45703aee$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $dAm1N(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    // Hook up interceptors middleware
    var chain = [
        $1wKaK,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$c16e5eed45703aee$var$Axios.prototype.getUri = function getUri(config) {
    config = $dAm1N(this.defaults, config);
    return $fu7bf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$bizsW.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $c16e5eed45703aee$var$Axios.prototype[method] = function(url, config) {
        return this.request($bizsW.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$bizsW.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $c16e5eed45703aee$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($bizsW.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $c16e5eed45703aee$var$Axios;

});
parcelRegister("fu7bf", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");
function $b45f3a3c772e5f95$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($bizsW.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $bizsW.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($bizsW.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $bizsW.forEach(val, function parseValue(v) {
                if ($bizsW.isDate(v)) v = v.toISOString();
                else if ($bizsW.isObject(v)) v = JSON.stringify(v);
                parts.push($b45f3a3c772e5f95$var$encode(key) + "=" + $b45f3a3c772e5f95$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("3SU6e", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");
function $2d41ee72a98c18e7$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $2d41ee72a98c18e7$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $2d41ee72a98c18e7$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $2d41ee72a98c18e7$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $bizsW.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $2d41ee72a98c18e7$var$InterceptorManager;

});

parcelRegister("1wKaK", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");

var $ceBI0 = parcelRequire("ceBI0");

var $aPeVm = parcelRequire("aPeVm");

var $k84Zj = parcelRequire("k84Zj");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $11cc98757a14ad13$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $11cc98757a14ad13$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $ceBI0(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $bizsW.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $bizsW.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $k84Zj.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $11cc98757a14ad13$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $ceBI0(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$aPeVm(reason)) {
            $11cc98757a14ad13$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $ceBI0(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("ceBI0", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $bizsW.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("aPeVm", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("k84Zj", function(module, exports) {

var $gz4U1 = parcelRequire("gz4U1");
"use strict";

var $bizsW = parcelRequire("bizsW");

var $8v6j0 = parcelRequire("8v6j0");
var $ea786c7f90a3bacc$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $ea786c7f90a3bacc$var$setContentTypeIfUnset(headers, value) {
    if (!$bizsW.isUndefined(headers) && $bizsW.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $ea786c7f90a3bacc$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("fiFTE"));
    else if (typeof $gz4U1 !== "undefined" && Object.prototype.toString.call($gz4U1) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("fiFTE"));
    return adapter;
}
var $ea786c7f90a3bacc$var$defaults = {
    adapter: $ea786c7f90a3bacc$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $8v6j0(headers, "Accept");
            $8v6j0(headers, "Content-Type");
            if ($bizsW.isFormData(data) || $bizsW.isArrayBuffer(data) || $bizsW.isBuffer(data) || $bizsW.isStream(data) || $bizsW.isFile(data) || $bizsW.isBlob(data)) return data;
            if ($bizsW.isArrayBufferView(data)) return data.buffer;
            if ($bizsW.isURLSearchParams(data)) {
                $ea786c7f90a3bacc$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($bizsW.isObject(data)) {
                $ea786c7f90a3bacc$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$ea786c7f90a3bacc$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$bizsW.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $ea786c7f90a3bacc$var$defaults.headers[method] = {};
});
$bizsW.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $ea786c7f90a3bacc$var$defaults.headers[method] = $bizsW.merge($ea786c7f90a3bacc$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $ea786c7f90a3bacc$var$defaults;

});
parcelRegister("gz4U1", function(module, exports) {
// shim for using process in browser
var $c0f3b7c2c8346566$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c0f3b7c2c8346566$var$cachedSetTimeout;
var $c0f3b7c2c8346566$var$cachedClearTimeout;
function $c0f3b7c2c8346566$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $c0f3b7c2c8346566$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $c0f3b7c2c8346566$var$cachedSetTimeout = setTimeout;
        else $c0f3b7c2c8346566$var$cachedSetTimeout = $c0f3b7c2c8346566$var$defaultSetTimout;
    } catch (e) {
        $c0f3b7c2c8346566$var$cachedSetTimeout = $c0f3b7c2c8346566$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $c0f3b7c2c8346566$var$cachedClearTimeout = clearTimeout;
        else $c0f3b7c2c8346566$var$cachedClearTimeout = $c0f3b7c2c8346566$var$defaultClearTimeout;
    } catch (e) {
        $c0f3b7c2c8346566$var$cachedClearTimeout = $c0f3b7c2c8346566$var$defaultClearTimeout;
    }
})();
function $c0f3b7c2c8346566$var$runTimeout(fun) {
    if ($c0f3b7c2c8346566$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c0f3b7c2c8346566$var$cachedSetTimeout === $c0f3b7c2c8346566$var$defaultSetTimout || !$c0f3b7c2c8346566$var$cachedSetTimeout) && setTimeout) {
        $c0f3b7c2c8346566$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c0f3b7c2c8346566$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c0f3b7c2c8346566$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c0f3b7c2c8346566$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c0f3b7c2c8346566$var$runClearTimeout(marker) {
    if ($c0f3b7c2c8346566$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c0f3b7c2c8346566$var$cachedClearTimeout === $c0f3b7c2c8346566$var$defaultClearTimeout || !$c0f3b7c2c8346566$var$cachedClearTimeout) && clearTimeout) {
        $c0f3b7c2c8346566$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c0f3b7c2c8346566$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c0f3b7c2c8346566$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c0f3b7c2c8346566$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c0f3b7c2c8346566$var$queue = [];
var $c0f3b7c2c8346566$var$draining = false;
var $c0f3b7c2c8346566$var$currentQueue;
var $c0f3b7c2c8346566$var$queueIndex = -1;
function $c0f3b7c2c8346566$var$cleanUpNextTick() {
    if (!$c0f3b7c2c8346566$var$draining || !$c0f3b7c2c8346566$var$currentQueue) return;
    $c0f3b7c2c8346566$var$draining = false;
    if ($c0f3b7c2c8346566$var$currentQueue.length) $c0f3b7c2c8346566$var$queue = $c0f3b7c2c8346566$var$currentQueue.concat($c0f3b7c2c8346566$var$queue);
    else $c0f3b7c2c8346566$var$queueIndex = -1;
    if ($c0f3b7c2c8346566$var$queue.length) $c0f3b7c2c8346566$var$drainQueue();
}
function $c0f3b7c2c8346566$var$drainQueue() {
    if ($c0f3b7c2c8346566$var$draining) return;
    var timeout = $c0f3b7c2c8346566$var$runTimeout($c0f3b7c2c8346566$var$cleanUpNextTick);
    $c0f3b7c2c8346566$var$draining = true;
    var len = $c0f3b7c2c8346566$var$queue.length;
    while(len){
        $c0f3b7c2c8346566$var$currentQueue = $c0f3b7c2c8346566$var$queue;
        $c0f3b7c2c8346566$var$queue = [];
        while(++$c0f3b7c2c8346566$var$queueIndex < len)if ($c0f3b7c2c8346566$var$currentQueue) $c0f3b7c2c8346566$var$currentQueue[$c0f3b7c2c8346566$var$queueIndex].run();
        $c0f3b7c2c8346566$var$queueIndex = -1;
        len = $c0f3b7c2c8346566$var$queue.length;
    }
    $c0f3b7c2c8346566$var$currentQueue = null;
    $c0f3b7c2c8346566$var$draining = false;
    $c0f3b7c2c8346566$var$runClearTimeout(timeout);
}
$c0f3b7c2c8346566$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c0f3b7c2c8346566$var$queue.push(new $c0f3b7c2c8346566$var$Item(fun, args));
    if ($c0f3b7c2c8346566$var$queue.length === 1 && !$c0f3b7c2c8346566$var$draining) $c0f3b7c2c8346566$var$runTimeout($c0f3b7c2c8346566$var$drainQueue);
};
// v8 likes predictible objects
function $c0f3b7c2c8346566$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c0f3b7c2c8346566$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c0f3b7c2c8346566$var$process.title = "browser";
$c0f3b7c2c8346566$var$process.browser = true;
$c0f3b7c2c8346566$var$process.env = {};
$c0f3b7c2c8346566$var$process.argv = [];
$c0f3b7c2c8346566$var$process.version = ""; // empty string to avoid regexp issues
$c0f3b7c2c8346566$var$process.versions = {};
function $c0f3b7c2c8346566$var$noop() {}
$c0f3b7c2c8346566$var$process.on = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.addListener = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.once = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.off = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.removeListener = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.removeAllListeners = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.emit = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.prependListener = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.prependOnceListener = $c0f3b7c2c8346566$var$noop;
$c0f3b7c2c8346566$var$process.listeners = function(name) {
    return [];
};
$c0f3b7c2c8346566$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$c0f3b7c2c8346566$var$process.cwd = function() {
    return "/";
};
$c0f3b7c2c8346566$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$c0f3b7c2c8346566$var$process.umask = function() {
    return 0;
};

});

parcelRegister("8v6j0", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $bizsW.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("fiFTE", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");

var $hCbnp = parcelRequire("hCbnp");

var $fu7bf = parcelRequire("fu7bf");

var $kAWfJ = parcelRequire("kAWfJ");

var $2tnIo = parcelRequire("2tnIo");

var $hsDy9 = parcelRequire("hsDy9");

var $91DNb = parcelRequire("91DNb");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($bizsW.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $kAWfJ(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $fu7bf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $2tnIo(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $hCbnp(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($91DNb("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($91DNb("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($91DNb(timeoutErrorMessage, config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($bizsW.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("6UWDW"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $hsDy9(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $bizsW.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$bizsW.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("hCbnp", function(module, exports) {
"use strict";

var $91DNb = parcelRequire("91DNb");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($91DNb("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("91DNb", function(module, exports) {
"use strict";

var $exZgc = parcelRequire("exZgc");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $exZgc(error, config, code, request, response);
};

});
parcelRegister("exZgc", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("kAWfJ", function(module, exports) {
"use strict";

var $9yWTS = parcelRequire("9yWTS");

var $aGjhn = parcelRequire("aGjhn");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$9yWTS(requestedURL)) return $aGjhn(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("9yWTS", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("aGjhn", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("2tnIo", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $1cd0af8995f49b74$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $bizsW.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $bizsW.trim(line.substr(0, i)).toLowerCase();
        val = $bizsW.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $1cd0af8995f49b74$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("hsDy9", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");
module.exports = $bizsW.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $bizsW.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("6UWDW", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");
module.exports = $bizsW.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($bizsW.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($bizsW.isString(path)) cookie.push("path=" + path);
            if ($bizsW.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRegister("dAm1N", function(module, exports) {
"use strict";

var $bizsW = parcelRequire("bizsW");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "params",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "url",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "maxContentLength",
        "validateStatus",
        "maxRedirects",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath"
    ];
    $bizsW.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
    });
    $bizsW.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($bizsW.isObject(config2[prop])) config[prop] = $bizsW.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if ($bizsW.isObject(config1[prop])) config[prop] = $bizsW.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    $bizsW.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $bizsW.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    return config;
};

});


parcelRegister("53ZPL", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $3afd32787e517c98$var$Cancel(message) {
    this.message = message;
}
$3afd32787e517c98$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$3afd32787e517c98$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $3afd32787e517c98$var$Cancel;

});

parcelRegister("5kwOY", function(module, exports) {
"use strict";

var $53ZPL = parcelRequire("53ZPL");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $3e184797bd7d474c$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $53ZPL(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $3e184797bd7d474c$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $3e184797bd7d474c$var$CancelToken.source = function source() {
    var cancel;
    var token = new $3e184797bd7d474c$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $3e184797bd7d474c$var$CancelToken;

});

parcelRegister("gcHh0", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});




parcelRegister("2BEDj", function(module, exports) {

$parcel$export(module.exports, "authClient", function () { return $1e5e8e58ab6fd67b$export$22c80259b1397f7c; });

var $nMjJa = parcelRequire("nMjJa");

var $9kYD9 = parcelRequire("9kYD9");
// Create the Better Auth client
const $1e5e8e58ab6fd67b$export$22c80259b1397f7c = (0, $nMjJa.createAuthClient)({
    baseURL: "https://server2.coincraft.co",
    sessionName: "session",
    plugins: [
        (0, $9kYD9.magicLinkClient)(),
        (0, $9kYD9.organizationClient)(),
        (0, $9kYD9.customSessionClient)(),
        (0, $9kYD9.adminClient)()
    ]
});

});
parcelRegister("nMjJa", function(module, exports) {

$parcel$export(module.exports, "createAuthClient", function () { return $e5c9228211e1e5a7$export$fe8facb67c11a5fb; });

var $bgDb7 = parcelRequire("bgDb7");

var $aFVHE = parcelRequire("aFVHE");

var $7PdBe = parcelRequire("7PdBe");
parcelRequire("etuIp");
parcelRequire("1Nyw2");
parcelRequire("5AtET");
parcelRequire("03I28");
parcelRequire("gEnRY");
parcelRequire("luq3q");
function $e5c9228211e1e5a7$export$6ccbb43953eebf8(store, options = {}) {
    let snapshotRef = (0, $7PdBe.useRef)(store.get());
    const { keys: keys, deps: deps = [
        store,
        keys
    ] } = options;
    let subscribe = (0, $7PdBe.useCallback)((onChange)=>{
        const emitChange = (value)=>{
            if (snapshotRef.current === value) return;
            snapshotRef.current = value;
            onChange();
        };
        emitChange(store.value);
        if (keys?.length) return (0, $aFVHE.listenKeys)(store, keys, emitChange);
        return store.listen(emitChange);
    }, deps);
    let get = ()=>snapshotRef.current;
    return (0, $7PdBe.useSyncExternalStore)(subscribe, get, get);
}
function $e5c9228211e1e5a7$var$getAtomKey(str) {
    return `use${$e5c9228211e1e5a7$export$d07f57595c356899(str)}`;
}
function $e5c9228211e1e5a7$export$d07f57595c356899(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function $e5c9228211e1e5a7$export$fe8facb67c11a5fb(options) {
    const { pluginPathMethods: pluginPathMethods, pluginsActions: pluginsActions, pluginsAtoms: pluginsAtoms, $fetch: $fetch, $store: $store, atomListeners: atomListeners } = (0, $bgDb7.g)(options);
    let resolvedHooks = {};
    for (const [key, value] of Object.entries(pluginsAtoms))resolvedHooks[$e5c9228211e1e5a7$var$getAtomKey(key)] = ()=>$e5c9228211e1e5a7$export$6ccbb43953eebf8(value);
    const routes = {
        ...pluginsActions,
        ...resolvedHooks,
        $fetch: $fetch,
        $store: $store
    };
    const proxy = (0, $bgDb7.c)(routes, $fetch, pluginPathMethods, pluginsAtoms, atomListeners);
    return proxy;
}

});
parcelRegister("bgDb7", function(module, exports) {

$parcel$export(module.exports, "g", function () { return $9ff977ffcd76802c$export$39b482c5e57630a8; });
$parcel$export(module.exports, "c", function () { return $9ff977ffcd76802c$export$db3b6bfb95261072; });

var $etuIp = parcelRequire("etuIp");

var $1Nyw2 = parcelRequire("1Nyw2");

var $2DqEF = parcelRequire("2DqEF");

var $gEnRY = parcelRequire("gEnRY");

var $luq3q = parcelRequire("luq3q");
const $9ff977ffcd76802c$var$redirectPlugin = {
    id: "redirect",
    name: "Redirect",
    hooks: {
        onSuccess (context) {
            if (context.data?.url && context.data?.redirect) {
                if (typeof window !== "undefined" && window.location) {
                    if (window.location) try {
                        window.location.href = context.data.url;
                    } catch  {}
                }
            }
        }
    }
};
function $9ff977ffcd76802c$var$getSessionAtom($fetch) {
    const $signal = (0, $2DqEF.atom)(false);
    const session = (0, $gEnRY.u)($signal, "/get-session", $fetch, {
        method: "GET"
    });
    return {
        session: session,
        $sessionSignal: $signal
    };
}
const $9ff977ffcd76802c$export$39b482c5e57630a8 = (options, loadEnv)=>{
    const isCredentialsSupported = "credentials" in Request.prototype;
    const baseURL = (0, $1Nyw2.a)(options?.baseURL, options?.basePath, void 0, loadEnv) ?? "/api/auth";
    const pluginsFetchPlugins = options?.plugins?.flatMap((plugin)=>plugin.fetchPlugins).filter((pl)=>pl !== void 0) || [];
    const lifeCyclePlugin = {
        id: "lifecycle-hooks",
        name: "lifecycle-hooks",
        hooks: {
            onSuccess: options?.fetchOptions?.onSuccess,
            onError: options?.fetchOptions?.onError,
            onRequest: options?.fetchOptions?.onRequest,
            onResponse: options?.fetchOptions?.onResponse
        }
    };
    const { onSuccess: onSuccess, onError: onError, onRequest: onRequest, onResponse: onResponse, ...restOfFetchOptions } = options?.fetchOptions || {};
    const $fetch = (0, $etuIp.createFetch)({
        baseURL: baseURL,
        ...isCredentialsSupported ? {
            credentials: "include"
        } : {},
        method: "GET",
        jsonParser (text) {
            if (!text) return null;
            return (0, $luq3q.p)(text, {
                strict: false
            });
        },
        customFetchImpl: fetch,
        ...restOfFetchOptions,
        plugins: [
            lifeCyclePlugin,
            ...restOfFetchOptions.plugins || [],
            ...options?.disableDefaultFetchPlugins ? [] : [
                $9ff977ffcd76802c$var$redirectPlugin
            ],
            ...pluginsFetchPlugins
        ]
    });
    const { $sessionSignal: $sessionSignal, session: session } = $9ff977ffcd76802c$var$getSessionAtom($fetch);
    const plugins = options?.plugins || [];
    let pluginsActions = {};
    let pluginsAtoms = {
        $sessionSignal: $sessionSignal,
        session: session
    };
    let pluginPathMethods = {
        "/sign-out": "POST",
        "/revoke-sessions": "POST",
        "/revoke-other-sessions": "POST",
        "/delete-user": "POST"
    };
    const atomListeners = [
        {
            signal: "$sessionSignal",
            matcher (path) {
                return path === "/sign-out" || path === "/update-user" || path.startsWith("/sign-in") || path.startsWith("/sign-up") || path === "/delete-user" || path === "/verify-email";
            }
        }
    ];
    for (const plugin of plugins){
        if (plugin.getAtoms) Object.assign(pluginsAtoms, plugin.getAtoms?.($fetch));
        if (plugin.pathMethods) Object.assign(pluginPathMethods, plugin.pathMethods);
        if (plugin.atomListeners) atomListeners.push(...plugin.atomListeners);
    }
    const $store = {
        notify: (signal)=>{
            pluginsAtoms[signal].set(!pluginsAtoms[signal].get());
        },
        listen: (signal, listener)=>{
            pluginsAtoms[signal].subscribe(listener);
        },
        atoms: pluginsAtoms
    };
    for (const plugin of plugins)if (plugin.getActions) Object.assign(pluginsActions, plugin.getActions?.($fetch, $store, options));
    return {
        get baseURL () {
            return baseURL;
        },
        pluginsActions: pluginsActions,
        pluginsAtoms: pluginsAtoms,
        pluginPathMethods: pluginPathMethods,
        atomListeners: atomListeners,
        $fetch: $fetch,
        $store: $store
    };
};
function $9ff977ffcd76802c$var$isAtom(value) {
    return typeof value === "object" && value !== null && "get" in value && typeof value.get === "function" && "lc" in value && typeof value.lc === "number";
}
function $9ff977ffcd76802c$var$getMethod(path, knownPathMethods, args) {
    const method = knownPathMethods[path];
    const { fetchOptions: fetchOptions, query: query, ...body } = args || {};
    if (method) return method;
    if (fetchOptions?.method) return fetchOptions.method;
    if (body && Object.keys(body).length > 0) return "POST";
    return "GET";
}
function $9ff977ffcd76802c$export$db3b6bfb95261072(routes, client, knownPathMethods, atoms, atomListeners) {
    function createProxy(path = []) {
        return new Proxy(function() {}, {
            get (_, prop) {
                if (typeof prop !== "string") return void 0;
                if (prop === "then" || prop === "catch" || prop === "finally") return void 0;
                const fullPath = [
                    ...path,
                    prop
                ];
                let current = routes;
                for (const segment of fullPath)if (current && typeof current === "object" && segment in current) current = current[segment];
                else {
                    current = void 0;
                    break;
                }
                if (typeof current === "function") return current;
                if ($9ff977ffcd76802c$var$isAtom(current)) return current;
                return createProxy(fullPath);
            },
            apply: async (_, __, args)=>{
                const routePath = "/" + path.map((segment)=>segment.replace(/[A-Z]/g, (letter)=>`-${letter.toLowerCase()}`)).join("/");
                const arg = args[0] || {};
                const fetchOptions = args[1] || {};
                const { query: query, fetchOptions: argFetchOptions, ...body } = arg;
                const options = {
                    ...fetchOptions,
                    ...argFetchOptions
                };
                const method = $9ff977ffcd76802c$var$getMethod(routePath, knownPathMethods, arg);
                return await client(routePath, {
                    ...options,
                    body: method === "GET" ? void 0 : {
                        ...body,
                        ...options?.body || {}
                    },
                    query: query || options?.query,
                    method: method,
                    async onSuccess (context) {
                        await options?.onSuccess?.(context);
                        const matches = atomListeners?.find((s)=>s.matcher(routePath));
                        if (!matches) return;
                        const signal = atoms[matches.signal];
                        if (!signal) return;
                        const val = signal.get();
                        setTimeout(()=>{
                            signal.set(!val);
                        }, 10);
                    }
                });
            }
        });
    }
    return createProxy();
}

});
parcelRegister("etuIp", function(module, exports) {

$parcel$export(module.exports, "createFetch", function () { return $a89b9988149453d4$export$3d173a42d8c9a48a; });
var $a89b9988149453d4$var$__defProp = Object.defineProperty;
var $a89b9988149453d4$var$__defProps = Object.defineProperties;
var $a89b9988149453d4$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a89b9988149453d4$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a89b9988149453d4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a89b9988149453d4$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a89b9988149453d4$var$__defNormalProp = (obj, key, value)=>key in obj ? $a89b9988149453d4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a89b9988149453d4$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a89b9988149453d4$var$__hasOwnProp.call(b, prop)) $a89b9988149453d4$var$__defNormalProp(a, prop, b[prop]);
    if ($a89b9988149453d4$var$__getOwnPropSymbols) {
        for (var prop of $a89b9988149453d4$var$__getOwnPropSymbols(b))if ($a89b9988149453d4$var$__propIsEnum.call(b, prop)) $a89b9988149453d4$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a89b9988149453d4$var$__spreadProps = (a, b)=>$a89b9988149453d4$var$__defProps(a, $a89b9988149453d4$var$__getOwnPropDescs(b));
// src/error.ts
var $a89b9988149453d4$export$1ec4b49d46b7b978 = class extends Error {
    constructor(status, statusText, error){
        super(statusText || status.toString(), {
            cause: error
        });
        this.status = status;
        this.statusText = statusText;
        this.error = error;
    }
};
// src/plugins.ts
var $a89b9988149453d4$export$be211df7b1eeb33e = async (url, options)=>{
    var _a, _b, _c, _d, _e, _f;
    let opts = options || {};
    const hooks = {
        onRequest: [
            options == null ? void 0 : options.onRequest
        ],
        onResponse: [
            options == null ? void 0 : options.onResponse
        ],
        onSuccess: [
            options == null ? void 0 : options.onSuccess
        ],
        onError: [
            options == null ? void 0 : options.onError
        ],
        onRetry: [
            options == null ? void 0 : options.onRetry
        ]
    };
    if (!options || !(options == null ? void 0 : options.plugins)) return {
        url: url,
        options: opts,
        hooks: hooks
    };
    for (const plugin of (options == null ? void 0 : options.plugins) || []){
        if (plugin.init) {
            const pluginRes = await ((_a = plugin.init) == null ? void 0 : _a.call(plugin, url.toString(), options));
            opts = pluginRes.options || opts;
            url = pluginRes.url;
        }
        hooks.onRequest.push((_b = plugin.hooks) == null ? void 0 : _b.onRequest);
        hooks.onResponse.push((_c = plugin.hooks) == null ? void 0 : _c.onResponse);
        hooks.onSuccess.push((_d = plugin.hooks) == null ? void 0 : _d.onSuccess);
        hooks.onError.push((_e = plugin.hooks) == null ? void 0 : _e.onError);
        hooks.onRetry.push((_f = plugin.hooks) == null ? void 0 : _f.onRetry);
    }
    return {
        url: url,
        options: opts,
        hooks: hooks
    };
};
// src/retry.ts
var $a89b9988149453d4$var$LinearRetryStrategy = class {
    constructor(options){
        this.options = options;
    }
    shouldAttemptRetry(attempt, response) {
        if (this.options.shouldRetry) return Promise.resolve(attempt < this.options.attempts && this.options.shouldRetry(response));
        return Promise.resolve(attempt < this.options.attempts);
    }
    getDelay() {
        return this.options.delay;
    }
};
var $a89b9988149453d4$var$ExponentialRetryStrategy = class {
    constructor(options){
        this.options = options;
    }
    shouldAttemptRetry(attempt, response) {
        if (this.options.shouldRetry) return Promise.resolve(attempt < this.options.attempts && this.options.shouldRetry(response));
        return Promise.resolve(attempt < this.options.attempts);
    }
    getDelay(attempt) {
        const delay = Math.min(this.options.maxDelay, this.options.baseDelay * 2 ** attempt);
        return delay;
    }
};
function $a89b9988149453d4$export$5afd80a626249200(options) {
    if (typeof options === "number") return new $a89b9988149453d4$var$LinearRetryStrategy({
        type: "linear",
        attempts: options,
        delay: 1e3
    });
    switch(options.type){
        case "linear":
            return new $a89b9988149453d4$var$LinearRetryStrategy(options);
        case "exponential":
            return new $a89b9988149453d4$var$ExponentialRetryStrategy(options);
        default:
            throw new Error("Invalid retry strategy");
    }
}
// src/auth.ts
var $a89b9988149453d4$var$getAuthHeader = async (options)=>{
    const headers = {};
    const getValue = async (value)=>typeof value === "function" ? await value() : value;
    if (options == null ? void 0 : options.auth) {
        if (options.auth.type === "Bearer") {
            const token = await getValue(options.auth.token);
            if (!token) return headers;
            headers["authorization"] = `Bearer ${token}`;
        } else if (options.auth.type === "Basic") {
            const username = getValue(options.auth.username);
            const password = getValue(options.auth.password);
            if (!username || !password) return headers;
            headers["authorization"] = `Basic ${btoa(`${username}:${password}`)}`;
        } else if (options.auth.type === "Custom") {
            const value = getValue(options.auth.value);
            if (!value) return headers;
            headers["authorization"] = `${getValue(options.auth.prefix)} ${value}`;
        }
    }
    return headers;
};
// src/utils.ts
var $a89b9988149453d4$var$JSON_RE = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function $a89b9988149453d4$export$7050699849f0a195(request) {
    const _contentType = request.headers.get("content-type");
    const textTypes = /* @__PURE__ */ new Set([
        "image/svg",
        "application/xml",
        "application/xhtml",
        "application/html"
    ]);
    if (!_contentType) return "json";
    const contentType = _contentType.split(";").shift() || "";
    if ($a89b9988149453d4$var$JSON_RE.test(contentType)) return "json";
    if (textTypes.has(contentType) || contentType.startsWith("text/")) return "text";
    return "blob";
}
function $a89b9988149453d4$export$6e49ee1d3bb53d6a(value) {
    try {
        JSON.parse(value);
        return true;
    } catch (error) {
        return false;
    }
}
function $a89b9988149453d4$export$e9c37eb9108255c(value) {
    if (value === void 0) return false;
    const t = typeof value;
    if (t === "string" || t === "number" || t === "boolean" || t === null) return true;
    if (t !== "object") return false;
    if (Array.isArray(value)) return true;
    if (value.buffer) return false;
    return value.constructor && value.constructor.name === "Object" || typeof value.toJSON === "function";
}
function $a89b9988149453d4$export$de908365a6d7ba3a(text) {
    try {
        return JSON.parse(text);
    } catch (error) {
        return text;
    }
}
function $a89b9988149453d4$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $a89b9988149453d4$export$3105c6651375d4fa(options) {
    if (options == null ? void 0 : options.customFetchImpl) return options.customFetchImpl;
    if (typeof globalThis !== "undefined" && $a89b9988149453d4$export$f6e2535fb5126e54(globalThis.fetch)) return globalThis.fetch;
    if (typeof window !== "undefined" && $a89b9988149453d4$export$f6e2535fb5126e54(window.fetch)) return window.fetch;
    throw new Error("No fetch implementation found");
}
function $a89b9988149453d4$export$6be4b19980799a6a(method) {
    if (!method) return false;
    const payloadMethod = [
        "POST",
        "PUT",
        "PATCH",
        "DELETE"
    ];
    return payloadMethod.includes(method.toUpperCase());
}
function $a89b9988149453d4$export$9731b64d88bc89bf(method) {
    const routeMethod = [
        "GET",
        "POST",
        "PUT",
        "PATCH",
        "DELETE"
    ];
    if (!method) return false;
    return routeMethod.includes(method.toUpperCase());
}
async function $a89b9988149453d4$export$6a9b8dd1339b1a17(opts) {
    const headers = new Headers(opts == null ? void 0 : opts.headers);
    const authHeader = await $a89b9988149453d4$var$getAuthHeader(opts);
    for (const [key, value] of Object.entries(authHeader || {}))headers.set(key, value);
    if (!headers.has("content-type")) {
        const t = $a89b9988149453d4$export$aa3d4714533adf37(opts == null ? void 0 : opts.body);
        if (t) headers.set("content-type", t);
    }
    return headers;
}
function $a89b9988149453d4$export$152462a4e1ffe278(url, options) {
    if (url.startsWith("@")) {
        const m = url.toString().split("@")[1].split("/")[0];
        if ($a89b9988149453d4$export$e13b82b2b0368a6a.includes(m)) url = url.replace(`@${m}/`, "/");
    }
    let _url;
    try {
        if (url.startsWith("http")) _url = url;
        else {
            let baseURL = options == null ? void 0 : options.baseURL;
            if (baseURL && !(baseURL == null ? void 0 : baseURL.endsWith("/"))) baseURL = baseURL + "/";
            if (url.startsWith("/")) _url = new URL(url.substring(1), baseURL);
            else _url = new URL(url, options == null ? void 0 : options.baseURL);
        }
    } catch (e) {
        if (e instanceof TypeError) {
            if (!(options == null ? void 0 : options.baseURL)) throw TypeError(`Invalid URL ${url}. Are you passing in a relative url but not setting the baseURL?`);
            throw TypeError(`Invalid URL ${url}. Please validate that you are passing the correct input.`);
        }
        throw e;
    }
    if (options == null ? void 0 : options.params) {
        if (Array.isArray(options == null ? void 0 : options.params)) {
            const params = (options == null ? void 0 : options.params) ? Array.isArray(options.params) ? `/${options.params.join("/")}` : `/${Object.values(options.params).join("/")}` : "";
            _url = _url.toString().split("/:")[0];
            _url = `${_url.toString()}${params}`;
        } else for (const [key, value] of Object.entries(options == null ? void 0 : options.params))_url = _url.toString().replace(`:${key}`, String(value));
    }
    const __url = new URL(_url);
    const queryParams = options == null ? void 0 : options.query;
    if (queryParams) for (const [key, value] of Object.entries(queryParams))__url.searchParams.append(key, String(value));
    return __url;
}
function $a89b9988149453d4$export$aa3d4714533adf37(body) {
    if ($a89b9988149453d4$export$e9c37eb9108255c(body)) return "application/json";
    return null;
}
function $a89b9988149453d4$export$135b49d4bc2964c6(options) {
    if (!(options == null ? void 0 : options.body)) return null;
    const headers = new Headers(options == null ? void 0 : options.headers);
    if ($a89b9988149453d4$export$e9c37eb9108255c(options.body) && !headers.has("content-type")) {
        for (const [key, value] of Object.entries(options == null ? void 0 : options.body))if (value instanceof Date) options.body[key] = value.toISOString();
        return JSON.stringify(options.body);
    }
    return options.body;
}
function $a89b9988149453d4$export$8793fab959da70d1(url, options) {
    var _a;
    if (options == null ? void 0 : options.method) return options.method.toUpperCase();
    if (url.startsWith("@")) {
        const pMethod = (_a = url.split("@")[1]) == null ? void 0 : _a.split("/")[0];
        if (!$a89b9988149453d4$export$e13b82b2b0368a6a.includes(pMethod)) return (options == null ? void 0 : options.body) ? "POST" : "GET";
        return pMethod.toUpperCase();
    }
    return (options == null ? void 0 : options.body) ? "POST" : "GET";
}
function $a89b9988149453d4$export$d2e3f47e67110e3a(options, controller) {
    let abortTimeout;
    if (!(options == null ? void 0 : options.signal) && (options == null ? void 0 : options.timeout)) abortTimeout = setTimeout(()=>controller == null ? void 0 : controller.abort(), options == null ? void 0 : options.timeout);
    return {
        abortTimeout: abortTimeout,
        clearTimeout: ()=>{
            if (abortTimeout) clearTimeout(abortTimeout);
        }
    };
}
function $a89b9988149453d4$export$c496cb0ca76513f5(data, responseType) {
    if (responseType === "json") return JSON.parse(data);
    return data;
}
var $a89b9988149453d4$export$2191b9da168c6cf0 = class _ValidationError extends Error {
    constructor(issues, message){
        super(message || JSON.stringify(issues, null, 2));
        this.issues = issues;
        Object.setPrototypeOf(this, _ValidationError.prototype);
    }
};
async function $a89b9988149453d4$export$f0e128f343327807(schema, input) {
    let result = await schema["~standard"].validate(input);
    if (result.issues) throw new $a89b9988149453d4$export$2191b9da168c6cf0(result.issues);
    return result.value;
}
// src/create-fetch/schema.ts
var $a89b9988149453d4$export$e13b82b2b0368a6a = [
    "get",
    "post",
    "put",
    "patch",
    "delete"
];
var $a89b9988149453d4$export$5f4ce795563f4211 = (schema, config)=>{
    return {
        schema: schema,
        config: config
    };
};
// src/create-fetch/index.ts
var $a89b9988149453d4$export$a10581e202712bb3 = (config)=>({
        id: "apply-schema",
        name: "Apply Schema",
        version: "1.0.0",
        async init (url, options) {
            var _a, _b, _c, _d;
            const schema = ((_b = (_a = config.plugins) == null ? void 0 : _a.find((plugin)=>{
                var _a2;
                return ((_a2 = plugin.schema) == null ? void 0 : _a2.config) ? url.startsWith(plugin.schema.config.baseURL || "") || url.startsWith(plugin.schema.config.prefix || "") : false;
            })) == null ? void 0 : _b.schema) || config.schema;
            if (schema) {
                let urlKey = url;
                if ((_c = schema.config) == null ? void 0 : _c.prefix) {
                    if (urlKey.startsWith(schema.config.prefix)) {
                        urlKey = urlKey.replace(schema.config.prefix, "");
                        if (schema.config.baseURL) url = url.replace(schema.config.prefix, schema.config.baseURL);
                    }
                }
                if ((_d = schema.config) == null ? void 0 : _d.baseURL) {
                    if (urlKey.startsWith(schema.config.baseURL)) urlKey = urlKey.replace(schema.config.baseURL, "");
                }
                const keySchema = schema.schema[urlKey];
                if (keySchema) {
                    let opts = $a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, options), {
                        method: keySchema.method,
                        output: keySchema.output
                    });
                    if (!(options == null ? void 0 : options.disableValidation)) opts = $a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, opts), {
                        body: keySchema.input ? await $a89b9988149453d4$export$f0e128f343327807(keySchema.input, options == null ? void 0 : options.body) : options == null ? void 0 : options.body,
                        params: keySchema.params ? await $a89b9988149453d4$export$f0e128f343327807(keySchema.params, options == null ? void 0 : options.params) : options == null ? void 0 : options.params,
                        query: keySchema.query ? await $a89b9988149453d4$export$f0e128f343327807(keySchema.query, options == null ? void 0 : options.query) : options == null ? void 0 : options.query
                    });
                    return {
                        url: url,
                        options: opts
                    };
                }
            }
            return {
                url: url,
                options: options
            };
        }
    });
var $a89b9988149453d4$export$3d173a42d8c9a48a = (config)=>{
    async function $fetch(url, options) {
        const opts = $a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues($a89b9988149453d4$var$__spreadValues({}, config), options), {
            plugins: [
                ...(config == null ? void 0 : config.plugins) || [],
                $a89b9988149453d4$export$a10581e202712bb3(config || {})
            ]
        });
        if (config == null ? void 0 : config.catchAllError) try {
            return await $a89b9988149453d4$export$6c69aae6e4fe698e(url, opts);
        } catch (error) {
            return {
                data: null,
                error: {
                    status: 500,
                    statusText: "Fetch Error",
                    message: "Fetch related error. Captured by catchAllError option. See error property for more details.",
                    error: error
                }
            };
        }
        return await $a89b9988149453d4$export$6c69aae6e4fe698e(url, opts);
    }
    return $fetch;
};
// src/url.ts
function $a89b9988149453d4$var$getURL2(url, option) {
    let { baseURL: baseURL, params: params, query: query } = option || {
        query: {},
        params: {},
        baseURL: ""
    };
    let basePath = url.startsWith("http") ? url.split("/").slice(0, 3).join("/") : baseURL || "";
    if (url.startsWith("@")) {
        const m = url.toString().split("@")[1].split("/")[0];
        if ($a89b9988149453d4$export$e13b82b2b0368a6a.includes(m)) url = url.replace(`@${m}/`, "/");
    }
    if (!basePath.endsWith("/")) basePath += "/";
    let [path, urlQuery] = url.replace(basePath, "").split("?");
    const queryParams = new URLSearchParams(urlQuery);
    for (const [key, value] of Object.entries(query || {})){
        if (value == null) continue;
        queryParams.set(key, String(value));
    }
    if (params) {
        if (Array.isArray(params)) {
            const paramPaths = path.split("/").filter((p)=>p.startsWith(":"));
            for (const [index, key] of paramPaths.entries()){
                const value = params[index];
                path = path.replace(key, value);
            }
        } else for (const [key, value] of Object.entries(params))path = path.replace(`:${key}`, String(value));
    }
    path = path.split("/").map(encodeURIComponent).join("/");
    if (path.startsWith("/")) path = path.slice(1);
    let queryParamString = queryParams.toString();
    queryParamString = queryParamString.length > 0 ? `?${queryParamString}`.replace(/\+/g, "%20") : "";
    if (!basePath.startsWith("http")) return `${basePath}${path}${queryParamString}`;
    const _url = new URL(`${path}${queryParamString}`, basePath);
    return _url;
}
// src/fetch.ts
var $a89b9988149453d4$export$6c69aae6e4fe698e = async (url, options)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { hooks: hooks, url: __url, options: opts } = await $a89b9988149453d4$export$be211df7b1eeb33e(url, options);
    const fetch = $a89b9988149453d4$export$3105c6651375d4fa(opts);
    const controller = new AbortController();
    const signal = (_a = opts.signal) != null ? _a : controller.signal;
    const _url = $a89b9988149453d4$var$getURL2(__url, opts);
    const body = $a89b9988149453d4$export$135b49d4bc2964c6(opts);
    const headers = await $a89b9988149453d4$export$6a9b8dd1339b1a17(opts);
    const method = $a89b9988149453d4$export$8793fab959da70d1(__url, opts);
    let context = $a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, opts), {
        url: _url,
        headers: headers,
        body: body,
        method: method,
        signal: signal
    });
    for (const onRequest of hooks.onRequest)if (onRequest) {
        const res = await onRequest(context);
        if (res instanceof Object) context = res;
    }
    if ("pipeTo" in context && typeof context.pipeTo === "function" || typeof ((_b = options == null ? void 0 : options.body) == null ? void 0 : _b.pipe) === "function") {
        if (!("duplex" in context)) context.duplex = "half";
    }
    const { clearTimeout: clearTimeout2 } = $a89b9988149453d4$export$d2e3f47e67110e3a(opts, controller);
    let response = await fetch(context.url, context);
    clearTimeout2();
    const responseContext = {
        response: response,
        request: context
    };
    for (const onResponse of hooks.onResponse)if (onResponse) {
        const r = await onResponse($a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, responseContext), {
            response: ((_c = options == null ? void 0 : options.hookOptions) == null ? void 0 : _c.cloneResponse) ? response.clone() : response
        }));
        if (r instanceof Response) response = r;
        else if (r instanceof Object) response = r.response;
    }
    if (response.ok) {
        const hasBody = context.method !== "HEAD";
        if (!hasBody) return {
            data: "",
            error: null
        };
        const responseType = $a89b9988149453d4$export$7050699849f0a195(response);
        const successContext = {
            data: "",
            response: response,
            request: context
        };
        if (responseType === "json" || responseType === "text") {
            const text = await response.text();
            const parser2 = (_d = context.jsonParser) != null ? _d : $a89b9988149453d4$export$de908365a6d7ba3a;
            const data = await parser2(text);
            successContext.data = data;
        } else successContext.data = await response[responseType]();
        if (context == null ? void 0 : context.output) {
            if (context.output && !context.disableValidation) successContext.data = await $a89b9988149453d4$export$f0e128f343327807(context.output, successContext.data);
        }
        for (const onSuccess of hooks.onSuccess)if (onSuccess) await onSuccess($a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, successContext), {
            response: ((_e = options == null ? void 0 : options.hookOptions) == null ? void 0 : _e.cloneResponse) ? response.clone() : response
        }));
        if (options == null ? void 0 : options.throw) return successContext.data;
        return {
            data: successContext.data,
            error: null
        };
    }
    const parser = (_f = options == null ? void 0 : options.jsonParser) != null ? _f : $a89b9988149453d4$export$de908365a6d7ba3a;
    const responseText = await response.text();
    const isJSONResponse = $a89b9988149453d4$export$6e49ee1d3bb53d6a(responseText);
    const errorObject = isJSONResponse ? await parser(responseText) : null;
    const errorContext = {
        response: response,
        responseText: responseText,
        request: context,
        error: $a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, errorObject), {
            status: response.status,
            statusText: response.statusText
        })
    };
    for (const onError of hooks.onError)if (onError) await onError($a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, errorContext), {
        response: ((_g = options == null ? void 0 : options.hookOptions) == null ? void 0 : _g.cloneResponse) ? response.clone() : response
    }));
    if (options == null ? void 0 : options.retry) {
        const retryStrategy = $a89b9988149453d4$export$5afd80a626249200(options.retry);
        const _retryAttempt = (_h = options.retryAttempt) != null ? _h : 0;
        if (await retryStrategy.shouldAttemptRetry(_retryAttempt, response)) {
            for (const onRetry of hooks.onRetry)if (onRetry) await onRetry(responseContext);
            const delay = retryStrategy.getDelay(_retryAttempt);
            await new Promise((resolve)=>setTimeout(resolve, delay));
            return await $a89b9988149453d4$export$6c69aae6e4fe698e(url, $a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, options), {
                retryAttempt: _retryAttempt + 1
            }));
        }
    }
    if (options == null ? void 0 : options.throw) throw new $a89b9988149453d4$export$1ec4b49d46b7b978(response.status, response.statusText, isJSONResponse ? errorObject : responseText);
    return {
        data: null,
        error: $a89b9988149453d4$var$__spreadProps($a89b9988149453d4$var$__spreadValues({}, errorObject), {
            status: response.status,
            statusText: response.statusText
        })
    };
};

});

parcelRegister("1Nyw2", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $5e0fe087013e574b$export$407448d2b89b1813; });

var $5AtET = parcelRequire("5AtET");

var $03I28 = parcelRequire("03I28");
function $5e0fe087013e574b$var$checkHasPath(url) {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.pathname !== "/";
    } catch (error) {
        throw new (0, $03I28.B)(`Invalid base URL: ${url}. Please provide a valid base URL.`);
    }
}
function $5e0fe087013e574b$var$withPath(url, path = "/api/auth") {
    const hasPath = $5e0fe087013e574b$var$checkHasPath(url);
    if (hasPath) return url;
    path = path.startsWith("/") ? path : `/${path}`;
    return `${url.replace(/\/+$/, "")}${path}`;
}
function $5e0fe087013e574b$export$407448d2b89b1813(url, path, request, loadEnv) {
    if (url) return $5e0fe087013e574b$var$withPath(url, path);
    if (loadEnv !== false) {
        const fromEnv = (0, $5AtET.e).BETTER_AUTH_URL || (0, $5AtET.e).NEXT_PUBLIC_BETTER_AUTH_URL || (0, $5AtET.e).PUBLIC_BETTER_AUTH_URL || (0, $5AtET.e).NUXT_PUBLIC_BETTER_AUTH_URL || (0, $5AtET.e).NUXT_PUBLIC_AUTH_URL || ((0, $5AtET.e).BASE_URL !== "/" ? (0, $5AtET.e).BASE_URL : void 0);
        if (fromEnv) return $5e0fe087013e574b$var$withPath(fromEnv, path);
    }
    const fromRequest = request?.headers.get("x-forwarded-host");
    const fromRequestProto = request?.headers.get("x-forwarded-proto");
    if (fromRequest && fromRequestProto) return $5e0fe087013e574b$var$withPath(`${fromRequestProto}://${fromRequest}`, path);
    if (request) {
        const url2 = $5e0fe087013e574b$export$39b482c5e57630a8(request.url);
        if (!url2) throw new (0, $03I28.B)("Could not get origin from request. Please provide a valid base URL.");
        return $5e0fe087013e574b$var$withPath(url2, path);
    }
    if (typeof window !== "undefined" && window.location) return $5e0fe087013e574b$var$withPath(window.location.origin, path);
    return void 0;
}
function $5e0fe087013e574b$export$39b482c5e57630a8(url) {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.origin;
    } catch (error) {
        return null;
    }
}
function $5e0fe087013e574b$export$db3b6bfb95261072(url) {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.protocol;
    } catch (error) {
        return null;
    }
}
function $5e0fe087013e574b$export$8b22cf2602fb60ce(url) {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.host;
    } catch (error) {
        return url;
    }
}

});
parcelRegister("5AtET", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $650b3bc9661bcce0$export$f1e1789686576879; });

var $gz4U1 = parcelRequire("gz4U1");
const $650b3bc9661bcce0$var$_envShim = /* @__PURE__ */ Object.create(null);
const $650b3bc9661bcce0$var$_getEnv = (useShim)=>globalThis.process?.env || //@ts-expect-error
    globalThis.Deno?.env.toObject() || //@ts-expect-error
    globalThis.__env__ || (useShim ? $650b3bc9661bcce0$var$_envShim : globalThis);
const $650b3bc9661bcce0$export$f1e1789686576879 = new Proxy($650b3bc9661bcce0$var$_envShim, {
    get (_, prop) {
        const env2 = $650b3bc9661bcce0$var$_getEnv();
        return env2[prop] ?? $650b3bc9661bcce0$var$_envShim[prop];
    },
    has (_, prop) {
        const env2 = $650b3bc9661bcce0$var$_getEnv();
        return prop in env2 || prop in $650b3bc9661bcce0$var$_envShim;
    },
    set (_, prop, value) {
        const env2 = $650b3bc9661bcce0$var$_getEnv(true);
        env2[prop] = value;
        return true;
    },
    deleteProperty (_, prop) {
        if (!prop) return false;
        const env2 = $650b3bc9661bcce0$var$_getEnv(true);
        delete env2[prop];
        return true;
    },
    ownKeys () {
        const env2 = $650b3bc9661bcce0$var$_getEnv(true);
        return Object.keys(env2);
    }
});
function $650b3bc9661bcce0$var$toBoolean(val) {
    return val ? val !== "false" : false;
}
const $650b3bc9661bcce0$var$nodeENV = typeof $gz4U1 !== "undefined" && $gz4U1.env && "production" || "";
const $650b3bc9661bcce0$export$8b22cf2602fb60ce = $650b3bc9661bcce0$var$nodeENV === "production";
const $650b3bc9661bcce0$export$407448d2b89b1813 = $650b3bc9661bcce0$var$nodeENV === "dev" || $650b3bc9661bcce0$var$nodeENV === "development";
const $650b3bc9661bcce0$export$23f2a1d2818174ef = ()=>$650b3bc9661bcce0$var$nodeENV === "test" || $650b3bc9661bcce0$var$toBoolean($650b3bc9661bcce0$export$f1e1789686576879.TEST);
function $650b3bc9661bcce0$export$39b482c5e57630a8(key, fallback) {
    if (typeof $gz4U1 !== "undefined" && $gz4U1.env) return $gz4U1.env[key] ?? fallback;
    if (typeof Deno !== "undefined") return Deno.env.get(key) ?? fallback;
    if (typeof Bun !== "undefined") return Bun.env[key] ?? fallback;
    return fallback;
}
function $650b3bc9661bcce0$export$db3b6bfb95261072(key, fallback = true) {
    const value = $650b3bc9661bcce0$export$39b482c5e57630a8(key);
    if (!value) return fallback;
    return value !== "0" && value.toLowerCase() !== "false" && value !== "";
}
const $650b3bc9661bcce0$export$a9c23c6ac3fc3eca = {
    get BETTER_AUTH_TELEMETRY_ENDPOINT () {
        return $650b3bc9661bcce0$export$39b482c5e57630a8("BETTER_AUTH_TELEMETRY_ENDPOINT", "https://telemetry.better-auth.com/v1/track");
    }
};

});

parcelRegister("03I28", function(module, exports) {

$parcel$export(module.exports, "B", function () { return $cb4f352b7be893a4$export$ef35774e6d314e91; });
class $cb4f352b7be893a4$export$ef35774e6d314e91 extends Error {
    constructor(message, cause){
        super(message);
        this.name = "BetterAuthError";
        this.message = message;
        this.cause = cause;
        this.stack = "";
    }
}
class $cb4f352b7be893a4$export$3a1a48c8f6ef640e extends $cb4f352b7be893a4$export$ef35774e6d314e91 {
    constructor(pkgName){
        super(`The package "${pkgName}" is required. Make sure it is installed.`, pkgName);
    }
}

});


parcelRegister("2DqEF", function(module, exports) {

$parcel$export(module.exports, "atom", function () { return $1eb3e6682b5aad44$export$5fb5cc0d078610b; });

let $1eb3e6682b5aad44$var$listenerQueue = [];
let $1eb3e6682b5aad44$var$lqIndex = 0;
const $1eb3e6682b5aad44$var$QUEUE_ITEMS_PER_LISTENER = 4;
let $1eb3e6682b5aad44$export$8a255bebea64f637 = 0;
let $1eb3e6682b5aad44$export$5fb5cc0d078610b = (initialValue)=>{
    let listeners = [];
    let $atom = {
        get () {
            if (!$atom.lc) $atom.listen(()=>{})();
            return $atom.value;
        },
        lc: 0,
        listen (listener) {
            $atom.lc = listeners.push(listener);
            return ()=>{
                for(let i = $1eb3e6682b5aad44$var$lqIndex + $1eb3e6682b5aad44$var$QUEUE_ITEMS_PER_LISTENER; i < $1eb3e6682b5aad44$var$listenerQueue.length;)if ($1eb3e6682b5aad44$var$listenerQueue[i] === listener) $1eb3e6682b5aad44$var$listenerQueue.splice(i, $1eb3e6682b5aad44$var$QUEUE_ITEMS_PER_LISTENER);
                else i += $1eb3e6682b5aad44$var$QUEUE_ITEMS_PER_LISTENER;
                let index = listeners.indexOf(listener);
                if (~index) {
                    listeners.splice(index, 1);
                    if (!--$atom.lc) $atom.off();
                }
            };
        },
        notify (oldValue, changedKey) {
            $1eb3e6682b5aad44$export$8a255bebea64f637++;
            let runListenerQueue = !$1eb3e6682b5aad44$var$listenerQueue.length;
            for (let listener of listeners)$1eb3e6682b5aad44$var$listenerQueue.push(listener, $atom.value, oldValue, changedKey);
            if (runListenerQueue) {
                for($1eb3e6682b5aad44$var$lqIndex = 0; $1eb3e6682b5aad44$var$lqIndex < $1eb3e6682b5aad44$var$listenerQueue.length; $1eb3e6682b5aad44$var$lqIndex += $1eb3e6682b5aad44$var$QUEUE_ITEMS_PER_LISTENER)$1eb3e6682b5aad44$var$listenerQueue[$1eb3e6682b5aad44$var$lqIndex]($1eb3e6682b5aad44$var$listenerQueue[$1eb3e6682b5aad44$var$lqIndex + 1], $1eb3e6682b5aad44$var$listenerQueue[$1eb3e6682b5aad44$var$lqIndex + 2], $1eb3e6682b5aad44$var$listenerQueue[$1eb3e6682b5aad44$var$lqIndex + 3]);
                $1eb3e6682b5aad44$var$listenerQueue.length = 0;
            }
        },
        /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */ off () {},
        set (newValue) {
            let oldValue = $atom.value;
            if (oldValue !== newValue) {
                $atom.value = newValue;
                $atom.notify(oldValue);
            }
        },
        subscribe (listener) {
            let unbind = $atom.listen(listener);
            listener($atom.value);
            return unbind;
        },
        value: initialValue
    };
    return $atom;
};
const $1eb3e6682b5aad44$export$2bb990bb90890844 = (store)=>store;

});

parcelRegister("gEnRY", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $fcb1e1df2e102877$export$3b14a55fb2447963; });

var $2DqEF = parcelRequire("2DqEF");
var $b5QEp = parcelRequire("b5QEp");
const $fcb1e1df2e102877$var$isServer = typeof window === "undefined";
const $fcb1e1df2e102877$export$3b14a55fb2447963 = (initializedAtom, path, $fetch, options)=>{
    const value = (0, $2DqEF.atom)({
        data: null,
        error: null,
        isPending: true,
        isRefetching: false,
        refetch: (queryParams)=>{
            return fn(queryParams);
        }
    });
    const fn = (queryParams)=>{
        const opts = typeof options === "function" ? options({
            data: value.get().data,
            error: value.get().error,
            isPending: value.get().isPending
        }) : options;
        $fetch(path, {
            ...opts,
            query: {
                ...opts?.query,
                ...queryParams?.query
            },
            async onSuccess (context) {
                value.set({
                    data: context.data,
                    error: null,
                    isPending: false,
                    isRefetching: false,
                    refetch: value.value.refetch
                });
                await opts?.onSuccess?.(context);
            },
            async onError (context) {
                const { request: request } = context;
                const retryAttempts = typeof request.retry === "number" ? request.retry : request.retry?.attempts;
                const retryAttempt = request.retryAttempt || 0;
                if (retryAttempts && retryAttempt < retryAttempts) return;
                value.set({
                    error: context.error,
                    data: null,
                    isPending: false,
                    isRefetching: false,
                    refetch: value.value.refetch
                });
                await opts?.onError?.(context);
            },
            async onRequest (context) {
                const currentValue = value.get();
                value.set({
                    isPending: currentValue.data === null,
                    data: currentValue.data,
                    error: null,
                    isRefetching: true,
                    refetch: value.value.refetch
                });
                await opts?.onRequest?.(context);
            }
        }).catch((error)=>{
            value.set({
                error: error,
                data: null,
                isPending: false,
                isRefetching: false,
                refetch: value.value.refetch
            });
        });
    };
    initializedAtom = Array.isArray(initializedAtom) ? initializedAtom : [
        initializedAtom
    ];
    let isMounted = false;
    for (const initAtom of initializedAtom)initAtom.subscribe(()=>{
        if ($fcb1e1df2e102877$var$isServer) return;
        if (isMounted) fn();
        else (0, $b5QEp.onMount)(value, ()=>{
            const timeoutId = setTimeout(()=>{
                if (!isMounted) {
                    fn();
                    isMounted = true;
                }
            }, 0);
            return ()=>{
                value.off();
                initAtom.off();
                clearTimeout(timeoutId);
            };
        });
    });
    return value;
};

});
parcelRegister("b5QEp", function(module, exports) {

$parcel$export(module.exports, "onMount", function () { return $813900ac0127e962$export$1e848a9e87980bd5; });

const $813900ac0127e962$var$START = 0;
const $813900ac0127e962$var$STOP = 1;
const $813900ac0127e962$var$SET = 2;
const $813900ac0127e962$var$NOTIFY = 3;
const $813900ac0127e962$var$MOUNT = 5;
const $813900ac0127e962$var$UNMOUNT = 6;
const $813900ac0127e962$var$REVERT_MUTATION = 10;
let $813900ac0127e962$export$af631764ddc44097 = (object, listener, eventKey, mutateStore)=>{
    object.events = object.events || {};
    if (!object.events[eventKey + $813900ac0127e962$var$REVERT_MUTATION]) object.events[eventKey + $813900ac0127e962$var$REVERT_MUTATION] = mutateStore((eventProps)=>{
        // eslint-disable-next-line no-sequences
        object.events[eventKey].reduceRight((event, l)=>(l(event), event), {
            shared: {},
            ...eventProps
        });
    });
    object.events[eventKey] = object.events[eventKey] || [];
    object.events[eventKey].push(listener);
    return ()=>{
        let currentListeners = object.events[eventKey];
        let index = currentListeners.indexOf(listener);
        currentListeners.splice(index, 1);
        if (!currentListeners.length) {
            delete object.events[eventKey];
            object.events[eventKey + $813900ac0127e962$var$REVERT_MUTATION]();
            delete object.events[eventKey + $813900ac0127e962$var$REVERT_MUTATION];
        }
    };
};
let $813900ac0127e962$export$aaa2d21dd8862419 = ($store, listener)=>$813900ac0127e962$export$af631764ddc44097($store, listener, $813900ac0127e962$var$START, (runListeners)=>{
        let originListen = $store.listen;
        $store.listen = (arg)=>{
            if (!$store.lc && !$store.starting) {
                $store.starting = true;
                runListeners();
                delete $store.starting;
            }
            return originListen(arg);
        };
        return ()=>{
            $store.listen = originListen;
        };
    });
let $813900ac0127e962$export$a26634867096e2e9 = ($store, listener)=>$813900ac0127e962$export$af631764ddc44097($store, listener, $813900ac0127e962$var$STOP, (runListeners)=>{
        let originOff = $store.off;
        $store.off = ()=>{
            runListeners();
            originOff();
        };
        return ()=>{
            $store.off = originOff;
        };
    });
let $813900ac0127e962$export$39b63c7d2c06f43b = ($store, listener)=>$813900ac0127e962$export$af631764ddc44097($store, listener, $813900ac0127e962$var$SET, (runListeners)=>{
        let originSet = $store.set;
        let originSetKey = $store.setKey;
        if ($store.setKey) $store.setKey = (changed, changedValue)=>{
            let isAborted;
            let abort = ()=>{
                isAborted = true;
            };
            runListeners({
                abort: abort,
                changed: changed,
                newValue: {
                    ...$store.value,
                    [changed]: changedValue
                }
            });
            if (!isAborted) return originSetKey(changed, changedValue);
        };
        $store.set = (newValue)=>{
            let isAborted;
            let abort = ()=>{
                isAborted = true;
            };
            runListeners({
                abort: abort,
                newValue: newValue
            });
            if (!isAborted) return originSet(newValue);
        };
        return ()=>{
            $store.set = originSet;
            $store.setKey = originSetKey;
        };
    });
let $813900ac0127e962$export$9e6767ead5482085 = ($store, listener)=>$813900ac0127e962$export$af631764ddc44097($store, listener, $813900ac0127e962$var$NOTIFY, (runListeners)=>{
        let originNotify = $store.notify;
        $store.notify = (oldValue, changed)=>{
            let isAborted;
            let abort = ()=>{
                isAborted = true;
            };
            runListeners({
                abort: abort,
                changed: changed,
                oldValue: oldValue
            });
            if (!isAborted) return originNotify(oldValue, changed);
        };
        return ()=>{
            $store.notify = originNotify;
        };
    });
let $813900ac0127e962$export$560f0a991e34556 = 1000;
let $813900ac0127e962$export$1e848a9e87980bd5 = ($store, initialize)=>{
    let listener = (payload)=>{
        let destroy = initialize(payload);
        if (destroy) $store.events[$813900ac0127e962$var$UNMOUNT].push(destroy);
    };
    return $813900ac0127e962$export$af631764ddc44097($store, listener, $813900ac0127e962$var$MOUNT, (runListeners)=>{
        let originListen = $store.listen;
        $store.listen = (...args)=>{
            if (!$store.lc && !$store.active) {
                $store.active = true;
                runListeners();
            }
            return originListen(...args);
        };
        let originOff = $store.off;
        $store.events[$813900ac0127e962$var$UNMOUNT] = [];
        $store.off = ()=>{
            originOff();
            setTimeout(()=>{
                if ($store.active && !$store.lc) {
                    $store.active = false;
                    for (let destroy of $store.events[$813900ac0127e962$var$UNMOUNT])destroy();
                    $store.events[$813900ac0127e962$var$UNMOUNT] = [];
                }
            }, $813900ac0127e962$export$560f0a991e34556);
        };
        return ()=>{
            $store.listen = originListen;
            $store.off = originOff;
        };
    });
};

});


parcelRegister("luq3q", function(module, exports) {

$parcel$export(module.exports, "p", function () { return $4fa7e8994e9d12af$export$ffb5f4729a158638; });
const $4fa7e8994e9d12af$var$PROTO_POLLUTION_PATTERNS = {
    proto: /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/,
    constructor: /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/,
    protoShort: /"__proto__"\s*:/,
    constructorShort: /"constructor"\s*:/
};
const $4fa7e8994e9d12af$var$JSON_SIGNATURE = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
const $4fa7e8994e9d12af$var$SPECIAL_VALUES = {
    true: true,
    false: false,
    null: null,
    undefined: void 0,
    nan: Number.NaN,
    infinity: Number.POSITIVE_INFINITY,
    "-infinity": Number.NEGATIVE_INFINITY
};
const $4fa7e8994e9d12af$var$ISO_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,7}))?(?:Z|([+-])(\d{2}):(\d{2}))$/;
function $4fa7e8994e9d12af$var$isValidDate(date) {
    return date instanceof Date && !isNaN(date.getTime());
}
function $4fa7e8994e9d12af$var$parseISODate(value) {
    const match = $4fa7e8994e9d12af$var$ISO_DATE_REGEX.exec(value);
    if (!match) return null;
    const [, year, month, day, hour, minute, second, ms, offsetSign, offsetHour, offsetMinute] = match;
    let date = new Date(Date.UTC(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), parseInt(hour, 10), parseInt(minute, 10), parseInt(second, 10), ms ? parseInt(ms.padEnd(3, "0"), 10) : 0));
    if (offsetSign) {
        const offset = (parseInt(offsetHour, 10) * 60 + parseInt(offsetMinute, 10)) * (offsetSign === "+" ? -1 : 1);
        date.setUTCMinutes(date.getUTCMinutes() + offset);
    }
    return $4fa7e8994e9d12af$var$isValidDate(date) ? date : null;
}
function $4fa7e8994e9d12af$var$betterJSONParse(value, options = {}) {
    const { strict: strict = false, warnings: warnings = false, reviver: reviver, parseDates: parseDates = true } = options;
    if (typeof value !== "string") return value;
    const trimmed = value.trim();
    if (trimmed.length > 0 && trimmed[0] === '"' && trimmed.endsWith('"') && !trimmed.slice(1, -1).includes('"')) return trimmed.slice(1, -1);
    const lowerValue = trimmed.toLowerCase();
    if (lowerValue.length <= 9 && lowerValue in $4fa7e8994e9d12af$var$SPECIAL_VALUES) return $4fa7e8994e9d12af$var$SPECIAL_VALUES[lowerValue];
    if (!$4fa7e8994e9d12af$var$JSON_SIGNATURE.test(trimmed)) {
        if (strict) throw new SyntaxError("[better-json] Invalid JSON");
        return value;
    }
    const hasProtoPattern = Object.entries($4fa7e8994e9d12af$var$PROTO_POLLUTION_PATTERNS).some(([key, pattern])=>{
        const matches = pattern.test(trimmed);
        if (matches && warnings) console.warn(`[better-json] Detected potential prototype pollution attempt using ${key} pattern`);
        return matches;
    });
    if (hasProtoPattern && strict) throw new Error("[better-json] Potential prototype pollution attempt detected");
    try {
        const secureReviver = (key, value2)=>{
            if (key === "__proto__" || key === "constructor" && value2 && typeof value2 === "object" && "prototype" in value2) {
                if (warnings) console.warn(`[better-json] Dropping "${key}" key to prevent prototype pollution`);
                return void 0;
            }
            if (parseDates && typeof value2 === "string") {
                const date = $4fa7e8994e9d12af$var$parseISODate(value2);
                if (date) return date;
            }
            return reviver ? reviver(key, value2) : value2;
        };
        return JSON.parse(trimmed, secureReviver);
    } catch (error) {
        if (strict) throw error;
        return value;
    }
}
function $4fa7e8994e9d12af$export$ffb5f4729a158638(value, options = {
    strict: true
}) {
    return $4fa7e8994e9d12af$var$betterJSONParse(value, options);
}

});


parcelRegister("aFVHE", function(module, exports) {

$parcel$export(module.exports, "listenKeys", function () { return $7c5a7e574a5b9522$export$5830513599693295; });
function $7c5a7e574a5b9522$export$5830513599693295($store, keys, listener) {
    let keysSet = new Set(keys).add(undefined);
    return $store.listen((value, oldValue, changed)=>{
        if (keysSet.has(changed)) listener(value, oldValue, changed);
    });
}
function $7c5a7e574a5b9522$export$cfd6baa0b82a37e5($store, keys, listener) {
    let unbind = $7c5a7e574a5b9522$export$5830513599693295($store, keys, listener);
    listener($store.value);
    return unbind;
}

});


parcelRegister("9kYD9", function(module, exports) {

$parcel$export(module.exports, "organizationClient", function () { return $a627193a0905e9f8$export$ba05072dbff94b66; });
$parcel$export(module.exports, "magicLinkClient", function () { return $a627193a0905e9f8$export$aa5d14e9e06f195; });
$parcel$export(module.exports, "adminClient", function () { return $a627193a0905e9f8$export$9b6f0d7b123aae64; });
$parcel$export(module.exports, "customSessionClient", function () { return $a627193a0905e9f8$export$765170933e7e7a81; });

var $2DqEF = parcelRequire("2DqEF");
parcelRequire("etuIp");
parcelRequire("5AtET");

var $gEnRY = parcelRequire("gEnRY");

var $eEsoZ = parcelRequire("eEsoZ");

var $99SVx = parcelRequire("99SVx");
parcelRequire("82igF");
var $3NTVa = parcelRequire("3NTVa");
var $bGHVc = parcelRequire("bGHVc");
var $1OECG = parcelRequire("1OECG");

var $5uJx6 = parcelRequire("5uJx6");

var $eZ1eF = parcelRequire("eZ1eF");

var $lvobb = parcelRequire("lvobb");

var $6UVbL = parcelRequire("6UVbL");
parcelRequire("3lTCV");
parcelRequire("03I28");
const $a627193a0905e9f8$export$1b8e3b61ee754c2e = (input)=>{
    const acRoles = input.options.roles || (0, $eEsoZ.defaultRoles);
    return (0, $99SVx.h)(input, acRoles);
};
const $a627193a0905e9f8$export$ba05072dbff94b66 = (options)=>{
    const $listOrg = (0, $2DqEF.atom)(false);
    const $activeOrgSignal = (0, $2DqEF.atom)(false);
    const $activeMemberSignal = (0, $2DqEF.atom)(false);
    const $activeMemberRoleSignal = (0, $2DqEF.atom)(false);
    const roles = {
        admin: (0, $eEsoZ.adminAc),
        member: (0, $eEsoZ.memberAc),
        owner: (0, $eEsoZ.ownerAc),
        ...options?.roles
    };
    return {
        id: "organization",
        $InferServerPlugin: {},
        getActions: ($fetch, _$store, co)=>({
                $Infer: {
                    ActiveOrganization: {},
                    Organization: {},
                    Invitation: {},
                    Member: {},
                    Team: {}
                },
                organization: {
                    checkRolePermission: (data)=>{
                        const isAuthorized = $a627193a0905e9f8$export$1b8e3b61ee754c2e({
                            role: data.role,
                            options: {
                                ac: options?.ac,
                                roles: roles
                            },
                            permissions: data.permissions ?? data.permission
                        });
                        return isAuthorized;
                    }
                }
            }),
        getAtoms: ($fetch)=>{
            const listOrganizations = (0, $gEnRY.u)($listOrg, "/organization/list", $fetch, {
                method: "GET"
            });
            const activeOrganization = (0, $gEnRY.u)([
                $activeOrgSignal
            ], "/organization/get-full-organization", $fetch, ()=>({
                    method: "GET"
                }));
            const activeMember = (0, $gEnRY.u)([
                $activeMemberSignal
            ], "/organization/get-active-member", $fetch, {
                method: "GET"
            });
            const activeMemberRole = (0, $gEnRY.u)([
                $activeMemberRoleSignal
            ], "/organization/get-active-member-role", $fetch, {
                method: "GET"
            });
            return {
                $listOrg: $listOrg,
                $activeOrgSignal: $activeOrgSignal,
                $activeMemberSignal: $activeMemberSignal,
                $activeMemberRoleSignal: $activeMemberRoleSignal,
                activeOrganization: activeOrganization,
                listOrganizations: listOrganizations,
                activeMember: activeMember,
                activeMemberRole: activeMemberRole
            };
        },
        pathMethods: {
            "/organization/get-full-organization": "GET",
            "/organization/list-user-teams": "GET"
        },
        atomListeners: [
            {
                matcher (path) {
                    return path === "/organization/create" || path === "/organization/delete" || path === "/organization/update";
                },
                signal: "$listOrg"
            },
            {
                matcher (path) {
                    return path.startsWith("/organization");
                },
                signal: "$activeOrgSignal"
            },
            {
                matcher (path) {
                    return path.startsWith("/organization/set-active");
                },
                signal: "$sessionSignal"
            },
            {
                matcher (path) {
                    return path.includes("/organization/update-member-role");
                },
                signal: "$activeMemberSignal"
            },
            {
                matcher (path) {
                    return path.includes("/organization/update-member-role");
                },
                signal: "$activeMemberRoleSignal"
            }
        ]
    };
};
const $a627193a0905e9f8$export$c87f38047c955c36 = (schema)=>{
    return {};
};
const $a627193a0905e9f8$export$d51ca8b599fd9338 = ()=>{
    return {
        id: "username",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$f79b91736405b4a0 = ($fetch, { $listPasskeys: $listPasskeys })=>{
    const signInPasskey = async (opts, options)=>{
        const response = await $fetch("/passkey/generate-authenticate-options", {
            method: "POST"
        });
        if (!response.data) return response;
        try {
            const res = await (0, $3NTVa.startAuthentication)({
                optionsJSON: response.data,
                useBrowserAutofill: opts?.autoFill
            });
            const verified = await $fetch("/passkey/verify-authentication", {
                body: {
                    response: res
                },
                ...opts?.fetchOptions,
                ...options,
                method: "POST"
            });
            return verified;
        } catch (e) {
            return {
                data: null,
                error: {
                    code: "AUTH_CANCELLED",
                    message: "auth cancelled",
                    status: 400,
                    statusText: "BAD_REQUEST"
                }
            };
        }
    };
    const registerPasskey = async (opts, fetchOpts)=>{
        const options = await $fetch("/passkey/generate-register-options", {
            method: "GET",
            query: {
                ...opts?.authenticatorAttachment && {
                    authenticatorAttachment: opts.authenticatorAttachment
                },
                ...opts?.name && {
                    name: opts.name
                }
            }
        });
        if (!options.data) return options;
        try {
            const res = await (0, $bGHVc.startRegistration)({
                optionsJSON: options.data,
                useAutoRegister: opts?.useAutoRegister
            });
            const verified = await $fetch("/passkey/verify-registration", {
                ...opts?.fetchOptions,
                ...fetchOpts,
                body: {
                    response: res,
                    name: opts?.name
                },
                method: "POST"
            });
            if (!verified.data) return verified;
            $listPasskeys.set(Math.random());
        } catch (e) {
            if (e instanceof (0, $1OECG.WebAuthnError)) {
                if (e.code === "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED") return {
                    data: null,
                    error: {
                        code: e.code,
                        message: "previously registered",
                        status: 400,
                        statusText: "BAD_REQUEST"
                    }
                };
                if (e.code === "ERROR_CEREMONY_ABORTED") return {
                    data: null,
                    error: {
                        code: e.code,
                        message: "registration cancelled",
                        status: 400,
                        statusText: "BAD_REQUEST"
                    }
                };
                return {
                    data: null,
                    error: {
                        code: e.code,
                        message: e.message,
                        status: 400,
                        statusText: "BAD_REQUEST"
                    }
                };
            }
            return {
                data: null,
                error: {
                    code: "UNKNOWN_ERROR",
                    message: e instanceof Error ? e.message : "unknown error",
                    status: 500,
                    statusText: "INTERNAL_SERVER_ERROR"
                }
            };
        }
    };
    return {
        signIn: {
            /**
       * Sign in with a registered passkey
       */ passkey: signInPasskey
        },
        passkey: {
            /**
       * Add a passkey to the user account
       */ addPasskey: registerPasskey
        },
        /**
     * Inferred Internal Types
     */ $Infer: {}
    };
};
const $a627193a0905e9f8$export$bde50b940c02f039 = ()=>{
    const $listPasskeys = (0, $2DqEF.atom)();
    return {
        id: "passkey",
        $InferServerPlugin: {},
        getActions: ($fetch)=>$a627193a0905e9f8$export$f79b91736405b4a0($fetch, {
                $listPasskeys: $listPasskeys
            }),
        getAtoms ($fetch) {
            const listPasskeys = (0, $gEnRY.u)($listPasskeys, "/passkey/list-user-passkeys", $fetch, {
                method: "GET"
            });
            return {
                listPasskeys: listPasskeys,
                $listPasskeys: $listPasskeys
            };
        },
        pathMethods: {
            "/passkey/register": "POST",
            "/passkey/authenticate": "POST"
        },
        atomListeners: [
            {
                matcher (path) {
                    return path === "/passkey/verify-registration" || path === "/passkey/delete-passkey" || path === "/passkey/update-passkey";
                },
                signal: "_listPasskeys"
            }
        ]
    };
};
const $a627193a0905e9f8$export$aa5d14e9e06f195 = ()=>{
    return {
        id: "magic-link",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$6f784bb36203843e = ()=>{
    return {
        id: "phoneNumber",
        $InferServerPlugin: {},
        atomListeners: [
            {
                matcher (path) {
                    return path === "/phone-number/update" || path === "/phone-number/verify";
                },
                signal: "$sessionSignal"
            }
        ]
    };
};
const $a627193a0905e9f8$export$92e69e7b30289483 = ()=>{
    return {
        id: "anonymous",
        $InferServerPlugin: {},
        pathMethods: {
            "/sign-in/anonymous": "POST"
        }
    };
};
const $a627193a0905e9f8$export$af5bd705b756e239 = (schema)=>{
    return {
        id: "additional-fields-client",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$9b6f0d7b123aae64 = (options)=>{
    const roles = {
        admin: (0, $eZ1eF.adminAc),
        user: (0, $eZ1eF.userAc),
        ...options?.roles
    };
    return {
        id: "admin-client",
        $InferServerPlugin: {},
        getActions: ()=>({
                admin: {
                    checkRolePermission: (data)=>{
                        const isAuthorized = (0, $lvobb.h)({
                            role: data.role,
                            options: {
                                ac: options?.ac,
                                roles: roles
                            },
                            permissions: data.permissions ?? data.permission
                        });
                        return isAuthorized;
                    }
                }
            }),
        pathMethods: {
            "/admin/list-users": "GET",
            "/admin/stop-impersonating": "POST"
        }
    };
};
const $a627193a0905e9f8$export$4ef1eca346ea236e = ()=>{
    return {
        id: "generic-oauth-client",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$5cb4cd9447df72d8 = ()=>{
    return {
        id: "better-auth-client",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$faee3fb2d55b9bbb = ()=>{
    return {
        id: "multi-session",
        $InferServerPlugin: {},
        atomListeners: [
            {
                matcher (path) {
                    return path === "/multi-session/set-active";
                },
                signal: "$sessionSignal"
            }
        ]
    };
};
const $a627193a0905e9f8$export$e1f3d6571d77e112 = ()=>{
    return {
        id: "email-otp",
        $InferServerPlugin: {}
    };
};
let $a627193a0905e9f8$var$isRequestInProgress = false;
const $a627193a0905e9f8$export$26bf55c369103800 = (options)=>{
    return {
        id: "one-tap",
        getActions: ($fetch, _)=>({
                oneTap: async (opts, fetchOptions)=>{
                    if ($a627193a0905e9f8$var$isRequestInProgress) {
                        console.warn("A Google One Tap request is already in progress. Please wait.");
                        return;
                    }
                    $a627193a0905e9f8$var$isRequestInProgress = true;
                    try {
                        if (typeof window === "undefined" || !window.document) {
                            console.warn("Google One Tap is only available in browser environments");
                            return;
                        }
                        const { autoSelect: autoSelect, cancelOnTapOutside: cancelOnTapOutside, context: context } = opts ?? {};
                        const contextValue = context ?? options.context ?? "signin";
                        await $a627193a0905e9f8$var$loadGoogleScript();
                        await new Promise((resolve, reject)=>{
                            let isResolved = false;
                            const baseDelay = options.promptOptions?.baseDelay ?? 1e3;
                            const maxAttempts = options.promptOptions?.maxAttempts ?? 5;
                            window.google?.accounts.id.initialize({
                                client_id: options.clientId,
                                callback: async (response)=>{
                                    isResolved = true;
                                    try {
                                        await $fetch("/one-tap/callback", {
                                            method: "POST",
                                            body: {
                                                idToken: response.credential
                                            },
                                            ...opts?.fetchOptions,
                                            ...fetchOptions
                                        });
                                        if (!opts?.fetchOptions && !fetchOptions || opts?.callbackURL) window.location.href = opts?.callbackURL ?? "/";
                                        resolve();
                                    } catch (error) {
                                        console.error("Error during One Tap callback:", error);
                                        reject(error);
                                    }
                                },
                                auto_select: autoSelect,
                                cancel_on_tap_outside: cancelOnTapOutside,
                                context: contextValue,
                                ...options.additionalOptions
                            });
                            const handlePrompt = (attempt)=>{
                                if (isResolved) return;
                                window.google?.accounts.id.prompt((notification)=>{
                                    if (isResolved) return;
                                    if (notification.isDismissedMoment && notification.isDismissedMoment()) {
                                        if (attempt < maxAttempts) {
                                            const delay = Math.pow(2, attempt) * baseDelay;
                                            setTimeout(()=>handlePrompt(attempt + 1), delay);
                                        } else opts?.onPromptNotification?.(notification);
                                    } else if (notification.isSkippedMoment && notification.isSkippedMoment()) {
                                        if (attempt < maxAttempts) {
                                            const delay = Math.pow(2, attempt) * baseDelay;
                                            setTimeout(()=>handlePrompt(attempt + 1), delay);
                                        } else opts?.onPromptNotification?.(notification);
                                    }
                                });
                            };
                            handlePrompt(0);
                        });
                    } catch (error) {
                        console.error("Error during Google One Tap flow:", error);
                        throw error;
                    } finally{
                        $a627193a0905e9f8$var$isRequestInProgress = false;
                    }
                }
            }),
        getAtoms ($fetch) {
            return {};
        }
    };
};
const $a627193a0905e9f8$var$loadGoogleScript = ()=>{
    return new Promise((resolve)=>{
        if (window.googleScriptInitialized) {
            resolve();
            return;
        }
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.onload = ()=>{
            window.googleScriptInitialized = true;
            resolve();
        };
        document.head.appendChild(script);
    });
};
const $a627193a0905e9f8$export$765170933e7e7a81 = ()=>{
    return $a627193a0905e9f8$export$9671ac751f7a57bb();
};
const $a627193a0905e9f8$export$9671ac751f7a57bb = ()=>{
    return {
        id: "infer-server-plugin",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$1baa7f9d6bc08596 = ()=>{
    return {
        id: "sso-client",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$cd0ab08a1bc5359a = ()=>{
    return {
        id: "oidc-client",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$d07855a248450546 = ()=>{
    return {
        id: "api-key",
        $InferServerPlugin: {},
        pathMethods: {
            "/api-key/create": "POST",
            "/api-key/delete": "POST",
            "/api-key/delete-all-expired-api-keys": "POST"
        }
    };
};
const $a627193a0905e9f8$export$ee68314792c9e5db = ()=>{
    return {
        id: "one-time-token",
        $InferServerPlugin: {}
    };
};
const $a627193a0905e9f8$export$c49f51b437eb9e85 = ()=>{
    return {
        id: "siwe",
        $InferServerPlugin: {}
    };
};
function $a627193a0905e9f8$var$getCookieValue(name) {
    if (typeof document === "undefined") return null;
    const cookie = document.cookie.split("; ").find((row)=>row.startsWith(`${name}=`));
    return cookie ? cookie.split("=")[1] : null;
}
const $a627193a0905e9f8$export$f4170b5783df91bd = (config = {})=>{
    const cookieName = config.cookieName || "better-auth.last_used_login_method";
    return {
        id: "last-login-method-client",
        getActions () {
            return {
                /**
         * Get the last used login method from cookies
         * @returns The last used login method or null if not found
         */ getLastUsedLoginMethod: ()=>{
                    return $a627193a0905e9f8$var$getCookieValue(cookieName);
                },
                /**
         * Clear the last used login method cookie
         * This sets the cookie with an expiration date in the past
         */ clearLastUsedLoginMethod: ()=>{
                    if (typeof document !== "undefined") document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                },
                /**
         * Check if a specific login method was the last used
         * @param method The method to check
         * @returns True if the method was the last used, false otherwise
         */ isLastUsedLoginMethod: (method)=>{
                    const lastMethod = $a627193a0905e9f8$var$getCookieValue(cookieName);
                    return lastMethod === method;
                }
            };
        }
    };
};

});
parcelRegister("eEsoZ", function(module, exports) {

$parcel$export(module.exports, "adminAc", function () { return $5ca6135548f0d2a4$export$249949d67b58b94c; });
$parcel$export(module.exports, "ownerAc", function () { return $5ca6135548f0d2a4$export$463e19fe12b05062; });
$parcel$export(module.exports, "memberAc", function () { return $5ca6135548f0d2a4$export$dcdecdda54c91a26; });
$parcel$export(module.exports, "defaultRoles", function () { return $5ca6135548f0d2a4$export$a48e0866bfebaa70; });

var $3lTCV = parcelRequire("3lTCV");
parcelRequire("03I28");
const $5ca6135548f0d2a4$export$1dd05adec993ee15 = {
    organization: [
        "update",
        "delete"
    ],
    member: [
        "create",
        "update",
        "delete"
    ],
    invitation: [
        "create",
        "cancel"
    ],
    team: [
        "create",
        "update",
        "delete"
    ],
    ac: [
        "create",
        "read",
        "update",
        "delete"
    ]
};
const $5ca6135548f0d2a4$export$2b3fd6fdc8593a4c = (0, $3lTCV.createAccessControl)($5ca6135548f0d2a4$export$1dd05adec993ee15);
const $5ca6135548f0d2a4$export$249949d67b58b94c = $5ca6135548f0d2a4$export$2b3fd6fdc8593a4c.newRole({
    organization: [
        "update"
    ],
    invitation: [
        "create",
        "cancel"
    ],
    member: [
        "create",
        "update",
        "delete"
    ],
    team: [
        "create",
        "update",
        "delete"
    ],
    ac: [
        "create",
        "read",
        "update",
        "delete"
    ]
});
const $5ca6135548f0d2a4$export$463e19fe12b05062 = $5ca6135548f0d2a4$export$2b3fd6fdc8593a4c.newRole({
    organization: [
        "update",
        "delete"
    ],
    member: [
        "create",
        "update",
        "delete"
    ],
    invitation: [
        "create",
        "cancel"
    ],
    team: [
        "create",
        "update",
        "delete"
    ],
    ac: [
        "create",
        "read",
        "update",
        "delete"
    ]
});
const $5ca6135548f0d2a4$export$dcdecdda54c91a26 = $5ca6135548f0d2a4$export$2b3fd6fdc8593a4c.newRole({
    organization: [],
    member: [],
    invitation: [],
    team: [],
    ac: [
        "read"
    ]
});
const $5ca6135548f0d2a4$export$a48e0866bfebaa70 = {
    admin: $5ca6135548f0d2a4$export$249949d67b58b94c,
    owner: $5ca6135548f0d2a4$export$463e19fe12b05062,
    member: $5ca6135548f0d2a4$export$dcdecdda54c91a26
};

});
parcelRegister("3lTCV", function(module, exports) {

$parcel$export(module.exports, "createAccessControl", function () { return $29a688ca088f5f2b$export$12eb5dcdd0256b93; });

var $03I28 = parcelRequire("03I28");
function $29a688ca088f5f2b$export$3100efae45e879(statements) {
    return {
        authorize (request, connector = "AND") {
            let success = false;
            for (const [requestedResource, requestedActions] of Object.entries(request)){
                const allowedActions = statements[requestedResource];
                if (!allowedActions) return {
                    success: false,
                    error: `You are not allowed to access resource: ${requestedResource}`
                };
                if (Array.isArray(requestedActions)) success = requestedActions.every((requestedAction)=>allowedActions.includes(requestedAction));
                else {
                    if (typeof requestedActions === "object") {
                        const actions = requestedActions;
                        if (actions.connector === "OR") success = actions.actions.some((requestedAction)=>allowedActions.includes(requestedAction));
                        else success = actions.actions.every((requestedAction)=>allowedActions.includes(requestedAction));
                    } else throw new (0, $03I28.B)("Invalid access control request");
                }
                if (success && connector === "OR") return {
                    success: success
                };
                if (!success && connector === "AND") return {
                    success: false,
                    error: `unauthorized to access resource "${requestedResource}"`
                };
            }
            if (success) return {
                success: success
            };
            return {
                success: false,
                error: "Not authorized"
            };
        },
        statements: statements
    };
}
function $29a688ca088f5f2b$export$12eb5dcdd0256b93(s) {
    return {
        newRole (statements) {
            return $29a688ca088f5f2b$export$3100efae45e879(statements);
        },
        statements: s
    };
}

});


parcelRegister("99SVx", function(module, exports) {

$parcel$export(module.exports, "h", function () { return $5644947a6c8b60c4$export$dda1d9f60106f0e9; });
const $5644947a6c8b60c4$export$dda1d9f60106f0e9 = (input, acRoles)=>{
    if (!input.permissions && !input.permission) return false;
    const roles = input.role.split(",");
    const creatorRole = input.options.creatorRole || "owner";
    const isCreator = roles.includes(creatorRole);
    const allowCreatorsAllPermissions = input.allowCreatorAllPermissions || false;
    if (isCreator && allowCreatorsAllPermissions) return true;
    for (const role of roles){
        const _role = acRoles[role];
        const result = _role?.authorize(input.permissions ?? input.permission);
        if (result?.success) return true;
    }
    return false;
};
let $5644947a6c8b60c4$export$db3b6bfb95261072 = /* @__PURE__ */ new Map();

});

parcelRegister("82igF", function(module, exports) {
$parcel$export(module.exports, "startRegistration", function () { return (parcelRequire("bGHVc")).startRegistration; });
$parcel$export(module.exports, "startAuthentication", function () { return (parcelRequire("3NTVa")).startAuthentication; });
$parcel$export(module.exports, "WebAuthnError", function () { return (parcelRequire("1OECG")).WebAuthnError; });
parcelRequire("bGHVc");
parcelRequire("3NTVa");
parcelRequire("e8Ov6");
parcelRequire("dXOzy");
parcelRequire("80Wns");
parcelRequire("aM6EX");
parcelRequire("kBfFd");
parcelRequire("FlY2o");
parcelRequire("1OECG");
parcelRequire("g421O");

});
parcelRegister("bGHVc", function(module, exports) {

$parcel$export(module.exports, "startRegistration", function () { return $8825afdcb231b37e$export$20d6f277a113c2ce; });

var $kBfFd = parcelRequire("kBfFd");

var $aM6EX = parcelRequire("aM6EX");

var $e8Ov6 = parcelRequire("e8Ov6");

var $ffwnP = parcelRequire("ffwnP");

var $9l0jC = parcelRequire("9l0jC");

var $FlY2o = parcelRequire("FlY2o");

var $ikYrt = parcelRequire("ikYrt");
async function $8825afdcb231b37e$export$20d6f277a113c2ce(options) {
    // @ts-ignore: Intentionally check for old call structure to warn about improper API call
    if (!options.optionsJSON && options.challenge) {
        console.warn("startRegistration() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information.");
        // @ts-ignore: Reassign the options, passed in as a positional argument, to the expected variable
        options = {
            optionsJSON: options
        };
    }
    const { optionsJSON: optionsJSON, useAutoRegister: useAutoRegister = false } = options;
    if (!(0, $e8Ov6.browserSupportsWebAuthn)()) throw new Error("WebAuthn is not supported in this browser");
    // We need to convert some values to Uint8Arrays before passing the credentials to the navigator
    const publicKey = {
        ...optionsJSON,
        challenge: (0, $aM6EX.base64URLStringToBuffer)(optionsJSON.challenge),
        user: {
            ...optionsJSON.user,
            id: (0, $aM6EX.base64URLStringToBuffer)(optionsJSON.user.id)
        },
        excludeCredentials: optionsJSON.excludeCredentials?.map((0, $ffwnP.toPublicKeyCredentialDescriptor))
    };
    // Prepare options for `.create()`
    const createOptions = {};
    /**
     * Try to use conditional create to register a passkey for the user with the password manager
     * the user just used to authenticate with. The user won't be shown any prominent UI by the
     * browser.
     */ if (useAutoRegister) // @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
    createOptions.mediation = "conditional";
    // Finalize options
    createOptions.publicKey = publicKey;
    // Set up the ability to cancel this request if the user attempts another
    createOptions.signal = (0, $FlY2o.WebAuthnAbortService).createNewAbortSignal();
    // Wait for the user to complete attestation
    let credential;
    try {
        credential = await navigator.credentials.create(createOptions);
    } catch (err) {
        throw (0, $9l0jC.identifyRegistrationError)({
            error: err,
            options: createOptions
        });
    }
    if (!credential) throw new Error("Registration was not completed");
    const { id: id, rawId: rawId, response: response, type: type } = credential;
    // Continue to play it safe with `getTransports()` for now, even when L3 types say it's required
    let transports = undefined;
    if (typeof response.getTransports === "function") transports = response.getTransports();
    // L3 says this is required, but browser and webview support are still not guaranteed.
    let responsePublicKeyAlgorithm = undefined;
    if (typeof response.getPublicKeyAlgorithm === "function") try {
        responsePublicKeyAlgorithm = response.getPublicKeyAlgorithm();
    } catch (error) {
        $8825afdcb231b37e$var$warnOnBrokenImplementation("getPublicKeyAlgorithm()", error);
    }
    let responsePublicKey = undefined;
    if (typeof response.getPublicKey === "function") try {
        const _publicKey = response.getPublicKey();
        if (_publicKey !== null) responsePublicKey = (0, $kBfFd.bufferToBase64URLString)(_publicKey);
    } catch (error) {
        $8825afdcb231b37e$var$warnOnBrokenImplementation("getPublicKey()", error);
    }
    // L3 says this is required, but browser and webview support are still not guaranteed.
    let responseAuthenticatorData;
    if (typeof response.getAuthenticatorData === "function") try {
        responseAuthenticatorData = (0, $kBfFd.bufferToBase64URLString)(response.getAuthenticatorData());
    } catch (error) {
        $8825afdcb231b37e$var$warnOnBrokenImplementation("getAuthenticatorData()", error);
    }
    return {
        id: id,
        rawId: (0, $kBfFd.bufferToBase64URLString)(rawId),
        response: {
            attestationObject: (0, $kBfFd.bufferToBase64URLString)(response.attestationObject),
            clientDataJSON: (0, $kBfFd.bufferToBase64URLString)(response.clientDataJSON),
            transports: transports,
            publicKeyAlgorithm: responsePublicKeyAlgorithm,
            publicKey: responsePublicKey,
            authenticatorData: responseAuthenticatorData
        },
        type: type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: (0, $ikYrt.toAuthenticatorAttachment)(credential.authenticatorAttachment)
    };
}
/**
 * Visibly warn when we detect an issue related to a passkey provider intercepting WebAuthn API
 * calls
 */ function $8825afdcb231b37e$var$warnOnBrokenImplementation(methodName, cause) {
    console.warn(`The browser extension that intercepted this WebAuthn API call incorrectly implemented ${methodName}. You should report this error to them.\n`, cause);
}

});
parcelRegister("kBfFd", function(module, exports) {

$parcel$export(module.exports, "bufferToBase64URLString", function () { return $eff369de6fc74384$export$a2e0e37897ea77dc; });
/**
 * Convert the given array buffer into a Base64URL-encoded string. Ideal for converting various
 * credential response ArrayBuffers to string for sending back to the server as JSON.
 *
 * Helper method to compliment `base64URLStringToBuffer`
 */ function $eff369de6fc74384$export$a2e0e37897ea77dc(buffer) {
    const bytes = new Uint8Array(buffer);
    let str = "";
    for (const charCode of bytes)str += String.fromCharCode(charCode);
    const base64String = btoa(str);
    return base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

});

parcelRegister("aM6EX", function(module, exports) {

$parcel$export(module.exports, "base64URLStringToBuffer", function () { return $7d838d8bdb989eb6$export$5fed9f4baa53df29; });
/**
 * Convert from a Base64URL-encoded string to an Array Buffer. Best used when converting a
 * credential ID from a JSON string to an ArrayBuffer, like in allowCredentials or
 * excludeCredentials
 *
 * Helper method to compliment `bufferToBase64URLString`
 */ function $7d838d8bdb989eb6$export$5fed9f4baa53df29(base64URLString) {
    // Convert from Base64URL to Base64
    const base64 = base64URLString.replace(/-/g, "+").replace(/_/g, "/");
    /**
     * Pad with '=' until it's a multiple of four
     * (4 - (85 % 4 = 1) = 3) % 4 = 3 padding
     * (4 - (86 % 4 = 2) = 2) % 4 = 2 padding
     * (4 - (87 % 4 = 3) = 1) % 4 = 1 padding
     * (4 - (88 % 4 = 0) = 4) % 4 = 0 padding
     */ const padLength = (4 - base64.length % 4) % 4;
    const padded = base64.padEnd(base64.length + padLength, "=");
    // Convert to a binary string
    const binary = atob(padded);
    // Convert binary string to buffer
    const buffer = new ArrayBuffer(binary.length);
    const bytes = new Uint8Array(buffer);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return buffer;
}

});

parcelRegister("e8Ov6", function(module, exports) {

$parcel$export(module.exports, "browserSupportsWebAuthn", function () { return $a4b8fc6f8b5f307c$export$21f8045e1be8a25d; });
/**
 * Determine if the browser is capable of Webauthn
 */ function $a4b8fc6f8b5f307c$export$21f8045e1be8a25d() {
    return $a4b8fc6f8b5f307c$export$8b1c3c4214204e67.stubThis(globalThis?.PublicKeyCredential !== undefined && typeof globalThis.PublicKeyCredential === "function");
}
const $a4b8fc6f8b5f307c$export$8b1c3c4214204e67 = {
    stubThis: (value)=>value
};

});

parcelRegister("ffwnP", function(module, exports) {

$parcel$export(module.exports, "toPublicKeyCredentialDescriptor", function () { return $b1a1605d48a99f61$export$6e9dda8f9869899d; });

var $aM6EX = parcelRequire("aM6EX");
function $b1a1605d48a99f61$export$6e9dda8f9869899d(descriptor) {
    const { id: id } = descriptor;
    return {
        ...descriptor,
        id: (0, $aM6EX.base64URLStringToBuffer)(id),
        /**
         * `descriptor.transports` is an array of our `AuthenticatorTransportFuture` that includes newer
         * transports that TypeScript's DOM lib is ignorant of. Convince TS that our list of transports
         * are fine to pass to WebAuthn since browsers will recognize the new value.
         */ transports: descriptor.transports
    };
}

});

parcelRegister("9l0jC", function(module, exports) {

$parcel$export(module.exports, "identifyRegistrationError", function () { return $6cc651e0ce32e36d$export$1c18a773f8a28a92; });

var $leh2X = parcelRequire("leh2X");

var $1OECG = parcelRequire("1OECG");
function $6cc651e0ce32e36d$export$1c18a773f8a28a92({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error("options was missing required publicKey property");
    if (error.name === "AbortError") {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new (0, $1OECG.WebAuthnError)({
            message: "Registration ceremony was sent an abort signal",
            code: "ERROR_CEREMONY_ABORTED",
            cause: error
        });
    } else if (error.name === "ConstraintError") {
        if (publicKey.authenticatorSelection?.requireResidentKey === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
        return new (0, $1OECG.WebAuthnError)({
            message: "Discoverable credentials were required but no available authenticator supported it",
            code: "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
            cause: error
        });
        else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === "conditional" && publicKey.authenticatorSelection?.userVerification === "required") // https://w3c.github.io/webauthn/#sctn-createCredential (Step 22.4)
        return new (0, $1OECG.WebAuthnError)({
            message: "User verification was required during automatic registration but it could not be performed",
            code: "ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE",
            cause: error
        });
        else if (publicKey.authenticatorSelection?.userVerification === "required") // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
        return new (0, $1OECG.WebAuthnError)({
            message: "User verification was required but no available authenticator supported it",
            code: "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
            cause: error
        });
    } else if (error.name === "InvalidStateError") // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
    return new (0, $1OECG.WebAuthnError)({
        message: "The authenticator was previously registered",
        code: "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
        cause: error
    });
    else if (error.name === "NotAllowedError") /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new (0, $1OECG.WebAuthnError)({
        message: error.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
    else if (error.name === "NotSupportedError") {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === "public-key");
        if (validPubKeyCredParams.length === 0) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 10)
        return new (0, $1OECG.WebAuthnError)({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: "ERROR_MALFORMED_PUBKEYCREDPARAMS",
            cause: error
        });
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
        return new (0, $1OECG.WebAuthnError)({
            message: "No available authenticator supported any of the specified pubKeyCredParams algorithms",
            code: "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
            cause: error
        });
    } else if (error.name === "SecurityError") {
        const effectiveDomain = globalThis.location.hostname;
        if (!(0, $leh2X.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
        return new (0, $1OECG.WebAuthnError)({
            message: `${globalThis.location.hostname} is an invalid domain`,
            code: "ERROR_INVALID_DOMAIN",
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
        return new (0, $1OECG.WebAuthnError)({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: error
        });
    } else if (error.name === "TypeError") {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
        return new (0, $1OECG.WebAuthnError)({
            message: "User ID was not between 1 and 64 characters",
            code: "ERROR_INVALID_USER_ID_LENGTH",
            cause: error
        });
    } else if (error.name === "UnknownError") // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
    return new (0, $1OECG.WebAuthnError)({
        message: "The authenticator was unable to process the specified options, or could not create a new credential",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: error
    });
    return error;
}

});
parcelRegister("leh2X", function(module, exports) {

$parcel$export(module.exports, "isValidDomain", function () { return $f74820e56af6defe$export$59e759560deddc3c; });
/**
 * A simple test to determine if a hostname is a properly-formatted domain name
 *
 * A "valid domain" is defined here: https://url.spec.whatwg.org/#valid-domain
 *
 * Regex sourced from here:
 * https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s15.html
 */ function $f74820e56af6defe$export$59e759560deddc3c(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === "localhost" || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}

});

parcelRegister("1OECG", function(module, exports) {

$parcel$export(module.exports, "WebAuthnError", function () { return $1529f8d7a061d4a6$export$90f0c14a652de832; });
/**
 * A custom Error used to return a more nuanced error detailing _why_ one of the eight documented
 * errors in the spec was raised after calling `navigator.credentials.create()` or
 * `navigator.credentials.get()`:
 *
 * - `AbortError`
 * - `ConstraintError`
 * - `InvalidStateError`
 * - `NotAllowedError`
 * - `NotSupportedError`
 * - `SecurityError`
 * - `TypeError`
 * - `UnknownError`
 *
 * Error messages were determined through investigation of the spec to determine under which
 * scenarios a given error would be raised.
 */ class $1529f8d7a061d4a6$export$90f0c14a652de832 extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        // @ts-ignore: help Rollup understand that `cause` is okay to set
        super(message, {
            cause: cause
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name ?? cause.name;
        this.code = code;
    }
}

});


parcelRegister("FlY2o", function(module, exports) {

$parcel$export(module.exports, "WebAuthnAbortService", function () { return $07c4deb52d53008f$export$442ada5d34ca6e87; });
class $07c4deb52d53008f$var$BaseWebAuthnAbortService {
    constructor(){
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    createNewAbortSignal() {
        // Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
        if (this.controller) {
            const abortError = new Error("Cancelling existing WebAuthn API call for new one");
            abortError.name = "AbortError";
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    cancelCeremony() {
        if (this.controller) {
            const abortError = new Error("Manually cancelling existing WebAuthn API call");
            abortError.name = "AbortError";
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const $07c4deb52d53008f$export$442ada5d34ca6e87 = new $07c4deb52d53008f$var$BaseWebAuthnAbortService();

});

parcelRegister("ikYrt", function(module, exports) {

$parcel$export(module.exports, "toAuthenticatorAttachment", function () { return $d598fad1c8c54aaa$export$a7e79abca43712d0; });
const $d598fad1c8c54aaa$var$attachments = [
    "cross-platform",
    "platform"
];
function $d598fad1c8c54aaa$export$a7e79abca43712d0(attachment) {
    if (!attachment) return;
    if ($d598fad1c8c54aaa$var$attachments.indexOf(attachment) < 0) return;
    return attachment;
}

});


parcelRegister("3NTVa", function(module, exports) {

$parcel$export(module.exports, "startAuthentication", function () { return $2c515375194b0f63$export$c4f13730a14de143; });

var $kBfFd = parcelRequire("kBfFd");

var $aM6EX = parcelRequire("aM6EX");

var $e8Ov6 = parcelRequire("e8Ov6");

var $80Wns = parcelRequire("80Wns");

var $ffwnP = parcelRequire("ffwnP");

var $gW5Hn = parcelRequire("gW5Hn");

var $FlY2o = parcelRequire("FlY2o");

var $ikYrt = parcelRequire("ikYrt");
async function $2c515375194b0f63$export$c4f13730a14de143(options) {
    // @ts-ignore: Intentionally check for old call structure to warn about improper API call
    if (!options.optionsJSON && options.challenge) {
        console.warn("startAuthentication() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information.");
        // @ts-ignore: Reassign the options, passed in as a positional argument, to the expected variable
        options = {
            optionsJSON: options
        };
    }
    const { optionsJSON: optionsJSON, useBrowserAutofill: useBrowserAutofill = false, verifyBrowserAutofillInput: verifyBrowserAutofillInput = true } = options;
    if (!(0, $e8Ov6.browserSupportsWebAuthn)()) throw new Error("WebAuthn is not supported in this browser");
    // We need to avoid passing empty array to avoid blocking retrieval
    // of public key
    let allowCredentials;
    if (optionsJSON.allowCredentials?.length !== 0) allowCredentials = optionsJSON.allowCredentials?.map((0, $ffwnP.toPublicKeyCredentialDescriptor));
    // We need to convert some values to Uint8Arrays before passing the credentials to the navigator
    const publicKey = {
        ...optionsJSON,
        challenge: (0, $aM6EX.base64URLStringToBuffer)(optionsJSON.challenge),
        allowCredentials: allowCredentials
    };
    // Prepare options for `.get()`
    const getOptions = {};
    /**
     * Set up the page to prompt the user to select a credential for authentication via the browser's
     * input autofill mechanism.
     */ if (useBrowserAutofill) {
        if (!await (0, $80Wns.browserSupportsWebAuthnAutofill)()) throw Error("Browser does not support WebAuthn autofill");
        // Check for an <input> with "webauthn" in its `autocomplete` attribute
        const eligibleInputs = document.querySelectorAll("input[autocomplete$='webauthn']");
        // WebAuthn autofill requires at least one valid input
        if (eligibleInputs.length < 1 && verifyBrowserAutofillInput) throw Error('No <input> with "webauthn" as the only or last value in its `autocomplete` attribute was detected');
        // `CredentialMediationRequirement` doesn't know about "conditional" yet as of
        // typescript@4.6.3
        getOptions.mediation = "conditional";
        // Conditional UI requires an empty allow list
        publicKey.allowCredentials = [];
    }
    // Finalize options
    getOptions.publicKey = publicKey;
    // Set up the ability to cancel this request if the user attempts another
    getOptions.signal = (0, $FlY2o.WebAuthnAbortService).createNewAbortSignal();
    // Wait for the user to complete assertion
    let credential;
    try {
        credential = await navigator.credentials.get(getOptions);
    } catch (err) {
        throw (0, $gW5Hn.identifyAuthenticationError)({
            error: err,
            options: getOptions
        });
    }
    if (!credential) throw new Error("Authentication was not completed");
    const { id: id, rawId: rawId, response: response, type: type } = credential;
    let userHandle = undefined;
    if (response.userHandle) userHandle = (0, $kBfFd.bufferToBase64URLString)(response.userHandle);
    // Convert values to base64 to make it easier to send back to the server
    return {
        id: id,
        rawId: (0, $kBfFd.bufferToBase64URLString)(rawId),
        response: {
            authenticatorData: (0, $kBfFd.bufferToBase64URLString)(response.authenticatorData),
            clientDataJSON: (0, $kBfFd.bufferToBase64URLString)(response.clientDataJSON),
            signature: (0, $kBfFd.bufferToBase64URLString)(response.signature),
            userHandle: userHandle
        },
        type: type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: (0, $ikYrt.toAuthenticatorAttachment)(credential.authenticatorAttachment)
    };
}

});
parcelRegister("80Wns", function(module, exports) {

$parcel$export(module.exports, "browserSupportsWebAuthnAutofill", function () { return $5d5b9b52c7546fa6$export$18d4f667a5042852; });

var $e8Ov6 = parcelRequire("e8Ov6");
function $5d5b9b52c7546fa6$export$18d4f667a5042852() {
    if (!(0, $e8Ov6.browserSupportsWebAuthn)()) return $5d5b9b52c7546fa6$export$6e4f15da96b8fc8.stubThis(new Promise((resolve)=>resolve(false)));
    /**
     * I don't like the `as unknown` here but there's a `declare var PublicKeyCredential` in
     * TS' DOM lib that's making it difficult for me to just go `as PublicKeyCredentialFuture` as I
     * want. I think I'm fine with this for now since it's _supposed_ to be temporary, until TS types
     * have a chance to catch up.
     */ const globalPublicKeyCredential = globalThis.PublicKeyCredential;
    if (globalPublicKeyCredential?.isConditionalMediationAvailable === undefined) return $5d5b9b52c7546fa6$export$6e4f15da96b8fc8.stubThis(new Promise((resolve)=>resolve(false)));
    return $5d5b9b52c7546fa6$export$6e4f15da96b8fc8.stubThis(globalPublicKeyCredential.isConditionalMediationAvailable());
}
const $5d5b9b52c7546fa6$export$6e4f15da96b8fc8 = {
    stubThis: (value)=>value
};

});

parcelRegister("gW5Hn", function(module, exports) {

$parcel$export(module.exports, "identifyAuthenticationError", function () { return $c5467bbf300dcc3b$export$9b62fd498befe529; });

var $leh2X = parcelRequire("leh2X");

var $1OECG = parcelRequire("1OECG");
function $c5467bbf300dcc3b$export$9b62fd498befe529({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error("options was missing required publicKey property");
    if (error.name === "AbortError") {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new (0, $1OECG.WebAuthnError)({
            message: "Authentication ceremony was sent an abort signal",
            code: "ERROR_CEREMONY_ABORTED",
            cause: error
        });
    } else if (error.name === "NotAllowedError") /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new (0, $1OECG.WebAuthnError)({
        message: error.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
    else if (error.name === "SecurityError") {
        const effectiveDomain = globalThis.location.hostname;
        if (!(0, $leh2X.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
        return new (0, $1OECG.WebAuthnError)({
            message: `${globalThis.location.hostname} is an invalid domain`,
            code: "ERROR_INVALID_DOMAIN",
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
        return new (0, $1OECG.WebAuthnError)({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: error
        });
    } else if (error.name === "UnknownError") // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
    return new (0, $1OECG.WebAuthnError)({
        message: "The authenticator was unable to process the specified options, or could not create a new assertion signature",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: error
    });
    return error;
}

});


parcelRegister("dXOzy", function(module, exports) {

var $e8Ov6 = parcelRequire("e8Ov6");
function $a2a803b2a297bac9$export$d2e10ee5223ea44b() {
    if (!(0, $e8Ov6.browserSupportsWebAuthn)()) return new Promise((resolve)=>resolve(false));
    return PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
}

});

parcelRegister("g421O", function(module, exports) {

});


parcelRegister("5uJx6", function(module, exports) {
const $779756ad2540666c$export$625550452a3fa3ec = (options)=>{
    return {
        id: "two-factor",
        $InferServerPlugin: {},
        atomListeners: [
            {
                matcher: (path)=>path.startsWith("/two-factor/"),
                signal: "$sessionSignal"
            }
        ],
        pathMethods: {
            "/two-factor/disable": "POST",
            "/two-factor/enable": "POST",
            "/two-factor/send-otp": "POST",
            "/two-factor/generate-backup-codes": "POST"
        },
        fetchPlugins: [
            {
                id: "two-factor",
                name: "two-factor",
                hooks: {
                    async onSuccess (context) {
                        if (context.data?.twoFactorRedirect) {
                            if (options?.onTwoFactorRedirect) await options.onTwoFactorRedirect();
                        }
                    }
                }
            }
        ]
    };
};

});

parcelRegister("eZ1eF", function(module, exports) {

$parcel$export(module.exports, "adminAc", function () { return $5c54928c356f796e$export$249949d67b58b94c; });
$parcel$export(module.exports, "userAc", function () { return $5c54928c356f796e$export$3c63a58acfbdbe50; });
$parcel$export(module.exports, "defaultRoles", function () { return $5c54928c356f796e$export$a48e0866bfebaa70; });

var $3lTCV = parcelRequire("3lTCV");
parcelRequire("03I28");
const $5c54928c356f796e$export$1dd05adec993ee15 = {
    user: [
        "create",
        "list",
        "set-role",
        "ban",
        "impersonate",
        "delete",
        "set-password",
        "get",
        "update"
    ],
    session: [
        "list",
        "revoke",
        "delete"
    ]
};
const $5c54928c356f796e$export$2b3fd6fdc8593a4c = (0, $3lTCV.createAccessControl)($5c54928c356f796e$export$1dd05adec993ee15);
const $5c54928c356f796e$export$249949d67b58b94c = $5c54928c356f796e$export$2b3fd6fdc8593a4c.newRole({
    user: [
        "create",
        "list",
        "set-role",
        "ban",
        "impersonate",
        "delete",
        "set-password",
        "get",
        "update"
    ],
    session: [
        "list",
        "revoke",
        "delete"
    ]
});
const $5c54928c356f796e$export$3c63a58acfbdbe50 = $5c54928c356f796e$export$2b3fd6fdc8593a4c.newRole({
    user: [],
    session: []
});
const $5c54928c356f796e$export$a48e0866bfebaa70 = {
    admin: $5c54928c356f796e$export$249949d67b58b94c,
    user: $5c54928c356f796e$export$3c63a58acfbdbe50
};

});

parcelRegister("lvobb", function(module, exports) {

$parcel$export(module.exports, "h", function () { return $8143debb424e01df$export$dda1d9f60106f0e9; });

var $eZ1eF = parcelRequire("eZ1eF");
const $8143debb424e01df$export$dda1d9f60106f0e9 = (input)=>{
    if (input.userId && input.options?.adminUserIds?.includes(input.userId)) return true;
    if (!input.permissions && !input.permission) return false;
    const roles = (input.role || input.options?.defaultRole || "user").split(",");
    const acRoles = input.options?.roles || (0, $eZ1eF.defaultRoles);
    for (const role of roles){
        const _role = acRoles[role];
        const result = _role?.authorize(input.permission ?? input.permissions);
        if (result?.success) return true;
    }
    return false;
};

});

parcelRegister("6UVbL", function(module, exports) {
const $313b539cf69f04b5$export$4368d992c4eafac0 = ()=>{
    return {
        id: "device-authorization",
        $InferServerPlugin: {},
        pathMethods: {
            "/device/code": "POST",
            "/device/token": "POST",
            "/device": "GET",
            "/device/approve": "POST",
            "/device/deny": "POST"
        }
    };
};

});



parcelRegister("kR2qW", function(module, exports) {

$parcel$export(module.exports, "collections", function () { return $f2eaa523beb37991$export$167de583c0ce0e55; });
$parcel$export(module.exports, "aggregateCollections", function () { return $f2eaa523beb37991$export$3ffbf194efc035e2; });
$parcel$export(module.exports, "CollectionLookup", function () { return $f2eaa523beb37991$export$2bd3f057a523cb29; });
$parcel$export(module.exports, "AggregateCollectionLookup", function () { return $f2eaa523beb37991$export$90240c993c78249f; });
$parcel$export(module.exports, "autoSaveCollections", function () { return $f2eaa523beb37991$export$6fdabe77c101832f; });
$parcel$export(module.exports, "collectionClasses", function () { return $f2eaa523beb37991$export$514460938402b9ab; });
$parcel$export(module.exports, "aggregateCollectionClasses", function () { return $f2eaa523beb37991$export$b45a5f62da66feff; });
$parcel$export(module.exports, "CollectionClassLookup", function () { return $f2eaa523beb37991$export$1c068831c12f7c9a; });
$parcel$export(module.exports, "AggregateCollectionClassLookup", function () { return $f2eaa523beb37991$export$873db4a93360f506; });

var $4sGvn = parcelRequire("4sGvn");

var $hy8Zj = parcelRequire("hy8Zj");

var $foua5 = parcelRequire("foua5");

var $cPDHe = parcelRequire("cPDHe");

var $k7Nfo = parcelRequire("k7Nfo");

var $2F6ay = parcelRequire("2F6ay");

var $cfz4k = parcelRequire("cfz4k");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $PIDKX = parcelRequire("PIDKX");

var $arSbR = parcelRequire("arSbR");

var $cLLPo = parcelRequire("cLLPo");

var $grD63 = parcelRequire("grD63");

var $kB03O = parcelRequire("kB03O");

var $2U4XU = parcelRequire("2U4XU");

var $bzI0s = parcelRequire("bzI0s");

var $h8VDI = parcelRequire("h8VDI");

var $bMOby = parcelRequire("bMOby");

var $6omGT = parcelRequire("6omGT");

var $gDUfk = parcelRequire("gDUfk");

var $iV9Vs = parcelRequire("iV9Vs");

var $fpkTk = parcelRequire("fpkTk");

var $8YeUb = parcelRequire("8YeUb");

var $9W6IT = parcelRequire("9W6IT");

var $lTrDt = parcelRequire("lTrDt");

var $ftbex = parcelRequire("ftbex");

var $augzx = parcelRequire("augzx");

var $cuB2x = parcelRequire("cuB2x");

var $8sHH3 = parcelRequire("8sHH3");

var $5EjDW = parcelRequire("5EjDW");

var $itgIJ = parcelRequire("itgIJ");

var $hwZYE = parcelRequire("hwZYE");

var $aZYqt = parcelRequire("aZYqt");

var $4nGBk = parcelRequire("4nGBk");

var $4uDE2 = parcelRequire("4uDE2");

var $1Nfhh = parcelRequire("1Nfhh");

var $bErJe = parcelRequire("bErJe");

var $fhWB7 = parcelRequire("fhWB7");

var $3GX9k = parcelRequire("3GX9k");

var $6UKmT = parcelRequire("6UKmT");

var $gVN2k = parcelRequire("gVN2k");

var $gUQZS = parcelRequire("gUQZS");

var $gwjB7 = parcelRequire("gwjB7");

var $blgBn = parcelRequire("blgBn");

var $5Rhbi = parcelRequire("5Rhbi");

var $lUr4c = parcelRequire("lUr4c");

var $1qwrf = parcelRequire("1qwrf");

var $cpPFf = parcelRequire("cpPFf");
const $f2eaa523beb37991$export$167de583c0ce0e55 = [
    (0, $5EjDW.default),
    (0, $hwZYE.default),
    (0, $4sGvn.default),
    (0, $hy8Zj.default),
    (0, $foua5.default),
    (0, $cPDHe.default),
    (0, $k7Nfo.default),
    (0, $2F6ay.default),
    (0, $cfz4k.default),
    (0, $PIDKX.default),
    (0, $aZYqt.default),
    (0, $arSbR.default),
    (0, $cLLPo.default),
    (0, $grD63.default),
    (0, $kB03O.default),
    (0, $2U4XU.default),
    (0, $bzI0s.default),
    (0, $9Lw71.default),
    (0, $kdO1A.default),
    (0, $8sHH3.default),
    (0, $h8VDI.default),
    (0, $bMOby.default),
    (0, $itgIJ.default),
    (0, $6omGT.default),
    (0, $gDUfk.default),
    (0, $iV9Vs.default),
    (0, $fpkTk.default),
    (0, $8YeUb.default),
    (0, $9W6IT.default),
    (0, $lTrDt.default),
    (0, $ftbex.default),
    (0, $augzx.default),
    (0, $cuB2x.default),
    (0, $gwjB7.default),
    (0, $blgBn.default),
    (0, $5Rhbi.default),
    (0, $lUr4c.default),
    (0, $1qwrf.default),
    (0, $cpPFf.default)
];
const $f2eaa523beb37991$export$3ffbf194efc035e2 = [
    (0, $4nGBk.default),
    (0, $4uDE2.default),
    (0, $1Nfhh.default),
    (0, $bErJe.default),
    (0, $fhWB7.default),
    (0, $3GX9k.default),
    (0, $6UKmT.default),
    (0, $gVN2k.default),
    (0, $gUQZS.default)
];
const $f2eaa523beb37991$export$2bd3f057a523cb29 = Object.fromEntries([
    ...$f2eaa523beb37991$export$167de583c0ce0e55.map((c)=>[
            c.collection,
            c
        ]),
    [
        "staffMembers",
        (0, $lTrDt.default)
    ],
    [
        "staffs",
        (0, $lTrDt.default)
    ]
]);
const $f2eaa523beb37991$export$90240c993c78249f = Object.fromEntries($f2eaa523beb37991$export$3ffbf194efc035e2.map((c)=>[
        c.collection,
        c
    ]));
const $f2eaa523beb37991$export$6fdabe77c101832f = [
    (0, $5EjDW.default),
    (0, $hwZYE.default),
    (0, $4sGvn.default),
    (0, $hy8Zj.default),
    (0, $foua5.default),
    (0, $cPDHe.default),
    (0, $k7Nfo.default),
    (0, $2F6ay.default),
    (0, $cfz4k.default),
    (0, $PIDKX.default),
    (0, $aZYqt.default),
    (0, $arSbR.default),
    (0, $cLLPo.default),
    (0, $grD63.default),
    // OrganisationSubscriptionCollection,
    // ReportCollection,
    (0, $bzI0s.default),
    (0, $9Lw71.default),
    (0, $kdO1A.default),
    (0, $8sHH3.default),
    (0, $h8VDI.default),
    (0, $bMOby.default),
    (0, $itgIJ.default),
    (0, $6omGT.default),
    // ResourceScheduleReportCollection,
    // RevenueForecastReportCollection,
    (0, $fpkTk.default),
    (0, $8YeUb.default),
    (0, $9W6IT.default),
    (0, $fpkTk.default),
    (0, $lTrDt.default),
    (0, $ftbex.default),
    (0, $augzx.default),
    (0, $cuB2x.default),
    (0, $gwjB7.default),
    (0, $blgBn.default),
    (0, $5Rhbi.default),
    (0, $lUr4c.default),
    (0, $1qwrf.default),
    (0, $cpPFf.default)
];
const $f2eaa523beb37991$export$514460938402b9ab = [
    (0, $5EjDW.BudgetCollectionClass),
    (0, $hwZYE.ChangeLogCollectionClass),
    (0, $4sGvn.ContactCollectionClass),
    (0, $hy8Zj.CostCentreCollectionClass),
    (0, $foua5.SupplierCollectionClass),
    (0, $cPDHe.DailyAllocationCollectionClass),
    (0, $k7Nfo.AllocationCollectionClass),
    (0, $2F6ay.MonthlyAllocationCollectionClass),
    (0, $cfz4k.WeeklyAllocationCollectionClass),
    (0, $PIDKX.InvoiceCollectionClass),
    (0, $aZYqt.InvoiceLineItemCollectionClass),
    (0, $arSbR.InvoiceDescriptionTemplateCollectionClass),
    (0, $cLLPo.OrganisationCollectionClass),
    (0, $grD63.OrganisationHolidayCollectionClass),
    (0, $kB03O.OrganisationSubscriptionCollectionClass),
    (0, $2U4XU.ReportCollectionClass),
    (0, $bzI0s.OverheadExpenseCollectionClass),
    (0, $9Lw71.PhaseCollectionClass),
    (0, $kdO1A.ProjectCollectionClass),
    (0, $8sHH3.ProjectExpenseCollectionClass),
    (0, $h8VDI.ProjectExpenseAllocationCollectionClass),
    (0, $bMOby.ProjectExpenseItemCollectionClass),
    (0, $itgIJ.ProjectNoteCollectionClass),
    (0, $6omGT.ProjectRateCollectionClass),
    (0, $gDUfk.ResourceScheduleReportCollectionClass),
    (0, $iV9Vs.RevenueForecastReportCollectionClass),
    (0, $fpkTk.RevenueTargetCollectionClass),
    (0, $8YeUb.RoleCollectionClass),
    (0, $9W6IT.RoleRateCollectionClass),
    (0, $lTrDt.StaffCollectionClass),
    (0, $ftbex.StaffRateCollectionClass),
    (0, $augzx.TaskCollectionClass),
    (0, $cuB2x.TimeEntryCollectionClass),
    (0, $gwjB7.MonthlyResourceCellCollectionClass),
    (0, $blgBn.ResourceRowCollectionClass),
    (0, $5Rhbi.MonthlyRevenueCellCollectionClass),
    (0, $lUr4c.RevenueRowCollectionClass),
    (0, $1qwrf.MonthlyExpenseCellCollectionClass),
    (0, $cpPFf.ExpenseRowCollectionClass)
];
const $f2eaa523beb37991$export$b45a5f62da66feff = [
    (0, $4nGBk.InvoiceLineItemAggregateCollectionClass),
    (0, $4uDE2.ProjectExpenseAggregateCollectionClass),
    (0, $1Nfhh.TimeEntryAggregateCollectionClass),
    (0, $bErJe.DailyAllocationAggregateCollectionClass),
    (0, $fhWB7.AllocationAggregateCollectionClass),
    (0, $2F6ay.MonthlyAllocationCollectionClass),
    (0, $6UKmT.RevenueTargetAggregateCollectionClass),
    (0, $gVN2k.PhaseAggregateCollectionClass),
    (0, $gUQZS.BudgetAggregateCollectionClass)
];
const $f2eaa523beb37991$export$1c068831c12f7c9a = Object.fromEntries($f2eaa523beb37991$export$514460938402b9ab.map((c)=>[
        new c().collection,
        c
    ]));
const $f2eaa523beb37991$export$873db4a93360f506 = Object.fromEntries($f2eaa523beb37991$export$b45a5f62da66feff.map((c)=>[
        new c().collection,
        c
    ]));

});
parcelRegister("k7Nfo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea6aa998bfa5278e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "AllocationCollectionClass", function () { return $ea6aa998bfa5278e$export$10677ecf6e061ea5; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $21QKB = parcelRequire("21QKB");

var $iCTvZ = parcelRequire("iCTvZ");
var $ea6aa998bfa5278e$var$_dec, $ea6aa998bfa5278e$var$_dec2, $ea6aa998bfa5278e$var$_class;
function $ea6aa998bfa5278e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $ea6aa998bfa5278e$var$AllocationCollection = ($ea6aa998bfa5278e$var$_dec = (0, $d8hWe.action).bound, $ea6aa998bfa5278e$var$_dec2 = (0, $d8hWe.action).bound, $ea6aa998bfa5278e$var$_class = class AllocationCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "allocations",
            modelClass: (0, $21QKB.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByTaskId", "manyByKey", {
            key: (t)=>t.taskId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByCostCentreId", "manyByKey", {
            key: (t)=>t.costCentreId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdDate", "manyByKey", {
            key: (t)=>(0, $iCTvZ.default)(t.staffId, t.date.getTime()),
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffIdWeek", "manyByKey", {
            key: (t)=>{
                return (0, $iCTvZ.default)(t.staffId, t.week);
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data, options) {
        this.add(data, options);
    }
    addAllocations(data, options) {
        this.addMany(data, options);
    }
}, $ea6aa998bfa5278e$var$_applyDecoratedDescriptor($ea6aa998bfa5278e$var$_class.prototype, "addAllocation", [
    $ea6aa998bfa5278e$var$_dec
], Object.getOwnPropertyDescriptor($ea6aa998bfa5278e$var$_class.prototype, "addAllocation"), $ea6aa998bfa5278e$var$_class.prototype), $ea6aa998bfa5278e$var$_applyDecoratedDescriptor($ea6aa998bfa5278e$var$_class.prototype, "addAllocations", [
    $ea6aa998bfa5278e$var$_dec2
], Object.getOwnPropertyDescriptor($ea6aa998bfa5278e$var$_class.prototype, "addAllocations"), $ea6aa998bfa5278e$var$_class.prototype), $ea6aa998bfa5278e$var$_class);
var $ea6aa998bfa5278e$export$2e2bcd8739ae039 = new $ea6aa998bfa5278e$var$AllocationCollection();
const $ea6aa998bfa5278e$export$10677ecf6e061ea5 = $ea6aa998bfa5278e$var$AllocationCollection;

});
parcelRegister("21QKB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a497f682bcc20f$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");
parcelRequire("augzx");

var $fqmGV = parcelRequire("fqmGV");

var $k7Nfo = parcelRequire("k7Nfo");
parcelRequire("hy8Zj");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $17a497f682bcc20f$var$_class, $17a497f682bcc20f$var$_descriptor, $17a497f682bcc20f$var$_descriptor2, $17a497f682bcc20f$var$_descriptor3, $17a497f682bcc20f$var$_descriptor4, $17a497f682bcc20f$var$_descriptor5, $17a497f682bcc20f$var$_descriptor6, $17a497f682bcc20f$var$_descriptor7, $17a497f682bcc20f$var$_descriptor8, $17a497f682bcc20f$var$_descriptor9, $17a497f682bcc20f$var$_descriptor10;
function $17a497f682bcc20f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $17a497f682bcc20f$var$_defineProperty(e, r, t) {
    return (r = $17a497f682bcc20f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $17a497f682bcc20f$var$_toPropertyKey(t) {
    var i = $17a497f682bcc20f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $17a497f682bcc20f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $17a497f682bcc20f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $17a497f682bcc20f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $17a497f682bcc20f$var$AllocationModel = ($17a497f682bcc20f$var$_class = class AllocationModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "staffId", $17a497f682bcc20f$var$_descriptor, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "roleId", $17a497f682bcc20f$var$_descriptor2, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "projectId", $17a497f682bcc20f$var$_descriptor3, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "phaseId", $17a497f682bcc20f$var$_descriptor4, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "date", $17a497f682bcc20f$var$_descriptor5, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "numMinutes", $17a497f682bcc20f$var$_descriptor6, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "startMinutes", $17a497f682bcc20f$var$_descriptor7, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "pay", $17a497f682bcc20f$var$_descriptor8, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "cost", $17a497f682bcc20f$var$_descriptor9, this);
        $17a497f682bcc20f$var$_initializerDefineProperty(this, "charge_out", $17a497f682bcc20f$var$_descriptor10, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $k7Nfo.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).staffsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return (0, $8YeUb.default).rolesById[this.roleId] || ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role);
    }
    get costCentre() {
        return this.project.costCentre;
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get hours() {
        return this.numMinutes / 60;
    }
    get payRate() {
        return this.pay / this.hours;
    }
    get costRate() {
        return this.cost / this.hours;
    }
    get chargeOutRate() {
        return this.chargeOut / this.hours;
    }
    get week() {
        return (0, $egx7S.getWeek)(this.date, {
            weekStartsOn: 1
        });
    }
    get month() {
        return (0, $egx7S.getMonth)(this.date);
    }
    get likelihood() {
        var _this$phase;
        return ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.likelihood) || 100;
    }
}, $17a497f682bcc20f$var$_descriptor = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $17a497f682bcc20f$var$_descriptor2 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $17a497f682bcc20f$var$_descriptor3 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $17a497f682bcc20f$var$_descriptor4 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $17a497f682bcc20f$var$_descriptor5 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Date();
    }
}), $17a497f682bcc20f$var$_descriptor6 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $17a497f682bcc20f$var$_descriptor7 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "startMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $17a497f682bcc20f$var$_descriptor8 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $17a497f682bcc20f$var$_descriptor9 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $17a497f682bcc20f$var$_descriptor10 = $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "charge_out", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "staff"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "role"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "costCentre"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "project"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "phase"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "hours"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "payRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "payRate"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "costRate"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "chargeOutRate"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "week", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "week"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "month", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "month"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_applyDecoratedDescriptor($17a497f682bcc20f$var$_class.prototype, "likelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($17a497f682bcc20f$var$_class.prototype, "likelihood"), $17a497f682bcc20f$var$_class.prototype), $17a497f682bcc20f$var$_class);
var $17a497f682bcc20f$export$2e2bcd8739ae039 = $17a497f682bcc20f$var$AllocationModel;

});


parcelRegister("arSbR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79b67613d0953638$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InvoiceDescriptionTemplateCollectionClass", function () { return $79b67613d0953638$export$5663121f96b25801; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $cm9S9 = parcelRequire("cm9S9");
var $79b67613d0953638$var$_dec, $79b67613d0953638$var$_dec2, $79b67613d0953638$var$_class;
function $79b67613d0953638$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $79b67613d0953638$var$InvoiceDescriptionTemplateCollection = ($79b67613d0953638$var$_dec = (0, $d8hWe.action).bound, $79b67613d0953638$var$_dec2 = (0, $d8hWe.action).bound, $79b67613d0953638$var$_class = class InvoiceDescriptionTemplateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "invoiceDescriptionTemplates",
            modelClass: (0, $cm9S9.default)
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get descriptionTemplatesById() {
        return this.modelsById;
    }
    get descriptionTemplates() {
        return this.models;
    }
    addDescriptionTemplate(data) {
        this.add(data);
    }
    addDescriptionTemplates(data) {
        this.addMany(data);
    }
}, $79b67613d0953638$var$_applyDecoratedDescriptor($79b67613d0953638$var$_class.prototype, "addDescriptionTemplate", [
    $79b67613d0953638$var$_dec
], Object.getOwnPropertyDescriptor($79b67613d0953638$var$_class.prototype, "addDescriptionTemplate"), $79b67613d0953638$var$_class.prototype), $79b67613d0953638$var$_applyDecoratedDescriptor($79b67613d0953638$var$_class.prototype, "addDescriptionTemplates", [
    $79b67613d0953638$var$_dec2
], Object.getOwnPropertyDescriptor($79b67613d0953638$var$_class.prototype, "addDescriptionTemplates"), $79b67613d0953638$var$_class.prototype), $79b67613d0953638$var$_class);
var $79b67613d0953638$export$2e2bcd8739ae039 = new $79b67613d0953638$var$InvoiceDescriptionTemplateCollection();
const $79b67613d0953638$export$5663121f96b25801 = $79b67613d0953638$var$InvoiceDescriptionTemplateCollection;

});
parcelRegister("cm9S9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fef3295edee24c3$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $arSbR = parcelRequire("arSbR");

var $fqmGV = parcelRequire("fqmGV");
var $8fef3295edee24c3$var$_class, $8fef3295edee24c3$var$_descriptor, $8fef3295edee24c3$var$_descriptor2;
function $8fef3295edee24c3$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $8fef3295edee24c3$var$_defineProperty(e, r, t) {
    return (r = $8fef3295edee24c3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8fef3295edee24c3$var$_toPropertyKey(t) {
    var i = $8fef3295edee24c3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8fef3295edee24c3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8fef3295edee24c3$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $8fef3295edee24c3$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $8fef3295edee24c3$var$InvoiceDescriptionTemplateModel = ($8fef3295edee24c3$var$_class = class InvoiceDescriptionTemplateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $8fef3295edee24c3$var$_initializerDefineProperty(this, "name", $8fef3295edee24c3$var$_descriptor, this);
        $8fef3295edee24c3$var$_initializerDefineProperty(this, "description", $8fef3295edee24c3$var$_descriptor2, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $arSbR.default);
        this.init(data, options);
    }
}, $8fef3295edee24c3$var$_descriptor = $8fef3295edee24c3$var$_applyDecoratedDescriptor($8fef3295edee24c3$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8fef3295edee24c3$var$_descriptor2 = $8fef3295edee24c3$var$_applyDecoratedDescriptor($8fef3295edee24c3$var$_class.prototype, "description", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8fef3295edee24c3$var$_class);
var $8fef3295edee24c3$export$2e2bcd8739ae039 = $8fef3295edee24c3$var$InvoiceDescriptionTemplateModel;

});


parcelRegister("grD63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf8d7eb92ba628ea$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "OrganisationHolidayCollectionClass", function () { return $bf8d7eb92ba628ea$export$643eeb189ba93479; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $awGtd = parcelRequire("awGtd");
var $bf8d7eb92ba628ea$var$_dec, $bf8d7eb92ba628ea$var$_dec2, $bf8d7eb92ba628ea$var$_class;
function $bf8d7eb92ba628ea$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $bf8d7eb92ba628ea$var$OrganisationHolidayCollection = ($bf8d7eb92ba628ea$var$_dec = (0, $d8hWe.action).bound, $bf8d7eb92ba628ea$var$_dec2 = (0, $d8hWe.action).bound, $bf8d7eb92ba628ea$var$_class = class OrganisationHolidayCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "organisationHolidays",
            modelClass: (0, $awGtd.default)
        });
        this.addLookup("activeHolidays", "list", {
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get organisationHolidaysById() {
        return this.modelsById;
    }
    get organisationHolidays() {
        return this.models;
    }
    addOrganisationHoliday(data) {
        this.add(data);
    }
    addOrganisationHolidays(data) {
        this.addMany(data);
    }
}, $bf8d7eb92ba628ea$var$_applyDecoratedDescriptor($bf8d7eb92ba628ea$var$_class.prototype, "addOrganisationHoliday", [
    $bf8d7eb92ba628ea$var$_dec
], Object.getOwnPropertyDescriptor($bf8d7eb92ba628ea$var$_class.prototype, "addOrganisationHoliday"), $bf8d7eb92ba628ea$var$_class.prototype), $bf8d7eb92ba628ea$var$_applyDecoratedDescriptor($bf8d7eb92ba628ea$var$_class.prototype, "addOrganisationHolidays", [
    $bf8d7eb92ba628ea$var$_dec2
], Object.getOwnPropertyDescriptor($bf8d7eb92ba628ea$var$_class.prototype, "addOrganisationHolidays"), $bf8d7eb92ba628ea$var$_class.prototype), $bf8d7eb92ba628ea$var$_class);
var $bf8d7eb92ba628ea$export$2e2bcd8739ae039 = new $bf8d7eb92ba628ea$var$OrganisationHolidayCollection();
const $bf8d7eb92ba628ea$export$643eeb189ba93479 = $bf8d7eb92ba628ea$var$OrganisationHolidayCollection;

});
parcelRegister("awGtd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a9dd6378dbd1c9f$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $grD63 = parcelRequire("grD63");

var $fqmGV = parcelRequire("fqmGV");
var $7a9dd6378dbd1c9f$var$_class, $7a9dd6378dbd1c9f$var$_descriptor, $7a9dd6378dbd1c9f$var$_descriptor2, $7a9dd6378dbd1c9f$var$_descriptor3;
function $7a9dd6378dbd1c9f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $7a9dd6378dbd1c9f$var$_defineProperty(e, r, t) {
    return (r = $7a9dd6378dbd1c9f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7a9dd6378dbd1c9f$var$_toPropertyKey(t) {
    var i = $7a9dd6378dbd1c9f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7a9dd6378dbd1c9f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7a9dd6378dbd1c9f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $7a9dd6378dbd1c9f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $7a9dd6378dbd1c9f$var$OrganisationHolidayModel = ($7a9dd6378dbd1c9f$var$_class = class OrganisationHolidayModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $7a9dd6378dbd1c9f$var$_initializerDefineProperty(this, "name", $7a9dd6378dbd1c9f$var$_descriptor, this);
        $7a9dd6378dbd1c9f$var$_initializerDefineProperty(this, "startDate", $7a9dd6378dbd1c9f$var$_descriptor2, this);
        $7a9dd6378dbd1c9f$var$_initializerDefineProperty(this, "endDate", $7a9dd6378dbd1c9f$var$_descriptor3, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $grD63.default);
        this.init(data, options);
    }
}, $7a9dd6378dbd1c9f$var$_descriptor = $7a9dd6378dbd1c9f$var$_applyDecoratedDescriptor($7a9dd6378dbd1c9f$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7a9dd6378dbd1c9f$var$_descriptor2 = $7a9dd6378dbd1c9f$var$_applyDecoratedDescriptor($7a9dd6378dbd1c9f$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7a9dd6378dbd1c9f$var$_descriptor3 = $7a9dd6378dbd1c9f$var$_applyDecoratedDescriptor($7a9dd6378dbd1c9f$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $7a9dd6378dbd1c9f$var$_class);
var $7a9dd6378dbd1c9f$export$2e2bcd8739ae039 = $7a9dd6378dbd1c9f$var$OrganisationHolidayModel;

});


parcelRegister("bMOby", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $894b1b2fd85db891$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectExpenseItemCollectionClass", function () { return $894b1b2fd85db891$export$3b87e9d4226b3e21; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $iGBGM = parcelRequire("iGBGM");

var $iCTvZ = parcelRequire("iCTvZ");
var $894b1b2fd85db891$var$_dec, $894b1b2fd85db891$var$_dec2, $894b1b2fd85db891$var$_class;
function $894b1b2fd85db891$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $894b1b2fd85db891$var$ProjectExpenseItemCollection = ($894b1b2fd85db891$var$_dec = (0, $d8hWe.action).bound, $894b1b2fd85db891$var$_dec2 = (0, $d8hWe.action).bound, $894b1b2fd85db891$var$_class = class ProjectExpenseItemCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "projectExpenseItems",
            modelClass: (0, $iGBGM.default)
        });
        this.addLookup("expenseItemsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseItemsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseItemsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expenseItemsByStaffIdDate", "manyByKey", {
            key: (t)=>{
                var _t$date;
                return (0, $iCTvZ.tuple)(t === null || t === void 0 ? void 0 : t.staffId, t === null || t === void 0 ? void 0 : (_t$date = t.date) === null || _t$date === void 0 ? void 0 : _t$date.getTime());
            },
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get projectExpenseItemsById() {
        return this.modelsById;
    }
    get projectExpenseItems() {
        return this.models;
    }
    addProjectExpenseItem(data) {
        this.add(data);
    }
    addProjectExpenseItems(data) {
        this.addMany(data);
    }
}, $894b1b2fd85db891$var$_applyDecoratedDescriptor($894b1b2fd85db891$var$_class.prototype, "addProjectExpenseItem", [
    $894b1b2fd85db891$var$_dec
], Object.getOwnPropertyDescriptor($894b1b2fd85db891$var$_class.prototype, "addProjectExpenseItem"), $894b1b2fd85db891$var$_class.prototype), $894b1b2fd85db891$var$_applyDecoratedDescriptor($894b1b2fd85db891$var$_class.prototype, "addProjectExpenseItems", [
    $894b1b2fd85db891$var$_dec2
], Object.getOwnPropertyDescriptor($894b1b2fd85db891$var$_class.prototype, "addProjectExpenseItems"), $894b1b2fd85db891$var$_class.prototype), $894b1b2fd85db891$var$_class);
var $894b1b2fd85db891$export$2e2bcd8739ae039 = new $894b1b2fd85db891$var$ProjectExpenseItemCollection();
const $894b1b2fd85db891$export$3b87e9d4226b3e21 = $894b1b2fd85db891$var$ProjectExpenseItemCollection;

});
parcelRegister("iGBGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9a9627dfc102c06$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $bMOby = parcelRequire("bMOby");

var $8sHH3 = parcelRequire("8sHH3");

var $fqmGV = parcelRequire("fqmGV");
var $d9a9627dfc102c06$var$_class, $d9a9627dfc102c06$var$_descriptor, $d9a9627dfc102c06$var$_descriptor2, $d9a9627dfc102c06$var$_descriptor3, $d9a9627dfc102c06$var$_descriptor4, $d9a9627dfc102c06$var$_descriptor5, $d9a9627dfc102c06$var$_descriptor6, $d9a9627dfc102c06$var$_descriptor7, $d9a9627dfc102c06$var$_descriptor8, $d9a9627dfc102c06$var$_descriptor9, $d9a9627dfc102c06$var$_descriptor10;
function $d9a9627dfc102c06$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $d9a9627dfc102c06$var$_defineProperty(e, r, t) {
    return (r = $d9a9627dfc102c06$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d9a9627dfc102c06$var$_toPropertyKey(t) {
    var i = $d9a9627dfc102c06$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d9a9627dfc102c06$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d9a9627dfc102c06$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $d9a9627dfc102c06$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $d9a9627dfc102c06$var$ProjectExpenseItemModel = ($d9a9627dfc102c06$var$_class = class ProjectExpenseItemModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "projectId", $d9a9627dfc102c06$var$_descriptor, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "phaseId", $d9a9627dfc102c06$var$_descriptor2, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "staffId", $d9a9627dfc102c06$var$_descriptor3, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "expenseId", $d9a9627dfc102c06$var$_descriptor4, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "date", $d9a9627dfc102c06$var$_descriptor5, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "cost", $d9a9627dfc102c06$var$_descriptor6, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "quantity", $d9a9627dfc102c06$var$_descriptor7, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "description", $d9a9627dfc102c06$var$_descriptor8, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "isLocked", $d9a9627dfc102c06$var$_descriptor9, this);
        $d9a9627dfc102c06$var$_initializerDefineProperty(this, "beenInvoiced", $d9a9627dfc102c06$var$_descriptor10, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $bMOby.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get expense() {
        return (0, $8sHH3.default).modelsById[this.expenseId];
    }
}, $d9a9627dfc102c06$var$_descriptor = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor2 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor3 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor4 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "expenseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor5 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor6 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor7 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "quantity", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor8 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "description", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor9 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "isLocked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_descriptor10 = $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "beenInvoiced", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($d9a9627dfc102c06$var$_class.prototype, "project"), $d9a9627dfc102c06$var$_class.prototype), $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($d9a9627dfc102c06$var$_class.prototype, "phase"), $d9a9627dfc102c06$var$_class.prototype), $d9a9627dfc102c06$var$_applyDecoratedDescriptor($d9a9627dfc102c06$var$_class.prototype, "expense", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($d9a9627dfc102c06$var$_class.prototype, "expense"), $d9a9627dfc102c06$var$_class.prototype), $d9a9627dfc102c06$var$_class);
var $d9a9627dfc102c06$export$2e2bcd8739ae039 = $d9a9627dfc102c06$var$ProjectExpenseItemModel;

});


parcelRegister("ftbex", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4324729579adc69$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "StaffRateCollectionClass", function () { return $b4324729579adc69$export$b7f94ba660bb961a; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $9pq6C = parcelRequire("9pq6C");
var $b4324729579adc69$var$_dec, $b4324729579adc69$var$_dec2, $b4324729579adc69$var$_class;
function $b4324729579adc69$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $b4324729579adc69$var$StaffRateCollection = ($b4324729579adc69$var$_dec = (0, $d8hWe.action).bound, $b4324729579adc69$var$_dec2 = (0, $d8hWe.action).bound, $b4324729579adc69$var$_class = class StaffRateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "staffRates",
            modelClass: (0, $9pq6C.default)
        });
        this.addLookup("ratesByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get staffRatesById() {
        return this.modelsById;
    }
    get staffRates() {
        return this.models;
    }
    addStaffRate(data) {
        this.add(data);
    }
    addStaffRates(data) {
        this.addMany(data);
    }
}, $b4324729579adc69$var$_applyDecoratedDescriptor($b4324729579adc69$var$_class.prototype, "addStaffRate", [
    $b4324729579adc69$var$_dec
], Object.getOwnPropertyDescriptor($b4324729579adc69$var$_class.prototype, "addStaffRate"), $b4324729579adc69$var$_class.prototype), $b4324729579adc69$var$_applyDecoratedDescriptor($b4324729579adc69$var$_class.prototype, "addStaffRates", [
    $b4324729579adc69$var$_dec2
], Object.getOwnPropertyDescriptor($b4324729579adc69$var$_class.prototype, "addStaffRates"), $b4324729579adc69$var$_class.prototype), $b4324729579adc69$var$_class);
var $b4324729579adc69$export$2e2bcd8739ae039 = new $b4324729579adc69$var$StaffRateCollection();
const $b4324729579adc69$export$b7f94ba660bb961a = $b4324729579adc69$var$StaffRateCollection;

});
parcelRegister("9pq6C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d9ab2ef8fa2b74c$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $ftbex = parcelRequire("ftbex");

var $fqmGV = parcelRequire("fqmGV");
var $6d9ab2ef8fa2b74c$var$_class, $6d9ab2ef8fa2b74c$var$_descriptor, $6d9ab2ef8fa2b74c$var$_descriptor2, $6d9ab2ef8fa2b74c$var$_descriptor3, $6d9ab2ef8fa2b74c$var$_descriptor4, $6d9ab2ef8fa2b74c$var$_descriptor5, $6d9ab2ef8fa2b74c$var$_descriptor6, $6d9ab2ef8fa2b74c$var$_descriptor7;
function $6d9ab2ef8fa2b74c$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $6d9ab2ef8fa2b74c$var$_defineProperty(e, r, t) {
    return (r = $6d9ab2ef8fa2b74c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6d9ab2ef8fa2b74c$var$_toPropertyKey(t) {
    var i = $6d9ab2ef8fa2b74c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6d9ab2ef8fa2b74c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $6d9ab2ef8fa2b74c$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $6d9ab2ef8fa2b74c$var$StaffRateModel = ($6d9ab2ef8fa2b74c$var$_class = class StaffRateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $6d9ab2ef8fa2b74c$var$_initializerDefineProperty(this, "staffId", $6d9ab2ef8fa2b74c$var$_descriptor, this);
        $6d9ab2ef8fa2b74c$var$_initializerDefineProperty(this, "date", $6d9ab2ef8fa2b74c$var$_descriptor2, this);
        $6d9ab2ef8fa2b74c$var$_initializerDefineProperty(this, "payRate", $6d9ab2ef8fa2b74c$var$_descriptor3, this);
        $6d9ab2ef8fa2b74c$var$_initializerDefineProperty(this, "chargeOutRate", $6d9ab2ef8fa2b74c$var$_descriptor4, this);
        $6d9ab2ef8fa2b74c$var$_initializerDefineProperty(this, "costRate", $6d9ab2ef8fa2b74c$var$_descriptor5, this);
        $6d9ab2ef8fa2b74c$var$_initializerDefineProperty(this, "weeklyAvailability", $6d9ab2ef8fa2b74c$var$_descriptor6, this);
        $6d9ab2ef8fa2b74c$var$_initializerDefineProperty(this, "overtimeRate", $6d9ab2ef8fa2b74c$var$_descriptor7, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $ftbex.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).modelsById[this.staffId];
    }
}, $6d9ab2ef8fa2b74c$var$_descriptor = $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d9ab2ef8fa2b74c$var$_descriptor2 = $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "date", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d9ab2ef8fa2b74c$var$_descriptor3 = $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "payRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d9ab2ef8fa2b74c$var$_descriptor4 = $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d9ab2ef8fa2b74c$var$_descriptor5 = $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "costRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d9ab2ef8fa2b74c$var$_descriptor6 = $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "weeklyAvailability", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d9ab2ef8fa2b74c$var$_descriptor7 = $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "overtimeRate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $6d9ab2ef8fa2b74c$var$_applyDecoratedDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($6d9ab2ef8fa2b74c$var$_class.prototype, "staff"), $6d9ab2ef8fa2b74c$var$_class.prototype), $6d9ab2ef8fa2b74c$var$_class);
var $6d9ab2ef8fa2b74c$export$2e2bcd8739ae039 = $6d9ab2ef8fa2b74c$var$StaffRateModel;

});


parcelRegister("4uDE2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3458b760f2d4b5aa$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProjectExpenseAggregateCollectionClass", function () { return $3458b760f2d4b5aa$export$d72ddc0b5eb1bc01; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $5z1wx = parcelRequire("5z1wx");

var $15hRc = parcelRequire("15hRc");
var $3458b760f2d4b5aa$var$_dec, $3458b760f2d4b5aa$var$_dec2, $3458b760f2d4b5aa$var$_class;
function $3458b760f2d4b5aa$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $3458b760f2d4b5aa$var$ProjectExpenseAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $3458b760f2d4b5aa$var$ProjectExpenseAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $3458b760f2d4b5aa$var$ProjectExpenseAggregateCollection = ($3458b760f2d4b5aa$var$_dec = (0, $d8hWe.action).bound, $3458b760f2d4b5aa$var$_dec2 = (0, $d8hWe.action).bound, $3458b760f2d4b5aa$var$_class = class ProjectExpenseAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "projectExpenses",
            modelClass: (0, $15hRc.default)
        });
        this.addLookup("expensesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expensesByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("expensesByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get projectExpensesById() {
        return this.modelsById;
    }
    get projectExpenses() {
        return this.models;
    }
    get projectExpensesById() {
        return this.modelsById;
    }
    addProjectExpense(data) {
        this.add(data);
    }
    addProjectExpenses(data) {
        this.addMany(data);
    }
}, $3458b760f2d4b5aa$var$_applyDecoratedDescriptor($3458b760f2d4b5aa$var$_class.prototype, "addProjectExpense", [
    $3458b760f2d4b5aa$var$_dec
], Object.getOwnPropertyDescriptor($3458b760f2d4b5aa$var$_class.prototype, "addProjectExpense"), $3458b760f2d4b5aa$var$_class.prototype), $3458b760f2d4b5aa$var$_applyDecoratedDescriptor($3458b760f2d4b5aa$var$_class.prototype, "addProjectExpenses", [
    $3458b760f2d4b5aa$var$_dec2
], Object.getOwnPropertyDescriptor($3458b760f2d4b5aa$var$_class.prototype, "addProjectExpenses"), $3458b760f2d4b5aa$var$_class.prototype), $3458b760f2d4b5aa$var$_class);
var $3458b760f2d4b5aa$export$2e2bcd8739ae039 = new $3458b760f2d4b5aa$var$ProjectExpenseAggregate();
const $3458b760f2d4b5aa$export$d72ddc0b5eb1bc01 = $3458b760f2d4b5aa$var$ProjectExpenseAggregateCollection;

});
parcelRegister("15hRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ca41c233d6b1973$export$2e2bcd8739ae039; });


var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $4uDE2 = parcelRequire("4uDE2");

var $h8VDI = parcelRequire("h8VDI");

var $fqmGV = parcelRequire("fqmGV");
var $0ca41c233d6b1973$var$_class, $0ca41c233d6b1973$var$_descriptor, $0ca41c233d6b1973$var$_descriptor2, $0ca41c233d6b1973$var$_descriptor3, $0ca41c233d6b1973$var$_descriptor4, $0ca41c233d6b1973$var$_descriptor5, $0ca41c233d6b1973$var$_descriptor6, $0ca41c233d6b1973$var$_descriptor7, $0ca41c233d6b1973$var$_descriptor8, $0ca41c233d6b1973$var$_descriptor9;
function $0ca41c233d6b1973$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $0ca41c233d6b1973$var$_defineProperty(e, r, t) {
    return (r = $0ca41c233d6b1973$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0ca41c233d6b1973$var$_toPropertyKey(t) {
    var i = $0ca41c233d6b1973$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0ca41c233d6b1973$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0ca41c233d6b1973$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $0ca41c233d6b1973$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $0ca41c233d6b1973$var$ProjectExpenseAggregateModel = ($0ca41c233d6b1973$var$_class = class ProjectExpenseAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "projectId", $0ca41c233d6b1973$var$_descriptor, this);
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "phaseId", $0ca41c233d6b1973$var$_descriptor2, this);
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "name", $0ca41c233d6b1973$var$_descriptor3, this);
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "quantity", $0ca41c233d6b1973$var$_descriptor4, this);
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "unitCost", $0ca41c233d6b1973$var$_descriptor5, this);
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "billable", $0ca41c233d6b1973$var$_descriptor6, this);
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "cost", $0ca41c233d6b1973$var$_descriptor7, this);
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "startDate", $0ca41c233d6b1973$var$_descriptor8, this);
        $0ca41c233d6b1973$var$_initializerDefineProperty(this, "endDate", $0ca41c233d6b1973$var$_descriptor9, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $4uDE2.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get allocations() {
        return (0, $h8VDI.default).expenseAllocationsByExpenseId[this.id];
    }
}, $0ca41c233d6b1973$var$_descriptor = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_descriptor2 = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_descriptor3 = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_descriptor4 = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "quantity", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_descriptor5 = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "unitCost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_descriptor6 = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "billable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_descriptor7 = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_descriptor8 = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_descriptor9 = $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0ca41c233d6b1973$var$_class.prototype, "project"), $0ca41c233d6b1973$var$_class.prototype), $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0ca41c233d6b1973$var$_class.prototype, "phase"), $0ca41c233d6b1973$var$_class.prototype), $0ca41c233d6b1973$var$_applyDecoratedDescriptor($0ca41c233d6b1973$var$_class.prototype, "allocations", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($0ca41c233d6b1973$var$_class.prototype, "allocations"), $0ca41c233d6b1973$var$_class.prototype), $0ca41c233d6b1973$var$_class);
var $0ca41c233d6b1973$export$2e2bcd8739ae039 = $0ca41c233d6b1973$var$ProjectExpenseAggregateModel;

});


parcelRegister("bErJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87b8f072582631b1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DailyAllocationAggregateCollectionClass", function () { return $87b8f072582631b1$export$daa479bc7a97193c; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $efqQq = parcelRequire("efqQq");

var $5z1wx = parcelRequire("5z1wx");
parcelRequire("5Xh7w");

var $iCTvZ = parcelRequire("iCTvZ");
var $87b8f072582631b1$var$_dec, $87b8f072582631b1$var$_dec2, $87b8f072582631b1$var$_class;
function $87b8f072582631b1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $87b8f072582631b1$var$DailyAllocationAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $87b8f072582631b1$var$DailyAllocationAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $87b8f072582631b1$var$DailyAllocationAggregateCollection = ($87b8f072582631b1$var$_dec = (0, $d8hWe.action).bound, $87b8f072582631b1$var$_dec2 = (0, $d8hWe.action).bound, $87b8f072582631b1$var$_class = class DailyAllocationAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "dailyAllocations",
            modelClass: (0, $efqQq.default)
        });
        this.addLookup("dailyAllocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("dailyAllocationsByModelTuple", "manyByMany", {
            keys: (t)=>{
                var _t$project, _t$phase, _t$role, _t$staff2, _t$project2, _t$phase2, _t$project3, _t$role2, _t$project4, _t$staff3, _t$phase3, _t$role3, _t$phase4, _t$staff4, _t$role4, _t$staff5, _t$project5, _t$phase5, _t$role5, _t$project6, _t$phase6, _t$staff6, _t$project7, _t$role6, _t$staff7, _t$phase7, _t$role7, _t$staff8, _t$project8, _t$phase8, _t$role8, _t$staff9;
                return [
                    (0, $iCTvZ.default)((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.id, undefined, undefined, undefined),
                    (0, $iCTvZ.default)(undefined, (_t$phase = t.phase) === null || _t$phase === void 0 ? void 0 : _t$phase.id, undefined, undefined),
                    (0, $iCTvZ.default)(undefined, undefined, (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.id, undefined),
                    (0, $iCTvZ.default)(undefined, undefined, undefined, (_t$staff2 = t.staff) === null || _t$staff2 === void 0 ? void 0 : _t$staff2.id),
                    (0, $iCTvZ.default)((_t$project2 = t.project) === null || _t$project2 === void 0 ? void 0 : _t$project2.id, (_t$phase2 = t.phase) === null || _t$phase2 === void 0 ? void 0 : _t$phase2.id, undefined, undefined),
                    (0, $iCTvZ.default)((_t$project3 = t.project) === null || _t$project3 === void 0 ? void 0 : _t$project3.id, undefined, (_t$role2 = t.role) === null || _t$role2 === void 0 ? void 0 : _t$role2.id, undefined),
                    (0, $iCTvZ.default)((_t$project4 = t.project) === null || _t$project4 === void 0 ? void 0 : _t$project4.id, undefined, undefined, (_t$staff3 = t.staff) === null || _t$staff3 === void 0 ? void 0 : _t$staff3.id),
                    (0, $iCTvZ.default)(undefined, (_t$phase3 = t.phase) === null || _t$phase3 === void 0 ? void 0 : _t$phase3.id, (_t$role3 = t.role) === null || _t$role3 === void 0 ? void 0 : _t$role3.id, undefined),
                    (0, $iCTvZ.default)(undefined, (_t$phase4 = t.phase) === null || _t$phase4 === void 0 ? void 0 : _t$phase4.id, undefined, (_t$staff4 = t.staff) === null || _t$staff4 === void 0 ? void 0 : _t$staff4.id),
                    (0, $iCTvZ.default)(undefined, undefined, (_t$role4 = t.role) === null || _t$role4 === void 0 ? void 0 : _t$role4.id, (_t$staff5 = t.staff) === null || _t$staff5 === void 0 ? void 0 : _t$staff5.id),
                    (0, $iCTvZ.default)((_t$project5 = t.project) === null || _t$project5 === void 0 ? void 0 : _t$project5.id, (_t$phase5 = t.phase) === null || _t$phase5 === void 0 ? void 0 : _t$phase5.id, (_t$role5 = t.role) === null || _t$role5 === void 0 ? void 0 : _t$role5.id, undefined),
                    (0, $iCTvZ.default)((_t$project6 = t.project) === null || _t$project6 === void 0 ? void 0 : _t$project6.id, (_t$phase6 = t.phase) === null || _t$phase6 === void 0 ? void 0 : _t$phase6.id, undefined, (_t$staff6 = t.staff) === null || _t$staff6 === void 0 ? void 0 : _t$staff6.id),
                    (0, $iCTvZ.default)((_t$project7 = t.project) === null || _t$project7 === void 0 ? void 0 : _t$project7.id, undefined, (_t$role6 = t.role) === null || _t$role6 === void 0 ? void 0 : _t$role6.id, (_t$staff7 = t.staff) === null || _t$staff7 === void 0 ? void 0 : _t$staff7.id),
                    (0, $iCTvZ.default)(undefined, (_t$phase7 = t.phase) === null || _t$phase7 === void 0 ? void 0 : _t$phase7.id, (_t$role7 = t.role) === null || _t$role7 === void 0 ? void 0 : _t$role7.id, (_t$staff8 = t.staff) === null || _t$staff8 === void 0 ? void 0 : _t$staff8.id),
                    (0, $iCTvZ.default)((_t$project8 = t.project) === null || _t$project8 === void 0 ? void 0 : _t$project8.id, (_t$phase8 = t.phase) === null || _t$phase8 === void 0 ? void 0 : _t$phase8.id, (_t$role8 = t.role) === null || _t$role8 === void 0 ? void 0 : _t$role8.id, (_t$staff9 = t.staff) === null || _t$staff9 === void 0 ? void 0 : _t$staff9.id)
                ];
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get dailyAllocationsById() {
        return this.modelsById;
    }
    get dailyAllocations() {
        return this.models;
    }
    get dailyAllocationsById() {
        return this.modelsById;
    }
    addDailyAllocation(data) {
        this.add(data);
    }
    addDailyAllocations(data) {
        this.addMany(data);
    }
}, $87b8f072582631b1$var$_applyDecoratedDescriptor($87b8f072582631b1$var$_class.prototype, "addDailyAllocation", [
    $87b8f072582631b1$var$_dec
], Object.getOwnPropertyDescriptor($87b8f072582631b1$var$_class.prototype, "addDailyAllocation"), $87b8f072582631b1$var$_class.prototype), $87b8f072582631b1$var$_applyDecoratedDescriptor($87b8f072582631b1$var$_class.prototype, "addDailyAllocations", [
    $87b8f072582631b1$var$_dec2
], Object.getOwnPropertyDescriptor($87b8f072582631b1$var$_class.prototype, "addDailyAllocations"), $87b8f072582631b1$var$_class.prototype), $87b8f072582631b1$var$_class);
var $87b8f072582631b1$export$2e2bcd8739ae039 = new $87b8f072582631b1$var$DailyAllocationAggregate();
const $87b8f072582631b1$export$daa479bc7a97193c = $87b8f072582631b1$var$DailyAllocationAggregateCollection;

});
parcelRegister("efqQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5f74a311fc314fe$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");

var $fqmGV = parcelRequire("fqmGV");

var $bErJe = parcelRequire("bErJe");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $a5f74a311fc314fe$var$_class, $a5f74a311fc314fe$var$_descriptor, $a5f74a311fc314fe$var$_descriptor2, $a5f74a311fc314fe$var$_descriptor3, $a5f74a311fc314fe$var$_descriptor4, $a5f74a311fc314fe$var$_descriptor5, $a5f74a311fc314fe$var$_descriptor6, $a5f74a311fc314fe$var$_descriptor7, $a5f74a311fc314fe$var$_descriptor8, $a5f74a311fc314fe$var$_descriptor9, $a5f74a311fc314fe$var$_descriptor10, $a5f74a311fc314fe$var$_descriptor11;
function $a5f74a311fc314fe$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $a5f74a311fc314fe$var$_defineProperty(e, r, t) {
    return (r = $a5f74a311fc314fe$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a5f74a311fc314fe$var$_toPropertyKey(t) {
    var i = $a5f74a311fc314fe$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a5f74a311fc314fe$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a5f74a311fc314fe$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $a5f74a311fc314fe$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $a5f74a311fc314fe$var$DailyAllocationAggregateModel = ($a5f74a311fc314fe$var$_class = class DailyAllocationAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "staffId", $a5f74a311fc314fe$var$_descriptor, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "projectId", $a5f74a311fc314fe$var$_descriptor2, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "phaseId", $a5f74a311fc314fe$var$_descriptor3, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "month", $a5f74a311fc314fe$var$_descriptor4, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "numMinutes", $a5f74a311fc314fe$var$_descriptor5, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "pay", $a5f74a311fc314fe$var$_descriptor6, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "cost", $a5f74a311fc314fe$var$_descriptor7, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "chargeOut", $a5f74a311fc314fe$var$_descriptor8, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "isBillable", $a5f74a311fc314fe$var$_descriptor9, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "isVariation", $a5f74a311fc314fe$var$_descriptor10, this);
        $a5f74a311fc314fe$var$_initializerDefineProperty(this, "beenInvoiced", $a5f74a311fc314fe$var$_descriptor11, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $bErJe.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role) || (0, $8YeUb.default).modelsById[this.roleId];
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get date() {
        return (0, $egx7S.parse)(this.month, "yyyy-MM", new Date());
    }
    get startDate() {
        return (0, $egx7S.startOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get endDate() {
        return (0, $egx7S.endOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get hours() {
        return this.numMinutes / 60;
    }
}, $a5f74a311fc314fe$var$_descriptor = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a5f74a311fc314fe$var$_descriptor2 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a5f74a311fc314fe$var$_descriptor3 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a5f74a311fc314fe$var$_descriptor4 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "month", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $a5f74a311fc314fe$var$_descriptor5 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a5f74a311fc314fe$var$_descriptor6 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a5f74a311fc314fe$var$_descriptor7 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a5f74a311fc314fe$var$_descriptor8 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "chargeOut", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $a5f74a311fc314fe$var$_descriptor9 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "isBillable", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a5f74a311fc314fe$var$_descriptor10 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "isVariation", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a5f74a311fc314fe$var$_descriptor11 = $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "beenInvoiced", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a5f74a311fc314fe$var$_class.prototype, "staff"), $a5f74a311fc314fe$var$_class.prototype), $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a5f74a311fc314fe$var$_class.prototype, "role"), $a5f74a311fc314fe$var$_class.prototype), $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a5f74a311fc314fe$var$_class.prototype, "project"), $a5f74a311fc314fe$var$_class.prototype), $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a5f74a311fc314fe$var$_class.prototype, "phase"), $a5f74a311fc314fe$var$_class.prototype), $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a5f74a311fc314fe$var$_class.prototype, "date"), $a5f74a311fc314fe$var$_class.prototype), $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a5f74a311fc314fe$var$_class.prototype, "startDate"), $a5f74a311fc314fe$var$_class.prototype), $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a5f74a311fc314fe$var$_class.prototype, "endDate"), $a5f74a311fc314fe$var$_class.prototype), $a5f74a311fc314fe$var$_applyDecoratedDescriptor($a5f74a311fc314fe$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a5f74a311fc314fe$var$_class.prototype, "hours"), $a5f74a311fc314fe$var$_class.prototype), $a5f74a311fc314fe$var$_class);
var $a5f74a311fc314fe$export$2e2bcd8739ae039 = $a5f74a311fc314fe$var$DailyAllocationAggregateModel;

});


parcelRegister("fhWB7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b215e5d326960afb$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "AllocationAggregateCollectionClass", function () { return $b215e5d326960afb$export$a8665b634e909b5c; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $2EXqY = parcelRequire("2EXqY");

var $5z1wx = parcelRequire("5z1wx");
parcelRequire("5Xh7w");

var $iCTvZ = parcelRequire("iCTvZ");
var $b215e5d326960afb$var$_dec, $b215e5d326960afb$var$_dec2, $b215e5d326960afb$var$_class;
function $b215e5d326960afb$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $b215e5d326960afb$var$AllocationAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $b215e5d326960afb$var$AllocationAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $b215e5d326960afb$var$AllocationAggregateCollection = ($b215e5d326960afb$var$_dec = (0, $d8hWe.action).bound, $b215e5d326960afb$var$_dec2 = (0, $d8hWe.action).bound, $b215e5d326960afb$var$_class = class AllocationAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "allocations",
            modelClass: (0, $2EXqY.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByModelTuple", "manyByMany", {
            keys: (t)=>{
                var _t$project, _t$phase, _t$role, _t$staff2, _t$project2, _t$phase2, _t$project3, _t$role2, _t$project4, _t$staff3, _t$phase3, _t$role3, _t$phase4, _t$staff4, _t$role4, _t$staff5, _t$project5, _t$phase5, _t$role5, _t$project6, _t$phase6, _t$staff6, _t$project7, _t$role6, _t$staff7, _t$phase7, _t$role7, _t$staff8, _t$project8, _t$phase8, _t$role8, _t$staff9;
                return [
                    (0, $iCTvZ.default)((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.id, undefined, undefined, undefined),
                    (0, $iCTvZ.default)(undefined, (_t$phase = t.phase) === null || _t$phase === void 0 ? void 0 : _t$phase.id, undefined, undefined),
                    (0, $iCTvZ.default)(undefined, undefined, (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.id, undefined),
                    (0, $iCTvZ.default)(undefined, undefined, undefined, (_t$staff2 = t.staff) === null || _t$staff2 === void 0 ? void 0 : _t$staff2.id),
                    (0, $iCTvZ.default)((_t$project2 = t.project) === null || _t$project2 === void 0 ? void 0 : _t$project2.id, (_t$phase2 = t.phase) === null || _t$phase2 === void 0 ? void 0 : _t$phase2.id, undefined, undefined),
                    (0, $iCTvZ.default)((_t$project3 = t.project) === null || _t$project3 === void 0 ? void 0 : _t$project3.id, undefined, (_t$role2 = t.role) === null || _t$role2 === void 0 ? void 0 : _t$role2.id, undefined),
                    (0, $iCTvZ.default)((_t$project4 = t.project) === null || _t$project4 === void 0 ? void 0 : _t$project4.id, undefined, undefined, (_t$staff3 = t.staff) === null || _t$staff3 === void 0 ? void 0 : _t$staff3.id),
                    (0, $iCTvZ.default)(undefined, (_t$phase3 = t.phase) === null || _t$phase3 === void 0 ? void 0 : _t$phase3.id, (_t$role3 = t.role) === null || _t$role3 === void 0 ? void 0 : _t$role3.id, undefined),
                    (0, $iCTvZ.default)(undefined, (_t$phase4 = t.phase) === null || _t$phase4 === void 0 ? void 0 : _t$phase4.id, undefined, (_t$staff4 = t.staff) === null || _t$staff4 === void 0 ? void 0 : _t$staff4.id),
                    (0, $iCTvZ.default)(undefined, undefined, (_t$role4 = t.role) === null || _t$role4 === void 0 ? void 0 : _t$role4.id, (_t$staff5 = t.staff) === null || _t$staff5 === void 0 ? void 0 : _t$staff5.id),
                    (0, $iCTvZ.default)((_t$project5 = t.project) === null || _t$project5 === void 0 ? void 0 : _t$project5.id, (_t$phase5 = t.phase) === null || _t$phase5 === void 0 ? void 0 : _t$phase5.id, (_t$role5 = t.role) === null || _t$role5 === void 0 ? void 0 : _t$role5.id, undefined),
                    (0, $iCTvZ.default)((_t$project6 = t.project) === null || _t$project6 === void 0 ? void 0 : _t$project6.id, (_t$phase6 = t.phase) === null || _t$phase6 === void 0 ? void 0 : _t$phase6.id, undefined, (_t$staff6 = t.staff) === null || _t$staff6 === void 0 ? void 0 : _t$staff6.id),
                    (0, $iCTvZ.default)((_t$project7 = t.project) === null || _t$project7 === void 0 ? void 0 : _t$project7.id, undefined, (_t$role6 = t.role) === null || _t$role6 === void 0 ? void 0 : _t$role6.id, (_t$staff7 = t.staff) === null || _t$staff7 === void 0 ? void 0 : _t$staff7.id),
                    (0, $iCTvZ.default)(undefined, (_t$phase7 = t.phase) === null || _t$phase7 === void 0 ? void 0 : _t$phase7.id, (_t$role7 = t.role) === null || _t$role7 === void 0 ? void 0 : _t$role7.id, (_t$staff8 = t.staff) === null || _t$staff8 === void 0 ? void 0 : _t$staff8.id),
                    (0, $iCTvZ.default)((_t$project8 = t.project) === null || _t$project8 === void 0 ? void 0 : _t$project8.id, (_t$phase8 = t.phase) === null || _t$phase8 === void 0 ? void 0 : _t$phase8.id, (_t$role8 = t.role) === null || _t$role8 === void 0 ? void 0 : _t$role8.id, (_t$staff9 = t.staff) === null || _t$staff9 === void 0 ? void 0 : _t$staff9.id)
                ];
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data) {
        this.add(data);
    }
    addAllocations(data) {
        this.addMany(data);
    }
}, $b215e5d326960afb$var$_applyDecoratedDescriptor($b215e5d326960afb$var$_class.prototype, "addAllocation", [
    $b215e5d326960afb$var$_dec
], Object.getOwnPropertyDescriptor($b215e5d326960afb$var$_class.prototype, "addAllocation"), $b215e5d326960afb$var$_class.prototype), $b215e5d326960afb$var$_applyDecoratedDescriptor($b215e5d326960afb$var$_class.prototype, "addAllocations", [
    $b215e5d326960afb$var$_dec2
], Object.getOwnPropertyDescriptor($b215e5d326960afb$var$_class.prototype, "addAllocations"), $b215e5d326960afb$var$_class.prototype), $b215e5d326960afb$var$_class);
var $b215e5d326960afb$export$2e2bcd8739ae039 = new $b215e5d326960afb$var$AllocationAggregate();
const $b215e5d326960afb$export$a8665b634e909b5c = $b215e5d326960afb$var$AllocationAggregateCollection;

});
parcelRegister("2EXqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1efd6b8ae61325f2$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");

var $fqmGV = parcelRequire("fqmGV");

var $fhWB7 = parcelRequire("fhWB7");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $1efd6b8ae61325f2$var$_class, $1efd6b8ae61325f2$var$_descriptor, $1efd6b8ae61325f2$var$_descriptor2, $1efd6b8ae61325f2$var$_descriptor3, $1efd6b8ae61325f2$var$_descriptor4, $1efd6b8ae61325f2$var$_descriptor5, $1efd6b8ae61325f2$var$_descriptor6, $1efd6b8ae61325f2$var$_descriptor7, $1efd6b8ae61325f2$var$_descriptor8, $1efd6b8ae61325f2$var$_descriptor9;
function $1efd6b8ae61325f2$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $1efd6b8ae61325f2$var$_defineProperty(e, r, t) {
    return (r = $1efd6b8ae61325f2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1efd6b8ae61325f2$var$_toPropertyKey(t) {
    var i = $1efd6b8ae61325f2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1efd6b8ae61325f2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1efd6b8ae61325f2$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $1efd6b8ae61325f2$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $1efd6b8ae61325f2$var$AllocationAggregateModel = ($1efd6b8ae61325f2$var$_class = class AllocationAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "staffId", $1efd6b8ae61325f2$var$_descriptor, this);
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "projectId", $1efd6b8ae61325f2$var$_descriptor2, this);
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "phaseId", $1efd6b8ae61325f2$var$_descriptor3, this);
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "roleId", $1efd6b8ae61325f2$var$_descriptor4, this);
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "month", $1efd6b8ae61325f2$var$_descriptor5, this);
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "numMinutes", $1efd6b8ae61325f2$var$_descriptor6, this);
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "pay", $1efd6b8ae61325f2$var$_descriptor7, this);
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "cost", $1efd6b8ae61325f2$var$_descriptor8, this);
        $1efd6b8ae61325f2$var$_initializerDefineProperty(this, "chargeOut", $1efd6b8ae61325f2$var$_descriptor9, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $fhWB7.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role) || (0, $8YeUb.default).modelsById[this.staffRoleId] || (0, $8YeUb.default).modelsById[this.roleId];
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get date() {
        return (0, $egx7S.parse)(this.month, "yyyy-MM", new Date());
    }
    get startDate() {
        return (0, $egx7S.startOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get endDate() {
        return (0, $egx7S.endOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get hours() {
        return this.numMinutes / 60;
    }
}, $1efd6b8ae61325f2$var$_descriptor = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1efd6b8ae61325f2$var$_descriptor2 = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1efd6b8ae61325f2$var$_descriptor3 = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1efd6b8ae61325f2$var$_descriptor4 = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1efd6b8ae61325f2$var$_descriptor5 = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "month", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $1efd6b8ae61325f2$var$_descriptor6 = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1efd6b8ae61325f2$var$_descriptor7 = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1efd6b8ae61325f2$var$_descriptor8 = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1efd6b8ae61325f2$var$_descriptor9 = $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "chargeOut", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1efd6b8ae61325f2$var$_class.prototype, "staff"), $1efd6b8ae61325f2$var$_class.prototype), $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1efd6b8ae61325f2$var$_class.prototype, "role"), $1efd6b8ae61325f2$var$_class.prototype), $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1efd6b8ae61325f2$var$_class.prototype, "project"), $1efd6b8ae61325f2$var$_class.prototype), $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1efd6b8ae61325f2$var$_class.prototype, "phase"), $1efd6b8ae61325f2$var$_class.prototype), $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1efd6b8ae61325f2$var$_class.prototype, "date"), $1efd6b8ae61325f2$var$_class.prototype), $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1efd6b8ae61325f2$var$_class.prototype, "startDate"), $1efd6b8ae61325f2$var$_class.prototype), $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1efd6b8ae61325f2$var$_class.prototype, "endDate"), $1efd6b8ae61325f2$var$_class.prototype), $1efd6b8ae61325f2$var$_applyDecoratedDescriptor($1efd6b8ae61325f2$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1efd6b8ae61325f2$var$_class.prototype, "hours"), $1efd6b8ae61325f2$var$_class.prototype), $1efd6b8ae61325f2$var$_class);
var $1efd6b8ae61325f2$export$2e2bcd8739ae039 = $1efd6b8ae61325f2$var$AllocationAggregateModel;

});


parcelRegister("3GX9k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b032d358a4c4814$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $2AdEy = parcelRequire("2AdEy");

var $5z1wx = parcelRequire("5z1wx");
parcelRequire("5Xh7w");

var $iCTvZ = parcelRequire("iCTvZ");
var $2b032d358a4c4814$var$_dec, $2b032d358a4c4814$var$_dec2, $2b032d358a4c4814$var$_class;
function $2b032d358a4c4814$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $2b032d358a4c4814$var$MonthlyAllocationAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $2b032d358a4c4814$var$MonthlyAllocationAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $2b032d358a4c4814$var$MonthlyAllocationAggregateCollection = ($2b032d358a4c4814$var$_dec = (0, $d8hWe.action).bound, $2b032d358a4c4814$var$_dec2 = (0, $d8hWe.action).bound, $2b032d358a4c4814$var$_class = class MonthlyAllocationAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "monthlyAllocations",
            modelClass: (0, $2AdEy.default)
        });
        this.addLookup("allocationsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByRoleId", "manyByKey", {
            key: (t)=>{
                var _t$staff;
                return t.roleId || ((_t$staff = t.staff) === null || _t$staff === void 0 ? void 0 : _t$staff.roleId);
            },
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("allocationsByModelTuple", "manyByMany", {
            keys: (t)=>{
                var _t$project, _t$phase, _t$role, _t$staff2, _t$project2, _t$phase2, _t$project3, _t$role2, _t$project4, _t$staff3, _t$phase3, _t$role3, _t$phase4, _t$staff4, _t$role4, _t$staff5, _t$project5, _t$phase5, _t$role5, _t$project6, _t$phase6, _t$staff6, _t$project7, _t$role6, _t$staff7, _t$phase7, _t$role7, _t$staff8, _t$project8, _t$phase8, _t$role8, _t$staff9;
                return [
                    (0, $iCTvZ.default)((_t$project = t.project) === null || _t$project === void 0 ? void 0 : _t$project.id, undefined, undefined, undefined),
                    (0, $iCTvZ.default)(undefined, (_t$phase = t.phase) === null || _t$phase === void 0 ? void 0 : _t$phase.id, undefined, undefined),
                    (0, $iCTvZ.default)(undefined, undefined, (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.id, undefined),
                    (0, $iCTvZ.default)(undefined, undefined, undefined, (_t$staff2 = t.staff) === null || _t$staff2 === void 0 ? void 0 : _t$staff2.id),
                    (0, $iCTvZ.default)((_t$project2 = t.project) === null || _t$project2 === void 0 ? void 0 : _t$project2.id, (_t$phase2 = t.phase) === null || _t$phase2 === void 0 ? void 0 : _t$phase2.id, undefined, undefined),
                    (0, $iCTvZ.default)((_t$project3 = t.project) === null || _t$project3 === void 0 ? void 0 : _t$project3.id, undefined, (_t$role2 = t.role) === null || _t$role2 === void 0 ? void 0 : _t$role2.id, undefined),
                    (0, $iCTvZ.default)((_t$project4 = t.project) === null || _t$project4 === void 0 ? void 0 : _t$project4.id, undefined, undefined, (_t$staff3 = t.staff) === null || _t$staff3 === void 0 ? void 0 : _t$staff3.id),
                    (0, $iCTvZ.default)(undefined, (_t$phase3 = t.phase) === null || _t$phase3 === void 0 ? void 0 : _t$phase3.id, (_t$role3 = t.role) === null || _t$role3 === void 0 ? void 0 : _t$role3.id, undefined),
                    (0, $iCTvZ.default)(undefined, (_t$phase4 = t.phase) === null || _t$phase4 === void 0 ? void 0 : _t$phase4.id, undefined, (_t$staff4 = t.staff) === null || _t$staff4 === void 0 ? void 0 : _t$staff4.id),
                    (0, $iCTvZ.default)(undefined, undefined, (_t$role4 = t.role) === null || _t$role4 === void 0 ? void 0 : _t$role4.id, (_t$staff5 = t.staff) === null || _t$staff5 === void 0 ? void 0 : _t$staff5.id),
                    (0, $iCTvZ.default)((_t$project5 = t.project) === null || _t$project5 === void 0 ? void 0 : _t$project5.id, (_t$phase5 = t.phase) === null || _t$phase5 === void 0 ? void 0 : _t$phase5.id, (_t$role5 = t.role) === null || _t$role5 === void 0 ? void 0 : _t$role5.id, undefined),
                    (0, $iCTvZ.default)((_t$project6 = t.project) === null || _t$project6 === void 0 ? void 0 : _t$project6.id, (_t$phase6 = t.phase) === null || _t$phase6 === void 0 ? void 0 : _t$phase6.id, undefined, (_t$staff6 = t.staff) === null || _t$staff6 === void 0 ? void 0 : _t$staff6.id),
                    (0, $iCTvZ.default)((_t$project7 = t.project) === null || _t$project7 === void 0 ? void 0 : _t$project7.id, undefined, (_t$role6 = t.role) === null || _t$role6 === void 0 ? void 0 : _t$role6.id, (_t$staff7 = t.staff) === null || _t$staff7 === void 0 ? void 0 : _t$staff7.id),
                    (0, $iCTvZ.default)(undefined, (_t$phase7 = t.phase) === null || _t$phase7 === void 0 ? void 0 : _t$phase7.id, (_t$role7 = t.role) === null || _t$role7 === void 0 ? void 0 : _t$role7.id, (_t$staff8 = t.staff) === null || _t$staff8 === void 0 ? void 0 : _t$staff8.id),
                    (0, $iCTvZ.default)((_t$project8 = t.project) === null || _t$project8 === void 0 ? void 0 : _t$project8.id, (_t$phase8 = t.phase) === null || _t$phase8 === void 0 ? void 0 : _t$phase8.id, (_t$role8 = t.role) === null || _t$role8 === void 0 ? void 0 : _t$role8.id, (_t$staff9 = t.staff) === null || _t$staff9 === void 0 ? void 0 : _t$staff9.id)
                ];
            },
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get allocationsById() {
        return this.modelsById;
    }
    get allocations() {
        return this.models;
    }
    get allocationsById() {
        return this.modelsById;
    }
    addAllocation(data) {
        this.add(data);
    }
    addAllocations(data) {
        this.addMany(data);
    }
}, $2b032d358a4c4814$var$_applyDecoratedDescriptor($2b032d358a4c4814$var$_class.prototype, "addAllocation", [
    $2b032d358a4c4814$var$_dec
], Object.getOwnPropertyDescriptor($2b032d358a4c4814$var$_class.prototype, "addAllocation"), $2b032d358a4c4814$var$_class.prototype), $2b032d358a4c4814$var$_applyDecoratedDescriptor($2b032d358a4c4814$var$_class.prototype, "addAllocations", [
    $2b032d358a4c4814$var$_dec2
], Object.getOwnPropertyDescriptor($2b032d358a4c4814$var$_class.prototype, "addAllocations"), $2b032d358a4c4814$var$_class.prototype), $2b032d358a4c4814$var$_class);
var $2b032d358a4c4814$export$2e2bcd8739ae039 = new $2b032d358a4c4814$var$MonthlyAllocationAggregate();
const $2b032d358a4c4814$export$c9e702474e5b47e2 = $2b032d358a4c4814$var$MonthlyAllocationAggregateCollection;

});
parcelRegister("2AdEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e1988c6bd89ee1a$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $lTrDt = parcelRequire("lTrDt");

var $kdO1A = parcelRequire("kdO1A");

var $9Lw71 = parcelRequire("9Lw71");

var $fqmGV = parcelRequire("fqmGV");

var $3GX9k = parcelRequire("3GX9k");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");
var $1e1988c6bd89ee1a$var$_class, $1e1988c6bd89ee1a$var$_descriptor, $1e1988c6bd89ee1a$var$_descriptor2, $1e1988c6bd89ee1a$var$_descriptor3, $1e1988c6bd89ee1a$var$_descriptor4, $1e1988c6bd89ee1a$var$_descriptor5, $1e1988c6bd89ee1a$var$_descriptor6, $1e1988c6bd89ee1a$var$_descriptor7, $1e1988c6bd89ee1a$var$_descriptor8, $1e1988c6bd89ee1a$var$_descriptor9;
function $1e1988c6bd89ee1a$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $1e1988c6bd89ee1a$var$_defineProperty(e, r, t) {
    return (r = $1e1988c6bd89ee1a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1e1988c6bd89ee1a$var$_toPropertyKey(t) {
    var i = $1e1988c6bd89ee1a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1e1988c6bd89ee1a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $1e1988c6bd89ee1a$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $1e1988c6bd89ee1a$var$MonthlyAllocationAggregateModel = ($1e1988c6bd89ee1a$var$_class = class MonthlyAllocationAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "staffId", $1e1988c6bd89ee1a$var$_descriptor, this);
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "projectId", $1e1988c6bd89ee1a$var$_descriptor2, this);
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "phaseId", $1e1988c6bd89ee1a$var$_descriptor3, this);
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "roleId", $1e1988c6bd89ee1a$var$_descriptor4, this);
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "month", $1e1988c6bd89ee1a$var$_descriptor5, this);
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "numMinutes", $1e1988c6bd89ee1a$var$_descriptor6, this);
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "pay", $1e1988c6bd89ee1a$var$_descriptor7, this);
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "cost", $1e1988c6bd89ee1a$var$_descriptor8, this);
        $1e1988c6bd89ee1a$var$_initializerDefineProperty(this, "chargeOut", $1e1988c6bd89ee1a$var$_descriptor9, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $3GX9k.default);
        this.init(data, options);
    }
    get staff() {
        return (0, $lTrDt.default).modelsById[this.staffId];
    }
    get role() {
        var _this$staff;
        return ((_this$staff = this.staff) === null || _this$staff === void 0 ? void 0 : _this$staff.role) || (0, $8YeUb.default).modelsById[this.staffRoleId] || (0, $8YeUb.default).modelsById[this.roleId];
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).modelsById[this.phaseId];
    }
    get date() {
        return (0, $egx7S.parse)(this.month, "yyyy-MM", new Date());
    }
    get startDate() {
        return (0, $egx7S.startOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get endDate() {
        return (0, $egx7S.endOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get hours() {
        return this.numMinutes / 60;
    }
}, $1e1988c6bd89ee1a$var$_descriptor = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1e1988c6bd89ee1a$var$_descriptor2 = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1e1988c6bd89ee1a$var$_descriptor3 = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1e1988c6bd89ee1a$var$_descriptor4 = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $1e1988c6bd89ee1a$var$_descriptor5 = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "month", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "";
    }
}), $1e1988c6bd89ee1a$var$_descriptor6 = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "numMinutes", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1e1988c6bd89ee1a$var$_descriptor7 = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "pay", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1e1988c6bd89ee1a$var$_descriptor8 = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1e1988c6bd89ee1a$var$_descriptor9 = $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "chargeOut", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "staff"), $1e1988c6bd89ee1a$var$_class.prototype), $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "role"), $1e1988c6bd89ee1a$var$_class.prototype), $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "project"), $1e1988c6bd89ee1a$var$_class.prototype), $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "phase"), $1e1988c6bd89ee1a$var$_class.prototype), $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "date"), $1e1988c6bd89ee1a$var$_class.prototype), $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "startDate"), $1e1988c6bd89ee1a$var$_class.prototype), $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "endDate"), $1e1988c6bd89ee1a$var$_class.prototype), $1e1988c6bd89ee1a$var$_applyDecoratedDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "hours", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($1e1988c6bd89ee1a$var$_class.prototype, "hours"), $1e1988c6bd89ee1a$var$_class.prototype), $1e1988c6bd89ee1a$var$_class);
var $1e1988c6bd89ee1a$export$2e2bcd8739ae039 = $1e1988c6bd89ee1a$var$MonthlyAllocationAggregateModel;

});


parcelRegister("6UKmT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $508bf0cbc7909ac7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RevenueTargetAggregateCollectionClass", function () { return $508bf0cbc7909ac7$export$ba135e6aff5357c; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $5z1wx = parcelRequire("5z1wx");

var $d5Iof = parcelRequire("d5Iof");
var $508bf0cbc7909ac7$var$_dec, $508bf0cbc7909ac7$var$_dec2, $508bf0cbc7909ac7$var$_class;
function $508bf0cbc7909ac7$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $508bf0cbc7909ac7$var$RevenueTargetAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $508bf0cbc7909ac7$var$RevenueTargetAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $508bf0cbc7909ac7$var$RevenueTargetAggregateCollection = ($508bf0cbc7909ac7$var$_dec = (0, $d8hWe.action).bound, $508bf0cbc7909ac7$var$_dec2 = (0, $d8hWe.action).bound, $508bf0cbc7909ac7$var$_class = class RevenueTargetAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "revenueTargets",
            modelClass: (0, $d5Iof.default)
        });
        this.addLookup("revenueTargetsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("revenueTargetsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("revenueTargetsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get revenueTargetsById() {
        return this.modelsById;
    }
    get revenueTargets() {
        return this.models;
    }
    get revenueTargetsById() {
        return this.modelsById;
    }
    addRevenueTarget(data) {
        this.add(data);
    }
    addRevenueTargets(data) {
        this.addMany(data);
    }
}, $508bf0cbc7909ac7$var$_applyDecoratedDescriptor($508bf0cbc7909ac7$var$_class.prototype, "addRevenueTarget", [
    $508bf0cbc7909ac7$var$_dec
], Object.getOwnPropertyDescriptor($508bf0cbc7909ac7$var$_class.prototype, "addRevenueTarget"), $508bf0cbc7909ac7$var$_class.prototype), $508bf0cbc7909ac7$var$_applyDecoratedDescriptor($508bf0cbc7909ac7$var$_class.prototype, "addRevenueTargets", [
    $508bf0cbc7909ac7$var$_dec2
], Object.getOwnPropertyDescriptor($508bf0cbc7909ac7$var$_class.prototype, "addRevenueTargets"), $508bf0cbc7909ac7$var$_class.prototype), $508bf0cbc7909ac7$var$_class);
var $508bf0cbc7909ac7$export$2e2bcd8739ae039 = new $508bf0cbc7909ac7$var$RevenueTargetAggregate();
const $508bf0cbc7909ac7$export$ba135e6aff5357c = $508bf0cbc7909ac7$var$RevenueTargetAggregateCollection;

});
parcelRegister("d5Iof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $987e2cf1e50fca82$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");
parcelRequire("4sGvn");
parcelRequire("PIDKX");

var $6UKmT = parcelRequire("6UKmT");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $fqmGV = parcelRequire("fqmGV");
var $987e2cf1e50fca82$var$_class, $987e2cf1e50fca82$var$_descriptor, $987e2cf1e50fca82$var$_descriptor2, $987e2cf1e50fca82$var$_descriptor3;
function $987e2cf1e50fca82$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $987e2cf1e50fca82$var$_defineProperty(e, r, t) {
    return (r = $987e2cf1e50fca82$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $987e2cf1e50fca82$var$_toPropertyKey(t) {
    var i = $987e2cf1e50fca82$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $987e2cf1e50fca82$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $987e2cf1e50fca82$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $987e2cf1e50fca82$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $987e2cf1e50fca82$var$RevenueTargetAggregateModel = ($987e2cf1e50fca82$var$_class = class RevenueTargetAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $987e2cf1e50fca82$var$_initializerDefineProperty(this, "projectId", $987e2cf1e50fca82$var$_descriptor, this);
        $987e2cf1e50fca82$var$_initializerDefineProperty(this, "phaseId", $987e2cf1e50fca82$var$_descriptor2, this);
        $987e2cf1e50fca82$var$_initializerDefineProperty(this, "amount", $987e2cf1e50fca82$var$_descriptor3, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $6UKmT.default);
        this.init(data, options);
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
}, $987e2cf1e50fca82$var$_descriptor = $987e2cf1e50fca82$var$_applyDecoratedDescriptor($987e2cf1e50fca82$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $987e2cf1e50fca82$var$_descriptor2 = $987e2cf1e50fca82$var$_applyDecoratedDescriptor($987e2cf1e50fca82$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $987e2cf1e50fca82$var$_descriptor3 = $987e2cf1e50fca82$var$_applyDecoratedDescriptor($987e2cf1e50fca82$var$_class.prototype, "amount", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $987e2cf1e50fca82$var$_applyDecoratedDescriptor($987e2cf1e50fca82$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($987e2cf1e50fca82$var$_class.prototype, "project"), $987e2cf1e50fca82$var$_class.prototype), $987e2cf1e50fca82$var$_applyDecoratedDescriptor($987e2cf1e50fca82$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($987e2cf1e50fca82$var$_class.prototype, "phase"), $987e2cf1e50fca82$var$_class.prototype), $987e2cf1e50fca82$var$_class);
var $987e2cf1e50fca82$export$2e2bcd8739ae039 = $987e2cf1e50fca82$var$RevenueTargetAggregateModel;

});


parcelRegister("gVN2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c53801dfc07c25cf$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "PhaseAggregateCollectionClass", function () { return $c53801dfc07c25cf$export$203f52a416729f06; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $eCOpq = parcelRequire("eCOpq");

var $5z1wx = parcelRequire("5z1wx");
var $c53801dfc07c25cf$var$_dec, $c53801dfc07c25cf$var$_dec2, $c53801dfc07c25cf$var$_class;
function $c53801dfc07c25cf$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $c53801dfc07c25cf$var$PhaseAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $c53801dfc07c25cf$var$PhaseAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $c53801dfc07c25cf$var$PhaseAggregateCollection = ($c53801dfc07c25cf$var$_dec = (0, $d8hWe.action).bound, $c53801dfc07c25cf$var$_dec2 = (0, $d8hWe.action).bound, $c53801dfc07c25cf$var$_class = class PhaseAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "phases",
            modelClass: (0, $eCOpq.default)
        });
        this.addLookup("phasesByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("phasesByCostCentreId", "manyByKey", {
            key: (t)=>t.phasesByCostCentreId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get phasesById() {
        return this.modelsById;
    }
    get phases() {
        return this.models;
    }
    get phasesById() {
        return this.modelsById;
    }
    addPhase(data) {
        this.add(data);
    }
    addPhases(data) {
        this.addMany(data);
    }
}, $c53801dfc07c25cf$var$_applyDecoratedDescriptor($c53801dfc07c25cf$var$_class.prototype, "addPhase", [
    $c53801dfc07c25cf$var$_dec
], Object.getOwnPropertyDescriptor($c53801dfc07c25cf$var$_class.prototype, "addPhase"), $c53801dfc07c25cf$var$_class.prototype), $c53801dfc07c25cf$var$_applyDecoratedDescriptor($c53801dfc07c25cf$var$_class.prototype, "addPhases", [
    $c53801dfc07c25cf$var$_dec2
], Object.getOwnPropertyDescriptor($c53801dfc07c25cf$var$_class.prototype, "addPhases"), $c53801dfc07c25cf$var$_class.prototype), $c53801dfc07c25cf$var$_class);
var $c53801dfc07c25cf$export$2e2bcd8739ae039 = new $c53801dfc07c25cf$var$PhaseAggregate();
const $c53801dfc07c25cf$export$203f52a416729f06 = $c53801dfc07c25cf$var$PhaseAggregateCollection;

});
parcelRegister("eCOpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa5bb78490dab2a3$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $gVN2k = parcelRequire("gVN2k");

var $bwMFl = parcelRequire("bwMFl");
parcelRequire("dBifK");

var $kdO1A = parcelRequire("kdO1A");

var $fqmGV = parcelRequire("fqmGV");
var $aa5bb78490dab2a3$var$_class, $aa5bb78490dab2a3$var$_descriptor, $aa5bb78490dab2a3$var$_descriptor2, $aa5bb78490dab2a3$var$_descriptor3, $aa5bb78490dab2a3$var$_descriptor4, $aa5bb78490dab2a3$var$_descriptor5, $aa5bb78490dab2a3$var$_descriptor6, $aa5bb78490dab2a3$var$_descriptor7, $aa5bb78490dab2a3$var$_descriptor8, $aa5bb78490dab2a3$var$_descriptor9, $aa5bb78490dab2a3$var$_descriptor10, $aa5bb78490dab2a3$var$_descriptor11, $aa5bb78490dab2a3$var$_descriptor12, $aa5bb78490dab2a3$var$_descriptor13, $aa5bb78490dab2a3$var$_descriptor14;
function $aa5bb78490dab2a3$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $aa5bb78490dab2a3$var$_defineProperty(e, r, t) {
    return (r = $aa5bb78490dab2a3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $aa5bb78490dab2a3$var$_toPropertyKey(t) {
    var i = $aa5bb78490dab2a3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $aa5bb78490dab2a3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $aa5bb78490dab2a3$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $aa5bb78490dab2a3$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $aa5bb78490dab2a3$var$PhaseAggregateModel = ($aa5bb78490dab2a3$var$_class = class PhaseAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "jobNumber", $aa5bb78490dab2a3$var$_descriptor, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "name", $aa5bb78490dab2a3$var$_descriptor2, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "projectId", $aa5bb78490dab2a3$var$_descriptor3, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "startDate", $aa5bb78490dab2a3$var$_descriptor4, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "endDate", $aa5bb78490dab2a3$var$_descriptor5, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "fee", $aa5bb78490dab2a3$var$_descriptor6, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "expenseBudget", $aa5bb78490dab2a3$var$_descriptor7, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "hoursBudget", $aa5bb78490dab2a3$var$_descriptor8, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "status", $aa5bb78490dab2a3$var$_descriptor9, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "percentLikelihood", $aa5bb78490dab2a3$var$_descriptor10, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "feeLinked", $aa5bb78490dab2a3$var$_descriptor11, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "expenseBudgetLinked", $aa5bb78490dab2a3$var$_descriptor12, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "hoursBudgetLinked", $aa5bb78490dab2a3$var$_descriptor13, this);
        $aa5bb78490dab2a3$var$_initializerDefineProperty(this, "durationUnit", $aa5bb78490dab2a3$var$_descriptor14, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $gVN2k.default);
        this.init(data, options);
    }
    get title() {
        return this.jobNumber && this.name ? `${this.jobNumber}: ${this.name}` : this.name || this.jobNumber;
    }
    get project() {
        return (0, $kdO1A.default).modelsById[this.projectId];
    }
    get duration() {
        return (0, $bwMFl.unitsBetween)(this.startDate, this.endDate, this.durationUnit);
    }
    get costCentre() {
        var _this$project;
        return (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.costCentre;
    }
    get contact() {
        var _this$project2;
        return (_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.contact;
    }
    get primaryContact() {
        var _this$project3;
        return (_this$project3 = this.project) === null || _this$project3 === void 0 ? void 0 : _this$project3.primaryContact;
    }
    get owner() {
        var _this$project4;
        return (_this$project4 = this.project) === null || _this$project4 === void 0 ? void 0 : _this$project4.owner;
    }
    get hasDates() {
        return this.startDate && this.endDate;
    }
    get isCurrent() {
        return !this.startDate && this.endDate >= new Date() || !this.endDate && this.startDate <= new Date() || this.endDate >= new Date() && this.startDate <= new Date();
    }
    get hasEnded() {
        return this.hasDates && !this.isCurrent;
    }
    get feeAdjustedByLikelihood() {
        if ([
            "prospective",
            "onHold"
        ].includes(this.status) && this.percentLikelihood) return this.fee * (this.percentLikelihood / 100);
        else return this.fee;
    }
}, $aa5bb78490dab2a3$var$_descriptor = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "jobNumber", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor2 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "name", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor3 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor4 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor5 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor6 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "fee", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor7 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "expenseBudget", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor8 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "hoursBudget", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor9 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "status", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor10 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "percentLikelihood", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor11 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "feeLinked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor12 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "expenseBudgetLinked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor13 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "hoursBudgetLinked", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_descriptor14 = $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "durationUnit", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "title", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "title"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "project"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "duration", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "duration"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "costCentre", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "costCentre"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "contact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "contact"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "primaryContact", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "primaryContact"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "owner", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "owner"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "hasDates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "hasDates"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "isCurrent", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "isCurrent"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "hasEnded", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "hasEnded"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_applyDecoratedDescriptor($aa5bb78490dab2a3$var$_class.prototype, "feeAdjustedByLikelihood", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($aa5bb78490dab2a3$var$_class.prototype, "feeAdjustedByLikelihood"), $aa5bb78490dab2a3$var$_class.prototype), $aa5bb78490dab2a3$var$_class);
var $aa5bb78490dab2a3$export$2e2bcd8739ae039 = $aa5bb78490dab2a3$var$PhaseAggregateModel;

});


parcelRegister("gUQZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c50afc69f56b3368$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BudgetAggregateCollectionClass", function () { return $c50afc69f56b3368$export$55d313ff01ac4c2e; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $dSA4Y = parcelRequire("dSA4Y");

var $5z1wx = parcelRequire("5z1wx");
var $c50afc69f56b3368$var$_dec, $c50afc69f56b3368$var$_dec2, $c50afc69f56b3368$var$_class;
function $c50afc69f56b3368$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
class $c50afc69f56b3368$var$BudgetAggregate extends (0, $5z1wx.default) {
    constructor(){
        super({
            collectionClass: $c50afc69f56b3368$var$BudgetAggregateCollection
        });
        (0, $d8hWe.makeObservable)(this);
    }
}
let $c50afc69f56b3368$var$BudgetAggregateCollection = ($c50afc69f56b3368$var$_dec = (0, $d8hWe.action).bound, $c50afc69f56b3368$var$_dec2 = (0, $d8hWe.action).bound, $c50afc69f56b3368$var$_class = class BudgetAggregateCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "budgetedHours",
            modelClass: (0, $dSA4Y.default)
        });
        this.addLookup("budgetsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByRoleId", "manyByKey", {
            key: (t)=>t.roleId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("budgetsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get budgetsById() {
        return this.modelsById;
    }
    get budgets() {
        return this.models;
    }
    get budgetsById() {
        return this.modelsById;
    }
    addBudget(data) {
        this.add(data);
    }
    addBudgets(data) {
        this.addMany(data);
    }
}, $c50afc69f56b3368$var$_applyDecoratedDescriptor($c50afc69f56b3368$var$_class.prototype, "addBudget", [
    $c50afc69f56b3368$var$_dec
], Object.getOwnPropertyDescriptor($c50afc69f56b3368$var$_class.prototype, "addBudget"), $c50afc69f56b3368$var$_class.prototype), $c50afc69f56b3368$var$_applyDecoratedDescriptor($c50afc69f56b3368$var$_class.prototype, "addBudgets", [
    $c50afc69f56b3368$var$_dec2
], Object.getOwnPropertyDescriptor($c50afc69f56b3368$var$_class.prototype, "addBudgets"), $c50afc69f56b3368$var$_class.prototype), $c50afc69f56b3368$var$_class);
var $c50afc69f56b3368$export$2e2bcd8739ae039 = new $c50afc69f56b3368$var$BudgetAggregate();
const $c50afc69f56b3368$export$55d313ff01ac4c2e = $c50afc69f56b3368$var$BudgetAggregateCollection;

});
parcelRegister("dSA4Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1ac4e129e82124b$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $gUQZS = parcelRequire("gUQZS");
parcelRequire("bwMFl");
parcelRequire("dBifK");

var $kdO1A = parcelRequire("kdO1A");

var $fqmGV = parcelRequire("fqmGV");

var $lTrDt = parcelRequire("lTrDt");

var $9Lw71 = parcelRequire("9Lw71");

var $8YeUb = parcelRequire("8YeUb");

var $5tqXB = parcelRequire("5tqXB");
var $a1ac4e129e82124b$var$_dec, $a1ac4e129e82124b$var$_class, $a1ac4e129e82124b$var$_descriptor, $a1ac4e129e82124b$var$_descriptor2, $a1ac4e129e82124b$var$_descriptor3, $a1ac4e129e82124b$var$_descriptor4, $a1ac4e129e82124b$var$_descriptor5;
function $a1ac4e129e82124b$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $a1ac4e129e82124b$var$_defineProperty(e, r, t) {
    return (r = $a1ac4e129e82124b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a1ac4e129e82124b$var$_toPropertyKey(t) {
    var i = $a1ac4e129e82124b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a1ac4e129e82124b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a1ac4e129e82124b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $a1ac4e129e82124b$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $a1ac4e129e82124b$var$BudgetAggregateModel = ($a1ac4e129e82124b$var$_dec = (0, $d8hWe.action).bound, $a1ac4e129e82124b$var$_class = class BudgetAggregateModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $a1ac4e129e82124b$var$_initializerDefineProperty(this, "staffId", $a1ac4e129e82124b$var$_descriptor, this);
        $a1ac4e129e82124b$var$_initializerDefineProperty(this, "roleId", $a1ac4e129e82124b$var$_descriptor2, this);
        $a1ac4e129e82124b$var$_initializerDefineProperty(this, "projectId", $a1ac4e129e82124b$var$_descriptor3, this);
        $a1ac4e129e82124b$var$_initializerDefineProperty(this, "phaseId", $a1ac4e129e82124b$var$_descriptor4, this);
        $a1ac4e129e82124b$var$_initializerDefineProperty(this, "hours", $a1ac4e129e82124b$var$_descriptor5, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $gUQZS.default);
        this.init(data, options);
    }
    get resource() {
        return this.staff || this.role;
    }
    get staff() {
        return (0, $lTrDt.default).staffsById[this.staffId];
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get role() {
        return (0, $8YeUb.default).rolesById[this.roleId];
    }
    get costRate() {
        if (!this.resource) return 0;
        return (0, $5tqXB.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "cost", [
            this.startDate,
            this.endDate
        ]);
    }
    get chargeOutRate() {
        if (!this.resource) return 0;
        return (0, $5tqXB.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "chargeOut", [
            this.startDate,
            this.endDate
        ]);
    }
    get cost() {
        return this.hours * this.costRate;
    }
    get chargeOut() {
        return this.hours * this.chargeOutRate;
    }
    rateValueToHours(value, rateType) {
        const rateName = rateType === "availability" ? "weeklyAvailability" : rateType + "Rate";
        this.update({
            hours: value / this[rateName]
        });
    }
    get rates() {
        var _this$resource;
        return (_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.rates.sort((a, b)=>a.date - b.date);
    }
    get startDate() {
        var _this$phase;
        return (_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.startDate;
    }
    get endDate() {
        var _this$phase2;
        return (_this$phase2 = this.phase) === null || _this$phase2 === void 0 ? void 0 : _this$phase2.endDate;
    }
}, $a1ac4e129e82124b$var$_descriptor = $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a1ac4e129e82124b$var$_descriptor2 = $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "roleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a1ac4e129e82124b$var$_descriptor3 = $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a1ac4e129e82124b$var$_descriptor4 = $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a1ac4e129e82124b$var$_descriptor5 = $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "hours", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "resource", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "resource"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "staff"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "phase"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "project"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "role"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "costRate"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "chargeOutRate"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "cost", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "cost"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "chargeOut", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "chargeOut"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "rateValueToHours", [
    $a1ac4e129e82124b$var$_dec
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "rateValueToHours"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "rates", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "rates"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "startDate"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_applyDecoratedDescriptor($a1ac4e129e82124b$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($a1ac4e129e82124b$var$_class.prototype, "endDate"), $a1ac4e129e82124b$var$_class.prototype), $a1ac4e129e82124b$var$_class);
var $a1ac4e129e82124b$export$2e2bcd8739ae039 = $a1ac4e129e82124b$var$BudgetAggregateModel;

});


parcelRegister("gwjB7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c06ed6351e6e3853$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MonthlyResourceCellCollectionClass", function () { return $c06ed6351e6e3853$export$2f6614d0d0b22e74; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $cdoKQ = parcelRequire("cdoKQ");
var $c06ed6351e6e3853$var$_dec, $c06ed6351e6e3853$var$_dec2, $c06ed6351e6e3853$var$_class;
function $c06ed6351e6e3853$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $c06ed6351e6e3853$var$MonthlyResourceCellCollection = ($c06ed6351e6e3853$var$_dec = (0, $d8hWe.action).bound, $c06ed6351e6e3853$var$_dec2 = (0, $d8hWe.action).bound, $c06ed6351e6e3853$var$_class = class MonthlyResourceCellCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "monthlyResourceCells",
            modelClass: (0, $cdoKQ.default)
        });
        this.addLookup("cellsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByRoleId", "manyByKey", {
            key: (t)=>t.staffRoleId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByType", "manyByKey", {
            key: (t)=>t.type,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get cellsById() {
        return this.modelsById;
    }
    get cells() {
        return this.models;
    }
    addCell(data, options) {
        return this.add(data, options);
    }
    addCells(data, options) {
        return this.addMany(data, options);
    }
}, $c06ed6351e6e3853$var$_applyDecoratedDescriptor($c06ed6351e6e3853$var$_class.prototype, "addCell", [
    $c06ed6351e6e3853$var$_dec
], Object.getOwnPropertyDescriptor($c06ed6351e6e3853$var$_class.prototype, "addCell"), $c06ed6351e6e3853$var$_class.prototype), $c06ed6351e6e3853$var$_applyDecoratedDescriptor($c06ed6351e6e3853$var$_class.prototype, "addCells", [
    $c06ed6351e6e3853$var$_dec2
], Object.getOwnPropertyDescriptor($c06ed6351e6e3853$var$_class.prototype, "addCells"), $c06ed6351e6e3853$var$_class.prototype), $c06ed6351e6e3853$var$_class);
var $c06ed6351e6e3853$export$2e2bcd8739ae039 = new $c06ed6351e6e3853$var$MonthlyResourceCellCollection();
const $c06ed6351e6e3853$export$2f6614d0d0b22e74 = $c06ed6351e6e3853$var$MonthlyResourceCellCollection;

});
parcelRegister("cdoKQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e49e6b224350db9$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $gwjB7 = parcelRequire("gwjB7");

var $fqmGV = parcelRequire("fqmGV");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");

var $lTrDt = parcelRequire("lTrDt");

var $5Xh7w = parcelRequire("5Xh7w");

var $blgBn = parcelRequire("blgBn");
var $8e49e6b224350db9$var$_class, $8e49e6b224350db9$var$_descriptor, $8e49e6b224350db9$var$_descriptor2, $8e49e6b224350db9$var$_descriptor3, $8e49e6b224350db9$var$_descriptor4, $8e49e6b224350db9$var$_descriptor5, $8e49e6b224350db9$var$_descriptor6, $8e49e6b224350db9$var$_descriptor7, $8e49e6b224350db9$var$_descriptor8, $8e49e6b224350db9$var$_descriptor9, $8e49e6b224350db9$var$_descriptor10, $8e49e6b224350db9$var$_descriptor11, $8e49e6b224350db9$var$_descriptor12, $8e49e6b224350db9$var$_descriptor13;
function $8e49e6b224350db9$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $8e49e6b224350db9$var$_defineProperty(e, r, t) {
    return (r = $8e49e6b224350db9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e49e6b224350db9$var$_toPropertyKey(t) {
    var i = $8e49e6b224350db9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8e49e6b224350db9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e49e6b224350db9$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $8e49e6b224350db9$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $8e49e6b224350db9$var$MonthlyResourceCellModel = ($8e49e6b224350db9$var$_class = class MonthlyResourceCellModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "month", $8e49e6b224350db9$var$_descriptor, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "hours", $8e49e6b224350db9$var$_descriptor2, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "cost", $8e49e6b224350db9$var$_descriptor3, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "chargeOut", $8e49e6b224350db9$var$_descriptor4, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "status", $8e49e6b224350db9$var$_descriptor5, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "projectId", $8e49e6b224350db9$var$_descriptor6, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "phaseId", $8e49e6b224350db9$var$_descriptor7, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "phaseTitle", $8e49e6b224350db9$var$_descriptor8, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "staffRoleId", $8e49e6b224350db9$var$_descriptor9, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "staffId", $8e49e6b224350db9$var$_descriptor10, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "ownerId", $8e49e6b224350db9$var$_descriptor11, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "costCentreId", $8e49e6b224350db9$var$_descriptor12, this);
        $8e49e6b224350db9$var$_initializerDefineProperty(this, "type", $8e49e6b224350db9$var$_descriptor13, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $gwjB7.default);
        this.init(data, options);
        const rowId = `('${this.status}', '${this.projectId}', '${this.phaseId}', '${this.staffRoleId || null}', '${this.staffId}')`;
        const row = (0, $blgBn.default).rowsById[rowId];
        if (!row) (0, $blgBn.default).addRow({
            id: rowId,
            status: this.status,
            projectId: this.projectId,
            phaseId: this.phaseId,
            phaseTitle: this.phaseTitle,
            staffRoleId: this.staffRoleId,
            staffId: this.staffId,
            groups: [
                "status",
                "project",
                "phase",
                "role",
                "staff"
            ]
        }, {
            trackUpdates: false
        });
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get role() {
        return (0, $8YeUb.default).rolesById[this.staffRoleId];
    }
    get staff() {
        return (0, $lTrDt.default).staffById[this.staffId];
    }
    serialize() {
        return {
            id: this.id,
            month: this.month,
            hours: this.hours,
            projectId: this.projectId,
            phaseId: this.phaseId,
            staffRoleId: this.staffRoleId,
            staffId: this.staffId
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
    get date() {
        return (0, $egx7S.startOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
    get startDate() {
        return this.date;
    }
    get endDate() {
        return (0, $egx7S.endOfMonth)(this.date);
    }
    getRateInDateRange(rateType, dateRange) {
        if (this.staff) return this.staff.getRateInDateRange(rateType, dateRange);
        else if (this.role) return this.role.getRateInDateRange(rateType, dateRange);
        else return null;
    }
    get costRate() {
        return this.getRateInDateRange("cost", [
            this.startDate,
            this.endDate
        ]);
    }
    get chargeOutRate() {
        return this.getRateInDateRange("chargeOut", [
            this.startDate,
            this.endDate
        ]);
    }
}, $8e49e6b224350db9$var$_descriptor = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "month", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor2 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "hours", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $8e49e6b224350db9$var$_descriptor3 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "cost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $8e49e6b224350db9$var$_descriptor4 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "chargeOut", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $8e49e6b224350db9$var$_descriptor5 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "status", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor6 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor7 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor8 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "phaseTitle", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor9 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "staffRoleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor10 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor11 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "ownerId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor12 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "costCentreId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_descriptor13 = $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "type", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "phase"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "project"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "role"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "staff"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "date"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "startDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "startDate"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "endDate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "endDate"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "getRateInDateRange", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "getRateInDateRange"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "costRate"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_applyDecoratedDescriptor($8e49e6b224350db9$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($8e49e6b224350db9$var$_class.prototype, "chargeOutRate"), $8e49e6b224350db9$var$_class.prototype), $8e49e6b224350db9$var$_class);
var $8e49e6b224350db9$export$2e2bcd8739ae039 = $8e49e6b224350db9$var$MonthlyResourceCellModel;

});
parcelRegister("blgBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $841e88a4d7a50662$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ResourceRowCollectionClass", function () { return $841e88a4d7a50662$export$6798d7f54903900c; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $lJe7g = parcelRequire("lJe7g");
var $841e88a4d7a50662$var$_dec, $841e88a4d7a50662$var$_dec2, $841e88a4d7a50662$var$_class;
function $841e88a4d7a50662$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $841e88a4d7a50662$var$ResourceRowCollection = ($841e88a4d7a50662$var$_dec = (0, $d8hWe.action).bound, $841e88a4d7a50662$var$_dec2 = (0, $d8hWe.action).bound, $841e88a4d7a50662$var$_class = class ResourceRowCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "resourceRows",
            modelClass: (0, $lJe7g.default)
        });
        this.addLookup("rowsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("rowsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("rowsByStaffId", "manyByKey", {
            key: (t)=>t.staffId,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("rowsByRoleId", "manyByKey", {
            key: (t)=>t.staffRoleId || null,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("rowsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!(t !== null && t !== void 0 && t.deletedAt)
        });
        this.addLookup("leafRows", "list", {
            filter: (m)=>{
                return m.isLeaf;
            }
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get rowsById() {
        return this.modelsById;
    }
    get rows() {
        return this.models;
    }
    addRow(data) {
        return this.add(data);
    }
    addRows(data) {
        return this.addMany(data);
    }
}, $841e88a4d7a50662$var$_applyDecoratedDescriptor($841e88a4d7a50662$var$_class.prototype, "addRow", [
    $841e88a4d7a50662$var$_dec
], Object.getOwnPropertyDescriptor($841e88a4d7a50662$var$_class.prototype, "addRow"), $841e88a4d7a50662$var$_class.prototype), $841e88a4d7a50662$var$_applyDecoratedDescriptor($841e88a4d7a50662$var$_class.prototype, "addRows", [
    $841e88a4d7a50662$var$_dec2
], Object.getOwnPropertyDescriptor($841e88a4d7a50662$var$_class.prototype, "addRows"), $841e88a4d7a50662$var$_class.prototype), $841e88a4d7a50662$var$_class);
var $841e88a4d7a50662$export$2e2bcd8739ae039 = new $841e88a4d7a50662$var$ResourceRowCollection();
const $841e88a4d7a50662$export$6798d7f54903900c = $841e88a4d7a50662$var$ResourceRowCollection;

});
parcelRegister("lJe7g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd18c01be6c358d4$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $blgBn = parcelRequire("blgBn");

var $fqmGV = parcelRequire("fqmGV");

var $dBifK = parcelRequire("dBifK");

var $5Xh7w = parcelRequire("5Xh7w");

var $egx7S = parcelRequire("egx7S");

var $8YeUb = parcelRequire("8YeUb");

var $lTrDt = parcelRequire("lTrDt");

var $YCvN6 = parcelRequire("YCvN6");

var $5tqXB = parcelRequire("5tqXB");

var $grD63 = parcelRequire("grD63");
var $fd18c01be6c358d4$var$_dec, $fd18c01be6c358d4$var$_dec2, $fd18c01be6c358d4$var$_dec3, $fd18c01be6c358d4$var$_dec4, $fd18c01be6c358d4$var$_dec5, $fd18c01be6c358d4$var$_class, $fd18c01be6c358d4$var$_descriptor, $fd18c01be6c358d4$var$_descriptor2, $fd18c01be6c358d4$var$_descriptor3, $fd18c01be6c358d4$var$_descriptor4, $fd18c01be6c358d4$var$_descriptor5, $fd18c01be6c358d4$var$_descriptor6, $fd18c01be6c358d4$var$_descriptor7, $fd18c01be6c358d4$var$_descriptor8, $fd18c01be6c358d4$var$_descriptor9, $fd18c01be6c358d4$var$_descriptor10, $fd18c01be6c358d4$var$_descriptor11, $fd18c01be6c358d4$var$_descriptor12, $fd18c01be6c358d4$var$_descriptor13, $fd18c01be6c358d4$var$_descriptor14, $fd18c01be6c358d4$var$_descriptor15, $fd18c01be6c358d4$var$_descriptor16, $fd18c01be6c358d4$var$_descriptor17, $fd18c01be6c358d4$var$_descriptor18, $fd18c01be6c358d4$var$_descriptor19, $fd18c01be6c358d4$var$_descriptor20, $fd18c01be6c358d4$var$_descriptor21, $fd18c01be6c358d4$var$_descriptor22, $fd18c01be6c358d4$var$_descriptor23;
function $fd18c01be6c358d4$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $fd18c01be6c358d4$var$_defineProperty(e, r, t) {
    return (r = $fd18c01be6c358d4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fd18c01be6c358d4$var$_toPropertyKey(t) {
    var i = $fd18c01be6c358d4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fd18c01be6c358d4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fd18c01be6c358d4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $fd18c01be6c358d4$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $fd18c01be6c358d4$var$propByGroup = {
    status: "status",
    project: "projectId",
    phase: "phaseId",
    staff: "staffId",
    role: "staffRoleId"
};
const $fd18c01be6c358d4$var$titlePropByGroup = {
    project: "title",
    phase: "title",
    staff: "fullName",
    role: "name"
};
let $fd18c01be6c358d4$var$ResourceRowModel = ($fd18c01be6c358d4$var$_dec = (0, $d8hWe.action).bound, $fd18c01be6c358d4$var$_dec2 = (0, $d8hWe.action).bound, $fd18c01be6c358d4$var$_dec3 = (0, $d8hWe.action).bound, $fd18c01be6c358d4$var$_dec4 = (0, $d8hWe.action).bound, $fd18c01be6c358d4$var$_dec5 = (0, $d8hWe.action).bound, $fd18c01be6c358d4$var$_class = class ResourceRowModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "label", $fd18c01be6c358d4$var$_descriptor, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "budget", $fd18c01be6c358d4$var$_descriptor2, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "actualHours", $fd18c01be6c358d4$var$_descriptor3, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "projectedHours", $fd18c01be6c358d4$var$_descriptor4, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "prospectiveHours", $fd18c01be6c358d4$var$_descriptor5, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "actualCost", $fd18c01be6c358d4$var$_descriptor6, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "projectedCost", $fd18c01be6c358d4$var$_descriptor7, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "prospectiveCost", $fd18c01be6c358d4$var$_descriptor8, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "editedHours", $fd18c01be6c358d4$var$_descriptor9, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "editedCost", $fd18c01be6c358d4$var$_descriptor10, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "status", $fd18c01be6c358d4$var$_descriptor11, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "projectId", $fd18c01be6c358d4$var$_descriptor12, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "phaseId", $fd18c01be6c358d4$var$_descriptor13, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "phaseTitle", $fd18c01be6c358d4$var$_descriptor14, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "staffRoleId", $fd18c01be6c358d4$var$_descriptor15, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "staffId", $fd18c01be6c358d4$var$_descriptor16, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "hoursStartDate", $fd18c01be6c358d4$var$_descriptor17, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "hoursEndDate", $fd18c01be6c358d4$var$_descriptor18, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "groups", $fd18c01be6c358d4$var$_descriptor19, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "store", $fd18c01be6c358d4$var$_descriptor20, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "parent", $fd18c01be6c358d4$var$_descriptor21, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "children", $fd18c01be6c358d4$var$_descriptor22, this);
        $fd18c01be6c358d4$var$_initializerDefineProperty(this, "isRootPhase", $fd18c01be6c358d4$var$_descriptor23, this);
        $fd18c01be6c358d4$var$_defineProperty(this, "getHoursInMonth", (month, hoursData = this.hoursData)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.map((r)=>r.getHoursInMonth(month)));
            if (hoursData === "actual") {
                var _this$actualHours$mon;
                return (_this$actualHours$mon = this.actualHours[month]) !== null && _this$actualHours$mon !== void 0 ? _this$actualHours$mon : 0;
            }
            if (hoursData === "projected") {
                var _this$staff, _ref, _this$editedHours$mon;
                if ((_this$staff = this.staff) !== null && _this$staff !== void 0 && _this$staff.isArchived) return 0;
                return (_ref = (_this$editedHours$mon = this.editedHours[month]) !== null && _this$editedHours$mon !== void 0 ? _this$editedHours$mon : this.projectedHours[month]) !== null && _ref !== void 0 ? _ref : 0;
            }
            if (hoursData === "actualsProjected") {
                if (month < (0, $egx7S.format)(new Date(), "yyyy-MM")) {
                    var _this$actualHours$mon2;
                    return (_this$actualHours$mon2 = this.actualHours[month]) !== null && _this$actualHours$mon2 !== void 0 ? _this$actualHours$mon2 : 0;
                } else if (month > (0, $egx7S.format)(new Date(), "yyyy-MM")) {
                    var _ref2, _this$editedHours$mon2;
                    return (_ref2 = (_this$editedHours$mon2 = this.editedHours[month]) !== null && _this$editedHours$mon2 !== void 0 ? _this$editedHours$mon2 : this.projectedHours[month]) !== null && _ref2 !== void 0 ? _ref2 : 0;
                } else {
                    var _this$actualHours$mon3, _ref3, _this$editedHours$mon3;
                    return Math.max((_this$actualHours$mon3 = this.actualHours[month]) !== null && _this$actualHours$mon3 !== void 0 ? _this$actualHours$mon3 : 0, (_ref3 = (_this$editedHours$mon3 = this.editedHours[month]) !== null && _this$editedHours$mon3 !== void 0 ? _this$editedHours$mon3 : this.projectedHours[month]) !== null && _ref3 !== void 0 ? _ref3 : 0);
                }
            }
            if (hoursData === "remainingProjected") {
                var _ref4, _this$editedHours$mon4, _this$actualHours$mon4;
                return ((_ref4 = (_this$editedHours$mon4 = this.editedHours[month]) !== null && _this$editedHours$mon4 !== void 0 ? _this$editedHours$mon4 : this.projectedHours[month]) !== null && _ref4 !== void 0 ? _ref4 : 0) - ((_this$actualHours$mon4 = this.actualHours[month]) !== null && _this$actualHours$mon4 !== void 0 ? _this$actualHours$mon4 : 0);
            }
            if (hoursData === "remainingProjectedCapped") {
                var _ref5, _this$editedHours$mon5, _this$actualHours$mon5;
                return Math.max(((_ref5 = (_this$editedHours$mon5 = this.editedHours[month]) !== null && _this$editedHours$mon5 !== void 0 ? _this$editedHours$mon5 : this.projectedHours[month]) !== null && _ref5 !== void 0 ? _ref5 : 0) - ((_this$actualHours$mon5 = this.actualHours[month]) !== null && _this$actualHours$mon5 !== void 0 ? _this$actualHours$mon5 : 0), 0);
            }
        });
        $fd18c01be6c358d4$var$_defineProperty(this, "getProspectiveHoursInMonth", (0, $YCvN6.computedFn)((month)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.map((r)=>r.getProspectiveHoursInMonth(month)));
            if (this.hoursData === "actual") return 0;
            if (this.hoursData === "projected") {
                var _this$staff2, _this$prospectiveHour;
                if ((_this$staff2 = this.staff) !== null && _this$staff2 !== void 0 && _this$staff2.isArchived) return 0;
                return (_this$prospectiveHour = this.prospectiveHours[month]) !== null && _this$prospectiveHour !== void 0 ? _this$prospectiveHour : 0;
            }
            if (this.hoursData === "actualsProjected") {
                if (month < (0, $egx7S.format)(new Date(), "yyyy-MM")) return 0;
                else if (month >= (0, $egx7S.format)(new Date(), "yyyy-MM")) {
                    var _this$prospectiveHour2;
                    return (_this$prospectiveHour2 = this.prospectiveHours[month]) !== null && _this$prospectiveHour2 !== void 0 ? _this$prospectiveHour2 : 0;
                }
            }
        }));
        $fd18c01be6c358d4$var$_defineProperty(this, "getCostInMonth", (0, $YCvN6.computedFn)((month)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.map((r)=>r.getCostInMonth(month)));
            if (this.hoursData === "actual") {
                var _this$actualCost$mont;
                return (_this$actualCost$mont = this.actualCost[month]) !== null && _this$actualCost$mont !== void 0 ? _this$actualCost$mont : 0;
            }
            if (this.hoursData === "projected") {
                var _ref6, _this$editedCost$mont;
                return (_ref6 = (_this$editedCost$mont = this.editedCost[month]) !== null && _this$editedCost$mont !== void 0 ? _this$editedCost$mont : this.projectedCost[month]) !== null && _ref6 !== void 0 ? _ref6 : 0;
            }
            if (this.hoursData === "actualsProjected") {
                if (month < (0, $egx7S.format)(new Date(), "yyyy-MM")) {
                    var _this$actualCost$mont2;
                    return (_this$actualCost$mont2 = this.actualCost[month]) !== null && _this$actualCost$mont2 !== void 0 ? _this$actualCost$mont2 : 0;
                } else if (month > (0, $egx7S.format)(new Date(), "yyyy-MM")) {
                    var _ref7, _this$editedCost$mont2;
                    return (_ref7 = (_this$editedCost$mont2 = this.editedCost[month]) !== null && _this$editedCost$mont2 !== void 0 ? _this$editedCost$mont2 : this.projectedCost[month]) !== null && _ref7 !== void 0 ? _ref7 : 0;
                } else {
                    var _this$actualCost$mont3, _ref8, _this$editedCost$mont3;
                    return Math.max((_this$actualCost$mont3 = this.actualCost[month]) !== null && _this$actualCost$mont3 !== void 0 ? _this$actualCost$mont3 : 0, (_ref8 = (_this$editedCost$mont3 = this.editedCost[month]) !== null && _this$editedCost$mont3 !== void 0 ? _this$editedCost$mont3 : this.projectedCost[month]) !== null && _ref8 !== void 0 ? _ref8 : 0);
                }
            }
        }));
        $fd18c01be6c358d4$var$_defineProperty(this, "getHoursToDateInMonth", (0, $YCvN6.computedFn)((month)=>{
            const prevHoursMonths = this.hoursMonths.filter((m)=>m <= month);
            const hoursToDate = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(prevHoursMonths.map((m)=>this.getHoursInMonth(m)));
            return hoursToDate;
        }));
        $fd18c01be6c358d4$var$_defineProperty(this, "getCostToDateInMonth", (0, $YCvN6.computedFn)((month)=>{
            const prevHoursMonths = this.hoursMonths.filter((m)=>m <= month);
            const costToDate = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(prevHoursMonths.map((m)=>this.getCostInMonth(m)));
            return costToDate;
        }));
        $fd18c01be6c358d4$var$_defineProperty(this, "getTotalHours", (0, $YCvN6.computedFn)(()=>{
            return this.getHoursToDateInMonth((0, $egx7S.format)((0, $egx7S.addYears)(new Date(), 100), "yyyy-MM"));
        }));
        $fd18c01be6c358d4$var$_defineProperty(this, "getTotalCost", (0, $YCvN6.computedFn)(()=>{
            return this.getCostToDateInMonth((0, $egx7S.format)((0, $egx7S.addYears)(new Date(), 100), "yyyy-MM"));
        }));
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $blgBn.default);
        this.init(data, options);
    }
    setStore(store) {
        this.children.forEach((r)=>r.setStore(store));
        if (this.store === store) return;
        this.store = store;
    }
    setParent(parent) {
        this.parent = parent;
    }
    setChildren(children = []) {
        this.children = children;
    }
    get leaves() {
        if (this.children.length) return this.children.flatMap((c)=>c.leaves);
        return [
            this
        ];
    }
    get hoursData() {
        var _this$store, _this$store$report, _this$store$report$fi, _this$store2, _this$store2$report, _this$store2$report$f, _this$store3, _this$store3$report, _this$store3$report$f;
        return ((_this$store = this.store) === null || _this$store === void 0 ? void 0 : (_this$store$report = _this$store.report) === null || _this$store$report === void 0 ? void 0 : (_this$store$report$fi = _this$store$report.filters) === null || _this$store$report$fi === void 0 ? void 0 : _this$store$report$fi.hoursData) || ((_this$store2 = this.store) === null || _this$store2 === void 0 ? void 0 : (_this$store2$report = _this$store2.report) === null || _this$store2$report === void 0 ? void 0 : (_this$store2$report$f = _this$store2$report.filters) === null || _this$store2$report$f === void 0 ? void 0 : _this$store2$report$f.revenueData) || ((_this$store3 = this.store) === null || _this$store3 === void 0 ? void 0 : (_this$store3$report = _this$store3.report) === null || _this$store3$report === void 0 ? void 0 : (_this$store3$report$f = _this$store3$report.filters) === null || _this$store3$report$f === void 0 ? void 0 : _this$store3$report$f.expenseData) || "actualsProjected";
    }
    get title() {
        const lastGroup = this.groups[this.groups.length - 1];
        if (!this.label || this.label === "") {
            var _this$lastGroup;
            const titleProp = $fd18c01be6c358d4$var$titlePropByGroup[lastGroup];
            return titleProp ? (_this$lastGroup = this[lastGroup]) === null || _this$lastGroup === void 0 ? void 0 : _this$lastGroup[titleProp] : this[lastGroup];
        } else return this.label;
    }
    get hoursBudget() {
        if (!("staffId" in this.matchers || "staffRoleId" in this.matchers)) {
            var _this$phase, _this$project;
            return this.budget || ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.hoursBudget) || ((_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.hoursBudget);
        } else return this.budget || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.map((c)=>c.hoursBudget));
    }
    get costBudget() {
        if (!("staffId" in this.matchers || "staffRoleId" in this.matchers)) {
            var _this$phase2, _this$project2;
            return this.hoursBudget * this.costRate || ((_this$phase2 = this.phase) === null || _this$phase2 === void 0 ? void 0 : _this$phase2.expenseBudget) || ((_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.expenseBudget);
        } else return this.hoursBudget * this.costRate || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.map((c)=>c.costBudget));
    }
    get chargeOutBudget() {
        if (!("staffId" in this.matchers || "staffRoleId" in this.matchers)) {
            var _this$phase3, _this$project3;
            return this.hoursBudget * this.chargeOutRate || ((_this$phase3 = this.phase) === null || _this$phase3 === void 0 ? void 0 : _this$phase3.fee) || ((_this$project3 = this.project) === null || _this$project3 === void 0 ? void 0 : _this$project3.fee);
        } else return this.hoursBudget * this.chargeOutRate || (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.map((c)=>c.chargeOutBudget));
    }
    get level() {
        return this.groups.length - 1;
    }
    get childPhases() {
        return this.phase ? [
            this.phase
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childPhases))
        ].filter((p)=>p);
    }
    get childPhaseIds() {
        return this.phaseId ? [
            this.phaseId
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childPhaseIds))
        ].filter((p)=>p);
    }
    get childProjects() {
        return this.project ? [
            this.project
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childProjects))
        ].filter((p)=>p);
    }
    get childProjectIds() {
        return this.projectId ? [
            this.projectId
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childProjectIds))
        ].filter((p)=>p);
    }
    get childProjectRows() {
        return this.project ? [
            this
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childProjectRows))
        ];
    }
    get childStaff() {
        return this.staff ? [
            this.staff
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childStaff))
        ].filter((s)=>s);
    }
    get childRoles() {
        return this.role ? [
            this.role
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childRoles))
        ];
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.matchers.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.matchers.projectId];
    }
    get role() {
        return (0, $8YeUb.default).rolesById[this.matchers.staffRoleId];
    }
    get staff() {
        return (0, $lTrDt.default).staffById[this.matchers.staffId];
    }
    get allStaff() {
        var _this$role;
        return ((this.groups.includes("staff") ? [
            this.staff
        ] : this.groups.includes("role") ? ((_this$role = this.role) === null || _this$role === void 0 ? void 0 : _this$role.staff) || (0, $lTrDt.default).staffByRoleId[this.staffRoleId] : (0, $lTrDt.default).staff) || []).filter((s)=>s && !(s !== null && s !== void 0 && s.deletedAt));
    }
    get matchers() {
        let matchers = {};
        if (this.groups.includes("staff")) matchers.staffId = this.staffId;
        if (this.groups.includes("role")) matchers.staffRoleId = this.staffRoleId;
        if (this.groups.includes("phase")) matchers.phaseId = this.phaseId;
        if (this.groups.includes("project")) matchers.projectId = this.projectId;
        if (this.groups.includes("status")) matchers.status = this.status;
        return matchers;
    }
    getAvailabilityInMonth(month, store) {
        const monthDate = (0, $egx7S.startOfMonth)((0, $egx7S.parse)(month, "yyyy-MM", new Date()));
        const start = (0, $egx7S.startOfMonth)(monthDate);
        const end = (0, $egx7S.endOfMonth)(monthDate);
        const dayAfterEnd = (0, $egx7S.startOfMonth)((0, $egx7S.addDays)(end, 1));
        const holidayDays = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum((0, $grD63.default).organisationHolidays.filter((h)=>h.startDate <= end && h.endDate >= start).map((h)=>{
            const startDate = Math.max(h.startDate, start);
            const endDate = (0, $egx7S.addDays)((0, $egx7S.startOfDay)(Math.min(h.endDate, end)), 1);
            return (0, $egx7S.differenceInBusinessDays)(endDate, startDate);
        }));
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.allStaff.filter((s)=>!store || store.staff.includes(s)).map((s)=>s.getAvailabilityInDateRange([
                start,
                end
            ]) / 60 / 5)) * ((0, $egx7S.differenceInBusinessDays)(dayAfterEnd, start) - holidayDays);
    }
    getTotalAvailability(store) {
        const endMonth = (0, $egx7S.startOfMonth)(this.hoursEndDate || new Date());
        let startMonth = (0, $egx7S.startOfMonth)(this.hoursStartDate || new Date());
        const months = [];
        while(startMonth <= endMonth){
            months.push((0, $egx7S.format)(startMonth, "yyyy-MM"));
            startMonth = (0, $egx7S.startOfMonth)((0, $egx7S.addMonths)(startMonth, 1));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(months.map((m)=>this.getAvailabilityInMonth(m, store))) || 0;
    }
    get hoursMonths() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).uniq(this.children.flatMap((r)=>r.hoursMonths));
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).uniq([
            ...Object.keys(this.actualHours),
            ...Object.keys(this.projectedHours),
            ...Object.keys(this.editedHours)
        ]);
    }
    getProgressInMonth(month) {
        return this.getHoursToDateInMonth(month) / this.hoursBudget;
    }
    getCostProgressInMonth(month) {
        return this.getCostToDateInMonth(month) / this.costBudget;
    }
    get resource() {
        return this.staff || this.role;
    }
    get costRate() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.children.map((r)=>r.costRate));
        return (0, $5tqXB.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "cost", [
            this.startDate,
            this.endDate
        ]);
    }
    get chargeOutRate() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.children.map((r)=>r.chargeOutRate));
        return (0, $5tqXB.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "chargeOut", [
            this.startDate,
            this.endDate
        ]);
    }
    getCostRateInMonth(month) {
        const costInMonth = this.getCostInMonth(month);
        const hoursInMonth = this.getHoursInMonth(month);
        if (hoursInMonth) return costInMonth / hoursInMonth;
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.children.map((r)=>r.getCostRateInMonth(month)));
        const monthDate = (0, $egx7S.startOfMonth)((0, $egx7S.parse)(month, "yyyy-MM", new Date()));
        const monthEndDate = (0, $egx7S.endOfMonth)(monthDate);
        return (0, $5tqXB.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "cost", [
            monthDate,
            monthEndDate
        ]);
    }
    getChargeOutRateInMonth(month) {
        const chargeOutInMonth = this.getChargeOutInMonth(month);
        const hoursInMonth = this.getHoursInMonth(month);
        if (hoursInMonth) return chargeOutInMonth / hoursInMonth;
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(this.children.map((r)=>r.getChargeOutRateInMonth(month)));
        const monthDate = (0, $egx7S.startOfMonth)((0, $egx7S.parse)(month, "yyyy-MM", new Date()));
        const monthEndDate = (0, $egx7S.endOfMonth)(monthDate);
        return (0, $5tqXB.default)({
            project: this.project,
            phase: this.phase,
            staff: this.staff,
            role: this.role
        }, "chargeOut", [
            monthDate,
            monthEndDate
        ]);
    }
    setHoursProgressInMonth(month, progress) {
        progress || (progress = 0);
        const monthDate = (0, $egx7S.parse)(month, "yyyy-MM", new Date());
        const prevMonth = (0, $egx7S.format)((0, $egx7S.subMonths)(monthDate, 1), "yyyy-MM");
        const prevProgress = this.getProgressInMonth(prevMonth) || 0;
        const diffProgress = Math.max(progress, prevProgress) - prevProgress;
        const diffHours = diffProgress * this.hoursBudget;
        return this.setHoursInMonth(month, diffHours);
    }
    setCostProgressInMonth(month, progress) {
        progress || (progress = 0);
        const monthDate = (0, $egx7S.parse)(month, "yyyy-MM", new Date());
        const prevMonth = (0, $egx7S.format)((0, $egx7S.subMonths)(monthDate, 1), "yyyy-MM");
        const prevProgress = this.getCostProgressInMonth(prevMonth) || 0;
        const diffProgress = Math.max(progress, prevProgress) - prevProgress;
        const diffCost = diffProgress * this.costBudget;
        return this.setCostInMonth(month, diffCost);
    }
    setHoursInMonth(month, v, options) {
        const costRate = this.getCostRateInMonth(month);
        if (!this.children.length) {
            this.editedHours[month] = v;
            this.update({
                editedHours: {
                    ...this.editedHours
                }
            }, options);
            this.editedCost[month] = v * costRate;
        }
        const children = this.children;
        const childrenWithHoursInMonth = children.filter((r)=>r.getHoursInMonth(month) > 0);
        const existingHoursInMonth = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(childrenWithHoursInMonth.map((r)=>r.getHoursInMonth(month)));
        if (existingHoursInMonth) {
            const ratio = v / existingHoursInMonth;
            childrenWithHoursInMonth.forEach((r)=>r.setHoursInMonth(month, r.getHoursInMonth(month) * ratio, options));
        } else children.forEach((r)=>r.setHoursInMonth(month, v / children.length, options));
    }
    setCostInMonth(month, v, options) {
        const costRate = this.getCostRateInMonth(month);
        const hours = costRate ? v / costRate : 0;
        this.setHoursInMonth(month, hours, options);
    }
    serialize() {
        var _this$store4, _this$store4$report;
        return {
            id: this.id,
            editedHours: this.editedHours,
            reportFilters: {
                ...((_this$store4 = this.store) === null || _this$store4 === void 0 ? void 0 : (_this$store4$report = _this$store4.report) === null || _this$store4$report === void 0 ? void 0 : _this$store4$report.filters) || {},
                ...this.matchers
            }
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
}, $fd18c01be6c358d4$var$_descriptor = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "label", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor2 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "budget", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $fd18c01be6c358d4$var$_descriptor3 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "actualHours", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fd18c01be6c358d4$var$_descriptor4 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "projectedHours", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fd18c01be6c358d4$var$_descriptor5 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "prospectiveHours", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fd18c01be6c358d4$var$_descriptor6 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "actualCost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fd18c01be6c358d4$var$_descriptor7 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "projectedCost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fd18c01be6c358d4$var$_descriptor8 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "prospectiveCost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fd18c01be6c358d4$var$_descriptor9 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "editedHours", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fd18c01be6c358d4$var$_descriptor10 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "editedCost", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $fd18c01be6c358d4$var$_descriptor11 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "status", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor12 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor13 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor14 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "phaseTitle", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor15 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "staffRoleId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor16 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "staffId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor17 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "hoursStartDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor18 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "hoursEndDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor19 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "groups", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            "status"
        ];
    }
}), $fd18c01be6c358d4$var$_descriptor20 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "store", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor21 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "parent", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_descriptor22 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "children", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $fd18c01be6c358d4$var$_descriptor23 = $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "isRootPhase", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "setStore", [
    $fd18c01be6c358d4$var$_dec
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "setStore"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "setParent", [
    $fd18c01be6c358d4$var$_dec2
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "setParent"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "setChildren", [
    $fd18c01be6c358d4$var$_dec3
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "setChildren"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "leaves", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "leaves"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "hoursData", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "hoursData"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "title", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "title"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "hoursBudget", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "hoursBudget"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "costBudget", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "costBudget"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "chargeOutBudget", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "chargeOutBudget"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "level", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "level"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "childPhases", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "childPhases"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "childPhaseIds", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "childPhaseIds"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "childProjects", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "childProjects"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "childProjectIds", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "childProjectIds"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "childProjectRows", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "childProjectRows"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "childStaff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "childStaff"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "childRoles", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "childRoles"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "phase"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "project"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "role", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "role"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "staff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "staff"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "allStaff", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "allStaff"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "matchers", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "matchers"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "getAvailabilityInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "getAvailabilityInMonth"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "getTotalAvailability", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "getTotalAvailability"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "hoursMonths", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "hoursMonths"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "getProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "getProgressInMonth"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "getCostProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "getCostProgressInMonth"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "resource", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "resource"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "costRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "costRate"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "chargeOutRate", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "chargeOutRate"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "setHoursProgressInMonth", [
    $fd18c01be6c358d4$var$_dec4
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "setHoursProgressInMonth"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "setCostProgressInMonth", [
    $fd18c01be6c358d4$var$_dec5
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "setCostProgressInMonth"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "setHoursInMonth", [
    (0, $d8hWe.action)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "setHoursInMonth"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_applyDecoratedDescriptor($fd18c01be6c358d4$var$_class.prototype, "setCostInMonth", [
    (0, $d8hWe.action)
], Object.getOwnPropertyDescriptor($fd18c01be6c358d4$var$_class.prototype, "setCostInMonth"), $fd18c01be6c358d4$var$_class.prototype), $fd18c01be6c358d4$var$_class);
var $fd18c01be6c358d4$export$2e2bcd8739ae039 = $fd18c01be6c358d4$var$ResourceRowModel;

});
parcelRegister("YCvN6", function(module, exports) {

$parcel$export(module.exports, "computedFn", function () { return $0b637a582db6edc4$export$79a1d35ba0cac8da; });

var $d8hWe = parcelRequire("d8hWe");
var $0b637a582db6edc4$export$5702a91a6f42969f = function() {};
var $0b637a582db6edc4$export$76c0f2b8ecfc3d8a = function(_) {
    return _;
};
function $0b637a582db6edc4$export$2b62a06a9fee979c(message) {
    throw new Error("[mobx-utils] " + message);
}
function $0b637a582db6edc4$export$f5708dca728d7177(cond, message) {
    if (message === void 0) message = "Illegal state";
    if (!cond) $0b637a582db6edc4$export$2b62a06a9fee979c(message);
}
function $0b637a582db6edc4$export$edfd600d9920791e(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
var $0b637a582db6edc4$var$deepFields = function(x) {
    return x && x !== Object.prototype && Object.getOwnPropertyNames(x).concat($0b637a582db6edc4$var$deepFields(Object.getPrototypeOf(x)) || []);
};
var $0b637a582db6edc4$var$distinctDeepFields = function(x) {
    var deepFieldsIndistinct = $0b637a582db6edc4$var$deepFields(x);
    var deepFieldsDistinct = deepFieldsIndistinct.filter(function(item, index) {
        return deepFieldsIndistinct.indexOf(item) === index;
    });
    return deepFieldsDistinct;
};
var $0b637a582db6edc4$export$a984b761acd10b55 = function(x) {
    return $0b637a582db6edc4$var$distinctDeepFields(x).filter(function(name) {
        return name !== "constructor" && !~name.indexOf("__");
    });
};
var $0b637a582db6edc4$export$aebb42912407fb2d = "pending";
var $0b637a582db6edc4$export$db6da4f66a5dc93d = "fulfilled";
var $0b637a582db6edc4$export$83d3e3ad3e63df9c = "rejected";
function $0b637a582db6edc4$var$caseImpl(handlers) {
    switch(this.state){
        case $0b637a582db6edc4$export$aebb42912407fb2d:
            return handlers.pending && handlers.pending(this.value);
        case $0b637a582db6edc4$export$83d3e3ad3e63df9c:
            return handlers.rejected && handlers.rejected(this.value);
        case $0b637a582db6edc4$export$db6da4f66a5dc93d:
            return handlers.fulfilled ? handlers.fulfilled(this.value) : this.value;
    }
}
/**
 * `fromPromise` takes a Promise, extends it with 2 observable properties that track
 * the status of the promise and returns it. The returned object has the following observable properties:
 *  - `value`: either the initial value, the value the Promise resolved to, or the value the Promise was rejected with. use `.state` if you need to be able to tell the difference.
 *  - `state`: one of `"pending"`, `"fulfilled"` or `"rejected"`
 *
 * And the following methods:
 * - `case({fulfilled, rejected, pending})`: maps over the result using the provided handlers, or returns `undefined` if a handler isn't available for the current promise state.
 *
 * The returned object implements `PromiseLike<TValue>`, so you can chain additional `Promise` handlers using `then`. You may also use it with `await` in `async` functions.
 *
 * Note that the status strings are available as constants:
 * `mobxUtils.PENDING`, `mobxUtils.REJECTED`, `mobxUtil.FULFILLED`
 *
 * fromPromise takes an optional second argument, a previously created `fromPromise` based observable.
 * This is useful to replace one promise based observable with another, without going back to an intermediate
 * "pending" promise state while fetching data. For example:
 *
 * @example
 * \@observer
 * class SearchResults extends React.Component {
 *   \@observable.ref searchResults
 *
 *   componentDidUpdate(nextProps) {
 *     if (nextProps.query !== this.props.query)
 *       this.searchResults = fromPromise(
 *         window.fetch("/search?q=" + nextProps.query),
 *         // by passing, we won't render a pending state if we had a successful search query before
 *         // rather, we will keep showing the previous search results, until the new promise resolves (or rejects)
 *         this.searchResults
 *       )
 *   }
 *
 *   render() {
 *     return this.searchResults.case({
 *        pending: (staleValue) => {
 *          return staleValue || "searching" // <- value might set to previous results while the promise is still pending
 *        },
 *        fulfilled: (value) => {
 *          return value // the fresh results
 *        },
 *        rejected: (error) => {
 *          return "Oops: " + error
 *        }
 *     })
 *   }
 * }
 *
 * Observable promises can be created immediately in a certain state using
 * `fromPromise.reject(reason)` or `fromPromise.resolve(value?)`.
 * The main advantage of `fromPromise.resolve(value)` over `fromPromise(Promise.resolve(value))` is that the first _synchronously_ starts in the desired state.
 *
 * It is possible to directly create a promise using a resolve, reject function:
 * `fromPromise((resolve, reject) => setTimeout(() => resolve(true), 1000))`
 *
 * @example
 * const fetchResult = fromPromise(fetch("http://someurl"))
 *
 * // combine with when..
 * when(
 *   () => fetchResult.state !== "pending",
 *   () => {
 *     console.log("Got ", fetchResult.value)
 *   }
 * )
 *
 * // or a mobx-react component..
 * const myComponent = observer(({ fetchResult }) => {
 *   switch(fetchResult.state) {
 *      case "pending": return <div>Loading...</div>
 *      case "rejected": return <div>Ooops... {fetchResult.value}</div>
 *      case "fulfilled": return <div>Gotcha: {fetchResult.value}</div>
 *   }
 * })
 *
 * // or using the case method instead of switch:
 *
 * const myComponent = observer(({ fetchResult }) =>
 *   fetchResult.case({
 *     pending:   () => <div>Loading...</div>,
 *     rejected:  error => <div>Ooops.. {error}</div>,
 *     fulfilled: value => <div>Gotcha: {value}</div>,
 *   }))
 *
 * // chain additional handler(s) to the resolve/reject:
 *
 * fetchResult.then(
 *   (result) =>  doSomeTransformation(result),
 *   (rejectReason) => console.error('fetchResult was rejected, reason: ' + rejectReason)
 * ).then(
 *   (transformedResult) => console.log('transformed fetchResult: ' + transformedResult)
 * )
 *
 * @param origPromise The promise which will be observed
 * @param oldPromise The previously observed promise
 * @returns origPromise with added properties and methods described above.
 */ function $0b637a582db6edc4$export$60f45028237c39d1(origPromise, oldPromise) {
    $0b637a582db6edc4$export$f5708dca728d7177(arguments.length <= 2, "fromPromise expects up to two arguments");
    $0b637a582db6edc4$export$f5708dca728d7177(typeof origPromise === "function" || typeof origPromise === "object" && origPromise && typeof origPromise.then === "function", "Please pass a promise or function to fromPromise");
    if (origPromise.isPromiseBasedObservable === true) return origPromise;
    if (typeof origPromise === "function") // If it is a (reject, resolve function, wrap it)
    origPromise = new Promise(origPromise);
    var promise = origPromise;
    origPromise.then((0, $d8hWe.action)("observableFromPromise-resolve", function(value) {
        promise.value = value;
        promise.state = $0b637a582db6edc4$export$db6da4f66a5dc93d;
    }), (0, $d8hWe.action)("observableFromPromise-reject", function(reason) {
        promise.value = reason;
        promise.state = $0b637a582db6edc4$export$83d3e3ad3e63df9c;
    }));
    promise.isPromiseBasedObservable = true;
    promise.case = $0b637a582db6edc4$var$caseImpl;
    var oldData = oldPromise && (oldPromise.state === $0b637a582db6edc4$export$db6da4f66a5dc93d || oldPromise.state === $0b637a582db6edc4$export$aebb42912407fb2d) ? oldPromise.value : undefined;
    (0, $d8hWe.extendObservable)(promise, {
        value: oldData,
        state: $0b637a582db6edc4$export$aebb42912407fb2d
    }, {}, {
        deep: false
    });
    return promise;
}
(function(fromPromise) {
    fromPromise.reject = (0, $d8hWe.action)("fromPromise.reject", function(reason) {
        var p = fromPromise(Promise.reject(reason));
        p.state = $0b637a582db6edc4$export$83d3e3ad3e63df9c;
        p.value = reason;
        return p;
    });
    function resolveBase(value) {
        if (value === void 0) value = undefined;
        var p = fromPromise(Promise.resolve(value));
        p.state = $0b637a582db6edc4$export$db6da4f66a5dc93d;
        p.value = value;
        return p;
    }
    fromPromise.resolve = (0, $d8hWe.action)("fromPromise.resolve", resolveBase);
})($0b637a582db6edc4$export$60f45028237c39d1 || ($0b637a582db6edc4$export$60f45028237c39d1 = {}));
/**
 * Returns true if the provided value is a promise-based observable.
 * @param value any
 * @returns {boolean}
 */ function $0b637a582db6edc4$export$ec6a0a7c8171750d(value) {
    return value && value.isPromiseBasedObservable === true;
}
var $0b637a582db6edc4$var$__spreadArrays = function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
/**
 * Moves an item from one position to another, checking that the indexes given are within bounds.
 *
 * @example
 * const source = observable([1, 2, 3])
 * moveItem(source, 0, 1)
 * console.log(source.map(x => x)) // [2, 1, 3]
 *
 * @export
 * @param {ObservableArray<T>} target
 * @param {number} fromIndex
 * @param {number} toIndex
 * @returns {ObservableArray<T>}
 */ function $0b637a582db6edc4$export$ec937e64de6c1257(target, fromIndex, toIndex) {
    $0b637a582db6edc4$var$checkIndex(target, fromIndex);
    $0b637a582db6edc4$var$checkIndex(target, toIndex);
    if (fromIndex === toIndex) return;
    var oldItems = target.slice();
    var newItems;
    if (fromIndex < toIndex) newItems = $0b637a582db6edc4$var$__spreadArrays(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
        oldItems[fromIndex]
    ], oldItems.slice(toIndex + 1));
    else // toIndex < fromIndex
    newItems = $0b637a582db6edc4$var$__spreadArrays(oldItems.slice(0, toIndex), [
        oldItems[fromIndex]
    ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
    target.replace(newItems);
    return target;
}
/**
 * Checks whether the specified index is within bounds. Throws if not.
 *
 * @private
 * @param {ObservableArray<any>} target
 * @param {number }index
 */ function $0b637a582db6edc4$var$checkIndex(target, index) {
    if (index < 0) throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
    var length = target.length;
    if (index >= length) throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
}
/**
 * `lazyObservable` creates an observable around a `fetch` method that will not be invoked
 * until the observable is needed the first time.
 * The fetch method receives a `sink` callback which can be used to replace the
 * current value of the lazyObservable. It is allowed to call `sink` multiple times
 * to keep the lazyObservable up to date with some external resource.
 *
 * Note that it is the `current()` call itself which is being tracked by MobX,
 * so make sure that you don't dereference to early.
 *
 * @example
 * const userProfile = lazyObservable(
 *   sink => fetch("/myprofile").then(profile => sink(profile))
 * )
 *
 * // use the userProfile in a React component:
 * const Profile = observer(({ userProfile }) =>
 *   userProfile.current() === undefined
 *   ? <div>Loading user profile...</div>
 *   : <div>{userProfile.current().displayName}</div>
 * )
 *
 * // triggers refresh the userProfile
 * userProfile.refresh()
 *
 * @param {(sink: (newValue: T) => void) => void} fetch method that will be called the first time the value of this observable is accessed. The provided sink can be used to produce a new value, synchronously or asynchronously
 * @param {T} [initialValue=undefined] optional initialValue that will be returned from `current` as long as the `sink` has not been called at least once
 * @returns {{
 *     current(): T,
 *     refresh(): T,
 *     reset(): T
 *     pending: boolean
 * }}
 */ function $0b637a582db6edc4$export$fa198792e96a6577(fetch, initialValue) {
    if (initialValue === void 0) initialValue = undefined;
    var started = false;
    var value = (0, $d8hWe.observable).box(initialValue, {
        deep: false
    });
    var pending = (0, $d8hWe.observable).box(false);
    var currentFnc = function() {
        if (!started) {
            started = true;
            (0, $d8hWe._allowStateChanges)(true, function() {
                pending.set(true);
            });
            fetch(function(newValue) {
                (0, $d8hWe._allowStateChanges)(true, function() {
                    value.set(newValue);
                    pending.set(false);
                });
            });
        }
        return value.get();
    };
    var resetFnc = (0, $d8hWe.action)("lazyObservable-reset", function() {
        started = false;
        value.set(initialValue);
        return value.get();
    });
    return {
        current: currentFnc,
        refresh: function() {
            if (started) {
                started = false;
                return currentFnc();
            } else return value.get();
        },
        reset: function() {
            return resetFnc();
        },
        get pending () {
            return pending.get();
        }
    };
}
/**
 * `fromResource` creates an observable whose current state can be inspected using `.current()`,
 * and which can be kept in sync with some external datasource that can be subscribed to.
 *
 * The created observable will only subscribe to the datasource if it is in use somewhere,
 * (un)subscribing when needed. To enable `fromResource` to do that two callbacks need to be provided,
 * one to subscribe, and one to unsubscribe. The subscribe callback itself will receive a `sink` callback, which can be used
 * to update the current state of the observable, allowing observes to react.
 *
 * Whatever is passed to `sink` will be returned by `current()`. The values passed to the sink will not be converted to
 * observables automatically, but feel free to do so.
 * It is the `current()` call itself which is being tracked,
 * so make sure that you don't dereference to early.
 *
 * For inspiration, an example integration with the apollo-client on [github](https://github.com/apollostack/apollo-client/issues/503#issuecomment-241101379),
 * or the [implementation](https://github.com/mobxjs/mobx-utils/blob/1d17cf7f7f5200937f68cc0b5e7ec7f3f71dccba/src/now.ts#L43-L57) of `mobxUtils.now`
 *
 * The following example code creates an observable that connects to a `dbUserRecord`,
 * which comes from an imaginary database and notifies when it has changed.
 *
 * @example
 * function createObservableUser(dbUserRecord) {
 *   let currentSubscription;
 *   return fromResource(
 *     (sink) => {
 *       // sink the current state
 *       sink(dbUserRecord.fields)
 *       // subscribe to the record, invoke the sink callback whenever new data arrives
 *       currentSubscription = dbUserRecord.onUpdated(() => {
 *         sink(dbUserRecord.fields)
 *       })
 *     },
 *     () => {
 *       // the user observable is not in use at the moment, unsubscribe (for now)
 *       dbUserRecord.unsubscribe(currentSubscription)
 *     }
 *   )
 * }
 *
 * // usage:
 * const myUserObservable = createObservableUser(myDatabaseConnector.query("name = 'Michel'"))
 *
 * // use the observable in autorun
 * autorun(() => {
 *   // printed everytime the database updates its records
 *   console.log(myUserObservable.current().displayName)
 * })
 *
 * // ... or a component
 * const userComponent = observer(({ user }) =>
 *   <div>{user.current().displayName}</div>
 * )
 *
 * @export
 * @template T
 * @param {(sink: (newValue: T) => void) => void} subscriber
 * @param {IDisposer} [unsubscriber=NOOP]
 * @param {T} [initialValue=undefined] the data that will be returned by `get()` until the `sink` has emitted its first data
 * @returns {{
 *     current(): T;
 *     dispose(): void;
 *     isAlive(): boolean;
 * }}
 */ function $0b637a582db6edc4$export$c5c49fce5ba0daad(subscriber, unsubscriber, initialValue) {
    if (unsubscriber === void 0) unsubscriber = $0b637a582db6edc4$export$5702a91a6f42969f;
    if (initialValue === void 0) initialValue = undefined;
    var isActive = false;
    var isDisposed = false;
    var value = initialValue;
    var suspender = function() {
        if (isActive) {
            isActive = false;
            unsubscriber();
        }
    };
    var atom = (0, $d8hWe.createAtom)("ResourceBasedObservable", function() {
        $0b637a582db6edc4$export$f5708dca728d7177(!isActive && !isDisposed);
        isActive = true;
        subscriber(function(newValue) {
            (0, $d8hWe._allowStateChanges)(true, function() {
                value = newValue;
                atom.reportChanged();
            });
        });
    }, suspender);
    return {
        current: function() {
            $0b637a582db6edc4$export$f5708dca728d7177(!isDisposed, "subscribingObservable has already been disposed");
            var isBeingTracked = atom.reportObserved();
            if (!isBeingTracked && !isActive) console.warn("Called `get` of a subscribingObservable outside a reaction. Current value will be returned but no new subscription has started");
            return value;
        },
        dispose: function() {
            isDisposed = true;
            suspender();
        },
        isAlive: function() {
            return isActive;
        }
    };
}
var $0b637a582db6edc4$var$__decorate = function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function $0b637a582db6edc4$var$observableSymbol() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}
/**
 * Converts an expression to an observable stream (a.k.a. TC 39 Observable / RxJS observable).
 * The provided expression is tracked by mobx as long as there are subscribers, automatically
 * emitting when new values become available. The expressions respect (trans)actions.
 *
 * @example
 *
 * const user = observable({
 *   firstName: "C.S",
 *   lastName: "Lewis"
 * })
 *
 * Rx.Observable
 *   .from(mobxUtils.toStream(() => user.firstname + user.lastName))
 *   .scan(nameChanges => nameChanges + 1, 0)
 *   .subscribe(nameChanges => console.log("Changed name ", nameChanges, "times"))
 *
 * @export
 * @template T
 * @param {() => T} expression
 * @param {boolean} fireImmediately (by default false)
 * @returns {IObservableStream<T>}
 */ function $0b637a582db6edc4$export$d4050479c73a24b(expression, fireImmediately) {
    var _a;
    if (fireImmediately === void 0) fireImmediately = false;
    var computedValue = (0, $d8hWe.computed)(expression);
    return _a = {
        subscribe: function(observer) {
            if ("function" === typeof observer) return {
                unsubscribe: (0, $d8hWe.observe)(computedValue, function(_a) {
                    var newValue = _a.newValue;
                    return observer(newValue);
                }, fireImmediately)
            };
            if (observer && "object" === typeof observer && observer.next) return {
                unsubscribe: (0, $d8hWe.observe)(computedValue, function(_a) {
                    var newValue = _a.newValue;
                    return observer.next(newValue);
                }, fireImmediately)
            };
            return {
                unsubscribe: function() {}
            };
        }
    }, _a[$0b637a582db6edc4$var$observableSymbol()] = function() {
        return this;
    }, _a;
}
var $0b637a582db6edc4$var$StreamListener = /** @class */ function() {
    function StreamListener(observable, initialValue) {
        var _this = this;
        Object.defineProperty(this, "current", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subscription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, $d8hWe.makeObservable)(this);
        (0, $d8hWe.runInAction)(function() {
            _this.current = initialValue;
            _this.subscription = observable.subscribe(_this);
        });
    }
    Object.defineProperty(StreamListener.prototype, "dispose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.subscription) this.subscription.unsubscribe();
        }
    });
    Object.defineProperty(StreamListener.prototype, "next", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value) {
            this.current = value;
        }
    });
    Object.defineProperty(StreamListener.prototype, "complete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.dispose();
        }
    });
    Object.defineProperty(StreamListener.prototype, "error", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value) {
            this.current = value;
            this.dispose();
        }
    });
    $0b637a582db6edc4$var$__decorate([
        (0, $d8hWe.observable).ref
    ], StreamListener.prototype, "current", void 0);
    $0b637a582db6edc4$var$__decorate([
        (0, $d8hWe.action).bound
    ], StreamListener.prototype, "next", null);
    $0b637a582db6edc4$var$__decorate([
        (0, $d8hWe.action).bound
    ], StreamListener.prototype, "complete", null);
    $0b637a582db6edc4$var$__decorate([
        (0, $d8hWe.action).bound
    ], StreamListener.prototype, "error", null);
    return StreamListener;
}();
function $0b637a582db6edc4$export$2c6bc52bcd2a369b(observable, initialValue) {
    if (initialValue === void 0) initialValue = undefined;
    return new $0b637a582db6edc4$var$StreamListener(observable, initialValue);
}
var $0b637a582db6edc4$var$__assign = function() {
    $0b637a582db6edc4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0b637a582db6edc4$var$__assign.apply(this, arguments);
};
var $0b637a582db6edc4$var$__decorate$1 = function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0b637a582db6edc4$var$RESERVED_NAMES = [
    "model",
    "reset",
    "submit",
    "isDirty",
    "isPropertyDirty",
    "resetProperty"
];
var $0b637a582db6edc4$export$a0505c1b7de1f868 = /** @class */ function() {
    function ViewModel(model) {
        var _this = this;
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: model
        });
        Object.defineProperty(this, "localValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $d8hWe.observable).map({})
        });
        Object.defineProperty(this, "localComputedValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $d8hWe.observable).map({})
        });
        Object.defineProperty(this, "isPropertyDirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(key) {
                return _this.localValues.has(key);
            }
        });
        (0, $d8hWe.makeObservable)(this);
        $0b637a582db6edc4$export$f5708dca728d7177((0, $d8hWe.isObservableObject)(model), "createViewModel expects an observable object");
        var ownMethodsAndProperties = $0b637a582db6edc4$export$a984b761acd10b55(this);
        // use this helper as Object.getOwnPropertyNames doesn't return getters
        $0b637a582db6edc4$export$a984b761acd10b55(model).forEach(function(key) {
            var _a;
            if (ownMethodsAndProperties.includes(key)) return;
            if (key === (0, $d8hWe.$mobx) || key === "__mobxDidRunLazyInitializers") return;
            $0b637a582db6edc4$export$f5708dca728d7177($0b637a582db6edc4$var$RESERVED_NAMES.indexOf(key) === -1, "The propertyname " + key + " is reserved and cannot be used with viewModels");
            if ((0, $d8hWe.isComputedProp)(model, key)) {
                var computedBox = (0, $d8hWe._getAdministration)(model, key); // Fixme: there is no clear api to get the derivation
                var get = computedBox.derivation.bind(_this);
                var set = (_a = computedBox.setter_) === null || _a === void 0 ? void 0 : _a.bind(_this);
                _this.localComputedValues.set(key, (0, $d8hWe.computed)(get, {
                    set: set
                }));
            }
            var descriptor = Object.getOwnPropertyDescriptor(model, key);
            var additionalDescriptor = descriptor ? {
                enumerable: descriptor.enumerable
            } : {};
            Object.defineProperty(_this, key, $0b637a582db6edc4$var$__assign($0b637a582db6edc4$var$__assign({}, additionalDescriptor), {
                configurable: true,
                get: function() {
                    if ((0, $d8hWe.isComputedProp)(model, key)) return _this.localComputedValues.get(key).get();
                    if (_this.isPropertyDirty(key)) return _this.localValues.get(key);
                    else return _this.model[key];
                },
                set: (0, $d8hWe.action)(function(value) {
                    if ((0, $d8hWe.isComputedProp)(model, key)) _this.localComputedValues.get(key).set(value);
                    else if (value !== _this.model[key]) _this.localValues.set(key, value);
                    else _this.localValues.delete(key);
                })
            }));
        });
    }
    Object.defineProperty(ViewModel.prototype, "isDirty", {
        get: function() {
            return this.localValues.size > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewModel.prototype, "changedValues", {
        get: function() {
            return new Map(this.localValues);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewModel.prototype, "submit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var _this = this;
            (0, $d8hWe.keys)(this.localValues).forEach(function(key) {
                var source = _this.localValues.get(key);
                var destination = _this.model[key];
                if ((0, $d8hWe.isObservableArray)(destination)) destination.replace(source);
                else if ((0, $d8hWe.isObservableMap)(destination)) {
                    destination.clear();
                    destination.merge(source);
                } else if (!(0, $d8hWe.isComputed)(source)) _this.model[key] = source;
            });
            this.localValues.clear();
        }
    });
    Object.defineProperty(ViewModel.prototype, "reset", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.localValues.clear();
        }
    });
    Object.defineProperty(ViewModel.prototype, "resetProperty", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            this.localValues.delete(key);
        }
    });
    $0b637a582db6edc4$var$__decorate$1([
        (0, $d8hWe.computed)
    ], ViewModel.prototype, "isDirty", null);
    $0b637a582db6edc4$var$__decorate$1([
        (0, $d8hWe.computed)
    ], ViewModel.prototype, "changedValues", null);
    $0b637a582db6edc4$var$__decorate$1([
        (0, $d8hWe.action).bound
    ], ViewModel.prototype, "submit", null);
    $0b637a582db6edc4$var$__decorate$1([
        (0, $d8hWe.action).bound
    ], ViewModel.prototype, "reset", null);
    $0b637a582db6edc4$var$__decorate$1([
        (0, $d8hWe.action).bound
    ], ViewModel.prototype, "resetProperty", null);
    return ViewModel;
}();
/**
 * `createViewModel` takes an object with observable properties (model)
 * and wraps a viewmodel around it. The viewmodel proxies all enumerable properties of the original model with the following behavior:
 *  - as long as no new value has been assigned to the viewmodel property, the original property will be returned.
 *  - any future change in the model will be visible in the viewmodel as well unless the viewmodel property was dirty at the time of the attempted change.
 *  - once a new value has been assigned to a property of the viewmodel, that value will be returned during a read of that property in the future. However, the original model remain untouched until `submit()` is called.
 *
 * The viewmodel exposes the following additional methods, besides all the enumerable properties of the model:
 * - `submit()`: copies all the values of the viewmodel to the model and resets the state
 * - `reset()`: resets the state of the viewmodel, abandoning all local modifications
 * - `resetProperty(propName)`: resets the specified property of the viewmodel
 * - `isDirty`: observable property indicating if the viewModel contains any modifications
 * - `isPropertyDirty(propName)`: returns true if the specified property is dirty
 * - `changedValues`: returns a key / value map with the properties that have been changed in the model so far
 * - `model`: The original model object for which this viewModel was created
 *
 * You may use observable arrays, maps and objects with `createViewModel` but keep in mind to assign fresh instances of those to the viewmodel's properties, otherwise you would end up modifying the properties of the original model.
 * Note that if you read a non-dirty property, viewmodel only proxies the read to the model. You therefore need to assign a fresh instance not only the first time you make the assignment but also after calling `reset()` or `submit()`.
 *
 * @example
 * class Todo {
 *   \@observable title = "Test"
 * }
 *
 * const model = new Todo()
 * const viewModel = createViewModel(model);
 *
 * autorun(() => console.log(viewModel.model.title, ",", viewModel.title))
 * // prints "Test, Test"
 * model.title = "Get coffee"
 * // prints "Get coffee, Get coffee", viewModel just proxies to model
 * viewModel.title = "Get tea"
 * // prints "Get coffee, Get tea", viewModel's title is now dirty, and the local value will be printed
 * viewModel.submit()
 * // prints "Get tea, Get tea", changes submitted from the viewModel to the model, viewModel is proxying again
 * viewModel.title = "Get cookie"
 * // prints "Get tea, Get cookie" // viewModel has diverged again
 * viewModel.reset()
 * // prints "Get tea, Get tea", changes of the viewModel have been abandoned
 *
 * @param {T} model
 * @returns {(T & IViewModel<T>)}
 * ```
 */ function $0b637a582db6edc4$export$313a9917afd1f6c1(model) {
    return new $0b637a582db6edc4$export$a0505c1b7de1f868(model);
}
/**
 * MobX normally suspends any computed value that is not in use by any reaction,
 * and lazily re-evaluates the expression if needed outside a reaction while not in use.
 * `keepAlive` marks a computed value as always in use, meaning that it will always fresh, but never disposed automatically.
 *
 * @example
 * const obj = observable({
 *   number: 3,
 *   doubler: function() { return this.number * 2 }
 * })
 * const stop = keepAlive(obj, "doubler")
 *
 * @param {Object} target an object that has a computed property, created by `@computed` or `extendObservable`
 * @param {string} property the name of the property to keep alive
 * @returns {IDisposer} stops this keep alive so that the computed value goes back to normal behavior
 */ /**
 * @example
 * const number = observable(3)
 * const doubler = computed(() => number.get() * 2)
 * const stop = keepAlive(doubler)
 * // doubler will now stay in sync reactively even when there are no further observers
 * stop()
 * // normal behavior, doubler results will be recomputed if not observed but needed, but lazily
 *
 * @param {IComputedValue<any>} computedValue created using the `computed` function
 * @returns {IDisposer} stops this keep alive so that the computed value goes back to normal behavior
 */ function $0b637a582db6edc4$export$a1c7a439f47575e5(_1, _2) {
    var computed = (0, $d8hWe.getAtom)(_1, _2);
    if (!computed) throw new Error("No computed provided, please provide an object created with `computed(() => expr)` or an object + property name");
    return (0, $d8hWe.observe)(computed, function() {});
}
/**
 * `queueProcessor` takes an observable array, observes it and calls `processor`
 * once for each item added to the observable array, optionally debouncing the action
 *
 * @example
 * const pendingNotifications = observable([])
 * const stop = queueProcessor(pendingNotifications, msg => {
 *   // show Desktop notification
 *   new Notification(msg);
 * })
 *
 * // usage:
 * pendingNotifications.push("test!")
 *
 * @param {T[]} observableArray observable array instance to track
 * @param {(item: T) => void} processor action to call per item
 * @param {number} [debounce=0] optional debounce time in ms. With debounce 0 the processor will run synchronously
 * @returns {IDisposer} stops the processor
 */ function $0b637a582db6edc4$export$2b2a82cc67fc06db(observableArray, processor, debounce) {
    if (debounce === void 0) debounce = 0;
    if (!(0, $d8hWe.isObservableArray)(observableArray)) throw new Error("Expected observable array as first argument");
    if (!(0, $d8hWe.isAction)(processor)) processor = (0, $d8hWe.action)("queueProcessor", processor);
    var runner = function() {
        // construct a final set
        var items = observableArray.slice(0);
        // clear the queue for next iteration
        (0, $d8hWe.runInAction)(function() {
            return observableArray.splice(0);
        });
        // fire processor
        items.forEach(processor);
    };
    if (debounce > 0) return (0, $d8hWe.autorun)(runner, {
        delay: debounce
    });
    else return (0, $d8hWe.autorun)(runner);
}
/**
 * `chunkProcessor` takes an observable array, observes it and calls `processor`
 * once for a chunk of items added to the observable array, optionally deboucing the action.
 * The maximum chunk size can be limited by number.
 * This allows both, splitting larger into smaller chunks or (when debounced) combining smaller
 * chunks and/or single items into reasonable chunks of work.
 *
 * @example
 * const trackedActions = observable([])
 * const stop = chunkProcessor(trackedActions, chunkOfMax10Items => {
 *   sendTrackedActionsToServer(chunkOfMax10Items);
 * }, 100, 10)
 *
 * // usage:
 * trackedActions.push("scrolled")
 * trackedActions.push("hoveredButton")
 * // when both pushes happen within 100ms, there will be only one call to server
 *
 * @param {T[]} observableArray observable array instance to track
 * @param {(item: T[]) => void} processor action to call per item
 * @param {number} [debounce=0] optional debounce time in ms. With debounce 0 the processor will run synchronously
 * @param {number} [maxChunkSize=0] optionally do not call on full array but smaller chunks. With 0 it will process the full array.
 * @returns {IDisposer} stops the processor
 */ function $0b637a582db6edc4$export$8430f878cdcb7e2f(observableArray, processor, debounce, maxChunkSize) {
    if (debounce === void 0) debounce = 0;
    if (maxChunkSize === void 0) maxChunkSize = 0;
    if (!(0, $d8hWe.isObservableArray)(observableArray)) throw new Error("Expected observable array as first argument");
    if (!(0, $d8hWe.isAction)(processor)) processor = (0, $d8hWe.action)("chunkProcessor", processor);
    var runner = function() {
        var _loop_1 = function() {
            var chunkSize = maxChunkSize === 0 ? observableArray.length : Math.min(observableArray.length, maxChunkSize);
            // construct a final set
            var items = observableArray.slice(0, chunkSize);
            // clear the slice for next iteration
            (0, $d8hWe.runInAction)(function() {
                return observableArray.splice(0, chunkSize);
            });
            // fire processor
            processor(items);
        };
        while(observableArray.length > 0)_loop_1();
    };
    if (debounce > 0) return (0, $d8hWe.autorun)(runner, {
        delay: debounce
    });
    else return (0, $d8hWe.autorun)(runner);
}
var $0b637a582db6edc4$var$tickers = {};
/**
 * Disposes of all the internal Observables created by invocations of `now()`.
 *
 * The use case for this is to ensure that unit tests can run independent of each other.
 * You should not call this in regular application code.
 *
 * @example
 * afterEach(() => {
 *     utils.resetNowInternalState()
 * })
 */ function $0b637a582db6edc4$export$63951e38944358c9() {
    for(var _i = 0, _a = Object.getOwnPropertyNames($0b637a582db6edc4$var$tickers); _i < _a.length; _i++){
        var key = _a[_i];
        $0b637a582db6edc4$var$tickers[key].dispose();
        delete $0b637a582db6edc4$var$tickers[key];
    }
}
/**
 * Returns the current date time as epoch number.
 * The date time is read from an observable which is updated automatically after the given interval.
 * So basically it treats time as an observable.
 *
 * The function takes an interval as parameter, which indicates how often `now()` will return a new value.
 * If no interval is given, it will update each second. If "frame" is specified, it will update each time a
 * `requestAnimationFrame` is available.
 *
 * Multiple clocks with the same interval will automatically be synchronized.
 *
 * Countdown example: https://jsfiddle.net/mweststrate/na0qdmkw/
 *
 * @example
 *
 * const start = Date.now()
 *
 * autorun(() => {
 *   console.log("Seconds elapsed: ", (mobxUtils.now() - start) / 1000)
 * })
 *
 *
 * @export
 * @param {(number | "frame")} [interval=1000] interval in milliseconds about how often the interval should update
 * @returns
 */ function $0b637a582db6edc4$export$461939dd4422153(interval) {
    if (interval === void 0) interval = 1000;
    if (!(0, $d8hWe._isComputingDerivation)()) // See #40
    return Date.now();
    if (!$0b637a582db6edc4$var$tickers[interval]) {
        if (typeof interval === "number") $0b637a582db6edc4$var$tickers[interval] = $0b637a582db6edc4$var$createIntervalTicker(interval);
        else $0b637a582db6edc4$var$tickers[interval] = $0b637a582db6edc4$var$createAnimationFrameTicker();
    }
    return $0b637a582db6edc4$var$tickers[interval].current();
}
function $0b637a582db6edc4$var$createIntervalTicker(interval) {
    var subscriptionHandle;
    return $0b637a582db6edc4$export$c5c49fce5ba0daad(function(sink) {
        sink(Date.now());
        subscriptionHandle = setInterval(function() {
            return sink(Date.now());
        }, interval);
    }, function() {
        clearInterval(subscriptionHandle);
    }, Date.now());
}
function $0b637a582db6edc4$var$createAnimationFrameTicker() {
    var frameBasedTicker = $0b637a582db6edc4$export$c5c49fce5ba0daad(function(sink) {
        sink(Date.now());
        function scheduleTick() {
            window.requestAnimationFrame(function() {
                sink(Date.now());
                if (frameBasedTicker.isAlive()) scheduleTick();
            });
        }
        scheduleTick();
    }, function() {}, Date.now());
    return frameBasedTicker;
}
/**
 *`expr` can be used to create temporary computed values inside computed values.
 * Nesting computed values is useful to create cheap computations in order to prevent expensive computations from needing to run.
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * `expr(func)` is an alias for `computed(func).get()`.
 * Please note that the function given to `expr` is evaluated _twice_ in the scenario that the overall expression value changes.
 * It is evaluated the first time when any observables it depends on change.
 * It is evaluated a second time when a change in its value triggers the outer computed or reaction to evaluate, which recreates and reevaluates the expression.
 *
 * In the following example, the expression prevents the `TodoView` component from being re-rendered if the selection changes elsewhere.
 * Instead, the component will only re-render when the relevant todo is (de)selected, which happens much less frequently.
 *
 * @example
 * const Todo = observer((props) => {
 *     const todo = props.todo
 *     const isSelected = mobxUtils.expr(() => props.viewState.selection === todo)
 * const TodoView = observer(({ todo, editorState }) => {
 *     const isSelected = mobxUtils.expr(() => editorState.selection === todo)
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * })
 */ function $0b637a582db6edc4$export$dce8637ca0d755f(expr) {
    if (!(0, $d8hWe._isComputingDerivation)()) console.warn("'expr' should only be used inside other reactive functions.");
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return (0, $d8hWe.computed)(expr).get();
}
var $0b637a582db6edc4$var$__assign$1 = function() {
    $0b637a582db6edc4$var$__assign$1 = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0b637a582db6edc4$var$__assign$1.apply(this, arguments);
};
var $0b637a582db6edc4$var$memoizationId = 0;
/**
 * Creates a function that maps an object to a view.
 * The mapping is memoized.
 *
 * See the [transformer](#createtransformer-in-detail) section for more details.
 *
 * @param transformer
 * @param onCleanup
 */ function $0b637a582db6edc4$export$9591aa59b8e3deeb(transformer, arg2) {
    $0b637a582db6edc4$export$f5708dca728d7177(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var views = {};
    var onCleanup = undefined;
    var keepAlive = false;
    var debugNameGenerator = undefined;
    if (typeof arg2 === "object") {
        onCleanup = arg2.onCleanup;
        keepAlive = arg2.keepAlive !== undefined ? arg2.keepAlive : false;
        debugNameGenerator = arg2.debugNameGenerator;
    } else if (typeof arg2 === "function") onCleanup = arg2;
    function createView(sourceIdentifier, sourceObject) {
        var latestValue;
        var computedValueOptions = {};
        if (typeof arg2 === "object") {
            onCleanup = arg2.onCleanup;
            debugNameGenerator = arg2.debugNameGenerator;
            computedValueOptions = arg2;
        } else if (typeof arg2 === "function") onCleanup = arg2;
        else {
            onCleanup = undefined;
            debugNameGenerator = undefined;
        }
        var prettifiedName = debugNameGenerator ? debugNameGenerator(sourceObject) : "Transformer-" + transformer.name + "-" + sourceIdentifier;
        var expr = (0, $d8hWe.computed)(function() {
            return latestValue = transformer(sourceObject);
        }, $0b637a582db6edc4$var$__assign$1($0b637a582db6edc4$var$__assign$1({}, computedValueOptions), {
            name: prettifiedName
        }));
        if (!keepAlive) var disposer_1 = (0, $d8hWe.onBecomeUnobserved)(expr, function() {
            delete views[sourceIdentifier];
            disposer_1();
            if (onCleanup) onCleanup(latestValue, sourceObject);
        });
        return expr;
    }
    var memoWarned = false;
    return function(object) {
        var identifier = $0b637a582db6edc4$var$getMemoizationId(object);
        var reactiveView = views[identifier];
        if (reactiveView) return reactiveView.get();
        if (!keepAlive && !(0, $d8hWe._isComputingDerivation)()) {
            if (!memoWarned) {
                console.warn("invoking a transformer from outside a reactive context won't memorized and is cleaned up immediately, unless keepAlive is set");
                memoWarned = true;
            }
            var value = transformer(object);
            if (onCleanup) onCleanup(value, object);
            return value;
        }
        // Not in cache; create a reactive view
        reactiveView = views[identifier] = createView(identifier, object);
        return reactiveView.get();
    };
}
function $0b637a582db6edc4$var$getMemoizationId(object) {
    var objectType = typeof object;
    if (objectType === "string") return "string:" + object;
    if (objectType === "number") return "number:" + object;
    if (object === null || objectType !== "object" && objectType !== "function") throw new Error("[mobx-utils] transform expected an object, function, string or number, got: " + String(object));
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = "memoizationId:" + ++$0b637a582db6edc4$var$memoizationId;
        $0b637a582db6edc4$export$edfd600d9920791e(object, "$transformId", tid);
    }
    return tid;
}
function $0b637a582db6edc4$var$buildPath(entry) {
    if (!entry) return "ROOT";
    var res = [];
    while(entry.parent){
        res.push(entry.path);
        entry = entry.parent;
    }
    return res.reverse().join("/");
}
function $0b637a582db6edc4$var$isRecursivelyObservable(thing) {
    return (0, $d8hWe.isObservableObject)(thing) || (0, $d8hWe.isObservableArray)(thing) || (0, $d8hWe.isObservableMap)(thing);
}
/**
 * Given an object, deeply observes the given object.
 * It is like `observe` from mobx, but applied recursively, including all future children.
 *
 * Note that the given object cannot ever contain cycles and should be a tree.
 *
 * As benefit: path and root will be provided in the callback, so the signature of the listener is
 * (change, path, root) => void
 *
 * The returned disposer can be invoked to clean up the listener
 *
 * deepObserve cannot be used on computed values.
 *
 * @example
 * const disposer = deepObserve(target, (change, path) => {
 *    console.dir(change)
 * })
 */ function $0b637a582db6edc4$export$d026ecd6f7c99c26(target, listener) {
    var entrySet = new WeakMap();
    function genericListener(change) {
        var entry = entrySet.get(change.object);
        processChange(change, entry);
        listener(change, $0b637a582db6edc4$var$buildPath(entry), target);
    }
    function processChange(change, parent) {
        switch(change.type){
            // Object changes
            case "add":
                observeRecursively(change.newValue, parent, change.name);
                break;
            case "update":
                unobserveRecursively(change.oldValue);
                observeRecursively(change.newValue, parent, change.name || "" + change.index);
                break;
            case "remove":
            case "delete":
                unobserveRecursively(change.oldValue);
                break;
            // Array changes
            case "splice":
                change.removed.map(unobserveRecursively);
                change.added.forEach(function(value, idx) {
                    return observeRecursively(value, parent, "" + (change.index + idx));
                });
                // update paths
                for(var i = change.index + change.addedCount; i < change.object.length; i++)if ($0b637a582db6edc4$var$isRecursivelyObservable(change.object[i])) {
                    var entry = entrySet.get(change.object[i]);
                    if (entry) entry.path = "" + i;
                }
                break;
        }
    }
    function observeRecursively(thing, parent, path) {
        if ($0b637a582db6edc4$var$isRecursivelyObservable(thing)) {
            var entry = entrySet.get(thing);
            if (entry) {
                if (entry.parent !== parent || entry.path !== path) // MWE: this constraint is artificial, and this tool could be made to work with cycles,
                // but it increases administration complexity, has tricky edge cases and the meaning of 'path'
                // would become less clear. So doesn't seem to be needed for now
                throw new Error("The same observable object cannot appear twice in the same tree," + (" trying to assign it to '" + $0b637a582db6edc4$var$buildPath(parent) + "/" + path + "',") + (" but it already exists at '" + $0b637a582db6edc4$var$buildPath(entry.parent) + "/" + entry.path + "'"));
            } else {
                var entry_1 = {
                    parent: parent,
                    path: path,
                    dispose: (0, $d8hWe.observe)(thing, genericListener)
                };
                entrySet.set(thing, entry_1);
                (0, $d8hWe.entries)(thing).forEach(function(_a) {
                    var key = _a[0], value = _a[1];
                    return observeRecursively(value, entry_1, key);
                });
            }
        }
    }
    function unobserveRecursively(thing) {
        if ($0b637a582db6edc4$var$isRecursivelyObservable(thing)) {
            var entry = entrySet.get(thing);
            if (!entry) return;
            entrySet.delete(thing);
            entry.dispose();
            (0, $d8hWe.values)(thing).forEach(unobserveRecursively);
        }
    }
    observeRecursively(target, undefined, "");
    return function() {
        unobserveRecursively(target);
    };
}
var $0b637a582db6edc4$var$__extends = function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Reactively sorts a base observable array into multiple observable arrays based on the value of a
 * `groupBy: (item: T) => G` function.
 *
 * This observes the individual computed groupBy values and only updates the source and dest arrays
 * when there is an actual change, so this is far more efficient than, for example
 * `base.filter(i => groupBy(i) === 'we')`. Call #dispose() to stop tracking.
 *
 * No guarantees are made about the order of items in the grouped arrays.
 *
 * The resulting map of arrays is read-only. clear(), set(), delete() are not supported and
 * modifying the group arrays will lead to undefined behavior.
 *
 * NB: ObservableGroupMap relies on `Symbol`s. If you are targeting a platform which doesn't
 * support these natively, you will need to provide a polyfill.
 *
 * @param {array} base The array to sort into groups.
 * @param {function} groupBy The function used for grouping.
 * @param options Object with properties:
 *  `name`: Debug name of this ObservableGroupMap.
 *  `keyToName`: Function to create the debug names of the observable group arrays.
 *
 * @example
 * const slices = observable([
 *     { day: "mo", hours: 12 },
 *     { day: "tu", hours: 2 },
 * ])
 * const slicesByDay = new ObservableGroupMap(slices, (slice) => slice.day)
 * autorun(() => console.log(
 *     slicesByDay.get("mo")?.length ?? 0,
 *     slicesByDay.get("we"))) // outputs 1, undefined
 * slices[0].day = "we" // outputs 0, [{ day: "we", hours: 12 }]
 */ var $0b637a582db6edc4$export$f8edb9738c5f010e = /** @class */ function(_super) {
    $0b637a582db6edc4$var$__extends(ObservableGroupMap, _super);
    function ObservableGroupMap(base, groupBy, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.name, name = _c === void 0 ? "ogm" + (Math.random() * 1000 | 0) : _c, _d = _b.keyToName, keyToName = _d === void 0 ? function(x) {
            return "" + x;
        } : _d;
        var _this = _super.call(this) || this;
        /**
         * Base observable array which is being sorted into groups.
         */ Object.defineProperty(_this, "_base", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * The ObservableGroupMap needs to track some state per-item. This is the name/symbol of the
         * property used to attach the state.
         */ Object.defineProperty(_this, "_ogmInfoKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * The function used to group the items.
         */ Object.defineProperty(_this, "_groupBy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * This function is used to generate the mobx debug names of the observable group arrays.
         */ Object.defineProperty(_this, "_keyToName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_disposeBaseObserver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this._keyToName = keyToName;
        _this._groupBy = groupBy;
        _this._ogmInfoKey = Symbol("ogmInfo" + name);
        _this._base = base;
        for(var i = 0; i < base.length; i++)_this._addItem(base[i]);
        _this._disposeBaseObserver = (0, $d8hWe.observe)(_this._base, function(change) {
            if ("splice" === change.type) (0, $d8hWe.transaction)(function() {
                for(var _i = 0, _a = change.removed; _i < _a.length; _i++){
                    var removed = _a[_i];
                    _this._removeItem(removed);
                }
                for(var _b = 0, _c = change.added; _b < _c.length; _b++){
                    var added = _c[_b];
                    _this._addItem(added);
                }
            });
            else if ("update" === change.type) (0, $d8hWe.transaction)(function() {
                _this._removeItem(change.oldValue);
                _this._addItem(change.newValue);
            });
            else throw new Error("illegal state");
        });
        return _this;
    }
    Object.defineProperty(ObservableGroupMap.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            throw new Error("not supported");
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(_key) {
            throw new Error("not supported");
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "set", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(_key, _value) {
            throw new Error("not supported");
        }
    });
    /**
     * Disposes all observers created during construction and removes state added to base array
     * items.
     */ Object.defineProperty(ObservableGroupMap.prototype, "dispose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this._disposeBaseObserver();
            for(var i = 0; i < this._base.length; i++){
                var item = this._base[i];
                var grouperItemInfo = item[this._ogmInfoKey];
                grouperItemInfo.reaction();
                delete item[this._ogmInfoKey];
            }
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "_getGroupArr", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            var result = _super.prototype.get.call(this, key);
            if (undefined === result) {
                result = (0, $d8hWe.observable)([], {
                    name: "GroupArray[" + this._keyToName(key) + "]",
                    deep: false
                });
                _super.prototype.set.call(this, key, result);
            }
            return result;
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "_removeFromGroupArr", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key, itemIndex) {
            var arr = _super.prototype.get.call(this, key);
            if (1 === arr.length) _super.prototype.delete.call(this, key);
            else if (itemIndex === arr.length - 1) // last position in array
            arr.length--;
            else {
                arr[itemIndex] = arr[arr.length - 1];
                arr[itemIndex][this._ogmInfoKey].groupArrIndex = itemIndex;
                arr.length--;
            }
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "_addItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(item) {
            var _this = this;
            var groupByValue = this._groupBy(item);
            var groupArr = this._getGroupArr(groupByValue);
            var value = {
                groupByValue: groupByValue,
                groupArrIndex: groupArr.length,
                reaction: (0, $d8hWe.reaction)(function() {
                    return _this._groupBy(item);
                }, function(newGroupByValue, _r) {
                    var grouperItemInfo = item[_this._ogmInfoKey];
                    _this._removeFromGroupArr(grouperItemInfo.groupByValue, grouperItemInfo.groupArrIndex);
                    var newGroupArr = _this._getGroupArr(newGroupByValue);
                    var newGroupArrIndex = newGroupArr.length;
                    newGroupArr.push(item);
                    grouperItemInfo.groupByValue = newGroupByValue;
                    grouperItemInfo.groupArrIndex = newGroupArrIndex;
                })
            };
            Object.defineProperty(item, this._ogmInfoKey, {
                configurable: true,
                enumerable: false,
                value: value
            });
            groupArr.push(item);
        }
    });
    Object.defineProperty(ObservableGroupMap.prototype, "_removeItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(item) {
            var grouperItemInfo = item[this._ogmInfoKey];
            this._removeFromGroupArr(grouperItemInfo.groupByValue, grouperItemInfo.groupArrIndex);
            grouperItemInfo.reaction();
            delete item[this._ogmInfoKey];
        }
    });
    return ObservableGroupMap;
}((0, $d8hWe.ObservableMap));
/**
 * @private
 */ var $0b637a582db6edc4$var$DeepMapEntry = /** @class */ function() {
    function DeepMapEntry(base, args) {
        Object.defineProperty(this, "base", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: args
        });
        Object.defineProperty(this, "root", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closestIdx", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "isDisposed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        var current = this.closest = this.root = base;
        var i = 0;
        for(; i < this.args.length - 1; i++){
            current = current.get(args[i]);
            if (current) this.closest = current;
            else break;
        }
        this.closestIdx = i;
    }
    Object.defineProperty(DeepMapEntry.prototype, "exists", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.assertNotDisposed();
            var l = this.args.length;
            return this.closestIdx >= l - 1 && this.closest.has(this.args[l - 1]);
        }
    });
    Object.defineProperty(DeepMapEntry.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.assertNotDisposed();
            if (!this.exists()) throw new Error("Entry doesn't exist");
            return this.closest.get(this.args[this.args.length - 1]);
        }
    });
    Object.defineProperty(DeepMapEntry.prototype, "set", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value) {
            this.assertNotDisposed();
            var l = this.args.length;
            var current = this.closest;
            // create remaining maps
            for(var i = this.closestIdx; i < l - 1; i++){
                var m = new Map();
                current.set(this.args[i], m);
                current = m;
            }
            this.closestIdx = l - 1;
            this.closest = current;
            current.set(this.args[l - 1], value);
        }
    });
    Object.defineProperty(DeepMapEntry.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.assertNotDisposed();
            if (!this.exists()) throw new Error("Entry doesn't exist");
            var l = this.args.length;
            this.closest.delete(this.args[l - 1]);
            // clean up remaining maps if needed (reconstruct stack first)
            var c = this.root;
            var maps = [
                c
            ];
            for(var i = 0; i < l - 1; i++){
                c = c.get(this.args[i]);
                maps.push(c);
            }
            for(var i = maps.length - 1; i > 0; i--)if (maps[i].size === 0) maps[i - 1].delete(this.args[i - 1]);
            this.isDisposed = true;
        }
    });
    Object.defineProperty(DeepMapEntry.prototype, "assertNotDisposed", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            // TODO: once this becomes annoying, we should introduce a reset method to re-run the constructor logic
            if (this.isDisposed) throw new Error("Concurrent modification exception");
        }
    });
    return DeepMapEntry;
}();
/**
 * @private
 */ var $0b637a582db6edc4$var$DeepMap = /** @class */ function() {
    function DeepMap() {
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "argsLength", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: -1
        });
        Object.defineProperty(this, "last", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(DeepMap.prototype, "entry", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(args) {
            if (this.argsLength === -1) this.argsLength = args.length;
            else if (this.argsLength !== args.length) throw new Error("DeepMap should be used with functions with a consistent length, expected: " + this.argsLength + ", got: " + args.length);
            if (this.last) this.last.isDisposed = true;
            return this.last = new $0b637a582db6edc4$var$DeepMapEntry(this.store, args);
        }
    });
    return DeepMap;
}();
var $0b637a582db6edc4$var$__assign$2 = function() {
    $0b637a582db6edc4$var$__assign$2 = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0b637a582db6edc4$var$__assign$2.apply(this, arguments);
};
var $0b637a582db6edc4$var$__spreadArrays$1 = function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
/**
 * computedFn takes a function with an arbitrary amount of arguments,
 * and memoizes the output of the function based on the arguments passed in.
 *
 * computedFn(fn) returns a function with the very same signature. There is no limit on the amount of arguments
 * that is accepted. However, the amount of arguments must be constant and default arguments are not supported.
 *
 * By default the output of a function call will only be memoized as long as the
 * output is being observed.
 *
 * The function passes into `computedFn` should be pure, not be an action and only be relying on
 * observables.
 *
 * Setting `keepAlive` to `true` will cause the output to be forcefully cached forever.
 * Note that this might introduce memory leaks!
 *
 * @example
 * const store = observable({
    a: 1,
    b: 2,
    c: 3,
    m: computedFn(function(x) {
      return this.a * this.b * x
    })
  })

  const d = autorun(() => {
    // store.m(3) will be cached as long as this autorun is running
    console.log(store.m(3) * store.c)
  })
 *
 * @param fn
 * @param keepAliveOrOptions
 */ function $0b637a582db6edc4$export$79a1d35ba0cac8da(fn, keepAliveOrOptions) {
    if (keepAliveOrOptions === void 0) keepAliveOrOptions = false;
    if ((0, $d8hWe.isAction)(fn)) throw new Error("computedFn shouldn't be used on actions");
    var memoWarned = false;
    var i = 0;
    var opts = typeof keepAliveOrOptions === "boolean" ? {
        keepAlive: keepAliveOrOptions
    } : keepAliveOrOptions;
    var d = new $0b637a582db6edc4$var$DeepMap();
    return function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var entry = d.entry(args);
        // cache hit, return
        if (entry.exists()) return entry.get().get();
        // if function is invoked, and its a cache miss without reactive, there is no point in caching...
        if (!opts.keepAlive && !(0, $d8hWe._isComputingDerivation)()) {
            if (!memoWarned && (0, $d8hWe._getGlobalState)().computedRequiresReaction) {
                console.warn("invoking a computedFn from outside an reactive context won't be memoized, unless keepAlive is set");
                memoWarned = true;
            }
            return fn.apply(this, args);
        }
        // create new entry
        var latestValue;
        var c = (0, $d8hWe.computed)(function() {
            return latestValue = fn.apply(_this, args);
        }, $0b637a582db6edc4$var$__assign$2($0b637a582db6edc4$var$__assign$2({}, opts), {
            name: "computedFn(" + (opts.name || fn.name) + "#" + ++i + ")"
        }));
        entry.set(c);
        // clean up if no longer observed
        if (!opts.keepAlive) (0, $d8hWe.onBecomeUnobserved)(c, function() {
            d.entry(args).delete();
            if (opts.onCleanup) opts.onCleanup.apply(opts, $0b637a582db6edc4$var$__spreadArrays$1([
                latestValue
            ], args));
            latestValue = undefined;
        });
        // return current val
        return c.get();
    };
}

});





parcelRegister("5Rhbi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $443f3ad6a95030fc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MonthlyRevenueCellCollectionClass", function () { return $443f3ad6a95030fc$export$b2adacc0b3733cd1; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $7LXW5 = parcelRequire("7LXW5");
var $443f3ad6a95030fc$var$_dec, $443f3ad6a95030fc$var$_dec2, $443f3ad6a95030fc$var$_class;
function $443f3ad6a95030fc$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $443f3ad6a95030fc$var$MonthlyRevenueCellCollection = ($443f3ad6a95030fc$var$_dec = (0, $d8hWe.action).bound, $443f3ad6a95030fc$var$_dec2 = (0, $d8hWe.action).bound, $443f3ad6a95030fc$var$_class = class MonthlyRevenueCellCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "monthlyRevenueCells",
            modelClass: (0, $7LXW5.default)
        });
        this.addLookup("cellsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByType", "manyByKey", {
            key: (t)=>t.type,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get cellsById() {
        return this.modelsById;
    }
    get cells() {
        return this.models;
    }
    addCell(data, options) {
        return this.add(data, options);
    }
    addCells(data, options) {
        return this.addMany(data, options);
    }
}, $443f3ad6a95030fc$var$_applyDecoratedDescriptor($443f3ad6a95030fc$var$_class.prototype, "addCell", [
    $443f3ad6a95030fc$var$_dec
], Object.getOwnPropertyDescriptor($443f3ad6a95030fc$var$_class.prototype, "addCell"), $443f3ad6a95030fc$var$_class.prototype), $443f3ad6a95030fc$var$_applyDecoratedDescriptor($443f3ad6a95030fc$var$_class.prototype, "addCells", [
    $443f3ad6a95030fc$var$_dec2
], Object.getOwnPropertyDescriptor($443f3ad6a95030fc$var$_class.prototype, "addCells"), $443f3ad6a95030fc$var$_class.prototype), $443f3ad6a95030fc$var$_class);
var $443f3ad6a95030fc$export$2e2bcd8739ae039 = new $443f3ad6a95030fc$var$MonthlyRevenueCellCollection();
const $443f3ad6a95030fc$export$b2adacc0b3733cd1 = $443f3ad6a95030fc$var$MonthlyRevenueCellCollection;

});
parcelRegister("7LXW5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a8b6a349f88a319$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $5Rhbi = parcelRequire("5Rhbi");

var $fqmGV = parcelRequire("fqmGV");

var $egx7S = parcelRequire("egx7S");

var $lUr4c = parcelRequire("lUr4c");
var $5a8b6a349f88a319$var$_class, $5a8b6a349f88a319$var$_descriptor, $5a8b6a349f88a319$var$_descriptor2, $5a8b6a349f88a319$var$_descriptor3, $5a8b6a349f88a319$var$_descriptor4, $5a8b6a349f88a319$var$_descriptor5, $5a8b6a349f88a319$var$_descriptor6, $5a8b6a349f88a319$var$_descriptor7, $5a8b6a349f88a319$var$_descriptor8, $5a8b6a349f88a319$var$_descriptor9, $5a8b6a349f88a319$var$_descriptor10;
function $5a8b6a349f88a319$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $5a8b6a349f88a319$var$_defineProperty(e, r, t) {
    return (r = $5a8b6a349f88a319$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5a8b6a349f88a319$var$_toPropertyKey(t) {
    var i = $5a8b6a349f88a319$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5a8b6a349f88a319$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5a8b6a349f88a319$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $5a8b6a349f88a319$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $5a8b6a349f88a319$var$MonthlyRevenueCellModel = ($5a8b6a349f88a319$var$_class = class MonthlyRevenueCellModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "month", $5a8b6a349f88a319$var$_descriptor, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "revenue", $5a8b6a349f88a319$var$_descriptor2, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "revenueToDate", $5a8b6a349f88a319$var$_descriptor3, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "status", $5a8b6a349f88a319$var$_descriptor4, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "projectId", $5a8b6a349f88a319$var$_descriptor5, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "phaseId", $5a8b6a349f88a319$var$_descriptor6, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "phaseTitle", $5a8b6a349f88a319$var$_descriptor7, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "ownerId", $5a8b6a349f88a319$var$_descriptor8, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "costCentreId", $5a8b6a349f88a319$var$_descriptor9, this);
        $5a8b6a349f88a319$var$_initializerDefineProperty(this, "type", $5a8b6a349f88a319$var$_descriptor10, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $5Rhbi.default);
        this.init(data, options);
        const rowId = `('${this.status}', '${this.projectId}', '${this.phaseId}')`;
        const row = (0, $lUr4c.default).rowsById[rowId];
        if (!row) (0, $lUr4c.default).addRow({
            id: rowId,
            status: this.status,
            projectId: this.projectId,
            phaseId: this.phaseId,
            phaseTitle: this.phaseTitle,
            groups: [
                "status",
                "project",
                "phase"
            ]
        }, {
            trackUpdates: false
        });
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    serialize() {
        return {
            id: this.id,
            month: this.month,
            revenue: this.revenue,
            projectId: this.projectId,
            phaseId: this.phaseId
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
    get date() {
        return (0, $egx7S.startOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
}, $5a8b6a349f88a319$var$_descriptor = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "month", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5a8b6a349f88a319$var$_descriptor2 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "revenue", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $5a8b6a349f88a319$var$_descriptor3 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "revenueToDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $5a8b6a349f88a319$var$_descriptor4 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "status", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5a8b6a349f88a319$var$_descriptor5 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5a8b6a349f88a319$var$_descriptor6 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5a8b6a349f88a319$var$_descriptor7 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "phaseTitle", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5a8b6a349f88a319$var$_descriptor8 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "ownerId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5a8b6a349f88a319$var$_descriptor9 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "costCentreId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5a8b6a349f88a319$var$_descriptor10 = $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "type", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($5a8b6a349f88a319$var$_class.prototype, "phase"), $5a8b6a349f88a319$var$_class.prototype), $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($5a8b6a349f88a319$var$_class.prototype, "project"), $5a8b6a349f88a319$var$_class.prototype), $5a8b6a349f88a319$var$_applyDecoratedDescriptor($5a8b6a349f88a319$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($5a8b6a349f88a319$var$_class.prototype, "date"), $5a8b6a349f88a319$var$_class.prototype), $5a8b6a349f88a319$var$_class);
var $5a8b6a349f88a319$export$2e2bcd8739ae039 = $5a8b6a349f88a319$var$MonthlyRevenueCellModel;

});
parcelRegister("lUr4c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff33d2d9a6679ea3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "RevenueRowCollectionClass", function () { return $ff33d2d9a6679ea3$export$eeeec0570e0f8690; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $2YQIp = parcelRequire("2YQIp");
var $ff33d2d9a6679ea3$var$_dec, $ff33d2d9a6679ea3$var$_dec2, $ff33d2d9a6679ea3$var$_class;
function $ff33d2d9a6679ea3$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $ff33d2d9a6679ea3$var$RevenueRowCollection = ($ff33d2d9a6679ea3$var$_dec = (0, $d8hWe.action).bound, $ff33d2d9a6679ea3$var$_dec2 = (0, $d8hWe.action).bound, $ff33d2d9a6679ea3$var$_class = class RevenueRowCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "revenueRows",
            modelClass: (0, $2YQIp.default)
        });
        this.addLookup("rowsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("leafRows", "list", {
            filter: (m)=>{
                return m.isLeaf;
            }
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get rowsById() {
        return this.modelsById;
    }
    get rows() {
        return this.models;
    }
    addRow(data) {
        return this.add(data);
    }
    addRows(data) {
        return this.addMany(data);
    }
}, $ff33d2d9a6679ea3$var$_applyDecoratedDescriptor($ff33d2d9a6679ea3$var$_class.prototype, "addRow", [
    $ff33d2d9a6679ea3$var$_dec
], Object.getOwnPropertyDescriptor($ff33d2d9a6679ea3$var$_class.prototype, "addRow"), $ff33d2d9a6679ea3$var$_class.prototype), $ff33d2d9a6679ea3$var$_applyDecoratedDescriptor($ff33d2d9a6679ea3$var$_class.prototype, "addRows", [
    $ff33d2d9a6679ea3$var$_dec2
], Object.getOwnPropertyDescriptor($ff33d2d9a6679ea3$var$_class.prototype, "addRows"), $ff33d2d9a6679ea3$var$_class.prototype), $ff33d2d9a6679ea3$var$_class);
var $ff33d2d9a6679ea3$export$2e2bcd8739ae039 = new $ff33d2d9a6679ea3$var$RevenueRowCollection();
const $ff33d2d9a6679ea3$export$eeeec0570e0f8690 = $ff33d2d9a6679ea3$var$RevenueRowCollection;

});
parcelRegister("2YQIp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22ba1383c921e140$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $lUr4c = parcelRequire("lUr4c");

var $fqmGV = parcelRequire("fqmGV");

var $dBifK = parcelRequire("dBifK");

var $5Xh7w = parcelRequire("5Xh7w");

var $egx7S = parcelRequire("egx7S");
parcelRequire("8YeUb");
parcelRequire("lTrDt");

var $YCvN6 = parcelRequire("YCvN6");
var $22ba1383c921e140$var$_dec, $22ba1383c921e140$var$_dec2, $22ba1383c921e140$var$_dec3, $22ba1383c921e140$var$_dec4, $22ba1383c921e140$var$_dec5, $22ba1383c921e140$var$_class, $22ba1383c921e140$var$_descriptor, $22ba1383c921e140$var$_descriptor2, $22ba1383c921e140$var$_descriptor3, $22ba1383c921e140$var$_descriptor4, $22ba1383c921e140$var$_descriptor5, $22ba1383c921e140$var$_descriptor6, $22ba1383c921e140$var$_descriptor7, $22ba1383c921e140$var$_descriptor8, $22ba1383c921e140$var$_descriptor9, $22ba1383c921e140$var$_descriptor10, $22ba1383c921e140$var$_descriptor11, $22ba1383c921e140$var$_descriptor12, $22ba1383c921e140$var$_descriptor13, $22ba1383c921e140$var$_descriptor14, $22ba1383c921e140$var$_descriptor15, $22ba1383c921e140$var$_descriptor16, $22ba1383c921e140$var$_descriptor17, $22ba1383c921e140$var$_descriptor18, $22ba1383c921e140$var$_descriptor19, $22ba1383c921e140$var$_descriptor20, $22ba1383c921e140$var$_descriptor21, $22ba1383c921e140$var$_descriptor22;
function $22ba1383c921e140$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $22ba1383c921e140$var$_defineProperty(e, r, t) {
    return (r = $22ba1383c921e140$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $22ba1383c921e140$var$_toPropertyKey(t) {
    var i = $22ba1383c921e140$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $22ba1383c921e140$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $22ba1383c921e140$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $22ba1383c921e140$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $22ba1383c921e140$var$propByGroup = {
    status: "status",
    project: "projectId",
    phase: "phaseId"
};
let $22ba1383c921e140$var$RevenueRowModel = ($22ba1383c921e140$var$_dec = (0, $d8hWe.action).bound, $22ba1383c921e140$var$_dec2 = (0, $d8hWe.action).bound, $22ba1383c921e140$var$_dec3 = (0, $d8hWe.action).bound, $22ba1383c921e140$var$_dec4 = (0, $d8hWe.action).bound, $22ba1383c921e140$var$_dec5 = (0, $d8hWe.action).bound, $22ba1383c921e140$var$_class = class RevenueRowModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $22ba1383c921e140$var$_initializerDefineProperty(this, "label", $22ba1383c921e140$var$_descriptor, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "fee", $22ba1383c921e140$var$_descriptor2, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "actualRevenue", $22ba1383c921e140$var$_descriptor3, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "actualVariationRevenue", $22ba1383c921e140$var$_descriptor4, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "actualReimbursementRevenue", $22ba1383c921e140$var$_descriptor5, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "projectedRevenue", $22ba1383c921e140$var$_descriptor6, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "editedRevenue", $22ba1383c921e140$var$_descriptor7, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "editedExpense", $22ba1383c921e140$var$_descriptor8, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "expenses", $22ba1383c921e140$var$_descriptor9, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "status", $22ba1383c921e140$var$_descriptor10, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "projectId", $22ba1383c921e140$var$_descriptor11, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "phaseId", $22ba1383c921e140$var$_descriptor12, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "phaseTitle", $22ba1383c921e140$var$_descriptor13, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "revenueStartDate", $22ba1383c921e140$var$_descriptor14, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "revenueEndDate", $22ba1383c921e140$var$_descriptor15, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "startDate", $22ba1383c921e140$var$_descriptor16, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "endDate", $22ba1383c921e140$var$_descriptor17, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "groups", $22ba1383c921e140$var$_descriptor18, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "store", $22ba1383c921e140$var$_descriptor19, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "parent", $22ba1383c921e140$var$_descriptor20, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "children", $22ba1383c921e140$var$_descriptor21, this);
        $22ba1383c921e140$var$_initializerDefineProperty(this, "isRootPhase", $22ba1383c921e140$var$_descriptor22, this);
        $22ba1383c921e140$var$_defineProperty(this, "getRevenueInMonth", (0, $YCvN6.computedFn)((month)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.flatMap((r)=>r.getRevenueInMonth(month)));
            if (this.revenueData === "actual") {
                var _this$actualRevenue$m;
                return (_this$actualRevenue$m = this.actualRevenue[month]) !== null && _this$actualRevenue$m !== void 0 ? _this$actualRevenue$m : 0;
            }
            if (this.revenueData === "projected") {
                var _ref, _this$editedRevenue$m;
                return (_ref = (_this$editedRevenue$m = this.editedRevenue[month]) !== null && _this$editedRevenue$m !== void 0 ? _this$editedRevenue$m : this.projectedRevenue[month]) !== null && _ref !== void 0 ? _ref : 0;
            }
            if (this.revenueData === "actualsProjected") {
                if (month < (0, $egx7S.format)(new Date(), "yyyy-MM")) {
                    var _this$actualRevenue$m2;
                    return (_this$actualRevenue$m2 = this.actualRevenue[month]) !== null && _this$actualRevenue$m2 !== void 0 ? _this$actualRevenue$m2 : 0;
                } else if (month > (0, $egx7S.format)(new Date(), "yyyy-MM")) {
                    var _ref2, _this$editedRevenue$m2;
                    return (_ref2 = (_this$editedRevenue$m2 = this.editedRevenue[month]) !== null && _this$editedRevenue$m2 !== void 0 ? _this$editedRevenue$m2 : this.projectedRevenue[month]) !== null && _ref2 !== void 0 ? _ref2 : 0;
                } else {
                    var _this$actualRevenue$m3, _ref3, _this$editedRevenue$m3;
                    return Math.max((_this$actualRevenue$m3 = this.actualRevenue[month]) !== null && _this$actualRevenue$m3 !== void 0 ? _this$actualRevenue$m3 : 0, (_ref3 = (_this$editedRevenue$m3 = this.editedRevenue[month]) !== null && _this$editedRevenue$m3 !== void 0 ? _this$editedRevenue$m3 : this.projectedRevenue[month]) !== null && _ref3 !== void 0 ? _ref3 : 0);
                }
            }
        }));
        $22ba1383c921e140$var$_defineProperty(this, "getVariationRevenueInMonth", (0, $YCvN6.computedFn)((month)=>{
            var _this$actualVariation;
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.flatMap((r)=>r.getVariationRevenueInMonth(month)));
            if (this.revenueData === "projected") return 0;
            return (_this$actualVariation = this.actualVariationRevenue[month]) !== null && _this$actualVariation !== void 0 ? _this$actualVariation : 0;
        }));
        $22ba1383c921e140$var$_defineProperty(this, "getExpenseInMonth", (0, $YCvN6.computedFn)((month)=>{
            if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.flatMap((r)=>r.getExpenseInMonth(month)));
            if (this.revenueData === "actual") return this.expenses[month] || 0;
            if (this.revenueData === "projected") return this.editedExpense[month] || this.expenses[month] || 0;
            if (this.revenueData === "actualsProjected") {
                if (month < (0, $egx7S.format)(new Date(), "yyyy-MM")) return this.expenses[month] || 0;
                else if (month > (0, $egx7S.format)(new Date(), "yyyy-MM")) return this.editedExpense[month] || this.expenses[month] || 0;
                else return Math.max(this.expenses[month] || 0, this.editedExpense[month] || this.expenses[month] || 0);
            }
        }));
        $22ba1383c921e140$var$_defineProperty(this, "getRevenueToDateInMonth", (0, $YCvN6.computedFn)((month)=>{
            const prevRevenueMonths = this.revenueMonths.filter((m)=>m <= month);
            const revenueToDate = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(prevRevenueMonths.map((m)=>this.getRevenueInMonth(m)));
            return revenueToDate;
        }));
        $22ba1383c921e140$var$_defineProperty(this, "getVariationRevenueToDateInMonth", (0, $YCvN6.computedFn)((month)=>{
            const prevRevenueMonths = this.revenueMonths.filter((m)=>m <= month);
            const revenueToDate = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(prevRevenueMonths.map((m)=>this.getVariationRevenueInMonth(m)));
            return revenueToDate;
        }));
        $22ba1383c921e140$var$_defineProperty(this, "getExpenseToDateInMonth", (0, $YCvN6.computedFn)((month)=>{
            const prevExpenseMonths = this.expenseMonths.filter((m)=>m <= month);
            const expensesToDate = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(prevExpenseMonths.map((m)=>this.getExpenseInMonth(m)));
            return expensesToDate;
        }));
        $22ba1383c921e140$var$_defineProperty(this, "getTotalRevenue", (0, $YCvN6.computedFn)(()=>{
            return this.getRevenueToDateInMonth((0, $egx7S.format)((0, $egx7S.addYears)(new Date(), 100), "yyyy-MM"));
        }));
        $22ba1383c921e140$var$_defineProperty(this, "getTotalExpense", (0, $YCvN6.computedFn)(()=>{
            return this.getExpenseToDateInMonth((0, $egx7S.format)((0, $egx7S.addYears)(new Date(), 100), "yyyy-MM"));
        }));
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $lUr4c.default);
        this.init(data, options);
    }
    setStore(store) {
        this.children.forEach((r)=>r.setStore(store));
        if (this.store === store) return;
        this.store = store;
    }
    setParent(parent) {
        this.parent = parent;
    }
    setChildren(children = []) {
        this.children = children;
    }
    get totalFee() {
        var _this$phase, _this$project;
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.children.map((r)=>r.totalFee));
        return this.fee || ((_this$phase = this.phase) === null || _this$phase === void 0 ? void 0 : _this$phase.fee) || ((_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.fee) || 0;
    }
    get revenueData() {
        var _this$store, _this$store$report, _this$store$report$fi, _this$store2, _this$store2$report, _this$store2$report$f, _this$store3, _this$store3$report, _this$store3$report$f;
        return ((_this$store = this.store) === null || _this$store === void 0 ? void 0 : (_this$store$report = _this$store.report) === null || _this$store$report === void 0 ? void 0 : (_this$store$report$fi = _this$store$report.filters) === null || _this$store$report$fi === void 0 ? void 0 : _this$store$report$fi.revenueData) || ((_this$store2 = this.store) === null || _this$store2 === void 0 ? void 0 : (_this$store2$report = _this$store2.report) === null || _this$store2$report === void 0 ? void 0 : (_this$store2$report$f = _this$store2$report.filters) === null || _this$store2$report$f === void 0 ? void 0 : _this$store2$report$f.expenseData) || ((_this$store3 = this.store) === null || _this$store3 === void 0 ? void 0 : (_this$store3$report = _this$store3.report) === null || _this$store3$report === void 0 ? void 0 : (_this$store3$report$f = _this$store3$report.filters) === null || _this$store3$report$f === void 0 ? void 0 : _this$store3$report$f.hoursData) || "actualsProjected";
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get childPhases() {
        return this.phase ? [
            this.phase
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childPhases))
        ].filter((p)=>p);
    }
    get childPhaseIds() {
        return this.phaseId ? [
            this.phaseId
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childPhaseIds))
        ].filter((p)=>p);
    }
    get childProjects() {
        return this.project ? [
            this.project
        ] : [
            ...new Set(this.children.flatMap((c)=>c.childProjects))
        ].filter((p)=>p);
    }
    get level() {
        return this.groups.length - 1;
    }
    get matchers() {
        let matchers = {};
        if (this.groups.includes("staff")) matchers.staffId = this.staffId;
        if (this.groups.includes("role")) matchers.roleId = this.roleId;
        if (this.groups.includes("phase")) matchers.phaseId = this.phaseId;
        if (this.groups.includes("project")) matchers.projectId = this.projectId;
        if (this.groups.includes("status")) matchers.status = this.status;
        return matchers;
    }
    get revenueMonths() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).uniq(this.children.flatMap((r)=>r.revenueMonths));
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).uniq([
            ...Object.keys(this.actualRevenue),
            ...Object.keys(this.projectedRevenue),
            ...Object.keys(this.editedRevenue)
        ]);
    }
    get expenseMonths() {
        if (this.children.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).uniq(this.children.flatMap((r)=>r.expenseMonths));
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).uniq([
            ...Object.keys(this.expenses),
            ...Object.keys(this.editedExpense)
        ]);
    }
    getProgressInMonth(month) {
        if (!this.totalFee) return null;
        return this.getRevenueToDateInMonth(month) / this.totalFee;
    }
    getExpenseProgressInMonth(month) {
        return this.getExpenseToDateInMonth(month) / this.expenseBudget;
    }
    setProgressInMonth(month, progress) {
        progress || (progress = 0);
        const monthDate = (0, $egx7S.parse)(month, "yyyy-MM", new Date());
        const prevMonth = (0, $egx7S.format)((0, $egx7S.subMonths)(monthDate, 1), "yyyy-MM");
        const prevProgress = this.getProgressInMonth(prevMonth) || 0;
        const diffProgress = Math.max(progress, prevProgress) - prevProgress;
        const diffRevenue = diffProgress * this.totalFee;
        return this.setRevenueInMonth(month, diffRevenue);
    }
    setExpenseProgressInMonth(month, progress) {
        progress || (progress = 0);
        const monthDate = (0, $egx7S.parse)(month, "yyyy-MM", new Date());
        const prevMonth = (0, $egx7S.format)((0, $egx7S.subMonths)(monthDate, 1), "yyyy-MM");
        const prevProgress = this.getExpenseProgressInMonth(prevMonth) || 0;
        const diffProgress = Math.max(progress, prevProgress) - prevProgress;
        const diffExpense = diffProgress * this.expenseBudget;
        return this.setExpenseInMonth(month, diffExpense);
    }
    setRevenueInMonth(month, v) {
        if (!this.children.length) {
            this.editedRevenue[month] = v;
            this.update({
                editedRevenue: {
                    ...this.editedRevenue
                }
            });
        }
        const children = this.children;
        const childrenWithRevenueInMonth = children.filter((r)=>r.getRevenueInMonth(month) > 0);
        const existingRevenueInMonth = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(childrenWithRevenueInMonth.map((r)=>r.getRevenueInMonth(month)));
        if (existingRevenueInMonth) {
            const ratio = v / existingRevenueInMonth;
            childrenWithRevenueInMonth.forEach((r)=>r.setRevenueInMonth(month, r.getRevenueInMonth(month) * ratio));
        } else children.forEach((r)=>r.setRevenueInMonth(month, v / children.length));
    }
    serialize() {
        var _this$store4, _this$store4$report;
        return {
            id: this.id,
            editedRevenue: this.editedRevenue,
            reportFilters: {
                ...((_this$store4 = this.store) === null || _this$store4 === void 0 ? void 0 : (_this$store4$report = _this$store4.report) === null || _this$store4$report === void 0 ? void 0 : _this$store4$report.filters) || {},
                ...this.matchers
            }
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
}, $22ba1383c921e140$var$_descriptor = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "label", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor2 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "fee", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $22ba1383c921e140$var$_descriptor3 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "actualRevenue", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $22ba1383c921e140$var$_descriptor4 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "actualVariationRevenue", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $22ba1383c921e140$var$_descriptor5 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "actualReimbursementRevenue", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $22ba1383c921e140$var$_descriptor6 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "projectedRevenue", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $22ba1383c921e140$var$_descriptor7 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "editedRevenue", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $22ba1383c921e140$var$_descriptor8 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "editedExpense", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $22ba1383c921e140$var$_descriptor9 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "expenses", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $22ba1383c921e140$var$_descriptor10 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "status", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor11 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor12 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor13 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "phaseTitle", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor14 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "revenueStartDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor15 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "revenueEndDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor16 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor17 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor18 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "groups", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            "status"
        ];
    }
}), $22ba1383c921e140$var$_descriptor19 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "store", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor20 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "parent", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_descriptor21 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "children", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $22ba1383c921e140$var$_descriptor22 = $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "isRootPhase", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "setStore", [
    (0, $d8hWe.action)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "setStore"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "setParent", [
    $22ba1383c921e140$var$_dec
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "setParent"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "setChildren", [
    $22ba1383c921e140$var$_dec2
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "setChildren"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "totalFee", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "totalFee"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "revenueData", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "revenueData"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "phase"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "project"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "childPhases", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "childPhases"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "childPhaseIds", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "childPhaseIds"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "childProjects", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "childProjects"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "level", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "level"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "matchers", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "matchers"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "revenueMonths", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "revenueMonths"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "expenseMonths", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "expenseMonths"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "getProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "getProgressInMonth"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "getExpenseProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "getExpenseProgressInMonth"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "setProgressInMonth", [
    $22ba1383c921e140$var$_dec3
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "setProgressInMonth"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "setExpenseProgressInMonth", [
    $22ba1383c921e140$var$_dec4
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "setExpenseProgressInMonth"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_applyDecoratedDescriptor($22ba1383c921e140$var$_class.prototype, "setRevenueInMonth", [
    $22ba1383c921e140$var$_dec5
], Object.getOwnPropertyDescriptor($22ba1383c921e140$var$_class.prototype, "setRevenueInMonth"), $22ba1383c921e140$var$_class.prototype), $22ba1383c921e140$var$_class);
var $22ba1383c921e140$export$2e2bcd8739ae039 = $22ba1383c921e140$var$RevenueRowModel;

});




parcelRegister("1qwrf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10a161c9041ceffe$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "MonthlyExpenseCellCollectionClass", function () { return $10a161c9041ceffe$export$b3413dfcf8f176a9; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $3QDyA = parcelRequire("3QDyA");
var $10a161c9041ceffe$var$_dec, $10a161c9041ceffe$var$_dec2, $10a161c9041ceffe$var$_class;
function $10a161c9041ceffe$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $10a161c9041ceffe$var$MonthlyExpenseCellCollection = ($10a161c9041ceffe$var$_dec = (0, $d8hWe.action).bound, $10a161c9041ceffe$var$_dec2 = (0, $d8hWe.action).bound, $10a161c9041ceffe$var$_class = class MonthlyExpenseCellCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "monthlyExpenseCells",
            modelClass: (0, $3QDyA.default)
        });
        this.addLookup("cellsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByExpenseName", "manyByKey", {
            key: (t)=>t.expenseName,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByMonth", "manyByKey", {
            key: (t)=>t.month,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("cellsByType", "manyByKey", {
            key: (t)=>t.type,
            filter: (t)=>!t.deletedAt
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get cellsById() {
        return this.modelsById;
    }
    get cells() {
        return this.models;
    }
    addCell(data, options) {
        return this.add(data, options);
    }
    addCells(data, options) {
        return this.addMany(data, options);
    }
}, $10a161c9041ceffe$var$_applyDecoratedDescriptor($10a161c9041ceffe$var$_class.prototype, "addCell", [
    $10a161c9041ceffe$var$_dec
], Object.getOwnPropertyDescriptor($10a161c9041ceffe$var$_class.prototype, "addCell"), $10a161c9041ceffe$var$_class.prototype), $10a161c9041ceffe$var$_applyDecoratedDescriptor($10a161c9041ceffe$var$_class.prototype, "addCells", [
    $10a161c9041ceffe$var$_dec2
], Object.getOwnPropertyDescriptor($10a161c9041ceffe$var$_class.prototype, "addCells"), $10a161c9041ceffe$var$_class.prototype), $10a161c9041ceffe$var$_class);
var $10a161c9041ceffe$export$2e2bcd8739ae039 = new $10a161c9041ceffe$var$MonthlyExpenseCellCollection();
const $10a161c9041ceffe$export$b3413dfcf8f176a9 = $10a161c9041ceffe$var$MonthlyExpenseCellCollection;

});
parcelRegister("3QDyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cd4e99da37b0531$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $1qwrf = parcelRequire("1qwrf");

var $fqmGV = parcelRequire("fqmGV");

var $egx7S = parcelRequire("egx7S");

var $8sHH3 = parcelRequire("8sHH3");
parcelRequire("iTrNV");
var $2cd4e99da37b0531$var$_class, $2cd4e99da37b0531$var$_descriptor, $2cd4e99da37b0531$var$_descriptor2, $2cd4e99da37b0531$var$_descriptor3, $2cd4e99da37b0531$var$_descriptor4, $2cd4e99da37b0531$var$_descriptor5, $2cd4e99da37b0531$var$_descriptor6, $2cd4e99da37b0531$var$_descriptor7, $2cd4e99da37b0531$var$_descriptor8, $2cd4e99da37b0531$var$_descriptor9, $2cd4e99da37b0531$var$_descriptor10;
function $2cd4e99da37b0531$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $2cd4e99da37b0531$var$_defineProperty(e, r, t) {
    return (r = $2cd4e99da37b0531$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2cd4e99da37b0531$var$_toPropertyKey(t) {
    var i = $2cd4e99da37b0531$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2cd4e99da37b0531$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2cd4e99da37b0531$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $2cd4e99da37b0531$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $2cd4e99da37b0531$var$MonthlyExpenseCellModel = ($2cd4e99da37b0531$var$_class = class MonthlyExpenseCellModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "month", $2cd4e99da37b0531$var$_descriptor, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "expense", $2cd4e99da37b0531$var$_descriptor2, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "expenseToDate", $2cd4e99da37b0531$var$_descriptor3, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "status", $2cd4e99da37b0531$var$_descriptor4, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "projectId", $2cd4e99da37b0531$var$_descriptor5, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "phaseId", $2cd4e99da37b0531$var$_descriptor6, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "expenseName", $2cd4e99da37b0531$var$_descriptor7, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "ownerId", $2cd4e99da37b0531$var$_descriptor8, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "costCentreId", $2cd4e99da37b0531$var$_descriptor9, this);
        $2cd4e99da37b0531$var$_initializerDefineProperty(this, "type", $2cd4e99da37b0531$var$_descriptor10, this);
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $1qwrf.default);
        this.init(data, options);
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get projectExpense() {
        return (0, $8sHH3.default).expensesByName[this.expenseName] || (0, $8sHH3.default).add({
            projectId: this.projectId,
            phaseId: this.phaseId,
            name: this.expenseName
        });
    }
    serialize() {
        return {
            id: this.id,
            month: this.month,
            expense: this.expense,
            expenseName: this.expenseName,
            projectId: this.projectId,
            phaseId: this.phaseId
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
    get date() {
        return (0, $egx7S.startOfMonth)((0, $egx7S.parse)(this.month, "yyyy-MM", new Date()));
    }
}, $2cd4e99da37b0531$var$_descriptor = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "month", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2cd4e99da37b0531$var$_descriptor2 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "expense", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $2cd4e99da37b0531$var$_descriptor3 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "expenseToDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $2cd4e99da37b0531$var$_descriptor4 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "status", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2cd4e99da37b0531$var$_descriptor5 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2cd4e99da37b0531$var$_descriptor6 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2cd4e99da37b0531$var$_descriptor7 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "expenseName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2cd4e99da37b0531$var$_descriptor8 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "ownerId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2cd4e99da37b0531$var$_descriptor9 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "costCentreId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2cd4e99da37b0531$var$_descriptor10 = $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "type", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2cd4e99da37b0531$var$_class.prototype, "phase"), $2cd4e99da37b0531$var$_class.prototype), $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2cd4e99da37b0531$var$_class.prototype, "project"), $2cd4e99da37b0531$var$_class.prototype), $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "projectExpense", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2cd4e99da37b0531$var$_class.prototype, "projectExpense"), $2cd4e99da37b0531$var$_class.prototype), $2cd4e99da37b0531$var$_applyDecoratedDescriptor($2cd4e99da37b0531$var$_class.prototype, "date", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($2cd4e99da37b0531$var$_class.prototype, "date"), $2cd4e99da37b0531$var$_class.prototype), $2cd4e99da37b0531$var$_class);
var $2cd4e99da37b0531$export$2e2bcd8739ae039 = $2cd4e99da37b0531$var$MonthlyExpenseCellModel;

});


parcelRegister("cpPFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $909fe549ab0a3bc1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ExpenseRowCollectionClass", function () { return $909fe549ab0a3bc1$export$61860cc5fc65ddb4; });

var $d8hWe = parcelRequire("d8hWe");

var $906tN = parcelRequire("906tN");

var $kNb8x = parcelRequire("kNb8x");
var $909fe549ab0a3bc1$var$_dec, $909fe549ab0a3bc1$var$_dec2, $909fe549ab0a3bc1$var$_class;
function $909fe549ab0a3bc1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $909fe549ab0a3bc1$var$ExpenseRowCollection = ($909fe549ab0a3bc1$var$_dec = (0, $d8hWe.action).bound, $909fe549ab0a3bc1$var$_dec2 = (0, $d8hWe.action).bound, $909fe549ab0a3bc1$var$_class = class ExpenseRowCollection extends (0, $906tN.default) {
    constructor(){
        super({
            collection: "expenseRows",
            modelClass: (0, $kNb8x.default)
        });
        this.addLookup("rowsByPhaseId", "manyByKey", {
            key: (t)=>t.phaseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByProjectId", "manyByKey", {
            key: (t)=>t.projectId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByExpenseId", "manyByKey", {
            key: (t)=>t.expenseId,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("rowsByStatus", "manyByKey", {
            key: (t)=>t.status,
            filter: (t)=>!t.deletedAt
        });
        this.addLookup("leafRows", "list", {
            filter: (m)=>{
                return m.isLeaf;
            }
        });
        (0, $d8hWe.makeObservable)(this);
    }
    get rowsById() {
        return this.modelsById;
    }
    get rows() {
        return this.models;
    }
    addRow(data) {
        this.add(data);
    }
    addRows(data) {
        this.addMany(data);
    }
}, $909fe549ab0a3bc1$var$_applyDecoratedDescriptor($909fe549ab0a3bc1$var$_class.prototype, "addRow", [
    $909fe549ab0a3bc1$var$_dec
], Object.getOwnPropertyDescriptor($909fe549ab0a3bc1$var$_class.prototype, "addRow"), $909fe549ab0a3bc1$var$_class.prototype), $909fe549ab0a3bc1$var$_applyDecoratedDescriptor($909fe549ab0a3bc1$var$_class.prototype, "addRows", [
    $909fe549ab0a3bc1$var$_dec2
], Object.getOwnPropertyDescriptor($909fe549ab0a3bc1$var$_class.prototype, "addRows"), $909fe549ab0a3bc1$var$_class.prototype), $909fe549ab0a3bc1$var$_class);
var $909fe549ab0a3bc1$export$2e2bcd8739ae039 = new $909fe549ab0a3bc1$var$ExpenseRowCollection();
const $909fe549ab0a3bc1$export$61860cc5fc65ddb4 = $909fe549ab0a3bc1$var$ExpenseRowCollection;

});
parcelRegister("kNb8x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f23105c0bacbcbbd$export$2e2bcd8739ae039; });

var $d8hWe = parcelRequire("d8hWe");

var $9Lw71 = parcelRequire("9Lw71");

var $kdO1A = parcelRequire("kdO1A");

var $cpPFf = parcelRequire("cpPFf");

var $fqmGV = parcelRequire("fqmGV");

var $1qwrf = parcelRequire("1qwrf");

var $dBifK = parcelRequire("dBifK");

var $5Xh7w = parcelRequire("5Xh7w");

var $egx7S = parcelRequire("egx7S");
parcelRequire("8YeUb");
parcelRequire("lTrDt");

var $YCvN6 = parcelRequire("YCvN6");

var $8sHH3 = parcelRequire("8sHH3");
var $f23105c0bacbcbbd$var$_dec, $f23105c0bacbcbbd$var$_class, $f23105c0bacbcbbd$var$_descriptor, $f23105c0bacbcbbd$var$_descriptor2, $f23105c0bacbcbbd$var$_descriptor3, $f23105c0bacbcbbd$var$_descriptor4, $f23105c0bacbcbbd$var$_descriptor5, $f23105c0bacbcbbd$var$_descriptor6, $f23105c0bacbcbbd$var$_descriptor7, $f23105c0bacbcbbd$var$_descriptor8, $f23105c0bacbcbbd$var$_descriptor9, $f23105c0bacbcbbd$var$_descriptor10, $f23105c0bacbcbbd$var$_descriptor11, $f23105c0bacbcbbd$var$_descriptor12, $f23105c0bacbcbbd$var$_descriptor13, $f23105c0bacbcbbd$var$_descriptor14, $f23105c0bacbcbbd$var$_descriptor15;
function $f23105c0bacbcbbd$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $f23105c0bacbcbbd$var$_defineProperty(e, r, t) {
    return (r = $f23105c0bacbcbbd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f23105c0bacbcbbd$var$_toPropertyKey(t) {
    var i = $f23105c0bacbcbbd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f23105c0bacbcbbd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f23105c0bacbcbbd$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $f23105c0bacbcbbd$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
const $f23105c0bacbcbbd$var$cellsByGroup = {
    status: ()=>(0, $1qwrf.default).cellsByStatus,
    project: ()=>(0, $1qwrf.default).cellsByProjectId,
    phase: ()=>(0, $1qwrf.default).cellsByPhaseId,
    expense: ()=>(0, $1qwrf.default).cellsByExpenseName
};
const $f23105c0bacbcbbd$var$propByGroup = {
    status: "status",
    project: "projectId",
    phase: "phaseId",
    expense: "expenseName"
};
const $f23105c0bacbcbbd$var$titlePropByGroup = {
    project: "title",
    phase: "title",
    staff: "fullName",
    role: "name",
    expense: "expenseName"
};
let $f23105c0bacbcbbd$var$ExpenseRowModel = ($f23105c0bacbcbbd$var$_dec = (0, $d8hWe.action).bound, $f23105c0bacbcbbd$var$_class = class ExpenseRowModel extends (0, $fqmGV.default) {
    constructor(data, options){
        super();
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "label", $f23105c0bacbcbbd$var$_descriptor, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "fee", $f23105c0bacbcbbd$var$_descriptor2, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "hoursBudget", $f23105c0bacbcbbd$var$_descriptor3, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "expenseBudget", $f23105c0bacbcbbd$var$_descriptor4, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "expenses", $f23105c0bacbcbbd$var$_descriptor5, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "editedExpenses", $f23105c0bacbcbbd$var$_descriptor6, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "status", $f23105c0bacbcbbd$var$_descriptor7, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "projectId", $f23105c0bacbcbbd$var$_descriptor8, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "phaseId", $f23105c0bacbcbbd$var$_descriptor9, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "expenseName", $f23105c0bacbcbbd$var$_descriptor10, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "expenseStartDate", $f23105c0bacbcbbd$var$_descriptor11, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "expenseEndDate", $f23105c0bacbcbbd$var$_descriptor12, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "startDate", $f23105c0bacbcbbd$var$_descriptor13, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "endDate", $f23105c0bacbcbbd$var$_descriptor14, this);
        $f23105c0bacbcbbd$var$_initializerDefineProperty(this, "groups", $f23105c0bacbcbbd$var$_descriptor15, this);
        $f23105c0bacbcbbd$var$_defineProperty(this, "getExpenseInMonth", (0, $YCvN6.computedFn)((month, expenseData = "actualsProjected")=>{
            var _ref, _this$editedExpenses$;
            if (!this.isLeaf && this.leafRows.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(this.leafRows.flatMap((r)=>r.getExpenseInMonth(month, expenseData)));
            return (_ref = (_this$editedExpenses$ = this.editedExpenses[month]) !== null && _this$editedExpenses$ !== void 0 ? _this$editedExpenses$ : this.expenses[month]) !== null && _ref !== void 0 ? _ref : 0;
        }));
        $f23105c0bacbcbbd$var$_defineProperty(this, "getExpenseToDateInMonth", (0, $YCvN6.computedFn)((month, expenseData = "actualsProjected")=>{
            const prevExpenseMonths = this.expenseMonths.filter((m)=>m <= month);
            const expenseToDate = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(prevExpenseMonths.map((m)=>this.getExpenseInMonth(m, expenseData)));
            return expenseToDate;
        }));
        $f23105c0bacbcbbd$var$_defineProperty(this, "getTotalExpense", (0, $YCvN6.computedFn)((expenseData = "actualsProjected")=>{
            return this.getExpenseToDateInMonth((0, $egx7S.format)(addYears(new Date(), 100), "yyyy-MM"), expenseData);
        }));
        (0, $d8hWe.makeObservable)(this);
        this.collection = (0, $cpPFf.default);
        this.init(data, options);
    }
    get title() {
        const lastGroup = this.groups[this.groups.length - 1];
        if (!this.label || this.label === "") {
            var _this$lastGroup;
            const titleProp = $f23105c0bacbcbbd$var$titlePropByGroup[lastGroup];
            return titleProp ? (_this$lastGroup = this[lastGroup]) === null || _this$lastGroup === void 0 ? void 0 : _this$lastGroup[titleProp] : this[lastGroup];
        } else return this.label;
    }
    get isLeaf() {
        return this.groups.includes("phase") && this.groups.includes("project") && this.groups.includes("status") && this.groups.includes("expense");
    }
    get leafRows() {
        return this.isLeaf ? [] : (0, $cpPFf.default).leafRows.filter((r)=>{
            const matcher = this.matchers;
            return (!("phaseId" in matcher) || r.phaseId === this.phaseId) && (!("projectId" in matcher) || r.projectId === this.projectId) && (!("status" in matcher) || r.status === this.status) && (!("expense" in matcher) || r.expenseName === this.expenseName);
        });
    }
    get level() {
        return this.groups.length - 1;
    }
    get childPhases() {
        return this.phase ? [
            this.phase
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childPhases))
        ].filter((p)=>p);
    }
    get childPhaseIds() {
        return this.phaseId ? [
            this.phaseId
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childPhaseIds))
        ].filter((p)=>p);
    }
    get childProjects() {
        return this.project ? [
            this.project
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childProjects))
        ].filter((p)=>p);
    }
    get childProjectIds() {
        return this.projectId ? [
            this.projectId
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childProjectIds))
        ].filter((p)=>p);
    }
    get childProjectExpenses() {
        return this.projectExpense ? [
            this.projectExpense
        ] : [
            ...new Set(this.leafRows.flatMap((c)=>c.childProjectExpenses))
        ].filter((p)=>p);
    }
    get phase() {
        return (0, $9Lw71.default).phasesById[this.phaseId];
    }
    get project() {
        return (0, $kdO1A.default).projectsById[this.projectId];
    }
    get projectExpense() {
        return (0, $8sHH3.default).expensesByName[this.expenseName];
    }
    get matchers() {
        let matchers = {};
        if (this.groups.includes("phase")) matchers.phaseId = this.phaseId;
        if (this.groups.includes("project")) matchers.projectId = this.projectId;
        if (this.groups.includes("status")) matchers.status = this.status;
        if (this.groups.includes("expense")) matchers.expenseName = this.expenseName;
        return matchers;
    }
    get expenseMonths() {
        if (!this.isLeaf && this.leafRows.length) return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).uniq(this.leafRows.flatMap((r)=>r.revenueMonths));
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).uniq([
            ...Object.keys(this.expenses),
            ...Object.keys(this.editedExpenses)
        ]);
    }
    getProgressInMonth(month, expenseData = "actualsProjected") {
        return this.getExpenseToDateInMonth(month, expenseData) / this.budget;
    }
    setExpenseInMonth(month, v, expenseData = "actualsProjected") {
        if (this.isLeaf) {
            this.editedExpenses[month] = v;
            this.update({
                editedExpenses: {
                    ...this.editedExpenses
                }
            });
        }
        const leafRows = this.leafRows;
        const leafRowsWithExpensesInMonth = leafRows.filter((r)=>r.getExpenseInMonth(month, expenseData) > 0);
        const existingExpenseInMonth = (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(leafRowsWithExpensesInMonth.map((r)=>r.getExpenseInMonth(month, expenseData)));
        if (existingExpenseInMonth) {
            const ratio = v / existingExpenseInMonth;
            leafRowsWithExpensesInMonth.forEach((r)=>r.setExpenseInMonth(month, r.getExpenseInMonth(month, expenseData) * ratio));
        } else leafRows.forEach((r)=>r.getExpenseInMonth(month, v / leafRows.length));
    }
    serialize() {
        return {
            id: this.id,
            editedExpenses: this.editedExpenses,
            projectId: this.projectId,
            phaseId: this.phaseId,
            expenseName: this.expenseName
        };
    }
    serializeUpdates() {
        return this.serialize();
    }
}, $f23105c0bacbcbbd$var$_descriptor = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "label", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor2 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "fee", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $f23105c0bacbcbbd$var$_descriptor3 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "hoursBudget", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $f23105c0bacbcbbd$var$_descriptor4 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "expenseBudget", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $f23105c0bacbcbbd$var$_descriptor5 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "expenses", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $f23105c0bacbcbbd$var$_descriptor6 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "editedExpenses", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $f23105c0bacbcbbd$var$_descriptor7 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "status", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor8 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "projectId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor9 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "phaseId", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor10 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "expenseName", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor11 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "expenseStartDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor12 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "expenseEndDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor13 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "startDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor14 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "endDate", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $f23105c0bacbcbbd$var$_descriptor15 = $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "groups", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [
            "status"
        ];
    }
}), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "title", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "title"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "isLeaf", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "isLeaf"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "leafRows", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "leafRows"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "level", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "level"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childPhases", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childPhases"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childPhaseIds", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childPhaseIds"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childProjects", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childProjects"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childProjectIds", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childProjectIds"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childProjectExpenses", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "childProjectExpenses"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "phase", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "phase"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "project", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "project"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "projectExpense", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "projectExpense"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "matchers", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "matchers"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "expenseMonths", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "expenseMonths"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "getProgressInMonth", [
    (0, (/*@__PURE__*/$parcel$interopDefault($5Xh7w)))
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "getProgressInMonth"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_applyDecoratedDescriptor($f23105c0bacbcbbd$var$_class.prototype, "setExpenseInMonth", [
    $f23105c0bacbcbbd$var$_dec
], Object.getOwnPropertyDescriptor($f23105c0bacbcbbd$var$_class.prototype, "setExpenseInMonth"), $f23105c0bacbcbbd$var$_class.prototype), $f23105c0bacbcbbd$var$_class);
var $f23105c0bacbcbbd$export$2e2bcd8739ae039 = $f23105c0bacbcbbd$var$ExpenseRowModel;

});







parcelRegister("WdVIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0af03919a63dbd94$export$2e2bcd8739ae039; });

var $5uSSv = parcelRequire("5uSSv");
var $0af03919a63dbd94$export$2e2bcd8739ae039 = (a, b)=>{
    var _a$title2, _a$title2$toLowerCase, _a$title2$toLowerCase2, _a$title2$toLowerCase3, _b$title, _b$title$toLowerCase;
    // Check if either phase is a root phase
    if (a !== null && a !== void 0 && a.isRootPhase && !(b !== null && b !== void 0 && b.isRootPhase)) return 1; // a is root, so it should be last
    else if (!(a !== null && a !== void 0 && a.isRootPhase) && b !== null && b !== void 0 && b.isRootPhase) return -1; // b is root, so a should come first
    if ((0, $5uSSv.default).settings.sortPhasesBy === "startDate") {
        // Check if both items have a startDate
        if (a.startDate && b.startDate) {
            var _a$title, _a$title$localeCompar;
            // If both have a startDate, first sort by startDate
            if (a.startDate !== b.startDate) return new Date(a.startDate) - new Date(b.startDate);
            // If startDate is the same, sort by title
            return (_a$title = a.title) === null || _a$title === void 0 ? void 0 : (_a$title$localeCompar = _a$title.localeCompare) === null || _a$title$localeCompar === void 0 ? void 0 : _a$title$localeCompar.call(_a$title, b.title);
        } else if (a.startDate) // If only a has a startDate, it should come first
        return -1;
        else if (b.startDate) // If only b has a startDate, it should come first
        return 1;
    }
    // If neither has a startDate, sort by title
    return (_a$title2 = a.title) === null || _a$title2 === void 0 ? void 0 : (_a$title2$toLowerCase = _a$title2.toLowerCase) === null || _a$title2$toLowerCase === void 0 ? void 0 : (_a$title2$toLowerCase2 = _a$title2$toLowerCase.call(_a$title2)) === null || _a$title2$toLowerCase2 === void 0 ? void 0 : (_a$title2$toLowerCase3 = _a$title2$toLowerCase2.localeCompare) === null || _a$title2$toLowerCase3 === void 0 ? void 0 : _a$title2$toLowerCase3.call(_a$title2$toLowerCase2, (_b$title = b.title) === null || _b$title === void 0 ? void 0 : (_b$title$toLowerCase = _b$title.toLowerCase) === null || _b$title$toLowerCase === void 0 ? void 0 : _b$title$toLowerCase.call(_b$title));
};

});


parcelRegister("3oSmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $279dc841e30c4c3f$export$2e2bcd8739ae039; });

var $ktD5v = parcelRequire("ktD5v");

var $9psKg = parcelRequire("9psKg");

var $b0ErZ = parcelRequire("b0ErZ");

var $gnlsD = parcelRequire("gnlsD");

var $PIDKX = parcelRequire("PIDKX");

var $5uSSv = parcelRequire("5uSSv");

var $kdO1A = parcelRequire("kdO1A");

var $egx7S = parcelRequire("egx7S");

var $4sGvn = parcelRequire("4sGvn");
const $279dc841e30c4c3f$var$getObjs = ()=>{
    var _ProjectCollection$pr;
    return {
        ...Object.fromEntries((0, $PIDKX.default).invoices.map((i)=>[
                "inv" + i.id,
                {
                    ...i.serialize(),
                    type: "invoice"
                }
            ])),
        ...Object.fromEntries((0, $kdO1A.default).projects.map((i)=>[
                "pr" + i.id,
                {
                    ...i.serialize(),
                    type: "project"
                }
            ])),
        ...Object.fromEntries((0, $4sGvn.default).contacts.map((i)=>[
                "con" + i.id,
                {
                    ...i.serialize(),
                    type: "contact"
                }
            ])),
        inv0: {
            type: "invoice",
            projectId: ((_ProjectCollection$pr = (0, $kdO1A.default).projects[0]) === null || _ProjectCollection$pr === void 0 ? void 0 : _ProjectCollection$pr.id) || -1
        }
    };
};
const $279dc841e30c4c3f$var$getHashObj = (ref, contextRef)=>{
    var _contextObj$siblingsB;
    const contextObj = $279dc841e30c4c3f$var$getContextObj(contextRef);
    const refObj = (contextObj === null || contextObj === void 0 ? void 0 : (_contextObj$siblingsB = contextObj.siblingsByRef) === null || _contextObj$siblingsB === void 0 ? void 0 : _contextObj$siblingsB[ref]) || $279dc841e30c4c3f$var$getObjs()[ref];
    return refObj;
};
const $279dc841e30c4c3f$var$getAtObj = (ref, contextRef)=>{
    var _contextObj$siblingsB2;
    const contextObj = $279dc841e30c4c3f$var$getContextObj(contextRef);
    const refObj = (contextObj === null || contextObj === void 0 ? void 0 : (_contextObj$siblingsB2 = contextObj.siblingsByRef) === null || _contextObj$siblingsB2 === void 0 ? void 0 : _contextObj$siblingsB2[ref]) || $279dc841e30c4c3f$var$getObjs()[ref];
    return refObj;
};
const $279dc841e30c4c3f$var$getContextObj = ([ref, prop])=>{
    return $279dc841e30c4c3f$var$getObjs()[ref];
};
var $279dc841e30c4c3f$export$2e2bcd8739ae039 = (0, $ktD5v.initParser)({
    getHashObj: $279dc841e30c4c3f$var$getHashObj,
    getAtObj: $279dc841e30c4c3f$var$getAtObj,
    getContextObj: $279dc841e30c4c3f$var$getContextObj,
    constants: {
        invNum: ()=>{
            var _SessionStore$organis;
            return {
                type: "number",
                value: (0, $PIDKX.default).invoices.length + 1 + (((_SessionStore$organis = (0, $5uSSv.default).organisation.settings.invoiceNumber) === null || _SessionStore$organis === void 0 ? void 0 : _SessionStore$organis.numAdjustor) || 0)
            };
        },
        projNum: ()=>{
            var _SessionStore$organis2;
            return {
                type: "number",
                value: (0, $kdO1A.default).projects.length + 1 + (((_SessionStore$organis2 = (0, $5uSSv.default).organisation.settings.projectNumber) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2.numAdjustor) || 0)
            };
        },
        invNumYear: ()=>{
            var _SessionStore$organis3, _SessionStore$organis4;
            return {
                type: "number",
                value: (0, $PIDKX.default).invoices.filter((i)=>(0, $egx7S.isSameYear)(i.createdAt, new Date())).length + 1 + (((_SessionStore$organis3 = (0, $5uSSv.default).organisation.settings.invoiceNumber) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.numYearAdjustors) === null || _SessionStore$organis4 === void 0 ? void 0 : _SessionStore$organis4[new Date().getFullYear()]) || 0)
            };
        },
        projNumYear: ()=>{
            var _SessionStore$organis5, _SessionStore$organis6;
            return {
                type: "number",
                value: (0, $kdO1A.default).projects.filter((i)=>(0, $egx7S.isSameYear)(i.createdAt, new Date())).length + 1 + (((_SessionStore$organis5 = (0, $5uSSv.default).organisation.settings.projectNumber) === null || _SessionStore$organis5 === void 0 ? void 0 : (_SessionStore$organis6 = _SessionStore$organis5.numYearAdjustors) === null || _SessionStore$organis6 === void 0 ? void 0 : _SessionStore$organis6[new Date().getFullYear()]) || 0)
            };
        }
    },
    functions: {
    },
    objectProps: {
        invoice: {
            propertyLookup: (0, $9psKg.invoiceProperties),
            methodLookup: {}
        },
        project: {
            propertyLookup: (0, $b0ErZ.projectProperties),
            methodLookup: {}
        },
        contact: {
            propertyLookup: (0, $gnlsD.contactProperties),
            methodLookup: {}
        }
    }
});

});
parcelRegister("ktD5v", function(module, exports) {

$parcel$export(module.exports, "initParser", function () { return $ee84d61742c80d96$export$84bb9899435eeb61; });

var $4RbPN = parcelRequire("4RbPN");

var $1KElr = parcelRequire("1KElr");

var $dBifK = parcelRequire("dBifK");

var $j7zix = parcelRequire("j7zix");

var $aFtfn = parcelRequire("aFtfn");

var $8wlqd = parcelRequire("8wlqd");

var $9fbCM = parcelRequire("9fbCM");
const $ee84d61742c80d96$export$84bb9899435eeb61 = ({ getHashObj: getHashObj, getAtObj: getAtObj, getContextObj: getContextObj, objectProps: objectProps, constants: constants, functions: functions })=>{
    (0, $j7zix.setGetHashObj)(getHashObj);
    (0, $j7zix.setGetAtObj)(getAtObj);
    (0, $j7zix.setGetContextObj)(getContextObj);
    (0, $4RbPN.addProperties)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mapValues(objectProps, (o)=>o.propertyLookup));
    (0, $1KElr.addMethods)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mapValues(objectProps, (o)=>o.methodLookup));
    (0, $8wlqd.addConstants)(constants);
    (0, $9fbCM.addFunctions)(functions);
    return 0, $aFtfn.default;
};

});
parcelRegister("4RbPN", function(module, exports) {

$parcel$export(module.exports, "Properties", function () { return $38954abdaadeb338$export$8714badcfa4caafb; });
$parcel$export(module.exports, "addProperties", function () { return $38954abdaadeb338$export$25069d271a4443b2; });

var $cWSfz = parcelRequire("cWSfz");
let $38954abdaadeb338$export$8714badcfa4caafb = {
    text: (0, $cWSfz.textProperties)
};
const $38954abdaadeb338$export$25069d271a4443b2 = (newProps)=>{
    $38954abdaadeb338$export$8714badcfa4caafb = {
        ...$38954abdaadeb338$export$8714badcfa4caafb,
        ...newProps
    };
};

});
parcelRegister("cWSfz", function(module, exports) {

$parcel$export(module.exports, "textProperties", function () { return $96d4fbc7a341a087$export$b9f5db49c77be77f; });
$parcel$export(module.exports, "textMethods", function () { return $96d4fbc7a341a087$export$8e502bccaff93437; });
const $96d4fbc7a341a087$export$b9f5db49c77be77f = (prop, textValue, context)=>{
    var _textPropertiesLookup;
    return (_textPropertiesLookup = $96d4fbc7a341a087$var$textPropertiesLookup[prop]) === null || _textPropertiesLookup === void 0 ? void 0 : _textPropertiesLookup.call($96d4fbc7a341a087$var$textPropertiesLookup, textValue, context);
};
const $96d4fbc7a341a087$var$textPropertiesLookup = {
    length: (textValue, context)=>({
            type: "number",
            value: textValue.value.length
        })
};
const $96d4fbc7a341a087$export$8e502bccaff93437 = {};

});


parcelRegister("1KElr", function(module, exports) {

$parcel$export(module.exports, "Methods", function () { return $146961f1e298618a$export$abe5cd09e951a89a; });
$parcel$export(module.exports, "addMethods", function () { return $146961f1e298618a$export$626ce79af72fc3d3; });

var $cWSfz = parcelRequire("cWSfz");
let $146961f1e298618a$export$abe5cd09e951a89a = {
    text: (0, $cWSfz.textMethods)
};
const $146961f1e298618a$export$626ce79af72fc3d3 = (newMeths)=>{
    $146961f1e298618a$export$abe5cd09e951a89a = {
        ...$146961f1e298618a$export$abe5cd09e951a89a,
        ...newMeths
    };
};

});

parcelRegister("j7zix", function(module, exports) {

$parcel$export(module.exports, "setGetHashObj", function () { return $deba0d3171eede28$export$8e01281f14bbe8a3; });
$parcel$export(module.exports, "setGetAtObj", function () { return $deba0d3171eede28$export$fb0166b6a3ca2434; });
$parcel$export(module.exports, "setGetContextObj", function () { return $deba0d3171eede28$export$1b324680ae6b31b5; });
$parcel$export(module.exports, "getHashReferenceObject", function () { return $deba0d3171eede28$export$ff6cc93a5b9478c3; });
$parcel$export(module.exports, "getAtReferenceObject", function () { return $deba0d3171eede28$export$1ff62241d409976d; });
$parcel$export(module.exports, "getContextReferenceObject", function () { return $deba0d3171eede28$export$270a34244357bdcb; });
let $deba0d3171eede28$export$1c378393ceebe07d = (ref, contextRef)=>null;
const $deba0d3171eede28$export$8e01281f14bbe8a3 = (newLookupFunc)=>$deba0d3171eede28$export$1c378393ceebe07d = newLookupFunc !== null && newLookupFunc !== void 0 ? newLookupFunc : $deba0d3171eede28$export$1c378393ceebe07d;
let $deba0d3171eede28$export$1a026f087e274241 = (ref, contextRef)=>null;
const $deba0d3171eede28$export$fb0166b6a3ca2434 = (newLookupFunc)=>$deba0d3171eede28$export$1a026f087e274241 = newLookupFunc !== null && newLookupFunc !== void 0 ? newLookupFunc : $deba0d3171eede28$export$1a026f087e274241;
let $deba0d3171eede28$export$db89a4411af472ae = (contextRef)=>null;
const $deba0d3171eede28$export$1b324680ae6b31b5 = (newLookupFunc)=>$deba0d3171eede28$export$db89a4411af472ae = newLookupFunc !== null && newLookupFunc !== void 0 ? newLookupFunc : $deba0d3171eede28$export$db89a4411af472ae;
const $deba0d3171eede28$export$ff6cc93a5b9478c3 = (ref, contextRef)=>{
    return $deba0d3171eede28$export$1c378393ceebe07d(ref, contextRef);
};
const $deba0d3171eede28$export$1ff62241d409976d = (ref, contextRef)=>{
    return $deba0d3171eede28$export$1a026f087e274241(ref, contextRef);
};
const $deba0d3171eede28$export$270a34244357bdcb = (contextRef)=>{
    return $deba0d3171eede28$export$db89a4411af472ae(contextRef);
};

});

parcelRegister("aFtfn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c446b93741ca635$export$2e2bcd8739ae039; });

var $cNwQA = parcelRequire("cNwQA");

var $iCTvZ = parcelRequire("iCTvZ");

var $9AXSd = parcelRequire("9AXSd");

var $cjCbh = parcelRequire("cjCbh");

var $4LeDk = parcelRequire("4LeDk");
function $7c446b93741ca635$var$_defineProperty(e, r, t) {
    return (r = $7c446b93741ca635$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7c446b93741ca635$var$_toPropertyKey(t) {
    var i = $7c446b93741ca635$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c446b93741ca635$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// import { unitDefinitions } from "../../TimelineHelpers";
// // import CanvasStore from "../../CanvasStore";
// import { roundDateToNearestUnit } from "@ryki/datemath";
// import { getReferenceObject } from "./core/ReferenceLookup";
class $7c446b93741ca635$var$Formula {
    constructor({ ref: /*context,*/ ref, prop: prop, expectedType: expectedType, formula: formula }){
        var _ref;
        $7c446b93741ca635$var$_defineProperty(this, "ref", (0, (/*@__PURE__*/$parcel$interopDefault($cjCbh)))());
        // context = null;
        $7c446b93741ca635$var$_defineProperty(this, "prop", null);
        $7c446b93741ca635$var$_defineProperty(this, "expectedType", null);
        $7c446b93741ca635$var$_defineProperty(this, "_formula", "");
        $7c446b93741ca635$var$_defineProperty(this, "cachedAst", {});
        $7c446b93741ca635$var$_defineProperty(this, "cachedValidAst", {});
        $7c446b93741ca635$var$_defineProperty(this, "updateListeners", new Set());
        $7c446b93741ca635$var$_defineProperty(this, "needsUpdate", true);
        // this.context = context;
        this.ref = ref;
        this.prop = prop;
        this._formula = (_ref = formula !== null && formula !== void 0 ? formula : (0, $9AXSd.formulaDefaults)[expectedType]) !== null && _ref !== void 0 ? _ref : "";
        (0, $4LeDk.storeFormula)(this);
        this.update = this.update.bind(this);
        this.prepareUpdate = this.prepareUpdate.bind(this);
    }
    get formula() {
        return this._formula;
    }
    set formula(newFormula) {
        this._formula = newFormula;
        this.prepareUpdate();
        (0, $4LeDk.updateFormulas)();
    }
    update() {
        for (const listenter of this.updateListeners)listenter();
    }
    prepareUpdate() {
        (0, $4LeDk.prepareFormulaForUpdate)(this);
        this.needsUpdate = true;
        for (const dep of (0, $4LeDk.getDependants)(this))dep.prepareUpdate();
    }
    get context() {
        return (0, $iCTvZ.default)(this.ref, this.prop);
    }
    get ast() {
        var _this$cachedAst, _this$cachedAst2;
        if (!this.needsUpdate) return this.cachedAst;
        const oldDeps = this.cachedValidAst.dependencies || new Map();
        this.cachedAst = (0, $cNwQA.parseFormula)(this.formula, this.context);
        if ((_this$cachedAst = this.cachedAst) !== null && _this$cachedAst !== void 0 && _this$cachedAst.type && ((_this$cachedAst2 = this.cachedAst) === null || _this$cachedAst2 === void 0 ? void 0 : _this$cachedAst2.type) !== "error") this.cachedValidAst = {
            ...this.cachedAst
        };
        const newDeps = this.cachedValidAst.dependencies || new Map();
        if (!(oldDeps.size === newDeps.size && [
            ...newDeps.keys()
        ].every((dep)=>oldDeps.has(dep)))) (0, $4LeDk.updateDependencies)(this, oldDeps, newDeps);
        this.needsUpdate = false;
        return this.cachedAst;
    }
    get validAst() {
        var _this$ast, _this$ast2;
        return ((_this$ast = this.ast) === null || _this$ast === void 0 ? void 0 : _this$ast.type) && ((_this$ast2 = this.ast) === null || _this$ast2 === void 0 ? void 0 : _this$ast2.type) !== "error";
    }
    get type() {
        return this.validAst && this.ast.type || this.cachedValidAst.type;
    }
    get value() {
        return this.validAst && this.ast.value || this.cachedValidAst.value;
    }
    get dependencies() {
        return this.validAst && this.ast.dependencies || this.cachedValidAst.dependencies || new Map();
    }
    adjustToValue(newVal) {
        const newFormula = (0, $9AXSd.adjustFormulaToValue)(this.ast, newVal, this.context);
        this.formula = newFormula;
        return newFormula;
    }
}
var $7c446b93741ca635$export$2e2bcd8739ae039 = $7c446b93741ca635$var$Formula;

});
parcelRegister("cNwQA", function(module, exports) {

$parcel$export(module.exports, "parseFormula", function () { return $95138a659258a649$export$eeb32a119aed5e3; });

var $ju1Ry = parcelRequire("ju1Ry");

var $17tCx = parcelRequire("17tCx");
parcelRequire("dpgWR");
const $95138a659258a649$export$eeb32a119aed5e3 = (string, context)=>{
    if (!string) return;
    const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($ju1Ry))).Parser((0, (/*@__PURE__*/$parcel$interopDefault($ju1Ry))).Grammar.fromCompiled((0, $17tCx.default)(context)));
    try {
        parser.feed(string);
        return parser.results[0];
    } catch (err) {
        //error breaks things for some reason
        return {
            type: "error"
        };
    }
};

});
parcelRegister("ju1Ry", function(module, exports) {
(function(root, factory) {
    if (0, module.exports) module.exports = factory();
    else root.nearley = factory();
})(module.exports, function() {
    function Rule(name, symbols, postprocess) {
        this.id = ++Rule.highestId;
        this.name = name;
        this.symbols = symbols; // a list of literal | regex class | nonterminal
        this.postprocess = postprocess;
        return this;
    }
    Rule.highestId = 0;
    Rule.prototype.toString = function(withCursorAt) {
        var symbolSequence = typeof withCursorAt === "undefined" ? this.symbols.map(getSymbolShortDisplay).join(" ") : this.symbols.slice(0, withCursorAt).map(getSymbolShortDisplay).join(" ") + " \u25CF " + this.symbols.slice(withCursorAt).map(getSymbolShortDisplay).join(" ");
        return this.name + " \u2192 " + symbolSequence;
    };
    // a State is a rule at a position from a given starting point in the input stream (reference)
    function State(rule, dot, reference, wantedBy) {
        this.rule = rule;
        this.dot = dot;
        this.reference = reference;
        this.data = [];
        this.wantedBy = wantedBy;
        this.isComplete = this.dot === rule.symbols.length;
    }
    State.prototype.toString = function() {
        return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
    };
    State.prototype.nextState = function(child) {
        var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
        state.left = this;
        state.right = child;
        if (state.isComplete) {
            state.data = state.build();
            // Having right set here will prevent the right state and its children
            // form being garbage collected
            state.right = undefined;
        }
        return state;
    };
    State.prototype.build = function() {
        var children = [];
        var node = this;
        do {
            children.push(node.right.data);
            node = node.left;
        }while (node.left);
        children.reverse();
        return children;
    };
    State.prototype.finish = function() {
        if (this.rule.postprocess) this.data = this.rule.postprocess(this.data, this.reference, Parser.fail);
    };
    function Column(grammar, index) {
        this.grammar = grammar;
        this.index = index;
        this.states = [];
        this.wants = {}; // states indexed by the non-terminal they expect
        this.scannable = []; // list of states that expect a token
        this.completed = {}; // states that are nullable
    }
    Column.prototype.process = function(nextColumn) {
        var states = this.states;
        var wants = this.wants;
        var completed = this.completed;
        for(var w = 0; w < states.length; w++){
            var state = states[w];
            if (state.isComplete) {
                state.finish();
                if (state.data !== Parser.fail) {
                    // complete
                    var wantedBy = state.wantedBy;
                    for(var i = wantedBy.length; i--;){
                        var left = wantedBy[i];
                        this.complete(left, state);
                    }
                    // special-case nullables
                    if (state.reference === this.index) {
                        // make sure future predictors of this rule get completed.
                        var exp = state.rule.name;
                        (this.completed[exp] = this.completed[exp] || []).push(state);
                    }
                }
            } else {
                // queue scannable states
                var exp = state.rule.symbols[state.dot];
                if (typeof exp !== "string") {
                    this.scannable.push(state);
                    continue;
                }
                // predict
                if (wants[exp]) {
                    wants[exp].push(state);
                    if (completed.hasOwnProperty(exp)) {
                        var nulls = completed[exp];
                        for(var i = 0; i < nulls.length; i++){
                            var right = nulls[i];
                            this.complete(state, right);
                        }
                    }
                } else {
                    wants[exp] = [
                        state
                    ];
                    this.predict(exp);
                }
            }
        }
    };
    Column.prototype.predict = function(exp) {
        var rules = this.grammar.byName[exp] || [];
        for(var i = 0; i < rules.length; i++){
            var r = rules[i];
            var wantedBy = this.wants[exp];
            var s = new State(r, 0, this.index, wantedBy);
            this.states.push(s);
        }
    };
    Column.prototype.complete = function(left, right) {
        var copy = left.nextState(right);
        this.states.push(copy);
    };
    function Grammar(rules, start) {
        this.rules = rules;
        this.start = start || this.rules[0].name;
        var byName = this.byName = {};
        this.rules.forEach(function(rule) {
            if (!byName.hasOwnProperty(rule.name)) byName[rule.name] = [];
            byName[rule.name].push(rule);
        });
    }
    // So we can allow passing (rules, start) directly to Parser for backwards compatibility
    Grammar.fromCompiled = function(rules, start) {
        var lexer = rules.Lexer;
        if (rules.ParserStart) {
            start = rules.ParserStart;
            rules = rules.ParserRules;
        }
        var rules = rules.map(function(r) {
            return new Rule(r.name, r.symbols, r.postprocess);
        });
        var g = new Grammar(rules, start);
        g.lexer = lexer; // nb. storing lexer on Grammar is iffy, but unavoidable
        return g;
    };
    function StreamLexer() {
        this.reset("");
    }
    StreamLexer.prototype.reset = function(data, state) {
        this.buffer = data;
        this.index = 0;
        this.line = state ? state.line : 1;
        this.lastLineBreak = state ? -state.col : 0;
    };
    StreamLexer.prototype.next = function() {
        if (this.index < this.buffer.length) {
            var ch = this.buffer[this.index++];
            if (ch === "\n") {
                this.line += 1;
                this.lastLineBreak = this.index;
            }
            return {
                value: ch
            };
        }
    };
    StreamLexer.prototype.save = function() {
        return {
            line: this.line,
            col: this.index - this.lastLineBreak
        };
    };
    StreamLexer.prototype.formatError = function(token, message) {
        // nb. this gets called after consuming the offending token,
        // so the culprit is index-1
        var buffer = this.buffer;
        if (typeof buffer === "string") {
            var lines = buffer.split("\n").slice(Math.max(0, this.line - 5), this.line);
            var nextLineBreak = buffer.indexOf("\n", this.index);
            if (nextLineBreak === -1) nextLineBreak = buffer.length;
            var col = this.index - this.lastLineBreak;
            var lastLineDigits = String(this.line).length;
            message += " at line " + this.line + " col " + col + ":\n\n";
            message += lines.map(function(line, i) {
                return pad(this.line - lines.length + i + 1, lastLineDigits) + " " + line;
            }, this).join("\n");
            message += "\n" + pad("", lastLineDigits + col) + "^\n";
            return message;
        } else return message + " at index " + (this.index - 1);
        function pad(n, length) {
            var s = String(n);
            return Array(length - s.length + 1).join(" ") + s;
        }
    };
    function Parser(rules, start, options) {
        if (rules instanceof Grammar) {
            var grammar = rules;
            var options = start;
        } else var grammar = Grammar.fromCompiled(rules, start);
        this.grammar = grammar;
        // Read options
        this.options = {
            keepHistory: false,
            lexer: grammar.lexer || new StreamLexer
        };
        for(var key in options || {})this.options[key] = options[key];
        // Setup lexer
        this.lexer = this.options.lexer;
        this.lexerState = undefined;
        // Setup a table
        var column = new Column(grammar, 0);
        var table = this.table = [
            column
        ];
        // I could be expecting anything.
        column.wants[grammar.start] = [];
        column.predict(grammar.start);
        // TODO what if start rule is nullable?
        column.process();
        this.current = 0; // token index
    }
    // create a reserved token for indicating a parse fail
    Parser.fail = {};
    Parser.prototype.feed = function(chunk) {
        var lexer = this.lexer;
        lexer.reset(chunk, this.lexerState);
        var token;
        while(true){
            try {
                token = lexer.next();
                if (!token) break;
            } catch (e) {
                // Create the next column so that the error reporter
                // can display the correctly predicted states.
                var nextColumn = new Column(this.grammar, this.current + 1);
                this.table.push(nextColumn);
                var err = new Error(this.reportLexerError(e));
                err.offset = this.current;
                err.token = e.token;
                throw err;
            }
            // We add new states to table[current+1]
            var column = this.table[this.current];
            // GC unused states
            if (!this.options.keepHistory) delete this.table[this.current - 1];
            var n = this.current + 1;
            var nextColumn = new Column(this.grammar, n);
            this.table.push(nextColumn);
            // Advance all tokens that expect the symbol
            var literal = token.text !== undefined ? token.text : token.value;
            var value = lexer.constructor === StreamLexer ? token.value : token;
            var scannable = column.scannable;
            for(var w = scannable.length; w--;){
                var state = scannable[w];
                var expect = state.rule.symbols[state.dot];
                // Try to consume the token
                // either regex or literal
                if (expect.test ? expect.test(value) : expect.type ? expect.type === token.type : expect.literal === literal) {
                    // Add it
                    var next = state.nextState({
                        data: value,
                        token: token,
                        isToken: true,
                        reference: n - 1
                    });
                    nextColumn.states.push(next);
                }
            }
            // Next, for each of the rules, we either
            // (a) complete it, and try to see if the reference row expected that
            //     rule
            // (b) predict the next nonterminal it expects by adding that
            //     nonterminal's start state
            // To prevent duplication, we also keep track of rules we have already
            // added
            nextColumn.process();
            // If needed, throw an error:
            if (nextColumn.states.length === 0) {
                // No states at all! This is not good.
                var err = new Error(this.reportError(token));
                err.offset = this.current;
                err.token = token;
                throw err;
            }
            // maybe save lexer state
            if (this.options.keepHistory) column.lexerState = lexer.save();
            this.current++;
        }
        if (column) this.lexerState = lexer.save();
        // Incrementally keep track of results
        this.results = this.finish();
        // Allow chaining, for whatever it's worth
        return this;
    };
    Parser.prototype.reportLexerError = function(lexerError) {
        var tokenDisplay, lexerMessage;
        // Planning to add a token property to moo's thrown error
        // even on erroring tokens to be used in error display below
        var token = lexerError.token;
        if (token) {
            tokenDisplay = "input " + JSON.stringify(token.text[0]) + " (lexer error)";
            lexerMessage = this.lexer.formatError(token, "Syntax error");
        } else {
            tokenDisplay = "input (lexer error)";
            lexerMessage = lexerError.message;
        }
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser.prototype.reportError = function(token) {
        var tokenDisplay = (token.type ? token.type + " token: " : "") + JSON.stringify(token.value !== undefined ? token.value : token);
        var lexerMessage = this.lexer.formatError(token, "Syntax error");
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser.prototype.reportErrorCommon = function(lexerMessage, tokenDisplay) {
        var lines = [];
        lines.push(lexerMessage);
        var lastColumnIndex = this.table.length - 2;
        var lastColumn = this.table[lastColumnIndex];
        var expectantStates = lastColumn.states.filter(function(state) {
            var nextSymbol = state.rule.symbols[state.dot];
            return nextSymbol && typeof nextSymbol !== "string";
        });
        if (expectantStates.length === 0) {
            lines.push("Unexpected " + tokenDisplay + ". I did not expect any more input. Here is the state of my parse table:\n");
            this.displayStateStack(lastColumn.states, lines);
        } else {
            lines.push("Unexpected " + tokenDisplay + ". Instead, I was expecting to see one of the following:\n");
            // Display a "state stack" for each expectant state
            // - which shows you how this state came to be, step by step.
            // If there is more than one derivation, we only display the first one.
            var stateStacks = expectantStates.map(function(state) {
                return this.buildFirstStateStack(state, []) || [
                    state
                ];
            }, this);
            // Display each state that is expecting a terminal symbol next.
            stateStacks.forEach(function(stateStack) {
                var state = stateStack[0];
                var nextSymbol = state.rule.symbols[state.dot];
                var symbolDisplay = this.getSymbolDisplay(nextSymbol);
                lines.push("A " + symbolDisplay + " based on:");
                this.displayStateStack(stateStack, lines);
            }, this);
        }
        lines.push("");
        return lines.join("\n");
    };
    Parser.prototype.displayStateStack = function(stateStack, lines) {
        var lastDisplay;
        var sameDisplayCount = 0;
        for(var j = 0; j < stateStack.length; j++){
            var state = stateStack[j];
            var display = state.rule.toString(state.dot);
            if (display === lastDisplay) sameDisplayCount++;
            else {
                if (sameDisplayCount > 0) lines.push("    ^ " + sameDisplayCount + " more lines identical to this");
                sameDisplayCount = 0;
                lines.push("    " + display);
            }
            lastDisplay = display;
        }
    };
    Parser.prototype.getSymbolDisplay = function(symbol) {
        return getSymbolLongDisplay(symbol);
    };
    /*
    Builds a the first state stack. You can think of a state stack as the call stack
    of the recursive-descent parser which the Nearley parse algorithm simulates.
    A state stack is represented as an array of state objects. Within a
    state stack, the first item of the array will be the starting
    state, with each successive item in the array going further back into history.

    This function needs to be given a starting state and an empty array representing
    the visited states, and it returns an single state stack.

    */ Parser.prototype.buildFirstStateStack = function(state, visited) {
        if (visited.indexOf(state) !== -1) // Found cycle, return null
        // to eliminate this path from the results, because
        // we don't know how to display it meaningfully
        return null;
        if (state.wantedBy.length === 0) return [
            state
        ];
        var prevState = state.wantedBy[0];
        var childVisited = [
            state
        ].concat(visited);
        var childResult = this.buildFirstStateStack(prevState, childVisited);
        if (childResult === null) return null;
        return [
            state
        ].concat(childResult);
    };
    Parser.prototype.save = function() {
        var column = this.table[this.current];
        column.lexerState = this.lexerState;
        return column;
    };
    Parser.prototype.restore = function(column) {
        var index = column.index;
        this.current = index;
        this.table[index] = column;
        this.table.splice(index + 1);
        this.lexerState = column.lexerState;
        // Incrementally keep track of results
        this.results = this.finish();
    };
    // nb. deprecated: use save/restore instead!
    Parser.prototype.rewind = function(index) {
        if (!this.options.keepHistory) throw new Error("set option `keepHistory` to enable rewinding");
        // nb. recall column (table) indicies fall between token indicies.
        //        col 0   --   token 0   --   col 1
        this.restore(this.table[index]);
    };
    Parser.prototype.finish = function() {
        // Return the possible parsings
        var considerations = [];
        var start = this.grammar.start;
        var column = this.table[this.table.length - 1];
        column.states.forEach(function(t) {
            if (t.rule.name === start && t.dot === t.rule.symbols.length && t.reference === 0 && t.data !== Parser.fail) considerations.push(t);
        });
        return considerations.map(function(c) {
            return c.data;
        });
    };
    function getSymbolLongDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") return symbol;
        else if (type === "object") {
            if (symbol.literal) return JSON.stringify(symbol.literal);
            else if (symbol instanceof RegExp) return "character matching " + symbol;
            else if (symbol.type) return symbol.type + " token";
            else if (symbol.test) return "token matching " + String(symbol.test);
            else throw new Error("Unknown symbol type: " + symbol);
        }
    }
    function getSymbolShortDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") return symbol;
        else if (type === "object") {
            if (symbol.literal) return JSON.stringify(symbol.literal);
            else if (symbol instanceof RegExp) return symbol.toString();
            else if (symbol.type) return "%" + symbol.type;
            else if (symbol.test) return "<" + String(symbol.test) + ">";
            else throw new Error("Unknown symbol type: " + symbol);
        }
    }
    return {
        Parser: Parser,
        Grammar: Grammar,
        Rule: Rule
    };
});

});

parcelRegister("17tCx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0d0d6be935a6e722$export$2e2bcd8739ae039; });
// Generated automatically by nearley, version 2.19.3
// http://github.com/Hardmath123/nearley

function $0d0d6be935a6e722$export$2e2bcd8739ae039(context) {
    function id(x) {
        return x[0];
    }
    const FormulaNode = (parcelRequire("dpgWR")).FormulaNode;
    const makeString = (d)=>{
        return d.map((e)=>{
            var _ref, _e$matchString;
            return (_ref = (_e$matchString = e === null || e === void 0 ? void 0 : e.matchString) !== null && _e$matchString !== void 0 ? _e$matchString : e) !== null && _ref !== void 0 ? _ref : "";
        }).join("");
    };
    const modifyString = (objects, opVal)=>{
        const str = makeString(objects);
        opVal.matchString = str;
        return opVal;
    };
    const op = (name, objects, inputs)=>{
        return FormulaNode(name, inputs, makeString(objects), context);
    };
    var grammar = {
        Lexer: undefined,
        ParserRules: [
            {
                "name": "value",
                "symbols": [
                    "expression"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "function",
                "symbols": [
                    "P",
                    {
                        "literal": "."
                    },
                    "string",
                    {
                        "literal": "("
                    },
                    "array",
                    {
                        "literal": ")"
                    }
                ],
                "postprocess": (d)=>op("method", d, {
                        object: d[0],
                        method: d[2],
                        args: d[4]
                    })
            },
            {
                "name": "function",
                "symbols": [
                    "P",
                    {
                        "literal": "."
                    },
                    "string"
                ],
                "postprocess": (d)=>op("property", d, {
                        object: d[0],
                        prop: d[2]
                    })
            },
            {
                "name": "function",
                "symbols": [
                    "context",
                    "string"
                ],
                "postprocess": (d)=>op("property", d, {
                        object: d[0],
                        prop: d[1]
                    })
            },
            {
                "name": "function",
                "symbols": [
                    "string",
                    {
                        "literal": "("
                    },
                    "array",
                    {
                        "literal": ")"
                    }
                ],
                "postprocess": (d)=>op("function", d, {
                        funcName: d[0],
                        args: d[2]
                    })
            },
            {
                "name": "function",
                "symbols": [
                    "basicObject"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "array",
                "symbols": [
                    "condition",
                    "_",
                    {
                        "literal": ","
                    },
                    "_",
                    "array"
                ],
                "postprocess": (d)=>op("array", d, {
                        array: [
                            d[0],
                            ...d[4].type === "array" ? d[4].value : [
                                d[4]
                            ]
                        ]
                    })
            },
            {
                "name": "array",
                "symbols": [
                    "condition"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "range"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "context"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "dateTime"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "time"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "hashRef"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "atRef"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "text"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "percent"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "duration"
                ]
            },
            {
                "name": "basicObject$subexpression$1",
                "symbols": [
                    "float"
                ]
            },
            {
                "name": "basicObject",
                "symbols": [
                    "basicObject$subexpression$1"
                ],
                "postprocess": (d)=>d[0][0]
            },
            {
                "name": "expression",
                "symbols": [
                    "_",
                    "array",
                    "_"
                ],
                "postprocess": (d)=>d[1].length === 1 ? d[1][0] : d[1]
            },
            {
                "name": "condition$subexpression$1",
                "symbols": [
                    /[iI]/,
                    /[fF]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition$subexpression$2",
                "symbols": [
                    /[tT]/,
                    /[hH]/,
                    /[eE]/,
                    /[nN]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition$subexpression$3",
                "symbols": [
                    /[eE]/,
                    /[lL]/,
                    /[sS]/,
                    /[eE]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition",
                "symbols": [
                    "condition$subexpression$1",
                    "__",
                    "condition",
                    "__",
                    "condition$subexpression$2",
                    "__",
                    "condition",
                    "__",
                    "condition$subexpression$3",
                    "__",
                    "condition"
                ],
                "postprocess": (d)=>op("ifElse", d, {
                        if: d[2],
                        then: d[6],
                        else: d[10]
                    })
            },
            {
                "name": "condition",
                "symbols": [
                    "condition",
                    "_",
                    {
                        "literal": "?"
                    },
                    "_",
                    "condition",
                    "_",
                    {
                        "literal": ":"
                    },
                    "_",
                    "condition"
                ],
                "postprocess": (d)=>op("ifElse", d, {
                        if: d[0],
                        then: d[4],
                        else: d[8]
                    })
            },
            {
                "name": "condition$subexpression$4",
                "symbols": [
                    /[iI]/,
                    /[fF]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition$subexpression$5",
                "symbols": [
                    /[eE]/,
                    /[lL]/,
                    /[sS]/,
                    /[eE]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "condition",
                "symbols": [
                    "condition",
                    "_",
                    "condition$subexpression$4",
                    "_",
                    "condition",
                    "_",
                    "condition$subexpression$5",
                    "_",
                    "condition"
                ],
                "postprocess": (d)=>op("ifElse", d, {
                        if: d[4],
                        then: d[0],
                        else: d[8]
                    })
            },
            {
                "name": "condition",
                "symbols": [
                    "comparison"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    {
                        "literal": "="
                    },
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("equal", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison$string$1",
                "symbols": [
                    {
                        "literal": ">"
                    },
                    {
                        "literal": "="
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join("");
                }
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    "comparison$string$1",
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("greaterThanEqual", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison$string$2",
                "symbols": [
                    {
                        "literal": "<"
                    },
                    {
                        "literal": "="
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join("");
                }
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    "comparison$string$2",
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("lessThanEqual", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    {
                        "literal": ">"
                    },
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("greaterThan", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison",
                "symbols": [
                    "comparison",
                    "_",
                    {
                        "literal": "<"
                    },
                    "_",
                    "logic"
                ],
                "postprocess": (d)=>op("lessThan", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "comparison",
                "symbols": [
                    "logic"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "logic$subexpression$1",
                "symbols": [
                    /[aA]/,
                    /[nN]/,
                    /[dD]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "logic",
                "symbols": [
                    "logic",
                    "__",
                    "logic$subexpression$1",
                    "__",
                    "AS"
                ],
                "postprocess": (d)=>op("and", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "logic",
                "symbols": [
                    "logic",
                    "_",
                    {
                        "literal": "&"
                    },
                    "_",
                    "AS"
                ],
                "postprocess": (d)=>op("and", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "logic$subexpression$2",
                "symbols": [
                    /[oO]/,
                    /[rR]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "logic",
                "symbols": [
                    "logic",
                    "__",
                    "logic$subexpression$2",
                    "__",
                    "AS"
                ],
                "postprocess": (d)=>op("or", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "logic",
                "symbols": [
                    "logic",
                    "_",
                    {
                        "literal": "|"
                    },
                    "_",
                    "AS"
                ],
                "postprocess": (d)=>op("or", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "logic",
                "symbols": [
                    "AS"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "P",
                "symbols": [
                    {
                        "literal": "("
                    },
                    "_",
                    "value",
                    "_",
                    {
                        "literal": ")"
                    }
                ],
                "postprocess": (d)=>modifyString(d, d[2])
            },
            {
                "name": "P",
                "symbols": [
                    "function"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "not$subexpression$1",
                "symbols": [
                    /[nN]/,
                    /[oO]/,
                    /[tT]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "not",
                "symbols": [
                    "not$subexpression$1",
                    "__",
                    "not"
                ],
                "postprocess": (d)=>op("not", d, {
                        val: {
                            ...d[2]
                        }
                    })
            },
            {
                "name": "not",
                "symbols": [
                    {
                        "literal": "!"
                    },
                    "_",
                    "not"
                ],
                "postprocess": (d)=>op("not", d, {
                        val: {
                            ...d[2]
                        }
                    })
            },
            {
                "name": "not",
                "symbols": [
                    "P"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "E",
                "symbols": [
                    "not",
                    "_",
                    {
                        "literal": "^"
                    },
                    "_",
                    "E"
                ],
                "postprocess": (d)=>op("power", d, {
                        base: d[0],
                        power: d[4]
                    })
            },
            {
                "name": "E",
                "symbols": [
                    "not"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "MD",
                "symbols": [
                    "MD",
                    "_",
                    {
                        "literal": "*"
                    },
                    "_",
                    "E"
                ],
                "postprocess": (d)=>op("multiply", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "MD",
                "symbols": [
                    "MD",
                    "_",
                    {
                        "literal": "/"
                    },
                    "_",
                    "E"
                ],
                "postprocess": (d)=>op("divide", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "MD",
                "symbols": [
                    "E"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "AS",
                "symbols": [
                    "AS",
                    "_",
                    {
                        "literal": "+"
                    },
                    "_",
                    "MD"
                ],
                "postprocess": (d)=>op("add", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "AS",
                "symbols": [
                    "AS",
                    "_",
                    {
                        "literal": "-"
                    },
                    "_",
                    "MD"
                ],
                "postprocess": (d)=>op("subtract", d, {
                        left: d[0],
                        right: d[4]
                    })
            },
            {
                "name": "AS",
                "symbols": [
                    "MD"
                ],
                "postprocess": (d)=>d[0]
            },
            {
                "name": "context",
                "symbols": [
                    {
                        "literal": "$"
                    }
                ],
                "postprocess": (d)=>op("context", d, {
                        context: context
                    })
            },
            {
                "name": "hashRef",
                "symbols": [
                    {
                        "literal": "#"
                    },
                    "ref"
                ],
                "postprocess": (d)=>op("hashRef", d, {
                        context: context,
                        ref: d[1]
                    })
            },
            {
                "name": "atRef",
                "symbols": [
                    {
                        "literal": "@"
                    },
                    "ref"
                ],
                "postprocess": (d)=>op("atRef", d, {
                        context: context,
                        ref: d[1]
                    })
            },
            {
                "name": "range$string$1",
                "symbols": [
                    {
                        "literal": "-"
                    },
                    {
                        "literal": ">"
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join("");
                }
            },
            {
                "name": "range",
                "symbols": [
                    "P",
                    "_",
                    "range$string$1",
                    "_",
                    "P"
                ],
                "postprocess": (d)=>op("range", d, {
                        start: d[0],
                        end: d[4]
                    })
            },
            {
                "name": "duration",
                "symbols": [
                    "P",
                    "__",
                    "durationUnit"
                ],
                "postprocess": (d)=>op("duration", d, {
                        amount: d[0],
                        unit: d[2]
                    })
            },
            {
                "name": "duration",
                "symbols": [
                    "P",
                    "__",
                    "durationUnitSingular"
                ],
                "postprocess": (d)=>op("duration", d, {
                        amount: d[0],
                        unit: `${d[2]}s`
                    })
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$1",
                "symbols": [
                    /[mM]/,
                    /[iI]/,
                    /[lL]/,
                    /[lL]/,
                    /[iI]/,
                    /[sS]/,
                    /[eE]/,
                    /[cC]/,
                    /[oO]/,
                    /[nN]/,
                    /[dD]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$2",
                "symbols": [
                    /[sS]/,
                    /[eE]/,
                    /[cC]/,
                    /[oO]/,
                    /[nN]/,
                    /[dD]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$3",
                "symbols": [
                    /[mM]/,
                    /[iI]/,
                    /[nN]/,
                    /[uU]/,
                    /[tT]/,
                    /[eE]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$3"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$4",
                "symbols": [
                    /[hH]/,
                    /[oO]/,
                    /[uU]/,
                    /[rR]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$4"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$5",
                "symbols": [
                    /[dD]/,
                    /[aA]/,
                    /[yY]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$5"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$6",
                "symbols": [
                    /[wW]/,
                    /[eE]/,
                    /[eE]/,
                    /[kK]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$6"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$7",
                "symbols": [
                    /[mM]/,
                    /[oO]/,
                    /[nN]/,
                    /[tT]/,
                    /[hH]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$7"
                ]
            },
            {
                "name": "durationUnit$subexpression$1$subexpression$8",
                "symbols": [
                    /[yY]/,
                    /[eE]/,
                    /[aA]/,
                    /[rR]/,
                    /[sS]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnit$subexpression$1",
                "symbols": [
                    "durationUnit$subexpression$1$subexpression$8"
                ]
            },
            {
                "name": "durationUnit",
                "symbols": [
                    "durationUnit$subexpression$1"
                ],
                "postprocess": (d)=>d[0][0]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$1",
                "symbols": [
                    /[mM]/,
                    /[iI]/,
                    /[lL]/,
                    /[lL]/,
                    /[iI]/,
                    /[sS]/,
                    /[eE]/,
                    /[cC]/,
                    /[oO]/,
                    /[nN]/,
                    /[dD]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$2",
                "symbols": [
                    /[sS]/,
                    /[eE]/,
                    /[cC]/,
                    /[oO]/,
                    /[nN]/,
                    /[dD]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$3",
                "symbols": [
                    /[mM]/,
                    /[iI]/,
                    /[nN]/,
                    /[uU]/,
                    /[tT]/,
                    /[eE]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$3"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$4",
                "symbols": [
                    /[hH]/,
                    /[oO]/,
                    /[uU]/,
                    /[rR]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$4"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$5",
                "symbols": [
                    /[dD]/,
                    /[aA]/,
                    /[yY]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$5"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$6",
                "symbols": [
                    /[wW]/,
                    /[eE]/,
                    /[eE]/,
                    /[kK]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$6"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$7",
                "symbols": [
                    /[mM]/,
                    /[oO]/,
                    /[nN]/,
                    /[tT]/,
                    /[hH]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$7"
                ]
            },
            {
                "name": "durationUnitSingular$subexpression$1$subexpression$8",
                "symbols": [
                    /[yY]/,
                    /[eE]/,
                    /[aA]/,
                    /[rR]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "durationUnitSingular$subexpression$1",
                "symbols": [
                    "durationUnitSingular$subexpression$1$subexpression$8"
                ]
            },
            {
                "name": "durationUnitSingular",
                "symbols": [
                    "durationUnitSingular$subexpression$1"
                ],
                "postprocess": (d)=>d[0][0]
            },
            {
                "name": "dateTime",
                "symbols": [
                    "date",
                    "__",
                    "time"
                ],
                "postprocess": (d)=>op("dateTime", d, {
                        date: d[0],
                        time: d[2]
                    })
            },
            {
                "name": "dateTime",
                "symbols": [
                    "time",
                    "__",
                    "date"
                ],
                "postprocess": (d)=>op("dateTime", d, {
                        date: d[2],
                        time: d[0]
                    })
            },
            {
                "name": "dateTime",
                "symbols": [
                    "date"
                ],
                "postprocess": (d)=>op("dateTime", d, {
                        date: d[0]
                    })
            },
            {
                "name": "date",
                "symbols": [
                    "int",
                    {
                        "literal": "."
                    },
                    "int",
                    {
                        "literal": "."
                    },
                    "int"
                ],
                "postprocess": (d)=>op("date", d, {
                        day: d[0],
                        month: d[2],
                        year: d[4]
                    })
            },
            {
                "name": "time$ebnf$1$subexpression$1$subexpression$1",
                "symbols": [
                    /[aA]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$ebnf$1$subexpression$1",
                "symbols": [
                    "time$ebnf$1$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "time$ebnf$1$subexpression$1$subexpression$2",
                "symbols": [
                    /[pP]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$ebnf$1$subexpression$1",
                "symbols": [
                    "time$ebnf$1$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "time$ebnf$1",
                "symbols": [
                    "time$ebnf$1$subexpression$1"
                ],
                "postprocess": id
            },
            {
                "name": "time$ebnf$1",
                "symbols": [],
                "postprocess": function(d) {
                    return null;
                }
            },
            {
                "name": "time",
                "symbols": [
                    "int",
                    {
                        "literal": ":"
                    },
                    "int",
                    {
                        "literal": ":"
                    },
                    "int",
                    "_",
                    "time$ebnf$1"
                ],
                "postprocess": (d)=>{
                    var _d$;
                    return op("time", d, {
                        hours: d[0],
                        minutes: d[2],
                        seconds: d[4],
                        ampm: (_d$ = d[6]) === null || _d$ === void 0 ? void 0 : _d$[0]
                    });
                }
            },
            {
                "name": "time$ebnf$2$subexpression$1$subexpression$1",
                "symbols": [
                    /[aA]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$ebnf$2$subexpression$1",
                "symbols": [
                    "time$ebnf$2$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "time$ebnf$2$subexpression$1$subexpression$2",
                "symbols": [
                    /[pP]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$ebnf$2$subexpression$1",
                "symbols": [
                    "time$ebnf$2$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "time$ebnf$2",
                "symbols": [
                    "time$ebnf$2$subexpression$1"
                ],
                "postprocess": id
            },
            {
                "name": "time$ebnf$2",
                "symbols": [],
                "postprocess": function(d) {
                    return null;
                }
            },
            {
                "name": "time",
                "symbols": [
                    "int",
                    {
                        "literal": ":"
                    },
                    "int",
                    "_",
                    "time$ebnf$2"
                ],
                "postprocess": (d)=>{
                    var _d$2;
                    return op("time", d, {
                        hours: d[0],
                        minutes: d[2],
                        seconds: 0,
                        ampm: (_d$2 = d[4]) === null || _d$2 === void 0 ? void 0 : _d$2[0]
                    });
                }
            },
            {
                "name": "time$subexpression$1$subexpression$1",
                "symbols": [
                    /[aA]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$subexpression$1",
                "symbols": [
                    "time$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "time$subexpression$1$subexpression$2",
                "symbols": [
                    /[pP]/,
                    /[mM]/
                ],
                "postprocess": function(d) {
                    return d.join("");
                }
            },
            {
                "name": "time$subexpression$1",
                "symbols": [
                    "time$subexpression$1$subexpression$2"
                ]
            },
            {
                "name": "time",
                "symbols": [
                    "int",
                    "_",
                    "time$subexpression$1"
                ],
                "postprocess": (d)=>{
                    var _d$3;
                    return op("time", d, {
                        hours: d[0],
                        minutes: 0,
                        seconds: 0,
                        ampm: (_d$3 = d[2]) === null || _d$3 === void 0 ? void 0 : _d$3[0]
                    });
                }
            },
            {
                "name": "percent",
                "symbols": [
                    "int",
                    "_",
                    {
                        "literal": "%"
                    }
                ],
                "postprocess": (d)=>op("percent", d, {
                        val: d[0]
                    })
            },
            {
                "name": "float$ebnf$1",
                "symbols": []
            },
            {
                "name": "float$ebnf$1",
                "symbols": [
                    "float$ebnf$1",
                    /[-]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "float",
                "symbols": [
                    "float$ebnf$1",
                    "int",
                    {
                        "literal": "."
                    },
                    "int"
                ],
                "postprocess": (d)=>op("number", [
                        d.join("")
                    ], {
                        val: d.join("")
                    })
            },
            {
                "name": "float$ebnf$2",
                "symbols": []
            },
            {
                "name": "float$ebnf$2",
                "symbols": [
                    "float$ebnf$2",
                    /[-]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "float",
                "symbols": [
                    "float$ebnf$2",
                    "int"
                ],
                "postprocess": (d)=>op("number", [
                        d.join("")
                    ], {
                        val: d.join("")
                    })
            },
            {
                "name": "int$ebnf$1",
                "symbols": [
                    /[0-9]/
                ]
            },
            {
                "name": "int$ebnf$1",
                "symbols": [
                    "int$ebnf$1",
                    /[0-9]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "int",
                "symbols": [
                    "int$ebnf$1"
                ],
                "postprocess": (d)=>d[0].join("")
            },
            {
                "name": "text",
                "symbols": [
                    {
                        "literal": '"'
                    },
                    "quotedString",
                    {
                        "literal": '"'
                    }
                ],
                "postprocess": (d)=>op("quoteText", d, {
                        string: d[1]
                    })
            },
            {
                "name": "text",
                "symbols": [
                    "string"
                ],
                "postprocess": (d)=>op("text", d, {
                        string: d[0]
                    })
            },
            {
                "name": "ref",
                "symbols": [
                    {
                        "literal": '"'
                    },
                    "quotedString",
                    {
                        "literal": '"'
                    }
                ],
                "postprocess": (d)=>op("quoteText", d, {
                        string: d[1]
                    })
            },
            {
                "name": "ref",
                "symbols": [
                    "refString"
                ],
                "postprocess": (d)=>op("text", d, {
                        string: d[0]
                    })
            },
            {
                "name": "string$subexpression$1$subexpression$1$ebnf$1",
                "symbols": [
                    /[0-9]/
                ]
            },
            {
                "name": "string$subexpression$1$subexpression$1$ebnf$1",
                "symbols": [
                    "string$subexpression$1$subexpression$1$ebnf$1",
                    /[0-9]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "string$subexpression$1$subexpression$1",
                "symbols": [
                    "string$subexpression$1$subexpression$1$ebnf$1",
                    /[a-zA-Z_]/
                ]
            },
            {
                "name": "string$subexpression$1",
                "symbols": [
                    "string$subexpression$1$subexpression$1"
                ]
            },
            {
                "name": "string$subexpression$1",
                "symbols": [
                    /[a-zA-Z_]/
                ]
            },
            {
                "name": "string$ebnf$1",
                "symbols": []
            },
            {
                "name": "string$ebnf$1",
                "symbols": [
                    "string$ebnf$1",
                    /[a-zA-Z_0-9]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "string",
                "symbols": [
                    "string$subexpression$1",
                    "string$ebnf$1"
                ],
                "postprocess": (d)=>d.toString().replace(/,/g, "")
            },
            {
                "name": "quotedString$ebnf$1",
                "symbols": [
                    /[a-zA-Z0-9\s.,\/?:;\[\]+=\-_~!@#$%^&*()]/
                ]
            },
            {
                "name": "quotedString$ebnf$1",
                "symbols": [
                    "quotedString$ebnf$1",
                    /[a-zA-Z0-9\s.,\/?:;\[\]+=\-_~!@#$%^&*()]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "quotedString",
                "symbols": [
                    "quotedString$ebnf$1"
                ],
                "postprocess": (d)=>d[0].join("")
            },
            {
                "name": "refString$ebnf$1",
                "symbols": [
                    /[a-zA-Z_0-9:]/
                ]
            },
            {
                "name": "refString$ebnf$1",
                "symbols": [
                    "refString$ebnf$1",
                    /[a-zA-Z_0-9:]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "refString",
                "symbols": [
                    "refString$ebnf$1"
                ],
                "postprocess": (d)=>d[0].join("")
            },
            {
                "name": "_$ebnf$1",
                "symbols": []
            },
            {
                "name": "_$ebnf$1",
                "symbols": [
                    "_$ebnf$1",
                    /[\s]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "_",
                "symbols": [
                    "_$ebnf$1"
                ],
                "postprocess": function(d) {
                    return d[0].join("");
                }
            },
            {
                "name": "__$ebnf$1",
                "symbols": [
                    /[\s]/
                ]
            },
            {
                "name": "__$ebnf$1",
                "symbols": [
                    "__$ebnf$1",
                    /[\s]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "__",
                "symbols": [
                    "__$ebnf$1"
                ],
                "postprocess": function(d) {
                    return d[0].join("");
                }
            }
        ],
        ParserStart: "value"
    };
    if (typeof module.exports !== "undefined") return grammar;
    else return grammar;
}

});
parcelRegister("dpgWR", function(module, exports) {

$parcel$export(module.exports, "FormulaNode", function () { return $9c2ac1ba980d78b0$export$6c22c9de3c5987ee; });

var $7mo1e = parcelRequire("7mo1e");

var $9WFAs = parcelRequire("9WFAs");
const $9c2ac1ba980d78b0$export$6c22c9de3c5987ee = (type, inputs, matchString, contextRef)=>{
    var _value$dependencies, _value$dependencies2;
    let value, dependencies;
    try {
        value = (0, $7mo1e.Operations)[type](inputs, contextRef);
    } catch (err) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($9WFAs))).error(err)) console.error(err);
        value = err;
    }
    if (!((_value$dependencies = value.dependencies) !== null && _value$dependencies !== void 0 && _value$dependencies.size)) {
        let depArray = [];
        Object.values(inputs).forEach((i)=>{
            (i === null || i === void 0 ? void 0 : i.dependencies) && depArray.push(...i.dependencies);
        });
        dependencies = new Map(depArray);
    }
    const node = {
        op: type,
        params: inputs,
        matchString: matchString,
        ...value,
        dependencies: (_value$dependencies2 = value.dependencies) !== null && _value$dependencies2 !== void 0 && _value$dependencies2.size ? value.dependencies : dependencies
    };
    Object.values(inputs).forEach((i)=>(0, (/*@__PURE__*/$parcel$interopDefault($9WFAs))).plainObject(i) && (i.parent = node));
    return node;
};

});
parcelRegister("7mo1e", function(module, exports) {

$parcel$export(module.exports, "Operations", function () { return $55bd381b3ce9f750$export$3d72bd1ae0aee044; });

var $fEh3f = parcelRequire("fEh3f");

var $gVgxz = parcelRequire("gVgxz");

var $kjgxB = parcelRequire("kjgxB");

var $26OMC = parcelRequire("26OMC");

var $6Xxk0 = parcelRequire("6Xxk0");

var $7C7jN = parcelRequire("7C7jN");

var $cev2V = parcelRequire("cev2V");

var $9QlOY = parcelRequire("9QlOY");

var $6u1bB = parcelRequire("6u1bB");

var $dGSCa = parcelRequire("dGSCa");

var $dUrMW = parcelRequire("dUrMW");

var $hrN69 = parcelRequire("hrN69");

var $8qTAV = parcelRequire("8qTAV");

var $aKNoZ = parcelRequire("aKNoZ");

var $8GlSR = parcelRequire("8GlSR");

var $ggRNi = parcelRequire("ggRNi");

var $l2MjW = parcelRequire("l2MjW");

var $lLQ0V = parcelRequire("lLQ0V");

var $epT10 = parcelRequire("epT10");

var $3SmSc = parcelRequire("3SmSc");

var $c1jtr = parcelRequire("c1jtr");

var $frBCw = parcelRequire("frBCw");

var $5rlC7 = parcelRequire("5rlC7");

var $k0WhL = parcelRequire("k0WhL");

var $fccik = parcelRequire("fccik");

var $dwOAg = parcelRequire("dwOAg");

var $fitji = parcelRequire("fitji");

var $kogLx = parcelRequire("kogLx");

var $1v5nB = parcelRequire("1v5nB");

var $dbi4m = parcelRequire("dbi4m");
let $55bd381b3ce9f750$export$3d72bd1ae0aee044 = {
    array: (0, $fEh3f.default),
    context: (0, $gVgxz.default),
    date: (0, $kjgxB.default),
    dateTime: (0, $26OMC.default),
    duration: (0, $6Xxk0.default),
    number: (0, $7C7jN.default),
    method: (0, $cev2V.default),
    property: (0, $9QlOY.default),
    percent: (0, $6u1bB.default),
    quoteText: (0, $dGSCa.default),
    range: (0, $dUrMW.default),
    text: (0, $aKNoZ.default),
    time: (0, $8GlSR.default),
    add: (0, $ggRNi.default),
    and: (0, $l2MjW.default),
    divide: (0, $lLQ0V.default),
    equal: (0, $epT10.default),
    function: (0, $3SmSc.default),
    greaterThan: (0, $c1jtr.default),
    greaterThanEqual: (0, $frBCw.default),
    ifElse: (0, $5rlC7.default),
    lessThan: (0, $k0WhL.default),
    lessThanEqual: (0, $fccik.default),
    multiply: (0, $dwOAg.default),
    not: (0, $fitji.default),
    or: (0, $kogLx.default),
    power: (0, $1v5nB.default),
    subtract: (0, $dbi4m.default),
    atRef: (0, $hrN69.default),
    hashRef: (0, $8qTAV.default)
};

});
parcelRegister("fEh3f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b647d181178a5b59$export$2e2bcd8739ae039; });
var $b647d181178a5b59$export$2e2bcd8739ae039 = ({ array: array }, context)=>{
    return {
        type: "array",
        value: array
    };
};

});

parcelRegister("gVgxz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51eccca6a0d2c56$export$2e2bcd8739ae039; });

var $j7zix = parcelRequire("j7zix");
var $c51eccca6a0d2c56$export$2e2bcd8739ae039 = (inputs, context)=>{
    if (!context) throw {
        value: "No context provided",
        type: "error",
        dependencies: []
    };
    const contextObj = (0, $j7zix.getContextReferenceObject)(context);
    return {
        type: contextObj.type,
        value: contextObj,
        primitive: true
    };
};

});

parcelRegister("26OMC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $189388c87269a695$export$2e2bcd8739ae039; });

var $bwMFl = parcelRequire("bwMFl");
var $189388c87269a695$export$2e2bcd8739ae039 = ({ date: date, time: time }, context)=>{
    return {
        type: "dateTime",
        value: time !== null && time !== void 0 && time.value ? (0, $bwMFl.addDurationToDate)(date.value, time.value).getTime() : date.value,
        primitive: true
    };
};

});

parcelRegister("6Xxk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $511219bf5ddd6f81$export$2e2bcd8739ae039; });
var $511219bf5ddd6f81$export$2e2bcd8739ae039 = ({ amount: amount, unit: unit }, context)=>{
    return {
        type: "duration",
        value: Object.fromEntries([
            [
                unit,
                amount.value
            ]
        ]),
        primitive: true
    };
};

});

parcelRegister("7C7jN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58b1c243e896c71b$export$2e2bcd8739ae039; });
var $58b1c243e896c71b$export$2e2bcd8739ae039 = ({ val: val })=>{
    return {
        type: "number",
        value: parseFloat(val),
        primitive: true
    };
};

});

parcelRegister("cev2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e7edff2f06fa74a$export$2e2bcd8739ae039; });

var $1KElr = parcelRequire("1KElr");
var $8e7edff2f06fa74a$export$2e2bcd8739ae039 = ({ object: object, method: method, args: args }, context)=>{
    if (object.type !== "array") {
        var _Methods$object$type, _Methods$object$type2, _Methods$object$type3;
        if (!((_Methods$object$type = (0, $1KElr.Methods)[object.type]) !== null && _Methods$object$type !== void 0 && _Methods$object$type[method])) throw {
            value: `${object.type} does not have method ${method}`,
            type: "error"
        };
        return (_Methods$object$type2 = (0, $1KElr.Methods)[object.type]) === null || _Methods$object$type2 === void 0 ? void 0 : (_Methods$object$type3 = _Methods$object$type2[method]) === null || _Methods$object$type3 === void 0 ? void 0 : _Methods$object$type3.call(_Methods$object$type2, object, args, context);
    } else {
        var _Methods$object$value;
        if (!((_Methods$object$value = (0, $1KElr.Methods)[object.value[0].type]) !== null && _Methods$object$value !== void 0 && _Methods$object$value[method])) throw {
            value: `${object.type} does not have method ${method}`,
            type: "error"
        };
        const methArray = object.value.map((ob)=>{
            var _Methods$ob$type, _Methods$ob$type$meth;
            return (_Methods$ob$type = (0, $1KElr.Methods)[ob.type]) === null || _Methods$ob$type === void 0 ? void 0 : (_Methods$ob$type$meth = _Methods$ob$type[method]) === null || _Methods$ob$type$meth === void 0 ? void 0 : _Methods$ob$type$meth.call(_Methods$ob$type, ob, args, context);
        });
        return {
            type: "array",
            value: methArray
        };
    }
};

});

parcelRegister("9QlOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72a9e598a7b86861$export$2e2bcd8739ae039; });

var $4RbPN = parcelRequire("4RbPN");
var $72a9e598a7b86861$export$2e2bcd8739ae039 = ({ object: object, prop: prop }, context)=>{
    if (object.type !== "array") {
        var _Properties$object$ty;
        let val = (_Properties$object$ty = (0, $4RbPN.Properties)[object.type]) === null || _Properties$object$ty === void 0 ? void 0 : _Properties$object$ty.call((0, $4RbPN.Properties), prop, object, context);
        if (!val) throw {
            value: `${object.type} does not have property ${prop}`,
            type: "error"
        };
        return val;
    } else {
        let propArray = [];
        object.value.forEach((ob)=>{
            var _Properties$ob$type;
            let propVal = (_Properties$ob$type = (0, $4RbPN.Properties)[ob.type]) === null || _Properties$ob$type === void 0 ? void 0 : _Properties$ob$type.call((0, $4RbPN.Properties), prop, ob, context);
            if (propVal && propVal.type === "array") propArray.push(...propVal.value);
            else if (propVal) propArray.push(propVal);
        });
        if (propArray.length && !propArray[0]) throw {
            value: `${object.value[0].type} does not have property ${prop}`,
            type: "error"
        };
        let dependencies = new Map();
        propArray.forEach((p)=>[
                ...p.dependencies || []
            ].forEach(([dId, dData])=>{
                const existingDepData = dependencies.get(dId);
                dependencies.set(dId, {
                    ...existingDepData || {},
                    ...dData,
                    inherited: existingDepData && !existingDepData.inherited ? existingDepData.inherited : dData.inherited
                });
            }));
        return {
            type: "array",
            value: propArray,
            dependencies: dependencies
        };
    }
};

});

parcelRegister("6u1bB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b8676f92653bbf7$export$2e2bcd8739ae039; });
var $4b8676f92653bbf7$export$2e2bcd8739ae039 = ({ val: val }, context)=>{
    return {
        type: "number",
        value: parseFloat(val) / 100,
        primitive: true
    };
};

});

parcelRegister("dGSCa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f798ff08a868209$export$2e2bcd8739ae039; });
var $9f798ff08a868209$export$2e2bcd8739ae039 = ({ string: string }, context)=>{
    return {
        type: "text",
        value: string
    };
};

});

parcelRegister("dUrMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2060f811f3cd0c7$export$2e2bcd8739ae039; });
var $a2060f811f3cd0c7$export$2e2bcd8739ae039 = ({ start: start, end: end }, context)=>{
    return {
        type: start.type,
        value: {
            start: start,
            end: end
        }
    };
};

});

parcelRegister("hrN69", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3b0b2a289c9b3d$export$2e2bcd8739ae039; });

var $j7zix = parcelRequire("j7zix");
var $cb3b0b2a289c9b3d$export$2e2bcd8739ae039 = ({ ref: ref }, context)=>{
    const refObj = (0, $j7zix.getAtReferenceObject)(ref.value, context);
    if (!refObj) throw {
        value: "No object found with this reference.",
        type: "error",
        dependencies: new Map([
            ...ref.dependencies
        ])
    };
    return {
        type: refObj.type,
        value: refObj,
        primitive: true
    };
};

});

parcelRegister("8qTAV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $623be05bda5d7b14$export$2e2bcd8739ae039; });

var $j7zix = parcelRequire("j7zix");
var $623be05bda5d7b14$export$2e2bcd8739ae039 = ({ ref: ref }, context)=>{
    const refObj = (0, $j7zix.getHashReferenceObject)(ref.value, context);
    if (!refObj) throw {
        value: "No object found with this reference.",
        type: "error",
        dependencies: new Map([
            ...ref.dependencies
        ])
    };
    return {
        type: refObj.type,
        value: refObj,
        primitive: true
    };
};

});

parcelRegister("aKNoZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d44857754f64adc$export$2e2bcd8739ae039; });

var $8wlqd = parcelRequire("8wlqd");
var $7d44857754f64adc$export$2e2bcd8739ae039 = ({ string: string })=>{
    var _Constants$string;
    return ((_Constants$string = (0, $8wlqd.Constants)[string]) === null || _Constants$string === void 0 ? void 0 : _Constants$string.call((0, $8wlqd.Constants))) || {
        type: "text",
        value: string,
        primitive: true
    };
};

});
parcelRegister("8wlqd", function(module, exports) {

$parcel$export(module.exports, "Constants", function () { return $6341edce36306e12$export$a002182e51710d39; });
$parcel$export(module.exports, "addConstants", function () { return $6341edce36306e12$export$f08b431b616b78c4; });
let $6341edce36306e12$export$a002182e51710d39 = {
    true: ()=>({
            type: "logic",
            value: true
        }),
    false: ()=>({
            type: "logic",
            value: false
        }),
    pi: ()=>({
            type: "number",
            value: Math.PI
        }),
    e: ()=>({
            type: "number",
            value: Math.E
        }),
    millisecond: ()=>({
            type: "duration",
            value: {
                milliseconds: 1
            }
        }),
    second: ()=>({
            type: "duration",
            value: {
                seconds: 1
            }
        }),
    minute: ()=>({
            type: "duration",
            value: {
                minutes: 1
            }
        }),
    hour: ()=>({
            type: "duration",
            value: {
                hours: 1
            }
        }),
    day: ()=>({
            type: "duration",
            value: {
                days: 1
            }
        }),
    week: ()=>({
            type: "duration",
            value: {
                weeks: 1
            }
        }),
    month: ()=>({
            type: "duration",
            value: {
                months: 1
            }
        }),
    year: ()=>({
            type: "duration",
            value: {
                years: 1
            }
        }),
    now: ()=>({
            type: "dateTime",
            value: Date.now(),
            primitive: true
        }),
    currentDate: ()=>({
            type: "dateTime",
            value: Date.now(),
            primitive: true
        })
};
const $6341edce36306e12$export$f08b431b616b78c4 = (newConsts)=>{
    $6341edce36306e12$export$a002182e51710d39 = {
        ...$6341edce36306e12$export$a002182e51710d39,
        ...newConsts
    };
};

});


parcelRegister("8GlSR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $652338ab30b184e8$export$2e2bcd8739ae039; });
var $652338ab30b184e8$export$2e2bcd8739ae039 = ({ hours: hours, minutes: minutes, seconds: seconds, ampm: ampm }, context)=>{
    if (ampm === "pm" && hours < 12) hours += 12;
    return {
        type: "date",
        value: {
            hours: hours,
            minutes: minutes,
            seconds: seconds
        },
        primitive: true
    };
};

});

parcelRegister("ggRNi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd87de5ba22c16f3$export$2e2bcd8739ae039; });

var $bwMFl = parcelRequire("bwMFl");
var $bd87de5ba22c16f3$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const adderId = left.type + right.type;
    if (!$bd87de5ba22c16f3$var$adderValues[adderId]) throw {
        value: `Cannot add a ${left.type} to a ${right.type}.`,
        type: "error",
        dependencies: []
    };
    return {
        type: $bd87de5ba22c16f3$var$adderTypes[adderId],
        value: $bd87de5ba22c16f3$var$adderValues[adderId](left, right)
    };
};
const $bd87de5ba22c16f3$var$adderTypes = {
    numbernumber: "number",
    texttext: "text",
    textnumber: "text",
    numbertext: "text",
    dateTimeduration: "dateTime",
    durationduration: "duration",
    raterate: "rate"
};
const $bd87de5ba22c16f3$var$adderValues = {
    numbernumber: (left, right)=>left.value + right.value,
    texttext: (left, right)=>left.value + right.value,
    textnumber: (left, right)=>left.value + right.value,
    numbertext: (left, right)=>left.value + right.value,
    dateTimeduration: (left, right)=>(0, $bwMFl.addDurationToDate)(left.value, right.value).getTime(),
    durationduration: (left, right)=>(0, $bwMFl.simplifyDuration)((0, $bwMFl.addDurations)(left.value, right.value)),
    raterate: (left, right)=>(0, $bwMFl.simplifyRate)((0, $bwMFl.addRates)(left.value, right.value))
};

});

parcelRegister("l2MjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f51f445897eb019f$export$2e2bcd8739ae039; });
var $f51f445897eb019f$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const selectedVal = left.value ? right : left;
    return {
        type: selectedVal.type,
        value: selectedVal.value
    };
};

});

parcelRegister("lLQ0V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd9655a12a6a87bb$export$2e2bcd8739ae039; });

var $bwMFl = parcelRequire("bwMFl");

var $9AXSd = parcelRequire("9AXSd");
var $fd9655a12a6a87bb$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const dividerId = left.type + right.type;
    if (!$fd9655a12a6a87bb$var$dividerValues[dividerId]) throw {
        value: `Cannot divide a ${left.type} to a ${right.type}.`,
        type: "error"
    };
    if ((0, $9AXSd.isZeroValue)[right.type](right.value)) throw {
        value: `Cannot divide by zero.`,
        type: "error"
    };
    return {
        type: $fd9655a12a6a87bb$var$dividerTypes[dividerId],
        value: $fd9655a12a6a87bb$var$dividerValues[dividerId](left, right)
    };
};
const $fd9655a12a6a87bb$var$dividerTypes = {
    numbernumber: "number",
    numberduration: "rate",
    durationnumber: "duration",
    durationduration: "number",
    numberrate: "duration",
    ratenumber: "rate",
    raterate: "number",
    powerDurationduration: "duration"
};
const $fd9655a12a6a87bb$var$dividerValues = {
    numbernumber: (left, right)=>left.value / right.value,
    numberduration: (left, right)=>{
        return (0, $bwMFl.simplifyRate)({
            amount: left.value,
            per: right.value
        });
    },
    durationnumber: (left, right)=>(0, $bwMFl.simplifyDuration)((0, $bwMFl.divideDurationBy)(left.value, right.value)),
    durationduration: (left, right)=>{
        return (0, $bwMFl.divideDurations)(left.value, right.value);
    },
    numberrate: (left, right)=>{
        return (0, $bwMFl.divideNumberByRate)(left.value, right.value);
    },
    ratenumber: (left, right)=>{
        return (0, $bwMFl.divideRateBy)(left.value, right.value);
    },
    raterate: (left, right)=>{
        return (0, $bwMFl.divideRates)(left.value, right.value);
    },
    powerDurationduration: (left, right)=>{
        return (0, $bwMFl.simplifyDuration)((0, $bwMFl.dividePowerDurationByDuration)(left.value, right.value));
    }
};

});
parcelRegister("9AXSd", function(module, exports) {

$parcel$export(module.exports, "adjustFormulaToValue", function () { return $6fc5eb79ee00fccf$export$506457a8beabc4ae; });
$parcel$export(module.exports, "isZeroValue", function () { return $6fc5eb79ee00fccf$export$634c47c3257423c1; });
$parcel$export(module.exports, "formulaDefaults", function () { return $6fc5eb79ee00fccf$export$7aaf19950eefdf1c; });

var $cNwQA = parcelRequire("cNwQA");

var $egx7S = parcelRequire("egx7S");
parcelRequire("bwMFl");
const $6fc5eb79ee00fccf$export$506457a8beabc4ae = (ast, newValue, ref)=>{
    if (!(ast.type === newValue.type)) return;
    if (!$6fc5eb79ee00fccf$export$412b44c694f80a56.includes(ast.type)) return;
    if (ast.primitive && ast.type === newValue.type) return $6fc5eb79ee00fccf$export$a902250547926f80[newValue.type](newValue.value);
    else {
        var _isZeroValue$diffAst$;
        let nodes = [];
        let newFormula = null;
        const diffAst = (0, $cNwQA.parseFormula)(`(${$6fc5eb79ee00fccf$export$a902250547926f80[newValue.type](newValue.value)}) - (${ast.matchString})`, ref);
        if ((_isZeroValue$diffAst$ = $6fc5eb79ee00fccf$export$634c47c3257423c1[diffAst.type]) !== null && _isZeroValue$diffAst$ !== void 0 && _isZeroValue$diffAst$.call($6fc5eb79ee00fccf$export$634c47c3257423c1, diffAst.value)) return ast.matchString;
        nodes.push(ast);
        while(nodes.length && !newFormula){
            // may be an issue with primitive string inputs
            const node = nodes.shift();
            if (node.primitive && node.type === diffAst.type) {
                var _node$parent;
                const invert = (node === null || node === void 0 ? void 0 : (_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.op) === "subtract";
                // node does not know if it's being subtracted resulting in bad calculations
                const adjustedVal = (0, $cNwQA.parseFormula)(`((${$6fc5eb79ee00fccf$export$a902250547926f80[diffAst.type](diffAst.value)}) ${!invert ? "+" : "-"} (${node.matchString}))${invert ? "* -1" : ""}`, ref);
                newFormula = ast.matchString.replace(node.matchString, $6fc5eb79ee00fccf$export$a902250547926f80[adjustedVal.type](adjustedVal.value)).replace("+ -", "- ").replace("- -", "+ ");
            }
            if (!newFormula && $6fc5eb79ee00fccf$export$38839043d87f15bb(node.type, node.op)) nodes.push(...Object.values(node.params));
        }
        if (!newFormula && $6fc5eb79ee00fccf$export$d0a5c90efda19e8c(ast.type, ast.op)) {
            let nodes = [];
            const scalerVal = (0, $cNwQA.parseFormula)(`(${$6fc5eb79ee00fccf$export$a902250547926f80[newValue.type](newValue.value)}) / (${$6fc5eb79ee00fccf$export$a902250547926f80[ast.type](ast.value)})`, ref);
            nodes.push(ast);
            while(nodes.length && !newFormula){
                // may be an issue with primitive string inputs
                const node = nodes.shift();
                if (node.primitive && $6fc5eb79ee00fccf$export$f51d97000f83ee12.includes(node.type)) {
                    const scaledVal = (0, $cNwQA.parseFormula)(`(${node.matchString}) * (${$6fc5eb79ee00fccf$export$a902250547926f80[scalerVal.type](scalerVal.value)})`, ref);
                    newFormula = ast.matchString.replace(node.matchString, $6fc5eb79ee00fccf$export$a902250547926f80[scaledVal.type](scaledVal.value));
                }
                if (!newFormula && $6fc5eb79ee00fccf$export$d0a5c90efda19e8c(node.type, node.op)) nodes.push(...Object.values(node.params));
            }
        }
        return newFormula || `${ast.matchString} + ${$6fc5eb79ee00fccf$export$a902250547926f80[diffAst.type](diffAst.value)}`.replace("+ -", "- ");
    }
};
const $6fc5eb79ee00fccf$export$a902250547926f80 = {
    text: (val)=>String(val),
    number: (val)=>String(val),
    dateTime: (val)=>{
        const date = new Date(val);
        if (date.getHours() || date.getMinutes() || date.getSeconds()) return (0, $egx7S.format)(date, "dd.MM.yyyy HH:mm:ss");
        else return (0, $egx7S.format)(date, "dd.MM.yyyy");
    },
    duration: (val)=>{
        const units = Object.keys(val)[0];
        return `${val[units]} ${units}`;
    },
    rate: (val)=>{
        return `${val.amount} / ${Object.keys(val.per)[0].slice(0, -1)}`;
    },
    task: (val)=>val.label,
    resource: (val)=>val.label,
    undefined: (val)=>"-",
    null: (val)=>"-"
};
const $6fc5eb79ee00fccf$export$634c47c3257423c1 = {
    string: (val)=>null,
    number: (val)=>val === 0,
    dateTime: (val)=>val === 0,
    duration: (val)=>{
        const units = Object.keys(val)[0];
        return val[units] === 0;
    },
    rate: (val)=>val.amount === 0,
    task: (val)=>null,
    resource: (val)=>null
};
const $6fc5eb79ee00fccf$export$38839043d87f15bb = (type, op)=>$6fc5eb79ee00fccf$export$412b44c694f80a56.includes(type) && $6fc5eb79ee00fccf$export$b4b14971105a4fb0.includes(op);
const $6fc5eb79ee00fccf$export$412b44c694f80a56 = [
    "number",
    "dateTime",
    "duration",
    "rate"
];
const $6fc5eb79ee00fccf$export$b4b14971105a4fb0 = [
    "add",
    "subtract"
];
const $6fc5eb79ee00fccf$export$d0a5c90efda19e8c = (type, op)=>$6fc5eb79ee00fccf$export$f51d97000f83ee12.includes(type) && $6fc5eb79ee00fccf$export$33624ca114bff389.includes(op);
const $6fc5eb79ee00fccf$export$f51d97000f83ee12 = [
    "number",
    "duration",
    "rate"
];
const $6fc5eb79ee00fccf$export$33624ca114bff389 = [
    "divide",
    "multiply"
];
const $6fc5eb79ee00fccf$export$c09fd095eb6d34d1 = (ref)=>{
    return /^[a-zA-Z_0-9]+$/.test(ref) ? ref : `"${ref}"`;
};
const $6fc5eb79ee00fccf$export$7aaf19950eefdf1c = {
    string: (val)=>"",
    number: (val)=>"0",
    dateTime: (val)=>"",
    duration: (val)=>"0 days",
    rate: (val)=>"0 / hour",
    task: (val)=>"",
    resource: (val)=>""
};

});


parcelRegister("epT10", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7ee135eef7eb6ae$export$2e2bcd8739ae039; });
var $a7ee135eef7eb6ae$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value === right.value
    };
};

});

parcelRegister("3SmSc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d2828673c7c6abb$export$2e2bcd8739ae039; });

var $9fbCM = parcelRequire("9fbCM");
var $2d2828673c7c6abb$export$2e2bcd8739ae039 = ({ funcName: funcName, args: args }, context)=>{
    var _args$;
    args = args.type === "array" ? args.value : [
        args
    ];
    const type = (_args$ = args[0]) === null || _args$ === void 0 ? void 0 : _args$.type;
    if (!(0, $9fbCM.Functions)[funcName]) throw {
        value: `Function ${funcName} does not exist`,
        type: "error"
    };
    if ((0, $9fbCM.Functions)[funcName] && !(0, $9fbCM.Functions)[funcName][type]) throw {
        value: `Cannot apply ${funcName} function to ${type} types.`,
        type: "error"
    };
    return (0, $9fbCM.Functions)[funcName][type](args, context);
};

});
parcelRegister("9fbCM", function(module, exports) {

$parcel$export(module.exports, "Functions", function () { return $6bae882c16560ede$export$da780471809663e; });
$parcel$export(module.exports, "addFunctions", function () { return $6bae882c16560ede$export$b09452532e358f46; });

var $dBifK = parcelRequire("dBifK");

var $bwMFl = parcelRequire("bwMFl");

var $jjsqC = parcelRequire("jjsqC");

var $egx7S = parcelRequire("egx7S");
let $6bae882c16560ede$export$da780471809663e = {
    abs: {
        number: (args, context)=>({
                type: args[0].type,
                value: Math.abs(args[0].value)
            })
    },
    round: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).round(...args.map((a)=>a.value))
            })
    },
    max: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(args.map((a)=>a.value).filter((v)=>v))
            }),
        dateTime: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(args.map((a)=>a.value).filter((v)=>v))
            }),
        duration: (args, context)=>({
                type: args[0].type,
                value: (0, $bwMFl.simplifyDuration)({
                    milliseconds: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).max(args.map((a)=>(0, $bwMFl.durationToUnit)(a.value, "milliseconds")).filter((v)=>v))
                })
            })
    },
    min: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(args.map((a)=>a.value).filter((v)=>v))
            }),
        dateTime: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(args.map((a)=>a.value).filter((v)=>v))
            }),
        duration: (args, context)=>({
                type: args[0].type,
                value: (0, $bwMFl.simplifyDuration)({
                    milliseconds: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).min(args.map((a)=>(0, $bwMFl.durationToUnit)(a.value, "milliseconds")).filter((v)=>v))
                })
            })
    },
    sum: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(args.map((a)=>a.value).filter((v)=>v))
            }),
        duration: (args, context)=>{
            return {
                type: args[0].type,
                value: (0, $bwMFl.simplifyDuration)({
                    milliseconds: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(args.map((a)=>(0, $bwMFl.durationToUnit)(a.value, "milliseconds")).filter((v)=>v))
                })
            };
        }
    },
    avg: {
        number: (args, context)=>({
                type: args[0].type,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(args.map((a)=>a.value).filter((v)=>v))
            }),
        duration: (args, context)=>({
                type: args[0].type,
                value: (0, $bwMFl.simplifyDuration)({
                    milliseconds: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(args.map((a)=>(0, $bwMFl.durationToUnit)(a.value, "milliseconds")).filter((v)=>v))
                })
            }),
        rate: (args, context)=>({
                type: args[0].type,
                value: (0, $bwMFl.simplifyRate)({
                    amount: (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).mean(args.map((a)=>(0, $bwMFl.ratePerUnit)(a.value, "milliseconds").amount)),
                    per: {
                        milliseconds: 1
                    }
                })
            })
    },
    format: {
        number: (args, context)=>({
                type: "text",
                value: (0, (/*@__PURE__*/$parcel$interopDefault($jjsqC)))(args[0].value).format(args[1].value)
            }),
        dateTime: (args, context)=>({
                type: "text",
                value: (0, $egx7S.format)(args[0].value, args[1].value)
            })
    }
};
const $6bae882c16560ede$export$b09452532e358f46 = (newConsts)=>{
    $6bae882c16560ede$export$da780471809663e = {
        ...$6bae882c16560ede$export$da780471809663e,
        ...newConsts
    };
};

});
parcelRegister("jjsqC", function(module, exports) {
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else if (0, module.exports) module.exports = factory();
    else global.numeral = factory();
})(module.exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = "2.0.6", formats = {}, locales = {}, defaults = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === "undefined") value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === "string") {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === "function" ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = "", neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, "(")) {
                negP = true;
                format = format.replace(/[\(|\)]/g, "");
            } else if (numeral._.includes(format, "+") || numeral._.includes(format, "-")) {
                signed = numeral._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
                format = format.replace(/[\+|\-]/g, "");
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, "a")) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, " a")) abbr = " ";
                format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
                if (abs >= trillion && !abbrForce || abbrForce === "t") {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === "b") {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === "m") {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === "k") {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, "[.]")) {
                optDec = true;
                format = format.replace("[.]", ".");
            }
            // break number and format
            int = value.toString().split(".")[0];
            precision = format.split(".")[1];
            thousands = format.indexOf(",");
            leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, "[")) {
                    precision = precision.replace("]", "");
                    precision = precision.split("[");
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split(".")[0];
                if (numeral._.includes(decimal, ".")) decimal = locale.delimiters.decimal + decimal.split(".")[1];
                else decimal = "";
                if (optDec && Number(decimal.slice(1)) === 0) decimal = "";
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, "-")) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = "0" + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
            if (format.indexOf(".") === 0) int = "";
            output = int + decimal + (abbr ? abbr : "");
            if (negP) output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
                else if (neg) output = "-" + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, "").length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
                for(abbreviation in abbreviations){
                    regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, "");
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === "number" && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError("Array.prototype.reduce called on null or undefined");
            if (typeof callback !== "function") throw new TypeError(callback + " is not a function");
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError("Reduce of empty array with no initial value");
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split(".");
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
                output = output.replace(optionalsRegExp, "");
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error("Unknown locale : " + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === "string" ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === "string" ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === "string" ? format : "0.0";
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + "s"][name]) throw new TypeError(name + " " + type + " already registered.");
        this[type + "s"][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== "string") {
            val += "";
            if (console.warn) console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === "") return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === ".") _thousandSep = "\\.";
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + "{2}");
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register("locale", "en", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        },
        currency: {
            symbol: "$"
        }
    });
    (function() {
        numeral.register("format", "bps", {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " BPS") ? " " : "", output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "BPS");
                    output = output.join("");
                } else output = output + space + "BPS";
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                "B",
                "KB",
                "MB",
                "GB",
                "TB",
                "PB",
                "EB",
                "ZB",
                "YB"
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                "B",
                "KiB",
                "MiB",
                "GiB",
                "TiB",
                "PiB",
                "EiB",
                "ZiB",
                "YiB"
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join("|");
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
        numeral.register("format", "bytes", {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, "ib") ? binary : decimal, suffix = numeral._.includes(format, " b") || numeral._.includes(format, " ib") ? " " : "", power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, "");
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register("format", "currency", {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, "");
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, "");
                    symbols.after = symbols.after.replace(/[\-\)]/, "");
                } else if (value < 0 && !numeral._.includes(symbols.before, "-") && !numeral._.includes(symbols.before, "(")) symbols.before = "-" + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case "$":
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case " ":
                            output = numeral._.insert(output, " ", i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case "$":
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case " ":
                            output = i === symbols.after.length - 1 ? output + " " : numeral._.insert(output, " ", -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register("format", "exponential", {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === "number" && !numeral._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
                format = format.replace(/e[\+|\-]{1}0/, "");
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + "e" + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, "e+") ? string.split("e+") : string.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, "e-") ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register("format", "ordinal", {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, " o") ? " " : "";
                // check for space before
                format = format.replace(/\s?o/, "");
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register("format", "percentage", {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " %") ? " " : "", output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "%");
                    output = output.join("");
                } else output = output + space + "%";
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register("format", "time", {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(":"), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});

});



parcelRegister("c1jtr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c04af27a3cd95c8$export$2e2bcd8739ae039; });
var $8c04af27a3cd95c8$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value > right.value
    };
};

});

parcelRegister("frBCw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3e68f3cfac7e06e$export$2e2bcd8739ae039; });
var $b3e68f3cfac7e06e$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value >= right.value
    };
};

});

parcelRegister("5rlC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f603d665e2afbb4$export$2e2bcd8739ae039; });
var $3f603d665e2afbb4$export$2e2bcd8739ae039 = (inputs, context)=>{
    const val = inputs.if ? inputs.then : inputs.else;
    return {
        type: val.type,
        value: val.value
    };
};

});

parcelRegister("k0WhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e92105040557c79b$export$2e2bcd8739ae039; });
var $e92105040557c79b$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value < right.value
    };
};

});

parcelRegister("fccik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b10183788dab2278$export$2e2bcd8739ae039; });
var $b10183788dab2278$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    return {
        type: "logic",
        value: left.value <= right.value
    };
};

});

parcelRegister("dwOAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d958071ea06298a$export$2e2bcd8739ae039; });

var $bwMFl = parcelRequire("bwMFl");
var $9d958071ea06298a$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const multiplierId = left.type + right.type;
    if (!$9d958071ea06298a$var$multiplierValues[multiplierId]) throw {
        value: `Cannot multiply a ${left.type} with a ${right.type}.`,
        type: "error"
    };
    return {
        type: $9d958071ea06298a$var$multiplierTypes[multiplierId],
        value: $9d958071ea06298a$var$multiplierValues[multiplierId](left, right)
    };
};
const $9d958071ea06298a$var$multiplierTypes = {
    numbernumber: "number",
    textnumber: "text",
    numbertext: "text",
    numberduration: "duration",
    durationnumber: "duration",
    numberrate: "rate",
    ratenumber: "rate",
    durationrate: "number",
    rateduration: "number",
    durationduration: "powerDuration"
};
const $9d958071ea06298a$var$multiplierValues = {
    numbernumber: (left, right)=>left.value * right.value,
    textnumber: (left, right)=>left.value.repeat(right.value),
    numbertext: (left, right)=>right.value.repeat(left.value),
    numberduration: (left, right)=>{
        return (0, $bwMFl.simplifyDuration)((0, $bwMFl.multiplyDurationBy)(right.value, left.value));
    },
    durationnumber: (left, right)=>{
        return (0, $bwMFl.simplifyDuration)((0, $bwMFl.multiplyDurationBy)(left.value, right.value));
    },
    numberrate: (left, right)=>{
        return (0, $bwMFl.simplifyRate)((0, $bwMFl.multiplyRateBy)(right.value, left.value));
    },
    ratenumber: (left, right)=>{
        return (0, $bwMFl.simplifyRate)((0, $bwMFl.multiplyRateBy)(left.value, right.value));
    },
    durationrate: (left, right)=>{
        return (0, $bwMFl.multiplyRateByDuration)(right.value, left.value);
    },
    rateduration: (left, right)=>{
        return (0, $bwMFl.multiplyRateByDuration)(left.value, right.value);
    },
    durationduration: (left, right)=>{
        return (0, $bwMFl.multiplyDurations)(left.value, right.value);
    }
};

});

parcelRegister("fitji", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b22f45d7df8694c8$export$2e2bcd8739ae039; });
var $b22f45d7df8694c8$export$2e2bcd8739ae039 = ({ val: val }, context)=>{
    return {
        type: "logic",
        value: !val.value
    };
};

});

parcelRegister("kogLx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed830de0b5df5e2e$export$2e2bcd8739ae039; });
var $ed830de0b5df5e2e$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const selectedVal = left.value ? left : right;
    return {
        type: selectedVal.type,
        value: selectedVal.value
    };
};

});

parcelRegister("1v5nB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $117cdbff21d6130e$export$2e2bcd8739ae039; });
var $117cdbff21d6130e$export$2e2bcd8739ae039 = ({ base: base, power: power }, context)=>{
    const raiserId = base.type + power.type;
    if (!$117cdbff21d6130e$var$raiserValues[raiserId]) throw {
        value: `Cannot raise a ${base.type} to the power of a ${power.type}.`,
        type: "error"
    };
    return {
        type: $117cdbff21d6130e$var$raiserTypes[raiserId],
        value: $117cdbff21d6130e$var$raiserValues[raiserId] && $117cdbff21d6130e$var$raiserValues[raiserId](base, power)
    };
};
const $117cdbff21d6130e$var$raiserTypes = {
    numbernumber: "number"
};
const $117cdbff21d6130e$var$raiserValues = {
    numbernumber: (base, power)=>Math.pow(base.value, power.value)
};
const $117cdbff21d6130e$var$raiserValidators = {
    numbernumber: []
};

});

parcelRegister("dbi4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $998a51a1d90a694f$export$2e2bcd8739ae039; });

var $bwMFl = parcelRequire("bwMFl");
var $998a51a1d90a694f$export$2e2bcd8739ae039 = ({ left: left, right: right }, context)=>{
    const subberId = left.type + right.type;
    if (!$998a51a1d90a694f$var$subberValues[subberId]) throw {
        value: `Cannot subtract a ${right.type} from a ${left.type}.`,
        type: "error"
    };
    return {
        type: $998a51a1d90a694f$var$subberTypes[subberId],
        value: $998a51a1d90a694f$var$subberValues[subberId] && $998a51a1d90a694f$var$subberValues[subberId](left, right)
    };
};
const $998a51a1d90a694f$var$subberTypes = {
    numbernumber: "number",
    texttext: "text",
    dateTimeduration: "dateTime",
    dateTimedateTime: "duration",
    durationduration: "duration",
    raterate: "rate"
};
const $998a51a1d90a694f$var$subberValues = {
    numbernumber: (left, right)=>left.value - right.value,
    texttext: (left, right)=>left.value.replace(right.value, ""),
    dateTimeduration: (left, right)=>(0, $bwMFl.subDurationFromDate)(left.value, right.value).getTime(),
    dateTimedateTime: (left, right)=>(0, $bwMFl.simplifyDuration)((0, $bwMFl.durationBetween)(right.value, left.value)),
    durationduration: (left, right)=>(0, $bwMFl.simplifyDuration)((0, $bwMFl.subDurations)(left.value, right.value)),
    raterate: (left, right)=>(0, $bwMFl.simplifyRate)((0, $bwMFl.subRates)(left.value, right.value))
};

});





parcelRegister("4LeDk", function(module, exports) {

$parcel$export(module.exports, "storeFormula", function () { return $3776e7107f86701a$export$60ed586f871e60ae; });
$parcel$export(module.exports, "updateDependencies", function () { return $3776e7107f86701a$export$9a371ee2fc90de9a; });
$parcel$export(module.exports, "getDependants", function () { return $3776e7107f86701a$export$ba70c5c8163184ee; });
$parcel$export(module.exports, "prepareFormulaForUpdate", function () { return $3776e7107f86701a$export$6d4423933971cfe0; });
$parcel$export(module.exports, "updateFormulas", function () { return $3776e7107f86701a$export$ac548ee671daaf6a; });

var $iCTvZ = parcelRequire("iCTvZ");
let $3776e7107f86701a$export$fca82059df0f33af = new Map();
let $3776e7107f86701a$export$2c2eda57346d1d49 = new Map();
let $3776e7107f86701a$export$3ee3d3a9e0006c80 = new Set();
const $3776e7107f86701a$export$60ed586f871e60ae = (formula)=>{
    $3776e7107f86701a$export$fca82059df0f33af.set(formula.context, formula);
};
const $3776e7107f86701a$export$3f9479a0e213ca3e = (dependencyRef, formula)=>{
    var _DependencyStore$get;
    $3776e7107f86701a$export$2c2eda57346d1d49.set(dependencyRef, (_DependencyStore$get = $3776e7107f86701a$export$2c2eda57346d1d49.get(dependencyRef)) !== null && _DependencyStore$get !== void 0 ? _DependencyStore$get : new Set());
    $3776e7107f86701a$export$2c2eda57346d1d49.get(dependencyRef).add(formula);
};
const $3776e7107f86701a$export$d68ff131ad0917e4 = (dependencyRef, formula)=>{
    const dependants = $3776e7107f86701a$export$2c2eda57346d1d49.get(dependencyRef);
    dependants && dependants.delete(formula);
    if (!dependants.size) $3776e7107f86701a$export$2c2eda57346d1d49.delete(dependencyRef);
};
const $3776e7107f86701a$export$9a371ee2fc90de9a = (formula, oldDeps, newDeps)=>{
    for (const depRef of oldDeps.keys())$3776e7107f86701a$export$d68ff131ad0917e4(depRef, formula);
    for (const depRef of newDeps.keys())$3776e7107f86701a$export$3f9479a0e213ca3e(depRef, formula);
};
const $3776e7107f86701a$export$862155d9d6290450 = (formula)=>{
    $3776e7107f86701a$export$fca82059df0f33af.delete(formula.context);
    for (const depRef of formula.dependencies.keys())$3776e7107f86701a$export$2c2eda57346d1d49.get(depRef).delete(formula);
};
const $3776e7107f86701a$export$ba70c5c8163184ee = (formula)=>{
    // console.log(
    //     "🚀 ~ file: FormulaStore.js ~ line 41 ~ getDependants ~ DependencyStore.get(formula.context)",
    // 	DependencyStore
    // );    
    return $3776e7107f86701a$export$2c2eda57346d1d49.get(formula.context) || new Set();
};
const $3776e7107f86701a$export$b97978456bcd4d5a = (oldRef, newRef)=>{
    for (const formulaRef of $3776e7107f86701a$export$fca82059df0f33af.keys())if (formulaRef[0] === oldRef) {
        const newFormulaRef = (0, $iCTvZ.default)(newRef, formulaRef[1]);
        const formula = $3776e7107f86701a$export$fca82059df0f33af.get(formulaRef);
        $3776e7107f86701a$export$fca82059df0f33af.delete(formulaRef);
        $3776e7107f86701a$export$fca82059df0f33af.set(newFormulaRef, formula);
    }
    for (const depRef of $3776e7107f86701a$export$2c2eda57346d1d49.keys())if (depRef[0] === oldRef) {
        const dependants = $3776e7107f86701a$export$2c2eda57346d1d49.get(depRef);
        for (const dep of dependants)$3776e7107f86701a$export$35aac200cfa5adf1(dep);
    }
};
const $3776e7107f86701a$export$35aac200cfa5adf1 = (formula, oldRef, newRef)=>{
    const oldString = formula.formula;
    const newString = oldString.replace(`#{oldRef}`, `#{newRef}`);
    if (oldString !== newString) formula.setFormula(newString);
};
const $3776e7107f86701a$export$6d4423933971cfe0 = (formula)=>{
    $3776e7107f86701a$export$3ee3d3a9e0006c80.add(formula);
};
const $3776e7107f86701a$export$ac548ee671daaf6a = ()=>{
    for (const formula of $3776e7107f86701a$export$3ee3d3a9e0006c80)formula.update();
    $3776e7107f86701a$export$3ee3d3a9e0006c80 = new Set();
};

});



parcelRegister("9psKg", function(module, exports) {

$parcel$export(module.exports, "invoiceProperties", function () { return $6d9cbf078e0f9cc1$export$d8cbae27a3b99756; });

var $iCTvZ = parcelRequire("iCTvZ");

var $4sGvn = parcelRequire("4sGvn");

var $kdO1A = parcelRequire("kdO1A");
const $6d9cbf078e0f9cc1$export$d8cbae27a3b99756 = (prop, invoiceValue, context)=>{
    var _invoicePropDepLookup, _invoicePropertiesLoo;
    const dependencies = ((_invoicePropDepLookup = $6d9cbf078e0f9cc1$var$invoicePropDepLookup[prop]) === null || _invoicePropDepLookup === void 0 ? void 0 : _invoicePropDepLookup.call($6d9cbf078e0f9cc1$var$invoicePropDepLookup, invoiceValue, context)) || new Map();
    if (dependencies.get(context)) throw {
        value: "Circular reference.",
        type: "error",
        dependencies: dependencies
    };
    const val = (_invoicePropertiesLoo = $6d9cbf078e0f9cc1$var$invoicePropertiesLookup[prop]) === null || _invoicePropertiesLoo === void 0 ? void 0 : _invoicePropertiesLoo.call($6d9cbf078e0f9cc1$var$invoicePropertiesLookup, invoiceValue, context);
    return val && {
        ...val,
        dependencies: dependencies
    };
};
const $6d9cbf078e0f9cc1$var$invoicePropertiesLookup = {
    project: (invoiceValue, context)=>{
        return {
            type: "project",
            value: (0, $kdO1A.default).projectsById[invoiceValue.value.projectId]
        };
    },
    contact: (invoiceValue, context)=>{
        return {
            type: "contact",
            value: (0, $4sGvn.default).contactsById[invoiceValue.value.contactId]
        };
    }
};
const $6d9cbf078e0f9cc1$var$invoicePropDepLookup = {
    project: (invoiceValue, context)=>new Map([
            ...invoiceValue.dependencies || [],
            [
                (0, $iCTvZ.default)(invoiceValue.value.ref, "project"),
                {}
            ]
        ]),
    contact: (invoiceValue, context)=>new Map([
            ...invoiceValue.dependencies || [],
            [
                (0, $iCTvZ.default)(invoiceValue.value.ref, "contact"),
                {}
            ]
        ])
};
const $6d9cbf078e0f9cc1$export$bc99da532307cb19 = {};

});

parcelRegister("b0ErZ", function(module, exports) {

$parcel$export(module.exports, "projectProperties", function () { return $803f12663a8cdaeb$export$6d40c8dda1d4fe52; });

var $egx7S = parcelRequire("egx7S");

var $5uSSv = parcelRequire("5uSSv");

var $PIDKX = parcelRequire("PIDKX");
const $803f12663a8cdaeb$export$6d40c8dda1d4fe52 = (prop, projectValue, context)=>{
    var _projectPropDepLookup, _projectPropertiesLoo;
    const dependencies = ((_projectPropDepLookup = $803f12663a8cdaeb$var$projectPropDepLookup[prop]) === null || _projectPropDepLookup === void 0 ? void 0 : _projectPropDepLookup.call($803f12663a8cdaeb$var$projectPropDepLookup, projectValue, context)) || new Map();
    if (dependencies.get(context)) throw {
        value: "Circular reference.",
        type: "error",
        dependencies: dependencies
    };
    const val = (_projectPropertiesLoo = $803f12663a8cdaeb$var$projectPropertiesLookup[prop]) === null || _projectPropertiesLoo === void 0 ? void 0 : _projectPropertiesLoo.call($803f12663a8cdaeb$var$projectPropertiesLookup, projectValue, context);
    return val && {
        ...val,
        dependencies: dependencies
    };
};
const $803f12663a8cdaeb$var$projectPropertiesLookup = {
    code: (projectValue, context)=>{
        return {
            type: "text",
            value: projectValue.value.jobNumber
        };
    },
    name: (projectValue, context)=>{
        return {
            type: "text",
            value: projectValue.value.name
        };
    },
    invNum: (projectValue, context)=>{
        var _SessionStore$organis, _SessionStore$organis2;
        return {
            type: "number",
            value: (0, $PIDKX.default).invoices.filter((i)=>i.projectId === projectValue.value.id).length + 1 + (((_SessionStore$organis = (0, $5uSSv.default).organisation.settings.invoiceNumber) === null || _SessionStore$organis === void 0 ? void 0 : (_SessionStore$organis2 = _SessionStore$organis.numProjAdjustors) === null || _SessionStore$organis2 === void 0 ? void 0 : _SessionStore$organis2[projectValue.value.id]) || 0)
        };
    },
    invNumYear: (projectValue, context)=>{
        var _SessionStore$organis3, _SessionStore$organis4, _SessionStore$organis5;
        return {
            type: "number",
            value: (0, $PIDKX.default).invoicesfilter((i)=>i.projectId === projectValue.value.id && (0, $egx7S.isSameYear)(i.createdAt, new Date())).length + 1 + (((_SessionStore$organis3 = (0, $5uSSv.default).organisation.settings.invoiceNumber) === null || _SessionStore$organis3 === void 0 ? void 0 : (_SessionStore$organis4 = _SessionStore$organis3.numProjAdjustors) === null || _SessionStore$organis4 === void 0 ? void 0 : (_SessionStore$organis5 = _SessionStore$organis4[projectValue.value.id]) === null || _SessionStore$organis5 === void 0 ? void 0 : _SessionStore$organis5[new Date().getFullYear()]) || 0)
        };
    }
};
const $803f12663a8cdaeb$var$projectPropDepLookup = {
    code: (projectValue, context)=>new Map([
            ...projectValue.dependencies || []
        ]),
    name: (projectValue, context)=>new Map([
            ...projectValue.dependencies || []
        ]),
    numInvoices: (projectValue, context)=>new Map([
            ...projectValue.dependencies || []
        ]),
    numInvoicesThisYear: (projectValue, context)=>new Map([
            ...projectValue.dependencies || []
        ])
};
const $803f12663a8cdaeb$export$67497ab732922a97 = {};

});

parcelRegister("gnlsD", function(module, exports) {

$parcel$export(module.exports, "contactProperties", function () { return $bebf70ff37126e50$export$7840d0801779381f; });
const $bebf70ff37126e50$export$7840d0801779381f = (prop, contactValue, context)=>{
    var _contactPropDepLookup, _contactPropertiesLoo;
    const dependencies = ((_contactPropDepLookup = $bebf70ff37126e50$var$contactPropDepLookup[prop]) === null || _contactPropDepLookup === void 0 ? void 0 : _contactPropDepLookup.call($bebf70ff37126e50$var$contactPropDepLookup, contactValue, context)) || new Map();
    if (dependencies.get(context)) throw {
        value: "Circular reference.",
        type: "error",
        dependencies: dependencies
    };
    const val = (_contactPropertiesLoo = $bebf70ff37126e50$var$contactPropertiesLookup[prop]) === null || _contactPropertiesLoo === void 0 ? void 0 : _contactPropertiesLoo.call($bebf70ff37126e50$var$contactPropertiesLookup, contactValue, context);
    return val && {
        ...val,
        dependencies: dependencies
    };
};
const $bebf70ff37126e50$var$contactPropertiesLookup = {
    firstName: (contactValue, context)=>{
        return {
            type: "text",
            value: contactValue.value.firstName
        };
    },
    lastName: (contactValue, context)=>{
        return {
            type: "text",
            value: contactValue.value.lastName
        };
    },
    organisation: (contactValue, context)=>{
        return {
            type: "text",
            value: contactValue.value.organisationName
        };
    }
};
const $bebf70ff37126e50$var$contactPropDepLookup = {
    firstName: (contactValue, context)=>new Map([
            ...contactValue.dependencies || []
        ]),
    lastName: (contactValue, context)=>new Map([
            ...contactValue.dependencies || []
        ]),
    organisation: (contactValue, context)=>new Map([
            ...contactValue.dependencies || []
        ])
};
const $bebf70ff37126e50$export$acaba7e6766bdad = {};

});











parcelRegister("1SEQ6", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $15ea8374ad5a81da$export$306c0aa65ff9ec16; }, function (v) { return $15ea8374ad5a81da$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $15ea8374ad5a81da$export$306c0aa65ff9ec16;
"use strict";

var $7PdBe = parcelRequire("7PdBe");
function $15ea8374ad5a81da$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $15ea8374ad5a81da$var$objectIs = "function" === typeof Object.is ? Object.is : $15ea8374ad5a81da$var$is, $15ea8374ad5a81da$var$useState = $7PdBe.useState, $15ea8374ad5a81da$var$useEffect = $7PdBe.useEffect, $15ea8374ad5a81da$var$useLayoutEffect = $7PdBe.useLayoutEffect, $15ea8374ad5a81da$var$useDebugValue = $7PdBe.useDebugValue;
function $15ea8374ad5a81da$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $15ea8374ad5a81da$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $15ea8374ad5a81da$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $15ea8374ad5a81da$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $15ea8374ad5a81da$var$useEffect(function() {
        $15ea8374ad5a81da$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $15ea8374ad5a81da$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $15ea8374ad5a81da$var$useDebugValue(value);
    return value;
}
function $15ea8374ad5a81da$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$15ea8374ad5a81da$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $15ea8374ad5a81da$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $15ea8374ad5a81da$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $15ea8374ad5a81da$var$useSyncExternalStore$1 : $15ea8374ad5a81da$var$useSyncExternalStore$2;
$15ea8374ad5a81da$export$306c0aa65ff9ec16 = void 0 !== $7PdBe.useSyncExternalStore ? $7PdBe.useSyncExternalStore : $15ea8374ad5a81da$var$shim;

});

parcelRegister("2BzXY", function(module, exports) {
/* UAParser.js v2.0.5
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   AGPLv3 License */ ((i, c)=>{
    function V(i) {
        for(var e = {}, t = 0; t < i.length; t++)e[i[t].toUpperCase()] = i[t];
        return e;
    }
    var I = 500, U = "user-agent", d = "", B = "?", L = "function", n = "undefined", l = "object", R = "string", u = "browser", h = "cpu", p = "device", m = "engine", f = "os", g = "result", v = "name", k = "type", x = "vendor", y = "version", C = "architecture", G = "major", S = "model", W = "console", _ = "mobile", r = "tablet", e = "smarttv", t = "wearable", N = "xr", F = "embedded", o = "inapp", D = "brands", q = "formFactors", $ = "fullVersionList", z = "platform", X = "platformVersion", Y = "bitness", a = "sec-ch-ua", Z = a + "-full-version-list", Q = a + "-arch", K = a + "-" + Y, J = a + "-form-factors", ii = a + "-" + _, ei = a + "-" + S, ti = a + "-" + z, oi = ti + "-version", ri = [
        D,
        $,
        _,
        S,
        z,
        X,
        C,
        q,
        Y
    ], ai = "Amazon", s = "Apple", si = "ASUS", ni = "BlackBerry", w = "Google", wi = "Huawei", bi = "Lenovo", di = "Microsoft", li = "Motorola", ci = "Nvidia", ui = "OnePlus", hi = "OPPO", pi = "Samsung", mi = "Sony", fi = "Xiaomi", gi = "Zebra", vi = "Chromium", b = "Chromecast", ki = "Edge", xi = "Firefox", O = "Opera", yi = "Facebook", T = "Mobile ", Ci = " Browser", Si = "Windows", _i = typeof i !== n, A = _i && i.navigator ? i.navigator : c, H = A && A.userAgentData ? A.userAgentData : c, qi = function(i, e) {
        if (typeof i === l && 0 < i.length) {
            for(var t in i)if (j(e) == j(i[t])) return !0;
            return !1;
        }
        return !!Oi(i) && j(e) == j(i);
    }, zi = function(i, e) {
        for(var t in i)return /^(browser|cpu|device|engine|os)$/.test(t) || !!e && zi(i[t]);
    }, Oi = function(i) {
        return typeof i === R;
    }, Ti = function(i) {
        if (!i) return c;
        for(var e, t = [], o = Hi(/\\?\"/g, i).split(","), r = 0; r < o.length; r++)-1 < o[r].indexOf(";") ? (e = Mi(o[r]).split(";v="), t[r] = {
            brand: e[0],
            version: e[1]
        }) : t[r] = Mi(o[r]);
        return t;
    }, j = function(i) {
        return Oi(i) ? i.toLowerCase() : i;
    }, Ai = function(i) {
        return Oi(i) ? Hi(/[^\d\.]/g, i).split(".")[0] : c;
    }, M = function(i) {
        for(var e in i)i.hasOwnProperty(e) && (typeof (e = i[e]) == l && 2 == e.length ? this[e[0]] = e[1] : this[e] = c);
        return this;
    }, Hi = function(i, e) {
        return Oi(e) ? e.replace(i, d) : e;
    }, ji = function(i) {
        return Hi(/\\?\"/g, i);
    }, Mi = function(i, e) {
        if (Oi(i)) return i = Hi(/^\s\s*/, i), typeof e === n ? i : i.substring(0, I);
    }, Ei = function(i, e) {
        if (i && e) for(var t, o, r, a, s, n = 0; n < e.length && !a;){
            for(var w = e[n], b = e[n + 1], d = t = 0; d < w.length && !a && w[d];)if (a = w[d++].exec(i)) for(o = 0; o < b.length; o++)s = a[++t], typeof (r = b[o]) === l && 0 < r.length ? 2 === r.length ? typeof r[1] == L ? this[r[0]] = r[1].call(this, s) : this[r[0]] = r[1] : 3 <= r.length && (typeof r[1] !== L || r[1].exec && r[1].test ? 3 == r.length ? this[r[0]] = s ? s.replace(r[1], r[2]) : c : 4 == r.length ? this[r[0]] = s ? r[3].call(this, s.replace(r[1], r[2])) : c : 4 < r.length && (this[r[0]] = s ? r[3].apply(this, [
                s.replace(r[1], r[2])
            ].concat(r.slice(4))) : c) : 3 < r.length ? this[r[0]] = s ? r[1].apply(this, r.slice(2)) : c : this[r[0]] = s ? r[1].call(this, s, r[2]) : c) : this[r] = s || c;
            n += 2;
        }
    }, E = function(i, e) {
        for(var t in e)if (typeof e[t] === l && 0 < e[t].length) {
            for(var o = 0; o < e[t].length; o++)if (qi(e[t][o], i)) return t === B ? c : t;
        } else if (qi(e[t], i)) return t === B ? c : t;
        return e.hasOwnProperty("*") ? e["*"] : i;
    }, Pi = {
        ME: "4.90",
        "NT 3.51": "3.51",
        "NT 4.0": "4.0",
        2e3: [
            "5.0",
            "5.01"
        ],
        XP: [
            "5.1",
            "5.2"
        ],
        Vista: "6.0",
        7: "6.1",
        8: "6.2",
        8.1: "6.3",
        10: [
            "6.4",
            "10.0"
        ],
        NT: ""
    }, Vi = {
        embedded: "Automotive",
        mobile: "Mobile",
        tablet: [
            "Tablet",
            "EInk"
        ],
        smarttv: "TV",
        wearable: "Watch",
        xr: [
            "VR",
            "XR"
        ],
        "?": [
            "Desktop",
            "Unknown"
        ],
        "*": c
    }, Ii = {
        Chrome: "Google Chrome",
        Edge: "Microsoft Edge",
        "Edge WebView2": "Microsoft Edge WebView2",
        "Chrome WebView": "Android WebView",
        "Chrome Headless": "HeadlessChrome",
        "Huawei Browser": "HuaweiBrowser",
        "MIUI Browser": "Miui Browser",
        "Opera Mobi": "OperaMobile",
        Yandex: "YaBrowser"
    }, Ui = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    T + "Chrome"
                ]
            ],
            [
                /webview.+edge\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    ki + " WebView"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    O + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    O + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    O
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                y,
                [
                    v,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:lg |qute)browser)\/([-\w\.]+)/i,
                /(heytap|ovi|115|surf)browser\/([\d\.]+)/i,
                /(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "UCBrowser"
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                y,
                [
                    v,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Smart " + bi + Ci
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "$1 Secure" + Ci
                ],
                y
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    xi + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    O + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    O + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "MIUI" + Ci
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                y,
                [
                    v,
                    T + xi
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                y,
                [
                    v,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "$1Browser"
                ],
                y
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "$1" + Ci
                ],
                y
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    pi + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    v,
                    "Sogou Mobile"
                ],
                y
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /(lbbrowser|rekonq)/i
            ],
            [
                v
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                y,
                v
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    v,
                    yi
                ],
                y,
                [
                    k,
                    o
                ]
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(instagram|snapchat|klarna)[\/ ]([-\w\.]+)/i
            ],
            [
                v,
                y,
                [
                    k,
                    o
                ]
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                y,
                [
                    v,
                    "GSA"
                ],
                [
                    k,
                    o
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "TikTok"
                ],
                [
                    k,
                    o
                ]
            ],
            [
                /\[(linkedin)app\]/i
            ],
            [
                v,
                [
                    k,
                    o
                ]
            ],
            [
                /(zalo(?:app)?)[\/\sa-z]*([\w\.-]+)/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "Zalo"
                ],
                y,
                [
                    k,
                    o
                ]
            ],
            [
                /(chromium)[\/ ]([-\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                y,
                [
                    v,
                    "Chrome Headless"
                ]
            ],
            [
                /wv\).+chrome\/([\w\.]+).+edgw\//i
            ],
            [
                y,
                [
                    v,
                    ki + " WebView2"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    v,
                    "Chrome WebView"
                ],
                y
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                y,
                [
                    v,
                    "Android" + Ci
                ]
            ],
            [
                /chrome\/([\w\.]+) mobile/i
            ],
            [
                y,
                [
                    v,
                    T + "Chrome"
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
            ],
            [
                y,
                [
                    v,
                    T + "Safari"
                ]
            ],
            [
                /iphone .*mobile(?:\/\w+ | ?)safari/i
            ],
            [
                [
                    v,
                    T + "Safari"
                ]
            ],
            [
                /version\/([\w\.\,]+) .*(safari)/i
            ],
            [
                y,
                v
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                v,
                [
                    y,
                    "1"
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
            ],
            [
                [
                    v,
                    T + xi
                ],
                y
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    v,
                    "Netscape"
                ],
                y
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                y,
                [
                    v,
                    xi + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                v,
                [
                    y,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                v,
                [
                    y,
                    /[^\d\.]+./,
                    d
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    C,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    C,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    C,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    C,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    C,
                    "arm"
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    C,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i,
                /((ppc|powerpc)(64)?)( mac|;|\))/i,
                /(?:osf1|[freopnt]{3,4}bsd) (alpha)/i
            ],
            [
                [
                    C,
                    /ower/,
                    d,
                    j
                ]
            ],
            [
                /winnt.+\[axp/i
            ],
            [
                [
                    C,
                    "alpha"
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                S,
                [
                    x,
                    pi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr]|browser)[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                S,
                [
                    x,
                    pi
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                S,
                [
                    x,
                    s
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                S,
                [
                    x,
                    s
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                S,
                [
                    x,
                    s
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                S,
                [
                    x,
                    "Sharp"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                S,
                [
                    x,
                    "Honor"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                S,
                [
                    x,
                    "Honor"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                S,
                [
                    x,
                    wi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                S,
                [
                    x,
                    wi
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    S,
                    /_/g,
                    " "
                ],
                [
                    x,
                    fi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    S,
                    /_/g,
                    " "
                ],
                [
                    x,
                    fi
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /droid.+; (cph2[3-6]\d[13579]|((gm|hd)19|(ac|be|in|kb)20|(d[en]|eb|le|mt)21|ne22)[0-2]\d|p[g-k]\w[1m]10)\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                S,
                [
                    x,
                    ui
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                S,
                [
                    x,
                    hi
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                S,
                [
                    x,
                    E,
                    {
                        OnePlus: [
                            "203",
                            "304",
                            "403",
                            "404",
                            "413",
                            "415"
                        ],
                        "*": hi
                    }
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i
            ],
            [
                S,
                [
                    x,
                    "BLU"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /; vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                S,
                [
                    x,
                    "Vivo"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                S,
                [
                    x,
                    "Realme"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                S,
                [
                    x,
                    bi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /lenovo[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i
            ],
            [
                S,
                [
                    x,
                    bi
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ]([\w\s]+)(\)| bui)/i,
                /((?:moto(?! 360)[-\w\(\) ]+|xt\d{3,4}[cgkosw\+]?[-\d]*|nexus 6)(?= bui|\)))/i
            ],
            [
                S,
                [
                    x,
                    li
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                S,
                [
                    x,
                    li
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                S,
                [
                    x,
                    "LG"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch|webos))(\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                S,
                [
                    x,
                    "LG"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                x,
                S,
                [
                    k,
                    r
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    S,
                    /_/g,
                    " "
                ],
                [
                    k,
                    _
                ],
                [
                    x,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                S,
                [
                    x,
                    w
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid.+;(?: google)? (g(01[13]a|020[aem]|025[jn]|1b60|1f8f|2ybb|4s1m|576d|5nz6|8hhn|8vou|a02099|c15s|d1yq|e2ae|ec77|gh2x|kv4x|p4bc|pj41|r83y|tt9q|ur25|wvk6)|pixel[\d ]*a?( pro)?( xl)?( fold)?( \(5g\))?)( bui|\))/i
            ],
            [
                S,
                [
                    x,
                    w
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(google) (pixelbook( go)?)/i
            ],
            [
                x,
                S
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-\w\w\d\d)(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                S,
                [
                    x,
                    mi
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    S,
                    "Xperia Tablet"
                ],
                [
                    x,
                    mi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                S,
                [
                    x,
                    ai
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    S,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    x,
                    ai
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                S,
                x,
                [
                    k,
                    r
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                S,
                [
                    x,
                    ni
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                S,
                [
                    x,
                    si
                ],
                [
                    k,
                    r
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                S,
                [
                    x,
                    si
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                S,
                [
                    x,
                    "HTC"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                x,
                [
                    S,
                    /_/g,
                    " "
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /tcl (xess p17aa)/i,
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
            ],
            [
                S,
                [
                    x,
                    "TCL"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
            ],
            [
                S,
                [
                    x,
                    "TCL"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    x,
                    j
                ],
                S,
                [
                    k,
                    E,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                S,
                [
                    x,
                    "Acer"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                S,
                [
                    x,
                    "Meizu"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                S,
                [
                    x,
                    "Ulefone"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                S,
                [
                    x,
                    "Energizer"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                S,
                [
                    x,
                    "Cat"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                S,
                [
                    x,
                    "Smartfren"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /droid.+; (a(in)?(0(15|59|6[35])|142)p?)/i
            ],
            [
                S,
                [
                    x,
                    "Nothing"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                S,
                [
                    x,
                    "Archos"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                S,
                [
                    x,
                    "Archos"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /; (n159v)/i
            ],
            [
                S,
                [
                    x,
                    "HMD"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix|tecno) (x1101b?|p904|dp(7c|8d|10a)( pro)?|p70[1-3]a?|p904|t1101)/i
            ],
            [
                x,
                S,
                [
                    k,
                    r
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (blu|hmd|imo|infinix|lava|oneplus|tcl)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(oppo) ?([\w ]+) bui/i,
                /droid[^;]+; (philips)[_ ]([sv-x][\d]{3,4}[xz]?)/i
            ],
            [
                x,
                S,
                [
                    k,
                    _
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i
            ],
            [
                x,
                S,
                [
                    k,
                    r
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                S,
                [
                    x,
                    di
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                S,
                [
                    x,
                    "Fairphone"
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                S,
                [
                    x,
                    ci
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                x,
                S,
                [
                    k,
                    _
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    S,
                    /\./g,
                    " "
                ],
                [
                    x,
                    di
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                S,
                [
                    x,
                    gi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                S,
                [
                    x,
                    gi
                ],
                [
                    k,
                    _
                ]
            ],
            [
                /(philips)[\w ]+tv/i,
                /smart-tv.+(samsung)/i
            ],
            [
                x,
                [
                    k,
                    e
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    S,
                    /^/,
                    "SmartTV"
                ],
                [
                    x,
                    pi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(vizio)(?: |.+model\/)(\w+-\w+)/i,
                /tcast.+(lg)e?. ([-\w]+)/i
            ],
            [
                x,
                S,
                [
                    k,
                    e
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    x,
                    "LG"
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                x,
                [
                    S,
                    s + " TV"
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /crkey.*devicetype\/chromecast/i
            ],
            [
                [
                    S,
                    b + " Third Generation"
                ],
                [
                    x,
                    w
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /crkey.*devicetype\/([^/]*)/i
            ],
            [
                [
                    S,
                    /^/,
                    "Chromecast "
                ],
                [
                    x,
                    w
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /fuchsia.*crkey/i
            ],
            [
                [
                    S,
                    b + " Nest Hub"
                ],
                [
                    x,
                    w
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    S,
                    b
                ],
                [
                    x,
                    w
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(portaltv)/i
            ],
            [
                S,
                [
                    x,
                    yi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                S,
                [
                    x,
                    ai
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                S,
                [
                    x,
                    ci
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                S,
                [
                    x,
                    "Sharp"
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                S,
                [
                    x,
                    mi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                S,
                [
                    x,
                    fi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                x,
                S,
                [
                    k,
                    e
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    x,
                    /.+\/(\w+)/,
                    "$1",
                    E,
                    {
                        LG: "lge"
                    }
                ],
                [
                    S,
                    Mi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                S,
                [
                    x,
                    mi
                ],
                [
                    k,
                    W
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                S,
                [
                    x,
                    di
                ],
                [
                    k,
                    W
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) (\w+)/i,
                /(retroid) (pocket ([^\)]+))/i
            ],
            [
                x,
                S,
                [
                    k,
                    W
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                S,
                [
                    x,
                    ci
                ],
                [
                    k,
                    W
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                S,
                [
                    x,
                    pi
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                x,
                S,
                [
                    k,
                    t
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                S,
                [
                    x,
                    hi
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                S,
                [
                    x,
                    s
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                S,
                [
                    x,
                    ui
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                S,
                [
                    x,
                    li
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                S,
                [
                    x,
                    mi
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                S,
                [
                    x,
                    "LG"
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                S,
                [
                    x,
                    gi
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                S,
                [
                    x,
                    w
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(pico) ([\w ]+) os\d/i
            ],
            [
                x,
                S,
                [
                    k,
                    N
                ]
            ],
            [
                /(quest( \d| pro)?s?).+vr/i
            ],
            [
                S,
                [
                    x,
                    yi
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /mobile vr; rv.+firefox/i
            ],
            [
                [
                    k,
                    N
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                x,
                [
                    k,
                    F
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                S,
                [
                    x,
                    ai
                ],
                [
                    k,
                    F
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                S,
                [
                    x,
                    s
                ],
                [
                    k,
                    F
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    k,
                    F
                ]
            ],
            [
                /droid.+; ([\w- ]+) (4k|android|smart|google)[- ]?tv/i
            ],
            [
                S,
                [
                    k,
                    e
                ]
            ],
            [
                /\b((4k|android|smart|opera)[- ]?tv|tv; rv:|large screen[\w ]+safari)\b/i
            ],
            [
                [
                    k,
                    e
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i
            ],
            [
                S,
                [
                    k,
                    E,
                    {
                        mobile: "Mobile",
                        xr: "VR",
                        "*": r
                    }
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    k,
                    r
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    k,
                    _
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                S,
                [
                    x,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    ki + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                v,
                y
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    v,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                y,
                v
            ]
        ],
        os: [
            [
                /(windows nt) (6\.[23]); arm/i
            ],
            [
                [
                    v,
                    /N/,
                    "R"
                ],
                [
                    y,
                    E,
                    Pi
                ]
            ],
            [
                /(windows (?:phone|mobile|iot))(?: os)?[\/ ]?([\d\.]*( se)?)/i,
                /(windows)[\/ ](1[01]|2000|3\.1|7|8(\.1)?|9[58]|me|server 20\d\d( r2)?|vista|xp)/i
            ],
            [
                v,
                y
            ],
            [
                /windows nt ?([\d\.\)]*)(?!.+xbox)/i,
                /\bwin(?=3| ?9|n)(?:nt| 9x )?([\d\.;]*)/i
            ],
            [
                [
                    y,
                    /(;|\))/g,
                    "",
                    E,
                    Pi
                ],
                [
                    v,
                    Si
                ]
            ],
            [
                /(windows ce)\/?([\d\.]*)/i
            ],
            [
                v,
                y
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    y,
                    /_/g,
                    "."
                ],
                [
                    v,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+(haiku|morphos))/i
            ],
            [
                [
                    v,
                    "macOS"
                ],
                [
                    y,
                    /_/g,
                    "."
                ]
            ],
            [
                /android ([\d\.]+).*crkey/i
            ],
            [
                y,
                [
                    v,
                    b + " Android"
                ]
            ],
            [
                /fuchsia.*crkey\/([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    b + " Fuchsia"
                ]
            ],
            [
                /crkey\/([\d\.]+).*devicetype\/smartspeaker/i
            ],
            [
                y,
                [
                    v,
                    b + " SmartSpeaker"
                ]
            ],
            [
                /linux.*crkey\/([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    b + " Linux"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    b
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86)/i
            ],
            [
                y,
                v
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "$1 Touch"
                ],
                y
            ],
            [
                /(harmonyos)[\/ ]?([\d\.]*)/i,
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen)\w*[-\/\.; ]?([\d\.]*)/i
            ],
            [
                v,
                y
            ],
            [
                /\(bb(10);/i
            ],
            [
                y,
                [
                    v,
                    ni
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                y,
                [
                    v,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    xi + " OS"
                ]
            ],
            [
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i,
                /webos(?:[ \/]?|\.tv-20(?=2[2-9]))(\d[\d\.]*)/i
            ],
            [
                y,
                [
                    v,
                    "webOS"
                ]
            ],
            [
                /web0s;.+?(?:chr[o0]me|safari)\/(\d+)/i
            ],
            [
                [
                    y,
                    E,
                    {
                        25: "120",
                        24: "108",
                        23: "94",
                        22: "87",
                        6: "79",
                        5: "68",
                        4: "53",
                        3: "38",
                        2: "538",
                        1: "537",
                        "*": "TV"
                    }
                ],
                [
                    v,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "watchOS"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    v,
                    "Chrome OS"
                ],
                y
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) (\w+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /(pico) .+os([\w\.]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /linux.+(mint)[\/\(\) ]?([\w\.]*)/i,
                /(mageia|vectorlinux|fuchsia|arcaos|arch(?= ?linux))[;l ]([\d\.]*)/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire|knoppix)(?: gnu[\/ ]linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /\b(aix)[; ]([1-9\.]{0,4})/i,
                /(hurd|linux|morphos)(?: (?:arm|x86|ppc)\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) ?(r\d)?/i
            ],
            [
                v,
                y
            ],
            [
                /(sunos) ?([\d\.]*)/i
            ],
            [
                [
                    v,
                    "Solaris"
                ],
                y
            ],
            [
                /\b(beos|os\/2|amigaos|openvms|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                v,
                y
            ]
        ]
    }, Bi = (O = {
        init: {},
        isIgnore: {},
        isIgnoreRgx: {},
        toString: {}
    }, M.call(O.init, [
        [
            u,
            [
                v,
                y,
                G,
                k
            ]
        ],
        [
            h,
            [
                C
            ]
        ],
        [
            p,
            [
                k,
                S,
                x
            ]
        ],
        [
            m,
            [
                v,
                y
            ]
        ],
        [
            f,
            [
                v,
                y
            ]
        ]
    ]), M.call(O.isIgnore, [
        [
            u,
            [
                y,
                G
            ]
        ],
        [
            m,
            [
                y
            ]
        ],
        [
            f,
            [
                y
            ]
        ]
    ]), M.call(O.isIgnoreRgx, [
        [
            u,
            / ?browser$/i
        ],
        [
            f,
            / ?os$/i
        ]
    ]), M.call(O.toString, [
        [
            u,
            [
                v,
                y
            ]
        ],
        [
            h,
            [
                C
            ]
        ],
        [
            p,
            [
                x,
                S
            ]
        ],
        [
            m,
            [
                v,
                y
            ]
        ],
        [
            f,
            [
                v,
                y
            ]
        ]
    ]), O), Li = function(e, i) {
        var t = Bi.init[i], o = Bi.isIgnore[i] || 0, r = Bi.isIgnoreRgx[i] || 0, a = Bi.toString[i] || 0;
        function s() {
            M.call(this, t);
        }
        return s.prototype.getItem = function() {
            return e;
        }, s.prototype.withClientHints = function() {
            return H ? H.getHighEntropyValues(ri).then(function(i) {
                return e.setCH(new Ri(i, !1)).parseCH().get();
            }) : e.parseCH().get();
        }, s.prototype.withFeatureCheck = function() {
            return e.detectFeature().get();
        }, i != g && (s.prototype.is = function(i) {
            var e, t = !1;
            for(e in this)if (this.hasOwnProperty(e) && !qi(o, e) && j(r ? Hi(r, this[e]) : this[e]) == j(r ? Hi(r, i) : i)) {
                if (t = !0, i != n) break;
            } else if (i == n && t) {
                t = !t;
                break;
            }
            return t;
        }, s.prototype.toString = function() {
            var i, e = d;
            for(i in a)typeof this[a[i]] !== n && (e += (e ? " " : d) + this[a[i]]);
            return e || n;
        }), H || (s.prototype.then = function(i) {
            function e() {
                for(var i in t)t.hasOwnProperty(i) && (this[i] = t[i]);
            }
            var t = this, o = (e.prototype = {
                is: s.prototype.is,
                toString: s.prototype.toString
            }, new e);
            return i(o), o;
        }), new s;
    };
    function Ri(i, e) {
        if (i = i || {}, M.call(this, ri), e) M.call(this, [
            [
                D,
                Ti(i[a])
            ],
            [
                $,
                Ti(i[Z])
            ],
            [
                _,
                /\?1/.test(i[ii])
            ],
            [
                S,
                ji(i[ei])
            ],
            [
                z,
                ji(i[ti])
            ],
            [
                X,
                ji(i[oi])
            ],
            [
                C,
                ji(i[Q])
            ],
            [
                q,
                Ti(i[J])
            ],
            [
                Y,
                ji(i[K])
            ]
        ]);
        else for(var t in i)this.hasOwnProperty(t) && typeof i[t] !== n && (this[t] = i[t]);
    }
    function Gi(i, e, t, o) {
        return this.get = function(i) {
            return i ? this.data.hasOwnProperty(i) ? this.data[i] : c : this.data;
        }, this.set = function(i, e) {
            return this.data[i] = e, this;
        }, this.setCH = function(i) {
            return this.uaCH = i, this;
        }, this.detectFeature = function() {
            if (A && A.userAgent == this.ua) switch(this.itemType){
                case u:
                    A.brave && typeof A.brave.isBrave == L && this.set(v, "Brave");
                    break;
                case p:
                    !this.get(k) && H && H[_] && this.set(k, _), "Macintosh" == this.get(S) && A && typeof A.standalone !== n && A.maxTouchPoints && 2 < A.maxTouchPoints && this.set(S, "iPad").set(k, r);
                    break;
                case f:
                    !this.get(v) && H && H[z] && this.set(v, H[z]);
                    break;
                case g:
                    var e = this.data, i = function(i) {
                        return e[i].getItem().detectFeature().get();
                    };
                    this.set(u, i(u)).set(h, i(h)).set(p, i(p)).set(m, i(m)).set(f, i(f));
            }
            return this;
        }, this.parseUA = function() {
            return this.itemType != g && Ei.call(this.data, this.ua, this.rgxMap), this.itemType == u && this.set(G, Ai(this.get(y))), this;
        }, this.parseCH = function() {
            var i, e = this.uaCH, t = this.rgxMap;
            switch(this.itemType){
                case u:
                case m:
                    var o, r = e[$] || e[D];
                    if (r) for(var a = 0; a < r.length; a++){
                        var s = r[a].brand || r[a], n = r[a].version;
                        this.itemType == u && !/not.a.brand/i.test(s) && (!o || /Chrom/.test(o) && s != vi || o == ki && /WebView2/.test(s)) && (s = E(s, Ii), (o = this.get(v)) && !/Chrom/.test(o) && /Chrom/.test(s) || this.set(v, s).set(y, n).set(G, Ai(n)), o = s), this.itemType == m && s == vi && this.set(y, n);
                    }
                    break;
                case h:
                    var w = e[C];
                    w && ("64" == e[Y] && (w += "64"), Ei.call(this.data, w + ";", t));
                    break;
                case p:
                    if (e[_] && this.set(k, _), e[S] && (this.set(S, e[S]), this.get(k) && this.get(x) || (Ei.call(w = {}, "droid 9; " + e[S] + ")", t), !this.get(k) && w.type && this.set(k, w.type), !this.get(x) && w.vendor && this.set(x, w.vendor))), e[q]) {
                        if ("string" != typeof e[q]) for(var b = 0; !i && b < e[q].length;)i = E(e[q][b++], Vi);
                        else i = E(e[q], Vi);
                        this.set(k, i);
                    }
                    break;
                case f:
                    var d, w = e[z];
                    w && (d = e[X], w == Si && (d = 13 <= parseInt(Ai(d), 10) ? "11" : "10"), this.set(v, w).set(y, d)), this.get(v) == Si && "Xbox" == e[S] && this.set(v, "Xbox").set(y, c);
                    break;
                case g:
                    var l = this.data, w = function(i) {
                        return l[i].getItem().setCH(e).parseCH().get();
                    };
                    this.set(u, w(u)).set(h, w(h)).set(p, w(p)).set(m, w(m)).set(f, w(f));
            }
            return this;
        }, M.call(this, [
            [
                "itemType",
                i
            ],
            [
                "ua",
                e
            ],
            [
                "uaCH",
                o
            ],
            [
                "rgxMap",
                t
            ],
            [
                "data",
                Li(this, i)
            ]
        ]), this;
    }
    function P(i, e, t) {
        if (typeof i === l ? (e = zi(i, !0) ? (typeof e === l && (t = e), i) : (t = i, c), i = c) : typeof i !== R || zi(e, !0) || (t = e, e = c), t) {
            if (typeof t.append === L) {
                var o = {};
                t.forEach(function(i, e) {
                    o[String(e).toLowerCase()] = i;
                }), t = o;
            } else {
                var r, a = {};
                for(r in t)t.hasOwnProperty(r) && (a[String(r).toLowerCase()] = t[r]);
                t = a;
            }
        }
        var s, n, w, b;
        return this instanceof P ? (s = typeof i === R ? i : t && t[U] ? t[U] : A && A.userAgent ? A.userAgent : d, n = new Ri(t, !0), w = e ? ((i, e)=>{
            var t, o = {}, r = e;
            if (!zi(e)) for(var a in r = {}, e)for(var s in e[a])r[s] = e[a][s].concat(r[s] || []);
            for(t in i)o[t] = r[t] && r[t].length % 2 == 0 ? r[t].concat(i[t]) : i[t];
            return o;
        })(Ui, e) : Ui, M.call(this, [
            [
                "getBrowser",
                (b = function(i) {
                    return i == g ? function() {
                        return new Gi(i, s, w, n).set("ua", s).set(u, this.getBrowser()).set(h, this.getCPU()).set(p, this.getDevice()).set(m, this.getEngine()).set(f, this.getOS()).get();
                    } : function() {
                        return new Gi(i, s, w[i], n).parseUA().get();
                    };
                })(u)
            ],
            [
                "getCPU",
                b(h)
            ],
            [
                "getDevice",
                b(p)
            ],
            [
                "getEngine",
                b(m)
            ],
            [
                "getOS",
                b(f)
            ],
            [
                "getResult",
                b(g)
            ],
            [
                "getUA",
                function() {
                    return s;
                }
            ],
            [
                "setUA",
                function(i) {
                    return Oi(i) && (s = i.length > I ? Mi(i, I) : i), this;
                }
            ]
        ]).setUA(s), this) : new P(i, e, t).getResult();
    }
    P.VERSION = "2.0.5", P.BROWSER = V([
        v,
        y,
        G,
        k
    ]), P.CPU = V([
        C
    ]), P.DEVICE = V([
        S,
        x,
        k,
        W,
        _,
        e,
        r,
        t,
        F
    ]), P.ENGINE = P.OS = V([
        v,
        y
    ]), "object" !== n ? (exports = "object" !== n && module.exports ? module.exports = P : exports).UAParser = P : typeof define === L && define.amd ? define(function() {
        return P;
    }) : _i && (i.UAParser = P);
    var Wi, Ni = _i && (i.jQuery || i.Zepto);
    Ni && !Ni.ua && (Wi = new P, Ni.ua = Wi.getResult(), Ni.ua.get = function() {
        return Wi.getUA();
    }, Ni.ua.set = function(i) {
        Wi.setUA(i);
        var e, t = Wi.getResult();
        for(e in t)Ni.ua[e] = t[e];
    });
})("object" == typeof window ? window : this);

});

parcelRegister("erbba", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $a82c423d96fa78ed$export$306c0aa65ff9ec16; }, function (v) { return $a82c423d96fa78ed$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a82c423d96fa78ed$export$306c0aa65ff9ec16;
"use strict";

var $7PdBe = parcelRequire("7PdBe");
function $a82c423d96fa78ed$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a82c423d96fa78ed$var$k = "function" === typeof Object.is ? Object.is : $a82c423d96fa78ed$var$h, $a82c423d96fa78ed$var$l = $7PdBe.useState, $a82c423d96fa78ed$var$m = $7PdBe.useEffect, $a82c423d96fa78ed$var$n = $7PdBe.useLayoutEffect, $a82c423d96fa78ed$var$p = $7PdBe.useDebugValue;
function $a82c423d96fa78ed$var$q(a, b) {
    var d = b(), f = $a82c423d96fa78ed$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $a82c423d96fa78ed$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $a82c423d96fa78ed$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $a82c423d96fa78ed$var$m(function() {
        $a82c423d96fa78ed$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $a82c423d96fa78ed$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $a82c423d96fa78ed$var$p(d);
    return d;
}
function $a82c423d96fa78ed$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$a82c423d96fa78ed$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $a82c423d96fa78ed$var$t(a, b) {
    return b();
}
var $a82c423d96fa78ed$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $a82c423d96fa78ed$var$t : $a82c423d96fa78ed$var$q;
$a82c423d96fa78ed$export$306c0aa65ff9ec16 = void 0 !== $7PdBe.useSyncExternalStore ? $7PdBe.useSyncExternalStore : $a82c423d96fa78ed$var$u;

});

parcelRegister("bVBnA", function(module, exports) {

$parcel$export(module.exports, "Promise", function () { return Promise; });
/*!
 * @overview RSVP - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2016 Yehuda Katz, Tom Dale, Stefan Penner and contributors
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/tildeio/rsvp.js/master/LICENSE
 * @version   3.6.2
 */ 
var $gz4U1 = parcelRequire("gz4U1");
function indexOf(callbacks, callback) {
    for(var i = 0, l = callbacks.length; i < l; i++){
        if (callbacks[i] === callback) return i;
    }
    return -1;
}
function callbacksFor(object) {
    var callbacks = object._promiseCallbacks;
    if (!callbacks) callbacks = object._promiseCallbacks = {};
    return callbacks;
}
/**
  @class RSVP.EventTarget
*/ var EventTarget = {
    /**
    `RSVP.EventTarget.mixin` extends an object with EventTarget methods. For
    Example:
     ```javascript
    let object = {};
     RSVP.EventTarget.mixin(object);
     object.on('finished', function(event) {
      // handle event
    });
     object.trigger('finished', { detail: value });
    ```
     `EventTarget.mixin` also works with prototypes:
     ```javascript
    let Person = function() {};
    RSVP.EventTarget.mixin(Person.prototype);
     let yehuda = new Person();
    let tom = new Person();
     yehuda.on('poke', function(event) {
      console.log('Yehuda says OW');
    });
     tom.on('poke', function(event) {
      console.log('Tom says OW');
    });
     yehuda.trigger('poke');
    tom.trigger('poke');
    ```
     @method mixin
    @for RSVP.EventTarget
    @private
    @param {Object} object object to extend with EventTarget methods
  */ mixin: function(object) {
        object["on"] = this["on"];
        object["off"] = this["off"];
        object["trigger"] = this["trigger"];
        object._promiseCallbacks = undefined;
        return object;
    },
    /**
    Registers a callback to be executed when `eventName` is triggered
     ```javascript
    object.on('event', function(eventInfo){
      // handle the event
    });
     object.trigger('event');
    ```
     @method on
    @for RSVP.EventTarget
    @private
    @param {String} eventName name of the event to listen for
    @param {Function} callback function to be called when the event is triggered.
  */ on: function(eventName, callback) {
        if (typeof callback !== "function") throw new TypeError("Callback must be a function");
        var allCallbacks = callbacksFor(this), callbacks = void 0;
        callbacks = allCallbacks[eventName];
        if (!callbacks) callbacks = allCallbacks[eventName] = [];
        if (indexOf(callbacks, callback) === -1) callbacks.push(callback);
    },
    /**
    You can use `off` to stop firing a particular callback for an event:
     ```javascript
    function doStuff() { // do stuff! }
    object.on('stuff', doStuff);
     object.trigger('stuff'); // doStuff will be called
     // Unregister ONLY the doStuff callback
    object.off('stuff', doStuff);
    object.trigger('stuff'); // doStuff will NOT be called
    ```
     If you don't pass a `callback` argument to `off`, ALL callbacks for the
    event will not be executed when the event fires. For example:
     ```javascript
    let callback1 = function(){};
    let callback2 = function(){};
     object.on('stuff', callback1);
    object.on('stuff', callback2);
     object.trigger('stuff'); // callback1 and callback2 will be executed.
     object.off('stuff');
    object.trigger('stuff'); // callback1 and callback2 will not be executed!
    ```
     @method off
    @for RSVP.EventTarget
    @private
    @param {String} eventName event to stop listening to
    @param {Function} callback optional argument. If given, only the function
    given will be removed from the event's callback queue. If no `callback`
    argument is given, all callbacks will be removed from the event's callback
    queue.
  */ off: function(eventName, callback) {
        var allCallbacks = callbacksFor(this), callbacks = void 0, index = void 0;
        if (!callback) {
            allCallbacks[eventName] = [];
            return;
        }
        callbacks = allCallbacks[eventName];
        index = indexOf(callbacks, callback);
        if (index !== -1) callbacks.splice(index, 1);
    },
    /**
    Use `trigger` to fire custom events. For example:
     ```javascript
    object.on('foo', function(){
      console.log('foo event happened!');
    });
    object.trigger('foo');
    // 'foo event happened!' logged to the console
    ```
     You can also pass a value as a second argument to `trigger` that will be
    passed as an argument to all event listeners for the event:
     ```javascript
    object.on('foo', function(value){
      console.log(value.name);
    });
     object.trigger('foo', { name: 'bar' });
    // 'bar' logged to the console
    ```
     @method trigger
    @for RSVP.EventTarget
    @private
    @param {String} eventName name of the event to be triggered
    @param {*} options optional value to be passed to any event handlers for
    the given `eventName`
  */ trigger: function(eventName, options, label) {
        var allCallbacks = callbacksFor(this), callbacks = void 0, callback = void 0;
        if (callbacks = allCallbacks[eventName]) // Don't cache the callbacks.length since it may grow
        for(var i = 0; i < callbacks.length; i++){
            callback = callbacks[i];
            callback(options, label);
        }
    }
};
var config = {
    instrument: false
};
EventTarget["mixin"](config);
function configure(name, value) {
    if (arguments.length === 2) config[name] = value;
    else return config[name];
}
function objectOrFunction(x) {
    var type = typeof x;
    return x !== null && (type === "object" || type === "function");
}
function isFunction(x) {
    return typeof x === "function";
}
function isObject(x) {
    return x !== null && typeof x === "object";
}
function isMaybeThenable(x) {
    return x !== null && typeof x === "object";
}
var _isArray = void 0;
if (Array.isArray) _isArray = Array.isArray;
else _isArray = function(x) {
    return Object.prototype.toString.call(x) === "[object Array]";
};
var isArray = _isArray;
// Date.now is not available in browsers < IE9
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/now#Compatibility
var now = Date.now || function() {
    return new Date().getTime();
};
var queue = [];
function scheduleFlush() {
    setTimeout(function() {
        for(var i = 0; i < queue.length; i++){
            var entry = queue[i];
            var payload = entry.payload;
            payload.guid = payload.key + payload.id;
            payload.childGuid = payload.key + payload.childId;
            if (payload.error) payload.stack = payload.error.stack;
            config["trigger"](entry.name, entry.payload);
        }
        queue.length = 0;
    }, 50);
}
function instrument(eventName, promise, child) {
    if (1 === queue.push({
        name: eventName,
        payload: {
            key: promise._guidKey,
            id: promise._id,
            eventName: eventName,
            detail: promise._result,
            childId: child && child._id,
            label: promise._label,
            timeStamp: now(),
            error: config["instrument-with-stack"] ? new Error(promise._label) : null
        }
    })) scheduleFlush();
}
/**
  `RSVP.Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new RSVP.Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = RSVP.Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {*} object value that the returned promise will be resolved with
  @param {String} label optional string for identifying the returned promise.
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object, label) {
    /*jshint validthis:true */ var Constructor = this;
    if (object && typeof object === "object" && object.constructor === Constructor) return object;
    var promise = new Constructor(noop, label);
    resolve(promise, object);
    return promise;
}
function withOwnPromise() {
    return new TypeError("A promises callback cannot return that same promise.");
}
function noop() {}
var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;
var GET_THEN_ERROR = new ErrorObject();
function getThen(promise) {
    try {
        return promise.then;
    } catch (error) {
        GET_THEN_ERROR.error = error;
        return GET_THEN_ERROR;
    }
}
function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
        then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
        return e;
    }
}
function handleForeignThenable(promise, thenable, then$$1) {
    config.async(function(promise) {
        var sealed = false;
        var error = tryThen(then$$1, thenable, function(value) {
            if (sealed) return;
            sealed = true;
            if (thenable !== value) resolve(promise, value, undefined);
            else fulfill(promise, value);
        }, function(reason) {
            if (sealed) return;
            sealed = true;
            reject(promise, reason);
        }, "Settle: " + (promise._label || " unknown promise"));
        if (!sealed && error) {
            sealed = true;
            reject(promise, error);
        }
    }, promise);
}
function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
    else if (thenable._state === REJECTED) {
        thenable._onError = null;
        reject(promise, thenable._result);
    } else subscribe(thenable, undefined, function(value) {
        if (thenable !== value) resolve(promise, value, undefined);
        else fulfill(promise, value);
    }, function(reason) {
        return reject(promise, reason);
    });
}
function handleMaybeThenable(promise, maybeThenable, then$$1) {
    var isOwnThenable = maybeThenable.constructor === promise.constructor && then$$1 === then && promise.constructor.resolve === resolve$1;
    if (isOwnThenable) handleOwnThenable(promise, maybeThenable);
    else if (then$$1 === GET_THEN_ERROR) {
        reject(promise, GET_THEN_ERROR.error);
        GET_THEN_ERROR.error = null;
    } else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
    else fulfill(promise, maybeThenable);
}
function resolve(promise, value) {
    if (promise === value) fulfill(promise, value);
    else if (objectOrFunction(value)) handleMaybeThenable(promise, value, getThen(value));
    else fulfill(promise, value);
}
function publishRejection(promise) {
    if (promise._onError) promise._onError(promise._result);
    publish(promise);
}
function fulfill(promise, value) {
    if (promise._state !== PENDING) return;
    promise._result = value;
    promise._state = FULFILLED;
    if (promise._subscribers.length === 0) {
        if (config.instrument) instrument("fulfilled", promise);
    } else config.async(publish, promise);
}
function reject(promise, reason) {
    if (promise._state !== PENDING) return;
    promise._state = REJECTED;
    promise._result = reason;
    config.async(publishRejection, promise);
}
function subscribe(parent, child, onFulfillment, onRejection) {
    var subscribers = parent._subscribers;
    var length = subscribers.length;
    parent._onError = null;
    subscribers[length] = child;
    subscribers[length + FULFILLED] = onFulfillment;
    subscribers[length + REJECTED] = onRejection;
    if (length === 0 && parent._state) config.async(publish, parent);
}
function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;
    if (config.instrument) instrument(settled === FULFILLED ? "fulfilled" : "rejected", promise);
    if (subscribers.length === 0) return;
    var child = void 0, callback = void 0, result = promise._result;
    for(var i = 0; i < subscribers.length; i += 3){
        child = subscribers[i];
        callback = subscribers[i + settled];
        if (child) invokeCallback(settled, child, callback, result);
        else callback(result);
    }
    promise._subscribers.length = 0;
}
function ErrorObject() {
    this.error = null;
}
var TRY_CATCH_ERROR = new ErrorObject();
function tryCatch(callback, result) {
    try {
        return callback(result);
    } catch (e) {
        TRY_CATCH_ERROR.error = e;
        return TRY_CATCH_ERROR;
    }
}
function invokeCallback(state, promise, callback, result) {
    var hasCallback = isFunction(callback);
    var value = void 0, error = void 0;
    if (hasCallback) {
        value = tryCatch(callback, result);
        if (value === TRY_CATCH_ERROR) {
            error = value.error;
            value.error = null; // release
        } else if (value === promise) {
            reject(promise, withOwnPromise());
            return;
        }
    } else value = result;
    if (promise._state !== PENDING) ;
    else if (hasCallback && error === undefined) resolve(promise, value);
    else if (error !== undefined) reject(promise, error);
    else if (state === FULFILLED) fulfill(promise, value);
    else if (state === REJECTED) reject(promise, value);
}
function initializePromise(promise, resolver) {
    var resolved = false;
    try {
        resolver(function(value) {
            if (resolved) return;
            resolved = true;
            resolve(promise, value);
        }, function(reason) {
            if (resolved) return;
            resolved = true;
            reject(promise, reason);
        });
    } catch (e) {
        reject(promise, e);
    }
}
function then(onFulfillment, onRejection, label) {
    var parent = this;
    var state = parent._state;
    if (state === FULFILLED && !onFulfillment || state === REJECTED && !onRejection) {
        config.instrument && instrument("chained", parent, parent);
        return parent;
    }
    parent._onError = null;
    var child = new parent.constructor(noop, label);
    var result = parent._result;
    config.instrument && instrument("chained", parent, child);
    if (state === PENDING) subscribe(parent, child, onFulfillment, onRejection);
    else {
        var callback = state === FULFILLED ? onFulfillment : onRejection;
        config.async(function() {
            return invokeCallback(state, child, callback, result);
        });
    }
    return child;
}
var Enumerator = function() {
    function Enumerator(Constructor, input, abortOnReject, label) {
        this._instanceConstructor = Constructor;
        this.promise = new Constructor(noop, label);
        this._abortOnReject = abortOnReject;
        this._init.apply(this, arguments);
    }
    Enumerator.prototype._init = function _init(Constructor, input) {
        var len = input.length || 0;
        this.length = len;
        this._remaining = len;
        this._result = new Array(len);
        this._enumerate(input);
        if (this._remaining === 0) fulfill(this.promise, this._result);
    };
    Enumerator.prototype._enumerate = function _enumerate(input) {
        var length = this.length;
        var promise = this.promise;
        for(var i = 0; promise._state === PENDING && i < length; i++)this._eachEntry(input[i], i);
    };
    Enumerator.prototype._settleMaybeThenable = function _settleMaybeThenable(entry, i) {
        var c = this._instanceConstructor;
        var resolve$$1 = c.resolve;
        if (resolve$$1 === resolve$1) {
            var then$$1 = getThen(entry);
            if (then$$1 === then && entry._state !== PENDING) {
                entry._onError = null;
                this._settledAt(entry._state, i, entry._result);
            } else if (typeof then$$1 !== "function") {
                this._remaining--;
                this._result[i] = this._makeResult(FULFILLED, i, entry);
            } else if (c === Promise) {
                var promise = new c(noop);
                handleMaybeThenable(promise, entry, then$$1);
                this._willSettleAt(promise, i);
            } else this._willSettleAt(new c(function(resolve$$1) {
                return resolve$$1(entry);
            }), i);
        } else this._willSettleAt(resolve$$1(entry), i);
    };
    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
        if (isMaybeThenable(entry)) this._settleMaybeThenable(entry, i);
        else {
            this._remaining--;
            this._result[i] = this._makeResult(FULFILLED, i, entry);
        }
    };
    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
        var promise = this.promise;
        if (promise._state === PENDING) {
            if (this._abortOnReject && state === REJECTED) reject(promise, value);
            else {
                this._remaining--;
                this._result[i] = this._makeResult(state, i, value);
                if (this._remaining === 0) fulfill(promise, this._result);
            }
        }
    };
    Enumerator.prototype._makeResult = function _makeResult(state, i, value) {
        return value;
    };
    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
        var enumerator = this;
        subscribe(promise, undefined, function(value) {
            return enumerator._settledAt(FULFILLED, i, value);
        }, function(reason) {
            return enumerator._settledAt(REJECTED, i, reason);
        });
    };
    return Enumerator;
}();
function makeSettledResult(state, position, value) {
    if (state === FULFILLED) return {
        state: "fulfilled",
        value: value
    };
    else return {
        state: "rejected",
        reason: value
    };
}
/**
  `RSVP.Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.resolve(2);
  let promise3 = RSVP.resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  RSVP.Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `RSVP.all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.reject(new Error("2"));
  let promise3 = RSVP.reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  RSVP.Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries, label) {
    if (!isArray(entries)) return this.reject(new TypeError("Promise.all must be called with an array"), label);
    return new Enumerator(this, entries, true, label).promise;
}
/**
  `RSVP.Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new RSVP.Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new RSVP.Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  RSVP.Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `RSVP.Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new RSVP.Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new RSVP.Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  RSVP.Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  RSVP.Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} entries array of promises to observe
  @param {String} label optional string for describing the promise returned.
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries, label) {
    /*jshint validthis:true */ var Constructor = this;
    var promise = new Constructor(noop, label);
    if (!isArray(entries)) {
        reject(promise, new TypeError("Promise.race must be called with an array"));
        return promise;
    }
    for(var i = 0; promise._state === PENDING && i < entries.length; i++)subscribe(Constructor.resolve(entries[i]), undefined, function(value) {
        return resolve(promise, value);
    }, function(reason) {
        return reject(promise, reason);
    });
    return promise;
}
/**
  `RSVP.Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new RSVP.Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = RSVP.Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {*} reason value that the returned promise will be rejected with.
  @param {String} label optional string for identifying the returned promise.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason, label) {
    /*jshint validthis:true */ var Constructor = this;
    var promise = new Constructor(noop, label);
    reject(promise, reason);
    return promise;
}
var guidKey = "rsvp_" + now() + "-";
var counter = 0;
function needsResolver() {
    throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
}
function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}
/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise’s eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class RSVP.Promise
  @param {function} resolver
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @constructor
*/ var Promise = function() {
    function Promise(resolver, label) {
        this._id = counter++;
        this._label = label;
        this._state = undefined;
        this._result = undefined;
        this._subscribers = [];
        config.instrument && instrument("created", this);
        if (noop !== resolver) {
            typeof resolver !== "function" && needsResolver();
            this instanceof Promise ? initializePromise(this, resolver) : needsNew();
        }
    }
    Promise.prototype._onError = function _onError(reason) {
        var _this = this;
        config.after(function() {
            if (_this._onError) config.trigger("error", reason, _this._label);
        });
    };
    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn\'t find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection, label) {
        return this.then(undefined, onRejection, label);
    };
    /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuthor();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuthor();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback, label) {
        var promise = this;
        var constructor = promise.constructor;
        return promise.then(function(value) {
            return constructor.resolve(callback()).then(function() {
                return value;
            });
        }, function(reason) {
            return constructor.resolve(callback()).then(function() {
                throw reason;
            });
        }, label);
    };
    return Promise;
}();
Promise.cast = resolve$1; // deprecated
Promise.all = all;
Promise.race = race;
Promise.resolve = resolve$1;
Promise.reject = reject$1;
Promise.prototype._guidKey = guidKey;
/**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.

  ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```

  Chaining
  --------

  The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.

  ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });

  findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we\'re unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we\'re unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.

  ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```

  Assimilation
  ------------

  Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.

  ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```

  If the assimliated promise rejects, then the downstream promise will also reject.

  ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```

  Simple Example
  --------------

  Synchronous Example

  ```javascript
  let result;

  try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```

  Errback Example

  ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```

  Promise Example;

  ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```

  Advanced Example
  --------------

  Synchronous Example

  ```javascript
  let author, books;

  try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```

  Errback Example

  ```js

  function foundBooks(books) {

  }

  function failure(reason) {

  }

  findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```

  Promise Example;

  ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```

  @method then
  @param {Function} onFulfillment
  @param {Function} onRejection
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise}
*/ Promise.prototype.then = then;
function Result() {
    this.value = undefined;
}
var ERROR = new Result();
var GET_THEN_ERROR$1 = new Result();
function getThen$1(obj) {
    try {
        return obj.then;
    } catch (error) {
        ERROR.value = error;
        return ERROR;
    }
}
function tryApply(f, s, a) {
    try {
        f.apply(s, a);
    } catch (error) {
        ERROR.value = error;
        return ERROR;
    }
}
function makeObject(_, argumentNames) {
    var obj = {};
    var length = _.length;
    var args = new Array(length);
    for(var x = 0; x < length; x++)args[x] = _[x];
    for(var i = 0; i < argumentNames.length; i++){
        var name = argumentNames[i];
        obj[name] = args[i + 1];
    }
    return obj;
}
function arrayResult(_) {
    var length = _.length;
    var args = new Array(length - 1);
    for(var i = 1; i < length; i++)args[i - 1] = _[i];
    return args;
}
function wrapThenable(then, promise) {
    return {
        then: function(onFulFillment, onRejection) {
            return then.call(promise, onFulFillment, onRejection);
        }
    };
}
/**
  `RSVP.denodeify` takes a 'node-style' function and returns a function that
  will return an `RSVP.Promise`. You can use `denodeify` in Node.js or the
  browser when you'd prefer to use promises over using callbacks. For example,
  `denodeify` transforms the following:

  ```javascript
  let fs = require('fs');

  fs.readFile('myfile.txt', function(err, data){
    if (err) return handleError(err);
    handleData(data);
  });
  ```

  into:

  ```javascript
  let fs = require('fs');
  let readFile = RSVP.denodeify(fs.readFile);

  readFile('myfile.txt').then(handleData, handleError);
  ```

  If the node function has multiple success parameters, then `denodeify`
  just returns the first one:

  ```javascript
  let request = RSVP.denodeify(require('request'));

  request('http://example.com').then(function(res) {
    // ...
  });
  ```

  However, if you need all success parameters, setting `denodeify`'s
  second parameter to `true` causes it to return all success parameters
  as an array:

  ```javascript
  let request = RSVP.denodeify(require('request'), true);

  request('http://example.com').then(function(result) {
    // result[0] -> res
    // result[1] -> body
  });
  ```

  Or if you pass it an array with names it returns the parameters as a hash:

  ```javascript
  let request = RSVP.denodeify(require('request'), ['res', 'body']);

  request('http://example.com').then(function(result) {
    // result.res
    // result.body
  });
  ```

  Sometimes you need to retain the `this`:

  ```javascript
  let app = require('express')();
  let render = RSVP.denodeify(app.render.bind(app));
  ```

  The denodified function inherits from the original function. It works in all
  environments, except IE 10 and below. Consequently all properties of the original
  function are available to you. However, any properties you change on the
  denodeified function won't be changed on the original function. Example:

  ```javascript
  let request = RSVP.denodeify(require('request')),
      cookieJar = request.jar(); // <- Inheritance is used here

  request('http://example.com', {jar: cookieJar}).then(function(res) {
    // cookieJar.cookies holds now the cookies returned by example.com
  });
  ```

  Using `denodeify` makes it easier to compose asynchronous operations instead
  of using callbacks. For example, instead of:

  ```javascript
  let fs = require('fs');

  fs.readFile('myfile.txt', function(err, data){
    if (err) { ... } // Handle error
    fs.writeFile('myfile2.txt', data, function(err){
      if (err) { ... } // Handle error
      console.log('done')
    });
  });
  ```

  you can chain the operations together using `then` from the returned promise:

  ```javascript
  let fs = require('fs');
  let readFile = RSVP.denodeify(fs.readFile);
  let writeFile = RSVP.denodeify(fs.writeFile);

  readFile('myfile.txt').then(function(data){
    return writeFile('myfile2.txt', data);
  }).then(function(){
    console.log('done')
  }).catch(function(error){
    // Handle error
  });
  ```

  @method denodeify
  @static
  @for RSVP
  @param {Function} nodeFunc a 'node-style' function that takes a callback as
  its last argument. The callback expects an error to be passed as its first
  argument (if an error occurred, otherwise null), and the value from the
  operation as its second argument ('function(err, value){ }').
  @param {Boolean|Array} [options] An optional paramter that if set
  to `true` causes the promise to fulfill with the callback's success arguments
  as an array. This is useful if the node function has multiple success
  paramters. If you set this paramter to an array with names, the promise will
  fulfill with a hash with these names as keys and the success parameters as
  values.
  @return {Function} a function that wraps `nodeFunc` to return an
  `RSVP.Promise`
  @static
*/ function denodeify(nodeFunc, options) {
    var fn = function() {
        var self1 = this;
        var l = arguments.length;
        var args = new Array(l + 1);
        var promiseInput = false;
        for(var i = 0; i < l; ++i){
            var arg = arguments[i];
            if (!promiseInput) {
                // TODO: clean this up
                promiseInput = needsPromiseInput(arg);
                if (promiseInput === GET_THEN_ERROR$1) {
                    var p = new Promise(noop);
                    reject(p, GET_THEN_ERROR$1.value);
                    return p;
                } else if (promiseInput && promiseInput !== true) arg = wrapThenable(promiseInput, arg);
            }
            args[i] = arg;
        }
        var promise = new Promise(noop);
        args[l] = function(err, val) {
            if (err) reject(promise, err);
            else if (options === undefined) resolve(promise, val);
            else if (options === true) resolve(promise, arrayResult(arguments));
            else if (isArray(options)) resolve(promise, makeObject(arguments, options));
            else resolve(promise, val);
        };
        if (promiseInput) return handlePromiseInput(promise, args, nodeFunc, self1);
        else return handleValueInput(promise, args, nodeFunc, self1);
    };
    fn.__proto__ = nodeFunc;
    return fn;
}
function handleValueInput(promise, args, nodeFunc, self1) {
    var result = tryApply(nodeFunc, self1, args);
    if (result === ERROR) reject(promise, result.value);
    return promise;
}
function handlePromiseInput(promise, args, nodeFunc, self1) {
    return Promise.all(args).then(function(args) {
        var result = tryApply(nodeFunc, self1, args);
        if (result === ERROR) reject(promise, result.value);
        return promise;
    });
}
function needsPromiseInput(arg) {
    if (arg && typeof arg === "object") {
        if (arg.constructor === Promise) return true;
        else return getThen$1(arg);
    } else return false;
}
/**
  This is a convenient alias for `RSVP.Promise.all`.

  @method all
  @static
  @for RSVP
  @param {Array} array Array of promises.
  @param {String} label An optional label. This is useful
  for tooling.
*/ function all$1(array, label) {
    return Promise.all(array, label);
}
function _possibleConstructorReturn(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var AllSettled = function(_Enumerator) {
    _inherits(AllSettled, _Enumerator);
    function AllSettled(Constructor, entries, label) {
        return _possibleConstructorReturn(this, _Enumerator.call(this, Constructor, entries, false, label));
    }
    return AllSettled;
}(Enumerator);
AllSettled.prototype._makeResult = makeSettledResult;
/**
`RSVP.allSettled` is similar to `RSVP.all`, but instead of implementing
a fail-fast method, it waits until all the promises have returned and
shows you all the results. This is useful if you want to handle multiple
promises' failure states together as a set.
 Returns a promise that is fulfilled when all the given promises have been
settled. The return promise is fulfilled with an array of the states of
the promises passed into the `promises` array argument.
 Each state object will either indicate fulfillment or rejection, and
provide the corresponding value or reason. The states will take one of
the following formats:
 ```javascript
{ state: 'fulfilled', value: value }
  or
{ state: 'rejected', reason: reason }
```
 Example:
 ```javascript
let promise1 = RSVP.Promise.resolve(1);
let promise2 = RSVP.Promise.reject(new Error('2'));
let promise3 = RSVP.Promise.reject(new Error('3'));
let promises = [ promise1, promise2, promise3 ];
 RSVP.allSettled(promises).then(function(array){
  // array == [
  //   { state: 'fulfilled', value: 1 },
  //   { state: 'rejected', reason: Error },
  //   { state: 'rejected', reason: Error }
  // ]
  // Note that for the second item, reason.message will be '2', and for the
  // third item, reason.message will be '3'.
}, function(error) {
  // Not run. (This block would only be called if allSettled had failed,
  // for instance if passed an incorrect argument type.)
});
```
 @method allSettled
@static
@for RSVP
@param {Array} entries
@param {String} label - optional string that describes the promise.
Useful for tooling.
@return {Promise} promise that is fulfilled with an array of the settled
states of the constituent promises.
*/ function allSettled(entries, label) {
    if (!isArray(entries)) return Promise.reject(new TypeError("Promise.allSettled must be called with an array"), label);
    return new AllSettled(Promise, entries, label).promise;
}
/**
  This is a convenient alias for `RSVP.Promise.race`.

  @method race
  @static
  @for RSVP
  @param {Array} array Array of promises.
  @param {String} label An optional label. This is useful
  for tooling.
 */ function race$1(array, label) {
    return Promise.race(array, label);
}
function _possibleConstructorReturn$1(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
var PromiseHash = function(_Enumerator) {
    _inherits$1(PromiseHash, _Enumerator);
    function PromiseHash(Constructor, object) {
        var abortOnReject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var label = arguments[3];
        return _possibleConstructorReturn$1(this, _Enumerator.call(this, Constructor, object, abortOnReject, label));
    }
    PromiseHash.prototype._init = function _init(Constructor, object) {
        this._result = {};
        this._enumerate(object);
        if (this._remaining === 0) fulfill(this.promise, this._result);
    };
    PromiseHash.prototype._enumerate = function _enumerate(input) {
        var promise = this.promise;
        var results = [];
        for(var key in input)if (hasOwnProperty.call(input, key)) results.push({
            position: key,
            entry: input[key]
        });
        var length = results.length;
        this._remaining = length;
        var result = void 0;
        for(var i = 0; promise._state === PENDING && i < length; i++){
            result = results[i];
            this._eachEntry(result.entry, result.position);
        }
    };
    return PromiseHash;
}(Enumerator);
/**
  `RSVP.hash` is similar to `RSVP.all`, but takes an object instead of an array
  for its `promises` argument.

  Returns a promise that is fulfilled when all the given promises have been
  fulfilled, or rejected if any of them become rejected. The returned promise
  is fulfilled with a hash that has the same key names as the `promises` object
  argument. If any of the values in the object are not promises, they will
  simply be copied over to the fulfilled object.

  Example:

  ```javascript
  let promises = {
    myPromise: RSVP.resolve(1),
    yourPromise: RSVP.resolve(2),
    theirPromise: RSVP.resolve(3),
    notAPromise: 4
  };

  RSVP.hash(promises).then(function(hash){
    // hash here is an object that looks like:
    // {
    //   myPromise: 1,
    //   yourPromise: 2,
    //   theirPromise: 3,
    //   notAPromise: 4
    // }
  });
  ````

  If any of the `promises` given to `RSVP.hash` are rejected, the first promise
  that is rejected will be given as the reason to the rejection handler.

  Example:

  ```javascript
  let promises = {
    myPromise: RSVP.resolve(1),
    rejectedPromise: RSVP.reject(new Error('rejectedPromise')),
    anotherRejectedPromise: RSVP.reject(new Error('anotherRejectedPromise')),
  };

  RSVP.hash(promises).then(function(hash){
    // Code here never runs because there are rejected promises!
  }, function(reason) {
    // reason.message === 'rejectedPromise'
  });
  ```

  An important note: `RSVP.hash` is intended for plain JavaScript objects that
  are just a set of keys and values. `RSVP.hash` will NOT preserve prototype
  chains.

  Example:

  ```javascript
  function MyConstructor(){
    this.example = RSVP.resolve('Example');
  }

  MyConstructor.prototype = {
    protoProperty: RSVP.resolve('Proto Property')
  };

  let myObject = new MyConstructor();

  RSVP.hash(myObject).then(function(hash){
    // protoProperty will not be present, instead you will just have an
    // object that looks like:
    // {
    //   example: 'Example'
    // }
    //
    // hash.hasOwnProperty('protoProperty'); // false
    // 'undefined' === typeof hash.protoProperty
  });
  ```

  @method hash
  @static
  @for RSVP
  @param {Object} object
  @param {String} label optional string that describes the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all properties of `promises`
  have been fulfilled, or rejected if any of them become rejected.
*/ function hash(object, label) {
    if (!isObject(object)) return Promise.reject(new TypeError("Promise.hash must be called with an object"), label);
    return new PromiseHash(Promise, object, label).promise;
}
function _possibleConstructorReturn$2(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var HashSettled = function(_PromiseHash) {
    _inherits$2(HashSettled, _PromiseHash);
    function HashSettled(Constructor, object, label) {
        return _possibleConstructorReturn$2(this, _PromiseHash.call(this, Constructor, object, false, label));
    }
    return HashSettled;
}(PromiseHash);
HashSettled.prototype._makeResult = makeSettledResult;
/**
  `RSVP.hashSettled` is similar to `RSVP.allSettled`, but takes an object
  instead of an array for its `promises` argument.

  Unlike `RSVP.all` or `RSVP.hash`, which implement a fail-fast method,
  but like `RSVP.allSettled`, `hashSettled` waits until all the
  constituent promises have returned and then shows you all the results
  with their states and values/reasons. This is useful if you want to
  handle multiple promises' failure states together as a set.

  Returns a promise that is fulfilled when all the given promises have been
  settled, or rejected if the passed parameters are invalid.

  The returned promise is fulfilled with a hash that has the same key names as
  the `promises` object argument. If any of the values in the object are not
  promises, they will be copied over to the fulfilled object and marked with state
  'fulfilled'.

  Example:

  ```javascript
  let promises = {
    myPromise: RSVP.Promise.resolve(1),
    yourPromise: RSVP.Promise.resolve(2),
    theirPromise: RSVP.Promise.resolve(3),
    notAPromise: 4
  };

  RSVP.hashSettled(promises).then(function(hash){
    // hash here is an object that looks like:
    // {
    //   myPromise: { state: 'fulfilled', value: 1 },
    //   yourPromise: { state: 'fulfilled', value: 2 },
    //   theirPromise: { state: 'fulfilled', value: 3 },
    //   notAPromise: { state: 'fulfilled', value: 4 }
    // }
  });
  ```

  If any of the `promises` given to `RSVP.hash` are rejected, the state will
  be set to 'rejected' and the reason for rejection provided.

  Example:

  ```javascript
  let promises = {
    myPromise: RSVP.Promise.resolve(1),
    rejectedPromise: RSVP.Promise.reject(new Error('rejection')),
    anotherRejectedPromise: RSVP.Promise.reject(new Error('more rejection')),
  };

  RSVP.hashSettled(promises).then(function(hash){
    // hash here is an object that looks like:
    // {
    //   myPromise:              { state: 'fulfilled', value: 1 },
    //   rejectedPromise:        { state: 'rejected', reason: Error },
    //   anotherRejectedPromise: { state: 'rejected', reason: Error },
    // }
    // Note that for rejectedPromise, reason.message == 'rejection',
    // and for anotherRejectedPromise, reason.message == 'more rejection'.
  });
  ```

  An important note: `RSVP.hashSettled` is intended for plain JavaScript objects that
  are just a set of keys and values. `RSVP.hashSettled` will NOT preserve prototype
  chains.

  Example:

  ```javascript
  function MyConstructor(){
    this.example = RSVP.Promise.resolve('Example');
  }

  MyConstructor.prototype = {
    protoProperty: RSVP.Promise.resolve('Proto Property')
  };

  let myObject = new MyConstructor();

  RSVP.hashSettled(myObject).then(function(hash){
    // protoProperty will not be present, instead you will just have an
    // object that looks like:
    // {
    //   example: { state: 'fulfilled', value: 'Example' }
    // }
    //
    // hash.hasOwnProperty('protoProperty'); // false
    // 'undefined' === typeof hash.protoProperty
  });
  ```

  @method hashSettled
  @for RSVP
  @param {Object} object
  @param {String} label optional string that describes the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when when all properties of `promises`
  have been settled.
  @static
*/ function hashSettled(object, label) {
    if (!isObject(object)) return Promise.reject(new TypeError("RSVP.hashSettled must be called with an object"), label);
    return new HashSettled(Promise, object, false, label).promise;
}
/**
  `RSVP.rethrow` will rethrow an error on the next turn of the JavaScript event
  loop in order to aid debugging.

  Promises A+ specifies that any exceptions that occur with a promise must be
  caught by the promises implementation and bubbled to the last handler. For
  this reason, it is recommended that you always specify a second rejection
  handler function to `then`. However, `RSVP.rethrow` will throw the exception
  outside of the promise, so it bubbles up to your console if in the browser,
  or domain/cause uncaught exception in Node. `rethrow` will also throw the
  error again so the error can be handled by the promise per the spec.

  ```javascript
  function throws(){
    throw new Error('Whoops!');
  }

  let promise = new RSVP.Promise(function(resolve, reject){
    throws();
  });

  promise.catch(RSVP.rethrow).then(function(){
    // Code here doesn't run because the promise became rejected due to an
    // error!
  }, function (err){
    // handle the error here
  });
  ```

  The 'Whoops' error will be thrown on the next turn of the event loop
  and you can watch for it in your console. You can also handle it using a
  rejection handler given to `.then` or `.catch` on the returned promise.

  @method rethrow
  @static
  @for RSVP
  @param {Error} reason reason the promise became rejected.
  @throws Error
  @static
*/ function rethrow(reason) {
    setTimeout(function() {
        throw reason;
    });
    throw reason;
}
/**
  `RSVP.defer` returns an object similar to jQuery's `$.Deferred`.
  `RSVP.defer` should be used when porting over code reliant on `$.Deferred`'s
  interface. New code should use the `RSVP.Promise` constructor instead.

  The object returned from `RSVP.defer` is a plain object with three properties:

  * promise - an `RSVP.Promise`.
  * reject - a function that causes the `promise` property on this object to
    become rejected
  * resolve - a function that causes the `promise` property on this object to
    become fulfilled.

  Example:

   ```javascript
   let deferred = RSVP.defer();

   deferred.resolve("Success!");

   deferred.promise.then(function(value){
     // value here is "Success!"
   });
   ```

  @method defer
  @static
  @for RSVP
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Object}
 */ function defer(label) {
    var deferred = {
        resolve: undefined,
        reject: undefined
    };
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    }, label);
    return deferred;
}
/**
 `RSVP.map` is similar to JavaScript's native `map` method, except that it
  waits for all promises to become fulfilled before running the `mapFn` on
  each item in given to `promises`. `RSVP.map` returns a promise that will
  become fulfilled with the result of running `mapFn` on the values the promises
  become fulfilled with.

  For example:

  ```javascript

  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.resolve(2);
  let promise3 = RSVP.resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  let mapFn = function(item){
    return item + 1;
  };

  RSVP.map(promises, mapFn).then(function(result){
    // result is [ 2, 3, 4 ]
  });
  ```

  If any of the `promises` given to `RSVP.map` are rejected, the first promise
  that is rejected will be given as an argument to the returned promise's
  rejection handler. For example:

  ```javascript
  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.reject(new Error('2'));
  let promise3 = RSVP.reject(new Error('3'));
  let promises = [ promise1, promise2, promise3 ];

  let mapFn = function(item){
    return item + 1;
  };

  RSVP.map(promises, mapFn).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(reason) {
    // reason.message === '2'
  });
  ```

  `RSVP.map` will also wait if a promise is returned from `mapFn`. For example,
  say you want to get all comments from a set of blog posts, but you need
  the blog posts first because they contain a url to those comments.

  ```javscript

  let mapFn = function(blogPost){
    // getComments does some ajax and returns an RSVP.Promise that is fulfilled
    // with some comments data
    return getComments(blogPost.comments_url);
  };

  // getBlogPosts does some ajax and returns an RSVP.Promise that is fulfilled
  // with some blog post data
  RSVP.map(getBlogPosts(), mapFn).then(function(comments){
    // comments is the result of asking the server for the comments
    // of all blog posts returned from getBlogPosts()
  });
  ```

  @method map
  @static
  @for RSVP
  @param {Array} promises
  @param {Function} mapFn function to be called on each fulfilled promise.
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled with the result of calling
  `mapFn` on each fulfilled promise or value when they become fulfilled.
   The promise will be rejected if any of the given `promises` become rejected.
  @static
*/ function map(promises, mapFn, label) {
    if (!isArray(promises)) return Promise.reject(new TypeError("RSVP.map must be called with an array"), label);
    if (!isFunction(mapFn)) return Promise.reject(new TypeError("RSVP.map expects a function as a second argument"), label);
    return Promise.all(promises, label).then(function(values) {
        var length = values.length;
        var results = new Array(length);
        for(var i = 0; i < length; i++)results[i] = mapFn(values[i]);
        return Promise.all(results, label);
    });
}
/**
  This is a convenient alias for `RSVP.Promise.resolve`.

  @method resolve
  @static
  @for RSVP
  @param {*} value value that the returned promise will be resolved with
  @param {String} label optional string for identifying the returned promise.
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$2(value, label) {
    return Promise.resolve(value, label);
}
/**
  This is a convenient alias for `RSVP.Promise.reject`.

  @method reject
  @static
  @for RSVP
  @param {*} reason value that the returned promise will be rejected with.
  @param {String} label optional string for identifying the returned promise.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$2(reason, label) {
    return Promise.reject(reason, label);
}
/**
 `RSVP.filter` is similar to JavaScript's native `filter` method, except that it
  waits for all promises to become fulfilled before running the `filterFn` on
  each item in given to `promises`. `RSVP.filter` returns a promise that will
  become fulfilled with the result of running `filterFn` on the values the
  promises become fulfilled with.

  For example:

  ```javascript

  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.resolve(2);
  let promise3 = RSVP.resolve(3);

  let promises = [promise1, promise2, promise3];

  let filterFn = function(item){
    return item > 1;
  };

  RSVP.filter(promises, filterFn).then(function(result){
    // result is [ 2, 3 ]
  });
  ```

  If any of the `promises` given to `RSVP.filter` are rejected, the first promise
  that is rejected will be given as an argument to the returned promise's
  rejection handler. For example:

  ```javascript
  let promise1 = RSVP.resolve(1);
  let promise2 = RSVP.reject(new Error('2'));
  let promise3 = RSVP.reject(new Error('3'));
  let promises = [ promise1, promise2, promise3 ];

  let filterFn = function(item){
    return item > 1;
  };

  RSVP.filter(promises, filterFn).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(reason) {
    // reason.message === '2'
  });
  ```

  `RSVP.filter` will also wait for any promises returned from `filterFn`.
  For instance, you may want to fetch a list of users then return a subset
  of those users based on some asynchronous operation:

  ```javascript

  let alice = { name: 'alice' };
  let bob   = { name: 'bob' };
  let users = [ alice, bob ];

  let promises = users.map(function(user){
    return RSVP.resolve(user);
  });

  let filterFn = function(user){
    // Here, Alice has permissions to create a blog post, but Bob does not.
    return getPrivilegesForUser(user).then(function(privs){
      return privs.can_create_blog_post === true;
    });
  };
  RSVP.filter(promises, filterFn).then(function(users){
    // true, because the server told us only Alice can create a blog post.
    users.length === 1;
    // false, because Alice is the only user present in `users`
    users[0] === bob;
  });
  ```

  @method filter
  @static
  @for RSVP
  @param {Array} promises
  @param {Function} filterFn - function to be called on each resolved value to
  filter the final results.
  @param {String} label optional string describing the promise. Useful for
  tooling.
  @return {Promise}
*/ function resolveAll(promises, label) {
    return Promise.all(promises, label);
}
function resolveSingle(promise, label) {
    return Promise.resolve(promise, label).then(function(promises) {
        return resolveAll(promises, label);
    });
}
function filter(promises, filterFn, label) {
    if (!isArray(promises) && !(isObject(promises) && promises.then !== undefined)) return Promise.reject(new TypeError("RSVP.filter must be called with an array or promise"), label);
    if (!isFunction(filterFn)) return Promise.reject(new TypeError("RSVP.filter expects function as a second argument"), label);
    var promise = isArray(promises) ? resolveAll(promises, label) : resolveSingle(promises, label);
    return promise.then(function(values) {
        var length = values.length;
        var filtered = new Array(length);
        for(var i = 0; i < length; i++)filtered[i] = filterFn(values[i]);
        return resolveAll(filtered, label).then(function(filtered) {
            var results = new Array(length);
            var newLength = 0;
            for(var _i = 0; _i < length; _i++)if (filtered[_i]) {
                results[newLength] = values[_i];
                newLength++;
            }
            results.length = newLength;
            return results;
        });
    });
}
var len = 0;
var vertxNext = void 0;
function asap(callback, arg) {
    queue$1[len] = callback;
    queue$1[len + 1] = arg;
    len += 2;
    if (len === 2) // If len is 1, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    scheduleFlush$1();
}
var browserWindow = typeof window !== "undefined" ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === "undefined" && typeof $gz4U1 !== "undefined" && ({}).toString.call($gz4U1) === "[object process]";
// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
// node
function useNextTick() {
    var nextTick = $gz4U1.nextTick;
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // setImmediate should be used instead instead
    var version = $gz4U1.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
    if (Array.isArray(version) && version[1] === "0" && version[2] === "10") nextTick = setImmediate;
    return function() {
        return nextTick(flush);
    };
}
// vertx
function useVertxTimer() {
    if (typeof vertxNext !== "undefined") return function() {
        vertxNext(flush);
    };
    return useSetTimeout();
}
function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function() {
        return node.data = iterations = ++iterations % 2;
    };
}
// web worker
function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function() {
        return channel.port2.postMessage(0);
    };
}
function useSetTimeout() {
    return function() {
        return setTimeout(flush, 1);
    };
}
var queue$1 = new Array(1000);
function flush() {
    for(var i = 0; i < len; i += 2){
        var callback = queue$1[i];
        var arg = queue$1[i + 1];
        callback(arg);
        queue$1[i] = undefined;
        queue$1[i + 1] = undefined;
    }
    len = 0;
}
function attemptVertex() {
    try {
        var r = undefined;
        var vertx = r("vertx");
        vertxNext = vertx.runOnLoop || vertx.runOnContext;
        return useVertxTimer();
    } catch (e) {
        return useSetTimeout();
    }
}
var scheduleFlush$1 = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) scheduleFlush$1 = useNextTick();
else if (BrowserMutationObserver) scheduleFlush$1 = useMutationObserver();
else if (isWorker) scheduleFlush$1 = useMessageChannel();
else if (browserWindow === undefined && true) scheduleFlush$1 = attemptVertex();
else scheduleFlush$1 = useSetTimeout();
var platform = void 0;
/* global self */ if (typeof self === "object") platform = self;
else if (typeof $parcel$global === "object") platform = $parcel$global;
else throw new Error("no global: `self` or `global` found");
var _asap$cast$Promise$Ev;
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// defaults
config.async = asap;
config.after = function(cb) {
    return setTimeout(cb, 0);
};
var cast = resolve$2;
var async = function(callback, arg) {
    return config.async(callback, arg);
};
function on() {
    config["on"].apply(config, arguments);
}
function off() {
    config["off"].apply(config, arguments);
}
// Set up instrumentation through `window.__PROMISE_INTRUMENTATION__`
if (typeof window !== "undefined" && typeof window["__PROMISE_INSTRUMENTATION__"] === "object") {
    var callbacks = window["__PROMISE_INSTRUMENTATION__"];
    configure("instrument", true);
    for(var eventName in callbacks)if (callbacks.hasOwnProperty(eventName)) on(eventName, callbacks[eventName]);
}
// the default export here is for backwards compat:
//   https://github.com/tildeio/rsvp.js/issues/434
var rsvp = (_asap$cast$Promise$Ev = {
    asap: asap,
    cast: cast,
    Promise: Promise,
    EventTarget: EventTarget,
    all: all$1,
    allSettled: allSettled,
    race: race$1,
    hash: hash,
    hashSettled: hashSettled,
    rethrow: rethrow,
    defer: defer,
    denodeify: denodeify,
    configure: configure,
    on: on,
    off: off,
    resolve: resolve$2,
    reject: reject$2,
    map: map
}, _defineProperty(_asap$cast$Promise$Ev, "async", async), _defineProperty(_asap$cast$Promise$Ev, "filter", filter), _asap$cast$Promise$Ev);
var $8af20354d3384213$export$2e2bcd8739ae039 = rsvp;

});


var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");
// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $cd244d3777bb214a$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $cd244d3777bb214a$export$6503ec6e8aabbaf(config) {
    if ("serviceWorker" in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener("load", ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($cd244d3777bb214a$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $cd244d3777bb214a$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $cd244d3777bb214a$var$registerValidSW(swUrl, config);
        });
    }
}
function $cd244d3777bb214a$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log("Content is cached for offline use.");
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error("Error during service worker registration:", error);
    });
}
function $cd244d3777bb214a$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get("content-type");
        if (response.status === 404 || contentType != null && contentType.indexOf("javascript") === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $cd244d3777bb214a$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log("No internet connection found. App is running in offline mode.");
    });
}
function $cd244d3777bb214a$export$d07f55d4c15c0440() {
    if ("serviceWorker" in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}




var $d2277f625b0f1c32$export$882461b6382ed46c;
var $d2277f625b0f1c32$export$757ceba2d55c277e;
"use strict";

var $1cUCD = parcelRequire("1cUCD");
var $d2277f625b0f1c32$var$i;
$d2277f625b0f1c32$export$882461b6382ed46c = $1cUCD.createRoot;
$d2277f625b0f1c32$export$757ceba2d55c277e = $1cUCD.hydrateRoot;



var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");


var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");

var $e6FFD = parcelRequire("e6FFD");

var $5uSSv = parcelRequire("5uSSv");

var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");
var $9bd6db54a19dc2ee$export$2e2bcd8739ae039 = ({ text: text })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        className: "flex flex-align-items-center flex-justify-content-center",
        children: /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
            className: "flex-0-0-auto",
            style: {
                backgroundColor: "white",
                textAlign: "center",
                alignSelf: "center",
                padding: "4em 6.5em",
                opacity: 0.9
            },
            children: /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                        className: "fa fa-circle-o-notch fa-spin fa-3x fa-fw coincraft-gold",
                        style: {
                            marginRight: 0
                        }
                    }),
                    text ? /*#__PURE__*/ (0, $RSSjA.jsx)("h5", {
                        style: {
                            marginTop: "0.75em",
                            marginBottom: 0,
                            color: "#333"
                        },
                        children: text
                    }) : null
                ]
            })
        })
    });
};



var $RSSjA = parcelRequire("RSSjA");

var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");
function $a9d9685a8e9a96cb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $a9d9685a8e9a96cb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $a9d9685a8e9a96cb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $a9d9685a8e9a96cb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $a9d9685a8e9a96cb$export$2e2bcd8739ae039 = $a9d9685a8e9a96cb$export$4f5d2d50c9deca37;


var $86bbf129917d6fd4$exports = {};
"use strict";
Object.defineProperty($86bbf129917d6fd4$exports, Symbol.toStringTag, {
    value: "Module"
});
const $86bbf129917d6fd4$var$CLASS_PART_SEPARATOR = "-";
const $86bbf129917d6fd4$var$createClassGroupUtils = (config)=>{
    const classMap = $86bbf129917d6fd4$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        const classParts = className.split($86bbf129917d6fd4$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $86bbf129917d6fd4$var$getGroupRecursive(classParts, classMap) || $86bbf129917d6fd4$var$getGroupIdForArbitraryProperty(className);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $86bbf129917d6fd4$var$getGroupRecursive = (classParts, classPartObject)=>{
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $86bbf129917d6fd4$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($86bbf129917d6fd4$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
};
const $86bbf129917d6fd4$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
const $86bbf129917d6fd4$var$getGroupIdForArbitraryProperty = (className)=>{
    if ($86bbf129917d6fd4$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $86bbf129917d6fd4$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
};
/**
 * Exported for testing only
 */ const $86bbf129917d6fd4$var$createClassMap = (config)=>{
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $86bbf129917d6fd4$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $86bbf129917d6fd4$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
};
const $86bbf129917d6fd4$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === "string") {
            const classPartObjectToEdit = classDefinition === "" ? classPartObject : $86bbf129917d6fd4$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($86bbf129917d6fd4$var$isThemeGetter(classDefinition)) {
                $86bbf129917d6fd4$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $86bbf129917d6fd4$var$processClassesRecursively(classGroup, $86bbf129917d6fd4$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
};
const $86bbf129917d6fd4$var$getPart = (classPartObject, path)=>{
    let currentClassPartObject = classPartObject;
    path.split($86bbf129917d6fd4$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
};
const $86bbf129917d6fd4$var$isThemeGetter = (func)=>func.isThemeGetter;
const $86bbf129917d6fd4$var$getPrefixedClassGroupEntries = (classGroupEntries, prefix)=>{
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
};
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
const $86bbf129917d6fd4$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    const update = (key, value)=>{
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    };
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
};
const $86bbf129917d6fd4$var$IMPORTANT_MODIFIER = "!";
const $86bbf129917d6fd4$var$createParseClassName = (config)=>{
    const { separator: separator, experimentalParseClassName: experimentalParseClassName } = config;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // parseClassName inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    const parseClassName = (className)=>{
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($86bbf129917d6fd4$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
    if (experimentalParseClassName) return (className)=>experimentalParseClassName({
            className: className,
            parseClassName: parseClassName
        });
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $86bbf129917d6fd4$var$sortModifiers = (modifiers)=>{
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
};
const $86bbf129917d6fd4$var$createConfigUtils = (config)=>({
        cache: $86bbf129917d6fd4$var$createLruCache(config.cacheSize),
        parseClassName: $86bbf129917d6fd4$var$createParseClassName(config),
        ...$86bbf129917d6fd4$var$createClassGroupUtils(config)
    });
const $86bbf129917d6fd4$var$SPLIT_CLASSES_REGEX = /\s+/;
const $86bbf129917d6fd4$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($86bbf129917d6fd4$var$SPLIT_CLASSES_REGEX);
    let result = "";
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? " " + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? " " + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        const variantModifier = $86bbf129917d6fd4$var$sortModifiers(modifiers).join(":");
        const modifierId = hasImportantModifier ? variantModifier + $86bbf129917d6fd4$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.includes(classId)) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? " " + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $86bbf129917d6fd4$var$twJoin() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $86bbf129917d6fd4$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
const $86bbf129917d6fd4$var$toValue = (mix)=>{
    if (typeof mix === "string") return mix;
    let resolvedValue;
    let string = "";
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $86bbf129917d6fd4$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
};
function $86bbf129917d6fd4$var$createTailwindMerge(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $86bbf129917d6fd4$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $86bbf129917d6fd4$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($86bbf129917d6fd4$var$twJoin.apply(null, arguments));
    };
}
const $86bbf129917d6fd4$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const $86bbf129917d6fd4$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $86bbf129917d6fd4$var$fractionRegex = /^\d+\/\d+$/;
const $86bbf129917d6fd4$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
const $86bbf129917d6fd4$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $86bbf129917d6fd4$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $86bbf129917d6fd4$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $86bbf129917d6fd4$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $86bbf129917d6fd4$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $86bbf129917d6fd4$var$isLength = (value)=>$86bbf129917d6fd4$var$isNumber(value) || $86bbf129917d6fd4$var$stringLengths.has(value) || $86bbf129917d6fd4$var$fractionRegex.test(value);
const $86bbf129917d6fd4$var$isArbitraryLength = (value)=>$86bbf129917d6fd4$var$getIsArbitraryValue(value, "length", $86bbf129917d6fd4$var$isLengthOnly);
const $86bbf129917d6fd4$var$isNumber = (value)=>Boolean(value) && !Number.isNaN(Number(value));
const $86bbf129917d6fd4$var$isArbitraryNumber = (value)=>$86bbf129917d6fd4$var$getIsArbitraryValue(value, "number", $86bbf129917d6fd4$var$isNumber);
const $86bbf129917d6fd4$var$isInteger = (value)=>Boolean(value) && Number.isInteger(Number(value));
const $86bbf129917d6fd4$var$isPercent = (value)=>value.endsWith("%") && $86bbf129917d6fd4$var$isNumber(value.slice(0, -1));
const $86bbf129917d6fd4$var$isArbitraryValue = (value)=>$86bbf129917d6fd4$var$arbitraryValueRegex.test(value);
const $86bbf129917d6fd4$var$isTshirtSize = (value)=>$86bbf129917d6fd4$var$tshirtUnitRegex.test(value);
const $86bbf129917d6fd4$var$sizeLabels = /*#__PURE__*/ new Set([
    "length",
    "size",
    "percentage"
]);
const $86bbf129917d6fd4$var$isArbitrarySize = (value)=>$86bbf129917d6fd4$var$getIsArbitraryValue(value, $86bbf129917d6fd4$var$sizeLabels, $86bbf129917d6fd4$var$isNever);
const $86bbf129917d6fd4$var$isArbitraryPosition = (value)=>$86bbf129917d6fd4$var$getIsArbitraryValue(value, "position", $86bbf129917d6fd4$var$isNever);
const $86bbf129917d6fd4$var$imageLabels = /*#__PURE__*/ new Set([
    "image",
    "url"
]);
const $86bbf129917d6fd4$var$isArbitraryImage = (value)=>$86bbf129917d6fd4$var$getIsArbitraryValue(value, $86bbf129917d6fd4$var$imageLabels, $86bbf129917d6fd4$var$isImage);
const $86bbf129917d6fd4$var$isArbitraryShadow = (value)=>$86bbf129917d6fd4$var$getIsArbitraryValue(value, "", $86bbf129917d6fd4$var$isShadow);
const $86bbf129917d6fd4$var$isAny = ()=>true;
const $86bbf129917d6fd4$var$getIsArbitraryValue = (value, label, testValue)=>{
    const result = $86bbf129917d6fd4$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === "string" ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $86bbf129917d6fd4$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $86bbf129917d6fd4$var$lengthUnitRegex.test(value) && !$86bbf129917d6fd4$var$colorFunctionRegex.test(value);
const $86bbf129917d6fd4$var$isNever = ()=>false;
const $86bbf129917d6fd4$var$isShadow = (value)=>$86bbf129917d6fd4$var$shadowRegex.test(value);
const $86bbf129917d6fd4$var$isImage = (value)=>$86bbf129917d6fd4$var$imageRegex.test(value);
const $86bbf129917d6fd4$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $86bbf129917d6fd4$var$isAny,
    isArbitraryImage: $86bbf129917d6fd4$var$isArbitraryImage,
    isArbitraryLength: $86bbf129917d6fd4$var$isArbitraryLength,
    isArbitraryNumber: $86bbf129917d6fd4$var$isArbitraryNumber,
    isArbitraryPosition: $86bbf129917d6fd4$var$isArbitraryPosition,
    isArbitraryShadow: $86bbf129917d6fd4$var$isArbitraryShadow,
    isArbitrarySize: $86bbf129917d6fd4$var$isArbitrarySize,
    isArbitraryValue: $86bbf129917d6fd4$var$isArbitraryValue,
    isInteger: $86bbf129917d6fd4$var$isInteger,
    isLength: $86bbf129917d6fd4$var$isLength,
    isNumber: $86bbf129917d6fd4$var$isNumber,
    isPercent: $86bbf129917d6fd4$var$isPercent,
    isTshirtSize: $86bbf129917d6fd4$var$isTshirtSize
}, Symbol.toStringTag, {
    value: "Module"
});
const $86bbf129917d6fd4$var$getDefaultConfig = ()=>{
    const colors = $86bbf129917d6fd4$var$fromTheme("colors");
    const spacing = $86bbf129917d6fd4$var$fromTheme("spacing");
    const blur = $86bbf129917d6fd4$var$fromTheme("blur");
    const brightness = $86bbf129917d6fd4$var$fromTheme("brightness");
    const borderColor = $86bbf129917d6fd4$var$fromTheme("borderColor");
    const borderRadius = $86bbf129917d6fd4$var$fromTheme("borderRadius");
    const borderSpacing = $86bbf129917d6fd4$var$fromTheme("borderSpacing");
    const borderWidth = $86bbf129917d6fd4$var$fromTheme("borderWidth");
    const contrast = $86bbf129917d6fd4$var$fromTheme("contrast");
    const grayscale = $86bbf129917d6fd4$var$fromTheme("grayscale");
    const hueRotate = $86bbf129917d6fd4$var$fromTheme("hueRotate");
    const invert = $86bbf129917d6fd4$var$fromTheme("invert");
    const gap = $86bbf129917d6fd4$var$fromTheme("gap");
    const gradientColorStops = $86bbf129917d6fd4$var$fromTheme("gradientColorStops");
    const gradientColorStopPositions = $86bbf129917d6fd4$var$fromTheme("gradientColorStopPositions");
    const inset = $86bbf129917d6fd4$var$fromTheme("inset");
    const margin = $86bbf129917d6fd4$var$fromTheme("margin");
    const opacity = $86bbf129917d6fd4$var$fromTheme("opacity");
    const padding = $86bbf129917d6fd4$var$fromTheme("padding");
    const saturate = $86bbf129917d6fd4$var$fromTheme("saturate");
    const scale = $86bbf129917d6fd4$var$fromTheme("scale");
    const sepia = $86bbf129917d6fd4$var$fromTheme("sepia");
    const skew = $86bbf129917d6fd4$var$fromTheme("skew");
    const space = $86bbf129917d6fd4$var$fromTheme("space");
    const translate = $86bbf129917d6fd4$var$fromTheme("translate");
    const getOverscroll = ()=>[
            "auto",
            "contain",
            "none"
        ];
    const getOverflow = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            "auto",
            $86bbf129917d6fd4$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $86bbf129917d6fd4$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            "",
            $86bbf129917d6fd4$var$isLength,
            $86bbf129917d6fd4$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            "auto",
            $86bbf129917d6fd4$var$isNumber,
            $86bbf129917d6fd4$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    const getLineStyles = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    const getBlendModes = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ];
    const getAlign = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    const getZeroAndEmpty = ()=>[
            "",
            "0",
            $86bbf129917d6fd4$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    const getNumberAndArbitrary = ()=>[
            $86bbf129917d6fd4$var$isNumber,
            $86bbf129917d6fd4$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ":",
        theme: {
            colors: [
                $86bbf129917d6fd4$var$isAny
            ],
            spacing: [
                $86bbf129917d6fd4$var$isLength,
                $86bbf129917d6fd4$var$isArbitraryLength
            ],
            blur: [
                "none",
                "",
                $86bbf129917d6fd4$var$isTshirtSize,
                $86bbf129917d6fd4$var$isArbitraryValue
            ],
            brightness: getNumberAndArbitrary(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                $86bbf129917d6fd4$var$isTshirtSize,
                $86bbf129917d6fd4$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumberAndArbitrary(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $86bbf129917d6fd4$var$isPercent,
                $86bbf129917d6fd4$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumberAndArbitrary(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumberAndArbitrary(),
            scale: getNumberAndArbitrary(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $86bbf129917d6fd4$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [
                        ...getPositions(),
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        $86bbf129917d6fd4$var$isInteger,
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        $86bbf129917d6fd4$var$isInteger,
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        $86bbf129917d6fd4$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                $86bbf129917d6fd4$var$isInteger,
                                $86bbf129917d6fd4$var$isArbitraryValue
                            ]
                        },
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        $86bbf129917d6fd4$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                $86bbf129917d6fd4$var$isInteger,
                                $86bbf129917d6fd4$var$isArbitraryValue
                            ]
                        },
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal",
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal",
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svw",
                        "lvw",
                        "dvw",
                        $86bbf129917d6fd4$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        $86bbf129917d6fd4$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        $86bbf129917d6fd4$var$isArbitraryValue,
                        spacing,
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                $86bbf129917d6fd4$var$isTshirtSize
                            ]
                        },
                        $86bbf129917d6fd4$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $86bbf129917d6fd4$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        $86bbf129917d6fd4$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        $86bbf129917d6fd4$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $86bbf129917d6fd4$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        $86bbf129917d6fd4$var$isTshirtSize,
                        $86bbf129917d6fd4$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        $86bbf129917d6fd4$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        $86bbf129917d6fd4$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractions"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        $86bbf129917d6fd4$var$isNumber,
                        $86bbf129917d6fd4$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        $86bbf129917d6fd4$var$isLength,
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [
                        ...getLineStyles(),
                        "wavy"
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        $86bbf129917d6fd4$var$isLength,
                        $86bbf129917d6fd4$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        $86bbf129917d6fd4$var$isLength,
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [
                        ...getPositions(),
                        $86bbf129917d6fd4$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        $86bbf129917d6fd4$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        $86bbf129917d6fd4$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [
                        ...getLineStyles(),
                        "hidden"
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-s": [
                {
                    "border-s": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-e": [
                {
                    "border-e": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        "",
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        $86bbf129917d6fd4$var$isLength,
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        $86bbf129917d6fd4$var$isLength,
                        $86bbf129917d6fd4$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        $86bbf129917d6fd4$var$isLength,
                        $86bbf129917d6fd4$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        $86bbf129917d6fd4$var$isTshirtSize,
                        $86bbf129917d6fd4$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        $86bbf129917d6fd4$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": [
                        ...getBlendModes(),
                        "plus-lighter",
                        "plus-darker"
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        $86bbf129917d6fd4$var$isTshirtSize,
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $86bbf129917d6fd4$var$isInteger,
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $86bbf129917d6fd4$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        $86bbf129917d6fd4$var$isLength,
                        $86bbf129917d6fd4$var$isArbitraryLength,
                        $86bbf129917d6fd4$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-s",
                "border-color-e",
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $86bbf129917d6fd4$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $86bbf129917d6fd4$var$overrideProperty(baseConfig, "cacheSize", cacheSize);
    $86bbf129917d6fd4$var$overrideProperty(baseConfig, "prefix", prefix);
    $86bbf129917d6fd4$var$overrideProperty(baseConfig, "separator", separator);
    $86bbf129917d6fd4$var$overrideProperty(baseConfig, "experimentalParseClassName", experimentalParseClassName);
    for(const configKey in override)$86bbf129917d6fd4$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$86bbf129917d6fd4$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
};
const $86bbf129917d6fd4$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $86bbf129917d6fd4$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$86bbf129917d6fd4$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $86bbf129917d6fd4$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
};
const $86bbf129917d6fd4$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === "function" ? $86bbf129917d6fd4$var$createTailwindMerge($86bbf129917d6fd4$var$getDefaultConfig, configExtension, ...createConfig) : $86bbf129917d6fd4$var$createTailwindMerge(()=>$86bbf129917d6fd4$var$mergeConfigs($86bbf129917d6fd4$var$getDefaultConfig(), configExtension), ...createConfig);
const $86bbf129917d6fd4$var$twMerge = /*#__PURE__*/ $86bbf129917d6fd4$var$createTailwindMerge($86bbf129917d6fd4$var$getDefaultConfig);
$86bbf129917d6fd4$exports.createTailwindMerge = $86bbf129917d6fd4$var$createTailwindMerge;
$86bbf129917d6fd4$exports.extendTailwindMerge = $86bbf129917d6fd4$var$extendTailwindMerge;
$86bbf129917d6fd4$exports.fromTheme = $86bbf129917d6fd4$var$fromTheme;
$86bbf129917d6fd4$exports.getDefaultConfig = $86bbf129917d6fd4$var$getDefaultConfig;
$86bbf129917d6fd4$exports.mergeConfigs = $86bbf129917d6fd4$var$mergeConfigs;
$86bbf129917d6fd4$exports.twJoin = $86bbf129917d6fd4$var$twJoin;
$86bbf129917d6fd4$exports.twMerge = $86bbf129917d6fd4$var$twMerge;
$86bbf129917d6fd4$exports.validators = $86bbf129917d6fd4$var$validators;


function $6f9f216e765f1a15$export$1343a74baacb0543(...inputs) {
    return (0, $86bbf129917d6fd4$exports.twMerge)((0, $a9d9685a8e9a96cb$export$4f5d2d50c9deca37)(inputs));
}


const $be19f28f4a94fab4$export$60332b2344f7fe41 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("rounded-lg border bg-card text-card-foreground shadow-sm", className),
        ...props
    }));
$be19f28f4a94fab4$export$60332b2344f7fe41.displayName = "Card";
const $be19f28f4a94fab4$export$5665775b26e26c5d = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("flex flex-col space-y-1.5 p-6", className),
        ...props
    }));
$be19f28f4a94fab4$export$5665775b26e26c5d.displayName = "CardHeader";
const $be19f28f4a94fab4$export$474db65c3c394e1c = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)("h3", {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("text-2xl font-semibold leading-none tracking-tight", className),
        ...props
    }));
$be19f28f4a94fab4$export$474db65c3c394e1c.displayName = "CardTitle";
const $be19f28f4a94fab4$export$16e0ed4cb97c00d4 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)("p", {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("text-sm text-muted-foreground", className),
        ...props
    }));
$be19f28f4a94fab4$export$16e0ed4cb97c00d4.displayName = "CardDescription";
const $be19f28f4a94fab4$export$64ef9b8c11710c47 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("p-6 pt-0", className),
        ...props
    }));
$be19f28f4a94fab4$export$64ef9b8c11710c47.displayName = "CardContent";
const $be19f28f4a94fab4$export$e9897d434e0741ee = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("flex items-center p-6 pt-0", className),
        ...props
    }));
$be19f28f4a94fab4$export$e9897d434e0741ee.displayName = "CardFooter";



var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");


var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");

var $7PdBe = parcelRequire("7PdBe");
// src/primitive.tsx

var $7PdBe = parcelRequire("7PdBe");

var $1cUCD = parcelRequire("1cUCD");
// src/slot.tsx

var $7PdBe = parcelRequire("7PdBe");
// packages/react/compose-refs/src/compose-refs.tsx

var $7PdBe = parcelRequire("7PdBe");
function $1d2c417c81554c6a$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $1d2c417c81554c6a$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $1d2c417c81554c6a$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $1d2c417c81554c6a$var$setRef(refs[i], null);
            }
        };
    };
}
function $1d2c417c81554c6a$export$c7b2cbe3552a0d05(...refs) {
    return $7PdBe.useCallback($1d2c417c81554c6a$export$43e446d32b3d21af(...refs), refs);
}



var $hvk62 = parcelRequire("hvk62");
// @__NO_SIDE_EFFECTS__
function $0deb3a18aa385379$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $0deb3a18aa385379$var$createSlotClone(ownerName);
    const Slot2 = $7PdBe.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        const childrenArray = $7PdBe.Children.toArray(children);
        const slottable = childrenArray.find($0deb3a18aa385379$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($7PdBe.Children.count(newElement) > 1) return $7PdBe.Children.only(null);
                    return $7PdBe.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $hvk62.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $7PdBe.isValidElement(newElement) ? $7PdBe.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $hvk62.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $0deb3a18aa385379$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $0deb3a18aa385379$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $0deb3a18aa385379$var$createSlotClone(ownerName) {
    const SlotClone = $7PdBe.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        if ($7PdBe.isValidElement(children)) {
            const childrenRef = $0deb3a18aa385379$var$getElementRef(children);
            const props2 = $0deb3a18aa385379$var$mergeProps(slotProps, children.props);
            if (children.type !== $7PdBe.Fragment) props2.ref = forwardedRef ? (0, $1d2c417c81554c6a$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef;
            return $7PdBe.cloneElement(children, props2);
        }
        return $7PdBe.Children.count(children) > 1 ? $7PdBe.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $0deb3a18aa385379$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $0deb3a18aa385379$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $hvk62.jsx)((0, $hvk62.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $0deb3a18aa385379$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $0deb3a18aa385379$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $0deb3a18aa385379$export$bf68c29d8281d0f7("Slottable");
function $0deb3a18aa385379$var$isSlottable(child) {
    return $7PdBe.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $0deb3a18aa385379$var$SLOTTABLE_IDENTIFIER;
}
function $0deb3a18aa385379$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $0deb3a18aa385379$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}



var $hvk62 = parcelRequire("hvk62");
var $252f0230ab9bb14c$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $252f0230ab9bb14c$export$250ffa63cdc0d034 = $252f0230ab9bb14c$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $0deb3a18aa385379$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $7PdBe.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $hvk62.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $252f0230ab9bb14c$export$6d1a0317bde7de7f(target, event) {
    if (target) $1cUCD.flushSync(()=>target.dispatchEvent(event));
}
var $252f0230ab9bb14c$export$be92b6f5f03c0fe9 = $252f0230ab9bb14c$export$250ffa63cdc0d034;



var $hvk62 = parcelRequire("hvk62");
"use client";
var $acc36a8a0b135d72$var$NAME = "Label";
var $acc36a8a0b135d72$export$b04be29aa201d4f5 = $7PdBe.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).label, {
        ...props,
        ref: forwardedRef,
        onMouseDown: (event)=>{
            const target = event.target;
            if (target.closest("button, input, select, textarea")) return;
            props.onMouseDown?.(event);
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    });
});
$acc36a8a0b135d72$export$b04be29aa201d4f5.displayName = $acc36a8a0b135d72$var$NAME;
var $acc36a8a0b135d72$export$be92b6f5f03c0fe9 = $acc36a8a0b135d72$export$b04be29aa201d4f5;


/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
const $fabf324b0990a90a$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $fabf324b0990a90a$export$a274e22fb40f762e = (0, $a9d9685a8e9a96cb$export$4f5d2d50c9deca37);
const $fabf324b0990a90a$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $fabf324b0990a90a$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $fabf324b0990a90a$var$falsyToString(variantProp) || $fabf324b0990a90a$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $fabf324b0990a90a$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };



const $c3de1c4159aa79b3$var$labelVariants = (0, $fabf324b0990a90a$export$87dc52566e90b739)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
const $c3de1c4159aa79b3$export$b04be29aa201d4f5 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)($acc36a8a0b135d72$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)($c3de1c4159aa79b3$var$labelVariants(), className),
        ...props
    }));
$c3de1c4159aa79b3$export$b04be29aa201d4f5.displayName = $acc36a8a0b135d72$export$be92b6f5f03c0fe9.displayName;


const $1bcecf728217e410$export$f5b8910cec6cf069 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, type: type, suffix: suffix, prefix: prefix, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: "relative flex items-center",
        children: [
            prefix && /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                className: "absolute left-0 text-sm text-muted-foreground",
                children: prefix
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)("input", {
                type: type,
                className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", suffix && "pr-10", className),
                ref: ref,
                ...props
            }),
            suffix && /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                className: "absolute right-3 text-sm text-muted-foreground",
                children: suffix
            })
        ]
    });
});
$1bcecf728217e410$export$f5b8910cec6cf069.displayName = "Input";
const $1bcecf728217e410$export$cc1ef317067e4e4b = /*#__PURE__*/ $7PdBe.forwardRef(({ label: label, containerClassName: containerClassName, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("flex flex-col", containerClassName),
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                className: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
                children: label
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)($1bcecf728217e410$export$f5b8910cec6cf069, {
                ref: ref,
                ...props
            })
        ]
    });
});
$1bcecf728217e410$export$cc1ef317067e4e4b.displayName = "InputWithLabel";



var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");

var $7PdBe = parcelRequire("7PdBe");

var $1cUCD = parcelRequire("1cUCD");
// packages/core/number/src/number.ts
function $16194be29f19938e$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}


// src/primitive.tsx
var $21cf51b9379dc6b2$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $21cf51b9379dc6b2$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $21cf51b9379dc6b2$export$f21a1ffae260145a(element) {
    if (!$21cf51b9379dc6b2$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $21cf51b9379dc6b2$export$b204af158042fbac(element) {
    if (!$21cf51b9379dc6b2$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $21cf51b9379dc6b2$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $21cf51b9379dc6b2$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($21cf51b9379dc6b2$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $21cf51b9379dc6b2$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $21cf51b9379dc6b2$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $21cf51b9379dc6b2$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}



var $7PdBe = parcelRequire("7PdBe");
// packages/react/context/src/create-context.tsx

var $7PdBe = parcelRequire("7PdBe");

var $hvk62 = parcelRequire("hvk62");
function $2b55cbfabf840987$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $7PdBe.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $7PdBe.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $hvk62.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $7PdBe.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $2b55cbfabf840987$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $7PdBe.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $7PdBe.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $hvk62.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $7PdBe.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $7PdBe.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $7PdBe.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $2b55cbfabf840987$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $2b55cbfabf840987$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $7PdBe.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}





var $hvk62 = parcelRequire("hvk62");
"use client";
function $63e4826237d580a4$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $hvk62.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $0deb3a18aa385379$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $hvk62.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $0deb3a18aa385379$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
        const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $hvk62.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var $63e4826237d580a4$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $63e4826237d580a4$var$OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $63e4826237d580a4$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($63e4826237d580a4$var$__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = $63e4826237d580a4$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $63e4826237d580a4$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $63e4826237d580a4$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $63e4826237d580a4$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $63e4826237d580a4$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $63e4826237d580a4$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function $63e4826237d580a4$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $63e4826237d580a4$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function $63e4826237d580a4$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function $63e4826237d580a4$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $63e4826237d580a4$var$OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $hvk62.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $hvk62.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $hvk62.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
        const [collectionElement, setCollectionElement] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(null);
        const composeRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
            if (!collectionElement) return;
            const observer = $63e4826237d580a4$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $hvk62.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $0deb3a18aa385379$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $hvk62.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $0deb3a18aa385379$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
        const [element, setElement] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(null);
        const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(itemData);
        if (!$63e4826237d580a4$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element: element
                    });
                    return map.toSorted($63e4826237d580a4$var$sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element: element
                }).toSorted($63e4826237d580a4$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $63e4826237d580a4$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $hvk62.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(new $63e4826237d580a4$var$OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function $63e4826237d580a4$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $63e4826237d580a4$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function $63e4826237d580a4$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $63e4826237d580a4$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function $63e4826237d580a4$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}




// packages/react/direction/src/direction.tsx

var $7PdBe = parcelRequire("7PdBe");

var $hvk62 = parcelRequire("hvk62");
var $e77fd31f81c27db6$var$DirectionContext = $7PdBe.createContext(void 0);
var $e77fd31f81c27db6$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)($e77fd31f81c27db6$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $e77fd31f81c27db6$export$b39126d51d94e6f3(localDir) {
    const globalDir = $7PdBe.useContext($e77fd31f81c27db6$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $e77fd31f81c27db6$export$2881499e37b75b9a = $e77fd31f81c27db6$export$c760c09fdd558351;



var $7PdBe = parcelRequire("7PdBe");



// packages/react/use-callback-ref/src/use-callback-ref.tsx

var $7PdBe = parcelRequire("7PdBe");
function $c64c66c1264b1e20$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $7PdBe.useRef(callback);
    $7PdBe.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $7PdBe.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-escape-keydown/src/use-escape-keydown.tsx

var $7PdBe = parcelRequire("7PdBe");

function $4e41aaeaa3cbefa9$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $7PdBe.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



var $hvk62 = parcelRequire("hvk62");
"use client";
var $f890894e21f3588e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $f890894e21f3588e$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $f890894e21f3588e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $f890894e21f3588e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $f890894e21f3588e$var$originalBodyPointerEvents;
var $f890894e21f3588e$var$DismissableLayerContext = $7PdBe.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $f890894e21f3588e$export$177fb62ff3ec1f22 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $7PdBe.useContext($f890894e21f3588e$var$DismissableLayerContext);
    const [node, setNode] = $7PdBe.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $7PdBe.useState({});
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $f890894e21f3588e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $f890894e21f3588e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $4e41aaeaa3cbefa9$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $7PdBe.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $f890894e21f3588e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $f890894e21f3588e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $f890894e21f3588e$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $7PdBe.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $f890894e21f3588e$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $7PdBe.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($f890894e21f3588e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($f890894e21f3588e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$f890894e21f3588e$export$177fb62ff3ec1f22.displayName = $f890894e21f3588e$var$DISMISSABLE_LAYER_NAME;
var $f890894e21f3588e$var$BRANCH_NAME = "DismissableLayerBranch";
var $f890894e21f3588e$export$4d5eb2109db14228 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const context = $7PdBe.useContext($f890894e21f3588e$var$DismissableLayerContext);
    const ref = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $7PdBe.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$f890894e21f3588e$export$4d5eb2109db14228.displayName = $f890894e21f3588e$var$BRANCH_NAME;
function $f890894e21f3588e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $7PdBe.useRef(false);
    const handleClickRef = $7PdBe.useRef(()=>{});
    $7PdBe.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $f890894e21f3588e$var$handleAndDispatchCustomEvent($f890894e21f3588e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $f890894e21f3588e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $7PdBe.useRef(false);
    $7PdBe.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $f890894e21f3588e$var$handleAndDispatchCustomEvent($f890894e21f3588e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $f890894e21f3588e$var$dispatchUpdate() {
    const event = new CustomEvent($f890894e21f3588e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $f890894e21f3588e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $252f0230ab9bb14c$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $f890894e21f3588e$export$be92b6f5f03c0fe9 = $f890894e21f3588e$export$177fb62ff3ec1f22;
var $f890894e21f3588e$export$aecb2ddcb55c95be = $f890894e21f3588e$export$4d5eb2109db14228;



var $7PdBe = parcelRequire("7PdBe");
"use client";
var $0c9b2820b9ffd5a2$var$count = 0;
function $0c9b2820b9ffd5a2$export$ac5b58043b79449b(props) {
    $0c9b2820b9ffd5a2$export$b7ece24a22aeda8c();
    return props.children;
}
function $0c9b2820b9ffd5a2$export$b7ece24a22aeda8c() {
    $7PdBe.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $0c9b2820b9ffd5a2$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $0c9b2820b9ffd5a2$var$createFocusGuard());
        $0c9b2820b9ffd5a2$var$count++;
        return ()=>{
            if ($0c9b2820b9ffd5a2$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $0c9b2820b9ffd5a2$var$count--;
        };
    }, []);
}
function $0c9b2820b9ffd5a2$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}



var $7PdBe = parcelRequire("7PdBe");




var $hvk62 = parcelRequire("hvk62");
"use client";
var $10a485d4fe8e4da1$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $10a485d4fe8e4da1$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $10a485d4fe8e4da1$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $10a485d4fe8e4da1$var$FOCUS_SCOPE_NAME = "FocusScope";
var $10a485d4fe8e4da1$export$20e40289641fbbb6 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $7PdBe.useState(null);
    const onMountAutoFocus = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $7PdBe.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $7PdBe.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $10a485d4fe8e4da1$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $10a485d4fe8e4da1$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $10a485d4fe8e4da1$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $7PdBe.useEffect(()=>{
        if (container) {
            $10a485d4fe8e4da1$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($10a485d4fe8e4da1$var$AUTOFOCUS_ON_MOUNT, $10a485d4fe8e4da1$var$EVENT_OPTIONS);
                container.addEventListener($10a485d4fe8e4da1$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $10a485d4fe8e4da1$var$focusFirst($10a485d4fe8e4da1$var$removeLinks($10a485d4fe8e4da1$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $10a485d4fe8e4da1$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($10a485d4fe8e4da1$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($10a485d4fe8e4da1$var$AUTOFOCUS_ON_UNMOUNT, $10a485d4fe8e4da1$var$EVENT_OPTIONS);
                    container.addEventListener($10a485d4fe8e4da1$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $10a485d4fe8e4da1$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($10a485d4fe8e4da1$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $10a485d4fe8e4da1$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $7PdBe.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $10a485d4fe8e4da1$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $10a485d4fe8e4da1$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $10a485d4fe8e4da1$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$10a485d4fe8e4da1$export$20e40289641fbbb6.displayName = $10a485d4fe8e4da1$var$FOCUS_SCOPE_NAME;
function $10a485d4fe8e4da1$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $10a485d4fe8e4da1$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $10a485d4fe8e4da1$var$getTabbableEdges(container) {
    const candidates = $10a485d4fe8e4da1$var$getTabbableCandidates(container);
    const first = $10a485d4fe8e4da1$var$findVisible(candidates, container);
    const last = $10a485d4fe8e4da1$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $10a485d4fe8e4da1$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $10a485d4fe8e4da1$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$10a485d4fe8e4da1$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $10a485d4fe8e4da1$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $10a485d4fe8e4da1$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $10a485d4fe8e4da1$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $10a485d4fe8e4da1$var$isSelectableInput(element) && select) element.select();
    }
}
var $10a485d4fe8e4da1$var$focusScopesStack = $10a485d4fe8e4da1$var$createFocusScopesStack();
function $10a485d4fe8e4da1$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $10a485d4fe8e4da1$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $10a485d4fe8e4da1$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $10a485d4fe8e4da1$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $10a485d4fe8e4da1$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $10a485d4fe8e4da1$export$be92b6f5f03c0fe9 = $10a485d4fe8e4da1$export$20e40289641fbbb6;


// packages/react/id/src/id.tsx

var $7PdBe = parcelRequire("7PdBe");
// packages/react/use-layout-effect/src/use-layout-effect.tsx

var $7PdBe = parcelRequire("7PdBe");
var $b50e35dc615f2236$export$e5c5a5f917a5871c = globalThis?.document ? $7PdBe.useLayoutEffect : ()=>{};


var $a2450a3e5d440835$var$useReactId = $7PdBe[" useId ".trim().toString()] || (()=>void 0);
var $a2450a3e5d440835$var$count = 0;
function $a2450a3e5d440835$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $7PdBe.useState($a2450a3e5d440835$var$useReactId());
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($a2450a3e5d440835$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $7PdBe = parcelRequire("7PdBe");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $fc505b666388d3a4$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $fc505b666388d3a4$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $fc505b666388d3a4$export$803cd8101b6c182b = /*#__PURE__*/ $fc505b666388d3a4$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $fc505b666388d3a4$export$27b07d8a310ed8b5[0], side + "-" + $fc505b666388d3a4$export$27b07d8a310ed8b5[1]), []);
const $fc505b666388d3a4$export$96ec731ed4dcb222 = Math.min;
const $fc505b666388d3a4$export$8960430cfd85939f = Math.max;
const $fc505b666388d3a4$export$2077e0241d6afd3c = Math.round;
const $fc505b666388d3a4$export$a3fe094919f356fd = Math.floor;
const $fc505b666388d3a4$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $fc505b666388d3a4$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $fc505b666388d3a4$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $fc505b666388d3a4$export$7d15b64cf5a3a4c4(start, value, end) {
    return $fc505b666388d3a4$export$8960430cfd85939f(start, $fc505b666388d3a4$export$96ec731ed4dcb222(value, end));
}
function $fc505b666388d3a4$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $fc505b666388d3a4$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $fc505b666388d3a4$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $fc505b666388d3a4$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $fc505b666388d3a4$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
const $fc505b666388d3a4$var$yAxisSides = /*#__PURE__*/ new Set([
    "top",
    "bottom"
]);
function $fc505b666388d3a4$export$f28e8f882010718a(placement) {
    return $fc505b666388d3a4$var$yAxisSides.has($fc505b666388d3a4$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $fc505b666388d3a4$export$2b57e0052a6d6d4c(placement) {
    return $fc505b666388d3a4$export$8a000a963141ac32($fc505b666388d3a4$export$f28e8f882010718a(placement));
}
function $fc505b666388d3a4$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $fc505b666388d3a4$export$f0989780f32bfcda(placement);
    const alignmentAxis = $fc505b666388d3a4$export$2b57e0052a6d6d4c(placement);
    const length = $fc505b666388d3a4$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $fc505b666388d3a4$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $fc505b666388d3a4$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $fc505b666388d3a4$export$496432a3699e50b1(placement) {
    const oppositePlacement = $fc505b666388d3a4$export$9c5e28bad23365fa(placement);
    return [
        $fc505b666388d3a4$export$2b182c584985588b(placement),
        oppositePlacement,
        $fc505b666388d3a4$export$2b182c584985588b(oppositePlacement)
    ];
}
function $fc505b666388d3a4$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$fc505b666388d3a4$var$oppositeAlignmentMap[alignment]);
}
const $fc505b666388d3a4$var$lrPlacement = [
    "left",
    "right"
];
const $fc505b666388d3a4$var$rlPlacement = [
    "right",
    "left"
];
const $fc505b666388d3a4$var$tbPlacement = [
    "top",
    "bottom"
];
const $fc505b666388d3a4$var$btPlacement = [
    "bottom",
    "top"
];
function $fc505b666388d3a4$var$getSideList(side, isStart, rtl) {
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? $fc505b666388d3a4$var$rlPlacement : $fc505b666388d3a4$var$lrPlacement;
            return isStart ? $fc505b666388d3a4$var$lrPlacement : $fc505b666388d3a4$var$rlPlacement;
        case "left":
        case "right":
            return isStart ? $fc505b666388d3a4$var$tbPlacement : $fc505b666388d3a4$var$btPlacement;
        default:
            return [];
    }
}
function $fc505b666388d3a4$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $fc505b666388d3a4$export$f0989780f32bfcda(placement);
    let list = $fc505b666388d3a4$var$getSideList($fc505b666388d3a4$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($fc505b666388d3a4$export$2b182c584985588b));
    }
    return list;
}
function $fc505b666388d3a4$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$fc505b666388d3a4$var$oppositeSideMap[side]);
}
function $fc505b666388d3a4$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $fc505b666388d3a4$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $fc505b666388d3a4$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $fc505b666388d3a4$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $eb8b1ce828e44057$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $fc505b666388d3a4$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $fc505b666388d3a4$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $fc505b666388d3a4$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $fc505b666388d3a4$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $eb8b1ce828e44057$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $eb8b1ce828e44057$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $eb8b1ce828e44057$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $eb8b1ce828e44057$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $fc505b666388d3a4$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $fc505b666388d3a4$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $fc505b666388d3a4$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $eb8b1ce828e44057$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $fc505b666388d3a4$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $fc505b666388d3a4$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $fc505b666388d3a4$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $fc505b666388d3a4$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $fc505b666388d3a4$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $eb8b1ce828e44057$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $fc505b666388d3a4$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $fc505b666388d3a4$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $fc505b666388d3a4$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $fc505b666388d3a4$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $eb8b1ce828e44057$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $fc505b666388d3a4$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $fc505b666388d3a4$export$803cd8101b6c182b) ? $eb8b1ce828e44057$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $eb8b1ce828e44057$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $fc505b666388d3a4$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $fc505b666388d3a4$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $fc505b666388d3a4$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $fc505b666388d3a4$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $eb8b1ce828e44057$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $fc505b666388d3a4$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $fc505b666388d3a4$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $fc505b666388d3a4$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $fc505b666388d3a4$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $fc505b666388d3a4$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $eb8b1ce828e44057$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $fc505b666388d3a4$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== (0, $fc505b666388d3a4$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $fc505b666388d3a4$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $fc505b666388d3a4$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $eb8b1ce828e44057$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $eb8b1ce828e44057$var$isAnySideFullyClipped(overflow) {
    return (0, $fc505b666388d3a4$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $eb8b1ce828e44057$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $eb8b1ce828e44057$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $eb8b1ce828e44057$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $eb8b1ce828e44057$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $eb8b1ce828e44057$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $eb8b1ce828e44057$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $eb8b1ce828e44057$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $eb8b1ce828e44057$var$getBoundingRect(rects) {
    const minX = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $fc505b666388d3a4$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $fc505b666388d3a4$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $eb8b1ce828e44057$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $fc505b666388d3a4$export$ee05aea0aeecbad4)($eb8b1ce828e44057$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $eb8b1ce828e44057$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $eb8b1ce828e44057$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $fc505b666388d3a4$export$ee05aea0aeecbad4)($eb8b1ce828e44057$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $fc505b666388d3a4$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $fc505b666388d3a4$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $fc505b666388d3a4$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $eb8b1ce828e44057$var$originSides = /*#__PURE__*/ new Set([
    "left",
    "top"
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $eb8b1ce828e44057$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $fc505b666388d3a4$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $fc505b666388d3a4$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = $eb8b1ce828e44057$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $eb8b1ce828e44057$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $eb8b1ce828e44057$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $eb8b1ce828e44057$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $eb8b1ce828e44057$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $fc505b666388d3a4$export$f28e8f882010718a)((0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $fc505b666388d3a4$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $fc505b666388d3a4$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $fc505b666388d3a4$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $eb8b1ce828e44057$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $fc505b666388d3a4$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $fc505b666388d3a4$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = $eb8b1ce828e44057$var$originSides.has((0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $eb8b1ce828e44057$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $fc505b666388d3a4$export$fef61f332f2c0afc)(options, state);
            const overflow = await $eb8b1ce828e44057$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $fc505b666388d3a4$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $fc505b666388d3a4$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $fc505b666388d3a4$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $fc505b666388d3a4$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $fc505b666388d3a4$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $fc505b666388d3a4$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $fc505b666388d3a4$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $fc505b666388d3a4$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $fc505b666388d3a4$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $b0f95843612cb401$var$hasWindow() {
    return typeof window !== "undefined";
}
function $b0f95843612cb401$export$651544f548703224(node) {
    if ($b0f95843612cb401$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $b0f95843612cb401$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b0f95843612cb401$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b0f95843612cb401$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b0f95843612cb401$export$8ee0fc9ee280b4ee(value) {
    if (!$b0f95843612cb401$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b0f95843612cb401$export$38b2d434cce3ea22(value).Node;
}
function $b0f95843612cb401$export$45a5e7f76e0caa8d(value) {
    if (!$b0f95843612cb401$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b0f95843612cb401$export$38b2d434cce3ea22(value).Element;
}
function $b0f95843612cb401$export$1b3bfaa9684536aa(value) {
    if (!$b0f95843612cb401$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b0f95843612cb401$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b0f95843612cb401$export$af51f0f06c0f328a(value) {
    if (!$b0f95843612cb401$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $b0f95843612cb401$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $b0f95843612cb401$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    "inline",
    "contents"
]);
function $b0f95843612cb401$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b0f95843612cb401$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$b0f95843612cb401$var$invalidOverflowDisplayValues.has(display);
}
const $b0f95843612cb401$var$tableElements = /*#__PURE__*/ new Set([
    "table",
    "td",
    "th"
]);
function $b0f95843612cb401$export$71535ffaa902797f(element) {
    return $b0f95843612cb401$var$tableElements.has($b0f95843612cb401$export$651544f548703224(element));
}
const $b0f95843612cb401$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $b0f95843612cb401$export$89e651af02346cd4(element) {
    return $b0f95843612cb401$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $b0f95843612cb401$var$transformProperties = [
    "transform",
    "translate",
    "scale",
    "rotate",
    "perspective"
];
const $b0f95843612cb401$var$willChangeValues = [
    "transform",
    "translate",
    "scale",
    "rotate",
    "perspective",
    "filter"
];
const $b0f95843612cb401$var$containValues = [
    "paint",
    "layout",
    "strict",
    "content"
];
function $b0f95843612cb401$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b0f95843612cb401$export$78551043582a6a98();
    const css = $b0f95843612cb401$export$45a5e7f76e0caa8d(elementOrCss) ? $b0f95843612cb401$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $b0f95843612cb401$var$transformProperties.some((value)=>css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || $b0f95843612cb401$var$willChangeValues.some((value)=>(css.willChange || "").includes(value)) || $b0f95843612cb401$var$containValues.some((value)=>(css.contain || "").includes(value));
}
function $b0f95843612cb401$export$940d8225183e1404(element) {
    let currentNode = $b0f95843612cb401$export$4e12058fc4d51d56(element);
    while($b0f95843612cb401$export$1b3bfaa9684536aa(currentNode) && !$b0f95843612cb401$export$d1162fb0b6d4cd51(currentNode)){
        if ($b0f95843612cb401$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b0f95843612cb401$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b0f95843612cb401$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b0f95843612cb401$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
const $b0f95843612cb401$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    "html",
    "body",
    "#document"
]);
function $b0f95843612cb401$export$d1162fb0b6d4cd51(node) {
    return $b0f95843612cb401$var$lastTraversableNodeNames.has($b0f95843612cb401$export$651544f548703224(node));
}
function $b0f95843612cb401$export$3735103072e4a80(element) {
    return $b0f95843612cb401$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b0f95843612cb401$export$dc8fc79fa2800137(element) {
    if ($b0f95843612cb401$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b0f95843612cb401$export$4e12058fc4d51d56(node) {
    if ($b0f95843612cb401$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b0f95843612cb401$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b0f95843612cb401$export$e495491855dc5418(node);
    return $b0f95843612cb401$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b0f95843612cb401$export$7cd01a57c8ca906c(node) {
    const parentNode = $b0f95843612cb401$export$4e12058fc4d51d56(node);
    if ($b0f95843612cb401$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b0f95843612cb401$export$1b3bfaa9684536aa(parentNode) && $b0f95843612cb401$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b0f95843612cb401$export$7cd01a57c8ca906c(parentNode);
}
function $b0f95843612cb401$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b0f95843612cb401$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b0f95843612cb401$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b0f95843612cb401$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b0f95843612cb401$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b0f95843612cb401$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b0f95843612cb401$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b0f95843612cb401$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $ffaf41eed90f1062$var$getCssDimensions(element) {
    const css = (0, $b0f95843612cb401$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $b0f95843612cb401$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $fc505b666388d3a4$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $fc505b666388d3a4$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $ffaf41eed90f1062$var$unwrapElement(element) {
    return !(0, $b0f95843612cb401$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $ffaf41eed90f1062$var$getScale(element) {
    const domElement = $ffaf41eed90f1062$var$unwrapElement(element);
    if (!(0, $b0f95843612cb401$export$1b3bfaa9684536aa)(domElement)) return (0, $fc505b666388d3a4$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $ffaf41eed90f1062$var$getCssDimensions(domElement);
    let x = ($ ? (0, $fc505b666388d3a4$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $fc505b666388d3a4$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $ffaf41eed90f1062$var$noOffsets = /*#__PURE__*/ (0, $fc505b666388d3a4$export$a397704b5e280835)(0);
function $ffaf41eed90f1062$var$getVisualOffsets(element) {
    const win = (0, $b0f95843612cb401$export$38b2d434cce3ea22)(element);
    if (!(0, $b0f95843612cb401$export$78551043582a6a98)() || !win.visualViewport) return $ffaf41eed90f1062$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $ffaf41eed90f1062$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $b0f95843612cb401$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $ffaf41eed90f1062$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $ffaf41eed90f1062$var$unwrapElement(element);
    let scale = (0, $fc505b666388d3a4$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $b0f95843612cb401$export$45a5e7f76e0caa8d)(offsetParent)) scale = $ffaf41eed90f1062$var$getScale(offsetParent);
        } else scale = $ffaf41eed90f1062$var$getScale(element);
    }
    const visualOffsets = $ffaf41eed90f1062$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $ffaf41eed90f1062$var$getVisualOffsets(domElement) : (0, $fc505b666388d3a4$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $b0f95843612cb401$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $b0f95843612cb401$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $b0f95843612cb401$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $b0f95843612cb401$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $ffaf41eed90f1062$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $b0f95843612cb401$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $b0f95843612cb401$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $b0f95843612cb401$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $fc505b666388d3a4$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $ffaf41eed90f1062$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $b0f95843612cb401$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $ffaf41eed90f1062$var$getBoundingClientRect((0, $b0f95843612cb401$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $ffaf41eed90f1062$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $ffaf41eed90f1062$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $ffaf41eed90f1062$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $b0f95843612cb401$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $b0f95843612cb401$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $fc505b666388d3a4$export$a397704b5e280835)(1);
    const offsets = (0, $fc505b666388d3a4$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $b0f95843612cb401$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b0f95843612cb401$export$651544f548703224)(offsetParent) !== "body" || (0, $b0f95843612cb401$export$989e911fa9af580a)(documentElement)) scroll = (0, $b0f95843612cb401$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $b0f95843612cb401$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $ffaf41eed90f1062$var$getBoundingClientRect(offsetParent);
            scale = $ffaf41eed90f1062$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $ffaf41eed90f1062$var$getHTMLOffset(documentElement, scroll) : (0, $fc505b666388d3a4$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $ffaf41eed90f1062$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $ffaf41eed90f1062$var$getDocumentRect(element) {
    const html = (0, $b0f95843612cb401$export$e495491855dc5418)(element);
    const scroll = (0, $b0f95843612cb401$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $fc505b666388d3a4$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $fc505b666388d3a4$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $ffaf41eed90f1062$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $b0f95843612cb401$export$3735103072e4a80)(body).direction === "rtl") x += (0, $fc505b666388d3a4$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $ffaf41eed90f1062$var$SCROLLBAR_MAX = 25;
function $ffaf41eed90f1062$var$getViewportRect(element, strategy) {
    const win = (0, $b0f95843612cb401$export$38b2d434cce3ea22)(element);
    const html = (0, $b0f95843612cb401$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $b0f95843612cb401$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $ffaf41eed90f1062$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $ffaf41eed90f1062$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $ffaf41eed90f1062$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $ffaf41eed90f1062$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    "absolute",
    "fixed"
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $ffaf41eed90f1062$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $ffaf41eed90f1062$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $b0f95843612cb401$export$1b3bfaa9684536aa)(element) ? $ffaf41eed90f1062$var$getScale(element) : (0, $fc505b666388d3a4$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ffaf41eed90f1062$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $ffaf41eed90f1062$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $ffaf41eed90f1062$var$getDocumentRect((0, $b0f95843612cb401$export$e495491855dc5418)(element));
    else if ((0, $b0f95843612cb401$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $ffaf41eed90f1062$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $ffaf41eed90f1062$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $fc505b666388d3a4$export$ee05aea0aeecbad4)(rect);
}
function $ffaf41eed90f1062$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $b0f95843612cb401$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $b0f95843612cb401$export$45a5e7f76e0caa8d)(parentNode) || (0, $b0f95843612cb401$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $b0f95843612cb401$export$3735103072e4a80)(parentNode).position === "fixed" || $ffaf41eed90f1062$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $ffaf41eed90f1062$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $b0f95843612cb401$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $b0f95843612cb401$export$45a5e7f76e0caa8d)(el) && (0, $b0f95843612cb401$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $b0f95843612cb401$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $b0f95843612cb401$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $b0f95843612cb401$export$45a5e7f76e0caa8d)(currentNode) && !(0, $b0f95843612cb401$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $b0f95843612cb401$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $b0f95843612cb401$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && $ffaf41eed90f1062$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $b0f95843612cb401$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $ffaf41eed90f1062$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $b0f95843612cb401$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $ffaf41eed90f1062$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $b0f95843612cb401$export$89e651af02346cd4)(element) ? [] : $ffaf41eed90f1062$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $ffaf41eed90f1062$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $fc505b666388d3a4$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $fc505b666388d3a4$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $ffaf41eed90f1062$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $ffaf41eed90f1062$var$getDimensions(element) {
    const { width: width, height: height } = $ffaf41eed90f1062$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $ffaf41eed90f1062$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $b0f95843612cb401$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $b0f95843612cb401$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $ffaf41eed90f1062$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $fc505b666388d3a4$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $ffaf41eed90f1062$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b0f95843612cb401$export$651544f548703224)(offsetParent) !== "body" || (0, $b0f95843612cb401$export$989e911fa9af580a)(documentElement)) scroll = (0, $b0f95843612cb401$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $ffaf41eed90f1062$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $ffaf41eed90f1062$var$getHTMLOffset(documentElement, scroll) : (0, $fc505b666388d3a4$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $ffaf41eed90f1062$var$isStaticPositioned(element) {
    return (0, $b0f95843612cb401$export$3735103072e4a80)(element).position === "static";
}
function $ffaf41eed90f1062$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $b0f95843612cb401$export$1b3bfaa9684536aa)(element) || (0, $b0f95843612cb401$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $b0f95843612cb401$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $ffaf41eed90f1062$var$getOffsetParent(element, polyfill) {
    const win = (0, $b0f95843612cb401$export$38b2d434cce3ea22)(element);
    if ((0, $b0f95843612cb401$export$89e651af02346cd4)(element)) return win;
    if (!(0, $b0f95843612cb401$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $b0f95843612cb401$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $b0f95843612cb401$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $b0f95843612cb401$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$ffaf41eed90f1062$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $b0f95843612cb401$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $ffaf41eed90f1062$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $b0f95843612cb401$export$71535ffaa902797f)(offsetParent) && $ffaf41eed90f1062$var$isStaticPositioned(offsetParent))offsetParent = $ffaf41eed90f1062$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $b0f95843612cb401$export$d1162fb0b6d4cd51)(offsetParent) && $ffaf41eed90f1062$var$isStaticPositioned(offsetParent) && !(0, $b0f95843612cb401$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $b0f95843612cb401$export$940d8225183e1404)(element) || win;
}
const $ffaf41eed90f1062$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $ffaf41eed90f1062$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $ffaf41eed90f1062$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $ffaf41eed90f1062$var$isRTL(element) {
    return (0, $b0f95843612cb401$export$3735103072e4a80)(element).direction === "rtl";
}
const $ffaf41eed90f1062$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $ffaf41eed90f1062$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $b0f95843612cb401$export$e495491855dc5418,
    getClippingRect: $ffaf41eed90f1062$var$getClippingRect,
    getOffsetParent: $ffaf41eed90f1062$var$getOffsetParent,
    getElementRects: $ffaf41eed90f1062$var$getElementRects,
    getClientRects: $ffaf41eed90f1062$var$getClientRects,
    getDimensions: $ffaf41eed90f1062$var$getDimensions,
    getScale: $ffaf41eed90f1062$var$getScale,
    isElement: $b0f95843612cb401$export$45a5e7f76e0caa8d,
    isRTL: $ffaf41eed90f1062$var$isRTL
};
function $ffaf41eed90f1062$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $ffaf41eed90f1062$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $b0f95843612cb401$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $fc505b666388d3a4$export$a3fe094919f356fd)(top);
        const insetRight = (0, $fc505b666388d3a4$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $fc505b666388d3a4$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $fc505b666388d3a4$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $fc505b666388d3a4$export$8960430cfd85939f)(0, (0, $fc505b666388d3a4$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$ffaf41eed90f1062$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $ffaf41eed90f1062$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $ffaf41eed90f1062$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $b0f95843612cb401$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $b0f95843612cb401$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $ffaf41eed90f1062$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $ffaf41eed90f1062$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $ffaf41eed90f1062$var$getBoundingClientRect(reference);
        if (prevRefRect && !$ffaf41eed90f1062$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $ffaf41eed90f1062$export$37b6bde19b108ecc = (0, $eb8b1ce828e44057$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $ffaf41eed90f1062$export$cc800923e997bb8 = (0, $eb8b1ce828e44057$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $ffaf41eed90f1062$export$91fb6ecbd551914 = (0, $eb8b1ce828e44057$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $ffaf41eed90f1062$export$fba63a578e423eb = (0, $eb8b1ce828e44057$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $ffaf41eed90f1062$export$8a83211c878a3f1f = (0, $eb8b1ce828e44057$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $ffaf41eed90f1062$export$346677f925de839c = (0, $eb8b1ce828e44057$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $ffaf41eed90f1062$export$fe8985bb6374093c = (0, $eb8b1ce828e44057$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $ffaf41eed90f1062$export$f2120bbfa5450bd2 = (0, $eb8b1ce828e44057$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $ffaf41eed90f1062$export$18c8ad048e32c7d5 = (0, $eb8b1ce828e44057$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $ffaf41eed90f1062$export$7bf07e38f3dc4b69 = (0, $eb8b1ce828e44057$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $ffaf41eed90f1062$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $ffaf41eed90f1062$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $eb8b1ce828e44057$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $7PdBe = parcelRequire("7PdBe");

var $1cUCD = parcelRequire("1cUCD");
var $6b14a6aa3d68c3e9$var$isClient = typeof document !== "undefined";
var $6b14a6aa3d68c3e9$var$noop = function noop() {};
var $6b14a6aa3d68c3e9$var$index = $6b14a6aa3d68c3e9$var$isClient ? (0, $7PdBe.useLayoutEffect) : $6b14a6aa3d68c3e9$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $6b14a6aa3d68c3e9$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$6b14a6aa3d68c3e9$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$6b14a6aa3d68c3e9$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $6b14a6aa3d68c3e9$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $6b14a6aa3d68c3e9$var$roundByDPR(element, value) {
    const dpr = $6b14a6aa3d68c3e9$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $6b14a6aa3d68c3e9$var$useLatestRef(value) {
    const ref = $7PdBe.useRef(value);
    $6b14a6aa3d68c3e9$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $6b14a6aa3d68c3e9$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $7PdBe.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $7PdBe.useState(middleware);
    if (!$6b14a6aa3d68c3e9$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $7PdBe.useState(null);
    const [_floating, _setFloating] = $7PdBe.useState(null);
    const setReference = $7PdBe.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $7PdBe.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $7PdBe.useRef(null);
    const floatingRef = $7PdBe.useRef(null);
    const dataRef = $7PdBe.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $6b14a6aa3d68c3e9$var$useLatestRef(whileElementsMounted);
    const platformRef = $6b14a6aa3d68c3e9$var$useLatestRef(platform);
    const openRef = $6b14a6aa3d68c3e9$var$useLatestRef(open);
    const update = $7PdBe.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $ffaf41eed90f1062$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$6b14a6aa3d68c3e9$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1cUCD.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $6b14a6aa3d68c3e9$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $7PdBe.useRef(false);
    $6b14a6aa3d68c3e9$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $6b14a6aa3d68c3e9$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $7PdBe.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $7PdBe.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $7PdBe.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $6b14a6aa3d68c3e9$var$roundByDPR(elements.floating, data.x);
        const y = $6b14a6aa3d68c3e9$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$6b14a6aa3d68c3e9$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $7PdBe.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6b14a6aa3d68c3e9$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $ffaf41eed90f1062$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $ffaf41eed90f1062$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $6b14a6aa3d68c3e9$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $ffaf41eed90f1062$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $6b14a6aa3d68c3e9$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $ffaf41eed90f1062$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $6b14a6aa3d68c3e9$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $ffaf41eed90f1062$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $6b14a6aa3d68c3e9$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $ffaf41eed90f1062$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $6b14a6aa3d68c3e9$export$346677f925de839c = (options, deps)=>({
        ...(0, $ffaf41eed90f1062$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $6b14a6aa3d68c3e9$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $ffaf41eed90f1062$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $6b14a6aa3d68c3e9$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $ffaf41eed90f1062$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $6b14a6aa3d68c3e9$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $ffaf41eed90f1062$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6b14a6aa3d68c3e9$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$6b14a6aa3d68c3e9$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


// src/arrow.tsx

var $7PdBe = parcelRequire("7PdBe");


var $hvk62 = parcelRequire("hvk62");
var $6fc3a7a1c86512b4$var$NAME = "Arrow";
var $6fc3a7a1c86512b4$export$21b07c8f274aebd5 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $hvk62.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$6fc3a7a1c86512b4$export$21b07c8f274aebd5.displayName = $6fc3a7a1c86512b4$var$NAME;
var $6fc3a7a1c86512b4$export$be92b6f5f03c0fe9 = $6fc3a7a1c86512b4$export$21b07c8f274aebd5;







// packages/react/use-size/src/use-size.tsx

var $7PdBe = parcelRequire("7PdBe");

function $424a8748a5f37a7c$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $7PdBe.useState(void 0);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



var $hvk62 = parcelRequire("hvk62");
"use client";
var $138fccadffc9ae29$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $138fccadffc9ae29$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $138fccadffc9ae29$var$POPPER_NAME = "Popper";
var [$138fccadffc9ae29$var$createPopperContext, $138fccadffc9ae29$export$722aac194ae923] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)($138fccadffc9ae29$var$POPPER_NAME);
var [$138fccadffc9ae29$var$PopperProvider, $138fccadffc9ae29$var$usePopperContext] = $138fccadffc9ae29$var$createPopperContext($138fccadffc9ae29$var$POPPER_NAME);
var $138fccadffc9ae29$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $7PdBe.useState(null);
    return /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$138fccadffc9ae29$export$badac9ada3a0bdf9.displayName = $138fccadffc9ae29$var$POPPER_NAME;
var $138fccadffc9ae29$var$ANCHOR_NAME = "PopperAnchor";
var $138fccadffc9ae29$export$ecd4e1ccab6ed6d = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $138fccadffc9ae29$var$usePopperContext($138fccadffc9ae29$var$ANCHOR_NAME, __scopePopper);
    const ref = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const anchorRef = $7PdBe.useRef(null);
    $7PdBe.useEffect(()=>{
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef?.current || ref.current;
        if (previousAnchor !== anchorRef.current) context.onAnchorChange(anchorRef.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$138fccadffc9ae29$export$ecd4e1ccab6ed6d.displayName = $138fccadffc9ae29$var$ANCHOR_NAME;
var $138fccadffc9ae29$var$CONTENT_NAME = "PopperContent";
var [$138fccadffc9ae29$var$PopperContentProvider, $138fccadffc9ae29$var$useContentContext] = $138fccadffc9ae29$var$createPopperContext($138fccadffc9ae29$var$CONTENT_NAME);
var $138fccadffc9ae29$export$bc4ae5855d3c4fc = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $138fccadffc9ae29$var$usePopperContext($138fccadffc9ae29$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $7PdBe.useState(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $7PdBe.useState(null);
    const arrowSize = (0, $424a8748a5f37a7c$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($138fccadffc9ae29$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $6b14a6aa3d68c3e9$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $ffaf41eed90f1062$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $6b14a6aa3d68c3e9$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $6b14a6aa3d68c3e9$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $6b14a6aa3d68c3e9$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $6b14a6aa3d68c3e9$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $6b14a6aa3d68c3e9$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $6b14a6aa3d68c3e9$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $138fccadffc9ae29$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $6b14a6aa3d68c3e9$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $138fccadffc9ae29$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onPlaced);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $7PdBe.useState();
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$138fccadffc9ae29$export$bc4ae5855d3c4fc.displayName = $138fccadffc9ae29$var$CONTENT_NAME;
var $138fccadffc9ae29$var$ARROW_NAME = "PopperArrow";
var $138fccadffc9ae29$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $138fccadffc9ae29$export$79d62cd4e10a3fd0 = $7PdBe.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $138fccadffc9ae29$var$useContentContext($138fccadffc9ae29$var$ARROW_NAME, __scopePopper);
    const baseSide = $138fccadffc9ae29$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $hvk62.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $hvk62.jsx)($6fc3a7a1c86512b4$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$138fccadffc9ae29$export$79d62cd4e10a3fd0.displayName = $138fccadffc9ae29$var$ARROW_NAME;
function $138fccadffc9ae29$var$isNotNull(value) {
    return value !== null;
}
var $138fccadffc9ae29$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $138fccadffc9ae29$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $138fccadffc9ae29$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $138fccadffc9ae29$export$be92b6f5f03c0fe9 = $138fccadffc9ae29$export$badac9ada3a0bdf9;
var $138fccadffc9ae29$export$b688253958b8dfe7 = $138fccadffc9ae29$export$ecd4e1ccab6ed6d;
var $138fccadffc9ae29$export$7c6e2c02157bb7d2 = $138fccadffc9ae29$export$bc4ae5855d3c4fc;
var $138fccadffc9ae29$export$21b07c8f274aebd5 = $138fccadffc9ae29$export$79d62cd4e10a3fd0;



var $7PdBe = parcelRequire("7PdBe");

var $1cUCD = parcelRequire("1cUCD");



var $hvk62 = parcelRequire("hvk62");
"use client";
var $fa484e2fa46a4ad3$var$PORTAL_NAME = "Portal";
var $fa484e2fa46a4ad3$export$602eac185826482c = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $7PdBe.useState(false);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($1cUCD))).createPortal(/* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$fa484e2fa46a4ad3$export$602eac185826482c.displayName = $fa484e2fa46a4ad3$var$PORTAL_NAME;
var $fa484e2fa46a4ad3$export$be92b6f5f03c0fe9 = $fa484e2fa46a4ad3$export$602eac185826482c;





// src/use-controllable-state.tsx

var $7PdBe = parcelRequire("7PdBe");

// src/use-effect-event.tsx


var $7PdBe = parcelRequire("7PdBe");
var $46ce675f07822b98$var$useReactEffectEvent = $7PdBe[" useEffectEvent ".trim().toString()];
var $46ce675f07822b98$var$useReactInsertionEffect = $7PdBe[" useInsertionEffect ".trim().toString()];
function $46ce675f07822b98$export$7f54fc3180508a52(callback) {
    if (typeof $46ce675f07822b98$var$useReactEffectEvent === "function") return $46ce675f07822b98$var$useReactEffectEvent(callback);
    const ref = $7PdBe.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $46ce675f07822b98$var$useReactInsertionEffect === "function") $46ce675f07822b98$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $7PdBe.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $892645e7859416d3$var$useInsertionEffect = $7PdBe[" useInsertionEffect ".trim().toString()] || (0, $b50e35dc615f2236$export$e5c5a5f917a5871c);
function $892645e7859416d3$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $892645e7859416d3$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $7PdBe.useRef(prop !== void 0);
        $7PdBe.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $7PdBe.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $892645e7859416d3$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $892645e7859416d3$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $7PdBe.useState(defaultProp);
    const prevValueRef = $7PdBe.useRef(value);
    const onChangeRef = $7PdBe.useRef(onChange);
    $892645e7859416d3$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $7PdBe.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $892645e7859416d3$var$isFunction(value) {
    return typeof value === "function";
}
var $892645e7859416d3$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $892645e7859416d3$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $46ce675f07822b98$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $7PdBe.useRef(controlledState !== void 0);
        $7PdBe.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $7PdBe.useReducer((state2, action)=>{
        if (action.type === $892645e7859416d3$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $7PdBe.useRef(uncontrolledState);
    $7PdBe.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $7PdBe.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $7PdBe.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $892645e7859416d3$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



// packages/react/use-previous/src/use-previous.tsx

var $7PdBe = parcelRequire("7PdBe");
function $3c07d3728496d837$export$5cae361ad82dce8b(value) {
    const ref = $7PdBe.useRef({
        value: value,
        previous: value
    });
    return $7PdBe.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}


// src/visually-hidden.tsx

var $7PdBe = parcelRequire("7PdBe");


var $hvk62 = parcelRequire("hvk62");
var $f70a3173a8902d58$export$f23ec2f542b3b173 = Object.freeze({
    // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
});
var $f70a3173a8902d58$var$NAME = "VisuallyHidden";
var $f70a3173a8902d58$export$439d29a4e110a164 = $7PdBe.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
        ...props,
        ref: forwardedRef,
        style: {
            ...$f70a3173a8902d58$export$f23ec2f542b3b173,
            ...props.style
        }
    });
});
$f70a3173a8902d58$export$439d29a4e110a164.displayName = $f70a3173a8902d58$var$NAME;
var $f70a3173a8902d58$export$be92b6f5f03c0fe9 = $f70a3173a8902d58$export$439d29a4e110a164;


var $8f3a43ac6049bac0$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $8f3a43ac6049bac0$var$counterMap = new WeakMap();
var $8f3a43ac6049bac0$var$uncontrolledNodes = new WeakMap();
var $8f3a43ac6049bac0$var$markerMap = {};
var $8f3a43ac6049bac0$var$lockCount = 0;
var $8f3a43ac6049bac0$var$unwrapHost = function(node) {
    return node && (node.host || $8f3a43ac6049bac0$var$unwrapHost(node.parentNode));
};
var $8f3a43ac6049bac0$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $8f3a43ac6049bac0$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $8f3a43ac6049bac0$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $8f3a43ac6049bac0$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$8f3a43ac6049bac0$var$markerMap[markerName]) $8f3a43ac6049bac0$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $8f3a43ac6049bac0$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($8f3a43ac6049bac0$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $8f3a43ac6049bac0$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $8f3a43ac6049bac0$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $8f3a43ac6049bac0$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $8f3a43ac6049bac0$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $8f3a43ac6049bac0$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$8f3a43ac6049bac0$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $8f3a43ac6049bac0$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $8f3a43ac6049bac0$var$lockCount--;
        if (!$8f3a43ac6049bac0$var$lockCount) {
            // clear
            $8f3a43ac6049bac0$var$counterMap = new WeakMap();
            $8f3a43ac6049bac0$var$counterMap = new WeakMap();
            $8f3a43ac6049bac0$var$uncontrolledNodes = new WeakMap();
            $8f3a43ac6049bac0$var$markerMap = {};
        }
    };
};
var $8f3a43ac6049bac0$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $8f3a43ac6049bac0$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live], script")));
    return $8f3a43ac6049bac0$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $8f3a43ac6049bac0$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $8f3a43ac6049bac0$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $8f3a43ac6049bac0$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $8f3a43ac6049bac0$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $8f3a43ac6049bac0$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($8f3a43ac6049bac0$export$cc95fea82d705fca() ? $8f3a43ac6049bac0$export$59151cc8db999a24 : $8f3a43ac6049bac0$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $9b923e54ca454b1f$var$extendStatics = function(d, b) {
    $9b923e54ca454b1f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $9b923e54ca454b1f$var$extendStatics(d, b);
};
function $9b923e54ca454b1f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $9b923e54ca454b1f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9b923e54ca454b1f$export$18ce0697a983be9b = function() {
    $9b923e54ca454b1f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9b923e54ca454b1f$export$18ce0697a983be9b.apply(this, arguments);
};
function $9b923e54ca454b1f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9b923e54ca454b1f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9b923e54ca454b1f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9b923e54ca454b1f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $9b923e54ca454b1f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $9b923e54ca454b1f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $9b923e54ca454b1f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $9b923e54ca454b1f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9b923e54ca454b1f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9b923e54ca454b1f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $9b923e54ca454b1f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $9b923e54ca454b1f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $9b923e54ca454b1f$export$45d3717a4c69092e(o, m, p);
}
function $9b923e54ca454b1f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9b923e54ca454b1f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9b923e54ca454b1f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9b923e54ca454b1f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9b923e54ca454b1f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9b923e54ca454b1f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $9b923e54ca454b1f$export$10c90e4f7922046c(v) {
    return this instanceof $9b923e54ca454b1f$export$10c90e4f7922046c ? (this.v = v, this) : new $9b923e54ca454b1f$export$10c90e4f7922046c(v);
}
function $9b923e54ca454b1f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9b923e54ca454b1f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9b923e54ca454b1f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9b923e54ca454b1f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $9b923e54ca454b1f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9b923e54ca454b1f$export$19a8beecd37a4c45 === "function" ? $9b923e54ca454b1f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9b923e54ca454b1f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $9b923e54ca454b1f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $9b923e54ca454b1f$var$ownKeys = function(o) {
    $9b923e54ca454b1f$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $9b923e54ca454b1f$var$ownKeys(o);
};
function $9b923e54ca454b1f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $9b923e54ca454b1f$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9b923e54ca454b1f$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $9b923e54ca454b1f$var$__setModuleDefault(result, mod);
    return result;
}
function $9b923e54ca454b1f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9b923e54ca454b1f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9b923e54ca454b1f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $9b923e54ca454b1f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $9b923e54ca454b1f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $9b923e54ca454b1f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $9b923e54ca454b1f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $9b923e54ca454b1f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $9b923e54ca454b1f$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $9b923e54ca454b1f$export$2e2bcd8739ae039 = {
    __extends: $9b923e54ca454b1f$export$a8ba968b8961cb8a,
    __assign: $9b923e54ca454b1f$export$18ce0697a983be9b,
    __rest: $9b923e54ca454b1f$export$3c9a16f847548506,
    __decorate: $9b923e54ca454b1f$export$29e00dfd3077644b,
    __param: $9b923e54ca454b1f$export$d5ad3fd78186038f,
    __esDecorate: $9b923e54ca454b1f$export$3a84e1ae4e97e9b0,
    __runInitializers: $9b923e54ca454b1f$export$d831c04e792af3d,
    __propKey: $9b923e54ca454b1f$export$6a2a36740a146cb8,
    __setFunctionName: $9b923e54ca454b1f$export$d1a06452d3489bc7,
    __metadata: $9b923e54ca454b1f$export$f1db080c865becb9,
    __awaiter: $9b923e54ca454b1f$export$1050f835b63b671e,
    __generator: $9b923e54ca454b1f$export$67ebef60e6f28a6,
    __createBinding: $9b923e54ca454b1f$export$45d3717a4c69092e,
    __exportStar: $9b923e54ca454b1f$export$f33643c0debef087,
    __values: $9b923e54ca454b1f$export$19a8beecd37a4c45,
    __read: $9b923e54ca454b1f$export$8d051b38c9118094,
    __spread: $9b923e54ca454b1f$export$afc72e2116322959,
    __spreadArrays: $9b923e54ca454b1f$export$6388937ca91ccae8,
    __spreadArray: $9b923e54ca454b1f$export$1216008129fb82ed,
    __await: $9b923e54ca454b1f$export$10c90e4f7922046c,
    __asyncGenerator: $9b923e54ca454b1f$export$e427f37a30a4de9b,
    __asyncDelegator: $9b923e54ca454b1f$export$bbd80228419bb833,
    __asyncValues: $9b923e54ca454b1f$export$e3b29a3d6162315f,
    __makeTemplateObject: $9b923e54ca454b1f$export$4fb47efe1390b86f,
    __importStar: $9b923e54ca454b1f$export$c21735bcef00d192,
    __importDefault: $9b923e54ca454b1f$export$da59b14a69baef04,
    __classPrivateFieldGet: $9b923e54ca454b1f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $9b923e54ca454b1f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $9b923e54ca454b1f$export$81fdc39f203e4e04,
    __addDisposableResource: $9b923e54ca454b1f$export$88ac25d8e944e405,
    __disposeResources: $9b923e54ca454b1f$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $9b923e54ca454b1f$export$889dfb5d17574b0b
};



var $7PdBe = parcelRequire("7PdBe");


var $7PdBe = parcelRequire("7PdBe");
var $0f3726250160e434$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $0f3726250160e434$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $0f3726250160e434$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $0f3726250160e434$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $7PdBe = parcelRequire("7PdBe");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $28c21117cd4829a4$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $7PdBe = parcelRequire("7PdBe");
function $227989df00e7ba67$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $7PdBe.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1563c246d30d5626$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $7PdBe.useLayoutEffect : $7PdBe.useEffect;
var $1563c246d30d5626$var$currentValues = new WeakMap();
function $1563c246d30d5626$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $227989df00e7ba67$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $28c21117cd4829a4$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1563c246d30d5626$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1563c246d30d5626$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $28c21117cd4829a4$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $28c21117cd4829a4$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1563c246d30d5626$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $ad7f63ddb38a5aba$var$extendStatics = function(d, b) {
    $ad7f63ddb38a5aba$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ad7f63ddb38a5aba$var$extendStatics(d, b);
};
function $ad7f63ddb38a5aba$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ad7f63ddb38a5aba$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ad7f63ddb38a5aba$export$18ce0697a983be9b = function() {
    $ad7f63ddb38a5aba$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ad7f63ddb38a5aba$export$18ce0697a983be9b.apply(this, arguments);
};
function $ad7f63ddb38a5aba$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ad7f63ddb38a5aba$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ad7f63ddb38a5aba$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ad7f63ddb38a5aba$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ad7f63ddb38a5aba$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ad7f63ddb38a5aba$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ad7f63ddb38a5aba$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ad7f63ddb38a5aba$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ad7f63ddb38a5aba$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ad7f63ddb38a5aba$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ad7f63ddb38a5aba$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ad7f63ddb38a5aba$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ad7f63ddb38a5aba$export$45d3717a4c69092e(o, m, p);
}
function $ad7f63ddb38a5aba$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ad7f63ddb38a5aba$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ad7f63ddb38a5aba$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ad7f63ddb38a5aba$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ad7f63ddb38a5aba$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ad7f63ddb38a5aba$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ad7f63ddb38a5aba$export$10c90e4f7922046c(v) {
    return this instanceof $ad7f63ddb38a5aba$export$10c90e4f7922046c ? (this.v = v, this) : new $ad7f63ddb38a5aba$export$10c90e4f7922046c(v);
}
function $ad7f63ddb38a5aba$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ad7f63ddb38a5aba$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ad7f63ddb38a5aba$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ad7f63ddb38a5aba$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ad7f63ddb38a5aba$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ad7f63ddb38a5aba$export$19a8beecd37a4c45 === "function" ? $ad7f63ddb38a5aba$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ad7f63ddb38a5aba$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ad7f63ddb38a5aba$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $ad7f63ddb38a5aba$var$ownKeys = function(o) {
    $ad7f63ddb38a5aba$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $ad7f63ddb38a5aba$var$ownKeys(o);
};
function $ad7f63ddb38a5aba$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $ad7f63ddb38a5aba$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $ad7f63ddb38a5aba$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $ad7f63ddb38a5aba$var$__setModuleDefault(result, mod);
    return result;
}
function $ad7f63ddb38a5aba$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ad7f63ddb38a5aba$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ad7f63ddb38a5aba$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ad7f63ddb38a5aba$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ad7f63ddb38a5aba$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ad7f63ddb38a5aba$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ad7f63ddb38a5aba$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ad7f63ddb38a5aba$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $ad7f63ddb38a5aba$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $ad7f63ddb38a5aba$export$2e2bcd8739ae039 = {
    __extends: $ad7f63ddb38a5aba$export$a8ba968b8961cb8a,
    __assign: $ad7f63ddb38a5aba$export$18ce0697a983be9b,
    __rest: $ad7f63ddb38a5aba$export$3c9a16f847548506,
    __decorate: $ad7f63ddb38a5aba$export$29e00dfd3077644b,
    __param: $ad7f63ddb38a5aba$export$d5ad3fd78186038f,
    __esDecorate: $ad7f63ddb38a5aba$export$3a84e1ae4e97e9b0,
    __runInitializers: $ad7f63ddb38a5aba$export$d831c04e792af3d,
    __propKey: $ad7f63ddb38a5aba$export$6a2a36740a146cb8,
    __setFunctionName: $ad7f63ddb38a5aba$export$d1a06452d3489bc7,
    __metadata: $ad7f63ddb38a5aba$export$f1db080c865becb9,
    __awaiter: $ad7f63ddb38a5aba$export$1050f835b63b671e,
    __generator: $ad7f63ddb38a5aba$export$67ebef60e6f28a6,
    __createBinding: $ad7f63ddb38a5aba$export$45d3717a4c69092e,
    __exportStar: $ad7f63ddb38a5aba$export$f33643c0debef087,
    __values: $ad7f63ddb38a5aba$export$19a8beecd37a4c45,
    __read: $ad7f63ddb38a5aba$export$8d051b38c9118094,
    __spread: $ad7f63ddb38a5aba$export$afc72e2116322959,
    __spreadArrays: $ad7f63ddb38a5aba$export$6388937ca91ccae8,
    __spreadArray: $ad7f63ddb38a5aba$export$1216008129fb82ed,
    __await: $ad7f63ddb38a5aba$export$10c90e4f7922046c,
    __asyncGenerator: $ad7f63ddb38a5aba$export$e427f37a30a4de9b,
    __asyncDelegator: $ad7f63ddb38a5aba$export$bbd80228419bb833,
    __asyncValues: $ad7f63ddb38a5aba$export$e3b29a3d6162315f,
    __makeTemplateObject: $ad7f63ddb38a5aba$export$4fb47efe1390b86f,
    __importStar: $ad7f63ddb38a5aba$export$c21735bcef00d192,
    __importDefault: $ad7f63ddb38a5aba$export$da59b14a69baef04,
    __classPrivateFieldGet: $ad7f63ddb38a5aba$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ad7f63ddb38a5aba$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ad7f63ddb38a5aba$export$81fdc39f203e4e04,
    __addDisposableResource: $ad7f63ddb38a5aba$export$88ac25d8e944e405,
    __disposeResources: $ad7f63ddb38a5aba$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $ad7f63ddb38a5aba$export$889dfb5d17574b0b
};


function $839014ae5cea9a09$var$ItoI(a) {
    return a;
}
function $839014ae5cea9a09$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $839014ae5cea9a09$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $839014ae5cea9a09$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $839014ae5cea9a09$var$ItoI;
    return $839014ae5cea9a09$var$innerCreateMedium(defaults, middleware);
}
function $839014ae5cea9a09$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $839014ae5cea9a09$var$innerCreateMedium(null);
    medium.options = (0, $ad7f63ddb38a5aba$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $cde7f91dc24d2bd6$export$e27363444bedfeac = (0, $839014ae5cea9a09$export$e13ec7dd7a14088d)();


var $c3d68be8098e0983$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $c3d68be8098e0983$export$22940b497e769dee = $7PdBe.forwardRef(function(props, parentRef) {
    var ref = $7PdBe.useRef(null);
    var _a = $7PdBe.useState({
        onScrollCapture: $c3d68be8098e0983$var$nothing,
        onWheelCapture: $c3d68be8098e0983$var$nothing,
        onTouchMoveCapture: $c3d68be8098e0983$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $9b923e54ca454b1f$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1563c246d30d5626$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $9b923e54ca454b1f$export$18ce0697a983be9b)((0, $9b923e54ca454b1f$export$18ce0697a983be9b)({}, rest), callbacks);
    return $7PdBe.createElement($7PdBe.Fragment, null, enabled && $7PdBe.createElement(SideCar, {
        sideCar: (0, $cde7f91dc24d2bd6$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $7PdBe.cloneElement($7PdBe.Children.only(children), (0, $9b923e54ca454b1f$export$18ce0697a983be9b)((0, $9b923e54ca454b1f$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $7PdBe.createElement(Container, (0, $9b923e54ca454b1f$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$c3d68be8098e0983$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$c3d68be8098e0983$export$22940b497e769dee.classNames = {
    fullWidth: (0, $0f3726250160e434$export$898e37bbd2a0ae4e),
    zeroRight: (0, $0f3726250160e434$export$1da7500147d4bc3)
};




var $7PdBe = parcelRequire("7PdBe");
var $c4985be644c0deed$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $ad7f63ddb38a5aba$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $7PdBe.createElement(Target, (0, $ad7f63ddb38a5aba$export$18ce0697a983be9b)({}, rest));
};
$c4985be644c0deed$var$SideCar.isSideCarExport = true;
function $c4985be644c0deed$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c4985be644c0deed$var$SideCar;
}




var $7PdBe = parcelRequire("7PdBe");

var $7PdBe = parcelRequire("7PdBe");

var $7PdBe = parcelRequire("7PdBe");
var $0f978d92d04fb078$var$currentNonce;
var $0f978d92d04fb078$export$c5f670b24c0ae95a = function(nonce) {
    $0f978d92d04fb078$var$currentNonce = nonce;
};
var $0f978d92d04fb078$export$2b85b721e524d74b = function() {
    if ($0f978d92d04fb078$var$currentNonce) return $0f978d92d04fb078$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $7d6579f2bca601be$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $0f978d92d04fb078$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $7d6579f2bca601be$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $7d6579f2bca601be$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $7d6579f2bca601be$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $7d6579f2bca601be$var$makeStyleTag()) {
                    $7d6579f2bca601be$var$injectStyles(stylesheet, style);
                    $7d6579f2bca601be$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $775b4d4296f7af88$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $7d6579f2bca601be$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $7PdBe.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $0914c8aea0691a04$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $775b4d4296f7af88$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $d44f39656366a14d$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $d44f39656366a14d$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $d44f39656366a14d$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $d44f39656366a14d$var$parse(left),
        $d44f39656366a14d$var$parse(top),
        $d44f39656366a14d$var$parse(right)
    ];
};
var $d44f39656366a14d$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $d44f39656366a14d$export$efed13b5d0ca3386;
    var offsets = $d44f39656366a14d$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $ce3f6562a11475b1$var$Style = (0, $0914c8aea0691a04$export$c1248ee86ba532c8)();
var $ce3f6562a11475b1$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $ce3f6562a11475b1$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $0f3726250160e434$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($ce3f6562a11475b1$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $0f3726250160e434$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $0f3726250160e434$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $0f3726250160e434$export$1da7500147d4bc3), " .").concat((0, $0f3726250160e434$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $0f3726250160e434$export$898e37bbd2a0ae4e), " .").concat((0, $0f3726250160e434$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($ce3f6562a11475b1$export$65254d5f26cb9564, "] {\n    ").concat((0, $0f3726250160e434$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $ce3f6562a11475b1$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($ce3f6562a11475b1$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $ce3f6562a11475b1$export$a1939b1f9f9b02dc = function() {
    $7PdBe.useEffect(function() {
        document.body.setAttribute($ce3f6562a11475b1$export$65254d5f26cb9564, ($ce3f6562a11475b1$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $ce3f6562a11475b1$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($ce3f6562a11475b1$export$65254d5f26cb9564);
            else document.body.setAttribute($ce3f6562a11475b1$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $ce3f6562a11475b1$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $ce3f6562a11475b1$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $7PdBe.useMemo(function() {
        return (0, $d44f39656366a14d$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $7PdBe.createElement($ce3f6562a11475b1$var$Style, {
        styles: $ce3f6562a11475b1$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $968127847ea099ce$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $968127847ea099ce$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $968127847ea099ce$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $968127847ea099ce$var$options, $968127847ea099ce$var$options);
    // @ts-ignore
    window.removeEventListener("test", $968127847ea099ce$var$options, $968127847ea099ce$var$options);
} catch (err) {
    $968127847ea099ce$var$passiveSupported = false;
}
var $968127847ea099ce$export$10a6e88623fa9454 = $968127847ea099ce$var$passiveSupported ? {
    passive: false
} : false;


var $7b25e801d3c64a91$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $7b25e801d3c64a91$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$7b25e801d3c64a91$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $7b25e801d3c64a91$var$elementCouldBeVScrolled = function(node) {
    return $7b25e801d3c64a91$var$elementCanBeScrolled(node, "overflowY");
};
var $7b25e801d3c64a91$var$elementCouldBeHScrolled = function(node) {
    return $7b25e801d3c64a91$var$elementCanBeScrolled(node, "overflowX");
};
var $7b25e801d3c64a91$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $7b25e801d3c64a91$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $7b25e801d3c64a91$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $7b25e801d3c64a91$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $7b25e801d3c64a91$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $7b25e801d3c64a91$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $7b25e801d3c64a91$var$elementCouldBeVScrolled(node) : $7b25e801d3c64a91$var$elementCouldBeHScrolled(node);
};
var $7b25e801d3c64a91$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $7b25e801d3c64a91$var$getVScrollVariables(node) : $7b25e801d3c64a91$var$getHScrollVariables(node);
};
var $7b25e801d3c64a91$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $7b25e801d3c64a91$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $7b25e801d3c64a91$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $7b25e801d3c64a91$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($7b25e801d3c64a91$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $d8536bab9e655a75$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $d8536bab9e655a75$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $d8536bab9e655a75$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $d8536bab9e655a75$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $d8536bab9e655a75$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $d8536bab9e655a75$var$idCounter = 0;
var $d8536bab9e655a75$var$lockStack = [];
function $d8536bab9e655a75$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $7PdBe.useRef([]);
    var touchStartRef = $7PdBe.useRef([
        0,
        0
    ]);
    var activeAxis = $7PdBe.useRef();
    var id = $7PdBe.useState($d8536bab9e655a75$var$idCounter++)[0];
    var Style = $7PdBe.useState((0, $0914c8aea0691a04$export$c1248ee86ba532c8))[0];
    var lastProps = $7PdBe.useRef(props);
    $7PdBe.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $7PdBe.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $9b923e54ca454b1f$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($d8536bab9e655a75$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $7PdBe.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $d8536bab9e655a75$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $7b25e801d3c64a91$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $7b25e801d3c64a91$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $7b25e801d3c64a91$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $7PdBe.useCallback(function(_event) {
        var event = _event;
        if (!$d8536bab9e655a75$var$lockStack.length || $d8536bab9e655a75$var$lockStack[$d8536bab9e655a75$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $d8536bab9e655a75$export$39efaa2ca254a28d(event) : $d8536bab9e655a75$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $d8536bab9e655a75$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($d8536bab9e655a75$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $7PdBe.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $d8536bab9e655a75$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $7PdBe.useCallback(function(event) {
        touchStartRef.current = $d8536bab9e655a75$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $7PdBe.useCallback(function(event) {
        shouldCancel(event.type, $d8536bab9e655a75$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $7PdBe.useCallback(function(event) {
        shouldCancel(event.type, $d8536bab9e655a75$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $7PdBe.useEffect(function() {
        $d8536bab9e655a75$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $968127847ea099ce$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $968127847ea099ce$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $968127847ea099ce$export$10a6e88623fa9454));
        return function() {
            $d8536bab9e655a75$var$lockStack = $d8536bab9e655a75$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $968127847ea099ce$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $968127847ea099ce$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $968127847ea099ce$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $7PdBe.createElement($7PdBe.Fragment, null, inert ? $7PdBe.createElement(Style, {
        styles: $d8536bab9e655a75$var$generateStyle(id)
    }) : null, removeScrollBar ? $7PdBe.createElement((0, $ce3f6562a11475b1$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $d8536bab9e655a75$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $4242419b3b7cf701$export$2e2bcd8739ae039 = (0, $c4985be644c0deed$export$6cacc8fb0a9b94ce)((0, $cde7f91dc24d2bd6$export$e27363444bedfeac), (0, $d8536bab9e655a75$export$a09dbff87b5da2d));


var $b3721a98528862e1$var$ReactRemoveScroll = $7PdBe.forwardRef(function(props, ref) {
    return $7PdBe.createElement((0, $c3d68be8098e0983$export$22940b497e769dee), (0, $9b923e54ca454b1f$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $4242419b3b7cf701$export$2e2bcd8739ae039)
    }));
});
$b3721a98528862e1$var$ReactRemoveScroll.classNames = (0, $c3d68be8098e0983$export$22940b497e769dee).classNames;
var $b3721a98528862e1$export$2e2bcd8739ae039 = $b3721a98528862e1$var$ReactRemoveScroll;



var $hvk62 = parcelRequire("hvk62");
"use client";
var $97fa768cc4dabf19$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
var $97fa768cc4dabf19$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
var $97fa768cc4dabf19$var$SELECT_NAME = "Select";
var [$97fa768cc4dabf19$var$Collection, $97fa768cc4dabf19$var$useCollection, $97fa768cc4dabf19$var$createCollectionScope] = (0, $63e4826237d580a4$export$c74125a8e3af6bb2)($97fa768cc4dabf19$var$SELECT_NAME);
var [$97fa768cc4dabf19$var$createSelectContext, $97fa768cc4dabf19$export$286727a75dc039bd] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)($97fa768cc4dabf19$var$SELECT_NAME, [
    $97fa768cc4dabf19$var$createCollectionScope,
    (0, $138fccadffc9ae29$export$722aac194ae923)
]);
var $97fa768cc4dabf19$var$usePopperScope = (0, $138fccadffc9ae29$export$722aac194ae923)();
var [$97fa768cc4dabf19$var$SelectProvider, $97fa768cc4dabf19$var$useSelectContext] = $97fa768cc4dabf19$var$createSelectContext($97fa768cc4dabf19$var$SELECT_NAME);
var [$97fa768cc4dabf19$var$SelectNativeOptionsProvider, $97fa768cc4dabf19$var$useSelectNativeOptionsContext] = $97fa768cc4dabf19$var$createSelectContext($97fa768cc4dabf19$var$SELECT_NAME);
var $97fa768cc4dabf19$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required, form: form } = props;
    const popperScope = $97fa768cc4dabf19$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = $7PdBe.useState(null);
    const [valueNode, setValueNode] = $7PdBe.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = $7PdBe.useState(false);
    const direction = (0, $e77fd31f81c27db6$export$b39126d51d94e6f3)(dir);
    const [open, setOpen] = (0, $892645e7859416d3$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $97fa768cc4dabf19$var$SELECT_NAME
    });
    const [value, setValue] = (0, $892645e7859416d3$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange,
        caller: $97fa768cc4dabf19$var$SELECT_NAME
    });
    const triggerPointerDownPosRef = $7PdBe.useRef(null);
    const isFormControl = trigger ? form || !!trigger.closest("form") : true;
    const [nativeOptionsSet, setNativeOptionsSet] = $7PdBe.useState(/* @__PURE__ */ new Set());
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($97fa768cc4dabf19$var$SelectProvider, {
            required: required,
            scope: __scopeSelect,
            trigger: trigger,
            onTriggerChange: setTrigger,
            valueNode: valueNode,
            onValueNodeChange: setValueNode,
            valueNodeHasChildren: valueNodeHasChildren,
            onValueNodeHasChildrenChange: setValueNodeHasChildren,
            contentId: (0, $a2450a3e5d440835$export$f680877a34711e37)(),
            value: value,
            onValueChange: setValue,
            open: open,
            onOpenChange: setOpen,
            dir: direction,
            triggerPointerDownPosRef: triggerPointerDownPosRef,
            disabled: disabled,
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$Collection.Provider, {
                    scope: __scopeSelect,
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectNativeOptionsProvider, {
                        scope: props.__scopeSelect,
                        onNativeOptionAdd: $7PdBe.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>new Set(prev).add(option));
                        }, []),
                        onNativeOptionRemove: $7PdBe.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>{
                                const optionsSet = new Set(prev);
                                optionsSet.delete(option);
                                return optionsSet;
                            });
                        }, []),
                        children: children
                    })
                }),
                isFormControl ? /* @__PURE__ */ (0, $hvk62.jsxs)($97fa768cc4dabf19$var$SelectBubbleInput, {
                    "aria-hidden": true,
                    required: required,
                    tabIndex: -1,
                    name: name,
                    autoComplete: autoComplete,
                    value: value,
                    onChange: (event)=>setValue(event.target.value),
                    disabled: disabled,
                    form: form,
                    children: [
                        value === void 0 ? /* @__PURE__ */ (0, $hvk62.jsx)("option", {
                            value: ""
                        }) : null,
                        Array.from(nativeOptionsSet)
                    ]
                }, nativeSelectKey) : null
            ]
        })
    });
};
$97fa768cc4dabf19$export$ef9b1a59e592288f.displayName = $97fa768cc4dabf19$var$SELECT_NAME;
var $97fa768cc4dabf19$var$TRIGGER_NAME = "SelectTrigger";
var $97fa768cc4dabf19$export$3ac1e88a1c0b9f1 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $97fa768cc4dabf19$var$usePopperScope(__scopeSelect);
    const context = $97fa768cc4dabf19$var$useSelectContext($97fa768cc4dabf19$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $97fa768cc4dabf19$var$useCollection(__scopeSelect);
    const pointerTypeRef = $7PdBe.useRef("touch");
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $97fa768cc4dabf19$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $97fa768cc4dabf19$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== void 0) context.onValueChange(nextItem.value);
    });
    const handleOpen = (pointerEvent)=>{
        if (!isDisabled) {
            context.onOpenChange(true);
            resetTypeahead();
        }
        if (pointerEvent) context.triggerPointerDownPosRef.current = {
            x: Math.round(pointerEvent.pageX),
            y: Math.round(pointerEvent.pageY)
        };
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "combobox",
            "aria-controls": context.contentId,
            "aria-expanded": context.open,
            "aria-required": context.required,
            "aria-autocomplete": "none",
            dir: context.dir,
            "data-state": context.open ? "open" : "closed",
            disabled: isDisabled,
            "data-disabled": isDisabled ? "" : void 0,
            "data-placeholder": $97fa768cc4dabf19$var$shouldShowPlaceholder(context.value) ? "" : void 0,
            ...triggerProps,
            ref: composedRefs,
            onClick: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
                event.currentTarget.focus();
                if (pointerTypeRef.current !== "mouse") handleOpen(event);
            }),
            onPointerDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
                pointerTypeRef.current = event.pointerType;
                const target = event.target;
                if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
                if (event.button === 0 && event.ctrlKey === false && event.pointerType === "mouse") {
                    handleOpen(event);
                    event.preventDefault();
                }
            }),
            onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
                const isTypingAhead = searchRef.current !== "";
                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                if (isTypingAhead && event.key === " ") return;
                if ($97fa768cc4dabf19$var$OPEN_KEYS.includes(event.key)) {
                    handleOpen();
                    event.preventDefault();
                }
            })
        })
    });
});
$97fa768cc4dabf19$export$3ac1e88a1c0b9f1.displayName = $97fa768cc4dabf19$var$TRIGGER_NAME;
var $97fa768cc4dabf19$var$VALUE_NAME = "SelectValue";
var $97fa768cc4dabf19$export$e288731fd71264f0 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "", ...valueProps } = props;
    const context = $97fa768cc4dabf19$var$useSelectContext($97fa768cc4dabf19$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== void 0;
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
        ...valueProps,
        ref: composedRefs,
        style: {
            pointerEvents: "none"
        },
        children: $97fa768cc4dabf19$var$shouldShowPlaceholder(context.value) ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $hvk62.Fragment), {
            children: placeholder
        }) : children
    });
});
$97fa768cc4dabf19$export$e288731fd71264f0.displayName = $97fa768cc4dabf19$var$VALUE_NAME;
var $97fa768cc4dabf19$var$ICON_NAME = "SelectIcon";
var $97fa768cc4dabf19$export$99b400cabb58c515 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...iconProps,
        ref: forwardedRef,
        children: children || "\u25BC"
    });
});
$97fa768cc4dabf19$export$99b400cabb58c515.displayName = $97fa768cc4dabf19$var$ICON_NAME;
var $97fa768cc4dabf19$var$PORTAL_NAME = "SelectPortal";
var $97fa768cc4dabf19$export$b2af6c9944296213 = (props)=>{
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $fa484e2fa46a4ad3$export$602eac185826482c), {
        asChild: true,
        ...props
    });
};
$97fa768cc4dabf19$export$b2af6c9944296213.displayName = $97fa768cc4dabf19$var$PORTAL_NAME;
var $97fa768cc4dabf19$var$CONTENT_NAME = "SelectContent";
var $97fa768cc4dabf19$export$c973a4b3cb86a03d = $7PdBe.forwardRef((props, forwardedRef)=>{
    const context = $97fa768cc4dabf19$var$useSelectContext($97fa768cc4dabf19$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = $7PdBe.useState();
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? $1cUCD.createPortal(/* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectContentProvider, {
            scope: props.__scopeSelect,
            children: /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$Collection.Slot, {
                scope: props.__scopeSelect,
                children: /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                    children: props.children
                })
            })
        }), frag) : null;
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectContentImpl, {
        ...props,
        ref: forwardedRef
    });
});
$97fa768cc4dabf19$export$c973a4b3cb86a03d.displayName = $97fa768cc4dabf19$var$CONTENT_NAME;
var $97fa768cc4dabf19$var$CONTENT_MARGIN = 10;
var [$97fa768cc4dabf19$var$SelectContentProvider, $97fa768cc4dabf19$var$useSelectContentContext] = $97fa768cc4dabf19$var$createSelectContext($97fa768cc4dabf19$var$CONTENT_NAME);
var $97fa768cc4dabf19$var$CONTENT_IMPL_NAME = "SelectContentImpl";
var $97fa768cc4dabf19$var$Slot = (0, $0deb3a18aa385379$export$e88b45bda5c13eb9)("SelectContent.RemoveScroll");
var $97fa768cc4dabf19$var$SelectContentImpl = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: //
    // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, //
    ...contentProps } = props;
    const context = $97fa768cc4dabf19$var$useSelectContext($97fa768cc4dabf19$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = $7PdBe.useState(null);
    const [viewport, setViewport] = $7PdBe.useState(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = $7PdBe.useState(null);
    const [selectedItemText, setSelectedItemText] = $7PdBe.useState(null);
    const getItems = $97fa768cc4dabf19$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = $7PdBe.useState(false);
    const firstValidItemFoundRef = $7PdBe.useRef(false);
    $7PdBe.useEffect(()=>{
        if (content) return (0, $8f3a43ac6049bac0$export$6e33d16126ed003c)(content);
    }, [
        content
    ]);
    (0, $0c9b2820b9ffd5a2$export$b7ece24a22aeda8c)();
    const focusFirst = $7PdBe.useCallback((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate?.scrollIntoView({
                block: "nearest"
            });
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate?.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = $7PdBe.useCallback(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]);
    $7PdBe.useEffect(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]);
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    $7PdBe.useEffect(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - (triggerPointerDownPosRef.current?.x ?? 0)),
                    y: Math.abs(Math.round(event.pageY) - (triggerPointerDownPosRef.current?.y ?? 0))
                };
            };
            const handlePointerUp = (event)=>{
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    $7PdBe.useEffect(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $97fa768cc4dabf19$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $97fa768cc4dabf19$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = $7PdBe.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = $7PdBe.useCallback(()=>content?.focus(), [
        content
    ]);
    const itemTextRefCallback = $7PdBe.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $97fa768cc4dabf19$var$SelectPopperPosition : $97fa768cc4dabf19$var$SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === $97fa768cc4dabf19$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $b3721a98528862e1$export$2e2bcd8739ae039), {
            as: $97fa768cc4dabf19$var$Slot,
            allowPinchZoom: true,
            children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $10a485d4fe8e4da1$export$20e40289641fbbb6), {
                asChild: true,
                trapped: context.open,
                onMountAutoFocus: (event)=>{
                    event.preventDefault();
                },
                onUnmountAutoFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
                    context.trigger?.focus({
                        preventScroll: true
                    });
                    event.preventDefault();
                }),
                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $f890894e21f3588e$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: true,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: (event)=>event.preventDefault(),
                    onDismiss: ()=>context.onOpenChange(false),
                    children: /* @__PURE__ */ (0, $hvk62.jsx)(SelectPosition, {
                        role: "listbox",
                        id: context.contentId,
                        "data-state": context.open ? "open" : "closed",
                        dir: context.dir,
                        onContextMenu: (event)=>event.preventDefault(),
                        ...contentProps,
                        ...popperContentProps,
                        onPlaced: ()=>setIsPositioned(true),
                        ref: composedRefs,
                        style: {
                            // flex layout so we can place the scroll buttons properly
                            display: "flex",
                            flexDirection: "column",
                            // reset the outline by default as the content MAY get focused
                            outline: "none",
                            ...contentProps.style
                        },
                        onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                            if ([
                                "ArrowUp",
                                "ArrowDown",
                                "Home",
                                "End"
                            ].includes(event.key)) {
                                const items = getItems().filter((item)=>!item.disabled);
                                let candidateNodes = items.map((item)=>item.ref.current);
                                if ([
                                    "ArrowUp",
                                    "End"
                                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                                if ([
                                    "ArrowUp",
                                    "ArrowDown"
                                ].includes(event.key)) {
                                    const currentElement = event.target;
                                    const currentIndex = candidateNodes.indexOf(currentElement);
                                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                                }
                                setTimeout(()=>focusFirst(candidateNodes));
                                event.preventDefault();
                            }
                        })
                    })
                })
            })
        })
    });
});
$97fa768cc4dabf19$var$SelectContentImpl.displayName = $97fa768cc4dabf19$var$CONTENT_IMPL_NAME;
var $97fa768cc4dabf19$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var $97fa768cc4dabf19$var$SelectItemAlignedPosition = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $97fa768cc4dabf19$var$useSelectContext($97fa768cc4dabf19$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $97fa768cc4dabf19$var$useSelectContentContext($97fa768cc4dabf19$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = $7PdBe.useState(null);
    const [content, setContent] = $7PdBe.useState(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $97fa768cc4dabf19$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = $7PdBe.useRef(false);
    const shouldRepositionRef = $7PdBe.useRef(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = $7PdBe.useCallback(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $97fa768cc4dabf19$var$CONTENT_MARGIN;
                const clampedLeft = (0, $16194be29f19938e$export$7d15b64cf5a3a4c4)(left, [
                    $97fa768cc4dabf19$var$CONTENT_MARGIN,
                    // Prevents the content from going off the starting edge of the
                    // viewport. It may still go off the ending edge, but this can be
                    // controlled by the user since they may want to manage overflow in a
                    // specific way.
                    // https://github.com/radix-ui/primitives/issues/2049
                    Math.max($97fa768cc4dabf19$var$CONTENT_MARGIN, rightEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $97fa768cc4dabf19$var$CONTENT_MARGIN;
                const clampedRight = (0, $16194be29f19938e$export$7d15b64cf5a3a4c4)(right, [
                    $97fa768cc4dabf19$var$CONTENT_MARGIN,
                    Math.max($97fa768cc4dabf19$var$CONTENT_MARGIN, leftEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            }
            const items = getItems();
            const availableHeight = window.innerHeight - $97fa768cc4dabf19$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $97fa768cc4dabf19$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = items.length > 0 && selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
                (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = items.length > 0 && selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
                (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$97fa768cc4dabf19$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px";
            onPlaced?.();
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]);
    const [contentZIndex, setContentZIndex] = $7PdBe.useState();
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const handleScrollButtonChange = $7PdBe.useCallback((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem?.();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange,
        children: /* @__PURE__ */ (0, $hvk62.jsx)("div", {
            ref: setContentWrapper,
            style: {
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                zIndex: contentZIndex
            },
            children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
                ...popperProps,
                ref: composedRefs,
                style: {
                    // When we get the height of the content, it includes borders. If we were to set
                    // the height without having `boxSizing: 'border-box'` it would be too big.
                    boxSizing: "border-box",
                    // We need to ensure the content doesn't get taller than the wrapper
                    maxHeight: "100%",
                    ...popperProps.style
                }
            })
        })
    });
});
$97fa768cc4dabf19$var$SelectItemAlignedPosition.displayName = $97fa768cc4dabf19$var$ITEM_ALIGNED_POSITION_NAME;
var $97fa768cc4dabf19$var$POPPER_POSITION_NAME = "SelectPopperPosition";
var $97fa768cc4dabf19$var$SelectPopperPosition = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $97fa768cc4dabf19$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $97fa768cc4dabf19$var$usePopperScope(__scopeSelect);
    return /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$7c6e2c02157bb7d2, {
        ...popperScope,
        ...popperProps,
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$97fa768cc4dabf19$var$SelectPopperPosition.displayName = $97fa768cc4dabf19$var$POPPER_POSITION_NAME;
var [$97fa768cc4dabf19$var$SelectViewportProvider, $97fa768cc4dabf19$var$useSelectViewportContext] = $97fa768cc4dabf19$var$createSelectContext($97fa768cc4dabf19$var$CONTENT_NAME, {});
var $97fa768cc4dabf19$var$VIEWPORT_NAME = "SelectViewport";
var $97fa768cc4dabf19$export$9ed6e7b40248d36d = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, nonce: nonce, ...viewportProps } = props;
    const contentContext = $97fa768cc4dabf19$var$useSelectContentContext($97fa768cc4dabf19$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $97fa768cc4dabf19$var$useSelectViewportContext($97fa768cc4dabf19$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = $7PdBe.useRef(0);
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$Collection.Slot, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
                    "data-radix-select-viewport": "",
                    role: "presentation",
                    ...viewportProps,
                    ref: composedRefs,
                    style: {
                        // we use position: 'relative' here on the `viewport` so that when we call
                        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
                        // (independent of the scrollUpButton).
                        position: "relative",
                        flex: 1,
                        // Viewport should only be scrollable in the vertical direction.
                        // This won't work in vertical writing modes, so we'll need to
                        // revisit this if/when that is supported
                        // https://developer.chrome.com/blog/vertical-form-controls
                        overflow: "hidden auto",
                        ...viewportProps.style
                    },
                    onScroll: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
                        const viewport = event.currentTarget;
                        const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
                        if (shouldExpandOnScrollRef?.current && contentWrapper) {
                            const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                            if (scrolledBy > 0) {
                                const availableHeight = window.innerHeight - $97fa768cc4dabf19$var$CONTENT_MARGIN * 2;
                                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                                const cssHeight = parseFloat(contentWrapper.style.height);
                                const prevHeight = Math.max(cssMinHeight, cssHeight);
                                if (prevHeight < availableHeight) {
                                    const nextHeight = prevHeight + scrolledBy;
                                    const clampedNextHeight = Math.min(availableHeight, nextHeight);
                                    const heightDiff = nextHeight - clampedNextHeight;
                                    contentWrapper.style.height = clampedNextHeight + "px";
                                    if (contentWrapper.style.bottom === "0px") {
                                        viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                                        contentWrapper.style.justifyContent = "flex-end";
                                    }
                                }
                            }
                        }
                        prevScrollTopRef.current = viewport.scrollTop;
                    })
                })
            })
        ]
    });
});
$97fa768cc4dabf19$export$9ed6e7b40248d36d.displayName = $97fa768cc4dabf19$var$VIEWPORT_NAME;
var $97fa768cc4dabf19$var$GROUP_NAME = "SelectGroup";
var [$97fa768cc4dabf19$var$SelectGroupContextProvider, $97fa768cc4dabf19$var$useSelectGroupContext] = $97fa768cc4dabf19$var$createSelectContext($97fa768cc4dabf19$var$GROUP_NAME);
var $97fa768cc4dabf19$export$ee25a334c55de1f4 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $a2450a3e5d440835$export$f680877a34711e37)();
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
            role: "group",
            "aria-labelledby": groupId,
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$97fa768cc4dabf19$export$ee25a334c55de1f4.displayName = $97fa768cc4dabf19$var$GROUP_NAME;
var $97fa768cc4dabf19$var$LABEL_NAME = "SelectLabel";
var $97fa768cc4dabf19$export$f67338d29bd972f8 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $97fa768cc4dabf19$var$useSelectGroupContext($97fa768cc4dabf19$var$LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        id: groupContext.id,
        ...labelProps,
        ref: forwardedRef
    });
});
$97fa768cc4dabf19$export$f67338d29bd972f8.displayName = $97fa768cc4dabf19$var$LABEL_NAME;
var $97fa768cc4dabf19$var$ITEM_NAME = "SelectItem";
var [$97fa768cc4dabf19$var$SelectItemContextProvider, $97fa768cc4dabf19$var$useSelectItemContext] = $97fa768cc4dabf19$var$createSelectContext($97fa768cc4dabf19$var$ITEM_NAME);
var $97fa768cc4dabf19$export$13ef48a934230896 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $97fa768cc4dabf19$var$useSelectContext($97fa768cc4dabf19$var$ITEM_NAME, __scopeSelect);
    const contentContext = $97fa768cc4dabf19$var$useSelectContentContext($97fa768cc4dabf19$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = $7PdBe.useState(textValueProp ?? "");
    const [isFocused, setIsFocused] = $7PdBe.useState(false);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>contentContext.itemRefCallback?.(node, value, disabled));
    const textId = (0, $a2450a3e5d440835$export$f680877a34711e37)();
    const pointerTypeRef = $7PdBe.useRef("touch");
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: $7PdBe.useCallback((node)=>{
            setTextValue((prevTextValue)=>prevTextValue || (node?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$Collection.ItemSlot, {
            scope: __scopeSelect,
            value: value,
            disabled: disabled,
            textValue: textValue,
            children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1,
                ...itemProps,
                ref: composedRefs,
                onFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
                onClick: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(itemProps.onClick, ()=>{
                    if (pointerTypeRef.current !== "mouse") handleSelect();
                }),
                onPointerUp: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(itemProps.onPointerUp, ()=>{
                    if (pointerTypeRef.current === "mouse") handleSelect();
                }),
                onPointerDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(itemProps.onPointerDown, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                }),
                onPointerMove: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                    if (disabled) contentContext.onItemLeave?.();
                    else if (pointerTypeRef.current === "mouse") event.currentTarget.focus({
                        preventScroll: true
                    });
                }),
                onPointerLeave: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
                    if (event.currentTarget === document.activeElement) contentContext.onItemLeave?.();
                }),
                onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
                    const isTypingAhead = contentContext.searchRef?.current !== "";
                    if (isTypingAhead && event.key === " ") return;
                    if ($97fa768cc4dabf19$var$SELECTION_KEYS.includes(event.key)) handleSelect();
                    if (event.key === " ") event.preventDefault();
                })
            })
        })
    });
});
$97fa768cc4dabf19$export$13ef48a934230896.displayName = $97fa768cc4dabf19$var$ITEM_NAME;
var $97fa768cc4dabf19$var$ITEM_TEXT_NAME = "SelectItemText";
var $97fa768cc4dabf19$export$3572fb0fb821ff49 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $97fa768cc4dabf19$var$useSelectContext($97fa768cc4dabf19$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $97fa768cc4dabf19$var$useSelectContentContext($97fa768cc4dabf19$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $97fa768cc4dabf19$var$useSelectItemContext($97fa768cc4dabf19$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $97fa768cc4dabf19$var$useSelectNativeOptionsContext($97fa768cc4dabf19$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = $7PdBe.useState(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>contentContext.itemTextRefCallback?.(node, itemContext.value, itemContext.disabled));
    const textContent = itemTextNode?.textContent;
    const nativeOption = $7PdBe.useMemo(()=>/* @__PURE__ */ (0, $hvk62.jsx)("option", {
            value: itemContext.value,
            disabled: itemContext.disabled,
            children: textContent
        }, itemContext.value), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
                id: itemContext.textId,
                ...itemTextProps,
                ref: composedRefs
            }),
            itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? $1cUCD.createPortal(itemTextProps.children, context.valueNode) : null
        ]
    });
});
$97fa768cc4dabf19$export$3572fb0fb821ff49.displayName = $97fa768cc4dabf19$var$ITEM_TEXT_NAME;
var $97fa768cc4dabf19$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
var $97fa768cc4dabf19$export$6b9198de19accfe6 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $97fa768cc4dabf19$var$useSelectItemContext($97fa768cc4dabf19$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...itemIndicatorProps,
        ref: forwardedRef
    }) : null;
});
$97fa768cc4dabf19$export$6b9198de19accfe6.displayName = $97fa768cc4dabf19$var$ITEM_INDICATOR_NAME;
var $97fa768cc4dabf19$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var $97fa768cc4dabf19$export$d8117927658af6d7 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const contentContext = $97fa768cc4dabf19$var$useSelectContentContext($97fa768cc4dabf19$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $97fa768cc4dabf19$var$useSelectViewportContext($97fa768cc4dabf19$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp, setCanScrollUp] = $7PdBe.useState(false);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const canScrollUp2 = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp ? /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    }) : null;
});
$97fa768cc4dabf19$export$d8117927658af6d7.displayName = $97fa768cc4dabf19$var$SCROLL_UP_BUTTON_NAME;
var $97fa768cc4dabf19$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var $97fa768cc4dabf19$export$ff951e476c12189 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const contentContext = $97fa768cc4dabf19$var$useSelectContentContext($97fa768cc4dabf19$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $97fa768cc4dabf19$var$useSelectViewportContext($97fa768cc4dabf19$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown, setCanScrollDown] = $7PdBe.useState(false);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight;
                const canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown ? /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    }) : null;
});
$97fa768cc4dabf19$export$ff951e476c12189.displayName = $97fa768cc4dabf19$var$SCROLL_DOWN_BUTTON_NAME;
var $97fa768cc4dabf19$var$SelectScrollButtonImpl = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $97fa768cc4dabf19$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = $7PdBe.useRef(null);
    const getItems = $97fa768cc4dabf19$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = $7PdBe.useCallback(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    $7PdBe.useEffect(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem?.ref.current?.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...scrollIndicatorProps,
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            contentContext.onItemLeave?.();
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    });
});
var $97fa768cc4dabf19$var$SEPARATOR_NAME = "SelectSeparator";
var $97fa768cc4dabf19$export$eba4b1df07cb1d3 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...separatorProps,
        ref: forwardedRef
    });
});
$97fa768cc4dabf19$export$eba4b1df07cb1d3.displayName = $97fa768cc4dabf19$var$SEPARATOR_NAME;
var $97fa768cc4dabf19$var$ARROW_NAME = "SelectArrow";
var $97fa768cc4dabf19$export$314f4cb8f8099628 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $97fa768cc4dabf19$var$usePopperScope(__scopeSelect);
    const context = $97fa768cc4dabf19$var$useSelectContext($97fa768cc4dabf19$var$ARROW_NAME, __scopeSelect);
    const contentContext = $97fa768cc4dabf19$var$useSelectContentContext($97fa768cc4dabf19$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    }) : null;
});
$97fa768cc4dabf19$export$314f4cb8f8099628.displayName = $97fa768cc4dabf19$var$ARROW_NAME;
var $97fa768cc4dabf19$var$BUBBLE_INPUT_NAME = "SelectBubbleInput";
var $97fa768cc4dabf19$var$SelectBubbleInput = $7PdBe.forwardRef(({ __scopeSelect: __scopeSelect, value: value, ...props }, forwardedRef)=>{
    const ref = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $3c07d3728496d837$export$5cae361ad82dce8b)(value);
    $7PdBe.useEffect(()=>{
        const select = ref.current;
        if (!select) return;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).select, {
        ...props,
        style: {
            ...(0, $f70a3173a8902d58$export$f23ec2f542b3b173),
            ...props.style
        },
        ref: composedRefs,
        defaultValue: value
    });
});
$97fa768cc4dabf19$var$SelectBubbleInput.displayName = $97fa768cc4dabf19$var$BUBBLE_INPUT_NAME;
function $97fa768cc4dabf19$var$shouldShowPlaceholder(value) {
    return value === "" || value === void 0;
}
function $97fa768cc4dabf19$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = $7PdBe.useRef("");
    const timerRef = $7PdBe.useRef(0);
    const handleTypeaheadSearch = $7PdBe.useCallback((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = $7PdBe.useCallback(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    $7PdBe.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
function $97fa768cc4dabf19$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $97fa768cc4dabf19$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : void 0;
}
function $97fa768cc4dabf19$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $97fa768cc4dabf19$export$be92b6f5f03c0fe9 = $97fa768cc4dabf19$export$ef9b1a59e592288f;
var $97fa768cc4dabf19$export$41fb9f06171c75f4 = $97fa768cc4dabf19$export$3ac1e88a1c0b9f1;
var $97fa768cc4dabf19$export$4c8d1a57a761ef94 = $97fa768cc4dabf19$export$e288731fd71264f0;
var $97fa768cc4dabf19$export$f04a61298a47a40f = $97fa768cc4dabf19$export$99b400cabb58c515;
var $97fa768cc4dabf19$export$602eac185826482c = $97fa768cc4dabf19$export$b2af6c9944296213;
var $97fa768cc4dabf19$export$7c6e2c02157bb7d2 = $97fa768cc4dabf19$export$c973a4b3cb86a03d;
var $97fa768cc4dabf19$export$d5c6c08dc2d3ca7 = $97fa768cc4dabf19$export$9ed6e7b40248d36d;
var $97fa768cc4dabf19$export$eb2fcfdbd7ba97d4 = $97fa768cc4dabf19$export$ee25a334c55de1f4;
var $97fa768cc4dabf19$export$b04be29aa201d4f5 = $97fa768cc4dabf19$export$f67338d29bd972f8;
var $97fa768cc4dabf19$export$6d08773d2e66f8f2 = $97fa768cc4dabf19$export$13ef48a934230896;
var $97fa768cc4dabf19$export$d6e5bf9c43ea9319 = $97fa768cc4dabf19$export$3572fb0fb821ff49;
var $97fa768cc4dabf19$export$c3468e2714d175fa = $97fa768cc4dabf19$export$6b9198de19accfe6;
var $97fa768cc4dabf19$export$2f60d3ec9ad468f2 = $97fa768cc4dabf19$export$d8117927658af6d7;
var $97fa768cc4dabf19$export$bf1aedc3039c8d63 = $97fa768cc4dabf19$export$ff951e476c12189;
var $97fa768cc4dabf19$export$1ff3c3f08ae963c0 = $97fa768cc4dabf19$export$eba4b1df07cb1d3;
var $97fa768cc4dabf19$export$21b07c8f274aebd5 = $97fa768cc4dabf19$export$314f4cb8f8099628;


/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $7PdBe = parcelRequire("7PdBe");
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $2bb1e09f9a425862$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $2bb1e09f9a425862$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && array.indexOf(className) === index;
    }).join(" ");


/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $7PdBe = parcelRequire("7PdBe");
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $ee9637dff6dafb40$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $643532e038ccc1a5$export$2e2bcd8739ae039 = (0, $7PdBe.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $7PdBe.createElement)("svg", {
        ref: ref,
        ...(0, $ee9637dff6dafb40$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $2bb1e09f9a425862$export$3d46f4579dba46e5)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $7PdBe.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $d566ee6b21ad38ed$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $7PdBe.forwardRef)(({ className: className, ...props }, ref)=>(0, $7PdBe.createElement)((0, $643532e038ccc1a5$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $2bb1e09f9a425862$export$3d46f4579dba46e5)(`lucide-${(0, $2bb1e09f9a425862$export$73bda83cddbc7187)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};


const $bf8cdbeb7c4555a4$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Check", [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2b64d72813bd9423$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("ChevronDown", [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c92fa035e28749e7$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("ChevronUp", [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
]);




const $188abd732422c87b$export$ef9b1a59e592288f = $97fa768cc4dabf19$export$be92b6f5f03c0fe9;
const $188abd732422c87b$export$ee25a334c55de1f4 = $97fa768cc4dabf19$export$eb2fcfdbd7ba97d4;
const $188abd732422c87b$export$e288731fd71264f0 = $97fa768cc4dabf19$export$4c8d1a57a761ef94;
const $188abd732422c87b$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsxs)($97fa768cc4dabf19$export$41fb9f06171c75f4, {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$f04a61298a47a40f, {
                asChild: true,
                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $2b64d72813bd9423$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 opacity-50"
                })
            })
        ]
    }));
$188abd732422c87b$export$3ac1e88a1c0b9f1.displayName = $97fa768cc4dabf19$export$41fb9f06171c75f4.displayName;
const $188abd732422c87b$export$d8117927658af6d7 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$2f60d3ec9ad468f2, {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c92fa035e28749e7$export$2e2bcd8739ae039), {
            className: "h-4 w-4"
        })
    }));
$188abd732422c87b$export$d8117927658af6d7.displayName = $97fa768cc4dabf19$export$2f60d3ec9ad468f2.displayName;
const $188abd732422c87b$export$ff951e476c12189 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$bf1aedc3039c8d63, {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $2b64d72813bd9423$export$2e2bcd8739ae039), {
            className: "h-4 w-4"
        })
    }));
$188abd732422c87b$export$ff951e476c12189.displayName = $97fa768cc4dabf19$export$bf1aedc3039c8d63.displayName;
const $188abd732422c87b$export$c973a4b3cb86a03d = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, children: children, position: position = "popper", ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $RSSjA.jsxs)($97fa768cc4dabf19$export$7c6e2c02157bb7d2, {
            ref: ref,
            className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
            position: position,
            ...props,
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsx)($188abd732422c87b$export$d8117927658af6d7, {}),
                /*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$d5c6c08dc2d3ca7, {
                    className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"),
                    children: children
                }),
                /*#__PURE__*/ (0, $RSSjA.jsx)($188abd732422c87b$export$ff951e476c12189, {})
            ]
        })
    }));
$188abd732422c87b$export$c973a4b3cb86a03d.displayName = $97fa768cc4dabf19$export$7c6e2c02157bb7d2.displayName;
const $188abd732422c87b$export$f67338d29bd972f8 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$b04be29aa201d4f5, {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("py-1.5 pl-8 pr-2 text-sm font-semibold", className),
        ...props
    }));
$188abd732422c87b$export$f67338d29bd972f8.displayName = $97fa768cc4dabf19$export$b04be29aa201d4f5.displayName;
const $188abd732422c87b$export$13ef48a934230896 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsxs)($97fa768cc4dabf19$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$c3468e2714d175fa, {
                    children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $bf8cdbeb7c4555a4$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$d6e5bf9c43ea9319, {
                children: children
            })
        ]
    }));
$188abd732422c87b$export$13ef48a934230896.displayName = $97fa768cc4dabf19$export$6d08773d2e66f8f2.displayName;
const $188abd732422c87b$export$eba4b1df07cb1d3 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $RSSjA.jsx)($97fa768cc4dabf19$export$1ff3c3f08ae963c0, {
        ref: ref,
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    }));
$188abd732422c87b$export$eba4b1df07cb1d3.displayName = $97fa768cc4dabf19$export$1ff3c3f08ae963c0.displayName;
const $188abd732422c87b$export$2d49384d850eb0d6 = ({ defaultValue: defaultValue, value: value, onValueChange: onValueChange, options: options = [], placeholder: placeholder = "Select...", className: className, label: label, editable: editable = true })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)("flex items-center space-x-2", className),
        children: [
            label ? /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                children: label
            }) : null,
            /*#__PURE__*/ (0, $RSSjA.jsxs)($188abd732422c87b$export$ef9b1a59e592288f, {
                defaultValue: defaultValue,
                value: value,
                onValueChange: onValueChange,
                disabled: !editable,
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsx)($188abd732422c87b$export$3ac1e88a1c0b9f1, {
                        className: "w-[180px] mx-auto",
                        children: /*#__PURE__*/ (0, $RSSjA.jsx)($188abd732422c87b$export$e288731fd71264f0, {
                            placeholder: placeholder
                        })
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)($188abd732422c87b$export$c973a4b3cb86a03d, {
                        children: options.map((op)=>/*#__PURE__*/ (0, $RSSjA.jsx)($188abd732422c87b$export$13ef48a934230896, {
                                value: op === null || op === void 0 ? void 0 : op.value,
                                children: op === null || op === void 0 ? void 0 : op.label
                            }, op === null || op === void 0 ? void 0 : op.key))
                    })
                ]
            })
        ]
    });
};



var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");



const $80ce2cc30ed5cbab$export$dca1ee5a936bb312 = (0, $fabf324b0990a90a$export$87dc52566e90b739)("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
            outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "size-8"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $80ce2cc30ed5cbab$export$353f5b6fc5456de1 = /*#__PURE__*/ $7PdBe.forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $0deb3a18aa385379$export$be92b6f5f03c0fe9) : "button";
    return /*#__PURE__*/ (0, $RSSjA.jsx)(Comp, {
        className: (0, $6f9f216e765f1a15$export$1343a74baacb0543)($80ce2cc30ed5cbab$export$dca1ee5a936bb312({
            variant: variant,
            size: size,
            className: className
        })),
        ref: ref,
        ...props
    });
});
$80ce2cc30ed5cbab$export$353f5b6fc5456de1.displayName = "Button";



// src/lib/utils.ts


var $47f1291f3f379baa$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($47f1291f3f379baa$export$7debb50ef11d5e0b || ($47f1291f3f379baa$export$7debb50ef11d5e0b = {}));
var $47f1291f3f379baa$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($47f1291f3f379baa$export$4aa2142c225fd5c7 || ($47f1291f3f379baa$export$4aa2142c225fd5c7 = {}));
const $47f1291f3f379baa$export$5716da67bfaa244d = $47f1291f3f379baa$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $47f1291f3f379baa$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $47f1291f3f379baa$export$5716da67bfaa244d.undefined;
        case "string":
            return $47f1291f3f379baa$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $47f1291f3f379baa$export$5716da67bfaa244d.nan : $47f1291f3f379baa$export$5716da67bfaa244d.number;
        case "boolean":
            return $47f1291f3f379baa$export$5716da67bfaa244d.boolean;
        case "function":
            return $47f1291f3f379baa$export$5716da67bfaa244d.function;
        case "bigint":
            return $47f1291f3f379baa$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $47f1291f3f379baa$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $47f1291f3f379baa$export$5716da67bfaa244d.array;
            if (data === null) return $47f1291f3f379baa$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $47f1291f3f379baa$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $47f1291f3f379baa$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $47f1291f3f379baa$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $47f1291f3f379baa$export$5716da67bfaa244d.date;
            return $47f1291f3f379baa$export$5716da67bfaa244d.object;
        default:
            return $47f1291f3f379baa$export$5716da67bfaa244d.unknown;
    }
};


const $5dd06e68c444f991$export$5ba560653e4a1035 = (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $5dd06e68c444f991$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $5dd06e68c444f991$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $5dd06e68c444f991$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$5dd06e68c444f991$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $5dd06e68c444f991$export$f98dac4b251ab333(issues);
    return error;
};




const $c870a696813c56c0$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type:
            if (issue.received === (0, $47f1291f3f379baa$export$5716da67bfaa244d).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).jsonStringifyReplacer)}`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $47f1291f3f379baa$export$7debb50ef11d5e0b).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $47f1291f3f379baa$export$7debb50ef11d5e0b).joinValues(issue.options)}`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $47f1291f3f379baa$export$7debb50ef11d5e0b).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).custom:
            message = `Invalid input`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $5dd06e68c444f991$export$5ba560653e4a1035).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).assertNever(issue);
    }
    return {
        message: message
    };
};
var $c870a696813c56c0$export$2e2bcd8739ae039 = $c870a696813c56c0$var$errorMap;


let $297b3578b400e378$var$overrideErrorMap = (0, $c870a696813c56c0$export$2e2bcd8739ae039);
function $297b3578b400e378$export$1097a8289cfd22d7(map) {
    $297b3578b400e378$var$overrideErrorMap = map;
}
function $297b3578b400e378$export$32f27c719778d4c4() {
    return $297b3578b400e378$var$overrideErrorMap;
}


var $7232557b5e929743$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($7232557b5e929743$export$b9faa7f0c32cb80d || ($7232557b5e929743$export$b9faa7f0c32cb80d = {}));




const $4852d609824b6db6$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $4852d609824b6db6$export$1526d2e05f74572 = [];
function $4852d609824b6db6$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $297b3578b400e378$export$32f27c719778d4c4)();
    const issue = $4852d609824b6db6$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $c870a696813c56c0$export$2e2bcd8739ae039) ? undefined : (0, $c870a696813c56c0$export$2e2bcd8739ae039)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $4852d609824b6db6$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $4852d609824b6db6$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $4852d609824b6db6$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $4852d609824b6db6$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $4852d609824b6db6$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $4852d609824b6db6$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $4852d609824b6db6$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $4852d609824b6db6$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $4852d609824b6db6$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $4852d609824b6db6$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $4852d609824b6db6$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $4852d609824b6db6$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;



class $034fa980286ebb75$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $034fa980286ebb75$var$handleResult = (ctx, result)=>{
    if ((0, $4852d609824b6db6$export$1ea939691cdc45b8)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $5dd06e68c444f991$export$f98dac4b251ab333)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $034fa980286ebb75$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $47f1291f3f379baa$export$3e9057828ebd5c7a)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $47f1291f3f379baa$export$3e9057828ebd5c7a)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $47f1291f3f379baa$export$3e9057828ebd5c7a)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $4852d609824b6db6$export$aefee5ebe1dcfd9e)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $47f1291f3f379baa$export$3e9057828ebd5c7a)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $034fa980286ebb75$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $47f1291f3f379baa$export$3e9057828ebd5c7a)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $4852d609824b6db6$export$1ea939691cdc45b8)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $4852d609824b6db6$export$1ea939691cdc45b8)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $47f1291f3f379baa$export$3e9057828ebd5c7a)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $4852d609824b6db6$export$aefee5ebe1dcfd9e)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $034fa980286ebb75$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $034fa980286ebb75$export$a60af00cc0ce2582({
            schema: this,
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $034fa980286ebb75$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $034fa980286ebb75$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $034fa980286ebb75$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $034fa980286ebb75$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $034fa980286ebb75$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $034fa980286ebb75$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $034fa980286ebb75$export$a60af00cc0ce2582({
            ...$034fa980286ebb75$var$processCreateParams(this._def),
            schema: this,
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $034fa980286ebb75$export$bb19b37874861e7e({
            ...$034fa980286ebb75$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $034fa980286ebb75$export$66b0c798a395271f({
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$034fa980286ebb75$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $034fa980286ebb75$export$75a44ec6249ac76b({
            ...$034fa980286ebb75$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $034fa980286ebb75$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $034fa980286ebb75$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $034fa980286ebb75$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $034fa980286ebb75$var$cuid2Regex = /^[0-9a-z]+$/;
const $034fa980286ebb75$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $034fa980286ebb75$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $034fa980286ebb75$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $034fa980286ebb75$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $034fa980286ebb75$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $034fa980286ebb75$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $034fa980286ebb75$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $034fa980286ebb75$var$emojiRegex;
// faster, simpler, safer
const $034fa980286ebb75$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $034fa980286ebb75$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $034fa980286ebb75$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $034fa980286ebb75$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $034fa980286ebb75$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $034fa980286ebb75$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $034fa980286ebb75$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $034fa980286ebb75$var$dateRegex = new RegExp(`^${$034fa980286ebb75$var$dateRegexSource}$`);
function $034fa980286ebb75$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $034fa980286ebb75$var$timeRegex(args) {
    return new RegExp(`^${$034fa980286ebb75$var$timeRegexSource(args)}$`);
}
function $034fa980286ebb75$export$a4b563879add27a(args) {
    let regex = `${$034fa980286ebb75$var$dateRegexSource}T${$034fa980286ebb75$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $034fa980286ebb75$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $034fa980286ebb75$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $034fa980286ebb75$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $034fa980286ebb75$var$isValidJWT(jwt, alg) {
    if (!$034fa980286ebb75$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $034fa980286ebb75$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $034fa980286ebb75$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $034fa980286ebb75$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $034fa980286ebb75$export$1230eb29b8d3b502 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).string,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const status = new (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$034fa980286ebb75$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "email",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$034fa980286ebb75$var$emojiRegex) $034fa980286ebb75$var$emojiRegex = new RegExp($034fa980286ebb75$var$_emojiRegex, "u");
                if (!$034fa980286ebb75$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "emoji",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$034fa980286ebb75$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "uuid",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$034fa980286ebb75$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "nanoid",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$034fa980286ebb75$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "cuid",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$034fa980286ebb75$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "cuid2",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$034fa980286ebb75$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "ulid",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                    validation: "url",
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "regex",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $034fa980286ebb75$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $034fa980286ebb75$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $034fa980286ebb75$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$034fa980286ebb75$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "duration",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$034fa980286ebb75$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "ip",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$034fa980286ebb75$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "jwt",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$034fa980286ebb75$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "cidr",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$034fa980286ebb75$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "base64",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$034fa980286ebb75$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        validation: "base64url",
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_string,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $034fa980286ebb75$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message));
    }
    trim() {
        return new $034fa980286ebb75$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $034fa980286ebb75$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $034fa980286ebb75$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$034fa980286ebb75$export$1230eb29b8d3b502.create = (params)=>{
    return new $034fa980286ebb75$export$1230eb29b8d3b502({
        checks: [],
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $034fa980286ebb75$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $034fa980286ebb75$export$5b070a55c0c43e09 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).number,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $47f1291f3f379baa$export$7debb50ef11d5e0b).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($034fa980286ebb75$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $034fa980286ebb75$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $034fa980286ebb75$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$034fa980286ebb75$export$5b070a55c0c43e09.create = (params)=>{
    return new $034fa980286ebb75$export$5b070a55c0c43e09({
        checks: [],
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$67d741fd70ff98f4 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
            code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
            expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).bigint,
            received: ctx.parsedType
        });
        return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $034fa980286ebb75$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $034fa980286ebb75$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$034fa980286ebb75$export$67d741fd70ff98f4.create = (params)=>{
    return new $034fa980286ebb75$export$67d741fd70ff98f4({
        checks: [],
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$723d146f80596191 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).boolean,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
}
$034fa980286ebb75$export$723d146f80596191.create = (params)=>{
    return new $034fa980286ebb75$export$723d146f80596191({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$e974be33bdc55521 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).date,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_date
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const status = new (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $034fa980286ebb75$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$034fa980286ebb75$export$e974be33bdc55521.create = (params)=>{
    return new $034fa980286ebb75$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodDate,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$bcc3b40f6b638044 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).symbol,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
}
$034fa980286ebb75$export$bcc3b40f6b638044.create = (params)=>{
    return new $034fa980286ebb75$export$bcc3b40f6b638044({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodSymbol,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$4e780e961c30340d extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).undefined,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
}
$034fa980286ebb75$export$4e780e961c30340d.create = (params)=>{
    return new $034fa980286ebb75$export$4e780e961c30340d({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodUndefined,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$a96281f914484f2d extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).null,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
}
$034fa980286ebb75$export$a96281f914484f2d.create = (params)=>{
    return new $034fa980286ebb75$export$a96281f914484f2d({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodNull,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$b9d1edb536b4e4eb extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
}
$034fa980286ebb75$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $034fa980286ebb75$export$b9d1edb536b4e4eb({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodAny,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$ef3b1bb1630977ae extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
}
$034fa980286ebb75$export$ef3b1bb1630977ae.create = (params)=>{
    return new $034fa980286ebb75$export$ef3b1bb1630977ae({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodUnknown,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$1e576a20c3ce9fb5 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
            code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
            expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).never,
            received: ctx.parsedType
        });
        return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
    }
}
$034fa980286ebb75$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $034fa980286ebb75$export$1e576a20c3ce9fb5({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodNever,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$7d39f5df85f21031 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).void,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
}
$034fa980286ebb75$export$7d39f5df85f21031.create = (params)=>{
    return new $034fa980286ebb75$export$7d39f5df85f21031({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodVoid,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$7acfc3e64785411 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).array) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).array,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                    code: tooBig ? (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big : (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $034fa980286ebb75$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $034fa980286ebb75$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    length(len, message) {
        return new $034fa980286ebb75$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$034fa980286ebb75$export$7acfc3e64785411.create = (schema, params)=>{
    return new $034fa980286ebb75$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodArray,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
function $034fa980286ebb75$var$deepPartialify(schema) {
    if (schema instanceof $034fa980286ebb75$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $034fa980286ebb75$export$aa56fec1e9d629b8.create($034fa980286ebb75$var$deepPartialify(fieldSchema));
        }
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $034fa980286ebb75$export$7acfc3e64785411) return new $034fa980286ebb75$export$7acfc3e64785411({
        ...schema._def,
        type: $034fa980286ebb75$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $034fa980286ebb75$export$aa56fec1e9d629b8) return $034fa980286ebb75$export$aa56fec1e9d629b8.create($034fa980286ebb75$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $034fa980286ebb75$export$aaac0b8b429cef5) return $034fa980286ebb75$export$aaac0b8b429cef5.create($034fa980286ebb75$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $034fa980286ebb75$export$e2a18bb771d8e6a3) return $034fa980286ebb75$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$034fa980286ebb75$var$deepPartialify(item)));
    else return schema;
}
class $034fa980286ebb75$export$736315c5b55efbad extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $034fa980286ebb75$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $034fa980286ebb75$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                        code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f).mergeObjectSync(status, syncPairs);
        });
        else return (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj;
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $034fa980286ebb75$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $034fa980286ebb75$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $034fa980286ebb75$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $034fa980286ebb75$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $034fa980286ebb75$var$createZodEnum((0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectKeys(this.shape));
    }
}
$034fa980286ebb75$export$736315c5b55efbad.create = (shape, params)=>{
    return new $034fa980286ebb75$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $034fa980286ebb75$export$1e576a20c3ce9fb5.create(),
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodObject,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
$034fa980286ebb75$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $034fa980286ebb75$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $034fa980286ebb75$export$1e576a20c3ce9fb5.create(),
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodObject,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
$034fa980286ebb75$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $034fa980286ebb75$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $034fa980286ebb75$export$1e576a20c3ce9fb5.create(),
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodObject,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$a8b236cb5070a311 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $5dd06e68c444f991$export$f98dac4b251ab333)(result.ctx.common.issues));
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $5dd06e68c444f991$export$f98dac4b251ab333)(issues));
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$034fa980286ebb75$export$a8b236cb5070a311.create = (types, params)=>{
    return new $034fa980286ebb75$export$a8b236cb5070a311({
        options: types,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodUnion,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $034fa980286ebb75$var$getDiscriminator = (type)=>{
    if (type instanceof $034fa980286ebb75$export$378d0cfce37406e6) return $034fa980286ebb75$var$getDiscriminator(type.schema);
    else if (type instanceof $034fa980286ebb75$export$a60af00cc0ce2582) return $034fa980286ebb75$var$getDiscriminator(type.innerType());
    else if (type instanceof $034fa980286ebb75$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $034fa980286ebb75$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $034fa980286ebb75$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectValues(type.enum);
    else if (type instanceof $034fa980286ebb75$export$bb19b37874861e7e) return $034fa980286ebb75$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $034fa980286ebb75$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $034fa980286ebb75$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $034fa980286ebb75$export$aa56fec1e9d629b8) return [
        undefined,
        ...$034fa980286ebb75$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $034fa980286ebb75$export$aaac0b8b429cef5) return [
        null,
        ...$034fa980286ebb75$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $034fa980286ebb75$export$66b0c798a395271f) return $034fa980286ebb75$var$getDiscriminator(type.unwrap());
    else if (type instanceof $034fa980286ebb75$export$5d1f7ef05c4e493a) return $034fa980286ebb75$var$getDiscriminator(type.unwrap());
    else if (type instanceof $034fa980286ebb75$export$75a44ec6249ac76b) return $034fa980286ebb75$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $034fa980286ebb75$export$5ef2424805ac76a3 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).object) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $034fa980286ebb75$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $034fa980286ebb75$export$5ef2424805ac76a3({
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$034fa980286ebb75$var$processCreateParams(params)
        });
    }
}
function $034fa980286ebb75$var$mergeValues(a, b) {
    const aType = (0, $47f1291f3f379baa$export$3e9057828ebd5c7a)(a);
    const bType = (0, $47f1291f3f379baa$export$3e9057828ebd5c7a)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).object && bType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).object) {
        const bKeys = (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectKeys(b);
        const sharedKeys = (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $034fa980286ebb75$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).array && bType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $034fa980286ebb75$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).date && bType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $034fa980286ebb75$export$c02deaf0bb5203d4 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $4852d609824b6db6$export$afa861e3c5730743)(parsedLeft) || (0, $4852d609824b6db6$export$afa861e3c5730743)(parsedRight)) return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
            const merged = $034fa980286ebb75$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_intersection_types
                });
                return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
            }
            if ((0, $4852d609824b6db6$export$910b6cdd390341b3)(parsedLeft) || (0, $4852d609824b6db6$export$910b6cdd390341b3)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$034fa980286ebb75$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $034fa980286ebb75$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodIntersection,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$e2a18bb771d8e6a3 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).array) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).array,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f).mergeArray(status, results);
        });
        else return (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $034fa980286ebb75$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$034fa980286ebb75$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $034fa980286ebb75$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$a2acc09968cb4b7f extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).object) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f).mergeObjectAsync(status, pairs);
        else return (0, $4852d609824b6db6$export$5b20a5c3d05c1f6f).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $034fa980286ebb75$export$2afb8ab49d4b92c0) return new $034fa980286ebb75$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodRecord,
            ...$034fa980286ebb75$var$processCreateParams(third)
        });
        return new $034fa980286ebb75$export$a2acc09968cb4b7f({
            keyType: $034fa980286ebb75$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodRecord,
            ...$034fa980286ebb75$var$processCreateParams(second)
        });
    }
}
class $034fa980286ebb75$export$163b6a2b712d9542 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).map) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).map,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$034fa980286ebb75$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $034fa980286ebb75$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodMap,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$977057706f816712 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).set) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).set,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $034fa980286ebb75$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $034fa980286ebb75$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $034fa980286ebb75$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $7232557b5e929743$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$034fa980286ebb75$export$977057706f816712.create = (valueType, params)=>{
    return new $034fa980286ebb75$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodSet,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$d4602ba55673f53c extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).function) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).function,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return (0, $4852d609824b6db6$export$244a85fde9c419ed)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $297b3578b400e378$export$32f27c719778d4c4)(),
                    (0, $c870a696813c56c0$export$2e2bcd8739ae039)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $4852d609824b6db6$export$244a85fde9c419ed)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $297b3578b400e378$export$32f27c719778d4c4)(),
                    (0, $c870a696813c56c0$export$2e2bcd8739ae039)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $034fa980286ebb75$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(async function(...args) {
                const error = new (0, $5dd06e68c444f991$export$f98dac4b251ab333)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $5dd06e68c444f991$export$f98dac4b251ab333)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $5dd06e68c444f991$export$f98dac4b251ab333)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $034fa980286ebb75$export$d4602ba55673f53c({
            ...this._def,
            args: $034fa980286ebb75$export$e2a18bb771d8e6a3.create(items).rest($034fa980286ebb75$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $034fa980286ebb75$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $034fa980286ebb75$export$d4602ba55673f53c({
            args: args ? args : $034fa980286ebb75$export$e2a18bb771d8e6a3.create([]).rest($034fa980286ebb75$export$ef3b1bb1630977ae.create()),
            returns: returns || $034fa980286ebb75$export$ef3b1bb1630977ae.create(),
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodFunction,
            ...$034fa980286ebb75$var$processCreateParams(params)
        });
    }
}
class $034fa980286ebb75$export$378d0cfce37406e6 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$034fa980286ebb75$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $034fa980286ebb75$export$378d0cfce37406e6({
        getter: getter,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodLazy,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$7e44096782a165d3 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_literal,
                expected: this._def.value
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$034fa980286ebb75$export$7e44096782a165d3.create = (value, params)=>{
    return new $034fa980286ebb75$export$7e44096782a165d3({
        value: value,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodLiteral,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
function $034fa980286ebb75$var$createZodEnum(values, params) {
    return new $034fa980286ebb75$export$d325d1f0e1c20179({
        values: values,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodEnum,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
}
class $034fa980286ebb75$export$d325d1f0e1c20179 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                expected: (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_enum_value,
                options: expectedValues
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $034fa980286ebb75$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $034fa980286ebb75$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$034fa980286ebb75$export$d325d1f0e1c20179.create = $034fa980286ebb75$var$createZodEnum;
class $034fa980286ebb75$export$370b2e8d6d6f5c56 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).string && ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).number) {
            const expectedValues = (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectValues(nativeEnumValues);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                expected: (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        if (!this._cache) this._cache = new Set((0, $47f1291f3f379baa$export$7debb50ef11d5e0b).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).objectValues(nativeEnumValues);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_enum_value,
                options: expectedValues
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$034fa980286ebb75$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $034fa980286ebb75$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodNativeEnum,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$3f196b0127d6e50a extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).promise && ctx.common.async === false) {
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).promise,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$034fa980286ebb75$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $034fa980286ebb75$export$3f196b0127d6e50a({
        type: schema,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodPromise,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$a60af00cc0ce2582 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $034fa980286ebb75$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                if (result.status === "dirty") return (0, $4852d609824b6db6$export$325a211da9693fcf)(result.value);
                if (status.value === "dirty") return (0, $4852d609824b6db6$export$325a211da9693fcf)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                if (result.status === "dirty") return (0, $4852d609824b6db6$export$325a211da9693fcf)(result.value);
                if (status.value === "dirty") return (0, $4852d609824b6db6$export$325a211da9693fcf)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $4852d609824b6db6$export$1ea939691cdc45b8)(base)) return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $4852d609824b6db6$export$1ea939691cdc45b8)(base)) return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $47f1291f3f379baa$export$7debb50ef11d5e0b).assertNever(effect);
    }
}
$034fa980286ebb75$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $034fa980286ebb75$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
$034fa980286ebb75$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $034fa980286ebb75$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodEffects,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$aa56fec1e9d629b8 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).undefined) return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$034fa980286ebb75$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $034fa980286ebb75$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodOptional,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$aaac0b8b429cef5 extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).null) return (0, $4852d609824b6db6$export$c6813a8d51f77eaf)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$034fa980286ebb75$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $034fa980286ebb75$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodNullable,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$bb19b37874861e7e extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $47f1291f3f379baa$export$5716da67bfaa244d).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$034fa980286ebb75$export$bb19b37874861e7e.create = (type, params)=>{
    return new $034fa980286ebb75$export$bb19b37874861e7e({
        innerType: type,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$75a44ec6249ac76b extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $4852d609824b6db6$export$aefee5ebe1dcfd9e)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $5dd06e68c444f991$export$f98dac4b251ab333)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $5dd06e68c444f991$export$f98dac4b251ab333)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$034fa980286ebb75$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $034fa980286ebb75$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
class $034fa980286ebb75$export$26ccfa0145e8511f extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $47f1291f3f379baa$export$5716da67bfaa244d).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $4852d609824b6db6$export$db7caee60e5d514d)(ctx, {
                code: (0, $5dd06e68c444f991$export$5ba560653e4a1035).invalid_type,
                expected: (0, $47f1291f3f379baa$export$5716da67bfaa244d).nan,
                received: ctx.parsedType
            });
            return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$034fa980286ebb75$export$26ccfa0145e8511f.create = (params)=>{
    return new $034fa980286ebb75$export$26ccfa0145e8511f({
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodNaN,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
const $034fa980286ebb75$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $034fa980286ebb75$export$66b0c798a395271f extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $034fa980286ebb75$export$a3c3ef8a0e95c6da extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $4852d609824b6db6$export$325a211da9693fcf)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $4852d609824b6db6$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $034fa980286ebb75$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $034fa980286ebb75$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $034fa980286ebb75$export$5d1f7ef05c4e493a extends $034fa980286ebb75$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $4852d609824b6db6$export$1ea939691cdc45b8)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $4852d609824b6db6$export$aefee5ebe1dcfd9e)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$034fa980286ebb75$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $034fa980286ebb75$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $034fa980286ebb75$export$558106ce543bd011.ZodReadonly,
        ...$034fa980286ebb75$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $034fa980286ebb75$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $034fa980286ebb75$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $034fa980286ebb75$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $034fa980286ebb75$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $034fa980286ebb75$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $034fa980286ebb75$export$b9d1edb536b4e4eb.create();
}
const $034fa980286ebb75$export$1ee8ee30835eab8b = {
    object: $034fa980286ebb75$export$736315c5b55efbad.lazycreate
};
var $034fa980286ebb75$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($034fa980286ebb75$export$558106ce543bd011 || ($034fa980286ebb75$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $034fa980286ebb75$var$Class {
    constructor(..._){}
}
const $034fa980286ebb75$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$034fa980286ebb75$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $034fa980286ebb75$export$22b082955e083ec3 = $034fa980286ebb75$export$1230eb29b8d3b502.create;
const $034fa980286ebb75$export$98e628dec113755e = $034fa980286ebb75$export$5b070a55c0c43e09.create;
const $034fa980286ebb75$export$9e06de0973666692 = $034fa980286ebb75$export$26ccfa0145e8511f.create;
const $034fa980286ebb75$export$a0f65b52274bcc00 = $034fa980286ebb75$export$67d741fd70ff98f4.create;
const $034fa980286ebb75$export$4a21f16c33752377 = $034fa980286ebb75$export$723d146f80596191.create;
const $034fa980286ebb75$export$324d90190a8b822a = $034fa980286ebb75$export$e974be33bdc55521.create;
const $034fa980286ebb75$export$8f701197936bc2a6 = $034fa980286ebb75$export$bcc3b40f6b638044.create;
const $034fa980286ebb75$export$1db45310990710a5 = $034fa980286ebb75$export$4e780e961c30340d.create;
const $034fa980286ebb75$export$7b1b591b262c240 = $034fa980286ebb75$export$a96281f914484f2d.create;
const $034fa980286ebb75$export$4154a199d7d90455 = $034fa980286ebb75$export$b9d1edb536b4e4eb.create;
const $034fa980286ebb75$export$19282c40b967aec6 = $034fa980286ebb75$export$ef3b1bb1630977ae.create;
const $034fa980286ebb75$export$b3e22bcfd64c1022 = $034fa980286ebb75$export$1e576a20c3ce9fb5.create;
const $034fa980286ebb75$export$490e536ee7389aeb = $034fa980286ebb75$export$7d39f5df85f21031.create;
const $034fa980286ebb75$export$2f23118c22fb2630 = $034fa980286ebb75$export$7acfc3e64785411.create;
const $034fa980286ebb75$export$be5493f9613cbbe = $034fa980286ebb75$export$736315c5b55efbad.create;
const $034fa980286ebb75$export$8fb0df5f40d0b477 = $034fa980286ebb75$export$736315c5b55efbad.strictCreate;
const $034fa980286ebb75$export$971dd5b0dfd021b6 = $034fa980286ebb75$export$a8b236cb5070a311.create;
const $034fa980286ebb75$export$4b888e40c4ee26dd = $034fa980286ebb75$export$5ef2424805ac76a3.create;
const $034fa980286ebb75$export$bc86dfbf7795668c = $034fa980286ebb75$export$c02deaf0bb5203d4.create;
const $034fa980286ebb75$export$65e3907585753458 = $034fa980286ebb75$export$e2a18bb771d8e6a3.create;
const $034fa980286ebb75$export$e5185e241753e543 = $034fa980286ebb75$export$a2acc09968cb4b7f.create;
const $034fa980286ebb75$export$871de8747c9eaa88 = $034fa980286ebb75$export$163b6a2b712d9542.create;
const $034fa980286ebb75$export$adaa4cf7ef1b65be = $034fa980286ebb75$export$977057706f816712.create;
const $034fa980286ebb75$export$44e51c8aac7c2deb = $034fa980286ebb75$export$d4602ba55673f53c.create;
const $034fa980286ebb75$export$488013bae63b21da = $034fa980286ebb75$export$378d0cfce37406e6.create;
const $034fa980286ebb75$export$c8ec6e1ec9fefcb0 = $034fa980286ebb75$export$7e44096782a165d3.create;
const $034fa980286ebb75$export$78a99c8d44d72635 = $034fa980286ebb75$export$d325d1f0e1c20179.create;
const $034fa980286ebb75$export$6fe7eca19ebe5199 = $034fa980286ebb75$export$370b2e8d6d6f5c56.create;
const $034fa980286ebb75$export$c957ef27a0ebfd4 = $034fa980286ebb75$export$3f196b0127d6e50a.create;
const $034fa980286ebb75$export$dc573d8a6576cdb3 = $034fa980286ebb75$export$a60af00cc0ce2582.create;
const $034fa980286ebb75$export$516e28dec6a4b6d4 = $034fa980286ebb75$export$aa56fec1e9d629b8.create;
const $034fa980286ebb75$export$133fc36489ac9add = $034fa980286ebb75$export$aaac0b8b429cef5.create;
const $034fa980286ebb75$export$fc37fe19dfda43ee = $034fa980286ebb75$export$a60af00cc0ce2582.createWithPreprocess;
const $034fa980286ebb75$export$43f28b24e1eb8181 = $034fa980286ebb75$export$a3c3ef8a0e95c6da.create;
const $034fa980286ebb75$export$3b3d07727c5b702c = ()=>$034fa980286ebb75$export$22b082955e083ec3().optional();
const $034fa980286ebb75$export$eb150471a61fced6 = ()=>$034fa980286ebb75$export$98e628dec113755e().optional();
const $034fa980286ebb75$export$269251733cdcbbf1 = ()=>$034fa980286ebb75$export$4a21f16c33752377().optional();
const $034fa980286ebb75$export$8c14e57e778d3873 = {
    string: (arg)=>$034fa980286ebb75$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$034fa980286ebb75$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$034fa980286ebb75$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$034fa980286ebb75$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$034fa980286ebb75$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $034fa980286ebb75$export$96c94437c95d7862 = (0, $4852d609824b6db6$export$9a105a556e65c2c0);


function $220046a7533cffdb$export$1343a74baacb0543(...inputs) {
    return (0, $86bbf129917d6fd4$exports.twMerge)((0, $a9d9685a8e9a96cb$export$4f5d2d50c9deca37)(inputs));
}
function $220046a7533cffdb$export$371e338370561054(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
function $220046a7533cffdb$export$fc12d552df054270({ error: error, localization: localization }) {
    if (typeof error === "string") {
        if (localization == null ? void 0 : localization[error]) return localization[error];
    }
    if (error == null ? void 0 : error.error) {
        if (error.error.code) {
            const errorCode = error.error.code;
            if (localization == null ? void 0 : localization[errorCode]) return localization[errorCode];
        }
        return error.error.message || error.error.code || error.error.statusText || (localization == null ? void 0 : localization.REQUEST_FAILED);
    }
    return (error == null ? void 0 : error.message) || (localization == null ? void 0 : localization.REQUEST_FAILED) || "Request failed";
}
function $220046a7533cffdb$export$cea57e52bbb16e9c(paramName) {
    return typeof window !== "undefined" ? new URLSearchParams(window.location.search).get(paramName) : null;
}
function $220046a7533cffdb$export$4bd320b27036ede5(viewPaths, path) {
    for(const key in viewPaths){
        if (viewPaths[key] === path) return key;
    }
}
function $220046a7533cffdb$export$cb8de236c1721184(passwordValidation, localization) {
    let schema = $034fa980286ebb75$export$22b082955e083ec3().min(1, {
        message: localization == null ? void 0 : localization.PASSWORD_REQUIRED
    });
    if (passwordValidation == null ? void 0 : passwordValidation.minLength) schema = schema.min(passwordValidation.minLength, {
        message: localization == null ? void 0 : localization.PASSWORD_TOO_SHORT
    });
    if (passwordValidation == null ? void 0 : passwordValidation.maxLength) schema = schema.max(passwordValidation.maxLength, {
        message: localization == null ? void 0 : localization.PASSWORD_TOO_LONG
    });
    if (passwordValidation == null ? void 0 : passwordValidation.regex) schema = schema.regex(passwordValidation.regex, {
        message: localization == null ? void 0 : localization.INVALID_PASSWORD
    });
    return schema;
}
// src/localization/admin-error-codes.ts
var $220046a7533cffdb$var$ADMIN_ERROR_CODES = {
    FAILED_TO_CREATE_USER: "Failed to create user",
    USER_ALREADY_EXISTS: "User already exists",
    YOU_CANNOT_BAN_YOURSELF: "You cannot ban yourself",
    YOU_ARE_NOT_ALLOWED_TO_CHANGE_USERS_ROLE: "You are not allowed to change users role",
    YOU_ARE_NOT_ALLOWED_TO_CREATE_USERS: "You are not allowed to create users",
    YOU_ARE_NOT_ALLOWED_TO_LIST_USERS: "You are not allowed to list users",
    YOU_ARE_NOT_ALLOWED_TO_LIST_USERS_SESSIONS: "You are not allowed to list users sessions",
    YOU_ARE_NOT_ALLOWED_TO_BAN_USERS: "You are not allowed to ban users",
    YOU_ARE_NOT_ALLOWED_TO_IMPERSONATE_USERS: "You are not allowed to impersonate users",
    YOU_ARE_NOT_ALLOWED_TO_REVOKE_USERS_SESSIONS: "You are not allowed to revoke users sessions",
    YOU_ARE_NOT_ALLOWED_TO_DELETE_USERS: "You are not allowed to delete users",
    YOU_ARE_NOT_ALLOWED_TO_SET_USERS_PASSWORD: "You are not allowed to set users password",
    BANNED_USER: "You have been banned from this application"
};
// src/localization/anonymous-error-codes.ts
var $220046a7533cffdb$var$ANONYMOUS_ERROR_CODES = {
    FAILED_TO_CREATE_USER: "Failed to create user",
    COULD_NOT_CREATE_SESSION: "Could not create session",
    ANONYMOUS_USERS_CANNOT_SIGN_IN_AGAIN_ANONYMOUSLY: "Anonymous users cannot sign in again anonymously"
};
// src/localization/api-key-error-codes.ts
var $220046a7533cffdb$var$API_KEY_ERROR_CODES = {
    INVALID_METADATA_TYPE: "metadata must be an object or undefined",
    REFILL_AMOUNT_AND_INTERVAL_REQUIRED: "refillAmount is required when refillInterval is provided",
    REFILL_INTERVAL_AND_AMOUNT_REQUIRED: "refillInterval is required when refillAmount is provided",
    USER_BANNED: "User is banned",
    UNAUTHORIZED_SESSION: "Unauthorized or invalid session",
    KEY_NOT_FOUND: "API Key not found",
    KEY_DISABLED: "API Key is disabled",
    KEY_EXPIRED: "API Key has expired",
    USAGE_EXCEEDED: "API Key has reached its usage limit",
    KEY_NOT_RECOVERABLE: "API Key is not recoverable",
    EXPIRES_IN_IS_TOO_SMALL: "The expiresIn is smaller than the predefined minimum value.",
    EXPIRES_IN_IS_TOO_LARGE: "The expiresIn is larger than the predefined maximum value.",
    INVALID_REMAINING: "The remaining count is either too large or too small.",
    INVALID_PREFIX_LENGTH: "The prefix length is either too large or too small.",
    INVALID_NAME_LENGTH: "The name length is either too large or too small.",
    METADATA_DISABLED: "Metadata is disabled.",
    RATE_LIMIT_EXCEEDED: "Rate limit exceeded.",
    NO_VALUES_TO_UPDATE: "No values to update.",
    KEY_DISABLED_EXPIRATION: "Custom key expiration values are disabled.",
    INVALID_API_KEY: "Invalid API key.",
    INVALID_USER_ID_FROM_API_KEY: "The user id from the API key is invalid.",
    INVALID_API_KEY_GETTER_RETURN_TYPE: "API Key getter returned an invalid key type. Expected string.",
    SERVER_ONLY_PROPERTY: "The property you're trying to set can only be set from the server auth instance only."
};
// src/localization/base-error-codes.ts
var $220046a7533cffdb$var$BASE_ERROR_CODES = {
    USER_NOT_FOUND: "User not found",
    FAILED_TO_CREATE_USER: "Failed to create user",
    FAILED_TO_CREATE_SESSION: "Failed to create session",
    FAILED_TO_UPDATE_USER: "Failed to update user",
    FAILED_TO_GET_SESSION: "Failed to get session",
    INVALID_PASSWORD: "Invalid password",
    INVALID_EMAIL: "Invalid email",
    INVALID_EMAIL_OR_PASSWORD: "Invalid email or password",
    SOCIAL_ACCOUNT_ALREADY_LINKED: "Social account already linked",
    PROVIDER_NOT_FOUND: "Provider not found",
    INVALID_TOKEN: "Invalid token",
    ID_TOKEN_NOT_SUPPORTED: "id_token not supported",
    FAILED_TO_GET_USER_INFO: "Failed to get user info",
    USER_EMAIL_NOT_FOUND: "User email not found",
    EMAIL_NOT_VERIFIED: "Email not verified",
    PASSWORD_TOO_SHORT: "Password too short",
    PASSWORD_TOO_LONG: "Password too long",
    USER_ALREADY_EXISTS: "User already exists",
    EMAIL_CAN_NOT_BE_UPDATED: "Email can not be updated",
    CREDENTIAL_ACCOUNT_NOT_FOUND: "Credential account not found",
    SESSION_EXPIRED: "Session expired. Re-authenticate to perform this action.",
    FAILED_TO_UNLINK_LAST_ACCOUNT: "You can't unlink your last account",
    ACCOUNT_NOT_FOUND: "Account not found",
    USER_ALREADY_HAS_PASSWORD: "User already has a password. Provide that to delete the account."
};
// src/localization/captcha-error-codes.ts
var $220046a7533cffdb$var$EXTERNAL_ERROR_CODES = {
    VERIFICATION_FAILED: "Captcha verification failed",
    MISSING_RESPONSE: "Missing CAPTCHA response",
    UNKNOWN_ERROR: "Something went wrong"
};
var $220046a7533cffdb$var$INTERNAL_ERROR_CODES = {
    MISSING_SECRET_KEY: "Missing secret key",
    SERVICE_UNAVAILABLE: "CAPTCHA service unavailable"
};
var $220046a7533cffdb$var$CAPTCHA_ERROR_CODES = {
    ...$220046a7533cffdb$var$EXTERNAL_ERROR_CODES,
    ...$220046a7533cffdb$var$INTERNAL_ERROR_CODES
};
// src/localization/email-otp-error-codes.ts
var $220046a7533cffdb$var$EMAIL_OTP_ERROR_CODES = {
    OTP_EXPIRED: "otp expired",
    INVALID_OTP: "Invalid OTP",
    INVALID_EMAIL: "Invalid email",
    USER_NOT_FOUND: "User not found",
    TOO_MANY_ATTEMPTS: "Too many attempts"
};
// src/localization/generic-oauth-error-codes.ts
var $220046a7533cffdb$var$GENERIC_OAUTH_ERROR_CODES = {
    INVALID_OAUTH_CONFIGURATION: "Invalid OAuth configuration"
};
// src/localization/haveibeenpwned-error-codes.ts
var $220046a7533cffdb$var$HAVEIBEENPWNED_ERROR_CODES = {
    PASSWORD_COMPROMISED: "The password you entered has been compromised. Please choose a different password."
};
// src/localization/multi-session-error-codes.ts
var $220046a7533cffdb$var$MULTI_SESSION_ERROR_CODES = {
    INVALID_SESSION_TOKEN: "Invalid session token"
};
// src/localization/organization-error-codes.ts
var $220046a7533cffdb$var$ORGANIZATION_ERROR_CODES = {
    YOU_ARE_NOT_ALLOWED_TO_CREATE_A_NEW_ORGANIZATION: "You are not allowed to create a new organization",
    YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_ORGANIZATIONS: "You have reached the maximum number of organizations",
    ORGANIZATION_ALREADY_EXISTS: "Organization already exists",
    ORGANIZATION_NOT_FOUND: "Organization not found",
    USER_IS_NOT_A_MEMBER_OF_THE_ORGANIZATION: "User is not a member of the organization",
    YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_ORGANIZATION: "You are not allowed to update this organization",
    YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_ORGANIZATION: "You are not allowed to delete this organization",
    NO_ACTIVE_ORGANIZATION: "No active organization",
    USER_IS_ALREADY_A_MEMBER_OF_THIS_ORGANIZATION: "User is already a member of this organization",
    MEMBER_NOT_FOUND: "Member not found",
    ROLE_NOT_FOUND: "Role not found",
    YOU_ARE_NOT_ALLOWED_TO_CREATE_A_NEW_TEAM: "You are not allowed to create a new team",
    TEAM_ALREADY_EXISTS: "Team already exists",
    TEAM_NOT_FOUND: "Team not found",
    YOU_CANNOT_LEAVE_THE_ORGANIZATION_AS_THE_ONLY_OWNER: "You cannot leave the organization as the only owner",
    YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_MEMBER: "You are not allowed to delete this member",
    YOU_ARE_NOT_ALLOWED_TO_INVITE_USERS_TO_THIS_ORGANIZATION: "You are not allowed to invite users to this organization",
    USER_IS_ALREADY_INVITED_TO_THIS_ORGANIZATION: "User is already invited to this organization",
    INVITATION_NOT_FOUND: "Invitation not found",
    YOU_ARE_NOT_THE_RECIPIENT_OF_THE_INVITATION: "You are not the recipient of the invitation",
    YOU_ARE_NOT_ALLOWED_TO_CANCEL_THIS_INVITATION: "You are not allowed to cancel this invitation",
    INVITER_IS_NO_LONGER_A_MEMBER_OF_THE_ORGANIZATION: "Inviter is no longer a member of the organization",
    YOU_ARE_NOT_ALLOWED_TO_INVITE_USER_WITH_THIS_ROLE: "you are not allowed to invite user with this role",
    FAILED_TO_RETRIEVE_INVITATION: "Failed to retrieve invitation",
    YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_TEAMS: "You have reached the maximum number of teams",
    UNABLE_TO_REMOVE_LAST_TEAM: "Unable to remove last team",
    YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_MEMBER: "You are not allowed to update this member",
    ORGANIZATION_MEMBERSHIP_LIMIT_REACHED: "Organization membership limit reached",
    YOU_ARE_NOT_ALLOWED_TO_CREATE_TEAMS_IN_THIS_ORGANIZATION: "You are not allowed to create teams in this organization",
    YOU_ARE_NOT_ALLOWED_TO_DELETE_TEAMS_IN_THIS_ORGANIZATION: "You are not allowed to delete teams in this organization",
    YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_TEAM: "You are not allowed to update this team",
    YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_TEAM: "You are not allowed to delete this team",
    INVITATION_LIMIT_REACHED: "Invitation limit reached"
};
// src/localization/passkey-error-codes.ts
var $220046a7533cffdb$var$PASSKEY_ERROR_CODES = {
    CHALLENGE_NOT_FOUND: "Challenge not found",
    YOU_ARE_NOT_ALLOWED_TO_REGISTER_THIS_PASSKEY: "You are not allowed to register this passkey",
    FAILED_TO_VERIFY_REGISTRATION: "Failed to verify registration",
    PASSKEY_NOT_FOUND: "Passkey not found",
    AUTHENTICATION_FAILED: "Authentication failed",
    UNABLE_TO_CREATE_SESSION: "Unable to create session",
    FAILED_TO_UPDATE_PASSKEY: "Failed to update passkey"
};
// src/localization/phone-number-error-codes.ts
var $220046a7533cffdb$var$PHONE_NUMBER_ERROR_CODES = {
    INVALID_PHONE_NUMBER: "Invalid phone number",
    PHONE_NUMBER_EXIST: "Phone number already exists",
    INVALID_PHONE_NUMBER_OR_PASSWORD: "Invalid phone number or password",
    UNEXPECTED_ERROR: "Unexpected error",
    OTP_NOT_FOUND: "OTP not found",
    OTP_EXPIRED: "OTP expired",
    INVALID_OTP: "Invalid OTP",
    PHONE_NUMBER_NOT_VERIFIED: "Phone number not verified"
};
// src/localization/stripe-localization.ts
var $220046a7533cffdb$var$STRIPE_ERROR_CODES = {
    SUBSCRIPTION_NOT_FOUND: "Subscription not found",
    SUBSCRIPTION_PLAN_NOT_FOUND: "Subscription plan not found",
    ALREADY_SUBSCRIBED_PLAN: "You're already subscribed to this plan",
    UNABLE_TO_CREATE_CUSTOMER: "Unable to create customer",
    FAILED_TO_FETCH_PLANS: "Failed to fetch plans",
    EMAIL_VERIFICATION_REQUIRED: "Email verification is required before you can subscribe to a plan",
    SUBSCRIPTION_NOT_ACTIVE: "Subscription is not active",
    SUBSCRIPTION_NOT_SCHEDULED_FOR_CANCELLATION: "Subscription is not scheduled for cancellation"
};
// src/localization/two-factor-error-codes.ts
var $220046a7533cffdb$var$TWO_FACTOR_ERROR_CODES = {
    OTP_NOT_ENABLED: "OTP not enabled",
    OTP_HAS_EXPIRED: "OTP has expired",
    TOTP_NOT_ENABLED: "TOTP not enabled",
    TWO_FACTOR_NOT_ENABLED: "Two factor isn't enabled",
    BACKUP_CODES_NOT_ENABLED: "Backup codes aren't enabled",
    INVALID_BACKUP_CODE: "Invalid backup code",
    INVALID_CODE: "Invalid code",
    TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE: "Too many attempts. Please request a new code.",
    INVALID_TWO_FACTOR_COOKIE: "Invalid two factor cookie"
};
// src/localization/username-error-codes.ts
var $220046a7533cffdb$var$USERNAME_ERROR_CODES = {
    INVALID_USERNAME_OR_PASSWORD: "invalid username or password",
    EMAIL_NOT_VERIFIED: "email not verified",
    UNEXPECTED_ERROR: "unexpected error",
    USERNAME_IS_ALREADY_TAKEN: "username is already taken. please try another.",
    USERNAME_TOO_SHORT: "username is too short",
    USERNAME_TOO_LONG: "username is too long",
    INVALID_USERNAME: "username is invalid"
};
// src/localization/auth-localization.ts
var $220046a7533cffdb$export$978479025ceb1313 = {
    /** @default "App" */ APP: "App",
    /** @default "Account" */ ACCOUNT: "Account",
    /** @default "Accounts" */ ACCOUNTS: "Accounts",
    /** @default "Manage your currently signed in accounts." */ ACCOUNTS_DESCRIPTION: "Switch between your currently signed in accounts.",
    /** @default "Sign in to an additional account." */ ACCOUNTS_INSTRUCTIONS: "Sign in to an additional account.",
    /** @default "Add Account" */ ADD_ACCOUNT: "Add Account",
    /** @default "Add Passkey" */ ADD_PASSKEY: "Add Passkey",
    /** @default "Already have an account?" */ ALREADY_HAVE_AN_ACCOUNT: "Already have an account?",
    /** @default "Avatar" */ AVATAR: "Avatar",
    /** @default "Click on the avatar to upload a custom one from your files." */ AVATAR_DESCRIPTION: "Click on the avatar to upload a custom one from your files.",
    /** @default "An avatar is optional but strongly recommended." */ AVATAR_INSTRUCTIONS: "An avatar is optional but strongly recommended.",
    /** @default "Backup code is required" */ BACKUP_CODE_REQUIRED: "Backup code is required",
    /** @default "Backup Codes" */ BACKUP_CODES: "Backup Codes",
    /** @default "Save these backup codes in a secure place. You can use them to access your account if you lose your two-factor authentication method." */ BACKUP_CODES_DESCRIPTION: "Save these backup codes in a secure place. You can use them to access your account if you lose your two-factor authentication method.",
    /** @default "Backup Code." */ BACKUP_CODE_PLACEHOLDER: "Backup Code",
    /** @default "Backup Code" */ BACKUP_CODE: "Backup Code",
    /** @default "Cancel" */ CANCEL: "Cancel",
    /** @default "Change Password" */ CHANGE_PASSWORD: "Change Password",
    /** @default "Enter your current password and a new password." */ CHANGE_PASSWORD_DESCRIPTION: "Enter your current password and a new password.",
    /** @default "Please use 8 characters at minimum." */ CHANGE_PASSWORD_INSTRUCTIONS: "Please use 8 characters at minimum.",
    /** @default "Your password has been changed." */ CHANGE_PASSWORD_SUCCESS: "Your password has been changed.",
    /** @default "Confirm Password" */ CONFIRM_PASSWORD: "Confirm Password",
    /** @default "Confirm Password" */ CONFIRM_PASSWORD_PLACEHOLDER: "Confirm Password",
    /** @default "Confirm password is required" */ CONFIRM_PASSWORD_REQUIRED: "Confirm password is required",
    /** @default "Continue with Authenticator" */ CONTINUE_WITH_AUTHENTICATOR: "Continue with Authenticator",
    /** @default "Copied to clipboard" */ COPIED_TO_CLIPBOARD: "Copied to clipboard",
    /** @default "Copy to clipboard" */ COPY_TO_CLIPBOARD: "Copy to clipboard",
    /** @default "Copy all codes" */ COPY_ALL_CODES: "Copy all codes",
    /** @default "Continue" */ CONTINUE: "Continue",
    /** @default "Current Password" */ CURRENT_PASSWORD: "Current Password",
    /** @default "Current Password" */ CURRENT_PASSWORD_PLACEHOLDER: "Current Password",
    /** @default "Current Session" */ CURRENT_SESSION: "Current Session",
    /** @default "Delete" */ DELETE: "Delete",
    /** @default "Delete Avatar" */ DELETE_AVATAR: "Delete Avatar",
    /** @default "Delete Account" */ DELETE_ACCOUNT: "Delete Account",
    /** @default "Permanently remove your account and all of its contents. This action is not reversible, so please continue with caution." */ DELETE_ACCOUNT_DESCRIPTION: "Permanently remove your account and all of its contents. This action is not reversible, so please continue with caution.",
    /** @default "Please confirm the deletion of your account. This action is not reversible, so please continue with caution." */ DELETE_ACCOUNT_INSTRUCTIONS: "Please confirm the deletion of your account. This action is not reversible, so please continue with caution.",
    /** @default "Please check your email to verify the deletion of your account." */ DELETE_ACCOUNT_VERIFY: "Please check your email to verify the deletion of your account.",
    /** @default "Your account has been deleted." */ DELETE_ACCOUNT_SUCCESS: "Your account has been deleted.",
    /** @default "Disable Two-Factor" */ DISABLE_TWO_FACTOR: "Disable Two-Factor",
    /** @default "Choose a provider to login to your account" */ DISABLED_CREDENTIALS_DESCRIPTION: "Choose a provider to login to your account",
    /** @default "Don't have an account?" */ DONT_HAVE_AN_ACCOUNT: "Don't have an account?",
    /** @default "Done" */ DONE: "Done",
    /** @default "Email" */ EMAIL: "Email",
    /** @default "Enter the email address you want to use to log in." */ EMAIL_DESCRIPTION: "Enter the email address you want to use to log in.",
    /** @default "Please enter a valid email address." */ EMAIL_INSTRUCTIONS: "Please enter a valid email address.",
    /** @default "Email is the same" */ EMAIL_IS_THE_SAME: "Email is the same",
    /** @default "m@example.com" */ EMAIL_PLACEHOLDER: "m@example.com",
    /** @default "Email address is required" */ EMAIL_REQUIRED: "Email address is required",
    /** @default "Please check your email to verify the change." */ EMAIL_VERIFY_CHANGE: "Please check your email to verify the change.",
    /** @default "Please check your email for the verification link." */ EMAIL_VERIFICATION: "Please check your email for the verification link.",
    /** @default "Enable Two-Factor" */ ENABLE_TWO_FACTOR: "Enable Two-Factor",
    /** @default "is invalid" */ IS_INVALID: "is invalid",
    /** @default "is required" */ IS_REQUIRED: "is required",
    /** @default "is the same" */ IS_THE_SAME: "is the same",
    /** @default "Forgot authenticator?" */ FORGOT_AUTHENTICATOR: "Forgot authenticator?",
    /** @default "Forgot Password" */ FORGOT_PASSWORD: "Forgot Password",
    /** @default "Send reset link" */ FORGOT_PASSWORD_ACTION: "Send reset link",
    /** @default "Enter your email to reset your password" */ FORGOT_PASSWORD_DESCRIPTION: "Enter your email to reset your password",
    /** @default "Check your email for the password reset link." */ FORGOT_PASSWORD_EMAIL: "Check your email for the password reset link.",
    /** @default "Forgot your password?" */ FORGOT_PASSWORD_LINK: "Forgot your password?",
    /** @default "Link" */ LINK: "Link",
    /** @default "Magic Link" */ MAGIC_LINK: "Magic Link",
    /** @default "Send magic link" */ MAGIC_LINK_ACTION: "Send magic link",
    /** @default "Enter your email to receive a magic link" */ MAGIC_LINK_DESCRIPTION: "Enter your email to receive a magic link",
    /** @default "Check your email for the magic link" */ MAGIC_LINK_EMAIL: "Check your email for the magic link",
    /** @default "Email Code" */ EMAIL_OTP: "Email Code",
    /** @default "Send code" */ EMAIL_OTP_SEND_ACTION: "Send code",
    /** @default "Verify code" */ EMAIL_OTP_VERIFY_ACTION: "Verify code",
    /** @default "Enter your email to receive a code" */ EMAIL_OTP_DESCRIPTION: "Enter your email to receive a code",
    /** @default "Please check your email for the verification code." */ EMAIL_OTP_VERIFICATION_SENT: "Please check your email for the verification code.",
    /** @default "Name" */ NAME: "Name",
    /** @default "Please enter your full name, or a display name." */ NAME_DESCRIPTION: "Please enter your full name, or a display name.",
    /** @default "Please use 32 characters at maximum." */ NAME_INSTRUCTIONS: "Please use 32 characters at maximum.",
    /** @default "Name" */ NAME_PLACEHOLDER: "Name",
    /** @default "New Password" */ NEW_PASSWORD: "New Password",
    /** @default "New Password" */ NEW_PASSWORD_PLACEHOLDER: "New Password",
    /** @default "New password is required" */ NEW_PASSWORD_REQUIRED: "New password is required",
    /** @default "One-Time Password" */ ONE_TIME_PASSWORD: "One-Time Password",
    /** @default "Or continue with" */ OR_CONTINUE_WITH: "Or continue with",
    /** @default "Passkey" */ PASSKEY: "Passkey",
    /** @default "Passkeys" */ PASSKEYS: "Passkeys",
    /** @default "Manage your passkeys for secure access." */ PASSKEYS_DESCRIPTION: "Manage your passkeys for secure access.",
    /** @default "Securely access your account without a password." */ PASSKEYS_INSTRUCTIONS: "Securely access your account without a password.",
    /** @default "Personal Account" */ PERSONAL_ACCOUNT: "Personal Account",
    /** @default "API Keys" */ API_KEYS: "API Keys",
    /** @default "Manage your API keys for secure access." */ API_KEYS_DESCRIPTION: "Manage your API keys for secure access.",
    /** @default "Generate API keys to access your account programmatically." */ API_KEYS_INSTRUCTIONS: "Generate API keys to access your account programmatically.",
    /** @default "Create API Key" */ CREATE_API_KEY: "Create API Key",
    /** @default "Enter a unique name for your API key to differentiate it from other keys." */ CREATE_API_KEY_DESCRIPTION: "Enter a unique name for your API key to differentiate it from other keys.",
    /** @default "New API Key" */ API_KEY_NAME_PLACEHOLDER: "New API Key",
    /** @default "API Key Created" */ API_KEY_CREATED: "API Key Created",
    /** @default "Please copy your API key and store it in a safe place. For security reasons we cannot show it again." */ CREATE_API_KEY_SUCCESS: "Please copy your API key and store it in a safe place. For security reasons we cannot show it again.",
    /** @default "Never Expires" */ NEVER_EXPIRES: "Never Expires",
    /** @default "Expires" */ EXPIRES: "Expires",
    /** @default "No Expiration" */ NO_EXPIRATION: "No Expiration",
    /** @default "Create Organization" */ CREATE_ORGANIZATION: "Create Organization",
    /** @default "Organization" */ ORGANIZATION: "Organization",
    /** @default "Name" */ ORGANIZATION_NAME: "Name",
    /** @default "Acme Inc." */ ORGANIZATION_NAME_PLACEHOLDER: "Acme Inc.",
    /** @default "This is your organization's visible name." */ ORGANIZATION_NAME_DESCRIPTION: "This is your organization's visible name.",
    /** @default "Please use 32 characters at maximum." */ ORGANIZATION_NAME_INSTRUCTIONS: "Please use 32 characters at maximum.",
    /** @default "Slug URL" */ ORGANIZATION_SLUG: "Slug URL",
    /** @default "This is your organization's URL namespace." */ ORGANIZATION_SLUG_DESCRIPTION: "This is your organization's URL namespace.",
    /** @default "Please use 48 characters at maximum." */ ORGANIZATION_SLUG_INSTRUCTIONS: "Please use 48 characters at maximum.",
    /** @default "acme-inc" */ ORGANIZATION_SLUG_PLACEHOLDER: "acme-inc",
    /** @default "Organization created successfully" */ CREATE_ORGANIZATION_SUCCESS: "Organization created successfully",
    /** @default "Password" */ PASSWORD: "Password",
    /** @default "Password" */ PASSWORD_PLACEHOLDER: "Password",
    /** @default "Password is required" */ PASSWORD_REQUIRED: "Password is required",
    /** @default "Passwords do not match" */ PASSWORDS_DO_NOT_MATCH: "Passwords do not match",
    /** @default "Providers" */ PROVIDERS: "Providers",
    /** @default "Connect your account with a third-party service." */ PROVIDERS_DESCRIPTION: "Connect your account with a third-party service.",
    /** @default "Recover Account" */ RECOVER_ACCOUNT: "Recover Account",
    /** @default "Recover account" */ RECOVER_ACCOUNT_ACTION: "Recover account",
    /** @default "Please enter a backup code to access your account" */ RECOVER_ACCOUNT_DESCRIPTION: "Please enter a backup code to access your account",
    /** @default "Remember me" */ REMEMBER_ME: "Remember me",
    /** @default "Resend code" */ RESEND_CODE: "Resend code",
    /** @default "Resend verification email" */ RESEND_VERIFICATION_EMAIL: "Resend Verification Email",
    /** @default "Reset Password" */ RESET_PASSWORD: "Reset Password",
    /** @default "Save new password" */ RESET_PASSWORD_ACTION: "Save new password",
    /** @default "Enter your new password below" */ RESET_PASSWORD_DESCRIPTION: "Enter your new password below",
    /** @default "Password reset successfully" */ RESET_PASSWORD_SUCCESS: "Password reset successfully",
    /** @default "Request failed" */ REQUEST_FAILED: "Request failed",
    /** @default "Revoke" */ REVOKE: "Revoke",
    /** @default "Delete API Key" */ DELETE_API_KEY: "Delete API Key",
    /** @default "Are you sure you want to delete this API key?" */ DELETE_API_KEY_CONFIRM: "Are you sure you want to delete this API key?",
    /** @default "API Key" */ API_KEY: "API Key",
    /** @default "Sign In" */ SIGN_IN: "Sign In",
    /** @default "Login" */ SIGN_IN_ACTION: "Login",
    /** @default "Enter your email below to login to your account" */ SIGN_IN_DESCRIPTION: "Enter your email below to login to your account",
    /** @default "Enter your username or email below to login to your account" */ SIGN_IN_USERNAME_DESCRIPTION: "Enter your username or email to login to your account",
    /** @default "Sign in with" */ SIGN_IN_WITH: "Sign in with",
    /** @default "Sign Out" */ SIGN_OUT: "Sign Out",
    /** @default "Sign Up" */ SIGN_UP: "Sign Up",
    /** @default "Create an account" */ SIGN_UP_ACTION: "Create an account",
    /** @default "Enter your information to create an account" */ SIGN_UP_DESCRIPTION: "Enter your information to create an account",
    /** @default "Check your email for the verification link." */ SIGN_UP_EMAIL: "Check your email for the verification link.",
    /** @default "Sessions" */ SESSIONS: "Sessions",
    /** @default "Manage your active sessions and revoke access." */ SESSIONS_DESCRIPTION: "Manage your active sessions and revoke access.",
    /** @default "Set Password" */ SET_PASSWORD: "Set Password",
    /** @default "Click the button below to receive an email to set up a password for your account." */ SET_PASSWORD_DESCRIPTION: "Click the button below to receive an email to set up a password for your account.",
    /** @default "Settings" */ SETTINGS: "Settings",
    /** @default "Save" */ SAVE: "Save",
    /** @default "Security" */ SECURITY: "Security",
    /** @default "Switch Account" */ SWITCH_ACCOUNT: "Switch Account",
    /** @default "Trust this device" */ TRUST_DEVICE: "Trust this device",
    /** @default "Two-Factor" */ TWO_FACTOR: "Two-Factor",
    /** @default "Verify code" */ TWO_FACTOR_ACTION: "Verify code",
    /** @default "Please enter your one-time password to continue" */ TWO_FACTOR_DESCRIPTION: "Please enter your one-time password to continue",
    /** @default "Add an extra layer of security to your account." */ TWO_FACTOR_CARD_DESCRIPTION: "Add an extra layer of security to your account.",
    /** @default "Please enter your password to disable 2FA." */ TWO_FACTOR_DISABLE_INSTRUCTIONS: "Please enter your password to disable 2FA.",
    /** @default "Please enter your password to enable 2FA" */ TWO_FACTOR_ENABLE_INSTRUCTIONS: "Please enter your password to enable 2FA.",
    /** @default "Two-factor authentication has been enabled" */ TWO_FACTOR_ENABLED: "Two-factor authentication has been enabled",
    /** @default "Two-Factor Authentication has been disabled" */ TWO_FACTOR_DISABLED: "Two-Factor Authentication has been disabled",
    /** @default "Two-Factor Authentication" */ TWO_FACTOR_PROMPT: "Two-Factor Authentication",
    /** @default "Scan the QR Code with your Authenticator" */ TWO_FACTOR_TOTP_LABEL: "Scan the QR Code with your Authenticator",
    /** @default "Send verification code" */ SEND_VERIFICATION_CODE: "Send verification code",
    /** @default "Unlink" */ UNLINK: "Unlink",
    /** @default "Updated successfully" */ UPDATED_SUCCESSFULLY: "updated successfully",
    /** @default "Username" */ USERNAME: "Username",
    /** @default "Enter the username you want to use to log in." */ USERNAME_DESCRIPTION: "Enter the username you want to use to log in.",
    /** @default "Please use 32 characters at maximum." */ USERNAME_INSTRUCTIONS: "Please use 32 characters at maximum.",
    /** @default "Username" */ USERNAME_PLACEHOLDER: "Username",
    /** @default "Username or email" */ SIGN_IN_USERNAME_PLACEHOLDER: "Username or email",
    /** @default "Verify Your Email" */ VERIFY_YOUR_EMAIL: "Verify Your Email",
    /** @default "Please verify your email address. Check your inbox for the verification email. If you haven't received the email, click the button below to resend." */ VERIFY_YOUR_EMAIL_DESCRIPTION: "Please verify your email address. Check your inbox for the verification email. If you haven't received the email, click the button below to resend.",
    /** @default "Go back" */ GO_BACK: "Go back",
    /** @default "Your session is not fresh. Please sign in again." */ SESSION_NOT_FRESH: "Your session is not fresh. Please sign in again.",
    /** @default "Upload Avatar" */ UPLOAD_AVATAR: "Upload Avatar",
    /** @default "Logo" */ LOGO: "Logo",
    /** @default "Click on the logo to upload a custom one from your files." */ LOGO_DESCRIPTION: "Click on the logo to upload a custom one from your files.",
    /** @default "A logo is optional but strongly recommended." */ LOGO_INSTRUCTIONS: "A logo is optional but strongly recommended.",
    /** @default "Upload" */ UPLOAD: "Upload",
    /** @default "Upload Logo" */ UPLOAD_LOGO: "Upload Logo",
    /** @default "Delete Logo" */ DELETE_LOGO: "Delete Logo",
    /** @default "Privacy Policy" */ PRIVACY_POLICY: "Privacy Policy",
    /** @default "Terms of Service" */ TERMS_OF_SERVICE: "Terms of Service",
    /** @default "This site is protected by reCAPTCHA." */ PROTECTED_BY_RECAPTCHA: "This site is protected by reCAPTCHA.",
    /** @default "By continuing, you agree to the" */ BY_CONTINUING_YOU_AGREE: "By continuing, you agree to the",
    /** @default "User" */ USER: "User",
    /** @default "Organizations" */ ORGANIZATIONS: "Organizations",
    /** @default "Manage your organizations and memberships." */ ORGANIZATIONS_DESCRIPTION: "Manage your organizations and memberships.",
    /** @default "Create an organization to collaborate with other users." */ ORGANIZATIONS_INSTRUCTIONS: "Create an organization to collaborate with other users.",
    /** @default "Leave Organization" */ LEAVE_ORGANIZATION: "Leave Organization",
    /** @default "Are you sure you want to leave this organization?" */ LEAVE_ORGANIZATION_CONFIRM: "Are you sure you want to leave this organization?",
    /** @default "You have successfully left the organization." */ LEAVE_ORGANIZATION_SUCCESS: "You have successfully left the organization.",
    /** @default "Manage Organization" */ MANAGE_ORGANIZATION: "Manage Organization",
    /** @default "Remove Member" */ REMOVE_MEMBER: "Remove Member",
    /** @default "Are you sure you want to remove this member from the organization?" */ REMOVE_MEMBER_CONFIRM: "Are you sure you want to remove this member from the organization?",
    /** @default "Member removed successfully" */ REMOVE_MEMBER_SUCCESS: "Member removed successfully",
    /** @default "Invite Member" */ INVITE_MEMBER: "Invite Member",
    /** @default "Members" */ MEMBERS: "Members",
    /** @default "Add or remove members and manage their roles." */ MEMBERS_DESCRIPTION: "Add or remove members and manage their roles.",
    /** @default "Invite new members to your organization." */ MEMBERS_INSTRUCTIONS: "Invite new members to your organization.",
    /** @default "Send an invitation to add a new member to your organization." */ INVITE_MEMBER_DESCRIPTION: "Send an invitation to add a new member to your organization.",
    /** @default "Role" */ ROLE: "Role",
    /** @default "Select a role" */ SELECT_ROLE: "Select a role",
    /** @default "Admin" */ ADMIN: "Admin",
    /** @default "Member" */ MEMBER: "Member",
    /** @default "Guest" */ GUEST: "Guest",
    /** @default "Owner" */ OWNER: "Owner",
    /** @default "Update the role for this member" */ UPDATE_ROLE_DESCRIPTION: "Update the role for this member",
    /** @default "Update Role" */ UPDATE_ROLE: "Update Role",
    /** @default "Member role updated successfully" */ MEMBER_ROLE_UPDATED: "Member role updated successfully",
    /** @default "Send Invitation" */ SEND_INVITATION: "Send Invitation",
    /** @default "Invitation sent successfully" */ SEND_INVITATION_SUCCESS: "Invitation sent successfully",
    /** @default "Pending Invitations" */ PENDING_INVITATIONS: "Pending Invitations",
    /** @default "Manage pending invitations to your organization." */ PENDING_INVITATIONS_DESCRIPTION: "Manage pending invitations to your organization.",
    /** @default "Invitations you've received from organizations." */ PENDING_USER_INVITATIONS_DESCRIPTION: "Invitations you've received from organizations.",
    /** @default "Cancel Invitation" */ CANCEL_INVITATION: "Cancel Invitation",
    /** @default "Invitation cancelled successfully" */ INVITATION_CANCELLED: "Invitation cancelled successfully",
    /** @default "Accept Invitation" */ ACCEPT_INVITATION: "Accept Invitation",
    /** @default "You have been invited to join an organization." */ ACCEPT_INVITATION_DESCRIPTION: "You have been invited to join an organization.",
    /** @default "Invitation accepted successfully" */ INVITATION_ACCEPTED: "Invitation accepted successfully",
    /** @default "Invitation rejected successfully" */ INVITATION_REJECTED: "Invitation rejected successfully",
    /** @default "Accept" */ ACCEPT: "Accept",
    /** @default "Reject" */ REJECT: "Reject",
    /** @default "This invitation has expired" */ INVITATION_EXPIRED: "This invitation has expired",
    /** @default "Delete Organization" */ DELETE_ORGANIZATION: "Delete Organization",
    /** @default "Permanently remove your organization and all of its contents. This action is not reversible — please continue with caution." */ DELETE_ORGANIZATION_DESCRIPTION: "Permanently remove your organization and all of its contents. This action is not reversible \u2014 please continue with caution.",
    /** @default "Organization deleted successfully" */ DELETE_ORGANIZATION_SUCCESS: "Organization deleted successfully",
    /** @default "Enter the organization slug to continue:" */ DELETE_ORGANIZATION_INSTRUCTIONS: "Enter the organization slug to continue:",
    /** @default "Organization slug is required" */ SLUG_REQUIRED: "Organization slug is required",
    /** @default "The slug does not match" */ SLUG_DOES_NOT_MATCH: "The slug does not match",
    /** @default "Unknown" */ UNKNOWN: "Unknown",
    ...$220046a7533cffdb$var$BASE_ERROR_CODES,
    ...$220046a7533cffdb$var$ADMIN_ERROR_CODES,
    ...$220046a7533cffdb$var$ANONYMOUS_ERROR_CODES,
    ...$220046a7533cffdb$var$API_KEY_ERROR_CODES,
    ...$220046a7533cffdb$var$CAPTCHA_ERROR_CODES,
    ...$220046a7533cffdb$var$EMAIL_OTP_ERROR_CODES,
    ...$220046a7533cffdb$var$GENERIC_OAUTH_ERROR_CODES,
    ...$220046a7533cffdb$var$HAVEIBEENPWNED_ERROR_CODES,
    ...$220046a7533cffdb$var$MULTI_SESSION_ERROR_CODES,
    ...$220046a7533cffdb$var$ORGANIZATION_ERROR_CODES,
    ...$220046a7533cffdb$var$PASSKEY_ERROR_CODES,
    ...$220046a7533cffdb$var$PHONE_NUMBER_ERROR_CODES,
    ...$220046a7533cffdb$var$STRIPE_ERROR_CODES,
    ...$220046a7533cffdb$var$TWO_FACTOR_ERROR_CODES,
    ...$220046a7533cffdb$var$USERNAME_ERROR_CODES
};
// src/lib/view-paths.ts
var $220046a7533cffdb$export$5dc0d48aa89a4acc = {
    /** @default "callback" */ CALLBACK: "callback",
    /** @default "email-otp" */ EMAIL_OTP: "email-otp",
    /** @default "forgot-password" */ FORGOT_PASSWORD: "forgot-password",
    /** @default "magic-link" */ MAGIC_LINK: "magic-link",
    /** @default "recover-account" */ RECOVER_ACCOUNT: "recover-account",
    /** @default "reset-password" */ RESET_PASSWORD: "reset-password",
    /** @default "sign-in" */ SIGN_IN: "sign-in",
    /** @default "sign-out" */ SIGN_OUT: "sign-out",
    /** @default "sign-up" */ SIGN_UP: "sign-up",
    /** @default "two-factor" */ TWO_FACTOR: "two-factor",
    /** @default "accept-invitation" */ ACCEPT_INVITATION: "accept-invitation"
};
var $220046a7533cffdb$export$486f5d213d473670 = {
    /** @default "settings" */ SETTINGS: "settings",
    /** @default "security" */ SECURITY: "security",
    /** @default "api-keys" */ API_KEYS: "api-keys",
    /** @default "organizations" */ ORGANIZATIONS: "organizations"
};
var $220046a7533cffdb$export$6c6a5ee601b29a67 = {
    /** @default "settings" */ SETTINGS: "settings",
    /** @default "members" */ MEMBERS: "members",
    /** @default "api-keys" */ API_KEYS: "api-keys"
};



var $7PdBe = parcelRequire("7PdBe");
var $0bf2944f2fb447de$exports = {};
"use client";
var $0bf2944f2fb447de$var$se = Object.create;
var $0bf2944f2fb447de$var$ft = Object.defineProperty;
var $0bf2944f2fb447de$var$re = Object.getOwnPropertyDescriptor;
var $0bf2944f2fb447de$var$ne = Object.getOwnPropertyNames;
var $0bf2944f2fb447de$var$ie = Object.getPrototypeOf, $0bf2944f2fb447de$var$le = Object.prototype.hasOwnProperty;
var $0bf2944f2fb447de$var$ce = (s, e)=>{
    for(var t in e)$0bf2944f2fb447de$var$ft(s, t, {
        get: e[t],
        enumerable: !0
    });
}, $0bf2944f2fb447de$var$Ot = (s, e, t, a)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let l of $0bf2944f2fb447de$var$ne(e))!$0bf2944f2fb447de$var$le.call(s, l) && l !== t && $0bf2944f2fb447de$var$ft(s, l, {
        get: ()=>e[l],
        enumerable: !(a = $0bf2944f2fb447de$var$re(e, l)) || a.enumerable
    });
    return s;
};
var $0bf2944f2fb447de$var$tt = (s, e, t)=>(t = s != null ? $0bf2944f2fb447de$var$se($0bf2944f2fb447de$var$ie(s)) : {}, $0bf2944f2fb447de$var$Ot(e || !s || !s.__esModule ? $0bf2944f2fb447de$var$ft(t, "default", {
        value: s,
        enumerable: !0
    }) : t, s)), $0bf2944f2fb447de$var$de = (s)=>$0bf2944f2fb447de$var$Ot($0bf2944f2fb447de$var$ft({}, "__esModule", {
        value: !0
    }), s);
var $0bf2944f2fb447de$var$Me = {};
$0bf2944f2fb447de$var$ce($0bf2944f2fb447de$var$Me, {
    Toaster: ()=>$0bf2944f2fb447de$var$Ie,
    toast: ()=>$0bf2944f2fb447de$var$Ut,
    useSonner: ()=>$0bf2944f2fb447de$var$ke
});
$0bf2944f2fb447de$exports = $0bf2944f2fb447de$var$de($0bf2944f2fb447de$var$Me);

var $0bf2944f2fb447de$var$o = $0bf2944f2fb447de$var$tt((parcelRequire("7PdBe")));

var $0bf2944f2fb447de$var$pt = $0bf2944f2fb447de$var$tt((parcelRequire("1cUCD")));

var $0bf2944f2fb447de$var$S = $0bf2944f2fb447de$var$tt((parcelRequire("7PdBe"))), $0bf2944f2fb447de$var$$t = (s)=>{
    switch(s){
        case "success":
            return $0bf2944f2fb447de$var$fe;
        case "info":
            return $0bf2944f2fb447de$var$me;
        case "warning":
            return $0bf2944f2fb447de$var$pe;
        case "error":
            return $0bf2944f2fb447de$var$ge;
        default:
            return null;
    }
}, $0bf2944f2fb447de$var$ue = Array(12).fill(0), $0bf2944f2fb447de$var$Ft = ({ visible: s, className: e })=>$0bf2944f2fb447de$var$S.default.createElement("div", {
        className: [
            "sonner-loading-wrapper",
            e
        ].filter(Boolean).join(" "),
        "data-visible": s
    }, $0bf2944f2fb447de$var$S.default.createElement("div", {
        className: "sonner-spinner"
    }, $0bf2944f2fb447de$var$ue.map((t, a)=>$0bf2944f2fb447de$var$S.default.createElement("div", {
            className: "sonner-loading-bar",
            key: `spinner-bar-${a}`
        })))), $0bf2944f2fb447de$var$fe = $0bf2944f2fb447de$var$S.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, $0bf2944f2fb447de$var$S.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    clipRule: "evenodd"
})), $0bf2944f2fb447de$var$pe = $0bf2944f2fb447de$var$S.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    height: "20",
    width: "20"
}, $0bf2944f2fb447de$var$S.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
})), $0bf2944f2fb447de$var$me = $0bf2944f2fb447de$var$S.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, $0bf2944f2fb447de$var$S.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    clipRule: "evenodd"
})), $0bf2944f2fb447de$var$ge = $0bf2944f2fb447de$var$S.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, $0bf2944f2fb447de$var$S.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
})), $0bf2944f2fb447de$var$Wt = $0bf2944f2fb447de$var$S.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}, $0bf2944f2fb447de$var$S.default.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
}), $0bf2944f2fb447de$var$S.default.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
}));

var $0bf2944f2fb447de$var$xt = $0bf2944f2fb447de$var$tt((parcelRequire("7PdBe"))), $0bf2944f2fb447de$var$_t = ()=>{
    let [s, e] = $0bf2944f2fb447de$var$xt.default.useState(document.hidden);
    return $0bf2944f2fb447de$var$xt.default.useEffect(()=>{
        let t = ()=>{
            e(document.hidden);
        };
        return document.addEventListener("visibilitychange", t), ()=>window.removeEventListener("visibilitychange", t);
    }, []), s;
};

var $0bf2944f2fb447de$var$Vt = $0bf2944f2fb447de$var$tt((parcelRequire("7PdBe"))), $0bf2944f2fb447de$var$vt = 1, $0bf2944f2fb447de$var$Tt = class {
    constructor(){
        this.subscribe = (e)=>(this.subscribers.push(e), ()=>{
                let t = this.subscribers.indexOf(e);
                this.subscribers.splice(t, 1);
            });
        this.publish = (e)=>{
            this.subscribers.forEach((t)=>t(e));
        };
        this.addToast = (e)=>{
            this.publish(e), this.toasts = [
                ...this.toasts,
                e
            ];
        };
        this.create = (e)=>{
            var R;
            let { message: t, ...a } = e, l = typeof (e == null ? void 0 : e.id) == "number" || ((R = e.id) == null ? void 0 : R.length) > 0 ? e.id : $0bf2944f2fb447de$var$vt++, f = this.toasts.find((g)=>g.id === l), w = e.dismissible === void 0 ? !0 : e.dismissible;
            return this.dismissedToasts.has(l) && this.dismissedToasts.delete(l), f ? this.toasts = this.toasts.map((g)=>g.id === l ? (this.publish({
                    ...g,
                    ...e,
                    id: l,
                    title: t
                }), {
                    ...g,
                    ...e,
                    id: l,
                    dismissible: w,
                    title: t
                }) : g) : this.addToast({
                title: t,
                ...a,
                dismissible: w,
                id: l
            }), l;
        };
        this.dismiss = (e)=>(this.dismissedToasts.add(e), e || this.toasts.forEach((t)=>{
                this.subscribers.forEach((a)=>a({
                        id: t.id,
                        dismiss: !0
                    }));
            }), this.subscribers.forEach((t)=>t({
                    id: e,
                    dismiss: !0
                })), e);
        this.message = (e, t)=>this.create({
                ...t,
                message: e
            });
        this.error = (e, t)=>this.create({
                ...t,
                message: e,
                type: "error"
            });
        this.success = (e, t)=>this.create({
                ...t,
                type: "success",
                message: e
            });
        this.info = (e, t)=>this.create({
                ...t,
                type: "info",
                message: e
            });
        this.warning = (e, t)=>this.create({
                ...t,
                type: "warning",
                message: e
            });
        this.loading = (e, t)=>this.create({
                ...t,
                type: "loading",
                message: e
            });
        this.promise = (e, t)=>{
            if (!t) return;
            let a;
            t.loading !== void 0 && (a = this.create({
                ...t,
                promise: e,
                type: "loading",
                message: t.loading,
                description: typeof t.description != "function" ? t.description : void 0
            }));
            let l = e instanceof Promise ? e : e(), f = a !== void 0, w, R = l.then(async (i)=>{
                if (w = [
                    "resolve",
                    i
                ], $0bf2944f2fb447de$var$Vt.default.isValidElement(i)) f = !1, this.create({
                    id: a,
                    type: "default",
                    message: i
                });
                else if ($0bf2944f2fb447de$var$be(i) && !i.ok) {
                    f = !1;
                    let T = typeof t.error == "function" ? await t.error(`HTTP error! status: ${i.status}`) : t.error, F = typeof t.description == "function" ? await t.description(`HTTP error! status: ${i.status}`) : t.description;
                    this.create({
                        id: a,
                        type: "error",
                        message: T,
                        description: F
                    });
                } else if (t.success !== void 0) {
                    f = !1;
                    let T = typeof t.success == "function" ? await t.success(i) : t.success, F = typeof t.description == "function" ? await t.description(i) : t.description;
                    this.create({
                        id: a,
                        type: "success",
                        message: T,
                        description: F
                    });
                }
            }).catch(async (i)=>{
                if (w = [
                    "reject",
                    i
                ], t.error !== void 0) {
                    f = !1;
                    let D = typeof t.error == "function" ? await t.error(i) : t.error, T = typeof t.description == "function" ? await t.description(i) : t.description;
                    this.create({
                        id: a,
                        type: "error",
                        message: D,
                        description: T
                    });
                }
            }).finally(()=>{
                var i;
                f && (this.dismiss(a), a = void 0), (i = t.finally) == null || i.call(t);
            }), g = ()=>new Promise((i, D)=>R.then(()=>w[0] === "reject" ? D(w[1]) : i(w[1])).catch(D));
            return typeof a != "string" && typeof a != "number" ? {
                unwrap: g
            } : Object.assign(a, {
                unwrap: g
            });
        };
        this.custom = (e, t)=>{
            let a = (t == null ? void 0 : t.id) || $0bf2944f2fb447de$var$vt++;
            return this.create({
                jsx: e(a),
                id: a,
                ...t
            }), a;
        };
        this.getActiveToasts = ()=>this.toasts.filter((e)=>!this.dismissedToasts.has(e.id));
        this.subscribers = [], this.toasts = [], this.dismissedToasts = new Set;
    }
}, $0bf2944f2fb447de$var$v = new $0bf2944f2fb447de$var$Tt, $0bf2944f2fb447de$var$he = (s, e)=>{
    let t = (e == null ? void 0 : e.id) || $0bf2944f2fb447de$var$vt++;
    return $0bf2944f2fb447de$var$v.addToast({
        title: s,
        ...e,
        id: t
    }), t;
}, $0bf2944f2fb447de$var$be = (s)=>s && typeof s == "object" && "ok" in s && typeof s.ok == "boolean" && "status" in s && typeof s.status == "number", $0bf2944f2fb447de$var$ye = $0bf2944f2fb447de$var$he, $0bf2944f2fb447de$var$we = ()=>$0bf2944f2fb447de$var$v.toasts, $0bf2944f2fb447de$var$xe = ()=>$0bf2944f2fb447de$var$v.getActiveToasts(), $0bf2944f2fb447de$var$Ut = Object.assign($0bf2944f2fb447de$var$ye, {
    success: $0bf2944f2fb447de$var$v.success,
    info: $0bf2944f2fb447de$var$v.info,
    warning: $0bf2944f2fb447de$var$v.warning,
    error: $0bf2944f2fb447de$var$v.error,
    custom: $0bf2944f2fb447de$var$v.custom,
    message: $0bf2944f2fb447de$var$v.message,
    promise: $0bf2944f2fb447de$var$v.promise,
    dismiss: $0bf2944f2fb447de$var$v.dismiss,
    loading: $0bf2944f2fb447de$var$v.loading
}, {
    getHistory: $0bf2944f2fb447de$var$we,
    getToasts: $0bf2944f2fb447de$var$xe
});
function $0bf2944f2fb447de$var$St(s, { insertAt: e } = {}) {
    if (!s || typeof document == "undefined") return;
    let t = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
    a.type = "text/css", e === "top" && t.firstChild ? t.insertBefore(a, t.firstChild) : t.appendChild(a), a.styleSheet ? a.styleSheet.cssText = s : a.appendChild(document.createTextNode(s));
}
$0bf2944f2fb447de$var$St(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function $0bf2944f2fb447de$var$et(s) {
    return s.label !== void 0;
}
var $0bf2944f2fb447de$var$ve = 3, $0bf2944f2fb447de$var$Te = "32px", $0bf2944f2fb447de$var$Se = "16px", $0bf2944f2fb447de$var$Kt = 4e3, $0bf2944f2fb447de$var$Re = 356, $0bf2944f2fb447de$var$Ee = 14, $0bf2944f2fb447de$var$De = 20, $0bf2944f2fb447de$var$Pe = 200;
function $0bf2944f2fb447de$var$M(...s) {
    return s.filter(Boolean).join(" ");
}
function $0bf2944f2fb447de$var$Ne(s) {
    let [e, t] = s.split("-"), a = [];
    return e && a.push(e), t && a.push(t), a;
}
var $0bf2944f2fb447de$var$Be = (s)=>{
    var Nt, Bt, Ct, kt, It, Mt, Ht, At, Lt, zt, jt;
    let { invert: e, toast: t, unstyled: a, interacting: l, setHeights: f, visibleToasts: w, heights: R, index: g, toasts: i, expanded: D, removeToast: T, defaultRichColors: F, closeButton: ot, style: mt, cancelButtonStyle: gt, actionButtonStyle: c, className: at = "", descriptionClassName: st = "", duration: X, position: rt, gap: ht, loadingIcon: nt, expandByDefault: B, classNames: r, icons: P, closeButtonAriaLabel: it = "Close toast", pauseWhenPageIsHidden: lt } = s, [Y, C] = $0bf2944f2fb447de$var$o.default.useState(null), [ct, J] = $0bf2944f2fb447de$var$o.default.useState(null), [W, H] = $0bf2944f2fb447de$var$o.default.useState(!1), [A, bt] = $0bf2944f2fb447de$var$o.default.useState(!1), [L, z] = $0bf2944f2fb447de$var$o.default.useState(!1), [dt, u] = $0bf2944f2fb447de$var$o.default.useState(!1), [h, y] = $0bf2944f2fb447de$var$o.default.useState(!1), [E, j] = $0bf2944f2fb447de$var$o.default.useState(0), [p, _] = $0bf2944f2fb447de$var$o.default.useState(0), O = $0bf2944f2fb447de$var$o.default.useRef(t.duration || X || $0bf2944f2fb447de$var$Kt), G = $0bf2944f2fb447de$var$o.default.useRef(null), k = $0bf2944f2fb447de$var$o.default.useRef(null), Jt = g === 0, Gt = g + 1 <= w, N = t.type, V = t.dismissible !== !1, Qt = t.className || "", qt = t.descriptionClassName || "", ut = $0bf2944f2fb447de$var$o.default.useMemo(()=>R.findIndex((n)=>n.toastId === t.id) || 0, [
        R,
        t.id
    ]), Zt = $0bf2944f2fb447de$var$o.default.useMemo(()=>{
        var n;
        return (n = t.closeButton) != null ? n : ot;
    }, [
        t.closeButton,
        ot
    ]), Rt = $0bf2944f2fb447de$var$o.default.useMemo(()=>t.duration || X || $0bf2944f2fb447de$var$Kt, [
        t.duration,
        X
    ]), yt = $0bf2944f2fb447de$var$o.default.useRef(0), U = $0bf2944f2fb447de$var$o.default.useRef(0), Et = $0bf2944f2fb447de$var$o.default.useRef(0), K = $0bf2944f2fb447de$var$o.default.useRef(null), [te, ee] = rt.split("-"), Dt = $0bf2944f2fb447de$var$o.default.useMemo(()=>R.reduce((n, m, d)=>d >= ut ? n : n + m.height, 0), [
        R,
        ut
    ]), Pt = $0bf2944f2fb447de$var$_t(), oe = t.invert || e, wt = N === "loading";
    U.current = $0bf2944f2fb447de$var$o.default.useMemo(()=>ut * ht + Dt, [
        ut,
        Dt
    ]), $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        O.current = Rt;
    }, [
        Rt
    ]), $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        H(!0);
    }, []), $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        let n = k.current;
        if (n) {
            let m = n.getBoundingClientRect().height;
            return _(m), f((d)=>[
                    {
                        toastId: t.id,
                        height: m,
                        position: t.position
                    },
                    ...d
                ]), ()=>f((d)=>d.filter((b)=>b.toastId !== t.id));
        }
    }, [
        f,
        t.id
    ]), $0bf2944f2fb447de$var$o.default.useLayoutEffect(()=>{
        if (!W) return;
        let n = k.current, m = n.style.height;
        n.style.height = "auto";
        let d = n.getBoundingClientRect().height;
        n.style.height = m, _(d), f((b)=>b.find((x)=>x.toastId === t.id) ? b.map((x)=>x.toastId === t.id ? {
                    ...x,
                    height: d
                } : x) : [
                {
                    toastId: t.id,
                    height: d,
                    position: t.position
                },
                ...b
            ]);
    }, [
        W,
        t.title,
        t.description,
        f,
        t.id
    ]);
    let $ = $0bf2944f2fb447de$var$o.default.useCallback(()=>{
        bt(!0), j(U.current), f((n)=>n.filter((m)=>m.toastId !== t.id)), setTimeout(()=>{
            T(t);
        }, $0bf2944f2fb447de$var$Pe);
    }, [
        t,
        T,
        f,
        U
    ]);
    $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        if (t.promise && N === "loading" || t.duration === 1 / 0 || t.type === "loading") return;
        let n;
        return D || l || lt && Pt ? (()=>{
            if (Et.current < yt.current) {
                let b = new Date().getTime() - yt.current;
                O.current = O.current - b;
            }
            Et.current = new Date().getTime();
        })() : (()=>{
            O.current !== 1 / 0 && (yt.current = new Date().getTime(), n = setTimeout(()=>{
                var b;
                (b = t.onAutoClose) == null || b.call(t, t), $();
            }, O.current));
        })(), ()=>clearTimeout(n);
    }, [
        D,
        l,
        t,
        N,
        lt,
        Pt,
        $
    ]), $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        t.delete && $();
    }, [
        $,
        t.delete
    ]);
    function ae() {
        var n, m, d;
        return P != null && P.loading ? $0bf2944f2fb447de$var$o.default.createElement("div", {
            className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.loader, (n = t == null ? void 0 : t.classNames) == null ? void 0 : n.loader, "sonner-loader"),
            "data-visible": N === "loading"
        }, P.loading) : nt ? $0bf2944f2fb447de$var$o.default.createElement("div", {
            className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.loader, (m = t == null ? void 0 : t.classNames) == null ? void 0 : m.loader, "sonner-loader"),
            "data-visible": N === "loading"
        }, nt) : $0bf2944f2fb447de$var$o.default.createElement($0bf2944f2fb447de$var$Ft, {
            className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.loader, (d = t == null ? void 0 : t.classNames) == null ? void 0 : d.loader),
            visible: N === "loading"
        });
    }
    return $0bf2944f2fb447de$var$o.default.createElement("li", {
        tabIndex: 0,
        ref: k,
        className: $0bf2944f2fb447de$var$M(at, Qt, r == null ? void 0 : r.toast, (Nt = t == null ? void 0 : t.classNames) == null ? void 0 : Nt.toast, r == null ? void 0 : r.default, r == null ? void 0 : r[N], (Bt = t == null ? void 0 : t.classNames) == null ? void 0 : Bt[N]),
        "data-sonner-toast": "",
        "data-rich-colors": (Ct = t.richColors) != null ? Ct : F,
        "data-styled": !(t.jsx || t.unstyled || a),
        "data-mounted": W,
        "data-promise": !!t.promise,
        "data-swiped": h,
        "data-removed": A,
        "data-visible": Gt,
        "data-y-position": te,
        "data-x-position": ee,
        "data-index": g,
        "data-front": Jt,
        "data-swiping": L,
        "data-dismissible": V,
        "data-type": N,
        "data-invert": oe,
        "data-swipe-out": dt,
        "data-swipe-direction": ct,
        "data-expanded": !!(D || B && W),
        style: {
            "--index": g,
            "--toasts-before": g,
            "--z-index": i.length - g,
            "--offset": `${A ? E : U.current}px`,
            "--initial-height": B ? "auto" : `${p}px`,
            ...mt,
            ...t.style
        },
        onDragEnd: ()=>{
            z(!1), C(null), K.current = null;
        },
        onPointerDown: (n)=>{
            wt || !V || (G.current = new Date, j(U.current), n.target.setPointerCapture(n.pointerId), n.target.tagName !== "BUTTON" && (z(!0), K.current = {
                x: n.clientX,
                y: n.clientY
            }));
        },
        onPointerUp: ()=>{
            var x, Q, q, Z;
            if (dt || !V) return;
            K.current = null;
            let n = Number(((x = k.current) == null ? void 0 : x.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), m = Number(((Q = k.current) == null ? void 0 : Q.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), d = new Date().getTime() - ((q = G.current) == null ? void 0 : q.getTime()), b = Y === "x" ? n : m, I = Math.abs(b) / d;
            if (Math.abs(b) >= $0bf2944f2fb447de$var$De || I > .11) {
                j(U.current), (Z = t.onDismiss) == null || Z.call(t, t), J(Y === "x" ? n > 0 ? "right" : "left" : m > 0 ? "down" : "up"), $(), u(!0), y(!1);
                return;
            }
            z(!1), C(null);
        },
        onPointerMove: (n)=>{
            var Q, q, Z, Yt;
            if (!K.current || !V || ((Q = window.getSelection()) == null ? void 0 : Q.toString().length) > 0) return;
            let d = n.clientY - K.current.y, b = n.clientX - K.current.x, I = (q = s.swipeDirections) != null ? q : $0bf2944f2fb447de$var$Ne(rt);
            !Y && (Math.abs(b) > 1 || Math.abs(d) > 1) && C(Math.abs(b) > Math.abs(d) ? "x" : "y");
            let x = {
                x: 0,
                y: 0
            };
            Y === "y" ? (I.includes("top") || I.includes("bottom")) && (I.includes("top") && d < 0 || I.includes("bottom") && d > 0) && (x.y = d) : Y === "x" && (I.includes("left") || I.includes("right")) && (I.includes("left") && b < 0 || I.includes("right") && b > 0) && (x.x = b), (Math.abs(x.x) > 0 || Math.abs(x.y) > 0) && y(!0), (Z = k.current) == null || Z.style.setProperty("--swipe-amount-x", `${x.x}px`), (Yt = k.current) == null || Yt.style.setProperty("--swipe-amount-y", `${x.y}px`);
        }
    }, Zt && !t.jsx ? $0bf2944f2fb447de$var$o.default.createElement("button", {
        "aria-label": it,
        "data-disabled": wt,
        "data-close-button": !0,
        onClick: wt || !V ? ()=>{} : ()=>{
            var n;
            $(), (n = t.onDismiss) == null || n.call(t, t);
        },
        className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.closeButton, (kt = t == null ? void 0 : t.classNames) == null ? void 0 : kt.closeButton)
    }, (It = P == null ? void 0 : P.close) != null ? It : $0bf2944f2fb447de$var$Wt) : null, t.jsx || (0, $0bf2944f2fb447de$var$o.isValidElement)(t.title) ? t.jsx ? t.jsx : typeof t.title == "function" ? t.title() : t.title : $0bf2944f2fb447de$var$o.default.createElement($0bf2944f2fb447de$var$o.default.Fragment, null, N || t.icon || t.promise ? $0bf2944f2fb447de$var$o.default.createElement("div", {
        "data-icon": "",
        className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.icon, (Mt = t == null ? void 0 : t.classNames) == null ? void 0 : Mt.icon)
    }, t.promise || t.type === "loading" && !t.icon ? t.icon || ae() : null, t.type !== "loading" ? t.icon || (P == null ? void 0 : P[N]) || $0bf2944f2fb447de$var$$t(N) : null) : null, $0bf2944f2fb447de$var$o.default.createElement("div", {
        "data-content": "",
        className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.content, (Ht = t == null ? void 0 : t.classNames) == null ? void 0 : Ht.content)
    }, $0bf2944f2fb447de$var$o.default.createElement("div", {
        "data-title": "",
        className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.title, (At = t == null ? void 0 : t.classNames) == null ? void 0 : At.title)
    }, typeof t.title == "function" ? t.title() : t.title), t.description ? $0bf2944f2fb447de$var$o.default.createElement("div", {
        "data-description": "",
        className: $0bf2944f2fb447de$var$M(st, qt, r == null ? void 0 : r.description, (Lt = t == null ? void 0 : t.classNames) == null ? void 0 : Lt.description)
    }, typeof t.description == "function" ? t.description() : t.description) : null), (0, $0bf2944f2fb447de$var$o.isValidElement)(t.cancel) ? t.cancel : t.cancel && $0bf2944f2fb447de$var$et(t.cancel) ? $0bf2944f2fb447de$var$o.default.createElement("button", {
        "data-button": !0,
        "data-cancel": !0,
        style: t.cancelButtonStyle || gt,
        onClick: (n)=>{
            var m, d;
            $0bf2944f2fb447de$var$et(t.cancel) && V && ((d = (m = t.cancel).onClick) == null || d.call(m, n), $());
        },
        className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.cancelButton, (zt = t == null ? void 0 : t.classNames) == null ? void 0 : zt.cancelButton)
    }, t.cancel.label) : null, (0, $0bf2944f2fb447de$var$o.isValidElement)(t.action) ? t.action : t.action && $0bf2944f2fb447de$var$et(t.action) ? $0bf2944f2fb447de$var$o.default.createElement("button", {
        "data-button": !0,
        "data-action": !0,
        style: t.actionButtonStyle || c,
        onClick: (n)=>{
            var m, d;
            $0bf2944f2fb447de$var$et(t.action) && ((d = (m = t.action).onClick) == null || d.call(m, n), !n.defaultPrevented && $());
        },
        className: $0bf2944f2fb447de$var$M(r == null ? void 0 : r.actionButton, (jt = t == null ? void 0 : t.classNames) == null ? void 0 : jt.actionButton)
    }, t.action.label) : null));
};
function $0bf2944f2fb447de$var$Xt() {
    if (typeof window == "undefined" || typeof document == "undefined") return "ltr";
    let s = document.documentElement.getAttribute("dir");
    return s === "auto" || !s ? window.getComputedStyle(document.documentElement).direction : s;
}
function $0bf2944f2fb447de$var$Ce(s, e) {
    let t = {};
    return [
        s,
        e
    ].forEach((a, l)=>{
        let f = l === 1, w = f ? "--mobile-offset" : "--offset", R = f ? $0bf2944f2fb447de$var$Se : $0bf2944f2fb447de$var$Te;
        function g(i) {
            [
                "top",
                "right",
                "bottom",
                "left"
            ].forEach((D)=>{
                t[`${w}-${D}`] = typeof i == "number" ? `${i}px` : i;
            });
        }
        typeof a == "number" || typeof a == "string" ? g(a) : typeof a == "object" ? [
            "top",
            "right",
            "bottom",
            "left"
        ].forEach((i)=>{
            a[i] === void 0 ? t[`${w}-${i}`] = R : t[`${w}-${i}`] = typeof a[i] == "number" ? `${a[i]}px` : a[i];
        }) : g(R);
    }), t;
}
function $0bf2944f2fb447de$var$ke() {
    let [s, e] = $0bf2944f2fb447de$var$o.default.useState([]);
    return $0bf2944f2fb447de$var$o.default.useEffect(()=>$0bf2944f2fb447de$var$v.subscribe((t)=>{
            if (t.dismiss) {
                setTimeout(()=>{
                    $0bf2944f2fb447de$var$pt.default.flushSync(()=>{
                        e((a)=>a.filter((l)=>l.id !== t.id));
                    });
                });
                return;
            }
            setTimeout(()=>{
                $0bf2944f2fb447de$var$pt.default.flushSync(()=>{
                    e((a)=>{
                        let l = a.findIndex((f)=>f.id === t.id);
                        return l !== -1 ? [
                            ...a.slice(0, l),
                            {
                                ...a[l],
                                ...t
                            },
                            ...a.slice(l + 1)
                        ] : [
                            t,
                            ...a
                        ];
                    });
                });
            });
        }), []), {
        toasts: s
    };
}
var $0bf2944f2fb447de$var$Ie = (0, $0bf2944f2fb447de$var$o.forwardRef)(function(e, t) {
    let { invert: a, position: l = "bottom-right", hotkey: f = [
        "altKey",
        "KeyT"
    ], expand: w, closeButton: R, className: g, offset: i, mobileOffset: D, theme: T = "light", richColors: F, duration: ot, style: mt, visibleToasts: gt = $0bf2944f2fb447de$var$ve, toastOptions: c, dir: at = $0bf2944f2fb447de$var$Xt(), gap: st = $0bf2944f2fb447de$var$Ee, loadingIcon: X, icons: rt, containerAriaLabel: ht = "Notifications", pauseWhenPageIsHidden: nt } = e, [B, r] = $0bf2944f2fb447de$var$o.default.useState([]), P = $0bf2944f2fb447de$var$o.default.useMemo(()=>Array.from(new Set([
            l
        ].concat(B.filter((u)=>u.position).map((u)=>u.position)))), [
        B,
        l
    ]), [it, lt] = $0bf2944f2fb447de$var$o.default.useState([]), [Y, C] = $0bf2944f2fb447de$var$o.default.useState(!1), [ct, J] = $0bf2944f2fb447de$var$o.default.useState(!1), [W, H] = $0bf2944f2fb447de$var$o.default.useState(T !== "system" ? T : typeof window != "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), A = $0bf2944f2fb447de$var$o.default.useRef(null), bt = f.join("+").replace(/Key/g, "").replace(/Digit/g, ""), L = $0bf2944f2fb447de$var$o.default.useRef(null), z = $0bf2944f2fb447de$var$o.default.useRef(!1), dt = $0bf2944f2fb447de$var$o.default.useCallback((u)=>{
        r((h)=>{
            var y;
            return (y = h.find((E)=>E.id === u.id)) != null && y.delete || $0bf2944f2fb447de$var$v.dismiss(u.id), h.filter(({ id: E })=>E !== u.id);
        });
    }, []);
    return $0bf2944f2fb447de$var$o.default.useEffect(()=>$0bf2944f2fb447de$var$v.subscribe((u)=>{
            if (u.dismiss) {
                r((h)=>h.map((y)=>y.id === u.id ? {
                            ...y,
                            delete: !0
                        } : y));
                return;
            }
            setTimeout(()=>{
                $0bf2944f2fb447de$var$pt.default.flushSync(()=>{
                    r((h)=>{
                        let y = h.findIndex((E)=>E.id === u.id);
                        return y !== -1 ? [
                            ...h.slice(0, y),
                            {
                                ...h[y],
                                ...u
                            },
                            ...h.slice(y + 1)
                        ] : [
                            u,
                            ...h
                        ];
                    });
                });
            });
        }), []), $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        if (T !== "system") {
            H(T);
            return;
        }
        if (T === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? H("dark") : H("light")), typeof window == "undefined") return;
        let u = window.matchMedia("(prefers-color-scheme: dark)");
        try {
            u.addEventListener("change", ({ matches: h })=>{
                H(h ? "dark" : "light");
            });
        } catch (h) {
            u.addListener(({ matches: y })=>{
                try {
                    H(y ? "dark" : "light");
                } catch (E) {
                    console.error(E);
                }
            });
        }
    }, [
        T
    ]), $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        B.length <= 1 && C(!1);
    }, [
        B
    ]), $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        let u = (h)=>{
            var E, j;
            f.every((p)=>h[p] || h.code === p) && (C(!0), (E = A.current) == null || E.focus()), h.code === "Escape" && (document.activeElement === A.current || (j = A.current) != null && j.contains(document.activeElement)) && C(!1);
        };
        return document.addEventListener("keydown", u), ()=>document.removeEventListener("keydown", u);
    }, [
        f
    ]), $0bf2944f2fb447de$var$o.default.useEffect(()=>{
        if (A.current) return ()=>{
            L.current && (L.current.focus({
                preventScroll: !0
            }), L.current = null, z.current = !1);
        };
    }, [
        A.current
    ]), $0bf2944f2fb447de$var$o.default.createElement("section", {
        ref: t,
        "aria-label": `${ht} ${bt}`,
        tabIndex: -1,
        "aria-live": "polite",
        "aria-relevant": "additions text",
        "aria-atomic": "false",
        suppressHydrationWarning: !0
    }, P.map((u, h)=>{
        var j;
        let [y, E] = u.split("-");
        return B.length ? $0bf2944f2fb447de$var$o.default.createElement("ol", {
            key: u,
            dir: at === "auto" ? $0bf2944f2fb447de$var$Xt() : at,
            tabIndex: -1,
            ref: A,
            className: g,
            "data-sonner-toaster": !0,
            "data-theme": W,
            "data-y-position": y,
            "data-lifted": Y && B.length > 1 && !w,
            "data-x-position": E,
            style: {
                "--front-toast-height": `${((j = it[0]) == null ? void 0 : j.height) || 0}px`,
                "--width": `${$0bf2944f2fb447de$var$Re}px`,
                "--gap": `${st}px`,
                ...mt,
                ...$0bf2944f2fb447de$var$Ce(i, D)
            },
            onBlur: (p)=>{
                z.current && !p.currentTarget.contains(p.relatedTarget) && (z.current = !1, L.current && (L.current.focus({
                    preventScroll: !0
                }), L.current = null));
            },
            onFocus: (p)=>{
                p.target instanceof HTMLElement && p.target.dataset.dismissible === "false" || z.current || (z.current = !0, L.current = p.relatedTarget);
            },
            onMouseEnter: ()=>C(!0),
            onMouseMove: ()=>C(!0),
            onMouseLeave: ()=>{
                ct || C(!1);
            },
            onDragEnd: ()=>C(!1),
            onPointerDown: (p)=>{
                p.target instanceof HTMLElement && p.target.dataset.dismissible === "false" || J(!0);
            },
            onPointerUp: ()=>J(!1)
        }, B.filter((p)=>!p.position && h === 0 || p.position === u).map((p, _)=>{
            var O, G;
            return $0bf2944f2fb447de$var$o.default.createElement($0bf2944f2fb447de$var$Be, {
                key: p.id,
                icons: rt,
                index: _,
                toast: p,
                defaultRichColors: F,
                duration: (O = c == null ? void 0 : c.duration) != null ? O : ot,
                className: c == null ? void 0 : c.className,
                descriptionClassName: c == null ? void 0 : c.descriptionClassName,
                invert: a,
                visibleToasts: gt,
                closeButton: (G = c == null ? void 0 : c.closeButton) != null ? G : R,
                interacting: ct,
                position: u,
                style: c == null ? void 0 : c.style,
                unstyled: c == null ? void 0 : c.unstyled,
                classNames: c == null ? void 0 : c.classNames,
                cancelButtonStyle: c == null ? void 0 : c.cancelButtonStyle,
                actionButtonStyle: c == null ? void 0 : c.actionButtonStyle,
                removeToast: dt,
                toasts: B.filter((k)=>k.position == p.position),
                heights: it.filter((k)=>k.position == p.position),
                setHeights: lt,
                expandByDefault: w,
                gap: st,
                loadingIcon: X,
                expanded: Y,
                pauseWhenPageIsHidden: nt,
                swipeDirections: e.swipeDirections
            });
        })) : null;
    }));
});



var $hvk62 = parcelRequire("hvk62");

var $7PdBe = parcelRequire("7PdBe");
var $7abd3a06d8c4ddef$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $7abd3a06d8c4ddef$var$__DEV__ = false;
var $7abd3a06d8c4ddef$var$warning = function() {};
if ($7abd3a06d8c4ddef$var$__DEV__) {
    var $7abd3a06d8c4ddef$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $7abd3a06d8c4ddef$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $7abd3a06d8c4ddef$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$7abd3a06d8c4ddef$exports = $7abd3a06d8c4ddef$var$warning;



var $7PdBe = parcelRequire("7PdBe");
const $85f45565699dc9df$var$ReCaptchaContext = (0, $7PdBe.createContext)({});
var $85f45565699dc9df$export$2e2bcd8739ae039 = $85f45565699dc9df$var$ReCaptchaContext;


function $809dd6f200c89725$export$2cb99e4be0dc4646({ async: async, appendTo: appendTo, defer: defer, id: id, nonce: nonce, src: src }) {
    const script = document.createElement("script");
    if (async !== undefined) script.async = async;
    if (defer !== undefined) script.defer = defer;
    if (id) script.id = id;
    if (nonce) script.setAttribute("nonce", nonce);
    script.src = src;
    const appendTarget = appendTo === "head" ? document.head : document.body;
    appendTarget.appendChild(script);
}


var $bf58a0c7d6d2b788$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Holds the loaded script type. This is used to prevent multiple versions of the script from
 * being loaded.
 */ let $bf58a0c7d6d2b788$var$loadedUrl = null;
let $bf58a0c7d6d2b788$var$isLoaded = false;
const $bf58a0c7d6d2b788$var$instances = new Set();
const $bf58a0c7d6d2b788$var$onLoadCallbacks = new Set();
const $bf58a0c7d6d2b788$var$isBrowser = typeof window !== "undefined";
const $bf58a0c7d6d2b788$var$cfgKey = "___grecaptcha_cfg";
// Random name to prevent conflicts with other scripts
const $bf58a0c7d6d2b788$var$onLoadCallbackName = `onLoadCallback_${Math.random().toString(36).slice(2)}`;
function $bf58a0c7d6d2b788$var$initialize() {
    if (!$bf58a0c7d6d2b788$var$isBrowser) return;
    /**
     * Makes it possible for multiple reCAPTCHA instances to be loaded by wrapping the onReady
     * callback in a function that pushes the callbacks to a global array (fns). This array is then
     * executed when reCAPTCHA loads.
     *
     * A modified version of the script provided by Google:
     * https://developers.google.com/recaptcha/docs/loading#loading_recaptcha_asynchronously
     */ function ready(cb) {
        if ($bf58a0c7d6d2b788$var$isLoaded) cb();
        else {
            if (!window[$bf58a0c7d6d2b788$var$cfgKey]) window[$bf58a0c7d6d2b788$var$cfgKey] = {};
            const cfg = window[$bf58a0c7d6d2b788$var$cfgKey];
            if (!cfg.fns) cfg.fns = [];
            const fns = cfg.fns;
            fns.push(cb);
        }
    }
    if (!window.grecaptcha) window.grecaptcha = {};
    if (!window.grecaptcha.enterprise) window.grecaptcha.enterprise = {};
    window.grecaptcha.ready = ready;
    window.grecaptcha.enterprise.ready = ready;
    function onLoadCallback() {
        $bf58a0c7d6d2b788$var$isLoaded = true;
        for (const callback of $bf58a0c7d6d2b788$var$onLoadCallbacks)callback();
        $bf58a0c7d6d2b788$var$onLoadCallbacks.clear();
    }
    // @ts-ignore
    window[$bf58a0c7d6d2b788$var$onLoadCallbackName] = onLoadCallback;
}
function $bf58a0c7d6d2b788$var$generateGoogleRecaptchaSrc({ language: language, onLoadCallbackName: onLoadCallbackName, render: render, useEnterprise: useEnterprise = false, useRecaptchaNet: useRecaptchaNet = false }) {
    const host = useRecaptchaNet ? "recaptcha.net" : "google.com";
    const script = useEnterprise ? "enterprise.js" : "api.js";
    const params = new URLSearchParams({
        render: render
    });
    if (onLoadCallbackName) params.set("onload", onLoadCallbackName);
    if (language) params.set("hl", language);
    return `https://www.${host}/recaptcha/${script}?${params.toString()}`;
}
function $bf58a0c7d6d2b788$var$loadGoogleRecaptchaScript({ language: language, render: render, scriptProps: scriptProps, useEnterprise: useEnterprise, useRecaptchaNet: useRecaptchaNet }) {
    const defaultScriptProps = {
        id: "google-recaptcha-v3"
    };
    const src = $bf58a0c7d6d2b788$var$generateGoogleRecaptchaSrc({
        language: language,
        onLoadCallbackName: $bf58a0c7d6d2b788$var$onLoadCallbackName,
        render: render,
        useEnterprise: useEnterprise,
        useRecaptchaNet: useRecaptchaNet
    });
    if ($bf58a0c7d6d2b788$var$loadedUrl) {
        if ($bf58a0c7d6d2b788$var$loadedUrl !== src) throw new Error("reCAPTCHA has already been loaded with different parameters. Remove the existing script and load it again.");
        return;
    }
    $bf58a0c7d6d2b788$var$loadedUrl = src;
    (0, $809dd6f200c89725$export$2cb99e4be0dc4646)(Object.assign(Object.assign(Object.assign({}, defaultScriptProps), scriptProps), {
        src: src
    }));
}
function $bf58a0c7d6d2b788$export$5040e837a9e3cf22(clientId) {
    if (!window[$bf58a0c7d6d2b788$var$cfgKey]) return;
    const cfg = window[$bf58a0c7d6d2b788$var$cfgKey];
    if (!cfg.clients) return;
    delete cfg.clients[clientId];
}
function $bf58a0c7d6d2b788$export$ea4bcaef8454fd24(instanceId, _a) {
    var { onLoadCallback: onLoadCallback, onLoadCallbackName: onLoadCallbackName } = _a, loadGoogleRecaptchaScriptOptions = $bf58a0c7d6d2b788$var$__rest(_a, [
        "onLoadCallback",
        "onLoadCallbackName"
    ]);
    if ($bf58a0c7d6d2b788$var$instances.size === 0) $bf58a0c7d6d2b788$var$initialize();
    $bf58a0c7d6d2b788$var$loadGoogleRecaptchaScript(loadGoogleRecaptchaScriptOptions);
    $bf58a0c7d6d2b788$var$instances.add(instanceId);
    if (onLoadCallback) {
        if ($bf58a0c7d6d2b788$var$isLoaded) onLoadCallback();
        else $bf58a0c7d6d2b788$var$onLoadCallbacks.add(onLoadCallback);
    }
    if (onLoadCallbackName) {
        function callOnLoadCallbackIfExists() {
            if (!onLoadCallbackName) return;
            // @ts-ignore
            const maybeOnLoadCallback = window[onLoadCallbackName];
            if (typeof maybeOnLoadCallback === "function") maybeOnLoadCallback();
        }
        if ($bf58a0c7d6d2b788$var$isLoaded) callOnLoadCallbackIfExists();
        else $bf58a0c7d6d2b788$var$onLoadCallbacks.add(callOnLoadCallbackIfExists);
    }
}
function $bf58a0c7d6d2b788$export$6b9cdc983efc1beb(instanceId) {
    var _a, _b, _c;
    $bf58a0c7d6d2b788$var$instances.delete(instanceId);
    if ($bf58a0c7d6d2b788$var$instances.size === 0) {
        window.grecaptcha = undefined;
        window[$bf58a0c7d6d2b788$var$cfgKey] = undefined;
        (_a = document.querySelector(".grecaptcha-badge")) === null || _a === void 0 || _a.remove();
        (_b = document.querySelector(`script[src="${$bf58a0c7d6d2b788$var$loadedUrl}"]`)) === null || _b === void 0 || _b.remove();
        (_c = document.querySelector(`script[src^="https://www.gstatic.com/recaptcha/releases"]`)) === null || _c === void 0 || _c.remove();
        $bf58a0c7d6d2b788$var$loadedUrl = null;
        $bf58a0c7d6d2b788$var$isLoaded = false;
    }
}


let $6fa0d1b95691bc7e$var$didWarnAboutHiddenBadge = false;
function $6fa0d1b95691bc7e$export$2e2bcd8739ae039({ container: container, children: children, language: language, reCaptchaKey: reCaptchaKey, scriptProps: scriptProps, useEnterprise: useEnterprise, useRecaptchaNet: useRecaptchaNet }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const id = (0, $7PdBe.useId)();
    const [reCaptchaInstance, setReCaptchaInstance] = (0, $7PdBe.useState)(null);
    const [clientId, setClientId] = (0, $7PdBe.useState)(null);
    const clientIdMounted = (0, $7PdBe.useRef)(false);
    (0, $7PdBe.useEffect)(()=>{
        function onLoadCallback() {
            var _a;
            const nextReCaptchaInstance = useEnterprise ? (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise : window.grecaptcha;
            if (!nextReCaptchaInstance) throw new Error("reCAPTCHA not found");
            if (!nextReCaptchaInstance.ready) throw new Error("reCAPTCHA ready callback not found");
            nextReCaptchaInstance.ready(()=>{
                setReCaptchaInstance(nextReCaptchaInstance);
            });
        }
        (0, $bf58a0c7d6d2b788$export$ea4bcaef8454fd24)(id, {
            language: language,
            onLoadCallback: onLoadCallback,
            onLoadCallbackName: scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.onLoadCallbackName,
            render: (container === null || container === void 0 ? void 0 : container.element) ? "explicit" : reCaptchaKey,
            scriptProps: {
                appendTo: scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.appendTo,
                async: scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.async,
                defer: scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.defer,
                id: scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.id,
                nonce: scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.nonce
            },
            useEnterprise: useEnterprise,
            useRecaptchaNet: useRecaptchaNet
        });
        return ()=>{
            (0, $bf58a0c7d6d2b788$export$6b9cdc983efc1beb)(id);
            setReCaptchaInstance(null);
        };
    }, [
        container === null || container === void 0 ? void 0 : container.element,
        id,
        language,
        reCaptchaKey,
        scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.appendTo,
        scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.async,
        scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.defer,
        scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.id,
        scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.nonce,
        scriptProps === null || scriptProps === void 0 ? void 0 : scriptProps.onLoadCallbackName,
        useEnterprise,
        useRecaptchaNet
    ]);
    (0, $7PdBe.useEffect)(()=>{
        var _a, _b, _c;
        if (!(container === null || container === void 0 ? void 0 : container.element) || !(reCaptchaInstance === null || reCaptchaInstance === void 0 ? void 0 : reCaptchaInstance.render)) return;
        const params = {
            "error-callback": container.parameters.errorCallback,
            "expired-callback": container.parameters.expiredCallback,
            badge: ((_a = container.parameters) === null || _a === void 0 ? void 0 : _a.badge) || "inline",
            callback: container.parameters.callback,
            sitekey: reCaptchaKey,
            size: "invisible",
            tabindex: container.parameters.tabindex,
            theme: container.parameters.theme
        };
        const actualContainerElement = typeof (container === null || container === void 0 ? void 0 : container.element) === "string" ? document.getElementById(container.element) : container === null || container === void 0 ? void 0 : container.element;
        if (!actualContainerElement) throw new Error("reCAPTCHA container element not found");
        const nextClientId = reCaptchaInstance.render(actualContainerElement, params);
        if ((_b = container === null || container === void 0 ? void 0 : container.parameters) === null || _b === void 0 ? void 0 : _b.hidden) {
            if (!$6fa0d1b95691bc7e$var$didWarnAboutHiddenBadge) {
                (0, (/*@__PURE__*/$parcel$interopDefault($7abd3a06d8c4ddef$exports)))(false, "reCAPTCHA badge hidden. See https://cloud.google.com/recaptcha/docs/faq#id_like_to_hide_the_badge_what_is_allowed for more information.");
                $6fa0d1b95691bc7e$var$didWarnAboutHiddenBadge = true;
            }
            (_c = actualContainerElement.querySelector(".grecaptcha-badge")) === null || _c === void 0 || _c.style.setProperty("display", "none");
        }
        setClientId(nextClientId);
        clientIdMounted.current = true;
        return ()=>{
            setClientId(null);
            clientIdMounted.current = false;
            (0, $bf58a0c7d6d2b788$export$5040e837a9e3cf22)(nextClientId);
            actualContainerElement.innerHTML = "";
        };
    }, [
        container === null || container === void 0 ? void 0 : container.element,
        (_a = container === null || container === void 0 ? void 0 : container.parameters) === null || _a === void 0 ? void 0 : _a.badge,
        (_b = container === null || container === void 0 ? void 0 : container.parameters) === null || _b === void 0 ? void 0 : _b.hidden,
        (_c = container === null || container === void 0 ? void 0 : container.parameters) === null || _c === void 0 ? void 0 : _c.callback,
        (_d = container === null || container === void 0 ? void 0 : container.parameters) === null || _d === void 0 ? void 0 : _d.errorCallback,
        (_e = container === null || container === void 0 ? void 0 : container.parameters) === null || _e === void 0 ? void 0 : _e.expiredCallback,
        (_f = container === null || container === void 0 ? void 0 : container.parameters) === null || _f === void 0 ? void 0 : _f.tabindex,
        (_g = container === null || container === void 0 ? void 0 : container.parameters) === null || _g === void 0 ? void 0 : _g.theme,
        reCaptchaInstance,
        reCaptchaKey
    ]);
    const shouldUseClientId = Boolean(container === null || container === void 0 ? void 0 : container.element);
    const clientIdOrReCaptchaKey = shouldUseClientId ? clientId : reCaptchaKey;
    const executeRecaptcha = (0, $7PdBe.useMemo)(()=>clientIdOrReCaptchaKey !== null && (reCaptchaInstance === null || reCaptchaInstance === void 0 ? void 0 : reCaptchaInstance.execute) ? (action)=>{
            if (clientIdOrReCaptchaKey === null || !(reCaptchaInstance === null || reCaptchaInstance === void 0 ? void 0 : reCaptchaInstance.execute)) throw new Error("reCAPTCHA has not been loaded");
            if (shouldUseClientId && !clientIdMounted.current) {
                console.warn("Client ID not mounted");
                return null;
            }
            return reCaptchaInstance.execute(clientIdOrReCaptchaKey, {
                action: action
            });
        } : undefined, [
        clientIdOrReCaptchaKey,
        reCaptchaInstance,
        shouldUseClientId
    ]);
    return (0, $hvk62.jsx)((0, $85f45565699dc9df$export$2e2bcd8739ae039).Provider, {
        value: {
            container: container === null || container === void 0 ? void 0 : container.element,
            executeRecaptcha: executeRecaptcha,
            reCaptchaInstance: reCaptchaInstance
        },
        children: children
    });
}


var $7PdBe = parcelRequire("7PdBe");

function $2c6937dda4728c6c$export$2e2bcd8739ae039() {
    return (0, $7PdBe.useContext)((0, $85f45565699dc9df$export$2e2bcd8739ae039));
}



var $hvk62 = parcelRequire("hvk62");
"use client";
// src/lib/auth-data-cache.ts
var $07d0275849708341$var$AuthDataCache = class {
    cache = /* @__PURE__ */ new Map();
    listeners = /* @__PURE__ */ new Map();
    inFlightRequests = /* @__PURE__ */ new Map();
    get(key) {
        return this.cache.get(key);
    }
    set(key, data) {
        const entry = {
            data: data,
            timestamp: Date.now(),
            isRefetching: false
        };
        this.cache.set(key, entry);
        this.notify(key);
    }
    setRefetching(key, isRefetching) {
        const entry = this.cache.get(key);
        if (entry) {
            entry.isRefetching = isRefetching;
            this.notify(key);
        }
    }
    clear(key) {
        if (key) {
            this.cache.delete(key);
            this.inFlightRequests.delete(key);
            this.notify(key);
        } else {
            this.cache.clear();
            this.inFlightRequests.clear();
            const keys = Array.from(this.listeners.keys());
            for (const key2 of keys)this.notify(key2);
        }
    }
    getInFlightRequest(key) {
        return this.inFlightRequests.get(key);
    }
    setInFlightRequest(key, promise) {
        this.inFlightRequests.set(key, promise);
    }
    removeInFlightRequest(key) {
        this.inFlightRequests.delete(key);
    }
    subscribe(key, callback) {
        if (!this.listeners.has(key)) this.listeners.set(key, /* @__PURE__ */ new Set());
        this.listeners.get(key).add(callback);
        return ()=>{
            const callbacks = this.listeners.get(key);
            if (callbacks) {
                callbacks.delete(callback);
                if (callbacks.size === 0) this.listeners.delete(key);
            }
        };
    }
    notify(key) {
        const callbacks = this.listeners.get(key);
        if (callbacks) {
            const callbackArray = Array.from(callbacks);
            for (const callback of callbackArray)callback();
        }
    }
};
var $07d0275849708341$var$authDataCache = new $07d0275849708341$var$AuthDataCache();
function $07d0275849708341$var$subscribe() {
    return ()=>{};
}
function $07d0275849708341$export$fd0534379e135f3d() {
    return (0, $7PdBe.useSyncExternalStore)($07d0275849708341$var$subscribe, ()=>true, ()=>false);
}
function $07d0275849708341$export$b24a004ee43dce44() {
    const [lang, setLang] = (0, $7PdBe.useState)();
    (0, $7PdBe.useEffect)(()=>{
        const checkLang = ()=>{
            const currentLang = document.documentElement.getAttribute("lang");
            setLang(currentLang ?? void 0);
        };
        checkLang();
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.attributeName === "lang") checkLang();
        });
        observer.observe(document.documentElement, {
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return {
        lang: lang
    };
}
function $07d0275849708341$export$93d4e7f90805808f() {
    const [theme, setTheme] = (0, $7PdBe.useState)("light");
    (0, $7PdBe.useEffect)(()=>{
        const checkTheme = ()=>{
            var _a;
            const isDark = document.documentElement.classList.contains("dark") || ((_a = document.documentElement.getAttribute("style")) == null ? void 0 : _a.includes("color-scheme: dark"));
            setTheme(isDark ? "dark" : "light");
        };
        checkTheme();
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.attributeName === "style" || mutation.attributeName === "class") checkTheme();
        });
        observer.observe(document.documentElement, {
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return {
        theme: theme
    };
}
function $07d0275849708341$var$RecaptchaV3({ children: children }) {
    const isHydrated = $07d0275849708341$export$fd0534379e135f3d();
    const { captcha: captcha } = (0, $7PdBe.useContext)($07d0275849708341$export$f7b89be550702182);
    if ((captcha == null ? void 0 : captcha.provider) !== "google-recaptcha-v3") return children;
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $6fa0d1b95691bc7e$export$2e2bcd8739ae039), {
        reCaptchaKey: captcha.siteKey,
        useEnterprise: captcha.enterprise,
        useRecaptchaNet: captcha.recaptchaNet,
        children: [
            isHydrated && /* @__PURE__ */ (0, $hvk62.jsx)("style", {
                children: `
                    .grecaptcha-badge {
                        visibility: hidden;
                        border-radius: var(--radius) !important;
                        --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, #0000000d);
                        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
                        border-style: var(--tw-border-style) !important;
                        border-width: 1px;
                    }

                    .dark .grecaptcha-badge {
                        border-color: var(--input) !important;
                    }
                `
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($07d0275849708341$var$RecaptchaV3Style, {}),
            children
        ]
    });
}
function $07d0275849708341$var$RecaptchaV3Style() {
    const { executeRecaptcha: executeRecaptcha } = (0, $2c6937dda4728c6c$export$2e2bcd8739ae039)();
    const { theme: theme } = $07d0275849708341$export$93d4e7f90805808f();
    const { lang: lang } = $07d0275849708341$export$b24a004ee43dce44();
    (0, $7PdBe.useEffect)(()=>{
        if (!executeRecaptcha) return;
        const updateRecaptcha = async ()=>{
            const iframe = document.querySelector("iframe[title='reCAPTCHA']");
            if (iframe) {
                const iframeSrcUrl = new URL(iframe.src);
                iframeSrcUrl.searchParams.set("theme", theme);
                if (lang) iframeSrcUrl.searchParams.set("hl", lang);
                iframe.src = iframeSrcUrl.toString();
            }
        };
        updateRecaptcha();
    }, [
        executeRecaptcha,
        theme,
        lang
    ]);
    return null;
}
function $07d0275849708341$export$4710633352285863({ slug: slugProp } = {}) {
    const { organization: organizationOptions, hooks: { useActiveOrganization: useActiveOrganization, useListOrganizations: useListOrganizations } } = (0, $7PdBe.useContext)($07d0275849708341$export$f7b89be550702182);
    const { pathMode: pathMode, slug: contextSlug } = organizationOptions || {};
    let data;
    let isPending;
    let isRefetching;
    let refetch;
    const { data: organizations, isPending: organizationsPending, isRefetching: organizationsRefetching } = useListOrganizations();
    if (pathMode === "slug") {
        const slug = slugProp || contextSlug;
        data = organizations == null ? void 0 : organizations.find((organization)=>organization.slug === slug);
        isPending = organizationsPending;
        isRefetching = organizationsRefetching;
    } else {
        const { data: activeOrganization, isPending: organizationPending, isRefetching: organizationRefetching, refetch: refetchOrganization } = useActiveOrganization();
        refetch = refetchOrganization;
        data = activeOrganization;
        isPending = organizationPending;
        isRefetching = organizationRefetching;
    }
    return (0, $7PdBe.useMemo)(()=>({
            data: data,
            isPending: isPending,
            isRefetching: isRefetching,
            refetch: refetch
        }), [
        data,
        isPending,
        isRefetching,
        refetch
    ]);
}
// src/lib/organization-refetcher.tsx
var $07d0275849708341$var$OrganizationRefetcher = ()=>{
    const { hooks: { useListOrganizations: useListOrganizations, useSession: useSession }, organization: organizationOptions, navigate: navigate, redirectTo: redirectTo } = (0, $7PdBe.useContext)($07d0275849708341$export$f7b89be550702182);
    const { slug: slug, pathMode: pathMode, personalPath: personalPath } = organizationOptions || {};
    const { data: sessionData } = useSession();
    const { data: organization, isPending: organizationPending, isRefetching: organizationRefetching, refetch: refetchOrganization } = $07d0275849708341$export$4710633352285863();
    const { refetch: refetchListOrganizations } = useListOrganizations();
    const { data: organizations } = useListOrganizations();
    (0, $7PdBe.useEffect)(()=>{
        if (!(sessionData == null ? void 0 : sessionData.user.id)) return;
        if (organization || organizations) {
            refetchOrganization == null || refetchOrganization();
            refetchListOrganizations == null || refetchListOrganizations();
        }
    }, [
        sessionData == null ? void 0 : sessionData.user.id
    ]);
    (0, $7PdBe.useEffect)(()=>{
        if (organizationRefetching || organizationPending) return;
        if (slug && pathMode === "slug" && !organization) navigate(personalPath || redirectTo);
    }, [
        organization,
        organizationRefetching,
        organizationPending,
        slug,
        pathMode,
        personalPath,
        navigate,
        redirectTo
    ]);
    return null;
};
var $07d0275849708341$var$DefaultLink = ({ href: href, className: className, children: children })=>/* @__PURE__ */ (0, $hvk62.jsx)("a", {
        className: className,
        href: href,
        children: children
    });
var $07d0275849708341$var$defaultNavigate = (href)=>{
    window.location.href = href;
};
var $07d0275849708341$var$defaultReplace = (href)=>{
    window.location.replace(href);
};
var $07d0275849708341$var$defaultToast = ({ variant: variant = "default", message: message })=>{
    if (variant === "default") (0, $0bf2944f2fb447de$exports.toast)(message);
    else (0, $0bf2944f2fb447de$exports.toast)[variant](message);
};
var $07d0275849708341$export$f7b89be550702182 = (0, $7PdBe.createContext)({});
var $07d0275849708341$export$8b282e20e92fcb40 = ({ children: children, authClient: authClientProp, account: accountProp, avatar: avatarProp, deleteUser: deleteUserProp, social: socialProp, genericOAuth: genericOAuthProp, basePath: basePath = "/auth", baseURL: baseURL = "", captcha: captcha, redirectTo: redirectTo = "/", credentials: credentialsProp, changeEmail: changeEmail = true, freshAge: freshAge = 86400, hooks: hooksProp, mutators: mutatorsProp, localization: localizationProp, nameRequired: nameRequired = true, organization: organizationProp, signUp: signUpProp = true, toast: toast2 = $07d0275849708341$var$defaultToast, viewPaths: viewPathsProp, navigate: navigate, replace: replace, Link: Link = $07d0275849708341$var$DefaultLink, ...props })=>{
    const authClient = authClientProp;
    const avatar = (0, $7PdBe.useMemo)(()=>{
        if (!avatarProp) return;
        if (avatarProp === true) return {
            extension: "png",
            size: 128
        };
        return {
            upload: avatarProp.upload,
            delete: avatarProp.delete,
            extension: avatarProp.extension || "png",
            size: avatarProp.size || (avatarProp.upload ? 256 : 128)
        };
    }, [
        avatarProp
    ]);
    const account = (0, $7PdBe.useMemo)(()=>{
        var _a;
        if (accountProp === false) return;
        if (accountProp === true || accountProp === void 0) return {
            basePath: "/account",
            fields: [
                "image",
                "name"
            ],
            viewPaths: (0, $220046a7533cffdb$export$486f5d213d473670)
        };
        const basePath2 = ((_a = accountProp.basePath) == null ? void 0 : _a.endsWith("/")) ? accountProp.basePath.slice(0, -1) : accountProp.basePath;
        return {
            basePath: basePath2 ?? "/account",
            fields: accountProp.fields || [
                "image",
                "name"
            ],
            viewPaths: {
                ...(0, $220046a7533cffdb$export$486f5d213d473670),
                ...accountProp.viewPaths
            }
        };
    }, [
        accountProp
    ]);
    const deleteUser = (0, $7PdBe.useMemo)(()=>{
        if (!deleteUserProp) return;
        if (deleteUserProp === true) return {};
        return deleteUserProp;
    }, [
        deleteUserProp
    ]);
    const social = (0, $7PdBe.useMemo)(()=>{
        if (!socialProp) return;
        return socialProp;
    }, [
        socialProp
    ]);
    const genericOAuth = (0, $7PdBe.useMemo)(()=>{
        if (!genericOAuthProp) return;
        return genericOAuthProp;
    }, [
        genericOAuthProp
    ]);
    const credentials = (0, $7PdBe.useMemo)(()=>{
        if (credentialsProp === false) return;
        if (credentialsProp === true) return {
            forgotPassword: true
        };
        return {
            ...credentialsProp,
            forgotPassword: (credentialsProp == null ? void 0 : credentialsProp.forgotPassword) ?? true
        };
    }, [
        credentialsProp
    ]);
    const signUp = (0, $7PdBe.useMemo)(()=>{
        if (signUpProp === false) return;
        if (signUpProp === true || signUpProp === void 0) return {
            fields: [
                "name"
            ]
        };
        return {
            fields: signUpProp.fields || [
                "name"
            ]
        };
    }, [
        signUpProp
    ]);
    const organization = (0, $7PdBe.useMemo)(()=>{
        var _a;
        if (!organizationProp) return;
        if (organizationProp === true) return {
            basePath: "/organization",
            viewPaths: (0, $220046a7533cffdb$export$6c6a5ee601b29a67),
            customRoles: []
        };
        let logo;
        if (organizationProp.logo === true) logo = {
            extension: "png",
            size: 128
        };
        else if (organizationProp.logo) logo = {
            upload: organizationProp.logo.upload,
            delete: organizationProp.logo.delete,
            extension: organizationProp.logo.extension || "png",
            size: organizationProp.logo.size || organizationProp.logo.upload ? 256 : 128
        };
        const basePath2 = ((_a = organizationProp.basePath) == null ? void 0 : _a.endsWith("/")) ? organizationProp.basePath.slice(0, -1) : organizationProp.basePath;
        return {
            ...organizationProp,
            logo: logo,
            basePath: basePath2 ?? "/organization",
            customRoles: organizationProp.customRoles || [],
            viewPaths: {
                ...(0, $220046a7533cffdb$export$6c6a5ee601b29a67),
                ...organizationProp.viewPaths
            }
        };
    }, [
        organizationProp
    ]);
    const defaultMutators = (0, $7PdBe.useMemo)(()=>{
        return {
            deleteApiKey: (params)=>authClient.apiKey.delete({
                    ...params,
                    fetchOptions: {
                        throw: true
                    }
                }),
            deletePasskey: (params)=>authClient.passkey.deletePasskey({
                    ...params,
                    fetchOptions: {
                        throw: true
                    }
                }),
            revokeDeviceSession: (params)=>authClient.multiSession.revoke({
                    ...params,
                    fetchOptions: {
                        throw: true
                    }
                }),
            revokeSession: (params)=>authClient.revokeSession({
                    ...params,
                    fetchOptions: {
                        throw: true
                    }
                }),
            setActiveSession: (params)=>authClient.multiSession.setActive({
                    ...params,
                    fetchOptions: {
                        throw: true
                    }
                }),
            updateOrganization: (params)=>authClient.organization.update({
                    ...params,
                    fetchOptions: {
                        throw: true
                    }
                }),
            updateUser: (params)=>authClient.updateUser({
                    ...params,
                    fetchOptions: {
                        throw: true
                    }
                }),
            unlinkAccount: (params)=>authClient.unlinkAccount({
                    ...params,
                    fetchOptions: {
                        throw: true
                    }
                })
        };
    }, [
        authClient
    ]);
    const defaultHooks = (0, $7PdBe.useMemo)(()=>{
        return {
            useSession: authClient.useSession,
            useListAccounts: ()=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: authClient.listAccounts,
                    cacheKey: "listAccounts"
                }),
            useAccountInfo: (params)=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: ()=>authClient.accountInfo(params),
                    cacheKey: `accountInfo:${JSON.stringify(params)}`
                }),
            useListDeviceSessions: ()=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: authClient.multiSession.listDeviceSessions,
                    cacheKey: "listDeviceSessions"
                }),
            useListSessions: ()=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: authClient.listSessions,
                    cacheKey: "listSessions"
                }),
            useListPasskeys: authClient.useListPasskeys,
            useListApiKeys: ()=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: authClient.apiKey.list,
                    cacheKey: "listApiKeys"
                }),
            useActiveOrganization: authClient.useActiveOrganization,
            useListOrganizations: authClient.useListOrganizations,
            useHasPermission: (params)=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: ()=>authClient.$fetch("/organization/has-permission", {
                            method: "POST",
                            body: params
                        }),
                    cacheKey: `hasPermission:${JSON.stringify(params)}`
                }),
            useInvitation: (params)=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: ()=>authClient.organization.getInvitation(params),
                    cacheKey: `invitation:${JSON.stringify(params)}`
                }),
            useListInvitations: (params)=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: ()=>{
                        var _a;
                        return authClient.$fetch(`/organization/list-invitations?organizationId=${((_a = params == null ? void 0 : params.query) == null ? void 0 : _a.organizationId) || ""}`);
                    },
                    cacheKey: `listInvitations:${JSON.stringify(params)}`
                }),
            useListUserInvitations: ()=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: ()=>authClient.$fetch("/organization/list-user-invitations"),
                    cacheKey: `listUserInvitations`
                }),
            useListMembers: (params)=>$07d0275849708341$export$69bbac602c81ca6e({
                    queryFn: ()=>{
                        var _a;
                        return authClient.$fetch(`/organization/list-members?organizationId=${((_a = params == null ? void 0 : params.query) == null ? void 0 : _a.organizationId) || ""}`);
                    },
                    cacheKey: `listMembers:${JSON.stringify(params)}`
                })
        };
    }, [
        authClient
    ]);
    const viewPaths = (0, $7PdBe.useMemo)(()=>{
        return {
            ...(0, $220046a7533cffdb$export$5dc0d48aa89a4acc),
            ...viewPathsProp
        };
    }, [
        viewPathsProp
    ]);
    const localization = (0, $7PdBe.useMemo)(()=>{
        return {
            ...(0, $220046a7533cffdb$export$978479025ceb1313),
            ...localizationProp
        };
    }, [
        localizationProp
    ]);
    const hooks = (0, $7PdBe.useMemo)(()=>{
        return {
            ...defaultHooks,
            ...hooksProp
        };
    }, [
        defaultHooks,
        hooksProp
    ]);
    const mutators = (0, $7PdBe.useMemo)(()=>{
        return {
            ...defaultMutators,
            ...mutatorsProp
        };
    }, [
        defaultMutators,
        mutatorsProp
    ]);
    baseURL = baseURL.endsWith("/") ? baseURL.slice(0, -1) : baseURL;
    basePath = basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;
    const { data: sessionData } = hooks.useSession();
    return /* @__PURE__ */ (0, $hvk62.jsxs)($07d0275849708341$export$f7b89be550702182.Provider, {
        value: {
            authClient: authClient,
            avatar: avatar,
            basePath: basePath === "/" ? "" : basePath,
            baseURL: baseURL,
            captcha: captcha,
            redirectTo: redirectTo,
            changeEmail: changeEmail,
            credentials: credentials,
            deleteUser: deleteUser,
            freshAge: freshAge,
            genericOAuth: genericOAuth,
            hooks: hooks,
            mutators: mutators,
            localization: localization,
            nameRequired: nameRequired,
            organization: organization,
            account: account,
            signUp: signUp,
            social: social,
            toast: toast2,
            navigate: navigate || $07d0275849708341$var$defaultNavigate,
            replace: replace || navigate || $07d0275849708341$var$defaultReplace,
            viewPaths: viewPaths,
            Link: Link,
            ...props
        },
        children: [
            sessionData && organization && /* @__PURE__ */ (0, $hvk62.jsx)($07d0275849708341$var$OrganizationRefetcher, {}),
            (captcha == null ? void 0 : captcha.provider) === "google-recaptcha-v3" ? /* @__PURE__ */ (0, $hvk62.jsx)($07d0275849708341$var$RecaptchaV3, {
                children: children
            }) : children
        ]
    });
};
// src/hooks/use-auth-data.ts
function $07d0275849708341$export$69bbac602c81ca6e({ queryFn: queryFn, cacheKey: cacheKey, staleTime: staleTime = 1e4 }) {
    var _a;
    const { hooks: { useSession: useSession }, toast: toast2, localization: localization } = (0, $7PdBe.useContext)($07d0275849708341$export$f7b89be550702182);
    const { data: sessionData, isPending: sessionPending } = useSession();
    const queryFnRef = (0, $7PdBe.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const stableCacheKey = cacheKey || queryFn.toString();
    const cacheEntry = (0, $7PdBe.useSyncExternalStore)((0, $7PdBe.useCallback)((callback)=>$07d0275849708341$var$authDataCache.subscribe(stableCacheKey, callback), [
        stableCacheKey
    ]), (0, $7PdBe.useCallback)(()=>$07d0275849708341$var$authDataCache.get(stableCacheKey), [
        stableCacheKey
    ]), (0, $7PdBe.useCallback)(()=>$07d0275849708341$var$authDataCache.get(stableCacheKey), [
        stableCacheKey
    ]));
    const initialized = (0, $7PdBe.useRef)(false);
    const previousUserId = (0, $7PdBe.useRef)(void 0);
    const [error, setError] = (0, $7PdBe.useState)(null);
    const refetch = (0, $7PdBe.useCallback)(async ()=>{
        const existingRequest = $07d0275849708341$var$authDataCache.getInFlightRequest(stableCacheKey);
        if (existingRequest) {
            try {
                const result = await existingRequest;
                if (result.error) setError(result.error);
                else setError(null);
            } catch (err) {
                setError(err);
            }
            return;
        }
        if ((cacheEntry == null ? void 0 : cacheEntry.data) !== void 0) $07d0275849708341$var$authDataCache.setRefetching(stableCacheKey, true);
        const fetchPromise = queryFnRef.current();
        $07d0275849708341$var$authDataCache.setInFlightRequest(stableCacheKey, fetchPromise);
        try {
            const { data: data, error: error2 } = await fetchPromise;
            if (error2) {
                setError(error2);
                toast2({
                    variant: "error",
                    message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                        error: error2,
                        localization: localization
                    })
                });
            } else setError(null);
            $07d0275849708341$var$authDataCache.set(stableCacheKey, data);
        } catch (err) {
            const error2 = err;
            setError(error2);
            toast2({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error2,
                    localization: localization
                })
            });
        } finally{
            $07d0275849708341$var$authDataCache.setRefetching(stableCacheKey, false);
            $07d0275849708341$var$authDataCache.removeInFlightRequest(stableCacheKey);
        }
    }, [
        stableCacheKey,
        toast2,
        localization,
        cacheEntry
    ]);
    (0, $7PdBe.useEffect)(()=>{
        var _a2;
        const currentUserId = (_a2 = sessionData == null ? void 0 : sessionData.user) == null ? void 0 : _a2.id;
        if (!sessionData) {
            $07d0275849708341$var$authDataCache.setRefetching(stableCacheKey, false);
            $07d0275849708341$var$authDataCache.clear(stableCacheKey);
            initialized.current = false;
            previousUserId.current = void 0;
            return;
        }
        const userIdChanged = previousUserId.current !== void 0 && previousUserId.current !== currentUserId;
        if (userIdChanged) $07d0275849708341$var$authDataCache.clear(stableCacheKey);
        const hasCachedData = (cacheEntry == null ? void 0 : cacheEntry.data) !== void 0;
        const isStale = !cacheEntry || Date.now() - cacheEntry.timestamp > staleTime;
        if (!initialized.current || !hasCachedData || userIdChanged || hasCachedData && isStale) {
            if (!hasCachedData || isStale) {
                initialized.current = true;
                refetch();
            }
        }
        previousUserId.current = currentUserId;
    }, [
        sessionData,
        (_a = sessionData == null ? void 0 : sessionData.user) == null ? void 0 : _a.id,
        stableCacheKey,
        refetch,
        cacheEntry,
        staleTime
    ]);
    const isPending = sessionPending || (cacheEntry == null ? void 0 : cacheEntry.data) === void 0 && !error;
    return {
        data: (cacheEntry == null ? void 0 : cacheEntry.data) ?? null,
        isPending: isPending,
        isRefetching: (cacheEntry == null ? void 0 : cacheEntry.isRefetching) ?? false,
        error: error,
        refetch: refetch
    };
}



/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30a2e868cfd5681e$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("ArrowLeft", [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3c5c7b34b6c8fa4f$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Building", [
    [
        "rect",
        {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            ry: "2",
            key: "76otgf"
        }
    ],
    [
        "path",
        {
            d: "M9 22v-4h6v4",
            key: "r93iot"
        }
    ],
    [
        "path",
        {
            d: "M8 6h.01",
            key: "1dz90k"
        }
    ],
    [
        "path",
        {
            d: "M16 6h.01",
            key: "1x0f13"
        }
    ],
    [
        "path",
        {
            d: "M12 6h.01",
            key: "1vi96p"
        }
    ],
    [
        "path",
        {
            d: "M12 10h.01",
            key: "1nrarc"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 10h.01",
            key: "19clt8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f258299638c7248e$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("ChevronsUpDown", [
    [
        "path",
        {
            d: "m7 15 5 5 5-5",
            key: "1hf1tw"
        }
    ],
    [
        "path",
        {
            d: "m7 9 5-5 5 5",
            key: "sgt6xg"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0ff2a797c5b6f40a$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Copy", [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9d2f9bea6f0d78a8$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Ellipsis", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "12",
            r: "1",
            key: "1wjl8i"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "12",
            r: "1",
            key: "1pcz8c"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $03a6a1f3f1b2db9c$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Eye", [
    [
        "path",
        {
            d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z",
            key: "rwhkz3"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d519d8f211846ea6$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("EyeOff", [
    [
        "path",
        {
            d: "M9.88 9.88a3 3 0 1 0 4.24 4.24",
            key: "1jxqfv"
        }
    ],
    [
        "path",
        {
            d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68",
            key: "9wicm4"
        }
    ],
    [
        "path",
        {
            d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61",
            key: "1jreej"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "2",
            y2: "22",
            key: "a6p6uj"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3b980a999e8ec75a$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Fingerprint", [
    [
        "path",
        {
            d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4",
            key: "1nerag"
        }
    ],
    [
        "path",
        {
            d: "M14 13.12c0 2.38 0 6.38-1 8.88",
            key: "o46ks0"
        }
    ],
    [
        "path",
        {
            d: "M17.29 21.02c.12-.6.43-2.3.5-3.02",
            key: "ptglia"
        }
    ],
    [
        "path",
        {
            d: "M2 12a10 10 0 0 1 18-6",
            key: "ydlgp0"
        }
    ],
    [
        "path",
        {
            d: "M2 16h.01",
            key: "1gqxmh"
        }
    ],
    [
        "path",
        {
            d: "M21.8 16c.2-2 .131-5.354 0-6",
            key: "drycrb"
        }
    ],
    [
        "path",
        {
            d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2",
            key: "1tidbn"
        }
    ],
    [
        "path",
        {
            d: "M8.65 22c.21-.66.45-1.32.57-2",
            key: "13wd9y"
        }
    ],
    [
        "path",
        {
            d: "M9 6.8a6 6 0 0 1 9 5.2v2",
            key: "1fr1j5"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $68f6b959252c02b7$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("KeyRound", [
    [
        "path",
        {
            d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
            key: "1s6t7t"
        }
    ],
    [
        "circle",
        {
            cx: "16.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "w0ekpg"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $58bb0bc6d028a22f$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Laptop", [
    [
        "path",
        {
            d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
            key: "tarvll"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6b2b36fe46a7aba1$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("LoaderCircle", [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $93fca3000ef27384$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Lock", [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9a20346f482de2f$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("LogIn", [
    [
        "path",
        {
            d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
            key: "u53s6r"
        }
    ],
    [
        "polyline",
        {
            points: "10 17 15 12 10 7",
            key: "1ail0h"
        }
    ],
    [
        "line",
        {
            x1: "15",
            x2: "3",
            y1: "12",
            y2: "12",
            key: "v6grx8"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2e97570e53b7162e$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("LogOut", [
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ],
    [
        "polyline",
        {
            points: "16 17 21 12 16 7",
            key: "1gabdz"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "9",
            y1: "12",
            y2: "12",
            key: "1uyos4"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $633ef490ccb7bfce$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Mail", [
    [
        "rect",
        {
            width: "20",
            height: "16",
            x: "2",
            y: "4",
            rx: "2",
            key: "18n3k1"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7",
            key: "1ocrg3"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2f5c5352f7ba804e$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Menu", [
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "12",
            y2: "12",
            key: "1e0a9i"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "6",
            y2: "6",
            key: "1owob3"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "18",
            y2: "18",
            key: "yk5zj1"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $014dbf7ae4460a37$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Minus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $daa75c34e4a35766$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("CirclePlus", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M8 12h8",
            key: "1wcyev"
        }
    ],
    [
        "path",
        {
            d: "M12 8v8",
            key: "napkw2"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c25648be789a95d0$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("QrCode", [
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "3",
            y: "3",
            rx: "1",
            key: "1tu5fj"
        }
    ],
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "16",
            y: "3",
            rx: "1",
            key: "1v8r4q"
        }
    ],
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "1x03jg"
        }
    ],
    [
        "path",
        {
            d: "M21 16h-3a2 2 0 0 0-2 2v3",
            key: "177gqh"
        }
    ],
    [
        "path",
        {
            d: "M21 21v.01",
            key: "ents32"
        }
    ],
    [
        "path",
        {
            d: "M12 7v3a2 2 0 0 1-2 2H7",
            key: "8crl2c"
        }
    ],
    [
        "path",
        {
            d: "M3 12h.01",
            key: "nlz23k"
        }
    ],
    [
        "path",
        {
            d: "M12 3h.01",
            key: "n36tog"
        }
    ],
    [
        "path",
        {
            d: "M12 16v.01",
            key: "133mhm"
        }
    ],
    [
        "path",
        {
            d: "M16 12h1",
            key: "1slzba"
        }
    ],
    [
        "path",
        {
            d: "M21 12v.01",
            key: "1lwtk9"
        }
    ],
    [
        "path",
        {
            d: "M12 21v-1",
            key: "1880an"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $667851380e8e7d6d$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Repeat", [
    [
        "path",
        {
            d: "m17 2 4 4-4 4",
            key: "nntrym"
        }
    ],
    [
        "path",
        {
            d: "M3 11v-1a4 4 0 0 1 4-4h14",
            key: "84bu3i"
        }
    ],
    [
        "path",
        {
            d: "m7 22-4-4 4-4",
            key: "1wqhfi"
        }
    ],
    [
        "path",
        {
            d: "M21 13v1a4 4 0 0 1-4 4H3",
            key: "1rx37r"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e0677777e3a5031b$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Send", [
    [
        "path",
        {
            d: "m22 2-7 20-4-9-9-4Z",
            key: "1q3vgg"
        }
    ],
    [
        "path",
        {
            d: "M22 2 11 13",
            key: "nzbqef"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e7182fc0af14339c$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Settings", [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1010c5d615305245$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Smartphone", [
    [
        "rect",
        {
            width: "14",
            height: "20",
            x: "5",
            y: "2",
            rx: "2",
            ry: "2",
            key: "1yt0o3"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $28b54fce4c436a82$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("Trash2", [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c30ce99ee32b9b4f$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("CloudUpload", [
    [
        "path",
        {
            d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
            key: "1pljnt"
        }
    ],
    [
        "path",
        {
            d: "M12 12v9",
            key: "192myk"
        }
    ],
    [
        "path",
        {
            d: "m16 16-4-4-4 4",
            key: "119tzi"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3b86cb767adbc7b7$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("UserCog", [
    [
        "circle",
        {
            cx: "18",
            cy: "15",
            r: "3",
            key: "gjjjvw"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "path",
        {
            d: "M10 15H6a4 4 0 0 0-4 4v2",
            key: "1nfge6"
        }
    ],
    [
        "path",
        {
            d: "m21.7 16.4-.9-.3",
            key: "12j9ji"
        }
    ],
    [
        "path",
        {
            d: "m15.2 13.9-.9-.3",
            key: "1fdjdi"
        }
    ],
    [
        "path",
        {
            d: "m16.6 18.7.3-.9",
            key: "heedtr"
        }
    ],
    [
        "path",
        {
            d: "m19.1 12.2.3-.9",
            key: "1af3ki"
        }
    ],
    [
        "path",
        {
            d: "m19.6 18.7-.4-1",
            key: "1x9vze"
        }
    ],
    [
        "path",
        {
            d: "m16.8 12.3-.4-1",
            key: "vqeiwj"
        }
    ],
    [
        "path",
        {
            d: "m14.3 16.6 1-.4",
            key: "1qlj63"
        }
    ],
    [
        "path",
        {
            d: "m20.7 13.8 1-.4",
            key: "1v5t8k"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfd39e716df2888f$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("UserRound", [
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "5",
            key: "1hypcn"
        }
    ],
    [
        "path",
        {
            d: "M20 21a8 8 0 0 0-16 0",
            key: "rfgkzh"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7632311beff79d2b$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("UserRoundPlus", [
    [
        "path",
        {
            d: "M2 21a8 8 0 0 1 13.292-6",
            key: "bjp14o"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ],
    [
        "path",
        {
            d: "M19 16v6",
            key: "tddt3s"
        }
    ],
    [
        "path",
        {
            d: "M22 19h-6",
            key: "vcuq98"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c97b93ac65ea0586$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("UserRoundX", [
    [
        "path",
        {
            d: "M2 21a8 8 0 0 1 11.873-7",
            key: "74fkxq"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ],
    [
        "path",
        {
            d: "m17 17 5 5",
            key: "p7ous7"
        }
    ],
    [
        "path",
        {
            d: "m22 17-5 5",
            key: "gqnmv0"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d3655f26227b4756$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("UserX", [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "line",
        {
            x1: "17",
            x2: "22",
            y1: "8",
            y2: "13",
            key: "3nzzx3"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "17",
            y1: "8",
            y2: "13",
            key: "1swrse"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f5645b1fe1001619$export$2e2bcd8739ae039 = (0, $d566ee6b21ad38ed$export$2e2bcd8739ae039)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);



var $7PdBe = parcelRequire("7PdBe");

var $hvk62 = parcelRequire("hvk62");

var $7PdBe = parcelRequire("7PdBe");
var $9a9ac4df444a6447$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $9a9ac4df444a6447$var$isDateObject = (value1)=>value1 instanceof Date;
var $9a9ac4df444a6447$var$isNullOrUndefined = (value1)=>value1 == null;
const $9a9ac4df444a6447$var$isObjectType = (value1)=>typeof value1 === "object";
var $9a9ac4df444a6447$var$isObject = (value1)=>!$9a9ac4df444a6447$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $9a9ac4df444a6447$var$isObjectType(value1) && !$9a9ac4df444a6447$var$isDateObject(value1);
var $9a9ac4df444a6447$var$getEventValue = (event)=>$9a9ac4df444a6447$var$isObject(event) && event.target ? $9a9ac4df444a6447$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $9a9ac4df444a6447$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $9a9ac4df444a6447$var$isNameInFieldArray = (names, name)=>names.has($9a9ac4df444a6447$var$getNodeParentName(name));
var $9a9ac4df444a6447$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $9a9ac4df444a6447$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $9a9ac4df444a6447$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $9a9ac4df444a6447$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== "undefined" ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (!($9a9ac4df444a6447$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $9a9ac4df444a6447$var$isObject(data))) {
        copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
        if (!isArray && !$9a9ac4df444a6447$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $9a9ac4df444a6447$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $9a9ac4df444a6447$var$isKey = (value1)=>/^\w*$/.test(value1);
var $9a9ac4df444a6447$var$isUndefined = (val)=>val === undefined;
var $9a9ac4df444a6447$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $9a9ac4df444a6447$var$stringToPath = (input)=>$9a9ac4df444a6447$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $9a9ac4df444a6447$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$9a9ac4df444a6447$var$isObject(object)) return defaultValue;
    const result = ($9a9ac4df444a6447$var$isKey(path) ? [
        path
    ] : $9a9ac4df444a6447$var$stringToPath(path)).reduce((result, key)=>$9a9ac4df444a6447$var$isNullOrUndefined(result) ? result : result[key], object);
    return $9a9ac4df444a6447$var$isUndefined(result) || result === object ? $9a9ac4df444a6447$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $9a9ac4df444a6447$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $9a9ac4df444a6447$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $9a9ac4df444a6447$var$isKey(path) ? [
        path
    ] : $9a9ac4df444a6447$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $9a9ac4df444a6447$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === "__proto__" || key === "constructor" || key === "prototype") return;
        object[key] = newValue;
        object = object[key];
    }
};
const $9a9ac4df444a6447$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $9a9ac4df444a6447$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $9a9ac4df444a6447$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $9a9ac4df444a6447$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createContext(null);
$9a9ac4df444a6447$var$HookFormContext.displayName = "HookFormContext";
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $9a9ac4df444a6447$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useContext($9a9ac4df444a6447$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $9a9ac4df444a6447$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement($9a9ac4df444a6447$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $9a9ac4df444a6447$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $9a9ac4df444a6447$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $9a9ac4df444a6447$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $9a9ac4df444a6447$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $9a9ac4df444a6447$export$606f11b2eb45ecc6(props) {
    const methods = $9a9ac4df444a6447$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $9a9ac4df444a6447$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>$9a9ac4df444a6447$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $9a9ac4df444a6447$var$isString = (value1)=>typeof value1 === "string";
var $9a9ac4df444a6447$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($9a9ac4df444a6447$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $9a9ac4df444a6447$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $9a9ac4df444a6447$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $9a9ac4df444a6447$var$isPrimitive = (value1)=>$9a9ac4df444a6447$var$isNullOrUndefined(value1) || !$9a9ac4df444a6447$var$isObjectType(value1);
function $9a9ac4df444a6447$var$deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if ($9a9ac4df444a6447$var$isPrimitive(object1) || $9a9ac4df444a6447$var$isPrimitive(object2)) return object1 === object2;
    if ($9a9ac4df444a6447$var$isDateObject(object1) && $9a9ac4df444a6447$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) return true;
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($9a9ac4df444a6447$var$isDateObject(val1) && $9a9ac4df444a6447$var$isDateObject(val2) || $9a9ac4df444a6447$var$isObject(val1) && $9a9ac4df444a6447$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$9a9ac4df444a6447$var$deepEqual(val1, val2, _internal_visited) : val1 !== val2) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $9a9ac4df444a6447$export$3c773aa2b84f29e0(props) {
    const methods = $9a9ac4df444a6447$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(undefined);
    _compute.current = compute;
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>control._getWatch(name, _defaultValue.current), [
        control,
        name
    ]);
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(_compute.current ? _compute.current(defaultValueMemo) : defaultValueMemo);
    $9a9ac4df444a6447$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                if (!disabled) {
                    const formValues = $9a9ac4df444a6447$var$generateWatchOutput(name, control._names, formState.values || control._formValues, false, _defaultValue.current);
                    if (_compute.current) {
                        const computedFormValues = _compute.current(formValues);
                        if (!$9a9ac4df444a6447$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                            updateValue(computedFormValues);
                            _computeFormValues.current = computedFormValues;
                        }
                    } else updateValue(formValues);
                }
            }
        }), [
        control,
        disabled,
        name,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $9a9ac4df444a6447$export$e8c786024a2b0a79(props) {
    const methods = $9a9ac4df444a6447$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister, defaultValue: defaultValue } = props;
    const isArrayField = $9a9ac4df444a6447$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>$9a9ac4df444a6447$export$3988ae62b71be9a3(control._formValues, name, $9a9ac4df444a6447$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $9a9ac4df444a6447$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: true
    });
    const formState = $9a9ac4df444a6447$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(props);
    const _previousNameRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(undefined);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$9a9ac4df444a6447$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$9a9ac4df444a6447$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$9a9ac4df444a6447$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$9a9ac4df444a6447$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$9a9ac4df444a6447$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$9a9ac4df444a6447$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $9a9ac4df444a6447$var$getEventValue(event),
                name: name
            },
            type: $9a9ac4df444a6447$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $9a9ac4df444a6447$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $9a9ac4df444a6447$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback((elm)=>{
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus && elm.focus(),
            select: ()=>elm.select && elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>({
            name: name,
            value: value1,
            ...$9a9ac4df444a6447$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const previousName = _previousNameRef.current;
        if (previousName && previousName !== name && !isArrayField) control.unregister(previousName);
        control.register(name, {
            ..._props.current.rules,
            ...$9a9ac4df444a6447$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $9a9ac4df444a6447$var$cloneObject($9a9ac4df444a6447$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue));
            $9a9ac4df444a6447$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($9a9ac4df444a6447$var$isUndefined($9a9ac4df444a6447$export$3988ae62b71be9a3(control._formValues, name))) $9a9ac4df444a6447$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        _previousNameRef.current = name;
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $9a9ac4df444a6447$export$bd0bf19f25da8474 = (props)=>props.render($9a9ac4df444a6447$export$e8c786024a2b0a79(props));
const $9a9ac4df444a6447$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($9a9ac4df444a6447$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $9a9ac4df444a6447$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $9a9ac4df444a6447$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $9a9ac4df444a6447$export$a7fed597f4b8afd8(props) {
    const methods = $9a9ac4df444a6447$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $9a9ac4df444a6447$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $9a9ac4df444a6447$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType && encType !== "multipart/form-data" ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $9a9ac4df444a6447$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $9a9ac4df444a6447$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $9a9ac4df444a6447$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $9a9ac4df444a6447$var$extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && $9a9ac4df444a6447$var$isObject(fieldState) && fieldValue) {
            const nestedFieldsState = $9a9ac4df444a6447$var$extractFormValues(fieldState, fieldValue);
            if ($9a9ac4df444a6447$var$isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var $9a9ac4df444a6447$var$isEmptyObject = (value1)=>$9a9ac4df444a6447$var$isObject(value1) && !Object.keys(value1).length;
var $9a9ac4df444a6447$var$isFileInput = (element)=>element.type === "file";
var $9a9ac4df444a6447$var$isFunction = (value1)=>typeof value1 === "function";
var $9a9ac4df444a6447$var$isHTMLElement = (value1)=>{
    if (!$9a9ac4df444a6447$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $9a9ac4df444a6447$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $9a9ac4df444a6447$var$isRadioInput = (element)=>element.type === "radio";
var $9a9ac4df444a6447$var$isRadioOrCheckbox = (ref)=>$9a9ac4df444a6447$var$isRadioInput(ref) || $9a9ac4df444a6447$var$isCheckBoxInput(ref);
var $9a9ac4df444a6447$var$live = (ref)=>$9a9ac4df444a6447$var$isHTMLElement(ref) && ref.isConnected;
function $9a9ac4df444a6447$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $9a9ac4df444a6447$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $9a9ac4df444a6447$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$9a9ac4df444a6447$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $9a9ac4df444a6447$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $9a9ac4df444a6447$var$isKey(path) ? [
        path
    ] : $9a9ac4df444a6447$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $9a9ac4df444a6447$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($9a9ac4df444a6447$var$isObject(childObject) && $9a9ac4df444a6447$var$isEmptyObject(childObject) || Array.isArray(childObject) && $9a9ac4df444a6447$var$isEmptyArray(childObject))) $9a9ac4df444a6447$var$unset(object, paths.slice(0, -1));
    return object;
}
var $9a9ac4df444a6447$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($9a9ac4df444a6447$var$isFunction(data[key])) return true;
    }
    return false;
};
function $9a9ac4df444a6447$var$isTraversable(value1) {
    return Array.isArray(value1) || $9a9ac4df444a6447$var$isObject(value1) && !$9a9ac4df444a6447$var$objectHasFunction(value1);
}
function $9a9ac4df444a6447$var$markFieldsDirty(data, fields = {}) {
    for(const key in data){
        if ($9a9ac4df444a6447$var$isTraversable(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $9a9ac4df444a6447$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$9a9ac4df444a6447$var$isUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $9a9ac4df444a6447$var$getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $9a9ac4df444a6447$var$markFieldsDirty(formValues);
    for(const key in data)if ($9a9ac4df444a6447$var$isTraversable(data[key])) {
        if ($9a9ac4df444a6447$var$isUndefined(formValues) || $9a9ac4df444a6447$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $9a9ac4df444a6447$var$markFieldsDirty(data[key], Array.isArray(data[key]) ? [] : {});
        else $9a9ac4df444a6447$var$getDirtyFields(data[key], $9a9ac4df444a6447$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
    } else dirtyFieldsFromValues[key] = !$9a9ac4df444a6447$var$deepEqual(data[key], formValues[key]);
    return dirtyFieldsFromValues;
}
const $9a9ac4df444a6447$var$defaultResult = {
    value: false,
    isValid: false
};
const $9a9ac4df444a6447$var$validResult = {
    value: true,
    isValid: true
};
var $9a9ac4df444a6447$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$9a9ac4df444a6447$var$isUndefined(options[0].attributes.value) ? $9a9ac4df444a6447$var$isUndefined(options[0].value) || options[0].value === "" ? $9a9ac4df444a6447$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $9a9ac4df444a6447$var$validResult : $9a9ac4df444a6447$var$defaultResult;
    }
    return $9a9ac4df444a6447$var$defaultResult;
};
var $9a9ac4df444a6447$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$9a9ac4df444a6447$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $9a9ac4df444a6447$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $9a9ac4df444a6447$var$defaultReturn = {
    isValid: false,
    value: null
};
var $9a9ac4df444a6447$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $9a9ac4df444a6447$var$defaultReturn) : $9a9ac4df444a6447$var$defaultReturn;
function $9a9ac4df444a6447$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($9a9ac4df444a6447$var$isFileInput(ref)) return ref.files;
    if ($9a9ac4df444a6447$var$isRadioInput(ref)) return $9a9ac4df444a6447$var$getRadioValue(_f.refs).value;
    if ($9a9ac4df444a6447$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($9a9ac4df444a6447$var$isCheckBoxInput(ref)) return $9a9ac4df444a6447$var$getCheckboxValue(_f.refs).value;
    return $9a9ac4df444a6447$var$getFieldValueAs($9a9ac4df444a6447$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $9a9ac4df444a6447$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
        field && $9a9ac4df444a6447$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $9a9ac4df444a6447$var$isRegex = (value1)=>value1 instanceof RegExp;
var $9a9ac4df444a6447$var$getRuleValue = (rule)=>$9a9ac4df444a6447$var$isUndefined(rule) ? rule : $9a9ac4df444a6447$var$isRegex(rule) ? rule.source : $9a9ac4df444a6447$var$isObject(rule) ? $9a9ac4df444a6447$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $9a9ac4df444a6447$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $9a9ac4df444a6447$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $9a9ac4df444a6447$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $9a9ac4df444a6447$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $9a9ac4df444a6447$var$VALIDATION_MODE.all,
        isOnTouch: mode === $9a9ac4df444a6447$var$VALIDATION_MODE.onTouched
    });
const $9a9ac4df444a6447$var$ASYNC_FUNCTION = "AsyncFunction";
var $9a9ac4df444a6447$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($9a9ac4df444a6447$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $9a9ac4df444a6447$var$ASYNC_FUNCTION || $9a9ac4df444a6447$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $9a9ac4df444a6447$var$ASYNC_FUNCTION));
var $9a9ac4df444a6447$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $9a9ac4df444a6447$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $9a9ac4df444a6447$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($9a9ac4df444a6447$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($9a9ac4df444a6447$var$isObject(currentField)) {
                if ($9a9ac4df444a6447$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $9a9ac4df444a6447$var$schemaErrorLookup(errors, _fields, name) {
    const error = $9a9ac4df444a6447$export$3988ae62b71be9a3(errors, name);
    if (error || $9a9ac4df444a6447$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $9a9ac4df444a6447$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $9a9ac4df444a6447$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $9a9ac4df444a6447$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $9a9ac4df444a6447$var$VALIDATION_MODE.all));
};
var $9a9ac4df444a6447$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $9a9ac4df444a6447$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $9a9ac4df444a6447$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $9a9ac4df444a6447$var$unsetEmptyArray = (ref, name)=>!$9a9ac4df444a6447$var$compact($9a9ac4df444a6447$export$3988ae62b71be9a3(ref, name)).length && $9a9ac4df444a6447$var$unset(ref, name);
var $9a9ac4df444a6447$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $9a9ac4df444a6447$var$convertToArrayPayload($9a9ac4df444a6447$export$3988ae62b71be9a3(errors, name));
    $9a9ac4df444a6447$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $9a9ac4df444a6447$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
function $9a9ac4df444a6447$var$getValidateError(result, ref, type = "validate") {
    if ($9a9ac4df444a6447$var$isString(result) || Array.isArray(result) && result.every($9a9ac4df444a6447$var$isString) || $9a9ac4df444a6447$var$isBoolean(result) && !result) return {
        type: type,
        message: $9a9ac4df444a6447$var$isString(result) ? result : "",
        ref: ref
    };
}
var $9a9ac4df444a6447$var$getValueAndMessage = (validationData)=>$9a9ac4df444a6447$var$isObject(validationData) && !$9a9ac4df444a6447$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $9a9ac4df444a6447$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $9a9ac4df444a6447$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($9a9ac4df444a6447$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $9a9ac4df444a6447$var$isRadioInput(ref);
    const isCheckBox = $9a9ac4df444a6447$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $9a9ac4df444a6447$var$isFileInput(ref)) && $9a9ac4df444a6447$var$isUndefined(ref.value) && $9a9ac4df444a6447$var$isUndefined(inputValue) || $9a9ac4df444a6447$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $9a9ac4df444a6447$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.maxLength, minType = $9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $9a9ac4df444a6447$var$isNullOrUndefined(inputValue)) || $9a9ac4df444a6447$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$9a9ac4df444a6447$var$getCheckboxValue(refs).isValid || isRadio && !$9a9ac4df444a6447$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $9a9ac4df444a6447$var$isString(required) ? {
            value: !!required,
            message: required
        } : $9a9ac4df444a6447$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$9a9ac4df444a6447$var$isNullOrUndefined(min) || !$9a9ac4df444a6447$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $9a9ac4df444a6447$var$getValueAndMessage(max);
        const minOutput = $9a9ac4df444a6447$var$getValueAndMessage(min);
        if (!$9a9ac4df444a6447$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$9a9ac4df444a6447$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$9a9ac4df444a6447$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($9a9ac4df444a6447$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($9a9ac4df444a6447$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.max, $9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($9a9ac4df444a6447$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $9a9ac4df444a6447$var$getValueAndMessage(maxLength);
        const minLengthOutput = $9a9ac4df444a6447$var$getValueAndMessage(minLength);
        const exceedMax = !$9a9ac4df444a6447$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$9a9ac4df444a6447$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $9a9ac4df444a6447$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $9a9ac4df444a6447$var$getValueAndMessage(pattern);
        if ($9a9ac4df444a6447$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($9a9ac4df444a6447$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $9a9ac4df444a6447$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($9a9ac4df444a6447$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($9a9ac4df444a6447$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$9a9ac4df444a6447$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $9a9ac4df444a6447$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$9a9ac4df444a6447$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $9a9ac4df444a6447$var$defaultOptions = {
    mode: $9a9ac4df444a6447$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $9a9ac4df444a6447$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $9a9ac4df444a6447$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$9a9ac4df444a6447$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $9a9ac4df444a6447$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $9a9ac4df444a6447$var$isObject(_options.defaultValues) || $9a9ac4df444a6447$var$isObject(_options.values) ? $9a9ac4df444a6447$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $9a9ac4df444a6447$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $9a9ac4df444a6447$var$createSubject(),
        state: $9a9ac4df444a6447$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $9a9ac4df444a6447$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $9a9ac4df444a6447$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $9a9ac4df444a6447$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$9a9ac4df444a6447$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $9a9ac4df444a6447$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $9a9ac4df444a6447$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $9a9ac4df444a6447$export$3988ae62b71be9a3(_formValues, name, $9a9ac4df444a6447$var$isUndefined(value1) ? $9a9ac4df444a6447$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $9a9ac4df444a6447$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $9a9ac4df444a6447$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $9a9ac4df444a6447$var$deepEqual($9a9ac4df444a6447$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $9a9ac4df444a6447$var$unset(_formState.dirtyFields, name) : $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $9a9ac4df444a6447$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $9a9ac4df444a6447$var$unset(_formState.errors, name);
        }
        if ((error ? !$9a9ac4df444a6447$var$deepEqual(previousFieldError, error) : previousFieldError) || !$9a9ac4df444a6447$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $9a9ac4df444a6447$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $9a9ac4df444a6447$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $9a9ac4df444a6447$export$3988ae62b71be9a3(errors, name);
            error ? $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $9a9ac4df444a6447$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $9a9ac4df444a6447$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await $9a9ac4df444a6447$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($9a9ac4df444a6447$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $9a9ac4df444a6447$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $9a9ac4df444a6447$var$unset(_formState.errors, _f.name));
                }
                !$9a9ac4df444a6447$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$9a9ac4df444a6447$var$live(ref)) : !$9a9ac4df444a6447$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formValues, name, data), !$9a9ac4df444a6447$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$9a9ac4df444a6447$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $9a9ac4df444a6447$var$isUndefined(defaultValue) ? _defaultValues : $9a9ac4df444a6447$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$9a9ac4df444a6447$var$compact($9a9ac4df444a6447$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $9a9ac4df444a6447$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formValues, name, $9a9ac4df444a6447$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $9a9ac4df444a6447$var$isHTMLElement(fieldReference.ref) && $9a9ac4df444a6447$var$isNullOrUndefined(value1) ? "" : value1;
                if ($9a9ac4df444a6447$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($9a9ac4df444a6447$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($9a9ac4df444a6447$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $9a9ac4df444a6447$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + "." + fieldKey;
            const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $9a9ac4df444a6447$var$isObject(fieldValue) || field && !field._f) && !$9a9ac4df444a6447$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $9a9ac4df444a6447$var$cloneObject(value1);
        $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $9a9ac4df444a6447$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $9a9ac4df444a6447$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$9a9ac4df444a6447$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $9a9ac4df444a6447$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState,
            name: name
        });
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $9a9ac4df444a6447$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $9a9ac4df444a6447$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $9a9ac4df444a6447$var$deepEqual(fieldValue, $9a9ac4df444a6447$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $9a9ac4df444a6447$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $9a9ac4df444a6447$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $9a9ac4df444a6447$var$getFieldValue(field._f) : $9a9ac4df444a6447$var$getEventValue(event);
            const isBlurEvent = event.type === $9a9ac4df444a6447$var$EVENTS.BLUR || event.type === $9a9ac4df444a6447$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$9a9ac4df444a6447$var$hasValidation(field._f) && !_options.resolver && !$9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $9a9ac4df444a6447$var$skipValidation(isBlurEvent, $9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $9a9ac4df444a6447$var$isWatched(name, _names, isBlurEvent);
            $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$9a9ac4df444a6447$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $9a9ac4df444a6447$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === "onBlur") {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $9a9ac4df444a6447$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $9a9ac4df444a6447$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $9a9ac4df444a6447$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $9a9ac4df444a6447$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $9a9ac4df444a6447$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($9a9ac4df444a6447$var$isUndefined(name) ? name : fieldNames);
            isValid = $9a9ac4df444a6447$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$9a9ac4df444a6447$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$9a9ac4df444a6447$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $9a9ac4df444a6447$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        if (config) values = $9a9ac4df444a6447$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $9a9ac4df444a6447$var$isUndefined(fieldNames) ? values : $9a9ac4df444a6447$var$isString(fieldNames) ? $9a9ac4df444a6447$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$9a9ac4df444a6447$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$9a9ac4df444a6447$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$9a9ac4df444a6447$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $9a9ac4df444a6447$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$9a9ac4df444a6447$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $9a9ac4df444a6447$var$convertToArrayPayload(name).forEach((inputName)=>$9a9ac4df444a6447$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$9a9ac4df444a6447$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>"values" in payload && name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($9a9ac4df444a6447$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $9a9ac4df444a6447$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback({
                    values: {
                        ..._formValues
                    },
                    ..._formState,
                    ...formState,
                    defaultValues: _defaultValues
                });
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: _proxySubscribeFormState
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $9a9ac4df444a6447$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $9a9ac4df444a6447$var$unset(_fields, fieldName);
                $9a9ac4df444a6447$var$unset(_formValues, fieldName);
            }
            !options.keepError && $9a9ac4df444a6447$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $9a9ac4df444a6447$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $9a9ac4df444a6447$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $9a9ac4df444a6447$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $9a9ac4df444a6447$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $9a9ac4df444a6447$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($9a9ac4df444a6447$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $9a9ac4df444a6447$var$isBoolean(options.disabled) || $9a9ac4df444a6447$var$isBoolean(_options.disabled);
        $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $9a9ac4df444a6447$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $9a9ac4df444a6447$var$getRuleValue(options.min),
                max: $9a9ac4df444a6447$var$getRuleValue(options.max),
                minLength: $9a9ac4df444a6447$var$getRuleValue(options.minLength),
                maxLength: $9a9ac4df444a6447$var$getRuleValue(options.maxLength),
                pattern: $9a9ac4df444a6447$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $9a9ac4df444a6447$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $9a9ac4df444a6447$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($9a9ac4df444a6447$var$live),
                                    fieldRef,
                                    ...Array.isArray($9a9ac4df444a6447$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($9a9ac4df444a6447$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $9a9ac4df444a6447$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($9a9ac4df444a6447$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $9a9ac4df444a6447$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $9a9ac4df444a6447$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = $9a9ac4df444a6447$var$cloneObject(values);
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$9a9ac4df444a6447$var$unset(fieldValues, name);
            $9a9ac4df444a6447$var$unset(_formState.errors, "root");
            if ($9a9ac4df444a6447$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $9a9ac4df444a6447$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name)) {
            if ($9a9ac4df444a6447$var$isUndefined(options.defaultValue)) setValue(name, $9a9ac4df444a6447$var$cloneObject($9a9ac4df444a6447$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $9a9ac4df444a6447$export$adaa4cf7ef1b65be(_defaultValues, name, $9a9ac4df444a6447$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $9a9ac4df444a6447$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $9a9ac4df444a6447$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $9a9ac4df444a6447$var$cloneObject($9a9ac4df444a6447$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $9a9ac4df444a6447$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $9a9ac4df444a6447$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $9a9ac4df444a6447$var$cloneObject(updatedValues);
        const isEmptyResetValues = $9a9ac4df444a6447$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($9a9ac4df444a6447$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$9a9ac4df444a6447$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $9a9ac4df444a6447$export$adaa4cf7ef1b65be(values, fieldName, $9a9ac4df444a6447$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $9a9ac4df444a6447$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($9a9ac4df444a6447$var$isWeb && $9a9ac4df444a6447$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($9a9ac4df444a6447$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $9a9ac4df444a6447$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $9a9ac4df444a6447$var$cloneObject(_defaultValues) : {} : $9a9ac4df444a6447$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$9a9ac4df444a6447$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $9a9ac4df444a6447$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $9a9ac4df444a6447$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($9a9ac4df444a6447$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $9a9ac4df444a6447$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$9a9ac4df444a6447$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $9a9ac4df444a6447$var$generateId = ()=>{
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $9a9ac4df444a6447$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $9a9ac4df444a6447$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$9a9ac4df444a6447$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $9a9ac4df444a6447$var$appendAt = (data, value1)=>[
        ...data,
        ...$9a9ac4df444a6447$var$convertToArrayPayload(value1)
    ];
var $9a9ac4df444a6447$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $9a9ac4df444a6447$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$9a9ac4df444a6447$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $9a9ac4df444a6447$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($9a9ac4df444a6447$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $9a9ac4df444a6447$var$prependAt = (data, value1)=>[
        ...$9a9ac4df444a6447$var$convertToArrayPayload(value1),
        ...$9a9ac4df444a6447$var$convertToArrayPayload(data)
    ];
function $9a9ac4df444a6447$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $9a9ac4df444a6447$var$compact(temp).length ? temp : [];
}
var $9a9ac4df444a6447$var$removeArrayAt = (data, index)=>$9a9ac4df444a6447$var$isUndefined(index) ? [] : $9a9ac4df444a6447$var$removeAtIndexes(data, $9a9ac4df444a6447$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $9a9ac4df444a6447$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $9a9ac4df444a6447$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $9a9ac4df444a6447$export$310131896651d559(props) {
    const methods = $9a9ac4df444a6447$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(control._getFieldArray(name).map($9a9ac4df444a6447$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(false);
    control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules
    ]);
    $9a9ac4df444a6447$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $9a9ac4df444a6447$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($9a9ac4df444a6447$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $9a9ac4df444a6447$var$convertToArrayPayload($9a9ac4df444a6447$var$cloneObject(value1));
        const updatedFieldArrayValues = $9a9ac4df444a6447$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $9a9ac4df444a6447$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $9a9ac4df444a6447$var$appendAt(ids.current, appendValue.map($9a9ac4df444a6447$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $9a9ac4df444a6447$var$appendAt, {
            argA: $9a9ac4df444a6447$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $9a9ac4df444a6447$var$convertToArrayPayload($9a9ac4df444a6447$var$cloneObject(value1));
        const updatedFieldArrayValues = $9a9ac4df444a6447$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $9a9ac4df444a6447$var$getFocusFieldName(name, 0, options);
        ids.current = $9a9ac4df444a6447$var$prependAt(ids.current, prependValue.map($9a9ac4df444a6447$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $9a9ac4df444a6447$var$prependAt, {
            argA: $9a9ac4df444a6447$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $9a9ac4df444a6447$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $9a9ac4df444a6447$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($9a9ac4df444a6447$export$3988ae62b71be9a3(control._fields, name)) && $9a9ac4df444a6447$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $9a9ac4df444a6447$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $9a9ac4df444a6447$var$convertToArrayPayload($9a9ac4df444a6447$var$cloneObject(value1));
        const updatedFieldArrayValues = $9a9ac4df444a6447$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $9a9ac4df444a6447$var$getFocusFieldName(name, index, options);
        ids.current = $9a9ac4df444a6447$var$insert(ids.current, index, insertValue.map($9a9ac4df444a6447$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $9a9ac4df444a6447$var$insert, {
            argA: index,
            argB: $9a9ac4df444a6447$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $9a9ac4df444a6447$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $9a9ac4df444a6447$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $9a9ac4df444a6447$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $9a9ac4df444a6447$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $9a9ac4df444a6447$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $9a9ac4df444a6447$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $9a9ac4df444a6447$var$cloneObject(value1);
        const updatedFieldArrayValues = $9a9ac4df444a6447$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $9a9ac4df444a6447$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $9a9ac4df444a6447$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $9a9ac4df444a6447$var$convertToArrayPayload($9a9ac4df444a6447$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($9a9ac4df444a6447$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        control._state.action = false;
        $9a9ac4df444a6447$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$9a9ac4df444a6447$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$9a9ac4df444a6447$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $9a9ac4df444a6447$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $9a9ac4df444a6447$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $9a9ac4df444a6447$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $9a9ac4df444a6447$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($9a9ac4df444a6447$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $9a9ac4df444a6447$var$getValidationModes(control._options.mode).isOnSubmit)) $9a9ac4df444a6447$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $9a9ac4df444a6447$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$9a9ac4df444a6447$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $9a9ac4df444a6447$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $9a9ac4df444a6447$var$cloneObject(control._formValues)
        });
        control._names.focus && $9a9ac4df444a6447$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        !$9a9ac4df444a6447$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $9a9ac4df444a6447$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $9a9ac4df444a6447$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $9a9ac4df444a6447$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $9a9ac4df444a6447$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $9a9ac4df444a6447$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState: formState
            };
            if (props.defaultValues && !$9a9ac4df444a6447$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl: formControl, ...rest } = $9a9ac4df444a6447$export$1361f5e0e4cca3c3(props);
            _formControl.current = {
                ...rest,
                formState: formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $9a9ac4df444a6447$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (props.values && !$9a9ac4df444a6447$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $9a9ac4df444a6447$var$getProxyFormState(formState, control);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param names - Array of field names to watch for changes
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const $9a9ac4df444a6447$export$4c68f1a79f88778c = ({ control: control, names: names, render: render })=>render($9a9ac4df444a6447$export$3c773aa2b84f29e0({
        control: control,
        name: names
    }));





var $aac36b370e6d425c$var$t = function(e, t, i) {
    if (e && "reportValidity" in e) {
        var n = (0, $9a9ac4df444a6447$export$3988ae62b71be9a3)(i, t);
        e.setCustomValidity(n && n.message || ""), e.reportValidity();
    }
}, $aac36b370e6d425c$export$6bd436d70894afff = function(r, e) {
    var i = function(i) {
        var n = e.fields[i];
        n && n.ref && "reportValidity" in n.ref ? $aac36b370e6d425c$var$t(n.ref, i, r) : n.refs && n.refs.forEach(function(e) {
            return $aac36b370e6d425c$var$t(e, i, r);
        });
    };
    for(var n in e.fields)i(n);
}, $aac36b370e6d425c$export$f0545b73a179e3a2 = function(t, n) {
    n.shouldUseNativeValidation && $aac36b370e6d425c$export$6bd436d70894afff(t, n);
    var f = {};
    for(var a in t){
        var s = (0, $9a9ac4df444a6447$export$3988ae62b71be9a3)(n.fields, a), u = Object.assign(t[a] || {}, {
            ref: s && s.ref
        });
        if ($aac36b370e6d425c$var$o(n.names || Object.keys(t), a)) {
            var c = Object.assign({}, (0, $9a9ac4df444a6447$export$3988ae62b71be9a3)(f, a));
            (0, $9a9ac4df444a6447$export$adaa4cf7ef1b65be)(c, "root", u), (0, $9a9ac4df444a6447$export$adaa4cf7ef1b65be)(f, a, c);
        } else (0, $9a9ac4df444a6447$export$adaa4cf7ef1b65be)(f, a, u);
    }
    return f;
}, $aac36b370e6d425c$var$o = function(r, e) {
    return r.some(function(r) {
        return r.startsWith(e + ".");
    });
};



var $d0fab596071fa8a6$var$n = function(r, e) {
    for(var n = {}; r.length;){
        var t = r[0], s = t.code, i = t.message, a = t.path.join(".");
        if (!n[a]) {
            if ("unionErrors" in t) {
                var u = t.unionErrors[0].errors[0];
                n[a] = {
                    message: u.message,
                    type: u.code
                };
            } else n[a] = {
                message: i,
                type: s
            };
        }
        if ("unionErrors" in t && t.unionErrors.forEach(function(e) {
            return e.errors.forEach(function(e) {
                return r.push(e);
            });
        }), e) {
            var c = n[a].types, f = c && c[t.code];
            n[a] = (0, $9a9ac4df444a6447$export$b196c2a4f765bd30)(a, e, n, s, f ? [].concat(f, t.message) : t.message);
        }
        r.shift();
    }
    return n;
}, $d0fab596071fa8a6$export$66b7b5879c70f722 = function(o, t, s) {
    return void 0 === s && (s = {}), function(i, a, u) {
        try {
            return Promise.resolve(function(e, n) {
                try {
                    var a = Promise.resolve(o["sync" === s.mode ? "parse" : "parseAsync"](i, t)).then(function(e) {
                        return u.shouldUseNativeValidation && (0, $aac36b370e6d425c$export$6bd436d70894afff)({}, u), {
                            errors: {},
                            values: s.raw ? i : e
                        };
                    });
                } catch (r) {
                    return n(r);
                }
                return a && a.then ? a.then(void 0, n) : a;
            }(0, function(r) {
                if (function(r) {
                    return Array.isArray(null == r ? void 0 : r.errors);
                }(r)) return {
                    values: {},
                    errors: (0, $aac36b370e6d425c$export$f0545b73a179e3a2)($d0fab596071fa8a6$var$n(r.errors, !u.shouldUseNativeValidation && "all" === u.criteriaMode), u)
                };
                throw r;
            }));
        } catch (r) {
            return Promise.reject(r);
        }
    };
};




var $7PdBe = parcelRequire("7PdBe");









var $7PdBe = parcelRequire("7PdBe");


"use client";
function $7c269d36919d4419$var$useStateMachine(initialState, machine) {
    return $7PdBe.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $7c269d36919d4419$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $7c269d36919d4419$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $7PdBe.Children.only(children);
    const ref = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(presence.ref, $7c269d36919d4419$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $7PdBe.cloneElement(child, {
        ref: ref
    }) : null;
};
$7c269d36919d4419$export$99c2b779aa4e8b8b.displayName = "Presence";
function $7c269d36919d4419$var$usePresence(present) {
    const [node, setNode] = $7PdBe.useState();
    const stylesRef = $7PdBe.useRef(null);
    const prevPresentRef = $7PdBe.useRef(present);
    const prevAnimationNameRef = $7PdBe.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $7c269d36919d4419$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $7PdBe.useEffect(()=>{
        const currentAnimationName = $7c269d36919d4419$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $7c269d36919d4419$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $7c269d36919d4419$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $7c269d36919d4419$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $7PdBe.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $7c269d36919d4419$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $7c269d36919d4419$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $7c269d36919d4419$export$be92b6f5f03c0fe9 = $7c269d36919d4419$export$99c2b779aa4e8b8b;








var $hvk62 = parcelRequire("hvk62");
"use client";
var $3db049dff66a112d$var$DIALOG_NAME = "Dialog";
var [$3db049dff66a112d$var$createDialogContext, $3db049dff66a112d$export$cc702773b8ea3e41] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)($3db049dff66a112d$var$DIALOG_NAME);
var [$3db049dff66a112d$var$DialogProvider, $3db049dff66a112d$var$useDialogContext] = $3db049dff66a112d$var$createDialogContext($3db049dff66a112d$var$DIALOG_NAME);
var $3db049dff66a112d$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $7PdBe.useRef(null);
    const contentRef = $7PdBe.useRef(null);
    const [open, setOpen] = (0, $892645e7859416d3$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $3db049dff66a112d$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $a2450a3e5d440835$export$f680877a34711e37)(),
        titleId: (0, $a2450a3e5d440835$export$f680877a34711e37)(),
        descriptionId: (0, $a2450a3e5d440835$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $7PdBe.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$3db049dff66a112d$export$3ddf2d174ce01153.displayName = $3db049dff66a112d$var$DIALOG_NAME;
var $3db049dff66a112d$var$TRIGGER_NAME = "DialogTrigger";
var $3db049dff66a112d$export$2e1e1122cf0cba88 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $3db049dff66a112d$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$3db049dff66a112d$export$2e1e1122cf0cba88.displayName = $3db049dff66a112d$var$TRIGGER_NAME;
var $3db049dff66a112d$var$PORTAL_NAME = "DialogPortal";
var [$3db049dff66a112d$var$PortalProvider, $3db049dff66a112d$var$usePortalContext] = $3db049dff66a112d$var$createDialogContext($3db049dff66a112d$var$PORTAL_NAME, {
    forceMount: void 0
});
var $3db049dff66a112d$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $7PdBe.Children.map(children, (child)=>/* @__PURE__ */ (0, $hvk62.jsx)((0, $7c269d36919d4419$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $fa484e2fa46a4ad3$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$3db049dff66a112d$export$dad7c95542bacce0.displayName = $3db049dff66a112d$var$PORTAL_NAME;
var $3db049dff66a112d$var$OVERLAY_NAME = "DialogOverlay";
var $3db049dff66a112d$export$bd1d06c79be19e17 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const portalContext = $3db049dff66a112d$var$usePortalContext($3db049dff66a112d$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $7c269d36919d4419$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$3db049dff66a112d$export$bd1d06c79be19e17.displayName = $3db049dff66a112d$var$OVERLAY_NAME;
var $3db049dff66a112d$var$Slot = (0, $0deb3a18aa385379$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll");
var $3db049dff66a112d$var$DialogOverlayImpl = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $hvk62.jsx)((0, $b3721a98528862e1$export$2e2bcd8739ae039), {
        as: $3db049dff66a112d$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
            "data-state": $3db049dff66a112d$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $3db049dff66a112d$var$CONTENT_NAME = "DialogContent";
var $3db049dff66a112d$export$b6d9565de1e068cf = $7PdBe.forwardRef((props, forwardedRef)=>{
    const portalContext = $3db049dff66a112d$var$usePortalContext($3db049dff66a112d$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $7c269d36919d4419$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$3db049dff66a112d$export$b6d9565de1e068cf.displayName = $3db049dff66a112d$var$CONTENT_NAME;
var $3db049dff66a112d$var$DialogContentModal = $7PdBe.forwardRef((props, forwardedRef)=>{
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $7PdBe.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $8f3a43ac6049bac0$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $3db049dff66a112d$var$DialogContentNonModal = $7PdBe.forwardRef((props, forwardedRef)=>{
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $7PdBe.useRef(false);
    const hasPointerDownOutsideRef = $7PdBe.useRef(false);
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $3db049dff66a112d$var$DialogContentImpl = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $0c9b2820b9ffd5a2$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)((0, $10a485d4fe8e4da1$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $f890894e21f3588e$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $3db049dff66a112d$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $3db049dff66a112d$var$TITLE_NAME = "DialogTitle";
var $3db049dff66a112d$export$16f7638e4a34b909 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$3db049dff66a112d$export$16f7638e4a34b909.displayName = $3db049dff66a112d$var$TITLE_NAME;
var $3db049dff66a112d$var$DESCRIPTION_NAME = "DialogDescription";
var $3db049dff66a112d$export$94e94c2ec2c954d5 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$3db049dff66a112d$export$94e94c2ec2c954d5.displayName = $3db049dff66a112d$var$DESCRIPTION_NAME;
var $3db049dff66a112d$var$CLOSE_NAME = "DialogClose";
var $3db049dff66a112d$export$fba2fb7cd781b7ac = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $3db049dff66a112d$var$useDialogContext($3db049dff66a112d$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$3db049dff66a112d$export$fba2fb7cd781b7ac.displayName = $3db049dff66a112d$var$CLOSE_NAME;
function $3db049dff66a112d$var$getState(open) {
    return open ? "open" : "closed";
}
var $3db049dff66a112d$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$3db049dff66a112d$export$69b62a49393917d6, $3db049dff66a112d$var$useWarningContext] = (0, $2b55cbfabf840987$export$fd42f52fd3ae1109)($3db049dff66a112d$var$TITLE_WARNING_NAME, {
    contentName: $3db049dff66a112d$var$CONTENT_NAME,
    titleName: $3db049dff66a112d$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $3db049dff66a112d$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $3db049dff66a112d$var$useWarningContext($3db049dff66a112d$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $7PdBe.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $3db049dff66a112d$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $3db049dff66a112d$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $3db049dff66a112d$var$useWarningContext($3db049dff66a112d$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $7PdBe.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $3db049dff66a112d$export$be92b6f5f03c0fe9 = $3db049dff66a112d$export$3ddf2d174ce01153;
var $3db049dff66a112d$export$41fb9f06171c75f4 = $3db049dff66a112d$export$2e1e1122cf0cba88;
var $3db049dff66a112d$export$602eac185826482c = $3db049dff66a112d$export$dad7c95542bacce0;
var $3db049dff66a112d$export$c6fdb837b070b4ff = $3db049dff66a112d$export$bd1d06c79be19e17;
var $3db049dff66a112d$export$7c6e2c02157bb7d2 = $3db049dff66a112d$export$b6d9565de1e068cf;
var $3db049dff66a112d$export$f99233281efd08a0 = $3db049dff66a112d$export$16f7638e4a34b909;
var $3db049dff66a112d$export$393edc798c47379d = $3db049dff66a112d$export$94e94c2ec2c954d5;
var $3db049dff66a112d$export$f39c2d165cd861fe = $3db049dff66a112d$export$fba2fb7cd781b7ac;



var $7PdBe = parcelRequire("7PdBe");






var $7PdBe = parcelRequire("7PdBe");














var $7PdBe = parcelRequire("7PdBe");










var $hvk62 = parcelRequire("hvk62");
"use client";
var $a1c514d00dd47b34$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $a1c514d00dd47b34$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $a1c514d00dd47b34$var$GROUP_NAME = "RovingFocusGroup";
var [$a1c514d00dd47b34$var$Collection, $a1c514d00dd47b34$var$useCollection, $a1c514d00dd47b34$var$createCollectionScope] = (0, $63e4826237d580a4$export$c74125a8e3af6bb2)($a1c514d00dd47b34$var$GROUP_NAME);
var [$a1c514d00dd47b34$var$createRovingFocusGroupContext, $a1c514d00dd47b34$export$c7109489551a4f4] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)($a1c514d00dd47b34$var$GROUP_NAME, [
    $a1c514d00dd47b34$var$createCollectionScope
]);
var [$a1c514d00dd47b34$var$RovingFocusProvider, $a1c514d00dd47b34$var$useRovingFocusContext] = $a1c514d00dd47b34$var$createRovingFocusGroupContext($a1c514d00dd47b34$var$GROUP_NAME);
var $a1c514d00dd47b34$export$8699f7c8af148338 = $7PdBe.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $hvk62.jsx)($a1c514d00dd47b34$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($a1c514d00dd47b34$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $hvk62.jsx)($a1c514d00dd47b34$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$a1c514d00dd47b34$export$8699f7c8af148338.displayName = $a1c514d00dd47b34$var$GROUP_NAME;
var $a1c514d00dd47b34$var$RovingFocusGroupImpl = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $e77fd31f81c27db6$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $892645e7859416d3$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: $a1c514d00dd47b34$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $7PdBe.useState(false);
    const handleEntryFocus = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $a1c514d00dd47b34$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $7PdBe.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $7PdBe.useState(0);
    $7PdBe.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($a1c514d00dd47b34$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($a1c514d00dd47b34$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)($a1c514d00dd47b34$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $7PdBe.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $7PdBe.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $7PdBe.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $7PdBe.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($a1c514d00dd47b34$var$ENTRY_FOCUS, $a1c514d00dd47b34$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $a1c514d00dd47b34$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $a1c514d00dd47b34$var$ITEM_NAME = "RovingFocusGroupItem";
var $a1c514d00dd47b34$export$ab9df7c53fe8454 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children, ...itemProps } = props;
    const autoId = (0, $a2450a3e5d440835$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $a1c514d00dd47b34$var$useRovingFocusContext($a1c514d00dd47b34$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $a1c514d00dd47b34$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    $7PdBe.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)($a1c514d00dd47b34$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $a1c514d00dd47b34$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $a1c514d00dd47b34$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$a1c514d00dd47b34$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
});
$a1c514d00dd47b34$export$ab9df7c53fe8454.displayName = $a1c514d00dd47b34$var$ITEM_NAME;
var $a1c514d00dd47b34$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $a1c514d00dd47b34$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $a1c514d00dd47b34$var$getFocusIntent(event, orientation, dir) {
    const key = $a1c514d00dd47b34$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $a1c514d00dd47b34$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $a1c514d00dd47b34$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $a1c514d00dd47b34$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $a1c514d00dd47b34$export$be92b6f5f03c0fe9 = $a1c514d00dd47b34$export$8699f7c8af148338;
var $a1c514d00dd47b34$export$6d08773d2e66f8f2 = $a1c514d00dd47b34$export$ab9df7c53fe8454;







var $hvk62 = parcelRequire("hvk62");
"use client";
var $bf0e7c6991755a6d$var$SELECTION_KEYS = [
    "Enter",
    " "
];
var $bf0e7c6991755a6d$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
var $bf0e7c6991755a6d$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
var $bf0e7c6991755a6d$var$FIRST_LAST_KEYS = [
    ...$bf0e7c6991755a6d$var$FIRST_KEYS,
    ...$bf0e7c6991755a6d$var$LAST_KEYS
];
var $bf0e7c6991755a6d$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$bf0e7c6991755a6d$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$bf0e7c6991755a6d$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
var $bf0e7c6991755a6d$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
var $bf0e7c6991755a6d$var$MENU_NAME = "Menu";
var [$bf0e7c6991755a6d$var$Collection, $bf0e7c6991755a6d$var$useCollection, $bf0e7c6991755a6d$var$createCollectionScope] = (0, $63e4826237d580a4$export$c74125a8e3af6bb2)($bf0e7c6991755a6d$var$MENU_NAME);
var [$bf0e7c6991755a6d$var$createMenuContext, $bf0e7c6991755a6d$export$4027731b685e72eb] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)($bf0e7c6991755a6d$var$MENU_NAME, [
    $bf0e7c6991755a6d$var$createCollectionScope,
    (0, $138fccadffc9ae29$export$722aac194ae923),
    (0, $a1c514d00dd47b34$export$c7109489551a4f4)
]);
var $bf0e7c6991755a6d$var$usePopperScope = (0, $138fccadffc9ae29$export$722aac194ae923)();
var $bf0e7c6991755a6d$var$useRovingFocusGroupScope = (0, $a1c514d00dd47b34$export$c7109489551a4f4)();
var [$bf0e7c6991755a6d$var$MenuProvider, $bf0e7c6991755a6d$var$useMenuContext] = $bf0e7c6991755a6d$var$createMenuContext($bf0e7c6991755a6d$var$MENU_NAME);
var [$bf0e7c6991755a6d$var$MenuRootProvider, $bf0e7c6991755a6d$var$useMenuRootContext] = $bf0e7c6991755a6d$var$createMenuContext($bf0e7c6991755a6d$var$MENU_NAME);
var $bf0e7c6991755a6d$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu, open: open = false, children: children, dir: dir, onOpenChange: onOpenChange, modal: modal = true } = props;
    const popperScope = $bf0e7c6991755a6d$var$usePopperScope(__scopeMenu);
    const [content, setContent] = $7PdBe.useState(null);
    const isUsingKeyboardRef = $7PdBe.useRef(false);
    const handleOpenChange = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onOpenChange);
    const direction = (0, $e77fd31f81c27db6$export$b39126d51d94e6f3)(dir);
    $7PdBe.useEffect(()=>{
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuRootProvider, {
                scope: __scopeMenu,
                onClose: $7PdBe.useCallback(()=>handleOpenChange(false), [
                    handleOpenChange
                ]),
                isUsingKeyboardRef: isUsingKeyboardRef,
                dir: direction,
                modal: modal,
                children: children
            })
        })
    });
};
$bf0e7c6991755a6d$export$d9b273488cd8ce6f.displayName = $bf0e7c6991755a6d$var$MENU_NAME;
var $bf0e7c6991755a6d$var$ANCHOR_NAME = "MenuAnchor";
var $bf0e7c6991755a6d$export$9fa5ebd18bee4d43 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...anchorProps } = props;
    const popperScope = $bf0e7c6991755a6d$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$bf0e7c6991755a6d$export$9fa5ebd18bee4d43.displayName = $bf0e7c6991755a6d$var$ANCHOR_NAME;
var $bf0e7c6991755a6d$var$PORTAL_NAME = "MenuPortal";
var [$bf0e7c6991755a6d$var$PortalProvider, $bf0e7c6991755a6d$var$usePortalContext] = $bf0e7c6991755a6d$var$createMenuContext($bf0e7c6991755a6d$var$PORTAL_NAME, {
    forceMount: void 0
});
var $bf0e7c6991755a6d$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, children: children, container: container } = props;
    const context = $bf0e7c6991755a6d$var$useMenuContext($bf0e7c6991755a6d$var$PORTAL_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $7c269d36919d4419$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $fa484e2fa46a4ad3$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$bf0e7c6991755a6d$export$793392f970497feb.displayName = $bf0e7c6991755a6d$var$PORTAL_NAME;
var $bf0e7c6991755a6d$var$CONTENT_NAME = "MenuContent";
var [$bf0e7c6991755a6d$var$MenuContentProvider, $bf0e7c6991755a6d$var$useMenuContentContext] = $bf0e7c6991755a6d$var$createMenuContext($bf0e7c6991755a6d$var$CONTENT_NAME);
var $bf0e7c6991755a6d$export$479f0f2f71193efe = $7PdBe.forwardRef((props, forwardedRef)=>{
    const portalContext = $bf0e7c6991755a6d$var$usePortalContext($bf0e7c6991755a6d$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $bf0e7c6991755a6d$var$useMenuContext($bf0e7c6991755a6d$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $bf0e7c6991755a6d$var$useMenuRootContext($bf0e7c6991755a6d$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $7c269d36919d4419$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: rootContext.modal ? /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuRootContentModal, {
                    ...contentProps,
                    ref: forwardedRef
                }) : /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuRootContentNonModal, {
                    ...contentProps,
                    ref: forwardedRef
                })
            })
        })
    });
});
var $bf0e7c6991755a6d$var$MenuRootContentModal = $7PdBe.forwardRef((props, forwardedRef)=>{
    const context = $bf0e7c6991755a6d$var$useMenuContext($bf0e7c6991755a6d$var$CONTENT_NAME, props.__scopeMenu);
    const ref = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $7PdBe.useEffect(()=>{
        const content = ref.current;
        if (content) return (0, $8f3a43ac6049bac0$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $bf0e7c6991755a6d$var$MenuRootContentNonModal = $7PdBe.forwardRef((props, forwardedRef)=>{
    const context = $bf0e7c6991755a6d$var$useMenuContext($bf0e7c6991755a6d$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $bf0e7c6991755a6d$var$Slot = (0, $0deb3a18aa385379$export$e88b45bda5c13eb9)("MenuContent.ScrollLock");
var $bf0e7c6991755a6d$var$MenuContentImpl = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, loop: loop = false, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEntryFocus: onEntryFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, disableOutsideScroll: disableOutsideScroll, ...contentProps } = props;
    const context = $bf0e7c6991755a6d$var$useMenuContext($bf0e7c6991755a6d$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $bf0e7c6991755a6d$var$useMenuRootContext($bf0e7c6991755a6d$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $bf0e7c6991755a6d$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $bf0e7c6991755a6d$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $bf0e7c6991755a6d$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = $7PdBe.useState(null);
    const contentRef = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = $7PdBe.useRef(0);
    const searchRef = $7PdBe.useRef("");
    const pointerGraceTimerRef = $7PdBe.useRef(0);
    const pointerGraceIntentRef = $7PdBe.useRef(null);
    const pointerDirRef = $7PdBe.useRef("right");
    const lastPointerXRef = $7PdBe.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $b3721a98528862e1$export$2e2bcd8739ae039) : $7PdBe.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: $bf0e7c6991755a6d$var$Slot,
        allowPinchZoom: true
    } : void 0;
    const handleTypeaheadSearch = (key)=>{
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = items.find((item)=>item.ref.current === currentItem)?.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $bf0e7c6991755a6d$var$getNextMatch(values, search, currentMatch);
        const newItem = items.find((item)=>item.textValue === nextMatch)?.ref.current;
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
        if (newItem) setTimeout(()=>newItem.focus());
    };
    $7PdBe.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    (0, $0c9b2820b9ffd5a2$export$b7ece24a22aeda8c)();
    const isPointerMovingToSubmenu = $7PdBe.useCallback((event)=>{
        const isMovingTowards = pointerDirRef.current === pointerGraceIntentRef.current?.side;
        return isMovingTowards && $bf0e7c6991755a6d$var$isPointerInGraceArea(event, pointerGraceIntentRef.current?.area);
    }, []);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: $7PdBe.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: $7PdBe.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) return;
            contentRef.current?.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: $7PdBe.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: $7PdBe.useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ (0, $hvk62.jsx)(ScrollLockWrapper, {
            ...scrollLockWrapperProps,
            children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $10a485d4fe8e4da1$export$20e40289641fbbb6), {
                asChild: true,
                trapped: trapFocus,
                onMountAutoFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(onOpenAutoFocus, (event)=>{
                    event.preventDefault();
                    contentRef.current?.focus({
                        preventScroll: true
                    });
                }),
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $f890894e21f3588e$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: disableOutsidePointerEvents,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: onFocusOutside,
                    onInteractOutside: onInteractOutside,
                    onDismiss: onDismiss,
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($a1c514d00dd47b34$export$be92b6f5f03c0fe9, {
                        asChild: true,
                        ...rovingFocusGroupScope,
                        dir: rootContext.dir,
                        orientation: "vertical",
                        loop: loop,
                        currentTabStopId: currentItemId,
                        onCurrentTabStopIdChange: setCurrentItemId,
                        onEntryFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(onEntryFocus, (event)=>{
                            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                        }),
                        preventScrollOnEntryFocus: true,
                        children: /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$7c6e2c02157bb7d2, {
                            role: "menu",
                            "aria-orientation": "vertical",
                            "data-state": $bf0e7c6991755a6d$var$getOpenState(context.open),
                            "data-radix-menu-content": "",
                            dir: rootContext.dir,
                            ...popperScope,
                            ...contentProps,
                            ref: composedRefs,
                            style: {
                                outline: "none",
                                ...contentProps.style
                            },
                            onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                                const target = event.target;
                                const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                                const isCharacterKey = event.key.length === 1;
                                if (isKeyDownInside) {
                                    if (event.key === "Tab") event.preventDefault();
                                    if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                                }
                                const content = contentRef.current;
                                if (event.target !== content) return;
                                if (!$bf0e7c6991755a6d$var$FIRST_LAST_KEYS.includes(event.key)) return;
                                event.preventDefault();
                                const items = getItems().filter((item)=>!item.disabled);
                                const candidateNodes = items.map((item)=>item.ref.current);
                                if ($bf0e7c6991755a6d$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                                $bf0e7c6991755a6d$var$focusFirst(candidateNodes);
                            }),
                            onBlur: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onBlur, (event)=>{
                                if (!event.currentTarget.contains(event.target)) {
                                    window.clearTimeout(timerRef.current);
                                    searchRef.current = "";
                                }
                            }),
                            onPointerMove: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerMove, $bf0e7c6991755a6d$var$whenMouse((event)=>{
                                const target = event.target;
                                const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                                if (event.currentTarget.contains(target) && pointerXHasChanged) {
                                    const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                                    pointerDirRef.current = newDir;
                                    lastPointerXRef.current = event.clientX;
                                }
                            }))
                        })
                    })
                })
            })
        })
    });
});
$bf0e7c6991755a6d$export$479f0f2f71193efe.displayName = $bf0e7c6991755a6d$var$CONTENT_NAME;
var $bf0e7c6991755a6d$var$GROUP_NAME = "MenuGroup";
var $bf0e7c6991755a6d$export$22a631d1f72787bb = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        role: "group",
        ...groupProps,
        ref: forwardedRef
    });
});
$bf0e7c6991755a6d$export$22a631d1f72787bb.displayName = $bf0e7c6991755a6d$var$GROUP_NAME;
var $bf0e7c6991755a6d$var$LABEL_NAME = "MenuLabel";
var $bf0e7c6991755a6d$export$dd37bec0e8a99143 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        ...labelProps,
        ref: forwardedRef
    });
});
$bf0e7c6991755a6d$export$dd37bec0e8a99143.displayName = $bf0e7c6991755a6d$var$LABEL_NAME;
var $bf0e7c6991755a6d$var$ITEM_NAME = "MenuItem";
var $bf0e7c6991755a6d$var$ITEM_SELECT = "menu.itemSelect";
var $bf0e7c6991755a6d$export$2ce376c2cc3355c8 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { disabled: disabled = false, onSelect: onSelect, ...itemProps } = props;
    const ref = $7PdBe.useRef(null);
    const rootContext = $bf0e7c6991755a6d$var$useMenuRootContext($bf0e7c6991755a6d$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $bf0e7c6991755a6d$var$useMenuContentContext($bf0e7c6991755a6d$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const isPointerDownRef = $7PdBe.useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($bf0e7c6991755a6d$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($bf0e7c6991755a6d$var$ITEM_SELECT, (event)=>onSelect?.(event), {
                once: true
            });
            (0, $252f0230ab9bb14c$export$6d1a0317bde7de7f)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuItemImpl, {
        ...itemProps,
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            props.onPointerDown?.(event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            if (!isPointerDownRef.current) event.currentTarget?.click();
        }),
        onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($bf0e7c6991755a6d$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                event.preventDefault();
            }
        })
    });
});
$bf0e7c6991755a6d$export$2ce376c2cc3355c8.displayName = $bf0e7c6991755a6d$var$ITEM_NAME;
var $bf0e7c6991755a6d$var$MenuItemImpl = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, disabled: disabled = false, textValue: textValue, ...itemProps } = props;
    const contentContext = $bf0e7c6991755a6d$var$useMenuContentContext($bf0e7c6991755a6d$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $bf0e7c6991755a6d$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [isFocused, setIsFocused] = $7PdBe.useState(false);
    const [textContent, setTextContent] = $7PdBe.useState("");
    $7PdBe.useEffect(()=>{
        const menuItem = ref.current;
        if (menuItem) setTextContent((menuItem.textContent ?? "").trim());
    }, [
        itemProps.children
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue ?? textContent,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($a1c514d00dd47b34$export$6d08773d2e66f8f2, {
            asChild: true,
            ...rovingFocusGroupScope,
            focusable: !disabled,
            children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
                role: "menuitem",
                "data-highlighted": isFocused ? "" : void 0,
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                ...itemProps,
                ref: composedRefs,
                onPointerMove: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerMove, $bf0e7c6991755a6d$var$whenMouse((event)=>{
                    if (disabled) contentContext.onItemLeave(event);
                    else {
                        contentContext.onItemEnter(event);
                        if (!event.defaultPrevented) {
                            const item = event.currentTarget;
                            item.focus({
                                preventScroll: true
                            });
                        }
                    }
                })),
                onPointerLeave: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerLeave, $bf0e7c6991755a6d$var$whenMouse((event)=>contentContext.onItemLeave(event))),
                onFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsFocused(false))
            })
        })
    });
});
var $bf0e7c6991755a6d$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var $bf0e7c6991755a6d$export$f6f243521332502d = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { checked: checked = false, onCheckedChange: onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$2ce376c2cc3355c8, {
            role: "menuitemcheckbox",
            "aria-checked": $bf0e7c6991755a6d$var$isIndeterminate(checked) ? "mixed" : checked,
            ...checkboxItemProps,
            ref: forwardedRef,
            "data-state": $bf0e7c6991755a6d$var$getCheckedState(checked),
            onSelect: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(checkboxItemProps.onSelect, ()=>onCheckedChange?.($bf0e7c6991755a6d$var$isIndeterminate(checked) ? true : !checked), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$bf0e7c6991755a6d$export$f6f243521332502d.displayName = $bf0e7c6991755a6d$var$CHECKBOX_ITEM_NAME;
var $bf0e7c6991755a6d$var$RADIO_GROUP_NAME = "MenuRadioGroup";
var [$bf0e7c6991755a6d$var$RadioGroupProvider, $bf0e7c6991755a6d$var$useRadioGroupContext] = $bf0e7c6991755a6d$var$createMenuContext($bf0e7c6991755a6d$var$RADIO_GROUP_NAME, {
    value: void 0,
    onValueChange: ()=>{}
});
var $bf0e7c6991755a6d$export$ea2200c9eee416b3 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { value: value, onValueChange: onValueChange, ...groupProps } = props;
    const handleValueChange = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onValueChange);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$22a631d1f72787bb, {
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$bf0e7c6991755a6d$export$ea2200c9eee416b3.displayName = $bf0e7c6991755a6d$var$RADIO_GROUP_NAME;
var $bf0e7c6991755a6d$var$RADIO_ITEM_NAME = "MenuRadioItem";
var $bf0e7c6991755a6d$export$69bd225e9817f6d0 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { value: value, ...radioItemProps } = props;
    const context = $bf0e7c6991755a6d$var$useRadioGroupContext($bf0e7c6991755a6d$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$2ce376c2cc3355c8, {
            role: "menuitemradio",
            "aria-checked": checked,
            ...radioItemProps,
            ref: forwardedRef,
            "data-state": $bf0e7c6991755a6d$var$getCheckedState(checked),
            onSelect: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(radioItemProps.onSelect, ()=>context.onValueChange?.(value), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$bf0e7c6991755a6d$export$69bd225e9817f6d0.displayName = $bf0e7c6991755a6d$var$RADIO_ITEM_NAME;
var $bf0e7c6991755a6d$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
var [$bf0e7c6991755a6d$var$ItemIndicatorProvider, $bf0e7c6991755a6d$var$useItemIndicatorContext] = $bf0e7c6991755a6d$var$createMenuContext($bf0e7c6991755a6d$var$ITEM_INDICATOR_NAME, {
    checked: false
});
var $bf0e7c6991755a6d$export$a2593e23056970a3 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = $bf0e7c6991755a6d$var$useItemIndicatorContext($bf0e7c6991755a6d$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $7c269d36919d4419$export$99c2b779aa4e8b8b), {
        present: forceMount || $bf0e7c6991755a6d$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": $bf0e7c6991755a6d$var$getCheckedState(indicatorContext.checked)
        })
    });
});
$bf0e7c6991755a6d$export$a2593e23056970a3.displayName = $bf0e7c6991755a6d$var$ITEM_INDICATOR_NAME;
var $bf0e7c6991755a6d$var$SEPARATOR_NAME = "MenuSeparator";
var $bf0e7c6991755a6d$export$1cec7dcdd713e220 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
    });
});
$bf0e7c6991755a6d$export$1cec7dcdd713e220.displayName = $bf0e7c6991755a6d$var$SEPARATOR_NAME;
var $bf0e7c6991755a6d$var$ARROW_NAME = "MenuArrow";
var $bf0e7c6991755a6d$export$bcdda4773debf5fa = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...arrowProps } = props;
    const popperScope = $bf0e7c6991755a6d$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$bf0e7c6991755a6d$export$bcdda4773debf5fa.displayName = $bf0e7c6991755a6d$var$ARROW_NAME;
var $bf0e7c6991755a6d$var$SUB_NAME = "MenuSub";
var [$bf0e7c6991755a6d$var$MenuSubProvider, $bf0e7c6991755a6d$var$useMenuSubContext] = $bf0e7c6991755a6d$var$createMenuContext($bf0e7c6991755a6d$var$SUB_NAME);
var $bf0e7c6991755a6d$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu, children: children, open: open = false, onOpenChange: onOpenChange } = props;
    const parentMenuContext = $bf0e7c6991755a6d$var$useMenuContext($bf0e7c6991755a6d$var$SUB_NAME, __scopeMenu);
    const popperScope = $bf0e7c6991755a6d$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = $7PdBe.useState(null);
    const [content, setContent] = $7PdBe.useState(null);
    const handleOpenChange = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)(onOpenChange);
    $7PdBe.useEffect(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)($138fccadffc9ae29$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuSubProvider, {
                scope: __scopeMenu,
                contentId: (0, $a2450a3e5d440835$export$f680877a34711e37)(),
                triggerId: (0, $a2450a3e5d440835$export$f680877a34711e37)(),
                trigger: trigger,
                onTriggerChange: setTrigger,
                children: children
            })
        })
    });
};
$bf0e7c6991755a6d$export$71bdb9d1e2909932.displayName = $bf0e7c6991755a6d$var$SUB_NAME;
var $bf0e7c6991755a6d$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
var $bf0e7c6991755a6d$export$5fbbb3ba7297405f = $7PdBe.forwardRef((props, forwardedRef)=>{
    const context = $bf0e7c6991755a6d$var$useMenuContext($bf0e7c6991755a6d$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $bf0e7c6991755a6d$var$useMenuRootContext($bf0e7c6991755a6d$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $bf0e7c6991755a6d$var$useMenuSubContext($bf0e7c6991755a6d$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $bf0e7c6991755a6d$var$useMenuContentContext($bf0e7c6991755a6d$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = $7PdBe.useRef(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef, onPointerGraceIntentChange: onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = $7PdBe.useCallback(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    $7PdBe.useEffect(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    $7PdBe.useEffect(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$9fa5ebd18bee4d43, {
        asChild: true,
        ...scope,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuItemImpl, {
            id: subContext.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": subContext.contentId,
            "data-state": $bf0e7c6991755a6d$var$getOpenState(context.open),
            ...props,
            ref: (0, $1d2c417c81554c6a$export$43e446d32b3d21af)(forwardedRef, subContext.onTriggerChange),
            onClick: (event)=>{
                props.onClick?.(event);
                if (props.disabled || event.defaultPrevented) return;
                event.currentTarget.focus();
                if (!context.open) context.onOpenChange(true);
            },
            onPointerMove: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerMove, $bf0e7c6991755a6d$var$whenMouse((event)=>{
                contentContext.onItemEnter(event);
                if (event.defaultPrevented) return;
                if (!props.disabled && !context.open && !openTimerRef.current) {
                    contentContext.onPointerGraceIntentChange(null);
                    openTimerRef.current = window.setTimeout(()=>{
                        context.onOpenChange(true);
                        clearOpenTimer();
                    }, 100);
                }
            })),
            onPointerLeave: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerLeave, $bf0e7c6991755a6d$var$whenMouse((event)=>{
                clearOpenTimer();
                const contentRect = context.content?.getBoundingClientRect();
                if (contentRect) {
                    const side = context.content?.dataset.side;
                    const rightSide = side === "right";
                    const bleed = rightSide ? -5 : 5;
                    const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                    const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                    contentContext.onPointerGraceIntentChange({
                        area: [
                            // Apply a bleed on clientX to ensure that our exit point is
                            // consistently within polygon bounds
                            {
                                x: event.clientX + bleed,
                                y: event.clientY
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.bottom
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.bottom
                            }
                        ],
                        side: side
                    });
                    window.clearTimeout(pointerGraceTimerRef.current);
                    pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
                } else {
                    contentContext.onTriggerLeave(event);
                    if (event.defaultPrevented) return;
                    contentContext.onPointerGraceIntentChange(null);
                }
            })),
            onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                const isTypingAhead = contentContext.searchRef.current !== "";
                if (props.disabled || isTypingAhead && event.key === " ") return;
                if ($bf0e7c6991755a6d$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                    context.onOpenChange(true);
                    context.content?.focus();
                    event.preventDefault();
                }
            })
        })
    });
});
$bf0e7c6991755a6d$export$5fbbb3ba7297405f.displayName = $bf0e7c6991755a6d$var$SUB_TRIGGER_NAME;
var $bf0e7c6991755a6d$var$SUB_CONTENT_NAME = "MenuSubContent";
var $bf0e7c6991755a6d$export$e7142ab31822bde6 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const portalContext = $bf0e7c6991755a6d$var$usePortalContext($bf0e7c6991755a6d$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = $bf0e7c6991755a6d$var$useMenuContext($bf0e7c6991755a6d$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $bf0e7c6991755a6d$var$useMenuRootContext($bf0e7c6991755a6d$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $bf0e7c6991755a6d$var$useMenuSubContext($bf0e7c6991755a6d$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = $7PdBe.useRef(null);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $7c269d36919d4419$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$var$MenuContentImpl, {
                    id: subContext.contentId,
                    "aria-labelledby": subContext.triggerId,
                    ...subContentProps,
                    ref: composedRefs,
                    align: "start",
                    side: rootContext.dir === "rtl" ? "left" : "right",
                    disableOutsidePointerEvents: false,
                    disableOutsideScroll: false,
                    trapFocus: false,
                    onOpenAutoFocus: (event)=>{
                        if (rootContext.isUsingKeyboardRef.current) ref.current?.focus();
                        event.preventDefault();
                    },
                    onCloseAutoFocus: (event)=>event.preventDefault(),
                    onFocusOutside: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
                        if (event.target !== subContext.trigger) context.onOpenChange(false);
                    }),
                    onEscapeKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onEscapeKeyDown, (event)=>{
                        rootContext.onClose();
                        event.preventDefault();
                    }),
                    onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                        const isKeyDownInside = event.currentTarget.contains(event.target);
                        const isCloseKey = $bf0e7c6991755a6d$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
                        if (isKeyDownInside && isCloseKey) {
                            context.onOpenChange(false);
                            subContext.trigger?.focus();
                            event.preventDefault();
                        }
                    })
                })
            })
        })
    });
});
$bf0e7c6991755a6d$export$e7142ab31822bde6.displayName = $bf0e7c6991755a6d$var$SUB_CONTENT_NAME;
function $bf0e7c6991755a6d$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $bf0e7c6991755a6d$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $bf0e7c6991755a6d$var$getCheckedState(checked) {
    return $bf0e7c6991755a6d$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $bf0e7c6991755a6d$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $bf0e7c6991755a6d$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
function $bf0e7c6991755a6d$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $bf0e7c6991755a6d$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $bf0e7c6991755a6d$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const ii = polygon[i];
        const jj = polygon[j];
        const xi = ii.x;
        const yi = ii.y;
        const xj = jj.x;
        const yj = jj.y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $bf0e7c6991755a6d$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $bf0e7c6991755a6d$var$isPointInPolygon(cursorPos, area);
}
function $bf0e7c6991755a6d$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : void 0;
}
var $bf0e7c6991755a6d$export$be92b6f5f03c0fe9 = $bf0e7c6991755a6d$export$d9b273488cd8ce6f;
var $bf0e7c6991755a6d$export$b688253958b8dfe7 = $bf0e7c6991755a6d$export$9fa5ebd18bee4d43;
var $bf0e7c6991755a6d$export$602eac185826482c = $bf0e7c6991755a6d$export$793392f970497feb;
var $bf0e7c6991755a6d$export$7c6e2c02157bb7d2 = $bf0e7c6991755a6d$export$479f0f2f71193efe;
var $bf0e7c6991755a6d$export$eb2fcfdbd7ba97d4 = $bf0e7c6991755a6d$export$22a631d1f72787bb;
var $bf0e7c6991755a6d$export$b04be29aa201d4f5 = $bf0e7c6991755a6d$export$dd37bec0e8a99143;
var $bf0e7c6991755a6d$export$6d08773d2e66f8f2 = $bf0e7c6991755a6d$export$2ce376c2cc3355c8;
var $bf0e7c6991755a6d$export$16ce288f89fa631c = $bf0e7c6991755a6d$export$f6f243521332502d;
var $bf0e7c6991755a6d$export$a98f0dcb43a68a25 = $bf0e7c6991755a6d$export$ea2200c9eee416b3;
var $bf0e7c6991755a6d$export$371ab307eab489c0 = $bf0e7c6991755a6d$export$69bd225e9817f6d0;
var $bf0e7c6991755a6d$export$c3468e2714d175fa = $bf0e7c6991755a6d$export$a2593e23056970a3;
var $bf0e7c6991755a6d$export$1ff3c3f08ae963c0 = $bf0e7c6991755a6d$export$1cec7dcdd713e220;
var $bf0e7c6991755a6d$export$21b07c8f274aebd5 = $bf0e7c6991755a6d$export$bcdda4773debf5fa;
var $bf0e7c6991755a6d$export$d7a01e11500dfb6f = $bf0e7c6991755a6d$export$71bdb9d1e2909932;
var $bf0e7c6991755a6d$export$2ea8a7a591ac5eac = $bf0e7c6991755a6d$export$5fbbb3ba7297405f;
var $bf0e7c6991755a6d$export$6d4de93b380beddf = $bf0e7c6991755a6d$export$e7142ab31822bde6;




var $hvk62 = parcelRequire("hvk62");
"use client";
var $e7bd25a108aa4fe5$var$DROPDOWN_MENU_NAME = "DropdownMenu";
var [$e7bd25a108aa4fe5$var$createDropdownMenuContext, $e7bd25a108aa4fe5$export$c0623cd925aeb687] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)($e7bd25a108aa4fe5$var$DROPDOWN_MENU_NAME, [
    (0, $bf0e7c6991755a6d$export$4027731b685e72eb)
]);
var $e7bd25a108aa4fe5$var$useMenuScope = (0, $bf0e7c6991755a6d$export$4027731b685e72eb)();
var [$e7bd25a108aa4fe5$var$DropdownMenuProvider, $e7bd25a108aa4fe5$var$useDropdownMenuContext] = $e7bd25a108aa4fe5$var$createDropdownMenuContext($e7bd25a108aa4fe5$var$DROPDOWN_MENU_NAME);
var $e7bd25a108aa4fe5$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, dir: dir, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = $7PdBe.useRef(null);
    const [open, setOpen] = (0, $892645e7859416d3$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $e7bd25a108aa4fe5$var$DROPDOWN_MENU_NAME
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($e7bd25a108aa4fe5$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $a2450a3e5d440835$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        contentId: (0, $a2450a3e5d440835$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $7PdBe.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$be92b6f5f03c0fe9, {
            ...menuScope,
            open: open,
            onOpenChange: setOpen,
            dir: dir,
            modal: modal,
            children: children
        })
    });
};
$e7bd25a108aa4fe5$export$e44a253a59704894.displayName = $e7bd25a108aa4fe5$var$DROPDOWN_MENU_NAME;
var $e7bd25a108aa4fe5$var$TRIGGER_NAME = "DropdownMenuTrigger";
var $e7bd25a108aa4fe5$export$d2469213b3befba9 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $e7bd25a108aa4fe5$var$useDropdownMenuContext($e7bd25a108aa4fe5$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$b688253958b8dfe7, {
        asChild: true,
        ...menuScope,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).button, {
            type: "button",
            id: context.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": context.open ? context.contentId : void 0,
            "data-state": context.open ? "open" : "closed",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            ...triggerProps,
            ref: (0, $1d2c417c81554c6a$export$43e446d32b3d21af)(forwardedRef, context.triggerRef),
            onPointerDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) {
                    context.onOpenToggle();
                    if (!context.open) event.preventDefault();
                }
            }),
            onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (disabled) return;
                if ([
                    "Enter",
                    " "
                ].includes(event.key)) context.onOpenToggle();
                if (event.key === "ArrowDown") context.onOpenChange(true);
                if ([
                    "Enter",
                    " ",
                    "ArrowDown"
                ].includes(event.key)) event.preventDefault();
            })
        })
    });
});
$e7bd25a108aa4fe5$export$d2469213b3befba9.displayName = $e7bd25a108aa4fe5$var$TRIGGER_NAME;
var $e7bd25a108aa4fe5$var$PORTAL_NAME = "DropdownMenuPortal";
var $e7bd25a108aa4fe5$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$602eac185826482c, {
        ...menuScope,
        ...portalProps
    });
};
$e7bd25a108aa4fe5$export$cd369b4d4d54efc9.displayName = $e7bd25a108aa4fe5$var$PORTAL_NAME;
var $e7bd25a108aa4fe5$var$CONTENT_NAME = "DropdownMenuContent";
var $e7bd25a108aa4fe5$export$6e76d93a37c01248 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...contentProps } = props;
    const context = $e7bd25a108aa4fe5$var$useDropdownMenuContext($e7bd25a108aa4fe5$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = $7PdBe.useRef(false);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$7c6e2c02157bb7d2, {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
            hasInteractedOutsideRef.current = false;
            event.preventDefault();
        }),
        onInteractOutside: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$e7bd25a108aa4fe5$export$6e76d93a37c01248.displayName = $e7bd25a108aa4fe5$var$CONTENT_NAME;
var $e7bd25a108aa4fe5$var$GROUP_NAME = "DropdownMenuGroup";
var $e7bd25a108aa4fe5$export$246bebaba3a2f70e = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$eb2fcfdbd7ba97d4, {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$246bebaba3a2f70e.displayName = $e7bd25a108aa4fe5$var$GROUP_NAME;
var $e7bd25a108aa4fe5$var$LABEL_NAME = "DropdownMenuLabel";
var $e7bd25a108aa4fe5$export$76e48c5b57f24495 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$b04be29aa201d4f5, {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$76e48c5b57f24495.displayName = $e7bd25a108aa4fe5$var$LABEL_NAME;
var $e7bd25a108aa4fe5$var$ITEM_NAME = "DropdownMenuItem";
var $e7bd25a108aa4fe5$export$ed97964d1871885d = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$6d08773d2e66f8f2, {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$ed97964d1871885d.displayName = $e7bd25a108aa4fe5$var$ITEM_NAME;
var $e7bd25a108aa4fe5$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
var $e7bd25a108aa4fe5$export$53a69729da201fa9 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$16ce288f89fa631c, {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$53a69729da201fa9.displayName = $e7bd25a108aa4fe5$var$CHECKBOX_ITEM_NAME;
var $e7bd25a108aa4fe5$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
var $e7bd25a108aa4fe5$export$3323ad73d55f587e = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$a98f0dcb43a68a25, {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$3323ad73d55f587e.displayName = $e7bd25a108aa4fe5$var$RADIO_GROUP_NAME;
var $e7bd25a108aa4fe5$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
var $e7bd25a108aa4fe5$export$e4f69b41b1637536 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$371ab307eab489c0, {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$e4f69b41b1637536.displayName = $e7bd25a108aa4fe5$var$RADIO_ITEM_NAME;
var $e7bd25a108aa4fe5$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
var $e7bd25a108aa4fe5$export$42355ae145153fb6 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$c3468e2714d175fa, {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$42355ae145153fb6.displayName = $e7bd25a108aa4fe5$var$INDICATOR_NAME;
var $e7bd25a108aa4fe5$var$SEPARATOR_NAME = "DropdownMenuSeparator";
var $e7bd25a108aa4fe5$export$da160178fd3bc7e9 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$1ff3c3f08ae963c0, {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$da160178fd3bc7e9.displayName = $e7bd25a108aa4fe5$var$SEPARATOR_NAME;
var $e7bd25a108aa4fe5$var$ARROW_NAME = "DropdownMenuArrow";
var $e7bd25a108aa4fe5$export$34b8980744021ec5 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$21b07c8f274aebd5, {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$34b8980744021ec5.displayName = $e7bd25a108aa4fe5$var$ARROW_NAME;
var $e7bd25a108aa4fe5$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, open: openProp, onOpenChange: onOpenChange, defaultOpen: defaultOpen } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    const [open, setOpen] = (0, $892645e7859416d3$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: "DropdownMenuSub"
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$d7a01e11500dfb6f, {
        ...menuScope,
        open: open,
        onOpenChange: setOpen,
        children: children
    });
};
var $e7bd25a108aa4fe5$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
var $e7bd25a108aa4fe5$export$21dcb7ec56f874cf = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$2ea8a7a591ac5eac, {
        ...menuScope,
        ...subTriggerProps,
        ref: forwardedRef
    });
});
$e7bd25a108aa4fe5$export$21dcb7ec56f874cf.displayName = $e7bd25a108aa4fe5$var$SUB_TRIGGER_NAME;
var $e7bd25a108aa4fe5$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
var $e7bd25a108aa4fe5$export$f34ec8bc2482cc5f = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = $e7bd25a108aa4fe5$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $hvk62.jsx)($bf0e7c6991755a6d$export$6d4de93b380beddf, {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$e7bd25a108aa4fe5$export$f34ec8bc2482cc5f.displayName = $e7bd25a108aa4fe5$var$SUB_CONTENT_NAME;
var $e7bd25a108aa4fe5$export$be92b6f5f03c0fe9 = $e7bd25a108aa4fe5$export$e44a253a59704894;
var $e7bd25a108aa4fe5$export$41fb9f06171c75f4 = $e7bd25a108aa4fe5$export$d2469213b3befba9;
var $e7bd25a108aa4fe5$export$602eac185826482c = $e7bd25a108aa4fe5$export$cd369b4d4d54efc9;
var $e7bd25a108aa4fe5$export$7c6e2c02157bb7d2 = $e7bd25a108aa4fe5$export$6e76d93a37c01248;
var $e7bd25a108aa4fe5$export$eb2fcfdbd7ba97d4 = $e7bd25a108aa4fe5$export$246bebaba3a2f70e;
var $e7bd25a108aa4fe5$export$b04be29aa201d4f5 = $e7bd25a108aa4fe5$export$76e48c5b57f24495;
var $e7bd25a108aa4fe5$export$6d08773d2e66f8f2 = $e7bd25a108aa4fe5$export$ed97964d1871885d;
var $e7bd25a108aa4fe5$export$16ce288f89fa631c = $e7bd25a108aa4fe5$export$53a69729da201fa9;
var $e7bd25a108aa4fe5$export$a98f0dcb43a68a25 = $e7bd25a108aa4fe5$export$3323ad73d55f587e;
var $e7bd25a108aa4fe5$export$371ab307eab489c0 = $e7bd25a108aa4fe5$export$e4f69b41b1637536;
var $e7bd25a108aa4fe5$export$c3468e2714d175fa = $e7bd25a108aa4fe5$export$42355ae145153fb6;
var $e7bd25a108aa4fe5$export$1ff3c3f08ae963c0 = $e7bd25a108aa4fe5$export$da160178fd3bc7e9;
var $e7bd25a108aa4fe5$export$21b07c8f274aebd5 = $e7bd25a108aa4fe5$export$34b8980744021ec5;
var $e7bd25a108aa4fe5$export$d7a01e11500dfb6f = $e7bd25a108aa4fe5$export$2f307d81a64f5442;
var $e7bd25a108aa4fe5$export$2ea8a7a591ac5eac = $e7bd25a108aa4fe5$export$21dcb7ec56f874cf;
var $e7bd25a108aa4fe5$export$6d4de93b380beddf = $e7bd25a108aa4fe5$export$f34ec8bc2482cc5f;




var $7PdBe = parcelRequire("7PdBe");




// src/use-is-hydrated.tsx
var $a28a8abe653694a1$exports = {};
"use strict";

$a28a8abe653694a1$exports = (parcelRequire("1SEQ6"));


function $adbcd7c7b5b1417f$export$fd0534379e135f3d() {
    return (0, $a28a8abe653694a1$exports.useSyncExternalStore)($adbcd7c7b5b1417f$var$subscribe, ()=>true, ()=>false);
}
function $adbcd7c7b5b1417f$var$subscribe() {
    return ()=>{};
}



var $hvk62 = parcelRequire("hvk62");
"use client";
var $f8c59fb24ef52765$var$AVATAR_NAME = "Avatar";
var [$f8c59fb24ef52765$var$createAvatarContext, $f8c59fb24ef52765$export$90370d16b488820f] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)($f8c59fb24ef52765$var$AVATAR_NAME);
var [$f8c59fb24ef52765$var$AvatarProvider, $f8c59fb24ef52765$var$useAvatarContext] = $f8c59fb24ef52765$var$createAvatarContext($f8c59fb24ef52765$var$AVATAR_NAME);
var $f8c59fb24ef52765$export$e2255cf6045e8d47 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, ...avatarProps } = props;
    const [imageLoadingStatus, setImageLoadingStatus] = $7PdBe.useState("idle");
    return /* @__PURE__ */ (0, $hvk62.jsx)($f8c59fb24ef52765$var$AvatarProvider, {
        scope: __scopeAvatar,
        imageLoadingStatus: imageLoadingStatus,
        onImageLoadingStatusChange: setImageLoadingStatus,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
            ...avatarProps,
            ref: forwardedRef
        })
    });
});
$f8c59fb24ef52765$export$e2255cf6045e8d47.displayName = $f8c59fb24ef52765$var$AVATAR_NAME;
var $f8c59fb24ef52765$var$IMAGE_NAME = "AvatarImage";
var $f8c59fb24ef52765$export$2cd8ae1985206fe8 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, src: src, onLoadingStatusChange: onLoadingStatusChange = ()=>{}, ...imageProps } = props;
    const context = $f8c59fb24ef52765$var$useAvatarContext($f8c59fb24ef52765$var$IMAGE_NAME, __scopeAvatar);
    const imageLoadingStatus = $f8c59fb24ef52765$var$useImageLoadingStatus(src, imageProps);
    const handleLoadingStatusChange = (0, $c64c66c1264b1e20$export$25bec8c6f54ee79a)((status)=>{
        onLoadingStatusChange(status);
        context.onImageLoadingStatusChange(status);
    });
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        if (imageLoadingStatus !== "idle") handleLoadingStatusChange(imageLoadingStatus);
    }, [
        imageLoadingStatus,
        handleLoadingStatusChange
    ]);
    return imageLoadingStatus === "loaded" ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).img, {
        ...imageProps,
        ref: forwardedRef,
        src: src
    }) : null;
});
$f8c59fb24ef52765$export$2cd8ae1985206fe8.displayName = $f8c59fb24ef52765$var$IMAGE_NAME;
var $f8c59fb24ef52765$var$FALLBACK_NAME = "AvatarFallback";
var $f8c59fb24ef52765$export$69fffb6a9571fbfe = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, delayMs: delayMs, ...fallbackProps } = props;
    const context = $f8c59fb24ef52765$var$useAvatarContext($f8c59fb24ef52765$var$FALLBACK_NAME, __scopeAvatar);
    const [canRender, setCanRender] = $7PdBe.useState(delayMs === void 0);
    $7PdBe.useEffect(()=>{
        if (delayMs !== void 0) {
            const timerId = window.setTimeout(()=>setCanRender(true), delayMs);
            return ()=>window.clearTimeout(timerId);
        }
    }, [
        delayMs
    ]);
    return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
        ...fallbackProps,
        ref: forwardedRef
    }) : null;
});
$f8c59fb24ef52765$export$69fffb6a9571fbfe.displayName = $f8c59fb24ef52765$var$FALLBACK_NAME;
function $f8c59fb24ef52765$var$resolveLoadingStatus(image, src) {
    if (!image) return "idle";
    if (!src) return "error";
    if (image.src !== src) image.src = src;
    return image.complete && image.naturalWidth > 0 ? "loaded" : "loading";
}
function $f8c59fb24ef52765$var$useImageLoadingStatus(src, { referrerPolicy: referrerPolicy, crossOrigin: crossOrigin }) {
    const isHydrated = (0, $adbcd7c7b5b1417f$export$fd0534379e135f3d)();
    const imageRef = $7PdBe.useRef(null);
    const image = (()=>{
        if (!isHydrated) return null;
        if (!imageRef.current) imageRef.current = new window.Image();
        return imageRef.current;
    })();
    const [loadingStatus, setLoadingStatus] = $7PdBe.useState(()=>$f8c59fb24ef52765$var$resolveLoadingStatus(image, src));
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        setLoadingStatus($f8c59fb24ef52765$var$resolveLoadingStatus(image, src));
    }, [
        image,
        src
    ]);
    (0, $b50e35dc615f2236$export$e5c5a5f917a5871c)(()=>{
        const updateStatus = (status)=>()=>{
                setLoadingStatus(status);
            };
        if (!image) return;
        const handleLoad = updateStatus("loaded");
        const handleError = updateStatus("error");
        image.addEventListener("load", handleLoad);
        image.addEventListener("error", handleError);
        if (referrerPolicy) image.referrerPolicy = referrerPolicy;
        if (typeof crossOrigin === "string") image.crossOrigin = crossOrigin;
        return ()=>{
            image.removeEventListener("load", handleLoad);
            image.removeEventListener("error", handleError);
        };
    }, [
        image,
        crossOrigin,
        referrerPolicy
    ]);
    return loadingStatus;
}
var $f8c59fb24ef52765$export$be92b6f5f03c0fe9 = $f8c59fb24ef52765$export$e2255cf6045e8d47;
var $f8c59fb24ef52765$export$3e431a229df88919 = $f8c59fb24ef52765$export$2cd8ae1985206fe8;
var $f8c59fb24ef52765$export$fb8d7f40caaeea67 = $f8c59fb24ef52765$export$69fffb6a9571fbfe;


/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://www.rfc-editor.org/rfc/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ /**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ /**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ /** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $9b412c1c8dc7e8e4$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $9b412c1c8dc7e8e4$export$75364c6cb16d43b6(n, title = "") {
    if (!Number.isSafeInteger(n) || n < 0) {
        const prefix = title && `"${title}" `;
        throw new Error(`${prefix}expected integer >= 0, got ${n}`);
    }
}
function $9b412c1c8dc7e8e4$export$e8a750b9efad93f5(value, length, title = "") {
    const bytes = $9b412c1c8dc7e8e4$export$c6fabfbfd097fc30(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || needsLen && len !== length) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : "";
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + "expected Uint8Array" + ofLen + ", got " + got);
    }
    return value;
}
function $9b412c1c8dc7e8e4$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash must wrapped by utils.createHasher");
    $9b412c1c8dc7e8e4$export$75364c6cb16d43b6(h.outputLen);
    $9b412c1c8dc7e8e4$export$75364c6cb16d43b6(h.blockLen);
}
function $9b412c1c8dc7e8e4$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $9b412c1c8dc7e8e4$export$e8e53abee12b995e(out, instance) {
    $9b412c1c8dc7e8e4$export$e8a750b9efad93f5(out, undefined, "digestInto() output");
    const min = instance.outputLen;
    if (out.length < min) throw new Error('"digestInto() output" expected to be of length >=' + min);
}
function $9b412c1c8dc7e8e4$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $9b412c1c8dc7e8e4$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $9b412c1c8dc7e8e4$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $9b412c1c8dc7e8e4$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $9b412c1c8dc7e8e4$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $9b412c1c8dc7e8e4$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $9b412c1c8dc7e8e4$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $9b412c1c8dc7e8e4$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $9b412c1c8dc7e8e4$export$e108944b32ae0e38 = $9b412c1c8dc7e8e4$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$9b412c1c8dc7e8e4$export$a4170f7f8be47425(n);
function $9b412c1c8dc7e8e4$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $9b412c1c8dc7e8e4$export$a4170f7f8be47425(arr[i]);
    return arr;
}
const $9b412c1c8dc7e8e4$export$f3e5ccb1e5f96d20 = $9b412c1c8dc7e8e4$export$a0f88e38d4cf9577 ? (u)=>u : $9b412c1c8dc7e8e4$export$97b40fc37f25d711;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $9b412c1c8dc7e8e4$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === "function" && typeof Uint8Array.fromHex === "function")();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $9b412c1c8dc7e8e4$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $9b412c1c8dc7e8e4$export$58b867e287a802c8(bytes) {
    $9b412c1c8dc7e8e4$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($9b412c1c8dc7e8e4$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $9b412c1c8dc7e8e4$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $9b412c1c8dc7e8e4$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $9b412c1c8dc7e8e4$var$asciiToBase16(ch) {
    if (ch >= $9b412c1c8dc7e8e4$var$asciis._0 && ch <= $9b412c1c8dc7e8e4$var$asciis._9) return ch - $9b412c1c8dc7e8e4$var$asciis._0; // '2' => 50-48
    if (ch >= $9b412c1c8dc7e8e4$var$asciis.A && ch <= $9b412c1c8dc7e8e4$var$asciis.F) return ch - ($9b412c1c8dc7e8e4$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $9b412c1c8dc7e8e4$var$asciis.a && ch <= $9b412c1c8dc7e8e4$var$asciis.f) return ch - ($9b412c1c8dc7e8e4$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $9b412c1c8dc7e8e4$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // @ts-ignore
    if ($9b412c1c8dc7e8e4$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $9b412c1c8dc7e8e4$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $9b412c1c8dc7e8e4$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $9b412c1c8dc7e8e4$export$bdd553fddd433dcb = async ()=>{};
async function $9b412c1c8dc7e8e4$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $9b412c1c8dc7e8e4$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $9b412c1c8dc7e8e4$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $9b412c1c8dc7e8e4$export$e01ba4a527b8942d(data, errorTitle = "") {
    if (typeof data === "string") return $9b412c1c8dc7e8e4$export$3df70a15530b5e81(data);
    return $9b412c1c8dc7e8e4$export$e8a750b9efad93f5(data, undefined, errorTitle);
}
function $9b412c1c8dc7e8e4$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $9b412c1c8dc7e8e4$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $9b412c1c8dc7e8e4$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("options must be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $9b412c1c8dc7e8e4$export$14b114effbc08b6b(hashCons, info = {}) {
    const hashC = (msg, opts)=>hashCons(opts).update(msg).digest();
    const tmp = hashCons(undefined);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    Object.assign(hashC, info);
    return Object.freeze(hashC);
}
function $9b412c1c8dc7e8e4$export$5f828d93ff035aa8(bytesLength = 32) {
    const cr = typeof globalThis === "object" ? globalThis.crypto : null;
    if (typeof cr?.getRandomValues !== "function") throw new Error("crypto.getRandomValues must be defined");
    return cr.getRandomValues(new Uint8Array(bytesLength));
}
const $9b412c1c8dc7e8e4$export$6befe166550a2fc1 = (suffix)=>({
        oid: Uint8Array.from([
            0x06,
            0x09,
            0x60,
            0x86,
            0x48,
            0x01,
            0x65,
            0x03,
            0x04,
            0x02,
            suffix
        ])
    });


function $02b5fb1a6a7325ce$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $02b5fb1a6a7325ce$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $02b5fb1a6a7325ce$export$f9f830659f932cb2 {
    blockLen;
    outputLen;
    padOffset;
    isLE;
    // For partial updates less than block size
    buffer;
    view;
    finished = false;
    length = 0;
    pos = 0;
    destroyed = false;
    constructor(blockLen, outputLen, padOffset, isLE){
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $9b412c1c8dc7e8e4$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $9b412c1c8dc7e8e4$export$20871f6b1d047d77)(this);
        (0, $9b412c1c8dc7e8e4$export$e8a750b9efad93f5)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $9b412c1c8dc7e8e4$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $9b412c1c8dc7e8e4$export$20871f6b1d047d77)(this);
        (0, $9b412c1c8dc7e8e4$export$e8e53abee12b995e)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $9b412c1c8dc7e8e4$export$cf0b2a6c63f9e656)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        view.setBigUint64(blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $9b412c1c8dc7e8e4$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which must be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen must be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to ||= new this.constructor();
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
const $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $02b5fb1a6a7325ce$export$104dc246f4c65f21 = /* @__PURE__ */ Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
const $02b5fb1a6a7325ce$export$b5217b4b948279ee = /* @__PURE__ */ Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
const $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);


/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $3ea3e9d099e1e5e1$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $3ea3e9d099e1e5e1$var$_32n = /* @__PURE__ */ BigInt(32);
function $3ea3e9d099e1e5e1$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $3ea3e9d099e1e5e1$var$U32_MASK64),
        l: Number(n >> $3ea3e9d099e1e5e1$var$_32n & $3ea3e9d099e1e5e1$var$U32_MASK64)
    };
    return {
        h: Number(n >> $3ea3e9d099e1e5e1$var$_32n & $3ea3e9d099e1e5e1$var$U32_MASK64) | 0,
        l: Number(n & $3ea3e9d099e1e5e1$var$U32_MASK64) | 0
    };
}
function $3ea3e9d099e1e5e1$export$65980d18b75784e2(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $3ea3e9d099e1e5e1$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $3ea3e9d099e1e5e1$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $3ea3e9d099e1e5e1$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $3ea3e9d099e1e5e1$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $3ea3e9d099e1e5e1$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $3ea3e9d099e1e5e1$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $3ea3e9d099e1e5e1$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $3ea3e9d099e1e5e1$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $3ea3e9d099e1e5e1$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $3ea3e9d099e1e5e1$export$a088d44bd387d2a3 = (_h, l)=>l;
const $3ea3e9d099e1e5e1$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $3ea3e9d099e1e5e1$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $3ea3e9d099e1e5e1$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $3ea3e9d099e1e5e1$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $3ea3e9d099e1e5e1$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $3ea3e9d099e1e5e1$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $3ea3e9d099e1e5e1$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $3ea3e9d099e1e5e1$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $3ea3e9d099e1e5e1$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $3ea3e9d099e1e5e1$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $3ea3e9d099e1e5e1$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $3ea3e9d099e1e5e1$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $3ea3e9d099e1e5e1$var$u64 = {
    fromBig: $3ea3e9d099e1e5e1$export$9625d4333cb56c3f,
    split: $3ea3e9d099e1e5e1$export$65980d18b75784e2,
    toBig: $3ea3e9d099e1e5e1$export$30f78adcaaa2eb7,
    shrSH: $3ea3e9d099e1e5e1$export$75aa78dc5bd52853,
    shrSL: $3ea3e9d099e1e5e1$export$a0225ff0aee14e25,
    rotrSH: $3ea3e9d099e1e5e1$export$97f812dfd830ca87,
    rotrSL: $3ea3e9d099e1e5e1$export$60987e30e2c9d9d,
    rotrBH: $3ea3e9d099e1e5e1$export$af9c7fbac44dcb76,
    rotrBL: $3ea3e9d099e1e5e1$export$f619171d6d5ac414,
    rotr32H: $3ea3e9d099e1e5e1$export$a088d44bd387d2a3,
    rotr32L: $3ea3e9d099e1e5e1$export$8415aae4d1f69577,
    rotlSH: $3ea3e9d099e1e5e1$export$4b80a2917447870e,
    rotlSL: $3ea3e9d099e1e5e1$export$20652918a7b63b3,
    rotlBH: $3ea3e9d099e1e5e1$export$a52f14bf902f9977,
    rotlBL: $3ea3e9d099e1e5e1$export$5d12cc1da441323f,
    add: $3ea3e9d099e1e5e1$export$e16d8520af44a096,
    add3L: $3ea3e9d099e1e5e1$export$c0c22b91f08911f,
    add3H: $3ea3e9d099e1e5e1$export$ef7b26044977a8ec,
    add4L: $3ea3e9d099e1e5e1$export$2f4e199c560f545d,
    add4H: $3ea3e9d099e1e5e1$export$e909220d675a7741,
    add5H: $3ea3e9d099e1e5e1$export$b45ee8d78c965098,
    add5L: $3ea3e9d099e1e5e1$export$d732b061fe9c9ae4
};
var $3ea3e9d099e1e5e1$export$2e2bcd8739ae039 = $3ea3e9d099e1e5e1$var$u64;



/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $858c77bb5141d899$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $858c77bb5141d899$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
/** Internal 32-byte base SHA2 hash class. */ class $858c77bb5141d899$var$SHA2_32B extends (0, $02b5fb1a6a7325ce$export$f9f830659f932cb2) {
    constructor(outputLen){
        super(64, outputLen, 8, false);
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$858c77bb5141d899$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $858c77bb5141d899$var$SHA256_W[i - 15];
            const W2 = $858c77bb5141d899$var$SHA256_W[i - 2];
            const s0 = (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(W15, 7) ^ (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(W2, 17) ^ (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $858c77bb5141d899$var$SHA256_W[i] = s1 + $858c77bb5141d899$var$SHA256_W[i - 7] + s0 + $858c77bb5141d899$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(E, 6) ^ (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(E, 11) ^ (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + (0, $02b5fb1a6a7325ce$export$d0d97f016526eaf0)(E, F, G) + $858c77bb5141d899$var$SHA256_K[i] + $858c77bb5141d899$var$SHA256_W[i] | 0;
            const sigma0 = (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(A, 2) ^ (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(A, 13) ^ (0, $9b412c1c8dc7e8e4$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + (0, $02b5fb1a6a7325ce$export$8b1d810b1bd30adf)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $9b412c1c8dc7e8e4$export$cf0b2a6c63f9e656)($858c77bb5141d899$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $9b412c1c8dc7e8e4$export$cf0b2a6c63f9e656)(this.buffer);
    }
}
class $858c77bb5141d899$export$978b14127c36190d extends $858c77bb5141d899$var$SHA2_32B {
    // We cannot use array here since array allows indexing by variable
    // which means optimizer/compiler cannot use registers.
    A = (0, $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8)[0] | 0;
    B = (0, $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8)[1] | 0;
    C = (0, $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8)[2] | 0;
    D = (0, $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8)[3] | 0;
    E = (0, $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8)[4] | 0;
    F = (0, $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8)[5] | 0;
    G = (0, $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8)[6] | 0;
    H = (0, $02b5fb1a6a7325ce$export$a986fdf7a5bdfdf8)[7] | 0;
    constructor(){
        super(32);
    }
}
class $858c77bb5141d899$export$bb11dd29d05650f6 extends $858c77bb5141d899$var$SHA2_32B {
    A = (0, $02b5fb1a6a7325ce$export$104dc246f4c65f21)[0] | 0;
    B = (0, $02b5fb1a6a7325ce$export$104dc246f4c65f21)[1] | 0;
    C = (0, $02b5fb1a6a7325ce$export$104dc246f4c65f21)[2] | 0;
    D = (0, $02b5fb1a6a7325ce$export$104dc246f4c65f21)[3] | 0;
    E = (0, $02b5fb1a6a7325ce$export$104dc246f4c65f21)[4] | 0;
    F = (0, $02b5fb1a6a7325ce$export$104dc246f4c65f21)[5] | 0;
    G = (0, $02b5fb1a6a7325ce$export$104dc246f4c65f21)[6] | 0;
    H = (0, $02b5fb1a6a7325ce$export$104dc246f4c65f21)[7] | 0;
    constructor(){
        super(28);
    }
}
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $858c77bb5141d899$var$K512 = /* @__PURE__ */ (()=>$3ea3e9d099e1e5e1$export$65980d18b75784e2([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
const $858c77bb5141d899$var$SHA512_Kh = /* @__PURE__ */ (()=>$858c77bb5141d899$var$K512[0])();
const $858c77bb5141d899$var$SHA512_Kl = /* @__PURE__ */ (()=>$858c77bb5141d899$var$K512[1])();
// Reusable temporary buffers
const $858c77bb5141d899$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $858c77bb5141d899$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
/** Internal 64-byte base SHA2 hash class. */ class $858c77bb5141d899$var$SHA2_64B extends (0, $02b5fb1a6a7325ce$export$f9f830659f932cb2) {
    constructor(outputLen){
        super(128, outputLen, 16, false);
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $858c77bb5141d899$var$SHA512_W_H[i] = view.getUint32(offset);
            $858c77bb5141d899$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $858c77bb5141d899$var$SHA512_W_H[i - 15] | 0;
            const W15l = $858c77bb5141d899$var$SHA512_W_L[i - 15] | 0;
            const s0h = $3ea3e9d099e1e5e1$export$97f812dfd830ca87(W15h, W15l, 1) ^ $3ea3e9d099e1e5e1$export$97f812dfd830ca87(W15h, W15l, 8) ^ $3ea3e9d099e1e5e1$export$75aa78dc5bd52853(W15h, W15l, 7);
            const s0l = $3ea3e9d099e1e5e1$export$60987e30e2c9d9d(W15h, W15l, 1) ^ $3ea3e9d099e1e5e1$export$60987e30e2c9d9d(W15h, W15l, 8) ^ $3ea3e9d099e1e5e1$export$a0225ff0aee14e25(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $858c77bb5141d899$var$SHA512_W_H[i - 2] | 0;
            const W2l = $858c77bb5141d899$var$SHA512_W_L[i - 2] | 0;
            const s1h = $3ea3e9d099e1e5e1$export$97f812dfd830ca87(W2h, W2l, 19) ^ $3ea3e9d099e1e5e1$export$af9c7fbac44dcb76(W2h, W2l, 61) ^ $3ea3e9d099e1e5e1$export$75aa78dc5bd52853(W2h, W2l, 6);
            const s1l = $3ea3e9d099e1e5e1$export$60987e30e2c9d9d(W2h, W2l, 19) ^ $3ea3e9d099e1e5e1$export$f619171d6d5ac414(W2h, W2l, 61) ^ $3ea3e9d099e1e5e1$export$a0225ff0aee14e25(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $3ea3e9d099e1e5e1$export$2f4e199c560f545d(s0l, s1l, $858c77bb5141d899$var$SHA512_W_L[i - 7], $858c77bb5141d899$var$SHA512_W_L[i - 16]);
            const SUMh = $3ea3e9d099e1e5e1$export$e909220d675a7741(SUMl, s0h, s1h, $858c77bb5141d899$var$SHA512_W_H[i - 7], $858c77bb5141d899$var$SHA512_W_H[i - 16]);
            $858c77bb5141d899$var$SHA512_W_H[i] = SUMh | 0;
            $858c77bb5141d899$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $3ea3e9d099e1e5e1$export$97f812dfd830ca87(Eh, El, 14) ^ $3ea3e9d099e1e5e1$export$97f812dfd830ca87(Eh, El, 18) ^ $3ea3e9d099e1e5e1$export$af9c7fbac44dcb76(Eh, El, 41);
            const sigma1l = $3ea3e9d099e1e5e1$export$60987e30e2c9d9d(Eh, El, 14) ^ $3ea3e9d099e1e5e1$export$60987e30e2c9d9d(Eh, El, 18) ^ $3ea3e9d099e1e5e1$export$f619171d6d5ac414(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $3ea3e9d099e1e5e1$export$d732b061fe9c9ae4(Hl, sigma1l, CHIl, $858c77bb5141d899$var$SHA512_Kl[i], $858c77bb5141d899$var$SHA512_W_L[i]);
            const T1h = $3ea3e9d099e1e5e1$export$b45ee8d78c965098(T1ll, Hh, sigma1h, CHIh, $858c77bb5141d899$var$SHA512_Kh[i], $858c77bb5141d899$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $3ea3e9d099e1e5e1$export$97f812dfd830ca87(Ah, Al, 28) ^ $3ea3e9d099e1e5e1$export$af9c7fbac44dcb76(Ah, Al, 34) ^ $3ea3e9d099e1e5e1$export$af9c7fbac44dcb76(Ah, Al, 39);
            const sigma0l = $3ea3e9d099e1e5e1$export$60987e30e2c9d9d(Ah, Al, 28) ^ $3ea3e9d099e1e5e1$export$f619171d6d5ac414(Ah, Al, 34) ^ $3ea3e9d099e1e5e1$export$f619171d6d5ac414(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $3ea3e9d099e1e5e1$export$c0c22b91f08911f(T1l, sigma0l, MAJl);
            Ah = $3ea3e9d099e1e5e1$export$ef7b26044977a8ec(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $3ea3e9d099e1e5e1$export$e16d8520af44a096(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $9b412c1c8dc7e8e4$export$cf0b2a6c63f9e656)($858c77bb5141d899$var$SHA512_W_H, $858c77bb5141d899$var$SHA512_W_L);
    }
    destroy() {
        (0, $9b412c1c8dc7e8e4$export$cf0b2a6c63f9e656)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $858c77bb5141d899$export$f1b13c91499a6586 extends $858c77bb5141d899$var$SHA2_64B {
    Ah = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[0] | 0;
    Al = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[1] | 0;
    Bh = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[2] | 0;
    Bl = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[3] | 0;
    Ch = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[4] | 0;
    Cl = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[5] | 0;
    Dh = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[6] | 0;
    Dl = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[7] | 0;
    Eh = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[8] | 0;
    El = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[9] | 0;
    Fh = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[10] | 0;
    Fl = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[11] | 0;
    Gh = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[12] | 0;
    Gl = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[13] | 0;
    Hh = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[14] | 0;
    Hl = (0, $02b5fb1a6a7325ce$export$f2cbb88a1784d2d1)[15] | 0;
    constructor(){
        super(64);
    }
}
class $858c77bb5141d899$export$f4ad3bd28f228957 extends $858c77bb5141d899$var$SHA2_64B {
    Ah = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[0] | 0;
    Al = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[1] | 0;
    Bh = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[2] | 0;
    Bl = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[3] | 0;
    Ch = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[4] | 0;
    Cl = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[5] | 0;
    Dh = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[6] | 0;
    Dl = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[7] | 0;
    Eh = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[8] | 0;
    El = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[9] | 0;
    Fh = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[10] | 0;
    Fl = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[11] | 0;
    Gh = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[12] | 0;
    Gl = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[13] | 0;
    Hh = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[14] | 0;
    Hl = (0, $02b5fb1a6a7325ce$export$b5217b4b948279ee)[15] | 0;
    constructor(){
        super(48);
    }
}
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $858c77bb5141d899$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $858c77bb5141d899$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $858c77bb5141d899$export$224cfee675191366 extends $858c77bb5141d899$var$SHA2_64B {
    Ah = $858c77bb5141d899$var$T224_IV[0] | 0;
    Al = $858c77bb5141d899$var$T224_IV[1] | 0;
    Bh = $858c77bb5141d899$var$T224_IV[2] | 0;
    Bl = $858c77bb5141d899$var$T224_IV[3] | 0;
    Ch = $858c77bb5141d899$var$T224_IV[4] | 0;
    Cl = $858c77bb5141d899$var$T224_IV[5] | 0;
    Dh = $858c77bb5141d899$var$T224_IV[6] | 0;
    Dl = $858c77bb5141d899$var$T224_IV[7] | 0;
    Eh = $858c77bb5141d899$var$T224_IV[8] | 0;
    El = $858c77bb5141d899$var$T224_IV[9] | 0;
    Fh = $858c77bb5141d899$var$T224_IV[10] | 0;
    Fl = $858c77bb5141d899$var$T224_IV[11] | 0;
    Gh = $858c77bb5141d899$var$T224_IV[12] | 0;
    Gl = $858c77bb5141d899$var$T224_IV[13] | 0;
    Hh = $858c77bb5141d899$var$T224_IV[14] | 0;
    Hl = $858c77bb5141d899$var$T224_IV[15] | 0;
    constructor(){
        super(28);
    }
}
class $858c77bb5141d899$export$9705f0e3a7ee4586 extends $858c77bb5141d899$var$SHA2_64B {
    Ah = $858c77bb5141d899$var$T256_IV[0] | 0;
    Al = $858c77bb5141d899$var$T256_IV[1] | 0;
    Bh = $858c77bb5141d899$var$T256_IV[2] | 0;
    Bl = $858c77bb5141d899$var$T256_IV[3] | 0;
    Ch = $858c77bb5141d899$var$T256_IV[4] | 0;
    Cl = $858c77bb5141d899$var$T256_IV[5] | 0;
    Dh = $858c77bb5141d899$var$T256_IV[6] | 0;
    Dl = $858c77bb5141d899$var$T256_IV[7] | 0;
    Eh = $858c77bb5141d899$var$T256_IV[8] | 0;
    El = $858c77bb5141d899$var$T256_IV[9] | 0;
    Fh = $858c77bb5141d899$var$T256_IV[10] | 0;
    Fl = $858c77bb5141d899$var$T256_IV[11] | 0;
    Gh = $858c77bb5141d899$var$T256_IV[12] | 0;
    Gl = $858c77bb5141d899$var$T256_IV[13] | 0;
    Hh = $858c77bb5141d899$var$T256_IV[14] | 0;
    Hl = $858c77bb5141d899$var$T256_IV[15] | 0;
    constructor(){
        super(32);
    }
}
const $858c77bb5141d899$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$14b114effbc08b6b)(()=>new $858c77bb5141d899$export$978b14127c36190d(), /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$6befe166550a2fc1)(0x01));
const $858c77bb5141d899$export$97b70509d4e397ea = /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$14b114effbc08b6b)(()=>new $858c77bb5141d899$export$bb11dd29d05650f6(), /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$6befe166550a2fc1)(0x04));
const $858c77bb5141d899$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$14b114effbc08b6b)(()=>new $858c77bb5141d899$export$f1b13c91499a6586(), /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$6befe166550a2fc1)(0x03));
const $858c77bb5141d899$export$612d47d55dedde45 = /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$14b114effbc08b6b)(()=>new $858c77bb5141d899$export$f4ad3bd28f228957(), /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$6befe166550a2fc1)(0x02));
const $858c77bb5141d899$export$c78786b6da86db2a = /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$14b114effbc08b6b)(()=>new $858c77bb5141d899$export$9705f0e3a7ee4586(), /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$6befe166550a2fc1)(0x06));
const $858c77bb5141d899$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$14b114effbc08b6b)(()=>new $858c77bb5141d899$export$224cfee675191366(), /* @__PURE__ */ (0, $9b412c1c8dc7e8e4$export$6befe166550a2fc1)(0x05));




var $7PdBe = parcelRequire("7PdBe");









var $hvk62 = parcelRequire("hvk62");
"use client";
var $5b5eb1673d93610f$var$CHECKBOX_NAME = "Checkbox";
var [$5b5eb1673d93610f$var$createCheckboxContext, $5b5eb1673d93610f$export$b566c4ff5488ea01] = (0, $2b55cbfabf840987$export$50c7b4e9d9f19c1)($5b5eb1673d93610f$var$CHECKBOX_NAME);
var [$5b5eb1673d93610f$var$CheckboxProviderImpl, $5b5eb1673d93610f$var$useCheckboxContext] = $5b5eb1673d93610f$var$createCheckboxContext($5b5eb1673d93610f$var$CHECKBOX_NAME);
function $5b5eb1673d93610f$export$1335a92a9ee50a8d(props) {
    const { __scopeCheckbox: __scopeCheckbox, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $892645e7859416d3$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $5b5eb1673d93610f$var$CHECKBOX_NAME
    });
    const [control, setControl] = $7PdBe.useState(null);
    const [bubbleInput, setBubbleInput] = $7PdBe.useState(null);
    const hasConsumerStoppedPropagationRef = $7PdBe.useRef(false);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        disabled: disabled,
        setChecked: setChecked,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef,
        required: required,
        defaultChecked: $5b5eb1673d93610f$var$isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($5b5eb1673d93610f$var$CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: $5b5eb1673d93610f$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
var $5b5eb1673d93610f$var$TRIGGER_NAME = "CheckboxTrigger";
var $5b5eb1673d93610f$export$1386466acbe59ca2 = $7PdBe.forwardRef(({ __scopeCheckbox: __scopeCheckbox, onKeyDown: onKeyDown, onClick: onClick, ...checkboxProps }, forwardedRef)=>{
    const { control: control, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, isFormControl: isFormControl, bubbleInput: bubbleInput } = $5b5eb1673d93610f$var$useCheckboxContext($5b5eb1673d93610f$var$TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, setControl);
    const initialCheckedStateRef = $7PdBe.useRef(checked);
    $7PdBe.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": $5b5eb1673d93610f$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $5b5eb1673d93610f$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $21cf51b9379dc6b2$export$b9ecd428b558ff10)(onClick, (event)=>{
            setChecked((prevChecked)=>$5b5eb1673d93610f$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
});
$5b5eb1673d93610f$export$1386466acbe59ca2.displayName = $5b5eb1673d93610f$var$TRIGGER_NAME;
var $5b5eb1673d93610f$export$48513f6b9f8ce62d = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, $hvk62.jsx)($5b5eb1673d93610f$export$1335a92a9ee50a8d, {
        __scopeCheckbox: __scopeCheckbox,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($5b5eb1673d93610f$export$1386466acbe59ca2, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox: __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, $hvk62.jsx)($5b5eb1673d93610f$export$493083511fc9f964, {
                        __scopeCheckbox: __scopeCheckbox
                    })
                ]
            })
    });
});
$5b5eb1673d93610f$export$48513f6b9f8ce62d.displayName = $5b5eb1673d93610f$var$CHECKBOX_NAME;
var $5b5eb1673d93610f$var$INDICATOR_NAME = "CheckboxIndicator";
var $5b5eb1673d93610f$export$59aad738f51d1c05 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $5b5eb1673d93610f$var$useCheckboxContext($5b5eb1673d93610f$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $7c269d36919d4419$export$99c2b779aa4e8b8b), {
        present: forceMount || $5b5eb1673d93610f$var$isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).span, {
            "data-state": $5b5eb1673d93610f$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
$5b5eb1673d93610f$export$59aad738f51d1c05.displayName = $5b5eb1673d93610f$var$INDICATOR_NAME;
var $5b5eb1673d93610f$var$BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var $5b5eb1673d93610f$export$493083511fc9f964 = $7PdBe.forwardRef(({ __scopeCheckbox: __scopeCheckbox, ...props }, forwardedRef)=>{
    const { control: control, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $5b5eb1673d93610f$var$useCheckboxContext($5b5eb1673d93610f$var$BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, $1d2c417c81554c6a$export$c7b2cbe3552a0d05)(forwardedRef, setBubbleInput);
    const prevChecked = (0, $3c07d3728496d837$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $424a8748a5f37a7c$export$1ab7ae714698c4b8)(control);
    $7PdBe.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const bubbles = !hasConsumerStoppedPropagationRef.current;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $5b5eb1673d93610f$var$isIndeterminate(checked);
            setChecked.call(input, $5b5eb1673d93610f$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        bubbleInput,
        prevChecked,
        checked,
        hasConsumerStoppedPropagationRef
    ]);
    const defaultCheckedRef = $7PdBe.useRef($5b5eb1673d93610f$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
});
$5b5eb1673d93610f$export$493083511fc9f964.displayName = $5b5eb1673d93610f$var$BUBBLE_INPUT_NAME;
function $5b5eb1673d93610f$var$isFunction(value) {
    return typeof value === "function";
}
function $5b5eb1673d93610f$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $5b5eb1673d93610f$var$getState(checked) {
    return $5b5eb1673d93610f$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}




var $2BzXY = parcelRequire("2BzXY");


var $7PdBe = parcelRequire("7PdBe");
"use client";
function $f60a43aec6935ca4$var$__insertCSS(code) {
    if (!code || typeof document == "undefined") return;
    let head = document.head || document.getElementsByTagName("head")[0];
    let style = document.createElement("style");
    style.type = "text/css";
    head.appendChild(style);
    style.styleSheet ? style.styleSheet.cssText = code : style.appendChild(document.createTextNode(code));
}
const $f60a43aec6935ca4$var$DrawerContext = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createContext({
    drawerRef: {
        current: null
    },
    overlayRef: {
        current: null
    },
    onPress: ()=>{},
    onRelease: ()=>{},
    onDrag: ()=>{},
    onNestedDrag: ()=>{},
    onNestedOpenChange: ()=>{},
    onNestedRelease: ()=>{},
    openProp: undefined,
    dismissible: false,
    isOpen: false,
    isDragging: false,
    keyboardIsOpen: {
        current: false
    },
    snapPointsOffset: null,
    snapPoints: null,
    handleOnly: false,
    modal: false,
    shouldFade: false,
    activeSnapPoint: null,
    onOpenChange: ()=>{},
    setActiveSnapPoint: ()=>{},
    closeDrawer: ()=>{},
    direction: "bottom",
    shouldAnimate: {
        current: true
    },
    shouldScaleBackground: false,
    setBackgroundColorOnScale: true,
    noBodyStyles: false,
    container: null,
    autoFocus: false
});
const $f60a43aec6935ca4$var$useDrawerContext = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useContext($f60a43aec6935ca4$var$DrawerContext);
    if (!context) throw new Error("useDrawerContext must be used within a Drawer.Root");
    return context;
};
$f60a43aec6935ca4$var$__insertCSS("[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(\n[data-state=closed]\n){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}");
function $f60a43aec6935ca4$var$isMobileFirefox() {
    const userAgent = navigator.userAgent;
    return typeof window !== "undefined" && (/Firefox/.test(userAgent) && /Mobile/.test(userAgent) || // Android Firefox
    /FxiOS/.test(userAgent) // iOS Firefox
    );
}
function $f60a43aec6935ca4$var$isMac() {
    return $f60a43aec6935ca4$var$testPlatform(/^Mac/);
}
function $f60a43aec6935ca4$var$isIPhone() {
    return $f60a43aec6935ca4$var$testPlatform(/^iPhone/);
}
function $f60a43aec6935ca4$var$isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function $f60a43aec6935ca4$var$isIPad() {
    return $f60a43aec6935ca4$var$testPlatform(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $f60a43aec6935ca4$var$isMac() && navigator.maxTouchPoints > 1;
}
function $f60a43aec6935ca4$var$isIOS() {
    return $f60a43aec6935ca4$var$isIPhone() || $f60a43aec6935ca4$var$isIPad();
}
function $f60a43aec6935ca4$var$testPlatform(re) {
    return typeof window !== "undefined" && window.navigator != null ? re.test(window.navigator.platform) : undefined;
}
// This code comes from https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/overlays/src/usePreventScroll.ts
const $f60a43aec6935ca4$var$KEYBOARD_BUFFER = 24;
const $f60a43aec6935ca4$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $7PdBe.useLayoutEffect) : (0, $7PdBe.useEffect);
function $f60a43aec6935ca4$var$chain$1(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}
// @ts-ignore
const $f60a43aec6935ca4$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $f60a43aec6935ca4$var$isScrollable(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}
function $f60a43aec6935ca4$var$getScrollParent(node) {
    if ($f60a43aec6935ca4$var$isScrollable(node)) node = node.parentElement;
    while(node && !$f60a43aec6935ca4$var$isScrollable(node))node = node.parentElement;
    return node || document.scrollingElement || document.documentElement;
}
// HTML input types that do not cause the software keyboard to appear.
const $f60a43aec6935ca4$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $f60a43aec6935ca4$var$preventScrollCount = 0;
let $f60a43aec6935ca4$var$restore;
/**
 * Prevents scrolling on the document body on mount, and
 * restores it on unmount. Also ensures that content does not
 * shift due to the scrollbars disappearing.
 */ function $f60a43aec6935ca4$var$usePreventScroll(options = {}) {
    let { isDisabled: isDisabled } = options;
    $f60a43aec6935ca4$var$useIsomorphicLayoutEffect(()=>{
        if (isDisabled) return;
        $f60a43aec6935ca4$var$preventScrollCount++;
        if ($f60a43aec6935ca4$var$preventScrollCount === 1) {
            if ($f60a43aec6935ca4$var$isIOS()) $f60a43aec6935ca4$var$restore = $f60a43aec6935ca4$var$preventScrollMobileSafari();
        }
        return ()=>{
            $f60a43aec6935ca4$var$preventScrollCount--;
            if ($f60a43aec6935ca4$var$preventScrollCount === 0) $f60a43aec6935ca4$var$restore == null || $f60a43aec6935ca4$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $f60a43aec6935ca4$var$preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = $f60a43aec6935ca4$var$getScrollParent(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (bottom === 0) return;
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) e.preventDefault();
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($f60a43aec6935ca4$var$isInput(target) && target !== document.activeElement) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($f60a43aec6935ca4$var$isInput(target)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($f60a43aec6935ca4$var$visualViewport) {
                    if ($f60a43aec6935ca4$var$visualViewport.height < window.innerHeight) // If the keyboard is already visible, do this after one additional frame
                    // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $f60a43aec6935ca4$var$scrollIntoView(target);
                    });
                    else // Otherwise, wait for the visual viewport to resize before scrolling so we can
                    // measure the correct position to scroll to.
                    $f60a43aec6935ca4$var$visualViewport.addEventListener("resize", ()=>$f60a43aec6935ca4$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = $f60a43aec6935ca4$var$chain$1($f60a43aec6935ca4$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = $f60a43aec6935ca4$var$chain$1($f60a43aec6935ca4$var$addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), $f60a43aec6935ca4$var$addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), $f60a43aec6935ca4$var$addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), $f60a43aec6935ca4$var$addEvent(document, "focus", onFocus, true), $f60a43aec6935ca4$var$addEvent(window, "scroll", onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $f60a43aec6935ca4$var$setStyle(element, style, value) {
    // https://github.com/microsoft/TypeScript/issues/17827#issuecomment-391663310
    // @ts-ignore
    let cur = element.style[style];
    // @ts-ignore
    element.style[style] = value;
    return ()=>{
        // @ts-ignore
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $f60a43aec6935ca4$var$addEvent(target, event, handler, options) {
    // @ts-ignore
    target.addEventListener(event, handler, options);
    return ()=>{
        // @ts-ignore
        target.removeEventListener(event, handler, options);
    };
}
function $f60a43aec6935ca4$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = $f60a43aec6935ca4$var$getScrollParent(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            let targetBottom = target.getBoundingClientRect().bottom;
            // Buffer is needed for some edge cases
            const keyboardHeight = scrollable.getBoundingClientRect().bottom + $f60a43aec6935ca4$var$KEYBOARD_BUFFER;
            if (targetBottom > keyboardHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        // @ts-ignore
        target = scrollable.parentElement;
    }
}
function $f60a43aec6935ca4$var$isInput(target) {
    return target instanceof HTMLInputElement && !$f60a43aec6935ca4$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}
// This code comes from https://github.com/radix-ui/primitives/tree/main/packages/react/compose-refs
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $f60a43aec6935ca4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $f60a43aec6935ca4$var$composeRefs(...refs) {
    return (node)=>refs.forEach((ref)=>$f60a43aec6935ca4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $f60a43aec6935ca4$var$useComposedRefs(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return $7PdBe.useCallback($f60a43aec6935ca4$var$composeRefs(...refs), refs);
}
const $f60a43aec6935ca4$var$cache = new WeakMap();
function $f60a43aec6935ca4$var$set(el, styles, ignoreCache = false) {
    if (!el || !(el instanceof HTMLElement)) return;
    let originalStyles = {};
    Object.entries(styles).forEach(([key, value])=>{
        if (key.startsWith("--")) {
            el.style.setProperty(key, value);
            return;
        }
        originalStyles[key] = el.style[key];
        el.style[key] = value;
    });
    if (ignoreCache) return;
    $f60a43aec6935ca4$var$cache.set(el, originalStyles);
}
function $f60a43aec6935ca4$var$reset(el, prop) {
    if (!el || !(el instanceof HTMLElement)) return;
    let originalStyles = $f60a43aec6935ca4$var$cache.get(el);
    if (!originalStyles) return;
    el.style[prop] = originalStyles[prop];
}
const $f60a43aec6935ca4$var$isVertical = (direction)=>{
    switch(direction){
        case "top":
        case "bottom":
            return true;
        case "left":
        case "right":
            return false;
        default:
            return direction;
    }
};
function $f60a43aec6935ca4$var$getTranslate(element, direction) {
    if (!element) return null;
    const style = window.getComputedStyle(element);
    const transform = style.transform || style.webkitTransform || style.mozTransform;
    let mat = transform.match(/^matrix3d\((.+)\)$/);
    if (mat) // https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix3d
    return parseFloat(mat[1].split(", ")[$f60a43aec6935ca4$var$isVertical(direction) ? 13 : 12]);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    mat = transform.match(/^matrix\((.+)\)$/);
    return mat ? parseFloat(mat[1].split(", ")[$f60a43aec6935ca4$var$isVertical(direction) ? 5 : 4]) : null;
}
function $f60a43aec6935ca4$var$dampenValue(v) {
    return 8 * (Math.log(v + 1) - 2);
}
function $f60a43aec6935ca4$var$assignStyle(element, style) {
    if (!element) return ()=>{};
    const prevStyle = element.style.cssText;
    Object.assign(element.style, style);
    return ()=>{
        element.style.cssText = prevStyle;
    };
}
/**
 * Receives functions as arguments and returns a new function that calls all.
 */ function $f60a43aec6935ca4$var$chain(...fns) {
    return (...args)=>{
        for (const fn of fns)if (typeof fn === "function") // @ts-ignore
        fn(...args);
    };
}
const $f60a43aec6935ca4$var$TRANSITIONS = {
    DURATION: 0.5,
    EASE: [
        0.32,
        0.72,
        0,
        1
    ]
};
const $f60a43aec6935ca4$var$VELOCITY_THRESHOLD = 0.4;
const $f60a43aec6935ca4$var$CLOSE_THRESHOLD = 0.25;
const $f60a43aec6935ca4$var$SCROLL_LOCK_TIMEOUT = 100;
const $f60a43aec6935ca4$var$BORDER_RADIUS = 8;
const $f60a43aec6935ca4$var$NESTED_DISPLACEMENT = 16;
const $f60a43aec6935ca4$var$WINDOW_TOP_OFFSET = 26;
const $f60a43aec6935ca4$var$DRAG_CLASS = "vaul-dragging";
// This code comes from https://github.com/radix-ui/primitives/blob/main/packages/react/use-controllable-state/src/useControllableState.tsx
function $f60a43aec6935ca4$var$useCallbackRef(callback) {
    const callbackRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        callbackRef.current = callback;
    });
    // https://github.com/facebook/react/issues/19240
    return (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>(...args)=>callbackRef.current == null ? void 0 : callbackRef.current.call(callbackRef, ...args), []);
}
function $f60a43aec6935ca4$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(value);
    const handleChange = $f60a43aec6935ca4$var$useCallbackRef(onChange);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}
function $f60a43aec6935ca4$var$useControllableState({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $f60a43aec6935ca4$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = $f60a43aec6935ca4$var$useCallbackRef(onChange);
    const setValue = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $f60a43aec6935ca4$var$useSnapPoints({ activeSnapPointProp: activeSnapPointProp, setActiveSnapPointProp: setActiveSnapPointProp, snapPoints: snapPoints, drawerRef: drawerRef, overlayRef: overlayRef, fadeFromIndex: fadeFromIndex, onSnapPointChange: onSnapPointChange, direction: direction = "bottom", container: container, snapToSequentialPoint: snapToSequentialPoint }) {
    const [activeSnapPoint, setActiveSnapPoint] = $f60a43aec6935ca4$var$useControllableState({
        prop: activeSnapPointProp,
        defaultProp: snapPoints == null ? void 0 : snapPoints[0],
        onChange: setActiveSnapPointProp
    });
    const [windowDimensions, setWindowDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(typeof window !== "undefined" ? {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
    } : undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        function onResize() {
            setWindowDimensions({
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight
            });
        }
        window.addEventListener("resize", onResize);
        return ()=>window.removeEventListener("resize", onResize);
    }, []);
    const isLastSnapPoint = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>activeSnapPoint === (snapPoints == null ? void 0 : snapPoints[snapPoints.length - 1]) || null, [
        snapPoints,
        activeSnapPoint
    ]);
    const activeSnapPointIndex = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>{
        var _snapPoints_findIndex;
        return (_snapPoints_findIndex = snapPoints == null ? void 0 : snapPoints.findIndex((snapPoint)=>snapPoint === activeSnapPoint)) != null ? _snapPoints_findIndex : null;
    }, [
        snapPoints,
        activeSnapPoint
    ]);
    const shouldFade = snapPoints && snapPoints.length > 0 && (fadeFromIndex || fadeFromIndex === 0) && !Number.isNaN(fadeFromIndex) && snapPoints[fadeFromIndex] === activeSnapPoint || !snapPoints;
    const snapPointsOffset = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>{
        const containerSize = container ? {
            width: container.getBoundingClientRect().width,
            height: container.getBoundingClientRect().height
        } : typeof window !== "undefined" ? {
            width: window.innerWidth,
            height: window.innerHeight
        } : {
            width: 0,
            height: 0
        };
        var _snapPoints_map;
        return (_snapPoints_map = snapPoints == null ? void 0 : snapPoints.map((snapPoint)=>{
            const isPx = typeof snapPoint === "string";
            let snapPointAsNumber = 0;
            if (isPx) snapPointAsNumber = parseInt(snapPoint, 10);
            if ($f60a43aec6935ca4$var$isVertical(direction)) {
                const height = isPx ? snapPointAsNumber : windowDimensions ? snapPoint * containerSize.height : 0;
                if (windowDimensions) return direction === "bottom" ? containerSize.height - height : -containerSize.height + height;
                return height;
            }
            const width = isPx ? snapPointAsNumber : windowDimensions ? snapPoint * containerSize.width : 0;
            if (windowDimensions) return direction === "right" ? containerSize.width - width : -containerSize.width + width;
            return width;
        })) != null ? _snapPoints_map : [];
    }, [
        snapPoints,
        windowDimensions,
        container
    ]);
    const activeSnapPointOffset = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useMemo(()=>activeSnapPointIndex !== null ? snapPointsOffset == null ? void 0 : snapPointsOffset[activeSnapPointIndex] : null, [
        snapPointsOffset,
        activeSnapPointIndex
    ]);
    const snapToPoint = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback((dimension)=>{
        var _snapPointsOffset_findIndex;
        const newSnapPointIndex = (_snapPointsOffset_findIndex = snapPointsOffset == null ? void 0 : snapPointsOffset.findIndex((snapPointDim)=>snapPointDim === dimension)) != null ? _snapPointsOffset_findIndex : null;
        onSnapPointChange(newSnapPointIndex);
        $f60a43aec6935ca4$var$set(drawerRef.current, {
            transition: `transform ${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`,
            transform: $f60a43aec6935ca4$var$isVertical(direction) ? `translate3d(0, ${dimension}px, 0)` : `translate3d(${dimension}px, 0, 0)`
        });
        if (snapPointsOffset && newSnapPointIndex !== snapPointsOffset.length - 1 && fadeFromIndex !== undefined && newSnapPointIndex !== fadeFromIndex && newSnapPointIndex < fadeFromIndex) $f60a43aec6935ca4$var$set(overlayRef.current, {
            transition: `opacity ${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`,
            opacity: "0"
        });
        else $f60a43aec6935ca4$var$set(overlayRef.current, {
            transition: `opacity ${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`,
            opacity: "1"
        });
        setActiveSnapPoint(snapPoints == null ? void 0 : snapPoints[Math.max(newSnapPointIndex, 0)]);
    }, [
        drawerRef.current,
        snapPoints,
        snapPointsOffset,
        fadeFromIndex,
        overlayRef,
        setActiveSnapPoint
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (activeSnapPoint || activeSnapPointProp) {
            var _snapPoints_findIndex;
            const newIndex = (_snapPoints_findIndex = snapPoints == null ? void 0 : snapPoints.findIndex((snapPoint)=>snapPoint === activeSnapPointProp || snapPoint === activeSnapPoint)) != null ? _snapPoints_findIndex : -1;
            if (snapPointsOffset && newIndex !== -1 && typeof snapPointsOffset[newIndex] === "number") snapToPoint(snapPointsOffset[newIndex]);
        }
    }, [
        activeSnapPoint,
        activeSnapPointProp,
        snapPoints,
        snapPointsOffset,
        snapToPoint
    ]);
    function onRelease({ draggedDistance: draggedDistance, closeDrawer: closeDrawer, velocity: velocity, dismissible: dismissible }) {
        if (fadeFromIndex === undefined) return;
        const currentPosition = direction === "bottom" || direction === "right" ? (activeSnapPointOffset != null ? activeSnapPointOffset : 0) - draggedDistance : (activeSnapPointOffset != null ? activeSnapPointOffset : 0) + draggedDistance;
        const isOverlaySnapPoint = activeSnapPointIndex === fadeFromIndex - 1;
        const isFirst = activeSnapPointIndex === 0;
        const hasDraggedUp = draggedDistance > 0;
        if (isOverlaySnapPoint) $f60a43aec6935ca4$var$set(overlayRef.current, {
            transition: `opacity ${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`
        });
        if (!snapToSequentialPoint && velocity > 2 && !hasDraggedUp) {
            if (dismissible) closeDrawer();
            else snapToPoint(snapPointsOffset[0]); // snap to initial point
            return;
        }
        if (!snapToSequentialPoint && velocity > 2 && hasDraggedUp && snapPointsOffset && snapPoints) {
            snapToPoint(snapPointsOffset[snapPoints.length - 1]);
            return;
        }
        // Find the closest snap point to the current position
        const closestSnapPoint = snapPointsOffset == null ? void 0 : snapPointsOffset.reduce((prev, curr)=>{
            if (typeof prev !== "number" || typeof curr !== "number") return prev;
            return Math.abs(curr - currentPosition) < Math.abs(prev - currentPosition) ? curr : prev;
        });
        const dim = $f60a43aec6935ca4$var$isVertical(direction) ? window.innerHeight : window.innerWidth;
        if (velocity > $f60a43aec6935ca4$var$VELOCITY_THRESHOLD && Math.abs(draggedDistance) < dim * 0.4) {
            const dragDirection = hasDraggedUp ? 1 : -1; // 1 = up, -1 = down
            // Don't do anything if we swipe upwards while being on the last snap point
            if (dragDirection > 0 && isLastSnapPoint && snapPoints) {
                snapToPoint(snapPointsOffset[snapPoints.length - 1]);
                return;
            }
            if (isFirst && dragDirection < 0 && dismissible) closeDrawer();
            if (activeSnapPointIndex === null) return;
            snapToPoint(snapPointsOffset[activeSnapPointIndex + dragDirection]);
            return;
        }
        snapToPoint(closestSnapPoint);
    }
    function onDrag({ draggedDistance: draggedDistance }) {
        if (activeSnapPointOffset === null) return;
        const newValue = direction === "bottom" || direction === "right" ? activeSnapPointOffset - draggedDistance : activeSnapPointOffset + draggedDistance;
        // Don't do anything if we exceed the last(biggest) snap point
        if ((direction === "bottom" || direction === "right") && newValue < snapPointsOffset[snapPointsOffset.length - 1]) return;
        if ((direction === "top" || direction === "left") && newValue > snapPointsOffset[snapPointsOffset.length - 1]) return;
        $f60a43aec6935ca4$var$set(drawerRef.current, {
            transform: $f60a43aec6935ca4$var$isVertical(direction) ? `translate3d(0, ${newValue}px, 0)` : `translate3d(${newValue}px, 0, 0)`
        });
    }
    function getPercentageDragged(absDraggedDistance, isDraggingDown) {
        if (!snapPoints || typeof activeSnapPointIndex !== "number" || !snapPointsOffset || fadeFromIndex === undefined) return null;
        // If this is true we are dragging to a snap point that is supposed to have an overlay
        const isOverlaySnapPoint = activeSnapPointIndex === fadeFromIndex - 1;
        const isOverlaySnapPointOrHigher = activeSnapPointIndex >= fadeFromIndex;
        if (isOverlaySnapPointOrHigher && isDraggingDown) return 0;
        // Don't animate, but still use this one if we are dragging away from the overlaySnapPoint
        if (isOverlaySnapPoint && !isDraggingDown) return 1;
        if (!shouldFade && !isOverlaySnapPoint) return null;
        // Either fadeFrom index or the one before
        const targetSnapPointIndex = isOverlaySnapPoint ? activeSnapPointIndex + 1 : activeSnapPointIndex - 1;
        // Get the distance from overlaySnapPoint to the one before or vice-versa to calculate the opacity percentage accordingly
        const snapPointDistance = isOverlaySnapPoint ? snapPointsOffset[targetSnapPointIndex] - snapPointsOffset[targetSnapPointIndex - 1] : snapPointsOffset[targetSnapPointIndex + 1] - snapPointsOffset[targetSnapPointIndex];
        const percentageDragged = absDraggedDistance / Math.abs(snapPointDistance);
        if (isOverlaySnapPoint) return 1 - percentageDragged;
        else return percentageDragged;
    }
    return {
        isLastSnapPoint: isLastSnapPoint,
        activeSnapPoint: activeSnapPoint,
        shouldFade: shouldFade,
        getPercentageDragged: getPercentageDragged,
        setActiveSnapPoint: setActiveSnapPoint,
        activeSnapPointIndex: activeSnapPointIndex,
        onRelease: onRelease,
        onDrag: onDrag,
        snapPointsOffset: snapPointsOffset
    };
}
const $f60a43aec6935ca4$var$noop = ()=>()=>{};
function $f60a43aec6935ca4$var$useScaleBackground() {
    const { direction: direction, isOpen: isOpen, shouldScaleBackground: shouldScaleBackground, setBackgroundColorOnScale: setBackgroundColorOnScale, noBodyStyles: noBodyStyles } = $f60a43aec6935ca4$var$useDrawerContext();
    const timeoutIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const initialBackgroundColor = (0, $7PdBe.useMemo)(()=>document.body.style.backgroundColor, []);
    function getScale() {
        return (window.innerWidth - $f60a43aec6935ca4$var$WINDOW_TOP_OFFSET) / window.innerWidth;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (isOpen && shouldScaleBackground) {
            if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
            const wrapper = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
            if (!wrapper) return;
            $f60a43aec6935ca4$var$chain(setBackgroundColorOnScale && !noBodyStyles ? $f60a43aec6935ca4$var$assignStyle(document.body, {
                background: "black"
            }) : $f60a43aec6935ca4$var$noop, $f60a43aec6935ca4$var$assignStyle(wrapper, {
                transformOrigin: $f60a43aec6935ca4$var$isVertical(direction) ? "top" : "left",
                transitionProperty: "transform, border-radius",
                transitionDuration: `${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s`,
                transitionTimingFunction: `cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`
            }));
            const wrapperStylesCleanup = $f60a43aec6935ca4$var$assignStyle(wrapper, {
                borderRadius: `${$f60a43aec6935ca4$var$BORDER_RADIUS}px`,
                overflow: "hidden",
                ...$f60a43aec6935ca4$var$isVertical(direction) ? {
                    transform: `scale(${getScale()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
                } : {
                    transform: `scale(${getScale()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
                }
            });
            return ()=>{
                wrapperStylesCleanup();
                timeoutIdRef.current = window.setTimeout(()=>{
                    if (initialBackgroundColor) document.body.style.background = initialBackgroundColor;
                    else document.body.style.removeProperty("background");
                }, $f60a43aec6935ca4$var$TRANSITIONS.DURATION * 1000);
            };
        }
    }, [
        isOpen,
        shouldScaleBackground,
        initialBackgroundColor
    ]);
}
let $f60a43aec6935ca4$var$previousBodyPosition = null;
/**
 * This hook is necessary to prevent buggy behavior on iOS devices (need to test on Android).
 * I won't get into too much detail about what bugs it solves, but so far I've found that setting the body to `position: fixed` is the most reliable way to prevent those bugs.
 * Issues that this hook solves:
 * https://github.com/emilkowalski/vaul/issues/435
 * https://github.com/emilkowalski/vaul/issues/433
 * And more that I discovered, but were just not reported.
 */ function $f60a43aec6935ca4$var$usePositionFixed({ isOpen: isOpen, modal: modal, nested: nested, hasBeenOpened: hasBeenOpened, preventScrollRestoration: preventScrollRestoration, noBodyStyles: noBodyStyles }) {
    const [activeUrl, setActiveUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(()=>typeof window !== "undefined" ? window.location.href : "");
    const scrollPos = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(0);
    const setPositionFixed = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(()=>{
        // All browsers on iOS will return true here.
        if (!$f60a43aec6935ca4$var$isSafari()) return;
        // If previousBodyPosition is already set, don't set it again.
        if ($f60a43aec6935ca4$var$previousBodyPosition === null && isOpen && !noBodyStyles) {
            $f60a43aec6935ca4$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left,
                height: document.body.style.height,
                right: "unset"
            };
            // Update the dom inside an animation frame
            const { scrollX: scrollX, innerHeight: innerHeight } = window;
            document.body.style.setProperty("position", "fixed", "important");
            Object.assign(document.body.style, {
                top: `${-scrollPos.current}px`,
                left: `${-scrollX}px`,
                right: "0px",
                height: "auto"
            });
            window.setTimeout(()=>window.requestAnimationFrame(()=>{
                    // Attempt to check if the bottom bar appeared due to the position change
                    const bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollPos.current >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = `${-(scrollPos.current + bottomBarHeight)}px`;
                }), 300);
        }
    }, [
        isOpen
    ]);
    const restorePositionSetting = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback(()=>{
        // All browsers on iOS will return true here.
        if (!$f60a43aec6935ca4$var$isSafari()) return;
        if ($f60a43aec6935ca4$var$previousBodyPosition !== null && !noBodyStyles) {
            // Convert the position from "px" to Int
            const y = -parseInt(document.body.style.top, 10);
            const x = -parseInt(document.body.style.left, 10);
            // Restore styles
            Object.assign(document.body.style, $f60a43aec6935ca4$var$previousBodyPosition);
            window.requestAnimationFrame(()=>{
                if (preventScrollRestoration && activeUrl !== window.location.href) {
                    setActiveUrl(window.location.href);
                    return;
                }
                window.scrollTo(x, y);
            });
            $f60a43aec6935ca4$var$previousBodyPosition = null;
        }
    }, [
        activeUrl
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        function onScroll() {
            scrollPos.current = window.scrollY;
        }
        onScroll();
        window.addEventListener("scroll", onScroll);
        return ()=>{
            window.removeEventListener("scroll", onScroll);
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (!modal) return;
        return ()=>{
            if (typeof document === "undefined") return;
            // Another drawer is opened, safe to ignore the execution
            const hasDrawerOpened = !!document.querySelector("[data-vaul-drawer]");
            if (hasDrawerOpened) return;
            restorePositionSetting();
        };
    }, [
        modal,
        restorePositionSetting
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (nested || !hasBeenOpened) return;
        // This is needed to force Safari toolbar to show **before** the drawer starts animating to prevent a gnarly shift from happening
        if (isOpen) {
            // avoid for standalone mode (PWA)
            const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
            !isStandalone && setPositionFixed();
            if (!modal) window.setTimeout(()=>{
                restorePositionSetting();
            }, 500);
        } else restorePositionSetting();
    }, [
        isOpen,
        hasBeenOpened,
        activeUrl,
        modal,
        nested,
        setPositionFixed,
        restorePositionSetting
    ]);
    return {
        restorePositionSetting: restorePositionSetting
    };
}
function $f60a43aec6935ca4$export$be92b6f5f03c0fe9({ open: openProp, onOpenChange: onOpenChange, children: children, onDrag: onDragProp, onRelease: onReleaseProp, snapPoints: snapPoints, shouldScaleBackground: shouldScaleBackground = false, setBackgroundColorOnScale: setBackgroundColorOnScale = true, closeThreshold: closeThreshold = $f60a43aec6935ca4$var$CLOSE_THRESHOLD, scrollLockTimeout: scrollLockTimeout = $f60a43aec6935ca4$var$SCROLL_LOCK_TIMEOUT, dismissible: dismissible = true, handleOnly: handleOnly = false, fadeFromIndex: fadeFromIndex = snapPoints && snapPoints.length - 1, activeSnapPoint: activeSnapPointProp, setActiveSnapPoint: setActiveSnapPointProp, fixed: fixed, modal: modal = true, onClose: onClose, nested: nested, noBodyStyles: noBodyStyles = false, direction: direction = "bottom", defaultOpen: defaultOpen = false, disablePreventScroll: disablePreventScroll = true, snapToSequentialPoint: snapToSequentialPoint = false, preventScrollRestoration: preventScrollRestoration = false, repositionInputs: repositionInputs = true, onAnimationEnd: onAnimationEnd, container: container, autoFocus: autoFocus = false }) {
    var _drawerRef_current, _drawerRef_current1;
    const [isOpen = false, setIsOpen] = $f60a43aec6935ca4$var$useControllableState({
        defaultProp: defaultOpen,
        prop: openProp,
        onChange: (o)=>{
            onOpenChange == null || onOpenChange(o);
            if (!o && !nested) restorePositionSetting();
            setTimeout(()=>{
                onAnimationEnd == null || onAnimationEnd(o);
            }, $f60a43aec6935ca4$var$TRANSITIONS.DURATION * 1000);
            if (o && !modal) {
                if (typeof window !== "undefined") window.requestAnimationFrame(()=>{
                    document.body.style.pointerEvents = "auto";
                });
            }
            if (!o) // This will be removed when the exit animation ends (`500ms`)
            document.body.style.pointerEvents = "auto";
        }
    });
    const [hasBeenOpened, setHasBeenOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(false);
    const [isDragging, setIsDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(false);
    const [justReleased, setJustReleased] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(false);
    const overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const openTime = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const dragEndTime = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const lastTimeDragPrevented = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const isAllowedToDrag = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(false);
    const nestedOpenChangeTimer = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const pointerStart = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(0);
    const keyboardIsOpen = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(false);
    const shouldAnimate = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(!defaultOpen);
    const previousDiffFromInitial = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(0);
    const drawerRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const drawerHeightRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(((_drawerRef_current = drawerRef.current) == null ? void 0 : _drawerRef_current.getBoundingClientRect().height) || 0);
    const drawerWidthRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(((_drawerRef_current1 = drawerRef.current) == null ? void 0 : _drawerRef_current1.getBoundingClientRect().width) || 0);
    const initialDrawerHeight = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(0);
    const onSnapPointChange = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback((activeSnapPointIndex)=>{
        // Change openTime ref when we reach the last snap point to prevent dragging for 500ms incase it's scrollable.
        if (snapPoints && activeSnapPointIndex === snapPointsOffset.length - 1) openTime.current = new Date();
    }, []);
    const { activeSnapPoint: activeSnapPoint, activeSnapPointIndex: activeSnapPointIndex, setActiveSnapPoint: setActiveSnapPoint, onRelease: onReleaseSnapPoints, snapPointsOffset: snapPointsOffset, onDrag: onDragSnapPoints, shouldFade: shouldFade, getPercentageDragged: getSnapPointsPercentageDragged } = $f60a43aec6935ca4$var$useSnapPoints({
        snapPoints: snapPoints,
        activeSnapPointProp: activeSnapPointProp,
        setActiveSnapPointProp: setActiveSnapPointProp,
        drawerRef: drawerRef,
        fadeFromIndex: fadeFromIndex,
        overlayRef: overlayRef,
        onSnapPointChange: onSnapPointChange,
        direction: direction,
        container: container,
        snapToSequentialPoint: snapToSequentialPoint
    });
    $f60a43aec6935ca4$var$usePreventScroll({
        isDisabled: !isOpen || isDragging || !modal || justReleased || !hasBeenOpened || !repositionInputs || !disablePreventScroll
    });
    const { restorePositionSetting: restorePositionSetting } = $f60a43aec6935ca4$var$usePositionFixed({
        isOpen: isOpen,
        modal: modal,
        nested: nested != null ? nested : false,
        hasBeenOpened: hasBeenOpened,
        preventScrollRestoration: preventScrollRestoration,
        noBodyStyles: noBodyStyles
    });
    function getScale() {
        return (window.innerWidth - $f60a43aec6935ca4$var$WINDOW_TOP_OFFSET) / window.innerWidth;
    }
    function onPress(event) {
        var _drawerRef_current, _drawerRef_current1;
        if (!dismissible && !snapPoints) return;
        if (drawerRef.current && !drawerRef.current.contains(event.target)) return;
        drawerHeightRef.current = ((_drawerRef_current = drawerRef.current) == null ? void 0 : _drawerRef_current.getBoundingClientRect().height) || 0;
        drawerWidthRef.current = ((_drawerRef_current1 = drawerRef.current) == null ? void 0 : _drawerRef_current1.getBoundingClientRect().width) || 0;
        setIsDragging(true);
        dragStartTime.current = new Date();
        // iOS doesn't trigger mouseUp after scrolling so we need to listen to touched in order to disallow dragging
        if ($f60a43aec6935ca4$var$isIOS()) window.addEventListener("touchend", ()=>isAllowedToDrag.current = false, {
            once: true
        });
        // Ensure we maintain correct pointer capture even when going outside of the drawer
        event.target.setPointerCapture(event.pointerId);
        pointerStart.current = $f60a43aec6935ca4$var$isVertical(direction) ? event.pageY : event.pageX;
    }
    function shouldDrag(el, isDraggingInDirection) {
        var _window_getSelection;
        let element = el;
        const highlightedText = (_window_getSelection = window.getSelection()) == null ? void 0 : _window_getSelection.toString();
        const swipeAmount = drawerRef.current ? $f60a43aec6935ca4$var$getTranslate(drawerRef.current, direction) : null;
        const date = new Date();
        // Fixes https://github.com/emilkowalski/vaul/issues/483
        if (element.tagName === "SELECT") return false;
        if (element.hasAttribute("data-vaul-no-drag") || element.closest("[data-vaul-no-drag]")) return false;
        if (direction === "right" || direction === "left") return true;
        // Allow scrolling when animating
        if (openTime.current && date.getTime() - openTime.current.getTime() < 500) return false;
        if (swipeAmount !== null) {
            if (direction === "bottom" ? swipeAmount > 0 : swipeAmount < 0) return true;
        }
        // Don't drag if there's highlighted text
        if (highlightedText && highlightedText.length > 0) return false;
        // Disallow dragging if drawer was scrolled within `scrollLockTimeout`
        if (lastTimeDragPrevented.current && date.getTime() - lastTimeDragPrevented.current.getTime() < scrollLockTimeout && swipeAmount === 0) {
            lastTimeDragPrevented.current = date;
            return false;
        }
        if (isDraggingInDirection) {
            lastTimeDragPrevented.current = date;
            // We are dragging down so we should allow scrolling
            return false;
        }
        // Keep climbing up the DOM tree as long as there's a parent
        while(element){
            // Check if the element is scrollable
            if (element.scrollHeight > element.clientHeight) {
                if (element.scrollTop !== 0) {
                    lastTimeDragPrevented.current = new Date();
                    // The element is scrollable and not scrolled to the top, so don't drag
                    return false;
                }
                if (element.getAttribute("role") === "dialog") return true;
            }
            // Move up to the parent element
            element = element.parentNode;
        }
        // No scrollable parents not scrolled to the top found, so drag
        return true;
    }
    function onDrag(event) {
        if (!drawerRef.current) return;
        // We need to know how much of the drawer has been dragged in percentages so that we can transform background accordingly
        if (isDragging) {
            const directionMultiplier = direction === "bottom" || direction === "right" ? 1 : -1;
            const draggedDistance = (pointerStart.current - ($f60a43aec6935ca4$var$isVertical(direction) ? event.pageY : event.pageX)) * directionMultiplier;
            const isDraggingInDirection = draggedDistance > 0;
            // Pre condition for disallowing dragging in the close direction.
            const noCloseSnapPointsPreCondition = snapPoints && !dismissible && !isDraggingInDirection;
            // Disallow dragging down to close when first snap point is the active one and dismissible prop is set to false.
            if (noCloseSnapPointsPreCondition && activeSnapPointIndex === 0) return;
            // We need to capture last time when drag with scroll was triggered and have a timeout between
            const absDraggedDistance = Math.abs(draggedDistance);
            const wrapper = document.querySelector("[data-vaul-drawer-wrapper]");
            const drawerDimension = direction === "bottom" || direction === "top" ? drawerHeightRef.current : drawerWidthRef.current;
            // Calculate the percentage dragged, where 1 is the closed position
            let percentageDragged = absDraggedDistance / drawerDimension;
            const snapPointPercentageDragged = getSnapPointsPercentageDragged(absDraggedDistance, isDraggingInDirection);
            if (snapPointPercentageDragged !== null) percentageDragged = snapPointPercentageDragged;
            // Disallow close dragging beyond the smallest snap point.
            if (noCloseSnapPointsPreCondition && percentageDragged >= 1) return;
            if (!isAllowedToDrag.current && !shouldDrag(event.target, isDraggingInDirection)) return;
            drawerRef.current.classList.add($f60a43aec6935ca4$var$DRAG_CLASS);
            // If shouldDrag gave true once after pressing down on the drawer, we set isAllowedToDrag to true and it will remain true until we let go, there's no reason to disable dragging mid way, ever, and that's the solution to it
            isAllowedToDrag.current = true;
            $f60a43aec6935ca4$var$set(drawerRef.current, {
                transition: "none"
            });
            $f60a43aec6935ca4$var$set(overlayRef.current, {
                transition: "none"
            });
            if (snapPoints) onDragSnapPoints({
                draggedDistance: draggedDistance
            });
            // Run this only if snapPoints are not defined or if we are at the last snap point (highest one)
            if (isDraggingInDirection && !snapPoints) {
                const dampenedDraggedDistance = $f60a43aec6935ca4$var$dampenValue(draggedDistance);
                const translateValue = Math.min(dampenedDraggedDistance * -1, 0) * directionMultiplier;
                $f60a43aec6935ca4$var$set(drawerRef.current, {
                    transform: $f60a43aec6935ca4$var$isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
                });
                return;
            }
            const opacityValue = 1 - percentageDragged;
            if (shouldFade || fadeFromIndex && activeSnapPointIndex === fadeFromIndex - 1) {
                onDragProp == null || onDragProp(event, percentageDragged);
                $f60a43aec6935ca4$var$set(overlayRef.current, {
                    opacity: `${opacityValue}`,
                    transition: "none"
                }, true);
            }
            if (wrapper && overlayRef.current && shouldScaleBackground) {
                // Calculate percentageDragged as a fraction (0 to 1)
                const scaleValue = Math.min(getScale() + percentageDragged * (1 - getScale()), 1);
                const borderRadiusValue = 8 - percentageDragged * 8;
                const translateValue = Math.max(0, 14 - percentageDragged * 14);
                $f60a43aec6935ca4$var$set(wrapper, {
                    borderRadius: `${borderRadiusValue}px`,
                    transform: $f60a43aec6935ca4$var$isVertical(direction) ? `scale(${scaleValue}) translate3d(0, ${translateValue}px, 0)` : `scale(${scaleValue}) translate3d(${translateValue}px, 0, 0)`,
                    transition: "none"
                }, true);
            }
            if (!snapPoints) {
                const translateValue = absDraggedDistance * directionMultiplier;
                $f60a43aec6935ca4$var$set(drawerRef.current, {
                    transform: $f60a43aec6935ca4$var$isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
                });
            }
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        window.requestAnimationFrame(()=>{
            shouldAnimate.current = true;
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        var _window_visualViewport;
        function onVisualViewportChange() {
            if (!drawerRef.current || !repositionInputs) return;
            const focusedElement = document.activeElement;
            if ($f60a43aec6935ca4$var$isInput(focusedElement) || keyboardIsOpen.current) {
                var _window_visualViewport;
                const visualViewportHeight = ((_window_visualViewport = window.visualViewport) == null ? void 0 : _window_visualViewport.height) || 0;
                const totalHeight = window.innerHeight;
                // This is the height of the keyboard
                let diffFromInitial = totalHeight - visualViewportHeight;
                const drawerHeight = drawerRef.current.getBoundingClientRect().height || 0;
                // Adjust drawer height only if it's tall enough
                const isTallEnough = drawerHeight > totalHeight * 0.8;
                if (!initialDrawerHeight.current) initialDrawerHeight.current = drawerHeight;
                const offsetFromTop = drawerRef.current.getBoundingClientRect().top;
                // visualViewport height may change due to somq e subtle changes to the keyboard. Checking if the height changed by 60 or more will make sure that they keyboard really changed its open state.
                if (Math.abs(previousDiffFromInitial.current - diffFromInitial) > 60) keyboardIsOpen.current = !keyboardIsOpen.current;
                if (snapPoints && snapPoints.length > 0 && snapPointsOffset && activeSnapPointIndex) {
                    const activeSnapPointHeight = snapPointsOffset[activeSnapPointIndex] || 0;
                    diffFromInitial += activeSnapPointHeight;
                }
                previousDiffFromInitial.current = diffFromInitial;
                // We don't have to change the height if the input is in view, when we are here we are in the opened keyboard state so we can correctly check if the input is in view
                if (drawerHeight > visualViewportHeight || keyboardIsOpen.current) {
                    const height = drawerRef.current.getBoundingClientRect().height;
                    let newDrawerHeight = height;
                    if (height > visualViewportHeight) newDrawerHeight = visualViewportHeight - (isTallEnough ? offsetFromTop : $f60a43aec6935ca4$var$WINDOW_TOP_OFFSET);
                    // When fixed, don't move the drawer upwards if there's space, but rather only change it's height so it's fully scrollable when the keyboard is open
                    if (fixed) drawerRef.current.style.height = `${height - Math.max(diffFromInitial, 0)}px`;
                    else drawerRef.current.style.height = `${Math.max(newDrawerHeight, visualViewportHeight - offsetFromTop)}px`;
                } else if (!$f60a43aec6935ca4$var$isMobileFirefox()) drawerRef.current.style.height = `${initialDrawerHeight.current}px`;
                if (snapPoints && snapPoints.length > 0 && !keyboardIsOpen.current) drawerRef.current.style.bottom = `0px`;
                else // Negative bottom value would never make sense
                drawerRef.current.style.bottom = `${Math.max(diffFromInitial, 0)}px`;
            }
        }
        (_window_visualViewport = window.visualViewport) == null || _window_visualViewport.addEventListener("resize", onVisualViewportChange);
        return ()=>{
            var _window_visualViewport;
            return (_window_visualViewport = window.visualViewport) == null ? void 0 : _window_visualViewport.removeEventListener("resize", onVisualViewportChange);
        };
    }, [
        activeSnapPointIndex,
        snapPoints,
        snapPointsOffset
    ]);
    function closeDrawer(fromWithin) {
        cancelDrag();
        onClose == null || onClose();
        if (!fromWithin) setIsOpen(false);
        setTimeout(()=>{
            if (snapPoints) setActiveSnapPoint(snapPoints[0]);
        }, $f60a43aec6935ca4$var$TRANSITIONS.DURATION * 1000); // seconds to ms
    }
    function resetDrawer() {
        if (!drawerRef.current) return;
        const wrapper = document.querySelector("[data-vaul-drawer-wrapper]");
        const currentSwipeAmount = $f60a43aec6935ca4$var$getTranslate(drawerRef.current, direction);
        $f60a43aec6935ca4$var$set(drawerRef.current, {
            transform: "translate3d(0, 0, 0)",
            transition: `transform ${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`
        });
        $f60a43aec6935ca4$var$set(overlayRef.current, {
            transition: `opacity ${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`,
            opacity: "1"
        });
        // Don't reset background if swiped upwards
        if (shouldScaleBackground && currentSwipeAmount && currentSwipeAmount > 0 && isOpen) $f60a43aec6935ca4$var$set(wrapper, {
            borderRadius: `${$f60a43aec6935ca4$var$BORDER_RADIUS}px`,
            overflow: "hidden",
            ...$f60a43aec6935ca4$var$isVertical(direction) ? {
                transform: `scale(${getScale()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
                transformOrigin: "top"
            } : {
                transform: `scale(${getScale()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
                transformOrigin: "left"
            },
            transitionProperty: "transform, border-radius",
            transitionDuration: `${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s`,
            transitionTimingFunction: `cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`
        }, true);
    }
    function cancelDrag() {
        if (!isDragging || !drawerRef.current) return;
        drawerRef.current.classList.remove($f60a43aec6935ca4$var$DRAG_CLASS);
        isAllowedToDrag.current = false;
        setIsDragging(false);
        dragEndTime.current = new Date();
    }
    function onRelease(event) {
        if (!isDragging || !drawerRef.current) return;
        drawerRef.current.classList.remove($f60a43aec6935ca4$var$DRAG_CLASS);
        isAllowedToDrag.current = false;
        setIsDragging(false);
        dragEndTime.current = new Date();
        const swipeAmount = $f60a43aec6935ca4$var$getTranslate(drawerRef.current, direction);
        if (!event || !shouldDrag(event.target, false) || !swipeAmount || Number.isNaN(swipeAmount)) return;
        if (dragStartTime.current === null) return;
        const timeTaken = dragEndTime.current.getTime() - dragStartTime.current.getTime();
        const distMoved = pointerStart.current - ($f60a43aec6935ca4$var$isVertical(direction) ? event.pageY : event.pageX);
        const velocity = Math.abs(distMoved) / timeTaken;
        if (velocity > 0.05) {
            // `justReleased` is needed to prevent the drawer from focusing on an input when the drag ends, as it's not the intent most of the time.
            setJustReleased(true);
            setTimeout(()=>{
                setJustReleased(false);
            }, 200);
        }
        if (snapPoints) {
            const directionMultiplier = direction === "bottom" || direction === "right" ? 1 : -1;
            onReleaseSnapPoints({
                draggedDistance: distMoved * directionMultiplier,
                closeDrawer: closeDrawer,
                velocity: velocity,
                dismissible: dismissible
            });
            onReleaseProp == null || onReleaseProp(event, true);
            return;
        }
        // Moved upwards, don't do anything
        if (direction === "bottom" || direction === "right" ? distMoved > 0 : distMoved < 0) {
            resetDrawer();
            onReleaseProp == null || onReleaseProp(event, true);
            return;
        }
        if (velocity > $f60a43aec6935ca4$var$VELOCITY_THRESHOLD) {
            closeDrawer();
            onReleaseProp == null || onReleaseProp(event, false);
            return;
        }
        var _drawerRef_current_getBoundingClientRect_height;
        const visibleDrawerHeight = Math.min((_drawerRef_current_getBoundingClientRect_height = drawerRef.current.getBoundingClientRect().height) != null ? _drawerRef_current_getBoundingClientRect_height : 0, window.innerHeight);
        var _drawerRef_current_getBoundingClientRect_width;
        const visibleDrawerWidth = Math.min((_drawerRef_current_getBoundingClientRect_width = drawerRef.current.getBoundingClientRect().width) != null ? _drawerRef_current_getBoundingClientRect_width : 0, window.innerWidth);
        const isHorizontalSwipe = direction === "left" || direction === "right";
        if (Math.abs(swipeAmount) >= (isHorizontalSwipe ? visibleDrawerWidth : visibleDrawerHeight) * closeThreshold) {
            closeDrawer();
            onReleaseProp == null || onReleaseProp(event, false);
            return;
        }
        onReleaseProp == null || onReleaseProp(event, true);
        resetDrawer();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        // Trigger enter animation without using CSS animation
        if (isOpen) {
            $f60a43aec6935ca4$var$set(document.documentElement, {
                scrollBehavior: "auto"
            });
            openTime.current = new Date();
        }
        return ()=>{
            $f60a43aec6935ca4$var$reset(document.documentElement, "scrollBehavior");
        };
    }, [
        isOpen
    ]);
    function onNestedOpenChange(o) {
        const scale = o ? (window.innerWidth - $f60a43aec6935ca4$var$NESTED_DISPLACEMENT) / window.innerWidth : 1;
        const initialTranslate = o ? -$f60a43aec6935ca4$var$NESTED_DISPLACEMENT : 0;
        if (nestedOpenChangeTimer.current) window.clearTimeout(nestedOpenChangeTimer.current);
        $f60a43aec6935ca4$var$set(drawerRef.current, {
            transition: `transform ${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`,
            transform: $f60a43aec6935ca4$var$isVertical(direction) ? `scale(${scale}) translate3d(0, ${initialTranslate}px, 0)` : `scale(${scale}) translate3d(${initialTranslate}px, 0, 0)`
        });
        if (!o && drawerRef.current) nestedOpenChangeTimer.current = setTimeout(()=>{
            const translateValue = $f60a43aec6935ca4$var$getTranslate(drawerRef.current, direction);
            $f60a43aec6935ca4$var$set(drawerRef.current, {
                transition: "none",
                transform: $f60a43aec6935ca4$var$isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
            });
        }, 500);
    }
    function onNestedDrag(_event, percentageDragged) {
        if (percentageDragged < 0) return;
        const initialScale = (window.innerWidth - $f60a43aec6935ca4$var$NESTED_DISPLACEMENT) / window.innerWidth;
        const newScale = initialScale + percentageDragged * (1 - initialScale);
        const newTranslate = -$f60a43aec6935ca4$var$NESTED_DISPLACEMENT + percentageDragged * $f60a43aec6935ca4$var$NESTED_DISPLACEMENT;
        $f60a43aec6935ca4$var$set(drawerRef.current, {
            transform: $f60a43aec6935ca4$var$isVertical(direction) ? `scale(${newScale}) translate3d(0, ${newTranslate}px, 0)` : `scale(${newScale}) translate3d(${newTranslate}px, 0, 0)`,
            transition: "none"
        });
    }
    function onNestedRelease(_event, o) {
        const dim = $f60a43aec6935ca4$var$isVertical(direction) ? window.innerHeight : window.innerWidth;
        const scale = o ? (dim - $f60a43aec6935ca4$var$NESTED_DISPLACEMENT) / dim : 1;
        const translate = o ? -$f60a43aec6935ca4$var$NESTED_DISPLACEMENT : 0;
        if (o) $f60a43aec6935ca4$var$set(drawerRef.current, {
            transition: `transform ${$f60a43aec6935ca4$var$TRANSITIONS.DURATION}s cubic-bezier(${$f60a43aec6935ca4$var$TRANSITIONS.EASE.join(",")})`,
            transform: $f60a43aec6935ca4$var$isVertical(direction) ? `scale(${scale}) translate3d(0, ${translate}px, 0)` : `scale(${scale}) translate3d(${translate}px, 0, 0)`
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (!modal) // Need to do this manually unfortunately
        window.requestAnimationFrame(()=>{
            document.body.style.pointerEvents = "auto";
        });
    }, [
        modal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement($3db049dff66a112d$export$be92b6f5f03c0fe9, {
        defaultOpen: defaultOpen,
        onOpenChange: (open)=>{
            if (!dismissible && !open) return;
            if (open) setHasBeenOpened(true);
            else closeDrawer(true);
            setIsOpen(open);
        },
        open: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement($f60a43aec6935ca4$var$DrawerContext.Provider, {
        value: {
            activeSnapPoint: activeSnapPoint,
            snapPoints: snapPoints,
            setActiveSnapPoint: setActiveSnapPoint,
            drawerRef: drawerRef,
            overlayRef: overlayRef,
            onOpenChange: onOpenChange,
            onPress: onPress,
            onRelease: onRelease,
            onDrag: onDrag,
            dismissible: dismissible,
            shouldAnimate: shouldAnimate,
            handleOnly: handleOnly,
            isOpen: isOpen,
            isDragging: isDragging,
            shouldFade: shouldFade,
            closeDrawer: closeDrawer,
            onNestedDrag: onNestedDrag,
            onNestedOpenChange: onNestedOpenChange,
            onNestedRelease: onNestedRelease,
            keyboardIsOpen: keyboardIsOpen,
            modal: modal,
            snapPointsOffset: snapPointsOffset,
            activeSnapPointIndex: activeSnapPointIndex,
            direction: direction,
            shouldScaleBackground: shouldScaleBackground,
            setBackgroundColorOnScale: setBackgroundColorOnScale,
            noBodyStyles: noBodyStyles,
            container: container,
            autoFocus: autoFocus
        }
    }, children));
}
const $f60a43aec6935ca4$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).forwardRef(function({ ...rest }, ref) {
    const { overlayRef: overlayRef, snapPoints: snapPoints, onRelease: onRelease, shouldFade: shouldFade, isOpen: isOpen, modal: modal, shouldAnimate: shouldAnimate } = $f60a43aec6935ca4$var$useDrawerContext();
    const composedRef = $f60a43aec6935ca4$var$useComposedRefs(ref, overlayRef);
    const hasSnapPoints = snapPoints && snapPoints.length > 0;
    // Overlay is the component that is locking scroll, removing it will unlock the scroll without having to dig into Radix's Dialog library
    if (!modal) return null;
    const onMouseUp = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useCallback((event)=>onRelease(event), [
        onRelease
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement($3db049dff66a112d$export$c6fdb837b070b4ff, {
        onMouseUp: onMouseUp,
        ref: composedRef,
        "data-vaul-overlay": "",
        "data-vaul-snap-points": isOpen && hasSnapPoints ? "true" : "false",
        "data-vaul-snap-points-overlay": isOpen && shouldFade ? "true" : "false",
        "data-vaul-animate": (shouldAnimate == null ? void 0 : shouldAnimate.current) ? "true" : "false",
        ...rest
    });
});
$f60a43aec6935ca4$export$c6fdb837b070b4ff.displayName = "Drawer.Overlay";
const $f60a43aec6935ca4$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).forwardRef(function({ onPointerDownOutside: onPointerDownOutside, style: style, onOpenAutoFocus: onOpenAutoFocus, ...rest }, ref) {
    const { drawerRef: drawerRef, onPress: onPress, onRelease: onRelease, onDrag: onDrag, keyboardIsOpen: keyboardIsOpen, snapPointsOffset: snapPointsOffset, activeSnapPointIndex: activeSnapPointIndex, modal: modal, isOpen: isOpen, direction: direction, snapPoints: snapPoints, container: container, handleOnly: handleOnly, shouldAnimate: shouldAnimate, autoFocus: autoFocus } = $f60a43aec6935ca4$var$useDrawerContext();
    // Needed to use transition instead of animations
    const [delayedSnapPoints, setDelayedSnapPoints] = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useState(false);
    const composedRef = $f60a43aec6935ca4$var$useComposedRefs(ref, drawerRef);
    const pointerStartRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const lastKnownPointerEventRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const wasBeyondThePointRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(false);
    const hasSnapPoints = snapPoints && snapPoints.length > 0;
    $f60a43aec6935ca4$var$useScaleBackground();
    const isDeltaInDirection = (delta, direction, threshold = 0)=>{
        if (wasBeyondThePointRef.current) return true;
        const deltaY = Math.abs(delta.y);
        const deltaX = Math.abs(delta.x);
        const isDeltaX = deltaX > deltaY;
        const dFactor = [
            "bottom",
            "right"
        ].includes(direction) ? 1 : -1;
        if (direction === "left" || direction === "right") {
            const isReverseDirection = delta.x * dFactor < 0;
            if (!isReverseDirection && deltaX >= 0 && deltaX <= threshold) return isDeltaX;
        } else {
            const isReverseDirection = delta.y * dFactor < 0;
            if (!isReverseDirection && deltaY >= 0 && deltaY <= threshold) return !isDeltaX;
        }
        wasBeyondThePointRef.current = true;
        return true;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useEffect(()=>{
        if (hasSnapPoints) window.requestAnimationFrame(()=>{
            setDelayedSnapPoints(true);
        });
    }, []);
    function handleOnPointerUp(event) {
        pointerStartRef.current = null;
        wasBeyondThePointRef.current = false;
        onRelease(event);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement($3db049dff66a112d$export$7c6e2c02157bb7d2, {
        "data-vaul-drawer-direction": direction,
        "data-vaul-drawer": "",
        "data-vaul-delayed-snap-points": delayedSnapPoints ? "true" : "false",
        "data-vaul-snap-points": isOpen && hasSnapPoints ? "true" : "false",
        "data-vaul-custom-container": container ? "true" : "false",
        "data-vaul-animate": (shouldAnimate == null ? void 0 : shouldAnimate.current) ? "true" : "false",
        ...rest,
        ref: composedRef,
        style: snapPointsOffset && snapPointsOffset.length > 0 ? {
            "--snap-point-height": `${snapPointsOffset[activeSnapPointIndex != null ? activeSnapPointIndex : 0]}px`,
            ...style
        } : style,
        onPointerDown: (event)=>{
            if (handleOnly) return;
            rest.onPointerDown == null || rest.onPointerDown.call(rest, event);
            pointerStartRef.current = {
                x: event.pageX,
                y: event.pageY
            };
            onPress(event);
        },
        onOpenAutoFocus: (e)=>{
            onOpenAutoFocus == null || onOpenAutoFocus(e);
            if (!autoFocus) e.preventDefault();
        },
        onPointerDownOutside: (e)=>{
            onPointerDownOutside == null || onPointerDownOutside(e);
            if (!modal || e.defaultPrevented) {
                e.preventDefault();
                return;
            }
            if (keyboardIsOpen.current) keyboardIsOpen.current = false;
        },
        onFocusOutside: (e)=>{
            if (!modal) {
                e.preventDefault();
                return;
            }
        },
        onPointerMove: (event)=>{
            lastKnownPointerEventRef.current = event;
            if (handleOnly) return;
            rest.onPointerMove == null || rest.onPointerMove.call(rest, event);
            if (!pointerStartRef.current) return;
            const yPosition = event.pageY - pointerStartRef.current.y;
            const xPosition = event.pageX - pointerStartRef.current.x;
            const swipeStartThreshold = event.pointerType === "touch" ? 10 : 2;
            const delta = {
                x: xPosition,
                y: yPosition
            };
            const isAllowedToSwipe = isDeltaInDirection(delta, direction, swipeStartThreshold);
            if (isAllowedToSwipe) onDrag(event);
            else if (Math.abs(xPosition) > swipeStartThreshold || Math.abs(yPosition) > swipeStartThreshold) pointerStartRef.current = null;
        },
        onPointerUp: (event)=>{
            rest.onPointerUp == null || rest.onPointerUp.call(rest, event);
            pointerStartRef.current = null;
            wasBeyondThePointRef.current = false;
            onRelease(event);
        },
        onPointerOut: (event)=>{
            rest.onPointerOut == null || rest.onPointerOut.call(rest, event);
            handleOnPointerUp(lastKnownPointerEventRef.current);
        },
        onContextMenu: (event)=>{
            rest.onContextMenu == null || rest.onContextMenu.call(rest, event);
            if (lastKnownPointerEventRef.current) handleOnPointerUp(lastKnownPointerEventRef.current);
        }
    });
});
$f60a43aec6935ca4$export$7c6e2c02157bb7d2.displayName = "Drawer.Content";
const $f60a43aec6935ca4$var$LONG_HANDLE_PRESS_TIMEOUT = 250;
const $f60a43aec6935ca4$var$DOUBLE_TAP_TIMEOUT = 120;
const $f60a43aec6935ca4$export$94890c79f4cae6d6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).forwardRef(function({ preventCycle: preventCycle = false, children: children, ...rest }, ref) {
    const { closeDrawer: closeDrawer, isDragging: isDragging, snapPoints: snapPoints, activeSnapPoint: activeSnapPoint, setActiveSnapPoint: setActiveSnapPoint, dismissible: dismissible, handleOnly: handleOnly, isOpen: isOpen, onPress: onPress, onDrag: onDrag } = $f60a43aec6935ca4$var$useDrawerContext();
    const closeTimeoutIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(null);
    const shouldCancelInteractionRef = (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).useRef(false);
    function handleStartCycle() {
        // Stop if this is the second click of a double click
        if (shouldCancelInteractionRef.current) {
            handleCancelInteraction();
            return;
        }
        window.setTimeout(()=>{
            handleCycleSnapPoints();
        }, $f60a43aec6935ca4$var$DOUBLE_TAP_TIMEOUT);
    }
    function handleCycleSnapPoints() {
        // Prevent accidental taps while resizing drawer
        if (isDragging || preventCycle || shouldCancelInteractionRef.current) {
            handleCancelInteraction();
            return;
        }
        // Make sure to clear the timeout id if the user releases the handle before the cancel timeout
        handleCancelInteraction();
        if (!snapPoints || snapPoints.length === 0) {
            if (!dismissible) closeDrawer();
            return;
        }
        const isLastSnapPoint = activeSnapPoint === snapPoints[snapPoints.length - 1];
        if (isLastSnapPoint && dismissible) {
            closeDrawer();
            return;
        }
        const currentSnapIndex = snapPoints.findIndex((point)=>point === activeSnapPoint);
        if (currentSnapIndex === -1) return; // activeSnapPoint not found in snapPoints
        const nextSnapPoint = snapPoints[currentSnapIndex + 1];
        setActiveSnapPoint(nextSnapPoint);
    }
    function handleStartInteraction() {
        closeTimeoutIdRef.current = window.setTimeout(()=>{
            // Cancel click interaction on a long press
            shouldCancelInteractionRef.current = true;
        }, $f60a43aec6935ca4$var$LONG_HANDLE_PRESS_TIMEOUT);
    }
    function handleCancelInteraction() {
        if (closeTimeoutIdRef.current) window.clearTimeout(closeTimeoutIdRef.current);
        shouldCancelInteractionRef.current = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement("div", {
        onClick: handleStartCycle,
        onPointerCancel: handleCancelInteraction,
        onPointerDown: (e)=>{
            if (handleOnly) onPress(e);
            handleStartInteraction();
        },
        onPointerMove: (e)=>{
            if (handleOnly) onDrag(e);
        },
        // onPointerUp is already handled by the content component
        ref: ref,
        "data-vaul-drawer-visible": isOpen ? "true" : "false",
        "data-vaul-handle": "",
        "aria-hidden": "true",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement("span", {
        "data-vaul-handle-hitarea": "",
        "aria-hidden": "true"
    }, children));
});
$f60a43aec6935ca4$export$94890c79f4cae6d6.displayName = "Drawer.Handle";
function $f60a43aec6935ca4$export$a70aab124b3d51be({ onDrag: onDrag, onOpenChange: onOpenChange, open: nestedIsOpen, ...rest }) {
    const { onNestedDrag: onNestedDrag, onNestedOpenChange: onNestedOpenChange, onNestedRelease: onNestedRelease } = $f60a43aec6935ca4$var$useDrawerContext();
    if (!onNestedDrag) throw new Error("Drawer.NestedRoot must be placed in another drawer");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement($f60a43aec6935ca4$export$be92b6f5f03c0fe9, {
        nested: true,
        open: nestedIsOpen,
        onClose: ()=>{
            onNestedOpenChange(false);
        },
        onDrag: (e, p)=>{
            onNestedDrag(e, p);
            onDrag == null || onDrag(e, p);
        },
        onOpenChange: (o)=>{
            if (o) onNestedOpenChange(o);
            onOpenChange == null || onOpenChange(o);
        },
        onRelease: onNestedRelease,
        ...rest
    });
}
function $f60a43aec6935ca4$export$602eac185826482c(props) {
    const context = $f60a43aec6935ca4$var$useDrawerContext();
    const { container: container = context.container, ...portalProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7PdBe))).createElement($3db049dff66a112d$export$602eac185826482c, {
        container: container,
        ...portalProps
    });
}
const $f60a43aec6935ca4$export$4071300121a182f5 = {
    Root: $f60a43aec6935ca4$export$be92b6f5f03c0fe9,
    NestedRoot: $f60a43aec6935ca4$export$a70aab124b3d51be,
    Content: $f60a43aec6935ca4$export$7c6e2c02157bb7d2,
    Overlay: $f60a43aec6935ca4$export$c6fdb837b070b4ff,
    Trigger: $3db049dff66a112d$export$41fb9f06171c75f4,
    Portal: $f60a43aec6935ca4$export$602eac185826482c,
    Handle: $f60a43aec6935ca4$export$94890c79f4cae6d6,
    Close: $3db049dff66a112d$export$f39c2d165cd861fe,
    Title: $3db049dff66a112d$export$f99233281efd08a0,
    Description: $3db049dff66a112d$export$393edc798c47379d
};



var $7PdBe = parcelRequire("7PdBe");
var $0b4ffad7aef772d8$var$Bt = Object.defineProperty, $0b4ffad7aef772d8$var$At = Object.defineProperties;
var $0b4ffad7aef772d8$var$kt = Object.getOwnPropertyDescriptors;
var $0b4ffad7aef772d8$var$Y = Object.getOwnPropertySymbols;
var $0b4ffad7aef772d8$var$gt = Object.prototype.hasOwnProperty, $0b4ffad7aef772d8$var$Et = Object.prototype.propertyIsEnumerable;
var $0b4ffad7aef772d8$var$vt = (r, s, e)=>s in r ? $0b4ffad7aef772d8$var$Bt(r, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[s] = e, $0b4ffad7aef772d8$var$St = (r, s)=>{
    for(var e in s || (s = {}))$0b4ffad7aef772d8$var$gt.call(s, e) && $0b4ffad7aef772d8$var$vt(r, e, s[e]);
    if ($0b4ffad7aef772d8$var$Y) for (var e of $0b4ffad7aef772d8$var$Y(s))$0b4ffad7aef772d8$var$Et.call(s, e) && $0b4ffad7aef772d8$var$vt(r, e, s[e]);
    return r;
}, $0b4ffad7aef772d8$var$bt = (r, s)=>$0b4ffad7aef772d8$var$At(r, $0b4ffad7aef772d8$var$kt(s));
var $0b4ffad7aef772d8$var$Pt = (r, s)=>{
    var e = {};
    for(var u in r)$0b4ffad7aef772d8$var$gt.call(r, u) && s.indexOf(u) < 0 && (e[u] = r[u]);
    if (r != null && $0b4ffad7aef772d8$var$Y) for (var u of $0b4ffad7aef772d8$var$Y(r))s.indexOf(u) < 0 && $0b4ffad7aef772d8$var$Et.call(r, u) && (e[u] = r[u]);
    return e;
};
function $0b4ffad7aef772d8$var$ht(r) {
    let s = setTimeout(r, 0), e = setTimeout(r, 10), u = setTimeout(r, 50);
    return [
        s,
        e,
        u
    ];
}
function $0b4ffad7aef772d8$var$_t(r) {
    let s = $7PdBe.useRef();
    return $7PdBe.useEffect(()=>{
        s.current = r;
    }), s.current;
}
var $0b4ffad7aef772d8$var$Ot = 18, $0b4ffad7aef772d8$var$wt = 40, $0b4ffad7aef772d8$var$Gt = `${$0b4ffad7aef772d8$var$wt}px`, $0b4ffad7aef772d8$var$xt = [
    "[data-lastpass-icon-root]",
    "com-1password-button",
    "[data-dashlanecreated]",
    '[style$="2147483647 !important;"]'
].join(",");
function $0b4ffad7aef772d8$var$Tt({ containerRef: r, inputRef: s, pushPasswordManagerStrategy: e, isFocused: u }) {
    let [P, D] = $7PdBe.useState(!1), [G, H] = $7PdBe.useState(!1), [F, W] = $7PdBe.useState(!1), Z = $7PdBe.useMemo(()=>e === "none" ? !1 : (e === "increase-width" || e === "experimental-no-flickering") && P && G, [
        P,
        G,
        e
    ]), T = $7PdBe.useCallback(()=>{
        let f = r.current, h = s.current;
        if (!f || !h || F || e === "none") return;
        let a = f, B = a.getBoundingClientRect().left + a.offsetWidth, A = a.getBoundingClientRect().top + a.offsetHeight / 2, z = B - $0b4ffad7aef772d8$var$Ot, q = A;
        document.querySelectorAll($0b4ffad7aef772d8$var$xt).length === 0 && document.elementFromPoint(z, q) === f || (D(!0), W(!0));
    }, [
        r,
        s,
        F,
        e
    ]);
    return $7PdBe.useEffect(()=>{
        let f = r.current;
        if (!f || e === "none") return;
        function h() {
            let A = window.innerWidth - f.getBoundingClientRect().right;
            H(A >= $0b4ffad7aef772d8$var$wt);
        }
        h();
        let a = setInterval(h, 1e3);
        return ()=>{
            clearInterval(a);
        };
    }, [
        r,
        e
    ]), $7PdBe.useEffect(()=>{
        let f = u || document.activeElement === s.current;
        if (e === "none" || !f) return;
        let h = setTimeout(T, 0), a = setTimeout(T, 2e3), B = setTimeout(T, 5e3), A = setTimeout(()=>{
            W(!0);
        }, 6e3);
        return ()=>{
            clearTimeout(h), clearTimeout(a), clearTimeout(B), clearTimeout(A);
        };
    }, [
        s,
        u,
        e,
        T
    ]), {
        hasPWMBadge: P,
        willPushPWMBadge: Z,
        PWM_BADGE_SPACE_WIDTH: $0b4ffad7aef772d8$var$Gt
    };
}
var $0b4ffad7aef772d8$export$8507feb4f97f5eac = $7PdBe.createContext({}), $0b4ffad7aef772d8$export$b3e9284b45af84ba = $7PdBe.forwardRef((A, B)=>{
    var z = A, { value: r, onChange: s, maxLength: e, textAlign: u = "left", pattern: P, placeholder: D, inputMode: G = "numeric", onComplete: H, pushPasswordManagerStrategy: F = "increase-width", pasteTransformer: W, containerClassName: Z, noScriptCSSFallback: T = $0b4ffad7aef772d8$var$Nt, render: f, children: h } = z, a = $0b4ffad7aef772d8$var$Pt(z, [
        "value",
        "onChange",
        "maxLength",
        "textAlign",
        "pattern",
        "placeholder",
        "inputMode",
        "onComplete",
        "pushPasswordManagerStrategy",
        "pasteTransformer",
        "containerClassName",
        "noScriptCSSFallback",
        "render",
        "children"
    ]);
    var X, lt, ut, dt, ft;
    let [q, nt] = $7PdBe.useState(typeof a.defaultValue == "string" ? a.defaultValue : ""), i = r != null ? r : q, I = $0b4ffad7aef772d8$var$_t(i), x = $7PdBe.useCallback((t)=>{
        s == null || s(t), nt(t);
    }, [
        s
    ]), m = $7PdBe.useMemo(()=>P ? typeof P == "string" ? new RegExp(P) : P : null, [
        P
    ]), l = $7PdBe.useRef(null), K = $7PdBe.useRef(null), J = $7PdBe.useRef({
        value: i,
        onChange: x,
        isIOS: typeof window != "undefined" && ((lt = (X = window == null ? void 0 : window.CSS) == null ? void 0 : X.supports) == null ? void 0 : lt.call(X, "-webkit-touch-callout", "none"))
    }), V = $7PdBe.useRef({
        prev: [
            (ut = l.current) == null ? void 0 : ut.selectionStart,
            (dt = l.current) == null ? void 0 : dt.selectionEnd,
            (ft = l.current) == null ? void 0 : ft.selectionDirection
        ]
    });
    $7PdBe.useImperativeHandle(B, ()=>l.current, []), $7PdBe.useEffect(()=>{
        let t = l.current, o = K.current;
        if (!t || !o) return;
        J.current.value !== t.value && J.current.onChange(t.value), V.current.prev = [
            t.selectionStart,
            t.selectionEnd,
            t.selectionDirection
        ];
        function d() {
            if (document.activeElement !== t) {
                L(null), N(null);
                return;
            }
            let c = t.selectionStart, b = t.selectionEnd, mt = t.selectionDirection, v = t.maxLength, C = t.value, _ = V.current.prev, g = -1, E = -1, w;
            if (C.length !== 0 && c !== null && b !== null) {
                let Dt = c === b, Ht = c === C.length && C.length < v;
                if (Dt && !Ht) {
                    let y = c;
                    if (y === 0) g = 0, E = 1, w = "forward";
                    else if (y === v) g = y - 1, E = y, w = "backward";
                    else if (v > 1 && C.length > 1) {
                        let et = 0;
                        if (_[0] !== null && _[1] !== null) {
                            w = y < _[1] ? "backward" : "forward";
                            let Wt = _[0] === _[1] && _[0] < v;
                            w === "backward" && !Wt && (et = -1);
                        }
                        g = et + y, E = et + y + 1;
                    }
                }
                g !== -1 && E !== -1 && g !== E && l.current.setSelectionRange(g, E, w);
            }
            let pt = g !== -1 ? g : c, Rt = E !== -1 ? E : b, yt = w != null ? w : mt;
            L(pt), N(Rt), V.current.prev = [
                pt,
                Rt,
                yt
            ];
        }
        if (document.addEventListener("selectionchange", d, {
            capture: !0
        }), d(), document.activeElement === t && Q(!0), !document.getElementById("input-otp-style")) {
            let c = document.createElement("style");
            if (c.id = "input-otp-style", document.head.appendChild(c), c.sheet) {
                let b = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
                $0b4ffad7aef772d8$var$$(c.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), $0b4ffad7aef772d8$var$$(c.sheet, `[data-input-otp]:autofill { ${b} }`), $0b4ffad7aef772d8$var$$(c.sheet, `[data-input-otp]:-webkit-autofill { ${b} }`), $0b4ffad7aef772d8$var$$(c.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), $0b4ffad7aef772d8$var$$(c.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
            }
        }
        let R = ()=>{
            o && o.style.setProperty("--root-height", `${t.clientHeight}px`);
        };
        R();
        let p = new ResizeObserver(R);
        return p.observe(t), ()=>{
            document.removeEventListener("selectionchange", d, {
                capture: !0
            }), p.disconnect();
        };
    }, []);
    let [ot, rt] = $7PdBe.useState(!1), [j, Q] = $7PdBe.useState(!1), [M, L] = $7PdBe.useState(null), [k, N] = $7PdBe.useState(null);
    $7PdBe.useEffect(()=>{
        $0b4ffad7aef772d8$var$ht(()=>{
            var R, p, c, b;
            (R = l.current) == null || R.dispatchEvent(new Event("input"));
            let t = (p = l.current) == null ? void 0 : p.selectionStart, o = (c = l.current) == null ? void 0 : c.selectionEnd, d = (b = l.current) == null ? void 0 : b.selectionDirection;
            t !== null && o !== null && (L(t), N(o), V.current.prev = [
                t,
                o,
                d
            ]);
        });
    }, [
        i,
        j
    ]), $7PdBe.useEffect(()=>{
        I !== void 0 && i !== I && I.length < e && i.length === e && (H == null || H(i));
    }, [
        e,
        H,
        I,
        i
    ]);
    let O = $0b4ffad7aef772d8$var$Tt({
        containerRef: K,
        inputRef: l,
        pushPasswordManagerStrategy: F,
        isFocused: j
    }), st = $7PdBe.useCallback((t)=>{
        let o = t.currentTarget.value.slice(0, e);
        if (o.length > 0 && m && !m.test(o)) {
            t.preventDefault();
            return;
        }
        typeof I == "string" && o.length < I.length && document.dispatchEvent(new Event("selectionchange")), x(o);
    }, [
        e,
        x,
        I,
        m
    ]), at = $7PdBe.useCallback(()=>{
        var t;
        if (l.current) {
            let o = Math.min(l.current.value.length, e - 1), d = l.current.value.length;
            (t = l.current) == null || t.setSelectionRange(o, d), L(o), N(d);
        }
        Q(!0);
    }, [
        e
    ]), ct = $7PdBe.useCallback((t)=>{
        var g, E;
        let o = l.current;
        if (!W && (!J.current.isIOS || !t.clipboardData || !o)) return;
        let d = t.clipboardData.getData("text/plain"), R = W ? W(d) : d;
        t.preventDefault();
        let p = (g = l.current) == null ? void 0 : g.selectionStart, c = (E = l.current) == null ? void 0 : E.selectionEnd, v = (p !== c ? i.slice(0, p) + R + i.slice(c) : i.slice(0, p) + R + i.slice(p)).slice(0, e);
        if (v.length > 0 && m && !m.test(v)) return;
        o.value = v, x(v);
        let C = Math.min(v.length, e - 1), _ = v.length;
        o.setSelectionRange(C, _), L(C), N(_);
    }, [
        e,
        x,
        m,
        i
    ]), It = $7PdBe.useMemo(()=>({
            position: "relative",
            cursor: a.disabled ? "default" : "text",
            userSelect: "none",
            WebkitUserSelect: "none",
            pointerEvents: "none"
        }), [
        a.disabled
    ]), it = $7PdBe.useMemo(()=>({
            position: "absolute",
            inset: 0,
            width: O.willPushPWMBadge ? `calc(100% + ${O.PWM_BADGE_SPACE_WIDTH})` : "100%",
            clipPath: O.willPushPWMBadge ? `inset(0 ${O.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0,
            height: "100%",
            display: "flex",
            textAlign: u,
            opacity: "1",
            color: "transparent",
            pointerEvents: "all",
            background: "transparent",
            caretColor: "transparent",
            border: "0 solid transparent",
            outline: "0 solid transparent",
            boxShadow: "none",
            lineHeight: "1",
            letterSpacing: "-.5em",
            fontSize: "var(--root-height)",
            fontFamily: "monospace",
            fontVariantNumeric: "tabular-nums"
        }), [
        O.PWM_BADGE_SPACE_WIDTH,
        O.willPushPWMBadge,
        u
    ]), Mt = $7PdBe.useMemo(()=>$7PdBe.createElement("input", $0b4ffad7aef772d8$var$bt($0b4ffad7aef772d8$var$St({
            autoComplete: a.autoComplete || "one-time-code"
        }, a), {
            "data-input-otp": !0,
            "data-input-otp-placeholder-shown": i.length === 0 || void 0,
            "data-input-otp-mss": M,
            "data-input-otp-mse": k,
            inputMode: G,
            pattern: m == null ? void 0 : m.source,
            "aria-placeholder": D,
            style: it,
            maxLength: e,
            value: i,
            ref: l,
            onPaste: (t)=>{
                var o;
                ct(t), (o = a.onPaste) == null || o.call(a, t);
            },
            onChange: st,
            onMouseOver: (t)=>{
                var o;
                rt(!0), (o = a.onMouseOver) == null || o.call(a, t);
            },
            onMouseLeave: (t)=>{
                var o;
                rt(!1), (o = a.onMouseLeave) == null || o.call(a, t);
            },
            onFocus: (t)=>{
                var o;
                at(), (o = a.onFocus) == null || o.call(a, t);
            },
            onBlur: (t)=>{
                var o;
                Q(!1), (o = a.onBlur) == null || o.call(a, t);
            }
        })), [
        st,
        at,
        ct,
        G,
        it,
        e,
        k,
        M,
        a,
        m == null ? void 0 : m.source,
        i
    ]), tt = $7PdBe.useMemo(()=>({
            slots: Array.from({
                length: e
            }).map((t, o)=>{
                var c;
                let d = j && M !== null && k !== null && (M === k && o === M || o >= M && o < k), R = i[o] !== void 0 ? i[o] : null, p = i[0] !== void 0 ? null : (c = D == null ? void 0 : D[o]) != null ? c : null;
                return {
                    char: R,
                    placeholderChar: p,
                    isActive: d,
                    hasFakeCaret: d && R === null
                };
            }),
            isFocused: j,
            isHovering: !a.disabled && ot
        }), [
        j,
        ot,
        e,
        k,
        M,
        a.disabled,
        i
    ]), Ct = $7PdBe.useMemo(()=>f ? f(tt) : $7PdBe.createElement($0b4ffad7aef772d8$export$8507feb4f97f5eac.Provider, {
            value: tt
        }, h), [
        h,
        tt,
        f
    ]);
    return $7PdBe.createElement($7PdBe.Fragment, null, T !== null && $7PdBe.createElement("noscript", null, $7PdBe.createElement("style", null, T)), $7PdBe.createElement("div", {
        ref: K,
        "data-input-otp-container": !0,
        style: It,
        className: Z
    }, Ct, $7PdBe.createElement("div", {
        style: {
            position: "absolute",
            inset: 0,
            pointerEvents: "none"
        }
    }, Mt)));
});
$0b4ffad7aef772d8$export$b3e9284b45af84ba.displayName = "Input";
function $0b4ffad7aef772d8$var$$(r, s) {
    try {
        r.insertRule(s);
    } catch (e) {
        console.error("input-otp could not insert CSS rule:", s);
    }
}
var $0b4ffad7aef772d8$var$Nt = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`;
var $0b4ffad7aef772d8$export$ca0331751de28cef = "^\\d+$", $0b4ffad7aef772d8$export$ea0f6489324fa3f5 = "^[a-zA-Z]+$", $0b4ffad7aef772d8$export$7178bcff264f2b6b = "^[a-zA-Z0-9]+$";



var $b6d686f7eba6ba3e$exports = {};
function $b6d686f7eba6ba3e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$b6d686f7eba6ba3e$exports = $b6d686f7eba6ba3e$var$_assertThisInitialized, $b6d686f7eba6ba3e$exports.__esModule = true, $b6d686f7eba6ba3e$exports["default"] = $b6d686f7eba6ba3e$exports;


var $c66195df0bbcf9ec$exports = {};
var $7a6f62141ba08acd$exports = {};
function $7a6f62141ba08acd$var$_setPrototypeOf(t, e) {
    return $7a6f62141ba08acd$exports = $7a6f62141ba08acd$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7a6f62141ba08acd$exports.__esModule = true, $7a6f62141ba08acd$exports["default"] = $7a6f62141ba08acd$exports, $7a6f62141ba08acd$var$_setPrototypeOf(t, e);
}
$7a6f62141ba08acd$exports = $7a6f62141ba08acd$var$_setPrototypeOf, $7a6f62141ba08acd$exports.__esModule = true, $7a6f62141ba08acd$exports["default"] = $7a6f62141ba08acd$exports;


function $c66195df0bbcf9ec$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $7a6f62141ba08acd$exports(t, o);
}
$c66195df0bbcf9ec$exports = $c66195df0bbcf9ec$var$_inheritsLoose, $c66195df0bbcf9ec$exports.__esModule = true, $c66195df0bbcf9ec$exports["default"] = $c66195df0bbcf9ec$exports;



var $7PdBe = parcelRequire("7PdBe");
var $49cc68baa5357f91$var$K = Object.defineProperty, $49cc68baa5357f91$var$Y = Object.defineProperties;
var $49cc68baa5357f91$var$V = Object.getOwnPropertyDescriptors;
var $49cc68baa5357f91$var$y = Object.getOwnPropertySymbols;
var $49cc68baa5357f91$var$P = Object.prototype.hasOwnProperty, $49cc68baa5357f91$var$D = Object.prototype.propertyIsEnumerable;
var $49cc68baa5357f91$var$I = (t, e, r)=>e in t ? $49cc68baa5357f91$var$K(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $49cc68baa5357f91$var$d = (t, e)=>{
    for(var r in e || (e = {}))$49cc68baa5357f91$var$P.call(e, r) && $49cc68baa5357f91$var$I(t, r, e[r]);
    if ($49cc68baa5357f91$var$y) for (var r of $49cc68baa5357f91$var$y(e))$49cc68baa5357f91$var$D.call(e, r) && $49cc68baa5357f91$var$I(t, r, e[r]);
    return t;
}, $49cc68baa5357f91$var$O = (t, e)=>$49cc68baa5357f91$var$Y(t, $49cc68baa5357f91$var$V(e));
var $49cc68baa5357f91$var$M = (t, e)=>{
    var r = {};
    for(var n in t)$49cc68baa5357f91$var$P.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
    if (t != null && $49cc68baa5357f91$var$y) for (var n of $49cc68baa5357f91$var$y(t))e.indexOf(n) < 0 && $49cc68baa5357f91$var$D.call(t, n) && (r[n] = t[n]);
    return r;
};
var $49cc68baa5357f91$var$l = (t, e, r)=>($49cc68baa5357f91$var$I(t, typeof e != "symbol" ? e + "" : e, r), r);
var $49cc68baa5357f91$var$x = (t, e, r)=>new Promise((n, s)=>{
        var a = (c)=>{
            try {
                o(r.next(c));
            } catch (i) {
                s(i);
            }
        }, u = (c)=>{
            try {
                o(r.throw(c));
            } catch (i) {
                s(i);
            }
        }, o = (c)=>c.done ? n(c.value) : Promise.resolve(c.value).then(a, u);
        o((r = r.apply(t, e)).next());
    });
var $49cc68baa5357f91$var$L = "hCaptcha-script", $49cc68baa5357f91$var$b = "hCaptchaOnLoad", $49cc68baa5357f91$var$_ = "script-error";
var $49cc68baa5357f91$var$g = "@hCaptcha/loader";
function $49cc68baa5357f91$var$U(t) {
    return Object.entries(t).filter(([, e])=>e || e === !1).map(([e, r])=>`${encodeURIComponent(e)}=${encodeURIComponent(String(r))}`).join("&");
}
function $49cc68baa5357f91$var$R(t) {
    let e = t && t.ownerDocument || document, r = e.defaultView || e.parentWindow || window;
    return {
        document: e,
        window: r
    };
}
function $49cc68baa5357f91$var$S(t) {
    return t || document.head;
}
function $49cc68baa5357f91$var$F(t) {
    var e;
    t.setTag("source", $49cc68baa5357f91$var$g), t.setTag("url", document.URL), t.setContext("os", {
        UA: navigator.userAgent
    }), t.setContext("browser", $49cc68baa5357f91$var$d({}, $49cc68baa5357f91$var$z())), t.setContext("device", $49cc68baa5357f91$var$O($49cc68baa5357f91$var$d({}, $49cc68baa5357f91$var$J()), {
        screen_width_pixels: screen.width,
        screen_height_pixels: screen.height,
        language: navigator.language,
        orientation: ((e = screen.orientation) == null ? void 0 : e.type) || "Unknown",
        processor_count: navigator.hardwareConcurrency,
        platform: navigator.platform
    }));
}
function $49cc68baa5357f91$var$z() {
    var n, s, a, u, o, c;
    let t = navigator.userAgent, e, r;
    return t.indexOf("Firefox") !== -1 ? (e = "Firefox", r = (n = t.match(/Firefox\/([\d.]+)/)) == null ? void 0 : n[1]) : t.indexOf("Edg") !== -1 ? (e = "Microsoft Edge", r = (s = t.match(/Edg\/([\d.]+)/)) == null ? void 0 : s[1]) : t.indexOf("Chrome") !== -1 && t.indexOf("Safari") !== -1 ? (e = "Chrome", r = (a = t.match(/Chrome\/([\d.]+)/)) == null ? void 0 : a[1]) : t.indexOf("Safari") !== -1 && t.indexOf("Chrome") === -1 ? (e = "Safari", r = (u = t.match(/Version\/([\d.]+)/)) == null ? void 0 : u[1]) : t.indexOf("Opera") !== -1 || t.indexOf("OPR") !== -1 ? (e = "Opera", r = (o = t.match(/(Opera|OPR)\/([\d.]+)/)) == null ? void 0 : o[2]) : t.indexOf("MSIE") !== -1 || t.indexOf("Trident") !== -1 ? (e = "Internet Explorer", r = (c = t.match(/(MSIE |rv:)([\d.]+)/)) == null ? void 0 : c[2]) : (e = "Unknown", r = "Unknown"), {
        name: e,
        version: r
    };
}
function $49cc68baa5357f91$var$J() {
    let t = navigator.userAgent, e;
    t.indexOf("Win") !== -1 ? e = "Windows" : t.indexOf("Mac") !== -1 ? e = "Mac" : t.indexOf("Linux") !== -1 ? e = "Linux" : t.indexOf("Android") !== -1 ? e = "Android" : t.indexOf("like Mac") !== -1 || t.indexOf("iPhone") !== -1 || t.indexOf("iPad") !== -1 ? e = "iOS" : e = "Unknown";
    let r;
    return /Mobile|iPhone|iPod|Android/i.test(t) ? r = "Mobile" : /Tablet|iPad/i.test(t) ? r = "Tablet" : r = "Desktop", {
        model: e,
        family: e,
        device: r
    };
}
var $49cc68baa5357f91$var$Q = class B {
    constructor(e){
        $49cc68baa5357f91$var$l(this, "_parent");
        $49cc68baa5357f91$var$l(this, "breadcrumbs", []);
        $49cc68baa5357f91$var$l(this, "context", {});
        $49cc68baa5357f91$var$l(this, "extra", {});
        $49cc68baa5357f91$var$l(this, "tags", {});
        $49cc68baa5357f91$var$l(this, "request");
        $49cc68baa5357f91$var$l(this, "user");
        this._parent = e;
    }
    get parent() {
        return this._parent;
    }
    child() {
        return new B(this);
    }
    setRequest(e) {
        return this.request = e, this;
    }
    removeRequest() {
        return this.request = void 0, this;
    }
    addBreadcrumb(e) {
        return typeof e.timestamp > "u" && (e.timestamp = new Date().toISOString()), this.breadcrumbs.push(e), this;
    }
    setExtra(e, r) {
        return this.extra[e] = r, this;
    }
    removeExtra(e) {
        return delete this.extra[e], this;
    }
    setContext(e, r) {
        return typeof r.type > "u" && (r.type = e), this.context[e] = r, this;
    }
    removeContext(e) {
        return delete this.context[e], this;
    }
    setTags(e) {
        return this.tags = $49cc68baa5357f91$var$d($49cc68baa5357f91$var$d({}, this.tags), e), this;
    }
    setTag(e, r) {
        return this.tags[e] = r, this;
    }
    removeTag(e) {
        return delete this.tags[e], this;
    }
    setUser(e) {
        return this.user = e, this;
    }
    removeUser() {
        return this.user = void 0, this;
    }
    toBody() {
        let e = [], r = this;
        for(; r;)e.push(r), r = r.parent;
        return e.reverse().reduce((n, s)=>{
            var a;
            return n.breadcrumbs = [
                ...(a = n.breadcrumbs) != null ? a : [],
                ...s.breadcrumbs
            ], n.extra = $49cc68baa5357f91$var$d($49cc68baa5357f91$var$d({}, n.extra), s.extra), n.contexts = $49cc68baa5357f91$var$d($49cc68baa5357f91$var$d({}, n.contexts), s.context), n.tags = $49cc68baa5357f91$var$d($49cc68baa5357f91$var$d({}, n.tags), s.tags), s.user && (n.user = s.user), s.request && (n.request = s.request), n;
        }, {
            breadcrumbs: [],
            extra: {},
            contexts: {},
            tags: {},
            request: void 0,
            user: void 0
        });
    }
    clear() {
        this.breadcrumbs = [], this.context = {}, this.tags = {}, this.user = void 0;
    }
}, $49cc68baa5357f91$var$Z = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $49cc68baa5357f91$var$ee = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i, $49cc68baa5357f91$var$te = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, $49cc68baa5357f91$var$re = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/, $49cc68baa5357f91$var$N = "?", $49cc68baa5357f91$var$k = "An unknown error occurred", $49cc68baa5357f91$var$ne = "0.0.4";
function $49cc68baa5357f91$var$se(t) {
    for(let e = 0; e < t.length; e++)t[e] = Math.floor(Math.random() * 256);
    return t;
}
function $49cc68baa5357f91$var$p(t) {
    return (t + 256).toString(16).substring(1);
}
function $49cc68baa5357f91$var$oe() {
    let t = $49cc68baa5357f91$var$se(new Array(16));
    return t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, $49cc68baa5357f91$var$p(t[0]) + $49cc68baa5357f91$var$p(t[1]) + $49cc68baa5357f91$var$p(t[2]) + $49cc68baa5357f91$var$p(t[3]) + "-" + $49cc68baa5357f91$var$p(t[4]) + $49cc68baa5357f91$var$p(t[5]) + "-" + $49cc68baa5357f91$var$p(t[6]) + $49cc68baa5357f91$var$p(t[7]) + "-" + $49cc68baa5357f91$var$p(t[8]) + $49cc68baa5357f91$var$p(t[9]) + "-" + $49cc68baa5357f91$var$p(t[10]) + $49cc68baa5357f91$var$p(t[11]) + $49cc68baa5357f91$var$p(t[12]) + $49cc68baa5357f91$var$p(t[13]) + $49cc68baa5357f91$var$p(t[14]) + $49cc68baa5357f91$var$p(t[15]);
}
var $49cc68baa5357f91$var$ie = [
    [
        $49cc68baa5357f91$var$Z,
        "chrome"
    ],
    [
        $49cc68baa5357f91$var$te,
        "winjs"
    ],
    [
        $49cc68baa5357f91$var$ee,
        "gecko"
    ]
];
function $49cc68baa5357f91$var$ae(t) {
    var n, s, a, u;
    if (!t.stack) return null;
    let e = [], r = (a = (s = (n = t.stack).split) == null ? void 0 : s.call(n, `
`)) != null ? a : [];
    for(let o = 0; o < r.length; ++o){
        let c = null, i = null, f = null;
        for (let [v, w] of $49cc68baa5357f91$var$ie)if (i = v.exec(r[o]), i) {
            f = w;
            break;
        }
        if (!(!i || !f)) {
            if (f === "chrome") c = {
                filename: (u = i[2]) != null && u.startsWith("address at ") ? i[2].substring(11) : i[2],
                function: i[1] || $49cc68baa5357f91$var$N,
                lineno: i[3] ? +i[3] : null,
                colno: i[4] ? +i[4] : null
            };
            else if (f === "winjs") c = {
                filename: i[2],
                function: i[1] || $49cc68baa5357f91$var$N,
                lineno: +i[3],
                colno: i[4] ? +i[4] : null
            };
            else if (f === "gecko") o === 0 && !i[5] && t.columnNumber !== void 0 && e.length > 0 && (e[0].column = t.columnNumber + 1), c = {
                filename: i[3],
                function: i[1] || $49cc68baa5357f91$var$N,
                lineno: i[4] ? +i[4] : null,
                colno: i[5] ? +i[5] : null
            };
            else continue;
            !c.function && c.lineno && (c.function = $49cc68baa5357f91$var$N), e.push(c);
        }
    }
    return e.length ? e.reverse() : null;
}
function $49cc68baa5357f91$var$ce(t) {
    let e = $49cc68baa5357f91$var$ae(t);
    return {
        type: t.name,
        value: t.message,
        stacktrace: {
            frames: e != null ? e : []
        }
    };
}
function $49cc68baa5357f91$var$ue(t) {
    let e = $49cc68baa5357f91$var$re.exec(t), r = e ? e.slice(1) : [];
    if (r.length !== 6) throw new Error("Invalid DSN");
    let n = r[5].split("/"), s = n.slice(0, -1).join("/");
    return r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (s ? "/" + s : "") + "/api/" + n.pop() + "/envelope/?sentry_version=7&sentry_key=" + r[1] + (r[2] ? "&sentry_secret=" + r[2] : "");
}
function $49cc68baa5357f91$var$le(t, e, r) {
    var s, a;
    let n = $49cc68baa5357f91$var$d({
        event_id: $49cc68baa5357f91$var$oe().replaceAll("-", ""),
        platform: "javascript",
        sdk: {
            name: "@hcaptcha/sentry",
            version: $49cc68baa5357f91$var$ne
        },
        environment: e,
        release: r,
        timestamp: Date.now() / 1e3
    }, t.scope.toBody());
    if (t.type === "exception") {
        n.message = (a = (s = t.error) == null ? void 0 : s.message) != null ? a : "Unknown error", n.fingerprint = [
            n.message
        ];
        let u = [], o = t.error;
        for(let c = 0; c < 5 && o && (u.push($49cc68baa5357f91$var$ce(o)), !(!o.cause || !(o.cause instanceof Error))); c++)o = o.cause;
        n.exception = {
            values: u.reverse()
        };
    }
    return t.type === "message" && (n.message = t.message, n.level = t.level), n;
}
function $49cc68baa5357f91$var$de(t) {
    if (t instanceof Error) return t;
    if (typeof t == "string") return new Error(t);
    if (typeof t == "object" && t !== null && !Array.isArray(t)) {
        let r = t, { message: n } = r, s = $49cc68baa5357f91$var$M(r, [
            "message"
        ]), a = new Error(typeof n == "string" ? n : $49cc68baa5357f91$var$k);
        return Object.assign(a, s);
    }
    let e = new Error($49cc68baa5357f91$var$k);
    return Object.assign(e, {
        cause: t
    });
}
function $49cc68baa5357f91$var$pe(t, e, r) {
    return $49cc68baa5357f91$var$x(this, null, function*() {
        var n, s;
        try {
            if (typeof fetch < "u" && typeof AbortSignal < "u") {
                let a;
                if (r) {
                    let c = new AbortController;
                    a = c.signal, setTimeout(()=>c.abort(), r);
                }
                let u = yield fetch(t, $49cc68baa5357f91$var$O($49cc68baa5357f91$var$d({}, e), {
                    signal: a
                })), o = yield u.text();
                return {
                    status: u.status,
                    body: o
                };
            }
            return yield new Promise((a, u)=>{
                var c, i;
                let o = new XMLHttpRequest;
                if (o.open((c = e == null ? void 0 : e.method) != null ? c : "GET", t), o.onload = ()=>a({
                        status: o.status,
                        body: o.responseText
                    }), o.onerror = ()=>u(new Error("XHR Network Error")), e == null ? void 0 : e.headers) for (let [f, v] of Object.entries(e.headers))o.setRequestHeader(f, v);
                if (r) {
                    let f = setTimeout(()=>{
                        o.abort(), u(new Error("Request timed out"));
                    }, r);
                    o.onloadend = ()=>{
                        clearTimeout(f);
                    };
                }
                o.send((i = e == null ? void 0 : e.body) == null ? void 0 : i.toString());
            });
        } catch (a) {
            return {
                status: 0,
                body: (s = (n = a == null ? void 0 : a.toString) == null ? void 0 : n.call(a)) != null ? s : "Unknown error"
            };
        }
    });
}
var $49cc68baa5357f91$var$h, $49cc68baa5357f91$var$A = ($49cc68baa5357f91$var$h = class {
    constructor(e){
        $49cc68baa5357f91$var$l(this, "apiURL");
        $49cc68baa5357f91$var$l(this, "dsn");
        $49cc68baa5357f91$var$l(this, "environment");
        $49cc68baa5357f91$var$l(this, "release");
        $49cc68baa5357f91$var$l(this, "sampleRate");
        $49cc68baa5357f91$var$l(this, "debug");
        $49cc68baa5357f91$var$l(this, "_scope");
        $49cc68baa5357f91$var$l(this, "shouldBuffer", !1);
        $49cc68baa5357f91$var$l(this, "bufferlimit", 20);
        $49cc68baa5357f91$var$l(this, "buffer", []);
        var r, n, s, a, u;
        this.environment = e.environment, this.release = e.release, this.sampleRate = (r = e.sampleRate) != null ? r : 1, this.debug = (n = e.debug) != null ? n : !1, this._scope = (s = e.scope) != null ? s : new $49cc68baa5357f91$var$Q, this.apiURL = $49cc68baa5357f91$var$ue(e.dsn), this.dsn = e.dsn, this.shouldBuffer = (a = e.buffer) != null ? a : !1, this.bufferlimit = (u = e.bufferLimit) != null ? u : 20;
    }
    static init(e) {
        $49cc68baa5357f91$var$h._instance || ($49cc68baa5357f91$var$h._instance = new $49cc68baa5357f91$var$h(e));
    }
    static get instance() {
        if (!$49cc68baa5357f91$var$h._instance) throw new Error("Sentry has not been initialized");
        return $49cc68baa5357f91$var$h._instance;
    }
    log(...e) {
        this.debug && console.log(...e);
    }
    get scope() {
        return this._scope;
    }
    static get scope() {
        return $49cc68baa5357f91$var$h.instance.scope;
    }
    withScope(e) {
        let r = this._scope.child();
        e(r);
    }
    static withScope(e) {
        $49cc68baa5357f91$var$h.instance.withScope(e);
    }
    captureException(e, r) {
        this.captureEvent({
            type: "exception",
            level: "error",
            error: $49cc68baa5357f91$var$de(e),
            scope: r != null ? r : this._scope
        });
    }
    static captureException(e, r) {
        $49cc68baa5357f91$var$h.instance.captureException(e, r);
    }
    captureMessage(e, r = "info", n) {
        this.captureEvent({
            type: "message",
            level: r,
            message: e,
            scope: n != null ? n : this._scope
        });
    }
    static captureMessage(e, r = "info", n) {
        $49cc68baa5357f91$var$h.instance.captureMessage(e, r, n);
    }
    captureEvent(e) {
        if (Math.random() >= this.sampleRate) {
            this.log("Dropped event due to sample rate");
            return;
        }
        if (this.shouldBuffer) {
            if (this.buffer.length >= this.bufferlimit) return;
            this.buffer.push(e);
        } else this.sendEvent(e);
    }
    sendEvent(e, r = 5e3) {
        return $49cc68baa5357f91$var$x(this, null, function*() {
            try {
                this.log("Sending sentry event", e);
                let n = $49cc68baa5357f91$var$le(e, this.environment, this.release), s = {
                    event_id: n.event_id,
                    dsn: this.dsn
                }, a = {
                    type: "event"
                }, u = JSON.stringify(s) + `
` + JSON.stringify(a) + `
` + JSON.stringify(n), o = yield $49cc68baa5357f91$var$pe(this.apiURL, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-sentry-envelope"
                    },
                    body: u
                }, r);
                this.log("Sentry response", o.status), o.status !== 200 && (console.log(o.body), console.error("Failed to send event to Sentry", o));
            } catch (n) {
                console.error("Failed to send event", n);
            }
        });
    }
    flush(e = 5e3) {
        return $49cc68baa5357f91$var$x(this, null, function*() {
            try {
                this.log("Flushing sentry events", this.buffer.length);
                let r = this.buffer.splice(0, this.buffer.length).map((n)=>this.sendEvent(n, e));
                yield Promise.all(r), this.log("Flushed all events");
            } catch (r) {
                console.error("Failed to flush events", r);
            }
        });
    }
    static flush(e = 5e3) {
        return $49cc68baa5357f91$var$h.instance.flush(e);
    }
    static reset() {
        $49cc68baa5357f91$var$h._instance = void 0;
    }
}, $49cc68baa5357f91$var$l($49cc68baa5357f91$var$h, "_instance"), $49cc68baa5357f91$var$h);
var $49cc68baa5357f91$var$he = "https://d233059272824702afc8c43834c4912d@sentry.hcaptcha.com/6", $49cc68baa5357f91$var$fe = "2.1.0", $49cc68baa5357f91$var$me = "production";
function $49cc68baa5357f91$var$j(t = !0) {
    if (!t) return $49cc68baa5357f91$var$q();
    $49cc68baa5357f91$var$A.init({
        dsn: $49cc68baa5357f91$var$he,
        release: $49cc68baa5357f91$var$fe,
        environment: $49cc68baa5357f91$var$me
    });
    let e = $49cc68baa5357f91$var$A.scope;
    return $49cc68baa5357f91$var$F(e), $49cc68baa5357f91$var$q(e);
}
function $49cc68baa5357f91$var$q(t = null) {
    return {
        addBreadcrumb: (e)=>{
            t && t.addBreadcrumb(e);
        },
        captureRequest: (e)=>{
            t && t.setRequest(e);
        },
        captureException: (e)=>{
            t && $49cc68baa5357f91$var$A.captureException(e, t);
        }
    };
}
function $49cc68baa5357f91$var$H({ scriptLocation: t, query: e, loadAsync: r = !0, crossOrigin: n = "anonymous", apihost: s = "https://js.hcaptcha.com", cleanup: a = !1, secureApi: u = !1, scriptSource: o = "" } = {}, c) {
    let i = $49cc68baa5357f91$var$S(t), f = $49cc68baa5357f91$var$R(i);
    return new Promise((v, w)=>{
        let m = f.document.createElement("script");
        m.id = $49cc68baa5357f91$var$L, o ? m.src = `${o}?onload=${$49cc68baa5357f91$var$b}` : u ? m.src = `${s}/1/secure-api.js?onload=${$49cc68baa5357f91$var$b}` : m.src = `${s}/1/api.js?onload=${$49cc68baa5357f91$var$b}`, m.crossOrigin = n, m.async = r;
        let T = (E, X)=>{
            try {
                !u && a && i.removeChild(m), X(E);
            } catch (G) {
                w(G);
            }
        };
        m.onload = (E)=>T(E, v), m.onerror = (E)=>{
            c && c(m.src), T(E, w);
        }, m.src += e !== "" ? `&${e}` : "", i.appendChild(m);
    });
}
var $49cc68baa5357f91$var$C = [];
function $49cc68baa5357f91$var$ge(t = {
    cleanup: !1
}, e) {
    try {
        e.addBreadcrumb({
            category: $49cc68baa5357f91$var$g,
            message: "hCaptcha loader params",
            data: t
        });
        let r = $49cc68baa5357f91$var$S(t.scriptLocation), n = $49cc68baa5357f91$var$R(r), s = $49cc68baa5357f91$var$C.find(({ scope: u })=>u === n.window);
        if (s) return e.addBreadcrumb({
            category: $49cc68baa5357f91$var$g,
            message: "hCaptcha already loaded"
        }), s.promise;
        let a = new Promise((u, o)=>$49cc68baa5357f91$var$x(this, null, function*() {
                try {
                    n.window[$49cc68baa5357f91$var$b] = ()=>{
                        e.addBreadcrumb({
                            category: $49cc68baa5357f91$var$g,
                            message: "hCaptcha script called onload function"
                        }), u(n.window.hcaptcha);
                    };
                    let c = $49cc68baa5357f91$var$U({
                        custom: t.custom,
                        render: t.render,
                        sentry: t.sentry,
                        assethost: t.assethost,
                        imghost: t.imghost,
                        reportapi: t.reportapi,
                        endpoint: t.endpoint,
                        host: t.host,
                        recaptchacompat: t.recaptchacompat,
                        hl: t.hl
                    });
                    yield $49cc68baa5357f91$var$H($49cc68baa5357f91$var$d({
                        query: c
                    }, t), (i)=>{
                        e.captureRequest({
                            url: i,
                            method: "GET"
                        });
                    }), e.addBreadcrumb({
                        category: $49cc68baa5357f91$var$g,
                        message: "hCaptcha loaded",
                        data: s
                    });
                } catch (c) {
                    e.addBreadcrumb({
                        category: $49cc68baa5357f91$var$g,
                        message: "hCaptcha failed to load"
                    });
                    let i = $49cc68baa5357f91$var$C.findIndex((f)=>f.scope === n.window);
                    i !== -1 && $49cc68baa5357f91$var$C.splice(i, 1), o(new Error($49cc68baa5357f91$var$_));
                }
            }));
        return $49cc68baa5357f91$var$C.push({
            promise: a,
            scope: n.window
        }), a;
    } catch (r) {
        return e.captureException(r), Promise.reject(new Error($49cc68baa5357f91$var$_));
    }
}
function $49cc68baa5357f91$var$$(t, e, r = 0) {
    return $49cc68baa5357f91$var$x(this, null, function*() {
        let n = r < 2 ? "Retry loading hCaptcha Api" : "Exceeded maximum retries";
        try {
            return yield $49cc68baa5357f91$var$ge(t, e);
        } catch (s) {
            return e.addBreadcrumb({
                category: $49cc68baa5357f91$var$g,
                message: n
            }), r >= 2 ? (e.captureException(s), Promise.reject(s)) : (r += 1, $49cc68baa5357f91$var$$(t, e, r));
        }
    });
}
function $49cc68baa5357f91$export$5b4338a936fac718() {
    return $49cc68baa5357f91$var$x(this, arguments, function*(t = {}) {
        let e = $49cc68baa5357f91$var$j(t.sentry);
        return yield $49cc68baa5357f91$var$$(t, e);
    });
}


function $52b75afc2acfc270$export$fd8d2ba2926cdfb6(element) {
    var doc = element && element.ownerDocument || document;
    var win = doc.defaultView || doc.parentWindow || window;
    return {
        document: doc,
        window: win
    };
}
function $52b75afc2acfc270$export$a939d66a5741a5ae(element) {
    return element || document.head;
}


var $4b7bd5be895d43d1$var$HCaptcha = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($c66195df0bbcf9ec$exports)))(HCaptcha, _React$Component);
    function HCaptcha(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        /**
     * Internal reference to track hCaptcha API
     *
     * Required as window is relative to initialization in application
     * not where the script and iFrames have been loaded.
     */ _this._hcaptcha = undefined;
        // API Methods
        _this.renderCaptcha = _this.renderCaptcha.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.resetCaptcha = _this.resetCaptcha.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.removeCaptcha = _this.removeCaptcha.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.isReady = _this.isReady.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this._onReady = null;
        // Event Handlers
        _this.loadCaptcha = _this.loadCaptcha.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.handleOnLoad = _this.handleOnLoad.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.handleSubmit = _this.handleSubmit.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.handleExpire = _this.handleExpire.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.handleError = _this.handleError.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.handleOpen = _this.handleOpen.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.handleClose = _this.handleClose.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.handleChallengeExpired = _this.handleChallengeExpired.bind((0, (/*@__PURE__*/$parcel$interopDefault($b6d686f7eba6ba3e$exports)))(_this));
        _this.ref = /*#__PURE__*/ $7PdBe.createRef();
        _this.apiScriptRequested = false;
        _this.sentryHub = null;
        _this.captchaId = "";
        _this.state = {
            isApiReady: false,
            isRemoved: false,
            elementId: props.id
        };
        return _this;
    }
    var _proto = HCaptcha.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        // Once captcha is mounted intialize hCaptcha - hCaptcha
        var element = (0, $52b75afc2acfc270$export$a939d66a5741a5ae)(this.props.scriptLocation);
        var frame = (0, $52b75afc2acfc270$export$fd8d2ba2926cdfb6)(element);
        this._hcaptcha = frame.window.hcaptcha || undefined;
        var isApiReady = typeof this._hcaptcha !== "undefined";
        /*
     * Check if hCaptcha has already been loaded,
     * If Yes, render the captcha
     * If No, create script tag and wait to render the captcha
     */ if (isApiReady) {
            this.setState({
                isApiReady: true
            }, function() {
                _this2.renderCaptcha();
            });
            return;
        }
        this.loadCaptcha();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        // Reset any stored variables / timers when unmounting
        hcaptcha.reset(captchaId);
        hcaptcha.remove(captchaId);
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        // Prevent component re-rendering when these internal state variables are updated
        if (this.state.isApiReady !== nextState.isApiReady || this.state.isRemoved !== nextState.isRemoved) return false;
        return true;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this3 = this;
        // Prop Keys that could change
        var keys = [
            "sitekey",
            "size",
            "theme",
            "tabindex",
            "languageOverride",
            "endpoint"
        ];
        // See if any props changed during component update
        var match = keys.every(function(key) {
            return prevProps[key] === _this3.props[key];
        });
        // If they have changed, remove current captcha and render a new one
        if (!match) this.removeCaptcha(function() {
            _this3.renderCaptcha();
        });
    };
    _proto.loadCaptcha = function loadCaptcha() {
        if (this.apiScriptRequested) return;
        var _this$props = this.props, apihost = _this$props.apihost, assethost = _this$props.assethost, endpoint = _this$props.endpoint, host = _this$props.host, imghost = _this$props.imghost, hl = _this$props.languageOverride, reCaptchaCompat = _this$props.reCaptchaCompat, reportapi = _this$props.reportapi, sentry = _this$props.sentry, custom = _this$props.custom, loadAsync = _this$props.loadAsync, scriptLocation = _this$props.scriptLocation, scriptSource = _this$props.scriptSource, secureApi = _this$props.secureApi, _this$props$cleanup = _this$props.cleanup, cleanup = _this$props$cleanup === void 0 ? true : _this$props$cleanup;
        var mountParams = {
            render: "explicit",
            apihost: apihost,
            assethost: assethost,
            endpoint: endpoint,
            hl: hl,
            host: host,
            imghost: imghost,
            recaptchacompat: reCaptchaCompat === false ? "off" : null,
            reportapi: reportapi,
            sentry: sentry,
            custom: custom,
            loadAsync: loadAsync,
            scriptLocation: scriptLocation,
            scriptSource: scriptSource,
            secureApi: secureApi,
            cleanup: cleanup
        };
        (0, $49cc68baa5357f91$export$5b4338a936fac718)(mountParams).then(this.handleOnLoad, this.handleError)["catch"](this.handleError);
        this.apiScriptRequested = true;
    };
    _proto.renderCaptcha = function renderCaptcha(onRender) {
        var _this4 = this;
        var onReady = this.props.onReady;
        var isApiReady = this.state.isApiReady;
        var captchaId = this.captchaId;
        // Prevent calling hCaptcha render on two conditions:
        // • API is not ready
        // • Component has already been mounted
        if (!isApiReady || captchaId) return;
        var renderParams = Object.assign({
            "open-callback": this.handleOpen,
            "close-callback": this.handleClose,
            "error-callback": this.handleError,
            "chalexpired-callback": this.handleChallengeExpired,
            "expired-callback": this.handleExpire,
            "callback": this.handleSubmit
        }, this.props, {
            hl: this.props.hl || this.props.languageOverride,
            languageOverride: undefined
        });
        var hcaptcha = this._hcaptcha;
        //Render hCaptcha widget and provide necessary callbacks - hCaptcha
        var id = hcaptcha.render(this.ref.current, renderParams);
        this.captchaId = id;
        this.setState({
            isRemoved: false
        }, function() {
            onRender && onRender();
            onReady && onReady();
            _this4._onReady && _this4._onReady(id);
        });
    };
    _proto.resetCaptcha = function resetCaptcha() {
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        // Reset captcha state, removes stored token and unticks checkbox
        hcaptcha.reset(captchaId);
    };
    _proto.removeCaptcha = function removeCaptcha(callback) {
        var _this5 = this;
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        this.setState({
            isRemoved: true
        }, function() {
            _this5.captchaId = "";
            hcaptcha.remove(captchaId);
            callback && callback();
        });
    };
    _proto.handleOnLoad = function handleOnLoad() {
        var _this6 = this;
        this.setState({
            isApiReady: true
        }, function() {
            var element = (0, $52b75afc2acfc270$export$a939d66a5741a5ae)(_this6.props.scriptLocation);
            var frame = (0, $52b75afc2acfc270$export$fd8d2ba2926cdfb6)(element);
            _this6._hcaptcha = frame.window.hcaptcha;
            // render captcha and wait for captcha id
            _this6.renderCaptcha(function() {
                // trigger onLoad if it exists
                var onLoad = _this6.props.onLoad;
                if (onLoad) onLoad();
            });
        });
    };
    _proto.handleSubmit = function handleSubmit(event) {
        var onVerify = this.props.onVerify;
        var isRemoved = this.state.isRemoved;
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (typeof hcaptcha === "undefined" || isRemoved) return;
        var token = hcaptcha.getResponse(captchaId); //Get response token from hCaptcha widget
        var ekey = hcaptcha.getRespKey(captchaId); //Get current challenge session id from hCaptcha widget
        if (onVerify) onVerify(token, ekey); //Dispatch event to verify user response
    };
    _proto.handleExpire = function handleExpire() {
        var onExpire = this.props.onExpire;
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        hcaptcha.reset(captchaId); // If hCaptcha runs into error, reset captcha - hCaptcha
        if (onExpire) onExpire();
    };
    _proto.handleError = function handleError(event) {
        var onError = this.props.onError;
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (this.isReady()) // If hCaptcha runs into error, reset captcha - hCaptcha
        hcaptcha.reset(captchaId);
        if (onError) onError(event);
    };
    _proto.isReady = function isReady() {
        var _this$state = this.state, isApiReady = _this$state.isApiReady, isRemoved = _this$state.isRemoved;
        return isApiReady && !isRemoved;
    };
    _proto.handleOpen = function handleOpen() {
        if (!this.isReady() || !this.props.onOpen) return;
        this.props.onOpen();
    };
    _proto.handleClose = function handleClose() {
        if (!this.isReady() || !this.props.onClose) return;
        this.props.onClose();
    };
    _proto.handleChallengeExpired = function handleChallengeExpired() {
        if (!this.isReady() || !this.props.onChalExpired) return;
        this.props.onChalExpired();
    };
    _proto.execute = function execute(opts) {
        var _this7 = this;
        if (opts === void 0) opts = null;
        opts = typeof opts === "object" ? opts : null;
        try {
            var hcaptcha = this._hcaptcha;
            var captchaId = this.captchaId;
            if (!this.isReady()) {
                var _opts;
                var onReady = new Promise(function(resolve, reject) {
                    _this7._onReady = function(id) {
                        try {
                            var _hcaptcha = _this7._hcaptcha;
                            if (opts && opts.async) _hcaptcha.execute(id, opts).then(resolve)["catch"](reject);
                            else resolve(_hcaptcha.execute(id, opts));
                        } catch (e) {
                            reject(e);
                        }
                    };
                });
                return (_opts = opts) != null && _opts.async ? onReady : null;
            }
            return hcaptcha.execute(captchaId, opts);
        } catch (error) {
            if (opts && opts.async) return Promise.reject(error);
            return null;
        }
    };
    _proto.close = function close() {
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        return hcaptcha.close(captchaId);
    };
    _proto.setData = function setData(data) {
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        if (data && typeof data !== "object") data = null;
        hcaptcha.setData(captchaId, data);
    };
    _proto.getResponse = function getResponse() {
        var hcaptcha = this._hcaptcha;
        return hcaptcha.getResponse(this.captchaId);
    };
    _proto.getRespKey = function getRespKey() {
        var hcaptcha = this._hcaptcha;
        return hcaptcha.getRespKey(this.captchaId);
    };
    _proto.render = function render() {
        var elementId = this.state.elementId;
        return /*#__PURE__*/ $7PdBe.createElement("div", {
            ref: this.ref,
            id: elementId
        });
    };
    return HCaptcha;
}($7PdBe.Component);
var $4b7bd5be895d43d1$export$2e2bcd8739ae039 = $4b7bd5be895d43d1$var$HCaptcha;



var $7PdBe = parcelRequire("7PdBe");

var $hvk62 = parcelRequire("hvk62");
"use client";
var $6cbd97fe76e000ef$var$ae = ({ as: n = "div", ...a }, s)=>(0, $hvk62.jsx)(n, {
        ...a,
        ref: s
    }), $6cbd97fe76e000ef$var$J = (0, $7PdBe.forwardRef)($6cbd97fe76e000ef$var$ae);
var $6cbd97fe76e000ef$export$f87af7f569aace70 = "https://challenges.cloudflare.com/turnstile/v0/api.js", $6cbd97fe76e000ef$export$2eea204f6220c925 = "cf-turnstile-script", $6cbd97fe76e000ef$export$2ce14c6f26d19d0f = "cf-turnstile", $6cbd97fe76e000ef$export$da1f91a396bc4872 = "onloadTurnstileCallback", $6cbd97fe76e000ef$var$M = (n)=>!!document.getElementById(n), $6cbd97fe76e000ef$var$X = ({ render: n = "explicit", onLoadCallbackName: a = $6cbd97fe76e000ef$export$da1f91a396bc4872, scriptOptions: { nonce: s = "", defer: e = !0, async: m = !0, id: v = "", appendTo: g, onError: T, crossOrigin: w = "" } = {} })=>{
    let E = v || $6cbd97fe76e000ef$export$2eea204f6220c925;
    if ($6cbd97fe76e000ef$var$M(E)) return;
    let i = document.createElement("script");
    if (i.id = E, i.src = `${$6cbd97fe76e000ef$export$f87af7f569aace70}?onload=${a}&render=${n}`, document.querySelector(`script[src="${i.src}"]`)) return;
    i.defer = !!e, i.async = !!m, s && (i.nonce = s), w && (i.crossOrigin = w), T && (i.onerror = T, delete window[a]), (g === "body" ? document.body : document.getElementsByTagName("head")[0]).appendChild(i);
}, $6cbd97fe76e000ef$var$f = {
    normal: {
        width: 300,
        height: 65
    },
    compact: {
        width: 150,
        height: 140
    },
    invisible: {
        width: 0,
        height: 0,
        overflow: "hidden"
    },
    flexible: {
        minWidth: 300,
        width: "100%",
        height: 65
    },
    interactionOnly: {
        width: "fit-content",
        height: "auto",
        display: "flex"
    }
};
function $6cbd97fe76e000ef$var$G(n) {
    if (n !== "invisible" && n !== "interactionOnly") return n;
}
function $6cbd97fe76e000ef$var$z(n = $6cbd97fe76e000ef$export$2eea204f6220c925) {
    let [a, s] = (0, $7PdBe.useState)(!1);
    return (0, $7PdBe.useEffect)(()=>{
        let e = ()=>{
            $6cbd97fe76e000ef$var$M(n) && s(!0);
        }, m = new MutationObserver(e);
        return m.observe(document, {
            childList: !0,
            subtree: !0
        }), e(), ()=>{
            m.disconnect();
        };
    }, [
        n
    ]), a;
}
var $6cbd97fe76e000ef$var$_ = "unloaded", $6cbd97fe76e000ef$var$ee, $6cbd97fe76e000ef$var$Te = new Promise((n, a)=>{
    $6cbd97fe76e000ef$var$ee = {
        resolve: n,
        reject: a
    }, $6cbd97fe76e000ef$var$_ === "ready" && n(void 0);
}), $6cbd97fe76e000ef$var$we = (n = $6cbd97fe76e000ef$export$da1f91a396bc4872)=>($6cbd97fe76e000ef$var$_ === "unloaded" && ($6cbd97fe76e000ef$var$_ = "loading", window[n] = ()=>{
        $6cbd97fe76e000ef$var$ee.resolve(), $6cbd97fe76e000ef$var$_ = "ready", delete window[n];
    }), $6cbd97fe76e000ef$var$Te), $6cbd97fe76e000ef$export$9370f0117bf9debc = (0, $7PdBe.forwardRef)((n, a)=>{
    let { scriptOptions: s, options: e = {}, siteKey: m, onWidgetLoad: v, onSuccess: g, onExpire: T, onError: w, onBeforeInteractive: E, onAfterInteractive: i, onUnsupported: I, onTimeout: k, onLoadScript: W, id: te, style: re, as: ne = "div", injectScript: $ = !0, rerenderOnCallbackChange: o = !1, ...oe } = n, c = e.size, j = (0, $7PdBe.useCallback)(()=>typeof c > "u" ? {} : e.execution === "execute" ? $6cbd97fe76e000ef$var$f.invisible : e.appearance === "interaction-only" ? $6cbd97fe76e000ef$var$f.interactionOnly : $6cbd97fe76e000ef$var$f[c], [
        e.execution,
        c,
        e.appearance
    ]), [ie, R] = (0, $7PdBe.useState)(j()), u = (0, $7PdBe.useRef)(null), [x, B] = (0, $7PdBe.useState)(!1), r = (0, $7PdBe.useRef)(), L = (0, $7PdBe.useRef)(!1), H = te || $6cbd97fe76e000ef$export$2ce14c6f26d19d0f, d = (0, $7PdBe.useRef)({
        onSuccess: g,
        onError: w,
        onExpire: T,
        onBeforeInteractive: E,
        onAfterInteractive: i,
        onUnsupported: I,
        onTimeout: k
    });
    (0, $7PdBe.useEffect)(()=>{
        o || (d.current = {
            onSuccess: g,
            onError: w,
            onExpire: T,
            onBeforeInteractive: E,
            onAfterInteractive: i,
            onUnsupported: I,
            onTimeout: k
        });
    });
    let O = s?.id || $6cbd97fe76e000ef$export$2eea204f6220c925, A = $6cbd97fe76e000ef$var$z(O), V = s?.onLoadCallbackName || $6cbd97fe76e000ef$export$da1f91a396bc4872, se = e.appearance || "always", C = (0, $7PdBe.useMemo)(()=>({
            sitekey: m,
            action: e.action,
            cData: e.cData,
            theme: e.theme || "auto",
            language: e.language || "auto",
            tabindex: e.tabIndex,
            "response-field": e.responseField,
            "response-field-name": e.responseFieldName,
            size: $6cbd97fe76e000ef$var$G(c),
            retry: e.retry || "auto",
            "retry-interval": e.retryInterval || 8e3,
            "refresh-expired": e.refreshExpired || "auto",
            "refresh-timeout": e.refreshTimeout || "auto",
            execution: e.execution || "render",
            appearance: e.appearance || "always",
            "feedback-enabled": e.feedbackEnabled || !0,
            callback: (t)=>{
                L.current = !0, o ? g?.(t) : d.current.onSuccess?.(t);
            },
            "error-callback": o ? w : (...t)=>d.current.onError?.(...t),
            "expired-callback": o ? T : (...t)=>d.current.onExpire?.(...t),
            "before-interactive-callback": o ? E : (...t)=>d.current.onBeforeInteractive?.(...t),
            "after-interactive-callback": o ? i : (...t)=>d.current.onAfterInteractive?.(...t),
            "unsupported-callback": o ? I : (...t)=>d.current.onUnsupported?.(...t),
            "timeout-callback": o ? k : (...t)=>d.current.onTimeout?.(...t)
        }), [
        e.action,
        e.appearance,
        e.cData,
        e.execution,
        e.language,
        e.refreshExpired,
        e.responseField,
        e.responseFieldName,
        e.retry,
        e.retryInterval,
        e.tabIndex,
        e.theme,
        e.feedbackEnabled,
        e.refreshTimeout,
        m,
        c,
        o,
        o ? g : null,
        o ? w : null,
        o ? T : null,
        o ? E : null,
        o ? i : null,
        o ? I : null,
        o ? k : null
    ]), y = (0, $7PdBe.useCallback)(()=>typeof window < "u" && !!window.turnstile, []);
    return (0, $7PdBe.useEffect)(function() {
        $ && !x && $6cbd97fe76e000ef$var$X({
            onLoadCallbackName: V,
            scriptOptions: {
                ...s,
                id: O
            }
        });
    }, [
        $,
        x,
        s,
        O
    ]), (0, $7PdBe.useEffect)(function() {
        $6cbd97fe76e000ef$var$_ !== "ready" && $6cbd97fe76e000ef$var$we(V).then(()=>B(!0)).catch(console.error);
    }, []), (0, $7PdBe.useEffect)(function() {
        if (!u.current || !x) return;
        let l = !1;
        return (async ()=>{
            if (l || !u.current) return;
            let F = window.turnstile.render(u.current, C);
            r.current = F, r.current && v?.(r.current);
        })(), ()=>{
            l = !0, r.current && (window.turnstile.remove(r.current), L.current = !1);
        };
    }, [
        H,
        x,
        C
    ]), (0, $7PdBe.useImperativeHandle)(a, ()=>{
        let { turnstile: t } = window;
        return {
            getResponse () {
                if (!t?.getResponse || !r.current || !y()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                return t.getResponse(r.current);
            },
            async getResponsePromise (l = 3e4, Y = 100) {
                return new Promise((F, N)=>{
                    let p, q = async ()=>{
                        if (L.current && window.turnstile && r.current) try {
                            let S = window.turnstile.getResponse(r.current);
                            return p && clearTimeout(p), S ? F(S) : N(new Error("No response received"));
                        } catch (S) {
                            return p && clearTimeout(p), console.warn("Failed to get response", S), N(new Error("Failed to get response"));
                        }
                        p || (p = setTimeout(()=>{
                            p && clearTimeout(p), N(new Error("Timeout"));
                        }, l)), await new Promise((S)=>setTimeout(S, Y)), await q();
                    };
                    q();
                });
            },
            reset () {
                if (!t?.reset || !r.current || !y()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                e.execution === "execute" && R($6cbd97fe76e000ef$var$f.invisible);
                try {
                    L.current = !1, t.reset(r.current);
                } catch (l) {
                    console.warn(`Failed to reset Turnstile widget ${r}`, l);
                }
            },
            remove () {
                if (!t?.remove || !r.current || !y()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                R($6cbd97fe76e000ef$var$f.invisible), L.current = !1, t.remove(r.current), r.current = null;
            },
            render () {
                if (!t?.render || !u.current || !y() || r.current) {
                    console.warn("Turnstile has not been loaded or container not found");
                    return;
                }
                let l = t.render(u.current, C);
                return r.current = l, r.current && v?.(r.current), e.execution !== "execute" && R(c ? $6cbd97fe76e000ef$var$f[c] : {}), l;
            },
            execute () {
                if (e.execution !== "execute") {
                    console.warn('Execution mode is not set to "execute"');
                    return;
                }
                if (!t?.execute || !u.current || !r.current || !y()) {
                    console.warn("Turnstile has not been loaded or container not found");
                    return;
                }
                t.execute(u.current, C), R(c ? $6cbd97fe76e000ef$var$f[c] : {});
            },
            isExpired () {
                return !t?.isExpired || !r.current || !y() ? (console.warn("Turnstile has not been loaded"), !1) : t.isExpired(r.current);
            }
        };
    }, [
        r,
        e.execution,
        c,
        C,
        u,
        y,
        x,
        v
    ]), (0, $7PdBe.useEffect)(()=>{
        A && !x && window.turnstile && B(!0);
    }, [
        x,
        A
    ]), (0, $7PdBe.useEffect)(()=>{
        R(j());
    }, [
        e.execution,
        c,
        se
    ]), (0, $7PdBe.useEffect)(()=>{
        !A || typeof W != "function" || W();
    }, [
        A
    ]), (0, $hvk62.jsx)($6cbd97fe76e000ef$var$J, {
        ref: u,
        as: ne,
        id: H,
        style: {
            ...ie,
            ...re
        },
        ...oe
    });
});
$6cbd97fe76e000ef$export$9370f0117bf9debc.displayName = "Turnstile";



var $7PdBe = parcelRequire("7PdBe");

var $S29Lp = parcelRequire("S29Lp");
var $e28f330f058194bf$var$_excluded = [
    "sitekey",
    "onChange",
    "theme",
    "type",
    "tabindex",
    "onExpired",
    "onErrored",
    "size",
    "stoken",
    "grecaptcha",
    "badge",
    "hl",
    "isolated"
];
function $e28f330f058194bf$var$_extends() {
    $e28f330f058194bf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e28f330f058194bf$var$_extends.apply(this, arguments);
}
function $e28f330f058194bf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e28f330f058194bf$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e28f330f058194bf$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e28f330f058194bf$var$_setPrototypeOf(subClass, superClass);
}
function $e28f330f058194bf$var$_setPrototypeOf(o, p) {
    $e28f330f058194bf$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e28f330f058194bf$var$_setPrototypeOf(o, p);
}
var $e28f330f058194bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    $e28f330f058194bf$var$_inheritsLoose(ReCAPTCHA, _React$Component);
    function ReCAPTCHA() {
        var _this;
        _this = _React$Component.call(this) || this;
        _this.handleExpired = _this.handleExpired.bind($e28f330f058194bf$var$_assertThisInitialized(_this));
        _this.handleErrored = _this.handleErrored.bind($e28f330f058194bf$var$_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind($e28f330f058194bf$var$_assertThisInitialized(_this));
        _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind($e28f330f058194bf$var$_assertThisInitialized(_this));
        return _this;
    }
    var _proto = ReCAPTCHA.prototype;
    _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
        if (this.props.grecaptcha) {
            if (this.props.grecaptcha.enterprise) return this.props.grecaptcha.enterprise[fnName];
            return this.props.grecaptcha[fnName];
        }
        return null;
    };
    _proto.getValue = function getValue() {
        var getResponse = this.getCaptchaFunction("getResponse");
        if (getResponse && this._widgetId !== undefined) return getResponse(this._widgetId);
        return null;
    };
    _proto.getWidgetId = function getWidgetId() {
        if (this.props.grecaptcha && this._widgetId !== undefined) return this._widgetId;
        return null;
    };
    _proto.execute = function execute() {
        var execute = this.getCaptchaFunction("execute");
        if (execute && this._widgetId !== undefined) return execute(this._widgetId);
        else this._executeRequested = true;
    };
    _proto.executeAsync = function executeAsync() {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.executionResolve = resolve;
            _this2.executionReject = reject;
            _this2.execute();
        });
    };
    _proto.reset = function reset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter && this._widgetId !== undefined) resetter(this._widgetId);
    };
    _proto.forceReset = function forceReset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter) resetter();
    };
    _proto.handleExpired = function handleExpired() {
        if (this.props.onExpired) this.props.onExpired();
        else this.handleChange(null);
    };
    _proto.handleErrored = function handleErrored() {
        if (this.props.onErrored) this.props.onErrored();
        if (this.executionReject) {
            this.executionReject();
            delete this.executionResolve;
            delete this.executionReject;
        }
    };
    _proto.handleChange = function handleChange(token) {
        if (this.props.onChange) this.props.onChange(token);
        if (this.executionResolve) {
            this.executionResolve(token);
            delete this.executionReject;
            delete this.executionResolve;
        }
    };
    _proto.explicitRender = function explicitRender() {
        var render = this.getCaptchaFunction("render");
        if (render && this._widgetId === undefined) {
            var wrapper = document.createElement("div");
            this._widgetId = render(wrapper, {
                sitekey: this.props.sitekey,
                callback: this.handleChange,
                theme: this.props.theme,
                type: this.props.type,
                tabindex: this.props.tabindex,
                "expired-callback": this.handleExpired,
                "error-callback": this.handleErrored,
                size: this.props.size,
                stoken: this.props.stoken,
                hl: this.props.hl,
                badge: this.props.badge,
                isolated: this.props.isolated
            });
            this.captcha.appendChild(wrapper);
        }
        if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
            this._executeRequested = false;
            this.execute();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        this.explicitRender();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.explicitRender();
    };
    _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
        this.captcha = elem;
    };
    _proto.render = function render() {
        // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
        /* eslint-disable no-unused-vars */ var _this$props = this.props, sitekey = _this$props.sitekey, onChange = _this$props.onChange, theme = _this$props.theme, type = _this$props.type, tabindex = _this$props.tabindex, onExpired = _this$props.onExpired, onErrored = _this$props.onErrored, size = _this$props.size, stoken = _this$props.stoken, grecaptcha = _this$props.grecaptcha, badge = _this$props.badge, hl = _this$props.hl, isolated = _this$props.isolated, childProps = $e28f330f058194bf$var$_objectWithoutPropertiesLoose(_this$props, $e28f330f058194bf$var$_excluded);
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $7PdBe.createElement("div", $e28f330f058194bf$var$_extends({}, childProps, {
            ref: this.handleRecaptchaRef
        }));
    };
    return ReCAPTCHA;
}($7PdBe.Component);
$e28f330f058194bf$export$2e2bcd8739ae039.displayName = "ReCAPTCHA";
$e28f330f058194bf$export$2e2bcd8739ae039.propTypes = {
    sitekey: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    grecaptcha: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).object,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOf([
        "dark",
        "light"
    ]),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOf([
        "image",
        "audio"
    ]),
    tabindex: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).number,
    onExpired: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    onErrored: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOf([
        "compact",
        "normal",
        "invisible"
    ]),
    stoken: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string,
    hl: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).string,
    badge: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).oneOf([
        "bottomright",
        "bottomleft",
        "inline"
    ]),
    isolated: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).bool
};
$e28f330f058194bf$export$2e2bcd8739ae039.defaultProps = {
    onChange: function onChange() {},
    theme: "light",
    type: "image",
    tabindex: 0,
    size: "normal",
    badge: "bottomright"
};



var $7PdBe = parcelRequire("7PdBe");

var $S29Lp = parcelRequire("S29Lp");

var $1IGIR = parcelRequire("1IGIR");
function $579daf8868817dec$var$_extends() {
    $579daf8868817dec$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $579daf8868817dec$var$_extends.apply(this, arguments);
}
function $579daf8868817dec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $579daf8868817dec$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $579daf8868817dec$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $579daf8868817dec$var$idCount = 0;
function $579daf8868817dec$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $579daf8868817dec$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $579daf8868817dec$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $579daf8868817dec$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $579daf8868817dec$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($579daf8868817dec$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $579daf8868817dec$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $579daf8868817dec$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($579daf8868817dec$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $579daf8868817dec$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $579daf8868817dec$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $579daf8868817dec$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $579daf8868817dec$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $579daf8868817dec$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $579daf8868817dec$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $7PdBe.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $7PdBe.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $7PdBe.forwardRef)(function(props, ref) {
            return (0, $7PdBe.createElement)(AsyncScriptLoader, $579daf8868817dec$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($S29Lp))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($1IGIR)))(ForwardedComponent, WrappedComponent);
    };
}


var $dc71127d65706864$var$callbackName = "onloadcallback";
var $dc71127d65706864$var$globalName = "grecaptcha";
function $dc71127d65706864$var$getOptions() {
    return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function $dc71127d65706864$var$getURL() {
    var dynamicOptions = $dc71127d65706864$var$getOptions();
    var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
    if (dynamicOptions.enterprise) return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + $dc71127d65706864$var$callbackName + "&render=explicit";
    return "https://" + hostname + "/recaptcha/api.js?onload=" + $dc71127d65706864$var$callbackName + "&render=explicit";
}
var $dc71127d65706864$export$2e2bcd8739ae039 = (0, $579daf8868817dec$export$2e2bcd8739ae039)($dc71127d65706864$var$getURL, {
    callbackName: $dc71127d65706864$var$callbackName,
    globalName: $dc71127d65706864$var$globalName,
    attributes: $dc71127d65706864$var$getOptions().nonce ? {
        nonce: $dc71127d65706864$var$getOptions().nonce
    } : {}
})((0, $e28f330f058194bf$export$2e2bcd8739ae039));



var $352a1050383a653c$export$2e2bcd8739ae039 = (0, $dc71127d65706864$export$2e2bcd8739ae039);


var $674f57cdc6deabab$exports = {};
"use strict";
Object.defineProperty($674f57cdc6deabab$exports, "__esModule", {
    value: true
});
$674f57cdc6deabab$exports.QRCode = undefined;
var $674f57cdc6deabab$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $S29Lp = parcelRequire("S29Lp");
var $674f57cdc6deabab$var$_propTypes2 = $674f57cdc6deabab$var$_interopRequireDefault($S29Lp);
var $eb335229f263ee49$exports = {};
$eb335229f263ee49$exports = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};


var $674f57cdc6deabab$var$_ErrorCorrectLevel2 = $674f57cdc6deabab$var$_interopRequireDefault($eb335229f263ee49$exports);
var $3abcbfdc4d0a2cd0$exports = {};
var $324e3a9a2bf7ded4$exports = {};
var $e7e2ee802b45c18a$exports = {};
$e7e2ee802b45c18a$exports = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};


function $324e3a9a2bf7ded4$var$QR8bitByte(data) {
    this.mode = $e7e2ee802b45c18a$exports.MODE_8BIT_BYTE;
    this.data = data;
}
$324e3a9a2bf7ded4$var$QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.data.length;
    },
    write: function(buffer) {
        for(var i = 0; i < this.data.length; i++)// not JIS ...
        buffer.put(this.data.charCodeAt(i), 8);
    }
};
$324e3a9a2bf7ded4$exports = $324e3a9a2bf7ded4$var$QR8bitByte;


var $6420f7adef3454ca$exports = {};
// ErrorCorrectLevel

function $6420f7adef3454ca$var$QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
$6420f7adef3454ca$var$QRRSBlock.RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    // 2
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    // 3
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    // 4		
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    // 5
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    // 6
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    // 7		
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    // 8
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    // 9
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    // 10		
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    // 11
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    // 12
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    // 13
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    // 14
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    // 15
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    // 16
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    // 17
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    // 18
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    // 19
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    // 20
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    // 21
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    // 22
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    // 23
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    // 24
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    // 25
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    // 26
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    // 27
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    // 28
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    // 29
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    // 30
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    // 31
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    // 32
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    // 33
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    // 34
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    // 35
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    // 36
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    // 37
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    // 38
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    // 39
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    // 40
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
$6420f7adef3454ca$var$QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = $6420f7adef3454ca$var$QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = new Array();
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new $6420f7adef3454ca$var$QRRSBlock(totalCount, dataCount));
    }
    return list;
};
$6420f7adef3454ca$var$QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case $eb335229f263ee49$exports.L:
            return $6420f7adef3454ca$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case $eb335229f263ee49$exports.M:
            return $6420f7adef3454ca$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case $eb335229f263ee49$exports.Q:
            return $6420f7adef3454ca$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case $eb335229f263ee49$exports.H:
            return $6420f7adef3454ca$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$6420f7adef3454ca$exports = $6420f7adef3454ca$var$QRRSBlock;


var $930c34121c27e3d5$exports = {};
function $930c34121c27e3d5$var$QRBitBuffer() {
    this.buffer = new Array();
    this.length = 0;
}
$930c34121c27e3d5$var$QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$930c34121c27e3d5$exports = $930c34121c27e3d5$var$QRBitBuffer;


var $26ab06d816710ddf$exports = {};

var $c92c796faaceef43$exports = {};
var $dd8fd913b6eb643d$exports = {};
var $dd8fd913b6eb643d$var$QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return $dd8fd913b6eb643d$var$QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return $dd8fd913b6eb643d$var$QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var $dd8fd913b6eb643d$var$i = 0; $dd8fd913b6eb643d$var$i < 8; $dd8fd913b6eb643d$var$i++)$dd8fd913b6eb643d$var$QRMath.EXP_TABLE[$dd8fd913b6eb643d$var$i] = 1 << $dd8fd913b6eb643d$var$i;
for(var $dd8fd913b6eb643d$var$i = 8; $dd8fd913b6eb643d$var$i < 256; $dd8fd913b6eb643d$var$i++)$dd8fd913b6eb643d$var$QRMath.EXP_TABLE[$dd8fd913b6eb643d$var$i] = $dd8fd913b6eb643d$var$QRMath.EXP_TABLE[$dd8fd913b6eb643d$var$i - 4] ^ $dd8fd913b6eb643d$var$QRMath.EXP_TABLE[$dd8fd913b6eb643d$var$i - 5] ^ $dd8fd913b6eb643d$var$QRMath.EXP_TABLE[$dd8fd913b6eb643d$var$i - 6] ^ $dd8fd913b6eb643d$var$QRMath.EXP_TABLE[$dd8fd913b6eb643d$var$i - 8];
for(var $dd8fd913b6eb643d$var$i = 0; $dd8fd913b6eb643d$var$i < 255; $dd8fd913b6eb643d$var$i++)$dd8fd913b6eb643d$var$QRMath.LOG_TABLE[$dd8fd913b6eb643d$var$QRMath.EXP_TABLE[$dd8fd913b6eb643d$var$i]] = $dd8fd913b6eb643d$var$i;
$dd8fd913b6eb643d$exports = $dd8fd913b6eb643d$var$QRMath;


function $c92c796faaceef43$var$QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
$c92c796faaceef43$var$QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= $dd8fd913b6eb643d$exports.gexp($dd8fd913b6eb643d$exports.glog(this.get(i)) + $dd8fd913b6eb643d$exports.glog(e.get(j)));
        return new $c92c796faaceef43$var$QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = $dd8fd913b6eb643d$exports.glog(this.get(0)) - $dd8fd913b6eb643d$exports.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= $dd8fd913b6eb643d$exports.gexp($dd8fd913b6eb643d$exports.glog(e.get(i)) + ratio);
        // recursive call
        return new $c92c796faaceef43$var$QRPolynomial(num, 0).mod(e);
    }
};
$c92c796faaceef43$exports = $c92c796faaceef43$var$QRPolynomial;



var $26ab06d816710ddf$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var $26ab06d816710ddf$var$QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while($26ab06d816710ddf$var$QRUtil.getBCHDigit(d) - $26ab06d816710ddf$var$QRUtil.getBCHDigit($26ab06d816710ddf$var$QRUtil.G15) >= 0)d ^= $26ab06d816710ddf$var$QRUtil.G15 << $26ab06d816710ddf$var$QRUtil.getBCHDigit(d) - $26ab06d816710ddf$var$QRUtil.getBCHDigit($26ab06d816710ddf$var$QRUtil.G15);
        return (data << 10 | d) ^ $26ab06d816710ddf$var$QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while($26ab06d816710ddf$var$QRUtil.getBCHDigit(d) - $26ab06d816710ddf$var$QRUtil.getBCHDigit($26ab06d816710ddf$var$QRUtil.G18) >= 0)d ^= $26ab06d816710ddf$var$QRUtil.G18 << $26ab06d816710ddf$var$QRUtil.getBCHDigit(d) - $26ab06d816710ddf$var$QRUtil.getBCHDigit($26ab06d816710ddf$var$QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return $26ab06d816710ddf$var$QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case $26ab06d816710ddf$var$QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case $26ab06d816710ddf$var$QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case $26ab06d816710ddf$var$QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case $26ab06d816710ddf$var$QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case $26ab06d816710ddf$var$QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case $26ab06d816710ddf$var$QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case $26ab06d816710ddf$var$QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case $26ab06d816710ddf$var$QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new $c92c796faaceef43$exports([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new $c92c796faaceef43$exports([
            1,
            $dd8fd913b6eb643d$exports.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $e7e2ee802b45c18a$exports.MODE_NUMBER:
                return 10;
            case $e7e2ee802b45c18a$exports.MODE_ALPHA_NUM:
                return 9;
            case $e7e2ee802b45c18a$exports.MODE_8BIT_BYTE:
                return 8;
            case $e7e2ee802b45c18a$exports.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $e7e2ee802b45c18a$exports.MODE_NUMBER:
                return 12;
            case $e7e2ee802b45c18a$exports.MODE_ALPHA_NUM:
                return 11;
            case $e7e2ee802b45c18a$exports.MODE_8BIT_BYTE:
                return 16;
            case $e7e2ee802b45c18a$exports.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $e7e2ee802b45c18a$exports.MODE_NUMBER:
                return 14;
            case $e7e2ee802b45c18a$exports.MODE_ALPHA_NUM:
                return 13;
            case $e7e2ee802b45c18a$exports.MODE_8BIT_BYTE:
                return 16;
            case $e7e2ee802b45c18a$exports.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        // LEVEL1
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
$26ab06d816710ddf$exports = $26ab06d816710ddf$var$QRUtil;



function $3abcbfdc4d0a2cd0$var$QRCode(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
// for client side minification
var $3abcbfdc4d0a2cd0$var$proto = $3abcbfdc4d0a2cd0$var$QRCode.prototype;
$3abcbfdc4d0a2cd0$var$proto.addData = function(data) {
    var newData = new $324e3a9a2bf7ded4$exports(data);
    this.dataList.push(newData);
    this.dataCache = null;
};
$3abcbfdc4d0a2cd0$var$proto.isDark = function(row, col) {
    if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
    return this.modules[row][col];
};
$3abcbfdc4d0a2cd0$var$proto.getModuleCount = function() {
    return this.moduleCount;
};
$3abcbfdc4d0a2cd0$var$proto.make = function() {
    // Calculate automatically typeNumber if provided is < 1
    if (this.typeNumber < 1) {
        var typeNumber = 1;
        for(typeNumber = 1; typeNumber < 40; typeNumber++){
            var rsBlocks = $6420f7adef3454ca$exports.getRSBlocks(typeNumber, this.errorCorrectLevel);
            var buffer = new $930c34121c27e3d5$exports();
            var totalDataCount = 0;
            for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
            for(var i = 0; i < this.dataList.length; i++){
                var data = this.dataList[i];
                buffer.put(data.mode, 4);
                buffer.put(data.getLength(), $26ab06d816710ddf$exports.getLengthInBits(data.mode, typeNumber));
                data.write(buffer);
            }
            if (buffer.getLengthInBits() <= totalDataCount * 8) break;
        }
        this.typeNumber = typeNumber;
    }
    this.makeImpl(false, this.getBestMaskPattern());
};
$3abcbfdc4d0a2cd0$var$proto.makeImpl = function(test, maskPattern) {
    this.moduleCount = this.typeNumber * 4 + 17;
    this.modules = new Array(this.moduleCount);
    for(var row = 0; row < this.moduleCount; row++){
        this.modules[row] = new Array(this.moduleCount);
        for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null; //(col + row) % 3;
    }
    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this.moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this.moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);
    if (this.typeNumber >= 7) this.setupTypeNumber(test);
    if (this.dataCache == null) this.dataCache = $3abcbfdc4d0a2cd0$var$QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
    this.mapData(this.dataCache, maskPattern);
};
$3abcbfdc4d0a2cd0$var$proto.setupPositionProbePattern = function(row, col) {
    for(var r = -1; r <= 7; r++){
        if (row + r <= -1 || this.moduleCount <= row + r) continue;
        for(var c = -1; c <= 7; c++){
            if (col + c <= -1 || this.moduleCount <= col + c) continue;
            if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$3abcbfdc4d0a2cd0$var$proto.getBestMaskPattern = function() {
    var minLostPoint = 0;
    var pattern = 0;
    for(var i = 0; i < 8; i++){
        this.makeImpl(true, i);
        var lostPoint = $26ab06d816710ddf$exports.getLostPoint(this);
        if (i == 0 || minLostPoint > lostPoint) {
            minLostPoint = lostPoint;
            pattern = i;
        }
    }
    return pattern;
};
$3abcbfdc4d0a2cd0$var$proto.createMovieClip = function(target_mc, instance_name, depth) {
    var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
    var cs = 1;
    this.make();
    for(var row = 0; row < this.modules.length; row++){
        var y = row * cs;
        for(var col = 0; col < this.modules[row].length; col++){
            var x = col * cs;
            var dark = this.modules[row][col];
            if (dark) {
                qr_mc.beginFill(0, 100);
                qr_mc.moveTo(x, y);
                qr_mc.lineTo(x + cs, y);
                qr_mc.lineTo(x + cs, y + cs);
                qr_mc.lineTo(x, y + cs);
                qr_mc.endFill();
            }
        }
    }
    return qr_mc;
};
$3abcbfdc4d0a2cd0$var$proto.setupTimingPattern = function() {
    for(var r = 8; r < this.moduleCount - 8; r++){
        if (this.modules[r][6] != null) continue;
        this.modules[r][6] = r % 2 == 0;
    }
    for(var c = 8; c < this.moduleCount - 8; c++){
        if (this.modules[6][c] != null) continue;
        this.modules[6][c] = c % 2 == 0;
    }
};
$3abcbfdc4d0a2cd0$var$proto.setupPositionAdjustPattern = function() {
    var pos = $26ab06d816710ddf$exports.getPatternPosition(this.typeNumber);
    for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
        var row = pos[i];
        var col = pos[j];
        if (this.modules[row][col] != null) continue;
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$3abcbfdc4d0a2cd0$var$proto.setupTypeNumber = function(test) {
    var bits = $26ab06d816710ddf$exports.getBCHTypeNumber(this.typeNumber);
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
    }
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
    }
};
$3abcbfdc4d0a2cd0$var$proto.setupTypeInfo = function(test, maskPattern) {
    var data = this.errorCorrectLevel << 3 | maskPattern;
    var bits = $26ab06d816710ddf$exports.getBCHTypeInfo(data);
    // vertical		
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 6) this.modules[i][8] = mod;
        else if (i < 8) this.modules[i + 1][8] = mod;
        else this.modules[this.moduleCount - 15 + i][8] = mod;
    }
    // horizontal
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
        else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
        else this.modules[8][15 - i - 1] = mod;
    }
    // fixed module
    this.modules[this.moduleCount - 8][8] = !test;
};
$3abcbfdc4d0a2cd0$var$proto.mapData = function(data, maskPattern) {
    var inc = -1;
    var row = this.moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = this.moduleCount - 1; col > 0; col -= 2){
        if (col == 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                var mask = $26ab06d816710ddf$exports.getMask(maskPattern, row, col - c);
                if (mask) dark = !dark;
                this.modules[row][col - c] = dark;
                bitIndex--;
                if (bitIndex == -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || this.moduleCount <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
};
$3abcbfdc4d0a2cd0$var$QRCode.PAD0 = 0xEC;
$3abcbfdc4d0a2cd0$var$QRCode.PAD1 = 0x11;
$3abcbfdc4d0a2cd0$var$QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = $6420f7adef3454ca$exports.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new $930c34121c27e3d5$exports();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), $26ab06d816710ddf$exports.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    // calc num max data.
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    // end code
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    // padding
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    // padding
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($3abcbfdc4d0a2cd0$var$QRCode.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($3abcbfdc4d0a2cd0$var$QRCode.PAD1, 8);
    }
    return $3abcbfdc4d0a2cd0$var$QRCode.createBytes(buffer, rsBlocks);
};
$3abcbfdc4d0a2cd0$var$QRCode.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = $26ab06d816710ddf$exports.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new $c92c796faaceef43$exports(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
$3abcbfdc4d0a2cd0$exports = $3abcbfdc4d0a2cd0$var$QRCode;


var $674f57cdc6deabab$var$_QRCode2 = $674f57cdc6deabab$var$_interopRequireDefault($3abcbfdc4d0a2cd0$exports);

var $7PdBe = parcelRequire("7PdBe");
var $674f57cdc6deabab$var$_react2 = $674f57cdc6deabab$var$_interopRequireDefault($7PdBe);
var $50761da128c6db11$exports = {};
"use strict";
Object.defineProperty($50761da128c6db11$exports, "__esModule", {
    value: true
});
var $50761da128c6db11$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $S29Lp = parcelRequire("S29Lp");
var $50761da128c6db11$var$_propTypes2 = $50761da128c6db11$var$_interopRequireDefault($S29Lp);

var $7PdBe = parcelRequire("7PdBe");
var $50761da128c6db11$var$_react2 = $50761da128c6db11$var$_interopRequireDefault($7PdBe);
function $50761da128c6db11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $50761da128c6db11$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $50761da128c6db11$var$propTypes = {
    bgColor: $50761da128c6db11$var$_propTypes2.default.oneOfType([
        $50761da128c6db11$var$_propTypes2.default.object,
        $50761da128c6db11$var$_propTypes2.default.string
    ]).isRequired,
    bgD: $50761da128c6db11$var$_propTypes2.default.string.isRequired,
    fgColor: $50761da128c6db11$var$_propTypes2.default.oneOfType([
        $50761da128c6db11$var$_propTypes2.default.object,
        $50761da128c6db11$var$_propTypes2.default.string
    ]).isRequired,
    fgD: $50761da128c6db11$var$_propTypes2.default.string.isRequired,
    size: $50761da128c6db11$var$_propTypes2.default.number.isRequired,
    title: $50761da128c6db11$var$_propTypes2.default.string,
    viewBoxSize: $50761da128c6db11$var$_propTypes2.default.number.isRequired,
    xmlns: $50761da128c6db11$var$_propTypes2.default.string
};
var $50761da128c6db11$var$QRCodeSvg = (0, $7PdBe.forwardRef)(function(_ref, ref) {
    var bgColor = _ref.bgColor, bgD = _ref.bgD, fgD = _ref.fgD, fgColor = _ref.fgColor, size = _ref.size, title = _ref.title, viewBoxSize = _ref.viewBoxSize, _ref$xmlns = _ref.xmlns, xmlns = _ref$xmlns === undefined ? "http://www.w3.org/2000/svg" : _ref$xmlns, props = $50761da128c6db11$var$_objectWithoutProperties(_ref, [
        "bgColor",
        "bgD",
        "fgD",
        "fgColor",
        "size",
        "title",
        "viewBoxSize",
        "xmlns"
    ]);
    return $50761da128c6db11$var$_react2.default.createElement("svg", $50761da128c6db11$var$_extends({}, props, {
        height: size,
        ref: ref,
        viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize,
        width: size,
        xmlns: xmlns
    }), title ? $50761da128c6db11$var$_react2.default.createElement("title", null, title) : null, $50761da128c6db11$var$_react2.default.createElement("path", {
        d: bgD,
        fill: bgColor
    }), $50761da128c6db11$var$_react2.default.createElement("path", {
        d: fgD,
        fill: fgColor
    }));
});
$50761da128c6db11$var$QRCodeSvg.displayName = "QRCodeSvg";
$50761da128c6db11$var$QRCodeSvg.propTypes = $50761da128c6db11$var$propTypes;
$50761da128c6db11$exports.default = $50761da128c6db11$var$QRCodeSvg;


var $674f57cdc6deabab$var$_QRCodeSvg2 = $674f57cdc6deabab$var$_interopRequireDefault($50761da128c6db11$exports);
function $674f57cdc6deabab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $674f57cdc6deabab$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
// A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.
var $674f57cdc6deabab$var$propTypes = {
    bgColor: $674f57cdc6deabab$var$_propTypes2.default.oneOfType([
        $674f57cdc6deabab$var$_propTypes2.default.object,
        $674f57cdc6deabab$var$_propTypes2.default.string
    ]),
    fgColor: $674f57cdc6deabab$var$_propTypes2.default.oneOfType([
        $674f57cdc6deabab$var$_propTypes2.default.object,
        $674f57cdc6deabab$var$_propTypes2.default.string
    ]),
    level: $674f57cdc6deabab$var$_propTypes2.default.string,
    size: $674f57cdc6deabab$var$_propTypes2.default.number,
    value: $674f57cdc6deabab$var$_propTypes2.default.string.isRequired
};
var $674f57cdc6deabab$var$QRCode = (0, $7PdBe.forwardRef)(function(_ref, ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === undefined ? "#FFFFFF" : _ref$bgColor, _ref$fgColor = _ref.fgColor, fgColor = _ref$fgColor === undefined ? "#000000" : _ref$fgColor, _ref$level = _ref.level, level = _ref$level === undefined ? "L" : _ref$level, _ref$size = _ref.size, size = _ref$size === undefined ? 256 : _ref$size, value = _ref.value, props = $674f57cdc6deabab$var$_objectWithoutProperties(_ref, [
        "bgColor",
        "fgColor",
        "level",
        "size",
        "value"
    ]);
    // Use type === -1 to automatically pick the best type.
    var qrcode = new $674f57cdc6deabab$var$_QRCode2.default(-1, $674f57cdc6deabab$var$_ErrorCorrectLevel2.default[level]);
    qrcode.addData(value);
    qrcode.make();
    var cells = qrcode.modules;
    return $674f57cdc6deabab$var$_react2.default.createElement($674f57cdc6deabab$var$_QRCodeSvg2.default, $674f57cdc6deabab$var$_extends({}, props, {
        bgColor: bgColor,
        bgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        fgColor: fgColor,
        fgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        ref: ref,
        size: size,
        viewBoxSize: cells.length
    }));
});
$674f57cdc6deabab$exports.QRCode = $674f57cdc6deabab$var$QRCode;
$674f57cdc6deabab$var$QRCode.displayName = "QRCode";
$674f57cdc6deabab$var$QRCode.propTypes = $674f57cdc6deabab$var$propTypes;
$674f57cdc6deabab$exports.default = $674f57cdc6deabab$var$QRCode;


// src/separator.tsx

var $7PdBe = parcelRequire("7PdBe");


var $hvk62 = parcelRequire("hvk62");
var $84502cd5180c34f1$var$NAME = "Separator";
var $84502cd5180c34f1$var$DEFAULT_ORIENTATION = "horizontal";
var $84502cd5180c34f1$var$ORIENTATIONS = [
    "horizontal",
    "vertical"
];
var $84502cd5180c34f1$export$1ff3c3f08ae963c0 = $7PdBe.forwardRef((props, forwardedRef)=>{
    const { decorative: decorative, orientation: orientationProp = $84502cd5180c34f1$var$DEFAULT_ORIENTATION, ...domProps } = props;
    const orientation = $84502cd5180c34f1$var$isValidOrientation(orientationProp) ? orientationProp : $84502cd5180c34f1$var$DEFAULT_ORIENTATION;
    const ariaOrientation = orientation === "vertical" ? orientation : void 0;
    const semanticProps = decorative ? {
        role: "none"
    } : {
        "aria-orientation": ariaOrientation,
        role: "separator"
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $252f0230ab9bb14c$export$250ffa63cdc0d034).div, {
        "data-orientation": orientation,
        ...semanticProps,
        ...domProps,
        ref: forwardedRef
    });
});
$84502cd5180c34f1$export$1ff3c3f08ae963c0.displayName = $84502cd5180c34f1$var$NAME;
function $84502cd5180c34f1$var$isValidOrientation(orientation) {
    return $84502cd5180c34f1$var$ORIENTATIONS.includes(orientation);
}
var $84502cd5180c34f1$export$be92b6f5f03c0fe9 = $84502cd5180c34f1$export$1ff3c3f08ae963c0;


"use client";
function $c5bb23e187c19083$export$141ca0666da3bf00(options) {
    const { authView: authView = "SIGN_IN", enabled: enabled = true } = options ?? {};
    const { hooks: { useSession: useSession }, basePath: basePath, viewPaths: viewPaths, replace: replace } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { data: data, isPending: isPending, error: error, refetch: refetch } = useSession();
    const sessionData = data;
    (0, $7PdBe.useEffect)(()=>{
        if (!enabled || isPending || sessionData) return;
        const currentUrl = new URL(window.location.href);
        const redirectTo = currentUrl.searchParams.get("redirectTo") || window.location.href.replace(window.location.origin, "");
        replace(`${basePath}/${viewPaths[authView]}?redirectTo=${encodeURIComponent(redirectTo)}`);
    }, [
        isPending,
        sessionData,
        basePath,
        viewPaths,
        replace,
        authView,
        enabled
    ]);
    return {
        data: sessionData,
        user: sessionData == null ? void 0 : sessionData.user,
        isPending: isPending,
        error: error,
        refetch: refetch
    };
}
function $c5bb23e187c19083$var$Card({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "card",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm", className),
        ...props
    });
}
function $c5bb23e187c19083$var$CardHeader({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "card-header",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6", className),
        ...props
    });
}
function $c5bb23e187c19083$var$CardTitle({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "card-title",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("leading-none font-semibold", className),
        ...props
    });
}
function $c5bb23e187c19083$var$CardDescription({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "card-description",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-muted-foreground text-sm", className),
        ...props
    });
}
function $c5bb23e187c19083$var$CardContent({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "card-content",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("px-6", className),
        ...props
    });
}
function $c5bb23e187c19083$var$CardFooter({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "card-footer",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center px-6 [.border-t]:pt-6", className),
        ...props
    });
}
function $c5bb23e187c19083$var$Skeleton({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "skeleton",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-accent animate-pulse rounded-md", className),
        ...props
    });
}
var $c5bb23e187c19083$var$buttonVariants = (0, $fabf324b0990a90a$export$87dc52566e90b739)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
            destructive: "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
            outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
            secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            default: "h-9 px-4 py-2 has-[>svg]:px-3",
            sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
            lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
            icon: "size-9"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
function $c5bb23e187c19083$var$Button({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }) {
    const Comp = asChild ? (0, $0deb3a18aa385379$export$be92b6f5f03c0fe9) : "button";
    return /* @__PURE__ */ (0, $hvk62.jsx)(Comp, {
        "data-slot": "button",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)($c5bb23e187c19083$var$buttonVariants({
            variant: variant,
            size: size,
            className: className
        })),
        ...props
    });
}
function $c5bb23e187c19083$var$SettingsActionButton({ classNames: classNames, actionLabel: actionLabel, disabled: disabled, isSubmitting: isSubmitting, variant: variant, onClick: onClick, ...props }) {
    if (!onClick) {
        const formState = (0, $9a9ac4df444a6447$export$606f11b2eb45ecc6)();
        isSubmitting = formState.isSubmitting;
    }
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("md:ms-auto", classNames == null ? void 0 : classNames.button, variant === "default" && (classNames == null ? void 0 : classNames.primaryButton), variant === "destructive" && (classNames == null ? void 0 : classNames.destructiveButton)),
        disabled: isSubmitting || disabled,
        size: "sm",
        type: onClick ? "button" : "submit",
        variant: variant,
        onClick: onClick,
        ...props,
        children: [
            isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                className: "animate-spin"
            }),
            actionLabel
        ]
    });
}
function $c5bb23e187c19083$var$SettingsCardFooter({ className: className, classNames: classNames, actionLabel: actionLabel, disabled: disabled, instructions: instructions, isPending: isPending, isSubmitting: isSubmitting, variant: variant, action: action }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardFooter, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex flex-col justify-between gap-4 rounded-b-xl md:flex-row", (actionLabel || instructions) && "!py-4 border-t", variant === "destructive" ? "border-destructive/30 bg-destructive/15" : "bg-sidebar", className, classNames == null ? void 0 : classNames.footer),
        children: isPending ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
            children: [
                instructions && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("my-0.5 h-3 w-48 max-w-full md:h-4 md:w-56", classNames == null ? void 0 : classNames.skeleton)
                }),
                actionLabel && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-8 w-14 md:ms-auto", classNames == null ? void 0 : classNames.skeleton)
                })
            ]
        }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
            children: [
                instructions && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardDescription, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-center text-muted-foreground text-xs md:text-start md:text-sm", classNames == null ? void 0 : classNames.instructions),
                    children: instructions
                }),
                actionLabel && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsActionButton, {
                    classNames: classNames,
                    actionLabel: actionLabel,
                    disabled: disabled,
                    isSubmitting: isSubmitting,
                    variant: variant,
                    onClick: action
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$SettingsCardHeader({ className: className, classNames: classNames, description: description, isPending: isPending, title: title }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardHeader, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.header, className),
        children: isPending ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("my-0.5 h-5 w-1/3 md:h-5.5", classNames == null ? void 0 : classNames.skeleton)
                }),
                description && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("mt-1.5 mb-0.5 h-3 w-2/3 md:h-3.5", classNames == null ? void 0 : classNames.skeleton)
                })
            ]
        }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardTitle, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                    children: title
                }),
                description && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardDescription, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                    children: description
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$d64d9b0d320b2798({ children: children, className: className, classNames: classNames, title: title, description: description, instructions: instructions, actionLabel: actionLabel, disabled: disabled, isPending: isPending, isSubmitting: isSubmitting, optimistic: optimistic, variant: variant, action: action, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full pb-0 text-start", variant === "destructive" && "border-destructive/40", className, classNames == null ? void 0 : classNames.base),
        ...props,
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsCardHeader, {
                classNames: classNames,
                description: description,
                isPending: isPending,
                title: title
            }),
            children,
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsCardFooter, {
                classNames: classNames,
                actionLabel: actionLabel,
                disabled: disabled,
                isPending: isPending,
                isSubmitting: isSubmitting,
                instructions: instructions,
                optimistic: optimistic,
                variant: variant,
                action: action
            })
        ]
    });
}
function $c5bb23e187c19083$export$4cc32ea01a6b64cb({ classNames: classNames }) {
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center gap-3 px-4 py-3", classNames == null ? void 0 : classNames.cell),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-5 rounded-full", classNames == null ? void 0 : classNames.skeleton)
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-4 w-24", classNames == null ? void 0 : classNames.skeleton)
                        })
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("ms-auto size-8 w-12", classNames == null ? void 0 : classNames.skeleton)
            })
        ]
    });
}
// src/lib/image-utils.ts
async function $c5bb23e187c19083$var$resizeAndCropImage(file, name, size, extension) {
    const image = await $c5bb23e187c19083$var$loadImage(file);
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext("2d");
    const minEdge = Math.min(image.width, image.height);
    const sx = (image.width - minEdge) / 2;
    const sy = (image.height - minEdge) / 2;
    const sWidth = minEdge;
    const sHeight = minEdge;
    ctx == null || ctx.drawImage(image, sx, sy, sWidth, sHeight, 0, 0, size, size);
    const resizedImageBlob = await new Promise((resolve)=>canvas.toBlob(resolve, `image/${extension}`));
    return new File([
        resizedImageBlob
    ], `${name}.${extension}`, {
        type: `image/${extension}`
    });
}
async function $c5bb23e187c19083$var$loadImage(file) {
    return new Promise((resolve, reject)=>{
        const image = new Image();
        const reader = new FileReader();
        reader.onload = (e)=>{
            var _a;
            image.src = (_a = e.target) == null ? void 0 : _a.result;
        };
        image.onload = ()=>resolve(image);
        image.onerror = (err)=>reject(err);
        reader.readAsDataURL(file);
    });
}
async function $c5bb23e187c19083$var$fileToBase64(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
function $c5bb23e187c19083$var$Dialog({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$export$be92b6f5f03c0fe9, {
        "data-slot": "dialog",
        ...props
    });
}
function $c5bb23e187c19083$var$DialogPortal({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$export$602eac185826482c, {
        "data-slot": "dialog-portal",
        ...props
    });
}
function $c5bb23e187c19083$var$DialogOverlay({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$export$c6fdb837b070b4ff, {
        "data-slot": "dialog-overlay",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", className),
        ...props
    });
}
function $c5bb23e187c19083$var$DialogContent({ className: className, children: children, showCloseButton: showCloseButton = true, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogPortal, {
        "data-slot": "dialog-portal",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogOverlay, {}),
            /* @__PURE__ */ (0, $hvk62.jsxs)($3db049dff66a112d$export$7c6e2c02157bb7d2, {
                "data-slot": "dialog-content",
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg", className),
                ...props,
                children: [
                    children,
                    showCloseButton && /* @__PURE__ */ (0, $hvk62.jsxs)($3db049dff66a112d$export$f39c2d165cd861fe, {
                        "data-slot": "dialog-close",
                        className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $f5645b1fe1001619$export$2e2bcd8739ae039), {}),
                            /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$var$DialogHeader({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "dialog-header",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex flex-col gap-2 text-center sm:text-left", className),
        ...props
    });
}
function $c5bb23e187c19083$var$DialogFooter({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "dialog-footer",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", className),
        ...props
    });
}
function $c5bb23e187c19083$var$DialogTitle({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$export$f99233281efd08a0, {
        "data-slot": "dialog-title",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg leading-none font-semibold", className),
        ...props
    });
}
function $c5bb23e187c19083$var$DialogDescription({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($3db049dff66a112d$export$393edc798c47379d, {
        "data-slot": "dialog-description",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-muted-foreground text-sm", className),
        ...props
    });
}
function $c5bb23e187c19083$var$DropdownMenu({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($e7bd25a108aa4fe5$export$be92b6f5f03c0fe9, {
        "data-slot": "dropdown-menu",
        ...props
    });
}
function $c5bb23e187c19083$var$DropdownMenuTrigger({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($e7bd25a108aa4fe5$export$41fb9f06171c75f4, {
        "data-slot": "dropdown-menu-trigger",
        ...props
    });
}
function $c5bb23e187c19083$var$DropdownMenuContent({ className: className, sideOffset: sideOffset = 4, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($e7bd25a108aa4fe5$export$602eac185826482c, {
        children: /* @__PURE__ */ (0, $hvk62.jsx)($e7bd25a108aa4fe5$export$7c6e2c02157bb7d2, {
            "data-slot": "dropdown-menu-content",
            sideOffset: sideOffset,
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md", className),
            ...props
        })
    });
}
function $c5bb23e187c19083$var$DropdownMenuItem({ className: className, inset: inset, variant: variant = "default", ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($e7bd25a108aa4fe5$export$6d08773d2e66f8f2, {
        "data-slot": "dropdown-menu-item",
        "data-inset": inset,
        "data-variant": variant,
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className),
        ...props
    });
}
function $c5bb23e187c19083$var$DropdownMenuSeparator({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($e7bd25a108aa4fe5$export$1ff3c3f08ae963c0, {
        "data-slot": "dropdown-menu-separator",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-border -mx-1 my-1 h-px", className),
        ...props
    });
}
function $c5bb23e187c19083$var$Label2({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($acc36a8a0b135d72$export$be92b6f5f03c0fe9, {
        "data-slot": "label",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", className),
        ...props
    });
}
var $c5bb23e187c19083$var$Form = (0, $9a9ac4df444a6447$export$8ce1ff4f94d08846);
var $c5bb23e187c19083$var$FormFieldContext = $7PdBe.createContext({});
var $c5bb23e187c19083$var$FormField = ({ ...props })=>{
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormFieldContext.Provider, {
        value: {
            name: props.name
        },
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $9a9ac4df444a6447$export$bd0bf19f25da8474), {
            ...props
        })
    });
};
var $c5bb23e187c19083$var$useFormField = ()=>{
    const fieldContext = $7PdBe.useContext($c5bb23e187c19083$var$FormFieldContext);
    const itemContext = $7PdBe.useContext($c5bb23e187c19083$var$FormItemContext);
    const { getFieldState: getFieldState } = (0, $9a9ac4df444a6447$export$4d957a5e1be13b03)();
    const formState = (0, $9a9ac4df444a6447$export$606f11b2eb45ecc6)({
        name: fieldContext.name
    });
    const fieldState = getFieldState(fieldContext.name, formState);
    if (!fieldContext) throw new Error("useFormField should be used within <FormField>");
    const { id: id } = itemContext;
    return {
        id: id,
        name: fieldContext.name,
        formItemId: `${id}-form-item`,
        formDescriptionId: `${id}-form-item-description`,
        formMessageId: `${id}-form-item-message`,
        ...fieldState
    };
};
var $c5bb23e187c19083$var$FormItemContext = $7PdBe.createContext({});
function $c5bb23e187c19083$var$FormItem({ className: className, ...props }) {
    const id = $7PdBe.useId();
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormItemContext.Provider, {
        value: {
            id: id
        },
        children: /* @__PURE__ */ (0, $hvk62.jsx)("div", {
            "data-slot": "form-item",
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-2", className),
            ...props
        })
    });
}
function $c5bb23e187c19083$var$FormLabel({ className: className, ...props }) {
    const { error: error, formItemId: formItemId } = $c5bb23e187c19083$var$useFormField();
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Label2, {
        "data-slot": "form-label",
        "data-error": !!error,
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("data-[error=true]:text-destructive", className),
        htmlFor: formItemId,
        ...props
    });
}
function $c5bb23e187c19083$var$FormControl({ ...props }) {
    const { error: error, formItemId: formItemId, formDescriptionId: formDescriptionId, formMessageId: formMessageId } = $c5bb23e187c19083$var$useFormField();
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $0deb3a18aa385379$export$be92b6f5f03c0fe9), {
        "data-slot": "form-control",
        id: formItemId,
        "aria-describedby": !error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`,
        "aria-invalid": !!error,
        ...props
    });
}
function $c5bb23e187c19083$var$FormMessage({ className: className, ...props }) {
    const { error: error, formMessageId: formMessageId } = $c5bb23e187c19083$var$useFormField();
    const body = error ? String((error == null ? void 0 : error.message) ?? "") : props.children;
    if (!body) return null;
    return /* @__PURE__ */ (0, $hvk62.jsx)("p", {
        "data-slot": "form-message",
        id: formMessageId,
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-destructive text-sm", className),
        ...props,
        children: body
    });
}
function $c5bb23e187c19083$var$Input({ className: className, type: type, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("input", {
        type: type,
        "data-slot": "input",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", className),
        ...props
    });
}
function $c5bb23e187c19083$var$Avatar({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($f8c59fb24ef52765$export$be92b6f5f03c0fe9, {
        "data-slot": "avatar",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative flex size-8 shrink-0 overflow-hidden rounded-full", className),
        ...props
    });
}
function $c5bb23e187c19083$var$AvatarImage({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($f8c59fb24ef52765$export$3e431a229df88919, {
        "data-slot": "avatar-image",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("aspect-square size-full", className),
        ...props
    });
}
function $c5bb23e187c19083$var$AvatarFallback({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($f8c59fb24ef52765$export$fb8d7f40caaeea67, {
        "data-slot": "avatar-fallback",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-muted flex size-full items-center justify-center rounded-full", className),
        ...props
    });
}
function $c5bb23e187c19083$export$61f623436a84786({ className: className, classNames: classNames, isPending: isPending, size: size, organization: organization, localization: propLocalization, ...props }) {
    const { localization: contextLocalization, avatar: avatar } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...propLocalization
        }), [
        contextLocalization,
        propLocalization
    ]);
    const name = organization == null ? void 0 : organization.name;
    const src = organization == null ? void 0 : organization.logo;
    if (isPending) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("shrink-0 rounded-full", size === "sm" ? "size-6" : size === "lg" ? "size-10" : size === "xl" ? "size-12" : "size-8", className, classNames == null ? void 0 : classNames.base, classNames == null ? void 0 : classNames.skeleton)
    });
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Avatar, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-muted", size === "sm" ? "size-6" : size === "lg" ? "size-10" : size === "xl" ? "size-12" : "size-8", className, classNames == null ? void 0 : classNames.base),
        ...props,
        children: [
            (avatar == null ? void 0 : avatar.Image) ? /* @__PURE__ */ (0, $hvk62.jsx)(avatar.Image, {
                alt: name || (localization == null ? void 0 : localization.ORGANIZATION),
                className: classNames == null ? void 0 : classNames.image,
                src: src || ""
            }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AvatarImage, {
                alt: name || (localization == null ? void 0 : localization.ORGANIZATION),
                className: classNames == null ? void 0 : classNames.image,
                src: src || void 0
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AvatarFallback, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-foreground", classNames == null ? void 0 : classNames.fallback),
                delayMs: src ? 600 : void 0,
                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $3c5c7b34b6c8fa4f$export$2e2bcd8739ae039), {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-[50%]", classNames == null ? void 0 : classNames.fallbackIcon)
                })
            })
        ]
    });
}
function $c5bb23e187c19083$export$5a688c9906fdd181({ className: className, classNames: classNames, localization: localizationProp, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { authClient: authClient, localization: contextLocalization, organization: organizationOptions, navigate: navigate, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const [logo, setLogo] = (0, $7PdBe.useState)(null);
    const [logoPending, setLogoPending] = (0, $7PdBe.useState)(false);
    const fileInputRef = (0, $7PdBe.useRef)(null);
    const openFileDialog = ()=>{
        var _a2;
        return (_a2 = fileInputRef.current) == null ? void 0 : _a2.click();
    };
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        logo: $034fa980286ebb75$export$22b082955e083ec3().optional(),
        name: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.ORGANIZATION_NAME} ${localization.IS_REQUIRED}`
        }),
        slug: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.ORGANIZATION_SLUG} ${localization.IS_REQUIRED}`
        }).regex(/^[a-z0-9-]+$/, {
            message: `${localization.ORGANIZATION_SLUG} ${localization.IS_INVALID}`
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            logo: "",
            name: "",
            slug: ""
        }
    });
    const isSubmitting = form.formState.isSubmitting;
    const handleLogoChange = async (file)=>{
        if (!(organizationOptions == null ? void 0 : organizationOptions.logo)) return;
        setLogoPending(true);
        try {
            const resizedFile = await $c5bb23e187c19083$var$resizeAndCropImage(file, crypto.randomUUID(), organizationOptions.logo.size, organizationOptions.logo.extension);
            let image;
            if (organizationOptions == null ? void 0 : organizationOptions.logo.upload) image = await organizationOptions.logo.upload(resizedFile);
            else image = await $c5bb23e187c19083$var$fileToBase64(resizedFile);
            setLogo(image || null);
            form.setValue("logo", image || "");
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setLogoPending(false);
    };
    const deleteLogo = async ()=>{
        var _a2;
        setLogoPending(true);
        const currentUrl = logo || void 0;
        if (currentUrl && ((_a2 = organizationOptions == null ? void 0 : organizationOptions.logo) == null ? void 0 : _a2.delete)) await organizationOptions.logo.delete(currentUrl);
        setLogo(null);
        form.setValue("logo", "");
        setLogoPending(false);
    };
    async function onSubmit({ name: name, slug: slug, logo: logo2 }) {
        try {
            const organization = await authClient.organization.create({
                name: name,
                slug: slug,
                logo: logo2,
                fetchOptions: {
                    throw: true
                }
            });
            if ((organizationOptions == null ? void 0 : organizationOptions.pathMode) === "slug") {
                navigate(`${organizationOptions.basePath}/${organization.slug}`);
                return;
            }
            await authClient.organization.setActive({
                organizationId: organization.id
            });
            onOpenChange == null || onOpenChange(false);
            form.reset();
            setLogo(null);
            toast({
                variant: "success",
                message: localization.CREATE_ORGANIZATION_SUCCESS
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content,
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization.CREATE_ORGANIZATION
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.ORGANIZATIONS_INSTRUCTIONS
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                    ...form,
                    children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
                        onSubmit: form.handleSubmit(onSubmit),
                        className: "space-y-6",
                        children: [
                            (organizationOptions == null ? void 0 : organizationOptions.logo) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "logo",
                                render: ()=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)("input", {
                                                ref: fileInputRef,
                                                accept: "image/*",
                                                disabled: logoPending,
                                                hidden: true,
                                                type: "file",
                                                onChange: (e)=>{
                                                    var _a2;
                                                    const file = (_a2 = e.target.files) == null ? void 0 : _a2.item(0);
                                                    if (file) handleLogoChange(file);
                                                    e.target.value = "";
                                                }
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                children: localization.LOGO
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                                className: "flex items-center gap-4",
                                                children: [
                                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                                                        children: [
                                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                                                                asChild: true,
                                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                                                    className: "size-fit rounded-full",
                                                                    size: "icon",
                                                                    type: "button",
                                                                    variant: "ghost",
                                                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$61f623436a84786, {
                                                                        className: "size-16",
                                                                        isPending: logoPending,
                                                                        localization: localization,
                                                                        organization: {
                                                                            name: form.watch("name"),
                                                                            logo: logo
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                                                                align: "start",
                                                                onCloseAutoFocus: (e)=>e.preventDefault(),
                                                                children: [
                                                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                                                        onClick: openFileDialog,
                                                                        disabled: logoPending,
                                                                        children: [
                                                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $c30ce99ee32b9b4f$export$2e2bcd8739ae039), {}),
                                                                            localization.UPLOAD_LOGO
                                                                        ]
                                                                    }),
                                                                    logo && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                                                        onClick: deleteLogo,
                                                                        disabled: logoPending,
                                                                        variant: "destructive",
                                                                        children: [
                                                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $28b54fce4c436a82$export$2e2bcd8739ae039), {}),
                                                                            localization.DELETE_LOGO
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                                        disabled: logoPending,
                                                        variant: "outline",
                                                        onClick: openFileDialog,
                                                        type: "button",
                                                        children: [
                                                            logoPending && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                                                className: "animate-spin"
                                                            }),
                                                            localization.UPLOAD
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "name",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                children: localization.ORGANIZATION_NAME
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                                    placeholder: localization.ORGANIZATION_NAME_PLACEHOLDER,
                                                    ...field
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "slug",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                children: localization.ORGANIZATION_SLUG
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                                    placeholder: localization.ORGANIZATION_SLUG_PLACEHOLDER,
                                                    ...field
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                                className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                        type: "button",
                                        variant: "outline",
                                        onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                                        children: localization.CANCEL
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                        type: "submit",
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                                        disabled: isSubmitting,
                                        children: [
                                            isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                                className: "animate-spin"
                                            }),
                                            localization.CREATE_ORGANIZATION
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$da1a8bd1e2e95ad({ className: className, classNames: classNames, isPending: isPending, size: size, organization: organization, localization: propLocalization }) {
    const { localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = {
        ...contextLocalization,
        ...propLocalization
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center gap-2 truncate", className, classNames == null ? void 0 : classNames.base),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$61f623436a84786, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(size !== "sm" && "my-0.5"),
                classNames: classNames == null ? void 0 : classNames.avatar,
                isPending: isPending,
                localization: localization,
                organization: organization,
                size: size
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex flex-col truncate text-left leading-tight", classNames == null ? void 0 : classNames.content),
                children: isPending ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("max-w-full", size === "lg" ? "h-4.5 w-32" : "h-3.5 w-24", classNames == null ? void 0 : classNames.title, classNames == null ? void 0 : classNames.skeleton)
                        }),
                        size !== "sm" && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("mt-1.5 max-w-full", size === "lg" ? "h-3.5 w-24" : "h-3 w-16", classNames == null ? void 0 : classNames.subtitle, classNames == null ? void 0 : classNames.skeleton)
                        })
                    ]
                }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("truncate font-semibold", size === "lg" ? "text-base" : "text-sm", classNames == null ? void 0 : classNames.title),
                            children: (organization == null ? void 0 : organization.name) || (localization == null ? void 0 : localization.ORGANIZATION)
                        }),
                        size !== "sm" && (organization == null ? void 0 : organization.slug) && /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("truncate opacity-70", size === "lg" ? "text-sm" : "text-xs", classNames == null ? void 0 : classNames.subtitle),
                            children: organization.slug
                        })
                    ]
                })
            })
        ]
    });
}
function $c5bb23e187c19083$var$LeaveOrganizationDialog({ organization: organization, className: className, classNames: classNames, localization: localizationProp, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { authClient: authClient, hooks: { useListOrganizations: useListOrganizations }, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { refetch: refetchOrganizations } = useListOrganizations();
    const [isLeaving, setIsLeaving] = (0, $7PdBe.useState)(false);
    const handleLeaveOrganization = async ()=>{
        setIsLeaving(true);
        try {
            await authClient.organization.leave({
                organizationId: organization.id,
                fetchOptions: {
                    throw: true
                }
            });
            await (refetchOrganizations == null ? void 0 : refetchOrganizations());
            toast({
                variant: "success",
                message: localization.LEAVE_ORGANIZATION_SUCCESS
            });
            onOpenChange == null || onOpenChange(false);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsLeaving(false);
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content,
            onOpenAutoFocus: (e)=>e.preventDefault(),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization.LEAVE_ORGANIZATION
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.LEAVE_ORGANIZATION_CONFIRM
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Card, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("my-2 flex-row p-4", className, classNames == null ? void 0 : classNames.cell),
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                        organization: organization,
                        localization: localization
                    })
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                    className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "outline",
                            onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                            disabled: isLeaving,
                            children: localization.CANCEL
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "destructive",
                            onClick: handleLeaveOrganization,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.destructiveButton),
                            disabled: isLeaving,
                            children: [
                                isLeaving && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                    className: "animate-spin"
                                }),
                                localization.LEAVE_ORGANIZATION
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$OrganizationCell({ className: className, classNames: classNames, organization: organization, localization: localizationProp }) {
    var _a;
    const { authClient: authClient, localization: contextLocalization, organization: organizationOptions, navigate: navigate, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { pathMode: pathMode } = organizationOptions || {};
    const [isLeaveDialogOpen, setIsLeaveDialogOpen] = (0, $7PdBe.useState)(false);
    const [isManagingOrganization, setIsManagingOrganization] = (0, $7PdBe.useState)(false);
    const handleManageOrganization = (0, $7PdBe.useCallback)(async ()=>{
        var _a2;
        setIsManagingOrganization(true);
        if (pathMode === "slug") {
            navigate(`${organizationOptions == null ? void 0 : organizationOptions.basePath}/${organization.slug}/${organizationOptions == null ? void 0 : organizationOptions.viewPaths.SETTINGS}`);
            return;
        }
        try {
            await authClient.organization.setActive({
                organizationId: organization.id,
                fetchOptions: {
                    throw: true
                }
            });
            navigate(`${organizationOptions == null ? void 0 : organizationOptions.basePath}/${(_a2 = organizationOptions == null ? void 0 : organizationOptions.viewPaths) == null ? void 0 : _a2.SETTINGS}`);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setIsManagingOrganization(false);
        }
    }, [
        authClient,
        organization.id,
        organizationOptions == null ? void 0 : organizationOptions.basePath,
        (_a = organizationOptions == null ? void 0 : organizationOptions.viewPaths) == null ? void 0 : _a.SETTINGS,
        organization.slug,
        pathMode,
        navigate,
        toast,
        localization
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row p-4", className, classNames == null ? void 0 : classNames.cell),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                        organization: organization,
                        localization: localization
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                                asChild: true,
                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                                    disabled: isManagingOrganization,
                                    size: "icon",
                                    type: "button",
                                    variant: "outline",
                                    children: isManagingOrganization ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                        className: "animate-spin"
                                    }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $9d2f9bea6f0d78a8$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    })
                                })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        onClick: handleManageOrganization,
                                        disabled: isManagingOrganization,
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $e7182fc0af14339c$export$2e2bcd8739ae039), {
                                                className: classNames == null ? void 0 : classNames.icon
                                            }),
                                            localization.MANAGE_ORGANIZATION
                                        ]
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        onClick: ()=>setIsLeaveDialogOpen(true),
                                        variant: "destructive",
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $2e97570e53b7162e$export$2e2bcd8739ae039), {
                                                className: classNames == null ? void 0 : classNames.icon
                                            }),
                                            localization.LEAVE_ORGANIZATION
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$LeaveOrganizationDialog, {
                open: isLeaveDialogOpen,
                onOpenChange: setIsLeaveDialogOpen,
                organization: organization,
                localization: localization
            })
        ]
    });
}
function $c5bb23e187c19083$export$93f9032b69be429e({ className: className, classNames: classNames, localization: localization, ...props }) {
    const { hooks: { useListOrganizations: useListOrganizations }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localization
        }), [
        contextLocalization,
        localization
    ]);
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const { data: organizations, isPending: organizationsPending } = useListOrganizations();
    const isPending = !isHydrated || organizationsPending;
    const [createDialogOpen, setCreateDialogOpen] = (0, $7PdBe.useState)(false);
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                title: localization.ORGANIZATIONS,
                description: localization.ORGANIZATIONS_DESCRIPTION,
                instructions: localization.ORGANIZATIONS_INSTRUCTIONS,
                actionLabel: localization.CREATE_ORGANIZATION,
                action: ()=>setCreateDialogOpen(true),
                isPending: isPending,
                ...props,
                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$CardContent, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
                    children: [
                        isPending && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$4cc32ea01a6b64cb, {}),
                        organizations == null ? void 0 : organizations.map((organization)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OrganizationCell, {
                                classNames: classNames,
                                organization: organization,
                                localization: localization
                            }, organization.id))
                    ]
                })
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$5a688c9906fdd181, {
                classNames: classNames,
                localization: localization,
                open: createDialogOpen,
                onOpenChange: setCreateDialogOpen
            })
        ]
    });
}
function $c5bb23e187c19083$var$getGravatarUrl(email, options) {
    if (!email) return null;
    try {
        const normalizedEmail = email.trim().toLowerCase();
        const encoder = new TextEncoder();
        const emailBytes = encoder.encode(normalizedEmail);
        const hash = (0, $9b412c1c8dc7e8e4$export$58b867e287a802c8)((0, $858c77bb5141d899$export$bced8d2aada2d1c9)(emailBytes));
        const extension = (options == null ? void 0 : options.jpg) ? ".jpg" : "";
        let url = `https://gravatar.com/avatar/${hash}${extension}`;
        const params = new URLSearchParams();
        if (options == null ? void 0 : options.size) params.append("s", Math.min(Math.max(options.size, 1), 2048).toString());
        if (options == null ? void 0 : options.d) params.append("d", options.d);
        if (options == null ? void 0 : options.forceDefault) params.append("f", "y");
        const queryString = params.toString();
        if (queryString) url += `?${queryString}`;
        return url;
    } catch (error) {
        console.error("Error generating Gravatar URL:", error);
        return null;
    }
}
function $c5bb23e187c19083$export$6c0524ba53950d9f({ className: className, classNames: classNames, isPending: isPending, size: size, user: user, localization: propLocalization, ...props }) {
    const { localization: contextLocalization, gravatar: gravatar, avatar: avatar } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = {
        ...contextLocalization,
        ...propLocalization
    };
    const name = (user == null ? void 0 : user.displayName) || (user == null ? void 0 : user.name) || (user == null ? void 0 : user.fullName) || (user == null ? void 0 : user.firstName) || (user == null ? void 0 : user.displayUsername) || (user == null ? void 0 : user.username) || (user == null ? void 0 : user.email);
    const userImage = (user == null ? void 0 : user.image) || (user == null ? void 0 : user.avatar) || (user == null ? void 0 : user.avatarUrl);
    const gravatarUrl = gravatar && (user == null ? void 0 : user.email) ? $c5bb23e187c19083$var$getGravatarUrl(user.email, gravatar === true ? void 0 : gravatar) : null;
    const src = gravatar ? gravatarUrl : userImage;
    if (isPending) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("shrink-0 rounded-full", size === "sm" ? "size-6" : size === "lg" ? "size-10" : size === "xl" ? "size-12" : "size-8", className, classNames == null ? void 0 : classNames.base, classNames == null ? void 0 : classNames.skeleton)
    });
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Avatar, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-muted", size === "sm" ? "size-6" : size === "lg" ? "size-10" : size === "xl" ? "size-12" : "size-8", className, classNames == null ? void 0 : classNames.base),
        ...props,
        children: [
            (avatar == null ? void 0 : avatar.Image) ? /* @__PURE__ */ (0, $hvk62.jsx)(avatar.Image, {
                alt: name || (localization == null ? void 0 : localization.USER),
                className: classNames == null ? void 0 : classNames.image,
                src: src || ""
            }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AvatarImage, {
                alt: name || (localization == null ? void 0 : localization.USER),
                className: classNames == null ? void 0 : classNames.image,
                src: src || void 0
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AvatarFallback, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-foreground uppercase", classNames == null ? void 0 : classNames.fallback),
                delayMs: src ? 600 : void 0,
                children: $c5bb23e187c19083$var$firstTwoCharacters(name) || /* @__PURE__ */ (0, $hvk62.jsx)((0, $bfd39e716df2888f$export$2e2bcd8739ae039), {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-[50%]", classNames == null ? void 0 : classNames.fallbackIcon)
                })
            })
        ]
    });
}
var $c5bb23e187c19083$var$firstTwoCharacters = (name)=>name == null ? void 0 : name.slice(0, 2);
function $c5bb23e187c19083$export$72f118cc20e62477({ className: className, classNames: classNames, localization: localizationProp, ...props }) {
    const { hooks: { useListUserInvitations: useListUserInvitations, useListOrganizations: useListOrganizations }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: invitations, refetch: refetchInvitations } = useListUserInvitations();
    const { refetch: refetchOrganizations } = useListOrganizations();
    const handleRefresh = async ()=>{
        await (refetchInvitations == null ? void 0 : refetchInvitations());
        await (refetchOrganizations == null ? void 0 : refetchOrganizations());
    };
    const pendingInvitations = invitations == null ? void 0 : invitations.filter((invitation)=>invitation.status === "pending");
    if (!(pendingInvitations == null ? void 0 : pendingInvitations.length)) return null;
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        title: localization.PENDING_INVITATIONS,
        description: localization.PENDING_USER_INVITATIONS_DESCRIPTION || localization.PENDING_INVITATIONS_DESCRIPTION,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
            children: pendingInvitations.map((invitation)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$UserInvitationRow, {
                    classNames: classNames,
                    invitation: {
                        id: invitation.id,
                        email: invitation.email,
                        role: invitation.role,
                        status: invitation.status,
                        expiresAt: invitation.expiresAt
                    },
                    onChanged: handleRefresh
                }, invitation.id))
        })
    });
}
function $c5bb23e187c19083$var$UserInvitationRow({ classNames: classNames, invitation: invitation, onChanged: onChanged }) {
    const { authClient: authClient, organization: organizationOptions, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = contextLocalization;
    const [isLoading, setIsLoading] = (0, $7PdBe.useState)(false);
    const builtInRoles = [
        {
            role: "owner",
            label: localization.OWNER
        },
        {
            role: "admin",
            label: localization.ADMIN
        },
        {
            role: "member",
            label: localization.MEMBER
        }
    ];
    const roles = [
        ...builtInRoles,
        ...(organizationOptions == null ? void 0 : organizationOptions.customRoles) || []
    ];
    const role = roles.find((r)=>r.role === invitation.role);
    const handleAccept = async ()=>{
        setIsLoading(true);
        try {
            await authClient.organization.acceptInvitation({
                invitationId: invitation.id,
                fetchOptions: {
                    throw: true
                }
            });
            await (onChanged == null ? void 0 : onChanged());
            toast({
                variant: "success",
                message: localization.INVITATION_ACCEPTED
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsLoading(false);
    };
    const handleReject = async ()=>{
        setIsLoading(true);
        try {
            await authClient.organization.rejectInvitation({
                invitationId: invitation.id,
                fetchOptions: {
                    throw: true
                }
            });
            await (onChanged == null ? void 0 : onChanged());
            toast({
                variant: "success",
                message: localization.INVITATION_REJECTED
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsLoading(false);
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center p-4", classNames == null ? void 0 : classNames.cell),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex flex-1 items-center gap-2",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6c0524ba53950d9f, {
                        className: "my-0.5",
                        user: {
                            email: invitation.email
                        },
                        localization: localization
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                        className: "grid flex-1 text-left leading-tight",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                                className: "truncate font-semibold text-sm",
                                children: invitation.email
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)("span", {
                                className: "truncate text-muted-foreground text-xs",
                                children: [
                                    localization.EXPIRES,
                                    " ",
                                    invitation.expiresAt.toLocaleDateString()
                                ]
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                className: "truncate text-sm opacity-70",
                children: role == null ? void 0 : role.label
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                className: "flex items-center gap-2",
                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                            asChild: true,
                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                                disabled: isLoading,
                                size: "icon",
                                type: "button",
                                variant: "outline",
                                children: isLoading ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                    className: "animate-spin"
                                }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $9d2f9bea6f0d78a8$export$2e2bcd8739ae039), {
                                    className: classNames == null ? void 0 : classNames.icon
                                })
                            })
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                            onCloseAutoFocus: (e)=>e.preventDefault(),
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    onClick: handleAccept,
                                    disabled: isLoading,
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $bf8cdbeb7c4555a4$export$2e2bcd8739ae039), {
                                            className: classNames == null ? void 0 : classNames.icon
                                        }),
                                        localization.ACCEPT
                                    ]
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    onClick: handleReject,
                                    disabled: isLoading,
                                    variant: "destructive",
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $f5645b1fe1001619$export$2e2bcd8739ae039), {
                                            className: classNames == null ? void 0 : classNames.icon
                                        }),
                                        localization.REJECT
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $c5bb23e187c19083$export$93c94555daa109c4({ className: className, classNames: classNames, isPending: isPending, size: size, user: user, localization: propLocalization }) {
    const { localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...propLocalization
        }), [
        contextLocalization,
        propLocalization
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center gap-2", className, classNames == null ? void 0 : classNames.base),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6c0524ba53950d9f, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(size !== "sm" && "my-0.5"),
                classNames: classNames == null ? void 0 : classNames.avatar,
                isPending: isPending,
                size: size,
                user: user,
                localization: localization
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid flex-1 text-left leading-tight", classNames == null ? void 0 : classNames.content),
                children: isPending ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("max-w-full", size === "lg" ? "h-4.5 w-32" : "h-3.5 w-24", classNames == null ? void 0 : classNames.title, classNames == null ? void 0 : classNames.skeleton)
                        }),
                        size !== "sm" && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("mt-1.5 max-w-full", size === "lg" ? "h-3.5 w-40" : "h-3 w-32", classNames == null ? void 0 : classNames.subtitle, classNames == null ? void 0 : classNames.skeleton)
                        })
                    ]
                }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("truncate font-semibold", size === "lg" ? "text-base" : "text-sm", classNames == null ? void 0 : classNames.title),
                            children: (user == null ? void 0 : user.displayName) || (user == null ? void 0 : user.name) || (user == null ? void 0 : user.fullName) || (user == null ? void 0 : user.firstName) || (user == null ? void 0 : user.displayUsername) || (user == null ? void 0 : user.username) || (user == null ? void 0 : user.email) || (localization == null ? void 0 : localization.USER)
                        }),
                        !(user == null ? void 0 : user.isAnonymous) && size !== "sm" && ((user == null ? void 0 : user.name) || (user == null ? void 0 : user.username)) && /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("truncate opacity-70", size === "lg" ? "text-sm" : "text-xs", classNames == null ? void 0 : classNames.subtitle),
                            children: user == null ? void 0 : user.email
                        })
                    ]
                })
            })
        ]
    });
}
function $c5bb23e187c19083$var$AccountCell({ className: className, classNames: classNames, deviceSession: deviceSession, localization: localization, refetch: refetch }) {
    const { basePath: basePath, localization: contextLocalization, hooks: { useSession: useSession }, mutators: { revokeDeviceSession: revokeDeviceSession, setActiveSession: setActiveSession }, toast: toast, viewPaths: viewPaths, navigate: navigate } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: sessionData } = useSession();
    const [isLoading, setIsLoading] = (0, $7PdBe.useState)(false);
    const handleRevoke = async ()=>{
        setIsLoading(true);
        try {
            await revokeDeviceSession({
                sessionToken: deviceSession.session.token
            });
            refetch == null || refetch();
        } catch (error) {
            setIsLoading(false);
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    const handleSetActiveSession = async ()=>{
        setIsLoading(true);
        try {
            await setActiveSession({
                sessionToken: deviceSession.session.token
            });
            refetch == null || refetch();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsLoading(false);
    };
    const isCurrentSession = deviceSession.session.id === (sessionData == null ? void 0 : sessionData.session.id);
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row p-4", className, classNames == null ? void 0 : classNames.cell),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$93c94555daa109c4, {
                user: deviceSession.user,
                localization: localization
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                        asChild: true,
                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                            disabled: isLoading,
                            size: "icon",
                            type: "button",
                            variant: "outline",
                            children: isLoading ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                className: "animate-spin"
                            }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $9d2f9bea6f0d78a8$export$2e2bcd8739ae039), {
                                className: classNames == null ? void 0 : classNames.icon
                            })
                        })
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                        children: [
                            !isCurrentSession && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                onClick: handleSetActiveSession,
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)((0, $667851380e8e7d6d$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    }),
                                    localization.SWITCH_ACCOUNT
                                ]
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                onClick: ()=>{
                                    if (isCurrentSession) {
                                        navigate(`${basePath}/${viewPaths.SIGN_OUT}`);
                                        return;
                                    }
                                    handleRevoke();
                                },
                                variant: "destructive",
                                children: [
                                    isCurrentSession ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $2e97570e53b7162e$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $c97b93ac65ea0586$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    }),
                                    isCurrentSession ? localization.SIGN_OUT : localization.REVOKE
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$export$92c499fe94508e4f({ className: className, classNames: classNames, localization: localization }) {
    const { basePath: basePath, hooks: { useListDeviceSessions: useListDeviceSessions, useSession: useSession }, localization: contextLocalization, viewPaths: viewPaths, navigate: navigate } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: deviceSessions, isPending: isPending, refetch: refetch } = useListDeviceSessions();
    const { data: sessionData } = useSession();
    const otherDeviceSessions = (deviceSessions || []).filter((ds)=>ds.session.id !== (sessionData == null ? void 0 : sessionData.session.id));
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        title: localization.ACCOUNTS,
        description: localization.ACCOUNTS_DESCRIPTION,
        actionLabel: localization.ADD_ACCOUNT,
        instructions: localization.ACCOUNTS_INSTRUCTIONS,
        isPending: isPending,
        action: ()=>navigate(`${basePath}/${viewPaths.SIGN_IN}`),
        children: (deviceSessions == null ? void 0 : deviceSessions.length) && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$CardContent, {
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
            children: [
                sessionData && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AccountCell, {
                    classNames: classNames,
                    deviceSession: sessionData,
                    localization: localization,
                    refetch: refetch
                }),
                otherDeviceSessions.map((deviceSession)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AccountCell, {
                        classNames: classNames,
                        deviceSession: deviceSession,
                        localization: localization,
                        refetch: refetch
                    }, deviceSession.session.id))
            ]
        })
    });
}
function $c5bb23e187c19083$export$a0fe7f8ce5df8958({ className: className, classNames: classNames, localization: localization, ...props }) {
    const { hooks: { useSession: useSession }, mutators: { updateUser: updateUser }, localization: authLocalization2, optimistic: optimistic, avatar: avatar, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...authLocalization2,
        ...localization
    };
    const { data: sessionData, isPending: isPending, refetch: refetch } = useSession();
    const fileInputRef = (0, $7PdBe.useRef)(null);
    const [loading, setLoading] = (0, $7PdBe.useState)(false);
    const handleAvatarChange = async (file)=>{
        if (!sessionData || !avatar) return;
        setLoading(true);
        const resizedFile = await $c5bb23e187c19083$var$resizeAndCropImage(file, crypto.randomUUID(), avatar.size, avatar.extension);
        let image;
        if (avatar.upload) image = await avatar.upload(resizedFile);
        else image = await $c5bb23e187c19083$var$fileToBase64(resizedFile);
        if (!image) {
            setLoading(false);
            return;
        }
        if (optimistic && !avatar.upload) setLoading(false);
        try {
            await updateUser({
                image: image
            });
            await (refetch == null ? void 0 : refetch());
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setLoading(false);
    };
    const handleDeleteAvatar = async ()=>{
        if (!sessionData) return;
        setLoading(true);
        try {
            if (sessionData.user.image && (avatar == null ? void 0 : avatar.delete)) await avatar.delete(sessionData.user.image);
            await updateUser({
                image: null
            });
            await (refetch == null ? void 0 : refetch());
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setLoading(false);
    };
    const openFileDialog = ()=>{
        var _a;
        return (_a = fileInputRef.current) == null ? void 0 : _a.click();
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full pb-0 text-start", className, classNames == null ? void 0 : classNames.base),
        ...props,
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("input", {
                ref: fileInputRef,
                accept: "image/*",
                disabled: loading,
                hidden: true,
                type: "file",
                onChange: (e)=>{
                    var _a;
                    const file = (_a = e.target.files) == null ? void 0 : _a.item(0);
                    if (file) handleAvatarChange(file);
                    e.target.value = "";
                }
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsCardHeader, {
                        className: "grow self-start",
                        title: localization.AVATAR,
                        description: localization.AVATAR_DESCRIPTION,
                        isPending: isPending,
                        classNames: classNames
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                                asChild: true,
                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                    className: "me-6 size-fit rounded-full",
                                    size: "icon",
                                    variant: "ghost",
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6c0524ba53950d9f, {
                                        isPending: isPending || loading,
                                        className: "size-20 text-2xl",
                                        classNames: classNames == null ? void 0 : classNames.avatar,
                                        user: sessionData == null ? void 0 : sessionData.user,
                                        localization: localization
                                    }, sessionData == null ? void 0 : sessionData.user.image)
                                })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                                align: "end",
                                onCloseAutoFocus: (e)=>e.preventDefault(),
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        onClick: openFileDialog,
                                        disabled: loading,
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $c30ce99ee32b9b4f$export$2e2bcd8739ae039), {}),
                                            localization.UPLOAD_AVATAR
                                        ]
                                    }),
                                    (sessionData == null ? void 0 : sessionData.user.image) && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        onClick: handleDeleteAvatar,
                                        disabled: loading,
                                        variant: "destructive",
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $28b54fce4c436a82$export$2e2bcd8739ae039), {}),
                                            localization.DELETE_AVATAR
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsCardFooter, {
                className: "!py-5",
                instructions: localization.AVATAR_INSTRUCTIONS,
                classNames: classNames,
                isPending: isPending,
                isSubmitting: loading
            })
        ]
    });
}
function $c5bb23e187c19083$var$Checkbox({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($5b5eb1673d93610f$export$48513f6b9f8ce62d, {
        "data-slot": "checkbox",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50", className),
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($5b5eb1673d93610f$export$59aad738f51d1c05, {
            "data-slot": "checkbox-indicator",
            className: "flex items-center justify-center text-current transition-none",
            children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $bf8cdbeb7c4555a4$export$2e2bcd8739ae039), {
                className: "size-3.5"
            })
        })
    });
}
function $c5bb23e187c19083$var$Textarea({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("textarea", {
        "data-slot": "textarea",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className),
        ...props
    });
}
function $c5bb23e187c19083$export$c6c9843d22fcfd26({ className: className, classNames: classNames, description: description, instructions: instructions, localization: localizationProp, name: name, placeholder: placeholder, required: required, label: label, type: type, multiline: multiline, value: value, validate: validate }) {
    const { hooks: { useSession: useSession }, mutators: { updateUser: updateUser }, localization: contextLocalization, optimistic: optimistic, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { isPending: isPending } = useSession();
    let fieldSchema = $034fa980286ebb75$export$19282c40b967aec6();
    if (type === "number") fieldSchema = required ? $034fa980286ebb75$export$fc37fe19dfda43ee((val)=>!val ? void 0 : Number(val), $034fa980286ebb75$export$98e628dec113755e({
        message: `${label} ${localization.IS_INVALID}`
    })) : $034fa980286ebb75$export$8c14e57e778d3873.number({
        message: `${label} ${localization.IS_INVALID}`
    }).optional();
    else if (type === "boolean") fieldSchema = required ? $034fa980286ebb75$export$8c14e57e778d3873.boolean({
        message: `${label} ${localization.IS_INVALID}`
    }).refine((val)=>val === true, {
        message: `${label} ${localization.IS_REQUIRED}`
    }) : $034fa980286ebb75$export$8c14e57e778d3873.boolean({
        message: `${label} ${localization.IS_INVALID}`
    });
    else fieldSchema = required ? $034fa980286ebb75$export$22b082955e083ec3().min(1, `${label} ${localization.IS_REQUIRED}`) : $034fa980286ebb75$export$22b082955e083ec3().optional();
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)($034fa980286ebb75$export$be5493f9613cbbe({
            [name]: fieldSchema
        })),
        values: {
            [name]: value || ""
        }
    });
    const { isSubmitting: isSubmitting } = form.formState;
    const updateField = async (values)=>{
        await new Promise((resolve)=>setTimeout(resolve));
        const newValue = values[name];
        if (value === newValue) {
            toast({
                variant: "error",
                message: `${label} ${localization.IS_THE_SAME}`
            });
            return;
        }
        if (validate && typeof newValue === "string" && !await validate(newValue)) {
            form.setError(name, {
                message: `${label} ${localization.IS_INVALID}`
            });
            return;
        }
        try {
            await updateUser({
                [name]: newValue
            });
            toast({
                variant: "success",
                message: `${label} ${localization.UPDATED_SUCCESSFULLY}`
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsx)("form", {
            onSubmit: form.handleSubmit(updateField),
            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                description: description,
                instructions: instructions,
                isPending: isPending,
                title: label,
                actionLabel: localization.SAVE,
                optimistic: optimistic,
                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
                    className: classNames == null ? void 0 : classNames.content,
                    children: type === "boolean" ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                        control: form.control,
                        name: name,
                        render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                className: "flex",
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Checkbox, {
                                            checked: field.value,
                                            onCheckedChange: field.onChange,
                                            disabled: isSubmitting,
                                            className: classNames == null ? void 0 : classNames.checkbox
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                        className: classNames == null ? void 0 : classNames.label,
                                        children: label
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                        className: classNames == null ? void 0 : classNames.error
                                    })
                                ]
                            })
                    }) : isPending ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-9 w-full", classNames == null ? void 0 : classNames.skeleton)
                    }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                        control: form.control,
                        name: name,
                        render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                        children: type === "number" ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                            className: classNames == null ? void 0 : classNames.input,
                                            type: "number",
                                            placeholder: placeholder || (typeof label === "string" ? label : ""),
                                            disabled: isSubmitting,
                                            ...field,
                                            value: field.value
                                        }) : multiline ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Textarea, {
                                            className: classNames == null ? void 0 : classNames.input,
                                            placeholder: placeholder || (typeof label === "string" ? label : ""),
                                            disabled: isSubmitting,
                                            ...field,
                                            value: field.value
                                        }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                            className: classNames == null ? void 0 : classNames.input,
                                            type: "text",
                                            placeholder: placeholder || (typeof label === "string" ? label : ""),
                                            disabled: isSubmitting,
                                            ...field,
                                            value: field.value
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                        className: classNames == null ? void 0 : classNames.error
                                    })
                                ]
                            })
                    })
                })
            })
        })
    });
}
function $c5bb23e187c19083$export$ce562489f11211bb({ className: className, classNames: classNames, localization: localization, ...props }) {
    const { hooks: { useSession: useSession }, localization: contextLocalization, nameRequired: nameRequired } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: sessionData } = useSession();
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$c6c9843d22fcfd26, {
        className: className,
        classNames: classNames,
        value: sessionData == null ? void 0 : sessionData.user.name,
        description: localization.NAME_DESCRIPTION,
        name: "name",
        instructions: localization.NAME_INSTRUCTIONS,
        label: localization.NAME,
        localization: localization,
        placeholder: localization.NAME_PLACEHOLDER,
        required: nameRequired,
        ...props
    });
}
function $c5bb23e187c19083$export$2a43a3bf0df0716b({ className: className, classNames: classNames, localization: localization, ...props }) {
    var _a, _b;
    const { hooks: { useSession: useSession }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: sessionData } = useSession();
    const value = ((_a = sessionData == null ? void 0 : sessionData.user) == null ? void 0 : _a.displayUsername) || ((_b = sessionData == null ? void 0 : sessionData.user) == null ? void 0 : _b.username);
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$c6c9843d22fcfd26, {
        className: className,
        classNames: classNames,
        value: value,
        description: localization.USERNAME_DESCRIPTION,
        name: "username",
        instructions: localization.USERNAME_INSTRUCTIONS,
        label: localization.USERNAME,
        localization: localization,
        placeholder: localization.USERNAME_PLACEHOLDER,
        required: true,
        ...props
    });
}
function $c5bb23e187c19083$export$d0b1d0a671230c9b({ className: className, classNames: classNames, localization: localization, ...props }) {
    const { authClient: authClient, emailVerification: emailVerification, hooks: { useSession: useSession }, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: sessionData, isPending: isPending, refetch: refetch } = useSession();
    const [resendDisabled, setResendDisabled] = (0, $7PdBe.useState)(false);
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        email: $034fa980286ebb75$export$22b082955e083ec3().email({
            message: localization.INVALID_EMAIL
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        values: {
            email: (sessionData == null ? void 0 : sessionData.user.email) || ""
        }
    });
    const resendForm = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)();
    const { isSubmitting: isSubmitting } = form.formState;
    const changeEmail = async ({ email: email })=>{
        if (email === (sessionData == null ? void 0 : sessionData.user.email)) {
            await new Promise((resolve)=>setTimeout(resolve));
            toast({
                variant: "error",
                message: localization.EMAIL_IS_THE_SAME
            });
            return;
        }
        try {
            await authClient.changeEmail({
                newEmail: email,
                callbackURL: window.location.pathname,
                fetchOptions: {
                    throw: true
                }
            });
            if (sessionData == null ? void 0 : sessionData.user.emailVerified) toast({
                variant: "success",
                message: localization.EMAIL_VERIFY_CHANGE
            });
            else {
                await (refetch == null ? void 0 : refetch());
                toast({
                    variant: "success",
                    message: `${localization.EMAIL} ${localization.UPDATED_SUCCESSFULLY}`
                });
            }
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    const resendVerification = async ()=>{
        if (!sessionData) return;
        const email = sessionData.user.email;
        setResendDisabled(true);
        try {
            await authClient.sendVerificationEmail({
                email: email,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.EMAIL_VERIFICATION
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setResendDisabled(false);
            throw error;
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                ...form,
                children: /* @__PURE__ */ (0, $hvk62.jsx)("form", {
                    noValidate: true,
                    onSubmit: form.handleSubmit(changeEmail),
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                        className: className,
                        classNames: classNames,
                        description: localization.EMAIL_DESCRIPTION,
                        instructions: localization.EMAIL_INSTRUCTIONS,
                        isPending: isPending,
                        title: localization.EMAIL,
                        actionLabel: localization.SAVE,
                        ...props,
                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
                            className: classNames == null ? void 0 : classNames.content,
                            children: isPending ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-9 w-full", classNames == null ? void 0 : classNames.skeleton)
                            }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "email",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                                    className: classNames == null ? void 0 : classNames.input,
                                                    placeholder: localization.EMAIL_PLACEHOLDER,
                                                    type: "email",
                                                    disabled: isSubmitting,
                                                    ...field
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                                className: classNames == null ? void 0 : classNames.error
                                            })
                                        ]
                                    })
                            })
                        })
                    })
                })
            }),
            emailVerification && (sessionData == null ? void 0 : sessionData.user) && !(sessionData == null ? void 0 : sessionData.user.emailVerified) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                ...resendForm,
                children: /* @__PURE__ */ (0, $hvk62.jsx)("form", {
                    onSubmit: resendForm.handleSubmit(resendVerification),
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                        className: className,
                        classNames: classNames,
                        title: localization.VERIFY_YOUR_EMAIL,
                        description: localization.VERIFY_YOUR_EMAIL_DESCRIPTION,
                        actionLabel: localization.RESEND_VERIFICATION_EMAIL,
                        disabled: resendDisabled,
                        ...props
                    })
                })
            })
        ]
    });
}
function $c5bb23e187c19083$export$db800a74e878c520({ className: className, classNames: classNames, localization: localization }) {
    var _a, _b, _c;
    const { additionalFields: additionalFields, avatar: avatar, changeEmail: changeEmail, credentials: credentials, hooks: { useSession: useSession }, multiSession: multiSession, account: accountOptions } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { data: sessionData } = useSession();
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-full flex-col gap-4 md:gap-6", className, classNames == null ? void 0 : classNames.cards),
        children: [
            ((_a = accountOptions == null ? void 0 : accountOptions.fields) == null ? void 0 : _a.includes("image")) && avatar && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$a0fe7f8ce5df8958, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            }),
            (credentials == null ? void 0 : credentials.username) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$2a43a3bf0df0716b, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            }),
            ((_b = accountOptions == null ? void 0 : accountOptions.fields) == null ? void 0 : _b.includes("name")) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$ce562489f11211bb, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            }),
            changeEmail && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d0b1d0a671230c9b, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            }),
            (_c = accountOptions == null ? void 0 : accountOptions.fields) == null ? void 0 : _c.map((field)=>{
                if (field === "image") return null;
                if (field === "name") return null;
                const additionalField = additionalFields == null ? void 0 : additionalFields[field];
                if (!additionalField) return null;
                const { label: label, description: description, instructions: instructions, placeholder: placeholder, required: required, type: type, multiline: multiline, validate: validate } = additionalField;
                const defaultValue = sessionData == null ? void 0 : sessionData.user[field];
                return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$c6c9843d22fcfd26, {
                    classNames: classNames == null ? void 0 : classNames.card,
                    value: defaultValue,
                    description: description,
                    name: field,
                    instructions: instructions,
                    label: label,
                    localization: localization,
                    placeholder: placeholder,
                    required: required,
                    type: type,
                    multiline: multiline,
                    validate: validate
                }, field);
            }),
            multiSession && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$92c499fe94508e4f, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            })
        ]
    });
}
function $c5bb23e187c19083$var$ApiKeyDeleteDialog({ classNames: classNames, apiKey: apiKey, localization: localization, refetch: refetch, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { localization: contextLocalization, mutators: { deleteApiKey: deleteApiKey }, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { lang: lang } = (0, $07d0275849708341$export$b24a004ee43dce44)();
    const [isLoading, setIsLoading] = (0, $7PdBe.useState)(false);
    const handleDelete = async ()=>{
        setIsLoading(true);
        try {
            await deleteApiKey({
                keyId: apiKey.id
            });
            await (refetch == null ? void 0 : refetch());
            onOpenChange == null || onOpenChange(false);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsLoading(false);
    };
    const formatExpiration = ()=>{
        if (!apiKey.expiresAt) return localization.NEVER_EXPIRES;
        const expiresDate = new Date(apiKey.expiresAt);
        return `${localization.EXPIRES} ${expiresDate.toLocaleDateString(lang ?? "en", {
            month: "short",
            day: "numeric",
            year: "numeric"
        })}`;
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            onOpenAutoFocus: (e)=>e.preventDefault(),
            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content,
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: [
                                localization.DELETE,
                                " ",
                                localization.API_KEY
                            ]
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.DELETE_API_KEY_CONFIRM
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("my-2 flex-row items-center gap-3 px-4 py-3", classNames == null ? void 0 : classNames.cell),
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $68f6b959252c02b7$export$2e2bcd8739ae039), {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-4", classNames == null ? void 0 : classNames.icon)
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                                            className: "font-semibold text-sm",
                                            children: apiKey.name
                                        }),
                                        /* @__PURE__ */ (0, $hvk62.jsxs)("span", {
                                            className: "text-muted-foreground text-sm",
                                            children: [
                                                apiKey.start,
                                                "******"
                                            ]
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                                    className: "text-muted-foreground text-xs",
                                    children: formatExpiration()
                                })
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                    className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "secondary",
                            onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                            disabled: isLoading,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.secondaryButton),
                            children: localization.CANCEL
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "destructive",
                            onClick: handleDelete,
                            disabled: isLoading,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.destructiveButton),
                            children: [
                                isLoading && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                    className: "animate-spin"
                                }),
                                localization.DELETE
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$ApiKeyCell({ className: className, classNames: classNames, apiKey: apiKey, localization: localization, refetch: refetch }) {
    const { localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { lang: lang } = (0, $07d0275849708341$export$b24a004ee43dce44)();
    const [showDeleteDialog, setShowDeleteDialog] = (0, $7PdBe.useState)(false);
    const formatExpiration = ()=>{
        if (!apiKey.expiresAt) return localization.NEVER_EXPIRES;
        const expiresDate = new Date(apiKey.expiresAt);
        return `${localization.EXPIRES} ${expiresDate.toLocaleDateString(lang ?? "en", {
            month: "short",
            day: "numeric",
            year: "numeric"
        })}`;
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center gap-3 truncate px-4 py-3", className, classNames == null ? void 0 : classNames.cell),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)((0, $68f6b959252c02b7$export$2e2bcd8739ae039), {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-4 flex-shrink-0", classNames == null ? void 0 : classNames.icon)
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                        className: "flex flex-col truncate",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                                        className: "truncate font-semibold text-sm",
                                        children: apiKey.name
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)("span", {
                                        className: "flex-1 truncate text-muted-foreground text-sm",
                                        children: [
                                            apiKey.start,
                                            "******"
                                        ]
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                                className: "truncate text-muted-foreground text-xs",
                                children: formatExpiration()
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                        size: "sm",
                        variant: "outline",
                        onClick: ()=>setShowDeleteDialog(true),
                        children: localization.DELETE
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$ApiKeyDeleteDialog, {
                classNames: classNames,
                apiKey: apiKey,
                localization: localization,
                open: showDeleteDialog,
                onOpenChange: setShowDeleteDialog,
                refetch: refetch
            })
        ]
    });
}
function $c5bb23e187c19083$var$ApiKeyDisplayDialog({ classNames: classNames, apiKey: apiKey, localization: localization, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const [copied, setCopied] = (0, $7PdBe.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(apiKey);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2e3);
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            onOpenAutoFocus: (e)=>e.preventDefault(),
            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content,
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization.API_KEY_CREATED
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.CREATE_API_KEY_SUCCESS
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                    className: "break-all rounded-md bg-muted p-4 font-mono text-sm",
                    children: apiKey
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                    className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "outline",
                            onClick: handleCopy,
                            disabled: copied,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                            children: copied ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)((0, $bf8cdbeb7c4555a4$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    }),
                                    localization.COPIED_TO_CLIPBOARD
                                ]
                            }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)((0, $0ff2a797c5b6f40a$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    }),
                                    localization.COPY_TO_CLIPBOARD
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "default",
                            onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                            children: localization.DONE
                        })
                    ]
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$PersonalAccountView({ className: className, classNames: classNames, isPending: isPending, size: size, user: user, localization: propLocalization }) {
    const { localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...propLocalization
        }), [
        contextLocalization,
        propLocalization
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center gap-2", className, classNames == null ? void 0 : classNames.base),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6c0524ba53950d9f, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(size !== "sm" && "my-0.5"),
                classNames: classNames == null ? void 0 : classNames.avatar,
                isPending: isPending,
                localization: localization,
                size: size,
                user: user
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid flex-1 text-left leading-tight", classNames == null ? void 0 : classNames.content),
                children: isPending ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("max-w-full", size === "lg" ? "h-4.5 w-32" : "h-3.5 w-24", classNames == null ? void 0 : classNames.title, classNames == null ? void 0 : classNames.skeleton)
                        }),
                        size !== "sm" && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("mt-1.5 max-w-full", size === "lg" ? "h-3.5 w-40" : "h-3 w-32", classNames == null ? void 0 : classNames.subtitle, classNames == null ? void 0 : classNames.skeleton)
                        })
                    ]
                }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("truncate font-semibold", size === "lg" ? "text-base" : "text-sm", classNames == null ? void 0 : classNames.title),
                            children: (user == null ? void 0 : user.displayName) || (user == null ? void 0 : user.name) || (user == null ? void 0 : user.fullName) || (user == null ? void 0 : user.firstName) || (user == null ? void 0 : user.displayUsername) || (user == null ? void 0 : user.username) || (user == null ? void 0 : user.email) || (localization == null ? void 0 : localization.USER)
                        }),
                        size !== "sm" && /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("truncate opacity-70", size === "lg" ? "text-sm" : "text-xs", classNames == null ? void 0 : classNames.subtitle),
                            children: localization == null ? void 0 : localization.PERSONAL_ACCOUNT
                        })
                    ]
                })
            })
        ]
    });
}
function $c5bb23e187c19083$var$Select({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$be92b6f5f03c0fe9, {
        "data-slot": "select",
        ...props
    });
}
function $c5bb23e187c19083$var$SelectValue({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$4c8d1a57a761ef94, {
        "data-slot": "select-value",
        ...props
    });
}
function $c5bb23e187c19083$var$SelectTrigger({ className: className, size: size = "default", children: children, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsxs)($97fa768cc4dabf19$export$41fb9f06171c75f4, {
        "data-slot": "select-trigger",
        "data-size": size,
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className),
        ...props,
        children: [
            children,
            /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$f04a61298a47a40f, {
                asChild: true,
                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $2b64d72813bd9423$export$2e2bcd8739ae039), {
                    className: "size-4 opacity-50"
                })
            })
        ]
    });
}
function $c5bb23e187c19083$var$SelectContent({ className: className, children: children, position: position = "popper", ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$602eac185826482c, {
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($97fa768cc4dabf19$export$7c6e2c02157bb7d2, {
            "data-slot": "select-content",
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
            position: position,
            ...props,
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectScrollUpButton, {}),
                /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$d5c6c08dc2d3ca7, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"),
                    children: children
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectScrollDownButton, {})
            ]
        })
    });
}
function $c5bb23e187c19083$var$SelectItem({ className: className, children: children, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsxs)($97fa768cc4dabf19$export$6d08773d2e66f8f2, {
        "data-slot": "select-item",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", className),
        ...props,
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                className: "absolute right-2 flex size-3.5 items-center justify-center",
                children: /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$c3468e2714d175fa, {
                    children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $bf8cdbeb7c4555a4$export$2e2bcd8739ae039), {
                        className: "size-4"
                    })
                })
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$d6e5bf9c43ea9319, {
                children: children
            })
        ]
    });
}
function $c5bb23e187c19083$var$SelectScrollUpButton({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$2f60d3ec9ad468f2, {
        "data-slot": "select-scroll-up-button",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $c92fa035e28749e7$export$2e2bcd8739ae039), {
            className: "size-4"
        })
    });
}
function $c5bb23e187c19083$var$SelectScrollDownButton({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($97fa768cc4dabf19$export$bf1aedc3039c8d63, {
        "data-slot": "select-scroll-down-button",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $2b64d72813bd9423$export$2e2bcd8739ae039), {
            className: "size-4"
        })
    });
}
function $c5bb23e187c19083$var$CreateApiKeyDialog({ classNames: classNames, localization: localization, onSuccess: onSuccess, refetch: refetch, organizationId: organizationId, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { authClient: authClient, apiKey: apiKey, hooks: { useListOrganizations: useListOrganizations, useSession: useSession }, localization: contextLocalization, organization: contextOrganization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { lang: lang } = (0, $07d0275849708341$export$b24a004ee43dce44)();
    let organizations;
    if (contextOrganization) {
        const { data: data } = useListOrganizations();
        organizations = data;
    }
    const { data: sessionData } = useSession();
    const user = sessionData == null ? void 0 : sessionData.user;
    const showOrganizationSelect = contextOrganization == null ? void 0 : contextOrganization.apiKey;
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        name: $034fa980286ebb75$export$22b082955e083ec3().min(1, `${localization.NAME} ${localization.IS_REQUIRED}`),
        expiresInDays: $034fa980286ebb75$export$22b082955e083ec3().optional(),
        organizationId: showOrganizationSelect ? $034fa980286ebb75$export$22b082955e083ec3().min(1, `${localization.ORGANIZATION} ${localization.IS_REQUIRED}`) : $034fa980286ebb75$export$22b082955e083ec3().optional()
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        values: {
            name: "",
            expiresInDays: "none",
            organizationId: organizationId ?? "personal"
        }
    });
    const { isSubmitting: isSubmitting } = form.formState;
    const onSubmit = async (values)=>{
        try {
            const expiresIn = values.expiresInDays && values.expiresInDays !== "none" ? Number.parseInt(values.expiresInDays) * 86400 : void 0;
            const selectedOrgId = values.organizationId === "personal" ? void 0 : values.organizationId;
            const metadata = {
                ...typeof apiKey === "object" ? apiKey.metadata : {},
                ...contextOrganization && selectedOrgId ? {
                    organizationId: selectedOrgId
                } : {}
            };
            const result = await authClient.apiKey.create({
                name: values.name,
                expiresIn: expiresIn,
                prefix: typeof apiKey === "object" ? apiKey.prefix : void 0,
                metadata: Object.keys(metadata).length > 0 ? metadata : void 0,
                fetchOptions: {
                    throw: true
                }
            });
            await (refetch == null ? void 0 : refetch());
            onSuccess(result.key);
            onOpenChange == null || onOpenChange(false);
            form.reset();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    const rtf = new Intl.RelativeTimeFormat(lang ?? "en");
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            onOpenAutoFocus: (e)=>e.preventDefault(),
            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content,
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization.CREATE_API_KEY
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.CREATE_API_KEY_DESCRIPTION
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                    ...form,
                    children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
                        onSubmit: form.handleSubmit(onSubmit),
                        className: "space-y-6",
                        children: [
                            showOrganizationSelect && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "organizationId",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        className: "w-full",
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                className: classNames == null ? void 0 : classNames.label,
                                                children: localization.ORGANIZATION
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Select, {
                                                onValueChange: field.onChange,
                                                value: field.value,
                                                disabled: isSubmitting,
                                                children: [
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectTrigger, {
                                                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full p-2", classNames == null ? void 0 : classNames.input),
                                                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectValue, {
                                                                placeholder: localization.ORGANIZATION
                                                            })
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$SelectContent, {
                                                        className: "w-[--radix-select-trigger-width]",
                                                        children: [
                                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectItem, {
                                                                value: "personal",
                                                                className: "p-2",
                                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$PersonalAccountView, {
                                                                    user: user,
                                                                    localization: localization,
                                                                    size: "sm"
                                                                })
                                                            }),
                                                            organizations == null ? void 0 : organizations.map((org)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectItem, {
                                                                    value: org.id,
                                                                    className: "p-2",
                                                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                                                                        organization: org,
                                                                        localization: localization,
                                                                        size: "sm"
                                                                    })
                                                                }, org.id))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                className: "flex gap-4",
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                        control: form.control,
                                        name: "name",
                                        render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                                className: "flex-1",
                                                children: [
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                        className: classNames == null ? void 0 : classNames.label,
                                                        children: localization.NAME
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                                            className: classNames == null ? void 0 : classNames.input,
                                                            placeholder: localization.API_KEY_NAME_PLACEHOLDER,
                                                            autoFocus: true,
                                                            disabled: isSubmitting,
                                                            ...field
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                                ]
                                            })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                        control: form.control,
                                        name: "expiresInDays",
                                        render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                                children: [
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                        className: classNames == null ? void 0 : classNames.label,
                                                        children: localization.EXPIRES
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Select, {
                                                        onValueChange: field.onChange,
                                                        defaultValue: field.value,
                                                        disabled: isSubmitting,
                                                        children: [
                                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectTrigger, {
                                                                    className: classNames == null ? void 0 : classNames.input,
                                                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectValue, {
                                                                        placeholder: localization.NO_EXPIRATION
                                                                    })
                                                                })
                                                            }),
                                                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$SelectContent, {
                                                                children: [
                                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectItem, {
                                                                        value: "none",
                                                                        children: localization.NO_EXPIRATION
                                                                    }),
                                                                    [
                                                                        1,
                                                                        7,
                                                                        30,
                                                                        60,
                                                                        90,
                                                                        180,
                                                                        365
                                                                    ].map((days)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectItem, {
                                                                            value: days.toString(),
                                                                            children: days === 365 ? rtf.format(1, "year") : rtf.format(days, "day")
                                                                        }, days))
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                                ]
                                            })
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                                className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                        type: "button",
                                        variant: "outline",
                                        onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                                        disabled: isSubmitting,
                                        children: localization.CANCEL
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                        type: "submit",
                                        variant: "default",
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                                        disabled: isSubmitting,
                                        children: [
                                            isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                                className: "animate-spin"
                                            }),
                                            localization.CREATE_API_KEY
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$ab29d533d6c9d3ce({ className: className, classNames: classNames, localization: localization, organizationId: organizationId, ...props }) {
    const { hooks: { useListApiKeys: useListApiKeys }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: apiKeys, isPending: isPending, refetch: refetch } = useListApiKeys();
    const filteredApiKeys = (0, $7PdBe.useMemo)(()=>{
        return apiKeys == null ? void 0 : apiKeys.filter((apiKey)=>{
            var _a;
            return organizationId === ((_a = apiKey.metadata) == null ? void 0 : _a.organizationId);
        });
    }, [
        apiKeys,
        organizationId
    ]);
    const [createDialogOpen, setCreateDialogOpen] = (0, $7PdBe.useState)(false);
    const [displayDialogOpen, setDisplayDialogOpen] = (0, $7PdBe.useState)(false);
    const [createdApiKey, setCreatedApiKey] = (0, $7PdBe.useState)("");
    const handleCreateApiKey = (apiKey)=>{
        setCreatedApiKey(apiKey);
        setDisplayDialogOpen(true);
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                actionLabel: localization.CREATE_API_KEY,
                description: localization.API_KEYS_DESCRIPTION,
                instructions: localization.API_KEYS_INSTRUCTIONS,
                isPending: isPending,
                title: localization.API_KEYS,
                action: ()=>setCreateDialogOpen(true),
                ...props,
                children: filteredApiKeys && filteredApiKeys.length > 0 && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
                    children: filteredApiKeys == null ? void 0 : filteredApiKeys.map((apiKey)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$ApiKeyCell, {
                            classNames: classNames,
                            apiKey: apiKey,
                            localization: localization,
                            refetch: refetch
                        }, apiKey.id))
                })
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CreateApiKeyDialog, {
                classNames: classNames,
                localization: localization,
                open: createDialogOpen,
                onOpenChange: setCreateDialogOpen,
                onSuccess: handleCreateApiKey,
                refetch: refetch,
                organizationId: organizationId
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$ApiKeyDisplayDialog, {
                classNames: classNames,
                apiKey: createdApiKey,
                localization: localization,
                open: displayDialogOpen,
                onOpenChange: setDisplayDialogOpen
            })
        ]
    });
}
function $c5bb23e187c19083$var$DeleteAccountDialog({ classNames: classNames, accounts: accounts, localization: localization, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { authClient: authClient, basePath: basePath, baseURL: baseURL, deleteUser: deleteUser, freshAge: freshAge, hooks: { useSession: useSession }, localization: contextLocalization, viewPaths: viewPaths, navigate: navigate, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: sessionData } = useSession();
    const session = sessionData == null ? void 0 : sessionData.session;
    const user = sessionData == null ? void 0 : sessionData.user;
    const isFresh = session ? Date.now() - new Date(session == null ? void 0 : session.createdAt).getTime() < freshAge * 1e3 : false;
    const credentialsLinked = accounts == null ? void 0 : accounts.some((acc)=>acc.providerId === "credential");
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        password: credentialsLinked ? $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: localization.PASSWORD_REQUIRED
        }) : $034fa980286ebb75$export$22b082955e083ec3().optional()
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            password: ""
        }
    });
    const { isSubmitting: isSubmitting } = form.formState;
    const deleteAccount = async ({ password: password })=>{
        const params = {};
        if (credentialsLinked) params.password = password;
        else if (!isFresh) {
            navigate(`${basePath}/${viewPaths.SIGN_OUT}`);
            return;
        }
        if (deleteUser == null ? void 0 : deleteUser.verification) params.callbackURL = `${baseURL}${basePath}/${viewPaths.SIGN_OUT}`;
        try {
            await authClient.deleteUser({
                ...params,
                fetchOptions: {
                    throw: true
                }
            });
            if (deleteUser == null ? void 0 : deleteUser.verification) toast({
                variant: "success",
                message: localization.DELETE_ACCOUNT_VERIFY
            });
            else {
                toast({
                    variant: "success",
                    message: localization.DELETE_ACCOUNT_SUCCESS
                });
                navigate(`${basePath}/${viewPaths.SIGN_OUT}`);
            }
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        onOpenChange == null || onOpenChange(false);
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("sm:max-w-md", (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization == null ? void 0 : localization.DELETE_ACCOUNT
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: isFresh ? localization == null ? void 0 : localization.DELETE_ACCOUNT_INSTRUCTIONS : localization == null ? void 0 : localization.SESSION_NOT_FRESH
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Card, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("my-2 flex-row p-4", classNames == null ? void 0 : classNames.cell),
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$93c94555daa109c4, {
                        user: user,
                        localization: localization
                    })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                    ...form,
                    children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
                        onSubmit: form.handleSubmit(deleteAccount),
                        className: "grid gap-6",
                        children: [
                            credentialsLinked && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "password",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                className: classNames == null ? void 0 : classNames.label,
                                                children: localization == null ? void 0 : localization.PASSWORD
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                                    autoComplete: "current-password",
                                                    placeholder: localization == null ? void 0 : localization.PASSWORD_PLACEHOLDER,
                                                    type: "password",
                                                    className: classNames == null ? void 0 : classNames.input,
                                                    ...field
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                                className: classNames == null ? void 0 : classNames.error
                                            })
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                                className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                        type: "button",
                                        variant: "secondary",
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.secondaryButton),
                                        onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                                        children: localization.CANCEL
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.destructiveButton),
                                        disabled: isSubmitting,
                                        variant: "destructive",
                                        type: "submit",
                                        children: [
                                            isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                                className: "animate-spin"
                                            }),
                                            isFresh ? localization == null ? void 0 : localization.DELETE_ACCOUNT : localization == null ? void 0 : localization.SIGN_OUT
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$e6c2f96bd0326378({ className: className, classNames: classNames, accounts: accounts, isPending: isPending, localization: localization, skipHook: skipHook }) {
    const { hooks: { useListAccounts: useListAccounts }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const [showDialog, setShowDialog] = (0, $7PdBe.useState)(false);
    if (!skipHook) {
        const result = useListAccounts();
        accounts = result.data;
        isPending = result.isPending;
    }
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                actionLabel: localization == null ? void 0 : localization.DELETE_ACCOUNT,
                description: localization == null ? void 0 : localization.DELETE_ACCOUNT_DESCRIPTION,
                isPending: isPending,
                title: localization == null ? void 0 : localization.DELETE_ACCOUNT,
                variant: "destructive",
                action: ()=>setShowDialog(true)
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DeleteAccountDialog, {
                classNames: classNames,
                accounts: accounts,
                localization: localization,
                open: showDialog,
                onOpenChange: setShowDialog
            })
        ]
    });
}
function $c5bb23e187c19083$var$SessionFreshnessDialog({ classNames: classNames, localization: localization, title: title, description: description, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { basePath: basePath, localization: contextLocalization, viewPaths: viewPaths, navigate: navigate } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const handleSignOut = ()=>{
        navigate(`${basePath}/${viewPaths.SIGN_OUT}`);
        onOpenChange == null || onOpenChange(false);
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("sm:max-w-md", (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: title || (localization == null ? void 0 : localization.SESSION_EXPIRED) || "Session Expired"
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: description || (localization == null ? void 0 : localization.SESSION_NOT_FRESH)
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                    className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "secondary",
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.secondaryButton),
                            onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                            children: localization.CANCEL
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                            variant: "default",
                            onClick: handleSignOut,
                            children: localization == null ? void 0 : localization.SIGN_OUT
                        })
                    ]
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$PasskeyCell({ className: className, classNames: classNames, localization: localization, passkey: passkey }) {
    const { freshAge: freshAge, hooks: { useSession: useSession, useListPasskeys: useListPasskeys }, localization: contextLocalization, mutators: { deletePasskey: deletePasskey }, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { refetch: refetch } = useListPasskeys();
    const { data: sessionData } = useSession();
    const session = sessionData == null ? void 0 : sessionData.session;
    const isFresh = session ? Date.now() - new Date(session == null ? void 0 : session.createdAt).getTime() < freshAge * 1e3 : false;
    const [showFreshnessDialog, setShowFreshnessDialog] = (0, $7PdBe.useState)(false);
    const [isLoading, setIsLoading] = (0, $7PdBe.useState)(false);
    const handleDeletePasskey = async ()=>{
        if (!isFresh) {
            setShowFreshnessDialog(true);
            return;
        }
        setIsLoading(true);
        try {
            await deletePasskey({
                id: passkey.id
            });
            refetch == null || refetch();
        } catch (error) {
            setIsLoading(false);
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SessionFreshnessDialog, {
                open: showFreshnessDialog,
                onOpenChange: setShowFreshnessDialog,
                classNames: classNames,
                localization: localization
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center p-4", className, classNames == null ? void 0 : classNames.cell),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $3b980a999e8ec75a$export$2e2bcd8739ae039), {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-4", classNames == null ? void 0 : classNames.icon)
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                                className: "text-sm",
                                children: new Date(passkey.createdAt).toLocaleString()
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                        disabled: isLoading,
                        size: "sm",
                        variant: "outline",
                        onClick: handleDeletePasskey,
                        children: [
                            isLoading && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                className: "animate-spin"
                            }),
                            localization.DELETE
                        ]
                    })
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$export$ea81fe102dc1bc56({ className: className, classNames: classNames, localization: localization }) {
    const { authClient: authClient, freshAge: freshAge, hooks: { useListPasskeys: useListPasskeys, useSession: useSession }, localization: authLocalization2, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...authLocalization2,
        ...localization
    };
    const { data: passkeys, isPending: isPending, refetch: refetch } = useListPasskeys();
    const { data: sessionData } = useSession();
    const session = sessionData == null ? void 0 : sessionData.session;
    const isFresh = session ? Date.now() - new Date(session == null ? void 0 : session.createdAt).getTime() < freshAge * 1e3 : false;
    const [showFreshnessDialog, setShowFreshnessDialog] = (0, $7PdBe.useState)(false);
    const addPasskey = async ()=>{
        if (!isFresh) {
            setShowFreshnessDialog(true);
            return;
        }
        try {
            await authClient.passkey.addPasskey({
                fetchOptions: {
                    throw: true
                }
            });
            await (refetch == null ? void 0 : refetch());
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)();
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SessionFreshnessDialog, {
                open: showFreshnessDialog,
                onOpenChange: setShowFreshnessDialog,
                classNames: classNames,
                localization: localization
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                ...form,
                children: /* @__PURE__ */ (0, $hvk62.jsx)("form", {
                    onSubmit: form.handleSubmit(addPasskey),
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                        className: className,
                        classNames: classNames,
                        actionLabel: localization.ADD_PASSKEY,
                        description: localization.PASSKEYS_DESCRIPTION,
                        instructions: localization.PASSKEYS_INSTRUCTIONS,
                        isPending: isPending,
                        title: localization.PASSKEYS,
                        children: passkeys && passkeys.length > 0 && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
                            children: passkeys == null ? void 0 : passkeys.map((passkey)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$PasskeyCell, {
                                    classNames: classNames,
                                    localization: localization,
                                    passkey: passkey
                                }, passkey.id))
                        })
                    })
                })
            })
        ]
    });
}
var $c5bb23e187c19083$export$ec00f8086d88a9de = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            d: "M9.438 31.401a7 7 0 0 1-1.656-1.536a20 20 0 0 1-1.422-1.938a18.9 18.9 0 0 1-2.375-4.849c-.667-2-.99-3.917-.99-5.792c0-2.094.453-3.922 1.339-5.458a7.7 7.7 0 0 1 2.797-2.906a7.45 7.45 0 0 1 3.786-1.12q.705.002 1.51.198c.385.109.854.281 1.427.495c.729.281 1.13.453 1.266.495c.427.156.786.224 1.068.224c.214 0 .516-.068.859-.172c.193-.068.557-.188 1.078-.411c.516-.188.922-.349 1.245-.469c.495-.146.974-.281 1.401-.349a6.7 6.7 0 0 1 1.531-.063a9 9 0 0 1 2.589.557c1.359.547 2.458 1.401 3.276 2.615a6.4 6.4 0 0 0-.969.734a8.2 8.2 0 0 0-1.641 2.005a6.8 6.8 0 0 0-.859 3.359c.021 1.443.391 2.714 1.12 3.813a7.2 7.2 0 0 0 2.047 2.047c.417.281.776.474 1.12.604c-.161.5-.333.984-.536 1.464a19 19 0 0 1-1.667 3.083c-.578.839-1.031 1.464-1.375 1.88c-.536.635-1.052 1.12-1.573 1.458c-.573.38-1.25.583-1.938.583a4.4 4.4 0 0 1-1.38-.167c-.385-.13-.766-.271-1.141-.432a9 9 0 0 0-1.203-.453a6.3 6.3 0 0 0-3.099-.005c-.417.12-.818.26-1.214.432c-.557.234-.927.391-1.141.458c-.427.125-.87.203-1.318.229c-.693 0-1.339-.198-1.979-.599zm9.14-24.615c-.906.453-1.771.646-2.63.583c-.135-.865 0-1.75.359-2.719a7.3 7.3 0 0 1 1.333-2.24A7.1 7.1 0 0 1 19.812.733q1.319-.68 2.521-.734c.104.906 0 1.797-.333 2.76a8 8 0 0 1-1.333 2.344a6.8 6.8 0 0 1-2.115 1.682z",
            fill: "currentColor"
        })
    });
var $c5bb23e187c19083$export$de73dc4d201c5f29 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        viewBox: "0 0 256 199",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            d: "M216.856 16.597A208.5 208.5 0 0 0 164.042 0c-2.275 4.113-4.933 9.645-6.766 14.046q-29.538-4.442-58.533 0c-1.832-4.4-4.55-9.933-6.846-14.046a207.8 207.8 0 0 0-52.855 16.638C5.618 67.147-3.443 116.4 1.087 164.956c22.169 16.555 43.653 26.612 64.775 33.193A161 161 0 0 0 79.735 175.3a136.4 136.4 0 0 1-21.846-10.632a109 109 0 0 0 5.356-4.237c42.122 19.702 87.89 19.702 129.51 0a132 132 0 0 0 5.355 4.237a136 136 0 0 1-21.886 10.653c4.006 8.02 8.638 15.67 13.873 22.848c21.142-6.58 42.646-16.637 64.815-33.213c5.316-56.288-9.08-105.09-38.056-148.36M85.474 135.095c-12.645 0-23.015-11.805-23.015-26.18s10.149-26.2 23.015-26.2s23.236 11.804 23.015 26.2c.02 14.375-10.148 26.18-23.015 26.18m85.051 0c-12.645 0-23.014-11.805-23.014-26.18s10.148-26.2 23.014-26.2c12.867 0 23.236 11.804 23.015 26.2c0 14.375-10.148 26.18-23.015 26.18",
            fill: "#5865f2"
        })
    });
var $c5bb23e187c19083$export$5e2362bb78414664 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        viewBox: "0 0 256 218",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            d: "M63.995 0L0 40.771l63.995 40.772L128 40.771zM192 0l-64 40.775l64 40.775l64.001-40.775zM0 122.321l63.995 40.772L128 122.321L63.995 81.55zM192 81.55l-64 40.775l64 40.774l64-40.774zM64 176.771l64.005 40.772L192 176.771L128.005 136z",
            fill: "#0061ff"
        })
    });
var $c5bb23e187c19083$export$3fdaca054b3d1181 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsxs)("svg", {
        className: className,
        viewBox: "0 0 256 256",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M256 128C256 57.308 198.692 0 128 0S0 57.308 0 128c0 63.888 46.808 116.843 108 126.445V165H75.5v-37H108V99.8c0-32.08 19.11-49.8 48.348-49.8C170.352 50 185 52.5 185 52.5V84h-16.14C152.959 84 148 93.867 148 103.99V128h35.5l-5.675 37H148v89.445c61.192-9.602 108-62.556 108-126.445",
                fill: "#1877f2"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "m177.825 165l5.675-37H148v-24.01C148 93.866 152.959 84 168.86 84H185V52.5S170.352 50 156.347 50C127.11 50 108 67.72 108 99.8V128H75.5v37H108v89.445A129 129 0 0 0 128 256a129 129 0 0 0 20-1.555V165z",
                fill: "#fff"
            })
        ]
    });
var $c5bb23e187c19083$export$1e450c42b77127b1 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            d: "M12 .297c-6.63 0-12 5.373-12 12c0 5.303 3.438 9.8 8.205 11.385c.6.113.82-.258.82-.577c0-.285-.01-1.04-.015-2.04c-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729c1.205.084 1.838 1.236 1.838 1.236c1.07 1.835 2.809 1.305 3.495.998c.108-.776.417-1.305.76-1.605c-2.665-.3-5.466-1.332-5.466-5.93c0-1.31.465-2.38 1.235-3.22c-.135-.303-.54-1.523.105-3.176c0 0 1.005-.322 3.3 1.23c.96-.267 1.98-.399 3-.405c1.02.006 2.04.138 3 .405c2.28-1.552 3.285-1.23 3.285-1.23c.645 1.653.24 2.873.12 3.176c.765.84 1.23 1.91 1.23 3.22c0 4.61-2.805 5.625-5.475 5.92c.42.36.81 1.096.81 2.22c0 1.606-.015 2.896-.015 3.286c0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12",
            fill: "currentColor"
        })
    });
var $c5bb23e187c19083$export$28e008202e511484 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsxs)("svg", {
        className: className,
        viewBox: "0 0 256 236",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "m128.075 236.075l47.104-144.97H80.97z",
                fill: "#e24329"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M128.075 236.074L80.97 91.104H14.956z",
                fill: "#fc6d26"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M14.956 91.104L.642 135.16a9.75 9.75 0 0 0 3.542 10.903l123.891 90.012z",
                fill: "#fca326"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M14.956 91.105H80.97L52.601 3.79c-1.46-4.493-7.816-4.492-9.275 0z",
                fill: "#e24329"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "m128.075 236.074l47.104-144.97h66.015z",
                fill: "#fc6d26"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "m241.194 91.104l14.314 44.056a9.75 9.75 0 0 1-3.543 10.903l-123.89 90.012z",
                fill: "#fca326"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M241.194 91.105h-66.015l28.37-87.315c1.46-4.493 7.816-4.492 9.275 0z",
                fill: "#e24329"
            })
        ]
    });
var $c5bb23e187c19083$export$6314f2dd65e45f24 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsxs)("svg", {
        className: className,
        viewBox: "0 0 256 262",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622l38.755 30.023l2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
                fill: "#4285f4"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055c-34.523 0-63.824-22.773-74.269-54.25l-1.531.13l-40.298 31.187l-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
                fill: "#34a853"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82c0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z",
                fill: "#fbbc05"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0C79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
                fill: "#eb4335"
            })
        ]
    });
var $c5bb23e187c19083$export$57e5411458dd3b03 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            fill: "currentColor",
            d: "M12.025 1.13c-5.77 0-10.449 4.647-10.449 10.378c0 1.112.178 2.181.503 3.185c.064-.222.203-.444.416-.577a.96.96 0 0 1 .524-.15c.293 0 .584.124.84.284c.278.173.48.408.71.694c.226.282.458.611.684.951v-.014c.017-.324.106-.622.264-.874s.403-.487.762-.543c.3-.047.596.06.787.203s.31.313.4.467c.15.257.212.468.233.542c.01.026.653 1.552 1.657 2.54c.616.605 1.01 1.223 1.082 1.912c.055.537-.096 1.059-.38 1.572c.637.121 1.294.187 1.967.187c.657 0 1.298-.063 1.921-.178c-.287-.517-.44-1.041-.384-1.581c.07-.69.465-1.307 1.081-1.913c1.004-.987 1.647-2.513 1.657-2.539c.021-.074.083-.285.233-.542c.09-.154.208-.323.4-.467a1.08 1.08 0 0 1 .787-.203c.359.056.604.29.762.543s.247.55.265.874v.015c.225-.34.457-.67.683-.952c.23-.286.432-.52.71-.694c.257-.16.547-.284.84-.285a.97.97 0 0 1 .524.151c.228.143.373.388.43.625l.006.04a10.3 10.3 0 0 0 .534-3.273c0-5.731-4.678-10.378-10.449-10.378M8.327 6.583a1.5 1.5 0 0 1 .713.174a1.487 1.487 0 0 1 .617 2.013c-.183.343-.762-.214-1.102-.094c-.38.134-.532.914-.917.71a1.487 1.487 0 0 1 .69-2.803m7.486 0a1.487 1.487 0 0 1 .689 2.803c-.385.204-.536-.576-.916-.71c-.34-.12-.92.437-1.103.094a1.487 1.487 0 0 1 .617-2.013a1.5 1.5 0 0 1 .713-.174m-10.68 1.55a.96.96 0 1 1 0 1.921a.96.96 0 0 1 0-1.92m13.838 0a.96.96 0 1 1 0 1.92a.96.96 0 0 1 0-1.92M8.489 11.458c.588.01 1.965 1.157 3.572 1.164c1.607-.007 2.984-1.155 3.572-1.164c.196-.003.305.12.305.454c0 .886-.424 2.328-1.563 3.202c-.22-.756-1.396-1.366-1.63-1.32q-.011.001-.02.006l-.044.026l-.01.008l-.03.024q-.018.017-.035.036l-.032.04a1 1 0 0 0-.058.09l-.014.025q-.049.088-.11.19a1 1 0 0 1-.083.116a1.2 1.2 0 0 1-.173.18q-.035.029-.075.058a1.3 1.3 0 0 1-.251-.243a1 1 0 0 1-.076-.107c-.124-.193-.177-.363-.337-.444c-.034-.016-.104-.008-.2.022q-.094.03-.216.087q-.06.028-.125.063l-.13.074q-.067.04-.136.086a3 3 0 0 0-.135.096a3 3 0 0 0-.26.219a2 2 0 0 0-.12.121a2 2 0 0 0-.106.128l-.002.002a2 2 0 0 0-.09.132l-.001.001a1.2 1.2 0 0 0-.105.212q-.013.036-.024.073c-1.139-.875-1.563-2.317-1.563-3.203c0-.334.109-.457.305-.454m.836 10.354c.824-1.19.766-2.082-.365-3.194c-1.13-1.112-1.789-2.738-1.789-2.738s-.246-.945-.806-.858s-.97 1.499.202 2.362c1.173.864-.233 1.45-.685.64c-.45-.812-1.683-2.896-2.322-3.295s-1.089-.175-.938.647s2.822 2.813 2.562 3.244s-1.176-.506-1.176-.506s-2.866-2.567-3.49-1.898s.473 1.23 2.037 2.16c1.564.932 1.686 1.178 1.464 1.53s-3.675-2.511-4-1.297c-.323 1.214 3.524 1.567 3.287 2.405c-.238.839-2.71-1.587-3.216-.642c-.506.946 3.49 2.056 3.522 2.064c1.29.33 4.568 1.028 5.713-.624m5.349 0c-.824-1.19-.766-2.082.365-3.194c1.13-1.112 1.789-2.738 1.789-2.738s.246-.945.806-.858s.97 1.499-.202 2.362c-1.173.864.233 1.45.685.64c.451-.812 1.683-2.896 2.322-3.295s1.089-.175.938.647s-2.822 2.813-2.562 3.244s1.176-.506 1.176-.506s2.866-2.567 3.49-1.898s-.473 1.23-2.037 2.16c-1.564.932-1.686 1.178-1.464 1.53s3.675-2.511 4-1.297c.323 1.214-3.524 1.567-3.287 2.405c.238.839 2.71-1.587 3.216-.642c.506.946-3.49 2.056-3.522 2.064c-1.29.33-4.568 1.028-5.713-.624"
        })
    });
var $c5bb23e187c19083$export$f49b9fbdf1a1bb2c = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            fill: "currentColor",
            d: "M1.333 0h8v5.333H12V2.667h2.667V0h8v8H20v2.667h-2.667v2.666H20V16h2.667v8h-8v-2.667H12v-2.666H9.333V24h-8Z"
        })
    });
var $c5bb23e187c19083$export$964611110d72a811 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            fill: "currentColor",
            d: "M2.886 4.18A11.98 11.98 0 0 1 11.99 0C18.624 0 24 5.376 24 12.009c0 3.64-1.62 6.903-4.18 9.105L2.887 4.18ZM1.817 5.626l16.556 16.556q-.787.496-1.65.866L.951 7.277q.371-.863.866-1.65ZM.322 9.163l14.515 14.515q-1.066.26-2.195.322L0 11.358a12 12 0 0 1 .322-2.195m-.17 4.862l9.823 9.824a12.02 12.02 0 0 1-9.824-9.824Z"
        })
    });
var $c5bb23e187c19083$export$3b889a6533231d2c = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsxs)("svg", {
        className: className,
        viewBox: "0 0 128 128",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M116 3H12a8.91 8.91 0 0 0-9 8.8v104.42a8.91 8.91 0 0 0 9 8.78h104a8.93 8.93 0 0 0 9-8.81V11.77A8.93 8.93 0 0 0 116 3",
                fill: "#0076b2"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M21.06 48.73h18.11V107H21.06zm9.06-29a10.5 10.5 0 1 1-10.5 10.49a10.5 10.5 0 0 1 10.5-10.49m20.41 29h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75v32H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53z",
                fill: "#fff"
            })
        ]
    });
var $c5bb23e187c19083$export$ad6b83e535366949 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsxs)("svg", {
        className: className,
        viewBox: "0 0 256 256",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M121.666 121.666H0V0h121.666z",
                fill: "#f1511b"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M256 121.666H134.335V0H256z",
                fill: "#80cc28"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M121.663 256.002H0V134.336h121.663z",
                fill: "#00adef"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M256 256.002H134.335V134.336H256z",
                fill: "#fbbc09"
            })
        ]
    });
var $c5bb23e187c19083$export$694ff710b1e20299 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            fill: "currentColor",
            d: "M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 1.968c-.42-.326-.981-.7-2.055-.607L3.01 2.295c-.466.046-.56.28-.374.466zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.841-.046.935-.56.935-1.167V6.354c0-.606-.233-.933-.748-.887l-15.177.887c-.56.047-.747.327-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514c-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952L12.21 19s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233l4.764 7.279v-6.44l-1.215-.139c-.093-.514.28-.887.747-.933zM1.936 1.035l13.31-.98c1.634-.14 2.055-.047 3.082.7l4.249 2.986c.7.513.934.653.934 1.213v16.378c0 1.026-.373 1.634-1.68 1.726l-15.458.934c-.98.047-1.448-.093-1.962-.747l-3.129-4.06c-.56-.747-.793-1.306-.793-1.96V2.667c0-.839.374-1.54 1.447-1.632"
        })
    });
var $c5bb23e187c19083$export$f2a2ba94522e14f2 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsxs)("svg", {
        className: className,
        viewBox: "0 0 256 256",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("circle", {
                cx: "128",
                cy: "128",
                fill: "#ff4500",
                r: "128"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M213.15 129.22c0-10.376-8.391-18.617-18.617-18.617a18.74 18.74 0 0 0-12.97 5.189c-12.818-9.157-30.368-15.107-49.9-15.87l8.544-39.981l27.773 5.95c.307 7.02 6.104 12.667 13.278 12.667c7.324 0 13.275-5.95 13.275-13.278c0-7.324-5.95-13.275-13.275-13.275c-5.188 0-9.768 3.052-11.904 7.478l-30.976-6.562c-.916-.154-1.832 0-2.443.458c-.763.458-1.22 1.22-1.371 2.136l-9.464 44.558c-19.837.612-37.692 6.562-50.662 15.872a18.74 18.74 0 0 0-12.971-5.188c-10.377 0-18.617 8.391-18.617 18.617c0 7.629 4.577 14.037 10.988 16.939a33.6 33.6 0 0 0-.458 5.646c0 28.686 33.42 52.036 74.621 52.036c41.202 0 74.622-23.196 74.622-52.036a35 35 0 0 0-.458-5.646c6.408-2.902 10.985-9.464 10.985-17.093M85.272 142.495c0-7.324 5.95-13.275 13.278-13.275c7.324 0 13.275 5.95 13.275 13.275s-5.95 13.278-13.275 13.278c-7.327.15-13.278-5.953-13.278-13.278m74.317 35.251c-9.156 9.157-26.553 9.768-31.588 9.768c-5.188 0-22.584-.765-31.59-9.768c-1.371-1.373-1.371-3.51 0-4.883c1.374-1.371 3.51-1.371 4.884 0c5.8 5.8 18.008 7.782 26.706 7.782s21.058-1.983 26.704-7.782c1.374-1.371 3.51-1.371 4.884 0c1.22 1.373 1.22 3.51 0 4.883m-2.443-21.822c-7.325 0-13.275-5.95-13.275-13.275s5.95-13.275 13.275-13.275c7.327 0 13.277 5.95 13.277 13.275c0 7.17-5.95 13.275-13.277 13.275",
                fill: "#fff"
            })
        ]
    });
var $c5bb23e187c19083$export$14cbe60a158aaf55 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            d: "M18.926 23.998L0 18.892L5.075.002L24 5.108ZM15.348 10.09l-5.282-1.453l-1.414 5.273l5.282 1.453z",
            fill: "currentColor"
        })
    });
var $c5bb23e187c19083$export$b33fb54b08bb6422 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            fill: "currentColor",
            d: "M6 15a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2h2zm1 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2a2 2 0 0 1-2-2zm2-8a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2v2zm0 1a2 2 0 0 1 2 2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2a2 2 0 0 1 2-2zm8 2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-2zm-1 0a2 2 0 0 1-2 2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2a2 2 0 0 1 2 2zm-2 8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2v-2zm0-1a2 2 0 0 1-2-2a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2a2 2 0 0 1-2 2z"
        })
    });
var $c5bb23e187c19083$export$a6d85ff49bd8db56 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        viewBox: "0 0 256 256",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            d: "M128 0C57.308 0 0 57.309 0 128c0 70.696 57.309 128 128 128c70.697 0 128-57.304 128-128C256 57.314 198.697.007 127.998.007zm58.699 184.614c-2.293 3.76-7.215 4.952-10.975 2.644c-30.053-18.357-67.885-22.515-112.44-12.335a7.98 7.98 0 0 1-9.552-6.007a7.97 7.97 0 0 1 6-9.553c48.76-11.14 90.583-6.344 124.323 14.276c3.76 2.308 4.952 7.215 2.644 10.975m15.667-34.853c-2.89 4.695-9.034 6.178-13.726 3.289c-34.406-21.148-86.853-27.273-127.548-14.92c-5.278 1.594-10.852-1.38-12.454-6.649c-1.59-5.278 1.386-10.842 6.655-12.446c46.485-14.106 104.275-7.273 143.787 17.007c4.692 2.89 6.175 9.034 3.286 13.72zm1.345-36.293C162.457 88.964 94.394 86.71 55.007 98.666c-6.325 1.918-13.014-1.653-14.93-7.978c-1.917-6.328 1.65-13.012 7.98-14.935C93.27 62.027 168.434 64.68 215.929 92.876c5.702 3.376 7.566 10.724 4.188 16.405c-3.362 5.69-10.73 7.565-16.4 4.187z",
            fill: "#1ed760"
        })
    });
var $c5bb23e187c19083$export$f71bb80776ba043 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsxs)("svg", {
        className: className,
        viewBox: "0 0 256 290",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M189.72 104.421c18.678 13.345 41.56 21.197 66.273 21.197v-47.53a67 67 0 0 1-13.918-1.456v37.413c-24.711 0-47.59-7.851-66.272-21.195v96.996c0 48.523-39.356 87.855-87.9 87.855c-18.113 0-34.949-5.473-48.934-14.86c15.962 16.313 38.222 26.432 62.848 26.432c48.548 0 87.905-39.332 87.905-87.857v-96.995zm17.17-47.952c-9.546-10.423-15.814-23.893-17.17-38.785v-6.113h-13.189c3.32 18.927 14.644 35.097 30.358 44.898M69.673 225.607a40 40 0 0 1-8.203-24.33c0-22.192 18.001-40.186 40.21-40.186a40.3 40.3 0 0 1 12.197 1.883v-48.593c-4.61-.631-9.262-.9-13.912-.801v37.822a40.3 40.3 0 0 0-12.203-1.882c-22.208 0-40.208 17.992-40.208 40.187c0 15.694 8.997 29.281 22.119 35.9",
                fill: "#ff004f"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M175.803 92.849c18.683 13.344 41.56 21.195 66.272 21.195V76.631c-13.794-2.937-26.005-10.141-35.186-20.162c-15.715-9.802-27.038-25.972-30.358-44.898h-34.643v189.843c-.079 22.132-18.049 40.052-40.21 40.052c-13.058 0-24.66-6.221-32.007-15.86c-13.12-6.618-22.118-20.206-22.118-35.898c0-22.193 18-40.187 40.208-40.187c4.255 0 8.356.662 12.203 1.882v-37.822c-47.692.985-86.047 39.933-86.047 87.834c0 23.912 9.551 45.589 25.053 61.428c13.985 9.385 30.82 14.86 48.934 14.86c48.545 0 87.9-39.335 87.9-87.857z"
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                d: "M242.075 76.63V66.516a66.3 66.3 0 0 1-35.186-10.047a66.47 66.47 0 0 0 35.186 20.163M176.53 11.57a68 68 0 0 1-.728-5.457V0h-47.834v189.845c-.076 22.13-18.046 40.05-40.208 40.05a40.06 40.06 0 0 1-18.09-4.287c7.347 9.637 18.949 15.857 32.007 15.857c22.16 0 40.132-17.918 40.21-40.05V11.571zM99.966 113.58v-10.769a89 89 0 0 0-12.061-.818C39.355 101.993 0 141.327 0 189.845c0 30.419 15.467 57.227 38.971 72.996c-15.502-15.838-25.053-37.516-25.053-61.427c0-47.9 38.354-86.848 86.048-87.833",
                fill: "#00f2ea"
            })
        ]
    });
var $c5bb23e187c19083$export$ceb66f67e793134f = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsxs)("svg", {
        className: className,
        version: "1.1",
        viewBox: "0 0 2400 2800",
        x: "0px",
        xmlSpace: "preserve",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        y: "0px",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("style", {
                type: "text/css",
                children: `
                .st0{fill:#FFFFFF}
                .st1{fill:#9146FF}
            `
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("title", {
                children: "Asset 2"
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)("g", {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)("polygon", {
                        className: "st0",
                        points: "2200,1300 1800,1700 1400,1700 1050,2050 1050,1700 600,1700 600,200 2200,200"
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)("g", {
                        children: /* @__PURE__ */ (0, $hvk62.jsxs)("g", {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)("path", {
                                    className: "st1",
                                    d: "M500,0L0,500v1800h600v500l500-500h400l900-900V0H500z M2200,1300l-400,400h-400l-350,350v-350H600V200h1600V1300z"
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)("rect", {
                                    className: "st1",
                                    height: "600",
                                    width: "200",
                                    x: "1700",
                                    y: "550"
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)("rect", {
                                    className: "st1",
                                    height: "600",
                                    width: "200",
                                    x: "1150",
                                    y: "550"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
var $c5bb23e187c19083$export$c1684fb75a64f8dd = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        viewBox: "0 0 576 512",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            d: "M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7c0 0-30 73.1-72.4 120.5c-13.7 13.7-20 18.1-27.5 18.1c-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5c0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5c-20 0-68.6-73.4-97.4-157.4c-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7c0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9c0-66.8-3.4-73.1 15.4-73.1c8.7 0 23.7 4.4 58.7 38.1c40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25c-11.2-34.9-86.9-106.7-90.3-111.5c-8.7-11.2-6.2-16.2 0-26.2c.1-.1 72-101.3 79.4-135.6",
            fill: "currentColor"
        })
    });
var $c5bb23e187c19083$export$5e658a8851ae9322 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            d: "M389.2 48h70.6L305.6 224.2L487 464H345L233.7 318.6L106.5 464H35.8l164.9-188.5L26.8 48h145.6l100.5 132.9zm-24.8 373.8h39.1L151.1 88h-42z",
            fill: "currentColor"
        })
    });
var $c5bb23e187c19083$export$db7393a57b3e6d84 = ({ className: className })=>/* @__PURE__ */ (0, $hvk62.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: 512,
        height: 117,
        viewBox: "0 0 512 117",
        children: /* @__PURE__ */ (0, $hvk62.jsx)("path", {
            fill: "#0b5cff",
            d: "M107.472 114.706H16.348c-5.968 0-11.791-3.203-14.557-8.589C-1.41 99.858-.247 92.434 4.702 87.63L68.17 24.164H22.607C10.088 24.164.044 13.974.044 1.6h83.992c5.968 0 11.79 3.203 14.556 8.589c3.203 6.259 2.038 13.683-2.911 18.486L32.214 92.143h52.55c12.518 0 22.708 10.19 22.708 22.563M468.183 0c-13.1 0-24.746 5.677-32.898 14.702C427.134 5.677 415.488 0 402.388 0c-24.164 0-43.961 20.67-43.961 44.834v69.872c12.518 0 22.562-10.19 22.562-22.563V44.689c0-11.646 9.025-21.544 20.67-21.98c12.228-.437 22.272 9.315 22.272 21.397v48.037c0 12.519 10.19 22.563 22.563 22.563V44.543c0-11.645 9.025-21.544 20.67-21.98c12.228-.437 22.272 9.316 22.272 21.398v48.036c0 12.52 10.19 22.563 22.563 22.563V44.69C512.144 20.67 492.347 0 468.183 0M221.595 58.226c0 32.17-26.056 58.226-58.226 58.226s-58.226-26.056-58.226-58.226S131.199 0 163.369 0s58.226 26.056 58.226 58.226m-22.563 0c0-19.651-16.012-35.663-35.663-35.663s-35.664 16.012-35.664 35.663c0 19.652 16.013 35.664 35.664 35.664s35.663-16.012 35.663-35.664m148.04 0c0 32.17-26.056 58.226-58.226 58.226S230.62 90.396 230.62 58.226S256.676 0 288.846 0s58.227 26.056 58.227 58.226m-22.562 0c0-19.651-16.012-35.663-35.664-35.663c-19.65 0-35.663 16.012-35.663 35.663c0 19.652 16.012 35.664 35.663 35.664c19.652 0 35.664-16.012 35.664-35.664"
        })
    });
// src/lib/social-providers.ts
var $c5bb23e187c19083$export$f673b72d48c114fb = [
    {
        provider: "apple",
        name: "Apple",
        icon: $c5bb23e187c19083$export$ec00f8086d88a9de
    },
    {
        provider: "discord",
        name: "Discord",
        icon: $c5bb23e187c19083$export$de73dc4d201c5f29
    },
    {
        provider: "dropbox",
        name: "Dropbox",
        icon: $c5bb23e187c19083$export$5e2362bb78414664
    },
    {
        provider: "facebook",
        name: "Facebook",
        icon: $c5bb23e187c19083$export$3fdaca054b3d1181
    },
    {
        provider: "github",
        name: "GitHub",
        icon: $c5bb23e187c19083$export$1e450c42b77127b1
    },
    {
        provider: "gitlab",
        name: "GitLab",
        icon: $c5bb23e187c19083$export$28e008202e511484
    },
    {
        provider: "google",
        name: "Google",
        icon: $c5bb23e187c19083$export$6314f2dd65e45f24
    },
    {
        provider: "huggingface",
        name: "Hugging Face",
        icon: $c5bb23e187c19083$export$57e5411458dd3b03
    },
    {
        provider: "kick",
        name: "Kick",
        icon: $c5bb23e187c19083$export$f49b9fbdf1a1bb2c
    },
    {
        provider: "linear",
        name: "Linear",
        icon: $c5bb23e187c19083$export$964611110d72a811
    },
    {
        provider: "linkedin",
        name: "LinkedIn",
        icon: $c5bb23e187c19083$export$3b889a6533231d2c
    },
    {
        provider: "microsoft",
        name: "Microsoft",
        icon: $c5bb23e187c19083$export$ad6b83e535366949
    },
    {
        provider: "notion",
        name: "Notion",
        icon: $c5bb23e187c19083$export$694ff710b1e20299
    },
    {
        provider: "reddit",
        name: "Reddit",
        icon: $c5bb23e187c19083$export$f2a2ba94522e14f2
    },
    {
        provider: "roblox",
        name: "Roblox",
        icon: $c5bb23e187c19083$export$14cbe60a158aaf55
    },
    {
        provider: "slack",
        name: "Slack",
        icon: $c5bb23e187c19083$export$b33fb54b08bb6422
    },
    {
        provider: "spotify",
        name: "Spotify",
        icon: $c5bb23e187c19083$export$a6d85ff49bd8db56
    },
    {
        provider: "tiktok",
        name: "TikTok",
        icon: $c5bb23e187c19083$export$f71bb80776ba043
    },
    {
        provider: "twitch",
        name: "Twitch",
        icon: $c5bb23e187c19083$export$ceb66f67e793134f
    },
    {
        provider: "vk",
        name: "VK",
        icon: $c5bb23e187c19083$export$c1684fb75a64f8dd
    },
    {
        provider: "twitter",
        name: "X",
        icon: $c5bb23e187c19083$export$5e658a8851ae9322
    },
    {
        provider: "zoom",
        name: "Zoom",
        icon: $c5bb23e187c19083$export$db7393a57b3e6d84
    }
];
function $c5bb23e187c19083$var$ProviderCell({ className: className, classNames: classNames, account: account, localization: localization, other: other, provider: provider, refetch: refetch }) {
    const { authClient: authClient, basePath: basePath, baseURL: baseURL, localization: contextLocalization, mutators: { unlinkAccount: unlinkAccount }, viewPaths: viewPaths, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const [isLoading, setIsLoading] = (0, $7PdBe.useState)(false);
    const handleLink = async ()=>{
        setIsLoading(true);
        const callbackURL = `${baseURL}${basePath}/${viewPaths.CALLBACK}?redirectTo=${encodeURIComponent(window.location.pathname)}`;
        try {
            if (other) await authClient.oauth2.link({
                providerId: provider.provider,
                callbackURL: callbackURL,
                fetchOptions: {
                    throw: true
                }
            });
            else await authClient.linkSocial({
                provider: provider.provider,
                callbackURL: callbackURL,
                fetchOptions: {
                    throw: true
                }
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setIsLoading(false);
        }
    };
    const handleUnlink = async ()=>{
        setIsLoading(true);
        try {
            await unlinkAccount({
                accountId: account == null ? void 0 : account.accountId,
                providerId: provider.provider
            });
            await (refetch == null ? void 0 : refetch());
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsLoading(false);
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center gap-3 px-4 py-3", className, classNames == null ? void 0 : classNames.cell),
        children: [
            provider.icon && /* @__PURE__ */ (0, $hvk62.jsx)(provider.icon, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-4", classNames == null ? void 0 : classNames.icon)
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex-col",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                        className: "text-sm",
                        children: provider.name
                    }),
                    account && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AccountInfo, {
                        account: account
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button),
                disabled: isLoading,
                size: "sm",
                type: "button",
                variant: account ? "outline" : "default",
                onClick: account ? handleUnlink : handleLink,
                children: [
                    isLoading && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }),
                    account ? localization.UNLINK : localization.LINK
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$var$AccountInfo({ account: account }) {
    const { hooks: { useAccountInfo: useAccountInfo } } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { data: accountInfo, isPending: isPending } = useAccountInfo({
        accountId: account.accountId
    });
    if (isPending) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
        className: "my-0.5 h-3 w-28"
    });
    if (!accountInfo) return null;
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        className: "text-muted-foreground text-xs",
        children: accountInfo == null ? void 0 : accountInfo.user.email
    });
}
function $c5bb23e187c19083$export$4d5bdb5c371d2172({ className: className, classNames: classNames, accounts: accounts, isPending: isPending, localization: localization, skipHook: skipHook, refetch: refetch }) {
    var _a, _b, _c;
    const { hooks: { useListAccounts: useListAccounts }, localization: contextLocalization, social: social, genericOAuth: genericOAuth } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    if (!skipHook) {
        const result = useListAccounts();
        accounts = result.data;
        isPending = result.isPending;
        refetch = result.refetch;
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        title: localization.PROVIDERS,
        description: localization.PROVIDERS_DESCRIPTION,
        isPending: isPending,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
            children: isPending ? (_a = social == null ? void 0 : social.providers) == null ? void 0 : _a.map((provider)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$4cc32ea01a6b64cb, {
                    classNames: classNames
                }, provider)) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                children: [
                    (_b = social == null ? void 0 : social.providers) == null ? void 0 : _b.map((provider)=>{
                        const socialProvider = $c5bb23e187c19083$export$f673b72d48c114fb.find((socialProvider2)=>socialProvider2.provider === provider);
                        if (!socialProvider) return null;
                        return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$ProviderCell, {
                            classNames: classNames,
                            account: accounts == null ? void 0 : accounts.find((acc)=>acc.providerId === provider),
                            provider: socialProvider,
                            refetch: refetch
                        }, provider);
                    }),
                    (_c = genericOAuth == null ? void 0 : genericOAuth.providers) == null ? void 0 : _c.map((provider)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$ProviderCell, {
                            classNames: classNames,
                            account: accounts == null ? void 0 : accounts.find((acc)=>acc.providerId === provider.provider),
                            provider: provider,
                            refetch: refetch,
                            other: true
                        }, provider.provider))
                ]
            })
        })
    });
}
function $c5bb23e187c19083$export$b28585a458fee016({ className: className, enableToggle: enableToggle, onChange: onChange, ...props }) {
    const [disabled, setDisabled] = (0, $7PdBe.useState)(true);
    const [isVisible, setIsVisible] = (0, $7PdBe.useState)(false);
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: "relative",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(enableToggle && "pr-10", className),
                ...props,
                type: isVisible && enableToggle ? "text" : "password",
                onChange: (event)=>{
                    setDisabled(!event.target.value);
                    onChange == null || onChange(event);
                }
            }),
            enableToggle && /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                        className: "!bg-transparent absolute top-0 right-0",
                        disabled: disabled,
                        size: "icon",
                        type: "button",
                        variant: "ghost",
                        onClick: ()=>setIsVisible(!isVisible),
                        children: isVisible ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $03a6a1f3f1b2db9c$export$2e2bcd8739ae039), {}) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $d519d8f211846ea6$export$2e2bcd8739ae039), {})
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)("style", {
                        children: `
                        .hide-password-toggle::-ms-reveal,
                        .hide-password-toggle::-ms-clear {
                            visibility: hidden;
                            pointer-events: none;
                            display: none;
                        }
                    `
                    })
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$export$87cba2619f818916({ classNames: classNames }) {
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: "flex flex-col gap-1.5",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-4 w-32", classNames == null ? void 0 : classNames.skeleton)
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-9 w-full", classNames == null ? void 0 : classNames.skeleton)
            })
        ]
    });
}
function $c5bb23e187c19083$export$b78c3f98a6b95c86({ className: className, classNames: classNames, accounts: accounts, isPending: isPending, localization: localization, skipHook: skipHook, passwordValidation: passwordValidation }) {
    const { authClient: authClient, basePath: basePath, baseURL: baseURL, credentials: credentials, hooks: { useSession: useSession, useListAccounts: useListAccounts }, localization: contextLocalization, viewPaths: viewPaths, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const confirmPasswordEnabled = credentials == null ? void 0 : credentials.confirmPassword;
    const contextPasswordValidation = credentials == null ? void 0 : credentials.passwordValidation;
    localization = {
        ...contextLocalization,
        ...localization
    };
    passwordValidation = {
        ...contextPasswordValidation,
        ...passwordValidation
    };
    const { data: sessionData } = useSession();
    if (!skipHook) {
        const result = useListAccounts();
        accounts = result.data;
        isPending = result.isPending;
    }
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        currentPassword: (0, $220046a7533cffdb$export$cb8de236c1721184)(passwordValidation, localization),
        newPassword: (0, $220046a7533cffdb$export$cb8de236c1721184)(passwordValidation, {
            PASSWORD_REQUIRED: localization.NEW_PASSWORD_REQUIRED,
            PASSWORD_TOO_SHORT: localization.PASSWORD_TOO_SHORT,
            PASSWORD_TOO_LONG: localization.PASSWORD_TOO_LONG,
            INVALID_PASSWORD: localization.INVALID_PASSWORD
        }),
        confirmPassword: confirmPasswordEnabled ? (0, $220046a7533cffdb$export$cb8de236c1721184)(passwordValidation, {
            PASSWORD_REQUIRED: localization.CONFIRM_PASSWORD_REQUIRED,
            PASSWORD_TOO_SHORT: localization.PASSWORD_TOO_SHORT,
            PASSWORD_TOO_LONG: localization.PASSWORD_TOO_LONG,
            INVALID_PASSWORD: localization.INVALID_PASSWORD
        }) : $034fa980286ebb75$export$22b082955e083ec3().optional()
    }).refine((data)=>!confirmPasswordEnabled || data.newPassword === data.confirmPassword, {
        message: localization.PASSWORDS_DO_NOT_MATCH,
        path: [
            "confirmPassword"
        ]
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
        }
    });
    const setPasswordForm = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)();
    const { isSubmitting: isSubmitting } = form.formState;
    const setPassword = async ()=>{
        if (!sessionData) return;
        const email = sessionData == null ? void 0 : sessionData.user.email;
        try {
            await authClient.requestPasswordReset({
                email: email,
                redirectTo: `${baseURL}${basePath}/${viewPaths.RESET_PASSWORD}`,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.FORGOT_PASSWORD_EMAIL
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    const changePassword = async ({ currentPassword: currentPassword, newPassword: newPassword })=>{
        try {
            await authClient.changePassword({
                currentPassword: currentPassword,
                newPassword: newPassword,
                revokeOtherSessions: true,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.CHANGE_PASSWORD_SUCCESS
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        form.reset();
    };
    const credentialsLinked = accounts == null ? void 0 : accounts.some((acc)=>acc.providerId === "credential");
    if (!isPending && !credentialsLinked) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...setPasswordForm,
        children: /* @__PURE__ */ (0, $hvk62.jsx)("form", {
            onSubmit: setPasswordForm.handleSubmit(setPassword),
            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                title: localization.SET_PASSWORD,
                description: localization.SET_PASSWORD_DESCRIPTION,
                actionLabel: localization.SET_PASSWORD,
                isPending: isPending,
                className: className,
                classNames: classNames
            })
        })
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsx)("form", {
            onSubmit: form.handleSubmit(changePassword),
            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                actionLabel: localization.SAVE,
                description: localization.CHANGE_PASSWORD_DESCRIPTION,
                instructions: localization.CHANGE_PASSWORD_INSTRUCTIONS,
                isPending: isPending,
                title: localization.CHANGE_PASSWORD,
                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-6", classNames == null ? void 0 : classNames.content),
                    children: isPending || !accounts ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$87cba2619f818916, {
                                classNames: classNames
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$87cba2619f818916, {
                                classNames: classNames
                            }),
                            confirmPasswordEnabled && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$87cba2619f818916, {
                                classNames: classNames
                            })
                        ]
                    }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "currentPassword",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                className: classNames == null ? void 0 : classNames.label,
                                                children: localization.CURRENT_PASSWORD
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                                    className: classNames == null ? void 0 : classNames.input,
                                                    autoComplete: "current-password",
                                                    placeholder: localization.CURRENT_PASSWORD_PLACEHOLDER,
                                                    disabled: isSubmitting,
                                                    ...field
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                                className: classNames == null ? void 0 : classNames.error
                                            })
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "newPassword",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                className: classNames == null ? void 0 : classNames.label,
                                                children: localization.NEW_PASSWORD
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                                    className: classNames == null ? void 0 : classNames.input,
                                                    autoComplete: "new-password",
                                                    disabled: isSubmitting,
                                                    placeholder: localization.NEW_PASSWORD_PLACEHOLDER,
                                                    enableToggle: true,
                                                    ...field
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                                className: classNames == null ? void 0 : classNames.error
                                            })
                                        ]
                                    })
                            }),
                            confirmPasswordEnabled && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "confirmPassword",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                className: classNames == null ? void 0 : classNames.label,
                                                children: localization.CONFIRM_PASSWORD
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                                    className: classNames == null ? void 0 : classNames.input,
                                                    autoComplete: "new-password",
                                                    placeholder: localization.CONFIRM_PASSWORD_PLACEHOLDER,
                                                    disabled: isSubmitting,
                                                    enableToggle: true,
                                                    ...field
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                                className: classNames == null ? void 0 : classNames.error
                                            })
                                        ]
                                    })
                            })
                        ]
                    })
                })
            })
        })
    });
}
function $c5bb23e187c19083$var$SessionCell({ className: className, classNames: classNames, localization: localization, session: session, refetch: refetch }) {
    var _a, _b;
    const { basePath: basePath, hooks: { useSession: useSession }, localization: contextLocalization, mutators: { revokeSession: revokeSession }, viewPaths: viewPaths, navigate: navigate, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: sessionData } = useSession();
    const isCurrentSession = session.id === ((_a = sessionData == null ? void 0 : sessionData.session) == null ? void 0 : _a.id);
    const [isLoading, setIsLoading] = (0, $7PdBe.useState)(false);
    const handleRevoke = async ()=>{
        setIsLoading(true);
        if (isCurrentSession) {
            navigate(`${basePath}/${viewPaths.SIGN_OUT}`);
            return;
        }
        try {
            await revokeSession({
                token: session.token
            });
            refetch == null || refetch();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setIsLoading(false);
        }
    };
    const parser = (0, $2BzXY.UAParser)(session.userAgent);
    const isMobile = parser.device.type === "mobile";
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center gap-3 px-4 py-3", className, classNames == null ? void 0 : classNames.cell),
        children: [
            isMobile ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $1010c5d615305245$export$2e2bcd8739ae039), {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-4", classNames == null ? void 0 : classNames.icon)
            }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $58bb0bc6d028a22f$export$2e2bcd8739ae039), {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-4", classNames == null ? void 0 : classNames.icon)
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                        className: "font-semibold text-sm",
                        children: isCurrentSession ? localization.CURRENT_SESSION : session == null ? void 0 : session.ipAddress
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                        className: "text-muted-foreground text-xs",
                        children: ((_b = session.userAgent) == null ? void 0 : _b.includes("tauri-plugin-http")) ? localization.APP : parser.os.name && parser.browser.name ? `${parser.os.name}, ${parser.browser.name}` : parser.os.name || parser.browser.name || session.userAgent || localization.UNKNOWN
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                disabled: isLoading,
                size: "sm",
                variant: "outline",
                onClick: handleRevoke,
                children: [
                    isLoading && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }),
                    isCurrentSession ? localization.SIGN_OUT : localization.REVOKE
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$export$f198f7039d37b4d8({ className: className, classNames: classNames, localization: localization }) {
    const { hooks: { useListSessions: useListSessions }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: sessions, isPending: isPending, refetch: refetch } = useListSessions();
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        description: localization.SESSIONS_DESCRIPTION,
        isPending: isPending,
        title: localization.SESSIONS,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
            children: isPending ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$4cc32ea01a6b64cb, {
                classNames: classNames
            }) : sessions == null ? void 0 : sessions.map((session)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SessionCell, {
                    classNames: classNames,
                    localization: localization,
                    session: session,
                    refetch: refetch
                }, session.id))
        })
    });
}
function $c5bb23e187c19083$var$BackupCodesDialog({ classNames: classNames, backupCodes: backupCodes, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { localization: localization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const [copied, setCopied] = (0, $7PdBe.useState)(false);
    const handleCopy = ()=>{
        const codeText = backupCodes.join("\n");
        navigator.clipboard.writeText(codeText);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2e3);
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            onOpenAutoFocus: (e)=>e.preventDefault(),
            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content,
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization.BACKUP_CODES
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.BACKUP_CODES_DESCRIPTION
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                    className: "grid grid-cols-2 gap-2",
                    children: backupCodes.map((code, index)=>/* @__PURE__ */ (0, $hvk62.jsx)("div", {
                            className: "rounded-md bg-muted p-2 text-center font-mono text-sm",
                            children: code
                        }, index))
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                    className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "outline",
                            onClick: handleCopy,
                            disabled: copied,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                            children: copied ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)((0, $bf8cdbeb7c4555a4$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    }),
                                    localization.COPIED_TO_CLIPBOARD
                                ]
                            }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)((0, $0ff2a797c5b6f40a$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    }),
                                    localization.COPY_ALL_CODES
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "default",
                            onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                            children: localization.CONTINUE
                        })
                    ]
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$TwoFactorPasswordDialog({ classNames: classNames, onOpenChange: onOpenChange, isTwoFactorEnabled: isTwoFactorEnabled, ...props }) {
    var _a, _b;
    const { localization: localization, authClient: authClient, basePath: basePath, viewPaths: viewPaths, navigate: navigate, toast: toast, twoFactor: twoFactor } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const [showBackupCodesDialog, setShowBackupCodesDialog] = (0, $7PdBe.useState)(false);
    const [backupCodes, setBackupCodes] = (0, $7PdBe.useState)([]);
    const [totpURI, setTotpURI] = (0, $7PdBe.useState)(null);
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        password: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: localization.PASSWORD_REQUIRED
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            password: ""
        }
    });
    const { isSubmitting: isSubmitting } = form.formState;
    async function enableTwoFactor({ password: password }) {
        try {
            const response = await authClient.twoFactor.enable({
                password: password,
                fetchOptions: {
                    throw: true
                }
            });
            onOpenChange == null || onOpenChange(false);
            setBackupCodes(response.backupCodes);
            if (twoFactor == null ? void 0 : twoFactor.includes("totp")) setTotpURI(response.totpURI);
            setTimeout(()=>{
                setShowBackupCodesDialog(true);
            }, 250);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    }
    async function disableTwoFactor({ password: password }) {
        try {
            await authClient.twoFactor.disable({
                password: password,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.TWO_FACTOR_DISABLED
            });
            onOpenChange == null || onOpenChange(false);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
                onOpenChange: onOpenChange,
                ...props,
                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("sm:max-w-md", classNames == null ? void 0 : classNames.dialog),
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.header,
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                                    className: classNames == null ? void 0 : classNames.title,
                                    children: localization.TWO_FACTOR
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                                    className: classNames == null ? void 0 : classNames.description,
                                    children: isTwoFactorEnabled ? localization.TWO_FACTOR_DISABLE_INSTRUCTIONS : localization.TWO_FACTOR_ENABLE_INSTRUCTIONS
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                            ...form,
                            children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
                                onSubmit: form.handleSubmit(isTwoFactorEnabled ? disableTwoFactor : enableTwoFactor),
                                className: "grid gap-4",
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                        control: form.control,
                                        name: "password",
                                        render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                                children: [
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                        className: classNames == null ? void 0 : classNames.label,
                                                        children: localization.PASSWORD
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                                            className: classNames == null ? void 0 : classNames.input,
                                                            placeholder: localization.PASSWORD_PLACEHOLDER,
                                                            autoComplete: "current-password",
                                                            ...field
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                                        className: classNames == null ? void 0 : classNames.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                                        className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.footer,
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                                type: "button",
                                                variant: "secondary",
                                                onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.secondaryButton),
                                                children: localization.CANCEL
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                                type: "submit",
                                                disabled: isSubmitting,
                                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                                                children: [
                                                    isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                                        className: "animate-spin"
                                                    }),
                                                    isTwoFactorEnabled ? localization.DISABLE_TWO_FACTOR : localization.ENABLE_TWO_FACTOR
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$BackupCodesDialog, {
                classNames: classNames,
                open: showBackupCodesDialog,
                onOpenChange: (open)=>{
                    setShowBackupCodesDialog(open);
                    if (!open) {
                        const url = `${basePath}/${viewPaths.TWO_FACTOR}`;
                        navigate((twoFactor == null ? void 0 : twoFactor.includes("totp")) && totpURI ? `${url}?totpURI=${totpURI}` : url);
                    }
                },
                backupCodes: backupCodes
            })
        ]
    });
}
function $c5bb23e187c19083$export$63a84495d6ad3272({ className: className, classNames: classNames, localization: localization }) {
    var _a;
    const { localization: contextLocalization, hooks: { useSession: useSession } } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const [showPasswordDialog, setShowPasswordDialog] = (0, $7PdBe.useState)(false);
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { data: sessionData, isPending: isPending } = useSession();
    const isTwoFactorEnabled = (_a = sessionData == null ? void 0 : sessionData.user) == null ? void 0 : _a.twoFactorEnabled;
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                actionLabel: isTwoFactorEnabled ? localization.DISABLE_TWO_FACTOR : localization.ENABLE_TWO_FACTOR,
                description: localization.TWO_FACTOR_CARD_DESCRIPTION,
                instructions: isTwoFactorEnabled ? localization.TWO_FACTOR_DISABLE_INSTRUCTIONS : localization.TWO_FACTOR_ENABLE_INSTRUCTIONS,
                isPending: isPending,
                title: localization.TWO_FACTOR,
                action: ()=>setShowPasswordDialog(true)
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$TwoFactorPasswordDialog, {
                classNames: classNames,
                open: showPasswordDialog,
                onOpenChange: setShowPasswordDialog,
                isTwoFactorEnabled: !!isTwoFactorEnabled
            })
        ]
    });
}
function $c5bb23e187c19083$export$f3c57e5817e9409({ className: className, classNames: classNames, localization: localization }) {
    var _a, _b;
    const { credentials: credentials, deleteUser: deleteUser, hooks: hooks, localization: contextLocalization, passkey: passkey, social: social, genericOAuth: genericOAuth, twoFactor: twoFactor } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { useListAccounts: useListAccounts } = hooks;
    const { data: accounts, isPending: accountsPending, refetch: refetchAccounts } = useListAccounts();
    const credentialsLinked = accounts == null ? void 0 : accounts.some((acc)=>acc.providerId === "credential");
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-full flex-col gap-4 md:gap-6", className, classNames == null ? void 0 : classNames.cards),
        children: [
            credentials && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b78c3f98a6b95c86, {
                accounts: accounts,
                classNames: classNames == null ? void 0 : classNames.card,
                isPending: accountsPending,
                localization: localization,
                skipHook: true
            }),
            (((_a = social == null ? void 0 : social.providers) == null ? void 0 : _a.length) || ((_b = genericOAuth == null ? void 0 : genericOAuth.providers) == null ? void 0 : _b.length)) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$4d5bdb5c371d2172, {
                accounts: accounts,
                classNames: classNames == null ? void 0 : classNames.card,
                isPending: accountsPending,
                localization: localization,
                refetch: refetchAccounts,
                skipHook: true
            }),
            twoFactor && credentialsLinked && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$63a84495d6ad3272, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            }),
            passkey && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$ea81fe102dc1bc56, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$f198f7039d37b4d8, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            }),
            deleteUser && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$e6c2f96bd0326378, {
                accounts: accounts,
                classNames: classNames == null ? void 0 : classNames.card,
                isPending: accountsPending,
                localization: localization,
                skipHook: true
            })
        ]
    });
}
function $c5bb23e187c19083$var$Drawer({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $f60a43aec6935ca4$export$4071300121a182f5).Root, {
        "data-slot": "drawer",
        ...props
    });
}
function $c5bb23e187c19083$var$DrawerTrigger({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $f60a43aec6935ca4$export$4071300121a182f5).Trigger, {
        "data-slot": "drawer-trigger",
        ...props
    });
}
function $c5bb23e187c19083$var$DrawerPortal({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $f60a43aec6935ca4$export$4071300121a182f5).Portal, {
        "data-slot": "drawer-portal",
        ...props
    });
}
function $c5bb23e187c19083$var$DrawerOverlay({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $f60a43aec6935ca4$export$4071300121a182f5).Overlay, {
        "data-slot": "drawer-overlay",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", className),
        ...props
    });
}
function $c5bb23e187c19083$var$DrawerContent({ className: className, children: children, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DrawerPortal, {
        "data-slot": "drawer-portal",
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DrawerOverlay, {}),
            /* @__PURE__ */ (0, $hvk62.jsxs)((0, $f60a43aec6935ca4$export$4071300121a182f5).Content, {
                "data-slot": "drawer-content",
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("group/drawer-content bg-background fixed z-50 flex h-auto flex-col", "data-[vaul-drawer-direction=top]:inset-x-0 data-[vaul-drawer-direction=top]:top-0 data-[vaul-drawer-direction=top]:mb-24 data-[vaul-drawer-direction=top]:max-h-[80vh] data-[vaul-drawer-direction=top]:rounded-b-lg data-[vaul-drawer-direction=top]:border-b", "data-[vaul-drawer-direction=bottom]:inset-x-0 data-[vaul-drawer-direction=bottom]:bottom-0 data-[vaul-drawer-direction=bottom]:mt-24 data-[vaul-drawer-direction=bottom]:max-h-[80vh] data-[vaul-drawer-direction=bottom]:rounded-t-lg data-[vaul-drawer-direction=bottom]:border-t", "data-[vaul-drawer-direction=right]:inset-y-0 data-[vaul-drawer-direction=right]:right-0 data-[vaul-drawer-direction=right]:w-3/4 data-[vaul-drawer-direction=right]:border-l data-[vaul-drawer-direction=right]:sm:max-w-sm", "data-[vaul-drawer-direction=left]:inset-y-0 data-[vaul-drawer-direction=left]:left-0 data-[vaul-drawer-direction=left]:w-3/4 data-[vaul-drawer-direction=left]:border-r data-[vaul-drawer-direction=left]:sm:max-w-sm", className),
                ...props,
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                        className: "bg-muted mx-auto mt-4 hidden h-2 w-[100px] shrink-0 rounded-full group-data-[vaul-drawer-direction=bottom]/drawer-content:block"
                    }),
                    children
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$var$DrawerHeader({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "drawer-header",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex flex-col gap-0.5 p-4 group-data-[vaul-drawer-direction=bottom]/drawer-content:text-center group-data-[vaul-drawer-direction=top]/drawer-content:text-center md:gap-1.5 md:text-left", className),
        ...props
    });
}
function $c5bb23e187c19083$var$DrawerTitle({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $f60a43aec6935ca4$export$4071300121a182f5).Title, {
        "data-slot": "drawer-title",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-foreground font-semibold", className),
        ...props
    });
}
function $c5bb23e187c19083$export$fc14f7024165eccb({ className: className, classNames: classNames, localization: localizationProp, path: pathProp, pathname: pathname, view: viewProp, hideNav: hideNav }) {
    var _a, _b;
    const { apiKey: apiKey, localization: contextLocalization, organization: organization, account: accountOptions, Link: Link } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    if (!accountOptions) return null;
    $c5bb23e187c19083$export$141ca0666da3bf00();
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const path = pathProp ?? (pathname == null ? void 0 : pathname.split("/").pop());
    const view = viewProp || (0, $220046a7533cffdb$export$4bd320b27036ede5)(accountOptions.viewPaths, path) || "SETTINGS";
    const navItems = [
        {
            view: "SETTINGS",
            label: localization.ACCOUNT
        },
        {
            view: "SECURITY",
            label: localization.SECURITY
        }
    ];
    if (apiKey) navItems.push({
        view: "API_KEYS",
        label: localization.API_KEYS
    });
    if (organization) navItems.push({
        view: "ORGANIZATIONS",
        label: localization.ORGANIZATIONS
    });
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-full grow flex-col gap-4 md:flex-row md:gap-12", className, classNames == null ? void 0 : classNames.base),
        children: [
            !hideNav && /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex justify-between gap-2 md:hidden",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Label2, {
                        className: "font-semibold text-base",
                        children: (_a = navItems.find((i)=>i.view === view)) == null ? void 0 : _a.label
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Drawer, {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DrawerTrigger, {
                                asChild: true,
                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                    variant: "outline",
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $2f5c5352f7ba804e$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DrawerContent, {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DrawerHeader, {
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DrawerTitle, {
                                            className: "hidden",
                                            children: localization.SETTINGS
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                                        className: "flex flex-col px-4 pb-4",
                                        children: navItems.map((item)=>{
                                            var _a2;
                                            return /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                                href: `${accountOptions == null ? void 0 : accountOptions.basePath}/${accountOptions == null ? void 0 : accountOptions.viewPaths[item.view]}`,
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                                    size: "lg",
                                                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full justify-start px-4 transition-none", (_a2 = classNames == null ? void 0 : classNames.drawer) == null ? void 0 : _a2.menuItem, view === item.view ? "font-semibold" : "text-foreground/70"),
                                                    variant: "ghost",
                                                    children: item.label
                                                })
                                            }, item.view);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !hideNav && /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                className: "hidden md:block",
                children: /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-48 flex-col gap-1 lg:w-60", (_b = classNames == null ? void 0 : classNames.sidebar) == null ? void 0 : _b.base),
                    children: navItems.map((item)=>{
                        var _a2, _b2;
                        return /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                            href: `${accountOptions == null ? void 0 : accountOptions.basePath}/${accountOptions == null ? void 0 : accountOptions.viewPaths[item.view]}`,
                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                size: "lg",
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full justify-start px-4 transition-none", (_a2 = classNames == null ? void 0 : classNames.sidebar) == null ? void 0 : _a2.button, view === item.view ? "font-semibold" : "text-foreground/70", view === item.view && ((_b2 = classNames == null ? void 0 : classNames.sidebar) == null ? void 0 : _b2.buttonActive)),
                                variant: "ghost",
                                children: item.label
                            })
                        }, item.view);
                    })
                })
            }),
            view === "SETTINGS" && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$db800a74e878c520, {
                classNames: classNames,
                localization: localization
            }),
            view === "SECURITY" && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$f3c57e5817e9409, {
                classNames: classNames,
                localization: localization
            }),
            view === "API_KEYS" && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$ab29d533d6c9d3ce, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization
            }),
            view === "ORGANIZATIONS" && organization && /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "grid w-full gap-4 md:gap-6",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$93f9032b69be429e, {
                        classNames: classNames == null ? void 0 : classNames.card,
                        localization: localization
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$72f118cc20e62477, {
                        classNames: classNames == null ? void 0 : classNames.card,
                        localization: localization
                    })
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$var$useOnSuccessTransition({ redirectTo: redirectToProp }) {
    const { redirectTo: contextRedirectTo } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const getRedirectTo = (0, $7PdBe.useCallback)(()=>redirectToProp || (0, $220046a7533cffdb$export$cea57e52bbb16e9c)("redirectTo") || contextRedirectTo, [
        redirectToProp,
        contextRedirectTo
    ]);
    const [isPending, startTransition] = (0, $7PdBe.useTransition)();
    const [success, setSuccess] = (0, $7PdBe.useState)(false);
    const { navigate: navigate, hooks: { useSession: useSession }, onSessionChange: onSessionChange } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { refetch: refetchSession } = useSession();
    (0, $7PdBe.useEffect)(()=>{
        if (!success || isPending) return;
        startTransition(()=>{
            navigate(getRedirectTo());
        });
    }, [
        success,
        isPending,
        navigate,
        getRedirectTo
    ]);
    const onSuccess = (0, $7PdBe.useCallback)(async ()=>{
        await (refetchSession == null ? void 0 : refetchSession());
        setSuccess(true);
        if (onSessionChange) startTransition(onSessionChange);
    }, [
        refetchSession,
        onSessionChange
    ]);
    return {
        onSuccess: onSuccess,
        isPending: isPending
    };
}
function $c5bb23e187c19083$export$ac3c0d49631935da({ redirectTo: redirectTo }) {
    const { hooks: { useIsRestoring: useIsRestoring }, persistClient: persistClient } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const isRestoring = useIsRestoring == null ? void 0 : useIsRestoring();
    const isRedirecting = (0, $7PdBe.useRef)(false);
    const { onSuccess: onSuccess } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: redirectTo
    });
    (0, $7PdBe.useEffect)(()=>{
        if (isRedirecting.current) return;
        if (!persistClient) {
            isRedirecting.current = true;
            onSuccess();
            return;
        }
        if (isRestoring) return;
        isRedirecting.current = true;
        onSuccess();
    }, [
        isRestoring,
        persistClient,
        onSuccess
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
        className: "animate-spin"
    });
}
function $c5bb23e187c19083$var$InputOTP({ className: className, containerClassName: containerClassName, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $0b4ffad7aef772d8$export$b3e9284b45af84ba), {
        "data-slot": "input-otp",
        containerClassName: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center gap-2 has-disabled:opacity-50", containerClassName),
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("disabled:cursor-not-allowed", className),
        ...props
    });
}
function $c5bb23e187c19083$var$InputOTPGroup({ className: className, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "input-otp-group",
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center", className),
        ...props
    });
}
function $c5bb23e187c19083$var$InputOTPSlot({ index: index, className: className, ...props }) {
    const inputOTPContext = $7PdBe.useContext((0, $0b4ffad7aef772d8$export$8507feb4f97f5eac));
    const { char: char, hasFakeCaret: hasFakeCaret, isActive: isActive } = (inputOTPContext == null ? void 0 : inputOTPContext.slots[index]) ?? {};
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        "data-slot": "input-otp-slot",
        "data-active": isActive,
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("data-[active=true]:border-ring data-[active=true]:ring-ring/50 data-[active=true]:aria-invalid:ring-destructive/20 dark:data-[active=true]:aria-invalid:ring-destructive/40 aria-invalid:border-destructive data-[active=true]:aria-invalid:border-destructive dark:bg-input/30 border-input relative flex h-9 w-9 items-center justify-center border-y border-r text-sm shadow-xs transition-all outline-none first:rounded-l-md first:border-l last:rounded-r-md data-[active=true]:z-10 data-[active=true]:ring-[3px]", className),
        ...props,
        children: [
            char,
            hasFakeCaret && /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                className: "pointer-events-none absolute inset-0 flex items-center justify-center",
                children: /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                    className: "animate-caret-blink bg-foreground h-4 w-px duration-1000"
                })
            })
        ]
    });
}
function $c5bb23e187c19083$var$InputOTPSeparator({ ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)("div", {
        "data-slot": "input-otp-separator",
        role: "separator",
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $014dbf7ae4460a37$export$2e2bcd8739ae039), {})
    });
}
function $c5bb23e187c19083$var$OTPInputGroup({ otpSeparators: otpSeparators = 0 }) {
    if (otpSeparators === 0) return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$InputOTPGroup, {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                index: 0
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                index: 1
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                index: 2
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                index: 3
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                index: 4
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                index: 5
            })
        ]
    });
    if (otpSeparators === 1) return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$InputOTPGroup, {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 0
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 1
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 2
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSeparator, {}),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$InputOTPGroup, {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 3
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 4
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 5
                    })
                ]
            })
        ]
    });
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$InputOTPGroup, {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 0
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 1
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSeparator, {}),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$InputOTPGroup, {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 2
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 3
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSeparator, {}),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$InputOTPGroup, {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 4
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTPSlot, {
                        index: 5
                    })
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$var$EmailOTPForm(props) {
    const [email, setEmail] = (0, $7PdBe.useState)();
    if (!email) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$EmailForm, {
        ...props,
        setEmail: setEmail
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OTPForm, {
        ...props,
        email: email
    });
}
function $c5bb23e187c19083$var$EmailForm({ className: className, classNames: classNames, isSubmitting: isSubmitting, localization: localization, setIsSubmitting: setIsSubmitting, setEmail: setEmail }) {
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const { authClient: authClient, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        email: $034fa980286ebb75$export$22b082955e083ec3().email({
            message: `${localization.EMAIL} ${localization.IS_INVALID}`
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            email: ""
        }
    });
    isSubmitting = isSubmitting || form.formState.isSubmitting;
    (0, $7PdBe.useEffect)(()=>{
        setIsSubmitting == null || setIsSubmitting(form.formState.isSubmitting);
    }, [
        form.formState.isSubmitting,
        setIsSubmitting
    ]);
    async function sendEmailOTP({ email: email }) {
        try {
            await authClient.emailOtp.sendVerificationOtp({
                email: email,
                type: "sign-in",
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.EMAIL_OTP_VERIFICATION_SENT
            });
            setEmail(email);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(sendEmailOTP),
            noValidate: isHydrated,
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid w-full gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "email",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.EMAIL
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                        className: classNames == null ? void 0 : classNames.input,
                                        type: "email",
                                        placeholder: localization.EMAIL_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                    type: "submit",
                    disabled: isSubmitting,
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                    children: isSubmitting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }) : localization.EMAIL_OTP_SEND_ACTION
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$OTPForm({ className: className, classNames: classNames, isSubmitting: isSubmitting, localization: localization, otpSeparators: otpSeparators = 0, redirectTo: redirectTo, setIsSubmitting: setIsSubmitting, email: email }) {
    const { authClient: authClient, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { onSuccess: onSuccess, isPending: transitionPending } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: redirectTo
    });
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        code: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.EMAIL_OTP} ${localization.IS_REQUIRED}`
        }).min(6, {
            message: `${localization.EMAIL_OTP} ${localization.IS_INVALID}`
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            code: ""
        }
    });
    isSubmitting = isSubmitting || form.formState.isSubmitting || transitionPending;
    (0, $7PdBe.useEffect)(()=>{
        setIsSubmitting == null || setIsSubmitting(form.formState.isSubmitting || transitionPending);
    }, [
        form.formState.isSubmitting,
        transitionPending,
        setIsSubmitting
    ]);
    async function verifyCode({ code: code }) {
        try {
            await authClient.signIn.emailOtp({
                email: email,
                otp: code,
                fetchOptions: {
                    throw: true
                }
            });
            await onSuccess();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            form.reset();
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(verifyCode),
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid w-full gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "code",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.EMAIL_OTP
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTP, {
                                        ...field,
                                        maxLength: 6,
                                        onChange: (value)=>{
                                            field.onChange(value);
                                            if (value.length === 6) form.handleSubmit(verifyCode)();
                                        },
                                        containerClassName: classNames == null ? void 0 : classNames.otpInputContainer,
                                        className: classNames == null ? void 0 : classNames.otpInput,
                                        disabled: isSubmitting,
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OTPInputGroup, {
                                            otpSeparators: otpSeparators
                                        })
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                    className: "grid gap-4",
                    children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                        type: "submit",
                        disabled: isSubmitting,
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                        children: [
                            isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                className: "animate-spin"
                            }),
                            localization.EMAIL_OTP_VERIFY_ACTION
                        ]
                    })
                })
            ]
        })
    });
}
var $c5bb23e187c19083$var$DEFAULT_CAPTCHA_ENDPOINTS = [
    "/sign-up/email",
    "/sign-in/email",
    "/forget-password"
];
var $c5bb23e187c19083$var$sanitizeActionName = (action)=>{
    let result = action.startsWith("/") ? action.substring(1) : action;
    result = result.replace(/-([a-z])/g, (_, letter)=>letter.toUpperCase()).replace(/\/([a-z])/g, (_, letter)=>letter.toUpperCase()).replace(/\//g, "").replace(/[^A-Za-z0-9_]/g, "");
    return result;
};
function $c5bb23e187c19083$var$useCaptcha({ localization: localization }) {
    const { captcha: captcha, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const captchaRef = (0, $7PdBe.useRef)(null);
    const { executeRecaptcha: executeRecaptcha } = (0, $2c6937dda4728c6c$export$2e2bcd8739ae039)();
    const executeCaptcha = async (action)=>{
        if (!captcha) throw new Error(localization.MISSING_RESPONSE);
        let response;
        switch(captcha.provider){
            case "google-recaptcha-v3":
                {
                    const sanitizedAction = $c5bb23e187c19083$var$sanitizeActionName(action);
                    response = await (executeRecaptcha == null ? void 0 : executeRecaptcha(sanitizedAction));
                    break;
                }
            case "google-recaptcha-v2-checkbox":
                {
                    const recaptchaRef = captchaRef;
                    response = recaptchaRef.current.getValue();
                    break;
                }
            case "google-recaptcha-v2-invisible":
                {
                    const recaptchaRef = captchaRef;
                    response = await recaptchaRef.current.executeAsync();
                    break;
                }
            case "cloudflare-turnstile":
                {
                    const turnstileRef = captchaRef;
                    response = turnstileRef.current.getResponse();
                    break;
                }
            case "hcaptcha":
                {
                    const hcaptchaRef = captchaRef;
                    response = hcaptchaRef.current.getResponse();
                    break;
                }
        }
        if (!response) throw new Error(localization.MISSING_RESPONSE);
        return response;
    };
    const getCaptchaHeaders = async (action)=>{
        if (!captcha) return void 0;
        const endpoints = captcha.endpoints || $c5bb23e187c19083$var$DEFAULT_CAPTCHA_ENDPOINTS;
        if (endpoints.includes(action)) return {
            "x-captcha-response": await executeCaptcha(action)
        };
        return void 0;
    };
    const resetCaptcha = ()=>{
        var _a, _b, _c, _d, _e, _f;
        if (!captcha) return;
        switch(captcha.provider){
            case "google-recaptcha-v3":
                break;
            case "google-recaptcha-v2-checkbox":
            case "google-recaptcha-v2-invisible":
                {
                    const recaptchaRef = captchaRef;
                    (_b = (_a = recaptchaRef.current) == null ? void 0 : _a.reset) == null || _b.call(_a);
                    break;
                }
            case "cloudflare-turnstile":
                {
                    const turnstileRef = captchaRef;
                    (_d = (_c = turnstileRef.current) == null ? void 0 : _c.reset) == null || _d.call(_c);
                    break;
                }
            case "hcaptcha":
                {
                    const hcaptchaRef = captchaRef;
                    (_f = (_e = hcaptchaRef.current) == null ? void 0 : _e.resetCaptcha) == null || _f.call(_e);
                    break;
                }
        }
    };
    return {
        captchaRef: captchaRef,
        getCaptchaHeaders: getCaptchaHeaders,
        resetCaptcha: resetCaptcha
    };
}
function $c5bb23e187c19083$var$RecaptchaBadge({ className: className, localization: propLocalization }) {
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const { captcha: captcha, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = {
        ...contextLocalization,
        ...propLocalization
    };
    if (!captcha) return null;
    if (!captcha.hideBadge) return isHydrated ? /* @__PURE__ */ (0, $hvk62.jsx)("style", {
        children: `
                .grecaptcha-badge { visibility: visible !important; }
            `
    }) : null;
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("style", {
                children: `
                .grecaptcha-badge { visibility: hidden; }
            `
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)("p", {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-muted-foreground text-xs", className),
                children: [
                    localization.PROTECTED_BY_RECAPTCHA,
                    " ",
                    localization.BY_CONTINUING_YOU_AGREE,
                    " Google",
                    " ",
                    /* @__PURE__ */ (0, $hvk62.jsx)("a", {
                        className: "text-foreground hover:underline",
                        href: "https://policies.google.com/privacy",
                        target: "_blank",
                        rel: "noreferrer",
                        children: localization.PRIVACY_POLICY
                    }),
                    " ",
                    "&",
                    " ",
                    /* @__PURE__ */ (0, $hvk62.jsx)("a", {
                        className: "text-foreground hover:underline",
                        href: "https://policies.google.com/terms",
                        target: "_blank",
                        rel: "noreferrer",
                        children: localization.TERMS_OF_SERVICE
                    }),
                    "."
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$var$RecaptchaV2({ ref: ref }) {
    const { captcha: captcha } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { theme: theme } = (0, $07d0275849708341$export$93d4e7f90805808f)();
    const { lang: lang } = (0, $07d0275849708341$export$b24a004ee43dce44)();
    (0, $7PdBe.useEffect)(()=>{
        window.recaptchaOptions = {
            useRecaptchaNet: captcha == null ? void 0 : captcha.recaptchaNet,
            enterprise: captcha == null ? void 0 : captcha.enterprise
        };
    }, [
        captcha
    ]);
    if (!captcha) return null;
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("style", {
                children: `
                .grecaptcha-badge {
                    border-radius: var(--radius) !important;
                    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, #0000000d);
                    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
                    border-style: var(--tw-border-style) !important;
                    border-width: 1px;
                }

                .dark .grecaptcha-badge {
                    border-color: var(--input) !important;
                }
            `
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)((0, $352a1050383a653c$export$2e2bcd8739ae039), {
                ref: ref,
                sitekey: captcha.siteKey,
                theme: theme,
                hl: lang,
                size: captcha.provider === "google-recaptcha-v2-invisible" ? "invisible" : "normal",
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(captcha.provider === "google-recaptcha-v2-invisible" ? "absolute" : "mx-auto h-[76px] w-[302px] overflow-hidden rounded bg-muted")
            }, `${theme}-${lang}-${captcha.provider}`)
        ]
    });
}
var $c5bb23e187c19083$var$DEFAULT_CAPTCHA_ENDPOINTS2 = [
    "/sign-up/email",
    "/sign-in/email",
    "/forget-password"
];
function $c5bb23e187c19083$var$Captcha({ ref: ref, localization: localization, action: action }) {
    const { captcha: captcha } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    if (!captcha) return null;
    if (action) {
        const endpoints = captcha.endpoints || $c5bb23e187c19083$var$DEFAULT_CAPTCHA_ENDPOINTS2;
        if (!endpoints.includes(action)) return null;
    }
    const { theme: theme } = (0, $07d0275849708341$export$93d4e7f90805808f)();
    const showRecaptchaV2 = captcha.provider === "google-recaptcha-v2-checkbox" || captcha.provider === "google-recaptcha-v2-invisible";
    const showRecaptchaBadge = captcha.provider === "google-recaptcha-v3" || captcha.provider === "google-recaptcha-v2-invisible";
    const showTurnstile = captcha.provider === "cloudflare-turnstile";
    const showHCaptcha = captcha.provider === "hcaptcha";
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            showRecaptchaV2 && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$RecaptchaV2, {
                ref: ref
            }),
            showRecaptchaBadge && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$RecaptchaBadge, {
                localization: localization
            }),
            showTurnstile && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6cbd97fe76e000ef$export$9370f0117bf9debc), {
                className: "mx-auto",
                ref: ref,
                siteKey: captcha.siteKey,
                options: {
                    theme: theme,
                    size: "flexible"
                }
            }),
            showHCaptcha && /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                className: "mx-auto",
                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $4b7bd5be895d43d1$export$2e2bcd8739ae039), {
                    ref: ref,
                    sitekey: captcha.siteKey,
                    theme: theme
                })
            })
        ]
    });
}
function $c5bb23e187c19083$export$187cf9544d0c1f9e({ className: className, classNames: classNames, isSubmitting: isSubmitting, localization: localization, setIsSubmitting: setIsSubmitting }) {
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const { captchaRef: captchaRef, getCaptchaHeaders: getCaptchaHeaders, resetCaptcha: resetCaptcha } = $c5bb23e187c19083$var$useCaptcha({
        localization: localization
    });
    const { authClient: authClient, basePath: basePath, baseURL: baseURL, localization: contextLocalization, navigate: navigate, toast: toast, viewPaths: viewPaths } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        email: $034fa980286ebb75$export$22b082955e083ec3().email({
            message: `${localization.EMAIL} ${localization.IS_INVALID}`
        }).min(1, {
            message: `${localization.EMAIL} ${localization.IS_REQUIRED}`
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            email: ""
        }
    });
    isSubmitting = isSubmitting || form.formState.isSubmitting;
    (0, $7PdBe.useEffect)(()=>{
        setIsSubmitting == null || setIsSubmitting(form.formState.isSubmitting);
    }, [
        form.formState.isSubmitting,
        setIsSubmitting
    ]);
    async function forgotPassword({ email: email }) {
        try {
            const fetchOptions = {
                throw: true,
                headers: await getCaptchaHeaders("/forget-password")
            };
            await authClient.requestPasswordReset({
                email: email,
                redirectTo: `${baseURL}${basePath}/${viewPaths.RESET_PASSWORD}`,
                fetchOptions: fetchOptions
            });
            toast({
                variant: "success",
                message: localization.FORGOT_PASSWORD_EMAIL
            });
            navigate(`${basePath}/${viewPaths.SIGN_IN}${window.location.search}`);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            resetCaptcha();
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(forgotPassword),
            noValidate: isHydrated,
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid w-full gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "email",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.EMAIL
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                        className: classNames == null ? void 0 : classNames.input,
                                        type: "email",
                                        placeholder: localization.EMAIL_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Captcha, {
                    ref: captchaRef,
                    localization: localization,
                    action: "/forget-password"
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                    type: "submit",
                    disabled: isSubmitting,
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                    children: isSubmitting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }) : localization.FORGOT_PASSWORD_ACTION
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$2030ca72657e424({ className: className, classNames: classNames, callbackURL: callbackURLProp, isSubmitting: isSubmitting, localization: localization, redirectTo: redirectToProp, setIsSubmitting: setIsSubmitting }) {
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const { captchaRef: captchaRef, getCaptchaHeaders: getCaptchaHeaders, resetCaptcha: resetCaptcha } = $c5bb23e187c19083$var$useCaptcha({
        localization: localization
    });
    const { authClient: authClient, basePath: basePath, baseURL: baseURL, persistClient: persistClient, localization: contextLocalization, redirectTo: contextRedirectTo, viewPaths: viewPaths, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const getRedirectTo = (0, $7PdBe.useCallback)(()=>redirectToProp || (0, $220046a7533cffdb$export$cea57e52bbb16e9c)("redirectTo") || contextRedirectTo, [
        redirectToProp,
        contextRedirectTo
    ]);
    const getCallbackURL = (0, $7PdBe.useCallback)(()=>`${baseURL}${callbackURLProp || (persistClient ? `${basePath}/${viewPaths.CALLBACK}?redirectTo=${encodeURIComponent(getRedirectTo())}` : getRedirectTo())}`, [
        callbackURLProp,
        persistClient,
        basePath,
        viewPaths,
        baseURL,
        getRedirectTo
    ]);
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        email: $034fa980286ebb75$export$22b082955e083ec3().email({
            message: `${localization.EMAIL} ${localization.IS_INVALID}`
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            email: ""
        }
    });
    isSubmitting = isSubmitting || form.formState.isSubmitting;
    (0, $7PdBe.useEffect)(()=>{
        setIsSubmitting == null || setIsSubmitting(form.formState.isSubmitting);
    }, [
        form.formState.isSubmitting,
        setIsSubmitting
    ]);
    async function sendMagicLink({ email: email }) {
        try {
            const fetchOptions = {
                throw: true,
                headers: await getCaptchaHeaders("/sign-in/magic-link")
            };
            await authClient.signIn.magicLink({
                email: email,
                callbackURL: getCallbackURL(),
                fetchOptions: fetchOptions
            });
            toast({
                variant: "success",
                message: localization.MAGIC_LINK_EMAIL
            });
            form.reset();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            resetCaptcha();
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(sendMagicLink),
            noValidate: isHydrated,
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid w-full gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "email",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.EMAIL
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                        className: classNames == null ? void 0 : classNames.input,
                                        type: "email",
                                        placeholder: localization.EMAIL_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Captcha, {
                    ref: captchaRef,
                    localization: localization,
                    action: "/sign-in/magic-link"
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                    type: "submit",
                    disabled: isSubmitting,
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                    children: isSubmitting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }) : localization.MAGIC_LINK_ACTION
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$6e670311e107d5b2({ className: className, classNames: classNames, isSubmitting: isSubmitting, localization: localization, redirectTo: redirectTo, setIsSubmitting: setIsSubmitting }) {
    const { authClient: authClient, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { onSuccess: onSuccess, isPending: transitionPending } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: redirectTo
    });
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        code: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: localization.BACKUP_CODE_REQUIRED
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            code: ""
        }
    });
    isSubmitting = isSubmitting || form.formState.isSubmitting || transitionPending;
    (0, $7PdBe.useEffect)(()=>{
        setIsSubmitting == null || setIsSubmitting(form.formState.isSubmitting || transitionPending);
    }, [
        form.formState.isSubmitting,
        transitionPending,
        setIsSubmitting
    ]);
    async function verifyBackupCode({ code: code }) {
        try {
            await authClient.twoFactor.verifyBackupCode({
                code: code,
                fetchOptions: {
                    throw: true
                }
            });
            await onSuccess();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            form.reset();
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(verifyBackupCode),
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "code",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.BACKUP_CODE
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                        placeholder: localization.BACKUP_CODE_PLACEHOLDER,
                                        autoComplete: "off",
                                        className: classNames == null ? void 0 : classNames.input,
                                        disabled: isSubmitting,
                                        ...field
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                    type: "submit",
                    disabled: isSubmitting,
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                    children: isSubmitting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }) : localization.RECOVER_ACCOUNT_ACTION
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$29f8ea18bcf9a8f3({ className: className, classNames: classNames, localization: localization, passwordValidation: passwordValidation }) {
    const tokenChecked = (0, $7PdBe.useRef)(false);
    const { authClient: authClient, basePath: basePath, credentials: credentials, localization: contextLocalization, viewPaths: viewPaths, navigate: navigate, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const confirmPasswordEnabled = credentials == null ? void 0 : credentials.confirmPassword;
    const contextPasswordValidation = credentials == null ? void 0 : credentials.passwordValidation;
    localization = {
        ...contextLocalization,
        ...localization
    };
    passwordValidation = {
        ...contextPasswordValidation,
        ...passwordValidation
    };
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        newPassword: (0, $220046a7533cffdb$export$cb8de236c1721184)(passwordValidation, {
            PASSWORD_REQUIRED: localization.NEW_PASSWORD_REQUIRED,
            PASSWORD_TOO_SHORT: localization.PASSWORD_TOO_SHORT,
            PASSWORD_TOO_LONG: localization.PASSWORD_TOO_LONG,
            INVALID_PASSWORD: localization.INVALID_PASSWORD
        }),
        confirmPassword: confirmPasswordEnabled ? (0, $220046a7533cffdb$export$cb8de236c1721184)(passwordValidation, {
            PASSWORD_REQUIRED: localization.CONFIRM_PASSWORD_REQUIRED,
            PASSWORD_TOO_SHORT: localization.PASSWORD_TOO_SHORT,
            PASSWORD_TOO_LONG: localization.PASSWORD_TOO_LONG,
            INVALID_PASSWORD: localization.INVALID_PASSWORD
        }) : $034fa980286ebb75$export$22b082955e083ec3().optional()
    }).refine((data)=>!confirmPasswordEnabled || data.newPassword === data.confirmPassword, {
        message: localization.PASSWORDS_DO_NOT_MATCH,
        path: [
            "confirmPassword"
        ]
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            newPassword: "",
            confirmPassword: ""
        }
    });
    const isSubmitting = form.formState.isSubmitting;
    (0, $7PdBe.useEffect)(()=>{
        if (tokenChecked.current) return;
        tokenChecked.current = true;
        const searchParams = new URLSearchParams(window.location.search);
        const token = searchParams.get("token");
        if (!token || token === "INVALID_TOKEN") {
            navigate(`${basePath}/${viewPaths.SIGN_IN}${window.location.search}`);
            toast({
                variant: "error",
                message: localization.INVALID_TOKEN
            });
        }
    }, [
        basePath,
        navigate,
        toast,
        viewPaths,
        localization
    ]);
    async function resetPassword({ newPassword: newPassword }) {
        try {
            const searchParams = new URLSearchParams(window.location.search);
            const token = searchParams.get("token");
            await authClient.resetPassword({
                newPassword: newPassword,
                token: token,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.RESET_PASSWORD_SUCCESS
            });
            navigate(`${basePath}/${viewPaths.SIGN_IN}${window.location.search}`);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            form.reset();
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(resetPassword),
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid w-full gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "newPassword",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.NEW_PASSWORD
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                        autoComplete: "new-password",
                                        className: classNames == null ? void 0 : classNames.input,
                                        placeholder: localization.NEW_PASSWORD_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                confirmPasswordEnabled && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "confirmPassword",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.CONFIRM_PASSWORD
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                        autoComplete: "new-password",
                                        className: classNames == null ? void 0 : classNames.input,
                                        placeholder: localization.CONFIRM_PASSWORD_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                    type: "submit",
                    disabled: isSubmitting,
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                    children: isSubmitting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }) : localization.RESET_PASSWORD_ACTION
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$88eb1f631f57c0a6({ className: className, classNames: classNames, isSubmitting: isSubmitting, localization: localization, redirectTo: redirectTo, setIsSubmitting: setIsSubmitting, passwordValidation: passwordValidation }) {
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const { captchaRef: captchaRef, getCaptchaHeaders: getCaptchaHeaders, resetCaptcha: resetCaptcha } = $c5bb23e187c19083$var$useCaptcha({
        localization: localization
    });
    const { authClient: authClient, basePath: basePath, credentials: credentials, localization: contextLocalization, viewPaths: viewPaths, navigate: navigate, toast: toast, Link: Link } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const rememberMeEnabled = credentials == null ? void 0 : credentials.rememberMe;
    const usernameEnabled = credentials == null ? void 0 : credentials.username;
    const contextPasswordValidation = credentials == null ? void 0 : credentials.passwordValidation;
    localization = {
        ...contextLocalization,
        ...localization
    };
    passwordValidation = {
        ...contextPasswordValidation,
        ...passwordValidation
    };
    const { onSuccess: onSuccess, isPending: transitionPending } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: redirectTo
    });
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        email: usernameEnabled ? $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.USERNAME} ${localization.IS_REQUIRED}`
        }) : $034fa980286ebb75$export$22b082955e083ec3().email({
            message: `${localization.EMAIL} ${localization.IS_INVALID}`
        }),
        password: (0, $220046a7533cffdb$export$cb8de236c1721184)(passwordValidation, localization),
        rememberMe: $034fa980286ebb75$export$4a21f16c33752377().optional()
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            email: "",
            password: "",
            rememberMe: !rememberMeEnabled
        }
    });
    isSubmitting = isSubmitting || form.formState.isSubmitting || transitionPending;
    (0, $7PdBe.useEffect)(()=>{
        setIsSubmitting == null || setIsSubmitting(form.formState.isSubmitting || transitionPending);
    }, [
        form.formState.isSubmitting,
        transitionPending,
        setIsSubmitting
    ]);
    async function signIn({ email: email, password: password, rememberMe: rememberMe }) {
        try {
            let response = {};
            if (usernameEnabled && !(0, $220046a7533cffdb$export$371e338370561054)(email)) {
                const fetchOptions = {
                    throw: true,
                    headers: await getCaptchaHeaders("/sign-in/username")
                };
                response = await authClient.signIn.username({
                    username: email,
                    password: password,
                    rememberMe: rememberMe,
                    fetchOptions: fetchOptions
                });
            } else {
                const fetchOptions = {
                    throw: true,
                    headers: await getCaptchaHeaders("/sign-in/email")
                };
                response = await authClient.signIn.email({
                    email: email,
                    password: password,
                    rememberMe: rememberMe,
                    fetchOptions: fetchOptions
                });
            }
            if (response.twoFactorRedirect) navigate(`${basePath}/${viewPaths.TWO_FACTOR}${window.location.search}`);
            else await onSuccess();
        } catch (error) {
            form.resetField("password");
            resetCaptcha();
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(signIn),
            noValidate: isHydrated,
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid w-full gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "email",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: usernameEnabled ? localization.USERNAME : localization.EMAIL
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                        autoComplete: usernameEnabled ? "username" : "email",
                                        className: classNames == null ? void 0 : classNames.input,
                                        type: usernameEnabled ? "text" : "email",
                                        placeholder: usernameEnabled ? localization.SIGN_IN_USERNAME_PLACEHOLDER : localization.EMAIL_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "password",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                            className: classNames == null ? void 0 : classNames.label,
                                            children: localization.PASSWORD
                                        }),
                                        (credentials == null ? void 0 : credentials.forgotPassword) && /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-sm hover:underline", classNames == null ? void 0 : classNames.forgotPasswordLink),
                                            href: `${basePath}/${viewPaths.FORGOT_PASSWORD}${isHydrated ? window.location.search : ""}`,
                                            children: localization.FORGOT_PASSWORD_LINK
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                        autoComplete: "current-password",
                                        className: classNames == null ? void 0 : classNames.input,
                                        placeholder: localization.PASSWORD_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                rememberMeEnabled && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "rememberMe",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            className: "flex",
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Checkbox, {
                                        checked: field.value,
                                        onCheckedChange: field.onChange,
                                        disabled: isSubmitting
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    children: localization.REMEMBER_ME
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Captcha, {
                    ref: captchaRef,
                    localization: localization,
                    action: "/sign-in/email"
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                    type: "submit",
                    disabled: isSubmitting,
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                    children: isSubmitting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }) : localization.SIGN_IN_ACTION
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$3bd2b4ee8d70ffe2({ className: className, classNames: classNames, callbackURL: callbackURL, isSubmitting: isSubmitting, localization: localization, redirectTo: redirectTo, setIsSubmitting: setIsSubmitting, passwordValidation: passwordValidation }) {
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const { captchaRef: captchaRef, getCaptchaHeaders: getCaptchaHeaders, resetCaptcha: resetCaptcha } = $c5bb23e187c19083$var$useCaptcha({
        localization: localization
    });
    const { additionalFields: additionalFields, authClient: authClient, basePath: basePath, baseURL: baseURL, credentials: credentials, localization: contextLocalization, nameRequired: nameRequired, persistClient: persistClient, redirectTo: contextRedirectTo, signUp: signUpOptions, viewPaths: viewPaths, navigate: navigate, toast: toast, avatar: avatar } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const confirmPasswordEnabled = credentials == null ? void 0 : credentials.confirmPassword;
    const usernameEnabled = credentials == null ? void 0 : credentials.username;
    const contextPasswordValidation = credentials == null ? void 0 : credentials.passwordValidation;
    const signUpFields = signUpOptions == null ? void 0 : signUpOptions.fields;
    localization = {
        ...contextLocalization,
        ...localization
    };
    passwordValidation = {
        ...contextPasswordValidation,
        ...passwordValidation
    };
    const fileInputRef = (0, $7PdBe.useRef)(null);
    const [avatarImage, setAvatarImage] = (0, $7PdBe.useState)(null);
    const [uploadingAvatar, setUploadingAvatar] = (0, $7PdBe.useState)(false);
    const getRedirectTo = (0, $7PdBe.useCallback)(()=>redirectTo || (0, $220046a7533cffdb$export$cea57e52bbb16e9c)("redirectTo") || contextRedirectTo, [
        redirectTo,
        contextRedirectTo
    ]);
    const getCallbackURL = (0, $7PdBe.useCallback)(()=>`${baseURL}${callbackURL || (persistClient ? `${basePath}/${viewPaths.CALLBACK}?redirectTo=${encodeURIComponent(getRedirectTo())}` : getRedirectTo())}`, [
        callbackURL,
        persistClient,
        basePath,
        viewPaths,
        baseURL,
        getRedirectTo
    ]);
    const { onSuccess: onSuccess, isPending: transitionPending } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: redirectTo
    });
    const defaultFields = {
        email: $034fa980286ebb75$export$22b082955e083ec3().email({
            message: `${localization.EMAIL} ${localization.IS_INVALID}`
        }),
        password: (0, $220046a7533cffdb$export$cb8de236c1721184)(passwordValidation, localization),
        name: (signUpFields == null ? void 0 : signUpFields.includes("name")) && nameRequired ? $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.NAME} ${localization.IS_REQUIRED}`
        }) : $034fa980286ebb75$export$22b082955e083ec3().optional(),
        image: $034fa980286ebb75$export$22b082955e083ec3().optional(),
        username: usernameEnabled ? $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.USERNAME} ${localization.IS_REQUIRED}`
        }) : $034fa980286ebb75$export$22b082955e083ec3().optional(),
        confirmPassword: confirmPasswordEnabled ? (0, $220046a7533cffdb$export$cb8de236c1721184)(passwordValidation, {
            PASSWORD_REQUIRED: localization.CONFIRM_PASSWORD_REQUIRED,
            PASSWORD_TOO_SHORT: localization.PASSWORD_TOO_SHORT,
            PASSWORD_TOO_LONG: localization.PASSWORD_TOO_LONG,
            INVALID_PASSWORD: localization.INVALID_PASSWORD
        }) : $034fa980286ebb75$export$22b082955e083ec3().optional()
    };
    const schemaFields = {};
    if (signUpFields) for (const field of signUpFields){
        if (field === "name") continue;
        if (field === "image") continue;
        const additionalField = additionalFields == null ? void 0 : additionalFields[field];
        if (!additionalField) continue;
        let fieldSchema;
        if (additionalField.type === "number") fieldSchema = additionalField.required ? $034fa980286ebb75$export$fc37fe19dfda43ee((val)=>!val ? void 0 : Number(val), $034fa980286ebb75$export$98e628dec113755e({
            message: `${additionalField.label} ${localization.IS_INVALID}`
        })) : $034fa980286ebb75$export$8c14e57e778d3873.number({
            message: `${additionalField.label} ${localization.IS_INVALID}`
        }).optional();
        else if (additionalField.type === "boolean") fieldSchema = additionalField.required ? $034fa980286ebb75$export$8c14e57e778d3873.boolean({
            message: `${additionalField.label} ${localization.IS_INVALID}`
        }).refine((val)=>val === true, {
            message: `${additionalField.label} ${localization.IS_REQUIRED}`
        }) : $034fa980286ebb75$export$8c14e57e778d3873.boolean({
            message: `${additionalField.label} ${localization.IS_INVALID}`
        }).optional();
        else fieldSchema = additionalField.required ? $034fa980286ebb75$export$22b082955e083ec3().min(1, `${additionalField.label} ${localization.IS_REQUIRED}`) : $034fa980286ebb75$export$22b082955e083ec3().optional();
        schemaFields[field] = fieldSchema;
    }
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe(defaultFields).extend(schemaFields).refine((data)=>{
        if (!confirmPasswordEnabled) return true;
        return data.password === data.confirmPassword;
    }, {
        message: localization.PASSWORDS_DO_NOT_MATCH,
        path: [
            "confirmPassword"
        ]
    });
    const defaultValues = {
        email: "",
        password: "",
        ...confirmPasswordEnabled && {
            confirmPassword: ""
        },
        ...(signUpFields == null ? void 0 : signUpFields.includes("name")) ? {
            name: ""
        } : {},
        ...usernameEnabled ? {
            username: ""
        } : {},
        ...(signUpFields == null ? void 0 : signUpFields.includes("image")) && avatar ? {
            image: ""
        } : {}
    };
    if (signUpFields) for (const field of signUpFields){
        if (field === "name") continue;
        if (field === "image") continue;
        const additionalField = additionalFields == null ? void 0 : additionalFields[field];
        if (!additionalField) continue;
        defaultValues[field] = additionalField.type === "boolean" ? false : "";
    }
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: defaultValues
    });
    isSubmitting = isSubmitting || form.formState.isSubmitting || transitionPending;
    (0, $7PdBe.useEffect)(()=>{
        setIsSubmitting == null || setIsSubmitting(form.formState.isSubmitting || transitionPending);
    }, [
        form.formState.isSubmitting,
        transitionPending,
        setIsSubmitting
    ]);
    const handleAvatarChange = async (file)=>{
        if (!avatar) return;
        setUploadingAvatar(true);
        try {
            const resizedFile = await $c5bb23e187c19083$var$resizeAndCropImage(file, crypto.randomUUID(), avatar.size, avatar.extension);
            let image;
            if (avatar.upload) image = await avatar.upload(resizedFile);
            else image = await $c5bb23e187c19083$var$fileToBase64(resizedFile);
            if (image) {
                setAvatarImage(image);
                form.setValue("image", image);
            } else {
                setAvatarImage(null);
                form.setValue("image", "");
            }
        } catch (error) {
            console.error(error);
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setUploadingAvatar(false);
    };
    const handleDeleteAvatar = ()=>{
        setAvatarImage(null);
        form.setValue("image", "");
    };
    const openFileDialog = ()=>{
        var _a;
        return (_a = fileInputRef.current) == null ? void 0 : _a.click();
    };
    async function signUp({ email: email, password: password, name: name, username: username, confirmPassword: confirmPassword, image: image, ...additionalFieldValues }) {
        try {
            for (const [field, value] of Object.entries(additionalFieldValues)){
                const additionalField = additionalFields == null ? void 0 : additionalFields[field];
                if (!(additionalField == null ? void 0 : additionalField.validate)) continue;
                if (typeof value === "string" && !await additionalField.validate(value)) {
                    form.setError(field, {
                        message: `${additionalField.label} ${localization.IS_INVALID}`
                    });
                    return;
                }
            }
            const fetchOptions = {
                throw: true,
                headers: await getCaptchaHeaders("/sign-up/email")
            };
            const additionalParams = {};
            if (username !== void 0) additionalParams.username = username;
            if (image !== void 0) additionalParams.image = image;
            const data = await authClient.signUp.email({
                email: email,
                password: password,
                name: name || "",
                ...additionalParams,
                ...additionalFieldValues,
                callbackURL: getCallbackURL(),
                fetchOptions: fetchOptions
            });
            if ("token" in data && data.token) await onSuccess();
            else {
                navigate(`${basePath}/${viewPaths.SIGN_IN}${window.location.search}`);
                toast({
                    variant: "success",
                    message: localization.SIGN_UP_EMAIL
                });
            }
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            form.resetField("password");
            form.resetField("confirmPassword");
            resetCaptcha();
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(signUp),
            noValidate: isHydrated,
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid w-full gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                (signUpFields == null ? void 0 : signUpFields.includes("image")) && avatar && /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)("input", {
                            ref: fileInputRef,
                            accept: "image/*",
                            disabled: uploadingAvatar,
                            hidden: true,
                            type: "file",
                            onChange: (e)=>{
                                var _a;
                                const file = (_a = e.target.files) == null ? void 0 : _a.item(0);
                                if (file) handleAvatarChange(file);
                                e.target.value = "";
                            }
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                            control: form.control,
                            name: "image",
                            render: ()=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                            children: localization.AVATAR
                                        }),
                                        /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                            className: "flex items-center gap-4",
                                            children: [
                                                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                                                    children: [
                                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                                                            asChild: true,
                                                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                                                className: "size-fit rounded-full",
                                                                size: "icon",
                                                                variant: "ghost",
                                                                type: "button",
                                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6c0524ba53950d9f, {
                                                                    isPending: uploadingAvatar,
                                                                    className: "size-16",
                                                                    user: avatarImage ? {
                                                                        name: form.watch("name"),
                                                                        email: form.watch("email"),
                                                                        image: avatarImage
                                                                    } : null,
                                                                    localization: localization
                                                                })
                                                            })
                                                        }),
                                                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                                                            align: "start",
                                                            onCloseAutoFocus: (e)=>e.preventDefault(),
                                                            children: [
                                                                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                                                    onClick: openFileDialog,
                                                                    disabled: uploadingAvatar,
                                                                    children: [
                                                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $c30ce99ee32b9b4f$export$2e2bcd8739ae039), {}),
                                                                        localization.UPLOAD_AVATAR
                                                                    ]
                                                                }),
                                                                avatarImage && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                                                    onClick: handleDeleteAvatar,
                                                                    disabled: uploadingAvatar,
                                                                    variant: "destructive",
                                                                    children: [
                                                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $28b54fce4c436a82$export$2e2bcd8739ae039), {}),
                                                                        localization.DELETE_AVATAR
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                                    type: "button",
                                                    variant: "outline",
                                                    onClick: openFileDialog,
                                                    disabled: uploadingAvatar,
                                                    children: [
                                                        uploadingAvatar && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                                            className: "animate-spin"
                                                        }),
                                                        localization.UPLOAD
                                                    ]
                                                })
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                    ]
                                })
                        })
                    ]
                }),
                (signUpFields == null ? void 0 : signUpFields.includes("name")) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "name",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.NAME
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                        className: classNames == null ? void 0 : classNames.input,
                                        placeholder: localization.NAME_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field,
                                        value: field.value
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                usernameEnabled && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "username",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.USERNAME
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                        className: classNames == null ? void 0 : classNames.input,
                                        placeholder: localization.USERNAME_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field,
                                        value: field.value
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "email",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.EMAIL
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                        className: classNames == null ? void 0 : classNames.input,
                                        type: "email",
                                        placeholder: localization.EMAIL_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        ...field,
                                        value: field.value
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "password",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.PASSWORD
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                        autoComplete: "new-password",
                                        className: classNames == null ? void 0 : classNames.input,
                                        placeholder: localization.PASSWORD_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        enableToggle: true,
                                        ...field,
                                        value: field.value
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                confirmPasswordEnabled && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                    control: form.control,
                    name: "confirmPassword",
                    render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                    className: classNames == null ? void 0 : classNames.label,
                                    children: localization.CONFIRM_PASSWORD
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$b28585a458fee016, {
                                        autoComplete: "new-password",
                                        className: classNames == null ? void 0 : classNames.input,
                                        placeholder: localization.CONFIRM_PASSWORD_PLACEHOLDER,
                                        disabled: isSubmitting,
                                        enableToggle: true,
                                        ...field,
                                        value: field.value
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                    className: classNames == null ? void 0 : classNames.error
                                })
                            ]
                        })
                }),
                signUpFields == null ? void 0 : signUpFields.filter((field)=>field !== "name" && field !== "image").map((field)=>{
                    const additionalField = additionalFields == null ? void 0 : additionalFields[field];
                    if (!additionalField) {
                        console.error(`Additional field ${field} not found`);
                        return null;
                    }
                    return additionalField.type === "boolean" ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                        control: form.control,
                        name: field,
                        render: ({ field: formField })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                className: "flex",
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Checkbox, {
                                            checked: formField.value,
                                            onCheckedChange: formField.onChange,
                                            disabled: isSubmitting
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                        className: classNames == null ? void 0 : classNames.label,
                                        children: additionalField.label
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                        className: classNames == null ? void 0 : classNames.error
                                    })
                                ]
                            })
                    }, field) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                        control: form.control,
                        name: field,
                        render: ({ field: formField })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                        className: classNames == null ? void 0 : classNames.label,
                                        children: additionalField.label
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                        children: additionalField.type === "number" ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                            className: classNames == null ? void 0 : classNames.input,
                                            type: "number",
                                            placeholder: additionalField.placeholder || (typeof additionalField.label === "string" ? additionalField.label : ""),
                                            disabled: isSubmitting,
                                            ...formField,
                                            value: formField.value
                                        }) : additionalField.multiline ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Textarea, {
                                            className: classNames == null ? void 0 : classNames.input,
                                            placeholder: additionalField.placeholder || (typeof additionalField.label === "string" ? additionalField.label : ""),
                                            disabled: isSubmitting,
                                            ...formField,
                                            value: formField.value
                                        }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                            className: classNames == null ? void 0 : classNames.input,
                                            type: "text",
                                            placeholder: additionalField.placeholder || (typeof additionalField.label === "string" ? additionalField.label : ""),
                                            disabled: isSubmitting,
                                            ...formField,
                                            value: formField.value
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                        className: classNames == null ? void 0 : classNames.error
                                    })
                                ]
                            })
                    }, field);
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Captcha, {
                    ref: captchaRef,
                    localization: localization,
                    action: "/sign-up/email"
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                    type: "submit",
                    disabled: isSubmitting,
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                    children: isSubmitting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                        className: "animate-spin"
                    }) : localization.SIGN_UP_ACTION
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$4d5987b82320f50f({ className: className, classNames: classNames, isSubmitting: isSubmitting, localization: localization, otpSeparators: otpSeparators = 0, redirectTo: redirectTo, setIsSubmitting: setIsSubmitting }) {
    var _a;
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const totpURI = isHydrated ? (0, $220046a7533cffdb$export$cea57e52bbb16e9c)("totpURI") : null;
    const initialSendRef = (0, $7PdBe.useRef)(false);
    const { authClient: authClient, basePath: basePath, hooks: { useSession: useSession }, localization: contextLocalization, twoFactor: twoFactor, viewPaths: viewPaths, toast: toast, Link: Link } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { onSuccess: onSuccess, isPending: transitionPending } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: redirectTo
    });
    const { data: sessionData } = useSession();
    const isTwoFactorEnabled = (_a = sessionData == null ? void 0 : sessionData.user) == null ? void 0 : _a.twoFactorEnabled;
    const [method, setMethod] = (0, $7PdBe.useState)((twoFactor == null ? void 0 : twoFactor.length) === 1 ? twoFactor[0] : null);
    const [isSendingOtp, setIsSendingOtp] = (0, $7PdBe.useState)(false);
    const [cooldownSeconds, setCooldownSeconds] = (0, $7PdBe.useState)(0);
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        code: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.ONE_TIME_PASSWORD} ${localization.IS_REQUIRED}`
        }).min(6, {
            message: `${localization.ONE_TIME_PASSWORD} ${localization.IS_INVALID}`
        }),
        trustDevice: $034fa980286ebb75$export$4a21f16c33752377().optional()
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            code: ""
        }
    });
    isSubmitting = isSubmitting || form.formState.isSubmitting || transitionPending;
    (0, $7PdBe.useEffect)(()=>{
        setIsSubmitting == null || setIsSubmitting(form.formState.isSubmitting || transitionPending);
    }, [
        form.formState.isSubmitting,
        transitionPending,
        setIsSubmitting
    ]);
    (0, $7PdBe.useEffect)(()=>{
        if (method === "otp" && cooldownSeconds <= 0 && !initialSendRef.current) {
            initialSendRef.current = true;
            sendOtp();
        }
    }, [
        method
    ]);
    (0, $7PdBe.useEffect)(()=>{
        if (cooldownSeconds <= 0) return;
        const timer = setTimeout(()=>{
            setCooldownSeconds((prev)=>prev - 1);
        }, 1e3);
        return ()=>clearTimeout(timer);
    }, [
        cooldownSeconds
    ]);
    const sendOtp = async ()=>{
        if (isSendingOtp || cooldownSeconds > 0) return;
        try {
            setIsSendingOtp(true);
            await authClient.twoFactor.sendOtp({
                fetchOptions: {
                    throw: true
                }
            });
            setCooldownSeconds(60);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            if (error.error.code === "INVALID_TWO_FACTOR_COOKIE") history.back();
        }
        initialSendRef.current = false;
        setIsSendingOtp(false);
    };
    async function verifyCode({ code: code, trustDevice: trustDevice }) {
        try {
            const verifyMethod = method === "totp" ? authClient.twoFactor.verifyTotp : authClient.twoFactor.verifyOtp;
            await verifyMethod({
                code: code,
                trustDevice: trustDevice,
                fetchOptions: {
                    throw: true
                }
            });
            await onSuccess();
            if (sessionData && !isTwoFactorEnabled) toast({
                variant: "success",
                message: localization == null ? void 0 : localization.TWO_FACTOR_ENABLED
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            form.reset();
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
            onSubmit: form.handleSubmit(verifyCode),
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid w-full gap-6", className, classNames == null ? void 0 : classNames.base),
            children: [
                (twoFactor == null ? void 0 : twoFactor.includes("totp")) && totpURI && method === "totp" && /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                    className: "space-y-3",
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Label2, {
                            className: classNames == null ? void 0 : classNames.label,
                            children: localization.TWO_FACTOR_TOTP_LABEL
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($674f57cdc6deabab$exports))), {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("border shadow-xs", classNames == null ? void 0 : classNames.qrCode),
                            value: totpURI
                        })
                    ]
                }),
                method !== null && /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                            control: form.control,
                            name: "code",
                            render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                    className: classNames == null ? void 0 : classNames.label,
                                                    children: localization.ONE_TIME_PASSWORD
                                                }),
                                                /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-sm hover:underline", classNames == null ? void 0 : classNames.forgotPasswordLink),
                                                    href: `${basePath}/${viewPaths.RECOVER_ACCOUNT}${isHydrated ? window.location.search : ""}`,
                                                    children: localization.FORGOT_AUTHENTICATOR
                                                })
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InputOTP, {
                                                ...field,
                                                maxLength: 6,
                                                onChange: (value)=>{
                                                    field.onChange(value);
                                                    if (value.length === 6) form.handleSubmit(verifyCode)();
                                                },
                                                containerClassName: classNames == null ? void 0 : classNames.otpInputContainer,
                                                className: classNames == null ? void 0 : classNames.otpInput,
                                                disabled: isSubmitting,
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OTPInputGroup, {
                                                    otpSeparators: otpSeparators
                                                })
                                            })
                                        }),
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                            className: classNames == null ? void 0 : classNames.error
                                        })
                                    ]
                                })
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                            control: form.control,
                            name: "trustDevice",
                            render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                    className: "flex",
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Checkbox, {
                                                checked: field.value,
                                                onCheckedChange: field.onChange,
                                                disabled: isSubmitting,
                                                className: classNames == null ? void 0 : classNames.checkbox
                                            })
                                        }),
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                            className: classNames == null ? void 0 : classNames.label,
                                            children: localization.TRUST_DEVICE
                                        })
                                    ]
                                })
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                    className: "grid gap-4",
                    children: [
                        method !== null && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            type: "submit",
                            disabled: isSubmitting,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                            children: [
                                isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                    className: "animate-spin"
                                }),
                                localization.TWO_FACTOR_ACTION
                            ]
                        }),
                        method === "otp" && (twoFactor == null ? void 0 : twoFactor.includes("otp")) && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "outline",
                            onClick: sendOtp,
                            disabled: cooldownSeconds > 0 || isSendingOtp || isSubmitting,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                            children: [
                                isSendingOtp ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                    className: "animate-spin"
                                }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $e0677777e3a5031b$export$2e2bcd8739ae039), {
                                    className: classNames == null ? void 0 : classNames.icon
                                }),
                                localization.RESEND_CODE,
                                cooldownSeconds > 0 && ` (${cooldownSeconds})`
                            ]
                        }),
                        method !== "otp" && (twoFactor == null ? void 0 : twoFactor.includes("otp")) && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "secondary",
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.secondaryButton),
                            onClick: ()=>setMethod("otp"),
                            disabled: isSubmitting,
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)((0, $e0677777e3a5031b$export$2e2bcd8739ae039), {
                                    className: classNames == null ? void 0 : classNames.icon
                                }),
                                localization.SEND_VERIFICATION_CODE
                            ]
                        }),
                        method !== "totp" && (twoFactor == null ? void 0 : twoFactor.includes("totp")) && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "secondary",
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.secondaryButton),
                            onClick: ()=>setMethod("totp"),
                            disabled: isSubmitting,
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)((0, $c25648be789a95d0$export$2e2bcd8739ae039), {
                                    className: classNames == null ? void 0 : classNames.icon
                                }),
                                localization.CONTINUE_WITH_AUTHENTICATOR
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$8bdd9b9a27ab4764() {
    const signingOut = (0, $7PdBe.useRef)(false);
    const { authClient: authClient, basePath: basePath, viewPaths: viewPaths } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { onSuccess: onSuccess } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: `${basePath}/${viewPaths.SIGN_IN}`
    });
    (0, $7PdBe.useEffect)(()=>{
        if (signingOut.current) return;
        signingOut.current = true;
        authClient.signOut().finally(onSuccess);
    }, [
        authClient,
        onSuccess
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
        className: "animate-spin"
    });
}
function $c5bb23e187c19083$export$c17ac1167fee36b4({ className: className, classNames: classNames, callbackURL: callbackURL, isSubmitting: isSubmitting, localization: localization, pathname: pathname, redirectTo: redirectTo, view: view, otpSeparators: otpSeparators = 0, setIsSubmitting: setIsSubmitting }) {
    const { basePath: basePath, credentials: credentials, localization: contextLocalization, magicLink: magicLink, emailOTP: emailOTP, signUp: signUp, twoFactor: twoFactorEnabled, viewPaths: viewPaths, replace: replace } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const signUpEnabled = !!signUp;
    localization = {
        ...contextLocalization,
        ...localization
    };
    (0, $7PdBe.useEffect)(()=>{
        if (pathname && !(0, $220046a7533cffdb$export$4bd320b27036ede5)(viewPaths, pathname)) {
            console.error(`Invalid auth view: ${pathname}`);
            replace(`${basePath}/${viewPaths.SIGN_IN}${window.location.search}`);
        }
    }, [
        pathname,
        viewPaths,
        basePath,
        replace
    ]);
    view = view || (0, $220046a7533cffdb$export$4bd320b27036ede5)(viewPaths, pathname) || "SIGN_IN";
    (0, $7PdBe.useEffect)(()=>{
        let isInvalidView = false;
        if (view === "MAGIC_LINK" && (!magicLink || !credentials && !emailOTP)) isInvalidView = true;
        if (view === "EMAIL_OTP" && (!emailOTP || !credentials && !magicLink)) isInvalidView = true;
        if (view === "SIGN_UP" && !signUpEnabled) isInvalidView = true;
        if (!credentials && [
            "SIGN_UP",
            "FORGOT_PASSWORD",
            "RESET_PASSWORD",
            "TWO_FACTOR",
            "RECOVER_ACCOUNT"
        ].includes(view)) isInvalidView = true;
        if ([
            "TWO_FACTOR",
            "RECOVER_ACCOUNT"
        ].includes(view) && !twoFactorEnabled) isInvalidView = true;
        if (isInvalidView) replace(`${basePath}/${viewPaths.SIGN_IN}${window.location.search}`);
    }, [
        basePath,
        view,
        viewPaths,
        credentials,
        replace,
        emailOTP,
        signUpEnabled,
        magicLink,
        twoFactorEnabled
    ]);
    if (view === "SIGN_OUT") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$8bdd9b9a27ab4764, {});
    if (view === "CALLBACK") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$ac3c0d49631935da, {
        redirectTo: redirectTo
    });
    if (view === "SIGN_IN") return credentials ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$88eb1f631f57c0a6, {
        className: className,
        classNames: classNames,
        localization: localization,
        redirectTo: redirectTo,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    }) : magicLink ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$2030ca72657e424, {
        className: className,
        classNames: classNames,
        callbackURL: callbackURL,
        localization: localization,
        redirectTo: redirectTo,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    }) : emailOTP ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$EmailOTPForm, {
        className: className,
        classNames: classNames,
        callbackURL: callbackURL,
        localization: localization,
        redirectTo: redirectTo,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    }) : null;
    if (view === "TWO_FACTOR") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$4d5987b82320f50f, {
        className: className,
        classNames: classNames,
        localization: localization,
        otpSeparators: otpSeparators,
        redirectTo: redirectTo,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    });
    if (view === "RECOVER_ACCOUNT") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6e670311e107d5b2, {
        className: className,
        classNames: classNames,
        localization: localization,
        redirectTo: redirectTo,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    });
    if (view === "MAGIC_LINK") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$2030ca72657e424, {
        className: className,
        classNames: classNames,
        callbackURL: callbackURL,
        localization: localization,
        redirectTo: redirectTo,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    });
    if (view === "EMAIL_OTP") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$EmailOTPForm, {
        className: className,
        classNames: classNames,
        callbackURL: callbackURL,
        localization: localization,
        redirectTo: redirectTo,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    });
    if (view === "FORGOT_PASSWORD") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$187cf9544d0c1f9e, {
        className: className,
        classNames: classNames,
        localization: localization,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    });
    if (view === "RESET_PASSWORD") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$29f8ea18bcf9a8f3, {
        className: className,
        classNames: classNames,
        localization: localization
    });
    if (view === "SIGN_UP") return signUpEnabled && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$3bd2b4ee8d70ffe2, {
        className: className,
        classNames: classNames,
        callbackURL: callbackURL,
        localization: localization,
        redirectTo: redirectTo,
        isSubmitting: isSubmitting,
        setIsSubmitting: setIsSubmitting
    });
}
function $c5bb23e187c19083$export$bef676af1f4743eb({ className: className, classNames: classNames, localization: localizationProp }) {
    const { localization: contextLocalization, redirectTo: redirectTo, replace: replace, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: sessionData } = $c5bb23e187c19083$export$141ca0666da3bf00();
    const [invitationId, setInvitationId] = (0, $7PdBe.useState)(null);
    (0, $7PdBe.useEffect)(()=>{
        const invitationIdParam = (0, $220046a7533cffdb$export$cea57e52bbb16e9c)("invitationId");
        if (!invitationIdParam) {
            toast({
                variant: "error",
                message: localization.INVITATION_NOT_FOUND
            });
            replace(redirectTo);
            return;
        }
        setInvitationId(invitationIdParam);
    }, [
        localization.INVITATION_NOT_FOUND,
        toast,
        replace,
        redirectTo
    ]);
    if (!sessionData || !invitationId) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AcceptInvitationSkeleton, {
        className: className,
        classNames: classNames
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AcceptInvitationContent, {
        className: className,
        classNames: classNames,
        localization: localization,
        invitationId: invitationId
    });
}
function $c5bb23e187c19083$var$AcceptInvitationContent({ className: className, classNames: classNames, localization: localizationProp, invitationId: invitationId }) {
    var _a;
    const { authClient: authClient, hooks: { useInvitation: useInvitation }, localization: contextLocalization, organization: organization, redirectTo: redirectTo, replace: replace, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const [isRejecting, setIsRejecting] = (0, $7PdBe.useState)(false);
    const [isAccepting, setIsAccepting] = (0, $7PdBe.useState)(false);
    const isProcessing = isRejecting || isAccepting;
    const { data: invitation, isPending: isPending } = useInvitation({
        query: {
            id: invitationId
        }
    });
    const getRedirectTo = (0, $7PdBe.useCallback)(()=>(0, $220046a7533cffdb$export$cea57e52bbb16e9c)("redirectTo") || redirectTo, [
        redirectTo
    ]);
    (0, $7PdBe.useEffect)(()=>{
        if (isPending || !invitationId) return;
        if (!invitation) {
            toast({
                variant: "error",
                message: localization.INVITATION_NOT_FOUND
            });
            replace(redirectTo);
            return;
        }
        if (invitation.status !== "pending" || new Date(invitation.expiresAt) < /* @__PURE__ */ new Date()) {
            toast({
                variant: "error",
                message: new Date(invitation.expiresAt) < /* @__PURE__ */ new Date() ? localization.INVITATION_EXPIRED : localization.INVITATION_NOT_FOUND
            });
            replace(redirectTo);
        }
    }, [
        invitation,
        isPending,
        invitationId,
        localization,
        toast,
        replace,
        redirectTo
    ]);
    const acceptInvitation = async ()=>{
        setIsAccepting(true);
        try {
            await authClient.organization.acceptInvitation({
                invitationId: invitationId,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.INVITATION_ACCEPTED || "Invitation accepted"
            });
            replace(getRedirectTo());
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setIsAccepting(false);
        }
    };
    const rejectInvitation = async ()=>{
        setIsRejecting(true);
        try {
            await authClient.organization.rejectInvitation({
                invitationId: invitationId,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.INVITATION_REJECTED
            });
            replace(redirectTo);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setIsRejecting(false);
        }
    };
    const builtInRoles = [
        {
            role: "owner",
            label: localization.OWNER
        },
        {
            role: "admin",
            label: localization.ADMIN
        },
        {
            role: "member",
            label: localization.MEMBER
        }
    ];
    const roles = [
        ...builtInRoles,
        ...(organization == null ? void 0 : organization.customRoles) || []
    ];
    const roleLabel = ((_a = roles.find((r)=>r.role === (invitation == null ? void 0 : invitation.role))) == null ? void 0 : _a.label) || (invitation == null ? void 0 : invitation.role);
    if (!invitation) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$AcceptInvitationSkeleton, {
        className: className,
        classNames: classNames
    });
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full max-w-sm", className, classNames == null ? void 0 : classNames.base),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$CardHeader, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("justify-items-center text-center", classNames == null ? void 0 : classNames.header),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardTitle, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                        children: localization.ACCEPT_INVITATION
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardDescription, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                        children: localization.ACCEPT_INVITATION_DESCRIPTION
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$CardContent, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex flex-col gap-6 truncate", classNames == null ? void 0 : classNames.content),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center p-4"),
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                                organization: {
                                    id: invitation.organizationId,
                                    name: invitation.organizationName,
                                    slug: invitation.organizationSlug,
                                    logo: invitation.organizationLogo,
                                    createdAt: /* @__PURE__ */ new Date()
                                },
                                localization: localization
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)("p", {
                                className: "ml-auto text-muted-foreground text-sm",
                                children: roleLabel
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                        className: "grid grid-cols-2 gap-3",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                variant: "outline",
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                                onClick: rejectInvitation,
                                disabled: isProcessing,
                                children: [
                                    isRejecting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                        className: "animate-spin"
                                    }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $f5645b1fe1001619$export$2e2bcd8739ae039), {}),
                                    localization.REJECT
                                ]
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                                onClick: acceptInvitation,
                                disabled: isProcessing,
                                children: [
                                    isAccepting ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                        className: "animate-spin"
                                    }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $bf8cdbeb7c4555a4$export$2e2bcd8739ae039), {}),
                                    localization.ACCEPT
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $c5bb23e187c19083$var$AcceptInvitationSkeleton = ({ className: className, classNames: classNames, localization: localization })=>{
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full max-w-sm", className, classNames == null ? void 0 : classNames.base),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$CardHeader, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("justify-items-center", classNames == null ? void 0 : classNames.header),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("my-1 h-5 w-full max-w-32 md:h-5.5 md:w-40", classNames == null ? void 0 : classNames.skeleton)
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("my-0.5 h-3 w-full max-w-56 md:h-3.5 md:w-64", classNames == null ? void 0 : classNames.skeleton)
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$CardContent, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex flex-col gap-6 truncate", classNames == null ? void 0 : classNames.content),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center p-4"),
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                                isPending: true,
                                localization: localization
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                                className: "mt-0.5 ml-auto h-4 w-full max-w-14 shrink-2"
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                        className: "grid grid-cols-2 gap-3",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                                className: "h-9 w-full"
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                                className: "h-9 w-full"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function $c5bb23e187c19083$var$Separator3({ className: className, orientation: orientation = "horizontal", decorative: decorative = true, ...props }) {
    return /* @__PURE__ */ (0, $hvk62.jsx)($84502cd5180c34f1$export$be92b6f5f03c0fe9, {
        "data-slot": "separator",
        decorative: decorative,
        orientation: orientation,
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px", className),
        ...props
    });
}
function $c5bb23e187c19083$var$EmailOTPButton({ classNames: classNames, isSubmitting: isSubmitting, localization: localization, view: view }) {
    var _a, _b, _c, _d;
    const { viewPaths: viewPaths, navigate: navigate, basePath: basePath } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", (_a = classNames == null ? void 0 : classNames.form) == null ? void 0 : _a.button, (_b = classNames == null ? void 0 : classNames.form) == null ? void 0 : _b.secondaryButton),
        disabled: isSubmitting,
        type: "button",
        variant: "secondary",
        onClick: ()=>navigate(`${basePath}/${view === "EMAIL_OTP" ? viewPaths.SIGN_IN : viewPaths.EMAIL_OTP}${window.location.search}`),
        children: [
            view === "EMAIL_OTP" ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $93fca3000ef27384$export$2e2bcd8739ae039), {
                className: (_c = classNames == null ? void 0 : classNames.form) == null ? void 0 : _c.icon
            }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $633ef490ccb7bfce$export$2e2bcd8739ae039), {
                className: (_d = classNames == null ? void 0 : classNames.form) == null ? void 0 : _d.icon
            }),
            localization.SIGN_IN_WITH,
            " ",
            view === "EMAIL_OTP" ? localization.PASSWORD : localization.EMAIL_OTP
        ]
    });
}
function $c5bb23e187c19083$var$MagicLinkButton({ classNames: classNames, isSubmitting: isSubmitting, localization: localization, view: view }) {
    var _a, _b, _c, _d;
    const { viewPaths: viewPaths, navigate: navigate, basePath: basePath, credentials: credentials } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", (_a = classNames == null ? void 0 : classNames.form) == null ? void 0 : _a.button, (_b = classNames == null ? void 0 : classNames.form) == null ? void 0 : _b.secondaryButton),
        disabled: isSubmitting,
        type: "button",
        variant: "secondary",
        onClick: ()=>navigate(`${basePath}/${view === "MAGIC_LINK" || !credentials ? viewPaths.SIGN_IN : viewPaths.MAGIC_LINK}${window.location.search}`),
        children: [
            view === "MAGIC_LINK" ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $93fca3000ef27384$export$2e2bcd8739ae039), {
                className: (_c = classNames == null ? void 0 : classNames.form) == null ? void 0 : _c.icon
            }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $633ef490ccb7bfce$export$2e2bcd8739ae039), {
                className: (_d = classNames == null ? void 0 : classNames.form) == null ? void 0 : _d.icon
            }),
            localization.SIGN_IN_WITH,
            " ",
            view === "MAGIC_LINK" ? localization.PASSWORD : localization.MAGIC_LINK
        ]
    });
}
function $c5bb23e187c19083$var$OneTap({ localization: localization, redirectTo: redirectTo }) {
    const { authClient: authClient, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const oneTapFetched = (0, $7PdBe.useRef)(false);
    localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localization
        }), [
        contextLocalization,
        localization
    ]);
    const { onSuccess: onSuccess } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: redirectTo
    });
    (0, $7PdBe.useEffect)(()=>{
        if (oneTapFetched.current) return;
        oneTapFetched.current = true;
        try {
            authClient.oneTap({
                fetchOptions: {
                    throw: true,
                    onSuccess: onSuccess
                }
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    }, [
        authClient,
        localization,
        onSuccess,
        toast
    ]);
    return null;
}
function $c5bb23e187c19083$var$PasskeyButton({ classNames: classNames, isSubmitting: isSubmitting, localization: localization, redirectTo: redirectTo, setIsSubmitting: setIsSubmitting }) {
    var _a, _b;
    const { authClient: authClient, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    const { onSuccess: onSuccess } = $c5bb23e187c19083$var$useOnSuccessTransition({
        redirectTo: redirectTo
    });
    const signInPassKey = async ()=>{
        setIsSubmitting == null || setIsSubmitting(true);
        try {
            const response = await authClient.signIn.passkey({
                fetchOptions: {
                    throw: true
                }
            });
            if (response == null ? void 0 : response.error) {
                toast({
                    variant: "error",
                    message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                        error: response.error,
                        localization: localization
                    })
                });
                setIsSubmitting == null || setIsSubmitting(false);
            } else onSuccess();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setIsSubmitting == null || setIsSubmitting(false);
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full", (_a = classNames == null ? void 0 : classNames.form) == null ? void 0 : _a.button, (_b = classNames == null ? void 0 : classNames.form) == null ? void 0 : _b.secondaryButton),
        disabled: isSubmitting,
        formNoValidate: true,
        name: "passkey",
        value: "true",
        variant: "secondary",
        onClick: signInPassKey,
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)((0, $3b980a999e8ec75a$export$2e2bcd8739ae039), {}),
            localization.SIGN_IN_WITH,
            " ",
            localization.PASSKEY
        ]
    });
}
function $c5bb23e187c19083$var$ProviderButton({ className: className, classNames: classNames, callbackURL: callbackURLProp, isSubmitting: isSubmitting, localization: localization, other: other, provider: provider, redirectTo: redirectToProp, socialLayout: socialLayout, setIsSubmitting: setIsSubmitting }) {
    var _a, _b, _c, _d;
    const { authClient: authClient, basePath: basePath, baseURL: baseURL, persistClient: persistClient, redirectTo: contextRedirectTo, viewPaths: viewPaths, social: social, genericOAuth: genericOAuth, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const getRedirectTo = (0, $7PdBe.useCallback)(()=>redirectToProp || (0, $220046a7533cffdb$export$cea57e52bbb16e9c)("redirectTo") || contextRedirectTo, [
        redirectToProp,
        contextRedirectTo
    ]);
    const getCallbackURL = (0, $7PdBe.useCallback)(()=>`${baseURL}${callbackURLProp || (persistClient ? `${basePath}/${viewPaths.CALLBACK}?redirectTo=${encodeURIComponent(getRedirectTo())}` : getRedirectTo())}`, [
        callbackURLProp,
        persistClient,
        basePath,
        viewPaths,
        baseURL,
        getRedirectTo
    ]);
    const doSignInSocial = async ()=>{
        setIsSubmitting(true);
        try {
            if (other) {
                const oauth2Params = {
                    providerId: provider.provider,
                    callbackURL: getCallbackURL(),
                    fetchOptions: {
                        throw: true
                    }
                };
                if (genericOAuth == null ? void 0 : genericOAuth.signIn) {
                    await genericOAuth.signIn(oauth2Params);
                    setTimeout(()=>{
                        setIsSubmitting(false);
                    }, 1e4);
                } else await authClient.signIn.oauth2(oauth2Params);
            } else {
                const socialParams = {
                    provider: provider.provider,
                    callbackURL: getCallbackURL(),
                    fetchOptions: {
                        throw: true
                    }
                };
                if (social == null ? void 0 : social.signIn) {
                    await social.signIn(socialParams);
                    setTimeout(()=>{
                        setIsSubmitting(false);
                    }, 1e4);
                } else await authClient.signIn.social(socialParams);
            }
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setIsSubmitting(false);
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(socialLayout === "vertical" ? "w-full" : "grow", className, (_a = classNames == null ? void 0 : classNames.form) == null ? void 0 : _a.button, (_b = classNames == null ? void 0 : classNames.form) == null ? void 0 : _b.outlineButton, (_c = classNames == null ? void 0 : classNames.form) == null ? void 0 : _c.providerButton),
        disabled: isSubmitting,
        variant: "outline",
        onClick: doSignInSocial,
        children: [
            provider.icon && /* @__PURE__ */ (0, $hvk62.jsx)(provider.icon, {
                className: (_d = classNames == null ? void 0 : classNames.form) == null ? void 0 : _d.icon
            }),
            socialLayout === "grid" && provider.name,
            socialLayout === "vertical" && `${localization.SIGN_IN_WITH} ${provider.name}`
        ]
    });
}
function $c5bb23e187c19083$export$6e722c8f9ee9bf65({ className: className, classNames: classNames, callbackURL: callbackURL, cardHeader: cardHeader, localization: localization, path: pathProp, pathname: pathname, redirectTo: redirectTo, socialLayout: socialLayoutProp = "auto", view: viewProp, otpSeparators: otpSeparators = 0 }) {
    var _a, _b, _c, _d, _e, _f;
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const { basePath: basePath, credentials: credentials, localization: contextLocalization, magicLink: magicLink, emailOTP: emailOTP, oneTap: oneTap, passkey: passkey, signUp: signUp, social: social, genericOAuth: genericOAuth, viewPaths: viewPaths, Link: Link } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    localization = {
        ...contextLocalization,
        ...localization
    };
    let socialLayout = socialLayoutProp;
    if (socialLayout === "auto") socialLayout = !credentials ? "vertical" : (social == null ? void 0 : social.providers) && social.providers.length > 2 ? "horizontal" : "vertical";
    const path = pathProp ?? (pathname == null ? void 0 : pathname.split("/").pop());
    const view = viewProp || (0, $220046a7533cffdb$export$4bd320b27036ede5)(viewPaths, path) || "SIGN_IN";
    const [isSubmitting, setIsSubmitting] = (0, $7PdBe.useState)(false);
    (0, $7PdBe.useEffect)(()=>{
        const handlePageHide = ()=>setIsSubmitting(false);
        window.addEventListener("pagehide", handlePageHide);
        return ()=>{
            setIsSubmitting(false);
            window.removeEventListener("pagehide", handlePageHide);
        };
    }, []);
    if (view === "CALLBACK") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$ac3c0d49631935da, {
        redirectTo: redirectTo
    });
    if (view === "SIGN_OUT") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$8bdd9b9a27ab4764, {});
    if (view === "ACCEPT_INVITATION") return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$bef676af1f4743eb, {});
    const description = !credentials && !magicLink && !emailOTP ? localization.DISABLED_CREDENTIALS_DESCRIPTION : localization[`${view}_DESCRIPTION`];
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full max-w-sm", className, classNames == null ? void 0 : classNames.base),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardHeader, {
                className: classNames == null ? void 0 : classNames.header,
                children: cardHeader ? cardHeader : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization[view]
                        }),
                        description && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: description
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$CardContent, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-6", classNames == null ? void 0 : classNames.content),
                children: [
                    oneTap && [
                        "SIGN_IN",
                        "SIGN_UP",
                        "MAGIC_LINK",
                        "EMAIL_OTP"
                    ].includes(view) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OneTap, {
                        localization: localization,
                        redirectTo: redirectTo
                    }),
                    (credentials || magicLink || emailOTP) && /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                        className: "grid gap-4",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$c17ac1167fee36b4, {
                                classNames: classNames == null ? void 0 : classNames.form,
                                callbackURL: callbackURL,
                                isSubmitting: isSubmitting,
                                localization: localization,
                                otpSeparators: otpSeparators,
                                view: view,
                                redirectTo: redirectTo,
                                setIsSubmitting: setIsSubmitting
                            }),
                            magicLink && (credentials && [
                                "FORGOT_PASSWORD",
                                "SIGN_UP",
                                "SIGN_IN",
                                "MAGIC_LINK",
                                "EMAIL_OTP"
                            ].includes(view) || emailOTP && view === "EMAIL_OTP") && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$MagicLinkButton, {
                                classNames: classNames,
                                localization: localization,
                                view: view,
                                isSubmitting: isSubmitting
                            }),
                            emailOTP && (credentials && [
                                "FORGOT_PASSWORD",
                                "SIGN_UP",
                                "SIGN_IN",
                                "MAGIC_LINK",
                                "EMAIL_OTP"
                            ].includes(view) || magicLink && [
                                "SIGN_IN",
                                "MAGIC_LINK"
                            ].includes(view)) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$EmailOTPButton, {
                                classNames: classNames,
                                localization: localization,
                                view: view,
                                isSubmitting: isSubmitting
                            })
                        ]
                    }),
                    view !== "RESET_PASSWORD" && (((_a = social == null ? void 0 : social.providers) == null ? void 0 : _a.length) || ((_b = genericOAuth == null ? void 0 : genericOAuth.providers) == null ? void 0 : _b.length) || view === "SIGN_IN" && passkey) && /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                        children: [
                            (credentials || magicLink || emailOTP) && /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center gap-2", classNames == null ? void 0 : classNames.continueWith),
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Separator3, {
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("!w-auto grow", classNames == null ? void 0 : classNames.separator)
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                                        className: "flex-shrink-0 text-muted-foreground text-sm",
                                        children: localization.OR_CONTINUE_WITH
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Separator3, {
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("!w-auto grow", classNames == null ? void 0 : classNames.separator)
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                className: "grid gap-4",
                                children: [
                                    (((_c = social == null ? void 0 : social.providers) == null ? void 0 : _c.length) || ((_d = genericOAuth == null ? void 0 : genericOAuth.providers) == null ? void 0 : _d.length)) && /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-full items-center justify-between gap-4", socialLayout === "horizontal" && "flex-wrap", socialLayout === "vertical" && "flex-col", socialLayout === "grid" && "grid grid-cols-2"),
                                        children: [
                                            (_e = social == null ? void 0 : social.providers) == null ? void 0 : _e.map((provider)=>{
                                                const socialProvider = $c5bb23e187c19083$export$f673b72d48c114fb.find((socialProvider2)=>socialProvider2.provider === provider);
                                                if (!socialProvider) return null;
                                                return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$ProviderButton, {
                                                    classNames: classNames,
                                                    callbackURL: callbackURL,
                                                    isSubmitting: isSubmitting,
                                                    localization: localization,
                                                    provider: socialProvider,
                                                    redirectTo: redirectTo,
                                                    setIsSubmitting: setIsSubmitting,
                                                    socialLayout: socialLayout
                                                }, provider);
                                            }),
                                            (_f = genericOAuth == null ? void 0 : genericOAuth.providers) == null ? void 0 : _f.map((provider)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$ProviderButton, {
                                                    classNames: classNames,
                                                    callbackURL: callbackURL,
                                                    isSubmitting: isSubmitting,
                                                    localization: localization,
                                                    provider: provider,
                                                    redirectTo: redirectTo,
                                                    setIsSubmitting: setIsSubmitting,
                                                    socialLayout: socialLayout,
                                                    other: true
                                                }, provider.provider))
                                        ]
                                    }),
                                    passkey && [
                                        "SIGN_IN",
                                        "MAGIC_LINK",
                                        "EMAIL_OTP",
                                        "RECOVER_ACCOUNT",
                                        "TWO_FACTOR",
                                        "FORGOT_PASSWORD"
                                    ].includes(view) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$PasskeyButton, {
                                        classNames: classNames,
                                        isSubmitting: isSubmitting,
                                        localization: localization,
                                        redirectTo: redirectTo,
                                        setIsSubmitting: setIsSubmitting
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            credentials && signUp && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$CardFooter, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("justify-center gap-1.5 text-muted-foreground text-sm", classNames == null ? void 0 : classNames.footer),
                children: [
                    view === "SIGN_IN" || view === "MAGIC_LINK" || view === "EMAIL_OTP" ? localization.DONT_HAVE_AN_ACCOUNT : view === "SIGN_UP" ? localization.ALREADY_HAVE_AN_ACCOUNT : /* @__PURE__ */ (0, $hvk62.jsx)((0, $30a2e868cfd5681e$export$2e2bcd8739ae039), {
                        className: "size-3"
                    }),
                    view === "SIGN_IN" || view === "MAGIC_LINK" || view === "EMAIL_OTP" || view === "SIGN_UP" ? /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-foreground underline", classNames == null ? void 0 : classNames.footerLink),
                        href: `${basePath}/${viewPaths[view === "SIGN_IN" || view === "MAGIC_LINK" || view === "EMAIL_OTP" ? "SIGN_UP" : "SIGN_IN"]}${isHydrated ? window.location.search : ""}`,
                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            variant: "link",
                            size: "sm",
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("px-0 text-foreground underline", classNames == null ? void 0 : classNames.footerLink),
                            children: view === "SIGN_IN" || view === "MAGIC_LINK" || view === "EMAIL_OTP" ? localization.SIGN_UP : localization.SIGN_IN
                        })
                    }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                        variant: "link",
                        size: "sm",
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("px-0 text-foreground underline", classNames == null ? void 0 : classNames.footerLink),
                        onClick: ()=>window.history.back(),
                        children: localization.GO_BACK
                    })
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$export$4a7d0b5dbbb3a3e5({ children: children }) {
    const { hooks: { useSession: useSession } } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { isPending: isPending } = useSession();
    return isPending ? children : null;
}
function $c5bb23e187c19083$var$DeleteOrganizationDialog({ classNames: classNames, localization: localizationProp, onOpenChange: onOpenChange, organization: organization, ...props }) {
    var _a, _b, _c;
    const { authClient: authClient, account: accountOptions, hooks: { useListOrganizations: useListOrganizations }, localization: contextLocalization, navigate: navigate, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { refetch: refetchOrganizations } = useListOrganizations();
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        slug: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: localization.SLUG_REQUIRED
        }).refine((val)=>val === organization.slug, {
            message: localization.SLUG_DOES_NOT_MATCH
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            slug: ""
        }
    });
    const { isSubmitting: isSubmitting } = form.formState;
    const deleteOrganization = async ()=>{
        try {
            await authClient.organization.delete({
                organizationId: organization.id,
                fetchOptions: {
                    throw: true
                }
            });
            await (refetchOrganizations == null ? void 0 : refetchOrganizations());
            toast({
                variant: "success",
                message: localization.DELETE_ORGANIZATION_SUCCESS
            });
            navigate(`${accountOptions == null ? void 0 : accountOptions.basePath}/${accountOptions == null ? void 0 : accountOptions.viewPaths.ORGANIZATIONS}`);
            onOpenChange == null || onOpenChange(false);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("sm:max-w-md", (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization == null ? void 0 : localization.DELETE_ORGANIZATION
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization == null ? void 0 : localization.DELETE_ORGANIZATION_DESCRIPTION
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Card, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("my-2 flex-row p-4", classNames == null ? void 0 : classNames.cell),
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                        organization: organization,
                        localization: localization
                    })
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                    ...form,
                    children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
                        onSubmit: form.handleSubmit(deleteOrganization),
                        className: "grid gap-6",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "slug",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormLabel, {
                                                className: classNames == null ? void 0 : classNames.label,
                                                children: [
                                                    localization == null ? void 0 : localization.DELETE_ORGANIZATION_INSTRUCTIONS,
                                                    /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                                                        className: "font-bold",
                                                        children: organization.slug
                                                    })
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                                    placeholder: organization.slug,
                                                    className: classNames == null ? void 0 : classNames.input,
                                                    autoComplete: "off",
                                                    ...field
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                                className: classNames == null ? void 0 : classNames.error
                                            })
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                                className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                        type: "button",
                                        variant: "secondary",
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.secondaryButton),
                                        onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                                        children: localization.CANCEL
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.destructiveButton),
                                        disabled: isSubmitting,
                                        variant: "destructive",
                                        type: "submit",
                                        children: [
                                            isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                                className: "animate-spin"
                                            }),
                                            localization == null ? void 0 : localization.DELETE_ORGANIZATION
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function $c5bb23e187c19083$export$f786337c5634e129({ className: className, classNames: classNames, localization: localizationProp, slug: slug, ...props }) {
    const { localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: organization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: slug
    });
    if (!organization) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        actionLabel: localization == null ? void 0 : localization.DELETE_ORGANIZATION,
        description: localization == null ? void 0 : localization.DELETE_ORGANIZATION_DESCRIPTION,
        isPending: true,
        title: localization == null ? void 0 : localization.DELETE_ORGANIZATION,
        variant: "destructive"
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DeleteOrganizationForm, {
        className: className,
        classNames: classNames,
        localization: localization,
        organization: organization,
        ...props
    });
}
function $c5bb23e187c19083$var$DeleteOrganizationForm({ className: className, classNames: classNames, localization: localizationProp, organization: organization }) {
    const { localization: contextLocalization, hooks: { useHasPermission: useHasPermission } } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: hasPermission, isPending: isPending } = useHasPermission({
        organizationId: organization.id,
        permissions: {
            organization: [
                "delete"
            ]
        }
    });
    const [showDialog, setShowDialog] = (0, $7PdBe.useState)(false);
    if (!(hasPermission == null ? void 0 : hasPermission.success)) return null;
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                actionLabel: localization == null ? void 0 : localization.DELETE_ORGANIZATION,
                description: localization == null ? void 0 : localization.DELETE_ORGANIZATION_DESCRIPTION,
                isPending: isPending,
                title: localization == null ? void 0 : localization.DELETE_ORGANIZATION,
                variant: "destructive",
                action: ()=>setShowDialog(true)
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DeleteOrganizationDialog, {
                classNames: classNames,
                localization: localization,
                open: showDialog,
                onOpenChange: setShowDialog,
                organization: organization
            })
        ]
    });
}
function $c5bb23e187c19083$var$InvitationCell({ className: className, classNames: classNames, invitation: invitation, localization: localizationProp, organization: organization }) {
    const { authClient: authClient, hooks: { useListInvitations: useListInvitations }, organization: organizationOptions, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const [isLoading, setIsLoading] = (0, $7PdBe.useState)(false);
    const builtInRoles = [
        {
            role: "owner",
            label: localization.OWNER
        },
        {
            role: "admin",
            label: localization.ADMIN
        },
        {
            role: "member",
            label: localization.MEMBER
        }
    ];
    const roles = [
        ...builtInRoles,
        ...(organizationOptions == null ? void 0 : organizationOptions.customRoles) || []
    ];
    const role = roles.find((r)=>r.role === invitation.role);
    const { refetch: refetch } = useListInvitations({
        query: {
            organizationId: organization == null ? void 0 : organization.id
        }
    });
    const handleCancelInvitation = async ()=>{
        setIsLoading(true);
        try {
            await authClient.organization.cancelInvitation({
                invitationId: invitation.id,
                fetchOptions: {
                    throw: true
                }
            });
            await (refetch == null ? void 0 : refetch());
            toast({
                variant: "success",
                message: localization.INVITATION_CANCELLED
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsLoading(false);
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center p-4", className, classNames == null ? void 0 : classNames.cell),
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex flex-1 items-center gap-2",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6c0524ba53950d9f, {
                        className: "my-0.5",
                        user: invitation,
                        localization: localization
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                        className: "grid flex-1 text-left leading-tight",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                                className: "truncate font-semibold text-sm",
                                children: invitation.email
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)("span", {
                                className: "truncate text-muted-foreground text-xs",
                                children: [
                                    localization.EXPIRES,
                                    " ",
                                    invitation.expiresAt.toLocaleDateString()
                                ]
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                className: "truncate text-sm opacity-70",
                children: role == null ? void 0 : role.label
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                        asChild: true,
                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                            disabled: isLoading,
                            size: "icon",
                            type: "button",
                            variant: "outline",
                            children: isLoading ? /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                className: "animate-spin"
                            }) : /* @__PURE__ */ (0, $hvk62.jsx)((0, $9d2f9bea6f0d78a8$export$2e2bcd8739ae039), {
                                className: classNames == null ? void 0 : classNames.icon
                            })
                        })
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuContent, {
                        onCloseAutoFocus: (e)=>e.preventDefault(),
                        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                            onClick: handleCancelInvitation,
                            disabled: isLoading,
                            variant: "destructive",
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)((0, $f5645b1fe1001619$export$2e2bcd8739ae039), {
                                    className: classNames == null ? void 0 : classNames.icon
                                }),
                                localization.CANCEL_INVITATION
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function $c5bb23e187c19083$export$ae7abacb7bb2ade8({ className: className, classNames: classNames, localization: localizationProp, slug: slugProp, ...props }) {
    const { localization: contextLocalization, organization: organizationOptions } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const slug = slugProp || (organizationOptions == null ? void 0 : organizationOptions.slug);
    const { data: organization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: slug
    });
    if (!organization) return null;
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OrganizationInvitationsContent, {
        className: className,
        classNames: classNames,
        localization: localization,
        organization: organization,
        ...props
    });
}
function $c5bb23e187c19083$var$OrganizationInvitationsContent({ className: className, classNames: classNames, localization: localizationProp, organization: organization, ...props }) {
    const { hooks: { useListInvitations: useListInvitations }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: invitations } = useListInvitations({
        query: {
            organizationId: organization.id
        }
    });
    const pendingInvitations = invitations == null ? void 0 : invitations.filter((invitation)=>invitation.status === "pending");
    if (!(pendingInvitations == null ? void 0 : pendingInvitations.length)) return null;
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        title: localization.PENDING_INVITATIONS,
        description: localization.PENDING_INVITATIONS_DESCRIPTION,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
            children: pendingInvitations.map((invitation)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InvitationCell, {
                    classNames: classNames,
                    invitation: invitation,
                    localization: localization,
                    organization: organization
                }, invitation.id))
        })
    });
}
function $c5bb23e187c19083$export$db6fd78caf0a235d({ className: className, classNames: classNames, localization: localizationProp, slug: slug, ...props }) {
    const { localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: organization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: slug
    });
    if (!organization) return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full pb-0 text-start", className, classNames == null ? void 0 : classNames.base),
        ...props,
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsCardHeader, {
                        className: "grow self-start",
                        title: localization.LOGO,
                        description: localization.LOGO_DESCRIPTION,
                        isPending: true,
                        classNames: classNames
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                        type: "button",
                        className: "me-6 size-fit rounded-full",
                        size: "icon",
                        variant: "ghost",
                        disabled: true,
                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$61f623436a84786, {
                            isPending: true,
                            className: "size-20 text-2xl",
                            classNames: classNames == null ? void 0 : classNames.avatar,
                            localization: localization
                        })
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsCardFooter, {
                className: "!py-5",
                instructions: localization.LOGO_INSTRUCTIONS,
                classNames: classNames,
                isPending: true
            })
        ]
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OrganizationLogoForm, {
        className: className,
        classNames: classNames,
        localization: localization,
        organization: organization,
        ...props
    });
}
function $c5bb23e187c19083$var$OrganizationLogoForm({ className: className, classNames: classNames, localization: localizationProp, organization: organization, ...props }) {
    const { hooks: { useHasPermission: useHasPermission }, localization: authLocalization2, organization: organizationOptions, mutators: { updateOrganization: updateOrganization }, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...authLocalization2,
            ...localizationProp
        }), [
        authLocalization2,
        localizationProp
    ]);
    const { refetch: refetchOrganization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: organization.slug
    });
    const { data: hasPermission, isPending: permissionPending } = useHasPermission({
        organizationId: organization.id,
        permissions: {
            organization: [
                "update"
            ]
        }
    });
    const isPending = permissionPending;
    const fileInputRef = (0, $7PdBe.useRef)(null);
    const [loading, setLoading] = (0, $7PdBe.useState)(false);
    const handleLogoChange = async (file)=>{
        if (!(organizationOptions == null ? void 0 : organizationOptions.logo) || !(hasPermission == null ? void 0 : hasPermission.success)) return;
        setLoading(true);
        const resizedFile = await $c5bb23e187c19083$var$resizeAndCropImage(file, crypto.randomUUID(), organizationOptions.logo.size, organizationOptions.logo.extension);
        let image;
        if (organizationOptions.logo.upload) image = await organizationOptions.logo.upload(resizedFile);
        else image = await $c5bb23e187c19083$var$fileToBase64(resizedFile);
        if (!image) {
            setLoading(false);
            return;
        }
        try {
            await updateOrganization({
                organizationId: organization.id,
                data: {
                    logo: image
                }
            });
            await (refetchOrganization == null ? void 0 : refetchOrganization());
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setLoading(false);
    };
    const handleDeleteLogo = async ()=>{
        var _a, _b;
        if (!(hasPermission == null ? void 0 : hasPermission.success)) return;
        setLoading(true);
        try {
            if (organization.logo) await ((_b = (_a = organizationOptions == null ? void 0 : organizationOptions.logo) == null ? void 0 : _a.delete) == null ? void 0 : _b.call(_a, organization.logo));
            await updateOrganization({
                organizationId: organization.id,
                data: {
                    logo: ""
                }
            });
            await (refetchOrganization == null ? void 0 : refetchOrganization());
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setLoading(false);
    };
    const openFileDialog = ()=>{
        var _a;
        (_a = fileInputRef.current) == null || _a.click();
    };
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full pb-0 text-start", className, classNames == null ? void 0 : classNames.base),
        ...props,
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)("input", {
                ref: fileInputRef,
                accept: "image/*",
                disabled: loading || !(hasPermission == null ? void 0 : hasPermission.success),
                hidden: true,
                type: "file",
                onChange: (e)=>{
                    var _a;
                    const file = (_a = e.target.files) == null ? void 0 : _a.item(0);
                    if (file) handleLogoChange(file);
                    e.target.value = "";
                }
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsCardHeader, {
                        className: "grow self-start",
                        title: localization.LOGO,
                        description: localization.LOGO_DESCRIPTION,
                        isPending: isPending,
                        classNames: classNames
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                                asChild: true,
                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                    type: "button",
                                    className: "me-6 size-fit rounded-full",
                                    size: "icon",
                                    variant: "ghost",
                                    disabled: !(hasPermission == null ? void 0 : hasPermission.success),
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$61f623436a84786, {
                                        isPending: isPending || loading,
                                        className: "size-20 text-2xl",
                                        classNames: classNames == null ? void 0 : classNames.avatar,
                                        organization: organization,
                                        localization: localization
                                    }, organization.logo)
                                })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                                align: "end",
                                onCloseAutoFocus: (e)=>e.preventDefault(),
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        onClick: openFileDialog,
                                        disabled: loading || !(hasPermission == null ? void 0 : hasPermission.success),
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $c30ce99ee32b9b4f$export$2e2bcd8739ae039), {}),
                                            localization.UPLOAD_LOGO
                                        ]
                                    }),
                                    organization.logo && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        onClick: handleDeleteLogo,
                                        disabled: loading || !(hasPermission == null ? void 0 : hasPermission.success),
                                        variant: "destructive",
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $28b54fce4c436a82$export$2e2bcd8739ae039), {}),
                                            localization.DELETE_LOGO
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SettingsCardFooter, {
                className: "!py-5",
                instructions: localization.LOGO_INSTRUCTIONS,
                classNames: classNames,
                isPending: isPending,
                isSubmitting: loading
            })
        ]
    });
}
function $c5bb23e187c19083$var$InviteMemberDialog({ classNames: classNames, localization: localizationProp, onOpenChange: onOpenChange, organization: organization, ...props }) {
    var _a, _b, _c;
    const { authClient: authClient, hooks: { useListInvitations: useListInvitations, useListMembers: useListMembers, useSession: useSession }, localization: contextLocalization, toast: toast, organization: organizationOptions } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: data } = useListMembers({
        query: {
            organizationId: organization.id
        }
    });
    const { refetch: refetch } = useListInvitations({
        query: {
            organizationId: organization.id
        }
    });
    const members = data == null ? void 0 : data.members;
    const { data: sessionData } = useSession();
    const membership = members == null ? void 0 : members.find((m)=>m.userId === (sessionData == null ? void 0 : sessionData.user.id));
    const builtInRoles = [
        {
            role: "owner",
            label: localization.OWNER
        },
        {
            role: "admin",
            label: localization.ADMIN
        },
        {
            role: "member",
            label: localization.MEMBER
        }
    ];
    const roles = [
        ...builtInRoles,
        ...(organizationOptions == null ? void 0 : organizationOptions.customRoles) || []
    ];
    const availableRoles = roles.filter((role)=>(membership == null ? void 0 : membership.role) === "owner" || role.role !== "owner");
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        email: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: localization.EMAIL_REQUIRED
        }).email({
            message: localization.INVALID_EMAIL
        }),
        role: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.ROLE} ${localization.IS_REQUIRED}`
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        defaultValues: {
            email: "",
            role: "member"
        }
    });
    const isSubmitting = form.formState.isSubmitting;
    async function onSubmit({ email: email, role: role }) {
        try {
            await authClient.organization.inviteMember({
                email: email,
                role: role,
                organizationId: organization.id,
                fetchOptions: {
                    throw: true
                }
            });
            await (refetch == null ? void 0 : refetch());
            onOpenChange == null || onOpenChange(false);
            form.reset();
            toast({
                variant: "success",
                message: localization.SEND_INVITATION_SUCCESS || "Invitation sent successfully"
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    }
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content,
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization.INVITE_MEMBER
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.INVITE_MEMBER_DESCRIPTION
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
                    ...form,
                    children: /* @__PURE__ */ (0, $hvk62.jsxs)("form", {
                        onSubmit: form.handleSubmit(onSubmit),
                        className: "space-y-6",
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "email",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                className: classNames == null ? void 0 : classNames.label,
                                                children: localization.EMAIL
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                                    placeholder: localization.EMAIL_PLACEHOLDER,
                                                    type: "email",
                                                    ...field,
                                                    className: classNames == null ? void 0 : classNames.input
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                                control: form.control,
                                name: "role",
                                render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormLabel, {
                                                className: classNames == null ? void 0 : classNames.label,
                                                children: localization.ROLE
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Select, {
                                                onValueChange: field.onChange,
                                                defaultValue: field.value,
                                                children: [
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectTrigger, {
                                                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectValue, {})
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectContent, {
                                                        children: availableRoles.map((role)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectItem, {
                                                                value: role.role,
                                                                children: role.label
                                                            }, role.role))
                                                    })
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {})
                                        ]
                                    })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                                className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                        type: "button",
                                        variant: "outline",
                                        onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                                        children: localization.CANCEL
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                                        type: "submit",
                                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                                        disabled: isSubmitting,
                                        children: [
                                            isSubmitting && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                                className: "animate-spin"
                                            }),
                                            localization.SEND_INVITATION
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$RemoveMemberDialog({ member: member, classNames: classNames, localization: localizationProp, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c;
    const { authClient: authClient, hooks: { useListMembers: useListMembers }, localization: contextLocalization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { refetch: refetch } = useListMembers({
        query: {
            organizationId: member.organizationId
        }
    });
    const [isRemoving, setIsRemoving] = (0, $7PdBe.useState)(false);
    const removeMember = async ()=>{
        setIsRemoving(true);
        try {
            await authClient.organization.removeMember({
                memberIdOrEmail: member.id,
                organizationId: member.organizationId,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.REMOVE_MEMBER_SUCCESS
            });
            await (refetch == null ? void 0 : refetch());
            onOpenChange == null || onOpenChange(false);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsRemoving(false);
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            className: (_a = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _a.content,
            onOpenAutoFocus: (e)=>e.preventDefault(),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization.REMOVE_MEMBER
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.REMOVE_MEMBER_CONFIRM
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$MemberCell, {
                    className: classNames == null ? void 0 : classNames.cell,
                    member: member,
                    localization: localization,
                    hideActions: true
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                    className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.footer,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "outline",
                            onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                            disabled: isRemoving,
                            children: localization.CANCEL
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "destructive",
                            onClick: removeMember,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.destructiveButton),
                            disabled: isRemoving,
                            children: [
                                isRemoving && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                    className: "animate-spin"
                                }),
                                localization.REMOVE_MEMBER
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$UpdateMemberRoleDialog({ member: member, classNames: classNames, localization: localizationProp, onOpenChange: onOpenChange, ...props }) {
    var _a, _b, _c, _d;
    const { authClient: authClient, hooks: { useSession: useSession, useListMembers: useListMembers }, localization: contextLocalization, organization: organization, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: data, refetch: refetch } = useListMembers({
        query: {
            organizationId: member.organizationId
        }
    });
    const members = data == null ? void 0 : data.members;
    const { data: sessionData } = useSession();
    const [isUpdating, setIsUpdating] = (0, $7PdBe.useState)(false);
    const [selectedRole, setSelectedRole] = (0, $7PdBe.useState)(member.role);
    const builtInRoles = [
        {
            role: "owner",
            label: localization.OWNER
        },
        {
            role: "admin",
            label: localization.ADMIN
        },
        {
            role: "member",
            label: localization.MEMBER
        }
    ];
    const roles = [
        ...builtInRoles,
        ...(organization == null ? void 0 : organization.customRoles) || []
    ];
    const currentUserRole = (_a = members == null ? void 0 : members.find((m)=>{
        var _a2;
        return ((_a2 = m.user) == null ? void 0 : _a2.id) === (sessionData == null ? void 0 : sessionData.user.id);
    })) == null ? void 0 : _a.role;
    const availableRoles = roles.filter((role)=>{
        if (role.role === "owner") return currentUserRole === "owner";
        if (role.role === "admin") return currentUserRole === "owner" || currentUserRole === "admin";
        return true;
    });
    const updateMemberRole = async ()=>{
        if (selectedRole === member.role) {
            toast({
                variant: "error",
                message: `${localization.ROLE} ${localization.IS_THE_SAME}`
            });
            return;
        }
        setIsUpdating(true);
        try {
            await authClient.organization.updateMemberRole({
                memberId: member.id,
                role: selectedRole,
                organizationId: member.organizationId,
                fetchOptions: {
                    throw: true
                }
            });
            toast({
                variant: "success",
                message: localization.MEMBER_ROLE_UPDATED
            });
            await (refetch == null ? void 0 : refetch());
            onOpenChange == null || onOpenChange(false);
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
        setIsUpdating(false);
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Dialog, {
        onOpenChange: onOpenChange,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogContent, {
            className: (_b = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _b.content,
            onOpenAutoFocus: (e)=>e.preventDefault(),
            children: [
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogHeader, {
                    className: (_c = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _c.header,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogTitle, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-lg md:text-xl", classNames == null ? void 0 : classNames.title),
                            children: localization.UPDATE_ROLE
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DialogDescription, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("text-xs md:text-sm", classNames == null ? void 0 : classNames.description),
                            children: localization.UPDATE_ROLE_DESCRIPTION
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                    className: "grid gap-6 py-4",
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$MemberCell, {
                            className: classNames == null ? void 0 : classNames.cell,
                            member: member,
                            localization: localization,
                            hideActions: true
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Select, {
                            value: selectedRole,
                            onValueChange: setSelectedRole,
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectTrigger, {
                                    className: "w-full",
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectValue, {
                                        placeholder: localization.SELECT_ROLE
                                    })
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectContent, {
                                    children: availableRoles.map((role)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$SelectItem, {
                                            value: role.role,
                                            children: role.label
                                        }, role.role))
                                })
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DialogFooter, {
                    className: (_d = classNames == null ? void 0 : classNames.dialog) == null ? void 0 : _d.footer,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            variant: "outline",
                            onClick: ()=>onOpenChange == null ? void 0 : onOpenChange(false),
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                            disabled: isUpdating,
                            children: localization.CANCEL
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            type: "button",
                            onClick: updateMemberRole,
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)(classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.primaryButton),
                            disabled: isUpdating,
                            children: [
                                isUpdating && /* @__PURE__ */ (0, $hvk62.jsx)((0, $6b2b36fe46a7aba1$export$2e2bcd8739ae039), {
                                    className: "animate-spin"
                                }),
                                localization.UPDATE_ROLE
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $c5bb23e187c19083$var$MemberCell({ className: className, classNames: classNames, member: member, localization: localizationProp, hideActions: hideActions }) {
    var _a;
    const { organization: organizationOptions, hooks: { useListMembers: useListMembers, useSession: useSession, useListOrganizations: useListOrganizations, useHasPermission: useHasPermission }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = {
        ...contextLocalization,
        ...localizationProp
    };
    const { data: sessionData } = useSession();
    const [removeDialogOpen, setRemoveDialogOpen] = (0, $7PdBe.useState)(false);
    const [leaveDialogOpen, setLeaveDialogOpen] = (0, $7PdBe.useState)(false);
    const [updateRoleDialogOpen, setUpdateRoleDialogOpen] = (0, $7PdBe.useState)(false);
    const builtInRoles = [
        {
            role: "owner",
            label: localization.OWNER
        },
        {
            role: "admin",
            label: localization.ADMIN
        },
        {
            role: "member",
            label: localization.MEMBER
        }
    ];
    const { data: data } = useListMembers({
        query: {
            organizationId: member.organizationId
        }
    });
    const members = data == null ? void 0 : data.members;
    const myRole = (_a = members == null ? void 0 : members.find((m)=>{
        var _a2;
        return ((_a2 = m.user) == null ? void 0 : _a2.id) === (sessionData == null ? void 0 : sessionData.user.id);
    })) == null ? void 0 : _a.role;
    const roles = [
        ...builtInRoles,
        ...(organizationOptions == null ? void 0 : organizationOptions.customRoles) || []
    ];
    const role = roles.find((r)=>r.role === member.role);
    const isSelf = (sessionData == null ? void 0 : sessionData.user.id) === (member == null ? void 0 : member.userId);
    const { data: organizations } = useListOrganizations();
    const organization = organizations == null ? void 0 : organizations.find((org)=>org.id === member.organizationId);
    const { data: hasPermissionToUpdateMember } = useHasPermission({
        organizationId: member.organizationId,
        permission: {
            member: [
                "update"
            ]
        }
    });
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Card, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex-row items-center p-4", className, classNames == null ? void 0 : classNames.cell),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$93c94555daa109c4, {
                        user: member.user,
                        localization: localization,
                        className: "flex-1"
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)("span", {
                        className: "text-xs opacity-70",
                        children: role == null ? void 0 : role.label
                    }),
                    !hideActions && (isSelf || member.role !== "owner" || myRole === "owner") && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                                asChild: true,
                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("relative ms-auto", classNames == null ? void 0 : classNames.button, classNames == null ? void 0 : classNames.outlineButton),
                                    size: "icon",
                                    type: "button",
                                    variant: "outline",
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $9d2f9bea6f0d78a8$export$2e2bcd8739ae039), {
                                        className: classNames == null ? void 0 : classNames.icon
                                    })
                                })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                                onCloseAutoFocus: (e)=>e.preventDefault(),
                                children: [
                                    (hasPermissionToUpdateMember == null ? void 0 : hasPermissionToUpdateMember.success) && /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        onClick: ()=>setUpdateRoleDialogOpen(true),
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $3b86cb767adbc7b7$export$2e2bcd8739ae039), {
                                                className: classNames == null ? void 0 : classNames.icon
                                            }),
                                            localization == null ? void 0 : localization.UPDATE_ROLE
                                        ]
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        onClick: ()=>isSelf ? setLeaveDialogOpen(true) : setRemoveDialogOpen(true),
                                        variant: "destructive",
                                        children: [
                                            /* @__PURE__ */ (0, $hvk62.jsx)((0, $d3655f26227b4756$export$2e2bcd8739ae039), {
                                                className: classNames == null ? void 0 : classNames.icon
                                            }),
                                            isSelf ? localization == null ? void 0 : localization.LEAVE_ORGANIZATION : localization == null ? void 0 : localization.REMOVE_MEMBER
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$RemoveMemberDialog, {
                open: removeDialogOpen,
                onOpenChange: setRemoveDialogOpen,
                member: member,
                classNames: classNames,
                localization: localization
            }),
            organization && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$LeaveOrganizationDialog, {
                open: leaveDialogOpen,
                onOpenChange: setLeaveDialogOpen,
                organization: organization,
                classNames: classNames,
                localization: localization
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$UpdateMemberRoleDialog, {
                open: updateRoleDialogOpen,
                onOpenChange: setUpdateRoleDialogOpen,
                member: member,
                classNames: classNames,
                localization: localization
            })
        ]
    });
}
function $c5bb23e187c19083$export$fad6268ccf505db4({ className: className, classNames: classNames, localization: localizationProp, slug: slugProp, ...props }) {
    const { localization: contextLocalization, organization: organizationOptions } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const slug = slugProp || (organizationOptions == null ? void 0 : organizationOptions.slug);
    const { data: organization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: slug
    });
    if (!organization) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        title: localization.MEMBERS,
        description: localization.MEMBERS_DESCRIPTION,
        instructions: localization.MEMBERS_INSTRUCTIONS,
        actionLabel: localization.INVITE_MEMBER,
        isPending: true,
        ...props
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OrganizationMembersContent, {
        className: className,
        classNames: classNames,
        localization: localization,
        organization: organization,
        ...props
    });
}
function $c5bb23e187c19083$var$OrganizationMembersContent({ className: className, classNames: classNames, localization: localizationProp, organization: organization, ...props }) {
    const { hooks: { useHasPermission: useHasPermission, useListMembers: useListMembers }, localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: hasPermissionInvite, isPending: isPendingInvite } = useHasPermission({
        organizationId: organization.id,
        permissions: {
            invitation: [
                "create"
            ]
        }
    });
    const { data: hasPermissionUpdateMember, isPending: isPendingUpdateMember } = useHasPermission({
        organizationId: organization.id,
        permission: {
            member: [
                "update"
            ]
        }
    });
    const isPending = isPendingInvite || isPendingUpdateMember;
    const { data: data } = useListMembers({
        query: {
            organizationId: organization.id
        }
    });
    const members = data == null ? void 0 : data.members;
    const [inviteDialogOpen, setInviteDialogOpen] = (0, $7PdBe.useState)(false);
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                title: localization.MEMBERS,
                description: localization.MEMBERS_DESCRIPTION,
                instructions: localization.MEMBERS_INSTRUCTIONS,
                actionLabel: localization.INVITE_MEMBER,
                action: ()=>setInviteDialogOpen(true),
                isPending: isPending,
                disabled: !(hasPermissionInvite == null ? void 0 : hasPermissionInvite.success),
                ...props,
                children: !isPending && members && members.length > 0 && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("grid gap-4", classNames == null ? void 0 : classNames.content),
                    children: members.sort((a, b)=>new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()).map((member)=>/* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$MemberCell, {
                            classNames: classNames,
                            member: member,
                            localization: localization,
                            hideActions: !(hasPermissionUpdateMember == null ? void 0 : hasPermissionUpdateMember.success)
                        }, member.id))
                })
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$InviteMemberDialog, {
                open: inviteDialogOpen,
                onOpenChange: setInviteDialogOpen,
                classNames: classNames,
                localization: localization,
                organization: organization
            })
        ]
    });
}
function $c5bb23e187c19083$export$e777b1a84c26f186({ className: className, classNames: classNames, localization: localizationProp, slug: slug, ...props }) {
    const { localization: contextLocalization } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { data: organization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: slug
    });
    if (!organization) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        actionLabel: localization.SAVE,
        description: localization.ORGANIZATION_NAME_DESCRIPTION,
        instructions: localization.ORGANIZATION_NAME_INSTRUCTIONS,
        isPending: true,
        title: localization.ORGANIZATION_NAME,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
            className: classNames == null ? void 0 : classNames.content,
            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-9 w-full", classNames == null ? void 0 : classNames.skeleton)
            })
        })
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OrganizationNameForm, {
        className: className,
        classNames: classNames,
        localization: localization,
        organization: organization,
        ...props
    });
}
function $c5bb23e187c19083$var$OrganizationNameForm({ className: className, classNames: classNames, localization: localizationProp, organization: organization, ...props }) {
    const { localization: contextLocalization, hooks: { useHasPermission: useHasPermission }, mutators: { updateOrganization: updateOrganization }, optimistic: optimistic, toast: toast } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = {
        ...contextLocalization,
        ...localizationProp
    };
    const { data: hasPermission, isPending: permissionPending } = useHasPermission({
        organizationId: organization.id,
        permissions: {
            organization: [
                "update"
            ]
        }
    });
    const { refetch: refetchOrganization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: organization.slug
    });
    const isPending = permissionPending;
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        name: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.ORGANIZATION_NAME} ${localization.IS_REQUIRED}`
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        values: {
            name: organization.name || ""
        }
    });
    const { isSubmitting: isSubmitting } = form.formState;
    const updateOrganizationName = async ({ name: name })=>{
        if (organization.name === name) {
            toast({
                variant: "error",
                message: `${localization.ORGANIZATION_NAME} ${localization.IS_THE_SAME}`
            });
            return;
        }
        try {
            await updateOrganization({
                organizationId: organization.id,
                data: {
                    name: name
                }
            });
            await (refetchOrganization == null ? void 0 : refetchOrganization());
            toast({
                variant: "success",
                message: `${localization.ORGANIZATION_NAME} ${localization.UPDATED_SUCCESSFULLY}`
            });
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsx)("form", {
            onSubmit: form.handleSubmit(updateOrganizationName),
            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                description: localization.ORGANIZATION_NAME_DESCRIPTION,
                instructions: localization.ORGANIZATION_NAME_INSTRUCTIONS,
                isPending: isPending,
                title: localization.ORGANIZATION_NAME,
                actionLabel: localization.SAVE,
                optimistic: optimistic,
                disabled: !(hasPermission == null ? void 0 : hasPermission.success),
                ...props,
                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
                    className: classNames == null ? void 0 : classNames.content,
                    children: isPending ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-9 w-full", classNames == null ? void 0 : classNames.skeleton)
                    }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                        control: form.control,
                        name: "name",
                        render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                            className: classNames == null ? void 0 : classNames.input,
                                            placeholder: localization.ORGANIZATION_NAME_PLACEHOLDER,
                                            disabled: isSubmitting || !(hasPermission == null ? void 0 : hasPermission.success),
                                            ...field
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                        className: classNames == null ? void 0 : classNames.error
                                    })
                                ]
                            })
                    })
                })
            })
        })
    });
}
function $c5bb23e187c19083$export$98e12812f31e5fe1({ className: className, classNames: classNames, localization: localizationProp, slug: slugProp, ...props }) {
    const { localization: contextLocalization, organization: organizationOptions } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const slug = slugProp || (organizationOptions == null ? void 0 : organizationOptions.slug);
    const { data: organization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: slug
    });
    if (!organization) return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
        className: className,
        classNames: classNames,
        description: localization.ORGANIZATION_SLUG_DESCRIPTION,
        instructions: localization.ORGANIZATION_SLUG_INSTRUCTIONS,
        isPending: true,
        title: localization.ORGANIZATION_SLUG,
        actionLabel: localization.SAVE,
        ...props,
        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
            className: classNames == null ? void 0 : classNames.content,
            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-9 w-full", classNames == null ? void 0 : classNames.skeleton)
            })
        })
    });
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$OrganizationSlugForm, {
        className: className,
        classNames: classNames,
        localization: localization,
        organization: organization,
        ...props
    });
}
function $c5bb23e187c19083$var$OrganizationSlugForm({ className: className, classNames: classNames, localization: localizationProp, organization: organization, ...props }) {
    const { localization: contextLocalization, hooks: { useHasPermission: useHasPermission }, mutators: { updateOrganization: updateOrganization }, optimistic: optimistic, toast: toast, organization: organizationOptions, replace: replace } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const { refetch: refetchOrganization } = (0, $07d0275849708341$export$4710633352285863)({
        slug: organization.slug
    });
    const { data: hasPermission, isPending: isPending } = useHasPermission({
        organizationId: organization.id,
        permissions: {
            organization: [
                "update"
            ]
        }
    });
    const formSchema = $034fa980286ebb75$export$be5493f9613cbbe({
        slug: $034fa980286ebb75$export$22b082955e083ec3().min(1, {
            message: `${localization.ORGANIZATION_SLUG} ${localization.IS_REQUIRED}`
        }).regex(/^[a-z0-9-]+$/, {
            message: `${localization.ORGANIZATION_SLUG} ${localization.IS_INVALID}`
        })
    });
    const form = (0, $9a9ac4df444a6447$export$87c0cf8eb5a167e0)({
        resolver: (0, $d0fab596071fa8a6$export$66b7b5879c70f722)(formSchema),
        values: {
            slug: organization.slug || ""
        }
    });
    const { isSubmitting: isSubmitting } = form.formState;
    const updateOrganizationSlug = async ({ slug: slug })=>{
        if (organization.slug === slug) {
            toast({
                variant: "error",
                message: `${localization.ORGANIZATION_SLUG} ${localization.IS_THE_SAME}`
            });
            return;
        }
        try {
            await updateOrganization({
                organizationId: organization.id,
                data: {
                    slug: slug
                }
            });
            await (refetchOrganization == null ? void 0 : refetchOrganization());
            toast({
                variant: "success",
                message: `${localization.ORGANIZATION_SLUG} ${localization.UPDATED_SUCCESSFULLY}`
            });
            if ((organizationOptions == null ? void 0 : organizationOptions.pathMode) === "slug") {
                const basePath = organizationOptions.basePath;
                const settingsPath = organizationOptions.viewPaths.SETTINGS;
                replace(`${basePath}/${slug}/${settingsPath}`);
            }
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
        }
    };
    return /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Form, {
        ...form,
        children: /* @__PURE__ */ (0, $hvk62.jsx)("form", {
            onSubmit: form.handleSubmit(updateOrganizationSlug),
            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$d64d9b0d320b2798, {
                className: className,
                classNames: classNames,
                description: localization.ORGANIZATION_SLUG_DESCRIPTION,
                instructions: localization.ORGANIZATION_SLUG_INSTRUCTIONS,
                isPending: isPending,
                title: localization.ORGANIZATION_SLUG,
                actionLabel: localization.SAVE,
                optimistic: optimistic,
                disabled: !(hasPermission == null ? void 0 : hasPermission.success),
                ...props,
                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$CardContent, {
                    className: classNames == null ? void 0 : classNames.content,
                    children: isPending ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Skeleton, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("h-9 w-full", classNames == null ? void 0 : classNames.skeleton)
                    }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormField, {
                        control: form.control,
                        name: "slug",
                        render: ({ field: field })=>/* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$FormItem, {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormControl, {
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Input, {
                                            className: classNames == null ? void 0 : classNames.input,
                                            placeholder: localization.ORGANIZATION_SLUG_PLACEHOLDER,
                                            disabled: isSubmitting || !(hasPermission == null ? void 0 : hasPermission.success),
                                            ...field
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$FormMessage, {
                                        className: classNames == null ? void 0 : classNames.error
                                    })
                                ]
                            })
                    })
                })
            })
        })
    });
}
function $c5bb23e187c19083$export$1ec86dece3a71f4a({ className: className, classNames: classNames, localization: localization, slug: slug }) {
    const { organization: organizationOptions } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-full flex-col gap-4 md:gap-6", className, classNames == null ? void 0 : classNames.cards),
        children: [
            (organizationOptions == null ? void 0 : organizationOptions.logo) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$db6fd78caf0a235d, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization,
                slug: slug
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$e777b1a84c26f186, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization,
                slug: slug
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$98e12812f31e5fe1, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization,
                slug: slug
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$f786337c5634e129, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization,
                slug: slug
            })
        ]
    });
}
function $c5bb23e187c19083$export$f9ea96486f7143a1({ className: className, classNames: classNames, align: align, alignOffset: alignOffset, side: side, sideOffset: sideOffset, trigger: trigger, localization: localizationProp, slug: slugProp, size: size, onSetActive: onSetActive, hidePersonal: hidePersonal, ...props }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
    const { authClient: authClient, basePath: basePath, hooks: { useSession: useSession, useListOrganizations: useListOrganizations }, localization: contextLocalization, account: accountOptions, organization: organizationOptions, redirectTo: redirectTo, navigate: navigate, toast: toast, viewPaths: viewPaths, Link: Link } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { pathMode: pathMode, slug: contextSlug, personalPath: personalPath } = organizationOptions || {};
    const slug = slugProp || contextSlug;
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const [activeOrganizationPending, setActiveOrganizationPending] = (0, $7PdBe.useState)(false);
    const [isCreateOrgDialogOpen, setIsCreateOrgDialogOpen] = (0, $7PdBe.useState)(false);
    const [dropdownOpen, setDropdownOpen] = (0, $7PdBe.useState)(false);
    const { data: sessionData, isPending: sessionPending } = useSession();
    const user = sessionData == null ? void 0 : sessionData.user;
    const { data: organizations, isPending: organizationsPending } = useListOrganizations();
    const { data: activeOrganization, isPending: organizationPending, isRefetching: organizationRefetching, refetch: organizationRefetch } = (0, $07d0275849708341$export$4710633352285863)({
        slug: slug
    });
    const isPending = organizationsPending || sessionPending || activeOrganizationPending || organizationPending;
    (0, $7PdBe.useEffect)(()=>{
        if (organizationRefetching) return;
        setActiveOrganizationPending(false);
    }, [
        activeOrganization,
        organizationRefetching
    ]);
    const switchOrganization = (0, $7PdBe.useCallback)(async (organization)=>{
        if (hidePersonal && organization === null) return;
        if (pathMode === "slug") {
            if (organization) navigate(`${organizationOptions == null ? void 0 : organizationOptions.basePath}/${organization.slug}`);
            else navigate(personalPath ?? redirectTo);
            return;
        }
        setActiveOrganizationPending(true);
        try {
            onSetActive == null || onSetActive(organization);
            await authClient.organization.setActive({
                organizationId: (organization == null ? void 0 : organization.id) || null,
                fetchOptions: {
                    throw: true
                }
            });
            organizationRefetch == null || organizationRefetch();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setActiveOrganizationPending(false);
        }
    }, [
        authClient,
        toast,
        localization,
        onSetActive,
        hidePersonal,
        pathMode,
        personalPath,
        organizationOptions == null ? void 0 : organizationOptions.basePath,
        redirectTo,
        navigate,
        organizationRefetch
    ]);
    (0, $7PdBe.useEffect)(()=>{
        if (hidePersonal && !activeOrganization && !activeOrganizationPending && organizations && organizations.length > 0 && !sessionPending && !organizationPending && !slug) switchOrganization(organizations[0]);
    }, [
        hidePersonal,
        activeOrganization,
        activeOrganizationPending,
        organizations,
        sessionPending,
        organizationPending,
        switchOrganization,
        slug
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
                open: dropdownOpen,
                onOpenChange: setDropdownOpen,
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                        asChild: true,
                        children: trigger || (size === "icon" ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                            size: "icon",
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("size-fit rounded-full", className, (_a = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _a.base),
                            variant: "ghost",
                            type: "button",
                            ...props,
                            children: isPending || activeOrganization || !sessionData || (user == null ? void 0 : user.isAnonymous) || hidePersonal ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$61f623436a84786, {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(className, classNames == null ? void 0 : classNames.base),
                                classNames: (_b = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _b.avatar,
                                isPending: isPending,
                                organization: activeOrganization,
                                "aria-label": localization.ORGANIZATION,
                                localization: localization
                            }, activeOrganization == null ? void 0 : activeOrganization.logo) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6c0524ba53950d9f, {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(className, classNames == null ? void 0 : classNames.base),
                                classNames: (_c = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _c.avatar,
                                user: user,
                                "aria-label": localization.ACCOUNT,
                                localization: localization
                            }, user == null ? void 0 : user.image)
                        }) : /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                            className: (0, $220046a7533cffdb$export$1343a74baacb0543)("!p-2 h-fit", className, (_d = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _d.base),
                            size: size,
                            ...props,
                            children: [
                                isPending || activeOrganization || !sessionData || (user == null ? void 0 : user.isAnonymous) || hidePersonal ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                                    classNames: (_e = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _e.organization,
                                    isPending: isPending,
                                    localization: localization,
                                    organization: activeOrganization,
                                    size: size
                                }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$PersonalAccountView, {
                                    classNames: (_f = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _f.user,
                                    localization: localization,
                                    size: size,
                                    user: user
                                }),
                                /* @__PURE__ */ (0, $hvk62.jsx)((0, $f258299638c7248e$export$2e2bcd8739ae039), {
                                    className: "ml-auto"
                                })
                            ]
                        }))
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-[--radix-dropdown-menu-trigger-width] min-w-56 max-w-64", (_g = classNames == null ? void 0 : classNames.content) == null ? void 0 : _g.base),
                        align: align,
                        alignOffset: alignOffset,
                        side: side,
                        sideOffset: sideOffset,
                        onCloseAutoFocus: (e)=>e.preventDefault(),
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex items-center justify-between gap-2 p-2", (_h = classNames == null ? void 0 : classNames.content) == null ? void 0 : _h.menuItem),
                                children: user && !user.isAnonymous || isPending ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                                    children: [
                                        activeOrganizationPending || activeOrganization || hidePersonal ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                                            classNames: (_i = classNames == null ? void 0 : classNames.content) == null ? void 0 : _i.organization,
                                            isPending: isPending || activeOrganizationPending,
                                            organization: activeOrganization,
                                            localization: localization
                                        }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$PersonalAccountView, {
                                            classNames: (_j = classNames == null ? void 0 : classNames.content) == null ? void 0 : _j.user,
                                            isPending: isPending,
                                            localization: localization,
                                            user: user
                                        }),
                                        !isPending && /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                            href: activeOrganization ? pathMode === "slug" ? `${organizationOptions == null ? void 0 : organizationOptions.basePath}/${activeOrganization.slug}/${organizationOptions == null ? void 0 : organizationOptions.viewPaths.SETTINGS}` : `${organizationOptions == null ? void 0 : organizationOptions.basePath}/${organizationOptions == null ? void 0 : organizationOptions.viewPaths.SETTINGS}` : `${accountOptions == null ? void 0 : accountOptions.basePath}/${accountOptions == null ? void 0 : accountOptions.viewPaths.SETTINGS}`,
                                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                                size: "icon",
                                                variant: "outline",
                                                className: "!size-8 ml-auto",
                                                onClick: ()=>setDropdownOpen(false),
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $e7182fc0af14339c$export$2e2bcd8739ae039), {
                                                    className: "size-4"
                                                })
                                            })
                                        })
                                    ]
                                }) : /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                                    className: "-my-1 text-muted-foreground text-xs",
                                    children: localization.ORGANIZATION
                                })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuSeparator, {
                                className: (_k = classNames == null ? void 0 : classNames.content) == null ? void 0 : _k.separator
                            }),
                            activeOrganization && !hidePersonal && (pathMode === "slug" ? /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                href: personalPath ?? redirectTo,
                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$PersonalAccountView, {
                                        classNames: (_l = classNames == null ? void 0 : classNames.content) == null ? void 0 : _l.user,
                                        isPending: isPending,
                                        localization: localization,
                                        user: user
                                    })
                                })
                            }) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuItem, {
                                onClick: ()=>switchOrganization(null),
                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$PersonalAccountView, {
                                    classNames: (_m = classNames == null ? void 0 : classNames.content) == null ? void 0 : _m.user,
                                    isPending: isPending,
                                    localization: localization,
                                    user: user
                                })
                            })),
                            organizations == null ? void 0 : organizations.map((organization)=>{
                                var _a2, _b2;
                                return organization.id !== (activeOrganization == null ? void 0 : activeOrganization.id) && (pathMode === "slug" ? /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                    href: `${organizationOptions == null ? void 0 : organizationOptions.basePath}/${organization.slug}`,
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                                            classNames: (_a2 = classNames == null ? void 0 : classNames.content) == null ? void 0 : _a2.organization,
                                            isPending: isPending,
                                            localization: localization,
                                            organization: organization
                                        })
                                    })
                                }, organization.id) : /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    onClick: ()=>switchOrganization(organization),
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$da1a8bd1e2e95ad, {
                                        classNames: (_b2 = classNames == null ? void 0 : classNames.content) == null ? void 0 : _b2.organization,
                                        isPending: isPending,
                                        localization: localization,
                                        organization: organization
                                    })
                                }, organization.id));
                            }),
                            organizations && organizations.length > 0 && (!hidePersonal || organizations.length > 1) && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuSeparator, {
                                className: (_n = classNames == null ? void 0 : classNames.content) == null ? void 0 : _n.separator
                            }),
                            !isPending && sessionData && !user.isAnonymous ? /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)((_o = classNames == null ? void 0 : classNames.content) == null ? void 0 : _o.menuItem),
                                onClick: ()=>setIsCreateOrgDialogOpen(true),
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)((0, $daa75c34e4a35766$export$2e2bcd8739ae039), {}),
                                    localization.CREATE_ORGANIZATION
                                ]
                            }) : /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                href: `${basePath}/${viewPaths.SIGN_IN}`,
                                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)((_p = classNames == null ? void 0 : classNames.content) == null ? void 0 : _p.menuItem),
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $c9a20346f482de2f$export$2e2bcd8739ae039), {}),
                                        localization.SIGN_IN
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$5a688c9906fdd181, {
                open: isCreateOrgDialogOpen,
                onOpenChange: setIsCreateOrgDialogOpen,
                localization: localization
            })
        ]
    });
}
function $c5bb23e187c19083$export$9ca0f69aa1820760({ className: className, classNames: classNames, localization: localizationProp, path: pathProp, pathname: pathname, view: viewProp, hideNav: hideNav, slug: slugProp }) {
    var _a, _b, _c;
    const { organization: organizationOptions, localization: contextLocalization, account: accountOptions, Link: Link, replace: replace } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { slug: contextSlug, viewPaths: viewPaths, apiKey: apiKey } = organizationOptions || {};
    $c5bb23e187c19083$export$141ca0666da3bf00();
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...localizationProp
        }), [
        contextLocalization,
        localizationProp
    ]);
    const path = pathProp ?? (pathname == null ? void 0 : pathname.split("/").pop());
    const view = viewProp || (0, $220046a7533cffdb$export$4bd320b27036ede5)(viewPaths, path) || "SETTINGS";
    const slug = slugProp || contextSlug;
    const { data: organization, isPending: organizationPending, isRefetching: organizationRefetching } = (0, $07d0275849708341$export$4710633352285863)({
        slug: slug
    });
    const navItems = [
        {
            view: "SETTINGS",
            label: localization.SETTINGS
        },
        {
            view: "MEMBERS",
            label: localization.MEMBERS
        }
    ];
    if (apiKey) navItems.push({
        view: "API_KEYS",
        label: localization.API_KEYS
    });
    (0, $7PdBe.useEffect)(()=>{
        var _a2;
        if (organization || organizationPending || organizationRefetching) return;
        replace(`${accountOptions == null ? void 0 : accountOptions.basePath}/${(_a2 = accountOptions == null ? void 0 : accountOptions.viewPaths) == null ? void 0 : _a2.ORGANIZATIONS}`);
    }, [
        organization,
        organizationPending,
        organizationRefetching,
        accountOptions == null ? void 0 : accountOptions.basePath,
        (_a = accountOptions == null ? void 0 : accountOptions.viewPaths) == null ? void 0 : _a.ORGANIZATIONS,
        replace
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-full grow flex-col gap-4 md:flex-row md:gap-12", className, classNames == null ? void 0 : classNames.base),
        children: [
            !hideNav && /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: "flex justify-between gap-2 md:hidden",
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Label2, {
                        className: "font-semibold text-base",
                        children: (_b = navItems.find((i)=>i.view === view)) == null ? void 0 : _b.label
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Drawer, {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DrawerTrigger, {
                                asChild: true,
                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                    variant: "outline",
                                    children: /* @__PURE__ */ (0, $hvk62.jsx)((0, $2f5c5352f7ba804e$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DrawerContent, {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DrawerHeader, {
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DrawerTitle, {
                                            className: "hidden",
                                            children: localization.ORGANIZATION
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                                        className: "flex flex-col px-4 pb-4",
                                        children: navItems.map((item)=>{
                                            var _a2;
                                            return /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                                href: `${organizationOptions == null ? void 0 : organizationOptions.basePath}${(organizationOptions == null ? void 0 : organizationOptions.pathMode) === "slug" ? `/${slug}` : ""}/${organizationOptions == null ? void 0 : organizationOptions.viewPaths[item.view]}`,
                                                children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                                    size: "lg",
                                                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full justify-start px-4 transition-none", (_a2 = classNames == null ? void 0 : classNames.drawer) == null ? void 0 : _a2.menuItem, view === item.view ? "font-semibold" : "text-foreground/70"),
                                                    variant: "ghost",
                                                    children: item.label
                                                })
                                            }, item.view);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !hideNav && /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                className: "hidden md:block",
                children: /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-48 flex-col gap-1 lg:w-60", (_c = classNames == null ? void 0 : classNames.sidebar) == null ? void 0 : _c.base),
                    children: navItems.map((item)=>{
                        var _a2, _b2;
                        return /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                            href: `${organizationOptions == null ? void 0 : organizationOptions.basePath}${(organizationOptions == null ? void 0 : organizationOptions.pathMode) === "slug" ? `/${slug}` : ""}/${organizationOptions == null ? void 0 : organizationOptions.viewPaths[item.view]}`,
                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                                size: "lg",
                                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-full justify-start px-4 transition-none", (_a2 = classNames == null ? void 0 : classNames.sidebar) == null ? void 0 : _a2.button, view === item.view ? "font-semibold" : "text-foreground/70", view === item.view && ((_b2 = classNames == null ? void 0 : classNames.sidebar) == null ? void 0 : _b2.buttonActive)),
                                variant: "ghost",
                                children: item.label
                            })
                        }, item.view);
                    })
                })
            }),
            view === "MEMBERS" && /* @__PURE__ */ (0, $hvk62.jsxs)("div", {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("flex w-full flex-col gap-4 md:gap-6", className, classNames == null ? void 0 : classNames.cards),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$fad6268ccf505db4, {
                        classNames: classNames == null ? void 0 : classNames.card,
                        localization: localization,
                        slug: slug
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$ae7abacb7bb2ade8, {
                        classNames: classNames == null ? void 0 : classNames.card,
                        localization: localization,
                        slug: slug
                    })
                ]
            }),
            view === "API_KEYS" && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$ab29d533d6c9d3ce, {
                classNames: classNames == null ? void 0 : classNames.card,
                localization: localization,
                isPending: organizationPending,
                organizationId: organization == null ? void 0 : organization.id
            }),
            view === "SETTINGS" && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$1ec86dece3a71f4a, {
                classNames: classNames,
                localization: localization,
                slug: slug
            })
        ]
    });
}
// src/components/redirect-to-sign-in.tsx
function $c5bb23e187c19083$export$1582f592a0156b9e() {
    $c5bb23e187c19083$export$141ca0666da3bf00({
        authView: "SIGN_IN"
    });
    return null;
}
// src/components/redirect-to-sign-up.tsx
function $c5bb23e187c19083$export$ff5dc1138f64391d() {
    $c5bb23e187c19083$export$141ca0666da3bf00({
        authView: "SIGN_UP"
    });
    return null;
}
function $c5bb23e187c19083$export$e407e752c306ef1a({ children: children }) {
    const { hooks: { useSession: useSession } } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { data: data } = useSession();
    return data ? children : null;
}
function $c5bb23e187c19083$export$44f9b89d67a6846b({ children: children }) {
    const { hooks: { useSession: useSession } } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const { data: data, isPending: isPending } = useSession();
    return !data && !isPending ? children : null;
}
function $c5bb23e187c19083$export$235493e82cf65451({ className: className, classNames: classNames, align: align, alignOffset: alignOffset, side: side, sideOffset: sideOffset, trigger: trigger, additionalLinks: additionalLinks, disableDefaultLinks: disableDefaultLinks, localization: propLocalization, size: size, ...props }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
    const { basePath: basePath, hooks: { useSession: useSession, useListDeviceSessions: useListDeviceSessions }, mutators: { setActiveSession: setActiveSession }, localization: contextLocalization, multiSession: multiSession, account: accountOptions, signUp: signUp, toast: toast, viewPaths: viewPaths, onSessionChange: onSessionChange, Link: Link } = (0, $7PdBe.useContext)((0, $07d0275849708341$export$f7b89be550702182));
    const localization = (0, $7PdBe.useMemo)(()=>({
            ...contextLocalization,
            ...propLocalization
        }), [
        contextLocalization,
        propLocalization
    ]);
    let deviceSessions = null;
    let deviceSessionsPending = false;
    if (multiSession) {
        const { data: data, isPending: isPending2 } = useListDeviceSessions();
        deviceSessions = data;
        deviceSessionsPending = isPending2;
    }
    const { data: sessionData, isPending: sessionPending } = useSession();
    const user = sessionData == null ? void 0 : sessionData.user;
    const [activeSessionPending, setActiveSessionPending] = (0, $7PdBe.useState)(false);
    const isHydrated = (0, $07d0275849708341$export$fd0534379e135f3d)();
    const isPending = sessionPending || activeSessionPending || !isHydrated;
    const switchAccount = (0, $7PdBe.useCallback)(async (sessionToken)=>{
        setActiveSessionPending(true);
        try {
            await setActiveSession({
                sessionToken: sessionToken
            });
            onSessionChange == null || onSessionChange();
        } catch (error) {
            toast({
                variant: "error",
                message: (0, $220046a7533cffdb$export$fc12d552df054270)({
                    error: error,
                    localization: localization
                })
            });
            setActiveSessionPending(false);
        }
    }, [
        setActiveSession,
        onSessionChange,
        toast,
        localization
    ]);
    (0, $7PdBe.useEffect)(()=>{
        if (!multiSession) return;
        setActiveSessionPending(false);
    }, [
        sessionData,
        multiSession
    ]);
    const warningLogged = (0, $7PdBe.useRef)(false);
    (0, $7PdBe.useEffect)(()=>{
        if (size || warningLogged.current) return;
        console.warn("[Better Auth UI] The `size` prop of `UserButton` no longer defaults to `icon`. Please pass `size='icon'` to the `UserButton` component to get the same behaviour as before. This warning will be removed in a future release. It can be suppressed in the meantime by defining the `size` prop.");
        warningLogged.current = true;
    }, [
        size
    ]);
    return /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenu, {
        children: [
            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuTrigger, {
                asChild: true,
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)(size === "icon" && "rounded-full", (_a = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _a.base),
                children: trigger || (size === "icon" ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$Button, {
                    size: "icon",
                    className: "size-fit rounded-full",
                    variant: "ghost",
                    children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$6c0524ba53950d9f, {
                        isPending: isPending,
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)(className, classNames == null ? void 0 : classNames.base),
                        classNames: (_b = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _b.avatar,
                        user: user,
                        "aria-label": localization.ACCOUNT,
                        localization: localization
                    }, user == null ? void 0 : user.image)
                }) : /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$Button, {
                    className: (0, $220046a7533cffdb$export$1343a74baacb0543)("!p-2 h-fit", className, (_c = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _c.base),
                    size: size,
                    ...props,
                    children: [
                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$93c94555daa109c4, {
                            size: size,
                            user: !(user == null ? void 0 : user.isAnonymous) ? user : null,
                            isPending: isPending,
                            classNames: (_d = classNames == null ? void 0 : classNames.trigger) == null ? void 0 : _d.user,
                            localization: localization
                        }),
                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $f258299638c7248e$export$2e2bcd8739ae039), {
                            className: "ml-auto"
                        })
                    ]
                }))
            }),
            /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuContent, {
                className: (0, $220046a7533cffdb$export$1343a74baacb0543)("w-[--radix-dropdown-menu-trigger-width] min-w-56 max-w-64", (_e = classNames == null ? void 0 : classNames.content) == null ? void 0 : _e.base),
                align: align,
                alignOffset: alignOffset,
                side: side,
                sideOffset: sideOffset,
                onCloseAutoFocus: (e)=>e.preventDefault(),
                children: [
                    /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                        className: (0, $220046a7533cffdb$export$1343a74baacb0543)("p-2", (_f = classNames == null ? void 0 : classNames.content) == null ? void 0 : _f.menuItem),
                        children: user && !user.isAnonymous || isPending ? /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$93c94555daa109c4, {
                            user: user,
                            isPending: isPending,
                            classNames: (_g = classNames == null ? void 0 : classNames.content) == null ? void 0 : _g.user,
                            localization: localization
                        }) : /* @__PURE__ */ (0, $hvk62.jsx)("div", {
                            className: "-my-1 text-muted-foreground text-xs",
                            children: localization.ACCOUNT
                        })
                    }),
                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuSeparator, {
                        className: (_h = classNames == null ? void 0 : classNames.content) == null ? void 0 : _h.separator
                    }),
                    additionalLinks == null ? void 0 : additionalLinks.map(({ href: href, icon: icon, label: label, signedIn: signedIn, separator: separator }, index)=>{
                        var _a2, _b2;
                        return (signedIn === void 0 || signedIn && !!sessionData || !signedIn && !sessionData) && /* @__PURE__ */ (0, $hvk62.jsxs)((0, $7PdBe.Fragment), {
                            children: [
                                /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                    href: href,
                                    children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        className: (_a2 = classNames == null ? void 0 : classNames.content) == null ? void 0 : _a2.menuItem,
                                        children: [
                                            icon,
                                            label
                                        ]
                                    })
                                }),
                                separator && /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuSeparator, {
                                    className: (_b2 = classNames == null ? void 0 : classNames.content) == null ? void 0 : _b2.separator
                                })
                            ]
                        }, index);
                    }),
                    !user || user.isAnonymous ? /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                href: `${basePath}/${viewPaths.SIGN_IN}`,
                                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    className: (_i = classNames == null ? void 0 : classNames.content) == null ? void 0 : _i.menuItem,
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $c9a20346f482de2f$export$2e2bcd8739ae039), {}),
                                        localization.SIGN_IN
                                    ]
                                })
                            }),
                            signUp && /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                href: `${basePath}/${viewPaths.SIGN_UP}`,
                                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    className: (_j = classNames == null ? void 0 : classNames.content) == null ? void 0 : _j.menuItem,
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $7632311beff79d2b$export$2e2bcd8739ae039), {}),
                                        localization.SIGN_UP
                                    ]
                                })
                            })
                        ]
                    }) : /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                        children: [
                            !disableDefaultLinks && accountOptions && /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                href: `${accountOptions.basePath}/${(_k = accountOptions.viewPaths) == null ? void 0 : _k.SETTINGS}`,
                                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    className: (_l = classNames == null ? void 0 : classNames.content) == null ? void 0 : _l.menuItem,
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $e7182fc0af14339c$export$2e2bcd8739ae039), {}),
                                        localization.SETTINGS
                                    ]
                                })
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                href: `${basePath}/${viewPaths.SIGN_OUT}`,
                                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    className: (_m = classNames == null ? void 0 : classNames.content) == null ? void 0 : _m.menuItem,
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $2e97570e53b7162e$export$2e2bcd8739ae039), {}),
                                        localization.SIGN_OUT
                                    ]
                                })
                            })
                        ]
                    }),
                    user && multiSession && /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                        children: [
                            /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuSeparator, {
                                className: (_n = classNames == null ? void 0 : classNames.content) == null ? void 0 : _n.separator
                            }),
                            !deviceSessions && deviceSessionsPending && /* @__PURE__ */ (0, $hvk62.jsxs)((0, $hvk62.Fragment), {
                                children: [
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuItem, {
                                        disabled: true,
                                        className: (_o = classNames == null ? void 0 : classNames.content) == null ? void 0 : _o.menuItem,
                                        children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$93c94555daa109c4, {
                                            isPending: true,
                                            classNames: (_p = classNames == null ? void 0 : classNames.content) == null ? void 0 : _p.user
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuSeparator, {
                                        className: (_q = classNames == null ? void 0 : classNames.content) == null ? void 0 : _q.separator
                                    })
                                ]
                            }),
                            deviceSessions == null ? void 0 : deviceSessions.filter((sessionData2)=>sessionData2.user.id !== (user == null ? void 0 : user.id)).map(({ session: session, user: user2 })=>{
                                var _a2, _b2, _c2;
                                return /* @__PURE__ */ (0, $hvk62.jsxs)((0, $7PdBe.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuItem, {
                                            className: (_a2 = classNames == null ? void 0 : classNames.content) == null ? void 0 : _a2.menuItem,
                                            onClick: ()=>switchAccount(session.token),
                                            children: /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$export$93c94555daa109c4, {
                                                user: user2,
                                                classNames: (_b2 = classNames == null ? void 0 : classNames.content) == null ? void 0 : _b2.user
                                            })
                                        }),
                                        /* @__PURE__ */ (0, $hvk62.jsx)($c5bb23e187c19083$var$DropdownMenuSeparator, {
                                            className: (_c2 = classNames == null ? void 0 : classNames.content) == null ? void 0 : _c2.separator
                                        })
                                    ]
                                }, session.id);
                            }),
                            /* @__PURE__ */ (0, $hvk62.jsx)(Link, {
                                href: `${basePath}/${viewPaths.SIGN_IN}`,
                                children: /* @__PURE__ */ (0, $hvk62.jsxs)($c5bb23e187c19083$var$DropdownMenuItem, {
                                    className: (_r = classNames == null ? void 0 : classNames.content) == null ? void 0 : _r.menuItem,
                                    children: [
                                        /* @__PURE__ */ (0, $hvk62.jsx)((0, $daa75c34e4a35766$export$2e2bcd8739ae039), {}),
                                        localization.ADD_ACCOUNT
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $7PdBe = parcelRequire("7PdBe");
var $15e9ed60d91245e4$exports = {};
"use strict";

$15e9ed60d91245e4$exports = (parcelRequire("erbba"));




// React.useInsertionEffect is not available in React <18
const { useEffect: $6e1b7a0c4a47829b$var$useEffect, useLayoutEffect: $6e1b7a0c4a47829b$var$useLayoutEffect, useRef: $6e1b7a0c4a47829b$var$useRef, useInsertionEffect: $6e1b7a0c4a47829b$var$useBuiltinInsertionEffect } = $7PdBe;
// Copied from:
// https://github.com/facebook/react/blob/main/packages/shared/ExecutionEnvironment.js
const $6e1b7a0c4a47829b$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $6e1b7a0c4a47829b$export$700979bc83e7db82 = $6e1b7a0c4a47829b$var$canUseDOM ? $6e1b7a0c4a47829b$var$useLayoutEffect : $6e1b7a0c4a47829b$var$useEffect;
const $6e1b7a0c4a47829b$export$aaabe4eda9ed9969 = $6e1b7a0c4a47829b$var$useBuiltinInsertionEffect || $6e1b7a0c4a47829b$export$700979bc83e7db82;
const $6e1b7a0c4a47829b$export$90fc3a17d93f704c = (fn)=>{
    const ref = $6e1b7a0c4a47829b$var$useRef([
        fn,
        (...args)=>ref[0](...args)
    ]).current;
    // Per Dan Abramov: useInsertionEffect executes marginally closer to the
    // correct timing for ref synchronization than useLayoutEffect on React 18.
    // See: https://github.com/facebook/react/pull/25881#issuecomment-1356244360
    $6e1b7a0c4a47829b$export$aaabe4eda9ed9969(()=>{
        ref[0] = fn;
    });
    return ref[1];
};


/*
 * Transforms `path` into its relative `base` version
 * If base isn't part of the path provided returns absolute path e.g. `~/app`
 */ const $91019e9652c658fa$export$7413eea5ad243d4 = (base = "", path = location.pathname)=>!path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
const $91019e9652c658fa$export$f1dd14e03b54dad4 = (to, base = "")=>to[0] === "~" ? to.slice(1) : base + to;


/**
 * History API docs @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */ const $e8a03e4c95d5e73c$var$eventPopstate = "popstate";
const $e8a03e4c95d5e73c$var$eventPushState = "pushState";
const $e8a03e4c95d5e73c$var$eventReplaceState = "replaceState";
const $e8a03e4c95d5e73c$var$eventHashchange = "hashchange";
const $e8a03e4c95d5e73c$export$4bf9923669ad6c63 = [
    $e8a03e4c95d5e73c$var$eventPopstate,
    $e8a03e4c95d5e73c$var$eventPushState,
    $e8a03e4c95d5e73c$var$eventReplaceState,
    $e8a03e4c95d5e73c$var$eventHashchange
];
const $e8a03e4c95d5e73c$var$subscribeToLocationUpdates = (callback)=>{
    for (const event of $e8a03e4c95d5e73c$export$4bf9923669ad6c63)addEventListener(event, callback);
    return ()=>{
        for (const event of $e8a03e4c95d5e73c$export$4bf9923669ad6c63)removeEventListener(event, callback);
    };
};
const $e8a03e4c95d5e73c$export$3a1ff78c39f8a86 = (fn, ssrFn)=>(0, $15e9ed60d91245e4$exports.useSyncExternalStore)($e8a03e4c95d5e73c$var$subscribeToLocationUpdates, fn, ssrFn);
const $e8a03e4c95d5e73c$var$currentSearch = ()=>location.search;
const $e8a03e4c95d5e73c$export$bd221a7c56b93941 = ()=>$e8a03e4c95d5e73c$export$3a1ff78c39f8a86($e8a03e4c95d5e73c$var$currentSearch);
const $e8a03e4c95d5e73c$var$currentPathname = ()=>location.pathname;
const $e8a03e4c95d5e73c$export$2a28ef6a9fe822a4 = ({ ssrPath: ssrPath } = {})=>$e8a03e4c95d5e73c$export$3a1ff78c39f8a86($e8a03e4c95d5e73c$var$currentPathname, ssrPath ? ()=>ssrPath : $e8a03e4c95d5e73c$var$currentPathname);
const $e8a03e4c95d5e73c$export$ff7962acd6052c28 = (to, { replace: replace = false } = {})=>history[replace ? $e8a03e4c95d5e73c$var$eventReplaceState : $e8a03e4c95d5e73c$var$eventPushState](null, "", to);
// the 2nd argument of the `useLocation` return value is a function
// that allows to perform a navigation.
//
// the function reference should stay the same between re-renders, so that
// it can be passed down as an element prop without any performance concerns.
// (This is achieved via `useEvent`.)
const $e8a03e4c95d5e73c$var$useLocation = (opts = {})=>[
        (0, $91019e9652c658fa$export$7413eea5ad243d4)(opts.base, $e8a03e4c95d5e73c$export$2a28ef6a9fe822a4(opts)),
        (0, $6e1b7a0c4a47829b$export$90fc3a17d93f704c)((to, navOpts)=>$e8a03e4c95d5e73c$export$ff7962acd6052c28((0, $91019e9652c658fa$export$f1dd14e03b54dad4)(to, opts.base), navOpts))
    ];
var $e8a03e4c95d5e73c$export$2e2bcd8739ae039 = $e8a03e4c95d5e73c$var$useLocation;
// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
if (typeof history !== "undefined") for (const type of [
    $e8a03e4c95d5e73c$var$eventPushState,
    $e8a03e4c95d5e73c$var$eventReplaceState
]){
    const original = history[type];
    // TODO: we should be using unstable_batchedUpdates to avoid multiple re-renders,
    // however that will require an additional peer dependency on react-dom.
    // See: https://github.com/reactwg/react-18/discussions/86#discussioncomment-1567149
    history[type] = function() {
        const result = original.apply(this, arguments);
        const event = new Event(type);
        event.arguments = arguments;
        dispatchEvent(event);
        return result;
    };
}


// creates a matcher function
function $54f635cd154b5e8b$export$2e2bcd8739ae039(makeRegexpFn = $54f635cd154b5e8b$var$pathToRegexp) {
    let cache = {};
    // obtains a cached regexp version of the pattern
    const getRegexp = (pattern)=>cache[pattern] || (cache[pattern] = makeRegexpFn(pattern));
    return (pattern, path)=>{
        const { regexp: regexp, keys: keys } = getRegexp(pattern || "");
        const out = regexp.exec(path);
        if (!out) return [
            false,
            null
        ];
        // formats an object with matched params
        const params = keys.reduce((params, key, i)=>{
            params[key.name] = out[i + 1];
            return params;
        }, {});
        return [
            true,
            params
        ];
    };
}
// escapes a regexp string (borrowed from path-to-regexp sources)
// https://github.com/pillarjs/path-to-regexp/blob/v3.0.0/index.js#L202
const $54f635cd154b5e8b$var$escapeRx = (str)=>str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
// returns a segment representation in RegExp based on flags
// adapted and simplified version from path-to-regexp sources
const $54f635cd154b5e8b$var$rxForSegment = (repeat, optional, prefix)=>{
    let capture = repeat ? "((?:[^\\/]+?)(?:\\/(?:[^\\/]+?))*)" : "([^\\/]+?)";
    if (optional && prefix) capture = "(?:\\/" + capture + ")";
    return capture + (optional ? "?" : "");
};
const $54f635cd154b5e8b$var$pathToRegexp = (pattern)=>{
    const groupRx = /:([A-Za-z0-9_]+)([?+*]?)/g;
    let match = null, lastIndex = 0, keys = [], result = "";
    while((match = groupRx.exec(pattern)) !== null){
        const [_, segment, mod] = match;
        // :foo  [1]      (  )
        // :foo? [0 - 1]  ( o)
        // :foo+ [1 - ∞]  (r )
        // :foo* [0 - ∞]  (ro)
        const repeat = mod === "+" || mod === "*";
        const optional = mod === "?" || mod === "*";
        const prefix = optional && pattern[match.index - 1] === "/" ? 1 : 0;
        const prev = pattern.substring(lastIndex, match.index - prefix);
        keys.push({
            name: segment
        });
        lastIndex = groupRx.lastIndex;
        result += $54f635cd154b5e8b$var$escapeRx(prev) + $54f635cd154b5e8b$var$rxForSegment(repeat, optional, prefix);
    }
    result += $54f635cd154b5e8b$var$escapeRx(pattern.substring(lastIndex));
    return {
        keys: keys,
        regexp: new RegExp("^" + result + "(?:\\/)?$", "i")
    };
};



var $7PdBe = parcelRequire("7PdBe");
/*
 * Router and router context. Router is a lightweight object that represents the current
 * routing options: how location is managed, base path etc.
 *
 * There is a default router present for most of the use cases, however it can be overridden
 * via the <Router /> component.
 */ const $710ca58b924d6f0b$var$defaultRouter = {
    hook: (0, $e8a03e4c95d5e73c$export$2e2bcd8739ae039),
    matcher: (0, $54f635cd154b5e8b$export$2e2bcd8739ae039)(),
    base: ""
};
const $710ca58b924d6f0b$var$RouterCtx = (0, $7PdBe.createContext)($710ca58b924d6f0b$var$defaultRouter);
const $710ca58b924d6f0b$export$9a302a45f65d0572 = ()=>(0, $7PdBe.useContext)($710ca58b924d6f0b$var$RouterCtx);
/*
 * Part 1, Hooks API: useRoute, useLocation and useParams
 */ // Internal version of useLocation to avoid redundant useRouter calls
const $710ca58b924d6f0b$var$useLocationFromRouter = (router)=>router.hook(router);
const $710ca58b924d6f0b$export$45d76561a5302f2b = ()=>$710ca58b924d6f0b$var$useLocationFromRouter($710ca58b924d6f0b$export$9a302a45f65d0572());
const $710ca58b924d6f0b$export$3f79f0b98112cf57 = (pattern)=>{
    const router = $710ca58b924d6f0b$export$9a302a45f65d0572();
    const [path] = $710ca58b924d6f0b$var$useLocationFromRouter(router);
    return router.matcher(pattern, path);
};
const $710ca58b924d6f0b$var$ParamsCtx = (0, $7PdBe.createContext)({
    params: {}
});
const $710ca58b924d6f0b$export$99eaa27ddbbb95ef = ()=>(0, $7PdBe.useContext)($710ca58b924d6f0b$var$ParamsCtx).params;
const $710ca58b924d6f0b$export$55185c17a0fcbe46 = ({ hook: hook, matcher: matcher, ssrPath: ssrPath, base: base = "", parent: parent, children: children })=>{
    // updates the current router with the props passed down to the component
    const updateRouter = (router, proto = parent || $710ca58b924d6f0b$var$defaultRouter)=>{
        router.hook = hook || proto.hook;
        router.matcher = matcher || proto.matcher;
        router.ssrPath = ssrPath || proto.ssrPath;
        router.ownBase = base;
        // store reference to parent router
        router.parent = parent;
        return router;
    };
    // we use `useState` here, but it only catches the first render and never changes.
    // https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
    const [value] = (0, $7PdBe.useState)(()=>updateRouter({
            // We must store base as a property accessor because effects
            // somewhat counter-intuitively run in child components *first*!
            // This means that by the time a parent's base is updated in the
            // parent effect, the child effect has already run, and saw
            // the parent's *previous* base during its own execution.
            get base () {
                return (value.parent || $710ca58b924d6f0b$var$defaultRouter).base + value.ownBase;
            }
        })); // create the object once...
    (0, $6e1b7a0c4a47829b$export$aaabe4eda9ed9969)(()=>{
        updateRouter(value);
    }); // ...then update it on each render
    return (0, $7PdBe.createElement)($710ca58b924d6f0b$var$RouterCtx.Provider, {
        value: value,
        children: children
    });
};
// Helper to wrap children component inside the ParamsCtx provider
const $710ca58b924d6f0b$var$ParamsWrapper = (params, children)=>(0, $7PdBe.createElement)($710ca58b924d6f0b$var$ParamsCtx.Provider, {
        value: {
            params: params
        },
        children: children
    });
const $710ca58b924d6f0b$export$e7b0ac011bb776c6 = ({ path: path, match: match, component: component, children: children })=>{
    const useRouteMatch = $710ca58b924d6f0b$export$3f79f0b98112cf57(path);
    // `props.match` is present - Route is controlled by the Switch
    const [matches, params] = match || useRouteMatch;
    if (!matches) return null;
    // React-Router style `component` prop
    if (component) return $710ca58b924d6f0b$var$ParamsWrapper(params, (0, $7PdBe.createElement)(component, {
        params: params
    }));
    // support render prop or plain children
    return $710ca58b924d6f0b$var$ParamsWrapper(params, typeof children === "function" ? children(params) : children);
};
const $710ca58b924d6f0b$export$a6c7ac8248d6e38a = (0, $7PdBe.forwardRef)((props, ref)=>{
    const router = $710ca58b924d6f0b$export$9a302a45f65d0572();
    const [, navigate] = $710ca58b924d6f0b$var$useLocationFromRouter(router);
    const { to: to, href: href = to, children: children, onClick: onClick } = props;
    const handleClick = (0, $6e1b7a0c4a47829b$export$90fc3a17d93f704c)((event)=>{
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        onClick && onClick(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            navigate(to || href, props);
        }
    });
    // wraps children in `a` if needed
    const extraProps = {
        // handle nested routers and absolute paths
        href: href[0] === "~" ? href.slice(1) : router.base + href,
        onClick: handleClick,
        to: null,
        ref: ref
    };
    const jsx = (0, $7PdBe.isValidElement)(children) ? children : (0, $7PdBe.createElement)("a", props);
    return (0, $7PdBe.cloneElement)(jsx, extraProps);
});
const $710ca58b924d6f0b$var$flattenChildren = (children)=>{
    return Array.isArray(children) ? [].concat(...children.map((c)=>c && c.type === (0, $7PdBe.Fragment) ? $710ca58b924d6f0b$var$flattenChildren(c.props.children) : $710ca58b924d6f0b$var$flattenChildren(c))) : [
        children
    ];
};
const $710ca58b924d6f0b$export$b5d5cf8927ab7262 = ({ children: children, location: location })=>{
    const router = $710ca58b924d6f0b$export$9a302a45f65d0572();
    const matcher = router.matcher;
    const [originalLocation] = $710ca58b924d6f0b$var$useLocationFromRouter(router);
    for (const element of $710ca58b924d6f0b$var$flattenChildren(children)){
        let match = 0;
        if ((0, $7PdBe.isValidElement)(element) && // we don't require an element to be of type Route,
        // but we do require it to contain a truthy `path` prop.
        // this allows to use different components that wrap Route
        // inside of a switch, for example <AnimatedRoute />.
        (match = element.props.path ? matcher(element.props.path, location || originalLocation) : [
            true,
            {}
        ])[0]) return (0, $7PdBe.cloneElement)(element, {
            match: match
        });
    }
    return null;
};
const $710ca58b924d6f0b$export$2d8d895a0a0f636e = (props)=>{
    const { to: to, href: href = to } = props;
    const [, navigate] = $710ca58b924d6f0b$export$45d76561a5302f2b();
    const redirect = (0, $6e1b7a0c4a47829b$export$90fc3a17d93f704c)(()=>navigate(to || href, props));
    // redirect is guaranteed to be stable since it is returned from useEvent
    (0, $6e1b7a0c4a47829b$export$700979bc83e7db82)(()=>{
        redirect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
};
var $710ca58b924d6f0b$export$2e2bcd8739ae039 = $710ca58b924d6f0b$export$3f79f0b98112cf57;



var $7PdBe = parcelRequire("7PdBe");
/**
  * Generated by going here: https://countrycode.org/
  * - Making the window size so that the visible table has three columns
  * - Selecting the visible table in dev tools
  * - Running the following Javascript:

    console.log(JSON.stringify(
      [].slice.call($0.querySelectorAll("tr")).map(function(e, i) {
        if (i > 0) {
          var tds = e.querySelectorAll("td");
          return [
            tds[0].querySelector("a").innerHTML,
            tds[2].innerHTML.split("/")[0].trim().toLowerCase()
          ];
        }
        else {
          return null;
        }
      }).filter(r => r != null),
      null,
      4
    ))

  */ 
var $bVBnA = parcelRequire("bVBnA");
function $4e9a94e13d88d600$export$2cc4aa3607b4f5d7() {
    return new $bVBnA.Promise(function(resolve, reject) {
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function(position) {
            window.$.ajax({
                url: "http://ws.geonames.org/countryCode",
                dataType: "json",
                data: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    username: "amagee99",
                    type: "JSON"
                },
                timeout: 5000,
                success: function(result) {
                    if (result.countryCode != null) resolve(result.countryCode.toLowerCase());
                    else reject(result);
                }
            }).fail(function() {
                reject("request_failed");
            });
        }, function() {
            reject("geolocation_failed");
        });
        else reject("no_geolocation");
    });
}
window.getCountryCodeViaGeolocation = $4e9a94e13d88d600$export$2cc4aa3607b4f5d7;
let $4e9a94e13d88d600$var$cs = [
    [
        "Afghanistan",
        "af"
    ],
    [
        "Albania",
        "al"
    ],
    [
        "Algeria",
        "dz"
    ],
    [
        "American Samoa",
        "as"
    ],
    [
        "Andorra",
        "ad"
    ],
    [
        "Angola",
        "ao"
    ],
    [
        "Anguilla",
        "ai"
    ],
    [
        "Antarctica",
        "aq"
    ],
    [
        "Antigua and Barbuda",
        "ag"
    ],
    [
        "Argentina",
        "ar"
    ],
    [
        "Armenia",
        "am"
    ],
    [
        "Aruba",
        "aw"
    ],
    [
        "Australia",
        "au"
    ],
    [
        "Austria",
        "at"
    ],
    [
        "Azerbaijan",
        "az"
    ],
    [
        "Bahamas",
        "bs"
    ],
    [
        "Bahrain",
        "bh"
    ],
    [
        "Bangladesh",
        "bd"
    ],
    [
        "Barbados",
        "bb"
    ],
    [
        "Belarus",
        "by"
    ],
    [
        "Belgium",
        "be"
    ],
    [
        "Belize",
        "bz"
    ],
    [
        "Benin",
        "bj"
    ],
    [
        "Bermuda",
        "bm"
    ],
    [
        "Bhutan",
        "bt"
    ],
    [
        "Bolivia",
        "bo"
    ],
    [
        "Bosnia and Herzegovina",
        "ba"
    ],
    [
        "Botswana",
        "bw"
    ],
    [
        "Brazil",
        "br"
    ],
    [
        "British Indian Ocean Territory",
        "io"
    ],
    [
        "British Virgin Islands",
        "vg"
    ],
    [
        "Brunei",
        "bn"
    ],
    [
        "Bulgaria",
        "bg"
    ],
    [
        "Burkina Faso",
        "bf"
    ],
    [
        "Burundi",
        "bi"
    ],
    [
        "Cambodia",
        "kh"
    ],
    [
        "Cameroon",
        "cm"
    ],
    [
        "Canada",
        "ca"
    ],
    [
        "Cape Verde",
        "cv"
    ],
    [
        "Cayman Islands",
        "ky"
    ],
    [
        "Central African Republic",
        "cf"
    ],
    [
        "Chad",
        "td"
    ],
    [
        "Chile",
        "cl"
    ],
    [
        "China",
        "cn"
    ],
    [
        "Christmas Island",
        "cx"
    ],
    [
        "Cocos Islands",
        "cc"
    ],
    [
        "Colombia",
        "co"
    ],
    [
        "Comoros",
        "km"
    ],
    [
        "Cook Islands",
        "ck"
    ],
    [
        "Costa Rica",
        "cr"
    ],
    [
        "Croatia",
        "hr"
    ],
    [
        "Cuba",
        "cu"
    ],
    [
        "Curacao",
        "cw"
    ],
    [
        "Cyprus",
        "cy"
    ],
    [
        "Czech Republic",
        "cz"
    ],
    [
        "Democratic Republic of the Congo",
        "cd"
    ],
    [
        "Denmark",
        "dk"
    ],
    [
        "Djibouti",
        "dj"
    ],
    [
        "Dominica",
        "dm"
    ],
    [
        "Dominican Republic",
        "do"
    ],
    [
        "East Timor",
        "tl"
    ],
    [
        "Ecuador",
        "ec"
    ],
    [
        "Egypt",
        "eg"
    ],
    [
        "El Salvador",
        "sv"
    ],
    [
        "Equatorial Guinea",
        "gq"
    ],
    [
        "Eritrea",
        "er"
    ],
    [
        "Estonia",
        "ee"
    ],
    [
        "Ethiopia",
        "et"
    ],
    [
        "Falkland Islands",
        "fk"
    ],
    [
        "Faroe Islands",
        "fo"
    ],
    [
        "Fiji",
        "fj"
    ],
    [
        "Finland",
        "fi"
    ],
    [
        "France",
        "fr"
    ],
    [
        "French Polynesia",
        "pf"
    ],
    [
        "Gabon",
        "ga"
    ],
    [
        "Gambia",
        "gm"
    ],
    [
        "Georgia",
        "ge"
    ],
    [
        "Germany",
        "de"
    ],
    [
        "Ghana",
        "gh"
    ],
    [
        "Gibraltar",
        "gi"
    ],
    [
        "Greece",
        "gr"
    ],
    [
        "Greenland",
        "gl"
    ],
    [
        "Grenada",
        "gd"
    ],
    [
        "Guam",
        "gu"
    ],
    [
        "Guatemala",
        "gt"
    ],
    [
        "Guernsey",
        "gg"
    ],
    [
        "Guinea",
        "gn"
    ],
    [
        "Guinea-Bissau",
        "gw"
    ],
    [
        "Guyana",
        "gy"
    ],
    [
        "Haiti",
        "ht"
    ],
    [
        "Honduras",
        "hn"
    ],
    [
        "Hong Kong",
        "hk"
    ],
    [
        "Hungary",
        "hu"
    ],
    [
        "Iceland",
        "is"
    ],
    [
        "India",
        "in"
    ],
    [
        "Indonesia",
        "id"
    ],
    [
        "Iran",
        "ir"
    ],
    [
        "Iraq",
        "iq"
    ],
    [
        "Ireland",
        "ie"
    ],
    [
        "Isle of Man",
        "im"
    ],
    [
        "Israel",
        "il"
    ],
    [
        "Italy",
        "it"
    ],
    [
        "Ivory Coast",
        "ci"
    ],
    [
        "Jamaica",
        "jm"
    ],
    [
        "Japan",
        "jp"
    ],
    [
        "Jersey",
        "je"
    ],
    [
        "Jordan",
        "jo"
    ],
    [
        "Kazakhstan",
        "kz"
    ],
    [
        "Kenya",
        "ke"
    ],
    [
        "Kiribati",
        "ki"
    ],
    [
        "Kosovo",
        "xk"
    ],
    [
        "Kuwait",
        "kw"
    ],
    [
        "Kyrgyzstan",
        "kg"
    ],
    [
        "Laos",
        "la"
    ],
    [
        "Latvia",
        "lv"
    ],
    [
        "Lebanon",
        "lb"
    ],
    [
        "Lesotho",
        "ls"
    ],
    [
        "Liberia",
        "lr"
    ],
    [
        "Libya",
        "ly"
    ],
    [
        "Liechtenstein",
        "li"
    ],
    [
        "Lithuania",
        "lt"
    ],
    [
        "Luxembourg",
        "lu"
    ],
    [
        "Macao",
        "mo"
    ],
    [
        "Macedonia",
        "mk"
    ],
    [
        "Madagascar",
        "mg"
    ],
    [
        "Malawi",
        "mw"
    ],
    [
        "Malaysia",
        "my"
    ],
    [
        "Maldives",
        "mv"
    ],
    [
        "Mali",
        "ml"
    ],
    [
        "Malta",
        "mt"
    ],
    [
        "Marshall Islands",
        "mh"
    ],
    [
        "Mauritania",
        "mr"
    ],
    [
        "Mauritius",
        "mu"
    ],
    [
        "Mayotte",
        "yt"
    ],
    [
        "Mexico",
        "mx"
    ],
    [
        "Micronesia",
        "fm"
    ],
    [
        "Moldova",
        "md"
    ],
    [
        "Monaco",
        "mc"
    ],
    [
        "Mongolia",
        "mn"
    ],
    [
        "Montenegro",
        "me"
    ],
    [
        "Montserrat",
        "ms"
    ],
    [
        "Morocco",
        "ma"
    ],
    [
        "Mozambique",
        "mz"
    ],
    [
        "Myanmar",
        "mm"
    ],
    [
        "Namibia",
        "na"
    ],
    [
        "Nauru",
        "nr"
    ],
    [
        "Nepal",
        "np"
    ],
    [
        "Netherlands",
        "nl"
    ],
    [
        "Netherlands Antilles",
        "an"
    ],
    [
        "New Caledonia",
        "nc"
    ],
    [
        "New Zealand",
        "nz"
    ],
    [
        "Nicaragua",
        "ni"
    ],
    [
        "Niger",
        "ne"
    ],
    [
        "Nigeria",
        "ng"
    ],
    [
        "Niue",
        "nu"
    ],
    [
        "North Korea",
        "kp"
    ],
    [
        "Northern Mariana Islands",
        "mp"
    ],
    [
        "Norway",
        "no"
    ],
    [
        "Oman",
        "om"
    ],
    [
        "Pakistan",
        "pk"
    ],
    [
        "Palau",
        "pw"
    ],
    [
        "Palestine",
        "ps"
    ],
    [
        "Panama",
        "pa"
    ],
    [
        "Papua New Guinea",
        "pg"
    ],
    [
        "Paraguay",
        "py"
    ],
    [
        "Peru",
        "pe"
    ],
    [
        "Philippines",
        "ph"
    ],
    [
        "Pitcairn",
        "pn"
    ],
    [
        "Poland",
        "pl"
    ],
    [
        "Portugal",
        "pt"
    ],
    [
        "Puerto Rico",
        "pr"
    ],
    [
        "Qatar",
        "qa"
    ],
    [
        "Republic of the Congo",
        "cg"
    ],
    [
        "Reunion",
        "re"
    ],
    [
        "Romania",
        "ro"
    ],
    [
        "Russia",
        "ru"
    ],
    [
        "Rwanda",
        "rw"
    ],
    [
        "Saint Barthelemy",
        "bl"
    ],
    [
        "Saint Helena",
        "sh"
    ],
    [
        "Saint Kitts and Nevis",
        "kn"
    ],
    [
        "Saint Lucia",
        "lc"
    ],
    [
        "Saint Martin",
        "mf"
    ],
    [
        "Saint Pierre and Miquelon",
        "pm"
    ],
    [
        "Saint Vincent and the Grenadines",
        "vc"
    ],
    [
        "Samoa",
        "ws"
    ],
    [
        "San Marino",
        "sm"
    ],
    [
        "Sao Tome and Principe",
        "st"
    ],
    [
        "Saudi Arabia",
        "sa"
    ],
    [
        "Senegal",
        "sn"
    ],
    [
        "Serbia",
        "rs"
    ],
    [
        "Seychelles",
        "sc"
    ],
    [
        "Sierra Leone",
        "sl"
    ],
    [
        "Singapore",
        "sg"
    ],
    [
        "Sint Maarten",
        "sx"
    ],
    [
        "Slovakia",
        "sk"
    ],
    [
        "Slovenia",
        "si"
    ],
    [
        "Solomon Islands",
        "sb"
    ],
    [
        "Somalia",
        "so"
    ],
    [
        "South Africa",
        "za"
    ],
    [
        "South Korea",
        "kr"
    ],
    [
        "South Sudan",
        "ss"
    ],
    [
        "Spain",
        "es"
    ],
    [
        "Sri Lanka",
        "lk"
    ],
    [
        "Sudan",
        "sd"
    ],
    [
        "Suriname",
        "sr"
    ],
    [
        "Svalbard and Jan Mayen",
        "sj"
    ],
    [
        "Swaziland",
        "sz"
    ],
    [
        "Sweden",
        "se"
    ],
    [
        "Switzerland",
        "ch"
    ],
    [
        "Syria",
        "sy"
    ],
    [
        "Taiwan",
        "tw"
    ],
    [
        "Tajikistan",
        "tj"
    ],
    [
        "Tanzania",
        "tz"
    ],
    [
        "Thailand",
        "th"
    ],
    [
        "Togo",
        "tg"
    ],
    [
        "Tokelau",
        "tk"
    ],
    [
        "Tonga",
        "to"
    ],
    [
        "Trinidad and Tobago",
        "tt"
    ],
    [
        "Tunisia",
        "tn"
    ],
    [
        "Turkey",
        "tr"
    ],
    [
        "Turkmenistan",
        "tm"
    ],
    [
        "Turks and Caicos Islands",
        "tc"
    ],
    [
        "Tuvalu",
        "tv"
    ],
    [
        "U.S. Virgin Islands",
        "vi"
    ],
    [
        "Uganda",
        "ug"
    ],
    [
        "Ukraine",
        "ua"
    ],
    [
        "United Arab Emirates",
        "ae"
    ],
    [
        "United Kingdom",
        "gb"
    ],
    [
        "United States",
        "us"
    ],
    [
        "Uruguay",
        "uy"
    ],
    [
        "Uzbekistan",
        "uz"
    ],
    [
        "Vanuatu",
        "vu"
    ],
    [
        "Vatican",
        "va"
    ],
    [
        "Venezuela",
        "ve"
    ],
    [
        "Vietnam",
        "vn"
    ],
    [
        "Wallis and Futuna",
        "wf"
    ],
    [
        "Western Sahara",
        "eh"
    ],
    [
        "Yemen",
        "ye"
    ],
    [
        "Zambia",
        "zm"
    ],
    [
        "Zimbabwe",
        "zw"
    ]
];
const $4e9a94e13d88d600$export$e5ad74579c86b003 = $4e9a94e13d88d600$var$cs.map((c)=>({
        name: c[0],
        code: c[1]
    }));



var $b8BPd = parcelRequire("b8BPd");

var $RSSjA = parcelRequire("RSSjA");

const $55e9f4dfe94c5bdf$export$fb98e3a2a4cd92d7 = ({ ...props })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $0bf2944f2fb447de$exports.Toaster), {
        className: "toaster group",
        toastOptions: {
            classNames: {
                toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
                description: "group-[.toast]:text-muted-foreground",
                actionButton: "group-[.toast]:bg-background group-[.toast]:text-foreground",
                cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
            }
        },
        ...props
    });
};




var $5uSSv = parcelRequire("5uSSv");

var $2BEDj = parcelRequire("2BEDj");

function $8edff7cab15c34e3$export$2e2bcd8739ae039({ authView: authView }) {
    const [, setLocation] = (0, $710ca58b924d6f0b$export$45d76561a5302f2b)();
    // Memoize URL params to prevent unnecessary re-renders
    const urlParams = (0, $7PdBe.useMemo)(()=>{
        const searchParams = new URLSearchParams(window.location.search);
        return {
            redirectTo: searchParams.get("redirectTo") || "/",
            invitationId: searchParams.get("invitationId"),
            email: searchParams.get("email")
        };
    }, []);
    const redirectPath = urlParams.redirectTo;
    // Memoize localization object to prevent unnecessary re-renders
    const localization = (0, $7PdBe.useMemo)(()=>({
            NAME: "Company Name",
            NAME_PLACEHOLDER: "Company Name",
            SIGN_UP: "Create an Account",
            SIGN_UP_DESCRIPTION: "Enter your information below to create an account for your company",
            MAGIC_LINK: "Email Link",
            MAGIC_LINK_ACTION: "Send Email Link"
        }), []);
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("main", {
        className: "flex grow flex-col items-center justify-center gap-3 self-center p-4 md:p-6 bg-background w-full",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $55e9f4dfe94c5bdf$export$fb98e3a2a4cd92d7), {
                position: "top-center"
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)("img", {
                src: new URL((parcelRequire("4Iihd"))).href,
                alt: "Coincraft Logo",
                className: "size-28 mb-10"
            }),
            authView === "account-details" ? /*#__PURE__*/ (0, $RSSjA.jsx)($8edff7cab15c34e3$var$AccountDetails, {
                redirectPath: redirectPath
            }) : authView === "accept-invitation" ? /*#__PURE__*/ (0, $RSSjA.jsx)($8edff7cab15c34e3$var$AcceptInvitationView, {
                redirectPath: redirectPath
            }) : authView === "sign-out" ? /*#__PURE__*/ (0, $RSSjA.jsx)($8edff7cab15c34e3$var$SignOutView, {}) : authView === "verify" ? /*#__PURE__*/ (0, $RSSjA.jsx)($8edff7cab15c34e3$var$MagicLinkVerify, {
                redirectPath: redirectPath
            }) : /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c5bb23e187c19083$export$6e722c8f9ee9bf65), {
                className: "mb-28",
                pathname: authView,
                redirectTo: redirectPath,
                callbackURL: redirectPath,
                localization: localization
            })
        ]
    });
}
const $8edff7cab15c34e3$var$AcceptInvitationView = ({ redirectPath: redirectPath = "/select-organisation" })=>{
    var _session$data2, _session$data3;
    const [, setLocation] = (0, $710ca58b924d6f0b$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(window.location.search);
    const invitationId = searchParams.get("invitationId");
    const session = (0, $2BEDj.authClient).useSession();
    const [invitationDetails, setInvitationDetails] = (0, $7PdBe.useState)(null);
    const [accountExists, setAccountExists] = (0, $7PdBe.useState)(null);
    const [isLoading, setIsLoading] = (0, $7PdBe.useState)(true);
    (0, $7PdBe.useEffect)(()=>{
        const checkInvitation = async ()=>{
            if (!invitationId) {
                setIsLoading(false);
                return;
            }
            try {
                var _session$data;
                // Get invitation details
                const details = await (0, $b8BPd.trpc).auth.getInvitationDetails.query({
                    invitationId: invitationId
                });
                setInvitationDetails(details);
                // Only check if account exists when user is not logged in
                if (!((_session$data = session.data) !== null && _session$data !== void 0 && _session$data.user)) {
                    const accountCheck = await (0, $b8BPd.trpc).auth.checkAccountExists.query({
                        email: details.email
                    });
                    setAccountExists(accountCheck.exists);
                }
            } catch (error) {
                console.error("Error checking invitation:", error);
            } finally{
                setIsLoading(false);
            }
        };
        checkInvitation();
    }, [
        invitationId,
        (_session$data2 = session.data) === null || _session$data2 === void 0 ? void 0 : _session$data2.user
    ]);
    // Handle navigation based on account existence
    (0, $7PdBe.useEffect)(()=>{
        // Only navigate when we have determined account existence
        if (accountExists === null || !invitationDetails || !invitationId) return;
        if (accountExists) // Redirect to sign-in with the invitation ID
        setLocation(`/auth/sign-in?invitationId=${invitationId}&redirectTo=/auth/accept-invitation`);
        else // Redirect to sign-up with prefilled email
        setLocation(`/auth/sign-up?invitationId=${invitationId}&email=${invitationDetails.email}&redirectTo=/auth/accept-invitation`);
    }, [
        accountExists,
        invitationDetails,
        invitationId,
        setLocation
    ]);
    // If user is already logged in, show the invitation card
    if ((_session$data3 = session.data) !== null && _session$data3 !== void 0 && _session$data3.user) {
        if (!invitationId) return /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$60332b2344f7fe41), {
            className: "w-full max-w-md",
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$5665775b26e26c5d), {
                    children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$474db65c3c394e1c), {
                        className: "text-lg md:text-xl text-red-600",
                        children: "Invalid Invitation"
                    })
                }),
                /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$64ef9b8c11710c47), {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                            className: "text-sm text-muted-foreground",
                            children: "No invitation ID provided"
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)((0, $80ce2cc30ed5cbab$export$353f5b6fc5456de1), {
                            onClick: ()=>setLocation("/auth/sign-in"),
                            className: "w-full",
                            children: "Go to Sign In"
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c5bb23e187c19083$export$bef676af1f4743eb), {
            className: "w-full max-w-md",
            invitationId: invitationId,
            onSuccess: async ()=>{
                (0, $0bf2944f2fb447de$exports.toast).success("Welcome to the team!");
                // Set this organisation as active
                if (invitationDetails !== null && invitationDetails !== void 0 && invitationDetails.organisationId) await (0, $2BEDj.authClient).organization.setActive({
                    organizationId: invitationDetails.organisationId
                });
                // Reload to get fresh session with staff record
                setTimeout(()=>{
                    window.location.href = "/";
                }, 500);
            },
            onError: (error)=>{
                (0, $0bf2944f2fb447de$exports.toast).error(error.message || "Failed to accept invitation");
            }
        });
    }
    // User is not logged in - check if they have an account
    if (isLoading) return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$60332b2344f7fe41), {
        className: "w-full max-w-md",
        children: /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$64ef9b8c11710c47), {
            className: "pt-6 pb-6 flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                    className: "animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"
                }),
                /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                    className: "text-center text-muted-foreground",
                    children: "Checking invitation..."
                })
            ]
        })
    });
    if (!invitationId || !invitationDetails) return /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$60332b2344f7fe41), {
        className: "w-full max-w-md",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$474db65c3c394e1c), {
                    className: "text-lg md:text-xl text-red-600",
                    children: "Invalid Invitation"
                })
            }),
            /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$64ef9b8c11710c47), {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                        className: "text-sm text-muted-foreground",
                        children: !invitationId ? "No invitation ID provided" : "Invitation not found or expired"
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $80ce2cc30ed5cbab$export$353f5b6fc5456de1), {
                        onClick: ()=>setLocation("/auth/sign-in"),
                        className: "w-full",
                        children: "Go to Sign In"
                    })
                ]
            })
        ]
    });
    // Show loading state while navigation is happening
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$60332b2344f7fe41), {
        className: "w-full max-w-md",
        children: /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$64ef9b8c11710c47), {
            className: "pt-6 pb-6 flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                    className: "animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"
                }),
                /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                    className: "text-center text-muted-foreground",
                    children: "Redirecting..."
                })
            ]
        })
    });
};
const $8edff7cab15c34e3$var$AccountDetails = ({ redirectPath: redirectPath = "/select-organisation" })=>{
    const [, setLocation] = (0, $710ca58b924d6f0b$export$45d76561a5302f2b)();
    const [firstName, setFirstName] = (0, $7PdBe.useState)("");
    const [lastName, setLastName] = (0, $7PdBe.useState)("");
    const [phoneNumber, setPhoneNumber] = (0, $7PdBe.useState)("");
    const [countryCode, setCountryCode] = (0, $7PdBe.useState)("");
    const [industry, setIndustry] = (0, $7PdBe.useState)("");
    const [otherIndustry, setOtherIndustry] = (0, $7PdBe.useState)("");
    const [companySize, setCompanySize] = (0, $7PdBe.useState)("");
    const [referralSource, setReferralSource] = (0, $7PdBe.useState)("");
    const [otherReferralSource, setOtherReferralSource] = (0, $7PdBe.useState)("");
    const [termsAccepted, setTermsAccepted] = (0, $7PdBe.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $7PdBe.useState)(false);
    const [errors, setErrors] = (0, $7PdBe.useState)({});
    (0, $7PdBe.useEffect)(()=>{
        fetch("https://cloudflare.com/cdn-cgi/trace").then((response)=>response.text()).then((data)=>{
            const parsedData = Object.fromEntries(data.trim().split("\n").map((line)=>line.split("=")));
            if (!countryCode && parsedData.loc) setCountryCode(parsedData.loc.toLowerCase());
        }).catch(()=>{
        // Silently fail if geolocation doesn't work
        });
    }, []);
    const validateForm = ()=>{
        const newErrors = {};
        if (!firstName.trim()) newErrors.firstName = true;
        if (!lastName.trim()) newErrors.lastName = true;
        if (!countryCode) newErrors.countryCode = true;
        if (!termsAccepted) newErrors.termsAccepted = true;
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async ()=>{
        if (!validateForm()) return;
        setIsSubmitting(true);
        setErrors({});
        try {
            const result = await (0, $b8BPd.trpc).auth.registerDetails.mutate({
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                country: countryCode,
                phoneNumber: phoneNumber.trim() || undefined,
                industry: industry !== "other" ? industry || undefined : otherIndustry.trim() || undefined,
                companySize: companySize || undefined,
                referralSource: referralSource !== "other" ? referralSource || undefined : otherReferralSource.trim() || undefined
            });
            if (result.success) // Navigate to organisation selection to choose/create org
            window.location.href = redirectPath;
            else throw new Error("Failed to update account details");
        } catch (error) {
            console.error("[AccountDetails] Failed to save account details:", error);
            alert("Failed to save account details. Please try again.");
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$60332b2344f7fe41), {
        className: "w-full max-w-sm",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$5665775b26e26c5d), {
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$474db65c3c394e1c), {
                        className: "text-lg md:text-xl",
                        children: "Account Details"
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$16e0ed4cb97c00d4), {
                        className: "text-xs md:text-sm",
                        children: "We just need to know a few more things so we can finish setting up your account."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$64ef9b8c11710c47), {
                className: "grid gap-6",
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "grid gap-4",
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "space-y-2",
                                "data-testid": "name-fields",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                                        className: "text-sm font-medium",
                                        children: "What's your name?"
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                        className: "grid grid-cols-2 gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $1bcecf728217e410$export$f5b8910cec6cf069), {
                                                    placeholder: "First name",
                                                    value: firstName,
                                                    onChange: (e)=>setFirstName(e.target.value),
                                                    className: errors.firstName ? "border-red-500" : ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $1bcecf728217e410$export$f5b8910cec6cf069), {
                                                    placeholder: "Last name",
                                                    value: lastName,
                                                    onChange: (e)=>setLastName(e.target.value),
                                                    className: errors.lastName ? "border-red-500" : ""
                                                })
                                            })
                                        ]
                                    }),
                                    (errors.firstName || errors.lastName) && /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                                        className: "text-sm text-red-500",
                                        children: "Please enter your name."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "space-y-2",
                                "data-testid": "phone-number-input",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                                        htmlFor: "phone",
                                        children: "What's your phone number?"
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $1bcecf728217e410$export$f5b8910cec6cf069), {
                                        id: "phone",
                                        type: "tel",
                                        placeholder: "Phone number",
                                        value: phoneNumber,
                                        onChange: (e)=>setPhoneNumber(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "space-y-2",
                                "data-testid": "country-selector",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                                        children: "Which country are you from?"
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $188abd732422c87b$export$ef9b1a59e592288f), {
                                        value: countryCode,
                                        onValueChange: setCountryCode,
                                        children: [
                                            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$3ac1e88a1c0b9f1), {
                                                className: errors.countryCode ? "border-red-500" : "",
                                                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$e288731fd71264f0), {
                                                    placeholder: "Select your country"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$c973a4b3cb86a03d), {
                                                children: (0, $4e9a94e13d88d600$export$e5ad74579c86b003).map((country)=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: country.code,
                                                        children: country.name
                                                    }, country.code))
                                            })
                                        ]
                                    }),
                                    errors.countryCode && /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                                        className: "text-sm text-red-500",
                                        children: "Please select your country."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "space-y-2",
                                "data-testid": "industry-selector",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                                        children: "Industry"
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $188abd732422c87b$export$ef9b1a59e592288f), {
                                        value: industry,
                                        onValueChange: setIndustry,
                                        children: [
                                            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$3ac1e88a1c0b9f1), {
                                                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$e288731fd71264f0), {
                                                    placeholder: "Select your industry"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $188abd732422c87b$export$c973a4b3cb86a03d), {
                                                children: [
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "architecture",
                                                        children: "Architecture"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "engineering",
                                                        children: "Engineering"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "marketing",
                                                        children: "Marketing"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "other",
                                                        children: "Other"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    industry === "other" && /*#__PURE__*/ (0, $RSSjA.jsx)((0, $1bcecf728217e410$export$f5b8910cec6cf069), {
                                        placeholder: "Please specify your industry",
                                        value: otherIndustry,
                                        onChange: (e)=>setOtherIndustry(e.target.value),
                                        className: "mt-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "space-y-2",
                                "data-testid": "company-size-selector",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                                        children: "Company Size"
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $188abd732422c87b$export$ef9b1a59e592288f), {
                                        value: companySize,
                                        onValueChange: setCompanySize,
                                        children: [
                                            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$3ac1e88a1c0b9f1), {
                                                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$e288731fd71264f0), {
                                                    placeholder: "Select company size"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $188abd732422c87b$export$c973a4b3cb86a03d), {
                                                children: [
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "just-me",
                                                        children: "Just me"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "1-5",
                                                        children: "2-5 staff"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "6-10",
                                                        children: "6-10 staff"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "11-25",
                                                        children: "11-25 staff"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "26-50",
                                                        children: "26-50 staff"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "51-100",
                                                        children: "51-100 staff"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "101-200",
                                                        children: "101-200 staff"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "201-500",
                                                        children: "201-500 staff"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "500+",
                                                        children: "500+ staff"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "space-y-2",
                                "data-testid": "referral-source-selector",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                                        children: "How did you hear about us?"
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $188abd732422c87b$export$ef9b1a59e592288f), {
                                        value: referralSource,
                                        onValueChange: setReferralSource,
                                        children: [
                                            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$3ac1e88a1c0b9f1), {
                                                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$e288731fd71264f0), {
                                                    placeholder: "Select an option"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $188abd732422c87b$export$c973a4b3cb86a03d), {
                                                children: [
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "google_search",
                                                        children: "Google/Search Engine"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "social_media",
                                                        children: "Social Media (LinkedIn, Facebook, Twitter, etc.)"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "online_ads",
                                                        children: "Online Ads"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "word_of_mouth",
                                                        children: "Word of Mouth/Referral from a Friend"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "review_site",
                                                        children: "Review Site (e.g., G2, Capterra)"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "blog_article",
                                                        children: "Blog/Article"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "email_newsletter",
                                                        children: "Email Newsletter"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "event_webinar",
                                                        children: "Event/Webinar"
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $188abd732422c87b$export$13ef48a934230896), {
                                                        value: "other",
                                                        children: "Other"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    referralSource === "other" && /*#__PURE__*/ (0, $RSSjA.jsx)((0, $1bcecf728217e410$export$f5b8910cec6cf069), {
                                        placeholder: "Please specify",
                                        value: otherReferralSource,
                                        onChange: (e)=>setOtherReferralSource(e.target.value),
                                        className: "mt-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "flex items-start space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)("input", {
                                        type: "checkbox",
                                        id: "termsAccepted",
                                        checked: termsAccepted,
                                        onChange: (e)=>setTermsAccepted(e.target.checked),
                                        disabled: isSubmitting,
                                        className: "mt-1"
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $c3de1c4159aa79b3$export$b04be29aa201d4f5), {
                                        htmlFor: "termsAccepted",
                                        className: "text-sm font-normal cursor-pointer",
                                        children: [
                                            "I agree to the",
                                            " ",
                                            /*#__PURE__*/ (0, $RSSjA.jsx)("a", {
                                                href: "/terms",
                                                className: "underline",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "Coincraft Terms of Service"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            errors.termsAccepted && /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                                className: "text-sm text-red-500",
                                children: "You must accept the Terms of Service to continue."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $80ce2cc30ed5cbab$export$353f5b6fc5456de1), {
                        onClick: handleSubmit,
                        disabled: isSubmitting,
                        className: "w-full",
                        size: "lg",
                        children: isSubmitting ? "Saving..." : "Start Using Coincraft!"
                    })
                ]
            })
        ]
    });
};
const $8edff7cab15c34e3$var$MagicLinkVerify = ({ redirectPath: redirectPath = "/" })=>{
    const [, setLocation] = (0, $710ca58b924d6f0b$export$45d76561a5302f2b)();
    const [status, setStatus] = (0, $7PdBe.useState)("verifying");
    const [errorMessage, setErrorMessage] = (0, $7PdBe.useState)("");
    (0, $7PdBe.useEffect)(()=>{
        const searchParams = new URLSearchParams(window.location.search);
        const token = searchParams.get("token");
        if (!token) {
            setErrorMessage("No verification token provided.");
            setStatus("error");
            return;
        }
        const verifyToken = async ()=>{
            try {
                const serverUrl = "https://server2.coincraft.co";
                const response = await fetch(`${serverUrl}/api/auth/magic-link/verify?token=${token}`, {
                    method: "GET",
                    credentials: "include",
                    redirect: "manual"
                });
                if (response.type === "opaqueredirect") {
                    // Check session to determine if verification succeeded
                    const sessionResponse = await fetch(`${serverUrl}/api/auth/get-session`, {
                        credentials: "include"
                    });
                    const sessionData = await sessionResponse.json();
                    if (sessionData.user) {
                        setStatus("success");
                        setTimeout(()=>{
                            window.location.href = redirectPath;
                        }, 1000);
                    } else {
                        setErrorMessage("Email link is invalid or expired.");
                        setStatus("error");
                    }
                    return;
                }
                if (response.status === 200) {
                    setStatus("success");
                    setTimeout(()=>{
                        window.location.href = redirectPath;
                    }, 1000);
                    return;
                }
                try {
                    var _result$error;
                    const text = await response.text();
                    const result = JSON.parse(text);
                    setErrorMessage(((_result$error = result.error) === null || _result$error === void 0 ? void 0 : _result$error.message) || result.message || "Email link is invalid or expired.");
                } catch  {
                    setErrorMessage("Email link is invalid or expired.");
                }
                setStatus("error");
            } catch (err) {
                setErrorMessage("Unable to verify the email link. Please try again.");
                setStatus("error");
            }
        };
        verifyToken();
    }, [
        redirectPath
    ]);
    return /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$60332b2344f7fe41), {
        className: "w-full max-w-md mb-28",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$474db65c3c394e1c), {
                    className: "text-lg md:text-xl flex items-center gap-3",
                    children: [
                        status === "verifying" && "Verifying Email link",
                        status === "success" && /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $RSSjA.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $RSSjA.jsx)("svg", {
                                    className: "h-6 w-6 text-green-600 flex-shrink-0",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $RSSjA.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M5 13l4 4L19 7"
                                    })
                                }),
                                /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                    children: "Welcome Back!"
                                })
                            ]
                        }),
                        status === "error" && /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $RSSjA.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $RSSjA.jsx)("svg", {
                                    className: "h-6 w-6 text-red-600 flex-shrink-0",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $RSSjA.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M6 18L18 6M6 6l12 12"
                                    })
                                }),
                                /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                    children: "Verification Failed"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$64ef9b8c11710c47), {
                className: "pt-2 pb-6",
                children: [
                    status === "verifying" && /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "space-y-4 flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                className: "animate-spin rounded-full h-16 w-16 border-b-2 border-primary"
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                                className: "text-center text-muted-foreground text-sm",
                                children: "Please wait while we verify your email link..."
                            })
                        ]
                    }),
                    status === "success" && /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "space-y-2 animate-in fade-in duration-500",
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                                className: "text-base",
                                children: "Successfully verified!"
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: "Redirecting you now..."
                            })
                        ]
                    }),
                    status === "error" && /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "space-y-6 animate-in fade-in duration-300",
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "space-y-3",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                                        className: "text-base text-foreground",
                                        children: errorMessage
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                                        className: "text-sm text-muted-foreground",
                                        children: "This link may have expired or already been used."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                className: "space-y-3",
                                children: [
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $80ce2cc30ed5cbab$export$353f5b6fc5456de1), {
                                        onClick: ()=>setLocation("/auth/magic-link"),
                                        className: "w-full",
                                        children: "Request New Email link"
                                    }),
                                    /*#__PURE__*/ (0, $RSSjA.jsx)((0, $80ce2cc30ed5cbab$export$353f5b6fc5456de1), {
                                        onClick: ()=>setLocation("/auth/sign-in"),
                                        variant: "outline",
                                        className: "w-full",
                                        children: "Sign In with Password"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $8edff7cab15c34e3$var$SignOutView = ()=>{
    const [, setLocation] = (0, $710ca58b924d6f0b$export$45d76561a5302f2b)();
    (0, $7PdBe.useEffect)(()=>{
        const performSignOut = async ()=>{
            try {
                await (0, $5uSSv.default).logout();
            } catch (error) {
                console.error("Sign out error:", error);
                // Even if logout fails, redirect to sign-in
                setLocation("/auth/sign-in");
            }
        };
        performSignOut();
    }, [
        setLocation
    ]);
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $be19f28f4a94fab4$export$60332b2344f7fe41), {
        className: "w-full max-w-md",
        children: /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $be19f28f4a94fab4$export$64ef9b8c11710c47), {
            className: "pt-6 pb-6 flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                    className: "animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"
                }),
                /*#__PURE__*/ (0, $RSSjA.jsx)("p", {
                    className: "text-center text-muted-foreground",
                    children: "Signing out..."
                })
            ]
        })
    });
};



var $RSSjA = parcelRequire("RSSjA");

var $e6FFD = parcelRequire("e6FFD");
parcelRequire("7PdBe");

var $RSSjA = parcelRequire("RSSjA");

var $e6FFD = parcelRequire("e6FFD");

var $7PdBe = parcelRequire("7PdBe");

var $7PdBe = parcelRequire("7PdBe");
// TYPES
// UTILS
const $050bd9872e54bf11$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $050bd9872e54bf11$export$8793edee2d425525() {
    return undefined;
}
function $050bd9872e54bf11$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $050bd9872e54bf11$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $050bd9872e54bf11$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $050bd9872e54bf11$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $050bd9872e54bf11$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $050bd9872e54bf11$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$050bd9872e54bf11$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $050bd9872e54bf11$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($050bd9872e54bf11$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $050bd9872e54bf11$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $050bd9872e54bf11$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $050bd9872e54bf11$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $050bd9872e54bf11$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $050bd9872e54bf11$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($050bd9872e54bf11$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $050bd9872e54bf11$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$050bd9872e54bf11$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $050bd9872e54bf11$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($050bd9872e54bf11$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($050bd9872e54bf11$export$5fcb678681417b54(mutation.options.mutationKey) !== $050bd9872e54bf11$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$050bd9872e54bf11$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $050bd9872e54bf11$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $050bd9872e54bf11$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $050bd9872e54bf11$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$050bd9872e54bf11$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $050bd9872e54bf11$export$2f07189bb9fa26a7(a, b) {
    return $050bd9872e54bf11$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $050bd9872e54bf11$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$050bd9872e54bf11$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $050bd9872e54bf11$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $050bd9872e54bf11$export$7a8558113332b71e(a) && $050bd9872e54bf11$export$7a8558113332b71e(b);
    if (array || $050bd9872e54bf11$export$53b83ca8eaab0383(a) && $050bd9872e54bf11$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $050bd9872e54bf11$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $050bd9872e54bf11$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $050bd9872e54bf11$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $050bd9872e54bf11$export$53b83ca8eaab0383(o) {
    if (!$050bd9872e54bf11$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$050bd9872e54bf11$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $050bd9872e54bf11$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $050bd9872e54bf11$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $050bd9872e54bf11$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $050bd9872e54bf11$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $050bd9872e54bf11$export$4304cb76768ca134(callback) {
    $050bd9872e54bf11$export$e772c8ff12451969(0).then(callback);
}
function $050bd9872e54bf11$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $050bd9872e54bf11$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $050bd9872e54bf11$export$77a71fc411098696(prevData, data);
    return data;
}


function $9470fc4dba0f530c$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $050bd9872e54bf11$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $050bd9872e54bf11$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $9470fc4dba0f530c$export$520687f44db6e1ab = $9470fc4dba0f530c$export$316a8efd03cd1458();





class $84d81d1e1229099f$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $48a50d26ddc0abfa$export$86f1af424b2ca4de extends (0, $84d81d1e1229099f$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $050bd9872e54bf11$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $48a50d26ddc0abfa$export$6bf54661be5b02cf = new $48a50d26ddc0abfa$export$86f1af424b2ca4de();






const $543519bcdf2eb9c7$var$onlineEvents = [
    "online",
    "offline"
];
class $543519bcdf2eb9c7$export$58774fb55d5ff7fc extends (0, $84d81d1e1229099f$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $050bd9872e54bf11$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $543519bcdf2eb9c7$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $543519bcdf2eb9c7$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $543519bcdf2eb9c7$export$b113e788b2dd3fdc = new $543519bcdf2eb9c7$export$58774fb55d5ff7fc();



function $72c5852a0bdb61b8$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $72c5852a0bdb61b8$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $543519bcdf2eb9c7$export$b113e788b2dd3fdc).isOnline() : true;
}
class $72c5852a0bdb61b8$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $72c5852a0bdb61b8$export$986cc6445c1d323(value) {
    return value instanceof $72c5852a0bdb61b8$export$a8430ed4188f35a9;
}
function $72c5852a0bdb61b8$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $72c5852a0bdb61b8$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $48a50d26ddc0abfa$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $543519bcdf2eb9c7$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $72c5852a0bdb61b8$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $050bd9872e54bf11$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($72c5852a0bdb61b8$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}


class $b69ffc93c589a02c$export$a06cf8c0066f0d4c extends (0, $84d81d1e1229099f$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($b69ffc93c589a02c$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $b69ffc93c589a02c$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $b69ffc93c589a02c$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $050bd9872e54bf11$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $b69ffc93c589a02c$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($b69ffc93c589a02c$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $050bd9872e54bf11$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $050bd9872e54bf11$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $050bd9872e54bf11$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $050bd9872e54bf11$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $050bd9872e54bf11$export$6acf61af03e62db) || this.options.enabled === false || !(0, $050bd9872e54bf11$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $48a50d26ddc0abfa$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $b69ffc93c589a02c$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $b69ffc93c589a02c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $72c5852a0bdb61b8$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $050bd9872e54bf11$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $050bd9872e54bf11$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $b69ffc93c589a02c$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $050bd9872e54bf11$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $72c5852a0bdb61b8$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function $b69ffc93c589a02c$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $b69ffc93c589a02c$var$shouldFetchOnMount(query, options) {
    return $b69ffc93c589a02c$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $b69ffc93c589a02c$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $b69ffc93c589a02c$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $b69ffc93c589a02c$var$isStale(query, options);
    }
    return false;
}
function $b69ffc93c589a02c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $b69ffc93c589a02c$var$isStale(query, options);
}
function $b69ffc93c589a02c$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $b69ffc93c589a02c$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $050bd9872e54bf11$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



class $7d16667c3be9ad02$export$15352e437905ad4c extends (0, $84d81d1e1229099f$export$d26086b469ecdbcc) {
    constructor(client, queries){
        super();
        this.client = client;
        this.queries = [];
        this.result = [];
        this.observers = [];
        this.observersMap = {};
        if (queries) this.setQueries(queries);
    }
    onSubscribe() {
        if (this.listeners.size === 1) this.observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = new Set();
        this.observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, notifyOptions) {
        this.queries = queries;
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            const prevObservers = this.observers;
            const newObserverMatches = this.findMatchingObservers(this.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions, notifyOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newObserversMap = Object.fromEntries(newObservers.map((observer)=>[
                    observer.options.queryHash,
                    observer
                ]));
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            this.observers = newObservers;
            this.observersMap = newObserversMap;
            this.result = newResult;
            if (!this.hasListeners()) return;
            (0, $050bd9872e54bf11$export$acaf96a27438246b)(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            (0, $050bd9872e54bf11$export$acaf96a27438246b)(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    this.onUpdate(observer, result);
                });
            });
            this.notify();
        });
    }
    getCurrentResult() {
        return this.result;
    }
    getQueries() {
        return this.observers.map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return this.observers;
    }
    getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
    }
    findMatchingObservers(queries) {
        const prevObservers = this.observers;
        const prevObserversMap = new Map(prevObservers.map((observer)=>[
                observer.options.queryHash,
                observer
            ]));
        const defaultedQueryOptions = queries.map((options)=>this.client.defaultQueryOptions(options));
        const matchingObservers = defaultedQueryOptions.flatMap((defaultedOptions)=>{
            const match = prevObserversMap.get(defaultedOptions.queryHash);
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        const matchedQueryHashes = new Set(matchingObservers.map((match)=>match.defaultedQueryOptions.queryHash));
        const unmatchedQueries = defaultedQueryOptions.filter((defaultedOptions)=>!matchedQueryHashes.has(defaultedOptions.queryHash));
        const matchingObserversSet = new Set(matchingObservers.map((match)=>match.observer));
        const unmatchedObservers = prevObservers.filter((prevObserver)=>!matchingObserversSet.has(prevObserver));
        const getObserver = (options)=>{
            const defaultedOptions = this.client.defaultQueryOptions(options);
            const currentObserver = this.observersMap[defaultedOptions.queryHash];
            return currentObserver != null ? currentObserver : new (0, $b69ffc93c589a02c$export$a06cf8c0066f0d4c)(this.client, defaultedOptions);
        };
        const newOrReusedObservers = unmatchedQueries.map((options, index)=>{
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                const previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: getObserver(options)
            };
        });
        const sortMatchesByOrderOfQueries = (a, b)=>defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    }
    onUpdate(observer, result) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, $050bd9872e54bf11$export$224e3b7078227b8a)(this.result, index, result);
            this.notify();
        }
    }
    notify() {
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(this.result);
            });
        });
    }
}



"use client";
const $968a7ca492e1a2f6$export$306c0aa65ff9ec16 = (0, $15e9ed60d91245e4$exports.useSyncExternalStore);



var $7PdBe = parcelRequire("7PdBe");
"use client";
const $fd5b90db0c3a799e$export$2fba198b5b2e37fa = /*#__PURE__*/ $7PdBe.createContext(undefined);
const $fd5b90db0c3a799e$var$QueryClientSharingContext = /*#__PURE__*/ $7PdBe.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $fd5b90db0c3a799e$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $fd5b90db0c3a799e$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $fd5b90db0c3a799e$export$2fba198b5b2e37fa;
}
const $fd5b90db0c3a799e$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $7PdBe.useContext($fd5b90db0c3a799e$var$getQueryClientContext(context, $7PdBe.useContext($fd5b90db0c3a799e$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $fd5b90db0c3a799e$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $7PdBe.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $fd5b90db0c3a799e$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $7PdBe.createElement($fd5b90db0c3a799e$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $7PdBe.createElement(Context.Provider, {
        value: client
    }, children));
};



var $7PdBe = parcelRequire("7PdBe");
"use client";
const $6be6b03369342221$var$IsRestoringContext = /*#__PURE__*/ $7PdBe.createContext(false);
const $6be6b03369342221$export$4da0178d6b5f553 = ()=>$7PdBe.useContext($6be6b03369342221$var$IsRestoringContext);
const $6be6b03369342221$export$593807d4e94f9621 = $6be6b03369342221$var$IsRestoringContext.Provider;



var $7PdBe = parcelRequire("7PdBe");
"use client";
function $969a00bf7107e528$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $969a00bf7107e528$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $7PdBe.createContext($969a00bf7107e528$var$createValue()); // HOOK
const $969a00bf7107e528$export$50dfac555130cafd = ()=>$7PdBe.useContext($969a00bf7107e528$var$QueryErrorResetBoundaryContext); // COMPONENT
const $969a00bf7107e528$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $7PdBe.useState(()=>$969a00bf7107e528$var$createValue());
    return /*#__PURE__*/ $7PdBe.createElement($969a00bf7107e528$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};



var $7PdBe = parcelRequire("7PdBe");
function $d9f01935f6dbfbef$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


"use client";
const $31c4b0d19602c6ba$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $31c4b0d19602c6ba$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $7PdBe.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $31c4b0d19602c6ba$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $d9f01935f6dbfbef$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


const $28b9bff5defd132b$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $28b9bff5defd132b$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $28b9bff5defd132b$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $28b9bff5defd132b$export$e0a3f29513afe430(result, isRestoring);
const $28b9bff5defd132b$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


"use client";
function $8388abaf942e494d$export$408667c6c87da1e5({ queries: queries, context: context }) {
    const queryClient = (0, $fd5b90db0c3a799e$export$22e77b9572c4fded)({
        context: context
    });
    const isRestoring = (0, $6be6b03369342221$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $969a00bf7107e528$export$50dfac555130cafd)();
    const defaultedQueries = $7PdBe.useMemo(()=>queries.map((options)=>{
            const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        }), [
        queries,
        queryClient,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, $28b9bff5defd132b$export$2c40a591ad2dafb1)(query);
        (0, $31c4b0d19602c6ba$export$ae8adb3de3d77633)(query, errorResetBoundary);
    });
    (0, $31c4b0d19602c6ba$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $7PdBe.useState(()=>new (0, $7d16667c3be9ad02$export$15352e437905ad4c)(queryClient, defaultedQueries));
    const optimisticResult = observer.getOptimisticResult(defaultedQueries);
    (0, $968a7ca492e1a2f6$export$306c0aa65ff9ec16)($7PdBe.useCallback((onStoreChange)=>isRestoring ? ()=>undefined : observer.subscribe((0, $9470fc4dba0f530c$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $7PdBe.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, $28b9bff5defd132b$export$88d3586dfed64df9)(defaultedQueries[index], result, isRestoring));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const options = defaultedQueries[index];
        const queryObserver = observer.getObservers()[index];
        if (options && queryObserver) {
            if ((0, $28b9bff5defd132b$export$88d3586dfed64df9)(options, result, isRestoring)) return (0, $28b9bff5defd132b$export$defdc11a9c9acfcf)(options, queryObserver, errorResetBoundary);
            else if ((0, $28b9bff5defd132b$export$e0a3f29513afe430)(result, isRestoring)) (0, $28b9bff5defd132b$export$defdc11a9c9acfcf)(options, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const observerQueries = observer.getQueries();
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        var _defaultedQueries$ind, _defaultedQueries$ind2;
        return (0, $31c4b0d19602c6ba$export$1fbcf724762d607)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            useErrorBoundary: (_defaultedQueries$ind = (_defaultedQueries$ind2 = defaultedQueries[index]) == null ? void 0 : _defaultedQueries$ind2.useErrorBoundary) != null ? _defaultedQueries$ind : false,
            query: observerQueries[index]
        });
    });
    if (firstSingleResultWhichShouldThrow != null && firstSingleResultWhichShouldThrow.error) throw firstSingleResultWhichShouldThrow.error;
    return optimisticResult;
}


var $1ca6cd2065bda0d5$exports = {};

(function(global, factory) {
    factory($1ca6cd2065bda0d5$exports, (parcelRequire("7PdBe")));
})($1ca6cd2065bda0d5$exports, function(exports1, React) {
    "use strict";
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === "function") return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



var $RSSjA = parcelRequire("RSSjA");
parcelRequire("7PdBe");
var $af42b777c5f29f29$export$2e2bcd8739ae039 = ()=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
        className: "fa fa-spinner fa-spin",
        style: {
            margin: 0
        }
    });
};


parcelRequire("dBifK");

var $kAeQh = parcelRequire("kAeQh");
parcelRequire("X1RuM");
var $b2r1H = parcelRequire("b2r1H");
var $fa4d6aaef4fef497$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(({ queryIds: queryIds, children: children, loading: loading })=>{
    const { reset: reset } = (0, $969a00bf7107e528$export$50dfac555130cafd)();
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $1ca6cd2065bda0d5$exports.ErrorBoundary), {
        onReset: reset,
        fallbackRender: ({ error: error, resetErrorBoundary: resetErrorBoundary })=>{
            return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                children: [
                    "There was an error!",
                    /*#__PURE__*/ (0, $RSSjA.jsx)("button", {
                        className: "btn btn-default",
                        style: {
                            padding: "0.25em 0.5em",
                            marginLeft: "0.5em",
                            fontSize: "0.9em"
                        },
                        onClick: ()=>resetErrorBoundary(),
                        children: "Try again"
                    })
                ]
            });
        },
        children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $7PdBe.Suspense), {
            fallback: loading || /*#__PURE__*/ (0, $RSSjA.jsx)((0, $af42b777c5f29f29$export$2e2bcd8739ae039), {}),
            children: /*#__PURE__*/ (0, $RSSjA.jsx)($fa4d6aaef4fef497$var$RenderItems, {
                queryIds: queryIds,
                children: children
            }, queryIds)
        })
    });
});
const $fa4d6aaef4fef497$var$RenderItems = (0, $e6FFD.observer)(({ queryIds: queryIds, children: children })=>{
    const queryResults = (0, $8388abaf942e494d$export$408667c6c87da1e5)({
        queries: queryIds.map((qId)=>{
            return {
                queryKey: (0, $b2r1H.default)(qId) ? qId : [
                    (qId === null || qId === void 0 ? void 0 : qId.id) || qId
                ],
                queryFn: qId.queryFn ? async ()=>await qId.queryFn() : async ()=>await (0, $kAeQh.makeRequest)(qId),
                staleTime: qId.staleTime || 0,
                cacheTime: qId.cacheTime || 0,
                retry: 3
            };
        })
    });
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $RSSjA.Fragment), {
        children: children
    });
});


parcelRequire("5uSSv");
parcelRequire("7PdBe");

var $egx7S = parcelRequire("egx7S");

var $cuB2x = parcelRequire("cuB2x");

var $dBifK = parcelRequire("dBifK");

var $RSSjA = parcelRequire("RSSjA");

var $e6FFD = parcelRequire("e6FFD");
parcelRequire("7PdBe");

var $RSSjA = parcelRequire("RSSjA");

var $e6FFD = parcelRequire("e6FFD");

var $7PdBe = parcelRequire("7PdBe");

var $7abd3504f35f78d9$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(({ title: title, label: label, items: items, onChange: onChange, backRoute: backRoute, sortBy: sortBy })=>{
    const [search, setSearch] = (0, $7PdBe.useState)("");
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                className: "top-nav",
                style: {
                    borderBottom: "1px solid #ccc"
                },
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                        className: "nav-btn right"
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "nav-title",
                        children: [
                            "Select ",
                            title,
                            " Below"
                        ]
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                        className: "nav-btn right",
                        onClick: ()=>{
                            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setRoute("listEntries");
                            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).resetSelection();
                        },
                        children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                            className: "fa fa-times"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                style: {
                    marginTop: "-4.8em"
                },
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                        className: "project-input",
                        style: {
                            padding: "1rem",
                            backgroundColor: "#f2f2f2"
                        },
                        children: /*#__PURE__*/ (0, $RSSjA.jsx)("input", {
                            type: "text",
                            value: search,
                            onChange: (e)=>setSearch(e.target.value),
                            placeholder: "Search...",
                            style: {
                                fontSize: "1.5em",
                                letterSpacing: "0.1em",
                                fontStyle: "italic"
                            }
                        })
                    }),
                    [
                        ...items
                    ].sort((a, b)=>{
                        var _a$label, _a$label$localeCompar;
                        return (_a$label = a[label]) === null || _a$label === void 0 ? void 0 : (_a$label$localeCompar = _a$label.localeCompare) === null || _a$label$localeCompar === void 0 ? void 0 : _a$label$localeCompar.call(_a$label, b[label]);
                    }).sort((a, b)=>{
                        var _a$label2, _a$label2$localeCompa;
                        if (sortBy && a[sortBy] && b[sortBy]) return a[sortBy] > b[sortBy] ? 1 : -1;
                        return (_a$label2 = a[label]) === null || _a$label2 === void 0 ? void 0 : (_a$label2$localeCompa = _a$label2.localeCompare) === null || _a$label2$localeCompa === void 0 ? void 0 : _a$label2$localeCompa.call(_a$label2, b[label]);
                    }).filter((item)=>item[label].toLowerCase().includes(search.toLowerCase())).map(function(item, i) {
                        return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                            className: "project",
                            onClick: ()=>onChange(item),
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                className: "project-sel",
                                children: /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                    className: "project-text",
                                    children: /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                        className: "add-entry-form__item",
                                        children: item[label]
                                    })
                                })
                            })
                        }, i);
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                        style: {
                            borderBottom: "solid 1px #ccc"
                        },
                        children: /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                            className: "project-btn",
                            onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setRoute(backRoute),
                            children: "<< Back"
                        })
                    })
                ]
            })
        ]
    });
});



var $hy8Zj = parcelRequire("hy8Zj");


var $kdO1A = parcelRequire("kdO1A");

var $4iD0l = parcelRequire("4iD0l");

var $5uSSv = parcelRequire("5uSSv");
var $6e51b6e248dbe48e$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(()=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $7abd3504f35f78d9$export$2e2bcd8739ae039), {
        title: "Cost Centre",
        label: "name",
        items: (0, $hy8Zj.default).costCentres.filter((cc)=>((0, $kdO1A.default).projectsByCostCentreId[cc.id] || []).filter((p)=>(0, $4iD0l.canEnterTimeAgainstProject)((0, $5uSSv.default).user, p)).length),
        backRoute: "listEntries",
        onChange: (costCentre)=>{
            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectCostCentre(costCentre);
            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setRoute("selectProject");
        }
    });
});



var $RSSjA = parcelRequire("RSSjA");

var $e6FFD = parcelRequire("e6FFD");
parcelRequire("7PdBe");

parcelRequire("hy8Zj");


var $kdO1A = parcelRequire("kdO1A");

var $4iD0l = parcelRequire("4iD0l");

var $5uSSv = parcelRequire("5uSSv");
var $03bd62a1a14aff2d$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(()=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $7abd3504f35f78d9$export$2e2bcd8739ae039), {
        title: "Projects",
        label: "title",
        items: (0, $kdO1A.default).projectsByCostCentreId[(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedCostCentre.id].filter((p)=>(0, $4iD0l.canEnterTimeAgainstProject)((0, $5uSSv.default).user, p)) || [],
        backRoute: "selectCostCentre",
        onChange: (project)=>{
            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectProject(project);
            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setRoute("selectPhase");
        }
    });
});



var $RSSjA = parcelRequire("RSSjA");

var $e6FFD = parcelRequire("e6FFD");
parcelRequire("7PdBe");




var $4iD0l = parcelRequire("4iD0l");

var $5uSSv = parcelRequire("5uSSv");

var $b8BPd = parcelRequire("b8BPd");
parcelRequire("kAeQh");

var $kR2qW = parcelRequire("kR2qW");
parcelRequire("5uSSv");
parcelRequire("dBifK");

var $d8hWe = parcelRequire("d8hWe");
var $f58aceb3c3c6d7eb$var$_class, $f58aceb3c3c6d7eb$var$_descriptor;
function $f58aceb3c3c6d7eb$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $f58aceb3c3c6d7eb$var$_defineProperty(e, r, t) {
    return (r = $f58aceb3c3c6d7eb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f58aceb3c3c6d7eb$var$_toPropertyKey(t) {
    var i = $f58aceb3c3c6d7eb$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f58aceb3c3c6d7eb$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f58aceb3c3c6d7eb$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $f58aceb3c3c6d7eb$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $f58aceb3c3c6d7eb$var$FetchStoreClass = ($f58aceb3c3c6d7eb$var$_class = class FetchStoreClass {
    constructor(){
        $f58aceb3c3c6d7eb$var$_initializerDefineProperty(this, "lookup", $f58aceb3c3c6d7eb$var$_descriptor, this);
        (0, $d8hWe.makeObservable)(this);
    }
    setResponse(id, response) {
        this.lookup[id] = response;
    }
    getResponse(id) {
        return this.lookup[id];
    }
    deleteResponse(id) {
        delete this.lookup[id];
    }
}, $f58aceb3c3c6d7eb$var$_descriptor = $f58aceb3c3c6d7eb$var$_applyDecoratedDescriptor($f58aceb3c3c6d7eb$var$_class.prototype, "lookup", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $f58aceb3c3c6d7eb$var$_applyDecoratedDescriptor($f58aceb3c3c6d7eb$var$_class.prototype, "setResponse", [
    (0, $d8hWe.action)
], Object.getOwnPropertyDescriptor($f58aceb3c3c6d7eb$var$_class.prototype, "setResponse"), $f58aceb3c3c6d7eb$var$_class.prototype), $f58aceb3c3c6d7eb$var$_applyDecoratedDescriptor($f58aceb3c3c6d7eb$var$_class.prototype, "deleteResponse", [
    (0, $d8hWe.action)
], Object.getOwnPropertyDescriptor($f58aceb3c3c6d7eb$var$_class.prototype, "deleteResponse"), $f58aceb3c3c6d7eb$var$_class.prototype), $f58aceb3c3c6d7eb$var$_class);
var $f58aceb3c3c6d7eb$export$2e2bcd8739ae039 = new $f58aceb3c3c6d7eb$var$FetchStoreClass();


parcelRequire("4iD0l");

var $flyUR = parcelRequire("flyUR");

var $f9Rb7 = parcelRequire("f9Rb7");
const $b1d2146eeffbc838$export$93e54950f4ca4b28 = (data, id = null)=>{
    if (!data) {
        console.error("processTRPCData received null or undefined data");
        return {};
    }
    const models = {};
    let returnRawData = true;
    Object.entries(data).forEach(([collectionName, modelsData])=>{
        if (!modelsData || collectionName === "labels") return;
        // Determine the correct collection name (handling potential aliases if needed in future)
        const rCollection = collectionName; // Simple mapping for now
        if (!(0, $kR2qW.CollectionLookup)[rCollection] && !(0, $kR2qW.AggregateCollectionLookup)[rCollection]) return; // Skip if no corresponding store
        try {
            // Check if this collection should be treated as aggregated (based on name or structure if needed)
            // For now, assuming all data from getAppData is non-aggregated
            const isAggregated = false; // Adjust if getAppData returns aggregated formats
            if (!isAggregated) {
                if ((0, $kR2qW.CollectionLookup)[rCollection]) {
                    var _models$rCollection;
                    (0, $kR2qW.CollectionLookup)[rCollection].addMany(modelsData, {
                        trackUpdates: false
                    });
                    (_models$rCollection = models[rCollection]) !== null && _models$rCollection !== void 0 ? _models$rCollection : models[rCollection] = new (0, $kR2qW.CollectionClassLookup)[rCollection]();
                    // Ensure modelsData is an array before calling addMany
                    const dataArray = Array.isArray(modelsData) ? modelsData : modelsData ? [
                        modelsData
                    ] : [];
                    models[rCollection].addMany(dataArray, {
                        trackUpdates: false
                    });
                    returnRawData = false;
                } else console.warn(`CollectionLookup[${rCollection}] not found, but not aggregated.`);
            } else // Handle aggregated data if necessary (requires groupBy info)
            // This part is complex as groupBy info isn't directly in getAppData response
            // Might need to refactor or avoid using this function for aggregated data initially
            console.warn(`Processing aggregated data for ${rCollection} not fully implemented in processTRPCData yet.`);
        } catch (e) {
            $flyUR.captureException(e);
            (0, $f9Rb7.default).captureException(e);
            console.error(`Error processing collection ${rCollection} in processTRPCData:`, e);
        // Decide if we should throw or just log and continue
        }
    });
    // Optionally, could set response in FetchStore if needed, but maybe not necessary
    if (id) (0, $f58aceb3c3c6d7eb$export$2e2bcd8739ae039).setResponse(id, returnRawData ? data : models);
    return returnRawData ? data : models;
};
function $b1d2146eeffbc838$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


var $e263e84e717f43e4$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(()=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $fa4d6aaef4fef497$export$2e2bcd8739ae039), {
        queryIds: [
            {
                id: `phases-${(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedProject.id}`,
                queryFn: async ()=>{
                    const requestData = await (0, $b8BPd.trpc).legacy.getProjectPhases.query({
                        projectId: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedProject.id
                    });
                    return (0, $b1d2146eeffbc838$export$93e54950f4ca4b28)(requestData, `phases-${(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedProject.id}`);
                }
            }
        ],
        children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $7abd3504f35f78d9$export$2e2bcd8739ae039), {
            title: "Phase",
            label: "title",
            sortBy: "startDate",
            items: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedProject.phases.filter((p)=>(0, $4iD0l.canEnterTimeAgainstPhase)((0, $5uSSv.default).user, p)) || [],
            backRoute: "selectProject",
            onChange: (phase)=>{
                (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectPhase(phase);
                (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setRoute("selectTask");
            }
        })
    });
});



var $RSSjA = parcelRequire("RSSjA");

var $e6FFD = parcelRequire("e6FFD");
parcelRequire("7PdBe");





var $b8BPd = parcelRequire("b8BPd");
var $e5d065d55d42f466$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(()=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $fa4d6aaef4fef497$export$2e2bcd8739ae039), {
        queryIds: [
            {
                id: `tasks-${(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedPhase.id}`,
                queryFn: async ()=>{
                    const requestData = await (0, $b8BPd.trpc).legacy.getTasks.query({
                        projectId: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedProject.id,
                        phaseId: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedPhase.id
                    });
                    return (0, $b1d2146eeffbc838$export$93e54950f4ca4b28)(requestData, `tasks-${(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedPhase.id}`);
                }
            }
        ],
        children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $7abd3504f35f78d9$export$2e2bcd8739ae039), {
            title: "Task",
            label: "name",
            items: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedPhase.tasks || [],
            backRoute: "selectPhase",
            onChange: (task)=>{
                (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectTask(task);
                (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).createTimeEntry();
                (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setRoute("listEntries");
            }
        })
    });
});



var $RSSjA = parcelRequire("RSSjA");

var $e6FFD = parcelRequire("e6FFD");
parcelRequire("7PdBe");


var $5uSSv = parcelRequire("5uSSv");
parcelRequire("61cVC");


var $egx7S = parcelRequire("egx7S");

var $ksXgP = parcelRequire("ksXgP");

var $4bOnx = parcelRequire("4bOnx");

var $RSSjA = parcelRequire("RSSjA");

var $7PdBe = parcelRequire("7PdBe");

var $cuB2x = parcelRequire("cuB2x");


var $e6FFD = parcelRequire("e6FFD");

var $4bOnx = parcelRequire("4bOnx");
parcelRequire("8GlSR");

var $5uSSv = parcelRequire("5uSSv");

var $ksXgP = parcelRequire("ksXgP");
parcelRequire("1xzA7");

var $d8hWe = parcelRequire("d8hWe");

var $kR2qW = parcelRequire("kR2qW");

var $b8BPd = parcelRequire("b8BPd");
var $755ff9b392d4d3e8$var$_dec, $755ff9b392d4d3e8$var$_dec2, $755ff9b392d4d3e8$var$_dec3, $755ff9b392d4d3e8$var$_dec4, $755ff9b392d4d3e8$var$_dec5, $755ff9b392d4d3e8$var$_dec6, $755ff9b392d4d3e8$var$_dec7, $755ff9b392d4d3e8$var$_class, $755ff9b392d4d3e8$var$_descriptor, $755ff9b392d4d3e8$var$_descriptor2, $755ff9b392d4d3e8$var$_descriptor3, $755ff9b392d4d3e8$var$_descriptor4, $755ff9b392d4d3e8$var$_descriptor5, $755ff9b392d4d3e8$var$_descriptor6;
function $755ff9b392d4d3e8$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $755ff9b392d4d3e8$var$_defineProperty(e, r, t) {
    return (r = $755ff9b392d4d3e8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $755ff9b392d4d3e8$var$_toPropertyKey(t) {
    var i = $755ff9b392d4d3e8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $755ff9b392d4d3e8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $755ff9b392d4d3e8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $755ff9b392d4d3e8$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $755ff9b392d4d3e8$var$DataStore = ($755ff9b392d4d3e8$var$_dec = (0, $d8hWe.action).bound, $755ff9b392d4d3e8$var$_dec2 = (0, $d8hWe.action).bound, $755ff9b392d4d3e8$var$_dec3 = (0, $d8hWe.action).bound, $755ff9b392d4d3e8$var$_dec4 = (0, $d8hWe.action).bound, $755ff9b392d4d3e8$var$_dec5 = (0, $d8hWe.action).bound, $755ff9b392d4d3e8$var$_dec6 = (0, $d8hWe.action).bound, $755ff9b392d4d3e8$var$_dec7 = (0, $d8hWe.action).bound, $755ff9b392d4d3e8$var$_class = class DataStore {
    constructor(props){
        $755ff9b392d4d3e8$var$_initializerDefineProperty(this, "state", $755ff9b392d4d3e8$var$_descriptor, this);
        // fetching, success, error
        $755ff9b392d4d3e8$var$_initializerDefineProperty(this, "rawData", $755ff9b392d4d3e8$var$_descriptor2, this);
        $755ff9b392d4d3e8$var$_initializerDefineProperty(this, "saveState", $755ff9b392d4d3e8$var$_descriptor3, this);
        $755ff9b392d4d3e8$var$_initializerDefineProperty(this, "autosave", $755ff9b392d4d3e8$var$_descriptor4, this);
        $755ff9b392d4d3e8$var$_initializerDefineProperty(this, "circularSaveAttempts", $755ff9b392d4d3e8$var$_descriptor5, this);
        $755ff9b392d4d3e8$var$_initializerDefineProperty(this, "idsToSave", $755ff9b392d4d3e8$var$_descriptor6, this);
        (0, $d8hWe.makeObservable)(this);
        (0, $d8hWe.reaction)(()=>this.needsSaving, this.whenNeedsSaving);
        // autosave
        (0, $d8hWe.reaction)(()=>this.needsSaving, this.startAutosave);
    }
    setAutosave(autosave) {
        this.autosave = autosave;
    }
    async startAutosave() {
        if (this.autosave) this.startSave();
    }
    whenNeedsSaving() {
        if (this.needsSaving) this.saveState = "needsSaving";
    }
    get needsSaving() {
        return (0, $kR2qW.autoSaveCollections).some((c)=>c.needsSaving);
    }
    async retrySave() {
        this.saveState = "idle";
        await this.startSave();
    }
    async startSave() {
        if (this.needsSaving && this.saveState !== "saving" && this.saveState !== "error") {
            this.saveState = "saving";
            const savedAt = Date.now();
            const saveData = {};
            const modals = {};
            try {
                const idsToSave = new Set((0, $kR2qW.autoSaveCollections).map((c)=>{
                    return c.modelsToSave.map((m)=>m.id);
                }).flat());
                if (idsToSave.size === this.idsToSave.size && [
                    ...idsToSave
                ].every((item)=>this.idsToSave.has(item))) {
                    if (this.circularSaveAttempts > 10) {
                        this.idsToSave = new Set();
                        throw new Error("Circular Save");
                    } else {
                        this.circularSaveAttempts += 1;
                        this.idsToSave = idsToSave;
                    }
                } else this.idsToSave = idsToSave;
                (0, $kR2qW.autoSaveCollections).forEach((c)=>{
                    if (c.needsSaving) saveData[c.collection] = c.modelsToSave.map((m)=>this.serializeModel(m)).filter((d)=>d);
                });
                const newIds = await (0, $b8BPd.trpc).legacy.saveData.mutate(saveData);
                let replaceUrl = null;
                Object.entries(newIds).forEach(([collection, idLookup])=>{
                    const c = (0, $kR2qW.CollectionLookup)[collection];
                    Object.values(idLookup).forEach((id)=>{
                        c.update(id, {}, {
                            trackUpdates: false,
                            savedAt: savedAt
                        });
                    });
                });
                this.saveState = "success";
                this.idsToSave = new Set();
                this.circularSaveAttempts = 0;
                if (this.needsSaving) this.startSave();
                else setTimeout(()=>{
                    if (this.saveState === "success") this.saveState = "idle";
                }, 1000);
                if (replaceUrl) //TODO - do a nicer version of this in the future
                window.location.navigate(replaceUrl);
            } catch (e) {
                console.error(e.message);
                this.saveState = "error";
            }
        }
    }
    serializeModel(model) {
        // if (!SessionStore.canEditModel(model))
        //     throw new Error('Cannot Edit Model')
        let data = model.serializeUpdates();
        // if (
        //     data.createdAt &&
        //     !SessionStore.canCreateInCollection(model.collection.collection)
        // )
        //     throw new Error('Cannot Create Model')
        // if (
        //     data.deletedAt &&
        //     !SessionStore.canDeleteInCollection(model.collection.collection)
        // )
        //     throw new Error('Cannot Delete Model')
        Object.keys(data).forEach((field)=>{
            if ([
                "id",
                "id",
                "updatedAt",
                "deletedAt",
                "createdAt"
            ].includes(field)) return;
        // if (!SessionStore.canEditField(model, field)) {
        //     delete data[field]
        // }
        });
        return data;
    }
    async saveModel(model) {
        this.saveState = "saving";
        const savedAt = Date.now();
        const saveData = {};
        try {
            saveData[model.collection.collection] = [
                this.serializeModel(model)
            ];
            const newIds = await (0, $b8BPd.trpc).legacy.saveData.mutate(saveData);
            !model.detached && Object.entries(newIds).forEach(([collection, idLookup])=>{
                const c = (0, $kR2qW.CollectionLookup)[collection];
                Object.values(idLookup).forEach((id)=>{
                    c.update(id, {}, {
                        trackUpdates: false,
                        savedAt: savedAt
                    });
                });
            });
            this.saveState = "success";
            if (this.needsSaving) this.startSave();
            else setTimeout(()=>{
                if (this.saveState === "success") this.saveState = "idle";
            }, 1000);
        } catch (e) {
            console.error(e.message);
            this.saveState = "error";
        }
    }
}, $755ff9b392d4d3e8$var$_descriptor = $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "state", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "uninitialized";
    }
}), $755ff9b392d4d3e8$var$_descriptor2 = $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "rawData", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return {};
    }
}), $755ff9b392d4d3e8$var$_descriptor3 = $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "saveState", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $755ff9b392d4d3e8$var$_descriptor4 = $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "autosave", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $755ff9b392d4d3e8$var$_descriptor5 = $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "circularSaveAttempts", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $755ff9b392d4d3e8$var$_descriptor6 = $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "idsToSave", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return new Set();
    }
}), $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "setAutosave", [
    $755ff9b392d4d3e8$var$_dec
], Object.getOwnPropertyDescriptor($755ff9b392d4d3e8$var$_class.prototype, "setAutosave"), $755ff9b392d4d3e8$var$_class.prototype), $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "startAutosave", [
    $755ff9b392d4d3e8$var$_dec2
], Object.getOwnPropertyDescriptor($755ff9b392d4d3e8$var$_class.prototype, "startAutosave"), $755ff9b392d4d3e8$var$_class.prototype), $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "whenNeedsSaving", [
    $755ff9b392d4d3e8$var$_dec3
], Object.getOwnPropertyDescriptor($755ff9b392d4d3e8$var$_class.prototype, "whenNeedsSaving"), $755ff9b392d4d3e8$var$_class.prototype), $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "needsSaving", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($755ff9b392d4d3e8$var$_class.prototype, "needsSaving"), $755ff9b392d4d3e8$var$_class.prototype), $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "retrySave", [
    $755ff9b392d4d3e8$var$_dec4
], Object.getOwnPropertyDescriptor($755ff9b392d4d3e8$var$_class.prototype, "retrySave"), $755ff9b392d4d3e8$var$_class.prototype), $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "startSave", [
    $755ff9b392d4d3e8$var$_dec5
], Object.getOwnPropertyDescriptor($755ff9b392d4d3e8$var$_class.prototype, "startSave"), $755ff9b392d4d3e8$var$_class.prototype), $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "serializeModel", [
    $755ff9b392d4d3e8$var$_dec6
], Object.getOwnPropertyDescriptor($755ff9b392d4d3e8$var$_class.prototype, "serializeModel"), $755ff9b392d4d3e8$var$_class.prototype), $755ff9b392d4d3e8$var$_applyDecoratedDescriptor($755ff9b392d4d3e8$var$_class.prototype, "saveModel", [
    $755ff9b392d4d3e8$var$_dec7
], Object.getOwnPropertyDescriptor($755ff9b392d4d3e8$var$_class.prototype, "saveModel"), $755ff9b392d4d3e8$var$_class.prototype), $755ff9b392d4d3e8$var$_class);
var $755ff9b392d4d3e8$export$2e2bcd8739ae039 = new $755ff9b392d4d3e8$var$DataStore();
function $755ff9b392d4d3e8$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}



var $d8hWe = parcelRequire("d8hWe");

parcelRequire("1xzA7");
parcelRequire("hiuv4");
parcelRequire("5uSSv");
parcelRequire("kdO1A");
parcelRequire("9Lw71");
parcelRequire("cuB2x");

parcelRequire("iCTvZ");
var $621605b590fb8e7f$var$_dec, $621605b590fb8e7f$var$_dec2, $621605b590fb8e7f$var$_dec3, $621605b590fb8e7f$var$_dec4, $621605b590fb8e7f$var$_dec5, $621605b590fb8e7f$var$_class, $621605b590fb8e7f$var$_descriptor, $621605b590fb8e7f$var$_descriptor2, $621605b590fb8e7f$var$_descriptor3, $621605b590fb8e7f$var$_descriptor4, $621605b590fb8e7f$var$_descriptor5, $621605b590fb8e7f$var$_descriptor6;
function $621605b590fb8e7f$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $621605b590fb8e7f$var$_defineProperty(e, r, t) {
    return (r = $621605b590fb8e7f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $621605b590fb8e7f$var$_toPropertyKey(t) {
    var i = $621605b590fb8e7f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $621605b590fb8e7f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $621605b590fb8e7f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $621605b590fb8e7f$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $621605b590fb8e7f$var$TimerStore = ($621605b590fb8e7f$var$_dec = (0, $d8hWe.action).bound, $621605b590fb8e7f$var$_dec2 = (0, $d8hWe.action).bound, $621605b590fb8e7f$var$_dec3 = (0, $d8hWe.action).bound, $621605b590fb8e7f$var$_dec4 = (0, $d8hWe.action).bound, $621605b590fb8e7f$var$_dec5 = (0, $d8hWe.action).bound, $621605b590fb8e7f$var$_class = class TimerStore {
    constructor(){
        $621605b590fb8e7f$var$_initializerDefineProperty(this, "timerState", $621605b590fb8e7f$var$_descriptor, this);
        $621605b590fb8e7f$var$_initializerDefineProperty(this, "saveState", $621605b590fb8e7f$var$_descriptor2, this);
        $621605b590fb8e7f$var$_initializerDefineProperty(this, "selectedTimeEntry", $621605b590fb8e7f$var$_descriptor3, this);
        $621605b590fb8e7f$var$_initializerDefineProperty(this, "prevSeconds", $621605b590fb8e7f$var$_descriptor4, this);
        $621605b590fb8e7f$var$_initializerDefineProperty(this, "startTime", $621605b590fb8e7f$var$_descriptor5, this);
        $621605b590fb8e7f$var$_initializerDefineProperty(this, "currentTime", $621605b590fb8e7f$var$_descriptor6, this);
        $621605b590fb8e7f$var$_defineProperty(this, "timerInterval", null);
        (0, $d8hWe.makeObservable)(this);
    }
    tick() {
        this.currentTime = new Date();
    }
    startTimer() {
        clearInterval(this.timerInterval);
        this.startTime = new Date();
        this.timerInterval = setInterval(this.tick, 1000);
        this.timerState = "running";
    }
    pauseTimer() {
        this.prevSeconds = this.seconds;
        // this.startTime = null;
        this.currentTime = null;
        clearInterval(this.timerInterval);
        this.timerState = "idle";
    }
    resetTimer() {
        this.pauseTimer();
        this.prevSeconds = 0;
    }
    get currentSeconds() {
        return this.startTime && this.currentTime ? (this.currentTime - this.startTime) / 1000 : 0;
    }
    get seconds() {
        return this.prevSeconds + this.currentSeconds;
    }
    get timeDisplay() {
        return new Date(this.seconds * 1000).toISOString().substr(12, 7);
    }
    setSelectedTimeEntry(timeEntry) {
        this.selectedTimeEntry = timeEntry;
        this.prevSeconds = ((timeEntry === null || timeEntry === void 0 ? void 0 : timeEntry.numMinutes) || 0) * 60;
    }
}, $621605b590fb8e7f$var$_descriptor = $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "timerState", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $621605b590fb8e7f$var$_descriptor2 = $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "saveState", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "idle";
    }
}), $621605b590fb8e7f$var$_descriptor3 = $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "selectedTimeEntry", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $621605b590fb8e7f$var$_descriptor4 = $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "prevSeconds", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $621605b590fb8e7f$var$_descriptor5 = $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "startTime", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $621605b590fb8e7f$var$_descriptor6 = $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "currentTime", [
    (0, $d8hWe.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "tick", [
    $621605b590fb8e7f$var$_dec
], Object.getOwnPropertyDescriptor($621605b590fb8e7f$var$_class.prototype, "tick"), $621605b590fb8e7f$var$_class.prototype), $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "startTimer", [
    $621605b590fb8e7f$var$_dec2
], Object.getOwnPropertyDescriptor($621605b590fb8e7f$var$_class.prototype, "startTimer"), $621605b590fb8e7f$var$_class.prototype), $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "pauseTimer", [
    $621605b590fb8e7f$var$_dec3
], Object.getOwnPropertyDescriptor($621605b590fb8e7f$var$_class.prototype, "pauseTimer"), $621605b590fb8e7f$var$_class.prototype), $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "resetTimer", [
    $621605b590fb8e7f$var$_dec4
], Object.getOwnPropertyDescriptor($621605b590fb8e7f$var$_class.prototype, "resetTimer"), $621605b590fb8e7f$var$_class.prototype), $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "currentSeconds", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($621605b590fb8e7f$var$_class.prototype, "currentSeconds"), $621605b590fb8e7f$var$_class.prototype), $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "seconds", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($621605b590fb8e7f$var$_class.prototype, "seconds"), $621605b590fb8e7f$var$_class.prototype), $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "timeDisplay", [
    (0, $d8hWe.computed)
], Object.getOwnPropertyDescriptor($621605b590fb8e7f$var$_class.prototype, "timeDisplay"), $621605b590fb8e7f$var$_class.prototype), $621605b590fb8e7f$var$_applyDecoratedDescriptor($621605b590fb8e7f$var$_class.prototype, "setSelectedTimeEntry", [
    $621605b590fb8e7f$var$_dec5
], Object.getOwnPropertyDescriptor($621605b590fb8e7f$var$_class.prototype, "setSelectedTimeEntry"), $621605b590fb8e7f$var$_class.prototype), $621605b590fb8e7f$var$_class);
var $621605b590fb8e7f$export$2e2bcd8739ae039 = new $621605b590fb8e7f$var$TimerStore();


var $6d7342b4c46a0d7f$export$2e2bcd8739ae039 = ()=>{
    return ((0, $cuB2x.default).timeEntriesByDate[(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedDate.getTime()] || []).map((te)=>/*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$TimesheetItem, {
            timesheetEntry: te,
            path: te.id
        }, te.id));
};
const $6d7342b4c46a0d7f$var$TimesheetItem = (0, $e6FFD.observer)(({ timesheetEntry: timesheetEntry })=>{
    var _timesheetEntry$costC, _timesheetEntry$proje, _timesheetEntry$phase, _timesheetEntry$task, _timesheetEntry$task2;
    const budgetHours = false;
    const progressPercent = 50;
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: "timesheet-entry project",
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                className: "project-sel",
                onClick: ()=>{
                    (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectTimeEntry(timesheetEntry);
                    (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState((0, $621605b590fb8e7f$export$2e2bcd8739ae039).selectedTimeEntry === timesheetEntry ? "timer" : "select");
                },
                style: {
                    position: "relative",
                    paddingBottom: "0.5em"
                },
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "project-text",
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "cc-name",
                                children: ((_timesheetEntry$costC = timesheetEntry.costCentre) === null || _timesheetEntry$costC === void 0 ? void 0 : _timesheetEntry$costC.name) || "(No cost centre)"
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-name",
                                children: ((_timesheetEntry$proje = timesheetEntry.project) === null || _timesheetEntry$proje === void 0 ? void 0 : _timesheetEntry$proje.title) || "(No project)"
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsxs)("span", {
                                className: "ph-name",
                                children: [
                                    !timesheetEntry.isBillable ? /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                        className: "fa-stack",
                                        style: {
                                            fontSize: "0.7em",
                                            marginRight: "0.4em",
                                            display: "inline-block"
                                        },
                                        children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                            className: "fa fa-ban fa-stack-2x"
                                        })
                                    }) : null,
                                    timesheetEntry.isVariation ? /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                        className: "fa fa-code-fork",
                                        style: {
                                            fontSize: "1.3em",
                                            position: "relative",
                                            top: "0.15em"
                                        }
                                    }) : null,
                                    /*#__PURE__*/ (0, $RSSjA.jsxs)("span", {
                                        style: {
                                            marginLeft: "0.5em",
                                            display: "inline-block"
                                        },
                                        children: [
                                            ((_timesheetEntry$phase = timesheetEntry.phase) === null || _timesheetEntry$phase === void 0 ? void 0 : _timesheetEntry$phase.title) || "(No phase)",
                                            timesheetEntry.task && ((_timesheetEntry$task = timesheetEntry.task) === null || _timesheetEntry$task === void 0 ? void 0 : _timesheetEntry$task.name) !== "(No task)" ? ": " + ((_timesheetEntry$task2 = timesheetEntry.task) === null || _timesheetEntry$task2 === void 0 ? void 0 : _timesheetEntry$task2.name) : null,
                                            budgetHours ? ` - ${Math.round(progressPercent)}%` : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                        className: "project-time",
                        children: (0, $621605b590fb8e7f$export$2e2bcd8739ae039).selectedTimeEntry === timesheetEntry ? (0, $621605b590fb8e7f$export$2e2bcd8739ae039).timeDisplay : (0, $4bOnx.formatMinutes)(timesheetEntry.numMinutes)
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        style: {
                            height: "3px",
                            position: "absolute",
                            bottom: "0.5em",
                            left: "1em",
                            right: "1em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                style: {
                                    height: "3px",
                                    backgroundColor: "#ccc",
                                    width: "100%",
                                    position: "absolute",
                                    left: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                style: {
                                    height: "3px",
                                    backgroundColor: `${"red"}`,
                                    width: `${100}%`,
                                    position: "absolute",
                                    left: 0
                                }
                            })
                        ]
                    })
                ]
            }),
            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedTimeEntry === timesheetEntry ? /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$export$5b24287eb037832d, {
                timesheetEntry: timesheetEntry
            }) : null
        ]
    });
});
const $6d7342b4c46a0d7f$export$5b24287eb037832d = (0, $e6FFD.observer)(({ timesheetEntry: timesheetEntry })=>{
    return ({
        select: /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$export$81cc89b4d950255c, {
            timesheetEntry: timesheetEntry
        }),
        timer: /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$TimesheetDropdownTimer, {
            timesheetEntry: timesheetEntry
        }),
        manualEntry: /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$TimesheetDropdownManualEntry, {
            timesheetEntry: timesheetEntry
        }),
        notes: /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$TimesheetDropdownNotes, {
            timesheetEntry: timesheetEntry
        }),
        options: /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$TimesheetDropdownOptions, {
            timesheetEntry: timesheetEntry
        }),
        locked: /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$TimesheetDropdownLocked, {
            timesheetEntry: timesheetEntry
        })
    })[timesheetEntry.isLocked ? "locked" : (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).dropdownState || "select"];
});
const $6d7342b4c46a0d7f$export$81cc89b4d950255c = (0, $e6FFD.observer)(({ timesheetEntry: timesheetEntry })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        className: "project-dropdown",
        children: /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
            className: "project-options",
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                    className: "pr-opt",
                    onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("timer"),
                    children: [
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-icon timer",
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                className: "fa fa-play",
                                children: " "
                            })
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-label",
                            children: "Start Timer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                    className: "enter-time-button pr-opt",
                    onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("manualEntry"),
                    children: [
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-icon input",
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                className: "fa fa-clock-o",
                                children: " "
                            })
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-label",
                            children: "Enter Time"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                    className: "pr-opt",
                    onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("notes"),
                    children: [
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-icon notes",
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                className: "fa fa-sticky-note",
                                children: " "
                            })
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-label",
                            children: "Add Note"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                    className: "pr-opt",
                    onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("options"),
                    children: [
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-icon time-options",
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                className: "fa fa-code-fork",
                                children: " "
                            })
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-label",
                            children: "Time Options"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                    className: "pr-opt",
                    onClick: ()=>{
                        (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).deleteTimeEntry(timesheetEntry);
                        (0, $755ff9b392d4d3e8$export$2e2bcd8739ae039).saveModel(timesheetEntry);
                    },
                    children: [
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-icon delete",
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                className: "fa fa-times",
                                children: " "
                            })
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                            className: "pr-opt-label",
                            children: "Delete Entry"
                        })
                    ]
                })
            ]
        })
    });
});
const $6d7342b4c46a0d7f$var$TimesheetDropdownTimer = (0, $e6FFD.observer)(({ timesheetEntry: timesheetEntry })=>{
    (0, $7PdBe.useEffect)(()=>{
        if (!(0, $621605b590fb8e7f$export$2e2bcd8739ae039).selectedTimeEntry) {
            (0, $621605b590fb8e7f$export$2e2bcd8739ae039).setSelectedTimeEntry(timesheetEntry);
            (0, $621605b590fb8e7f$export$2e2bcd8739ae039).startTimer();
        }
    }, [
        timesheetEntry
    ]);
    if ((0, $621605b590fb8e7f$export$2e2bcd8739ae039).selectedTimeEntry !== timesheetEntry) return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        className: "project-dropdown",
        style: {
            padding: "1em"
        },
        children: "Another Timer is Running. Please save or cancel it before starting a new one."
    });
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: "project-dropdown two-btn",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                className: "project-timer",
                children: /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                    children: (0, $621605b590fb8e7f$export$2e2bcd8739ae039).timeDisplay
                })
            }),
            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                className: "project-options",
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "pr-opt",
                        onClick: ()=>{
                            (0, $621605b590fb8e7f$export$2e2bcd8739ae039).pauseTimer();
                            timesheetEntry.update({
                                numMinutes: Math.round((0, $621605b590fb8e7f$export$2e2bcd8739ae039).seconds / 60)
                            });
                            (0, $755ff9b392d4d3e8$export$2e2bcd8739ae039).saveModel(timesheetEntry);
                            (0, $621605b590fb8e7f$export$2e2bcd8739ae039).setSelectedTimeEntry(null);
                            (0, $621605b590fb8e7f$export$2e2bcd8739ae039).resetTimer();
                            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("select");
                        },
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-opt-icon notes",
                                children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                    className: "fa fa-download",
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-opt-label",
                                children: "Save"
                            })
                        ]
                    }),
                    (0, $621605b590fb8e7f$export$2e2bcd8739ae039).timerState === "running" ? /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "pr-opt",
                        onClick: ()=>(0, $621605b590fb8e7f$export$2e2bcd8739ae039).pauseTimer(),
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-opt-icon timer",
                                children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                    className: "fa fa-pause",
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-opt-label",
                                children: "Pause"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "pr-opt",
                        onClick: ()=>(0, $621605b590fb8e7f$export$2e2bcd8739ae039).startTimer(),
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-opt-icon timer",
                                children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                    className: "fa fa-play",
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-opt-label",
                                children: "Start"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                        className: "pr-opt",
                        onClick: ()=>{
                            (0, $621605b590fb8e7f$export$2e2bcd8739ae039).resetTimer();
                            (0, $621605b590fb8e7f$export$2e2bcd8739ae039).setSelectedTimeEntry(null);
                            (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("select");
                        },
                        children: [
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-opt-icon delete",
                                children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                    className: "fa fa-times",
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                className: "pr-opt-label",
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
const $6d7342b4c46a0d7f$var$TimesheetDropdownManualEntry = (0, $e6FFD.observer)(({ timesheetEntry: timesheetEntry })=>{
    const [numMinutes, setNumMinutes] = (0, $7PdBe.useState)(timesheetEntry.numMinutes);
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: "project-dropdown two-btn",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                className: "project-input",
                children: /*#__PURE__*/ (0, $RSSjA.jsx)("input", {
                    className: "entry-time-input__input",
                    type: "text",
                    maxLength: 5,
                    value: (0, $4bOnx.isNumber)(numMinutes) ? (0, $4bOnx.formatMinutes)(numMinutes) : numMinutes,
                    onChange: (e)=>setNumMinutes(e.target.value),
                    onBlur: (e)=>setNumMinutes((0, $4bOnx.parseTime)(e.target.value))
                })
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$SaveCancelPanel, {
                onSave: ()=>{
                    timesheetEntry.update({
                        numMinutes: numMinutes
                    });
                    (0, $755ff9b392d4d3e8$export$2e2bcd8739ae039).saveModel(timesheetEntry);
                    (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("select");
                },
                onCancel: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("select")
            })
        ]
    });
});
const $6d7342b4c46a0d7f$var$TimesheetDropdownNotes = (0, $e6FFD.observer)(({ timesheetEntry: timesheetEntry })=>{
    const [notes, setNotes] = (0, $7PdBe.useState)(timesheetEntry.notes || "");
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: "project-dropdown two-btn",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                className: "project-note",
                children: /*#__PURE__*/ (0, $RSSjA.jsx)("textarea", {
                    rows: "3",
                    placeholder: "Text goes here...",
                    onChange: (e)=>setNotes(e.target.value),
                    children: notes
                })
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$SaveCancelPanel, {
                onSave: ()=>{
                    timesheetEntry.update({
                        notes: notes
                    });
                    (0, $755ff9b392d4d3e8$export$2e2bcd8739ae039).saveModel(timesheetEntry);
                    (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("select");
                },
                onCancel: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("select")
            })
        ]
    });
});
const $6d7342b4c46a0d7f$var$TimesheetDropdownOptions = (0, $e6FFD.observer)(({ timesheetEntry: timesheetEntry })=>{
    const [isBillable, setIsBillable] = (0, $7PdBe.useState)(timesheetEntry.isBillable);
    const [isVariation, setIsVariation] = (0, $7PdBe.useState)(timesheetEntry.isVariation);
    const [isOvertime, setIsOvertime] = (0, $7PdBe.useState)(timesheetEntry.isOvertime);
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: "project-dropdown two-btn",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                className: "time-entry-switches",
                children: [
                    (0, $5uSSv.default).organisation.settings.timeEntryFlags.includes("billable") && /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$Checkbox, {
                        value: isBillable,
                        label: "Billable",
                        onChange: (v)=>setIsBillable(v)
                    }),
                    (0, $5uSSv.default).organisation.settings.timeEntryFlags.includes("variation") && /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$Checkbox, {
                        value: isVariation,
                        label: "Variation",
                        onChange: (v)=>setIsVariation(v)
                    }),
                    (0, $5uSSv.default).organisation.settings.timeEntryFlags.includes("overtime") && /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$Checkbox, {
                        value: isOvertime,
                        label: "Overtime",
                        onChange: (v)=>setIsOvertime(v)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)($6d7342b4c46a0d7f$var$SaveCancelPanel, {
                onSave: ()=>{
                    timesheetEntry.update({
                        isBillable: isBillable,
                        isVariation: isVariation,
                        isOvertime: isOvertime
                    });
                    (0, $755ff9b392d4d3e8$export$2e2bcd8739ae039).saveModel(timesheetEntry);
                    (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("select");
                },
                onCancel: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setDropdownState("select")
            })
        ]
    });
});
const $6d7342b4c46a0d7f$var$TimesheetDropdownLocked = (0, $e6FFD.observer)(({ timesheetEntry: timesheetEntry })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
        className: "project-dropdown two-btn",
        children: /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
            className: "project-locked",
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                    className: "fa fa-lock",
                    style: {
                        marginRight: "1em"
                    }
                }),
                /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                    children: "Time Entry Locked"
                })
            ]
        })
    });
});
function $6d7342b4c46a0d7f$var$pad2(n) {
    return (n < 10 ? "0" : "") + n.toString();
}
function $6d7342b4c46a0d7f$var$formatSeconds(seconds) {
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds - hours * 3600) / 60);
    let s = seconds - hours * 3600 - minutes * 60;
    return `${$6d7342b4c46a0d7f$var$pad2(hours)}:${$6d7342b4c46a0d7f$var$pad2(minutes)}:${$6d7342b4c46a0d7f$var$pad2(s)}`;
}
const $6d7342b4c46a0d7f$var$SaveCancelPanel = (0, $e6FFD.observer)(({ onSave: onSave, onCancel: onCancel })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: "project-options",
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                className: "entry-time-input__save-button pr-opt",
                onClick: onSave,
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                        className: "pr-opt-icon notes",
                        children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                            className: "fa fa-download"
                        })
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                        className: "pr-opt-label",
                        children: "Save"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                className: "pr-opt",
                onClick: onCancel,
                children: [
                    /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                        className: "pr-opt-icon delete",
                        children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                            className: "fa fa-times"
                        })
                    }),
                    /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                        className: "pr-opt-label",
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
});
const $6d7342b4c46a0d7f$var$Checkbox = ({ value: value, onChange: onChange, label: label })=>{
    return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
        className: "time-entry-switch",
        onClick: ()=>onChange(!value),
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ksXgP)))("fa fa-fw", value ? "fa-check-square" : "fa-square-o")
            }),
            label
        ]
    });
};



var $dBifK = parcelRequire("dBifK");

var $cuB2x = parcelRequire("cuB2x");


var $b8BPd = parcelRequire("b8BPd");

var $egx7S = parcelRequire("egx7S");
const $d4711306eb94abde$export$9c9299b602d594d6 = async (staffId, beforeDate = new Date())=>{
    const r = await (0, $b8BPd.trpc).timeTracking.getWeeklyPreviousTime.query({
        staffId: staffId,
        beforeDate: (0, $egx7S.format)(beforeDate, "yyyy-MM-dd")
    });
    return (r === null || r === void 0 ? void 0 : r.timeEntries) || [];
};
const $d4711306eb94abde$export$2a4397dd354dfdea = async (staffId, beforeDate = new Date())=>{
    const r = await (0, $b8BPd.trpc).timeTracking.getDailyPreviousTime.query({
        staffId: staffId,
        beforeDate: (0, $egx7S.format)(beforeDate, "yyyy-MM-dd")
    });
    return (r === null || r === void 0 ? void 0 : r.timeEntries) || [];
};



var $2BEDj = parcelRequire("2BEDj");

var $b8BPd = parcelRequire("b8BPd");


var $dfd3049173892854$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(()=>{
    const today = new Date();
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $fa4d6aaef4fef497$export$2e2bcd8739ae039), {
        loading: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $9bd6db54a19dc2ee$export$2e2bcd8739ae039), {}),
        queryIds: [
            {
                id: `timeEntries-${(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedDate.getTime()}`,
                queryFn: async ()=>{
                    const requestData = await (0, $b8BPd.trpc).legacy.getTimeEntries.query({
                        startDate: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).startOfWeek,
                        endDate: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).endOfWeek
                    });
                    return (0, $b1d2146eeffbc838$export$93e54950f4ca4b28)(requestData, `timeEntries-${(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedDate.getTime()}`);
                }
            }
        ],
        children: /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
            style: {
                height: "100%",
                display: "flex",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                    style: {
                        flex: "1 0 auto"
                    },
                    children: [
                        (0, $5uSSv.default).updateAvailable ? /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                            style: {
                                padding: "7px 0",
                                position: "fixed",
                                top: "0",
                                zIndex: "1000",
                                background: "#0000FF",
                                width: "100%",
                                height: "32px",
                                fontSize: "0.9em",
                                textAlign: "center",
                                fontWeight: "600",
                                color: "#FFF",
                                boxSizing: "border-box"
                            },
                            onClick: ()=>{
                                let url = window.location.href;
                                url += `${url.indexOf("?") > -1 ? "&" : "?"}ts=${Date.now()}`;
                                window.location.href = url;
                            },
                            children: "Click Here to Update Coincraft."
                        }) : null,
                        /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                            className: "top-nav",
                            children: [
                                /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                    className: "nav-btn left",
                                    onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).shiftWeek(-1),
                                    children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                        className: "fa fa-chevron-left"
                                    })
                                }),
                                /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                    className: "nav-title",
                                    children: /*#__PURE__*/ (0, $RSSjA.jsxs)("span", {
                                        className: "date-title",
                                        children: [
                                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                                style: {
                                                    fontSize: "0.9em"
                                                },
                                                children: "Week Starting"
                                            }),
                                            /*#__PURE__*/ (0, $RSSjA.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                                style: {
                                                    fontWeight: 600
                                                },
                                                children: (0, $egx7S.format)((0, $8e84f1e667c8947e$export$2e2bcd8739ae039).startOfWeek, "EEE, d MMM yyyy")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                    className: "nav-btn right",
                                    onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).shiftWeek(1),
                                    children: /*#__PURE__*/ (0, $RSSjA.jsx)("i", {
                                        className: "fa fa-chevron-right"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                            className: "weekday",
                            children: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).daysOfWeek.map(function(date, i) {
                                return /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                    className: "d-sel",
                                    onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectDate(date),
                                    children: [
                                        /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ksXgP)))("day", {
                                                selected: (0, $egx7S.isSameDay)(date, (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedDate),
                                                today: (0, $egx7S.isSameDay)(date, today)
                                            }),
                                            children: /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                                                className: "day-circle",
                                                children: [
                                                    /*#__PURE__*/ (0, $RSSjA.jsx)("span", {
                                                        className: "mini-day",
                                                        children: (0, $egx7S.format)(date, "EEE")
                                                    }),
                                                    /*#__PURE__*/ (0, $RSSjA.jsxs)("span", {
                                                        className: "mini-date",
                                                        children: [
                                                            " ",
                                                            (0, $egx7S.format)(date, "dd")
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                            className: "day-hours",
                                            children: (0, $4bOnx.formatMinutes)((0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum(((0, $cuB2x.default).timeEntriesByDate[date.getTime()] || []).map((te)=>te.numMinutes)))
                                        })
                                    ]
                                }, (0, $egx7S.format)(date, "yyyy-MM-dd"));
                            })
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)((0, $6d7342b4c46a0d7f$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $RSSjA.jsxs)("div", {
                    className: "bottom-footer",
                    children: [
                        /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                            className: "project-btn",
                            onClick: async ()=>{
                                const uniqueRows = await (0, $d4711306eb94abde$export$2a4397dd354dfdea)((0, $5uSSv.default).userId, (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedDate);
                                uniqueRows.forEach((r)=>{
                                    (0, $cuB2x.default).add({
                                        numMinutes: 0,
                                        ...r,
                                        date: (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).selectedDate,
                                        staffId: (0, $5uSSv.default).userId
                                    }, {
                                        trackUpdates: true
                                    });
                                });
                            },
                            children: "+ Copy Previous Entries"
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                            style: {
                                borderBottom: "solid 1px #ccc"
                            },
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                className: "add-entry-button project-btn",
                                onClick: ()=>(0, $8e84f1e667c8947e$export$2e2bcd8739ae039).setRoute("selectCostCentre"),
                                children: "+ Add Entry"
                            })
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                            style: {
                                textAlign: "center",
                                marginTop: "1em"
                            },
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("img", {
                                src: new URL((parcelRequire("4Iihd"))),
                                alt: "Coincraft Logo",
                                style: {
                                    display: "inline-block",
                                    paddingBottom: "1rem"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                            children: /*#__PURE__*/ (0, $RSSjA.jsx)("div", {
                                className: "add-entry-button project-btn",
                                onClick: async ()=>{
                                    await (0, $2BEDj.authClient).signOut();
                                    await (0, $5uSSv.default).clearCache();
                                },
                                children: "Logout"
                            })
                        })
                    ]
                })
            ]
        })
    });
});



var $5uSSv = parcelRequire("5uSSv");
var $8e84f1e667c8947e$var$_dec, $8e84f1e667c8947e$var$_dec2, $8e84f1e667c8947e$var$_dec3, $8e84f1e667c8947e$var$_dec4, $8e84f1e667c8947e$var$_dec5, $8e84f1e667c8947e$var$_dec6, $8e84f1e667c8947e$var$_dec7, $8e84f1e667c8947e$var$_dec8, $8e84f1e667c8947e$var$_dec9, $8e84f1e667c8947e$var$_dec10, $8e84f1e667c8947e$var$_dec11, $8e84f1e667c8947e$var$_dec12, $8e84f1e667c8947e$var$_class, $8e84f1e667c8947e$var$_descriptor, $8e84f1e667c8947e$var$_descriptor2, $8e84f1e667c8947e$var$_descriptor3, $8e84f1e667c8947e$var$_descriptor4, $8e84f1e667c8947e$var$_descriptor5, $8e84f1e667c8947e$var$_descriptor6, $8e84f1e667c8947e$var$_descriptor7, $8e84f1e667c8947e$var$_descriptor8;
function $8e84f1e667c8947e$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $8e84f1e667c8947e$var$_defineProperty(e, r, t) {
    return (r = $8e84f1e667c8947e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e84f1e667c8947e$var$_toPropertyKey(t) {
    var i = $8e84f1e667c8947e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8e84f1e667c8947e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e84f1e667c8947e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $8e84f1e667c8947e$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}

var $d8hWe = parcelRequire("d8hWe");
var $8e84f1e667c8947e$require$makeObservable = $d8hWe.makeObservable;
var $8e84f1e667c8947e$require$observable = $d8hWe.observable;
var $8e84f1e667c8947e$require$computed = $d8hWe.computed;
var $8e84f1e667c8947e$require$action = $d8hWe.action;
let $8e84f1e667c8947e$var$TimesheetAppStore = ($8e84f1e667c8947e$var$_dec = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec2 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec3 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec4 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec5 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec6 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec7 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec8 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec9 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec10 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec11 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_dec12 = $8e84f1e667c8947e$require$action.bound, $8e84f1e667c8947e$var$_class = class TimesheetAppStore {
    constructor(props){
        $8e84f1e667c8947e$var$_initializerDefineProperty(this, "selectedDate", $8e84f1e667c8947e$var$_descriptor, this);
        $8e84f1e667c8947e$var$_initializerDefineProperty(this, "route", $8e84f1e667c8947e$var$_descriptor2, this);
        $8e84f1e667c8947e$var$_initializerDefineProperty(this, "dropdownState", $8e84f1e667c8947e$var$_descriptor3, this);
        $8e84f1e667c8947e$var$_initializerDefineProperty(this, "selectedCostCentre", $8e84f1e667c8947e$var$_descriptor4, this);
        $8e84f1e667c8947e$var$_initializerDefineProperty(this, "selectedProject", $8e84f1e667c8947e$var$_descriptor5, this);
        $8e84f1e667c8947e$var$_initializerDefineProperty(this, "selectedPhase", $8e84f1e667c8947e$var$_descriptor6, this);
        $8e84f1e667c8947e$var$_initializerDefineProperty(this, "selectedTask", $8e84f1e667c8947e$var$_descriptor7, this);
        $8e84f1e667c8947e$var$_initializerDefineProperty(this, "selectedTimeEntry", $8e84f1e667c8947e$var$_descriptor8, this);
        $8e84f1e667c8947e$require$makeObservable(this);
    }
    get displayedPage() {
        const routes = {
            selectCostCentre: (0, $6e51b6e248dbe48e$export$2e2bcd8739ae039),
            selectProject: (0, $03bd62a1a14aff2d$export$2e2bcd8739ae039),
            selectPhase: (0, $e263e84e717f43e4$export$2e2bcd8739ae039),
            selectTask: (0, $e5d065d55d42f466$export$2e2bcd8739ae039),
            listEntries: (0, $dfd3049173892854$export$2e2bcd8739ae039)
        };
        return routes[this.route] || (0, $dfd3049173892854$export$2e2bcd8739ae039);
    }
    get startOfWeek() {
        return (0, $egx7S.startOfWeek)(this.selectedDate, {
            weekStartsOn: 1
        });
    }
    get endOfWeek() {
        return (0, $egx7S.endOfWeek)(this.selectedDate, {
            weekStartsOn: 1
        });
    }
    shiftWeek(shift) {
        this.selectedDate = (0, $egx7S.addWeeks)(this.selectedDate, shift);
    }
    selectDate(date) {
        this.selectedDate = (0, $egx7S.startOfDay)(date);
    }
    get daysOfWeek() {
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ].map((i)=>{
            return (0, $egx7S.addDays)(this.startOfWeek, i);
        });
    }
    get dailyTotals() {
        return this.daysOfWeek.map((date)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($dBifK))).sum((0, $cuB2x.default).timeEntriesByDate[date.getTime()].map((te)=>te.hours));
        });
    }
    resetSelection() {
        this.selectedCostCentre = null;
        this.selectedProject = null;
        this.selectedPhase = null;
        this.selectedTask = null;
    }
    setRoute(route) {
        this.route = route;
    }
    selectCostCentre(costCentre) {
        this.selectedCostCentre = costCentre;
    }
    selectProject(project) {
        this.selectedProject = project;
    }
    selectPhase(phase) {
        this.selectedPhase = phase;
    }
    selectTask(task) {
        this.selectedTask = task;
    }
    selectTimeEntry(timeEntry) {
        this.selectedTimeEntry = timeEntry;
    }
    createTimeEntry() {
        (0, $cuB2x.default).add({
            staffId: (0, $5uSSv.default).userId,
            costCentreId: this.selectedCostCentre.id,
            projectId: this.selectedProject.id,
            phaseId: this.selectedPhase.id,
            taskId: this.selectedTask.id,
            date: this.selectedDate,
            numMinutes: 0
        }, {
            trackUpdates: true
        });
    }
    setDropdownState(state) {
        this.dropdownState = state;
    }
    deleteTimeEntry(timeEntry) {
        timeEntry.update({
            deletedAt: new Date()
        });
    }
}, $8e84f1e667c8947e$var$_descriptor = $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectedDate", [
    $8e84f1e667c8947e$require$observable
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (0, $egx7S.startOfDay)(new Date());
    }
}), $8e84f1e667c8947e$var$_descriptor2 = $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "route", [
    $8e84f1e667c8947e$require$observable
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "listEntries";
    }
}), $8e84f1e667c8947e$var$_descriptor3 = $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "dropdownState", [
    $8e84f1e667c8947e$require$observable
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "select";
    }
}), $8e84f1e667c8947e$var$_descriptor4 = $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectedCostCentre", [
    $8e84f1e667c8947e$require$observable
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e84f1e667c8947e$var$_descriptor5 = $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectedProject", [
    $8e84f1e667c8947e$require$observable
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e84f1e667c8947e$var$_descriptor6 = $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectedPhase", [
    $8e84f1e667c8947e$require$observable
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e84f1e667c8947e$var$_descriptor7 = $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectedTask", [
    $8e84f1e667c8947e$require$observable
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e84f1e667c8947e$var$_descriptor8 = $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectedTimeEntry", [
    $8e84f1e667c8947e$require$observable
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return null;
    }
}), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "displayedPage", [
    $8e84f1e667c8947e$require$computed
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "displayedPage"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "startOfWeek", [
    $8e84f1e667c8947e$require$computed
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "startOfWeek"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "endOfWeek", [
    $8e84f1e667c8947e$require$computed
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "endOfWeek"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "shiftWeek", [
    $8e84f1e667c8947e$var$_dec
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "shiftWeek"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectDate", [
    $8e84f1e667c8947e$var$_dec2
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectDate"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "daysOfWeek", [
    $8e84f1e667c8947e$require$computed
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "daysOfWeek"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "dailyTotals", [
    $8e84f1e667c8947e$require$computed
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "dailyTotals"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "resetSelection", [
    $8e84f1e667c8947e$var$_dec3
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "resetSelection"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "setRoute", [
    $8e84f1e667c8947e$var$_dec4
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "setRoute"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectCostCentre", [
    $8e84f1e667c8947e$var$_dec5
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectCostCentre"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectProject", [
    $8e84f1e667c8947e$var$_dec6
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectProject"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectPhase", [
    $8e84f1e667c8947e$var$_dec7
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectPhase"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectTask", [
    $8e84f1e667c8947e$var$_dec8
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectTask"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectTimeEntry", [
    $8e84f1e667c8947e$var$_dec9
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "selectTimeEntry"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "createTimeEntry", [
    $8e84f1e667c8947e$var$_dec10
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "createTimeEntry"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "setDropdownState", [
    $8e84f1e667c8947e$var$_dec11
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "setDropdownState"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_applyDecoratedDescriptor($8e84f1e667c8947e$var$_class.prototype, "deleteTimeEntry", [
    $8e84f1e667c8947e$var$_dec12
], Object.getOwnPropertyDescriptor($8e84f1e667c8947e$var$_class.prototype, "deleteTimeEntry"), $8e84f1e667c8947e$var$_class.prototype), $8e84f1e667c8947e$var$_class);
var $8e84f1e667c8947e$export$2e2bcd8739ae039 = new $8e84f1e667c8947e$var$TimesheetAppStore();










var $b8BPd = parcelRequire("b8BPd");
var $610b252bb2709f8c$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(()=>{
    const Page = (0, $8e84f1e667c8947e$export$2e2bcd8739ae039).displayedPage;
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $fa4d6aaef4fef497$export$2e2bcd8739ae039), {
        loading: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $9bd6db54a19dc2ee$export$2e2bcd8739ae039), {}),
        queryIds: [
            {
                collection: "mobileAppData",
                queryFn: async ()=>{
                    const requestData = await (0, $b8BPd.trpc).legacy.getMobileAppData.query();
                    return (0, $b1d2146eeffbc838$export$93e54950f4ca4b28)(requestData, `mobileAppData`);
                }
            }
        ],
        children: /*#__PURE__*/ (0, $RSSjA.jsx)(Page, {})
    });
});



var $2BEDj = parcelRequire("2BEDj");

var $d8b0b26a08aa2103$export$2e2bcd8739ae039 = (0, $e6FFD.observer)(()=>{
    const { data: session, isPending: isPending } = (0, $2BEDj.authClient).useSession();
    const [location] = (0, $710ca58b924d6f0b$export$45d76561a5302f2b)();
    (0, $7PdBe.useEffect)(()=>{
        // Sync better-auth session changes with SessionStore
        const syncSession = async ()=>{
            if (!isPending && (0, $5uSSv.default).initialized) {
                if (session !== null && session !== void 0 && session.user) // Session exists, update SessionStore if needed
                {
                    if ((0, $5uSSv.default).userId !== session.user.id) await (0, $5uSSv.default).checkAuthentication();
                } else // No session, logout if needed
                if ((0, $5uSSv.default).authenticated) await (0, $5uSSv.default).clearCache();
            }
        };
        syncSession();
    }, [
        session,
        isPending
    ]);
    // Handle loading state
    if (!(0, $5uSSv.default).initialized || isPending) return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $9bd6db54a19dc2ee$export$2e2bcd8739ae039), {});
    // If not authenticated and not on an auth route, redirect to login
    if (!(0, $5uSSv.default).authenticated && !location.startsWith("/auth")) return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $8edff7cab15c34e3$export$2e2bcd8739ae039), {
        authView: "sign-in"
    });
    // If authenticated but on an auth route, allow it (needed for account-details, etc.)
    if ((0, $5uSSv.default).authenticated && location.startsWith("/auth")) {
        // Extract the auth view from the location
        const authView = location.replace("/auth/", "");
        return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $8edff7cab15c34e3$export$2e2bcd8739ae039), {
            authView: authView || "sign-in"
        });
    }
    // Authenticated users get the router
    return /*#__PURE__*/ (0, $RSSjA.jsxs)((0, $710ca58b924d6f0b$export$b5d5cf8927ab7262), {
        children: [
            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $710ca58b924d6f0b$export$e7b0ac011bb776c6), {
                path: "/auth/:authView",
                children: (params)=>/*#__PURE__*/ (0, $RSSjA.jsx)((0, $8edff7cab15c34e3$export$2e2bcd8739ae039), {
                        authView: params.authView
                    })
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $710ca58b924d6f0b$export$e7b0ac011bb776c6), {
                path: "/",
                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $610b252bb2709f8c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $RSSjA.jsx)((0, $710ca58b924d6f0b$export$e7b0ac011bb776c6), {
                children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $610b252bb2709f8c$export$2e2bcd8739ae039), {})
            })
        ]
    });
});





const $a8d5bb49d7f80e0f$export$1cf3d545f2d4635c = console;





class $1ad960da43f1dc6a$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $050bd9872e54bf11$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $050bd9872e54bf11$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


// CLASS
class $c268c881ec533a4e$export$62297b13309008b2 extends (0, $1ad960da43f1dc6a$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $a8d5bb49d7f80e0f$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $c268c881ec533a4e$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $050bd9872e54bf11$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $050bd9872e54bf11$export$8793edee2d425525)).catch((0, $050bd9872e54bf11$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $050bd9872e54bf11$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $050bd9872e54bf11$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $72c5852a0bdb61b8$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $72c5852a0bdb61b8$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $72c5852a0bdb61b8$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $72c5852a0bdb61b8$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $72c5852a0bdb61b8$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $c268c881ec533a4e$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}




// CLASS
class $d7c509a9a30c07d9$export$5dde0cd941da8468 extends (0, $84d81d1e1229099f$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $050bd9872e54bf11$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $c268c881ec533a4e$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $050bd9872e54bf11$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $050bd9872e54bf11$export$c5d1efe363797780)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $050bd9872e54bf11$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $050bd9872e54bf11$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}







// CLASS
class $11013a1a7d467f4e$export$17b8b19c814bcf56 extends (0, $1ad960da43f1dc6a$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $a8d5bb49d7f80e0f$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $11013a1a7d467f4e$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $72c5852a0bdb61b8$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $72c5852a0bdb61b8$export$61b92f63f30245cf)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $11013a1a7d467f4e$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}




// CLASS
class $ac50a58f74182820$export$1fcfd9a244434844 extends (0, $84d81d1e1229099f$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $11013a1a7d467f4e$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $050bd9872e54bf11$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $050bd9872e54bf11$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $050bd9872e54bf11$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}





function $ee94112318d696ad$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $ee94112318d696ad$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $ee94112318d696ad$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $ee94112318d696ad$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $ee94112318d696ad$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $ee94112318d696ad$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $ee94112318d696ad$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $ee94112318d696ad$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $ee94112318d696ad$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $ee94112318d696ad$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $ba3957ab769984d5$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $d7c509a9a30c07d9$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $ac50a58f74182820$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $a8d5bb49d7f80e0f$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $48a50d26ddc0abfa$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $48a50d26ddc0abfa$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $543519bcdf2eb9c7$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $543519bcdf2eb9c7$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $050bd9872e54bf11$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $050bd9872e54bf11$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $050bd9872e54bf11$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $050bd9872e54bf11$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $050bd9872e54bf11$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $050bd9872e54bf11$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $050bd9872e54bf11$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $050bd9872e54bf11$export$8793edee2d425525)).catch((0, $050bd9872e54bf11$export$8793edee2d425525));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $050bd9872e54bf11$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $050bd9872e54bf11$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $9470fc4dba0f530c$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $050bd9872e54bf11$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $050bd9872e54bf11$export$8793edee2d425525));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $050bd9872e54bf11$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $050bd9872e54bf11$export$8793edee2d425525)).catch((0, $050bd9872e54bf11$export$8793edee2d425525));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $050bd9872e54bf11$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $ee94112318d696ad$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $050bd9872e54bf11$export$8793edee2d425525)).catch((0, $050bd9872e54bf11$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $050bd9872e54bf11$export$5fcb678681417b54)(queryKey) === (0, $050bd9872e54bf11$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $050bd9872e54bf11$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $050bd9872e54bf11$export$5fcb678681417b54)(mutationKey) === (0, $050bd9872e54bf11$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $050bd9872e54bf11$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $050bd9872e54bf11$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}



var $f9Rb7 = parcelRequire("f9Rb7");

var $5uSSv = parcelRequire("5uSSv");

var $7PdBe = parcelRequire("7PdBe");
const $549d1ca7ada2bb38$var$useVisible = ()=>{
    const [state, setState] = (0, $7PdBe.useState)({
        hidden: document.hidden,
        visibilityState: document.visibilityState
    });
    const onVisibilityChangeEvent = (event)=>{
        setState({
            hidden: document.hidden,
            visibilityState: document.visibilityState
        });
    };
    (0, $7PdBe.useEffect)(()=>{
        document.addEventListener("visibilitychange", onVisibilityChangeEvent);
        return ()=>{
            document.removeEventListener("visibilitychange", onVisibilityChangeEvent);
        };
    }, []);
    return state;
};
var $549d1ca7ada2bb38$export$2e2bcd8739ae039 = $549d1ca7ada2bb38$var$useVisible;


parcelRequire("2BEDj");

var $RSSjA = parcelRequire("RSSjA");


var $2BEDj = parcelRequire("2BEDj");

var $7PdBe = parcelRequire("7PdBe");


// Simple Link component for wouter
const $b6ef18840b694735$var$Link = ({ href: href, to: to, children: children, ...props })=>{
    const [, setLocation] = (0, $710ca58b924d6f0b$export$45d76561a5302f2b)();
    // Support both 'href' and 'to' props (better-auth-ui uses 'href')
    const path = href || to;
    const handleClick = (e)=>{
        e.preventDefault();
        setLocation(path);
    };
    return /*#__PURE__*/ (0, $RSSjA.jsx)("a", {
        href: path,
        onClick: handleClick,
        ...props,
        children: children
    });
};
function $b6ef18840b694735$export$797a850985de4c33({ children: children }) {
    const [, setLocation] = (0, $710ca58b924d6f0b$export$45d76561a5302f2b)();
    const hasNavigatedRef = (0, $7PdBe.useRef)(false);
    // Create a stable navigate function that prevents duplicate navigations
    const handleNavigate = (0, $7PdBe.useRef)((href)=>{
        // Prevent duplicate navigations
        if (hasNavigatedRef.current) return;
        hasNavigatedRef.current = true;
        // Use full page navigation for auth routes to ensure clean unmount
        if (window.location.pathname.includes("/auth/")) window.location.href = href;
        else setLocation(href);
        // Reset after navigation completes
        setTimeout(()=>{
            hasNavigatedRef.current = false;
        }, 1000);
    }).current;
    const handleToast = (0, $7PdBe.useCallback)(({ variant: variant, message: message })=>{
        if (variant === "error") (0, $0bf2944f2fb447de$exports.toast).error(message);
        else if (variant === "success") (0, $0bf2944f2fb447de$exports.toast).success(message);
        else (0, $0bf2944f2fb447de$exports.toast).error(message);
    }, []);
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $07d0275849708341$export$8b282e20e92fcb40), {
        authClient: (0, $2BEDj.authClient),
        basePath: "/auth",
        baseURL: "https://mobile.coincraft.co",
        navigate: handleNavigate,
        Link: $b6ef18840b694735$var$Link,
        toast: handleToast,
        signUp: false,
        magicLink: true,
        social: {
            providers: [
                "google",
                "microsoft"
            ]
        },
        children: children
    });
}


const $38ee2b2ad71cbe15$var$isDev = false;
(0, $f9Rb7.default).init("phc_Burb304xExjYSqj20cLeUVWCO2DfMIZqELYlfzC89i6", {
    api_host: $38ee2b2ad71cbe15$var$isDev ? "https://app.posthog.com" : "https://hog.coincraft.co",
    ui_host: "https://app.posthog.com",
    session_recording: {
        maskAllInputs: false
    },
    capture_exceptions: !$38ee2b2ad71cbe15$var$isDev,
    // Disable error tracking in development
    autocapture: !$38ee2b2ad71cbe15$var$isDev // Disable automatic event capturing in development
});
const $38ee2b2ad71cbe15$export$7c07b633a151f9c5 = new (0, $ba3957ab769984d5$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            useErrorBoundary: true,
            suspense: true,
            staleTime: 0,
            //5 * 60 * 1000, // 5 minutes
            refetchOnWindowFocus: false // default: true
        }
    }
});
function $38ee2b2ad71cbe15$var$App() {
    const visibilityState = (0, $549d1ca7ada2bb38$export$2e2bcd8739ae039)();
    (0, $7PdBe.useEffect)(()=>{
        (0, $5uSSv.default).checkIfUpdateIsAvailable();
    }, [
        visibilityState
    ]);
    return /*#__PURE__*/ (0, $RSSjA.jsx)((0, $fd5b90db0c3a799e$export$45604f0cc8ae667b), {
        client: $38ee2b2ad71cbe15$export$7c07b633a151f9c5,
        children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $b6ef18840b694735$export$797a850985de4c33), {
            children: /*#__PURE__*/ (0, $RSSjA.jsx)((0, $d8b0b26a08aa2103$export$2e2bcd8739ae039), {})
        })
    });
}
var $38ee2b2ad71cbe15$export$2e2bcd8739ae039 = $38ee2b2ad71cbe15$var$App;


const $2bea51b9e0d38813$var$root = document.getElementById("root");
const $2bea51b9e0d38813$var$reactRoot = (0, $d2277f625b0f1c32$export$882461b6382ed46c)($2bea51b9e0d38813$var$root);
$2bea51b9e0d38813$var$reactRoot.render(/*#__PURE__*/ (0, $RSSjA.jsx)((0, $38ee2b2ad71cbe15$export$2e2bcd8739ae039), {}));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
$cd244d3777bb214a$export$d07f55d4c15c0440();

})();
//# sourceMappingURL=index.6d268aa1.js.map
